/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://lexstep.com/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(494);
	module.exports = __webpack_require__(545);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _isPlaceholder = /*#__PURE__*/__webpack_require__(112);
	
	/**
	 * Optimized internal two-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	
	
	function _curry2(fn) {
	  return function f2(a, b) {
	    switch (arguments.length) {
	      case 0:
	        return f2;
	      case 1:
	        return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
	          return fn(a, _b);
	        });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
	          return fn(_a, b);
	        }) : _isPlaceholder(b) ? _curry1(function (_b) {
	          return fn(a, _b);
	        }) : fn(a, b);
	    }
	  };
	}
	module.exports = _curry2;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.4
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        return name.match('^[^/\\\\]*$') != null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(989)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.4';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(169)(module)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7);
	var core = __webpack_require__(35);
	var hide = __webpack_require__(22);
	var redefine = __webpack_require__(23);
	var ctx = __webpack_require__(36);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var _isPlaceholder = /*#__PURE__*/__webpack_require__(112);
	
	/**
	 * Optimized internal one-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	
	
	function _curry1(fn) {
	  return function f1(a) {
	    if (arguments.length === 0 || _isPlaceholder(a)) {
	      return f1;
	    } else {
	      return fn.apply(this, arguments);
	    }
	  };
	}
	module.exports = _curry1;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _isPlaceholder = /*#__PURE__*/__webpack_require__(112);
	
	/**
	 * Optimized internal three-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	
	
	function _curry3(fn) {
	  return function f3(a, b, c) {
	    switch (arguments.length) {
	      case 0:
	        return f3;
	      case 1:
	        return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
	          return fn(a, _b, _c);
	        });
	      case 2:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
	          return fn(_a, b, _c);
	        }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
	          return fn(a, _b, _c);
	        }) : _curry1(function (_c) {
	          return fn(a, b, _c);
	        });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
	          return fn(_a, _b, c);
	        }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
	          return fn(_a, b, _c);
	        }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
	          return fn(a, _b, _c);
	        }) : _isPlaceholder(a) ? _curry1(function (_a) {
	          return fn(_a, b, c);
	        }) : _isPlaceholder(b) ? _curry1(function (_b) {
	          return fn(a, _b, c);
	        }) : _isPlaceholder(c) ? _curry1(function (_c) {
	          return fn(a, b, _c);
	        }) : fn(a, b, c);
	    }
	  };
	}
	module.exports = _curry3;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(9);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(78)('wks');
	var uid = __webpack_require__(65);
	var Symbol = __webpack_require__(7).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(38);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(8)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(6);
	var IE8_DOM_DEFINE = __webpack_require__(202);
	var toPrimitive = __webpack_require__(46);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(12) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(44);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArray = /*#__PURE__*/__webpack_require__(50);
	
	var _isTransformer = /*#__PURE__*/__webpack_require__(160);
	
	/**
	 * Returns a function that dispatches with different strategies based on the
	 * object in list position (last argument). If it is an array, executes [fn].
	 * Otherwise, if it has a function with one of the given method names, it will
	 * execute that function (functor case). Otherwise, if it is a transformer,
	 * uses transducer [xf] to return a new transformer (transducer case).
	 * Otherwise, it will default to executing [fn].
	 *
	 * @private
	 * @param {Array} methodNames properties to check for a custom implementation
	 * @param {Function} xf transducer to initialize if object is transformer
	 * @param {Function} fn default ramda implementation
	 * @return {Function} A function that dispatches on object in list position
	 */
	
	
	function _dispatchable(methodNames, xf, fn) {
	  return function () {
	    if (arguments.length === 0) {
	      return fn();
	    }
	    var args = Array.prototype.slice.call(arguments, 0);
	    var obj = args.pop();
	    if (!_isArray(obj)) {
	      var idx = 0;
	      while (idx < methodNames.length) {
	        if (typeof obj[methodNames[idx]] === 'function') {
	          return obj[methodNames[idx]].apply(obj, args);
	        }
	        idx += 1;
	      }
	      if (_isTransformer(obj)) {
	        var transducer = xf.apply(null, args);
	        return transducer(obj);
	      }
	    }
	    return fn.apply(this, arguments);
	  };
	}
	module.exports = _dispatchable;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	module.exports = {
	  init: function () {
	    return this.xf['@@transducer/init']();
	  },
	  result: function (result) {
	    return this.xf['@@transducer/result'](result);
	  }
	};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(176);
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	// eslint-disable-next-line func-names
	var kindOf = (function(cache) {
	  // eslint-disable-next-line func-names
	  return function(thing) {
	    var str = toString.call(thing);
	    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
	  };
	})(Object.create(null));
	
	function kindOfTest(type) {
	  type = type.toLowerCase();
	  return function isKindOf(thing) {
	    return kindOf(thing) === type;
	  };
	}
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return Array.isArray(val);
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is a Buffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Buffer, otherwise false
	 */
	function isBuffer(val) {
	  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
	    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @function
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	var isArrayBuffer = kindOfTest('ArrayBuffer');
	
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a plain Object
	 *
	 * @param {Object} val The value to test
	 * @return {boolean} True if value is a plain Object, otherwise false
	 */
	function isPlainObject(val) {
	  if (kindOf(val) !== 'object') {
	    return false;
	  }
	
	  var prototype = Object.getPrototypeOf(val);
	  return prototype === null || prototype === Object.prototype;
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @function
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	var isDate = kindOfTest('Date');
	
	/**
	 * Determine if a value is a File
	 *
	 * @function
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	var isFile = kindOfTest('File');
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @function
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	var isBlob = kindOfTest('Blob');
	
	/**
	 * Determine if a value is a FileList
	 *
	 * @function
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	var isFileList = kindOfTest('FileList');
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} thing The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(thing) {
	  var pattern = '[object FormData]';
	  return thing && (
	    (typeof FormData === 'function' && thing instanceof FormData) ||
	    toString.call(thing) === pattern ||
	    (isFunction(thing.toString) && thing.toString() === pattern)
	  );
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 * @function
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	var isURLSearchParams = kindOfTest('URLSearchParams');
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
	                                           navigator.product === 'NativeScript' ||
	                                           navigator.product === 'NS')) {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (isPlainObject(result[key]) && isPlainObject(val)) {
	      result[key] = merge(result[key], val);
	    } else if (isPlainObject(val)) {
	      result[key] = merge({}, val);
	    } else if (isArray(val)) {
	      result[key] = val.slice();
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	/**
	 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
	 *
	 * @param {string} content with BOM
	 * @return {string} content value without BOM
	 */
	function stripBOM(content) {
	  if (content.charCodeAt(0) === 0xFEFF) {
	    content = content.slice(1);
	  }
	  return content;
	}
	
	/**
	 * Inherit the prototype methods from one constructor into another
	 * @param {function} constructor
	 * @param {function} superConstructor
	 * @param {object} [props]
	 * @param {object} [descriptors]
	 */
	
	function inherits(constructor, superConstructor, props, descriptors) {
	  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
	  constructor.prototype.constructor = constructor;
	  props && Object.assign(constructor.prototype, props);
	}
	
	/**
	 * Resolve object with deep prototype chain to a flat object
	 * @param {Object} sourceObj source object
	 * @param {Object} [destObj]
	 * @param {Function} [filter]
	 * @returns {Object}
	 */
	
	function toFlatObject(sourceObj, destObj, filter) {
	  var props;
	  var i;
	  var prop;
	  var merged = {};
	
	  destObj = destObj || {};
	
	  do {
	    props = Object.getOwnPropertyNames(sourceObj);
	    i = props.length;
	    while (i-- > 0) {
	      prop = props[i];
	      if (!merged[prop]) {
	        destObj[prop] = sourceObj[prop];
	        merged[prop] = true;
	      }
	    }
	    sourceObj = Object.getPrototypeOf(sourceObj);
	  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
	
	  return destObj;
	}
	
	/*
	 * determines whether a string ends with the characters of a specified string
	 * @param {String} str
	 * @param {String} searchString
	 * @param {Number} [position= 0]
	 * @returns {boolean}
	 */
	function endsWith(str, searchString, position) {
	  str = String(str);
	  if (position === undefined || position > str.length) {
	    position = str.length;
	  }
	  position -= searchString.length;
	  var lastIndex = str.indexOf(searchString, position);
	  return lastIndex !== -1 && lastIndex === position;
	}
	
	
	/**
	 * Returns new array from array like object
	 * @param {*} [thing]
	 * @returns {Array}
	 */
	function toArray(thing) {
	  if (!thing) return null;
	  var i = thing.length;
	  if (isUndefined(i)) return null;
	  var arr = new Array(i);
	  while (i-- > 0) {
	    arr[i] = thing[i];
	  }
	  return arr;
	}
	
	// eslint-disable-next-line func-names
	var isTypedArray = (function(TypedArray) {
	  // eslint-disable-next-line func-names
	  return function(thing) {
	    return TypedArray && thing instanceof TypedArray;
	  };
	})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isPlainObject: isPlainObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim,
	  stripBOM: stripBOM,
	  inherits: inherits,
	  toFlatObject: toFlatObject,
	  kindOf: kindOf,
	  kindOfTest: kindOfTest,
	  endsWith: endsWith,
	  toArray: toArray,
	  isTypedArray: isTypedArray,
	  isFileList: isFileList
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(39);
	
	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _curryN = /*#__PURE__*/__webpack_require__(109);
	
	/**
	 * Returns a curried equivalent of the provided function, with the specified
	 * arity. The curried function has two unusual capabilities. First, its
	 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
	 * the following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curry
	 * @example
	 *
	 *      const sumArgs = (...args) => R.sum(args);
	 *
	 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
	 *      const f = curriedAddFourNumbers(1, 2);
	 *      const g = f(3);
	 *      g(4); //=> 10
	 */
	
	
	var curryN = /*#__PURE__*/_curry2(function curryN(length, fn) {
	  if (length === 1) {
	    return _curry1(fn);
	  }
	  return _arity(length, _curryN(length, [], fn));
	});
	module.exports = curryN;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var wrap = exports.wrap = function () {
	  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(callable) {
	    var result;
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            startLoadingOverlay();
	            _context.prev = 1;
	            _context.next = 4;
	            return callable();
	
	          case 4:
	            result = _context.sent;
	            return _context.abrupt('return', result);
	
	          case 6:
	            _context.prev = 6;
	
	            stopLoadingOverlay();
	            return _context.finish(6);
	
	          case 9:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this, [[1,, 6, 9]]);
	  }));
	
	  return function wrap(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	exports.startLoadingOverlay = startLoadingOverlay;
	exports.stopLoadingOverlay = stopLoadingOverlay;
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/* eslint-disable no-undef */
	var options = exports.options = {
	  overlayBackgroundColor: '#F8F8F8',
	  overlayOpacity: '0.5',
	  spinnerIcon: 'ball-pulse',
	  spinnerColor: '#666666',
	  spinnerSize: '2x',
	  OverlayIDName: 'loading-overlay',
	  spinnerIDName: 'loading-spinner',
	  offsetX: 0,
	  offsetY: 0,
	  lockScroll: true,
	  overlayZIndex: 9998,
	  spinnerZIndex: 9999
	};
	
	function startLoadingOverlay() {
	  // Start the overlay
	  JsLoadingOverlay.show(options);
	}
	
	function stopLoadingOverlay() {
	  // Start the overlay
	  JsLoadingOverlay.hide(options);
	}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable unicorn/prevent-abbreviations */
	/* eslint-disable unicorn/catch-error-name */
	/* eslint-disable camelcase */
	var identifyUser = exports.identifyUser = function identifyUser() {
	  try {
	    var inStorage = localStorage.getItem('user');
	    var user = JSON.parse(inStorage);
	    try {
	      var identity = _.extend({}, user, {
	        name: user.firstName + ' ' + user.lastName,
	        Name: user.firstName + ' ' + user.lastName
	      });
	      console.debug('identifyUser:', { identity: identity, user: user });
	      analytics.identify(user.id, identity);
	    } catch (error) {
	      console.error('analytics.identify', error);
	    }
	
	    return user;
	  } catch (e) {
	    console.error('Track: identifyUser error', e);
	  }
	};
	
	/* Pre-User Acquisition */
	var homepageMainCTA = exports.homepageMainCTA = function homepageMainCTA(type) {
	  if (type === 'Who Is Hiring') {
	    analytics.track('homepage main cta', {
	      event: 'lexstep_webapp',
	      eventCategory: 'pre-user acquisition',
	      eventAction: 'homepage main cta',
	      eventLabel: 'click'
	    });
	  } else if (type === 'Request Access Now') {
	    analytics.track('signing bonus request access', {
	      event: 'lexstep_webapp',
	      eventCategory: 'pre-user acquisition',
	      eventAction: 'signing bonus request access',
	      eventLabel: 'click'
	    });
	  } else if (type === 'Get Started Now') {
	    analytics.track('how it works get started now', {
	      event: 'lexstep_webapp',
	      eventCategory: 'pre-user acquisition',
	      eventAction: 'how it works get started now',
	      eventLabel: 'click'
	    });
	  }
	};
	
	var menuVideos = exports.menuVideos = function menuVideos() {
	  analytics.track('menu videos', {
	    event: 'lexstep_webapp',
	    eventCategory: 'pre-user acquisition',
	    eventAction: 'menu videos',
	    eventLabel: 'click'
	  });
	};
	
	var getStarted = exports.getStarted = function getStarted() {
	  analytics.track('get started', {
	    event: 'lexstep_webapp',
	    eventCategory: 'pre-user acquisition',
	    eventAction: 'get started',
	    eventLabel: 'click'
	  });
	};
	
	var blogBannerGetStarted = exports.blogBannerGetStarted = function blogBannerGetStarted() {
	  analytics.track('blog banner get started', {
	    event: 'lexstep_webapp',
	    eventCategory: 'pre-user acquisition',
	    eventAction: 'blog banner get started',
	    eventLabel: 'click'
	  });
	};
	
	var socialButtonClick = exports.socialButtonClick = function socialButtonClick(type) {
	  analytics.track('social button clicks footer', {
	    event: 'lexstep_webapp',
	    eventCategory: 'pre-user acquisition',
	    eventAction: 'social button clicks footer',
	    eventLabel: 'click',
	    social: type
	  });
	};
	
	/* Lead Acquisition */
	var earnOneThousandGetYourLink = exports.earnOneThousandGetYourLink = function earnOneThousandGetYourLink(first_Name, last_Name, email) {
	  try {
	    analytics.track('earn 1000 get your link', {
	      event: 'lexstep_webapp',
	      eventCategory: 'lead acquisition',
	      eventAction: 'earn 1000 get your link',
	      eventLabel: 'submit',
	      first_Name: first_Name,
	      last_Name: last_Name,
	      email: email
	    });
	  } catch (e) {
	    console.log('Track: earnOneThousandGetYourLink', e);
	  }
	};
	
	var copyLinkClipboard = exports.copyLinkClipboard = function copyLinkClipboard() {
	  try {
	    analytics.track('copy link clipboard', {
	      event: 'lexstep_webapp',
	      eventCategory: 'lead acquisition',
	      eventAction: 'copy link clipboard',
	      eventLabel: 'click'
	    });
	  } catch (e) {
	    console.log('Track: copyLinkClipboard', e);
	  }
	};
	
	var shareFacebook = exports.shareFacebook = function shareFacebook() {
	  try {
	    analytics.track('share facebook', {
	      event: 'lexstep_webapp',
	      eventCategory: 'lead acquisition',
	      eventAction: 'share facebook',
	      eventLabel: 'submit'
	    });
	  } catch (e) {
	    console.log('Track: shareFacebook', e);
	  }
	};
	
	var sendEmailEvent = exports.sendEmailEvent = function sendEmailEvent() {
	  try {
	    analytics.track('send email', {
	      event: 'lexstep_webapp',
	      eventCategory: 'lead acquisition',
	      eventAction: 'send email',
	      eventLabel: 'submit'
	    });
	  } catch (e) {
	    console.log('Track: sendEmailEvent', e);
	  }
	};
	
	/* User Acquisition */
	var signUpPageView = exports.signUpPageView = function signUpPageView() {
	  try {
	    analytics.track('sign up - page view', {
	      event: 'lexstep_webapp',
	      eventCategory: 'user acquisition',
	      eventAction: 'sign up - page view',
	      eventLabel: ''
	    });
	  } catch (e) {
	    console.log('Track: signUpPageView', e);
	  }
	};
	
	var signUpGetStartedEvent = exports.signUpGetStartedEvent = function signUpGetStartedEvent() {
	  try {
	    analytics.track('sign up - get started', {
	      event: 'lexstep_webapp',
	      eventCategory: 'user acquisition',
	      eventAction: 'sign up - get started',
	      eventLabel: 'submit'
	    });
	  } catch (e) {
	    console.log('Track: signUpGetStarted', e);
	  }
	};
	
	var signUpRequestAccess = exports.signUpRequestAccess = function signUpRequestAccess(nationality, current_location,
	/* Category, */phone, date_commenced_practice, jurisdictions, practice_areas, target_location, linkedin, cv) {
	  try {
	    analytics.track('sign up - request access', {
	      event: 'lexstep_webapp',
	      eventCategory: 'user acquisition',
	      eventAction: 'sign up - request access',
	      eventLabel: 'submit',
	      nationality: nationality,
	      current_location: current_location,
	      /* Category, */
	      phone: phone,
	      date_commenced_practice: date_commenced_practice,
	      jurisdictions: jurisdictions,
	      practice_areas: practice_areas,
	      target_location: target_location,
	      linkedin: linkedin,
	      cv: cv
	    });
	  } catch (e) {
	    console.log('Track: signUpRequestAccess', e);
	  }
	};
	
	var signUpLinkedInConnect = exports.signUpLinkedInConnect = function signUpLinkedInConnect() {
	  try {
	    analytics.track('sign up - linkedin connect', {
	      event: 'lexstep_webapp',
	      eventCategory: 'user acquisition',
	      eventAction: 'sign up - linkedin connect',
	      eventLabel: 'submit'
	    });
	  } catch (e) {
	    console.log('Track: signUpLinkedInConnect', e);
	  }
	};
	
	var signUpCVUpload = exports.signUpCVUpload = function signUpCVUpload() {
	  try {
	    analytics.track('sign up - cv upload', {
	      event: 'lexstep_webapp',
	      eventCategory: 'user acquisition',
	      eventAction: 'sign up - cv upload',
	      eventLabel: 'submit'
	    });
	  } catch (e) {
	    console.log('Track: signUpCVUpload', e);
	  }
	};
	
	var hiringFormSubmission = exports.hiringFormSubmission = function hiringFormSubmission(name, email, company_name, job_type, where_did_you_hear_about_us) {
	  try {
	    analytics.track('hiring - form submission', {
	      event: 'lexstep_webapp',
	      eventCategory: 'user acquisition',
	      eventAction: 'hiring - form submission',
	      eventLabel: 'submit',
	      name: name,
	      email: email,
	      company_name: company_name,
	      job_type: job_type,
	      where_did_you_hear_about_us: where_did_you_hear_about_us
	    });
	  } catch (e) {
	    console.log('Track: hiringFormSubmission', e);
	  }
	};
	
	/* Post User Acquisition */
	var jobView = exports.jobView = function jobView(job_id, job_company, job_title, job_pqe, job_contract, job_role, job_address, job_type, firm_name, firm_id) {
	  try {
	    var options = {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'job - view',
	      eventLabel: 'click',
	      job_id: job_id,
	      job_company: job_company,
	      job_title: job_title,
	      job_pqe: job_pqe,
	      job_contract: job_contract,
	      job_role: job_role,
	      job_address: job_address,
	      job_type: job_type,
	      firm_name: firm_name,
	      firm_id: firm_id
	    };
	
	    console.debug('Tracking "job - view"', options);
	    analytics.track('job - view', options);
	  } catch (e) {
	    console.log('Track: jobView', e);
	  }
	};
	
	var jobInterested = exports.jobInterested = function jobInterested(job_id, job_company, job_title, job_pqe, job_contract, job_role, job_address, job_type, firm_name, firm_id) {
	  try {
	    analytics.track('job - interested', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'job - interested',
	      eventLabel: 'submit',
	      job_id: job_id,
	      job_company: job_company,
	      job_title: job_title,
	      job_pqe: job_pqe,
	      job_contract: job_contract,
	      job_role: job_role,
	      job_address: job_address,
	      job_type: job_type,
	      firm_name: firm_name,
	      firm_id: firm_id
	    });
	  } catch (e) {
	    console.log('Track: jobInterested', e);
	  }
	};
	
	var jobShareProfile = exports.jobShareProfile = function jobShareProfile(job_id, job_company, job_title, job_pqe, job_contract, job_role, job_address, job_type, firm_name, firm_id) {
	  try {
	    analytics.track('job - share profile', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'job - share profile',
	      eventLabel: 'submit',
	      job_id: job_id,
	      job_company: job_company,
	      job_title: job_title,
	      job_pqe: job_pqe,
	      job_contract: job_contract,
	      job_role: job_role,
	      job_address: job_address,
	      job_type: job_type,
	      firm_name: firm_name,
	      firm_id: firm_id
	    });
	  } catch (e) {
	    console.log('Track: jobView', e);
	  }
	};
	
	var jobNotForMe = exports.jobNotForMe = function jobNotForMe(job_id, job_company, job_title, job_pqe, job_contract, job_role, job_address, job_type, firm_name, firm_id) {
	  try {
	    analytics.track('job - not for me', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'job - not for me',
	      eventLabel: 'submit',
	      job_id: job_id,
	      job_company: job_company,
	      job_title: job_title,
	      job_pqe: job_pqe,
	      job_contract: job_contract,
	      job_role: job_role,
	      job_address: job_address,
	      job_type: job_type,
	      firm_name: firm_name,
	      firm_id: firm_id
	    });
	  } catch (e) {
	    console.log('Track: jobNotForMe', e);
	  }
	};
	
	var searchMyPracticeArea = exports.searchMyPracticeArea = function searchMyPracticeArea(practice_area) {
	  try {
	    analytics.track('search - my practice area ', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'search - my practice area ',
	      eventLabel: 'submit',
	      practice_area: practice_area
	    });
	  } catch (e) {
	    console.log('Track: searchMyPracticeArea', e);
	  }
	};
	
	var searchLocation = exports.searchLocation = function searchLocation(location) {
	  try {
	    analytics.track('search - location', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'search - location',
	      eventLabel: 'submit',
	      location: location
	    });
	  } catch (e) {
	    console.log('Track: searchLocation', e);
	  }
	};
	
	var searchPQESelected = exports.searchPQESelected = function searchPQESelected(pqe) {
	  try {
	    analytics.track('search - pqe - selected', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'search - pqe - selected',
	      eventLabel: 'submit',
	      pqe: pqe
	    });
	  } catch (e) {
	    console.log('Track: searchPQESelected', e);
	  }
	};
	
	var makeMeAnOffer = exports.makeMeAnOffer = function makeMeAnOffer() {
	  try {
	    analytics.track('make me an offer ', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'make me an offer ',
	      eventLabel: 'click'
	    });
	  } catch (e) {
	    console.log('Track: makeMeAnOffer', e);
	  }
	};
	
	var dropUsANoteFormSubmission = exports.dropUsANoteFormSubmission = function dropUsANoteFormSubmission() {
	  // Try {
	  // } catch (error) {
	  //     console.log("Track: jobView", e);
	  // }
	  analytics.track('drop us a note - form submission', {
	    event: 'lexstep_webapp',
	    eventCategory: 'post-user acquisition',
	    eventAction: 'drop us a note - form submission',
	    eventLabel: 'submit'
	  });
	};
	
	var trackOpen = exports.trackOpen = function trackOpen() {
	  try {
	    analytics.track('track - open', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'track - open',
	      eventLabel: 'submit'
	    });
	  } catch (e) {
	    console.log('Track: trackOpen', e);
	  }
	};
	
	var trackViewJob = exports.trackViewJob = function trackViewJob(job_id, job_company, job_title, job_pqe, firm_name, firm_id) {
	  try {
	    analytics.track('track - view job', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'track - view job',
	      eventLabel: 'submit',
	      job_id: job_id,
	      job_company: job_company,
	      job_title: job_title,
	      job_pqe: job_pqe,
	      // Job_contract: [],
	      // job_role: [],
	      // job_address: [],
	      // job_type: [],
	      firm_name: firm_name,
	      firm_id: firm_id
	    });
	  } catch (e) {
	    console.log('Track: trackViewJob', e);
	  }
	};
	
	var profileCVAdd = exports.profileCVAdd = function profileCVAdd(cv) {
	  try {
	    analytics.track('profile - cv - add', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'profile - cv - add',
	      eventLabel: 'submit',
	      cv: cv
	    });
	  } catch (e) {
	    console.log('Track: profileCVAdd', e);
	  }
	};
	
	var profileExperienceAdd = exports.profileExperienceAdd = function profileExperienceAdd(experience) {
	  try {
	    analytics.track('profile - experience - add', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'profile - experience - add',
	      eventLabel: 'submit',
	      experience: experience
	    });
	  } catch (e) {
	    console.log('Track: profileExperienceAdd', e);
	  }
	};
	
	var profileAboutYouUpdate = exports.profileAboutYouUpdate = function profileAboutYouUpdate(about_you) {
	  try {
	    analytics.track('profile - about you - update', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'profile - about you - update',
	      eventLabel: 'submit',
	      about_you: about_you
	    });
	  } catch (e) {
	    console.log('Track: profileAboutYouUpdate', e);
	  }
	};
	
	var profileLanguageUpdate = exports.profileLanguageUpdate = function profileLanguageUpdate(language) {
	  try {
	    analytics.track('profile - language - update', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'profile - language - update',
	      eventLabel: 'submit',
	      language: language
	    });
	  } catch (e) {
	    console.log('Track: profileLanguageUpdate', e);
	  }
	};
	
	var profileJuridictionUpdate = exports.profileJuridictionUpdate = function profileJuridictionUpdate(juridiction) {
	  try {
	    analytics.track('profile - juridiction - update', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'profile - juridiction - update',
	      eventLabel: 'submit',
	      juridiction: juridiction
	    });
	  } catch (e) {
	    console.log('Track: profileJuridictionUpdate', e);
	  }
	};
	
	var profilePracticeAreaUpdate = exports.profilePracticeAreaUpdate = function profilePracticeAreaUpdate(practice_area) {
	  try {
	    analytics.track('profile - practice area - update', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'profile - practice area - update',
	      eventLabel: 'submit',
	      practice_area: practice_area
	    });
	  } catch (e) {
	    console.log('Track: profilePracticeAreaUpdate', e);
	  }
	};
	
	var profileSalaryDetailsAdd = exports.profileSalaryDetailsAdd = function profileSalaryDetailsAdd(salary) {
	  try {
	    analytics.track('profile - salary details - add', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'profile - salary details - add',
	      eventLabel: 'submit',
	      salary: salary
	    });
	  } catch (e) {
	    console.log('Track: profileSalaryDetailsAdd', e);
	  }
	};
	
	var profileTargetLocationsUpdate = exports.profileTargetLocationsUpdate = function profileTargetLocationsUpdate(target_location) {
	  try {
	    analytics.track('profile - target locations - update', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'profile - target locations - update',
	      eventLabel: 'submit',
	      target_location: target_location
	    });
	  } catch (e) {
	    console.log('Track: profileTargetLocationsUpdate', e);
	  }
	};
	
	var profileContractUpdate = exports.profileContractUpdate = function profileContractUpdate(contract) {
	  try {
	    analytics.track('profile - contract - update', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'profile - contract - update',
	      eventLabel: 'submit',
	      contract: contract
	    });
	  } catch (e) {
	    console.log('Track: profileContractUpdate', e);
	  }
	};
	
	var profileRoleUpdate = exports.profileRoleUpdate = function profileRoleUpdate(role) {
	  try {
	    analytics.track('profile - role - update', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'profile - role - update',
	      eventLabel: 'submit',
	      role: role
	    });
	  } catch (e) {
	    console.log('Track: profileRoleUpdate', e);
	  }
	};
	
	var profileTargetEmployerTypeUpdate = exports.profileTargetEmployerTypeUpdate = function profileTargetEmployerTypeUpdate(target_employer_type) {
	  try {
	    analytics.track('profile - target employer type - update', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'profile - target employer type - update',
	      eventLabel: 'submit',
	      target_employer_type: target_employer_type
	    });
	  } catch (e) {
	    console.log('Track: profileTargetEmployerTypeUpdate', e);
	  }
	};
	
	var profileInfosUpdate = exports.profileInfosUpdate = function profileInfosUpdate() {
	  try {
	    analytics.track('profile - infos - update', {
	      event: 'lexstep_webapp',
	      eventCategory: 'post-user acquisition',
	      eventAction: 'profile - infos - update',
	      eventLabel: 'submit'
	    });
	  } catch (e) {
	    console.log('Track: profileInfosUpdate', e);
	  }
	};
	
	/* Retention */
	var trackLogin = exports.trackLogin = function trackLogin(user) {
	  try {
	    var user_id = user.id;
	    var name = user.firstName + ' ' + user.lastName;
	
	    analytics.track('login', _.extend({}, user, {
	      event: 'lexstep_webapp',
	      eventCategory: 'retention',
	      eventAction: 'login',
	      eventLabel: 'submit',
	      name: name,
	      user_id: user_id,
	      currentEmployerName: user && user.employer ? user.employer.name : undefined
	    }));
	  } catch (e) {
	    console.log('Track: trackLogin', e);
	  }
	};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(13);
	var createDesc = __webpack_require__(61);
	module.exports = __webpack_require__(12) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7);
	var hide = __webpack_require__(22);
	var has = __webpack_require__(27);
	var SRC = __webpack_require__(65)('src');
	var $toString = __webpack_require__(779);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(35).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var fails = __webpack_require__(8);
	var defined = __webpack_require__(44);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	function _has(prop, obj) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	module.exports = _has;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArrayLike = /*#__PURE__*/__webpack_require__(111);
	
	var _xwrap = /*#__PURE__*/__webpack_require__(399);
	
	var bind = /*#__PURE__*/__webpack_require__(373);
	
	function _arrayReduce(xf, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    acc = xf['@@transducer/step'](acc, list[idx]);
	    if (acc && acc['@@transducer/reduced']) {
	      acc = acc['@@transducer/value'];
	      break;
	    }
	    idx += 1;
	  }
	  return xf['@@transducer/result'](acc);
	}
	
	function _iterableReduce(xf, acc, iter) {
	  var step = iter.next();
	  while (!step.done) {
	    acc = xf['@@transducer/step'](acc, step.value);
	    if (acc && acc['@@transducer/reduced']) {
	      acc = acc['@@transducer/value'];
	      break;
	    }
	    step = iter.next();
	  }
	  return xf['@@transducer/result'](acc);
	}
	
	function _methodReduce(xf, acc, obj, methodName) {
	  return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
	}
	
	var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
	
	function _reduce(fn, acc, list) {
	  if (typeof fn === 'function') {
	    fn = _xwrap(fn);
	  }
	  if (_isArrayLike(list)) {
	    return _arrayReduce(fn, acc, list);
	  }
	  if (typeof list['fantasy-land/reduce'] === 'function') {
	    return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
	  }
	  if (list[symIterator] != null) {
	    return _iterableReduce(fn, acc, list[symIterator]());
	  }
	  if (typeof list.next === 'function') {
	    return _iterableReduce(fn, acc, list);
	  }
	  if (typeof list.reduce === 'function') {
	    return _methodReduce(fn, acc, list, 'reduce');
	  }
	
	  throw new TypeError('reduce: list must be array or iterable');
	}
	module.exports = _reduce;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(77);
	var createDesc = __webpack_require__(61);
	var toIObject = __webpack_require__(30);
	var toPrimitive = __webpack_require__(46);
	var has = __webpack_require__(27);
	var IE8_DOM_DEFINE = __webpack_require__(202);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(12) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(27);
	var toObject = __webpack_require__(14);
	var IE_PROTO = __webpack_require__(141)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(76);
	var defined = __webpack_require__(44);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _equals = /*#__PURE__*/__webpack_require__(1060);
	
	/**
	 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
	 * cyclical data structures.
	 *
	 * Dispatches symmetrically to the `equals` methods of both arguments, if
	 * present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> b -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      R.equals(1, 1); //=> true
	 *      R.equals(1, '1'); //=> false
	 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
	 *
	 *      const a = {}; a.v = a;
	 *      const b = {}; b.v = b;
	 *      R.equals(a, b); //=> true
	 */
	
	
	var equals = /*#__PURE__*/_curry2(function equals(a, b) {
	  return _equals(a, b, [], []);
	});
	module.exports = equals;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _map = /*#__PURE__*/__webpack_require__(113);
	
	var _reduce = /*#__PURE__*/__webpack_require__(26);
	
	var _xmap = /*#__PURE__*/__webpack_require__(1084);
	
	var curryN = /*#__PURE__*/__webpack_require__(18);
	
	var keys = /*#__PURE__*/__webpack_require__(41);
	
	/**
	 * Takes a function and
	 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
	 * applies the function to each of the functor's values, and returns
	 * a functor of the same shape.
	 *
	 * Ramda provides suitable `map` implementations for `Array` and `Object`,
	 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
	 *
	 * Dispatches to the `map` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * Also treats functions as functors and will compose them together.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Functor f => (a -> b) -> f a -> f b
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {Array} list The list to be iterated over.
	 * @return {Array} The new list.
	 * @see R.transduce, R.addIndex
	 * @example
	 *
	 *      const double = x => x * 2;
	 *
	 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
	 *
	 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
	 * @symb R.map(f, [a, b]) = [f(a), f(b)]
	 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
	 * @symb R.map(f, functor_o) = functor_o.map(f)
	 */
	
	
	var map = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
	  switch (Object.prototype.toString.call(functor)) {
	    case '[object Function]':
	      return curryN(functor.length, function () {
	        return fn.call(this, functor.apply(this, arguments));
	      });
	    case '[object Object]':
	      return _reduce(function (acc, key) {
	        acc[key] = fn(functor[key]);
	        return acc;
	      }, {}, keys(functor));
	    default:
	      return _map(fn, functor);
	  }
	}));
	module.exports = map;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/******************************************************************/
	/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
	/******************************************************************/
	var isSelected = function isSelected(object) {
	  return object.isSelected;
	};
	var isAnyObjectSelected = function isAnyObjectSelected(objectArray) {
	  return objectArray.some(isSelected);
	};
	
	var countSelectedObjects = function countSelectedObjects(allObjects) {
	  return getSelectedObjects(allObjects).length;
	};
	
	var getSelectedObjects = function getSelectedObjects(allObjects) {
	  return _.filter(allObjects, function (object) {
	    return isSelected(object);
	  });
	};
	
	var getSelectedObjectsProperty = function getSelectedObjectsProperty(allObjects, property) {
	  return new Promise(function (resolve, reject) {
	    resolve(getSelectedObjects(allObjects).map(function (object) {
	      return object[property];
	    }));
	  });
	};
	
	var setPropertyForAllObjects = function setPropertyForAllObjects(allObjects, property, value) {
	  if (_.isEmpty(allObjects)) return;else if (!_.isArray(allObjects)) allObjects = new Array(allObjects);
	
	  allObjects.forEach(function (object) {
	    return object[property] = value;
	  });
	};
	
	var changeSelectedForAllObjects = function changeSelectedForAllObjects(allObjects, value) {
	  setPropertyForAllObjects(allObjects, 'isSelected', value);
	};
	
	var getDefaultListForAssignedAdminDropdown = function getDefaultListForAssignedAdminDropdown(listOfAdmins) {
	  return [{
	    name: "Select None",
	    ticked: true,
	    value: 0
	  }].concat(listOfAdmins.map(function (admin) {
	    return {
	      name: admin.first_Name + " " + admin.last_Name,
	      email: admin.email,
	      user_ID: admin.user_ID,
	      ticked: false,
	      value: admin.user_ID
	    };
	  }));
	};
	
	// Converts a CSV into an ARRAY
	var splitStringIntoArray = function splitStringIntoArray(string, splitter) {
	  return !string ? string : string.split(splitter);
	};
	
	var isSignUpPage = function isSignUpPage() {
	  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  return !!url.match(url.match(/^\/sign-?up.*/));
	};
	var isResetPasswordPage = function isResetPasswordPage() {
	  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  return !!url.match(url.match(/^\/reset-?[pP]assword.*/));
	};
	
	exports.countSelectedObjects = countSelectedObjects;
	exports.getSelectedObjects = getSelectedObjects;
	exports.getSelectedObjectsProperty = getSelectedObjectsProperty;
	exports.changeSelectedForAllObjects = changeSelectedForAllObjects;
	exports.setPropertyForAllObjects = setPropertyForAllObjects;
	exports.getDefaultListForAssignedAdminDropdown = getDefaultListForAssignedAdminDropdown;
	exports.isSelected = isSelected;
	exports.isAnyObjectSelected = isAnyObjectSelected;
	exports.isSignUpPage = isSignUpPage;
	exports.isResetPasswordPage = isResetPasswordPage;
	exports.splitStringIntoArray = splitStringIntoArray;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(19);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(8);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	function _arity(n, fn) {
	  /* eslint-disable no-unused-vars */
	  switch (n) {
	    case 0:
	      return function () {
	        return fn.apply(this, arguments);
	      };
	    case 1:
	      return function (a0) {
	        return fn.apply(this, arguments);
	      };
	    case 2:
	      return function (a0, a1) {
	        return fn.apply(this, arguments);
	      };
	    case 3:
	      return function (a0, a1, a2) {
	        return fn.apply(this, arguments);
	      };
	    case 4:
	      return function (a0, a1, a2, a3) {
	        return fn.apply(this, arguments);
	      };
	    case 5:
	      return function (a0, a1, a2, a3, a4) {
	        return fn.apply(this, arguments);
	      };
	    case 6:
	      return function (a0, a1, a2, a3, a4, a5) {
	        return fn.apply(this, arguments);
	      };
	    case 7:
	      return function (a0, a1, a2, a3, a4, a5, a6) {
	        return fn.apply(this, arguments);
	      };
	    case 8:
	      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
	        return fn.apply(this, arguments);
	      };
	    case 9:
	      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
	        return fn.apply(this, arguments);
	      };
	    case 10:
	      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
	        return fn.apply(this, arguments);
	      };
	    default:
	      throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
	  }
	}
	module.exports = _arity;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	/**
	 * Private `concat` function to merge two array-like objects.
	 *
	 * @private
	 * @param {Array|Arguments} [set1=[]] An array-like object.
	 * @param {Array|Arguments} [set2=[]] An array-like object.
	 * @return {Array} A new, merged array.
	 * @example
	 *
	 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 */
	function _concat(set1, set2) {
	  set1 = set1 || [];
	  set2 = set2 || [];
	  var idx;
	  var len1 = set1.length;
	  var len2 = set2.length;
	  var result = [];
	
	  idx = 0;
	  while (idx < len1) {
	    result[result.length] = set1[idx];
	    idx += 1;
	  }
	  idx = 0;
	  while (idx < len2) {
	    result[result.length] = set2[idx];
	    idx += 1;
	  }
	  return result;
	}
	module.exports = _concat;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _has = /*#__PURE__*/__webpack_require__(25);
	
	var _isArguments = /*#__PURE__*/__webpack_require__(393);
	
	// cover IE < 9 keys issues
	
	
	var hasEnumBug = ! /*#__PURE__*/{ toString: null }.propertyIsEnumerable('toString');
	var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	// Safari bug
	var hasArgsEnumBug = /*#__PURE__*/function () {
	  'use strict';
	
	  return arguments.propertyIsEnumerable('length');
	}();
	
	var contains = function contains(list, item) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (list[idx] === item) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	};
	
	/**
	 * Returns a list containing the names of all the enumerable own properties of
	 * the supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own properties.
	 * @see R.keysIn, R.values
	 * @example
	 *
	 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
	 */
	var keys = typeof Object.keys === 'function' && !hasArgsEnumBug ? /*#__PURE__*/_curry1(function keys(obj) {
	  return Object(obj) !== obj ? [] : Object.keys(obj);
	}) : /*#__PURE__*/_curry1(function keys(obj) {
	  if (Object(obj) !== obj) {
	    return [];
	  }
	  var prop, nIdx;
	  var ks = [];
	  var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
	  for (prop in obj) {
	    if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
	      ks[ks.length] = prop;
	    }
	  }
	  if (hasEnumBug) {
	    nIdx = nonEnumerableProps.length - 1;
	    while (nIdx >= 0) {
	      prop = nonEnumerableProps[nIdx];
	      if (_has(prop, obj) && !contains(ks, prop)) {
	        ks[ks.length] = prop;
	      }
	      nIdx -= 1;
	    }
	  }
	  return ks;
	});
	module.exports = keys;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = /*#__PURE__*/__webpack_require__(80);
	
	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Returns the elements of the given list or string (or object with a `slice`
	 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
	 *
	 * Dispatches to the `slice` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @sig Number -> Number -> String -> String
	 * @param {Number} fromIndex The start index (inclusive).
	 * @param {Number} toIndex The end index (exclusive).
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
	 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
	 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
	 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
	 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
	 */
	
	
	var slice = /*#__PURE__*/_curry3( /*#__PURE__*/_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
	  return Array.prototype.slice.call(list, fromIndex, toIndex);
	}));
	module.exports = slice;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(36);
	var IObject = __webpack_require__(76);
	var toObject = __webpack_require__(14);
	var toLength = __webpack_require__(11);
	var asc = __webpack_require__(125);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(3);
	var core = __webpack_require__(35);
	var fails = __webpack_require__(8);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(9);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var _reduce = /*#__PURE__*/__webpack_require__(26);
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It may use
	 * [`R.reduced`](#reduced) to shortcut the iteration.
	 *
	 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
	 * is *(value, acc)*.
	 *
	 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
	 *
	 * Dispatches to the `reduce` method of the third argument, if present. When
	 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
	 * shortcuting, as this is not implemented by `reduce`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduced, R.addIndex, R.reduceRight
	 * @example
	 *
	 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
	 *      //          -               -10
	 *      //         / \              / \
	 *      //        -   4           -6   4
	 *      //       / \              / \
	 *      //      -   3   ==>     -3   3
	 *      //     / \              / \
	 *      //    -   2           -1   2
	 *      //   / \              / \
	 *      //  0   1            0   1
	 *
	 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
	 */
	
	
	var reduce = /*#__PURE__*/_curry3(_reduce);
	module.exports = reduce;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(224);
	var $export = __webpack_require__(3);
	var shared = __webpack_require__(78)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(228))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(12)) {
	  var LIBRARY = __webpack_require__(52);
	  var global = __webpack_require__(7);
	  var fails = __webpack_require__(8);
	  var $export = __webpack_require__(3);
	  var $typed = __webpack_require__(101);
	  var $buffer = __webpack_require__(146);
	  var ctx = __webpack_require__(36);
	  var anInstance = __webpack_require__(56);
	  var propertyDesc = __webpack_require__(61);
	  var hide = __webpack_require__(22);
	  var redefineAll = __webpack_require__(62);
	  var toInteger = __webpack_require__(38);
	  var toLength = __webpack_require__(11);
	  var toIndex = __webpack_require__(222);
	  var toAbsoluteIndex = __webpack_require__(64);
	  var toPrimitive = __webpack_require__(46);
	  var has = __webpack_require__(27);
	  var classof = __webpack_require__(68);
	  var isObject = __webpack_require__(9);
	  var toObject = __webpack_require__(14);
	  var isArrayIter = __webpack_require__(132);
	  var create = __webpack_require__(58);
	  var getPrototypeOf = __webpack_require__(29);
	  var gOPN = __webpack_require__(59).f;
	  var getIterFn = __webpack_require__(148);
	  var uid = __webpack_require__(65);
	  var wks = __webpack_require__(10);
	  var createArrayMethod = __webpack_require__(43);
	  var createArrayIncludes = __webpack_require__(89);
	  var speciesConstructor = __webpack_require__(79);
	  var ArrayIterators = __webpack_require__(149);
	  var Iterators = __webpack_require__(69);
	  var $iterDetect = __webpack_require__(94);
	  var setSpecies = __webpack_require__(63);
	  var arrayFill = __webpack_require__(124);
	  var arrayCopyWithin = __webpack_require__(194);
	  var $DP = __webpack_require__(13);
	  var $GOPD = __webpack_require__(28);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	/**
	 * Tests whether or not an object is an array.
	 *
	 * @private
	 * @param {*} val The object to test.
	 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
	 * @example
	 *
	 *      _isArray([]); //=> true
	 *      _isArray(null); //=> false
	 *      _isArray({}); //=> false
	 */
	module.exports = Array.isArray || function _isArray(val) {
	  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
	};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(10)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(22)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(65)('meta');
	var isObject = __webpack_require__(9);
	var has = __webpack_require__(27);
	var setDesc = __webpack_require__(13).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(8)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	function _reduced(x) {
	  return x && x['@@transducer/reduced'] ? x : {
	    '@@transducer/value': x,
	    '@@transducer/reduced': true
	  };
	}
	module.exports = _reduced;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatQualificationDateToPqe = undefined;
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatQualificationDateToPqe = exports.formatQualificationDateToPqe = function formatQualificationDateToPqe(input) {
	  if (!input) return '-';
	
	  var now = (0, _moment2.default)(new Date());
	  var qualified = (0, _moment2.default)(new Date(input));
	
	  var differenceInMonths = now.diff(qualified, 'months') % 12;
	  var qualifiesInFuture = now.isBefore(qualified);
	  if (qualifiesInFuture) {
	    var yearsOffset = differenceInMonths <= -6 ? 1 : 0;
	    var _years = now.diff(qualified, 'years') + yearsOffset;
	    var _months = differenceInMonths <= -6 ? '0' : '5';
	    var asString = ('-' + _years + '.' + _months).replace('--', '-');
	    var _asFloat = Number.parseFloat(asString);
	    return _asFloat <= -2.5 ? -2.5 : _asFloat;
	  }
	
	  var years = '' + now.diff(qualified, 'years');
	  var months = differenceInMonths >= 6 ? '5' : '0';
	  var asFloat = Number.parseFloat(years + '.' + months);
	  return asFloat >= 11 ? 11 : asFloat;
	};

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(36);
	var call = __webpack_require__(205);
	var isArrayIter = __webpack_require__(132);
	var anObject = __webpack_require__(6);
	var toLength = __webpack_require__(11);
	var getIterFn = __webpack_require__(148);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(6);
	var dPs = __webpack_require__(211);
	var enumBugKeys = __webpack_require__(128);
	var IE_PROTO = __webpack_require__(141)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(127)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(130).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(213);
	var hiddenKeys = __webpack_require__(128).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(213);
	var enumBugKeys = __webpack_require__(128);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(23);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(7);
	var dP = __webpack_require__(13);
	var DESCRIPTORS = __webpack_require__(12);
	var SPECIES = __webpack_require__(10)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(38);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(9);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [config] The config.
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	function AxiosError(message, code, config, request, response) {
	  Error.call(this);
	  this.message = message;
	  this.name = 'AxiosError';
	  code && (this.code = code);
	  config && (this.config = config);
	  request && (this.request = request);
	  response && (this.response = response);
	}
	
	utils.inherits(AxiosError, Error, {
	  toJSON: function toJSON() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code,
	      status: this.response && this.response.status ? this.response.status : null
	    };
	  }
	});
	
	var prototype = AxiosError.prototype;
	var descriptors = {};
	
	[
	  'ERR_BAD_OPTION_VALUE',
	  'ERR_BAD_OPTION',
	  'ECONNABORTED',
	  'ETIMEDOUT',
	  'ERR_NETWORK',
	  'ERR_FR_TOO_MANY_REDIRECTS',
	  'ERR_DEPRECATED',
	  'ERR_BAD_RESPONSE',
	  'ERR_BAD_REQUEST',
	  'ERR_CANCELED'
	// eslint-disable-next-line func-names
	].forEach(function(code) {
	  descriptors[code] = {value: code};
	});
	
	Object.defineProperties(AxiosError, descriptors);
	Object.defineProperty(prototype, 'isAxiosError', {value: true});
	
	// eslint-disable-next-line func-names
	AxiosError.from = function(error, code, config, request, response, customProps) {
	  var axiosError = Object.create(prototype);
	
	  utils.toFlatObject(error, axiosError, function filter(obj) {
	    return obj !== Error.prototype;
	  });
	
	  AxiosError.call(axiosError, error.message, code, config, request, response);
	
	  axiosError.name = error.name;
	
	  customProps && Object.assign(axiosError, customProps);
	
	  return axiosError;
	};
	
	module.exports = AxiosError;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(34);
	var TAG = __webpack_require__(10)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(13).f;
	var has = __webpack_require__(27);
	var TAG = __webpack_require__(10)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var defined = __webpack_require__(44);
	var fails = __webpack_require__(8);
	var spaces = __webpack_require__(144);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var _indexOf = /*#__PURE__*/__webpack_require__(392);
	
	function _includes(a, list) {
	  return _indexOf(list, a, 0) >= 0;
	}
	module.exports = _includes;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns the larger of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.maxBy, R.min
	 * @example
	 *
	 *      R.max(789, 123); //=> 789
	 *      R.max('a', 'b'); //=> 'b'
	 */
	
	
	var max = /*#__PURE__*/_curry2(function max(a, b) {
	  return b > a ? b : a;
	});
	module.exports = max;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Retrieve the value at a given path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> {a} -> a | Undefined
	 * @param {Array} path The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path`.
	 * @see R.prop
	 * @example
	 *
	 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
	 */
	
	
	var path = /*#__PURE__*/_curry2(function path(paths, obj) {
	  var val = obj;
	  var idx = 0;
	  while (idx < paths.length) {
	    if (val == null) {
	      return;
	    }
	    val = val[paths[idx]];
	    idx += 1;
	  }
	  return val;
	});
	module.exports = path;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(6);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(34);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(35);
	var global = __webpack_require__(7);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(52) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(6);
	var aFunction = __webpack_require__(19);
	var SPECIES = __webpack_require__(10)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArray = /*#__PURE__*/__webpack_require__(50);
	
	/**
	 * This checks whether a function has a [methodname] function. If it isn't an
	 * array it will execute that function otherwise it will default to the ramda
	 * implementation.
	 *
	 * @private
	 * @param {Function} fn ramda implemtation
	 * @param {String} methodname property to check for a custom implementation
	 * @return {Object} Whatever the return value of the method is.
	 */
	
	
	function _checkForMethod(methodname, fn) {
	  return function () {
	    var length = arguments.length;
	    if (length === 0) {
	      return fn();
	    }
	    var obj = arguments[length - 1];
	    return _isArray(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
	  };
	}
	module.exports = _checkForMethod;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	function _isFunction(x) {
	  return Object.prototype.toString.call(x) === '[object Function]';
	}
	module.exports = _isFunction;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	function _isString(x) {
	  return Object.prototype.toString.call(x) === '[object String]';
	}
	module.exports = _isString;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var _has = /*#__PURE__*/__webpack_require__(25);
	
	// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	
	
	function _objectAssign(target) {
	  if (target == null) {
	    throw new TypeError('Cannot convert undefined or null to object');
	  }
	
	  var output = Object(target);
	  var idx = 1;
	  var length = arguments.length;
	  while (idx < length) {
	    var source = arguments[idx];
	    if (source != null) {
	      for (var nextKey in source) {
	        if (_has(nextKey, source)) {
	          output[nextKey] = source[nextKey];
	        }
	      }
	    }
	    idx += 1;
	  }
	  return output;
	}
	
	module.exports = typeof Object.assign === 'function' ? Object.assign : _objectAssign;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _isFunction = /*#__PURE__*/__webpack_require__(81);
	
	var curryN = /*#__PURE__*/__webpack_require__(18);
	
	var toString = /*#__PURE__*/__webpack_require__(121);
	
	/**
	 * Turns a named method with a specified arity into a function that can be
	 * called directly supplied with arguments and a target object.
	 *
	 * The returned function is curried and accepts `arity + 1` parameters where
	 * the final parameter is the target object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
	 * @param {Number} arity Number of arguments the returned function should take
	 *        before the target object.
	 * @param {String} method Name of the method to call.
	 * @return {Function} A new curried function.
	 * @see R.construct
	 * @example
	 *
	 *      const sliceFrom = R.invoker(1, 'slice');
	 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
	 *      const sliceFrom6 = R.invoker(2, 'slice')(6);
	 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
	 * @symb R.invoker(0, 'method')(o) = o['method']()
	 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
	 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
	 */
	
	
	var invoker = /*#__PURE__*/_curry2(function invoker(arity, method) {
	  return curryN(arity + 1, function () {
	    var target = arguments[arity];
	    if (target != null && _isFunction(target[method])) {
	      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
	    }
	    throw new TypeError(toString(target) + ' does not have a method named "' + method + '"');
	  });
	});
	module.exports = invoker;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _isString = /*#__PURE__*/__webpack_require__(82);
	
	/**
	 * Returns the nth element of the given list or string. If n is negative the
	 * element at index length + n is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> a | Undefined
	 * @sig Number -> String -> String
	 * @param {Number} offset
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      const list = ['foo', 'bar', 'baz', 'quux'];
	 *      R.nth(1, list); //=> 'bar'
	 *      R.nth(-1, list); //=> 'quux'
	 *      R.nth(-99, list); //=> undefined
	 *
	 *      R.nth(2, 'abc'); //=> 'c'
	 *      R.nth(3, 'abc'); //=> ''
	 * @symb R.nth(-1, [a, b, c]) = c
	 * @symb R.nth(0, [a, b, c]) = a
	 * @symb R.nth(1, [a, b, c]) = b
	 */
	
	
	var nth = /*#__PURE__*/_curry2(function nth(offset, list) {
	  var idx = offset < 0 ? list.length + offset : offset;
	  return _isString(list) ? list.charAt(idx) : list[idx];
	});
	module.exports = nth;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var map = /*#__PURE__*/__webpack_require__(32);
	
	var prop = /*#__PURE__*/__webpack_require__(162);
	
	/**
	 * Returns a new list by plucking the same named property off all objects in
	 * the list supplied.
	 *
	 * `pluck` will work on
	 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
	 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Functor f => k -> f {k: v} -> f v
	 * @param {Number|String} key The key name to pluck off of each object.
	 * @param {Array} f The array or functor to consider.
	 * @return {Array} The list of values for the given key.
	 * @see R.props
	 * @example
	 *
	 *      var getAges = R.pluck('age');
	 *      getAges([{name: 'fred', age: 29}, {name: 'wilma', age: 27}]); //=> [29, 27]
	 *
	 *      R.pluck(0, [[1, 2], [3, 4]]);               //=> [1, 3]
	 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
	 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
	 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
	 */
	
	
	var pluck = /*#__PURE__*/_curry2(function pluck(p, list) {
	  return map(prop(p), list);
	});
	module.exports = pluck;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _isString = /*#__PURE__*/__webpack_require__(82);
	
	/**
	 * Returns a new list or string with the elements or characters in reverse
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {Array|String}
	 * @example
	 *
	 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
	 *      R.reverse([1, 2]);     //=> [2, 1]
	 *      R.reverse([1]);        //=> [1]
	 *      R.reverse([]);         //=> []
	 *
	 *      R.reverse('abc');      //=> 'cba'
	 *      R.reverse('ab');       //=> 'ba'
	 *      R.reverse('a');        //=> 'a'
	 *      R.reverse('');         //=> ''
	 */
	
	
	var reverse = /*#__PURE__*/_curry1(function reverse(list) {
	  return _isString(list) ? list.split('').reverse().join('') : Array.prototype.slice.call(list, 0).reverse();
	});
	module.exports = reverse;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var AxiosError = __webpack_require__(67);
	var utils = __webpack_require__(17);
	
	/**
	 * A `CanceledError` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function CanceledError(message) {
	  // eslint-disable-next-line no-eq-null,eqeqeq
	  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
	  this.name = 'CanceledError';
	}
	
	utils.inherits(CanceledError, AxiosError, {
	  __CANCEL__: true
	});
	
	module.exports = CanceledError;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(30);
	var toLength = __webpack_require__(11);
	var toAbsoluteIndex = __webpack_require__(64);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(7);
	var $export = __webpack_require__(3);
	var redefine = __webpack_require__(23);
	var redefineAll = __webpack_require__(62);
	var meta = __webpack_require__(53);
	var forOf = __webpack_require__(57);
	var anInstance = __webpack_require__(56);
	var isObject = __webpack_require__(9);
	var fails = __webpack_require__(8);
	var $iterDetect = __webpack_require__(94);
	var setToStringTag = __webpack_require__(70);
	var inheritIfRequired = __webpack_require__(131);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(225);
	var redefine = __webpack_require__(23);
	var hide = __webpack_require__(22);
	var fails = __webpack_require__(8);
	var defined = __webpack_require__(44);
	var wks = __webpack_require__(10);
	var regexpExec = __webpack_require__(139);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(34);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(9);
	var cof = __webpack_require__(34);
	var MATCH = __webpack_require__(10)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(10)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(52) || !__webpack_require__(8)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(7)[K];
	});


/***/ }),
/* 96 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(68);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(3);
	var aFunction = __webpack_require__(19);
	var ctx = __webpack_require__(36);
	var forOf = __webpack_require__(57);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(3);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(38);
	var defined = __webpack_require__(44);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7);
	var hide = __webpack_require__(22);
	var uid = __webpack_require__(65);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.6.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2022-08-26T17:52Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket trac-14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.6.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.6
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2021-02-16
	 */
	( function( window ) {
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ( {} ).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		pushNative = arr.push,
		push = arr.push,
		slice = arr.slice,
	
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[ i ] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
			"ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5]
			// or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
			whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
			"*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			return nonHex ?
	
				// Strip the backslash prefix from a non-hex escape sequence
				nonHex :
	
				// Replace a hexadecimal escape sequence with the encoded Unicode code point
				// Support: IE <=11+
				// For values outside the Basic Multilingual Plane (BMP), manually construct a
				// surrogate pair
				high < 0 ?
					String.fromCharCode( high + 0x10000 ) :
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" +
					ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android<4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
	
				// Can't trust NodeList.length
				while ( ( target[ j++ ] = els[ i++ ] ) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&
	
					// Support: IE 8 only
					// Exclude object elements
					( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						if ( newContext !== context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = nid.replace( rcssescape, fcssescape );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split( "|" ),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[ i ] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( ( cur = cur.nextSibling ) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return ( name === "input" || name === "button" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
		// Safari 4 - 5 only, Opera <=11.6 - 12.x only
		// IE/Edge & older browsers don't support the :scope pseudo-class.
		// Support: Safari 6.0 only
		// Safari 6.0 supports :scope but it's an alias of :root there.
		support.scope = assert( function( el ) {
			docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
			return typeof el.querySelectorAll !== "undefined" &&
				!el.querySelectorAll( ":scope fieldset div" ).length;
		} );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert( function( el ) {
			el.className = "i";
			return !el.getAttribute( "className" );
		} );
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert( function( el ) {
			el.appendChild( document.createComment( "" ) );
			return !el.getElementsByTagName( "*" ).length;
		} );
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter[ "ID" ] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter[ "ID" ] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find[ "TAG" ] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
	
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( ( elem = results[ i++ ] ) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {
	
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert( function( el ) {
	
				var input;
	
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll( "[selected]" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push( "~=" );
				}
	
				// Support: IE 11+, Edge 15 - 18+
				// IE 11/Edge don't find elements on a `[name='']` query in some cases.
				// Adding a temporary attribute to the document before the selection works
				// around the issue.
				// Interestingly, IE 10 & older don't seem to have the issue.
				input = document.createElement( "input" );
				input.setAttribute( "name", "" );
				el.appendChild( input );
				if ( !el.querySelectorAll( "[name='']" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
						whitespace + "*(?:''|\"\")" );
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll( ":checked" ).length ) {
					rbuggyQSA.push( ":checked" );
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push( ".#.+[+~]" );
				}
	
				// Support: Firefox <=3.6 - 5 only
				// Old Firefox doesn't throw on a badly-escaped identifier.
				el.querySelectorAll( "\\\f" );
				rbuggyQSA.push( "[\\r\\n\\f]" );
			} );
	
			assert( function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement( "input" );
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll( "[name=d]" ).length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: Opera 10 - 11 only
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll( "*,:x" );
				rbuggyQSA.push( ",.*:" );
			} );
		}
	
		if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector ) ) ) ) {
	
			assert( function( el ) {
	
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			} );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				) );
			} :
			function( a, b ) {
				if ( b ) {
					while ( ( b = b.parentNode ) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a == document || a.ownerDocument == preferredDoc &&
					contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b == document || b.ownerDocument == preferredDoc &&
					contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
	
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				return a == document ? -1 :
					b == document ? 1 :
					/* eslint-enable eqeqeq */
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( ( cur = cur.parentNode ) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( ( cur = cur.parentNode ) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[ i ] === bp[ i ] ) {
				i++;
			}
	
			return i ?
	
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[ i ], bp[ i ] ) :
	
				// Otherwise nodes in our document sort first
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				ap[ i ] == preferredDoc ? -1 :
				bp[ i ] == preferredDoc ? 1 :
				/* eslint-enable eqeqeq */
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
	
			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {
	
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
	
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
	
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
	
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
					match[ 5 ] || "" ).replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						Sizzle.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
					// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace +
						")" + className + "(" + whitespace + "|$)" ) ) && classCache(
							className, function( elem ) {
								return pattern.test(
									typeof elem.className === "string" && elem.className ||
									typeof elem.getAttribute !== "undefined" &&
										elem.getAttribute( "class" ) ||
									""
								);
					} );
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					/* eslint-disable max-len */
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
					/* eslint-enable max-len */
	
				};
			},
	
			"CHILD": function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || ( node[ expando ] = {} );
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
	
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || ( node[ expando ] = {} );
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										( outerCache[ node.uniqueID ] = {} );
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													( outerCache[ node.uniqueID ] = {} );
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			"not": markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element (issue #299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			"has": markFunction( function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			} ),
	
			"contains": markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement &&
					( !document.hasFocus || document.hasFocus() ) &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return ( nodeName === "input" && !!elem.checked ) ||
					( nodeName === "option" && !!elem.selected );
			},
	
			"selected": function( elem ) {
	
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
	
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos[ "empty" ]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			"last": createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			"even": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"odd": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rcombinators.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrim, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
	
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] ||
								( outerCache[ elem.uniqueID ] = {} );
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = uniqueCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts(
					selector || "*",
					context.nodeType ? [ context ] : context,
					[]
				),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
	
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens
							.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache(
				selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers )
			);
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
					.replace( runescape, funescape ), context ) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
							context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert( function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute( "href" ) === "#";
	} ) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		} );
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert( function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	} ) ) {
		addHandle( "value", function( elem, _name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		} );
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert( function( el ) {
		return el.getAttribute( "disabled" ) == null;
	} ) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
					( val = elem.getAttributeNode( name ) ) && val.specified ?
						val.value :
						null;
			}
		} );
	}
	
	return Sizzle;
	
	} )( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
		// Strict HTML recognition (trac-11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See trac-6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (trac-9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see trac-8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (trac-14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (trac-11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (trac-14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (trac-13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (trac-12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (trac-13208)
					// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (trac-13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							// Support: Chrome 86+
							// In Chrome, if an element having a focusout handler is blurred by
							// clicking outside of it, it invokes the handler synchronously. If
							// that handler calls `.remove()` on the element, the data is cleared,
							// leaving `result` undefined. We need to guard against this.
							return result && result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (trac-504, trac-13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			// Suppress native focus or blur if we're currently inside
			// a leveraged native-event stack
			_default: function( event ) {
				return dataPriv.get( event.target, type );
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	
		rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (trac-8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
	
								// Unwrap a CDATA section containing script contents. This shouldn't be
								// needed as in XML documents they're already not visible when
								// inspecting element contents and in HTML documents they have no
								// meaning but we're preserving that logic for backwards compatibility.
								// This will be removed completely in 4.0. See gh-4904.
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var rcustomProp = /^--/;
	
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	var whitespace = "[\\x20\\t\\r\\n\\f]";
	
	
	var rtrimCSS = new RegExp(
		"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
		"g"
	);
	
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (trac-8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is display: block
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			isCustomProp = rcustomProp.test( name ),
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, trac-12537)
		//   .css('--customProperty) (gh-3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			// trim whitespace for custom property (issue gh-4926)
			if ( isCustomProp ) {
	
				// rtrim treats U+000D CARRIAGE RETURN and U+000C FORM FEED
				// as whitespace while CSS does not, but this is not a problem
				// because CSS preprocessing replaces them with U+000A LINE FEED
				// (which *is* CSS whitespace)
				// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
				ret = ret.replace( rtrimCSS, "$1" );
			}
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (trac-7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug trac-9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (trac-7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// Use proper attribute retrieval (trac-12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
							if ( cur.indexOf( " " + className + " " ) < 0 ) {
								cur += className + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
	
					// This expression is here for better compressibility (see addClass)
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
	
							// Remove *all* instances
							while ( cur.indexOf( " " + className + " " ) > -1 ) {
								cur = cur.replace( " " + className + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var classNames, className, i, self,
				type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			classNames = classesToArray( value );
	
			return this.each( function() {
				if ( isValidValue ) {
	
					// Toggle individual class names
					self = jQuery( this );
	
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (trac-14686, trac-14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (trac-2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (trac-9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (trac-6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
	
					// Handle: regular nodes (via `this.ownerDocument`), window
					// (via `this.document`) & document (via `this`).
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// trac-7653, trac-8125, trac-8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes trac-9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (trac-10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket trac-12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// trac-9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (trac-11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// trac-1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see trac-8605, trac-14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// trac-14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	// Require that the "whitespace run" starts from a non-whitespace
	// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
	var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "$1" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (trac-13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Adds two values.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Number}
	 * @see R.subtract
	 * @example
	 *
	 *      R.add(2, 3);       //=>  5
	 *      R.add(7)(10);      //=> 17
	 */
	
	
	var add = /*#__PURE__*/_curry2(function add(a, b) {
	  return Number(a) + Number(b);
	});
	module.exports = add;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Returns a function that always returns the given value. Note that for
	 * non-primitives the value returned is a reference to the original value.
	 *
	 * This function is known as `const`, `constant`, or `K` (for K combinator) in
	 * other languages and libraries.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> (* -> a)
	 * @param {*} val The value to wrap in a function
	 * @return {Function} A Function :: * -> val.
	 * @example
	 *
	 *      const t = R.always('Tee');
	 *      t(); //=> 'Tee'
	 */
	
	
	var always = /*#__PURE__*/_curry1(function always(val) {
	  return function () {
	    return val;
	  };
	});
	module.exports = always;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the specified
	 * property with the given value. Note that this copies and flattens prototype
	 * properties onto the new object as well. All non-primitive properties are
	 * copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig String -> a -> {k: v} -> {k: v}
	 * @param {String} prop The property name to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except for the changed property.
	 * @see R.dissoc, R.pick
	 * @example
	 *
	 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
	 */
	
	
	var assoc = /*#__PURE__*/_curry3(function assoc(prop, val, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  result[prop] = val;
	  return result;
	});
	module.exports = assoc;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var curryN = /*#__PURE__*/__webpack_require__(18);
	
	/**
	 * Returns a new function much like the supplied one, except that the first two
	 * arguments' order is reversed.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
	 * @param {Function} fn The function to invoke with its first two parameters reversed.
	 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
	 * @example
	 *
	 *      const mergeThree = (a, b, c) => [].concat(a, b, c);
	 *
	 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
	 * @symb R.flip(f)(a, b, c) = f(b, a, c)
	 */
	
	
	var flip = /*#__PURE__*/_curry1(function flip(fn) {
	  return curryN(fn.length, function (a, b) {
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = b;
	    args[1] = a;
	    return fn.apply(this, args);
	  });
	});
	module.exports = flip;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _identity = /*#__PURE__*/__webpack_require__(157);
	
	/**
	 * A function that does nothing but return the parameter supplied to it. Good
	 * as a default or placeholder function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x The value to return.
	 * @return {*} The input value, `x`.
	 * @example
	 *
	 *      R.identity(1); //=> 1
	 *
	 *      const obj = {};
	 *      R.identity(obj) === obj; //=> true
	 * @symb R.identity(a) = a
	 */
	
	
	var identity = /*#__PURE__*/_curry1(_identity);
	module.exports = identity;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(39);
	
	var _isPlaceholder = /*#__PURE__*/__webpack_require__(112);
	
	/**
	 * Internal curryN function.
	 *
	 * @private
	 * @category Function
	 * @param {Number} length The arity of the curried function.
	 * @param {Array} received An array of arguments received thus far.
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	
	
	function _curryN(length, received, fn) {
	  return function () {
	    var combined = [];
	    var argsIdx = 0;
	    var left = length;
	    var combinedIdx = 0;
	    while (combinedIdx < received.length || argsIdx < arguments.length) {
	      var result;
	      if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
	        result = received[combinedIdx];
	      } else {
	        result = arguments[argsIdx];
	        argsIdx += 1;
	      }
	      combined[combinedIdx] = result;
	      if (!_isPlaceholder(result)) {
	        left -= 1;
	      }
	      combinedIdx += 1;
	    }
	    return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length, combined, fn));
	  };
	}
	module.exports = _curryN;

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	function _includesWith(pred, x, list) {
	  var idx = 0;
	  var len = list.length;
	
	  while (idx < len) {
	    if (pred(x, list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	}
	module.exports = _includesWith;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _isArray = /*#__PURE__*/__webpack_require__(50);
	
	var _isString = /*#__PURE__*/__webpack_require__(82);
	
	/**
	 * Tests whether or not an object is similar to an array.
	 *
	 * @private
	 * @category Type
	 * @category List
	 * @sig * -> Boolean
	 * @param {*} x The object to test.
	 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
	 * @example
	 *
	 *      _isArrayLike([]); //=> true
	 *      _isArrayLike(true); //=> false
	 *      _isArrayLike({}); //=> false
	 *      _isArrayLike({length: 10}); //=> false
	 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
	 */
	
	
	var _isArrayLike = /*#__PURE__*/_curry1(function isArrayLike(x) {
	  if (_isArray(x)) {
	    return true;
	  }
	  if (!x) {
	    return false;
	  }
	  if (typeof x !== 'object') {
	    return false;
	  }
	  if (_isString(x)) {
	    return false;
	  }
	  if (x.nodeType === 1) {
	    return !!x.length;
	  }
	  if (x.length === 0) {
	    return true;
	  }
	  if (x.length > 0) {
	    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
	  }
	  return false;
	});
	module.exports = _isArrayLike;

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	function _isPlaceholder(a) {
	       return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
	}
	module.exports = _isPlaceholder;

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	function _map(fn, functor) {
	  var idx = 0;
	  var len = functor.length;
	  var result = Array(len);
	  while (idx < len) {
	    result[idx] = fn(functor[idx]);
	    idx += 1;
	  }
	  return result;
	}
	module.exports = _map;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var map = /*#__PURE__*/__webpack_require__(32);
	
	/**
	 * Returns a lens for the given getter and setter functions. The getter "gets"
	 * the value of the focus; the setter "sets" the value of the focus. The setter
	 * should not mutate the data structure.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
	 * @param {Function} getter
	 * @param {Function} setter
	 * @return {Lens}
	 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      const xLens = R.lens(R.prop('x'), R.assoc('x'));
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	
	
	var lens = /*#__PURE__*/_curry2(function lens(getter, setter) {
	  return function (toFunctorFn) {
	    return function (target) {
	      return map(function (focus) {
	        return setter(focus, target);
	      }, toFunctorFn(getter(target)));
	    };
	  };
	});
	module.exports = lens;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var liftN = /*#__PURE__*/__webpack_require__(405);
	
	/**
	 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
	 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.liftN
	 * @example
	 *
	 *      const madd3 = R.lift((a, b, c) => a + b + c);
	 *
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 *
	 *      const madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
	 *
	 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
	 */
	
	
	var lift = /*#__PURE__*/_curry1(function lift(fn) {
	  return liftN(fn.length, fn);
	});
	module.exports = lift;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var _isObject = /*#__PURE__*/__webpack_require__(159);
	
	var mergeWithKey = /*#__PURE__*/__webpack_require__(161);
	
	/**
	 * Creates a new object with the own properties of the two provided objects.
	 * If a key exists in both objects:
	 * - and both associated values are also objects then the values will be
	 *   recursively merged.
	 * - otherwise the provided function is applied to the key and associated values
	 *   using the resulting value as the new value associated with the key.
	 * If a key only exists in one object, the value will be associated with the key
	 * of the resulting object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Object
	 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} lObj
	 * @param {Object} rObj
	 * @return {Object}
	 * @see R.mergeWithKey, R.mergeDeepWith
	 * @example
	 *
	 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
	 *      R.mergeDeepWithKey(concatValues,
	 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
	 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
	 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
	 */
	
	
	var mergeDeepWithKey = /*#__PURE__*/_curry3(function mergeDeepWithKey(fn, lObj, rObj) {
	  return mergeWithKey(function (k, lVal, rVal) {
	    if (_isObject(lVal) && _isObject(rVal)) {
	      return mergeDeepWithKey(fn, lVal, rVal);
	    } else {
	      return fn(k, lVal, rVal);
	    }
	  }, lObj, rObj);
	});
	module.exports = mergeDeepWithKey;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly `n` parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} n The desired arity of the new function.
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity `n`.
	 * @see R.binary, R.unary
	 * @example
	 *
	 *      const takesTwoArgs = (a, b) => [a, b];
	 *
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      const takesOneArg = R.nAry(1, takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only `n` arguments are passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 * @symb R.nAry(0, f)(a, b) = f()
	 * @symb R.nAry(1, f)(a, b) = f(a)
	 * @symb R.nAry(2, f)(a, b) = f(a, b)
	 */
	
	
	var nAry = /*#__PURE__*/_curry2(function nAry(n, fn) {
	  switch (n) {
	    case 0:
	      return function () {
	        return fn.call(this);
	      };
	    case 1:
	      return function (a0) {
	        return fn.call(this, a0);
	      };
	    case 2:
	      return function (a0, a1) {
	        return fn.call(this, a0, a1);
	      };
	    case 3:
	      return function (a0, a1, a2) {
	        return fn.call(this, a0, a1, a2);
	      };
	    case 4:
	      return function (a0, a1, a2, a3) {
	        return fn.call(this, a0, a1, a2, a3);
	      };
	    case 5:
	      return function (a0, a1, a2, a3, a4) {
	        return fn.call(this, a0, a1, a2, a3, a4);
	      };
	    case 6:
	      return function (a0, a1, a2, a3, a4, a5) {
	        return fn.call(this, a0, a1, a2, a3, a4, a5);
	      };
	    case 7:
	      return function (a0, a1, a2, a3, a4, a5, a6) {
	        return fn.call(this, a0, a1, a2, a3, a4, a5, a6);
	      };
	    case 8:
	      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
	        return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);
	      };
	    case 9:
	      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
	        return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);
	      };
	    case 10:
	      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
	        return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
	      };
	    default:
	      throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
	  }
	});
	module.exports = nAry;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	var _curryN = /*#__PURE__*/__webpack_require__(109);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _has = /*#__PURE__*/__webpack_require__(25);
	
	var _reduce = /*#__PURE__*/__webpack_require__(26);
	
	var _xreduceBy = /*#__PURE__*/__webpack_require__(1085);
	
	/**
	 * Groups the elements of the list according to the result of calling
	 * the String-returning function `keyFn` on each element and reduces the elements
	 * of each group to a single value via the reducer function `valueFn`.
	 *
	 * This function is basically a more general [`groupBy`](#groupBy) function.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
	 * @param {Function} valueFn The function that reduces the elements of each group to a single
	 *        value. Receives two values, accumulator for a particular group and the current element.
	 * @param {*} acc The (initial) accumulator value for each group.
	 * @param {Function} keyFn The function that maps the list's element into a key.
	 * @param {Array} list The array to group.
	 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
	 *         `valueFn` for elements which produced that key when passed to `keyFn`.
	 * @see R.groupBy, R.reduce
	 * @example
	 *
	 *      const groupNames = (acc, {name}) => acc.concat(name)
	 *      const toGrade = ({score}) =>
	 *        score < 65 ? 'F' :
	 *        score < 70 ? 'D' :
	 *        score < 80 ? 'C' :
	 *        score < 90 ? 'B' : 'A'
	 *
	 *      var students = [
	 *        {name: 'Abby', score: 83},
	 *        {name: 'Bart', score: 62},
	 *        {name: 'Curt', score: 88},
	 *        {name: 'Dora', score: 92},
	 *      ]
	 *
	 *      reduceBy(groupNames, [], toGrade, students)
	 *      //=> {"A": ["Dora"], "B": ["Abby", "Curt"], "F": ["Bart"]}
	 */
	
	
	var reduceBy = /*#__PURE__*/_curryN(4, [], /*#__PURE__*/_dispatchable([], _xreduceBy, function reduceBy(valueFn, valueAcc, keyFn, list) {
	  return _reduce(function (acc, elt) {
	    var key = keyFn(elt);
	    acc[key] = valueFn(_has(key, acc) ? acc[key] : valueAcc, elt);
	    return acc;
	  }, {}, list);
	}));
	module.exports = reduceBy;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var _complement = /*#__PURE__*/__webpack_require__(390);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var filter = /*#__PURE__*/__webpack_require__(155);
	
	/**
	 * The complement of [`filter`](#filter).
	 *
	 * Acts as a transducer if a transformer is given in list position. Filterable
	 * objects include plain objects or any object that has a filter method such
	 * as `Array`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.filter, R.transduce, R.addIndex
	 * @example
	 *
	 *      const isOdd = (n) => n % 2 === 1;
	 *
	 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	
	
	var reject = /*#__PURE__*/_curry2(function reject(pred, filterable) {
	  return filter(_complement(pred), filterable);
	});
	module.exports = reject;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = /*#__PURE__*/__webpack_require__(80);
	
	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var slice = /*#__PURE__*/__webpack_require__(42);
	
	/**
	 * Returns all but the first element of the given list or string (or object
	 * with a `tail` method).
	 *
	 * Dispatches to the `slice` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.head, R.init, R.last
	 * @example
	 *
	 *      R.tail([1, 2, 3]);  //=> [2, 3]
	 *      R.tail([1, 2]);     //=> [2]
	 *      R.tail([1]);        //=> []
	 *      R.tail([]);         //=> []
	 *
	 *      R.tail('abc');  //=> 'bc'
	 *      R.tail('ab');   //=> 'b'
	 *      R.tail('a');    //=> ''
	 *      R.tail('');     //=> ''
	 */
	
	
	var tail = /*#__PURE__*/_curry1( /*#__PURE__*/_checkForMethod('tail', /*#__PURE__*/slice(1, Infinity)));
	module.exports = tail;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _toString = /*#__PURE__*/__webpack_require__(397);
	
	/**
	 * Returns the string representation of the given value. `eval`'ing the output
	 * should result in a value equivalent to the input value. Many of the built-in
	 * `toString` methods do not satisfy this requirement.
	 *
	 * If the given value is an `[object Object]` with a `toString` method other
	 * than `Object.prototype.toString`, this method is invoked with no arguments
	 * to produce the return value. This means user-defined constructor functions
	 * can provide a suitable `toString` method. For example:
	 *
	 *     function Point(x, y) {
	 *       this.x = x;
	 *       this.y = y;
	 *     }
	 *
	 *     Point.prototype.toString = function() {
	 *       return 'new Point(' + this.x + ', ' + this.y + ')';
	 *     };
	 *
	 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category String
	 * @sig * -> String
	 * @param {*} val
	 * @return {String}
	 * @example
	 *
	 *      R.toString(42); //=> '42'
	 *      R.toString('abc'); //=> '"abc"'
	 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
	 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
	 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
	 */
	
	
	var toString = /*#__PURE__*/_curry1(function toString(val) {
	  return _toString(val, []);
	});
	module.exports = toString;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(17);
	var normalizeHeaderName = __webpack_require__(516);
	var AxiosError = __webpack_require__(67);
	var transitionalDefaults = __webpack_require__(174);
	var toFormData = __webpack_require__(178);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(170);
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(170);
	  }
	  return adapter;
	}
	
	function stringifySafely(rawValue, parser, encoder) {
	  if (utils.isString(rawValue)) {
	    try {
	      (parser || JSON.parse)(rawValue);
	      return utils.trim(rawValue);
	    } catch (e) {
	      if (e.name !== 'SyntaxError') {
	        throw e;
	      }
	    }
	  }
	
	  return (encoder || JSON.stringify)(rawValue);
	}
	
	var defaults = {
	
	  transitional: transitionalDefaults,
	
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');
	
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	
	    var isObjectPayload = utils.isObject(data);
	    var contentType = headers && headers['Content-Type'];
	
	    var isFileList;
	
	    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
	      var _FormData = this.env && this.env.FormData;
	      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
	    } else if (isObjectPayload || contentType === 'application/json') {
	      setContentTypeIfUnset(headers, 'application/json');
	      return stringifySafely(data);
	    }
	
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    var transitional = this.transitional || defaults.transitional;
	    var silentJSONParsing = transitional && transitional.silentJSONParsing;
	    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
	    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
	
	    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
	      try {
	        return JSON.parse(data);
	      } catch (e) {
	        if (strictJSONParsing) {
	          if (e.name === 'SyntaxError') {
	            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
	          }
	          throw e;
	        }
	      }
	    }
	
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	  maxBodyLength: -1,
	
	  env: {
	    FormData: __webpack_require__(517)
	  },
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  },
	
	  headers: {
	    common: {
	      'Accept': 'application/json, text/plain, */*'
	    }
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(366)))

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(100)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(14);
	var toAbsoluteIndex = __webpack_require__(64);
	var toLength = __webpack_require__(11);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(775);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(13);
	var createDesc = __webpack_require__(61);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(9);
	var document = __webpack_require__(7).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 128 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(10)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(7).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(9);
	var setPrototypeOf = __webpack_require__(140).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(69);
	var ITERATOR = __webpack_require__(10)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(58);
	var descriptor = __webpack_require__(61);
	var setToStringTag = __webpack_require__(70);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(22)(IteratorPrototype, __webpack_require__(10)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(52);
	var $export = __webpack_require__(3);
	var redefine = __webpack_require__(23);
	var hide = __webpack_require__(22);
	var Iterators = __webpack_require__(69);
	var $iterCreate = __webpack_require__(133);
	var setToStringTag = __webpack_require__(70);
	var getPrototypeOf = __webpack_require__(29);
	var ITERATOR = __webpack_require__(10)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 135 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 136 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7);
	var macrotask = __webpack_require__(145).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(34)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(19);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(75);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(9);
	var anObject = __webpack_require__(6);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(36)(Function.call, __webpack_require__(28).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(78)('keys');
	var uid = __webpack_require__(65);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(93);
	var defined = __webpack_require__(44);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(38);
	var defined = __webpack_require__(44);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 144 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(36);
	var invoke = __webpack_require__(203);
	var html = __webpack_require__(130);
	var cel = __webpack_require__(127);
	var global = __webpack_require__(7);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(34)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(7);
	var DESCRIPTORS = __webpack_require__(12);
	var LIBRARY = __webpack_require__(52);
	var $typed = __webpack_require__(101);
	var hide = __webpack_require__(22);
	var redefineAll = __webpack_require__(62);
	var fails = __webpack_require__(8);
	var anInstance = __webpack_require__(56);
	var toInteger = __webpack_require__(38);
	var toLength = __webpack_require__(11);
	var toIndex = __webpack_require__(222);
	var gOPN = __webpack_require__(59).f;
	var dP = __webpack_require__(13).f;
	var arrayFill = __webpack_require__(124);
	var setToStringTag = __webpack_require__(70);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7);
	var core = __webpack_require__(35);
	var LIBRARY = __webpack_require__(52);
	var wksExt = __webpack_require__(223);
	var defineProperty = __webpack_require__(13).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(68);
	var ITERATOR = __webpack_require__(10)('iterator');
	var Iterators = __webpack_require__(69);
	module.exports = __webpack_require__(35).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(51);
	var step = __webpack_require__(206);
	var Iterators = __webpack_require__(69);
	var toIObject = __webpack_require__(30);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(134)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(40);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _reduce = /*#__PURE__*/__webpack_require__(26);
	
	var map = /*#__PURE__*/__webpack_require__(32);
	
	/**
	 * ap applies a list of functions to a list of values.
	 *
	 * Dispatches to the `ap` method of the second argument, if present. Also
	 * treats curried functions as applicatives.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig [a -> b] -> [a] -> [b]
	 * @sig Apply f => f (a -> b) -> f a -> f b
	 * @sig (r -> a -> b) -> (r -> a) -> (r -> b)
	 * @param {*} applyF
	 * @param {*} applyX
	 * @return {*}
	 * @example
	 *
	 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
	 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
	 *
	 *      // R.ap can also be used as S combinator
	 *      // when only two functions are passed
	 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
	 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
	 */
	
	
	var ap = /*#__PURE__*/_curry2(function ap(applyF, applyX) {
	  return typeof applyX['fantasy-land/ap'] === 'function' ? applyX['fantasy-land/ap'](applyF) : typeof applyF.ap === 'function' ? applyF.ap(applyX) : typeof applyF === 'function' ? function (x) {
	    return applyF(x)(applyX(x));
	  } : _reduce(function (acc, f) {
	    return _concat(acc, map(f, applyX));
	  }, [], applyF);
	});
	module.exports = ap;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _makeFlat = /*#__PURE__*/__webpack_require__(395);
	
	var _xchain = /*#__PURE__*/__webpack_require__(1074);
	
	var map = /*#__PURE__*/__webpack_require__(32);
	
	/**
	 * `chain` maps a function over a list and concatenates the results. `chain`
	 * is also known as `flatMap` in some libraries.
	 *
	 * Dispatches to the `chain` method of the second argument, if present,
	 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
	 *
	 * If second argument is a function, `chain(f, g)(x)` is equivalent to `f(g(x), x)`.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig Chain m => (a -> m b) -> m a -> m b
	 * @param {Function} fn The function to map with
	 * @param {Array} list The list to map over
	 * @return {Array} The result of flat-mapping `list` with `fn`
	 * @example
	 *
	 *      const duplicate = n => [n, n];
	 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
	 *
	 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
	 */
	
	
	var chain = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['fantasy-land/chain', 'chain'], _xchain, function chain(fn, monad) {
	  if (typeof monad === 'function') {
	    return function (x) {
	      return fn(monad(x))(x);
	    };
	  }
	  return _makeFlat(false)(map(fn, monad));
	}));
	module.exports = chain;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var pipe = /*#__PURE__*/__webpack_require__(414);
	
	var reverse = /*#__PURE__*/__webpack_require__(87);
	
	/**
	 * Performs right-to-left function composition. The rightmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * **Note:** The result of compose is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipe
	 * @example
	 *
	 *      const classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
	 *      const yellGreeting = R.compose(R.toUpper, classyGreeting);
	 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
	 *
	 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
	 *
	 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
	 */
	
	
	function compose() {
	  if (arguments.length === 0) {
	    throw new Error('compose requires at least one argument');
	  }
	  return pipe.apply(this, reverse(arguments));
	}
	module.exports = compose;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _isArray = /*#__PURE__*/__webpack_require__(50);
	
	var _isFunction = /*#__PURE__*/__webpack_require__(81);
	
	var _isString = /*#__PURE__*/__webpack_require__(82);
	
	var toString = /*#__PURE__*/__webpack_require__(121);
	
	/**
	 * Returns the result of concatenating the given lists or strings.
	 *
	 * Note: `R.concat` expects both arguments to be of the same type,
	 * unlike the native `Array.prototype.concat` method. It will throw
	 * an error if you `concat` an Array with a non-Array value.
	 *
	 * Dispatches to the `concat` method of the first argument, if present.
	 * Can also concatenate two members of a [fantasy-land
	 * compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @sig String -> String -> String
	 * @param {Array|String} firstList The first list
	 * @param {Array|String} secondList The second list
	 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
	 * `secondList`.
	 *
	 * @example
	 *
	 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
	 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 *      R.concat([], []); //=> []
	 */
	
	
	var concat = /*#__PURE__*/_curry2(function concat(a, b) {
	  if (_isArray(a)) {
	    if (_isArray(b)) {
	      return a.concat(b);
	    }
	    throw new TypeError(toString(b) + ' is not an array');
	  }
	  if (_isString(a)) {
	    if (_isString(b)) {
	      return a + b;
	    }
	    throw new TypeError(toString(b) + ' is not a string');
	  }
	  if (a != null && _isFunction(a['fantasy-land/concat'])) {
	    return a['fantasy-land/concat'](b);
	  }
	  if (a != null && _isFunction(a.concat)) {
	    return a.concat(b);
	  }
	  throw new TypeError(toString(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
	});
	module.exports = concat;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var curryN = /*#__PURE__*/__webpack_require__(18);
	
	/**
	 * Returns a curried equivalent of the provided function. The curried function
	 * has two unusual capabilities. First, its arguments needn't be provided one
	 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
	 * the following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> a) -> (* -> a)
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curryN, R.partial
	 * @example
	 *
	 *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
	 *
	 *      const curriedAddFourNumbers = R.curry(addFourNumbers);
	 *      const f = curriedAddFourNumbers(1, 2);
	 *      const g = f(3);
	 *      g(4); //=> 10
	 */
	
	
	var curry = /*#__PURE__*/_curry1(function curry(fn) {
	  return curryN(fn.length, fn);
	});
	module.exports = curry;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _filter = /*#__PURE__*/__webpack_require__(156);
	
	var _isObject = /*#__PURE__*/__webpack_require__(159);
	
	var _reduce = /*#__PURE__*/__webpack_require__(26);
	
	var _xfilter = /*#__PURE__*/__webpack_require__(1079);
	
	var keys = /*#__PURE__*/__webpack_require__(41);
	
	/**
	 * Takes a predicate and a `Filterable`, and returns a new filterable of the
	 * same type containing the members of the given filterable which satisfy the
	 * given predicate. Filterable objects include plain objects or any object
	 * that has a filter method such as `Array`.
	 *
	 * Dispatches to the `filter` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array} Filterable
	 * @see R.reject, R.transduce, R.addIndex
	 * @example
	 *
	 *      const isEven = n => n % 2 === 0;
	 *
	 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	
	
	var filter = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['filter'], _xfilter, function (pred, filterable) {
	  return _isObject(filterable) ? _reduce(function (acc, key) {
	    if (pred(filterable[key])) {
	      acc[key] = filterable[key];
	    }
	    return acc;
	  }, {}, keys(filterable)) :
	  // else
	  _filter(pred, filterable);
	}));
	module.exports = filter;

/***/ }),
/* 156 */
/***/ (function(module, exports) {

	function _filter(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	
	  while (idx < len) {
	    if (fn(list[idx])) {
	      result[result.length] = list[idx];
	    }
	    idx += 1;
	  }
	  return result;
	}
	module.exports = _filter;

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	function _identity(x) {
	  return x;
	}
	module.exports = _identity;

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	/**
	 * Determine if the passed argument is an integer.
	 *
	 * @private
	 * @param {*} n
	 * @category Type
	 * @return {Boolean}
	 */
	module.exports = Number.isInteger || function _isInteger(n) {
	  return n << 0 === n;
	};

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	function _isObject(x) {
	  return Object.prototype.toString.call(x) === '[object Object]';
	}
	module.exports = _isObject;

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	function _isTransformer(obj) {
	  return obj != null && typeof obj['@@transducer/step'] === 'function';
	}
	module.exports = _isTransformer;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var _has = /*#__PURE__*/__webpack_require__(25);
	
	/**
	 * Creates a new object with the own properties of the two provided objects. If
	 * a key exists in both objects, the provided function is applied to the key
	 * and the values associated with the key in each object, with the result being
	 * used as the value associated with the key in the returned object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
	 * @example
	 *
	 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
	 *      R.mergeWithKey(concatValues,
	 *                     { a: true, thing: 'foo', values: [10, 20] },
	 *                     { b: true, thing: 'bar', values: [15, 35] });
	 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
	 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
	 */
	
	
	var mergeWithKey = /*#__PURE__*/_curry3(function mergeWithKey(fn, l, r) {
	  var result = {};
	  var k;
	
	  for (k in l) {
	    if (_has(k, l)) {
	      result[k] = _has(k, r) ? fn(k, l[k], r[k]) : l[k];
	    }
	  }
	
	  for (k in r) {
	    if (_has(k, r) && !_has(k, result)) {
	      result[k] = r[k];
	    }
	  }
	
	  return result;
	});
	module.exports = mergeWithKey;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var path = /*#__PURE__*/__webpack_require__(74);
	
	/**
	 * Returns a function that when supplied an object returns the indicated
	 * property of that object, if it exists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig s -> {s: a} -> a | Undefined
	 * @param {String} p The property name
	 * @param {Object} obj The object to query
	 * @return {*} The value at `obj.p`.
	 * @see R.path
	 * @example
	 *
	 *      R.prop('x', {x: 100}); //=> 100
	 *      R.prop('x', {}); //=> undefined
	 *      R.compose(R.inc, R.prop('x'))({ x: 3 }) //=> 4
	 */
	
	var prop = /*#__PURE__*/_curry2(function prop(p, obj) {
	  return path([p], obj);
	});
	module.exports = prop;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _xtake = /*#__PURE__*/__webpack_require__(1086);
	
	var slice = /*#__PURE__*/__webpack_require__(42);
	
	/**
	 * Returns the first `n` elements of the given list, string, or
	 * transducer/transformer (or object with a `take` method).
	 *
	 * Dispatches to the `take` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n
	 * @param {*} list
	 * @return {*}
	 * @see R.drop
	 * @example
	 *
	 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
	 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.take(3, 'ramda');               //=> 'ram'
	 *
	 *      const personnel = [
	 *        'Dave Brubeck',
	 *        'Paul Desmond',
	 *        'Eugene Wright',
	 *        'Joe Morello',
	 *        'Gerry Mulligan',
	 *        'Bob Bates',
	 *        'Joe Dodge',
	 *        'Ron Crotty'
	 *      ];
	 *
	 *      const takeFive = R.take(5);
	 *      takeFive(personnel);
	 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
	 * @symb R.take(-1, [a, b]) = [a, b]
	 * @symb R.take(0, [a, b]) = []
	 * @symb R.take(1, [a, b]) = [a]
	 * @symb R.take(2, [a, b]) = [a, b]
	 */
	
	
	var take = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['take'], _xtake, function take(n, xs) {
	  return slice(0, n < 0 ? Infinity : n, xs);
	}));
	module.exports = take;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Gives a single-word string description of the (native) type of a value,
	 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
	 * attempt to distinguish user Object types any further, reporting them all as
	 * 'Object'.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Type
	 * @sig (* -> {*}) -> String
	 * @param {*} val The value to test
	 * @return {String}
	 * @example
	 *
	 *      R.type({}); //=> "Object"
	 *      R.type(1); //=> "Number"
	 *      R.type(false); //=> "Boolean"
	 *      R.type('s'); //=> "String"
	 *      R.type(null); //=> "Null"
	 *      R.type([]); //=> "Array"
	 *      R.type(/[A-z]/); //=> "RegExp"
	 *      R.type(() => {}); //=> "Function"
	 *      R.type(undefined); //=> "Undefined"
	 */
	
	
	var type = /*#__PURE__*/_curry1(function type(val) {
	  return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
	});
	module.exports = type;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = /*#__PURE__*/__webpack_require__(108);
	
	var uniqBy = /*#__PURE__*/__webpack_require__(424);
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list. [`R.equals`](#equals) is used to determine equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
	 *      R.uniq([1, '1']);     //=> [1, '1']
	 *      R.uniq([[42], [42]]); //=> [[42]]
	 */
	
	
	var uniq = /*#__PURE__*/uniqBy(identity);
	module.exports = uniq;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var adjust = /*#__PURE__*/__webpack_require__(368);
	
	var always = /*#__PURE__*/__webpack_require__(105);
	
	/**
	 * Returns a new copy of the array with the element at the provided index
	 * replaced with the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} idx The index to update.
	 * @param {*} x The value to exist at the given index of the returned array.
	 * @param {Array|Arguments} list The source array-like object to be updated.
	 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
	 * @see R.adjust
	 * @example
	 *
	 *      R.update(1, '_', ['a', 'b', 'c']);      //=> ['a', '_', 'c']
	 *      R.update(-1, '_', ['a', 'b', 'c']);     //=> ['a', 'b', '_']
	 * @symb R.update(-1, a, [b, c]) = [b, a]
	 * @symb R.update(0, a, [b, c]) = [a, c]
	 * @symb R.update(1, a, [b, c]) = [b, a]
	 */
	
	
	var update = /*#__PURE__*/_curry3(function update(idx, x, list) {
	  return adjust(idx, always(x), list);
	});
	module.exports = update;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Rangy, a cross-browser JavaScript range and selection library
	 * https://github.com/timdown/rangy
	 *
	 * Copyright 2022, Tim Down
	 * Licensed under the MIT license.
	 * Version: 1.3.1
	 * Build date: 17 August 2022
	 */
	
	(function(factory, root) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module != "undefined" && typeof exports == "object") {
	        // Node/CommonJS style
	        module.exports = factory();
	    } else {
	        // No AMD or CommonJS support so we place Rangy in (probably) the global variable
	        root.rangy = factory();
	    }
	})(function() {
	
	    var OBJECT = "object", FUNCTION = "function", UNDEFINED = "undefined";
	
	    // Minimal set of properties required for DOM Level 2 Range compliance. Comparison constants such as START_TO_START
	    // are omitted because ranges in KHTML do not have them but otherwise work perfectly well. See issue 113.
	    var domRangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
	        "commonAncestorContainer"];
	
	    // Minimal set of methods required for DOM Level 2 Range compliance
	    var domRangeMethods = ["setStart", "setStartBefore", "setStartAfter", "setEnd", "setEndBefore",
	        "setEndAfter", "collapse", "selectNode", "selectNodeContents", "compareBoundaryPoints", "deleteContents",
	        "extractContents", "cloneContents", "insertNode", "surroundContents", "cloneRange", "toString", "detach"];
	
	    var textRangeProperties = ["boundingHeight", "boundingLeft", "boundingTop", "boundingWidth", "htmlText", "text"];
	
	    // Subset of TextRange's full set of methods that we're interested in
	    var textRangeMethods = ["collapse", "compareEndPoints", "duplicate", "moveToElementText", "parentElement", "select",
	        "setEndPoint", "getBoundingClientRect"];
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Trio of functions taken from Peter Michaux's article:
	    // http://peter.michaux.ca/articles/feature-detection-state-of-the-art-browser-scripting
	    function isHostMethod(o, p) {
	        var t = typeof o[p];
	        return t == FUNCTION || (!!(t == OBJECT && o[p])) || t == "unknown";
	    }
	
	    function isHostObject(o, p) {
	        return !!(typeof o[p] == OBJECT && o[p]);
	    }
	
	    function isHostProperty(o, p) {
	        return typeof o[p] != UNDEFINED;
	    }
	
	    // Creates a convenience function to save verbose repeated calls to tests functions
	    function createMultiplePropertyTest(testFunc) {
	        return function(o, props) {
	            var i = props.length;
	            while (i--) {
	                if (!testFunc(o, props[i])) {
	                    return false;
	                }
	            }
	            return true;
	        };
	    }
	
	    // Next trio of functions are a convenience to save verbose repeated calls to previous two functions
	    var areHostMethods = createMultiplePropertyTest(isHostMethod);
	    var areHostObjects = createMultiplePropertyTest(isHostObject);
	    var areHostProperties = createMultiplePropertyTest(isHostProperty);
	
	    function isTextRange(range) {
	        return range && areHostMethods(range, textRangeMethods) && areHostProperties(range, textRangeProperties);
	    }
	
	    function getBody(doc) {
	        return isHostObject(doc, "body") ? doc.body : doc.getElementsByTagName("body")[0];
	    }
	
	    var forEach = [].forEach ?
	        function(arr, func) {
	            arr.forEach(func);
	        } :
	        function(arr, func) {
	            for (var i = 0, len = arr.length; i < len; ++i) {
	                func(arr[i], i);
	            }
	        };
	
	    var modules = {};
	
	    var isBrowser = (typeof window != UNDEFINED && typeof document != UNDEFINED);
	
	    var util = {
	        isHostMethod: isHostMethod,
	        isHostObject: isHostObject,
	        isHostProperty: isHostProperty,
	        areHostMethods: areHostMethods,
	        areHostObjects: areHostObjects,
	        areHostProperties: areHostProperties,
	        isTextRange: isTextRange,
	        getBody: getBody,
	        forEach: forEach
	    };
	
	    var api = {
	        version: "1.3.1",
	        initialized: false,
	        isBrowser: isBrowser,
	        supported: true,
	        util: util,
	        features: {},
	        modules: modules,
	        config: {
	            alertOnFail: false,
	            alertOnWarn: false,
	            preferTextRange: false,
	            autoInitialize: (typeof rangyAutoInitialize == UNDEFINED) ? true : rangyAutoInitialize
	        }
	    };
	
	    function consoleLog(msg) {
	        if (typeof console != UNDEFINED && isHostMethod(console, "log")) {
	            console.log(msg);
	        }
	    }
	
	    function alertOrLog(msg, shouldAlert) {
	        if (isBrowser && shouldAlert) {
	            alert(msg);
	        } else  {
	            consoleLog(msg);
	        }
	    }
	
	    function fail(reason) {
	        api.initialized = true;
	        api.supported = false;
	        alertOrLog("Rangy is not supported in this environment. Reason: " + reason, api.config.alertOnFail);
	    }
	
	    api.fail = fail;
	
	    function warn(msg) {
	        alertOrLog("Rangy warning: " + msg, api.config.alertOnWarn);
	    }
	
	    api.warn = warn;
	
	    // Add utility extend() method
	    var extend;
	    if ({}.hasOwnProperty) {
	        util.extend = extend = function(obj, props, deep) {
	            var o, p;
	            for (var i in props) {
	                if (props.hasOwnProperty(i)) {
	                    o = obj[i];
	                    p = props[i];
	                    if (deep && o !== null && typeof o == "object" && p !== null && typeof p == "object") {
	                        extend(o, p, true);
	                    }
	                    obj[i] = p;
	                }
	            }
	            // Special case for toString, which does not show up in for...in loops in IE <= 8
	            if (props.hasOwnProperty("toString")) {
	                obj.toString = props.toString;
	            }
	            return obj;
	        };
	
	        util.createOptions = function(optionsParam, defaults) {
	            var options = {};
	            extend(options, defaults);
	            if (optionsParam) {
	                extend(options, optionsParam);
	            }
	            return options;
	        };
	    } else {
	        fail("hasOwnProperty not supported");
	    }
	
	    // Test whether we're in a browser and bail out if not
	    if (!isBrowser) {
	        fail("Rangy can only run in a browser");
	    }
	
	    // Test whether Array.prototype.slice can be relied on for NodeLists and use an alternative toArray() if not
	    (function() {
	        var toArray;
	
	        if (isBrowser) {
	            var el = document.createElement("div");
	            el.appendChild(document.createElement("span"));
	            var slice = [].slice;
	            try {
	                if (slice.call(el.childNodes, 0)[0].nodeType == 1) {
	                    toArray = function(arrayLike) {
	                        return slice.call(arrayLike, 0);
	                    };
	                }
	            } catch (e) {}
	        }
	
	        if (!toArray) {
	            toArray = function(arrayLike) {
	                var arr = [];
	                for (var i = 0, len = arrayLike.length; i < len; ++i) {
	                    arr[i] = arrayLike[i];
	                }
	                return arr;
	            };
	        }
	
	        util.toArray = toArray;
	    })();
	
	    // Very simple event handler wrapper function that doesn't attempt to solve issues such as "this" handling or
	    // normalization of event properties because we don't need this.
	    var addListener;
	    if (isBrowser) {
	        if (isHostMethod(document, "addEventListener")) {
	            addListener = function(obj, eventType, listener) {
	                obj.addEventListener(eventType, listener, false);
	            };
	        } else if (isHostMethod(document, "attachEvent")) {
	            addListener = function(obj, eventType, listener) {
	                obj.attachEvent("on" + eventType, listener);
	            };
	        } else {
	            fail("Document does not have required addEventListener or attachEvent method");
	        }
	
	        util.addListener = addListener;
	    }
	
	    var initListeners = [];
	
	    function getErrorDesc(ex) {
	        return ex.message || ex.description || String(ex);
	    }
	
	    // Initialization
	    function init() {
	        if (!isBrowser || api.initialized) {
	            return;
	        }
	        var testRange;
	        var implementsDomRange = false, implementsTextRange = false;
	
	        // First, perform basic feature tests
	
	        if (isHostMethod(document, "createRange")) {
	            testRange = document.createRange();
	            if (areHostMethods(testRange, domRangeMethods) && areHostProperties(testRange, domRangeProperties)) {
	                implementsDomRange = true;
	            }
	        }
	
	        var body = getBody(document);
	        if (!body || body.nodeName.toLowerCase() != "body") {
	            fail("No body element found");
	            return;
	        }
	
	        if (body && isHostMethod(body, "createTextRange")) {
	            testRange = body.createTextRange();
	            if (isTextRange(testRange)) {
	                implementsTextRange = true;
	            }
	        }
	
	        if (!implementsDomRange && !implementsTextRange) {
	            fail("Neither Range nor TextRange are available");
	            return;
	        }
	
	        api.initialized = true;
	        api.features = {
	            implementsDomRange: implementsDomRange,
	            implementsTextRange: implementsTextRange
	        };
	
	        // Initialize modules
	        var module, errorMessage;
	        for (var moduleName in modules) {
	            if ( (module = modules[moduleName]) instanceof Module ) {
	                module.init(module, api);
	            }
	        }
	
	        // Call init listeners
	        for (var i = 0, len = initListeners.length; i < len; ++i) {
	            try {
	                initListeners[i](api);
	            } catch (ex) {
	                errorMessage = "Rangy init listener threw an exception. Continuing. Detail: " + getErrorDesc(ex);
	                consoleLog(errorMessage);
	            }
	        }
	    }
	
	    function deprecationNotice(deprecated, replacement, module) {
	        if (module) {
	            deprecated += " in module " + module.name;
	        }
	        api.warn("DEPRECATED: " + deprecated + " is deprecated. Please use " +
	        replacement + " instead.");
	    }
	
	    function createAliasForDeprecatedMethod(owner, deprecated, replacement, module) {
	        owner[deprecated] = function() {
	            deprecationNotice(deprecated, replacement, module);
	            return owner[replacement].apply(owner, util.toArray(arguments));
	        };
	    }
	
	    util.deprecationNotice = deprecationNotice;
	    util.createAliasForDeprecatedMethod = createAliasForDeprecatedMethod;
	
	    // Allow external scripts to initialize this library in case it's loaded after the document has loaded
	    api.init = init;
	
	    // Execute listener immediately if already initialized
	    api.addInitListener = function(listener) {
	        if (api.initialized) {
	            listener(api);
	        } else {
	            initListeners.push(listener);
	        }
	    };
	
	    var shimListeners = [];
	
	    api.addShimListener = function(listener) {
	        shimListeners.push(listener);
	    };
	
	    function shim(win) {
	        win = win || window;
	        init();
	
	        // Notify listeners
	        for (var i = 0, len = shimListeners.length; i < len; ++i) {
	            shimListeners[i](win);
	        }
	    }
	
	    if (isBrowser) {
	        api.shim = api.createMissingNativeApi = shim;
	        createAliasForDeprecatedMethod(api, "createMissingNativeApi", "shim");
	    }
	
	    function Module(name, dependencies, initializer) {
	        this.name = name;
	        this.dependencies = dependencies;
	        this.initialized = false;
	        this.supported = false;
	        this.initializer = initializer;
	    }
	
	    Module.prototype = {
	        init: function() {
	            var requiredModuleNames = this.dependencies || [];
	            for (var i = 0, len = requiredModuleNames.length, requiredModule, moduleName; i < len; ++i) {
	                moduleName = requiredModuleNames[i];
	
	                requiredModule = modules[moduleName];
	                if (!requiredModule || !(requiredModule instanceof Module)) {
	                    throw new Error("required module '" + moduleName + "' not found");
	                }
	
	                requiredModule.init();
	
	                if (!requiredModule.supported) {
	                    throw new Error("required module '" + moduleName + "' not supported");
	                }
	            }
	
	            // Now run initializer
	            this.initializer(this);
	        },
	
	        fail: function(reason) {
	            this.initialized = true;
	            this.supported = false;
	            throw new Error(reason);
	        },
	
	        warn: function(msg) {
	            api.warn("Module " + this.name + ": " + msg);
	        },
	
	        deprecationNotice: function(deprecated, replacement) {
	            api.warn("DEPRECATED: " + deprecated + " in module " + this.name + " is deprecated. Please use " +
	                replacement + " instead");
	        },
	
	        createError: function(msg) {
	            return new Error("Error in Rangy " + this.name + " module: " + msg);
	        }
	    };
	
	    function createModule(name, dependencies, initFunc) {
	        var newModule = new Module(name, dependencies, function(module) {
	            if (!module.initialized) {
	                module.initialized = true;
	                try {
	                    initFunc(api, module);
	                    module.supported = true;
	                } catch (ex) {
	                    var errorMessage = "Module '" + name + "' failed to load: " + getErrorDesc(ex);
	                    consoleLog(errorMessage);
	                    if (ex.stack) {
	                        consoleLog(ex.stack);
	                    }
	                }
	            }
	        });
	        modules[name] = newModule;
	        return newModule;
	    }
	
	    api.createModule = function(name) {
	        // Allow 2 or 3 arguments (second argument is an optional array of dependencies)
	        var initFunc, dependencies;
	        if (arguments.length == 2) {
	            initFunc = arguments[1];
	            dependencies = [];
	        } else {
	            initFunc = arguments[2];
	            dependencies = arguments[1];
	        }
	
	        var module = createModule(name, dependencies, initFunc);
	
	        // Initialize the module immediately if the core is already initialized
	        if (api.initialized && api.supported) {
	            module.init();
	        }
	    };
	
	    api.createCoreModule = function(name, dependencies, initFunc) {
	        createModule(name, dependencies, initFunc);
	    };
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Ensure rangy.rangePrototype and rangy.selectionPrototype are available immediately
	
	    function RangePrototype() {}
	    api.RangePrototype = RangePrototype;
	    api.rangePrototype = new RangePrototype();
	
	    function SelectionPrototype() {}
	    api.selectionPrototype = new SelectionPrototype();
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // DOM utility methods used by Rangy
	    api.createCoreModule("DomUtil", [], function(api, module) {
	        var UNDEF = "undefined";
	        var util = api.util;
	        var getBody = util.getBody;
	
	        // Perform feature tests
	        if (!util.areHostMethods(document, ["createDocumentFragment", "createElement", "createTextNode"])) {
	            module.fail("document missing a Node creation method");
	        }
	
	        if (!util.isHostMethod(document, "getElementsByTagName")) {
	            module.fail("document missing getElementsByTagName method");
	        }
	
	        var el = document.createElement("div");
	        if (!util.areHostMethods(el, ["insertBefore", "appendChild", "cloneNode"] ||
	                !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]))) {
	            module.fail("Incomplete Element implementation");
	        }
	
	        // innerHTML is required for Range's createContextualFragment method
	        if (!util.isHostProperty(el, "innerHTML")) {
	            module.fail("Element is missing innerHTML property");
	        }
	
	        var textNode = document.createTextNode("test");
	        if (!util.areHostMethods(textNode, ["splitText", "deleteData", "insertData", "appendData", "cloneNode"] ||
	                !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]) ||
	                !util.areHostProperties(textNode, ["data"]))) {
	            module.fail("Incomplete Text Node implementation");
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Removed use of indexOf because of a bizarre bug in Opera that is thrown in one of the Acid3 tests. I haven't been
	        // able to replicate it outside of the test. The bug is that indexOf returns -1 when called on an Array that
	        // contains just the document as a single element and the value searched for is the document.
	        var arrayContains = /*Array.prototype.indexOf ?
	            function(arr, val) {
	                return arr.indexOf(val) > -1;
	            }:*/
	
	            function(arr, val) {
	                var i = arr.length;
	                while (i--) {
	                    if (arr[i] === val) {
	                        return true;
	                    }
	                }
	                return false;
	            };
	
	        // Opera 11 puts HTML elements in the null namespace, it seems, and IE 7 has undefined namespaceURI
	        function isHtmlNamespace(node) {
	            var ns;
	            return typeof node.namespaceURI == UNDEF || ((ns = node.namespaceURI) === null || ns == "http://www.w3.org/1999/xhtml");
	        }
	
	        function parentElement(node) {
	            var parent = node.parentNode;
	            return (parent.nodeType == 1) ? parent : null;
	        }
	
	        function getNodeIndex(node) {
	            var i = 0;
	            while( (node = node.previousSibling) ) {
	                ++i;
	            }
	            return i;
	        }
	
	        function getNodeLength(node) {
	            switch (node.nodeType) {
	                case 7:
	                case 10:
	                    return 0;
	                case 3:
	                case 8:
	                    return node.length;
	                default:
	                    return node.childNodes.length;
	            }
	        }
	
	        function getCommonAncestor(node1, node2) {
	            var ancestors = [], n;
	            for (n = node1; n; n = n.parentNode) {
	                ancestors.push(n);
	            }
	
	            for (n = node2; n; n = n.parentNode) {
	                if (arrayContains(ancestors, n)) {
	                    return n;
	                }
	            }
	
	            return null;
	        }
	
	        function isAncestorOf(ancestor, descendant, selfIsAncestor) {
	            var n = selfIsAncestor ? descendant : descendant.parentNode;
	            while (n) {
	                if (n === ancestor) {
	                    return true;
	                } else {
	                    n = n.parentNode;
	                }
	            }
	            return false;
	        }
	
	        function isOrIsAncestorOf(ancestor, descendant) {
	            return isAncestorOf(ancestor, descendant, true);
	        }
	
	        function getClosestAncestorIn(node, ancestor, selfIsAncestor) {
	            var p, n = selfIsAncestor ? node : node.parentNode;
	            while (n) {
	                p = n.parentNode;
	                if (p === ancestor) {
	                    return n;
	                }
	                n = p;
	            }
	            return null;
	        }
	
	        function isCharacterDataNode(node) {
	            var t = node.nodeType;
	            return t == 3 || t == 4 || t == 8 ; // Text, CDataSection or Comment
	        }
	
	        function isTextOrCommentNode(node) {
	            if (!node) {
	                return false;
	            }
	            var t = node.nodeType;
	            return t == 3 || t == 8 ; // Text or Comment
	        }
	
	        function insertAfter(node, precedingNode) {
	            var nextNode = precedingNode.nextSibling, parent = precedingNode.parentNode;
	            if (nextNode) {
	                parent.insertBefore(node, nextNode);
	            } else {
	                parent.appendChild(node);
	            }
	            return node;
	        }
	
	        // Note that we cannot use splitText() because it is bugridden in IE 9.
	        function splitDataNode(node, index, positionsToPreserve) {
	            var newNode = node.cloneNode(false);
	            newNode.deleteData(0, index);
	            node.deleteData(index, node.length - index);
	            insertAfter(newNode, node);
	
	            // Preserve positions
	            if (positionsToPreserve) {
	                for (var i = 0, position; position = positionsToPreserve[i++]; ) {
	                    // Handle case where position was inside the portion of node after the split point
	                    if (position.node == node && position.offset > index) {
	                        position.node = newNode;
	                        position.offset -= index;
	                    }
	                    // Handle the case where the position is a node offset within node's parent
	                    else if (position.node == node.parentNode && position.offset > getNodeIndex(node)) {
	                        ++position.offset;
	                    }
	                }
	            }
	            return newNode;
	        }
	
	        function getDocument(node) {
	            if (node.nodeType == 9) {
	                return node;
	            } else if (typeof node.ownerDocument != UNDEF) {
	                return node.ownerDocument;
	            } else if (typeof node.document != UNDEF) {
	                return node.document;
	            } else if (node.parentNode) {
	                return getDocument(node.parentNode);
	            } else {
	                throw module.createError("getDocument: no document found for node");
	            }
	        }
	
	        function getWindow(node) {
	            var doc = getDocument(node);
	            if (typeof doc.defaultView != UNDEF) {
	                return doc.defaultView;
	            } else if (typeof doc.parentWindow != UNDEF) {
	                return doc.parentWindow;
	            } else {
	                throw module.createError("Cannot get a window object for node");
	            }
	        }
	
	        function getIframeDocument(iframeEl) {
	            if (typeof iframeEl.contentDocument != UNDEF) {
	                return iframeEl.contentDocument;
	            } else if (typeof iframeEl.contentWindow != UNDEF) {
	                return iframeEl.contentWindow.document;
	            } else {
	                throw module.createError("getIframeDocument: No Document object found for iframe element");
	            }
	        }
	
	        function getIframeWindow(iframeEl) {
	            if (typeof iframeEl.contentWindow != UNDEF) {
	                return iframeEl.contentWindow;
	            } else if (typeof iframeEl.contentDocument != UNDEF) {
	                return iframeEl.contentDocument.defaultView;
	            } else {
	                throw module.createError("getIframeWindow: No Window object found for iframe element");
	            }
	        }
	
	        // This looks bad. Is it worth it?
	        function isWindow(obj) {
	            return obj && util.isHostMethod(obj, "setTimeout") && util.isHostObject(obj, "document");
	        }
	
	        function getContentDocument(obj, module, methodName) {
	            var doc;
	
	            if (!obj) {
	                doc = document;
	            }
	
	            // Test if a DOM node has been passed and obtain a document object for it if so
	            else if (util.isHostProperty(obj, "nodeType")) {
	                doc = (obj.nodeType == 1 && obj.tagName.toLowerCase() == "iframe") ?
	                    getIframeDocument(obj) : getDocument(obj);
	            }
	
	            // Test if the doc parameter appears to be a Window object
	            else if (isWindow(obj)) {
	                doc = obj.document;
	            }
	
	            if (!doc) {
	                throw module.createError(methodName + "(): Parameter must be a Window object or DOM node");
	            }
	
	            return doc;
	        }
	
	        function getRootContainer(node) {
	            var parent;
	            while ( (parent = node.parentNode) ) {
	                node = parent;
	            }
	            return node;
	        }
	
	        function comparePoints(nodeA, offsetA, nodeB, offsetB) {
	            // See http://www.w3.org/TR/DOM-Level-2-Traversal-Range/ranges.html#Level-2-Range-Comparing
	            var nodeC, root, childA, childB, n;
	            if (nodeA == nodeB) {
	                // Case 1: nodes are the same
	                return offsetA === offsetB ? 0 : (offsetA < offsetB) ? -1 : 1;
	            } else if ( (nodeC = getClosestAncestorIn(nodeB, nodeA, true)) ) {
	                // Case 2: node C (container B or an ancestor) is a child node of A
	                return offsetA <= getNodeIndex(nodeC) ? -1 : 1;
	            } else if ( (nodeC = getClosestAncestorIn(nodeA, nodeB, true)) ) {
	                // Case 3: node C (container A or an ancestor) is a child node of B
	                return getNodeIndex(nodeC) < offsetB  ? -1 : 1;
	            } else {
	                root = getCommonAncestor(nodeA, nodeB);
	                if (!root) {
	                    throw new Error("comparePoints error: nodes have no common ancestor");
	                }
	
	                // Case 4: containers are siblings or descendants of siblings
	                childA = (nodeA === root) ? root : getClosestAncestorIn(nodeA, root, true);
	                childB = (nodeB === root) ? root : getClosestAncestorIn(nodeB, root, true);
	
	                if (childA === childB) {
	                    // This shouldn't be possible
	                    throw module.createError("comparePoints got to case 4 and childA and childB are the same!");
	                } else {
	                    n = root.firstChild;
	                    while (n) {
	                        if (n === childA) {
	                            return -1;
	                        } else if (n === childB) {
	                            return 1;
	                        }
	                        n = n.nextSibling;
	                    }
	                }
	            }
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Test for IE's crash (IE 6/7) or exception (IE >= 8) when a reference to garbage-collected text node is queried
	        var crashyTextNodes = false;
	
	        function isBrokenNode(node) {
	            var n;
	            try {
	                n = node.parentNode;
	                return false;
	            } catch (e) {
	                return true;
	            }
	        }
	
	        (function() {
	            var el = document.createElement("b");
	            el.innerHTML = "1";
	            var textNode = el.firstChild;
	            el.innerHTML = "<br />";
	            crashyTextNodes = isBrokenNode(textNode);
	
	            api.features.crashyTextNodes = crashyTextNodes;
	        })();
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        function inspectNode(node) {
	            if (!node) {
	                return "[No node]";
	            }
	            if (crashyTextNodes && isBrokenNode(node)) {
	                return "[Broken node]";
	            }
	            if (isCharacterDataNode(node)) {
	                return '"' + node.data + '"';
	            }
	            if (node.nodeType == 1) {
	                var idAttr = node.id ? ' id="' + node.id + '"' : "";
	                return "<" + node.nodeName + idAttr + ">[index:" + getNodeIndex(node) + ",length:" + node.childNodes.length + "][" + (node.innerHTML || "[innerHTML not supported]").slice(0, 25) + "]";
	            }
	            return node.nodeName;
	        }
	
	        function fragmentFromNodeChildren(node) {
	            var fragment = getDocument(node).createDocumentFragment(), child;
	            while ( (child = node.firstChild) ) {
	                fragment.appendChild(child);
	            }
	            return fragment;
	        }
	
	        var getComputedStyleProperty;
	        if (typeof window.getComputedStyle != UNDEF) {
	            getComputedStyleProperty = function(el, propName) {
	                return getWindow(el).getComputedStyle(el, null)[propName];
	            };
	        } else if (typeof document.documentElement.currentStyle != UNDEF) {
	            getComputedStyleProperty = function(el, propName) {
	                return el.currentStyle ? el.currentStyle[propName] : "";
	            };
	        } else {
	            module.fail("No means of obtaining computed style properties found");
	        }
	
	        function createTestElement(doc, html, contentEditable) {
	            var body = getBody(doc);
	            var el = doc.createElement("div");
	            el.contentEditable = "" + !!contentEditable;
	            if (html) {
	                el.innerHTML = html;
	            }
	
	            // Insert the test element at the start of the body to prevent scrolling to the bottom in iOS (issue #292)
	            var bodyFirstChild = body.firstChild;
	            if (bodyFirstChild) {
	                body.insertBefore(el, bodyFirstChild);
	            } else {
	                body.appendChild(el);
	            }
	
	            return el;
	        }
	
	        function removeNode(node) {
	            return node.parentNode.removeChild(node);
	        }
	
	        function NodeIterator(root) {
	            this.root = root;
	            this._next = root;
	        }
	
	        NodeIterator.prototype = {
	            _current: null,
	
	            hasNext: function() {
	                return !!this._next;
	            },
	
	            next: function() {
	                var n = this._current = this._next;
	                var child, next;
	                if (this._current) {
	                    child = n.firstChild;
	                    if (child) {
	                        this._next = child;
	                    } else {
	                        next = null;
	                        while ((n !== this.root) && !(next = n.nextSibling)) {
	                            n = n.parentNode;
	                        }
	                        this._next = next;
	                    }
	                }
	                return this._current;
	            },
	
	            detach: function() {
	                this._current = this._next = this.root = null;
	            }
	        };
	
	        function createIterator(root) {
	            return new NodeIterator(root);
	        }
	
	        function DomPosition(node, offset) {
	            this.node = node;
	            this.offset = offset;
	        }
	
	        DomPosition.prototype = {
	            equals: function(pos) {
	                return !!pos && this.node === pos.node && this.offset == pos.offset;
	            },
	
	            inspect: function() {
	                return "[DomPosition(" + inspectNode(this.node) + ":" + this.offset + ")]";
	            },
	
	            toString: function() {
	                return this.inspect();
	            }
	        };
	
	        function DOMException(codeName) {
	            this.code = this[codeName];
	            this.codeName = codeName;
	            this.message = "DOMException: " + this.codeName;
	        }
	
	        DOMException.prototype = {
	            INDEX_SIZE_ERR: 1,
	            HIERARCHY_REQUEST_ERR: 3,
	            WRONG_DOCUMENT_ERR: 4,
	            NO_MODIFICATION_ALLOWED_ERR: 7,
	            NOT_FOUND_ERR: 8,
	            NOT_SUPPORTED_ERR: 9,
	            INVALID_STATE_ERR: 11,
	            INVALID_NODE_TYPE_ERR: 24
	        };
	
	        DOMException.prototype.toString = function() {
	            return this.message;
	        };
	
	        api.dom = {
	            arrayContains: arrayContains,
	            isHtmlNamespace: isHtmlNamespace,
	            parentElement: parentElement,
	            getNodeIndex: getNodeIndex,
	            getNodeLength: getNodeLength,
	            getCommonAncestor: getCommonAncestor,
	            isAncestorOf: isAncestorOf,
	            isOrIsAncestorOf: isOrIsAncestorOf,
	            getClosestAncestorIn: getClosestAncestorIn,
	            isCharacterDataNode: isCharacterDataNode,
	            isTextOrCommentNode: isTextOrCommentNode,
	            insertAfter: insertAfter,
	            splitDataNode: splitDataNode,
	            getDocument: getDocument,
	            getWindow: getWindow,
	            getIframeWindow: getIframeWindow,
	            getIframeDocument: getIframeDocument,
	            getBody: getBody,
	            isWindow: isWindow,
	            getContentDocument: getContentDocument,
	            getRootContainer: getRootContainer,
	            comparePoints: comparePoints,
	            isBrokenNode: isBrokenNode,
	            inspectNode: inspectNode,
	            getComputedStyleProperty: getComputedStyleProperty,
	            createTestElement: createTestElement,
	            removeNode: removeNode,
	            fragmentFromNodeChildren: fragmentFromNodeChildren,
	            createIterator: createIterator,
	            DomPosition: DomPosition
	        };
	
	        api.DOMException = DOMException;
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Pure JavaScript implementation of DOM Range
	    api.createCoreModule("DomRange", ["DomUtil"], function(api, module) {
	        var dom = api.dom;
	        var util = api.util;
	        var DomPosition = dom.DomPosition;
	        var DOMException = api.DOMException;
	
	        var isCharacterDataNode = dom.isCharacterDataNode;
	        var getNodeIndex = dom.getNodeIndex;
	        var isOrIsAncestorOf = dom.isOrIsAncestorOf;
	        var getDocument = dom.getDocument;
	        var comparePoints = dom.comparePoints;
	        var splitDataNode = dom.splitDataNode;
	        var getClosestAncestorIn = dom.getClosestAncestorIn;
	        var getNodeLength = dom.getNodeLength;
	        var arrayContains = dom.arrayContains;
	        var getRootContainer = dom.getRootContainer;
	        var crashyTextNodes = api.features.crashyTextNodes;
	
	        var removeNode = dom.removeNode;
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Utility functions
	
	        function isNonTextPartiallySelected(node, range) {
	            return (node.nodeType != 3) &&
	                   (isOrIsAncestorOf(node, range.startContainer) || isOrIsAncestorOf(node, range.endContainer));
	        }
	
	        function getRangeDocument(range) {
	            return range.document || getDocument(range.startContainer);
	        }
	
	        function getRangeRoot(range) {
	            return getRootContainer(range.startContainer);
	        }
	
	        function getBoundaryBeforeNode(node) {
	            return new DomPosition(node.parentNode, getNodeIndex(node));
	        }
	
	        function getBoundaryAfterNode(node) {
	            return new DomPosition(node.parentNode, getNodeIndex(node) + 1);
	        }
	
	        function insertNodeAtPosition(node, n, o) {
	            var firstNodeInserted = node.nodeType == 11 ? node.firstChild : node;
	            if (isCharacterDataNode(n)) {
	                if (o == n.length) {
	                    dom.insertAfter(node, n);
	                } else {
	                    n.parentNode.insertBefore(node, o == 0 ? n : splitDataNode(n, o));
	                }
	            } else if (o >= n.childNodes.length) {
	                n.appendChild(node);
	            } else {
	                n.insertBefore(node, n.childNodes[o]);
	            }
	            return firstNodeInserted;
	        }
	
	        function rangesIntersect(rangeA, rangeB, touchingIsIntersecting) {
	            assertRangeValid(rangeA);
	            assertRangeValid(rangeB);
	
	            if (getRangeDocument(rangeB) != getRangeDocument(rangeA)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	
	            var startComparison = comparePoints(rangeA.startContainer, rangeA.startOffset, rangeB.endContainer, rangeB.endOffset),
	                endComparison = comparePoints(rangeA.endContainer, rangeA.endOffset, rangeB.startContainer, rangeB.startOffset);
	
	            return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
	        }
	
	        function cloneSubtree(iterator) {
	            var partiallySelected;
	            for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {
	                partiallySelected = iterator.isPartiallySelectedSubtree();
	                node = node.cloneNode(!partiallySelected);
	                if (partiallySelected) {
	                    subIterator = iterator.getSubtreeIterator();
	                    node.appendChild(cloneSubtree(subIterator));
	                    subIterator.detach();
	                }
	
	                if (node.nodeType == 10) { // DocumentType
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	                frag.appendChild(node);
	            }
	            return frag;
	        }
	
	        function iterateSubtree(rangeIterator, func, iteratorState) {
	            var it, n;
	            iteratorState = iteratorState || { stop: false };
	            for (var node, subRangeIterator; node = rangeIterator.next(); ) {
	                if (rangeIterator.isPartiallySelectedSubtree()) {
	                    if (func(node) === false) {
	                        iteratorState.stop = true;
	                        return;
	                    } else {
	                        // The node is partially selected by the Range, so we can use a new RangeIterator on the portion of
	                        // the node selected by the Range.
	                        subRangeIterator = rangeIterator.getSubtreeIterator();
	                        iterateSubtree(subRangeIterator, func, iteratorState);
	                        subRangeIterator.detach();
	                        if (iteratorState.stop) {
	                            return;
	                        }
	                    }
	                } else {
	                    // The whole node is selected, so we can use efficient DOM iteration to iterate over the node and its
	                    // descendants
	                    it = dom.createIterator(node);
	                    while ( (n = it.next()) ) {
	                        if (func(n) === false) {
	                            iteratorState.stop = true;
	                            return;
	                        }
	                    }
	                }
	            }
	        }
	
	        function deleteSubtree(iterator) {
	            var subIterator;
	            while (iterator.next()) {
	                if (iterator.isPartiallySelectedSubtree()) {
	                    subIterator = iterator.getSubtreeIterator();
	                    deleteSubtree(subIterator);
	                    subIterator.detach();
	                } else {
	                    iterator.remove();
	                }
	            }
	        }
	
	        function extractSubtree(iterator) {
	            for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {
	
	                if (iterator.isPartiallySelectedSubtree()) {
	                    node = node.cloneNode(false);
	                    subIterator = iterator.getSubtreeIterator();
	                    node.appendChild(extractSubtree(subIterator));
	                    subIterator.detach();
	                } else {
	                    iterator.remove();
	                }
	                if (node.nodeType == 10) { // DocumentType
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	                frag.appendChild(node);
	            }
	            return frag;
	        }
	
	        function getNodesInRange(range, nodeTypes, filter) {
	            var filterNodeTypes = !!(nodeTypes && nodeTypes.length), regex;
	            var filterExists = !!filter;
	            if (filterNodeTypes) {
	                regex = new RegExp("^(" + nodeTypes.join("|") + ")$");
	            }
	
	            var nodes = [];
	            iterateSubtree(new RangeIterator(range, false), function(node) {
	                if (filterNodeTypes && !regex.test(node.nodeType)) {
	                    return;
	                }
	                if (filterExists && !filter(node)) {
	                    return;
	                }
	                // Don't include a boundary container if it is a character data node and the range does not contain any
	                // of its character data. See issue 190.
	                var sc = range.startContainer;
	                if (node == sc && isCharacterDataNode(sc) && range.startOffset == sc.length) {
	                    return;
	                }
	
	                var ec = range.endContainer;
	                if (node == ec && isCharacterDataNode(ec) && range.endOffset == 0) {
	                    return;
	                }
	
	                nodes.push(node);
	            });
	            return nodes;
	        }
	
	        function inspect(range) {
	            var name = (typeof range.getName == "undefined") ? "Range" : range.getName();
	            return "[" + name + "(" + dom.inspectNode(range.startContainer) + ":" + range.startOffset + ", " +
	                    dom.inspectNode(range.endContainer) + ":" + range.endOffset + ")]";
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // RangeIterator code partially borrows from IERange by Tim Ryan (http://github.com/timcameronryan/IERange)
	
	        function RangeIterator(range, clonePartiallySelectedTextNodes) {
	            this.range = range;
	            this.clonePartiallySelectedTextNodes = clonePartiallySelectedTextNodes;
	
	
	            if (!range.collapsed) {
	                this.sc = range.startContainer;
	                this.so = range.startOffset;
	                this.ec = range.endContainer;
	                this.eo = range.endOffset;
	                var root = range.commonAncestorContainer;
	
	                if (this.sc === this.ec && isCharacterDataNode(this.sc)) {
	                    this.isSingleCharacterDataNode = true;
	                    this._first = this._last = this._next = this.sc;
	                } else {
	                    this._first = this._next = (this.sc === root && !isCharacterDataNode(this.sc)) ?
	                        this.sc.childNodes[this.so] : getClosestAncestorIn(this.sc, root, true);
	                    this._last = (this.ec === root && !isCharacterDataNode(this.ec)) ?
	                        this.ec.childNodes[this.eo - 1] : getClosestAncestorIn(this.ec, root, true);
	                }
	            }
	        }
	
	        RangeIterator.prototype = {
	            _current: null,
	            _next: null,
	            _first: null,
	            _last: null,
	            isSingleCharacterDataNode: false,
	
	            reset: function() {
	                this._current = null;
	                this._next = this._first;
	            },
	
	            hasNext: function() {
	                return !!this._next;
	            },
	
	            next: function() {
	                // Move to next node
	                var current = this._current = this._next;
	                if (current) {
	                    this._next = (current !== this._last) ? current.nextSibling : null;
	
	                    // Check for partially selected text nodes
	                    if (isCharacterDataNode(current) && this.clonePartiallySelectedTextNodes) {
	                        if (current === this.ec) {
	                            (current = current.cloneNode(true)).deleteData(this.eo, current.length - this.eo);
	                        }
	                        if (this._current === this.sc) {
	                            (current = current.cloneNode(true)).deleteData(0, this.so);
	                        }
	                    }
	                }
	
	                return current;
	            },
	
	            remove: function() {
	                var current = this._current, start, end;
	
	                if (isCharacterDataNode(current) && (current === this.sc || current === this.ec)) {
	                    start = (current === this.sc) ? this.so : 0;
	                    end = (current === this.ec) ? this.eo : current.length;
	                    if (start != end) {
	                        current.deleteData(start, end - start);
	                    }
	                } else {
	                    if (current.parentNode) {
	                        removeNode(current);
	                    } else {
	                    }
	                }
	            },
	
	            // Checks if the current node is partially selected
	            isPartiallySelectedSubtree: function() {
	                var current = this._current;
	                return isNonTextPartiallySelected(current, this.range);
	            },
	
	            getSubtreeIterator: function() {
	                var subRange;
	                if (this.isSingleCharacterDataNode) {
	                    subRange = this.range.cloneRange();
	                    subRange.collapse(false);
	                } else {
	                    subRange = new Range(getRangeDocument(this.range));
	                    var current = this._current;
	                    var startContainer = current, startOffset = 0, endContainer = current, endOffset = getNodeLength(current);
	
	                    if (isOrIsAncestorOf(current, this.sc)) {
	                        startContainer = this.sc;
	                        startOffset = this.so;
	                    }
	                    if (isOrIsAncestorOf(current, this.ec)) {
	                        endContainer = this.ec;
	                        endOffset = this.eo;
	                    }
	
	                    updateBoundaries(subRange, startContainer, startOffset, endContainer, endOffset);
	                }
	                return new RangeIterator(subRange, this.clonePartiallySelectedTextNodes);
	            },
	
	            detach: function() {
	                this.range = this._current = this._next = this._first = this._last = this.sc = this.so = this.ec = this.eo = null;
	            }
	        };
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        var beforeAfterNodeTypes = [1, 3, 4, 5, 7, 8, 10];
	        var rootContainerNodeTypes = [2, 9, 11];
	        var readonlyNodeTypes = [5, 6, 10, 12];
	        var insertableNodeTypes = [1, 3, 4, 5, 7, 8, 10, 11];
	        var surroundNodeTypes = [1, 3, 4, 5, 7, 8];
	
	        function createAncestorFinder(nodeTypes) {
	            return function(node, selfIsAncestor) {
	                var t, n = selfIsAncestor ? node : node.parentNode;
	                while (n) {
	                    t = n.nodeType;
	                    if (arrayContains(nodeTypes, t)) {
	                        return n;
	                    }
	                    n = n.parentNode;
	                }
	                return null;
	            };
	        }
	
	        var getDocumentOrFragmentContainer = createAncestorFinder( [9, 11] );
	        var getReadonlyAncestor = createAncestorFinder(readonlyNodeTypes);
	        var getDocTypeNotationEntityAncestor = createAncestorFinder( [6, 10, 12] );
	        var getElementAncestor = createAncestorFinder( [1] );
	
	        function assertNoDocTypeNotationEntityAncestor(node, allowSelf) {
	            if (getDocTypeNotationEntityAncestor(node, allowSelf)) {
	                throw new DOMException("INVALID_NODE_TYPE_ERR");
	            }
	        }
	
	        function assertValidNodeType(node, invalidTypes) {
	            if (!arrayContains(invalidTypes, node.nodeType)) {
	                throw new DOMException("INVALID_NODE_TYPE_ERR");
	            }
	        }
	
	        function assertValidOffset(node, offset) {
	            if (offset < 0 || offset > (isCharacterDataNode(node) ? node.length : node.childNodes.length)) {
	                throw new DOMException("INDEX_SIZE_ERR");
	            }
	        }
	
	        function assertSameDocumentOrFragment(node1, node2) {
	            if (getDocumentOrFragmentContainer(node1, true) !== getDocumentOrFragmentContainer(node2, true)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	        }
	
	        function assertNodeNotReadOnly(node) {
	            if (getReadonlyAncestor(node, true)) {
	                throw new DOMException("NO_MODIFICATION_ALLOWED_ERR");
	            }
	        }
	
	        function assertNode(node, codeName) {
	            if (!node) {
	                throw new DOMException(codeName);
	            }
	        }
	
	        function isValidOffset(node, offset) {
	            return offset <= (isCharacterDataNode(node) ? node.length : node.childNodes.length);
	        }
	
	        function isRangeValid(range) {
	            return (!!range.startContainer && !!range.endContainer &&
	                    !(crashyTextNodes && (dom.isBrokenNode(range.startContainer) || dom.isBrokenNode(range.endContainer))) &&
	                    getRootContainer(range.startContainer) == getRootContainer(range.endContainer) &&
	                    isValidOffset(range.startContainer, range.startOffset) &&
	                    isValidOffset(range.endContainer, range.endOffset));
	        }
	
	        function assertRangeValid(range) {
	            if (!isRangeValid(range)) {
	                throw new Error("Range error: Range is not valid. This usually happens after DOM mutation. Range: (" + range.inspect() + ")");
	            }
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Test the browser's innerHTML support to decide how to implement createContextualFragment
	        var styleEl = document.createElement("style");
	        var htmlParsingConforms = false;
	        try {
	            styleEl.innerHTML = "<b>x</b>";
	            htmlParsingConforms = (styleEl.firstChild.nodeType == 3); // Pre-Blink Opera incorrectly creates an element node
	        } catch (e) {
	            // IE 6 and 7 throw
	        }
	
	        api.features.htmlParsingConforms = htmlParsingConforms;
	
	        var createContextualFragment = htmlParsingConforms ?
	
	            // Implementation as per HTML parsing spec, trusting in the browser's implementation of innerHTML. See
	            // discussion and base code for this implementation at issue 67.
	            // Spec: http://html5.org/specs/dom-parsing.html#extensions-to-the-range-interface
	            // Thanks to Aleks Williams.
	            function(fragmentStr) {
	                // "Let node the context object's start's node."
	                var node = this.startContainer;
	                var doc = getDocument(node);
	
	                // "If the context object's start's node is null, raise an INVALID_STATE_ERR
	                // exception and abort these steps."
	                if (!node) {
	                    throw new DOMException("INVALID_STATE_ERR");
	                }
	
	                // "Let element be as follows, depending on node's interface:"
	                // Document, Document Fragment: null
	                var el = null;
	
	                // "Element: node"
	                if (node.nodeType == 1) {
	                    el = node;
	
	                // "Text, Comment: node's parentElement"
	                } else if (isCharacterDataNode(node)) {
	                    el = dom.parentElement(node);
	                }
	
	                // "If either element is null or element's ownerDocument is an HTML document
	                // and element's local name is "html" and element's namespace is the HTML
	                // namespace"
	                if (el === null || (
	                    el.nodeName == "HTML" &&
	                    dom.isHtmlNamespace(getDocument(el).documentElement) &&
	                    dom.isHtmlNamespace(el)
	                )) {
	
	                // "let element be a new Element with "body" as its local name and the HTML
	                // namespace as its namespace.""
	                    el = doc.createElement("body");
	                } else {
	                    el = el.cloneNode(false);
	                }
	
	                // "If the node's document is an HTML document: Invoke the HTML fragment parsing algorithm."
	                // "If the node's document is an XML document: Invoke the XML fragment parsing algorithm."
	                // "In either case, the algorithm must be invoked with fragment as the input
	                // and element as the context element."
	                el.innerHTML = fragmentStr;
	
	                // "If this raises an exception, then abort these steps. Otherwise, let new
	                // children be the nodes returned."
	
	                // "Let fragment be a new DocumentFragment."
	                // "Append all new children to fragment."
	                // "Return fragment."
	                return dom.fragmentFromNodeChildren(el);
	            } :
	
	            // In this case, innerHTML cannot be trusted, so fall back to a simpler, non-conformant implementation that
	            // previous versions of Rangy used (with the exception of using a body element rather than a div)
	            function(fragmentStr) {
	                var doc = getRangeDocument(this);
	                var el = doc.createElement("body");
	                el.innerHTML = fragmentStr;
	
	                return dom.fragmentFromNodeChildren(el);
	            };
	
	        function splitRangeBoundaries(range, positionsToPreserve) {
	            assertRangeValid(range);
	
	            var sc = range.startContainer, so = range.startOffset, ec = range.endContainer, eo = range.endOffset;
	            var startEndSame = (sc === ec);
	
	            if (isCharacterDataNode(ec) && eo > 0 && eo < ec.length) {
	                splitDataNode(ec, eo, positionsToPreserve);
	            }
	
	            if (isCharacterDataNode(sc) && so > 0 && so < sc.length) {
	                sc = splitDataNode(sc, so, positionsToPreserve);
	                if (startEndSame) {
	                    eo -= so;
	                    ec = sc;
	                } else if (ec == sc.parentNode && eo >= getNodeIndex(sc)) {
	                    eo++;
	                }
	                so = 0;
	            }
	            range.setStartAndEnd(sc, so, ec, eo);
	        }
	
	        function rangeToHtml(range) {
	            assertRangeValid(range);
	            var container = range.commonAncestorContainer.parentNode.cloneNode(false);
	            container.appendChild( range.cloneContents() );
	            return container.innerHTML;
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        var rangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
	            "commonAncestorContainer"];
	
	        var s2s = 0, s2e = 1, e2e = 2, e2s = 3;
	        var n_b = 0, n_a = 1, n_b_a = 2, n_i = 3;
	
	        util.extend(api.rangePrototype, {
	            compareBoundaryPoints: function(how, range) {
	                assertRangeValid(this);
	                assertSameDocumentOrFragment(this.startContainer, range.startContainer);
	
	                var nodeA, offsetA, nodeB, offsetB;
	                var prefixA = (how == e2s || how == s2s) ? "start" : "end";
	                var prefixB = (how == s2e || how == s2s) ? "start" : "end";
	                nodeA = this[prefixA + "Container"];
	                offsetA = this[prefixA + "Offset"];
	                nodeB = range[prefixB + "Container"];
	                offsetB = range[prefixB + "Offset"];
	                return comparePoints(nodeA, offsetA, nodeB, offsetB);
	            },
	
	            insertNode: function(node) {
	                assertRangeValid(this);
	                assertValidNodeType(node, insertableNodeTypes);
	                assertNodeNotReadOnly(this.startContainer);
	
	                if (isOrIsAncestorOf(node, this.startContainer)) {
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	
	                // No check for whether the container of the start of the Range is of a type that does not allow
	                // children of the type of node: the browser's DOM implementation should do this for us when we attempt
	                // to add the node
	
	                var firstNodeInserted = insertNodeAtPosition(node, this.startContainer, this.startOffset);
	                this.setStartBefore(firstNodeInserted);
	            },
	
	            cloneContents: function() {
	                assertRangeValid(this);
	
	                var clone, frag;
	                if (this.collapsed) {
	                    return getRangeDocument(this).createDocumentFragment();
	                } else {
	                    if (this.startContainer === this.endContainer && isCharacterDataNode(this.startContainer)) {
	                        clone = this.startContainer.cloneNode(true);
	                        clone.data = clone.data.slice(this.startOffset, this.endOffset);
	                        frag = getRangeDocument(this).createDocumentFragment();
	                        frag.appendChild(clone);
	                        return frag;
	                    } else {
	                        var iterator = new RangeIterator(this, true);
	                        clone = cloneSubtree(iterator);
	                        iterator.detach();
	                    }
	                    return clone;
	                }
	            },
	
	            canSurroundContents: function() {
	                assertRangeValid(this);
	                assertNodeNotReadOnly(this.startContainer);
	                assertNodeNotReadOnly(this.endContainer);
	
	                // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
	                // no non-text nodes.
	                var iterator = new RangeIterator(this, true);
	                var boundariesInvalid = (iterator._first && (isNonTextPartiallySelected(iterator._first, this)) ||
	                        (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
	                iterator.detach();
	                return !boundariesInvalid;
	            },
	
	            surroundContents: function(node) {
	                assertValidNodeType(node, surroundNodeTypes);
	
	                if (!this.canSurroundContents()) {
	                    throw new DOMException("INVALID_STATE_ERR");
	                }
	
	                // Extract the contents
	                var content = this.extractContents();
	
	                // Clear the children of the node
	                if (node.hasChildNodes()) {
	                    while (node.lastChild) {
	                        node.removeChild(node.lastChild);
	                    }
	                }
	
	                // Insert the new node and add the extracted contents
	                insertNodeAtPosition(node, this.startContainer, this.startOffset);
	                node.appendChild(content);
	
	                this.selectNode(node);
	            },
	
	            cloneRange: function() {
	                assertRangeValid(this);
	                var range = new Range(getRangeDocument(this));
	                var i = rangeProperties.length, prop;
	                while (i--) {
	                    prop = rangeProperties[i];
	                    range[prop] = this[prop];
	                }
	                return range;
	            },
	
	            toString: function() {
	                assertRangeValid(this);
	                var sc = this.startContainer;
	                if (sc === this.endContainer && isCharacterDataNode(sc)) {
	                    return (sc.nodeType == 3 || sc.nodeType == 4) ? sc.data.slice(this.startOffset, this.endOffset) : "";
	                } else {
	                    var textParts = [], iterator = new RangeIterator(this, true);
	                    iterateSubtree(iterator, function(node) {
	                        // Accept only text or CDATA nodes, not comments
	                        if (node.nodeType == 3 || node.nodeType == 4) {
	                            textParts.push(node.data);
	                        }
	                    });
	                    iterator.detach();
	                    return textParts.join("");
	                }
	            },
	
	            // The methods below are all non-standard. The following batch were introduced by Mozilla but have since
	            // been removed from Mozilla.
	
	            compareNode: function(node) {
	                assertRangeValid(this);
	
	                var parent = node.parentNode;
	                var nodeIndex = getNodeIndex(node);
	
	                if (!parent) {
	                    throw new DOMException("NOT_FOUND_ERR");
	                }
	
	                var startComparison = this.comparePoint(parent, nodeIndex),
	                    endComparison = this.comparePoint(parent, nodeIndex + 1);
	
	                if (startComparison < 0) { // Node starts before
	                    return (endComparison > 0) ? n_b_a : n_b;
	                } else {
	                    return (endComparison > 0) ? n_a : n_i;
	                }
	            },
	
	            comparePoint: function(node, offset) {
	                assertRangeValid(this);
	                assertNode(node, "HIERARCHY_REQUEST_ERR");
	                assertSameDocumentOrFragment(node, this.startContainer);
	
	                if (comparePoints(node, offset, this.startContainer, this.startOffset) < 0) {
	                    return -1;
	                } else if (comparePoints(node, offset, this.endContainer, this.endOffset) > 0) {
	                    return 1;
	                }
	                return 0;
	            },
	
	            createContextualFragment: createContextualFragment,
	
	            toHtml: function() {
	                return rangeToHtml(this);
	            },
	
	            // touchingIsIntersecting determines whether this method considers a node that borders a range intersects
	            // with it (as in WebKit) or not (as in Gecko pre-1.9, and the default)
	            intersectsNode: function(node, touchingIsIntersecting) {
	                assertRangeValid(this);
	                if (getRootContainer(node) != getRangeRoot(this)) {
	                    return false;
	                }
	
	                var parent = node.parentNode, offset = getNodeIndex(node);
	                if (!parent) {
	                    return true;
	                }
	
	                var startComparison = comparePoints(parent, offset, this.endContainer, this.endOffset),
	                    endComparison = comparePoints(parent, offset + 1, this.startContainer, this.startOffset);
	
	                return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
	            },
	
	            isPointInRange: function(node, offset) {
	                assertRangeValid(this);
	                assertNode(node, "HIERARCHY_REQUEST_ERR");
	                assertSameDocumentOrFragment(node, this.startContainer);
	
	                return (comparePoints(node, offset, this.startContainer, this.startOffset) >= 0) &&
	                       (comparePoints(node, offset, this.endContainer, this.endOffset) <= 0);
	            },
	
	            // The methods below are non-standard and invented by me.
	
	            // Sharing a boundary start-to-end or end-to-start does not count as intersection.
	            intersectsRange: function(range) {
	                return rangesIntersect(this, range, false);
	            },
	
	            // Sharing a boundary start-to-end or end-to-start does count as intersection.
	            intersectsOrTouchesRange: function(range) {
	                return rangesIntersect(this, range, true);
	            },
	
	            intersection: function(range) {
	                if (this.intersectsRange(range)) {
	                    var startComparison = comparePoints(this.startContainer, this.startOffset, range.startContainer, range.startOffset),
	                        endComparison = comparePoints(this.endContainer, this.endOffset, range.endContainer, range.endOffset);
	
	                    var intersectionRange = this.cloneRange();
	                    if (startComparison == -1) {
	                        intersectionRange.setStart(range.startContainer, range.startOffset);
	                    }
	                    if (endComparison == 1) {
	                        intersectionRange.setEnd(range.endContainer, range.endOffset);
	                    }
	                    return intersectionRange;
	                }
	                return null;
	            },
	
	            union: function(range) {
	                if (this.intersectsOrTouchesRange(range)) {
	                    var unionRange = this.cloneRange();
	                    if (comparePoints(range.startContainer, range.startOffset, this.startContainer, this.startOffset) == -1) {
	                        unionRange.setStart(range.startContainer, range.startOffset);
	                    }
	                    if (comparePoints(range.endContainer, range.endOffset, this.endContainer, this.endOffset) == 1) {
	                        unionRange.setEnd(range.endContainer, range.endOffset);
	                    }
	                    return unionRange;
	                } else {
	                    throw new DOMException("Ranges do not intersect");
	                }
	            },
	
	            containsNode: function(node, allowPartial) {
	                if (allowPartial) {
	                    return this.intersectsNode(node, false);
	                } else {
	                    return this.compareNode(node) == n_i;
	                }
	            },
	
	            containsNodeContents: function(node) {
	                return this.comparePoint(node, 0) >= 0 && this.comparePoint(node, getNodeLength(node)) <= 0;
	            },
	
	            containsRange: function(range) {
	                var intersection = this.intersection(range);
	                return intersection !== null && range.equals(intersection);
	            },
	
	            containsNodeText: function(node) {
	                var nodeRange = this.cloneRange();
	                nodeRange.selectNode(node);
	                var textNodes = nodeRange.getNodes([3]);
	                if (textNodes.length > 0) {
	                    nodeRange.setStart(textNodes[0], 0);
	                    var lastTextNode = textNodes.pop();
	                    nodeRange.setEnd(lastTextNode, lastTextNode.length);
	                    return this.containsRange(nodeRange);
	                } else {
	                    return this.containsNodeContents(node);
	                }
	            },
	
	            getNodes: function(nodeTypes, filter) {
	                assertRangeValid(this);
	                return getNodesInRange(this, nodeTypes, filter);
	            },
	
	            getDocument: function() {
	                return getRangeDocument(this);
	            },
	
	            collapseBefore: function(node) {
	                this.setEndBefore(node);
	                this.collapse(false);
	            },
	
	            collapseAfter: function(node) {
	                this.setStartAfter(node);
	                this.collapse(true);
	            },
	
	            getBookmark: function(containerNode) {
	                var doc = getRangeDocument(this);
	                var preSelectionRange = api.createRange(doc);
	                containerNode = containerNode || dom.getBody(doc);
	                preSelectionRange.selectNodeContents(containerNode);
	                var range = this.intersection(preSelectionRange);
	                var start = 0, end = 0;
	                if (range) {
	                    preSelectionRange.setEnd(range.startContainer, range.startOffset);
	                    start = preSelectionRange.toString().length;
	                    end = start + range.toString().length;
	                }
	
	                return {
	                    start: start,
	                    end: end,
	                    containerNode: containerNode
	                };
	            },
	
	            moveToBookmark: function(bookmark) {
	                var containerNode = bookmark.containerNode;
	                var charIndex = 0;
	                this.setStart(containerNode, 0);
	                this.collapse(true);
	                var nodeStack = [containerNode], node, foundStart = false, stop = false;
	                var nextCharIndex, i, childNodes;
	
	                while (!stop && (node = nodeStack.pop())) {
	                    if (node.nodeType == 3) {
	                        nextCharIndex = charIndex + node.length;
	                        if (!foundStart && bookmark.start >= charIndex && bookmark.start <= nextCharIndex) {
	                            this.setStart(node, bookmark.start - charIndex);
	                            foundStart = true;
	                        }
	                        if (foundStart && bookmark.end >= charIndex && bookmark.end <= nextCharIndex) {
	                            this.setEnd(node, bookmark.end - charIndex);
	                            stop = true;
	                        }
	                        charIndex = nextCharIndex;
	                    } else {
	                        childNodes = node.childNodes;
	                        i = childNodes.length;
	                        while (i--) {
	                            nodeStack.push(childNodes[i]);
	                        }
	                    }
	                }
	            },
	
	            getName: function() {
	                return "DomRange";
	            },
	
	            equals: function(range) {
	                return Range.rangesEqual(this, range);
	            },
	
	            isValid: function() {
	                return isRangeValid(this);
	            },
	
	            inspect: function() {
	                return inspect(this);
	            },
	
	            detach: function() {
	                // In DOM4, detach() is now a no-op.
	            }
	        });
	
	        function copyComparisonConstantsToObject(obj) {
	            obj.START_TO_START = s2s;
	            obj.START_TO_END = s2e;
	            obj.END_TO_END = e2e;
	            obj.END_TO_START = e2s;
	
	            obj.NODE_BEFORE = n_b;
	            obj.NODE_AFTER = n_a;
	            obj.NODE_BEFORE_AND_AFTER = n_b_a;
	            obj.NODE_INSIDE = n_i;
	        }
	
	        function copyComparisonConstants(constructor) {
	            copyComparisonConstantsToObject(constructor);
	            copyComparisonConstantsToObject(constructor.prototype);
	        }
	
	        function createRangeContentRemover(remover, boundaryUpdater) {
	            return function() {
	                assertRangeValid(this);
	
	                var sc = this.startContainer, so = this.startOffset, root = this.commonAncestorContainer;
	
	                var iterator = new RangeIterator(this, true);
	
	                // Work out where to position the range after content removal
	                var node, boundary;
	                if (sc !== root) {
	                    node = getClosestAncestorIn(sc, root, true);
	                    boundary = getBoundaryAfterNode(node);
	                    sc = boundary.node;
	                    so = boundary.offset;
	                }
	
	                // Check none of the range is read-only
	                iterateSubtree(iterator, assertNodeNotReadOnly);
	
	                iterator.reset();
	
	                // Remove the content
	                var returnValue = remover(iterator);
	                iterator.detach();
	
	                // Move to the new position
	                boundaryUpdater(this, sc, so, sc, so);
	
	                return returnValue;
	            };
	        }
	
	        function createPrototypeRange(constructor, boundaryUpdater) {
	            function createBeforeAfterNodeSetter(isBefore, isStart) {
	                return function(node) {
	                    assertValidNodeType(node, beforeAfterNodeTypes);
	                    assertValidNodeType(getRootContainer(node), rootContainerNodeTypes);
	
	                    var boundary = (isBefore ? getBoundaryBeforeNode : getBoundaryAfterNode)(node);
	                    (isStart ? setRangeStart : setRangeEnd)(this, boundary.node, boundary.offset);
	                };
	            }
	
	            function setRangeStart(range, node, offset) {
	                var ec = range.endContainer, eo = range.endOffset;
	                if (node !== range.startContainer || offset !== range.startOffset) {
	                    // Check the root containers of the range and the new boundary, and also check whether the new boundary
	                    // is after the current end. In either case, collapse the range to the new position
	                    if (getRootContainer(node) != getRootContainer(ec) || comparePoints(node, offset, ec, eo) == 1) {
	                        ec = node;
	                        eo = offset;
	                    }
	                    boundaryUpdater(range, node, offset, ec, eo);
	                }
	            }
	
	            function setRangeEnd(range, node, offset) {
	                var sc = range.startContainer, so = range.startOffset;
	                if (node !== range.endContainer || offset !== range.endOffset) {
	                    // Check the root containers of the range and the new boundary, and also check whether the new boundary
	                    // is after the current end. In either case, collapse the range to the new position
	                    if (getRootContainer(node) != getRootContainer(sc) || comparePoints(node, offset, sc, so) == -1) {
	                        sc = node;
	                        so = offset;
	                    }
	                    boundaryUpdater(range, sc, so, node, offset);
	                }
	            }
	
	            // Set up inheritance
	            var F = function() {};
	            F.prototype = api.rangePrototype;
	            constructor.prototype = new F();
	
	            util.extend(constructor.prototype, {
	                setStart: function(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	
	                    setRangeStart(this, node, offset);
	                },
	
	                setEnd: function(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	
	                    setRangeEnd(this, node, offset);
	                },
	
	                /**
	                 * Convenience method to set a range's start and end boundaries. Overloaded as follows:
	                 * - Two parameters (node, offset) creates a collapsed range at that position
	                 * - Three parameters (node, startOffset, endOffset) creates a range contained with node starting at
	                 *   startOffset and ending at endOffset
	                 * - Four parameters (startNode, startOffset, endNode, endOffset) creates a range starting at startOffset in
	                 *   startNode and ending at endOffset in endNode
	                 */
	                setStartAndEnd: function() {
	                    var args = arguments;
	                    var sc = args[0], so = args[1], ec = sc, eo = so;
	
	                    switch (args.length) {
	                        case 3:
	                            eo = args[2];
	                            break;
	                        case 4:
	                            ec = args[2];
	                            eo = args[3];
	                            break;
	                    }
	
	                    assertNoDocTypeNotationEntityAncestor(sc, true);
	                    assertValidOffset(sc, so);
	
	                    assertNoDocTypeNotationEntityAncestor(ec, true);
	                    assertValidOffset(ec, eo);
	
	                    boundaryUpdater(this, sc, so, ec, eo);
	                },
	
	                setBoundary: function(node, offset, isStart) {
	                    this["set" + (isStart ? "Start" : "End")](node, offset);
	                },
	
	                setStartBefore: createBeforeAfterNodeSetter(true, true),
	                setStartAfter: createBeforeAfterNodeSetter(false, true),
	                setEndBefore: createBeforeAfterNodeSetter(true, false),
	                setEndAfter: createBeforeAfterNodeSetter(false, false),
	
	                collapse: function(isStart) {
	                    assertRangeValid(this);
	                    if (isStart) {
	                        boundaryUpdater(this, this.startContainer, this.startOffset, this.startContainer, this.startOffset);
	                    } else {
	                        boundaryUpdater(this, this.endContainer, this.endOffset, this.endContainer, this.endOffset);
	                    }
	                },
	
	                selectNodeContents: function(node) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	
	                    boundaryUpdater(this, node, 0, node, getNodeLength(node));
	                },
	
	                selectNode: function(node) {
	                    assertNoDocTypeNotationEntityAncestor(node, false);
	                    assertValidNodeType(node, beforeAfterNodeTypes);
	
	                    var start = getBoundaryBeforeNode(node), end = getBoundaryAfterNode(node);
	                    boundaryUpdater(this, start.node, start.offset, end.node, end.offset);
	                },
	
	                extractContents: createRangeContentRemover(extractSubtree, boundaryUpdater),
	
	                deleteContents: createRangeContentRemover(deleteSubtree, boundaryUpdater),
	
	                canSurroundContents: function() {
	                    assertRangeValid(this);
	                    assertNodeNotReadOnly(this.startContainer);
	                    assertNodeNotReadOnly(this.endContainer);
	
	                    // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
	                    // no non-text nodes.
	                    var iterator = new RangeIterator(this, true);
	                    var boundariesInvalid = (iterator._first && isNonTextPartiallySelected(iterator._first, this) ||
	                            (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
	                    iterator.detach();
	                    return !boundariesInvalid;
	                },
	
	                splitBoundaries: function() {
	                    splitRangeBoundaries(this);
	                },
	
	                splitBoundariesPreservingPositions: function(positionsToPreserve) {
	                    splitRangeBoundaries(this, positionsToPreserve);
	                },
	
	                normalizeBoundaries: function() {
	                    assertRangeValid(this);
	
	                    var sc = this.startContainer, so = this.startOffset, ec = this.endContainer, eo = this.endOffset;
	
	                    var mergeForward = function(node) {
	                        var sibling = node.nextSibling;
	                        if (sibling && sibling.nodeType == node.nodeType) {
	                            ec = node;
	                            eo = node.length;
	                            node.appendData(sibling.data);
	                            removeNode(sibling);
	                        }
	                    };
	
	                    var mergeBackward = function(node) {
	                        var sibling = node.previousSibling;
	                        if (sibling && sibling.nodeType == node.nodeType) {
	                            sc = node;
	                            var nodeLength = node.length;
	                            so = sibling.length;
	                            node.insertData(0, sibling.data);
	                            removeNode(sibling);
	                            if (sc == ec) {
	                                eo += so;
	                                ec = sc;
	                            } else if (ec == node.parentNode) {
	                                var nodeIndex = getNodeIndex(node);
	                                if (eo == nodeIndex) {
	                                    ec = node;
	                                    eo = nodeLength;
	                                } else if (eo > nodeIndex) {
	                                    eo--;
	                                }
	                            }
	                        }
	                    };
	
	                    var normalizeStart = true;
	                    var sibling;
	
	                    if (isCharacterDataNode(ec)) {
	                        if (eo == ec.length) {
	                            mergeForward(ec);
	                        } else if (eo == 0) {
	                            sibling = ec.previousSibling;
	                            if (sibling && sibling.nodeType == ec.nodeType) {
	                                eo = sibling.length;
	                                if (sc == ec) {
	                                    normalizeStart = false;
	                                }
	                                sibling.appendData(ec.data);
	                                removeNode(ec);
	                                ec = sibling;
	                            }
	                        }
	                    } else {
	                        if (eo > 0) {
	                            var endNode = ec.childNodes[eo - 1];
	                            if (endNode && isCharacterDataNode(endNode)) {
	                                mergeForward(endNode);
	                            }
	                        }
	                        normalizeStart = !this.collapsed;
	                    }
	
	                    if (normalizeStart) {
	                        if (isCharacterDataNode(sc)) {
	                            if (so == 0) {
	                                mergeBackward(sc);
	                            } else if (so == sc.length) {
	                                sibling = sc.nextSibling;
	                                if (sibling && sibling.nodeType == sc.nodeType) {
	                                    if (ec == sibling) {
	                                        ec = sc;
	                                        eo += sc.length;
	                                    }
	                                    sc.appendData(sibling.data);
	                                    removeNode(sibling);
	                                }
	                            }
	                        } else {
	                            if (so < sc.childNodes.length) {
	                                var startNode = sc.childNodes[so];
	                                if (startNode && isCharacterDataNode(startNode)) {
	                                    mergeBackward(startNode);
	                                }
	                            }
	                        }
	                    } else {
	                        sc = ec;
	                        so = eo;
	                    }
	
	                    boundaryUpdater(this, sc, so, ec, eo);
	                },
	
	                collapseToPoint: function(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	                    this.setStartAndEnd(node, offset);
	                },
	
	                parentElement: function() {
	                    assertRangeValid(this);
	                    var parentNode = this.commonAncestorContainer;
	                    return parentNode ? getElementAncestor(this.commonAncestorContainer, true) : null;
	                }
	            });
	
	            copyComparisonConstants(constructor);
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Updates commonAncestorContainer and collapsed after boundary change
	        function updateCollapsedAndCommonAncestor(range) {
	            range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
	            range.commonAncestorContainer = range.collapsed ?
	                range.startContainer : dom.getCommonAncestor(range.startContainer, range.endContainer);
	        }
	
	        function updateBoundaries(range, startContainer, startOffset, endContainer, endOffset) {
	            range.startContainer = startContainer;
	            range.startOffset = startOffset;
	            range.endContainer = endContainer;
	            range.endOffset = endOffset;
	            range.document = dom.getDocument(startContainer);
	            updateCollapsedAndCommonAncestor(range);
	        }
	
	        function Range(doc) {
	            updateBoundaries(this, doc, 0, doc, 0);
	        }
	
	        createPrototypeRange(Range, updateBoundaries);
	
	        util.extend(Range, {
	            rangeProperties: rangeProperties,
	            RangeIterator: RangeIterator,
	            copyComparisonConstants: copyComparisonConstants,
	            createPrototypeRange: createPrototypeRange,
	            inspect: inspect,
	            toHtml: rangeToHtml,
	            getRangeDocument: getRangeDocument,
	            rangesEqual: function(r1, r2) {
	                return r1.startContainer === r2.startContainer &&
	                    r1.startOffset === r2.startOffset &&
	                    r1.endContainer === r2.endContainer &&
	                    r1.endOffset === r2.endOffset;
	            }
	        });
	
	        api.DomRange = Range;
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Wrappers for the browser's native DOM Range and/or TextRange implementation
	    api.createCoreModule("WrappedRange", ["DomRange"], function(api, module) {
	        var WrappedRange, WrappedTextRange;
	        var dom = api.dom;
	        var util = api.util;
	        var DomPosition = dom.DomPosition;
	        var DomRange = api.DomRange;
	        var getBody = dom.getBody;
	        var getContentDocument = dom.getContentDocument;
	        var isCharacterDataNode = dom.isCharacterDataNode;
	
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        if (api.features.implementsDomRange) {
	            // This is a wrapper around the browser's native DOM Range. It has two aims:
	            // - Provide workarounds for specific browser bugs
	            // - provide convenient extensions, which are inherited from Rangy's DomRange
	
	            (function() {
	                var rangeProto;
	                var rangeProperties = DomRange.rangeProperties;
	
	                function updateRangeProperties(range) {
	                    var i = rangeProperties.length, prop;
	                    while (i--) {
	                        prop = rangeProperties[i];
	                        range[prop] = range.nativeRange[prop];
	                    }
	                    // Fix for broken collapsed property in IE 9.
	                    range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
	                }
	
	                function updateNativeRange(range, startContainer, startOffset, endContainer, endOffset) {
	                    var startMoved = (range.startContainer !== startContainer || range.startOffset != startOffset);
	                    var endMoved = (range.endContainer !== endContainer || range.endOffset != endOffset);
	                    var nativeRangeDifferent = !range.equals(range.nativeRange);
	
	                    // Always set both boundaries for the benefit of IE9 (see issue 35)
	                    if (startMoved || endMoved || nativeRangeDifferent) {
	                        range.setEnd(endContainer, endOffset);
	                        range.setStart(startContainer, startOffset);
	                    }
	                }
	
	                var createBeforeAfterNodeSetter;
	
	                WrappedRange = function(range) {
	                    if (!range) {
	                        throw module.createError("WrappedRange: Range must be specified");
	                    }
	                    this.nativeRange = range;
	                    updateRangeProperties(this);
	                };
	
	                DomRange.createPrototypeRange(WrappedRange, updateNativeRange);
	
	                rangeProto = WrappedRange.prototype;
	
	                rangeProto.selectNode = function(node) {
	                    this.nativeRange.selectNode(node);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.cloneContents = function() {
	                    return this.nativeRange.cloneContents();
	                };
	
	                // Due to a long-standing Firefox bug that I have not been able to find a reliable way to detect,
	                // insertNode() is never delegated to the native range.
	
	                rangeProto.surroundContents = function(node) {
	                    this.nativeRange.surroundContents(node);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.collapse = function(isStart) {
	                    this.nativeRange.collapse(isStart);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.cloneRange = function() {
	                    return new WrappedRange(this.nativeRange.cloneRange());
	                };
	
	                rangeProto.refresh = function() {
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.toString = function() {
	                    return this.nativeRange.toString();
	                };
	
	                // Create test range and node for feature detection
	
	                var testTextNode = document.createTextNode("test");
	                getBody(document).appendChild(testTextNode);
	                var range = document.createRange();
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for Firefox 2 bug that prevents moving the start of a Range to a point after its current end and
	                // correct for it
	
	                range.setStart(testTextNode, 0);
	                range.setEnd(testTextNode, 0);
	
	                try {
	                    range.setStart(testTextNode, 1);
	
	                    rangeProto.setStart = function(node, offset) {
	                        this.nativeRange.setStart(node, offset);
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.setEnd = function(node, offset) {
	                        this.nativeRange.setEnd(node, offset);
	                        updateRangeProperties(this);
	                    };
	
	                    createBeforeAfterNodeSetter = function(name) {
	                        return function(node) {
	                            this.nativeRange[name](node);
	                            updateRangeProperties(this);
	                        };
	                    };
	
	                } catch(ex) {
	
	                    rangeProto.setStart = function(node, offset) {
	                        try {
	                            this.nativeRange.setStart(node, offset);
	                        } catch (ex) {
	                            this.nativeRange.setEnd(node, offset);
	                            this.nativeRange.setStart(node, offset);
	                        }
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.setEnd = function(node, offset) {
	                        try {
	                            this.nativeRange.setEnd(node, offset);
	                        } catch (ex) {
	                            this.nativeRange.setStart(node, offset);
	                            this.nativeRange.setEnd(node, offset);
	                        }
	                        updateRangeProperties(this);
	                    };
	
	                    createBeforeAfterNodeSetter = function(name, oppositeName) {
	                        return function(node) {
	                            try {
	                                this.nativeRange[name](node);
	                            } catch (ex) {
	                                this.nativeRange[oppositeName](node);
	                                this.nativeRange[name](node);
	                            }
	                            updateRangeProperties(this);
	                        };
	                    };
	                }
	
	                rangeProto.setStartBefore = createBeforeAfterNodeSetter("setStartBefore", "setEndBefore");
	                rangeProto.setStartAfter = createBeforeAfterNodeSetter("setStartAfter", "setEndAfter");
	                rangeProto.setEndBefore = createBeforeAfterNodeSetter("setEndBefore", "setStartBefore");
	                rangeProto.setEndAfter = createBeforeAfterNodeSetter("setEndAfter", "setStartAfter");
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Always use DOM4-compliant selectNodeContents implementation: it's simpler and less code than testing
	                // whether the native implementation can be trusted
	                rangeProto.selectNodeContents = function(node) {
	                    this.setStartAndEnd(node, 0, dom.getNodeLength(node));
	                };
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for and correct WebKit bug that has the behaviour of compareBoundaryPoints round the wrong way for
	                // constants START_TO_END and END_TO_START: https://bugs.webkit.org/show_bug.cgi?id=20738
	
	                range.selectNodeContents(testTextNode);
	                range.setEnd(testTextNode, 3);
	
	                var range2 = document.createRange();
	                range2.selectNodeContents(testTextNode);
	                range2.setEnd(testTextNode, 4);
	                range2.setStart(testTextNode, 2);
	
	                if (range.compareBoundaryPoints(range.START_TO_END, range2) == -1 &&
	                        range.compareBoundaryPoints(range.END_TO_START, range2) == 1) {
	                    // This is the wrong way round, so correct for it
	
	                    rangeProto.compareBoundaryPoints = function(type, range) {
	                        range = range.nativeRange || range;
	                        if (type == range.START_TO_END) {
	                            type = range.END_TO_START;
	                        } else if (type == range.END_TO_START) {
	                            type = range.START_TO_END;
	                        }
	                        return this.nativeRange.compareBoundaryPoints(type, range);
	                    };
	                } else {
	                    rangeProto.compareBoundaryPoints = function(type, range) {
	                        return this.nativeRange.compareBoundaryPoints(type, range.nativeRange || range);
	                    };
	                }
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for IE deleteContents() and extractContents() bug and correct it. See issue 107.
	
	                var el = document.createElement("div");
	                el.innerHTML = "123";
	                var textNode = el.firstChild;
	                var body = getBody(document);
	                body.appendChild(el);
	
	                range.setStart(textNode, 1);
	                range.setEnd(textNode, 2);
	                range.deleteContents();
	
	                if (textNode.data == "13") {
	                    // Behaviour is correct per DOM4 Range so wrap the browser's implementation of deleteContents() and
	                    // extractContents()
	                    rangeProto.deleteContents = function() {
	                        this.nativeRange.deleteContents();
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.extractContents = function() {
	                        var frag = this.nativeRange.extractContents();
	                        updateRangeProperties(this);
	                        return frag;
	                    };
	                } else {
	                }
	
	                body.removeChild(el);
	                body = null;
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for existence of createContextualFragment and delegate to it if it exists
	                if (util.isHostMethod(range, "createContextualFragment")) {
	                    rangeProto.createContextualFragment = function(fragmentStr) {
	                        return this.nativeRange.createContextualFragment(fragmentStr);
	                    };
	                }
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Clean up
	                getBody(document).removeChild(testTextNode);
	
	                rangeProto.getName = function() {
	                    return "WrappedRange";
	                };
	
	                api.WrappedRange = WrappedRange;
	
	                api.createNativeRange = function(doc) {
	                    doc = getContentDocument(doc, module, "createNativeRange");
	                    return doc.createRange();
	                };
	            })();
	        }
	
	        if (api.features.implementsTextRange) {
	            /*
	            This is a workaround for a bug where IE returns the wrong container element from the TextRange's parentElement()
	            method. For example, in the following (where pipes denote the selection boundaries):
	
	            <ul id="ul"><li id="a">| a </li><li id="b"> b |</li></ul>
	
	            var range = document.selection.createRange();
	            alert(range.parentElement().id); // Should alert "ul" but alerts "b"
	
	            This method returns the common ancestor node of the following:
	            - the parentElement() of the textRange
	            - the parentElement() of the textRange after calling collapse(true)
	            - the parentElement() of the textRange after calling collapse(false)
	            */
	            var getTextRangeContainerElement = function(textRange) {
	                var parentEl = textRange.parentElement();
	                var range = textRange.duplicate();
	                range.collapse(true);
	                var startEl = range.parentElement();
	                range = textRange.duplicate();
	                range.collapse(false);
	                var endEl = range.parentElement();
	                var startEndContainer = (startEl == endEl) ? startEl : dom.getCommonAncestor(startEl, endEl);
	
	                return startEndContainer == parentEl ? startEndContainer : dom.getCommonAncestor(parentEl, startEndContainer);
	            };
	
	            var textRangeIsCollapsed = function(textRange) {
	                return textRange.compareEndPoints("StartToEnd", textRange) == 0;
	            };
	
	            // Gets the boundary of a TextRange expressed as a node and an offset within that node. This function started
	            // out as an improved version of code found in Tim Cameron Ryan's IERange (http://code.google.com/p/ierange/)
	            // but has grown, fixing problems with line breaks in preformatted text, adding workaround for IE TextRange
	            // bugs, handling for inputs and images, plus optimizations.
	            var getTextRangeBoundaryPosition = function(textRange, wholeRangeContainerElement, isStart, isCollapsed, startInfo) {
	                var workingRange = textRange.duplicate();
	                workingRange.collapse(isStart);
	                var containerElement = workingRange.parentElement();
	
	                // Sometimes collapsing a TextRange that's at the start of a text node can move it into the previous node, so
	                // check for that
	                if (!dom.isOrIsAncestorOf(wholeRangeContainerElement, containerElement)) {
	                    containerElement = wholeRangeContainerElement;
	                }
	
	
	                // Deal with nodes that cannot "contain rich HTML markup". In practice, this means form inputs, images and
	                // similar. See http://msdn.microsoft.com/en-us/library/aa703950%28VS.85%29.aspx
	                if (!containerElement.canHaveHTML) {
	                    var pos = new DomPosition(containerElement.parentNode, dom.getNodeIndex(containerElement));
	                    return {
	                        boundaryPosition: pos,
	                        nodeInfo: {
	                            nodeIndex: pos.offset,
	                            containerElement: pos.node
	                        }
	                    };
	                }
	
	                var workingNode = dom.getDocument(containerElement).createElement("span");
	
	                // Workaround for HTML5 Shiv's insane violation of document.createElement(). See Rangy issue 104 and HTML5
	                // Shiv issue 64: https://github.com/aFarkas/html5shiv/issues/64
	                if (workingNode.parentNode) {
	                    dom.removeNode(workingNode);
	                }
	
	                var comparison, workingComparisonType = isStart ? "StartToStart" : "StartToEnd";
	                var previousNode, nextNode, boundaryPosition, boundaryNode;
	                var start = (startInfo && startInfo.containerElement == containerElement) ? startInfo.nodeIndex : 0;
	                var childNodeCount = containerElement.childNodes.length;
	                var end = childNodeCount;
	
	                // Check end first. Code within the loop assumes that the endth child node of the container is definitely
	                // after the range boundary.
	                var nodeIndex = end;
	
	                while (true) {
	                    if (nodeIndex == childNodeCount) {
	                        containerElement.appendChild(workingNode);
	                    } else {
	                        containerElement.insertBefore(workingNode, containerElement.childNodes[nodeIndex]);
	                    }
	                    workingRange.moveToElementText(workingNode);
	                    comparison = workingRange.compareEndPoints(workingComparisonType, textRange);
	                    if (comparison == 0 || start == end) {
	                        break;
	                    } else if (comparison == -1) {
	                        if (end == start + 1) {
	                            // We know the endth child node is after the range boundary, so we must be done.
	                            break;
	                        } else {
	                            start = nodeIndex;
	                        }
	                    } else {
	                        end = (end == start + 1) ? start : nodeIndex;
	                    }
	                    nodeIndex = Math.floor((start + end) / 2);
	                    containerElement.removeChild(workingNode);
	                }
	
	
	                // We've now reached or gone past the boundary of the text range we're interested in
	                // so have identified the node we want
	                boundaryNode = workingNode.nextSibling;
	
	                if (comparison == -1 && boundaryNode && isCharacterDataNode(boundaryNode)) {
	                    // This is a character data node (text, comment, cdata). The working range is collapsed at the start of
	                    // the node containing the text range's boundary, so we move the end of the working range to the
	                    // boundary point and measure the length of its text to get the boundary's offset within the node.
	                    workingRange.setEndPoint(isStart ? "EndToStart" : "EndToEnd", textRange);
	
	                    var offset;
	
	                    if (/[\r\n]/.test(boundaryNode.data)) {
	                        /*
	                        For the particular case of a boundary within a text node containing rendered line breaks (within a
	                        <pre> element, for example), we need a slightly complicated approach to get the boundary's offset in
	                        IE. The facts:
	
	                        - Each line break is represented as \r in the text node's data/nodeValue properties
	                        - Each line break is represented as \r\n in the TextRange's 'text' property
	                        - The 'text' property of the TextRange does not contain trailing line breaks
	
	                        To get round the problem presented by the final fact above, we can use the fact that TextRange's
	                        moveStart() and moveEnd() methods return the actual number of characters moved, which is not
	                        necessarily the same as the number of characters it was instructed to move. The simplest approach is
	                        to use this to store the characters moved when moving both the start and end of the range to the
	                        start of the document body and subtracting the start offset from the end offset (the
	                        "move-negative-gazillion" method). However, this is extremely slow when the document is large and
	                        the range is near the end of it. Clearly doing the mirror image (i.e. moving the range boundaries to
	                        the end of the document) has the same problem.
	
	                        Another approach that works is to use moveStart() to move the start boundary of the range up to the
	                        end boundary one character at a time and incrementing a counter with the value returned by the
	                        moveStart() call. However, the check for whether the start boundary has reached the end boundary is
	                        expensive, so this method is slow (although unlike "move-negative-gazillion" is largely unaffected
	                        by the location of the range within the document).
	
	                        The approach used below is a hybrid of the two methods above. It uses the fact that a string
	                        containing the TextRange's 'text' property with each \r\n converted to a single \r character cannot
	                        be longer than the text of the TextRange, so the start of the range is moved that length initially
	                        and then a character at a time to make up for any trailing line breaks not contained in the 'text'
	                        property. This has good performance in most situations compared to the previous two methods.
	                        */
	                        var tempRange = workingRange.duplicate();
	                        var rangeLength = tempRange.text.replace(/\r\n/g, "\r").length;
	
	                        offset = tempRange.moveStart("character", rangeLength);
	                        while ( (comparison = tempRange.compareEndPoints("StartToEnd", tempRange)) == -1) {
	                            offset++;
	                            tempRange.moveStart("character", 1);
	                        }
	                    } else {
	                        offset = workingRange.text.length;
	                    }
	                    boundaryPosition = new DomPosition(boundaryNode, offset);
	                } else {
	
	                    // If the boundary immediately follows a character data node and this is the end boundary, we should favour
	                    // a position within that, and likewise for a start boundary preceding a character data node
	                    previousNode = (isCollapsed || !isStart) && workingNode.previousSibling;
	                    nextNode = (isCollapsed || isStart) && workingNode.nextSibling;
	                    if (nextNode && isCharacterDataNode(nextNode)) {
	                        boundaryPosition = new DomPosition(nextNode, 0);
	                    } else if (previousNode && isCharacterDataNode(previousNode)) {
	                        boundaryPosition = new DomPosition(previousNode, previousNode.data.length);
	                    } else {
	                        boundaryPosition = new DomPosition(containerElement, dom.getNodeIndex(workingNode));
	                    }
	                }
	
	                // Clean up
	                dom.removeNode(workingNode);
	
	                return {
	                    boundaryPosition: boundaryPosition,
	                    nodeInfo: {
	                        nodeIndex: nodeIndex,
	                        containerElement: containerElement
	                    }
	                };
	            };
	
	            // Returns a TextRange representing the boundary of a TextRange expressed as a node and an offset within that
	            // node. This function started out as an optimized version of code found in Tim Cameron Ryan's IERange
	            // (http://code.google.com/p/ierange/)
	            var createBoundaryTextRange = function(boundaryPosition, isStart) {
	                var boundaryNode, boundaryParent, boundaryOffset = boundaryPosition.offset;
	                var doc = dom.getDocument(boundaryPosition.node);
	                var workingNode, childNodes, workingRange = getBody(doc).createTextRange();
	                var nodeIsDataNode = isCharacterDataNode(boundaryPosition.node);
	
	                if (nodeIsDataNode) {
	                    boundaryNode = boundaryPosition.node;
	                    boundaryParent = boundaryNode.parentNode;
	                } else {
	                    childNodes = boundaryPosition.node.childNodes;
	                    boundaryNode = (boundaryOffset < childNodes.length) ? childNodes[boundaryOffset] : null;
	                    boundaryParent = boundaryPosition.node;
	                }
	
	                // Position the range immediately before the node containing the boundary
	                workingNode = doc.createElement("span");
	
	                // Making the working element non-empty element persuades IE to consider the TextRange boundary to be within
	                // the element rather than immediately before or after it
	                workingNode.innerHTML = "&#feff;";
	
	                // insertBefore is supposed to work like appendChild if the second parameter is null. However, a bug report
	                // for IERange suggests that it can crash the browser: http://code.google.com/p/ierange/issues/detail?id=12
	                if (boundaryNode) {
	                    boundaryParent.insertBefore(workingNode, boundaryNode);
	                } else {
	                    boundaryParent.appendChild(workingNode);
	                }
	
	                workingRange.moveToElementText(workingNode);
	                workingRange.collapse(!isStart);
	
	                // Clean up
	                boundaryParent.removeChild(workingNode);
	
	                // Move the working range to the text offset, if required
	                if (nodeIsDataNode) {
	                    workingRange[isStart ? "moveStart" : "moveEnd"]("character", boundaryOffset);
	                }
	
	                return workingRange;
	            };
	
	            /*------------------------------------------------------------------------------------------------------------*/
	
	            // This is a wrapper around a TextRange, providing full DOM Range functionality using rangy's DomRange as a
	            // prototype
	
	            WrappedTextRange = function(textRange) {
	                this.textRange = textRange;
	                this.refresh();
	            };
	
	            WrappedTextRange.prototype = new DomRange(document);
	
	            WrappedTextRange.prototype.refresh = function() {
	                var start, end, startBoundary;
	
	                // TextRange's parentElement() method cannot be trusted. getTextRangeContainerElement() works around that.
	                var rangeContainerElement = getTextRangeContainerElement(this.textRange);
	
	                if (textRangeIsCollapsed(this.textRange)) {
	                    end = start = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true,
	                        true).boundaryPosition;
	                } else {
	                    startBoundary = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true, false);
	                    start = startBoundary.boundaryPosition;
	
	                    // An optimization used here is that if the start and end boundaries have the same parent element, the
	                    // search scope for the end boundary can be limited to exclude the portion of the element that precedes
	                    // the start boundary
	                    end = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, false, false,
	                        startBoundary.nodeInfo).boundaryPosition;
	                }
	
	                this.setStart(start.node, start.offset);
	                this.setEnd(end.node, end.offset);
	            };
	
	            WrappedTextRange.prototype.getName = function() {
	                return "WrappedTextRange";
	            };
	
	            DomRange.copyComparisonConstants(WrappedTextRange);
	
	            var rangeToTextRange = function(range) {
	                if (range.collapsed) {
	                    return createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
	                } else {
	                    var startRange = createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
	                    var endRange = createBoundaryTextRange(new DomPosition(range.endContainer, range.endOffset), false);
	                    var textRange = getBody( DomRange.getRangeDocument(range) ).createTextRange();
	                    textRange.setEndPoint("StartToStart", startRange);
	                    textRange.setEndPoint("EndToEnd", endRange);
	                    return textRange;
	                }
	            };
	
	            WrappedTextRange.rangeToTextRange = rangeToTextRange;
	
	            WrappedTextRange.prototype.toTextRange = function() {
	                return rangeToTextRange(this);
	            };
	
	            api.WrappedTextRange = WrappedTextRange;
	
	            // IE 9 and above have both implementations and Rangy makes both available. The next few lines sets which
	            // implementation to use by default.
	            if (!api.features.implementsDomRange || api.config.preferTextRange) {
	                // Add WrappedTextRange as the Range property of the global object to allow expression like Range.END_TO_END to work
	                var globalObj = (function(f) { return f("return this;")(); })(Function);
	                if (typeof globalObj.Range == "undefined") {
	                    globalObj.Range = WrappedTextRange;
	                }
	
	                api.createNativeRange = function(doc) {
	                    doc = getContentDocument(doc, module, "createNativeRange");
	                    return getBody(doc).createTextRange();
	                };
	
	                api.WrappedRange = WrappedTextRange;
	            }
	        }
	
	        api.createRange = function(doc) {
	            doc = getContentDocument(doc, module, "createRange");
	            return new api.WrappedRange(api.createNativeRange(doc));
	        };
	
	        api.createRangyRange = function(doc) {
	            doc = getContentDocument(doc, module, "createRangyRange");
	            return new DomRange(doc);
	        };
	
	        util.createAliasForDeprecatedMethod(api, "createIframeRange", "createRange");
	        util.createAliasForDeprecatedMethod(api, "createIframeRangyRange", "createRangyRange");
	
	        api.addShimListener(function(win) {
	            var doc = win.document;
	            if (typeof doc.createRange == "undefined") {
	                doc.createRange = function() {
	                    return api.createRange(doc);
	                };
	            }
	            doc = win = null;
	        });
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // This module creates a selection object wrapper that conforms as closely as possible to the Selection specification
	    // in the W3C Selection API spec (https://www.w3.org/TR/selection-api)
	    api.createCoreModule("WrappedSelection", ["DomRange", "WrappedRange"], function(api, module) {
	        api.config.checkSelectionRanges = true;
	
	        var BOOLEAN = "boolean";
	        var NUMBER = "number";
	        var dom = api.dom;
	        var util = api.util;
	        var isHostMethod = util.isHostMethod;
	        var DomRange = api.DomRange;
	        var WrappedRange = api.WrappedRange;
	        var DOMException = api.DOMException;
	        var DomPosition = dom.DomPosition;
	        var getNativeSelection;
	        var selectionIsCollapsed;
	        var features = api.features;
	        var CONTROL = "Control";
	        var getDocument = dom.getDocument;
	        var getBody = dom.getBody;
	        var rangesEqual = DomRange.rangesEqual;
	
	
	        // Utility function to support direction parameters in the API that may be a string ("backward", "backwards",
	        // "forward" or "forwards") or a Boolean (true for backwards).
	        function isDirectionBackward(dir) {
	            return (typeof dir == "string") ? /^backward(s)?$/i.test(dir) : !!dir;
	        }
	
	        function getWindow(win, methodName) {
	            if (!win) {
	                return window;
	            } else if (dom.isWindow(win)) {
	                return win;
	            } else if (win instanceof WrappedSelection) {
	                return win.win;
	            } else {
	                var doc = dom.getContentDocument(win, module, methodName);
	                return dom.getWindow(doc);
	            }
	        }
	
	        function getWinSelection(winParam) {
	            return getWindow(winParam, "getWinSelection").getSelection();
	        }
	
	        function getDocSelection(winParam) {
	            return getWindow(winParam, "getDocSelection").document.selection;
	        }
	
	        function winSelectionIsBackward(sel) {
	            var backward = false;
	            if (sel.anchorNode) {
	                backward = (dom.comparePoints(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset) == 1);
	            }
	            return backward;
	        }
	
	        // Test for the Range/TextRange and Selection features required
	        // Test for ability to retrieve selection
	        var implementsWinGetSelection = isHostMethod(window, "getSelection"),
	            implementsDocSelection = util.isHostObject(document, "selection");
	
	        features.implementsWinGetSelection = implementsWinGetSelection;
	        features.implementsDocSelection = implementsDocSelection;
	
	        var useDocumentSelection = implementsDocSelection && (!implementsWinGetSelection || api.config.preferTextRange);
	
	        if (useDocumentSelection) {
	            getNativeSelection = getDocSelection;
	            api.isSelectionValid = function(winParam) {
	                var doc = getWindow(winParam, "isSelectionValid").document, nativeSel = doc.selection;
	
	                // Check whether the selection TextRange is actually contained within the correct document
	                return (nativeSel.type != "None" || getDocument(nativeSel.createRange().parentElement()) == doc);
	            };
	        } else if (implementsWinGetSelection) {
	            getNativeSelection = getWinSelection;
	            api.isSelectionValid = function() {
	                return true;
	            };
	        } else {
	            module.fail("Neither document.selection or window.getSelection() detected.");
	            return false;
	        }
	
	        api.getNativeSelection = getNativeSelection;
	
	        var testSelection = getNativeSelection();
	
	        // In Firefox, the selection is null in an iframe with display: none. See issue #138.
	        if (!testSelection) {
	            module.fail("Native selection was null (possibly issue 138?)");
	            return false;
	        }
	
	        var testRange = api.createNativeRange(document);
	        var body = getBody(document);
	
	        // Obtaining a range from a selection
	        var selectionHasAnchorAndFocus = util.areHostProperties(testSelection,
	            ["anchorNode", "focusNode", "anchorOffset", "focusOffset"]);
	
	        features.selectionHasAnchorAndFocus = selectionHasAnchorAndFocus;
	
	        // Test for existence of native selection extend() method
	        var selectionHasExtend = isHostMethod(testSelection, "extend");
	        features.selectionHasExtend = selectionHasExtend;
	
	        // Test for existence of native selection setBaseAndExtent() method
	        var selectionHasSetBaseAndExtent = isHostMethod(testSelection, "setBaseAndExtent");
	        features.selectionHasSetBaseAndExtent = selectionHasSetBaseAndExtent;
	
	        // Test if rangeCount exists
	        var selectionHasRangeCount = (typeof testSelection.rangeCount == NUMBER);
	        features.selectionHasRangeCount = selectionHasRangeCount;
	
	        var selectionSupportsMultipleRanges = false;
	        var collapsedNonEditableSelectionsSupported = true;
	
	        var addRangeBackwardToNative = selectionHasExtend ?
	            function(nativeSelection, range) {
	                var doc = DomRange.getRangeDocument(range);
	                var endRange = api.createRange(doc);
	                endRange.collapseToPoint(range.endContainer, range.endOffset);
	                nativeSelection.addRange(getNativeRange(endRange));
	                nativeSelection.extend(range.startContainer, range.startOffset);
	            } : null;
	
	        if (util.areHostMethods(testSelection, ["addRange", "getRangeAt", "removeAllRanges"]) &&
	                typeof testSelection.rangeCount == NUMBER && features.implementsDomRange) {
	
	            (function() {
	                // Previously an iframe was used but this caused problems in some circumstances in IE, so tests are
	                // performed on the current document's selection. See issue 109.
	
	                // Note also that if a selection previously existed, it is wiped and later restored by these tests. This
	                // will result in the selection direction being reversed if the original selection was backwards and the
	                // browser does not support setting backwards selections (Internet Explorer, I'm looking at you).
	                var sel = window.getSelection();
	                if (sel) {
	                    // Store the current selection
	                    var originalSelectionRangeCount = sel.rangeCount;
	                    var selectionHasMultipleRanges = (originalSelectionRangeCount > 1);
	                    var originalSelectionRanges = [];
	                    var originalSelectionBackward = winSelectionIsBackward(sel);
	                    for (var i = 0; i < originalSelectionRangeCount; ++i) {
	                        originalSelectionRanges[i] = sel.getRangeAt(i);
	                    }
	
	                    // Create some test elements
	                    var testEl = dom.createTestElement(document, "", false);
	                    var textNode = testEl.appendChild( document.createTextNode("\u00a0\u00a0\u00a0") );
	
	                    // Test whether the native selection will allow a collapsed selection within a non-editable element
	                    var r1 = document.createRange();
	
	                    r1.setStart(textNode, 1);
	                    r1.collapse(true);
	                    sel.removeAllRanges();
	                    sel.addRange(r1);
	                    collapsedNonEditableSelectionsSupported = (sel.rangeCount == 1);
	                    sel.removeAllRanges();
	
	                    // Test whether the native selection is capable of supporting multiple ranges.
	                    if (!selectionHasMultipleRanges) {
	                        // Doing the original feature test here in Chrome 36 (and presumably later versions) prints a
	                        // console error of "Discontiguous selection is not supported." that cannot be suppressed. There's
	                        // nothing we can do about this while retaining the feature test so we have to resort to a browser
	                        // sniff. I'm not happy about it. See
	                        // https://code.google.com/p/chromium/issues/detail?id=399791
	                        var chromeMatch = window.navigator.appVersion.match(/Chrome\/(.*?) /);
	                        if (chromeMatch && parseInt(chromeMatch[1]) >= 36) {
	                            selectionSupportsMultipleRanges = false;
	                        } else {
	                            var r2 = r1.cloneRange();
	                            r1.setStart(textNode, 0);
	                            r2.setEnd(textNode, 3);
	                            r2.setStart(textNode, 2);
	                            sel.addRange(r1);
	                            sel.addRange(r2);
	                            selectionSupportsMultipleRanges = (sel.rangeCount == 2);
	                        }
	                    }
	
	                    // Clean up
	                    dom.removeNode(testEl);
	                    sel.removeAllRanges();
	
	                    for (i = 0; i < originalSelectionRangeCount; ++i) {
	                        if (i == 0 && originalSelectionBackward) {
	                            if (addRangeBackwardToNative) {
	                                addRangeBackwardToNative(sel, originalSelectionRanges[i]);
	                            } else {
	                                api.warn("Rangy initialization: original selection was backwards but selection has been restored forwards because the browser does not support Selection.extend");
	                                sel.addRange(originalSelectionRanges[i]);
	                            }
	                        } else {
	                            sel.addRange(originalSelectionRanges[i]);
	                        }
	                    }
	                }
	            })();
	        }
	
	        features.selectionSupportsMultipleRanges = selectionSupportsMultipleRanges;
	        features.collapsedNonEditableSelectionsSupported = collapsedNonEditableSelectionsSupported;
	
	        // ControlRanges
	        var implementsControlRange = false, testControlRange;
	
	        if (body && isHostMethod(body, "createControlRange")) {
	            testControlRange = body.createControlRange();
	            if (util.areHostProperties(testControlRange, ["item", "add"])) {
	                implementsControlRange = true;
	            }
	        }
	        features.implementsControlRange = implementsControlRange;
	
	        // Selection collapsedness
	        if (selectionHasAnchorAndFocus) {
	            selectionIsCollapsed = function(sel) {
	                return sel.anchorNode === sel.focusNode && sel.anchorOffset === sel.focusOffset;
	            };
	        } else {
	            selectionIsCollapsed = function(sel) {
	                return sel.rangeCount ? sel.getRangeAt(sel.rangeCount - 1).collapsed : false;
	            };
	        }
	
	        function updateAnchorAndFocusFromRange(sel, range, backward) {
	            var anchorPrefix = backward ? "end" : "start", focusPrefix = backward ? "start" : "end";
	            sel.anchorNode = range[anchorPrefix + "Container"];
	            sel.anchorOffset = range[anchorPrefix + "Offset"];
	            sel.focusNode = range[focusPrefix + "Container"];
	            sel.focusOffset = range[focusPrefix + "Offset"];
	        }
	
	        function updateAnchorAndFocusFromNativeSelection(sel) {
	            var nativeSel = sel.nativeSelection;
	            sel.anchorNode = nativeSel.anchorNode;
	            sel.anchorOffset = nativeSel.anchorOffset;
	            sel.focusNode = nativeSel.focusNode;
	            sel.focusOffset = nativeSel.focusOffset;
	        }
	
	        function updateEmptySelection(sel) {
	            sel.anchorNode = sel.focusNode = null;
	            sel.anchorOffset = sel.focusOffset = 0;
	            sel.rangeCount = 0;
	            sel.isCollapsed = true;
	            sel._ranges.length = 0;
	            updateType(sel);
	        }
	
	        function updateType(sel) {
	            sel.type = (sel.rangeCount == 0) ? "None" : (selectionIsCollapsed(sel) ? "Caret" : "Range");
	        }
	
	        function getNativeRange(range) {
	            var nativeRange;
	            if (range instanceof DomRange) {
	                nativeRange = api.createNativeRange(range.getDocument());
	                nativeRange.setEnd(range.endContainer, range.endOffset);
	                nativeRange.setStart(range.startContainer, range.startOffset);
	            } else if (range instanceof WrappedRange) {
	                nativeRange = range.nativeRange;
	            } else if (features.implementsDomRange && (range instanceof dom.getWindow(range.startContainer).Range)) {
	                nativeRange = range;
	            }
	            return nativeRange;
	        }
	
	        function rangeContainsSingleElement(rangeNodes) {
	            if (!rangeNodes.length || rangeNodes[0].nodeType != 1) {
	                return false;
	            }
	            for (var i = 1, len = rangeNodes.length; i < len; ++i) {
	                if (!dom.isAncestorOf(rangeNodes[0], rangeNodes[i])) {
	                    return false;
	                }
	            }
	            return true;
	        }
	
	        function getSingleElementFromRange(range) {
	            var nodes = range.getNodes();
	            if (!rangeContainsSingleElement(nodes)) {
	                throw module.createError("getSingleElementFromRange: range " + range.inspect() + " did not consist of a single element");
	            }
	            return nodes[0];
	        }
	
	        // Simple, quick test which only needs to distinguish between a TextRange and a ControlRange
	        function isTextRange(range) {
	            return !!range && typeof range.text != "undefined";
	        }
	
	        function updateFromTextRange(sel, range) {
	            // Create a Range from the selected TextRange
	            var wrappedRange = new WrappedRange(range);
	            sel._ranges = [wrappedRange];
	
	            updateAnchorAndFocusFromRange(sel, wrappedRange, false);
	            sel.rangeCount = 1;
	            sel.isCollapsed = wrappedRange.collapsed;
	            updateType(sel);
	        }
	
	        function updateControlSelection(sel) {
	            // Update the wrapped selection based on what's now in the native selection
	            sel._ranges.length = 0;
	            if (sel.docSelection.type == "None") {
	                updateEmptySelection(sel);
	            } else {
	                var controlRange = sel.docSelection.createRange();
	                if (isTextRange(controlRange)) {
	                    // This case (where the selection type is "Control" and calling createRange() on the selection returns
	                    // a TextRange) can happen in IE 9. It happens, for example, when all elements in the selected
	                    // ControlRange have been removed from the ControlRange and removed from the document.
	                    updateFromTextRange(sel, controlRange);
	                } else {
	                    sel.rangeCount = controlRange.length;
	                    var range, doc = getDocument(controlRange.item(0));
	                    for (var i = 0; i < sel.rangeCount; ++i) {
	                        range = api.createRange(doc);
	                        range.selectNode(controlRange.item(i));
	                        sel._ranges.push(range);
	                    }
	                    sel.isCollapsed = sel.rangeCount == 1 && sel._ranges[0].collapsed;
	                    updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], false);
	                    updateType(sel);
	                }
	            }
	        }
	
	        function addRangeToControlSelection(sel, range) {
	            var controlRange = sel.docSelection.createRange();
	            var rangeElement = getSingleElementFromRange(range);
	
	            // Create a new ControlRange containing all the elements in the selected ControlRange plus the element
	            // contained by the supplied range
	            var doc = getDocument(controlRange.item(0));
	            var newControlRange = getBody(doc).createControlRange();
	            for (var i = 0, len = controlRange.length; i < len; ++i) {
	                newControlRange.add(controlRange.item(i));
	            }
	            try {
	                newControlRange.add(rangeElement);
	            } catch (ex) {
	                throw module.createError("addRange(): Element within the specified Range could not be added to control selection (does it have layout?)");
	            }
	            newControlRange.select();
	
	            // Update the wrapped selection based on what's now in the native selection
	            updateControlSelection(sel);
	        }
	
	        var getSelectionRangeAt;
	
	        if (isHostMethod(testSelection, "getRangeAt")) {
	            // try/catch is present because getRangeAt() must have thrown an error in some browser and some situation.
	            // Unfortunately, I didn't write a comment about the specifics and am now scared to take it out. Let that be a
	            // lesson to us all, especially me.
	            getSelectionRangeAt = function(sel, index) {
	                try {
	                    return sel.getRangeAt(index);
	                } catch (ex) {
	                    return null;
	                }
	            };
	        } else if (selectionHasAnchorAndFocus) {
	            getSelectionRangeAt = function(sel) {
	                var doc = getDocument(sel.anchorNode);
	                var range = api.createRange(doc);
	                range.setStartAndEnd(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset);
	
	                // Handle the case when the selection was selected backwards (from the end to the start in the
	                // document)
	                if (range.collapsed !== this.isCollapsed) {
	                    range.setStartAndEnd(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset);
	                }
	
	                return range;
	            };
	        }
	
	        function WrappedSelection(selection, docSelection, win) {
	            this.nativeSelection = selection;
	            this.docSelection = docSelection;
	            this._ranges = [];
	            this.win = win;
	            this.refresh();
	        }
	
	        WrappedSelection.prototype = api.selectionPrototype;
	
	        function deleteProperties(sel) {
	            sel.win = sel.anchorNode = sel.focusNode = sel._ranges = null;
	            sel.rangeCount = sel.anchorOffset = sel.focusOffset = 0;
	            sel.detached = true;
	            updateType(sel);
	        }
	
	        var cachedRangySelections = [];
	
	        function actOnCachedSelection(win, action) {
	            var i = cachedRangySelections.length, cached, sel;
	            while (i--) {
	                cached = cachedRangySelections[i];
	                sel = cached.selection;
	                if (action == "deleteAll") {
	                    deleteProperties(sel);
	                } else if (cached.win == win) {
	                    if (action == "delete") {
	                        cachedRangySelections.splice(i, 1);
	                        return true;
	                    } else {
	                        return sel;
	                    }
	                }
	            }
	            if (action == "deleteAll") {
	                cachedRangySelections.length = 0;
	            }
	            return null;
	        }
	
	        var getSelection = function(win) {
	            // Check if the parameter is a Rangy Selection object
	            if (win && win instanceof WrappedSelection) {
	                win.refresh();
	                return win;
	            }
	
	            win = getWindow(win, "getNativeSelection");
	
	            var sel = actOnCachedSelection(win);
	            var nativeSel = getNativeSelection(win), docSel = implementsDocSelection ? getDocSelection(win) : null;
	            if (sel) {
	                sel.nativeSelection = nativeSel;
	                sel.docSelection = docSel;
	                sel.refresh();
	            } else {
	                sel = new WrappedSelection(nativeSel, docSel, win);
	                cachedRangySelections.push( { win: win, selection: sel } );
	            }
	            return sel;
	        };
	
	        api.getSelection = getSelection;
	
	        util.createAliasForDeprecatedMethod(api, "getIframeSelection", "getSelection");
	
	        var selProto = WrappedSelection.prototype;
	
	        function createControlSelection(sel, ranges) {
	            // Ensure that the selection becomes of type "Control"
	            var doc = getDocument(ranges[0].startContainer);
	            var controlRange = getBody(doc).createControlRange();
	            for (var i = 0, el, len = ranges.length; i < len; ++i) {
	                el = getSingleElementFromRange(ranges[i]);
	                try {
	                    controlRange.add(el);
	                } catch (ex) {
	                    throw module.createError("setRanges(): Element within one of the specified Ranges could not be added to control selection (does it have layout?)");
	                }
	            }
	            controlRange.select();
	
	            // Update the wrapped selection based on what's now in the native selection
	            updateControlSelection(sel);
	        }
	
	        // Selecting a range
	        if (!useDocumentSelection && selectionHasAnchorAndFocus && util.areHostMethods(testSelection, ["removeAllRanges", "addRange"])) {
	            selProto.removeAllRanges = function() {
	                this.nativeSelection.removeAllRanges();
	                updateEmptySelection(this);
	            };
	
	            var addRangeBackward = function(sel, range) {
	                addRangeBackwardToNative(sel.nativeSelection, range);
	                sel.refresh();
	            };
	
	            if (selectionHasRangeCount) {
	                selProto.addRange = function(range, direction) {
	                    if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
	                        addRangeToControlSelection(this, range);
	                    } else {
	                        if (isDirectionBackward(direction) && selectionHasExtend) {
	                            addRangeBackward(this, range);
	                        } else {
	                            var previousRangeCount;
	                            if (selectionSupportsMultipleRanges) {
	                                previousRangeCount = this.rangeCount;
	                            } else {
	                                this.removeAllRanges();
	                                previousRangeCount = 0;
	                            }
	                            // Clone the native range so that changing the selected range does not affect the selection.
	                            // This is contrary to the spec but is the only way to achieve consistency between browsers. See
	                            // issue 80.
	                            var clonedNativeRange = getNativeRange(range).cloneRange();
	                            try {
	                                this.nativeSelection.addRange(clonedNativeRange);
	                            } catch (ex) {
	                            }
	
	                            // Check whether adding the range was successful
	                            this.rangeCount = this.nativeSelection.rangeCount;
	
	                            if (this.rangeCount == previousRangeCount + 1) {
	                                // The range was added successfully
	
	                                // Check whether the range that we added to the selection is reflected in the last range extracted from
	                                // the selection
	                                if (api.config.checkSelectionRanges) {
	                                    var nativeRange = getSelectionRangeAt(this.nativeSelection, this.rangeCount - 1);
	                                    if (nativeRange && !rangesEqual(nativeRange, range)) {
	                                        // Happens in WebKit with, for example, a selection placed at the start of a text node
	                                        range = new WrappedRange(nativeRange);
	                                    }
	                                }
	                                this._ranges[this.rangeCount - 1] = range;
	                                updateAnchorAndFocusFromRange(this, range, selectionIsBackward(this.nativeSelection));
	                                this.isCollapsed = selectionIsCollapsed(this);
	                                updateType(this);
	                            } else {
	                                // The range was not added successfully. The simplest thing is to refresh
	                                this.refresh();
	                            }
	                        }
	                    }
	                };
	            } else {
	                selProto.addRange = function(range, direction) {
	                    if (isDirectionBackward(direction) && selectionHasExtend) {
	                        addRangeBackward(this, range);
	                    } else {
	                        this.nativeSelection.addRange(getNativeRange(range));
	                        this.refresh();
	                    }
	                };
	            }
	
	            selProto.setRanges = function(ranges) {
	                if (implementsControlRange && implementsDocSelection && ranges.length > 1) {
	                    createControlSelection(this, ranges);
	                } else {
	                    this.removeAllRanges();
	                    for (var i = 0, len = ranges.length; i < len; ++i) {
	                        this.addRange(ranges[i]);
	                    }
	                }
	            };
	        } else if (isHostMethod(testSelection, "empty") && isHostMethod(testRange, "select") &&
	                   implementsControlRange && useDocumentSelection) {
	
	            selProto.removeAllRanges = function() {
	                // Added try/catch as fix for issue #21
	                try {
	                    this.docSelection.empty();
	
	                    // Check for empty() not working (issue #24)
	                    if (this.docSelection.type != "None") {
	                        // Work around failure to empty a control selection by instead selecting a TextRange and then
	                        // calling empty()
	                        var doc;
	                        if (this.anchorNode) {
	                            doc = getDocument(this.anchorNode);
	                        } else if (this.docSelection.type == CONTROL) {
	                            var controlRange = this.docSelection.createRange();
	                            if (controlRange.length) {
	                                doc = getDocument( controlRange.item(0) );
	                            }
	                        }
	                        if (doc) {
	                            var textRange = getBody(doc).createTextRange();
	                            textRange.select();
	                            this.docSelection.empty();
	                        }
	                    }
	                } catch(ex) {}
	                updateEmptySelection(this);
	            };
	
	            selProto.addRange = function(range) {
	                if (this.docSelection.type == CONTROL) {
	                    addRangeToControlSelection(this, range);
	                } else {
	                    api.WrappedTextRange.rangeToTextRange(range).select();
	                    this._ranges[0] = range;
	                    this.rangeCount = 1;
	                    this.isCollapsed = this._ranges[0].collapsed;
	                    updateAnchorAndFocusFromRange(this, range, false);
	                    updateType(this);
	                }
	            };
	
	            selProto.setRanges = function(ranges) {
	                this.removeAllRanges();
	                var rangeCount = ranges.length;
	                if (rangeCount > 1) {
	                    createControlSelection(this, ranges);
	                } else if (rangeCount) {
	                    this.addRange(ranges[0]);
	                }
	            };
	        } else {
	            module.fail("No means of selecting a Range or TextRange was found");
	            return false;
	        }
	
	        selProto.getRangeAt = function(index) {
	            if (index < 0 || index >= this.rangeCount) {
	                throw new DOMException("INDEX_SIZE_ERR");
	            } else {
	                // Clone the range to preserve selection-range independence. See issue 80.
	                return this._ranges[index].cloneRange();
	            }
	        };
	
	        var refreshSelection;
	
	        if (useDocumentSelection) {
	            refreshSelection = function(sel) {
	                var range;
	                if (api.isSelectionValid(sel.win)) {
	                    range = sel.docSelection.createRange();
	                } else {
	                    range = getBody(sel.win.document).createTextRange();
	                    range.collapse(true);
	                }
	
	                if (sel.docSelection.type == CONTROL) {
	                    updateControlSelection(sel);
	                } else if (isTextRange(range)) {
	                    updateFromTextRange(sel, range);
	                } else {
	                    updateEmptySelection(sel);
	                }
	            };
	        } else if (isHostMethod(testSelection, "getRangeAt") && typeof testSelection.rangeCount == NUMBER) {
	            refreshSelection = function(sel) {
	                if (implementsControlRange && implementsDocSelection && sel.docSelection.type == CONTROL) {
	                    updateControlSelection(sel);
	                } else {
	                    sel._ranges.length = sel.rangeCount = sel.nativeSelection.rangeCount;
	                    if (sel.rangeCount) {
	                        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	                            sel._ranges[i] = new api.WrappedRange(sel.nativeSelection.getRangeAt(i));
	                        }
	                        updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], selectionIsBackward(sel.nativeSelection));
	                        sel.isCollapsed = selectionIsCollapsed(sel);
	                        updateType(sel);
	                    } else {
	                        updateEmptySelection(sel);
	                    }
	                }
	            };
	        } else if (selectionHasAnchorAndFocus && typeof testSelection.isCollapsed == BOOLEAN && typeof testRange.collapsed == BOOLEAN && features.implementsDomRange) {
	            refreshSelection = function(sel) {
	                var range, nativeSel = sel.nativeSelection;
	                if (nativeSel.anchorNode) {
	                    range = getSelectionRangeAt(nativeSel, 0);
	                    sel._ranges = [range];
	                    sel.rangeCount = 1;
	                    updateAnchorAndFocusFromNativeSelection(sel);
	                    sel.isCollapsed = selectionIsCollapsed(sel);
	                    updateType(sel);
	                } else {
	                    updateEmptySelection(sel);
	                }
	            };
	        } else {
	            module.fail("No means of obtaining a Range or TextRange from the user's selection was found");
	            return false;
	        }
	
	        selProto.refresh = function(checkForChanges) {
	            var oldRanges = checkForChanges ? this._ranges.slice(0) : null;
	            var oldAnchorNode = this.anchorNode, oldAnchorOffset = this.anchorOffset;
	
	            refreshSelection(this);
	            if (checkForChanges) {
	                // Check the range count first
	                var i = oldRanges.length;
	                if (i != this._ranges.length) {
	                    return true;
	                }
	
	                // Now check the direction. Checking the anchor position is the same is enough since we're checking all the
	                // ranges after this
	                if (this.anchorNode != oldAnchorNode || this.anchorOffset != oldAnchorOffset) {
	                    return true;
	                }
	
	                // Finally, compare each range in turn
	                while (i--) {
	                    if (!rangesEqual(oldRanges[i], this._ranges[i])) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	        };
	
	        // Removal of a single range
	        var removeRangeManually = function(sel, range) {
	            var ranges = sel.getAllRanges();
	            sel.removeAllRanges();
	            for (var i = 0, len = ranges.length; i < len; ++i) {
	                if (!rangesEqual(range, ranges[i])) {
	                    sel.addRange(ranges[i]);
	                }
	            }
	            if (!sel.rangeCount) {
	                updateEmptySelection(sel);
	            }
	        };
	
	        if (implementsControlRange && implementsDocSelection) {
	            selProto.removeRange = function(range) {
	                if (this.docSelection.type == CONTROL) {
	                    var controlRange = this.docSelection.createRange();
	                    var rangeElement = getSingleElementFromRange(range);
	
	                    // Create a new ControlRange containing all the elements in the selected ControlRange minus the
	                    // element contained by the supplied range
	                    var doc = getDocument(controlRange.item(0));
	                    var newControlRange = getBody(doc).createControlRange();
	                    var el, removed = false;
	                    for (var i = 0, len = controlRange.length; i < len; ++i) {
	                        el = controlRange.item(i);
	                        if (el !== rangeElement || removed) {
	                            newControlRange.add(controlRange.item(i));
	                        } else {
	                            removed = true;
	                        }
	                    }
	                    newControlRange.select();
	
	                    // Update the wrapped selection based on what's now in the native selection
	                    updateControlSelection(this);
	                } else {
	                    removeRangeManually(this, range);
	                }
	            };
	        } else {
	            selProto.removeRange = function(range) {
	                removeRangeManually(this, range);
	            };
	        }
	
	        // Detecting if a selection is backward
	        var selectionIsBackward;
	        if (!useDocumentSelection && selectionHasAnchorAndFocus && features.implementsDomRange) {
	            selectionIsBackward = winSelectionIsBackward;
	
	            selProto.isBackward = function() {
	                return selectionIsBackward(this);
	            };
	        } else {
	            selectionIsBackward = selProto.isBackward = function() {
	                return false;
	            };
	        }
	
	        // Create an alias for backwards compatibility. From 1.3, everything is "backward" rather than "backwards"
	        selProto.isBackwards = selProto.isBackward;
	
	        // Selection stringifier
	        // This is conformant to the old HTML5 selections draft spec but differs from WebKit and Mozilla's implementation.
	        // The current spec does not yet define this method.
	        selProto.toString = function() {
	            var rangeTexts = [];
	            for (var i = 0, len = this.rangeCount; i < len; ++i) {
	                rangeTexts[i] = "" + this._ranges[i];
	            }
	            return rangeTexts.join("");
	        };
	
	        function assertNodeInSameDocument(sel, node) {
	            if (sel.win.document != getDocument(node)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	        }
	
	        function assertValidOffset(node, offset) {
	            if (offset < 0 || offset > (dom.isCharacterDataNode(node) ? node.length : node.childNodes.length)) {
	                throw new DOMException("INDEX_SIZE_ERR");
	            }
	        }
	
	        // No current browser conforms fully to the spec for this method, so Rangy's own method is always used
	        selProto.collapse = function(node, offset) {
	            assertNodeInSameDocument(this, node);
	            var range = api.createRange(node);
	            range.collapseToPoint(node, offset);
	            this.setSingleRange(range);
	            this.isCollapsed = true;
	        };
	
	        selProto.collapseToStart = function() {
	            if (this.rangeCount) {
	                var range = this._ranges[0];
	                this.collapse(range.startContainer, range.startOffset);
	            } else {
	                throw new DOMException("INVALID_STATE_ERR");
	            }
	        };
	
	        selProto.collapseToEnd = function() {
	            if (this.rangeCount) {
	                var range = this._ranges[this.rangeCount - 1];
	                this.collapse(range.endContainer, range.endOffset);
	            } else {
	                throw new DOMException("INVALID_STATE_ERR");
	            }
	        };
	
	        // The spec is very specific on how selectAllChildren should be implemented and not all browsers implement it as
	        // specified so the native implementation is never used by Rangy.
	        selProto.selectAllChildren = function(node) {
	            assertNodeInSameDocument(this, node);
	            var range = api.createRange(node);
	            range.selectNodeContents(node);
	            this.setSingleRange(range);
	        };
	
	        if (selectionHasSetBaseAndExtent) {
	            selProto.setBaseAndExtent = function(anchorNode, anchorOffset, focusNode, focusOffset) {
	                this.nativeSelection.setBaseAndExtent(anchorNode, anchorOffset, focusNode, focusOffset);
	                this.refresh();
	            };
	        } else if (selectionHasExtend) {
	            selProto.setBaseAndExtent = function(anchorNode, anchorOffset, focusNode, focusOffset) {
	                assertValidOffset(anchorNode, anchorOffset);
	                assertValidOffset(focusNode, focusOffset);
	                assertNodeInSameDocument(this, anchorNode);
	                assertNodeInSameDocument(this, focusNode);
	                var range = api.createRange(node);
	                var isBackwards = (dom.comparePoints(anchorNode, anchorOffset, focusNode, focusOffset) == -1);
	                if (isBackwards) {
	                    range.setStartAndEnd(focusNode, focusOffset, anchorNode, anchorOffset);
	                } else {
	                    range.setStartAndEnd(anchorNode, anchorOffset, focusNode, focusOffset);
	                }
	                this.setSingleRange(range, isBackwards);
	            };
	        }
	
	        selProto.deleteFromDocument = function() {
	            // Sepcial behaviour required for IE's control selections
	            if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
	                var controlRange = this.docSelection.createRange();
	                var element;
	                while (controlRange.length) {
	                    element = controlRange.item(0);
	                    controlRange.remove(element);
	                    dom.removeNode(element);
	                }
	                this.refresh();
	            } else if (this.rangeCount) {
	                var ranges = this.getAllRanges();
	                if (ranges.length) {
	                    this.removeAllRanges();
	                    for (var i = 0, len = ranges.length; i < len; ++i) {
	                        ranges[i].deleteContents();
	                    }
	                    // The spec says nothing about what the selection should contain after calling deleteContents on each
	                    // range. Firefox moves the selection to where the final selected range was, so we emulate that
	                    this.addRange(ranges[len - 1]);
	                }
	            }
	        };
	
	        // The following are non-standard extensions
	        selProto.eachRange = function(func, returnValue) {
	            for (var i = 0, len = this._ranges.length; i < len; ++i) {
	                if ( func( this.getRangeAt(i) ) ) {
	                    return returnValue;
	                }
	            }
	        };
	
	        selProto.getAllRanges = function() {
	            var ranges = [];
	            this.eachRange(function(range) {
	                ranges.push(range);
	            });
	            return ranges;
	        };
	
	        selProto.setSingleRange = function(range, direction) {
	            this.removeAllRanges();
	            this.addRange(range, direction);
	        };
	
	        selProto.callMethodOnEachRange = function(methodName, params) {
	            var results = [];
	            this.eachRange( function(range) {
	                results.push( range[methodName].apply(range, params || []) );
	            } );
	            return results;
	        };
	
	        function createStartOrEndSetter(isStart) {
	            return function(node, offset) {
	                var range;
	                if (this.rangeCount) {
	                    range = this.getRangeAt(0);
	                    range["set" + (isStart ? "Start" : "End")](node, offset);
	                } else {
	                    range = api.createRange(this.win.document);
	                    range.setStartAndEnd(node, offset);
	                }
	                this.setSingleRange(range, this.isBackward());
	            };
	        }
	
	        selProto.setStart = createStartOrEndSetter(true);
	        selProto.setEnd = createStartOrEndSetter(false);
	
	        // Add select() method to Range prototype. Any existing selection will be removed.
	        api.rangePrototype.select = function(direction) {
	            getSelection( this.getDocument() ).setSingleRange(this, direction);
	        };
	
	        selProto.changeEachRange = function(func) {
	            var ranges = [];
	            var backward = this.isBackward();
	
	            this.eachRange(function(range) {
	                func(range);
	                ranges.push(range);
	            });
	
	            this.removeAllRanges();
	            if (backward && ranges.length == 1) {
	                this.addRange(ranges[0], "backward");
	            } else {
	                this.setRanges(ranges);
	            }
	        };
	
	        selProto.containsNode = function(node, allowPartial) {
	            return this.eachRange( function(range) {
	                return range.containsNode(node, allowPartial);
	            }, true ) || false;
	        };
	
	        selProto.getBookmark = function(containerNode) {
	            return {
	                backward: this.isBackward(),
	                rangeBookmarks: this.callMethodOnEachRange("getBookmark", [containerNode])
	            };
	        };
	
	        selProto.moveToBookmark = function(bookmark) {
	            var selRanges = [];
	            for (var i = 0, rangeBookmark, range; rangeBookmark = bookmark.rangeBookmarks[i++]; ) {
	                range = api.createRange(this.win);
	                range.moveToBookmark(rangeBookmark);
	                selRanges.push(range);
	            }
	            if (bookmark.backward) {
	                this.setSingleRange(selRanges[0], "backward");
	            } else {
	                this.setRanges(selRanges);
	            }
	        };
	
	        selProto.saveRanges = function() {
	            return {
	                backward: this.isBackward(),
	                ranges: this.callMethodOnEachRange("cloneRange")
	            };
	        };
	
	        selProto.restoreRanges = function(selRanges) {
	            this.removeAllRanges();
	            for (var i = 0, range; range = selRanges.ranges[i]; ++i) {
	                this.addRange(range, (selRanges.backward && i == 0));
	            }
	        };
	
	        selProto.toHtml = function() {
	            var rangeHtmls = [];
	            this.eachRange(function(range) {
	                rangeHtmls.push( DomRange.toHtml(range) );
	            });
	            return rangeHtmls.join("");
	        };
	
	        if (features.implementsTextRange) {
	            selProto.getNativeTextRange = function() {
	                var sel, textRange;
	                if ( (sel = this.docSelection) ) {
	                    var range = sel.createRange();
	                    if (isTextRange(range)) {
	                        return range;
	                    } else {
	                        throw module.createError("getNativeTextRange: selection is a control selection");
	                    }
	                } else if (this.rangeCount > 0) {
	                    return api.WrappedTextRange.rangeToTextRange( this.getRangeAt(0) );
	                } else {
	                    throw module.createError("getNativeTextRange: selection contains no range");
	                }
	            };
	        }
	
	        function inspect(sel) {
	            var rangeInspects = [];
	            var anchor = new DomPosition(sel.anchorNode, sel.anchorOffset);
	            var focus = new DomPosition(sel.focusNode, sel.focusOffset);
	            var name = (typeof sel.getName == "function") ? sel.getName() : "Selection";
	
	            if (typeof sel.rangeCount != "undefined") {
	                for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	                    rangeInspects[i] = DomRange.inspect(sel.getRangeAt(i));
	                }
	            }
	            return "[" + name + "(Ranges: " + rangeInspects.join(", ") +
	                    ")(anchor: " + anchor.inspect() + ", focus: " + focus.inspect() + "]";
	        }
	
	        selProto.getName = function() {
	            return "WrappedSelection";
	        };
	
	        selProto.inspect = function() {
	            return inspect(this);
	        };
	
	        selProto.detach = function() {
	            actOnCachedSelection(this.win, "delete");
	            deleteProperties(this);
	        };
	
	        WrappedSelection.detachAll = function() {
	            actOnCachedSelection(null, "deleteAll");
	        };
	
	        WrappedSelection.inspect = inspect;
	        WrappedSelection.isDirectionBackward = isDirectionBackward;
	
	        api.Selection = WrappedSelection;
	
	        api.selectionPrototype = selProto;
	
	        api.addShimListener(function(win) {
	            if (typeof win.getSelection == "undefined") {
	                win.getSelection = function() {
	                    return getSelection(win);
	                };
	            }
	            win = null;
	        });
	    });
	    
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Wait for document to load before initializing
	    var docReady = false;
	
	    var loadHandler = function(e) {
	        if (!docReady) {
	            docReady = true;
	            if (!api.initialized && api.config.autoInitialize) {
	                init();
	            }
	        }
	    };
	
	    if (isBrowser) {
	        // Test whether the document has already been loaded and initialize immediately if so
	        if (document.readyState == "complete") {
	            loadHandler();
	        } else {
	            if (isHostMethod(document, "addEventListener")) {
	                document.addEventListener("DOMContentLoaded", loadHandler, false);
	            }
	
	            // Add a fallback in case the DOMContentLoaded event isn't supported
	            addListener(window, "load", loadHandler);
	        }
	    }
	
	    return api;
	}, this);

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <div class=\"modal-header\">\n    <h3 class=\"text-center\" style=\"margin-top:10px\">\n      Welcome to LexStep!\n    </h3>\n    <h5 class=\"text-center\">\n      Help LexStep learn your personal preferences to find and match\n    </h5>\n    <h5 class=\"text-center\">\n      you with the most relevant opportunities in the market:\n    </h5>\n  </div>\n\n  <div class=\"modal-body\">\n    <div style=\"padding: 0px 20px 20px 20px; margin-top: -25px;\">\n      <div class=\"row margin-t20\">\n        <strong>\n          Contract Preferences\n        </strong>\n      </div>\n\n      <div class=\"row\">\n        <span>Select the type of Contract you would be open to:</span>\n        <div class=\"margin-t10\">\n          <table>\n            <tr\n              ng-repeat=\"contract in ctrl.contractsFilterData\"\n              ng-switch\n              on=\"$index % 2\"\n            >\n              <td ng-switch-when=\"0\">\n                <label class=\"ui-checkbox\">\n                  <input\n                    class=\"form-check-input\"\n                    type=\"checkbox\"\n                    ng-value=\"true\"\n                    ng-model=\"ctrl.contractsFilterData[$index].ticked\"\n                    id=\"ctrl.contractsFilterData[$index].id\"\n                  />\n                  <span>{{ctrl.contractsFilterData[$index].name}}</span>\n                </label>\n              </td>\n              <td ng-switch-when=\"0\">\n                <span ng-show=\"ctrl.contractsFilterData[$index+1]\">\n                  <label class=\"ui-checkbox\">\n                    <input\n                      class=\"form-check-input\"\n                      type=\"checkbox\"\n                      ng-value=\"true\"\n                      ng-model=\"ctrl.contractsFilterData[$index+1].ticked\"\n                      id=\"ctrl.contractsFilterData[$index+1].id\"\n                    />\n                    <span>{{ctrl.contractsFilterData[$index+1].name}}</span>\n                  </label>\n                </span>\n              </td>\n            </tr>\n          </table>\n        </div>\n      </div>\n\n      <div class=\"row margin-t20\">\n        <strong>\n          Role Preferences\n        </strong>\n      </div>\n\n      <div class=\"row\">\n        <span>Select the type of Role you would be open to:</span>\n        <div class=\"margin-t10\">\n          <table>\n            <tr\n              ng-repeat=\"contract in ctrl.occupationsFilterData\"\n              ng-switch\n              on=\"$index % 2\"\n            >\n              <td ng-switch-when=\"0\">\n                <label class=\"ui-checkbox\">\n                  <input\n                    class=\"form-check-input\"\n                    type=\"checkbox\"\n                    ng-value=\"true\"\n                    ng-model=\"ctrl.occupationsFilterData[$index].ticked\"\n                    id=\"ctrl.occupationsFilterData[$index].id\"\n                  />\n                  <span>{{ctrl.occupationsFilterData[$index].name}}</span>\n                </label>\n              </td>\n              <td ng-switch-when=\"0\">\n                <span ng-show=\"ctrl.occupationsFilterData[$index+1]\">\n                  <label class=\"ui-checkbox\">\n                    <input\n                      class=\"form-check-input\"\n                      type=\"checkbox\"\n                      ng-value=\"true\"\n                      ng-model=\"ctrl.occupationsFilterData[$index+1].ticked\"\n                      id=\"ctrl.occupationsFilterData[$index+1].id\"\n                    />\n                    <span>{{ctrl.occupationsFilterData[$index+1].name}}</span>\n                  </label>\n                </span>\n              </td>\n            </tr>\n          </table>\n        </div>\n      </div>\n\n      <div class=\"row margin-t20\">\n        <strong>\n          Employer Preferences\n        </strong>\n      </div>\n\n      <div class=\"row\">\n        <span>Select the type of Employer you would be open to:</span>\n        <div class=\"margin-t10\">\n          <table>\n            <tr\n              ng-repeat=\"employerType in ctrl.employerTypeFilterData\"\n              ng-switch\n              on=\"$index % 2\"\n            >\n              <td ng-switch-when=\"0\">\n                <label class=\"ui-checkbox\">\n                  <input\n                    class=\"form-check-input\"\n                    type=\"checkbox\"\n                    ng-value=\"true\"\n                    ng-model=\"ctrl.employerTypeFilterData[$index].ticked\"\n                    id=\"ctrl.employerTypeFilterData[$index].id\"\n                  />\n                  <span>{{ctrl.employerTypeFilterData[$index].name}}</span>\n                </label>\n              </td>\n              <td ng-switch-when=\"0\">\n                <span ng-show=\"ctrl.employerTypeFilterData[$index+1]\">\n                  <label class=\"ui-checkbox\">\n                    <input\n                      class=\"form-check-input\"\n                      type=\"checkbox\"\n                      ng-value=\"true\"\n                      ng-model=\"ctrl.employerTypeFilterData[$index+1].ticked\"\n                      id=\"ctrl.employerTypeFilterData[$index+1].id\"\n                    />\n                    <span>{{ctrl.employerTypeFilterData[$index+1].name}}</span>\n                  </label>\n                </span>\n              </td>\n            </tr>\n          </table>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"modal-footer-apply-job\">\n    <center>\n      <button class=\"btn btn-info\" ng-click=\"ctrl.updateCandidatePreference()\">\n        See My Matches\n      </button>\n    </center>\n  </div>\n</div>\n"

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	var settle = __webpack_require__(509);
	var cookies = __webpack_require__(512);
	var buildURL = __webpack_require__(177);
	var buildFullPath = __webpack_require__(172);
	var parseHeaders = __webpack_require__(518);
	var isURLSameOrigin = __webpack_require__(515);
	var transitionalDefaults = __webpack_require__(174);
	var AxiosError = __webpack_require__(67);
	var CanceledError = __webpack_require__(88);
	var parseProtocol = __webpack_require__(519);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	    var responseType = config.responseType;
	    var onCanceled;
	    function done() {
	      if (config.cancelToken) {
	        config.cancelToken.unsubscribe(onCanceled);
	      }
	
	      if (config.signal) {
	        config.signal.removeEventListener('abort', onCanceled);
	      }
	    }
	
	    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    var fullPath = buildFullPath(config.baseURL, config.url);
	
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    function onloadend() {
	      if (!request) {
	        return;
	      }
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
	        request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(function _resolve(value) {
	        resolve(value);
	        done();
	      }, function _reject(err) {
	        reject(err);
	        done();
	      }, response);
	
	      // Clean up request
	      request = null;
	    }
	
	    if ('onloadend' in request) {
	      // Use onloadend if available
	      request.onloadend = onloadend;
	    } else {
	      // Listen for ready state to emulate onloadend
	      request.onreadystatechange = function handleLoad() {
	        if (!request || request.readyState !== 4) {
	          return;
	        }
	
	        // The request errored out and we didn't get a response, this will be
	        // handled by onerror instead
	        // With one exception: request that using file: protocol, most browsers
	        // will return status as 0 even though it's a successful request
	        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	          return;
	        }
	        // readystate handler is calling before onerror or ontimeout handlers,
	        // so we should call onloadend on the next 'tick'
	        setTimeout(onloadend);
	      };
	    }
	
	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }
	
	      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
	      var transitional = config.transitional || transitionalDefaults;
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(new AxiosError(
	        timeoutErrorMessage,
	        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
	        config,
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }
	
	    // Add responseType to request if needed
	    if (responseType && responseType !== 'json') {
	      request.responseType = config.responseType;
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken || config.signal) {
	      // Handle cancellation
	      // eslint-disable-next-line func-names
	      onCanceled = function(cancel) {
	        if (!request) {
	          return;
	        }
	        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
	        request.abort();
	        request = null;
	      };
	
	      config.cancelToken && config.cancelToken.subscribe(onCanceled);
	      if (config.signal) {
	        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
	      }
	    }
	
	    if (!requestData) {
	      requestData = null;
	    }
	
	    var protocol = parseProtocol(fullPath);
	
	    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
	      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
	      return;
	    }
	
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 171 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isAbsoluteURL = __webpack_require__(513);
	var combineURLs = __webpack_require__(511);
	
	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	module.exports = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */
	module.exports = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	
	  function getMergedValue(target, source) {
	    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
	      return utils.merge(target, source);
	    } else if (utils.isPlainObject(source)) {
	      return utils.merge({}, source);
	    } else if (utils.isArray(source)) {
	      return source.slice();
	    }
	    return source;
	  }
	
	  // eslint-disable-next-line consistent-return
	  function mergeDeepProperties(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      return getMergedValue(config1[prop], config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  // eslint-disable-next-line consistent-return
	  function valueFromConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      return getMergedValue(undefined, config2[prop]);
	    }
	  }
	
	  // eslint-disable-next-line consistent-return
	  function defaultToConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      return getMergedValue(undefined, config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  // eslint-disable-next-line consistent-return
	  function mergeDirectKeys(prop) {
	    if (prop in config2) {
	      return getMergedValue(config1[prop], config2[prop]);
	    } else if (prop in config1) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  var mergeMap = {
	    'url': valueFromConfig2,
	    'method': valueFromConfig2,
	    'data': valueFromConfig2,
	    'baseURL': defaultToConfig2,
	    'transformRequest': defaultToConfig2,
	    'transformResponse': defaultToConfig2,
	    'paramsSerializer': defaultToConfig2,
	    'timeout': defaultToConfig2,
	    'timeoutMessage': defaultToConfig2,
	    'withCredentials': defaultToConfig2,
	    'adapter': defaultToConfig2,
	    'responseType': defaultToConfig2,
	    'xsrfCookieName': defaultToConfig2,
	    'xsrfHeaderName': defaultToConfig2,
	    'onUploadProgress': defaultToConfig2,
	    'onDownloadProgress': defaultToConfig2,
	    'decompress': defaultToConfig2,
	    'maxContentLength': defaultToConfig2,
	    'maxBodyLength': defaultToConfig2,
	    'beforeRedirect': defaultToConfig2,
	    'transport': defaultToConfig2,
	    'httpAgent': defaultToConfig2,
	    'httpsAgent': defaultToConfig2,
	    'cancelToken': defaultToConfig2,
	    'socketPath': defaultToConfig2,
	    'responseEncoding': defaultToConfig2,
	    'validateStatus': mergeDirectKeys
	  };
	
	  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
	    var merge = mergeMap[prop] || mergeDeepProperties;
	    var configValue = merge(prop);
	    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
	  });
	
	  return config;
	};


/***/ }),
/* 174 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  silentJSONParsing: true,
	  forcedJSONParsing: true,
	  clarifyTimeoutError: false
	};


/***/ }),
/* 175 */
/***/ (function(module, exports) {

	module.exports = {
	  "version": "0.27.2"
	};

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');
	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }
	
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var utils = __webpack_require__(17);
	
	/**
	 * Convert a data object to FormData
	 * @param {Object} obj
	 * @param {?Object} [formData]
	 * @returns {Object}
	 **/
	
	function toFormData(obj, formData) {
	  // eslint-disable-next-line no-param-reassign
	  formData = formData || new FormData();
	
	  var stack = [];
	
	  function convertValue(value) {
	    if (value === null) return '';
	
	    if (utils.isDate(value)) {
	      return value.toISOString();
	    }
	
	    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
	      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
	    }
	
	    return value;
	  }
	
	  function build(data, parentKey) {
	    if (utils.isPlainObject(data) || utils.isArray(data)) {
	      if (stack.indexOf(data) !== -1) {
	        throw Error('Circular reference detected in ' + parentKey);
	      }
	
	      stack.push(data);
	
	      utils.forEach(data, function each(value, key) {
	        if (utils.isUndefined(value)) return;
	        var fullKey = parentKey ? parentKey + '.' + key : key;
	        var arr;
	
	        if (value && !parentKey && typeof value === 'object') {
	          if (utils.endsWith(key, '{}')) {
	            // eslint-disable-next-line no-param-reassign
	            value = JSON.stringify(value);
	          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
	            // eslint-disable-next-line func-names
	            arr.forEach(function(el) {
	              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
	            });
	            return;
	          }
	        }
	
	        build(value, fullKey);
	      });
	
	      stack.pop();
	    } else {
	      formData.append(parentKey, convertValue(data));
	    }
	  }
	
	  build(obj);
	
	  return formData;
	}
	
	module.exports = toFormData;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(773).Buffer))

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CandidateProfileDirectiveController = undefined;
	
	var _formatPqe = __webpack_require__(55);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var CandidateProfileDirectiveController = exports.CandidateProfileDirectiveController = function CandidateProfileDirectiveController($scope, userService, CandidateProfileApi, PreferencesApi, $modal, $location, usSpinnerService, SharedApi, socket, logger, $rootScope, api, $interval
	// $timeout
	) {
	  var getCandidateProfile = function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	      var _ref4, data;
	
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.next = 2;
	              return CandidateProfileApi.getUserProfile($scope.currentCandidate);
	
	            case 2:
	              _ref4 = _context3.sent;
	              data = _ref4.data;
	
	              $scope.candidate = data;
	              _context3.next = 7;
	              return SharedApi.getReferrer($scope.currentCandidate);
	
	            case 7:
	              $scope.referrerName = _context3.sent;
	
	            case 8:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, this);
	    }));
	
	    return function getCandidateProfile() {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  var getPreferences = function () {
	    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
	      var lowerEmail, gravatarHash, gravatarUrl;
	      return regeneratorRuntime.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _context4.next = 2;
	              return Promise.all([PreferencesApi.getCategoryById(1), PreferencesApi.getCategoryById(2), PreferencesApi.getCategoryById(3), PreferencesApi.getLocations(), PreferencesApi.getLanguages(), PreferencesApi.getContractTypes(), PreferencesApi.getOccupationsByProfession('law'), CandidateProfileApi.getUserResumes($scope.currentCandidate), SharedApi.getAllSchools(), SharedApi.getAllNationalities()]).then(function (result) {
	                $scope.legalPracticeAreas = result[0].data.specialties;
	                $scope.legalEmployerType = result[1].data.specialties;
	                $scope.legalJurisdiction = result[2].data.specialties;
	                $scope.locations = result[3].data;
	                $scope.languages = result[4].data;
	                $scope.contractTypes = result[5].data;
	                $scope.occupations = result[6].data;
	                $scope.candidate.resumes = result[7].data;
	                $scope.schoolList = result[8].data;
	                $scope.nationalitiesList = result[9].data.map(function (nationality) {
	                  return {
	                    code: nationality.code,
	                    name: nationality.demonyms[0]
	                  };
	                }).filter(function (nationality) {
	                  return nationality.name;
	                });
	                var school = $scope.schoolList.find(function (x) {
	                  return x.id === $scope.candidate.schoolId;
	                });
	                var schoolName = school && school.name ? school.name : 'n/a';
	                $scope.schoolName = schoolName;
	              }, function (error) {
	                console.error('Error loading candidate profile: ' + error);
	              });
	
	            case 2:
	              lowerEmail = $scope.candidate.user.email && $scope.candidate.user.email.trim().toLowerCase();
	              // eslint-disable-next-line no-undef
	
	              gravatarHash = lowerEmail && SparkMD5.hash(lowerEmail);
	              gravatarUrl = gravatarHash ? 'https://www.gravatar.com/avatar/' + gravatarHash + '?s=400&d=retro' : 'images/defaultPic.jpg';
	
	
	              if ($scope.user.isAdmin) $scope.candidate.isAdminProfile = true;
	              if ($scope.candidate.user.profilePicture && $scope.candidate.user.profilePicture.contains('https://')) $scope.candidate.user.logoSrc = $scope.candidate.user.profilePicture;else if ($scope.candidate.user.profilePicture) $scope.candidate.user.logoSrc = ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/user/' + $scope.candidate.id + '/photo/' + $scope.candidate.user.profilePicture;else $scope.candidate.user.logoSrc = gravatarUrl;
	              getCandidateLanguages();
	              getCandidateLastConversation();
	
	            case 9:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, this);
	    }));
	
	    return function getPreferences() {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	
	  var initializeProfile = function () {
	    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
	      var candidateEmployerTypes, candidateJurisdictions;
	      return regeneratorRuntime.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              _context6.next = 2;
	              return userService.getUser();
	
	            case 2:
	              $scope.user = _context6.sent;
	              _context6.next = 5;
	              return getCandidateProfile();
	
	            case 5:
	              _context6.next = 7;
	              return getPreferences();
	
	            case 7:
	              $scope.candidate.nationality = $scope.candidate.nationalities && $scope.candidate.nationalities.length > 0 ? $scope.candidate.nationalities.map(function (nationality) {
	                return {
	                  code: nationality.code,
	                  name: nationality.demonyms[0]
	                };
	              }).find(function (nationality) {
	                return nationality.name;
	              }) : undefined;
	
	              $scope.candidate.candidateEducation = $scope.candidate.school && $scope.candidate.school.name;
	              $scope.candidate.linkedInData = JSON.parse($scope.candidate.linkedinData);
	
	              // Preferences data
	
	              candidateEmployerTypes = $scope.candidate.category && $scope.candidate.category.find(function (category) {
	                return category.id === 2;
	              }).specialties;
	
	              $scope.candidate.legalEmployerTypes = $scope.legalEmployerType && $scope.legalEmployerType.map(function (employerType) {
	                return Object.assign({
	                  isSelected: Boolean(candidateEmployerTypes.find(function (candidateEmployerType) {
	                    return candidateEmployerType.id === employerType.id;
	                  }))
	                }, employerType);
	              });
	              $scope.candidate.occupations = $scope.occupations && $scope.occupations.map(function (contractType) {
	                return Object.assign({
	                  isSelected: Boolean($scope.candidate.occupations.find(function (candidateOccupation) {
	                    return candidateOccupation.id === contractType.id;
	                  }))
	                }, contractType);
	              });
	              $scope.candidate.preferredContractTypes = $scope.contractTypes && $scope.contractTypes.map(function (contractType) {
	                return Object.assign({
	                  isSelected: Boolean($scope.candidate.preferredContractTypes.find(function (candidateContractType) {
	                    return candidateContractType.id === contractType.id;
	                  }))
	                }, contractType);
	              });
	              $scope.candidate.legalPracticeAreas = $scope.candidate.category.find(function (category) {
	                return category.id === 1;
	              }).specialties;
	
	              candidateJurisdictions = $scope.candidate.category.find(function (category) {
	                return category.id === 3;
	              }).specialties;
	
	              $scope.candidate.legalJurisdictions = $scope.legalJurisdiction && $scope.legalJurisdiction.map(function (jurisdiction) {
	                return Object.assign({
	                  isSelected: Boolean(candidateJurisdictions.find(function (candidateJurisdiction) {
	                    return candidateJurisdiction.id === jurisdiction.id;
	                  }))
	                }, jurisdiction);
	              });
	              updateQualificationDate($scope.candidate && $scope.candidate.lawProfile && $scope.candidate.lawProfile.qualificationDate);
	              _context6.next = 20;
	              return updateApplicationsCount();
	
	            case 20:
	              $scope.$apply();
	
	            case 21:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, this);
	    }));
	
	    return function initializeProfile() {
	      return _ref9.apply(this, arguments);
	    };
	  }();
	
	  var updateQualificationDate = function updateQualificationDate(input) {
	    console.debug('updateQualificationDate', input);
	    if ($scope.candidate && $scope.candidate.lawProfile) {
	      $scope.candidate.lawProfile.qualificationDate = input;
	      $scope.candidate.calculatedPqe = (0, _formatPqe.formatQualificationDateToPqe)($scope.candidate.lawProfile.qualificationDate);
	      console.debug('calculatedPqe', $scope.candidate.calculatedPqe);
	      $scope.$applyAsync();
	    } else {
	      console.warn('no candidate or lawProfile');
	    }
	  };
	
	  var getUserFromSession = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var user;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return userService.getUser();
	
	            case 2:
	              user = _context.sent;
	
	              $scope.currentCandidate = $scope.profileUser ? $scope.profileUser : user.id;
	              initializeProfile();
	
	            case 5:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function getUserFromSession() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  if ($scope.profileUser === undefined) {
	    $scope.currentCandidate = $location.search().user;
	    initializeProfile();
	  } else {
	    getUserFromSession();
	  }
	
	  socket.on('CONVERSATION_NOTE_CREATED', function (data) {
	    if (data === $scope.candidate.id) getCandidateLastConversation();
	  });
	  socket.on('CONVERSATION_NOTE_UPDATED', function (data) {
	    if (data === $scope.candidate.id) getCandidateLastConversation();
	  });
	
	  // eslint-disable-next-line no-unused-vars
	  var updateAgentName = function updateAgentName(agentId) {
	    var found = $scope.assignableAgents.find(function (agent) {
	      return agent.id === agentId;
	    });
	
	    console.debug('updateAgentName. Found:', found);
	
	    if (found) {
	      $scope.candidate.agent = found;
	    } else {
	      console.warn('could not find agent');
	    }
	  };
	
	  var updateApplicationsCount = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	      var result, data;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;
	              _context2.next = 3;
	              return api.get('applications/candidate/' + $scope.candidate.id + '/count');
	
	            case 3:
	              result = _context2.sent;
	
	              if (!result) {
	                $scope.candidateApplicationsCount = 0;
	              }
	
	              data = result.data;
	
	
	              $scope.candidateApplicationsCount = data;
	              _context2.next = 12;
	              break;
	
	            case 9:
	              _context2.prev = 9;
	              _context2.t0 = _context2['catch'](0);
	
	              console.error('updateApplicationsCount error:', _context2.t0);
	
	            case 12:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[0, 9]]);
	    }));
	
	    return function updateApplicationsCount() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  $scope.$on('application:created', function () {
	    console.warn('application created');
	    updateApplicationsCount();
	  });
	
	  $interval(updateApplicationsCount, 10000);
	
	  $scope.$on('candidate:update:ready', function () {
	    console.debug('candidate:update:ready');
	    // Const handleUpdate = async () => {
	    //   console.debug('handleUpdate')
	    //   await wrap(async () => getCandidateProfile())
	    // }
	
	    // handleUpdate().then(() => {
	    //   console.debug('candidate:updated done', $scope.candidate)
	    //   updateAgentName($scope.candidate.agentId)
	    // })
	  });
	
	  var getCandidateLanguages = function () {
	    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	      var _ref7, data;
	
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              _context5.next = 2;
	              return CandidateProfileApi.getUserProfile($scope.currentCandidate, {
	                include: ['languages']
	              });
	
	            case 2:
	              _ref7 = _context5.sent;
	              data = _ref7.data;
	
	              $scope.candidate.languages = data ? data.languages : [];
	              $scope.candidate.languages = $scope.languages && $scope.languages.map(function (language) {
	                return Object.assign({
	                  isSelected: Boolean($scope.candidate.languages.find(function (candidateLanguage) {
	                    return candidateLanguage.code === language.code;
	                  }))
	                }, language);
	              });
	
	            case 6:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, undefined);
	    }));
	
	    return function getCandidateLanguages() {
	      return _ref6.apply(this, arguments);
	    };
	  }();
	
	  var getCandidateLastConversation = function getCandidateLastConversation() {
	    CandidateProfileApi.getLastConversation($scope.currentCandidate).then(function (_ref8) {
	      var data = _ref8.data;
	
	      $scope.lastConversationDate = data;
	      $scope.lastConversationDay = data ? Math.floor((new Date() - new Date(data)) / (1000 * 60 * 60 * 24)) : undefined;
	      $scope.approvedSince = Math.floor((new Date() - new Date($scope.candidate.approvalAcceptDate)) / (1000 * 60 * 60 * 24));
	      $scope.$apply();
	    }, function () {
	      $scope.lastConversationDate = undefined;
	      $scope.lastConversationDay = undefined;
	      $scope.approvedSince = undefined;
	      $scope.$apply();
	    });
	  };
	
	  $scope.editUserData = {
	    firstName: '',
	    lastName: ''
	  };
	
	  $scope.editName = function () {
	    $scope.editUserData.firstName = $scope.candidate.user.firstName;
	    $scope.editUserData.lastName = $scope.candidate.user.lastName;
	    $scope.editingName = true;
	  };
	
	  $scope.changeName = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
	    return regeneratorRuntime.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            _context7.next = 2;
	            return CandidateProfileApi.updateUserData($scope.candidate.id, $scope.editUserData);
	
	          case 2:
	            $scope.candidate.user.firstName = $scope.editUserData.firstName;
	            $scope.candidate.user.lastName = $scope.editUserData.lastName;
	            $scope.$apply();
	
	          case 5:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, undefined);
	  }));
	
	  $scope.uploadProfilePicture = function () {
	    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(file) {
	      var formData, _ref12, profilePicture;
	
	      return regeneratorRuntime.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              if (!($scope.candidate.approvalStatus === 'Locked' && !$scope.user.isAdmin)) {
	                _context8.next = 4;
	                break;
	              }
	
	              logger.notify('error', 'Unable to upload Profile as Candidate Profile is Locked');
	              _context8.next = 15;
	              break;
	
	            case 4:
	              usSpinnerService.spin('spinner-dp');
	              formData = new FormData();
	
	              formData.append('file', file[0]);
	              _context8.next = 9;
	              return CandidateProfileApi.uploadProfilePhoto($scope.candidate.id, formData);
	
	            case 9:
	              _ref12 = _context8.sent;
	              profilePicture = _ref12.data;
	
	              $scope.candidate.user.profilePicture = profilePicture;
	              $scope.candidate.user.logoSrc = ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/user/' + $scope.candidate.id + '/photo/' + $scope.candidate.user.profilePicture;
	              usSpinnerService.stop('spinner-dp');
	              $scope.$apply();
	
	            case 15:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, undefined);
	    }));
	
	    return function (_x) {
	      return _ref11.apply(this, arguments);
	    };
	  }();
	
	  $scope.deleteProfilePic = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
	    return regeneratorRuntime.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            _context9.next = 2;
	            return CandidateProfileApi.deleteProfilePhoto($scope.candidate.id);
	
	          case 2:
	            $scope.candidate.user.profilePicture = undefined;
	            $scope.candidate.user.logoSrc = 'images/defaultPic.jpg';
	            $scope.$apply();
	
	          case 5:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, undefined);
	  }));
	
	  $scope.openCandidateEditableField = function (event) {
	    var id = event.target.attributes.id.value;
	    $scope.editableCandidateProfile = {
	      id: $scope.candidate.id,
	      university: $scope.candidate.candidateEducation,
	      employer: $scope.candidate.employer ? $scope.candidate.employer.name : '',
	      nationality: $scope.candidate.nationality,
	      currentLocation: $scope.candidate.location,
	      pqe: $scope.candidate.lawProfile.qualificationDate
	    };
	    if (id === 'candidate-profile') {
	      $scope.showEditableProfileField = true;
	      $scope.showCancelProfileField = true;
	    } else if (id === 'edit-pqe') {
	      $scope.showPQECancel = true;
	      $scope.showPQEField = true;
	    }
	  };
	
	  $scope.isValidUpdateCandidateProfileField = function () {
	    if ($scope.editableCandidateProfile.university && $scope.editableCandidateProfile.nationality && $scope.editableCandidateProfile.currentLocation) {
	      return true;
	    }
	
	    logger.notify('warning', 'Please complete all fields');
	    return false;
	  };
	
	  $scope.updateCandidateProfileField = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
	    var school, existingSchool, _ref16, newSchool, statusSchool, payload;
	
	    return regeneratorRuntime.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            usSpinnerService.spin('spinner-candidate');
	            school = void 0;
	
	            if (!$scope.isValidUpdateCandidateProfileField()) {
	              _context10.next = 26;
	              break;
	            }
	
	            existingSchool = $scope.schoolList.find(function (_ref15) {
	              var name = _ref15.name;
	              return name === $scope.editableCandidateProfile.university;
	            });
	
	            school = existingSchool;
	
	            if (existingSchool) {
	              _context10.next = 12;
	              break;
	            }
	
	            _context10.next = 8;
	            return SharedApi.addSchool({
	              name: $scope.editableCandidateProfile.university
	            });
	
	          case 8:
	            _ref16 = _context10.sent;
	            newSchool = _ref16.data;
	            statusSchool = _ref16.status;
	
	            if (statusSchool === 201) {
	              $scope.schoolList.push(newSchool);
	              school = newSchool;
	            }
	
	          case 12:
	            payload = school ? { schoolId: school.id } : {};
	
	            payload = $scope.editableCandidateProfile.currentLocation ? Object.assign(payload, {
	              location: Number($scope.editableCandidateProfile.currentLocation.id)
	            }) : payload;
	            payload = $scope.editableCandidateProfile.nationality ? Object.assign(payload, {
	              candidatePreference: {
	                nationalities: [$scope.editableCandidateProfile.nationality.code]
	              }
	            }) : payload;
	            payload = $scope.editableCandidateProfile.pqe ? Object.assign(payload, {
	              lawProfile: {
	                qualificationDate: $scope.editableCandidateProfile.pqe
	              }
	            }) : payload;
	
	            _context10.next = 18;
	            return CandidateProfileApi.updateProfileData($scope.candidate.id, payload);
	
	          case 18:
	            $scope.showEditableProfileField = false;
	            $scope.showCancelProfileField = false;
	            logger.notify('success', 'Candidate Profile updated successfully');
	            $scope.candidate.candidateEducation = school && school.name;
	            $scope.candidate.nationality = $scope.editableCandidateProfile.nationality && $scope.editableCandidateProfile.nationality;
	            $scope.candidate.location = $scope.editableCandidateProfile.currentLocation;
	
	            $scope.qualificationDate = $scope.editableCandidateProfile.pqe;
	
	            $scope.$apply();
	
	          case 26:
	
	            usSpinnerService.stop('spinner-candidate');
	
	          case 27:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, undefined);
	  }));
	
	  $scope.cancelUpdateProfileField = function (event) {
	    var id = event.target.attributes.id.value;
	    if (id === 'cancel-candidate-profile') {
	      $scope.showEditableProfileField = false;
	      $scope.showCancelProfileField = false;
	    } else if (id === 'cancel-pqe') {
	      $scope.showPQECancel = false;
	      $scope.showPQEField = false;
	    }
	  };
	
	  // Recommendations: Start
	  $scope.recommendationsCount = {
	    regularCustom: '*',
	    specConnect: '*'
	  };
	
	  $scope.recommendations = {
	    showRegularCustom: false,
	    showSpecConnect: false
	  };
	
	  $scope.showRecommendations = function (type) {
	    $scope.preferredLocation = true;
	    $scope.recommendations[type] = true;
	    $scope.showApplicationsTab = false;
	    console.debug('candidateProfile.showRecommendations(' + type + ')');
	    $scope.$broadcast('tab:change', 'recommendations/' + type);
	  };
	  // Recommendations: End
	
	  $scope.showApplicationsTab = false;
	
	  $scope.showApplications = function () {
	    $scope.showApplicationsTab = true;
	  };
	
	  $scope.showPreferenceTab = false;
	
	  $scope.showPreferences = function () {
	    $scope.showPreferenceTab = true;
	  };
	
	  // Notes: Start
	  $scope.showNotesTab = false;
	  $scope.showNotes = function () {
	    $scope.showNotesTab = true;
	  };
	  // Notes: End
	
	  // Actions: Start
	  determineIsLawyersActionAllowedToView();
	  function determineIsLawyersActionAllowedToView(_assignedAgent) {
	    $scope.isCandidateActionsAllowedToView = true;
	    // TODO: Add Permissions
	    // TODO: Add newUser and no registered user page
	    // $scope.isCandidateActionsAllowedToView = Boolean(
	    //   accountPermission.isLawyersActionsAllowed($scope.user) ||
	    //     assignedAgent === $scope.user.id
	    // )
	  }
	
	  $scope.openActionsModal = function () {
	    var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(userID, event) {
	      var modalData, modalInstance;
	      return regeneratorRuntime.wrap(function _callee12$(_context12) {
	        while (1) {
	          switch (_context12.prev = _context12.next) {
	            case 0:
	              event.preventDefault();
	              event.stopPropagation();
	              // $scope.showActionsSpinner = true
	              // $scope.startSpin('spinner-' + userID)
	              $scope.selectedCandidate = $scope.candidate;
	              modalData = void 0;
	              _context12.next = 6;
	              return Promise.all([CandidateProfileApi.getUserBlockedEmployers($scope.candidate.id), CandidateProfileApi.getAdminAndCorporateUsers(), CandidateProfileApi.getUserSettings($scope.candidate.id), CandidateProfileApi.getEmployersList()]).then(function (results) {
	                var blockedEmployersList = results[3].data && results[3].data.map(function (employer) {
	                  return Object.assign({
	                    isSelected: Boolean(results[0].data.find(function (blockedEmployer) {
	                      return blockedEmployer.employerId === employer.id && blockedEmployer.block;
	                    }))
	                  }, employer);
	                });
	
	                console.debug('blockedEmployersList', {
	                  blockedEmployersList: blockedEmployersList,
	                  result: results[3]
	                });
	
	                $scope.assignableAgents = results[1].data;
	
	                modalData = {
	                  candidate: $scope.candidate,
	                  // BlockedEmployers: _.union(
	                  //   [
	                  //     {
	                  //       userId: $scope.candidate.id,
	                  //       block: true,
	                  //       employerId: $scope.candidate.employerId,
	                  //     },
	                  //   ],
	                  //   results[0].data
	                  // ),
	                  blockedEmployers: results[0].data,
	                  assignableAgents: $scope.assignableAgents,
	                  candidateSettings: results[2].data,
	                  employersList: blockedEmployersList
	                };
	                console.warn('modalData', modalData);
	              });
	
	            case 6:
	              modalInstance = $modal.open({
	                templateUrl: 'edit-candidate-modal.html',
	                controller: 'EditCandidateCtrl',
	                controllerAs: 'ctrl',
	                resolve: {
	                  data: function data() {
	                    return modalData;
	                  },
	                  candidateId: function candidateId() {
	                    return $scope.candidate.id;
	                  }
	                }
	              });
	
	              modalInstance.result.then(function () {
	                var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(data) {
	                  return regeneratorRuntime.wrap(function _callee11$(_context11) {
	                    while (1) {
	                      switch (_context11.prev = _context11.next) {
	                        case 0:
	                          console.debug('CandidateProfile::actions::result', data);
	                          if (data.updatedApprovalStatus) {
	                            $scope.candidate.approvalStatus = data.updatedApprovalStatus;
	                            if (data.updatedApprovalStatus === 'Approved') $scope.candidate.approvalAcceptDate = new Date();
	                            // $scope.$apply()
	                          }
	
	                          updateQualificationDate(data.updatedQualificationDate ? data.updatedQualificationDate : data.updatedCandidateProfile.lawProfile.qualificationDate);
	
	                          if (data.updatedCandidateProfile) {
	                            $scope.candidate.minSelectivity = data.updatedCandidateProfile.minSelectivity;
	                            $scope.candidate.maxSelectivity = data.updatedCandidateProfile.maxSelectivity;
	                            console.debug('assignableAgents:', $scope.assignableAgents);
	                            $scope.candidate.agent = $scope.assignableAgents.find(function (agent) {
	                              return agent.id === data.updatedCandidateProfile.agentId;
	                            });
	                            console.debug('$scope.candidate.agent:', $scope.candidate.agent);
	                            $rootScope.$broadcast('candidate:update:ready');
	                          }
	
	                        case 4:
	                        case 'end':
	                          return _context11.stop();
	                      }
	                    }
	                  }, _callee11, undefined);
	                }));
	
	                return function (_x4) {
	                  return _ref18.apply(this, arguments);
	                };
	              }());
	
	            case 8:
	            case 'end':
	              return _context12.stop();
	          }
	        }
	      }, _callee12, undefined);
	    }));
	
	    return function (_x2, _x3) {
	      return _ref17.apply(this, arguments);
	    };
	  }();
	
	  // Actions: End
	};

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var NotesController = exports.NotesController = function NotesController($scope, $location, NotesApi, notesModal, userService, CandidateProfileApi) {
	  var fetchUserNotes = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(userId) {
	      var _ref2, employers, _ref3, userNotes;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return CandidateProfileApi.getEmployersList();
	
	            case 2:
	              _ref2 = _context.sent;
	              employers = _ref2.data;
	              _context.next = 6;
	              return NotesApi.getAllNotes({ user: [userId] });
	
	            case 6:
	              _ref3 = _context.sent;
	              userNotes = _ref3.data;
	
	
	              modalData.employers = employers;
	              modalData.authors = $scope.authors;
	              $scope.notes = userNotes.map(function (note) {
	                return Object.assign({
	                  employer: note.employerId ? employers.find(function (employer) {
	                    return employer.id === note.employerId;
	                  }) : undefined,
	                  author: note.authorId ? $scope.authors.find(function (author) {
	                    return author.id === note.authorId;
	                  }) : undefined
	                }, note);
	              });
	              $scope.allNotes = $scope.notes;
	              if ($scope.notes.length > 0) $scope.noNotes = false;
	              $scope.$apply();
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    return function fetchUserNotes(_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var fetchEmployerNotes = function () {
	    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(employerId) {
	      var _ref5, allCandidate, _ref6, employerNotes;
	
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.next = 2;
	              return CandidateProfileApi.getCandidateList();
	
	            case 2:
	              _ref5 = _context2.sent;
	              allCandidate = _ref5.data;
	              _context2.next = 6;
	              return NotesApi.getAllNotes({
	                employer: [employerId]
	              });
	
	            case 6:
	              _ref6 = _context2.sent;
	              employerNotes = _ref6.data;
	
	              modalData.candidates = allCandidate;
	              modalData.authors = $scope.authors;
	              $scope.notes = employerNotes.map(function (note) {
	                return Object.assign({
	                  candidate: note.userId ? allCandidate.find(function (candidate) {
	                    return candidate.id === note.userId;
	                  }) : undefined,
	                  author: note.authorId ? $scope.authors.find(function (author) {
	                    return author.id === note.authorId;
	                  }) : undefined
	                }, note);
	              });
	              $scope.allNotes = $scope.notes;
	              if ($scope.notes.length > 0) $scope.noNotes = false;
	              $scope.$apply();
	
	            case 14:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, this);
	    }));
	
	    return function fetchEmployerNotes(_x2) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	
	  $scope.sortListData = [{
	    value: '-created',
	    label: 'Date'
	  }, {
	    value: 'category',
	    '-created': '-created',
	    label: 'Type'
	  }];
	  $scope.noteUser = $location.search().user;
	  if (!$scope.noteUser && $scope.user) $scope.noteUser = $scope.user.id;
	  $scope.employerId = $location.search().employer ? Number($location.search().employer) : undefined;
	  $scope.employerName = $location.search().employer ? $location.search().employerName : undefined;
	
	  $scope.openNotesModal = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	    return regeneratorRuntime.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return $scope.resetNote(modalData.note);
	
	          case 2:
	            modalData.note = _context3.sent;
	
	            $scope.notes = notesModal.openAddNoteModal(modalData, $scope.notes, $scope.noNotes);
	            $scope.noNotes = false;
	
	          case 5:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  $scope.editNote = function (noteID, index) {
	    modalData.note = $scope.resetNote(modalData.note);
	    var temporaryNote = $scope.notes.find(function (note) {
	      return note.id === noteID;
	    });
	    index = $scope.notes.indexOf(temporaryNote);
	    modalData.note = Object.assign({}, temporaryNote, {
	      authorId: $scope.loginUser.id
	    });
	    return notesModal.openEditNoteModal($scope.notes, index, modalData);
	  };
	
	  $scope.noteHistory = function () {
	    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(noteID) {
	      var payload, _ref9, noteHistory, notes;
	
	      return regeneratorRuntime.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              payload = {
	                category: 'note',
	                type: 'NOTE_UPDATE',
	                target: noteID
	              };
	              _context4.next = 3;
	              return NotesApi.getNoteHistory(payload);
	
	            case 3:
	              _ref9 = _context4.sent;
	              noteHistory = _ref9.data;
	              notes = noteHistory.map(function (note) {
	                return {
	                  created: note.created,
	                  employer: note.payload.old.employerId && modalData.employers ? modalData.employers.find(function (employer) {
	                    return employer.id === note.payload.old.employerId;
	                  }) : undefined,
	                  candidate: note.payload.old.userId && modalData.candidates ? modalData.candidates.find(function (candidate) {
	                    return candidate.id === note.payload.old.userId;
	                  }) : undefined,
	                  author: note.payload.old.authorId ? modalData.authors.find(function (author) {
	                    return author.id === note.payload.old.authorId;
	                  }) : undefined,
	                  data: note.payload.old
	                };
	              });
	              return _context4.abrupt('return', notesModal.openNoteHistoryModal(notes));
	
	            case 7:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, undefined);
	    }));
	
	    return function (_x3) {
	      return _ref8.apply(this, arguments);
	    };
	  }();
	
	  $scope.deleteNote = function (noteID, index) {
	    var temporaryNote;
	    temporaryNote = $scope.notes.find(function (note) {
	      return note.id === noteID;
	    });
	    index = $scope.notes.indexOf(temporaryNote);
	    notesModal.openDeleteNoteModal(noteID, $scope.notes, index);
	  };
	
	  var modalData = {
	    noteType: ['Comment', 'Conversation', 'Interview Feedback'],
	    employers: [],
	    assignTo: [],
	    note: $scope.Note,
	    selectedFirm: [],
	    isEmployerNote: false,
	    isUserNote: false
	  };
	
	  $scope.searchNotes = function (searchWord) {
	    $scope.notes = [];
	    $scope.allNotes.forEach(function (note) {
	      if (note.subject && note.subject.toLowerCase().includes(searchWord.toLowerCase()) || note.body && note.body.toLowerCase().includes(searchWord.toLowerCase())) {
	        $scope.notes.push(note);
	      }
	    });
	  };
	
	  $scope.clearSearchKey = function () {
	    $scope.searchKeywords.value = '';
	    $scope.searchNotes('');
	  };
	
	  $scope.resetNote = function () {
	    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(note) {
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              note = {
	                body: undefined,
	                subject: undefined,
	                attendees: undefined,
	                medium: undefined,
	                category: undefined, // Note type
	                time: new Date(),
	                date: new Date(),
	                authorId: $scope.loginUser.id,
	                employerId: $scope.employerId,
	                userId: $scope.noteUser
	              };
	              return _context5.abrupt('return', note);
	
	            case 2:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, undefined);
	    }));
	
	    return function (_x4) {
	      return _ref10.apply(this, arguments);
	    };
	  }();
	
	  $scope.initializeNotesController = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
	    var _ref12, authors;
	
	    return regeneratorRuntime.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _context6.next = 2;
	            return userService.getUser();
	
	          case 2:
	            $scope.loginUser = _context6.sent;
	            _context6.next = 5;
	            return CandidateProfileApi.getAdminAndCorporateUsers();
	
	          case 5:
	            _ref12 = _context6.sent;
	            authors = _ref12.data;
	
	            $scope.authors = authors;
	
	            $scope.Note = $scope.resetNote({});
	
	            if ($scope.noteUser) {
	              modalData.isUserNote = true;
	              fetchUserNotes($scope.noteUser);
	            }
	
	            if ($scope.employerId) {
	              modalData.isEmployerNote = true;
	              fetchEmployerNotes($scope.employerId);
	            }
	
	            console.debug('initializeNotesController done');
	
	          case 12:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  $scope.initializeNotesController();
	};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var axios = __webpack_require__(503);
	
	var _require = __webpack_require__(1049),
	    isNil = _require.isNil,
	    isEmpty = _require.isEmpty;
	
	var isDefined = function isDefined(input) {
	  return !isNil(input) && !isEmpty(input);
	};
	var logRequestDefault = false;
	var LOG_REQUESTS = isDefined(({"NODE_ENV":"production","LEXSTEP_URL":"https://api.lexstep.com","PREFIX":"v1","API_PREFIX":"v1","PUBLIC_URL":"https://lexstep.com","PUBLIC_BUCKET_URL":"https://lexstep-nest-public.s3.eu-west-2.amazonaws.com"}).LOG_REQUESTS) ? ({"NODE_ENV":"production","LEXSTEP_URL":"https://api.lexstep.com","PREFIX":"v1","API_PREFIX":"v1","PUBLIC_URL":"https://lexstep.com","PUBLIC_BUCKET_URL":"https://lexstep-nest-public.s3.eu-west-2.amazonaws.com"}).LOG_REQUESTS : logRequestDefault;
	
	var log = function log(method, url, payload) {
	  if (LOG_REQUESTS) {
	    console.debug(method.toUpperCase() + ' ' + url, payload);
	  }
	};
	
	var _require2 = __webpack_require__(766),
	    axiosRetry = _require2.axiosRetry,
	    exponentialDelay = _require2.exponentialDelay;
	
	function onRetry(retryCount, error, requestConfig) {
	  // If (LOG_REQUESTS) {
	  console.debug('Retry #' + retryCount + ' for ' + requestConfig.method + ' ' + requestConfig.url);
	  // }
	}
	
	axiosRetry(axios, {
	  retries: 10,
	  retryDelay: exponentialDelay,
	  onRetry: onRetry,
	  shouldResetTimeout: true
	});
	
	var convertResult = function convertResult(input) {
	  var data = input.data,
	      status = input.status,
	      headers = input.headers,
	      config = input.config,
	      statusText = input.statusText;
	
	  var xhrStatus = input.status < 200 || input.status >= 300 ? 'error' : 'success';
	  return {
	    data: data,
	    status: status,
	    headers: headers,
	    config: config,
	    statusText: statusText,
	    xhrStatus: xhrStatus
	  };
	};
	
	var $axios = {
	  get: function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, config) {
	      var result;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              log('get', url, { config: config });
	              _context.next = 3;
	              return axios.get(url, config);
	
	            case 3:
	              result = _context.sent;
	              return _context.abrupt('return', convertResult(result));
	
	            case 5:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    function get(_x, _x2) {
	      return _ref.apply(this, arguments);
	    }
	
	    return get;
	  }(),
	  put: function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, data, config) {
	      var result;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              log('put', url, { data: data, config: config });
	              _context2.next = 3;
	              return axios.put(url, data, config);
	
	            case 3:
	              result = _context2.sent;
	              return _context2.abrupt('return', convertResult(result));
	
	            case 5:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    function put(_x3, _x4, _x5) {
	      return _ref2.apply(this, arguments);
	    }
	
	    return put;
	  }(),
	  patch: function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(url, data, config) {
	      var result;
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              log('patch', url, { data: data, config: config });
	              _context3.next = 3;
	              return axios.patch(url, data, config);
	
	            case 3:
	              result = _context3.sent;
	              return _context3.abrupt('return', convertResult(result));
	
	            case 5:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined);
	    }));
	
	    function patch(_x6, _x7, _x8) {
	      return _ref3.apply(this, arguments);
	    }
	
	    return patch;
	  }(),
	  delete: function () {
	    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(url, config) {
	      var result;
	      return regeneratorRuntime.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              log('delete', url, { config: config });
	              _context4.next = 3;
	              return axios.delete(url, config);
	
	            case 3:
	              result = _context4.sent;
	              return _context4.abrupt('return', convertResult(result));
	
	            case 5:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, undefined);
	    }));
	
	    function _delete(_x9, _x10) {
	      return _ref4.apply(this, arguments);
	    }
	
	    return _delete;
	  }(),
	  request: function () {
	    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(config) {
	      var result;
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              console.error('REQUEST CALLED');
	              _context5.next = 3;
	              return axios.request(config);
	
	            case 3:
	              result = _context5.sent;
	              return _context5.abrupt('return', convertResult(result));
	
	            case 5:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, undefined);
	    }));
	
	    function request(_x11) {
	      return _ref5.apply(this, arguments);
	    }
	
	    return request;
	  }(),
	  post: function () {
	    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(url, data, config) {
	      var result;
	      return regeneratorRuntime.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              log('post', url, { data: data, config: config });
	              _context6.next = 3;
	              return axios.post(url, data, config);
	
	            case 3:
	              result = _context6.sent;
	              return _context6.abrupt('return', convertResult(result));
	
	            case 5:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, undefined);
	    }));
	
	    function post(_x12, _x13, _x14) {
	      return _ref6.apply(this, arguments);
	    }
	
	    return post;
	  }()
	};
	
	angular.module('app.api').factory('api', ['$timeout', '$window', 'logger', '$http', function api($timeout, $window, logger, $http) {
	  var _this = this;
	
	  var config = {};
	  var inMemoryToken = {
	    token: '',
	    expiry: 0
	  };
	  var refreshTimeOut = void 0;
	
	  var prefix = ("v1") || ("v1") || 'v1';
	  // eslint-disable-next-line unicorn/consistent-function-scoping
	  var apiUrl = function apiUrl(path) {
	    return ("https://api.lexstep.com") + '/api/' + ("v1") + '/' + path;
	  };
	
	  var httpOptionsWithCredentials = {
	    withCredentials: true
	  };
	
	  var getHandler = function getHandler(retry) {
	    if (retry === null || retry === undefined || retry) {
	      return $axios;
	    }
	
	    return $http;
	  };
	
	  var privateApi = {
	    logOut: function () {
	      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
	        var result;
	        return regeneratorRuntime.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _context7.next = 2;
	                return Api.post('auth/logout', {}, httpOptionsWithCredentials);
	
	              case 2:
	                result = _context7.sent;
	                return _context7.abrupt('return', result);
	
	              case 4:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this);
	      }));
	
	      function logOut() {
	        return _ref7.apply(this, arguments);
	      }
	
	      return logOut;
	    }(),
	    refreshToken: function refreshToken() {
	      try {
	        console.debug('getting refresh token from local storage:');
	        var tokenResponse = $window.localStorage.getItem('token');
	        if (tokenResponse) {
	          var parsed = JSON.parse(tokenResponse);
	          console.debug('token in local storage:', parsed);
	          return Api.post('auth/refresh', { token: parsed.refreshToken }, true);
	        }
	      } catch (error) {
	        console.error('failed to get refresh token from local storage', error);
	      }
	
	      return Api.post('auth/refresh', {}, httpOptionsWithCredentials);
	    },
	    verifyLoginUser: function () {
	      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(response) {
	        var user, updated;
	        return regeneratorRuntime.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                if (!(response.status === 401 || response.status === 404)) {
	                  _context8.next = 14;
	                  break;
	                }
	
	                user = $window.localStorage.getItem('user');
	
	                user = user && JSON.parse(user);
	
	                if (!user) {
	                  _context8.next = 14;
	                  break;
	                }
	
	                _context8.prev = 4;
	                _context8.next = 7;
	                return Api.get(apiUrl('users/' + user.id), config, true, true);
	
	              case 7:
	                updated = _context8.sent;
	
	
	                if (updated.status === 200) {
	                  console.debug('updating current user in local storage');
	                  $window.localStorage.setItem('user', JSON.stringify(updated.data));
	                }
	                _context8.next = 14;
	                break;
	
	              case 11:
	                _context8.prev = 11;
	                _context8.t0 = _context8['catch'](4);
	
	                if (_context8.t0.status < 500 && _context8.t0.status >= 400) {
	                  $window.localStorage.removeItem('token');
	                  // eslint-disable-next-line unicorn/no-null
	                  $window.localStorage.setItem('user', null);
	                  logger.notify('error', 'Please Login');
	                  $timeout(function () {
	                    $window.location.href = '/signin';
	                  }, 2000);
	                }
	
	              case 14:
	
	                if (response.status === 403) {
	                  logger.notify('error', response.statusText + ', Not allowed to access Route: ' + response.data.path);
	                }
	
	                if (response.status === -1 || response.status === 502) {
	                  logger.notify('error', 'A problem occurred when communicating with the LexStep.com server. Please try again. If the problem persists, please contact support.');
	                  console.error('verifyLoginUser', response);
	                }
	
	              case 16:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this, [[4, 11]]);
	      }));
	
	      function verifyLoginUser(_x15) {
	        return _ref8.apply(this, arguments);
	      }
	
	      return verifyLoginUser;
	    }()
	  };
	
	  var handleApiError = function () {
	    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(error, endpoint, shouldHandle) {
	      var errorIsFiveHundred;
	      return regeneratorRuntime.wrap(function _callee9$(_context9) {
	        while (1) {
	          switch (_context9.prev = _context9.next) {
	            case 0:
	              console.debug('handleApiError:', error);
	
	              if (error) {
	                _context9.next = 3;
	                break;
	              }
	
	              throw new Error('No error object');
	
	            case 3:
	              errorIsFiveHundred = error.response.status >= 500 && error.response.status < 600;
	
	              if (!(endpoint === 'auth/login' || endpoint === 'auth/refresh')) {
	                _context9.next = 6;
	                break;
	              }
	
	              throw error;
	
	            case 6:
	              if (!shouldHandle) {
	                _context9.next = 19;
	                break;
	              }
	
	              if (!(error.response.status === -1 || error.response.status === 401)) {
	                _context9.next = 12;
	                break;
	              }
	
	              _context9.next = 10;
	              return privateApi.verifyLoginUser(error);
	
	            case 10:
	              _context9.next = 17;
	              break;
	
	            case 12:
	              if (!errorIsFiveHundred) {
	                _context9.next = 16;
	                break;
	              }
	
	              $window.location.href = '/502';
	              _context9.next = 17;
	              break;
	
	            case 16:
	              throw error;
	
	            case 17:
	              _context9.next = 24;
	              break;
	
	            case 19:
	              console.error('handleApiError: should not verify login user');
	
	              if (!(error.response.status === 401)) {
	                _context9.next = 24;
	                break;
	              }
	
	              console.warn('ending session: 401 encountered');
	              _context9.next = 24;
	              return Api.endSession();
	
	            case 24:
	            case 'end':
	              return _context9.stop();
	          }
	        }
	      }, _callee9, _this);
	    }));
	
	    return function handleApiError(_x16, _x17, _x18) {
	      return _ref9.apply(this, arguments);
	    };
	  }();
	
	  var Api = {
	    get: function () {
	      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(path, apiConfig, retry, throwOnError) {
	        var shouldHandleError, handler, result;
	        return regeneratorRuntime.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                shouldHandleError = throwOnError === null || throwOnError === undefined || throwOnError === false;
	                _context10.prev = 1;
	                handler = getHandler(retry);
	                _context10.next = 5;
	                return handler.get(apiUrl(path), apiConfig ? angular.merge({}, config, apiConfig) : config);
	
	              case 5:
	                result = _context10.sent;
	                return _context10.abrupt('return', convertResult(result));
	
	              case 9:
	                _context10.prev = 9;
	                _context10.t0 = _context10['catch'](1);
	
	                handleApiError(_context10.t0, shouldHandleError);
	
	              case 12:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this, [[1, 9]]);
	      }));
	
	      function get(_x19, _x20, _x21, _x22) {
	        return _ref10.apply(this, arguments);
	      }
	
	      return get;
	    }(),
	    post: function () {
	      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(path, payload, apiConfig, retry, throwOnError) {
	        var handler, result;
	        return regeneratorRuntime.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                _context11.prev = 0;
	                handler = getHandler(retry);
	                _context11.next = 4;
	                return handler.post(apiUrl(path), payload, apiConfig ? angular.merge({}, config, apiConfig) : config);
	
	              case 4:
	                result = _context11.sent;
	                return _context11.abrupt('return', result);
	
	              case 8:
	                _context11.prev = 8;
	                _context11.t0 = _context11['catch'](0);
	
	                if (throwOnError) {
	                  _context11.next = 14;
	                  break;
	                }
	
	                handleApiError(_context11.t0, path);
	                _context11.next = 15;
	                break;
	
	              case 14:
	                throw _context11.t0;
	
	              case 15:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, _this, [[0, 8]]);
	      }));
	
	      function post(_x23, _x24, _x25, _x26, _x27) {
	        return _ref11.apply(this, arguments);
	      }
	
	      return post;
	    }(),
	    put: function () {
	      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(path, payload, apiConfig, retry) {
	        var handler, result;
	        return regeneratorRuntime.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                _context12.prev = 0;
	                handler = getHandler(retry);
	                _context12.next = 4;
	                return handler.put(apiUrl(path), payload, apiConfig ? angular.merge({}, config, apiConfig) : config);
	
	              case 4:
	                result = _context12.sent;
	                return _context12.abrupt('return', result);
	
	              case 8:
	                _context12.prev = 8;
	                _context12.t0 = _context12['catch'](0);
	
	                handleApiError(_context12.t0);
	
	              case 11:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, _this, [[0, 8]]);
	      }));
	
	      function put(_x28, _x29, _x30, _x31) {
	        return _ref12.apply(this, arguments);
	      }
	
	      return put;
	    }(),
	    delete: function () {
	      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(path, apiConfig, retry) {
	        var handler, result;
	        return regeneratorRuntime.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                _context13.prev = 0;
	                handler = getHandler(retry);
	                _context13.next = 4;
	                return handler.delete(apiUrl(path), apiConfig ? angular.merge({}, config, apiConfig) : config);
	
	              case 4:
	                result = _context13.sent;
	                return _context13.abrupt('return', result);
	
	              case 8:
	                _context13.prev = 8;
	                _context13.t0 = _context13['catch'](0);
	
	                handleApiError(_context13.t0);
	
	              case 11:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, _this, [[0, 8]]);
	      }));
	
	      function _delete(_x32, _x33, _x34) {
	        return _ref13.apply(this, arguments);
	      }
	
	      return _delete;
	    }(),
	    verifySessionToken: function verifySessionToken() {
	      if (inMemoryToken.token !== '') return true;
	      var token = $window.localStorage.getItem('token');
	      if (token) {
	        Api.updateInMemoryToken(JSON.parse(token));
	        return true;
	      }
	
	      return false;
	    },
	    startSession: function startSession(tokenResponse) {
	      Api.updateInMemoryToken(tokenResponse);
	      var nextRefresh = (inMemoryToken.expiry - 60) * 1000;
	      $window.localStorage.setItem('token', JSON.stringify(tokenResponse));
	      refreshTimeOut = $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
	        var response;
	        return regeneratorRuntime.wrap(function _callee14$(_context14) {
	          while (1) {
	            switch (_context14.prev = _context14.next) {
	              case 0:
	                _context14.next = 2;
	                return privateApi.refreshToken();
	
	              case 2:
	                response = _context14.sent;
	
	                if (response.status === 201) Api.startSession(response.data);
	
	              case 4:
	              case 'end':
	                return _context14.stop();
	            }
	          }
	        }, _callee14, _this);
	      })), nextRefresh);
	    },
	    endSession: function () {
	      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
	        return regeneratorRuntime.wrap(function _callee15$(_context15) {
	          while (1) {
	            switch (_context15.prev = _context15.next) {
	              case 0:
	                inMemoryToken = {
	                  token: '',
	                  expiry: 0
	                };
	                config = {};
	                $window.localStorage.setItem('logout', Date.now());
	                $timeout.cancel(refreshTimeOut);
	                $window.localStorage.removeItem('token');
	                $window.localStorage.removeItem('user');
	                _context15.next = 8;
	                return privateApi.logOut();
	
	              case 8:
	                $window.location.href = '/signin';
	
	              case 9:
	              case 'end':
	                return _context15.stop();
	            }
	          }
	        }, _callee15, _this);
	      }));
	
	      function endSession() {
	        return _ref15.apply(this, arguments);
	      }
	
	      return endSession;
	    }(),
	    refreshSession: function () {
	      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
	        return regeneratorRuntime.wrap(function _callee16$(_context16) {
	          while (1) {
	            switch (_context16.prev = _context16.next) {
	              case 0:
	                return _context16.abrupt('return', privateApi.refreshToken().then(function (_ref17) {
	                  var data = _ref17.data;
	
	                  Api.startSession(data);
	                  return true;
	                }, function (_error) {
	                  return false;
	                }));
	
	              case 1:
	              case 'end':
	                return _context16.stop();
	            }
	          }
	        }, _callee16, _this);
	      }));
	
	      function refreshSession() {
	        return _ref16.apply(this, arguments);
	      }
	
	      return refreshSession;
	    }(),
	    updateInMemoryToken: function updateInMemoryToken(tokenResponse) {
	      inMemoryToken = {
	        token: tokenResponse.id_token,
	        expiry: tokenResponse.expires_in
	      };
	      config = {
	        headers: {
	          Authorization: 'Bearer ' + inMemoryToken.token
	        }
	      };
	    }
	  };
	  return Api;
	}]);

/***/ }),
/* 182 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**************************************************************************/
	/*** 'Column Selector' implemented By Fahad Akbar(fahadakbar24@gmail.com)**/
	/**************************************************************************/
	
	var columnSelectorCtrl = function columnSelectorCtrl($scope, $rootScope, $modal, columnSelectionApi) {
	  var openSelectionPopup = function openSelectionPopup() {
	    var saveSelectionHandler = function saveSelectionHandler() {
	      if ($scope.isColumnSelectionToBeSaved) {
	        var selectionPayload = {
	          pageId: $scope.pageId,
	          selectedColumnIds: _.pluck(_.filter($scope.columnsList, function (column) {
	            return column.show;
	          }), ['id'])
	        };
	
	        columnSelectionApi.save(selectionPayload);
	      }
	    };
	    $scope.columnSelectPopup = $modal.open({
	      templateUrl: 'columnSelectTemplate.html',
	      controller: columnSelectorCtrl,
	      scope: $scope
	    });
	
	    return $scope.columnSelectPopup.result.finally(saveSelectionHandler);
	  };
	
	  var isColumnShown = function isColumnShown(column) {
	    return column.show;
	  };
	  var isAnyColumnShown = function isAnyColumnShown(columnsList) {
	    return columnsList.some(isColumnShown);
	  };
	  var mapShownStateWithDefault = function mapShownStateWithDefault(column) {
	    return column.show = column.show_by_default;
	  };
	  var showDefaultColumnSelection = function showDefaultColumnSelection(columnsList) {
	    return columnsList.forEach(mapShownStateWithDefault);
	  };
	
	  var determineToShowDefaultSelection = function determineToShowDefaultSelection(columnsList) {
	    $scope.$watch('columnsList', function (newList, oldList) {
	      if (newList && !isAnyColumnShown(newList)) showDefaultColumnSelection(newList);
	    }, true);
	  };
	
	  $scope.closeSelectionPopup = function () {
	    return $scope.columnSelectPopup.close();
	  };(function initialize() {
	    $scope.openColumnsPopup = openSelectionPopup;
	    determineToShowDefaultSelection($scope.columnsList);
	  })();
	};
	
	exports.columnSelectorCtrl = columnSelectorCtrl;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _loadingOverlay = __webpack_require__(20);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	(function module() {
	  angular.module('app.ui.form.ctrls').controller('CreateUpdateEmployerModalController', ['$log', '$timeout', '$uibModal', '$location', 'logger', 'usSpinnerService', 'EmployersApi', 'SharedApi', '$uibModalInstance', 'selectedEmployerId', 'userService', 'CandidateProfileApi', '$rootScope', function controller($log, $timeout, $uibModal, $location, logger, usSpinnerService, EmployersApi, SharedApi, $uibModalInstance, selectedEmployerId, userService, CandidateProfileApi, $rootScope) {
	    var _this = this;
	
	    var vm = this;
	    $rootScope.$on('employer-deleted', function (event, _ref) {
	      var employerDeleted = _ref.employerDeleted;
	
	      if (selectedEmployerId === employerDeleted && !$rootScope.isEmployerDeleted) {
	        logger.notify('error', 'Employer Deleted by Other Admin');
	        vm.cancel();
	      }
	    });
	    vm.showOnError = false;
	    vm.showOnSuccess = false;
	    vm.alertMsg = '';
	    vm.employerSpinnerId = 'spinner-firm-management';
	    vm.selectedEmployerId = selectedEmployerId;
	    var pageInitialize = function pageInitialize() {
	      vm.page = {
	        entityPlaceholder: 'Employer',
	        mandatoryPlaceholder: vm.isPrivatePractice === false ? '' : '*',
	        behaviorPlaceholder: vm.selectedEmployerId ? 'Edit' : 'Create'
	      };
	    };
	
	    vm.cancel = function () {
	      $uibModalInstance.dismiss('cancel');
	    };
	
	    pageInitialize();
	
	    //   $scope.$root.title = `${vm.page.behaviorPlaceholder} ${vm.page.entityPlaceholder} | Lexstep`
	
	    // $scope.canViewAddFirmAssignedAdmin = () => {
	    //   return accountPermission.canViewAddFirmAssignedAdmin($scope.user)
	    // }
	
	    vm.changeStatus = function (status, message) {
	      switch (status) {
	        case 201:
	          vm.alertMsg = 'Congratulations! Employers has been Successfully created.';
	          vm.showOnSuccess = true;
	          break;
	        case 200:
	          vm.alertMsg = 'Congratulations! Employers has been Successfully updated.';
	          vm.showOnSuccess = true;
	          break;
	        case 440:
	          $location.url('/signin');
	          break;
	        case 404:
	          vm.alertMsg = 'Page Not Found. Please try again.';
	          vm.showOnError = true;
	          break;
	        case 400:
	          vm.alertMsg = message;
	          vm.showOnError = true;
	          break;
	        case 500:
	          vm.alertMsg = 'Could not connect to the server. Please try again later.';
	          vm.showOnError = true;
	          break;
	        case 100:
	          vm.alertMsg = 'Please select a Employer by clicking the checkboxes before deleting.';
	          vm.showOnError = true;
	          break;
	        default:
	          vm.alertMsg = 'An error has occurred. Please try again.';
	          vm.showOnError = true;
	          break;
	      }
	    };
	
	    var discardMultipleField = function discardMultipleField() {
	      vm.employer.lawProfile = {
	        nqSalary: vm.employer.lawProfile.nqSalary,
	        nqSalaryVisible: vm.employer.lawProfile.nqSalaryVisible
	      };
	    };
	
	    vm.addEmployer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	      var payload;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              if (!vm.isPrivatePractice && vm.employer.lawProfile) discardMultipleField();
	              payload = employerDto();
	
	              startSpinner();
	              EmployersApi.createEmployer(payload).then(function () {
	                var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(successResponse) {
	                  var file, formData;
	                  return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          if (!vm.selectedFile) {
	                            _context.next = 6;
	                            break;
	                          }
	
	                          file = vm.selectedFile;
	                          formData = new FormData();
	
	                          formData.append('file', file);
	                          _context.next = 6;
	                          return EmployersApi.uploadEmployerLogo(successResponse.data.id, formData);
	
	                        case 6:
	
	                          stopSpinner();
	
	                          $uibModalInstance.close({
	                            employer: successResponse.data,
	                            type: 'created'
	                          });
	
	                        case 8:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this);
	                }));
	
	                return function (_x) {
	                  return _ref3.apply(this, arguments);
	                };
	              }()).catch(addUpdateErrorResponseHandler).finally(stopSpinner);
	
	            case 4:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this);
	    }));
	
	    vm.updateEmployer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	      var result;
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              _context5.next = 2;
	              return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
	                var payload;
	                return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                  while (1) {
	                    switch (_context4.prev = _context4.next) {
	                      case 0:
	                        console.debug('updateEmployer');
	                        if (!vm.isPrivatePractice && vm.employer.lawProfile) discardMultipleField();
	                        startSpinner();
	                        payload = employerDto();
	
	                        EmployersApi.updateEmployerById(vm.selectedEmployerId, payload).then(function () {
	                          var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(successResponse) {
	                            var file, formData;
	                            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                              while (1) {
	                                switch (_context3.prev = _context3.next) {
	                                  case 0:
	                                    if (!vm.selectedFile) {
	                                      _context3.next = 6;
	                                      break;
	                                    }
	
	                                    file = vm.selectedFile;
	                                    formData = new FormData();
	
	                                    formData.append('file', file);
	                                    _context3.next = 6;
	                                    return EmployersApi.uploadEmployerLogo(vm.selectedEmployerId, formData);
	
	                                  case 6:
	
	                                    stopSpinner();
	                                    $uibModalInstance.close({
	                                      employer: successResponse.data,
	                                      type: 'updated'
	                                    });
	
	                                  case 8:
	                                  case 'end':
	                                    return _context3.stop();
	                                }
	                              }
	                            }, _callee3, _this);
	                          }));
	
	                          return function (_x2) {
	                            return _ref6.apply(this, arguments);
	                          };
	                        }()).catch(addUpdateErrorResponseHandler).finally(stopSpinner);
	
	                      case 5:
	                      case 'end':
	                        return _context4.stop();
	                    }
	                  }
	                }, _callee4, _this);
	              })));
	
	            case 2:
	              result = _context5.sent;
	              return _context5.abrupt('return', result);
	
	            case 4:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this);
	    }));
	
	    var employerDto = function employerDto() {
	      var payload = angular.copy(vm.employer);
	
	      // eslint-disable-next-line unicorn/no-null
	      payload.agentId = payload.agentId === 0 ? null : payload.agentId;
	      payload.approved = vm.employer.approved;
	      payload.professions = ['law'];
	      payload.contactEmail = vm.employer.contactEmail ? vm.employer.contactEmail : undefined;
	      payload.specialties = vm.employer.practiceAreas;
	      payload.specialties = vm.selectedCategory ? [].concat(_toConsumableArray(payload.specialties), [vm.selectedCategory]) : payload.specialties;
	      payload.categories = [].concat(_toConsumableArray(new Set(payload.specialties && payload.specialties.map(function (specialty) {
	        return specialty.categoryId;
	      }))));
	
	      if (vm.editableEmployerName && payload.name.trim() === vm.editableEmployerName.trim()) delete payload.name;
	      delete payload.practiceAreas;
	      delete payload.categoryId;
	      delete payload.id;
	      delete payload.logo;
	
	      return payload;
	    };
	
	    var startSpinner = function startSpinner() {
	      return usSpinnerService.spin(vm.employerSpinnerId);
	    };
	
	    var stopSpinner = function stopSpinner() {
	      return usSpinnerService.stop(vm.employerSpinnerId);
	    };
	
	    var addUpdateErrorResponseHandler = function addUpdateErrorResponseHandler(errorResponse) {
	      $log.info('Error occurred in Add/Update Employer', errorResponse);
	      logger.notify('error', errorResponse.data.message);
	    };
	
	    vm.changeEmployerCategory = function (categoryId) {
	      if (categoryId) {
	        vm.employer.approved = true;
	
	        vm.selectedCategory = vm.categories.find(function (category) {
	          return category.id === categoryId;
	        });
	
	        if (vm.selectedCategory.name === 'Private Practice') vm.isPrivatePractice = true;else vm.isPrivatePractice = false;
	        pageInitialize();
	      } else {
	        vm.selectedCategory = undefined;
	      }
	    };
	
	    vm.openDeleteEmployerModal = function (_employerId) {
	      var modalInstance = $uibModal.open({
	        templateUrl: 'delete-employer-modal.html',
	        controller: 'DeleteEmployerController',
	        controllerAs: 'ctrl',
	        resolve: {
	          employerId: function employerId() {
	            return _employerId;
	          }
	        }
	      });
	      modalInstance.result.then(function (deletedEmployer) {
	        if (deletedEmployer) {
	          $uibModalInstance.close({
	            employer: deletedEmployer,
	            type: 'deleted'
	          });
	        } else {
	          vm.alertMsg = 'An error has occurred. Please try again.';
	          vm.showOnError = true;
	        }
	      }, function () {});
	    };
	
	    vm.onEmployerApproved = function (approvedCheckBoxValue) {
	      if (approvedCheckBoxValue === false) {
	        vm.employer.categoryId = undefined;
	        vm.selectedCategory = undefined;
	      }
	
	      if (approvedCheckBoxValue === true && vm.employer.categoryId === undefined) {
	        logger.notify('error', 'Category must be selected for approved employer');
	        vm.employer.approved = false;
	      }
	
	      pageInitialize();
	    };
	
	    vm.openLocationModal = function (_selectedLocations, event) {
	      event.preventDefault();
	      event.stopPropagation();
	      var modalInstance = $uibModal.open({
	        templateUrl: 'locations-modal.html',
	        controller: 'LocationsModalController',
	        controllerAs: 'ctrl',
	        resolve: {
	          locationList: function locationList() {
	            return vm.locationsList;
	          },
	          selectedLocations: function selectedLocations() {
	            return _selectedLocations;
	          },
	          limit: function limit() {
	            return 0;
	          },
	          locationModalHeading: function locationModalHeading() {
	            return false;
	          },
	          displayNextButton: function displayNextButton() {
	            return false;
	          }
	        }
	      });
	      modalInstance.result.then(function (selectedLocations) {
	        vm.selectedLocation = selectedLocations.length > 0;
	        vm.employer.locations = angular.copy(selectedLocations);
	      }, function () {});
	    };
	
	    vm.openPracticeModal = function (_selectedPractice, event) {
	      event.preventDefault();
	      event.stopPropagation();
	      var onlyParentPracticeArea = vm.legalPracticeAreaList.filter(function (_ref7) {
	        var parentId = _ref7.parentId;
	        return parentId === null;
	      });
	      var modalInstance = $uibModal.open({
	        templateUrl: 'practice-area-modal.html',
	        controller: 'PracticeAreaController',
	        controllerAs: 'ctrl',
	        resolve: {
	          practiceAreaList: function practiceAreaList() {
	            return onlyParentPracticeArea;
	          },
	          selectedPractice: function selectedPractice() {
	            return _selectedPractice;
	          },
	          limit: function limit() {
	            return 0;
	          },
	          isAdminProfile: function isAdminProfile() {
	            return true;
	          },
	          displayNextButton: function displayNextButton() {
	            return false;
	          }
	        }
	      });
	      modalInstance.result.then(function (selectPractices) {
	        vm.selectedPracticesShow = selectPractices.length > 0;
	        vm.employer.practiceAreas = angular.copy(selectPractices);
	      }, function () {});
	    };
	
	    vm.loadEmployer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
	      var _ref9, employerRecord, employerStatus, _ref10, _ref11, locationsList, legalPracticeAreaList, legalEmployerTypeList, candidateAgents;
	
	      return regeneratorRuntime.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              _context6.next = 2;
	              return userService.getUser();
	
	            case 2:
	              vm.user = _context6.sent;
	
	              startSpinner();
	
	              if (!vm.selectedEmployerId) {
	                _context6.next = 17;
	                break;
	              }
	
	              _context6.prev = 5;
	              _context6.next = 8;
	              return EmployersApi.getEmployerById(vm.selectedEmployerId);
	
	            case 8:
	              _ref9 = _context6.sent;
	              employerRecord = _ref9.data;
	              employerStatus = _ref9.status;
	
	              if (employerStatus === 200) {
	                vm.employerRecord = employerRecord;
	              }
	              _context6.next = 17;
	              break;
	
	            case 14:
	              _context6.prev = 14;
	              _context6.t0 = _context6['catch'](5);
	
	              vm.changeStatus(_context6.t0.status, _context6.t0.message);
	
	            case 17:
	              _context6.next = 19;
	              return Promise.all([SharedApi.getAllLocations({
	                supported: true,
	                regions: true
	              }), SharedApi.getCategoryById(1), SharedApi.getCategoryById(2), CandidateProfileApi.getAdminAndCorporateUsers()]);
	
	            case 19:
	              _ref10 = _context6.sent;
	              _ref11 = _slicedToArray(_ref10, 4);
	              locationsList = _ref11[0].data;
	              legalPracticeAreaList = _ref11[1].data;
	              legalEmployerTypeList = _ref11[2].data;
	              candidateAgents = _ref11[3].data;
	
	              vm.candidateAgentsList = candidateAgents;
	              vm.legalPracticeAreaList = legalPracticeAreaList.specialties;
	              vm.legalEmployerTypeList = legalEmployerTypeList;
	              vm.locationsList = locationsList;
	              $timeout(function () {
	                vm.initializeEmployer();
	                stopSpinner();
	              }, 300);
	
	            case 30:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this, [[5, 14]]);
	    }));
	
	    vm.initializeEmployer = function () {
	      vm.employer = { professions: ['law'], practiceAreas: [], locations: [] };
	      vm.isPrivatePractice = true;
	      vm.employer.lawProfile = {};
	      vm.modalTitle = 'Create Employer';
	      vm.selectedPracticesShow = false;
	      vm.showPracticeButton = true;
	      vm.selectedLocation = false;
	      vm.showLocationButton = true;
	      vm.categories = vm.legalEmployerTypeList.specialties;
	      vm.selectivity = [];
	      var employerSelectivity = '';
	      for (var index = 1; index <= 6; index++) {
	        employerSelectivity += '$';
	        vm.selectivity = [].concat(_toConsumableArray(vm.selectivity), [{ id: index, name: employerSelectivity }]);
	      }
	
	      vm.selectivity = [].concat(_toConsumableArray(vm.selectivity), [{ id: 0, name: 'Uncategorized' }]);
	      if (vm.employerRecord) {
	        vm.initializeEditEmployer(vm.employerRecord);
	      }
	    };
	
	    vm.initializeEditEmployer = function (existingEmployer) {
	      vm.modalTitle = 'Edit Employer';
	      vm.editEmployerModal = true;
	      vm.employer = {
	        logo: existingEmployer.logo,
	        id: existingEmployer.id,
	        approved: existingEmployer.approved,
	        name: existingEmployer.name,
	        selectivity: existingEmployer.selectivity,
	        contactName: existingEmployer.contactName,
	        contactEmail: existingEmployer.contactEmail,
	        address: existingEmployer.address,
	        isVisible: existingEmployer.isVisible,
	        description: existingEmployer.description,
	        agentId: existingEmployer.agentId,
	        practiceAreas: [],
	        locations: []
	      };
	      vm.editableEmployerName = angular.copy(existingEmployer.name);
	
	      if (existingEmployer.professions.find(function (profession) {
	        return profession.id === 'law';
	      })) {
	        vm.employer.lawProfile = {
	          size: existingEmployer.lawProfile.size,
	          sizeVisible: existingEmployer.lawProfile.sizeVisible,
	          targetHours: existingEmployer.lawProfile.targetHours,
	          targetHoursVisible: existingEmployer.lawProfile.targetHoursVisible,
	          associatesPerPartner: existingEmployer.lawProfile.associatesPerPartner,
	          associatesPerPartnerVisible: existingEmployer.lawProfile.associatesPerPartnerVisible,
	          profitPerEquityPartner: existingEmployer.lawProfile.profitPerEquityPartner,
	          profitPerEquityPartnerVisible: existingEmployer.lawProfile.profitPerEquityPartnerVisible,
	          nqSalary: existingEmployer.lawProfile.nqSalary,
	          nqSalaryVisible: existingEmployer.lawProfile.nqSalaryVisible
	        };
	      }
	
	      if (existingEmployer.categories.length > 0) {
	        var practiceAreas = existingEmployer.categories.find(function (category) {
	          return category.id === 1;
	        });
	        var category = existingEmployer.categories.find(function (category) {
	          return category.id === 2;
	        });
	        if (practiceAreas && practiceAreas.specialties.length > 0) {
	          vm.employer.practiceAreas = practiceAreas.specialties.map(function (practiceArea) {
	            practiceArea.isSelected = true;
	            return practiceArea;
	          });
	          vm.selectedPracticesShow = practiceAreas.specialties.length > 0;
	          vm.showPracticeButton = practiceAreas.specialties.length === 0;
	        }
	
	        if (category && category.specialties.length > 0) {
	          vm.employer.categoryId = category.specialties.find(function (specialty) {
	            return specialty.categoryId === 2;
	          }).id;
	          vm.changeEmployerCategory(vm.employer.categoryId);
	        }
	      }
	
	      if (existingEmployer.locations.length > 0) vm.employer.locations = existingEmployer.locations.map(function (location) {
	        location.isSelected = true;
	        return location;
	      });
	      vm.selectedLocation = existingEmployer.locations.length > 0;
	      vm.showLocationButton = existingEmployer.locations.length === 0;
	    };
	
	    vm.loadEmployer();
	  }]);
	})();

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _loadingOverlay = __webpack_require__(20);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	(function module() {
	  angular.module('app.ui.form.ctrls').controller('CreateUpdatePositionController', ['$location', '$uibModal', 'logger', 'SharedApi', 'PositionApi', 'EmployersApi', '$scope', 'userService', function controller($location, $uibModal, logger, SharedApi, PositionApi, EmployersApi, $scope, userService) {
	    var _this = this;
	
	    var vm = this;
	    var selectedPositionId = void 0;
	    if ($location.absUrl().includes('job-edit')) {
	      selectedPositionId = $location.search().job;
	    }
	
	    vm.showOnSuccess = false;
	    vm.showOnError = false;
	    vm.alertMsg = '';
	
	    vm.pqeOptions = {
	      round: 1,
	      from: -2,
	      to: 11,
	      step: 1,
	      dimension: '+ years',
	      scale: [-2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '11+']
	    };
	
	    vm.initializePosition = function () {
	      vm.modalTitle = 'Add Position';
	      vm.editPositionModal = false;
	      vm.position = {
	        employer: {},
	        locations: [],
	        practiceAreas: [],
	        minPQE: -2,
	        maxPQE: 11,
	        pqe: '-2;11',
	        positionType: 1,
	        visible: true,
	        contractTypeId: 1,
	        occupationId: 1,
	        description: ''
	      };
	      vm.selectedPracticesShow = false;
	      vm.showPracticeButton = true;
	      vm.selectedLocation = false;
	      vm.showLocationButton = true;
	    };
	
	    vm.initializeEditPosition = function (existingPosition) {
	      vm.modalTitle = 'Edit Position';
	      vm.editPositionModal = true;
	      if (existingPosition.professionId === 'tech' || !existingPosition.lawPreferences) {
	        existingPosition.lawPreferences = {
	          minPqe: existingPosition.techPreferences && existingPosition.techPreferences.minExperience ? existingPosition.techPreferences.minExperience : -2,
	          maxPqe: 11
	        };
	      }
	
	      vm.position = {
	        title: existingPosition.title,
	        locations: existingPosition.locations,
	        expiresAt: existingPosition.expiresAt,
	        minPQE: existingPosition.lawPreferences.minPqe ? existingPosition.lawPreferences.minPqe : -2,
	        maxPQE: existingPosition.lawPreferences.maxPqe ? existingPosition.lawPreferences.maxPqe : 11,
	        pqe: existingPosition.lawPreferences.minPqe + ';' + existingPosition.lawPreferences.maxPqe,
	        visible: existingPosition.visible,
	        contractTypeId: existingPosition.contractTypeId,
	        occupationId: existingPosition.occupationId,
	        description: existingPosition.description,
	        externalUrl: existingPosition.externalUrl
	      };
	      if (existingPosition.type === 'Regular') vm.position.positionType = 1;
	      if (existingPosition.type === 'Custom') vm.position.positionType = 2;
	      if (existingPosition.type === 'Connect') vm.position.positionType = 3;
	      if (existingPosition.type === 'Speculative') vm.position.positionType = 4;
	      if (existingPosition.type === 'External') vm.position.positionType = 5;
	      if (existingPosition.specialties.length > 0) vm.position.practiceAreas = existingPosition.specialties.map(function (practiceArea) {
	        practiceArea.isSelected = true;
	        return practiceArea;
	      });
	
	      vm.selectedPracticesShow = existingPosition.specialties.length > 0;
	      vm.showPracticeButton = existingPosition.specialties.length === 0;
	
	      if (existingPosition.locations.length > 0) vm.position.locations = existingPosition.locations.map(function (location) {
	        location.isSelected = true;
	        return location;
	      });
	      vm.selectedLocation = existingPosition.locations.length > 0;
	      vm.showLocationButton = existingPosition.locations.length === 0;
	    };
	
	    vm.positionDetailEditorOptions = {
	      extraPlugins: 'colorbutton'
	    };
	
	    vm.notify = function (type, message) {
	      switch (type) {
	        case 'info':
	          logger.log(message);
	          break;
	        case 'success':
	          logger.logSuccess(message);
	          break;
	        case 'warning':
	          logger.logWarning(message);
	          break;
	        case 'error':
	          logger.logError(message);
	          break;
	        default:
	          break;
	      }
	    };
	
	    vm.pqeChange = function () {
	      var separator;
	      separator = vm.position.pqe.search(';');
	      if (separator === 1) {
	        vm.position.minPQE = Number(vm.position.pqe.slice(0, 1));
	        vm.position.maxPQE = Number(vm.position.pqe.slice(2, 5));
	      } else if (separator === 2) {
	        vm.position.minPQE = Number(vm.position.pqe.slice(0, 2));
	        vm.position.maxPQE = Number(vm.position.pqe.slice(3, 5));
	      }
	    };
	
	    vm.changeEmployer = function (employer) {
	      vm.position.employer = employer;
	      vm.position.employerId = employer.id;
	      vm.position.employer.address = employer.address;
	      vm.position.employer.isInHouse = false;
	      var employerType = employer.specialties.filter(function (_ref) {
	        var categoryId = _ref.categoryId;
	        return categoryId === 2;
	      }).map(function (employerType) {
	        return employerType.name;
	      }).join();
	      if (employerType === 'In-House') vm.position.employer.isInHouse = true;
	    };
	
	    vm.setPositionType = function (positionType) {
	      if (positionType === 1) vm.position.type = 'Regular';
	      if (positionType === 2) vm.position.type = 'Custom';
	      if (positionType === 3) vm.position.type = 'Connect';
	      if (positionType === 4) vm.position.type = 'Speculative';
	      if (positionType === 5) vm.position.type = 'External';
	      if (positionType !== 1 && positionType !== 5) vm.position.externalUrl = undefined;
	    };
	
	    var createPosition = function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var payload, _ref3, status, message, _message;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                vm.setPositionType(vm.position.positionType);
	                vm.position.description = vm.position.description ? vm.position.description : '';
	
	                if (!(vm.position.practiceAreas.length > 0 && vm.position.locations.length > 0)) {
	                  _context.next = 21;
	                  break;
	                }
	
	                payload = angular.copy(vm.position);
	                // TODO: To be discussed professionId
	
	                payload.professionId = 'law';
	                payload.lawPreferences = {
	                  minPqe: payload.minPQE,
	                  maxPqe: payload.maxPQE
	                };
	                payload.specialties = payload.practiceAreas;
	
	                delete payload.employer;
	                delete payload.positionType;
	                delete payload.pqe;
	                delete payload.practiceAreas;
	                delete payload.minPQE;
	                delete payload.maxPQE;
	                _context.next = 15;
	                return PositionApi.createPosition(payload);
	
	              case 15:
	                _ref3 = _context.sent;
	                status = _ref3.status;
	
	                if (status === 201) {
	                  vm.initializePosition();
	                  vm.notify('success', 'Position has been added successfully.');
	                } else vm.notify('error', 'An error has occurred. Please try again.');
	                $scope.$apply();
	                _context.next = 23;
	                break;
	
	              case 21:
	                if (vm.position.locations.length === 0) {
	                  message = 'Please select at least one Location.';
	
	                  vm.notify('error', message);
	                }
	
	                if (vm.position.practiceAreas.length === 0) {
	                  _message = 'Please select at least one practice area.';
	
	                  vm.notify('error', _message);
	                }
	
	              case 23:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      return function createPosition() {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    vm.createPosition = (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              return _context2.abrupt('return', createPosition());
	
	            case 1:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this);
	    })));
	
	    var updatePosition = function () {
	      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	        var payload, _ref6, status, message, _message2;
	
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                vm.setPositionType(vm.position.positionType);
	                vm.position.description = vm.position.description ? vm.position.description : '';
	
	                if (!(vm.position.practiceAreas.length > 0 && vm.position.locations.length > 0)) {
	                  _context3.next = 19;
	                  break;
	                }
	
	                payload = angular.copy(vm.position);
	
	                // To be discussed professionId
	                // payload.professionId = 'law'
	
	                payload.lawPreferences = {
	                  minPqe: payload.minPQE,
	                  maxPqe: payload.maxPQE
	                };
	                payload.specialties = payload.practiceAreas;
	
	                delete payload.employer;
	                delete payload.positionType;
	                delete payload.pqe;
	                delete payload.practiceAreas;
	                delete payload.minPQE;
	                delete payload.maxPQE;
	
	                // TODO: only update that field which are new in editable field in V1
	                // let updateDto = {}
	                // Object.keys(payload).forEach(data => {
	                //   if (payload[data] !== vm.positionRecord[data])
	                //     updateDto[data] = payload[data]
	                //   if (data === 'specialties' || data === 'locations') {
	                //     if (payload[data].length !== vm.positionRecord[data].length)
	                //       updateDto[data] = payload[data]
	                //   }
	                // })
	                // Object.keys(updateDto).forEach(
	                //   key => updateDto[key] === undefined && delete updateDto[key]
	                // )
	                //
	
	                _context3.next = 14;
	                return PositionApi.updatePositionById(vm.positionRecord.id, payload);
	
	              case 14:
	                _ref6 = _context3.sent;
	                status = _ref6.status;
	
	                if (status === 200) {
	                  vm.notify('success', 'Position updated successfully.');
	                  // Redirect to positionListing Page
	                } else vm.notify('error', 'An error has occurred. Please try again.');
	                _context3.next = 21;
	                break;
	
	              case 19:
	                if (vm.position.locations.length === 0) {
	                  message = 'Please select at least one Location.';
	
	                  vm.notify('error', message);
	                }
	
	                if (vm.position.practiceAreas.length === 0) {
	                  _message2 = 'Please select at least one practice area.';
	
	                  vm.notify('error', _message2);
	                }
	
	              case 21:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this);
	      }));
	
	      return function updatePosition() {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    vm.updatePosition = (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
	      return regeneratorRuntime.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              return _context4.abrupt('return', updatePosition());
	
	            case 1:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this);
	    })));
	
	    vm.openDeletePositionModal = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	      var modalInstance;
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              modalInstance = $uibModal.open({
	                templateUrl: 'delete-position-modal.html',
	                controller: 'DeletePositionController',
	                controllerAs: 'ctrl',
	                resolve: {
	                  positionId: function positionId() {
	                    return vm.positionRecord.id;
	                  }
	                }
	              });
	
	              modalInstance.result.then(function (deletedPosition) {
	                if (deletedPosition) {
	                  vm.alertMsg = 'Position deleted successfully.';
	                  vm.showOnSuccess = true;
	                  vm.notify('success', 'Position deleted successfully.');
	                  $location.url('/admin/admin-listings?list=jobs');
	                } else {
	                  vm.alertMsg = 'An error has occurred. Please try again.';
	                  vm.showOnError = true;
	                }
	              }, function () {});
	
	            case 2:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this);
	    }));
	
	    vm.openPracticeModal = function (_selectedPractice, event) {
	      event.preventDefault();
	      event.stopPropagation();
	      var onlyParentPracticeArea = vm.legalPracticeAreaList.filter(function (_ref9) {
	        var parentId = _ref9.parentId;
	        return parentId === null;
	      });
	      var modalInstance = $uibModal.open({
	        templateUrl: 'practice-area-modal.html',
	        controller: 'PracticeAreaController',
	        controllerAs: 'ctrl',
	        resolve: {
	          practiceAreaList: function practiceAreaList() {
	            return onlyParentPracticeArea;
	          },
	          selectedPractice: function selectedPractice() {
	            return _selectedPractice;
	          },
	          limit: function limit() {
	            return 0;
	          },
	          isAdminProfile: function isAdminProfile() {
	            return false;
	          },
	          displayNextButton: function displayNextButton() {
	            return false;
	          }
	        }
	      });
	      modalInstance.result.then(function (selectPractices) {
	        vm.selectedPracticesShow = selectPractices.length > 0;
	        vm.position.practiceAreas = angular.copy(selectPractices);
	      }, function () {});
	    };
	
	    vm.openLocationModal = function (_selectedLocations, event) {
	      event.preventDefault();
	      event.stopPropagation();
	      var modalInstance = $uibModal.open({
	        templateUrl: 'locations-modal.html',
	        controller: 'LocationsModalController',
	        controllerAs: 'ctrl',
	        resolve: {
	          locationList: function locationList() {
	            return vm.locationsList;
	          },
	          selectedLocations: function selectedLocations() {
	            return _selectedLocations;
	          },
	          limit: function limit() {
	            return 0;
	          },
	          locationModalHeading: function locationModalHeading() {
	            return false;
	          },
	          displayNextButton: function displayNextButton() {
	            return false;
	          }
	        }
	      });
	      modalInstance.result.then(function (selectedLocations) {
	        vm.selectedLocation = selectedLocations.length > 0;
	        vm.position.locations = angular.copy(selectedLocations);
	      }, function () {});
	    };
	
	    vm.changeStatus = function (status) {
	      if (status === 200) {
	        vm.alertMsg = 'Congratulations! Position has been Successfully created.';
	        vm.showOnSuccess = true;
	      } else if (status === 440) {
	        $location.url('/signin');
	      } else {
	        vm.alertMsg = 'An error has occurred. Please try again.';
	        vm.showOnError = true;
	      }
	    };
	
	    vm.showClass = '';
	    vm.hideDropDown = function () {
	      vm.showClass = '';
	    };
	
	    vm.startPosition = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
	      var _ref11, positionRecord, positionStatus, _ref12, employersList, employersStatus, employer, _ref14, legalPracticeAreaList, legalPracticeAreaStatus, _ref15, contractTypeList, _ref16, occupationList, locationDto, _ref17, locationsList, locationsStatus;
	
	      return regeneratorRuntime.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              _context6.next = 2;
	              return userService.getUser();
	
	            case 2:
	              vm.user = _context6.sent;
	
	              vm.initializePosition();
	
	              if (!selectedPositionId) {
	                _context6.next = 11;
	                break;
	              }
	
	              _context6.next = 7;
	              return PositionApi.getPositionById(selectedPositionId);
	
	            case 7:
	              _ref11 = _context6.sent;
	              positionRecord = _ref11.data;
	              positionStatus = _ref11.status;
	
	              if (positionStatus === 200) {
	                vm.positionRecord = positionRecord;
	                vm.initializeEditPosition(vm.positionRecord);
	              }
	
	            case 11:
	              _context6.next = 13;
	              return EmployersApi.getAllEmployers({
	                isDeleted: false,
	                include: ['id', 'name', 'address', 'specialties']
	              });
	
	            case 13:
	              _ref12 = _context6.sent;
	              employersList = _ref12.data;
	              employersStatus = _ref12.status;
	
	              if (employersStatus === 200) {
	                vm.employersList = employersList.sort(function (a, b) {
	                  return a.name > b.name ? 1 : -1;
	                });
	                if (selectedPositionId) {
	                  employer = vm.employersList.find(function (_ref13) {
	                    var id = _ref13.id;
	                    return vm.positionRecord.employerId === id;
	                  });
	
	                  vm.changeEmployer(employer);
	                }
	              } else vm.changeStatus(employersStatus);
	              _context6.next = 19;
	              return SharedApi.getCategoryById(1);
	
	            case 19:
	              _ref14 = _context6.sent;
	              legalPracticeAreaList = _ref14.data;
	              legalPracticeAreaStatus = _ref14.status;
	
	              if (legalPracticeAreaStatus === 200) {
	                vm.legalPracticeAreaList = legalPracticeAreaList.specialties;
	              } else vm.changeStatus(legalPracticeAreaStatus);
	              _context6.next = 25;
	              return SharedApi.getAllContractTypes();
	
	            case 25:
	              _ref15 = _context6.sent;
	              contractTypeList = _ref15.data;
	              _context6.next = 29;
	              return SharedApi.getAllOccupations();
	
	            case 29:
	              _ref16 = _context6.sent;
	              occupationList = _ref16.data;
	
	              vm.contractType = contractTypeList;
	              vm.occupations = occupationList;
	              locationDto = {
	                supported: true,
	                regions: true
	              };
	              _context6.next = 36;
	              return SharedApi.getAllLocations(locationDto);
	
	            case 36:
	              _ref17 = _context6.sent;
	              locationsList = _ref17.data;
	              locationsStatus = _ref17.status;
	
	              if (locationsStatus === 200) {
	                vm.locationsList = locationsList;
	              } else vm.changeStatus(locationsStatus);
	
	            case 40:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this);
	    }));
	
	    vm.startPosition();
	  }]);
	})();

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	'use strict';
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('DateModalController', ['$uibModalInstance', '$uibModal', 'selectedModal', '$rootScope', 'logger', 'id', function controller($uibModalInstance, $uibModal, selectedModal, $rootScope, logger, id) {
	    var vm = this;
	    $rootScope.$on('application-deleted', function (event, _ref) {
	      var applicationDeleted = _ref.applicationDeleted;
	
	      if (id === applicationDeleted) {
	        logger.notify('error', 'Application is Deleted by Other Admin');
	        $uibModalInstance.dismiss('cancel');
	      }
	    });
	    $rootScope.$on('position-deleted', function (event, _ref2) {
	      var positionDeleted = _ref2.positionDeleted;
	
	      if (Array.isArray(id) && id.find(function (_ref3) {
	        var id = _ref3.id;
	        return id === positionDeleted;
	      })) {
	        logger.notify('error', 'One of the Position selected is Deleted by Other Admin');
	        id = id.filter(function (_ref4) {
	          var id = _ref4.id;
	          return id !== positionDeleted;
	        });
	        $uibModalInstance.dismiss('cancel');
	      }
	
	      if (id === positionDeleted) {
	        logger.notify('error', 'Position is Deleted by Other Admin');
	        $uibModalInstance.dismiss('cancel');
	      }
	    });
	    vm.selectedModal = angular.copy(selectedModal);
	
	    /** When clicking 'save' button this method will save only selected child practice area from modal
	     */
	    vm.save = function () {
	      $uibModalInstance.close(vm.selectedModal);
	    };
	
	    /**  When clicking 'cancel' button this method will closed modal
	     */
	    vm.cancel = function () {
	      $uibModalInstance.dismiss('cancel');
	    };
	
	    vm.deleteConfirmationPopup = function (_title) {
	      var modalInstance = $uibModal.open({
	        templateUrl: 'delete-confirmation-modal.html',
	        controller: function controller(title) {
	          var vm = this;
	          vm.title = title;
	          vm.cancel = function () {
	            modalInstance.dismiss('cancel');
	          };
	
	          vm.confirmDelete = function () {
	            modalInstance.close(true);
	          };
	        },
	        controllerAs: 'ctrl',
	        resolve: {
	          title: function title() {
	            return _title;
	          }
	        }
	      });
	      modalInstance.result.then(function (isDeleted) {
	        vm.selectedModal.isDeleted = isDeleted;
	        $uibModalInstance.close(vm.selectedModal);
	      }, function () {});
	    };
	  }]);
	})();

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('DeletePositionController', ['positionId', '$uibModalInstance', 'PositionApi', '$rootScope', function controller(positionId, $uibModalInstance, PositionApi, $rootScope) {
	    var _this = this;
	
	    var vm = this;
	    vm.positionId = positionId;
	
	    vm.cancel = function () {
	      $uibModalInstance.dismiss('cancel');
	    };
	
	    vm.delete = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var _ref2, status;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              $rootScope.isPositionDeleted = true;
	              _context.next = 3;
	              return PositionApi.deletePositionById(vm.positionId);
	
	            case 3:
	              _ref2 = _context.sent;
	              status = _ref2.status;
	
	              if (status === 200) $uibModalInstance.close(true);else $uibModalInstance.close(false);
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	  }]);
	})();

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/* eslint-disable unicorn/no-reduce */
	/* eslint-disable array-callback-return */
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('LocationsModalController', ['$uibModalInstance', 'locationList', 'selectedLocations', 'locationsGenericService', 'limit', 'logger', 'locationModalHeading', 'displayNextButton', function controller($uibModalInstance, locationList, selectedLocations, locationsGenericService, limit, logger, locationModalHeading, displayNextButton) {
	    var vm = this;
	    /** Setting Location list in this controller scope.
	     */
	    vm.locationList = angular.copy(locationList);
	    vm.regionHierarchialList = locationsGenericService.initialize(selectedLocations, vm.locationList);
	    vm.locationModalHeading = locationModalHeading;
	    vm.displayNextButton = displayNextButton;
	    vm.regionHierarchialList.sort(function (a, b) {
	      return a.name > b.name ? 1 : -1;
	    });
	    vm.regionHierarchialListWithEuropeOnTop = [].concat(_toConsumableArray(vm.regionHierarchialList.filter(function (region) {
	      return region.name === 'Europe';
	    })), _toConsumableArray(vm.regionHierarchialList.filter(function (region) {
	      return region.name !== 'Europe';
	    })));
	
	    /** This method will expand locations on '+' is clicked
	     */
	    vm.expandChildLocations = function (location) {
	      location.showLocations = true;
	    };
	
	    /** This method will collapse locations on '-' is clicked
	     */
	    vm.collapseChildLocations = function (location) {
	      location.showLocations = false;
	    };
	
	    /** When clicking 'save' button this method will save only selected child Locations from modal
	     */
	    vm.save = function () {
	      var selectedLocations = locationsGenericService.setIsSelectedChildrenLocation(vm.regionHierarchialListWithEuropeOnTop, []);
	
	      if (selectedLocations.length === 0) logger.notify('warning', 'Please select at least one Location.');else $uibModalInstance.close(selectedLocations);
	    };
	
	    /** When clicking 'cancel' button this method will closed modal
	     */
	    vm.cancel = function () {
	      $uibModalInstance.dismiss('cancel');
	    };
	
	    /** This method will make selected locations checked or unchecked and make parent and child selected and unselected
	     * @param  {} selectedValue selected location from modal
	     * @param  {} event modal event of i.e checked or unchecked
	     */
	    vm.selectLocation = function (selectedValue, event) {
	      if (limit > 0) {
	        var count = vm.regionHierarchialListWithEuropeOnTop.filter(function (location) {
	          return location.isSelected;
	        }).map(function (region) {
	          return region.locations.reduce(function (locationCount, location) {
	            return locationCount + getSelectedCount([location], false);
	          }, 0);
	        }).reduce(function (totalCount, eachCount) {
	          return totalCount + eachCount;
	        }, 0);
	
	        locationsGenericService.selectOrDeselectAllLocations([selectedValue], true);
	
	        count = event.target.checked ? selectedValue.children && selectedValue.children.length > 0 ? count + getSelectedCount([selectedValue], true) : selectedValue.locations && selectedValue.locations ? count + selectedValue.locations.reduce(function (locationCount, location) {
	          return locationCount + getSelectedCount([location], true);
	        }, 0) : count + 1 : selectedValue.children && selectedValue.children.length > 0 ? count - getSelectedCount([selectedValue], true) : selectedValue.locations && selectedValue.locations ? count - selectedValue.locations.reduce(function (locationCount, location) {
	          return locationCount + getSelectedCount([location], true);
	        }, 0) : count - 1;
	
	        if (count > limit - 5 && count < limit && count > 0) logger.notify('warning', 'You are approaching the limit for location selections.');
	        if (count === limit && count > 1) logger.notify('warning', ' You have reached the limit for location selections, please refine your expertise to only those locations you have actual experience in.');else if (count > limit && count > 0) {
	          logger.notify('error', 'You are allowed to choose a maximum of ' + limit + ' locations.');
	          selectedValue.isSelected = false;
	          event.target.checked = false;
	        }
	      }
	
	      locationsGenericService.selectLocation(vm.regionHierarchialListWithEuropeOnTop, selectedValue, event);
	    };
	  }]);
	})();
	
	var getSelectedCount = function getSelectedCount(locations, selected) {
	  return locations.reduce(function (count, location) {
	    if (location.isSelected || selected) {
	      if (location.children && location.children.length > 0) {
	        return count + getSelectedCount(location.children, selected);
	      }
	
	      count += 1;
	    }
	
	    return count;
	  }, 0);
	};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('PositionDetailsController', function controller(position, listingName, PositionApi) {
	    var _this = this;
	
	    var vm = this;
	    vm.position = position;
	    var setPositionRecord = function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
	        var _ref2, data;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return PositionApi.getPositionById(id);
	
	              case 2:
	                _ref2 = _context.sent;
	                data = _ref2.data;
	
	                vm.position.employer.name = data.employer.name;
	                vm.position.description = data.description;
	                vm.position.locations = data.locations;
	                vm.position.specialtiesName = data.specialties.length > 0 ? data.specialties.map(function (specialty) {
	                  return specialty.name;
	                }) : [];
	                vm.position.employerType = vm.position.employer.type ? typeof vm.position.employer.type === 'string' ? vm.position.employer.type : vm.position.employer.type.join() : '';
	                vm.position.specialtiesName = [].concat(_toConsumableArray(new Set(vm.position.specialtiesName)));
	                vm.position.externalUrlLink = vm.position.externalUrl ? vm.position.externalUrl.match(/http/) ? vm.position.externalUrl : 'http://'.concat(vm.position.externalUrl) : vm.position.externalUrl;
	                vm.position.employer.picSrc = data.employer.logo ? ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/employers/' + data.employerId + '/logo/' + data.employer.logo : '/images/firmlogo_Default.png';
	
	              case 12:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      return function setPositionRecord(_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    setPositionRecord(vm.position.id, vm);
	  });
	})();

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PracticeAreaDropdownController = exports.PracticeAreaDropdownController = function PracticeAreaDropdownController($scope, practiceAreaService) {
	  // $('.bootstrapDropdown').click(stopEventExecution)
	  $scope.openPracticeAreaDropDown = function (event) {
	    event.stopPropagation();
	  };
	
	  if ($scope.allChecked) {
	    practiceAreaService.initialize([], $scope.practiceAreasList, true);
	  }
	
	  $scope.selectAllPracticeArea = function () {
	    practiceAreaService.selectOrDeselectAllPractices($scope.practiceAreasList, true);
	    updatePracticeAreaDropdown();
	  };
	
	  /** This method will expand practice area on '+' is clicked
	   */
	  $scope.expandChildPracticeArea = function (practiceArea) {
	    practiceArea.showChildren = true;
	  };
	
	  /** This method will collapse practice area on '-' is clicked
	   */
	  $scope.collapseChildPracticeArea = function (practiceArea) {
	    practiceArea.showChildren = false;
	  };
	
	  $scope.deselectAllPracticeAreas = function () {
	    practiceAreaService.selectOrDeselectAllPractices($scope.practiceAreasList, false);
	
	    updatePracticeAreaDropdown();
	  };
	
	  $scope.selectPracticeArea = function (selectedValue, event) {
	    console.debug('PracticeAreaDropdownController::selectPracticeArea', {
	      practiceAreasList: $scope.practiceAreasList,
	      selectedValue: selectedValue,
	      event: event
	    });
	    practiceAreaService.selectPracticeArea($scope.practiceAreasList, selectedValue, event);
	    updatePracticeAreaDropdown();
	  };
	
	  var updatePracticeAreaDropdown = function updatePracticeAreaDropdown() {
	    var selectedPracticeArea = practiceAreaService.setIsSelectedChildrenPracticeArea($scope.practiceAreasList, []);
	
	    console.debug('PracticeAreaDropdownController::updatePracticeAreaDropdown:selectedPracticeArea', selectedPracticeArea);
	    $scope.onPracticeChange({ selectedPracticeArea: selectedPracticeArea });
	  };
	};

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	'use strict';
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('PracticeAreaController', ['$uibModalInstance', 'practiceAreaList', 'selectedPractice', 'practiceAreaService', 'limit', 'logger', 'isAdminProfile', 'displayNextButton', function controller($uibModalInstance, practiceAreaList, selectedPractice, practiceAreaService, limit, logger, isAdminProfile, displayNextButton) {
	    var vm = this;
	
	    // Setting practiceArea list in this controller scope.
	    vm.practiceAreasList = angular.copy(practiceAreaList);
	    vm.displayNextButton = displayNextButton;
	
	    if (selectedPractice) practiceAreaService.initialize(selectedPractice, vm.practiceAreasList, false);
	
	    /** This method will expand practice area on '+' is clicked
	     */
	    vm.expandChildPracticeArea = function (practiceArea) {
	      practiceArea.showChildren = true;
	    };
	
	    /** This method will collapse practice area on '-' is clicked
	     */
	    vm.collapseChildPracticeArea = function (practiceArea) {
	      practiceArea.showChildren = false;
	    };
	
	    /** When clicking 'save' button this method will save only selected child practice area from modal
	     */
	    vm.save = function () {
	      var selectedPracticeArea = practiceAreaService.setIsSelectedChildrenPracticeArea(vm.practiceAreasList, []);
	      if (selectedPracticeArea.length === 0 && !isAdminProfile) logger.notify('warning', 'Please select at least one Practice Area.');else if (limit && selectedPracticeArea.length > limit) logger.notify('error', 'You are allowed to choose a maximum of ' + limit + ' practice areas.');else $uibModalInstance.close(selectedPracticeArea);
	    };
	
	    /**  When clicking 'cancel' button this method will closed modal
	     */
	    vm.cancel = function () {
	      $uibModalInstance.dismiss('cancel');
	    };
	
	    /** This method will make selected practice area checked or unchecked and make parent and child selected and unselected
	     * @param  {} selectedValue practice area
	     * @param  {} event checked or unchecked
	     */
	    vm.selectPracticeArea = function (selectedValue, event) {
	      if (limit > 0) {
	        var count = getSelectedCount(vm.practiceAreasList.filter(function (practiceArea) {
	          return practiceArea.isSelected;
	        }));
	        practiceAreaService.selectOrDeselectAllPractices([selectedValue], true);
	
	        count = event.target.checked ? selectedValue.children ? count + getSelectedCount([selectedValue]) : count + 1 : selectedValue.children ? count - getSelectedCount([selectedValue]) : count - 1;
	
	        if (count > 0 && count > limit - 5 && count < limit) {
	          if (count >= 4) logger.notify('warning', 'You are approaching the limit for practice area selections.');
	        }
	
	        if (count > 0 && count === limit) logger.notify('warning', ' You have reached the limit for practice area selections, please refine your expertise to only those practice areas you have actual experience in.');else if (count > 0 && count > limit) {
	          logger.notify('error', 'You are allowed to choose a maximum of ' + limit + ' practice areas.');
	          selectedValue.isSelected = false;
	          event.target.checked = false;
	        }
	      }
	
	      practiceAreaService.selectPracticeArea(vm.practiceAreasList, selectedValue, event);
	    };
	  }]);
	})();
	
	var getSelectedCount = function getSelectedCount(allPractices) {
	  // eslint-disable-next-line unicorn/no-reduce
	  return allPractices.reduce(function (count, practiceArea) {
	    if (practiceArea.isSelected) {
	      if (practiceArea.children) {
	        return count + getSelectedCount(practiceArea.children);
	      }
	
	      count += 1;
	    }
	
	    return count;
	  }, 0);
	};

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('filterOpportunities', ["$log", "$filter", 'sharedProperties', function ($log, $filter, sharedProperties) {
	  return function (filterPractice, filterLocation, filterPQE, firmsList) {
	    var filteredFirms;
	    filteredFirms = angular.copy(firmsList);
	    if (sharedProperties.isNotNullOrEmpty(filterLocation) && filterLocation !== "All") {
	      filteredFirms = $filter('filterLocations')(filteredFirms, filterLocation);
	    }
	    if (sharedProperties.isNotNullOrEmpty(filterPractice)) {
	      filteredFirms = $filter('selectedTags')(filteredFirms, filterPractice);
	    }
	    if (!_.isNaN(filterPQE) && filterPQE !== "All") {
	      filteredFirms = $filter('filterJobsByPQE')(filteredFirms, filterPQE);
	    }
	    return filteredFirms;
	  };
	}]);

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLocationColorAndFlag = exports.getLocationFlag = exports.getLocationColor = exports.getLocation = exports.locationsList = undefined;
	
	var _flagEmoji = __webpack_require__(736);
	
	var locationsList = exports.locationsList = [{
	  id: 1,
	  name: 'United Kingdom',
	  countryCode: 'GB',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 2,
	  name: 'Belgium',
	  countryCode: 'BE',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'BE',
	    name: 'Belgium',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 3,
	  name: 'Czech Republic',
	  countryCode: 'CZ',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'CZ',
	    name: 'Czech Republic',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 4,
	  name: 'Finland',
	  countryCode: 'FI',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'FI',
	    name: 'Finland',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 5,
	  name: 'France',
	  countryCode: 'FR',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'FR',
	    name: 'France',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 6,
	  name: 'Germany',
	  countryCode: 'DE',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'DE',
	    name: 'Germany',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 7,
	  name: 'Hungary',
	  countryCode: 'HU',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'HU',
	    name: 'Hungary',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 8,
	  name: 'Ireland',
	  countryCode: 'IE',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'IE',
	    name: 'Ireland',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 9,
	  name: 'Italy',
	  countryCode: 'IT',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'IT',
	    name: 'Italy',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 10,
	  name: 'Luxembourg',
	  countryCode: 'LU',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'LU',
	    name: 'Luxembourg',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 11,
	  name: 'Netherlands',
	  countryCode: 'NL',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'NL',
	    name: 'Netherlands',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 12,
	  name: 'Poland',
	  countryCode: 'PL',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'PL',
	    name: 'Poland',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 13,
	  name: 'Romania',
	  countryCode: 'RO',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'RO',
	    name: 'Romania',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 14,
	  name: 'Russia',
	  countryCode: 'RU',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'RU',
	    name: 'Russia',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 15,
	  name: 'Slovakia',
	  countryCode: 'SK',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'SK',
	    name: 'Slovakia',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 16,
	  name: 'Spain',
	  countryCode: 'ES',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'ES',
	    name: 'Spain',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 17,
	  name: 'Sweden',
	  countryCode: 'SE',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'SE',
	    name: 'Sweden',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 18,
	  name: 'Switzerland',
	  countryCode: 'CH',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'CH',
	    name: 'Switzerland',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 19,
	  name: 'Turkey',
	  countryCode: 'TR',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'TR',
	    name: 'Turkey',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 20,
	  name: 'Australia',
	  countryCode: 'AU',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'AU',
	    name: 'Australia',
	    supported: true,
	    region: {
	      id: 8,
	      name: 'Oceania',
	      supported: true,
	      color: 'grey'
	    }
	  }
	}, {
	  id: 21,
	  name: 'New Zealand',
	  countryCode: 'NZ',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'NZ',
	    name: 'New Zealand',
	    supported: true,
	    region: {
	      id: 8,
	      name: 'Oceania',
	      supported: true,
	      color: 'grey'
	    }
	  }
	}, {
	  id: 22,
	  name: 'China',
	  countryCode: 'CN',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'CN',
	    name: 'China',
	    supported: true,
	    region: {
	      id: 3,
	      name: 'Asia',
	      supported: true,
	      color: 'cyan'
	    }
	  }
	}, {
	  id: 23,
	  name: 'Hong Kong',
	  countryCode: 'HK',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'HK',
	    name: 'Hong Kong',
	    supported: true,
	    region: {
	      id: 3,
	      name: 'Asia',
	      supported: true,
	      color: 'cyan'
	    }
	  }
	}, {
	  id: 24,
	  name: 'India',
	  countryCode: 'IN',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'IN',
	    name: 'India',
	    supported: true,
	    region: {
	      id: 3,
	      name: 'Asia',
	      supported: true,
	      color: 'cyan'
	    }
	  }
	}, {
	  id: 25,
	  name: 'Indonesia',
	  countryCode: 'ID',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'ID',
	    name: 'Indonesia',
	    supported: true,
	    region: {
	      id: 3,
	      name: 'Asia',
	      supported: true,
	      color: 'cyan'
	    }
	  }
	}, {
	  id: 26,
	  name: 'Japan',
	  countryCode: 'JP',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'JP',
	    name: 'Japan',
	    supported: true,
	    region: {
	      id: 3,
	      name: 'Asia',
	      supported: true,
	      color: 'cyan'
	    }
	  }
	}, {
	  id: 27,
	  name: 'South Korea',
	  countryCode: 'KR',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'KR',
	    name: 'South Korea',
	    supported: true,
	    region: {
	      id: 3,
	      name: 'Asia',
	      supported: true,
	      color: 'cyan'
	    }
	  }
	}, {
	  id: 28,
	  name: 'Myanmar [Burma]',
	  countryCode: 'MM',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'MM',
	    name: 'Myanmar [Burma]',
	    supported: true,
	    region: {
	      id: 3,
	      name: 'Asia',
	      supported: true,
	      color: 'cyan'
	    }
	  }
	}, {
	  id: 29,
	  name: 'Singapore',
	  countryCode: 'SG',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'SG',
	    name: 'Singapore',
	    supported: true,
	    region: {
	      id: 3,
	      name: 'Asia',
	      supported: true,
	      color: 'cyan'
	    }
	  }
	}, {
	  id: 30,
	  name: 'Thailand',
	  countryCode: 'TH',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'TH',
	    name: 'Thailand',
	    supported: true,
	    region: {
	      id: 3,
	      name: 'Asia',
	      supported: true,
	      color: 'cyan'
	    }
	  }
	}, {
	  id: 31,
	  name: 'Vietnam',
	  countryCode: 'VN',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'VN',
	    name: 'Vietnam',
	    supported: true,
	    region: {
	      id: 3,
	      name: 'Asia',
	      supported: true,
	      color: 'cyan'
	    }
	  }
	}, {
	  id: 32,
	  name: 'Qatar',
	  countryCode: 'QA',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'QA',
	    name: 'Qatar',
	    supported: true,
	    region: {
	      id: 6,
	      name: 'Middle East',
	      supported: true,
	      color: 'red'
	    }
	  }
	}, {
	  id: 33,
	  name: 'Saudi Arabia',
	  countryCode: 'SA',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'SA',
	    name: 'Saudi Arabia',
	    supported: true,
	    region: {
	      id: 6,
	      name: 'Middle East',
	      supported: true,
	      color: 'red'
	    }
	  }
	}, {
	  id: 34,
	  name: 'United Arab Emirates',
	  countryCode: 'AE',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'AE',
	    name: 'United Arab Emirates',
	    supported: true,
	    region: {
	      id: 6,
	      name: 'Middle East',
	      supported: true,
	      color: 'red'
	    }
	  }
	}, {
	  id: 35,
	  name: 'Bermuda',
	  countryCode: 'BM',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'BM',
	    name: 'Bermuda',
	    supported: true,
	    region: {
	      id: 9,
	      name: 'Offshore',
	      supported: true,
	      color: 'pink'
	    }
	  }
	}, {
	  id: 36,
	  name: 'British Virgin Islands',
	  countryCode: 'VG',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'VG',
	    name: 'British Virgin Islands',
	    supported: true,
	    region: {
	      id: 9,
	      name: 'Offshore',
	      supported: true,
	      color: 'pink'
	    }
	  }
	}, {
	  id: 37,
	  name: 'Cayman Islands',
	  countryCode: 'KY',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'KY',
	    name: 'Cayman Islands',
	    supported: true,
	    region: {
	      id: 9,
	      name: 'Offshore',
	      supported: true,
	      color: 'pink'
	    }
	  }
	}, {
	  id: 38,
	  name: 'Cyprus',
	  countryCode: 'CY',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'CY',
	    name: 'Cyprus',
	    supported: true,
	    region: {
	      id: 9,
	      name: 'Offshore',
	      supported: true,
	      color: 'pink'
	    }
	  }
	}, {
	  id: 39,
	  name: 'Guernsey',
	  countryCode: 'GG',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'GG',
	    name: 'Guernsey',
	    supported: true,
	    region: {
	      id: 9,
	      name: 'Offshore',
	      supported: true,
	      color: 'pink'
	    }
	  }
	}, {
	  id: 40,
	  name: 'Isle of Man',
	  countryCode: 'IM',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'IM',
	    name: 'Isle of Man',
	    supported: true,
	    region: {
	      id: 9,
	      name: 'Offshore',
	      supported: true,
	      color: 'pink'
	    }
	  }
	}, {
	  id: 41,
	  name: 'Jersey',
	  countryCode: 'JE',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'JE',
	    name: 'Jersey',
	    supported: true,
	    region: {
	      id: 9,
	      name: 'Offshore',
	      supported: true,
	      color: 'pink'
	    }
	  }
	}, {
	  id: 42,
	  name: 'Malta',
	  countryCode: 'MT',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'MT',
	    name: 'Malta',
	    supported: true,
	    region: {
	      id: 9,
	      name: 'Offshore',
	      supported: true,
	      color: 'pink'
	    }
	  }
	}, {
	  id: 43,
	  name: 'Mauritius',
	  countryCode: 'MU',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'MU',
	    name: 'Mauritius',
	    supported: true,
	    region: {
	      id: 9,
	      name: 'Offshore',
	      supported: true,
	      color: 'pink'
	    }
	  }
	}, {
	  id: 44,
	  name: 'Seychelles',
	  countryCode: 'SC',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'SC',
	    name: 'Seychelles',
	    supported: true,
	    region: {
	      id: 9,
	      name: 'Offshore',
	      supported: true,
	      color: 'pink'
	    }
	  }
	}, {
	  id: 45,
	  name: 'Canada',
	  countryCode: 'CA',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'CA',
	    name: 'Canada',
	    supported: true,
	    region: {
	      id: 7,
	      name: 'North America',
	      supported: true,
	      color: 'green'
	    }
	  }
	}, {
	  id: 46,
	  name: 'United States',
	  countryCode: 'US',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'US',
	    name: 'United States',
	    supported: true,
	    region: {
	      id: 7,
	      name: 'North America',
	      supported: true,
	      color: 'green'
	    }
	  }
	}, {
	  id: 47,
	  name: 'Argentina',
	  countryCode: 'AR',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'AR',
	    name: 'Argentina',
	    supported: true,
	    region: {
	      id: 5,
	      name: 'Latin America',
	      supported: true,
	      color: 'yellow'
	    }
	  }
	}, {
	  id: 48,
	  name: 'Brazil',
	  countryCode: 'BR',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'BR',
	    name: 'Brazil',
	    supported: true,
	    region: {
	      id: 5,
	      name: 'Latin America',
	      supported: true,
	      color: 'yellow'
	    }
	  }
	}, {
	  id: 49,
	  name: 'Chile',
	  countryCode: 'CL',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'CL',
	    name: 'Chile',
	    supported: true,
	    region: {
	      id: 5,
	      name: 'Latin America',
	      supported: true,
	      color: 'yellow'
	    }
	  }
	}, {
	  id: 50,
	  name: 'Mexico',
	  countryCode: 'MX',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'MX',
	    name: 'Mexico',
	    supported: true,
	    region: {
	      id: 5,
	      name: 'Latin America',
	      supported: true,
	      color: 'yellow'
	    }
	  }
	}, {
	  id: 51,
	  name: 'Peru',
	  countryCode: 'PE',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'PE',
	    name: 'Peru',
	    supported: true,
	    region: {
	      id: 5,
	      name: 'Latin America',
	      supported: true,
	      color: 'yellow'
	    }
	  }
	}, {
	  id: 52,
	  name: 'Venezuela',
	  countryCode: 'VE',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'VE',
	    name: 'Venezuela',
	    supported: true,
	    region: {
	      id: 5,
	      name: 'Latin America',
	      supported: true,
	      color: 'yellow'
	    }
	  }
	}, {
	  id: 53,
	  name: 'Morocco',
	  countryCode: 'MA',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'MA',
	    name: 'Morocco',
	    supported: true,
	    region: {
	      id: 1,
	      name: 'Africa',
	      supported: true,
	      color: 'orange'
	    }
	  }
	}, {
	  id: 54,
	  name: 'South Africa',
	  countryCode: 'ZA',
	  parentId: null,
	  supported: true,
	  parent: null,
	  country: {
	    code: 'ZA',
	    name: 'South Africa',
	    supported: true,
	    region: {
	      id: 1,
	      name: 'Africa',
	      supported: true,
	      color: 'orange'
	    }
	  }
	}, {
	  id: 251,
	  name: 'London',
	  countryCode: 'GB',
	  parentId: 1,
	  supported: true,
	  parent: {
	    id: 1,
	    name: 'United Kingdom',
	    countryCode: 'GB',
	    parentId: null,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 252,
	  name: 'North East England',
	  countryCode: 'GB',
	  parentId: 1,
	  supported: true,
	  parent: {
	    id: 1,
	    name: 'United Kingdom',
	    countryCode: 'GB',
	    parentId: null,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 253,
	  name: 'North West England',
	  countryCode: 'GB',
	  parentId: 1,
	  supported: true,
	  parent: {
	    id: 1,
	    name: 'United Kingdom',
	    countryCode: 'GB',
	    parentId: null,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 254,
	  name: 'South West England',
	  countryCode: 'GB',
	  parentId: 1,
	  supported: true,
	  parent: {
	    id: 1,
	    name: 'United Kingdom',
	    countryCode: 'GB',
	    parentId: null,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 255,
	  name: 'South East England',
	  countryCode: 'GB',
	  parentId: 1,
	  supported: true,
	  parent: {
	    id: 1,
	    name: 'United Kingdom',
	    countryCode: 'GB',
	    parentId: null,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 256,
	  name: 'N. Ireland',
	  countryCode: 'GB',
	  parentId: 1,
	  supported: true,
	  parent: {
	    id: 1,
	    name: 'United Kingdom',
	    countryCode: 'GB',
	    parentId: null,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 257,
	  name: 'Scotland',
	  countryCode: 'GB',
	  parentId: 1,
	  supported: true,
	  parent: {
	    id: 1,
	    name: 'United Kingdom',
	    countryCode: 'GB',
	    parentId: null,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 258,
	  name: 'Midlands',
	  countryCode: 'GB',
	  parentId: 1,
	  supported: true,
	  parent: {
	    id: 1,
	    name: 'United Kingdom',
	    countryCode: 'GB',
	    parentId: null,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 259,
	  name: 'Adelaide',
	  countryCode: 'AU',
	  parentId: 20,
	  supported: true,
	  parent: {
	    id: 20,
	    name: 'Australia',
	    countryCode: 'AU',
	    parentId: null,
	    supported: true
	  },
	  country: {
	    code: 'AU',
	    name: 'Australia',
	    supported: true,
	    region: {
	      id: 8,
	      name: 'Oceania',
	      supported: true,
	      color: 'grey'
	    }
	  }
	}, {
	  id: 260,
	  name: 'Brisbane',
	  countryCode: 'AU',
	  parentId: 20,
	  supported: true,
	  parent: {
	    id: 20,
	    name: 'Australia',
	    countryCode: 'AU',
	    parentId: null,
	    supported: true
	  },
	  country: {
	    code: 'AU',
	    name: 'Australia',
	    supported: true,
	    region: {
	      id: 8,
	      name: 'Oceania',
	      supported: true,
	      color: 'grey'
	    }
	  }
	}, {
	  id: 261,
	  name: 'Melbourne',
	  countryCode: 'AU',
	  parentId: 20,
	  supported: true,
	  parent: {
	    id: 20,
	    name: 'Australia',
	    countryCode: 'AU',
	    parentId: null,
	    supported: true
	  },
	  country: {
	    code: 'AU',
	    name: 'Australia',
	    supported: true,
	    region: {
	      id: 8,
	      name: 'Oceania',
	      supported: true,
	      color: 'grey'
	    }
	  }
	}, {
	  id: 262,
	  name: 'Perth',
	  countryCode: 'AU',
	  parentId: 20,
	  supported: true,
	  parent: {
	    id: 20,
	    name: 'Australia',
	    countryCode: 'AU',
	    parentId: null,
	    supported: true
	  },
	  country: {
	    code: 'AU',
	    name: 'Australia',
	    supported: true,
	    region: {
	      id: 8,
	      name: 'Oceania',
	      supported: true,
	      color: 'grey'
	    }
	  }
	}, {
	  id: 263,
	  name: 'Sydney',
	  countryCode: 'AU',
	  parentId: 20,
	  supported: true,
	  parent: {
	    id: 20,
	    name: 'Australia',
	    countryCode: 'AU',
	    parentId: null,
	    supported: true
	  },
	  country: {
	    code: 'AU',
	    name: 'Australia',
	    supported: true,
	    region: {
	      id: 8,
	      name: 'Oceania',
	      supported: true,
	      color: 'grey'
	    }
	  }
	}, {
	  id: 264,
	  name: 'Auckland',
	  countryCode: 'NZ',
	  parentId: 21,
	  supported: true,
	  parent: {
	    id: 21,
	    name: 'New Zealand',
	    countryCode: 'NZ',
	    parentId: null,
	    supported: true
	  },
	  country: {
	    code: 'NZ',
	    name: 'New Zealand',
	    supported: true,
	    region: {
	      id: 8,
	      name: 'Oceania',
	      supported: true,
	      color: 'grey'
	    }
	  }
	}, {
	  id: 265,
	  name: 'Christchurch',
	  countryCode: 'NZ',
	  parentId: 21,
	  supported: true,
	  parent: {
	    id: 21,
	    name: 'New Zealand',
	    countryCode: 'NZ',
	    parentId: null,
	    supported: true
	  },
	  country: {
	    code: 'NZ',
	    name: 'New Zealand',
	    supported: true,
	    region: {
	      id: 8,
	      name: 'Oceania',
	      supported: true,
	      color: 'grey'
	    }
	  }
	}, {
	  id: 266,
	  name: 'Wellington',
	  countryCode: 'NZ',
	  parentId: 21,
	  supported: true,
	  parent: {
	    id: 21,
	    name: 'New Zealand',
	    countryCode: 'NZ',
	    parentId: null,
	    supported: true
	  },
	  country: {
	    code: 'NZ',
	    name: 'New Zealand',
	    supported: true,
	    region: {
	      id: 8,
	      name: 'Oceania',
	      supported: true,
	      color: 'grey'
	    }
	  }
	}, {
	  id: 267,
	  name: 'Newcastle',
	  countryCode: 'GB',
	  parentId: 252,
	  supported: true,
	  parent: {
	    id: 252,
	    name: 'North East England',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 268,
	  name: 'Sheffield',
	  countryCode: 'GB',
	  parentId: 252,
	  supported: true,
	  parent: {
	    id: 252,
	    name: 'North East England',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 269,
	  name: 'Leeds',
	  countryCode: 'GB',
	  parentId: 253,
	  supported: true,
	  parent: {
	    id: 253,
	    name: 'North West England',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 270,
	  name: 'Liverpool',
	  countryCode: 'GB',
	  parentId: 253,
	  supported: true,
	  parent: {
	    id: 253,
	    name: 'North West England',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 271,
	  name: 'Manchester',
	  countryCode: 'GB',
	  parentId: 253,
	  supported: true,
	  parent: {
	    id: 253,
	    name: 'North West England',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 272,
	  name: 'Bristol',
	  countryCode: 'GB',
	  parentId: 254,
	  supported: true,
	  parent: {
	    id: 254,
	    name: 'South West England',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 273,
	  name: 'Exeter',
	  countryCode: 'GB',
	  parentId: 254,
	  supported: true,
	  parent: {
	    id: 254,
	    name: 'South West England',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 274,
	  name: 'Wales',
	  countryCode: 'GB',
	  parentId: 254,
	  supported: true,
	  parent: {
	    id: 254,
	    name: 'South West England',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 275,
	  name: 'Cambridge',
	  countryCode: 'GB',
	  parentId: 255,
	  supported: true,
	  parent: {
	    id: 255,
	    name: 'South East England',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 276,
	  name: 'Milton Keynes',
	  countryCode: 'GB',
	  parentId: 255,
	  supported: true,
	  parent: {
	    id: 255,
	    name: 'South East England',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 277,
	  name: 'Oxford',
	  countryCode: 'GB',
	  parentId: 255,
	  supported: true,
	  parent: {
	    id: 255,
	    name: 'South East England',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 278,
	  name: 'Portsmouth',
	  countryCode: 'GB',
	  parentId: 255,
	  supported: true,
	  parent: {
	    id: 255,
	    name: 'South East England',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 279,
	  name: 'Reading',
	  countryCode: 'GB',
	  parentId: 255,
	  supported: true,
	  parent: {
	    id: 255,
	    name: 'South East England',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 280,
	  name: 'Southampton',
	  countryCode: 'GB',
	  parentId: 255,
	  supported: true,
	  parent: {
	    id: 255,
	    name: 'South East England',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 281,
	  name: 'Winchester',
	  countryCode: 'GB',
	  parentId: 255,
	  supported: true,
	  parent: {
	    id: 255,
	    name: 'South East England',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 282,
	  name: 'Belfast',
	  countryCode: 'GB',
	  parentId: 256,
	  supported: true,
	  parent: {
	    id: 256,
	    name: 'N. Ireland',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 283,
	  name: 'Aberdeen',
	  countryCode: 'GB',
	  parentId: 257,
	  supported: true,
	  parent: {
	    id: 257,
	    name: 'Scotland',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 284,
	  name: 'Edinburgh',
	  countryCode: 'GB',
	  parentId: 257,
	  supported: true,
	  parent: {
	    id: 257,
	    name: 'Scotland',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 285,
	  name: 'Glasgow',
	  countryCode: 'GB',
	  parentId: 257,
	  supported: true,
	  parent: {
	    id: 257,
	    name: 'Scotland',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 286,
	  name: 'Birmingham',
	  countryCode: 'GB',
	  parentId: 258,
	  supported: true,
	  parent: {
	    id: 258,
	    name: 'Midlands',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 287,
	  name: 'Coventry',
	  countryCode: 'GB',
	  parentId: 258,
	  supported: true,
	  parent: {
	    id: 258,
	    name: 'Midlands',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 288,
	  name: 'Leicester',
	  countryCode: 'GB',
	  parentId: 258,
	  supported: true,
	  parent: {
	    id: 258,
	    name: 'Midlands',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}, {
	  id: 289,
	  name: 'Nottingham',
	  countryCode: 'GB',
	  parentId: 258,
	  supported: true,
	  parent: {
	    id: 258,
	    name: 'Midlands',
	    countryCode: 'GB',
	    parentId: 1,
	    supported: true
	  },
	  country: {
	    code: 'GB',
	    name: 'United Kingdom',
	    supported: true,
	    region: {
	      id: 4,
	      name: 'Europe',
	      supported: true,
	      color: 'magenta'
	    }
	  }
	}]; /* eslint-disable unicorn/no-null */
	var getLocation = exports.getLocation = function getLocation(locationName) {
	  if (!locationName) return {
	    code: 'GB',
	    name: 'Unknown',
	    region: { id: 4, name: 'Europe', supported: true, color: 'magenta' }
	  };
	  var location = locationsList.find(function (location) {
	    return location.name === locationName;
	  });
	  if (!location) {
	    console.error('could not get location for ' + locationName);
	  }
	  return location;
	};
	
	var getLocationColor = exports.getLocationColor = function getLocationColor(location) {
	  if (!location) return '';
	  try {
	    var countryCode = location.countryCode;
	    if (countryCode === 'GB') {
	      return 'london';
	    }
	
	    return location.country.region.color;
	  } catch (error) {
	    console.error('getCountryFromLocationName', error);
	    return 'london';
	  }
	};
	
	var getLocationFlag = exports.getLocationFlag = function getLocationFlag(location) {
	  // console.debug('getLocationFlag', location)
	  if (!location) return '';
	  return (0, _flagEmoji.getFlagEmoji)(location.countryCode);
	};
	
	var getLocationColorAndFlag = exports.getLocationColorAndFlag = function getLocationColorAndFlag(locationName) {
	  // console.debug('getLocationColorAndFlag', locationName)
	  var location = getLocation(locationName);
	  if (!location) return { color: '', flag: '' };
	  return {
	    color: getLocationColor(location),
	    flag: getLocationFlag(location)
	  };
	};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(34);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(14);
	var toAbsoluteIndex = __webpack_require__(64);
	var toLength = __webpack_require__(11);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(57);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(19);
	var toObject = __webpack_require__(14);
	var IObject = __webpack_require__(76);
	var toLength = __webpack_require__(11);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(19);
	var isObject = __webpack_require__(9);
	var invoke = __webpack_require__(203);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(13).f;
	var create = __webpack_require__(58);
	var redefineAll = __webpack_require__(62);
	var ctx = __webpack_require__(36);
	var anInstance = __webpack_require__(56);
	var forOf = __webpack_require__(57);
	var $iterDefine = __webpack_require__(134);
	var step = __webpack_require__(206);
	var setSpecies = __webpack_require__(63);
	var DESCRIPTORS = __webpack_require__(12);
	var fastKey = __webpack_require__(53).fastKey;
	var validate = __webpack_require__(66);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(68);
	var from = __webpack_require__(195);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(62);
	var getWeak = __webpack_require__(53).getWeak;
	var anObject = __webpack_require__(6);
	var isObject = __webpack_require__(9);
	var anInstance = __webpack_require__(56);
	var forOf = __webpack_require__(57);
	var createArrayMethod = __webpack_require__(43);
	var $has = __webpack_require__(27);
	var validate = __webpack_require__(66);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(92);
	var isObject = __webpack_require__(9);
	var toLength = __webpack_require__(11);
	var ctx = __webpack_require__(36);
	var IS_CONCAT_SPREADABLE = __webpack_require__(10)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(12) && !__webpack_require__(8)(function () {
	  return Object.defineProperty(__webpack_require__(127)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 203 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(9);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(6);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 206 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(136);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 208 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 209 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(12);
	var getKeys = __webpack_require__(60);
	var gOPS = __webpack_require__(96);
	var pIE = __webpack_require__(77);
	var toObject = __webpack_require__(14);
	var IObject = __webpack_require__(76);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(8)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(13);
	var anObject = __webpack_require__(6);
	var getKeys = __webpack_require__(60);
	
	module.exports = __webpack_require__(12) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(30);
	var gOPN = __webpack_require__(59).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(27);
	var toIObject = __webpack_require__(30);
	var arrayIndexOf = __webpack_require__(89)(false);
	var IE_PROTO = __webpack_require__(141)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(12);
	var getKeys = __webpack_require__(60);
	var toIObject = __webpack_require__(30);
	var isEnum = __webpack_require__(77).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(59);
	var gOPS = __webpack_require__(96);
	var anObject = __webpack_require__(6);
	var Reflect = __webpack_require__(7).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(7).parseFloat;
	var $trim = __webpack_require__(71).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(144) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(7).parseInt;
	var $trim = __webpack_require__(71).trim;
	var ws = __webpack_require__(144);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 218 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(6);
	var isObject = __webpack_require__(9);
	var newPromiseCapability = __webpack_require__(138);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 220 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(11);
	var repeat = __webpack_require__(143);
	var defined = __webpack_require__(44);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(38);
	var toLength = __webpack_require__(11);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(10);


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(198);
	var validate = __webpack_require__(66);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(90)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(139);
	__webpack_require__(3)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(12) && /./g.flags != 'g') __webpack_require__(13).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(75)
	});


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(198);
	var validate = __webpack_require__(66);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(90)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(7);
	var each = __webpack_require__(43)(0);
	var redefine = __webpack_require__(23);
	var meta = __webpack_require__(53);
	var assign = __webpack_require__(210);
	var weak = __webpack_require__(200);
	var isObject = __webpack_require__(9);
	var validate = __webpack_require__(66);
	var NATIVE_WEAK_MAP = __webpack_require__(66);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(90)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 229 */
/***/ (function(module, exports) {

	module.exports = {
	  'AED': 'د.إ',
	  'AFN': '؋',
	  'ALL': 'L',
	  'AMD': '֏',
	  'ANG': 'ƒ',
	  'AOA': 'Kz',
	  'ARS': '$',
	  'AUD': '$',
	  'AWG': 'ƒ',
	  'AZN': '₼',
	  'BAM': 'KM',
	  'BBD': '$',
	  'BDT': '৳',
	  'BGN': 'лв',
	  'BHD': '.د.ب',
	  'BIF': 'FBu',
	  'BMD': '$',
	  'BND': '$',
	  'BOB': '$b',
	  'BRL': 'R$',
	  'BSD': '$',
	  'BTC': '฿',
	  'BTN': 'Nu.',
	  'BWP': 'P',
	  'BYR': 'Br',
	  'BYN': 'Br',
	  'BZD': 'BZ$',
	  'CAD': '$',
	  'CDF': 'FC',
	  'CHF': 'CHF',
	  'CLP': '$',
	  'CNY': '¥',
	  'COP': '$',
	  'CRC': '₡',
	  'CUC': '$',
	  'CUP': '₱',
	  'CVE': '$',
	  'CZK': 'Kč',
	  'DJF': 'Fdj',
	  'DKK': 'kr',
	  'DOP': 'RD$',
	  'DZD': 'دج',
	  'EEK': 'kr',
	  'EGP': '£',
	  'ERN': 'Nfk',
	  'ETB': 'Br',
	  'ETH': 'Ξ',
	  'EUR': '€',
	  'FJD': '$',
	  'FKP': '£',
	  'GBP': '£',
	  'GEL': '₾',
	  'GGP': '£',
	  'GHC': '₵',
	  'GHS': 'GH₵',
	  'GIP': '£',
	  'GMD': 'D',
	  'GNF': 'FG',
	  'GTQ': 'Q',
	  'GYD': '$',
	  'HKD': '$',
	  'HNL': 'L',
	  'HRK': 'kn',
	  'HTG': 'G',
	  'HUF': 'Ft',
	  'IDR': 'Rp',
	  'ILS': '₪',
	  'IMP': '£',
	  'INR': '₹',
	  'IQD': 'ع.د',
	  'IRR': '﷼',
	  'ISK': 'kr',
	  'JEP': '£',
	  'JMD': 'J$',
	  'JOD': 'JD',
	  'JPY': '¥',
	  'KES': 'KSh',
	  'KGS': 'лв',
	  'KHR': '៛',
	  'KMF': 'CF',
	  'KPW': '₩',
	  'KRW': '₩',
	  'KWD': 'KD',
	  'KYD': '$',
	  'KZT': 'лв',
	  'LAK': '₭',
	  'LBP': '£',
	  'LKR': '₨',
	  'LRD': '$',
	  'LSL': 'M',
	  'LTC': 'Ł',
	  'LTL': 'Lt',
	  'LVL': 'Ls',
	  'LYD': 'LD',
	  'MAD': 'MAD',
	  'MDL': 'lei',
	  'MGA': 'Ar',
	  'MKD': 'ден',
	  'MMK': 'K',
	  'MNT': '₮',
	  'MOP': 'MOP$',
	  'MRO': 'UM',
	  'MRU': 'UM',
	  'MUR': '₨',
	  'MVR': 'Rf',
	  'MWK': 'MK',
	  'MXN': '$',
	  'MYR': 'RM',
	  'MZN': 'MT',
	  'NAD': '$',
	  'NGN': '₦',
	  'NIO': 'C$',
	  'NOK': 'kr',
	  'NPR': '₨',
	  'NZD': '$',
	  'OMR': '﷼',
	  'PAB': 'B/.',
	  'PEN': 'S/.',
	  'PGK': 'K',
	  'PHP': '₱',
	  'PKR': '₨',
	  'PLN': 'zł',
	  'PYG': 'Gs',
	  'QAR': '﷼',
	  'RMB': '￥',
	  'RON': 'lei',
	  'RSD': 'Дин.',
	  'RUB': '₽',
	  'RWF': 'R₣',
	  'SAR': '﷼',
	  'SBD': '$',
	  'SCR': '₨',
	  'SDG': 'ج.س.',
	  'SEK': 'kr',
	  'SGD': '$',
	  'SHP': '£',
	  'SLL': 'Le',
	  'SOS': 'S',
	  'SRD': '$',
	  'SSP': '£',
	  'STD': 'Db',
	  'STN': 'Db',
	  'SVC': '$',
	  'SYP': '£',
	  'SZL': 'E',
	  'THB': '฿',
	  'TJS': 'SM',
	  'TMT': 'T',
	  'TND': 'د.ت',
	  'TOP': 'T$',
	  'TRL': '₤',
	  'TRY': '₺',
	  'TTD': 'TT$',
	  'TVD': '$',
	  'TWD': 'NT$',
	  'TZS': 'TSh',
	  'UAH': '₴',
	  'UGX': 'USh',
	  'USD': '$',
	  'UYU': '$U',
	  'UZS': 'лв',
	  'VEF': 'Bs',
	  'VND': '₫',
	  'VUV': 'VT',
	  'WST': 'WS$',
	  'XAF': 'FCFA',
	  'XBT': 'Ƀ',
	  'XCD': '$',
	  'XOF': 'CFA',
	  'XPF': '₣',
	  'YER': '﷼',
	  'ZAR': 'R',
	  'ZWD': 'Z$'
	}


/***/ }),
/* 230 */
/***/ (function(module, exports) {

	module.exports = {"name":"angularjs-client","version":"2.7.35","description":"This Project contains the client side implementation for lexstep.com","homepage":"http://www.lexstep.com/","author":{"name":"Lexstep Ltd"},"entry":"public/index.html","contributors":[{"name":"Shaharyar Maroof","email":"m.shaharyar@emumba.com"},{"name":"Fahad Akbar","email":"fahadakbar24@gmail.com"},{"name":"Asfandyar Nasim Khan","email":"asfandyar.khan@emumba.com"},{"name":"Muhammad Rashid","email":"muhammad.rashid@emumba.com"}],"maintainers":[{"name":"Asfandyar Nasim Khan","email":"asfandyar.khan@emumba.com"},{"name":"Muhammad Rashid","email":"muhammad.rashid@emumba.com"}],"scripts":{"parcel":"parcel","postinstall":"node ./node_modules/bower/lib/bin/bower.js install","start-js":"node buildScripts/start.js","start":"npm-run-all -p start-js","build":"node buildScripts/build.js","test":"jest","test-watch":"jest --watchAll","test:e2e:ci":" start-server-and-test start http://localhost:3000 cy:run","test:e2e:dev":"start-server-and-test start http://localhost:3000 cy:dev","cy:run":"cypress run","cy:dev":"cypress open","release":"./buildScripts/release.py --type=patch","release:patch":"./buildScripts/release.py --type=patch","release:minor":"./buildScripts/release.py --type=minor","release:major":"./buildScripts/release.py --type=major"},"dependencies":{"@parcel/transformer-sass":"^2.6.2","alasql":"^0.4.4","angular":"1.7.9","angular-bootstrap-colorpicker":"^3.0.32","angular-drag-and-drop-lists":"^2.1.0","angular-filter":"^0.5.17","angular-spinner":"^1.0.1","aws-sdk":"^2.528.0","axios":"^0.27.2","axios-retry":"^3.3.1","babel":"^6.23.0","babel-eslint":"^8.2.1","babel-polyfill":"^6.26.0","babel-preset-es2020":"^1.0.2","bootbox":"^4.4.0","bootstrap":"^3.3.7","bootstrap-select":"^1.12.4","copy-webpack-plugin":"^4.5.1","currency-symbol-map":"^4.0.4","gravatar-url":"^4.0.1","interact.js":"^1.2.8","is-retry-allowed":"^3.0.0","jQuery-QueryBuilder":"^2.4.5","jquery":"^3.2.1","lodash":"^4.17.4","lodash.camelcase":"^4.3.0","lodash.get":"^4.4.2","moment":"^2.19.4","node-sass":"^4.13.1","rangy":"^1.3.0","react":"^16.2.0","react-dom":"^16.2.0","sass-loader":"^6.0.7","selectize":"^0.12.4","socket.io-client":"4.5.2","sql-parser":"^0.5.0","textangular":"^1.5.16","underscore":"^1.8.3","url-polyfill":"^1.0.11","xlsx":"^0.11.17"},"devDependencies":{"@babel/core":"^7.18.5","@babel/preset-env":"^7.18.2","@babel/preset-es2015":"^7.0.0-beta.53","@cypress/code-coverage":"^3.4.1","@kadira/storybook":"^2.21.0","@parcel/babel-preset-env":"^2.6.2","@testing-library/cypress":"^6.0.0","autoprefixer":"7","babel-core":"^6.26.0","babel-eslint":"8.2.6","babel-jest":"^18.0.0","babel-loader":"6.2","babel-plugin-istanbul":"^6.0.0","babel-plugin-ng-hot-reload":"^3.2.1","babel-preset-env":"^1.6.1","babel-preset-es2015":"^6.24.1","babel-preset-react-app":"^2.2.0","babel-runtime":"^6.26.0","bower":"^1.8.2","case-sensitive-paths-webpack-plugin":"1.1.4","chalk":"^2.3.0","connect-history-api-fallback":"1.3.0","cross-spawn":"4.0.2","css-loader":"0.26.1","cypress":"^4.2.0","cypress-plugin-tab":"^1.0.5","cz-conventional-changelog":"^3.1.0","detect-port":"1.1.0","dotenv":"^4.0.0","dotenv-flow":"^3.2.0","enzyme":"^3.3.0","enzyme-adapter-react-16":"^1.1.1","enzyme-to-json":"^3.3.3","eslint":"^7.14.0","eslint-config-prettier":"^6.15.0","eslint-config-react-app":"^2.0.1","eslint-config-xo-space":"^0.25.0","eslint-loader":"^1.9.0","eslint-plugin-angular":"^4.0.1","eslint-plugin-chai-friendly":"^0.6.0","eslint-plugin-cypress":"^2.10.3","eslint-plugin-import":"^2.22.1","eslint-plugin-jest":"^24.1.3","eslint-plugin-jest-formatting":"^2.0.0","eslint-plugin-jsx-a11y":"^6.0.3","eslint-plugin-react":"^7.5.1","eslint-plugin-unicorn":"^23.0.0","eslint-plugin-you-dont-need-lodash-underscore":"^6.10.0","expose-loader":"^0.7.4","extract-text-webpack-plugin":"1.0.1","file-loader":"0.10.0","fs-extra":"0.30.0","html-webpack-plugin":"2.24.0","http-proxy-middleware":"0.17.3","husky":"^4.2.3","istanbul-instrumenter-loader":"^3.0.1","istanbul-lib-coverage":"^3.0.0","jest":"^22.4.2","json-loader":"^0.5.4","lint-staged":"^10.0.8","npm-run-all":"^4.1.2","nyc":"^15.0.1","object-assign":"4.1.1","parcel-bundler":"^1.12.5","postcss-loader":"1.2.2","posthtml":"^0.16.6","posthtml-expressions":"^1.9.0","prettier":"^1.19.1","promise":"7.1.1","raw-loader":"^0.5.1","react-dev-utils":"^0.5.2","regenerator-runtime":"^0.11.1","start-server-and-test":"^1.10.11","style-loader":"0.13.1","url-loader":"0.5.7","webpack":"1.x","webpack-dev-server":"^1.16.2","webpack-manifest-plugin":"^1.1.0","whatwg-fetch":"2.0.2"},"jest":{"verbose":true,"testURL":"http://localhost:3000/","roots":["<rootDir>/scripts/"],"snapshotSerializers":["enzyme-to-json/serializer"],"setupTestFrameworkScriptFile":"<rootDir>/setupTests.js"},"config":{"commitizen":{"path":"./node_modules/cz-conventional-changelog"}},"husky":{"hooks":{"pre-commit":"lint-staged"}},"lint-staged":{"*.js":"eslint --cache --fix","*.{js,css,md}":"prettier --write"},"engines":{"node":"14.x"},"packageManager":"yarn@1.22.19"}

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                '_'
	            ),
	            standalone:
	                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                    '_'
	                ),
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 366 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(502);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(40);
	
	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Applies a function to the value at the given index of an array, returning a
	 * new copy of the array with the element at the given index replaced with the
	 * result of the function application.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig Number -> (a -> a) -> [a] -> [a]
	 * @param {Number} idx The index.
	 * @param {Function} fn The function to apply.
	 * @param {Array|Arguments} list An array-like object whose value
	 *        at the supplied index will be replaced.
	 * @return {Array} A copy of the supplied array-like object with
	 *         the element at index `idx` replaced with the value
	 *         returned by applying `fn` to the existing element.
	 * @see R.update
	 * @example
	 *
	 *      R.adjust(1, R.toUpper, ['a', 'b', 'c', 'd']);      //=> ['a', 'B', 'c', 'd']
	 *      R.adjust(-1, R.toUpper, ['a', 'b', 'c', 'd']);     //=> ['a', 'b', 'c', 'D']
	 * @symb R.adjust(-1, f, [a, b]) = [a, f(b)]
	 * @symb R.adjust(0, f, [a, b]) = [f(a), b]
	 */
	
	
	var adjust = /*#__PURE__*/_curry3(function adjust(idx, fn, list) {
	  if (idx >= list.length || idx < -list.length) {
	    return list;
	  }
	  var start = idx < 0 ? list.length : 0;
	  var _idx = start + idx;
	  var _list = _concat(list);
	  _list[_idx] = fn(list[_idx]);
	  return _list;
	});
	module.exports = adjust;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _xall = /*#__PURE__*/__webpack_require__(1071);
	
	/**
	 * Returns `true` if all elements of the list match the predicate, `false` if
	 * there are any that don't.
	 *
	 * Dispatches to the `all` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
	 *         otherwise.
	 * @see R.any, R.none, R.transduce
	 * @example
	 *
	 *      const equals3 = R.equals(3);
	 *      R.all(equals3)([3, 3, 3, 3]); //=> true
	 *      R.all(equals3)([3, 3, 1, 3]); //=> false
	 */
	
	
	var all = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['all'], _xall, function all(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (!fn(list[idx])) {
	      return false;
	    }
	    idx += 1;
	  }
	  return true;
	}));
	module.exports = all;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns `true` if both arguments are `true`; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if it is falsy, otherwise the second argument.
	 * @see R.both
	 * @example
	 *
	 *      R.and(true, true); //=> true
	 *      R.and(true, false); //=> false
	 *      R.and(false, true); //=> false
	 *      R.and(false, false); //=> false
	 */
	
	
	var and = /*#__PURE__*/_curry2(function and(a, b) {
	  return a && b;
	});
	module.exports = and;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Applies function `fn` to the argument list `args`. This is useful for
	 * creating a fixed-arity function from a variadic function. `fn` should be a
	 * bound function if context is significant.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> a) -> [*] -> a
	 * @param {Function} fn The function which will be called with `args`
	 * @param {Array} args The arguments to call `fn` with
	 * @return {*} result The result, equivalent to `fn(...args)`
	 * @see R.call, R.unapply
	 * @example
	 *
	 *      const nums = [1, 2, 3, -99, 42, 6, 7];
	 *      R.apply(Math.max, nums); //=> 42
	 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
	 */
	
	
	var apply = /*#__PURE__*/_curry2(function apply(fn, args) {
	  return fn.apply(this, args);
	});
	module.exports = apply;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var _has = /*#__PURE__*/__webpack_require__(25);
	
	var _isArray = /*#__PURE__*/__webpack_require__(50);
	
	var _isInteger = /*#__PURE__*/__webpack_require__(158);
	
	var assoc = /*#__PURE__*/__webpack_require__(106);
	
	var isNil = /*#__PURE__*/__webpack_require__(401);
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the nodes required
	 * to create the given path, and placing the specific value at the tail end of
	 * that path. Note that this copies and flattens prototype properties onto the
	 * new object as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> {a}
	 * @param {Array} path the path to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except along the specified path.
	 * @see R.dissocPath
	 * @example
	 *
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
	 *
	 *      // Any missing or non-object keys in path will be overridden
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
	 */
	
	
	var assocPath = /*#__PURE__*/_curry3(function assocPath(path, val, obj) {
	  if (path.length === 0) {
	    return val;
	  }
	  var idx = path[0];
	  if (path.length > 1) {
	    var nextObj = !isNil(obj) && _has(idx, obj) ? obj[idx] : _isInteger(path[1]) ? [] : {};
	    val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
	  }
	  if (_isInteger(idx) && _isArray(obj)) {
	    var arr = [].concat(obj);
	    arr[idx] = val;
	    return arr;
	  } else {
	    return assoc(idx, val, obj);
	  }
	});
	module.exports = assocPath;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(39);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Creates a function that is bound to a context.
	 * Note: `R.bind` does not provide the additional argument-binding capabilities of
	 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @category Object
	 * @sig (* -> *) -> {*} -> (* -> *)
	 * @param {Function} fn The function to bind to context
	 * @param {Object} thisObj The context to bind `fn` to
	 * @return {Function} A function that will execute in the context of `thisObj`.
	 * @see R.partial
	 * @example
	 *
	 *      const log = R.bind(console.log, console);
	 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
	 *      // logs {a: 2}
	 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
	 */
	
	
	var bind = /*#__PURE__*/_curry2(function bind(fn, thisObj) {
	  return _arity(fn.length, function () {
	    return fn.apply(thisObj, arguments);
	  });
	});
	module.exports = bind;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var chain = /*#__PURE__*/__webpack_require__(151);
	
	var compose = /*#__PURE__*/__webpack_require__(152);
	
	var map = /*#__PURE__*/__webpack_require__(32);
	
	/**
	 * Returns the right-to-left Kleisli composition of the provided functions,
	 * each of which must return a value of a type supported by [`chain`](#chain).
	 *
	 * `R.composeK(h, g, f)` is equivalent to `R.compose(R.chain(h), R.chain(g), f)`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Function
	 * @sig Chain m => ((y -> m z), (x -> m y), ..., (a -> m b)) -> (a -> m z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipeK
	 * @deprecated since v0.26.0
	 * @example
	 *
	 *       //  get :: String -> Object -> Maybe *
	 *       const get = R.curry((propName, obj) => Maybe(obj[propName]))
	 *
	 *       //  getStateCode :: Maybe String -> Maybe String
	 *       const getStateCode = R.composeK(
	 *         R.compose(Maybe.of, R.toUpper),
	 *         get('state'),
	 *         get('address'),
	 *         get('user'),
	 *       );
	 *       getStateCode({"user":{"address":{"state":"ny"}}}); //=> Maybe.Just("NY")
	 *       getStateCode({}); //=> Maybe.Nothing()
	 * @symb R.composeK(f, g, h)(a) = R.chain(f, R.chain(g, h(a)))
	 */
	
	
	function composeK() {
	  if (arguments.length === 0) {
	    throw new Error('composeK requires at least one argument');
	  }
	  var init = Array.prototype.slice.call(arguments);
	  var last = init.pop();
	  return compose(compose.apply(this, map(chain, init)), last);
	}
	module.exports = composeK;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var curry = /*#__PURE__*/__webpack_require__(154);
	
	var nAry = /*#__PURE__*/__webpack_require__(117);
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type. The arity of the function
	 * returned is specified to allow using variadic constructor functions.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Function
	 * @sig Number -> (* -> {*}) -> (* -> {*})
	 * @param {Number} n The arity of the constructor function.
	 * @param {Function} Fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @example
	 *
	 *      // Variadic Constructor function
	 *      function Salad() {
	 *        this.ingredients = arguments;
	 *      }
	 *
	 *      Salad.prototype.recipe = function() {
	 *        const instructions = R.map(ingredient => 'Add a dollop of ' + ingredient, this.ingredients);
	 *        return R.join('\n', instructions);
	 *      };
	 *
	 *      const ThreeLayerSalad = R.constructN(3, Salad);
	 *
	 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
	 *      const salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup');
	 *
	 *      console.log(salad.recipe());
	 *      // Add a dollop of Mayonnaise
	 *      // Add a dollop of Potato Chips
	 *      // Add a dollop of Ketchup
	 */
	
	
	var constructN = /*#__PURE__*/_curry2(function constructN(n, Fn) {
	  if (n > 10) {
	    throw new Error('Constructor with greater than ten arguments');
	  }
	  if (n === 0) {
	    return function () {
	      return new Fn();
	    };
	  }
	  return curry(nAry(n, function ($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
	    switch (arguments.length) {
	      case 1:
	        return new Fn($0);
	      case 2:
	        return new Fn($0, $1);
	      case 3:
	        return new Fn($0, $1, $2);
	      case 4:
	        return new Fn($0, $1, $2, $3);
	      case 5:
	        return new Fn($0, $1, $2, $3, $4);
	      case 6:
	        return new Fn($0, $1, $2, $3, $4, $5);
	      case 7:
	        return new Fn($0, $1, $2, $3, $4, $5, $6);
	      case 8:
	        return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
	      case 9:
	        return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
	      case 10:
	        return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
	    }
	  }));
	});
	module.exports = constructN;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _map = /*#__PURE__*/__webpack_require__(113);
	
	var curryN = /*#__PURE__*/__webpack_require__(18);
	
	var max = /*#__PURE__*/__webpack_require__(73);
	
	var pluck = /*#__PURE__*/__webpack_require__(86);
	
	var reduce = /*#__PURE__*/__webpack_require__(47);
	
	/**
	 * Accepts a converging function and a list of branching functions and returns
	 * a new function. The arity of the new function is the same as the arity of
	 * the longest branching function. When invoked, this new function is applied
	 * to some arguments, and each branching function is applied to those same
	 * arguments. The results of each branching function are passed as arguments
	 * to the converging function to produce the return value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.2
	 * @category Function
	 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} after A function. `after` will be invoked with the return values of
	 *        `fn1` and `fn2` as its arguments.
	 * @param {Array} functions A list of functions.
	 * @return {Function} A new function.
	 * @see R.useWith
	 * @example
	 *
	 *      const average = R.converge(R.divide, [R.sum, R.length])
	 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
	 *
	 *      const strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
	 *      strangeConcat("Yodel") //=> "YODELyodel"
	 *
	 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
	 */
	
	
	var converge = /*#__PURE__*/_curry2(function converge(after, fns) {
	  return curryN(reduce(max, 0, pluck('length', fns)), function () {
	    var args = arguments;
	    var context = this;
	    return after.apply(context, _map(function (fn) {
	      return fn.apply(context, args);
	    }, fns));
	  });
	});
	module.exports = converge;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
	 * otherwise the first argument is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {a} default The default value.
	 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
	 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
	 * @example
	 *
	 *      const defaultTo42 = R.defaultTo(42);
	 *
	 *      defaultTo42(null);  //=> 42
	 *      defaultTo42(undefined);  //=> 42
	 *      defaultTo42(false);  //=> false
	 *      defaultTo42('Ramda');  //=> 'Ramda'
	 *      // parseInt('string') results in NaN
	 *      defaultTo42(parseInt('string')); //=> 42
	 */
	
	
	var defaultTo = /*#__PURE__*/_curry2(function defaultTo(d, v) {
	  return v == null || v !== v ? d : v;
	});
	module.exports = defaultTo;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _Set = /*#__PURE__*/__webpack_require__(386);
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements in the first list not
	 * contained in the second list. Objects and Arrays are compared in terms of
	 * value equality, not reference equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` that are not in `list2`.
	 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
	 * @example
	 *
	 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
	 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
	 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
	 */
	
	
	var difference = /*#__PURE__*/_curry2(function difference(first, second) {
	  var out = [];
	  var idx = 0;
	  var firstLen = first.length;
	  var secondLen = second.length;
	  var toFilterOut = new _Set();
	
	  for (var i = 0; i < secondLen; i += 1) {
	    toFilterOut.add(second[i]);
	  }
	
	  while (idx < firstLen) {
	    if (toFilterOut.add(first[idx])) {
	      out[out.length] = first[idx];
	    }
	    idx += 1;
	  }
	  return out;
	});
	module.exports = difference;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	var _includesWith = /*#__PURE__*/__webpack_require__(110);
	
	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements in the first list not
	 * contained in the second list. Duplication is determined according to the
	 * value returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` that are not in `list2`.
	 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
	 * @example
	 *
	 *      const cmp = (x, y) => x.a === y.a;
	 *      const l1 = [{a: 1}, {a: 2}, {a: 3}];
	 *      const l2 = [{a: 3}, {a: 4}];
	 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
	 */
	
	
	var differenceWith = /*#__PURE__*/_curry3(function differenceWith(pred, first, second) {
	  var out = [];
	  var idx = 0;
	  var firstLen = first.length;
	  while (idx < firstLen) {
	    if (!_includesWith(pred, first[idx], second) && !_includesWith(pred, first[idx], out)) {
	      out.push(first[idx]);
	    }
	    idx += 1;
	  }
	  return out;
	});
	module.exports = differenceWith;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns a new object that does not contain a `prop` property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Object
	 * @sig String -> {k: v} -> {k: v}
	 * @param {String} prop The name of the property to dissociate
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original but without the specified property
	 * @see R.assoc, R.omit
	 * @example
	 *
	 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
	 */
	
	
	var dissoc = /*#__PURE__*/_curry2(function dissoc(prop, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  delete result[prop];
	  return result;
	});
	module.exports = dissoc;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _xdrop = /*#__PURE__*/__webpack_require__(1075);
	
	var slice = /*#__PURE__*/__webpack_require__(42);
	
	/**
	 * Returns all but the first `n` elements of the given list, string, or
	 * transducer/transformer (or object with a `drop` method).
	 *
	 * Dispatches to the `drop` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n
	 * @param {*} list
	 * @return {*} A copy of list without the first `n` elements
	 * @see R.take, R.transduce, R.dropLast, R.dropWhile
	 * @example
	 *
	 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
	 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
	 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
	 *      R.drop(3, 'ramda');               //=> 'da'
	 */
	
	
	var drop = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['drop'], _xdrop, function drop(n, xs) {
	  return slice(Math.max(0, n), Infinity, xs);
	}));
	module.exports = drop;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _xdropRepeatsWith = /*#__PURE__*/__webpack_require__(398);
	
	var last = /*#__PURE__*/__webpack_require__(403);
	
	/**
	 * Returns a new list without any consecutively repeating elements. Equality is
	 * determined by applying the supplied predicate to each pair of consecutive elements. The
	 * first element in a series of equal elements will be preserved.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig ((a, a) -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *      const l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
	 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
	 */
	
	
	var dropRepeatsWith = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable([], _xdropRepeatsWith, function dropRepeatsWith(pred, list) {
	  var result = [];
	  var idx = 1;
	  var len = list.length;
	  if (len !== 0) {
	    result[0] = list[0];
	    while (idx < len) {
	      if (!pred(last(result), list[idx])) {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	  }
	  return result;
	}));
	module.exports = dropRepeatsWith;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _isArguments = /*#__PURE__*/__webpack_require__(393);
	
	var _isArray = /*#__PURE__*/__webpack_require__(50);
	
	var _isObject = /*#__PURE__*/__webpack_require__(159);
	
	var _isString = /*#__PURE__*/__webpack_require__(82);
	
	/**
	 * Returns the empty value of its argument's type. Ramda defines the empty
	 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
	 * types are supported if they define `<Type>.empty`,
	 * `<Type>.prototype.empty` or implement the
	 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
	 *
	 * Dispatches to the `empty` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x
	 * @return {*}
	 * @example
	 *
	 *      R.empty(Just(42));      //=> Nothing()
	 *      R.empty([1, 2, 3]);     //=> []
	 *      R.empty('unicorns');    //=> ''
	 *      R.empty({x: 1, y: 2});  //=> {}
	 */
	
	
	var empty = /*#__PURE__*/_curry1(function empty(x) {
	  return x != null && typeof x['fantasy-land/empty'] === 'function' ? x['fantasy-land/empty']() : x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function' ? x.constructor['fantasy-land/empty']() : x != null && typeof x.empty === 'function' ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === 'function' ? x.constructor.empty() : _isArray(x) ? [] : _isString(x) ? '' : _isObject(x) ? {} : _isArguments(x) ? function () {
	    return arguments;
	  }() : void 0 // else
	  ;
	});
	module.exports = empty;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _has = /*#__PURE__*/__webpack_require__(25);
	
	/**
	 * Returns whether or not a path exists in an object. Only the object's
	 * own properties are checked.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.26.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> {a} -> Boolean
	 * @param {Array} path The path to use.
	 * @param {Object} obj The object to check the path in.
	 * @return {Boolean} Whether the path exists.
	 * @see R.has
	 * @example
	 *
	 *      R.hasPath(['a', 'b'], {a: {b: 2}});         // => true
	 *      R.hasPath(['a', 'b'], {a: {b: undefined}}); // => true
	 *      R.hasPath(['a', 'b'], {a: {c: 2}});         // => false
	 *      R.hasPath(['a', 'b'], {});                  // => false
	 */
	
	
	var hasPath = /*#__PURE__*/_curry2(function hasPath(_path, obj) {
	  if (_path.length === 0) {
	    return false;
	  }
	  var val = obj;
	  var idx = 0;
	  while (idx < _path.length) {
	    if (_has(_path[idx], val)) {
	      val = val[_path[idx]];
	      idx += 1;
	    } else {
	      return false;
	    }
	  }
	  return true;
	});
	module.exports = hasPath;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	var nth = /*#__PURE__*/__webpack_require__(85);
	
	/**
	 * Returns the first element of the given list or string. In some libraries
	 * this function is named `first`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {*}
	 * @see R.tail, R.init, R.last
	 * @example
	 *
	 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
	 *      R.head([]); //=> undefined
	 *
	 *      R.head('abc'); //=> 'a'
	 *      R.head(''); //=> ''
	 */
	
	
	var head = /*#__PURE__*/nth(0);
	module.exports = head;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	var _includes = /*#__PURE__*/__webpack_require__(72);
	
	var _Set = /*#__PURE__*/function () {
	
	  function _Set() {
	    /* globals Set */
	    this._nativeSet = typeof Set === 'function' ? new Set() : null;
	    this._items = {};
	  }
	
	  // until we figure out why jsdoc chokes on this
	  // @param item The item to add to the Set
	  // @returns {boolean} true if the item did not exist prior, otherwise false
	  //
	  _Set.prototype.add = function (item) {
	    return !hasOrAdd(item, true, this);
	  };
	
	  //
	  // @param item The item to check for existence in the Set
	  // @returns {boolean} true if the item exists in the Set, otherwise false
	  //
	  _Set.prototype.has = function (item) {
	    return hasOrAdd(item, false, this);
	  };
	
	  //
	  // Combines the logic for checking whether an item is a member of the set and
	  // for adding a new item to the set.
	  //
	  // @param item       The item to check or add to the Set instance.
	  // @param shouldAdd  If true, the item will be added to the set if it doesn't
	  //                   already exist.
	  // @param set        The set instance to check or add to.
	  // @return {boolean} true if the item already existed, otherwise false.
	  //
	  return _Set;
	}();
	
	function hasOrAdd(item, shouldAdd, set) {
	  var type = typeof item;
	  var prevSize, newSize;
	  switch (type) {
	    case 'string':
	    case 'number':
	      // distinguish between +0 and -0
	      if (item === 0 && 1 / item === -Infinity) {
	        if (set._items['-0']) {
	          return true;
	        } else {
	          if (shouldAdd) {
	            set._items['-0'] = true;
	          }
	          return false;
	        }
	      }
	      // these types can all utilise the native Set
	      if (set._nativeSet !== null) {
	        if (shouldAdd) {
	          prevSize = set._nativeSet.size;
	          set._nativeSet.add(item);
	          newSize = set._nativeSet.size;
	          return newSize === prevSize;
	        } else {
	          return set._nativeSet.has(item);
	        }
	      } else {
	        if (!(type in set._items)) {
	          if (shouldAdd) {
	            set._items[type] = {};
	            set._items[type][item] = true;
	          }
	          return false;
	        } else if (item in set._items[type]) {
	          return true;
	        } else {
	          if (shouldAdd) {
	            set._items[type][item] = true;
	          }
	          return false;
	        }
	      }
	
	    case 'boolean':
	      // set._items['boolean'] holds a two element array
	      // representing [ falseExists, trueExists ]
	      if (type in set._items) {
	        var bIdx = item ? 1 : 0;
	        if (set._items[type][bIdx]) {
	          return true;
	        } else {
	          if (shouldAdd) {
	            set._items[type][bIdx] = true;
	          }
	          return false;
	        }
	      } else {
	        if (shouldAdd) {
	          set._items[type] = item ? [false, true] : [true, false];
	        }
	        return false;
	      }
	
	    case 'function':
	      // compare functions for reference equality
	      if (set._nativeSet !== null) {
	        if (shouldAdd) {
	          prevSize = set._nativeSet.size;
	          set._nativeSet.add(item);
	          newSize = set._nativeSet.size;
	          return newSize === prevSize;
	        } else {
	          return set._nativeSet.has(item);
	        }
	      } else {
	        if (!(type in set._items)) {
	          if (shouldAdd) {
	            set._items[type] = [item];
	          }
	          return false;
	        }
	        if (!_includes(item, set._items[type])) {
	          if (shouldAdd) {
	            set._items[type].push(item);
	          }
	          return false;
	        }
	        return true;
	      }
	
	    case 'undefined':
	      if (set._items[type]) {
	        return true;
	      } else {
	        if (shouldAdd) {
	          set._items[type] = true;
	        }
	        return false;
	      }
	
	    case 'object':
	      if (item === null) {
	        if (!set._items['null']) {
	          if (shouldAdd) {
	            set._items['null'] = true;
	          }
	          return false;
	        }
	        return true;
	      }
	    /* falls through */
	    default:
	      // reduce the search size of heterogeneous sets by creating buckets
	      // for each type.
	      type = Object.prototype.toString.call(item);
	      if (!(type in set._items)) {
	        if (shouldAdd) {
	          set._items[type] = [item];
	        }
	        return false;
	      }
	      // scan through all previously applied items
	      if (!_includes(item, set._items[type])) {
	        if (shouldAdd) {
	          set._items[type].push(item);
	        }
	        return false;
	      }
	      return true;
	  }
	}
	
	// A simple Set type that honours R.equals semantics
	module.exports = _Set;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	var _isFunction = /*#__PURE__*/__webpack_require__(81);
	
	var _toString = /*#__PURE__*/__webpack_require__(397);
	
	function _assertPromise(name, p) {
	  if (p == null || !_isFunction(p.then)) {
	    throw new TypeError('`' + name + '` expected a Promise, received ' + _toString(p, []));
	  }
	}
	module.exports = _assertPromise;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	var _cloneRegExp = /*#__PURE__*/__webpack_require__(389);
	
	var type = /*#__PURE__*/__webpack_require__(164);
	
	/**
	 * Copies an object.
	 *
	 * @private
	 * @param {*} value The value to be copied
	 * @param {Array} refFrom Array containing the source references
	 * @param {Array} refTo Array containing the copied source references
	 * @param {Boolean} deep Whether or not to perform deep cloning.
	 * @return {*} The copied value.
	 */
	
	
	function _clone(value, refFrom, refTo, deep) {
	  var copy = function copy(copiedValue) {
	    var len = refFrom.length;
	    var idx = 0;
	    while (idx < len) {
	      if (value === refFrom[idx]) {
	        return refTo[idx];
	      }
	      idx += 1;
	    }
	    refFrom[idx + 1] = value;
	    refTo[idx + 1] = copiedValue;
	    for (var key in value) {
	      copiedValue[key] = deep ? _clone(value[key], refFrom, refTo, true) : value[key];
	    }
	    return copiedValue;
	  };
	  switch (type(value)) {
	    case 'Object':
	      return copy({});
	    case 'Array':
	      return copy([]);
	    case 'Date':
	      return new Date(value.valueOf());
	    case 'RegExp':
	      return _cloneRegExp(value);
	    default:
	      return value;
	  }
	}
	module.exports = _clone;

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	function _cloneRegExp(pattern) {
	                                  return new RegExp(pattern.source, (pattern.global ? 'g' : '') + (pattern.ignoreCase ? 'i' : '') + (pattern.multiline ? 'm' : '') + (pattern.sticky ? 'y' : '') + (pattern.unicode ? 'u' : ''));
	}
	module.exports = _cloneRegExp;

/***/ }),
/* 390 */
/***/ (function(module, exports) {

	function _complement(f) {
	  return function () {
	    return !f.apply(this, arguments);
	  };
	}
	module.exports = _complement;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(39);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	function _createPartialApplicator(concat) {
	  return _curry2(function (fn, args) {
	    return _arity(Math.max(0, fn.length - args.length), function () {
	      return fn.apply(this, concat(args, arguments));
	    });
	  });
	}
	module.exports = _createPartialApplicator;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	var equals = /*#__PURE__*/__webpack_require__(31);
	
	function _indexOf(list, a, idx) {
	  var inf, item;
	  // Array.prototype.indexOf doesn't exist below IE9
	  if (typeof list.indexOf === 'function') {
	    switch (typeof a) {
	      case 'number':
	        if (a === 0) {
	          // manually crawl the list to distinguish between +0 and -0
	          inf = 1 / a;
	          while (idx < list.length) {
	            item = list[idx];
	            if (item === 0 && 1 / item === inf) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        } else if (a !== a) {
	          // NaN
	          while (idx < list.length) {
	            item = list[idx];
	            if (typeof item === 'number' && item !== item) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        }
	        // non-zero numbers can utilise Set
	        return list.indexOf(a, idx);
	
	      // all these types can utilise Set
	      case 'string':
	      case 'boolean':
	      case 'function':
	      case 'undefined':
	        return list.indexOf(a, idx);
	
	      case 'object':
	        if (a === null) {
	          // null can utilise Set
	          return list.indexOf(a, idx);
	        }
	    }
	  }
	  // anything else not covered above, defer to R.equals
	  while (idx < list.length) {
	    if (equals(list[idx], a)) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	}
	module.exports = _indexOf;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	var _has = /*#__PURE__*/__webpack_require__(25);
	
	var toString = Object.prototype.toString;
	var _isArguments = /*#__PURE__*/function () {
	  return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
	    return toString.call(x) === '[object Arguments]';
	  } : function _isArguments(x) {
	    return _has('callee', x);
	  };
	}();
	
	module.exports = _isArguments;

/***/ }),
/* 394 */
/***/ (function(module, exports) {

	function _isNumber(x) {
	  return Object.prototype.toString.call(x) === '[object Number]';
	}
	module.exports = _isNumber;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArrayLike = /*#__PURE__*/__webpack_require__(111);
	
	/**
	 * `_makeFlat` is a helper function that returns a one-level or fully recursive
	 * function based on the flag passed in.
	 *
	 * @private
	 */
	
	
	function _makeFlat(recursive) {
	  return function flatt(list) {
	    var value, jlen, j;
	    var result = [];
	    var idx = 0;
	    var ilen = list.length;
	
	    while (idx < ilen) {
	      if (_isArrayLike(list[idx])) {
	        value = recursive ? flatt(list[idx]) : list[idx];
	        j = 0;
	        jlen = value.length;
	        while (j < jlen) {
	          result[result.length] = value[j];
	          j += 1;
	        }
	      } else {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	    return result;
	  };
	}
	module.exports = _makeFlat;

/***/ }),
/* 396 */
/***/ (function(module, exports) {

	// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function _objectIs(a, b) {
	  // SameValue algorithm
	  if (a === b) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return a !== 0 || 1 / a === 1 / b;
	  } else {
	    // Step 6.a: NaN == NaN
	    return a !== a && b !== b;
	  }
	}
	
	module.exports = typeof Object.is === 'function' ? Object.is : _objectIs;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	var _includes = /*#__PURE__*/__webpack_require__(72);
	
	var _map = /*#__PURE__*/__webpack_require__(113);
	
	var _quote = /*#__PURE__*/__webpack_require__(1068);
	
	var _toISOString = /*#__PURE__*/__webpack_require__(1070);
	
	var keys = /*#__PURE__*/__webpack_require__(41);
	
	var reject = /*#__PURE__*/__webpack_require__(119);
	
	function _toString(x, seen) {
	  var recur = function recur(y) {
	    var xs = seen.concat([x]);
	    return _includes(y, xs) ? '<Circular>' : _toString(y, xs);
	  };
	
	  //  mapPairs :: (Object, [String]) -> [String]
	  var mapPairs = function (obj, keys) {
	    return _map(function (k) {
	      return _quote(k) + ': ' + recur(obj[k]);
	    }, keys.slice().sort());
	  };
	
	  switch (Object.prototype.toString.call(x)) {
	    case '[object Arguments]':
	      return '(function() { return arguments; }(' + _map(recur, x).join(', ') + '))';
	    case '[object Array]':
	      return '[' + _map(recur, x).concat(mapPairs(x, reject(function (k) {
	        return (/^\d+$/.test(k)
	        );
	      }, keys(x)))).join(', ') + ']';
	    case '[object Boolean]':
	      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
	    case '[object Date]':
	      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';
	    case '[object Null]':
	      return 'null';
	    case '[object Number]':
	      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
	    case '[object String]':
	      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);
	    case '[object Undefined]':
	      return 'undefined';
	    default:
	      if (typeof x.toString === 'function') {
	        var repr = x.toString();
	        if (repr !== '[object Object]') {
	          return repr;
	        }
	      }
	      return '{' + mapPairs(x, keys(x)).join(', ') + '}';
	  }
	}
	module.exports = _toString;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var XDropRepeatsWith = /*#__PURE__*/function () {
	
	  function XDropRepeatsWith(pred, xf) {
	    this.xf = xf;
	    this.pred = pred;
	    this.lastValue = undefined;
	    this.seenFirstValue = false;
	  }
	
	  XDropRepeatsWith.prototype['@@transducer/init'] = _xfBase.init;
	  XDropRepeatsWith.prototype['@@transducer/result'] = _xfBase.result;
	  XDropRepeatsWith.prototype['@@transducer/step'] = function (result, input) {
	    var sameAsLast = false;
	    if (!this.seenFirstValue) {
	      this.seenFirstValue = true;
	    } else if (this.pred(this.lastValue, input)) {
	      sameAsLast = true;
	    }
	    this.lastValue = input;
	    return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
	  };
	
	  return XDropRepeatsWith;
	}();
	
	var _xdropRepeatsWith = /*#__PURE__*/_curry2(function _xdropRepeatsWith(pred, xf) {
	  return new XDropRepeatsWith(pred, xf);
	});
	module.exports = _xdropRepeatsWith;

/***/ }),
/* 399 */
/***/ (function(module, exports) {

	var XWrap = /*#__PURE__*/function () {
	  function XWrap(fn) {
	    this.f = fn;
	  }
	  XWrap.prototype['@@transducer/init'] = function () {
	    throw new Error('init not implemented on XWrap');
	  };
	  XWrap.prototype['@@transducer/result'] = function (acc) {
	    return acc;
	  };
	  XWrap.prototype['@@transducer/step'] = function (acc, x) {
	    return this.f(acc, x);
	  };
	
	  return XWrap;
	}();
	
	function _xwrap(fn) {
	  return new XWrap(fn);
	}
	module.exports = _xwrap;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * See if an object (`val`) is an instance of the supplied constructor. This
	 * function will check up the inheritance chain, if any.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Type
	 * @sig (* -> {*}) -> a -> Boolean
	 * @param {Object} ctor A constructor
	 * @param {*} val The value to test
	 * @return {Boolean}
	 * @example
	 *
	 *      R.is(Object, {}); //=> true
	 *      R.is(Number, 1); //=> true
	 *      R.is(Object, 1); //=> false
	 *      R.is(String, 's'); //=> true
	 *      R.is(String, new String('')); //=> true
	 *      R.is(Object, new String('')); //=> true
	 *      R.is(Object, 's'); //=> false
	 *      R.is(Number, {}); //=> false
	 */
	
	
	var is = /*#__PURE__*/_curry2(function is(Ctor, val) {
	  return val != null && val.constructor === Ctor || val instanceof Ctor;
	});
	module.exports = is;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Checks if the input value is `null` or `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Type
	 * @sig * -> Boolean
	 * @param {*} x The value to test.
	 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
	 * @example
	 *
	 *      R.isNil(null); //=> true
	 *      R.isNil(undefined); //=> true
	 *      R.isNil(0); //=> false
	 *      R.isNil([]); //=> false
	 */
	
	
	var isNil = /*#__PURE__*/_curry1(function isNil(x) {
	  return x == null;
	});
	module.exports = isNil;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var converge = /*#__PURE__*/__webpack_require__(376);
	
	/**
	 * juxt applies a list of functions to a list of values.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Function
	 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
	 * @param {Array} fns An array of functions
	 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
	 * @see R.applySpec
	 * @example
	 *
	 *      const getRange = R.juxt([Math.min, Math.max]);
	 *      getRange(3, 4, 9, -3); //=> [-3, 9]
	 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
	 */
	
	
	var juxt = /*#__PURE__*/_curry1(function juxt(fns) {
	  return converge(function () {
	    return Array.prototype.slice.call(arguments, 0);
	  }, fns);
	});
	module.exports = juxt;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	var nth = /*#__PURE__*/__webpack_require__(85);
	
	/**
	 * Returns the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.init, R.head, R.tail
	 * @example
	 *
	 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
	 *      R.last([]); //=> undefined
	 *
	 *      R.last('abc'); //=> 'c'
	 *      R.last(''); //=> ''
	 */
	
	
	var last = /*#__PURE__*/nth(-1);
	module.exports = last;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _isNumber = /*#__PURE__*/__webpack_require__(394);
	
	/**
	 * Returns the number of elements in the array by returning `list.length`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [a] -> Number
	 * @param {Array} list The array to inspect.
	 * @return {Number} The length of the array.
	 * @example
	 *
	 *      R.length([]); //=> 0
	 *      R.length([1, 2, 3]); //=> 3
	 */
	
	
	var length = /*#__PURE__*/_curry1(function length(list) {
	  return list != null && _isNumber(list.length) ? list.length : NaN;
	});
	module.exports = length;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _reduce = /*#__PURE__*/__webpack_require__(26);
	
	var ap = /*#__PURE__*/__webpack_require__(150);
	
	var curryN = /*#__PURE__*/__webpack_require__(18);
	
	var map = /*#__PURE__*/__webpack_require__(32);
	
	/**
	 * "lifts" a function to be the specified arity, so that it may "map over" that
	 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig Number -> (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.lift, R.ap
	 * @example
	 *
	 *      const madd3 = R.liftN(3, (...args) => R.sum(args));
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 */
	
	
	var liftN = /*#__PURE__*/_curry2(function liftN(arity, fn) {
	  var lifted = curryN(arity, fn);
	  return curryN(arity, function () {
	    return _reduce(ap, map(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
	  });
	});
	module.exports = liftN;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var sum = /*#__PURE__*/__webpack_require__(421);
	
	/**
	 * Returns the mean of the given list of numbers.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list
	 * @return {Number}
	 * @see R.median
	 * @example
	 *
	 *      R.mean([2, 7, 9]); //=> 6
	 *      R.mean([]); //=> NaN
	 */
	
	
	var mean = /*#__PURE__*/_curry1(function mean(list) {
	  return sum(list) / list.length;
	});
	module.exports = mean;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Multiplies two numbers. Equivalent to `a * b` but curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a * b`.
	 * @see R.divide
	 * @example
	 *
	 *      const double = R.multiply(2);
	 *      const triple = R.multiply(3);
	 *      double(3);       //=>  6
	 *      triple(4);       //=> 12
	 *      R.multiply(2, 5);  //=> 10
	 */
	
	
	var multiply = /*#__PURE__*/_curry2(function multiply(a, b) {
	  return a * b;
	});
	module.exports = multiply;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * A function that returns the `!` of its argument. It will return `true` when
	 * passed false-y value, and `false` when passed a truth-y one.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig * -> Boolean
	 * @param {*} a any value
	 * @return {Boolean} the logical inverse of passed argument.
	 * @see R.complement
	 * @example
	 *
	 *      R.not(true); //=> false
	 *      R.not(false); //=> true
	 *      R.not(0); //=> true
	 *      R.not(1); //=> false
	 */
	
	
	var not = /*#__PURE__*/_curry1(function not(a) {
	  return !a;
	});
	module.exports = not;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Creates an object containing a single key:value pair.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @sig String -> a -> {String:a}
	 * @param {String} key
	 * @param {*} val
	 * @return {Object}
	 * @see R.pair
	 * @example
	 *
	 *      const matchPhrases = R.compose(
	 *        R.objOf('must'),
	 *        R.map(R.objOf('match_phrase'))
	 *      );
	 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
	 */
	
	
	var objOf = /*#__PURE__*/_curry2(function objOf(key, val) {
	  var obj = {};
	  obj[key] = val;
	  return obj;
	});
	module.exports = objOf;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns `true` if one or both of its arguments are `true`. Returns `false`
	 * if both arguments are `false`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if truthy, otherwise the second argument.
	 * @see R.either
	 * @example
	 *
	 *      R.or(true, true); //=> true
	 *      R.or(true, false); //=> true
	 *      R.or(false, true); //=> true
	 *      R.or(false, false); //=> false
	 */
	
	
	var or = /*#__PURE__*/_curry2(function or(a, b) {
	  return a || b;
	});
	module.exports = or;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	// `Identity` is a functor that holds a single value, where `map` simply
	// transforms the held value with the provided function.
	
	
	var Identity = function (x) {
	  return { value: x, map: function (f) {
	      return Identity(f(x));
	    } };
	};
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the result of applying the given function to
	 * the focused value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> (a -> a) -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      const headLens = R.lensIndex(0);
	 *
	 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
	 */
	var over = /*#__PURE__*/_curry3(function over(lens, f, x) {
	  // The value returned by the getter function is first transformed with `f`,
	  // then set as the value of an `Identity`. This is then mapped over with the
	  // setter function of the lens.
	  return lens(function (y) {
	    return Identity(f(y));
	  })(x).value;
	});
	module.exports = over;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var defaultTo = /*#__PURE__*/__webpack_require__(377);
	
	var path = /*#__PURE__*/__webpack_require__(74);
	
	/**
	 * If the given, non-null object has a value at the given path, returns the
	 * value at that path. Otherwise returns the provided default value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig a -> [Idx] -> {a} -> a
	 * @param {*} d The default value.
	 * @param {Array} p The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path` of the supplied object or the default value.
	 * @example
	 *
	 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
	 */
	
	
	var pathOr = /*#__PURE__*/_curry3(function pathOr(d, p, obj) {
	  return defaultTo(d, path(p, obj));
	});
	module.exports = pathOr;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Similar to `pick` except that this one includes a `key: undefined` pair for
	 * properties that don't exist.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.pick
	 * @example
	 *
	 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
	 */
	
	
	var pickAll = /*#__PURE__*/_curry2(function pickAll(names, obj) {
	  var result = {};
	  var idx = 0;
	  var len = names.length;
	  while (idx < len) {
	    var name = names[idx];
	    result[name] = obj[name];
	    idx += 1;
	  }
	  return result;
	});
	module.exports = pickAll;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(39);
	
	var _pipe = /*#__PURE__*/__webpack_require__(1066);
	
	var reduce = /*#__PURE__*/__webpack_require__(47);
	
	var tail = /*#__PURE__*/__webpack_require__(120);
	
	/**
	 * Performs left-to-right function composition. The leftmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * In some libraries this function is named `sequence`.
	 *
	 * **Note:** The result of pipe is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.compose
	 * @example
	 *
	 *      const f = R.pipe(Math.pow, R.negate, R.inc);
	 *
	 *      f(3, 4); // -(3^4) + 1
	 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
	 */
	
	
	function pipe() {
	  if (arguments.length === 0) {
	    throw new Error('pipe requires at least one argument');
	  }
	  return _arity(arguments[0].length, reduce(_pipe, arguments[0], tail(arguments)));
	}
	module.exports = pipe;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(39);
	
	var _pipeP = /*#__PURE__*/__webpack_require__(1067);
	
	var reduce = /*#__PURE__*/__webpack_require__(47);
	
	var tail = /*#__PURE__*/__webpack_require__(120);
	
	/**
	 * Performs left-to-right composition of one or more Promise-returning
	 * functions. The leftmost function may have any arity; the remaining functions
	 * must be unary.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a -> Promise b), (b -> Promise c), ..., (y -> Promise z)) -> (a -> Promise z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.composeP
	 * @deprecated since v0.26.0
	 * @example
	 *
	 *      //  followersForUser :: String -> Promise [User]
	 *      const followersForUser = R.pipeP(db.getUserById, db.getFollowers);
	 */
	
	
	function pipeP() {
	  if (arguments.length === 0) {
	    throw new Error('pipeP requires at least one argument');
	  }
	  return _arity(arguments[0].length, reduce(_pipeP, arguments[0], tail(arguments)));
	}
	module.exports = pipeP;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(39);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var head = /*#__PURE__*/__webpack_require__(385);
	
	var _reduce = /*#__PURE__*/__webpack_require__(26);
	
	var tail = /*#__PURE__*/__webpack_require__(120);
	
	var identity = /*#__PURE__*/__webpack_require__(108);
	
	/**
	 * Performs left-to-right function composition using transforming function. The leftmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * **Note:** The result of pipeWith is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @category Function
	 * @sig ((* -> *), [((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)]) -> ((a, b, ..., n) -> z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.composeWith, R.pipe
	 * @example
	 *
	 *      const pipeWhileNotNil = R.pipeWith((f, res) => R.isNil(res) ? res : f(res));
	 *      const f = pipeWhileNotNil([Math.pow, R.negate, R.inc])
	 *
	 *      f(3, 4); // -(3^4) + 1
	 * @symb R.pipeWith(f)([g, h, i])(...args) = f(i, f(h, f(g, ...args)))
	 */
	
	
	var pipeWith = /*#__PURE__*/_curry2(function pipeWith(xf, list) {
	  if (list.length <= 0) {
	    return identity;
	  }
	
	  var headList = head(list);
	  var tailList = tail(list);
	
	  return _arity(headList.length, function () {
	    return _reduce(function (result, f) {
	      return xf.call(this, f, result);
	    }, headList.apply(this, arguments), tailList);
	  });
	});
	module.exports = pipeWith;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(40);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns a new list with the given element at the front, followed by the
	 * contents of the list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The item to add to the head of the output list.
	 * @param {Array} list The array to add to the tail of the output list.
	 * @return {Array} A new array.
	 * @see R.append
	 * @example
	 *
	 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
	 */
	
	
	var prepend = /*#__PURE__*/_curry2(function prepend(el, list) {
	  return _concat([el], list);
	});
	module.exports = prepend;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * Similar to [`reduce`](#reduce), except moves through the input list from the
	 * right to the left.
	 *
	 * The iterator function receives two values: *(value, acc)*, while the arguments'
	 * order of `reduce`'s iterator function is *(acc, value)*.
	 *
	 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduceRight` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> b) -> b -> [a] -> b
	 * @param {Function} fn The iterator function. Receives two values, the current element from the array
	 *        and the accumulator.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.addIndex
	 * @example
	 *
	 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
	 *      //    -               -2
	 *      //   / \              / \
	 *      //  1   -            1   3
	 *      //     / \              / \
	 *      //    2   -     ==>    2  -1
	 *      //       / \              / \
	 *      //      3   -            3   4
	 *      //         / \              / \
	 *      //        4   0            4   0
	 *
	 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
	 */
	
	
	var reduceRight = /*#__PURE__*/_curry3(function reduceRight(fn, acc, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    acc = fn(list[idx], acc);
	    idx -= 1;
	  }
	  return acc;
	});
	module.exports = reduceRight;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Removes the sub-list of `list` starting at index `start` and containing
	 * `count` elements. _Note that this is not destructive_: it returns a copy of
	 * the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @param {Number} start The position to start removing elements
	 * @param {Number} count The number of elements to remove
	 * @param {Array} list The list to remove from
	 * @return {Array} A new Array with `count` elements from `start` removed.
	 * @see R.without
	 * @example
	 *
	 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
	 */
	
	
	var remove = /*#__PURE__*/_curry3(function remove(start, count, list) {
	  var result = Array.prototype.slice.call(list, 0);
	  result.splice(start, count);
	  return result;
	});
	module.exports = remove;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var ap = /*#__PURE__*/__webpack_require__(150);
	
	var map = /*#__PURE__*/__webpack_require__(32);
	
	var prepend = /*#__PURE__*/__webpack_require__(417);
	
	var reduceRight = /*#__PURE__*/__webpack_require__(418);
	
	/**
	 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
	 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
	 * Applicative of Traversable.
	 *
	 * Dispatches to the `sequence` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
	 * @param {Function} of
	 * @param {*} traversable
	 * @return {*}
	 * @see R.traverse
	 * @example
	 *
	 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
	 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
	 *
	 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
	 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
	 */
	
	
	var sequence = /*#__PURE__*/_curry2(function sequence(of, traversable) {
	  return typeof traversable.sequence === 'function' ? traversable.sequence(of) : reduceRight(function (x, acc) {
	    return ap(map(prepend, x), acc);
	  }, of([]), traversable);
	});
	module.exports = sequence;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	var add = /*#__PURE__*/__webpack_require__(104);
	
	var reduce = /*#__PURE__*/__webpack_require__(47);
	
	/**
	 * Adds together all the elements of a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list An array of numbers
	 * @return {Number} The sum of all the numbers in the list.
	 * @see R.reduce
	 * @example
	 *
	 *      R.sum([2,4,6,8,100,1]); //=> 121
	 */
	
	
	var sum = /*#__PURE__*/reduce(add, 0);
	module.exports = sum;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var drop = /*#__PURE__*/__webpack_require__(381);
	
	/**
	 * Returns a new list containing the last `n` elements of the given list.
	 * If `n > list.length`, returns a list of `list.length` elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n The number of elements to return.
	 * @param {Array} xs The collection to consider.
	 * @return {Array}
	 * @see R.dropLast
	 * @example
	 *
	 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
	 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.takeLast(3, 'ramda');               //=> 'mda'
	 */
	
	
	var takeLast = /*#__PURE__*/_curry2(function takeLast(n, xs) {
	  return drop(n >= 0 ? xs.length - n : 0, xs);
	});
	module.exports = takeLast;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Calls an input function `n` times, returning an array containing the results
	 * of those function calls.
	 *
	 * `fn` is passed one argument: The current value of `n`, which begins at `0`
	 * and is gradually incremented to `n - 1`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.3
	 * @category List
	 * @sig (Number -> a) -> Number -> [a]
	 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
	 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
	 * @return {Array} An array containing the return values of all calls to `fn`.
	 * @see R.repeat
	 * @example
	 *
	 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
	 * @symb R.times(f, 0) = []
	 * @symb R.times(f, 1) = [f(0)]
	 * @symb R.times(f, 2) = [f(0), f(1)]
	 */
	
	
	var times = /*#__PURE__*/_curry2(function times(fn, n) {
	  var len = Number(n);
	  var idx = 0;
	  var list;
	
	  if (len < 0 || isNaN(len)) {
	    throw new RangeError('n must be a non-negative number');
	  }
	  list = new Array(len);
	  while (idx < len) {
	    list[idx] = fn(idx);
	    idx += 1;
	  }
	  return list;
	});
	module.exports = times;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	var _Set = /*#__PURE__*/__webpack_require__(386);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list, based upon the value returned by applying the supplied function to
	 * each list element. Prefers the first item if the supplied function produces
	 * the same value on two items. [`R.equals`](#equals) is used for comparison.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> b) -> [a] -> [a]
	 * @param {Function} fn A function used to produce a value to use during comparisons.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
	 */
	
	
	var uniqBy = /*#__PURE__*/_curry2(function uniqBy(fn, list) {
	  var set = new _Set();
	  var result = [];
	  var idx = 0;
	  var appliedItem, item;
	
	  while (idx < list.length) {
	    item = list[idx];
	    appliedItem = fn(item);
	    if (set.add(appliedItem)) {
	      result.push(item);
	    }
	    idx += 1;
	  }
	  return result;
	});
	module.exports = uniqBy;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	var _includesWith = /*#__PURE__*/__webpack_require__(110);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list, based upon the value returned by applying the supplied predicate to
	 * two list elements. Prefers the first item if two items compare equal based
	 * on the predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category List
	 * @sig ((a, a) -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      const strEq = R.eqBy(String);
	 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
	 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
	 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
	 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
	 */
	
	
	var uniqWith = /*#__PURE__*/_curry2(function uniqWith(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	  var item;
	  while (idx < len) {
	    item = list[idx];
	    if (!_includesWith(pred, item, result)) {
	      result[result.length] = item;
	    }
	    idx += 1;
	  }
	  return result;
	});
	module.exports = uniqWith;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var curryN = /*#__PURE__*/__webpack_require__(18);
	
	/**
	 * Accepts a function `fn` and a list of transformer functions and returns a
	 * new curried function. When the new function is invoked, it calls the
	 * function `fn` with parameters consisting of the result of calling each
	 * supplied handler on successive arguments to the new function.
	 *
	 * If more arguments are passed to the returned function than transformer
	 * functions, those arguments are passed directly to `fn` as additional
	 * parameters. If you expect additional arguments that don't need to be
	 * transformed, although you can ignore them, it's best to pass an identity
	 * function so that the new function reports the correct arity.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((x1, x2, ...) -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} fn The function to wrap.
	 * @param {Array} transformers A list of transformer functions
	 * @return {Function} The wrapped function.
	 * @see R.converge
	 * @example
	 *
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
	 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
	 */
	
	
	var useWith = /*#__PURE__*/_curry2(function useWith(fn, transformers) {
	  return curryN(transformers.length, function () {
	    var args = [];
	    var idx = 0;
	    while (idx < transformers.length) {
	      args.push(transformers[idx].call(this, arguments[idx]));
	      idx += 1;
	    }
	    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
	  });
	});
	module.exports = useWith;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var keys = /*#__PURE__*/__webpack_require__(41);
	
	/**
	 * Returns a list of all the enumerable own properties of the supplied object.
	 * Note that the order of the output array is not guaranteed across different
	 * JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [v]
	 * @param {Object} obj The object to extract values from
	 * @return {Array} An array of the values of the object's own properties.
	 * @see R.valuesIn, R.keys
	 * @example
	 *
	 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
	 */
	
	
	var values = /*#__PURE__*/_curry1(function values(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var vals = [];
	  var idx = 0;
	  while (idx < len) {
	    vals[idx] = obj[props[idx]];
	    idx += 1;
	  }
	  return vals;
	});
	module.exports = values;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _has = /*#__PURE__*/__webpack_require__(25);
	
	/**
	 * Takes a spec object and a test object; returns true if the test satisfies
	 * the spec. Each of the spec's own properties must be a predicate function.
	 * Each predicate is applied to the value of the corresponding property of the
	 * test object. `where` returns true if all the predicates return true, false
	 * otherwise.
	 *
	 * `where` is well suited to declaratively expressing constraints for other
	 * functions such as [`filter`](#filter) and [`find`](#find).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category Object
	 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
	 * @param {Object} spec
	 * @param {Object} testObj
	 * @return {Boolean}
	 * @see R.propSatisfies, R.whereEq
	 * @example
	 *
	 *      // pred :: Object -> Boolean
	 *      const pred = R.where({
	 *        a: R.equals('foo'),
	 *        b: R.complement(R.equals('bar')),
	 *        x: R.gt(R.__, 10),
	 *        y: R.lt(R.__, 20)
	 *      });
	 *
	 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
	 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
	 */
	
	
	var where = /*#__PURE__*/_curry2(function where(spec, testObj) {
	  for (var prop in spec) {
	    if (_has(prop, spec) && !spec[prop](testObj[prop])) {
	      return false;
	    }
	  }
	  return true;
	});
	module.exports = where;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Selection save and restore module for Rangy.
	 * Saves and restores user selections using marker invisible elements in the DOM.
	 *
	 * Part of Rangy, a cross-browser JavaScript range and selection library
	 * https://github.com/timdown/rangy
	 *
	 * Depends on Rangy core.
	 *
	 * Copyright 2022, Tim Down
	 * Licensed under the MIT license.
	 * Version: 1.3.1
	 * Build date: 17 August 2022
	 */
	(function(factory, root) {
	    if (true) {
	        // AMD. Register as an anonymous module with a dependency on Rangy.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(167)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module != "undefined" && typeof exports == "object") {
	        // Node/CommonJS style
	        module.exports = factory( require("rangy") );
	    } else {
	        // No AMD or CommonJS support so we use the rangy property of root (probably the global variable)
	        factory(root.rangy);
	    }
	})(function(rangy) {
	    rangy.createModule("SaveRestore", ["WrappedSelection"], function(api, module) {
	        var dom = api.dom;
	        var removeNode = dom.removeNode;
	        var isDirectionBackward = api.Selection.isDirectionBackward;
	        var markerTextChar = "\ufeff";
	
	        function gEBI(id, doc) {
	            return (doc || document).getElementById(id);
	        }
	
	        function insertRangeBoundaryMarker(range, atStart) {
	            var markerId = "selectionBoundary_" + (+new Date()) + "_" + ("" + Math.random()).slice(2);
	            var markerEl;
	            var doc = dom.getDocument(range.startContainer);
	
	            // Clone the Range and collapse to the appropriate boundary point
	            var boundaryRange = range.cloneRange();
	            boundaryRange.collapse(atStart);
	
	            // Create the marker element containing a single invisible character using DOM methods and insert it
	            markerEl = doc.createElement("span");
	            markerEl.id = markerId;
	            markerEl.style.lineHeight = "0";
	            markerEl.style.display = "none";
	            markerEl.className = "rangySelectionBoundary";
	            markerEl.appendChild(doc.createTextNode(markerTextChar));
	
	            boundaryRange.insertNode(markerEl);
	            return markerEl;
	        }
	
	        function setRangeBoundary(doc, range, markerId, atStart) {
	            var markerEl = gEBI(markerId, doc);
	            if (markerEl) {
	                range[atStart ? "setStartBefore" : "setEndBefore"](markerEl);
	                removeNode(markerEl);
	            } else {
	                module.warn("Marker element has been removed. Cannot restore selection.");
	            }
	        }
	
	        function compareRanges(r1, r2) {
	            return r2.compareBoundaryPoints(r1.START_TO_START, r1);
	        }
	
	        function saveRange(range, direction) {
	            var startEl, endEl, doc = api.DomRange.getRangeDocument(range), text = range.toString();
	            var backward = isDirectionBackward(direction);
	
	            if (range.collapsed) {
	                endEl = insertRangeBoundaryMarker(range, false);
	                return {
	                    document: doc,
	                    markerId: endEl.id,
	                    collapsed: true
	                };
	            } else {
	                endEl = insertRangeBoundaryMarker(range, false);
	                startEl = insertRangeBoundaryMarker(range, true);
	
	                return {
	                    document: doc,
	                    startMarkerId: startEl.id,
	                    endMarkerId: endEl.id,
	                    collapsed: false,
	                    backward: backward,
	                    toString: function() {
	                        return "original text: '" + text + "', new text: '" + range.toString() + "'";
	                    }
	                };
	            }
	        }
	
	        function restoreRange(rangeInfo, normalize) {
	            var doc = rangeInfo.document;
	            if (typeof normalize == "undefined") {
	                normalize = true;
	            }
	            var range = api.createRange(doc);
	            if (rangeInfo.collapsed) {
	                var markerEl = gEBI(rangeInfo.markerId, doc);
	                if (markerEl) {
	                    markerEl.style.display = "inline";
	                    var previousNode = markerEl.previousSibling;
	
	                    // Workaround for issue 17
	                    if (previousNode && previousNode.nodeType == 3) {
	                        removeNode(markerEl);
	                        range.collapseToPoint(previousNode, previousNode.length);
	                    } else {
	                        range.collapseBefore(markerEl);
	                        removeNode(markerEl);
	                    }
	                } else {
	                    module.warn("Marker element has been removed. Cannot restore selection.");
	                }
	            } else {
	                setRangeBoundary(doc, range, rangeInfo.startMarkerId, true);
	                setRangeBoundary(doc, range, rangeInfo.endMarkerId, false);
	            }
	
	            if (normalize) {
	                range.normalizeBoundaries();
	            }
	
	            return range;
	        }
	
	        function saveRanges(ranges, direction) {
	            var rangeInfos = [], range, doc;
	            var backward = isDirectionBackward(direction);
	
	            // Order the ranges by position within the DOM, latest first, cloning the array to leave the original untouched
	            ranges = ranges.slice(0);
	            ranges.sort(compareRanges);
	
	            for (var i = 0, len = ranges.length; i < len; ++i) {
	                rangeInfos[i] = saveRange(ranges[i], backward);
	            }
	
	            // Now that all the markers are in place and DOM manipulation over, adjust each range's boundaries to lie
	            // between its markers
	            for (i = len - 1; i >= 0; --i) {
	                range = ranges[i];
	                doc = api.DomRange.getRangeDocument(range);
	                if (range.collapsed) {
	                    range.collapseAfter(gEBI(rangeInfos[i].markerId, doc));
	                } else {
	                    range.setEndBefore(gEBI(rangeInfos[i].endMarkerId, doc));
	                    range.setStartAfter(gEBI(rangeInfos[i].startMarkerId, doc));
	                }
	            }
	
	            return rangeInfos;
	        }
	
	        function saveSelection(win) {
	            if (!api.isSelectionValid(win)) {
	                module.warn("Cannot save selection. This usually happens when the selection is collapsed and the selection document has lost focus.");
	                return null;
	            }
	            var sel = api.getSelection(win);
	            var ranges = sel.getAllRanges();
	            var backward = (ranges.length == 1 && sel.isBackward());
	
	            var rangeInfos = saveRanges(ranges, backward);
	
	            // Ensure current selection is unaffected
	            if (backward) {
	                sel.setSingleRange(ranges[0], backward);
	            } else {
	                sel.setRanges(ranges);
	            }
	
	            return {
	                win: win,
	                rangeInfos: rangeInfos,
	                restored: false
	            };
	        }
	
	        function restoreRanges(rangeInfos) {
	            var ranges = [];
	
	            // Ranges are in reverse order of appearance in the DOM. We want to restore earliest first to avoid
	            // normalization affecting previously restored ranges.
	            var rangeCount = rangeInfos.length;
	
	            for (var i = rangeCount - 1; i >= 0; i--) {
	                ranges[i] = restoreRange(rangeInfos[i], true);
	            }
	
	            return ranges;
	        }
	
	        function restoreSelection(savedSelection, preserveDirection) {
	            if (!savedSelection.restored) {
	                var rangeInfos = savedSelection.rangeInfos;
	                var sel = api.getSelection(savedSelection.win);
	                var ranges = restoreRanges(rangeInfos), rangeCount = rangeInfos.length;
	
	                if (rangeCount == 1 && preserveDirection && api.features.selectionHasExtend && rangeInfos[0].backward) {
	                    sel.removeAllRanges();
	                    sel.addRange(ranges[0], true);
	                } else {
	                    sel.setRanges(ranges);
	                }
	
	                savedSelection.restored = true;
	            }
	        }
	
	        function removeMarkerElement(doc, markerId) {
	            var markerEl = gEBI(markerId, doc);
	            if (markerEl) {
	                removeNode(markerEl);
	            }
	        }
	
	        function removeMarkers(savedSelection) {
	            var rangeInfos = savedSelection.rangeInfos;
	            for (var i = 0, len = rangeInfos.length, rangeInfo; i < len; ++i) {
	                rangeInfo = rangeInfos[i];
	                if (rangeInfo.collapsed) {
	                    removeMarkerElement(savedSelection.doc, rangeInfo.markerId);
	                } else {
	                    removeMarkerElement(savedSelection.doc, rangeInfo.startMarkerId);
	                    removeMarkerElement(savedSelection.doc, rangeInfo.endMarkerId);
	                }
	            }
	        }
	
	        api.util.extend(api, {
	            saveRange: saveRange,
	            restoreRange: restoreRange,
	            saveRanges: saveRanges,
	            restoreRanges: restoreRanges,
	            saveSelection: saveSelection,
	            restoreSelection: restoreSelection,
	            removeMarkerElement: removeMarkerElement,
	            removeMarkers: removeMarkers
	        });
	    });
	    
	    return rangy;
	}, this);

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	module.exports = "<script type=\"text/ng-template\" id=\"help-description-modal.html\">\n  <div class=\"modal-header\">\n  \t<div>\n  \t\t<center>\n  \t\t  <h3>Help</h3>\n  \t\t</center>\n  \t</div>\n  </div>\n  <div class=\"modal-body wizard-popup\">\n  \t<div class=\"list-wizard\">\n  \t\t\t<ul class=\"nav nav-pills tab-Matches\">\n  \t\t\t\t\t<li ng-class=\"{active:ctrl.isModalSet(3)}\"><a ng-click=\"ctrl.showModalTab(3,'tab')\">\n  \t\t\t\t\t\t<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n  \t\t\t\t\t\tstyle=\"padding-right: 15px;width:50px;height: 23px;\" viewBox=\"0 0 614.9 540\" style=\"enable-background:new 0 0 614.9 540;\" xml:space=\"preserve\">\n  \t\t\t\t\t\t\t<style type=\"text/css\">\n  \t\t\t\t\t\t\t\t.st0{fill:#9D9D9D;}\n  \t\t\t\t\t\t\t</style>\n  \t\t\t\t\t\t\t<path class=\"st0\" d=\"M512.9,3.8H102c-16.6,0-30,13.4-30,30v472.4c0,16.6,13.4,30,30,30h410.9c16.6,0,30-13.4,30-30V33.8\n  \t\t\t\t\t\t\t\tC542.9,17.2,529.5,3.8,512.9,3.8z M433.7,425.5H181.2c-15.1,0-27.3-12.2-27.3-27.3c0-15.1,12.2-27.3,27.3-27.3h252.6\n  \t\t\t\t\t\t\t\tc15.1,0,27.3,12.2,27.3,27.3C461,413.3,448.8,425.5,433.7,425.5z M433.7,302H181.2c-15.1,0-27.3-12.2-27.3-27.3\n  \t\t\t\t\t\t\t\tc0-15.1,12.2-27.3,27.3-27.3h252.6c15.1,0,27.3,12.2,27.3,27.3C461,289.8,448.8,302,433.7,302z M433.7,178.6H181.2\n  \t\t\t\t\t\t\t\tc-15.1,0-27.3-12.2-27.3-27.3c0-15.1,12.2-27.3,27.3-27.3h252.6c15.1,0,27.3,12.2,27.3,27.3C461,166.4,448.8,178.6,433.7,178.6z\"/>\n  \t\t\t\t\t\t</svg>\n  \t\t\t\t\t\tDescription</a></li>\n  \t\t\t\t\t<li  class=\"straightline\"></li>\n\n  \t\t\t\t\t<li ng-class=\"{active:ctrl.isModalSet(1)}\"><a ng-click=\"ctrl.showModalTab(1,'tab')\">\n  \t\t\t\t\t\t<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n  \t\t\t\t\t\t\t\tstyle=\"padding-right: 15px;width:50px;height: 23px;\" viewBox=\"0 0 614.9 540\" style=\"enable-background:new 0 0 614.9 540;\" xml:space=\"preserve\">\n  \t\t\t\t\t\t\t<style type=\"text/css\">\n  \t\t\t\t\t\t\t\t.st0{fill:#9D9D9D;}\n  \t\t\t\t\t\t\t</style>\n  \t\t\t\t\t\t\t<g>\n  \t\t\t\t\t\t\t\t<circle class=\"st0\" cx=\"282.2\" cy=\"206.9\" r=\"67.3\"/>\n  \t\t\t\t\t\t\t\t<path class=\"st0\" d=\"M562.6,472.1l-87.8-87.8l3.5-5.1c28-40.4,42.2-86.1,42.2-135.7c0-32.3-6.4-63.6-18.9-93\n  \t\t\t\t\t\t\t\t\tc-12.5-29.5-29.7-55.3-51-76.6c-21.3-21.3-47.1-38.5-76.6-51C344.6,10.3,313.3,4,281,4c-32.3,0-63.6,6.4-93,18.9\n  \t\t\t\t\t\t\t\t\tc-29.5,12.5-55.3,29.7-76.6,51C90,95.2,72.9,121,60.3,150.5c-12.5,29.5-18.9,60.8-18.9,93c0,32.3,6.4,63.6,18.9,93\n  \t\t\t\t\t\t\t\t\tc12.5,29.5,29.7,55.3,51,76.6c21.3,21.3,47.1,38.5,76.6,51c29.5,12.5,60.8,18.9,93,18.9c49.7,0,95.3-14.2,135.7-42.2l5-3.5\n  \t\t\t\t\t\t\t\t\tl87.9,87.5c7.2,7.6,15.5,11.1,26.3,11.1c10.1,0,18.9-3.8,26.4-11.2c7.4-7.4,11.2-16.3,11.2-26.4\n  \t\t\t\t\t\t\t\t\tC573.5,488.2,569.8,479.3,562.6,472.1z M397.2,359.7c-0.8,0.8-1.6,1.6-2.5,2.4C363.2,392.6,324.9,408,281,408\n  \t\t\t\t\t\t\t\t\tc-43.2,0-80.9-14.9-112.2-44.4c-1.6-1.5-2.8-2.7-4.1-3.9c-32-32-48.3-71.1-48.3-116.2c0-45.1,16.2-84.2,48.3-116.2\n  \t\t\t\t\t\t\t\t\tc32-32,71.1-48.3,116.2-48.3c45.1,0,84.2,16.2,116.2,48.3c32,32,48.3,71.1,48.3,116.2C445.5,288.6,429.2,327.7,397.2,359.7z\"/>\n  \t\t\t\t\t\t\t\t<path class=\"st0\" d=\"M281.7,387.1c1.6,0,3.3,0,4.9-0.1c-1.7,0.1-3.5,0.1-5.3,0.1C281.5,387.1,281.6,387.1,281.7,387.1z\"/>\n  \t\t\t\t\t\t\t\t<path class=\"st0\" d=\"M380.4,333.5c-22.2-30.1-57.9-49.6-98.2-49.6c-40.5,0-76.4,19.8-98.6,50.2c23,28.6,58.3,47,97.8,47.1\n  \t\t\t\t\t\t\t\t\tc1.7,0,3.4,0,5-0.1C324.5,379.6,358.2,361.4,380.4,333.5z\"/>\n  \t\t\t\t\t\t\t</g>\n  \t\t\t\t\t\t</svg>\n  \t\t\t\t\t\tMatches</a></li>\n  \t\t\t\t\t<li  class=\"straightline\"></li>\n\n  \t\t\t\t\t<li ng-class=\"{active:ctrl.isModalSet(2)}\"><a ng-click=\"ctrl.showModalTab(2,'tab')\">\n  \t\t\t\t\t\t<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n  \t\t\t\t\t\t\t\tstyle=\"padding-right: 15px; width:50px;height: 23px;\"\tviewBox=\"0 0 614.9 540\" style=\"enable-background:new 0 0 614.9 540;\" xml:space=\"preserve\">\n  \t\t\t\t\t\t\t\t<style type=\"text/css\">\n  \t\t\t\t\t\t\t\t\t.st0{fill:#9D9D9D;}\n  \t\t\t\t\t\t\t\t</style>\n  \t\t\t\t\t\t\t\t<g>\n  \t\t\t\t\t\t\t\t\t<path class=\"st0\" d=\"M22.7,338.7l301.1,92.6c2.2,0.7,4.5,1,6.8,1c3.3,0,6.6-0.7,9.6-2.1l254.7-115.8c11.6-5.3,16.8-19,11.5-30.7\n  \t\t\t\t\t\t\t\t\t\tc-5.3-11.6-18.9-16.8-30.7-11.5L329,384.5L36.3,294.4c-12.2-3.8-25.2,3.1-28.9,15.3C3.6,322,10.5,334.9,22.7,338.7z\"/>\n  \t\t\t\t\t\t\t\t\t<path class=\"st0\" d=\"M22.7,246.1l301.1,92.6c2.2,0.7,4.5,1,6.8,1c3.4,0,6.8-0.7,9.9-2.2c1-0.5,104.2-49.2,160.4-72.9\n  \t\t\t\t\t\t\t\t\t\tc83.9-35.4,83.9-80.6,83.9-149.1V112c0-10.7-7.3-19.9-17.6-22.5L267.4,15.7c-6.9-1.7-14.2-0.1-19.8,4.3c-5.6,4.4-8.9,11.1-8.9,18.2\n  \t\t\t\t\t\t\t\t\t\tc0,61.6-15.8,79.1-49.1,93.1L20.5,202.6c-9,3.8-14.6,12.8-14.1,22.5C6.9,234.8,13.4,243.2,22.7,246.1z\"/>\n  \t\t\t\t\t\t\t\t\t<path class=\"st0\" d=\"M575.8,365L329,477.1L36.3,387.1c-12.2-3.8-25.2,3.1-28.9,15.3c-3.8,12.2,3.1,25.2,15.3,28.9L323.8,524\n  \t\t\t\t\t\t\t\t\t\tc2.2,0.7,4.5,1,6.8,1c3.3,0,6.6-0.7,9.6-2.1l254.7-115.8c11.6-5.3,16.8-19,11.5-30.7C601.2,364.8,587.5,359.6,575.8,365z\"/>\n  \t\t\t\t\t\t\t\t</g>\n  \t\t\t\t\t\t\t\t</svg>\n  \t\t\t\t\t\tApplications</a></li>\n  \t\t\t\t\t<li  class=\"straightline\"></li>\n\n  \t\t\t\t\t<li ng-class=\"{active:ctrl.isModalSet(4)}\"><a ng-click=\"ctrl.showModalTab(4,'tab')\">\n  \t\t\t\t\t\t<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n  \t\t\t\t\t\t\tstyle=\"padding-right: 15px; width:50px;height: 23px;  margin-top: -4px;\" viewBox=\"0 0 614.9 540\" style=\"enable-background:new 0 0 614.9 540;\" xml:space=\"preserve\">\n  \t\t\t\t\t\t\t<style type=\"text/css\">\n  \t\t\t\t\t\t\t\t.st0{fill:#9D9D9D;}\n  \t\t\t\t\t\t\t</style>\n  \t\t\t\t\t\t\t<g>\n  \t\t\t\t\t\t\t\t<path class=\"st0\" d=\"M334.9,223.6c7.1-9,13.1-16.6,20.6-22.9c13.9-11.7,30-18.8,47.6-22.2c24.4-4.7,48.8-5.1,73.2,0.2\n  \t\t\t\t\t\t\t\t\tc38.7,8.4,64,32.1,78.3,68.3c7.9,19.9,11.5,40.8,13.1,62.1c3,40.1,1.4,80.2,1.7,120.4c0.2,28.5,0.1,57,0,85.5\n  \t\t\t\t\t\t\t\t\tc0,12.2-6.6,19-18.7,19c-25.5,0.1-51,0.1-76.6,0c-12.2,0-18.9-6.8-18.9-18.9c0-55.9,0.1-111.7-0.1-167.6c0-13.5-1.4-26.9-6.1-39.8\n  \t\t\t\t\t\t\t\t\tc-9-25-26.6-37.2-53.1-36.7c-26,0.5-45.2,15.4-54.3,42.1c-4.6,13.6-7,27.5-6.9,41.9c0.2,52.5,0.1,105.1,0.1,157.6\n  \t\t\t\t\t\t\t\t\tc0,15.4-6.1,21.4-21.5,21.4c-23.5,0-47,0-70.5,0c-13.2,0-19.8-6.6-19.8-19.7c0-104.7,0-209.4,0-314.1c0-13.5,6.6-20,20-20\n  \t\t\t\t\t\t\t\t\tc24,0,48.1,0,72.1,0c12.7,0,19.5,6.8,19.5,19.5C334.9,207,334.9,214.5,334.9,223.6z\"/>\n  \t\t\t\t\t\t\t\t<path class=\"st0\" d=\"M61.3,356.7c0-51.6,0-103.2,0-154.8c0-14.9,6.8-21.7,21.7-21.7c23.1,0,46.2,0,69.4,0\n  \t\t\t\t\t\t\t\t\tc13.5,0,20.6,6.9,20.6,20.5c0,104.3,0,208.7,0,313c0,13.3-7,20.3-20.2,20.3c-23.7,0.1-47.4,0.1-71,0c-13.4,0-20.4-7.2-20.4-20.7\n  \t\t\t\t\t\t\t\t\tC61.3,461,61.3,408.8,61.3,356.7z\"/>\n  \t\t\t\t\t\t\t\t<path class=\"st0\" d=\"M45.3,78.1c0-39.8,32-71.9,71.8-72.1c39.5-0.2,72.1,32.2,72.4,71.8c0.3,39.6-32.5,72.4-72.3,72.3\n  \t\t\t\t\t\t\t\t\tC77.2,150,45.3,118,45.3,78.1z\"/>\n  \t\t\t\t\t\t\t</g>\n  \t\t\t\t\t\t</svg>\n  \t\t\t\t\t\tSource</a></li>\n  \t\t\t\t</ul>\n  \t</div>\n  \t<div class=\"description-wizard\">\n  \t\t\t<p ng-class=\"{boldpara:ctrl.isModalSet(3)}\">Review Position Description to understand employer requirements. </p>\n  \t\t\t<p  style=\"height: 1px;margin: 15px \"></p>\n  \t\t\t<p ng-class=\"{boldpara:ctrl.isModalSet(1)}\">Review LexStep Matches - use filters to refine search and shortlist top candidates by promoting their match stage to “Scouted”.  Reach out to your assigned candidates and ask other Talent Agents to reach out to theirs to encourage interest in the Position. </p>\n  \t\t\t<p  style=\"height: 1px;margin: 15px\"></p>\n  \t\t\t<p ng-class=\"{boldpara:ctrl.isModalSet(2)}\">Review Applications to manage Interest in the Position. </p>\n  \t\t\t<p  style=\"height: 40px;margin: 15px;\"></p>\n  \t\t\t<p ng-class=\"{boldpara:ctrl.isModalSet(4)}\">Source additional off-platform candidate leads for the Position via LinkedIn. </p>\n  \t</div>\n  </div>\n  <div class=\"modal-footer\">\n  \t\t<center>\n  \t\t\t  <button class=\"closeDescriptionbtn\" ng-click=\"ctrl.cancel()\">Close</button>\n  \t\t</center>\n  \t</div>\n</script>\n"

/***/ }),
/* 431 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-signin\">\n  <div ng-click=\"hideDropDown()\">\n    <span\n      us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n      spinner-key=\"spinner-applications\"\n      class=\"lawyer-actions-spinner\"\n    ></span>\n    <div\n      class=\"panel panel-default\"\n      ng-class=\"{ 'bg-white': applications.length === 0, 'bg-grey': !applications.length === 0 }\"\n    >\n      <div class=\"text-center padding-t15\" ng-if=\"applications.length === 0\">\n        <h4>\n          {{candidate.user.firstName | uppercase}} hasn't applied for any jobs\n          yet\n        </h4>\n      </div>\n      <div\n        data-ng-repeat=\"(key, applicationGroup) in applications | orderBy:'-liveStatus' | groupBy: 'liveStatus'\"\n      >\n        <br />\n        <div class=\"margin-b20 job-group-title\" ng-if=\"key == 'Archived'\">\n          <span class=\"margin-0 job-groups\"\n            >{{key}} ({{applicationGroup.length}})</span\n          >\n        </div>\n        <div\n          class=\"list-item list-item-applied-jobs clearfix\"\n          data-ng-repeat-start=\"application in applicationGroup | orderBy:'-applicationCreatedDate'\"\n          ng-click=\"expandApplication(application)\"\n        >\n          <div class=\"col-md-5 col-sm-12 list-col-firm\">\n            <div class=\"pull-left list-firm-logo\">\n              <img\n                class=\"\"\n                alt=\"{{application.employerName}}\"\n                ng-src=\"{{application.employerPicture}}\"\n              />\n            </div>\n\n            <div class=\"media-body\">\n              <table border=\"0\" cellspacing=\"0\" cellpadding=\"0\" width=\"100%\">\n                <tr>\n                  <td class=\"list-job-title\">\n                    <h2 class=\"margin-t0 margin-b0 text-thin\">\n                      {{application.employerName}}\n                      <img\n                        ng-repeat=\"employerType in application.employerTypes\"\n                        ng-src=\"{{(employerType.name === 'Private Practice')?'/images/Private.png':'/images/Inhouse.png'}}\"\n                      />\n                    </h2>\n                    <h5\n                      ng-if=\"!application.positionVisible\"\n                      class=\"label label-info text-uppercase\"\n                      style=\"background-color: #ffef00; color:black;width: 52px;font-weight:normal;\"\n                    >\n                      Invisible Position\n                    </h5>\n                    <h5\n                      ng-if=\"!application.employerVisible\"\n                      class=\"label label-info text-uppercase\"\n                      style=\"background-color: #ffef00; color:black;width: 52px;font-weight:normal;\"\n                    >\n                      Invisible Firm\n                    </h5>\n                    <h5\n                      ng-if=\"application.positionHidden\"\n                      class=\"label label-info text-uppercase\"\n                      style=\"background-color: #e6b36a; color:black;width: 52px;font-weight:normal;\"\n                    >\n                      Position not for me\n                    </h5>\n                    <h5\n                      ng-if=\"application.employerHidden\"\n                      class=\"label label-info text-uppercase\"\n                      style=\"background-color: #e6b36a; color:black;width: 52px;font-weight:normal;\"\n                    >\n                      Employer not for me\n                    </h5>\n                    <h5\n                      ng-if=\"application.positionArchive\"\n                      class=\"label label-info text-uppercase\"\n                      style=\"background-color: #F44336;; color:white;width: 52px;font-weight:normal;\"\n                    >\n                      Deleted Position\n                    </h5>\n                  </td>\n                </tr>\n              </table>\n            </div>\n          </div>\n\n          <div class=\"col-md-3 col-sm-6\">\n            <table border=\"0\" cellspacing=\"0\" cellpadding=\"0\" width=\"100%\">\n              <tr>\n                <td class=\"list-job-title text-center\">\n                  <h4 class=\"margin-t0 margin-b0\">\n                    {{application.positionTitle}}\n                  </h4>\n                  <small>\n                    <span ng-if=\"application.isOffPlatform\">\n                      INDICATED INTEREST <strong>OFF-PLATFORM</strong> ON\n                    </span>\n                    <span ng-if=\"!application.isOffPlatform\">\n                      INDICATED INTEREST ON\n                    </span>\n                    {{application.applicationCreatedDate|date:\"dd-MMMM-yyyy\"}}\n                  </small>\n                </td>\n              </tr>\n            </table>\n          </div>\n          <div class=\"col-md-4 col-sm-6\">\n            <div class=\"row applicationpipelinediv\">\n              <ul class=\"applicationpipeline\">\n                <li\n                  name=\"{{stage.name}}\"\n                  id=\"{{application.positionId}}{{stage.id}}\"\n                  cy-data=\"application-stage\"\n                  ng-style=\"stage.id===application.stage.id && fetchApplicationActiveTab(application.positionId,stage.name, stage.id, application.applicationStatus)\"\n                  class=\"child-tab-list\"\n                  ng-if=\"stage.parentId === null\"\n                  ng-repeat=\"stage in applicationStages\"\n                >\n                  <span class=\"triangular-tabs\"></span>\n                </li>\n              </ul>\n              <div class=\"applicationstatus\">\n                <small\n                  ><b>Stage: &nbsp;</b> {{application.stage.name}} -\n                  {{application.substage.name}}</small\n                ><br />\n\n                <small\n                  ><b>Status: &nbsp;</b>\n                  {{application.applicationStatus}}</small\n                ><br />\n                <!-- <p>Applied : &nbsp; {{application.createdAt|date:\"dd/MM/yyyy\"}} </p> -->\n                <small\n                  ><b>Last Updated : </b> &nbsp;\n                  {{application.applicationUpdatedDate|date:\"dd/MM/yyyy\n                  HH:mm\"}}</small\n                >\n              </div>\n            </div>\n            <div\n              ng-if=\"application.feedBack\"\n              class=\"row applicationpipelinediv\"\n            >\n              <small>\n                <b>Feedback:</b\n                ><a\n                  tooltip=\"{{application.feedBack}}\"\n                  tooltip-placement=\"right\"\n                >\n                  <span\n                    class=\"badge badge-grey\"\n                    style=\"padding: 1px 5px !important;\"\n                  >\n                    <i class=\"fa fa-info\"></i>\n                  </span>\n                </a>\n              </small>\n            </div>\n          </div>\n        </div>\n        <!-- Job Detail -->\n        <div ng-if=\"application.expanded\" data-ng-repeat-end=\"\">\n          <div colspan=\"9\" class=\"padding-t0\">\n            <div\n              class=\"row inner-list\"\n              ng-class=\"{customjob: application.positionType === 'Custom', connectedjob: application.positionType === 'Connect', speculativejob: application.positionType === 'Speculative'}\"\n              style=\"margin: 0 0 10px\"\n            >\n              <div class=\"col-md-3 col-xs-3\">\n                <div>\n                  <h4>\n                    <strong>{{application.positionTitle}}</strong>\n                  </h4>\n                </div>\n                <h5>\n                  ID: {{application.employerId}}_{{application.positionId}}\n                </h5>\n                <h5>\n                  PQE: {{application.lawPreferences.minPqe <= 0\n                  ?\"NQ\":application.lawPreferences.minPqe}}{{application.lawPreferences.maxPqe\n                  == 11?\"+\":(application.lawPreferences.maxPqe <= 0 ||\n                  application.lawPreferences.maxPqe ==\n                  application.lawPreferences.minPqe)?\"\":\"-\"+application.lawPreferences.maxPqe}}\n                  year(s)\n                </h5>\n                <h5>Contract: {{application.contract.name}}</h5>\n                <h5>Occupation: {{application.occupation.name}}</h5>\n                <h5\n                  class=\"admin-parent-location location-{{application.locations[0].country.code === 'GB' ? 'london' : application.location[0].country.region.color}}\"\n                >\n                  {{application.locations[0].country.region.name}}\n                </h5>\n                <br />\n\n                <span ng-show=\"! application.editExpiry\">\n                  <span class=\"h5\">\n                    Last Date to\n                    Apply:{{application.jobData.last_date_to_apply|date:\"dd/MM/yyyy\"}}\n                  </span>\n                </span>\n\n                <h5 ng-show=\"application.positionVisible\">\n                  Job Visibility: Visible\n                </h5>\n                <h5 ng-show=\"!application.positionVisible\" class=\"red-color\">\n                  Job Visibility: Invisible\n                </h5>\n                <h5>\n                  Required Experience: {{application.lawPreferences.minPqe <= 0\n                  ?\"NQ\":application.lawPreferences.minPqe}}{{application.lawPreferences.maxPqe\n                  == 11?\"+\":(application.lawPreferences.maxPqe <= 0 ||\n                  application.lawPreferences.maxPqe ==\n                  application.lawPreferences.minPqe)?\"\":\"-\"+application.lawPreferences.maxPqe}}\n                </h5>\n                <h5>\n                  Uploaded: {{application.positionCreated|date:\"dd-MM-yyyy\"}}\n                </h5>\n              </div>\n\n              <div id=\"{{application.positionId}}\" class=\"col-md-9 col-xs-9\">\n                <div class=\"\" style=\"padding-top: 9px;\">\n                  <div\n                    class=\"job-description-text\"\n                    ng-class=\"{expanded: application.isExpanded}\"\n                  >\n                    <p\n                      ng-bind-html=\"application.positionDescription\"\n                      class=\"\"\n                      align=\"justify\"\n                    ></p>\n                  </div>\n                  <a\n                    href=\"\"\n                    class=\"text-info\"\n                    ng-show=\"!application.isExpanded && application.positionDescription.length > 600\"\n                    ng-click=\"application.isExpanded = !application.isExpanded; $event.stopPropagation()\"\n                    >more</a\n                  >\n                  <a\n                    href=\"\"\n                    class=\"text-info\"\n                    ng-show=\"application.isExpanded && application.positionDescription.length > 600\"\n                    ng-click=\"application.isExpanded = !application.isExpanded; $event.stopPropagation()\"\n                    >less</a\n                  >\n                  <hr class=\"job-practice-sep\" />\n                  <ul\n                    id=\"taglist\"\n                    class=\"list-inline list-practice-area margin-b0\"\n                  >\n                    <li\n                      class=\"tags-box\"\n                      ng-repeat=\"area in application.legalPracticeAreas\"\n                    >\n                      {{area.name}}\n                    </li>\n                  </ul>\n                  <hr class=\"job-practice-sep\" />\n                  <ul\n                    id=\"taglist\"\n                    class=\"list-inline list-practice-area margin-b0\"\n                  >\n                    <li\n                      class=\"tags-box-location location-{{location.countryCode === 'GB' ? 'london' : location.country.region.color}}\"\n                      ng-repeat=\"location in application.locations\"\n                    >\n                      {{location.name}}\n                    </li>\n                  </ul>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <footer class=\"table-footer table-dynamic\" style=\"margin-top: 10px;\">\n          <div class=\"row\">\n            <div class=\"page-num-info col-md-6\">\n              <span>\n                Show\n                <span class=\"ui-select select-enty-count\">\n                  <select\n                    data-ng-model=\"paginationOptions.selectedLimit\"\n                    data-ng-options=\"num for num in paginationOptions.limitOptions\"\n                    data-ng-change=\"applicationsPageChange()\"\n                  >\n                  </select>\n                </span>\n                entries per page\n              </span>\n            </div>\n            <div\n              class=\"text-right pagination-container custom-pagination col-md-6\"\n            >\n              <pagination\n                class=\"pagination-sm\"\n                ng-model=\"pagination.currentPage\"\n                total-items=\"pagination.totalItems\"\n                max-size=\"4\"\n                ng-change=\"applicationsPageChange()\"\n                items-per-page=\"paginationOptions.selectedLimit\"\n                rotate=\"false\"\n                boundary-links=\"true\"\n              >\n              </pagination>\n            </div>\n          </div>\n        </footer>\n        <!-- Job detail end -->\n      </div>\n      <br />\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 432 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <div class=\"\" ng-click=\"hideDropDown()\">\n    <section class=\"page modal-page ng-scope\">\n      <div class=\"row\">\n        <div hidden class=\"callout bg-danger margin-t0\" type=\"info\">\n          <span class=\"glyphicon glyphicon-lock\"></span> &nbsp;\n          <strong class=\"ng-binding\"\n            >Please be assured that we will NEVER share your profile with any\n            firm without your permission.</strong\n          >\n        </div>\n        <div class=\"row\">\n          <div\n            class=\"col-md-12\"\n            ng-show=\"candidate.approvalStatus === 'Locked'\"\n          >\n            <div class=\"alert alert-danger alert-dismissable  margin-t10\">\n              <div>\n                <span>\n                  <i class=\"fa fa-warning\"></i>&nbsp;The profile for this lawyer\n                  has been locked and is waiting for re-approval.</span\n                >\n                <!-- <a href=\"\" class=\"fa fa-times pull-right\" ng-click=\"profileAlert = 'fadeOutDown'; crossAnimate='fadeInUp'; showProfileAlert = false\"></a> -->\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"col-md-12\" ng-show=\"candidate.resumes.length === 0\">\n            <div class=\" animated\" ng-hide=\"profileCVAlert\" ng-class=\"CVAlert\">\n              <div class=\"alert alert-danger alert-dismissable margin-t10\">\n                <button\n                  class=\"close\"\n                  type=\"button\"\n                  ng-click=\"CVAlert = 'zoomOutDownRight'; cvAnimate='fadeIn';profileCVAlert=true\"\n                >\n                  <span aria-hidden=\"true\">×</span>\n                  <span class=\"sr-only\">Close</span>\n                </button>\n                <span class=\"ng-binding ng-scope\">\n                  <i class=\"fa fa-warning\"></i>\n                  <span>\n                    &nbsp;Upload your\n                    <b>CV</b> to connect with employers. &nbsp;\n                  </span>\n                </span>\n                <!-- <a href=\"\" class=\"fa fa-times pull-right\" ng-click=\"profileAlert = 'fadeOutDown'; crossAnimate='fadeInUp'; showProfileAlert = false\"></a> -->\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div\n            class=\"col-md-12 animated\"\n            ng-show=\"candidate && !candidate.user.phone\"\n            ng-class=\"PhoneAlert\"\n          >\n            <div class=\" animated\" ng-hide=\"profilePhoneAlert\">\n              <div\n                class=\"alert alert-danger alert-dismissable  margin-t10\"\n                ng-show=\"!candidate.user.phone\"\n              >\n                <button\n                  class=\"close\"\n                  type=\"button\"\n                  ng-click=\"PhoneAlert = 'zoomOutDownRight'; phoneAnimate='fadeIn'; profilePhoneAlert= true;\"\n                >\n                  <span aria-hidden=\"true\">×</span>\n                  <span class=\"sr-only\">Close</span>\n                </button>\n                <span class=\"ng-binding ng-scope\">\n                  <i class=\"fa fa-warning\"></i>\n                  <span>\n                    &nbsp;Please add a\n                    <b>contact number</b> in order to be able to connect with\n                    employers.\n                  </span>\n                </span>\n                <!-- <a href=\"\" class=\"fa fa-times pull-right\" ng-click=\"profileAlert = 'fadeOutDown'; crossAnimate='fadeInUp'; showProfileAlert = false\"></a> -->\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"panel panel-default section-about margin-b0\">\n            <div class=\"panel-heading hidden\">\n              <strong>About</strong>\n              <!-- <button type=\"button\" class=\"btn btn-noline-info btn-xs pull-right hidden\" ng-show=\"lawyerApproved\">Edit&nbsp; <i class=\"fa fa-pencil\"></i></button> -->\n            </div>\n            <div class=\"panel-body\" ng-if=\"candidate.isAdminProfile\">\n              <div class=\"pull-left profile-image text-center\">\n                <img\n                  id=\"profilePic\"\n                  alt=\"{{candidate.user.firstName | uppercase}} {{candidate.user.lastName | uppercase}}\"\n                  ng-model=\"files\"\n                  class=\"drop-box\"\n                  style=\"padding-top:0px; height:inherit;\"\n                  ng-src=\"{{candidate.user.logoSrc}}\"\n                />\n              </div>\n              <div class=\"media-body\" data-testid=\"candidate-profile\">\n                <button\n                  type=\"button\"\n                  class=\"hidden btn btn-noline-info btn-xs pull-right btn-edit\"\n                  ng-show=\"lawyerApproved\"\n                >\n                  <span class=\"text-edit\">Edit&nbsp; </span>\n                </button>\n\n                <div ng-show=\"!editingName\" data-testid=\"candidate-name\">\n                  <h1 class=\"margin-t0 pull-left\">\n                    <span class=\"ng-binding\"\n                      >{{candidate.user.firstName | uppercase}}\n                      {{candidate.user.lastName | uppercase}}</span\n                    >\n                  </h1>\n                  <a\n                    href=\"\"\n                    id=\"edit-fullname\"\n                    style=\"margin-top: 12px; margin-left: 10px\"\n                    class=\"btn btn-noline-info btn-xs\"\n                    ng-click=\"editName()\"\n                  >\n                    <i class=\"fa fa-pencil\"></i>\n                  </a>\n                </div>\n\n                <span ng-show=\"editingName\">\n                  <input\n                    type=\"text\"\n                    placeholder=\"First Name\"\n                    style=\"display:inline; width: 20%\"\n                    class=\"form-inline form-control margin-b10\"\n                    ng-model=\"editUserData.firstName\"\n                    alphabets-numbers\n                    limit-to=\"30\"\n                  />\n                  <input\n                    type=\"text\"\n                    placeholder=\"Last Name\"\n                    style=\"display:inline; width: 20%\"\n                    class=\"form-inline form-control margin-b10\"\n                    ng-model=\"editUserData.lastName\"\n                    alphabets-numbers\n                    limit-to=\"30\"\n                  />\n\n                  <span name=\"name\">\n                    <a\n                      href=\"\"\n                      id=\"edit-firstname\"\n                      class=\"btn btn-noline-info btn-xs\"\n                      ng-click=\"editingName = false; changeName()\"\n                    >\n                      <i class=\"fa fa-floppy-o\"></i>\n                    </a>\n                    <a\n                      href=\"\"\n                      id=\"edit-lastname\"\n                      class=\"btn btn-noline-info btn-xs\"\n                      ng-click=\"editingName = false; cancelName()\"\n                    >\n                      <i class=\"fa fa-times\"></i>\n                    </a>\n                  </span>\n                </span>\n\n                <div class=\"row alert-icons\">\n                  <div\n                    ng-show=\"!loggedInLawyer.user.user_CV && candidate.resumes.length === 0\"\n                    class=\"animated\"\n                    ng-class=\"cvAnimate\"\n                  >\n                    <span\n                      class=\"btn margin-t0 pull-right\"\n                      ng-show=\"profileCVAlert\"\n                      ng-click=\"CVAlert='zoomInUpLeft'; cvAnimate='fadeOut'; profileCVAlert = false\"\n                    >\n                      <i class=\"text-warning fa fa-warning\"></i>\n                    </span>\n                  </div>\n                  <div\n                    ng-show=\"profilePhoneAlert\"\n                    class=\"animated\"\n                    ng-class=\"phoneAnimate\"\n                  >\n                    <span\n                      class=\"btn margin-t0 pull-right\"\n                      ng-show=\"!candidate.user.phone\"\n                      ng-click=\"PhoneAlert='zoomInUpLeft'; phoneAnimate='fadeOut'; profilePhoneAlert = false\"\n                    >\n                      <i class=\"text-warning fa fa-warning\"></i>\n                    </span>\n                  </div>\n                </div>\n\n                <div class=\"clearfix \"></div>\n                  <span class=\"color-success pull-left margin-0 margin-b5\" ng-if=\"candidate.isAdminProfile && candidate.platformAccess && !candidate.leadAccount\"><i class=\"fa fa-user-circle\"></i> Candidate Account</span>\n                  <span class=\"color-warning pull-left margin-0 margin-b5\" ng-if=\"candidate.isAdminProfile && !candidate.platformAccess && !candidate.leadAccount\"><i class=\"fa fa-user-times\"></i> No Platform Access</span>\n                  <span class=\"color-danger pull-left margin-0 margin-b5\" ng-if=\"candidate.isAdminProfile && candidate.leadAccount\"><i class=\"fa fa-eye\"></i> Lead Account</span>\n                <div class=\"clearfix \"></div>\n                <h5 class=\"pull-left margin-0 margin-b5 \">\n                  <strong> ID: </strong>\n                  {{candidate.id}}\n                </h5>\n                <div class=\"clearfix\"></div>\n                <div\n                  class=\"clearfix margin-b5\"\n                  ng-if=\"!showEditableProfileField\"\n                >\n                  <h5 class=\"pull-left margin-0\">\n                    <strong\n                      >{{'lawyerProfile.curEmployerLabel'| translate}}\n                    </strong>\n                    <span>\n                      {{candidate.employer.name}}\n                      <span ng-if=\"loggedInLawyer.lawyer.recentlyMoved\">\n                        (joined within last 6 months)</span\n                      >\n                    </span>\n                  </h5>\n                </div>\n\n                <div\n                  class=\"clearfix margin-b5\"\n                  ng-if=\"!showEditableProfileField\"\n                >\n                  <h5 class=\"pull-left margin-0\">\n                    <strong>Employer Selectivity:</strong>\n                    <span ng-if=\"candidate.employer.selectivity === 0\"\n                      >Uncategorized</span\n                    >\n                    <span\n                      ng-if=\"candidate.employer.selectivity !== 0\"\n                      ng-repeat=\"n in [] | range:candidate.employer.selectivity\"\n                      >$</span\n                    >\n                  </h5>\n                </div>\n\n                <div class=\"clearfix margin-b5\" ng-if=\"showCancelProfileField\">\n                  <div class=\"col-md-2 col-sm-4 col-xs-12 padding-l0\">\n                    <h5 class=\"pull-left margin-0 margin-t5\">\n                      <strong\n                        >{{'lawyerProfile.curEmployerLabel'| translate}}\n                      </strong>\n                    </h5>\n                  </div>\n                  <div class=\"col-md-4 col-sm-5 col-xs-8 padding-l0\">\n                    <input\n                      type=\"text\"\n                      autocomplete=\"off\"\n                      placeholder=\"Current Employer\"\n                      class=\" pull-left form-control margin-b5\"\n                      ng-model=\"editableCandidateProfile.employer\"\n                      only-alphabets\n                    />\n                  </div>\n                  <div class=\"col-md-4 col-sm-3 col-xs-4 padding-l0\">\n                    <a\n                      href=\"\"\n                      id=\"save-firm\"\n                      ng-click=\"requestToUpdate()\"\n                      class=\"pull-left btn btn-noline-info\"\n                    >\n                      <i id=\"save-firm\" class=\"fa fa-save\"></i>\n                    </a>\n                    <a\n                      href=\"\"\n                      id=\"cancel-candidate-profile\"\n                      ng-click=\"cancelUpdateProfileField($event)\"\n                      class=\"pull-left btn btn-noline-info\"\n                    >\n                      <i id=\"cancel-candidate-profile\" class=\"fa fa-times\"></i>\n                    </a>\n                  </div>\n                </div>\n\n                <div class=\"clearfix\"></div>\n\n                <h5 class=\"pull-left margin-0 margin-b5\">\n                  <strong\n                    >{{'lawyerProfile.universityLabel'| translate}}\n                  </strong>\n                  <span id=\"lawyer-university\"\n                    >{{candidate.candidateEducation}}</span\n                  >\n                </h5>\n\n                <div class=\"clearfix\"></div>\n\n                <h5 class=\"pull-left margin-0 margin-b5\">\n                  <strong\n                    >{{'lawyerProfile.nationalityLabel'| translate}}</strong\n                  >\n                  <span id=\"lawyer-nationality\"\n                    >{{candidate.nationality.name}}</span\n                  >\n                </h5>\n\n                <div class=\"clearfix\"></div>\n\n                <h5 class=\"pull-left margin-0 margin-b5\">\n                  <strong\n                    >{{'lawyerProfile.curLocationLabel'| translate}}</strong\n                  >\n\n                  <span ng-if=\"candidate.location\" id=\"lawyer-current-location\">\n                    {{candidate.location.name}}\n                  </span>\n\n                  <!-- <span\n                  id=\"taglist\"\n                  ng-if=\"lawyerResidence && lawyerResidence.length > 0\"\n                  class=\"list-inline list-practice-area margin-b0 margin-l5\"\n                >\n                  <span\n                    class=\"label label-info text-uppercase margin-l5 label-currently-resides-in\"\n                    ng-repeat=\"location in lawyerResidence\"\n                    style=\"background-color: #66B5D7\"\n                  >\n                    {{location.ref_location.loc_name}}\n                  </span>\n                </span> -->\n                </h5>\n\n                <div class=\"clearfix\"></div>\n                <div class=\"clearfix\"></div>\n                <h5 class=\"pull-left margin-0 margin-b5\">\n                  <strong>{{'lawyerProfile.pqeLabel'| translate}}</strong>\n                  {{candidate.lawProfile.qualificationDate |date:\"MMMM-yyyy\"}} \n                </h5>\n                <div class=\"clearfix\"></div>\n                <h5 class=\"pull-left margin-0 margin-b5\">\n                  <strong>PQE</strong>\n                  {{candidate.calculatedPqe}} \n                </h5>\n\n                <div ng-if=\"!!candidate.user && !!candidate.user.phone\">\n                  <div class=\"clearfix\"></div>\n                  <h5 class=\"pull-left margin-0 margin-b5\">\n                    <strong>\n                      Tel:\n                    </strong>\n                    {{candidate.user.phone}}\n                  </h5>\n                </div>\n                <div ng-if=\"!!candidate.user\">\n                  <div class=\"clearfix\"></div>\n                  <h5\n                    class=\"pull-left margin-0 margin-b5\"\n                    ng-if=\"!!referrerName\"\n                  >\n                    <strong>\n                      Referrer:\n                    </strong>\n                    {{referrerName}}\n                  </h5>\n                  <h5\n                    class=\"pull-left margin-0 margin-b5\"\n                    ng-if=\"!referrerName\"\n                  >\n                    <strong>\n                      Referrer:\n                    </strong>\n                    (No Referrer)\n                  </h5>\n                </div>\n\n                <div class=\"clearfix \"></div>\n                <div\n                  class=\"pull-left\"\n                  ng-if=\"candidate.approvalStatus === 'Approved'\"\n                >\n                  <strong>\n                    Talent Agent:\n                  </strong>\n                  <span\n                    ng-if=\"candidate && candidate.agent && candidate.agent.email\"\n                    >{{candidate.agent.email}}</span\n                  >\n                  <span ng-if=\"!candidate.agent\">(Unassigned)</span>\n                  <span\n                    ng-if=\"lastConversationDay !== null || approvedSince !== null\"\n                    ><b\n                      ><span\n                        ng-if=\"lastConversationDay != null\"\n                        ng-style=\"(lastConversationDay <= 30) && {'color':'green'} ||\n                (lastConversationDay > 30 && lastConversationDay <= 60) && {'color':'#FFD300'} ||\n                (lastConversationDay > 60 && lastConversationDay <= 83) && {'color':'orange'} ||\n                (lastConversationDay > 83 && lastConversationDay <= 90) && {'color':'red'}\"\n                      >\n                        Last Conversation:\n                        <span ng-if=\"lastConversationDay\"\n                          >{{lastConversationDay}} days ago.</span\n                        ><span ng-if=\"!lastConversationDay\">Today</span>\n                        <span\n                          ng-if=\"(lastConversationDay > 83 && lastConversationDay <= 90)\"\n                          >Get in touch?</span\n                        >\n                        <span style=\"text-transform:none\">\n                          <a\n                            href=\"\"\n                            uib-tooltip=\"This candidate will be unassigned if a substantive conversation is not logged for more than 90 consecutive days.\"\n                            uib-tooltip-placement=\"right\"\n                          >\n                            <span class=\"badge badge-grey text-lowercase\">\n                              <i class=\"fa fa-info\"></i>\n                            </span>\n                          </a> </span\n                      ></span>\n                      <span\n                        ng-if=\"approvedSince <= 14 && lastConversationDay == null\"\n                        ng-style=\"(approvedSince <= 7) && {'color':'orange'} ||\n                (approvedSince > 7 && approvedSince <= 14) && {'color':'red'}\"\n                      >\n                        Newly approved {{approvedSince}} days ago.\n                        <span ng-if=\"(approvedSince > 7 && approvedSince <= 14)\"\n                          >Get in touch?</span\n                        >\n                        <span style=\"text-transform:none\">\n                          <a\n                            href=\"\"\n                            uib-tooltip=\"This candidate will be unassigned if a substantive conversation is not logged within 14 days of Approval.\"\n                            uib-tooltip-placement=\"right\"\n                          >\n                            <span class=\"badge badge-grey text-lowercase\">\n                              <i class=\"fa fa-info\"></i>\n                            </span>\n                          </a> </span></span></b\n                  ></span>\n                </div>\n\n                <h5 class=\"pull-right\">\n                  <a\n                    href=\"\"\n                    style=\"text-decoration: none;\"\n                    ng-class=\"{\n                  'actions-enabled': isCandidateActionsAllowedToView,\n                  'actions-disabled': !isCandidateActionsAllowedToView\n                }\"\n                    ng-disabled=\"!isCandidateActionsAllowedToView\"\n                    ng-click=\"isCandidateActionsAllowedToView && openActionsModal(candidate.id, $event)\"\n                  >\n                    Actions &nbsp;\n                    <span\n                      class=\"glyphicon glyphicon-chevron-down\"\n                      style=\"font-size:10px\"\n                    />\n                  </a>\n                  <span\n                    us-spinner=\"{radius:6, width:1, length: 5, color: 'black'}\"\n                    spinner-key=\"spinner-{{candidate.id}}\"\n                    class=\"lawyer-actions-spinner\"\n                  ></span>\n                </h5>\n\n                <div class=\"clearfix\"></div>\n\n                <!-- <h5 class=\"pull-left margin-0\">Does not required sponsership to work in UK.</h5> -->\n              </div>\n            </div>\n            <div\n              class=\"panel panel-default section-about margin-b0\"\n              ng-if=\"!candidate.isAdminProfile\"\n            >\n              <div class=\"panel-body row\">\n                <div class=\"col-md-3 col-sm-4 col-xs-12\">\n                  <div class=\"pull-left profile-image text-center\">\n                    <span\n                      class=\"spinner-profilepic\"\n                      us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n                      spinner-key=\"spinner-dp\"\n                    ></span>\n                    <img\n                      id=\"profilePic\"\n                      ng-file-drop\n                      ng-file-select=\"uploadProfilePicture($files);\"\n                      ng-model=\"files\"\n                      class=\"drop-box\"\n                      drag-over-class=\"dragover\"\n                      ng-multiple=\"false\"\n                      allow-dir=\"true\"\n                      accept=\".jpg,.jpeg,.png\"\n                      style=\"padding-top:0px; height:inherit;\"\n                      ng-src='{{candidate.user.logoSrc || \"//:0\"}}'\n                      uib-tooltip-placement=\"bottom\"\n                      uib-tooltip=\"Format: jpg/jpeg Resolution: 200x200px File Size limit is 8MB\"\n                      ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n                    />\n                    <div ng-no-file-drop>\n                      File Drag/Drop is not supported for this browser\n                    </div>\n                    <i class=\"fa fa-user fa-5x hidden\"></i>\n\n                    <button\n                      id=\"uploadPicBtn\"\n                      type=\"file\"\n                      ng-file-select=\"uploadProfilePicture($files);\"\n                      class=\" btn btn-info btn-w-lg\"\n                      ng-multiple=\"false\"\n                      allow-dir=\"true\"\n                      accept=\".jpg,.jpeg,.png\"\n                      ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n                    >\n                      <i class=\"fa fa-camera\"></i>\n                      {{'btn.upload.label'|translate}}\n                    </button>\n\n                    <button\n                      id=\"removePicBtn\"\n                      class=\"btn btn-danger btn-xs\"\n                      ng-show=\"candidate.user.profilePicture\"\n                      ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n                      ng-click=\"deleteProfilePic(candidate.id,candidate.user.profilePicture)\"\n                    >\n                      <i class=\"fa fa-times\"></i>\n                    </button>\n                  </div>\n                </div>\n\n                <div class=\"col-md-9 col-sm-8 col-xs-12\">\n                  <div class=\"row\">\n                    <h1\n                      data-testid=\"candidate-name\"\n                      class=\"col-md-10 margin-t0 pull-left username\"\n                    >\n                      <span class=\"ng-binding\"\n                        >{{candidate.user.firstName | uppercase}}\n                        {{candidate.user.lastName | uppercase}}</span\n                      >\n                    </h1>\n                    <div class=\"col-md-2 alert-icons\">\n                      <span\n                        class=\"btn margin-t0 animated pull-right\"\n                        ng-class=\"lockAnimate\"\n                        ng-show=\"loggedInLawyer.lawyer.mainAlertCollapse\"\n                        ng-click=\"mainAlert='zoomInUpLeft';lockAnimate='fadeOut'; updateMainAlertStatus()\"\n                      >\n                        <i class=\"text-danger glyphicon glyphicon-lock\"></i>\n                      </span>\n                      <div\n                        ng-show=\"(!loggedInLawyer.user.user_CV && !editCV && loggedInLawyer.user.user_resumes.length === 0) || (loggedInLawyer.lawyer.lawyer_phone === null)\"\n                      >\n                        <span\n                          class=\"btn pull-right\"\n                          ng-show=\"loggedInLawyer.lawyer.profileCvAlertCollapsed || loggedInLawyer.lawyer.profilePhoneAlertCollapsed\"\n                          ng-click=\"updateProfileAlertStatus((!loggedInLawyer.user.user_CV && !editCV && loggedInLawyer.user.user_resumes.length === 0 && loggedInLawyer.user.user_resumes.length === 0 && !loggedInLawyer.lawyer.lawyer_phone)? 'both': (!loggedInLawyer.lawyer.lawyer_phone? 'profilePhoneAlertCollapsed': 'profileCvAlertCollapsed'), false)\"\n                        >\n                          <i class=\"text-warning fa fa-warning\"></i>\n                        </span>\n                      </div>\n                      <!--<div ng-show=\"loggedInLawyer.lawyer.profilePhoneAlertCollapsed\" class=\"animated\" ng-class=\"phoneAnimate\">-->\n                      <!--<span class=\"btn margin-t0 pull-right\" ng-show=\"loggedInLawyer.lawyer.lawyer_phone === null\" ng-click=\"PhoneAlert='zoomInUpLeft'; phoneAnimate='fadeOut'; updateProfileAlertStatus('profilePhoneAlertCollapsed', false)\">-->\n                      <!--<i class=\"text-warning fa fa-warning\"></i>-->\n                      <!--</span>-->\n                      <!--</div>-->\n                    </div>\n                  </div>\n                  <div class=\"row clearfix info-row\">\n                    <div\n                      data-testid=\"profile-header\"\n                      class=\"col-md-6 col-sm-12 col-xs-12 info-box\"\n                    >\n                      <div class=\"row\">\n                        <h5\n                          class=\"pull-left margin-0 col-md-10 col-xs-10 col-sm-10\"\n                          ng-show=\"!showEditableProfileField\"\n                        >\n                          <strong\n                            >{{'lawyerProfile.curEmployerLabel'| translate}}\n                          </strong>\n                          {{candidate.employer.name}}\n                        </h5>\n\n                        <div class=\"col-md-2 col-sm-2 col-xs-2\">\n                          <a\n                            id=\"candidate-profile\"\n                            ng-show=\"candidate.approvalStatus === 'Approved' && !showEditableProfileField\"\n                            href=\"\"\n                            ng-click=\"openCandidateEditableField($event)\"\n                            class=\"pull-right btn btn-noline-info btn-xs \"\n                          >\n                            <i\n                              data-testid=\"header-profile-edit\"\n                              id=\"candidate-profile\"\n                              class=\"fa fa-pencil\"\n                            ></i>\n                          </a>\n                        </div>\n                      </div>\n\n                      <h5\n                        ng-show=\"showEditableProfileField\"\n                        class=\"pull-left edit-field\"\n                        uib-tooltip=\"Editing Employment History below will automatically update Current Employer\"\n                        uib-tooltip-placement=\"top\"\n                      >\n                        <input\n                          data-testid=\"current-employer\"\n                          type=\"text\"\n                          autocomplete=\"off\"\n                          placeholder=\"Current Employer\"\n                          class=\"form-control typeahead\"\n                          required\n                          ng-model=\"editableCandidateProfile.employer\"\n                          only-alphabets\n                          disabled\n                        />\n                      </h5>\n\n                      <div class=\"clearfix\"></div>\n\n                      <h5\n                        class=\"pull-left margin-0 margin-b5\"\n                        ng-show=\"!showEditableProfileField\"\n                      >\n                        <strong\n                          >{{'lawyerProfile.universityLabel'| translate}}\n                        </strong>\n                        {{candidate.candidateEducation}}\n                      </h5>\n\n                      <h5\n                        ng-show=\"showEditableProfileField\"\n                        class=\"pull-left edit-field\"\n                      >\n                        <input\n                          data-testid=\"undergraduate-university\"\n                          data-testid=\"university-name\"\n                          type=\"text\"\n                          autocomplete=\"off\"\n                          placeholder=\"Undergraduate University\"\n                          class=\"form-control\"\n                          uib-typeahead=\"school.name for school in schoolList | filter:$viewValue | limitTo:8\"\n                          required\n                          ng-model=\"editableCandidateProfile.university\"\n                        />\n                      </h5>\n\n                      <div class=\"clearfix\"></div>\n\n                      <h5\n                        class=\"pull-left margin-0 margin-b5\"\n                        ng-if=\"candidate && candidate.nationality && candidate.nationality.name\"\n                        ng-show=\"!showEditableProfileField\"\n                      >\n                        <strong\n                          >{{'lawyerProfile.nationalityLabel'|\n                          translate}}</strong\n                        >\n                        <span\n                          ng-if=\"candidate && candidate.nationality && candidate.nationality.name\"\n                          >{{candidate.nationality.name}}</span\n                        >\n                      </h5>\n\n                      <h5\n                        ng-show=\"showEditableProfileField\"\n                        class=\"pull-left  edit-field\"\n                      >\n                        <select\n                          data-testid=\"nationality\"\n                          class=\"form-control no-arrow-select\"\n                          style=\"padding: 8px 10px; width: 100%;\"\n                          id=\"nationality\"\n                          ng-model=\"editableCandidateProfile.nationality\"\n                          ng-options=\"nationality as nationality.name for nationality in nationalitiesList track by nationality.code\"\n                        >\n                          <option value=\"\" selected style=\"display:none;\"\n                            >Select Nationality</option\n                          >\n                        </select>\n                      </h5>\n\n                      <div class=\"clearfix\"></div>\n\n                      <h5\n                        class=\"pull-left margin-0 margin-b5\"\n                        ng-show=\"!showEditableProfileField\"\n                      >\n                        <strong\n                          >{{'lawyerProfile.curLocationLabel'|\n                          translate}}</strong\n                        >\n                        <span\n                          id=\"taglist\"\n                          ng-show=\"candidate.location\"\n                          class=\"list-inline list-practice-area margin-b0 margin-l5\"\n                        >\n                          <span\n                            class=\"label label-info text-uppercase margin-l5 label-currently-resides-in\"\n                          >\n                            {{candidate.location.name}}\n                          </span>\n                        </span>\n                      </h5>\n\n                      <h5\n                        ng-show=\"showEditableProfileField\"\n                        class=\"pull-left edit-field\"\n                      >\n                        <select\n                          data-testid=\"current-location\"\n                          class=\"form-control no-arrow-select\"\n                          style=\"padding: 8px 10px; width: 100%;\"\n                          id=\"location\"\n                          ng-model=\"editableCandidateProfile.currentLocation\"\n                          ng-options=\"location as location.name for location in locations track by location.id\"\n                        >\n                          <option value=\"\" selected style=\"display:none;\"\n                            >Select Locations</option\n                          >\n                        </select>\n                      </h5>\n\n                      <div class=\"clearfix\"></div>\n                      <h5\n                        class=\"pull-left margin-0\"\n                        ng-show=\"!showEditableProfileField\"\n                      >\n                        <strong>{{'lawyerProfile.pqeLabel'| translate}}</strong>\n                        {{candidate.lawProfile.qualificationDate|date:\"MMMM-yyyy\"}}\n                      </h5>\n\n                      <h5\n                        ng-show=\"showEditableProfileField\"\n                        class=\"pull-left edit-field\"\n                        style=\"margin-bottom:10px;\"\n                      >\n                        <div name=\"pqe\" data-ng-controller=\"DatepickerDemoCtrl\">\n                          <div class=\"input-group ui-datepicker\">\n                            <input\n                              data-testid=\"date-picker-field\"\n                              id=\"datepicker\"\n                              type=\"text\"\n                              placeholder=\"From\"\n                              class=\"form-control custom-readonly\"\n                              required\n                              disabled\n                              uib-datepicker-popup=\"{{format}}\"\n                              ng-model=\"editableCandidateProfile.pqe\"\n                              is-open=\"opened\"\n                              datepicker-options=\"dateOptions\"\n                              close-text=\"Close\"\n                            />\n                            <span\n                              data-testid=\"qualified-in\"\n                              class=\"input-group-addon\"\n                              ng-click=\"open($event)\"\n                            >\n                              <i\n                                class=\"fa fa-calendar\"\n                                ng-show=\"candidate.approvalStatus === 'Approved'\"\n                              ></i>\n                            </span>\n                          </div>\n                        </div>\n                      </h5>\n                      <span\n                        class=\"spinner-candidate\"\n                        us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n                        spinner-key=\"spinner-candidate\"\n                      ></span>\n                      <div class=\"clearfix margin-b5\"></div>\n                      <center>\n                        <a\n                          ng-show=\"showCancelProfileField\"\n                          href=\"\"\n                          id=\"update-candidate-profile\"\n                          ng-click=\"updateCandidateProfileField($event)\"\n                          class=\"btn btn-success\"\n                        >\n                          <i class=\"fa fa-remove hidden\"></i> Save\n                        </a>\n                        <a\n                          ng-show=\"showCancelProfileField\"\n                          href=\"\"\n                          id=\"cancel-candidate-profile\"\n                          ng-click=\"cancelUpdateProfileField($event)\"\n                          class=\"btn btn-default\"\n                        >\n                          <i class=\"fa fa-remove hidden\"></i> Cancel\n                        </a>\n                      </center>\n                    </div>\n                    <div class=\"col-md-6 col-sm-12 col-xs-12 text-right\">\n                      <div class=\"info-section-badge\">\n                        <span class=\"badge badge-info custom-badge\">\n                          <h5>\n                            <span>Questions? &nbsp; Give us a call:</span>\n                            <span>&nbsp;+44 (0)20 7060 9516</span>\n                          </h5>\n                        </span>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <!-- About Section End -->\n\n        <div class=\"row\">\n          <div data-ng-controller=\"TabsDemoCtrl\">\n            <div class=\"ui-tab-container\">\n              <tabset class=\"ui-tab\">\n                <tab\n                  heading=\"{{candidate.isAdminProfile?'PROFILE':'LEXSTEP PROFILE'}}\"\n                  data-testid=\"profile-tab\"\n                  ng-click=\"profileTabClicked()\"\n                >\n                  <candidate-profile-directive\n                    ng-if=\"candidate\"\n                    candidate=\"candidate\"\n                    practice-areas=\"legalPracticeAreas\"\n                    locations=\"locations\"\n                    contracts=\"contractTypes\"\n                    occupations=\"occupations\"\n                  ></candidate-profile-directive>\n                </tab>\n                <!-- About Tab End-->\n                <tab\n                  heading=\"PREFERENCES\"\n                  data-testid=\"preferences-tab\"\n                  ng-click=\"showPreferences()\"\n                >\n                  <candidate-preferences-directive\n                    ng-if=\"candidate && showPreferenceTab\"\n                    candidate=\"candidate\"\n                    locations=\"locations\"\n                    preferred-location=\"preferredLocation\"\n                  ></candidate-preferences-directive>\n                </tab>\n                <!-- CV/Linkedin Tab End-->\n                <tab\n                  ng-if=\"candidate.isAdminProfile\"\n                  heading=\"APPLICATIONS ({{candidateApplicationsCount}})\"\"\"\n                  data-testid=\"applications-tab\"\n                  ng-click=\"showApplications()\"\n                >\n                  <admin-applications-directive\n                    ng-if=\"showApplicationsTab\"\n                    count=\"applicationsCount\"\n                    candidate=\"candidate\"\n                    legal-practice-areas=\"legalPracticeAreas\"\n                    locations=\"locations\"\n                    contracts=\"contractTypes\"\n                    occupations=\"occupations\"\n                    employer-types=\"legalEmployerType\"\n                  ></admin-applications-directive>\n                </tab>\n                <!-- End Applied Jobs Tab -->\n                <tab\n                  ng-if=\"candidate.isAdminProfile\"\n                  heading=\"ACTIVITY\"\n                  data-testid=\"login-history-tab\"\n                  ng-click=\"showLoginHistory()\"\n                >\n                  <login-history-directive\n                    ng-if=\"candidate\"\n                    candidate=\"candidate\"\n                  ></login-history-directive>\n                </tab>\n                <!-- End Login History Tab -->\n                <tab\n                  ng-if=\"candidate.isAdminProfile\"\n                  heading=\"NOTES\"\n                  data-testid=\"notes-tab\"\n                  ng-click=\"showNotes()\"\n                >\n                  <notes-directive\n                    ng-if=\"showNotesTab\"\n                    user=\"candidate\"\n                  ></notes-directive>\n                </tab>\n                <tab\n                  ng-if=\"candidate.isAdminProfile\"\n                  heading=\"REGULAR/CUSTOM ({{recommendationsCount.regularCustom?recommendationsCount.regularCustom:0}})\"\n                  data-testid=\"regular-custom-tab\"\n                  ng-click=\"showRecommendations('showRegularCustom')\"\n                >\n                  <recommendations-directive\n                    ng-if=\"recommendations.showRegularCustom\"\n                    position-types=\"['Regular',  'Custom']\"\n                    count=\"recommendationsCount.regularCustom\"\n                    candidate=\"candidate\"\n                    legal-practice-areas=\"legalPracticeAreas\"\n                    locations=\"locations\"\n                    contracts=\"contractTypes\"\n                    occupations=\"occupations\"\n                    employer-types=\"legalEmployerType\"\n                    user=\"user\"\n                    preferred-location=\"showPreferenceTab\"\n                  ></recommendations-directive>\n                </tab>\n                <tab\n                  ng-if=\"candidate.isAdminProfile\"\n                  heading=\"SPEC/CONNECT ({{recommendationsCount.specConnect?recommendationsCount.specConnect:0}})\"\n                  data-testid=\"spec-connect-tab\"\n                  ng-click=\"showRecommendations('showSpecConnect')\"\n                >\n                  <recommendations-directive\n                    ng-if=\"recommendations.showSpecConnect\"\n                    position-types=\"['Speculative',  'Connect']\"\n                    count=\"recommendationsCount.specConnect\"\n                    candidate=\"candidate\"\n                    legal-practice-areas=\"legalPracticeAreas\"\n                    locations=\"locations\"\n                    contracts=\"contractTypes\"\n                    occupations=\"occupations\"\n                    employer-types=\"legalEmployerType\"\n                    user=\"user\"\n                    preferred-location=\"showPreferenceTab\"\n                  ></recommendations-directive>\n                </tab>\n              </tabset>\n            </div>\n          </div>\n        </div>\n        <!-- Tab Control End -->\n      </div>\n    </section>\n  </div>\n  <!-- Body Ends -->\n\n  <div ng-include src=\"'views/modals/edit-candidate-modal.html'\"></div>\n\n  <lawyer-preferences\n    modal-open-handler=\"openLawyerPreferencesModal\"\n    candidate=\"candidate\"\n    linear-locations=\"refLocations\"\n    nested-locations=\"nestedLocations\"\n    linear-practices=\"refPractices\"\n    nested-practices=\"nestedPractices\"\n    jurisdictions=\"candidate.legalJurisdictions\"\n    languages=\"candidate.languages\"\n  ></lawyer-preferences>\n  <script type=\"text/ng-template\" id=\"practice-area-modal.html\">\n    <practice-Area></practice-Area>\n  </script>\n  <delete-Position></delete-Position>\n\n  <script type=\"text/ng-template\" id=\"deleteCVModal.html\">\n    <div class=\"modal-header\">\n      <center>\n        <h3>Delete your CV?</h3>\n        <h5>Are you sure you want to delete your CV?</h5>\n      </center>\n    </div>\n    <div class=\"modal-footer\">\n      <center>\n        <button class=\"btn btn-info\" ng-click=\"yes()\">Yes</button>\n        <button class=\"btn btn-gap-v btn-default\" ng-click=\"no()\">No</button>\n      </center>\n    </div>\n  </script>\n</div>\n"

/***/ }),
/* 433 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <form\n    id=\"formId\"\n    data-testid=\"experience-form\"\n    name=\"formName\"\n    ng-submit=\"submitHandler()\"\n  >\n    <div class=\"clearfix\">\n      <div class=\"row\">\n        <div class=\"col-md-6\">\n          <input\n            type=\"text\"\n            ng-blur=\"verifyEmployerNameEscapeChar(employment.employer.name)\"\n            autocomplete=\"off\"\n            placeholder=\"Employer Name\"\n            class=\"h5 pull-left form-control margin-b5\"\n            typeahead=\"employer.name for employer in employers | employerTypeAheadFilter:$viewValue | limitTo:8\"\n            ng-model=\"employment.employer.name\"\n            only-alphabets\n            required\n          />\n        </div>\n        <div class=\"col-md-6\">\n          <input\n            type=\"text\"\n            autocomplete=\"off\"\n            placeholder=\"Job Title\"\n            class=\"h5 pull-left form-control margin-b5\"\n            ng-model=\"employment.jobTitle\"\n            only-alphabets\n            required\n          />\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-md-6\">\n          <div\n            class=\"h5\"\n            name=\"jobFrom\"\n            data-ng-controller=\"DatepickerDemoCtrl\"\n          >\n            <div id=\"from-datepicker\" class=\"input-group ui-datepicker\">\n              <input\n                type=\"text\"\n                disabled\n                placeholder=\"From\"\n                class=\"form-control custom-readonly\"\n                ng-class=\"employment.errors.from\"\n                uib-datepicker-popup=\"{{format}}\"\n                ng-model=\"employment.start\"\n                is-open=\"opened\"\n                datepicker-options=\"employmentFormDatePickerOptions\"\n                close-text=\"Close\"\n                required\n                max=\"today\"\n              />\n              <span\n                data-testid=\"date-picker-icon\"\n                class=\"input-group-addon\"\n                ng-click=\"open($event)\"\n              >\n                <i class=\"fa fa-calendar\"></i>\n              </span>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-md-6\">\n          <div\n            class=\"h5\"\n            name=\"jobTo\"\n            data-ng-controller=\"DatepickerDemoCtrl\"\n            ng-hide=\"employment.isLastJob\"\n          >\n            <div id=\"to-datepicker\" class=\"input-group ui-datepicker\">\n              <input\n                type=\"text\"\n                disabled\n                placeholder=\"To\"\n                class=\"form-control custom-readonly\"\n                ng-class=\"employment.errors.isCurrent\"\n                uib-datepicker-popup=\"{{format}}\"\n                ng-model=\"employment.end\"\n                is-open=\"opened\"\n                datepicker-options=\"employmentFormDatePickerOptions\"\n                close-text=\"Close\"\n                required\n                min=\"employment.end\"\n              />\n              <span class=\"input-group-addon\" ng-click=\"open($event)\">\n                <i class=\"fa fa-calendar\"></i>\n              </span>\n            </div>\n          </div>\n          <div class=\"h5 margin-t20\" ng-show=\"employment.isLastJob\">\n            <center>\n              <strong>Present</strong>\n            </center>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <label class=\"ui-checkbox\">\n            <input\n              type=\"checkbox\"\n              ng-class=\"employment.errors.isCurrent\"\n              ng-model=\"employment.isLastJob\"\n            />\n            <span>Currently working here?</span>\n          </label>\n        </div>\n      </div>\n      <div class=\"row margin-t5\">\n        <div class=\"col-xs-4 col-sm-2 text-right padding-b15\">\n          Location *\n        </div>\n        <div class=\"col-md-10\" data-testid=\"experience-location\">\n          <span ng-if=\"!employment.location || employment.location.length == 0\">\n            <input\n              type=\"button\"\n              class=\"btn btn-line-info\"\n              ng-class=\"employment.errors.location\"\n              id=\"select-locations\"\n              ng-click=\"openLocModal()\"\n              value=\"Click to specify\"\n            />\n          </span>\n\n          <ul\n            id=\"taglist\"\n            ng-if=\"employment.location\"\n            class=\"list-inline list-practice-area margin-b0\"\n          >\n            <li class=\"tags-box\">\n              {{employment.location.name}}\n            </li>\n\n            <button\n              type=\"button\"\n              ng-click=\"openLocModal()\"\n              ng-touch=\"openLocModal()\"\n              id=\"edit-location\"\n              class=\"btn btn-noline-info btn-xs margin-l5\"\n            >\n              <i class=\"fa fa-pencil\" id=\"edit-location\"></i>\n            </button>\n          </ul>\n        </div>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"h5 col-xs-2 text-right\">Description</div>\n        <div class=\"col-md-10\">\n          <textarea\n            name=\"workDescription\"\n            id=\"\"\n            class=\"margin-t15 form-control\"\n            rows=\"6\"\n            style=\"resize:none\"\n            data-ng-model=\"employment.comments\"\n            placeholder=\"Role Description\"\n          ></textarea>\n        </div>\n      </div>\n\n      <div class=\"row margin-t5\">\n        <div class=\"h5 col-xs-4 col-sm-2 text-right\">Role *</div>\n        <div class=\" col-md-6\">\n          <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n            <select\n              data-testid=\"experience-role\"\n              data-ng-model=\"employment.occupationId\"\n              style=\"padding: 8px 10px; width: 100%;\"\n              ng-init=\"employment.occupationId= employment.occupationId||1\"\n              required\n            >\n              <option value=\"\" disabled selected style=\"display:none;\"\n                >Role Type</option\n              >\n              <option\n                ng-repeat=\"role in occupations\"\n                ng-value=\"{{role.id}}\"\n                ng-selected=\"employment.occupationId === role.id\"\n                >{{role.name}}</option\n              >\n            </select>\n          </span>\n        </div>\n      </div>\n\n      <div class=\"row margin-t5\">\n        <div class=\"h5 col-xs-4 col-sm-2 text-right\">Contract *</div>\n        <div class=\" col-md-6\">\n          <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n            <select\n              data-testid=\"experience-contract\"\n              data-ng-model=\"employment.contractTypeId\"\n              style=\"padding: 8px 10px; width: 100%;\"\n              ng-init=\"employment.contractTypeId= employment.contractTypeId||1\"\n              required\n            >\n              <option value=\"\" disabled selected style=\"display:none;\"\n                >Contract Type</option\n              >\n              <option\n                ng-repeat=\"contract in contracts\"\n                ng-value=\"{{contract.id}}\"\n                ng-selected=\"employment.contractTypeId === contract.id\"\n                >{{contract.name}}</option\n              >\n            </select>\n          </span>\n        </div>\n      </div>\n\n      <div class=\"row margin-t5\">\n        <div\n          class=\"col-xs-4 col-sm-2 text-right padding-r15 padding-l0 padding-b15\"\n        >\n          Practice Areas<span ng-if=\"!candidate.isAdminProfile\"\n            ><span class=\"hidden-xs\"> </span>*</span\n          >\n        </div>\n        <div class=\"col-md-10\" data-testid=\"experience-practice-areas\">\n          <span\n            ng-if=\"!employment.specialties || employment.specialties.length == 0\"\n          >\n            <input\n              data-testid=\"experience-practiceArea\"\n              type=\"button\"\n              class=\"btn btn-line-info\"\n              ng-class=\"employment.errors.practiceAreas\"\n              id=\"select-practice-areas\"\n              ng-click=\"openPracticeAreasModal()\"\n              ng-touch=\"openPracticeAreasModal()\"\n              value=\"Click to specify\"\n            />\n          </span>\n\n          <ul\n            id=\"taglist\"\n            ng-if=\"employment.specialties.length > 0\"\n            class=\"pull-left list-inline list-practice-area margin-b0\"\n          >\n            <li\n              class=\"tags-box\"\n              ng-repeat=\"practiceArea in employment.specialties\"\n            >\n              {{practiceArea.name}}\n            </li>\n\n            <button\n              type=\"button\"\n              ng-click=\"openPracticeAreasModal()\"\n              ng-touch=\"openPracticeAreasModal()\"\n              id=\"edit-practice-areas\"\n              class=\"btn btn-noline-info btn-xs margin-l5\"\n            >\n              <i class=\"fa fa-pencil\" id=\"edit-practice-areas\"></i>\n            </button>\n          </ul>\n        </div>\n      </div>\n      <div class=\"row margin-t10 margin-b20\">\n        <div class=\"col-md-12\">\n          <center>\n            <button type=\"submit\" class=\"btn btn-info\">Save</button>\n            <button class=\"btn btn-default\" ng-click=\"cancelHandler()\">\n              Cancel\n            </button>\n          </center>\n        </div>\n      </div>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"panel panel-default section-matters\"\n  data-testid=\"experience-component\"\n  id=\"emp-panel\"\n>\n  <div class=\"panel-heading heading-profile\">\n    <strong class=\"text-uppercase\">\n      <i class=\"glyphicon glyphicon-th\"></i>\n      Experience\n    </strong>\n    &nbsp;\n\n    <a\n      href=\"\"\n      tooltip=\"{{'lawyerProfile.empHistorySection.toolTip' | translate}}\"\n      tooltip-placement=\"right\"\n    >\n      <span class=\"badge badge-grey\">\n        <i class=\"fa fa-info\"></i>\n      </span>\n    </a>\n\n    <button\n      type=\"button\"\n      ng-click=\"showAddEmploymentHistoryForm()\"\n      ng-touch=\"showAddEmploymentHistoryForm()\"\n      ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n      class=\"btn btn-noline-info btn-xs pull-right\"\n      ng-hide=\"addEmpHistory || !lawyerApproved\"\n    >\n      <span class=\"mobile-hide text-edit\" id=\"add-employment\">Add&nbsp;</span>\n      <i class=\"fa fa-plus\" id=\"add-employment\"></i>\n    </button>\n  </div>\n  <div class=\"panel-body\">\n    <!--Form to add an Employment Record  -->\n    <employment-form\n      formName=\"empHistoryForm\"\n      candidate=\"candidate\"\n      submit-handler=\"manageEmployment()\"\n      cancel-handler=\"cancelAddEditEmpHistory()\"\n      employment=\"employment\"\n      employers=\"employers\"\n      locations=\"locations\"\n      practices=\"practices\"\n      occupations=\"occupations\"\n      contracts=\"contracts\"\n      ng-if=\"addEmpHistory\"\n    >\n    </employment-form>\n\n    <div class=\"clearfix\" id=\"empHistorySection\">\n      <div\n        class=\"row h5\"\n        align=\"center\"\n        ng-hide=\"candidate.experiences.length > 0 || addEmpHistory\"\n      >\n        <strong class=\"col-md-offset-1 col-md-9\"\n          >{{'lawyerProfile.empHistorySection.toolTip' | translate}}</strong\n        >\n      </div>\n\n      <div\n        class=\"clearfix\"\n        data-testid=\"experience\"\n        ng-repeat=\"experience in candidate.experiences\"\n      >\n        <div ng-if=\"!experience.editEmpHistory\">\n          <div class=\"row\">\n            <div class=\"pull-left firm-image text-center col-md-2\">\n              <img\n                id=\"firmPic\"\n                class=\"drop-box\"\n                style=\"padding-top:0px; height:inherit;\"\n                ng-src=\"{{experience.employerPicture}}\"\n              />\n            </div>\n            <div class=\"col-xs-6\">\n              <div class=\"row font-size-large\">\n                <strong>{{experience.jobTitle}}</strong>\n                <span ng-if=\"experience.start\">&nbsp;at&nbsp;</span>\n                <span data-testid=\"firm-name\"\n                  >{{experience.employer.name}}</span\n                >\n              </div>\n\n              <div class=\"row clearfix color-gray\">\n                <span ng-if=\"experience.start\"\n                  >{{experience.start | date:\"MMM-yy\"}} &nbsp;–&nbsp;</span\n                >\n                <span ng-if=\"!experience.isLastJob && experience.end\"\n                  >{{experience.end | date:\"MMM-yy\"}}</span\n                >\n                <span ng-if=\"experience.isLastJob || !experience.end\"\n                  >Present</span\n                >\n                <span ng-if=\"experience.start\">• {{experience.monthDiff}}</span>\n              </div>\n              <div\n                data-testid=\"current-experience-location\"\n                class=\"row color-gray text-uppercase\"\n              >\n                <span>{{experience.location.name}}</span>\n              </div>\n            </div>\n            <div\n              class=\"col-xs-2 text-right pull-right\"\n              ng-show=\"lawyerApproved\"\n            >\n              <a\n                href=\"\"\n                id=\"edit-empHistory\"\n                class=\"btn btn-noline-info btn-xs\"\n                ng-hide=\"experience.editEmpHistory\"\n                ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n                ng-click=\"$parent.editEmpHistory(experience, $index)\"\n                ><span id=\"edit-empHistory\" class=\"fa fa-pencil\"></span\n              ></a>\n              <a\n                href=\"\"\n                ng-click=\"deleteEmployment(experience.id, $index)\"\n                ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n                class=\"btn btn-noline-info btn-xs\"\n                ><span class=\"glyphicon glyphicon-trash\"></span\n              ></a>\n            </div>\n          </div>\n          <div\n            ng-if=\"experience.comments\"\n            class=\"clearfix margin-t20 padding-l10\"\n          >\n            <read-more\n              hmtext=\"{{experience.comments}}\"\n              hmlimit=\"200\"\n              hm-more-text=\"more\"\n              hm-less-text=\"less\"\n              align=\"justify\"\n            >\n            </read-more>\n          </div>\n\n          <div class=\"clearfix margin-t20\" ng-if=\"experience.occupation\">\n            <b class=\"col-xs-3 col-sm-2 text-right\">Role:</b>\n            <ul id=\"taglist\" class=\"list-inline list-practice-area margin-b0\">\n              <li class=\"tags-box\" style=\"background-color: #e4f6e6\">\n                {{experience.occupation.name}}\n              </li>\n            </ul>\n          </div>\n\n          <div class=\"clearfix margin-t10\" ng-if=\"experience.contractType\">\n            <b class=\"col-xs-3 col-sm-2 text-right\">Contract:</b>\n            <ul id=\"taglist\" class=\"list-inline list-practice-area margin-b0\">\n              <li class=\"tags-box\" style=\"background-color: #DEDEDE\">\n                {{experience.contractType.name}}\n              </li>\n            </ul>\n          </div>\n\n          <div\n            class=\"clearfix margin-t10\"\n            ng-if=\"experience.specialties.length > 0\"\n          >\n            <b class=\"col-xs-3 col-sm-2 text-right padding-l0\"\n              >Practice Areas:</b\n            >\n            <ul\n              id=\"taglist\"\n              ng-if=\"experience.specialties\"\n              class=\"list-inline list-practice-area margin-b0 col-sm-10 col-xs-9 padding-lr0\"\n            >\n              <li\n                class=\"tags-box\"\n                ng-repeat=\"practice in experience.specialties\"\n                ng-if=\"practice\"\n              >\n                {{practice.name}}\n              </li>\n            </ul>\n          </div>\n        </div>\n\n        <!--Form to EDIT an Employment Record  -->\n        <employment-form\n          formName=\"editEmpHistoryForm\"\n          candidate=\"candidate\"\n          submit-handler=\"manageEmployment()\"\n          cancel-handler=\"cancelEditEmpHistory(experience)\"\n          employment=\"employment\"\n          employers=\"employers\"\n          locations=\"locations\"\n          practices=\"practices\"\n          occupations=\"occupations\"\n          contracts=\"contracts\"\n          ng-if=\"experience.editEmpHistory\"\n        >\n        </employment-form>\n        <div\n          class=\"margin-t15 margin-b20 border-bc\"\n          ng-if=\"candidate.experiences.length != ($index + 1)\"\n        ></div>\n      </div>\n    </div>\n  </div>\n\n  <script type=\"text/ng-template\" id=\"deleteExperienceModal.html\">\n    <div data-testid=\"experience-delete-modal\">\n      <div class=\"modal-header\">\n        <center>\n          <h3>Delete your Experience?</h3>\n          <h5>Are you sure you want to delete your Experience?</h5>\n        </center>\n      </div>\n      <div class=\"modal-footer\">\n        <center>\n          <button class=\"btn btn-info\" ng-click=\"deleteExperienceModalCtrl.yes()\">Yes</button>\n          <button class=\"btn btn-gap-v btn-default\" ng-click=\"deleteExperienceModalCtrl.no()\">No</button>\n        </center>\n      </div>\n    </div>\n  </script>\n  <script type=\"text/ng-template\" id=\"locations-modal.html\">\n    <locations-Modal></locations-Modal>\n  </script>\n</div>\n"

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <span\n    us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n    spinner-key=\"spinner-lh\"\n    class=\"lawyer-actions-spinner\"\n  ></span>\n  <div class=\"col-md-12\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-body\">\n        <div class=\"text-center\" ng-show=\"allHistory.length == 0\">\n          <h4>No history found</h4>\n        </div>\n\n        <div ng-show=\"allHistory\">\n          <table class=\"table\" style=\"width: auto; table-layout: fixed;\">\n            <thead>\n              <th>Action</th>\n              <th>Date</th>\n              <th>Details</th>\n            </thead>\n            <tbody>\n              <tr ng-repeat=\"history in history| orderBy: '-created' \">\n                <td class=\"wrap\" style=\"word-break:break-all;\">\n                  {{history.type}}\n                </td>\n                <td class=\"wrap\">\n                  {{history.created|date:'short'}}\n                </td>\n                <td class=\"wrap\" style=\"word-break: break-all;\">\n                  {{history.info}}\n                </td>\n              </tr>\n            </tbody>\n          </table>\n          <footer class=\"table-footer table-dynamic\">\n            <div class=\"row\">\n              <div class=\"page-num-info\">\n                <span>\n                  Show\n                  <span class=\"ui-select select-enty-count\">\n                    <select\n                      ng-model=\"paginationOptions.selectedLimit\"\n                      ng-options=\"num for num in paginationOptions.limitOptions\"\n                      ng-change=\"pagination.currentPage = 1; pageChange(numPerPage)\"\n                    >\n                    </select>\n                  </span>\n                  entries per page\n                </span>\n              </div>\n\n              <div class=\"text-right pagination-container custom-pagination\">\n                <pagination\n                  class=\"pagination-sm\"\n                  ng-model=\"pagination.currentPage\"\n                  total-items=\"pagination.totalItems\"\n                  max-size=\"4\"\n                  ng-change=\"pageChange(pagination.currentPage)\"\n                  items-per-page=\"paginationOptions.selectedLimit\"\n                  rotate=\"false\"\n                  boundary-links=\"true\"\n                >\n                </pagination>\n              </div>\n            </div>\n          </footer>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 436 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"col-md-8\">\n    <div class=\"panel panel-default preferred-location\">\n      <div\n        data-testid=\"candidate-preferred-locations-heading\"\n        class=\"panel-heading\"\n      >\n        <strong>\n          <span class=\"glyphicon glyphicon-th\"></span>Target Locations</strong\n        >\n        <button\n          data-testid=\"edit-location\"\n          type=\"button\"\n          ng-click=\"openLocationModal(null,$event);userInformationUpdate()\"\n          ng-touch=\"openLocationModal(null,$event);userInformationUpdate()\"\n          ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n          id=\"edit-location\"\n          class=\"btn btn-noline-info btn-xs pull-right \"\n          ng-show=\"true\"\n        >\n          <span class=\"text-edit\" id=\"edit-location\"></span>\n          <i class=\"fa fa-pencil\" id=\"edit-location\"></i>\n        </button>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"callout callout-danger margin-t0 padding-t5l10\">\n          <p class=\"margin-0\">Never shown to employers</p>\n        </div>\n        <ul\n          data-testid=\"candidate-preferred-locations\"\n          id=\"taglist\"\n          class=\"list-inline list-practice-area margin-b0\"\n        >\n          <li\n            class=\"tags-box\"\n            data-cy=\"lawyer-preference-locations\"\n            ng-repeat=\"location in candidate.preferredLocations track by location.id\"\n          >\n            <!-- ng-if=\"location.isSelected && !location.hasChild\" -->\n            {{location.name}}\n          </li>\n        </ul>\n      </div>\n    </div>\n    <!-- Followed Firms Section -->\n    <div class=\"panel panel-default followed-firms\">\n      <div\n        data-testid=\"candidate-followed-employers-heading\"\n        class=\"panel-heading\"\n      >\n        <strong>\n          <span class=\"glyphicon glyphicon-th\"></span>\n          {{'followedFirm.Heading'|translate}}\n        </strong>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"callout callout-danger margin-t0 padding-t5l10\">\n          <p class=\"margin-0\">\n            {{'followedFirm.Label'|translate}}\n          </p>\n        </div>\n        <ul\n          data-testid=\"candidate-followed-employers\"\n          id=\"taglist\"\n          class=\"list-inline list-practice-area margin-b0\"\n          ng-if=\"candidate.candidateFollow.length > 0\"\n        >\n          <li\n            class=\"tags-box\"\n            ng-repeat=\"candidateEmployer in candidate.candidateFollow\"\n            ng-if=\"candidateEmployer.follow\"\n          >\n            {{candidateEmployer.employer.name}}\n          </li>\n        </ul>\n        <div ng-if=\"candidate.candidateFollow.length == 0\">\n          This lawyer has not followed any firms yet.\n        </div>\n      </div>\n    </div>\n    <!-- End Followed Firms Section -->\n    <!-- Hidden Firms Section -->\n    <div class=\"panel panel-default followed-firms\">\n      <div\n        data-testid=\"candidate-hidden-employers-heading\"\n        class=\"panel-heading\"\n      >\n        <strong>\n          <span class=\"glyphicon glyphicon-th\"></span> Hidden Employers\n        </strong>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"callout callout-danger margin-t0 padding-t5l10\">\n          <p class=\"margin-0\">\n            Employers hidden by this lawyer\n          </p>\n        </div>\n        <ul\n          data-testid=\"candidate-hidden-employers\"\n          id=\"taglist\"\n          class=\"list-inline list-practice-area margin-b0\"\n          ng-if=\"candidate.candidateHidden.length > 0\"\n        >\n          <li\n            class=\"tags-box\"\n            ng-repeat=\"candidateHidden in candidate.candidateHidden\"\n            ng-if=\"candidateHidden.hide\"\n          >\n            {{candidateHidden.employer.name}}\n            <span\n              data-testid=\"cancel-hide-firm\"\n              class=\"fa fa-times pointer\"\n              style=\"    color: #767676; font-size: 12px;\"\n              ng-click=\"unHideEmployer(candidateHidden)\"\n            ></span>\n          </li>\n        </ul>\n        <div ng-if=\"candidate.candidateHidden.length == 0\">\n          This lawyer has not hidden any Employers yet.\n        </div>\n      </div>\n    </div>\n    <!-- End Hidden Firms Section -->\n  </div>\n  <div class=\"col-md-4\">\n    <div\n      ng-if=\"candidate.isAdminProfile\"\n      class=\"panel panel-default preferred-location clearfix\"\n    >\n      <div class=\"panel-heading heading-profile\">\n        <strong>\n          <span class=\"glyphicon glyphicon-th\"></span> ATS-Link Jobs (Weekly)\n          Alert Settings</strong\n        >\n      </div>\n      <div class=\"col-sm-12 job-switch-fillter switch-mt padding-15\">\n        <p>ATS-Link Jobs Alert</p>\n        <p\n          ng-class=\"{\n                          'paused': (candidate.emailSubscriptions.weekly_position_ping.paused == true || !candidate.emailSubscriptions.weekly_position_ping.stopped),\n                          'gray-scale100':(candidate.emailSubscriptions.weekly_position_ping.stopped),\n                          'gray-scale0': (!candidate.emailSubscriptions.weekly_position_ping.stopped)\n                          }\"\n        >\n          <span\n            ng-if=\"candidate.emailSubscriptions.weekly_position_ping.paused\"\n            class=\"center email-alert-on\"\n            >On</span\n          >\n          <span\n            ng-if=\"!candidate.emailSubscriptions.weekly_position_ping.paused\"\n            class=\"center email-alert-on\"\n          >\n            <strong>On</strong>\n          </span>\n          <label class=\"switch switch-info\">\n            <input\n              ng-change=\"updateEmailPause('weekly_position_ping')\"\n              ng-disabled=\"candidate.emailSubscriptions.weekly_position_ping.stopped\"\n              data-ng-model=\"candidate.emailSubscriptions.weekly_position_ping.paused\"\n              ng-checked=\"candidate.emailSubscriptions.weekly_position_ping.paused\"\n              type=\"checkbox\"\n            />\n            <i></i>\n          </label>\n          <span\n            ng-if=\"candidate.emailSubscriptions.weekly_position_ping.paused\"\n            class=\"center email-alert-pause\"\n          >\n            <strong>Pause</strong>\n          </span>\n          <span\n            ng-if=\"!candidate.emailSubscriptions.weekly_position_ping.paused\"\n            class=\"center email-alert-pause\"\n            >Pause</span\n          >\n          &nbsp;\n          <a\n            href=\"\"\n            tooltip=\"Switch slider to Pause to suspend alerts for 3 months\"\n            tooltip-placement=\"right\"\n          >\n            <span class=\"badge badge-grey email-pause-info\">\n              <i class=\"fa fa-info\"></i>\n            </span>\n          </a>\n        </p>\n        <p class=\"unsub-checkbox\" align=\"left\">\n          <label class=\"ui-checkbox\">\n            <input\n              type=\"checkbox\"\n              ng-click=\"updateEmailSubscription('weekly_position_ping')\"\n              ng-checked=\"candidate.emailSubscriptions.weekly_position_ping.stopped\"\n              ng-model=\"candidate.emailSubscriptions.weekly_position_ping.stopped\"\n            />\n            <span\n              ng-if=\"!candidate.emailSubscriptions.weekly_position_ping.stopped\"\n              class=\"checkbox-unsubscribe-heading\"\n              >Unsubscribe</span\n            >\n            <span\n              ng-if=\"candidate.emailSubscriptions.weekly_position_ping.stopped\"\n              class=\"checkbox-unsubscribe-heading\"\n              >Unsubscribed</span\n            >\n          </label>\n        </p>\n      </div>\n    </div>\n    <!-- Daily Alert Section -->\n    <div\n      ng-if=\"candidate.isAdminProfile\"\n      class=\"panel panel-default preferred-location clearfix\"\n    >\n      <div class=\"panel-heading heading-profile\">\n        <strong>\n          <span class=\"glyphicon glyphicon-th\"></span>\n          Reg/Custom Opportunity (Daily + Ad-hoc Matching Lawyers) Alert\n          Settings\n        </strong>\n      </div>\n      <div class=\"col-sm-12 job-switch-fillter switch-mt padding-15\">\n        <p>Reg/Custom Opportunity Alert</p>\n        <p\n          ng-class=\"{\n                          'paused': (candidate.emailSubscriptions.daily_positions_ping.paused === true || !candidate.emailSubscriptions.daily_positions_ping.stopped),\n                          'gray-scale100':(candidate.emailSubscriptions.daily_positions_ping.stopped),\n                          'gray-scale0': (!candidate.emailSubscriptions.daily_positions_ping.stopped)\n                          }\"\n        >\n          <span\n            ng-if=\"candidate.emailSubscriptions.daily_positions_ping.paused\"\n            class=\"center email-alert-on\"\n            >On</span\n          >\n          <span\n            ng-if=\"!candidate.emailSubscriptions.daily_positions_ping.paused\"\n            class=\"center email-alert-on\"\n          >\n            <strong>On</strong>\n          </span>\n          <label class=\"switch switch-info\">\n            <input\n              ng-change=\"updateEmailPause('daily_positions_ping')\"\n              ng-disabled=\"candidate.emailSubscriptions.daily_positions_ping.stopped\"\n              data-ng-model=\"candidate.emailSubscriptions.daily_positions_ping.paused\"\n              ng-checked=\"candidate.emailSubscriptions.daily_positions_ping.paused\"\n              type=\"checkbox\"\n            />\n            <i></i>\n          </label>\n          <span\n            ng-if=\"candidate.emailSubscriptions.daily_positions_ping.paused\"\n            class=\"center email-alert-pause\"\n          >\n            <strong>Pause</strong>\n          </span>\n          <span\n            ng-if=\"!candidate.emailSubscriptions.daily_positions_ping.paused\"\n            class=\"center email-alert-pause\"\n            >Pause</span\n          >\n          &nbsp;\n          <a\n            href=\"\"\n            tooltip=\"Switch slider to Pause to suspend alerts for 3 months\"\n            tooltip-placement=\"right\"\n          >\n            <span class=\"badge badge-grey email-pause-info\">\n              <i class=\"fa fa-info\"></i>\n            </span>\n          </a>\n        </p>\n        <p class=\"unsub-checkbox\" align=\"left\">\n          <label class=\"ui-checkbox\">\n            <input\n              type=\"checkbox\"\n              ng-click=\"updateEmailSubscription('daily_positions_ping')\"\n              ng-checked=\"candidate.emailSubscriptions.daily_positions_ping.stopped\"\n              ng-model=\"candidate.emailSubscriptions.daily_positions_ping.stopped\"\n            />\n            <span\n              ng-if=\"!candidate.emailSubscriptions.daily_positions_ping.stopped\"\n              class=\"checkbox-unsubscribe-heading\"\n              >Unsubscribe</span\n            >\n            <span\n              ng-if=\"candidate.emailSubscriptions.daily_positions_ping.stopped\"\n              class=\"checkbox-unsubscribe-heading\"\n              >Unsubscribed</span\n            >\n          </label>\n        </p>\n      </div>\n    </div>\n    <!-- Daily Alert Section END-->\n\n    <!-- Contract Section -->\n    <div class=\"panel panel-default followed-firms\" data-cy=\"lawyer-contract\">\n      <div data-testid=\"candidate-contract-heading\" class=\"panel-heading\">\n        <strong> <span class=\"glyphicon glyphicon-th\"></span> Contract </strong>\n        <button\n          ng-show=\"!editContract\"\n          type=\"button\"\n          ng-click=\"resetEditPreferences();editContract = !editContract\"\n          ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n          id=\"edit-contract\"\n          class=\"btn btn-noline-info btn-xs pull-right \"\n        >\n          <span class=\"text-edit\" id=\"edit-contract\"></span>\n          <i class=\"fa fa-pencil\" id=\"edit-contract\"></i>\n        </button>\n        <div ng-show=\"editContract\" class=\"pull-right\" name=\"contract\">\n          <a\n            href=\"\"\n            id=\"edit-contract\"\n            class=\"btn btn-noline-info btn-xs\"\n            ng-click=\"updateContracts();editContract = !editContract\"\n          >\n            <i class=\"fa fa-floppy-o\"></i>\n          </a>\n          <a\n            href=\"\"\n            ng-click=\"resetEditPreferences();editContract = !editContract\"\n            id=\"cancel-contractEdit\"\n            class=\"btn btn-noline-info btn-xs\"\n          >\n            <span class=\"fa fa-times\"></span>\n          </a>\n        </div>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"callout callout-danger margin-t0 padding-t5l10\">\n          <p class=\"margin-0\">\n            Select the type of Contract you would be open to\n          </p>\n        </div>\n        <ul\n          id=\"taglist\"\n          class=\"list-inline list-practice-area margin-b0\"\n          ng-if=\"editContract\"\n        >\n          <li ng-repeat=\"contract in editPreferences.contracts\">\n            <label class=\"ui-checkbox\">\n              <input\n                type=\"checkbox\"\n                ng-click=\"\"\n                data=\"\"\n                ng-model=\"contract.isSelected\"\n                class=\"ng-pristine ng-valid\"\n              />\n              <span class=\"\">{{contract.name}}</span>\n            </label>\n          </li>\n        </ul>\n        <ul\n          data-testid=\"candidate-contract\"\n          id=\"taglist\"\n          class=\"list-inline list-practice-area margin-b0\"\n          ng-if=\"!editContract\"\n        >\n          <li\n            ng-if=\"contract.isSelected\"\n            class=\"tags-box\"\n            ng-repeat=\"contract in candidate.preferredContractTypes\"\n          >\n            {{contract.name}}\n          </li>\n        </ul>\n\n        <div ng-if=\"candidate.preferredContractTypes == 0\">\n          This lawyer has not selected any contract.\n        </div>\n      </div>\n    </div>\n    <!-- End Contract Section -->\n\n    <!-- Role Section -->\n    <div class=\"panel panel-default followed-firms\" data-cy=\"lawyer-role\">\n      <div class=\"panel-heading\">\n        <strong> <span class=\"glyphicon glyphicon-th\"></span> Role </strong>\n        <button\n          ng-show=\"!editRoles\"\n          type=\"button\"\n          ng-click=\"resetEditPreferences();editRoles = !editRoles\"\n          ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n          id=\"edit-role\"\n          class=\"btn btn-noline-info btn-xs pull-right \"\n        >\n          <span class=\"text-edit\" id=\"edit-role\"></span>\n          <i class=\"fa fa-pencil\" id=\"edit-role\"></i>\n        </button>\n        <div ng-show=\"editRoles\" class=\"pull-right\" name=\"role\">\n          <a\n            href=\"\"\n            id=\"edit-role\"\n            class=\"btn btn-noline-info btn-xs\"\n            ng-click=\"updateOccupations();editRoles = !editRoles\"\n          >\n            <i class=\"fa fa-floppy-o\"></i>\n          </a>\n          <a\n            href=\"\"\n            ng-click=\"resetEditPreferences();editRoles = !editRoles\"\n            id=\"cancel-roleEdit\"\n            class=\"btn btn-noline-info btn-xs\"\n          >\n            <span class=\"fa fa-times\"></span>\n          </a>\n        </div>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"callout callout-danger margin-t0 padding-t5l10\">\n          <p class=\"margin-0\">\n            Select the type of Role you would be open to\n          </p>\n        </div>\n        <ul\n          id=\"taglist\"\n          class=\"list-inline list-practice-area margin-b0\"\n          ng-if=\"editRoles\"\n        >\n          <li ng-repeat=\"occupation in editPreferences.occupations\">\n            <label class=\"ui-checkbox\">\n              <input\n                type=\"checkbox\"\n                ng-click=\"\"\n                data=\"\"\n                ng-model=\"occupation.isSelected\"\n                class=\"ng-pristine ng-valid\"\n              />\n              <span class=\"\">{{occupation.name}}</span>\n            </label>\n          </li>\n        </ul>\n        <ul\n          data-testid=\"candidate-roles\"\n          id=\"taglist\"\n          class=\"list-inline list-practice-area margin-b0\"\n          ng-if=\"!editRoles\"\n        >\n          <li\n            ng-if=\"occupation.isSelected\"\n            class=\"tags-box\"\n            ng-repeat=\"occupation in candidate.occupations\"\n          >\n            {{occupation.name}}\n          </li>\n        </ul>\n\n        <div ng-if=\"candidate.occupations == 0\">\n          This lawyer has not selected any role yet.\n        </div>\n      </div>\n    </div>\n    <!-- End Role Section -->\n    <!-- Target Employer Section -->\n    <div\n      class=\"panel panel-default followed-firms\"\n      data-cy=\"lawyer-employer-type\"\n    >\n      <div class=\"panel-heading\">\n        <strong>\n          <span class=\"glyphicon glyphicon-th\"></span> Target Employer Type\n        </strong>\n        <button\n          ng-show=\"!editEmployerType\"\n          type=\"button\"\n          ng-click=\"resetEditPreferences();editEmployerType = !editEmployerType\"\n          ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n          id=\"edit-employer-type\"\n          class=\"btn btn-noline-info btn-xs pull-right \"\n        >\n          <span class=\"text-edit\" id=\"edit-employer-type\"></span>\n          <i class=\"fa fa-pencil\" id=\"edit-employer-type\"></i>\n        </button>\n        <div\n          ng-show=\"editEmployerType\"\n          class=\"pull-right\"\n          name=\"targetEmployer\"\n        >\n          <a\n            href=\"\"\n            id=\"edit-employer-type\"\n            class=\"btn btn-noline-info btn-xs\"\n            ng-click=\"updateEmployerTypes();editEmployerType = !editEmployerType\"\n          >\n            <i class=\"fa fa-floppy-o\"></i>\n          </a>\n          <a\n            href=\"\"\n            ng-click=\"resetEditPreferences();editEmployerType = !editEmployerType\"\n            id=\"cancel-targetEmployerEdit\"\n            class=\"btn btn-noline-info btn-xs\"\n          >\n            <span class=\"fa fa-times\"></span>\n          </a>\n        </div>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"callout callout-danger margin-t0 padding-t5l10\">\n          <p class=\"margin-0\">\n            Select the type of Employer you would be open to\n          </p>\n        </div>\n        <ul\n          id=\"taglist\"\n          class=\"list-inline list-practice-area margin-b0\"\n          ng-if=\"editEmployerType\"\n        >\n          <li ng-repeat=\"empType in editPreferences.employerTypes\">\n            <label class=\"ui-checkbox\">\n              <input\n                type=\"checkbox\"\n                ng-click=\"\"\n                data=\"\"\n                ng-model=\"empType.isSelected\"\n                class=\"ng-pristine ng-valid\"\n              />\n              <span class=\"\">{{empType.name}}</span>\n            </label>\n          </li>\n        </ul>\n        <ul\n          data-testid=\"candidate-employer-types\"\n          id=\"taglist\"\n          class=\"list-inline list-practice-area margin-b0\"\n          ng-if=\"!editEmployerType\"\n        >\n          <li\n            class=\"tags-box\"\n            ng-repeat=\"empType in candidate.legalEmployerTypes\"\n            ng-if=\"empType.isSelected\"\n          >\n            {{empType.name}}\n          </li>\n        </ul>\n\n        <div ng-if=\"candidate.legalEmployerTypes.length == 0\">\n          This lawyer has not selected any target employer yet.\n        </div>\n      </div>\n    </div>\n    <!-- End Target Employer Section -->\n  </div>\n  <script type=\"text/ng-template\" id=\"locations-modal.html\">\n    <locations-Modal></locations-Modal>\n  </script>\n</div>\n"

/***/ }),
/* 437 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"col-md-8\">\n    <div class=\"panel panel-default section-matters\">\n      <div class=\"panel-heading\">\n        <strong> <i class=\"glyphicon glyphicon-th\"></i> CV</strong>\n      </div>\n      <div class=\"panel-body\" data-cy=\"cv-section\">\n        <!-- ng-controller=\"CVCtrl\" -->\n        <div class=\"row\">\n          <div\n            class=\"col-md-12 h5\"\n            align=\"center\"\n            ng-show=\"candidate.resumes.length === 0\"\n          >\n            <strong\n              >{{candidate.isAdminProfile ? 'The lawyer has not uploaded any CV\n              yet.' : 'Please upload your CV to complete your LexStep\n              profile.'}}</strong\n            >\n          </div>\n\n          <span\n            us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n            spinner-key=\"spinner-1\"\n          ></span>\n\n          <div\n            class=\"col-sm-10 col-xs-12 sec-cv text-right user-cv\"\n            ng-show=\"editResume || candidate.resumes.length > 0\"\n          >\n            <div class=\"col-md-3\">\n              <h5>\n                <strong>Lawyer CV(s)</strong>\n              </h5>\n            </div>\n            <div class=\"col-md-8\">\n              <h5\n                class=\"row\"\n                ng-if=\"candidate.resumes.length > 0\"\n                ng-repeat=\"cv in candidate.resumes\"\n              >\n                <a\n                  title=\"Download this CV\"\n                  ng-if=\"!cv.editResume\"\n                  class=\"pull-left text-info\"\n                  href=\"\"\n                  target=\"_blank\"\n                  ng-click=\"downloadResume(cv)\"\n                  >{{cv.name}} &nbsp;&nbsp;</a\n                >\n                <div ng-if=\"cv.editResume\" class=\"col-md-9\">\n                  <input\n                    data-testid=\"rename-cv\"\n                    type=\"text\"\n                    ng-if=\"cv.editResume\"\n                    placeholder=\"Rename CV\"\n                    class=\"form-control\"\n                    ng-model=\"cv.newResumeName\"\n                    alphabets-numbers\n                    limit-to=\"30\"\n                    ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n                  />\n                </div>\n\n                <span ng-if=\"!cv.editResume\">\n                  <button\n                    data-testid=\"edit-cv-name\"\n                    ng-show=\"!cv.editResume\"\n                    class=\"btn btn-noline-info btn-xs\"\n                    id=\"edit-practice\"\n                    ng-click=\"cv.newResumeName = cv.name ;cv.editResume = true\"\n                    ng-touch=\"cv.newResumeName = cv.name ;cv.editResume = true\"\n                    ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n                  >\n                    <span class=\"text-edit\"></span>\n                    <i class=\"fa fa-pencil\"></i>\n                  </button>\n\n                  <button\n                    data-testid=\"delete-cv-bin\"\n                    class=\"btn btn-noline-info btn-xs\"\n                    ng-click=\"deleteResume(cv)\"\n                    ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n                  >\n                    <span class=\"glyphicon glyphicon-trash\"></span>\n                  </button>\n                </span>\n\n                <span class=\"col-md-3 pad-r0\" ng-if=\"cv.editResume\">\n                  <button\n                    class=\"btn btn-noline-info btn-xs \"\n                    id=\"edit-practice\"\n                    data-testid=\"save-cv-name\"\n                    ng-click=\"editResumeName(cv);cv.editResume= false;\"\n                    ng-touch=\"editResumeName(cv);cv.editResume=false;\"\n                    ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n                  >\n                    <span class=\"text-edit\"></span>\n                    <i class=\"fa fa-check\"></i>\n                  </button>\n\n                  <button\n                    data-testid=\"edit-cv-cancel\"\n                    class=\"btn btn-noline-info btn-xs \"\n                    id=\"edit-practice\"\n                    ng-click=\"cv.editResume= false;\"\n                    ng-touch=\"cv.editResume=false;\"\n                    ng-disabled=\"candidate.approvalStatus === 'Locked' &&\n                    !candidate.isAdminProfile\"\n                  >\n                    <span class=\"text-edit\"></span>\n                    <i class=\"fa fa-times\"></i>\n                  </button>\n                </span>\n              </h5>\n              <div class=\"row\">\n                <div class=\"col-md-offset-6 col-md-6 pad-r0\">\n                  <a\n                    data-testid=\"add-cv-button\"\n                    title=\"Add another CV\"\n                    type=\"file\"\n                    ng-file-select=\"uploadResumeButton($files);\"\n                    ng-multiple=\"false\"\n                    allow-dir=\"true\"\n                    accept=\".docx,.pdf,.doc\"\n                    ng-show=\"candidate.resumes.length < 5\"\n                    class=\"btn btn-w-md btn-line-info\"\n                    ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n                    >Add another CV</a\n                  >\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div\n            class=\"col-md-offset-5 col-md-6 pad-r0\"\n            style=\"padding-top: 8px;\"\n          >\n            <div ng-show=\"candidate.resumes.length === 0\">\n              <button\n                type=\"file\"\n                ng-file-select=\"uploadResumeButton($files);\"\n                class=\" btn btn-w-md btn-line-info\"\n                ng-multiple=\"false\"\n                allow-dir=\"true\"\n                accept=\".docx,.pdf,.doc\"\n                ng-show=\"!editResume\"\n                ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n              >\n                <span class=\"text-edit\">Add a CV &nbsp;</span>\n                <i class=\"fa fa-plus\"></i>\n              </button>\n\n              <!-- <button class=\"btn btn-noline-info btn-xs btn-default pull-right\" ng-click=\"editResume = false;\" ng-hide=\"!editResume || hideCancel\">Cancel</button> -->\n            </div>\n            <!-- <div ng-show=\"loggedInLawyer.user.user_CV\">\n\n            </div> -->\n          </div>\n        </div>\n        <br />\n        <p align=\"center\" ng-if=\"!candidate.isAdminProfile\">\n          Your CV remains completely confidential unless you explicitly grant an\n          employer permission to review it by tapping the\n          <i><strong>Interested</strong></i> button next to a specific\n          opportunity.\n        </p>\n      </div>\n    </div>\n\n    <employment-history\n      candidate=\"candidate\"\n      lawyer-id=\"candidate.id\"\n      current-employer=\"candidate.employer.name\"\n      lawyer-approved=\"true\"\n      law-firms=\"lawFirms\"\n      locations=\"locations\"\n      contracts=\"contracts\"\n      occupations=\"occupations\"\n      practices=\"practiceAreas\"\n      update-employment-info=\"updateEmploymentInfo(newLocations, currentEmployer)\"\n      ng-if=\"candidate.id\"\n    >\n    </employment-history>\n\n    <div\n      ng-if=\"candidate.isAdminProfile\"\n      class=\"panel panel-default section-matters\"\n      data-testid=\"profile-linked-in\"\n    >\n      <div class=\"panel-heading\">\n        <strong>\n          <i class=\"glyphicon glyphicon-th\"></i>\n          LinkedIn</strong\n        >\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"callout callout-danger margin-t0 padding-t5l10\">\n          <p class=\"margin-0\">Visible to Admin only</p>\n        </div>\n        <div\n          ng-if=\"candidate.linkedInData\"\n          class=\"row\"\n          style=\"padding-bottom: 10px;\"\n        >\n          <div class=\"col-md-1\">\n            <img\n              src='{{candidate.linkedInData.profileData.profilePicture[\"displayImage~\"].elements[0].identifiers[\"0\"].identifier}}'\n              class=\"linkedin-profile-picture\"\n            />\n          </div>\n          <div class=\"col-md-9 padding-l25\">\n            <b\n              >{{candidate.linkedInData.profileData.firstName.localized.en_US}}\n              {{candidate.linkedInData.profileData.lastName.localized.en_US}} |\n              verified on\n              {{candidate.linkedInData.profileData.connectDate?(candidate.linkedInData.profileData.connectDate\n              | date:'dd MMM, yyyy'):(candidate.approvalRequestDate | date:'dd\n              MMM, yyyy')}}</b\n            >\n            <br />\n            {{candidate.linkedInData.emailData.elements[0][\"handle~\"].emailAddress}}\n            <br />\n            <div class=\"margin-t5\">\n              <span class=\"green-tag\">Verified</span>\n            </div>\n          </div>\n        </div>\n        <hr />\n        <div class=\"row padding-l85\">\n          <strong ng-if=\"!candidate.linkedinUrl\">\n            This lawyer's LinkedIn URL has not been added yet.</strong\n          >\n          <a\n            ng-show=\"candidate.linkedinUrl && !editLinkedInUrl\"\n            target=\"_blank\"\n            class=\"text-info\"\n            href=\"{{linkedInUrlPrefix}}{{candidate.linkedinUrl}}\"\n            ng-hide=\"editURL\"\n            >{{candidate.linkedinUrl}}</a\n          >\n          <span class=\"col-md-2 text-right pull-right\">\n            <button\n              ng-show=\"!editLinkedInUrl\"\n              class=\"btn btn-noline-info btn-xs\"\n              id=\"edit-practice\"\n              ng-click=\"editLinkedInUrlMethod()\"\n              ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n            >\n              <span class=\"text-edit\"></span>\n              <i class=\"fa fa-pencil\"></i>\n            </button>\n          </span>\n        </div>\n\n        <div class=\"row\" ng-if=\"editLinkedInUrl\">\n          <div class=\"col-md-10 padding-l85\">\n            <input\n              type=\"text\"\n              placeholder=\"Type URL\"\n              class=\"form-control linkedin-input\"\n              value=\"{{candidate.linkedinUrl}}\"\n              ng-model=\"editUserData.linkedInUrl\"\n              ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n            />\n          </div>\n          <span class=\"col-md-2 text-right pull-right margin-t7\">\n            <button\n              class=\"btn btn-noline-info btn-xs \"\n              id=\"edit-practice\"\n              ng-click=\"updateLinkedInUrl();\"\n              ng-touch=\"updateLinkedInUrl();\"\n              ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n            >\n              <span class=\"text-edit\"></span>\n              <i class=\"fa fa-check\"></i>\n            </button>\n\n            <button\n              class=\"btn btn-noline-info btn-xs \"\n              id=\"edit-practice\"\n              ng-click=\"closeEditLinkedIn();\"\n              ng-touch=\"closeEditLinkedIn();\"\n              ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n            >\n              <span class=\"text-edit\"></span>\n              <i class=\"fa fa-times\"></i>\n            </button>\n          </span>\n        </div>\n      </div>\n    </div>\n    <div class=\"panel panel-default section-details\">\n      <div class=\"panel-heading\">\n        <strong ng-if=\"candidate.isAdminProfile\">\n          <i class=\"glyphicon glyphicon-th\"></i>\n          Responses</strong\n        >\n        <strong ng-if=\"!candidate.isAdminProfile\">\n          <i class=\"glyphicon glyphicon-th\"></i>\n          ABOUT YOU</strong\n        >\n      </div>\n      <div class=\"panel-body\">\n        <div data-testid=\"first-question\" class=\"responses-questions margin-b5\">\n          <h5 class=\"margin-t0 margin-b5\">\n            <strong\n              >{{'lawyerProfile.About.response.moveQuestion'|translate}}</strong\n            >\n            &nbsp;\n            <a\n              href=\"\"\n              tooltip=\"{{'lawyerProfile.response.moveQuestion.toolTip'|translate}}\"\n              tooltip-placement=\"right\"\n            >\n              <span data-testid=\"move-tooltip\" class=\"badge badge-grey\">\n                <i class=\"fa fa-info\"></i>\n              </span>\n            </a>\n\n            <button\n              ng-if=\"!candidate.isAdminProfile\"\n              data-testid=\"edit-move\"\n              type=\"button\"\n              class=\"btn btn-noline-info btn-xs pull-right\"\n              id=\"edit-move\"\n              ng-click=\"openLawyerPreferencesModal('edit-move')\"\n              ng-show=\"candidate.approvalStatus === 'Approved'\"\n            >\n              <i id=\"edit-move\" class=\"fa fa-pencil\"></i>\n            </button>\n          </h5>\n          <!-- <p align=\"justify\">{{candidate.infoMotivation}}</p> -->\n          <read-more\n            data-testid=\"response-one\"\n            hmtext=\"{{candidate.infoMotivation}}\"\n            hmlimit=\"200\"\n            hm-more-text=\"more\"\n            hm-less-text=\"less\"\n            hm-more-class=\"text-info\"\n            hm-less-class=\"text-info\"\n            align=\"justify\"\n          >\n          </read-more>\n        </div>\n        <br />\n\n        <div data-testid=\"second-question\" class=\"responses-questions\">\n          <h5 class=\"margin-t0 margin-b5\">\n            <strong\n              >{{'lawyerProfile.About.response.moreInfoQuestion'|translate}}</strong\n            >\n            &nbsp;\n            <a\n              href=\"\"\n              tooltip=\"{{'lawyerProfile.response.moreInfoQuestion.toolTip'|translate}}\"\n              tooltip-placement=\"bottom\"\n            >\n              <span data-testid=\"info-tooltip\" class=\"badge badge-grey\">\n                <i class=\"fa fa-info\"></i>\n              </span>\n            </a>\n            <!-- <a title=\"{{'lawyerProfile.response.moreInfoQuestion.toolTip'|translate}}\"><i class=\"fa fa-info\"></i></a> -->\n\n            <button\n              ng-if=\"!candidate.isAdminProfile\"\n              data-testid=\"edit-info\"\n              type=\"button\"\n              class=\"btn btn-noline-info  btn-xs pull-right\"\n              ng-show=\"candidate.approvalStatus === 'Approved'\"\n              id=\"edit-info\"\n              ng-click=\"openLawyerPreferencesModal('edit-info')\"\n            >\n              <i id=\"edit-info\" class=\"fa fa-pencil\"></i>\n            </button>\n          </h5>\n          <!-- <p class=\"margin-b0\">{{candidate.infoAdditional}}</p> -->\n          <read-more\n            hmtext=\"{{candidate.infoAdditional}}\"\n            hmlimit=\"200\"\n            hm-more-text=\"more\"\n            hm-less-text=\"less\"\n            hm-more-class=\"text-info\"\n            hm-less-class=\"text-info\"\n            align=\"justify\"\n          >\n          </read-more>\n        </div>\n      </div>\n    </div>\n    <!-- End Responses Section -->\n    <div class=\"panel panel-default preferred-location\">\n      <div class=\"panel-heading\">\n        <strong>\n          <span class=\"glyphicon glyphicon-th\"></span>\n          {{'modal.updateJurisdictions.Heading'|translate}}\n        </strong>\n\n        <button\n          data-testid=\"edit-jurisdictions-icon\"\n          type=\"button\"\n          ng-click=\"openLawyerPreferencesModal('edit-jurisdictions')\"\n          ng-touch=\"openLawyerPreferencesModal('edit-jurisdictions')\"\n          ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n          id=\"edit-jurisdictions\"\n          class=\"btn btn-noline-info btn-xs pull-right \"\n        >\n          <span class=\"text-edit\" id=\"edit-jurisdictions\"></span>\n          <i class=\"fa fa-pencil\" id=\"edit-jurisdictions\"></i>\n        </button>\n      </div>\n      <div class=\"panel-body\">\n        <ul id=\"taglist\" class=\"list-inline list-practice-area margin-b0\">\n          <li\n            class=\"tags-box\"\n            ng-repeat=\"locations in candidate.legalJurisdictions\"\n            ng-if=\"locations.isSelected\"\n          >\n            {{locations.name}}\n          </li>\n        </ul>\n      </div>\n    </div>\n    <!-- End Preferred Area Section -->\n  </div>\n  <!-- Left Col End-->\n\n  <div class=\"col-md-4\">\n    <div\n      class=\"panel panel-default section-details\"\n      data-testid=\"profile-contact-info\"\n    >\n      <div class=\"panel-heading\">\n        <strong> <i class=\"glyphicon glyphicon-th\"></i> Contact Info</strong>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"row margin-b5\">\n          <div class=\"col-xs-9\">\n            <a\n              data-testid=\"email-visible\"\n              href=\"mailto:{{candidate.user.email}}\"\n              class=\"text-info\"\n              >{{candidate.user.email}}</a\n            >\n          </div>\n          <div class=\"col-md-3 margin-t5 text-right \" name=\"email\">\n            <div ng-show=\"!editEmail\" ng-if=\"candidate.isAdminProfile\">\n              <a\n                href=\"\"\n                id=\"edit-email\"\n                class=\"btn btn-noline-info btn-xs\"\n                ng-click=\"editEmailAddress()\"\n                ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n              >\n                <span id=\"edit-email\" class=\"fa fa-pencil\"></span>\n              </a>\n            </div>\n          </div>\n        </div>\n        <div class=\"row margin-b5\" ng-show=\"editEmail\">\n          <div class=\"col-xs-9\">\n            <input\n              type=\"email\"\n              class=\"form-control\"\n              autocomplete=\"off\"\n              data-ng-model=\"editUserData.email\"\n            />\n          </div>\n          <!-- email ID edit-->\n          <div class=\"col-md-3 margin-t5 text-right \" name=\"email\">\n            <a\n              href=\"\"\n              id=\"edit-phone\"\n              class=\"btn btn-noline-info btn-xs\"\n              ng-click=\"editEmail = !editEmail;updateEmail()\"\n            >\n              <i class=\"fa fa-floppy-o\"></i>\n            </a>\n            <a\n              href=\"\"\n              ng-click=\"editEmail = !editEmail\"\n              id=\"cancel-email\"\n              class=\"btn btn-noline-info btn-xs\"\n            >\n              <span class=\"fa fa-times\"></span>\n            </a>\n          </div>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"col-xs-9\">\n            <a\n              data-testid=\"phone-visible\"\n              href=\"tel:{{candidate.user.phone}}\"\n              class=\"text-info\"\n              >{{candidate.user.phone}}</a\n            >\n            <p ng-if=\"!candidate.user.phone\">\n              No Phone number added\n            </p>\n          </div>\n          <div class=\"col-md-3 margin-t5\" align=\"right\" name=\"phone\">\n            <div ng-if=\"!editPhone\">\n              <a\n                href=\"\"\n                id=\"edit-phone\"\n                class=\"btn btn-noline-info btn-xs\"\n                ng-click=\"editPhoneNumber()\"\n                ng-if=\"!candidate.user.phone\"\n                ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n              >\n                <i class=\"fa fa-plus\"></i>\n              </a>\n              <a\n                href=\"\"\n                id=\"edit-phone\"\n                class=\"btn btn-noline-info btn-xs\"\n                ng-click=\"editPhoneNumber()\"\n                ng-if=\"candidate.user.phone\"\n                ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n              >\n                <i class=\"fa fa-pencil\"></i>\n              </a>\n            </div>\n          </div>\n        </div>\n        <div class=\"row margin-b5\" ng-show=\"editPhone\">\n          <div class=\"col-xs-9\">\n            <input\n              data-testid=\"phone-edit-field\"\n              placeholder=\"Enter your number\"\n              autocomplete=\"off\"\n              type=\"tel\"\n              class=\"form-control\"\n              ng-show=\"editPhone\"\n              data-ng-model=\"editUserData.phone\"\n              only-numbers\n            />\n          </div>\n          <!-- email ID edit-->\n          <div class=\"col-md-3 margin-t5 text-right \" name=\"phone\">\n            <div ng-if=\"editPhone\">\n              <a\n                href=\"\"\n                id=\"edit-phone\"\n                class=\"btn btn-noline-info btn-xs\"\n                ng-click=\"editPhone = !editPhone; updatePhoneNumber()\"\n              >\n                <i class=\"fa fa-floppy-o\"></i>\n              </a>\n              <a\n                href=\"\"\n                id=\"edit-phone\"\n                class=\"btn btn-noline-info btn-xs\"\n                ng-click=\"editPhone = !editPhone; cancelEditPhone()\"\n              >\n                <i class=\"fa fa-times\"></i>\n              </a>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- End Contact Info Section -->\n    <div class=\"panel panel-default languages\">\n      <div class=\"panel-heading\">\n        <strong>\n          <span class=\"glyphicon glyphicon-th\"></span>\n          Languages</strong\n        >\n        <button\n          type=\"button\"\n          data-testid=\"edit-languages-icon\"\n          ng-click=\"openLawyerPreferencesModal('edit-languages')\"\n          ng-touch=\"openLawyerPreferencesModal('edit-languages')\"\n          ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n          id=\"edit-languages\"\n          class=\"btn btn-noline-info btn-xs pull-right \"\n        >\n          <span class=\"text-edit\" id=\"edit-languages\">Add&nbsp;</span>\n          <i class=\"fa fa-plus\" id=\"edit-languages\"></i>\n        </button>\n      </div>\n      <div class=\"panel-body\">\n        <ul id=\"taglist\" class=\"list-inline list-practice-area\">\n          <li\n            class=\"tags-box\"\n            ng-repeat=\"language in candidate.languages\"\n            ng-if=\"language.isSelected\"\n          >\n            {{language.name}}\n          </li>\n        </ul>\n      </div>\n    </div>\n    <!-- End Languages Section -->\n    <div\n      class=\"panel panel-default practice-area\"\n      data-testid=\"profile-practice-areas\"\n    >\n      <div class=\"panel-heading\">\n        <strong>\n          <span class=\"glyphicon glyphicon-th\"></span>\n          PRACTICE AREA EXPERTISE\n        </strong>\n\n        <button\n          data-testid=\"edit-practice-area\"\n          type=\"button\"\n          ng-click=\"openPracticeModal(null,$event);userInformationUpdate()\"\n          ng-touch=\"openPracticeModal(null,$event);userInformationUpdate()\"\n          ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n          id=\"edit-practice\"\n          class=\"btn btn-noline-info btn-xs pull-right\"\n          ng-show=\"true\"\n        >\n          <span class=\"text-edit\" id=\"edit-practice\"></span>\n          <i class=\"fa fa-pencil\" id=\"edit-practice\"></i>\n        </button>\n      </div>\n      <div class=\"panel-body\">\n        <div class=\"callout callout-danger margin-t0 padding-t5l10\">\n          <p class=\"margin-0\">Never shown to employers</p>\n        </div>\n        <ul id=\"taglist\" class=\"list-inline list-practice-area margin-b0\">\n          <li\n            class=\"tags-box\"\n            ng-repeat=\"practice in candidate.legalPracticeAreas\"\n          >\n            <!-- ng-if=\"area.isSelected && !area.hasChild\" -->\n            {{practice.name}}\n          </li>\n        </ul>\n      </div>\n    </div>\n    <!-- End Practice Area Section -->\n    <lawyer-salary\n      data-testid=\"salary-modal\"\n      ng-if=\"candidate.id\"\n      lawyer-approved=\"true\"\n      candidate=\"candidate\"\n      locked-salary=\"lockedSalary\"\n    ></lawyer-salary>\n\n    <!-- LAWYER SRA ID -->\n    <div\n      ng-if=\"candidate.isAdminProfile\"\n      class=\"panel panel-default preferred-location\"\n      data-testid=\"profile-sra-number\"\n      ng-if=\"candidate.lawProfile.sraId\"\n    >\n      <div class=\"panel-heading\">\n        <strong>\n          <span class=\"glyphicon glyphicon-th\"></span> SRA Number\n        </strong>\n      </div>\n      <div class=\"panel-body\">\n        {{candidate.lawProfile.sraId}}\n      </div>\n    </div>\n  </div>\n  <!-- Right Col End-->\n  <lawyer-preferences\n    modal-open-handler=\"openLawyerPreferencesModal\"\n    candidate=\"candidate\"\n    linear-locations=\"refLocations\"\n    nested-locations=\"nestedLocations\"\n    linear-practices=\"refPractices\"\n    nested-practices=\"nestedPractices\"\n    jurisdictions=\"candidate.legalJurisdictions\"\n    languages=\"candidate.languages\"\n  ></lawyer-preferences>\n  <script type=\"text/ng-template\" id=\"practice-area-modal.html\">\n    <practice-Area></practice-Area>\n  </script>\n</div>\n"

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <span\n    us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n    spinner-key=\"spinner-recommendations\"\n    class=\"lawyer-actions-spinner\"\n    style=\"top: 50%;position: fixed;left: 50%;z-index: 1;\"\n  ></span>\n  <div class=\"row matching-lawyer-page\">\n    <div class=\"\">\n      <div class=\"panel panel-default\">\n        <div class=\"profile-recommendations-controls\">\n          <ul class=\"profile-recommendations-filters\">\n            <li>\n              <practice-Area-Dropdown\n                practice-areas-list=\"filterData.candidateSpecialties\"\n                on-practice-change=\"onChangePracticeArea($event,selectedPracticeArea)\"\n              ></practice-Area-Dropdown>\n            </li>\n            <li>\n              <locations-Dropdown\n                locations-list=\"filterData.locations\"\n                regions-list=\"filterData.regionHierarchialListWithEuropeOnTop\"\n                on-location-change=\"onChangeLocation($event,selectedLocation)\"\n              ></locations-Dropdown>\n            </li>\n            <li>\n              <multi-select-dropdown\n                base-list=\"filterData.employerTypes\"\n                on-change=\"applyFilter('employerType')\"\n                placeholder=\"'Employer Type'\"\n                button-id=\"tab-regCustom-filter-employer-type\"\n              ></multi-select-dropdown>\n            </li>\n            <li>\n              <multi-select-dropdown\n                base-list=\"filterData.contracts\"\n                on-change=\"applyFilter('contract')\"\n                placeholder=\"'Contract'\"\n                button-id=\"tab-regCustom-filter-contract\"\n              ></multi-select-dropdown>\n            </li>\n            <li>\n              <multi-select-dropdown\n                base-list=\"filterData.occupations\"\n                on-change=\"applyFilter('occupation')\"\n                placeholder=\"'Occupation'\"\n                button-id=\"tab-regCustom-filter-roles\"\n              ></multi-select-dropdown>\n            </li>\n          </ul>\n\n          <ul class=\"profile-recommendations-sliders\">\n            <li class=\"profile-recommendations-selectivity-slider\">\n              <input\n                ng-model=\"sliderFilter.selectivity\"\n                ng-change=\"applyFilter('selectivity')\"\n                autocomplete=\"off\"\n                type=\"text\"\n                id=\"specConnSelectivity\"\n                slider\n                options=\"sliderOptions.selectivity\"\n              />\n              <div class=\"Uncategorized-selectivity\">\n                <input\n                  type=\"checkbox\"\n                  id=\"allowUncategorizedSelectivity\"\n                  autocomplete=\"off\"\n                  ng-model=\"uncategorizedSelectivity\"\n                  ng-change=\"applyFilter('selectivity')\"\n                />\n                Show Uncategorized selectivity\n              </div>\n            </li>\n            <li class=\"profile-recommendations-pqe-slider\">\n              <input\n                ng-model=\"sliderFilter.experience\"\n                ng-change=\"applyFilter('experience')\"\n                autocomplete=\"off\"\n                type=\"text\"\n                id=\"mySlider2\"\n                slider\n                options=\"sliderOptions.experience\"\n              />\n\n              <a\n                class=\"lawyer-profile-tooltips margin-l-25\"\n                href=\"\"\n                tooltip=\"The speculative opportunities at the private practice firms below match {{loggedInLawyer.user.first_Name}}'s Practice Areas, PQE (within +1 / -1 PQE) and Location. This excludes {{loggedInLawyer.user.first_Name}}'s current firm, {{loggedInLawyer.lawyer.lawyer_currentEmp}}. Speculative opportunities at any other employers that are specifically blocked from {{loggedInLawyer.user.first_Name}}'s view or outside {{loggedInLawyer.user.first_Name}}'s visible selectivity level(s) are also excluded.\n\nPositions marked in grey are applications that {{loggedInLawyer.user.first_Name}} has already made.\n\nTo refine the list use the filters and PQE slider, which work in series (AND rather than OR).\n\nIf {{loggedInLawyer.user.first_Name}} has given you express instructions to speculatively approach firms on their behalf, you may do so by uploading their CV to their profile and clicking Interested next to the relevant position below. This will NOT be visible on {{loggedInLawyer.user.first_Name}}'s Track page.\"\n                tooltip-placement=\"left\"\n              >\n                <span class=\"badge badge-grey email-pause-info\">\n                  <i class=\"fa fa-info\"></i>\n                </span>\n              </a>\n            </li>\n          </ul>\n        </div>\n        <div class=\"sort-selector\">\n          <label>Sort:</label>\n          <select\n            ng-model=\"sortBy\"\n            ng-change=\"applySort()\"\n            class=\"form-control\"\n          >\n            <option value=\"recency\">Most Recent</option>\n            <option value=\"alphabetical\">A - Z </option>\n          </select>\n        </div>\n        <div class=\"panel-body\">\n          <div class=\"custom-table-body\">\n            <div\n              ng-if=\"recommendations.length === 0 && !recommendationsLoading\"\n            >\n              <center>\n                <h3>No jobs to show</h3>\n              </center>\n            </div>\n            <div ng-show=\"recommendationsLoading\">\n              <div class=\"ph-item margin-t5 margin-b5\">\n                <div class=\"ph-col-12\">\n                  <div class=\"ph-row\">\n                    <div class=\"ph-col-6 big\"></div>\n                    <div class=\"ph-col-4 empty big\"></div>\n                    <div class=\"ph-col-2 big\"></div>\n                    <div class=\"ph-col-4\"></div>\n                    <div class=\"ph-col-8 empty\"></div>\n                    <div class=\"ph-col-6\"></div>\n                    <div class=\"ph-col-6 empty\"></div>\n                    <div class=\"ph-col-12\"></div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"ph-item margin-t5 margin-b5\">\n                <div class=\"ph-col-12\">\n                  <div class=\"ph-row\">\n                    <div class=\"ph-col-6 big\"></div>\n                    <div class=\"ph-col-4 empty big\"></div>\n                    <div class=\"ph-col-2 big\"></div>\n                    <div class=\"ph-col-4\"></div>\n                    <div class=\"ph-col-8 empty\"></div>\n                    <div class=\"ph-col-6\"></div>\n                    <div class=\"ph-col-6 empty\"></div>\n                    <div class=\"ph-col-12\"></div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"ph-item margin-t5 margin-b5\">\n                <div class=\"ph-col-12\">\n                  <div class=\"ph-row\">\n                    <div class=\"ph-col-6 big\"></div>\n                    <div class=\"ph-col-4 empty big\"></div>\n                    <div class=\"ph-col-2 big\"></div>\n                    <div class=\"ph-col-4\"></div>\n                    <div class=\"ph-col-8 empty\"></div>\n                    <div class=\"ph-col-6\"></div>\n                    <div class=\"ph-col-6 empty\"></div>\n                    <div class=\"ph-col-12\"></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div\n              ng-hide=\"recommendationsLoading\"\n              ng-class=\"{appliedjob: position.isApplied}\"\n              class=\"list-item list-item-inhouse clearfix\"\n              title=\"Click to view position\"\n              data-ng-repeat-start=\"position in recommendations\"\n              data-ng-click=\"expandPosition(position)\"\n              ng-init=\"position.expanded=false\"\n            >\n              <div class=\"col-md-8 col-sm-12 col-xs-12 list-col-firm\">\n                <div class=\"row\">\n                  <div class=\"col-xs-4 list-firm-logo\">\n                    <img\n                      class=\"\"\n                      alt=\"{{position.employer.name}}\"\n                      ng-src=\"{{position.employer.logoSrc}}\"\n                    />\n                  </div>\n                  <div class=\"col-xs-8 list-job-title\">\n                    <h2 class=\"margin-t0 margin-b0 text-thin\">\n                      {{position.employer.name}}\n                      <img\n                        ng-repeat=\"employerType in position.employerTypes\"\n                        ng-src=\"{{(employerType.name === 'Private Practice')?'/images/Private.png':'/images/Inhouse.png'}}\"\n                      />\n                    </h2>\n                    <h3 class=\"padding-b10\" id=\"{{position.id}}\">\n                      {{position.title}}\n                    </h3>\n\n                    <h5\n                      ng-if=\"!position.visible\"\n                      class=\"label label-info text-uppercase\"\n                      style=\"background-color: #ffef00; color:black;width: 52px;font-weight:normal;\"\n                    >\n                      Invisible Position\n                    </h5>\n                    <h5\n                      ng-if=\"!position.employer.isVisible\"\n                      class=\"label label-info text-uppercase\"\n                      style=\"background-color: #ffef00; color:black;width: 52px;font-weight:normal;\"\n                    >\n                      Invisible Firm\n                    </h5>\n                    <h5\n                      ng-if=\"position.positionHidden\"\n                      class=\"label label-info text-uppercase\"\n                      style=\"background-color: #e6b36a; color:black;width: 52px;font-weight:normal;\"\n                    >\n                      Position not for me\n                    </h5>\n                    <h5\n                      ng-if=\"position.employerHidden\"\n                      class=\"label label-info text-uppercase\"\n                      style=\"background-color: #e6b36a; color:black;width: 52px;font-weight:normal;\"\n                    >\n                      Employer not for me\n                    </h5>\n                    <h5\n                      ng-if=\"position.isApplied\"\n                      class=\"label label-info text-uppercase\"\n                      style=\"background-color: #ffef00; color:black;width: 52px;font-weight:normal;\"\n                    >\n                      Indicated interest {{(position.appliedOffPlatform)?\" OFF\n                      PLATFORM\":''}} on\n                      {{position.applicationDate|date:\"dd/MM/yyyy\"}}\n                    </h5>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"col-md-3 col-sm-10 col-xs-12 col-inhouse-pqe\">\n                <h5>\n                  PQE: {{position.lawPreferences.minPqe <= 0\n                  ?\"NQ\":position.lawPreferences.minPqe}}{{position.lawPreferences.maxPqe\n                  == 11?\"+\":(position.lawPreferences.maxPqe <= 0 ||\n                  position.lawPreferences.maxPqe ==\n                  position.lawPreferences.minPqe)?\"\":\"-\"+position.lawPreferences.maxPqe}}\n                </h5>\n                <div class=\"location-cloud\">\n                  <h5\n                    ng-repeat=\"location in position.locations\"\n                    class=\"label label-info text-uppercase location-{{location.countryCode === 'GB' ? 'london' : location.country.region.color}}\"\n                  >\n                    {{location.name}}\n                  </h5>\n                </div>\n              </div>\n\n              <div\n                class=\"col-md-1 col-sm-2 col-xs-12 text-center list-col-explore\"\n              >\n                <div\n                  class=\"btn-noline btn-xs btn-explore \"\n                  ng-hide=\"position.noJobs\"\n                >\n                  <i\n                    ng-show=\"!position.expanded\"\n                    class=\"btn btn-sm btn-line-info fa fa-plus\"\n                  ></i>\n                  <i\n                    ng-show=\"position.expanded\"\n                    class=\"btn btn-sm btn-line-info fa fa-minus\"\n                  ></i>\n                  <span class=\"h5\">Explore Role</span>\n                </div>\n              </div>\n            </div>\n            <div\n              class=\"row inner-list\"\n              ng-if=\"position.expanded\"\n              ng-class=\"{customjob: position.type === 'Custom', connectedjob: position.type === 'Connect', speculativejob: position.type === 'Speculative'}\"\n              style=\"margin: 0 0 10px\"\n              data-ng-repeat-end=\"\"\n            >\n              <div class=\"col-md-3 col-xs-3\">\n                <div>\n                  <h4>\n                    <strong>{{position.title}}</strong>\n                  </h4>\n                </div>\n                <h5>ID: {{position.employerId}}_{{position.id}}</h5>\n                <h5>Selectivity: {{position.employer.selectivity}}</h5>\n                <h5>Contract: {{position.contract.name}}</h5>\n                <h5>Occupation: {{position.occupation.name}}</h5>\n                <span ng-show=\"position.expiresAt\">\n                  <span class=\"h5\">\n                    Last Date to Apply:{{position.expiresAt|date:\"dd/MM/yyyy\"}}\n                  </span>\n                </span>\n\n                <h5 ng-show=\"position.visible\">\n                  Job Visibility: Visible\n                </h5>\n                <h5 ng-show=\"!position.visible\" class=\"red-color\">\n                  Job Visibility: Invisible\n                </h5>\n                <h5>\n                  Required Experience: {{position.lawPreferences.minPqe <= 0\n                  ?\"NQ\":position.lawPreferences.minPqe}}{{position.lawPreferences.maxPqe\n                  == 11?\"+\":(position.lawPreferences.maxPqe <= 0 ||\n                  position.lawPreferences.maxPqe ==\n                  position.lawPreferences.minPqe)?\"\":\"-\"+position.lawPreferences.maxPqe}}\n                </h5>\n                <h5>\n                  Uploaded: {{position.created|date:\"dd-MM-yyyy\"}}\n                </h5>\n              </div>\n\n              <div id=\"{{position.job_ID}}\" class=\"col-md-9 col-xs-9\">\n                <div class=\"\" style=\"padding-top: 9px;\">\n                  <div class=\"row\">\n                    <div class=\"col-md-10\">\n                      <div\n                        class=\"job-description-text\"\n                        ng-class=\"{expanded: position.isExpanded}\"\n                      >\n                        <p\n                          ng-bind-html=\"position.description\"\n                          class=\"\"\n                          align=\"justify\"\n                        ></p>\n                      </div>\n                      <a\n                        href=\"\"\n                        class=\"text-info\"\n                        ng-show=\"!position.isExpanded && position.description.length > 600\"\n                        ng-click=\"position.isExpanded = !position.isExpanded; $event.stopPropagation()\"\n                        >more</a\n                      >\n                      <a\n                        href=\"\"\n                        class=\"text-info\"\n                        ng-show=\"position.isExpanded && position.description.length > 600\"\n                        ng-click=\"position.isExpanded = !position.isExpanded; $event.stopPropagation()\"\n                        >less</a\n                      >\n                    </div>\n                    <div class=\"col-md-2 padding-0\">\n                      <application-modal-directive\n                        candidate=\"candidate\"\n                        position=\"position\"\n                        user=\"user\"\n                      ></application-modal-directive>\n                      <div>\n                        <button\n                          ng-if=\"!position.positionHidden && !position.employerHidden\"\n                          ng-click=\"showHideJobModal(position, $event)\"\n                          class=\"btn btn-save\"\n                        >\n                          <span class=\"fa fa-eye-slash\"></span>&nbsp;Not for me\n                        </button>\n                        <button\n                          ng-if=\"position.positionHidden || position.employerHidden\"\n                          ng-click=\"unHidePosition(position)\"\n                          class=\"btn btn-saved\"\n                        >\n                          <span class=\"text-save fa fa-eye-slash\"\n                            ><span\n                              style='font-family:\"Lato\", \"Helvetica Neue\", Arial, sans-serif;'\n                              >&nbsp;Hidden</span\n                            ></span\n                          >\n                          <span class=\"text-unsave fa fa-eye\"\n                            ><span\n                              style='font-family:\"Lato\", \"Helvetica Neue\", Arial, sans-serif;'\n                              >&nbsp;Unhide</span\n                            ></span\n                          >\n                        </button>\n                      </div>\n                    </div>\n                  </div>\n                  <hr class=\"job-practice-sep\" />\n                  <ul\n                    id=\"taglist\"\n                    class=\"list-inline list-practice-area margin-b0\"\n                  >\n                    <li\n                      class=\"tags-box\"\n                      ng-repeat=\"practice in position.legalPracticeAreas\"\n                    >\n                      {{practice.name}}\n                    </li>\n                  </ul>\n                  <hr class=\"job-practice-sep\" />\n                  <ul\n                    id=\"taglist\"\n                    class=\"list-inline list-practice-area margin-b0\"\n                  >\n                    <li\n                      class=\"tags-box-location location-{{location.countryCode === 'GB' ? 'london' : location.country.region.color}}\"\n                      ng-repeat=\"location in position.locations\"\n                    >\n                      {{location.name}}\n                    </li>\n                  </ul>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <footer class=\"table-footer table-dynamic\">\n      <div class=\"row\">\n        <div class=\"page-num-info col-md-6\">\n          <span>\n            Show\n            <span class=\"ui-select select-enty-count\">\n              <select\n                data-ng-model=\"paginationOptions.selectedLimit\"\n                data-ng-options=\"num for num in paginationOptions.limitOptions\"\n                data-ng-change=\"recommendationsPageChange()\"\n              >\n              </select>\n            </span>\n            entries per page\n          </span>\n        </div>\n        <div class=\"text-right pagination-container custom-pagination col-md-6\">\n          <pagination\n            class=\"pagination-sm\"\n            ng-model=\"pagination.currentPage\"\n            total-items=\"count\"\n            max-size=\"4\"\n            ng-change=\"recommendationsPageChange()\"\n            items-per-page=\"paginationOptions.selectedLimit\"\n            rotate=\"false\"\n            boundary-links=\"true\"\n          >\n          </pagination>\n        </div>\n      </div>\n    </footer>\n  </div>\n  <hide-position-employer-modal\n    modal-open-handler=\"showHideJobModal\"\n    page=\"'matches'\"\n    on-position-hide=\"hideRecommendation(position, 'position')\"\n    on-employer-hide=\"hideRecommendation(position, 'employer')\"\n  >\n  </hide-position-employer-modal>\n</div>\n"

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	module.exports = "<div ng-class=\"{'container margin-t20': employerId}\">\n  <center ng-if=\"employerId\">\n    <h1 class=\"text-thin hdng-tshadow padding-b20\">\n      Notes for <strong>{{employerName}}</strong>\n    </h1>\n  </center>\n  <div class=\"panel panel-default\" data-cy=\"note-component\">\n    <div class=\"panel-body\">\n      <div class=\"text-center padding-t15\" ng-if=\"allNotes.length == 0\">\n        <h4>No notes are added yet</h4>\n        <button class=\"btn btn-info\" ng-click=\"openNotesModal()\">\n          Add Note\n        </button>\n      </div>\n      <div ng-if=\"allNotes.length != 0\">\n        <div class=\"row\">\n          <div class=\"col-md-3\">\n            <span class=\"color-bbb padding-lr20\">Sort List by:</span>\n            <span class=\"ui-select\">\n              <select\n                class=\"admin-filter\"\n                style=\" min-width:0px; padding-top: 6px;padding-bottom: 6px; width:75px;\"\n                ng-init=\"SortBy = sortListData[0]\"\n                ng-model=\"SortBy\"\n                ng-options=\"sort as sort.label for sort in sortListData\"\n              >\n              </select>\n            </span>\n          </div>\n          <div class=\"col-md-3\">\n            <form class=\"margin-b10 position-relative\">\n              <input\n                type=\"text\"\n                placeholder=\"Search\"\n                class=\"form-control\"\n                data-ng-model=\"searchKeywords.value\"\n                data-ng-keyup=\"searchNotes(searchKeywords.value)\"\n              />\n              <span\n                class=\"text-search-clear-lawyer\"\n                ng-if=\"searchKeywords.value.length > 0\"\n                ng-click=\"clearSearchKey()\"\n                >x</span\n              >\n            </form>\n          </div>\n          <div class=\"col-md-3\">\n            <div class=\"pull-left margin-t13\">\n              <a\n                href=\"\"\n                class=\"email-pause-info margin-l-25\"\n                tooltip=\"Using this function will allow you to search only the body of the notes below. The search will not include other data contained in the note (e.g. tagged employer)\"\n                tooltip-placement=\"right\"\n              >\n                <span class=\"badge badge-grey\">\n                  <i class=\"fa fa-info\"></i>\n                </span>\n              </a>\n            </div>\n          </div>\n          <button\n            class=\"btn btn-info pull-right margin-r20\"\n            ng-click=\"openNotesModal()\"\n          >\n            Add Note\n          </button>\n        </div>\n        <hr />\n        <div\n          class=\"row\"\n          ng-repeat=\"note in notes | orderBy: [SortBy.value,'-created'] track by $index\"\n          data-cy=\"lawyer-note\"\n          ng-if=\"allNotes.length > 0\"\n        >\n          <!-- | orderBy: [SortBy.value,'-createdAt'] track by $index -->\n          <div class=\"col-xs-2\">\n            <center>\n              <img\n                ng-if=\"note.category == 'Auto Generated'\"\n                ng-src=\"{{(note.category == 'Auto Generated')?'/images/Notes.png':''}}\"\n              />\n              <img\n                ng-if=\"note.category == 'Conversation'\"\n                class=\"hw40\"\n                ng-src=\"{{(note.category == 'Conversation')?'/images/chat-bubble.svg':''}}\"\n              />\n              <span\n                ng-if=\"note.category != 'Auto Generated'\"\n                ng-class=\"{\n                            'fa fa-comments': (note.category == 'Comment'),\n                            'fa fa-tasks':(note.category == 2),\n                            'fa fa-users': (note.category == 4),\n                            'fa fa-file-text-o': (note.category == 'Interview Feedback')\n                            }\"\n                style=\"font-size: 35px;\"\n              >\n              </span>\n            </center>\n          </div>\n          <div class=\"col-xs-8\" style=\"margin-bottom: 20px;\">\n            <div class=\"row\">\n              <h3 style=\"display: inline\">\n                <strong>{{note.subject}}</strong>\n              </h3>\n              <div\n                ng-if=\"note.category === 'Comment' || note.category === 'Conversation'\"\n                class=\"inline pull-right\"\n              >\n                <span style=\"padding:0px 5px;\">\n                  <button\n                    class=\"btn btn-noline-info btn-xs\"\n                    ng-click=\"noteHistory(note.id)\"\n                  >\n                    <span class=\"fa fa-history\"></span>\n                  </button>\n                </span>\n                <span style=\"padding:0px 5px;\">\n                  <button\n                    ng-disabled=\"note.category == 'Auto Generated'\"\n                    class=\"btn btn-noline-info btn-xs\"\n                    ng-click=\"editNote(note.id,$index)\"\n                  >\n                    <span class=\"fa fa-pencil\"></span>\n                  </button>\n                </span>\n                <span style=\"padding:0px 5px;\">\n                  <button\n                    class=\"btn btn-noline-info btn-xs\"\n                    ng-click=\"deleteNote(note.id,$index)\"\n                  >\n                    <span class=\"glyphicon glyphicon-trash\"></span>\n                  </button>\n                </span>\n              </div>\n            </div>\n\n            <div class=\"row padding-b5\">\n              <span class=\"color-bbb\">\n                Last updated by :&nbsp;&nbsp;\n              </span>\n              <span>\n                <a href=\"\" style=\"color: #1a78cf;\">{{note.author.email}}</a\n                >&nbsp; - &nbsp; {{note.created | date:'dd MMM yyyy'}} &nbsp;\n                {{note.created | date:'HH:mm'}}\n              </span>\n              <div\n                ng-if=\"note.category === 'Interview Feedback' || note.category === 'Auto Generated'\"\n                class=\"inline pull-right\"\n              >\n                <span style=\"padding:0px 5px;\">\n                  <button\n                    ng-if=\"note.category != 'Auto Generated'\"\n                    class=\"btn btn-noline-info btn-xs\"\n                    ng-click=\"noteHistory(note.id)\"\n                  >\n                    <span class=\"fa fa-history\"></span>\n                  </button>\n                </span>\n                <span style=\"padding:0px 5px;\">\n                  <button\n                    ng-disabled=\"note.category == 'Auto Generated'\"\n                    class=\"btn btn-noline-info btn-xs\"\n                    ng-click=\"editNote(note.id,$index)\"\n                  >\n                    <span class=\"fa fa-pencil\"></span>\n                  </button>\n                </span>\n                <span style=\"padding:0px 5px;\">\n                  <button\n                    class=\"btn btn-noline-info btn-xs\"\n                    ng-click=\"deleteNote(note,$index)\"\n                  >\n                    <span class=\"glyphicon glyphicon-trash\"></span>\n                  </button>\n                </span>\n              </div>\n            </div>\n\n            <div class=\"row padding-b5\">\n              <span ng-if=\"note.category == 'Conversation'\">\n                <span ng-if=\"note.medium\"\n                  ><span class=\"color-bbb\">Medium:&nbsp; </span>\n                  {{note.medium}}&nbsp;&nbsp;&nbsp;&nbsp;</span\n                >\n                <span class=\"color-bbb\">Attendees:&nbsp; </span>\n                {{note.attendees}}&nbsp;&nbsp;&nbsp;&nbsp;\n                <span class=\"color-bbb\">At: &nbsp; </span>\n                {{note.date | date:'dd MMM yyyy'}}&nbsp; {{note.date |\n                date:'HH:mm'}} &nbsp;&nbsp;\n              </span>\n              <span ng-if=\"note.category == 'Interview Feedback'\">\n                <span class=\"color-bbb\">Attendees:&nbsp; </span>\n                {{note.attendees}}&nbsp;&nbsp;&nbsp;&nbsp;\n                <span class=\"color-bbb\">Interview at: &nbsp; </span>\n                {{note.date | date:'dd MMM yyyy'}}&nbsp; {{note.date |\n                date:'HH:mm'}} &nbsp;&nbsp;\n              </span>\n            </div>\n            <div ng-if=\"note.employer\" class=\"row padding-b5\">\n              <span class=\"color-bbb\">Tagged Employer:&nbsp; </span>\n              {{note.employer.name}}\n            </div>\n            <div ng-if=\"note.candidate\" class=\"row padding-b5\">\n              <span class=\"color-bbb\">Tagged Candidate:&nbsp; </span>\n              {{note.candidate.firstName}}&nbsp; {{note.candidate.lastName}}\n            </div>\n            <div class=\"row\" style=\"padding-bottom: 5px;\">\n              <p\n                ng-bind-html=\"note.body\"\n                ng-class=\"{'note-expanded': !note.isCollapsed,'note-collapsed': note.isCollapsed}\"\n                align=\"justify\"\n              ></p>\n              <a\n                ng-if=\"note.category == 'Auto Generated'\"\n                ng-show=\"!note.isCollapsed && note.showButton\"\n                href=\"\"\n                class=\"text-info\"\n                ng-click=\"showLess(note);\"\n                ><b class=\"text-more\">less</b></a\n              >\n              <a\n                ng-if=\"note.category == 'Auto Generated'\"\n                ng-show=\"note.isCollapsed && note.showButton\"\n                href=\"\"\n                class=\"text-info\"\n                ng-click=\"showMore(note);\"\n                ><b class=\"text-more\">more</b></a\n              >\n            </div>\n            <hr />\n          </div>\n        </div>\n      </div>\n    </div>\n    <script type=\"text/ng-template\" id=\"notesModal.html\">\n      <div class=\"modal-header\"  >\n        <center>\n          <h3>Add Note</h3>\n        </center>\n      </div>\n      <form name=\"addNoteForm\">\n        <div class=\"modal-body custom-modal-addnotes clearfix\">\n          <div class=\"row\">\n            <div class=\"h5 col-xs-2 notes-modal-label\">Type </div>\n            <div class=\"h5 col-xs-10\">\n              <select class=\"select-cv\" style=\" min-width:0px; padding-top: 6px;padding-bottom: 6px; width:100%;\" ng-model=\"modalData.note.category\"\n              ng-change=\"typeChanged(modalData.note.category)\"\n              data-testid=\"note-type-field\"\n              required>\n                <!-- ng-options=\"type.note_type for type in modalData.noteType\" -->\n                <option ng-repeat=\"type in modalData.noteType\" ng-selected=\"modalData.note.category == type\">{{type}}</option>\n              </select>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"h5 col-xs-2 notes-modal-label\" ng-show=\"modalData.note.category === 'Conversation' || !modalData.note.category\">Medium </div>\n            <div class=\"h5 col-xs-10\" ng-show=\"modalData.note.category === 'Conversation' || !modalData.note.category\">\n              <select class=\"select-cv\"\n                style=\" min-width:0px; padding-top: 6px;padding-bottom: 6px; width:100%;\"\n                placeholder=\"Medium\"\n                ng-model=\"modalData.note.medium\"\n                ng-options=\"item for item in medium\"\n                ng-disabled=\"modalData.note.category != 'Conversation' || !modalData.note.category\"\n                ng-required=\"modalData.note.category === 'Conversation'\">\n              </select>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"h5 col-xs-2 notes-modal-label\" ng-show=\"(modalData.note.category === 'Comment' || modalData.note.category === 'Conversation') || !modalData.note.category\">Subject </div>\n            <div class=\"h5 col-xs-10\" ng-show=\"(modalData.note.category === 'Comment' || modalData.note.category === 'Conversation') || !modalData.note.category\">\n              <input type=\"text\" class=\"form-control\" name=\"noteSubject\" ng-model=\"modalData.note.subject\"\n              ng-required=\"modalData.note.category === 'Comment'\"\n              ng-disabled=\"modalData.note.category === 'Interview Feedback' || modalData.note.category === 'Auto Generated' || !modalData.note.category\">\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"h5 col-xs-2 notes-modal-label\" ng-show=\"modalData.note.category != 'Comment' || !modalData.note.category\">Attendees</div>\n            <div class=\"h5 col-xs-10\" ng-show=\"modalData.note.category != 'Comment' || !modalData.note.category\">\n              <input type=\"text\" class=\"form-control\" name=\"noteAttendees\" ng-model=\"modalData.note.attendees\" ng-required=\"modalData.note.category != 'Comment'\"\n                ng-disabled=\"modalData.note.category === 'Comment' || !modalData.note.category\">\n            </div>\n          </div>\n          <div ng-if=\"modalData.isUserNote\" class=\"row\">\n            <div class=\"h5 col-xs-2 notes-modal-label\">Employer </div>\n            <div class=\"h5 col-xs-10\" ng-show=\"modalData.note.category === 'Comment'  || modalData.note.category != 'Comment' || !modalData.note.category\">\n              <select  class=\"select-cv\" style=\" min-width:0px; padding-top: 6px;padding-bottom: 6px; width:100%;\" ng-model=\"modalData.note.employerId\"\n              data-testid=\"tag-firm\"\n\n              >\n                <option ng-repeat=\"employer in modalData.employers\" ng-value=\"{{employer.id}}\" >{{employer.name}}</option>\n              </select>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"h5 col-xs-2 notes-modal-label\" ng-show=\"modalData.note.category != 'Comment' || !modalData.note.category\">Date </div>\n            <div class=\"h5 col-xs-5\" name=\"pqe\" data-ng-controller=\"DatepickerDemoCtrl\" ng-show=\"modalData.note.category != 'Comment' || !modalData.note.category\">\n              <div class=\"input-group ui-datepicker\" >\n                <input\n                 type=\"text\" disabled placeholder=\"Date\" class=\"form-control custom-readonly\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"modalData.note.date\"\n                  is-open=\"opened\" datepicker-options=\"modalData.dateOptions\" date-disabled=\"reverseDisabled(date, mode)\" close-text=\"Close\">\n                <span\n                data-testid=\"note-date\"\n                class=\"input-group-addon\" ng-click=\"modalData.note.category && open($event)\">\n                  <i class=\"fa fa-calendar\"></i>\n                </span>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"h5 col-xs-2 notes-modal-label\" ng-show=\"modalData.note.category != 'Comment' || !modalData.note.category\">Time </div>\n            <div class=\"h5 col-xs-5\" ng-show=\"modalData.note.category != 'Comment' || !modalData.note.category\">\n              <div ng-model=\"modalData.note.date\" style=\"display:inline-block;\">\n                <uib-timepicker data-testid=\"note-time\" class=\"ui-timepicker\" hour-step=\"timeOptions.hourStep\" minute-step=\"timeOptions.minStep\" show-meridian=\"timeOptions.isMeridian\"></uib-timepicker>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"h5 col-xs-2 notes-modal-label\" ng-show=\"modalData.note.category === 'Comment'  || modalData.note.category != 'Comment' || !modalData.note.category\">Description </div>\n            <div class=\"h5 col-xs-10\" ng-show=\"modalData.note.category === 'Comment'  || modalData.note.category != 'Comment' || !modalData.note.category\">\n              <textarea name=\"noteDesc\" class=\"form-control\" ckeditor=\"editorOptions\" ng-model=\"modalData.note.body\" required>\n              </textarea>\n            </div>\n          </div>\n        </div>\n      </form>\n      <div class=\"modal-footer\">\n        <center>\n          <button   data-testid=\"add-note\" type=\"submit\" class=\"btn btn-info\" ng-disabled=\"!modalData.note.category || addNoteForm.$invalid\"\n            ng-click=\"addNote()\">Add</button>\n          <button class=\"btn btn-gap-v btn-default\" ng-click=\"no()\">Cancel</button>\n        </center>\n      </div>\n    </script>\n    <script type=\"text/ng-template\" id=\"deleteNoteModal.html\">\n      <div class=\"modal-header\">\n        <center>\n          <h3>Delete Note?</h3>\n          <h5>Are you sure you want to delete this Note?</h5>\n        </center>\n      </div>\n      <div class=\"modal-footer\">\n        <center>\n          <button class=\"btn btn-info\" ng-click=\"deleteNote(note_ID)\">Yes</button>\n          <button class=\"btn btn-gap-v btn-default\" ng-click=\"no()\">No</button>\n        </center>\n      </div>\n    </script>\n    <script type=\"text/ng-template\" id=\"editNoteModal.html\">\n      <div class=\"modal-header\">\n        <center>\n          <h3>Edit Note</h3>\n        </center>\n      </div>\n      <form name=\"editNoteForm\">\n        <div class=\"modal-body custom-modal-addnotes clearfix\">\n          <div class=\"row\">\n            <div class=\"h5 col-xs-2 notes-modal-label\">Type </div>\n            <div class=\"h5 col-xs-10\">\n              <select class=\"select-cv\" disabled  style=\" min-width:0px; padding-top: 6px;padding-bottom: 6px; width:100%;\" ng-model=\"modalData.note.category\"\n              ng-change=\"typeChanged(modalData.note.category)\"\n              data-testid=\"note-type-field\"\n              required>\n                <option ng-repeat=\"type in modalData.noteType\" ng-selected=\"modalData.note.category == type\">{{type}}</option>\n              </select>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"h5 col-xs-2 notes-modal-label\" ng-show=\"modalData.note.category == 'Conversation' || !modalData.note.category\">Medium </div>\n            <div class=\"h5 col-xs-10\" ng-show=\"modalData.note.category == 'Conversation' || !modalData.note.category\">\n              <select class=\"select-cv\"\n                style=\" min-width:0px; padding-top: 6px;padding-bottom: 6px; width:100%;\"\n                placeholder=\"Medium\"\n                ng-model=\"modalData.note.medium\"\n                ng-options=\"item for item in medium\"\n                ng-disabled=\"modalData.note.category != 'Conversation' || !modalData.note.category\"\n                ng-required=\"modalData.note.category == 'Conversation'\">\n              </select>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"h5 col-xs-2 notes-modal-label\" ng-show=\"(modalData.note.category === 'Comment' || modalData.note.category === 'Conversation') || !modalData.note.category\">Subject </div>\n            <div class=\"h5 col-xs-10\" ng-show=\"(modalData.note.category === 'Comment' || modalData.note.category === 'Conversation') || !modalData.note.category\">\n              <input type=\"text\" class=\"form-control\" name=\"noteSubject\" ng-model=\"modalData.note.subject\"\n                ng-required=\"modalData.note.category == 'Comment' \"\n                ng-disabled=\"modalData.note.category === 'Interview Feedback' || !modalData.note.category\">\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"h5 col-xs-2 notes-modal-label\" ng-show=\"modalData.note.category != 'Comment' || !modalData.note.category\">Attendees</div>\n            <div class=\"h5 col-xs-10\" ng-show=\"modalData.note.category != 'Comment' || !modalData.note.category\">\n              <input type=\"text\" class=\"form-control\" name=\"noteAttendees\" ng-model=\"modalData.note.attendees\" ng-required=\"modalData.note.category != 'Comment'\"\n                ng-disabled=\"modalData.note.category == 'Comment' || !modalData.note.category\">\n            </div>\n          </div>\n          <div ng-if=\"modalData.isUserNote\" class=\"row\">\n            <div class=\"h5 col-xs-2 notes-modal-label\" ng-show=\"modalData.note.category == 'Comment'  || modalData.note.category != 'Comment' || !modalData.note.category\">Employer </div>\n            <div class=\"h5 col-xs-10\" ng-show=\"modalData.note.category == 'Comment'  || modalData.note.category != 'Comment' || !modalData.note.category\">\n              <select data-testid=\"tag-firm\" class=\"select-cv\" style=\" min-width:0px; padding-top: 6px;padding-bottom: 6px; width:100%;\" ng-model=\"modalData.note.employerId\">\n                <option ng-repeat=\"employer in modalData.employers\" ng-value=\"{{employer.id}}\" ng-selected=\"employer.id === modalData.note.employer.id\" >{{employer.name}}</option>\n              </select>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"h5 col-xs-2 notes-modal-label\" ng-show=\"modalData.note.category != 'Comment' || !modalData.note.category\">Date </div>\n            <div class=\"h5 col-xs-5\" name=\"pqe\" data-ng-controller=\"DatepickerDemoCtrl\" ng-show=\"modalData.note.category != 'Comment' || !modalData.note.category\">\n              <div class=\"input-group ui-datepicker\">\n                <input type=\"text\" disabled placeholder=\"Date\" class=\"form-control custom-readonly\" uib-datepicker-popup=\"dd-MMMM-yyyy\" ng-model=\"modalData.note.date\"\n                  is-open=\"opened\" datepicker-options=\"modalData.dateOptions\" date-disabled=\"reverseDisabled(date, mode)\" close-text=\"Close\">\n                <span class=\"input-group-addon\" ng-click=\"open($event)\">\n                  <i class=\"fa fa-calendar\"></i>\n                </span>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"h5 col-xs-2 notes-modal-label\" ng-show=\"modalData.note.category != 'Comment' || !modalData.note.category\">Time </div>\n            <div class=\"h5 col-xs-5\" ng-show=\"modalData.note.category != 'Comment' || !modalData.note.category\">\n              <div ng-model=\"modalData.note.date\" style=\"display:inline-block;\">\n                <uib-timepicker class=\"ui-timepicker\" hour-step=\"timeOptions.hourStep\" minute-step=\"timeOptions.minStep\" show-meridian=\"timeOptions.isMeridian\"></uib-timepicker>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"h5 col-xs-2 notes-modal-label\" ng-show=\"modalData.note.category == 'Comment'  || modalData.note.category != 'Comment' || !modalData.note.category\">Description </div>\n            <div class=\"h5 col-xs-10\" ng-show=\"modalData.note.category == 'Comment'  || modalData.note.category != 'Comment' || !modalData.note.category\">\n              <textarea name=\"noteDesc\" class=\"form-control\" ckeditor=\"editorOptions\" ng-model=\"modalData.note.body\" required>\n              </textarea>\n            </div>\n          </div>\n        </div>\n        <div class=\"modal-footer\">\n          <center>\n            <button data-testid=\"save-edit-note\" class=\"btn btn-info\" ng-disabled=\"!modalData.note.category || editNoteForm.$invalid\"\n              ng-click=\"editNote()\">Save</button>\n            <button class=\"btn btn-gap-v btn-default\" ng-click=\"no()\">Cancel</button>\n          </center>\n        </div>\n      </form>\n    </script>\n    <script type=\"text/ng-template\" id=\"noteHistoryModal.html\">\n      <div class=\"modal-header\">\n        <center>\n          <h3>Edit History</h3>\n        </center>\n      </div>\n      <div class=\"modal-body custom-modal-notes clearfix\">\n        <center ng-if=\"modalData.length < 1\">\n          No History for this Note yet.\n        </center>\n        <div class=\"notes-edit-modal\" ng-repeat=\"note in modalData\">\n          <div class=\"row\">\n            <h3 style=\"display: inline\">\n              <strong>{{note.data.subject}}</strong>\n            </h3>\n          </div>\n          <div class=\"row padding-b5\">\n            <span class=\"color-bbb\">\n              Last updated by :&nbsp;&nbsp;\n            </span>\n            <span>\n              <a href=\"\" style=\"color: #1a78cf;\">{{note.author && note.author.email}}</a>&nbsp; - &nbsp; {{note.created | date:'dd MMM yyyy'}}\n            </span>\n          </div>\n          <div class=\"row padding-b5\">\n            <span ng-if=\"note.data.category !== 'Comment'\">\n              <span ng-if=\"note.data.medium\"><span class=\"color-bbb\">Medium:&nbsp; </span>\n              {{note.data.medium}}&nbsp;&nbsp;&nbsp;&nbsp;</span>\n              <span class=\"color-bbb\">Attendees:&nbsp; </span>\n              {{note.data.attendees}}&nbsp;&nbsp;&nbsp;&nbsp;\n              <span class=\"color-bbb\"> At: &nbsp; </span>\n              {{note.data.date | date:'dd MMM yyyy'}}&nbsp; {{note.data.date | date:'HH:mm'}} &nbsp;&nbsp;\n            </span>\n          </div>\n          <div ng-if=\"note.employer\" class=\"row padding-b5\">\n            <span class=\"color-bbb\">Tagged Employer:&nbsp; </span>\n            {{note.employer.name}}\n          </div>\n          <div ng-if=\"note.candidate\" class=\"row padding-b5\">\n            <span class=\"color-bbb\">Tagged Candidate:&nbsp; </span>\n            {{note.candidate.firstName}}  {{note.candidate.lastName}}\n          </div>\n          <div class=\"row padding-b5\">\n            <p ng-bind-html=\"note.data.body\" class=\"\" align=\"justify\"></p>\n          </div>\n          <hr>\n        </div>\n      </div>\n      <div class=\"modal-footer\">\n        <center>\n          <button class=\"btn btn-info\" ng-click=\"no()\">Close</button>\n        </center>\n      </div>\n    </script>\n  </div>\n</div>\n"

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	module.exports = "<div>\n    <a href=\"\" style=\"text-decoration: none;\" ng-class=\"{\n        'actions-enabled': isLawyersActionAllowedToView,\n        'actions-disabled': !isLawyersActionAllowedToView\n        }\" ng-disabled=\"!isLawyersActionAllowedToView\" ng-click=\"isLawyersActionAllowedToView && openModal(userId ,lawyerId , $event)\">\n        ActionsN &nbsp;\n        <span class=\"glyphicon glyphicon-chevron-down\" style=\"font-size:10px\" />\n    </a>\n    <span us-spinner=\"{radius:6, width:1, length: 5, color: 'black'}\" spinner-key=\"spinner-{{lawyerId}}\"\n    class=\"lawyer-actions-spinner\"></span>\n</div>"

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	module.exports = "<script type=\"text/ng-template\" id=\"add-filters-modal.html\">\n  <div class=\"modal-header\">\n    <center>\n    <h3>Save as New View</h3>\n    </center>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"modal-row\">\n    <div class=\"clearfix\">\n      <form name=\"saveRulesForm\">\n      <div class=\"col-sm-4 text-center padding-t10\"> Name Your New View</div>\n      <div class=\"col-sm-8\">\n        <input class=\"form-control\" type=\"text\" name=\"filterName\" ng-model=\"filterName\" placeholder=\"Type your New View's name\" required/>\n        <div class=\"padding-t15 margin-t10\">\n        <span class=\"center email-alert-on\">\n          <span ng-show=\"ctrl.filterSwitch.filter\">Private</span>\n          <strong ng-show=\"!ctrl.filterSwitch.filter\">Private </strong>\n        </span>\n\n        <label class=\"switch switch-info switch-view\">\n          <input ng-model=\"ctrl.filterSwitch.filter\" type=\"checkbox\" />\n          <i></i>\n        </label>\n\n        <span class=\"center email-alert-pause\">\n          <strong ng-show=\"ctrl.filterSwitch.filter\">Shared</strong>\n          <span ng-show=\"!ctrl.filterSwitch.filter\">Shared</span>\n        </span>\n        </div>\n        <div class=\"margin-t10\">\n        <ul id=\"taglist\" class=\"list-inline list-practice-area margin-b0\" style=\"display: grid;\">\n          <li>\n          <label class=\"ui-checkbox\">\n            <input type=\"checkbox\" ng-click=\"\" data=\"\" ng-model=\"ctrl.filterOptions.saveFilter\" class=\"ng-pristine ng-valid\">\n            <span class=\"\">Save Filters</span>\n          </label>\n          </li>\n          <li>\n          <label class=\"ui-checkbox\">\n            <input type=\"checkbox\" ng-click=\"\" data=\"\" ng-model=\"ctrl.filterOptions.saveColumnSetting\" class=\"ng-pristine ng-valid\">\n            <span class=\"\">Save Column Layout Settings</span>\n          </label>\n          </li>\n          <li>\n          <label class=\"ui-checkbox\">\n            <input type=\"checkbox\" ng-click=\"\" data=\"\" ng-model=\"ctrl.filterOptions.sorting\" class=\"ng-pristine ng-valid\">\n            <span class=\"\">Save Column Sorting</span>\n          </label>\n          </li>\n          <li>\n          <label class=\"ui-checkbox\">\n            <input type=\"checkbox\" ng-click=\"\" data=\"\" ng-model=\"ctrl.filterOptions.currentPositionInGrid\" class=\"ng-pristine ng-valid\">\n            <span class=\"\">Save Scroll Position</span>\n          </label>\n          </li>\n        </ul>\n        </div>\n      </div>\n      </form>\n    </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <center>\n    <button class=\"btn btn-info\" ng-click=\"ctrl.saveFilter(filterName)\">Save</button>\n    <button class=\"btn btn-gap-v btn-default\" ng-click=\"ctrl.cancel()\">Cancel</button>\n    </center>\n  </div>\n</script>\n"

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	module.exports = "<script type=\"text/ng-template\" id=\"delete-filters-modal.html\">\n  <div class=\"modal-header\">\n    <center>\n        <h3>Delete {{ctrl.type}}?</h3>\n        <h5 ng-if=\"ctrl.type === 'Private View'\">Are you sure you want to delete this {{ctrl.type}}?</h5>\n        <h5 ng-if=\"ctrl.type === 'Shared View'\">Type 'DELETE' in text field to confirm this {{ctrl.type}}?</h5>\n\n    </center>\n    </div>\n    <div ng-if=\"ctrl.type !== 'Private View'\" class=\"modal-body\">\n      <center>\n      <input class=\"form-control\" style=\"width: 50%\" type=\"text\" name=\"deleteConfirmation\" ng-model=\"ctrl.confirmationInput\" placeholder=\"DELETE\" required/>\n      </center>\n    </div>\n  <div class=\"modal-footer\">\n    <center>\n    <button class=\"btn btn-info\" ng-click=\"ctrl.confirmDelete()\">Yes</button>\n    <button class=\"btn btn-gap-v btn-default\" ng-click=\"ctrl.cancel()\">No</button>\n    </center>\n  </div>\n</script>\n"

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	module.exports = "<div uib-dropdown class=\"filters-action\">\n  <button\n    data-testid=\"saved-view-menu\"\n    uib-dropdown-toggle\n    class=\"btn\"\n    type=\"button\"\n    data-tooltip-check=\"Views\"\n  >\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      width=\"24\"\n      height=\"24\"\n      viewBox=\"0 0 20 15\"\n    >\n      <defs>\n        <style>\n          .st0 {\n            fill: #9d9d9d;\n          }\n        </style>\n      </defs>\n      <rect class=\"st0\" x=\"12\" width=\"6\" height=\"13\"></rect>\n      <rect\n        id=\"Rectangle_18_copy\"\n        data-name=\"Rectangle 18 copy\"\n        class=\"st0\"\n        width=\"9\"\n        height=\"2\"\n      ></rect>\n      <rect\n        id=\"Rectangle_18_copy_2\"\n        data-name=\"Rectangle 18 copy 2\"\n        class=\"st0\"\n        y=\"5\"\n        width=\"9\"\n        height=\"2\"\n      ></rect>\n      <rect\n        id=\"Rectangle_18_copy_3\"\n        data-name=\"Rectangle 18 copy 3\"\n        class=\"st0\"\n        y=\"10\"\n        width=\"9\"\n        height=\"2\"\n      ></rect>\n    </svg>\n  </button>\n  <ul\n    data-testid=\"saved-filter-list\"\n    uib-dropdown-menu\n    class=\"assigneAdminDropDownC savedfilterlist  dropdown-right saved-filters-width\"\n  >\n    <li role=\"presentation\" class=\"\">\n      <a\n        role=\"menuitem\"\n        tabindex=\"-1\"\n        ng-disabled=\"false\"\n        href=\"javascript://\"\n        class=\"text-purple\"\n        ng-show=\"true\"\n        ng-click=\"openSaveFilterModal()\"\n      >\n        Save Current View\n      </a>\n    </li>\n    <li role=\"presentation\" class=\"divider\"></li>\n    <li role=\"presentation\" class=\"dropdown-header\">Private</li>\n\n    <li\n      data-testid=\"private-saved-filter\"\n      id=\"{{savedFilter.id}}\"\n      class=\"dropdownfilter\"\n      ng-if=\"!savedFilter.isPublic\"\n      ng-repeat=\"savedFilter in savedFilters\"\n    >\n      <a\n        class=\"ag-grid-template-saved-filters-grid\"\n        ng-if=\"!savedFilter.isDefault\"\n        role=\"menuitem\"\n        tabindex=\"-1\"\n        ng-click=\"setFilter(savedFilter)\"\n        ng-class=\"{\n          'btn-viewfilter': !savedFilter.isApplied,\n          'selectedfilter': savedFilter.isApplied\n        }\"\n      >\n        <span class=\"padding-r10 pointer\">\n          <span\n            data-testid=\"default-view\"\n            ng-if=\"!savedFilter.default\"\n            ng-click=\"setDefaultViewFilter(savedFilter,true,$event)\"\n            class=\"show-on-hover\"\n          >\n            <img\n              style=\"width:17px;height: 17px;\"\n              src=\"/images/unfilledStarFilter.svg\"\n            />\n          </span>\n          <span\n            ng-if=\"savedFilter.default\"\n            ng-click=\"setDefaultViewFilter(savedFilter,false,$event)\"\n          >\n            <img\n              style=\"width:17px;height: 17px;\"\n              src=\"/images/filledStarFilter.svg\"\n            />\n          </span>\n        </span>\n        <!--  -->\n        <span\n          class=\"saved-filters-text\"\n          data-tooltip-check=\"{{savedFilter.name}}\"\n          >{{savedFilter.name}}</span\n        >\n        <span\n          data-testid=\"save-view\"\n          ng-click=\"openDeleteFilterModal('Private View', savedFilter, $event)\"\n          class=\"show-on-hover padding-L5 pointer\"\n          style=\"float:right\"\n        >\n          <i class=\"fa fa-trash-o\"></i>\n        </span>\n      </a>\n    </li>\n    <li role=\"presentation\" class=\"divider\"></li>\n    <li role=\"presentation\" class=\"dropdown-header\">Shared</li>\n\n    <li\n      data-testid=\"public-saved-filter\"\n      id=\"{{savedFilter.id}}\"\n      class=\"dropdownfilter\"\n      ng-if=\"savedFilter.isPublic\"\n      ng-repeat=\"savedFilter in savedFilters\"\n    >\n      <a\n        class=\"ag-grid-template-saved-filters-grid\"\n        ng-if=\"!savedFilter.isDefault\"\n        role=\"menuitem\"\n        tabindex=\"-1\"\n        ng-click=\"setFilter(savedFilter)\"\n        ng-class=\"{\n            'btn-viewfilter': !savedFilter.isApplied,\n            'selectedfilter': savedFilter.isApplied\n          }\"\n      >\n        <span class=\"padding-r10 pointer\">\n          <span\n            data-testid=\"default-view\"\n            ng-if=\"!savedFilter.default\"\n            ng-click=\"setDefaultViewFilter(savedFilter,true,$event)\"\n            class=\"show-on-hover\"\n          >\n            <img\n              style=\"width:18px;height: 18px;\"\n              src=\"/images/unfilledStarFilter.svg\"\n            />\n          </span>\n          <span\n            data-cy=\"defaultFilter\"\n            ng-if=\"savedFilter.default\"\n            ng-click=\"setDefaultViewFilter(savedFilter,false,$event)\"\n          >\n            <img\n              style=\"width:18px;height: 18px;\"\n              src=\"/images/filledStarFilter.svg\"\n            />\n          </span>\n        </span>\n        <!--  -->\n        <span\n          class=\"saved-filters-text\"\n          data-tooltip-check=\"{{savedFilter.name}}\"\n          >{{savedFilter.name}}</span\n        >\n        <span\n          data-testid=\"save-view\"\n          ng-click=\"openDeleteFilterModal('Shared View', savedFilter, $event)\"\n          class=\"show-on-hover padding-L5 pointer\"\n          style=\"float:right\"\n        >\n          <i class=\"fa fa-trash-o\"></i>\n        </span>\n      </a>\n    </li>\n    <li role=\"presentation\" class=\"divider\"></li>\n    <li\n      ng-if=\"savedFilter.showOnDropdown && savedFilter.isDefault\"\n      data-cy=\"{{savedFilter.id}}\"\n      id=\"{{savedFilter.id}}\"\n      class=\"dropdownfilter\"\n      ng-repeat=\"savedFilter in savedFilters\"\n    >\n      <a\n        class=\"ag-grid-template-saved-filters-grid\"\n        role=\"menuitem\"\n        tabindex=\"-1\"\n        ng-click=\"setFilter(savedFilter)\"\n        ng-class=\"{\n          'btn-viewfilter': !savedFilter.isApplied,\n          'selectedfilter': savedFilter.isApplied\n        }\"\n        ><span\n          class=\"saved-filters-text\"\n          data-tooltip-check=\"{{savedFilter.name}}\"\n          >{{savedFilter.name}}</span\n        >\n      </a>\n    </li>\n    <li\n      ng-if=\"savedFilters && savedFilters[1].showOnDropdown\"\n      role=\"presentation\"\n      class=\"divider\"\n    ></li>\n\n    <li role=\"presentation\">\n      <a role=\"menuitem\" tabindex=\"-1\" ng-click=\"expandCollapseGrid()\"\n        >Expand/Collapse All Rows</a\n      >\n    </li>\n    <li role=\"presentation\" style=\"margin-bottom: 0px !important;\">\n      <a role=\"menuitem\" tabindex=\"-1\" ng-click=\"resetColumnGrid()\"\n        >Reset Columns</a\n      >\n    </li>\n  </ul>\n\n  <add-ag-grid-filters></add-ag-grid-filters>\n  <delete-Ag-Grid-Filters></delete-Ag-Grid-Filters>\n</div>\n"

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\n  <div class=\"panel-body application-page bg-white\">\n    <span ng-if=\"groupList && groupList.length > 0\">\n      <group-Pipeline\n        group-list=\"groupList\"\n        grid-options=\"gridOptions\"\n      ></group-Pipeline\n    ></span>\n\n    <application-stages-setting\n      ng-if=\"isApplicationStagesSettingAllowed() && gridName=== 'application'\"\n      class=\"setting-container\"\n      hierarchial-application-stages=\"hierarchialApplicationStages\"\n      success-call-back=\"successCallBack(list,updateStageOnGrid)\"\n      all-application-stages=\"allApplicationStagesList\"\n    ></application-stages-setting>\n  </div>\n  <div class=\"panel-body bg-white margin-t-20\">\n    <div class=\"edit-application padding-b10\">\n      <div class=\"select-application\">\n        <div class=\"search-filter\">\n          <span class=\"search-form\">\n            <div class=\"form-group has-feedback\">\n              <label for=\"search\" class=\"sr-only\">Search</label>\n              <input\n                type=\"text\"\n                id=\"filter-text-box\"\n                placeholder=\"Search\"\n                class=\"form-control\"\n                data-ng-model=\"searchKeywords\"\n                data-ng-keyup=\"onFilterTextBoxChanged()\"\n                ng-model-options=\"{debounce: {'default': 500, 'blur': 0} }\"\n              />\n              <span\n                class=\"glyphicon glyphicon-search form-control-feedback\"\n              ></span>\n            </div>\n          </span>\n        </div>\n        <div class=\"saveFilter\">\n          <div class=\"displayFilter\">\n            <ul class=\"list-inline margin-b0 for-position\">\n              <li\n                ng-if=\"savedFilter.isDefault && !savedFilter.showOnDropdown\"\n                ng-repeat=\"savedFilter in savedFilters\"\n                class=\"btn-filters\"\n              >\n                <span\n                  class=\"btn\"\n                  ng-click=\"applyFavRules(savedFilter)\"\n                  ng-class=\"{\n                        'btn-viewfilter': !savedFilter.isApplied,\n                        'btn-selectedfilter': savedFilter.isApplied\n                      }\"\n                >\n                  <span\n                    ng-if=\"!savedFilter.isApplied && savedFilter.icon\"\n                    class=\"selected-filter-icon\"\n                  >\n                    <img\n                      src=\"{{savedFilter.icon}}\"\n                      alt=\"icon\"\n                      style=\"margin-bottom: 5px;\"\n                    />\n                  </span>\n                  <span\n                    ng-if=\"savedFilter.isApplied\"\n                    class=\"selected-filter-icon\"\n                  >\n                    <img\n                      src=\"/images/checkFilter.svg\"\n                      alt=\"icon\"\n                      style=\"margin-bottom: 5px;\"\n                    />\n                  </span>\n                  <span>{{savedFilter.name}}</span>\n                </span>\n              </li>\n            </ul>\n          </div>\n        </div>\n\n        <pqe-slider-dropdown\n          ng-if=\"gridActionsDirective && gridActionsDirective.pqeSlider\"\n          data=\"gridActionsDirective.pqeSlider\"\n        ></pqe-slider-dropdown>\n\n        <practice-Area-Dropdown\n          ng-if=\"gridActionsDirective && gridActionsDirective.practices\"\n          grid=\"true\"\n          button-id=\"gridActionsDirective.practices.buttonId\"\n          all-checked=\"true\"\n          icon-label=\"gridActionsDirective.practices.iconLabel\"\n          practice-areas-list=\"gridActionsDirective.practices.allPracticeAreaList\"\n          on-practice-change=\"gridOnChangePracticeArea($event,selectedPracticeArea)\"\n        ></practice-Area-Dropdown>\n\n        <div ng-if=\"actionsFunctions\" class=\"vertical-line\"></div>\n\n        <div\n          uib-dropdown\n          class=\"dropdown-application-actions\"\n          ng-if=\"multiSelectOptions && multiSelectOptions[0].count\"\n        >\n          <button\n            uib-dropdown-toggle\n            class=\"btn dropdown-selected\"\n            type=\"button\"\n            id=\"multiSelect menu1\"\n            data-tooltip-check=\"Selected rows\"\n          >\n            <span class=\"count-filter\">\n              <span> {{multiSelectOptions[0].count}} </span>\n              <svg\n                id=\"Layer_1\"\n                data-name=\"Layer 1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                width=\"19\"\n                height=\"19\"\n                viewBox=\"0 0 19 19\"\n              >\n                <path\n                  d=\"M16.26.1H2.74A2.65,2.65,0,0,0,.1,2.74V16.26A2.65,2.65,0,0,0,2.74,18.9H16.26a2.65,2.65,0,0,0,2.64-2.64V2.74A2.65,2.65,0,0,0,16.26.1Zm1,5.54-10,10a1,1,0,0,1-.66.27A.93.93,0,0,1,6,15.6L1.78,11.43a.91.91,0,0,1-.27-.65.93.93,0,0,1,.27-.65.92.92,0,0,1,1.3,0L6.6,13.65l9.31-9.31a.91.91,0,0,1,.65-.27.92.92,0,0,1,.92.92A.91.91,0,0,1,17.22,5.64Z\"\n                  class=\"st0\"\n                  style=\"fill:#9D9D9D\"\n                />\n              </svg>\n            </span>\n          </button>\n          <ul uib-dropdown-menu class=\"assigneAdminDropDownC\">\n            <li role=\"presentation\">\n              <a role=\"menuitem\" tabindex=\"-1\" ng-click=\"clearSelection()\"\n                >Clear Selection</a\n              >\n            </li>\n          </ul>\n        </div>\n\n        <application-stage-dropdown\n          ng-if=\"gridActionsDirective && gridActionsDirective.applicationStage && multiSelectOptions[0].count\"\n          data=\"gridActionsDirective.applicationStage\"\n          grid-options=\"gridOptions\"\n        ></application-stage-dropdown>\n\n        <application-status-dropdown\n          ng-if=\"multiSelectOptions && gridActionsDirective && gridActionsDirective.applicationStatus\"\n          data=\"gridActionsDirective.applicationStatus\"\n          grid-options=\"gridOptions\"\n        ></application-status-dropdown>\n\n        <div class=\"\">\n          <ul class=\"list-inline margin-b0 for-position\">\n            <li\n              class=\"grid-data-actions pointer\"\n              ng-repeat=\"fnc in gridDataActions\"\n              ng-if=\"fnc.icon && fnc.visible\"\n              ng-click=\"fnc.function(fnc.funcParameter,$event)\"\n              ng-right-click=\"fnc.rightClick()\"\n            >\n              <span data-tooltip-check=\"{{fnc.funcName}}\">\n                <img style=\"width:24px;height: 24px;\" src=\"{{fnc.icon}}\"\n              /></span>\n            </li>\n          </ul>\n        </div>\n\n        <div\n          ng-if=\"multipleSelectionActions.length\"\n          class=\"vertical-line\"\n        ></div>\n\n        <div class=\"\">\n          <ul class=\"list-inline margin-b0 for-position\">\n            <li\n              class=\"grid-data-actions pointer\"\n              ng-repeat=\"fnc in multipleSelectionActions\"\n              ng-if=\"fnc.icon && fnc.visible && fnc.funcName && (fnc.masterOnly || fnc.funcName !== 'Delete')\"\n              ng-click=\"fnc.function(fnc.funcParameter,$event)\"\n              ng-right-click=\"fnc.rightClick()\"\n            >\n              <span data-tooltip-check=\"{{fnc.funcName}}\">\n                <img style=\"width:24px;height: 24px;\" src=\"{{fnc.icon}}\"\n              /></span>\n            </li>\n          </ul>\n        </div>\n\n        <div\n          ng-if=\"activeActions.length && multipleSelectionActions.length\"\n          class=\"vertical-line\"\n        ></div>\n\n        <div class=\"\">\n          <ul class=\"list-inline margin-b0 for-position\">\n            <li\n              class=\"grid-data-actions pointer margin-rl2tb0\"\n              ng-repeat=\"fnc in activeActions\"\n              ng-if=\"fnc.icon && fnc.visible\"\n              ng-click=\"fnc.function(fnc.funcParameter,$event)\"\n              ng-right-click=\"fnc.rightClick()\"\n            >\n              <span data-tooltip-check=\"{{fnc.funcName}}\">\n                <img style=\"width:24px;height: 24px;\" src=\"{{fnc.icon}}\"\n              /></span>\n            </li>\n          </ul>\n        </div>\n\n        <assign-agent-dropdown\n          ng-if=\"multiSelectOptions && gridActionsDirective && gridActionsDirective.assignAgent\"\n          data=\"gridActionsDirective.assignAgent\"\n          grid-options=\"gridOptions\"\n        ></assign-agent-dropdown>\n\n        <div uib-dropdown class=\"filters-action\" ng-if=\"actionsFunctions\">\n          <button\n            data-testid=\"kebab-menu\"\n            uib-dropdown-toggle\n            class=\"btn\"\n            type=\"button\"\n            id=\"moreButton\"\n            style=\"margin: 0 !important;\"\n          >\n            <svg\n              xmlns=\"http://www.w3.org/2000/svg\"\n              width=\"24\"\n              height=\"24\"\n              viewBox=\"0 0 24 24\"\n            >\n              <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n              <path\n                class=\"st0\"\n                d=\"M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\"\n              />\n            </svg>\n          </button>\n          <ul uib-dropdown-menu class=\"assigneAdminDropDownC\">\n            <li\n              role=\"presentation\"\n              ng-repeat=\"fnc in actionsFunctions\"\n              ng-if=\"fnc.funcName && (fnc.masterOnly || fnc.funcName !== 'Mass Delete') && (fnc.masterOnly || fnc.funcName !== 'Delete')\"\n            >\n              <a\n                ng-class=\"{'disabled-actions-link': fnc.disabled}\"\n                role=\"menuitem\"\n                tabindex=\"-1\"\n                ng-right-click=\"fnc.rightClick()\"\n                ng-click=\"fnc.leftClick()\"\n                >{{fnc.funcName}}</a\n              >\n            </li>\n          </ul>\n        </div>\n      </div>\n\n      <div class=\"addNewFilter\">\n        <div\n          class=\"filters-action\"\n          data-testid=\"filter-menu\"\n          uib-dropdown\n          ng-if=\"filterCount>0\"\n        >\n          <button\n            uib-dropdown-toggle\n            ng-disabled=\" (filterCount>0) ?  false : true\"\n            class=\"btn\"\n            type=\"button\"\n            data-tooltip-check=\"Clear\"\n          >\n            <span class=\"count-filter\">\n              <span ng-if=\"filterCount>0\">{{filterCount}}</span>\n              <svg\n                id=\"Capa_1\"\n                data-name=\"Capa 1\"\n                xmlns=\"http://www.w3.org/2000/svg\"\n                width=\"24\"\n                height=\"24\"\n                viewBox=\"0 0 24 24\"\n              >\n                <rect\n                  x=\"9.4\"\n                  y=\"16.2\"\n                  width=\"5\"\n                  height=\"2.7\"\n                  class=\"st0\"\n                  style=\"fill:#9d9d9d\"\n                />\n                <rect\n                  x=\"0.2\"\n                  y=\"3.1\"\n                  width=\"23.4\"\n                  height=\"2.7\"\n                  class=\"st0\"\n                  style=\"fill:#9d9d9d\"\n                />\n                <polygon\n                  points=\"4.9 12.4 18.9 12.4 18.9 9.6 4.9 9.6 4.9 12.4\"\n                  class=\"st0\"\n                  style=\"fill:#9d9d9d\"\n                />\n                <polygon\n                  points=\"22.7 14.2 20.5 16.4 18.4 14.2 17.1 15.5 19.3 17.6 17.1 19.8 18.4 21.1 20.5 18.9 22.7 21.1 24 19.8 21.8 17.6 24 15.5 22.7 14.2\"\n                  style=\"fill:#b7333d\"\n                />\n              </svg>\n            </span>\n            <!-- <span class=\"caret\"></span> -->\n          </button>\n          <ul uib-dropdown-menu class=\"assigneAdminDropDownC dropdown-right\">\n            <li role=\"presentation\">\n              <a role=\"menuitem\" tabindex=\"-1\" ng-click=\"resetSearchFilter()\"\n                >Clear Search</a\n              >\n            </li>\n            <li role=\"presentation\">\n              <a role=\"menuitem\" tabindex=\"-1\" ng-click=\"resetOnlyFilter()\"\n                >Clear Filters</a\n              >\n            </li>\n            <li role=\"presentation\">\n              <a role=\"menuitem\" tabindex=\"-1\" ng-click=\"resetAllFilter()\"\n                >Clear All</a\n              >\n            </li>\n          </ul>\n        </div>\n\n        <ag-grid-filters\n          ng-if=\"gridOptions\"\n          grid-options=\"gridOptions\"\n          grid-Name=\"gridName\"\n          get-column-state-value=\"getColumnStateValue\"\n          saved-filters=\"savedFilters\"\n          set-filter-on-grid=\"applyFavRules(selectedFilter)\"\n        ></ag-grid-filters>\n\n        <div class=\"filters-action\" ng-click=\"openHelp()\" ng-if=\"helpTooltip\">\n          <button\n            class=\"btn dropdown-toggle dropdown-selected\"\n            style=\"margin-bottom: 5px;\"\n            type=\"button\"\n            id=\"menu1\"\n            data-tooltip-check=\"{{helpTooltip.name}}\"\n          >\n            <svg\n              xmlns=\"http://www.w3.org/2000/svg\"\n              width=\"24\"\n              height=\"24\"\n              viewBox=\"0 0 24 24\"\n            >\n              <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n              <path\n                class=\"st0\"\n                fill=\"#9D9D9D\"\n                d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z\"\n              />\n            </svg>\n          </button>\n        </div>\n      </div>\n    </div>\n    <div ng-if=\"gridName\" id=\"{{gridName}}\" class=\"ag-theme-material\"></div>\n    <div\n      ng-show=\"showCv.isShow\"\n      class=\"cvHalfDisplay col-md-4\"\n      data-testid=\"application-cv\"\n      id=\"myCV\"\n    >\n      <div class=\"headerCVDisplay\">\n        <span\n          ng-click=\"cvClose()\"\n          data-testid=\"close-application-cv\"\n          class=\"closeCv\"\n        >\n          <svg\n            version=\"1.1\"\n            id=\"Capa_1\"\n            width=\"30\"\n            height=\"23\"\n            xmlns=\"http://www.w3.org/2000/svg\"\n            xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n            x=\"0px\"\n            y=\"0px\"\n            viewBox=\"0 0 52 52\"\n            style=\"enable-background:new 0 0 52 52;\"\n            xml:space=\"preserve\"\n          >\n            <g>\n              <path\n                d=\"M26,0C11.664,0,0,11.663,0,26s11.664,26,26,26s26-11.663,26-26S40.336,0,26,0z M26,50C12.767,50,2,39.233,2,26\n\t\t\t\t\t\t\t\t   S12.767,2,26,2s24,10.767,24,24S39.233,50,26,50z\"\n              />\n              <path\n                d=\"M35.707,16.293c-0.391-0.391-1.023-0.391-1.414,0L26,24.586l-8.293-8.293c-0.391-0.391-1.023-0.391-1.414,0\n\t\t\t\t\t\t\t\t   s-0.391,1.023,0,1.414L24.586,26l-8.293,8.293c-0.391,0.391-0.391,1.023,0,1.414C16.488,35.902,16.744,36,17,36\n\t\t\t\t\t\t\t\t   s0.512-0.098,0.707-0.293L26,27.414l8.293,8.293C34.488,35.902,34.744,36,35,36s0.512-0.098,0.707-0.293\n\t\t\t\t\t\t\t\t   c0.391-0.391,0.391-1.023,0-1.414L27.414,26l8.293-8.293C36.098,17.316,36.098,16.684,35.707,16.293z\"\n              />\n            </g>\n          </svg>\n        </span>\n        <span class=\"closeCv\">\n          <i\n            ng-if=\"showCv.display\"\n            ng-click=\"downloadCV(showCv.path,showCv.applicationId,$event)\"\n            data-testid=\"download-application-cv\"\n            class=\"fa fa-download fa-2x\"\n            aria-hidden=\"true\"\n          ></i>\n        </span>\n      </div>\n      <span\n        us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n        spinner-key=\"spinner-resume\"\n        class=\"cvHalfDisplay spinner-static-center\"\n      ></span>\n      <iframe\n        ng-if=\"showCv.isDoc && showCv.display\"\n        frameborder=\"0\"\n        class=\"embedCV\"\n        type=\"application/pdf\"\n        ng-src=\"{{showCv.display}}\"\n      ></iframe>\n\n      <object\n        ng-if=\"!showCv.isDoc && showCv.display\"\n        data=\"{{showCv.display}}\"\n        class=\"embedCV\"\n        type=\"application/pdf\"\n      >\n        <iframe src=\"{{showCv.display}}\"></iframe>\n      </object>\n      <center>\n        <div class=\"showCv-isNotFound\" ng-if=\"showCv.isNotFound\">\n          <b>\n            Resume not found in S3 server\n          </b>\n        </div>\n      </center>\n    </div>\n  </div>\n\n  <help-Modal></help-Modal>\n  <candidate-profile-modal />\n</div>\n"

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	module.exports = "<script type=\"text/ng-template\" id=\"help-modal.html\">\n  <div class=\"modal-header\">\n  \t<div>\n  \t\t<center>\n  \t\t  <h3>{{ctrl.helpModal.name}}</h3>\n  \t\t</center>\n  \t</div>\n  </div>\n  <div class=\"modal-body\">\n  \t<div ng-bind-html=ctrl.helpModal.content></div>\n\n  </div>\n  <div class=\"modal-footer\">\n  \t\t<center>\n  \t\t\t  <button class=\"closeDescriptionbtn\" ng-click=\"ctrl.cancel()\">Close</button>\n  \t\t</center>\n  \t</div>\n</script>\n"

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	module.exports = "<script type=\"text/ng-template\" id=\"application-agent-modal.html\">\n   <div class=\"modal-header\">\n     <center>\n       <h3>Application Followers</h3>\n     </center>\n   </div>\n   <div class=\"modal-body\">\n    <b>Updates to this application will be notified to:</b>\n       <div class=\"modal-row\" data-testid=\"current-candidate-consultant\">\n         <b>Current Candidate Agent: </b>{{ctrl.consultant.candidateAgentEmail}}\n       </div>\n       <br/>\n       <div class=\"modal-row\" data-testid=\"current-candidate-employer\">\n         <b>Current Employer Agent: </b>{{ctrl.consultant.employerAgentEmail}}\n       </div>\n       <br/>\n\n       <br/>\n  <b>and Application Followers: </b>\n       <div class=\"modal-row\" style=\"width: 50%\">\n         <span\n           data-cy=\"follower-dropdown\"\n           isteven-multi-select\n           class=\"position-relative scroll500px full-width-multiselect\"\n           input-model=\"ctrl.agentsList\"\n           output-model=\"selectedAgent\"\n           button-label=\"email\"\n           item-label=\"email maker\"\n           helper-elements=\"\"\n           max-labels=\"1\"\n           on-item-click=\"ctrl.selectedAgent(data)\"\n           tick-property=\"ticked\"\n           style=\"max-width: 175px;\"\n         >\n         </span>\n       </div>\n   </div>\n   <div class=\"modal-footer\">\n     <center>\n       <button\n         class=\"btn btn-info\"\n         ng-click=\"ctrl.updateApplicationAgent(selectedAgent)\"\n       >\n         Save\n       </button>\n       <button class=\"btn btn-gap-v btn-default\" ng-click=\"ctrl.cancel()\">\n         Cancel\n       </button>\n     </center>\n   </div>\n</script>\n"

/***/ }),
/* 447 */
/***/ (function(module, exports) {

	module.exports = "<script type=\"text/ng-template\" id=\"application-history-modal.html\">\n  <div class=\"modal-header\">\n    <center>\n      <h3>Application History</h3>\n    </center>\n  </div>\n  <div class=\"modal-body col-md-12 clearfix\">\n    <div class=\"padding-t5 padding-r15 pull-right\">\n      <span class=\"center email-alert-on\">\n        <span ng-show=\"ctrl.isNote\">All history</span>\n        <strong ng-show=\"!ctrl.isNote\">All history</strong>\n      </span>\n\n      <label class=\"switch switch-info switch-sponsorship\">\n        <input\n          type=\"checkbox\"\n          ng-model=\"ctrl.isNote\"\n          ng-change=\"ctrl.toggleHistory()\"\n        />\n\n        <i></i>\n      </label>\n\n      <span class=\"center email-alert-pause\">\n        <strong ng-show=\"ctrl.isNote\">Internal Notes</strong>\n        <span ng-show=\"!ctrl.isNote\">Internal Notes</span>\n      </span>\n    </div>\n    <br />\n    <div class=\"contentTimeline\">\n      <div class=\"timeline\">\n        <span ng-repeat=\"history in ctrl.allApplication\">\n          <div\n            class=\"box left\"\n            data-testid=\"history-{{$index}}\"\n            id=\"{{$index}}\"\n            ng-if=\"!($index%2)\"\n          >\n            <div class=\"content\" style=\"padding-left: 10px;\">\n              <span\n                ng-if=\"history.isNote && !history.isEditable && !ctrl.enableMasterGrid\"\n                style=\"position: absolute;right: 5px;top: 5px;\"\n              >\n                <a\n                  href=\"\"\n                  data-testid=\"edit-note\"\n                  class=\"btn btn-noline-info btn-xs\"\n                  ng-click=\"ctrl.editNote(history)\"\n                >\n                  <i class=\"fa fa-pencil\"></i>\n                </a>\n                <a\n                  href=\"\"\n                  data-testid=\"delete-note\"\n                  class=\"btn btn-noline-info btn-xs\"\n                  ng-click=\"ctrl.deleteNoteModal(history.id)\"\n                >\n                  <i class=\"glyphicon glyphicon-trash\"></i>\n                </a>\n              </span>\n              <span\n                ng-if=\"history.isNote && history.isEditable && !ctrl.enableMasterGrid\"\n                style=\"position: absolute;right: 5px;top: 5px;\"\n              >\n                <a\n                  href=\"\"\n                  data-testid=\"save-note\"\n                  class=\"btn btn-noline-info btn-xs\"\n                  ng-click=\"ctrl.updateNote(history)\"\n                >\n                  <i class=\"fa fa-floppy-o\"></i>\n                </a>\n                <a\n                  href=\"\"\n                  class=\"btn btn-noline-info btn-xs\"\n                  ng-click=\"ctrl.discardNote(history)\"\n                >\n                  <i class=\"fa fa-times\"></i>\n                </a>\n              </span>\n              <span>\n                <h4 style=\"display:inline\">\n                  {{history.created | date:'dd MMM yyyy'}}\n                </h4>\n                <p style=\"display:inline\">\n                  &nbsp; {{history.created | date:'HH:mm'}}\n                </p>\n                <br />\n              </span>\n              <br />\n              <p ng-if=\"!history.isNote && history.typeId==='APPLICATION_UPDATE'\" class=\"updatedby\">\n                Application: <strong>{{history.keyName}} </strong>  updated <span ng-if=\"history.old\">from\n                  <strong>{{history.old}} </strong> </span>To\n                  <strong>{{history.current}}</strong>\n              </p>\n              <p ng-if=\"!history.isNote && history.typeId==='APPLICATION_FOLLOW_UPDATE'\" class=\"updatedby\">\n                Application: <strong>Agent Followers </strong>                 \n                <span ng-if=\"history.payload.follow\">updated </span> \n                <span ng-if=\"!history.payload.follow\">deleted </span> \n                  To <strong>{{history.applicationAgent}}</strong>\n              </p>\n              <p ng-if=\"!history.isNote && history.typeId==='APPLICATION_CREATE'\" class=\"updatedby\">\n                This Application was made from\n                <strong>{{ctrl.source}} </strong>\n              </p>\n              <p class=\"updatedby\">\n                <span ng-if=\"history.isNote && !history.isEditable\">{{history.body}}</span\n                ><textarea\n                  class=\"width-100p\"\n                  ng-if=\"history.isEditable\"\n                  ng-model=\"history.temporaryNote\"\n                  type=\"text\"\n                >\n                </textarea>\n              </p>\n              <p ng-if=\"history.author && history.typeId!=='APPLICATION_CREATE'\" class=\"updatedby\">\n                by : {{history.author}}\n              </p>\n            </div>\n          </div>\n          <div\n            class=\"box right\"\n            data-testid=\"history-{{$index}}\"\n            id=\"{{$index}}\"\n            ng-if=\"$index%2\"\n          >\n            <div class=\"content\" style=\"padding-left: 10px;\">\n              <span\n                ng-if=\"history.isNote && !history.isEditable && !ctrl.enableMasterGrid\"\n                style=\"position: absolute;right: 5px;top: 5px;\"\n              >\n                <a\n                  href=\"\"\n                  data-testid=\"edit-note\"\n                  class=\"btn btn-noline-info btn-xs\"\n                  ng-click=\"ctrl.editNote(history)\"\n                >\n                  <i class=\"fa fa-pencil\"></i>\n                </a>\n                <a\n                  href=\"\"\n                  data-testid=\"delete-note\"\n                  class=\"btn btn-noline-info btn-xs\"\n                  ng-click=\"ctrl.deleteNoteModal(history.id)\"\n                >\n                  <i class=\"glyphicon glyphicon-trash\"></i>\n                </a>\n              </span>\n              <span\n                ng-if=\"history.isNote && history.isEditable && !ctrl.enableMasterGrid\"\n                style=\"position: absolute;right: 5px;top: 5px;\"\n              >\n                <a\n                  href=\"\"\n                  data-testid=\"save-note\"\n                  class=\"btn btn-noline-info btn-xs\"\n                  ng-click=\"ctrl.updateNote(history)\"\n                >\n                  <i class=\"fa fa-floppy-o\"></i>\n                </a>\n                <a\n                  href=\"\"\n                  class=\"btn btn-noline-info btn-xs\"\n                  ng-click=\"ctrl.discardNote(history)\"\n                >\n                  <i class=\"fa fa-times\"></i>\n                </a>\n              </span>\n              <span>\n                <h4 style=\"display:inline\">\n                  {{history.created | date:'dd MMM yyyy'}}\n                </h4>\n                <p style=\"display:inline\">\n                  &nbsp; {{history.created | date:'HH:mm'}}\n                </p>\n                <br />\n              </span>\n              <br />\n              <p ng-if=\"!history.isNote && history.typeId==='APPLICATION_UPDATE'\" class=\"updatedby\">\n                Application: <strong>{{history.keyName}} </strong>  updated <span ng-if=\"history.old\">from\n                  <strong>{{history.old}} </strong> </span>To\n                  <strong>{{history.current}}</strong>\n              </p>\n              <p ng-if=\"!history.isNote && history.typeId==='APPLICATION_FOLLOW_UPDATE'\" class=\"updatedby\">\n                Application: <strong>Agent Followers </strong>\n                  <span ng-if=\"history.payload.follow\">updated </span> \n                  <span ng-if=\"!history.payload.follow\">deleted </span>\n                  To <strong>{{history.applicationAgent}}</strong>\n              </p>\n              <p ng-if=\"!history.isNote && history.typeId==='APPLICATION_CREATE'\" class=\"updatedby\">\n                This Application was made from\n                <strong>{{ctrl.source}} </strong>\n              </p>\n              <p class=\"updatedby\">\n                <span ng-if=\"history.isNote && !history.isEditable\">{{history.body}}</span\n                ><textarea\n                  class=\"width-100p\"\n                  ng-if=\"history.isEditable\"\n                  ng-model=\"history.temporaryNote\"\n                  type=\"text\"\n                ></textarea>\n              </p>\n              <p ng-if=\"history.author && history.typeId!=='APPLICATION_CREATE'\" class=\"updatedby\">\n                by : {{history.author}}\n              </p>\n            </div>\n          </div>\n        </span>\n      </div>\n    </div>\n    <div class=\"internalNote\" ng-if=\"!ctrl.enableMasterGrid\">\n      <textarea\n        name=\"workDescription\"\n        id=\"\"\n        class=\"textarea margin-b15 margin-t15 margin-l30 margin-r15 ng-pristine col-md-10 ng-valid\"\n        data-ng-model=\"ctrl.newNote\"\n        placeholder=\"Internal Note\"\n      ></textarea>\n      <span\n        ng-class=\"!ctrl.newNote ? 'disablespan margin-t25':'sendbuton margin-t25'\"\n        ng-disabled=\"!ctrl.newNote\"\n        ng-click=\"ctrl.createNote() && !newNote\"\n      >\n        <svg\n          xmlns=\"http://www.w3.org/2000/svg\"\n          version=\"1\"\n          style=\"\"\n          viewBox=\"0 0 24 24\"\n          width=\"25\"\n          height=\"25\"\n          enable-background=\"new 0 0 24 24\"\n        >\n          <path\n            d=\"M 2 3 L 2 10.8125 L 18 12 L 2 13.1875 L 2 21 L 22 12 L 2 3 z\"\n          />\n        </svg>\n      </span>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <center>\n      <button class=\"btn btn-info\" ng-click=\"ctrl.close()\">Close</button>\n    </center>\n  </div>\n  <script type=\"text/ng-template\" id=\"delete-internal-note-modal.html\">\n  <div class=\"modal-header\">\n    <center>\n      <h3>Delete Internal Note?</h3>\n    </center>\n  </div>\n  <div class=\"modal-footer\">\n    <center>\n      <button class=\"btn btn-info\" ng-click=\"deleteNoteCtrl.confirmDelete()\">Yes</button>\n      <button class=\"btn btn-gap-v btn-default\" ng-click=\"deleteNoteCtrl.cancel()\">No</button>\n    </center>\n  </div>\n</script>\n</script>\n"

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	module.exports = "<span>\n  <!-- ng-if=\"!position.isApplied\" -->\n\n  <span tooltip=\"{{position.tooltip}}\">\n    <button\n      class=\"btn btn-info btn-job-apply\"\n      ng-disabled=\"position.isApplied || (candidate.resumes.length === 0) || candidate.approvalStatus==='Locked'\"\n      ng-click=\"shareProfile(job,$event)\"\n      firmName=\"{{position.firm_Name}}\"\n      firmID=\"{{position.firmFirmID}}\"\n      firmLogo=\"{{position.picSrc}}\"\n      data-testid=\"applyButton{{job.id}}\"\n    >\n      <span ng-if=\"!position.isApplied\" class=\"fa fa-plus\"></span>\n      {{position.isApplied?'Profile Shared':'Interested'}}\n    </button>\n  </span>\n\n  <script type=\"text/ng-template\" id=\"application-modal.html\">\n    <div class=\"modal-header\">\n      <center>\n        <h3>{{'jobApplyModalHeading'|translate}}</h3>\n      </center>\n    </div>\n\n    <div data-testid=\"applyModal\" class=\"modal-body\">\n\n      <center>\n        <div class=\"row\">\n          <alert type=\"danger\" class=\"col-md-6 col-md-offset-3 alert-position\" ng-show=\"showOnError\">\n            <strong>\n              <center>{{alertMsg}}</center>\n            </strong>\n          </alert>\n        </div>\n\n        <div class=\"row\">\n          <div class=\"col-md-3 col-md-offset-2\">\n            <img src=\"{{candidate.user.logoSrc}}\" height=\"110\" width=\"110\" alt=\"{{candidate.user.firstName}}\">\n          </div>\n\n          <div class=\"col-md-6 applier-detail\">\n            <h3 style=\"margin-top:10px\">\n              <strong>{{candidate.user.firstName}} {{candidate.user.lastName}}</strong>\n            </h3>\n            <h5>{{candidate.employer.name}}</h5>\n            <h5>{{candidate.school.name}}</h5>\n          </div>\n        </div>\n\n        <hr>\n\n        <div class=\"row\">\n          <div class=\"row\">\n            <center>\n              <div class=\"col-md-3 col-md-offset-2\">\n                <div class=\"row\">\n                  <img align=\"center\" class=\"img-circle list-firm-logo\" alt=\"{{position.employer.name}}\" height=\"50%\" width=\"30%\" src=\"{{position.employer.logoSrc}}\">\n                  <div align=\"center\">\n                    <h4 ng-if=\"!suggestedFirm\">\n                      <b>{{position.employer.name}}</b>\n                    </h4>\n                  </div>\n                </div>\n              </div>\n            </center>\n            <div class=\"col-md-5 applier-detail padding-l18\">\n                <h4 ng-if=\"suggestedFirm\">\n                  <b>{{position.employer.name}}</b>\n                </h4>\n              <h4 style=\"margin-bottom:0px\">\n                <strong>{{position.title}}</strong>\n              </h4>\n              <span ng-if=\"!suggestedFirm\">Required Experience {{position.lawPreferences.minPqe <= 0 ?\"NQ\":position.lawPreferences.minPqe}}{{position.lawPreferences.maxPqe == 11?\"+\":\"-\"+position.lawPreferences.maxPqe}} year(s)</span>\n              <br>\n              <div ng-if=\"!user.isAdmin\" class=\"location-cloud\">\n                <h5 ng-repeat=\"location in position.locations\" class=\"label label-info text-uppercase\"                       ng-style=\"locationBackgroundColor(location.color)\"\n                >{{location.name}}</h5>\n            </div>\n\n            </div>\n          </div>\n        </div>\n        <hr ng-if=\"candidate.resumes.length > 0\">\n        <div class=\"row\" ng-if=\"candidate.resumes.length > 0\">\n          <div class=\"col-md-3 col-md-offset-2\">\n            <h5>Select a CV to share</h5>\n          </div>\n          <div class=\"col-md-7\">\n            <span class=\"ui-select\" style=\"width:100%;\">\n              <select class=\"select-cv\" style=\" min-width:0px; padding-top: 6px;padding-bottom: 6px; width:100%;\" ng-model=\"modalData.resume\"\n                required>\n                <option ng-value=\"resume.id\" ng-repeat=\"resume in candidate.resumes\" ng-selected=\"modalData.resume === resume.id\">{{resume.name}}</option>\n              </select>\n            </span>\n          </div>\n        </div>\n        <hr>\n        <br>\n        <div class=\"row\">\n          <span class=\"col-md-5 text-right\">Do you have the right to work in this location without sponsorship?</span>\n          <span ng-show=\"true\" ng-init=\"\" class=\"col-md-6 text-left padding-t10 display-inline-block padding-l25\">\n            <span>\n\n              <span class=\"center email-alert-on\">\n                <span ng-show=\"!modalData.sponsorship\">Yes</span>\n                <strong ng-show=\"modalData.sponsorship\">Yes</strong>\n              </span>\n\n              <label class=\"switch switch-info switch-sponsorship\">\n                <input ng-model=\"modalData.sponsorship\" type=\"checkbox\" />\n                <i></i>\n              </label>\n\n              <span class=\"center email-alert-pause\">\n                <strong ng-show=\"!modalData.sponsorship\">No</strong>\n                <span ng-show=\"modalData.sponsorship\">No</span>\n              </span>\n\n              &nbsp; &nbsp;\n              <a href=\"\" tooltip=\"Switch slider to No if you DO NOT have the right to work in this location without sponsorship\" tooltip-placement=\"top\">\n                <span class=\"badge badge-grey email-pause-info\">\n                  <i class=\"fa fa-info\"></i>\n                </span>\n              </a>\n            </span>\n          </span>\n        </div>\n      </center>\n    </div>\n\n    <div class=\"modal-footer-apply-job\">\n      <center>\n        <div class=\"apply-job-info\">\n          <span>By clicking Share Profile below you confirm that you have not applied to this firm directly or via a recruitment\n            agency within the last 6 months.</span>\n        </div>\n        <button class=\"btn btn-info\" ng-click=\"applyForApplication()\">{{'browseFirms.applyToJobPopUpBtn.label'|translate}}</button>\n        <button class=\"btn btn-default\" ng-click=\"cancel()\">{{'btn.cancel.label'|translate}}</button>\n      </center>\n    </div>\n  </script>\n</span>\n"

/***/ }),
/* 449 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <p\n    data-cy=\"application-setting-menu\"\n    class=\"setting-text\"\n    ng-click=\"openStageSettingModal($event)\"\n  >\n    <i class=\"fa fa-cog fa-2x\" aria-hidden=\"true\"></i>\n  </p>\n  <script type=\"text/ng-template\" id=\"application-stages-setting-modal.html\">\n    <div class=\"modal-header right-modal-header\">\n      <div>\n        <h3>Application Settings</h3>\n      </div>\n    </div>\n    <div class=\"modal-body right-modal-body col-md-12\">\n      <ul\n        dnd-list=\"applicationStagesList\"\n        dnd-allowed-types=\"['stage']\"\n        dnd-external-sources=\"true\"\n        class=\"application-setting-wrapper\"\n      >\n        <li\n          id=\"{{stage.id}}\"\n          ng-repeat=\"stage in applicationStagesList\"\n          class=\"application-stage\"\n          ng-mouseleave=\"stage.displayIcon=false\"\n          ng-mouseover=\"stage.displayIcon=true\"\n        >\n          <div class=\"container-element box box-blue\">\n            <div\n              class=\"stages-heading main-stages-heading\"\n              ng-if=\"!stage.isEditable\"\n            >\n              <span\n                dnd-draggable=\"stage\"\n                dnd-type=\"'stage'\"\n                dnd-moved=\"applicationStagesList.splice($index, 1)\"\n              >\n                <svg\n                  data-name=\"Layer 1\"\n                  xmlns=\"http://www.w3.org/2000/svg\"\n                  width=\"12\"\n                  height=\"10\"\n                  viewBox=\"0 0 6 10\"\n                >\n                  <ellipse cx=\"1.22\" cy=\"1.24\" rx=\"1.2\" ry=\"1.19\" fill=\"#888\" />\n                  <ellipse cx=\"4.78\" cy=\"1.24\" rx=\"1.2\" ry=\"1.19\" fill=\"#888\" />\n                  <ellipse cx=\"1.22\" cy=\"4.99\" rx=\"1.2\" ry=\"1.19\" fill=\"#888\" />\n                  <circle cx=\"4.79\" cy=\"4.99\" r=\"1.19\" fill=\"#888\" />\n                  <ellipse cx=\"1.22\" cy=\"8.76\" rx=\"1.2\" ry=\"1.19\" fill=\"#888\" />\n                  <ellipse cx=\"4.78\" cy=\"8.76\" rx=\"1.2\" ry=\"1.19\" fill=\"#888\" />\n                </svg>\n                <span class=\"togglelist\" ng-click=\"expandStage(stage)\">\n                  {{stage.name}} &nbsp;<i\n                    ng-if=\"!stage.expand\"\n                    class=\"fa fa-caret-down\"\n                    style=\"font-size:10px\"\n                  ></i\n                  >&nbsp;\n                  <i\n                    ng-if=\"stage.expand\"\n                    class=\"fa fa-caret-up\"\n                    style=\"font-size:10px\"\n                  ></i>\n                </span>\n              </span>\n              <span ng-show=\"stage.displayIcon\" class=\"heading-actions\">\n                <i\n                  data-cy=\"edit-stage\"\n                  class=\"fa fa-pencil\"\n                  ng-click=\"onEditClick(stage)\"\n                ></i>\n                <i\n                  data-cy=\"delete-stage\"\n                  class=\"glyphicon glyphicon-trash\"\n                  ng-click=\"deleteStage('parent',stage,applicationStagesList,$index,$event)\"\n                ></i>\n              </span>\n            </div>\n            <!-- Edit Section Start -->\n            <section class=\"stage-edit\" ng-if=\"stage.isEditable\">\n              <div class=\"stage-edit-inputs\">\n                <input\n                  type=\"text\"\n                  class=\"custom-input parent-input\"\n                  value=\"{{stage.name}}\"\n                  ng-model=\"stage.temporaryName\"\n                />\n              </div>\n              <div class=\"action-buttons\">\n                <a\n                  data-cy=\"update-stage\"\n                  class=\"fa fa-floppy-o\"\n                  ng-click=\"updateStage(stage);\"\n                ></a>\n                <a class=\"close state-close\" ng-click=\"onInputFieldCloseClick(stage)\"\n                  >×</a\n                >\n              </div>\n            </section>\n            <!-- Edit Section End -->\n\n            <ul\n              dnd-list=\"stage.children\"\n              dnd-allowed-types=\"['subStage']\"\n              dnd-horizontal-list=\"false\"\n              dnd-external-sources=\"true\"\n              ng-show=\"stage.expand\"\n              class=\"itemlist\"\n            >\n              <!-- Child Stage Start -->\n\n              <li\n                id=\"{{subStage.id}}\"\n                ng-repeat=\"subStage in stage.children\"\n                ng-mouseleave=\"subStage.displayIcon=false\"\n                ng-mouseover=\"subStage.displayIcon=true\"\n                class=\"childState\"\n                ng-style=\"colorChildren(subStage.color)\"\n              >\n                <section\n                  ng-hide=\"subStage.isEditable || (stage.newSubStage && $last)\"\n                  class=\"stages-heading itemlist-child\"\n                >\n                  <div\n                    dnd-draggable=\"subStage\"\n                    dnd-type=\"'subStage'\"\n                    dnd-moved=\"stage.children.splice($index, 1)\"\n                  >\n                    <svg\n                      data-name=\"Layer 1\"\n                      xmlns=\"http://www.w3.org/2000/svg\"\n                      width=\"12\"\n                      height=\"10\"\n                      viewBox=\"0 0 6 10\"\n                    >\n                      <ellipse\n                        cx=\"1.22\"\n                        cy=\"1.24\"\n                        rx=\"1.2\"\n                        ry=\"1.19\"\n                        fill=\"#888\"\n                      />\n                      <ellipse\n                        cx=\"4.78\"\n                        cy=\"1.24\"\n                        rx=\"1.2\"\n                        ry=\"1.19\"\n                        fill=\"#888\"\n                      />\n                      <ellipse\n                        cx=\"1.22\"\n                        cy=\"4.99\"\n                        rx=\"1.2\"\n                        ry=\"1.19\"\n                        fill=\"#888\"\n                      />\n                      <circle cx=\"4.79\" cy=\"4.99\" r=\"1.19\" fill=\"#888\" />\n                      <ellipse\n                        cx=\"1.22\"\n                        cy=\"8.76\"\n                        rx=\"1.2\"\n                        ry=\"1.19\"\n                        fill=\"#888\"\n                      />\n                      <ellipse\n                        cx=\"4.78\"\n                        cy=\"8.76\"\n                        rx=\"1.2\"\n                        ry=\"1.19\"\n                        fill=\"#888\"\n                      />\n                    </svg>\n                    <span>\n                      {{subStage.name}} </span\n                    >&nbsp;<span\n                      ><b>{{subStage.isDefault?\"(DEFAULT)\":\"\"}}</b></span\n                    >\n                  </div>\n                  <span ng-show=\"subStage.displayIcon\" class=\"heading-actions\">\n                    <i\n                      class=\"fa fa-pencil\"\n                      ng-click=\"onEditClick(subStage);\"\n                      ;\n                    ></i>\n                    <i\n                      class=\" glyphicon glyphicon-trash\"\n                      ng-click=\"deleteStage('child',subStage,stage.children,$index,$event)\"\n                    ></i>\n                  </span>\n                </section>\n                <!-- New Section Start -->\n                <section\n                  class=\"state-edit itemlist-child-edit\"\n                  ng-if=\"(stage.newSubStage && $last)\"\n                >\n                  <input\n                    type=\"text\"\n                    placeholder=\"Sub Stage name\"\n                    class=\"custom-input\"\n                    value=\"{{subStage.name}}\"\n                    ng-model=\"subStage.name\"\n                  />\n                  <div\n                    class=\"childcolor\"\n                    style=\"background-color:transparent\"\n                    colorpicker\n                    ng-model=\"subStage.color\"\n                  >\n                    <svg\n                      aria-hidden=\"true\"\n                      focusable=\"false\"\n                      data-prefix=\"fas\"\n                      style=\"color: {{subStage.color}}; background-color:transparent\"\n                      data-icon=\"palette\"\n                      class=\"svg-inline--fa fa-palette fa-w-16\"\n                      role=\"img\"\n                      xmlns=\"http://www.w3.org/2000/svg\"\n                      viewBox=\"0 0 512 512\"\n                    >\n                      <path\n                        fill=\"currentColor\"\n                        d=\"M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z\"\n                      ></path>\n                    </svg>\n                  </div>\n                  <span class=\"archive-input\"\n                    ><input\n                      type=\"checkbox\"\n                      checked=\"{{subStage.isDefault}}\"\n                      ng-disabled=\"subStage.isDefault\"\n                      ng-model=\"subStage.isDefault\"\n                    />\n                    Default</span\n                  >\n                  <div class=\"action-buttons\">\n                    <a\n                      data-cy=\"add-sub-stage\"\n                      class=\"fa fa-floppy-o\"\n                      ng-click=\"insertSubStage(subStage,stage)\"\n                    ></a>\n                    <a class=\"close state-close\" ng-click=\"closeSubStage(stage)\"\n                      >×</a\n                    >\n                  </div>\n                </section>\n                <!-- New Section End -->\n\n                <!-- Edit Section Start -->\n                <section\n                  class=\"state-edit itemlist-child-edit\"\n                  ng-show=\"subStage.isEditable\"\n                >\n                  <input\n                    type=\"text\"\n                    class=\"custom-input\"\n                    value=\"{{subStage.name}}\"\n                    ng-model=\"subStage.temporaryName\"\n                  />\n                  <div\n                    class=\"childcolor\"\n                    style=\"background-color:transparent\"\n                    colorpicker\n                    ng-model=\"subStage.temporaryColor\"\n                  >\n                    <svg\n                      aria-hidden=\"true\"\n                      focusable=\"false\"\n                      data-prefix=\"fas\"\n                      style=\"color: {{subStage.temporaryColor}}; background-color:transparent\"\n                      data-icon=\"palette\"\n                      class=\"svg-inline--fa fa-palette fa-w-16\"\n                      role=\"img\"\n                      xmlns=\"http://www.w3.org/2000/svg\"\n                      viewBox=\"0 0 512 512\"\n                    >\n                      <path\n                        fill=\"currentColor\"\n                        d=\"M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z\"\n                      ></path>\n                    </svg>\n                  </div>\n                  <span class=\"archive-input\"\n                    ><input\n                      type=\"checkbox\"\n                      checked=\"{{subStage.isDefault}}\"\n                      ng-disabled=\"subStage.isDefault\"\n                      ng-model=\"subStage.temporaryIsDefault\"\n                    />\n                    Default</span\n                  >\n\n                  <div class=\"action-buttons\">\n                    <a\n                      class=\"fa fa-floppy-o\"\n                      ng-click=\"updateStage(subStage)\"\n                    ></a>\n                    <a\n                      class=\"close state-close\"\n                      ng-click=\"onInputFieldCloseClick(subStage)\"\n                      >×</a\n                    >\n                  </div>\n                </section>\n                <!-- Edit Section End -->\n              </li>\n              <!-- Child State End-->\n            </ul>\n            <div ng-if=\"stage.expand\" class=\"add-state-button-wrapper\">\n              <button\n                ng-show=\"stage.expand\"\n                class=\"add-state-button\"\n                type=\"button\"\n                ng-if=\"!stage.newSubStage\"\n                ng-click=\"addNewSubStage(stage)\"\n              >\n                <i class=\"fa fa-plus\" id=\"edit-newSubStage\"></i>\n                <span class=\"text-edit\" id=\"edit-newSubStage\"\n                  >Add Sub-Stage&nbsp;</span\n                >\n              </button>\n            </div>\n          </div>\n        </li>\n        <!-- Parent Stage End-->\n      </ul>\n      <div ng-if=\"parentStage.newStage;\" class=\"application-form-top\">\n        <input\n          class=\"custom-input parent-input\"\n          id=\"input-newParentStage\"\n          placeholder=\"Stage Name\"\n          type=\"\"\n          ng-model=\"parentStage.name\"\n        />\n        <span class=\"add-stage-button\">\n          <div class=\"action-buttons\">\n            <a\n              data-cy=\"add-stage\"\n              class=\"fa fa-floppy-o\"\n              ng-click=\"insertParentStage(parentStage)\"\n            ></a>\n            <a class=\"close state-close\" ng-click=\"onInputFieldCloseClick(parentStage)\"\n              >×</a\n            >\n          </div>\n        </span>\n      </div>\n    </div>\n    <div class=\"modal-footer right-modal-footer\">\n      <button\n        ng-if=\"!parentStage.newStage;\"\n        class=\"addStageBtn btn btn-info\"\n        ng-click=\"addStageShow(parentStage)\"\n      >\n        <i class=\"fa fa-plus\"></i>Add Stage\n      </button>\n      <div class=\"content\">\n        <button\n          class=\"savebtn btn btn-info\"\n          ng-click=\"updateStagesOrder(applicationStagesList); !inputField;\"\n        >\n          Save\n        </button>\n        <button class=\"closebtn btn\" ng-click=\"cancelModal();\">Close</button>\n      </div>\n    </div>\n  </script>\n  <script type=\"text/ng-template\" id=\"deleteStageModal.html\">\n    <div class=\"modal-header\">\n      <center>\n        <h3>Delete Stage ?</h3>\n        <h5>Are you sure you want to delete this Stage ?</h5>\n      </center>\n    </div>\n    <div class=\"modal-footer\">\n      <center>\n        <button class=\"btn btn-info\" ng-click=\"confirmDelete()\">Yes</button>\n        <button class=\"btn btn-gap-v btn-isDefault\" ng-click=\"cancelDelete()\">\n          No\n        </button>\n      </center>\n    </div>\n  </script>\n</div>\n"

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	module.exports = "<div uib-dropdown class=\"filters-action\">\n  <style>\n    .multi-select-dropdown .dropdown-toggle,\n    .multi-select-dropdown .dropdown-toggle:active,\n    .multi-select-dropdown .dropdown-toggle:hover,\n    .multi-select-dropdown .dropdown-button.dropdown-toggle:focus {\n      border: none;\n    }\n    .dropdown-button {\n      color: #242633;\n      padding: 6px 10px 6px 10px;\n      width: 100%;\n      font-size: 14px;\n      font-weight: inherit;\n      letter-spacing: normal;\n      text-transform: unset;\n      border-color: transparent;\n      margin: 0;\n      text-align: left;\n    }\n    .dropdown-button:hover,\n    .dropdown-button:focus,\n    .dropdown-button:active {\n      background-color: transparent;\n      color: #242633;\n    }\n    .statusColor {\n      display: inline-block;\n      margin-right: 10px;\n      margin-bottom: -2px;\n      width: 15px;\n      height: 15px;\n      border-radius: 20px;\n    }\n  </style>\n  <button\n    uib-dropdown-toggle\n    id=\"{{data.buttonId}}\"\n    class=\"btn\"\n    data-testid=\"change-status\"\n    type=\"button\"\n    id=\"menu1\"\n    data-tooltip-check=\"Change Status\"\n  >\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      width=\"24\"\n      height=\"24\"\n      viewBox=\"0 0 24 24\"\n    >\n      <style type=\"text/css\">\n        .st0 {\n          fill: #9d9d9d;\n        }\n      </style>\n      <path\n        class=\"st0\"\n        d=\"M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z\"\n      />\n      <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n    </svg>\n  </button>\n  <ul\n    uib-dropdown-menu\n    data-testid=\"application-status-dropdown\"\n    id=\"applicationStatusDropdownList\"\n    ng-click=\"openApplicationStatusDropdown($event)\"\n    class=\"savedfilterlist assigneAdminDropDownC\"\n  >\n    <ul\n      class=\"savedfilterlist fixedAssigneAdmin\"\n      style=\"max-height: 160px;min-width: 250px;\"\n    >\n      <li\n        id=\"status{{status.id}}\"\n        role=\"presentation\"\n        class=\"dropdownfilter\"\n        ng-repeat=\"status in data.applicationStatusList\"\n      >\n        <a\n          role=\"menuitem\"\n          tabindex=\"-1\"\n          ng-click=\"selectApplicationStatus(status)\"\n          style=\"padding: 5px 14px;\"\n        >\n          <span class=\"statusColor\" ng-style=\"statusColor(status.color)\">\n          </span>\n          <span> {{status.name}}</span>\n        </a>\n      </li>\n    </ul>\n    <li role=\"presentation\" class=\"divider\"></li>\n    <li>\n      <center>\n        <button\n          class=\"btn btn-info\"\n          ng-disabled=\"(selectedApplicationStatus) ?  false : true\"\n          ng-click=\"data.function(selectedApplicationStatus)\"\n        >\n          Update\n        </button>\n        <button class=\"btn btn-default\" ng-click=\"closeApplicationDropdown()\">\n          Cancel\n        </button>\n      </center>\n    </li>\n  </ul>\n</div>\n"

/***/ }),
/* 451 */
/***/ (function(module, exports) {

	module.exports = "<div uib-dropdown class=\"filters-action\">\n  <style>\n    .multi-select-dropdown .dropdown-toggle,\n    .multi-select-dropdown .dropdown-toggle:active,\n    .multi-select-dropdown .dropdown-toggle:hover,\n    .multi-select-dropdown .dropdown-button.dropdown-toggle:focus {\n      border: none;\n    }\n    .dropdown-button {\n      color: #242633;\n      padding: 6px 10px 6px 10px;\n      width: 100%;\n      font-size: 14px;\n      font-weight: inherit;\n      letter-spacing: normal;\n      text-transform: unset;\n      border-color: transparent;\n      margin: 0;\n      text-align: left;\n    }\n    .dropdown-button:hover,\n    .dropdown-button:focus,\n    .dropdown-button:active {\n      background-color: transparent;\n      color: #242633;\n    }\n\n    .stage-color {\n      display: inline-block;\n      margin-right: 10px;\n      margin-bottom: -2px;\n      width: 15px;\n      height: 15px;\n      border-radius: 20px;\n    }\n  </style>\n  <button\n    uib-dropdown-toggle\n    id=\"{{data.buttonId}}\"\n    data-testid=\"change-stage\"\n    class=\"btn\"\n    type=\"button\"\n    id=\"menu1\"\n    data-tooltip-check=\"Change Stage\"\n  >\n    <svg\n      id=\"Layer_1\"\n      data-name=\"Layer 1\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      width=\"23\"\n      height=\"23\"\n      viewBox=\"0 0 24 24\"\n    >\n      <polygon\n        points=\"18.36 2.65 0.19 2.65 5.65 12 0.19 21.35 18.79 21.35 23.81 12 18.36 2.65\"\n        class=\"st0\"\n        style=\"fill:#9d9d9d\"\n      />\n    </svg>\n  </button>\n  <ul\n    uib-dropdown-menu\n    data-testid=\"application-stage-dropdown\"\n    id=\"applicationStageDropdownList\"\n    ng-click=\"openApplicationStageDropdown($event)\"\n    class=\"savedfilterlist assigneAdminDropDownC\"\n  >\n    <ul\n      class=\"savedfilterlist fixedAssigneAdmin\"\n      style=\"min-height: 250px;min-width: max-content;\"\n    >\n      <li\n        role=\"presentation\"\n        id=\"stage{{stage.id}}\"\n        class=\"dropdownfilter\"\n        ng-repeat=\"stage in data.applicationStageList\"\n      >\n        <a\n          ng-disabled=\"true\"\n          role=\"menuitem\"\n          tabindex=\"-1\"\n          style=\"\n          background:transparent;\n          padding: 5px 14px;\n          pointer-events: none;\"\n          ng-class=\"{\n              'test': !changeApplicationStageID,\n              'fixedAssigneAdmin': changeApplicationStageID\n            }\"\n        >\n          <span class=\"stage-color\" ng-style=\"stageColor(stage.color)\"> </span>\n          <span> {{stage.name}}</span>\n        </a>\n        <ul\n          class=\"savedfilterlist fixedAssigneAdmin\"\n          style=\"max-height: 950px;min-width: max-content;\"\n        >\n          <li\n            role=\"presentation\"\n            id=\"stage{{childStage.id}}\"\n            class=\"dropdownfilter\"\n            ng-repeat=\"childStage in stage.children\"\n          >\n            <a\n              role=\"menuitem\"\n              tabindex=\"-1\"\n              ng-click=\"selectApplicationStage(childStage)\"\n              style=\"padding:5px 0px 0 30px;\"\n            >\n              <span class=\"stage-color\" ng-style=\"stageColor(childStage.color)\">\n              </span>\n              <span> {{childStage.name}}</span>\n            </a>\n          </li>\n        </ul>\n      </li>\n    </ul>\n    <li role=\"presentation\" class=\"divider\"></li>\n    <li>\n      <center>\n        <button\n          class=\"btn btn-info\"\n          ng-disabled=\"(selectedApplicationStage) ?  false : true\"\n          ng-click=\"data.function(selectedApplicationStage)\"\n        >\n          Update\n        </button>\n        <button class=\"btn btn-default\" ng-click=\"closeApplicationStageModal()\">\n          Cancel\n        </button>\n      </center>\n    </li>\n  </ul>\n</div>\n"

/***/ }),
/* 452 */
/***/ (function(module, exports) {

	module.exports = "<script type=\"text/ng-template\" id=\"delete-application-modal.html\">\n  <div class=\"modal-header\">\n      <center>\n          <h3>Delete {{ctrl.type}}?</h3>\n          <h5>Type 'DELETE' in text field to confirm this action</h5>\n      </center>\n      </div>\n      <div class=\"modal-body\">\n        <center>\n        <input class=\"form-control\" style=\"width: 50%\" type=\"text\" name=\"deleteConfirmation\" ng-model=\"ctrl.confirmationInput\" placeholder=\"DELETE\" required/>\n        </center>\n      </div>\n    <div class=\"modal-footer\">\n      <center>\n      <button class=\"btn btn-info\"\n      ng-disabled=\"(ctrl.confirmationInput) ?  false : true\"\n\n      ng-click=\"ctrl.confirmDelete()\">Yes</button>\n      <button class=\"btn btn-gap-v btn-default\" ng-click=\"ctrl.cancel()\">No</button>\n      </center>\n    </div>\n</script>\n"

/***/ }),
/* 453 */
/***/ (function(module, exports) {

	module.exports = "<div uib-dropdown class=\"filters-action\">\n  <style>\n    .multi-select-dropdown .dropdown-toggle,\n    .multi-select-dropdown .dropdown-toggle:active,\n    .multi-select-dropdown .dropdown-toggle:hover,\n    .multi-select-dropdown .dropdown-button.dropdown-toggle:focus {\n      border: none;\n    }\n    .dropdown-button {\n      color: #242633;\n      padding: 6px 10px 6px 10px;\n      width: 100%;\n      font-size: 14px;\n      font-weight: inherit;\n      letter-spacing: normal;\n      text-transform: unset;\n      border-color: transparent;\n      margin: 0;\n      text-align: left;\n    }\n    .dropdown-button:hover,\n    .dropdown-button:focus,\n    .dropdown-button:active {\n      background-color: transparent;\n      color: #242633;\n    }\n  </style>\n  <button\n    uib-dropdown-toggle\n    id=\"{{data.buttonId}}\"\n    class=\"btn\"\n    type=\"button\"\n    id=\"menu1\"\n    data-testid=\"assign-admin\"\n    data-tooltip-check=\"Assign Admin\"\n  >\n    <svg\n      version=\"1.1\"\n      width=\"20\"\n      height=\"20\"\n      id=\"Layer_1\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n      x=\"0px\"\n      y=\"0px\"\n      viewBox=\"0 0 614.9 540\"\n      style=\"enable-background:new 0 0 614.9 540;\"\n      xml:space=\"preserve\"\n    >\n      <style type=\"text/css\">\n        .st0 {\n          fill: #9d9d9d;\n        }\n      </style>\n      <g>\n        <path\n          class=\"st0\"\n          d=\"M237.5,258.4c35,0,65.3-12.6,90.1-37.3C352.4,196.3,365,166,365,131c0-35-12.6-65.3-37.3-90.1\n            c-24.8-24.8-55.1-37.3-90.1-37.3c-35,0-65.3,12.6-90.1,37.3S110,95.9,110,131c0,35,12.6,65.3,37.3,90.1\n            C172.2,245.9,202.5,258.4,237.5,258.4z\"\n        />\n        <g>\n          <path\n            class=\"st0\"\n            d=\"M357.4,524.6l-0.2-1.7l-1.4,1c-16,12-40.8,10.9-56.6-2.5c-7.2-6.1-13.9-12.8-20-20\n              c-13.4-15.8-14.5-40.7-2.5-56.6c0.4-0.5,0.7-0.9,1-1.4l-1.7-0.2c-19.6-2.8-35.9-18.8-37.8-37.2c-0.7-6.2-1-12.5-1-18.8\n              c0-6.4,0.3-12.7,1-18.9c2-18.3,18.2-34.3,37.8-37l1.7-0.2l-1-1.4c-6.2-8.3-9-19.5-8-30.5c-9.2,2.4-18.6,3.7-27.8,3.7\n              c-11.3,0-22.8-1.9-34.2-5.5c-11.6-3.7-21-7.9-27.9-12.3c-8-5.1-15.3-9.8-21.6-13.9c-10.1-6.6-15.3-8.8-20.7-8.8\n              c-13.8,0-26.6,2.3-38.2,6.9c-11.6,4.6-21.7,10.9-29.9,18.8c-7.9,7.5-14.9,16.7-20.8,27.2c-5.7,10.1-10.4,20.7-13.8,31.4\n              c-3.3,10.3-6.1,21.7-8.2,33.6c-2.1,11.9-3.6,23.1-4.3,33.5c-0.7,10.1-1.1,20.6-1.1,31.3c0,27.6,8.8,50,26.1,66.5\n              c17.1,16.3,39.7,24.5,67.3,24.5h247.2C359.1,532.2,358,528.4,357.4,524.6z\"\n          />\n        </g>\n        <path\n          class=\"st0\"\n          d=\"M593.9,364.3c-1-9.1-10.5-17.5-20.2-18.9l-17.5-2.5c-2-6.1-4.5-12.1-7.4-17.8c0,0,4.8-6.4,10.6-14.2\n            c5.9-7.8,5.7-22.1-1.7-30.8c-5.4-6.3-11.3-12.2-17.7-17.6c-8.7-7.4-23-7.6-30.8-1.7l-14.2,10.6c-5.7-2.9-11.6-5.4-17.8-7.4\n            c0,0-1.1-7.9-2.5-17.5c-1.4-9.7-9.8-19.2-18.9-20.2c-5.5-0.6-11-0.9-16.6-0.9c-5.6,0-11.1,0.3-16.6,0.9c-9.1,1-17.5,10.5-18.9,20.2\n            l-2,14l-0.5,3.6c-6.2,2-12.1,4.5-17.9,7.4c0,0-6.3-4.8-14.2-10.6c-1.8-1.3-3.9-2.3-6.1-3c-7.8-2.4-17.9-1-24.7,4.8\n            c-6.3,5.4-12.3,11.3-17.7,17.6c-1.2,1.4-2.1,2.9-2.9,4.4c-4.4,8.6-3.8,19.8,1.2,26.4l10.6,14.2c-2.9,5.7-5.4,11.7-7.4,17.8\n            c0,0-7.9,1.1-17.5,2.5c-9.7,1.4-19.2,9.8-20.2,18.9c-0.6,5.5-0.9,11-0.9,16.6c0,5.6,0.3,11.2,0.9,16.6c1,9.1,10.5,17.5,20.2,18.9\n            l17.5,2.5c2,6.2,4.5,12.1,7.4,17.8c0,0-4.8,6.3-10.6,14.2c-5.9,7.8-5.7,22.1,1.7,30.8c5.4,6.3,11.3,12.2,17.7,17.7\n            c8.7,7.4,23,7.6,30.8,1.7l14.2-10.6c5.7,2.9,11.7,5.4,17.9,7.4c0,0,1.1,7.9,2.5,17.5c0.7,4.8,3.1,9.5,6.4,13.2\n            c3.4,3.8,7.9,6.5,12.5,7c5.4,0.6,11,0.9,16.6,0.9c5.6,0,11.1-0.3,16.6-0.9c9.1-1,17.5-10.5,18.9-20.2l2.5-17.5\n            c6.2-2,12.1-4.5,17.8-7.4c0,0,6.3,4.8,14.2,10.6c7.8,5.9,22.1,5.7,30.8-1.7c6.3-5.4,12.3-11.3,17.7-17.7c7.4-8.7,7.6-23,1.7-30.8\n            l-10.6-14.2c2.9-5.7,5.4-11.7,7.4-17.8c0,0,7.9-1.1,17.5-2.5c9.7-1.4,19.2-9.8,20.2-18.9c0.6-5.4,0.9-11,0.9-16.6\n            C594.8,375.3,594.5,369.8,593.9,364.3z M487.4,430.7c-12.5,12.1-29.4,19.5-48.1,19.5c-38.2,0-69.2-31-69.2-69.2s31-69.2,69.2-69.2\n            c8.7,0,17.1,1.6,24.7,4.6c26,10,44.5,35.2,44.5,64.7C508.5,400.5,500.4,418.1,487.4,430.7z\"\n        />\n      </g>\n    </svg>\n  </button>\n  <ul\n    uib-dropdown-menu\n    data-testid=\"assign-admin-dropdown\"\n    id=\"agentsDropdownList\"\n    class=\"savedfilterlist assigneAdminDropDownC\"\n    ng-click=\"openAgentDropdown($event)\"\n  >\n    <li>\n      <div class=\"assigneadmin has-search\">\n        <input\n          type=\"text\"\n          id=\"filter-agents\"\n          class=\"form-control\"\n          placeholder=\"Search\"\n          data-ng-keyup=\"filterAssignAgent()\"\n        />\n      </div>\n    </li>\n\n    <ul data-testid=\"admin-list\" class=\"savedfilterlist fixedAssigneAdmin\">\n      <li role=\"presentation\" id=\"0\" class=\"dropdownfilter\">\n        <a\n          role=\"menuitem\"\n          tabindex=\"-1\"\n          ng-click=\"selectedAgent({id:0,email:'unassign'})\"\n          >unassign\n        </a>\n      </li>\n      <li\n        role=\"presentation\"\n        id=\"{{assigneeAdmin.id}}\"\n        class=\"dropdownfilter\"\n        ng-repeat=\"assigneeAdmin in data.filteredAgentList\"\n      >\n        <a role=\"menuitem\" tabindex=\"-1\" ng-click=\"selectedAgent(assigneeAdmin)\"\n          >{{assigneeAdmin.email}}\n        </a>\n      </li>\n      <label ng-if=\"data.filteredAgentList.length==0\">No record found!</label>\n    </ul>\n\n    <li role=\"presentation\" class=\"divider\"></li>\n    <li>\n      <center>\n        <button\n          class=\"btn btn-info\"\n          ng-disabled=\" (selectedAgentValue) ?  false : true\"\n          ng-click=\"data.function(selectedAgentValue)\"\n        >\n          Assign\n        </button>\n        <button class=\"btn btn-default\" ng-click=\"closeAgentList()\">\n          Cancel\n        </button>\n      </center>\n    </li>\n  </ul>\n</div>\n"

/***/ }),
/* 454 */
/***/ (function(module, exports) {

	module.exports = "<script type=\"text/ng-template\" id=\"candidateProfileModal.html\">\n  <candidate-profile  profile-user=\"candidateId\" />\n</script>\n"

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	module.exports = "<script type=\"text/ng-template\" id=\"clone-position-modal.html\">\n  <div data-testid=\"clone-position-modal\">\n    <span\n      class=\"spinner-static-center\"\n      us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n      spinner-key=\"spinner-clone-jobs\"\n    >\n    </span>\n\n    <div class=\"modal-header\">\n      <center>\n        <h3>Clone Positions</h3>\n      </center>\n\n      <div class=\"row\">\n        <div class=\"col-md-3 col-sm-2\">\n          <b> Employer ID:</b>\n          {{ctrl.positions[ctrl.currentIndex].employerId}}\n        </div>\n        <div class=\"col-md-9 col-sm-10\">\n          <b> Employer Name:</b>\n          {{ctrl.positions[ctrl.currentIndex].employer.name}}\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-body padding-5 clone-modal\">\n      <div class=\"col-xs-12 selected-job\">\n        <div class=\"row\">\n          <h5 class=\" col-md-offset-0 col-md-3 text-right\">\n            <strong>Position Title</strong>\n          </h5>\n          <div class=\"col-md-8\">\n            <input\n              class=\" form-control\"\n              data-ng-model=\"ctrl.positions[ctrl.currentIndex].title\"\n            />\n          </div>\n        </div>\n        <div class=\"row\">\n          <h5 class=\" col-md-offset-0 col-md-3 text-right\">\n            <strong>Location</strong>\n          </h5>\n          <div class=\"col-md-5\">\n            <locations-Dropdown\n            locations-list=\"ctrl.allLocations\"\n            regions-list=\"ctrl.regionHierarchialListWithEuropeOnTop\"\n            on-location-change=\"ctrl.onChangeLocation($event,selectedLocation)\"\n            ></locations-Dropdown>\n          </div>\n        </div>\n        <div class=\"row\">\n          <h5 class=\" col-md-offset-0 col-md-3 text-right\">\n            <strong>Practice Areas</strong>\n          </h5>\n          <div class=\"col-md-5\">\n            <practice-Area-Dropdown\n              practice-areas-list=\"ctrl.allPracticeArea\"\n              on-practice-change=\"ctrl.onChangePracticeArea($event,selectedPracticeArea)\"\n              ></practice-Area-Dropdown>\n          </div>\n        </div>\n        <div data-testid=\"clone-position-address\" class=\"row\">\n          <h5 class=\"col-md-offset-0 col-md-3 text-right\">\n            <strong>Address</strong>\n          </h5>\n          <div class=\"col-md-8\">\n            <input\n              type=\"text\"\n              autocomplete=\"off\"\n              placeholder=\"Address\"\n              class=\"form-control\"\n              ng-model=\"ctrl.positions[ctrl.currentIndex].employer.address\"\n            />\n          </div>\n        </div>\n        <div class=\"row\">\n          <h5 class=\" col-md-offset-0 col-md-3 text-right\">\n            <strong>Position Expires On</strong>\n          </h5>\n          <div class=\"col-md-5\" data-ng-controller=\"DatepickerDemoCtrl\">\n            <div class=\"input-group ui-datepicker\">\n              <input\n                id=\"datepicker\"\n                type=\"text\"\n                placeholder=\"Expiry Date\"\n                class=\"form-control custom-readonly\"\n                uib-datepicker-popup=\"{{format}}\"\n                is-open=\"opened\"\n                datepicker-options=\"dateOptions\"\n                date-disabled=\"disabled(date, mode)\"\n                close-text=\"Close\"\n                ng-model=\"ctrl.positions[ctrl.currentIndex].expiresAt\"\n              />\n              <span class=\"input-group-addon pointer\" ng-click=\"open($event)\">\n                <i class=\"fa fa-calendar\"></i>\n              </span>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <h5 class=\"col-md-offset-0 col-md-3 padding-l0 text-right\">\n            <strong>Required Experience</strong>\n          </h5>\n          <div class=\"col-md-8\">\n            <input\n              ng-model=\"ctrl.positions[ctrl.currentIndex].pqe\"\n              autocomplete=\"off\"\n              type=\"text\"\n              id=\"mySlider1\"\n              slider\n              options=\"ctrl.pqeOptions\"\n              ng-change=\"ctrl.pqeChange()\"\n            />\n            <div class=\"space\"></div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <h5 class=\"col-md-offset-0 col-md-3 text-right\">\n            <strong>Contract: </strong>\n          </h5>\n          <div class=\" col-md-8\">\n            <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n              <select\n                data-ng-model=\"ctrl.positions[ctrl.currentIndex].contractTypeId\"\n                style=\"padding: 8px 10px; width: 100%;\"\n                required\n              >\n                <option\n                  ng-repeat=\"contract in ctrl.allContractType\"\n                  ng-value=\"{{contract.id}}\"\n                  ng-selected=\"contract.id == positions[ctrl.currentIndex].contractTypeId\"\n                  >{{contract.name}}</option\n                >\n              </select>\n            </span>\n          </div>\n        </div>\n        <div class=\"row\">\n          <h5 class=\"col-md-offset-0 col-md-3 text-right\">\n            <strong>Occupation: </strong>\n          </h5>\n          <div class=\" col-md-8\">\n            <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n              <select\n                data-ng-model=\"ctrl.positions[ctrl.currentIndex].occupationId\"\n                style=\"padding: 8px 10px; width: 100%;\"\n                required\n              >\n                <option\n                  ng-repeat=\"occupation in ctrl.allOccupations\"\n                  ng-value=\"{{occupation.id}}\"\n                  ng-selected=\"occupation.id == positions[ctrl.currentIndex].occupationId\"\n                  >{{occupation.name}}</option\n                >\n              </select>\n            </span>\n          </div>\n        </div>\n        <div data-testid=\"clone-position-description\" class=\"row\">\n          <h5 class=\"col-md-offset-0 col-md-3 text-right\">\n            <strong>Position Description</strong>\n          </h5>\n          <div\n            class=\"col-md-9 clone-job-description\"\n            ng-init=\"editorOptions = { extraPlugins: 'colorbutton' }\"\n          >\n            <textarea\n              name=\"jobDescription\"\n              class=\"form-control\"\n              ckeditor=\"editorOptions\"\n              ng-model=\"ctrl.positions[ctrl.currentIndex].description\"\n            >\n            </textarea>\n          </div>\n        </div>\n        <div class=\"row\">\n          <h5 class=\"col-md-offset-0 col-md-3 text-right margin-t0\">\n            Listing Type\n          </h5>\n          <div class=\"col-md-9\">\n            <dd>\n              <label class=\"ui-radio\"\n                ><input\n                  name=\"job_category\"\n                  type=\"radio\"\n                  ng-value=\"1\"\n                  ng-model=\"ctrl.positions[ctrl.currentIndex].positionType\"\n                  checked\n                /><span>Regular</span></label\n              >\n\n              <label class=\"ui-radio\"\n                ><input\n                  name=\"job_category\"\n                  type=\"radio\"\n                  ng-value=\"2\"\n                  ng-model=\"ctrl.positions[ctrl.currentIndex].positionType\"\n                /><span>Custom</span></label\n              >\n\n              <label class=\"ui-radio\"\n                ><input\n                  name=\"job_category\"\n                  type=\"radio\"\n                  ng-value=\"3\"\n                  ng-model=\"ctrl.positions[ctrl.currentIndex].positionType\"\n                /><span>Connect</span></label\n              >\n\n              <label class=\"ui-radio\"\n                ><input\n                  name=\"job_category\"\n                  type=\"radio\"\n                  ng-value=\"4\"\n                  ng-model=\"ctrl.positions[ctrl.currentIndex].positionType\"\n                /><span>Speculative</span></label\n              >\n              <label class=\"ui-radio\" ng-show=\"ctrl.positions[ctrl.currentIndex].employerType=='In-House'\"\n              ><input\n                data-testid=\"job-category\"\n                name=\"job_category\"\n                type=\"radio\"\n                ng-value=\"5\"\n                ng-model=\"ctrl.positions[ctrl.currentIndex].positionType\"\n              /><span>ATS Direct Link</span></label\n            >\n            </dd>\n          </div>\n        </div>\n        <div ng-show=\"ctrl.positions[ctrl.currentIndex].positionType == 1\" class=\"row\">\n          <div class=\"col-md-offset-0 col-md-3 text-right margin-t0\">Source/External Link</div>\n          <div class=\"col-md-5\">\n            <input\n              data-testid=\"job-reference\"\n              ng-disabled=\"ctrl.positions[ctrl.currentIndex].positionType !=1\"\n              type=\"text\"\n              autocomplete=\"off\"\n              placeholder=\"Enter your link..\"\n              class=\"form-control\"\n              ng-model=\"ctrl.positions[ctrl.currentIndex].externalUrl\"\n            />\n          </div>\n        </div>\n\n        <div ng-show=\"ctrl.positions[ctrl.currentIndex].positionType == 5\" class=\"row\">\n          <div class=\"col-md-offset-0 col-md-3 text-right margin-t0\">ATS Direct Link *</div>\n          <div class=\"col-md-5\">\n            <input\n              data-testid=\"job-atsLink\"\n              ng-disabled=\"ctrl.positions[ctrl.currentIndex].positionType != 5\"\n              type=\"text\"\n              autocomplete=\"off\"\n              placeholder=\"Enter your link..\"\n              class=\"form-control\"\n              ng-model=\"ctrl.positions[ctrl.currentIndex].externalUrl\"\n              ng-required=\"ctrl.positions[ctrl.currentIndex].positionType == 5\"\n            />\n          </div>\n        </div>\n        <div class=\"row\">\n          <h5 class=\"col-md-offset-0 col-md-3 text-right margin-t0\">\n            Position Visibility *\n          </h5>\n          <div class=\" col-md-5\">\n            <span class=\"ui-select\" style=\"margin-left: 0; width: 100%;\">\n              <select\n                data-ng-model=\"ctrl.positions[ctrl.currentIndex].visible\"\n                style=\"padding: 8px 10px; width: 100%;\"\n                required\n              >\n                <option\n                  ng-value=\"true\"\n                  ng-selected=\"positions[ctrl.currentIndex].visible\"\n                  >Visible</option\n                >\n                <option\n                  ng-value=\"false\"\n                  ng-selected=\"!positions[ctrl.currentIndex].visible\"\n                  >Invisible</option\n                >\n              </select>\n            </span>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <div class=\"row\">\n        <div class=\"col-md-8 col-xs-5 text-left\">\n          {{ctrl.currentIndex + 1}} of {{ctrl.positions.length}}\n        </div>\n        <div class=\"col-md-4 col-xs-7 text-right\">\n          <button\n            class=\"btn btn-xs btn-info\"\n            ng-click=\"ctrl.firstPage()\"\n            ng-disabled=\"ctrl.currentIndex == 0\"\n          >\n            <i class=\"fa fa-chevron-left\"></i>\n            <i class=\"fa fa-chevron-left\" style=\"margin-left: -5px;\"></i>\n          </button>\n          <button\n            class=\"btn btn-xs btn-info\"\n            ng-click=\"ctrl.previousPage()\"\n            ng-disabled=\"ctrl.currentIndex == 0\"\n          >\n            <i class=\"fa fa-chevron-left\"></i>\n          </button>\n\n          <button\n            class=\"btn btn-xs btn-info\"\n            ng-click=\"ctrl.nextPage()\"\n            ng-disabled=\"ctrl.currentIndex == ctrl.positions.length-1\"\n          >\n            <i class=\"fa fa-chevron-right\"></i>\n          </button>\n          <button\n            class=\"btn btn-xs btn-info\"\n            ng-click=\"ctrl.lastPage()\"\n            ng-disabled=\"ctrl.currentIndex == ctrl.positions.length-1\"\n          >\n            <i class=\"fa fa-chevron-right\"></i>\n            <i class=\"fa fa-chevron-right\" style=\"margin-left: -5px;\"></i>\n          </button>\n        </div>\n      </div>\n      <div class=\"row margin-t5\">\n        <center>\n          <button class=\"btn btn-info\" ng-click=\"ctrl.clonePositions()\">\n            Clone\n          </button>\n          <button class=\"btn btn-gap-v btn-default\" ng-click=\"ctrl.cancel()\">\n            Cancel\n          </button>\n        </center>\n      </div>\n    </div>\n  </div>\n</script>\n"

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	module.exports = "<script type=\"text/ng-template\" id=\"contact-admin-modal.html\">\n  <div class=\"modal-header\">\n    <center>\n      <h3>{{'contactAdminEmailHeading'|translate}}</h3>\n    </center>\n  </div>\n\n  <div class=\"modal-body\">\n    <div class=\"clearfix\">\n      <textarea data-testid=\"lawyer-question\" rows=\"20\" data-ng-model=\"ctrl.lawyerQuestion\" class=\n      \"col-md-12 col-xs-12 contact-admin-textarea\">\n      </textarea>\n    </div>\n  </div>\n\n  <div class=\"modal-footer\">\n    <center>\n      <button data-testid=\"submit-question\" class=\"btn btn-info\" ng-disabled=\"!ctrl.lawyerQuestion\" ng-click=\n      \"ctrl.submitQuestion()\">{{'contactAdminEmailBtnLabel'|translate}}</button>\n      <button class=\"btn btn-default\" ng-click=\n      \"ctrl.cancel()\">{{'btn.cancel.label'|translate}}</button>\n    </center>\n  </div>\n</script>\n"

/***/ }),
/* 457 */
/***/ (function(module, exports) {

	module.exports = "<span>\n  <div data-testid=\"employer-modal\" class=\"modal-header right-modal-header\">\n    <div>\n      <h3>{{ctrl.modalTitle}}</h3>\n    </div>\n  </div>\n  <div class=\"right-modal-body\">\n    <span\n      us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n      spinner-key=\"{{ctrl.employerSpinnerId}}\"\n      class=\"spinner-static-center\"\n    ></span>\n    <form class=\"form-horizontal firm-creation\" name=\"employerForm\">\n      <!-- Firm logo -->\n      <div class=\"modal-body col-md-12\">\n        <div class=\"row\" ng-init=\"logoUpdated=false\">\n          <div class=\"h5 col-md-4 text-right\">\n            {{ctrl.page.entityPlaceholder}} Logo\n          </div>\n          <div class=\"col-md-5\">\n            <input\n              type=\"file\"\n              file-upload=\"ctrl.selectedFile\"\n              accept=\"image/*\"\n            />\n\n            <span>{{ctrl.selectedFile ? '' :ctrl.employer.logo}}</span>\n          </div>\n          <div class=\"col-md-3\">\n            <p ng-if=\"!ctrl.selectedEmployerId\">\n              <a\n                href=\"\"\n                tooltip=\"200 x 200 pixels recommended\"\n                tooltip-placement=\"right\"\n              >\n                <span\n                  class=\"badge badge-grey\"\n                  style=\"padding: 1px 5px !important;\"\n                >\n                  <i class=\"fa fa-info\"></i>\n                </span>\n                <!-- <span class=\"badge badge-grey email-pause-info\">\n                                      <i class=\"fa fa-info\"></i>\n                                  </span> -->\n              </a>\n            </p>\n            <button\n              class=\"btn btn-danger text-center\"\n              ng-if=\"ctrl.selectedEmployerId\"\n              ng-click=\"ctrl.openDeleteEmployerModal(ctrl.selectedEmployerId)\"\n              ng-disabled=\"ctrl.showOnError\"\n            >\n              Delete {{ctrl.page.entityPlaceholder}}\n            </button>\n          </div>\n        </div>\n\n        <br ng-if=\"ctrl.selectedEmployerId\" />\n        <div class=\"row\" ng-if=\"ctrl.selectedEmployerId\">\n          <div class=\"h5 col-md-4 text-right\">\n            {{ctrl.page.entityPlaceholder}} ID\n          </div>\n          <div class=\"col-md-5\">\n            <span data-testid=\"employer-id\" class=\"inlineBlock margin-t10\">\n              {{ ctrl.employer.id }}\n            </span>\n          </div>\n        </div>\n        <br />\n\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">\n            {{ctrl.page.entityPlaceholder}} Name *\n          </div>\n          <div class=\"col-md-5\">\n            <input\n              type=\"text\"\n              data-testid=\"employer-name\"\n              autocomplete=\"off\"\n              placeholder=\"Employer Name\"\n              class=\"form-control\"\n              ng-model=\"ctrl.employer.name\"\n              required\n            />\n            <div class=\"space\"></div>\n          </div>\n        </div>\n        <div class=\"row\" ng-hide=\"!ctrl.isPrivatePractice\">\n          <div class=\"h5 col-md-4 text-right\">\n            {{ctrl.page.entityPlaceholder}} Size *\n          </div>\n          <div class=\"col-md-5\">\n            <input\n              type=\"number\"\n              data-testid=\"employer-size\"\n              id=\"firm-mgt-size\"\n              autocomplete=\"off\"\n              min=\"0\"\n              placeholder=\"Employer Size\"\n              class=\"form-control\"\n              ng-model=\"ctrl.employer.lawProfile.size\"\n              ng-required=\"ctrl.isPrivatePractice\"\n              only-numbers\n            />\n          </div>\n\n          <div class=\"col-md-3\">\n            <label class=\"ui-checkbox\" style=\"margin-top:5px\">\n              <input\n                name=\"show-firm-size\"\n                data-testid=\"employer-size-visibility\"\n                id=\"firm-mgt-size-chkbx\"\n                type=\"checkbox\"\n                ng-model=\"ctrl.employer.lawProfile.sizeVisible\"\n              />\n              <span>Show Publicly</span>\n            </label>\n          </div>\n        </div>\n        <br ng-hide=\"!ctrl.isPrivatePractice\" />\n\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">\n            {{ctrl.page.entityPlaceholder}} Category *\n          </div>\n\n          <div class=\"col-md-5\">\n            <span class=\"ui-select\" style=\"margin-left: 0; width: 80%;\">\n              <select\n                style=\"padding: 8px 10px; width: 100%;\"\n                data-testid=\"employer-category\"\n                id=\"firm-mgt-category\"\n                ng-change=\"ctrl.changeEmployerCategory(ctrl.employer.categoryId)\"\n                ng-model=\"ctrl.employer.categoryId\"\n                ng-required=\"ctrl.selectedEmployerId? ctrl.employer.approved:true\"\n              >\n                <option value=\"\" disabled selected style=\"display:none;\"\n                  >{{ctrl.page.entityPlaceholder}} Category</option\n                >\n                <option\n                  ng-repeat=\"category in ctrl.categories\"\n                  ng-value=\"{{category.id}}\"\n                  ng-selected=\"category.id == ctrl.employer.categoryId\"\n                >\n                  {{category.name}}\n                </option>\n              </select>\n            </span>\n          </div>\n\n          <div ng-if=\"ctrl.selectedEmployerId\" class=\"col-md-3\">\n            <label class=\"ui-checkbox\" style=\"margin-top:5px\">\n              <input\n                data-testid=\"employer-approved\"\n                id=\"firm-mgt-target-chkbx\"\n                ng-change=\"ctrl.onEmployerApproved(ctrl.employer.approved)\"\n                ng-model=\"ctrl.employer.approved\"\n                name=\"show-employer-approved\"\n                type=\"checkbox\"\n                value=\"show\"\n              />\n              <span>Approved</span>\n            </label>\n          </div>\n        </div>\n        <br />\n        <div class=\"row\">\n          <div class=\"clearfix\">\n            <div class=\"h5 col-md-4 text-right\">\n              {{ctrl.page.entityPlaceholder}} Selectivity *\n            </div>\n\n            <div class=\"col-md-8\">\n              <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n                <select\n                  data-testid=\"employer-selectivity\"\n                  id=\"firm-mgt-selectivity\"\n                  style=\"padding: 8px 10px; width: 100%;\"\n                  ng-model=\"ctrl.employer.selectivity\"\n                  required\n                >\n                  <option class=\"hidden\" value=\"\" selected disabled\n                    >{{ctrl.page.entityPlaceholder}} Selectivity</option\n                  >\n                  <option\n                    ng-repeat=\"selectivity in ctrl.selectivity\"\n                    ng-value=\"{{selectivity.id}}\"\n                    ng-selected=\"selectivity.id == ctrl.employer.selectivity\"\n                  >\n                    {{selectivity.name}}\n                  </option>\n                </select>\n              </span>\n            </div>\n          </div>\n\n          <br />\n        </div>\n\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">\n            {{ctrl.page.entityPlaceholder}} Contact Name\n          </div>\n          <div class=\"col-md-5\">\n            <input\n              type=\"text\"\n              data-testid=\"employer-contact-name\"\n              id=\"firm-mgt-contact-name\"\n              autocomplete=\"off\"\n              placeholder=\"Employer Contact Name\"\n              class=\"form-control\"\n              ng-model=\"ctrl.employer.contactName\"\n            />\n            <div class=\"space\"></div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">\n            {{ctrl.page.entityPlaceholder}} Contact Email\n          </div>\n          <div class=\"col-md-5\">\n            <input\n              type=\"email\"\n              data-testid=\"employer-contact-email\"\n              id=\"firm-mgt-contact-email\"\n              autocomplete=\"off\"\n              pattern=\"^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$\"\n              placeholder=\"Employer Contact Email\"\n              class=\"form-control\"\n              ng-model=\"ctrl.employer.contactEmail\"\n              oninvalid=\"setCustomValidity('Please enter valid email')\"\n              oninput=\"setCustomValidity('')\"\n            />\n            <div class=\"space\"></div>\n          </div>\n        </div>\n        <!-- Target Hours -->\n        <div class=\"row\" ng-hide=\"!ctrl.isPrivatePractice\">\n          <div class=\"h5 col-md-4 text-right\">Target Hours</div>\n          <div class=\"col-md-5\">\n            <input\n              type=\"text\"\n              data-testid=\"employer-target-hours\"\n              id=\"firm-mgt-target-hrs\"\n              autocomplete=\"off\"\n              placeholder=\"Target Hours\"\n              class=\"form-control\"\n              ng-model=\"ctrl.employer.lawProfile.targetHours\"\n            />\n          </div>\n          <div class=\"col-md-3\">\n            <label class=\"ui-checkbox\" style=\"margin-top:5px\">\n              <input\n                data-testid=\"employer-target-hours-visibility\"\n                id=\"firm-mgt-target-chkbx\"\n                ng-model=\"ctrl.employer.lawProfile.targetHoursVisible\"\n                name=\"show-firm-targetHours\"\n                type=\"checkbox\"\n                value=\"show\"\n              />\n              <span>Show Publicly</span>\n            </label>\n          </div>\n        </div>\n        <br ng-hide=\"!ctrl.isPrivatePractice\" />\n        <div class=\"row\" ng-hide=\"!ctrl.isPrivatePractice\">\n          <div class=\"h5 col-md-4 text-right\">£/$ Turnover</div>\n          <div class=\"col-md-5\">\n            <input\n              type=\"text\"\n              data-testid=\"employer-associatesPerPartner\"\n              id=\"firm-mgt-app\"\n              autocomplete=\"off\"\n              placeholder=\"£/$ Turnover\"\n              class=\"form-control\"\n              ng-model=\"ctrl.employer.lawProfile.associatesPerPartner\"\n              ng-pattern=\"/^[\\$\\£][\\ ]?[\\d,]+(\\.\\d*)?$/\"\n            />\n            <div class=\"space\"></div>\n          </div>\n          <div class=\"col-md-3\">\n            <label class=\"ui-checkbox\" style=\"margin-top:5px\">\n              <input\n                name=\"show-firm-app\"\n                data-testid=\"employer-associatesPerPartner-visibility\"\n                id=\"firm-mgt-app-chkbx\"\n                type=\"checkbox\"\n                ng-model=\"ctrl.employer.lawProfile.associatesPerPartnerVisible\"\n              />\n              <span>Show Publicly</span>\n            </label>\n          </div>\n        </div>\n        <div class=\"row\" ng-hide=\"!ctrl.isPrivatePractice\">\n          <div class=\"h5 col-md-4 text-right\">\n            £/$ Profit per Equity Partner\n          </div>\n          <div class=\"col-md-5\">\n            <input\n              type=\"text\"\n              data-testid=\"employer-pep\"\n              id=\"firm-mgt-pep\"\n              autocomplete=\"off\"\n              class=\"form-control\"\n              placeholder=\"£/$ Profit per Equity Partner\"\n              ng-model=\"ctrl.employer.lawProfile.profitPerEquityPartner\"\n              ng-pattern=\"/^[\\$\\£][\\ ]?[\\d,]+(\\.\\d*)?$/\"\n            />\n          </div>\n          <div class=\"col-md-3\">\n            <label class=\"ui-checkbox\" style=\"margin-top:5px\">\n              <input\n                name=\"show-firm-pep\"\n                data-testid=\"employer-pep-visibility\"\n                id=\"firm-mgt-chkbx\"\n                type=\"checkbox\"\n                ng-model=\"ctrl.employer.lawProfile.profitPerEquityPartnerVisible\"\n              />\n              <span>Show Publicly</span>\n            </label>\n          </div>\n        </div>\n        <br ng-hide=\"!ctrl.isPrivatePractice\" />\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">Salary</div>\n          <div class=\"col-md-5\">\n            <input\n              type=\"text\"\n              data-testid=\"employer-salary\"\n              id=\"firm-mgt-salary\"\n              autocomplete=\"off\"\n              class=\"form-control\"\n              placeholder=\"Salary\"\n              ng-model=\"ctrl.employer.lawProfile.nqSalary\"\n            />\n          </div>\n          <div class=\"col-md-3\">\n            <label class=\"ui-checkbox\" style=\"margin-top:5px\">\n              <input\n                name=\"show-firm-salary\"\n                data-testid=\"employer-salary-visibility\"\n                id=\"firm-mgt-salary-chkbx\"\n                type=\"checkbox\"\n                ng-model=\"ctrl.employer.lawProfile.nqSalaryVisible\"\n              />\n              <span>Show Publicly</span>\n            </label>\n          </div>\n        </div>\n        <br />\n\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">\n            Address {{ctrl.page.mandatoryPlaceholder}}\n          </div>\n          <div class=\"col-md-5\">\n            <input\n              type=\"text\"\n              data-testid=\"employer-address\"\n              id=\"firm-mgt-address\"\n              autocomplete=\"off\"\n              placeholder=\"Address\"\n              class=\"form-control\"\n              ng-model=\"ctrl.employer.address\"\n              ng-required=\"ctrl.isPrivatePractice\"\n            />\n            <div class=\"space\"></div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">\n            {{ctrl.page.entityPlaceholder}} Visibility *\n          </div>\n          <div class=\"col-md-8\">\n            <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n              <select\n                data-testid=\"employer-isVisible\"\n                id=\"firm-mgt-visibility\"\n                style=\"padding: 8px 10px; width: 100%;\"\n                required\n                ng-model=\"ctrl.employer.isVisible\"\n              >\n                <option value=\"\" disabled selected style=\"display:none;\"\n                  >Visibility</option\n                >\n                <option\n                  ng-selected=\"ctrl.employer.isVisible===true\"\n                  ng-value=\"true\"\n                  >Visible to Applicants</option\n                >\n                <option\n                  ng-selected=\"ctrl.employer.isVisible===false\"\n                  ng-value=\"false\"\n                  >Invisible to Applicants</option\n                >\n              </select>\n            </span>\n          </div>\n        </div>\n        <!-- Assigned Agent -->\n        <div class=\"row\">\n          <br />\n          <div class=\"h5 col-md-4 text-right\">Assigned Agent *</div>\n          <div class=\"col-md-8\">\n            <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n              <select\n                data-testid=\"employer-assigned-admin\"\n                id=\"firm-mgt-admin\"\n                style=\"padding: 8px 10px; width: 100%;\"\n                ng-model=\"ctrl.employer.agentId\"\n                required\n              >\n                <option value=\"\" disabled selected style=\"display:none;\"\n                  >Assign Admin</option\n                >\n                <option ng-value=\"0\" ng-selected=\"!ctrl.employer.agentId\">\n                  unassign\n                </option>\n                <option\n                  ng-value=\"{{agent.id}}\"\n                  ng-repeat=\"agent in ctrl.candidateAgentsList\"\n                  ng-selected=\"agent.id === ctrl.employer.agentId\"\n                >\n                  {{agent.email}}\n                </option>\n              </select>\n            </span>\n          </div>\n        </div>\n        <br />\n        <!-- description field -->\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">\n            {{page.entityPlaceholder}} Description\n          </div>\n          <div class=\"col-md-5\">\n            <textarea\n              data-testid=\"employer-description\"\n              id=\"firm-mgt-description\"\n              ng-model=\"ctrl.employer.description\"\n              name=\"\"\n              id=\"\"\n              class=\"form-control\"\n              style=\"margin-bottom:10px; resize:none\"\n            ></textarea>\n          </div>\n        </div>\n      </div>\n      <div class=\"modal-footer\">\n        <div class=\"content\">\n          <button\n            data-testid=\"employer-create\"\n            id=\"firm-mgt-create-btn\"\n            type=\"submit\"\n            class=\"savebtn btn btn-info\"\n            ng-if=\"!ctrl.selectedEmployerId\"\n            ng-click=\"employerForm.$valid&&ctrl.addEmployer()\"\n          >\n            Create\n          </button>\n\n          <button\n            data-testid=\"employer-update\"\n            id=\"firm-mgt-update-btn\"\n            ng-if=\"ctrl.selectedEmployerId\"\n            class=\"savebtn btn btn-success\"\n            ng-click=\"employerForm.$valid && ctrl.updateEmployer()\"\n            ng-disabled=\"ctrl.showOnError\"\n          >\n            Save\n          </button>\n          <button\n            data-testid=\"firm-cancel\"\n            class=\"closebtn btn\"\n            ng-click=\"ctrl.cancel();\"\n          >\n            Cancel\n          </button>\n        </div>\n      </div>\n    </form>\n  </div>\n  <script type=\"text/ng-template\" id=\"practice-area-modal.html\">\n    <practice-Area></practice-Area>\n  </script>\n  <script type=\"text/ng-template\" id=\"locations-modal.html\">\n    <locations-Modal></locations-Modal>\n  </script>\n  <delete-Employer></delete-Employer>\n</span>\n"

/***/ }),
/* 458 */
/***/ (function(module, exports) {

	module.exports = "<!-- <script type=\"text/ng-template\" id=\"create-update-position-modal.html\"> -->\n<span>\n  <div class=\"modal-header right-modal-header\">\n    <div>\n      <h3>{{ctrl.modalTitle}}</h3>\n    </div>\n  </div>\n  <div class=\"right-modal-body\">\n    <form name=\"positionForm\" class=\"form-horizontal btn-position-creation\">\n      <div class=\"modal-body col-md-12\">\n        <div class=\"row\">\n          <div class=\"col-md-3 text-center mobile-show\">\n            <button\n              class=\"btn btn-danger\"\n              ng-if=\"ctrl.editPositionModal\"\n              ng-click=\"ctrl.openDeletePositionModal(); $event.preventDefault();$event.stopPropagation();\"\n            >\n              Delete Position\n            </button>\n          </div>\n          <div class=\"h5 col-md-4 text-right\">\n            Employer Name *\n          </div>\n          <div class=\"col-md-5\">\n            <span class=\"ui-select\" style=\"margin-left: 0; \">\n              <select\n                data-testid=\"position-employers\"\n                data-ng-model=\"ctrl.position.employer\"\n                ng-change=\"ctrl.changeEmployer(ctrl.position.employer);\"\n                ng-options=\"employer as employer.name for employer in ctrl.employersList\"\n                required\n              >\n              </select>\n            </span>\n          </div>\n          <div class=\"col-md-3 text-center mobile-hide\">\n            <button\n              class=\"btn btn-danger\"\n              ng-if=\"ctrl.editPositionModal\"\n              ng-click=\"ctrl.openDeletePositionModal(); $event.preventDefault();$event.stopPropagation();\"\n            >\n              Delete Position\n            </button>\n          </div>\n        </div>\n        <br />\n        <!-- Practice areas -->\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">Practice Areas *</div>\n          <div\n            class=\"col-md-6 text-left\"\n            ng-show=\"!ctrl.selectedPracticesShow && ctrl.showPracticeButton\"\n          >\n            <button\n              data-testid=\"position-practices\"\n              class=\"btn btn-line-info\"\n              ng-click=\"ctrl.openPracticeModal(null,$event)\"\n            >\n              Click to specify\n            </button>\n          </div>\n          <div class=\"divider clearfix\"></div>\n          <div class=\"col-md-5 text-left\" ng-show=\"ctrl.selectedPracticesShow\">\n            <ul\n              data-testid=\"position-selected-practices\"\n              id=\"taglist\"\n              class=\"list-inline list-practice-area margin-b0\"\n            >\n              <li\n                class=\"tags-box\"\n                ng-if=\"practiceArea.isSelected\"\n                ng-repeat=\"practiceArea in ctrl.position.practiceAreas \"\n              >\n                {{practiceArea.name}}\n              </li>\n              <a\n                href=\"\"\n                class=\"fa fa-pencil\"\n                ng-click=\"ctrl.openPracticeModal(ctrl.position.practiceAreas ,$event)\"\n              ></a>\n            </ul>\n          </div>\n        </div>\n\n        <br />\n\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">Position Title *</div>\n          <div class=\"col-md-6\">\n            <input\n              type=\"text\"\n              data-testid=\"position-title\"\n              autocomplete=\"off\"\n              class=\"form-control\"\n              placeholder=\"Position Title\"\n              data-ng-model=\"ctrl.position.title\"\n              required\n            />\n          </div>\n        </div>\n        <br />\n\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">Locations *</div>\n          <div\n            class=\"col-md-6 text-left\"\n            ng-show=\"!ctrl.selectedLocation && ctrl.showLocationButton\"\n          >\n            <button\n              data-testid=\"position-locations\"\n              class=\"btn btn-line-info\"\n              id=\"select-locations\"\n              ng-click=\"ctrl.openLocationModal(null,$event)\"\n            >\n              Click to specify\n            </button>\n          </div>\n          <div class=\"divider clearfix\"></div>\n          <div class=\"col-md-6 text-left\" ng-show=\"ctrl.selectedLocation\">\n            <ul\n              data-testid=\"position-selected-locations\"\n              id=\"taglist\"\n              class=\"list-inline list-practice-area margin-b0\"\n            >\n              <li\n                class=\"tags-box\"\n                ng-if=\"location.isSelected\"\n                ng-repeat=\"location in ctrl.position.locations\"\n              >\n                {{location.name}}\n              </li>\n              <a\n                href=\"\"\n                class=\"fa fa-pencil\"\n                id=\"select-locations\"\n                ng-click=\"ctrl.openLocationModal(ctrl.position.locations,$event)\"\n              ></a>\n            </ul>\n          </div>\n        </div>\n        <br />\n\n        <!-- Address -->\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">Address</div>\n          <div class=\"col-md-6\">\n            <input\n              type=\"text\"\n              data-testid=\"position-address\"\n              autocomplete=\"off\"\n              placeholder=\"Address\"\n              class=\"form-control\"\n              ng-model=\"ctrl.position.employer.address\"\n            />\n            <!-- <div class=\"space\"></div> -->\n          </div>\n        </div>\n        <br />\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">Position Expires on</div>\n\n          <div\n            class=\"col-md-6\"\n            name=\"pqe\"\n            data-ng-controller=\"DatepickerDemoCtrl\"\n          >\n            <div\n              data-testid=\"position-expiryAt\"\n              class=\"input-group add-new-job-ui-datepicker\"\n            >\n              <input\n                type=\"text\"\n                disabled\n                placeholder=\"Position Expiry date\"\n                class=\"form-control custom-readonly\"\n                uib-datepicker-popup=\"dd-MMMM-yyyy\"\n                ng-model=\"ctrl.position.expiresAt\"\n                is-open=\"opened\"\n                datepicker-options=\"dateOptions\"\n                date-disabled=\"disabled(date, mode)\"\n                close-text=\"Close\"\n              />\n              <span class=\"input-group-addon\" ng-click=\"open($event)\">\n                <i class=\"fa fa-calendar\"></i>\n              </span>\n            </div>\n          </div>\n        </div>\n        <br /><br />\n\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">Min PQE *</div>\n          <span class=\"ui-select\" style=\"margin-left:0; width: 50pt;\">\n                    <select data-testid=\"position-minpqe\" class=\"form-control\" ng-model=\"ctrl.position.minPqe\" required ng-change=\"ctrl.onPqeChange()\" style=\"padding: 8px 10px; width: 100%;\"\">\n            <option ng-repeat=\"item in ctrl.pqeValues\" ng-value=\"{{item}}\">{{item}}</option>\n            </select>\n          </span>\n            <div class=\"space\"></div>\n          </div>\n\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">Max PQE *</div>\n          <span class=\"ui-select\" style=\"margin-left:0; width: 50pt;\">\n                    <select data-testid=\"position-maxpqe\" class=\"form-control\" ng-model=\"ctrl.position.maxPqe\" ng-change=\"ctrl.onPqeChange()\" required style=\"padding: 8px 10px; width: 100%;\"\">\n            <option ng-repeat=\"item in ctrl.pqeValues\" ng-value=\"{{item}}\">{{item}}</option>\n            </select>\n          </span>\n            <div class=\"space\"></div>\n          </div>\n\n\n        <br />\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">Contract: *</div>\n          <div class=\" col-md-8\">\n            <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n              <select\n                data-testid=\"position-contract\"\n                data-ng-model=\"ctrl.position.contractTypeId\"\n                style=\"padding: 8px 10px; width: 100%;\"\n                required\n              >\n                <option\n                  ng-repeat=\"contract in ctrl.contractType\"\n                  ng-value=\"{{contract.id}}\"\n                  >{{contract.name}}</option\n                >\n              </select>\n            </span>\n          </div>\n        </div>\n        <br />\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">Occupation: *</div>\n          <div class=\" col-md-8\">\n            <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n              <select\n                data-testid=\"position-occupation\"\n                data-ng-model=\"ctrl.position.occupationId\"\n                style=\"padding: 8px 10px; width: 100%;\"\n                required\n              >\n                <option\n                  ng-repeat=\"occupation in ctrl.occupations\"\n                  ng-value=\"{{occupation.id}}\"\n                  >{{occupation.name}}</option\n                >\n              </select>\n            </span>\n          </div>\n        </div>\n        <br />\n\n        <!-- extra field 1 -->\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">Position Description</div>\n          <div class=\"col-md-8\">\n            <div class=\"text-editor\" data-testid=\"position-description\">\n              <textarea\n                name=\"positionDescription\"\n                class=\"form-control\"\n                ckeditor=\"ctrl.positionDetailEditorOptions\"\n                ng-model=\"ctrl.position.description\"\n              >\n              </textarea>\n\n              <p\n                class=\"email-body-error-message\"\n                ng-show=\"placeholdersModified\"\n              >\n                Placeholders cannot be changed from Email body and Subject line\n              </p>\n            </div>\n          </div>\n        </div>\n        <br />\n\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right margin-t0\">Listing Type</div>\n          <div class=\"col-md-8\">\n            <dd>\n              <label class=\"ui-radio\"\n                ><input\n                  data-testid=\"position-type\"\n                  name=\"positionType\"\n                  type=\"radio\"\n                  ng-value=\"1\"\n                  ng-model=\"ctrl.position.positionType\"\n                  checked\n                /><span>Regular</span></label\n              >\n              <label class=\"ui-radio\"\n                ><input\n                  data-testid=\"position-type\"\n                  name=\"positionType\"\n                  type=\"radio\"\n                  ng-value=\"2\"\n                  ng-model=\"ctrl.position.positionType\"\n                /><span>Custom</span></label\n              >\n\n              <label class=\"ui-radio\"\n                ><input\n                  data-testid=\"position-type\"\n                  name=\"positionType\"\n                  type=\"radio\"\n                  ng-value=\"3\"\n                  ng-model=\"ctrl.position.positionType\"\n                /><span>Connect</span></label\n              >\n\n              <label class=\"ui-radio\"\n                ><input\n                  data-testid=\"position-type\"\n                  name=\"positionType\"\n                  type=\"radio\"\n                  ng-value=\"4\"\n                  ng-model=\"ctrl.position.positionType\"\n                /><span>Speculative</span></label\n              >\n\n              <label class=\"ui-radio\" ng-show=\"ctrl.position.employer.isInHouse\"\n                ><input\n                  data-testid=\"position-type\"\n                  name=\"positionType\"\n                  type=\"radio\"\n                  ng-value=\"5\"\n                  ng-model=\"ctrl.position.positionType\"\n                /><span>ATS Direct Link</span></label\n              >\n            </dd>\n          </div>\n        </div>\n\n        <div ng-show=\"ctrl.position.positionType == 1\" class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">Source/External Link</div>\n          <div class=\"col-md-6\">\n            <input\n              data-testid=\"position-regular-externalUrl\"\n              ng-disabled=\"ctrl.position.positionType !=1\"\n              type=\"text\"\n              autocomplete=\"off\"\n              placeholder=\"Enter your link..\"\n              class=\"form-control\"\n              ng-model=\"ctrl.position.externalUrl\"\n            />\n          </div>\n        </div>\n\n        <div ng-show=\"ctrl.position.positionType == 5\" class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">ATS Direct Link *</div>\n          <div class=\"col-md-6\">\n            <input\n              data-testid=\"position-ats-externalUrl\"\n              ng-disabled=\"ctrl.position.positionType != 5\"\n              type=\"text\"\n              autocomplete=\"off\"\n              placeholder=\"Enter your link..\"\n              class=\"form-control\"\n              ng-model=\"ctrl.position.externalUrl\"\n              ng-required=\"ctrl.position.positionType == 5\"\n            />\n          </div>\n        </div>\n        <br\n          ng-show=\"ctrl.position.positionType == 5 || ctrl.position.positionType == 1\"\n        />\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\">Position Visibility *</div>\n          <div class=\" col-md-6\">\n            <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n              <select\n                data-testid=\"position-visibility\"\n                data-ng-model=\"ctrl.position.visible\"\n                style=\"padding: 8px 10px; width: 100%;\"\n                required\n              >\n                <option ng-value=\"\" selected style=\"display:none;\"\n                  >Visibility</option\n                >\n                <option\n                  ng-selected=\"ctrl.position.visible == true\"\n                  ng-value=\"true\"\n                  >Visible to Applicants</option\n                >\n                <option\n                  ng-selected=\"ctrl.position.visible == false\"\n                  ng-value=\"false\"\n                  >Invisible to Applicants</option\n                >\n              </select>\n            </span>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"modal-footer\">\n        <div class=\"content\">\n          <button\n            ng-if=\"!ctrl.editPositionModal\"\n            data-testid=\"btn-position-creation\"\n            class=\"btn btn-success\"\n            ng-click=\"positionForm.$valid && ctrl.createPosition()\"\n          >\n            Add\n          </button>\n          <button\n            ng-if=\"ctrl.editPositionModal\"\n            data-testid=\"btn-update-position\"\n            class=\"btn btn-success\"\n            ng-click=\"ctrl.updatePosition()\"\n          >\n            Update\n          </button>\n          <button\n            data-testid=\"job-cancel\"\n            class=\"closebtn btn\"\n            ng-click=\"ctrl.closePositionModal()\"\n          >\n            Cancel\n          </button>\n        </div>\n      </div>\n    </form>\n  </div>\n\n  <!-- </script> -->\n  <script type=\"text/ng-template\" id=\"practice-area-modal.html\">\n    <practice-Area></practice-Area>\n  </script>\n  <delete-Position></delete-Position>\n  <script type=\"text/ng-template\" id=\"locations-modal.html\">\n    <locations-Modal></locations-Modal>\n  </script>\n</span>\n"

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	module.exports = "<script type=\"text/ng-template\" id=\"date-modal.html\">\n  <div class=\"modal-header\">\n    <center>\n      <h3>{{ctrl.selectedModal.title}}</h3>\n    </center>\n  </div>\n  <div class=\"modal-body\">\n    <center>\n      <div class=\"modal-row\">\n        <div name=\"date-modal\" data-ng-controller=\"DatePickerController as datePickerCtrl\" style=\"width:50%\">\n            <div class=\"input-group ui-datepicker\">\n              <input id= \"datepicker\"\n                type=\"text\"\n                disabled\n                class=\"custom-readonly form-control\"\n                placeholder =\"Date-Month-Year\"\n                uib-datepicker-popup=\"{{datePickerCtrl.format}}\"\n                ng-model=\"ctrl.selectedModal.date\"\n                is-open=\"datePickerCtrl.opened\"\n                min=\"datePickerCtrl.minDate\"\n                max=\"'2015-06-22'\"\n                datepicker-options=\"datePickerCtrl.dateOptions\"\n                ng-class=\"ctrl.selectedModal.errorClass\"\n                close-text=\"Close\"\n                required>\n                <span class=\"input-group-addon\" ng-click=\"datePickerCtrl.open($event)\"><i class=\"fa fa-calendar\"></i></span>\n            </div>\n        </div>\n        <div data-ng-controller=\"TimePickerController as timePickerCtrl\"\n             ng-if=\"ctrl.selectedModal.isDate\">\n          <div ng-model=\"ctrl.selectedModal.date\" style=\"display:inline-block;\">\n                  <uib-timepicker ng-model=\"ctrl.selectedModal.date\" class=\"ui-timepicker\" hour-step=\"timePickerCtrl.hourStep\" minute-step=\"timePickerCtrl.minStep\" show-meridian=\"timePickerCtrl.isMeridian\"></uib-timepicker>\n          </div>\n  </div>\n      </div>\n    </center>\n      </div>\n  <div class=\"modal-footer\">\n    <div class=\"modalFooter\">\n          <button class=\"btn btn-info\" ng-disabled=\"!ctrl.selectedModal.date\" ng-click=\"ctrl.save()\">Save</button>\n          <button class=\"btn btn-gap-v btn-default\" ng-click=\"ctrl.cancel()\">Cancel</button>\n          <button class=\"btn btn-gap-v btn-danger\"  ng-if=\"ctrl.selectedModal.isDelete\"  ng-click=\"ctrl.deleteConfirmationPopup(ctrl.selectedModal.title, $event)\">Delete</button>\n      </div>\n  </div>\n\n  <script type=\"text/ng-template\" id=\"delete-confirmation-modal.html\">\n    <div class=\"modal-header\">\n      <center>\n        <h3>Delete {{ctrl.title}}?</h3>\n       </center>\n    </div>\n    <div class=\"modal-footer\">\n      <center>\n        <button class=\"btn btn-info\" ng-click=\"ctrl.confirmDelete()\">Yes</button>\n        <button class=\"btn btn-gap-v btn-default\" ng-click=\"ctrl.cancel()\">No</button>\n      </center>\n    </div>\n  </script>\n</script>\n"

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	module.exports = "<script type=\"text/ng-template\" id=\"delete-employer-modal.html\">\n  <div class=\"modal-header\">\n    <center>\n      <h3>Delete Employer</h3>\n      <h5>Are you sure you want to delete this employer?</h5>\n    </center>\n  </div>\n  <div class=\"modal-footer\">\n    <center>\n      <button class=\"btn btn-info\" ng-click=\"ctrl.delete()\">Yes</button>\n      <button class=\"btn btn-default\" ng-click=\"ctrl.cancel()\">No</button>\n    </center>\n  </div>\n</script>\n"

/***/ }),
/* 461 */
/***/ (function(module, exports) {

	module.exports = "<script type=\"text/ng-template\" id=\"delete-position-modal.html\">\n  <div class=\"modal-header\">\n    <center>\n      <h3>Delete Position</h3>\n      <h5>Are you sure you want to delete this position?</h5>\n    </center>\n  </div>\n  <div class=\"modal-footer\">\n    <center>\n      <button class=\"btn btn-info\" ng-click=\"ctrl.delete()\">Yes</button>\n      <button class=\"btn btn-gap-v btn-default\" ng-click=\"ctrl.cancel()\">No</button>\n    </center>\n  </div>\n</script>\n"

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	module.exports = "<footer class=\"footer\">\n  <div class=\"container\">\n    <div class=\"panel-body text-center margin-b10t15\">\n      <div class=\"row\" ng-if=\"user.isCandidate\">\n        <div class=\"consultant-text text-center\" style=\"padding-bottom: 20px;\">\n          <h5 class=\"hdng-tshadow\">\n            Contact {{contactUsername}} |\n            <a class=\"contact-info\" href=\"mailto:{{contactEmail}}\"\n              >{{contactEmail}}</a\n            >\n            |\n            <a class=\"contact-info\" href=\"tel:{{contactPhone}}\"\n              >{{contactPhone}}</a\n            >\n          </h5>\n        </div>\n      </div>\n      <ul class=\"list-inline\">\n        <li ng-if=\"!user\"><a href=\"/signup\">Sign up</a></li>\n        <li ng-if=\"!user\"><a href=\"/get-in-touch\">Hiring?</a></li>\n        <li><a href=\"/about\">About</a></li>\n        <li><a href=\"/faqs\">FAQ</a></li>\n        <li><a target=\"_blank\" href=\"https://blog.lexstep.com\">Blog</a></li>\n        <li><a href=\"/terms-conditions\">Terms</a></li>\n        <li><a href=\"/privacy-policy\">Privacy Policy</a></li>\n      </ul>\n\n      <div class=\"clearfix\"></div>\n\n      <ul class=\"list-inline\">\n        <li>\n          <a\n            target=\"_blank\"\n            ng-click=\"socialLinkClick('Youtube')\"\n            href=\"https://www.youtube.com/channel/UC8LCUVMk7Wb5qn0oO8BLXJw\"\n            ><i class=\"fa fa-lg fa-youtube-square\"></i> Youtube</a\n          >\n        </li>\n        <li>\n          <a\n            target=\"_blank\"\n            ng-click=\"socialLinkClick('Twitter')\"\n            href=\"https://twitter.com/lexstepuk\"\n            ><i class=\"fa fa-lg fa-twitter-square\"></i> Twitter</a\n          >\n        </li>\n        <li>\n          <a\n            target=\"_blank\"\n            ng-click=\"socialLinkClick('Facebook')\"\n            href=\"https://www.facebook.com/LexStepUK\"\n            ><i class=\"fa fa-lg fa-facebook-square\"></i> Facebook</a\n          >\n        </li>\n        <li>\n          <a\n            target=\"_blank\"\n            ng-click=\"socialLinkClick('Linkedin')\"\n            href=\"https://www.linkedin.com/company/lexstep\"\n            ><i class=\"fa fa-lg fa-linkedin-square\"></i> LinkedIn</a\n          >\n        </li>\n      </ul>\n\n      <p class=\"text-muted hidden\">\n        LexStep is a trading name of Lexstep Limited (company number 09454360)\n        registered in England<br />\n        whose registered office is at 4th Floor, 86 - 90 Paul Street, London,\n        EC2A 4NE<br /><br />\n      </p>\n      <p>© {{currentYear}} LEXSTEP Ltd. All rights reserved.</p>\n    </div>\n  </div>\n  <!-- / .container -->\n</footer>\n"

/***/ }),
/* 463 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"col-md-12 pipleline-container\">\n  <ul class=\"pipeline\">\n    <li\n      ng-class=\"{'active': (stage.selected && stage.hasChild), 'activePipelineGrid': stage.isActive, 'prevPipelineActive': (stage.prevActive && !stage.selected), 'font-bold': (stage.selected && !stage.hasChild)}\"\n      id=\"{{stage.id}}\"\n      class=\"child-tab-list\"\n      ng-click=\"onClickPipeline(stage)\"\n      ng-repeat=\"stage in groupList\"\n      ng-if=\"!stage.isHidden\"\n      ng-style=\"fetchActiveTab(stage.color, stage) \"\n    >\n      <div class=\"tabHeading\">\n        <h4 class=\"tab-heading\">\n          <span\n            ng-style=\"!stage.hasChild && {'color':'{{stage.color}}'}\"\n            ng-class=\"{'font-bold': (stage.selected && !stage.hasChild)}\"\n          >\n            {{stage.applicationsCount}}\n          </span>\n        </h4>\n        <p>{{stage.name}}</p>\n      </div>\n      <span\n        ng-style=\"fetchArrowStyle(stage.color)\"\n        class=\"triangular-tabs\"\n      ></span>\n    </li>\n  </ul>\n</div>\n"

/***/ }),
/* 464 */
/***/ (function(module, exports) {

	module.exports = "<header class=\"top_header navbar-inverse clearfix\">\n  <div class=\"navbar navbar-static-top navbar-create-profile margin-b0\">\n    <div class=\"logo-container\">\n      <a href=\"/\" class=\"logo\" ng-if=\"!user || !user.isAdmin\">LEXSTEP.com</a>\n      <a href=\"/\" class=\"logo\" ng-if=\"user && user.isAdmin\">LEXSTEP</a>\n      <p\n        ng-if=\"user && user.isAdmin && applicationInfo && serverInfo && applicationInfo.version && serverInfo.version\"\n        class=\"version\"\n      >\n        <span class=\"version-type\">client</span> v{{applicationInfo.version}}\n        <span class=\"version-type\">server</span> v{{serverInfo.version}}\n      </p>\n    </div>\n\n    <div id=\"filler\"></div>\n\n    <div class=\"nav-container text-right\">\n      <div class=\"navbar-header hidden-lg\">\n        <span ng-if=\"user.isCandidate\">\n          <a href=\"/user-profile\" class=\"profile-pic\">\n            <img\n              ng-src=\"{{user.profilePicSrc}}\"\n              alt=\"\"\n              class=\"img-circle img30_30\"\n            />\n            >\n          </a>\n        </span>\n        <button\n          type=\"button\"\n          class=\"navbar-toggle show-sm\"\n          ng-click=\"showDropDown()\"\n          data-toggle=\"collapse\"\n          id=\"navbar-bars\"\n          data-target=\"#navbar-collapse\"\n        >\n          <span ng-click=\"hideAllNotifications()\">\n            <span class=\"sr-only\">Toggle navigation</span>\n            <span class=\"icon-bar\"></span>\n            <span class=\"icon-bar\"></span>\n            <span class=\"icon-bar\"></span>\n          </span>\n        </button>\n      </div>\n      <ul\n        class=\"nav top-nav nav-justified pull-right hide-sm navbar-collapse\"\n        ng-class=\"showClass\"\n        id=\"navbar-collapse\"\n        ng-if=\"user.isNewUser || user.isAdmin\"\n      >\n        <li\n          ng-if=\"user.isAdmin && ['admin', 'agent', 'ops','intern'].includes(user.type)\"\n        >\n          <a\n            href=\"/admin/lawyer-listing\"\n            ng-click=\"hideDropDown()\"\n            ng-class=\"{'highlightNavbar': (path == '/admin/lawyer-listing')}\"\n            >Lawyers</a\n          >\n        </li>\n        <li ng-if=\"user.isAdmin\">\n          <a\n            href=\"/admin/employers-listing\"\n            ng-class=\"{'highlightNavbar': (path == '/admin/employers-listing')}\"\n            ng-click=\"hideDropDown()\"\n            >Employers</a\n          >\n        </li>\n        <li ng-if=\"user.isAdmin\" ng-click=\"hideDropDown();\">\n          <a\n            href=\"/admin/admin-listings?list=jobs\"\n            ng-class=\"{'highlightNavbar': (path == '/admin/admin-listings?list=jobs' || path == '/admin/admin-listings' || path.includes('/admin/matching-lawyers') )}\"\n            >Positions</a\n          >\n        </li>\n        <li\n          ng-if=\"user.isAdmin && ['admin', 'agent', 'ops','intern'].includes(user.type)\"\n        >\n          <a\n            href=\"/admin/application-listing\"\n            ng-click=\"hideDropDown()\"\n            ng-class=\"{'highlightNavbar': (path == '/admin/application-listing')}\"\n            >Applications</a\n          >\n        </li>\n        <!-- <li ng-if=\"user.isAdmin\" ng-click=\"hideDropDown();\">\n                <a href=\"/admin/admin-listings?list=jobs\" ng-class=\"{'highlightNavbar': (path == '/admin/admin-listings?list=jobs' || path == '/admin/admin-listings')}\">{{'navBar.browseFirmsJobsAdmin.label'| translate}}</a>\n            </li>\n            <li ng-if=\"user.isAdmin\" ng-click=\"hideDropDown();\" >\n                <a href=\"/admin/admin-listings?list=inhouse-jobs\" ng-class=\"{'highlightNavbar': (path == '/admin/admin-listings?list=inhouse-jobs')}\">IN-HOUSE JOBS</a>\n            </li> -->\n        <li\n          ng-if=\"user.isAdmin && ['admin', 'ops'].includes(user.type)\"\n          ng-click=\"hideDropDown();\"\n        >\n          <a\n            href=\"/admin/email-listing\"\n            ng-click=\"hideDropDown()\"\n            ng-class=\"{'highlightNavbar': (path == '/admin/email-listing')}\"\n            >EMAILS</a\n          >\n        </li>\n        <li ng-if=\"user.isAdmin\" ng-click=\"hideDropDown();\">\n          <a\n            href=\"/admin/referral-listing\"\n            ng-click=\"hideDropDown()\"\n            ng-class=\"{'highlightNavbar': (path.includes('/admin/referral-listing'))}\"\n            >REFERRALS</a\n          >\n        </li>\n\n        <li ng-if=\"user.isNewUser\">\n          <a\n            href=\"/profile\"\n            ng-click=\"hideDropDown()\"\n            ng-class=\"{'highlightNavbar': (path == '/profile')}\"\n            >My Profile</a\n          >\n        </li>\n        <li ng-if=\"user.isNewUser\">\n          <a\n            href=\"/invite-friend\"\n            ng-click=\"hideDropDown()\"\n            ng-class=\"{'highlightNavbar': (path == '/invite-friend')}\"\n            >Earn £1000!</a\n          >\n        </li>\n        <li ng-if=\"user.isNewUser\">\n          <a\n            ng-href=\"{{'blogLink'|translate}}\"\n            target=\"_blank\"\n            ng-click=\"hideDropDown()\"\n            >Blog</a\n          >\n        </li>\n        <li uib-dropdown is-open=\"status.isopen1\">\n          <span class=\"user-name hidden\">Welcome</span>\n          <a\n            uib-dropdown-toggle\n            type=\"button\"\n            class=\"btn btn-noline\"\n            aria-expanded=\"true\"\n            aria-haspopup=\"true\"\n            >{{user.firstName}} <span class=\"caret\"></span\n          ></a>\n          <ul uib-dropdown-menu class=\" menu-right\" role=\"menu\">\n            <li ng-if=\"user.isNewUser\">\n              <a href=\"/invite-friend\" ng-click=\"hideDropDown()\">Earn £1000!</a>\n            </li>\n            <li ng-if=\"user.isAdmin\">\n              <a href=\"/admin/profile\" ng-click=\"hideDropDown()\">\n                My Profile\n              </a>\n            </li>\n            <li>\n              <a href=\"/change-password\" ng-click=\"hideDropDown()\"\n                >{{'navBar.changePasswordBtn.label'|translate}}</a\n              >\n            </li>\n            <li ng-click=\"hideDropDown();logOut()\">\n              <a href=\"javascript:;\" class=\"btn-signout\"\n                >{{'navBar.signOutBtn.label'|translate}}</a\n              >\n            </li>\n          </ul>\n        </li>\n      </ul>\n      <ul\n        class=\"nav top-nav nav-justified pull-right hide-sm navbar-collapse\"\n        ng-class=\"showClass\"\n        id=\"navbar-collapse\"\n        ng-if=\"user.isCandidate\"\n      >\n        <!-- <li class=\"dropdown dropdown-hover-toggle\">\n                  <a href=\"{{ !isSpecOppsUrl ?'/matches' :'/opportunities'}}\" class=\"btn btn-noline\" ng-class=\"(path == '/matches' || path == '/opportunities')?'highlightNavbar':''\" data-hover=\"dropdown\">\n                    Matches\n                    <span class=\"caret\"></span>\n                  </a>\n                  <ul class=\"dropdown-menu menu-right\" role=\"menu\">\n                      <li>\n                        <a href=\"/matches\" style=\"color:#babbc1;\" ng-class=\"(path == '/matches')?'highlightNavbar':''\">\n                          MY LEXSTEP MATCHES\n                        </a>\n                      </li>\n                      <li>\n                        <a href=\"/opportunities\" style=\"color:#babbc1;\" ng-class=\"(path == '/opportunities')?'highlightNavbar':''\">\n                          MAKE ME AN OFFER\n                        </a>\n                      </li>\n                  </ul>\n                </li> -->\n        <li uib-dropdown is-open=\"status.isopen2\">\n          <a\n            uib-dropdown-toggle\n            type=\"button\"\n            href=\"{{ !isSpecOppsUrl ?'/matches' :'/opportunities'}}\"\n            class=\"btn btn-noline\"\n            aria-expanded=\"true\"\n            aria-haspopup=\"true\"\n            data-toggle=\"dropdown\"\n            ng-class=\"(path == '/matches' || path == '/opportunities')?'highlightNavbar':''\"\n          >\n            Matches\n            <span class=\"caret\"></span>\n          </a>\n          <ul uib-dropdown-menu class=\"menu-right\" role=\"menu\">\n            <li>\n              <a\n                href=\"/matches/\"\n                style=\"color:#babbc1;\"\n                ng-class=\"(path == '/matches')?'highlightNavbar':''\"\n              >\n                MY LEXSTEP MATCHES\n              </a>\n            </li>\n            <li>\n              <a\n                href=\"/opportunities/ \"\n                style=\"color:#babbc1;\"\n                ng-class=\"(path == '/opportunities')?'highlightNavbar':''\"\n              >\n                MAKE ME AN OFFER\n              </a>\n            </li>\n            <!-- <li ng-click=\" showClass=''; logOut()\" ng-click=\"hideDropDown()\"><a  href=\"javascript:;\" class=\"btn-signout\">Sign Out</a></li> -->\n          </ul>\n        </li>\n        <li>\n          <a\n            href=\"/inhouse-jobs\"\n            class=\"btn-signout\"\n            ng-click=\"hideDropDown()\"\n            ng-class=\"{'highlightNavbar': (path == '/inhouse-jobs')}\"\n            >In-House Jobs</a\n          >\n        </li>\n        <li>\n          <a\n            href=\"/connections\"\n            ng-click=\"trackPageRedirection();hideDropDown()\"\n            ng-class=\"{'highlightNavbar': (path == '/connections')}\"\n            >{{'navBar.connections.label'|translate}}</a\n          >\n        </li>\n        <li>\n          <a\n            href=\"/invite-friend\"\n            ng-click=\"hideDropDown()\"\n            ng-class=\"{'highlightNavbar': (path == '/invite-friend')}\"\n            >Earn £1000!</a\n          >\n        </li>\n        <li>\n          <a\n            ng-href=\"{{'blogLink'|translate}}\"\n            target=\"_blank\"\n            ng-click=\"hideDropDown()\"\n            >Blog</a\n          >\n        </li>\n        <li><div class=\"v-devider\">&nbsp;</div></li>\n        <li class=\"profile-pic\">\n          <a href=\"/user-profile\">\n            <img\n              ng-src=\"{{user.profilePicSrc}}\"\n              alt=\"\"\n              class=\"img-circle img30_30\"\n            />\n          </a>\n        </li>\n        <li uib-dropdown is-open=\"status.isopen1\">\n          <a\n            uib-dropdown-toggle\n            type=\"button\"\n            class=\"btn btn-noline\"\n            aria-expanded=\"true\"\n            aria-haspopup=\"true\"\n            data-toggle=\"dropdown\"\n            ng-class=\"{'highlightNavbar': (path == '/user-profile')}\"\n          >\n            {{user.firstName}}\n            <span class=\"caret\"></span>\n          </a>\n          <ul uib-dropdown-menu class=\"menu-right\" role=\"menu\">\n            <li>\n              <a href=\"/user-profile\" ng-click=\"hideDropDown()\">\n                My Profile\n              </a>\n            </li>\n            <li>\n              <a href=\"/change-password\" ng-click=\"hideDropDown()\"\n                >Change Password</a\n              >\n            </li>\n            <li ng-click=\" showClass=''; logOut()\" ng-click=\"hideDropDown()\">\n              <a href=\"javascript:;\" class=\"btn-signout\">Sign Out</a>\n            </li>\n          </ul>\n        </li>\n      </ul>\n\n      <ul\n        class=\"nav top-nav nav-justified pull-right hide-sm navbar-collapse\"\n        ng-class=\"showClass\"\n        id=\"navbar-collapse\"\n        ng-if=\"!user\"\n      >\n        <!--<li hidden><a href=\"/for-employers\">For Employers</a></li>-->\n        <li>\n          <a\n            ng-href=\"{{'blogLink'|translate}}\"\n            target=\"_blank\"\n            ng-click=\"hideDropDown()\"\n            >Blog</a\n          >\n        </li>\n        <li>\n          <a\n            ng-href=\"{{'youtubeLink'|translate}}\"\n            target=\"_blank\"\n            ng-click=\"hideDropDown('videos')\"\n            >Videos</a\n          >\n        </li>\n        <li>\n          <a\n            ng-class=\"{'highlightNavbar': (path == '/faqs')}\"\n            href=\"/faqs\"\n            ng-click=\"hideDropDown()\"\n            >FAQ</a\n          >\n        </li>\n        <li>\n          <a\n            ng-class=\"{'highlightNavbar': (path == '/about')}\"\n            href=\"/about\"\n            ng-click=\"hideDropDown()\"\n            >About</a\n          >\n        </li>\n        <li>\n          <a\n            ng-class=\"{'highlightNavbar': (path == '/get-in-touch')}\"\n            href=\"/get-in-touch\"\n            ng-click=\"hideDropDown()\"\n            >Hiring?</a\n          >\n        </li>\n        <li>\n          <a\n            ng-class=\"{'highlightNavbar': (path == '/invite-friends')}\"\n            href=\"/invite-friends\"\n            ng-click=\"hideDropDown()\"\n            >Earn £1000!</a\n          >\n        </li>\n        <li>\n          <a\n            ng-class=\"{'highlightNavbar': (path == '/signin')}\"\n            href=\"/signin\"\n            class=\"btn-signout\"\n            ng-click=\"hideDropDown()\"\n            >{{'btn.signIn.label'| translate}}</a\n          >\n        </li>\n        <li>\n          <a\n            ng-class=\"{'highlightNavbar': (path == '/signup')}\"\n            href=\"/signup\"\n            class=\"btn-signout\"\n            ng-click=\"hideDropDown('sign-up')\"\n            >{{'navBar.btn.signUp.label'| translate}}</a\n          >\n        </li>\n      </ul>\n    </div>\n    <!-- <div class=\"hidden col-md-8 col-xs-8\">\n          <div type=\"info\" class=\"callout bg-danger\" >\n           <span class=\"hidden glyphicon glyphicon-lock\"></span> &nbsp;<strong>{{topAlert}}</strong>\n         </div>\n        </div> -->\n  </div>\n</header>\n"

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	module.exports = "<div data-testid=\"candidate-preference-modal\">\n  <!--\n    /****************************************************************************************/\n    /*** 'lawyer Preferences' extracted & refactored By Fahad Akbar(fahadakbar24@gmail.com)**/\n    /****************************************************************************************/\n  -->\n  <script type=\"text/ng-template\" id=\"lawyer-preferences-template.html\">\n    <div class=\"modal-header\">\n      <center>\n        <h3>{{heading|translate}}</h3>\n        <h5>{{subHeading|translate}}</h5>\n      </center>\n    </div>\n    <div class=\"modal-body custom-modal clearfix\">\n      <div class=\"modal-row\" ng-if=\"showTextArea\">\n        <h5>\n          <strong>{{'lawyerProfile.About.responseModal.moveQuestion'|translate}}</strong>\n        </h5>\n        <div class=\"\">\n          <textarea data-testid='reason-move' name=\"move reason\" id=\"\" class=\"form-control\" rows=\"4\" style=\"resize:none\" data-ng-model=\"updatedData.data\"></textarea>\n        </div>\n      </div>\n      <div class=\"modal-row\" ng-if=\"showAdditionalInfo\">\n        <h5>\n          <strong>{{'lawyerProfile.About.response.moreInfoQuestion'|translate}}</strong>\n        </h5>\n        <div class=\"\">\n          <textarea data-testid=\"reason-info\" name=\"about\" id=\"\" class=\"form-control\" rows=\"4\" style=\"resize:none\" data-ng-model=\"updatedData.data\"></textarea>\n        </div>\n      </div>\n      <div class=\"modal-row custom-modal\" ng-if=\"showLocations\">\n        <div class=\"col-md-12\">\n          <div class=\"\" data-ng-repeat=\"region in data | orderBy: 'loc_ID'\">\n            <span>\n              <i data-testid=\"expand-collapse\" ng-hide=\"region.showChildLocations\" ng-click=\"displayChildLocations(region)\" class=\"fa fa-plus expand-collapse-button\"\n                aria-hidden=\"true\"></i>\n            </span>\n            <span>\n              <i ng-hide=\"!region.showChildLocations\" ng-click=\"hideChildLocations(region)\" class=\"fa fa-minus expand-collapse-button\"\n                aria-hidden=\"true\"></i>\n            </span>\n            <label class=\"ui-checkbox\">\n              <input type=\"checkbox\" ng-click=\"selectLocation($event , region , 2)\" data=\"{{loc_ID}}\" ng-checked=\"region.isSelected\">\n              <span class=\"checkbox-group-heading\">\n                <strong>{{region.loc_name}}</strong>\n              </span>\n            </label>\n            <ul class=\" practice-area-list padding-l70 clearfix\" ng-show=\"region.showChildLocations\">\n              <li data-ng-repeat=\"location in region.locations\">\n                <label class=\"ui-checkbox\">\n                  <input type=\"checkbox\" data=\"{{location.loc_ID}}\" ng-click=\"selectLocation($event , location , 1)\" ng-checked=\"location.isSelected\">\n                  <span>{{location.loc_name}}</span>\n                </label>\n                <ul class=\" sub-list clearfix\">\n                  <li data-ng-repeat=\"sub in location.sub_areas\">\n                    <label class=\"ui-checkbox\">\n                      <input type=\"checkbox\" ng-click=\"selectLocation($event , sub , 0)\" ng-checked=\"sub.isSelected\">\n                      <span>{{sub.loc_name}}</span>\n                    </label>\n                  </li>\n                </ul>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div>\n      <div class=\"modal-row\" ng-if=\"showLanguages\">\n        <div data-testid=\"language-modal\" class=\"col-md-12 lang-modal\">\n          <ul\n          data-testid=\"languages-name\"\n\n          class=\"checkbox-grid pref-language-list clearfix\">\n            <li ng-repeat=\"user_data in data\">\n              <label class=\"ui-checkbox\">\n                <input name=\"user_data.name\" type=\"checkbox\" ng-true-value=\"{{user_data.code}}\" ng-false-value=\"false\"\n                  data=\"{{user_data.code}}\" ng-click=\"updateData($event , user_data)\" ng-checked=\"{{user_data.isSelected}}\">\n                <span>{{user_data.name}}</span>\n              </label>\n            </li>\n          </ul>\n        </div>\n      </div>\n\n      <div class=\"modal-row custom-modal-overflow-x-hidden\" ng-if=\"showJurisdictions\">\n        <div class=\"col-md-12 lang-modal\">\n          <ul\n          data-testid=\"jurisdictions-name\"\n          class=\"checkbox-grid pref-location-list clearfix\">\n            <li ng-repeat=\"user_data in data\">\n              <label class=\"ui-checkbox\">\n                <input name=\"user_data.name\" type=\"checkbox\" ng-value=\"user_data.id\" ng-click=\"updateData($event , user_data)\" ng-checked=\"{{user_data.isSelected}}\">\n                <span>{{user_data.name}}</span>\n              </label>\n            </li>\n          </ul>\n        </div>\n      </div>\n\n      <div class=\"modal-row custom-modal\" ng-if=\"showPractices\">\n        <div class=\"col-md-12\">\n          <div class=\"\" data-ng-repeat=\"law_area in data\">\n            <span ng-class=\"{'no-child': law_area.practices.length === 0}\">\n              <i ng-hide=\"law_area.showSubPracticeAreas || law_area.practices.length === 0\" ng-click=\"displaySubPracticeAreas(law_area)\"\n                class=\"fa fa-plus expand-collapse-button\" aria-hidden=\"true\"></i>\n            </span>\n            <span ng-class=\"{'no-child': law_area.practices.length === 0}\">\n              <i ng-hide=\"!law_area.showSubPracticeAreas\" ng-click=\"hideSubPracticeAreas(law_area)\" class=\"fa fa-minus expand-collapse-button\"\n                aria-hidden=\"true\"></i>\n            </span>\n            <label class=\"ui-checkbox\">\n              <input type=\"checkbox\" ng-click=\"selectPractices($event , law_area , 2)\" data=\"{{practice_ID}}\" ng-checked=\"law_area.isSelected\">\n              <span class=\"checkbox-group-heading\" ng-style=\"law_area.practices.length > 0 && {'font-weight': 'bold'}\">{{law_area.practice_name}}\n              </span>\n            </label>\n            <ul ng-show=\"law_area.showSubPracticeAreas\" class=\" practice-area-list padding-l70 clearfix\">\n              <li data-ng-repeat=\"practice in law_area.practices\">\n                <label class=\"ui-checkbox\">\n                  <input type=\"checkbox\" data=\"{{practice.loc_ID}}\" ng-click=\"selectPractices($event , practice , 1)\" ng-checked=\"practice.isSelected\">\n                  <span>{{practice.practice_name}}</span>\n                </label>\n                <ul class=\" sub-list clearfix\">\n                  <li data-ng-repeat=\"sub in practice.sub_areas\">\n                    <label class=\"ui-checkbox\">\n                      <input type=\"checkbox\" ng-click=\"selectPractices($event , sub , 0)\" ng-checked=\"sub.isSelected\">\n                      <span>{{sub.practice_name}}</span>\n                    </label>\n                  </li>\n                </ul>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\">\n      <center>\n        <button  data-testid=\"save-button\" class=\"btn btn-info\" ng-click=\"save()\" ng-if=\"!nextButtonShow\">Save</button>\n        <button  data-testid=\"save-button\" class=\"btn btn-info\" ng-click=\"save()\" ng-if=\"nextButtonShow\">Next</button>\n        <button class=\"btn btn-gap-v btn-default\" ng-click=\"cancel()\">Cancel</button>\n      </center>\n    </div>\n  </script>\n</div>\n"

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <!-- Salary Details Section -->\n  <div class=\"panel panel-default section-details\" data-testid=\"profile-salary\">\n    <div class=\"row panel-heading margin-lr0 padding-r5\">\n      <div class=\"col-xs-7 padding-lr0\">\n        <strong> <i class=\"glyphicon glyphicon-th\"></i> Salary Details</strong>\n        <span style=\"text-transform:none\">\n          <a\n            href=\"\"\n            tooltip=\"{{'lawyerProfile.salarySection.toolTip'|translate}}\"\n            tooltip-placement=\"bottom\"\n          >\n            <span class=\"badge badge-grey text-lowercase\">\n              <i class=\"fa fa-info\"></i>\n            </span>\n          </a>\n        </span>\n      </div>\n      <div class=\"col-xs-5 padding-lr0\">\n        <button\n          type=\"button\"\n          ng-click=\"fetchSalaryHistory()\"\n          id=\"add-salary\"\n          class=\"pull-right\"\n          ng-disabled=\"salaryHistoryAvailable <= 1\"\n          ng-class=\"{'salary-history-disabled': (salaryHistoryAvailable <= 1),'salary-history-selected': showHistory, 'history-status': !showHistory && !(salaryHistoryAvailable <= 1)}\"\n          ng-show=\"lockedSalary.isSelected\"\n        />\n\n        <button\n          type=\"button\"\n          ng-click=\"lockUnlockSalary()\"\n          id=\"add-salary\"\n          class=\"lock-status pull-right\"\n          ng-show=\"lockedSalary.isSelected\"\n        />\n        <button\n          ng-show=\"lockedSalary.isSelected\"\n          ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n          type=\"button\"\n          ng-click=\"AddSalaryDetails()\"\n          ng-touch=\"AddSalaryDetails()\"\n          id=\"add-salary\"\n          class=\"btn btn-noline-info btn-xs pull-right \"\n          ng-if=\"lawyerApproved\"\n        >\n          <span class=\"text-edit\" id=\"add-salary\">Add&nbsp;</span>\n          <i class=\"fa fa-plus\" id=\"add-salary\"></i>\n        </button>\n      </div>\n    </div>\n    <div class=\"panel-body\">\n      <img ng-show=\"false\" src=\"/images/Lock_pink.png\" />\n      <img ng-show=\"false\" src=\"/images/History-pink.png\" />\n      <div\n        ng-if=\"!lockedSalary.isSelected\"\n        class=\"overlay\"\n        ng-click=\"lockUnlockSalary()\"\n      >\n        <center class=\"\">\n          <img class=\"padlock-overlay\" src=\"/images/lock_with_background.png\" />\n        </center>\n        <center class=\"padlock-gray-text\">\n          Click to unlock salary details\n        </center>\n        <center class=\"padlock-lightgray-text\">Never shown to employers</center>\n      </div>\n      <!-- <img ng-if=\"!lockedSalary\" src=\"/images/lockScreen.png\" style=\"position:absolute; margin:-15px\" ng-click=\"lockUnlockSalary()\" > -->\n      <div\n        ng-show=\"lockedSalary.isSelected\"\n        class=\"callout callout-danger margin-t0 padding-t5l10\"\n      >\n        <p class=\"margin-0\">{{'neverShownToEmployersAlert'|translate}}</p>\n      </div>\n      <!-- Salary Edit Section Start-->\n      <div\n        ng-show=\"lockedSalary.isSelected\"\n        ng-if=\"editingSalaryDetails || addingSalaryDetails\"\n      >\n        <div data-testid=\"profile-salary-form\">\n          <div class=\"row margin-b5 margin-l1\">\n            <span\n              ><b\n                >{{candidate.employer.name}}, {{candidate.location.name}}</b\n              ></span\n            ><br />\n          </div>\n          <div class=\"margin-b5 col-xs-6 padding-lr0\">\n            <span class=\"ui-select\" style=\"margin-left: 1px; width: 99%;\">\n              <select\n                data-ng-model=\"editableSalary.unit\"\n                style=\"padding: 8px 10px; width: 100%;\"\n                ng-change=\"updateSalarySymbol(editableSalary.unit)\"\n                required\n              >\n                <option value=\"\" disabled selected style=\"display:none;\"\n                  >Select Currency</option\n                >\n                <option\n                  ng-repeat=\"unit in currencyList\"\n                  value=\"{{unit}}\"\n                  ng-selected=\"editableSalary.unit == unit\"\n                  >{{unit}}</option\n                >\n              </select>\n            </span>\n          </div>\n          <div class=\"margin-b5 col-xs-6 padding-lr0\">\n            <input\n              type=\"number\"\n              autocomplete=\"off\"\n              class=\"form-control\"\n              placeholder=\"{{salaryCurrencySymbol}}0.00\"\n              data-ng-model=\"editableSalary.amount\"\n              required\n              style=\"margin-left: 1px; width: 99%; height: 37px;\"\n            />\n          </div>\n          <div\n            class=\"row margin-b5 input-group ui-datepicker salary-datepicker col-xs-12\"\n            data-ng-controller=\"DatepickerDemoCtrl\"\n          >\n            <input\n              type=\"text\"\n              disabled\n              placeholder=\"Date of last salary review\"\n              class=\"form-control custom-readonly\"\n              uib-datepicker-popup=\"dd-MMMM-yyyy\"\n              ng-model=\"editableSalary.salaryDate\"\n              is-open=\"opened\"\n              datepicker-options=\"salaryDetailsDatePickerOptions\"\n              date-disabled=\"reverseDisabled(date, mode)\"\n              close-text=\"Close\"\n            />\n            <span class=\"input-group-addon\" ng-click=\"open($event)\">\n              <i class=\"fa fa-calendar\"></i>\n            </span>\n          </div>\n          <div class=\"row margin-b5\">\n            <span class=\"ui-select salary-per-pay\">\n              <select\n                title=\"Salary Pay Period\"\n                class=\"col-sm-1 admin-filter\"\n                ng-model=\"editableSalary.payPeriod\"\n              >\n                <option\n                  value=\"\"\n                  disabled\n                  selected\n                  style=\"display:none;\"\n                  ng-selected=\"!editableSalary.payPeriod\"\n                  >Salary Pay Period</option\n                >\n                <option value=\"per hour\">per hour</option>\n                <option value=\"per day\">per day</option>\n                <option value=\"per month\">per month</option>\n                <option value=\"per year\">per year</option>\n              </select>\n            </span>\n          </div>\n        </div>\n        <div data-testid=\"profile-bonus-form\">\n          <div class=\"row margin-b5 margin-t20 margin-l1\">\n            <span><b>Last Bonus</b></span\n            ><br />\n          </div>\n          <div class=\"margin-b5 col-xs-6 padding-lr0\">\n            <span class=\"ui-select\" style=\"margin-left: 1px; width: 99%;\">\n              <select\n                data-ng-model=\"editableSalary.bonusUnit\"\n                style=\"padding: 8px 10px; width: 100%;\"\n                ng-change=\"updateBonusSymbol(editableSalary.bonusUnit)\"\n              >\n                <option value=\"\" disabled selected style=\"display:none;\"\n                  >Select Currency</option\n                >\n                <option\n                  ng-repeat=\"unit in currencyList\"\n                  value=\"{{unit}}\"\n                  ng-selected=\"editableSalary.bonusUnit == unit\"\n                  >{{unit}}</option\n                >\n              </select>\n            </span>\n          </div>\n          <div class=\"margin-b5 col-xs-6 padding-lr0\">\n            <input\n              type=\"number\"\n              autocomplete=\"off\"\n              class=\"form-control\"\n              placeholder=\"{{bonusCurrencySymbol}}0.00\"\n              data-ng-model=\"editableSalary.bonusAmount\"\n              style=\"margin-left: 1px; width: 99%; height: 37px;\"\n            />\n          </div>\n          <div\n            class=\"row margin-b5 input-group ui-datepicker salary-datepicker col-xs-12\"\n            data-ng-controller=\"DatepickerDemoCtrl\"\n          >\n            <input\n              type=\"text\"\n              disabled\n              placeholder=\"Date of last bonus award\"\n              class=\"form-control custom-readonly\"\n              uib-datepicker-popup=\"dd-MMMM-yyyy\"\n              ng-model=\"editableSalary.bonusDate\"\n              is-open=\"opened\"\n              datepicker-options=\"salaryDetailsDatePickerOptions\"\n              date-disabled=\"reverseDisabled(date, mode)\"\n              close-text=\"Close\"\n            />\n            <span class=\"input-group-addon\" ng-click=\"open($event)\">\n              <i class=\"fa fa-calendar\"></i>\n            </span>\n          </div>\n        </div>\n        <div class=\"modal-footer\" style=\"border-top: none !important;\">\n          <center>\n            <button class=\"btn btn-info\" ng-click=\"saveSalaryDetails()\">\n              Save\n            </button>\n            <button\n              class=\"btn btn-gap-v btn-default\"\n              ng-click=\"cancelSalaryDetails()\"\n            >\n              Cancel\n            </button>\n          </center>\n        </div>\n      </div>\n      <!-- Salary Edit Section End-->\n      <!-- Salary View Start-->\n      <div\n        ng-if=\"lockedSalary.isSelected\"\n        ng-show=\"(!editingSalaryDetails && !addingSalaryDetails) && (salaryDetails.unit || salaryDetails.amount) && !showHistory\"\n      >\n        <button\n          ng-disabled=\"candidate.approvalStatus === 'Locked' && !candidate.isAdminProfile\"\n          type=\"button\"\n          ng-click=\"editSalaryDetails()\"\n          ng-touch=\"editSalaryDetails()\"\n          id=\"edit-salary\"\n          class=\"btn btn-noline-info btn-xs pull-right \"\n          ng-show=\"lawyerApproved\"\n        >\n          <span class=\"text-edit\" id=\"edit-salary\"></span>\n          <i class=\"fa fa-pencil\" id=\"edit-salary\"></i>\n        </button>\n        <div class=\"row margin-b5 margin-l1\">\n          <span\n            ><b\n              >{{salaryDetails.employer.name}},\n              {{salaryDetails.location.name}}</b\n            ></span\n          ><br />\n        </div>\n        <div class=\"row margin-b5 margin-l1\">\n          <span\n            >{{salaryDetails.unit}} {{salaryDetails.salaryAmountToShow}}\n            {{salaryDetails.payPeriod}}</span\n          ><br />\n          <span\n            style=\"color: #767676; font-size: 12px;\"\n            ng-if=\"salaryDetails.unit || salaryDetails.amount\"\n            >Effective since\n          </span>\n          <span>{{salaryDetails.salaryDateToShow}}</span>\n        </div>\n        <div\n          class=\"row margin-b5 margin-l1\"\n          ng-if=\"salaryDetails.bonusUnit || salaryDetails.bonusAmount\"\n        >\n          <span class=\"\"><b>Last Bonus </b></span>\n          <br />\n          <span\n            >{{salaryDetails.bonusUnit}}\n            {{salaryDetails.bonusAmountToShow}}</span\n          ><br />\n          <span\n            style=\"color: #767676; font-size: 12px;\"\n            ng-if=\"salaryDetails.bonusUnit || salaryDetails.bonusAmount\"\n            >Awarded on\n          </span>\n          <span>{{salaryDetails.bonusDateToShow}}</span>\n        </div>\n      </div>\n      <div\n        ng-if=\"showHistory && (!editingSalaryDetails && !addingSalaryDetails)\"\n        ng-repeat=\"history in salaryHistory\"\n      >\n        <button\n          ng-disabled=\"editingSalaryDetails\"\n          type=\"button\"\n          ng-click=\"editHistorySalaryDetails(history,$index)\"\n          ng-touch=\"editHistorySalaryDetails(history,$index)\"\n          id=\"edit-salary\"\n          class=\"btn btn-noline-info btn-xs pull-right \"\n          ng-show=\"lawyerApproved\"\n        >\n          <span class=\"text-edit\" id=\"edit-salary\"></span>\n          <i class=\"fa fa-pencil\" id=\"edit-salary\"></i>\n        </button>\n        <div class=\"row margin-b5 margin-l1\">\n          <span\n            ><b>{{history.employer.name}}, {{history.location.name}}</b></span\n          ><br />\n        </div>\n        <div class=\"row margin-b5 margin-l1\">\n          <span\n            >{{history.unit}} {{history.salaryAmountToShow}}\n            {{history.payPeriod}}</span\n          ><br />\n          <span\n            style=\"color: #767676; font-size: 12px;\"\n            ng-if=\"history.unit || history.amount\"\n            >Effective since\n          </span>\n          <span>{{history.salaryDateToShow}}</span>\n        </div>\n        <div\n          class=\"row margin-b5 margin-l1\"\n          ng-if=\"history.bonusUnit || history.bonusAmount\"\n        >\n          <span class=\"\"\n            ><b><span ng-if=\"$first\">Last</span> Bonus </b></span\n          >\n          <br />\n          <span>{{history.bonusUnit}} {{history.bonusAmountToShow}}</span>\n          <span\n            style=\"color: #767676; font-size: 12px;\"\n            ng-if=\"history.bonusUnit || history.bonusAmount\"\n          >\n            awarded on\n          </span>\n          <span>{{history.bonusDateToShow}}</span>\n        </div>\n        <hr ng-if=\"!$last\" />\n      </div>\n      <!-- Salary View End-->\n    </div>\n  </div>\n  <!-- End Salary Details Section -->\n</div>\n"

/***/ }),
/* 467 */
/***/ (function(module, exports) {

	module.exports = "<div\n  uib-dropdown\n  class=\"select-locations inlineBlock margin-r20 color-dropdown-ml\"\n  style=\"margin-left: 0;width: 100%;\"\n>\n  <style>\n    .select-locations .dropdown-toggle,\n    .select-locations .dropdown-toggle:active,\n    .select-locations .dropdown-toggle:hover,\n    .select-locations .dropdown-button.dropdown-toggle:focus {\n      border: 1px solid #cbd5dd;\n      background-color: white;\n    }\n    .dropdown-button {\n      color: #242633;\n      padding: 6px 10px 6px 10px;\n      width: 100%;\n      font-size: 14px;\n      font-weight: inherit;\n      letter-spacing: normal;\n      text-transform: unset;\n      border-color: transparent;\n      margin: 0;\n      text-align: left;\n    }\n    .dropdown-button:hover,\n    .dropdown-button:focus,\n    .dropdown-button:active {\n      background-color: transparent;\n      color: #242633;\n    }\n    .dropdown .location-drop-down {\n      /* max-height: 300px; */\n      width: 330px;\n    }\n\n    .dropdown .bootstrapDropdownMaxWidth {\n      width: 100%;\n    }\n    .practice-area-dropdown {\n      padding-left: 38px;\n    }\n    .practice-area-list li {\n      padding: 2px 0;\n    }\n    .dropdown-caret {\n      color: #cbd5dd;\n      z-index: 0;\n      content: '';\n      position: absolute;\n      right: 8%;\n      top: 50%;\n      width: 0;\n      margin-top: -3px;\n      height: 0;\n      border-top: 6px solid;\n      border-right: 6px solid transparent;\n      border-left: 6px solid transparent;\n    }\n  </style>\n  <div uib-dropdown>\n    <button\n      ng-if=\"!placeholder\"\n      uib-dropdown-toggle\n      id=\"{{buttonId}}\"\n      class=\"btn-noline-info btn-xs dropdown-button\"\n      type=\"button\"\n    >\n      Locations\n      <span class=\"caret dropdown-caret\"></span>\n    </button>\n    <button\n      ng-if=\"placeholder\"\n      uib-dropdown-toggle\n      id=\"{{buttonId}}\"\n      data-testid=\"locations-area-filter\"\n      class=\"btn-noline-info btn-xs dropdown-button\"\n      type=\"button\"\n    >\n      {{placeholder}}\n      <span class=\"caret dropdown-caret\"></span>\n    </button>\n    <div\n      uib-dropdown-menu\n      class=\"locationAreaMenu\"\n      ng-class=\"{ 'bootstrapDropdown bootstrapDropdownMaxWidth': width, 'bootstrapDropdown  location-drop-down': !width }\"\n      ng-click=\"openLocationDropDown($event)\"\n    >\n      <div class=\"pull-right\">\n        <button ng-click=\"selectAllLocations()\" class=\"btn btn-info btn-xs\">\n          Select All\n        </button>\n        <button ng-click=\"deselectAllLocations()\" class=\"btn btn-info btn-xs\">\n          Deselect All\n        </button>\n      </div>\n      <br />\n\n      <div class=\"\" data-ng-repeat=\"region in regionsList\">\n        <label class=\"ui-checkbox\">\n          <input\n            type=\"checkbox\"\n            ng-click=\"selectLocation(region,$event)\"\n            data=\"{{region}}\"\n            ng-checked=\"region.isSelected\"\n            ng-model=\"region.isSelected\"\n          />\n          <span class=\"checkbox-group-heading\"\n            ><strong>{{region.name}}</strong></span\n          >\n        </label>\n        <ul class=\"sub-list clearfix\">\n          <li data-ng-repeat=\"country in region.locations\">\n            <label class=\"ui-checkbox\">\n              <input\n                type=\"checkbox\"\n                data=\"{{country}}\"\n                ng-click=\"selectLocation(country,$event)\"\n                ng-checked=\"country.isSelected\"\n                ng-model=\"country.isSelected\"\n              />\n              <span>{{country.name}}</span>\n            </label>\n            <ul class=\" sub-list clearfix\">\n              <li data-ng-repeat=\"location in country.children\">\n                <label class=\"ui-checkbox\">\n                  <input\n                    type=\"checkbox\"\n                    ng-click=\"selectLocation(location,$event)\"\n                    ng-checked=\"location.isSelected\"\n                  />\n                  <span>{{location.name}}</span>\n                </label>\n                <ul class=\" sub-list clearfix\">\n                  <li data-ng-repeat=\"child in location.children\">\n                    <label class=\"ui-checkbox\">\n                      <input\n                        type=\"checkbox\"\n                        ng-click=\"selectLocation(child,$event)\"\n                        ng-checked=\"child.isSelected\"\n                      />\n                      <span>{{child.name}}</span>\n                    </label>\n                  </li>\n                </ul>\n              </li>\n            </ul>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 468 */
/***/ (function(module, exports) {

	module.exports = "<!-- <script type=\"text/ng-template\" id=\"locations-modal.html\"> -->\n<div data-testid=\"location-modal\">\n  <div class=\"modal-header\">\n    <center ng-if=\"!ctrl.locationModalHeading\">\n      <h3>Target Location(s)</h3>\n      <h5>Where would your ideal position be based?</h5>\n    </center>\n    <center ng-if=\"ctrl.locationModalHeading\">\n      <h3>Current Location</h3>\n      <h5>Where was this role based?</h5>\n    </center>\n  </div>\n\n  <div class=\"modal-body\">\n    <div class=\"modal-row custom-modal\">\n      <div class=\"col-md-12\">\n        <div\n          class=\"\"\n          data-ng-repeat=\"region in ctrl.regionHierarchialListWithEuropeOnTop\"\n        >\n          <span\n            ><i\n              ng-hide=\"!region.locations || region.showLocations\"\n              data-ng-click=\"ctrl.expandChildLocations(region)\"\n              class=\"fa fa-plus expand-collapse-button\"\n              aria-hidden=\"true\"\n            ></i>\n          </span>\n          <span\n            ><i\n              ng-hide=\"!region.showLocations\"\n              ng-click=\"ctrl.collapseChildLocations(region)\"\n              class=\"fa fa-minus expand-collapse-button\"\n              aria-hidden=\"true\"\n            ></i>\n          </span>\n          <label class=\"ui-checkbox\">\n            <input\n              type=\"checkbox\"\n              ng-click=\"ctrl.selectLocation(region,$event)\"\n              data=\"{{region}}\"\n              ng-checked=\"region.isSelected\"\n              ng-model=\"region.isSelected\"\n            />\n            <span class=\"checkbox-group-heading\"\n              ><strong>{{region.name}}</strong></span\n            >\n          </label>\n          <ul\n            class=\" practice-area-list clearfix\"\n            ng-show=\"region.showLocations\"\n          >\n            <li data-ng-repeat=\"country in region.locations\">\n              <label class=\"ui-checkbox\">\n                <input\n                  type=\"checkbox\"\n                  data=\"{{country}}\"\n                  ng-click=\"ctrl.selectLocation(country,$event)\"\n                  ng-checked=\"country.isSelected\"\n                  ng-model=\"country.isSelected\"\n                />\n                <span>{{country.name}}</span>\n              </label>\n              <ul class=\" sub-list clearfix\">\n                <li data-ng-repeat=\"location in country.children\">\n                  <label class=\"ui-checkbox\">\n                    <input\n                      type=\"checkbox\"\n                      ng-click=\"ctrl.selectLocation(location,$event)\"\n                      ng-checked=\"location.isSelected\"\n                    />\n                    <span>{{location.name}}</span>\n                  </label>\n                  <ul class=\" sub-list clearfix\">\n                    <li data-ng-repeat=\"child in location.children\">\n                      <label class=\"ui-checkbox\">\n                        <input\n                          type=\"checkbox\"\n                          ng-click=\"ctrl.selectLocation(child,$event)\"\n                          ng-checked=\"child.isSelected\"\n                        />\n                        <span>{{child.name}}</span>\n                      </label>\n                    </li>\n                  </ul>\n                </li>\n              </ul>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <center>\n      <button\n        class=\"btn btn-info\"\n        ng-if=\"!ctrl.displayNextButton\"\n        ng-click=\"ctrl.save()\"\n      >\n        Save\n      </button>\n      <button\n        class=\"btn btn-info\"\n        ng-if=\"ctrl.displayNextButton\"\n        ng-click=\"ctrl.save()\"\n      >\n        Next\n      </button>\n\n      <button class=\"btn btn-gap-v btn-default\" ng-click=\"ctrl.cancel()\">\n        Cancel\n      </button>\n    </center>\n  </div>\n</div>\n<!-- </script> -->\n"

/***/ }),
/* 469 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <script type=\"text/ng-template\" id=\"modal-template-position-hide-options\">\n    <div class=\"modal-header\">\n        <h3 class=\"text-center\" style=\"margin-top:10px\">\n            Hide Opportunities\n        </h3>\n    </div>\n\n    <div class=\"modal-body\">\n        <div class=\"row margin-b30\">\n            <div class=\"col-sm-offset-1 col-sm-11\">\n                <strong style=\"margin-top:10px;\">\n                    Help Lexi, LexStep's AI assistant, get smarter so she can find and match you with opportunities that are\n                    a better fit:\n                </strong>\n            </div>\n        </div>\n\n        <div class=\"row\">\n            <ul class=\" hide-opportunities-list clearfix\">\n                <li>\n                    <label class=\"ui-radio\">\n                        <input type=\"radio\" name=\"hideSelectedOption\" ng-value=\"true\" ng-model=\"options.alreadyApplied.selected\">\n                        <span ng-if=\"page === 'opportunities'\">Hide this team - I'm interested but I've <b>previously applied</b>.</span>\n                        <span ng-if=\"page === 'in-house'\">Hide this job - I'm interested but I've <b>previously applied</b>.</span>\n                        <span ng-if=\"page === 'matches'\">Hide this match - I'm interested but I've <b>previously applied</b>.</span>\n                    </label>\n                </li>\n\n                <li class=\"margin-t15\">\n                    <label class=\"ui-radio\">\n                        <input type=\"radio\" name=\"hideSelectedOption\" ng-value=\"true\" ng-model=\"options.hideOpportunity.selected\">\n                        <span ng-if=\"page === 'opportunities'\">Hide this team - it's <b>not for me</b>.</span>\n                        <span ng-if=\"page === 'in-house'\">Hide this job - it's <b>not for me</b>.</span>\n                        <span ng-if=\"page === 'matches'\">Hide this match - it's <b>not for me</b>.</span>\n                    </label>\n                </li>\n\n                <li class=\"margin-t15\">\n                    <label class=\"ui-radio\">\n                        <input type=\"radio\" name=\"hideSelectedOption\" ng-value=\"true\" ng-model=\"options.hideEmployer.selected\">\n                        <span ng-if=\"page === 'opportunities'\">Hide this team and all others at this employer - this <b>employer is not for me</b>.</span>\n                        <span ng-if=\"page === 'in-house'\">Hide this job and all future jobs at this employer - this <b>employer is not for me</b>.</span>\n                        <span ng-if=\"page === 'matches'\">Hide this match and all future matches at this employer - this <b>employer is not for me</b>.</span>\n                    </label>\n                </li>\n            </ul>\n        </div>\n    </div>\n\n    <div class=\"modal-footer-apply-job\">\n        <center>\n            <button class=\"btn btn-info\" ng-click=\"hidePositionOrEmployer()\">\n                Hide\n            </button>\n            <button class=\"btn btn-default\" ng-click=\"closeModal()\">\n                {{'btn.cancel.label'|translate}}\n            </button>\n        </center>\n    </div>\n  </script>\n</div>\n"

/***/ }),
/* 470 */
/***/ (function(module, exports) {

	module.exports = "<script type=\"text/ng-template\" id=\"position-details-modal.html\">\n  <div data-testid=\"position-details-modal\">\n    <div class=\"modal-header\">\n      <div>\n        <h3>Position Details</h3>\n      </div>\n    </div>\n\n    <div class=\"modal-body\">\n      <!-- <div class=\"wrapperPositionModal\" ng-cloak data-ng-controller=\"PositionDetailsController as vm\"> -->\n        <div class=\"wrapperPositionModal\" >\n        <div class=\"labelPosition\"><b>Position ID: </b></div>\n        <div class=\"content\">\n          {{ctrl.position.id}}\n        </div>\n\n        <div class=\"labelPosition\"><b>Employer Name</b></div>\n        <div class=\"content\">{{ctrl.position.employer.name}}</div>\n        <div class=\"logo\">\n          <img class=\"logoEmployer\" src=\"{{ctrl.position.employer.picSrc}}\" alt=\"pic\"/>\n        </div>\n\n        <div class=\"labelPosition\"><b>Position Title</b></div>\n        <div class=\"content\">{{ctrl.position.title}}</div>\n\n        <div class=\"labelPosition\"><b>Required PQE </b></div>\n        <div class=\"content\">{{ctrl.position.lawPreferences.minPqe <= 0 ?\"NQ\":ctrl.position.lawPreferences.minPqe}}{{ctrl.position.lawPreferences.maxPqe== 11?\"+\":(ctrl.position.lawPreferences.maxPqe <= 0 || ctrl.position.lawPreferences.maxPqe == ctrl.position.lawPreferences.minPqe)?\"\":\"-\"+ctrl.position.lawPreferences.maxPqe}}</div>\n\n        <div class=\"labelPosition\"><b>Locations </b></div>\n        <div class=\"content\">\n            <ul id=\"taglist\" class=\"list-inline list-practice-area margin-b0\">\n              <li class=\"tags-box\"\n                ng-repeat=\"location in ctrl.position.locations\">{{location.name}}</li>\n          </ul>\n        </div>\n\n        <div class=\"labelPosition\"><b>Practice Areas </b></div>\n        <div class=\"content\">\n            <ul id=\"taglist\" class=\"list-inline list-practice-area margin-b0\">\n              <li class=\"tags-box\"\n                ng-repeat=\"specialty in ctrl.position.specialtiesName\">\n                  {{specialty}}\n              </li>\n            </ul>\n        </div>\n\n        <div class=\"labelPosition\"><b>Contract: </b></div>\n        <div class=\"content\">{{ctrl.position.contractType}}</div>\n\n        <div class=\"labelPosition\"><b>Occupation: </b></div>\n        <div class=\"content\"> {{ctrl.position.occupation}}</div>\n\n        <div class=\"labelPosition\"><b>Listing Type: </b></div>\n        <div class=\"content\">{{ ctrl.position.type}}</div>\n\n        <div class=\"labelPosition\" ng-if=\"ctrl.position.employerType\"><b>Employer Type: </b></div>\n        <div class=\"content\" ng-if=\"ctrl.position.employerType\">{{ ctrl.position.employerType}}</div>\n\n        <div class=\"labelPosition\"><b>Visible: </b></div>\n        <div class=\"content\"> {{ctrl.position.visible}}</div>\n\n        <div class=\"labelPosition\"><b>Uploaded: </b></div>\n        <div class=\"content\"> {{ctrl.position.created | date:'dd MMM yyyy'}}</div>\n\n        <div class=\"labelPosition\"><b>Expiry Date: </b></div>\n        <div class=\"content\"> {{ctrl.position.expiresAt | date:'dd MMM yyyy'}}</div>\n\n        <div class=\"labelPosition\"><b>Source/External Link: </b></div>\n        <div class=\"content\">\n          <a style=\"color:#4c9bda;word-break: break-all;\" target=\"_blank\"\n           href={{ctrl.position.externalUrlLink}}>\n           {{ctrl.position.externalUrl}}</a>\n        </div>\n\n        <div class=\"labelPosition\"><b>Position Description: </b></div>\n        <div class=\"content\">\n            <read-more-words hmtext=\"{{ctrl.position.description}}\" hmlimit=\"20\" hm-more-text=\"more\"\n            hm-less-text=\"less\" align=\"justify\" />\n        </div>\n      </div>\n    </div>\n  </div>\n</script>\n"

/***/ }),
/* 471 */
/***/ (function(module, exports) {

	module.exports = "<div\n  uib-dropdown\n  ng-class=\"{\n  'filters-action':grid ,\n  'select-practice-areas inlineBlock margin-r20 margin-l0  full-width': !grid}\"\n>\n  <style>\n    .select-practice-areas .dropdown-toggle,\n    .select-practice-areas .dropdown-toggle:hover,\n    .select-practice-areas .dropdown-toggle:active,\n    .select-practice-areas .dropdown-button.dropdown-toggle:focus {\n      border: 1px solid #cbd5dd;\n      background-color: white;\n    }\n    .dropdown-button {\n      color: #242633;\n      padding: 8px 10px;\n      width: 100%;\n      font-size: 14px;\n      font-weight: inherit;\n      letter-spacing: normal;\n      text-transform: unset;\n      border-color: transparent;\n      text-align: left;\n    }\n    .dropdown-button:hover,\n    .dropdown-button:focus,\n    .dropdown-button:active {\n      background-color: transparent;\n      color: #242633;\n    }\n    .dropdown .bootstrapDropdown {\n      max-height: 300px;\n      width: 386px;\n      color: black !important;\n    }\n    .dropdown .bootstrapDropdownMaxWidth {\n      width: 100%;\n    }\n    .practice-area-dropdown {\n      padding-left: 38px;\n    }\n    .practice-area-list li {\n      padding: 3px 0;\n      color: black;\n    }\n    .dropdown-caret {\n      color: #cbd5dd;\n      z-index: 0;\n      content: '';\n      position: absolute;\n      right: 8%;\n      top: 50%;\n      width: 0;\n      margin-top: -3px;\n      height: 0;\n      border-top: 6px solid;\n      border-right: 6px solid transparent;\n      border-left: 6px solid transparent;\n    }\n  </style>\n  <button\n    ng-if=\"!grid && placeholder \"\n    uib-dropdown-toggle\n    data-testid=\"practice-area-filter\"\n    id=\"{{buttonId}}\"\n    class=\"btn-noline-info btn-xs dropdown-button\"\n    type=\"button\"\n  >\n    {{placeholder}}\n    <span class=\"caret dropdown-caret\"></span>\n  </button>\n\n  <button\n    ng-if=\"!grid && !placeholder\"\n    uib-dropdown-toggle\n    id=\"{{buttonId}}\"\n    class=\"btn-noline-info btn-xs dropdown-button\"\n    type=\"button\"\n  >\n    Practice Areas\n    <span class=\"caret dropdown-caret\"></span>\n  </button>\n  <button\n    ng-if=\"grid\"\n    uib-dropdown-toggle\n    id=\"{{buttonId}}\"\n    class=\"btn\"\n    type=\"button\"\n    data-tooltip-check=\"{{iconLabel}}\"\n  >\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      width=\"24\"\n      height=\"24\"\n      viewBox=\"0 0 24 24\"\n    >\n      <style type=\"text/css\">\n        .st0 {\n          fill: #9d9d9d;\n        }\n      </style>\n      <path fill=\"none\" d=\"M0 0h24v24H0V0z\" />\n      <path\n        class=\"st0\"\n        d=\"M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z\"\n      />\n    </svg>\n  </button>\n  <div\n    uib-dropdown-menu\n    class=\"practiceAreaMenu\"\n    ng-class=\"{ 'bootstrapDropdown bootstrapDropdownMaxWidth': width, 'bootstrapDropdown': !width }\"\n    ng-click=\"openPracticeAreaDropDown($event)\"\n  >\n    <div class=\"pull-right\">\n      <button ng-click=\"selectAllPracticeArea()\" class=\"btn btn-info btn-xs\">\n        Select All\n      </button>\n      <button ng-click=\"deselectAllPracticeAreas()\" class=\"btn btn-info btn-xs\">\n        Deselect All\n      </button>\n    </div>\n    <br />\n    <div data-ng-repeat=\"practiceArea in practiceAreasList\">\n      <div>\n        <span ng-class=\"{'no-child': !practiceArea.children}\"\n          ><i\n            ng-hide=\"!practiceArea.children || practiceArea.showChildren\"\n            ng-click=\"expandChildPracticeArea(practiceArea)\"\n            class=\"fa fa-plus expand-collapse-button\"\n            aria-hidden=\"true\"\n          ></i>\n        </span>\n        <span ng-class=\"{'no-child': !practiceArea.children}\"\n          ><i\n            ng-hide=\"!practiceArea.showChildren\"\n            ng-click=\"collapseChildPracticeArea(practiceArea)\"\n            class=\"fa fa-minus expand-collapse-button\"\n            aria-hidden=\"true\"\n          ></i>\n        </span>\n        <label class=\"ui-checkbox\">\n          <input\n            data-testid=\"practice-area-list\"\n            type=\"checkbox\"\n            ng-click=\"selectPracticeArea(practiceArea,$event)\"\n            data=\"{{practiceArea}}\"\n            ng-checked=\"practiceArea.isSelected\"\n            ng-model=\"practiceArea.isSelected\"\n          />\n          <span\n            class=\"checkbox-group-heading\"\n            ng-style=\"practiceArea.children && {'color':'black', 'font-weight': 'bold'}\"\n            >{{practiceArea.name}}</span\n          >\n        </label>\n      </div>\n      <ul\n        ng-show=\"practiceArea.showChildren\"\n        class=\" practice-area-list clearfix\"\n      >\n        <li data-ng-repeat=\"child in practiceArea.children track by $index\">\n          <label class=\"ui-checkbox\">\n            <input\n              type=\"checkbox\"\n              data=\"{{child}}\"\n              ng-click=\"selectPracticeArea(child,$event)\"\n              ng-style=\"practiceArea.children.length > 0 && {'color':'black', 'font-weight': 'bold'}\"\n              ng-checked=\"child.isSelected\"\n              ng-model=\"child.isSelected\"\n            />\n            <span>{{child.name}}</span>\n          </label>\n          <ul class=\"sub-list clearfix\">\n            <li data-ng-repeat=\"subChild in child.children track by $index\">\n              <label class=\"ui-checkbox\">\n                <input\n                  type=\"checkbox\"\n                  ng-click=\"selectPracticeArea(subChild,$event)\"\n                  ng-checked=\"subChild.isSelected\"\n                  ng-model=\"subChild.isSelected\"\n                />\n                <span>{{subChild.name}}</span>\n              </label>\n            </li>\n          </ul>\n        </li>\n      </ul>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 472 */
/***/ (function(module, exports) {

	module.exports = "<!-- <script type=\"text/ng-template\" id=\"practice-area-modal.html\"> -->\n<div data-testid=\"practice-area-modal\">\n  <div class=\"modal-header\">\n    <center>\n      <h3>Select Practice Areas</h3>\n      <h5 hidden>Sub heading section</h5>\n    </center>\n  </div>\n\n  <div class=\"modal-body\">\n    <div class=\"row custom-modal\">\n      <div class=\"col-md-12\">\n        <div class=\"\" data-ng-repeat=\"practiceArea in ctrl.practiceAreasList\">\n          <span ng-class=\"{'no-child': !practiceArea.children}\"\n            ><i\n              ng-hide=\"!practiceArea.children || practiceArea.showChildren\"\n              ng-click=\"ctrl.expandChildPracticeArea(practiceArea)\"\n              class=\"fa fa-plus expand-collapse-button\"\n              aria-hidden=\"true\"\n            ></i>\n          </span>\n          <span ng-class=\"{'no-child': !practiceArea.children}\"\n            ><i\n              ng-hide=\"!practiceArea.showChildren\"\n              ng-click=\"ctrl.collapseChildPracticeArea(practiceArea)\"\n              class=\"fa fa-minus expand-collapse-button\"\n              aria-hidden=\"true\"\n            ></i>\n          </span>\n          <label class=\"ui-checkbox\">\n            <input\n              type=\"checkbox\"\n              ng-click=\"ctrl.selectPracticeArea(practiceArea,$event)\"\n              data=\"{{practiceArea}}\"\n              ng-checked=\"practiceArea.isSelected\"\n              ng-model=\"practiceArea.isSelected\"\n            />\n            <span\n              class=\"checkbox-group-heading\"\n              ng-style=\"practiceArea.children && {'font-weight': 'bold'}\"\n              >{{practiceArea.name}}</span\n            >\n          </label>\n          <ul\n            ng-show=\"practiceArea.showChildren\"\n            class=\" practice-area-list clearfix\"\n          >\n            <li data-ng-repeat=\"child in practiceArea.children\">\n              <label class=\"ui-checkbox\">\n                <input\n                  type=\"checkbox\"\n                  data=\"{{child}}\"\n                  ng-click=\"ctrl.selectPracticeArea(child,$event)\"\n                  ng-style=\"practiceArea.children.length > 0 && {'font-weight': 'bold'}\"\n                  ng-checked=\"child.isSelected\"\n                  ng-model=\"child.isSelected\"\n                />\n                <span>{{child.name}}</span>\n              </label>\n              <ul class=\" sub-list clearfix\">\n                <li data-ng-repeat=\"subChild in child.children\">\n                  <label class=\"ui-checkbox\">\n                    <input\n                      type=\"checkbox\"\n                      ng-click=\"ctrl.selectPracticeArea(subChild,$event)\"\n                      ng-checked=\"subChild.isSelected\"\n                      ng-model=\"subChild.isSelected\"\n                    />\n                    <span>{{subChild.name}}</span>\n                  </label>\n                </li>\n              </ul>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <center>\n      <button\n        class=\"btn btn-info\"\n        ng-if=\"!ctrl.displayNextButton\"\n        ng-click=\"ctrl.save()\"\n      >\n        Save\n      </button>\n      <button\n        class=\"btn btn-info\"\n        ng-if=\"ctrl.displayNextButton\"\n        ng-click=\"ctrl.save()\"\n      >\n        Next\n      </button>\n      <button class=\"btn btn-gap-v btn-default\" ng-click=\"ctrl.cancel()\">\n        Cancel\n      </button>\n    </center>\n  </div>\n</div>\n<!-- </script> -->\n"

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Socket.IO v4.5.2
	 * (c) 2014-2022 Guillermo Rauch
	 * Released under the MIT License.
	 */
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.io = factory());
	})(this, (function () { 'use strict';
	
	  function _typeof(obj) {
	    "@babel/helpers - typeof";
	
	    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
	      return typeof obj;
	    } : function (obj) {
	      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    }, _typeof(obj);
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    Object.defineProperty(Constructor, "prototype", {
	      writable: false
	    });
	    return Constructor;
	  }
	
	  function _extends() {
	    _extends = Object.assign ? Object.assign.bind() : function (target) {
	      for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];
	
	        for (var key in source) {
	          if (Object.prototype.hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	          }
	        }
	      }
	
	      return target;
	    };
	    return _extends.apply(this, arguments);
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function");
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        writable: true,
	        configurable: true
	      }
	    });
	    Object.defineProperty(subClass, "prototype", {
	      writable: false
	    });
	    if (superClass) _setPrototypeOf(subClass, superClass);
	  }
	
	  function _getPrototypeOf(o) {
	    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
	      return o.__proto__ || Object.getPrototypeOf(o);
	    };
	    return _getPrototypeOf(o);
	  }
	
	  function _setPrototypeOf(o, p) {
	    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	      o.__proto__ = p;
	      return o;
	    };
	    return _setPrototypeOf(o, p);
	  }
	
	  function _isNativeReflectConstruct() {
	    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	    if (Reflect.construct.sham) return false;
	    if (typeof Proxy === "function") return true;
	
	    try {
	      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	
	  function _construct(Parent, args, Class) {
	    if (_isNativeReflectConstruct()) {
	      _construct = Reflect.construct.bind();
	    } else {
	      _construct = function _construct(Parent, args, Class) {
	        var a = [null];
	        a.push.apply(a, args);
	        var Constructor = Function.bind.apply(Parent, a);
	        var instance = new Constructor();
	        if (Class) _setPrototypeOf(instance, Class.prototype);
	        return instance;
	      };
	    }
	
	    return _construct.apply(null, arguments);
	  }
	
	  function _isNativeFunction(fn) {
	    return Function.toString.call(fn).indexOf("[native code]") !== -1;
	  }
	
	  function _wrapNativeSuper(Class) {
	    var _cache = typeof Map === "function" ? new Map() : undefined;
	
	    _wrapNativeSuper = function _wrapNativeSuper(Class) {
	      if (Class === null || !_isNativeFunction(Class)) return Class;
	
	      if (typeof Class !== "function") {
	        throw new TypeError("Super expression must either be null or a function");
	      }
	
	      if (typeof _cache !== "undefined") {
	        if (_cache.has(Class)) return _cache.get(Class);
	
	        _cache.set(Class, Wrapper);
	      }
	
	      function Wrapper() {
	        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
	      }
	
	      Wrapper.prototype = Object.create(Class.prototype, {
	        constructor: {
	          value: Wrapper,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      });
	      return _setPrototypeOf(Wrapper, Class);
	    };
	
	    return _wrapNativeSuper(Class);
	  }
	
	  function _assertThisInitialized(self) {
	    if (self === void 0) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return self;
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (call && (typeof call === "object" || typeof call === "function")) {
	      return call;
	    } else if (call !== void 0) {
	      throw new TypeError("Derived constructors may only return object or undefined");
	    }
	
	    return _assertThisInitialized(self);
	  }
	
	  function _createSuper(Derived) {
	    var hasNativeReflectConstruct = _isNativeReflectConstruct();
	
	    return function _createSuperInternal() {
	      var Super = _getPrototypeOf(Derived),
	          result;
	
	      if (hasNativeReflectConstruct) {
	        var NewTarget = _getPrototypeOf(this).constructor;
	
	        result = Reflect.construct(Super, arguments, NewTarget);
	      } else {
	        result = Super.apply(this, arguments);
	      }
	
	      return _possibleConstructorReturn(this, result);
	    };
	  }
	
	  function _superPropBase(object, property) {
	    while (!Object.prototype.hasOwnProperty.call(object, property)) {
	      object = _getPrototypeOf(object);
	      if (object === null) break;
	    }
	
	    return object;
	  }
	
	  function _get() {
	    if (typeof Reflect !== "undefined" && Reflect.get) {
	      _get = Reflect.get.bind();
	    } else {
	      _get = function _get(target, property, receiver) {
	        var base = _superPropBase(target, property);
	
	        if (!base) return;
	        var desc = Object.getOwnPropertyDescriptor(base, property);
	
	        if (desc.get) {
	          return desc.get.call(arguments.length < 3 ? target : receiver);
	        }
	
	        return desc.value;
	      };
	    }
	
	    return _get.apply(this, arguments);
	  }
	
	  function _unsupportedIterableToArray(o, minLen) {
	    if (!o) return;
	    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	    var n = Object.prototype.toString.call(o).slice(8, -1);
	    if (n === "Object" && o.constructor) n = o.constructor.name;
	    if (n === "Map" || n === "Set") return Array.from(o);
	    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	  }
	
	  function _arrayLikeToArray(arr, len) {
	    if (len == null || len > arr.length) len = arr.length;
	
	    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	
	    return arr2;
	  }
	
	  function _createForOfIteratorHelper(o, allowArrayLike) {
	    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
	
	    if (!it) {
	      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
	        if (it) o = it;
	        var i = 0;
	
	        var F = function () {};
	
	        return {
	          s: F,
	          n: function () {
	            if (i >= o.length) return {
	              done: true
	            };
	            return {
	              done: false,
	              value: o[i++]
	            };
	          },
	          e: function (e) {
	            throw e;
	          },
	          f: F
	        };
	      }
	
	      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	    }
	
	    var normalCompletion = true,
	        didErr = false,
	        err;
	    return {
	      s: function () {
	        it = it.call(o);
	      },
	      n: function () {
	        var step = it.next();
	        normalCompletion = step.done;
	        return step;
	      },
	      e: function (e) {
	        didErr = true;
	        err = e;
	      },
	      f: function () {
	        try {
	          if (!normalCompletion && it.return != null) it.return();
	        } finally {
	          if (didErr) throw err;
	        }
	      }
	    };
	  }
	
	  var PACKET_TYPES = Object.create(null); // no Map = no polyfill
	
	  PACKET_TYPES["open"] = "0";
	  PACKET_TYPES["close"] = "1";
	  PACKET_TYPES["ping"] = "2";
	  PACKET_TYPES["pong"] = "3";
	  PACKET_TYPES["message"] = "4";
	  PACKET_TYPES["upgrade"] = "5";
	  PACKET_TYPES["noop"] = "6";
	  var PACKET_TYPES_REVERSE = Object.create(null);
	  Object.keys(PACKET_TYPES).forEach(function (key) {
	    PACKET_TYPES_REVERSE[PACKET_TYPES[key]] = key;
	  });
	  var ERROR_PACKET = {
	    type: "error",
	    data: "parser error"
	  };
	
	  var withNativeBlob$1 = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
	  var withNativeArrayBuffer$2 = typeof ArrayBuffer === "function"; // ArrayBuffer.isView method is not defined in IE10
	
	  var isView$1 = function isView(obj) {
	    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
	  };
	
	  var encodePacket = function encodePacket(_ref, supportsBinary, callback) {
	    var type = _ref.type,
	        data = _ref.data;
	
	    if (withNativeBlob$1 && data instanceof Blob) {
	      if (supportsBinary) {
	        return callback(data);
	      } else {
	        return encodeBlobAsBase64(data, callback);
	      }
	    } else if (withNativeArrayBuffer$2 && (data instanceof ArrayBuffer || isView$1(data))) {
	      if (supportsBinary) {
	        return callback(data);
	      } else {
	        return encodeBlobAsBase64(new Blob([data]), callback);
	      }
	    } // plain string
	
	
	    return callback(PACKET_TYPES[type] + (data || ""));
	  };
	
	  var encodeBlobAsBase64 = function encodeBlobAsBase64(data, callback) {
	    var fileReader = new FileReader();
	
	    fileReader.onload = function () {
	      var content = fileReader.result.split(",")[1];
	      callback("b" + content);
	    };
	
	    return fileReader.readAsDataURL(data);
	  };
	
	  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'; // Use a lookup table to find the index.
	
	  var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
	
	  for (var i$1 = 0; i$1 < chars.length; i$1++) {
	    lookup$1[chars.charCodeAt(i$1)] = i$1;
	  }
	  var decode$1 = function decode(base64) {
	    var bufferLength = base64.length * 0.75,
	        len = base64.length,
	        i,
	        p = 0,
	        encoded1,
	        encoded2,
	        encoded3,
	        encoded4;
	
	    if (base64[base64.length - 1] === '=') {
	      bufferLength--;
	
	      if (base64[base64.length - 2] === '=') {
	        bufferLength--;
	      }
	    }
	
	    var arraybuffer = new ArrayBuffer(bufferLength),
	        bytes = new Uint8Array(arraybuffer);
	
	    for (i = 0; i < len; i += 4) {
	      encoded1 = lookup$1[base64.charCodeAt(i)];
	      encoded2 = lookup$1[base64.charCodeAt(i + 1)];
	      encoded3 = lookup$1[base64.charCodeAt(i + 2)];
	      encoded4 = lookup$1[base64.charCodeAt(i + 3)];
	      bytes[p++] = encoded1 << 2 | encoded2 >> 4;
	      bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
	      bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
	    }
	
	    return arraybuffer;
	  };
	
	  var withNativeArrayBuffer$1 = typeof ArrayBuffer === "function";
	
	  var decodePacket = function decodePacket(encodedPacket, binaryType) {
	    if (typeof encodedPacket !== "string") {
	      return {
	        type: "message",
	        data: mapBinary(encodedPacket, binaryType)
	      };
	    }
	
	    var type = encodedPacket.charAt(0);
	
	    if (type === "b") {
	      return {
	        type: "message",
	        data: decodeBase64Packet(encodedPacket.substring(1), binaryType)
	      };
	    }
	
	    var packetType = PACKET_TYPES_REVERSE[type];
	
	    if (!packetType) {
	      return ERROR_PACKET;
	    }
	
	    return encodedPacket.length > 1 ? {
	      type: PACKET_TYPES_REVERSE[type],
	      data: encodedPacket.substring(1)
	    } : {
	      type: PACKET_TYPES_REVERSE[type]
	    };
	  };
	
	  var decodeBase64Packet = function decodeBase64Packet(data, binaryType) {
	    if (withNativeArrayBuffer$1) {
	      var decoded = decode$1(data);
	      return mapBinary(decoded, binaryType);
	    } else {
	      return {
	        base64: true,
	        data: data
	      }; // fallback for old browsers
	    }
	  };
	
	  var mapBinary = function mapBinary(data, binaryType) {
	    switch (binaryType) {
	      case "blob":
	        return data instanceof ArrayBuffer ? new Blob([data]) : data;
	
	      case "arraybuffer":
	      default:
	        return data;
	      // assuming the data is already an ArrayBuffer
	    }
	  };
	
	  var SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
	
	  var encodePayload = function encodePayload(packets, callback) {
	    // some packets may be added to the array while encoding, so the initial length must be saved
	    var length = packets.length;
	    var encodedPackets = new Array(length);
	    var count = 0;
	    packets.forEach(function (packet, i) {
	      // force base64 encoding for binary packets
	      encodePacket(packet, false, function (encodedPacket) {
	        encodedPackets[i] = encodedPacket;
	
	        if (++count === length) {
	          callback(encodedPackets.join(SEPARATOR));
	        }
	      });
	    });
	  };
	
	  var decodePayload = function decodePayload(encodedPayload, binaryType) {
	    var encodedPackets = encodedPayload.split(SEPARATOR);
	    var packets = [];
	
	    for (var i = 0; i < encodedPackets.length; i++) {
	      var decodedPacket = decodePacket(encodedPackets[i], binaryType);
	      packets.push(decodedPacket);
	
	      if (decodedPacket.type === "error") {
	        break;
	      }
	    }
	
	    return packets;
	  };
	
	  var protocol$1 = 4;
	
	  /**
	   * Initialize a new `Emitter`.
	   *
	   * @api public
	   */
	  function Emitter(obj) {
	    if (obj) return mixin(obj);
	  }
	  /**
	   * Mixin the emitter properties.
	   *
	   * @param {Object} obj
	   * @return {Object}
	   * @api private
	   */
	
	  function mixin(obj) {
	    for (var key in Emitter.prototype) {
	      obj[key] = Emitter.prototype[key];
	    }
	
	    return obj;
	  }
	  /**
	   * Listen on the given `event` with `fn`.
	   *
	   * @param {String} event
	   * @param {Function} fn
	   * @return {Emitter}
	   * @api public
	   */
	
	
	  Emitter.prototype.on = Emitter.prototype.addEventListener = function (event, fn) {
	    this._callbacks = this._callbacks || {};
	    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
	    return this;
	  };
	  /**
	   * Adds an `event` listener that will be invoked a single
	   * time then automatically removed.
	   *
	   * @param {String} event
	   * @param {Function} fn
	   * @return {Emitter}
	   * @api public
	   */
	
	
	  Emitter.prototype.once = function (event, fn) {
	    function on() {
	      this.off(event, on);
	      fn.apply(this, arguments);
	    }
	
	    on.fn = fn;
	    this.on(event, on);
	    return this;
	  };
	  /**
	   * Remove the given callback for `event` or all
	   * registered callbacks.
	   *
	   * @param {String} event
	   * @param {Function} fn
	   * @return {Emitter}
	   * @api public
	   */
	
	
	  Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function (event, fn) {
	    this._callbacks = this._callbacks || {}; // all
	
	    if (0 == arguments.length) {
	      this._callbacks = {};
	      return this;
	    } // specific event
	
	
	    var callbacks = this._callbacks['$' + event];
	    if (!callbacks) return this; // remove all handlers
	
	    if (1 == arguments.length) {
	      delete this._callbacks['$' + event];
	      return this;
	    } // remove specific handler
	
	
	    var cb;
	
	    for (var i = 0; i < callbacks.length; i++) {
	      cb = callbacks[i];
	
	      if (cb === fn || cb.fn === fn) {
	        callbacks.splice(i, 1);
	        break;
	      }
	    } // Remove event specific arrays for event types that no
	    // one is subscribed for to avoid memory leak.
	
	
	    if (callbacks.length === 0) {
	      delete this._callbacks['$' + event];
	    }
	
	    return this;
	  };
	  /**
	   * Emit `event` with the given args.
	   *
	   * @param {String} event
	   * @param {Mixed} ...
	   * @return {Emitter}
	   */
	
	
	  Emitter.prototype.emit = function (event) {
	    this._callbacks = this._callbacks || {};
	    var args = new Array(arguments.length - 1),
	        callbacks = this._callbacks['$' + event];
	
	    for (var i = 1; i < arguments.length; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    if (callbacks) {
	      callbacks = callbacks.slice(0);
	
	      for (var i = 0, len = callbacks.length; i < len; ++i) {
	        callbacks[i].apply(this, args);
	      }
	    }
	
	    return this;
	  }; // alias used for reserved events (protected method)
	
	
	  Emitter.prototype.emitReserved = Emitter.prototype.emit;
	  /**
	   * Return array of callbacks for `event`.
	   *
	   * @param {String} event
	   * @return {Array}
	   * @api public
	   */
	
	  Emitter.prototype.listeners = function (event) {
	    this._callbacks = this._callbacks || {};
	    return this._callbacks['$' + event] || [];
	  };
	  /**
	   * Check if this emitter has `event` handlers.
	   *
	   * @param {String} event
	   * @return {Boolean}
	   * @api public
	   */
	
	
	  Emitter.prototype.hasListeners = function (event) {
	    return !!this.listeners(event).length;
	  };
	
	  var globalThisShim = function () {
	    if (typeof self !== "undefined") {
	      return self;
	    } else if (typeof window !== "undefined") {
	      return window;
	    } else {
	      return Function("return this")();
	    }
	  }();
	
	  function pick(obj) {
	    for (var _len = arguments.length, attr = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      attr[_key - 1] = arguments[_key];
	    }
	
	    return attr.reduce(function (acc, k) {
	      if (obj.hasOwnProperty(k)) {
	        acc[k] = obj[k];
	      }
	
	      return acc;
	    }, {});
	  } // Keep a reference to the real timeout functions so they can be used when overridden
	
	  var NATIVE_SET_TIMEOUT = setTimeout;
	  var NATIVE_CLEAR_TIMEOUT = clearTimeout;
	  function installTimerFunctions(obj, opts) {
	    if (opts.useNativeTimers) {
	      obj.setTimeoutFn = NATIVE_SET_TIMEOUT.bind(globalThisShim);
	      obj.clearTimeoutFn = NATIVE_CLEAR_TIMEOUT.bind(globalThisShim);
	    } else {
	      obj.setTimeoutFn = setTimeout.bind(globalThisShim);
	      obj.clearTimeoutFn = clearTimeout.bind(globalThisShim);
	    }
	  } // base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
	
	  var BASE64_OVERHEAD = 1.33; // we could also have used `new Blob([obj]).size`, but it isn't supported in IE9
	
	  function byteLength(obj) {
	    if (typeof obj === "string") {
	      return utf8Length(obj);
	    } // arraybuffer or blob
	
	
	    return Math.ceil((obj.byteLength || obj.size) * BASE64_OVERHEAD);
	  }
	
	  function utf8Length(str) {
	    var c = 0,
	        length = 0;
	
	    for (var i = 0, l = str.length; i < l; i++) {
	      c = str.charCodeAt(i);
	
	      if (c < 0x80) {
	        length += 1;
	      } else if (c < 0x800) {
	        length += 2;
	      } else if (c < 0xd800 || c >= 0xe000) {
	        length += 3;
	      } else {
	        i++;
	        length += 4;
	      }
	    }
	
	    return length;
	  }
	
	  var TransportError = /*#__PURE__*/function (_Error) {
	    _inherits(TransportError, _Error);
	
	    var _super = _createSuper(TransportError);
	
	    function TransportError(reason, description, context) {
	      var _this;
	
	      _classCallCheck(this, TransportError);
	
	      _this = _super.call(this, reason);
	      _this.description = description;
	      _this.context = context;
	      _this.type = "TransportError";
	      return _this;
	    }
	
	    return _createClass(TransportError);
	  }( /*#__PURE__*/_wrapNativeSuper(Error));
	
	  var Transport = /*#__PURE__*/function (_Emitter) {
	    _inherits(Transport, _Emitter);
	
	    var _super2 = _createSuper(Transport);
	
	    /**
	     * Transport abstract constructor.
	     *
	     * @param {Object} options.
	     * @api private
	     */
	    function Transport(opts) {
	      var _this2;
	
	      _classCallCheck(this, Transport);
	
	      _this2 = _super2.call(this);
	      _this2.writable = false;
	      installTimerFunctions(_assertThisInitialized(_this2), opts);
	      _this2.opts = opts;
	      _this2.query = opts.query;
	      _this2.readyState = "";
	      _this2.socket = opts.socket;
	      return _this2;
	    }
	    /**
	     * Emits an error.
	     *
	     * @param {String} reason
	     * @param description
	     * @param context - the error context
	     * @return {Transport} for chaining
	     * @api protected
	     */
	
	
	    _createClass(Transport, [{
	      key: "onError",
	      value: function onError(reason, description, context) {
	        _get(_getPrototypeOf(Transport.prototype), "emitReserved", this).call(this, "error", new TransportError(reason, description, context));
	
	        return this;
	      }
	      /**
	       * Opens the transport.
	       *
	       * @api public
	       */
	
	    }, {
	      key: "open",
	      value: function open() {
	        if ("closed" === this.readyState || "" === this.readyState) {
	          this.readyState = "opening";
	          this.doOpen();
	        }
	
	        return this;
	      }
	      /**
	       * Closes the transport.
	       *
	       * @api public
	       */
	
	    }, {
	      key: "close",
	      value: function close() {
	        if ("opening" === this.readyState || "open" === this.readyState) {
	          this.doClose();
	          this.onClose();
	        }
	
	        return this;
	      }
	      /**
	       * Sends multiple packets.
	       *
	       * @param {Array} packets
	       * @api public
	       */
	
	    }, {
	      key: "send",
	      value: function send(packets) {
	        if ("open" === this.readyState) {
	          this.write(packets);
	        }
	      }
	      /**
	       * Called upon open
	       *
	       * @api protected
	       */
	
	    }, {
	      key: "onOpen",
	      value: function onOpen() {
	        this.readyState = "open";
	        this.writable = true;
	
	        _get(_getPrototypeOf(Transport.prototype), "emitReserved", this).call(this, "open");
	      }
	      /**
	       * Called with data.
	       *
	       * @param {String} data
	       * @api protected
	       */
	
	    }, {
	      key: "onData",
	      value: function onData(data) {
	        var packet = decodePacket(data, this.socket.binaryType);
	        this.onPacket(packet);
	      }
	      /**
	       * Called with a decoded packet.
	       *
	       * @api protected
	       */
	
	    }, {
	      key: "onPacket",
	      value: function onPacket(packet) {
	        _get(_getPrototypeOf(Transport.prototype), "emitReserved", this).call(this, "packet", packet);
	      }
	      /**
	       * Called upon close.
	       *
	       * @api protected
	       */
	
	    }, {
	      key: "onClose",
	      value: function onClose(details) {
	        this.readyState = "closed";
	
	        _get(_getPrototypeOf(Transport.prototype), "emitReserved", this).call(this, "close", details);
	      }
	    }]);
	
	    return Transport;
	  }(Emitter);
	
	  // imported from https://github.com/unshiftio/yeast
	
	  var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split(''),
	      length = 64,
	      map = {};
	  var seed = 0,
	      i = 0,
	      prev;
	  /**
	   * Return a string representing the specified number.
	   *
	   * @param {Number} num The number to convert.
	   * @returns {String} The string representation of the number.
	   * @api public
	   */
	
	  function encode$1(num) {
	    var encoded = '';
	
	    do {
	      encoded = alphabet[num % length] + encoded;
	      num = Math.floor(num / length);
	    } while (num > 0);
	
	    return encoded;
	  }
	  /**
	   * Yeast: A tiny growing id generator.
	   *
	   * @returns {String} A unique id.
	   * @api public
	   */
	
	  function yeast() {
	    var now = encode$1(+new Date());
	    if (now !== prev) return seed = 0, prev = now;
	    return now + '.' + encode$1(seed++);
	  } //
	  // Map each character to its index.
	  //
	
	  for (; i < length; i++) {
	    map[alphabet[i]] = i;
	  }
	
	  // imported from https://github.com/galkn/querystring
	
	  /**
	   * Compiles a querystring
	   * Returns string representation of the object
	   *
	   * @param {Object}
	   * @api private
	   */
	  function encode(obj) {
	    var str = '';
	
	    for (var i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        if (str.length) str += '&';
	        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
	      }
	    }
	
	    return str;
	  }
	  /**
	   * Parses a simple querystring into an object
	   *
	   * @param {String} qs
	   * @api private
	   */
	
	  function decode(qs) {
	    var qry = {};
	    var pairs = qs.split('&');
	
	    for (var i = 0, l = pairs.length; i < l; i++) {
	      var pair = pairs[i].split('=');
	      qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	    }
	
	    return qry;
	  }
	
	  // imported from https://github.com/component/has-cors
	  var value = false;
	
	  try {
	    value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
	  } catch (err) {// if XMLHttp support is disabled in IE then it will throw
	    // when trying to create
	  }
	
	  var hasCORS = value;
	
	  // browser shim for xmlhttprequest module
	  function XHR(opts) {
	    var xdomain = opts.xdomain; // XMLHttpRequest can be disabled on IE
	
	    try {
	      if ("undefined" !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
	        return new XMLHttpRequest();
	      }
	    } catch (e) {}
	
	    if (!xdomain) {
	      try {
	        return new globalThisShim[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
	      } catch (e) {}
	    }
	  }
	
	  function empty() {}
	
	  var hasXHR2 = function () {
	    var xhr = new XHR({
	      xdomain: false
	    });
	    return null != xhr.responseType;
	  }();
	
	  var Polling = /*#__PURE__*/function (_Transport) {
	    _inherits(Polling, _Transport);
	
	    var _super = _createSuper(Polling);
	
	    /**
	     * XHR Polling constructor.
	     *
	     * @param {Object} opts
	     * @api public
	     */
	    function Polling(opts) {
	      var _this;
	
	      _classCallCheck(this, Polling);
	
	      _this = _super.call(this, opts);
	      _this.polling = false;
	
	      if (typeof location !== "undefined") {
	        var isSSL = "https:" === location.protocol;
	        var port = location.port; // some user agents have empty `location.port`
	
	        if (!port) {
	          port = isSSL ? "443" : "80";
	        }
	
	        _this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
	        _this.xs = opts.secure !== isSSL;
	      }
	      /**
	       * XHR supports binary
	       */
	
	
	      var forceBase64 = opts && opts.forceBase64;
	      _this.supportsBinary = hasXHR2 && !forceBase64;
	      return _this;
	    }
	    /**
	     * Transport name.
	     */
	
	
	    _createClass(Polling, [{
	      key: "name",
	      get: function get() {
	        return "polling";
	      }
	      /**
	       * Opens the socket (triggers polling). We write a PING message to determine
	       * when the transport is open.
	       *
	       * @api private
	       */
	
	    }, {
	      key: "doOpen",
	      value: function doOpen() {
	        this.poll();
	      }
	      /**
	       * Pauses polling.
	       *
	       * @param {Function} callback upon buffers are flushed and transport is paused
	       * @api private
	       */
	
	    }, {
	      key: "pause",
	      value: function pause(onPause) {
	        var _this2 = this;
	
	        this.readyState = "pausing";
	
	        var pause = function pause() {
	          _this2.readyState = "paused";
	          onPause();
	        };
	
	        if (this.polling || !this.writable) {
	          var total = 0;
	
	          if (this.polling) {
	            total++;
	            this.once("pollComplete", function () {
	              --total || pause();
	            });
	          }
	
	          if (!this.writable) {
	            total++;
	            this.once("drain", function () {
	              --total || pause();
	            });
	          }
	        } else {
	          pause();
	        }
	      }
	      /**
	       * Starts polling cycle.
	       *
	       * @api public
	       */
	
	    }, {
	      key: "poll",
	      value: function poll() {
	        this.polling = true;
	        this.doPoll();
	        this.emitReserved("poll");
	      }
	      /**
	       * Overloads onData to detect payloads.
	       *
	       * @api private
	       */
	
	    }, {
	      key: "onData",
	      value: function onData(data) {
	        var _this3 = this;
	
	        var callback = function callback(packet) {
	          // if its the first message we consider the transport open
	          if ("opening" === _this3.readyState && packet.type === "open") {
	            _this3.onOpen();
	          } // if its a close packet, we close the ongoing requests
	
	
	          if ("close" === packet.type) {
	            _this3.onClose({
	              description: "transport closed by the server"
	            });
	
	            return false;
	          } // otherwise bypass onData and handle the message
	
	
	          _this3.onPacket(packet);
	        }; // decode payload
	
	
	        decodePayload(data, this.socket.binaryType).forEach(callback); // if an event did not trigger closing
	
	        if ("closed" !== this.readyState) {
	          // if we got data we're not polling
	          this.polling = false;
	          this.emitReserved("pollComplete");
	
	          if ("open" === this.readyState) {
	            this.poll();
	          }
	        }
	      }
	      /**
	       * For polling, send a close packet.
	       *
	       * @api private
	       */
	
	    }, {
	      key: "doClose",
	      value: function doClose() {
	        var _this4 = this;
	
	        var close = function close() {
	          _this4.write([{
	            type: "close"
	          }]);
	        };
	
	        if ("open" === this.readyState) {
	          close();
	        } else {
	          // in case we're trying to close while
	          // handshaking is in progress (GH-164)
	          this.once("open", close);
	        }
	      }
	      /**
	       * Writes a packets payload.
	       *
	       * @param {Array} data packets
	       * @param {Function} drain callback
	       * @api private
	       */
	
	    }, {
	      key: "write",
	      value: function write(packets) {
	        var _this5 = this;
	
	        this.writable = false;
	        encodePayload(packets, function (data) {
	          _this5.doWrite(data, function () {
	            _this5.writable = true;
	
	            _this5.emitReserved("drain");
	          });
	        });
	      }
	      /**
	       * Generates uri for connection.
	       *
	       * @api private
	       */
	
	    }, {
	      key: "uri",
	      value: function uri() {
	        var query = this.query || {};
	        var schema = this.opts.secure ? "https" : "http";
	        var port = ""; // cache busting is forced
	
	        if (false !== this.opts.timestampRequests) {
	          query[this.opts.timestampParam] = yeast();
	        }
	
	        if (!this.supportsBinary && !query.sid) {
	          query.b64 = 1;
	        } // avoid port if default for schema
	
	
	        if (this.opts.port && ("https" === schema && Number(this.opts.port) !== 443 || "http" === schema && Number(this.opts.port) !== 80)) {
	          port = ":" + this.opts.port;
	        }
	
	        var encodedQuery = encode(query);
	        var ipv6 = this.opts.hostname.indexOf(":") !== -1;
	        return schema + "://" + (ipv6 ? "[" + this.opts.hostname + "]" : this.opts.hostname) + port + this.opts.path + (encodedQuery.length ? "?" + encodedQuery : "");
	      }
	      /**
	       * Creates a request.
	       *
	       * @param {String} method
	       * @api private
	       */
	
	    }, {
	      key: "request",
	      value: function request() {
	        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _extends(opts, {
	          xd: this.xd,
	          xs: this.xs
	        }, this.opts);
	
	        return new Request(this.uri(), opts);
	      }
	      /**
	       * Sends data.
	       *
	       * @param {String} data to send.
	       * @param {Function} called upon flush.
	       * @api private
	       */
	
	    }, {
	      key: "doWrite",
	      value: function doWrite(data, fn) {
	        var _this6 = this;
	
	        var req = this.request({
	          method: "POST",
	          data: data
	        });
	        req.on("success", fn);
	        req.on("error", function (xhrStatus, context) {
	          _this6.onError("xhr post error", xhrStatus, context);
	        });
	      }
	      /**
	       * Starts a poll cycle.
	       *
	       * @api private
	       */
	
	    }, {
	      key: "doPoll",
	      value: function doPoll() {
	        var _this7 = this;
	
	        var req = this.request();
	        req.on("data", this.onData.bind(this));
	        req.on("error", function (xhrStatus, context) {
	          _this7.onError("xhr poll error", xhrStatus, context);
	        });
	        this.pollXhr = req;
	      }
	    }]);
	
	    return Polling;
	  }(Transport);
	  var Request = /*#__PURE__*/function (_Emitter) {
	    _inherits(Request, _Emitter);
	
	    var _super2 = _createSuper(Request);
	
	    /**
	     * Request constructor
	     *
	     * @param {Object} options
	     * @api public
	     */
	    function Request(uri, opts) {
	      var _this8;
	
	      _classCallCheck(this, Request);
	
	      _this8 = _super2.call(this);
	      installTimerFunctions(_assertThisInitialized(_this8), opts);
	      _this8.opts = opts;
	      _this8.method = opts.method || "GET";
	      _this8.uri = uri;
	      _this8.async = false !== opts.async;
	      _this8.data = undefined !== opts.data ? opts.data : null;
	
	      _this8.create();
	
	      return _this8;
	    }
	    /**
	     * Creates the XHR object and sends the request.
	     *
	     * @api private
	     */
	
	
	    _createClass(Request, [{
	      key: "create",
	      value: function create() {
	        var _this9 = this;
	
	        var opts = pick(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
	        opts.xdomain = !!this.opts.xd;
	        opts.xscheme = !!this.opts.xs;
	        var xhr = this.xhr = new XHR(opts);
	
	        try {
	          xhr.open(this.method, this.uri, this.async);
	
	          try {
	            if (this.opts.extraHeaders) {
	              xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
	
	              for (var i in this.opts.extraHeaders) {
	                if (this.opts.extraHeaders.hasOwnProperty(i)) {
	                  xhr.setRequestHeader(i, this.opts.extraHeaders[i]);
	                }
	              }
	            }
	          } catch (e) {}
	
	          if ("POST" === this.method) {
	            try {
	              xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
	            } catch (e) {}
	          }
	
	          try {
	            xhr.setRequestHeader("Accept", "*/*");
	          } catch (e) {} // ie6 check
	
	
	          if ("withCredentials" in xhr) {
	            xhr.withCredentials = this.opts.withCredentials;
	          }
	
	          if (this.opts.requestTimeout) {
	            xhr.timeout = this.opts.requestTimeout;
	          }
	
	          xhr.onreadystatechange = function () {
	            if (4 !== xhr.readyState) return;
	
	            if (200 === xhr.status || 1223 === xhr.status) {
	              _this9.onLoad();
	            } else {
	              // make sure the `error` event handler that's user-set
	              // does not throw in the same tick and gets caught here
	              _this9.setTimeoutFn(function () {
	                _this9.onError(typeof xhr.status === "number" ? xhr.status : 0);
	              }, 0);
	            }
	          };
	
	          xhr.send(this.data);
	        } catch (e) {
	          // Need to defer since .create() is called directly from the constructor
	          // and thus the 'error' event can only be only bound *after* this exception
	          // occurs.  Therefore, also, we cannot throw here at all.
	          this.setTimeoutFn(function () {
	            _this9.onError(e);
	          }, 0);
	          return;
	        }
	
	        if (typeof document !== "undefined") {
	          this.index = Request.requestsCount++;
	          Request.requests[this.index] = this;
	        }
	      }
	      /**
	       * Called upon error.
	       *
	       * @api private
	       */
	
	    }, {
	      key: "onError",
	      value: function onError(err) {
	        this.emitReserved("error", err, this.xhr);
	        this.cleanup(true);
	      }
	      /**
	       * Cleans up house.
	       *
	       * @api private
	       */
	
	    }, {
	      key: "cleanup",
	      value: function cleanup(fromError) {
	        if ("undefined" === typeof this.xhr || null === this.xhr) {
	          return;
	        }
	
	        this.xhr.onreadystatechange = empty;
	
	        if (fromError) {
	          try {
	            this.xhr.abort();
	          } catch (e) {}
	        }
	
	        if (typeof document !== "undefined") {
	          delete Request.requests[this.index];
	        }
	
	        this.xhr = null;
	      }
	      /**
	       * Called upon load.
	       *
	       * @api private
	       */
	
	    }, {
	      key: "onLoad",
	      value: function onLoad() {
	        var data = this.xhr.responseText;
	
	        if (data !== null) {
	          this.emitReserved("data", data);
	          this.emitReserved("success");
	          this.cleanup();
	        }
	      }
	      /**
	       * Aborts the request.
	       *
	       * @api public
	       */
	
	    }, {
	      key: "abort",
	      value: function abort() {
	        this.cleanup();
	      }
	    }]);
	
	    return Request;
	  }(Emitter);
	  Request.requestsCount = 0;
	  Request.requests = {};
	  /**
	   * Aborts pending requests when unloading the window. This is needed to prevent
	   * memory leaks (e.g. when using IE) and to ensure that no spurious error is
	   * emitted.
	   */
	
	  if (typeof document !== "undefined") {
	    // @ts-ignore
	    if (typeof attachEvent === "function") {
	      // @ts-ignore
	      attachEvent("onunload", unloadHandler);
	    } else if (typeof addEventListener === "function") {
	      var terminationEvent = "onpagehide" in globalThisShim ? "pagehide" : "unload";
	      addEventListener(terminationEvent, unloadHandler, false);
	    }
	  }
	
	  function unloadHandler() {
	    for (var i in Request.requests) {
	      if (Request.requests.hasOwnProperty(i)) {
	        Request.requests[i].abort();
	      }
	    }
	  }
	
	  var nextTick = function () {
	    var isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
	
	    if (isPromiseAvailable) {
	      return function (cb) {
	        return Promise.resolve().then(cb);
	      };
	    } else {
	      return function (cb, setTimeoutFn) {
	        return setTimeoutFn(cb, 0);
	      };
	    }
	  }();
	  var WebSocket = globalThisShim.WebSocket || globalThisShim.MozWebSocket;
	  var usingBrowserWebSocket = true;
	  var defaultBinaryType = "arraybuffer";
	
	  var isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
	  var WS = /*#__PURE__*/function (_Transport) {
	    _inherits(WS, _Transport);
	
	    var _super = _createSuper(WS);
	
	    /**
	     * WebSocket transport constructor.
	     *
	     * @api {Object} connection options
	     * @api public
	     */
	    function WS(opts) {
	      var _this;
	
	      _classCallCheck(this, WS);
	
	      _this = _super.call(this, opts);
	      _this.supportsBinary = !opts.forceBase64;
	      return _this;
	    }
	    /**
	     * Transport name.
	     *
	     * @api public
	     */
	
	
	    _createClass(WS, [{
	      key: "name",
	      get: function get() {
	        return "websocket";
	      }
	      /**
	       * Opens socket.
	       *
	       * @api private
	       */
	
	    }, {
	      key: "doOpen",
	      value: function doOpen() {
	        if (!this.check()) {
	          // let probe timeout
	          return;
	        }
	
	        var uri = this.uri();
	        var protocols = this.opts.protocols; // React Native only supports the 'headers' option, and will print a warning if anything else is passed
	
	        var opts = isReactNative ? {} : pick(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
	
	        if (this.opts.extraHeaders) {
	          opts.headers = this.opts.extraHeaders;
	        }
	
	        try {
	          this.ws = usingBrowserWebSocket && !isReactNative ? protocols ? new WebSocket(uri, protocols) : new WebSocket(uri) : new WebSocket(uri, protocols, opts);
	        } catch (err) {
	          return this.emitReserved("error", err);
	        }
	
	        this.ws.binaryType = this.socket.binaryType || defaultBinaryType;
	        this.addEventListeners();
	      }
	      /**
	       * Adds event listeners to the socket
	       *
	       * @api private
	       */
	
	    }, {
	      key: "addEventListeners",
	      value: function addEventListeners() {
	        var _this2 = this;
	
	        this.ws.onopen = function () {
	          if (_this2.opts.autoUnref) {
	            _this2.ws._socket.unref();
	          }
	
	          _this2.onOpen();
	        };
	
	        this.ws.onclose = function (closeEvent) {
	          return _this2.onClose({
	            description: "websocket connection closed",
	            context: closeEvent
	          });
	        };
	
	        this.ws.onmessage = function (ev) {
	          return _this2.onData(ev.data);
	        };
	
	        this.ws.onerror = function (e) {
	          return _this2.onError("websocket error", e);
	        };
	      }
	      /**
	       * Writes data to socket.
	       *
	       * @param {Array} array of packets.
	       * @api private
	       */
	
	    }, {
	      key: "write",
	      value: function write(packets) {
	        var _this3 = this;
	
	        this.writable = false; // encodePacket efficient as it uses WS framing
	        // no need for encodePayload
	
	        var _loop = function _loop(i) {
	          var packet = packets[i];
	          var lastPacket = i === packets.length - 1;
	          encodePacket(packet, _this3.supportsBinary, function (data) {
	            // always create a new object (GH-437)
	            var opts = {};
	            // have a chance of informing us about it yet, in that case send will
	            // throw an error
	
	
	            try {
	              if (usingBrowserWebSocket) {
	                // TypeError is thrown when passing the second argument on Safari
	                _this3.ws.send(data);
	              }
	            } catch (e) {}
	
	            if (lastPacket) {
	              // fake drain
	              // defer to next tick to allow Socket to clear writeBuffer
	              nextTick(function () {
	                _this3.writable = true;
	
	                _this3.emitReserved("drain");
	              }, _this3.setTimeoutFn);
	            }
	          });
	        };
	
	        for (var i = 0; i < packets.length; i++) {
	          _loop(i);
	        }
	      }
	      /**
	       * Closes socket.
	       *
	       * @api private
	       */
	
	    }, {
	      key: "doClose",
	      value: function doClose() {
	        if (typeof this.ws !== "undefined") {
	          this.ws.close();
	          this.ws = null;
	        }
	      }
	      /**
	       * Generates uri for connection.
	       *
	       * @api private
	       */
	
	    }, {
	      key: "uri",
	      value: function uri() {
	        var query = this.query || {};
	        var schema = this.opts.secure ? "wss" : "ws";
	        var port = ""; // avoid port if default for schema
	
	        if (this.opts.port && ("wss" === schema && Number(this.opts.port) !== 443 || "ws" === schema && Number(this.opts.port) !== 80)) {
	          port = ":" + this.opts.port;
	        } // append timestamp to URI
	
	
	        if (this.opts.timestampRequests) {
	          query[this.opts.timestampParam] = yeast();
	        } // communicate binary support capabilities
	
	
	        if (!this.supportsBinary) {
	          query.b64 = 1;
	        }
	
	        var encodedQuery = encode(query);
	        var ipv6 = this.opts.hostname.indexOf(":") !== -1;
	        return schema + "://" + (ipv6 ? "[" + this.opts.hostname + "]" : this.opts.hostname) + port + this.opts.path + (encodedQuery.length ? "?" + encodedQuery : "");
	      }
	      /**
	       * Feature detection for WebSocket.
	       *
	       * @return {Boolean} whether this transport is available.
	       * @api public
	       */
	
	    }, {
	      key: "check",
	      value: function check() {
	        return !!WebSocket;
	      }
	    }]);
	
	    return WS;
	  }(Transport);
	
	  var transports = {
	    websocket: WS,
	    polling: Polling
	  };
	
	  // imported from https://github.com/galkn/parseuri
	
	  /**
	   * Parses an URI
	   *
	   * @author Steven Levithan <stevenlevithan.com> (MIT license)
	   * @api private
	   */
	  var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
	  var parts = ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'];
	  function parse(str) {
	    var src = str,
	        b = str.indexOf('['),
	        e = str.indexOf(']');
	
	    if (b != -1 && e != -1) {
	      str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
	    }
	
	    var m = re.exec(str || ''),
	        uri = {},
	        i = 14;
	
	    while (i--) {
	      uri[parts[i]] = m[i] || '';
	    }
	
	    if (b != -1 && e != -1) {
	      uri.source = src;
	      uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
	      uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
	      uri.ipv6uri = true;
	    }
	
	    uri.pathNames = pathNames(uri, uri['path']);
	    uri.queryKey = queryKey(uri, uri['query']);
	    return uri;
	  }
	
	  function pathNames(obj, path) {
	    var regx = /\/{2,9}/g,
	        names = path.replace(regx, "/").split("/");
	
	    if (path.substr(0, 1) == '/' || path.length === 0) {
	      names.splice(0, 1);
	    }
	
	    if (path.substr(path.length - 1, 1) == '/') {
	      names.splice(names.length - 1, 1);
	    }
	
	    return names;
	  }
	
	  function queryKey(uri, query) {
	    var data = {};
	    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function ($0, $1, $2) {
	      if ($1) {
	        data[$1] = $2;
	      }
	    });
	    return data;
	  }
	
	  var Socket$1 = /*#__PURE__*/function (_Emitter) {
	    _inherits(Socket, _Emitter);
	
	    var _super = _createSuper(Socket);
	
	    /**
	     * Socket constructor.
	     *
	     * @param {String|Object} uri or options
	     * @param {Object} opts - options
	     * @api public
	     */
	    function Socket(uri) {
	      var _this;
	
	      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      _classCallCheck(this, Socket);
	
	      _this = _super.call(this);
	
	      if (uri && "object" === _typeof(uri)) {
	        opts = uri;
	        uri = null;
	      }
	
	      if (uri) {
	        uri = parse(uri);
	        opts.hostname = uri.host;
	        opts.secure = uri.protocol === "https" || uri.protocol === "wss";
	        opts.port = uri.port;
	        if (uri.query) opts.query = uri.query;
	      } else if (opts.host) {
	        opts.hostname = parse(opts.host).host;
	      }
	
	      installTimerFunctions(_assertThisInitialized(_this), opts);
	      _this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
	
	      if (opts.hostname && !opts.port) {
	        // if no port is specified manually, use the protocol default
	        opts.port = _this.secure ? "443" : "80";
	      }
	
	      _this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
	      _this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : _this.secure ? "443" : "80");
	      _this.transports = opts.transports || ["polling", "websocket"];
	      _this.readyState = "";
	      _this.writeBuffer = [];
	      _this.prevBufferLen = 0;
	      _this.opts = _extends({
	        path: "/engine.io",
	        agent: false,
	        withCredentials: false,
	        upgrade: true,
	        timestampParam: "t",
	        rememberUpgrade: false,
	        rejectUnauthorized: true,
	        perMessageDeflate: {
	          threshold: 1024
	        },
	        transportOptions: {},
	        closeOnBeforeunload: true
	      }, opts);
	      _this.opts.path = _this.opts.path.replace(/\/$/, "") + "/";
	
	      if (typeof _this.opts.query === "string") {
	        _this.opts.query = decode(_this.opts.query);
	      } // set on handshake
	
	
	      _this.id = null;
	      _this.upgrades = null;
	      _this.pingInterval = null;
	      _this.pingTimeout = null; // set on heartbeat
	
	      _this.pingTimeoutTimer = null;
	
	      if (typeof addEventListener === "function") {
	        if (_this.opts.closeOnBeforeunload) {
	          // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
	          // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
	          // closed/reloaded)
	          addEventListener("beforeunload", function () {
	            if (_this.transport) {
	              // silently close the transport
	              _this.transport.removeAllListeners();
	
	              _this.transport.close();
	            }
	          }, false);
	        }
	
	        if (_this.hostname !== "localhost") {
	          _this.offlineEventListener = function () {
	            _this.onClose("transport close", {
	              description: "network connection lost"
	            });
	          };
	
	          addEventListener("offline", _this.offlineEventListener, false);
	        }
	      }
	
	      _this.open();
	
	      return _this;
	    }
	    /**
	     * Creates transport of the given type.
	     *
	     * @param {String} transport name
	     * @return {Transport}
	     * @api private
	     */
	
	
	    _createClass(Socket, [{
	      key: "createTransport",
	      value: function createTransport(name) {
	        var query = _extends({}, this.opts.query); // append engine.io protocol identifier
	
	
	        query.EIO = protocol$1; // transport name
	
	        query.transport = name; // session id if we already have one
	
	        if (this.id) query.sid = this.id;
	
	        var opts = _extends({}, this.opts.transportOptions[name], this.opts, {
	          query: query,
	          socket: this,
	          hostname: this.hostname,
	          secure: this.secure,
	          port: this.port
	        });
	
	        return new transports[name](opts);
	      }
	      /**
	       * Initializes transport to use and starts probe.
	       *
	       * @api private
	       */
	
	    }, {
	      key: "open",
	      value: function open() {
	        var _this2 = this;
	
	        var transport;
	
	        if (this.opts.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) {
	          transport = "websocket";
	        } else if (0 === this.transports.length) {
	          // Emit error on next tick so it can be listened to
	          this.setTimeoutFn(function () {
	            _this2.emitReserved("error", "No transports available");
	          }, 0);
	          return;
	        } else {
	          transport = this.transports[0];
	        }
	
	        this.readyState = "opening"; // Retry with the next transport if the transport is disabled (jsonp: false)
	
	        try {
	          transport = this.createTransport(transport);
	        } catch (e) {
	          this.transports.shift();
	          this.open();
	          return;
	        }
	
	        transport.open();
	        this.setTransport(transport);
	      }
	      /**
	       * Sets the current transport. Disables the existing one (if any).
	       *
	       * @api private
	       */
	
	    }, {
	      key: "setTransport",
	      value: function setTransport(transport) {
	        var _this3 = this;
	
	        if (this.transport) {
	          this.transport.removeAllListeners();
	        } // set up transport
	
	
	        this.transport = transport; // set up transport listeners
	
	        transport.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", function (reason) {
	          return _this3.onClose("transport close", reason);
	        });
	      }
	      /**
	       * Probes a transport.
	       *
	       * @param {String} transport name
	       * @api private
	       */
	
	    }, {
	      key: "probe",
	      value: function probe(name) {
	        var _this4 = this;
	
	        var transport = this.createTransport(name);
	        var failed = false;
	        Socket.priorWebsocketSuccess = false;
	
	        var onTransportOpen = function onTransportOpen() {
	          if (failed) return;
	          transport.send([{
	            type: "ping",
	            data: "probe"
	          }]);
	          transport.once("packet", function (msg) {
	            if (failed) return;
	
	            if ("pong" === msg.type && "probe" === msg.data) {
	              _this4.upgrading = true;
	
	              _this4.emitReserved("upgrading", transport);
	
	              if (!transport) return;
	              Socket.priorWebsocketSuccess = "websocket" === transport.name;
	
	              _this4.transport.pause(function () {
	                if (failed) return;
	                if ("closed" === _this4.readyState) return;
	                cleanup();
	
	                _this4.setTransport(transport);
	
	                transport.send([{
	                  type: "upgrade"
	                }]);
	
	                _this4.emitReserved("upgrade", transport);
	
	                transport = null;
	                _this4.upgrading = false;
	
	                _this4.flush();
	              });
	            } else {
	              var err = new Error("probe error"); // @ts-ignore
	
	              err.transport = transport.name;
	
	              _this4.emitReserved("upgradeError", err);
	            }
	          });
	        };
	
	        function freezeTransport() {
	          if (failed) return; // Any callback called by transport should be ignored since now
	
	          failed = true;
	          cleanup();
	          transport.close();
	          transport = null;
	        } // Handle any error that happens while probing
	
	
	        var onerror = function onerror(err) {
	          var error = new Error("probe error: " + err); // @ts-ignore
	
	          error.transport = transport.name;
	          freezeTransport();
	
	          _this4.emitReserved("upgradeError", error);
	        };
	
	        function onTransportClose() {
	          onerror("transport closed");
	        } // When the socket is closed while we're probing
	
	
	        function onclose() {
	          onerror("socket closed");
	        } // When the socket is upgraded while we're probing
	
	
	        function onupgrade(to) {
	          if (transport && to.name !== transport.name) {
	            freezeTransport();
	          }
	        } // Remove all listeners on the transport and on self
	
	
	        var cleanup = function cleanup() {
	          transport.removeListener("open", onTransportOpen);
	          transport.removeListener("error", onerror);
	          transport.removeListener("close", onTransportClose);
	
	          _this4.off("close", onclose);
	
	          _this4.off("upgrading", onupgrade);
	        };
	
	        transport.once("open", onTransportOpen);
	        transport.once("error", onerror);
	        transport.once("close", onTransportClose);
	        this.once("close", onclose);
	        this.once("upgrading", onupgrade);
	        transport.open();
	      }
	      /**
	       * Called when connection is deemed open.
	       *
	       * @api private
	       */
	
	    }, {
	      key: "onOpen",
	      value: function onOpen() {
	        this.readyState = "open";
	        Socket.priorWebsocketSuccess = "websocket" === this.transport.name;
	        this.emitReserved("open");
	        this.flush(); // we check for `readyState` in case an `open`
	        // listener already closed the socket
	
	        if ("open" === this.readyState && this.opts.upgrade && this.transport.pause) {
	          var i = 0;
	          var l = this.upgrades.length;
	
	          for (; i < l; i++) {
	            this.probe(this.upgrades[i]);
	          }
	        }
	      }
	      /**
	       * Handles a packet.
	       *
	       * @api private
	       */
	
	    }, {
	      key: "onPacket",
	      value: function onPacket(packet) {
	        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
	          this.emitReserved("packet", packet); // Socket is live - any packet counts
	
	          this.emitReserved("heartbeat");
	
	          switch (packet.type) {
	            case "open":
	              this.onHandshake(JSON.parse(packet.data));
	              break;
	
	            case "ping":
	              this.resetPingTimeout();
	              this.sendPacket("pong");
	              this.emitReserved("ping");
	              this.emitReserved("pong");
	              break;
	
	            case "error":
	              var err = new Error("server error"); // @ts-ignore
	
	              err.code = packet.data;
	              this.onError(err);
	              break;
	
	            case "message":
	              this.emitReserved("data", packet.data);
	              this.emitReserved("message", packet.data);
	              break;
	          }
	        }
	      }
	      /**
	       * Called upon handshake completion.
	       *
	       * @param {Object} data - handshake obj
	       * @api private
	       */
	
	    }, {
	      key: "onHandshake",
	      value: function onHandshake(data) {
	        this.emitReserved("handshake", data);
	        this.id = data.sid;
	        this.transport.query.sid = data.sid;
	        this.upgrades = this.filterUpgrades(data.upgrades);
	        this.pingInterval = data.pingInterval;
	        this.pingTimeout = data.pingTimeout;
	        this.maxPayload = data.maxPayload;
	        this.onOpen(); // In case open handler closes socket
	
	        if ("closed" === this.readyState) return;
	        this.resetPingTimeout();
	      }
	      /**
	       * Sets and resets ping timeout timer based on server pings.
	       *
	       * @api private
	       */
	
	    }, {
	      key: "resetPingTimeout",
	      value: function resetPingTimeout() {
	        var _this5 = this;
	
	        this.clearTimeoutFn(this.pingTimeoutTimer);
	        this.pingTimeoutTimer = this.setTimeoutFn(function () {
	          _this5.onClose("ping timeout");
	        }, this.pingInterval + this.pingTimeout);
	
	        if (this.opts.autoUnref) {
	          this.pingTimeoutTimer.unref();
	        }
	      }
	      /**
	       * Called on `drain` event
	       *
	       * @api private
	       */
	
	    }, {
	      key: "onDrain",
	      value: function onDrain() {
	        this.writeBuffer.splice(0, this.prevBufferLen); // setting prevBufferLen = 0 is very important
	        // for example, when upgrading, upgrade packet is sent over,
	        // and a nonzero prevBufferLen could cause problems on `drain`
	
	        this.prevBufferLen = 0;
	
	        if (0 === this.writeBuffer.length) {
	          this.emitReserved("drain");
	        } else {
	          this.flush();
	        }
	      }
	      /**
	       * Flush write buffers.
	       *
	       * @api private
	       */
	
	    }, {
	      key: "flush",
	      value: function flush() {
	        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
	          var packets = this.getWritablePackets();
	          this.transport.send(packets); // keep track of current length of writeBuffer
	          // splice writeBuffer and callbackBuffer on `drain`
	
	          this.prevBufferLen = packets.length;
	          this.emitReserved("flush");
	        }
	      }
	      /**
	       * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
	       * long-polling)
	       *
	       * @private
	       */
	
	    }, {
	      key: "getWritablePackets",
	      value: function getWritablePackets() {
	        var shouldCheckPayloadSize = this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
	
	        if (!shouldCheckPayloadSize) {
	          return this.writeBuffer;
	        }
	
	        var payloadSize = 1; // first packet type
	
	        for (var i = 0; i < this.writeBuffer.length; i++) {
	          var data = this.writeBuffer[i].data;
	
	          if (data) {
	            payloadSize += byteLength(data);
	          }
	
	          if (i > 0 && payloadSize > this.maxPayload) {
	            return this.writeBuffer.slice(0, i);
	          }
	
	          payloadSize += 2; // separator + packet type
	        }
	
	        return this.writeBuffer;
	      }
	      /**
	       * Sends a message.
	       *
	       * @param {String} message.
	       * @param {Function} callback function.
	       * @param {Object} options.
	       * @return {Socket} for chaining.
	       * @api public
	       */
	
	    }, {
	      key: "write",
	      value: function write(msg, options, fn) {
	        this.sendPacket("message", msg, options, fn);
	        return this;
	      }
	    }, {
	      key: "send",
	      value: function send(msg, options, fn) {
	        this.sendPacket("message", msg, options, fn);
	        return this;
	      }
	      /**
	       * Sends a packet.
	       *
	       * @param {String} packet type.
	       * @param {String} data.
	       * @param {Object} options.
	       * @param {Function} callback function.
	       * @api private
	       */
	
	    }, {
	      key: "sendPacket",
	      value: function sendPacket(type, data, options, fn) {
	        if ("function" === typeof data) {
	          fn = data;
	          data = undefined;
	        }
	
	        if ("function" === typeof options) {
	          fn = options;
	          options = null;
	        }
	
	        if ("closing" === this.readyState || "closed" === this.readyState) {
	          return;
	        }
	
	        options = options || {};
	        options.compress = false !== options.compress;
	        var packet = {
	          type: type,
	          data: data,
	          options: options
	        };
	        this.emitReserved("packetCreate", packet);
	        this.writeBuffer.push(packet);
	        if (fn) this.once("flush", fn);
	        this.flush();
	      }
	      /**
	       * Closes the connection.
	       *
	       * @api public
	       */
	
	    }, {
	      key: "close",
	      value: function close() {
	        var _this6 = this;
	
	        var close = function close() {
	          _this6.onClose("forced close");
	
	          _this6.transport.close();
	        };
	
	        var cleanupAndClose = function cleanupAndClose() {
	          _this6.off("upgrade", cleanupAndClose);
	
	          _this6.off("upgradeError", cleanupAndClose);
	
	          close();
	        };
	
	        var waitForUpgrade = function waitForUpgrade() {
	          // wait for upgrade to finish since we can't send packets while pausing a transport
	          _this6.once("upgrade", cleanupAndClose);
	
	          _this6.once("upgradeError", cleanupAndClose);
	        };
	
	        if ("opening" === this.readyState || "open" === this.readyState) {
	          this.readyState = "closing";
	
	          if (this.writeBuffer.length) {
	            this.once("drain", function () {
	              if (_this6.upgrading) {
	                waitForUpgrade();
	              } else {
	                close();
	              }
	            });
	          } else if (this.upgrading) {
	            waitForUpgrade();
	          } else {
	            close();
	          }
	        }
	
	        return this;
	      }
	      /**
	       * Called upon transport error
	       *
	       * @api private
	       */
	
	    }, {
	      key: "onError",
	      value: function onError(err) {
	        Socket.priorWebsocketSuccess = false;
	        this.emitReserved("error", err);
	        this.onClose("transport error", err);
	      }
	      /**
	       * Called upon transport close.
	       *
	       * @api private
	       */
	
	    }, {
	      key: "onClose",
	      value: function onClose(reason, description) {
	        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
	          // clear timers
	          this.clearTimeoutFn(this.pingTimeoutTimer); // stop event from firing again for transport
	
	          this.transport.removeAllListeners("close"); // ensure transport won't stay open
	
	          this.transport.close(); // ignore further transport communication
	
	          this.transport.removeAllListeners();
	
	          if (typeof removeEventListener === "function") {
	            removeEventListener("offline", this.offlineEventListener, false);
	          } // set ready state
	
	
	          this.readyState = "closed"; // clear session id
	
	          this.id = null; // emit close event
	
	          this.emitReserved("close", reason, description); // clean buffers after, so users can still
	          // grab the buffers on `close` event
	
	          this.writeBuffer = [];
	          this.prevBufferLen = 0;
	        }
	      }
	      /**
	       * Filters upgrades, returning only those matching client transports.
	       *
	       * @param {Array} server upgrades
	       * @api private
	       *
	       */
	
	    }, {
	      key: "filterUpgrades",
	      value: function filterUpgrades(upgrades) {
	        var filteredUpgrades = [];
	        var i = 0;
	        var j = upgrades.length;
	
	        for (; i < j; i++) {
	          if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
	        }
	
	        return filteredUpgrades;
	      }
	    }]);
	
	    return Socket;
	  }(Emitter);
	  Socket$1.protocol = protocol$1;
	
	  Socket$1.protocol;
	
	  /**
	   * URL parser.
	   *
	   * @param uri - url
	   * @param path - the request path of the connection
	   * @param loc - An object meant to mimic window.location.
	   *        Defaults to window.location.
	   * @public
	   */
	
	  function url(uri) {
	    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	    var loc = arguments.length > 2 ? arguments[2] : undefined;
	    var obj = uri; // default to window.location
	
	    loc = loc || typeof location !== "undefined" && location;
	    if (null == uri) uri = loc.protocol + "//" + loc.host; // relative path support
	
	    if (typeof uri === "string") {
	      if ("/" === uri.charAt(0)) {
	        if ("/" === uri.charAt(1)) {
	          uri = loc.protocol + uri;
	        } else {
	          uri = loc.host + uri;
	        }
	      }
	
	      if (!/^(https?|wss?):\/\//.test(uri)) {
	        if ("undefined" !== typeof loc) {
	          uri = loc.protocol + "//" + uri;
	        } else {
	          uri = "https://" + uri;
	        }
	      } // parse
	
	
	      obj = parse(uri);
	    } // make sure we treat `localhost:80` and `localhost` equally
	
	
	    if (!obj.port) {
	      if (/^(http|ws)$/.test(obj.protocol)) {
	        obj.port = "80";
	      } else if (/^(http|ws)s$/.test(obj.protocol)) {
	        obj.port = "443";
	      }
	    }
	
	    obj.path = obj.path || "/";
	    var ipv6 = obj.host.indexOf(":") !== -1;
	    var host = ipv6 ? "[" + obj.host + "]" : obj.host; // define unique id
	
	    obj.id = obj.protocol + "://" + host + ":" + obj.port + path; // define href
	
	    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
	    return obj;
	  }
	
	  var withNativeArrayBuffer = typeof ArrayBuffer === "function";
	
	  var isView = function isView(obj) {
	    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
	  };
	
	  var toString = Object.prototype.toString;
	  var withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && toString.call(Blob) === "[object BlobConstructor]";
	  var withNativeFile = typeof File === "function" || typeof File !== "undefined" && toString.call(File) === "[object FileConstructor]";
	  /**
	   * Returns true if obj is a Buffer, an ArrayBuffer, a Blob or a File.
	   *
	   * @private
	   */
	
	  function isBinary(obj) {
	    return withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj)) || withNativeBlob && obj instanceof Blob || withNativeFile && obj instanceof File;
	  }
	  function hasBinary(obj, toJSON) {
	    if (!obj || _typeof(obj) !== "object") {
	      return false;
	    }
	
	    if (Array.isArray(obj)) {
	      for (var i = 0, l = obj.length; i < l; i++) {
	        if (hasBinary(obj[i])) {
	          return true;
	        }
	      }
	
	      return false;
	    }
	
	    if (isBinary(obj)) {
	      return true;
	    }
	
	    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) {
	      return hasBinary(obj.toJSON(), true);
	    }
	
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  /**
	   * Replaces every Buffer | ArrayBuffer | Blob | File in packet with a numbered placeholder.
	   *
	   * @param {Object} packet - socket.io event packet
	   * @return {Object} with deconstructed packet and list of buffers
	   * @public
	   */
	
	  function deconstructPacket(packet) {
	    var buffers = [];
	    var packetData = packet.data;
	    var pack = packet;
	    pack.data = _deconstructPacket(packetData, buffers);
	    pack.attachments = buffers.length; // number of binary 'attachments'
	
	    return {
	      packet: pack,
	      buffers: buffers
	    };
	  }
	
	  function _deconstructPacket(data, buffers) {
	    if (!data) return data;
	
	    if (isBinary(data)) {
	      var placeholder = {
	        _placeholder: true,
	        num: buffers.length
	      };
	      buffers.push(data);
	      return placeholder;
	    } else if (Array.isArray(data)) {
	      var newData = new Array(data.length);
	
	      for (var i = 0; i < data.length; i++) {
	        newData[i] = _deconstructPacket(data[i], buffers);
	      }
	
	      return newData;
	    } else if (_typeof(data) === "object" && !(data instanceof Date)) {
	      var _newData = {};
	
	      for (var key in data) {
	        if (Object.prototype.hasOwnProperty.call(data, key)) {
	          _newData[key] = _deconstructPacket(data[key], buffers);
	        }
	      }
	
	      return _newData;
	    }
	
	    return data;
	  }
	  /**
	   * Reconstructs a binary packet from its placeholder packet and buffers
	   *
	   * @param {Object} packet - event packet with placeholders
	   * @param {Array} buffers - binary buffers to put in placeholder positions
	   * @return {Object} reconstructed packet
	   * @public
	   */
	
	
	  function reconstructPacket(packet, buffers) {
	    packet.data = _reconstructPacket(packet.data, buffers);
	    packet.attachments = undefined; // no longer useful
	
	    return packet;
	  }
	
	  function _reconstructPacket(data, buffers) {
	    if (!data) return data;
	
	    if (data && data._placeholder) {
	      return buffers[data.num]; // appropriate buffer (should be natural order anyway)
	    } else if (Array.isArray(data)) {
	      for (var i = 0; i < data.length; i++) {
	        data[i] = _reconstructPacket(data[i], buffers);
	      }
	    } else if (_typeof(data) === "object") {
	      for (var key in data) {
	        if (Object.prototype.hasOwnProperty.call(data, key)) {
	          data[key] = _reconstructPacket(data[key], buffers);
	        }
	      }
	    }
	
	    return data;
	  }
	
	  /**
	   * Protocol version.
	   *
	   * @public
	   */
	
	  var protocol = 5;
	  var PacketType;
	
	  (function (PacketType) {
	    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
	    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
	    PacketType[PacketType["EVENT"] = 2] = "EVENT";
	    PacketType[PacketType["ACK"] = 3] = "ACK";
	    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
	    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
	    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
	  })(PacketType || (PacketType = {}));
	  /**
	   * A socket.io Encoder instance
	   */
	
	
	  var Encoder = /*#__PURE__*/function () {
	    /**
	     * Encoder constructor
	     *
	     * @param {function} replacer - custom replacer to pass down to JSON.parse
	     */
	    function Encoder(replacer) {
	      _classCallCheck(this, Encoder);
	
	      this.replacer = replacer;
	    }
	    /**
	     * Encode a packet as a single string if non-binary, or as a
	     * buffer sequence, depending on packet type.
	     *
	     * @param {Object} obj - packet object
	     */
	
	
	    _createClass(Encoder, [{
	      key: "encode",
	      value: function encode(obj) {
	        if (obj.type === PacketType.EVENT || obj.type === PacketType.ACK) {
	          if (hasBinary(obj)) {
	            obj.type = obj.type === PacketType.EVENT ? PacketType.BINARY_EVENT : PacketType.BINARY_ACK;
	            return this.encodeAsBinary(obj);
	          }
	        }
	
	        return [this.encodeAsString(obj)];
	      }
	      /**
	       * Encode packet as string.
	       */
	
	    }, {
	      key: "encodeAsString",
	      value: function encodeAsString(obj) {
	        // first is type
	        var str = "" + obj.type; // attachments if we have them
	
	        if (obj.type === PacketType.BINARY_EVENT || obj.type === PacketType.BINARY_ACK) {
	          str += obj.attachments + "-";
	        } // if we have a namespace other than `/`
	        // we append it followed by a comma `,`
	
	
	        if (obj.nsp && "/" !== obj.nsp) {
	          str += obj.nsp + ",";
	        } // immediately followed by the id
	
	
	        if (null != obj.id) {
	          str += obj.id;
	        } // json data
	
	
	        if (null != obj.data) {
	          str += JSON.stringify(obj.data, this.replacer);
	        }
	
	        return str;
	      }
	      /**
	       * Encode packet as 'buffer sequence' by removing blobs, and
	       * deconstructing packet into object with placeholders and
	       * a list of buffers.
	       */
	
	    }, {
	      key: "encodeAsBinary",
	      value: function encodeAsBinary(obj) {
	        var deconstruction = deconstructPacket(obj);
	        var pack = this.encodeAsString(deconstruction.packet);
	        var buffers = deconstruction.buffers;
	        buffers.unshift(pack); // add packet info to beginning of data list
	
	        return buffers; // write all the buffers
	      }
	    }]);
	
	    return Encoder;
	  }();
	  /**
	   * A socket.io Decoder instance
	   *
	   * @return {Object} decoder
	   */
	
	  var Decoder = /*#__PURE__*/function (_Emitter) {
	    _inherits(Decoder, _Emitter);
	
	    var _super = _createSuper(Decoder);
	
	    /**
	     * Decoder constructor
	     *
	     * @param {function} reviver - custom reviver to pass down to JSON.stringify
	     */
	    function Decoder(reviver) {
	      var _this;
	
	      _classCallCheck(this, Decoder);
	
	      _this = _super.call(this);
	      _this.reviver = reviver;
	      return _this;
	    }
	    /**
	     * Decodes an encoded packet string into packet JSON.
	     *
	     * @param {String} obj - encoded packet
	     */
	
	
	    _createClass(Decoder, [{
	      key: "add",
	      value: function add(obj) {
	        var packet;
	
	        if (typeof obj === "string") {
	          packet = this.decodeString(obj);
	
	          if (packet.type === PacketType.BINARY_EVENT || packet.type === PacketType.BINARY_ACK) {
	            // binary packet's json
	            this.reconstructor = new BinaryReconstructor(packet); // no attachments, labeled binary but no binary data to follow
	
	            if (packet.attachments === 0) {
	              _get(_getPrototypeOf(Decoder.prototype), "emitReserved", this).call(this, "decoded", packet);
	            }
	          } else {
	            // non-binary full packet
	            _get(_getPrototypeOf(Decoder.prototype), "emitReserved", this).call(this, "decoded", packet);
	          }
	        } else if (isBinary(obj) || obj.base64) {
	          // raw binary data
	          if (!this.reconstructor) {
	            throw new Error("got binary data when not reconstructing a packet");
	          } else {
	            packet = this.reconstructor.takeBinaryData(obj);
	
	            if (packet) {
	              // received final buffer
	              this.reconstructor = null;
	
	              _get(_getPrototypeOf(Decoder.prototype), "emitReserved", this).call(this, "decoded", packet);
	            }
	          }
	        } else {
	          throw new Error("Unknown type: " + obj);
	        }
	      }
	      /**
	       * Decode a packet String (JSON data)
	       *
	       * @param {String} str
	       * @return {Object} packet
	       */
	
	    }, {
	      key: "decodeString",
	      value: function decodeString(str) {
	        var i = 0; // look up type
	
	        var p = {
	          type: Number(str.charAt(0))
	        };
	
	        if (PacketType[p.type] === undefined) {
	          throw new Error("unknown packet type " + p.type);
	        } // look up attachments if type binary
	
	
	        if (p.type === PacketType.BINARY_EVENT || p.type === PacketType.BINARY_ACK) {
	          var start = i + 1;
	
	          while (str.charAt(++i) !== "-" && i != str.length) {}
	
	          var buf = str.substring(start, i);
	
	          if (buf != Number(buf) || str.charAt(i) !== "-") {
	            throw new Error("Illegal attachments");
	          }
	
	          p.attachments = Number(buf);
	        } // look up namespace (if any)
	
	
	        if ("/" === str.charAt(i + 1)) {
	          var _start = i + 1;
	
	          while (++i) {
	            var c = str.charAt(i);
	            if ("," === c) break;
	            if (i === str.length) break;
	          }
	
	          p.nsp = str.substring(_start, i);
	        } else {
	          p.nsp = "/";
	        } // look up id
	
	
	        var next = str.charAt(i + 1);
	
	        if ("" !== next && Number(next) == next) {
	          var _start2 = i + 1;
	
	          while (++i) {
	            var _c = str.charAt(i);
	
	            if (null == _c || Number(_c) != _c) {
	              --i;
	              break;
	            }
	
	            if (i === str.length) break;
	          }
	
	          p.id = Number(str.substring(_start2, i + 1));
	        } // look up json data
	
	
	        if (str.charAt(++i)) {
	          var payload = this.tryParse(str.substr(i));
	
	          if (Decoder.isPayloadValid(p.type, payload)) {
	            p.data = payload;
	          } else {
	            throw new Error("invalid payload");
	          }
	        }
	
	        return p;
	      }
	    }, {
	      key: "tryParse",
	      value: function tryParse(str) {
	        try {
	          return JSON.parse(str, this.reviver);
	        } catch (e) {
	          return false;
	        }
	      }
	    }, {
	      key: "destroy",
	      value:
	      /**
	       * Deallocates a parser's resources
	       */
	      function destroy() {
	        if (this.reconstructor) {
	          this.reconstructor.finishedReconstruction();
	        }
	      }
	    }], [{
	      key: "isPayloadValid",
	      value: function isPayloadValid(type, payload) {
	        switch (type) {
	          case PacketType.CONNECT:
	            return _typeof(payload) === "object";
	
	          case PacketType.DISCONNECT:
	            return payload === undefined;
	
	          case PacketType.CONNECT_ERROR:
	            return typeof payload === "string" || _typeof(payload) === "object";
	
	          case PacketType.EVENT:
	          case PacketType.BINARY_EVENT:
	            return Array.isArray(payload) && payload.length > 0;
	
	          case PacketType.ACK:
	          case PacketType.BINARY_ACK:
	            return Array.isArray(payload);
	        }
	      }
	    }]);
	
	    return Decoder;
	  }(Emitter);
	  /**
	   * A manager of a binary event's 'buffer sequence'. Should
	   * be constructed whenever a packet of type BINARY_EVENT is
	   * decoded.
	   *
	   * @param {Object} packet
	   * @return {BinaryReconstructor} initialized reconstructor
	   */
	
	  var BinaryReconstructor = /*#__PURE__*/function () {
	    function BinaryReconstructor(packet) {
	      _classCallCheck(this, BinaryReconstructor);
	
	      this.packet = packet;
	      this.buffers = [];
	      this.reconPack = packet;
	    }
	    /**
	     * Method to be called when binary data received from connection
	     * after a BINARY_EVENT packet.
	     *
	     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
	     * @return {null | Object} returns null if more binary data is expected or
	     *   a reconstructed packet object if all buffers have been received.
	     */
	
	
	    _createClass(BinaryReconstructor, [{
	      key: "takeBinaryData",
	      value: function takeBinaryData(binData) {
	        this.buffers.push(binData);
	
	        if (this.buffers.length === this.reconPack.attachments) {
	          // done with buffer list
	          var packet = reconstructPacket(this.reconPack, this.buffers);
	          this.finishedReconstruction();
	          return packet;
	        }
	
	        return null;
	      }
	      /**
	       * Cleans up binary packet reconstruction variables.
	       */
	
	    }, {
	      key: "finishedReconstruction",
	      value: function finishedReconstruction() {
	        this.reconPack = null;
	        this.buffers = [];
	      }
	    }]);
	
	    return BinaryReconstructor;
	  }();
	
	  var parser = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    protocol: protocol,
	    get PacketType () { return PacketType; },
	    Encoder: Encoder,
	    Decoder: Decoder
	  });
	
	  function on(obj, ev, fn) {
	    obj.on(ev, fn);
	    return function subDestroy() {
	      obj.off(ev, fn);
	    };
	  }
	
	  /**
	   * Internal events.
	   * These events can't be emitted by the user.
	   */
	
	  var RESERVED_EVENTS = Object.freeze({
	    connect: 1,
	    connect_error: 1,
	    disconnect: 1,
	    disconnecting: 1,
	    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
	    newListener: 1,
	    removeListener: 1
	  });
	  var Socket = /*#__PURE__*/function (_Emitter) {
	    _inherits(Socket, _Emitter);
	
	    var _super = _createSuper(Socket);
	
	    /**
	     * `Socket` constructor.
	     *
	     * @public
	     */
	    function Socket(io, nsp, opts) {
	      var _this;
	
	      _classCallCheck(this, Socket);
	
	      _this = _super.call(this);
	      _this.connected = false;
	      _this.receiveBuffer = [];
	      _this.sendBuffer = [];
	      _this.ids = 0;
	      _this.acks = {};
	      _this.flags = {};
	      _this.io = io;
	      _this.nsp = nsp;
	
	      if (opts && opts.auth) {
	        _this.auth = opts.auth;
	      }
	
	      if (_this.io._autoConnect) _this.open();
	      return _this;
	    }
	    /**
	     * Whether the socket is currently disconnected
	     */
	
	
	    _createClass(Socket, [{
	      key: "disconnected",
	      get: function get() {
	        return !this.connected;
	      }
	      /**
	       * Subscribe to open, close and packet events
	       *
	       * @private
	       */
	
	    }, {
	      key: "subEvents",
	      value: function subEvents() {
	        if (this.subs) return;
	        var io = this.io;
	        this.subs = [on(io, "open", this.onopen.bind(this)), on(io, "packet", this.onpacket.bind(this)), on(io, "error", this.onerror.bind(this)), on(io, "close", this.onclose.bind(this))];
	      }
	      /**
	       * Whether the Socket will try to reconnect when its Manager connects or reconnects
	       */
	
	    }, {
	      key: "active",
	      get: function get() {
	        return !!this.subs;
	      }
	      /**
	       * "Opens" the socket.
	       *
	       * @public
	       */
	
	    }, {
	      key: "connect",
	      value: function connect() {
	        if (this.connected) return this;
	        this.subEvents();
	        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
	
	        if ("open" === this.io._readyState) this.onopen();
	        return this;
	      }
	      /**
	       * Alias for connect()
	       */
	
	    }, {
	      key: "open",
	      value: function open() {
	        return this.connect();
	      }
	      /**
	       * Sends a `message` event.
	       *
	       * @return self
	       * @public
	       */
	
	    }, {
	      key: "send",
	      value: function send() {
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        args.unshift("message");
	        this.emit.apply(this, args);
	        return this;
	      }
	      /**
	       * Override `emit`.
	       * If the event is in `events`, it's emitted normally.
	       *
	       * @return self
	       * @public
	       */
	
	    }, {
	      key: "emit",
	      value: function emit(ev) {
	        if (RESERVED_EVENTS.hasOwnProperty(ev)) {
	          throw new Error('"' + ev.toString() + '" is a reserved event name');
	        }
	
	        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	          args[_key2 - 1] = arguments[_key2];
	        }
	
	        args.unshift(ev);
	        var packet = {
	          type: PacketType.EVENT,
	          data: args
	        };
	        packet.options = {};
	        packet.options.compress = this.flags.compress !== false; // event ack callback
	
	        if ("function" === typeof args[args.length - 1]) {
	          var id = this.ids++;
	          var ack = args.pop();
	
	          this._registerAckCallback(id, ack);
	
	          packet.id = id;
	        }
	
	        var isTransportWritable = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
	        var discardPacket = this.flags["volatile"] && (!isTransportWritable || !this.connected);
	
	        if (discardPacket) ; else if (this.connected) {
	          this.notifyOutgoingListeners(packet);
	          this.packet(packet);
	        } else {
	          this.sendBuffer.push(packet);
	        }
	
	        this.flags = {};
	        return this;
	      }
	      /**
	       * @private
	       */
	
	    }, {
	      key: "_registerAckCallback",
	      value: function _registerAckCallback(id, ack) {
	        var _this2 = this;
	
	        var timeout = this.flags.timeout;
	
	        if (timeout === undefined) {
	          this.acks[id] = ack;
	          return;
	        } // @ts-ignore
	
	
	        var timer = this.io.setTimeoutFn(function () {
	          delete _this2.acks[id];
	
	          for (var i = 0; i < _this2.sendBuffer.length; i++) {
	            if (_this2.sendBuffer[i].id === id) {
	              _this2.sendBuffer.splice(i, 1);
	            }
	          }
	
	          ack.call(_this2, new Error("operation has timed out"));
	        }, timeout);
	
	        this.acks[id] = function () {
	          // @ts-ignore
	          _this2.io.clearTimeoutFn(timer);
	
	          for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	            args[_key3] = arguments[_key3];
	          }
	
	          ack.apply(_this2, [null].concat(args));
	        };
	      }
	      /**
	       * Sends a packet.
	       *
	       * @param packet
	       * @private
	       */
	
	    }, {
	      key: "packet",
	      value: function packet(_packet) {
	        _packet.nsp = this.nsp;
	
	        this.io._packet(_packet);
	      }
	      /**
	       * Called upon engine `open`.
	       *
	       * @private
	       */
	
	    }, {
	      key: "onopen",
	      value: function onopen() {
	        var _this3 = this;
	
	        if (typeof this.auth == "function") {
	          this.auth(function (data) {
	            _this3.packet({
	              type: PacketType.CONNECT,
	              data: data
	            });
	          });
	        } else {
	          this.packet({
	            type: PacketType.CONNECT,
	            data: this.auth
	          });
	        }
	      }
	      /**
	       * Called upon engine or manager `error`.
	       *
	       * @param err
	       * @private
	       */
	
	    }, {
	      key: "onerror",
	      value: function onerror(err) {
	        if (!this.connected) {
	          this.emitReserved("connect_error", err);
	        }
	      }
	      /**
	       * Called upon engine `close`.
	       *
	       * @param reason
	       * @param description
	       * @private
	       */
	
	    }, {
	      key: "onclose",
	      value: function onclose(reason, description) {
	        this.connected = false;
	        delete this.id;
	        this.emitReserved("disconnect", reason, description);
	      }
	      /**
	       * Called with socket packet.
	       *
	       * @param packet
	       * @private
	       */
	
	    }, {
	      key: "onpacket",
	      value: function onpacket(packet) {
	        var sameNamespace = packet.nsp === this.nsp;
	        if (!sameNamespace) return;
	
	        switch (packet.type) {
	          case PacketType.CONNECT:
	            if (packet.data && packet.data.sid) {
	              var id = packet.data.sid;
	              this.onconnect(id);
	            } else {
	              this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
	            }
	
	            break;
	
	          case PacketType.EVENT:
	          case PacketType.BINARY_EVENT:
	            this.onevent(packet);
	            break;
	
	          case PacketType.ACK:
	          case PacketType.BINARY_ACK:
	            this.onack(packet);
	            break;
	
	          case PacketType.DISCONNECT:
	            this.ondisconnect();
	            break;
	
	          case PacketType.CONNECT_ERROR:
	            this.destroy();
	            var err = new Error(packet.data.message); // @ts-ignore
	
	            err.data = packet.data.data;
	            this.emitReserved("connect_error", err);
	            break;
	        }
	      }
	      /**
	       * Called upon a server event.
	       *
	       * @param packet
	       * @private
	       */
	
	    }, {
	      key: "onevent",
	      value: function onevent(packet) {
	        var args = packet.data || [];
	
	        if (null != packet.id) {
	          args.push(this.ack(packet.id));
	        }
	
	        if (this.connected) {
	          this.emitEvent(args);
	        } else {
	          this.receiveBuffer.push(Object.freeze(args));
	        }
	      }
	    }, {
	      key: "emitEvent",
	      value: function emitEvent(args) {
	        if (this._anyListeners && this._anyListeners.length) {
	          var listeners = this._anyListeners.slice();
	
	          var _iterator = _createForOfIteratorHelper(listeners),
	              _step;
	
	          try {
	            for (_iterator.s(); !(_step = _iterator.n()).done;) {
	              var listener = _step.value;
	              listener.apply(this, args);
	            }
	          } catch (err) {
	            _iterator.e(err);
	          } finally {
	            _iterator.f();
	          }
	        }
	
	        _get(_getPrototypeOf(Socket.prototype), "emit", this).apply(this, args);
	      }
	      /**
	       * Produces an ack callback to emit with an event.
	       *
	       * @private
	       */
	
	    }, {
	      key: "ack",
	      value: function ack(id) {
	        var self = this;
	        var sent = false;
	        return function () {
	          // prevent double callbacks
	          if (sent) return;
	          sent = true;
	
	          for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	            args[_key4] = arguments[_key4];
	          }
	
	          self.packet({
	            type: PacketType.ACK,
	            id: id,
	            data: args
	          });
	        };
	      }
	      /**
	       * Called upon a server acknowlegement.
	       *
	       * @param packet
	       * @private
	       */
	
	    }, {
	      key: "onack",
	      value: function onack(packet) {
	        var ack = this.acks[packet.id];
	
	        if ("function" === typeof ack) {
	          ack.apply(this, packet.data);
	          delete this.acks[packet.id];
	        }
	      }
	      /**
	       * Called upon server connect.
	       *
	       * @private
	       */
	
	    }, {
	      key: "onconnect",
	      value: function onconnect(id) {
	        this.id = id;
	        this.connected = true;
	        this.emitBuffered();
	        this.emitReserved("connect");
	      }
	      /**
	       * Emit buffered events (received and emitted).
	       *
	       * @private
	       */
	
	    }, {
	      key: "emitBuffered",
	      value: function emitBuffered() {
	        var _this4 = this;
	
	        this.receiveBuffer.forEach(function (args) {
	          return _this4.emitEvent(args);
	        });
	        this.receiveBuffer = [];
	        this.sendBuffer.forEach(function (packet) {
	          _this4.notifyOutgoingListeners(packet);
	
	          _this4.packet(packet);
	        });
	        this.sendBuffer = [];
	      }
	      /**
	       * Called upon server disconnect.
	       *
	       * @private
	       */
	
	    }, {
	      key: "ondisconnect",
	      value: function ondisconnect() {
	        this.destroy();
	        this.onclose("io server disconnect");
	      }
	      /**
	       * Called upon forced client/server side disconnections,
	       * this method ensures the manager stops tracking us and
	       * that reconnections don't get triggered for this.
	       *
	       * @private
	       */
	
	    }, {
	      key: "destroy",
	      value: function destroy() {
	        if (this.subs) {
	          // clean subscriptions to avoid reconnections
	          this.subs.forEach(function (subDestroy) {
	            return subDestroy();
	          });
	          this.subs = undefined;
	        }
	
	        this.io["_destroy"](this);
	      }
	      /**
	       * Disconnects the socket manually.
	       *
	       * @return self
	       * @public
	       */
	
	    }, {
	      key: "disconnect",
	      value: function disconnect() {
	        if (this.connected) {
	          this.packet({
	            type: PacketType.DISCONNECT
	          });
	        } // remove socket from pool
	
	
	        this.destroy();
	
	        if (this.connected) {
	          // fire events
	          this.onclose("io client disconnect");
	        }
	
	        return this;
	      }
	      /**
	       * Alias for disconnect()
	       *
	       * @return self
	       * @public
	       */
	
	    }, {
	      key: "close",
	      value: function close() {
	        return this.disconnect();
	      }
	      /**
	       * Sets the compress flag.
	       *
	       * @param compress - if `true`, compresses the sending data
	       * @return self
	       * @public
	       */
	
	    }, {
	      key: "compress",
	      value: function compress(_compress) {
	        this.flags.compress = _compress;
	        return this;
	      }
	      /**
	       * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
	       * ready to send messages.
	       *
	       * @returns self
	       * @public
	       */
	
	    }, {
	      key: "volatile",
	      get: function get() {
	        this.flags["volatile"] = true;
	        return this;
	      }
	      /**
	       * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
	       * given number of milliseconds have elapsed without an acknowledgement from the server:
	       *
	       * ```
	       * socket.timeout(5000).emit("my-event", (err) => {
	       *   if (err) {
	       *     // the server did not acknowledge the event in the given delay
	       *   }
	       * });
	       * ```
	       *
	       * @returns self
	       * @public
	       */
	
	    }, {
	      key: "timeout",
	      value: function timeout(_timeout) {
	        this.flags.timeout = _timeout;
	        return this;
	      }
	      /**
	       * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
	       * callback.
	       *
	       * @param listener
	       * @public
	       */
	
	    }, {
	      key: "onAny",
	      value: function onAny(listener) {
	        this._anyListeners = this._anyListeners || [];
	
	        this._anyListeners.push(listener);
	
	        return this;
	      }
	      /**
	       * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
	       * callback. The listener is added to the beginning of the listeners array.
	       *
	       * @param listener
	       * @public
	       */
	
	    }, {
	      key: "prependAny",
	      value: function prependAny(listener) {
	        this._anyListeners = this._anyListeners || [];
	
	        this._anyListeners.unshift(listener);
	
	        return this;
	      }
	      /**
	       * Removes the listener that will be fired when any event is emitted.
	       *
	       * @param listener
	       * @public
	       */
	
	    }, {
	      key: "offAny",
	      value: function offAny(listener) {
	        if (!this._anyListeners) {
	          return this;
	        }
	
	        if (listener) {
	          var listeners = this._anyListeners;
	
	          for (var i = 0; i < listeners.length; i++) {
	            if (listener === listeners[i]) {
	              listeners.splice(i, 1);
	              return this;
	            }
	          }
	        } else {
	          this._anyListeners = [];
	        }
	
	        return this;
	      }
	      /**
	       * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
	       * e.g. to remove listeners.
	       *
	       * @public
	       */
	
	    }, {
	      key: "listenersAny",
	      value: function listenersAny() {
	        return this._anyListeners || [];
	      }
	      /**
	       * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
	       * callback.
	       *
	       * @param listener
	       *
	       * <pre><code>
	       *
	       * socket.onAnyOutgoing((event, ...args) => {
	       *   console.log(event);
	       * });
	       *
	       * </pre></code>
	       *
	       * @public
	       */
	
	    }, {
	      key: "onAnyOutgoing",
	      value: function onAnyOutgoing(listener) {
	        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
	
	        this._anyOutgoingListeners.push(listener);
	
	        return this;
	      }
	      /**
	       * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
	       * callback. The listener is added to the beginning of the listeners array.
	       *
	       * @param listener
	       *
	       * <pre><code>
	       *
	       * socket.prependAnyOutgoing((event, ...args) => {
	       *   console.log(event);
	       * });
	       *
	       * </pre></code>
	       *
	       * @public
	       */
	
	    }, {
	      key: "prependAnyOutgoing",
	      value: function prependAnyOutgoing(listener) {
	        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
	
	        this._anyOutgoingListeners.unshift(listener);
	
	        return this;
	      }
	      /**
	       * Removes the listener that will be fired when any event is emitted.
	       *
	       * @param listener
	       *
	       * <pre><code>
	       *
	       * const handler = (event, ...args) => {
	       *   console.log(event);
	       * }
	       *
	       * socket.onAnyOutgoing(handler);
	       *
	       * // then later
	       * socket.offAnyOutgoing(handler);
	       *
	       * </pre></code>
	       *
	       * @public
	       */
	
	    }, {
	      key: "offAnyOutgoing",
	      value: function offAnyOutgoing(listener) {
	        if (!this._anyOutgoingListeners) {
	          return this;
	        }
	
	        if (listener) {
	          var listeners = this._anyOutgoingListeners;
	
	          for (var i = 0; i < listeners.length; i++) {
	            if (listener === listeners[i]) {
	              listeners.splice(i, 1);
	              return this;
	            }
	          }
	        } else {
	          this._anyOutgoingListeners = [];
	        }
	
	        return this;
	      }
	      /**
	       * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
	       * e.g. to remove listeners.
	       *
	       * @public
	       */
	
	    }, {
	      key: "listenersAnyOutgoing",
	      value: function listenersAnyOutgoing() {
	        return this._anyOutgoingListeners || [];
	      }
	      /**
	       * Notify the listeners for each packet sent
	       *
	       * @param packet
	       *
	       * @private
	       */
	
	    }, {
	      key: "notifyOutgoingListeners",
	      value: function notifyOutgoingListeners(packet) {
	        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
	          var listeners = this._anyOutgoingListeners.slice();
	
	          var _iterator2 = _createForOfIteratorHelper(listeners),
	              _step2;
	
	          try {
	            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
	              var listener = _step2.value;
	              listener.apply(this, packet.data);
	            }
	          } catch (err) {
	            _iterator2.e(err);
	          } finally {
	            _iterator2.f();
	          }
	        }
	      }
	    }]);
	
	    return Socket;
	  }(Emitter);
	
	  /**
	   * Initialize backoff timer with `opts`.
	   *
	   * - `min` initial timeout in milliseconds [100]
	   * - `max` max timeout [10000]
	   * - `jitter` [0]
	   * - `factor` [2]
	   *
	   * @param {Object} opts
	   * @api public
	   */
	  function Backoff(opts) {
	    opts = opts || {};
	    this.ms = opts.min || 100;
	    this.max = opts.max || 10000;
	    this.factor = opts.factor || 2;
	    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
	    this.attempts = 0;
	  }
	  /**
	   * Return the backoff duration.
	   *
	   * @return {Number}
	   * @api public
	   */
	
	  Backoff.prototype.duration = function () {
	    var ms = this.ms * Math.pow(this.factor, this.attempts++);
	
	    if (this.jitter) {
	      var rand = Math.random();
	      var deviation = Math.floor(rand * this.jitter * ms);
	      ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
	    }
	
	    return Math.min(ms, this.max) | 0;
	  };
	  /**
	   * Reset the number of attempts.
	   *
	   * @api public
	   */
	
	
	  Backoff.prototype.reset = function () {
	    this.attempts = 0;
	  };
	  /**
	   * Set the minimum duration
	   *
	   * @api public
	   */
	
	
	  Backoff.prototype.setMin = function (min) {
	    this.ms = min;
	  };
	  /**
	   * Set the maximum duration
	   *
	   * @api public
	   */
	
	
	  Backoff.prototype.setMax = function (max) {
	    this.max = max;
	  };
	  /**
	   * Set the jitter
	   *
	   * @api public
	   */
	
	
	  Backoff.prototype.setJitter = function (jitter) {
	    this.jitter = jitter;
	  };
	
	  var Manager = /*#__PURE__*/function (_Emitter) {
	    _inherits(Manager, _Emitter);
	
	    var _super = _createSuper(Manager);
	
	    function Manager(uri, opts) {
	      var _this;
	
	      _classCallCheck(this, Manager);
	
	      var _a;
	
	      _this = _super.call(this);
	      _this.nsps = {};
	      _this.subs = [];
	
	      if (uri && "object" === _typeof(uri)) {
	        opts = uri;
	        uri = undefined;
	      }
	
	      opts = opts || {};
	      opts.path = opts.path || "/socket.io";
	      _this.opts = opts;
	      installTimerFunctions(_assertThisInitialized(_this), opts);
	
	      _this.reconnection(opts.reconnection !== false);
	
	      _this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
	
	      _this.reconnectionDelay(opts.reconnectionDelay || 1000);
	
	      _this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
	
	      _this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
	
	      _this.backoff = new Backoff({
	        min: _this.reconnectionDelay(),
	        max: _this.reconnectionDelayMax(),
	        jitter: _this.randomizationFactor()
	      });
	
	      _this.timeout(null == opts.timeout ? 20000 : opts.timeout);
	
	      _this._readyState = "closed";
	      _this.uri = uri;
	
	      var _parser = opts.parser || parser;
	
	      _this.encoder = new _parser.Encoder();
	      _this.decoder = new _parser.Decoder();
	      _this._autoConnect = opts.autoConnect !== false;
	      if (_this._autoConnect) _this.open();
	      return _this;
	    }
	
	    _createClass(Manager, [{
	      key: "reconnection",
	      value: function reconnection(v) {
	        if (!arguments.length) return this._reconnection;
	        this._reconnection = !!v;
	        return this;
	      }
	    }, {
	      key: "reconnectionAttempts",
	      value: function reconnectionAttempts(v) {
	        if (v === undefined) return this._reconnectionAttempts;
	        this._reconnectionAttempts = v;
	        return this;
	      }
	    }, {
	      key: "reconnectionDelay",
	      value: function reconnectionDelay(v) {
	        var _a;
	
	        if (v === undefined) return this._reconnectionDelay;
	        this._reconnectionDelay = v;
	        (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setMin(v);
	        return this;
	      }
	    }, {
	      key: "randomizationFactor",
	      value: function randomizationFactor(v) {
	        var _a;
	
	        if (v === undefined) return this._randomizationFactor;
	        this._randomizationFactor = v;
	        (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setJitter(v);
	        return this;
	      }
	    }, {
	      key: "reconnectionDelayMax",
	      value: function reconnectionDelayMax(v) {
	        var _a;
	
	        if (v === undefined) return this._reconnectionDelayMax;
	        this._reconnectionDelayMax = v;
	        (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setMax(v);
	        return this;
	      }
	    }, {
	      key: "timeout",
	      value: function timeout(v) {
	        if (!arguments.length) return this._timeout;
	        this._timeout = v;
	        return this;
	      }
	      /**
	       * Starts trying to reconnect if reconnection is enabled and we have not
	       * started reconnecting yet
	       *
	       * @private
	       */
	
	    }, {
	      key: "maybeReconnectOnOpen",
	      value: function maybeReconnectOnOpen() {
	        // Only try to reconnect if it's the first time we're connecting
	        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) {
	          // keeps reconnection from firing twice for the same reconnection loop
	          this.reconnect();
	        }
	      }
	      /**
	       * Sets the current transport `socket`.
	       *
	       * @param {Function} fn - optional, callback
	       * @return self
	       * @public
	       */
	
	    }, {
	      key: "open",
	      value: function open(fn) {
	        var _this2 = this;
	
	        if (~this._readyState.indexOf("open")) return this;
	        this.engine = new Socket$1(this.uri, this.opts);
	        var socket = this.engine;
	        var self = this;
	        this._readyState = "opening";
	        this.skipReconnect = false; // emit `open`
	
	        var openSubDestroy = on(socket, "open", function () {
	          self.onopen();
	          fn && fn();
	        }); // emit `error`
	
	        var errorSub = on(socket, "error", function (err) {
	          self.cleanup();
	          self._readyState = "closed";
	
	          _this2.emitReserved("error", err);
	
	          if (fn) {
	            fn(err);
	          } else {
	            // Only do this if there is no fn to handle the error
	            self.maybeReconnectOnOpen();
	          }
	        });
	
	        if (false !== this._timeout) {
	          var timeout = this._timeout;
	
	          if (timeout === 0) {
	            openSubDestroy(); // prevents a race condition with the 'open' event
	          } // set timer
	
	
	          var timer = this.setTimeoutFn(function () {
	            openSubDestroy();
	            socket.close(); // @ts-ignore
	
	            socket.emit("error", new Error("timeout"));
	          }, timeout);
	
	          if (this.opts.autoUnref) {
	            timer.unref();
	          }
	
	          this.subs.push(function subDestroy() {
	            clearTimeout(timer);
	          });
	        }
	
	        this.subs.push(openSubDestroy);
	        this.subs.push(errorSub);
	        return this;
	      }
	      /**
	       * Alias for open()
	       *
	       * @return self
	       * @public
	       */
	
	    }, {
	      key: "connect",
	      value: function connect(fn) {
	        return this.open(fn);
	      }
	      /**
	       * Called upon transport open.
	       *
	       * @private
	       */
	
	    }, {
	      key: "onopen",
	      value: function onopen() {
	        // clear old subs
	        this.cleanup(); // mark as open
	
	        this._readyState = "open";
	        this.emitReserved("open"); // add new subs
	
	        var socket = this.engine;
	        this.subs.push(on(socket, "ping", this.onping.bind(this)), on(socket, "data", this.ondata.bind(this)), on(socket, "error", this.onerror.bind(this)), on(socket, "close", this.onclose.bind(this)), on(this.decoder, "decoded", this.ondecoded.bind(this)));
	      }
	      /**
	       * Called upon a ping.
	       *
	       * @private
	       */
	
	    }, {
	      key: "onping",
	      value: function onping() {
	        this.emitReserved("ping");
	      }
	      /**
	       * Called with data.
	       *
	       * @private
	       */
	
	    }, {
	      key: "ondata",
	      value: function ondata(data) {
	        try {
	          this.decoder.add(data);
	        } catch (e) {
	          this.onclose("parse error");
	        }
	      }
	      /**
	       * Called when parser fully decodes a packet.
	       *
	       * @private
	       */
	
	    }, {
	      key: "ondecoded",
	      value: function ondecoded(packet) {
	        this.emitReserved("packet", packet);
	      }
	      /**
	       * Called upon socket error.
	       *
	       * @private
	       */
	
	    }, {
	      key: "onerror",
	      value: function onerror(err) {
	        this.emitReserved("error", err);
	      }
	      /**
	       * Creates a new socket for the given `nsp`.
	       *
	       * @return {Socket}
	       * @public
	       */
	
	    }, {
	      key: "socket",
	      value: function socket(nsp, opts) {
	        var socket = this.nsps[nsp];
	
	        if (!socket) {
	          socket = new Socket(this, nsp, opts);
	          this.nsps[nsp] = socket;
	        }
	
	        return socket;
	      }
	      /**
	       * Called upon a socket close.
	       *
	       * @param socket
	       * @private
	       */
	
	    }, {
	      key: "_destroy",
	      value: function _destroy(socket) {
	        var nsps = Object.keys(this.nsps);
	
	        for (var _i = 0, _nsps = nsps; _i < _nsps.length; _i++) {
	          var nsp = _nsps[_i];
	          var _socket = this.nsps[nsp];
	
	          if (_socket.active) {
	            return;
	          }
	        }
	
	        this._close();
	      }
	      /**
	       * Writes a packet.
	       *
	       * @param packet
	       * @private
	       */
	
	    }, {
	      key: "_packet",
	      value: function _packet(packet) {
	        var encodedPackets = this.encoder.encode(packet);
	
	        for (var i = 0; i < encodedPackets.length; i++) {
	          this.engine.write(encodedPackets[i], packet.options);
	        }
	      }
	      /**
	       * Clean up transport subscriptions and packet buffer.
	       *
	       * @private
	       */
	
	    }, {
	      key: "cleanup",
	      value: function cleanup() {
	        this.subs.forEach(function (subDestroy) {
	          return subDestroy();
	        });
	        this.subs.length = 0;
	        this.decoder.destroy();
	      }
	      /**
	       * Close the current socket.
	       *
	       * @private
	       */
	
	    }, {
	      key: "_close",
	      value: function _close() {
	        this.skipReconnect = true;
	        this._reconnecting = false;
	        this.onclose("forced close");
	        if (this.engine) this.engine.close();
	      }
	      /**
	       * Alias for close()
	       *
	       * @private
	       */
	
	    }, {
	      key: "disconnect",
	      value: function disconnect() {
	        return this._close();
	      }
	      /**
	       * Called upon engine close.
	       *
	       * @private
	       */
	
	    }, {
	      key: "onclose",
	      value: function onclose(reason, description) {
	        this.cleanup();
	        this.backoff.reset();
	        this._readyState = "closed";
	        this.emitReserved("close", reason, description);
	
	        if (this._reconnection && !this.skipReconnect) {
	          this.reconnect();
	        }
	      }
	      /**
	       * Attempt a reconnection.
	       *
	       * @private
	       */
	
	    }, {
	      key: "reconnect",
	      value: function reconnect() {
	        var _this3 = this;
	
	        if (this._reconnecting || this.skipReconnect) return this;
	        var self = this;
	
	        if (this.backoff.attempts >= this._reconnectionAttempts) {
	          this.backoff.reset();
	          this.emitReserved("reconnect_failed");
	          this._reconnecting = false;
	        } else {
	          var delay = this.backoff.duration();
	          this._reconnecting = true;
	          var timer = this.setTimeoutFn(function () {
	            if (self.skipReconnect) return;
	
	            _this3.emitReserved("reconnect_attempt", self.backoff.attempts); // check again for the case socket closed in above events
	
	
	            if (self.skipReconnect) return;
	            self.open(function (err) {
	              if (err) {
	                self._reconnecting = false;
	                self.reconnect();
	
	                _this3.emitReserved("reconnect_error", err);
	              } else {
	                self.onreconnect();
	              }
	            });
	          }, delay);
	
	          if (this.opts.autoUnref) {
	            timer.unref();
	          }
	
	          this.subs.push(function subDestroy() {
	            clearTimeout(timer);
	          });
	        }
	      }
	      /**
	       * Called upon successful reconnect.
	       *
	       * @private
	       */
	
	    }, {
	      key: "onreconnect",
	      value: function onreconnect() {
	        var attempt = this.backoff.attempts;
	        this._reconnecting = false;
	        this.backoff.reset();
	        this.emitReserved("reconnect", attempt);
	      }
	    }]);
	
	    return Manager;
	  }(Emitter);
	
	  /**
	   * Managers cache.
	   */
	
	  var cache = {};
	
	  function lookup(uri, opts) {
	    if (_typeof(uri) === "object") {
	      opts = uri;
	      uri = undefined;
	    }
	
	    opts = opts || {};
	    var parsed = url(uri, opts.path || "/socket.io");
	    var source = parsed.source;
	    var id = parsed.id;
	    var path = parsed.path;
	    var sameNamespace = cache[id] && path in cache[id]["nsps"];
	    var newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
	    var io;
	
	    if (newConnection) {
	      io = new Manager(source, opts);
	    } else {
	      if (!cache[id]) {
	        cache[id] = new Manager(source, opts);
	      }
	
	      io = cache[id];
	    }
	
	    if (parsed.query && !opts.query) {
	      opts.query = parsed.queryKey;
	    }
	
	    return io.socket(parsed.path, opts);
	  } // so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
	  // namespace (e.g. `io.connect(...)`), for backward compatibility
	
	
	  _extends(lookup, {
	    Manager: Manager,
	    Socket: Socket,
	    io: lookup,
	    connect: lookup
	  });
	
	  return lookup;
	
	}));
	//# sourceMappingURL=socket.io.js.map


/***/ }),
/* 474 */
/***/ (function(module, exports) {

	/*<![CDATA[*/window.olark||(function(c){var f=window,d=document,l=f.location.protocol=="https:"?"https:":"http:",z=c.name,r="load";var nt=function(){
	f[z]=function(){
	(a.s=a.s||[]).push(arguments)};var a=f[z]._={
	},q=c.methods.length;while(q--){(function(n){f[z][n]=function(){
	f[z]("call",n,arguments)}})(c.methods[q])}a.l=c.loader;a.i=nt;a.p={
	0:+new Date};a.P=function(u){
	a.p[u]=new Date-a.p[0]};function s(){
	a.P(r);f[z](r)}f.addEventListener?f.addEventListener(r,s,false):f.attachEvent("on"+r,s);var ld=function(){function p(hd){
	hd="head";return["<",hd,"></",hd,"><",i,' onl' + 'oad="var d=',g,";d.getElementsByTagName('head')[0].",j,"(d.",h,"('script')).",k,"='",l,"//",a.l,"'",'"',"></",i,">"].join("")}var i="body",m=d[i];if(!m){
	return setTimeout(ld,100)}a.P(1);var j="appendChild",h="createElement",k="src",n=d[h]("div"),v=n[j](d[h](z)),b=d[h]("iframe"),g="document",e="domain",o;n.style.display="none";m.insertBefore(n,m.firstChild).id=z;b.frameBorder="0";b.id=z+"-loader";if(/MSIE[ ]+6/.test(navigator.userAgent)){
	b.src="javascript:false"}b.allowTransparency="true";v[j](b);try{
	b.contentWindow[g].open()}catch(w){
	c[e]=d[e];o="javascript:var d="+g+".open();d.domain='"+d.domain+"';";b[k]=o+"void(0);"}try{
	var t=b.contentWindow[g];t.write(p());t.close()}catch(x){
	b[k]=o+'d.write("'+p().replace(/"/g,String.fromCharCode(92)+'"')+'");d.close();'}a.P(2)};ld()};nt()})({
	loader: "static.olark.com/jsclient/loader0.js",name:"olark",methods:["configure","extend","declare","identify"]});
	/* custom configuration goes here (www.olark.com/documentation) */
	olark.identify("5933-889-10-6764");/*]]>*/

/***/ }),
/* 475 */
/***/ (function(module, exports) {

	/*
	 AngularJS v1.7.9
	 (c) 2010-2018 Google, Inc. http://angularjs.org
	 License: MIT
	*/
	(function(Y,z){'use strict';function Fa(a,b,c){if(!a)throw Pa("areq",b||"?",c||"required");return a}function Ga(a,b){if(!a&&!b)return"";if(!a)return b;if(!b)return a;Z(a)&&(a=a.join(" "));Z(b)&&(b=b.join(" "));return a+" "+b}function Qa(a){var b={};a&&(a.to||a.from)&&(b.to=a.to,b.from=a.from);return b}function $(a,b,c){var d="";a=Z(a)?a:a&&G(a)&&a.length?a.split(/\s+/):[];s(a,function(a,k){a&&0<a.length&&(d+=0<k?" ":"",d+=c?b+a:a+b)});return d}function Ha(a){if(a instanceof A)switch(a.length){case 0:return a;
	case 1:if(1===a[0].nodeType)return a;break;default:return A(va(a))}if(1===a.nodeType)return A(a)}function va(a){if(!a[0])return a;for(var b=0;b<a.length;b++){var c=a[b];if(1===c.nodeType)return c}}function Ra(a,b,c){s(b,function(b){a.addClass(b,c)})}function Sa(a,b,c){s(b,function(b){a.removeClass(b,c)})}function aa(a){return function(b,c){c.addClass&&(Ra(a,b,c.addClass),c.addClass=null);c.removeClass&&(Sa(a,b,c.removeClass),c.removeClass=null)}}function pa(a){a=a||{};if(!a.$$prepared){var b=a.domOperation||
	N;a.domOperation=function(){a.$$domOperationFired=!0;b();b=N};a.$$prepared=!0}return a}function ha(a,b){Ia(a,b);Ja(a,b)}function Ia(a,b){b.from&&(a.css(b.from),b.from=null)}function Ja(a,b){b.to&&(a.css(b.to),b.to=null)}function T(a,b,c){var d=b.options||{};c=c.options||{};var f=(d.addClass||"")+" "+(c.addClass||""),k=(d.removeClass||"")+" "+(c.removeClass||"");a=Ta(a.attr("class"),f,k);c.preparationClasses&&(d.preparationClasses=ba(c.preparationClasses,d.preparationClasses),delete c.preparationClasses);
	f=d.domOperation!==N?d.domOperation:null;wa(d,c);f&&(d.domOperation=f);d.addClass=a.addClass?a.addClass:null;d.removeClass=a.removeClass?a.removeClass:null;b.addClass=d.addClass;b.removeClass=d.removeClass;return d}function Ta(a,b,c){function d(a){G(a)&&(a=a.split(" "));var c={};s(a,function(a){a.length&&(c[a]=!0)});return c}var f={};a=d(a);b=d(b);s(b,function(a,c){f[c]=1});c=d(c);s(c,function(a,c){f[c]=1===f[c]?null:-1});var k={addClass:"",removeClass:""};s(f,function(c,b){var d,f;1===c?(d="addClass",
	f=!a[b]||a[b+"-remove"]):-1===c&&(d="removeClass",f=a[b]||a[b+"-add"]);f&&(k[d].length&&(k[d]+=" "),k[d]+=b)});return k}function K(a){return a instanceof A?a[0]:a}function Ua(a,b,c,d){a="";c&&(a=$(c,"ng-",!0));d.addClass&&(a=ba(a,$(d.addClass,"-add")));d.removeClass&&(a=ba(a,$(d.removeClass,"-remove")));a.length&&(d.preparationClasses=a,b.addClass(a))}function xa(a,b){var c=b?"paused":"",d=ca+"PlayState";ma(a,[d,c]);return[d,c]}function ma(a,b){a.style[b[0]]=b[1]}function ba(a,b){return a?b?a+" "+
	b:a:b}function Ka(a,b,c){var d=Object.create(null),f=a.getComputedStyle(b)||{};s(c,function(a,c){var b=f[a];if(b){var L=b.charAt(0);if("-"===L||"+"===L||0<=L)b=Va(b);0===b&&(b=null);d[c]=b}});return d}function Va(a){var b=0;a=a.split(/\s*,\s*/);s(a,function(a){"s"===a.charAt(a.length-1)&&(a=a.substring(0,a.length-1));a=parseFloat(a)||0;b=b?Math.max(a,b):a});return b}function ya(a){return 0===a||null!=a}function La(a,b){var c=M,d=a+"s";b?c+="Duration":d+=" linear all";return[c,d]}function Ma(a,b,c){s(c,
	function(c){a[c]=za(a[c])?a[c]:b.style.getPropertyValue(c)})}var M,Aa,ca,Ba;void 0===Y.ontransitionend&&void 0!==Y.onwebkittransitionend?(M="WebkitTransition",Aa="webkitTransitionEnd transitionend"):(M="transition",Aa="transitionend");void 0===Y.onanimationend&&void 0!==Y.onwebkitanimationend?(ca="WebkitAnimation",Ba="webkitAnimationEnd animationend"):(ca="animation",Ba="animationend");var qa=ca+"Delay",Ca=ca+"Duration",na=M+"Delay",Na=M+"Duration",Pa=z.$$minErr("ng"),ra={blockTransitions:function(a,
	b){var c=b?"-"+b+"s":"";ma(a,[na,c]);return[na,c]}},Wa={transitionDuration:Na,transitionDelay:na,transitionProperty:M+"Property",animationDuration:Ca,animationDelay:qa,animationIterationCount:ca+"IterationCount"},Xa={transitionDuration:Na,transitionDelay:na,animationDuration:Ca,animationDelay:qa},Da,wa,s,Z,za,sa,Ea,ta,G,R,A,N;z.module("ngAnimate",[],function(){N=z.noop;Da=z.copy;wa=z.extend;A=z.element;s=z.forEach;Z=z.isArray;G=z.isString;ta=z.isObject;R=z.isUndefined;za=z.isDefined;Ea=z.isFunction;
	sa=z.isElement}).info({angularVersion:"1.7.9"}).directive("ngAnimateSwap",["$animate",function(a){return{restrict:"A",transclude:"element",terminal:!0,priority:550,link:function(b,c,d,f,k){var e,Q;b.$watchCollection(d.ngAnimateSwap||d["for"],function(b){e&&a.leave(e);Q&&(Q.$destroy(),Q=null);(b||0===b)&&k(function(b,d){e=b;Q=d;a.enter(b,null,c)})})}}}]).directive("ngAnimateChildren",["$interpolate",function(a){return{link:function(b,c,d){function f(a){c.data("$$ngAnimateChildren","on"===a||"true"===
	a)}var k=d.ngAnimateChildren;G(k)&&0===k.length?c.data("$$ngAnimateChildren",!0):(f(a(k)(b)),d.$observe("ngAnimateChildren",f))}}}]).factory("$$rAFScheduler",["$$rAF",function(a){function b(a){d=d.concat(a);c()}function c(){if(d.length){for(var b=d.shift(),e=0;e<b.length;e++)b[e]();f||a(function(){f||c()})}}var d,f;d=b.queue=[];b.waitUntilQuiet=function(b){f&&f();f=a(function(){f=null;b();c()})};return b}]).provider("$$animateQueue",["$animateProvider",function(a){function b(a){return{addClass:a.addClass,
	removeClass:a.removeClass,from:a.from,to:a.to}}function c(a){if(!a)return null;a=a.split(" ");var b=Object.create(null);s(a,function(a){b[a]=!0});return b}function d(a,b){if(a&&b){var d=c(b);return a.split(" ").some(function(a){return d[a]})}}function f(a,b,c){return e[a].some(function(a){return a(b,c)})}function k(a,b){var c=0<(a.addClass||"").length,d=0<(a.removeClass||"").length;return b?c&&d:c||d}var e=this.rules={skip:[],cancel:[],join:[]};e.join.push(function(a,b){return!a.structural&&k(a)});
	e.skip.push(function(a,b){return!a.structural&&!k(a)});e.skip.push(function(a,b){return"leave"===b.event&&a.structural});e.skip.push(function(a,b){return b.structural&&2===b.state&&!a.structural});e.cancel.push(function(a,b){return b.structural&&a.structural});e.cancel.push(function(a,b){return 2===b.state&&a.structural});e.cancel.push(function(a,b){if(b.structural)return!1;var c=a.addClass,f=a.removeClass,k=b.addClass,e=b.removeClass;return R(c)&&R(f)||R(k)&&R(e)?!1:d(c,e)||d(f,k)});this.$get=["$$rAF",
	"$rootScope","$rootElement","$document","$$Map","$$animation","$$AnimateRunner","$templateRequest","$$jqLite","$$forceReflow","$$isDocumentHidden",function(c,d,e,C,U,oa,H,u,t,I,da){function ia(a){O.delete(a.target)}function v(){var a=!1;return function(b){a?b():d.$$postDigest(function(){a=!0;b()})}}function ua(a,b,c){var g=[],l=m[c];l&&s(l,function(l){Oa.call(l.node,b)?g.push(l.callback):"leave"===c&&Oa.call(l.node,a)&&g.push(l.callback)});return g}function h(a,b,c){var l=va(b);return a.filter(function(a){return!(a.node===
	l&&(!c||a.callback===c))})}function q(a,J,w){function e(a,b,l,g){u(function(){var a=ua(ia,m,b);a.length?c(function(){s(a,function(a){a(h,l,g)});"close"!==l||m.parentNode||D.off(m)}):"close"!==l||m.parentNode||D.off(m)});a.progress(b,l,g)}function I(a){var b=h,c=n;c.preparationClasses&&(b.removeClass(c.preparationClasses),c.preparationClasses=null);c.activeClasses&&(b.removeClass(c.activeClasses),c.activeClasses=null);W(h,n);ha(h,n);n.domOperation();q.complete(!a)}var n=Da(w),h=Ha(a),m=K(h),ia=m&&
	m.parentNode,n=pa(n),q=new H,u=v();Z(n.addClass)&&(n.addClass=n.addClass.join(" "));n.addClass&&!G(n.addClass)&&(n.addClass=null);Z(n.removeClass)&&(n.removeClass=n.removeClass.join(" "));n.removeClass&&!G(n.removeClass)&&(n.removeClass=null);n.from&&!ta(n.from)&&(n.from=null);n.to&&!ta(n.to)&&(n.to=null);if(!(B&&m&&fa(m,J,w)&&Ya(m,n)))return I(),q;var x=0<=["enter","move","leave"].indexOf(J),r=da(),P=r||O.get(m);w=!P&&y.get(m)||{};var p=!!w.state;P||p&&1===w.state||(P=!E(m,ia,J));if(P)return r&&
	e(q,J,"start",b(n)),I(),r&&e(q,J,"close",b(n)),q;x&&F(m);r={structural:x,element:h,event:J,addClass:n.addClass,removeClass:n.removeClass,close:I,options:n,runner:q};if(p){if(f("skip",r,w)){if(2===w.state)return I(),q;T(h,w,r);return w.runner}if(f("cancel",r,w))if(2===w.state)w.runner.end();else if(w.structural)w.close();else return T(h,w,r),w.runner;else if(f("join",r,w))if(2===w.state)T(h,r,{});else return Ua(t,h,x?J:null,n),J=r.event=w.event,n=T(h,w,r),w.runner}else T(h,r,{});(p=r.structural)||
	(p="animate"===r.event&&0<Object.keys(r.options.to||{}).length||k(r));if(!p)return I(),g(m),q;var C=(w.counter||0)+1;r.counter=C;l(m,1,r);d.$$postDigest(function(){h=Ha(a);var c=y.get(m),d=!c,c=c||{},t=0<(h.parent()||[]).length&&("animate"===c.event||c.structural||k(c));if(d||c.counter!==C||!t){d&&(W(h,n),ha(h,n));if(d||x&&c.event!==J)n.domOperation(),q.end();t||g(m)}else J=!c.structural&&k(c,!0)?"setClass":c.event,l(m,2),c=oa(h,J,c.options),q.setHost(c),e(q,J,"start",b(n)),c.done(function(a){I(!a);
	(a=y.get(m))&&a.counter===C&&g(m);e(q,J,"close",b(n))})});return q}function F(a){a=a.querySelectorAll("[data-ng-animate]");s(a,function(a){var b=parseInt(a.getAttribute("data-ng-animate"),10),c=y.get(a);if(c)switch(b){case 2:c.runner.end();case 1:y.delete(a)}})}function g(a){a.removeAttribute("data-ng-animate");y.delete(a)}function E(a,b,c){c=C[0].body;var l=K(e),g=a===c||"HTML"===a.nodeName,d=a===l,t=!1,m=O.get(a),h;for((a=A.data(a,"$ngAnimatePin"))&&(b=K(a));b;){d||(d=b===l);if(1!==b.nodeType)break;
	a=y.get(b)||{};if(!t){var f=O.get(b);if(!0===f&&!1!==m){m=!0;break}else!1===f&&(m=!1);t=a.structural}if(R(h)||!0===h)a=A.data(b,"$$ngAnimateChildren"),za(a)&&(h=a);if(t&&!1===h)break;g||(g=b===c);if(g&&d)break;if(!d&&(a=A.data(b,"$ngAnimatePin"))){b=K(a);continue}b=b.parentNode}return(!t||h)&&!0!==m&&d&&g}function l(a,b,c){c=c||{};c.state=b;a.setAttribute("data-ng-animate",b);c=(b=y.get(a))?wa(b,c):c;y.set(a,c)}var y=new U,O=new U,B=null,P=d.$watch(function(){return 0===u.totalPendingRequests},function(a){a&&
	(P(),d.$$postDigest(function(){d.$$postDigest(function(){null===B&&(B=!0)})}))}),m=Object.create(null);U=a.customFilter();var la=a.classNameFilter();I=function(){return!0};var fa=U||I,Ya=la?function(a,b){var c=[a.getAttribute("class"),b.addClass,b.removeClass].join(" ");return la.test(c)}:I,W=aa(t),Oa=Y.Node.prototype.contains||function(a){return this===a||!!(this.compareDocumentPosition(a)&16)},D={on:function(a,b,c){var l=va(b);m[a]=m[a]||[];m[a].push({node:l,callback:c});A(b).on("$destroy",function(){y.get(l)||
	D.off(a,b,c)})},off:function(a,b,c){if(1!==arguments.length||G(arguments[0])){var l=m[a];l&&(m[a]=1===arguments.length?null:h(l,b,c))}else for(l in b=arguments[0],m)m[l]=h(m[l],b)},pin:function(a,b){Fa(sa(a),"element","not an element");Fa(sa(b),"parentElement","not an element");a.data("$ngAnimatePin",b)},push:function(a,b,c,l){c=c||{};c.domOperation=l;return q(a,b,c)},enabled:function(a,b){var c=arguments.length;if(0===c)b=!!B;else if(sa(a)){var l=K(a);if(1===c)b=!O.get(l);else{if(!O.has(l))A(a).on("$destroy",
	ia);O.set(l,!b)}}else b=B=!!a;return b}};return D}]}]).provider("$$animateCache",function(){var a=0,b=Object.create(null);this.$get=[function(){return{cacheKey:function(b,d,f,k){var e=b.parentNode;b=[e.$$ngAnimateParentKey||(e.$$ngAnimateParentKey=++a),d,b.getAttribute("class")];f&&b.push(f);k&&b.push(k);return b.join(" ")},containsCachedAnimationWithoutDuration:function(a){return(a=b[a])&&!a.isValid||!1},flush:function(){b=Object.create(null)},count:function(a){return(a=b[a])?a.total:0},get:function(a){return(a=
	b[a])&&a.value},put:function(a,d,f){b[a]?(b[a].total++,b[a].value=d):b[a]={total:1,value:d,isValid:f}}}}]}).provider("$$animation",["$animateProvider",function(a){var b=this.drivers=[];this.$get=["$$jqLite","$rootScope","$injector","$$AnimateRunner","$$Map","$$rAFScheduler","$$animateCache",function(a,d,f,k,e,Q,L){function x(a){function b(a){if(a.processed)return a;a.processed=!0;var d=a.domNode,t=d.parentNode;f.set(d,a);for(var h;t;){if(h=f.get(t)){h.processed||(h=b(h));break}t=t.parentNode}(h||
	c).children.push(a);return a}var c={children:[]},d,f=new e;for(d=0;d<a.length;d++){var da=a[d];f.set(da.domNode,a[d]={domNode:da.domNode,element:da.element,fn:da.fn,children:[]})}for(d=0;d<a.length;d++)b(a[d]);return function(a){var b=[],c=[],d;for(d=0;d<a.children.length;d++)c.push(a.children[d]);a=c.length;var t=0,f=[];for(d=0;d<c.length;d++){var g=c[d];0>=a&&(a=t,t=0,b.push(f),f=[]);f.push(g);g.children.forEach(function(a){t++;c.push(a)});a--}f.length&&b.push(f);return b}(c)}var C=[],U=aa(a);return function(e,
	H,u){function t(a){a=a.hasAttribute("ng-animate-ref")?[a]:a.querySelectorAll("[ng-animate-ref]");var b=[];s(a,function(a){var c=a.getAttribute("ng-animate-ref");c&&c.length&&b.push(a)});return b}function I(a){var b=[],c={};s(a,function(a,d){var l=K(a.element),g=0<=["enter","move"].indexOf(a.event),l=a.structural?t(l):[];if(l.length){var f=g?"to":"from";s(l,function(a){var b=a.getAttribute("ng-animate-ref");c[b]=c[b]||{};c[b][f]={animationID:d,element:A(a)}})}else b.push(a)});var d={},g={};s(c,function(c,
	t){var f=c.from,e=c.to;if(f&&e){var h=a[f.animationID],k=a[e.animationID],E=f.animationID.toString();if(!g[E]){var I=g[E]={structural:!0,beforeStart:function(){h.beforeStart();k.beforeStart()},close:function(){h.close();k.close()},classes:da(h.classes,k.classes),from:h,to:k,anchors:[]};I.classes.length?b.push(I):(b.push(h),b.push(k))}g[E].anchors.push({out:f.element,"in":e.element})}else f=f?f.animationID:e.animationID,e=f.toString(),d[e]||(d[e]=!0,b.push(a[f]))});return b}function da(a,b){a=a.split(" ");
	b=b.split(" ");for(var c=[],d=0;d<a.length;d++){var g=a[d];if("ng-"!==g.substring(0,3))for(var t=0;t<b.length;t++)if(g===b[t]){c.push(g);break}}return c.join(" ")}function ia(a){for(var c=b.length-1;0<=c;c--){var d=f.get(b[c])(a);if(d)return d}}function v(a,b){function c(a){(a=a.data("$$animationRunner"))&&a.setHost(b)}a.from&&a.to?(c(a.from.element),c(a.to.element)):c(a.element)}function ua(){var a=e.data("$$animationRunner");!a||"leave"===H&&u.$$domOperationFired||a.end()}function h(b){e.off("$destroy",
	ua);e.removeData("$$animationRunner");U(e,u);ha(e,u);u.domOperation();E&&a.removeClass(e,E);F.complete(!b)}u=pa(u);var q=0<=["enter","move","leave"].indexOf(H),F=new k({end:function(){h()},cancel:function(){h(!0)}});if(!b.length)return h(),F;var g=Ga(e.attr("class"),Ga(u.addClass,u.removeClass)),E=u.tempClasses;E&&(g+=" "+E,u.tempClasses=null);q&&e.data("$$animatePrepareClasses","ng-"+H+"-prepare");e.data("$$animationRunner",F);C.push({element:e,classes:g,event:H,structural:q,options:u,beforeStart:function(){E=
	(E?E+" ":"")+"ng-animate";a.addClass(e,E);var b=e.data("$$animatePrepareClasses");b&&a.removeClass(e,b)},close:h});e.on("$destroy",ua);if(1<C.length)return F;d.$$postDigest(function(){var b=[];s(C,function(a){a.element.data("$$animationRunner")?b.push(a):a.close()});C.length=0;var d=I(b),g=[];s(d,function(a){var b=a.from?a.from.element:a.element,c=u.addClass,d=L.cacheKey(b[0],a.event,(c?c+" ":"")+"ng-animate",u.removeClass);g.push({element:b,domNode:K(b),fn:function(){var b,c=a.close;if(L.containsCachedAnimationWithoutDuration(d))c();
	else{a.beforeStart();if((a.anchors?a.from.element||a.to.element:a.element).data("$$animationRunner")){var g=ia(a);g&&(b=g.start)}b?(b=b(),b.done(function(a){c(!a)}),v(a,b)):c()}}})});for(var d=x(g),t=0;t<d.length;t++)for(var f=d[t],e=0;e<f.length;e++){var h=f[e],k=h.element;d[t][e]=h.fn;0===t?k.removeData("$$animatePrepareClasses"):(h=k.data("$$animatePrepareClasses"))&&a.addClass(k,h)}Q(d)});return F}}]}]).provider("$animateCss",["$animateProvider",function(a){this.$get=["$window","$$jqLite","$$AnimateRunner",
	"$timeout","$$animateCache","$$forceReflow","$sniffer","$$rAFScheduler","$$animateQueue",function(a,c,d,f,k,e,Q,L,x){function C(d,f,e,x){var v,s="stagger-"+e;0<k.count(e)&&(v=k.get(s),v||(f=$(f,"-stagger"),c.addClass(d,f),v=Ka(a,d,x),v.animationDuration=Math.max(v.animationDuration,0),v.transitionDuration=Math.max(v.transitionDuration,0),c.removeClass(d,f),k.put(s,v,!0)));return v||{}}function U(a){u.push(a);L.waitUntilQuiet(function(){k.flush();for(var a=e(),b=0;b<u.length;b++)u[b](a);u.length=0})}
	function z(c,d,f,e){d=k.get(f);d||(d=Ka(a,c,Wa),"infinite"===d.animationIterationCount&&(d.animationIterationCount=1));k.put(f,d,e||0<d.transitionDuration||0<d.animationDuration);c=d;f=c.animationDelay;e=c.transitionDelay;c.maxDelay=f&&e?Math.max(f,e):f||e;c.maxDuration=Math.max(c.animationDuration*c.animationIterationCount,c.transitionDuration);return c}var H=aa(c),u=[];return function(a,b){function e(){v()}function L(){v(!0)}function v(b){if(!(P||la&&m)){P=!0;m=!1;V&&!g.$$skipPreparationClasses&&
	c.removeClass(a,V);ba&&c.removeClass(a,ba);xa(l,!1);ra.blockTransitions(l,!1);s(y,function(a){l.style[a[0]]=""});H(a,g);ha(a,g);Object.keys(E).length&&s(E,function(a,b){a?l.style.setProperty(b,a):l.style.removeProperty(b)});if(g.onDone)g.onDone();w&&w.length&&a.off(w.join(" "),q);var d=a.data("$$animateCss");d&&(f.cancel(d[0].timer),a.removeData("$$animateCss"));fa&&fa.complete(!b)}}function u(a){p.blockTransition&&ra.blockTransitions(l,a);p.blockKeyframeAnimation&&xa(l,!!a)}function h(){fa=new d({end:e,
	cancel:L});U(N);v();return{$$willAnimate:!1,start:function(){return fa},end:e}}function q(a){a.stopPropagation();var b=a.originalEvent||a;b.target===l&&(a=b.$manualTimeStamp||Date.now(),b=parseFloat(b.elapsedTime.toFixed(3)),Math.max(a-J,0)>=G&&b>=D&&(la=!0,v()))}function F(){function b(){if(!P){u(!1);s(y,function(a){l.style[a[0]]=a[1]});H(a,g);c.addClass(a,ba);if(p.recalculateTimingStyles){T=l.getAttribute("class")+" "+V;ka=k.cacheKey(l,ja,g.addClass,g.removeClass);r=z(l,T,ka,!1);ga=r.maxDelay;W=
	Math.max(ga,0);D=r.maxDuration;if(0===D){v();return}p.hasTransitions=0<r.transitionDuration;p.hasAnimations=0<r.animationDuration}p.applyAnimationDelay&&(ga="boolean"!==typeof g.delay&&ya(g.delay)?parseFloat(g.delay):ga,W=Math.max(ga,0),r.animationDelay=ga,ea=[qa,ga+"s"],y.push(ea),l.style[ea[0]]=ea[1]);G=1E3*W;R=1E3*D;if(g.easing){var e,h=g.easing;p.hasTransitions&&(e=M+"TimingFunction",y.push([e,h]),l.style[e]=h);p.hasAnimations&&(e=ca+"TimingFunction",y.push([e,h]),l.style[e]=h)}r.transitionDuration&&
	w.push(Aa);r.animationDuration&&w.push(Ba);J=Date.now();var m=G+1.5*R;e=J+m;var h=a.data("$$animateCss")||[],F=!0;if(h.length){var n=h[0];(F=e>n.expectedEndTime)?f.cancel(n.timer):h.push(v)}F&&(m=f(d,m,!1),h[0]={timer:m,expectedEndTime:e},h.push(v),a.data("$$animateCss",h));if(w.length)a.on(w.join(" "),q);g.to&&(g.cleanupStyles&&Ma(E,l,Object.keys(g.to)),Ja(a,g))}}function d(){var b=a.data("$$animateCss");if(b){for(var c=1;c<b.length;c++)b[c]();a.removeData("$$animateCss")}}if(!P)if(l.parentNode){var e=
	function(a){if(la)m&&a&&(m=!1,v());else if(m=!a,r.animationDuration)if(a=xa(l,m),m)y.push(a);else{var b=y,c=b.indexOf(a);0<=a&&b.splice(c,1)}},h=0<aa&&(r.transitionDuration&&0===X.transitionDuration||r.animationDuration&&0===X.animationDuration)&&Math.max(X.animationDelay,X.transitionDelay);h?f(b,Math.floor(h*aa*1E3),!1):b();A.resume=function(){e(!0)};A.pause=function(){e(!1)}}else v()}var g=b||{};g.$$prepared||(g=pa(Da(g)));var E={},l=K(a);if(!l||!l.parentNode||!x.enabled())return h();var y=[],O=
	a.attr("class"),B=Qa(g),P,m,la,fa,A,W,G,D,R,J,w=[];if(0===g.duration||!Q.animations&&!Q.transitions)return h();var ja=g.event&&Z(g.event)?g.event.join(" "):g.event,Y=ja&&g.structural,n="",S="";Y?n=$(ja,"ng-",!0):ja&&(n=ja);g.addClass&&(S+=$(g.addClass,"-add"));g.removeClass&&(S.length&&(S+=" "),S+=$(g.removeClass,"-remove"));g.applyClassesEarly&&S.length&&H(a,g);var V=[n,S].join(" ").trim(),T=O+" "+V,O=B.to&&0<Object.keys(B.to).length;if(!(0<(g.keyframeStyle||"").length||O||V))return h();var X,ka=
	k.cacheKey(l,ja,g.addClass,g.removeClass);if(k.containsCachedAnimationWithoutDuration(ka))return V=null,h();0<g.stagger?(B=parseFloat(g.stagger),X={transitionDelay:B,animationDelay:B,transitionDuration:0,animationDuration:0}):X=C(l,V,ka,Xa);g.$$skipPreparationClasses||c.addClass(a,V);g.transitionStyle&&(B=[M,g.transitionStyle],ma(l,B),y.push(B));0<=g.duration&&(B=0<l.style[M].length,B=La(g.duration,B),ma(l,B),y.push(B));g.keyframeStyle&&(B=[ca,g.keyframeStyle],ma(l,B),y.push(B));var aa=X?0<=g.staggerIndex?
	g.staggerIndex:k.count(ka):0;(n=0===aa)&&!g.skipBlocking&&ra.blockTransitions(l,9999);var r=z(l,T,ka,!Y),ga=r.maxDelay;W=Math.max(ga,0);D=r.maxDuration;var p={};p.hasTransitions=0<r.transitionDuration;p.hasAnimations=0<r.animationDuration;p.hasTransitionAll=p.hasTransitions&&"all"===r.transitionProperty;p.applyTransitionDuration=O&&(p.hasTransitions&&!p.hasTransitionAll||p.hasAnimations&&!p.hasTransitions);p.applyAnimationDuration=g.duration&&p.hasAnimations;p.applyTransitionDelay=ya(g.delay)&&(p.applyTransitionDuration||
	p.hasTransitions);p.applyAnimationDelay=ya(g.delay)&&p.hasAnimations;p.recalculateTimingStyles=0<S.length;if(p.applyTransitionDuration||p.applyAnimationDuration)D=g.duration?parseFloat(g.duration):D,p.applyTransitionDuration&&(p.hasTransitions=!0,r.transitionDuration=D,B=0<l.style[M+"Property"].length,y.push(La(D,B))),p.applyAnimationDuration&&(p.hasAnimations=!0,r.animationDuration=D,y.push([Ca,D+"s"]));if(0===D&&!p.recalculateTimingStyles)return h();var ba=$(V,"-active");if(null!=g.delay){var ea;
	"boolean"!==typeof g.delay&&(ea=parseFloat(g.delay),W=Math.max(ea,0));p.applyTransitionDelay&&y.push([na,ea+"s"]);p.applyAnimationDelay&&y.push([qa,ea+"s"])}null==g.duration&&0<r.transitionDuration&&(p.recalculateTimingStyles=p.recalculateTimingStyles||n);G=1E3*W;R=1E3*D;g.skipBlocking||(p.blockTransition=0<r.transitionDuration,p.blockKeyframeAnimation=0<r.animationDuration&&0<X.animationDelay&&0===X.animationDuration);g.from&&(g.cleanupStyles&&Ma(E,l,Object.keys(g.from)),Ia(a,g));p.blockTransition||
	p.blockKeyframeAnimation?u(D):g.skipBlocking||ra.blockTransitions(l,!1);return{$$willAnimate:!0,end:e,start:function(){if(!P)return A={end:e,cancel:L,resume:null,pause:null},fa=new d(A),U(F),fa}}}}]}]).provider("$$animateCssDriver",["$$animationProvider",function(a){a.drivers.push("$$animateCssDriver");this.$get=["$animateCss","$rootScope","$$AnimateRunner","$rootElement","$sniffer","$$jqLite","$document",function(a,c,d,f,k,e,Q){function L(a){return a.replace(/\bng-\S+\b/g,"")}function x(a,b){G(a)&&
	(a=a.split(" "));G(b)&&(b=b.split(" "));return a.filter(function(a){return-1===b.indexOf(a)}).join(" ")}function C(c,e,f){function k(a){var b={},c=K(a).getBoundingClientRect();s(["width","height","top","left"],function(a){var d=c[a];switch(a){case "top":d+=H.scrollTop;break;case "left":d+=H.scrollLeft}b[a]=Math.floor(d)+"px"});return b}function v(){var c=L(f.attr("class")||""),d=x(c,q),c=x(q,c),d=a(h,{to:k(f),addClass:"ng-anchor-in "+d,removeClass:"ng-anchor-out "+c,delay:!0});return d.$$willAnimate?
	d:null}function C(){h.remove();e.removeClass("ng-animate-shim");f.removeClass("ng-animate-shim")}var h=A(K(e).cloneNode(!0)),q=L(h.attr("class")||"");e.addClass("ng-animate-shim");f.addClass("ng-animate-shim");h.addClass("ng-anchor");u.append(h);var F;c=function(){var c=a(h,{addClass:"ng-anchor-out",delay:!0,from:k(e)});return c.$$willAnimate?c:null}();if(!c&&(F=v(),!F))return C();var g=c||F;return{start:function(){function a(){c&&c.end()}var b,c=g.start();c.done(function(){c=null;if(!F&&(F=v()))return c=
	F.start(),c.done(function(){c=null;C();b.complete()}),c;C();b.complete()});return b=new d({end:a,cancel:a})}}}function z(a,b,c,e){var f=oa(a,N),k=oa(b,N),h=[];s(e,function(a){(a=C(c,a.out,a["in"]))&&h.push(a)});if(f||k||0!==h.length)return{start:function(){function a(){s(b,function(a){a.end()})}var b=[];f&&b.push(f.start());k&&b.push(k.start());s(h,function(a){b.push(a.start())});var c=new d({end:a,cancel:a});d.all(b,function(a){c.complete(a)});return c}}}function oa(c){var d=c.element,e=c.options||
	{};c.structural&&(e.event=c.event,e.structural=!0,e.applyClassesEarly=!0,"leave"===c.event&&(e.onDone=e.domOperation));e.preparationClasses&&(e.event=ba(e.event,e.preparationClasses));c=a(d,e);return c.$$willAnimate?c:null}if(!k.animations&&!k.transitions)return N;var H=Q[0].body;c=K(f);var u=A(c.parentNode&&11===c.parentNode.nodeType||H.contains(c)?c:H);return function(a){return a.from&&a.to?z(a.from,a.to,a.classes,a.anchors):oa(a)}}]}]).provider("$$animateJs",["$animateProvider",function(a){this.$get=
	["$injector","$$AnimateRunner","$$jqLite",function(b,c,d){function f(c){c=Z(c)?c:c.split(" ");for(var d=[],f={},k=0;k<c.length;k++){var s=c[k],z=a.$$registeredAnimations[s];z&&!f[s]&&(d.push(b.get(z)),f[s]=!0)}return d}var k=aa(d);return function(a,b,d,x){function C(){x.domOperation();k(a,x)}function z(a,b,d,f,e){switch(d){case "animate":b=[b,f.from,f.to,e];break;case "setClass":b=[b,t,I,e];break;case "addClass":b=[b,t,e];break;case "removeClass":b=[b,I,e];break;default:b=[b,e]}b.push(f);if(a=a.apply(a,
	b))if(Ea(a.start)&&(a=a.start()),a instanceof c)a.done(e);else if(Ea(a))return a;return N}function A(a,b,d,e,f){var h=[];s(e,function(e){var l=e[f];l&&h.push(function(){var e,f,h=!1,k=function(a){h||(h=!0,(f||N)(a),e.complete(!a))};e=new c({end:function(){k()},cancel:function(){k(!0)}});f=z(l,a,b,d,function(a){k(!1===a)});return e})});return h}function H(a,b,d,e,f){var h=A(a,b,d,e,f);if(0===h.length){var k,q;"beforeSetClass"===f?(k=A(a,"removeClass",d,e,"beforeRemoveClass"),q=A(a,"addClass",d,e,"beforeAddClass")):
	"setClass"===f&&(k=A(a,"removeClass",d,e,"removeClass"),q=A(a,"addClass",d,e,"addClass"));k&&(h=h.concat(k));q&&(h=h.concat(q))}if(0!==h.length)return function(a){var b=[];h.length&&s(h,function(a){b.push(a())});b.length?c.all(b,a):a();return function(a){s(b,function(b){a?b.cancel():b.end()})}}}var u=!1;3===arguments.length&&ta(d)&&(x=d,d=null);x=pa(x);d||(d=a.attr("class")||"",x.addClass&&(d+=" "+x.addClass),x.removeClass&&(d+=" "+x.removeClass));var t=x.addClass,I=x.removeClass,G=f(d),K,v;if(G.length){var M,
	h;"leave"===b?(h="leave",M="afterLeave"):(h="before"+b.charAt(0).toUpperCase()+b.substr(1),M=b);"enter"!==b&&"move"!==b&&(K=H(a,b,x,G,h));v=H(a,b,x,G,M)}if(K||v){var q;return{$$willAnimate:!0,end:function(){q?q.end():(u=!0,C(),ha(a,x),q=new c,q.complete(!0));return q},start:function(){function b(c){u=!0;C();ha(a,x);q.complete(c)}if(q)return q;q=new c;var d,f=[];K&&f.push(function(a){d=K(a)});f.length?f.push(function(a){C();a(!0)}):C();v&&f.push(function(a){d=v(a)});q.setHost({end:function(){u||((d||
	N)(void 0),b(void 0))},cancel:function(){u||((d||N)(!0),b(!0))}});c.chain(f,b);return q}}}}}]}]).provider("$$animateJsDriver",["$$animationProvider",function(a){a.drivers.push("$$animateJsDriver");this.$get=["$$animateJs","$$AnimateRunner",function(a,c){function d(c){return a(c.element,c.event,c.classes,c.options)}return function(a){if(a.from&&a.to){var b=d(a.from),e=d(a.to);if(b||e)return{start:function(){function a(){return function(){s(d,function(a){a.end()})}}var d=[];b&&d.push(b.start());e&&
	d.push(e.start());c.all(d,function(a){f.complete(a)});var f=new c({end:a(),cancel:a()});return f}}}else return d(a)}}]}])})(window,window.angular);
	//# sourceMappingURL=angular-animate.min.js.map


/***/ }),
/* 476 */
/***/ (function(module, exports) {

	angular.module('colorpicker.module', [])
	    .factory('Helper', function () {
	      'use strict';
	      return {
	        closestSlider: function (elem) {
	          var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
	          if (matchesSelector.bind(elem)('I')) {
	            return elem.parentNode;
	          }
	          return elem;
	        },
	        getOffset: function (elem, fixedPosition) {
	          var
	            scrollX = 0,
	            scrollY = 0,
	            rect = elem.getBoundingClientRect();
	          while (elem && !isNaN(elem.offsetLeft) && !isNaN(elem.offsetTop)) {
	            if (!fixedPosition && elem.tagName === 'BODY') {
	              scrollX += document.documentElement.scrollLeft || elem.scrollLeft;
	              scrollY += document.documentElement.scrollTop || elem.scrollTop;
	            } else {
	              scrollX += elem.scrollLeft;
	              scrollY += elem.scrollTop;
	            }
	            elem = elem.offsetParent;
	          }
	          return {
	            top: rect.top + window.pageYOffset,
	            left: rect.left + window.pageXOffset,
	            scrollX: scrollX,
	            scrollY: scrollY
	          };
	        },
	        // a set of RE's that can match strings and generate color tuples. https://github.com/jquery/jquery-color/
	        stringParsers: [
	          {
	            re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
	            parse: function (execResult) {
	              return [
	                execResult[1],
	                execResult[2],
	                execResult[3],
	                execResult[4]
	              ];
	            }
	          },
	          {
	            re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
	            parse: function (execResult) {
	              return [
	                2.55 * execResult[1],
	                2.55 * execResult[2],
	                2.55 * execResult[3],
	                execResult[4]
	              ];
	            }
	          },
	          {
	            re: /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,
	            parse: function (execResult) {
	              return [
	                parseInt(execResult[1], 16),
	                parseInt(execResult[2], 16),
	                parseInt(execResult[3], 16)
	              ];
	            }
	          },
	          {
	            re: /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/,
	            parse: function (execResult) {
	              return [
	                parseInt(execResult[1] + execResult[1], 16),
	                parseInt(execResult[2] + execResult[2], 16),
	                parseInt(execResult[3] + execResult[3], 16)
	              ];
	            }
	          }
	        ]
	      };
	    })
	    .factory('Color', ['Helper', function (Helper) {
	      'use strict';
	      return {
	        value: {
	          h: 1,
	          s: 1,
	          b: 1,
	          a: 1
	        },
	        // translate a format from Color object to a string
	        'rgb': function () {
	          var rgb = this.toRGB();
	          return 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')';
	        },
	        'rgba': function () {
	          var rgb = this.toRGB();
	          return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')';
	        },
	        'hex': function () {
	          return  this.toHex();
	        },
	
	        // HSBtoRGB from RaphaelJS
	        RGBtoHSB: function (r, g, b, a) {
	          r /= 255;
	          g /= 255;
	          b /= 255;
	
	          var H, S, V, C;
	          V = Math.max(r, g, b);
	          C = V - Math.min(r, g, b);
	          H = (C === 0 ? null :
	              V === r ? (g - b) / C :
	                  V === g ? (b - r) / C + 2 :
	                      (r - g) / C + 4
	              );
	          H = ((H + 360) % 6) * 60 / 360;
	          S = C === 0 ? 0 : C / V;
	          return {h: H || 1, s: S, b: V, a: a || 1};
	        },
	
	        //parse a string to HSB
	        setColor: function (val) {
	          val = (val) ? val.toLowerCase() : val;
	          for (var key in Helper.stringParsers) {
	            if (Helper.stringParsers.hasOwnProperty(key)) {
	              var parser = Helper.stringParsers[key];
	              var match = parser.re.exec(val),
	                  values = match && parser.parse(match);
	              if (values) {
	                this.value = this.RGBtoHSB.apply(null, values);
	                return false;
	              }
	            }
	          }
	        },
	
	        setHue: function (h) {
	          this.value.h = 1 - h;
	        },
	
	        setSaturation: function (s) {
	          this.value.s = s;
	        },
	
	        setLightness: function (b) {
	          this.value.b = 1 - b;
	        },
	
	        setAlpha: function (a) {
	          this.value.a = parseInt((1 - a) * 100, 10) / 100;
	        },
	
	        // HSBtoRGB from RaphaelJS
	        // https://github.com/DmitryBaranovskiy/raphael/
	        toRGB: function (h, s, b, a) {
	          if (!h) {
	            h = this.value.h;
	            s = this.value.s;
	            b = this.value.b;
	          }
	          h *= 360;
	          var R, G, B, X, C;
	          h = (h % 360) / 60;
	          C = b * s;
	          X = C * (1 - Math.abs(h % 2 - 1));
	          R = G = B = b - C;
	
	          h = ~~h;
	          R += [C, X, 0, 0, X, C][h];
	          G += [X, C, C, X, 0, 0][h];
	          B += [0, 0, X, C, C, X][h];
	          return {
	            r: Math.round(R * 255),
	            g: Math.round(G * 255),
	            b: Math.round(B * 255),
	            a: a || this.value.a
	          };
	        },
	
	        toHex: function (h, s, b, a) {
	          var rgb = this.toRGB(h, s, b, a);
	          return '#' + ((1 << 24) | (parseInt(rgb.r, 10) << 16) | (parseInt(rgb.g, 10) << 8) | parseInt(rgb.b, 10)).toString(16).substr(1);
	        }
	      };
	    }])
	    .factory('Slider', ['Helper', function (Helper) {
	      'use strict';
	      var
	          slider = {
	            maxLeft: 0,
	            maxTop: 0,
	            callLeft: null,
	            callTop: null,
	            knob: {
	              top: 0,
	              left: 0
	            }
	          },
	          pointer = {};
	
	      return {
	        getSlider: function() {
	          return slider;
	        },
	        getLeftPosition: function(event) {
	          return Math.max(0, Math.min(slider.maxLeft, slider.left + ((event.pageX || pointer.left) - pointer.left)));
	        },
	        getTopPosition: function(event) {
	          return Math.max(0, Math.min(slider.maxTop, slider.top + ((event.pageY || pointer.top) - pointer.top)));
	        },
	        setSlider: function (event, fixedPosition) {
	          var
	            target = Helper.closestSlider(event.target),
	            targetOffset = Helper.getOffset(target, fixedPosition),
	            rect = target.getBoundingClientRect(),
	            offsetX = event.clientX - rect.left,
	            offsetY = event.clientY - rect.top;
	
	          slider.knob = target.children[0].style;
	          slider.left = event.pageX - targetOffset.left - window.pageXOffset + targetOffset.scrollX;
	          slider.top = event.pageY - targetOffset.top - window.pageYOffset + targetOffset.scrollY;
	
	          pointer = {
	            left: event.pageX - (offsetX - slider.left),
	            top: event.pageY - (offsetY - slider.top)
	          };
	        },
	        setSaturation: function(event, fixedPosition, componentSize) {
	          slider = {
	            maxLeft: componentSize,
	            maxTop: componentSize,
	            callLeft: 'setSaturation',
	            callTop: 'setLightness'
	          };
	          this.setSlider(event, fixedPosition);
	        },
	        setHue: function(event, fixedPosition, componentSize) {
	          slider = {
	            maxLeft: 0,
	            maxTop: componentSize,
	            callLeft: false,
	            callTop: 'setHue'
	          };
	          this.setSlider(event, fixedPosition);
	        },
	        setAlpha: function(event, fixedPosition, componentSize) {
	          slider = {
	            maxLeft: 0,
	            maxTop: componentSize,
	            callLeft: false,
	            callTop: 'setAlpha'
	          };
	          this.setSlider(event, fixedPosition);
	        },
	        setKnob: function(top, left) {
	          slider.knob.top = top + 'px';
	          slider.knob.left = left + 'px';
	        }
	      };
	    }])
	    .directive('colorpicker', ['$document', '$compile', 'Color', 'Slider', 'Helper', function ($document, $compile, Color, Slider, Helper) {
	      'use strict';
	      return {
	        require: '?ngModel',
	        restrict: 'A',
	        link: function ($scope, elem, attrs, ngModel) {
	          var
	              thisFormat = attrs.colorpicker ? attrs.colorpicker : 'hex',
	              position = angular.isDefined(attrs.colorpickerPosition) ? attrs.colorpickerPosition : 'bottom',
	              inline = angular.isDefined(attrs.colorpickerInline) ? attrs.colorpickerInline : false,
	              fixedPosition = angular.isDefined(attrs.colorpickerFixedPosition) ? attrs.colorpickerFixedPosition : false,
	              target = angular.isDefined(attrs.colorpickerParent) ? elem.parent() : angular.element(document.body),
	              withInput = angular.isDefined(attrs.colorpickerWithInput) ? attrs.colorpickerWithInput : false,
	              componentSize = angular.isDefined(attrs.colorpickerSize) ? attrs.colorpickerSize : 100,
	              componentSizePx = componentSize + 'px',
	              inputTemplate = withInput ? '<input type="text" name="colorpicker-input" spellcheck="false">' : '',
	              closeButton = !inline ? '<button type="button" class="close close-colorpicker">&times;</button>' : '',
	              template =
	                  '<div class="colorpicker dropdown">' +
	                      '<div class="dropdown-menu">' +
	                      '<colorpicker-saturation><i></i></colorpicker-saturation>' +
	                      '<colorpicker-hue><i></i></colorpicker-hue>' +
	                      '<colorpicker-alpha><i></i></colorpicker-alpha>' +
	                      '<colorpicker-preview></colorpicker-preview>' +
	                      inputTemplate +
	                      closeButton +
	                      '</div>' +
	                      '</div>',
	              colorpickerTemplate = angular.element(template),
	              pickerColor = Color,
	              colorpickerValue = {
	                h: 1,
	                s: 0,
	                b: 1,
	                a: 1
	              },
	              sliderAlpha,
	              sliderHue = colorpickerTemplate.find('colorpicker-hue'),
	              sliderSaturation = colorpickerTemplate.find('colorpicker-saturation'),
	              colorpickerPreview = colorpickerTemplate.find('colorpicker-preview'),
	              pickerColorPointers = colorpickerTemplate.find('i'),
	              componentWidthWithToolbars = parseInt(componentSize) + 29 + (thisFormat === 'rgba' ? 15 : 0),
	              componentHeightWithToolbars = parseInt(componentSize) + 55;
	
	          $compile(colorpickerTemplate)($scope);
	          colorpickerTemplate.css('min-width', componentWidthWithToolbars + 'px');
	          sliderSaturation.css({
	            'width' : componentSizePx,
	            'height' : componentSizePx
	          });
	          sliderHue.css('height', componentSizePx);
	
	          if (withInput) {
	            var pickerColorInput = colorpickerTemplate.find('input');
	            pickerColorInput.css('width', componentSizePx);
	            pickerColorInput
	                .on('mousedown', function(event) {
	                  event.stopPropagation();
	                })
	              .on('keyup', function() {
	                var newColor = this.value;
	                elem.val(newColor);
	                if (ngModel && ngModel.$modelValue !== newColor) {
	                  $scope.$apply(ngModel.$setViewValue(newColor));
	                  update(true);
	                }
	              });
	          }
	
	          function bindMouseEvents() {
	            $document.on('mousemove', mousemove);
	            $document.on('mouseup', mouseup);
	          }
	
	          if (thisFormat === 'rgba') {
	            colorpickerTemplate.addClass('alpha');
	            sliderAlpha = colorpickerTemplate.find('colorpicker-alpha');
	            sliderAlpha.css('height', componentSizePx);
	            sliderAlpha
	                .on('click', function(event) {
	                  Slider.setAlpha(event, fixedPosition, componentSize);
	                  mousemove(event);
	                })
	                .on('mousedown', function(event) {
	                  Slider.setAlpha(event, fixedPosition, componentSize);
	                  bindMouseEvents();
	                })
	                .on('mouseup', function(event){
	                  emitEvent('colorpicker-selected-alpha');
	                });
	          }
	
	          sliderHue
	              .on('click', function(event) {
	                Slider.setHue(event, fixedPosition, componentSize);
	                mousemove(event);
	              })
	              .on('mousedown', function(event) {
	                Slider.setHue(event, fixedPosition, componentSize);
	                bindMouseEvents();
	              })
	              .on('mouseup', function(event){
	                emitEvent('colorpicker-selected-hue');
	              });
	
	          sliderSaturation
	              .on('click', function(event) {
	                Slider.setSaturation(event, fixedPosition, componentSize);
	                mousemove(event);
	                if (angular.isDefined(attrs.colorpickerCloseOnSelect)) {
	                  hideColorpickerTemplate();
	                }
	              })
	              .on('mousedown', function(event) {
	                Slider.setSaturation(event, fixedPosition, componentSize);
	                bindMouseEvents();
	              })
	              .on('mouseup', function(event){
	                emitEvent('colorpicker-selected-saturation');
	              });
	
	          if (fixedPosition) {
	            colorpickerTemplate.addClass('colorpicker-fixed-position');
	          }
	
	          colorpickerTemplate.addClass('colorpicker-position-' + position);
	          if (inline === 'true') {
	            colorpickerTemplate.addClass('colorpicker-inline');
	          }
	
	          target.append(colorpickerTemplate);
	
	          if (ngModel) {
	            ngModel.$render = function () {
	              elem.val(ngModel.$viewValue);
	
	              update();
	            };
	          }
	
	          elem.on('blur keyup change', function() {
	            update();
	          });
	
	          elem.on('$destroy', function() {
	            colorpickerTemplate.remove();
	          });
	
	          function previewColor() {
	            try {
	              colorpickerPreview.css('backgroundColor', pickerColor[thisFormat]());
	            } catch (e) {
	              colorpickerPreview.css('backgroundColor', pickerColor.toHex());
	            }
	            sliderSaturation.css('backgroundColor', pickerColor.toHex(pickerColor.value.h, 1, 1, 1));
	            if (thisFormat === 'rgba') {
	              sliderAlpha.css.backgroundColor = pickerColor.toHex();
	            }
	          }
	
	          function mousemove(event) {
	            var
	                left = Slider.getLeftPosition(event),
	                top = Slider.getTopPosition(event),
	                slider = Slider.getSlider();
	
	            Slider.setKnob(top, left);
	
	            if (slider.callLeft) {
	              pickerColor[slider.callLeft].call(pickerColor, left / componentSize);
	            }
	            if (slider.callTop) {
	              pickerColor[slider.callTop].call(pickerColor, top / componentSize);
	            }
	            previewColor();
	            var newColor = pickerColor[thisFormat]();
	            elem.val(newColor);
	            if (ngModel) {
	              $scope.$apply(ngModel.$setViewValue(newColor));
	            }
	            if (withInput) {
	              pickerColorInput.val(newColor);
	            }
	            return false;
	          }
	
	          function mouseup() {
	            emitEvent('colorpicker-selected');
	            $document.off('mousemove', mousemove);
	            $document.off('mouseup', mouseup);
	          }
	
	          function update(omitInnerInput) {
	            pickerColor.value = colorpickerValue;
	            pickerColor.setColor(elem.val());
	            if (withInput && !omitInnerInput) {
	              pickerColorInput.val(elem.val());
	            }
	            pickerColorPointers.eq(0).css({
	              left: pickerColor.value.s * componentSize + 'px',
	              top: componentSize - pickerColor.value.b * componentSize + 'px'
	            });
	            pickerColorPointers.eq(1).css('top', componentSize * (1 - pickerColor.value.h) + 'px');
	            pickerColorPointers.eq(2).css('top', componentSize * (1 - pickerColor.value.a) + 'px');
	            colorpickerValue = pickerColor.value;
	            previewColor();
	          }
	
	          function getColorpickerTemplatePosition() {
	            var
	                positionValue,
	                positionOffset = Helper.getOffset(elem[0]),
	                additionalSpaceBetweenElements = 2;
	
	            if(angular.isDefined(attrs.colorpickerParent)) {
	              positionOffset.left = 0;
	              positionOffset.top = 0;
	            }
	
	            if (position === 'top') {
	              positionValue =  {
	                'top': positionOffset.top - componentHeightWithToolbars - additionalSpaceBetweenElements,
	                'left': positionOffset.left
	              };
	            } else if (position === 'right') {
	              positionValue = {
	                'top': positionOffset.top,
	                'left': positionOffset.left + elem[0].offsetWidth + additionalSpaceBetweenElements
	              };
	            } else if (position === 'bottom') {
	              positionValue = {
	                'top': positionOffset.top + elem[0].offsetHeight + additionalSpaceBetweenElements,
	                'left': positionOffset.left
	              };
	            } else if (position === 'left') {
	              positionValue = {
	                'top': positionOffset.top,
	                'left': positionOffset.left - componentWidthWithToolbars - additionalSpaceBetweenElements
	              };
	            }
	            return {
	              'top': positionValue.top + 'px',
	              'left': positionValue.left + 'px'
	            };
	          }
	
	          function documentMousedownHandler() {
	            hideColorpickerTemplate();
	          }
	
	          function showColorpickerTemplate() {
	
	            if (!colorpickerTemplate.hasClass('colorpicker-visible')) {
	              update();
	              colorpickerTemplate
	                .addClass('colorpicker-visible')
	                .css(getColorpickerTemplatePosition());
	              emitEvent('colorpicker-shown');
	
	              if (inline === false) {
	                // register global mousedown event to hide the colorpicker
	                $document.on('mousedown', documentMousedownHandler);
	              }
	
	              if (attrs.colorpickerIsOpen) {
	                $scope[attrs.colorpickerIsOpen] = true;
	                if (!$scope.$$phase || !$scope.$root.$$phase) {
	                  $scope.$digest(); //trigger the watcher to fire
	                }
	              }
	            }
	          }
	
	          if (inline === false) {
	            elem.on('click', showColorpickerTemplate);
	          } else {
	            showColorpickerTemplate();
	          }
	
	          colorpickerTemplate.on('mousedown', function (event) {
	            event.stopPropagation();
	            event.preventDefault();
	          });
	
	          function emitEvent(name) {
	            if (ngModel) {
	              $scope.$emit(name, {
	                name: attrs.ngModel,
	                value: ngModel.$modelValue
	              });
	            }
	          }
	
	          function hideColorpickerTemplate() {
	            if (colorpickerTemplate.hasClass('colorpicker-visible')) {
	              colorpickerTemplate.removeClass('colorpicker-visible');
	              emitEvent('colorpicker-closed');
	              // unregister the global mousedown event
	              $document.off('mousedown', documentMousedownHandler);
	
	              if (attrs.colorpickerIsOpen) {
	                $scope[attrs.colorpickerIsOpen] = false;
	                if (!$scope.$$phase || !$scope.$root.$$phase) {
	                  $scope.$digest(); //trigger the watcher to fire
	                }
	              }
	            }
	          }
	
	          colorpickerTemplate.find('button').on('click', function () {
	            hideColorpickerTemplate();
	          });
	
	          if (attrs.colorpickerIsOpen) {
	            $scope.$watch(attrs.colorpickerIsOpen, function(shouldBeOpen) {
	
	              if (shouldBeOpen === true) {
	                showColorpickerTemplate();
	              } else if (shouldBeOpen === false) {
	                hideColorpickerTemplate();
	              }
	
	            });
	          }
	        }
	      };
	    }]);


/***/ }),
/* 477 */
/***/ (function(module, exports) {

	/*
	 * angular-ui-bootstrap
	 * http://angular-ui.github.io/bootstrap/
	
	 * Version: 0.14.3 - 2015-10-23
	 * License: MIT
	 */
	angular.module("ui.bootstrap",["ui.bootstrap.tpls","ui.bootstrap.collapse","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.position","ui.bootstrap.datepicker","ui.bootstrap.dropdown","ui.bootstrap.stackedMap","ui.bootstrap.modal","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]),angular.module("ui.bootstrap.tpls",["template/accordion/accordion-group.html","template/accordion/accordion.html","template/alert/alert.html","template/carousel/carousel.html","template/carousel/slide.html","template/datepicker/datepicker.html","template/datepicker/day.html","template/datepicker/month.html","template/datepicker/popup.html","template/datepicker/year.html","template/modal/backdrop.html","template/modal/window.html","template/pagination/pager.html","template/pagination/pagination.html","template/tooltip/tooltip-html-popup.html","template/tooltip/tooltip-popup.html","template/tooltip/tooltip-template-popup.html","template/popover/popover-html.html","template/popover/popover-template.html","template/popover/popover.html","template/progressbar/bar.html","template/progressbar/progress.html","template/progressbar/progressbar.html","template/rating/rating.html","template/tabs/tab.html","template/tabs/tabset.html","template/timepicker/timepicker.html","template/typeahead/typeahead-match.html","template/typeahead/typeahead-popup.html"]),angular.module("ui.bootstrap.collapse",[]).directive("uibCollapse",["$animate","$injector",function(a,b){var c=b.has("$animateCss")?b.get("$animateCss"):null;return{link:function(b,d,e){function f(){d.removeClass("collapse").addClass("collapsing").attr("aria-expanded",!0).attr("aria-hidden",!1),c?c(d,{addClass:"in",easing:"ease",to:{height:d[0].scrollHeight+"px"}}).start()["finally"](g):a.addClass(d,"in",{to:{height:d[0].scrollHeight+"px"}}).then(g)}function g(){d.removeClass("collapsing").addClass("collapse").css({height:"auto"})}function h(){return d.hasClass("collapse")||d.hasClass("in")?(d.css({height:d[0].scrollHeight+"px"}).removeClass("collapse").addClass("collapsing").attr("aria-expanded",!1).attr("aria-hidden",!0),void(c?c(d,{removeClass:"in",to:{height:"0"}}).start()["finally"](i):a.removeClass(d,"in",{to:{height:"0"}}).then(i))):i()}function i(){d.css({height:"0"}),d.removeClass("collapsing").addClass("collapse")}b.$watch(e.uibCollapse,function(a){a?h():f()})}}}]),angular.module("ui.bootstrap.collapse").value("$collapseSuppressWarning",!1).directive("collapse",["$animate","$injector","$log","$collapseSuppressWarning",function(a,b,c,d){var e=b.has("$animateCss")?b.get("$animateCss"):null;return{link:function(b,f,g){function h(){f.removeClass("collapse").addClass("collapsing").attr("aria-expanded",!0).attr("aria-hidden",!1),e?e(f,{easing:"ease",to:{height:f[0].scrollHeight+"px"}}).start().done(i):a.animate(f,{},{height:f[0].scrollHeight+"px"}).then(i)}function i(){f.removeClass("collapsing").addClass("collapse in").css({height:"auto"})}function j(){return f.hasClass("collapse")||f.hasClass("in")?(f.css({height:f[0].scrollHeight+"px"}).removeClass("collapse in").addClass("collapsing").attr("aria-expanded",!1).attr("aria-hidden",!0),void(e?e(f,{to:{height:"0"}}).start().done(k):a.animate(f,{},{height:"0"}).then(k))):k()}function k(){f.css({height:"0"}),f.removeClass("collapsing").addClass("collapse")}d||c.warn("collapse is now deprecated. Use uib-collapse instead."),b.$watch(g.collapse,function(a){a?j():h()})}}}]),angular.module("ui.bootstrap.accordion",["ui.bootstrap.collapse"]).constant("uibAccordionConfig",{closeOthers:!0}).controller("UibAccordionController",["$scope","$attrs","uibAccordionConfig",function(a,b,c){this.groups=[],this.closeOthers=function(d){var e=angular.isDefined(b.closeOthers)?a.$eval(b.closeOthers):c.closeOthers;e&&angular.forEach(this.groups,function(a){a!==d&&(a.isOpen=!1)})},this.addGroup=function(a){var b=this;this.groups.push(a),a.$on("$destroy",function(c){b.removeGroup(a)})},this.removeGroup=function(a){var b=this.groups.indexOf(a);-1!==b&&this.groups.splice(b,1)}}]).directive("uibAccordion",function(){return{controller:"UibAccordionController",controllerAs:"accordion",transclude:!0,templateUrl:function(a,b){return b.templateUrl||"template/accordion/accordion.html"}}}).directive("uibAccordionGroup",function(){return{require:"^uibAccordion",transclude:!0,replace:!0,templateUrl:function(a,b){return b.templateUrl||"template/accordion/accordion-group.html"},scope:{heading:"@",isOpen:"=?",isDisabled:"=?"},controller:function(){this.setHeading=function(a){this.heading=a}},link:function(a,b,c,d){d.addGroup(a),a.openClass=c.openClass||"panel-open",a.panelClass=c.panelClass,a.$watch("isOpen",function(c){b.toggleClass(a.openClass,!!c),c&&d.closeOthers(a)}),a.toggleOpen=function(b){a.isDisabled||b&&32!==b.which||(a.isOpen=!a.isOpen)}}}}).directive("uibAccordionHeading",function(){return{transclude:!0,template:"",replace:!0,require:"^uibAccordionGroup",link:function(a,b,c,d,e){d.setHeading(e(a,angular.noop))}}}).directive("uibAccordionTransclude",function(){return{require:["?^uibAccordionGroup","?^accordionGroup"],link:function(a,b,c,d){d=d[0]?d[0]:d[1],a.$watch(function(){return d[c.uibAccordionTransclude]},function(a){a&&(b.find("span").html(""),b.find("span").append(a))})}}}),angular.module("ui.bootstrap.accordion").value("$accordionSuppressWarning",!1).controller("AccordionController",["$scope","$attrs","$controller","$log","$accordionSuppressWarning",function(a,b,c,d,e){e||d.warn("AccordionController is now deprecated. Use UibAccordionController instead."),angular.extend(this,c("UibAccordionController",{$scope:a,$attrs:b}))}]).directive("accordion",["$log","$accordionSuppressWarning",function(a,b){return{restrict:"EA",controller:"AccordionController",controllerAs:"accordion",transclude:!0,replace:!1,templateUrl:function(a,b){return b.templateUrl||"template/accordion/accordion.html"},link:function(){b||a.warn("accordion is now deprecated. Use uib-accordion instead.")}}}]).directive("accordionGroup",["$log","$accordionSuppressWarning",function(a,b){return{require:"^accordion",restrict:"EA",transclude:!0,replace:!0,templateUrl:function(a,b){return b.templateUrl||"template/accordion/accordion-group.html"},scope:{heading:"@",isOpen:"=?",isDisabled:"=?"},controller:function(){this.setHeading=function(a){this.heading=a}},link:function(c,d,e,f){b||a.warn("accordion-group is now deprecated. Use uib-accordion-group instead."),f.addGroup(c),c.openClass=e.openClass||"panel-open",c.panelClass=e.panelClass,c.$watch("isOpen",function(a){d.toggleClass(c.openClass,!!a),a&&f.closeOthers(c)}),c.toggleOpen=function(a){c.isDisabled||a&&32!==a.which||(c.isOpen=!c.isOpen)}}}}]).directive("accordionHeading",["$log","$accordionSuppressWarning",function(a,b){return{restrict:"EA",transclude:!0,template:"",replace:!0,require:"^accordionGroup",link:function(c,d,e,f,g){b||a.warn("accordion-heading is now deprecated. Use uib-accordion-heading instead."),f.setHeading(g(c,angular.noop))}}}]).directive("accordionTransclude",["$log","$accordionSuppressWarning",function(a,b){return{require:"^accordionGroup",link:function(c,d,e,f){b||a.warn("accordion-transclude is now deprecated. Use uib-accordion-transclude instead."),c.$watch(function(){return f[e.accordionTransclude]},function(a){a&&(d.find("span").html(""),d.find("span").append(a))})}}}]),angular.module("ui.bootstrap.alert",[]).controller("UibAlertController",["$scope","$attrs","$interpolate","$timeout",function(a,b,c,d){a.closeable=!!b.close;var e=angular.isDefined(b.dismissOnTimeout)?c(b.dismissOnTimeout)(a.$parent):null;e&&d(function(){a.close()},parseInt(e,10))}]).directive("uibAlert",function(){return{controller:"UibAlertController",controllerAs:"alert",templateUrl:function(a,b){return b.templateUrl||"template/alert/alert.html"},transclude:!0,replace:!0,scope:{type:"@",close:"&"}}}),angular.module("ui.bootstrap.alert").value("$alertSuppressWarning",!1).controller("AlertController",["$scope","$attrs","$controller","$log","$alertSuppressWarning",function(a,b,c,d,e){e||d.warn("AlertController is now deprecated. Use UibAlertController instead."),angular.extend(this,c("UibAlertController",{$scope:a,$attrs:b}))}]).directive("alert",["$log","$alertSuppressWarning",function(a,b){return{controller:"AlertController",controllerAs:"alert",templateUrl:function(a,b){return b.templateUrl||"template/alert/alert.html"},transclude:!0,replace:!0,scope:{type:"@",close:"&"},link:function(){b||a.warn("alert is now deprecated. Use uib-alert instead.")}}}]),angular.module("ui.bootstrap.buttons",[]).constant("uibButtonConfig",{activeClass:"active",toggleEvent:"click"}).controller("UibButtonsController",["uibButtonConfig",function(a){this.activeClass=a.activeClass||"active",this.toggleEvent=a.toggleEvent||"click"}]).directive("uibBtnRadio",function(){return{require:["uibBtnRadio","ngModel"],controller:"UibButtonsController",controllerAs:"buttons",link:function(a,b,c,d){var e=d[0],f=d[1];b.find("input").css({display:"none"}),f.$render=function(){b.toggleClass(e.activeClass,angular.equals(f.$modelValue,a.$eval(c.uibBtnRadio)))},b.on(e.toggleEvent,function(){if(!c.disabled){var d=b.hasClass(e.activeClass);(!d||angular.isDefined(c.uncheckable))&&a.$apply(function(){f.$setViewValue(d?null:a.$eval(c.uibBtnRadio)),f.$render()})}})}}}).directive("uibBtnCheckbox",function(){return{require:["uibBtnCheckbox","ngModel"],controller:"UibButtonsController",controllerAs:"button",link:function(a,b,c,d){function e(){return g(c.btnCheckboxTrue,!0)}function f(){return g(c.btnCheckboxFalse,!1)}function g(b,c){return angular.isDefined(b)?a.$eval(b):c}var h=d[0],i=d[1];b.find("input").css({display:"none"}),i.$render=function(){b.toggleClass(h.activeClass,angular.equals(i.$modelValue,e()))},b.on(h.toggleEvent,function(){c.disabled||a.$apply(function(){i.$setViewValue(b.hasClass(h.activeClass)?f():e()),i.$render()})})}}}),angular.module("ui.bootstrap.buttons").value("$buttonsSuppressWarning",!1).controller("ButtonsController",["$controller","$log","$buttonsSuppressWarning",function(a,b,c){c||b.warn("ButtonsController is now deprecated. Use UibButtonsController instead."),angular.extend(this,a("UibButtonsController"))}]).directive("btnRadio",["$log","$buttonsSuppressWarning",function(a,b){return{require:["btnRadio","ngModel"],controller:"ButtonsController",controllerAs:"buttons",link:function(c,d,e,f){b||a.warn("btn-radio is now deprecated. Use uib-btn-radio instead.");var g=f[0],h=f[1];d.find("input").css({display:"none"}),h.$render=function(){d.toggleClass(g.activeClass,angular.equals(h.$modelValue,c.$eval(e.btnRadio)))},d.bind(g.toggleEvent,function(){if(!e.disabled){var a=d.hasClass(g.activeClass);(!a||angular.isDefined(e.uncheckable))&&c.$apply(function(){h.$setViewValue(a?null:c.$eval(e.btnRadio)),h.$render()})}})}}}]).directive("btnCheckbox",["$document","$log","$buttonsSuppressWarning",function(a,b,c){return{require:["btnCheckbox","ngModel"],controller:"ButtonsController",controllerAs:"button",link:function(d,e,f,g){function h(){return j(f.btnCheckboxTrue,!0)}function i(){return j(f.btnCheckboxFalse,!1)}function j(a,b){var c=d.$eval(a);return angular.isDefined(c)?c:b}c||b.warn("btn-checkbox is now deprecated. Use uib-btn-checkbox instead.");var k=g[0],l=g[1];e.find("input").css({display:"none"}),l.$render=function(){e.toggleClass(k.activeClass,angular.equals(l.$modelValue,h()))},e.bind(k.toggleEvent,function(){f.disabled||d.$apply(function(){l.$setViewValue(e.hasClass(k.activeClass)?i():h()),l.$render()})}),e.on("keypress",function(b){f.disabled||32!==b.which||a[0].activeElement!==e[0]||d.$apply(function(){l.$setViewValue(e.hasClass(k.activeClass)?i():h()),l.$render()})})}}}]),angular.module("ui.bootstrap.carousel",[]).controller("UibCarouselController",["$scope","$element","$interval","$animate",function(a,b,c,d){function e(b,c,e){s||(angular.extend(b,{direction:e,active:!0}),angular.extend(m.currentSlide||{},{direction:e,active:!1}),d.enabled()&&!a.noTransition&&!a.$currentTransition&&b.$element&&m.slides.length>1&&(b.$element.data(q,b.direction),m.currentSlide&&m.currentSlide.$element&&m.currentSlide.$element.data(q,b.direction),a.$currentTransition=!0,o?d.on("addClass",b.$element,function(b,c){"close"===c&&(a.$currentTransition=null,d.off("addClass",b))}):b.$element.one("$animate:close",function(){a.$currentTransition=null})),m.currentSlide=b,r=c,g())}function f(a){if(angular.isUndefined(n[a].index))return n[a];var b;n.length;for(b=0;b<n.length;++b)if(n[b].index==a)return n[b]}function g(){h();var b=+a.interval;!isNaN(b)&&b>0&&(k=c(i,b))}function h(){k&&(c.cancel(k),k=null)}function i(){var b=+a.interval;l&&!isNaN(b)&&b>0&&n.length?a.next():a.pause()}function j(b){b.length||(a.$currentTransition=null)}var k,l,m=this,n=m.slides=a.slides=[],o=angular.version.minor>=4,p="uib-noTransition",q="uib-slideDirection",r=-1;m.currentSlide=null;var s=!1;m.select=a.select=function(b,c){var d=a.indexOfSlide(b);void 0===c&&(c=d>m.getCurrentIndex()?"next":"prev"),b&&b!==m.currentSlide&&!a.$currentTransition&&e(b,d,c)},a.$on("$destroy",function(){s=!0}),m.getCurrentIndex=function(){return m.currentSlide&&angular.isDefined(m.currentSlide.index)?+m.currentSlide.index:r},a.indexOfSlide=function(a){return angular.isDefined(a.index)?+a.index:n.indexOf(a)},a.next=function(){var b=(m.getCurrentIndex()+1)%n.length;return 0===b&&a.noWrap()?void a.pause():m.select(f(b),"next")},a.prev=function(){var b=m.getCurrentIndex()-1<0?n.length-1:m.getCurrentIndex()-1;return a.noWrap()&&b===n.length-1?void a.pause():m.select(f(b),"prev")},a.isActive=function(a){return m.currentSlide===a},a.$watch("interval",g),a.$watchCollection("slides",j),a.$on("$destroy",h),a.play=function(){l||(l=!0,g())},a.pause=function(){a.noPause||(l=!1,h())},m.addSlide=function(b,c){b.$element=c,n.push(b),1===n.length||b.active?(m.select(n[n.length-1]),1===n.length&&a.play()):b.active=!1},m.removeSlide=function(a){angular.isDefined(a.index)&&n.sort(function(a,b){return+a.index>+b.index});var b=n.indexOf(a);n.splice(b,1),n.length>0&&a.active?b>=n.length?m.select(n[b-1]):m.select(n[b]):r>b&&r--,0===n.length&&(m.currentSlide=null)},a.$watch("noTransition",function(a){b.data(p,a)})}]).directive("uibCarousel",[function(){return{transclude:!0,replace:!0,controller:"UibCarouselController",controllerAs:"carousel",require:"carousel",templateUrl:function(a,b){return b.templateUrl||"template/carousel/carousel.html"},scope:{interval:"=",noTransition:"=",noPause:"=",noWrap:"&"}}}]).directive("uibSlide",function(){return{require:"^uibCarousel",restrict:"EA",transclude:!0,replace:!0,templateUrl:function(a,b){return b.templateUrl||"template/carousel/slide.html"},scope:{active:"=?",actual:"=?",index:"=?"},link:function(a,b,c,d){d.addSlide(a,b),a.$on("$destroy",function(){d.removeSlide(a)}),a.$watch("active",function(b){b&&d.select(a)})}}}).animation(".item",["$injector","$animate",function(a,b){function c(a,b,c){a.removeClass(b),c&&c()}var d="uib-noTransition",e="uib-slideDirection",f=null;return a.has("$animateCss")&&(f=a.get("$animateCss")),{beforeAddClass:function(a,g,h){if("active"==g&&a.parent()&&a.parent().parent()&&!a.parent().parent().data(d)){var i=!1,j=a.data(e),k="next"==j?"left":"right",l=c.bind(this,a,k+" "+j,h);return a.addClass(j),f?f(a,{addClass:k}).start().done(l):b.addClass(a,k).then(function(){i||l(),h()}),function(){i=!0}}h()},beforeRemoveClass:function(a,g,h){if("active"===g&&a.parent()&&a.parent().parent()&&!a.parent().parent().data(d)){var i=!1,j=a.data(e),k="next"==j?"left":"right",l=c.bind(this,a,k,h);return f?f(a,{addClass:k}).start().done(l):b.addClass(a,k).then(function(){i||l(),h()}),function(){i=!0}}h()}}}]),angular.module("ui.bootstrap.carousel").value("$carouselSuppressWarning",!1).controller("CarouselController",["$scope","$element","$controller","$log","$carouselSuppressWarning",function(a,b,c,d,e){e||d.warn("CarouselController is now deprecated. Use UibCarouselController instead."),angular.extend(this,c("UibCarouselController",{$scope:a,$element:b}))}]).directive("carousel",["$log","$carouselSuppressWarning",function(a,b){return{transclude:!0,replace:!0,controller:"CarouselController",controllerAs:"carousel",require:"carousel",templateUrl:function(a,b){return b.templateUrl||"template/carousel/carousel.html"},scope:{interval:"=",noTransition:"=",noPause:"=",noWrap:"&"},link:function(){b||a.warn("carousel is now deprecated. Use uib-carousel instead.")}}}]).directive("slide",["$log","$carouselSuppressWarning",function(a,b){return{require:"^carousel",transclude:!0,replace:!0,templateUrl:function(a,b){return b.templateUrl||"template/carousel/slide.html"},scope:{active:"=?",actual:"=?",index:"=?"},link:function(c,d,e,f){b||a.warn("slide is now deprecated. Use uib-slide instead."),f.addSlide(c,d),c.$on("$destroy",function(){f.removeSlide(c)}),c.$watch("active",function(a){a&&f.select(c)})}}}]),angular.module("ui.bootstrap.dateparser",[]).service("uibDateParser",["$log","$locale","orderByFilter",function(a,b,c){function d(a){var b=[],d=a.split("");return angular.forEach(g,function(c,e){var f=a.indexOf(e);if(f>-1){a=a.split(""),d[f]="("+c.regex+")",a[f]="$";for(var g=f+1,h=f+e.length;h>g;g++)d[g]="",a[g]="$";a=a.join(""),b.push({index:f,apply:c.apply})}}),{regex:new RegExp("^"+d.join("")+"$"),map:c(b,"index")}}function e(a,b,c){return 1>c?!1:1===b&&c>28?29===c&&(a%4===0&&a%100!==0||a%400===0):3===b||5===b||8===b||10===b?31>c:!0}var f,g,h=/[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;this.init=function(){f=b.id,this.parsers={},g={yyyy:{regex:"\\d{4}",apply:function(a){this.year=+a}},yy:{regex:"\\d{2}",apply:function(a){this.year=+a+2e3}},y:{regex:"\\d{1,4}",apply:function(a){this.year=+a}},MMMM:{regex:b.DATETIME_FORMATS.MONTH.join("|"),apply:function(a){this.month=b.DATETIME_FORMATS.MONTH.indexOf(a)}},MMM:{regex:b.DATETIME_FORMATS.SHORTMONTH.join("|"),apply:function(a){this.month=b.DATETIME_FORMATS.SHORTMONTH.indexOf(a)}},MM:{regex:"0[1-9]|1[0-2]",apply:function(a){this.month=a-1}},M:{regex:"[1-9]|1[0-2]",apply:function(a){this.month=a-1}},dd:{regex:"[0-2][0-9]{1}|3[0-1]{1}",apply:function(a){this.date=+a}},d:{regex:"[1-2]?[0-9]{1}|3[0-1]{1}",apply:function(a){this.date=+a}},EEEE:{regex:b.DATETIME_FORMATS.DAY.join("|")},EEE:{regex:b.DATETIME_FORMATS.SHORTDAY.join("|")},HH:{regex:"(?:0|1)[0-9]|2[0-3]",apply:function(a){this.hours=+a}},hh:{regex:"0[0-9]|1[0-2]",apply:function(a){this.hours=+a}},H:{regex:"1?[0-9]|2[0-3]",apply:function(a){this.hours=+a}},h:{regex:"[0-9]|1[0-2]",apply:function(a){this.hours=+a}},mm:{regex:"[0-5][0-9]",apply:function(a){this.minutes=+a}},m:{regex:"[0-9]|[1-5][0-9]",apply:function(a){this.minutes=+a}},sss:{regex:"[0-9][0-9][0-9]",apply:function(a){this.milliseconds=+a}},ss:{regex:"[0-5][0-9]",apply:function(a){this.seconds=+a}},s:{regex:"[0-9]|[1-5][0-9]",apply:function(a){this.seconds=+a}},a:{regex:b.DATETIME_FORMATS.AMPMS.join("|"),apply:function(a){12===this.hours&&(this.hours=0),"PM"===a&&(this.hours+=12)}}}},this.init(),this.parse=function(c,g,i){if(!angular.isString(c)||!g)return c;g=b.DATETIME_FORMATS[g]||g,g=g.replace(h,"\\$&"),b.id!==f&&this.init(),this.parsers[g]||(this.parsers[g]=d(g));var j=this.parsers[g],k=j.regex,l=j.map,m=c.match(k);if(m&&m.length){var n,o;angular.isDate(i)&&!isNaN(i.getTime())?n={year:i.getFullYear(),month:i.getMonth(),date:i.getDate(),hours:i.getHours(),minutes:i.getMinutes(),seconds:i.getSeconds(),milliseconds:i.getMilliseconds()}:(i&&a.warn("dateparser:","baseDate is not a valid date"),n={year:1900,month:0,date:1,hours:0,minutes:0,seconds:0,milliseconds:0});for(var p=1,q=m.length;q>p;p++){var r=l[p-1];r.apply&&r.apply.call(n,m[p])}return e(n.year,n.month,n.date)&&(angular.isDate(i)&&!isNaN(i.getTime())?(o=new Date(i),o.setFullYear(n.year,n.month,n.date,n.hours,n.minutes,n.seconds,n.milliseconds||0)):o=new Date(n.year,n.month,n.date,n.hours,n.minutes,n.seconds,n.milliseconds||0)),o}}}]),angular.module("ui.bootstrap.dateparser").value("$dateParserSuppressWarning",!1).service("dateParser",["$log","$dateParserSuppressWarning","uibDateParser",function(a,b,c){b||a.warn("dateParser is now deprecated. Use uibDateParser instead."),angular.extend(this,c)}]),angular.module("ui.bootstrap.position",[]).factory("$uibPosition",["$document","$window",function(a,b){function c(a,c){return a.currentStyle?a.currentStyle[c]:b.getComputedStyle?b.getComputedStyle(a)[c]:a.style[c]}function d(a){return"static"===(c(a,"position")||"static")}var e=function(b){for(var c=a[0],e=b.offsetParent||c;e&&e!==c&&d(e);)e=e.offsetParent;return e||c};return{position:function(b){var c=this.offset(b),d={top:0,left:0},f=e(b[0]);f!=a[0]&&(d=this.offset(angular.element(f)),d.top+=f.clientTop-f.scrollTop,d.left+=f.clientLeft-f.scrollLeft);var g=b[0].getBoundingClientRect();return{width:g.width||b.prop("offsetWidth"),height:g.height||b.prop("offsetHeight"),top:c.top-d.top,left:c.left-d.left}},offset:function(c){var d=c[0].getBoundingClientRect();return{width:d.width||c.prop("offsetWidth"),height:d.height||c.prop("offsetHeight"),top:d.top+(b.pageYOffset||a[0].documentElement.scrollTop),left:d.left+(b.pageXOffset||a[0].documentElement.scrollLeft)}},positionElements:function(a,b,c,d){var e,f,g,h,i=c.split("-"),j=i[0],k=i[1]||"center";e=d?this.offset(a):this.position(a),f=b.prop("offsetWidth"),g=b.prop("offsetHeight");var l={center:function(){return e.left+e.width/2-f/2},left:function(){return e.left},right:function(){return e.left+e.width}},m={center:function(){return e.top+e.height/2-g/2},top:function(){return e.top},bottom:function(){return e.top+e.height}};switch(j){case"right":h={top:m[k](),left:l[j]()};break;case"left":h={top:m[k](),left:e.left-f};break;case"bottom":h={top:m[j](),left:l[k]()};break;default:h={top:e.top-g,left:l[k]()}}return h}}}]),angular.module("ui.bootstrap.position").value("$positionSuppressWarning",!1).service("$position",["$log","$positionSuppressWarning","$uibPosition",function(a,b,c){b||a.warn("$position is now deprecated. Use $uibPosition instead."),angular.extend(this,c)}]),angular.module("ui.bootstrap.datepicker",["ui.bootstrap.dateparser","ui.bootstrap.position"]).value("$datepickerSuppressError",!1).constant("uibDatepickerConfig",{formatDay:"dd",formatMonth:"MMMM",formatYear:"yyyy",formatDayHeader:"EEE",formatDayTitle:"MMMM yyyy",formatMonthTitle:"yyyy",datepickerMode:"day",minMode:"day",maxMode:"year",showWeeks:!0,startingDay:0,yearRange:20,minDate:null,maxDate:null,shortcutPropagation:!1}).controller("UibDatepickerController",["$scope","$attrs","$parse","$interpolate","$log","dateFilter","uibDatepickerConfig","$datepickerSuppressError",function(a,b,c,d,e,f,g,h){var i=this,j={$setViewValue:angular.noop};this.modes=["day","month","year"],angular.forEach(["formatDay","formatMonth","formatYear","formatDayHeader","formatDayTitle","formatMonthTitle","showWeeks","startingDay","yearRange","shortcutPropagation"],function(c,e){i[c]=angular.isDefined(b[c])?6>e?d(b[c])(a.$parent):a.$parent.$eval(b[c]):g[c]}),angular.forEach(["minDate","maxDate"],function(d){b[d]?a.$parent.$watch(c(b[d]),function(a){i[d]=a?new Date(a):null,i.refreshView()}):i[d]=g[d]?new Date(g[d]):null}),angular.forEach(["minMode","maxMode"],function(d){b[d]?a.$parent.$watch(c(b[d]),function(c){i[d]=angular.isDefined(c)?c:b[d],a[d]=i[d],("minMode"==d&&i.modes.indexOf(a.datepickerMode)<i.modes.indexOf(i[d])||"maxMode"==d&&i.modes.indexOf(a.datepickerMode)>i.modes.indexOf(i[d]))&&(a.datepickerMode=i[d])}):(i[d]=g[d]||null,a[d]=i[d])}),a.datepickerMode=a.datepickerMode||g.datepickerMode,a.uniqueId="datepicker-"+a.$id+"-"+Math.floor(1e4*Math.random()),angular.isDefined(b.initDate)?(this.activeDate=a.$parent.$eval(b.initDate)||new Date,a.$parent.$watch(b.initDate,function(a){a&&(j.$isEmpty(j.$modelValue)||j.$invalid)&&(i.activeDate=a,i.refreshView())})):this.activeDate=new Date,a.isActive=function(b){return 0===i.compare(b.date,i.activeDate)?(a.activeDateId=b.uid,!0):!1},this.init=function(a){j=a,j.$render=function(){i.render()}},this.render=function(){if(j.$viewValue){var a=new Date(j.$viewValue),b=!isNaN(a);b?this.activeDate=a:h||e.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.')}this.refreshView()},this.refreshView=function(){if(this.element){this._refreshView();var a=j.$viewValue?new Date(j.$viewValue):null;j.$setValidity("dateDisabled",!a||this.element&&!this.isDisabled(a))}},this.createDateObject=function(a,b){var c=j.$viewValue?new Date(j.$viewValue):null;return{date:a,label:f(a,b),selected:c&&0===this.compare(a,c),disabled:this.isDisabled(a),current:0===this.compare(a,new Date),customClass:this.customClass(a)}},this.isDisabled=function(c){return this.minDate&&this.compare(c,this.minDate)<0||this.maxDate&&this.compare(c,this.maxDate)>0||b.dateDisabled&&a.dateDisabled({date:c,mode:a.datepickerMode})},this.customClass=function(b){return a.customClass({date:b,mode:a.datepickerMode})},this.split=function(a,b){for(var c=[];a.length>0;)c.push(a.splice(0,b));return c},a.select=function(b){if(a.datepickerMode===i.minMode){var c=j.$viewValue?new Date(j.$viewValue):new Date(0,0,0,0,0,0,0);c.setFullYear(b.getFullYear(),b.getMonth(),b.getDate()),j.$setViewValue(c),j.$render()}else i.activeDate=b,a.datepickerMode=i.modes[i.modes.indexOf(a.datepickerMode)-1]},a.move=function(a){var b=i.activeDate.getFullYear()+a*(i.step.years||0),c=i.activeDate.getMonth()+a*(i.step.months||0);i.activeDate.setFullYear(b,c,1),i.refreshView()},a.toggleMode=function(b){b=b||1,a.datepickerMode===i.maxMode&&1===b||a.datepickerMode===i.minMode&&-1===b||(a.datepickerMode=i.modes[i.modes.indexOf(a.datepickerMode)+b])},a.keys={13:"enter",32:"space",33:"pageup",34:"pagedown",35:"end",36:"home",37:"left",38:"up",39:"right",40:"down"};var k=function(){i.element[0].focus()};a.$on("uib:datepicker.focus",k),a.keydown=function(b){var c=a.keys[b.which];if(c&&!b.shiftKey&&!b.altKey)if(b.preventDefault(),i.shortcutPropagation||b.stopPropagation(),"enter"===c||"space"===c){if(i.isDisabled(i.activeDate))return;a.select(i.activeDate)}else!b.ctrlKey||"up"!==c&&"down"!==c?(i.handleKeyDown(c,b),i.refreshView()):a.toggleMode("up"===c?1:-1)}}]).controller("UibDaypickerController",["$scope","$element","dateFilter",function(a,b,c){function d(a,b){return 1!==b||a%4!==0||a%100===0&&a%400!==0?f[b]:29}function e(a){var b=new Date(a);b.setDate(b.getDate()+4-(b.getDay()||7));var c=b.getTime();return b.setMonth(0),b.setDate(1),Math.floor(Math.round((c-b)/864e5)/7)+1}var f=[31,28,31,30,31,30,31,31,30,31,30,31];this.step={months:1},this.element=b,this.init=function(b){angular.extend(b,this),a.showWeeks=b.showWeeks,b.refreshView()},this.getDates=function(a,b){for(var c,d=new Array(b),e=new Date(a),f=0;b>f;)c=new Date(e),d[f++]=c,e.setDate(e.getDate()+1);return d},this._refreshView=function(){var b=this.activeDate.getFullYear(),d=this.activeDate.getMonth(),f=new Date(this.activeDate);f.setFullYear(b,d,1);var g=this.startingDay-f.getDay(),h=g>0?7-g:-g,i=new Date(f);h>0&&i.setDate(-h+1);for(var j=this.getDates(i,42),k=0;42>k;k++)j[k]=angular.extend(this.createDateObject(j[k],this.formatDay),{secondary:j[k].getMonth()!==d,uid:a.uniqueId+"-"+k});a.labels=new Array(7);for(var l=0;7>l;l++)a.labels[l]={abbr:c(j[l].date,this.formatDayHeader),full:c(j[l].date,"EEEE")};if(a.title=c(this.activeDate,this.formatDayTitle),a.rows=this.split(j,7),a.showWeeks){a.weekNumbers=[];for(var m=(11-this.startingDay)%7,n=a.rows.length,o=0;n>o;o++)a.weekNumbers.push(e(a.rows[o][m].date))}},this.compare=function(a,b){return new Date(a.getFullYear(),a.getMonth(),a.getDate())-new Date(b.getFullYear(),b.getMonth(),b.getDate())},this.handleKeyDown=function(a,b){var c=this.activeDate.getDate();if("left"===a)c-=1;else if("up"===a)c-=7;else if("right"===a)c+=1;else if("down"===a)c+=7;else if("pageup"===a||"pagedown"===a){var e=this.activeDate.getMonth()+("pageup"===a?-1:1);this.activeDate.setMonth(e,1),c=Math.min(d(this.activeDate.getFullYear(),this.activeDate.getMonth()),c)}else"home"===a?c=1:"end"===a&&(c=d(this.activeDate.getFullYear(),this.activeDate.getMonth()));this.activeDate.setDate(c)}}]).controller("UibMonthpickerController",["$scope","$element","dateFilter",function(a,b,c){this.step={years:1},this.element=b,this.init=function(a){angular.extend(a,this),a.refreshView()},this._refreshView=function(){for(var b,d=new Array(12),e=this.activeDate.getFullYear(),f=0;12>f;f++)b=new Date(this.activeDate),b.setFullYear(e,f,1),d[f]=angular.extend(this.createDateObject(b,this.formatMonth),{uid:a.uniqueId+"-"+f});a.title=c(this.activeDate,this.formatMonthTitle),a.rows=this.split(d,3)},this.compare=function(a,b){return new Date(a.getFullYear(),a.getMonth())-new Date(b.getFullYear(),b.getMonth())},this.handleKeyDown=function(a,b){var c=this.activeDate.getMonth();if("left"===a)c-=1;else if("up"===a)c-=3;else if("right"===a)c+=1;else if("down"===a)c+=3;else if("pageup"===a||"pagedown"===a){var d=this.activeDate.getFullYear()+("pageup"===a?-1:1);this.activeDate.setFullYear(d)}else"home"===a?c=0:"end"===a&&(c=11);this.activeDate.setMonth(c)}}]).controller("UibYearpickerController",["$scope","$element","dateFilter",function(a,b,c){function d(a){return parseInt((a-1)/e,10)*e+1}var e;this.element=b,this.yearpickerInit=function(){e=this.yearRange,this.step={years:e}},this._refreshView=function(){for(var b,c=new Array(e),f=0,g=d(this.activeDate.getFullYear());e>f;f++)b=new Date(this.activeDate),b.setFullYear(g+f,0,1),c[f]=angular.extend(this.createDateObject(b,this.formatYear),{uid:a.uniqueId+"-"+f});a.title=[c[0].label,c[e-1].label].join(" - "),a.rows=this.split(c,5)},this.compare=function(a,b){return a.getFullYear()-b.getFullYear()},this.handleKeyDown=function(a,b){var c=this.activeDate.getFullYear();"left"===a?c-=1:"up"===a?c-=5:"right"===a?c+=1:"down"===a?c+=5:"pageup"===a||"pagedown"===a?c+=("pageup"===a?-1:1)*this.step.years:"home"===a?c=d(this.activeDate.getFullYear()):"end"===a&&(c=d(this.activeDate.getFullYear())+e-1),this.activeDate.setFullYear(c)}}]).directive("uibDatepicker",function(){return{replace:!0,templateUrl:function(a,b){return b.templateUrl||"template/datepicker/datepicker.html"},scope:{datepickerMode:"=?",dateDisabled:"&",customClass:"&",shortcutPropagation:"&?"},require:["uibDatepicker","^ngModel"],controller:"UibDatepickerController",controllerAs:"datepicker",link:function(a,b,c,d){var e=d[0],f=d[1];e.init(f)}}}).directive("uibDaypicker",function(){return{replace:!0,templateUrl:function(a,b){return b.templateUrl||"template/datepicker/day.html"},require:["^?uibDatepicker","uibDaypicker","^?datepicker"],controller:"UibDaypickerController",link:function(a,b,c,d){var e=d[0]||d[2],f=d[1];f.init(e)}}}).directive("uibMonthpicker",function(){return{replace:!0,templateUrl:function(a,b){return b.templateUrl||"template/datepicker/month.html"},require:["^?uibDatepicker","uibMonthpicker","^?datepicker"],controller:"UibMonthpickerController",link:function(a,b,c,d){var e=d[0]||d[2],f=d[1];f.init(e)}}}).directive("uibYearpicker",function(){return{replace:!0,templateUrl:function(a,b){return b.templateUrl||"template/datepicker/year.html"},require:["^?uibDatepicker","uibYearpicker","^?datepicker"],controller:"UibYearpickerController",link:function(a,b,c,d){var e=d[0]||d[2];angular.extend(e,d[1]),e.yearpickerInit(),e.refreshView()}}}).constant("uibDatepickerPopupConfig",{datepickerPopup:"yyyy-MM-dd",datepickerPopupTemplateUrl:"template/datepicker/popup.html",datepickerTemplateUrl:"template/datepicker/datepicker.html",html5Types:{date:"yyyy-MM-dd","datetime-local":"yyyy-MM-ddTHH:mm:ss.sss",month:"yyyy-MM"},currentText:"Today",clearText:"Clear",closeText:"Done",closeOnDateSelection:!0,appendToBody:!1,showButtonBar:!0,onOpenFocus:!0}).controller("UibDatepickerPopupController",["$scope","$element","$attrs","$compile","$parse","$document","$rootScope","$uibPosition","dateFilter","uibDateParser","uibDatepickerPopupConfig","$timeout",function(a,b,c,d,e,f,g,h,i,j,k,l){
	function m(a){return a.replace(/([A-Z])/g,function(a){return"-"+a.toLowerCase()})}function n(b){if(angular.isNumber(b)&&(b=new Date(b)),b){if(angular.isDate(b)&&!isNaN(b))return b;if(angular.isString(b)){var c=j.parse(b,r,a.date);return isNaN(c)?void 0:c}return void 0}return null}function o(a,b){var d=a||b;if(!c.ngRequired&&!d)return!0;if(angular.isNumber(d)&&(d=new Date(d)),d){if(angular.isDate(d)&&!isNaN(d))return!0;if(angular.isString(d)){var e=j.parse(d,r);return!isNaN(e)}return!1}return!0}function p(c){var d=A[0],e=b[0].contains(c.target),f=void 0!==d.contains&&d.contains(c.target);!a.isOpen||e||f||a.$apply(function(){a.isOpen=!1})}function q(c){27===c.which&&a.isOpen?(c.preventDefault(),c.stopPropagation(),a.$apply(function(){a.isOpen=!1}),b[0].focus()):40!==c.which||a.isOpen||(c.preventDefault(),c.stopPropagation(),a.$apply(function(){a.isOpen=!0}))}var r,s,t,u,v,w,x,y,z,A,B={},C=!1;a.watchData={},this.init=function(h){if(z=h,s=angular.isDefined(c.closeOnDateSelection)?a.$parent.$eval(c.closeOnDateSelection):k.closeOnDateSelection,t=angular.isDefined(c.datepickerAppendToBody)?a.$parent.$eval(c.datepickerAppendToBody):k.appendToBody,u=angular.isDefined(c.onOpenFocus)?a.$parent.$eval(c.onOpenFocus):k.onOpenFocus,v=angular.isDefined(c.datepickerPopupTemplateUrl)?c.datepickerPopupTemplateUrl:k.datepickerPopupTemplateUrl,w=angular.isDefined(c.datepickerTemplateUrl)?c.datepickerTemplateUrl:k.datepickerTemplateUrl,a.showButtonBar=angular.isDefined(c.showButtonBar)?a.$parent.$eval(c.showButtonBar):k.showButtonBar,k.html5Types[c.type]?(r=k.html5Types[c.type],C=!0):(r=c.datepickerPopup||c.uibDatepickerPopup||k.datepickerPopup,c.$observe("uibDatepickerPopup",function(a,b){var c=a||k.datepickerPopup;if(c!==r&&(r=c,z.$modelValue=null,!r))throw new Error("uibDatepickerPopup must have a date format specified.")})),!r)throw new Error("uibDatepickerPopup must have a date format specified.");if(C&&c.datepickerPopup)throw new Error("HTML5 date input types do not support custom formats.");if(x=angular.element("<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>"),x.attr({"ng-model":"date","ng-change":"dateSelection(date)","template-url":v}),y=angular.element(x.children()[0]),y.attr("template-url",w),C&&"month"===c.type&&(y.attr("datepicker-mode",'"month"'),y.attr("min-mode","month")),c.datepickerOptions){var l=a.$parent.$eval(c.datepickerOptions);l&&l.initDate&&(a.initDate=l.initDate,y.attr("init-date","initDate"),delete l.initDate),angular.forEach(l,function(a,b){y.attr(m(b),a)})}angular.forEach(["minMode","maxMode","minDate","maxDate","datepickerMode","initDate","shortcutPropagation"],function(b){if(c[b]){var d=e(c[b]);if(a.$parent.$watch(d,function(c){a.watchData[b]=c,("minDate"===b||"maxDate"===b)&&(B[b]=new Date(c))}),y.attr(m(b),"watchData."+b),"datepickerMode"===b){var f=d.assign;a.$watch("watchData."+b,function(b,c){angular.isFunction(f)&&b!==c&&f(a.$parent,b)})}}}),c.dateDisabled&&y.attr("date-disabled","dateDisabled({ date: date, mode: mode })"),c.showWeeks&&y.attr("show-weeks",c.showWeeks),c.customClass&&y.attr("custom-class","customClass({ date: date, mode: mode })"),C?z.$formatters.push(function(b){return a.date=b,b}):(z.$$parserName="date",z.$validators.date=o,z.$parsers.unshift(n),z.$formatters.push(function(b){return a.date=b,z.$isEmpty(b)?b:i(b,r)})),z.$viewChangeListeners.push(function(){a.date=j.parse(z.$viewValue,r,a.date)}),b.bind("keydown",q),A=d(x)(a),x.remove(),t?f.find("body").append(A):b.after(A),a.$on("$destroy",function(){a.isOpen===!0&&(g.$$phase||a.$apply(function(){a.isOpen=!1})),A.remove(),b.unbind("keydown",q),f.unbind("click",p)})},a.getText=function(b){return a[b+"Text"]||k[b+"Text"]},a.isDisabled=function(b){return"today"===b&&(b=new Date),a.watchData.minDate&&a.compare(b,B.minDate)<0||a.watchData.maxDate&&a.compare(b,B.maxDate)>0},a.compare=function(a,b){return new Date(a.getFullYear(),a.getMonth(),a.getDate())-new Date(b.getFullYear(),b.getMonth(),b.getDate())},a.dateSelection=function(c){angular.isDefined(c)&&(a.date=c);var d=a.date?i(a.date,r):null;b.val(d),z.$setViewValue(d),s&&(a.isOpen=!1,b[0].focus())},a.keydown=function(c){27===c.which&&(a.isOpen=!1,b[0].focus())},a.select=function(b){if("today"===b){var c=new Date;angular.isDate(a.date)?(b=new Date(a.date),b.setFullYear(c.getFullYear(),c.getMonth(),c.getDate())):b=new Date(c.setHours(0,0,0,0))}a.dateSelection(b)},a.close=function(){a.isOpen=!1,b[0].focus()},a.$watch("isOpen",function(c){c?(a.position=t?h.offset(b):h.position(b),a.position.top=a.position.top+b.prop("offsetHeight"),l(function(){u&&a.$broadcast("uib:datepicker.focus"),f.bind("click",p)},0,!1)):f.unbind("click",p)})}]).directive("uibDatepickerPopup",function(){return{require:["ngModel","uibDatepickerPopup"],controller:"UibDatepickerPopupController",scope:{isOpen:"=?",currentText:"@",clearText:"@",closeText:"@",dateDisabled:"&",customClass:"&"},link:function(a,b,c,d){var e=d[0],f=d[1];f.init(e)}}}).directive("uibDatepickerPopupWrap",function(){return{replace:!0,transclude:!0,templateUrl:function(a,b){return b.templateUrl||"template/datepicker/popup.html"}}}),angular.module("ui.bootstrap.datepicker").value("$datepickerSuppressWarning",!1).controller("DatepickerController",["$scope","$attrs","$parse","$interpolate","$log","dateFilter","uibDatepickerConfig","$datepickerSuppressError","$datepickerSuppressWarning",function(a,b,c,d,e,f,g,h,i){i||e.warn("DatepickerController is now deprecated. Use UibDatepickerController instead.");var j=this,k={$setViewValue:angular.noop};this.modes=["day","month","year"],angular.forEach(["formatDay","formatMonth","formatYear","formatDayHeader","formatDayTitle","formatMonthTitle","showWeeks","startingDay","yearRange","shortcutPropagation"],function(c,e){j[c]=angular.isDefined(b[c])?6>e?d(b[c])(a.$parent):a.$parent.$eval(b[c]):g[c]}),angular.forEach(["minDate","maxDate"],function(d){b[d]?a.$parent.$watch(c(b[d]),function(a){j[d]=a?new Date(a):null,j.refreshView()}):j[d]=g[d]?new Date(g[d]):null}),angular.forEach(["minMode","maxMode"],function(d){b[d]?a.$parent.$watch(c(b[d]),function(c){j[d]=angular.isDefined(c)?c:b[d],a[d]=j[d],("minMode"==d&&j.modes.indexOf(a.datepickerMode)<j.modes.indexOf(j[d])||"maxMode"==d&&j.modes.indexOf(a.datepickerMode)>j.modes.indexOf(j[d]))&&(a.datepickerMode=j[d])}):(j[d]=g[d]||null,a[d]=j[d])}),a.datepickerMode=a.datepickerMode||g.datepickerMode,a.uniqueId="datepicker-"+a.$id+"-"+Math.floor(1e4*Math.random()),angular.isDefined(b.initDate)?(this.activeDate=a.$parent.$eval(b.initDate)||new Date,a.$parent.$watch(b.initDate,function(a){a&&(k.$isEmpty(k.$modelValue)||k.$invalid)&&(j.activeDate=a,j.refreshView())})):this.activeDate=new Date,a.isActive=function(b){return 0===j.compare(b.date,j.activeDate)?(a.activeDateId=b.uid,!0):!1},this.init=function(a){k=a,k.$render=function(){j.render()}},this.render=function(){if(k.$viewValue){var a=new Date(k.$viewValue),b=!isNaN(a);b?this.activeDate=a:h||e.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.')}this.refreshView()},this.refreshView=function(){if(this.element){this._refreshView();var a=k.$viewValue?new Date(k.$viewValue):null;k.$setValidity("dateDisabled",!a||this.element&&!this.isDisabled(a))}},this.createDateObject=function(a,b){var c=k.$viewValue?new Date(k.$viewValue):null;return{date:a,label:f(a,b),selected:c&&0===this.compare(a,c),disabled:this.isDisabled(a),current:0===this.compare(a,new Date),customClass:this.customClass(a)}},this.isDisabled=function(c){return this.minDate&&this.compare(c,this.minDate)<0||this.maxDate&&this.compare(c,this.maxDate)>0||b.dateDisabled&&a.dateDisabled({date:c,mode:a.datepickerMode})},this.customClass=function(b){return a.customClass({date:b,mode:a.datepickerMode})},this.split=function(a,b){for(var c=[];a.length>0;)c.push(a.splice(0,b));return c},this.fixTimeZone=function(a){var b=a.getHours();a.setHours(23===b?b+2:0)},a.select=function(b){if(a.datepickerMode===j.minMode){var c=k.$viewValue?new Date(k.$viewValue):new Date(0,0,0,0,0,0,0);c.setFullYear(b.getFullYear(),b.getMonth(),b.getDate()),k.$setViewValue(c),k.$render()}else j.activeDate=b,a.datepickerMode=j.modes[j.modes.indexOf(a.datepickerMode)-1]},a.move=function(a){var b=j.activeDate.getFullYear()+a*(j.step.years||0),c=j.activeDate.getMonth()+a*(j.step.months||0);j.activeDate.setFullYear(b,c,1),j.refreshView()},a.toggleMode=function(b){b=b||1,a.datepickerMode===j.maxMode&&1===b||a.datepickerMode===j.minMode&&-1===b||(a.datepickerMode=j.modes[j.modes.indexOf(a.datepickerMode)+b])},a.keys={13:"enter",32:"space",33:"pageup",34:"pagedown",35:"end",36:"home",37:"left",38:"up",39:"right",40:"down"};var l=function(){j.element[0].focus()};a.$on("uib:datepicker.focus",l),a.keydown=function(b){var c=a.keys[b.which];if(c&&!b.shiftKey&&!b.altKey)if(b.preventDefault(),j.shortcutPropagation||b.stopPropagation(),"enter"===c||"space"===c){if(j.isDisabled(j.activeDate))return;a.select(j.activeDate)}else!b.ctrlKey||"up"!==c&&"down"!==c?(j.handleKeyDown(c,b),j.refreshView()):a.toggleMode("up"===c?1:-1)}}]).directive("datepicker",["$log","$datepickerSuppressWarning",function(a,b){return{replace:!0,templateUrl:function(a,b){return b.templateUrl||"template/datepicker/datepicker.html"},scope:{datepickerMode:"=?",dateDisabled:"&",customClass:"&",shortcutPropagation:"&?"},require:["datepicker","^ngModel"],controller:"DatepickerController",controllerAs:"datepicker",link:function(c,d,e,f){b||a.warn("datepicker is now deprecated. Use uib-datepicker instead.");var g=f[0],h=f[1];g.init(h)}}}]).directive("daypicker",["$log","$datepickerSuppressWarning",function(a,b){return{replace:!0,templateUrl:"template/datepicker/day.html",require:["^datepicker","daypicker"],controller:"UibDaypickerController",link:function(c,d,e,f){b||a.warn("daypicker is now deprecated. Use uib-daypicker instead.");var g=f[0],h=f[1];h.init(g)}}}]).directive("monthpicker",["$log","$datepickerSuppressWarning",function(a,b){return{replace:!0,templateUrl:"template/datepicker/month.html",require:["^datepicker","monthpicker"],controller:"UibMonthpickerController",link:function(c,d,e,f){b||a.warn("monthpicker is now deprecated. Use uib-monthpicker instead.");var g=f[0],h=f[1];h.init(g)}}}]).directive("yearpicker",["$log","$datepickerSuppressWarning",function(a,b){return{replace:!0,templateUrl:"template/datepicker/year.html",require:["^datepicker","yearpicker"],controller:"UibYearpickerController",link:function(c,d,e,f){b||a.warn("yearpicker is now deprecated. Use uib-yearpicker instead.");var g=f[0];angular.extend(g,f[1]),g.yearpickerInit(),g.refreshView()}}}]).directive("datepickerPopup",["$log","$datepickerSuppressWarning",function(a,b){return{require:["ngModel","datepickerPopup"],controller:"UibDatepickerPopupController",scope:{isOpen:"=?",currentText:"@",clearText:"@",closeText:"@",dateDisabled:"&",customClass:"&"},link:function(c,d,e,f){b||a.warn("datepicker-popup is now deprecated. Use uib-datepicker-popup instead.");var g=f[0],h=f[1];h.init(g)}}}]).directive("datepickerPopupWrap",["$log","$datepickerSuppressWarning",function(a,b){return{replace:!0,transclude:!0,templateUrl:function(a,b){return b.templateUrl||"template/datepicker/popup.html"},link:function(){b||a.warn("datepicker-popup-wrap is now deprecated. Use uib-datepicker-popup-wrap instead.")}}}]),angular.module("ui.bootstrap.dropdown",["ui.bootstrap.position"]).constant("uibDropdownConfig",{openClass:"open"}).service("uibDropdownService",["$document","$rootScope",function(a,b){var c=null;this.open=function(b){c||(a.bind("click",d),a.bind("keydown",e)),c&&c!==b&&(c.isOpen=!1),c=b},this.close=function(b){c===b&&(c=null,a.unbind("click",d),a.unbind("keydown",e))};var d=function(a){if(c&&(!a||"disabled"!==c.getAutoClose())){var d=c.getToggleElement();if(!(a&&d&&d[0].contains(a.target))){var e=c.getDropdownElement();a&&"outsideClick"===c.getAutoClose()&&e&&e[0].contains(a.target)||(c.isOpen=!1,b.$$phase||c.$apply())}}},e=function(a){27===a.which?(c.focusToggleElement(),d()):c.isKeynavEnabled()&&/(38|40)/.test(a.which)&&c.isOpen&&(a.preventDefault(),a.stopPropagation(),c.focusDropdownEntry(a.which))}}]).controller("UibDropdownController",["$scope","$element","$attrs","$parse","uibDropdownConfig","uibDropdownService","$animate","$uibPosition","$document","$compile","$templateRequest",function(a,b,c,d,e,f,g,h,i,j,k){var l,m,n=this,o=a.$new(),p=e.openClass,q=angular.noop,r=c.onToggle?d(c.onToggle):angular.noop,s=!1,t=!1;b.addClass("dropdown"),this.init=function(){c.isOpen&&(m=d(c.isOpen),q=m.assign,a.$watch(m,function(a){o.isOpen=!!a})),s=angular.isDefined(c.dropdownAppendToBody),t=angular.isDefined(c.uibKeyboardNav),s&&n.dropdownMenu&&(i.find("body").append(n.dropdownMenu),b.on("$destroy",function(){n.dropdownMenu.remove()}))},this.toggle=function(a){return o.isOpen=arguments.length?!!a:!o.isOpen},this.isOpen=function(){return o.isOpen},o.getToggleElement=function(){return n.toggleElement},o.getAutoClose=function(){return c.autoClose||"always"},o.getElement=function(){return b},o.isKeynavEnabled=function(){return t},o.focusDropdownEntry=function(a){var c=n.dropdownMenu?angular.element(n.dropdownMenu).find("a"):angular.element(b).find("ul").eq(0).find("a");switch(a){case 40:angular.isNumber(n.selectedOption)?n.selectedOption=n.selectedOption===c.length-1?n.selectedOption:n.selectedOption+1:n.selectedOption=0;break;case 38:angular.isNumber(n.selectedOption)?n.selectedOption=0===n.selectedOption?0:n.selectedOption-1:n.selectedOption=c.length-1}c[n.selectedOption].focus()},o.getDropdownElement=function(){return n.dropdownMenu},o.focusToggleElement=function(){n.toggleElement&&n.toggleElement[0].focus()},o.$watch("isOpen",function(c,d){if(s&&n.dropdownMenu){var e=h.positionElements(b,n.dropdownMenu,"bottom-left",!0),i={top:e.top+"px",display:c?"block":"none"},m=n.dropdownMenu.hasClass("dropdown-menu-right");m?(i.left="auto",i.right=window.innerWidth-(e.left+b.prop("offsetWidth"))+"px"):(i.left=e.left+"px",i.right="auto"),n.dropdownMenu.css(i)}if(g[c?"addClass":"removeClass"](b,p).then(function(){angular.isDefined(c)&&c!==d&&r(a,{open:!!c})}),c)n.dropdownMenuTemplateUrl&&k(n.dropdownMenuTemplateUrl).then(function(a){l=o.$new(),j(a.trim())(l,function(a){var b=a;n.dropdownMenu.replaceWith(b),n.dropdownMenu=b})}),o.focusToggleElement(),f.open(o);else{if(n.dropdownMenuTemplateUrl){l&&l.$destroy();var t=angular.element('<ul class="dropdown-menu"></ul>');n.dropdownMenu.replaceWith(t),n.dropdownMenu=t}f.close(o),n.selectedOption=null}angular.isFunction(q)&&q(a,c)}),a.$on("$locationChangeSuccess",function(){"disabled"!==o.getAutoClose()&&(o.isOpen=!1)});var u=a.$on("$destroy",function(){o.$destroy()});o.$on("$destroy",u)}]).directive("uibDropdown",function(){return{controller:"UibDropdownController",link:function(a,b,c,d){d.init()}}}).directive("uibDropdownMenu",function(){return{restrict:"AC",require:"?^uibDropdown",link:function(a,b,c,d){if(d&&!angular.isDefined(c.dropdownNested)){b.addClass("dropdown-menu");var e=c.templateUrl;e&&(d.dropdownMenuTemplateUrl=e),d.dropdownMenu||(d.dropdownMenu=b)}}}}).directive("uibKeyboardNav",function(){return{restrict:"A",require:"?^uibDropdown",link:function(a,b,c,d){b.bind("keydown",function(a){if(-1!==[38,40].indexOf(a.which)){a.preventDefault(),a.stopPropagation();var b=d.dropdownMenu.find("a");switch(a.which){case 40:angular.isNumber(d.selectedOption)?d.selectedOption=d.selectedOption===b.length-1?d.selectedOption:d.selectedOption+1:d.selectedOption=0;break;case 38:angular.isNumber(d.selectedOption)?d.selectedOption=0===d.selectedOption?0:d.selectedOption-1:d.selectedOption=b.length-1}b[d.selectedOption].focus()}})}}}).directive("uibDropdownToggle",function(){return{require:"?^uibDropdown",link:function(a,b,c,d){if(d){b.addClass("dropdown-toggle"),d.toggleElement=b;var e=function(e){e.preventDefault(),b.hasClass("disabled")||c.disabled||a.$apply(function(){d.toggle()})};b.bind("click",e),b.attr({"aria-haspopup":!0,"aria-expanded":!1}),a.$watch(d.isOpen,function(a){b.attr("aria-expanded",!!a)}),a.$on("$destroy",function(){b.unbind("click",e)})}}}}),angular.module("ui.bootstrap.dropdown").value("$dropdownSuppressWarning",!1).service("dropdownService",["$log","$dropdownSuppressWarning","uibDropdownService",function(a,b,c){b||a.warn("dropdownService is now deprecated. Use uibDropdownService instead."),angular.extend(this,c)}]).controller("DropdownController",["$scope","$element","$attrs","$parse","uibDropdownConfig","uibDropdownService","$animate","$uibPosition","$document","$compile","$templateRequest","$log","$dropdownSuppressWarning",function(a,b,c,d,e,f,g,h,i,j,k,l,m){m||l.warn("DropdownController is now deprecated. Use UibDropdownController instead.");var n,o,p=this,q=a.$new(),r=e.openClass,s=angular.noop,t=c.onToggle?d(c.onToggle):angular.noop,u=!1,v=!1;b.addClass("dropdown"),this.init=function(){c.isOpen&&(o=d(c.isOpen),s=o.assign,a.$watch(o,function(a){q.isOpen=!!a})),u=angular.isDefined(c.dropdownAppendToBody),v=angular.isDefined(c.uibKeyboardNav),u&&p.dropdownMenu&&(i.find("body").append(p.dropdownMenu),b.on("$destroy",function(){p.dropdownMenu.remove()}))},this.toggle=function(a){return q.isOpen=arguments.length?!!a:!q.isOpen},this.isOpen=function(){return q.isOpen},q.getToggleElement=function(){return p.toggleElement},q.getAutoClose=function(){return c.autoClose||"always"},q.getElement=function(){return b},q.isKeynavEnabled=function(){return v},q.focusDropdownEntry=function(a){var c=p.dropdownMenu?angular.element(p.dropdownMenu).find("a"):angular.element(b).find("ul").eq(0).find("a");switch(a){case 40:angular.isNumber(p.selectedOption)?p.selectedOption=p.selectedOption===c.length-1?p.selectedOption:p.selectedOption+1:p.selectedOption=0;break;case 38:angular.isNumber(p.selectedOption)?p.selectedOption=0===p.selectedOption?0:p.selectedOption-1:p.selectedOption=c.length-1}c[p.selectedOption].focus()},q.getDropdownElement=function(){return p.dropdownMenu},q.focusToggleElement=function(){p.toggleElement&&p.toggleElement[0].focus()},q.$watch("isOpen",function(c,d){if(u&&p.dropdownMenu){var e=h.positionElements(b,p.dropdownMenu,"bottom-left",!0),i={top:e.top+"px",display:c?"block":"none"},l=p.dropdownMenu.hasClass("dropdown-menu-right");l?(i.left="auto",i.right=window.innerWidth-(e.left+b.prop("offsetWidth"))+"px"):(i.left=e.left+"px",i.right="auto"),p.dropdownMenu.css(i)}if(g[c?"addClass":"removeClass"](b,r).then(function(){angular.isDefined(c)&&c!==d&&t(a,{open:!!c})}),c)p.dropdownMenuTemplateUrl&&k(p.dropdownMenuTemplateUrl).then(function(a){n=q.$new(),j(a.trim())(n,function(a){var b=a;p.dropdownMenu.replaceWith(b),p.dropdownMenu=b})}),q.focusToggleElement(),f.open(q);else{if(p.dropdownMenuTemplateUrl){n&&n.$destroy();var m=angular.element('<ul class="dropdown-menu"></ul>');p.dropdownMenu.replaceWith(m),p.dropdownMenu=m}f.close(q),p.selectedOption=null}angular.isFunction(s)&&s(a,c)}),a.$on("$locationChangeSuccess",function(){"disabled"!==q.getAutoClose()&&(q.isOpen=!1)});var w=a.$on("$destroy",function(){q.$destroy()});q.$on("$destroy",w)}]).directive("dropdown",["$log","$dropdownSuppressWarning",function(a,b){return{controller:"DropdownController",link:function(c,d,e,f){b||a.warn("dropdown is now deprecated. Use uib-dropdown instead."),f.init()}}}]).directive("dropdownMenu",["$log","$dropdownSuppressWarning",function(a,b){return{restrict:"AC",require:"?^dropdown",link:function(c,d,e,f){if(f&&!angular.isDefined(e.dropdownNested)){b||a.warn("dropdown-menu is now deprecated. Use uib-dropdown-menu instead."),d.addClass("dropdown-menu");var g=e.templateUrl;g&&(f.dropdownMenuTemplateUrl=g),f.dropdownMenu||(f.dropdownMenu=d)}}}}]).directive("keyboardNav",["$log","$dropdownSuppressWarning",function(a,b){return{restrict:"A",require:"?^dropdown",link:function(c,d,e,f){b||a.warn("keyboard-nav is now deprecated. Use uib-keyboard-nav instead."),d.bind("keydown",function(a){if(-1!==[38,40].indexOf(a.which)){a.preventDefault(),a.stopPropagation();var b=f.dropdownMenu.find("a");switch(a.which){case 40:angular.isNumber(f.selectedOption)?f.selectedOption=f.selectedOption===b.length-1?f.selectedOption:f.selectedOption+1:f.selectedOption=0;break;case 38:angular.isNumber(f.selectedOption)?f.selectedOption=0===f.selectedOption?0:f.selectedOption-1:f.selectedOption=b.length-1}b[f.selectedOption].focus()}})}}}]).directive("dropdownToggle",["$log","$dropdownSuppressWarning",function(a,b){return{require:"?^dropdown",link:function(c,d,e,f){if(b||a.warn("dropdown-toggle is now deprecated. Use uib-dropdown-toggle instead."),f){d.addClass("dropdown-toggle"),f.toggleElement=d;var g=function(a){a.preventDefault(),d.hasClass("disabled")||e.disabled||c.$apply(function(){f.toggle()})};d.bind("click",g),d.attr({"aria-haspopup":!0,"aria-expanded":!1}),c.$watch(f.isOpen,function(a){d.attr("aria-expanded",!!a)}),c.$on("$destroy",function(){d.unbind("click",g)})}}}}]),angular.module("ui.bootstrap.stackedMap",[]).factory("$$stackedMap",function(){return{createNew:function(){var a=[];return{add:function(b,c){a.push({key:b,value:c})},get:function(b){for(var c=0;c<a.length;c++)if(b==a[c].key)return a[c]},keys:function(){for(var b=[],c=0;c<a.length;c++)b.push(a[c].key);return b},top:function(){return a[a.length-1]},remove:function(b){for(var c=-1,d=0;d<a.length;d++)if(b==a[d].key){c=d;break}return a.splice(c,1)[0]},removeTop:function(){return a.splice(a.length-1,1)[0]},length:function(){return a.length}}}}}),angular.module("ui.bootstrap.modal",["ui.bootstrap.stackedMap"]).factory("$$multiMap",function(){return{createNew:function(){var a={};return{entries:function(){return Object.keys(a).map(function(b){return{key:b,value:a[b]}})},get:function(b){return a[b]},hasKey:function(b){return!!a[b]},keys:function(){return Object.keys(a)},put:function(b,c){a[b]||(a[b]=[]),a[b].push(c)},remove:function(b,c){var d=a[b];if(d){var e=d.indexOf(c);-1!==e&&d.splice(e,1),d.length||delete a[b]}}}}}}).directive("uibModalBackdrop",["$animate","$injector","$uibModalStack",function(a,b,c){function d(b,d,f){d.addClass("modal-backdrop"),f.modalInClass&&(e?e(d,{addClass:f.modalInClass}).start():a.addClass(d,f.modalInClass),b.$on(c.NOW_CLOSING_EVENT,function(b,c){var g=c();e?e(d,{removeClass:f.modalInClass}).start().then(g):a.removeClass(d,f.modalInClass).then(g)}))}var e=null;return b.has("$animateCss")&&(e=b.get("$animateCss")),{replace:!0,templateUrl:"template/modal/backdrop.html",compile:function(a,b){return a.addClass(b.backdropClass),d}}}]).directive("uibModalWindow",["$uibModalStack","$q","$animate","$injector",function(a,b,c,d){var e=null;return d.has("$animateCss")&&(e=d.get("$animateCss")),{scope:{index:"@"},replace:!0,transclude:!0,templateUrl:function(a,b){return b.templateUrl||"template/modal/window.html"},link:function(d,f,g){f.addClass(g.windowClass||""),f.addClass(g.windowTopClass||""),d.size=g.size,d.close=function(b){var c=a.getTop();c&&c.value.backdrop&&"static"!==c.value.backdrop&&b.target===b.currentTarget&&(b.preventDefault(),b.stopPropagation(),a.dismiss(c.key,"backdrop click"))},f.on("click",d.close),d.$isRendered=!0;var h=b.defer();g.$observe("modalRender",function(a){"true"==a&&h.resolve()}),h.promise.then(function(){var h=null;g.modalInClass&&(h=e?e(f,{addClass:g.modalInClass}).start():c.addClass(f,g.modalInClass),d.$on(a.NOW_CLOSING_EVENT,function(a,b){var d=b();e?e(f,{removeClass:g.modalInClass}).start().then(d):c.removeClass(f,g.modalInClass).then(d)})),b.when(h).then(function(){var a=f[0].querySelector("[autofocus]");a?a.focus():f[0].focus()});var i=a.getTop();i&&a.modalRendered(i.key)})}}}]).directive("uibModalAnimationClass",function(){return{compile:function(a,b){b.modalAnimation&&a.addClass(b.uibModalAnimationClass)}}}).directive("uibModalTransclude",function(){return{link:function(a,b,c,d,e){e(a.$parent,function(a){b.empty(),b.append(a)})}}}).factory("$uibModalStack",["$animate","$timeout","$document","$compile","$rootScope","$q","$injector","$$multiMap","$$stackedMap",function(a,b,c,d,e,f,g,h,i){function j(){for(var a=-1,b=u.keys(),c=0;c<b.length;c++)u.get(b[c]).value.backdrop&&(a=c);return a}function k(a,b){var d=c.find("body").eq(0),e=u.get(a).value;u.remove(a),n(e.modalDomEl,e.modalScope,function(){var b=e.openedClass||t;v.remove(b,a),d.toggleClass(b,v.hasKey(b)),l(!0)}),m(),b&&b.focus?b.focus():d.focus()}function l(a){var b;u.length()>0&&(b=u.top().value,b.modalDomEl.toggleClass(b.windowTopClass||"",a))}function m(){if(q&&-1==j()){var a=r;n(q,r,function(){a=null}),q=void 0,r=void 0}}function n(b,c,d){function e(){e.done||(e.done=!0,p?p(b,{event:"leave"}).start().then(function(){b.remove()}):a.leave(b),c.$destroy(),d&&d())}var g,h=null,i=function(){return g||(g=f.defer(),h=g.promise),function(){g.resolve()}};return c.$broadcast(w.NOW_CLOSING_EVENT,i),f.when(h).then(e)}function o(a,b,c){return!a.value.modalScope.$broadcast("modal.closing",b,c).defaultPrevented}var p=null;g.has("$animateCss")&&(p=g.get("$animateCss"));var q,r,s,t="modal-open",u=i.createNew(),v=h.createNew(),w={NOW_CLOSING_EVENT:"modal.stack.now-closing"},x=0,y="a[href], area[href], input:not([disabled]), button:not([disabled]),select:not([disabled]), textarea:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable=true]";return e.$watch(j,function(a){r&&(r.index=a)}),c.bind("keydown",function(a){if(a.isDefaultPrevented())return a;var b=u.top();if(b&&b.value.keyboard)switch(a.which){case 27:a.preventDefault(),e.$apply(function(){w.dismiss(b.key,"escape key press")});break;case 9:w.loadFocusElementList(b);var c=!1;a.shiftKey?w.isFocusInFirstItem(a)&&(c=w.focusLastFocusableElement()):w.isFocusInLastItem(a)&&(c=w.focusFirstFocusableElement()),c&&(a.preventDefault(),a.stopPropagation())}}),w.open=function(a,b){var f=c[0].activeElement,g=b.openedClass||t;l(!1),u.add(a,{deferred:b.deferred,renderDeferred:b.renderDeferred,modalScope:b.scope,backdrop:b.backdrop,keyboard:b.keyboard,openedClass:b.openedClass,windowTopClass:b.windowTopClass}),v.put(g,a);var h=c.find("body").eq(0),i=j();if(i>=0&&!q){r=e.$new(!0),r.index=i;var k=angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');k.attr("backdrop-class",b.backdropClass),b.animation&&k.attr("modal-animation","true"),q=d(k)(r),h.append(q)}var m=angular.element('<div uib-modal-window="modal-window"></div>');m.attr({"template-url":b.windowTemplateUrl,"window-class":b.windowClass,"window-top-class":b.windowTopClass,size:b.size,index:u.length()-1,animate:"animate"}).html(b.content),b.animation&&m.attr("modal-animation","true");var n=d(m)(b.scope);u.top().value.modalDomEl=n,u.top().value.modalOpener=f,h.append(n),h.addClass(g),w.clearFocusListCache()},w.close=function(a,b){var c=u.get(a);return c&&o(c,b,!0)?(c.value.modalScope.$$uibDestructionScheduled=!0,c.value.deferred.resolve(b),k(a,c.value.modalOpener),!0):!c},w.dismiss=function(a,b){var c=u.get(a);return c&&o(c,b,!1)?(c.value.modalScope.$$uibDestructionScheduled=!0,c.value.deferred.reject(b),k(a,c.value.modalOpener),!0):!c},w.dismissAll=function(a){for(var b=this.getTop();b&&this.dismiss(b.key,a);)b=this.getTop()},w.getTop=function(){return u.top()},w.modalRendered=function(a){var b=u.get(a);b&&b.value.renderDeferred.resolve()},w.focusFirstFocusableElement=function(){return s.length>0?(s[0].focus(),!0):!1},w.focusLastFocusableElement=function(){return s.length>0?(s[s.length-1].focus(),!0):!1},w.isFocusInFirstItem=function(a){return s.length>0?(a.target||a.srcElement)==s[0]:!1},w.isFocusInLastItem=function(a){return s.length>0?(a.target||a.srcElement)==s[s.length-1]:!1},w.clearFocusListCache=function(){s=[],x=0},w.loadFocusElementList=function(a){if((void 0===s||!s.length)&&a){var b=a.value.modalDomEl;b&&b.length&&(s=b[0].querySelectorAll(y))}},w}]).provider("$uibModal",function(){var a={options:{animation:!0,backdrop:!0,keyboard:!0},$get:["$injector","$rootScope","$q","$templateRequest","$controller","$uibModalStack","$modalSuppressWarning","$log",function(b,c,d,e,f,g,h,i){function j(a){return a.template?d.when(a.template):e(angular.isFunction(a.templateUrl)?a.templateUrl():a.templateUrl)}function k(a){var c=[];return angular.forEach(a,function(a){angular.isFunction(a)||angular.isArray(a)?c.push(d.when(b.invoke(a))):angular.isString(a)?c.push(d.when(b.get(a))):c.push(d.when(a))}),c}var l={},m=null;return l.getPromiseChain=function(){return m},l.open=function(b){function e(){return r}var l=d.defer(),n=d.defer(),o=d.defer(),p={result:l.promise,opened:n.promise,rendered:o.promise,close:function(a){return g.close(p,a)},dismiss:function(a){return g.dismiss(p,a)}};if(b=angular.extend({},a.options,b),b.resolve=b.resolve||{},!b.template&&!b.templateUrl)throw new Error("One of template or templateUrl options is required.");var q,r=d.all([j(b)].concat(k(b.resolve)));return q=m=d.all([m]).then(e,e).then(function(a){var d=(b.scope||c).$new();d.$close=p.close,d.$dismiss=p.dismiss,d.$on("$destroy",function(){d.$$uibDestructionScheduled||d.$dismiss("$uibUnscheduledDestruction")});var e,j={},k=1;b.controller&&(j.$scope=d,j.$uibModalInstance=p,Object.defineProperty(j,"$modalInstance",{get:function(){return h||i.warn("$modalInstance is now deprecated. Use $uibModalInstance instead."),p}}),angular.forEach(b.resolve,function(b,c){j[c]=a[k++]}),e=f(b.controller,j),b.controllerAs&&(b.bindToController&&angular.extend(e,d),d[b.controllerAs]=e)),g.open(p,{scope:d,deferred:l,renderDeferred:o,content:a[0],animation:b.animation,backdrop:b.backdrop,keyboard:b.keyboard,backdropClass:b.backdropClass,windowTopClass:b.windowTopClass,windowClass:b.windowClass,windowTemplateUrl:b.windowTemplateUrl,size:b.size,openedClass:b.openedClass}),n.resolve(!0)},function(a){n.reject(a),l.reject(a)})["finally"](function(){m===q&&(m=null)}),p},l}]};return a}),angular.module("ui.bootstrap.modal").value("$modalSuppressWarning",!1).directive("modalBackdrop",["$animate","$injector","$modalStack","$log","$modalSuppressWarning",function(a,b,c,d,e){function f(b,f,h){e||d.warn("modal-backdrop is now deprecated. Use uib-modal-backdrop instead."),f.addClass("modal-backdrop"),h.modalInClass&&(g?g(f,{addClass:h.modalInClass}).start():a.addClass(f,h.modalInClass),b.$on(c.NOW_CLOSING_EVENT,function(b,c){var d=c();g?g(f,{removeClass:h.modalInClass}).start().then(d):a.removeClass(f,h.modalInClass).then(d)}))}var g=null;return b.has("$animateCss")&&(g=b.get("$animateCss")),{replace:!0,templateUrl:"template/modal/backdrop.html",compile:function(a,b){return a.addClass(b.backdropClass),f}}}]).directive("modalWindow",["$modalStack","$q","$animate","$injector","$log","$modalSuppressWarning",function(a,b,c,d,e,f){var g=null;return d.has("$animateCss")&&(g=d.get("$animateCss")),{scope:{index:"@"},replace:!0,transclude:!0,templateUrl:function(a,b){return b.templateUrl||"template/modal/window.html"},link:function(d,h,i){f||e.warn("modal-window is now deprecated. Use uib-modal-window instead."),h.addClass(i.windowClass||""),h.addClass(i.windowTopClass||""),d.size=i.size,d.close=function(b){var c=a.getTop();c&&c.value.backdrop&&"static"!==c.value.backdrop&&b.target===b.currentTarget&&(b.preventDefault(),b.stopPropagation(),a.dismiss(c.key,"backdrop click"))},h.on("click",d.close),d.$isRendered=!0;var j=b.defer();i.$observe("modalRender",function(a){"true"==a&&j.resolve()}),j.promise.then(function(){var e=null;i.modalInClass&&(e=g?g(h,{addClass:i.modalInClass}).start():c.addClass(h,i.modalInClass),d.$on(a.NOW_CLOSING_EVENT,function(a,b){var d=b();g?g(h,{removeClass:i.modalInClass}).start().then(d):c.removeClass(h,i.modalInClass).then(d)})),b.when(e).then(function(){var a=h[0].querySelector("[autofocus]");a?a.focus():h[0].focus()});var f=a.getTop();f&&a.modalRendered(f.key)})}}}]).directive("modalAnimationClass",["$log","$modalSuppressWarning",function(a,b){return{compile:function(c,d){b||a.warn("modal-animation-class is now deprecated. Use uib-modal-animation-class instead."),d.modalAnimation&&c.addClass(d.modalAnimationClass)}}}]).directive("modalTransclude",["$log","$modalSuppressWarning",function(a,b){return{link:function(c,d,e,f,g){
	b||a.warn("modal-transclude is now deprecated. Use uib-modal-transclude instead."),g(c.$parent,function(a){d.empty(),d.append(a)})}}}]).service("$modalStack",["$animate","$timeout","$document","$compile","$rootScope","$q","$injector","$$multiMap","$$stackedMap","$uibModalStack","$log","$modalSuppressWarning",function(a,b,c,d,e,f,g,h,i,j,k,l){l||k.warn("$modalStack is now deprecated. Use $uibModalStack instead."),angular.extend(this,j)}]).provider("$modal",["$uibModalProvider",function(a){angular.extend(this,a),this.$get=["$injector","$log","$modalSuppressWarning",function(b,c,d){return d||c.warn("$modal is now deprecated. Use $uibModal instead."),b.invoke(a.$get)}]}]),angular.module("ui.bootstrap.pagination",[]).controller("UibPaginationController",["$scope","$attrs","$parse",function(a,b,c){var d=this,e={$setViewValue:angular.noop},f=b.numPages?c(b.numPages).assign:angular.noop;this.init=function(g,h){e=g,this.config=h,e.$render=function(){d.render()},b.itemsPerPage?a.$parent.$watch(c(b.itemsPerPage),function(b){d.itemsPerPage=parseInt(b,10),a.totalPages=d.calculateTotalPages()}):this.itemsPerPage=h.itemsPerPage,a.$watch("totalItems",function(){a.totalPages=d.calculateTotalPages()}),a.$watch("totalPages",function(b){f(a.$parent,b),a.page>b?a.selectPage(b):e.$render()})},this.calculateTotalPages=function(){var b=this.itemsPerPage<1?1:Math.ceil(a.totalItems/this.itemsPerPage);return Math.max(b||0,1)},this.render=function(){a.page=parseInt(e.$viewValue,10)||1},a.selectPage=function(b,c){c&&c.preventDefault();var d=!a.ngDisabled||!c;d&&a.page!==b&&b>0&&b<=a.totalPages&&(c&&c.target&&c.target.blur(),e.$setViewValue(b),e.$render())},a.getText=function(b){return a[b+"Text"]||d.config[b+"Text"]},a.noPrevious=function(){return 1===a.page},a.noNext=function(){return a.page===a.totalPages}}]).constant("uibPaginationConfig",{itemsPerPage:10,boundaryLinks:!1,directionLinks:!0,firstText:"First",previousText:"Previous",nextText:"Next",lastText:"Last",rotate:!0}).directive("uibPagination",["$parse","uibPaginationConfig",function(a,b){return{restrict:"EA",scope:{totalItems:"=",firstText:"@",previousText:"@",nextText:"@",lastText:"@",ngDisabled:"="},require:["uibPagination","?ngModel"],controller:"UibPaginationController",controllerAs:"pagination",templateUrl:function(a,b){return b.templateUrl||"template/pagination/pagination.html"},replace:!0,link:function(c,d,e,f){function g(a,b,c){return{number:a,text:b,active:c}}function h(a,b){var c=[],d=1,e=b,f=angular.isDefined(k)&&b>k;f&&(l?(d=Math.max(a-Math.floor(k/2),1),e=d+k-1,e>b&&(e=b,d=e-k+1)):(d=(Math.ceil(a/k)-1)*k+1,e=Math.min(d+k-1,b)));for(var h=d;e>=h;h++){var i=g(h,h,h===a);c.push(i)}if(f&&!l){if(d>1){var j=g(d-1,"...",!1);c.unshift(j)}if(b>e){var m=g(e+1,"...",!1);c.push(m)}}return c}var i=f[0],j=f[1];if(j){var k=angular.isDefined(e.maxSize)?c.$parent.$eval(e.maxSize):b.maxSize,l=angular.isDefined(e.rotate)?c.$parent.$eval(e.rotate):b.rotate;c.boundaryLinks=angular.isDefined(e.boundaryLinks)?c.$parent.$eval(e.boundaryLinks):b.boundaryLinks,c.directionLinks=angular.isDefined(e.directionLinks)?c.$parent.$eval(e.directionLinks):b.directionLinks,i.init(j,b),e.maxSize&&c.$parent.$watch(a(e.maxSize),function(a){k=parseInt(a,10),i.render()});var m=i.render;i.render=function(){m(),c.page>0&&c.page<=c.totalPages&&(c.pages=h(c.page,c.totalPages))}}}}}]).constant("uibPagerConfig",{itemsPerPage:10,previousText:"« Previous",nextText:"Next »",align:!0}).directive("uibPager",["uibPagerConfig",function(a){return{restrict:"EA",scope:{totalItems:"=",previousText:"@",nextText:"@",ngDisabled:"="},require:["uibPager","?ngModel"],controller:"UibPaginationController",controllerAs:"pagination",templateUrl:function(a,b){return b.templateUrl||"template/pagination/pager.html"},replace:!0,link:function(b,c,d,e){var f=e[0],g=e[1];g&&(b.align=angular.isDefined(d.align)?b.$parent.$eval(d.align):a.align,f.init(g,a))}}}]),angular.module("ui.bootstrap.pagination").value("$paginationSuppressWarning",!1).controller("PaginationController",["$scope","$attrs","$parse","$log","$paginationSuppressWarning",function(a,b,c,d,e){e||d.warn("PaginationController is now deprecated. Use UibPaginationController instead.");var f=this,g={$setViewValue:angular.noop},h=b.numPages?c(b.numPages).assign:angular.noop;this.init=function(d,e){g=d,this.config=e,g.$render=function(){f.render()},b.itemsPerPage?a.$parent.$watch(c(b.itemsPerPage),function(b){f.itemsPerPage=parseInt(b,10),a.totalPages=f.calculateTotalPages()}):this.itemsPerPage=e.itemsPerPage,a.$watch("totalItems",function(){a.totalPages=f.calculateTotalPages()}),a.$watch("totalPages",function(b){h(a.$parent,b),a.page>b?a.selectPage(b):g.$render()})},this.calculateTotalPages=function(){var b=this.itemsPerPage<1?1:Math.ceil(a.totalItems/this.itemsPerPage);return Math.max(b||0,1)},this.render=function(){a.page=parseInt(g.$viewValue,10)||1},a.selectPage=function(b,c){c&&c.preventDefault();var d=!a.ngDisabled||!c;d&&a.page!==b&&b>0&&b<=a.totalPages&&(c&&c.target&&c.target.blur(),g.$setViewValue(b),g.$render())},a.getText=function(b){return a[b+"Text"]||f.config[b+"Text"]},a.noPrevious=function(){return 1===a.page},a.noNext=function(){return a.page===a.totalPages}}]).directive("pagination",["$parse","uibPaginationConfig","$log","$paginationSuppressWarning",function(a,b,c,d){return{restrict:"EA",scope:{totalItems:"=",firstText:"@",previousText:"@",nextText:"@",lastText:"@",ngDisabled:"="},require:["pagination","?ngModel"],controller:"PaginationController",controllerAs:"pagination",templateUrl:function(a,b){return b.templateUrl||"template/pagination/pagination.html"},replace:!0,link:function(e,f,g,h){function i(a,b,c){return{number:a,text:b,active:c}}function j(a,b){var c=[],d=1,e=b,f=angular.isDefined(m)&&b>m;f&&(n?(d=Math.max(a-Math.floor(m/2),1),e=d+m-1,e>b&&(e=b,d=e-m+1)):(d=(Math.ceil(a/m)-1)*m+1,e=Math.min(d+m-1,b)));for(var g=d;e>=g;g++){var h=i(g,g,g===a);c.push(h)}if(f&&!n){if(d>1){var j=i(d-1,"...",!1);c.unshift(j)}if(b>e){var k=i(e+1,"...",!1);c.push(k)}}return c}d||c.warn("pagination is now deprecated. Use uib-pagination instead.");var k=h[0],l=h[1];if(l){var m=angular.isDefined(g.maxSize)?e.$parent.$eval(g.maxSize):b.maxSize,n=angular.isDefined(g.rotate)?e.$parent.$eval(g.rotate):b.rotate;e.boundaryLinks=angular.isDefined(g.boundaryLinks)?e.$parent.$eval(g.boundaryLinks):b.boundaryLinks,e.directionLinks=angular.isDefined(g.directionLinks)?e.$parent.$eval(g.directionLinks):b.directionLinks,k.init(l,b),g.maxSize&&e.$parent.$watch(a(g.maxSize),function(a){m=parseInt(a,10),k.render()});var o=k.render;k.render=function(){o(),e.page>0&&e.page<=e.totalPages&&(e.pages=j(e.page,e.totalPages))}}}}}]).directive("pager",["uibPagerConfig","$log","$paginationSuppressWarning",function(a,b,c){return{restrict:"EA",scope:{totalItems:"=",previousText:"@",nextText:"@",ngDisabled:"="},require:["pager","?ngModel"],controller:"PaginationController",controllerAs:"pagination",templateUrl:function(a,b){return b.templateUrl||"template/pagination/pager.html"},replace:!0,link:function(d,e,f,g){c||b.warn("pager is now deprecated. Use uib-pager instead.");var h=g[0],i=g[1];i&&(d.align=angular.isDefined(f.align)?d.$parent.$eval(f.align):a.align,h.init(i,a))}}}]),angular.module("ui.bootstrap.tooltip",["ui.bootstrap.position","ui.bootstrap.stackedMap"]).provider("$uibTooltip",function(){function a(a){var b=/[A-Z]/g,c="-";return a.replace(b,function(a,b){return(b?c:"")+a.toLowerCase()})}var b={placement:"top",animation:!0,popupDelay:0,popupCloseDelay:0,useContentExp:!1},c={mouseenter:"mouseleave",click:"click",focus:"blur",none:""},d={};this.options=function(a){angular.extend(d,a)},this.setTriggers=function(a){angular.extend(c,a)},this.$get=["$window","$compile","$timeout","$document","$uibPosition","$interpolate","$rootScope","$parse","$$stackedMap",function(e,f,g,h,i,j,k,l,m){var n=m.createNew();return h.on("keypress",function(a){if(27===a.which){var b=n.top();b&&(b.value.close(),n.removeTop(),b=null)}}),function(e,k,m,o){function p(a){var b=(a||o.trigger||m).split(" "),d=b.map(function(a){return c[a]||a});return{show:b,hide:d}}o=angular.extend({},b,d,o);var q=a(e),r=j.startSymbol(),s=j.endSymbol(),t="<div "+q+'-popup title="'+r+"title"+s+'" '+(o.useContentExp?'content-exp="contentExp()" ':'content="'+r+"content"+s+'" ')+'placement="'+r+"placement"+s+'" popup-class="'+r+"popupClass"+s+'" animation="animation" is-open="isOpen"origin-scope="origScope" style="visibility: hidden; display: block; top: -9999px; left: -9999px;"></div>';return{compile:function(a,b){var c=f(t);return function(a,b,d,f){function j(){L.isOpen?q():m()}function m(){(!K||a.$eval(d[k+"Enable"]))&&(u(),x(),L.popupDelay?F||(F=g(r,L.popupDelay,!1)):r())}function q(){s(),L.popupCloseDelay?G||(G=g(t,L.popupCloseDelay,!1)):t()}function r(){return s(),u(),L.content?(v(),void L.$evalAsync(function(){L.isOpen=!0,y(!0),Q()})):angular.noop}function s(){F&&(g.cancel(F),F=null),H&&(g.cancel(H),H=null)}function t(){s(),u(),L&&L.$evalAsync(function(){L.isOpen=!1,y(!1),L.animation?E||(E=g(w,150,!1)):w()})}function u(){G&&(g.cancel(G),G=null),E&&(g.cancel(E),E=null)}function v(){C||(D=L.$new(),C=c(D,function(a){I?h.find("body").append(a):b.after(a)}),z())}function w(){A(),E=null,C&&(C.remove(),C=null),D&&(D.$destroy(),D=null)}function x(){L.title=d[k+"Title"],O?L.content=O(a):L.content=d[e],L.popupClass=d[k+"Class"],L.placement=angular.isDefined(d[k+"Placement"])?d[k+"Placement"]:o.placement;var b=parseInt(d[k+"PopupDelay"],10),c=parseInt(d[k+"PopupCloseDelay"],10);L.popupDelay=isNaN(b)?o.popupDelay:b,L.popupCloseDelay=isNaN(c)?o.popupCloseDelay:c}function y(b){N&&angular.isFunction(N.assign)&&N.assign(a,b)}function z(){P.length=0,O?(P.push(a.$watch(O,function(a){L.content=a,!a&&L.isOpen&&t()})),P.push(D.$watch(function(){M||(M=!0,D.$$postDigest(function(){M=!1,L&&L.isOpen&&Q()}))}))):P.push(d.$observe(e,function(a){L.content=a,!a&&L.isOpen?t():Q()})),P.push(d.$observe(k+"Title",function(a){L.title=a,L.isOpen&&Q()})),P.push(d.$observe(k+"Placement",function(a){L.placement=a?a:o.placement,L.isOpen&&Q()}))}function A(){P.length&&(angular.forEach(P,function(a){a()}),P.length=0)}function B(){var a=d[k+"Trigger"];R(),J=p(a),"none"!==J.show&&J.show.forEach(function(a,c){a===J.hide[c]?b[0].addEventListener(a,j):a&&(b[0].addEventListener(a,m),J.hide[c].split(" ").forEach(function(a){b[0].addEventListener(a,q)})),b.on("keypress",function(a){27===a.which&&q()})})}var C,D,E,F,G,H,I=angular.isDefined(o.appendToBody)?o.appendToBody:!1,J=p(void 0),K=angular.isDefined(d[k+"Enable"]),L=a.$new(!0),M=!1,N=angular.isDefined(d[k+"IsOpen"])?l(d[k+"IsOpen"]):!1,O=o.useContentExp?l(d[e]):!1,P=[],Q=function(){C&&C.html()&&(H||(H=g(function(){C.css({top:0,left:0});var a=i.positionElements(b,C,L.placement,I);a.top+="px",a.left+="px",a.visibility="visible",C.css(a),H=null},0,!1)))};L.origScope=a,L.isOpen=!1,n.add(L,{close:t}),L.contentExp=function(){return L.content},d.$observe("disabled",function(a){a&&s(),a&&L.isOpen&&t()}),N&&a.$watch(N,function(a){L&&!a===L.isOpen&&j()});var R=function(){J.show.forEach(function(a){b.unbind(a,m)}),J.hide.forEach(function(a){a.split(" ").forEach(function(a){b[0].removeEventListener(a,q)})})};B();var S=a.$eval(d[k+"Animation"]);L.animation=angular.isDefined(S)?!!S:o.animation;var T=a.$eval(d[k+"AppendToBody"]);I=angular.isDefined(T)?T:I,I&&a.$on("$locationChangeSuccess",function(){L.isOpen&&t()}),a.$on("$destroy",function(){s(),u(),R(),w(),n.remove(L),L=null})}}}}}]}).directive("uibTooltipTemplateTransclude",["$animate","$sce","$compile","$templateRequest",function(a,b,c,d){return{link:function(e,f,g){var h,i,j,k=e.$eval(g.tooltipTemplateTranscludeScope),l=0,m=function(){i&&(i.remove(),i=null),h&&(h.$destroy(),h=null),j&&(a.leave(j).then(function(){i=null}),i=j,j=null)};e.$watch(b.parseAsResourceUrl(g.uibTooltipTemplateTransclude),function(b){var g=++l;b?(d(b,!0).then(function(d){if(g===l){var e=k.$new(),i=d,n=c(i)(e,function(b){m(),a.enter(b,f)});h=e,j=n,h.$emit("$includeContentLoaded",b)}},function(){g===l&&(m(),e.$emit("$includeContentError",b))}),e.$emit("$includeContentRequested",b)):m()}),e.$on("$destroy",m)}}}]).directive("uibTooltipClasses",function(){return{restrict:"A",link:function(a,b,c){a.placement&&b.addClass(a.placement),a.popupClass&&b.addClass(a.popupClass),a.animation()&&b.addClass(c.tooltipAnimationClass)}}}).directive("uibTooltipPopup",function(){return{replace:!0,scope:{content:"@",placement:"@",popupClass:"@",animation:"&",isOpen:"&"},templateUrl:"template/tooltip/tooltip-popup.html",link:function(a,b){b.addClass("tooltip")}}}).directive("uibTooltip",["$uibTooltip",function(a){return a("uibTooltip","tooltip","mouseenter")}]).directive("uibTooltipTemplatePopup",function(){return{replace:!0,scope:{contentExp:"&",placement:"@",popupClass:"@",animation:"&",isOpen:"&",originScope:"&"},templateUrl:"template/tooltip/tooltip-template-popup.html",link:function(a,b){b.addClass("tooltip")}}}).directive("uibTooltipTemplate",["$uibTooltip",function(a){return a("uibTooltipTemplate","tooltip","mouseenter",{useContentExp:!0})}]).directive("uibTooltipHtmlPopup",function(){return{replace:!0,scope:{contentExp:"&",placement:"@",popupClass:"@",animation:"&",isOpen:"&"},templateUrl:"template/tooltip/tooltip-html-popup.html",link:function(a,b){b.addClass("tooltip")}}}).directive("uibTooltipHtml",["$uibTooltip",function(a){return a("uibTooltipHtml","tooltip","mouseenter",{useContentExp:!0})}]),angular.module("ui.bootstrap.tooltip").value("$tooltipSuppressWarning",!1).provider("$tooltip",["$uibTooltipProvider",function(a){angular.extend(this,a),this.$get=["$log","$tooltipSuppressWarning","$injector",function(b,c,d){return c||b.warn("$tooltip is now deprecated. Use $uibTooltip instead."),d.invoke(a.$get)}]}]).directive("tooltipTemplateTransclude",["$animate","$sce","$compile","$templateRequest","$log","$tooltipSuppressWarning",function(a,b,c,d,e,f){return{link:function(g,h,i){f||e.warn("tooltip-template-transclude is now deprecated. Use uib-tooltip-template-transclude instead.");var j,k,l,m=g.$eval(i.tooltipTemplateTranscludeScope),n=0,o=function(){k&&(k.remove(),k=null),j&&(j.$destroy(),j=null),l&&(a.leave(l).then(function(){k=null}),k=l,l=null)};g.$watch(b.parseAsResourceUrl(i.tooltipTemplateTransclude),function(b){var e=++n;b?(d(b,!0).then(function(d){if(e===n){var f=m.$new(),g=d,i=c(g)(f,function(b){o(),a.enter(b,h)});j=f,l=i,j.$emit("$includeContentLoaded",b)}},function(){e===n&&(o(),g.$emit("$includeContentError",b))}),g.$emit("$includeContentRequested",b)):o()}),g.$on("$destroy",o)}}}]).directive("tooltipClasses",["$log","$tooltipSuppressWarning",function(a,b){return{restrict:"A",link:function(c,d,e){b||a.warn("tooltip-classes is now deprecated. Use uib-tooltip-classes instead."),c.placement&&d.addClass(c.placement),c.popupClass&&d.addClass(c.popupClass),c.animation()&&d.addClass(e.tooltipAnimationClass)}}}]).directive("tooltipPopup",["$log","$tooltipSuppressWarning",function(a,b){return{replace:!0,scope:{content:"@",placement:"@",popupClass:"@",animation:"&",isOpen:"&"},templateUrl:"template/tooltip/tooltip-popup.html",link:function(c,d){b||a.warn("tooltip-popup is now deprecated. Use uib-tooltip-popup instead."),d.addClass("tooltip")}}}]).directive("tooltip",["$tooltip",function(a){return a("tooltip","tooltip","mouseenter")}]).directive("tooltipTemplatePopup",["$log","$tooltipSuppressWarning",function(a,b){return{replace:!0,scope:{contentExp:"&",placement:"@",popupClass:"@",animation:"&",isOpen:"&",originScope:"&"},templateUrl:"template/tooltip/tooltip-template-popup.html",link:function(c,d){b||a.warn("tooltip-template-popup is now deprecated. Use uib-tooltip-template-popup instead."),d.addClass("tooltip")}}}]).directive("tooltipTemplate",["$tooltip",function(a){return a("tooltipTemplate","tooltip","mouseenter",{useContentExp:!0})}]).directive("tooltipHtmlPopup",["$log","$tooltipSuppressWarning",function(a,b){return{replace:!0,scope:{contentExp:"&",placement:"@",popupClass:"@",animation:"&",isOpen:"&"},templateUrl:"template/tooltip/tooltip-html-popup.html",link:function(c,d){b||a.warn("tooltip-html-popup is now deprecated. Use uib-tooltip-html-popup instead."),d.addClass("tooltip")}}}]).directive("tooltipHtml",["$tooltip",function(a){return a("tooltipHtml","tooltip","mouseenter",{useContentExp:!0})}]),angular.module("ui.bootstrap.popover",["ui.bootstrap.tooltip"]).directive("uibPopoverTemplatePopup",function(){return{replace:!0,scope:{title:"@",contentExp:"&",placement:"@",popupClass:"@",animation:"&",isOpen:"&",originScope:"&"},templateUrl:"template/popover/popover-template.html",link:function(a,b){b.addClass("popover")}}}).directive("uibPopoverTemplate",["$uibTooltip",function(a){return a("uibPopoverTemplate","popover","click",{useContentExp:!0})}]).directive("uibPopoverHtmlPopup",function(){return{replace:!0,scope:{contentExp:"&",title:"@",placement:"@",popupClass:"@",animation:"&",isOpen:"&"},templateUrl:"template/popover/popover-html.html",link:function(a,b){b.addClass("popover")}}}).directive("uibPopoverHtml",["$uibTooltip",function(a){return a("uibPopoverHtml","popover","click",{useContentExp:!0})}]).directive("uibPopoverPopup",function(){return{replace:!0,scope:{title:"@",content:"@",placement:"@",popupClass:"@",animation:"&",isOpen:"&"},templateUrl:"template/popover/popover.html",link:function(a,b){b.addClass("popover")}}}).directive("uibPopover",["$uibTooltip",function(a){return a("uibPopover","popover","click")}]),angular.module("ui.bootstrap.popover").value("$popoverSuppressWarning",!1).directive("popoverTemplatePopup",["$log","$popoverSuppressWarning",function(a,b){return{replace:!0,scope:{title:"@",contentExp:"&",placement:"@",popupClass:"@",animation:"&",isOpen:"&",originScope:"&"},templateUrl:"template/popover/popover-template.html",link:function(c,d){b||a.warn("popover-template-popup is now deprecated. Use uib-popover-template-popup instead."),d.addClass("popover")}}}]).directive("popoverTemplate",["$tooltip",function(a){return a("popoverTemplate","popover","click",{useContentExp:!0})}]).directive("popoverHtmlPopup",["$log","$popoverSuppressWarning",function(a,b){return{replace:!0,scope:{contentExp:"&",title:"@",placement:"@",popupClass:"@",animation:"&",isOpen:"&"},templateUrl:"template/popover/popover-html.html",link:function(c,d){b||a.warn("popover-html-popup is now deprecated. Use uib-popover-html-popup instead."),d.addClass("popover")}}}]).directive("popoverHtml",["$tooltip",function(a){return a("popoverHtml","popover","click",{useContentExp:!0})}]).directive("popoverPopup",["$log","$popoverSuppressWarning",function(a,b){return{replace:!0,scope:{title:"@",content:"@",placement:"@",popupClass:"@",animation:"&",isOpen:"&"},templateUrl:"template/popover/popover.html",link:function(c,d){b||a.warn("popover-popup is now deprecated. Use uib-popover-popup instead."),d.addClass("popover")}}}]).directive("popover",["$tooltip",function(a){return a("popover","popover","click")}]),angular.module("ui.bootstrap.progressbar",[]).constant("uibProgressConfig",{animate:!0,max:100}).controller("UibProgressController",["$scope","$attrs","uibProgressConfig",function(a,b,c){var d=this,e=angular.isDefined(b.animate)?a.$parent.$eval(b.animate):c.animate;this.bars=[],a.max=angular.isDefined(a.max)?a.max:c.max,this.addBar=function(b,c,f){e||c.css({transition:"none"}),this.bars.push(b),b.max=a.max,b.title=f&&angular.isDefined(f.title)?f.title:"progressbar",b.$watch("value",function(a){b.recalculatePercentage()}),b.recalculatePercentage=function(){var a=d.bars.reduce(function(a,b){return b.percent=+(100*b.value/b.max).toFixed(2),a+b.percent},0);a>100&&(b.percent-=a-100)},b.$on("$destroy",function(){c=null,d.removeBar(b)})},this.removeBar=function(a){this.bars.splice(this.bars.indexOf(a),1),this.bars.forEach(function(a){a.recalculatePercentage()})},a.$watch("max",function(b){d.bars.forEach(function(b){b.max=a.max,b.recalculatePercentage()})})}]).directive("uibProgress",function(){return{replace:!0,transclude:!0,controller:"UibProgressController",require:"uibProgress",scope:{max:"=?"},templateUrl:"template/progressbar/progress.html"}}).directive("uibBar",function(){return{replace:!0,transclude:!0,require:"^uibProgress",scope:{value:"=",type:"@"},templateUrl:"template/progressbar/bar.html",link:function(a,b,c,d){d.addBar(a,b,c)}}}).directive("uibProgressbar",function(){return{replace:!0,transclude:!0,controller:"UibProgressController",scope:{value:"=",max:"=?",type:"@"},templateUrl:"template/progressbar/progressbar.html",link:function(a,b,c,d){d.addBar(a,angular.element(b.children()[0]),{title:c.title})}}}),angular.module("ui.bootstrap.progressbar").value("$progressSuppressWarning",!1).controller("ProgressController",["$scope","$attrs","uibProgressConfig","$log","$progressSuppressWarning",function(a,b,c,d,e){e||d.warn("ProgressController is now deprecated. Use UibProgressController instead.");var f=this,g=angular.isDefined(b.animate)?a.$parent.$eval(b.animate):c.animate;this.bars=[],a.max=angular.isDefined(a.max)?a.max:c.max,this.addBar=function(b,c,d){g||c.css({transition:"none"}),this.bars.push(b),b.max=a.max,b.title=d&&angular.isDefined(d.title)?d.title:"progressbar",b.$watch("value",function(a){b.recalculatePercentage()}),b.recalculatePercentage=function(){b.percent=+(100*b.value/b.max).toFixed(2);var a=f.bars.reduce(function(a,b){return a+b.percent},0);a>100&&(b.percent-=a-100)},b.$on("$destroy",function(){c=null,f.removeBar(b)})},this.removeBar=function(a){this.bars.splice(this.bars.indexOf(a),1)},a.$watch("max",function(b){f.bars.forEach(function(b){b.max=a.max,b.recalculatePercentage()})})}]).directive("progress",["$log","$progressSuppressWarning",function(a,b){return{replace:!0,transclude:!0,controller:"ProgressController",require:"progress",scope:{max:"=?",title:"@?"},templateUrl:"template/progressbar/progress.html",link:function(){b||a.warn("progress is now deprecated. Use uib-progress instead.")}}}]).directive("bar",["$log","$progressSuppressWarning",function(a,b){return{replace:!0,transclude:!0,require:"^progress",scope:{value:"=",type:"@"},templateUrl:"template/progressbar/bar.html",link:function(c,d,e,f){b||a.warn("bar is now deprecated. Use uib-bar instead."),f.addBar(c,d)}}}]).directive("progressbar",["$log","$progressSuppressWarning",function(a,b){return{replace:!0,transclude:!0,controller:"ProgressController",scope:{value:"=",max:"=?",type:"@"},templateUrl:"template/progressbar/progressbar.html",link:function(c,d,e,f){b||a.warn("progressbar is now deprecated. Use uib-progressbar instead."),f.addBar(c,angular.element(d.children()[0]),{title:e.title})}}}]),angular.module("ui.bootstrap.rating",[]).constant("uibRatingConfig",{max:5,stateOn:null,stateOff:null,titles:["one","two","three","four","five"]}).controller("UibRatingController",["$scope","$attrs","uibRatingConfig",function(a,b,c){var d={$setViewValue:angular.noop};this.init=function(e){d=e,d.$render=this.render,d.$formatters.push(function(a){return angular.isNumber(a)&&a<<0!==a&&(a=Math.round(a)),a}),this.stateOn=angular.isDefined(b.stateOn)?a.$parent.$eval(b.stateOn):c.stateOn,this.stateOff=angular.isDefined(b.stateOff)?a.$parent.$eval(b.stateOff):c.stateOff;var f=angular.isDefined(b.titles)?a.$parent.$eval(b.titles):c.titles;this.titles=angular.isArray(f)&&f.length>0?f:c.titles;var g=angular.isDefined(b.ratingStates)?a.$parent.$eval(b.ratingStates):new Array(angular.isDefined(b.max)?a.$parent.$eval(b.max):c.max);a.range=this.buildTemplateObjects(g)},this.buildTemplateObjects=function(a){for(var b=0,c=a.length;c>b;b++)a[b]=angular.extend({index:b},{stateOn:this.stateOn,stateOff:this.stateOff,title:this.getTitle(b)},a[b]);return a},this.getTitle=function(a){return a>=this.titles.length?a+1:this.titles[a]},a.rate=function(b){!a.readonly&&b>=0&&b<=a.range.length&&(d.$setViewValue(d.$viewValue===b?0:b),d.$render())},a.enter=function(b){a.readonly||(a.value=b),a.onHover({value:b})},a.reset=function(){a.value=d.$viewValue,a.onLeave()},a.onKeydown=function(b){/(37|38|39|40)/.test(b.which)&&(b.preventDefault(),b.stopPropagation(),a.rate(a.value+(38===b.which||39===b.which?1:-1)))},this.render=function(){a.value=d.$viewValue}}]).directive("uibRating",function(){return{require:["uibRating","ngModel"],scope:{readonly:"=?",onHover:"&",onLeave:"&"},controller:"UibRatingController",templateUrl:"template/rating/rating.html",replace:!0,link:function(a,b,c,d){var e=d[0],f=d[1];e.init(f)}}}),angular.module("ui.bootstrap.rating").value("$ratingSuppressWarning",!1).controller("RatingController",["$scope","$attrs","$controller","$log","$ratingSuppressWarning",function(a,b,c,d,e){e||d.warn("RatingController is now deprecated. Use UibRatingController instead."),angular.extend(this,c("UibRatingController",{$scope:a,$attrs:b}))}]).directive("rating",["$log","$ratingSuppressWarning",function(a,b){return{require:["rating","ngModel"],scope:{readonly:"=?",onHover:"&",onLeave:"&"},controller:"RatingController",templateUrl:"template/rating/rating.html",replace:!0,link:function(c,d,e,f){b||a.warn("rating is now deprecated. Use uib-rating instead.");var g=f[0],h=f[1];g.init(h)}}}]),angular.module("ui.bootstrap.tabs",[]).controller("UibTabsetController",["$scope",function(a){var b=this,c=b.tabs=a.tabs=[];b.select=function(a){angular.forEach(c,function(b){b.active&&b!==a&&(b.active=!1,b.onDeselect(),a.selectCalled=!1)}),a.active=!0,a.selectCalled||(a.onSelect(),a.selectCalled=!0)},b.addTab=function(a){c.push(a),1===c.length&&a.active!==!1?a.active=!0:a.active?b.select(a):a.active=!1},b.removeTab=function(a){var e=c.indexOf(a);if(a.active&&c.length>1&&!d){var f=e==c.length-1?e-1:e+1;b.select(c[f])}c.splice(e,1)};var d;a.$on("$destroy",function(){d=!0})}]).directive("uibTabset",function(){return{restrict:"EA",transclude:!0,replace:!0,scope:{type:"@"},controller:"UibTabsetController",templateUrl:"template/tabs/tabset.html",link:function(a,b,c){a.vertical=angular.isDefined(c.vertical)?a.$parent.$eval(c.vertical):!1,a.justified=angular.isDefined(c.justified)?a.$parent.$eval(c.justified):!1}}}).directive("uibTab",["$parse",function(a){return{require:"^uibTabset",restrict:"EA",replace:!0,templateUrl:"template/tabs/tab.html",transclude:!0,scope:{active:"=?",heading:"@",onSelect:"&select",onDeselect:"&deselect"},controller:function(){},link:function(b,c,d,e,f){b.$watch("active",function(a){a&&e.select(b)}),b.disabled=!1,d.disable&&b.$parent.$watch(a(d.disable),function(a){b.disabled=!!a}),b.select=function(){b.disabled||(b.active=!0)},e.addTab(b),b.$on("$destroy",function(){e.removeTab(b)}),b.$transcludeFn=f}}}]).directive("uibTabHeadingTransclude",function(){return{restrict:"A",require:["?^uibTab","?^tab"],link:function(a,b){a.$watch("headingElement",function(a){a&&(b.html(""),b.append(a))})}}}).directive("uibTabContentTransclude",function(){function a(a){return a.tagName&&(a.hasAttribute("tab-heading")||a.hasAttribute("data-tab-heading")||a.hasAttribute("x-tab-heading")||a.hasAttribute("uib-tab-heading")||a.hasAttribute("data-uib-tab-heading")||a.hasAttribute("x-uib-tab-heading")||"tab-heading"===a.tagName.toLowerCase()||"data-tab-heading"===a.tagName.toLowerCase()||"x-tab-heading"===a.tagName.toLowerCase()||"uib-tab-heading"===a.tagName.toLowerCase()||"data-uib-tab-heading"===a.tagName.toLowerCase()||"x-uib-tab-heading"===a.tagName.toLowerCase())}return{restrict:"A",require:["?^uibTabset","?^tabset"],link:function(b,c,d){var e=b.$eval(d.uibTabContentTransclude);e.$transcludeFn(e.$parent,function(b){angular.forEach(b,function(b){a(b)?e.headingElement=b:c.append(b)})})}}}),angular.module("ui.bootstrap.tabs").value("$tabsSuppressWarning",!1).controller("TabsetController",["$scope","$controller","$log","$tabsSuppressWarning",function(a,b,c,d){d||c.warn("TabsetController is now deprecated. Use UibTabsetController instead."),angular.extend(this,b("UibTabsetController",{$scope:a}))}]).directive("tabset",["$log","$tabsSuppressWarning",function(a,b){return{restrict:"EA",transclude:!0,replace:!0,scope:{type:"@"},controller:"TabsetController",templateUrl:"template/tabs/tabset.html",link:function(c,d,e){b||a.warn("tabset is now deprecated. Use uib-tabset instead."),c.vertical=angular.isDefined(e.vertical)?c.$parent.$eval(e.vertical):!1,c.justified=angular.isDefined(e.justified)?c.$parent.$eval(e.justified):!1}}}]).directive("tab",["$parse","$log","$tabsSuppressWarning",function(a,b,c){return{require:"^tabset",restrict:"EA",replace:!0,templateUrl:"template/tabs/tab.html",transclude:!0,scope:{active:"=?",heading:"@",onSelect:"&select",onDeselect:"&deselect"},controller:function(){},link:function(d,e,f,g,h){c||b.warn("tab is now deprecated. Use uib-tab instead."),d.$watch("active",function(a){a&&g.select(d)}),d.disabled=!1,f.disable&&d.$parent.$watch(a(f.disable),function(a){d.disabled=!!a}),d.select=function(){d.disabled||(d.active=!0)},g.addTab(d),d.$on("$destroy",function(){g.removeTab(d)}),d.$transcludeFn=h}}}]).directive("tabHeadingTransclude",["$log","$tabsSuppressWarning",function(a,b){return{restrict:"A",require:"^tab",link:function(c,d){b||a.warn("tab-heading-transclude is now deprecated. Use uib-tab-heading-transclude instead."),c.$watch("headingElement",function(a){a&&(d.html(""),d.append(a))})}}}]).directive("tabContentTransclude",["$log","$tabsSuppressWarning",function(a,b){function c(a){return a.tagName&&(a.hasAttribute("tab-heading")||a.hasAttribute("data-tab-heading")||a.hasAttribute("x-tab-heading")||"tab-heading"===a.tagName.toLowerCase()||"data-tab-heading"===a.tagName.toLowerCase()||"x-tab-heading"===a.tagName.toLowerCase())}return{restrict:"A",require:"^tabset",link:function(d,e,f){b||a.warn("tab-content-transclude is now deprecated. Use uib-tab-content-transclude instead.");var g=d.$eval(f.tabContentTransclude);g.$transcludeFn(g.$parent,function(a){angular.forEach(a,function(a){c(a)?g.headingElement=a:e.append(a)})})}}}]),angular.module("ui.bootstrap.timepicker",[]).constant("uibTimepickerConfig",{hourStep:1,minuteStep:1,showMeridian:!0,meridians:null,readonlyInput:!1,mousewheel:!0,arrowkeys:!0,showSpinners:!0}).controller("UibTimepickerController",["$scope","$element","$attrs","$parse","$log","$locale","uibTimepickerConfig",function(a,b,c,d,e,f,g){function h(){var b=parseInt(a.hours,10),c=a.showMeridian?b>0&&13>b:b>=0&&24>b;return c?(a.showMeridian&&(12===b&&(b=0),a.meridian===r[1]&&(b+=12)),b):void 0}function i(){var b=parseInt(a.minutes,10);return b>=0&&60>b?b:void 0}function j(a){return angular.isDefined(a)&&a.toString().length<2?"0"+a:a.toString()}function k(a){l(),q.$setViewValue(new Date(p)),m(a)}function l(){q.$setValidity("time",!0),a.invalidHours=!1,a.invalidMinutes=!1}function m(b){var c=p.getHours(),d=p.getMinutes();a.showMeridian&&(c=0===c||12===c?12:c%12),a.hours="h"===b?c:j(c),"m"!==b&&(a.minutes=j(d)),a.meridian=p.getHours()<12?r[0]:r[1]}function n(a,b){var c=new Date(a.getTime()+6e4*b),d=new Date(a);return d.setHours(c.getHours(),c.getMinutes()),d}function o(a){p=n(p,a),k()}var p=new Date,q={$setViewValue:angular.noop},r=angular.isDefined(c.meridians)?a.$parent.$eval(c.meridians):g.meridians||f.DATETIME_FORMATS.AMPMS;a.tabindex=angular.isDefined(c.tabindex)?c.tabindex:0,b.removeAttr("tabindex"),this.init=function(b,d){q=b,q.$render=this.render,q.$formatters.unshift(function(a){return a?new Date(a):null});var e=d.eq(0),f=d.eq(1),h=angular.isDefined(c.mousewheel)?a.$parent.$eval(c.mousewheel):g.mousewheel;h&&this.setupMousewheelEvents(e,f);var i=angular.isDefined(c.arrowkeys)?a.$parent.$eval(c.arrowkeys):g.arrowkeys;i&&this.setupArrowkeyEvents(e,f),a.readonlyInput=angular.isDefined(c.readonlyInput)?a.$parent.$eval(c.readonlyInput):g.readonlyInput,this.setupInputEvents(e,f)};var s=g.hourStep;c.hourStep&&a.$parent.$watch(d(c.hourStep),function(a){s=parseInt(a,10)});var t=g.minuteStep;c.minuteStep&&a.$parent.$watch(d(c.minuteStep),function(a){t=parseInt(a,10)});var u;a.$parent.$watch(d(c.min),function(a){var b=new Date(a);u=isNaN(b)?void 0:b});var v;a.$parent.$watch(d(c.max),function(a){var b=new Date(a);v=isNaN(b)?void 0:b}),a.noIncrementHours=function(){var a=n(p,60*s);
	return a>v||p>a&&u>a},a.noDecrementHours=function(){var a=n(p,60*-s);return u>a||a>p&&a>v},a.noIncrementMinutes=function(){var a=n(p,t);return a>v||p>a&&u>a},a.noDecrementMinutes=function(){var a=n(p,-t);return u>a||a>p&&a>v},a.noToggleMeridian=function(){return p.getHours()<13?n(p,720)>v:n(p,-720)<u},a.showMeridian=g.showMeridian,c.showMeridian&&a.$parent.$watch(d(c.showMeridian),function(b){if(a.showMeridian=!!b,q.$error.time){var c=h(),d=i();angular.isDefined(c)&&angular.isDefined(d)&&(p.setHours(c),k())}else m()}),this.setupMousewheelEvents=function(b,c){var d=function(a){a.originalEvent&&(a=a.originalEvent);var b=a.wheelDelta?a.wheelDelta:-a.deltaY;return a.detail||b>0};b.bind("mousewheel wheel",function(b){a.$apply(d(b)?a.incrementHours():a.decrementHours()),b.preventDefault()}),c.bind("mousewheel wheel",function(b){a.$apply(d(b)?a.incrementMinutes():a.decrementMinutes()),b.preventDefault()})},this.setupArrowkeyEvents=function(b,c){b.bind("keydown",function(b){38===b.which?(b.preventDefault(),a.incrementHours(),a.$apply()):40===b.which&&(b.preventDefault(),a.decrementHours(),a.$apply())}),c.bind("keydown",function(b){38===b.which?(b.preventDefault(),a.incrementMinutes(),a.$apply()):40===b.which&&(b.preventDefault(),a.decrementMinutes(),a.$apply())})},this.setupInputEvents=function(b,c){if(a.readonlyInput)return a.updateHours=angular.noop,void(a.updateMinutes=angular.noop);var d=function(b,c){q.$setViewValue(null),q.$setValidity("time",!1),angular.isDefined(b)&&(a.invalidHours=b),angular.isDefined(c)&&(a.invalidMinutes=c)};a.updateHours=function(){var a=h(),b=i();angular.isDefined(a)&&angular.isDefined(b)?(p.setHours(a),u>p||p>v?d(!0):k("h")):d(!0)},b.bind("blur",function(b){!a.invalidHours&&a.hours<10&&a.$apply(function(){a.hours=j(a.hours)})}),a.updateMinutes=function(){var a=i(),b=h();angular.isDefined(a)&&angular.isDefined(b)?(p.setMinutes(a),u>p||p>v?d(void 0,!0):k("m")):d(void 0,!0)},c.bind("blur",function(b){!a.invalidMinutes&&a.minutes<10&&a.$apply(function(){a.minutes=j(a.minutes)})})},this.render=function(){var b=q.$viewValue;isNaN(b)?(q.$setValidity("time",!1),e.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.')):(b&&(p=b),u>p||p>v?(q.$setValidity("time",!1),a.invalidHours=!0,a.invalidMinutes=!0):l(),m())},a.showSpinners=angular.isDefined(c.showSpinners)?a.$parent.$eval(c.showSpinners):g.showSpinners,a.incrementHours=function(){a.noIncrementHours()||o(60*s)},a.decrementHours=function(){a.noDecrementHours()||o(60*-s)},a.incrementMinutes=function(){a.noIncrementMinutes()||o(t)},a.decrementMinutes=function(){a.noDecrementMinutes()||o(-t)},a.toggleMeridian=function(){a.noToggleMeridian()||o(720*(p.getHours()<12?1:-1))}}]).directive("uibTimepicker",function(){return{restrict:"EA",require:["uibTimepicker","?^ngModel"],controller:"UibTimepickerController",controllerAs:"timepicker",replace:!0,scope:{},templateUrl:function(a,b){return b.templateUrl||"template/timepicker/timepicker.html"},link:function(a,b,c,d){var e=d[0],f=d[1];f&&e.init(f,b.find("input"))}}}),angular.module("ui.bootstrap.timepicker").value("$timepickerSuppressWarning",!1).controller("TimepickerController",["$scope","$element","$attrs","$controller","$log","$timepickerSuppressWarning",function(a,b,c,d,e,f){f||e.warn("TimepickerController is now deprecated. Use UibTimepickerController instead."),angular.extend(this,d("UibTimepickerController",{$scope:a,$element:b,$attrs:c}))}]).directive("timepicker",["$log","$timepickerSuppressWarning",function(a,b){return{restrict:"EA",require:["timepicker","?^ngModel"],controller:"TimepickerController",controllerAs:"timepicker",replace:!0,scope:{},templateUrl:function(a,b){return b.templateUrl||"template/timepicker/timepicker.html"},link:function(c,d,e,f){b||a.warn("timepicker is now deprecated. Use uib-timepicker instead.");var g=f[0],h=f[1];h&&g.init(h,d.find("input"))}}}]),angular.module("ui.bootstrap.typeahead",["ui.bootstrap.position"]).factory("uibTypeaheadParser",["$parse",function(a){var b=/^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;return{parse:function(c){var d=c.match(b);if(!d)throw new Error('Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_" but got "'+c+'".');return{itemName:d[3],source:a(d[4]),viewMapper:a(d[2]||d[1]),modelMapper:a(d[1])}}}}]).controller("UibTypeaheadController",["$scope","$element","$attrs","$compile","$parse","$q","$timeout","$document","$window","$rootScope","$uibPosition","uibTypeaheadParser",function(a,b,c,d,e,f,g,h,i,j,k,l){function m(){K.moveInProgress||(K.moveInProgress=!0,K.$digest()),S&&g.cancel(S),S=g(function(){K.matches.length&&n(),K.moveInProgress=!1},r)}function n(){K.position=C?k.offset(b):k.position(b),K.position.top+=b.prop("offsetHeight")}var o,p,q=[9,13,27,38,40],r=200,s=a.$eval(c.typeaheadMinLength);s||0===s||(s=1);var t,u,v=a.$eval(c.typeaheadWaitMs)||0,w=a.$eval(c.typeaheadEditable)!==!1,x=e(c.typeaheadLoading).assign||angular.noop,y=e(c.typeaheadOnSelect),z=angular.isDefined(c.typeaheadSelectOnBlur)?a.$eval(c.typeaheadSelectOnBlur):!1,A=e(c.typeaheadNoResults).assign||angular.noop,B=c.typeaheadInputFormatter?e(c.typeaheadInputFormatter):void 0,C=c.typeaheadAppendToBody?a.$eval(c.typeaheadAppendToBody):!1,D=c.typeaheadAppendToElementId||!1,E=a.$eval(c.typeaheadFocusFirst)!==!1,F=c.typeaheadSelectOnExact?a.$eval(c.typeaheadSelectOnExact):!1,G=e(c.ngModel),H=e(c.ngModel+"($$$p)"),I=function(b,c){return angular.isFunction(G(a))&&p&&p.$options&&p.$options.getterSetter?H(b,{$$$p:c}):G.assign(b,c)},J=l.parse(c.uibTypeahead),K=a.$new(),L=a.$on("$destroy",function(){K.$destroy()});K.$on("$destroy",L);var M="typeahead-"+K.$id+"-"+Math.floor(1e4*Math.random());b.attr({"aria-autocomplete":"list","aria-expanded":!1,"aria-owns":M});var N=angular.element("<div uib-typeahead-popup></div>");N.attr({id:M,matches:"matches",active:"activeIdx",select:"select(activeIdx)","move-in-progress":"moveInProgress",query:"query",position:"position"}),angular.isDefined(c.typeaheadTemplateUrl)&&N.attr("template-url",c.typeaheadTemplateUrl),angular.isDefined(c.typeaheadPopupTemplateUrl)&&N.attr("popup-template-url",c.typeaheadPopupTemplateUrl);var O=function(){K.matches=[],K.activeIdx=-1,b.attr("aria-expanded",!1)},P=function(a){return M+"-option-"+a};K.$watch("activeIdx",function(a){0>a?b.removeAttr("aria-activedescendant"):b.attr("aria-activedescendant",P(a))});var Q=function(a,b){return K.matches.length>b&&a?a.toUpperCase()===K.matches[b].label.toUpperCase():!1},R=function(c){var d={$viewValue:c};x(a,!0),A(a,!1),f.when(J.source(a,d)).then(function(e){var f=c===o.$viewValue;if(f&&t)if(e&&e.length>0){K.activeIdx=E?0:-1,A(a,!1),K.matches.length=0;for(var g=0;g<e.length;g++)d[J.itemName]=e[g],K.matches.push({id:P(g),label:J.viewMapper(K,d),model:e[g]});K.query=c,n(),b.attr("aria-expanded",!0),F&&1===K.matches.length&&Q(c,0)&&K.select(0)}else O(),A(a,!0);f&&x(a,!1)},function(){O(),x(a,!1),A(a,!0)})};C&&(angular.element(i).bind("resize",m),h.find("body").bind("scroll",m));var S;K.moveInProgress=!1,K.query=void 0;var T,U=function(a){T=g(function(){R(a)},v)},V=function(){T&&g.cancel(T)};O(),K.select=function(d){var e,f,h={};u=!0,h[J.itemName]=f=K.matches[d].model,e=J.modelMapper(a,h),I(a,e),o.$setValidity("editable",!0),o.$setValidity("parse",!0),y(a,{$item:f,$model:e,$label:J.viewMapper(a,h)}),O(),K.$eval(c.typeaheadFocusOnSelect)!==!1&&g(function(){b[0].focus()},0,!1)},b.bind("keydown",function(a){if(0!==K.matches.length&&-1!==q.indexOf(a.which)){if(-1===K.activeIdx&&(9===a.which||13===a.which))return O(),void K.$digest();a.preventDefault(),40===a.which?(K.activeIdx=(K.activeIdx+1)%K.matches.length,K.$digest()):38===a.which?(K.activeIdx=(K.activeIdx>0?K.activeIdx:K.matches.length)-1,K.$digest()):13===a.which||9===a.which?K.$apply(function(){K.select(K.activeIdx)}):27===a.which&&(a.stopPropagation(),O(),K.$digest())}}),b.bind("blur",function(){z&&K.matches.length&&-1!==K.activeIdx&&!u&&(u=!0,K.$apply(function(){K.select(K.activeIdx)})),t=!1,u=!1});var W=function(a){b[0]!==a.target&&3!==a.which&&0!==K.matches.length&&(O(),j.$$phase||K.$digest())};h.bind("click",W),a.$on("$destroy",function(){h.unbind("click",W),(C||D)&&X.remove(),C&&(angular.element(i).unbind("resize",m),h.find("body").unbind("scroll",m)),N.remove()});var X=d(N)(K);C?h.find("body").append(X):D!==!1?angular.element(h[0].getElementById(D)).append(X):b.after(X),this.init=function(b,c){o=b,p=c,o.$parsers.unshift(function(b){return t=!0,0===s||b&&b.length>=s?v>0?(V(),U(b)):R(b):(x(a,!1),V(),O()),w?b:b?void o.$setValidity("editable",!1):(o.$setValidity("editable",!0),null)}),o.$formatters.push(function(b){var c,d,e={};return w||o.$setValidity("editable",!0),B?(e.$model=b,B(a,e)):(e[J.itemName]=b,c=J.viewMapper(a,e),e[J.itemName]=void 0,d=J.viewMapper(a,e),c!==d?c:b)})}}]).directive("uibTypeahead",function(){return{controller:"UibTypeaheadController",require:["ngModel","^?ngModelOptions","uibTypeahead"],link:function(a,b,c,d){d[2].init(d[0],d[1])}}}).directive("uibTypeaheadPopup",function(){return{scope:{matches:"=",query:"=",active:"=",position:"&",moveInProgress:"=",select:"&"},replace:!0,templateUrl:function(a,b){return b.popupTemplateUrl||"template/typeahead/typeahead-popup.html"},link:function(a,b,c){a.templateUrl=c.templateUrl,a.isOpen=function(){return a.matches.length>0},a.isActive=function(b){return a.active==b},a.selectActive=function(b){a.active=b},a.selectMatch=function(b){a.select({activeIdx:b})}}}}).directive("uibTypeaheadMatch",["$templateRequest","$compile","$parse",function(a,b,c){return{scope:{index:"=",match:"=",query:"="},link:function(d,e,f){var g=c(f.templateUrl)(d.$parent)||"template/typeahead/typeahead-match.html";a(g).then(function(a){b(a.trim())(d,function(a){e.replaceWith(a)})})}}}]).filter("uibTypeaheadHighlight",["$sce","$injector","$log",function(a,b,c){function d(a){return a.replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1")}function e(a){return/<.*>/g.test(a)}var f;return f=b.has("$sanitize"),function(b,g){return!f&&e(b)&&c.warn("Unsafe use of typeahead please use ngSanitize"),b=g?(""+b).replace(new RegExp(d(g),"gi"),"<strong>$&</strong>"):b,f||(b=a.trustAsHtml(b)),b}}]),angular.module("ui.bootstrap.typeahead").value("$typeaheadSuppressWarning",!1).service("typeaheadParser",["$parse","uibTypeaheadParser","$log","$typeaheadSuppressWarning",function(a,b,c,d){return d||c.warn("typeaheadParser is now deprecated. Use uibTypeaheadParser instead."),b}]).directive("typeahead",["$compile","$parse","$q","$timeout","$document","$window","$rootScope","$uibPosition","typeaheadParser","$log","$typeaheadSuppressWarning",function(a,b,c,d,e,f,g,h,i,j,k){var l=[9,13,27,38,40],m=200;return{require:["ngModel","^?ngModelOptions"],link:function(n,o,p,q){function r(){N.moveInProgress||(N.moveInProgress=!0,N.$digest()),V&&d.cancel(V),V=d(function(){N.matches.length&&s(),N.moveInProgress=!1},m)}function s(){N.position=F?h.offset(o):h.position(o),N.position.top+=o.prop("offsetHeight")}k||j.warn("typeahead is now deprecated. Use uib-typeahead instead.");var t=q[0],u=q[1],v=n.$eval(p.typeaheadMinLength);v||0===v||(v=1);var w,x,y=n.$eval(p.typeaheadWaitMs)||0,z=n.$eval(p.typeaheadEditable)!==!1,A=b(p.typeaheadLoading).assign||angular.noop,B=b(p.typeaheadOnSelect),C=angular.isDefined(p.typeaheadSelectOnBlur)?n.$eval(p.typeaheadSelectOnBlur):!1,D=b(p.typeaheadNoResults).assign||angular.noop,E=p.typeaheadInputFormatter?b(p.typeaheadInputFormatter):void 0,F=p.typeaheadAppendToBody?n.$eval(p.typeaheadAppendToBody):!1,G=p.typeaheadAppendToElementId||!1,H=n.$eval(p.typeaheadFocusFirst)!==!1,I=p.typeaheadSelectOnExact?n.$eval(p.typeaheadSelectOnExact):!1,J=b(p.ngModel),K=b(p.ngModel+"($$$p)"),L=function(a,b){return angular.isFunction(J(n))&&u&&u.$options&&u.$options.getterSetter?K(a,{$$$p:b}):J.assign(a,b)},M=i.parse(p.typeahead),N=n.$new(),O=n.$on("$destroy",function(){N.$destroy()});N.$on("$destroy",O);var P="typeahead-"+N.$id+"-"+Math.floor(1e4*Math.random());o.attr({"aria-autocomplete":"list","aria-expanded":!1,"aria-owns":P});var Q=angular.element("<div typeahead-popup></div>");Q.attr({id:P,matches:"matches",active:"activeIdx",select:"select(activeIdx)","move-in-progress":"moveInProgress",query:"query",position:"position"}),angular.isDefined(p.typeaheadTemplateUrl)&&Q.attr("template-url",p.typeaheadTemplateUrl),angular.isDefined(p.typeaheadPopupTemplateUrl)&&Q.attr("popup-template-url",p.typeaheadPopupTemplateUrl);var R=function(){N.matches=[],N.activeIdx=-1,o.attr("aria-expanded",!1)},S=function(a){return P+"-option-"+a};N.$watch("activeIdx",function(a){0>a?o.removeAttr("aria-activedescendant"):o.attr("aria-activedescendant",S(a))});var T=function(a,b){return N.matches.length>b&&a?a.toUpperCase()===N.matches[b].label.toUpperCase():!1},U=function(a){var b={$viewValue:a};A(n,!0),D(n,!1),c.when(M.source(n,b)).then(function(c){var d=a===t.$viewValue;if(d&&w)if(c&&c.length>0){N.activeIdx=H?0:-1,D(n,!1),N.matches.length=0;for(var e=0;e<c.length;e++)b[M.itemName]=c[e],N.matches.push({id:S(e),label:M.viewMapper(N,b),model:c[e]});N.query=a,s(),o.attr("aria-expanded",!0),I&&1===N.matches.length&&T(a,0)&&N.select(0)}else R(),D(n,!0);d&&A(n,!1)},function(){R(),A(n,!1),D(n,!0)})};F&&(angular.element(f).bind("resize",r),e.find("body").bind("scroll",r));var V;N.moveInProgress=!1,R(),N.query=void 0;var W,X=function(a){W=d(function(){U(a)},y)},Y=function(){W&&d.cancel(W)};t.$parsers.unshift(function(a){return w=!0,0===v||a&&a.length>=v?y>0?(Y(),X(a)):U(a):(A(n,!1),Y(),R()),z?a:a?void t.$setValidity("editable",!1):(t.$setValidity("editable",!0),null)}),t.$formatters.push(function(a){var b,c,d={};return z||t.$setValidity("editable",!0),E?(d.$model=a,E(n,d)):(d[M.itemName]=a,b=M.viewMapper(n,d),d[M.itemName]=void 0,c=M.viewMapper(n,d),b!==c?b:a)}),N.select=function(a){var b,c,e={};x=!0,e[M.itemName]=c=N.matches[a].model,b=M.modelMapper(n,e),L(n,b),t.$setValidity("editable",!0),t.$setValidity("parse",!0),B(n,{$item:c,$model:b,$label:M.viewMapper(n,e)}),R(),N.$eval(p.typeaheadFocusOnSelect)!==!1&&d(function(){o[0].focus()},0,!1)},o.bind("keydown",function(a){if(0!==N.matches.length&&-1!==l.indexOf(a.which)){if(-1===N.activeIdx&&(9===a.which||13===a.which))return R(),void N.$digest();a.preventDefault(),40===a.which?(N.activeIdx=(N.activeIdx+1)%N.matches.length,N.$digest()):38===a.which?(N.activeIdx=(N.activeIdx>0?N.activeIdx:N.matches.length)-1,N.$digest()):13===a.which||9===a.which?N.$apply(function(){N.select(N.activeIdx)}):27===a.which&&(a.stopPropagation(),R(),N.$digest())}}),o.bind("blur",function(){C&&N.matches.length&&-1!==N.activeIdx&&!x&&(x=!0,N.$apply(function(){N.select(N.activeIdx)})),w=!1,x=!1});var Z=function(a){o[0]!==a.target&&3!==a.which&&0!==N.matches.length&&(R(),g.$$phase||N.$digest())};e.bind("click",Z),n.$on("$destroy",function(){e.unbind("click",Z),(F||G)&&$.remove(),F&&(angular.element(f).unbind("resize",r),e.find("body").unbind("scroll",r)),Q.remove()});var $=a(Q)(N);F?e.find("body").append($):G!==!1?angular.element(e[0].getElementById(G)).append($):o.after($)}}}]).directive("typeaheadPopup",["$typeaheadSuppressWarning","$log",function(a,b){return{scope:{matches:"=",query:"=",active:"=",position:"&",moveInProgress:"=",select:"&"},replace:!0,templateUrl:function(a,b){return b.popupTemplateUrl||"template/typeahead/typeahead-popup.html"},link:function(c,d,e){a||b.warn("typeahead-popup is now deprecated. Use uib-typeahead-popup instead."),c.templateUrl=e.templateUrl,c.isOpen=function(){return c.matches.length>0},c.isActive=function(a){return c.active==a},c.selectActive=function(a){c.active=a},c.selectMatch=function(a){c.select({activeIdx:a})}}}}]).directive("typeaheadMatch",["$templateRequest","$compile","$parse","$typeaheadSuppressWarning","$log",function(a,b,c,d,e){return{restrict:"EA",scope:{index:"=",match:"=",query:"="},link:function(f,g,h){d||e.warn("typeahead-match is now deprecated. Use uib-typeahead-match instead.");var i=c(h.templateUrl)(f.$parent)||"template/typeahead/typeahead-match.html";a(i).then(function(a){b(a.trim())(f,function(a){g.replaceWith(a)})})}}}]).filter("typeaheadHighlight",["$sce","$injector","$log","$typeaheadSuppressWarning",function(a,b,c,d){function e(a){return a.replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1")}function f(a){return/<.*>/g.test(a)}var g;return g=b.has("$sanitize"),function(b,h){return d||c.warn("typeaheadHighlight is now deprecated. Use uibTypeaheadHighlight instead."),!g&&f(b)&&c.warn("Unsafe use of typeahead please use ngSanitize"),b=h?(""+b).replace(new RegExp(e(h),"gi"),"<strong>$&</strong>"):b,g||(b=a.trustAsHtml(b)),b}}]),angular.module("template/accordion/accordion-group.html",[]).run(["$templateCache",function(a){a.put("template/accordion/accordion-group.html",'<div class="panel {{panelClass || \'panel-default\'}}">\n  <div class="panel-heading" ng-keypress="toggleOpen($event)">\n    <h4 class="panel-title">\n      <a href tabindex="0" class="accordion-toggle" ng-click="toggleOpen()" uib-accordion-transclude="heading"><span ng-class="{\'text-muted\': isDisabled}">{{heading}}</span></a>\n    </h4>\n  </div>\n  <div class="panel-collapse collapse" uib-collapse="!isOpen">\n	  <div class="panel-body" ng-transclude></div>\n  </div>\n</div>\n')}]),angular.module("template/accordion/accordion.html",[]).run(["$templateCache",function(a){a.put("template/accordion/accordion.html",'<div class="panel-group" ng-transclude></div>')}]),angular.module("template/alert/alert.html",[]).run(["$templateCache",function(a){a.put("template/alert/alert.html",'<div class="alert" ng-class="[\'alert-\' + (type || \'warning\'), closeable ? \'alert-dismissible\' : null]" role="alert">\n    <button ng-show="closeable" type="button" class="close" ng-click="close({$event: $event})">\n        <span aria-hidden="true">&times;</span>\n        <span class="sr-only">Close</span>\n    </button>\n    <div ng-transclude></div>\n</div>\n')}]),angular.module("template/carousel/carousel.html",[]).run(["$templateCache",function(a){a.put("template/carousel/carousel.html",'<div ng-mouseenter="pause()" ng-mouseleave="play()" class="carousel" ng-swipe-right="prev()" ng-swipe-left="next()">\n  <div class="carousel-inner" ng-transclude></div>\n  <a role="button" href class="left carousel-control" ng-click="prev()" ng-show="slides.length > 1">\n    <span aria-hidden="true" class="glyphicon glyphicon-chevron-left"></span>\n    <span class="sr-only">previous</span>\n  </a>\n  <a role="button" href class="right carousel-control" ng-click="next()" ng-show="slides.length > 1">\n    <span aria-hidden="true" class="glyphicon glyphicon-chevron-right"></span>\n    <span class="sr-only">next</span>\n  </a>\n  <ol class="carousel-indicators" ng-show="slides.length > 1">\n    <li ng-repeat="slide in slides | orderBy:indexOfSlide track by $index" ng-class="{ active: isActive(slide) }" ng-click="select(slide)">\n      <span class="sr-only">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if="isActive(slide)">, currently active</span></span>\n    </li>\n  </ol>\n</div>')}]),angular.module("template/carousel/slide.html",[]).run(["$templateCache",function(a){a.put("template/carousel/slide.html",'<div ng-class="{\n    \'active\': active\n  }" class="item text-center" ng-transclude></div>\n')}]),angular.module("template/datepicker/datepicker.html",[]).run(["$templateCache",function(a){a.put("template/datepicker/datepicker.html",'<div ng-switch="datepickerMode" role="application" ng-keydown="keydown($event)">\n  <uib-daypicker ng-switch-when="day" tabindex="0"></uib-daypicker>\n  <uib-monthpicker ng-switch-when="month" tabindex="0"></uib-monthpicker>\n  <uib-yearpicker ng-switch-when="year" tabindex="0"></uib-yearpicker>\n</div>')}]),angular.module("template/datepicker/day.html",[]).run(["$templateCache",function(a){a.put("template/datepicker/day.html",'<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th colspan="{{::5 + showWeeks}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n    <tr>\n      <th ng-if="showWeeks" class="text-center"></th>\n      <th ng-repeat="label in ::labels track by $index" class="text-center"><small aria-label="{{::label.full}}">{{::label.abbr}}</small></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat="row in rows track by $index">\n      <td ng-if="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index] }}</em></td>\n      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}" ng-class="::dt.customClass">\n        <button type="button" style="min-width:100%;" class="btn btn-default btn-sm" ng-class="{\'btn-info\': dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="::{\'text-muted\': dt.secondary, \'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("template/datepicker/month.html",[]).run(["$templateCache",function(a){a.put("template/datepicker/month.html",'<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat="row in rows track by $index">\n      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}" ng-class="::dt.customClass">\n        <button type="button" style="min-width:100%;" class="btn btn-default" ng-class="{\'btn-info\': dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="::{\'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("template/datepicker/popup.html",[]).run(["$templateCache",function(a){a.put("template/datepicker/popup.html",'<ul class="dropdown-menu" dropdown-nested ng-if="isOpen" style="display: block" ng-style="{top: position.top+\'px\', left: position.left+\'px\'}" ng-keydown="keydown($event)" ng-click="$event.stopPropagation()">\n	<li ng-transclude></li>\n	<li ng-if="showButtonBar" style="padding:10px 9px 2px">\n		<span class="btn-group pull-left">\n			<button type="button" class="btn btn-sm btn-info" ng-click="select(\'today\')" ng-disabled="isDisabled(\'today\')">{{ getText(\'current\') }}</button>\n			<button type="button" class="btn btn-sm btn-danger" ng-click="select(null)">{{ getText(\'clear\') }}</button>\n		</span>\n		<button type="button" class="btn btn-sm btn-success pull-right" ng-click="close()">{{ getText(\'close\') }}</button>\n	</li>\n</ul>\n')}]),angular.module("template/datepicker/year.html",[]).run(["$templateCache",function(a){a.put("template/datepicker/year.html",'<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th colspan="3"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat="row in rows track by $index">\n      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}" ng-class="::dt.customClass">\n        <button type="button" style="min-width:100%;" class="btn btn-default" ng-class="{\'btn-info\': dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="::{\'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("template/modal/backdrop.html",[]).run(["$templateCache",function(a){a.put("template/modal/backdrop.html",'<div uib-modal-animation-class="fade"\n     modal-in-class="in"\n     ng-style="{\'z-index\': 1040 + (index && 1 || 0) + index*10}"\n></div>\n')}]),angular.module("template/modal/window.html",[]).run(["$templateCache",function(a){a.put("template/modal/window.html",'<div modal-render="{{$isRendered}}" tabindex="-1" role="dialog" class="modal"\n    uib-modal-animation-class="fade"\n    modal-in-class="in"\n    ng-style="{\'z-index\': 1050 + index*10, display: \'block\'}">\n    <div class="modal-dialog" ng-class="size ? \'modal-\' + size : \'\'"><div class="modal-content" uib-modal-transclude></div></div>\n</div>\n')}]),angular.module("template/pagination/pager.html",[]).run(["$templateCache",function(a){a.put("template/pagination/pager.html",'<ul class="pager">\n  <li ng-class="{disabled: noPrevious()||ngDisabled, previous: align}"><a href ng-click="selectPage(page - 1, $event)">{{::getText(\'previous\')}}</a></li>\n  <li ng-class="{disabled: noNext()||ngDisabled, next: align}"><a href ng-click="selectPage(page + 1, $event)">{{::getText(\'next\')}}</a></li>\n</ul>\n')}]),angular.module("template/pagination/pagination.html",[]).run(["$templateCache",function(a){a.put("template/pagination/pagination.html",'<ul class="pagination">\n  <li ng-if="::boundaryLinks" ng-class="{disabled: noPrevious()||ngDisabled}" class="pagination-first"><a href ng-click="selectPage(1, $event)">{{::getText(\'first\')}}</a></li>\n  <li ng-if="::directionLinks" ng-class="{disabled: noPrevious()||ngDisabled}" class="pagination-prev"><a href ng-click="selectPage(page - 1, $event)">{{::getText(\'previous\')}}</a></li>\n  <li ng-repeat="page in pages track by $index" ng-class="{active: page.active,disabled: ngDisabled&&!page.active}" class="pagination-page"><a href ng-click="selectPage(page.number, $event)">{{page.text}}</a></li>\n  <li ng-if="::directionLinks" ng-class="{disabled: noNext()||ngDisabled}" class="pagination-next"><a href ng-click="selectPage(page + 1, $event)">{{::getText(\'next\')}}</a></li>\n  <li ng-if="::boundaryLinks" ng-class="{disabled: noNext()||ngDisabled}" class="pagination-last"><a href ng-click="selectPage(totalPages, $event)">{{::getText(\'last\')}}</a></li>\n</ul>\n')}]),angular.module("template/tooltip/tooltip-html-popup.html",[]).run(["$templateCache",function(a){a.put("template/tooltip/tooltip-html-popup.html",'<div\n  tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner" ng-bind-html="contentExp()"></div>\n</div>\n')}]),angular.module("template/tooltip/tooltip-popup.html",[]).run(["$templateCache",function(a){a.put("template/tooltip/tooltip-popup.html",'<div\n  tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner" ng-bind="content"></div>\n</div>\n')}]),angular.module("template/tooltip/tooltip-template-popup.html",[]).run(["$templateCache",function(a){a.put("template/tooltip/tooltip-template-popup.html",'<div\n  tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner"\n    uib-tooltip-template-transclude="contentExp()"\n    tooltip-template-transclude-scope="originScope()"></div>\n</div>\n')}]),angular.module("template/popover/popover-html.html",[]).run(["$templateCache",function(a){a.put("template/popover/popover-html.html",'<div tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="arrow"></div>\n\n  <div class="popover-inner">\n      <h3 class="popover-title" ng-bind="title" ng-if="title"></h3>\n      <div class="popover-content" ng-bind-html="contentExp()"></div>\n  </div>\n</div>\n')}]),angular.module("template/popover/popover-template.html",[]).run(["$templateCache",function(a){a.put("template/popover/popover-template.html",'<div tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="arrow"></div>\n\n  <div class="popover-inner">\n      <h3 class="popover-title" ng-bind="title" ng-if="title"></h3>\n      <div class="popover-content"\n        uib-tooltip-template-transclude="contentExp()"\n        tooltip-template-transclude-scope="originScope()"></div>\n  </div>\n</div>\n')}]),angular.module("template/popover/popover.html",[]).run(["$templateCache",function(a){a.put("template/popover/popover.html",'<div tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="arrow"></div>\n\n  <div class="popover-inner">\n      <h3 class="popover-title" ng-bind="title" ng-if="title"></h3>\n      <div class="popover-content" ng-bind="content"></div>\n  </div>\n</div>\n')}]),angular.module("template/progressbar/bar.html",[]).run(["$templateCache",function(a){a.put("template/progressbar/bar.html",'<div class="progress-bar" ng-class="type && \'progress-bar-\' + type" role="progressbar" aria-valuenow="{{value}}" aria-valuemin="0" aria-valuemax="{{max}}" ng-style="{width: (percent < 100 ? percent : 100) + \'%\'}" aria-valuetext="{{percent | number:0}}%" aria-labelledby="{{::title}}" style="min-width: 0;" ng-transclude></div>\n')}]),angular.module("template/progressbar/progress.html",[]).run(["$templateCache",function(a){a.put("template/progressbar/progress.html",'<div class="progress" ng-transclude aria-labelledby="{{::title}}"></div>')}]),angular.module("template/progressbar/progressbar.html",[]).run(["$templateCache",function(a){a.put("template/progressbar/progressbar.html",'<div class="progress">\n  <div class="progress-bar" ng-class="type && \'progress-bar-\' + type" role="progressbar" aria-valuenow="{{value}}" aria-valuemin="0" aria-valuemax="{{max}}" ng-style="{width: (percent < 100 ? percent : 100) + \'%\'}" aria-valuetext="{{percent | number:0}}%" aria-labelledby="{{::title}}" style="min-width: 0;" ng-transclude></div>\n</div>\n')}]),angular.module("template/rating/rating.html",[]).run(["$templateCache",function(a){a.put("template/rating/rating.html",'<span ng-mouseleave="reset()" ng-keydown="onKeydown($event)" tabindex="0" role="slider" aria-valuemin="0" aria-valuemax="{{range.length}}" aria-valuenow="{{value}}">\n    <span ng-repeat-start="r in range track by $index" class="sr-only">({{ $index < value ? \'*\' : \' \' }})</span>\n    <i ng-repeat-end ng-mouseenter="enter($index + 1)" ng-click="rate($index + 1)" class="glyphicon" ng-class="$index < value && (r.stateOn || \'glyphicon-star\') || (r.stateOff || \'glyphicon-star-empty\')" ng-attr-title="{{r.title}}" aria-valuetext="{{r.title}}"></i>\n</span>\n');
	}]),angular.module("template/tabs/tab.html",[]).run(["$templateCache",function(a){a.put("template/tabs/tab.html",'<li ng-class="{active: active, disabled: disabled}">\n  <a href ng-click="select()" uib-tab-heading-transclude>{{heading}}</a>\n</li>\n')}]),angular.module("template/tabs/tabset.html",[]).run(["$templateCache",function(a){a.put("template/tabs/tabset.html",'<div>\n  <ul class="nav nav-{{type || \'tabs\'}}" ng-class="{\'nav-stacked\': vertical, \'nav-justified\': justified}" ng-transclude></ul>\n  <div class="tab-content">\n    <div class="tab-pane" \n         ng-repeat="tab in tabs" \n         ng-class="{active: tab.active}"\n         uib-tab-content-transclude="tab">\n    </div>\n  </div>\n</div>\n')}]),angular.module("template/timepicker/timepicker.html",[]).run(["$templateCache",function(a){a.put("template/timepicker/timepicker.html",'<table>\n  <tbody>\n    <tr class="text-center" ng-show="::showSpinners">\n      <td><a ng-click="incrementHours()" ng-class="{disabled: noIncrementHours()}" class="btn btn-link" ng-disabled="noIncrementHours()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n      <td>&nbsp;</td>\n      <td><a ng-click="incrementMinutes()" ng-class="{disabled: noIncrementMinutes()}" class="btn btn-link" ng-disabled="noIncrementMinutes()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n      <td ng-show="showMeridian"></td>\n    </tr>\n    <tr>\n      <td class="form-group" ng-class="{\'has-error\': invalidHours}">\n        <input style="width:50px;" type="text" ng-model="hours" ng-change="updateHours()" class="form-control text-center" ng-readonly="::readonlyInput" maxlength="2" tabindex="{{::tabindex}}">\n      </td>\n      <td>:</td>\n      <td class="form-group" ng-class="{\'has-error\': invalidMinutes}">\n        <input style="width:50px;" type="text" ng-model="minutes" ng-change="updateMinutes()" class="form-control text-center" ng-readonly="::readonlyInput" maxlength="2" tabindex="{{::tabindex}}">\n      </td>\n      <td ng-show="showMeridian"><button type="button" ng-class="{disabled: noToggleMeridian()}" class="btn btn-default text-center" ng-click="toggleMeridian()" ng-disabled="noToggleMeridian()" tabindex="{{::tabindex}}">{{meridian}}</button></td>\n    </tr>\n    <tr class="text-center" ng-show="::showSpinners">\n      <td><a ng-click="decrementHours()" ng-class="{disabled: noDecrementHours()}" class="btn btn-link" ng-disabled="noDecrementHours()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n      <td>&nbsp;</td>\n      <td><a ng-click="decrementMinutes()" ng-class="{disabled: noDecrementMinutes()}" class="btn btn-link" ng-disabled="noDecrementMinutes()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n      <td ng-show="showMeridian"></td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("template/typeahead/typeahead-match.html",[]).run(["$templateCache",function(a){a.put("template/typeahead/typeahead-match.html",'<a href tabindex="-1" ng-bind-html="match.label | uibTypeaheadHighlight:query"></a>\n')}]),angular.module("template/typeahead/typeahead-popup.html",[]).run(["$templateCache",function(a){a.put("template/typeahead/typeahead-popup.html",'<ul class="dropdown-menu" ng-show="isOpen() && !moveInProgress" ng-style="{top: position().top+\'px\', left: position().left+\'px\'}" style="display: block;" role="listbox" aria-hidden="{{!isOpen()}}">\n    <li ng-repeat="match in matches track by $index" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" ng-click="selectMatch($index)" role="option" id="{{::match.id}}">\n        <div uib-typeahead-match index="$index" match="match" query="query" template-url="templateUrl"></div>\n    </li>\n</ul>\n')}]),!angular.$$csp()&&angular.element(document).find("head").prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>');

/***/ }),
/* 478 */
/***/ (function(module, exports) {

	angular.module('angular-clipboard', [])
	    .directive('clipboard', ['$document', function ($document) {
	        return {
	            restrict: 'A',
	            scope: {
	                onCopied: '&',
	                onError: '&',
	                text: '='
	            },
	            link: function (scope, element) {
	                function createNode(text) {
	                    var node = $document[0].createElement('span');
	                    node.style.position = 'absolute';
	                    node.style.left = '-10000px';
	                    node.textContent = text;
	                    return node;
	                }
	
	                function copyNode(node) {
	                    var selection = $document[0].getSelection();
	                    selection.removeAllRanges();
	
	                    var range = $document[0].createRange();
	                    range.selectNodeContents(node);
	                    selection.addRange(range);
	
	                    $document[0].execCommand('copy');
	                    selection.removeAllRanges();
	                }
	
	                function copyText(text) {
	                    var node = createNode(text);
	                    $document[0].body.appendChild(node);
	                    copyNode(node);
	                    $document[0].body.removeChild(node);
	                }
	
	                element.on('click', function (event) {
	                    try {
	                        copyText(scope.text);
	                        if (scope.onCopied) {
	                            scope.onCopied();
	                        }
	                    } catch (err) {
	                        if (scope.onError) {
	                            scope.onError({err: err});
	                        }
	                    }
	                });
	            }
	        };
	    }]);

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.7.9
	 * (c) 2010-2018 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngCookies
	 * @description
	 *
	 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
	 *
	 * See {@link ngCookies.$cookies `$cookies`} for usage.
	 */
	
	
	angular.module('ngCookies', ['ng']).
	  info({ angularVersion: '1.7.9' }).
	  /**
	   * @ngdoc provider
	   * @name $cookiesProvider
	   * @description
	   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
	   * */
	   provider('$cookies', [/** @this */function $CookiesProvider() {
	    /**
	     * @ngdoc property
	     * @name $cookiesProvider#defaults
	     * @description
	     *
	     * Object containing default options to pass when setting cookies.
	     *
	     * The object may have following properties:
	     *
	     * - **path** - `{string}` - The cookie will be available only for this path and its
	     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
	     * - **domain** - `{string}` - The cookie will be available only for this domain and
	     *   its sub-domains. For security reasons the user agent will not accept the cookie
	     *   if the current domain is not a sub-domain of this domain or equal to it.
	     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
	     *   or a Date object indicating the exact date/time this cookie will expire.
	     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
	     *   secured connection.
	     * - **samesite** - `{string}` - prevents the browser from sending the cookie along with cross-site requests.
	     *   Accepts the values `lax` and `strict`. See the [OWASP Wiki](https://www.owasp.org/index.php/SameSite)
	     *   for more info. Note that as of May 2018, not all browsers support `SameSite`,
	     *   so it cannot be used as a single measure against Cross-Site-Request-Forgery (CSRF) attacks.
	     *
	     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
	     * This is important so that cookies will be visible for all routes when html5mode is enabled.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesProviderExample', ['ngCookies'])
	     *   .config(['$cookiesProvider', function($cookiesProvider) {
	     *     // Setting default options
	     *     $cookiesProvider.defaults.domain = 'foo.com';
	     *     $cookiesProvider.defaults.secure = true;
	     *   }]);
	     * ```
	     **/
	    var defaults = this.defaults = {};
	
	    function calcOptions(options) {
	      return options ? angular.extend({}, defaults, options) : defaults;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $cookies
	     *
	     * @description
	     * Provides read/write access to browser's cookies.
	     *
	     * <div class="alert alert-info">
	     * Up until AngularJS 1.3, `$cookies` exposed properties that represented the
	     * current browser cookie values. In version 1.4, this behavior has changed, and
	     * `$cookies` now provides a standard api of getters, setters etc.
	     * </div>
	     *
	     * Requires the {@link ngCookies `ngCookies`} module to be installed.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesExample', ['ngCookies'])
	     *   .controller('ExampleController', ['$cookies', function($cookies) {
	     *     // Retrieving a cookie
	     *     var favoriteCookie = $cookies.get('myFavorite');
	     *     // Setting a cookie
	     *     $cookies.put('myFavorite', 'oatmeal');
	     *   }]);
	     * ```
	     */
	    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
	      return {
	        /**
	         * @ngdoc method
	         * @name $cookies#get
	         *
	         * @description
	         * Returns the value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {string} Raw cookie value.
	         */
	        get: function(key) {
	          return $$cookieReader()[key];
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getObject
	         *
	         * @description
	         * Returns the deserialized value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {Object} Deserialized cookie value.
	         */
	        getObject: function(key) {
	          var value = this.get(key);
	          return value ? angular.fromJson(value) : value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getAll
	         *
	         * @description
	         * Returns a key value object with all the cookies
	         *
	         * @returns {Object} All cookies
	         */
	        getAll: function() {
	          return $$cookieReader();
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#put
	         *
	         * @description
	         * Sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {string} value Raw value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        put: function(key, value, options) {
	          $$cookieWriter(key, value, calcOptions(options));
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#putObject
	         *
	         * @description
	         * Serializes and sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {Object} value Value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        putObject: function(key, value, options) {
	          this.put(key, angular.toJson(value), options);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#remove
	         *
	         * @description
	         * Remove given cookie
	         *
	         * @param {string} key Id of the key-value pair to delete.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        remove: function(key, options) {
	          $$cookieWriter(key, undefined, calcOptions(options));
	        }
	      };
	    }];
	  }]);
	
	/**
	 * @name $$cookieWriter
	 * @requires $document
	 *
	 * @description
	 * This is a private service for writing cookies
	 *
	 * @param {string} name Cookie name
	 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
	 * @param {Object=} options Object with options that need to be stored for the cookie.
	 */
	function $$CookieWriter($document, $log, $browser) {
	  var cookiePath = $browser.baseHref();
	  var rawDocument = $document[0];
	
	  function buildCookieString(name, value, options) {
	    var path, expires;
	    options = options || {};
	    expires = options.expires;
	    path = angular.isDefined(options.path) ? options.path : cookiePath;
	    if (angular.isUndefined(value)) {
	      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
	      value = '';
	    }
	    if (angular.isString(expires)) {
	      expires = new Date(expires);
	    }
	
	    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
	    str += path ? ';path=' + path : '';
	    str += options.domain ? ';domain=' + options.domain : '';
	    str += expires ? ';expires=' + expires.toUTCString() : '';
	    str += options.secure ? ';secure' : '';
	    str += options.samesite ? ';samesite=' + options.samesite : '';
	
	    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
	    // - 300 cookies
	    // - 20 cookies per unique domain
	    // - 4096 bytes per cookie
	    var cookieLength = str.length + 1;
	    if (cookieLength > 4096) {
	      $log.warn('Cookie \'' + name +
	        '\' possibly not set or overflowed because it was too large (' +
	        cookieLength + ' > 4096 bytes)!');
	    }
	
	    return str;
	  }
	
	  return function(name, value, options) {
	    rawDocument.cookie = buildCookieString(name, value, options);
	  };
	}
	
	$$CookieWriter.$inject = ['$document', '$log', '$browser'];
	
	angular.module('ngCookies').provider('$$cookieWriter', /** @this */ function $$CookieWriterProvider() {
	  this.$get = $$CookieWriter;
	});
	
	
	})(window, window.angular);


/***/ }),
/* 480 */
/***/ (function(module, exports) {

	/*
	 AngularJS v1.7.9
	 (c) 2010-2018 Google, Inc. http://angularjs.org
	 License: MIT
	*/
	(function(I,b){'use strict';function z(b,h){var d=[],c=b.replace(/([().])/g,"\\$1").replace(/(\/)?:(\w+)(\*\?|[?*])?/g,function(b,c,h,k){b="?"===k||"*?"===k;k="*"===k||"*?"===k;d.push({name:h,optional:b});c=c||"";return(b?"(?:"+c:c+"(?:")+(k?"(.+?)":"([^/]+)")+(b?"?)?":")")}).replace(/([/$*])/g,"\\$1");h.ignoreTrailingSlashes&&(c=c.replace(/\/+$/,"")+"/*");return{keys:d,regexp:new RegExp("^"+c+"(?:[?#]|$)",h.caseInsensitiveMatch?"i":"")}}function A(b){p&&b.get("$route")}function v(u,h,d){return{restrict:"ECA",
	terminal:!0,priority:400,transclude:"element",link:function(c,f,g,l,k){function q(){r&&(d.cancel(r),r=null);m&&(m.$destroy(),m=null);s&&(r=d.leave(s),r.done(function(b){!1!==b&&(r=null)}),s=null)}function C(){var g=u.current&&u.current.locals;if(b.isDefined(g&&g.$template)){var g=c.$new(),l=u.current;s=k(g,function(g){d.enter(g,null,s||f).done(function(d){!1===d||!b.isDefined(w)||w&&!c.$eval(w)||h()});q()});m=l.scope=g;m.$emit("$viewContentLoaded");m.$eval(p)}else q()}var m,s,r,w=g.autoscroll,p=g.onload||
	"";c.$on("$routeChangeSuccess",C);C()}}}function x(b,h,d){return{restrict:"ECA",priority:-400,link:function(c,f){var g=d.current,l=g.locals;f.html(l.$template);var k=b(f.contents());if(g.controller){l.$scope=c;var q=h(g.controller,l);g.controllerAs&&(c[g.controllerAs]=q);f.data("$ngControllerController",q);f.children().data("$ngControllerController",q)}c[g.resolveAs||"$resolve"]=l;k(c)}}}var D,E,F,G,y=b.module("ngRoute",[]).info({angularVersion:"1.7.9"}).provider("$route",function(){function u(d,
	c){return b.extend(Object.create(d),c)}D=b.isArray;E=b.isObject;F=b.isDefined;G=b.noop;var h={};this.when=function(d,c){var f;f=void 0;if(D(c)){f=f||[];for(var g=0,l=c.length;g<l;g++)f[g]=c[g]}else if(E(c))for(g in f=f||{},c)if("$"!==g.charAt(0)||"$"!==g.charAt(1))f[g]=c[g];f=f||c;b.isUndefined(f.reloadOnUrl)&&(f.reloadOnUrl=!0);b.isUndefined(f.reloadOnSearch)&&(f.reloadOnSearch=!0);b.isUndefined(f.caseInsensitiveMatch)&&(f.caseInsensitiveMatch=this.caseInsensitiveMatch);h[d]=b.extend(f,{originalPath:d},
	d&&z(d,f));d&&(g="/"===d[d.length-1]?d.substr(0,d.length-1):d+"/",h[g]=b.extend({originalPath:d,redirectTo:d},z(g,f)));return this};this.caseInsensitiveMatch=!1;this.otherwise=function(b){"string"===typeof b&&(b={redirectTo:b});this.when(null,b);return this};p=!0;this.eagerInstantiationEnabled=function(b){return F(b)?(p=b,this):p};this.$get=["$rootScope","$location","$routeParams","$q","$injector","$templateRequest","$sce","$browser",function(d,c,f,g,l,k,q,p){function m(a){var e=t.current;n=A();(x=
	!B&&n&&e&&n.$$route===e.$$route&&(!n.reloadOnUrl||!n.reloadOnSearch&&b.equals(n.pathParams,e.pathParams)))||!e&&!n||d.$broadcast("$routeChangeStart",n,e).defaultPrevented&&a&&a.preventDefault()}function s(){var a=t.current,e=n;if(x)a.params=e.params,b.copy(a.params,f),d.$broadcast("$routeUpdate",a);else if(e||a){B=!1;t.current=e;var c=g.resolve(e);p.$$incOutstandingRequestCount("$route");c.then(r).then(w).then(function(g){return g&&c.then(y).then(function(c){e===t.current&&(e&&(e.locals=c,b.copy(e.params,
	f)),d.$broadcast("$routeChangeSuccess",e,a))})}).catch(function(b){e===t.current&&d.$broadcast("$routeChangeError",e,a,b)}).finally(function(){p.$$completeOutstandingRequest(G,"$route")})}}function r(a){var e={route:a,hasRedirection:!1};if(a)if(a.redirectTo)if(b.isString(a.redirectTo))e.path=v(a.redirectTo,a.params),e.search=a.params,e.hasRedirection=!0;else{var d=c.path(),f=c.search();a=a.redirectTo(a.pathParams,d,f);b.isDefined(a)&&(e.url=a,e.hasRedirection=!0)}else if(a.resolveRedirectTo)return g.resolve(l.invoke(a.resolveRedirectTo)).then(function(a){b.isDefined(a)&&
	(e.url=a,e.hasRedirection=!0);return e});return e}function w(a){var b=!0;if(a.route!==t.current)b=!1;else if(a.hasRedirection){var g=c.url(),d=a.url;d?c.url(d).replace():d=c.path(a.path).search(a.search).replace().url();d!==g&&(b=!1)}return b}function y(a){if(a){var e=b.extend({},a.resolve);b.forEach(e,function(a,c){e[c]=b.isString(a)?l.get(a):l.invoke(a,null,null,c)});a=z(a);b.isDefined(a)&&(e.$template=a);return g.all(e)}}function z(a){var e,c;b.isDefined(e=a.template)?b.isFunction(e)&&(e=e(a.params)):
	b.isDefined(c=a.templateUrl)&&(b.isFunction(c)&&(c=c(a.params)),b.isDefined(c)&&(a.loadedTemplateUrl=q.valueOf(c),e=k(c)));return e}function A(){var a,e;b.forEach(h,function(d,g){var f;if(f=!e){var h=c.path();f=d.keys;var l={};if(d.regexp)if(h=d.regexp.exec(h)){for(var k=1,p=h.length;k<p;++k){var m=f[k-1],n=h[k];m&&n&&(l[m.name]=n)}f=l}else f=null;else f=null;f=a=f}f&&(e=u(d,{params:b.extend({},c.search(),a),pathParams:a}),e.$$route=d)});return e||h[null]&&u(h[null],{params:{},pathParams:{}})}function v(a,
	c){var d=[];b.forEach((a||"").split(":"),function(a,b){if(0===b)d.push(a);else{var f=a.match(/(\w+)(?:[?*])?(.*)/),g=f[1];d.push(c[g]);d.push(f[2]||"");delete c[g]}});return d.join("")}var B=!1,n,x,t={routes:h,reload:function(){B=!0;var a={defaultPrevented:!1,preventDefault:function(){this.defaultPrevented=!0;B=!1}};d.$evalAsync(function(){m(a);a.defaultPrevented||s()})},updateParams:function(a){if(this.current&&this.current.$$route)a=b.extend({},this.current.params,a),c.path(v(this.current.$$route.originalPath,
	a)),c.search(a);else throw H("norout");}};d.$on("$locationChangeStart",m);d.$on("$locationChangeSuccess",s);return t}]}).run(A),H=b.$$minErr("ngRoute"),p;A.$inject=["$injector"];y.provider("$routeParams",function(){this.$get=function(){return{}}});y.directive("ngView",v);y.directive("ngView",x);v.$inject=["$route","$anchorScroll","$animate"];x.$inject=["$compile","$controller","$route"]})(window,window.angular);
	//# sourceMappingURL=angular-route.min.js.map


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.19.1 - 2024-01-21
	 * 
	 * Copyright (c) 2024 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	$translateStaticFilesLoader.$inject = ['$q', '$http'];
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateStaticFilesLoader
	 * @requires $q
	 * @requires $http
	 *
	 * @description
	 * Creates a loading function for a typical static file url pattern:
	 * "lang-en_US.json", "lang-de_DE.json", etc. Using this builder,
	 * the response of these urls must be an object of key-value pairs.
	 *
	 * @param {object} options Options object, which gets prefix, suffix, key, and fileMap
	 */
	.factory('$translateStaticFilesLoader', $translateStaticFilesLoader);
	
	function $translateStaticFilesLoader($q, $http) {
	
	  'use strict';
	
	  return function (options) {
	
	    if (!options || (!angular.isArray(options.files) && (!angular.isString(options.prefix) || !angular.isString(options.suffix)))) {
	      throw new Error('Couldn\'t load static files, no files and prefix or suffix specified!');
	    }
	
	    if (!options.files) {
	      options.files = [{
	        prefix: options.prefix,
	        suffix: options.suffix
	      }];
	    }
	
	    var load = function (file) {
	      if (!file || (!angular.isString(file.prefix) || !angular.isString(file.suffix))) {
	        throw new Error('Couldn\'t load static file, no prefix or suffix specified!');
	      }
	
	      var fileUrl = [
	        file.prefix,
	        options.key,
	        file.suffix
	      ].join('');
	
	      if (angular.isObject(options.fileMap) && options.fileMap[fileUrl]) {
	        fileUrl = options.fileMap[fileUrl];
	      }
	
	      return $http(angular.extend({
	        url: fileUrl,
	        method: 'GET'
	      }, options.$http))
	        .then(function(result) {
	          return result.data;
	        }, function () {
	          return $q.reject(options.key);
	        });
	    };
	
	    var promises = [],
	        length = options.files.length;
	
	    for (var i = 0; i < length; i++) {
	      promises.push(load({
	        prefix: options.files[i].prefix,
	        key: options.key,
	        suffix: options.files[i].suffix
	      }));
	    }
	
	    return $q.all(promises)
	      .then(function (data) {
	        var length = data.length,
	            mergedData = {};
	
	        for (var i = 0; i < length; i++) {
	          for (var key in data[i]) {
	            mergedData[key] = data[i][key];
	          }
	        }
	
	        return mergedData;
	      });
	  };
	}
	
	$translateStaticFilesLoader.displayName = '$translateStaticFilesLoader';
	return 'pascalprecht.translate';
	
	}));


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.19.1 - 2024-01-21
	 * 
	 * Copyright (c) 2024 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	/**
	 * @ngdoc overview
	 * @name pascalprecht.translate
	 *
	 * @description
	 * The main module which holds everything together.
	 */
	runTranslate.$inject = ['$translate'];
	$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
	$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
	translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
	translateAttrDirective.$inject = ['$translate', '$rootScope'];
	translateCloakDirective.$inject = ['$translate', '$rootScope'];
	translateFilterFactory.$inject = ['$parse', '$translate'];
	$translationCache.$inject = ['$cacheFactory'];
	angular.module('pascalprecht.translate', ['ng'])
	  .run(runTranslate);
	
	function runTranslate($translate) {
	
	  'use strict';
	
	  var key = $translate.storageKey(),
	    storage = $translate.storage();
	
	  var fallbackFromIncorrectStorageValue = function () {
	    var preferred = $translate.preferredLanguage();
	    if (angular.isString(preferred)) {
	      $translate.use(preferred);
	      // $translate.use() will also remember the language.
	      // So, we don't need to call storage.put() here.
	    } else {
	      storage.put(key, $translate.use());
	    }
	  };
	
	  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';
	
	  if (storage) {
	    if (!storage.get(key)) {
	      fallbackFromIncorrectStorageValue();
	    } else {
	      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
	    }
	  } else if (angular.isString($translate.preferredLanguage())) {
	    $translate.use($translate.preferredLanguage());
	  }
	}
	
	runTranslate.displayName = 'runTranslate';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateSanitizationProvider
	 *
	 * @description
	 *
	 * Configurations for $translateSanitization
	 */
	angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);
	
	function $translateSanitizationProvider () {
	
	  'use strict';
	
	  var $sanitize,
	      $sce,
	      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
	      hasConfiguredStrategy = false,
	      hasShownNoStrategyConfiguredWarning = false,
	      strategies;
	
	  /**
	   * Definition of a sanitization strategy function
	   * @callback StrategyFunction
	   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
	   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
	   * @return {string|object}
	   */
	
	  /**
	   * @ngdoc property
	   * @name strategies
	   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Following strategies are built-in:
	   * <dl>
	   *   <dt>sanitize</dt>
	   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
	   *   <dt>escape</dt>
	   *   <dd>Escapes HTML in the translation</dd>
	   *   <dt>sanitizeParameters</dt>
	   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
	   *   <dt>escapeParameters</dt>
	   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
	   *   <dt>escaped</dt>
	   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
	   * </dl>
	   *
	   */
	
	  strategies = {
	    sanitize: function (value, mode/*, context*/) {
	      if (mode === 'text') {
	        value = htmlSanitizeValue(value);
	      }
	      return value;
	    },
	    escape: function (value, mode/*, context*/) {
	      if (mode === 'text') {
	        value = htmlEscapeValue(value);
	      }
	      return value;
	    },
	    sanitizeParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlSanitizeValue);
	      }
	      return value;
	    },
	    escapeParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlEscapeValue);
	      }
	      return value;
	    },
	    sce: function (value, mode, context) {
	      if (mode === 'text') {
	        value = htmlTrustValue(value);
	      } else if (mode === 'params') {
	        if (context !== 'filter') {
	          // do html escape in filter context #1101
	          value = mapInterpolationParameters(value, htmlEscapeValue);
	        }
	      }
	      return value;
	    },
	    sceParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlTrustValue);
	      }
	      return value;
	    }
	  };
	  // Support legacy strategy name 'escaped' for backwards compatibility.
	  // TODO should be removed in 3.0
	  strategies.escaped = strategies.escapeParameters;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Adds a sanitization strategy to the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @param {StrategyFunction} strategyFunction - strategy function
	   * @returns {object} this
	   */
	  this.addStrategy = function (strategyName, strategyFunction) {
	    strategies[strategyName] = strategyFunction;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Removes a sanitization strategy from the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @returns {object} this
	   */
	  this.removeStrategy = function (strategyName) {
	    delete strategies[strategyName];
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	   *
	   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	   * @returns {object} this
	   */
	  this.useStrategy = function (strategy) {
	    hasConfiguredStrategy = true;
	    currentStrategy = strategy;
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translateSanitization
	   * @requires $injector
	   * @requires $log
	   *
	   * @description
	   * Sanitizes interpolation parameters and translated texts.
	   *
	   */
	  this.$get = ['$injector', '$log', function ($injector, $log) {
	
	    var cachedStrategyMap = {};
	
	    var applyStrategies = function (value, mode, context, selectedStrategies) {
	      angular.forEach(selectedStrategies, function (selectedStrategy) {
	        if (angular.isFunction(selectedStrategy)) {
	          value = selectedStrategy(value, mode, context);
	        } else if (angular.isFunction(strategies[selectedStrategy])) {
	          value = strategies[selectedStrategy](value, mode, context);
	        } else if (angular.isString(strategies[selectedStrategy])) {
	          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
	            try {
	              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
	            } catch (e) {
	              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
	              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	            }
	          }
	          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
	        } else {
	          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	        }
	      });
	      return value;
	    };
	
	    // TODO: should be removed in 3.0
	    var showNoStrategyConfiguredWarning = function () {
	      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
	        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
	        hasShownNoStrategyConfiguredWarning = true;
	      }
	    };
	
	    if ($injector.has('$sanitize')) {
	      $sanitize = $injector.get('$sanitize');
	    }
	    if ($injector.has('$sce')) {
	      $sce = $injector.get('$sce');
	    }
	
	    return {
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#useStrategy
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	       *
	       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	       */
	      useStrategy: (function (self) {
	        return function (strategy) {
	          self.useStrategy(strategy);
	        };
	      })(this),
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#sanitize
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Sanitizes a value.
	       *
	       * @param {string|object} value The value which should be sanitized.
	       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
	       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
	       * @param {string} [context] The context of this call: filter, service. Default is service
	       * @returns {string|object} sanitized value
	       */
	      sanitize: function (value, mode, strategy, context) {
	        if (!currentStrategy) {
	          showNoStrategyConfiguredWarning();
	        }
	
	        if (!strategy && strategy !== null) {
	          strategy = currentStrategy;
	        }
	
	        if (!strategy) {
	          return value;
	        }
	
	        if (!context) {
	          context = 'service';
	        }
	
	        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
	        return applyStrategies(value, mode, context, selectedStrategies);
	      }
	    };
	  }];
	
	  var htmlEscapeValue = function (value) {
	    var element = angular.element('<div></div>');
	    element.text(value); // not chainable, see #1044
	    return element.html();
	  };
	
	  var htmlSanitizeValue = function (value) {
	    if (!$sanitize) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
	    }
	    return $sanitize(value);
	  };
	
	  var htmlTrustValue = function (value) {
	    if (!$sce) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
	    }
	    return $sce.trustAsHtml(value);
	  };
	
	  var mapInterpolationParameters = function (value, iteratee, stack) {
	    if (angular.isDate(value)) {
	      return value;
	    } else if (angular.isObject(value)) {
	      var result = angular.isArray(value) ? [] : {};
	
	      if (!stack) {
	        stack = [];
	      } else {
	        if (stack.indexOf(value) > -1) {
	          throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
	        }
	      }
	
	      stack.push(value);
	      angular.forEach(value, function (propertyValue, propertyKey) {
	
	        /* Skipping function properties. */
	        if (angular.isFunction(propertyValue)) {
	          return;
	        }
	
	        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
	      });
	      stack.splice(-1, 1); // remove last
	
	      return result;
	    } else if (angular.isNumber(value)) {
	      return value;
	    } else if (value === true || value === false) {
	      return value;
	    } else if (!angular.isUndefined(value) && value !== null) {
	      return iteratee(value);
	    } else {
	      return value;
	    }
	  };
	}
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateProvider
	 * @description
	 *
	 * $translateProvider allows developers to register translation-tables, asynchronous loaders
	 * and similar to configure translation behavior directly inside of a module.
	 *
	 */
	angular.module('pascalprecht.translate')
	  .constant('pascalprechtTranslateOverrider', {})
	  .provider('$translate', $translate);
	
	function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {
	
	  'use strict';
	
	  var $translationTable = {},
	    $preferredLanguage,
	    $availableLanguageKeys = [],
	    $languageKeyAliases,
	    $fallbackLanguage,
	    $fallbackWasString,
	    $uses,
	    $nextLang,
	    $storageFactory,
	    $storageKey = $STORAGE_KEY,
	    $storagePrefix,
	    $missingTranslationHandlerFactory,
	    $interpolationFactory,
	    $interpolatorFactories = [],
	    $loaderFactory,
	    $cloakClassName = 'translate-cloak',
	    $loaderOptions,
	    $notFoundIndicatorLeft,
	    $notFoundIndicatorRight,
	    $postCompilingEnabled = false,
	    $forceAsyncReloadEnabled = false,
	    $allowNamespaces = true,
	    $nestedObjectDelimeter = '.',
	    $isReady = false,
	    $keepContent = false,
	    loaderCache,
	    directivePriority = 0,
	    statefulFilter = true,
	    postProcessFn,
	    uniformLanguageTagResolver = 'default',
	    languageTagResolver = {
	      'default' : function (tag) {
	        return (tag || '').split('-').join('_');
	      },
	      java : function (tag) {
	        var temp = (tag || '').split('-').join('_');
	        var parts = temp.split('_');
	        return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
	      },
	      bcp47 : function (tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	
	        switch (parts.length) {
	          case 1: // language only
	            parts[0] = parts[0].toLowerCase();
	            break;
	          case 2: // language-script or language-region
	            parts[0] = parts[0].toLowerCase();
	            if (parts[1].length === 4) { // parts[1] is script
	              parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            } else { // parts[1] is region
	              parts[1] = parts[1].toUpperCase();
	            }
	            break;
	          case 3: // language-script-region
	            parts[0] = parts[0].toLowerCase();
	            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            parts[2] = parts[2].toUpperCase();
	            break;
	          default:
	            return temp;
	        }
	
	        return parts.join('-');
	      },
	      'iso639-1' : function (tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	        return parts[0].toLowerCase();
	      }
	    };
	
	  var version = '2.19.1';
	
	  // tries to determine the browsers language
	  var getFirstBrowserLanguage = function () {
	
	    // internal purpose only
	    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
	      return pascalprechtTranslateOverrider.getLocale();
	    }
	
	    var nav = $windowProvider.$get().navigator,
	      browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
	      i,
	      language;
	
	    // support for HTML 5.1 "navigator.languages"
	    if (angular.isArray(nav.languages)) {
	      for (i = 0; i < nav.languages.length; i++) {
	        language = nav.languages[i];
	        if (language && language.length) {
	          return language;
	        }
	      }
	    }
	
	    // support for other well known properties in browsers
	    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
	      language = nav[browserLanguagePropertyKeys[i]];
	      if (language && language.length) {
	        return language;
	      }
	    }
	
	    return null;
	  };
	  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';
	
	  // tries to determine the browsers locale
	  var getLocale = function () {
	    var locale = getFirstBrowserLanguage() || '';
	    if (languageTagResolver[uniformLanguageTagResolver]) {
	      locale = languageTagResolver[uniformLanguageTagResolver](locale);
	    }
	    return locale;
	  };
	  getLocale.displayName = 'angular-translate/service: getLocale';
	
	  /**
	   * @name indexOf
	   * @private
	   *
	   * @description
	   * indexOf polyfill. Kinda sorta.
	   *
	   * @param {array} array Array to search in.
	   * @param {string} searchElement Element to search for.
	   *
	   * @returns {int} Index of search element.
	   */
	  var indexOf = function (array, searchElement) {
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (array[i] === searchElement) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function () {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  /**
	   * @name lowercase
	   * @private
	   *
	   * @description
	   * Return the lowercase string only if the type is string
	   *
	   * @returns {string} The string all in lowercase
	   */
	  var lowercase = function (string) {
	    return angular.isString(string) ? string.toLowerCase() : string;
	  };
	
	  var negotiateLocale = function (preferred) {
	    if (!preferred) {
	      return;
	    }
	
	    var avail = [],
	      locale = lowercase(preferred),
	      i = 0,
	      n = $availableLanguageKeys.length;
	
	    for (; i < n; i++) {
	      avail.push(lowercase($availableLanguageKeys[i]));
	    }
	
	    // Check for an exact match in our list of available keys
	    i = indexOf(avail, locale);
	    if (i > -1) {
	      return $availableLanguageKeys[i];
	    }
	
	    if ($languageKeyAliases) {
	      var alias;
	      for (var langKeyAlias in $languageKeyAliases) {
	        if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
	          var hasWildcardKey = false;
	          var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
	            lowercase(langKeyAlias) === lowercase(preferred);
	
	          if (langKeyAlias.slice(-1) === '*') {
	            hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
	          }
	          if (hasExactKey || hasWildcardKey) {
	            alias = $languageKeyAliases[langKeyAlias];
	            if (indexOf(avail, lowercase(alias)) > -1) {
	              return alias;
	            }
	          }
	        }
	      }
	    }
	
	    // Check for a language code without region
	    var parts = preferred.split('_');
	
	    if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
	      return parts[0];
	    }
	
	    // If everything fails, return undefined.
	    return;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translations
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a new translation table for specific language key.
	   *
	   * To register a translation table for specific language, pass a defined language
	   * key as first parameter.
	   *
	   * <pre>
	   *  // register translation table for language: 'de_DE'
	   *  $translateProvider.translations('de_DE', {
	   *    'GREETING': 'Hallo Welt!'
	   *  });
	   *
	   *  // register another one
	   *  $translateProvider.translations('en_US', {
	   *    'GREETING': 'Hello world!'
	   *  });
	   * </pre>
	   *
	   * When registering multiple translation tables for for the same language key,
	   * the actual translation table gets extended. This allows you to define module
	   * specific translation which only get added, once a specific module is loaded in
	   * your app.
	   *
	   * Invoking this method with no arguments returns the translation table which was
	   * registered with no language key. Invoking it with a language key returns the
	   * related translation table.
	   *
	   * @param {string} langKey A language key.
	   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
	   *
	   */
	  var translations = function (langKey, translationTable) {
	
	    if (!langKey && !translationTable) {
	      return $translationTable;
	    }
	
	    if (langKey && !translationTable) {
	      if (angular.isString(langKey)) {
	        return $translationTable[langKey];
	      }
	    } else {
	      if (!angular.isObject($translationTable[langKey])) {
	        $translationTable[langKey] = {};
	      }
	      angular.extend($translationTable[langKey], flatObject(translationTable));
	    }
	    return this;
	  };
	
	  this.translations = translations;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#cloakClassName
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the class name for `translate-cloak` directive.
	   * Default class name is `translate-cloak`.
	   *
	   * @param {string} name translate-cloak class name
	   */
	  this.cloakClassName = function (name) {
	    if (!name) {
	      return $cloakClassName;
	    }
	    $cloakClassName = name;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#allowNamespaces
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Let's you disable namespaces, if you don't need nested translation
	   * object files. Disabling namespaces can improve performance.
	   *
	   * Default value is `true`. Namespaces are enabled by default.
	   *
	   * @param {boolean} namespacesEnabled - namespaces are enabled or not
	   */
	  this.allowNamespaces = function (namespacesEnabled) {
	    if (namespacesEnabled === undefined) {
	      return $allowNamespaces;
	    }
	    $allowNamespaces = namespacesEnabled;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the delimiter for namespaced translations.
	   * Default delimiter is `.`.
	   *
	   * @param {string} delimiter namespace separator
	   */
	  this.nestedObjectDelimeter = function (delimiter) {
	    if (!delimiter) {
	      return $nestedObjectDelimeter;
	    }
	    $nestedObjectDelimeter = delimiter;
	    return this;
	  };
	
	  /**
	   * @name flatObject
	   * @private
	   *
	   * @description
	   * Flats an object. This function is used to flatten given translation data with
	   * namespaces, so they are later accessible via dot notation.
	   */
	  var flatObject = function (data, path, result, prevKey) {
	    var key, keyWithPath, keyWithShortPath, val;
	
	    if (!path) {
	      path = [];
	    }
	    if (!result) {
	      result = {};
	    }
	    if (!$allowNamespaces) {
	      return data;
	    }
	    for (key in data) {
	      if (!Object.prototype.hasOwnProperty.call(data, key)) {
	        continue;
	      }
	      val = data[key];
	      if (angular.isObject(val)) {
	        flatObject(val, path.concat(key), result, key);
	      } else {
	        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
	        if (path.length && key === prevKey) {
	          // Create shortcut path (foo.bar == foo.bar.bar)
	          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
	          // Link it to original path
	          result[keyWithShortPath] = '@:' + keyWithPath;
	        }
	        result[keyWithPath] = val;
	      }
	    }
	    return result;
	  };
	  flatObject.displayName = 'flatObject';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#addInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Adds interpolation services to angular-translate, so it can manage them.
	   *
	   * @param {object} factory Interpolation service factory
	   */
	  this.addInterpolation = function (factory) {
	    $interpolatorFactories.push(factory);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use interpolation functionality of messageformat.js.
	   * This is useful when having high level pluralization and gender selection.
	   */
	  this.useMessageFormatInterpolation = function () {
	    return this.useInterpolation('$translateMessageFormatInterpolation');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which interpolation style to use as default, application-wide.
	   * Simply pass a factory/service name. The interpolation service has to implement
	   * the correct interface.
	   *
	   * @param {string} factory Interpolation service name.
	   */
	  this.useInterpolation = function (factory) {
	    $interpolationFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Simply sets a sanitation strategy type.
	   *
	   * @param {string} value Strategy type.
	   */
	  this.useSanitizeValueStrategy = function (value) {
	    $translateSanitizationProvider.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#preferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use for translation
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **prefer**.
	   * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.preferredLanguage = function (langKey) {
	    if (langKey) {
	      setupPreferredLanguage(langKey);
	      return this;
	    }
	    return $preferredLanguage;
	  };
	  var setupPreferredLanguage = function (langKey) {
	    if (langKey) {
	      $preferredLanguage = langKey;
	    }
	    return $preferredLanguage;
	  };
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found. E.g. when
	   * setting the indicator as 'X' and one tries to translate a translation id
	   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
	   *
	   * Internally this methods sets a left indicator and a right indicator using
	   * `$translateProvider.translationNotFoundIndicatorLeft()` and
	   * `$translateProvider.translationNotFoundIndicatorRight()`.
	   *
	   * **Note**: These methods automatically add a whitespace between the indicators
	   * and the translation id.
	   *
	   * @param {string} indicator An indicator, could be any string.
	   */
	  this.translationNotFoundIndicator = function (indicator) {
	    this.translationNotFoundIndicatorLeft(indicator);
	    this.translationNotFoundIndicatorRight(indicator);
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found left to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorLeft = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorLeft;
	    }
	    $notFoundIndicatorLeft = indicator;
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found right to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorRight = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorRight;
	    }
	    $notFoundIndicatorRight = indicator;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use when missing translations
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **fallback**.
	   *
	   * @param {string||array} langKey A language key.
	   *
	   */
	  this.fallbackLanguage = function (langKey) {
	    fallbackStack(langKey);
	    return this;
	  };
	
	  var fallbackStack = function (langKey) {
	    if (langKey) {
	      if (angular.isString(langKey)) {
	        $fallbackWasString = true;
	        $fallbackLanguage = [langKey];
	      } else if (angular.isArray(langKey)) {
	        $fallbackWasString = false;
	        $fallbackLanguage = langKey;
	      }
	      if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	        $fallbackLanguage.push($preferredLanguage);
	      }
	
	      return this;
	    } else {
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#use
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Set which translation table to use for translation by given language key. When
	   * trying to 'use' a language which isn't provided, it'll throw an error.
	   *
	   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
	   * does the job too.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.use = function (langKey) {
	    if (langKey) {
	      if (!$translationTable[langKey] && (!$loaderFactory)) {
	        // only throw an error, when not loading translation data asynchronously
	        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
	      }
	      $uses = langKey;
	      return this;
	    }
	    return $uses;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#resolveClientLocale
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	   *
	   * @returns {string} the current client/browser language key
	   */
	  this.resolveClientLocale = function () {
	    return getLocale();
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storageKey
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which key must represent the choosed language by a user in the storage.
	   *
	   * @param {string} key A key for the storage.
	   */
	  var storageKey = function (key) {
	    if (!key) {
	      if ($storagePrefix) {
	        return $storagePrefix + $storageKey;
	      }
	      return $storageKey;
	    }
	    $storageKey = key;
	    return this;
	  };
	
	  this.storageKey = storageKey;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useUrlLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
	   *
	   * @param {string} url Url
	   * @param {Object=} options Optional configuration object
	   */
	  this.useUrlLoader = function (url, options) {
	    return this.useLoader('$translateUrlLoader', angular.extend({url : url}, options));
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
	   *
	   * @param {Object=} options Optional configuration object
	   */
	  this.useStaticFilesLoader = function (options) {
	    return this.useLoader('$translateStaticFilesLoader', options);
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use any other service as loader.
	   *
	   * @param {string} loaderFactory Factory name to use
	   * @param {Object=} options Optional configuration object
	   */
	  this.useLoader = function (loaderFactory, options) {
	    $loaderFactory = loaderFactory;
	    $loaderOptions = options || {};
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLocalStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
	   *
	   */
	  this.useLocalStorage = function () {
	    return this.useStorage('$translateLocalStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useCookieStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
	   */
	  this.useCookieStorage = function () {
	    return this.useStorage('$translateCookieStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use custom service as storage layer.
	   */
	  this.useStorage = function (storageFactory) {
	    $storageFactory = storageFactory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storagePrefix
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets prefix for storage key.
	   *
	   * @param {string} prefix Storage key prefix
	   */
	  this.storagePrefix = function (prefix) {
	    if (!prefix) {
	      return prefix;
	    }
	    $storagePrefix = prefix;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use built-in log handler when trying to translate
	   * a translation Id which doesn't exist.
	   *
	   * This is actually a shortcut method for `useMissingTranslationHandler()`.
	   *
	   */
	  this.useMissingTranslationHandlerLog = function () {
	    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Expects a factory name which later gets instantiated with `$injector`.
	   * This method can be used to tell angular-translate to use a custom
	   * missingTranslationHandler. Just build a factory which returns a function
	   * and expects a translation id as argument.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.useMissingTranslationHandler('customHandler');
	   *  });
	   *
	   *  app.factory('customHandler', function (dep1, dep2) {
	   *    return function (translationId) {
	   *      // something with translationId and dep1 and dep2
	   *    };
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.useMissingTranslationHandler = function (factory) {
	    $missingTranslationHandlerFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#usePostCompiling
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If post compiling is enabled, all translated values will be processed
	   * again with AngularJS' $compile.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.usePostCompiling(true);
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.usePostCompiling = function (value) {
	    $postCompilingEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If force async reload is enabled, async loader will always be called
	   * even if $translationTable already contains the language key, adding
	   * possible new entries to the $translationTable.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.forceAsyncReload(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.forceAsyncReload = function (value) {
	    $forceAsyncReloadEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which language tag should be used as a result when determining
	   * the current browser language.
	   *
	   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
	   *
	   * <pre>
	   * $translateProvider
	   *   .uniformLanguageTag('bcp47')
	   *   .determinePreferredLanguage()
	   * </pre>
	   *
	   * The resolver currently supports:
	   * * default
	   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_us
	   * * java
	   *     like default, but the second part will be always in uppercase
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_US
	   * * BCP 47 (RFC 4646 & 4647)
	   *     EN => en
	   *     en-US => en-US
	   *     en_US => en-US
	   *     en-us => en-US
	   *     sr-latn => sr-Latn
	   *     sr-latn-rs => sr-Latn-RS
	   *
	   * See also:
	   * * http://en.wikipedia.org/wiki/IETF_language_tag
	   * * http://www.w3.org/International/core/langtags/
	   * * http://tools.ietf.org/html/bcp47
	   *
	   * @param {string|object} options - options (or standard)
	   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
	   */
	  this.uniformLanguageTag = function (options) {
	
	    if (!options) {
	      options = {};
	    } else if (angular.isString(options)) {
	      options = {
	        standard : options
	      };
	    }
	
	    uniformLanguageTagResolver = options.standard;
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to try to determine on its own which language key
	   * to set as preferred language. When `fn` is given, angular-translate uses it
	   * to determine a language key, otherwise it uses the built-in `getLocale()`
	   * method.
	   *
	   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
	   * `[lang]` depending on what the browser provides.
	   *
	   * Use this method at your own risk, since not all browsers return a valid
	   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
	   *
	   * @param {Function=} fn Function to determine a browser's locale
	   */
	  this.determinePreferredLanguage = function (fn) {
	
	    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();
	
	    if (!$availableLanguageKeys.length) {
	      $preferredLanguage = locale;
	    } else {
	      $preferredLanguage = negotiateLocale(locale) || locale;
	    }
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a set of language keys the app will work with. Use this method in
	   * combination with
	   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
	   * When available languages keys are registered, angular-translate
	   * tries to find the best fitting language key depending on the browsers locale,
	   * considering your language key convention.
	   *
	   * @param {object} languageKeys Array of language keys the your app will use
	   * @param {object=} aliases Alias map.
	   */
	  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
	    if (languageKeys) {
	      $availableLanguageKeys = languageKeys;
	      if (aliases) {
	        $languageKeyAliases = aliases;
	      }
	      return this;
	    }
	    return $availableLanguageKeys;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoaderCache
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a cache for internal $http based loaders.
	   * {@link pascalprecht.translate.$translationCache $translationCache}.
	   * When false the cache will be disabled (default). When true or undefined
	   * the cache will be a default (see $cacheFactory). When an object it will
	   * be treat as a cache object itself: the usage is $http({cache: cache})
	   *
	   * @param {object} cache boolean, string or cache-object
	   */
	  this.useLoaderCache = function (cache) {
	    if (cache === false) {
	      // disable cache
	      loaderCache = undefined;
	    } else if (cache === true) {
	      // enable cache using AJS defaults
	      loaderCache = true;
	    } else if (typeof(cache) === 'undefined') {
	      // enable cache using default
	      loaderCache = '$translationCache';
	    } else if (cache) {
	      // enable cache using given one (see $cacheFactory)
	      loaderCache = cache;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#directivePriority
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets the default priority of the translate directive. The standard value is `0`.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {number} priority for the translate-directive
	   */
	  this.directivePriority = function (priority) {
	    if (priority === undefined) {
	      // getter
	      return directivePriority;
	    } else {
	      // setter with chaining
	      directivePriority = priority;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#statefulFilter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
	   * have to explicit define this behavior.
	   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
	   * meaning being stateful.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {boolean} state - defines the state of the filter
	   */
	  this.statefulFilter = function (state) {
	    if (state === undefined) {
	      // getter
	      return statefulFilter;
	    } else {
	      // setter with chaining
	      statefulFilter = state;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#postProcess
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * The post processor will be intercept right after the translation result. It can modify the result.
	   *
	   * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
	   */
	  this.postProcess = function (fn) {
	    if (fn) {
	      postProcessFn = fn;
	    } else {
	      postProcessFn = undefined;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#keepContent
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If keepContent is set to true than translate directive will always use innerHTML
	   * as a default translation
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.keepContent(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.keepContent = function (value) {
	    $keepContent = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translate
	   * @requires $interpolate
	   * @requires $log
	   * @requires $rootScope
	   * @requires $q
	   *
	   * @description
	   * The `$translate` service is the actual core of angular-translate. It expects a translation id
	   * and optional interpolate parameters to translate contents.
	   *
	   * <pre>
	   *  $translate('HEADLINE_TEXT').then(function (translation) {
	   *    $scope.translatedText = translation;
	   *  });
	   * </pre>
	   *
	   * @param {string|array} translationId A token which represents a translation id
	   *                                     This can be optionally an array of translation ids which
	   *                                     results that the function returns an object where each key
	   *                                     is the translation id and the value the translation.
	   * @param {object=} [interpolateParams={}] An object hash for dynamic values
	   * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	   * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
	   *                                        as default text in case it is not found in any configured language
	   * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	   * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	   * @returns {object} promise
	   */
	  this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {
	
	    var Storage,
	      defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
	      pendingLoader = false,
	      interpolatorHashMap = {},
	      langPromises = {},
	      fallbackIndex,
	      startFallbackIteration;
	
	    var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
	      if (!$uses && $preferredLanguage) {
	        $uses = $preferredLanguage;
	      }
	      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
	        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;
	
	      // Check forceLanguage is present
	      if (forceLanguage) {
	        loadTranslationsIfMissing(forceLanguage);
	      }
	
	      // Duck detection: If the first argument is an array, a bunch of translations was requested.
	      // The result is an object.
	      if (angular.isArray(translationId)) {
	        // Inspired by Q.allSettled by Kris Kowal
	        // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
	        // This transforms all promises regardless resolved or rejected
	        var translateAll = function (translationIds) {
	          var results = {}; // storing the actual results
	          var promises = []; // promises to wait for
	          // Wraps the promise a) being always resolved and b) storing the link id->value
	          var translate = function (translationId) {
	            var deferred = $q.defer();
	            var regardless = function (value) {
	              results[translationId] = value;
	              deferred.resolve([translationId, value]);
	            };
	            // we don't care whether the promise was resolved or rejected; just store the values
	            $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
	            return deferred.promise;
	          };
	          for (var i = 0, c = translationIds.length; i < c; i++) {
	            promises.push(translate(translationIds[i]));
	          }
	          // wait for all (including storing to results)
	          return $q.all(promises).then(function () {
	            // return the results
	            return results;
	          });
	        };
	        return translateAll(translationId);
	      }
	
	      var deferred = $q.defer();
	
	      // trim off any whitespace
	      if (translationId) {
	        translationId = trim.apply(translationId);
	      } else {
	        throw new TypeError('translationId must be a not empty string');
	      }
	
	      var promiseToWaitFor = (function () {
	        var promise = langPromises[uses] || langPromises[$preferredLanguage];
	
	        fallbackIndex = 0;
	
	        if ($storageFactory && !promise) {
	          // looks like there's no pending promise for $preferredLanguage or
	          // $uses. Maybe there's one pending for a language that comes from
	          // storage.
	          var langKey = Storage.get($storageKey);
	          promise = langPromises[langKey];
	
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            var index = indexOf($fallbackLanguage, langKey);
	            // maybe the language from storage is also defined as fallback language
	            // we increase the fallback language index to not search in that language
	            // as fallback, since it's probably the first used language
	            // in that case the index starts after the first element
	            fallbackIndex = (index === 0) ? 1 : 0;
	
	            // but we can make sure to ALWAYS fallback to preferred language at least
	            if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	              $fallbackLanguage.push($preferredLanguage);
	            }
	          }
	        }
	        return promise;
	      }());
	
	      if (!promiseToWaitFor) {
	        // no promise to wait for? okay. Then there's no loader registered
	        // nor is a one pending for language that comes from storage.
	        // We can just translate.
	        determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	      } else {
	        var promiseResolved = function () {
	          // $uses may have changed while waiting
	          if (!forceLanguage) {
	            uses = $uses;
	          }
	          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	        };
	        promiseResolved.displayName = 'promiseResolved';
	
	        promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name applyNotFoundIndicators
	     * @private
	     *
	     * @description
	     * Applies not fount indicators to given translation id, if needed.
	     * This function gets only executed, if a translation id doesn't exist,
	     * which is why a translation id is expected as argument.
	     *
	     * @param {string} translationId Translation id.
	     * @returns {string} Same as given translation id but applied with not found
	     * indicators.
	     */
	    var applyNotFoundIndicators = function (translationId) {
	      // applying notFoundIndicators
	      if ($notFoundIndicatorLeft) {
	        translationId = [$notFoundIndicatorLeft, translationId].join(' ');
	      }
	      if ($notFoundIndicatorRight) {
	        translationId = [translationId, $notFoundIndicatorRight].join(' ');
	      }
	      return translationId;
	    };
	
	    /**
	     * @name useLanguage
	     * @private
	     *
	     * @description
	     * Makes actual use of a language by setting a given language key as used
	     * language and informs registered interpolators to also use the given
	     * key as locale.
	     *
	     * @param {string} key Locale key.
	     */
	    var useLanguage = function (key) {
	      $uses = key;
	
	      // make sure to store new language key before triggering success event
	      if ($storageFactory) {
	        Storage.put($translate.storageKey(), $uses);
	      }
	
	      $rootScope.$emit('$translateChangeSuccess', {language : key});
	
	      // inform default interpolator
	      defaultInterpolator.setLocale($uses);
	
	      var eachInterpolator = function (interpolator, id) {
	        interpolatorHashMap[id].setLocale($uses);
	      };
	      eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';
	
	      // inform all others too!
	      angular.forEach(interpolatorHashMap, eachInterpolator);
	      $rootScope.$emit('$translateChangeEnd', {language : key});
	    };
	
	    /**
	     * @name loadAsync
	     * @private
	     *
	     * @description
	     * Kicks off registered async loader using `$injector` and applies existing
	     * loader options. When resolved, it updates translation tables accordingly
	     * or rejects with given language key.
	     *
	     * @param {string} key Language key.
	     * @return {Promise} A promise.
	     */
	    var loadAsync = function (key) {
	      if (!key) {
	        throw 'No language key specified for loading.';
	      }
	
	      var deferred = $q.defer();
	
	      $rootScope.$emit('$translateLoadingStart', {language : key});
	      pendingLoader = true;
	
	      var cache = loaderCache;
	      if (typeof(cache) === 'string') {
	        // getting on-demand instance of loader
	        cache = $injector.get(cache);
	      }
	
	      var loaderOptions = angular.extend({}, $loaderOptions, {
	        key : key,
	        $http : angular.extend({}, {
	          cache : cache
	        }, $loaderOptions.$http)
	      });
	
	      var onLoaderSuccess = function (data) {
	        var translationTable = {};
	        $rootScope.$emit('$translateLoadingSuccess', {language : key});
	
	        if (angular.isArray(data)) {
	          angular.forEach(data, function (table) {
	            angular.extend(translationTable, flatObject(table));
	          });
	        } else {
	          angular.extend(translationTable, flatObject(data));
	        }
	        pendingLoader = false;
	        deferred.resolve({
	          key : key,
	          table : translationTable
	        });
	        $rootScope.$emit('$translateLoadingEnd', {language : key});
	      };
	      onLoaderSuccess.displayName = 'onLoaderSuccess';
	
	      var onLoaderError = function (key) {
	        $rootScope.$emit('$translateLoadingError', {language : key});
	        deferred.reject(key);
	        $rootScope.$emit('$translateLoadingEnd', {language : key});
	      };
	      onLoaderError.displayName = 'onLoaderError';
	
	      $injector.get($loaderFactory)(loaderOptions)
	        .then(onLoaderSuccess, onLoaderError);
	
	      return deferred.promise;
	    };
	
	    if ($storageFactory) {
	      Storage = $injector.get($storageFactory);
	
	      if (!Storage.get || !Storage.put) {
	        throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
	      }
	    }
	
	    // if we have additional interpolations that were added via
	    // $translateProvider.addInterpolation(), we have to map'em
	    if ($interpolatorFactories.length) {
	      var eachInterpolationFactory = function (interpolatorFactory) {
	        var interpolator = $injector.get(interpolatorFactory);
	        // setting initial locale for each interpolation service
	        interpolator.setLocale($preferredLanguage || $uses);
	        // make'em recognizable through id
	        interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
	      };
	      eachInterpolationFactory.displayName = 'interpolationFactoryAdder';
	
	      angular.forEach($interpolatorFactories, eachInterpolationFactory);
	    }
	
	    /**
	     * @name getTranslationTable
	     * @private
	     *
	     * @description
	     * Returns a promise that resolves to the translation table
	     * or is rejected if an error occurred.
	     *
	     * @param langKey
	     * @returns {Q.promise}
	     */
	    var getTranslationTable = function (langKey) {
	      var deferred = $q.defer();
	      if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
	        deferred.resolve($translationTable[langKey]);
	      } else if (langPromises[langKey]) {
	        var onResolve = function (data) {
	          translations(data.key, data.table);
	          deferred.resolve(data.table);
	        };
	        onResolve.displayName = 'translationTableResolver';
	        langPromises[langKey].then(onResolve, deferred.reject);
	      } else {
	        deferred.reject();
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name getFallbackTranslation
	     * @private
	     *
	     * @description
	     * Returns a promise that will resolve to the translation
	     * or be rejected if no translation was found for the language.
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {Q.promise}
	     */
	    var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var deferred = $q.defer();
	
	      var onResolve = function (translationTable) {
	        if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	          Interpolator.setLocale(langKey);
	          var translation = translationTable[translationId];
	          if (translation.substr(0, 2) === '@:') {
	            getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy)
	              .then(deferred.resolve, deferred.reject);
	          } else {
	            var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
	            interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);
	
	            deferred.resolve(interpolatedValue);
	
	          }
	          Interpolator.setLocale($uses);
	        } else {
	          deferred.reject();
	        }
	      };
	      onResolve.displayName = 'fallbackTranslationResolver';
	
	      getTranslationTable(langKey).then(onResolve, deferred.reject);
	
	      return deferred.promise;
	    };
	
	    /**
	     * @name getFallbackTranslationInstant
	     * @private
	     *
	     * @description
	     * Returns a translation
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns {string} translation
	     */
	    var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var result, translationTable = $translationTable[langKey];
	
	      if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	        Interpolator.setLocale(langKey);
	        result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
	        result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
	        // workaround for TrustedValueHolderType
	        if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
	          var result2 = result.$$unwrapTrustedValue();
	          if (result2.substr(0, 2) === '@:') {
	            return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	          }
	        } else if (result.substr(0, 2) === '@:') {
	          return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	        }
	        Interpolator.setLocale($uses);
	      }
	
	      return result;
	    };
	
	
	    /**
	     * @name translateByHandler
	     * @private
	     *
	     * Translate by missing translation handler.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param defaultTranslationText
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
	     * absent
	     */
	    var translateByHandler = function (translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
	      // If we have a handler factory - we might also call it here to determine if it provides
	      // a default text for a translationid that can't be found anywhere in our tables
	      if ($missingTranslationHandlerFactory) {
	        return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
	      } else {
	        return translationId;
	      }
	    };
	
	    /**
	     * @name resolveForFallbackLanguage
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param defaultTranslationText
	     * @param sanitizeStrategy
	     * @returns {Q.promise} Promise that will resolve to the translation.
	     */
	    var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	      var deferred = $q.defer();
	
	      if (fallbackLanguageIndex < $fallbackLanguage.length) {
	        var langKey = $fallbackLanguage[fallbackLanguageIndex];
	        getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(
	          function (data) {
	            deferred.resolve(data);
	          },
	          function () {
	            // Look in the next fallback language for a translation.
	            // It delays the resolving by passing another promise to resolve.
	            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	          }
	        );
	      } else {
	        // No translation found in any fallback language
	        // if a default translation text is set in the directive, then return this as a result
	        if (defaultTranslationText) {
	          deferred.resolve(defaultTranslationText);
	        } else {
	          var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	
	          // if no default translation is set and an error handler is defined, send it to the handler
	          // and then return the result if it isn't undefined
	          if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
	            deferred.resolve(missingTranslationHandlerTranslation);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name resolveForFallbackLanguageInstant
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {string} translation
	     */
	    var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var result;
	
	      if (fallbackLanguageIndex < $fallbackLanguage.length) {
	        var langKey = $fallbackLanguage[fallbackLanguageIndex];
	        result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
	        if (!result && result !== '') {
	          result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
	        }
	      }
	      return result;
	    };
	
	    /**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param defaultTranslationText
	     * @param sanitizeStrategy
	     * @returns {Q.promise} Promise, that resolves to the translation.
	     */
	    var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	      // Start with the fallbackLanguage with index 0
	      return resolveForFallbackLanguage((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
	    };
	
	    /**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {String} translation
	     */
	    var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      // Start with the fallbackLanguage with index 0
	      return resolveForFallbackLanguageInstant((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, sanitizeStrategy);
	    };
	
	    var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {
	
	      var deferred = $q.defer();
	
	      var table = uses ? $translationTable[uses] : $translationTable,
	        Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;
	
	      // if the translation id exists, we can just interpolate it
	      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	        var translation = table[translationId];
	
	        // If using link, rerun $translate with linked translationId and return it
	        if (translation.substr(0, 2) === '@:') {
	
	          $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy)
	            .then(deferred.resolve, deferred.reject);
	        } else {
	          //
	          var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
	          resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
	          deferred.resolve(resolvedTranslation);
	        }
	      } else {
	        var missingTranslationHandlerTranslation;
	        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	        if ($missingTranslationHandlerFactory && !pendingLoader) {
	          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	        }
	
	        // since we couldn't translate the inital requested translation id,
	        // we try it now with one or more fallback languages, if fallback language(s) is
	        // configured.
	        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	          fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy)
	            .then(function (translation) {
	              deferred.resolve(translation);
	            }, function (_translationId) {
	              deferred.reject(applyNotFoundIndicators(_translationId));
	            });
	        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            deferred.resolve(missingTranslationHandlerTranslation);
	          }
	        } else {
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	      }
	      return deferred.promise;
	    };
	
	    var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {
	
	      var result, table = uses ? $translationTable[uses] : $translationTable,
	        Interpolator = defaultInterpolator;
	
	      // if the interpolation id exists use custom interpolator
	      if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
	        Interpolator = interpolatorHashMap[interpolationId];
	      }
	
	      // if the translation id exists, we can just interpolate it
	      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	        var translation = table[translationId];
	
	        // If using link, rerun $translate with linked translationId and return it
	        if (translation.substr(0, 2) === '@:') {
	          result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
	        } else {
	          result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
	          result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
	        }
	      } else {
	        var missingTranslationHandlerTranslation;
	        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	        if ($missingTranslationHandlerFactory && !pendingLoader) {
	          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	        }
	
	        // since we couldn't translate the inital requested translation id,
	        // we try it now with one or more fallback languages, if fallback language(s) is
	        // configured.
	        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	          fallbackIndex = 0;
	          result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
	        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          result = missingTranslationHandlerTranslation;
	        } else {
	          result = applyNotFoundIndicators(translationId);
	        }
	      }
	
	      return result;
	    };
	
	    var clearNextLangAndPromise = function (key) {
	      if ($nextLang === key) {
	        $nextLang = undefined;
	      }
	      langPromises[key] = undefined;
	    };
	
	    var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
	      var fn = postProcessFn;
	
	      if (fn) {
	
	        if (typeof(fn) === 'string') {
	          // getting on-demand instance
	          fn = $injector.get(fn);
	        }
	        if (fn) {
	          return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
	        }
	      }
	
	      return resolvedTranslation;
	    };
	
	    var loadTranslationsIfMissing = function (key) {
	      if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
	        langPromises[key] = loadAsync(key).then(function (translation) {
	          translations(translation.key, translation.table);
	          return translation;
	        });
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#preferredLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the preferred language.
	     *
	     * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
	     *
	     * @return {string} preferred language key
	     */
	    $translate.preferredLanguage = function (langKey) {
	      if (langKey) {
	        setupPreferredLanguage(langKey);
	      }
	      return $preferredLanguage;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#cloakClassName
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured class name for `translate-cloak` directive.
	     *
	     * @return {string} cloakClassName
	     */
	    $translate.cloakClassName = function () {
	      return $cloakClassName;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#allowNamespaces
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns if namespaces are enabled
	     *
	     * @return {boolean} allowNamespaces value
	     */
	    $translate.allowNamespaces = function () {
	      return $allowNamespaces;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#nestedObjectDelimeter
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured delimiter for nested namespaces.
	     *
	     * @return {string} nestedObjectDelimeter
	     */
	    $translate.nestedObjectDelimeter = function () {
	      return $nestedObjectDelimeter;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#fallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the fallback languages or sets a new fallback stack.
	     * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
	     *
	     * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
	     *
	     * @return {string||array} fallback language key
	     */
	    $translate.fallbackLanguage = function (langKey) {
	      if (langKey !== undefined && langKey !== null) {
	        fallbackStack(langKey);
	
	        // as we might have an async loader initiated and a new translation language might have been defined
	        // we need to add the promise to the stack also. So - iterate.
	        if ($loaderFactory) {
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	              if (!langPromises[$fallbackLanguage[i]]) {
	                langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
	              }
	            }
	          }
	        }
	        $translate.use($translate.use());
	      }
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#useFallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Sets the first key of the fallback language stack to be used for translation.
	     * Therefore all languages in the fallback array BEFORE this key will be skipped!
	     *
	     * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
	     * get back to the whole stack
	     */
	    $translate.useFallbackLanguage = function (langKey) {
	      if (langKey !== undefined && langKey !== null) {
	        if (!langKey) {
	          startFallbackIteration = 0;
	        } else {
	          var langKeyPosition = indexOf($fallbackLanguage, langKey);
	          if (langKeyPosition > -1) {
	            startFallbackIteration = langKeyPosition;
	          }
	        }
	
	      }
	
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#proposedLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key of language that is currently loaded asynchronously.
	     *
	     * @return {string} language key
	     */
	    $translate.proposedLanguage = function () {
	      return $nextLang;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns registered storage.
	     *
	     * @return {object} Storage
	     */
	    $translate.storage = function () {
	      return Storage;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#negotiateLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a language key based on available languages and language aliases. If a
	     * language key cannot be resolved, returns undefined.
	     *
	     * If no or a falsy key is given, returns undefined.
	     *
	     * @param {string} [key] Language key
	     * @return {string|undefined} Language key or undefined if no language key is found.
	     */
	    $translate.negotiateLocale = negotiateLocale;
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#use
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Tells angular-translate which language to use by given language key. This method is
	     * used to change language at runtime. It also takes care of storing the language
	     * key in a configured store to let your app remember the choosed language.
	     *
	     * When trying to 'use' a language which isn't available it tries to load it
	     * asynchronously with registered loaders.
	     *
	     * Returns promise object with loaded language file data or string of the currently used language.
	     *
	     * If no or a falsy key is given it returns the currently used language key.
	     * The returned string will be ```undefined``` if setting up $translate hasn't finished.
	     * @example
	     * $translate.use("en_US").then(function(data){
	       *   $scope.text = $translate("HELLO");
	       * });
	     *
	     * @param {string=} key Language key
	     * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
	     */
	    $translate.use = function (key) {
	      if (!key) {
	        return $uses;
	      }
	
	      var deferred = $q.defer();
	      deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"
	
	      $rootScope.$emit('$translateChangeStart', {language : key});
	
	      // Try to get the aliased language key
	      var aliasedKey = negotiateLocale(key);
	      // Ensure only registered language keys will be loaded
	      if ($availableLanguageKeys.length > 0 && !aliasedKey) {
	        return $q.reject(key);
	      }
	
	      if (aliasedKey) {
	        key = aliasedKey;
	      }
	
	      // if there isn't a translation table for the language we've requested,
	      // we load it asynchronously
	      $nextLang = key;
	      if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
	        langPromises[key] = loadAsync(key).then(function (translation) {
	          translations(translation.key, translation.table);
	          deferred.resolve(translation.key);
	          if ($nextLang === key) {
	            useLanguage(translation.key);
	          }
	          return translation;
	        }, function (key) {
	          $rootScope.$emit('$translateChangeError', {language : key});
	          deferred.reject(key);
	          $rootScope.$emit('$translateChangeEnd', {language : key});
	          return $q.reject(key);
	        });
	        langPromises[key]['finally'](function () {
	          clearNextLangAndPromise(key);
	        })['catch'](angular.noop); // we don't care about errors (clearing)
	      } else if (langPromises[key]) {
	        // we are already loading this asynchronously
	        // resolve our new deferred when the old langPromise is resolved
	        langPromises[key].then(function (translation) {
	          if ($nextLang === translation.key) {
	            useLanguage(translation.key);
	          }
	          deferred.resolve(translation.key);
	          return translation;
	        }, function (key) {
	          // find first available fallback language if that request has failed
	          if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
	            return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
	          } else {
	            return deferred.reject(key);
	          }
	        });
	      } else {
	        deferred.resolve(key);
	        useLanguage(key);
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#resolveClientLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	     *
	     * @returns {string} the current client/browser language key
	     */
	    $translate.resolveClientLocale = function () {
	      return getLocale();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storageKey
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the key for the storage.
	     *
	     * @return {string} storage key
	     */
	    $translate.storageKey = function () {
	      return storageKey();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isPostCompilingEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether post compiling is enabled or not
	     *
	     * @return {bool} storage key
	     */
	    $translate.isPostCompilingEnabled = function () {
	      return $postCompilingEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether force async reload is enabled or not
	     *
	     * @return {boolean} forceAsyncReload value
	     */
	    $translate.isForceAsyncReloadEnabled = function () {
	      return $forceAsyncReloadEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isKeepContent
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether keepContent or not
	     *
	     * @return {boolean} keepContent value
	     */
	    $translate.isKeepContent = function () {
	      return $keepContent;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#refresh
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
	     * the module will drop all existent translation tables and load new version of those which
	     * are currently in use.
	     *
	     * Refresh means that the module will drop target translation table and try to load it again.
	     *
	     * In case there are no loaders registered the refresh() method will throw an Error.
	     *
	     * If the module is able to refresh translation tables refresh() method will broadcast
	     * $translateRefreshStart and $translateRefreshEnd events.
	     *
	     * @example
	     * // this will drop all currently existent translation tables and reload those which are
	     * // currently in use
	     * $translate.refresh();
	     * // this will refresh a translation table for the en_US language
	     * $translate.refresh('en_US');
	     *
	     * @param {string} langKey A language key of the table, which has to be refreshed
	     *
	     * @return {promise} Promise, which will be resolved in case a translation tables refreshing
	     * process is finished successfully, and reject if not.
	     */
	    $translate.refresh = function (langKey) {
	      if (!$loaderFactory) {
	        throw new Error('Couldn\'t refresh translation table, no loader registered!');
	      }
	
	      $rootScope.$emit('$translateRefreshStart', {language : langKey});
	
	      var deferred = $q.defer(), updatedLanguages = {};
	
	      //private helper
	      function loadNewData(languageKey) {
	        var promise = loadAsync(languageKey);
	        //update the load promise cache for this language
	        langPromises[languageKey] = promise;
	        //register a data handler for the promise
	        promise.then(function (data) {
	            //clear the cache for this language
	            $translationTable[languageKey] = {};
	            //add the new data for this language
	            translations(languageKey, data.table);
	            //track that we updated this language
	            updatedLanguages[languageKey] = true;
	          },
	          //handle rejection to appease the $q validation
	          angular.noop);
	        return promise;
	      }
	
	      //set up post-processing
	      deferred.promise.then(
	        function () {
	          for (var key in $translationTable) {
	            if ($translationTable.hasOwnProperty(key)) {
	              //delete cache entries that were not updated
	              if (!(key in updatedLanguages)) {
	                delete $translationTable[key];
	              }
	            }
	          }
	          if ($uses) {
	            useLanguage($uses);
	          }
	        },
	        //handle rejection to appease the $q validation
	        angular.noop
	      )['finally'](
	        function () {
	          $rootScope.$emit('$translateRefreshEnd', {language : langKey});
	        }
	      );
	
	      if (!langKey) {
	        // if there's no language key specified we refresh ALL THE THINGS!
	        var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
	        if ($uses && languagesToReload.indexOf($uses) === -1) {
	          languagesToReload.push($uses);
	        }
	        $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);
	
	      } else if ($translationTable[langKey]) {
	        //just refresh the specified language cache
	        loadNewData(langKey).then(deferred.resolve, deferred.reject);
	
	      } else {
	        deferred.reject();
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#instant
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a translation instantly from the internal state of loaded translation. All rules
	     * regarding the current language, the preferred language of even fallback languages will be
	     * used except any promise handling. If a language was not found, an asynchronous loading
	     * will be invoked in the background.
	     *
	     * @param {string|array} translationId A token which represents a translation id
	     *                                     This can be optionally an array of translation ids which
	     *                                     results that the function's promise returns an object where
	     *                                     each key is the translation id and the value the translation.
	     * @param {object=} [interpolateParams={}] Params
	     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	     *
	     * @return {string|object} translation
	     */
	    $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {
	
	      // we don't want to re-negotiate $uses
	      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
	        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;
	
	      // Detect undefined and null values to shorten the execution and prevent exceptions
	      if (translationId === null || angular.isUndefined(translationId)) {
	        return translationId;
	      }
	
	      // Check forceLanguage is present
	      if (forceLanguage) {
	        loadTranslationsIfMissing(forceLanguage);
	      }
	
	      // Duck detection: If the first argument is an array, a bunch of translations was requested.
	      // The result is an object.
	      if (angular.isArray(translationId)) {
	        var results = {};
	        for (var i = 0, c = translationId.length; i < c; i++) {
	          results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
	        }
	        return results;
	      }
	
	      // We discarded unacceptable values. So we just need to verify if translationId is empty String
	      if (angular.isString(translationId) && translationId.length < 1) {
	        return translationId;
	      }
	
	      // trim off any whitespace
	      if (translationId) {
	        translationId = trim.apply(translationId);
	      }
	
	      var result, possibleLangKeys = [];
	      if ($preferredLanguage) {
	        possibleLangKeys.push($preferredLanguage);
	      }
	      if (uses) {
	        possibleLangKeys.push(uses);
	      }
	      if ($fallbackLanguage && $fallbackLanguage.length) {
	        possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
	      }
	      for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
	        var possibleLangKey = possibleLangKeys[j];
	        if ($translationTable[possibleLangKey]) {
	          if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
	            result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
	          }
	        }
	        if (typeof result !== 'undefined') {
	          break;
	        }
	      }
	
	      if (!result && result !== '') {
	        if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
	          result = applyNotFoundIndicators(translationId);
	        } else {
	          // Return translation of default interpolator if not found anything.
	          result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);
	
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          var missingTranslationHandlerTranslation;
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	          }
	
	          if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	            result = missingTranslationHandlerTranslation;
	          }
	        }
	      }
	
	      return result;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#versionInfo
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the current version information for the angular-translate library
	     *
	     * @return {string} angular-translate version
	     */
	    $translate.versionInfo = function () {
	      return version;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#loaderCache
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the defined loaderCache.
	     *
	     * @return {boolean|string|object} current value of loaderCache
	     */
	    $translate.loaderCache = function () {
	      return loaderCache;
	    };
	
	    // internal purpose only
	    $translate.directivePriority = function () {
	      return directivePriority;
	    };
	
	    // internal purpose only
	    $translate.statefulFilter = function () {
	      return statefulFilter;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
	     *
	     * @return {boolean} current value of ready
	     */
	    $translate.isReady = function () {
	      return $isReady;
	    };
	
	    var $onReadyDeferred = $q.defer();
	    $onReadyDeferred.promise.then(function () {
	      $isReady = true;
	    });
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#onReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
	     *
	     * @param {Function=} fn Function to invoke when service is ready
	     * @return {object} Promise resolved when service is ready
	     */
	    $translate.onReady = function (fn) {
	      var deferred = $q.defer();
	      if (angular.isFunction(fn)) {
	        deferred.promise.then(fn);
	      }
	      if ($isReady) {
	        deferred.resolve();
	      } else {
	        $onReadyDeferred.promise.then(deferred.resolve);
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This function simply returns the registered language keys being defined before in the config phase
	     * With this, an application can use the array to provide a language selection dropdown or similar
	     * without any additional effort
	     *
	     * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
	     */
	    $translate.getAvailableLanguageKeys = function () {
	      if ($availableLanguageKeys.length > 0) {
	        return $availableLanguageKeys;
	      }
	      return null;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getTranslationTable
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns translation table by the given language key.
	     *
	     * Unless a language is provided it returns a translation table of the current one.
	     * Note: If translation dictionary is currently downloading or in progress
	     * it will return null.
	     *
	     * @param {string} langKey A token which represents a translation id
	     *
	     * @return {object} a copy of angular-translate $translationTable
	     */
	    $translate.getTranslationTable = function (langKey) {
	      langKey = langKey || $translate.use();
	      if (langKey && $translationTable[langKey]) {
	        return angular.copy($translationTable[langKey]);
	      }
	      return null;
	    };
	
	    // Whenever $translateReady is being fired, this will ensure the state of $isReady
	    var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
	      $onReadyDeferred.resolve();
	      globalOnReadyListener(); // one time only
	      globalOnReadyListener = null;
	    });
	    var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
	      $onReadyDeferred.resolve();
	      globalOnChangeListener(); // one time only
	      globalOnChangeListener = null;
	    });
	
	    if ($loaderFactory) {
	
	      // If at least one async loader is defined and there are no
	      // (default) translations available we should try to load them.
	      if (angular.equals($translationTable, {})) {
	        if ($translate.use()) {
	          $translate.use($translate.use());
	        }
	      }
	
	      // Also, if there are any fallback language registered, we start
	      // loading them asynchronously as soon as we can.
	      if ($fallbackLanguage && $fallbackLanguage.length) {
	        var processAsyncResult = function (translation) {
	          translations(translation.key, translation.table);
	          $rootScope.$emit('$translateChangeEnd', {language : translation.key});
	          return translation;
	        };
	        for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	          var fallbackLanguageId = $fallbackLanguage[i];
	          if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
	            langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
	          }
	        }
	      }
	    } else {
	      $rootScope.$emit('$translateReady', {language : $translate.use()});
	    }
	
	    return $translate;
	  }];
	}
	
	$translate.displayName = 'displayName';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateDefaultInterpolation
	 * @requires $interpolate
	 *
	 * @description
	 * Uses angular's `$interpolate` services to interpolate strings against some values.
	 *
	 * Be aware to configure a proper sanitization strategy.
	 *
	 * See also:
	 * * {@link pascalprecht.translate.$translateSanitization}
	 *
	 * @return {object} $translateDefaultInterpolation Interpolator service
	 */
	angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);
	
	function $translateDefaultInterpolation ($interpolate, $translateSanitization) {
	
	  'use strict';
	
	  var $translateInterpolator = {},
	      $locale,
	      $identifier = 'default';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Sets current locale (this is currently not use in this interpolation).
	   *
	   * @param {string} locale Language key or locale.
	   */
	  $translateInterpolator.setLocale = function (locale) {
	    $locale = locale;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Returns an identifier for this interpolation service.
	   *
	   * @returns {string} $identifier
	   */
	  $translateInterpolator.getInterpolationIdentifier = function () {
	    return $identifier;
	  };
	
	  /**
	   * @deprecated will be removed in 3.0
	   * @see {@link pascalprecht.translate.$translateSanitization}
	   */
	  $translateInterpolator.useSanitizeValueStrategy = function (value) {
	    $translateSanitization.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Interpolates given value agains given interpolate params using angulars
	   * `$interpolate` service.
	   *
	   * Since AngularJS 1.5, `value` must not be a string but can be anything input.
	   *
	   * @param {string} value translation
	   * @param {object} [interpolationParams={}] interpolation params
	   * @param {string} [context=undefined] current context (filter, directive, service)
	   * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
	   * @param {string} translationId current translationId
	   *
	   * @returns {string} interpolated string
	   */
	  $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) { // jshint ignore:line
	    interpolationParams = interpolationParams || {};
	    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);
	
	    var interpolatedText;
	    if (angular.isNumber(value)) {
	      // numbers are safe
	      interpolatedText = '' + value;
	    } else if (angular.isString(value)) {
	      // strings must be interpolated (that's the job here)
	      interpolatedText = $interpolate(value)(interpolationParams);
	      interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
	    } else {
	      // neither a number or a string, cant interpolate => empty string
	      interpolatedText = '';
	    }
	
	    return interpolatedText;
	  };
	
	  return $translateInterpolator;
	}
	
	$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';
	
	angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate
	 * @requires $interpolate,
	 * @requires $compile,
	 * @requires $parse,
	 * @requires $rootScope
	 * @restrict AE
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses $translate service to translate the translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate Translation id which could be either string or interpolated string.
	 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
	 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
	 * @param {string=} translate-default will be used unless translation was successful
	 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
	 * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre translate="TRANSLATION_ID"></pre>
	        <pre translate>TRANSLATION_ID</pre>
	        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
	        <pre translate="{{translationId}}"></pre>
	        <pre translate>{{translationId}}</pre>
	        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
	        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
	        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
	        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('title')).toBe('Hello there!');
	
	          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translate', translateDirective);
	function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {
	
	  'use strict';
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function() {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  /**
	   * @name lowercase
	   * @private
	   *
	   * @description
	   * Return the lowercase string only if the type is string
	   *
	   * @returns {string} The string all in lowercase
	   */
	  var lowercase = function (string) {
	    return angular.isString(string) ? string.toLowerCase() : string;
	  };
	
	  return {
	    restrict: 'AE',
	    scope: true,
	    priority: $translate.directivePriority(),
	    compile: function (tElement, tAttr) {
	
	      var translateValuesExist = (tAttr.translateValues) ?
	        tAttr.translateValues : undefined;
	
	      var translateInterpolation = (tAttr.translateInterpolation) ?
	        tAttr.translateInterpolation : undefined;
	
	      var translateSanitizeStrategyExist = (tAttr.translateSanitizeStrategy) ?
	        tAttr.translateSanitizeStrategy : undefined;
	
	      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);
	
	      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
	          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';
	
	      return function linkFn(scope, iElement, iAttr) {
	
	        scope.interpolateParams = {};
	        scope.preText = '';
	        scope.postText = '';
	        scope.translateNamespace = getTranslateNamespace(scope);
	        var translationIds = {};
	
	        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
	          // initial setup
	          if (iAttr.translateValues) {
	            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
	          }
	          // initially fetch all attributes if existing and fill the params
	          if (translateValueExist) {
	            for (var attr in tAttr) {
	              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	                var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
	                interpolateParams[attributeName] = tAttr[attr];
	              }
	            }
	          }
	        };
	
	        // Ensures any change of the attribute "translate" containing the id will
	        // be re-stored to the scope's "translationId".
	        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
	        var observeElementTranslation = function (translationId) {
	
	          // Remove any old watcher
	          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
	            observeElementTranslation._unwatchOld();
	            observeElementTranslation._unwatchOld = undefined;
	          }
	
	          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
	            var iElementText = trim.apply(iElement.text()).replace(/\n/g, ' ');
	
	            // Resolve translation id by inner html if required
	            var interpolateMatches = iElementText.match(interpolateRegExp);
	            // Interpolate translation id if required
	            if (angular.isArray(interpolateMatches)) {
	              scope.preText = interpolateMatches[1];
	              scope.postText = interpolateMatches[3];
	              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
	              var watcherMatches = iElementText.match(watcherRegExp);
	              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
	                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
	                  translationIds.translate = newValue;
	                  updateTranslations();
	                });
	              }
	            } else {
	              // do not assigne the translation id if it is empty.
	              translationIds.translate = !iElementText ? undefined : iElementText;
	            }
	          } else {
	            translationIds.translate = translationId;
	          }
	          updateTranslations();
	        };
	
	        var observeAttributeTranslation = function (translateAttr) {
	          iAttr.$observe(translateAttr, function (translationId) {
	            translationIds[translateAttr] = translationId;
	            updateTranslations();
	          });
	        };
	
	        // initial setup with values
	        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);
	
	        var firstAttributeChangedEvent = true;
	        iAttr.$observe('translate', function (translationId) {
	          if (typeof translationId === 'undefined') {
	            // case of element "<translate>xyz</translate>"
	            observeElementTranslation('');
	          } else {
	            // case of regular attribute
	            if (translationId !== '' || !firstAttributeChangedEvent) {
	              translationIds.translate = translationId;
	              updateTranslations();
	            }
	          }
	          firstAttributeChangedEvent = false;
	        });
	
	        for (var translateAttr in iAttr) {
	          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
	            observeAttributeTranslation(translateAttr);
	          }
	        }
	
	        iAttr.$observe('translateDefault', function (value) {
	          scope.defaultText = value;
	          updateTranslations();
	        });
	
	        if (translateSanitizeStrategyExist) {
	          iAttr.$observe('translateSanitizeStrategy', function (value) {
	            scope.sanitizeStrategy = $parse(value)(scope.$parent);
	            updateTranslations();
	          });
	        }
	
	        if (translateValuesExist) {
	          iAttr.$observe('translateValues', function (interpolateParams) {
	            if (interpolateParams) {
	              scope.$parent.$watch(function () {
	                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
	              });
	            }
	          });
	        }
	
	        if (translateValueExist) {
	          var observeValueAttribute = function (attrName) {
	            iAttr.$observe(attrName, function (value) {
	              var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
	              scope.interpolateParams[attributeName] = value;
	            });
	          };
	          for (var attr in iAttr) {
	            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	              observeValueAttribute(attr);
	            }
	          }
	        }
	
	        // Master update function
	        var updateTranslations = function () {
	          for (var key in translationIds) {
	            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
	              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
	            }
	          }
	        };
	
	        // Put translation processing function outside loop
	        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
	          if (translationId) {
	            // if translation id starts with '.' and translateNamespace given, prepend namespace
	            if (translateNamespace && translationId.charAt(0) === '.') {
	              translationId = translateNamespace + translationId;
	            }
	
	            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy)
	              .then(function (translation) {
	                applyTranslation(translation, scope, true, translateAttr);
	              }, function (translationId) {
	                applyTranslation(translationId, scope, false, translateAttr);
	              });
	          } else {
	            // as an empty string cannot be translated, we can solve this using successful=false
	            applyTranslation(translationId, scope, false, translateAttr);
	          }
	        };
	
	        var applyTranslation = function (value, scope, successful, translateAttr) {
	          if (!successful) {
	            if (typeof scope.defaultText !== 'undefined') {
	              value = scope.defaultText;
	            }
	          }
	          if (translateAttr === 'translate') {
	            // default translate into innerHTML
	            if (successful || (!successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined')) {
	              iElement.empty().append(scope.preText + value + scope.postText);
	            }
	            var globallyEnabled = $translate.isPostCompilingEnabled();
	            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
	            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
	            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
	              $compile(iElement.contents())(scope);
	            }
	          } else {
	            // translate attribute
	            var attributeName = iAttr.$attr[translateAttr];
	            if (attributeName.substr(0, 5) === 'data-') {
	              // ensure html5 data prefix is stripped
	              attributeName = attributeName.substr(5);
	            }
	            attributeName = attributeName.substr(15);
	            iElement.attr(attributeName, value);
	          }
	        };
	
	        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
	          scope.$watch('interpolateParams', updateTranslations, true);
	        }
	
	        // Replaced watcher on translateLanguage with event listener
	        scope.$on('translateLanguageChanged', updateTranslations);
	
	        // Ensures the text will be refreshed after the current language was changed
	        // w/ $translate.use(...)
	        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	        // ensure translation will be looked up at least one
	        if (iElement.text().length) {
	          if (iAttr.translate) {
	            observeElementTranslation(iAttr.translate);
	          } else {
	            observeElementTranslation('');
	          }
	        } else if (iAttr.translate) {
	          // ensure attribute will be not skipped
	          observeElementTranslation(iAttr.translate);
	        }
	        updateTranslations();
	        scope.$on('$destroy', unbind);
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateDirective.displayName = 'translateDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate-attr
	 * @restrict A
	 *
	 * @description
	 * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
	 * Internally it uses `translate` service to translate translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate-attr Object literal mapping attributes to translation ids.
	 * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
	 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('placeholder)).toBe('Hello there!');
	          expect(element.attr('title)).toBe('The following value is dynamic: 5');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translateAttr', translateAttrDirective);
	function translateAttrDirective($translate, $rootScope) {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    priority: $translate.directivePriority(),
	    link: function linkFn(scope, element, attr) {
	
	      var translateAttr,
	          translateValues,
	          translateSanitizeStrategy,
	          previousAttributes = {};
	
	      // Main update translations function
	      var updateTranslations = function () {
	        angular.forEach(translateAttr, function (translationId, attributeName) {
	          if (!translationId) {
	            return;
	          }
	          previousAttributes[attributeName] = true;
	
	          // if translation id starts with '.' and translateNamespace given, prepend namespace
	          if (scope.translateNamespace && translationId.charAt(0) === '.') {
	            translationId = scope.translateNamespace + translationId;
	          }
	          $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy)
	            .then(function (translation) {
	              element.attr(attributeName, translation);
	            }, function (translationId) {
	              element.attr(attributeName, translationId);
	            });
	        });
	
	        // Removing unused attributes that were previously used
	        angular.forEach(previousAttributes, function (flag, attributeName) {
	          if (!translateAttr[attributeName]) {
	            element.removeAttr(attributeName);
	            delete previousAttributes[attributeName];
	          }
	        });
	      };
	
	      // Watch for attribute changes
	      watchAttribute(
	        scope,
	        attr.translateAttr,
	        function (newValue) { translateAttr = newValue; },
	        updateTranslations
	      );
	      // Watch for value changes
	      watchAttribute(
	        scope,
	        attr.translateValues,
	        function (newValue) { translateValues = newValue; },
	        updateTranslations
	      );
	      // Watch for sanitize strategy changes
	      watchAttribute(
	        scope,
	        attr.translateSanitizeStrategy,
	        function (newValue) { translateSanitizeStrategy = newValue; },
	        updateTranslations
	      );
	
	      if (attr.translateValues) {
	        scope.$watch(attr.translateValues, updateTranslations, true);
	      }
	
	      // Replaced watcher on translateLanguage with event listener
	      scope.$on('translateLanguageChanged', updateTranslations);
	
	      // Ensures the text will be refreshed after the current language was changed
	      // w/ $translate.use(...)
	      var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	      updateTranslations();
	      scope.$on('$destroy', unbind);
	    }
	  };
	}
	
	function watchAttribute(scope, attribute, valueCallback, changeCallback) {
	  'use strict';
	  if (!attribute) {
	    return;
	  }
	  if (attribute.substr(0, 2) === '::') {
	    attribute = attribute.substr(2);
	  } else {
	    scope.$watch(attribute, function(newValue) {
	      valueCallback(newValue);
	      changeCallback();
	    }, true);
	  }
	  valueCallback(scope.$eval(attribute));
	}
	
	translateAttrDirective.displayName = 'translateAttrDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateCloak
	 * @requires $translate
	 * @restrict A
	 *
	 * $description
	 * Adds a `translate-cloak` class name to the given element where this directive
	 * is applied initially and removes it, once a loader has finished loading.
	 *
	 * This directive can be used to prevent initial flickering when loading translation
	 * data asynchronously.
	 *
	 * The class name is defined in
	 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
	 *
	 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
	 *                                  or hiding the cloak. Basically it relies on the translation
	 *                                  resolve.
	 */
	.directive('translateCloak', translateCloakDirective);
	
	function translateCloakDirective($translate, $rootScope) {
	
	  'use strict';
	
	  return {
	    compile : function (tElement) {
	      var applyCloak = function (element) {
	          element.addClass($translate.cloakClassName());
	        },
	        removeCloak = function (element) {
	          element.removeClass($translate.cloakClassName());
	        };
	      applyCloak(tElement);
	
	      return function linkFn(scope, iElement, iAttr) {
	        //Create bound functions that incorporate the active DOM element.
	        var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
	        if (iAttr.translateCloak && iAttr.translateCloak.length) {
	          // Register a watcher for the defined translation allowing a fine tuned cloak
	          iAttr.$observe('translateCloak', function (translationId) {
	            $translate(translationId).then(iRemoveCloak, iApplyCloak);
	          });
	          $rootScope.$on('$translateChangeSuccess', function () {
	            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
	          });
	        } else {
	          $translate.onReady(iRemoveCloak);
	        }
	      };
	    }
	  };
	}
	
	translateCloakDirective.displayName = 'translateCloakDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateNamespace
	 * @restrict A
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses `translate` filter to translate translation id. It is possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate namespace name which could be either string or interpolated string.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div translate-namespace="CONTENT">
	
	        <div>
	            <h1 translate>.HEADERS.TITLE</h1>
	            <h1 translate>.HEADERS.WELCOME</h1>
	        </div>
	
	        <div translate-namespace=".HEADERS">
	            <h1 translate>.TITLE</h1>
	            <h1 translate>.WELCOME</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'CONTENT': {
	            'HEADERS': {
	                TITLE: 'Title'
	            }
	          },
	          'CONTENT.HEADERS.WELCOME': 'Welcome'
	        }).preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateNamespace', translateNamespaceDirective);
	
	function translateNamespaceDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return {
	        pre: function (scope, iElement, iAttrs) {
	          scope.translateNamespace = _getTranslateNamespace(scope);
	
	          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
	            scope.translateNamespace += iAttrs.translateNamespace;
	          } else {
	            scope.translateNamespace = iAttrs.translateNamespace;
	          }
	        }
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function _getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return _getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateNamespaceDirective.displayName = 'translateNamespaceDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateLanguage
	 * @restrict A
	 *
	 * @description
	 * Forces the language to the directives in the underlying scope.
	 *
	 * @param {string=} translate language that will be negotiated.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div>
	
	        <div>
	            <h1 translate>HELLO</h1>
	        </div>
	
	        <div translate-language="de">
	            <h1 translate>HELLO</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider
	          .translations('en',{
	            'HELLO': 'Hello world!'
	          })
	          .translations('de',{
	            'HELLO': 'Hallo Welt!'
	          })
	          .preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateLanguage', translateLanguageDirective);
	
	function translateLanguageDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return function linkFn(scope, iElement, iAttrs) {
	
	        iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
	          scope.translateLanguage = newTranslateLanguage;
	        });
	
	        scope.$watch('translateLanguage', function(){
	          scope.$broadcast('translateLanguageChanged');
	        });
	      };
	    }
	  };
	}
	
	translateLanguageDirective.displayName = 'translateLanguageDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc filter
	 * @name pascalprecht.translate.filter:translate
	 * @requires $parse
	 * @requires pascalprecht.translate.$translate
	 * @function
	 *
	 * @description
	 * Uses `$translate` service to translate contents. Accepts interpolate parameters
	 * to pass dynamized values though translation.
	 *
	 * @param {string} translationId A translation id to be translated.
	 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
	 *
	 * @returns {string} Translated text.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
	        <pre>{{ translationId | translate }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en', {
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}'
	        });
	        $translateProvider.preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	   </example>
	 */
	.filter('translate', translateFilterFactory);
	
	function translateFilterFactory($parse, $translate) {
	
	  'use strict';
	
	  var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
	    if (!angular.isObject(interpolateParams)) {
	      var ctx = this || {
	        '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
	        };
	      interpolateParams = $parse(interpolateParams)(ctx);
	    }
	
	    return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
	  };
	
	  if ($translate.statefulFilter()) {
	    translateFilter.$stateful = true;
	  }
	
	  return translateFilter;
	}
	
	translateFilterFactory.displayName = 'translateFilterFactory';
	
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translationCache
	 * @requires $cacheFactory
	 *
	 * @description
	 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
	 * can load translation tables directly into the cache by consuming the
	 * `$translationCache` service directly.
	 *
	 * @return {object} $cacheFactory object.
	 */
	  .factory('$translationCache', $translationCache);
	
	function $translationCache($cacheFactory) {
	
	  'use strict';
	
	  return $cacheFactory('translations');
	}
	
	$translationCache.displayName = '$translationCache';
	return 'pascalprecht.translate';
	
	}));


/***/ }),
/* 483 */
/***/ (function(module, exports) {

	/*
	  Bootstrap - File Input
	  ======================
	
	  This is meant to convert all file input tags into a set of elements that displays consistently in all browsers.
	
	  Converts all
	  <input type="file">
	  into Bootstrap buttons
	  <a class="btn">Browse</a>
	
	*/
	(function($) {
	
	$.fn.bootstrapFileInput = function() {
	
	  this.each(function(i,elem){
	
	    var $elem = $(elem);
	
	    // Add [processed] class to avoid double processing of input file element
	    if (typeof $elem.attr('data-bfi-processed-class') != 'undefined') {
	      // Check if the element already has the [processed] flag on it and skip it if it does
	      if ($elem.hasClass($elem.attr('data-bfi-processed-class'))) {
	          return;
	      }
	      $elem.addClass($elem.attr('data-bfi-processed-class'));
	    }
	
	    // Maybe some fields don't need to be standardized.
	    if (typeof $elem.attr('data-bfi-disabled') != 'undefined') {
	      return;
	    }
	
	    // Set the word to be displayed on the button
	    var buttonWord = 'Browse';
	
	    if (typeof $elem.attr('title') != 'undefined') {
	      buttonWord = $elem.attr('title');
	    }
	
	    var className = '';
	
	    if (!!$elem.attr('class')) {
	      className = ' ' + $elem.attr('class');
	    }
	
	    // Now we're going to wrap that input field with a Bootstrap button.
	    // The input will actually still be there, it will just be float above and transparent (done with the CSS).
	    $elem.wrap('<a class="file-input-wrapper btn btn-default ' + className + '"></a>').parent().prepend($('<span></span>').html(buttonWord));
	  })
	
	  // After we have found all of the file inputs let's apply a listener for tracking the mouse movement.
	  // This is important because the in order to give the illusion that this is a button in FF we actually need to move the button from the file input under the cursor. Ugh.
	  .promise().done( function(){
	
	    // As the cursor moves over our new Bootstrap button we need to adjust the position of the invisible file input Browse button to be under the cursor.
	    // This gives us the pointer cursor that FF denies us
	    $('.file-input-wrapper').on('mousemove', function(cursor) {
	
	      var input, wrapper,
	        wrapperX, wrapperY,
	        inputWidth, inputHeight,
	        cursorX, cursorY;
	
	      // This wrapper element (the button surround this file input)
	      wrapper = $(this);
	      // The invisible file input element
	      input = wrapper.find("input");
	      // The left-most position of the wrapper
	      wrapperX = wrapper.offset().left;
	      // The top-most position of the wrapper
	      wrapperY = wrapper.offset().top;
	      // The with of the browsers input field
	      inputWidth= input.width();
	      // The height of the browsers input field
	      inputHeight= input.height();
	      //The position of the cursor in the wrapper
	      cursorX = cursor.pageX;
	      cursorY = cursor.pageY;
	
	      //The positions we are to move the invisible file input
	      // The 20 at the end is an arbitrary number of pixels that we can shift the input such that cursor is not pointing at the end of the Browse button but somewhere nearer the middle
	      moveInputX = cursorX - wrapperX - inputWidth + 20;
	      // Slides the invisible input Browse button to be positioned middle under the cursor
	      moveInputY = cursorY- wrapperY - (inputHeight/2);
	
	      // Apply the positioning styles to actually move the invisible file input
	      input.css({
	        left:moveInputX,
	        top:moveInputY
	      });
	    });
	
	    $('body').on('change', '.file-input-wrapper input[type=file]', function(){
	
	      var fileName;
	      fileName = $(this).val();
	
	      // Remove any previous file names
	      $(this).parent().next('.file-input-name').remove();
	      if (!!$(this).prop('files') && $(this).prop('files').length > 1) {
	        var filesLabel = $(this).data('files-label');
	        if (!filesLabel) {
	          filesLabel = 'files';
	        }
	        fileName = $(this)[0].files.length+' '+filesLabel;
	      }
	      else {
	        fileName = fileName.substring(fileName.lastIndexOf('\\') + 1, fileName.length);
	      }
	
	      // Don't try to show the name if there is none
	      if (!fileName) {
	        return;
	      }
	
	      var selectedFileNamePlacement = $(this).data('filename-placement');
	      if (selectedFileNamePlacement === 'inside') {
	        // Print the fileName inside
	        $(this).siblings('span').html(fileName);
	        $(this).attr('title', fileName);
	      } else {
	        // Print the fileName aside (right after the the button)
	        $(this).parent().after('<span class="file-input-name">'+fileName+'</span>');
	      }
	    });
	
	  });
	
	};
	
	// Add the styles before the first stylesheet
	// This ensures they can be easily overridden with developer styles
	var cssHtml = '<style>'+
	  '.file-input-wrapper { overflow: hidden; position: relative; cursor: pointer; z-index: 1; }'+
	  '.file-input-wrapper input[type=file], .file-input-wrapper input[type=file]:focus, .file-input-wrapper input[type=file]:hover { position: absolute; top: 0; left: 0; cursor: pointer; opacity: 0; filter: alpha(opacity=0); z-index: 99; outline: 0; }'+
	  '.file-input-name { margin-left: 8px; }'+
	  '</style>';
	$('link[rel=stylesheet]').eq(0).before(cssHtml);
	
	})(jQuery);


/***/ }),
/* 484 */
/***/ (function(module, exports) {

	/*
	 * jquery.flot.tooltip
	 * 
	 * description: easy-to-use tooltips for Flot charts
	 * version: 0.9.0
	 * authors: Krzysztof Urbas @krzysu [myviews.pl],Evan Steinkerchner @Roundaround
	 * website: https://github.com/krzysu/flot.tooltip
	 * 
	 * build on 2016-07-26
	 * released under MIT License, 2012
	*/ 
	!function(a){var b={tooltip:{show:!1,cssClass:"flotTip",content:"%s | X: %x | Y: %y",xDateFormat:null,yDateFormat:null,monthNames:null,dayNames:null,shifts:{x:10,y:20},defaultTheme:!0,snap:!0,lines:!1,clickTips:!1,onHover:function(a,b){},$compat:!1}};b.tooltipOpts=b.tooltip;var c=function(a){this.tipPosition={x:0,y:0},this.init(a)};c.prototype.init=function(b){function c(a){var c={};c.x=a.pageX,c.y=a.pageY,b.setTooltipPosition(c)}function d(c,d,g){f.clickmode?(a(b.getPlaceholder()).bind("plothover",e),b.hideTooltip(),f.clickmode=!1):(e(c,d,g),f.getDomElement().is(":visible")&&(a(b.getPlaceholder()).unbind("plothover",e),f.clickmode=!0))}function e(c,d,e){var g=function(a,b,c,d){return Math.sqrt((c-a)*(c-a)+(d-b)*(d-b))},h=function(a,b,c,d,e,f,h){if(!h||(h=function(a,b,c,d,e,f){if("undefined"!=typeof c)return{x:c,y:b};if("undefined"!=typeof d)return{x:a,y:d};var g,h=-1/((f-d)/(e-c));return{x:g=(e*(a*h-b+d)+c*(a*-h+b-f))/(h*(e-c)+d-f),y:h*g-h*a+b}}(a,b,c,d,e,f),h.x>=Math.min(c,e)&&h.x<=Math.max(c,e)&&h.y>=Math.min(d,f)&&h.y<=Math.max(d,f))){var i=d-f,j=e-c,k=c*f-d*e;return Math.abs(i*a+j*b+k)/Math.sqrt(i*i+j*j)}var l=g(a,b,c,d),m=g(a,b,e,f);return l>m?m:l};if(e)b.showTooltip(e,f.tooltipOptions.snap?e:d);else if(f.plotOptions.series.lines.show&&f.tooltipOptions.lines===!0){var i=f.plotOptions.grid.mouseActiveRadius,j={distance:i+1},k=d;a.each(b.getData(),function(a,c){for(var e=0,i=-1,l=1;l<c.data.length;l++)c.data[l-1][0]<=d.x&&c.data[l][0]>=d.x&&(e=l-1,i=l);if(-1===i)return void b.hideTooltip();var m={x:c.data[e][0],y:c.data[e][1]},n={x:c.data[i][0],y:c.data[i][1]},o=h(c.xaxis.p2c(d.x),c.yaxis.p2c(d.y),c.xaxis.p2c(m.x),c.yaxis.p2c(m.y),c.xaxis.p2c(n.x),c.yaxis.p2c(n.y),!1);if(o<j.distance){var p=g(m.x,m.y,d.x,d.y)<g(d.x,d.y,n.x,n.y)?e:i,q=(c.datapoints.pointsize,[d.x,m.y+(n.y-m.y)*((d.x-m.x)/(n.x-m.x))]),r={datapoint:q,dataIndex:p,series:c,seriesIndex:a};j={distance:o,item:r},f.tooltipOptions.snap&&(k={pageX:c.xaxis.p2c(q[0]),pageY:c.yaxis.p2c(q[1])})}}),j.distance<i+1?b.showTooltip(j.item,k):b.hideTooltip()}else b.hideTooltip()}var f=this,g=a.plot.plugins.length;if(this.plotPlugins=[],g)for(var h=0;g>h;h++)this.plotPlugins.push(a.plot.plugins[h].name);b.hooks.bindEvents.push(function(b,g){if(f.plotOptions=b.getOptions(),"boolean"==typeof f.plotOptions.tooltip&&(f.plotOptions.tooltipOpts.show=f.plotOptions.tooltip,f.plotOptions.tooltip=f.plotOptions.tooltipOpts,delete f.plotOptions.tooltipOpts),f.plotOptions.tooltip.show!==!1&&"undefined"!=typeof f.plotOptions.tooltip.show){f.tooltipOptions=f.plotOptions.tooltip,f.tooltipOptions.$compat?(f.wfunc="width",f.hfunc="height"):(f.wfunc="innerWidth",f.hfunc="innerHeight");f.getDomElement();a(b.getPlaceholder()).bind("plothover",e),f.tooltipOptions.clickTips&&a(b.getPlaceholder()).bind("plotclick",d),f.clickmode=!1,a(g).bind("mousemove",c)}}),b.hooks.shutdown.push(function(b,f){a(b.getPlaceholder()).unbind("plothover",e),a(b.getPlaceholder()).unbind("plotclick",d),b.removeTooltip(),a(f).unbind("mousemove",c)}),b.setTooltipPosition=function(b){var c=f.getDomElement(),d=c.outerWidth()+f.tooltipOptions.shifts.x,e=c.outerHeight()+f.tooltipOptions.shifts.y;b.x-a(window).scrollLeft()>a(window)[f.wfunc]()-d&&(b.x-=d,b.x=Math.max(b.x,0)),b.y-a(window).scrollTop()>a(window)[f.hfunc]()-e&&(b.y-=e),isNaN(b.x)?f.tipPosition.x=f.tipPosition.xPrev:(f.tipPosition.x=b.x,f.tipPosition.xPrev=b.x),isNaN(b.y)?f.tipPosition.y=f.tipPosition.yPrev:(f.tipPosition.y=b.y,f.tipPosition.yPrev=b.y)},b.showTooltip=function(a,c,d){var e=f.getDomElement(),g=f.stringFormat(f.tooltipOptions.content,a);""!==g&&(e.html(g),b.setTooltipPosition({x:f.tipPosition.x,y:f.tipPosition.y}),e.css({left:f.tipPosition.x+f.tooltipOptions.shifts.x,top:f.tipPosition.y+f.tooltipOptions.shifts.y}).show(),"function"==typeof f.tooltipOptions.onHover&&f.tooltipOptions.onHover(a,e))},b.hideTooltip=function(){f.getDomElement().hide().html("")},b.removeTooltip=function(){f.getDomElement().remove()}},c.prototype.getDomElement=function(){var b=a("<div>");return this.tooltipOptions&&this.tooltipOptions.cssClass&&(b=a("."+this.tooltipOptions.cssClass),0===b.length&&(b=a("<div />").addClass(this.tooltipOptions.cssClass),b.appendTo("body").hide().css({position:"absolute"}),this.tooltipOptions.defaultTheme&&b.css({background:"#fff","z-index":"1040",padding:"0.4em 0.6em","border-radius":"0.5em","font-size":"0.8em",border:"1px solid #111",display:"none","white-space":"nowrap"}))),b},c.prototype.stringFormat=function(a,b){var c,d,e,f,g,h=/%p\.{0,1}(\d{0,})/,i=/%s/,j=/%c/,k=/%lx/,l=/%ly/,m=/%x\.{0,1}(\d{0,})/,n=/%y\.{0,1}(\d{0,})/,o="%x",p="%y",q="%ct",r="%n";if("undefined"!=typeof b.series.threshold?(c=b.datapoint[0],d=b.datapoint[1],e=b.datapoint[2]):"undefined"!=typeof b.series.curvedLines?(c=b.datapoint[0],d=b.datapoint[1]):"undefined"!=typeof b.series.lines&&b.series.lines.steps?(c=b.series.datapoints.points[2*b.dataIndex],d=b.series.datapoints.points[2*b.dataIndex+1],e=""):(c=b.series.data[b.dataIndex][0],d=b.series.data[b.dataIndex][1],e=b.series.data[b.dataIndex][2]),null===b.series.label&&b.series.originSeries&&(b.series.label=b.series.originSeries.label),"function"==typeof a&&(a=a(b.series.label,c,d,b)),"boolean"==typeof a&&!a)return"";if(e&&(a=a.replace(q,e)),"undefined"!=typeof b.series.percent?f=b.series.percent:"undefined"!=typeof b.series.percents&&(f=b.series.percents[b.dataIndex]),"number"==typeof f&&(a=this.adjustValPrecision(h,a,f)),b.series.hasOwnProperty("pie")&&"undefined"!=typeof b.series.data[0][1]&&(g=b.series.data[0][1]),"number"==typeof g&&(a=a.replace(r,g)),a="undefined"!=typeof b.series.label?a.replace(i,b.series.label):a.replace(i,""),a="undefined"!=typeof b.series.color?a.replace(j,b.series.color):a.replace(j,""),a=this.hasAxisLabel("xaxis",b)?a.replace(k,b.series.xaxis.options.axisLabel):a.replace(k,""),a=this.hasAxisLabel("yaxis",b)?a.replace(l,b.series.yaxis.options.axisLabel):a.replace(l,""),this.isTimeMode("xaxis",b)&&this.isXDateFormat(b)&&(a=a.replace(m,this.timestampToDate(c,this.tooltipOptions.xDateFormat,b.series.xaxis.options))),this.isTimeMode("yaxis",b)&&this.isYDateFormat(b)&&(a=a.replace(n,this.timestampToDate(d,this.tooltipOptions.yDateFormat,b.series.yaxis.options))),"number"==typeof c&&(a=this.adjustValPrecision(m,a,c)),"number"==typeof d&&(a=this.adjustValPrecision(n,a,d)),"undefined"!=typeof b.series.xaxis.ticks){var s;s=this.hasRotatedXAxisTicks(b)?"rotatedTicks":"ticks";var t=b.dataIndex+b.seriesIndex;for(var u in b.series.xaxis[s])if(b.series.xaxis[s].hasOwnProperty(t)&&!this.isTimeMode("xaxis",b)){var v=this.isCategoriesMode("xaxis",b)?b.series.xaxis[s][t].label:b.series.xaxis[s][t].v;v===c&&(a=a.replace(m,b.series.xaxis[s][t].label.replace(/\$/g,"$$$$")))}}if("undefined"!=typeof b.series.yaxis.ticks)for(var w in b.series.yaxis.ticks)if(b.series.yaxis.ticks.hasOwnProperty(w)){var x=this.isCategoriesMode("yaxis",b)?b.series.yaxis.ticks[w].label:b.series.yaxis.ticks[w].v;x===d&&(a=a.replace(n,b.series.yaxis.ticks[w].label.replace(/\$/g,"$$$$")))}return"undefined"!=typeof b.series.xaxis.tickFormatter&&(a=a.replace(o,b.series.xaxis.tickFormatter(c,b.series.xaxis).replace(/\$/g,"$$"))),"undefined"!=typeof b.series.yaxis.tickFormatter&&(a=a.replace(p,b.series.yaxis.tickFormatter(d,b.series.yaxis).replace(/\$/g,"$$"))),a},c.prototype.isTimeMode=function(a,b){return"undefined"!=typeof b.series[a].options.mode&&"time"===b.series[a].options.mode},c.prototype.isXDateFormat=function(a){return"undefined"!=typeof this.tooltipOptions.xDateFormat&&null!==this.tooltipOptions.xDateFormat},c.prototype.isYDateFormat=function(a){return"undefined"!=typeof this.tooltipOptions.yDateFormat&&null!==this.tooltipOptions.yDateFormat},c.prototype.isCategoriesMode=function(a,b){return"undefined"!=typeof b.series[a].options.mode&&"categories"===b.series[a].options.mode},c.prototype.timestampToDate=function(b,c,d){var e=a.plot.dateGenerator(b,d);return a.plot.formatDate(e,c,this.tooltipOptions.monthNames,this.tooltipOptions.dayNames)},c.prototype.adjustValPrecision=function(a,b,c){var d,e=b.match(a);return null!==e&&""!==RegExp.$1&&(d=RegExp.$1,c=c.toFixed(d),b=b.replace(a,c)),b},c.prototype.hasAxisLabel=function(b,c){return-1!==a.inArray("axisLabels",this.plotPlugins)&&"undefined"!=typeof c.series[b].options.axisLabel&&c.series[b].options.axisLabel.length>0},c.prototype.hasRotatedXAxisTicks=function(b){return-1!==a.inArray("tickRotor",this.plotPlugins)&&"undefined"!=typeof b.series.xaxis.rotatedTicks};var d=function(a){new c(a)};a.plot.plugins.push({init:d,options:b,name:"tooltip",version:"0.8.5"})}(jQuery);

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	/* Javascript plotting library for jQuery, version 0.8.3.
	
	Copyright (c) 2007-2014 IOLA and Ole Laursen.
	Licensed under the MIT license.
	
	*/
	
	// first an inline dependency, jquery.colorhelpers.js, we inline it here
	// for convenience
	
	/* Plugin for jQuery for working with colors.
	 *
	 * Version 1.1.
	 *
	 * Inspiration from jQuery color animation plugin by John Resig.
	 *
	 * Released under the MIT license by Ole Laursen, October 2009.
	 *
	 * Examples:
	 *
	 *   $.color.parse("#fff").scale('rgb', 0.25).add('a', -0.5).toString()
	 *   var c = $.color.extract($("#mydiv"), 'background-color');
	 *   console.log(c.r, c.g, c.b, c.a);
	 *   $.color.make(100, 50, 25, 0.4).toString() // returns "rgba(100,50,25,0.4)"
	 *
	 * Note that .scale() and .add() return the same modified object
	 * instead of making a new one.
	 *
	 * V. 1.1: Fix error handling so e.g. parsing an empty string does
	 * produce a color rather than just crashing.
	 */
	(function($){$.color={};$.color.make=function(r,g,b,a){var o={};o.r=r||0;o.g=g||0;o.b=b||0;o.a=a!=null?a:1;o.add=function(c,d){for(var i=0;i<c.length;++i)o[c.charAt(i)]+=d;return o.normalize()};o.scale=function(c,f){for(var i=0;i<c.length;++i)o[c.charAt(i)]*=f;return o.normalize()};o.toString=function(){if(o.a>=1){return"rgb("+[o.r,o.g,o.b].join(",")+")"}else{return"rgba("+[o.r,o.g,o.b,o.a].join(",")+")"}};o.normalize=function(){function clamp(min,value,max){return value<min?min:value>max?max:value}o.r=clamp(0,parseInt(o.r),255);o.g=clamp(0,parseInt(o.g),255);o.b=clamp(0,parseInt(o.b),255);o.a=clamp(0,o.a,1);return o};o.clone=function(){return $.color.make(o.r,o.b,o.g,o.a)};return o.normalize()};$.color.extract=function(elem,css){var c;do{c=elem.css(css).toLowerCase();if(c!=""&&c!="transparent")break;elem=elem.parent()}while(elem.length&&!$.nodeName(elem.get(0),"body"));if(c=="rgba(0, 0, 0, 0)")c="transparent";return $.color.parse(c)};$.color.parse=function(str){var res,m=$.color.make;if(res=/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/.exec(str))return m(parseInt(res[1],10),parseInt(res[2],10),parseInt(res[3],10));if(res=/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]+(?:\.[0-9]+)?)\s*\)/.exec(str))return m(parseInt(res[1],10),parseInt(res[2],10),parseInt(res[3],10),parseFloat(res[4]));if(res=/rgb\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*\)/.exec(str))return m(parseFloat(res[1])*2.55,parseFloat(res[2])*2.55,parseFloat(res[3])*2.55);if(res=/rgba\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\s*\)/.exec(str))return m(parseFloat(res[1])*2.55,parseFloat(res[2])*2.55,parseFloat(res[3])*2.55,parseFloat(res[4]));if(res=/#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/.exec(str))return m(parseInt(res[1],16),parseInt(res[2],16),parseInt(res[3],16));if(res=/#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/.exec(str))return m(parseInt(res[1]+res[1],16),parseInt(res[2]+res[2],16),parseInt(res[3]+res[3],16));var name=$.trim(str).toLowerCase();if(name=="transparent")return m(255,255,255,0);else{res=lookupColors[name]||[0,0,0];return m(res[0],res[1],res[2])}};var lookupColors={aqua:[0,255,255],azure:[240,255,255],beige:[245,245,220],black:[0,0,0],blue:[0,0,255],brown:[165,42,42],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgrey:[169,169,169],darkgreen:[0,100,0],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkviolet:[148,0,211],fuchsia:[255,0,255],gold:[255,215,0],green:[0,128,0],indigo:[75,0,130],khaki:[240,230,140],lightblue:[173,216,230],lightcyan:[224,255,255],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightyellow:[255,255,224],lime:[0,255,0],magenta:[255,0,255],maroon:[128,0,0],navy:[0,0,128],olive:[128,128,0],orange:[255,165,0],pink:[255,192,203],purple:[128,0,128],violet:[128,0,128],red:[255,0,0],silver:[192,192,192],white:[255,255,255],yellow:[255,255,0]}})(jQuery);
	
	// the actual Flot code
	(function($) {
	
		// Cache the prototype hasOwnProperty for faster access
	
		var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	    // A shim to provide 'detach' to jQuery versions prior to 1.4.  Using a DOM
	    // operation produces the same effect as detach, i.e. removing the element
	    // without touching its jQuery data.
	
	    // Do not merge this into Flot 0.9, since it requires jQuery 1.4.4+.
	
	    if (!$.fn.detach) {
	        $.fn.detach = function() {
	            return this.each(function() {
	                if (this.parentNode) {
	                    this.parentNode.removeChild( this );
	                }
	            });
	        };
	    }
	
		///////////////////////////////////////////////////////////////////////////
		// The Canvas object is a wrapper around an HTML5 <canvas> tag.
		//
		// @constructor
		// @param {string} cls List of classes to apply to the canvas.
		// @param {element} container Element onto which to append the canvas.
		//
		// Requiring a container is a little iffy, but unfortunately canvas
		// operations don't work unless the canvas is attached to the DOM.
	
		function Canvas(cls, container) {
	
			var element = container.children("." + cls)[0];
	
			if (element == null) {
	
				element = document.createElement("canvas");
				element.className = cls;
	
				$(element).css({ direction: "ltr", position: "absolute", left: 0, top: 0 })
					.appendTo(container);
	
				// If HTML5 Canvas isn't available, fall back to [Ex|Flash]canvas
	
				if (!element.getContext) {
					if (window.G_vmlCanvasManager) {
						element = window.G_vmlCanvasManager.initElement(element);
					} else {
						throw new Error("Canvas is not available. If you're using IE with a fall-back such as Excanvas, then there's either a mistake in your conditional include, or the page has no DOCTYPE and is rendering in Quirks Mode.");
					}
				}
			}
	
			this.element = element;
	
			var context = this.context = element.getContext("2d");
	
			// Determine the screen's ratio of physical to device-independent
			// pixels.  This is the ratio between the canvas width that the browser
			// advertises and the number of pixels actually present in that space.
	
			// The iPhone 4, for example, has a device-independent width of 320px,
			// but its screen is actually 640px wide.  It therefore has a pixel
			// ratio of 2, while most normal devices have a ratio of 1.
	
			var devicePixelRatio = window.devicePixelRatio || 1,
				backingStoreRatio =
					context.webkitBackingStorePixelRatio ||
					context.mozBackingStorePixelRatio ||
					context.msBackingStorePixelRatio ||
					context.oBackingStorePixelRatio ||
					context.backingStorePixelRatio || 1;
	
			this.pixelRatio = devicePixelRatio / backingStoreRatio;
	
			// Size the canvas to match the internal dimensions of its container
	
			this.resize(container.width(), container.height());
	
			// Collection of HTML div layers for text overlaid onto the canvas
	
			this.textContainer = null;
			this.text = {};
	
			// Cache of text fragments and metrics, so we can avoid expensively
			// re-calculating them when the plot is re-rendered in a loop.
	
			this._textCache = {};
		}
	
		// Resizes the canvas to the given dimensions.
		//
		// @param {number} width New width of the canvas, in pixels.
		// @param {number} width New height of the canvas, in pixels.
	
		Canvas.prototype.resize = function(width, height) {
	
			if (width <= 0 || height <= 0) {
				throw new Error("Invalid dimensions for plot, width = " + width + ", height = " + height);
			}
	
			var element = this.element,
				context = this.context,
				pixelRatio = this.pixelRatio;
	
			// Resize the canvas, increasing its density based on the display's
			// pixel ratio; basically giving it more pixels without increasing the
			// size of its element, to take advantage of the fact that retina
			// displays have that many more pixels in the same advertised space.
	
			// Resizing should reset the state (excanvas seems to be buggy though)
	
			if (this.width != width) {
				element.width = width * pixelRatio;
				element.style.width = width + "px";
				this.width = width;
			}
	
			if (this.height != height) {
				element.height = height * pixelRatio;
				element.style.height = height + "px";
				this.height = height;
			}
	
			// Save the context, so we can reset in case we get replotted.  The
			// restore ensure that we're really back at the initial state, and
			// should be safe even if we haven't saved the initial state yet.
	
			context.restore();
			context.save();
	
			// Scale the coordinate space to match the display density; so even though we
			// may have twice as many pixels, we still want lines and other drawing to
			// appear at the same size; the extra pixels will just make them crisper.
	
			context.scale(pixelRatio, pixelRatio);
		};
	
		// Clears the entire canvas area, not including any overlaid HTML text
	
		Canvas.prototype.clear = function() {
			this.context.clearRect(0, 0, this.width, this.height);
		};
	
		// Finishes rendering the canvas, including managing the text overlay.
	
		Canvas.prototype.render = function() {
	
			var cache = this._textCache;
	
			// For each text layer, add elements marked as active that haven't
			// already been rendered, and remove those that are no longer active.
	
			for (var layerKey in cache) {
				if (hasOwnProperty.call(cache, layerKey)) {
	
					var layer = this.getTextLayer(layerKey),
						layerCache = cache[layerKey];
	
					layer.hide();
	
					for (var styleKey in layerCache) {
						if (hasOwnProperty.call(layerCache, styleKey)) {
							var styleCache = layerCache[styleKey];
							for (var key in styleCache) {
								if (hasOwnProperty.call(styleCache, key)) {
	
									var positions = styleCache[key].positions;
	
									for (var i = 0, position; position = positions[i]; i++) {
										if (position.active) {
											if (!position.rendered) {
												layer.append(position.element);
												position.rendered = true;
											}
										} else {
											positions.splice(i--, 1);
											if (position.rendered) {
												position.element.detach();
											}
										}
									}
	
									if (positions.length == 0) {
										delete styleCache[key];
									}
								}
							}
						}
					}
	
					layer.show();
				}
			}
		};
	
		// Creates (if necessary) and returns the text overlay container.
		//
		// @param {string} classes String of space-separated CSS classes used to
		//     uniquely identify the text layer.
		// @return {object} The jQuery-wrapped text-layer div.
	
		Canvas.prototype.getTextLayer = function(classes) {
	
			var layer = this.text[classes];
	
			// Create the text layer if it doesn't exist
	
			if (layer == null) {
	
				// Create the text layer container, if it doesn't exist
	
				if (this.textContainer == null) {
					this.textContainer = $("<div class='flot-text'></div>")
						.css({
							position: "absolute",
							top: 0,
							left: 0,
							bottom: 0,
							right: 0,
							'font-size': "smaller",
							color: "#545454"
						})
						.insertAfter(this.element);
				}
	
				layer = this.text[classes] = $("<div></div>")
					.addClass(classes)
					.css({
						position: "absolute",
						top: 0,
						left: 0,
						bottom: 0,
						right: 0
					})
					.appendTo(this.textContainer);
			}
	
			return layer;
		};
	
		// Creates (if necessary) and returns a text info object.
		//
		// The object looks like this:
		//
		// {
		//     width: Width of the text's wrapper div.
		//     height: Height of the text's wrapper div.
		//     element: The jQuery-wrapped HTML div containing the text.
		//     positions: Array of positions at which this text is drawn.
		// }
		//
		// The positions array contains objects that look like this:
		//
		// {
		//     active: Flag indicating whether the text should be visible.
		//     rendered: Flag indicating whether the text is currently visible.
		//     element: The jQuery-wrapped HTML div containing the text.
		//     x: X coordinate at which to draw the text.
		//     y: Y coordinate at which to draw the text.
		// }
		//
		// Each position after the first receives a clone of the original element.
		//
		// The idea is that that the width, height, and general 'identity' of the
		// text is constant no matter where it is placed; the placements are a
		// secondary property.
		//
		// Canvas maintains a cache of recently-used text info objects; getTextInfo
		// either returns the cached element or creates a new entry.
		//
		// @param {string} layer A string of space-separated CSS classes uniquely
		//     identifying the layer containing this text.
		// @param {string} text Text string to retrieve info for.
		// @param {(string|object)=} font Either a string of space-separated CSS
		//     classes or a font-spec object, defining the text's font and style.
		// @param {number=} angle Angle at which to rotate the text, in degrees.
		//     Angle is currently unused, it will be implemented in the future.
		// @param {number=} width Maximum width of the text before it wraps.
		// @return {object} a text info object.
	
		Canvas.prototype.getTextInfo = function(layer, text, font, angle, width) {
	
			var textStyle, layerCache, styleCache, info;
	
			// Cast the value to a string, in case we were given a number or such
	
			text = "" + text;
	
			// If the font is a font-spec object, generate a CSS font definition
	
			if (typeof font === "object") {
				textStyle = font.style + " " + font.variant + " " + font.weight + " " + font.size + "px/" + font.lineHeight + "px " + font.family;
			} else {
				textStyle = font;
			}
	
			// Retrieve (or create) the cache for the text's layer and styles
	
			layerCache = this._textCache[layer];
	
			if (layerCache == null) {
				layerCache = this._textCache[layer] = {};
			}
	
			styleCache = layerCache[textStyle];
	
			if (styleCache == null) {
				styleCache = layerCache[textStyle] = {};
			}
	
			info = styleCache[text];
	
			// If we can't find a matching element in our cache, create a new one
	
			if (info == null) {
	
				var element = $("<div></div>").html(text)
					.css({
						position: "absolute",
						'max-width': width,
						top: -9999
					})
					.appendTo(this.getTextLayer(layer));
	
				if (typeof font === "object") {
					element.css({
						font: textStyle,
						color: font.color
					});
				} else if (typeof font === "string") {
					element.addClass(font);
				}
	
				info = styleCache[text] = {
					width: element.outerWidth(true),
					height: element.outerHeight(true),
					element: element,
					positions: []
				};
	
				element.detach();
			}
	
			return info;
		};
	
		// Adds a text string to the canvas text overlay.
		//
		// The text isn't drawn immediately; it is marked as rendering, which will
		// result in its addition to the canvas on the next render pass.
		//
		// @param {string} layer A string of space-separated CSS classes uniquely
		//     identifying the layer containing this text.
		// @param {number} x X coordinate at which to draw the text.
		// @param {number} y Y coordinate at which to draw the text.
		// @param {string} text Text string to draw.
		// @param {(string|object)=} font Either a string of space-separated CSS
		//     classes or a font-spec object, defining the text's font and style.
		// @param {number=} angle Angle at which to rotate the text, in degrees.
		//     Angle is currently unused, it will be implemented in the future.
		// @param {number=} width Maximum width of the text before it wraps.
		// @param {string=} halign Horizontal alignment of the text; either "left",
		//     "center" or "right".
		// @param {string=} valign Vertical alignment of the text; either "top",
		//     "middle" or "bottom".
	
		Canvas.prototype.addText = function(layer, x, y, text, font, angle, width, halign, valign) {
	
			var info = this.getTextInfo(layer, text, font, angle, width),
				positions = info.positions;
	
			// Tweak the div's position to match the text's alignment
	
			if (halign == "center") {
				x -= info.width / 2;
			} else if (halign == "right") {
				x -= info.width;
			}
	
			if (valign == "middle") {
				y -= info.height / 2;
			} else if (valign == "bottom") {
				y -= info.height;
			}
	
			// Determine whether this text already exists at this position.
			// If so, mark it for inclusion in the next render pass.
	
			for (var i = 0, position; position = positions[i]; i++) {
				if (position.x == x && position.y == y) {
					position.active = true;
					return;
				}
			}
	
			// If the text doesn't exist at this position, create a new entry
	
			// For the very first position we'll re-use the original element,
			// while for subsequent ones we'll clone it.
	
			position = {
				active: true,
				rendered: false,
				element: positions.length ? info.element.clone() : info.element,
				x: x,
				y: y
			};
	
			positions.push(position);
	
			// Move the element to its final position within the container
	
			position.element.css({
				top: Math.round(y),
				left: Math.round(x),
				'text-align': halign	// In case the text wraps
			});
		};
	
		// Removes one or more text strings from the canvas text overlay.
		//
		// If no parameters are given, all text within the layer is removed.
		//
		// Note that the text is not immediately removed; it is simply marked as
		// inactive, which will result in its removal on the next render pass.
		// This avoids the performance penalty for 'clear and redraw' behavior,
		// where we potentially get rid of all text on a layer, but will likely
		// add back most or all of it later, as when redrawing axes, for example.
		//
		// @param {string} layer A string of space-separated CSS classes uniquely
		//     identifying the layer containing this text.
		// @param {number=} x X coordinate of the text.
		// @param {number=} y Y coordinate of the text.
		// @param {string=} text Text string to remove.
		// @param {(string|object)=} font Either a string of space-separated CSS
		//     classes or a font-spec object, defining the text's font and style.
		// @param {number=} angle Angle at which the text is rotated, in degrees.
		//     Angle is currently unused, it will be implemented in the future.
	
		Canvas.prototype.removeText = function(layer, x, y, text, font, angle) {
			if (text == null) {
				var layerCache = this._textCache[layer];
				if (layerCache != null) {
					for (var styleKey in layerCache) {
						if (hasOwnProperty.call(layerCache, styleKey)) {
							var styleCache = layerCache[styleKey];
							for (var key in styleCache) {
								if (hasOwnProperty.call(styleCache, key)) {
									var positions = styleCache[key].positions;
									for (var i = 0, position; position = positions[i]; i++) {
										position.active = false;
									}
								}
							}
						}
					}
				}
			} else {
				var positions = this.getTextInfo(layer, text, font, angle).positions;
				for (var i = 0, position; position = positions[i]; i++) {
					if (position.x == x && position.y == y) {
						position.active = false;
					}
				}
			}
		};
	
		///////////////////////////////////////////////////////////////////////////
		// The top-level container for the entire plot.
	
	    function Plot(placeholder, data_, options_, plugins) {
	        // data is on the form:
	        //   [ series1, series2 ... ]
	        // where series is either just the data as [ [x1, y1], [x2, y2], ... ]
	        // or { data: [ [x1, y1], [x2, y2], ... ], label: "some label", ... }
	
	        var series = [],
	            options = {
	                // the color theme used for graphs
	                colors: ["#edc240", "#afd8f8", "#cb4b4b", "#4da74d", "#9440ed"],
	                legend: {
	                    show: true,
	                    noColumns: 1, // number of colums in legend table
	                    labelFormatter: null, // fn: string -> string
	                    labelBoxBorderColor: "#ccc", // border color for the little label boxes
	                    container: null, // container (as jQuery object) to put legend in, null means default on top of graph
	                    position: "ne", // position of default legend container within plot
	                    margin: 5, // distance from grid edge to default legend container within plot
	                    backgroundColor: null, // null means auto-detect
	                    backgroundOpacity: 0.85, // set to 0 to avoid background
	                    sorted: null    // default to no legend sorting
	                },
	                xaxis: {
	                    show: null, // null = auto-detect, true = always, false = never
	                    position: "bottom", // or "top"
	                    mode: null, // null or "time"
	                    font: null, // null (derived from CSS in placeholder) or object like { size: 11, lineHeight: 13, style: "italic", weight: "bold", family: "sans-serif", variant: "small-caps" }
	                    color: null, // base color, labels, ticks
	                    tickColor: null, // possibly different color of ticks, e.g. "rgba(0,0,0,0.15)"
	                    transform: null, // null or f: number -> number to transform axis
	                    inverseTransform: null, // if transform is set, this should be the inverse function
	                    min: null, // min. value to show, null means set automatically
	                    max: null, // max. value to show, null means set automatically
	                    autoscaleMargin: null, // margin in % to add if auto-setting min/max
	                    ticks: null, // either [1, 3] or [[1, "a"], 3] or (fn: axis info -> ticks) or app. number of ticks for auto-ticks
	                    tickFormatter: null, // fn: number -> string
	                    labelWidth: null, // size of tick labels in pixels
	                    labelHeight: null,
	                    reserveSpace: null, // whether to reserve space even if axis isn't shown
	                    tickLength: null, // size in pixels of ticks, or "full" for whole line
	                    alignTicksWithAxis: null, // axis number or null for no sync
	                    tickDecimals: null, // no. of decimals, null means auto
	                    tickSize: null, // number or [number, "unit"]
	                    minTickSize: null // number or [number, "unit"]
	                },
	                yaxis: {
	                    autoscaleMargin: 0.02,
	                    position: "left" // or "right"
	                },
	                xaxes: [],
	                yaxes: [],
	                series: {
	                    points: {
	                        show: false,
	                        radius: 3,
	                        lineWidth: 2, // in pixels
	                        fill: true,
	                        fillColor: "#ffffff",
	                        symbol: "circle" // or callback
	                    },
	                    lines: {
	                        // we don't put in show: false so we can see
	                        // whether lines were actively disabled
	                        lineWidth: 2, // in pixels
	                        fill: false,
	                        fillColor: null,
	                        steps: false
	                        // Omit 'zero', so we can later default its value to
	                        // match that of the 'fill' option.
	                    },
	                    bars: {
	                        show: false,
	                        lineWidth: 2, // in pixels
	                        barWidth: 1, // in units of the x axis
	                        fill: true,
	                        fillColor: null,
	                        align: "left", // "left", "right", or "center"
	                        horizontal: false,
	                        zero: true
	                    },
	                    shadowSize: 3,
	                    highlightColor: null
	                },
	                grid: {
	                    show: true,
	                    aboveData: false,
	                    color: "#545454", // primary color used for outline and labels
	                    backgroundColor: null, // null for transparent, else color
	                    borderColor: null, // set if different from the grid color
	                    tickColor: null, // color for the ticks, e.g. "rgba(0,0,0,0.15)"
	                    margin: 0, // distance from the canvas edge to the grid
	                    labelMargin: 5, // in pixels
	                    axisMargin: 8, // in pixels
	                    borderWidth: 2, // in pixels
	                    minBorderMargin: null, // in pixels, null means taken from points radius
	                    markings: null, // array of ranges or fn: axes -> array of ranges
	                    markingsColor: "#f4f4f4",
	                    markingsLineWidth: 2,
	                    // interactive stuff
	                    clickable: false,
	                    hoverable: false,
	                    autoHighlight: true, // highlight in case mouse is near
	                    mouseActiveRadius: 10 // how far the mouse can be away to activate an item
	                },
	                interaction: {
	                    redrawOverlayInterval: 1000/60 // time between updates, -1 means in same flow
	                },
	                hooks: {}
	            },
	        surface = null,     // the canvas for the plot itself
	        overlay = null,     // canvas for interactive stuff on top of plot
	        eventHolder = null, // jQuery object that events should be bound to
	        ctx = null, octx = null,
	        xaxes = [], yaxes = [],
	        plotOffset = { left: 0, right: 0, top: 0, bottom: 0},
	        plotWidth = 0, plotHeight = 0,
	        hooks = {
	            processOptions: [],
	            processRawData: [],
	            processDatapoints: [],
	            processOffset: [],
	            drawBackground: [],
	            drawSeries: [],
	            draw: [],
	            bindEvents: [],
	            drawOverlay: [],
	            shutdown: []
	        },
	        plot = this;
	
	        // public functions
	        plot.setData = setData;
	        plot.setupGrid = setupGrid;
	        plot.draw = draw;
	        plot.getPlaceholder = function() { return placeholder; };
	        plot.getCanvas = function() { return surface.element; };
	        plot.getPlotOffset = function() { return plotOffset; };
	        plot.width = function () { return plotWidth; };
	        plot.height = function () { return plotHeight; };
	        plot.offset = function () {
	            var o = eventHolder.offset();
	            o.left += plotOffset.left;
	            o.top += plotOffset.top;
	            return o;
	        };
	        plot.getData = function () { return series; };
	        plot.getAxes = function () {
	            var res = {}, i;
	            $.each(xaxes.concat(yaxes), function (_, axis) {
	                if (axis)
	                    res[axis.direction + (axis.n != 1 ? axis.n : "") + "axis"] = axis;
	            });
	            return res;
	        };
	        plot.getXAxes = function () { return xaxes; };
	        plot.getYAxes = function () { return yaxes; };
	        plot.c2p = canvasToAxisCoords;
	        plot.p2c = axisToCanvasCoords;
	        plot.getOptions = function () { return options; };
	        plot.highlight = highlight;
	        plot.unhighlight = unhighlight;
	        plot.triggerRedrawOverlay = triggerRedrawOverlay;
	        plot.pointOffset = function(point) {
	            return {
	                left: parseInt(xaxes[axisNumber(point, "x") - 1].p2c(+point.x) + plotOffset.left, 10),
	                top: parseInt(yaxes[axisNumber(point, "y") - 1].p2c(+point.y) + plotOffset.top, 10)
	            };
	        };
	        plot.shutdown = shutdown;
	        plot.destroy = function () {
	            shutdown();
	            placeholder.removeData("plot").empty();
	
	            series = [];
	            options = null;
	            surface = null;
	            overlay = null;
	            eventHolder = null;
	            ctx = null;
	            octx = null;
	            xaxes = [];
	            yaxes = [];
	            hooks = null;
	            highlights = [];
	            plot = null;
	        };
	        plot.resize = function () {
	        	var width = placeholder.width(),
	        		height = placeholder.height();
	            surface.resize(width, height);
	            overlay.resize(width, height);
	        };
	
	        // public attributes
	        plot.hooks = hooks;
	
	        // initialize
	        initPlugins(plot);
	        parseOptions(options_);
	        setupCanvases();
	        setData(data_);
	        setupGrid();
	        draw();
	        bindEvents();
	
	
	        function executeHooks(hook, args) {
	            args = [plot].concat(args);
	            for (var i = 0; i < hook.length; ++i)
	                hook[i].apply(this, args);
	        }
	
	        function initPlugins() {
	
	            // References to key classes, allowing plugins to modify them
	
	            var classes = {
	                Canvas: Canvas
	            };
	
	            for (var i = 0; i < plugins.length; ++i) {
	                var p = plugins[i];
	                p.init(plot, classes);
	                if (p.options)
	                    $.extend(true, options, p.options);
	            }
	        }
	
	        function parseOptions(opts) {
	
	            $.extend(true, options, opts);
	
	            // $.extend merges arrays, rather than replacing them.  When less
	            // colors are provided than the size of the default palette, we
	            // end up with those colors plus the remaining defaults, which is
	            // not expected behavior; avoid it by replacing them here.
	
	            if (opts && opts.colors) {
	            	options.colors = opts.colors;
	            }
	
	            if (options.xaxis.color == null)
	                options.xaxis.color = $.color.parse(options.grid.color).scale('a', 0.22).toString();
	            if (options.yaxis.color == null)
	                options.yaxis.color = $.color.parse(options.grid.color).scale('a', 0.22).toString();
	
	            if (options.xaxis.tickColor == null) // grid.tickColor for back-compatibility
	                options.xaxis.tickColor = options.grid.tickColor || options.xaxis.color;
	            if (options.yaxis.tickColor == null) // grid.tickColor for back-compatibility
	                options.yaxis.tickColor = options.grid.tickColor || options.yaxis.color;
	
	            if (options.grid.borderColor == null)
	                options.grid.borderColor = options.grid.color;
	            if (options.grid.tickColor == null)
	                options.grid.tickColor = $.color.parse(options.grid.color).scale('a', 0.22).toString();
	
	            // Fill in defaults for axis options, including any unspecified
	            // font-spec fields, if a font-spec was provided.
	
	            // If no x/y axis options were provided, create one of each anyway,
	            // since the rest of the code assumes that they exist.
	
	            var i, axisOptions, axisCount,
	                fontSize = placeholder.css("font-size"),
	                fontSizeDefault = fontSize ? +fontSize.replace("px", "") : 13,
	                fontDefaults = {
	                    style: placeholder.css("font-style"),
	                    size: Math.round(0.8 * fontSizeDefault),
	                    variant: placeholder.css("font-variant"),
	                    weight: placeholder.css("font-weight"),
	                    family: placeholder.css("font-family")
	                };
	
	            axisCount = options.xaxes.length || 1;
	            for (i = 0; i < axisCount; ++i) {
	
	                axisOptions = options.xaxes[i];
	                if (axisOptions && !axisOptions.tickColor) {
	                    axisOptions.tickColor = axisOptions.color;
	                }
	
	                axisOptions = $.extend(true, {}, options.xaxis, axisOptions);
	                options.xaxes[i] = axisOptions;
	
	                if (axisOptions.font) {
	                    axisOptions.font = $.extend({}, fontDefaults, axisOptions.font);
	                    if (!axisOptions.font.color) {
	                        axisOptions.font.color = axisOptions.color;
	                    }
	                    if (!axisOptions.font.lineHeight) {
	                        axisOptions.font.lineHeight = Math.round(axisOptions.font.size * 1.15);
	                    }
	                }
	            }
	
	            axisCount = options.yaxes.length || 1;
	            for (i = 0; i < axisCount; ++i) {
	
	                axisOptions = options.yaxes[i];
	                if (axisOptions && !axisOptions.tickColor) {
	                    axisOptions.tickColor = axisOptions.color;
	                }
	
	                axisOptions = $.extend(true, {}, options.yaxis, axisOptions);
	                options.yaxes[i] = axisOptions;
	
	                if (axisOptions.font) {
	                    axisOptions.font = $.extend({}, fontDefaults, axisOptions.font);
	                    if (!axisOptions.font.color) {
	                        axisOptions.font.color = axisOptions.color;
	                    }
	                    if (!axisOptions.font.lineHeight) {
	                        axisOptions.font.lineHeight = Math.round(axisOptions.font.size * 1.15);
	                    }
	                }
	            }
	
	            // backwards compatibility, to be removed in future
	            if (options.xaxis.noTicks && options.xaxis.ticks == null)
	                options.xaxis.ticks = options.xaxis.noTicks;
	            if (options.yaxis.noTicks && options.yaxis.ticks == null)
	                options.yaxis.ticks = options.yaxis.noTicks;
	            if (options.x2axis) {
	                options.xaxes[1] = $.extend(true, {}, options.xaxis, options.x2axis);
	                options.xaxes[1].position = "top";
	                // Override the inherit to allow the axis to auto-scale
	                if (options.x2axis.min == null) {
	                    options.xaxes[1].min = null;
	                }
	                if (options.x2axis.max == null) {
	                    options.xaxes[1].max = null;
	                }
	            }
	            if (options.y2axis) {
	                options.yaxes[1] = $.extend(true, {}, options.yaxis, options.y2axis);
	                options.yaxes[1].position = "right";
	                // Override the inherit to allow the axis to auto-scale
	                if (options.y2axis.min == null) {
	                    options.yaxes[1].min = null;
	                }
	                if (options.y2axis.max == null) {
	                    options.yaxes[1].max = null;
	                }
	            }
	            if (options.grid.coloredAreas)
	                options.grid.markings = options.grid.coloredAreas;
	            if (options.grid.coloredAreasColor)
	                options.grid.markingsColor = options.grid.coloredAreasColor;
	            if (options.lines)
	                $.extend(true, options.series.lines, options.lines);
	            if (options.points)
	                $.extend(true, options.series.points, options.points);
	            if (options.bars)
	                $.extend(true, options.series.bars, options.bars);
	            if (options.shadowSize != null)
	                options.series.shadowSize = options.shadowSize;
	            if (options.highlightColor != null)
	                options.series.highlightColor = options.highlightColor;
	
	            // save options on axes for future reference
	            for (i = 0; i < options.xaxes.length; ++i)
	                getOrCreateAxis(xaxes, i + 1).options = options.xaxes[i];
	            for (i = 0; i < options.yaxes.length; ++i)
	                getOrCreateAxis(yaxes, i + 1).options = options.yaxes[i];
	
	            // add hooks from options
	            for (var n in hooks)
	                if (options.hooks[n] && options.hooks[n].length)
	                    hooks[n] = hooks[n].concat(options.hooks[n]);
	
	            executeHooks(hooks.processOptions, [options]);
	        }
	
	        function setData(d) {
	            series = parseData(d);
	            fillInSeriesOptions();
	            processData();
	        }
	
	        function parseData(d) {
	            var res = [];
	            for (var i = 0; i < d.length; ++i) {
	                var s = $.extend(true, {}, options.series);
	
	                if (d[i].data != null) {
	                    s.data = d[i].data; // move the data instead of deep-copy
	                    delete d[i].data;
	
	                    $.extend(true, s, d[i]);
	
	                    d[i].data = s.data;
	                }
	                else
	                    s.data = d[i];
	                res.push(s);
	            }
	
	            return res;
	        }
	
	        function axisNumber(obj, coord) {
	            var a = obj[coord + "axis"];
	            if (typeof a == "object") // if we got a real axis, extract number
	                a = a.n;
	            if (typeof a != "number")
	                a = 1; // default to first axis
	            return a;
	        }
	
	        function allAxes() {
	            // return flat array without annoying null entries
	            return $.grep(xaxes.concat(yaxes), function (a) { return a; });
	        }
	
	        function canvasToAxisCoords(pos) {
	            // return an object with x/y corresponding to all used axes
	            var res = {}, i, axis;
	            for (i = 0; i < xaxes.length; ++i) {
	                axis = xaxes[i];
	                if (axis && axis.used)
	                    res["x" + axis.n] = axis.c2p(pos.left);
	            }
	
	            for (i = 0; i < yaxes.length; ++i) {
	                axis = yaxes[i];
	                if (axis && axis.used)
	                    res["y" + axis.n] = axis.c2p(pos.top);
	            }
	
	            if (res.x1 !== undefined)
	                res.x = res.x1;
	            if (res.y1 !== undefined)
	                res.y = res.y1;
	
	            return res;
	        }
	
	        function axisToCanvasCoords(pos) {
	            // get canvas coords from the first pair of x/y found in pos
	            var res = {}, i, axis, key;
	
	            for (i = 0; i < xaxes.length; ++i) {
	                axis = xaxes[i];
	                if (axis && axis.used) {
	                    key = "x" + axis.n;
	                    if (pos[key] == null && axis.n == 1)
	                        key = "x";
	
	                    if (pos[key] != null) {
	                        res.left = axis.p2c(pos[key]);
	                        break;
	                    }
	                }
	            }
	
	            for (i = 0; i < yaxes.length; ++i) {
	                axis = yaxes[i];
	                if (axis && axis.used) {
	                    key = "y" + axis.n;
	                    if (pos[key] == null && axis.n == 1)
	                        key = "y";
	
	                    if (pos[key] != null) {
	                        res.top = axis.p2c(pos[key]);
	                        break;
	                    }
	                }
	            }
	
	            return res;
	        }
	
	        function getOrCreateAxis(axes, number) {
	            if (!axes[number - 1])
	                axes[number - 1] = {
	                    n: number, // save the number for future reference
	                    direction: axes == xaxes ? "x" : "y",
	                    options: $.extend(true, {}, axes == xaxes ? options.xaxis : options.yaxis)
	                };
	
	            return axes[number - 1];
	        }
	
	        function fillInSeriesOptions() {
	
	            var neededColors = series.length, maxIndex = -1, i;
	
	            // Subtract the number of series that already have fixed colors or
	            // color indexes from the number that we still need to generate.
	
	            for (i = 0; i < series.length; ++i) {
	                var sc = series[i].color;
	                if (sc != null) {
	                    neededColors--;
	                    if (typeof sc == "number" && sc > maxIndex) {
	                        maxIndex = sc;
	                    }
	                }
	            }
	
	            // If any of the series have fixed color indexes, then we need to
	            // generate at least as many colors as the highest index.
	
	            if (neededColors <= maxIndex) {
	                neededColors = maxIndex + 1;
	            }
	
	            // Generate all the colors, using first the option colors and then
	            // variations on those colors once they're exhausted.
	
	            var c, colors = [], colorPool = options.colors,
	                colorPoolSize = colorPool.length, variation = 0;
	
	            for (i = 0; i < neededColors; i++) {
	
	                c = $.color.parse(colorPool[i % colorPoolSize] || "#666");
	
	                // Each time we exhaust the colors in the pool we adjust
	                // a scaling factor used to produce more variations on
	                // those colors. The factor alternates negative/positive
	                // to produce lighter/darker colors.
	
	                // Reset the variation after every few cycles, or else
	                // it will end up producing only white or black colors.
	
	                if (i % colorPoolSize == 0 && i) {
	                    if (variation >= 0) {
	                        if (variation < 0.5) {
	                            variation = -variation - 0.2;
	                        } else variation = 0;
	                    } else variation = -variation;
	                }
	
	                colors[i] = c.scale('rgb', 1 + variation);
	            }
	
	            // Finalize the series options, filling in their colors
	
	            var colori = 0, s;
	            for (i = 0; i < series.length; ++i) {
	                s = series[i];
	
	                // assign colors
	                if (s.color == null) {
	                    s.color = colors[colori].toString();
	                    ++colori;
	                }
	                else if (typeof s.color == "number")
	                    s.color = colors[s.color].toString();
	
	                // turn on lines automatically in case nothing is set
	                if (s.lines.show == null) {
	                    var v, show = true;
	                    for (v in s)
	                        if (s[v] && s[v].show) {
	                            show = false;
	                            break;
	                        }
	                    if (show)
	                        s.lines.show = true;
	                }
	
	                // If nothing was provided for lines.zero, default it to match
	                // lines.fill, since areas by default should extend to zero.
	
	                if (s.lines.zero == null) {
	                    s.lines.zero = !!s.lines.fill;
	                }
	
	                // setup axes
	                s.xaxis = getOrCreateAxis(xaxes, axisNumber(s, "x"));
	                s.yaxis = getOrCreateAxis(yaxes, axisNumber(s, "y"));
	            }
	        }
	
	        function processData() {
	            var topSentry = Number.POSITIVE_INFINITY,
	                bottomSentry = Number.NEGATIVE_INFINITY,
	                fakeInfinity = Number.MAX_VALUE,
	                i, j, k, m, length,
	                s, points, ps, x, y, axis, val, f, p,
	                data, format;
	
	            function updateAxis(axis, min, max) {
	                if (min < axis.datamin && min != -fakeInfinity)
	                    axis.datamin = min;
	                if (max > axis.datamax && max != fakeInfinity)
	                    axis.datamax = max;
	            }
	
	            $.each(allAxes(), function (_, axis) {
	                // init axis
	                axis.datamin = topSentry;
	                axis.datamax = bottomSentry;
	                axis.used = false;
	            });
	
	            for (i = 0; i < series.length; ++i) {
	                s = series[i];
	                s.datapoints = { points: [] };
	
	                executeHooks(hooks.processRawData, [ s, s.data, s.datapoints ]);
	            }
	
	            // first pass: clean and copy data
	            for (i = 0; i < series.length; ++i) {
	                s = series[i];
	
	                data = s.data;
	                format = s.datapoints.format;
	
	                if (!format) {
	                    format = [];
	                    // find out how to copy
	                    format.push({ x: true, number: true, required: true });
	                    format.push({ y: true, number: true, required: true });
	
	                    if (s.bars.show || (s.lines.show && s.lines.fill)) {
	                        var autoscale = !!((s.bars.show && s.bars.zero) || (s.lines.show && s.lines.zero));
	                        format.push({ y: true, number: true, required: false, defaultValue: 0, autoscale: autoscale });
	                        if (s.bars.horizontal) {
	                            delete format[format.length - 1].y;
	                            format[format.length - 1].x = true;
	                        }
	                    }
	
	                    s.datapoints.format = format;
	                }
	
	                if (s.datapoints.pointsize != null)
	                    continue; // already filled in
	
	                s.datapoints.pointsize = format.length;
	
	                ps = s.datapoints.pointsize;
	                points = s.datapoints.points;
	
	                var insertSteps = s.lines.show && s.lines.steps;
	                s.xaxis.used = s.yaxis.used = true;
	
	                for (j = k = 0; j < data.length; ++j, k += ps) {
	                    p = data[j];
	
	                    var nullify = p == null;
	                    if (!nullify) {
	                        for (m = 0; m < ps; ++m) {
	                            val = p[m];
	                            f = format[m];
	
	                            if (f) {
	                                if (f.number && val != null) {
	                                    val = +val; // convert to number
	                                    if (isNaN(val))
	                                        val = null;
	                                    else if (val == Infinity)
	                                        val = fakeInfinity;
	                                    else if (val == -Infinity)
	                                        val = -fakeInfinity;
	                                }
	
	                                if (val == null) {
	                                    if (f.required)
	                                        nullify = true;
	
	                                    if (f.defaultValue != null)
	                                        val = f.defaultValue;
	                                }
	                            }
	
	                            points[k + m] = val;
	                        }
	                    }
	
	                    if (nullify) {
	                        for (m = 0; m < ps; ++m) {
	                            val = points[k + m];
	                            if (val != null) {
	                                f = format[m];
	                                // extract min/max info
	                                if (f.autoscale !== false) {
	                                    if (f.x) {
	                                        updateAxis(s.xaxis, val, val);
	                                    }
	                                    if (f.y) {
	                                        updateAxis(s.yaxis, val, val);
	                                    }
	                                }
	                            }
	                            points[k + m] = null;
	                        }
	                    }
	                    else {
	                        // a little bit of line specific stuff that
	                        // perhaps shouldn't be here, but lacking
	                        // better means...
	                        if (insertSteps && k > 0
	                            && points[k - ps] != null
	                            && points[k - ps] != points[k]
	                            && points[k - ps + 1] != points[k + 1]) {
	                            // copy the point to make room for a middle point
	                            for (m = 0; m < ps; ++m)
	                                points[k + ps + m] = points[k + m];
	
	                            // middle point has same y
	                            points[k + 1] = points[k - ps + 1];
	
	                            // we've added a point, better reflect that
	                            k += ps;
	                        }
	                    }
	                }
	            }
	
	            // give the hooks a chance to run
	            for (i = 0; i < series.length; ++i) {
	                s = series[i];
	
	                executeHooks(hooks.processDatapoints, [ s, s.datapoints]);
	            }
	
	            // second pass: find datamax/datamin for auto-scaling
	            for (i = 0; i < series.length; ++i) {
	                s = series[i];
	                points = s.datapoints.points;
	                ps = s.datapoints.pointsize;
	                format = s.datapoints.format;
	
	                var xmin = topSentry, ymin = topSentry,
	                    xmax = bottomSentry, ymax = bottomSentry;
	
	                for (j = 0; j < points.length; j += ps) {
	                    if (points[j] == null)
	                        continue;
	
	                    for (m = 0; m < ps; ++m) {
	                        val = points[j + m];
	                        f = format[m];
	                        if (!f || f.autoscale === false || val == fakeInfinity || val == -fakeInfinity)
	                            continue;
	
	                        if (f.x) {
	                            if (val < xmin)
	                                xmin = val;
	                            if (val > xmax)
	                                xmax = val;
	                        }
	                        if (f.y) {
	                            if (val < ymin)
	                                ymin = val;
	                            if (val > ymax)
	                                ymax = val;
	                        }
	                    }
	                }
	
	                if (s.bars.show) {
	                    // make sure we got room for the bar on the dancing floor
	                    var delta;
	
	                    switch (s.bars.align) {
	                        case "left":
	                            delta = 0;
	                            break;
	                        case "right":
	                            delta = -s.bars.barWidth;
	                            break;
	                        default:
	                            delta = -s.bars.barWidth / 2;
	                    }
	
	                    if (s.bars.horizontal) {
	                        ymin += delta;
	                        ymax += delta + s.bars.barWidth;
	                    }
	                    else {
	                        xmin += delta;
	                        xmax += delta + s.bars.barWidth;
	                    }
	                }
	
	                updateAxis(s.xaxis, xmin, xmax);
	                updateAxis(s.yaxis, ymin, ymax);
	            }
	
	            $.each(allAxes(), function (_, axis) {
	                if (axis.datamin == topSentry)
	                    axis.datamin = null;
	                if (axis.datamax == bottomSentry)
	                    axis.datamax = null;
	            });
	        }
	
	        function setupCanvases() {
	
	            // Make sure the placeholder is clear of everything except canvases
	            // from a previous plot in this container that we'll try to re-use.
	
	            placeholder.css("padding", 0) // padding messes up the positioning
	                .children().filter(function(){
	                    return !$(this).hasClass("flot-overlay") && !$(this).hasClass('flot-base');
	                }).remove();
	
	            if (placeholder.css("position") == 'static')
	                placeholder.css("position", "relative"); // for positioning labels and overlay
	
	            surface = new Canvas("flot-base", placeholder);
	            overlay = new Canvas("flot-overlay", placeholder); // overlay canvas for interactive features
	
	            ctx = surface.context;
	            octx = overlay.context;
	
	            // define which element we're listening for events on
	            eventHolder = $(overlay.element).unbind();
	
	            // If we're re-using a plot object, shut down the old one
	
	            var existing = placeholder.data("plot");
	
	            if (existing) {
	                existing.shutdown();
	                overlay.clear();
	            }
	
	            // save in case we get replotted
	            placeholder.data("plot", plot);
	        }
	
	        function bindEvents() {
	            // bind events
	            if (options.grid.hoverable) {
	                eventHolder.mousemove(onMouseMove);
	
	                // Use bind, rather than .mouseleave, because we officially
	                // still support jQuery 1.2.6, which doesn't define a shortcut
	                // for mouseenter or mouseleave.  This was a bug/oversight that
	                // was fixed somewhere around 1.3.x.  We can return to using
	                // .mouseleave when we drop support for 1.2.6.
	
	                eventHolder.bind("mouseleave", onMouseLeave);
	            }
	
	            if (options.grid.clickable)
	                eventHolder.click(onClick);
	
	            executeHooks(hooks.bindEvents, [eventHolder]);
	        }
	
	        function shutdown() {
	            if (redrawTimeout)
	                clearTimeout(redrawTimeout);
	
	            eventHolder.unbind("mousemove", onMouseMove);
	            eventHolder.unbind("mouseleave", onMouseLeave);
	            eventHolder.unbind("click", onClick);
	
	            executeHooks(hooks.shutdown, [eventHolder]);
	        }
	
	        function setTransformationHelpers(axis) {
	            // set helper functions on the axis, assumes plot area
	            // has been computed already
	
	            function identity(x) { return x; }
	
	            var s, m, t = axis.options.transform || identity,
	                it = axis.options.inverseTransform;
	
	            // precompute how much the axis is scaling a point
	            // in canvas space
	            if (axis.direction == "x") {
	                s = axis.scale = plotWidth / Math.abs(t(axis.max) - t(axis.min));
	                m = Math.min(t(axis.max), t(axis.min));
	            }
	            else {
	                s = axis.scale = plotHeight / Math.abs(t(axis.max) - t(axis.min));
	                s = -s;
	                m = Math.max(t(axis.max), t(axis.min));
	            }
	
	            // data point to canvas coordinate
	            if (t == identity) // slight optimization
	                axis.p2c = function (p) { return (p - m) * s; };
	            else
	                axis.p2c = function (p) { return (t(p) - m) * s; };
	            // canvas coordinate to data point
	            if (!it)
	                axis.c2p = function (c) { return m + c / s; };
	            else
	                axis.c2p = function (c) { return it(m + c / s); };
	        }
	
	        function measureTickLabels(axis) {
	
	            var opts = axis.options,
	                ticks = axis.ticks || [],
	                labelWidth = opts.labelWidth || 0,
	                labelHeight = opts.labelHeight || 0,
	                maxWidth = labelWidth || (axis.direction == "x" ? Math.floor(surface.width / (ticks.length || 1)) : null),
	                legacyStyles = axis.direction + "Axis " + axis.direction + axis.n + "Axis",
	                layer = "flot-" + axis.direction + "-axis flot-" + axis.direction + axis.n + "-axis " + legacyStyles,
	                font = opts.font || "flot-tick-label tickLabel";
	
	            for (var i = 0; i < ticks.length; ++i) {
	
	                var t = ticks[i];
	
	                if (!t.label)
	                    continue;
	
	                var info = surface.getTextInfo(layer, t.label, font, null, maxWidth);
	
	                labelWidth = Math.max(labelWidth, info.width);
	                labelHeight = Math.max(labelHeight, info.height);
	            }
	
	            axis.labelWidth = opts.labelWidth || labelWidth;
	            axis.labelHeight = opts.labelHeight || labelHeight;
	        }
	
	        function allocateAxisBoxFirstPhase(axis) {
	            // find the bounding box of the axis by looking at label
	            // widths/heights and ticks, make room by diminishing the
	            // plotOffset; this first phase only looks at one
	            // dimension per axis, the other dimension depends on the
	            // other axes so will have to wait
	
	            var lw = axis.labelWidth,
	                lh = axis.labelHeight,
	                pos = axis.options.position,
	                isXAxis = axis.direction === "x",
	                tickLength = axis.options.tickLength,
	                axisMargin = options.grid.axisMargin,
	                padding = options.grid.labelMargin,
	                innermost = true,
	                outermost = true,
	                first = true,
	                found = false;
	
	            // Determine the axis's position in its direction and on its side
	
	            $.each(isXAxis ? xaxes : yaxes, function(i, a) {
	                if (a && (a.show || a.reserveSpace)) {
	                    if (a === axis) {
	                        found = true;
	                    } else if (a.options.position === pos) {
	                        if (found) {
	                            outermost = false;
	                        } else {
	                            innermost = false;
	                        }
	                    }
	                    if (!found) {
	                        first = false;
	                    }
	                }
	            });
	
	            // The outermost axis on each side has no margin
	
	            if (outermost) {
	                axisMargin = 0;
	            }
	
	            // The ticks for the first axis in each direction stretch across
	
	            if (tickLength == null) {
	                tickLength = first ? "full" : 5;
	            }
	
	            if (!isNaN(+tickLength))
	                padding += +tickLength;
	
	            if (isXAxis) {
	                lh += padding;
	
	                if (pos == "bottom") {
	                    plotOffset.bottom += lh + axisMargin;
	                    axis.box = { top: surface.height - plotOffset.bottom, height: lh };
	                }
	                else {
	                    axis.box = { top: plotOffset.top + axisMargin, height: lh };
	                    plotOffset.top += lh + axisMargin;
	                }
	            }
	            else {
	                lw += padding;
	
	                if (pos == "left") {
	                    axis.box = { left: plotOffset.left + axisMargin, width: lw };
	                    plotOffset.left += lw + axisMargin;
	                }
	                else {
	                    plotOffset.right += lw + axisMargin;
	                    axis.box = { left: surface.width - plotOffset.right, width: lw };
	                }
	            }
	
	             // save for future reference
	            axis.position = pos;
	            axis.tickLength = tickLength;
	            axis.box.padding = padding;
	            axis.innermost = innermost;
	        }
	
	        function allocateAxisBoxSecondPhase(axis) {
	            // now that all axis boxes have been placed in one
	            // dimension, we can set the remaining dimension coordinates
	            if (axis.direction == "x") {
	                axis.box.left = plotOffset.left - axis.labelWidth / 2;
	                axis.box.width = surface.width - plotOffset.left - plotOffset.right + axis.labelWidth;
	            }
	            else {
	                axis.box.top = plotOffset.top - axis.labelHeight / 2;
	                axis.box.height = surface.height - plotOffset.bottom - plotOffset.top + axis.labelHeight;
	            }
	        }
	
	        function adjustLayoutForThingsStickingOut() {
	            // possibly adjust plot offset to ensure everything stays
	            // inside the canvas and isn't clipped off
	
	            var minMargin = options.grid.minBorderMargin,
	                axis, i;
	
	            // check stuff from the plot (FIXME: this should just read
	            // a value from the series, otherwise it's impossible to
	            // customize)
	            if (minMargin == null) {
	                minMargin = 0;
	                for (i = 0; i < series.length; ++i)
	                    minMargin = Math.max(minMargin, 2 * (series[i].points.radius + series[i].points.lineWidth/2));
	            }
	
	            var margins = {
	                left: minMargin,
	                right: minMargin,
	                top: minMargin,
	                bottom: minMargin
	            };
	
	            // check axis labels, note we don't check the actual
	            // labels but instead use the overall width/height to not
	            // jump as much around with replots
	            $.each(allAxes(), function (_, axis) {
	                if (axis.reserveSpace && axis.ticks && axis.ticks.length) {
	                    if (axis.direction === "x") {
	                        margins.left = Math.max(margins.left, axis.labelWidth / 2);
	                        margins.right = Math.max(margins.right, axis.labelWidth / 2);
	                    } else {
	                        margins.bottom = Math.max(margins.bottom, axis.labelHeight / 2);
	                        margins.top = Math.max(margins.top, axis.labelHeight / 2);
	                    }
	                }
	            });
	
	            plotOffset.left = Math.ceil(Math.max(margins.left, plotOffset.left));
	            plotOffset.right = Math.ceil(Math.max(margins.right, plotOffset.right));
	            plotOffset.top = Math.ceil(Math.max(margins.top, plotOffset.top));
	            plotOffset.bottom = Math.ceil(Math.max(margins.bottom, plotOffset.bottom));
	        }
	
	        function setupGrid() {
	            var i, axes = allAxes(), showGrid = options.grid.show;
	
	            // Initialize the plot's offset from the edge of the canvas
	
	            for (var a in plotOffset) {
	                var margin = options.grid.margin || 0;
	                plotOffset[a] = typeof margin == "number" ? margin : margin[a] || 0;
	            }
	
	            executeHooks(hooks.processOffset, [plotOffset]);
	
	            // If the grid is visible, add its border width to the offset
	
	            for (var a in plotOffset) {
	                if(typeof(options.grid.borderWidth) == "object") {
	                    plotOffset[a] += showGrid ? options.grid.borderWidth[a] : 0;
	                }
	                else {
	                    plotOffset[a] += showGrid ? options.grid.borderWidth : 0;
	                }
	            }
	
	            $.each(axes, function (_, axis) {
	                var axisOpts = axis.options;
	                axis.show = axisOpts.show == null ? axis.used : axisOpts.show;
	                axis.reserveSpace = axisOpts.reserveSpace == null ? axis.show : axisOpts.reserveSpace;
	                setRange(axis);
	            });
	
	            if (showGrid) {
	
	                var allocatedAxes = $.grep(axes, function (axis) {
	                    return axis.show || axis.reserveSpace;
	                });
	
	                $.each(allocatedAxes, function (_, axis) {
	                    // make the ticks
	                    setupTickGeneration(axis);
	                    setTicks(axis);
	                    snapRangeToTicks(axis, axis.ticks);
	                    // find labelWidth/Height for axis
	                    measureTickLabels(axis);
	                });
	
	                // with all dimensions calculated, we can compute the
	                // axis bounding boxes, start from the outside
	                // (reverse order)
	                for (i = allocatedAxes.length - 1; i >= 0; --i)
	                    allocateAxisBoxFirstPhase(allocatedAxes[i]);
	
	                // make sure we've got enough space for things that
	                // might stick out
	                adjustLayoutForThingsStickingOut();
	
	                $.each(allocatedAxes, function (_, axis) {
	                    allocateAxisBoxSecondPhase(axis);
	                });
	            }
	
	            plotWidth = surface.width - plotOffset.left - plotOffset.right;
	            plotHeight = surface.height - plotOffset.bottom - plotOffset.top;
	
	            // now we got the proper plot dimensions, we can compute the scaling
	            $.each(axes, function (_, axis) {
	                setTransformationHelpers(axis);
	            });
	
	            if (showGrid) {
	                drawAxisLabels();
	            }
	
	            insertLegend();
	        }
	
	        function setRange(axis) {
	            var opts = axis.options,
	                min = +(opts.min != null ? opts.min : axis.datamin),
	                max = +(opts.max != null ? opts.max : axis.datamax),
	                delta = max - min;
	
	            if (delta == 0.0) {
	                // degenerate case
	                var widen = max == 0 ? 1 : 0.01;
	
	                if (opts.min == null)
	                    min -= widen;
	                // always widen max if we couldn't widen min to ensure we
	                // don't fall into min == max which doesn't work
	                if (opts.max == null || opts.min != null)
	                    max += widen;
	            }
	            else {
	                // consider autoscaling
	                var margin = opts.autoscaleMargin;
	                if (margin != null) {
	                    if (opts.min == null) {
	                        min -= delta * margin;
	                        // make sure we don't go below zero if all values
	                        // are positive
	                        if (min < 0 && axis.datamin != null && axis.datamin >= 0)
	                            min = 0;
	                    }
	                    if (opts.max == null) {
	                        max += delta * margin;
	                        if (max > 0 && axis.datamax != null && axis.datamax <= 0)
	                            max = 0;
	                    }
	                }
	            }
	            axis.min = min;
	            axis.max = max;
	        }
	
	        function setupTickGeneration(axis) {
	            var opts = axis.options;
	
	            // estimate number of ticks
	            var noTicks;
	            if (typeof opts.ticks == "number" && opts.ticks > 0)
	                noTicks = opts.ticks;
	            else
	                // heuristic based on the model a*sqrt(x) fitted to
	                // some data points that seemed reasonable
	                noTicks = 0.3 * Math.sqrt(axis.direction == "x" ? surface.width : surface.height);
	
	            var delta = (axis.max - axis.min) / noTicks,
	                dec = -Math.floor(Math.log(delta) / Math.LN10),
	                maxDec = opts.tickDecimals;
	
	            if (maxDec != null && dec > maxDec) {
	                dec = maxDec;
	            }
	
	            var magn = Math.pow(10, -dec),
	                norm = delta / magn, // norm is between 1.0 and 10.0
	                size;
	
	            if (norm < 1.5) {
	                size = 1;
	            } else if (norm < 3) {
	                size = 2;
	                // special case for 2.5, requires an extra decimal
	                if (norm > 2.25 && (maxDec == null || dec + 1 <= maxDec)) {
	                    size = 2.5;
	                    ++dec;
	                }
	            } else if (norm < 7.5) {
	                size = 5;
	            } else {
	                size = 10;
	            }
	
	            size *= magn;
	
	            if (opts.minTickSize != null && size < opts.minTickSize) {
	                size = opts.minTickSize;
	            }
	
	            axis.delta = delta;
	            axis.tickDecimals = Math.max(0, maxDec != null ? maxDec : dec);
	            axis.tickSize = opts.tickSize || size;
	
	            // Time mode was moved to a plug-in in 0.8, and since so many people use it
	            // we'll add an especially friendly reminder to make sure they included it.
	
	            if (opts.mode == "time" && !axis.tickGenerator) {
	                throw new Error("Time mode requires the flot.time plugin.");
	            }
	
	            // Flot supports base-10 axes; any other mode else is handled by a plug-in,
	            // like flot.time.js.
	
	            if (!axis.tickGenerator) {
	
	                axis.tickGenerator = function (axis) {
	
	                    var ticks = [],
	                        start = floorInBase(axis.min, axis.tickSize),
	                        i = 0,
	                        v = Number.NaN,
	                        prev;
	
	                    do {
	                        prev = v;
	                        v = start + i * axis.tickSize;
	                        ticks.push(v);
	                        ++i;
	                    } while (v < axis.max && v != prev);
	                    return ticks;
	                };
	
					axis.tickFormatter = function (value, axis) {
	
						var factor = axis.tickDecimals ? Math.pow(10, axis.tickDecimals) : 1;
						var formatted = "" + Math.round(value * factor) / factor;
	
						// If tickDecimals was specified, ensure that we have exactly that
						// much precision; otherwise default to the value's own precision.
	
						if (axis.tickDecimals != null) {
							var decimal = formatted.indexOf(".");
							var precision = decimal == -1 ? 0 : formatted.length - decimal - 1;
							if (precision < axis.tickDecimals) {
								return (precision ? formatted : formatted + ".") + ("" + factor).substr(1, axis.tickDecimals - precision);
							}
						}
	
	                    return formatted;
	                };
	            }
	
	            if ($.isFunction(opts.tickFormatter))
	                axis.tickFormatter = function (v, axis) { return "" + opts.tickFormatter(v, axis); };
	
	            if (opts.alignTicksWithAxis != null) {
	                var otherAxis = (axis.direction == "x" ? xaxes : yaxes)[opts.alignTicksWithAxis - 1];
	                if (otherAxis && otherAxis.used && otherAxis != axis) {
	                    // consider snapping min/max to outermost nice ticks
	                    var niceTicks = axis.tickGenerator(axis);
	                    if (niceTicks.length > 0) {
	                        if (opts.min == null)
	                            axis.min = Math.min(axis.min, niceTicks[0]);
	                        if (opts.max == null && niceTicks.length > 1)
	                            axis.max = Math.max(axis.max, niceTicks[niceTicks.length - 1]);
	                    }
	
	                    axis.tickGenerator = function (axis) {
	                        // copy ticks, scaled to this axis
	                        var ticks = [], v, i;
	                        for (i = 0; i < otherAxis.ticks.length; ++i) {
	                            v = (otherAxis.ticks[i].v - otherAxis.min) / (otherAxis.max - otherAxis.min);
	                            v = axis.min + v * (axis.max - axis.min);
	                            ticks.push(v);
	                        }
	                        return ticks;
	                    };
	
	                    // we might need an extra decimal since forced
	                    // ticks don't necessarily fit naturally
	                    if (!axis.mode && opts.tickDecimals == null) {
	                        var extraDec = Math.max(0, -Math.floor(Math.log(axis.delta) / Math.LN10) + 1),
	                            ts = axis.tickGenerator(axis);
	
	                        // only proceed if the tick interval rounded
	                        // with an extra decimal doesn't give us a
	                        // zero at end
	                        if (!(ts.length > 1 && /\..*0$/.test((ts[1] - ts[0]).toFixed(extraDec))))
	                            axis.tickDecimals = extraDec;
	                    }
	                }
	            }
	        }
	
	        function setTicks(axis) {
	            var oticks = axis.options.ticks, ticks = [];
	            if (oticks == null || (typeof oticks == "number" && oticks > 0))
	                ticks = axis.tickGenerator(axis);
	            else if (oticks) {
	                if ($.isFunction(oticks))
	                    // generate the ticks
	                    ticks = oticks(axis);
	                else
	                    ticks = oticks;
	            }
	
	            // clean up/labelify the supplied ticks, copy them over
	            var i, v;
	            axis.ticks = [];
	            for (i = 0; i < ticks.length; ++i) {
	                var label = null;
	                var t = ticks[i];
	                if (typeof t == "object") {
	                    v = +t[0];
	                    if (t.length > 1)
	                        label = t[1];
	                }
	                else
	                    v = +t;
	                if (label == null)
	                    label = axis.tickFormatter(v, axis);
	                if (!isNaN(v))
	                    axis.ticks.push({ v: v, label: label });
	            }
	        }
	
	        function snapRangeToTicks(axis, ticks) {
	            if (axis.options.autoscaleMargin && ticks.length > 0) {
	                // snap to ticks
	                if (axis.options.min == null)
	                    axis.min = Math.min(axis.min, ticks[0].v);
	                if (axis.options.max == null && ticks.length > 1)
	                    axis.max = Math.max(axis.max, ticks[ticks.length - 1].v);
	            }
	        }
	
	        function draw() {
	
	            surface.clear();
	
	            executeHooks(hooks.drawBackground, [ctx]);
	
	            var grid = options.grid;
	
	            // draw background, if any
	            if (grid.show && grid.backgroundColor)
	                drawBackground();
	
	            if (grid.show && !grid.aboveData) {
	                drawGrid();
	            }
	
	            for (var i = 0; i < series.length; ++i) {
	                executeHooks(hooks.drawSeries, [ctx, series[i]]);
	                drawSeries(series[i]);
	            }
	
	            executeHooks(hooks.draw, [ctx]);
	
	            if (grid.show && grid.aboveData) {
	                drawGrid();
	            }
	
	            surface.render();
	
	            // A draw implies that either the axes or data have changed, so we
	            // should probably update the overlay highlights as well.
	
	            triggerRedrawOverlay();
	        }
	
	        function extractRange(ranges, coord) {
	            var axis, from, to, key, axes = allAxes();
	
	            for (var i = 0; i < axes.length; ++i) {
	                axis = axes[i];
	                if (axis.direction == coord) {
	                    key = coord + axis.n + "axis";
	                    if (!ranges[key] && axis.n == 1)
	                        key = coord + "axis"; // support x1axis as xaxis
	                    if (ranges[key]) {
	                        from = ranges[key].from;
	                        to = ranges[key].to;
	                        break;
	                    }
	                }
	            }
	
	            // backwards-compat stuff - to be removed in future
	            if (!ranges[key]) {
	                axis = coord == "x" ? xaxes[0] : yaxes[0];
	                from = ranges[coord + "1"];
	                to = ranges[coord + "2"];
	            }
	
	            // auto-reverse as an added bonus
	            if (from != null && to != null && from > to) {
	                var tmp = from;
	                from = to;
	                to = tmp;
	            }
	
	            return { from: from, to: to, axis: axis };
	        }
	
	        function drawBackground() {
	            ctx.save();
	            ctx.translate(plotOffset.left, plotOffset.top);
	
	            ctx.fillStyle = getColorOrGradient(options.grid.backgroundColor, plotHeight, 0, "rgba(255, 255, 255, 0)");
	            ctx.fillRect(0, 0, plotWidth, plotHeight);
	            ctx.restore();
	        }
	
	        function drawGrid() {
	            var i, axes, bw, bc;
	
	            ctx.save();
	            ctx.translate(plotOffset.left, plotOffset.top);
	
	            // draw markings
	            var markings = options.grid.markings;
	            if (markings) {
	                if ($.isFunction(markings)) {
	                    axes = plot.getAxes();
	                    // xmin etc. is backwards compatibility, to be
	                    // removed in the future
	                    axes.xmin = axes.xaxis.min;
	                    axes.xmax = axes.xaxis.max;
	                    axes.ymin = axes.yaxis.min;
	                    axes.ymax = axes.yaxis.max;
	
	                    markings = markings(axes);
	                }
	
	                for (i = 0; i < markings.length; ++i) {
	                    var m = markings[i],
	                        xrange = extractRange(m, "x"),
	                        yrange = extractRange(m, "y");
	
	                    // fill in missing
	                    if (xrange.from == null)
	                        xrange.from = xrange.axis.min;
	                    if (xrange.to == null)
	                        xrange.to = xrange.axis.max;
	                    if (yrange.from == null)
	                        yrange.from = yrange.axis.min;
	                    if (yrange.to == null)
	                        yrange.to = yrange.axis.max;
	
	                    // clip
	                    if (xrange.to < xrange.axis.min || xrange.from > xrange.axis.max ||
	                        yrange.to < yrange.axis.min || yrange.from > yrange.axis.max)
	                        continue;
	
	                    xrange.from = Math.max(xrange.from, xrange.axis.min);
	                    xrange.to = Math.min(xrange.to, xrange.axis.max);
	                    yrange.from = Math.max(yrange.from, yrange.axis.min);
	                    yrange.to = Math.min(yrange.to, yrange.axis.max);
	
	                    var xequal = xrange.from === xrange.to,
	                        yequal = yrange.from === yrange.to;
	
	                    if (xequal && yequal) {
	                        continue;
	                    }
	
	                    // then draw
	                    xrange.from = Math.floor(xrange.axis.p2c(xrange.from));
	                    xrange.to = Math.floor(xrange.axis.p2c(xrange.to));
	                    yrange.from = Math.floor(yrange.axis.p2c(yrange.from));
	                    yrange.to = Math.floor(yrange.axis.p2c(yrange.to));
	
	                    if (xequal || yequal) {
	                        var lineWidth = m.lineWidth || options.grid.markingsLineWidth,
	                            subPixel = lineWidth % 2 ? 0.5 : 0;
	                        ctx.beginPath();
	                        ctx.strokeStyle = m.color || options.grid.markingsColor;
	                        ctx.lineWidth = lineWidth;
	                        if (xequal) {
	                            ctx.moveTo(xrange.to + subPixel, yrange.from);
	                            ctx.lineTo(xrange.to + subPixel, yrange.to);
	                        } else {
	                            ctx.moveTo(xrange.from, yrange.to + subPixel);
	                            ctx.lineTo(xrange.to, yrange.to + subPixel);                            
	                        }
	                        ctx.stroke();
	                    } else {
	                        ctx.fillStyle = m.color || options.grid.markingsColor;
	                        ctx.fillRect(xrange.from, yrange.to,
	                                     xrange.to - xrange.from,
	                                     yrange.from - yrange.to);
	                    }
	                }
	            }
	
	            // draw the ticks
	            axes = allAxes();
	            bw = options.grid.borderWidth;
	
	            for (var j = 0; j < axes.length; ++j) {
	                var axis = axes[j], box = axis.box,
	                    t = axis.tickLength, x, y, xoff, yoff;
	                if (!axis.show || axis.ticks.length == 0)
	                    continue;
	
	                ctx.lineWidth = 1;
	
	                // find the edges
	                if (axis.direction == "x") {
	                    x = 0;
	                    if (t == "full")
	                        y = (axis.position == "top" ? 0 : plotHeight);
	                    else
	                        y = box.top - plotOffset.top + (axis.position == "top" ? box.height : 0);
	                }
	                else {
	                    y = 0;
	                    if (t == "full")
	                        x = (axis.position == "left" ? 0 : plotWidth);
	                    else
	                        x = box.left - plotOffset.left + (axis.position == "left" ? box.width : 0);
	                }
	
	                // draw tick bar
	                if (!axis.innermost) {
	                    ctx.strokeStyle = axis.options.color;
	                    ctx.beginPath();
	                    xoff = yoff = 0;
	                    if (axis.direction == "x")
	                        xoff = plotWidth + 1;
	                    else
	                        yoff = plotHeight + 1;
	
	                    if (ctx.lineWidth == 1) {
	                        if (axis.direction == "x") {
	                            y = Math.floor(y) + 0.5;
	                        } else {
	                            x = Math.floor(x) + 0.5;
	                        }
	                    }
	
	                    ctx.moveTo(x, y);
	                    ctx.lineTo(x + xoff, y + yoff);
	                    ctx.stroke();
	                }
	
	                // draw ticks
	
	                ctx.strokeStyle = axis.options.tickColor;
	
	                ctx.beginPath();
	                for (i = 0; i < axis.ticks.length; ++i) {
	                    var v = axis.ticks[i].v;
	
	                    xoff = yoff = 0;
	
	                    if (isNaN(v) || v < axis.min || v > axis.max
	                        // skip those lying on the axes if we got a border
	                        || (t == "full"
	                            && ((typeof bw == "object" && bw[axis.position] > 0) || bw > 0)
	                            && (v == axis.min || v == axis.max)))
	                        continue;
	
	                    if (axis.direction == "x") {
	                        x = axis.p2c(v);
	                        yoff = t == "full" ? -plotHeight : t;
	
	                        if (axis.position == "top")
	                            yoff = -yoff;
	                    }
	                    else {
	                        y = axis.p2c(v);
	                        xoff = t == "full" ? -plotWidth : t;
	
	                        if (axis.position == "left")
	                            xoff = -xoff;
	                    }
	
	                    if (ctx.lineWidth == 1) {
	                        if (axis.direction == "x")
	                            x = Math.floor(x) + 0.5;
	                        else
	                            y = Math.floor(y) + 0.5;
	                    }
	
	                    ctx.moveTo(x, y);
	                    ctx.lineTo(x + xoff, y + yoff);
	                }
	
	                ctx.stroke();
	            }
	
	
	            // draw border
	            if (bw) {
	                // If either borderWidth or borderColor is an object, then draw the border
	                // line by line instead of as one rectangle
	                bc = options.grid.borderColor;
	                if(typeof bw == "object" || typeof bc == "object") {
	                    if (typeof bw !== "object") {
	                        bw = {top: bw, right: bw, bottom: bw, left: bw};
	                    }
	                    if (typeof bc !== "object") {
	                        bc = {top: bc, right: bc, bottom: bc, left: bc};
	                    }
	
	                    if (bw.top > 0) {
	                        ctx.strokeStyle = bc.top;
	                        ctx.lineWidth = bw.top;
	                        ctx.beginPath();
	                        ctx.moveTo(0 - bw.left, 0 - bw.top/2);
	                        ctx.lineTo(plotWidth, 0 - bw.top/2);
	                        ctx.stroke();
	                    }
	
	                    if (bw.right > 0) {
	                        ctx.strokeStyle = bc.right;
	                        ctx.lineWidth = bw.right;
	                        ctx.beginPath();
	                        ctx.moveTo(plotWidth + bw.right / 2, 0 - bw.top);
	                        ctx.lineTo(plotWidth + bw.right / 2, plotHeight);
	                        ctx.stroke();
	                    }
	
	                    if (bw.bottom > 0) {
	                        ctx.strokeStyle = bc.bottom;
	                        ctx.lineWidth = bw.bottom;
	                        ctx.beginPath();
	                        ctx.moveTo(plotWidth + bw.right, plotHeight + bw.bottom / 2);
	                        ctx.lineTo(0, plotHeight + bw.bottom / 2);
	                        ctx.stroke();
	                    }
	
	                    if (bw.left > 0) {
	                        ctx.strokeStyle = bc.left;
	                        ctx.lineWidth = bw.left;
	                        ctx.beginPath();
	                        ctx.moveTo(0 - bw.left/2, plotHeight + bw.bottom);
	                        ctx.lineTo(0- bw.left/2, 0);
	                        ctx.stroke();
	                    }
	                }
	                else {
	                    ctx.lineWidth = bw;
	                    ctx.strokeStyle = options.grid.borderColor;
	                    ctx.strokeRect(-bw/2, -bw/2, plotWidth + bw, plotHeight + bw);
	                }
	            }
	
	            ctx.restore();
	        }
	
	        function drawAxisLabels() {
	
	            $.each(allAxes(), function (_, axis) {
	                var box = axis.box,
	                    legacyStyles = axis.direction + "Axis " + axis.direction + axis.n + "Axis",
	                    layer = "flot-" + axis.direction + "-axis flot-" + axis.direction + axis.n + "-axis " + legacyStyles,
	                    font = axis.options.font || "flot-tick-label tickLabel",
	                    tick, x, y, halign, valign;
	
	                // Remove text before checking for axis.show and ticks.length;
	                // otherwise plugins, like flot-tickrotor, that draw their own
	                // tick labels will end up with both theirs and the defaults.
	
	                surface.removeText(layer);
	
	                if (!axis.show || axis.ticks.length == 0)
	                    return;
	
	                for (var i = 0; i < axis.ticks.length; ++i) {
	
	                    tick = axis.ticks[i];
	                    if (!tick.label || tick.v < axis.min || tick.v > axis.max)
	                        continue;
	
	                    if (axis.direction == "x") {
	                        halign = "center";
	                        x = plotOffset.left + axis.p2c(tick.v);
	                        if (axis.position == "bottom") {
	                            y = box.top + box.padding;
	                        } else {
	                            y = box.top + box.height - box.padding;
	                            valign = "bottom";
	                        }
	                    } else {
	                        valign = "middle";
	                        y = plotOffset.top + axis.p2c(tick.v);
	                        if (axis.position == "left") {
	                            x = box.left + box.width - box.padding;
	                            halign = "right";
	                        } else {
	                            x = box.left + box.padding;
	                        }
	                    }
	
	                    surface.addText(layer, x, y, tick.label, font, null, null, halign, valign);
	                }
	            });
	        }
	
	        function drawSeries(series) {
	            if (series.lines.show)
	                drawSeriesLines(series);
	            if (series.bars.show)
	                drawSeriesBars(series);
	            if (series.points.show)
	                drawSeriesPoints(series);
	        }
	
	        function drawSeriesLines(series) {
	            function plotLine(datapoints, xoffset, yoffset, axisx, axisy) {
	                var points = datapoints.points,
	                    ps = datapoints.pointsize,
	                    prevx = null, prevy = null;
	
	                ctx.beginPath();
	                for (var i = ps; i < points.length; i += ps) {
	                    var x1 = points[i - ps], y1 = points[i - ps + 1],
	                        x2 = points[i], y2 = points[i + 1];
	
	                    if (x1 == null || x2 == null)
	                        continue;
	
	                    // clip with ymin
	                    if (y1 <= y2 && y1 < axisy.min) {
	                        if (y2 < axisy.min)
	                            continue;   // line segment is outside
	                        // compute new intersection point
	                        x1 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y1 = axisy.min;
	                    }
	                    else if (y2 <= y1 && y2 < axisy.min) {
	                        if (y1 < axisy.min)
	                            continue;
	                        x2 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y2 = axisy.min;
	                    }
	
	                    // clip with ymax
	                    if (y1 >= y2 && y1 > axisy.max) {
	                        if (y2 > axisy.max)
	                            continue;
	                        x1 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y1 = axisy.max;
	                    }
	                    else if (y2 >= y1 && y2 > axisy.max) {
	                        if (y1 > axisy.max)
	                            continue;
	                        x2 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y2 = axisy.max;
	                    }
	
	                    // clip with xmin
	                    if (x1 <= x2 && x1 < axisx.min) {
	                        if (x2 < axisx.min)
	                            continue;
	                        y1 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x1 = axisx.min;
	                    }
	                    else if (x2 <= x1 && x2 < axisx.min) {
	                        if (x1 < axisx.min)
	                            continue;
	                        y2 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x2 = axisx.min;
	                    }
	
	                    // clip with xmax
	                    if (x1 >= x2 && x1 > axisx.max) {
	                        if (x2 > axisx.max)
	                            continue;
	                        y1 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x1 = axisx.max;
	                    }
	                    else if (x2 >= x1 && x2 > axisx.max) {
	                        if (x1 > axisx.max)
	                            continue;
	                        y2 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x2 = axisx.max;
	                    }
	
	                    if (x1 != prevx || y1 != prevy)
	                        ctx.moveTo(axisx.p2c(x1) + xoffset, axisy.p2c(y1) + yoffset);
	
	                    prevx = x2;
	                    prevy = y2;
	                    ctx.lineTo(axisx.p2c(x2) + xoffset, axisy.p2c(y2) + yoffset);
	                }
	                ctx.stroke();
	            }
	
	            function plotLineArea(datapoints, axisx, axisy) {
	                var points = datapoints.points,
	                    ps = datapoints.pointsize,
	                    bottom = Math.min(Math.max(0, axisy.min), axisy.max),
	                    i = 0, top, areaOpen = false,
	                    ypos = 1, segmentStart = 0, segmentEnd = 0;
	
	                // we process each segment in two turns, first forward
	                // direction to sketch out top, then once we hit the
	                // end we go backwards to sketch the bottom
	                while (true) {
	                    if (ps > 0 && i > points.length + ps)
	                        break;
	
	                    i += ps; // ps is negative if going backwards
	
	                    var x1 = points[i - ps],
	                        y1 = points[i - ps + ypos],
	                        x2 = points[i], y2 = points[i + ypos];
	
	                    if (areaOpen) {
	                        if (ps > 0 && x1 != null && x2 == null) {
	                            // at turning point
	                            segmentEnd = i;
	                            ps = -ps;
	                            ypos = 2;
	                            continue;
	                        }
	
	                        if (ps < 0 && i == segmentStart + ps) {
	                            // done with the reverse sweep
	                            ctx.fill();
	                            areaOpen = false;
	                            ps = -ps;
	                            ypos = 1;
	                            i = segmentStart = segmentEnd + ps;
	                            continue;
	                        }
	                    }
	
	                    if (x1 == null || x2 == null)
	                        continue;
	
	                    // clip x values
	
	                    // clip with xmin
	                    if (x1 <= x2 && x1 < axisx.min) {
	                        if (x2 < axisx.min)
	                            continue;
	                        y1 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x1 = axisx.min;
	                    }
	                    else if (x2 <= x1 && x2 < axisx.min) {
	                        if (x1 < axisx.min)
	                            continue;
	                        y2 = (axisx.min - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x2 = axisx.min;
	                    }
	
	                    // clip with xmax
	                    if (x1 >= x2 && x1 > axisx.max) {
	                        if (x2 > axisx.max)
	                            continue;
	                        y1 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x1 = axisx.max;
	                    }
	                    else if (x2 >= x1 && x2 > axisx.max) {
	                        if (x1 > axisx.max)
	                            continue;
	                        y2 = (axisx.max - x1) / (x2 - x1) * (y2 - y1) + y1;
	                        x2 = axisx.max;
	                    }
	
	                    if (!areaOpen) {
	                        // open area
	                        ctx.beginPath();
	                        ctx.moveTo(axisx.p2c(x1), axisy.p2c(bottom));
	                        areaOpen = true;
	                    }
	
	                    // now first check the case where both is outside
	                    if (y1 >= axisy.max && y2 >= axisy.max) {
	                        ctx.lineTo(axisx.p2c(x1), axisy.p2c(axisy.max));
	                        ctx.lineTo(axisx.p2c(x2), axisy.p2c(axisy.max));
	                        continue;
	                    }
	                    else if (y1 <= axisy.min && y2 <= axisy.min) {
	                        ctx.lineTo(axisx.p2c(x1), axisy.p2c(axisy.min));
	                        ctx.lineTo(axisx.p2c(x2), axisy.p2c(axisy.min));
	                        continue;
	                    }
	
	                    // else it's a bit more complicated, there might
	                    // be a flat maxed out rectangle first, then a
	                    // triangular cutout or reverse; to find these
	                    // keep track of the current x values
	                    var x1old = x1, x2old = x2;
	
	                    // clip the y values, without shortcutting, we
	                    // go through all cases in turn
	
	                    // clip with ymin
	                    if (y1 <= y2 && y1 < axisy.min && y2 >= axisy.min) {
	                        x1 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y1 = axisy.min;
	                    }
	                    else if (y2 <= y1 && y2 < axisy.min && y1 >= axisy.min) {
	                        x2 = (axisy.min - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y2 = axisy.min;
	                    }
	
	                    // clip with ymax
	                    if (y1 >= y2 && y1 > axisy.max && y2 <= axisy.max) {
	                        x1 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y1 = axisy.max;
	                    }
	                    else if (y2 >= y1 && y2 > axisy.max && y1 <= axisy.max) {
	                        x2 = (axisy.max - y1) / (y2 - y1) * (x2 - x1) + x1;
	                        y2 = axisy.max;
	                    }
	
	                    // if the x value was changed we got a rectangle
	                    // to fill
	                    if (x1 != x1old) {
	                        ctx.lineTo(axisx.p2c(x1old), axisy.p2c(y1));
	                        // it goes to (x1, y1), but we fill that below
	                    }
	
	                    // fill triangular section, this sometimes result
	                    // in redundant points if (x1, y1) hasn't changed
	                    // from previous line to, but we just ignore that
	                    ctx.lineTo(axisx.p2c(x1), axisy.p2c(y1));
	                    ctx.lineTo(axisx.p2c(x2), axisy.p2c(y2));
	
	                    // fill the other rectangle if it's there
	                    if (x2 != x2old) {
	                        ctx.lineTo(axisx.p2c(x2), axisy.p2c(y2));
	                        ctx.lineTo(axisx.p2c(x2old), axisy.p2c(y2));
	                    }
	                }
	            }
	
	            ctx.save();
	            ctx.translate(plotOffset.left, plotOffset.top);
	            ctx.lineJoin = "round";
	
	            var lw = series.lines.lineWidth,
	                sw = series.shadowSize;
	            // FIXME: consider another form of shadow when filling is turned on
	            if (lw > 0 && sw > 0) {
	                // draw shadow as a thick and thin line with transparency
	                ctx.lineWidth = sw;
	                ctx.strokeStyle = "rgba(0,0,0,0.1)";
	                // position shadow at angle from the mid of line
	                var angle = Math.PI/18;
	                plotLine(series.datapoints, Math.sin(angle) * (lw/2 + sw/2), Math.cos(angle) * (lw/2 + sw/2), series.xaxis, series.yaxis);
	                ctx.lineWidth = sw/2;
	                plotLine(series.datapoints, Math.sin(angle) * (lw/2 + sw/4), Math.cos(angle) * (lw/2 + sw/4), series.xaxis, series.yaxis);
	            }
	
	            ctx.lineWidth = lw;
	            ctx.strokeStyle = series.color;
	            var fillStyle = getFillStyle(series.lines, series.color, 0, plotHeight);
	            if (fillStyle) {
	                ctx.fillStyle = fillStyle;
	                plotLineArea(series.datapoints, series.xaxis, series.yaxis);
	            }
	
	            if (lw > 0)
	                plotLine(series.datapoints, 0, 0, series.xaxis, series.yaxis);
	            ctx.restore();
	        }
	
	        function drawSeriesPoints(series) {
	            function plotPoints(datapoints, radius, fillStyle, offset, shadow, axisx, axisy, symbol) {
	                var points = datapoints.points, ps = datapoints.pointsize;
	
	                for (var i = 0; i < points.length; i += ps) {
	                    var x = points[i], y = points[i + 1];
	                    if (x == null || x < axisx.min || x > axisx.max || y < axisy.min || y > axisy.max)
	                        continue;
	
	                    ctx.beginPath();
	                    x = axisx.p2c(x);
	                    y = axisy.p2c(y) + offset;
	                    if (symbol == "circle")
	                        ctx.arc(x, y, radius, 0, shadow ? Math.PI : Math.PI * 2, false);
	                    else
	                        symbol(ctx, x, y, radius, shadow);
	                    ctx.closePath();
	
	                    if (fillStyle) {
	                        ctx.fillStyle = fillStyle;
	                        ctx.fill();
	                    }
	                    ctx.stroke();
	                }
	            }
	
	            ctx.save();
	            ctx.translate(plotOffset.left, plotOffset.top);
	
	            var lw = series.points.lineWidth,
	                sw = series.shadowSize,
	                radius = series.points.radius,
	                symbol = series.points.symbol;
	
	            // If the user sets the line width to 0, we change it to a very 
	            // small value. A line width of 0 seems to force the default of 1.
	            // Doing the conditional here allows the shadow setting to still be 
	            // optional even with a lineWidth of 0.
	
	            if( lw == 0 )
	                lw = 0.0001;
	
	            if (lw > 0 && sw > 0) {
	                // draw shadow in two steps
	                var w = sw / 2;
	                ctx.lineWidth = w;
	                ctx.strokeStyle = "rgba(0,0,0,0.1)";
	                plotPoints(series.datapoints, radius, null, w + w/2, true,
	                           series.xaxis, series.yaxis, symbol);
	
	                ctx.strokeStyle = "rgba(0,0,0,0.2)";
	                plotPoints(series.datapoints, radius, null, w/2, true,
	                           series.xaxis, series.yaxis, symbol);
	            }
	
	            ctx.lineWidth = lw;
	            ctx.strokeStyle = series.color;
	            plotPoints(series.datapoints, radius,
	                       getFillStyle(series.points, series.color), 0, false,
	                       series.xaxis, series.yaxis, symbol);
	            ctx.restore();
	        }
	
	        function drawBar(x, y, b, barLeft, barRight, fillStyleCallback, axisx, axisy, c, horizontal, lineWidth) {
	            var left, right, bottom, top,
	                drawLeft, drawRight, drawTop, drawBottom,
	                tmp;
	
	            // in horizontal mode, we start the bar from the left
	            // instead of from the bottom so it appears to be
	            // horizontal rather than vertical
	            if (horizontal) {
	                drawBottom = drawRight = drawTop = true;
	                drawLeft = false;
	                left = b;
	                right = x;
	                top = y + barLeft;
	                bottom = y + barRight;
	
	                // account for negative bars
	                if (right < left) {
	                    tmp = right;
	                    right = left;
	                    left = tmp;
	                    drawLeft = true;
	                    drawRight = false;
	                }
	            }
	            else {
	                drawLeft = drawRight = drawTop = true;
	                drawBottom = false;
	                left = x + barLeft;
	                right = x + barRight;
	                bottom = b;
	                top = y;
	
	                // account for negative bars
	                if (top < bottom) {
	                    tmp = top;
	                    top = bottom;
	                    bottom = tmp;
	                    drawBottom = true;
	                    drawTop = false;
	                }
	            }
	
	            // clip
	            if (right < axisx.min || left > axisx.max ||
	                top < axisy.min || bottom > axisy.max)
	                return;
	
	            if (left < axisx.min) {
	                left = axisx.min;
	                drawLeft = false;
	            }
	
	            if (right > axisx.max) {
	                right = axisx.max;
	                drawRight = false;
	            }
	
	            if (bottom < axisy.min) {
	                bottom = axisy.min;
	                drawBottom = false;
	            }
	
	            if (top > axisy.max) {
	                top = axisy.max;
	                drawTop = false;
	            }
	
	            left = axisx.p2c(left);
	            bottom = axisy.p2c(bottom);
	            right = axisx.p2c(right);
	            top = axisy.p2c(top);
	
	            // fill the bar
	            if (fillStyleCallback) {
	                c.fillStyle = fillStyleCallback(bottom, top);
	                c.fillRect(left, top, right - left, bottom - top)
	            }
	
	            // draw outline
	            if (lineWidth > 0 && (drawLeft || drawRight || drawTop || drawBottom)) {
	                c.beginPath();
	
	                // FIXME: inline moveTo is buggy with excanvas
	                c.moveTo(left, bottom);
	                if (drawLeft)
	                    c.lineTo(left, top);
	                else
	                    c.moveTo(left, top);
	                if (drawTop)
	                    c.lineTo(right, top);
	                else
	                    c.moveTo(right, top);
	                if (drawRight)
	                    c.lineTo(right, bottom);
	                else
	                    c.moveTo(right, bottom);
	                if (drawBottom)
	                    c.lineTo(left, bottom);
	                else
	                    c.moveTo(left, bottom);
	                c.stroke();
	            }
	        }
	
	        function drawSeriesBars(series) {
	            function plotBars(datapoints, barLeft, barRight, fillStyleCallback, axisx, axisy) {
	                var points = datapoints.points, ps = datapoints.pointsize;
	
	                for (var i = 0; i < points.length; i += ps) {
	                    if (points[i] == null)
	                        continue;
	                    drawBar(points[i], points[i + 1], points[i + 2], barLeft, barRight, fillStyleCallback, axisx, axisy, ctx, series.bars.horizontal, series.bars.lineWidth);
	                }
	            }
	
	            ctx.save();
	            ctx.translate(plotOffset.left, plotOffset.top);
	
	            // FIXME: figure out a way to add shadows (for instance along the right edge)
	            ctx.lineWidth = series.bars.lineWidth;
	            ctx.strokeStyle = series.color;
	
	            var barLeft;
	
	            switch (series.bars.align) {
	                case "left":
	                    barLeft = 0;
	                    break;
	                case "right":
	                    barLeft = -series.bars.barWidth;
	                    break;
	                default:
	                    barLeft = -series.bars.barWidth / 2;
	            }
	
	            var fillStyleCallback = series.bars.fill ? function (bottom, top) { return getFillStyle(series.bars, series.color, bottom, top); } : null;
	            plotBars(series.datapoints, barLeft, barLeft + series.bars.barWidth, fillStyleCallback, series.xaxis, series.yaxis);
	            ctx.restore();
	        }
	
	        function getFillStyle(filloptions, seriesColor, bottom, top) {
	            var fill = filloptions.fill;
	            if (!fill)
	                return null;
	
	            if (filloptions.fillColor)
	                return getColorOrGradient(filloptions.fillColor, bottom, top, seriesColor);
	
	            var c = $.color.parse(seriesColor);
	            c.a = typeof fill == "number" ? fill : 0.4;
	            c.normalize();
	            return c.toString();
	        }
	
	        function insertLegend() {
	
	            if (options.legend.container != null) {
	                $(options.legend.container).html("");
	            } else {
	                placeholder.find(".legend").remove();
	            }
	
	            if (!options.legend.show) {
	                return;
	            }
	
	            var fragments = [], entries = [], rowStarted = false,
	                lf = options.legend.labelFormatter, s, label;
	
	            // Build a list of legend entries, with each having a label and a color
	
	            for (var i = 0; i < series.length; ++i) {
	                s = series[i];
	                if (s.label) {
	                    label = lf ? lf(s.label, s) : s.label;
	                    if (label) {
	                        entries.push({
	                            label: label,
	                            color: s.color
	                        });
	                    }
	                }
	            }
	
	            // Sort the legend using either the default or a custom comparator
	
	            if (options.legend.sorted) {
	                if ($.isFunction(options.legend.sorted)) {
	                    entries.sort(options.legend.sorted);
	                } else if (options.legend.sorted == "reverse") {
	                	entries.reverse();
	                } else {
	                    var ascending = options.legend.sorted != "descending";
	                    entries.sort(function(a, b) {
	                        return a.label == b.label ? 0 : (
	                            (a.label < b.label) != ascending ? 1 : -1   // Logical XOR
	                        );
	                    });
	                }
	            }
	
	            // Generate markup for the list of entries, in their final order
	
	            for (var i = 0; i < entries.length; ++i) {
	
	                var entry = entries[i];
	
	                if (i % options.legend.noColumns == 0) {
	                    if (rowStarted)
	                        fragments.push('</tr>');
	                    fragments.push('<tr>');
	                    rowStarted = true;
	                }
	
	                fragments.push(
	                    '<td class="legendColorBox"><div style="border:1px solid ' + options.legend.labelBoxBorderColor + ';padding:1px"><div style="width:4px;height:0;border:5px solid ' + entry.color + ';overflow:hidden"></div></div></td>' +
	                    '<td class="legendLabel">' + entry.label + '</td>'
	                );
	            }
	
	            if (rowStarted)
	                fragments.push('</tr>');
	
	            if (fragments.length == 0)
	                return;
	
	            var table = '<table style="font-size:smaller;color:' + options.grid.color + '">' + fragments.join("") + '</table>';
	            if (options.legend.container != null)
	                $(options.legend.container).html(table);
	            else {
	                var pos = "",
	                    p = options.legend.position,
	                    m = options.legend.margin;
	                if (m[0] == null)
	                    m = [m, m];
	                if (p.charAt(0) == "n")
	                    pos += 'top:' + (m[1] + plotOffset.top) + 'px;';
	                else if (p.charAt(0) == "s")
	                    pos += 'bottom:' + (m[1] + plotOffset.bottom) + 'px;';
	                if (p.charAt(1) == "e")
	                    pos += 'right:' + (m[0] + plotOffset.right) + 'px;';
	                else if (p.charAt(1) == "w")
	                    pos += 'left:' + (m[0] + plotOffset.left) + 'px;';
	                var legend = $('<div class="legend">' + table.replace('style="', 'style="position:absolute;' + pos +';') + '</div>').appendTo(placeholder);
	                if (options.legend.backgroundOpacity != 0.0) {
	                    // put in the transparent background
	                    // separately to avoid blended labels and
	                    // label boxes
	                    var c = options.legend.backgroundColor;
	                    if (c == null) {
	                        c = options.grid.backgroundColor;
	                        if (c && typeof c == "string")
	                            c = $.color.parse(c);
	                        else
	                            c = $.color.extract(legend, 'background-color');
	                        c.a = 1;
	                        c = c.toString();
	                    }
	                    var div = legend.children();
	                    $('<div style="position:absolute;width:' + div.width() + 'px;height:' + div.height() + 'px;' + pos +'background-color:' + c + ';"> </div>').prependTo(legend).css('opacity', options.legend.backgroundOpacity);
	                }
	            }
	        }
	
	
	        // interactive features
	
	        var highlights = [],
	            redrawTimeout = null;
	
	        // returns the data item the mouse is over, or null if none is found
	        function findNearbyItem(mouseX, mouseY, seriesFilter) {
	            var maxDistance = options.grid.mouseActiveRadius,
	                smallestDistance = maxDistance * maxDistance + 1,
	                item = null, foundPoint = false, i, j, ps;
	
	            for (i = series.length - 1; i >= 0; --i) {
	                if (!seriesFilter(series[i]))
	                    continue;
	
	                var s = series[i],
	                    axisx = s.xaxis,
	                    axisy = s.yaxis,
	                    points = s.datapoints.points,
	                    mx = axisx.c2p(mouseX), // precompute some stuff to make the loop faster
	                    my = axisy.c2p(mouseY),
	                    maxx = maxDistance / axisx.scale,
	                    maxy = maxDistance / axisy.scale;
	
	                ps = s.datapoints.pointsize;
	                // with inverse transforms, we can't use the maxx/maxy
	                // optimization, sadly
	                if (axisx.options.inverseTransform)
	                    maxx = Number.MAX_VALUE;
	                if (axisy.options.inverseTransform)
	                    maxy = Number.MAX_VALUE;
	
	                if (s.lines.show || s.points.show) {
	                    for (j = 0; j < points.length; j += ps) {
	                        var x = points[j], y = points[j + 1];
	                        if (x == null)
	                            continue;
	
	                        // For points and lines, the cursor must be within a
	                        // certain distance to the data point
	                        if (x - mx > maxx || x - mx < -maxx ||
	                            y - my > maxy || y - my < -maxy)
	                            continue;
	
	                        // We have to calculate distances in pixels, not in
	                        // data units, because the scales of the axes may be different
	                        var dx = Math.abs(axisx.p2c(x) - mouseX),
	                            dy = Math.abs(axisy.p2c(y) - mouseY),
	                            dist = dx * dx + dy * dy; // we save the sqrt
	
	                        // use <= to ensure last point takes precedence
	                        // (last generally means on top of)
	                        if (dist < smallestDistance) {
	                            smallestDistance = dist;
	                            item = [i, j / ps];
	                        }
	                    }
	                }
	
	                if (s.bars.show && !item) { // no other point can be nearby
	
	                    var barLeft, barRight;
	
	                    switch (s.bars.align) {
	                        case "left":
	                            barLeft = 0;
	                            break;
	                        case "right":
	                            barLeft = -s.bars.barWidth;
	                            break;
	                        default:
	                            barLeft = -s.bars.barWidth / 2;
	                    }
	
	                    barRight = barLeft + s.bars.barWidth;
	
	                    for (j = 0; j < points.length; j += ps) {
	                        var x = points[j], y = points[j + 1], b = points[j + 2];
	                        if (x == null)
	                            continue;
	
	                        // for a bar graph, the cursor must be inside the bar
	                        if (series[i].bars.horizontal ?
	                            (mx <= Math.max(b, x) && mx >= Math.min(b, x) &&
	                             my >= y + barLeft && my <= y + barRight) :
	                            (mx >= x + barLeft && mx <= x + barRight &&
	                             my >= Math.min(b, y) && my <= Math.max(b, y)))
	                                item = [i, j / ps];
	                    }
	                }
	            }
	
	            if (item) {
	                i = item[0];
	                j = item[1];
	                ps = series[i].datapoints.pointsize;
	
	                return { datapoint: series[i].datapoints.points.slice(j * ps, (j + 1) * ps),
	                         dataIndex: j,
	                         series: series[i],
	                         seriesIndex: i };
	            }
	
	            return null;
	        }
	
	        function onMouseMove(e) {
	            if (options.grid.hoverable)
	                triggerClickHoverEvent("plothover", e,
	                                       function (s) { return s["hoverable"] != false; });
	        }
	
	        function onMouseLeave(e) {
	            if (options.grid.hoverable)
	                triggerClickHoverEvent("plothover", e,
	                                       function (s) { return false; });
	        }
	
	        function onClick(e) {
	            triggerClickHoverEvent("plotclick", e,
	                                   function (s) { return s["clickable"] != false; });
	        }
	
	        // trigger click or hover event (they send the same parameters
	        // so we share their code)
	        function triggerClickHoverEvent(eventname, event, seriesFilter) {
	            var offset = eventHolder.offset(),
	                canvasX = event.pageX - offset.left - plotOffset.left,
	                canvasY = event.pageY - offset.top - plotOffset.top,
	            pos = canvasToAxisCoords({ left: canvasX, top: canvasY });
	
	            pos.pageX = event.pageX;
	            pos.pageY = event.pageY;
	
	            var item = findNearbyItem(canvasX, canvasY, seriesFilter);
	
	            if (item) {
	                // fill in mouse pos for any listeners out there
	                item.pageX = parseInt(item.series.xaxis.p2c(item.datapoint[0]) + offset.left + plotOffset.left, 10);
	                item.pageY = parseInt(item.series.yaxis.p2c(item.datapoint[1]) + offset.top + plotOffset.top, 10);
	            }
	
	            if (options.grid.autoHighlight) {
	                // clear auto-highlights
	                for (var i = 0; i < highlights.length; ++i) {
	                    var h = highlights[i];
	                    if (h.auto == eventname &&
	                        !(item && h.series == item.series &&
	                          h.point[0] == item.datapoint[0] &&
	                          h.point[1] == item.datapoint[1]))
	                        unhighlight(h.series, h.point);
	                }
	
	                if (item)
	                    highlight(item.series, item.datapoint, eventname);
	            }
	
	            placeholder.trigger(eventname, [ pos, item ]);
	        }
	
	        function triggerRedrawOverlay() {
	            var t = options.interaction.redrawOverlayInterval;
	            if (t == -1) {      // skip event queue
	                drawOverlay();
	                return;
	            }
	
	            if (!redrawTimeout)
	                redrawTimeout = setTimeout(drawOverlay, t);
	        }
	
	        function drawOverlay() {
	            redrawTimeout = null;
	
	            // draw highlights
	            octx.save();
	            overlay.clear();
	            octx.translate(plotOffset.left, plotOffset.top);
	
	            var i, hi;
	            for (i = 0; i < highlights.length; ++i) {
	                hi = highlights[i];
	
	                if (hi.series.bars.show)
	                    drawBarHighlight(hi.series, hi.point);
	                else
	                    drawPointHighlight(hi.series, hi.point);
	            }
	            octx.restore();
	
	            executeHooks(hooks.drawOverlay, [octx]);
	        }
	
	        function highlight(s, point, auto) {
	            if (typeof s == "number")
	                s = series[s];
	
	            if (typeof point == "number") {
	                var ps = s.datapoints.pointsize;
	                point = s.datapoints.points.slice(ps * point, ps * (point + 1));
	            }
	
	            var i = indexOfHighlight(s, point);
	            if (i == -1) {
	                highlights.push({ series: s, point: point, auto: auto });
	
	                triggerRedrawOverlay();
	            }
	            else if (!auto)
	                highlights[i].auto = false;
	        }
	
	        function unhighlight(s, point) {
	            if (s == null && point == null) {
	                highlights = [];
	                triggerRedrawOverlay();
	                return;
	            }
	
	            if (typeof s == "number")
	                s = series[s];
	
	            if (typeof point == "number") {
	                var ps = s.datapoints.pointsize;
	                point = s.datapoints.points.slice(ps * point, ps * (point + 1));
	            }
	
	            var i = indexOfHighlight(s, point);
	            if (i != -1) {
	                highlights.splice(i, 1);
	
	                triggerRedrawOverlay();
	            }
	        }
	
	        function indexOfHighlight(s, p) {
	            for (var i = 0; i < highlights.length; ++i) {
	                var h = highlights[i];
	                if (h.series == s && h.point[0] == p[0]
	                    && h.point[1] == p[1])
	                    return i;
	            }
	            return -1;
	        }
	
	        function drawPointHighlight(series, point) {
	            var x = point[0], y = point[1],
	                axisx = series.xaxis, axisy = series.yaxis,
	                highlightColor = (typeof series.highlightColor === "string") ? series.highlightColor : $.color.parse(series.color).scale('a', 0.5).toString();
	
	            if (x < axisx.min || x > axisx.max || y < axisy.min || y > axisy.max)
	                return;
	
	            var pointRadius = series.points.radius + series.points.lineWidth / 2;
	            octx.lineWidth = pointRadius;
	            octx.strokeStyle = highlightColor;
	            var radius = 1.5 * pointRadius;
	            x = axisx.p2c(x);
	            y = axisy.p2c(y);
	
	            octx.beginPath();
	            if (series.points.symbol == "circle")
	                octx.arc(x, y, radius, 0, 2 * Math.PI, false);
	            else
	                series.points.symbol(octx, x, y, radius, false);
	            octx.closePath();
	            octx.stroke();
	        }
	
	        function drawBarHighlight(series, point) {
	            var highlightColor = (typeof series.highlightColor === "string") ? series.highlightColor : $.color.parse(series.color).scale('a', 0.5).toString(),
	                fillStyle = highlightColor,
	                barLeft;
	
	            switch (series.bars.align) {
	                case "left":
	                    barLeft = 0;
	                    break;
	                case "right":
	                    barLeft = -series.bars.barWidth;
	                    break;
	                default:
	                    barLeft = -series.bars.barWidth / 2;
	            }
	
	            octx.lineWidth = series.bars.lineWidth;
	            octx.strokeStyle = highlightColor;
	
	            drawBar(point[0], point[1], point[2] || 0, barLeft, barLeft + series.bars.barWidth,
	                    function () { return fillStyle; }, series.xaxis, series.yaxis, octx, series.bars.horizontal, series.bars.lineWidth);
	        }
	
	        function getColorOrGradient(spec, bottom, top, defaultColor) {
	            if (typeof spec == "string")
	                return spec;
	            else {
	                // assume this is a gradient spec; IE currently only
	                // supports a simple vertical gradient properly, so that's
	                // what we support too
	                var gradient = ctx.createLinearGradient(0, top, 0, bottom);
	
	                for (var i = 0, l = spec.colors.length; i < l; ++i) {
	                    var c = spec.colors[i];
	                    if (typeof c != "string") {
	                        var co = $.color.parse(defaultColor);
	                        if (c.brightness != null)
	                            co = co.scale('rgb', c.brightness);
	                        if (c.opacity != null)
	                            co.a *= c.opacity;
	                        c = co.toString();
	                    }
	                    gradient.addColorStop(i / (l - 1), c);
	                }
	
	                return gradient;
	            }
	        }
	    }
	
	    // Add the plot function to the top level of the jQuery object
	
	    $.plot = function(placeholder, data, options) {
	        //var t0 = new Date();
	        var plot = new Plot($(placeholder), data, options, $.plot.plugins);
	        //(window.console ? console.log : alert)("time used (msecs): " + ((new Date()).getTime() - t0.getTime()));
	        return plot;
	    };
	
	    $.plot.version = "0.8.3";
	
	    $.plot.plugins = [];
	
	    // Also add the plot function as a chainable property
	
	    $.fn.plot = function(data, options) {
	        return this.each(function() {
	            $.plot(this, data, options);
	        });
	    };
	
	    // round to nearby lower multiple of base
	    function floorInBase(n, base) {
	        return base * Math.floor(n / base);
	    }
	
	})(jQuery);


/***/ }),
/* 486 */
/***/ (function(module, exports) {

	/* Flot plugin for rendering pie charts.
	
	Copyright (c) 2007-2014 IOLA and Ole Laursen.
	Licensed under the MIT license.
	
	The plugin assumes that each series has a single data value, and that each
	value is a positive integer or zero.  Negative numbers don't make sense for a
	pie chart, and have unpredictable results.  The values do NOT need to be
	passed in as percentages; the plugin will calculate the total and per-slice
	percentages internally.
	
	* Created by Brian Medendorp
	
	* Updated with contributions from btburnett3, Anthony Aragues and Xavi Ivars
	
	The plugin supports these options:
	
		series: {
			pie: {
				show: true/false
				radius: 0-1 for percentage of fullsize, or a specified pixel length, or 'auto'
				innerRadius: 0-1 for percentage of fullsize or a specified pixel length, for creating a donut effect
				startAngle: 0-2 factor of PI used for starting angle (in radians) i.e 3/2 starts at the top, 0 and 2 have the same result
				tilt: 0-1 for percentage to tilt the pie, where 1 is no tilt, and 0 is completely flat (nothing will show)
				offset: {
					top: integer value to move the pie up or down
					left: integer value to move the pie left or right, or 'auto'
				},
				stroke: {
					color: any hexidecimal color value (other formats may or may not work, so best to stick with something like '#FFF')
					width: integer pixel width of the stroke
				},
				label: {
					show: true/false, or 'auto'
					formatter:  a user-defined function that modifies the text/style of the label text
					radius: 0-1 for percentage of fullsize, or a specified pixel length
					background: {
						color: any hexidecimal color value (other formats may or may not work, so best to stick with something like '#000')
						opacity: 0-1
					},
					threshold: 0-1 for the percentage value at which to hide labels (if they're too small)
				},
				combine: {
					threshold: 0-1 for the percentage value at which to combine slices (if they're too small)
					color: any hexidecimal color value (other formats may or may not work, so best to stick with something like '#CCC'), if null, the plugin will automatically use the color of the first slice to be combined
					label: any text value of what the combined slice should be labeled
				}
				highlight: {
					opacity: 0-1
				}
			}
		}
	
	More detail and specific examples can be found in the included HTML file.
	
	*/
	
	(function($) {
	
		// Maximum redraw attempts when fitting labels within the plot
	
		var REDRAW_ATTEMPTS = 10;
	
		// Factor by which to shrink the pie when fitting labels within the plot
	
		var REDRAW_SHRINK = 0.95;
	
		function init(plot) {
	
			var canvas = null,
				target = null,
				options = null,
				maxRadius = null,
				centerLeft = null,
				centerTop = null,
				processed = false,
				ctx = null;
	
			// interactive variables
	
			var highlights = [];
	
			// add hook to determine if pie plugin in enabled, and then perform necessary operations
	
			plot.hooks.processOptions.push(function(plot, options) {
				if (options.series.pie.show) {
	
					options.grid.show = false;
	
					// set labels.show
	
					if (options.series.pie.label.show == "auto") {
						if (options.legend.show) {
							options.series.pie.label.show = false;
						} else {
							options.series.pie.label.show = true;
						}
					}
	
					// set radius
	
					if (options.series.pie.radius == "auto") {
						if (options.series.pie.label.show) {
							options.series.pie.radius = 3/4;
						} else {
							options.series.pie.radius = 1;
						}
					}
	
					// ensure sane tilt
	
					if (options.series.pie.tilt > 1) {
						options.series.pie.tilt = 1;
					} else if (options.series.pie.tilt < 0) {
						options.series.pie.tilt = 0;
					}
				}
			});
	
			plot.hooks.bindEvents.push(function(plot, eventHolder) {
				var options = plot.getOptions();
				if (options.series.pie.show) {
					if (options.grid.hoverable) {
						eventHolder.unbind("mousemove").mousemove(onMouseMove);
					}
					if (options.grid.clickable) {
						eventHolder.unbind("click").click(onClick);
					}
				}
			});
	
			plot.hooks.processDatapoints.push(function(plot, series, data, datapoints) {
				var options = plot.getOptions();
				if (options.series.pie.show) {
					processDatapoints(plot, series, data, datapoints);
				}
			});
	
			plot.hooks.drawOverlay.push(function(plot, octx) {
				var options = plot.getOptions();
				if (options.series.pie.show) {
					drawOverlay(plot, octx);
				}
			});
	
			plot.hooks.draw.push(function(plot, newCtx) {
				var options = plot.getOptions();
				if (options.series.pie.show) {
					draw(plot, newCtx);
				}
			});
	
			function processDatapoints(plot, series, datapoints) {
				if (!processed)	{
					processed = true;
					canvas = plot.getCanvas();
					target = $(canvas).parent();
					options = plot.getOptions();
					plot.setData(combine(plot.getData()));
				}
			}
	
			function combine(data) {
	
				var total = 0,
					combined = 0,
					numCombined = 0,
					color = options.series.pie.combine.color,
					newdata = [];
	
				// Fix up the raw data from Flot, ensuring the data is numeric
	
				for (var i = 0; i < data.length; ++i) {
	
					var value = data[i].data;
	
					// If the data is an array, we'll assume that it's a standard
					// Flot x-y pair, and are concerned only with the second value.
	
					// Note how we use the original array, rather than creating a
					// new one; this is more efficient and preserves any extra data
					// that the user may have stored in higher indexes.
	
					if ($.isArray(value) && value.length == 1) {
	    				value = value[0];
					}
	
					if ($.isArray(value)) {
						// Equivalent to $.isNumeric() but compatible with jQuery < 1.7
						if (!isNaN(parseFloat(value[1])) && isFinite(value[1])) {
							value[1] = +value[1];
						} else {
							value[1] = 0;
						}
					} else if (!isNaN(parseFloat(value)) && isFinite(value)) {
						value = [1, +value];
					} else {
						value = [1, 0];
					}
	
					data[i].data = [value];
				}
	
				// Sum up all the slices, so we can calculate percentages for each
	
				for (var i = 0; i < data.length; ++i) {
					total += data[i].data[0][1];
				}
	
				// Count the number of slices with percentages below the combine
				// threshold; if it turns out to be just one, we won't combine.
	
				for (var i = 0; i < data.length; ++i) {
					var value = data[i].data[0][1];
					if (value / total <= options.series.pie.combine.threshold) {
						combined += value;
						numCombined++;
						if (!color) {
							color = data[i].color;
						}
					}
				}
	
				for (var i = 0; i < data.length; ++i) {
					var value = data[i].data[0][1];
					if (numCombined < 2 || value / total > options.series.pie.combine.threshold) {
						newdata.push(
							$.extend(data[i], {     /* extend to allow keeping all other original data values
							                           and using them e.g. in labelFormatter. */
								data: [[1, value]],
								color: data[i].color,
								label: data[i].label,
								angle: value * Math.PI * 2 / total,
								percent: value / (total / 100)
							})
						);
					}
				}
	
				if (numCombined > 1) {
					newdata.push({
						data: [[1, combined]],
						color: color,
						label: options.series.pie.combine.label,
						angle: combined * Math.PI * 2 / total,
						percent: combined / (total / 100)
					});
				}
	
				return newdata;
			}
	
			function draw(plot, newCtx) {
	
				if (!target) {
					return; // if no series were passed
				}
	
				var canvasWidth = plot.getPlaceholder().width(),
					canvasHeight = plot.getPlaceholder().height(),
					legendWidth = target.children().filter(".legend").children().width() || 0;
	
				ctx = newCtx;
	
				// WARNING: HACK! REWRITE THIS CODE AS SOON AS POSSIBLE!
	
				// When combining smaller slices into an 'other' slice, we need to
				// add a new series.  Since Flot gives plugins no way to modify the
				// list of series, the pie plugin uses a hack where the first call
				// to processDatapoints results in a call to setData with the new
				// list of series, then subsequent processDatapoints do nothing.
	
				// The plugin-global 'processed' flag is used to control this hack;
				// it starts out false, and is set to true after the first call to
				// processDatapoints.
	
				// Unfortunately this turns future setData calls into no-ops; they
				// call processDatapoints, the flag is true, and nothing happens.
	
				// To fix this we'll set the flag back to false here in draw, when
				// all series have been processed, so the next sequence of calls to
				// processDatapoints once again starts out with a slice-combine.
				// This is really a hack; in 0.9 we need to give plugins a proper
				// way to modify series before any processing begins.
	
				processed = false;
	
				// calculate maximum radius and center point
	
				maxRadius =  Math.min(canvasWidth, canvasHeight / options.series.pie.tilt) / 2;
				centerTop = canvasHeight / 2 + options.series.pie.offset.top;
				centerLeft = canvasWidth / 2;
	
				if (options.series.pie.offset.left == "auto") {
					if (options.legend.position.match("w")) {
						centerLeft += legendWidth / 2;
					} else {
						centerLeft -= legendWidth / 2;
					}
					if (centerLeft < maxRadius) {
						centerLeft = maxRadius;
					} else if (centerLeft > canvasWidth - maxRadius) {
						centerLeft = canvasWidth - maxRadius;
					}
				} else {
					centerLeft += options.series.pie.offset.left;
				}
	
				var slices = plot.getData(),
					attempts = 0;
	
				// Keep shrinking the pie's radius until drawPie returns true,
				// indicating that all the labels fit, or we try too many times.
	
				do {
					if (attempts > 0) {
						maxRadius *= REDRAW_SHRINK;
					}
					attempts += 1;
					clear();
					if (options.series.pie.tilt <= 0.8) {
						drawShadow();
					}
				} while (!drawPie() && attempts < REDRAW_ATTEMPTS)
	
				if (attempts >= REDRAW_ATTEMPTS) {
					clear();
					target.prepend("<div class='error'>Could not draw pie with labels contained inside canvas</div>");
				}
	
				if (plot.setSeries && plot.insertLegend) {
					plot.setSeries(slices);
					plot.insertLegend();
				}
	
				// we're actually done at this point, just defining internal functions at this point
	
				function clear() {
					ctx.clearRect(0, 0, canvasWidth, canvasHeight);
					target.children().filter(".pieLabel, .pieLabelBackground").remove();
				}
	
				function drawShadow() {
	
					var shadowLeft = options.series.pie.shadow.left;
					var shadowTop = options.series.pie.shadow.top;
					var edge = 10;
					var alpha = options.series.pie.shadow.alpha;
					var radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius;
	
					if (radius >= canvasWidth / 2 - shadowLeft || radius * options.series.pie.tilt >= canvasHeight / 2 - shadowTop || radius <= edge) {
						return;	// shadow would be outside canvas, so don't draw it
					}
	
					ctx.save();
					ctx.translate(shadowLeft,shadowTop);
					ctx.globalAlpha = alpha;
					ctx.fillStyle = "#000";
	
					// center and rotate to starting position
	
					ctx.translate(centerLeft,centerTop);
					ctx.scale(1, options.series.pie.tilt);
	
					//radius -= edge;
	
					for (var i = 1; i <= edge; i++) {
						ctx.beginPath();
						ctx.arc(0, 0, radius, 0, Math.PI * 2, false);
						ctx.fill();
						radius -= i;
					}
	
					ctx.restore();
				}
	
				function drawPie() {
	
					var startAngle = Math.PI * options.series.pie.startAngle;
					var radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius;
	
					// center and rotate to starting position
	
					ctx.save();
					ctx.translate(centerLeft,centerTop);
					ctx.scale(1, options.series.pie.tilt);
					//ctx.rotate(startAngle); // start at top; -- This doesn't work properly in Opera
	
					// draw slices
	
					ctx.save();
					var currentAngle = startAngle;
					for (var i = 0; i < slices.length; ++i) {
						slices[i].startAngle = currentAngle;
						drawSlice(slices[i].angle, slices[i].color, true);
					}
					ctx.restore();
	
					// draw slice outlines
	
					if (options.series.pie.stroke.width > 0) {
						ctx.save();
						ctx.lineWidth = options.series.pie.stroke.width;
						currentAngle = startAngle;
						for (var i = 0; i < slices.length; ++i) {
							drawSlice(slices[i].angle, options.series.pie.stroke.color, false);
						}
						ctx.restore();
					}
	
					// draw donut hole
	
					drawDonutHole(ctx);
	
					ctx.restore();
	
					// Draw the labels, returning true if they fit within the plot
	
					if (options.series.pie.label.show) {
						return drawLabels();
					} else return true;
	
					function drawSlice(angle, color, fill) {
	
						if (angle <= 0 || isNaN(angle)) {
							return;
						}
	
						if (fill) {
							ctx.fillStyle = color;
						} else {
							ctx.strokeStyle = color;
							ctx.lineJoin = "round";
						}
	
						ctx.beginPath();
						if (Math.abs(angle - Math.PI * 2) > 0.000000001) {
							ctx.moveTo(0, 0); // Center of the pie
						}
	
						//ctx.arc(0, 0, radius, 0, angle, false); // This doesn't work properly in Opera
						ctx.arc(0, 0, radius,currentAngle, currentAngle + angle / 2, false);
						ctx.arc(0, 0, radius,currentAngle + angle / 2, currentAngle + angle, false);
						ctx.closePath();
						//ctx.rotate(angle); // This doesn't work properly in Opera
						currentAngle += angle;
	
						if (fill) {
							ctx.fill();
						} else {
							ctx.stroke();
						}
					}
	
					function drawLabels() {
	
						var currentAngle = startAngle;
						var radius = options.series.pie.label.radius > 1 ? options.series.pie.label.radius : maxRadius * options.series.pie.label.radius;
	
						for (var i = 0; i < slices.length; ++i) {
							if (slices[i].percent >= options.series.pie.label.threshold * 100) {
								if (!drawLabel(slices[i], currentAngle, i)) {
									return false;
								}
							}
							currentAngle += slices[i].angle;
						}
	
						return true;
	
						function drawLabel(slice, startAngle, index) {
	
							if (slice.data[0][1] == 0) {
								return true;
							}
	
							// format label text
	
							var lf = options.legend.labelFormatter, text, plf = options.series.pie.label.formatter;
	
							if (lf) {
								text = lf(slice.label, slice);
							} else {
								text = slice.label;
							}
	
							if (plf) {
								text = plf(text, slice);
							}
	
							var halfAngle = ((startAngle + slice.angle) + startAngle) / 2;
							var x = centerLeft + Math.round(Math.cos(halfAngle) * radius);
							var y = centerTop + Math.round(Math.sin(halfAngle) * radius) * options.series.pie.tilt;
	
							var html = "<span class='pieLabel' id='pieLabel" + index + "' style='position:absolute;top:" + y + "px;left:" + x + "px;'>" + text + "</span>";
							target.append(html);
	
							var label = target.children("#pieLabel" + index);
							var labelTop = (y - label.height() / 2);
							var labelLeft = (x - label.width() / 2);
	
							label.css("top", labelTop);
							label.css("left", labelLeft);
	
							// check to make sure that the label is not outside the canvas
	
							if (0 - labelTop > 0 || 0 - labelLeft > 0 || canvasHeight - (labelTop + label.height()) < 0 || canvasWidth - (labelLeft + label.width()) < 0) {
								return false;
							}
	
							if (options.series.pie.label.background.opacity != 0) {
	
								// put in the transparent background separately to avoid blended labels and label boxes
	
								var c = options.series.pie.label.background.color;
	
								if (c == null) {
									c = slice.color;
								}
	
								var pos = "top:" + labelTop + "px;left:" + labelLeft + "px;";
								$("<div class='pieLabelBackground' style='position:absolute;width:" + label.width() + "px;height:" + label.height() + "px;" + pos + "background-color:" + c + ";'></div>")
									.css("opacity", options.series.pie.label.background.opacity)
									.insertBefore(label);
							}
	
							return true;
						} // end individual label function
					} // end drawLabels function
				} // end drawPie function
			} // end draw function
	
			// Placed here because it needs to be accessed from multiple locations
	
			function drawDonutHole(layer) {
				if (options.series.pie.innerRadius > 0) {
	
					// subtract the center
	
					layer.save();
					var innerRadius = options.series.pie.innerRadius > 1 ? options.series.pie.innerRadius : maxRadius * options.series.pie.innerRadius;
					layer.globalCompositeOperation = "destination-out"; // this does not work with excanvas, but it will fall back to using the stroke color
					layer.beginPath();
					layer.fillStyle = options.series.pie.stroke.color;
					layer.arc(0, 0, innerRadius, 0, Math.PI * 2, false);
					layer.fill();
					layer.closePath();
					layer.restore();
	
					// add inner stroke
	
					layer.save();
					layer.beginPath();
					layer.strokeStyle = options.series.pie.stroke.color;
					layer.arc(0, 0, innerRadius, 0, Math.PI * 2, false);
					layer.stroke();
					layer.closePath();
					layer.restore();
	
					// TODO: add extra shadow inside hole (with a mask) if the pie is tilted.
				}
			}
	
			//-- Additional Interactive related functions --
	
			function isPointInPoly(poly, pt) {
				for(var c = false, i = -1, l = poly.length, j = l - 1; ++i < l; j = i)
					((poly[i][1] <= pt[1] && pt[1] < poly[j][1]) || (poly[j][1] <= pt[1] && pt[1]< poly[i][1]))
					&& (pt[0] < (poly[j][0] - poly[i][0]) * (pt[1] - poly[i][1]) / (poly[j][1] - poly[i][1]) + poly[i][0])
					&& (c = !c);
				return c;
			}
	
			function findNearbySlice(mouseX, mouseY) {
	
				var slices = plot.getData(),
					options = plot.getOptions(),
					radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius,
					x, y;
	
				for (var i = 0; i < slices.length; ++i) {
	
					var s = slices[i];
	
					if (s.pie.show) {
	
						ctx.save();
						ctx.beginPath();
						ctx.moveTo(0, 0); // Center of the pie
						//ctx.scale(1, options.series.pie.tilt);	// this actually seems to break everything when here.
						ctx.arc(0, 0, radius, s.startAngle, s.startAngle + s.angle / 2, false);
						ctx.arc(0, 0, radius, s.startAngle + s.angle / 2, s.startAngle + s.angle, false);
						ctx.closePath();
						x = mouseX - centerLeft;
						y = mouseY - centerTop;
	
						if (ctx.isPointInPath) {
							if (ctx.isPointInPath(mouseX - centerLeft, mouseY - centerTop)) {
								ctx.restore();
								return {
									datapoint: [s.percent, s.data],
									dataIndex: 0,
									series: s,
									seriesIndex: i
								};
							}
						} else {
	
							// excanvas for IE doesn;t support isPointInPath, this is a workaround.
	
							var p1X = radius * Math.cos(s.startAngle),
								p1Y = radius * Math.sin(s.startAngle),
								p2X = radius * Math.cos(s.startAngle + s.angle / 4),
								p2Y = radius * Math.sin(s.startAngle + s.angle / 4),
								p3X = radius * Math.cos(s.startAngle + s.angle / 2),
								p3Y = radius * Math.sin(s.startAngle + s.angle / 2),
								p4X = radius * Math.cos(s.startAngle + s.angle / 1.5),
								p4Y = radius * Math.sin(s.startAngle + s.angle / 1.5),
								p5X = radius * Math.cos(s.startAngle + s.angle),
								p5Y = radius * Math.sin(s.startAngle + s.angle),
								arrPoly = [[0, 0], [p1X, p1Y], [p2X, p2Y], [p3X, p3Y], [p4X, p4Y], [p5X, p5Y]],
								arrPoint = [x, y];
	
							// TODO: perhaps do some mathmatical trickery here with the Y-coordinate to compensate for pie tilt?
	
							if (isPointInPoly(arrPoly, arrPoint)) {
								ctx.restore();
								return {
									datapoint: [s.percent, s.data],
									dataIndex: 0,
									series: s,
									seriesIndex: i
								};
							}
						}
	
						ctx.restore();
					}
				}
	
				return null;
			}
	
			function onMouseMove(e) {
				triggerClickHoverEvent("plothover", e);
			}
	
			function onClick(e) {
				triggerClickHoverEvent("plotclick", e);
			}
	
			// trigger click or hover event (they send the same parameters so we share their code)
	
			function triggerClickHoverEvent(eventname, e) {
	
				var offset = plot.offset();
				var canvasX = parseInt(e.pageX - offset.left);
				var canvasY =  parseInt(e.pageY - offset.top);
				var item = findNearbySlice(canvasX, canvasY);
	
				if (options.grid.autoHighlight) {
	
					// clear auto-highlights
	
					for (var i = 0; i < highlights.length; ++i) {
						var h = highlights[i];
						if (h.auto == eventname && !(item && h.series == item.series)) {
							unhighlight(h.series);
						}
					}
				}
	
				// highlight the slice
	
				if (item) {
					highlight(item.series, eventname);
				}
	
				// trigger any hover bind events
	
				var pos = { pageX: e.pageX, pageY: e.pageY };
				target.trigger(eventname, [pos, item]);
			}
	
			function highlight(s, auto) {
				//if (typeof s == "number") {
				//	s = series[s];
				//}
	
				var i = indexOfHighlight(s);
	
				if (i == -1) {
					highlights.push({ series: s, auto: auto });
					plot.triggerRedrawOverlay();
				} else if (!auto) {
					highlights[i].auto = false;
				}
			}
	
			function unhighlight(s) {
				if (s == null) {
					highlights = [];
					plot.triggerRedrawOverlay();
				}
	
				//if (typeof s == "number") {
				//	s = series[s];
				//}
	
				var i = indexOfHighlight(s);
	
				if (i != -1) {
					highlights.splice(i, 1);
					plot.triggerRedrawOverlay();
				}
			}
	
			function indexOfHighlight(s) {
				for (var i = 0; i < highlights.length; ++i) {
					var h = highlights[i];
					if (h.series == s)
						return i;
				}
				return -1;
			}
	
			function drawOverlay(plot, octx) {
	
				var options = plot.getOptions();
	
				var radius = options.series.pie.radius > 1 ? options.series.pie.radius : maxRadius * options.series.pie.radius;
	
				octx.save();
				octx.translate(centerLeft, centerTop);
				octx.scale(1, options.series.pie.tilt);
	
				for (var i = 0; i < highlights.length; ++i) {
					drawHighlight(highlights[i].series);
				}
	
				drawDonutHole(octx);
	
				octx.restore();
	
				function drawHighlight(series) {
	
					if (series.angle <= 0 || isNaN(series.angle)) {
						return;
					}
	
					//octx.fillStyle = parseColor(options.series.pie.highlight.color).scale(null, null, null, options.series.pie.highlight.opacity).toString();
					octx.fillStyle = "rgba(255, 255, 255, " + options.series.pie.highlight.opacity + ")"; // this is temporary until we have access to parseColor
					octx.beginPath();
					if (Math.abs(series.angle - Math.PI * 2) > 0.000000001) {
						octx.moveTo(0, 0); // Center of the pie
					}
					octx.arc(0, 0, radius, series.startAngle, series.startAngle + series.angle / 2, false);
					octx.arc(0, 0, radius, series.startAngle + series.angle / 2, series.startAngle + series.angle, false);
					octx.closePath();
					octx.fill();
				}
			}
		} // end init (plugin body)
	
		// define pie specific options and their default values
	
		var options = {
			series: {
				pie: {
					show: false,
					radius: "auto",	// actual radius of the visible pie (based on full calculated radius if <=1, or hard pixel value)
					innerRadius: 0, /* for donut */
					startAngle: 3/2,
					tilt: 1,
					shadow: {
						left: 5,	// shadow left offset
						top: 15,	// shadow top offset
						alpha: 0.02	// shadow alpha
					},
					offset: {
						top: 0,
						left: "auto"
					},
					stroke: {
						color: "#fff",
						width: 1
					},
					label: {
						show: "auto",
						formatter: function(label, slice) {
							return "<div style='font-size:x-small;text-align:center;padding:2px;color:" + slice.color + ";'>" + label + "<br/>" + Math.round(slice.percent) + "%</div>";
						},	// formatter function
						radius: 1,	// radius at which to place the labels (based on full calculated radius if <=1, or hard pixel value)
						background: {
							color: null,
							opacity: 0
						},
						threshold: 0	// percentage at which to hide the label (i.e. the slice is too narrow)
					},
					combine: {
						threshold: -1,	// percentage at which to combine little slices into one larger slice
						color: null,	// color to give the new slice (auto-generated if null)
						label: "Other"	// label to give the new slice
					},
					highlight: {
						//color: "#fff",		// will add this functionality once parseColor is available
						opacity: 0.5
					}
				}
			}
		};
	
		$.plot.plugins.push({
			init: init,
			options: options,
			name: "pie",
			version: "1.1"
		});
	
	})(jQuery);


/***/ }),
/* 487 */
/***/ (function(module, exports) {

	/* Flot plugin for automatically redrawing plots as the placeholder resizes.
	
	Copyright (c) 2007-2014 IOLA and Ole Laursen.
	Licensed under the MIT license.
	
	It works by listening for changes on the placeholder div (through the jQuery
	resize event plugin) - if the size changes, it will redraw the plot.
	
	There are no options. If you need to disable the plugin for some plots, you
	can just fix the size of their placeholders.
	
	*/
	
	/* Inline dependency:
	 * jQuery resize event - v1.1 - 3/14/2010
	 * http://benalman.com/projects/jquery-resize-plugin/
	 *
	 * Copyright (c) 2010 "Cowboy" Ben Alman
	 * Dual licensed under the MIT and GPL licenses.
	 * http://benalman.com/about/license/
	 */
	(function($,e,t){"$:nomunge";var i=[],n=$.resize=$.extend($.resize,{}),a,r=false,s="setTimeout",u="resize",m=u+"-special-event",o="pendingDelay",l="activeDelay",f="throttleWindow";n[o]=200;n[l]=20;n[f]=true;$.event.special[u]={setup:function(){if(!n[f]&&this[s]){return false}var e=$(this);i.push(this);e.data(m,{w:e.width(),h:e.height()});if(i.length===1){a=t;h()}},teardown:function(){if(!n[f]&&this[s]){return false}var e=$(this);for(var t=i.length-1;t>=0;t--){if(i[t]==this){i.splice(t,1);break}}e.removeData(m);if(!i.length){if(r){cancelAnimationFrame(a)}else{clearTimeout(a)}a=null}},add:function(e){if(!n[f]&&this[s]){return false}var i;function a(e,n,a){var r=$(this),s=r.data(m)||{};s.w=n!==t?n:r.width();s.h=a!==t?a:r.height();i.apply(this,arguments)}if($.isFunction(e)){i=e;return a}else{i=e.handler;e.handler=a}}};function h(t){if(r===true){r=t||1}for(var s=i.length-1;s>=0;s--){var l=$(i[s]);if(l[0]==e||l.is(":visible")){var f=l.width(),c=l.height(),d=l.data(m);if(d&&(f!==d.w||c!==d.h)){l.trigger(u,[d.w=f,d.h=c]);r=t||true}}else{d=l.data(m);d.w=0;d.h=0}}if(a!==null){if(r&&(t==null||t-r<1e3)){a=e.requestAnimationFrame(h)}else{a=setTimeout(h,n[o]);r=false}}}if(!e.requestAnimationFrame){e.requestAnimationFrame=function(){return e.webkitRequestAnimationFrame||e.mozRequestAnimationFrame||e.oRequestAnimationFrame||e.msRequestAnimationFrame||function(t,i){return e.setTimeout(function(){t((new Date).getTime())},n[l])}}()}if(!e.cancelAnimationFrame){e.cancelAnimationFrame=function(){return e.webkitCancelRequestAnimationFrame||e.mozCancelRequestAnimationFrame||e.oCancelRequestAnimationFrame||e.msCancelRequestAnimationFrame||clearTimeout}()}})(jQuery,this);
	
	(function ($) {
	    var options = { }; // no options
	
	    function init(plot) {
	        function onResize() {
	            var placeholder = plot.getPlaceholder();
	
	            // somebody might have hidden us and we can't plot
	            // when we don't have the dimensions
	            if (placeholder.width() == 0 || placeholder.height() == 0)
	                return;
	
	            plot.resize();
	            plot.setupGrid();
	            plot.draw();
	        }
	        
	        function bindEvents(plot, eventHolder) {
	            plot.getPlaceholder().resize(onResize);
	        }
	
	        function shutdown(plot, eventHolder) {
	            plot.getPlaceholder().unbind("resize", onResize);
	        }
	        
	        plot.hooks.bindEvents.push(bindEvents);
	        plot.hooks.shutdown.push(shutdown);
	    }
	    
	    $.plot.plugins.push({
	        init: init,
	        options: options,
	        name: 'resize',
	        version: '1.0'
	    });
	})(jQuery);


/***/ }),
/* 488 */
/***/ (function(module, exports) {

	/* Flot plugin for stacking data sets rather than overlyaing them.
	
	Copyright (c) 2007-2014 IOLA and Ole Laursen.
	Licensed under the MIT license.
	
	The plugin assumes the data is sorted on x (or y if stacking horizontally).
	For line charts, it is assumed that if a line has an undefined gap (from a
	null point), then the line above it should have the same gap - insert zeros
	instead of "null" if you want another behaviour. This also holds for the start
	and end of the chart. Note that stacking a mix of positive and negative values
	in most instances doesn't make sense (so it looks weird).
	
	Two or more series are stacked when their "stack" attribute is set to the same
	key (which can be any number or string or just "true"). To specify the default
	stack, you can set the stack option like this:
	
		series: {
			stack: null/false, true, or a key (number/string)
		}
	
	You can also specify it for a single series, like this:
	
		$.plot( $("#placeholder"), [{
			data: [ ... ],
			stack: true
		}])
	
	The stacking order is determined by the order of the data series in the array
	(later series end up on top of the previous).
	
	Internally, the plugin modifies the datapoints in each series, adding an
	offset to the y value. For line series, extra data points are inserted through
	interpolation. If there's a second y value, it's also adjusted (e.g for bar
	charts or filled areas).
	
	*/
	
	(function ($) {
	    var options = {
	        series: { stack: null } // or number/string
	    };
	    
	    function init(plot) {
	        function findMatchingSeries(s, allseries) {
	            var res = null;
	            for (var i = 0; i < allseries.length; ++i) {
	                if (s == allseries[i])
	                    break;
	                
	                if (allseries[i].stack == s.stack)
	                    res = allseries[i];
	            }
	            
	            return res;
	        }
	        
	        function stackData(plot, s, datapoints) {
	            if (s.stack == null || s.stack === false)
	                return;
	
	            var other = findMatchingSeries(s, plot.getData());
	            if (!other)
	                return;
	
	            var ps = datapoints.pointsize,
	                points = datapoints.points,
	                otherps = other.datapoints.pointsize,
	                otherpoints = other.datapoints.points,
	                newpoints = [],
	                px, py, intery, qx, qy, bottom,
	                withlines = s.lines.show,
	                horizontal = s.bars.horizontal,
	                withbottom = ps > 2 && (horizontal ? datapoints.format[2].x : datapoints.format[2].y),
	                withsteps = withlines && s.lines.steps,
	                fromgap = true,
	                keyOffset = horizontal ? 1 : 0,
	                accumulateOffset = horizontal ? 0 : 1,
	                i = 0, j = 0, l, m;
	
	            while (true) {
	                if (i >= points.length)
	                    break;
	
	                l = newpoints.length;
	
	                if (points[i] == null) {
	                    // copy gaps
	                    for (m = 0; m < ps; ++m)
	                        newpoints.push(points[i + m]);
	                    i += ps;
	                }
	                else if (j >= otherpoints.length) {
	                    // for lines, we can't use the rest of the points
	                    if (!withlines) {
	                        for (m = 0; m < ps; ++m)
	                            newpoints.push(points[i + m]);
	                    }
	                    i += ps;
	                }
	                else if (otherpoints[j] == null) {
	                    // oops, got a gap
	                    for (m = 0; m < ps; ++m)
	                        newpoints.push(null);
	                    fromgap = true;
	                    j += otherps;
	                }
	                else {
	                    // cases where we actually got two points
	                    px = points[i + keyOffset];
	                    py = points[i + accumulateOffset];
	                    qx = otherpoints[j + keyOffset];
	                    qy = otherpoints[j + accumulateOffset];
	                    bottom = 0;
	
	                    if (px == qx) {
	                        for (m = 0; m < ps; ++m)
	                            newpoints.push(points[i + m]);
	
	                        newpoints[l + accumulateOffset] += qy;
	                        bottom = qy;
	                        
	                        i += ps;
	                        j += otherps;
	                    }
	                    else if (px > qx) {
	                        // we got past point below, might need to
	                        // insert interpolated extra point
	                        if (withlines && i > 0 && points[i - ps] != null) {
	                            intery = py + (points[i - ps + accumulateOffset] - py) * (qx - px) / (points[i - ps + keyOffset] - px);
	                            newpoints.push(qx);
	                            newpoints.push(intery + qy);
	                            for (m = 2; m < ps; ++m)
	                                newpoints.push(points[i + m]);
	                            bottom = qy; 
	                        }
	
	                        j += otherps;
	                    }
	                    else { // px < qx
	                        if (fromgap && withlines) {
	                            // if we come from a gap, we just skip this point
	                            i += ps;
	                            continue;
	                        }
	                            
	                        for (m = 0; m < ps; ++m)
	                            newpoints.push(points[i + m]);
	                        
	                        // we might be able to interpolate a point below,
	                        // this can give us a better y
	                        if (withlines && j > 0 && otherpoints[j - otherps] != null)
	                            bottom = qy + (otherpoints[j - otherps + accumulateOffset] - qy) * (px - qx) / (otherpoints[j - otherps + keyOffset] - qx);
	
	                        newpoints[l + accumulateOffset] += bottom;
	                        
	                        i += ps;
	                    }
	
	                    fromgap = false;
	                    
	                    if (l != newpoints.length && withbottom)
	                        newpoints[l + 2] += bottom;
	                }
	
	                // maintain the line steps invariant
	                if (withsteps && l != newpoints.length && l > 0
	                    && newpoints[l] != null
	                    && newpoints[l] != newpoints[l - ps]
	                    && newpoints[l + 1] != newpoints[l - ps + 1]) {
	                    for (m = 0; m < ps; ++m)
	                        newpoints[l + ps + m] = newpoints[l + m];
	                    newpoints[l + 1] = newpoints[l - ps + 1];
	                }
	            }
	
	            datapoints.points = newpoints;
	        }
	        
	        plot.hooks.processDatapoints.push(stackData);
	    }
	    
	    $.plot.plugins.push({
	        init: init,
	        options: options,
	        name: 'stack',
	        version: '1.2'
	    });
	})(jQuery);


/***/ }),
/* 489 */
/***/ (function(module, exports) {

	/* Pretty handling of time axes.
	
	Copyright (c) 2007-2014 IOLA and Ole Laursen.
	Licensed under the MIT license.
	
	Set axis.mode to "time" to enable. See the section "Time series data" in
	API.txt for details.
	
	*/
	
	(function($) {
	
		var options = {
			xaxis: {
				timezone: null,		// "browser" for local to the client or timezone for timezone-js
				timeformat: null,	// format string to use
				twelveHourClock: false,	// 12 or 24 time in time mode
				monthNames: null	// list of names of months
			}
		};
	
		// round to nearby lower multiple of base
	
		function floorInBase(n, base) {
			return base * Math.floor(n / base);
		}
	
		// Returns a string with the date d formatted according to fmt.
		// A subset of the Open Group's strftime format is supported.
	
		function formatDate(d, fmt, monthNames, dayNames) {
	
			if (typeof d.strftime == "function") {
				return d.strftime(fmt);
			}
	
			var leftPad = function(n, pad) {
				n = "" + n;
				pad = "" + (pad == null ? "0" : pad);
				return n.length == 1 ? pad + n : n;
			};
	
			var r = [];
			var escape = false;
			var hours = d.getHours();
			var isAM = hours < 12;
	
			if (monthNames == null) {
				monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
			}
	
			if (dayNames == null) {
				dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
			}
	
			var hours12;
	
			if (hours > 12) {
				hours12 = hours - 12;
			} else if (hours == 0) {
				hours12 = 12;
			} else {
				hours12 = hours;
			}
	
			for (var i = 0; i < fmt.length; ++i) {
	
				var c = fmt.charAt(i);
	
				if (escape) {
					switch (c) {
						case 'a': c = "" + dayNames[d.getDay()]; break;
						case 'b': c = "" + monthNames[d.getMonth()]; break;
						case 'd': c = leftPad(d.getDate()); break;
						case 'e': c = leftPad(d.getDate(), " "); break;
						case 'h':	// For back-compat with 0.7; remove in 1.0
						case 'H': c = leftPad(hours); break;
						case 'I': c = leftPad(hours12); break;
						case 'l': c = leftPad(hours12, " "); break;
						case 'm': c = leftPad(d.getMonth() + 1); break;
						case 'M': c = leftPad(d.getMinutes()); break;
						// quarters not in Open Group's strftime specification
						case 'q':
							c = "" + (Math.floor(d.getMonth() / 3) + 1); break;
						case 'S': c = leftPad(d.getSeconds()); break;
						case 'y': c = leftPad(d.getFullYear() % 100); break;
						case 'Y': c = "" + d.getFullYear(); break;
						case 'p': c = (isAM) ? ("" + "am") : ("" + "pm"); break;
						case 'P': c = (isAM) ? ("" + "AM") : ("" + "PM"); break;
						case 'w': c = "" + d.getDay(); break;
					}
					r.push(c);
					escape = false;
				} else {
					if (c == "%") {
						escape = true;
					} else {
						r.push(c);
					}
				}
			}
	
			return r.join("");
		}
	
		// To have a consistent view of time-based data independent of which time
		// zone the client happens to be in we need a date-like object independent
		// of time zones.  This is done through a wrapper that only calls the UTC
		// versions of the accessor methods.
	
		function makeUtcWrapper(d) {
	
			function addProxyMethod(sourceObj, sourceMethod, targetObj, targetMethod) {
				sourceObj[sourceMethod] = function() {
					return targetObj[targetMethod].apply(targetObj, arguments);
				};
			};
	
			var utc = {
				date: d
			};
	
			// support strftime, if found
	
			if (d.strftime != undefined) {
				addProxyMethod(utc, "strftime", d, "strftime");
			}
	
			addProxyMethod(utc, "getTime", d, "getTime");
			addProxyMethod(utc, "setTime", d, "setTime");
	
			var props = ["Date", "Day", "FullYear", "Hours", "Milliseconds", "Minutes", "Month", "Seconds"];
	
			for (var p = 0; p < props.length; p++) {
				addProxyMethod(utc, "get" + props[p], d, "getUTC" + props[p]);
				addProxyMethod(utc, "set" + props[p], d, "setUTC" + props[p]);
			}
	
			return utc;
		};
	
		// select time zone strategy.  This returns a date-like object tied to the
		// desired timezone
	
		function dateGenerator(ts, opts) {
			if (opts.timezone == "browser") {
				return new Date(ts);
			} else if (!opts.timezone || opts.timezone == "utc") {
				return makeUtcWrapper(new Date(ts));
			} else if (typeof timezoneJS != "undefined" && typeof timezoneJS.Date != "undefined") {
				var d = new timezoneJS.Date();
				// timezone-js is fickle, so be sure to set the time zone before
				// setting the time.
				d.setTimezone(opts.timezone);
				d.setTime(ts);
				return d;
			} else {
				return makeUtcWrapper(new Date(ts));
			}
		}
		
		// map of app. size of time units in milliseconds
	
		var timeUnitSize = {
			"second": 1000,
			"minute": 60 * 1000,
			"hour": 60 * 60 * 1000,
			"day": 24 * 60 * 60 * 1000,
			"month": 30 * 24 * 60 * 60 * 1000,
			"quarter": 3 * 30 * 24 * 60 * 60 * 1000,
			"year": 365.2425 * 24 * 60 * 60 * 1000
		};
	
		// the allowed tick sizes, after 1 year we use
		// an integer algorithm
	
		var baseSpec = [
			[1, "second"], [2, "second"], [5, "second"], [10, "second"],
			[30, "second"], 
			[1, "minute"], [2, "minute"], [5, "minute"], [10, "minute"],
			[30, "minute"], 
			[1, "hour"], [2, "hour"], [4, "hour"],
			[8, "hour"], [12, "hour"],
			[1, "day"], [2, "day"], [3, "day"],
			[0.25, "month"], [0.5, "month"], [1, "month"],
			[2, "month"]
		];
	
		// we don't know which variant(s) we'll need yet, but generating both is
		// cheap
	
		var specMonths = baseSpec.concat([[3, "month"], [6, "month"],
			[1, "year"]]);
		var specQuarters = baseSpec.concat([[1, "quarter"], [2, "quarter"],
			[1, "year"]]);
	
		function init(plot) {
			plot.hooks.processOptions.push(function (plot, options) {
				$.each(plot.getAxes(), function(axisName, axis) {
	
					var opts = axis.options;
	
					if (opts.mode == "time") {
						axis.tickGenerator = function(axis) {
	
							var ticks = [];
							var d = dateGenerator(axis.min, opts);
							var minSize = 0;
	
							// make quarter use a possibility if quarters are
							// mentioned in either of these options
	
							var spec = (opts.tickSize && opts.tickSize[1] ===
								"quarter") ||
								(opts.minTickSize && opts.minTickSize[1] ===
								"quarter") ? specQuarters : specMonths;
	
							if (opts.minTickSize != null) {
								if (typeof opts.tickSize == "number") {
									minSize = opts.tickSize;
								} else {
									minSize = opts.minTickSize[0] * timeUnitSize[opts.minTickSize[1]];
								}
							}
	
							for (var i = 0; i < spec.length - 1; ++i) {
								if (axis.delta < (spec[i][0] * timeUnitSize[spec[i][1]]
												  + spec[i + 1][0] * timeUnitSize[spec[i + 1][1]]) / 2
									&& spec[i][0] * timeUnitSize[spec[i][1]] >= minSize) {
									break;
								}
							}
	
							var size = spec[i][0];
							var unit = spec[i][1];
	
							// special-case the possibility of several years
	
							if (unit == "year") {
	
								// if given a minTickSize in years, just use it,
								// ensuring that it's an integer
	
								if (opts.minTickSize != null && opts.minTickSize[1] == "year") {
									size = Math.floor(opts.minTickSize[0]);
								} else {
	
									var magn = Math.pow(10, Math.floor(Math.log(axis.delta / timeUnitSize.year) / Math.LN10));
									var norm = (axis.delta / timeUnitSize.year) / magn;
	
									if (norm < 1.5) {
										size = 1;
									} else if (norm < 3) {
										size = 2;
									} else if (norm < 7.5) {
										size = 5;
									} else {
										size = 10;
									}
	
									size *= magn;
								}
	
								// minimum size for years is 1
	
								if (size < 1) {
									size = 1;
								}
							}
	
							axis.tickSize = opts.tickSize || [size, unit];
							var tickSize = axis.tickSize[0];
							unit = axis.tickSize[1];
	
							var step = tickSize * timeUnitSize[unit];
	
							if (unit == "second") {
								d.setSeconds(floorInBase(d.getSeconds(), tickSize));
							} else if (unit == "minute") {
								d.setMinutes(floorInBase(d.getMinutes(), tickSize));
							} else if (unit == "hour") {
								d.setHours(floorInBase(d.getHours(), tickSize));
							} else if (unit == "month") {
								d.setMonth(floorInBase(d.getMonth(), tickSize));
							} else if (unit == "quarter") {
								d.setMonth(3 * floorInBase(d.getMonth() / 3,
									tickSize));
							} else if (unit == "year") {
								d.setFullYear(floorInBase(d.getFullYear(), tickSize));
							}
	
							// reset smaller components
	
							d.setMilliseconds(0);
	
							if (step >= timeUnitSize.minute) {
								d.setSeconds(0);
							}
							if (step >= timeUnitSize.hour) {
								d.setMinutes(0);
							}
							if (step >= timeUnitSize.day) {
								d.setHours(0);
							}
							if (step >= timeUnitSize.day * 4) {
								d.setDate(1);
							}
							if (step >= timeUnitSize.month * 2) {
								d.setMonth(floorInBase(d.getMonth(), 3));
							}
							if (step >= timeUnitSize.quarter * 2) {
								d.setMonth(floorInBase(d.getMonth(), 6));
							}
							if (step >= timeUnitSize.year) {
								d.setMonth(0);
							}
	
							var carry = 0;
							var v = Number.NaN;
							var prev;
	
							do {
	
								prev = v;
								v = d.getTime();
								ticks.push(v);
	
								if (unit == "month" || unit == "quarter") {
									if (tickSize < 1) {
	
										// a bit complicated - we'll divide the
										// month/quarter up but we need to take
										// care of fractions so we don't end up in
										// the middle of a day
	
										d.setDate(1);
										var start = d.getTime();
										d.setMonth(d.getMonth() +
											(unit == "quarter" ? 3 : 1));
										var end = d.getTime();
										d.setTime(v + carry * timeUnitSize.hour + (end - start) * tickSize);
										carry = d.getHours();
										d.setHours(0);
									} else {
										d.setMonth(d.getMonth() +
											tickSize * (unit == "quarter" ? 3 : 1));
									}
								} else if (unit == "year") {
									d.setFullYear(d.getFullYear() + tickSize);
								} else {
									d.setTime(v + step);
								}
							} while (v < axis.max && v != prev);
	
							return ticks;
						};
	
						axis.tickFormatter = function (v, axis) {
	
							var d = dateGenerator(v, axis.options);
	
							// first check global format
	
							if (opts.timeformat != null) {
								return formatDate(d, opts.timeformat, opts.monthNames, opts.dayNames);
							}
	
							// possibly use quarters if quarters are mentioned in
							// any of these places
	
							var useQuarters = (axis.options.tickSize &&
									axis.options.tickSize[1] == "quarter") ||
								(axis.options.minTickSize &&
									axis.options.minTickSize[1] == "quarter");
	
							var t = axis.tickSize[0] * timeUnitSize[axis.tickSize[1]];
							var span = axis.max - axis.min;
							var suffix = (opts.twelveHourClock) ? " %p" : "";
							var hourCode = (opts.twelveHourClock) ? "%I" : "%H";
							var fmt;
	
							if (t < timeUnitSize.minute) {
								fmt = hourCode + ":%M:%S" + suffix;
							} else if (t < timeUnitSize.day) {
								if (span < 2 * timeUnitSize.day) {
									fmt = hourCode + ":%M" + suffix;
								} else {
									fmt = "%b %d " + hourCode + ":%M" + suffix;
								}
							} else if (t < timeUnitSize.month) {
								fmt = "%b %d";
							} else if ((useQuarters && t < timeUnitSize.quarter) ||
								(!useQuarters && t < timeUnitSize.year)) {
								if (span < timeUnitSize.year) {
									fmt = "%b";
								} else {
									fmt = "%b %Y";
								}
							} else if (useQuarters && t < timeUnitSize.year) {
								if (span < timeUnitSize.year) {
									fmt = "Q%q";
								} else {
									fmt = "Q%q %Y";
								}
							} else {
								fmt = "%Y";
							}
	
							var rt = formatDate(d, fmt, opts.monthNames, opts.dayNames);
	
							return rt;
						};
					}
				});
			});
		}
	
		$.plot.plugins.push({
			init: init,
			options: options,
			name: 'time',
			version: '1.0'
		});
	
		// Time-axis support used to be in Flot core, which exposed the
		// formatDate function on the plot object.  Various plugins depend
		// on the function, so we need to re-expose it here.
	
		$.plot.formatDate = formatDate;
		$.plot.dateGenerator = dateGenerator;
	
	})(jQuery);


/***/ }),
/* 490 */
/***/ (function(module, exports) {

	/* 
	 * Angular JS Multi Select
	 * Creates a dropdown-like button with checkboxes. 
	 *
	 * Project started on: Tue, 14 Jan 2014 - 5:18:02 PM
	 * Current version: 4.0.0
	 * 
	 * Released under the MIT License
	 * --------------------------------------------------------------------------------
	 * The MIT License (MIT)
	 *
	 * Copyright (c) 2014 Ignatius Steven (https://github.com/isteven)
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy 
	 * of this software and associated documentation files (the "Software"), to deal 
	 * in the Software without restriction, including without limitation the rights 
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell 
	 * copies of the Software, and to permit persons to whom the Software is 
	 * furnished to do so, subject to the following conditions: 
	 *
	 * The above copyright notice and this permission notice shall be included in all 
	 * copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR 
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, 
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE 
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER 
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, 
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE 
	 * SOFTWARE.
	 * --------------------------------------------------------------------------------
	 */
	
	'use strict'
	
	angular.module( 'isteven-multi-select', ['ng'] ).directive( 'istevenMultiSelect' , [ '$sce', '$timeout', '$templateCache', function ( $sce, $timeout, $templateCache ) {
	    return {
	        restrict: 
	            'AE',
	
	        scope: 
	        {   
	            // models
	            inputModel      : '=',
	            outputModel     : '=',
	
	            // settings based on attribute
	            isDisabled      : '=',
	
	            // callbacks
	            onClear         : '&',  
	            onClose         : '&',
	            onSearchChange  : '&',  
	            onItemClick     : '&',            
	            onOpen          : '&', 
	            onReset         : '&',  
	            onSelectAll     : '&',  
	            onSelectNone    : '&',  
	
	            // i18n
	            translation     : '='   
	        },
	        
	        /* 
	         * The rest are attributes. They don't need to be parsed / binded, so we can safely access them by value.
	         * - buttonLabel, directiveId, helperElements, itemLabel, maxLabels, orientation, selectionMode, minSearchLength,
	         *   tickProperty, disableProperty, groupProperty, searchProperty, maxHeight, outputProperties
	         */
	                                                         
	         templateUrl: 
	            'isteven-multi-select.htm',                            
	
	        link: function ( $scope, element, attrs ) {                       
	
	            $scope.backUp           = [];
	            $scope.varButtonLabel   = '';               
	            $scope.spacingProperty  = '';
	            $scope.indexProperty    = '';                        
	            $scope.orientationH     = false;
	            $scope.orientationV     = true;
	            $scope.filteredModel    = [];
	            $scope.inputLabel       = { labelFilter: '' };                        
	            $scope.tabIndex         = 0;            
	            $scope.lang             = {};
	            $scope.helperStatus     = {
	                all     : true,
	                none    : true,
	                reset   : true,
	                filter  : true
	            };
	
	            var 
	                prevTabIndex        = 0,
	                helperItems         = [],
	                helperItemsLength   = 0,
	                checkBoxLayer       = '',
	                scrolled            = false,
	                selectedItems       = [],
	                formElements        = [],
	                vMinSearchLength    = 0,
	                clickedItem         = null                
	
	            // v3.0.0
	            // clear button clicked
	            $scope.clearClicked = function( e ) {                
	                $scope.inputLabel.labelFilter = '';
	                $scope.updateFilter();
	                $scope.select( 'clear', e );                
	            }
	
	            // A little hack so that AngularJS ng-repeat can loop using start and end index like a normal loop
	            // http://stackoverflow.com/questions/16824853/way-to-ng-repeat-defined-number-of-times-instead-of-repeating-over-array
	            $scope.numberToArray = function( num ) {
	                return new Array( num );   
	            }
	
	            // Call this function when user type on the filter field
	            $scope.searchChanged = function() {                                                
	                if ( $scope.inputLabel.labelFilter.length < vMinSearchLength && $scope.inputLabel.labelFilter.length > 0 ) {
	                    return false;
	                }                
	                $scope.updateFilter();
	            }
	
	            $scope.updateFilter = function()
	            {      
	                // we check by looping from end of input-model
	                $scope.filteredModel = [];
	                var i = 0;
	
	                if ( typeof $scope.inputModel === 'undefined' ) {
	                    return false;                   
	                }
	
	                for( i = $scope.inputModel.length - 1; i >= 0; i-- ) {
	
	                    // if it's group end, we push it to filteredModel[];
	                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === false ) {
	                        $scope.filteredModel.push( $scope.inputModel[ i ] );
	                    }
	                    
	                    // if it's data 
	                    var gotData = false;
	                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] === 'undefined' ) {                        
	                        
	                        // If we set the search-key attribute, we use this loop. 
	                        if ( typeof attrs.searchProperty !== 'undefined' && attrs.searchProperty !== '' ) {
	
	                            for (var key in $scope.inputModel[ i ]  ) {
	                                if ( 
	                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
	                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0                                     
	                                    && attrs.searchProperty.indexOf( key ) > -1
	                                ) {
	                                    gotData = true;
	                                    break;
	                                }
	                            }                        
	                        }
	                        // if there's no search-key attribute, we use this one. Much better on performance.
	                        else {
	                            for ( var key in $scope.inputModel[ i ]  ) {
	                                if ( 
	                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
	                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0                                     
	                                ) {
	                                    gotData = true;
	                                    break;
	                                }
	                            }                        
	                        }
	
	                        if ( gotData === true ) {    
	                            // push
	                            $scope.filteredModel.push( $scope.inputModel[ i ] );
	                        }
	                    }
	
	                    // if it's group start
	                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === true ) {
	
	                        if ( typeof $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] !== 'undefined' 
	                                && $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] === false ) {
	                            $scope.filteredModel.pop();
	                        }
	                        else {
	                            $scope.filteredModel.push( $scope.inputModel[ i ] );
	                        }
	                    }
	                }                
	
	                $scope.filteredModel.reverse();  
	                
	                $timeout( function() {                    
	
	                    $scope.getFormElements();               
	                    
	                    // Callback: on filter change                      
	                    if ( $scope.inputLabel.labelFilter.length > vMinSearchLength ) {
	
	                        var filterObj = [];
	
	                        angular.forEach( $scope.filteredModel, function( value, key ) {
	                            if ( typeof value !== 'undefined' ) {                   
	                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                                                    
	                                    var tempObj = angular.copy( value );
	                                    var index = filterObj.push( tempObj );                                
	                                    delete filterObj[ index - 1 ][ $scope.indexProperty ];
	                                    delete filterObj[ index - 1 ][ $scope.spacingProperty ];      
	                                }
	                            }
	                        });
	
	                        $scope.onSearchChange({ 
	                            data: 
	                            {
	                                keyword: $scope.inputLabel.labelFilter, 
	                                result: filterObj 
	                            } 
	                        });
	                    }
	                },0);
	            };
	
	            // List all the input elements. We need this for our keyboard navigation.
	            // This function will be called everytime the filter is updated. 
	            // Depending on the size of filtered mode, might not good for performance, but oh well..
	            $scope.getFormElements = function() {                                     
	                formElements = [];
	
	                var 
	                    selectButtons   = [],
	                    inputField      = [],
	                    checkboxes      = [],
	                    clearButton     = [];
	                
	                // If available, then get select all, select none, and reset buttons
	                if ( $scope.helperStatus.all || $scope.helperStatus.none || $scope.helperStatus.reset ) {                                                       
	                    selectButtons = element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );                    
	                    // If available, then get the search box and the clear button
	                    if ( $scope.helperStatus.filter ) {                                            
	                        // Get helper - search and clear button. 
	                        inputField =    element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'input' );                    
	                        clearButton =   element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'button' );                        
	                    }
	                }
	                else {
	                    if ( $scope.helperStatus.filter ) {   
	                        // Get helper - search and clear button. 
	                        inputField =    element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'input' );                    
	                        clearButton =   element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );
	                    }
	                }
	               
	                // Get checkboxes
	                if ( !$scope.helperStatus.all && !$scope.helperStatus.none && !$scope.helperStatus.reset && !$scope.helperStatus.filter ) {
	                    checkboxes = element.children().children().next()[ 0 ].getElementsByTagName( 'input' );
	                }
	                else {
	                    checkboxes = element.children().children().next().children().next()[ 0 ].getElementsByTagName( 'input' );
	                }
	
	                // Push them into global array formElements[] 
	                for ( var i = 0; i < selectButtons.length ; i++ )   { formElements.push( selectButtons[ i ] );  }
	                for ( var i = 0; i < inputField.length ; i++ )      { formElements.push( inputField[ i ] );     }
	                for ( var i = 0; i < clearButton.length ; i++ )     { formElements.push( clearButton[ i ] );    }
	                for ( var i = 0; i < checkboxes.length ; i++ )      { formElements.push( checkboxes[ i ] );     }                                
	            }            
	
	            // check if an item has attrs.groupProperty (be it true or false)
	            $scope.isGroupMarker = function( item , type ) {
	                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === type ) return true; 
	                return false;
	            }
	
	            $scope.removeGroupEndMarker = function( item ) {
	                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) return false; 
	                return true;
	            }                       
	
	            // call this function when an item is clicked
	            $scope.syncItems = function( item, e, ng_repeat_index ) {                                      
	
	                e.preventDefault();
	                e.stopPropagation();
	
	                // if the directive is globaly disabled, do nothing
	                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {                                        
	                    return false;
	                }
	
	                // if item is disabled, do nothing
	                if ( typeof attrs.isDisabled !== 'undefined' && $scope.isDisabled === true ) {                        
	                    return false;
	                }                                
	
	                // if end group marker is clicked, do nothing
	                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) {
	                    return false;
	                }                
	
	                var index = $scope.filteredModel.indexOf( item );       
	
	                // if the start of group marker is clicked ( only for multiple selection! )
	                // how it works:
	                // - if, in a group, there are items which are not selected, then they all will be selected
	                // - if, in a group, all items are selected, then they all will be de-selected                
	                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === true ) {                                  
	
	                    // this is only for multiple selection, so if selection mode is single, do nothing
	                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
	                        return false;
	                    }
	                    
	                    var i,j,k;
	                    var startIndex = 0;
	                    var endIndex = $scope.filteredModel.length - 1;
	                    var tempArr = [];
	
	                    // nest level is to mark the depth of the group.
	                    // when you get into a group (start group marker), nestLevel++
	                    // when you exit a group (end group marker), nextLevel--
	                    var nestLevel = 0;                    
	
	                    // we loop throughout the filtered model (not whole model)
	                    for( i = index ; i < $scope.filteredModel.length ; i++) {  
	
	                        // this break will be executed when we're done processing each group
	                        if ( nestLevel === 0 && i > index ) 
	                        {
	                            break;
	                        }
	                    
	                        if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === true ) {
	                            
	                            // To cater multi level grouping
	                            if ( tempArr.length === 0 ) {
	                                startIndex = i + 1; 
	                            }                            
	                            nestLevel = nestLevel + 1;
	                        }                                                
	
	                        // if group end
	                        else if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === false ) {
	
	                            nestLevel = nestLevel - 1;                            
	
	                            // cek if all are ticked or not                            
	                            if ( tempArr.length > 0 && nestLevel === 0 ) {                                
	
	                                var allTicked = true;       
	
	                                endIndex = i;
	
	                                for ( j = 0; j < tempArr.length ; j++ ) {                                
	                                    if ( typeof tempArr[ j ][ $scope.tickProperty ] !== 'undefined' &&  tempArr[ j ][ $scope.tickProperty ] === false ) {
	                                        allTicked = false;
	                                        break;
	                                    }
	                                }                                                                                    
	
	                                if ( allTicked === true ) {
	                                    for ( j = startIndex; j <= endIndex ; j++ ) {
	                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
	                                            if ( typeof attrs.disableProperty === 'undefined' ) {
	                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
	                                                // we refresh input model as well
	                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
	                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
	                                            }
	                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
	                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
	                                                // we refresh input model as well
	                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
	                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
	                                            }
	                                        }
	                                    }                                
	                                }
	
	                                else {
	                                    for ( j = startIndex; j <= endIndex ; j++ ) {
	                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
	                                            if ( typeof attrs.disableProperty === 'undefined' ) {
	                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;                                                
	                                                // we refresh input model as well
	                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
	                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;
	
	                                            }                                            
	                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
	                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;
	                                                // we refresh input model as well
	                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
	                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;
	                                            }
	                                        }
	                                    }                                
	                                }                                                                                    
	                            }
	                        }
	            
	                        // if data
	                        else {                            
	                            tempArr.push( $scope.filteredModel[ i ] );                                                                                    
	                        }
	                    }                                 
	                }
	
	                // if an item (not group marker) is clicked
	                else {
	
	                    // If it's single selection mode
	                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
	                        
	                        // first, set everything to false
	                        for( i=0 ; i < $scope.filteredModel.length ; i++) {                            
	                            $scope.filteredModel[ i ][ $scope.tickProperty ] = false;                            
	                        }        
	                        for( i=0 ; i < $scope.inputModel.length ; i++) {                            
	                            $scope.inputModel[ i ][ $scope.tickProperty ] = false;                            
	                        }        
	                        
	                        // then set the clicked item to true
	                        $scope.filteredModel[ index ][ $scope.tickProperty ] = true;                                                                 
	                    }   
	
	                    // Multiple
	                    else {
	                        $scope.filteredModel[ index ][ $scope.tickProperty ]   = !$scope.filteredModel[ index ][ $scope.tickProperty ];
	                    }
	
	                    // we refresh input model as well
	                    var inputModelIndex = $scope.filteredModel[ index ][ $scope.indexProperty ];                                        
	                    $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = $scope.filteredModel[ index ][ $scope.tickProperty ];                    
	                }                                  
	
	                // we execute the callback function here
	                clickedItem = angular.copy( item );                                                    
	                if ( clickedItem !== null ) {                        
	                    $timeout( function() {
	                        delete clickedItem[ $scope.indexProperty ];
	                        delete clickedItem[ $scope.spacingProperty ];      
	                        $scope.onItemClick( { data: clickedItem } );
	                        clickedItem = null;                    
	                    }, 0 );                                                 
	                }                                    
	                
	                $scope.refreshOutputModel();
	                $scope.refreshButton();                              
	
	                // We update the index here
	                prevTabIndex = $scope.tabIndex;
	                $scope.tabIndex = ng_repeat_index + helperItemsLength;
	                                
	                // Set focus on the hidden checkbox 
	                e.target.focus();
	
	                // set & remove CSS style
	                $scope.removeFocusStyle( prevTabIndex );
	                $scope.setFocusStyle( $scope.tabIndex );
	
	                if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
	                    // on single selection mode, we then hide the checkbox layer
	                    $scope.toggleCheckboxes( e );       
	                }
	            }     
	
	            // update $scope.outputModel
	            $scope.refreshOutputModel = function() {            
	                
	                $scope.outputModel  = [];
	                var 
	                    outputProps     = [],
	                    tempObj         = {};
	
	                // v4.0.0
	                if ( typeof attrs.outputProperties !== 'undefined' ) {                    
	                    outputProps = attrs.outputProperties.split(' ');                
	                    angular.forEach( $scope.inputModel, function( value, key ) {                    
	                        if ( 
	                            typeof value !== 'undefined' 
	                            && typeof value[ attrs.groupProperty ] === 'undefined' 
	                            && value[ $scope.tickProperty ] === true 
	                        ) {
	                            tempObj         = {};
	                            angular.forEach( value, function( value1, key1 ) {                                
	                                if ( outputProps.indexOf( key1 ) > -1 ) {                                                                         
	                                    tempObj[ key1 ] = value1;                                    
	                                }
	                            });
	                            var index = $scope.outputModel.push( tempObj );                                                               
	                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
	                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];                                      
	                        }
	                    });         
	                }
	                else {
	                    angular.forEach( $scope.inputModel, function( value, key ) {                    
	                        if ( 
	                            typeof value !== 'undefined' 
	                            && typeof value[ attrs.groupProperty ] === 'undefined' 
	                            && value[ $scope.tickProperty ] === true 
	                        ) {
	                            var temp = angular.copy( value );
	                            var index = $scope.outputModel.push( temp );                                                               
	                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
	                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];                                      
	                        }
	                    });         
	                }
	            }
	
	            // refresh button label
	            $scope.refreshButton = function() {
	
	                $scope.varButtonLabel   = '';                
	                var ctr                 = 0;                  
	
	                // refresh button label...
	                if ( $scope.outputModel.length === 0 ) {
	                    // https://github.com/isteven/angular-multi-select/pull/19                    
	                    $scope.varButtonLabel = $scope.lang.nothingSelected;
	                }
	                else {                
	                    var tempMaxLabels = $scope.outputModel.length;
	                    if ( typeof attrs.maxLabels !== 'undefined' && attrs.maxLabels !== '' ) {
	                        tempMaxLabels = attrs.maxLabels;
	                    }
	
	                    // if max amount of labels displayed..
	                    if ( $scope.outputModel.length > tempMaxLabels ) {
	                        $scope.more = true;
	                    }
	                    else {
	                        $scope.more = false;
	                    }                
	                    
	                    angular.forEach( $scope.inputModel, function( value, key ) {
	                        if ( typeof value !== 'undefined' && value[ attrs.tickProperty ] === true ) {                        
	                            if ( ctr < tempMaxLabels ) {                            
	                                $scope.varButtonLabel += ( $scope.varButtonLabel.length > 0 ? '</div>, <div class="buttonLabel">' : '<div class="buttonLabel">') + $scope.writeLabel( value, 'buttonLabel' );
	                            }
	                            ctr++;
	                        }
	                    });                
	
	                    if ( $scope.more === true ) {
	                        // https://github.com/isteven/angular-multi-select/pull/16
	                        if (tempMaxLabels > 0) {
	                            $scope.varButtonLabel += ', ... ';
	                        }
	                        $scope.varButtonLabel += '(' + $scope.outputModel.length + ')';                        
	                    }
	                }
	                $scope.varButtonLabel = $sce.trustAsHtml( $scope.varButtonLabel + '<span class="caret"></span>' );                
	            }
	
	            // Check if a checkbox is disabled or enabled. It will check the granular control (disableProperty) and global control (isDisabled)
	            // Take note that the granular control has higher priority.
	            $scope.itemIsDisabled = function( item ) {
	                
	                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {                                        
	                    return true;
	                }
	                else {             
	                    if ( $scope.isDisabled === true ) {                        
	                        return true;
	                    }
	                    else {
	                        return false;
	                    }
	                }
	                
	            }
	
	            // A simple function to parse the item label settings. Used on the buttons and checkbox labels.
	            $scope.writeLabel = function( item, type ) {
	                
	                // type is either 'itemLabel' or 'buttonLabel'
	                var temp    = attrs[ type ].split( ' ' );                    
	                var label   = '';                
	
	                angular.forEach( temp, function( value, key ) {                    
	                    item[ value ] && ( label += '&nbsp;' + value.split( '.' ).reduce( function( prev, current ) {
	                        return prev[ current ]; 
	                    }, item ));        
	                });
	                
	                if ( type.toUpperCase() === 'BUTTONLABEL' ) {                    
	                    return label;
	                }
	                return $sce.trustAsHtml( label );
	            }                                
	
	            // UI operations to show/hide checkboxes based on click event..
	            $scope.toggleCheckboxes = function( e ) {                                    
	                
	                // We grab the button
	                var clickedEl = element.children()[0];
	
	                // Just to make sure.. had a bug where key events were recorded twice
	                angular.element( document ).off( 'click', $scope.externalClickListener );
	                angular.element( document ).off( 'keydown', $scope.keyboardListener );        
	
	                // The idea below was taken from another multi-select directive - https://github.com/amitava82/angular-multiselect 
	                // His version is awesome if you need a more simple multi-select approach.                                
	
	                // close
	                if ( angular.element( checkBoxLayer ).hasClass( 'show' )) {                         
	
	                    angular.element( checkBoxLayer ).removeClass( 'show' );                    
	                    angular.element( clickedEl ).removeClass( 'buttonClicked' );                    
	                    angular.element( document ).off( 'click', $scope.externalClickListener );
	                    angular.element( document ).off( 'keydown', $scope.keyboardListener );                                    
	
	                    // clear the focused element;
	                    $scope.removeFocusStyle( $scope.tabIndex );
	                    if ( typeof formElements[ $scope.tabIndex ] !== 'undefined' ) {
	                        formElements[ $scope.tabIndex ].blur();
	                    }
	
	                    // close callback
	                    $timeout( function() {
	                        $scope.onClose();
	                    }, 0 );
	
	                    // set focus on button again
	                    element.children().children()[ 0 ].focus();
	                } 
	                // open
	                else                 
	                {    
	                    // clear filter
	                    $scope.inputLabel.labelFilter = '';                
	                    $scope.updateFilter();                                
	
	                    helperItems = [];
	                    helperItemsLength = 0;
	
	                    angular.element( checkBoxLayer ).addClass( 'show' );
	                    angular.element( clickedEl ).addClass( 'buttonClicked' );       
	
	                    // Attach change event listener on the input filter. 
	                    // We need this because ng-change is apparently not an event listener.                    
	                    angular.element( document ).on( 'click', $scope.externalClickListener );
	                    angular.element( document ).on( 'keydown', $scope.keyboardListener );  
	
	                    // to get the initial tab index, depending on how many helper elements we have. 
	                    // priority is to always focus it on the input filter                                                                
	                    $scope.getFormElements();
	                    $scope.tabIndex = 0;
	
	                    var helperContainer = angular.element( element[ 0 ].querySelector( '.helperContainer' ) )[0];                
	                    
	                    if ( typeof helperContainer !== 'undefined' ) {
	                        for ( var i = 0; i < helperContainer.getElementsByTagName( 'BUTTON' ).length ; i++ ) {
	                            helperItems[ i ] = helperContainer.getElementsByTagName( 'BUTTON' )[ i ];
	                        }
	                        helperItemsLength = helperItems.length + helperContainer.getElementsByTagName( 'INPUT' ).length;
	                    }
	                    
	                    // focus on the filter element on open. 
	                    if ( element[ 0 ].querySelector( '.inputFilter' ) ) {                        
	                        element[ 0 ].querySelector( '.inputFilter' ).focus();    
	                        $scope.tabIndex = $scope.tabIndex + helperItemsLength - 2;
	                        // blur button in vain
	                        angular.element( element ).children()[ 0 ].blur();
	                    }
	                    // if there's no filter then just focus on the first checkbox item
	                    else {                  
	                        if ( !$scope.isDisabled ) {                        
	                            $scope.tabIndex = $scope.tabIndex + helperItemsLength;
	                            if ( $scope.inputModel.length > 0 ) {
	                                formElements[ $scope.tabIndex ].focus();
	                                $scope.setFocusStyle( $scope.tabIndex );
	                                // blur button in vain
	                                angular.element( element ).children()[ 0 ].blur();
	                            }                            
	                        }
	                    }                          
	
	                    // open callback
	                    $scope.onOpen();
	                }                            
	            }
	            
	            // handle clicks outside the button / multi select layer
	            $scope.externalClickListener = function( e ) {                   
	
	                var targetsArr = element.find( e.target.tagName );
	                for (var i = 0; i < targetsArr.length; i++) {                                        
	                    if ( e.target == targetsArr[i] ) {
	                        return;
	                    }
	                }
	
	                angular.element( checkBoxLayer.previousSibling ).removeClass( 'buttonClicked' );                    
	                angular.element( checkBoxLayer ).removeClass( 'show' );
	                angular.element( document ).off( 'click', $scope.externalClickListener ); 
	                angular.element( document ).off( 'keydown', $scope.keyboardListener );                
	                
	                // close callback                
	                $timeout( function() {
	                    $scope.onClose();
	                }, 0 );
	
	                // set focus on button again
	                element.children().children()[ 0 ].focus();
	            }
	   
	            // select All / select None / reset buttons
	            $scope.select = function( type, e ) {
	
	                var helperIndex = helperItems.indexOf( e.target );
	                $scope.tabIndex = helperIndex;
	
	                switch( type.toUpperCase() ) {
	                    case 'ALL':
	                        angular.forEach( $scope.filteredModel, function( value, key ) {                            
	                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                                
	                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                
	                                    value[ $scope.tickProperty ] = true;
	                                }
	                            }
	                        });                            
	                        $scope.refreshOutputModel();                                    
	                        $scope.refreshButton();                                                  
	                        $scope.onSelectAll();                                                
	                        break;
	                    case 'NONE':
	                        angular.forEach( $scope.filteredModel, function( value, key ) {
	                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                        
	                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {                                
	                                    value[ $scope.tickProperty ] = false;
	                                }
	                            }
	                        });               
	                        $scope.refreshOutputModel();                                    
	                        $scope.refreshButton();                                                                          
	                        $scope.onSelectNone();                        
	                        break;
	                    case 'RESET':            
	                        angular.forEach( $scope.filteredModel, function( value, key ) {                            
	                            if ( typeof value[ attrs.groupProperty ] === 'undefined' && typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {                        
	                                var temp = value[ $scope.indexProperty ];                                
	                                value[ $scope.tickProperty ] = $scope.backUp[ temp ][ $scope.tickProperty ];
	                            }
	                        });               
	                        $scope.refreshOutputModel();                                    
	                        $scope.refreshButton();                                                                          
	                        $scope.onReset();                        
	                        break;
	                    case 'CLEAR':
	                        $scope.tabIndex = $scope.tabIndex + 1;
	                        $scope.onClear();    
	                        break;
	                    case 'FILTER':                        
	                        $scope.tabIndex = helperItems.length - 1;
	                        break;
	                    default:                        
	                }                                                                                 
	            }            
	
	            // just to create a random variable name                
	            function genRandomString( length ) {                
	                var possible    = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
	                var temp        = '';
	                for( var i=0; i < length; i++ ) {
	                     temp += possible.charAt( Math.floor( Math.random() * possible.length ));
	                }
	                return temp;
	            }
	
	            // count leading spaces
	            $scope.prepareGrouping = function() {
	                var spacing     = 0;                                                
	                angular.forEach( $scope.filteredModel, function( value, key ) {
	                    value[ $scope.spacingProperty ] = spacing;                    
	                    if ( value[ attrs.groupProperty ] === true ) {
	                        spacing+=2;
	                    }                    
	                    else if ( value[ attrs.groupProperty ] === false ) {
	                        spacing-=2;
	                    }                 
	                });
	            }
	
	            // prepare original index
	            $scope.prepareIndex = function() {
	                var ctr = 0;
	                angular.forEach( $scope.filteredModel, function( value, key ) {
	                    value[ $scope.indexProperty ] = ctr;
	                    ctr++;
	                });
	            }
	
	            // navigate using up and down arrow
	            $scope.keyboardListener = function( e ) { 
	                
	                var key = e.keyCode ? e.keyCode : e.which;      
	                var isNavigationKey = false;                                                
	
	                // ESC key (close)
	                if ( key === 27 ) {
	                    e.preventDefault();                   
	                    e.stopPropagation();
	                    $scope.toggleCheckboxes( e );
	                }                    
	                
	                
	                // next element ( tab, down & right key )                    
	                else if ( key === 40 || key === 39 || ( !e.shiftKey && key == 9 ) ) {                    
	                    
	                    isNavigationKey = true;
	                    prevTabIndex = $scope.tabIndex; 
	                    $scope.tabIndex++;                         
	                    if ( $scope.tabIndex > formElements.length - 1 ) {
	                        $scope.tabIndex = 0;
	                        prevTabIndex = formElements.length - 1; 
	                    }                                                            
	                    while ( formElements[ $scope.tabIndex ].disabled === true ) {
	                        $scope.tabIndex++;
	                        if ( $scope.tabIndex > formElements.length - 1 ) {
	                            $scope.tabIndex = 0;                            
	                        }                                                                                    
	                        if ( $scope.tabIndex === prevTabIndex ) {
	                            break;
	                        }
	                    }              
	                }
	                  
	                // prev element ( shift+tab, up & left key )
	                else if ( key === 38 || key === 37 || ( e.shiftKey && key == 9 ) ) { 
	                    isNavigationKey = true;
	                    prevTabIndex = $scope.tabIndex; 
	                    $scope.tabIndex--;                              
	                    if ( $scope.tabIndex < 0 ) {
	                        $scope.tabIndex = formElements.length - 1;
	                        prevTabIndex = 0;
	                    }                                         
	                    while ( formElements[ $scope.tabIndex ].disabled === true ) {                        
	                        $scope.tabIndex--;
	                        if ( $scope.tabIndex === prevTabIndex ) {
	                            break;
	                        }                                            
	                        if ( $scope.tabIndex < 0 ) {
	                            $scope.tabIndex = formElements.length - 1;
	                        }                             
	                    }                                                     
	                }                    
	
	                if ( isNavigationKey === true ) {                                         
	                    
	                    e.preventDefault();
	
	                    // set focus on the checkbox                    
	                    formElements[ $scope.tabIndex ].focus();    
	                    var actEl = document.activeElement;                     
	                    
	                    if ( actEl.type.toUpperCase() === 'CHECKBOX' ) {                                                   
	                        $scope.setFocusStyle( $scope.tabIndex );
	                        $scope.removeFocusStyle( prevTabIndex );
	                    }                    
	                    else {
	                        $scope.removeFocusStyle( prevTabIndex );
	                        $scope.removeFocusStyle( helperItemsLength );
	                        $scope.removeFocusStyle( formElements.length - 1 );
	                    } 
	                }                
	
	                isNavigationKey = false;
	            }
	
	            // set (add) CSS style on selected row
	            $scope.setFocusStyle = function( tabIndex ) {                                
	                angular.element( formElements[ tabIndex ] ).parent().parent().parent().addClass( 'multiSelectFocus' );                        
	            }
	
	            // remove CSS style on selected row
	            $scope.removeFocusStyle = function( tabIndex ) {                
	                angular.element( formElements[ tabIndex ] ).parent().parent().parent().removeClass( 'multiSelectFocus' );
	            }
	
	            /*********************
	             *********************             
	             *
	             * 1) Initializations
	             *
	             *********************
	             *********************/
	
	            // attrs to $scope - attrs-$scope - attrs - $scope
	            // Copy some properties that will be used on the template. They need to be in the $scope.
	            $scope.groupProperty    = attrs.groupProperty;   
	            $scope.tickProperty     = attrs.tickProperty;
	            $scope.directiveId      = attrs.directiveId;
	            
	            // Unfortunately I need to add these grouping properties into the input model
	            var tempStr = genRandomString( 5 );
	            $scope.indexProperty = 'idx_' + tempStr;
	            $scope.spacingProperty = 'spc_' + tempStr;         
	
	            // set orientation css            
	            if ( typeof attrs.orientation !== 'undefined' ) {
	
	                if ( attrs.orientation.toUpperCase() === 'HORIZONTAL' ) {                    
	                    $scope.orientationH = true;
	                    $scope.orientationV = false;
	                }
	                else 
	                {
	                    $scope.orientationH = false;
	                    $scope.orientationV = true;
	                }
	            }            
	
	            // get elements required for DOM operation
	            checkBoxLayer = element.children().children().next()[0];
	
	            // set max-height property if provided
	            if ( typeof attrs.maxHeight !== 'undefined' ) {                
	                var layer = element.children().children().children()[0];
	                angular.element( layer ).attr( "style", "height:" + attrs.maxHeight + "; overflow-y:scroll;" );                                
	            }
	
	            // some flags for easier checking            
	            for ( var property in $scope.helperStatus ) {
	                if ( $scope.helperStatus.hasOwnProperty( property )) {                    
	                    if ( 
	                        typeof attrs.helperElements !== 'undefined' 
	                        && attrs.helperElements.toUpperCase().indexOf( property.toUpperCase() ) === -1 
	                    ) {
	                        $scope.helperStatus[ property ] = false;
	                    }
	                }
	            }
	            if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' )  {
	                $scope.helperStatus[ 'all' ] = false;
	                $scope.helperStatus[ 'none' ] = false;
	            }
	
	            // helper button icons.. I guess you can use html tag here if you want to. 
	            $scope.icon        = {};            
	            $scope.icon.selectAll  = '&#10003;';    // a tick icon
	            $scope.icon.selectNone = '&times;';     // x icon
	            $scope.icon.reset      = '&#8630;';     // undo icon            
	            // this one is for the selected items
	            $scope.icon.tickMark   = '&#10003;';    // a tick icon 
	
	            // configurable button labels                       
	            if ( typeof attrs.translation !== 'undefined' ) {
	                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;' + $scope.translation.selectAll );
	                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;' + $scope.translation.selectNone );
	                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;' + $scope.translation.reset );
	                $scope.lang.search          = $scope.translation.search;                
	                $scope.lang.nothingSelected = $sce.trustAsHtml( $scope.translation.nothingSelected );                
	            }
	            else {
	                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;Select All' );                
	                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;Select None' );
	                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;Reset' );
	                $scope.lang.search          = 'Search...';
	                $scope.lang.nothingSelected = 'None Selected';                
	            }
	            $scope.icon.tickMark = $sce.trustAsHtml( $scope.icon.tickMark );
	                
	            // min length of keyword to trigger the filter function
	            if ( typeof attrs.MinSearchLength !== 'undefined' && parseInt( attrs.MinSearchLength ) > 0 ) {
	                vMinSearchLength = Math.floor( parseInt( attrs.MinSearchLength ) );
	            }
	
	            /*******************************************************
	             *******************************************************
	             *
	             * 2) Logic starts here, initiated by watch 1 & watch 2
	             *
	             *******************************************************
	             *******************************************************/
	            
	            // watch1, for changes in input model property
	            // updates multi-select when user select/deselect a single checkbox programatically
	            // https://github.com/isteven/angular-multi-select/issues/8            
	            $scope.$watch( 'inputModel' , function( newVal ) {                                 
	                if ( newVal ) {                            
	                    $scope.refreshOutputModel();                                    
	                    $scope.refreshButton();                                                  
	                }
	            }, true );
	            
	            // watch2 for changes in input model as a whole
	            // this on updates the multi-select when a user load a whole new input-model. We also update the $scope.backUp variable
	            $scope.$watch( 'inputModel' , function( newVal ) {  
	                if ( newVal ) {
	                    $scope.backUp = angular.copy( $scope.inputModel );    
	                    $scope.updateFilter();
	                    $scope.prepareGrouping();
	                    $scope.prepareIndex();                                                              
	                    $scope.refreshOutputModel();                
	                    $scope.refreshButton();                                                                                                                 
	                }
	            });                        
	
	            // watch for changes in directive state (disabled or enabled)
	            $scope.$watch( 'isDisabled' , function( newVal ) {         
	                $scope.isDisabled = newVal;                               
	            });            
	            
	            // this is for touch enabled devices. We don't want to hide checkboxes on scroll. 
	            var onTouchStart = function( e ) { 
	            	$scope.$apply( function() {
	            		$scope.scrolled = false;
	            	}); 
	            };
	            angular.element( document ).bind( 'touchstart', onTouchStart);
	            var onTouchMove = function( e ) { 
	            	$scope.$apply( function() {
	            		$scope.scrolled = true;                
	            	});
	            };
	            angular.element( document ).bind( 'touchmove', onTouchMove);            
	
	            // unbind document events to prevent memory leaks
	            $scope.$on( '$destroy', function () {
				    angular.element( document ).unbind( 'touchstart', onTouchStart);
	            	angular.element( document ).unbind( 'touchmove', onTouchMove);
	            });
	        }
	    }
	}]).run( [ '$templateCache' , function( $templateCache ) {
	    var template = 
	        '<span class="multiSelect inlineBlock">' +
	            // main button
	            '<button id="{{directiveId}}" type="button"' +                
	                'ng-click="toggleCheckboxes( $event ); refreshSelectedItems(); refreshButton(); prepareGrouping; prepareIndex();"' +
	                'ng-bind-html="varButtonLabel"' +
	                'ng-disabled="disable-button"' +
	            '>' +
	            '</button>' +
	            // overlay layer
	            '<div class="checkboxLayer">' +
	                // container of the helper elements
	                '<div class="helperContainer" ng-if="helperStatus.filter || helperStatus.all || helperStatus.none || helperStatus.reset ">' +
	                    // container of the first 3 buttons, select all, none and reset
	                    '<div class="line" ng-if="helperStatus.all || helperStatus.none || helperStatus.reset ">' +
	                        // select all
	                        '<button type="button" class="helperButton"' +
	                            'ng-disabled="isDisabled"' + 
	                            'ng-if="helperStatus.all"' +
	                            'ng-click="select( \'all\', $event );"' +
	                            'ng-bind-html="lang.selectAll">' +
	                        '</button>'+
	                        // select none
	                        '<button type="button" class="helperButton"' +
	                            'ng-disabled="isDisabled"' + 
	                            'ng-if="helperStatus.none"' +
	                            'ng-click="select( \'none\', $event );"' +
	                            'ng-bind-html="lang.selectNone">' +
	                        '</button>'+
	                        // reset
	                        '<button type="button" class="helperButton reset"' +
	                            'ng-disabled="isDisabled"' + 
	                            'ng-if="helperStatus.reset"' +
	                            'ng-click="select( \'reset\', $event );"' +
	                            'ng-bind-html="lang.reset">'+
	                        '</button>' +
	                    '</div>' +
	                    // the search box
	                    '<div class="line" style="position:relative" ng-if="helperStatus.filter">'+
	                        // textfield                
	                        '<input placeholder="{{lang.search}}" type="text"' +
	                            'ng-click="select( \'filter\', $event )" '+
	                            'ng-model="inputLabel.labelFilter" '+
	                            'ng-change="searchChanged()" class="inputFilter"'+
	                            '/>'+
	                        // clear button
	                        '<button type="button" class="clearButton" ng-click="clearClicked( $event )" >×</button> '+
	                    '</div> '+
	                '</div> '+
	                // selection items
	                '<div class="checkBoxContainer">'+
	                    '<div '+
	                        'ng-repeat="item in filteredModel | filter:removeGroupEndMarker" class="multiSelectItem"'+
	                        'ng-class="{selected: item[ tickProperty ], horizontal: orientationH, vertical: orientationV, multiSelectGroup:item[ groupProperty ], disabled:itemIsDisabled( item )}"'+
	                        'ng-click="syncItems( item, $event, $index );" '+
	                        'ng-mouseleave="removeFocusStyle( tabIndex );"> '+
	                        // this is the spacing for grouped items
	                        '<div class="acol" ng-if="item[ spacingProperty ] > 0" ng-repeat="i in numberToArray( item[ spacingProperty ] ) track by $index">'+                        
	                    '</div>  '+        
	                    '<div class="acol">'+
	                        '<label>'+                                
	                            // input, so that it can accept focus on keyboard click
	                            '<input class="checkbox focusable" type="checkbox" '+
	                                'ng-disabled="itemIsDisabled( item )" '+
	                                'ng-checked="item[ tickProperty ]" '+
	                                'ng-click="syncItems( item, $event, $index )" />'+
	                            // item label using ng-bind-hteml
	                            '<span '+
	                                'ng-class="{disabled:itemIsDisabled( item )}" '+
	                                'ng-bind-html="writeLabel( item, \'itemLabel\' )">'+
	                            '</span>'+
	                        '</label>'+
	                    '</div>'+
	                    // the tick/check mark
	                    '<span class="tickMark" ng-if="item[ groupProperty ] !== true && item[ tickProperty ] === true" ng-bind-html="icon.tickMark"></span>'+
	                '</div>'+
	            '</div>'+
	        '</div>'+
	    '</span>';
		$templateCache.put( 'isteven-multi-select.htm' , template );
	}]); 


/***/ }),
/* 491 */
/***/ (function(module, exports) {

	/*! Copyright (c) 2011 Piotr Rochala (http://rocha.la)
	 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
	 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
	 *
	 * Version: 1.3.8
	 *
	 */
	(function(e){e.fn.extend({slimScroll:function(f){var a=e.extend({width:"auto",height:"250px",size:"7px",color:"#000",position:"right",distance:"1px",start:"top",opacity:.4,alwaysVisible:!1,disableFadeOut:!1,railVisible:!1,railColor:"#333",railOpacity:.2,railDraggable:!0,railClass:"slimScrollRail",barClass:"slimScrollBar",wrapperClass:"slimScrollDiv",allowPageScroll:!1,wheelStep:20,touchScrollStep:200,borderRadius:"7px",railBorderRadius:"7px"},f);this.each(function(){function v(d){if(r){d=d||window.event;
	var c=0;d.wheelDelta&&(c=-d.wheelDelta/120);d.detail&&(c=d.detail/3);e(d.target||d.srcTarget||d.srcElement).closest("."+a.wrapperClass).is(b.parent())&&n(c,!0);d.preventDefault&&!k&&d.preventDefault();k||(d.returnValue=!1)}}function n(d,g,e){k=!1;var f=b.outerHeight()-c.outerHeight();g&&(g=parseInt(c.css("top"))+d*parseInt(a.wheelStep)/100*c.outerHeight(),g=Math.min(Math.max(g,0),f),g=0<d?Math.ceil(g):Math.floor(g),c.css({top:g+"px"}));l=parseInt(c.css("top"))/(b.outerHeight()-c.outerHeight());g=
	l*(b[0].scrollHeight-b.outerHeight());e&&(g=d,d=g/b[0].scrollHeight*b.outerHeight(),d=Math.min(Math.max(d,0),f),c.css({top:d+"px"}));b.scrollTop(g);b.trigger("slimscrolling",~~g);w();p()}function x(){u=Math.max(b.outerHeight()/b[0].scrollHeight*b.outerHeight(),30);c.css({height:u+"px"});var a=u==b.outerHeight()?"none":"block";c.css({display:a})}function w(){x();clearTimeout(B);l==~~l?(k=a.allowPageScroll,C!=l&&b.trigger("slimscroll",0==~~l?"top":"bottom")):k=!1;C=l;u>=b.outerHeight()?k=!0:(c.stop(!0,
	!0).fadeIn("fast"),a.railVisible&&m.stop(!0,!0).fadeIn("fast"))}function p(){a.alwaysVisible||(B=setTimeout(function(){a.disableFadeOut&&r||y||z||(c.fadeOut("slow"),m.fadeOut("slow"))},1E3))}var r,y,z,B,A,u,l,C,k=!1,b=e(this);if(b.parent().hasClass(a.wrapperClass)){var q=b.scrollTop(),c=b.siblings("."+a.barClass),m=b.siblings("."+a.railClass);x();if(e.isPlainObject(f)){if("height"in f&&"auto"==f.height){b.parent().css("height","auto");b.css("height","auto");var h=b.parent().parent().height();b.parent().css("height",
	h);b.css("height",h)}else"height"in f&&(h=f.height,b.parent().css("height",h),b.css("height",h));if("scrollTo"in f)q=parseInt(a.scrollTo);else if("scrollBy"in f)q+=parseInt(a.scrollBy);else if("destroy"in f){c.remove();m.remove();b.unwrap();return}n(q,!1,!0)}}else if(!(e.isPlainObject(f)&&"destroy"in f)){a.height="auto"==a.height?b.parent().height():a.height;q=e("<div></div>").addClass(a.wrapperClass).css({position:"relative",overflow:"hidden",width:a.width,height:a.height});b.css({overflow:"hidden",
	width:a.width,height:a.height});var m=e("<div></div>").addClass(a.railClass).css({width:a.size,height:"100%",position:"absolute",top:0,display:a.alwaysVisible&&a.railVisible?"block":"none","border-radius":a.railBorderRadius,background:a.railColor,opacity:a.railOpacity,zIndex:90}),c=e("<div></div>").addClass(a.barClass).css({background:a.color,width:a.size,position:"absolute",top:0,opacity:a.opacity,display:a.alwaysVisible?"block":"none","border-radius":a.borderRadius,BorderRadius:a.borderRadius,MozBorderRadius:a.borderRadius,
	WebkitBorderRadius:a.borderRadius,zIndex:99}),h="right"==a.position?{right:a.distance}:{left:a.distance};m.css(h);c.css(h);b.wrap(q);b.parent().append(c);b.parent().append(m);a.railDraggable&&c.bind("mousedown",function(a){var b=e(document);z=!0;t=parseFloat(c.css("top"));pageY=a.pageY;b.bind("mousemove.slimscroll",function(a){currTop=t+a.pageY-pageY;c.css("top",currTop);n(0,c.position().top,!1)});b.bind("mouseup.slimscroll",function(a){z=!1;p();b.unbind(".slimscroll")});return!1}).bind("selectstart.slimscroll",
	function(a){a.stopPropagation();a.preventDefault();return!1});m.hover(function(){w()},function(){p()});c.hover(function(){y=!0},function(){y=!1});b.hover(function(){r=!0;w();p()},function(){r=!1;p()});b.bind("touchstart",function(a,b){a.originalEvent.touches.length&&(A=a.originalEvent.touches[0].pageY)});b.bind("touchmove",function(b){k||b.originalEvent.preventDefault();b.originalEvent.touches.length&&(n((A-b.originalEvent.touches[0].pageY)/a.touchScrollStep,!0),A=b.originalEvent.touches[0].pageY)});
	x();"bottom"===a.start?(c.css({top:b.outerHeight()-c.outerHeight()}),n(0,!0)):"top"!==a.start&&(n(e(a.start).position().top,null,!0),a.alwaysVisible||c.hide());window.addEventListener?(this.addEventListener("DOMMouseScroll",v,!1),this.addEventListener("mousewheel",v,!1)):document.attachEvent("onmousewheel",v)}});return this}});e.fn.extend({slimscroll:e.fn.slimScroll})})(jQuery);

/***/ }),
/* 492 */
/***/ (function(module, exports) {

	/*! ngTagsInput v2.0.1 License: MIT */!function(){"use strict";function a(){var a={};return{on:function(b,c){return b.split(" ").forEach(function(b){a[b]||(a[b]=[]),a[b].push(c)}),this},trigger:function(b,c){return angular.forEach(a[b],function(a){a.call(null,c)}),this}}}function b(a,b){return a=a||[],a.length>0&&!angular.isObject(a[0])&&a.forEach(function(c,d){a[d]={},a[d][b]=c}),a}function c(a,b,c){for(var d=null,e=0;e<a.length;e++)if(a[e][c].toLowerCase()===b[c].toLowerCase()){d=a[e];break}return d}function d(a,b,c){var d=b.replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1");return a.replace(new RegExp(d,"gi"),c)}var e={backspace:8,tab:9,enter:13,escape:27,space:32,up:38,down:40,comma:188},f=angular.module("ngTagsInput",[]);f.directive("tagsInput",["$timeout","$document","tagsInputConfig",function(d,f,g){function h(a,b){var d,e,f,g={};return d=function(b){return b[a.displayProperty]},e=function(b,c){b[a.displayProperty]=c},f=function(b){var e=d(b);return e.length>=a.minLength&&e.length<=(a.maxLength||e.length)&&a.allowedTagsPattern.test(e)&&!c(g.items,b,a.displayProperty)},g.items=[],g.addText=function(a){var b={};return e(b,a),g.add(b)},g.add=function(c){var h=d(c).trim();return a.replaceSpacesWithDashes&&(h=h.replace(/\s/g,"-")),e(c,h),f(c)?(g.items.push(c),b.trigger("tag-added",{$tag:c})):b.trigger("invalid-tag",{$tag:c}),c},g.remove=function(a){var c=g.items.splice(a,1)[0];return b.trigger("tag-removed",{$tag:c}),c},g.removeLast=function(){var b,c=g.items.length-1;return a.enableEditingLastTag||g.selected?(g.selected=null,b=g.remove(c)):g.selected||(g.selected=g.items[c]),b},g}return{restrict:"E",require:"ngModel",scope:{tags:"=ngModel",onTagAdded:"&",onTagRemoved:"&"},replace:!1,transclude:!0,templateUrl:"ngTagsInput/tags-input.html",controller:["$scope","$attrs","$element",function(b,c,d){g.load("tagsInput",b,c,{placeholder:[String,"Add a tag"],tabindex:[Number],removeTagSymbol:[String,String.fromCharCode(215)],replaceSpacesWithDashes:[Boolean,!0],minLength:[Number,3],maxLength:[Number],addOnEnter:[Boolean,!0],addOnSpace:[Boolean,!1],addOnComma:[Boolean,!0],addOnBlur:[Boolean,!0],allowedTagsPattern:[RegExp,/.+/],enableEditingLastTag:[Boolean,!1],minTags:[Number],maxTags:[Number],displayProperty:[String,"text"],allowLeftoverText:[Boolean,!1],addFromAutocompleteOnly:[Boolean,!1]}),b.events=new a,b.tagList=new h(b.options,b.events),this.registerAutocomplete=function(){var a=d.find("input");return a.on("keydown",function(a){b.events.trigger("input-keydown",a)}),{addTag:function(a){return b.tagList.add(a)},focusInput:function(){a[0].focus()},getTags:function(){return b.tags},getOptions:function(){return b.options},on:function(a,c){return b.events.on(a,c),this}}}}],link:function(a,c,g,h){var i=[e.enter,e.comma,e.space,e.backspace],j=a.tagList,k=a.events,l=a.options,m=c.find("input");k.on("tag-added",a.onTagAdded).on("tag-removed",a.onTagRemoved).on("tag-added",function(){a.newTag.text=""}).on("tag-added tag-removed",function(){h.$setViewValue(a.tags)}).on("invalid-tag",function(){a.newTag.invalid=!0}).on("input-change",function(){j.selected=null,a.newTag.invalid=null}).on("input-focus",function(){h.$setValidity("leftoverText",!0)}).on("input-blur",function(){l.addFromAutocompleteOnly||(l.addOnBlur&&j.addText(a.newTag.text),h.$setValidity("leftoverText",l.allowLeftoverText?!0:!a.newTag.text))}),a.newTag={text:"",invalid:null},a.getDisplayText=function(a){return a[l.displayProperty].trim()},a.track=function(a){return a[l.displayProperty]},a.newTagChange=function(){k.trigger("input-change",a.newTag.text)},a.$watch("tags",function(c){a.tags=b(c,l.displayProperty),j.items=a.tags}),a.$watch("tags.length",function(a){h.$setValidity("maxTags",angular.isUndefined(l.maxTags)||a<=l.maxTags),h.$setValidity("minTags",angular.isUndefined(l.minTags)||a>=l.minTags)}),m.on("keydown",function(b){if(!b.isImmediatePropagationStopped||!b.isImmediatePropagationStopped()){var c,d,f=b.keyCode,g=b.shiftKey||b.altKey||b.ctrlKey||b.metaKey,h={};if(!g&&-1!==i.indexOf(f))if(h[e.enter]=l.addOnEnter,h[e.comma]=l.addOnComma,h[e.space]=l.addOnSpace,c=!l.addFromAutocompleteOnly&&h[f],d=!c&&f===e.backspace&&0===a.newTag.text.length,c)j.addText(a.newTag.text),a.$apply(),b.preventDefault();else if(d){var k=j.removeLast();k&&l.enableEditingLastTag&&(a.newTag.text=k[l.displayProperty]),a.$apply(),b.preventDefault()}}}).on("focus",function(){a.hasFocus||(a.hasFocus=!0,k.trigger("input-focus"),a.$apply())}).on("blur",function(){d(function(){var b=f.prop("activeElement"),d=b===m[0],e=c[0].contains(b);(d||!e)&&(a.hasFocus=!1,k.trigger("input-blur"))})}),c.find("div").on("click",function(){m[0].focus()})}}}]),f.directive("autoComplete",["$document","$timeout","$sce","tagsInputConfig",function(a,f,g,h){function i(a,d){var e,g,h,i={};return g=function(a,b){return a.filter(function(a){return!c(b,a,d.tagsInput.displayProperty)})},i.reset=function(){h=null,i.items=[],i.visible=!1,i.index=-1,i.selected=null,i.query=null,f.cancel(e)},i.show=function(){i.selected=null,i.visible=!0},i.load=function(c,j){return c.length<d.minLength?void i.reset():(f.cancel(e),void(e=f(function(){i.query=c;var e=a({$query:c});h=e,e.then(function(a){e===h&&(a=b(a.data||a,d.tagsInput.displayProperty),a=g(a,j),i.items=a.slice(0,d.maxResultsToShow),i.items.length>0?i.show():i.reset())})},d.debounceDelay,!1)))},i.selectNext=function(){i.select(++i.index)},i.selectPrior=function(){i.select(--i.index)},i.select=function(a){0>a?a=i.items.length-1:a>=i.items.length&&(a=0),i.index=a,i.selected=i.items[a]},i.reset(),i}function j(a){return a.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")}return{restrict:"E",require:"^tagsInput",scope:{source:"&"},templateUrl:"ngTagsInput/auto-complete.html",link:function(b,c,f,k){var l,m,n,o,p,q=[e.enter,e.tab,e.escape,e.up,e.down];h.load("autoComplete",b,f,{debounceDelay:[Number,100],minLength:[Number,3],highlightMatchedText:[Boolean,!0],maxResultsToShow:[Number,10]}),n=b.options,m=k.registerAutocomplete(),n.tagsInput=m.getOptions(),l=new i(b.source,n),o=function(a){return a[n.tagsInput.displayProperty]},b.suggestionList=l,b.addSuggestion=function(){var a=!1;return l.selected&&(m.addTag(l.selected),l.reset(),m.focusInput(),a=!0),a},b.highlight=function(a){var b=o(a);return b=j(b),n.highlightMatchedText&&(b=d(b,j(l.query),"<em>$&</em>")),g.trustAsHtml(b)},b.track=function(a){return o(a)},m.on("tag-added invalid-tag",function(){l.reset()}).on("input-change",function(a){a?l.load(a,m.getTags()):l.reset()}).on("input-keydown",function(a){var c,d;if(-1!==q.indexOf(a.keyCode)){var f=!1;a.stopImmediatePropagation=function(){f=!0,a.stopPropagation()},a.isImmediatePropagationStopped=function(){return f},l.visible&&(c=a.keyCode,d=!1,c===e.down?(l.selectNext(),d=!0):c===e.up?(l.selectPrior(),d=!0):c===e.escape?(l.reset(),d=!0):(c===e.enter||c===e.tab)&&(d=b.addSuggestion()),d&&(a.preventDefault(),a.stopImmediatePropagation(),b.$apply()))}}).on("input-blur",function(){l.reset()}),p=function(){l.visible&&(l.reset(),b.$apply())},a.on("click",p),b.$on("$destroy",function(){a.off("click",p)})}}}]),f.directive("tiTranscludeAppend",function(){return function(a,b,c,d,e){e(function(a){b.append(a)})}}),f.directive("tiAutosize",function(){return{restrict:"A",require:"ngModel",link:function(a,b,c,d){var e,f,g=3;e=angular.element('<span class="input"></span>'),e.css("display","none").css("visibility","hidden").css("width","auto").css("white-space","pre"),b.parent().append(e),f=function(a){var d,f=a;return angular.isString(f)&&0===f.length&&(f=c.placeholder),f&&(e.text(f),e.css("display",""),d=e.prop("offsetWidth"),e.css("display","none")),b.css("width",d?d+g+"px":""),a},d.$parsers.unshift(f),d.$formatters.unshift(f),c.$observe("placeholder",function(a){d.$modelValue||f(a)})}}}),f.provider("tagsInputConfig",function(){var a={},b={};this.setDefaults=function(b,c){return a[b]=c,this},this.setActiveInterpolation=function(a,c){return b[a]=c,this},this.$get=["$interpolate",function(c){var d={};return d[String]=function(a){return a},d[Number]=function(a){return parseInt(a,10)},d[Boolean]=function(a){return"true"===a.toLowerCase()},d[RegExp]=function(a){return new RegExp(a)},{load:function(e,f,g,h){f.options={},angular.forEach(h,function(h,i){var j,k,l,m,n;j=h[0],k=h[1],l=d[j],m=function(){var b=a[e]&&a[e][i];return angular.isDefined(b)?b:k},n=function(a){f.options[i]=a?l(a):m()},b[e]&&b[e][i]?g.$observe(i,function(a){n(a)}):n(g[i]&&c(g[i])(f.$parent))})}}}]}),f.run(["$templateCache",function(a){a.put("ngTagsInput/tags-input.html",'<div class="host" tabindex="-1" ti-transclude-append=""><div class="tags" ng-class="{focused: hasFocus}"><ul class="tag-list"><li class="tag-item" ng-repeat="tag in tagList.items track by track(tag)" ng-class="{ selected: tag == tagList.selected }"><span>{{getDisplayText(tag)}}</span> <a class="remove-button" ng-click="tagList.remove($index)">{{options.removeTagSymbol}}</a></li></ul><input class="input" placeholder="{{options.placeholder}}" tabindex="{{options.tabindex}}" ng-model="newTag.text" ng-change="newTagChange()" ng-trim="false" ng-class="{\'invalid-tag\': newTag.invalid}" ti-autosize=""></div></div>'),a.put("ngTagsInput/auto-complete.html",'<div class="autocomplete" ng-show="suggestionList.visible"><ul class="suggestion-list"><li class="suggestion-item" ng-repeat="item in suggestionList.items track by track(item)" ng-class="{selected: item == suggestionList.selected}" ng-click="addSuggestion()" ng-mouseenter="suggestionList.select($index)" ng-bind-html="highlight(item)"></li></ul></div>')}])}();

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(a){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(103)], __WEBPACK_AMD_DEFINE_RESULT__ = function(a){return function(){function b(a,b,c){return o({type:u.error,iconClass:p().iconClasses.error,message:a,optionsOverride:c,title:b})}function c(b,c){return b||(b=p()),r=a("#"+b.containerId),r.length?r:(c&&(r=l(b)),r)}function d(a,b,c){return o({type:u.info,iconClass:p().iconClasses.info,message:a,optionsOverride:c,title:b})}function e(a){s=a}function f(a,b,c){return o({type:u.success,iconClass:p().iconClasses.success,message:a,optionsOverride:c,title:b})}function g(a,b,c){return o({type:u.warning,iconClass:p().iconClasses.warning,message:a,optionsOverride:c,title:b})}function h(a){var b=p();r||c(b),k(a,b)||j(b)}function i(b){var d=p();return r||c(d),b&&0===a(":focus",b).length?void q(b):void(r.children().length&&r.remove())}function j(b){for(var c=r.children(),d=c.length-1;d>=0;d--)k(a(c[d]),b)}function k(b,c){return b&&0===a(":focus",b).length?(b[c.hideMethod]({duration:c.hideDuration,easing:c.hideEasing,complete:function(){q(b)}}),!0):!1}function l(b){return r=a("<div/>").attr("id",b.containerId).addClass(b.positionClass).attr("aria-live","polite").attr("role","alert"),r.appendTo(a(b.target)),r}function m(){return{tapToDismiss:!0,toastClass:"toast",containerId:"toast-container",debug:!1,showMethod:"fadeIn",showDuration:300,showEasing:"swing",onShown:void 0,hideMethod:"fadeOut",hideDuration:1e3,hideEasing:"swing",onHidden:void 0,extendedTimeOut:1e3,iconClasses:{error:"toast-error",info:"toast-info",success:"toast-success",warning:"toast-warning"},iconClass:"toast-info",positionClass:"toast-top-right",timeOut:5e3,titleClass:"toast-title",messageClass:"toast-message",target:"body",closeHtml:"<button>&times;</button>",newestOnTop:!0}}function n(a){s&&s(a)}function o(b){function d(b){return!a(":focus",j).length||b?j[g.hideMethod]({duration:g.hideDuration,easing:g.hideEasing,complete:function(){q(j),g.onHidden&&"hidden"!==o.state&&g.onHidden(),o.state="hidden",o.endTime=new Date,n(o)}}):void 0}function e(){(g.timeOut>0||g.extendedTimeOut>0)&&(i=setTimeout(d,g.extendedTimeOut))}function f(){clearTimeout(i),j.stop(!0,!0)[g.showMethod]({duration:g.showDuration,easing:g.showEasing})}var g=p(),h=b.iconClass||g.iconClass;"undefined"!=typeof b.optionsOverride&&(g=a.extend(g,b.optionsOverride),h=b.optionsOverride.iconClass||h),t++,r=c(g,!0);var i=null,j=a("<div/>"),k=a("<div/>"),l=a("<div/>"),m=a(g.closeHtml),o={toastId:t,state:"visible",startTime:new Date,options:g,map:b};return b.iconClass&&j.addClass(g.toastClass).addClass(h),b.title&&(k.append(b.title).addClass(g.titleClass),j.append(k)),b.message&&(l.append(b.message).addClass(g.messageClass),j.append(l)),g.closeButton&&(m.addClass("toast-close-button").attr("role","button"),j.prepend(m)),j.hide(),g.newestOnTop?r.prepend(j):r.append(j),j[g.showMethod]({duration:g.showDuration,easing:g.showEasing,complete:g.onShown}),g.timeOut>0&&(i=setTimeout(d,g.timeOut)),j.hover(f,e),!g.onclick&&g.tapToDismiss&&j.click(d),g.closeButton&&m&&m.click(function(a){a.stopPropagation?a.stopPropagation():void 0!==a.cancelBubble&&a.cancelBubble!==!0&&(a.cancelBubble=!0),d(!0)}),g.onclick&&j.click(function(){g.onclick(),d()}),n(o),g.debug&&console&&console.log(o),j}function p(){return a.extend({},m(),v.options)}function q(a){r||(r=c()),a.is(":visible")||(a.remove(),a=null,0===r.children().length&&r.remove())}var r,s,t=0,u={error:"error",info:"info",success:"success",warning:"warning"},v={clear:h,remove:i,error:b,getContainer:c,info:d,options:{},subscribe:e,success:f,version:"2.0.3",warning:g};return v}()}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}(__webpack_require__(1244));

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(992).enable();
	  window.Promise = __webpack_require__(991);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(1245);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(990);


/***/ }),
/* 495 */
/***/ (function(module, exports) {

	/** 
	* @license ng-slider - v2.2.6
	* (c) 2013 Julien VALERY https://github.com/darul75/ng-slider
	* License: MIT 
	**/
	!function(a){"use strict";a.module("ngSlider",[]).directive("slider",["$compile","$templateCache","$timeout","$window","slider",function(b,c,d,e,f){return{restrict:"AE",require:"?ngModel",scope:{options:"=",ngDisabled:"="},priority:1,link:function(g,h,i,j){function k(){a.element(e).bind("resize",function(){g.slider.onresize()})}if(j){if(!g.options)throw new Error('You must provide a value for "options" attribute.');a.isString(g.options)&&(g.options=a.toJson(g.options)),g.mainSliderClass="jslider",g.mainSliderClass+=g.options.skin?" jslider_"+g.options.skin:" ",g.mainSliderClass+=g.options.vertical?" vertical ":"",g.mainSliderClass+=g.options.css?" sliderCSS":"",h.after(b(c.get("ng-slider/slider-bar.tmpl.html"))(g,function(a,b){b.tmplElt=a}));var l=!1,m=function(){g.from=""+g.options.from,g.to=""+g.options.to,g.options.calculate&&"function"==typeof g.options.calculate&&(g.from=g.options.calculate(g.from),g.to=g.options.calculate(g.to));var b={from:g.options.from,to:g.options.to,step:g.options.step,smooth:g.options.smooth,limits:g.options.smooth,round:g.options.round||!1,value:j.$viewValue,dimension:"",scale:g.options.scale,modelLabels:g.options.modelLabels,vertical:g.options.vertical,css:g.options.css,realtime:g.options.realtime,cb:n,threshold:g.options.threshold};b.calculate=g.options.calculate||void 0,b.onstatechange=g.options.onstatechange||void 0,g.slider=g.slider?g.slider.init(h,g.tmplElt,b):p(h,g.tmplElt,b),l||k();var c=g.tmplElt.find("div")[7];a.element(c).html(g.slider.generateScale()),g.slider.drawScale(c),g.ngDisabled&&o(g.ngDisabled),l=!0};j.$render=function(){(j.$viewValue||0===j.$viewValue)&&("number"==typeof j.$viewValue&&(j.$viewValue=""+j.$viewValue),j.$viewValue.split(";")[1]||(g.mainSliderClass+=" jslider-single"),g.slider&&(g.slider.getPointers()[0].set(j.$viewValue.split(";")[0],!0),j.$viewValue.split(";")[1]&&g.slider.getPointers()[1].set(j.$viewValue.split(";")[1],!0)))};var n=function(a,b){g.disabled||(g.$apply(function(){j.$setViewValue(a)}),g.options.callback&&g.options.callback(a,b))};g.$watch("options",function(){d(function(){m()})},!0);var o=function(a){g.disabled=a,g.slider&&(g.tmplElt.toggleClass("disabled"),g.slider.disable(a))};g.$watch("ngDisabled",function(a){o(a)});var p=function(a,b,c){return new f(a,b,c)}}}}}]).config(function(){}).run(function(){})}(angular),function(a){"use strict";a.module("ngSlider").constant("sliderConstants",{SLIDER:{settings:{from:1,to:40,step:1,smooth:!0,limits:!1,round:!1,value:"3",dimension:"",vertical:!1,calculate:!1,onstatechange:!1,callback:!1,realtime:!1},className:"jslider",selector:".jslider-",css:{visible:{visibility:"visible"},hidden:{visibility:"hidden"}}},EVENTS:{}})}(angular),function(a){"use strict";a.module("ngSlider").factory("sliderUtils",["$window",function(a){return{offset:function(a){var b=a[0],c=0,d=0,e=document.documentElement||document.body,f=window.pageXOffset||e.scrollLeft,g=window.pageYOffset||e.scrollTop;return c=b.getBoundingClientRect().left+f,d=b.getBoundingClientRect().top+g,{left:c,top:d}},browser:function(){var b=a.navigator.userAgent,c={mozilla:/mozilla/i,chrome:/chrome/i,safari:/safari/i,firefox:/firefox/i,ie:/internet explorer/i};for(var d in c)if(c[d].test(b))return d;return"unknown"}}}])}(angular),function(a){"use strict";a.module("ngSlider").factory("sliderDraggable",["sliderUtils",function(b){function c(){this._init.apply(this,arguments)}return c.prototype.oninit=function(){},c.prototype.events=function(){},c.prototype.onmousedown=function(){this.ptr.css({position:"absolute"})},c.prototype.onmousemove=function(a,b,c){this.ptr.css({left:b,top:c})},c.prototype.onmouseup=function(){},c.prototype.isDefault={drag:!1,clicked:!1,toclick:!0,mouseup:!1},c.prototype._init=function(){if(arguments.length>0){if(this.ptr=arguments[0],this.parent=arguments[2],!this.ptr)return;this.is={},a.extend(this.is,this.isDefault);var c=b.offset(this.ptr);this.d={left:c.left,top:c.top,width:this.ptr[0].clientWidth,height:this.ptr[0].clientHeight},this.oninit.apply(this,arguments),this._events()}},c.prototype._getPageCoords=function(a){return a.targetTouches&&a.targetTouches[0]?{x:a.targetTouches[0].pageX,y:a.targetTouches[0].pageY}:{x:a.pageX,y:a.pageY}},c.prototype._bindEvent=function(a,b,c){this.supportTouches_?a[0].addEventListener(this.events_[b],c,!1):a.bind(this.events_[b],c)},c.prototype._events=function(){var b=this;this.supportTouches_="ontouchend"in document,this.events_={click:this.supportTouches_?"touchstart":"click",down:this.supportTouches_?"touchstart":"mousedown",move:this.supportTouches_?"touchmove":"mousemove",up:this.supportTouches_?"touchend":"mouseup",mousedown:(this.supportTouches_,"mousedown")};var c=a.element(window.document);this._bindEvent(c,"move",function(a){b.is.drag&&(a.stopPropagation(),a.preventDefault(),b.parent.disabled||b._mousemove(a))}),this._bindEvent(c,"down",function(a){b.is.drag&&(a.stopPropagation(),a.preventDefault())}),this._bindEvent(c,"up",function(a){b._mouseup(a)}),this._bindEvent(this.ptr,"down",function(a){return b._mousedown(a),!1}),this._bindEvent(this.ptr,"up",function(a){b._mouseup(a)}),this.events()},c.prototype._mousedown=function(b){this.is.drag=!0,this.is.clicked=!1,this.is.mouseup=!1;var c=this._getPageCoords(b);this.cx=c.x-this.ptr[0].offsetLeft,this.cy=c.y-this.ptr[0].offsetTop,a.extend(this.d,{left:c.x,top:c.y,width:this.ptr[0].clientWidth,height:this.ptr[0].clientHeight}),this.outer&&this.outer.get(0)&&this.outer.css({height:Math.max(this.outer.height(),$(document.body).height()),overflow:"hidden"}),this.onmousedown(b)},c.prototype._mousemove=function(a){this.is.toclick=!1;var b=this._getPageCoords(a);this.onmousemove(a,b.x-this.cx,b.y-this.cy)},c.prototype._mouseup=function(a){if(this.is.drag){this.is.drag=!1;var c=b.browser();this.outer&&this.outer.get(0)&&(this.outer.css("mozilla"===c?{overflow:"hidden"}:{overflow:"visible"}),this.outer.css({height:"auto"})),this.onmouseup(a)}},c}])}(angular),function(a){"use strict";a.module("ngSlider").factory("sliderPointer",["sliderDraggable","sliderUtils",function(b,c){function d(){b.apply(this,arguments)}return d.prototype=new b,d.prototype.oninit=function(b,c,d,e){this.uid=c,this.parent=e,this.value={},this.vertical=d,this.settings=a.copy(e.settings),this.normalOrder=this.parent.settings.from<this.parent.settings.to,this.threshold=this.parent.settings.threshold},d.prototype.onmousedown=function(){var a=c.offset(this.parent.domNode),b={left:a.left,top:a.top,width:this.parent.domNode[0].clientWidth,height:this.parent.domNode[0].clientHeight};this._parent={offset:b,width:b.width,height:b.height},this.ptr.addClass("jslider-pointer-hover")},d.prototype.onmousemove=function(b){var c=this._getPageCoords(b);this._set(this.calc(this.vertical?c.y:c.x)),this.settings.realtime&&this.settings.cb&&a.isFunction(this.settings.cb)&&this.allowed&&this.settings.cb.call(this.parent,this.parent.getValue(),!this.is.drag)},d.prototype.onmouseup=function(){this.settings.cb&&a.isFunction(this.settings.cb)&&this.allowed&&this.settings.cb.call(this.parent,this.parent.getValue(),!this.is.drag),this.is.drag||this.ptr.removeClass("jslider-pointer-hover")},d.prototype.limits=function(a){return this.parent.limits(a,this)},d.prototype.calc=function(a){return this.limits(this.vertical?100*(a-this._parent.offset.top)/this._parent.height:100*(a-this._parent.offset.left)/this._parent.width)},d.prototype.set=function(a,b){this.value.origin=this.parent.round(a),this._set(this.parent.valueToPrc(a,this),b)},d.prototype._set=function(a){if(this.allowed=!0,this.value.origin=this.parent.prcToValue(a),this.threshold&&this.parent.o.pointers[1]){var b=this.parent.o.pointers[0].value.origin,c=this.parent.o.pointers[1].value.origin;this.allowed=(this.normalOrder?c-b:b-c)>=this.threshold}if(!this.allowed){var d=this.parent.o.pointers[0===this.uid?1:0];return void(this.value.origin=0===this.uid?this.normalOrder?d.value.origin-this.threshold:d.value.origin+this.threshold:this.normalOrder?d.value.origin+this.threshold:d.value.origin-this.threshold)}this.value.prc=a,this.ptr.css(this.vertical?{top:a+"%",marginTop:-5}:{left:a+"%"}),this.parent.redraw(this)},d}])}(angular),function(a){"use strict";a.module("ngSlider").factory("slider",["sliderPointer","sliderConstants","sliderUtils",function(b,c,d){function e(){return this.init.apply(this,arguments)}return e.prototype.init=function(b,d,e){return this.settings=e,this.inputNode=b,this.inputNode.addClass("ng-hide"),this.settings.interval=this.settings.to-this.settings.from,this.settings.calculate&&a.isFunction(this.settings.calculate)&&(this.nice=this.settings.calculate),this.settings.onstatechange&&a.isFunction(this.settings.onstatechange)&&(this.onstatechange=this.settings.onstatechange),this.css=c.SLIDER.css,this.is={init:!1},this.o={},this.initValue={},this.isAsc=e.from<e.to,this.create(d),this},e.prototype.create=function(c){var e=this;this.domNode=c;var f=this.domNode.find("div"),g=this.domNode.find("i"),h=a.element,i=a.extend,j=a.forEach,k=h(f[1]),l=h(f[2]),m=h(f[5]),n=h(f[6]),o=h(g[0]),p=h(g[1]),q=h(g[2]),r=h(g[3]),s=h(g[4]),t=h(g[5]),u=h(g[6]),v=[k,l],w=d.offset(this.domNode),x={left:w.left,top:w.top,width:this.domNode[0].clientWidth,height:this.domNode[0].clientHeight},y=e.settings.value.split(";");this.sizes={domWidth:this.domNode[0].clientWidth,domHeight:this.domNode[0].clientHeight,domOffset:x},i(this.o,{pointers:{},labels:{0:{o:m},1:{o:n}},limits:{0:a.element(f[3]),1:a.element(f[4])},indicators:{0:r,1:s,2:t,3:u}}),i(this.o.labels[0],{value:this.o.labels[0].o.find("span")}),i(this.o.labels[1],{value:this.o.labels[1].o.find("span")}),this.settings.single=!e.settings.value.split(";")[1],j(v,function(c,f){e.settings=a.copy(e.settings);var g,h,i,j,k,l=y[f];l&&(e.o.pointers[f]=new b(c,f,e.settings.vertical,e),g=y[f-1],h=g?parseInt(g,10):void 0,l=e.settings.round?parseFloat(l):parseInt(l,10),(g&&e.isAsc?h>l:l>h)&&(l=g),i=e.isAsc?l>e.settings.to:l<e.settings.to,j=i?e.settings.to:l,e.o.pointers[f].set(j,!0),k=d.offset(e.o.pointers[f].ptr),e.o.pointers[f].d={left:k.left,top:k.top})}),e.domNode.bind("mousedown",e.clickHandler.apply(e)),this.o.value=h(this.domNode.find("i")[2]),this.is.init=!0,this.settings.css&&(o.css(this.settings.css.background?this.settings.css.background:{}),p.css(this.settings.css.background?this.settings.css.background:{}),this.o.pointers[1]||(r.css(this.settings.css.before?this.settings.css.before:{}),u.css(this.settings.css.after?this.settings.css.after:{})),s.css(this.settings.css["default"]?this.settings.css["default"]:{}),t.css(this.settings.css["default"]?this.settings.css["default"]:{}),q.css(this.settings.css.range?this.settings.css.range:{}),k.css(this.settings.css.pointer?this.settings.css.pointer:{}),l.css(this.settings.css.pointer?this.settings.css.pointer:{})),j(this.o.pointers,function(a){e.redraw(a)})},e.prototype.clickHandler=function(){var b=this,c=function(){var a=b.o.pointers[0].ptr,c=b.o.pointers[1].ptr,e=d.offset(a),f=d.offset(c);b.o.pointers[0].d={left:e.left,top:e.top,width:a[0].clientWidth,height:a[0].clientHeight},b.o.pointers[1].d={left:f.left,top:f.top,width:c[0].clientWidth,height:c[0].clientHeight}};return function(e){if(!b.disabled){var f,g,h,i=b.settings.vertical,j=0,k=d.offset(b.domNode),l=b.o.pointers[0],m=b.o.pointers[1]?b.o.pointers[1]:null,n=e.originalEvent?e.originalEvent:e,o=i?n.pageY:n.pageX,p=i?"top":"left";if(!b.isAsc&&m&&(f=m,m=l,l=f),h={left:k.left,top:k.top,width:b.domNode[0].clientWidth,height:b.domNode[0].clientHeight},g=b.o.pointers[j],m){m.d.width||c();var q=(m.d[p]-l.d[p])/2,r=l.d[p],s=o-r,t=s>q;t&&(g=b.isAsc?m:l)}g._parent={offset:h,width:h.width,height:h.height};var u=l._getPageCoords(e);return g.cx=u.x-g.d.left,g.cy=u.y-g.d.top,g.onmousemove(e,u.x,u.y),g.onmouseup(),a.extend(g.d,{left:u.x,top:u.y}),b.redraw(g),!1}}},e.prototype.disable=function(a){this.disabled=a},e.prototype.nice=function(a){return a},e.prototype.onstatechange=function(){},e.prototype.limits=function(a,b){if(!this.settings.smooth){var c=100*this.settings.step/this.settings.interval;a=Math.round(a/c)*c}var d=this.o.pointers[1-b.uid];return d&&b.uid&&a<d.value.prc&&(a=d.value.prc),d&&!b.uid&&a>d.value.prc&&(a=d.value.prc),0>a&&(a=0),a>100&&(a=100),Math.round(10*a)/10},e.prototype.getPointers=function(){return this.o.pointers},e.prototype.generateScale=function(){if(this.settings.scale&&this.settings.scale.length>0){for(var a="",b=this.settings.scale,c=(100/(b.length-1)).toFixed(2),d=this.settings.vertical?"top":"left",e=0;e<b.length;e++)a+='<span style="'+d+": "+e*c+'%">'+("|"!=b[e]?"<ins>"+b[e]+"</ins>":"")+"</span>";return a}return""},e.prototype.onresize=function(){var b=this;this.sizes={domWidth:this.domNode[0].clientWidth,domHeight:this.domNode[0].clientHeight,domOffset:{left:this.domNode[0].offsetLeft,top:this.domNode[0].offsetTop,width:this.domNode[0].clientWidth,height:this.domNode[0].clientHeight}},a.forEach(this.o.pointers,function(a){b.redraw(a)})},e.prototype.update=function(){this.onresize(),this.drawScale()},e.prototype.drawScale=function(b){a.forEach(a.element(b).find("ins"),function(a){a.style.marginLeft=-a.clientWidth/2})},e.prototype.redraw=function(a){if(!this.is.init)return this.o.pointers[0]&&!this.o.pointers[1]?(this.originValue=this.o.pointers[0].value.prc,this.o.indicators[0].css(this.settings.vertical?{top:0,height:this.o.pointers[0].value.prc+"%"}:{left:0,width:this.o.pointers[0].value.prc+"%"}),this.o.indicators[1].css(this.settings.vertical?{top:this.o.pointers[0].value.prc+"%"}:{left:this.o.pointers[0].value.prc+"%"}),this.o.indicators[3].css(this.settings.vertical?{top:this.o.pointers[0].value.prc+"%"}:{left:this.o.pointers[0].value.prc+"%"})):(this.o.indicators[2].css(this.settings.vertical?{top:this.o.pointers[1].value.prc+"%"}:{left:this.o.pointers[1].value.prc+"%"}),this.o.indicators[0].css(this.settings.vertical?{top:0,height:"0"}:{left:0,width:"0"}),this.o.indicators[3].css(this.settings.vertical?{top:"0",height:"0"}:{left:"0",width:"0"})),!1;this.setValue();var b,c;this.o.pointers[0]&&this.o.pointers[1]&&(b=this.settings.vertical?{top:this.o.pointers[0].value.prc+"%",height:this.o.pointers[1].value.prc-this.o.pointers[0].value.prc+"%"}:{left:this.o.pointers[0].value.prc+"%",width:this.o.pointers[1].value.prc-this.o.pointers[0].value.prc+"%"},this.o.value.css(b),this.o.pointers[0].value.prc===this.o.pointers[1].value.prc&&this.o.pointers[1].ptr.css("z-index",0===this.o.pointers[0].value.prc?"3":"1")),this.o.pointers[0]&&!this.o.pointers[1]&&(c=this.o.pointers[0].value.prc-this.originValue,this.o.indicators[3].css(c>=0?this.settings.vertical?{height:c+"%"}:{width:c+"%"}:this.settings.vertical?{height:0}:{width:0}),this.o.indicators[0].css(this.o.pointers[0].value.prc<this.originValue?this.settings.vertical?{height:this.o.pointers[0].value.prc+"%"}:{width:this.o.pointers[0].value.prc+"%"}:this.settings.vertical?{height:this.originValue+"%"}:{width:this.originValue+"%"}));var d=this.nice(a.value.origin);this.settings.modelLabels&&(d=void 0!==this.settings.modelLabels[d]?this.settings.modelLabels[d]:d),this.o.labels[a.uid].value.html(d),this.redrawLabels(a)},e.prototype.redrawLabels=function(a){function b(a,b,d){b.margin=-b.label/2;var e=c.settings.vertical?c.sizes.domHeight:c.sizes.domWidth;if(c.sizes.domWidth){var f=b.border+b.margin;0>f&&(b.margin-=f),c.sizes.domWidth>0&&b.border+b.label/2>e?(b.margin=0,b.right=!0):b.right=!1}return a.o.css(c.settings.vertical?{top:d+"%",marginLeft:"20px",marginTop:b.margin,bottom:"auto"}:{left:d+"%",marginLeft:b.margin+"px",right:"auto"}),b.right&&c.sizes.domWidth>0&&a.o.css(c.settings.vertical?{top:"auto",bottom:0}:{left:"auto",right:0}),b}var c=this,d=this.o.labels[a.uid],e=a.value.prc,f=0===d.o[0].offsetWidth?7*d.o[0].textContent.length:d.o[0].offsetWidth;this.sizes.domWidth=this.domNode[0].clientWidth,this.sizes.domHeight=this.domNode[0].clientHeight;var g,h,i={label:c.settings.vertical?d.o[0].offsetHeight:f,right:!1,border:e*(c.settings.vertical?this.sizes.domHeight:this.sizes.domWidth)/100},j=0===a.uid?1:0;if(!this.settings.single&&!this.settings.vertical){g=this.o.labels[j],h=this.o.pointers[j];var k=this.o.labels[0],l=this.o.labels[1],m=this.o.pointers[0],n=this.o.pointers[1],o=n.ptr[0].offsetLeft-m.ptr[0].offsetLeft,p=this.nice(h.value.origin);if(k.o.css(this.css.visible),l.o.css(this.css.visible),o+10<k.o[0].offsetWidth+l.o[0].offsetWidth){if(g.o.css(this.css.hidden),g.value.html(p),e=(h.value.prc-e)/2+e,h.value.prc!=a.value.prc){p=this.nice(this.o.pointers[0].value.origin);var q=this.nice(this.o.pointers[1].value.origin);this.settings.modelLabels&&(p=void 0!==this.settings.modelLabels[p]?this.settings.modelLabels[p]:p,q=void 0!==this.settings.modelLabels[q]?this.settings.modelLabels[q]:q),d.value.html(p+"&nbsp;&ndash;&nbsp;"+q),i.label=d.o[0].offsetWidth,i.border=e*r/100}}else g.value.html(p),g.o.css(this.css.visible)}i=b(d,i,e);var r=c.settings.vertical?c.sizes.domHeight:c.sizes.domWidth;if(g){var s=0===d.o[0].offsetWidth?d.o[0].textContent.length/2*7:d.o[0].offsetWidth,t={label:c.settings.vertical?g.o[0].offsetHeight:s,right:!1,border:h.value.prc*this.sizes.domWidth/100};i=b(g,t,h.value.prc)}this.redrawLimits()},e.prototype.redrawLimits=function(){if(this.settings.limits){var b=[!0,!0],c=0;for(var d in this.o.pointers)if(!this.settings.single||0===d){var e=this.o.pointers[d],f=this.o.labels[e.uid],g=f.o[0].offsetLeft-this.sizes.domOffset.left,h=this.o.limits[0];g<h[0].clientWidth&&(b[0]=!1),h=this.o.limits[1],g+f.o[0].clientWidth>this.sizes.domWidth-h[0].clientWidth&&(b[1]=!1)}for(;c<b.length;c++)a.element(this.o.limits[c]).addClass(b[c]?"animate-show":"animate-hidde")}},e.prototype.setValue=function(){var a=this.getValue();this.inputNode.attr("value",a),this.onstatechange.call(this,a,this.inputNode)},e.prototype.getValue=function(){if(!this.is.init)return!1;var b=this,c="";return a.forEach(this.o.pointers,function(a,d){void 0===a.value.prc||isNaN(a.value.prc)||(c+=(d>0?";":"")+b.prcToValue(a.value.prc))}),c},e.prototype.getPrcValue=function(){if(!this.is.init)return!1;var a="";return a},e.prototype.prcToValue=function(a){var b;if(this.settings.heterogeneity&&this.settings.heterogeneity.length>0)for(var c=this.settings.heterogeneity,d=0,e=this.settings.from,f=0;f<=c.length;f++){var g;g=c[f]?c[f].split("/"):[100,this.settings.to],a>=d&&a<=g[0]&&(b=e+(a-d)*(g[1]-e)/(g[0]-d)),d=g[0],e=g[1]}else b=this.settings.from+a*this.settings.interval/100;return this.round(b)},e.prototype.valueToPrc=function(a,b){var c;if(this.settings.heterogeneity&&this.settings.heterogeneity.length>0)for(var d=this.settings.heterogeneity,e=0,f=this.settings.from,g=0;g<=d.length;g++){var h;h=d[g]?d[g].split("/"):[100,this.settings.to],a>=f&&a<=h[1]&&(c=b.limits(e+(a-f)*(h[0]-e)/(h[1]-f))),e=h[0],f=h[1]}else c=b.limits(100*(a-this.settings.from)/this.settings.interval);return c},e.prototype.round=function(a){return a=Math.round(a/this.settings.step)*this.settings.step,a=this.settings.round?Math.round(a*Math.pow(10,this.settings.round))/Math.pow(10,this.settings.round):Math.round(a)},e}])}(angular),function(a){"use strict";a.module("ngSlider").run(["$templateCache",function(a){a.put("ng-slider/slider-bar.tmpl.html",'<span ng-class="mainSliderClass" id="{{sliderTmplId}}"><table><tr><td><div class="jslider-bg"><i class="left"></i><i class="right"></i><i class="range"></i><i class="before"></i><i class="default"></i><i class="default"></i><i class="after"></i></div><div class="jslider-pointer"></div><div class="jslider-pointer jslider-pointer-to"></div><div class="jslider-label"><span>{{from}}</span>{{options.dimension}}</div><div class="jslider-label jslider-label-to"><span>{{to}}</span>{{options.dimension}}</div><div class="jslider-value"><span></span>{{options.dimension}}</div><div class="jslider-value jslider-value-to"><span></span>{{options.dimension}}</div><div class="jslider-scale" id="{{sliderScaleDivTmplId}}"></div></td></tr></table></span>')}])}(window.angular);

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	/**
	 * angular-drag-and-drop-lists v2.1.0
	 *
	 * Copyright (c) 2014 Marcel Juenemann marcel@juenemann.cc
	 * Copyright (c) 2014-2017 Google Inc.
	 * https://github.com/marceljuenemann/angular-drag-and-drop-lists
	 *
	 * License: MIT
	 */
	(function(dndLists) {
	
	  // In standard-compliant browsers we use a custom mime type and also encode the dnd-type in it.
	  // However, IE and Edge only support a limited number of mime types. The workarounds are described
	  // in https://github.com/marceljuenemann/angular-drag-and-drop-lists/wiki/Data-Transfer-Design
	  var MIME_TYPE = 'application/x-dnd';
	  var EDGE_MIME_TYPE = 'application/json';
	  var MSIE_MIME_TYPE = 'Text';
	
	  // All valid HTML5 drop effects, in the order in which we prefer to use them.
	  var ALL_EFFECTS = ['move', 'copy', 'link'];
	
	  /**
	   * Use the dnd-draggable attribute to make your element draggable
	   *
	   * Attributes:
	   * - dnd-draggable      Required attribute. The value has to be an object that represents the data
	   *                      of the element. In case of a drag and drop operation the object will be
	   *                      serialized and unserialized on the receiving end.
	   * - dnd-effect-allowed Use this attribute to limit the operations that can be performed. Valid
	   *                      options are "move", "copy" and "link", as well as "all", "copyMove",
	   *                      "copyLink" and "linkMove". The semantics of these operations are up to you
	   *                      and have to be implemented using the callbacks described below. If you
	   *                      allow multiple options, the user can choose between them by using the
	   *                      modifier keys (OS specific). The cursor will be changed accordingly,
	   *                      expect for IE and Edge, where this is not supported.
	   * - dnd-type           Use this attribute if you have different kinds of items in your
	   *                      application and you want to limit which items can be dropped into which
	   *                      lists. Combine with dnd-allowed-types on the dnd-list(s). This attribute
	   *                      must be a lower case string. Upper case characters can be used, but will
	   *                      be converted to lower case automatically.
	   * - dnd-disable-if     You can use this attribute to dynamically disable the draggability of the
	   *                      element. This is useful if you have certain list items that you don't want
	   *                      to be draggable, or if you want to disable drag & drop completely without
	   *                      having two different code branches (e.g. only allow for admins).
	   *
	   * Callbacks:
	   * - dnd-dragstart      Callback that is invoked when the element was dragged. The original
	   *                      dragstart event will be provided in the local event variable.
	   * - dnd-moved          Callback that is invoked when the element was moved. Usually you will
	   *                      remove your element from the original list in this callback, since the
	   *                      directive is not doing that for you automatically. The original dragend
	   *                      event will be provided in the local event variable.
	   * - dnd-copied         Same as dnd-moved, just that it is called when the element was copied
	   *                      instead of moved, so you probably want to implement a different logic.
	   * - dnd-linked         Same as dnd-moved, just that it is called when the element was linked
	   *                      instead of moved, so you probably want to implement a different logic.
	   * - dnd-canceled       Callback that is invoked if the element was dragged, but the operation was
	   *                      canceled and the element was not dropped. The original dragend event will
	   *                      be provided in the local event variable.
	   * - dnd-dragend        Callback that is invoked when the drag operation ended. Available local
	   *                      variables are event and dropEffect.
	   * - dnd-selected       Callback that is invoked when the element was clicked but not dragged.
	   *                      The original click event will be provided in the local event variable.
	   * - dnd-callback       Custom callback that is passed to dropzone callbacks and can be used to
	   *                      communicate between source and target scopes. The dropzone can pass user
	   *                      defined variables to this callback.
	   *
	   * CSS classes:
	   * - dndDragging        This class will be added to the element while the element is being
	   *                      dragged. It will affect both the element you see while dragging and the
	   *                      source element that stays at it's position. Do not try to hide the source
	   *                      element with this class, because that will abort the drag operation.
	   * - dndDraggingSource  This class will be added to the element after the drag operation was
	   *                      started, meaning it only affects the original element that is still at
	   *                      it's source position, and not the "element" that the user is dragging with
	   *                      his mouse pointer.
	   */
	  dndLists.directive('dndDraggable', ['$parse', '$timeout', function($parse, $timeout) {
	    return function(scope, element, attr) {
	      // Set the HTML5 draggable attribute on the element.
	      element.attr("draggable", "true");
	
	      // If the dnd-disable-if attribute is set, we have to watch that.
	      if (attr.dndDisableIf) {
	        scope.$watch(attr.dndDisableIf, function(disabled) {
	          element.attr("draggable", !disabled);
	        });
	      }
	
	      /**
	       * When the drag operation is started we have to prepare the dataTransfer object,
	       * which is the primary way we communicate with the target element
	       */
	      element.on('dragstart', function(event) {
	        event = event.originalEvent || event;
	
	        // Check whether the element is draggable, since dragstart might be triggered on a child.
	        if (element.attr('draggable') == 'false') return true;
	
	        // Initialize global state.
	        dndState.isDragging = true;
	        dndState.itemType = attr.dndType && scope.$eval(attr.dndType).toLowerCase();
	
	        // Set the allowed drop effects. See below for special IE handling.
	        dndState.dropEffect = "none";
	        dndState.effectAllowed = attr.dndEffectAllowed || ALL_EFFECTS[0];
	        event.dataTransfer.effectAllowed = dndState.effectAllowed;
	
	        // Internet Explorer and Microsoft Edge don't support custom mime types, see design doc:
	        // https://github.com/marceljuenemann/angular-drag-and-drop-lists/wiki/Data-Transfer-Design
	        var item = scope.$eval(attr.dndDraggable);
	        var mimeType = MIME_TYPE + (dndState.itemType ? ('-' + dndState.itemType) : '');
	        try {
	          event.dataTransfer.setData(mimeType, angular.toJson(item));
	        } catch (e) {
	          // Setting a custom MIME type did not work, we are probably in IE or Edge.
	          var data = angular.toJson({item: item, type: dndState.itemType});
	          try {
	            event.dataTransfer.setData(EDGE_MIME_TYPE, data);
	          } catch (e) {
	            // We are in Internet Explorer and can only use the Text MIME type. Also note that IE
	            // does not allow changing the cursor in the dragover event, therefore we have to choose
	            // the one we want to display now by setting effectAllowed.
	            var effectsAllowed = filterEffects(ALL_EFFECTS, dndState.effectAllowed);
	            event.dataTransfer.effectAllowed = effectsAllowed[0];
	            event.dataTransfer.setData(MSIE_MIME_TYPE, data);
	          }
	        }
	
	        // Add CSS classes. See documentation above.
	        element.addClass("dndDragging");
	        $timeout(function() { element.addClass("dndDraggingSource"); }, 0);
	
	        // Try setting a proper drag image if triggered on a dnd-handle (won't work in IE).
	        if (event._dndHandle && event.dataTransfer.setDragImage) {
	          event.dataTransfer.setDragImage(element[0], 0, 0);
	        }
	
	        // Invoke dragstart callback and prepare extra callback for dropzone.
	        $parse(attr.dndDragstart)(scope, {event: event});
	        if (attr.dndCallback) {
	          var callback = $parse(attr.dndCallback);
	          dndState.callback = function(params) { return callback(scope, params || {}); };
	        }
	
	        event.stopPropagation();
	      });
	
	      /**
	       * The dragend event is triggered when the element was dropped or when the drag
	       * operation was aborted (e.g. hit escape button). Depending on the executed action
	       * we will invoke the callbacks specified with the dnd-moved or dnd-copied attribute.
	       */
	      element.on('dragend', function(event) {
	        event = event.originalEvent || event;
	
	        // Invoke callbacks. Usually we would use event.dataTransfer.dropEffect to determine
	        // the used effect, but Chrome has not implemented that field correctly. On Windows
	        // it always sets it to 'none', while Chrome on Linux sometimes sets it to something
	        // else when it's supposed to send 'none' (drag operation aborted).
	        scope.$apply(function() {
	          var dropEffect = dndState.dropEffect;
	          var cb = {copy: 'dndCopied', link: 'dndLinked', move: 'dndMoved', none: 'dndCanceled'};
	          $parse(attr[cb[dropEffect]])(scope, {event: event});
	          $parse(attr.dndDragend)(scope, {event: event, dropEffect: dropEffect});
	        });
	
	        // Clean up
	        dndState.isDragging = false;
	        dndState.callback = undefined;
	        element.removeClass("dndDragging");
	        element.removeClass("dndDraggingSource");
	        event.stopPropagation();
	
	        // In IE9 it is possible that the timeout from dragstart triggers after the dragend handler.
	        $timeout(function() { element.removeClass("dndDraggingSource"); }, 0);
	      });
	
	      /**
	       * When the element is clicked we invoke the callback function
	       * specified with the dnd-selected attribute.
	       */
	      element.on('click', function(event) {
	        if (!attr.dndSelected) return;
	
	        event = event.originalEvent || event;
	        scope.$apply(function() {
	          $parse(attr.dndSelected)(scope, {event: event});
	        });
	
	        // Prevent triggering dndSelected in parent elements.
	        event.stopPropagation();
	      });
	
	      /**
	       * Workaround to make element draggable in IE9
	       */
	      element.on('selectstart', function() {
	        if (this.dragDrop) this.dragDrop();
	      });
	    };
	  }]);
	
	  /**
	   * Use the dnd-list attribute to make your list element a dropzone. Usually you will add a single
	   * li element as child with the ng-repeat directive. If you don't do that, we will not be able to
	   * position the dropped element correctly. If you want your list to be sortable, also add the
	   * dnd-draggable directive to your li element(s).
	   *
	   * Attributes:
	   * - dnd-list             Required attribute. The value has to be the array in which the data of
	   *                        the dropped element should be inserted. The value can be blank if used
	   *                        with a custom dnd-drop handler that always returns true.
	   * - dnd-allowed-types    Optional array of allowed item types. When used, only items that had a
	   *                        matching dnd-type attribute will be dropable. Upper case characters will
	   *                        automatically be converted to lower case.
	   * - dnd-effect-allowed   Optional string expression that limits the drop effects that can be
	   *                        performed in the list. See dnd-effect-allowed on dnd-draggable for more
	   *                        details on allowed options. The default value is all.
	   * - dnd-disable-if       Optional boolean expresssion. When it evaluates to true, no dropping
	   *                        into the list is possible. Note that this also disables rearranging
	   *                        items inside the list.
	   * - dnd-horizontal-list  Optional boolean expresssion. When it evaluates to true, the positioning
	   *                        algorithm will use the left and right halfs of the list items instead of
	   *                        the upper and lower halfs.
	   * - dnd-external-sources Optional boolean expression. When it evaluates to true, the list accepts
	   *                        drops from sources outside of the current browser tab. This allows to
	   *                        drag and drop accross different browser tabs. The only major browser
	   *                        that does not support this is currently Microsoft Edge.
	   *
	   * Callbacks:
	   * - dnd-dragover         Optional expression that is invoked when an element is dragged over the
	   *                        list. If the expression is set, but does not return true, the element is
	   *                        not allowed to be dropped. The following variables will be available:
	   *                        - event: The original dragover event sent by the browser.
	   *                        - index: The position in the list at which the element would be dropped.
	   *                        - type: The dnd-type set on the dnd-draggable, or undefined if non was
	   *                          set. Will be null for drops from external sources in IE and Edge,
	   *                          since we don't know the type in those cases.
	   *                        - dropEffect: One of move, copy or link, see dnd-effect-allowed.
	   *                        - external: Whether the element was dragged from an external source.
	   *                        - callback: If dnd-callback was set on the source element, this is a
	   *                          function reference to the callback. The callback can be invoked with
	   *                          custom variables like this: callback({var1: value1, var2: value2}).
	   *                          The callback will be executed on the scope of the source element. If
	   *                          dnd-external-sources was set and external is true, this callback will
	   *                          not be available.
	   * - dnd-drop             Optional expression that is invoked when an element is dropped on the
	   *                        list. The same variables as for dnd-dragover will be available, with the
	   *                        exception that type is always known and therefore never null. There
	   *                        will also be an item variable, which is the transferred object. The
	   *                        return value determines the further handling of the drop:
	   *                        - falsy: The drop will be canceled and the element won't be inserted.
	   *                        - true: Signalises that the drop is allowed, but the dnd-drop
	   *                          callback already took care of inserting the element.
	   *                        - otherwise: All other return values will be treated as the object to
	   *                          insert into the array. In most cases you want to simply return the
	   *                          item parameter, but there are no restrictions on what you can return.
	   * - dnd-inserted         Optional expression that is invoked after a drop if the element was
	   *                        actually inserted into the list. The same local variables as for
	   *                        dnd-drop will be available. Note that for reorderings inside the same
	   *                        list the old element will still be in the list due to the fact that
	   *                        dnd-moved was not called yet.
	   *
	   * CSS classes:
	   * - dndPlaceholder       When an element is dragged over the list, a new placeholder child
	   *                        element will be added. This element is of type li and has the class
	   *                        dndPlaceholder set. Alternatively, you can define your own placeholder
	   *                        by creating a child element with dndPlaceholder class.
	   * - dndDragover          Will be added to the list while an element is dragged over the list.
	   */
	  dndLists.directive('dndList', ['$parse', function($parse) {
	    return function(scope, element, attr) {
	      // While an element is dragged over the list, this placeholder element is inserted
	      // at the location where the element would be inserted after dropping.
	      var placeholder = getPlaceholderElement();
	      placeholder.remove();
	
	      var placeholderNode = placeholder[0];
	      var listNode = element[0];
	      var listSettings = {};
	
	      /**
	       * The dragenter event is fired when a dragged element or text selection enters a valid drop
	       * target. According to the spec, we either need to have a dropzone attribute or listen on
	       * dragenter events and call preventDefault(). It should be noted though that no browser seems
	       * to enforce this behaviour.
	       */
	      element.on('dragenter', function (event) {
	        event = event.originalEvent || event;
	
	        // Calculate list properties, so that we don't have to repeat this on every dragover event.
	        var types = attr.dndAllowedTypes && scope.$eval(attr.dndAllowedTypes);
	        listSettings = {
	          allowedTypes: angular.isArray(types) && types.join('|').toLowerCase().split('|'),
	          disabled: attr.dndDisableIf && scope.$eval(attr.dndDisableIf),
	          externalSources: attr.dndExternalSources && scope.$eval(attr.dndExternalSources),
	          horizontal: attr.dndHorizontalList && scope.$eval(attr.dndHorizontalList)
	        };
	
	        var mimeType = getMimeType(event.dataTransfer.types);
	        if (!mimeType || !isDropAllowed(getItemType(mimeType))) return true;
	        event.preventDefault();
	      });
	
	      /**
	       * The dragover event is triggered "every few hundred milliseconds" while an element
	       * is being dragged over our list, or over an child element.
	       */
	      element.on('dragover', function(event) {
	        event = event.originalEvent || event;
	
	        // Check whether the drop is allowed and determine mime type.
	        var mimeType = getMimeType(event.dataTransfer.types);
	        var itemType = getItemType(mimeType);
	        if (!mimeType || !isDropAllowed(itemType)) return true;
	
	        // Make sure the placeholder is shown, which is especially important if the list is empty.
	        if (placeholderNode.parentNode != listNode) {
	          element.append(placeholder);
	        }
	
	        if (event.target != listNode) {
	          // Try to find the node direct directly below the list node.
	          var listItemNode = event.target;
	          while (listItemNode.parentNode != listNode && listItemNode.parentNode) {
	            listItemNode = listItemNode.parentNode;
	          }
	
	          if (listItemNode.parentNode == listNode && listItemNode != placeholderNode) {
	            // If the mouse pointer is in the upper half of the list item element,
	            // we position the placeholder before the list item, otherwise after it.
	            var rect = listItemNode.getBoundingClientRect();
	            if (listSettings.horizontal) {
	              var isFirstHalf = event.clientX < rect.left + rect.width / 2;
	            } else {
	              var isFirstHalf = event.clientY < rect.top + rect.height / 2;
	            }
	            listNode.insertBefore(placeholderNode,
	                isFirstHalf ? listItemNode : listItemNode.nextSibling);
	          }
	        }
	
	        // In IE we set a fake effectAllowed in dragstart to get the correct cursor, we therefore
	        // ignore the effectAllowed passed in dataTransfer. We must also not access dataTransfer for
	        // drops from external sources, as that throws an exception.
	        var ignoreDataTransfer = mimeType == MSIE_MIME_TYPE;
	        var dropEffect = getDropEffect(event, ignoreDataTransfer);
	        if (dropEffect == 'none') return stopDragover();
	
	        // At this point we invoke the callback, which still can disallow the drop.
	        // We can't do this earlier because we want to pass the index of the placeholder.
	        if (attr.dndDragover && !invokeCallback(attr.dndDragover, event, dropEffect, itemType)) {
	          return stopDragover();
	        }
	
	        // Set dropEffect to modify the cursor shown by the browser, unless we're in IE, where this
	        // is not supported. This must be done after preventDefault in Firefox.
	        event.preventDefault();
	        if (!ignoreDataTransfer) {
	          event.dataTransfer.dropEffect = dropEffect;
	        }
	
	        element.addClass("dndDragover");
	        event.stopPropagation();
	        return false;
	      });
	
	      /**
	       * When the element is dropped, we use the position of the placeholder element as the
	       * position where we insert the transferred data. This assumes that the list has exactly
	       * one child element per array element.
	       */
	      element.on('drop', function(event) {
	        event = event.originalEvent || event;
	
	        // Check whether the drop is allowed and determine mime type.
	        var mimeType = getMimeType(event.dataTransfer.types);
	        var itemType = getItemType(mimeType);
	        if (!mimeType || !isDropAllowed(itemType)) return true;
	
	        // The default behavior in Firefox is to interpret the dropped element as URL and
	        // forward to it. We want to prevent that even if our drop is aborted.
	        event.preventDefault();
	
	        // Unserialize the data that was serialized in dragstart.
	        try {
	          var data = JSON.parse(event.dataTransfer.getData(mimeType));
	        } catch(e) {
	          return stopDragover();
	        }
	
	        // Drops with invalid types from external sources might not have been filtered out yet.
	        if (mimeType == MSIE_MIME_TYPE || mimeType == EDGE_MIME_TYPE) {
	          itemType = data.type || undefined;
	          data = data.item;
	          if (!isDropAllowed(itemType)) return stopDragover();
	        }
	
	        // Special handling for internal IE drops, see dragover handler.
	        var ignoreDataTransfer = mimeType == MSIE_MIME_TYPE;
	        var dropEffect = getDropEffect(event, ignoreDataTransfer);
	        if (dropEffect == 'none') return stopDragover();
	
	        // Invoke the callback, which can transform the transferredObject and even abort the drop.
	        var index = getPlaceholderIndex();
	        if (attr.dndDrop) {
	          data = invokeCallback(attr.dndDrop, event, dropEffect, itemType, index, data);
	          if (!data) return stopDragover();
	        }
	
	        // The drop is definitely going to happen now, store the dropEffect.
	        dndState.dropEffect = dropEffect;
	        if (!ignoreDataTransfer) {
	          event.dataTransfer.dropEffect = dropEffect;
	        }
	
	        // Insert the object into the array, unless dnd-drop took care of that (returned true).
	        if (data !== true) {
	          scope.$apply(function() {
	            scope.$eval(attr.dndList).splice(index, 0, data);
	          });
	        }
	        invokeCallback(attr.dndInserted, event, dropEffect, itemType, index, data);
	
	        // Clean up
	        stopDragover();
	        event.stopPropagation();
	        return false;
	      });
	
	      /**
	       * We have to remove the placeholder when the element is no longer dragged over our list. The
	       * problem is that the dragleave event is not only fired when the element leaves our list,
	       * but also when it leaves a child element. Therefore, we determine whether the mouse cursor
	       * is still pointing to an element inside the list or not.
	       */
	      element.on('dragleave', function(event) {
	        event = event.originalEvent || event;
	
	        var newTarget = document.elementFromPoint(event.clientX, event.clientY);
	        if (listNode.contains(newTarget) && !event._dndPhShown) {
	          // Signalize to potential parent lists that a placeholder is already shown.
	          event._dndPhShown = true;
	        } else {
	          stopDragover();
	        }
	      });
	
	      /**
	       * Given the types array from the DataTransfer object, returns the first valid mime type.
	       * A type is valid if it starts with MIME_TYPE, or it equals MSIE_MIME_TYPE or EDGE_MIME_TYPE.
	       */
	      function getMimeType(types) {
	        if (!types) return MSIE_MIME_TYPE; // IE 9 workaround.
	        for (var i = 0; i < types.length; i++) {
	          if (types[i] == MSIE_MIME_TYPE || types[i] == EDGE_MIME_TYPE ||
	              types[i].substr(0, MIME_TYPE.length) == MIME_TYPE) {
	            return types[i];
	          }
	        }
	        return null;
	      }
	
	      /**
	       * Determines the type of the item from the dndState, or from the mime type for items from
	       * external sources. Returns undefined if no item type was set and null if the item type could
	       * not be determined.
	       */
	      function getItemType(mimeType) {
	        if (dndState.isDragging) return dndState.itemType || undefined;
	        if (mimeType == MSIE_MIME_TYPE || mimeType == EDGE_MIME_TYPE) return null;
	        return (mimeType && mimeType.substr(MIME_TYPE.length + 1)) || undefined;
	      }
	
	      /**
	       * Checks various conditions that must be fulfilled for a drop to be allowed, including the
	       * dnd-allowed-types attribute. If the item Type is unknown (null), the drop will be allowed.
	       */
	      function isDropAllowed(itemType) {
	        if (listSettings.disabled) return false;
	        if (!listSettings.externalSources && !dndState.isDragging) return false;
	        if (!listSettings.allowedTypes || itemType === null) return true;
	        return itemType && listSettings.allowedTypes.indexOf(itemType) != -1;
	      }
	
	      /**
	       * Determines which drop effect to use for the given event. In Internet Explorer we have to
	       * ignore the effectAllowed field on dataTransfer, since we set a fake value in dragstart.
	       * In those cases we rely on dndState to filter effects. Read the design doc for more details:
	       * https://github.com/marceljuenemann/angular-drag-and-drop-lists/wiki/Data-Transfer-Design
	       */
	      function getDropEffect(event, ignoreDataTransfer) {
	        var effects = ALL_EFFECTS;
	        if (!ignoreDataTransfer) {
	          effects = filterEffects(effects, event.dataTransfer.effectAllowed);
	        }
	        if (dndState.isDragging) {
	          effects = filterEffects(effects, dndState.effectAllowed);
	        }
	        if (attr.dndEffectAllowed) {
	          effects = filterEffects(effects, attr.dndEffectAllowed);
	        }
	        // MacOS automatically filters dataTransfer.effectAllowed depending on the modifier keys,
	        // therefore the following modifier keys will only affect other operating systems.
	        if (!effects.length) {
	          return 'none';
	        } else if (event.ctrlKey && effects.indexOf('copy') != -1) {
	          return 'copy';
	        } else if (event.altKey && effects.indexOf('link') != -1) {
	          return 'link';
	        } else {
	          return effects[0];
	        }
	      }
	
	      /**
	       * Small helper function that cleans up if we aborted a drop.
	       */
	      function stopDragover() {
	        placeholder.remove();
	        element.removeClass("dndDragover");
	        return true;
	      }
	
	      /**
	       * Invokes a callback with some interesting parameters and returns the callbacks return value.
	       */
	      function invokeCallback(expression, event, dropEffect, itemType, index, item) {
	        return $parse(expression)(scope, {
	          callback: dndState.callback,
	          dropEffect: dropEffect,
	          event: event,
	          external: !dndState.isDragging,
	          index: index !== undefined ? index : getPlaceholderIndex(),
	          item: item || undefined,
	          type: itemType
	        });
	      }
	
	      /**
	       * We use the position of the placeholder node to determine at which position of the array the
	       * object needs to be inserted
	       */
	      function getPlaceholderIndex() {
	        return Array.prototype.indexOf.call(listNode.children, placeholderNode);
	      }
	
	      /**
	       * Tries to find a child element that has the dndPlaceholder class set. If none was found, a
	       * new li element is created.
	       */
	      function getPlaceholderElement() {
	        var placeholder;
	        angular.forEach(element.children(), function(childNode) {
	          var child = angular.element(childNode);
	          if (child.hasClass('dndPlaceholder')) {
	            placeholder = child;
	          }
	        });
	        return placeholder || angular.element("<li class='dndPlaceholder'></li>");
	      }
	    };
	  }]);
	
	  /**
	   * Use the dnd-nodrag attribute inside of dnd-draggable elements to prevent them from starting
	   * drag operations. This is especially useful if you want to use input elements inside of
	   * dnd-draggable elements or create specific handle elements. Note: This directive does not work
	   * in Internet Explorer 9.
	   */
	  dndLists.directive('dndNodrag', function() {
	    return function(scope, element, attr) {
	      // Set as draggable so that we can cancel the events explicitly
	      element.attr("draggable", "true");
	
	      /**
	       * Since the element is draggable, the browser's default operation is to drag it on dragstart.
	       * We will prevent that and also stop the event from bubbling up.
	       */
	      element.on('dragstart', function(event) {
	        event = event.originalEvent || event;
	
	        if (!event._dndHandle) {
	          // If a child element already reacted to dragstart and set a dataTransfer object, we will
	          // allow that. For example, this is the case for user selections inside of input elements.
	          if (!(event.dataTransfer.types && event.dataTransfer.types.length)) {
	            event.preventDefault();
	          }
	          event.stopPropagation();
	        }
	      });
	
	      /**
	       * Stop propagation of dragend events, otherwise dnd-moved might be triggered and the element
	       * would be removed.
	       */
	      element.on('dragend', function(event) {
	        event = event.originalEvent || event;
	        if (!event._dndHandle) {
	          event.stopPropagation();
	        }
	      });
	    };
	  });
	
	  /**
	   * Use the dnd-handle directive within a dnd-nodrag element in order to allow dragging with that
	   * element after all. Therefore, by combining dnd-nodrag and dnd-handle you can allow
	   * dnd-draggable elements to only be dragged via specific "handle" elements. Note that Internet
	   * Explorer will show the handle element as drag image instead of the dnd-draggable element. You
	   * can work around this by styling the handle element differently when it is being dragged. Use
	   * the CSS selector .dndDragging:not(.dndDraggingSource) [dnd-handle] for that.
	   */
	  dndLists.directive('dndHandle', function() {
	    return function(scope, element, attr) {
	      element.attr("draggable", "true");
	
	      element.on('dragstart dragend', function(event) {
	        event = event.originalEvent || event;
	        event._dndHandle = true;
	      });
	    };
	  });
	
	  /**
	   * Filters an array of drop effects using a HTML5 effectAllowed string.
	   */
	  function filterEffects(effects, effectAllowed) {
	    if (effectAllowed == 'all') return effects;
	    return effects.filter(function(effect) {
	      return effectAllowed.toLowerCase().indexOf(effect) != -1;
	    });
	  }
	
	  /**
	   * For some features we need to maintain global state. This is done here, with these fields:
	   * - callback: A callback function set at dragstart that is passed to internal dropzone handlers.
	   * - dropEffect: Set in dragstart to "none" and to the actual value in the drop handler. We don't
	   *   rely on the dropEffect passed by the browser, since there are various bugs in Chrome and
	   *   Safari, and Internet Explorer defaults to copy if effectAllowed is copyMove.
	   * - effectAllowed: Set in dragstart based on dnd-effect-allowed. This is needed for IE because
	   *   setting effectAllowed on dataTransfer might result in an undesired cursor.
	   * - isDragging: True between dragstart and dragend. Falsy for drops from external sources.
	   * - itemType: The item type of the dragged element set via dnd-type. This is needed because IE
	   *   and Edge don't support custom mime types that we can use to transfer this information.
	   */
	  var dndState = {};
	
	})(angular.module('dndLists', []));


/***/ }),
/* 497 */
/***/ (function(module, exports) {

	/**
	 * Bunch of useful filters for angularJS(with no external dependencies!)
	 * @version v0.5.17 - 2017-09-22 * @link https://github.com/a8m/angular-filter
	 * @author Ariel Mashraki <ariel@mashraki.co.il>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function ( window, angular, undefined ) {
	/*jshint globalstrict:true*/
	'use strict';
	
	var isDefined = angular.isDefined,
	    isUndefined = angular.isUndefined,
	    isFunction = angular.isFunction,
	    isString = angular.isString,
	    isNumber = angular.isNumber,
	    isObject = angular.isObject,
	    isArray = angular.isArray,
	    forEach = angular.forEach,
	    extend = angular.extend,
	    copy = angular.copy,
	    equals = angular.equals;
	
	
	/**
	 * @description
	 * get an object and return array of values
	 * @param object
	 * @returns {Array}
	 */
	function toArray(object) {
	  return isArray(object) 
	    ? object 
	    : Object.keys(object).map(function(key) {
	      return object[key];
	    });
	}
	
	/**
	 * @param value
	 * @returns {boolean}
	 */
	function isNull(value) {
	    return value === null;
	}
	
	/**
	 * @description
	 * return if object contains partial object
	 * @param partial{object}
	 * @param object{object}
	 * @returns {boolean}
	 */
	function objectContains(partial, object) {
	  var keys = Object.keys(partial);
	
	  return keys.map(function(el) {
	    return (object[el] !== undefined) && (object[el] == partial[el]);
	  }).indexOf(false) == -1;
	
	}
	
	/**
	 * @description
	 * search for approximate pattern in string
	 * @param word
	 * @param pattern
	 * @returns {*}
	 */
	function hasApproxPattern(word, pattern) {
	  // cheaper version of indexOf; instead of creating each
	  // iteration new str.
	  function indexOf(word, p, c) {
	    var j = 0;
	    while ((p + j) <= word.length) {
	      if (word.charAt(p + j) == c) return j;
	      j++;
	    }
	    return -1;
	  }
	  var p = 0;
	  for (var i = 0; i <= pattern.length; i++) {
	    var index = indexOf(word, p, pattern.charAt(i));
	    if (index == -1) return false;
	    p += index + 1;
	  }
	  return true
	}
	
	/**
	 * @description
	 * return the first n element of an array,
	 * if expression provided, is returns as long the expression return truthy
	 * @param array
	 * @param n {number}
	 * @param expression {$parse}
	 * @return array or single object
	 */
	function getFirstMatches(array, n, expression) {
	  var count = 0;
	
	  return array.filter(function(elm) {
	    var rest = isDefined(expression) ? (count < n && expression(elm)) : count < n;
	    count = rest ? count+1 : count;
	
	    return rest;
	  });
	}
	/**
	 * Polyfill to ECMA6 String.prototype.contains
	 */
	if (!String.prototype.contains) {
	  String.prototype.contains = function() {
	    return String.prototype.indexOf.apply(this, arguments) !== -1;
	  };
	}
	
	/**
	 * @param num {Number}
	 * @param decimal {Number}
	 * @returns {Number}
	 */
	function convertToDecimal(num, decimal){
	  return Math.round(num * Math.pow(10,decimal)) / (Math.pow(10, decimal));
	}
	
	/**
	 * @description
	 * Get an object, and return an array composed of it's properties names(nested too).
	 * @param obj {Object}
	 * @param stack {Array}
	 * @param parent {String}
	 * @returns {Array}
	 * @example
	 * parseKeys({ a:1, b: { c:2, d: { e: 3 } } }) ==> ["a", "b.c", "b.d.e"]
	 */
	function deepKeys(obj, stack, parent) {
	  stack = stack || [];
	  var keys = Object.keys(obj);
	
	  keys.forEach(function(el) {
	    //if it's a nested object
	    if(isObject(obj[el]) && !isArray(obj[el])) {
	      //concatenate the new parent if exist
	      var p = parent ? parent + '.' + el : parent;
	      deepKeys(obj[el], stack, p || el);
	    } else {
	      //create and save the key
	      var key = parent ? parent + '.' + el : el;
	      stack.push(key)
	    }
	  });
	  return stack
	}
	
	/**
	 * @description
	 * Test if given object is a Scope instance
	 * @param obj
	 * @returns {Boolean}
	 */
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	/**
	 * @ngdoc filter
	 * @name a8m.angular
	 * @kind function
	 *
	 * @description
	 * reference to angular function
	 */
	
	angular.module('a8m.angular', [])
	
	    .filter('isUndefined', function () {
	      return function (input) {
	        return angular.isUndefined(input);
	      }
	    })
	    .filter('isDefined', function() {
	      return function (input) {
	        return angular.isDefined(input);
	      }
	    })
	    .filter('isFunction', function() {
	      return function (input) {
	        return angular.isFunction(input);
	      }
	    })
	    .filter('isString', function() {
	      return function (input) {
	        return angular.isString(input)
	      }
	    })
	    .filter('isNumber', function() {
	      return function (input) {
	        return angular.isNumber(input);
	      }
	    })
	    .filter('isArray', function() {
	      return function (input) {
	        return angular.isArray(input);
	      }
	    })
	    .filter('isObject', function() {
	      return function (input) {
	        return angular.isObject(input);
	      }
	    })
	    .filter('isEqual', function() {
	      return function (o1, o2) {
	        return angular.equals(o1, o2);
	      }
	    });
	
	/**
	 * @ngdoc filter
	 * @name a8m.conditions
	 * @kind function
	 *
	 * @description
	 * reference to math conditions
	 */
	 angular.module('a8m.conditions', [])
	
	  .filter({
	    isGreaterThan  : isGreaterThanFilter,
	    '>'            : isGreaterThanFilter,
	
	    isGreaterThanOrEqualTo  : isGreaterThanOrEqualToFilter,
	    '>='                    : isGreaterThanOrEqualToFilter,
	
	    isLessThan  : isLessThanFilter,
	    '<'         : isLessThanFilter,
	
	    isLessThanOrEqualTo  : isLessThanOrEqualToFilter,
	    '<='                 : isLessThanOrEqualToFilter,
	
	    isEqualTo  : isEqualToFilter,
	    '=='       : isEqualToFilter,
	
	    isNotEqualTo  : isNotEqualToFilter,
	    '!='          : isNotEqualToFilter,
	
	    isIdenticalTo  : isIdenticalToFilter,
	    '==='          : isIdenticalToFilter,
	
	    isNotIdenticalTo  : isNotIdenticalToFilter,
	    '!=='             : isNotIdenticalToFilter
	  });
	
	  function isGreaterThanFilter() {
	    return function (input, check) {
	      return input > check;
	    };
	  }
	
	  function isGreaterThanOrEqualToFilter() {
	    return function (input, check) {
	      return input >= check;
	    };
	  }
	
	  function isLessThanFilter() {
	    return function (input, check) {
	      return input < check;
	    };
	  }
	
	  function isLessThanOrEqualToFilter() {
	    return function (input, check) {
	      return input <= check;
	    };
	  }
	
	  function isEqualToFilter() {
	    return function (input, check) {
	      return input == check;
	    };
	  }
	
	  function isNotEqualToFilter() {
	    return function (input, check) {
	      return input != check;
	    };
	  }
	
	  function isIdenticalToFilter() {
	    return function (input, check) {
	      return input === check;
	    };
	  }
	
	  function isNotIdenticalToFilter() {
	    return function (input, check) {
	      return input !== check;
	    };
	  }
	/**
	 * @ngdoc filter
	 * @name isNull
	 * @kind function
	 *
	 * @description
	 * checks if value is null or not
	 * @return Boolean
	 */
	angular.module('a8m.is-null', [])
	    .filter('isNull', function () {
	      return function(input) {
	        return isNull(input);
	      }
	    });
	
	/**
	 * @ngdoc filter
	 * @name after-where
	 * @kind function
	 *
	 * @description
	 * get a collection and properties object, and returns all of the items
	 * in the collection after the first that found with the given properties.
	 *
	 */
	angular.module('a8m.after-where', [])
	    .filter('afterWhere', function() {
	      return function (collection, object) {
	
	        collection = isObject(collection)
	          ? toArray(collection)
	          : collection;
	
	        if(!isArray(collection) || isUndefined(object)) return collection;
	
	        var index = collection.map( function( elm ) {
	          return objectContains(object, elm);
	        }).indexOf( true );
	
	        return collection.slice((index === -1) ? 0 : index);
	      }
	    });
	
	/**
	 * @ngdoc filter
	 * @name after
	 * @kind function
	 *
	 * @description
	 * get a collection and specified count, and returns all of the items
	 * in the collection after the specified count.
	 *
	 */
	
	angular.module('a8m.after', [])
	    .filter('after', function() {
	      return function (collection, count) {
	        collection = isObject(collection)
	          ? toArray(collection)
	          : collection;
	
	        return (isArray(collection))
	          ? collection.slice(count)
	          : collection;
	      }
	    });
	
	/**
	 * @ngdoc filter
	 * @name before-where
	 * @kind function
	 *
	 * @description
	 * get a collection and properties object, and returns all of the items
	 * in the collection before the first that found with the given properties.
	 */
	angular.module('a8m.before-where', [])
	  .filter('beforeWhere', function() {
	    return function (collection, object) {
	
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      if(!isArray(collection) || isUndefined(object)) return collection;
	
	      var index = collection.map( function( elm ) {
	        return objectContains(object, elm);
	      }).indexOf( true );
	
	      return collection.slice(0, (index === -1) ? collection.length : ++index);
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name before
	 * @kind function
	 *
	 * @description
	 * get a collection and specified count, and returns all of the items
	 * in the collection before the specified count.
	 */
	angular.module('a8m.before', [])
	    .filter('before', function() {
	      return function (collection, count) {
	        collection = isObject(collection)
	          ? toArray(collection)
	          : collection;
	
	        return (isArray(collection))
	          ? collection.slice(0, (!count) ? count : --count)
	          : collection;
	      }
	    });
	
	/**
	 * @ngdoc filter
	 * @name chunkBy
	 * @kind function
	 *
	 * @description
	 * Collect data into fixed-length chunks or blocks
	 */
	
	angular.module('a8m.chunk-by', ['a8m.filter-watcher'])
	    .filter('chunkBy', ['filterWatcher', function (filterWatcher) {
	      return function (array, n, fillVal) {
	
	        return filterWatcher.isMemoized('chunkBy', arguments) ||
	            filterWatcher.memoize('chunkBy', arguments, this,
	                _chunkBy(array, n, fillVal));
	        /**
	         * @description
	         * Get array with size `n` in `val` inside it.
	         * @param n
	         * @param val
	         * @returns {Array}
	         */
	        function fill(n, val) {
	          var ret = [];
	          while (n--) ret[n] = val;
	          return ret;
	        }
	
	        function _chunkBy(array, n, fillVal) {
	          if (!isArray(array)) return array;
	          return array.map(function (el, i, self) {
	            i = i * n;
	            el = self.slice(i, i + n);
	            return !isUndefined(fillVal) && el.length < n
	                ? el.concat(fill(n - el.length, fillVal))
	                : el;
	          }).slice(0, Math.ceil(array.length / n));
	        }
	      }
	    }]);
	
	/**
	 * @ngdoc filter
	 * @name concat
	 * @kind function
	 *
	 * @description
	 * get (array/object, object/array) and return merged collection
	 */
	angular.module('a8m.concat', [])
	  .filter('concat', [function () {
	    return function (collection, joined) {
	
	      if (isUndefined(joined)) return collection;
	
	      if (isArray(collection)) {
	        return isObject(joined)
	          ? collection.concat(toArray(joined))
	          : collection.concat(joined);
	      }
	
	      if (isObject(collection)) {
	        var array = toArray(collection);
	        return (isObject(joined))
	          ? array.concat(toArray(joined))
	          : array.concat(joined);
	      }
	      return collection;
	    };
	  }
	]);
	
	/**
	 * @ngdoc filter
	 * @name contains
	 * @kind function
	 *
	 * @description
	 * Checks if given expression is present in one or more object in the collection
	 */
	angular.module('a8m.contains', [])
	  .filter({
	    contains: ['$parse', containsFilter],
	    some: ['$parse', containsFilter]
	  });
	
	function containsFilter($parse) {
	    return function (collection, expression) {
	
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || isUndefined(expression)) {
	        return false;
	      }
	
	      return collection.some(function(elm) {
	        return ((isString(expression) && isObject(elm)) || isFunction(expression))
	          ? $parse(expression)(elm)
	          : elm === expression;
	      });
	
	    }
	 }
	
	/**
	 * @ngdoc filter
	 * @name countBy
	 * @kind function
	 *
	 * @description
	 * Sorts a list into groups and returns a count for the number of objects in each group.
	 */
	
	angular.module('a8m.count-by', [])
	
	  .filter('countBy', [ '$parse', function ( $parse ) {
	    return function (collection, property) {
	
	      var result = {},
	        get = $parse(property),
	        prop;
	
	      collection = (isObject(collection)) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || isUndefined(property)) {
	        return collection;
	      }
	
	      collection.forEach( function( elm ) {
	        prop = get(elm);
	
	        if(!result[prop]) {
	          result[prop] = 0;
	        }
	
	        result[prop]++;
	      });
	
	      return result;
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name defaults
	 * @kind function
	 *
	 * @description
	 * defaultsFilter allows to specify a default fallback value for properties that resolve to undefined.
	 */
	angular.module('a8m.defaults', [])
	  .filter('defaults', ['$parse', function( $parse ) {
	    return function(collection, defaults) {
	
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || !isObject(defaults)) {
	        return collection;
	      }
	
	      var keys = deepKeys(defaults);
	
	      collection.forEach(function(elm) {
	        //loop through all the keys
	        keys.forEach(function(key) {
	          var getter = $parse(key);
	          var setter = getter.assign;
	          //if it's not exist
	          if(isUndefined(getter(elm))) {
	            //get from defaults, and set to the returned object
	            setter(elm, getter(defaults))
	          }
	        });
	      });
	
	      return collection;
	    }
	  }]);
	/**
	 * @ngdoc filter
	 * @name every
	 * @kind function
	 *
	 * @description
	 * Checks if given expression is present in all members in the collection
	 *
	 */
	angular.module('a8m.every', [])
	  .filter('every', ['$parse', function($parse) {
	    return function (collection, expression) {
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || isUndefined(expression)) {
	        return true;
	      }
	
	      return collection.every( function(elm) {
	        return (isObject(elm) || isFunction(expression))
	          ? $parse(expression)(elm)
	          : elm === expression;
	      });
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name filterBy
	 * @kind function
	 *
	 * @description
	 * filter by specific properties, avoid the rest
	 */
	angular.module('a8m.filter-by', [])
	  .filter('filterBy', ['$parse', function( $parse ) {
	    return function(collection, properties, search, strict) {
	      var comparator;
	
	      search = (isString(search) || isNumber(search)) ?
	        String(search).toLowerCase() : undefined;
	
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || isUndefined(search)) {
	        return collection;
	      }
	
	      return collection.filter(function(elm) {
	        return properties.some(function(prop) {
	
	          /**
	           * check if there is concatenate properties
	           * example:
	           * object: { first: 'foo', last:'bar' }
	           * filterBy: ['first + last'] => search by full name(i.e 'foo bar')
	           */
	          if(!~prop.indexOf('+')) {
	            comparator = $parse(prop)(elm)
	          } else {
	            var propList = prop.replace(/\s+/g, '').split('+');
	            comparator = propList
	              .map(function(prop) { return $parse(prop)(elm); })
	              .join(' ');
	          }
	
	          if (!isString(comparator) && !isNumber(comparator)) {
	            return false;
	          }
	
	          comparator = String(comparator).toLowerCase();
	
	          return strict ? comparator === search : comparator.contains(search);
	        });
	      });
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name first
	 * @kind function
	 *
	 * @description
	 * Gets the first element or first n elements of an array
	 * if callback is provided, is returns as long the callback return truthy
	 */
	angular.module('a8m.first', [])
	  .filter('first', ['$parse', function( $parse ) {
	    return function(collection) {
	      var n
	        , getter
	        , args;
	
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      if(!isArray(collection)) {
	        return collection;
	      }
	
	      args = Array.prototype.slice.call(arguments, 1);
	      n = (isNumber(args[0])) ? args[0] : 1;
	      getter = (!isNumber(args[0]))  ? args[0] : (!isNumber(args[1])) ? args[1] : undefined;
	
	      return (args.length) ? getFirstMatches(collection, n,(getter) ? $parse(getter) : getter) :
	        collection[0];
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name flatten
	 * @kind function
	 *
	 * @description
	 * Flattens a nested array (the nesting can be to any depth).
	 * If you pass shallow, the array will only be flattened a single level
	 */
	angular.module('a8m.flatten', [])
	  .filter('flatten', function () {
	    return function(collection, shallow) {
	
	      shallow = shallow || false;
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      if(!isArray(collection)) {
	        return collection;
	      }
	
	      return !shallow
	        ? flatten(collection, 0)
	        : [].concat.apply([], collection);
	    }
	  });
	
	/**
	 * flatten nested array (the nesting can be to any depth).
	 * @param array {Array}
	 * @param i {int}
	 * @returns {Array}
	 * @private
	 */
	function flatten(array, i) {
	  i = i || 0;
	
	  if(i >= array.length)
	    return array;
	
	  if(isArray(array[i])) {
	    return flatten(array.slice(0,i)
	      .concat(array[i], array.slice(i+1)), i);
	  }
	  return flatten(array, i+1);
	}
	
	/**
	 * @ngdoc filter
	 * @name fuzzyByKey
	 * @kind function
	 *
	 * @description
	 * fuzzy string searching by key
	 */
	angular.module('a8m.fuzzy-by', [])
	  .filter('fuzzyBy', ['$parse', function ( $parse ) {
	    return function (collection, property, search, csensitive) {
	
	      var sensitive = csensitive || false,
	        prop, getter;
	
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || isUndefined(property)
	        || isUndefined(search)) {
	        return collection;
	      }
	
	      getter = $parse(property);
	
	      return collection.filter(function(elm) {
	
	        prop = getter(elm);
	        if(!isString(prop)) {
	          return false;
	        }
	
	        prop = (sensitive) ? prop : prop.toLowerCase();
	        search = (sensitive) ? search : search.toLowerCase();
	
	        return hasApproxPattern(prop, search) !== false
	      })
	    }
	
	 }]);
	/**
	 * @ngdoc filter
	 * @name fuzzy
	 * @kind function
	 *
	 * @description
	 * fuzzy string searching for array of strings, objects
	 */
	angular.module('a8m.fuzzy', [])
	  .filter('fuzzy', function () {
	    return function (collection, search, csensitive) {
	      var sensitive = csensitive || false;
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || isUndefined(search)) {
	        return collection;
	      }
	
	      search = (sensitive) ? search : search.toLowerCase();
	
	      return collection.filter(function(elm) {
	        if(isString(elm)) {
	          elm = (sensitive) ? elm : elm.toLowerCase();
	          return hasApproxPattern(elm, search) !== false
	        }
	        return (isObject(elm)) ? _hasApproximateKey(elm, search) : false;
	      });
	
	      /**
	       * checks if object has key{string} that match
	       * to fuzzy search pattern
	       * @param object
	       * @param search
	       * @returns {boolean}
	       * @private
	       */
	      function _hasApproximateKey(object, search) {
	        var properties = Object.keys(object),
	          prop, flag;
	        return 0 < properties.filter(function (elm) {
	          prop = object[elm];
	
	          //avoid iteration if we found some key that equal[performance]
	          if(flag) return true;
	
	          if (isString(prop)) {
	            prop = (sensitive) ? prop : prop.toLowerCase();
	            return flag = (hasApproxPattern(prop, search) !== false);
	          }
	
	          return false;
	
	        }).length;
	      }
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name groupBy
	 * @kind function
	 *
	 * @description
	 * Create an object composed of keys generated from the result of running each element of a collection,
	 * each key is an array of the elements.
	 */
	
	angular.module('a8m.group-by', [ 'a8m.filter-watcher' ])
	  .filter('groupBy', [ '$parse', 'filterWatcher', function ( $parse, filterWatcher ) {
	    return function (collection, property) {
	
	      if(!isObject(collection) || isUndefined(property)) {
	        return collection;
	      }
	
	      return filterWatcher.isMemoized('groupBy', arguments) ||
	        filterWatcher.memoize('groupBy', arguments, this,
	          _groupBy(collection, $parse(property)));
	
	      /**
	       * groupBy function
	       * @param collection
	       * @param getter
	       * @returns {{}}
	       */
	      function _groupBy(collection, getter) {
	        var result = {};
	        var prop;
	
	        forEach( collection, function( elm ) {
	          prop = getter(elm);
	
	          if(!result[prop]) {
	            result[prop] = [];
	          }
	          result[prop].push(elm);
	        });
	        return result;
	      }
	    }
	 }]);
	
	/**
	 * @ngdoc filter
	 * @name isEmpty
	 * @kind function
	 *
	 * @description
	 * get collection or string and return if it empty
	 */
	angular.module('a8m.is-empty', [])
	  .filter('isEmpty', function () {
	    return function(collection) {
	      return isObject(collection)
	        ? !toArray(collection).length
	        : !collection.length;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name join
	 * @kind function
	 *
	 * @description
	 * join a collection by a provided delimiter (space by default)
	 */
	angular.module('a8m.join', [])
	  .filter('join', function () {
	    return function (input, delimiter) {
	      if (isUndefined(input) || !isArray(input)) {
	        return input;
	      }
	      if (isUndefined(delimiter)) delimiter = ' ';
	
	      return input.join(delimiter);
	    };
	  })
	;
	
	/**
	 * @ngdoc filter
	 * @name last
	 * @kind function
	 *
	 * @description
	 * Gets the last element or last n elements of an array
	 * if callback is provided, is returns as long the callback return truthy
	 */
	angular.module('a8m.last', [])
	  .filter('last', ['$parse', function( $parse ) {
	    return function(collection) {
	      var n
	        , getter
	        , args
	        //cuz reverse change our src collection
	        //and we don't want side effects
	        , reversed = copy(collection);
	
	      reversed = isObject(reversed)
	        ? toArray(reversed)
	        : reversed;
	
	      if(!isArray(reversed)) {
	        return reversed;
	      }
	
	      args = Array.prototype.slice.call(arguments, 1);
	      n = (isNumber(args[0])) ? args[0] : 1;
	      getter = (!isNumber(args[0]))  ? args[0] : (!isNumber(args[1])) ? args[1] : undefined;
	
	      return (args.length)
	        //send reversed collection as arguments, and reverse it back as result
	        ? getFirstMatches(reversed.reverse(), n,(getter) ? $parse(getter) : getter).reverse()
	        //get the last element
	        : reversed[reversed.length-1];
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name map
	 * @kind function
	 *
	 * @description
	 * Returns a new collection of the results of each expression execution.
	 */
	angular.module('a8m.map', [])
	  .filter('map', ['$parse', function($parse) {
	    return function (collection, expression) {
	
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      if(!isArray(collection) || isUndefined(expression)) {
	        return collection;
	      }
	
	      return collection.map(function (elm) {
	        return $parse(expression)(elm);
	      });
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name omit
	 * @kind function
	 *
	 * @description
	 * filter collection by expression
	 */
	
	angular.module('a8m.omit', [])
	
	  .filter('omit', ['$parse', function($parse) {
	    return function (collection, expression) {
	
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      if(!isArray(collection) || isUndefined(expression)) {
	        return collection;
	      }
	
	      return collection.filter(function (elm) {
	        return !($parse(expression)(elm));
	      });
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name pick
	 * @kind function
	 *
	 * @description
	 * filter collection by expression
	 */
	
	angular.module('a8m.pick', [])
	
	  .filter('pick', ['$parse', function($parse) {
	    return function (collection, expression) {
	
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      if(!isArray(collection) || isUndefined(expression)) {
	        return collection;
	      }
	
	      return collection.filter(function (elm) {
	        return $parse(expression)(elm);
	      });
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name range
	 * @kind function
	 *
	 * @description
	 * rangeFilter provides some support for a for loop using numbers
	 */
	angular.module('a8m.range', [])
	  .filter('range', function () {
	    return function (input, total, start, increment, cb) {
	      start = start || 0;
	      increment = increment || 1;
	      for (var i = 0; i < parseInt(total); i++) {
	        var j = start + i * increment;
	        input.push(isFunction(cb) ? cb(j) : j);
	      }
	      return input;
	    };
	  });
	/**
	 * @ngdoc filter
	 * @name removeWith
	 * @kind function
	 *
	 * @description
	 * get collection and properties object, and removed elements
	 * with this properties
	 */
	
	angular.module('a8m.remove-with', [])
	  .filter('removeWith', function() {
	    return function (collection, object) {
	
	      if(isUndefined(object)) {
	        return collection;
	      }
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      return collection.filter(function (elm) {
	        return !objectContains(object, elm);
	      });
	    }
	  });
	
	
	/**
	 * @ngdoc filter
	 * @name remove
	 * @kind function
	 *
	 * @description
	 * remove specific members from collection
	 */
	
	angular.module('a8m.remove', [])
	
	  .filter('remove', function () {
	    return function (collection) {
	      collection = isObject(collection) ? toArray(collection) : collection;
	      var args = Array.prototype.slice.call(arguments, 1);
	
	      if(!isArray(collection)) {
	        return collection;
	      }
	
	      return collection.filter( function( member ) {
	        return !args.some(function(nest) {
	          return equals(nest, member);
	        })
	      });
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name reverse
	 * @kind function
	 *
	 * @description
	 * Reverses a string or collection
	 */
	angular.module('a8m.reverse', [])
	    .filter('reverse',[ function () {
	      return function (input) {
	        input = isObject(input) ? toArray(input) : input;
	
	        if(isString(input)) {
	          return input.split('').reverse().join('');
	        }
	
	        return isArray(input)
	          ? input.slice().reverse()
	          : input;
	      }
	    }]);
	
	/**
	 * @ngdoc filter
	 * @name searchField
	 * @kind function
	 *
	 * @description
	 * for each member, join several strings field and add them to
	 * new field called 'searchField' (use for search filtering)
	 */
	angular.module('a8m.search-field', [])
	  .filter('searchField', ['$parse', function ($parse) {
	    return function (collection) {
	
	      var get, field;
	
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      var args = Array.prototype.slice.call(arguments, 1);
	
	      if(!isArray(collection) || !args.length) {
	        return collection;
	      }
	
	      return collection.map(function(member) {
	
	        field = args.map(function(field) {
	          get = $parse(field);
	          return get(member);
	        }).join(' ');
	
	        return extend(member, { searchField: field });
	      });
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name toArray
	 * @kind function
	 *
	 * @description
	 * Convert objects into stable arrays.
	 * if addKey set to true,the filter also attaches a new property
	 * $key to the value containing the original key that was used in
	 * the object we are iterating over to reference the property
	 */
	angular.module('a8m.to-array', [])
	  .filter('toArray', function() {
	    return function (collection, addKey) {
	
	      if(!isObject(collection)) {
	        return collection;
	      }
	
	      return !addKey
	        ? toArray(collection)
	        : Object.keys(collection).map(function (key) {
	            return extend(collection[key], { $key: key });
	          });
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name unique/uniq
	 * @kind function
	 *
	 * @description
	 * get collection and filter duplicate members
	 * if uniqueFilter get a property(nested to) as argument it's
	 * filter by this property as unique identifier
	 */
	
	angular.module('a8m.unique', [])
	  .filter({
	      unique: ['$parse', uniqFilter],
	      uniq: ['$parse', uniqFilter]
	    });
	
	function uniqFilter($parse) {
	    return function (collection, property) {
	
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if (!isArray(collection)) {
	        return collection;
	      }
	
	      //store all unique identifiers
	      var uniqueItems = [],
	          get = $parse(property);
	
	      return (isUndefined(property))
	        //if it's kind of primitive array
	        ? collection.filter(function (elm, pos, self) {
	          return self.indexOf(elm) === pos;
	        })
	        //else compare with equals
	        : collection.filter(function (elm) {
	          var prop = get(elm);
	          if(some(uniqueItems, prop)) {
	            return false;
	          }
	          uniqueItems.push(prop);
	          return true;
	      });
	
	      //checked if the unique identifier is already exist
	      function some(array, member) {
	        if(isUndefined(member)) {
	          return false;
	        }
	        return array.some(function(el) {
	          return equals(el, member);
	        });
	      }
	    }
	}
	
	/**
	 * @ngdoc filter
	 * @name where
	 * @kind function
	 *
	 * @description
	 * of each element in a collection to the given properties object,
	 * returning an array of all elements that have equivalent property values.
	 *
	 */
	angular.module('a8m.where', [])
	  .filter('where', function() {
	    return function (collection, object) {
	      if(isUndefined(object)) return collection;
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      return collection.filter(function (elm) {
	        return objectContains(object, elm);
	      });
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name xor
	 * @kind function
	 *
	 * @description
	 * Exclusive or filter by expression
	 */
	
	angular.module('a8m.xor', [])
	
	  .filter('xor', ['$parse', function($parse) {
	    return function (col1, col2, expression) {
	
	      expression = expression || false;
	
	      col1 = isObject(col1) ? toArray(col1) : col1;
	      col2 = isObject(col2) ? toArray(col2) : col2;
	
	      if(!isArray(col1) || !isArray(col2)) return col1;
	
	      return col1.concat(col2)
	        .filter(function(elm) {
	          return !(some(elm, col1) && some(elm, col2));
	        });
	
	      function some(el, col) {
	        var getter = $parse(expression);
	        return col.some(function(dElm) {
	          return expression
	            ? equals(getter(dElm), getter(el))
	            : equals(dElm, el);
	        });
	      }
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name abs
	 * @kind function
	 *
	 * @description
	 * Will return the absolute value of a number
	 */
	angular.module('a8m.math.abs', [])
	  .filter('abs', function () {
	    return function (input) {
	      return Math.abs(input);
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name formatBytes
	 * @kind function
	 *
	 * @description
	 * Convert bytes into appropriate display 
	 * 1024 bytes => 1 KB
	 */
	angular.module('a8m.math.byteFmt', [])
	  .filter('byteFmt', function () {
	    var compared = [{str: 'B', val: 1024}];
	    ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'].forEach(function(el, i) {
	      compared.push({str: el, val: compared[i].val * 1024 });
	    });
	    return function (bytes, decimal) {
	      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
	        isNumber(bytes) && isFinite(bytes)) {
	        var i = 0;
	        while (i < compared.length-1 && bytes >= compared[i].val) i++;
	        bytes /= i > 0 ? compared[i-1].val : 1;
	        return convertToDecimal(bytes, decimal) + ' ' + compared[i].str;
	      }
	      return 'NaN';
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name degrees
	 * @kind function
	 *
	 * @description
	 * Convert angle from radians to degrees
	 */
	angular.module('a8m.math.degrees', [])
	  .filter('degrees', function () {
	    return function (radians, decimal) {
	      // if decimal is not an integer greater than -1, we cannot do. quit with error "NaN"
	      // if degrees is not a real number, we cannot do also. quit with error "NaN"
	      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
	        isNumber(radians) && isFinite(radians)) {
	        var degrees = (radians * 180) / Math.PI;
	        return Math.round(degrees * Math.pow(10,decimal)) / (Math.pow(10,decimal));
	      } else {
	        return 'NaN';
	      }
	    }
	  });
	
	 
	 
	/**
	 * @ngdoc filter
	 * @name formatBytes
	 * @kind function
	 *
	 * @description
	 * Convert bytes into appropriate display 
	 * 1024 kilobytes => 1 MB
	 */
	angular.module('a8m.math.kbFmt', [])
	  .filter('kbFmt', function () {
	    var compared = [{str: 'KB', val: 1024}];
	    ['MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'].forEach(function(el, i) {
	      compared.push({str: el, val: compared[i].val * 1024 });
	    });
	    return function (bytes, decimal) {
	      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
	        isNumber(bytes) && isFinite(bytes)) {
	        var i = 0;
	        while (i < compared.length-1 && bytes >= compared[i].val) i++;
	        bytes /= i > 0 ? compared[i-1].val : 1;
	        return convertToDecimal(bytes, decimal) + ' ' + compared[i].str;
	      }
	      return 'NaN';
	    }
	  });
	/**
	 * @ngdoc filter
	 * @name max
	 * @kind function
	 *
	 * @description
	 * Math.max will get an array and return the max value. if an expression
	 * is provided, will return max value by expression.
	 */
	angular.module('a8m.math.max', [])
	  .filter('max', ['$parse', function ($parse) {
	    return function (input, expression) {
	
	      if(!isArray(input)) {
	        return input;
	      }
	      return isUndefined(expression)
	        ? Math.max.apply(Math, input)
	        : input[indexByMax(input, expression)];
	    };
	
	    /**
	     * @private
	     * @param array
	     * @param exp
	     * @returns {number|*|Number}
	     */
	    function indexByMax(array, exp) {
	      var mappedArray = array.map(function(elm){
	        return $parse(exp)(elm);
	      });
	      return mappedArray.indexOf(Math.max.apply(Math, mappedArray));
	    }
	  }]);
	/**
	 * @ngdoc filter
	 * @name min
	 * @kind function
	 *
	 * @description
	 * Math.min will get an array and return the min value. if an expression
	 * is provided, will return min value by expression.
	 */
	angular.module('a8m.math.min', [])
	  .filter('min', ['$parse', function ($parse) {
	    return function (input, expression) {
	
	      if(!isArray(input)) {
	        return input;
	      }
	      return isUndefined(expression)
	        ? Math.min.apply(Math, input)
	        : input[indexByMin(input, expression)];
	    };
	
	    /**
	     * @private
	     * @param array
	     * @param exp
	     * @returns {number|*|Number}
	     */
	    function indexByMin(array, exp) {
	      var mappedArray = array.map(function(elm){
	        return $parse(exp)(elm);
	      });
	      return mappedArray.indexOf(Math.min.apply(Math, mappedArray));
	    }
	  }]);
	/**
	 * @ngdoc filter
	 * @name Percent
	 * @kind function
	 *
	 * @description
	 * percentage between two numbers
	 */
	angular.module('a8m.math.percent', [])
	  .filter('percent', function () {
	    return function (input, divided, round) {
	
	      var divider = isString(input) ? Number(input) : input;
	      divided = divided || 100;
	      round = round || false;
	
	      if (!isNumber(divider) || isNaN(divider)) return input;
	
	      return round
	        ? Math.round((divider / divided) * 100)
	        : (divider / divided) * 100;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name toRadians
	 * @kind function
	 *
	 * @description
	 * Convert angle from degrees to radians
	 */
	angular.module('a8m.math.radians', [])
	  .filter('radians', function() {
	    return function (degrees, decimal) {
	      // if decimal is not an integer greater than -1, we cannot do. quit with error "NaN"
	      // if degrees is not a real number, we cannot do also. quit with error "NaN"
	      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
	        isNumber(degrees) && isFinite(degrees)) {
	        var radians = (degrees * 3.14159265359) / 180;
	        return Math.round(radians * Math.pow(10,decimal)) / (Math.pow(10,decimal));
	      }
	      return 'NaN';
	    }
	  });
	
	 
	 
	/**
	 * @ngdoc filter
	 * @name Radix
	 * @kind function
	 *
	 * @description
	 * converting decimal numbers to different bases(radix)
	 */
	angular.module('a8m.math.radix', [])
	  .filter('radix', function () {
	    return function (input, radix) {
	      var RANGE = /^[2-9]$|^[1-2]\d$|^3[0-6]$/;
	
	      if(!isNumber(input) || !RANGE.test(radix)) {
	        return input;
	      }
	
	      return input.toString(radix).toUpperCase();
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name formatBytes
	 * @kind function
	 *
	 * @description
	 * Convert number into abbreviations.
	 * i.e: K for one thousand, M for Million, B for billion
	 * e.g: number of users:235,221, decimal:1 => 235.2 K
	 */
	angular.module('a8m.math.shortFmt', [])
	  .filter('shortFmt', function () {
	    return function (number, decimal) {
	      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
	        isNumber(number) && isFinite(number)){
	        if(number < 1e3) {
	          return '' + number;  // Coerce to string
	        } else if(number < 1e6) {
	          return convertToDecimal((number / 1e3), decimal) + ' K';
	        } else if(number < 1e9){
	          return convertToDecimal((number / 1e6), decimal) + ' M';
	        } else {
	          return convertToDecimal((number / 1e9), decimal) + ' B';
	        }
	
	      }
	      return 'NaN';
	    }
	  });
	/**
	 * @ngdoc filter
	 * @name sum
	 * @kind function
	 *
	 * @description
	 * Sum up all values within an array
	 */
	angular.module('a8m.math.sum', [])
	  .filter('sum', function () {
	    return function (input, initial) {
	      return !isArray(input)
	        ? input
	        : input.reduce(function(prev, curr) {
	          return prev + curr;
	        }, initial || 0);
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name endsWith
	 * @kind function
	 *
	 * @description
	 * checks whether string ends with the ends parameter.
	 */
	angular.module('a8m.ends-with', [])
	
	  .filter('endsWith', function () {
	    return function (input, ends, csensitive) {
	
	      var sensitive = csensitive || false,
	        position;
	
	      if(!isString(input) || isUndefined(ends)) {
	        return input;
	      }
	
	      input = (sensitive) ? input : input.toLowerCase();
	      position = input.length - ends.length;
	
	      return input.indexOf((sensitive) ? ends : ends.toLowerCase(), position) !== -1;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name latinize
	 * @kind function
	 *
	 * @description
	 * remove accents/diacritics from a string
	 */
	angular.module('a8m.latinize', [])
	  .filter('latinize',[ function () {
	    var defaultDiacriticsRemovalap = [
	      {'base':'A', 'letters':'\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'},
	      {'base':'AA','letters':'\uA732'},
	      {'base':'AE','letters':'\u00C6\u01FC\u01E2'},
	      {'base':'AO','letters':'\uA734'},
	      {'base':'AU','letters':'\uA736'},
	      {'base':'AV','letters':'\uA738\uA73A'},
	      {'base':'AY','letters':'\uA73C'},
	      {'base':'B', 'letters':'\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'},
	      {'base':'C', 'letters':'\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'},
	      {'base':'D', 'letters':'\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'},
	      {'base':'DZ','letters':'\u01F1\u01C4'},
	      {'base':'Dz','letters':'\u01F2\u01C5'},
	      {'base':'E', 'letters':'\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'},
	      {'base':'F', 'letters':'\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'},
	      {'base':'G', 'letters':'\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'},
	      {'base':'H', 'letters':'\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'},
	      {'base':'I', 'letters':'\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'},
	      {'base':'J', 'letters':'\u004A\u24BF\uFF2A\u0134\u0248'},
	      {'base':'K', 'letters':'\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'},
	      {'base':'L', 'letters':'\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'},
	      {'base':'LJ','letters':'\u01C7'},
	      {'base':'Lj','letters':'\u01C8'},
	      {'base':'M', 'letters':'\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'},
	      {'base':'N', 'letters':'\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'},
	      {'base':'NJ','letters':'\u01CA'},
	      {'base':'Nj','letters':'\u01CB'},
	      {'base':'O', 'letters':'\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'},
	      {'base':'OI','letters':'\u01A2'},
	      {'base':'OO','letters':'\uA74E'},
	      {'base':'OU','letters':'\u0222'},
	      {'base':'OE','letters':'\u008C\u0152'},
	      {'base':'oe','letters':'\u009C\u0153'},
	      {'base':'P', 'letters':'\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'},
	      {'base':'Q', 'letters':'\u0051\u24C6\uFF31\uA756\uA758\u024A'},
	      {'base':'R', 'letters':'\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'},
	      {'base':'S', 'letters':'\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'},
	      {'base':'T', 'letters':'\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'},
	      {'base':'TZ','letters':'\uA728'},
	      {'base':'U', 'letters':'\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'},
	      {'base':'V', 'letters':'\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'},
	      {'base':'VY','letters':'\uA760'},
	      {'base':'W', 'letters':'\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'},
	      {'base':'X', 'letters':'\u0058\u24CD\uFF38\u1E8A\u1E8C'},
	      {'base':'Y', 'letters':'\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'},
	      {'base':'Z', 'letters':'\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'},
	      {'base':'a', 'letters':'\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'},
	      {'base':'aa','letters':'\uA733'},
	      {'base':'ae','letters':'\u00E6\u01FD\u01E3'},
	      {'base':'ao','letters':'\uA735'},
	      {'base':'au','letters':'\uA737'},
	      {'base':'av','letters':'\uA739\uA73B'},
	      {'base':'ay','letters':'\uA73D'},
	      {'base':'b', 'letters':'\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'},
	      {'base':'c', 'letters':'\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'},
	      {'base':'d', 'letters':'\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'},
	      {'base':'dz','letters':'\u01F3\u01C6'},
	      {'base':'e', 'letters':'\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'},
	      {'base':'f', 'letters':'\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'},
	      {'base':'g', 'letters':'\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'},
	      {'base':'h', 'letters':'\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'},
	      {'base':'hv','letters':'\u0195'},
	      {'base':'i', 'letters':'\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'},
	      {'base':'j', 'letters':'\u006A\u24D9\uFF4A\u0135\u01F0\u0249'},
	      {'base':'k', 'letters':'\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'},
	      {'base':'l', 'letters':'\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'},
	      {'base':'lj','letters':'\u01C9'},
	      {'base':'m', 'letters':'\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'},
	      {'base':'n', 'letters':'\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'},
	      {'base':'nj','letters':'\u01CC'},
	      {'base':'o', 'letters':'\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'},
	      {'base':'oi','letters':'\u01A3'},
	      {'base':'ou','letters':'\u0223'},
	      {'base':'oo','letters':'\uA74F'},
	      {'base':'p','letters':'\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'},
	      {'base':'q','letters':'\u0071\u24E0\uFF51\u024B\uA757\uA759'},
	      {'base':'r','letters':'\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'},
	      {'base':'s','letters':'\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'},
	      {'base':'t','letters':'\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'},
	      {'base':'tz','letters':'\uA729'},
	      {'base':'u','letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'},
	      {'base':'v','letters':'\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'},
	      {'base':'vy','letters':'\uA761'},
	      {'base':'w','letters':'\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'},
	      {'base':'x','letters':'\u0078\u24E7\uFF58\u1E8B\u1E8D'},
	      {'base':'y','letters':'\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'},
	      {'base':'z','letters':'\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'}
	    ];
	
	    var diacriticsMap = {};
	    for (var i = 0; i < defaultDiacriticsRemovalap.length; i++) {
	      var letters = defaultDiacriticsRemovalap[i].letters.split("");
	      for (var j = 0; j < letters.length ; j++){
	        diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
	      }
	    }
	
	    // "what?" version ... http://jsperf.com/diacritics/12
	    function removeDiacritics (str) {
	      return str.replace(/[^\u0000-\u007E]/g, function(a){
	        return diacriticsMap[a] || a;
	      });
	    }
	
	    return function (input) {
	
	      return isString(input)
	        ? removeDiacritics(input)
	        : input;
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name ltrim
	 * @kind function
	 *
	 * @description
	 * Left trim. Similar to trimFilter, but only for left side.
	 */
	angular.module('a8m.ltrim', [])
	  .filter('ltrim', function () {
	    return function(input, chars) {
	
	      var trim = chars || '\\s';
	
	      return isString(input)
	        ? input.replace(new RegExp('^' + trim + '+'), '')
	        : input;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name match
	 * @kind function
	 *
	 * @description
	 * Return the matched pattern in a string.
	 */
	angular.module('a8m.match', [])
	  .filter('match', function () {
	    return function (input, pattern, flag) {
	
	      var reg = new RegExp(pattern, flag);
	
	      return isString(input)
	        ? input.match(reg)
	        : null;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name phone-us
	 * @kind function
	 *
	 * @description
	 * format a string or a number into a us-style
	 * phone number in the form (***) ***-****
	 */
	angular.module('a8m.phoneUS', [])
	  .filter('phoneUS', function () {
	    return function(num) {
	      num += '';
	      return '(' + num.slice(0, 3) + ') ' + num.slice(3, 6) + '-' + num.slice(6);
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name repeat
	 * @kind function
	 *
	 * @description
	 * Repeats a string n times
	 */
	angular.module('a8m.repeat', [])
	  .filter('repeat',[ function () {
	    return function (input, n, separator) {
	
	      var times = ~~n;
	
	      if(!isString(input)) {
	        return input;
	      }
	
	      return !times
	        ? input
	        : strRepeat(input, --n, separator || '');
	    }
	  }]);
	
	/**
	 * Repeats a string n times with given separator
	 * @param str string to repeat
	 * @param n number of times
	 * @param sep separator
	 * @returns {*}
	 */
	function strRepeat(str, n, sep) {
	  if(!n) {
	    return str;
	  }
	  return str + sep + strRepeat(str, --n, sep);
	}
	/**
	* @ngdoc filter
	* @name rtrim
	* @kind function
	*
	* @description
	* Right trim. Similar to trimFilter, but only for right side.
	*/
	angular.module('a8m.rtrim', [])
	  .filter('rtrim', function () {
	    return function(input, chars) {
	
	      var trim = chars || '\\s';
	
	      return isString(input)
	        ? input.replace(new RegExp(trim + '+$'), '')
	        : input;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name slugify
	 * @kind function
	 *
	 * @description
	 * remove spaces from string, replace with "-" or given argument
	 */
	angular.module('a8m.slugify', [])
	  .filter('slugify',[ function () {
	    return function (input, sub) {
	
	      var replace = (isUndefined(sub)) ? '-' : sub;
	
	      return isString(input)
	        ? input.toLowerCase().replace(/\s+/g, replace)
	        : input;
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name split
	 * @kind function
	 *
	 * @description
	 * split a string by a provided delimiter (none '' by default) and skip first n-delimiters
	 */
	angular.module('a8m.split', [])
	  .filter('split', function () {
	    function escapeRegExp(str) {
	      return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	    }
	
	    return function (input, delimiter, skip) {
	      var _regexp, _matches, _splitted, _temp;
	
	      if (isUndefined(input) || !isString(input)) {
	        return null;
	      }
	      if (isUndefined(delimiter)) delimiter = '';
	      if (isNaN(skip)) skip = 0;
	
	      _regexp = new RegExp(escapeRegExp(delimiter), 'g');
	      _matches = input.match(_regexp);
	      
	      if (isNull(_matches) || skip >= _matches.length) {
	        return [input];
	      }
	
	      if (skip === 0) return input.split(delimiter);
	      
	      _splitted = input.split(delimiter);
	      _temp = _splitted.splice(0, skip + 1);
	      _splitted.unshift(_temp.join(delimiter));
	    
	      return _splitted;
	    };
	  })
	;
	
	/**
	 * @ngdoc filter
	 * @name startWith
	 * @kind function
	 *
	 * @description
	 * checks whether string starts with the starts parameter.
	 */
	angular.module('a8m.starts-with', [])
	  .filter('startsWith', function () {
	    return function (input, start, csensitive) {
	
	      var sensitive = csensitive || false;
	
	      if(!isString(input) || isUndefined(start)) {
	        return input;
	      }
	
	      input = (sensitive) ? input : input.toLowerCase();
	
	      return !input.indexOf((sensitive) ? start : start.toLowerCase());
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name stringular
	 * @kind function
	 *
	 * @description
	 * get string with {n} and replace match with enumeration values
	 */
	angular.module('a8m.stringular', [])
	  .filter('stringular', function () {
	    return function(input) {
	
	      var args = Array.prototype.slice.call(arguments, 1);
	
	      return input.replace(/{(\d+)}/g, function (match, number) {
	        return isUndefined(args[number]) ? match : args[number];
	      });
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name stripTags
	 * @kind function
	 *
	 * @description
	 * strip html tags from string
	 */
	angular.module('a8m.strip-tags', [])
	  .filter('stripTags', function () {
	    return function(input) {
	      return isString(input)
	        ? input.replace(/<\S[^><]*>/g, '')
	        : input;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name test
	 * @kind function
	 *
	 * @description
	 * test if a string match a pattern.
	 */
	angular.module('a8m.test', [])
	  .filter('test', function () {
	    return function (input, pattern, flag) {
	
	      var reg = new RegExp(pattern, flag);
	
	      return isString(input)
	        ? reg.test(input)
	        : input;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name trim
	 * @kind function
	 *
	 * @description
	 *  Strip whitespace (or other characters) from the beginning and end of a string
	 */
	angular.module('a8m.trim', [])
	  .filter('trim', function () {
	    return function(input, chars) {
	
	      var trim = chars || '\\s';
	
	      return isString(input)
	        ? input.replace(new RegExp('^' + trim + '+|' + trim + '+$', 'g'), '')
	        : input;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name truncate
	 * @kind function
	 *
	 * @description
	 * truncates a string given a specified length, providing a custom string to denote an omission.
	 */
	angular.module('a8m.truncate', [])
	  .filter('truncate', function () {
	    return function(input, length, suffix, preserve) {
	
	      length = isUndefined(length) ? input.length : length;
	      preserve = preserve || false;
	      suffix = suffix || '';
	
	      if(!isString(input) || (input.length <= length)) return input;
	
	      return input.substring(0, (preserve)
	        ? ((input.indexOf(' ', length) === -1) ? input.length : input.indexOf(' ', length))
	        : length) + suffix;
	    };
	  });
	
	/**
	 * @ngdoc filter
	 * @name ucfirst
	 * @kind function
	 *
	 * @description
	 * ucfirst
	 */
	angular.module('a8m.ucfirst', [])
	  .filter({
	    ucfirst: ucfirstFilter,
	    titleize: ucfirstFilter
	  });
	
	function ucfirstFilter() {
	  return function (input) {
	    return isString(input)
	      ? input
	      .split(' ')
	      .map(function (ch) {
	        return ch.charAt(0).toUpperCase() + ch.substring(1);
	      })
	      .join(' ')
	      : input;
	  }
	}
	
	/**
	 * @ngdoc filter
	 * @name uriComponentEncode
	 * @kind function
	 *
	 * @description
	 * get string as parameter and return encoded string
	 */
	angular.module('a8m.uri-component-encode', [])
	  .filter('uriComponentEncode',['$window', function ($window) {
	      return function (input) {
	        return isString(input)
	          ? $window.encodeURIComponent(input)
	          : input;
	      }
	    }]);
	
	/**
	 * @ngdoc filter
	 * @name uriEncode
	 * @kind function
	 *
	 * @description
	 * get string as parameter and return encoded string
	 */
	angular.module('a8m.uri-encode', [])
	  .filter('uriEncode',['$window', function ($window) {
	      return function (input) {
	        return isString(input)
	          ? $window.encodeURI(input)
	          : input;
	      }
	    }]);
	
	/**
	 * @ngdoc filter
	 * @name wrap
	 * @kind function
	 *
	 * @description
	 * Wrap a string with another string
	 */
	angular.module('a8m.wrap', [])
	  .filter('wrap', function () {
	    return function(input, wrap, ends) {
	      return isString(input) && isDefined(wrap)
	        ? [wrap, input, ends || wrap].join('')
	        : input;
	    }
	  });
	
	/**
	 * @ngdoc provider
	 * @name filterWatcher
	 * @kind function
	 *
	 * @description
	 * store specific filters result in $$cache, based on scope life time(avoid memory leak).
	 * on scope.$destroy remove it's cache from $$cache container
	 */
	
	angular.module('a8m.filter-watcher', [])
	  .provider('filterWatcher', function() {
	
	    this.$get = ['$window', '$rootScope', function($window, $rootScope) {
	
	      /**
	       * Cache storing
	       * @type {Object}
	       */
	      var $$cache = {};
	
	      /**
	       * Scope listeners container
	       * scope.$destroy => remove all cache keys
	       * bind to current scope.
	       * @type {Object}
	       */
	      var $$listeners = {};
	
	      /**
	       * $timeout without triggering the digest cycle
	       * @type {function}
	       */
	      var $$timeout = $window.setTimeout;
	
	      /**
	       * @description
	       * get `HashKey` string based on the given arguments.
	       * @param fName
	       * @param args
	       * @returns {string}
	       */
	      function getHashKey(fName, args) {
	        function replacerFactory() {
	          var cache = [];
	          return function(key, val) {
	            if(isObject(val) && !isNull(val)) {
	              if (~cache.indexOf(val)) return '[Circular]';
	              cache.push(val)
	            }
	            if($window == val) return '$WINDOW';
	            if($window.document == val) return '$DOCUMENT';
	            if(isScope(val)) return '$SCOPE';
	            return val;
	          }
	        }
	        return [fName, JSON.stringify(args, replacerFactory())]
	          .join('#')
	          .replace(/"/g,'');
	      }
	
	      /**
	       * @description
	       * fir on $scope.$destroy,
	       * remove cache based scope from `$$cache`,
	       * and remove itself from `$$listeners`
	       * @param event
	       */
	      function removeCache(event) {
	        var id = event.targetScope.$id;
	        forEach($$listeners[id], function(key) {
	          delete $$cache[key];
	        });
	        delete $$listeners[id];
	      }
	
	      /**
	       * @description
	       * for angular version that greater than v.1.3.0
	       * it clear cache when the digest cycle is end.
	       */
	      function cleanStateless() {
	        $$timeout(function() {
	          if(!$rootScope.$$phase)
	            $$cache = {};
	        }, 2000);
	      }
	
	      /**
	       * @description
	       * Store hashKeys in $$listeners container
	       * on scope.$destroy, remove them all(bind an event).
	       * @param scope
	       * @param hashKey
	       * @returns {*}
	       */
	      function addListener(scope, hashKey) {
	        var id = scope.$id;
	        if(isUndefined($$listeners[id])) {
	          scope.$on('$destroy', removeCache);
	          $$listeners[id] = [];
	        }
	        return $$listeners[id].push(hashKey);
	      }
	
	      /**
	       * @description
	       * return the `cacheKey` or undefined.
	       * @param filterName
	       * @param args
	       * @returns {*}
	       */
	      function $$isMemoized(filterName, args) {
	        var hashKey = getHashKey(filterName, args);
	        return $$cache[hashKey];
	      }
	
	      /**
	       * @description
	       * store `result` in `$$cache` container, based on the hashKey.
	       * add $destroy listener and return result
	       * @param filterName
	       * @param args
	       * @param scope
	       * @param result
	       * @returns {*}
	       */
	      function $$memoize(filterName, args, scope, result) {
	        var hashKey = getHashKey(filterName, args);
	        //store result in `$$cache` container
	        $$cache[hashKey] = result;
	        // for angular versions that less than 1.3
	        // add to `$destroy` listener, a cleaner callback
	        if(isScope(scope)) {
	          addListener(scope, hashKey);
	        } else {
	          cleanStateless();
	        }
	        return result;
	      }
	
	      return {
	        isMemoized: $$isMemoized,
	        memoize: $$memoize
	      }
	    }];
	  });
	  
	
	/**
	 * @ngdoc module
	 * @name angular.filters
	 * @description
	 * Bunch of useful filters for angularJS
	 */
	
	angular.module('angular.filter', [
	
	  'a8m.ucfirst',
	  'a8m.uri-encode',
	  'a8m.uri-component-encode',
	  'a8m.slugify',
	  'a8m.latinize',
	  'a8m.strip-tags',
	  'a8m.stringular',
	  'a8m.truncate',
	  'a8m.starts-with',
	  'a8m.ends-with',
	  'a8m.wrap',
	  'a8m.trim',
	  'a8m.ltrim',
	  'a8m.rtrim',
	  'a8m.repeat',
	  'a8m.test',
	  'a8m.match',
	  'a8m.split',
	  'a8m.phoneUS',
	
	  'a8m.to-array',
	  'a8m.concat',
	  'a8m.contains',
	  'a8m.unique',
	  'a8m.is-empty',
	  'a8m.after',
	  'a8m.after-where',
	  'a8m.before',
	  'a8m.before-where',
	  'a8m.defaults',
	  'a8m.where',
	  'a8m.reverse',
	  'a8m.remove',
	  'a8m.remove-with',
	  'a8m.group-by',
	  'a8m.count-by',
	  'a8m.chunk-by',
	  'a8m.search-field',
	  'a8m.fuzzy-by',
	  'a8m.fuzzy',
	  'a8m.omit',
	  'a8m.pick',
	  'a8m.every',
	  'a8m.filter-by',
	  'a8m.xor',
	  'a8m.map',
	  'a8m.first',
	  'a8m.last',
	  'a8m.flatten',
	  'a8m.join',
	  'a8m.range',
	
	  'a8m.math.max',
	  'a8m.math.min',
	  'a8m.math.abs',
	  'a8m.math.percent',
	  'a8m.math.radix',
	  'a8m.math.sum',
	  'a8m.math.degrees',
	  'a8m.math.radians',
	  'a8m.math.byteFmt',
	  'a8m.math.kbFmt',
	  'a8m.math.shortFmt',
	
	  'a8m.angular',
	  'a8m.conditions',
	  'a8m.is-null',
	
	  'a8m.filter-watcher'
	]);
	})( window, window.angular );

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(497);
	module.exports = 'angular.filter';


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(501));
		else if(typeof define === 'function' && define.amd)
			define(["angular"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("angular")) : factory(root["angular"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(this, function(__WEBPACK_EXTERNAL_MODULE_5__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/*!********************************!*\
	  !*** ./src/angular-spinner.ts ***!
	  \********************************/
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var SpinJSSpinner_1 = __webpack_require__(/*! ./Constants/SpinJSSpinner */ 1);
		var UsSpinnerService_1 = __webpack_require__(/*! ./Services/UsSpinnerService */ 3);
		var AngularSpinner_1 = __webpack_require__(/*! ./Directives/AngularSpinner */ 4);
		var UsSpinnerConfig_1 = __webpack_require__(/*! ./Config/UsSpinnerConfig */ 6);
		var angular = __webpack_require__(/*! angular */ 5);
		exports.angularSpinner = angular
		    .module('angularSpinner', [])
		    .provider('usSpinnerConfig', UsSpinnerConfig_1.UsSpinnerConfig)
		    .constant('SpinJSSpinner', SpinJSSpinner_1.SpinJSSpinner)
		    .service('usSpinnerService', UsSpinnerService_1.UsSpinnerService)
		    .directive('usSpinner', AngularSpinner_1.usSpinner);
	
	
	/***/ },
	/* 1 */
	/*!****************************************!*\
	  !*** ./src/Constants/SpinJSSpinner.ts ***!
	  \****************************************/
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var Spinner = __webpack_require__(/*! spin.js */ 2);
		/**
		 * Exporting the Spinner prototype from spin.js library
		 */
		exports.SpinJSSpinner = Spinner;
	
	
	/***/ },
	/* 2 */
	/*!***************************!*\
	  !*** ./~/spin.js/spin.js ***!
	  \***************************/
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
		 * Copyright (c) 2011-2014 Felix Gnass
		 * Licensed under the MIT license
		 * http://spin.js.org/
		 *
		 * Example:
		    var opts = {
		      lines: 12             // The number of lines to draw
		    , length: 7             // The length of each line
		    , width: 5              // The line thickness
		    , radius: 10            // The radius of the inner circle
		    , scale: 1.0            // Scales overall size of the spinner
		    , corners: 1            // Roundness (0..1)
		    , color: '#000'         // #rgb or #rrggbb
		    , opacity: 1/4          // Opacity of the lines
		    , rotate: 0             // Rotation offset
		    , direction: 1          // 1: clockwise, -1: counterclockwise
		    , speed: 1              // Rounds per second
		    , trail: 100            // Afterglow percentage
		    , fps: 20               // Frames per second when using setTimeout()
		    , zIndex: 2e9           // Use a high z-index by default
		    , className: 'spinner'  // CSS class to assign to the element
		    , top: '50%'            // center vertically
		    , left: '50%'           // center horizontally
		    , shadow: false         // Whether to render a shadow
		    , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
		    , position: 'absolute'  // Element positioning
		    }
		    var target = document.getElementById('foo')
		    var spinner = new Spinner(opts).spin(target)
		 */
		;(function (root, factory) {
		
		  /* CommonJS */
		  if (typeof module == 'object' && module.exports) module.exports = factory()
		
		  /* AMD module */
		  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
		
		  /* Browser global */
		  else root.Spinner = factory()
		}(this, function () {
		  "use strict"
		
		  var prefixes = ['webkit', 'Moz', 'ms', 'O'] /* Vendor prefixes */
		    , animations = {} /* Animation rules keyed by their name */
		    , useCssAnimations /* Whether to use CSS animations or setTimeout */
		    , sheet /* A stylesheet to hold the @keyframe or VML rules. */
		
		  /**
		   * Utility function to create elements. If no tag name is given,
		   * a DIV is created. Optionally properties can be passed.
		   */
		  function createEl (tag, prop) {
		    var el = document.createElement(tag || 'div')
		      , n
		
		    for (n in prop) el[n] = prop[n]
		    return el
		  }
		
		  /**
		   * Appends children and returns the parent.
		   */
		  function ins (parent /* child1, child2, ...*/) {
		    for (var i = 1, n = arguments.length; i < n; i++) {
		      parent.appendChild(arguments[i])
		    }
		
		    return parent
		  }
		
		  /**
		   * Creates an opacity keyframe animation rule and returns its name.
		   * Since most mobile Webkits have timing issues with animation-delay,
		   * we create separate rules for each line/segment.
		   */
		  function addAnimation (alpha, trail, i, lines) {
		    var name = ['opacity', trail, ~~(alpha * 100), i, lines].join('-')
		      , start = 0.01 + i/lines * 100
		      , z = Math.max(1 - (1-alpha) / trail * (100-start), alpha)
		      , prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase()
		      , pre = prefix && '-' + prefix + '-' || ''
		
		    if (!animations[name]) {
		      sheet.insertRule(
		        '@' + pre + 'keyframes ' + name + '{' +
		        '0%{opacity:' + z + '}' +
		        start + '%{opacity:' + alpha + '}' +
		        (start+0.01) + '%{opacity:1}' +
		        (start+trail) % 100 + '%{opacity:' + alpha + '}' +
		        '100%{opacity:' + z + '}' +
		        '}', sheet.cssRules.length)
		
		      animations[name] = 1
		    }
		
		    return name
		  }
		
		  /**
		   * Tries various vendor prefixes and returns the first supported property.
		   */
		  function vendor (el, prop) {
		    var s = el.style
		      , pp
		      , i
		
		    prop = prop.charAt(0).toUpperCase() + prop.slice(1)
		    if (s[prop] !== undefined) return prop
		    for (i = 0; i < prefixes.length; i++) {
		      pp = prefixes[i]+prop
		      if (s[pp] !== undefined) return pp
		    }
		  }
		
		  /**
		   * Sets multiple style properties at once.
		   */
		  function css (el, prop) {
		    for (var n in prop) {
		      el.style[vendor(el, n) || n] = prop[n]
		    }
		
		    return el
		  }
		
		  /**
		   * Fills in default values.
		   */
		  function merge (obj) {
		    for (var i = 1; i < arguments.length; i++) {
		      var def = arguments[i]
		      for (var n in def) {
		        if (obj[n] === undefined) obj[n] = def[n]
		      }
		    }
		    return obj
		  }
		
		  /**
		   * Returns the line color from the given string or array.
		   */
		  function getColor (color, idx) {
		    return typeof color == 'string' ? color : color[idx % color.length]
		  }
		
		  // Built-in defaults
		
		  var defaults = {
		    lines: 12             // The number of lines to draw
		  , length: 7             // The length of each line
		  , width: 5              // The line thickness
		  , radius: 10            // The radius of the inner circle
		  , scale: 1.0            // Scales overall size of the spinner
		  , corners: 1            // Roundness (0..1)
		  , color: '#000'         // #rgb or #rrggbb
		  , opacity: 1/4          // Opacity of the lines
		  , rotate: 0             // Rotation offset
		  , direction: 1          // 1: clockwise, -1: counterclockwise
		  , speed: 1              // Rounds per second
		  , trail: 100            // Afterglow percentage
		  , fps: 20               // Frames per second when using setTimeout()
		  , zIndex: 2e9           // Use a high z-index by default
		  , className: 'spinner'  // CSS class to assign to the element
		  , top: '50%'            // center vertically
		  , left: '50%'           // center horizontally
		  , shadow: false         // Whether to render a shadow
		  , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
		  , position: 'absolute'  // Element positioning
		  }
		
		  /** The constructor */
		  function Spinner (o) {
		    this.opts = merge(o || {}, Spinner.defaults, defaults)
		  }
		
		  // Global defaults that override the built-ins:
		  Spinner.defaults = {}
		
		  merge(Spinner.prototype, {
		    /**
		     * Adds the spinner to the given target element. If this instance is already
		     * spinning, it is automatically removed from its previous target b calling
		     * stop() internally.
		     */
		    spin: function (target) {
		      this.stop()
		
		      var self = this
		        , o = self.opts
		        , el = self.el = createEl(null, {className: o.className})
		
		      css(el, {
		        position: o.position
		      , width: 0
		      , zIndex: o.zIndex
		      , left: o.left
		      , top: o.top
		      })
		
		      if (target) {
		        target.insertBefore(el, target.firstChild || null)
		      }
		
		      el.setAttribute('role', 'progressbar')
		      self.lines(el, self.opts)
		
		      if (!useCssAnimations) {
		        // No CSS animation support, use setTimeout() instead
		        var i = 0
		          , start = (o.lines - 1) * (1 - o.direction) / 2
		          , alpha
		          , fps = o.fps
		          , f = fps / o.speed
		          , ostep = (1 - o.opacity) / (f * o.trail / 100)
		          , astep = f / o.lines
		
		        ;(function anim () {
		          i++
		          for (var j = 0; j < o.lines; j++) {
		            alpha = Math.max(1 - (i + (o.lines - j) * astep) % f * ostep, o.opacity)
		
		            self.opacity(el, j * o.direction + start, alpha, o)
		          }
		          self.timeout = self.el && setTimeout(anim, ~~(1000 / fps))
		        })()
		      }
		      return self
		    }
		
		    /**
		     * Stops and removes the Spinner.
		     */
		  , stop: function () {
		      var el = this.el
		      if (el) {
		        clearTimeout(this.timeout)
		        if (el.parentNode) el.parentNode.removeChild(el)
		        this.el = undefined
		      }
		      return this
		    }
		
		    /**
		     * Internal method that draws the individual lines. Will be overwritten
		     * in VML fallback mode below.
		     */
		  , lines: function (el, o) {
		      var i = 0
		        , start = (o.lines - 1) * (1 - o.direction) / 2
		        , seg
		
		      function fill (color, shadow) {
		        return css(createEl(), {
		          position: 'absolute'
		        , width: o.scale * (o.length + o.width) + 'px'
		        , height: o.scale * o.width + 'px'
		        , background: color
		        , boxShadow: shadow
		        , transformOrigin: 'left'
		        , transform: 'rotate(' + ~~(360/o.lines*i + o.rotate) + 'deg) translate(' + o.scale*o.radius + 'px' + ',0)'
		        , borderRadius: (o.corners * o.scale * o.width >> 1) + 'px'
		        })
		      }
		
		      for (; i < o.lines; i++) {
		        seg = css(createEl(), {
		          position: 'absolute'
		        , top: 1 + ~(o.scale * o.width / 2) + 'px'
		        , transform: o.hwaccel ? 'translate3d(0,0,0)' : ''
		        , opacity: o.opacity
		        , animation: useCssAnimations && addAnimation(o.opacity, o.trail, start + i * o.direction, o.lines) + ' ' + 1 / o.speed + 's linear infinite'
		        })
		
		        if (o.shadow) ins(seg, css(fill('#000', '0 0 4px #000'), {top: '2px'}))
		        ins(el, ins(seg, fill(getColor(o.color, i), '0 0 1px rgba(0,0,0,.1)')))
		      }
		      return el
		    }
		
		    /**
		     * Internal method that adjusts the opacity of a single line.
		     * Will be overwritten in VML fallback mode below.
		     */
		  , opacity: function (el, i, val) {
		      if (i < el.childNodes.length) el.childNodes[i].style.opacity = val
		    }
		
		  })
		
		
		  function initVML () {
		
		    /* Utility function to create a VML tag */
		    function vml (tag, attr) {
		      return createEl('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', attr)
		    }
		
		    // No CSS transforms but VML support, add a CSS rule for VML elements:
		    sheet.addRule('.spin-vml', 'behavior:url(#default#VML)')
		
		    Spinner.prototype.lines = function (el, o) {
		      var r = o.scale * (o.length + o.width)
		        , s = o.scale * 2 * r
		
		      function grp () {
		        return css(
		          vml('group', {
		            coordsize: s + ' ' + s
		          , coordorigin: -r + ' ' + -r
		          })
		        , { width: s, height: s }
		        )
		      }
		
		      var margin = -(o.width + o.length) * o.scale * 2 + 'px'
		        , g = css(grp(), {position: 'absolute', top: margin, left: margin})
		        , i
		
		      function seg (i, dx, filter) {
		        ins(
		          g
		        , ins(
		            css(grp(), {rotation: 360 / o.lines * i + 'deg', left: ~~dx})
		          , ins(
		              css(
		                vml('roundrect', {arcsize: o.corners})
		              , { width: r
		                , height: o.scale * o.width
		                , left: o.scale * o.radius
		                , top: -o.scale * o.width >> 1
		                , filter: filter
		                }
		              )
		            , vml('fill', {color: getColor(o.color, i), opacity: o.opacity})
		            , vml('stroke', {opacity: 0}) // transparent stroke to fix color bleeding upon opacity change
		            )
		          )
		        )
		      }
		
		      if (o.shadow)
		        for (i = 1; i <= o.lines; i++) {
		          seg(i, -2, 'progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)')
		        }
		
		      for (i = 1; i <= o.lines; i++) seg(i)
		      return ins(el, g)
		    }
		
		    Spinner.prototype.opacity = function (el, i, val, o) {
		      var c = el.firstChild
		      o = o.shadow && o.lines || 0
		      if (c && i + o < c.childNodes.length) {
		        c = c.childNodes[i + o]; c = c && c.firstChild; c = c && c.firstChild
		        if (c) c.opacity = val
		      }
		    }
		  }
		
		  if (typeof document !== 'undefined') {
		    sheet = (function () {
		      var el = createEl('style', {type : 'text/css'})
		      ins(document.getElementsByTagName('head')[0], el)
		      return el.sheet || el.styleSheet
		    }())
		
		    var probe = css(createEl('group'), {behavior: 'url(#default#VML)'})
		
		    if (!vendor(probe, 'transform') && probe.adj) initVML()
		    else useCssAnimations = vendor(probe, 'animation')
		  }
		
		  return Spinner
		
		}));
	
	
	/***/ },
	/* 3 */
	/*!******************************************!*\
	  !*** ./src/Services/UsSpinnerService.ts ***!
	  \******************************************/
	/***/ function(module, exports) {
	
		"use strict";
		/**
		 * UsSpinnerService
		 * This service let you control spin, start and stop
		 */
		var UsSpinnerService = (function () {
		    function UsSpinnerService($rootScope) {
		        this.$rootScope = $rootScope;
		    }
		    UsSpinnerService.prototype.spin = function (key) {
		        this.$rootScope.$broadcast('us-spinner:spin', key);
		    };
		    UsSpinnerService.prototype.stop = function (key) {
		        this.$rootScope.$broadcast('us-spinner:stop', key);
		    };
		    return UsSpinnerService;
		}());
		UsSpinnerService.$inject = ['$rootScope'];
		exports.UsSpinnerService = UsSpinnerService;
	
	
	/***/ },
	/* 4 */
	/*!******************************************!*\
	  !*** ./src/Directives/AngularSpinner.ts ***!
	  \******************************************/
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		var angular = __webpack_require__(/*! angular */ 5);
		exports.usSpinner = function (SpinJSSpinner, usSpinnerConfig) {
		    return {
		        scope: true,
		        link: function (scope, element, attr) {
		            scope.spinner = null;
		            scope.key = angular.isDefined(attr.spinnerKey) ? attr.spinnerKey : false;
		            scope.startActive = (attr.spinnerStartActive) ?
		                scope.$eval(attr.spinnerStartActive) : scope.key ?
		                false : true;
		            function stopSpinner() {
		                if (scope.spinner) {
		                    scope.spinner.stop();
		                }
		            }
		            scope.spin = function () {
		                if (scope.spinner) {
		                    scope.spinner.spin(element[0]);
		                }
		            };
		            scope.stop = function () {
		                scope.startActive = false;
		                stopSpinner();
		            };
		            scope.$watch(attr.usSpinner, function (options) {
		                stopSpinner();
		                // order of precedence: element options, theme, defaults.
		                options = angular.extend({}, usSpinnerConfig.config, attr.spinnerTheme ? usSpinnerConfig.themes[attr.spinnerTheme] : undefined, options);
		                scope.spinner = new SpinJSSpinner(options);
		                if ((!scope.key || scope.startActive) && !attr.spinnerOn) {
		                    scope.spinner.spin(element[0]);
		                }
		            }, true);
		            if (attr.spinnerOn) {
		                scope.$watch(attr.spinnerOn, function (spin) {
		                    if (spin) {
		                        scope.spin();
		                    }
		                    else {
		                        scope.stop();
		                    }
		                });
		            }
		            scope.$on('us-spinner:spin', function (event, key) {
		                if (!key || key === scope.key) {
		                    scope.spin();
		                }
		            });
		            scope.$on('us-spinner:stop', function (event, key) {
		                if (!key || key === scope.key) {
		                    scope.stop();
		                }
		            });
		            scope.$on('$destroy', function () {
		                scope.stop();
		                scope.spinner = null;
		            });
		        }
		    };
		};
		exports.usSpinner.$inject = ['SpinJSSpinner', 'usSpinnerConfig'];
	
	
	/***/ },
	/* 5 */
	/*!**************************!*\
	  !*** external "angular" ***!
	  \**************************/
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_5__;
	
	/***/ },
	/* 6 */
	/*!***************************************!*\
	  !*** ./src/Config/UsSpinnerConfig.ts ***!
	  \***************************************/
	/***/ function(module, exports) {
	
		"use strict";
		/**
		 * UsSpinnerConfig
		 */
		var UsSpinnerConfig = (function () {
		    function UsSpinnerConfig() {
		        this.config = {};
		        this.themes = {};
		    }
		    UsSpinnerConfig.prototype.setDefaults = function (config) {
		        this.config = config || this.config;
		    };
		    UsSpinnerConfig.prototype.setTheme = function (name, config) {
		        this.themes[name] = config;
		    };
		    UsSpinnerConfig.prototype.$get = function () {
		        var _a = this, config = _a.config, themes = _a.themes;
		        return {
		            config: config,
		            themes: themes
		        };
		    };
		    return UsSpinnerConfig;
		}());
		exports.UsSpinnerConfig = UsSpinnerConfig;
	
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=angular-spinner.js.map

/***/ }),
/* 500 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.7.9
	 * (c) 2010-2018 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/* exported
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth
	*/
	
	var minErrConfig = {
	  objectMaxDepth: 5,
	  urlErrorParamsEnabled: true
	};
	
	/**
	 * @ngdoc function
	 * @name angular.errorHandlingConfig
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Configure several aspects of error handling in AngularJS if used as a setter or return the
	 * current configuration if used as a getter. The following options are supported:
	 *
	 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
	 *
	 * Omitted or undefined options will leave the corresponding configuration values unchanged.
	 *
	 * @param {Object=} config - The configuration object. May only contain the options that need to be
	 *     updated. Supported keys:
	 *
	 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
	 *   non-positive or non-numeric value, removes the max depth limit.
	 *   Default: 5
	 *
	 * * `urlErrorParamsEnabled`  **{Boolean}** - Specifies wether the generated error url will
	 *   contain the parameters of the thrown error. Disabling the parameters can be useful if the
	 *   generated error url is very long.
	 *
	 *   Default: true. When used without argument, it returns the current value.
	 */
	function errorHandlingConfig(config) {
	  if (isObject(config)) {
	    if (isDefined(config.objectMaxDepth)) {
	      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
	    }
	    if (isDefined(config.urlErrorParamsEnabled) && isBoolean(config.urlErrorParamsEnabled)) {
	      minErrConfig.urlErrorParamsEnabled = config.urlErrorParamsEnabled;
	    }
	  } else {
	    return minErrConfig;
	  }
	}
	
	/**
	 * @private
	 * @param {Number} maxDepth
	 * @return {boolean}
	 */
	function isValidObjectMaxDepth(maxDepth) {
	  return isNumber(maxDepth) && maxDepth > 0;
	}
	
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * AngularJS. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	
	  var url = 'https://errors.angularjs.org/1.7.9/';
	  var regex = url.replace('.', '\\.') + '[\\s\\S]*';
	  var errRegExp = new RegExp(regex, 'g');
	
	  return function() {
	    var code = arguments[0],
	      template = arguments[1],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
	        return toDebugString(arg, minErrConfig.objectMaxDepth);
	      }),
	      paramPrefix, i;
	
	    // A minErr message has two parts: the message itself and the url that contains the
	    // encoded message.
	    // The message's parameters can contain other error messages which also include error urls.
	    // To prevent the messages from getting too long, we strip the error urls from the parameters.
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1);
	
	      if (index < templateArgs.length) {
	        return templateArgs[index].replace(errRegExp, '');
	      }
	
	      return match;
	    });
	
	    message += '\n' + url + (module ? module + '/' : '') + code;
	
	    if (minErrConfig.urlErrorParamsEnabled) {
	      for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	        message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
	      }
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell ESLint what variables are being exported */
	/* exported
	  angular,
	  msie,
	  jqLite,
	  jQuery,
	  slice,
	  splice,
	  push,
	  toString,
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth,
	  ngMinErr,
	  angularModule,
	  uid,
	  REGEX_STRING_REGEXP,
	  VALIDITY_STATE_PROPERTY,
	
	  lowercase,
	  uppercase,
	  nodeName_,
	  isArrayLike,
	  forEach,
	  forEachSorted,
	  reverseParams,
	  nextUid,
	  setHashKey,
	  extend,
	  toInt,
	  inherit,
	  merge,
	  noop,
	  identity,
	  valueFn,
	  isUndefined,
	  isDefined,
	  isObject,
	  isBlankObject,
	  isString,
	  isNumber,
	  isNumberNaN,
	  isDate,
	  isError,
	  isArray,
	  isFunction,
	  isRegExp,
	  isWindow,
	  isScope,
	  isFile,
	  isFormData,
	  isBlob,
	  isBoolean,
	  isPromiseLike,
	  trim,
	  escapeForRegexp,
	  isElement,
	  makeMap,
	  includes,
	  arrayRemove,
	  copy,
	  simpleCompare,
	  equals,
	  csp,
	  jq,
	  concat,
	  sliceArgs,
	  bind,
	  toJsonReplacer,
	  toJson,
	  fromJson,
	  convertTimezoneToLocal,
	  timezoneToOffset,
	  addDateMinutes,
	  startingTag,
	  tryDecodeURIComponent,
	  parseKeyValue,
	  toKeyValue,
	  encodeUriSegment,
	  encodeUriQuery,
	  angularInit,
	  bootstrap,
	  getTestability,
	  snake_case,
	  bindJQuery,
	  assertArg,
	  assertArgFn,
	  assertNotHasOwnProperty,
	  getter,
	  getBlockNodes,
	  hasOwnProperty,
	  createMap,
	  stringify,
	
	  NODE_TYPE_ELEMENT,
	  NODE_TYPE_ATTRIBUTE,
	  NODE_TYPE_TEXT,
	  NODE_TYPE_COMMENT,
	  NODE_TYPE_DOCUMENT,
	  NODE_TYPE_DOCUMENT_FRAGMENT
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * @private
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	
	/**
	 * @private
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	// Support: IE 9-11 only
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = 'length' in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) && (length >= 0 && (length - 1) in obj || typeof obj.item === 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (key !== '__proto__') {
	            if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	            baseExtend(dst[key], [src], true);
	          }
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @deprecated
	* sinceVersion="1.6.5"
	* This function is deprecated, but will not be removed in the 1.x lifecycle.
	* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
	* supported by this function. We suggest using another, similar library for all-purpose merging,
	* such as [lodash's merge()](https://lodash.com/docs/4.17.4#merge).
	*
	* @knownIssue
	* This is a list of (known) object types that are not handled correctly by this function:
	* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
	* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
	* - AngularJS {@link $rootScope.Scope scopes};
	*
	* `angular.merge` also does not support merging objects with circular references.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
	  // eslint-disable-next-line no-self-compare
	  return num !== num;
	};
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	function isArray(arr) {
	  return Array.isArray(arr) || arr instanceof Array;
	}
	
	/**
	 * @description
	 * Determines if a reference is an `Error`.
	 * Loosely based on https://www.npmjs.com/package/iserror
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Error`.
	 */
	function isError(value) {
	  var tag = toString.call(value);
	  switch (tag) {
	    case '[object Error]': return true;
	    case '[object Exception]': return true;
	    case '[object DOMException]': return true;
	    default: return value instanceof Error;
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s
	    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
	    // eslint-disable-next-line no-control-regex
	    .replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) !== -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array. This functions is used
	 * internally, mostly in the change-detection code. It is not intended as an all-purpose copy
	 * function, and has several limitations (see below).
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 *
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 *   `angular.copy` does not check if destination and source are of the same type. It's the
	 *   developer's responsibility to make sure they are compatible.
	 * </div>
	 *
	 * @knownIssue
	 * This is a non-exhaustive list of object types / features that are not handled correctly by
	 * `angular.copy`. Note that since this functions is used by the change detection code, this
	 * means binding or watching objects of these types (or that include these types) might not work
	 * correctly.
	 * - [`File`](https://developer.mozilla.org/docs/Web/API/File)
	 * - [`Map`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Map)
	 * - [`ImageData`](https://developer.mozilla.org/docs/Web/API/ImageData)
	 * - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	 * - [`Set`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Set)
	 * - [`WeakMap`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/WeakMap)
	 * - ['getter'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get)/
	 *   [`setter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/set)`
	 *
	 * @param {*} source The source that will be used to make a copy. Can be any type, including
	 *     primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If provided,
	 *     must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample" name="angular-copy">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>leader = {{leader | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.leader = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.leader);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.leader);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination, maxDepth) {
	  var stackSource = [];
	  var stackDest = [];
	  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination, maxDepth);
	  }
	
	  return copyElement(source, maxDepth);
	
	  function copyRecurse(source, destination, maxDepth) {
	    maxDepth--;
	    if (maxDepth < 0) {
	      return '...';
	    }
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i], maxDepth));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key], maxDepth);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source, maxDepth) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination, maxDepth)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        // Support: IE10
	        if (!source.slice) {
	          // If we're in this case we know the environment supports ArrayBuffer
	          /* eslint-disable no-undef */
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          /* eslint-enable */
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	// eslint-disable-next-line no-self-compare
	function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  // eslint-disable-next-line no-self-compare
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 === t2 && t1 === 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) === o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return simpleCompare(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() === o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      // eslint-disable-next-line no-new, no-new-func
	      new Function('');
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
	    if (el) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since AngularJS uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // Support: IE 9-11 only, Edge 13-15+
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone().empty();
	  var elemHtml = jqLite('<div></div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || '').split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query         = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	function allowAutoBootstrap(document) {
	  var script = document.currentScript;
	
	  if (!script) {
	    // Support: IE 9-11 only
	    // IE does not have `document.currentScript`
	    return true;
	  }
	
	  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
	  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
	    return false;
	  }
	
	  var attributes = script.attributes;
	  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];
	
	  return srcs.every(function(src) {
	    if (!src) {
	      return true;
	    }
	    if (!src.value) {
	      return false;
	    }
	
	    var link = document.createElement('a');
	    link.href = src.value;
	
	    if (document.location.origin === link.origin) {
	      // Same-origin resources are always allowed, even for non-whitelisted schemes.
	      return true;
	    }
	    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
	    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
	    // content security policy in web pages and other browser extensions.
	    switch (link.protocol) {
	      case 'http:':
	      case 'https:':
	      case 'ftp:':
	      case 'blob:':
	      case 'file:':
	      case 'data:':
	        return true;
	      default:
	        return false;
	    }
	  });
	}
	
	// Cached as it has to run during loading so that document.currentScript is available.
	var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * @example
	 *
	 * ### Simple Usage
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo" name="ng-app">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * @example
	 *
	 * ### With `ngStrictDi`
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true" name="strict-di">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = 'World';
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    if (!isAutoBootstrapAllowed) {
	      window.console.error('AngularJS: disabling automatic bootstrap. <script> protocol indicates ' +
	          'an extension, document.location.href does not match.');
	      return;
	    }
	    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up AngularJS application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * AngularJS will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of AngularJS try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          'App already bootstrapped with this element \'{0}\'',
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of AngularJS on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: /** @type {?} */ (JQLitePrototype).controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	  } else {
	    jqLite = JQLite;
	  }
	
	  // All nodes removed from the DOM via various jqLite/jQuery APIs like .remove()
	  // are passed through jqLite/jQuery.cleanData. Monkey-patch this method to fire
	  // the $destroy event on all removed nodes.
	  originalCleanData = jqLite.cleanData;
	  jqLite.cleanData = function(elems) {
	    var events;
	    for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	      events = (jqLite._data(elem) || {}).events;
	      if (events && events.$destroy) {
	        jqLite(elem).triggerHandler('$destroy');
	      }
	    }
	    originalCleanData(elems);
	  };
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	function stringify(value) {
	  if (value == null) { // null || undefined
	    return '';
	  }
	  switch (typeof value) {
	    case 'string':
	      break;
	    case 'number':
	      value = '' + value;
	      break;
	    default:
	      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
	        value = value.toString();
	      } else {
	        value = toJson(value);
	      }
	  }
	
	  return value;
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring AngularJS {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving AngularJS
	     * modules.
	     * All modules (AngularJS core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	
	      var info = {};
	
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
	             'the module name or forgot to load it. If registering a module ensure that you ' +
	             'specify the dependencies as the second argument.', name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#info
	           * @module ng
	           *
	           * @param {Object=} info Information about the module
	           * @returns {Object|Module} The current info object for this module if called as a getter,
	           *                          or `this` if called as a setter.
	           *
	           * @description
	           * Read and write custom information about this module.
	           * For example you could put the version of the module in here.
	           *
	           * ```js
	           * angular.module('myModule', []).info({ version: '1.0.0' });
	           * ```
	           *
	           * The version could then be read back out by accessing the module elsewhere:
	           *
	           * ```
	           * var version = angular.module('myModule').info().version;
	           * ```
	           *
	           * You can also retrieve this information during runtime via the
	           * {@link $injector#modules `$injector.modules`} property:
	           *
	           * ```js
	           * var version = $injector.modules['myModule'].info().version;
	           * ```
	           */
	          info: function(value) {
	            if (isDefined(value)) {
	              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
	              info = value;
	              return this;
	            }
	            return info;
	          },
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid AngularJS expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	           *    or an object map of components where the keys are the names and the values are the component definition objects.
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to configure services by injecting their
	           * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
	           * {@link ngRoute.$routeProvider $routeProvider}.
	           *
	           * Note that you can only inject {@link angular.Module#provider `providers`} and
	           * {@link angular.Module#constant `constants`} into this function.
	           *
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method, queue) {
	          if (!queue) queue = invokeQueue;
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            queue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* exported toDebugString */
	
	function serializeObject(obj, maxDepth) {
	  var seen = [];
	
	  // There is no direct way to stringify object until reaching a specific depth
	  // and a very deep object can cause a performance issue, so we copy the object
	  // based on this specific depth and then stringify it.
	  if (isValidObjectMaxDepth(maxDepth)) {
	    // This file is also included in `angular-loader`, so `copy()` might not always be available in
	    // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
	    obj = angular.copy(obj, null, maxDepth);
	  }
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj, maxDepth) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj, maxDepth);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  hiddenInputBrowserCacheDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRefDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $$IsDocumentHiddenProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $$IntervalFactoryProvider,
	  $IntervalProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $$MapProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $$TaskTrackerFactoryProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  // These placeholder strings will be replaced by grunt's `build` task.
	  // They need to be double- or single-quoted.
	  full: '1.7.9',
	  major: 1,
	  minor: 7,
	  dot: 9,
	  codeName: 'pollution-eradication'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'errorHandlingConfig': errorHandlingConfig,
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    'reloadWithDebugInfo': reloadWithDebugInfo,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    '$$encodeUriSegment': encodeUriSegment,
	    '$$encodeUriQuery': encodeUriQuery,
	    '$$lowercase': lowercase,
	    '$$stringify': stringify,
	    '$$uppercase': uppercase
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRef: ngRefDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective,
	          input: hiddenInputBrowserCacheDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $$isDocumentHidden: $$IsDocumentHiddenProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $$intervalFactory: $$IntervalFactoryProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $$taskTrackerFactory: $$TaskTrackerFactoryProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$Map: $$MapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ])
	  .info({ angularVersion: '1.7.9' });
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global
	  JQLitePrototype: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## AngularJS's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/) - Contrary to jQuery, this doesn't clone elements
	 *   so will not work correctly when invoked on a jqLite object containing more than one DOM node
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1;
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
	var MS_HACK_REGEXP = /^-ms-/;
	var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts kebab-case to camelCase.
	 * There is also a special case for the ms prefix starting with a lowercase letter.
	 * @param name Name to normalize
	 */
	function cssKebabToCamel(name) {
	    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
	}
	
	function fnCamelCaseReplace(all, letter) {
	  return letter.toUpperCase();
	}
	
	/**
	 * Converts kebab-case to camelCase.
	 * @param name Name to normalize
	 */
	function kebabToCamel(name) {
	  return name
	    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	var wrapMap = {
	  'option': [1, '<select multiple="multiple">', '</select>'],
	
	  'thead': [1, '<table>', '</table>'],
	  'col': [2, '<table><colgroup>', '</colgroup></table>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	  '_default': [0, '', '']
	};
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement('div'));
	    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
	    wrap = wrapMap[tag] || wrapMap._default;
	    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, '<$1></$2>') + wrap[2];
	
	    // Descend through wrappers to the right content
	    i = wrap[0];
	    while (i--) {
	      tmp = tmp.lastChild;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = '';
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = '';
	  fragment.innerHTML = ''; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
	  // eslint-disable-next-line no-bitwise
	  return !!(this.compareDocumentPosition(arg) & 16);
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) !== '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else if (isFunction(element)) {
	    jqLiteReady(element);
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);
	
	  if (element.querySelectorAll) {
	    jqLite.cleanData(element.querySelectorAll('*'));
	  }
	}
	
	function isEmptyObject(obj) {
	  var name;
	
	  for (name in obj) {
	    return false;
	  }
	  return true;
	}
	
	function removeIfEmptyData(element) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  var events = expandoStore && expandoStore.events;
	  var data = expandoStore && expandoStore.data;
	
	  if ((!data || isEmptyObject(data)) && (!events || isEmptyObject(events))) {
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        element.removeEventListener(type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        element.removeEventListener(type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	
	  removeIfEmptyData(element);
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	    } else {
	      expandoStore.data = {};
	    }
	
	    removeIfEmptyData(element);
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	    var prop;
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[kebabToCamel(key)] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[kebabToCamel(key)];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          for (prop in key) {
	            data[kebabToCamel(prop)] = key[prop];
	          }
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
	      indexOf(' ' + selector + ' ') > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	    var newClasses = existingClasses;
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      newClasses = newClasses.replace(' ' + cssClass + ' ', ' ');
	    });
	
	    if (newClasses !== existingClasses) {
	      element.setAttribute('class', trim(newClasses));
	    }
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	    var newClasses = existingClasses;
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (newClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        newClasses += cssClass + ' ';
	      }
	    });
	
	    if (newClasses !== existingClasses) {
	      element.setAttribute('class', trim(newClasses));
	    }
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType === NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	function jqLiteReady(fn) {
	  function trigger() {
	    window.document.removeEventListener('DOMContentLoaded', trigger);
	    window.removeEventListener('load', trigger);
	    fn();
	  }
	
	  // check if document is already loaded
	  if (window.document.readyState === 'complete') {
	    window.setTimeout(fn);
	  } else {
	    // We can not use jqLite since we are not done loading and jQuery could be loaded later.
	
	    // Works for modern browsers and IE9
	    window.document.addEventListener('DOMContentLoaded', trigger);
	
	    // Fallback to window.onload for others
	    window.addEventListener('load', trigger);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: jqLiteReady,
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern',
	  'ngStep': 'step'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: function jqLiteCleanData(nodes) {
	    for (var i = 0, ii = nodes.length; i < ii; i++) {
	      jqLiteRemoveData(nodes[i]);
	      jqLiteOff(nodes[i]);
	    }
	  }
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = cssKebabToCamel(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var ret;
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
	      !element.getAttribute) {
	      return;
	    }
	
	    var lowercasedName = lowercase(name);
	    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
	
	    if (isDefined(value)) {
	      // setter
	
	      if (value === null || (value === false && isBooleanAttr)) {
	        element.removeAttribute(name);
	      } else {
	        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
	      }
	    } else {
	      // getter
	
	      ret = element.getAttribute(name);
	
	      if (isBooleanAttr && ret !== null) {
	        ret = lowercasedName;
	      }
	      // Normalize non-existing attributes to undefined (as jQuery).
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          element.addEventListener(type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	
	    if (parent) {
	      newElement = new JQLite(newElement);
	
	      for (var i = 0, ii = newElement.length; i < ii; i++) {
	        var node = newElement[i];
	        parent.insertBefore(node, index.nextSibling);
	        index = node;
	      }
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	});
	
	// bind legacy bind/unbind to on/off
	JQLite.prototype.bind = JQLite.prototype.on;
	JQLite.prototype.unbind = JQLite.prototype.off;
	
	
	// Provider for private $$jqLite service
	/** @this */
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType === 'function' || (objType === 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	// A minimal ES2015 Map implementation.
	// Should be bug/feature equivalent to the native implementations of supported browsers
	// (for the features required in Angular).
	// See https://kangax.github.io/compat-table/es6/#test-Map
	var nanKey = Object.create(null);
	function NgMapShim() {
	  this._keys = [];
	  this._values = [];
	  this._lastKey = NaN;
	  this._lastIndex = -1;
	}
	NgMapShim.prototype = {
	  _idx: function(key) {
	    if (key !== this._lastKey) {
	      this._lastKey = key;
	      this._lastIndex = this._keys.indexOf(key);
	    }
	    return this._lastIndex;
	  },
	  _transformKey: function(key) {
	    return isNumberNaN(key) ? nanKey : key;
	  },
	  get: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx !== -1) {
	      return this._values[idx];
	    }
	  },
	  has: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    return idx !== -1;
	  },
	  set: function(key, value) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      idx = this._lastIndex = this._keys.length;
	    }
	    this._keys[idx] = key;
	    this._values[idx] = value;
	
	    // Support: IE11
	    // Do not `return this` to simulate the partial IE11 implementation
	  },
	  delete: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      return false;
	    }
	    this._keys.splice(idx, 1);
	    this._values.splice(idx, 1);
	    this._lastKey = NaN;
	    this._lastIndex = -1;
	    return true;
	  }
	};
	
	// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
	// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
	// implementations get more stable, we can reconsider switching to `window.Map` (when available).
	var NgMap = NgMapShim;
	
	var $$MapProvider = [/** @this */function() {
	  this.$get = [function() {
	    return NgMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running AngularJS app
	 * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^(]+?)=>/;
	var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  return Function.prototype.toString.call(fn);
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * ## Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ### Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ### `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ### Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc property
	 * @name $injector#modules
	 * @type {Object}
	 * @description
	 * A hash containing all the modules that have been loaded into the
	 * $injector.
	 *
	 * You can use this property to find out information about a module via the
	 * {@link angular.Module#info `myModule.info(...)`} method.
	 *
	 * For example:
	 *
	 * ```
	 * var info = $injector.modules['ngAnimate'].info();
	 * ```
	 *
	 * **Do not use this property to attempt to modify the modules after the application
	 * has been bootstrapped.**
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * #### Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * #### The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * #### The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	/**
	 * @ngdoc method
	 * @name $injector#loadNewModules
	 *
	 * @description
	 *
	 * **This is a dangerous API, which you use at your own risk!**
	 *
	 * Add the specified modules to the current injector.
	 *
	 * This method will add each of the injectables to the injector and execute all of the config and run
	 * blocks for each module passed to the method.
	 *
	 * If a module has already been loaded into the injector then it will not be loaded again.
	 *
	 * * The application developer is responsible for loading the code containing the modules; and for
	 * ensuring that lazy scripts are not downloaded and executed more often that desired.
	 * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
	 * * Modules cannot be unloaded.
	 *
	 * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
	 * into the injector, which may indicate whether the script has been executed already.
	 *
	 * @example
	 * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
	 *
	 * ```javascript
	 * app.factory('loadModule', function($injector) {
	 *   return function loadModule(moduleName, bundleUrl) {
	 *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
	 *   };
	 * })
	 * ```
	 *
	 * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * It is possible to inject other providers into the provider function,
	 * but the injected provider must have been defined before the one that requires it.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new NgMap(),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  instanceInjector.modules = providerInjector.modules = createMap();
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  instanceInjector.loadNewModules = function(mods) {
	    forEach(loadModules(mods), function(fn) { if (fn) instanceInjector.invoke(fn); });
	  };
	
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
	    }
	    return (providerCache[name + providerSuffix] = provider_);
	  }
	
	  function enforceReturnValue(name, factory) {
	    return /** @this */ function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.set(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          instanceInjector.modules[module] = moduleFn;
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          // eslint-disable-next-line no-ex-assign
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          cache[serviceName] = factory(serviceName, caller);
	          return cache[serviceName];
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // Support: IE 9-11 only
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie || typeof func !== 'function') {
	        return false;
	      }
	      var result = func.$$ngIsClass;
	      if (!isBoolean(result)) {
	        result = func.$$ngIsClass = /^class\b/.test(stringifyFn(func));
	      }
	      return result;
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 * @this
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample" name="anchor-scroll">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      // Allow numeric hashes
	      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash === 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = /** @this */ function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = /** @this */ function() {
	  var postDigestQueue = new NgMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        if (domOperation) {
	          domOperation();
	        }
	
	        options = options || {};
	        if (options.from) {
	          element.css(options.from);
	        }
	        if (options.to) {
	          element.css(options.to);
	        }
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner();
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            if (toAdd) {
	              jqLiteAddClass(elm, toAdd);
	            }
	            if (toRemove) {
	              jqLiteRemoveClass(elm, toRemove);
	            }
	          });
	          postDigestQueue.delete(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.set(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', /** @this */ function($provide) {
	  var provider = this;
	  var classNameFilter = null;
	  var customFilter = null;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#customFilter
	   *
	   * @description
	   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
	   * determine if an animation is allowed or not. When no filter is specified (the default), no
	   * animation will be blocked. Setting the `customFilter` value will only allow animations for
	   * which the filter function's return value is truthy.
	   *
	   * This allows to easily create arbitrarily complex rules for filtering animations, such as
	   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
	   * Filtering animations can also boost performance for low-powered devices, as well as
	   * applications containing a lot of structural operations.
	   *
	   * <div class="alert alert-success">
	   *   **Best Practice:**
	   *   Keep the filtering function as lean as possible, because it will be called for each DOM
	   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
	   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
	   *   directives that support animations.
	   *   Performing computationally expensive or time-consuming operations on each call of the
	   *   filtering function can make your animations sluggish.
	   * </div>
	   *
	   * **Note:** If present, `customFilter` will be checked before
	   * {@link $animateProvider#classNameFilter classNameFilter}.
	   *
	   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
	   *   If a falsy value is returned, no animation will be performed. The function will be called
	   *   with the following arguments:
	   *   - **node** `{DOMElement}` - The DOM element to be animated.
	   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
	   *     etc).
	   *   - **options** `{Object}` - A collection of options/styles used for the animation.
	   * @return {Function} The current filter function or `null` if there is none set.
	   */
	  this.customFilter = function(filterFn) {
	    if (arguments.length === 1) {
	      customFilter = isFunction(filterFn) ? filterFn : null;
	    }
	
	    return customFilter;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   *
	   * **Note:** If present, `classNameFilter` will be checked after
	   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
	   * false, `classNameFilter` will not be checked.
	   *
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (classNameFilter) {
	        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
	        if (reservedRegex.test(classNameFilter.toString())) {
	          classNameFilter = null;
	          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	        }
	      }
	    }
	    return classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      if (afterElement) {
	        afterElement.after(element);
	      } else {
	        parentElement.prepend(element);
	      }
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * <div class="alert alert-warning">
	       * **Note**: Generally, the events that are fired correspond 1:1 to `$animate` method names,
	       * e.g. {@link ng.$animate#addClass addClass()} will fire `addClass`, and {@link ng.ngClass}
	       * will fire `addClass` if classes are added, and `removeClass` if classes are removed.
	       * However, there are two exceptions:
	       *
	       * <ul>
	       *   <li>if both an {@link ng.$animate#addClass addClass()} and a
	       *   {@link ng.$animate#removeClass removeClass()} action are performed during the same
	       *   animation, the event fired will be `setClass`. This is true even for `ngClass`.</li>
	       *   <li>an {@link ng.$animate#animate animate()} call that adds and removes classes will fire
	       *   the `setClass` event, but if it either removes or adds classes,
	       *   it will fire `animate` instead.</li>
	       * </ul>
	       *
	       * </div>
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered.
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       * * `data` - an object with these properties:
	       *     * addClass - `{string|null}` - space-separated CSS classes to add to the element
	       *     * removeClass - `{string|null}` - space-separated CSS classes to remove from the element
	       *     * from - `{Object|null}` - CSS properties & values at the beginning of the animation
	       *     * to - `{Object|null}` - CSS properties & values at the end of the animation
	       *
	       * Note that the callback does not trigger a scope digest. Wrap your call into a
	       * {@link $rootScope.Scope#$apply scope.$apply} to propagate changes to the scope.
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation and applies the end state of the animation.
	       * Note that this does not cancel the underlying operation, e.g. the setting of classes or
	       * adding the element to the DOM.
	       *
	       * @param {animationRunner} animationRunner An animation runner returned by an $animate function.
	       *
	       * @example
	        <example module="animationExample" deps="angular-animate.js" animations="true" name="animate-cancel">
	          <file name="app.js">
	            angular.module('animationExample', ['ngAnimate']).component('cancelExample', {
	              templateUrl: 'template.html',
	              controller: function($element, $animate) {
	                this.runner = null;
	
	                this.addClass = function() {
	                  this.runner = $animate.addClass($element.find('div'), 'red');
	                  var ctrl = this;
	                  this.runner.finally(function() {
	                    ctrl.runner = null;
	                  });
	                };
	
	                this.removeClass = function() {
	                  this.runner = $animate.removeClass($element.find('div'), 'red');
	                  var ctrl = this;
	                  this.runner.finally(function() {
	                    ctrl.runner = null;
	                  });
	                };
	
	                this.cancel = function() {
	                  $animate.cancel(this.runner);
	                };
	              }
	            });
	          </file>
	          <file name="template.html">
	            <p>
	              <button id="add" ng-click="$ctrl.addClass()">Add</button>
	              <button ng-click="$ctrl.removeClass()">Remove</button>
	              <br>
	              <button id="cancel" ng-click="$ctrl.cancel()" ng-disabled="!$ctrl.runner">Cancel</button>
	              <br>
	              <div id="target">CSS-Animated Text</div>
	            </p>
	          </file>
	          <file name="index.html">
	            <cancel-example></cancel-example>
	          </file>
	          <file name="style.css">
	            .red-add, .red-remove {
	              transition: all 4s cubic-bezier(0.250, 0.460, 0.450, 0.940);
	            }
	
	            .red,
	            .red-add.red-add-active {
	              color: #FF0000;
	              font-size: 40px;
	            }
	
	            .red-remove.red-remove-active {
	              font-size: 10px;
	              color: black;
	            }
	
	          </file>
	        </example>
	       */
	      cancel: function(runner) {
	        if (runner.cancel) {
	          runner.cancel();
	        }
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} animationRunner the animation runner
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        if (passed) {
	          callback();
	        } else {
	          waitForTick(callback);
	        }
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = /** @this */ function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        if ($$isDocumentHidden()) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              if (status === false) {
	                reject();
	              } else {
	                resolve();
	              }
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/* exported $CoreAnimateCssProvider */
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 * @this
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global getHash: true, stripHash: false */
	
	function getHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? '' : url.substr(index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/#$/, '');
	}
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer, $$taskTrackerFactory) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {},
	      taskTracker = $$taskTrackerFactory($log);
	
	  self.isMock = false;
	
	  //////////////////////////////////////////////////////////////
	  // Task-tracking API
	  //////////////////////////////////////////////////////////////
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = taskTracker.completeTask;
	  self.$$incOutstandingRequestCount = taskTracker.incTaskCount;
	
	  // TODO(vojta): prefix this method with $$ ?
	  self.notifyWhenNoOutstandingRequests = taskTracker.notifyWhenNoPendingTasks;
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of `location.href` (with a
	   * trailing `#` stripped of if the hash is empty).
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, `pushState`/`replaceState` is used, otherwise
	   * `location.href`/`location.replace` is used.
	   * Returns its own instance to allow chaining.
	   *
	   * NOTE: this api is intended for use only by the `$location` service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state State object to use with `pushState`/`replaceState`
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Normalize the inputted URL
	      url = urlResolve(url).href;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      return trimEmptyHash(pendingLocation || location.href);
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    fireStateOrUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	
	    lastCachedState = cachedState;
	    lastHistoryState = cachedState;
	  }
	
	  function fireStateOrUrlChange() {
	    var prevLastHistoryState = lastHistoryState;
	    cacheState();
	
	    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of AngularJS:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers don't
	      // fire popstate when user changes the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of AngularJS.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireStateOrUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] Number of milliseconds to defer the function execution.
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] The type of task that is deferred.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay, taskType) {
	    var timeoutId;
	
	    delay = delay || 0;
	    taskType = taskType || taskTracker.DEFAULT_TASK_TYPE;
	
	    taskTracker.incTaskCount(taskType);
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      taskTracker.completeTask(fn, taskType);
	    }, delay);
	    pendingDeferIds[timeoutId] = taskType;
	
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds.hasOwnProperty(deferId)) {
	      var taskType = pendingDeferIds[deferId];
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      taskTracker.completeTask(noop, taskType);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	/** @this */
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document', '$$taskTrackerFactory',
	       function($window,   $log,   $sniffer,   $document,   $$taskTrackerFactory) {
	    return new Browser($window, $document, $log, $sniffer, $$taskTrackerFactory);
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 * @this
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp" name="cache-factory">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
	       * directive to cache templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return (caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      });
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry !== freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd === entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry !== prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 * @this
	 *
	 * @description
	 * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
	 * {@link ng.$cacheFactory $cacheFactory}.
	 *
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
	 * or by consuming the `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
	 * element with {@link ngApp} attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your component:
	 * ```js
	 * myApp.component('myComponent', {
	 *    templateUrl: 'templateId.html'
	 * });
	 * ```
	 *
	 * or get it via the `$templateCache` service:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables like document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       {@link $compile#-priority- priority}: 0,
	 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       {@link $compile#-transclude- transclude}: false,
	 *       {@link $compile#-restrict- restrict}: 'A',
	 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
	 *       {@link $compile#-scope- scope}: false,
	 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
	 *       {@link $compile#-bindtocontroller- bindToController}: false,
	 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       {@link $compile#-multielement- multiElement}: false,
	 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // {@link $compile#-link- link}: {
	 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
	 *   also be called when your bindings are initialized.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with life-cycle hooks in the new Angular
	 * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
	 *
	 * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
	 *   `ngDoCheck` in Angular.
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance.)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `false`, `true`, or an object:
	 *
	 * * **`false` (default):** No scope will be created for the directive. The directive will use its
	 * parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
	 * The 'isolate' scope differs from normal scope in that it does not prototypically
	 * inherit from its parent scope. This is useful when creating reusable components, which should not
	 * accidentally read or modify data in the parent scope. Note that an isolate scope
	 * directive without a `template` or `templateUrl` will not apply the isolate scope
	 * to its children elements.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. If the binding expression is non-assignable, or if the attribute
	 *   isn't  optional and doesn't exist, an exception
	 *   ({@link error/$compile/nonassign `$compile:nonassign`}) will be thrown upon discovering changes
	 *   to the local value, since it will be impossible to sync them back to the parent scope.
	 *
	 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr`
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   It's also possible to watch the evaluated value shallowly with
	 *   {@link ng.$rootScope.Scope#$watchCollection `$watchCollection`}: use `<*` or `<*attr`
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * All 4 kinds of bindings (`@`, `=`, `<`, and `&`) can be made optional by adding `?` to the expression.
	 * The marker must come after the mode and before the attribute name.
	 * See the {@link error/$compile/iscp Invalid Isolate Scope Definition error} for definition examples.
	 * This is useful to refine the interface directives provide.
	 * One subtle difference between optional and non-optional happens **when the binding attribute is not
	 * set**:
	 * - the binding is optional: the property will not be defined
	 * - the binding is not optional: the property is defined
	 *
	 * ```js
	 *app.directive('testDir', function() {
	    return {
	      scope: {
	        notoptional: '=',
	        optional: '=?',
	      },
	      bindToController: true,
	      controller: function() {
	        this.$onInit = function() {
	          console.log(this.hasOwnProperty('notoptional')) // true
	          console.log(this.hasOwnProperty('optional')) // false
	        }
	      }
	    }
	  })
	 *```
	 *
	 *
	 * ##### Combining directives with different scope defintions
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkingFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default transclusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}.
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace`
	 * <div class="alert alert-danger">
	 * **Note:** `replace` is deprecated in AngularJS and has been removed in the new Angular (v2+).
	 * </div>
	 *
	 * Specifies what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using `$compile` in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that are defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Multi-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}.
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like `ngBind` can be expressed in many ways:
	 *   `ng:bind`, `data-ng-bind`, or `x-ng-bind`. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample" name="compile">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // Configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects '$compile'.
	        $compileProvider.directive('compile', function($compile) {
	          // The directive factory creates a link function.
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                // Watch the 'compile' expression for changes.
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // When the 'compile' expression changes
	                // assign it into the current DOM.
	                element.html(value);
	
	                // Compile the new DOM and link it to the current scope.
	                // NOTE: we only compile '.childNodes' so that we
	                // don't get into an infinite loop compiling ourselves.
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'AngularJS';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello AngularJS'.
	       expect(output.getText()).toBe('Hello AngularJS');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('AngularJS!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non HTML
	 *        elements (e.g. SVG elements). See also the `directive.controller` property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to `$digest`, which typically is done by
	 * AngularJS automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = angular.element('<p>{{total}}</p>');
	 *     $compile(element)(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone either via the `cloneAttachFn` or the value returned by the
	 *   linking function:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>');
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       // Attach the clone to DOM document at the right place.
	 *     });
	 *
	 *     // Now we have reference to the cloned DOM via `clonedElement`.
	 *     // NOTE: The `clonedElement` returned by the linking function is the same as the
	 *     //       `clonedElement` passed to `cloneAttachFn`.
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
	 *
	 * @knownIssue
	 *
	 * ### Double Compilation
	 *
	   Double compilation occurs when an already compiled part of the DOM gets
	   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
	   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
	   section on double compilation} for an in-depth explanation and ways to avoid it.
	
	 * @knownIssue
	
	   ### Issues with `replace: true`
	 *
	 * <div class="alert alert-danger">
	 *   **Note**: {@link $compile#-replace- `replace: true`} is deprecated and not recommended to use,
	 *   mainly due to the issues listed here. It has been completely removed in the new Angular.
	 * </div>
	 *
	 * #### Attribute values are not merged
	 *
	 * When a `replace` directive encounters the same attribute on the original and the replace node,
	 * it will simply deduplicate the attribute and join the values with a space or with a `;` in case of
	 * the `style` attribute.
	 * ```html
	 * Original Node: <span class="original" style="color: red;"></span>
	 * Replace Template: <span class="replaced" style="background: blue;"></span>
	 * Result: <span class="original replaced" style="color: red; background: blue;"></span>
	 * ```
	 *
	 * That means attributes that contain AngularJS expressions will not be merged correctly, e.g.
	 * {@link ngShow} or {@link ngClass} will cause a {@link $parse} error:
	 *
	 * ```html
	 * Original Node: <span ng-class="{'something': something}" ng-show="!condition"></span>
	 * Replace Template: <span ng-class="{'else': else}" ng-show="otherCondition"></span>
	 * Result: <span ng-class="{'something': something} {'else': else}" ng-show="!condition otherCondition"></span>
	 * ```
	 *
	 * See issue [#5695](https://github.com/angular/angular.js/issues/5695).
	 *
	 * #### Directives are not deduplicated before compilation
	 *
	 * When the original node and the replace template declare the same directive(s), they will be
	 * {@link guide/compiler#double-compilation-and-how-to-avoid-it compiled twice} because the compiler
	 * does not deduplicate them. In many cases, this is not noticable, but e.g. {@link ngModel} will
	 * attach `$formatters` and `$parsers` twice.
	 *
	 * See issue [#2573](https://github.com/angular/angular.js/issues/2573).
	 *
	 * #### `transclude: element` in the replace template root can have unexpected effects
	 *
	 * When the replace template has a directive at the root node that uses
	 * {@link $compile#-transclude- `transclude: element`}, e.g.
	 * {@link ngIf} or {@link ngRepeat}, the DOM structure or scope inheritance can be incorrect.
	 * See the following issues:
	 *
	 * - Incorrect scope on replaced element:
	 * [#9837](https://github.com/angular/angular.js/issues/9837)
	 * - Different DOM between `template` and `templateUrl`:
	 * [#10612](https://github.com/angular/angular.js/issues/14326)
	 *
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngProp
	 * @restrict A
	 * @element ANY
	 *
	 * @usage
	 *
	 * ```html
	 * <ANY ng-prop-propname="expression">
	 * </ANY>
	 * ```
	 *
	 * or with uppercase letters in property (e.g. "propName"):
	 *
	 *
	 * ```html
	 * <ANY ng-prop-prop_name="expression">
	 * </ANY>
	 * ```
	 *
	 *
	 * @description
	 * The `ngProp` directive binds an expression to a DOM element property.
	 * `ngProp` allows writing to arbitrary properties by including
	 * the property name in the attribute, e.g. `ng-prop-value="'my value'"` binds 'my value' to
	 * the `value` property.
	 *
	 * Usually, it's not necessary to write to properties in AngularJS, as the built-in directives
	 * handle the most common use cases (instead of the above example, you would use {@link ngValue}).
	 *
	 * However, [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements)
	 * often use custom properties to hold data, and `ngProp` can be used to provide input to these
	 * custom elements.
	 *
	 * ## Binding to camelCase properties
	 *
	 * Since HTML attributes are case-insensitive, camelCase properties like `innerHTML` must be escaped.
	 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
	 * `innerHTML`  must be written as `ng-prop-inner_h_t_m_l="expression"` (Note that this is just an
	 * example, and for binding HTML {@link ngBindHtml} should be used.
	 *
	 * ## Security
	 *
	 * Binding expressions to arbitrary properties poses a security risk, as  properties like `innerHTML`
	 * can insert potentially dangerous HTML into the application, e.g. script tags that execute
	 * malicious code.
	 * For this reason, `ngProp` applies Strict Contextual Escaping with the {@link ng.$sce $sce service}.
	 * This means vulnerable properties require their content to be "trusted", based on the
	 * context of the property. For example, the `innerHTML` is in the `HTML` context, and the
	 * `iframe.src` property is in the `RESOURCE_URL` context, which requires that values written to
	 * this property are trusted as a `RESOURCE_URL`.
	 *
	 * This can be set explicitly by calling $sce.trustAs(type, value) on the value that is
	 * trusted before passing it to the `ng-prop-*` directive. There are exist shorthand methods for
	 * each context type in the form of {@link ng.$sce#trustAsResourceUrl $sce.trustAsResourceUrl()} et al.
	 *
	 * In some cases you can also rely upon automatic sanitization of untrusted values - see below.
	 *
	 * Based on the context, other options may exist to mark a value as trusted / configure the behavior
	 * of {@link ng.$sce}. For example, to restrict the `RESOURCE_URL` context to specific origins, use
	 * the {@link $sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist()}
	 * and {@link $sceDelegateProvider#resourceUrlBlacklist resourceUrlBlacklist()}.
	 *
	 * {@link ng.$sce#what-trusted-context-types-are-supported- Find out more about the different context types}.
	 *
	 * ### HTML Sanitization
	 *
	 * By default, `$sce` will throw an error if it detects untrusted HTML content, and will not bind the
	 * content.
	 * However, if you include the {@link ngSanitize ngSanitize module}, it will try to sanitize the
	 * potentially dangerous HTML, e.g. strip non-whitelisted tags and attributes when binding to
	 * `innerHTML`.
	 *
	 * @example
	 * ### Binding to different contexts
	 *
	 * <example name="ngProp" module="exampleNgProp">
	 *   <file name="app.js">
	 *     angular.module('exampleNgProp', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function($sce) {
	 *           this.safeContent = '<strong>Safe content</strong>';
	 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
	 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       <div class="prop-unit">
	 *         Binding to a property without security context:
	 *         <div class="prop-binding" ng-prop-inner_text="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerText</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         "Safe" content that requires a security context will throw because the contents could potentially be dangerous ...
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... so that actually dangerous content cannot be executed:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (unsafeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... but unsafe Content that has been trusted explicitly works - only do this if you are 100% sure!
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 *   <file name="styles.css">
	 *     .prop-unit {
	 *       margin-bottom: 10px;
	 *     }
	 *
	 *     .prop-binding {
	 *       min-height: 30px;
	 *       border: 1px solid blue;
	 *     }
	 *
	 *     .prop-note {
	 *       font-family: Monospace;
	 *     }
	 *   </file>
	 * </example>
	 *
	 *
	 * @example
	 * ### Binding to innerHTML with ngSanitize
	 *
	 * <example name="ngProp" module="exampleNgProp" deps="angular-sanitize.js">
	 *   <file name="app.js">
	 *     angular.module('exampleNgProp', ['ngSanitize'])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function($sce) {
	 *           this.safeContent = '<strong>Safe content</strong>';
	 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
	 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       <div class="prop-unit">
	 *         "Safe" content will be sanitized ...
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... as will dangerous content:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (unsafeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... and content that has been trusted explicitly works the same as without ngSanitize:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 *   <file name="styles.css">
	 *     .prop-unit {
	 *       margin-bottom: 10px;
	 *     }
	 *
	 *     .prop-binding {
	 *       min-height: 30px;
	 *       border: 1px solid blue;
	 *     }
	 *
	 *     .prop-note {
	 *       font-family: Monospace;
	 *     }
	 *   </file>
	 * </example>
	 *
	 */
	
	/** @ngdoc directive
	 * @name ngOn
	 * @restrict A
	 * @element ANY
	 *
	 * @usage
	 *
	 * ```html
	 * <ANY ng-on-eventname="expression">
	 * </ANY>
	 * ```
	 *
	 * or with uppercase letters in property (e.g. "eventName"):
	 *
	 *
	 * ```html
	 * <ANY ng-on-event_name="expression">
	 * </ANY>
	 * ```
	 *
	 * @description
	 * The `ngOn` directive adds an event listener to a DOM element via
	 * {@link angular.element angular.element().on()}, and evaluates an expression when the event is
	 * fired.
	 * `ngOn` allows adding listeners for arbitrary events by including
	 * the event name in the attribute, e.g. `ng-on-drop="onDrop()"` executes the 'onDrop()' expression
	 * when the `drop` event is fired.
	 *
	 * AngularJS provides specific directives for many events, such as {@link ngClick}, so in most
	 * cases it is not necessary to use `ngOn`. However, AngularJS does not support all events
	 * (e.g. the `drop` event in the example above), and new events might be introduced in later DOM
	 * standards.
	 *
	 * Another use-case for `ngOn` is listening to
	 * [custom events](https://developer.mozilla.org/docs/Web/Guide/Events/Creating_and_triggering_events)
	 * fired by
	 * [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements).
	 *
	 * ## Binding to camelCase properties
	 *
	 * Since HTML attributes are case-insensitive, camelCase properties like `myEvent` must be escaped.
	 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
	 * `myEvent` must be written as `ng-on-my_event="expression"`.
	 *
	 * @example
	 * ### Bind to built-in DOM events
	 *
	 * <example name="ngOn" module="exampleNgOn">
	 *   <file name="app.js">
	 *     angular.module('exampleNgOn', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function() {
	 *           this.clickCount = 0;
	 *           this.mouseoverCount = 0;
	 *
	 *           this.loadingState = 0;
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       This is equivalent to `ngClick` and `ngMouseover`:<br>
	 *       <button
	 *         ng-on-click="$ctrl.clickCount = $ctrl.clickCount + 1"
	 *         ng-on-mouseover="$ctrl.mouseoverCount = $ctrl.mouseoverCount + 1">Click or mouseover</button><br>
	 *       clickCount: {{$ctrl.clickCount}}<br>
	 *       mouseover: {{$ctrl.mouseoverCount}}
	 *
	 *       <hr>
	 *
	 *       For the `error` and `load` event on images no built-in AngularJS directives exist:<br>
	 *       <img src="thisimagedoesnotexist.png" ng-on-error="$ctrl.loadingState = -1" ng-on-load="$ctrl.loadingState = 1"><br>
	 *       <div ng-switch="$ctrl.loadingState">
	 *         <span ng-switch-when="0">Image is loading</span>
	 *         <span ng-switch-when="-1">Image load error</span>
	 *         <span ng-switch-when="1">Image loaded successfully</span>
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 * </example>
	 *
	 *
	 * @example
	 * ### Bind to custom DOM events
	 *
	 * <example name="ngOnCustom" module="exampleNgOn">
	 *   <file name="app.js">
	 *     angular.module('exampleNgOn', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function() {
	 *           this.eventLog = '';
	 *
	 *           this.listener = function($event) {
	 *             this.eventLog = 'Event with type "' + $event.type + '" fired at ' + $event.detail;
	 *           };
	 *         }
	 *       })
	 *       .component('childComponent', {
	 *         templateUrl: 'child.html',
	 *         controller: function($element) {
	 *           this.fireEvent = function() {
	 *             var event = new CustomEvent('customtype', { detail: new Date()});
	 *
	 *             $element[0].dispatchEvent(event);
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <child-component ng-on-customtype="$ctrl.listener($event)"></child-component><br>
	 *     <span>Event log: {{$ctrl.eventLog}}</span>
	 *   </file>
	 *   <file name="child.html">
	      <button ng-click="$ctrl.fireEvent()">Fire custom event</button>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 * </example>
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	/** @this */
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^([@&]|[=<](\*?))(\??)\s*([\w$]*)$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      definition = definition.trim();
	
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            'Invalid {3} for directive \'{0}\'.' +
	            ' Definition: {... {1}: \'{2}\' ...}',
	            directiveName, scopeName, definition,
	            (isController ? 'controller bindings definition' :
	            'isolate scope definition'));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (bindings.bindToController && !directive.controller) {
	      // There is no controller
	      throw $compileMinErr('noctrl',
	            'Cannot bind to controller without directive \'{0}\'s controller.',
	            directiveName);
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  function getDirectiveRestrict(restrict, name) {
	    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
	      throw $compileMinErr('badrestrict',
	          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
	          restrict,
	          name);
	    }
	
	    return restrict || 'EA';
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. `ngBind` which will match
	   *    as `ng-bind`), or an object map of directives where the keys are the names and the values
	   *    are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertArg(name, 'name');
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = getDirectiveRestrict(directive.restrict, name);
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	   *    or an object map of components where the keys are the names and the values are the component definition objects.
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    if (!isString(name)) {
	      forEach(name, reverseParams(bind(this, registerComponent)));
	      return this;
	    }
	
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return /** @this */ function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in AngularJS looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `ng-scope` and `ng-isolated-scope` CSS classes
	   * * `$binding` data property containing an array of the binding expressions
	   * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
	   *   the element's scope.
	   * * Placeholder comments will contain information about what directive and binding caused the placeholder.
	   *   E.g. `<!-- ngIf: shouldShow() -->`.
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#strictComponentBindingsEnabled
	   *
	   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided,
	   * otherwise return the current strictComponentBindingsEnabled state.
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable / disable the strict component bindings check. If enabled, the
	   * compiler will enforce that all scope / controller bindings of a
	   * {@link $compileProvider#directive directive} / {@link $compileProvider#component component}
	   * that are not set as optional with `?`, must be provided when the directive is instantiated.
	   * If not provided, the compiler will throw the
	   * {@link error/$compile/missingattr $compile:missingattr error}.
	   *
	   * The default value is false.
	   */
	  var strictComponentBindingsEnabled = false;
	  this.strictComponentBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      strictComponentBindingsEnabled = enabled;
	      return this;
	    }
	    return strictComponentBindingsEnabled;
	  };
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  var commentDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#commentDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on comments should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on comments for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check comments when looking for directives.
	   * This should however only be used if you are sure that no comment directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.commentDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      commentDirectivesEnabledConfig = value;
	      return this;
	    }
	    return commentDirectivesEnabledConfig;
	  };
	
	
	  var cssClassDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#cssClassDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on element classes should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on element classes for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check element classes when looking for directives.
	   * This should however only be used if you are sure that no class directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.cssClassDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      cssClassDirectivesEnabledConfig = value;
	      return this;
	    }
	    return cssClassDirectivesEnabledConfig;
	  };
	
	
	  /**
	   * The security context of DOM Properties.
	   * @private
	   */
	  var PROP_CONTEXTS = createMap();
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#addPropertySecurityContext
	   * @description
	   *
	   * Defines the security context for DOM properties bound by ng-prop-*.
	   *
	   * @param {string} elementName The element name or '*' to match any element.
	   * @param {string} propertyName The DOM property name.
	   * @param {string} ctx The {@link $sce} security context in which this value is safe for use, e.g. `$sce.URL`
	   * @returns {object} `this` for chaining
	   */
	  this.addPropertySecurityContext = function(elementName, propertyName, ctx) {
	    var key = (elementName.toLowerCase() + '|' + propertyName.toLowerCase());
	
	    if (key in PROP_CONTEXTS && PROP_CONTEXTS[key] !== ctx) {
	      throw $compileMinErr('ctxoverride', 'Property context \'{0}.{1}\' already set to \'{2}\', cannot override to \'{3}\'.', elementName, propertyName, PROP_CONTEXTS[key], ctx);
	    }
	
	    PROP_CONTEXTS[key] = ctx;
	    return this;
	  };
	
	  /* Default property contexts.
	   *
	   * Copy of https://github.com/angular/angular/blob/6.0.6/packages/compiler/src/schema/dom_security_schema.ts#L31-L58
	   * Changing:
	   * - SecurityContext.* => SCE_CONTEXTS/$sce.*
	   * - STYLE => CSS
	   * - various URL => MEDIA_URL
	   * - *|formAction, form|action URL => RESOURCE_URL (like the attribute)
	   */
	  (function registerNativePropertyContexts() {
	    function registerContext(ctx, values) {
	      forEach(values, function(v) { PROP_CONTEXTS[v.toLowerCase()] = ctx; });
	    }
	
	    registerContext(SCE_CONTEXTS.HTML, [
	      'iframe|srcdoc',
	      '*|innerHTML',
	      '*|outerHTML'
	    ]);
	    registerContext(SCE_CONTEXTS.CSS, ['*|style']);
	    registerContext(SCE_CONTEXTS.URL, [
	      'area|href',       'area|ping',
	      'a|href',          'a|ping',
	      'blockquote|cite',
	      'body|background',
	      'del|cite',
	      'input|src',
	      'ins|cite',
	      'q|cite'
	    ]);
	    registerContext(SCE_CONTEXTS.MEDIA_URL, [
	      'audio|src',
	      'img|src',    'img|srcset',
	      'source|src', 'source|srcset',
	      'track|src',
	      'video|src',  'video|poster'
	    ]);
	    registerContext(SCE_CONTEXTS.RESOURCE_URL, [
	      '*|formAction',
	      'applet|code',      'applet|codebase',
	      'base|href',
	      'embed|src',
	      'frame|src',
	      'form|action',
	      'head|profile',
	      'html|manifest',
	      'iframe|src',
	      'link|href',
	      'media|src',
	      'object|codebase',  'object|data',
	      'script|src'
	    ]);
	  })();
	
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
	    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function sanitizeSrcset(value, invokeType) {
	      if (!value) {
	        return value;
	      }
	      if (!isString(value)) {
	        throw $compileMinErr('srcset', 'Can\'t pass trusted values to `{0}`: "{1}"', invokeType, value.toString());
	      }
	
	      // Such values are a bit too complex to handle automatically inside $sce.
	      // Instead, we sanitize each of the URIs individually, which works, even dynamically.
	
	      // It's not possible to work around this using `$sce.trustAsMediaUrl`.
	      // If you want to programmatically set explicitly trusted unsafe URLs, you should use
	      // `$sce.trustAsHtml` on the whole `img` tag and inject it into the DOM using the
	      // `ng-bind-html` directive.
	
	      var result = '';
	
	      // first check if there are spaces because it's not the same pattern
	      var trimmedSrcset = trim(value);
	      //                (   999x   ,|   999w   ,|   ,|,   )
	      var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	      var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	      // split srcset into tuple of uri and descriptor except for the last item
	      var rawUris = trimmedSrcset.split(pattern);
	
	      // for each tuples
	      var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	      for (var i = 0; i < nbrUrisWith2parts; i++) {
	        var innerIdx = i * 2;
	        // sanitize the uri
	        result += $sce.getTrustedMediaUrl(trim(rawUris[innerIdx]));
	        // add the descriptor
	        result += ' ' + trim(rawUris[innerIdx + 1]);
	      }
	
	      // split the last item into uri and descriptor
	      var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	      // sanitize the last uri
	      result += $sce.getTrustedMediaUrl(trim(lastTuple[0]));
	
	      // and add the last descriptor if any
	      if (lastTuple.length === 2) {
	        result += (' ' + trim(lastTuple[1]));
	      }
	      return result;
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        // is set through this function since it may cause $updateClass to
	        // become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        // Sanitize img[srcset] values.
	        if (nodeName === 'img' && key === 'srcset') {
	          this[key] = value = sanitizeSrcset(value, '$set(\'srcset\', value)');
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              // jQuery skips special boolean attrs treatment in XML nodes for
	              // historical reasons and hence AngularJS cannot freely call
	              // `.attr(attrName, false) with such attributes. To avoid issues
	              // in XHTML, call `removeAttr` in such cases instead.
	              // See https://github.com/jquery/jquery/issues/4249
	              if (booleanKey && value === false) {
	                this.$$element.removeAttr(attrName);
	              } else {
	                this.$$element.attr(attrName, value);
	              }
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        if ($$observers) {
	          forEach($$observers[observer], function(fn) {
	            try {
	              fn(value);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_PREFIX_BINDING = /^ng(Attr|Prop|On)([A-Z].*)$/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        if (!$compileNodes) {
	          throw $compileMinErr('multilink', 'This element has already been linked.');
	        }
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div></div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	
	        if (!cloneConnectFn) {
	          $compileNodes = compositeLinkFn = null;
	        }
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          // `nodeList` can be either an element's `.childNodes` (live NodeList)
	          // or a jqLite/jQuery collection or an array
	          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // Support: IE 11 only
	        // Workaround for #11781 and #14924
	        if (msie === 11) {
	          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
	        }
	
	        // We must always refer to `nodeList[i]` hereafter,
	        // since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i += 3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
	      var node = nodeList[idx];
	      var parent = node.parentNode;
	      var sibling;
	
	      if (node.nodeType !== NODE_TYPE_TEXT) {
	        return;
	      }
	
	      while (true) {
	        sibling = parent ? node.nextSibling : nodeList[idx + 1];
	        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
	          break;
	        }
	
	        node.nodeValue = node.nodeValue + sibling.nodeValue;
	
	        if (sibling.parentNode) {
	          sibling.parentNode.removeChild(sibling);
	        }
	        if (notLiveList && sibling === nodeList[idx + 1]) {
	          nodeList.splice(idx + 1, 1);
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          nodeName,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	
	          nodeName = nodeName_(node);
	
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, value, ngPrefixMatch, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            var isNgAttr = false, isNgProp = false, isNgEvent = false;
	            var multiElementMatch;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = attr.value;
	
	            nName = directiveNormalize(name.toLowerCase());
	
	            // Support ng-attr-*, ng-prop-* and ng-on-*
	            if ((ngPrefixMatch = nName.match(NG_PREFIX_BINDING))) {
	              isNgAttr = ngPrefixMatch[1] === 'Attr';
	              isNgProp = ngPrefixMatch[1] === 'Prop';
	              isNgEvent = ngPrefixMatch[1] === 'On';
	
	              // Normalize the non-prefixed name
	              name = name.replace(PREFIX_REGEXP, '')
	                .toLowerCase()
	                .substr(4 + ngPrefixMatch[1].length).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	
	            // Support *-start / *-end multi element directives
	            } else if ((multiElementMatch = nName.match(MULTI_ELEMENT_DIR_RE)) && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            if (isNgProp || isNgEvent) {
	              attrs[nName] = value;
	              attrsMap[nName] = attr.name;
	
	              if (isNgProp) {
	                addPropertyDirective(node, directives, nName, name);
	              } else {
	                addEventDirective(directives, nName, name);
	              }
	            } else {
	              // Update nName for cases where a prefix was removed
	              // NOTE: the .toLowerCase() is unnecessary and causes https://github.com/angular/angular.js/issues/16624 for ng-attr-*
	              nName = directiveNormalize(name.toLowerCase());
	              attrsMap[nName] = name;
	
	              if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	              }
	
	              addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	              addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                            attrEndName);
	            }
	          }
	
	          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
	            // Hidden input elements can have strange behaviour when navigating back to the page
	            // This tells the browser not to try to cache and reinstate previous values
	            node.setAttribute('autocomplete', 'off');
	          }
	
	          // use class as directive
	          if (!cssClassDirectivesEnabled) break;
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          if (!commentDirectivesEnabled) break;
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with a directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType === NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return /** @this */ function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        directiveValue = directive.scope;
	
	        if (directiveValue) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate('\'' + directiveName + '\' controller',
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        directiveValue = directive.transclude;
	
	        if (directiveValue) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue === 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            if (!isObject(directiveValue)) {
	              $template = jqLite(jqLiteClone(compileNode)).contents();
	            } else {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = window.document.createDocumentFragment();
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || window.document.createDocumentFragment();
	                  slots[slotName].appendChild(node);
	                } else {
	                  $template.appendChild(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  var slotCompileNodes = jqLite(slots[slotName].childNodes);
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slotCompileNodes, transcludeFn);
	                }
	              }
	
	              $template = jqLite($template.childNodes);
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          // eslint-disable-next-line no-func-assign
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          controller.instance = controller();
	          $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
	          controller.bindingInfo =
	            initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        if (childLinkFn) {
	          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	        }
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	
	          if (inheritType === '^^' && $element[0] && $element[0].nodeType === NODE_TYPE_DOCUMENT) {
	            // inheritedData() uses the documentElement when it finds the document, so we would
	            // require from the element itself.
	            value = null;
	          } else {
	            value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	          }
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller === '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	               directive.restrict.indexOf(location) !== -1) {
	            if (startAttrName) {
	              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	            }
	            if (!directive.$$bindings) {
	              var bindings = directive.$$bindings =
	                  parseDirectiveBindings(directive, directive.name);
	              if (isObject(bindings.isolateScope)) {
	                directive.$$isolateBindings = bindings.isolateScope;
	              }
	            }
	            tDirectives.push(directive);
	            match = directive;
	          }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) !== '$') {
	          if (src[key] && src[key] !== value) {
	            if (value.length) {
	              value += (key === 'style' ? ';' : ' ') + src[key];
	            } else {
	              value = src[key];
	            }
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node === compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        }).catch(function(error) {
	          if (isError(error)) {
	            $exceptionHandler(error);
	          }
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedAttrContext(nodeName, attrNormalizedName) {
	      if (attrNormalizedName === 'srcdoc') {
	        return $sce.HTML;
	      }
	      // All nodes with src attributes require a RESOURCE_URL value, except for
	      // img and various html5 media nodes, which require the MEDIA_URL context.
	      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
	        if (['img', 'video', 'audio', 'source', 'track'].indexOf(nodeName) === -1) {
	          return $sce.RESOURCE_URL;
	        }
	        return $sce.MEDIA_URL;
	      } else if (attrNormalizedName === 'xlinkHref') {
	        // Some xlink:href are okay, most aren't
	        if (nodeName === 'image') return $sce.MEDIA_URL;
	        if (nodeName === 'a') return $sce.URL;
	        return $sce.RESOURCE_URL;
	      } else if (
	          // Formaction
	          (nodeName === 'form' && attrNormalizedName === 'action') ||
	          // If relative URLs can go where they are not expected to, then
	          // all sorts of trust issues can arise.
	          (nodeName === 'base' && attrNormalizedName === 'href') ||
	          // links can be stylesheets or imports, which can run script in the current origin
	          (nodeName === 'link' && attrNormalizedName === 'href')
	      ) {
	        return $sce.RESOURCE_URL;
	      } else if (nodeName === 'a' && (attrNormalizedName === 'href' ||
	                                 attrNormalizedName === 'ngHref')) {
	        return $sce.URL;
	      }
	    }
	
	    function getTrustedPropContext(nodeName, propNormalizedName) {
	      var prop = propNormalizedName.toLowerCase();
	      return PROP_CONTEXTS[nodeName + '|' + prop] || PROP_CONTEXTS['*|' + prop];
	    }
	
	    function sanitizeSrcsetPropertyValue(value) {
	      return sanitizeSrcset($sce.valueOf(value), 'ng-prop-srcset');
	    }
	    function addPropertyDirective(node, directives, attrName, propName) {
	      if (EVENT_HANDLER_ATTR_REGEXP.test(propName)) {
	        throw $compileMinErr('nodomevents', 'Property bindings for HTML DOM event properties are disallowed');
	      }
	
	      var nodeName = nodeName_(node);
	      var trustedContext = getTrustedPropContext(nodeName, propName);
	
	      var sanitizer = identity;
	      // Sanitize img[srcset] + source[srcset] values.
	      if (propName === 'srcset' && (nodeName === 'img' || nodeName === 'source')) {
	        sanitizer = sanitizeSrcsetPropertyValue;
	      } else if (trustedContext) {
	        sanitizer = $sce.getTrusted.bind($sce, trustedContext);
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function ngPropCompileFn(_, attr) {
	          var ngPropGetter = $parse(attr[attrName]);
	          var ngPropWatch = $parse(attr[attrName], function sceValueOf(val) {
	            // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	            return $sce.valueOf(val);
	          });
	
	          return {
	            pre: function ngPropPreLinkFn(scope, $element) {
	              function applyPropValue() {
	                var propValue = ngPropGetter(scope);
	                $element[0][propName] = sanitizer(propValue);
	              }
	
	              applyPropValue();
	              scope.$watch(ngPropWatch, applyPropValue);
	            }
	          };
	        }
	      });
	    }
	
	    function addEventDirective(directives, attrName, eventName) {
	      directives.push(
	        createEventDirective($parse, $rootScope, $exceptionHandler, attrName, eventName, /*forceAsync=*/false)
	      );
	    }
	
	    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
	      var nodeName = nodeName_(node);
	      var trustedContext = getTrustedAttrContext(nodeName, name);
	      var mustHaveExpression = !isNgAttr;
	      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
	
	      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	      if (name === 'multiple' && nodeName === 'select') {
	        throw $compileMinErr('selmulti',
	            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
	            startingTag(node));
	      }
	
	      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	        throw $compileMinErr('nodomevents', 'Interpolations for HTML DOM event attributes are disallowed');
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue !== oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] === firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	    function strictBindingsCheck(attrName, directiveName) {
	      if (strictComponentBindingsEnabled) {
	        throw $compileMinErr('missingattr',
	          'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!',
	          attrName, directiveName);
	      }
	    }
	
	    // Set up $watches for isolate scope and controller bindings.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	              destination[scopeName] = attrs[attrName] = undefined;
	
	            }
	            removeWatch = attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = simpleCompare;
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              lastValue = parentValue;
	              return lastValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            var isLiteral = parentGet.literal;
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope[definition.collection ? '$watchCollection' : '$watch'](parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue || (isLiteral && equals(oldValue, initialValue))) {
	                  return;
	                }
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            });
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	            }
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;
	
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return name
	    .replace(PREFIX_REGEXP, '')
	    .replace(SPECIAL_CHARS_REGEXP, function(_, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    });
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in AngularJS:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token === tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT ||
	       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
	         splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @this
	 *
	 * @description
	 * The {@link ng.$controller $controller service} is used by AngularJS to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {};
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            'Badly formed controller string \'{0}\'. ' +
	            'Must match `__name__ as __id__` or `__name__`.', expression);
	        }
	        constructor = match[1];
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true);
	
	        if (!expression) {
	          throw $controllerMinErr('ctrlreg',
	            'The controller with the name \'{0}\' is not registered.', constructor);
	        }
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        return extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 * @this
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample" name="document">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	
	/**
	 * @private
	 * @this
	 * Listens for document visibility change and makes the current status accessible.
	 */
	function $$IsDocumentHiddenProvider() {
	  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
	    var doc = $document[0];
	    var hidden = doc && doc.hidden;
	
	    $document.on('visibilitychange', changeListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('visibilitychange', changeListener);
	    });
	
	    function changeListener() {
	      hidden = doc.hidden;
	    }
	
	    return function() {
	      return hidden;
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 * @this
	 *
	 * @description
	 * Any uncaught exception in AngularJS expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = /** @this */ function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
	var $httpMinErr = minErr('$http');
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	/** @this */
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value) || isFunction(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	/** @this */
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   *
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          if (isFunction(toSerialize)) {
	            toSerialize = toSerialize();
	          }
	          parts.push(encodeUriQuery(prefix) + '=' +
	              (toSerialize == null ? '' : encodeUriQuery(serializeValue(toSerialize))));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      var hasJsonContentType = contentType && (contentType.indexOf(APPLICATION_JSON) === 0);
	
	      if (hasJsonContentType || isJsonLike(tempData)) {
	        try {
	          data = fromJson(tempData);
	        } catch (e) {
	          if (!hasJsonContentType) {
	            return data;
	          }
	          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
	          'Parse error: "{1}"', data, e);
	        }
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === undefined) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @this
	 *
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
	   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
	   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   * - **`defaults.transformRequest`** -
	   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
	   * An array of functions (or a single function) which are applied to the request data.
	   * By default, this is an array with one request transformation function:
	   *
	   *   - If the `data` property of the request configuration object contains an object, serialize it
	   *     into JSON format.
	   *
	   * - **`defaults.transformResponse`** -
	   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
	   * An array of functions (or a single function) which are applied to the response data. By default,
	   * this is an array which applies one response transformation function that does two things:
	   *
	   *  - If XSRF prefix is detected, strip it
	   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
	   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *    deserialize it using a JSON parser.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   */
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer',
	
	    jsonpCallbackParam: 'callback'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   */
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   */
	  var interceptorFactories = this.interceptors = [];
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#xsrfWhitelistedOrigins
	   * @description
	   *
	   * Array containing URLs whose origins are trusted to receive the XSRF token. See the
	   * {@link ng.$http#security-considerations Security Considerations} sections for more details on
	   * XSRF.
	   *
	   * **Note:** An "origin" consists of the [URI scheme](https://en.wikipedia.org/wiki/URI_scheme),
	   * the [hostname](https://en.wikipedia.org/wiki/Hostname) and the
	   * [port number](https://en.wikipedia.org/wiki/Port_(computer_networking). For `http:` and
	   * `https:`, the port number can be omitted if using th default ports (80 and 443 respectively).
	   * Examples: `http://example.com`, `https://api.example.com:9876`
	   *
	   * <div class="alert alert-warning">
	   *   It is not possible to whitelist specific URLs/paths. The `path`, `query` and `fragment` parts
	   *   of a URL will be ignored. For example, `https://foo.com/path/bar?query=baz#fragment` will be
	   *   treated as `https://foo.com`, meaning that **all** requests to URLs starting with
	   *   `https://foo.com/` will include the XSRF token.
	   * </div>
	   *
	   * @example
	   *
	   * ```js
	   * // App served from `https://example.com/`.
	   * angular.
	   *   module('xsrfWhitelistedOriginsExample', []).
	   *   config(['$httpProvider', function($httpProvider) {
	   *     $httpProvider.xsrfWhitelistedOrigins.push('https://api.example.com');
	   *   }]).
	   *   run(['$http', function($http) {
	   *     // The XSRF token will be sent.
	   *     $http.get('https://api.example.com/preferences').then(...);
	   *
	   *     // The XSRF token will NOT be sent.
	   *     $http.get('https://stats.example.com/activity').then(...);
	   *   }]);
	   * ```
	   */
	  var xsrfWhitelistedOrigins = this.xsrfWhitelistedOrigins = [];
	
	  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
	      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * A function to check request URLs against a list of allowed origins.
	     */
	    var urlIsAllowedOrigin = urlIsAllowedOriginFactory(xsrfWhitelistedOrigins);
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core AngularJS service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise} that is
	     * resolved (request success) or rejected (request failure) with a
	     * {@link ng.$http#$http-returns response} object.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * AngularJS provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
	     * an array with one function that does the following:
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
	     * an array with one function that does the following:
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *      deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * AngularJS will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * AngularJS will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (by default `X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read
	     * the cookie, your server can be assured that the XHR came from JavaScript running on your
	     * domain.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches the `X-XSRF-TOKEN` HTTP header, and therefore be
	     * sure that only JavaScript running on your domain could have sent the request. The token must
	     * be unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The header will &mdash; by default &mdash; **not** be set for cross-domain requests. This
	     * prevents unauthorized servers (e.g. malicious or compromised 3rd-party APIs) from gaining
	     * access to your users' XSRF tokens and exposing them to Cross Site Request Forgery. If you
	     * want to, you can whitelist additional origins to also receive the XSRF token, by adding them
	     * to {@link ng.$httpProvider#xsrfWhitelistedOrigins xsrfWhitelistedOrigins}. This might be
	     * useful, for example, if your application, served from `example.com`, needs to access your API
	     * at `api.example.com`.
	     * See {@link ng.$httpProvider#xsrfWhitelistedOrigins $httpProvider.xsrfWhitelistedOrigins} for
	     * more details.
	     *
	     * <div class="alert alert-danger">
	     *   **Warning**<br />
	     *   Only whitelist origins that you have control over and make sure you understand the
	     *   implications of doing so.
	     * </div>
	     *
	     * The name of the cookie and the header can be specified using the `xsrfCookieName` and
	     * `xsrfHeaderName` properties of either `$httpProvider.defaults` at config-time,
	     * `$http.defaults` at run-time, or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple AngularJS apps share the
	     * same domain or subdomain, we recommend that each application uses a unique cookie name.
	     *
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
	     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *
	     *      A numerical timeout or a promise returned from {@link ng.$timeout $timeout}, will set
	     *      the `xhrStatus` in the {@link $http#$http-returns response} to "timeout", and any other
	     *      resolved promise will set it to "abort", following standard XMLHttpRequest behavior.
	     *
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} A {@link ng.$q `Promise}` that will be resolved (request success)
	     *   or rejected (request failure) with a response object.
	     *
	     *   The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with
	     *     the transform functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used
	     *     to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest
	     *     (`complete`, `error`, `timeout` or `abort`).
	     *
	     *
	     *   A response status code between 200 and 299 is considered a success status
	     *   and will result in the success callback being called. Any response status
	     *   code outside of that range is considered an error status and will result
	     *   in the error callback being called.
	     *   Also, status codes less than -1 are normalized to zero. -1 usually means
	     *   the request was aborted, e.g. using a `config.timeout`. More information
	     *   about the status might be available in the `xhrStatus` property.
	     *
	     *   Note that if the response is a redirect, XMLHttpRequest will transparently
	     *   follow it, meaning that the outcome (success or error) will be determined
	     *   by the final response status code.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample" name="http-service">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
	      // We must whitelist the JSONP endpoint that we are using to show that we trust it
	      $sceDelegateProvider.resourceUrlWhitelist([
	        'self',
	        'https://angularjs.org/**'
	      ]);
	    }])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || 'Request failed';
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString($sce.valueOf(requestConfig.url))) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer,
	        jsonpCallbackParam: defaults.jsonpCallbackParam
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      $browser.$$incOutstandingRequestCount('$http');
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.resolve(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	      promise = promise.finally(completeOutstandingRequest);
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function completeOutstandingRequest() {
	        $browser.$$completeOutstandingRequest(noop, '$http');
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
	     * the url must be declared, via {@link $sce} as a trusted resource URL.
	     * You can trust a URL by adding it to the whitelist via
	     * {@link $sceDelegateProvider#resourceUrlWhitelist  `$sceDelegateProvider.resourceUrlWhitelist`} or
	     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
	     *
	     * You should avoid generating the URL for the JSONP request from user provided data.
	     * Provide additional query parameters via `params` property of the `config` parameter, rather than
	     * modifying the URL itself.
	     *
	     * JSONP requests must specify a callback to be used in the response from the server. This callback
	     * is passed as a query parameter in the request. You must specify the name of this parameter by
	     * setting the `jsonpCallbackParam` property on the request config object.
	     *
	     * ```
	     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
	     * ```
	     *
	     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
	     * Initially this is set to `'callback'`.
	     *
	     * <div class="alert alert-danger">
	     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
	     * parameter value should go.
	     * </div>
	     *
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	      * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	      * See {@link ng.$http#$http-returns `$http()` return value}.
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          isJsonp = lowercase(config.method) === 'jsonp',
	          url = config.url;
	
	      if (isJsonp) {
	        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
	        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
	        url = $sce.getTrustedResourceUrl(url);
	      } else if (!isString(url)) {
	        // If it is not a string then the URL must be a $sce trusted object
	        url = $sce.valueOf(url);
	      }
	
	      url = buildUrl(url, config.paramSerializer(config.params));
	
	      if (isJsonp) {
	        // Check the url and add the JSONP callback placeholder
	        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
	      }
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	            : isObject(/** @type {?} */ (defaults).cache)
	              ? /** @type {?} */ (defaults).cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsAllowedOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText, xhrStatus) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText, xhrStatus);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText, xhrStatus) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText,
	          xhrStatus: xhrStatus
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	
	    function sanitizeJsonpCallbackParam(url, cbKey) {
	      var parts = url.split('?');
	      if (parts.length > 2) {
	        // Throw if the url contains more than one `?` query indicator
	        throw $httpMinErr('badjsonp', 'Illegal use more than one "?", in url, "{1}"', url);
	      }
	      var params = parseKeyValue(parts[1]);
	      forEach(params, function(value, key) {
	        if (value === 'JSON_CALLBACK') {
	          // Throw if the url already contains a reference to JSON_CALLBACK
	          throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
	        }
	        if (key === cbKey) {
	          // Throw if the callback param was already provided
	          throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
	        }
	      });
	
	      // Add in the JSON_CALLBACK callback param value
	      url += ((url.indexOf('?') === -1) ? '?' : '&') + cbKey + '=JSON_CALLBACK';
	
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 * @this
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 * @this
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, '', text, 'complete');
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	      var abortedByTimeout = false;
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText,
	            'complete');
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'error');
	      };
	
	      var requestAborted = function() {
	        completeRequest(callback, -1, null, null, '', abortedByTimeout ? 'timeout' : 'abort');
	      };
	
	      var requestTimeout = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'timeout');
	      };
	
	      xhr.onerror = requestError;
	      xhr.ontimeout = requestTimeout;
	      xhr.onabort = requestAborted;
	
	      forEach(eventHandlers, function(value, key) {
	        xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    // Since we are using xhr.abort() when a request times out, we have to set a flag that
	    // indicates to requestAborted if the request timed out or was aborted.
	    //
	    // http.timeout = numerical timeout   timeout
	    // http.timeout = $timeout            timeout
	    // http.timeout = promise             abort
	    // xhr.abort()                        abort (The xhr object is normally inaccessible, but
	    //                                    can be exposed with the xhrFactory)
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(function() {
	        timeoutRequest('timeout');
	      }, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(function() {
	        timeoutRequest(isDefined(timeout.$$timeoutId) ? 'timeout' : 'abort');
	      });
	    }
	
	    function timeoutRequest(reason) {
	      abortedByTimeout = reason === 'timeout';
	      if (jsonpDone) {
	        jsonpDone();
	      }
	      if (xhr) {
	        xhr.abort();
	      }
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText, xhrStatus);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = 'text/javascript';
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      script.removeEventListener('load', callback);
	      script.removeEventListener('error', callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = 'unknown';
	
	      if (event) {
	        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
	          event = { type: 'error' };
	        }
	        text = event.type;
	        status = event.type === 'error' ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    script.addEventListener('load', callback);
	    script.addEventListener('error', callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
	      'interpolations that concatenate multiple expressions when a trusted value is ' +
	      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    }
	    return startSymbol;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    }
	    return endSymbol;
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    // TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULARJS!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'AngularJS';
	     *   expect(exp(context)).toEqual('Hello AngularJS!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example name="interpolation">
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      var contextAllowsConcatenation = trustedContext === $sce.URL || trustedContext === $sce.MEDIA_URL;
	
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        if (mustHaveExpression) return;
	
	        var unescapedText = unescapeText(text);
	        if (contextAllowsConcatenation) {
	          unescapedText = $sce.getTrusted(trustedContext, unescapedText);
	        }
	        var constantInterp = valueFn(unescapedText);
	        constantInterp.exp = text;
	        constantInterp.expressions = [];
	        constantInterp.$$watchDelegate = constantWatchDelegate;
	
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns,
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [],
	          singleExpression;
	
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push(''); // Placeholder that will get replaced with the evaluated expression.
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      singleExpression = concat.length === 1 && expressionPositions.length === 1;
	      // Intercept expression if we need to stringify concatenated inputs, which may be SCE trusted
	      // objects rather than simple strings
	      // (we don't modify the expression if the input consists of only a single trusted input)
	      var interceptor = contextAllowsConcatenation && singleExpression ? undefined : parseStringifyInterceptor;
	      parseFns = expressions.map(function(exp) { return $parse(exp, interceptor); });
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for some $sce-managed secure contexts (RESOURCE_URLs mostly),
	      // we ensure that the value that's used is assigned or constructed by some JS code somewhere
	      // that is more testable or make it obvious that you bound the value to some user controlled
	      // value.  This helps reduce the load when auditing for XSS issues.
	
	      // Note that URL and MEDIA_URL $sce contexts do not need this, since `$sce` can sanitize the values
	      // passed to it. In that case, `$sce.getTrusted` will be called on either the single expression
	      // or on the overall concatenated string (losing trusted types used in the mix, by design).
	      // Both these methods will sanitize plain strings. Also, HTML could be included, but since it's
	      // only used in srcdoc attributes, this would not be very useful.
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	
	          if (contextAllowsConcatenation) {
	            // If `singleExpression` then `concat[0]` might be a "trusted" value or `null`, rather than a string
	            return $sce.getTrusted(trustedContext, singleExpression ? concat[0] : concat.join(''));
	          } else if (trustedContext && concat.length > 1) {
	            // This context does not allow more than one part, e.g. expr + string or exp + exp.
	            $interpolateMinErr.throwNoconcat(text);
	          }
	          // In an unprivileged context or only one part: just concatenate and return.
	          return concat.join('');
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          // In concatenable contexts, getTrusted comes at the end, to avoid sanitizing individual
	          // parts of a full URL. We don't care about losing the trustedness here.
	          // In non-concatenable contexts, where there is only one expression, this interceptor is
	          // not applied to the expression.
	          value = (trustedContext && !contextAllowsConcatenation) ?
	                    $sce.getTrusted(trustedContext, value) :
	                    $sce.valueOf(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	var $intervalMinErr = minErr('$interval');
	
	/** @this */
	function $IntervalProvider() {
	  this.$get = ['$$intervalFactory', '$window',
	       function($$intervalFactory,   $window) {
	    var intervals = {};
	    var setIntervalFn = function(tick, delay, deferred) {
	      var id = $window.setInterval(tick, delay);
	      intervals[id] = deferred;
	      return id;
	    };
	    var clearIntervalFn = function(id) {
	      $window.clearInterval(id);
	      delete intervals[id];
	    };
	
	    /**
	     * @ngdoc service
	     * @name $interval
	     *
	     * @description
	     * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	     * milliseconds.
	     *
	     * The return value of registering an interval function is a promise. This promise will be
	     * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	     * run indefinitely if `count` is not defined. The value of the notification will be the
	     * number of iterations that have run.
	     * To cancel an interval, call `$interval.cancel(promise)`.
	     *
	     * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	     * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	     * time.
	     *
	     * <div class="alert alert-warning">
	     * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	     * with them.  In particular they are not automatically destroyed when a controller's scope or a
	     * directive's element are destroyed.
	     * You should take this into consideration and make sure to always cancel the interval at the
	     * appropriate moment.  See the example below for more details on how and when to do this.
	     * </div>
	     *
	     * @param {function()} fn A function that should be called repeatedly. If no additional arguments
	     *   are passed (see below), the function is called with the current iteration count.
	     * @param {number} delay Number of milliseconds between each function call.
	     * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	     *   indefinitely.
	     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	     * @param {...*=} Pass additional parameters to the executed function.
	     * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
	     *
	     * @example
	     * <example module="intervalExample" name="interval-service">
	     * <file name="index.html">
	     *   <script>
	     *     angular.module('intervalExample', [])
	     *       .controller('ExampleController', ['$scope', '$interval',
	     *         function($scope, $interval) {
	     *           $scope.format = 'M/d/yy h:mm:ss a';
	     *           $scope.blood_1 = 100;
	     *           $scope.blood_2 = 120;
	     *
	     *           var stop;
	     *           $scope.fight = function() {
	     *             // Don't start a new fight if we are already fighting
	     *             if ( angular.isDefined(stop) ) return;
	     *
	     *             stop = $interval(function() {
	     *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	     *                 $scope.blood_1 = $scope.blood_1 - 3;
	     *                 $scope.blood_2 = $scope.blood_2 - 4;
	     *               } else {
	     *                 $scope.stopFight();
	     *               }
	     *             }, 100);
	     *           };
	     *
	     *           $scope.stopFight = function() {
	     *             if (angular.isDefined(stop)) {
	     *               $interval.cancel(stop);
	     *               stop = undefined;
	     *             }
	     *           };
	     *
	     *           $scope.resetFight = function() {
	     *             $scope.blood_1 = 100;
	     *             $scope.blood_2 = 120;
	     *           };
	     *
	     *           $scope.$on('$destroy', function() {
	     *             // Make sure that the interval is destroyed too
	     *             $scope.stopFight();
	     *           });
	     *         }])
	     *       // Register the 'myCurrentTime' directive factory method.
	     *       // We inject $interval and dateFilter service since the factory method is DI.
	     *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	     *         function($interval, dateFilter) {
	     *           // return the directive link function. (compile function not needed)
	     *           return function(scope, element, attrs) {
	     *             var format,  // date format
	     *                 stopTime; // so that we can cancel the time updates
	     *
	     *             // used to update the UI
	     *             function updateTime() {
	     *               element.text(dateFilter(new Date(), format));
	     *             }
	     *
	     *             // watch the expression, and update the UI on change.
	     *             scope.$watch(attrs.myCurrentTime, function(value) {
	     *               format = value;
	     *               updateTime();
	     *             });
	     *
	     *             stopTime = $interval(updateTime, 1000);
	     *
	     *             // listen on DOM destroy (removal) event, and cancel the next UI update
	     *             // to prevent updating time after the DOM element was removed.
	     *             element.on('$destroy', function() {
	     *               $interval.cancel(stopTime);
	     *             });
	     *           }
	     *         }]);
	     *   </script>
	     *
	     *   <div>
	     *     <div ng-controller="ExampleController">
	     *       <label>Date format: <input ng-model="format"></label> <hr/>
	     *       Current time is: <span my-current-time="format"></span>
	     *       <hr/>
	     *       Blood 1 : <font color='red'>{{blood_1}}</font>
	     *       Blood 2 : <font color='red'>{{blood_2}}</font>
	     *       <button type="button" data-ng-click="fight()">Fight</button>
	     *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	     *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	     *     </div>
	     *   </div>
	     *
	     * </file>
	     * </example>
	     */
	    var interval = $$intervalFactory(setIntervalFn, clearIntervalFn);
	
	    /**
	     * @ngdoc method
	     * @name $interval#cancel
	     *
	     * @description
	     * Cancels a task associated with the `promise`.
	     *
	     * @param {Promise=} promise returned by the `$interval` function.
	     * @returns {boolean} Returns `true` if the task was successfully canceled.
	     */
	    interval.cancel = function(promise) {
	      if (!promise) return false;
	
	      if (!promise.hasOwnProperty('$$intervalId')) {
	        throw $intervalMinErr('badprom',
	            '`$interval.cancel()` called with a promise that was not generated by `$interval()`.');
	      }
	
	      if (!intervals.hasOwnProperty(promise.$$intervalId)) return false;
	
	      var id = promise.$$intervalId;
	      var deferred = intervals[id];
	
	      // Interval cancels should not report an unhandled promise.
	      markQExceptionHandled(deferred.promise);
	      deferred.reject('canceled');
	      clearIntervalFn(id);
	
	      return true;
	    };
	
	    return interval;
	  }];
	}
	
	/** @this */
	function $$IntervalFactoryProvider() {
	  this.$get = ['$browser', '$q', '$$q', '$rootScope',
	       function($browser,   $q,   $$q,   $rootScope) {
	    return function intervalFactory(setIntervalFn, clearIntervalFn) {
	      return function intervalFn(fn, delay, count, invokeApply) {
	        var hasParams = arguments.length > 4,
	            args = hasParams ? sliceArgs(arguments, 4) : [],
	            iteration = 0,
	            skipApply = isDefined(invokeApply) && !invokeApply,
	            deferred = (skipApply ? $$q : $q).defer(),
	            promise = deferred.promise;
	
	        count = isDefined(count) ? count : 0;
	
	        function callback() {
	          if (!hasParams) {
	            fn(iteration);
	          } else {
	            fn.apply(null, args);
	          }
	        }
	
	        function tick() {
	          if (skipApply) {
	            $browser.defer(callback);
	          } else {
	            $rootScope.$evalAsync(callback);
	          }
	          deferred.notify(iteration++);
	
	          if (count > 0 && iteration >= count) {
	            deferred.resolve(iteration);
	            clearIntervalFn(promise.$$intervalId);
	          }
	
	          if (!skipApply) $rootScope.$apply();
	        }
	
	        promise.$$intervalId = setIntervalFn(tick, delay, deferred, skipApply);
	
	        return promise;
	      };
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = /** @this */ function() {
	  this.$get = function() {
	    var callbacks = angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  };
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various AngularJS components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	/* global stripHash: true */
	
	var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    // decode forward slashes to prevent them from being double encoded
	    segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, '/'));
	  }
	
	  return segments.join('/');
	}
	
	function decodePath(path, html5Mode) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = decodeURIComponent(segments[i]);
	    if (html5Mode) {
	      // encode forward slashes to prevent them from being mistaken for path separators
	      segments[i] = segments[i].replace(/\//g, '%2F');
	    }
	  }
	
	  return segments.join('/');
	}
	
	function normalizePath(pathValue, searchValue, hashValue) {
	  var search = toKeyValue(searchValue),
	    hash = hashValue ? '#' + encodeUriSegment(hashValue) : '',
	    path = encodePath(pathValue);
	
	  return path + (search ? '?' + search : '') + hash;
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
	function parseAppUrl(url, locationObj, html5Mode) {
	
	  if (DOUBLE_SLASH_REGEX.test(url)) {
	    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
	  }
	
	  var prefixed = (url.charAt(0) !== '/');
	  if (prefixed) {
	    url = '/' + url;
	  }
	  var match = urlResolve(url);
	  var path = prefixed && match.pathname.charAt(0) === '/' ? match.pathname.substring(1) : match.pathname;
	  locationObj.$$path = decodePath(path, html5Mode);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(str, search) {
	  return str.slice(0, search.length) === search;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? url : url.substr(0, index);
	}
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents a URL
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix URL path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given HTML5 (regular) URL string into properties
	   * @param {string} url HTML5 URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this, true);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  this.$$normalizeUrl = function(url) {
	    return appBaseNoFile + url.substr(1); // first char is always '/'
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang URL into properties
	   * @param {string} url Hashbang URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the URL starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          /** @type {?} */ (this).replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this, false);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of AngularJS, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  this.$$normalizeUrl = function(url) {
	    return appBase + (url ? hashPrefix + url : '');
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) === stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase === stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$normalizeUrl = function(url) {
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    return appBase + hashPrefix + url;
	  };
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute URL is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * Compose url and update `url` and `absUrl` property
	   * @private
	   */
	  $$compose: function() {
	    this.$$url = normalizePath(this.$$path, this.$$search, this.$$hash);
	    this.$$absUrl = this.$$normalizeUrl(this.$$url);
	    this.$$urlUpdatedByLocation = true;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full URL representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full URL
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current URL
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current URL.
	   *
	   * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current URL.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current URL when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) === '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current URL when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the URL.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	    this.$$urlUpdatedByLocation = true;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return /** @this */ function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return /** @this */ function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @this
	 *
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '!',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * The default value for the prefix is `'!'`.
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
	   *     only happen on links with an attribute that matches the given string. For example, if set
	   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
	   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
	   *     here, so `'internalLink'` will **not** match `'internal-link'`.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          '$location in HTML5 mode requires a <base> tag to be present!');
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    // Determine if two URLs are equal despite potentially having different encoding/normalizing
	    //  such as $location.absUrl() vs $browser.url()
	    // See https://github.com/angular/angular.js/issues/16592
	    function urlsEqual(a, b) {
	      return a === b || urlResolve(a).href === urlResolve(b).href;
	    }
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      var rewriteLinks = html5Mode.rewriteLinks;
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the AngularJS application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() !== $browser.url()) {
	            $rootScope.$apply();
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if ($location.absUrl() !== initialUrl) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (!startsWith(newUrl, appBaseNoFile)) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      if (initializing || $location.$$urlUpdatedByLocation) {
	        $location.$$urlUpdatedByLocation = false;
	
	        var oldUrl = $browser.url();
	        var newUrl = $location.absUrl();
	        var oldState = $browser.state();
	        var currentReplace = $location.$$replace;
	        var urlOrStateChanged = !urlsEqual(oldUrl, newUrl) ||
	          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	        if (initializing || urlOrStateChanged) {
	          initializing = false;
	
	          $rootScope.$evalAsync(function() {
	            var newUrl = $location.absUrl();
	            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	                $location.$$state, oldState).defaultPrevented;
	
	            // if the location was changed by a `$locationChangeStart` handler then stop
	            // processing this location change
	            if ($location.absUrl() !== newUrl) return;
	
	            if (defaultPrevented) {
	              $location.$$parse(oldUrl);
	              $location.$$state = oldState;
	            } else {
	              if (urlOrStateChanged) {
	                setBrowserUrlWithFallback(newUrl, currentReplace,
	                                          oldState === $location.$$state ? null : $location.$$state);
	              }
	              afterLocationChange(oldUrl, oldState);
	            }
	          });
	        }
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * To reveal the location of the calls to `$log` in the JavaScript console,
	 * you can "blackbox" the AngularJS source in your browser:
	 *
	 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
	 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
	 *
	 * Note: Not all browsers support blackboxing.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample" name="log-service">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @this
	 *
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	      return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    // Support: IE 9-11, Edge 12-14+
	    // IE/Edge display errors in such a way that it requires the user to click in 4 places
	    // to see the stack trace. There is no way to feature-detect it so there's a chance
	    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
	    // break apps. Other browsers display errors in a sensible way and some of them map stack
	    // traces along source maps if available so it makes sense to let browsers display it
	    // as they want.
	    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      })()
	    };
	
	    function formatError(arg) {
	      if (isError(arg)) {
	        if (arg.stack && formatStackTrace) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop;
	
	      return function() {
	        var args = [];
	        forEach(arguments, function(arg) {
	          args.push(formatError(arg));
	        });
	        // Support: IE 9 only
	        // console methods don't inherit from Function.prototype in IE 9 so we can't
	        // call `logFn.apply(console, args)` directly.
	        return Function.prototype.apply.call(logFn, console, args);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	var objectValueOf = {}.constructor.prototype.valueOf;
	
	// Sandboxing AngularJS Expressions
	// ------------------------------
	// AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
	// various means such as obtaining a reference to native JS functions like the Function constructor.
	//
	// As an example, consider the following AngularJS expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// It is important to realize that if you create an expression from a string that contains user provided
	// content then it is possible that your application contains a security vulnerability to an XSS style attack.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function Lexer(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === '\'') {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    // eslint-disable-next-line no-bitwise
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch === '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch === 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) === 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) === 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function AST(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    while (this.expect('|')) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      if (!isAssignable(result)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError('invalid key', this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	var PURITY_ABSOLUTE = 1;
	var PURITY_RELATIVE = 2;
	
	// Detect nodes which could depend on non-shallow state of objects
	function isPure(node, parentIsPure) {
	  switch (node.type) {
	    // Computed members might invoke a stateful toString()
	    case AST.MemberExpression:
	      if (node.computed) {
	        return false;
	      }
	      break;
	
	    // Unary always convert to primative
	    case AST.UnaryExpression:
	      return PURITY_ABSOLUTE;
	
	    // The binary + operator can invoke a stateful toString().
	    case AST.BinaryExpression:
	      return node.operator !== '+' ? PURITY_ABSOLUTE : false;
	
	    // Functions / filters probably read state from within objects
	    case AST.CallExpression:
	      return false;
	  }
	
	  return (undefined === parentIsPure) ? PURITY_RELATIVE : parentIsPure;
	}
	
	function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
	  var allConstants;
	  var argsToWatch;
	  var isStatelessFilter;
	
	  var astIsPure = ast.isPure = isPure(ast, parentIsPure);
	
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.CallExpression:
	    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    allConstants = isStatelessFilter;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter, astIsPure);
	      allConstants = allConstants && property.value.constant;
	      argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      if (property.computed) {
	        //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
	        findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/false);
	        allConstants = allConstants && property.key.constant;
	        argsToWatch.push.apply(argsToWatch, property.key.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length !== 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler($filter) {
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(ast) {
	    var self = this;
	    this.state = {
	      nextId: 0,
	      filters: {},
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push({name: fnKey, isPure: watch.isPure});
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    // eslint-disable-next-line no-new-func
	    var fn = (new Function('$filter',
	        'getStringValue',
	        'ifDefined',
	        'plus',
	        fnString))(
	          this.$filter,
	          getStringValue,
	          ifDefined,
	          plusFn);
	    this.state = this.stage = undefined;
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var inputs = this.state.inputs;
	    var self = this;
	    forEach(inputs, function(input) {
	      result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
	      if (input.isPure) {
	        result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
	      }
	    });
	    if (inputs.length) {
	      result.push('fn.inputs=[' + inputs.map(function(i) { return i.name; }).join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.isNull(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.computedMember(left, right);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            if (create && create !== 1) {
	              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	                args.push(argument);
	              });
	            });
	            if (left.name) {
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn(intoId || 's');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn(intoId || 'l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn(intoId || 'v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  isNull: function(expression) {
	    return expression + '==null';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter($filter) {
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(ast) {
	    var self = this;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        input.isPure = watch.isPure;
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      return self.identifier(ast.name, context, create);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create) :
	        this.nonComputedMember(left, right, context, create);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(args[i](scope, locals, assign, inputs));
	            }
	            value = rhs.value.apply(rhs.context, values);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = -0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && base[name] == null) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        if (create && create !== 1) {
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        if (lhs && lhs[right] == null) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	function Parser(lexer, $filter, options) {
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
	                                   new ASTCompiler($filter);
	}
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    var ast = this.getAst(text);
	    var fn = this.astCompiler.compile(ast.ast);
	    fn.literal = isLiteral(ast.ast);
	    fn.constant = isConstant(ast.ast);
	    fn.oneTime = ast.oneTime;
	    return fn;
	  },
	
	  getAst: function(exp) {
	    var oneTime = false;
	    exp = exp.trim();
	
	    if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	      oneTime = true;
	      exp = exp.substring(2);
	    }
	    return {
	      ast: this.ast.ast(exp),
	      oneTime: oneTime
	    };
	  }
	};
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts AngularJS {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'AngularJS'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('AngularJS');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 * @this
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cache = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  *
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in AngularJS expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensively, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    $parse.$$getAst = $$getAst;
	    return $parse;
	
	    function $parse(exp, interceptorFn) {
	      var parsedExpression, cacheKey;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            var lexer = new Lexer($parseOptions);
	            var parser = new Parser(lexer, $filter, $parseOptions);
	            parsedExpression = parser.parse(exp);
	
	            cache[cacheKey] = addWatchDelegate(parsedExpression);
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function $$getAst(exp) {
	      var lexer = new Lexer($parseOptions);
	      var parser = new Parser(lexer, $filter, $parseOptions);
	      return parser.getAst(exp).ast;
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object' && !compareObjectIdentity) {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      // eslint-disable-next-line no-self-compare
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var isDone = parsedExpression.literal ? isAllDefined : isDefined;
	      var unwatch, lastValue;
	
	      var exp = parsedExpression.$$intercepted || parsedExpression;
	      var post = parsedExpression.$$interceptor || identity;
	
	      var useInputs = parsedExpression.inputs && !exp.inputs;
	
	      // Propogate the literal/inputs/constant attributes
	      // ... but not oneTime since we are handling it
	      oneTimeWatch.literal = parsedExpression.literal;
	      oneTimeWatch.constant = parsedExpression.constant;
	      oneTimeWatch.inputs = parsedExpression.inputs;
	
	      // Allow other delegates to run on this wrapped expression
	      addWatchDelegate(oneTimeWatch);
	
	      unwatch = scope.$watch(oneTimeWatch, listener, objectEquality, prettyPrintExpression);
	
	      return unwatch;
	
	      function unwatchIfDone() {
	        if (isDone(lastValue)) {
	          unwatch();
	        }
	      }
	
	      function oneTimeWatch(scope, locals, assign, inputs) {
	        lastValue = useInputs && inputs ? inputs[0] : exp(scope, locals, assign, inputs);
	        if (isDone(lastValue)) {
	          scope.$$postDigest(unwatchIfDone);
	        }
	        return post(lastValue);
	      }
	    }
	
	    function isAllDefined(value) {
	      var allDefined = true;
	      forEach(value, function(val) {
	        if (!isDefined(val)) allDefined = false;
	      });
	      return allDefined;
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    function addWatchDelegate(parsedExpression) {
	      if (parsedExpression.constant) {
	        parsedExpression.$$watchDelegate = constantWatchDelegate;
	      } else if (parsedExpression.oneTime) {
	        parsedExpression.$$watchDelegate = oneTimeWatchDelegate;
	      } else if (parsedExpression.inputs) {
	        parsedExpression.$$watchDelegate = inputsWatchDelegate;
	      }
	
	      return parsedExpression;
	    }
	
	    function chainInterceptors(first, second) {
	      function chainedInterceptor(value) {
	        return second(first(value));
	      }
	      chainedInterceptor.$stateful = first.$stateful || second.$stateful;
	      chainedInterceptor.$$pure = first.$$pure && second.$$pure;
	
	      return chainedInterceptor;
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	
	      // Extract any existing interceptors out of the parsedExpression
	      // to ensure the original parsedExpression is always the $$intercepted
	      if (parsedExpression.$$interceptor) {
	        interceptorFn = chainInterceptors(parsedExpression.$$interceptor, interceptorFn);
	        parsedExpression = parsedExpression.$$intercepted;
	      }
	
	      var useInputs = false;
	
	      var fn = function interceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value);
	      };
	
	      // Maintain references to the interceptor/intercepted
	      fn.$$intercepted = parsedExpression;
	      fn.$$interceptor = interceptorFn;
	
	      // Propogate the literal/oneTime/constant attributes
	      fn.literal = parsedExpression.literal;
	      fn.oneTime = parsedExpression.oneTime;
	      fn.constant = parsedExpression.constant;
	
	      // Treat the interceptor like filters.
	      // If it is not $stateful then only watch its inputs.
	      // If the expression itself has no inputs then use the full expression as an input.
	      if (!interceptorFn.$stateful) {
	        useInputs = !parsedExpression.inputs;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	
	        if (!interceptorFn.$$pure) {
	          fn.inputs = fn.inputs.map(function(e) {
	              // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
	              // non-pure interceptor function.
	              if (e.isPure === PURITY_RELATIVE) {
	                return function depurifier(s) { return e(s); };
	              }
	              return e;
	            });
	        }
	      }
	
	      return addWatchDelegate(fn);
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
	 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * ## $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * ## The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * ## The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * ## Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * ## Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * ## Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	/**
	 * @ngdoc provider
	 * @name $qProvider
	 * @this
	 *
	 * @description
	 */
	function $QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  /**
	   * @ngdoc method
	   * @name $qProvider#errorOnUnhandledRejections
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
	   * This feature is enabled by default.
	   *
	   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
	   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
	   *    chaining otherwise.
	   */
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/** @this */
	function $$QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
	 *     promises rejections.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
	  var $qMinErr = minErr('$q', TypeError);
	  var queueSize = 0;
	  var checkQueue = [];
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  function defer() {
	    return new Deferred();
	  }
	
	  function Deferred() {
	    var promise = this.promise = new Promise();
	    //Non prototype methods necessary to support unbound execution :/
	    this.resolve = function(val) { resolvePromise(promise, val); };
	    this.reject = function(reason) { rejectPromise(promise, reason); };
	    this.notify = function(progress) { notifyPromise(promise, progress); };
	  }
	
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Promise();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result;
	    },
	
	    'catch': function(callback) {
	      return this.then(null, callback);
	    },
	
	    'finally': function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, resolve, callback);
	      }, function(error) {
	        return handleCallback(error, reject, callback);
	      }, progressBack);
	    }
	  });
	
	  function processQueue(state) {
	    var fn, promise, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    try {
	      for (var i = 0, ii = pending.length; i < ii; ++i) {
	        markQStateExceptionHandled(state);
	        promise = pending[i][0];
	        fn = pending[i][state.status];
	        try {
	          if (isFunction(fn)) {
	            resolvePromise(promise, fn(state.value));
	          } else if (state.status === 1) {
	            resolvePromise(promise, state.value);
	          } else {
	            rejectPromise(promise, state.value);
	          }
	        } catch (e) {
	          rejectPromise(promise, e);
	          // This error is explicitly marked for being passed to the $exceptionHandler
	          if (e && e.$$passToExceptionHandler === true) {
	            exceptionHandler(e);
	          }
	        }
	      }
	    } finally {
	      --queueSize;
	      if (errorOnUnhandledRejections && queueSize === 0) {
	        nextTick(processChecks);
	      }
	    }
	  }
	
	  function processChecks() {
	    // eslint-disable-next-line no-unmodified-loop-condition
	    while (!queueSize && checkQueue.length) {
	      var toCheck = checkQueue.shift();
	      if (!isStateExceptionHandled(toCheck)) {
	        markQStateExceptionHandled(toCheck);
	        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
	        if (isError(toCheck.value)) {
	          exceptionHandler(toCheck.value, errorMessage);
	        } else {
	          exceptionHandler(errorMessage);
	        }
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
	      if (queueSize === 0 && checkQueue.length === 0) {
	        nextTick(processChecks);
	      }
	      checkQueue.push(state);
	    }
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    ++queueSize;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function resolvePromise(promise, val) {
	    if (promise.$$state.status) return;
	    if (val === promise) {
	      $$reject(promise, $qMinErr(
	        'qcycle',
	        'Expected promise to be resolved with value other than itself \'{0}\'',
	        val));
	    } else {
	      $$resolve(promise, val);
	    }
	
	  }
	
	  function $$resolve(promise, val) {
	    var then;
	    var done = false;
	    try {
	      if (isObject(val) || isFunction(val)) then = val.then;
	      if (isFunction(then)) {
	        promise.$$state.status = -1;
	        then.call(val, doResolve, doReject, doNotify);
	      } else {
	        promise.$$state.value = val;
	        promise.$$state.status = 1;
	        scheduleProcessQueue(promise.$$state);
	      }
	    } catch (e) {
	      doReject(e);
	    }
	
	    function doResolve(val) {
	      if (done) return;
	      done = true;
	      $$resolve(promise, val);
	    }
	    function doReject(val) {
	      if (done) return;
	      done = true;
	      $$reject(promise, val);
	    }
	    function doNotify(progress) {
	      notifyPromise(promise, progress);
	    }
	  }
	
	  function rejectPromise(promise, reason) {
	    if (promise.$$state.status) return;
	    $$reject(promise, reason);
	  }
	
	  function $$reject(promise, reason) {
	    promise.$$state.value = reason;
	    promise.$$state.status = 2;
	    scheduleProcessQueue(promise.$$state);
	  }
	
	  function notifyPromise(promise, progress) {
	    var callbacks = promise.$$state.pending;
	
	    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
	      nextTick(function() {
	        var callback, result;
	        for (var i = 0, ii = callbacks.length; i < ii; i++) {
	          result = callbacks[i][0];
	          callback = callbacks[i][3];
	          try {
	            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
	          } catch (e) {
	            exceptionHandler(e);
	          }
	        }
	      });
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  function reject(reason) {
	    var result = new Promise();
	    rejectPromise(result, reason);
	    return result;
	  }
	
	  function handleCallback(value, resolver, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return reject(e);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return resolver(value);
	      }, reject);
	    } else {
	      return resolver(value);
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  function when(value, callback, errback, progressBack) {
	    var result = new Promise();
	    resolvePromise(result, value);
	    return result.then(callback, errback, progressBack);
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var result = new Promise(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        results[key] = value;
	        if (!(--counter)) resolvePromise(result, results);
	      }, function(reason) {
	        rejectPromise(result, reason);
	      });
	    });
	
	    if (counter === 0) {
	      resolvePromise(result, results);
	    }
	
	    return result;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  function $Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
	    }
	
	    var promise = new Promise();
	
	    function resolveFn(value) {
	      resolvePromise(promise, value);
	    }
	
	    function rejectFn(reason) {
	      rejectPromise(promise, reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return promise;
	  }
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	function isStateExceptionHandled(state) {
	  return !!state.pur;
	}
	function markQStateExceptionHandled(state) {
	  state.pur = true;
	}
	function markQExceptionHandled(q) {
	  // Built-in `$q` promises will always have a `$$state` property. This check is to allow
	  // overwriting `$q` with a different promise library (e.g. Bluebird + angular-bluebird-promises).
	  // (Currently, this is the only method that might be called with a promise, even if it is not
	  // created by the built-in `$q`.)
	  if (q.$$state) {
	    markQStateExceptionHandled(q.$$state);
	  }
	}
	
	/** @this */
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @this
	 *
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	      this.$$suspended = false;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      // Support: IE 9 only
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        if ($scope.$$childHead) {
	          cleanUpScope($scope.$$childHead);
	        }
	        if ($scope.$$nextSibling) {
	          cleanUpScope($scope.$$nextSibling);
	        }
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * ## Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$suspended = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - This should not be used to watch for changes in objects that are (or contain)
	       *   [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * @example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	        var fn = isFunction(listener) ? listener : noop;
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: fn,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!array) {
	          array = scope.$$watchers = [];
	          array.$$digestWatchIndex = -1;
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        array.$$digestWatchIndex++;
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          var index = arrayRemove(array, watcher);
	          if (index >= 0) {
	            incrementWatchersCount(scope, -1);
	            if (index < array.$$digestWatchIndex) {
	              array.$$digestWatchIndex--;
	            }
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
	       *   values are examined for changes on every call to `$digest`.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value) {
	            newValues[i] = value;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          try {
	            if (firstRun) {
	              firstRun = false;
	              listener(newValues, newValues, self);
	            } else {
	              listener(newValues, oldValues, self);
	            }
	          } finally {
	            for (var i = 0; i < watchExpressions.length; i++) {
	              oldValues[i] = newValues[i];
	            }
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * @example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        // Mark the interceptor as
	        // ... $$pure when literal since the instance will change when any input changes
	        $watchCollectionInterceptor.$$pure = $parse(obj).literal;
	        // ... $stateful when non-literal since we must read the state of the collection
	        $watchCollectionInterceptor.$stateful = !$watchCollectionInterceptor.$$pure;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              // eslint-disable-next-line no-self-compare
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  // eslint-disable-next-line no-self-compare
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * @example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            dirty, ttl = TTL,
	            next, current, target = asyncQueue.length ? $rootScope : this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              fn = asyncTask.fn;
	              fn(asyncTask.scope, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = !current.$$suspended && current.$$watchers)) {
	              // process our watches
	              watchers.$$digestWatchIndex = watchers.length;
	              while (watchers.$$digestWatchIndex--) {
	                try {
	                  watch = watchers[watchers.$$digestWatchIndex];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (isNumberNaN(value) && isNumberNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            // (though it differs due to having the extra check for $$suspended and does not
	            // check $$listenerCount)
	            if (!(next = ((!current.$$suspended && current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	
	        // Check for changes to browser url that happened during the $digest
	        // (for which no event is fired; e.g. via `history.pushState()`)
	        $browser.$$checkUrlChange();
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$suspend
	       * @kind function
	       *
	       * @description
	       * Suspend watchers of this scope subtree so that they will not be invoked during digest.
	       *
	       * This can be used to optimize your application when you know that running those watchers
	       * is redundant.
	       *
	       * **Warning**
	       *
	       * Suspending scopes from the digest cycle can have unwanted and difficult to debug results.
	       * Only use this approach if you are confident that you know what you are doing and have
	       * ample tests to ensure that bindings get updated as you expect.
	       *
	       * Some of the things to consider are:
	       *
	       * * Any external event on a directive/component will not trigger a digest while the hosting
	       *   scope is suspended - even if the event handler calls `$apply()` or `$rootScope.$digest()`.
	       * * Transcluded content exists on a scope that inherits from outside a directive but exists
	       *   as a child of the directive's containing scope. If the containing scope is suspended the
	       *   transcluded scope will also be suspended, even if the scope from which the transcluded
	       *   scope inherits is not suspended.
	       * * Multiple directives trying to manage the suspended status of a scope can confuse each other:
	       *    * A call to `$suspend()` on an already suspended scope is a no-op.
	       *    * A call to `$resume()` on a non-suspended scope is a no-op.
	       *    * If two directives suspend a scope, then one of them resumes the scope, the scope will no
	       *      longer be suspended. This could result in the other directive believing a scope to be
	       *      suspended when it is not.
	       * * If a parent scope is suspended then all its descendants will be also excluded from future
	       *   digests whether or not they have been suspended themselves. Note that this also applies to
	       *   isolate child scopes.
	       * * Calling `$digest()` directly on a descendant of a suspended scope will still run the watchers
	       *   for that scope and its descendants. When digesting we only check whether the current scope is
	       *   locally suspended, rather than checking whether it has a suspended ancestor.
	       * * Calling `$resume()` on a scope that has a suspended ancestor will not cause the scope to be
	       *   included in future digests until all its ancestors have been resumed.
	       * * Resolved promises, e.g. from explicit `$q` deferreds and `$http` calls, trigger `$apply()`
	       *   against the `$rootScope` and so will still trigger a global digest even if the promise was
	       *   initiated by a component that lives on a suspended scope.
	       */
	      $suspend: function() {
	        this.$$suspended = true;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$isSuspended
	       * @kind function
	       *
	       * @description
	       * Call this method to determine if this scope has been explicitly suspended. It will not
	       * tell you whether an ancestor has been suspended.
	       * To determine if this scope will be excluded from a digest triggered at the $rootScope,
	       * for example, you must check all its ancestors:
	       *
	       * ```
	       * function isExcludedFromDigest(scope) {
	       *   while(scope) {
	       *     if (scope.$isSuspended()) return true;
	       *     scope = scope.$parent;
	       *   }
	       *   return false;
	       * ```
	       *
	       * Be aware that a scope may not be included in digests if it has a suspended ancestor,
	       * even if `$isSuspended()` returns false.
	       *
	       * @returns true if the current scope has been suspended.
	       */
	      $isSuspended: function() {
	        return this.$$suspended;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$resume
	       * @kind function
	       *
	       * @description
	       * Resume watchers of this scope subtree in case it was suspended.
	       *
	       * See {@link $rootScope.Scope#$suspend} for information about the dangers of using this approach.
	       */
	      $resume: function() {
	        this.$$suspended = false;
	      },
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating AngularJS
	       * expressions.
	       *
	       * @example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          }, null, '$evalAsync');
	        }
	
	        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the AngularJS framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * **Life cycle: Pseudo-Code of `$apply()`**
	       *
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            // eslint-disable-next-line no-unsafe-finally
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        if (expr) {
	          applyAsyncQueue.push($applyAsyncExpression);
	        }
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            // Use delete in the hope of the browser deallocating the memory for the array entry,
	            // while not shifting the array indexes of other listeners.
	            // See issue https://github.com/angular/angular.js/issues/16135
	            delete namedListeners[indexOfListener];
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            break;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount and
	          // does not check $$suspended)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        }, null, '$applyAsync');
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of AngularJS application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @this
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	
	  var aHrefSanitizationWhitelist = /^\s*(https?|s?ftp|mailto|tel|file):/,
	    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via HTML anchor links.
	   *
	   * Any url due to be assigned to an `a[href]` attribute via interpolation is marked as requiring
	   * the $sce.URL security context. When interpolation occurs a call is made to `$sce.trustAsUrl(url)`
	   * which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize the potentially malicious URL.
	   *
	   * If the URL matches the `aHrefSanitizationWhitelist` regular expression, it is returned unchanged.
	   *
	   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
	   * to the DOM it is inactive and potentially malicious code will not be executed.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationWhitelist = regexp;
	      return this;
	    }
	    return aHrefSanitizationWhitelist;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via HTML image src links.
	   *
	   * Any URL due to be assigned to an `img[src]` attribute via interpolation is marked as requiring
	   * the $sce.MEDIA_URL security context. When interpolation occurs a call is made to
	   * `$sce.trustAsMediaUrl(url)` which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize
	   * the potentially malicious URL.
	   *
	   * If the URL matches the `aImgSanitizationWhitelist` regular expression, it is returned unchanged.
	   *
	   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
	   * to the DOM it is inactive and potentially malicious code will not be executed.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationWhitelist = regexp;
	      return this;
	    }
	    return imgSrcSanitizationWhitelist;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isMediaUrl) {
	      // if (!uri) return uri;
	      var regex = isMediaUrl ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	      var normalizedVal = urlResolve(uri && uri.trim()).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* exported $SceProvider, $SceDelegateProvider */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
	  HTML: 'html',
	
	  // Style statements or stylesheets. Currently unused in AngularJS.
	  CSS: 'css',
	
	  // An URL used in a context where it refers to the source of media, which are not expected to be run
	  // as scripts, such as an image, audio, video, etc.
	  MEDIA_URL: 'mediaUrl',
	
	  // An URL used in a context where it does not refer to a resource that loads code.
	  // A value that can be trusted as a URL can also trusted as a MEDIA_URL.
	  URL: 'url',
	
	  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
	  // code. (e.g. ng-include, script src binding, templateUrl)
	  // A value that can be trusted as a RESOURCE_URL, can also trusted as a URL and a MEDIA_URL.
	  RESOURCE_URL: 'resourceUrl',
	
	  // Script. Currently unused in AngularJS.
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
	
	function snakeToCamel(name) {
	  return name
	    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace(/\\\*\\\*/g, '.*').
	                  replace(/\\\*/g, '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * For an overview of this service and the functionnality it provides in AngularJS, see the main
	 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
	 * SCE works in their application, which shouldn't be needed in most cases.
	 *
	 * <div class="alert alert-danger">
	 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
	 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
	 * changes to this service will also influence users, so be extra careful and document your changes.
	 * </div>
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @this
	 *
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 *
	 * The `$sceDelegateProvider` allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing AngularJS templates and other script-running URLs are safe (all
	 * places that use the `$sce.RESOURCE_URL` context). See
	 * {@link ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist}
	 * and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist},
	 *
	 * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 * Note that an empty whitelist will block every resource URL from being loaded, and will require
	 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
	 * requested by {@link ng.$templateRequest $templateRequest} that are present in
	 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
	 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
	 * from that whitelist. This helps to mitigate the security impact of certain types of issues, like
	 * for instance attacker-controlled `ng-includes`.
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   * @return {Array} The currently set whitelist array.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** the default whitelist of 'self' is not recommended if your app shares its origin
	   * with other apps! It is a good idea to limit it to only your application's directory.
	   * </div>
	   */
	  this.resourceUrlWhitelist = function(value) {
	    if (arguments.length) {
	      resourceUrlWhitelist = adjustMatchers(value);
	    }
	    return resourceUrlWhitelist;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.</p><p>
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.</p><p>
	   *     The typical usage for the blacklist is to **block
	   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *     these would otherwise be trusted but actually return content from the redirected domain.
	   *     </p><p>
	   *     Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} The currently set blacklist array.
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   */
	
	  this.resourceUrlBlacklist = function(value) {
	    if (arguments.length) {
	      resourceUrlBlacklist = adjustMatchers(value);
	    }
	    return resourceUrlBlacklist;
	  };
	
	  this.$get = ['$injector', '$$sanitizeUri', function($injector, $$sanitizeUri) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl) || urlIsSameOriginAsBaseUrl(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the whitelist allows this url.
	      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the blacklist blocked this url.
	        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.MEDIA_URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(byType[SCE_CONTEXTS.MEDIA_URL]);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns a trusted representation of the parameter for the specified context. This trusted
	     * object will later on be used as-is, without any security check, by bindings or directives
	     * that require this security context.
	     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
	     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
	     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
	     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
	     * security risk.
	     *
	     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
	     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
	     * escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that should be considered trusted.
	     * @return {*} A trusted representation of value, that can be used in the given context.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *     call or anything else.
	     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Given an object and a security context in which to assign it, returns a value that's safe to
	     * use in this context, which was represented by the parameter. To do so, this function either
	     * unwraps the safe type it has been given (for instance, a {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`} result), or it might try to sanitize the value given, depending on
	     * the context and sanitizer availablility.
	     *
	     * The contexts that can be sanitized are $sce.MEDIA_URL, $sce.URL and $sce.HTML. The first two are available
	     * by default, and the third one relies on the `$sanitize` service (which may be loaded through
	     * the `ngSanitize` module). Furthermore, for $sce.RESOURCE_URL context, a plain string may be
	     * accepted if the resource url policy defined by {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	     * `$sceDelegateProvider.resourceUrlWhitelist`} and {@link ng.$sceDelegateProvider#resourceUrlBlacklist
	     * `$sceDelegateProvider.resourceUrlBlacklist`} accepts that resource.
	     *
	     * This function will throw if the safe type isn't appropriate for this context, or if the
	     * value given cannot be accepted in the context (which might be caused by sanitization not
	     * being available, or the value not being recognized as safe).
	     *
	     * <div class="alert alert-danger">
	     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
	     * (XSS) vulnerability in your application.
	     * </div>
	     *
	     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
	      // as-is.
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	
	      // If maybeTrusted is a trusted class instance but not of the correct trusted type
	      // then unwrap it and allow it to pass through to the rest of the checks
	      if (isFunction(maybeTrusted.$$unwrapTrustedValue)) {
	        maybeTrusted = maybeTrusted.$$unwrapTrustedValue();
	      }
	
	      // If we get here, then we will either sanitize the value or throw an exception.
	      if (type === SCE_CONTEXTS.MEDIA_URL || type === SCE_CONTEXTS.URL) {
	        // we attempt to sanitize non-resource URLs
	        return $$sanitizeUri(maybeTrusted.toString(), type === SCE_CONTEXTS.MEDIA_URL);
	      } else if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        // htmlSanitizer throws its own error when no sanitizer is available.
	        return htmlSanitizer(maybeTrusted);
	      }
	      // Default error when the $sce service has no way to make the input safe.
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @this
	 *
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * ## Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
	 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
	 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * ### Overview
	 *
	 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
	 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
	 * run security checks on them (sanitizations, whitelists, depending on context), or throw when it
	 * cannot guarantee the security of the result. That behavior depends strongly on contexts: HTML
	 * can be sanitized, but template URLs cannot, for instance.
	 *
	 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
	 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
	 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
	 * render the input as-is, you will need to mark it as trusted for that context before attempting
	 * to bind it.
	 *
	 * As of version 1.2, AngularJS ships with SCE enabled by default.
	 *
	 * ### In practice
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
	 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
	 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
	 * controlled input creates security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
	 * any similar validation process, unless there's a good reason to trust the given value in this
	 * context.  That trust is formalized with a function call. This means that as a developer, you
	 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
	 * you just need to ensure the values you mark as trusted indeed are safe - because they were
	 * received from your server, sanitized by your library, etc. You can organize your codebase to
	 * help with this - perhaps allowing only the files in a specific directory to do this.
	 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
	 * becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * build the trusted versions of your values.
	 *
	 * ### How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
	 * a way to enforce the required security context in your data sink. Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
	 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
	 * when binding without directives, AngularJS will understand the context of your bindings
	 * automatically.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ### Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, AngularJS only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ### This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works (remember to include the
	 * `ngSanitize` module). The `$sceDelegate` will also use the `$sanitize` service if it is available
	 * when binding untrusted values to `$sce.HTML` context.
	 * AngularJS provides an implementation in `angular-sanitize.js`, and if you
	 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
	 * your application.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ### What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
	 * | `$sce.MEDIA_URL`    | For URLs that are safe to render as media. Is automatically converted from string by sanitizing when needed. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links. Is automatically converted from string by sanitizing when needed. Note that `$sce.URL` makes a stronger statement about the URL than `$sce.MEDIA_URL` does and therefore contexts requiring values trusted for `$sce.URL` can be used anywhere that values trusted for `$sce.MEDIA_URL` are required.|
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` or `$sce.MEDIA_URL` do and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` or `$sce.MEDIA_URL` are required. <br><br> The {@link $sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider#resourceUrlWhitelist()} and {@link $sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider#resourceUrlBlacklist()} can be used to restrict trusted origins for `RESOURCE_URL` |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
	 *
	 *
	 * <div class="alert alert-warning">
	 * Be aware that, before AngularJS 1.7.0, `a[href]` and `img[src]` used to sanitize their
	 * interpolated values directly rather than rely upon {@link ng.$sce#getTrusted `$sce.getTrusted`}.
	 *
	 * **As of 1.7.0, this is no longer the case.**
	 *
	 * Now such interpolations are marked as requiring `$sce.URL` (for `a[href]`) or `$sce.MEDIA_URL`
	 * (for `img[src]`), so that the sanitization happens (via `$sce.getTrusted...`) when the `$interpolate`
	 * service evaluates the expressions.
	 * </div>
	 *
	 * There are no CSS or JS context bindings in AngularJS currently, so their corresponding `$sce.trustAs`
	 * functions aren't useful yet. This might evolve.
	 *
	 * ### Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ### Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function AppController($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
	 *           self.userComments = response.data;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
	 * you are writing a library, you will cause security bugs applications using it.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects or libraries.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
	   * @return {boolean} True if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way. In some future, we may not use
	   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
	   * be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Support: IE 9-11 only
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
	     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
	     * wrapped object that represents your value, and the trust you have in its safety for the given
	     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
	     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
	     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that that should be considered trusted.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in the context you specified.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.HTML` context (like `ng-bind-html`).
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsCss(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant
	     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
	     *     almost no reasons to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
	     *     to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
	     *     bindings, ...)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.JS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
	     *     use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes any input, and either returns a value that's safe to use in the specified context,
	     * or throws an exception. This function is aware of trusted values created by the `trustAs`
	     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
	     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
	     * safe value (e.g., no sanitization is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
	     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/* exported $SnifferProvider */
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 * @this
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`.
	        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
	        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
	        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
	        // (see https://developer.chrome.com/apps/manifest/sandbox).
	        // (NW.js apps have access to Chrome APIs, but do support `history`.)
	        isNw = $window.nw && $window.nw.process,
	        isChromePackagedApp =
	            !isNw &&
	            $window.chrome &&
	            ($window.chrome.app && $window.chrome.app.runtime ||
	                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false;
	
	    if (bodyStyle) {
	      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
	      // Mentioned browsers need a -webkit- prefix for transitions & animations.
	      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
	      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      hasEvent: function(event) {
	        // Support: IE 9-11 only
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $$taskTrackerFactory
	 * @description
	 * A function to create `TaskTracker` instances.
	 *
	 * A `TaskTracker` can keep track of pending tasks (grouped by type) and can notify interested
	 * parties when all pending tasks (or tasks of a specific type) have been completed.
	 *
	 * @param {$log} log - A logger instance (such as `$log`). Used to log error during callback
	 *     execution.
	 *
	 * @this
	 */
	function $$TaskTrackerFactoryProvider() {
	  this.$get = valueFn(function(log) { return new TaskTracker(log); });
	}
	
	function TaskTracker(log) {
	  var self = this;
	  var taskCounts = {};
	  var taskCallbacks = [];
	
	  var ALL_TASKS_TYPE = self.ALL_TASKS_TYPE = '$$all$$';
	  var DEFAULT_TASK_TYPE = self.DEFAULT_TASK_TYPE = '$$default$$';
	
	  /**
	   * Execute the specified function and decrement the appropriate `taskCounts` counter.
	   * If the counter reaches 0, all corresponding `taskCallbacks` are executed.
	   *
	   * @param {Function} fn - The function to execute.
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task that is being completed.
	   */
	  self.completeTask = completeTask;
	
	  /**
	   * Increase the task count for the specified task type (or the default task type if non is
	   * specified).
	   *
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task whose count will be increased.
	   */
	  self.incTaskCount = incTaskCount;
	
	  /**
	   * Execute the specified callback when all pending tasks have been completed.
	   *
	   * If there are no pending tasks, the callback is executed immediately. You can optionally limit
	   * the tasks that will be waited for to a specific type, by passing a `taskType`.
	   *
	   * @param {function} callback - The function to call when there are no pending tasks.
	   * @param {string=} [taskType=ALL_TASKS_TYPE] - The type of tasks that will be waited for.
	   */
	  self.notifyWhenNoPendingTasks = notifyWhenNoPendingTasks;
	
	  function completeTask(fn, taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	
	    try {
	      fn();
	    } finally {
	      decTaskCount(taskType);
	
	      var countForType = taskCounts[taskType];
	      var countForAll = taskCounts[ALL_TASKS_TYPE];
	
	      // If at least one of the queues (`ALL_TASKS_TYPE` or `taskType`) is empty, run callbacks.
	      if (!countForAll || !countForType) {
	        var getNextCallback = !countForAll ? getLastCallback : getLastCallbackForType;
	        var nextCb;
	
	        while ((nextCb = getNextCallback(taskType))) {
	          try {
	            nextCb();
	          } catch (e) {
	            log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function decTaskCount(taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	    if (taskCounts[taskType]) {
	      taskCounts[taskType]--;
	      taskCounts[ALL_TASKS_TYPE]--;
	    }
	  }
	
	  function getLastCallback() {
	    var cbInfo = taskCallbacks.pop();
	    return cbInfo && cbInfo.cb;
	  }
	
	  function getLastCallbackForType(taskType) {
	    for (var i = taskCallbacks.length - 1; i >= 0; --i) {
	      var cbInfo = taskCallbacks[i];
	      if (cbInfo.type === taskType) {
	        taskCallbacks.splice(i, 1);
	        return cbInfo.cb;
	      }
	    }
	  }
	
	  function incTaskCount(taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	    taskCounts[taskType] = (taskCounts[taskType] || 0) + 1;
	    taskCounts[ALL_TASKS_TYPE] = (taskCounts[ALL_TASKS_TYPE] || 0) + 1;
	  }
	
	  function notifyWhenNoPendingTasks(callback, taskType) {
	    taskType = taskType || ALL_TASKS_TYPE;
	    if (!taskCounts[taskType]) {
	      callback();
	    } else {
	      taskCallbacks.push({type: taskType, cb: callback});
	    }
	  }
	}
	
	var $templateRequestMinErr = minErr('$templateRequest');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @this
	 *
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
	   * as {@link ngInclude} to download and cache templates.
	   *
	   * 3rd party modules should use `$templateRequest` if their services or directives are loading
	   * templates.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
	    function($exceptionHandler, $templateCache, $http, $q, $sce) {
	
	      function handleRequestFn(tpl, ignoreRequestError) {
	        handleRequestFn.totalPendingRequests++;
	
	        // We consider the template cache holds only trusted templates, so
	        // there's no need to go through whitelisting again for keys that already
	        // are included in there. This also makes AngularJS accept any script
	        // directive, no matter its name. However, we still need to unwrap trusted
	        // types.
	        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	          tpl = $sce.getTrustedResourceUrl(tpl);
	        }
	
	        var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	        if (isArray(transformResponse)) {
	          transformResponse = transformResponse.filter(function(transformer) {
	            return transformer !== defaultHttpResponseTransform;
	          });
	        } else if (transformResponse === defaultHttpResponseTransform) {
	          transformResponse = null;
	        }
	
	        return $http.get(tpl, extend({
	            cache: $templateCache,
	            transformResponse: transformResponse
	          }, httpOptions))
	          .finally(function() {
	            handleRequestFn.totalPendingRequests--;
	          })
	          .then(function(response) {
	            return $templateCache.put(tpl, response.data);
	          }, handleError);
	
	        function handleError(resp) {
	          if (!ignoreRequestError) {
	            resp = $templateRequestMinErr('tpload',
	                'Failed to load template: {0} (HTTP status: {1} {2})',
	                tpl, resp.status, resp.statusText);
	
	            $exceptionHandler(resp);
	          }
	
	          return $q.reject(resp);
	        }
	      }
	
	      handleRequestFn.totalPendingRequests = 0;
	
	      return handleRequestFn;
	    }
	  ];
	}
	
	/** @this */
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) !== -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when all pending tasks are completed.
	     *
	     * Types of tasks waited for include:
	     * - Pending timeouts (via {@link $timeout}).
	     * - Pending HTTP requests (via {@link $http}).
	     * - In-progress route transitions (via {@link $route}).
	     * - Pending tasks scheduled via {@link $rootScope#$applyAsync}.
	     * - Pending tasks scheduled via {@link $rootScope#$evalAsync}.
	     *   These include tasks scheduled via `$evalAsync()` indirectly (such as {@link $q} promises).
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	var $timeoutMinErr = minErr('$timeout');
	
	/** @this */
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	    /**
	     * @ngdoc service
	     * @name $timeout
	     *
	     * @description
	     * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	     * block and delegates any exceptions to
	     * {@link ng.$exceptionHandler $exceptionHandler} service.
	     *
	     * The return value of calling `$timeout` is a promise, which will be resolved when
	     * the delay has passed and the timeout function, if provided, is executed.
	     *
	     * To cancel a timeout request, call `$timeout.cancel(promise)`.
	     *
	     * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	     * synchronously flush the queue of deferred functions.
	     *
	     * If you only want a promise that will be resolved after some specified delay
	     * then you can call `$timeout` without the `fn` function.
	     *
	     * @param {function()=} fn A function, whose execution should be delayed.
	     * @param {number=} [delay=0] Delay in milliseconds.
	     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	     * @param {...*=} Pass additional parameters to the executed function.
	     * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	     *   will be resolved with the return value of the `fn` function.
	     *
	     */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        } finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay, '$timeout');
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $timeout#cancel
	     *
	     * @description
	     * Cancels a task associated with the `promise`. As a result of this, the promise will be
	     * resolved with a rejection.
	     *
	     * @param {Promise=} promise Promise returned by the `$timeout` function.
	     * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	     *   canceled.
	     */
	    timeout.cancel = function(promise) {
	      if (!promise) return false;
	
	      if (!promise.hasOwnProperty('$$timeoutId')) {
	        throw $timeoutMinErr('badprom',
	            '`$timeout.cancel()` called with a promise that was not generated by `$timeout()`.');
	      }
	
	      if (!deferreds.hasOwnProperty(promise.$$timeoutId)) return false;
	
	      var id = promise.$$timeoutId;
	      var deferred = deferreds[id];
	
	      // Timeout cancels should not report an unhandled promise.
	      markQExceptionHandled(deferred.promise);
	      deferred.reject('canceled');
	      delete deferreds[id];
	
	      return $browser.defer.cancel(id);
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement('a');
	var originUrl = urlResolve(window.location.href);
	var baseUrlParsingNode;
	
	urlParsingNode.href = 'http://[::1]';
	
	// Support: IE 9-11 only, Edge 16-17 only (fixed in 18 Preview)
	// IE/Edge don't wrap IPv6 addresses' hostnames in square brackets
	// when parsed out of an anchor element.
	var ipv6InBrackets = urlParsingNode.hostname === '[::1]';
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+ etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string|object} url The URL to be parsed. If `url` is not a string, it will be returned
	 *     unchanged.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description                                                            |
	 *   |---------------|------------------------------------------------------------------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol without the trailing colon                                |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol                                 |
	 *   | hostname      | The hostname                                                           |
	 *   | port          | The port, without ":"                                                  |
	 *   | pathname      | The pathname, beginning with "/"                                       |
	 *
	 */
	function urlResolve(url) {
	  if (!isString(url)) return url;
	
	  var href = url;
	
	  // Support: IE 9-11 only
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute('href', href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  var hostname = urlParsingNode.hostname;
	
	  if (!ipv6InBrackets && hostname.indexOf(':') > -1) {
	    hostname = '[' + hostname + ']';
	  }
	
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application
	 * document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  return urlsAreSameOrigin(requestUrl, originUrl);
	}
	
	/**
	 * Parse a request URL and determine whether it is same-origin as the current document base URL.
	 *
	 * Note: The base URL is usually the same as the document location (`location.href`) but can
	 * be overriden by using the `<base>` tag.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the URL is same-origin as the document base URL.
	 */
	function urlIsSameOriginAsBaseUrl(requestUrl) {
	  return urlsAreSameOrigin(requestUrl, getBaseUrl());
	}
	
	/**
	 * Create a function that can check a URL's origin against a list of allowed/whitelisted origins.
	 * The current location's origin is implicitly trusted.
	 *
	 * @param {string[]} whitelistedOriginUrls - A list of URLs (strings), whose origins are trusted.
	 *
	 * @returns {Function} - A function that receives a URL (string or parsed URL object) and returns
	 *     whether it is of an allowed origin.
	 */
	function urlIsAllowedOriginFactory(whitelistedOriginUrls) {
	  var parsedAllowedOriginUrls = [originUrl].concat(whitelistedOriginUrls.map(urlResolve));
	
	  /**
	   * Check whether the specified URL (string or parsed URL object) has an origin that is allowed
	   * based on a list of whitelisted-origin URLs. The current location's origin is implicitly
	   * trusted.
	   *
	   * @param {string|Object} requestUrl - The URL to be checked (provided as a string that will be
	   *     resolved or a parsed URL object).
	   *
	   * @returns {boolean} - Whether the specified URL is of an allowed origin.
	   */
	  return function urlIsAllowedOrigin(requestUrl) {
	    var parsedUrl = urlResolve(requestUrl);
	    return parsedAllowedOriginUrls.some(urlsAreSameOrigin.bind(null, parsedUrl));
	  };
	}
	
	/**
	 * Determine if two URLs share the same origin.
	 *
	 * @param {string|Object} url1 - First URL to compare as a string or a normalized URL in the form of
	 *     a dictionary object returned by `urlResolve()`.
	 * @param {string|object} url2 - Second URL to compare as a string or a normalized URL in the form
	 *     of a dictionary object returned by `urlResolve()`.
	 *
	 * @returns {boolean} - True if both URLs have the same origin, and false otherwise.
	 */
	function urlsAreSameOrigin(url1, url2) {
	  url1 = urlResolve(url1);
	  url2 = urlResolve(url2);
	
	  return (url1.protocol === url2.protocol &&
	          url1.host === url2.host);
	}
	
	/**
	 * Returns the current document base URL.
	 * @returns {string}
	 */
	function getBaseUrl() {
	  if (window.document.baseURI) {
	    return window.document.baseURI;
	  }
	
	  // `document.baseURI` is available everywhere except IE
	  if (!baseUrlParsingNode) {
	    baseUrlParsingNode = window.document.createElement('a');
	    baseUrlParsingNode.href = '.';
	
	    // Work-around for IE bug described in Implementation Notes. The fix in `urlResolve()` is not
	    // suitable here because we need to track changes to the base URL.
	    baseUrlParsingNode = baseUrlParsingNode.cloneNode(false);
	  }
	  return baseUrlParsingNode.href;
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 * @this
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In AngularJS we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample" name="window-service">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeGetCookie(rawDocument) {
	    try {
	      return rawDocument.cookie || '';
	    } catch (e) {
	      return '';
	    }
	  }
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = safeGetCookie(rawDocument);
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	/** @this */
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how AngularJS filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the AngularJS Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * They can be used in view templates, controllers or services. AngularJS comes
	 * with a collection of [built-in filters](api/ng/filter), but it is easy to
	 * define your own as well.
	 *
	 * The general syntax in templates is as follows:
	 *
	 * ```html
	 * {{ expression [| filter_name[:parameter_value] ... ] }}
	 * ```
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	/** @this */
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * <div class="alert alert-info">
	 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
	 * </div>
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
	 *     determining if values retrieved using `expression` (when it is not a function) should be
	 *     considered a match based on the expected value (from the filter expression) and actual
	 *     value (from the object in the array).
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false`: A short hand for a function which will look for a substring match in a case
	 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
	 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 *
	 *   Defaults to `false`.
	 *
	 * @param {string} [anyPropertyKey] The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example name="filter-filter">
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        // falls through
	      case 'object':
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
	          // See: https://github.com/angular/angular.js/issues/15644
	          if (key.charAt && (key.charAt(0) !== '$') &&
	              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample" name="currency-filter">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser === 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // If the currency symbol is empty, trim whitespace around the symbol
	    var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(currencySymbolRe, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample" name="number-filter">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }
	
	  if (i === (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset === -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? '+' : '';
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
	    NUMBER_STRING = /^-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 *   Any other characters in the `format` string will be output as-is.
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example name="filter-date">
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if ((match = string.match(R_ISO8601_STR))) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example name="filter-json">
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 *
	 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
	 *
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @example
	   <example module="uppercaseFilterExample" name="filter-uppercase">
	     <file name="index.html">
	       <script>
	         angular.module('uppercaseFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.title = 'This is a title';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <!-- This title should be formatted normally -->
	         <h1>{{title}}</h1>
	         <!-- This title should be capitalized -->
	         <h1>{{title | uppercase}}</h1>
	       </div>
	     </file>
	   </example>
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample" name="limit-to-filter">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNumberNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 *    **Note:** `null` values use `'null'` as their type.
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * If a custom comparator still can't distinguish between two items, then they will be sorted based
	 * on their index using the built-in comparator.
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, sorts values of different types by type and puts
	 * `undefined` and `null` values at the end of the sorted list.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types:
	 *    - If one of the values is undefined, consider it "greater than" the other.
	 *    - Else if one of the values is null, consider it "greater than" the other.
	 *    - Else compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 * **Note:** For the purpose of sorting, `null` and `undefined` are considered "greater than"
	 *           any other value (with undefined "greater than" null). This effectively means that `null`
	 *           and `undefined` values end up at the end of a list sorted in ascending order.
	 * **Note:** `null` values use `'null'` as their type to be able to distinguish them from objects.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
	          descending = predicate.charAt(0) === '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = (type1 === 'undefined') ? 1 :
	        (type2 === 'undefined') ? -1 :
	        (type1 === 'null') ? 1 :
	        (type2 === 'null') ? -1 :
	        (type1 < type2) ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html a tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * AngularJS has a chance to replace the `{{hash}}` markup with its
	 * value. Until AngularJS replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example name="ng-href">
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element (typically a form control,
	 * e.g. `input`, `button`, `select` etc.) if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-disabled">
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-checked">
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
	        <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
	          element(by.model('leader')).click();
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-readonly">
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example name="ng-selected">
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Internet Explorer and Edge do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example name="ng-open">
	       <file name="index.html">
	         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>List</summary>
	            <ul>
	              <li>Apple</li>
	              <li>Orange</li>
	              <li>Durian</li>
	            </ul>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName === 'multiple') return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set('ngPattern', new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = ['$sce', function($sce) {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        // We need to sanitize the url at least once, in case it is a constant
	        // non-interpolated attribute.
	        attr.$set(normalized, $sce.getTrustedMediaUrl(attr[normalized]));
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // Support: IE 9-11 only
	          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // We use attr[attrName] value since $set might have sanitized the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  }];
	});
	
	/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $getControls: valueFn([]),
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop,
	  $$setSubmitted: noop
	},
	PENDING_CLASS = 'ng-pending',
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $pending An object hash, containing references to controls or forms with
	 *  pending validators, where:
	 *
	 *  - keys are validations tokens (error names).
	 *  - values are arrays of controls or forms that have a pending validator for the given error name.
	 *
	 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
	 *
	 * @property {Object} $error An object hash, containing references to controls or forms with failing
	 *  validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for the given error name.
	 *
	 *  Built-in validation tokens:
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController($element, $attrs, $scope, $animate, $interpolate) {
	  this.$$controls = [];
	
	  // init state
	  this.$error = {};
	  this.$$success = {};
	  this.$pending = undefined;
	  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
	  this.$dirty = false;
	  this.$pristine = true;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$submitted = false;
	  this.$$parentForm = nullFormCtrl;
	
	  this.$$element = $element;
	  this.$$animate = $animate;
	
	  setupValidity(this);
	}
	
	FormController.prototype = {
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  $rollbackViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$commitViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  $addControl: function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    this.$$controls.push(control);
	
	    if (control.$name) {
	      this[control.$name] = control;
	    }
	
	    control.$$parentForm = this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$getControls
	   * @returns {Array} the controls that are currently part of this form
	   *
	   * @description
	   * This method returns a **shallow copy** of the controls that are currently part of this form.
	   * The controls can be instances of {@link form.FormController `FormController`}
	   * ({@link ngForm "child-forms"}) and of {@link ngModel.NgModelController `NgModelController`}.
	   * If you need access to the controls of child-forms, you have to call `$getControls()`
	   * recursively on them.
	   * This can be used for example to iterate over all controls to validate them.
	   *
	   * The controls can be accessed normally, but adding to, or removing controls from the array has
	   * no effect on the form. Instead, use {@link form.FormController#$addControl `$addControl()`} and
	   * {@link form.FormController#$removeControl `$removeControl()`} for this use-case.
	   * Likewise, adding a control to, or removing a control from the form is not reflected
	   * in the shallow copy. That means you should get a fresh copy from `$getControls()` every time
	   * you need access to the controls.
	   */
	  $getControls: function() {
	    return shallowCopy(this.$$controls);
	  },
	
	  // Private API: rename a form control
	  $$renameControl: function(control, newName) {
	    var oldName = control.$name;
	
	    if (this[oldName] === control) {
	      delete this[oldName];
	    }
	    this[newName] = control;
	    control.$name = newName;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  $removeControl: function(control) {
	    if (control.$name && this[control.$name] === control) {
	      delete this[control.$name];
	    }
	    forEach(this.$pending, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$error, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$$success, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	
	    arrayRemove(this.$$controls, control);
	    control.$$parentForm = nullFormCtrl;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  $setDirty: function() {
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
	   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
	   * state to false.
	   *
	   * This method will also propagate to all the controls contained in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  $setPristine: function() {
	    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$submitted = false;
	    forEach(this.$$controls, function(control) {
	      control.$setPristine();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  $setUntouched: function() {
	    forEach(this.$$controls, function(control) {
	      control.$setUntouched();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its `$submitted` state. This will also set `$submitted` on all child and
	   * parent forms of the form.
	   */
	  $setSubmitted: function() {
	    var rootForm = this;
	    while (rootForm.$$parentForm && (rootForm.$$parentForm !== nullFormCtrl)) {
	      rootForm = rootForm.$$parentForm;
	    }
	    rootForm.$$setSubmitted();
	  },
	
	  $$setSubmitted: function() {
	    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
	    this.$submitted = true;
	    forEach(this.$$controls, function(control) {
	      if (control.$$setSubmitted) {
	        control.$$setSubmitted();
	      }
	    });
	  }
	};
	
	/**
	 * @ngdoc method
	 * @name form.FormController#$setValidity
	 *
	 * @description
	 * Change the validity state of the form, and notify the parent form (if any).
	 *
	 * Application developers will rarely need to call this method directly. It is used internally, by
	 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
	 * control's validity state to the parent `FormController`.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
	 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
	 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
	 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
	 *        class name. Example: `myError` will result in `ng-valid-my-error` and
	 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
	 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
	 *        `$asyncValidators` do not run because any of the `$validators` failed.
	 * @param {NgModelController | FormController} controller - The controller whose validity state is
	 *        triggering the change.
	 */
	addSetValidityMethod({
	  clazz: FormController,
	  set: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      object[property] = [controller];
	    } else {
	      var index = list.indexOf(controller);
	      if (index === -1) {
	        list.push(controller);
	      }
	    }
	  },
	  unset: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      return;
	    }
	    arrayRemove(list, controller);
	    if (list.length === 0) {
	      delete object[property];
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Helper directive that makes it possible to create control groups inside a
	 * {@link ng.directive:form `form`} directive.
	 * These "child forms" can be used, for example, to determine the validity of a sub-group of
	 * controls.
	 *
	 * <div class="alert alert-danger">
	 * **Note**: `ngForm` cannot be used as a replacement for `<form>`, because it lacks its
	 * [built-in HTML functionality](https://html.spec.whatwg.org/#the-form-element).
	 * Specifically, you cannot submit `ngForm` like a `<form>` tag. That means,
	 * you cannot send data to the server with `ngForm`, or integrate it with
	 * {@link ng.directive:ngSubmit `ngSubmit`}.
	 * </div>
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will
	 *                              be published into the related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * ## Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * ## CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * ## Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side AngularJS applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, AngularJS prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * @animations
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              formElement[0].addEventListener('submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  formElement[0].removeEventListener('submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	
	
	// helper methods
	function setupValidity(instance) {
	  instance.$$classCache = {};
	  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
	}
	function addSetValidityMethod(context) {
	  var clazz = context.clazz,
	      set = context.set,
	      unset = context.unset;
	
	  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet(this, '$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(this.$error, validationErrorKey, controller);
	      unset(this.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(this.$error, validationErrorKey, controller);
	        set(this.$$success, validationErrorKey, controller);
	      } else {
	        set(this.$error, validationErrorKey, controller);
	        unset(this.$$success, validationErrorKey, controller);
	      }
	    }
	    if (this.$pending) {
	      cachedToggleClass(this, PENDING_CLASS, true);
	      this.$valid = this.$invalid = undefined;
	      toggleValidationCss(this, '', null);
	    } else {
	      cachedToggleClass(this, PENDING_CLASS, false);
	      this.$valid = isObjectEmpty(this.$error);
	      this.$invalid = !this.$valid;
	      toggleValidationCss(this, '', this.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in this.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (this.$pending && this.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (this.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (this.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(this, validationErrorKey, combinedState);
	    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
	  };
	
	  function createAndSet(ctrl, name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(ctrl, name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(ctrl, className, switchValue) {
	    if (switchValue && !ctrl.$$classCache[className]) {
	      ctrl.$$animate.addClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = true;
	    } else if (!switchValue && ctrl.$$classCache[className]) {
	      ctrl.$$animate.removeClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/* global
	  VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  ngModelMinErr: false
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	// eslint-disable-next-line max-len
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise AngularJS will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * The format of the displayed time can be adjusted with the
	    * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
	    * and `timeStripZeroSeconds`.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions}. By default,
	   * this is the timezone of the browser.
	   *
	   * The format of the displayed time can be adjusted with the
	   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
	   * and `timeStripZeroSeconds`.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The value of the resulting Date object will be set to Thursday at 00:00:00 of the requested week,
	    * due to ISO-8601 week numbering standards. Information on ISO's system for numbering the weeks of the
	    * year can be found at: https://en.wikipedia.org/wiki/ISO_8601#Week_dates
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise AngularJS will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   *
	   *
	   * @knownIssue
	   *
	   * ### HTML5 constraint validation and `allowInvalid`
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   * @knownIssue
	   *
	   * ### Large numbers and `step` validation
	   *
	   * The `step` validation will not work correctly for very large numbers (e.g. 9999999999) due to
	   * Javascript's arithmetic limitations. If you need to handle large numbers, purpose-built
	   * libraries (e.g. https://github.com/MikeMcl/big.js/), can be included into AngularJS by
	   * {@link guide/forms#modifying-built-in-validators overwriting the validators}
	   * for `number` and / or `step`, or by {@link guide/forms#custom-validation applying custom validators}
	   * to an `input[text]` element. The source for `input[number]` type can be used as a starting
	   * point for both implementations.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *    Can be interpolated.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *    Can be interpolated.
	   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
	   *    Can be interpolated.
	   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium, which may not fulfill your app's requirements.
	   * If you need stricter (e.g. requiring a top-level domain), or more relaxed validation
	   * (e.g. allowing IPv6 address literals) you can use `ng-pattern` or
	   * modify the built-in validators (see the {@link guide/forms Forms guide}).
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * **Note:**<br>
	   * All inputs controlled by {@link ngModel ngModel} (including those of type `radio`) will use the
	   * value of their `name` attribute to determine the property under which their
	   * {@link ngModel.NgModelController NgModelController} will be published on the parent
	   * {@link form.FormController FormController}. Thus, if you use the same `name` for multiple
	   * inputs of a form (e.g. a group of radio inputs), only _one_ `NgModelController` will be
	   * published on the parent `FormController` under that name. The rest of the controllers will
	   * continue to work as expected, but you won't be able to access them as properties on the parent
	   * `FormController`.
	   *
	   * <div class="alert alert-info">
	   *   <p>
	   *     In plain HTML forms, the `name` attribute is used to identify groups of radio inputs, so
	   *     that the browser can manage their state (checked/unchecked) based on the state of other
	   *     inputs in the same group.
	   *   </p>
	   *   <p>
	   *     In AngularJS forms, this is not necessary. The input's state will be updated based on the
	   *     value of the underlying model data.
	   *   </p>
	   * </div>
	   *
	   * <div class="alert alert-success">
	   *   If you omit the `name` attribute on a radio input, `ngModel` will automatically assign it a
	   *   unique name.
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var inputs = element.all(by.model('color.name'));
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            inputs.get(0).click();
	            expect(color.getText()).toContain('red');
	
	            inputs.get(1).click();
	            expect(color.getText()).toContain('green');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[range]
	   *
	   * @description
	   * Native range input with validation and transformation.
	   *
	   * The model for the range input must always be a `Number`.
	   *
	   * IE9 and other browsers that do not support the `range` type fall back
	   * to a text input without any default values for `min`, `max` and `step`. Model binding,
	   * validation and number parsing are nevertheless supported.
	   *
	   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
	   * in a way that never allows the input to hold an invalid value. That means:
	   * - any non-numerical value is set to `(max + min) / 2`.
	   * - any numerical value that is less than the current min val, or greater than the current max val
	   * is set to the min / max val respectively.
	   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
	   * is used.
	   *
	   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
	   * for more info.
	   *
	   * This has the following consequences for AngularJS:
	   *
	   * Since the element value should always reflect the current model value, a range input
	   * will set the bound ngModel expression to the value that the browser has set for the
	   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
	   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
	   * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
	   *
	   * That means the model for range will immediately be set to `50` after `ngModel` has been
	   * initialized. It also means a range input can never have the required error.
	   *
	   * This does not only affect changes to the model value, but also to the values of the `min`,
	   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
	   * the input value, AngularJS will also update the model value.
	   *
	   * Automatic value adjustment also means that a range input element can never have the `required`,
	   * `min`, or `max` errors.
	   *
	   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
	   * when the step value changes dynamically - they do not adjust the element value correctly, but
	   * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
	   * error on the input, and set the model to `undefined`.
	   *
	   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
	   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
	   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
	   *
	   * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
	   *                  than `min`. Can be interpolated.
	   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
	   *                  Can be interpolated.
	   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
	   *                  Can be interpolated.
	   * @param {expression=} ngChange AngularJS expression to be executed when the ngModel value changes due
	   *                      to user interaction with the input element.
	   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
	   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
	   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
	   *
	   * @example
	      <example name="range-input-directive" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	
	            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   * ## Range Input with ngMin & ngMax attributes
	
	   * @example
	      <example name="range-input-directive-ng" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   */
	  'range': rangeInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputting intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    // Support: IE9+
	    element.on('compositionupdate', function(ev) {
	      // End composition when ev.data is empty string on 'compositionupdate' event.
	      // When the input de-focusses (e.g. by clicking away), IE triggers 'compositionupdate'
	      // instead of 'compositionend'.
	      if (isUndefined(ev.data) || ev.data === '') {
	        composing = false;
	      }
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', /** @this */ function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut drop', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, previousDate) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (previousDate) {
	          map = {
	            yyyy: previousDate.getFullYear(),
	            MM: previousDate.getMonth() + 1,
	            dd: previousDate.getDate(),
	            HH: previousDate.getHours(),
	            mm: previousDate.getMinutes(),
	            ss: previousDate.getSeconds(),
	            sss: previousDate.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	
	        var date = new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	        if (map.yyyy < 100) {
	          // In the constructor, 2-digit years map to 1900-1999.
	          // Use `setFullYear()` to set the correct year.
	          date.setFullYear(map.yyyy);
	        }
	
	        return date;
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	    badInputChecker(scope, element, attr, ctrl, type);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	    var isTimeType = type === 'time' || type === 'datetimelocal';
	    var previousDate;
	    var previousTimezone;
	
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        return parseDateAndConvertTimeZoneToLocal(value, previousDate);
	      }
	      ctrl.$$parserName = type;
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        var timezone = ctrl.$options.getOption('timezone');
	
	        if (timezone) {
	          previousTimezone = timezone;
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	
	        return formatter(value, timezone);
	      } else {
	        previousDate = null;
	        previousTimezone = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal = attr.min || $parse(attr.ngMin)(scope);
	      var parsedMinVal = parseObservedDateValue(minVal);
	
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(parsedMinVal) || parseDate(value) >= parsedMinVal;
	      };
	      attr.$observe('min', function(val) {
	        if (val !== minVal) {
	          parsedMinVal = parseObservedDateValue(val);
	          minVal = val;
	          ctrl.$validate();
	        }
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal = attr.max || $parse(attr.ngMax)(scope);
	      var parsedMaxVal = parseObservedDateValue(maxVal);
	
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(parsedMaxVal) || parseDate(value) <= parsedMaxVal;
	      };
	      attr.$observe('max', function(val) {
	        if (val !== maxVal) {
	          parsedMaxVal = parseObservedDateValue(val);
	          maxVal = val;
	          ctrl.$validate();
	        }
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDateAndConvertTimeZoneToLocal(val) || undefined : val;
	    }
	
	    function parseDateAndConvertTimeZoneToLocal(value, previousDate) {
	      var timezone = ctrl.$options.getOption('timezone');
	
	      if (previousTimezone && previousTimezone !== timezone) {
	        // If the timezone has changed, adjust the previousDate to the default timezone
	        // so that the new date is converted with the correct timezone offset
	        previousDate = addDateMinutes(previousDate, timezoneToOffset(previousTimezone));
	      }
	
	      var parsedDate = parseDate(value, previousDate);
	
	      if (!isNaN(parsedDate) && timezone) {
	        parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	      }
	      return parsedDate;
	    }
	
	    function formatter(value, timezone) {
	      var targetFormat = format;
	
	      if (isTimeType && isString(ctrl.$options.getOption('timeSecondsFormat'))) {
	        targetFormat = format
	          .replace('ss.sss', ctrl.$options.getOption('timeSecondsFormat'))
	          .replace(/:$/, '');
	      }
	
	      var formatted =  $filter('date')(value, targetFormat, timezone);
	
	      if (isTimeType && ctrl.$options.getOption('timeStripZeroSeconds')) {
	        formatted = formatted.replace(/(?::00)?(?:\.000)?$/, '');
	      }
	
	      return formatted;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl, parserName) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      if (validity.badInput || validity.typeMismatch) {
	        ctrl.$$parserName = parserName;
	        return undefined;
	      }
	
	      return value;
	    });
	  }
	}
	
	function numberFormatterParser(ctrl) {
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	
	    ctrl.$$parserName = 'number';
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	}
	
	function parseNumberAttrVal(val) {
	  if (isDefined(val) && !isNumber(val)) {
	    val = parseFloat(val);
	  }
	  return !isNumberNaN(val) ? val : undefined;
	}
	
	function isNumberInteger(num) {
	  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
	  // (minus the assumption that `num` is a number)
	
	  // eslint-disable-next-line no-bitwise
	  return (num | 0) === num;
	}
	
	function countDecimals(num) {
	  var numString = num.toString();
	  var decimalSymbolIndex = numString.indexOf('.');
	
	  if (decimalSymbolIndex === -1) {
	    if (-1 < num && num < 1) {
	      // It may be in the exponential notation format (`1e-X`)
	      var match = /e-(\d+)$/.exec(numString);
	
	      if (match) {
	        return Number(match[1]);
	      }
	    }
	
	    return 0;
	  }
	
	  return numString.length - decimalSymbolIndex - 1;
	}
	
	function isValidForStep(viewValue, stepBase, step) {
	  // At this point `stepBase` and `step` are expected to be non-NaN values
	  // and `viewValue` is expected to be a valid stringified number.
	  var value = Number(viewValue);
	
	  var isNonIntegerValue = !isNumberInteger(value);
	  var isNonIntegerStepBase = !isNumberInteger(stepBase);
	  var isNonIntegerStep = !isNumberInteger(step);
	
	  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
	  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
	  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
	    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
	    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
	    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;
	
	    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
	    var multiplier = Math.pow(10, decimalCount);
	
	    value = value * multiplier;
	    stepBase = stepBase * multiplier;
	    step = step * multiplier;
	
	    if (isNonIntegerValue) value = Math.round(value);
	    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
	    if (isNonIntegerStep) step = Math.round(step);
	  }
	
	  return (value - stepBase) % step === 0;
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  badInputChecker(scope, element, attr, ctrl, 'number');
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var parsedMinVal;
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    var minVal = attr.min || $parse(attr.ngMin)(scope);
	    parsedMinVal = parseNumberAttrVal(minVal);
	
	    ctrl.$validators.min = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMinVal) || viewValue >= parsedMinVal;
	    };
	
	    attr.$observe('min', function(val) {
	      if (val !== minVal) {
	        parsedMinVal = parseNumberAttrVal(val);
	        minVal = val;
	        // TODO(matsko): implement validateLater to reduce number of validations
	        ctrl.$validate();
	      }
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    var maxVal = attr.max || $parse(attr.ngMax)(scope);
	    var parsedMaxVal = parseNumberAttrVal(maxVal);
	
	    ctrl.$validators.max = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMaxVal) || viewValue <= parsedMaxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      if (val !== maxVal) {
	        parsedMaxVal = parseNumberAttrVal(val);
	        maxVal = val;
	        // TODO(matsko): implement validateLater to reduce number of validations
	        ctrl.$validate();
	      }
	    });
	  }
	
	  if (isDefined(attr.step) || attr.ngStep) {
	    var stepVal = attr.step || $parse(attr.ngStep)(scope);
	    var parsedStepVal = parseNumberAttrVal(stepVal);
	
	    ctrl.$validators.step = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedStepVal) ||
	        isValidForStep(viewValue, parsedMinVal || 0, parsedStepVal);
	    };
	
	    attr.$observe('step', function(val) {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      if (val !== stepVal) {
	        parsedStepVal = parseNumberAttrVal(val);
	        stepVal = val;
	        ctrl.$validate();
	      }
	
	    });
	
	  }
	}
	
	function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl, 'range');
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
	      minVal = supportsRange ? 0 : undefined,
	      maxVal = supportsRange ? 100 : undefined,
	      stepVal = supportsRange ? 1 : undefined,
	      validity = element[0].validity,
	      hasMinAttr = isDefined(attr.min),
	      hasMaxAttr = isDefined(attr.max),
	      hasStepAttr = isDefined(attr.step);
	
	  var originalRender = ctrl.$render;
	
	  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
	    //Browsers that implement range will set these values automatically, but reading the adjusted values after
	    //$render would cause the min / max validators to be applied with the wrong value
	    function rangeRender() {
	      originalRender();
	      ctrl.$setViewValue(element.val());
	    } :
	    originalRender;
	
	  if (hasMinAttr) {
	    minVal = parseNumberAttrVal(attr.min);
	
	    ctrl.$validators.min = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMinValidator() { return true; } :
	      // non-support browsers validate the min val
	      function minValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
	      };
	
	    setInitialValueAndObserver('min', minChange);
	  }
	
	  if (hasMaxAttr) {
	    maxVal = parseNumberAttrVal(attr.max);
	
	    ctrl.$validators.max = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMaxValidator() { return true; } :
	      // non-support browsers validate the max val
	      function maxValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
	      };
	
	    setInitialValueAndObserver('max', maxChange);
	  }
	
	  if (hasStepAttr) {
	    stepVal = parseNumberAttrVal(attr.step);
	
	    ctrl.$validators.step = supportsRange ?
	      function nativeStepValidator() {
	        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
	        // input element value to a valid value). It's possible that other browsers set the stepMismatch
	        // validity error instead, so we can at least report an error in that case.
	        return !validity.stepMismatch;
	      } :
	      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
	      function stepValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	               isValidForStep(viewValue, minVal || 0, stepVal);
	      };
	
	    setInitialValueAndObserver('step', stepChange);
	  }
	
	  function setInitialValueAndObserver(htmlAttrName, changeFn) {
	    // interpolated attributes set the attribute value only after a digest, but we need the
	    // attribute value when the input is first rendered, so that the browser can adjust the
	    // input value based on the min/max value
	    element.attr(htmlAttrName, attr[htmlAttrName]);
	    var oldVal = attr[htmlAttrName];
	    attr.$observe(htmlAttrName, function wrappedObserver(val) {
	      if (val !== oldVal) {
	        oldVal = val;
	        changeFn(val);
	      }
	    });
	  }
	
	  function minChange(val) {
	    minVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
	      if (minVal > elVal) {
	        elVal = minVal;
	        element.val(elVal);
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function maxChange(val) {
	    maxVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
	      if (maxVal < elVal) {
	        element.val(maxVal);
	        // IE11 and Chrome don't set the value to the minVal when max < min
	        elVal = maxVal < minVal ? minVal : maxVal;
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function stepChange(val) {
	    stepVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
	    if (!supportsRange) {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    } else if (ctrl.$viewValue !== element.val()) {
	      ctrl.$setViewValue(element.val());
	    }
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    var value;
	    if (element[0].checked) {
	      value = attr.value;
	      if (doTrim) {
	        value = trim(value);
	      }
	      ctrl.$setViewValue(value, ev && ev.type);
	    }
	  };
	
	  element.on('change', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    if (doTrim) {
	      value = trim(value);
	    }
	    element[0].checked = (value === ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('change', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with AngularJS data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *
	 * @knownIssue
	 *
	 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
	 * insert the placeholder value as the textarea's content. If the placeholder value contains
	 * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
	 * the value of the by-then-removed text node. This doesn't affect the functionality of the
	 * textarea, but can be undesirable.
	 *
	 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
	 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
	 * find more details on `ngAttr` in the
	 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
	 * Developer Guide.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	var hiddenInputBrowserCacheDirective = function() {
	  var valueProperty = {
	    configurable: true,
	    enumerable: false,
	    get: function() {
	      return this.getAttribute('value') || '';
	    },
	    set: function(val) {
	      this.setAttribute('value', val);
	    }
	  };
	
	  return {
	    restrict: 'E',
	    priority: 200,
	    compile: function(_, attr) {
	      if (lowercase(attr.type) !== 'hidden') {
	        return;
	      }
	
	      return {
	        pre: function(scope, element, attr, ctrls) {
	          var node = element[0];
	
	          // Support: Edge
	          // Moving the DOM around prevents autofillling
	          if (node.parentNode) {
	            node.parentNode.insertBefore(node, node.nextSibling);
	          }
	
	          // Support: FF, IE
	          // Avoiding direct assignment to .value prevents autofillling
	          if (Object.defineProperty) {
	            Object.defineProperty(node, 'value', valueProperty);
	          }
	        }
	      };
	    }
	  };
	};
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Binds the given expression to the value of the element.
	 *
	 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
	 * {@link select `select`} parent element) is set to the bound value. It is especially useful
	 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * It can also be used to achieve one-way binding of a given expression to an input element
	 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
	 *
	 * @element ANY
	 * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
	 * and `value` property of the element.
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  /**
	   *  inputs use the value attribute as their default value if the value property is not set.
	   *  Once the value property has been set (by adding input), it will not react to changes to
	   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
	   *  makes it possible to use ngValue as a sort of one-way bind.
	   */
	  function updateElementValue(element, attr, value) {
	    // Support: IE9 only
	    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
	    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
	    element.prop('value', propValue);
	    attr.$set('value', value);
	  }
	
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          var value = scope.$eval(attr.ngValue);
	          updateElementValue(elm, attr, value);
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            updateElementValue(elm, attr, value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample" name="ng-bind">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = stringify(value);
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample" name="ng-bind-template">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 * @restrict A
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element ANY
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	/* exported
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective
	*/
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  var indexWatchExpression;
	
	  return ['$parse', function($parse) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var classCounts = element.data('$classCounts');
	        var oldModulo = true;
	        var oldClassString;
	
	        if (!classCounts) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          classCounts = createMap();
	          element.data('$classCounts', classCounts);
	        }
	
	        if (name !== 'ngClass') {
	          if (!indexWatchExpression) {
	            indexWatchExpression = $parse('$index', function moduloTwo($index) {
	              // eslint-disable-next-line no-bitwise
	              return $index & 1;
	            });
	          }
	
	          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
	        }
	
	        scope.$watch($parse(attr[name], toClassString), ngClassWatchAction);
	
	        function addClasses(classString) {
	          classString = digestClassCounts(split(classString), 1);
	          attr.$addClass(classString);
	        }
	
	        function removeClasses(classString) {
	          classString = digestClassCounts(split(classString), -1);
	          attr.$removeClass(classString);
	        }
	
	        function updateClasses(oldClassString, newClassString) {
	          var oldClassArray = split(oldClassString);
	          var newClassArray = split(newClassString);
	
	          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
	          var toAddArray = arrayDifference(newClassArray, oldClassArray);
	
	          var toRemoveString = digestClassCounts(toRemoveArray, -1);
	          var toAddString = digestClassCounts(toAddArray, 1);
	
	          attr.$addClass(toAddString);
	          attr.$removeClass(toRemoveString);
	        }
	
	        function digestClassCounts(classArray, count) {
	          var classesToUpdate = [];
	
	          forEach(classArray, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	
	          return classesToUpdate.join(' ');
	        }
	
	        function ngClassIndexWatchAction(newModulo) {
	          // This watch-action should run before the `ngClassWatchAction()`, thus it
	          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
	          // `ngClassWatchAction()` will update the classes.
	          if (newModulo === selector) {
	            addClasses(oldClassString);
	          } else {
	            removeClasses(oldClassString);
	          }
	
	          oldModulo = newModulo;
	        }
	
	        function ngClassWatchAction(newClassString) {
	          if (oldModulo === selector) {
	            updateClasses(oldClassString, newClassString);
	          }
	
	          oldClassString = newClassString;
	        }
	      }
	    };
	  }];
	
	  // Helpers
	  function arrayDifference(tokens1, tokens2) {
	    if (!tokens1 || !tokens1.length) return [];
	    if (!tokens2 || !tokens2.length) return tokens1;
	
	    var values = [];
	
	    outer:
	    for (var i = 0; i < tokens1.length; i++) {
	      var token = tokens1[i];
	      for (var j = 0; j < tokens2.length; j++) {
	        if (token === tokens2[j]) continue outer;
	      }
	      values.push(token);
	    }
	
	    return values;
	  }
	
	  function split(classString) {
	    return classString && classString.split(' ');
	  }
	
	  function toClassString(classValue) {
	    if (!classValue) return classValue;
	
	    var classString = classValue;
	
	    if (isArray(classValue)) {
	      classString = classValue.map(toClassString).join(' ');
	    } else if (isObject(classValue)) {
	      classString = Object.keys(classValue).
	        filter(function(key) { return classValue[key]; }).
	        join(' ');
	    } else if (!isString(classValue)) {
	      classString = classValue + '';
	    }
	
	    return classString;
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 * @element ANY
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 * | {@link ng.$animate#setClass setClass} | just before classes are added and classes are removed from the element at the same time |
	 *
	 * ### ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 *
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example
	 * ### Basic
	   <example name="ng-class">
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   @example
	   ### Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-odd">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 *
	 * <hr />
	 * @example
	 * An example on how to implement animations using `ngClassOdd`:
	 *
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-odd-animate">
	     <file name="index.html">
	       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
	         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
	         <hr />
	         <table>
	           <tr ng-repeat="item in items" ng-class-odd="'odd'">
	             <td>{{ item }}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="style.css">
	       .odd {
	         background: rgba(255, 255, 0, 0.25);
	       }
	
	       .odd-add, .odd-remove {
	         transition: 1.5s;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should add new entries to the beginning of the list', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.count()).toBe(4);
	         expect(rows.get(0).getText()).toBe('Item 3');
	         expect(rows.get(1).getText()).toBe('Item 2');
	
	         button.click();
	
	         expect(rows.count()).toBe(5);
	         expect(rows.get(0).getText()).toBe('Item 4');
	         expect(rows.get(1).getText()).toBe('Item 3');
	       });
	
	       it('should add odd class to odd entries', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
	         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
	
	         button.click();
	
	         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
	         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-even">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 *
	 * <hr />
	 * @example
	 * An example on how to implement animations using `ngClassEven`:
	 *
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-even-animate">
	     <file name="index.html">
	       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
	         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
	         <hr />
	         <table>
	           <tr ng-repeat="item in items" ng-class-even="'even'">
	             <td>{{ item }}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="style.css">
	       .even {
	         background: rgba(255, 255, 0, 0.25);
	       }
	
	       .even-add, .even-remove {
	         transition: 1.5s;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should add new entries to the beginning of the list', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.count()).toBe(4);
	         expect(rows.get(0).getText()).toBe('Item 3');
	         expect(rows.get(1).getText()).toBe('Item 2');
	
	         button.click();
	
	         expect(rows.count()).toBe(5);
	         expect(rows.get(0).getText()).toBe('Item 4');
	         expect(rows.get(1).getText()).toBe('Item 3');
	       });
	
	       it('should add even class to even entries', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
	         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
	
	         button.click();
	
	         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
	         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example name="ng-cloak">
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the AngularJS community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = 'John Smith';
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'}
	 *      ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = 'John Smith';
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'}
	 *     ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @restrict A
	 * @element ANY
	 * @description
	 *
	 * AngularJS has some features that can conflict with certain restrictions that are applied when using
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
	 * features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following default rules in CSP affect AngularJS:
	 *
	 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
	 * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
	 * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
	 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
	 * weaken the protections offered by CSP.)
	 *
	 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
	 * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
	 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
	 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
	 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
	 * it is generally not recommended as it would weaken the protections offered by CSP.)
	 *
	 * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
	 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
	 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
	 * CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related AngularJS features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
	 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 *
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	
	  <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
	  <example name="example.csp" module="cspExample" ng-csp="true">
	    <file name="index.html">
	      <div ng-controller="MainController as ctrl">
	        <div>
	          <button ng-click="ctrl.inc()" id="inc">Increment</button>
	          <span id="counter">
	            {{ctrl.counter}}
	          </span>
	        </div>
	
	        <div>
	          <button ng-click="ctrl.evil()" id="evil">Evil</button>
	          <span id="evilError">
	            {{ctrl.evilError}}
	          </span>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	       angular.module('cspExample', [])
	         .controller('MainController', function MainController() {
	            this.counter = 0;
	            this.inc = function() {
	              this.counter++;
	            };
	            this.evil = function() {
	              try {
	                eval('1+2'); // eslint-disable-line no-eval
	              } catch (e) {
	                this.evilError = e.message;
	              }
	            };
	          });
	    </file>
	    <file name="protractor.js" type="protractor">
	      var util, webdriver;
	
	      var incBtn = element(by.id('inc'));
	      var counter = element(by.id('counter'));
	      var evilBtn = element(by.id('evil'));
	      var evilError = element(by.id('evilError'));
	
	      function getAndClearSevereErrors() {
	        return browser.manage().logs().get('browser').then(function(browserLog) {
	          return browserLog.filter(function(logEntry) {
	            return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	          });
	        });
	      }
	
	      function clearErrors() {
	        getAndClearSevereErrors();
	      }
	
	      function expectNoErrors() {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          expect(filteredLog.length).toEqual(0);
	          if (filteredLog.length) {
	            console.log('browser console errors: ' + util.inspect(filteredLog));
	          }
	        });
	      }
	
	      function expectError(regex) {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          var found = false;
	          filteredLog.forEach(function(log) {
	            if (log.message.match(regex)) {
	              found = true;
	            }
	          });
	          if (!found) {
	            throw new Error('expected an error that matches ' + regex);
	          }
	        });
	      }
	
	      beforeEach(function() {
	        util = require('util');
	        webdriver = require('selenium-webdriver');
	      });
	
	      // For now, we only test on Chrome,
	      // as Safari does not load the page with Protractor's injected scripts,
	      // and Firefox webdriver always disables content security policy (#6358)
	      if (browser.params.browser !== 'chrome') {
	        return;
	      }
	
	      it('should not report errors when the page is loaded', function() {
	        // clear errors so we are not dependent on previous tests
	        clearErrors();
	        // Need to reload the page as the page is already loaded when
	        // we come here
	        browser.driver.getCurrentUrl().then(function(url) {
	          browser.get(url);
	        });
	        expectNoErrors();
	      });
	
	      it('should evaluate expressions', function() {
	        expect(counter.getText()).toEqual('0');
	        incBtn.click();
	        expect(counter.getText()).toEqual('1');
	        expectNoErrors();
	      });
	
	      it('should throw and report an error when using "eval"', function() {
	        evilBtn.click();
	        expect(evilError.getText()).toMatch(/Content Security Policy/);
	        expectError(/Content Security Policy/);
	      });
	    </file>
	  </example>
	  */
	
	// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
	// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
	// fn that looks for the `ng-csp` attribute anywhere in the current doc.
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-click">
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * AngularJS expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', '$exceptionHandler', function($parse, $rootScope, $exceptionHandler) {
	      return createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsyncEvents[eventName]);
	    }];
	  }
	);
	
	function createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsync) {
	  return {
	    restrict: 'A',
	    compile: function($element, attr) {
	      // NOTE:
	      // We expose the powerful `$event` object on the scope that provides access to the Window,
	      // etc. This is OK, because expressions are not sandboxed any more (and the expression
	      // sandbox was never meant to be a security feature anyway).
	      var fn = $parse(attr[directiveName]);
	      return function ngEventHandler(scope, element) {
	        element.on(eventName, function(event) {
	          var callback = function() {
	            fn(scope, {$event: event});
	          };
	
	          if (!$rootScope.$$phase) {
	            scope.$apply(callback);
	          } else if (forceAsync) {
	            scope.$evalAsync(callback);
	          } else {
	            try {
	              callback();
	            } catch (error) {
	              $exceptionHandler(error);
	            }
	          }
	        });
	      };
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example name="ng-dblclick">
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousedown">
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseup">
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseover">
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseenter">
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseleave">
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousemove">
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keydown">
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keyup">
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 * @restrict A
	 * @element ANY
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keypress">
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 * @restrict A
	 * @element form
	 * @priority 0
	 *
	 * @description
	 * Enables binding AngularJS expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample" name="ng-submit">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-copy">
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-cut">
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-paste">
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).done(function(response) {
	                if (response !== false) previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 * @scope
	 * @priority -400
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to AngularJS's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [{ name: 'template1.html', url: 'template1.html'},
	             { name: 'template2.html', url: 'template2.html'}];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).done(function(response) {
	              if (response !== false) previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function(response) {
	            if (response !== false && isDefined(autoScrollExp) &&
	              (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).done(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 * @priority 450
	 * @element ANY
	 *
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`:
	 * <ul>
	 *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
	 *     as seen in the demo below.</li>
	 *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
	 *   <li>injecting data via server side scripting.</li>
	 * </ul>
	 *
	 * Besides these few cases, you should use {@link guide/component Components} or
	 * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @example
	   <example module="initExample" name="ng-init">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 * @restrict A
	 * @priority 100
	 *
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * @example
	 * ### Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Splitting on newline
	 *
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      var ngList = attr.ngList || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	  PENDING_CLASS: true,
	  addSetValidityMethod: true,
	  setupValidity: true,
	  defaultModelOptions: false
	*/
	
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 *
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 *
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
	    `$viewValue`} from the DOM, usually via user input.
	    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
	    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.
	
	  The functions are called in array order, each passing
	    its return value through to the next. The last return value is forwarded to the
	    {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	    `$viewValue`}.
	
	  Returning `undefined` from a parser means a parse error occurred. In that case,
	    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	    is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	  This simple example shows a parser that would convert text input value to lowercase:
	 * ```js
	 * function parse(value) {
	 *   if (value) {
	 *     return value.toLowerCase();
	 *   }
	 * }
	 * ngModelController.$parsers.push(parse);
	 * ```
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
	    value of the control is changed by user interaction.
	
	  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
	    `$modelValue`} for display in the control.
	
	  The functions are called in reverse array order, each passing the value through to the
	    next. The last return value is used as the actual DOM value.
	
	  This simple example shows a formatter that would convert the model value to uppercase:
	
	 * ```js
	 * function format(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(format);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
	 *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
	 *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
	 *     It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * AngularJS provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if (attrs.stripBr && html === '<br>') {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
	function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	  this.$options = defaultModelOptions;
	  this.$$updateEvents = '';
	  // Attach the correct context to the event handler function for updateOn
	  this.$$updateEventHandler = this.$$updateEventHandler.bind(this);
	
	  this.$$parsedNgModel = $parse($attr.ngModel);
	  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
	  this.$$ngModelGet = this.$$parsedNgModel;
	  this.$$ngModelSet = this.$$parsedNgModelAssign;
	  this.$$pendingDebounce = null;
	  this.$$parserValid = undefined;
	  this.$$parserName = 'parse';
	
	  this.$$currentValidationRunId = 0;
	
	  this.$$scope = $scope;
	  this.$$rootScope = $scope.$root;
	  this.$$attr = $attr;
	  this.$$element = $element;
	  this.$$animate = $animate;
	  this.$$timeout = $timeout;
	  this.$$parse = $parse;
	  this.$$q = $q;
	  this.$$exceptionHandler = $exceptionHandler;
	
	  setupValidity(this);
	  setupModelWatcher(this);
	}
	
	NgModelController.prototype = {
	  $$initGetterSetters: function() {
	    if (this.$options.getOption('getterSetter')) {
	      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
	          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');
	
	      this.$$ngModelGet = function($scope) {
	        var modelValue = this.$$parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      this.$$ngModelSet = function($scope, newValue) {
	        if (isFunction(this.$$parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          this.$$parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!this.$$parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
	          this.$$attr.ngModel, startingTag(this.$$element));
	    }
	  },
	
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  $render: noop,
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  $isEmpty: function(value) {
	    // eslint-disable-next-line no-self-compare
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  },
	
	  $$updateEmptyClasses: function(value) {
	    if (this.$isEmpty(value)) {
	      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
	    } else {
	      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  $setPristine: function() {
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
	    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  $setDirty: function() {
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  $setUntouched: function() {
	    this.$touched = false;
	    this.$untouched = true;
	    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  $setTouched: function() {
	    this.$touched = true;
	    this.$untouched = false;
	    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
	   * sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * @example
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {value1: '', value2: ''};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode === 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *       empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                  ng-keydown="setEmpty($event, 'value1')">
	   *           value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *           <p id="inputDescription2">With $rollbackViewValue():</p>
	   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                  ng-keydown="setEmpty($event, 'value2', true)">
	   *           value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  $rollbackViewValue: function() {
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    this.$viewValue = this.$$lastCommittedViewValue;
	    this.$render();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  $validate: function() {
	
	    // ignore $validate before model is initialized
	    if (isNumberNaN(this.$modelValue)) {
	      return;
	    }
	
	    var viewValue = this.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = this.$$rawModelValue;
	
	    var prevValid = this.$valid;
	    var prevModelValue = this.$modelValue;
	
	    var allowInvalid = this.$options.getOption('allowInvalid');
	
	    var that = this;
	    this.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	
	        if (that.$modelValue !== prevModelValue) {
	          that.$$writeModelToScope();
	        }
	      }
	    });
	  },
	
	  $$runValidators: function(modelValue, viewValue, doneCallback) {
	    this.$$currentValidationRunId++;
	    var localValidationRunId = this.$$currentValidationRunId;
	    var that = this;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = that.$$parserName;
	
	      if (isUndefined(that.$$parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!that.$$parserValid) {
	          forEach(that.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(that.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, that.$$parserValid);
	        return that.$$parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(that.$validators, function(validator, name) {
	        var result = Boolean(validator(modelValue, viewValue));
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(that.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(that.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        that.$$q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	        that.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    var viewValue = this.$viewValue;
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
	      return;
	    }
	    this.$$updateEmptyClasses(viewValue);
	    this.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (this.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  },
	
	  $$parseAndValidate: function() {
	    var viewValue = this.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    var that = this;
	
	    this.$$parserValid = isUndefined(modelValue) ? undefined : true;
	
	    // Reset any previous parse error
	    this.$setValidity(this.$$parserName, null);
	    this.$$parserName = 'parse';
	
	    if (this.$$parserValid) {
	      for (var i = 0; i < this.$parsers.length; i++) {
	        modelValue = this.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          this.$$parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumberNaN(this.$modelValue)) {
	      // this.$modelValue has not been touched yet...
	      this.$modelValue = this.$$ngModelGet(this.$$scope);
	    }
	    var prevModelValue = this.$modelValue;
	    var allowInvalid = this.$options.getOption('allowInvalid');
	    this.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      this.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (that.$modelValue !== prevModelValue) {
	        that.$$writeModelToScope();
	      }
	    }
	  },
	
	  $$writeModelToScope: function() {
	    this.$$ngModelSet(this.$$scope, this.$modelValue);
	    forEach(this.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        // eslint-disable-next-line no-invalid-this
	        this.$$exceptionHandler(e);
	      }
	    }, this);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
	   * `$asyncValidators` are called and the value is applied to `$modelValue`.
	   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
	   * all the registered change listeners, in the `$viewChangeListeners` list are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  $setViewValue: function(value, trigger) {
	    this.$viewValue = value;
	    if (this.$options.getOption('updateOnDefault')) {
	      this.$$debounceViewValueCommit(trigger);
	    }
	  },
	
	  $$debounceViewValueCommit: function(trigger) {
	    var debounceDelay = this.$options.getOption('debounce');
	
	    if (isNumber(debounceDelay[trigger])) {
	      debounceDelay = debounceDelay[trigger];
	    } else if (isNumber(debounceDelay['default']) &&
	      this.$options.getOption('updateOn').indexOf(trigger) === -1
	    ) {
	      debounceDelay = debounceDelay['default'];
	    } else if (isNumber(debounceDelay['*'])) {
	      debounceDelay = debounceDelay['*'];
	    }
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    var that = this;
	    if (debounceDelay > 0) { // this fails if debounceDelay is an object
	      this.$$pendingDebounce = this.$$timeout(function() {
	        that.$commitViewValue();
	      }, debounceDelay);
	    } else if (this.$$rootScope.$$phase) {
	      this.$commitViewValue();
	    } else {
	      this.$$scope.$apply(function() {
	        that.$commitViewValue();
	      });
	    }
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name ngModel.NgModelController#$overrideModelOptions
	   *
	   * @description
	   *
	   * Override the current model options settings programmatically.
	   *
	   * The previous `ModelOptions` value will not be modified. Instead, a
	   * new `ModelOptions` object will inherit from the previous one overriding
	   * or inheriting settings that are defined in the given parameter.
	   *
	   * See {@link ngModelOptions} for information about what options can be specified
	   * and how model option inheritance works.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** this function only affects the options set on the `ngModelController`,
	   * and not the options on the {@link ngModelOptions} directive from which they might have been
	   * obtained initially.
	   * </div>
	   *
	   * <div class="alert alert-danger">
	   * **Note:** it is not possible to override the `getterSetter` option.
	   * </div>
	   *
	   * @param {Object} options a hash of settings to override the previous options
	   *
	   */
	  $overrideModelOptions: function(options) {
	    this.$options = this.$options.createChild(options);
	    this.$$setUpdateOnEvents();
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name  ngModel.NgModelController#$processModelValue
	
	   * @description
	   *
	   * Runs the model -> view pipeline on the current
	   * {@link ngModel.NgModelController#$modelValue $modelValue}.
	   *
	   * The following actions are performed by this method:
	   *
	   * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
	   * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
	   * - the `ng-empty` or `ng-not-empty` class is set on the element
	   * - if the `$viewValue` has changed:
	   *   - {@link ngModel.NgModelController#$render $render} is called on the control
	   *   - the {@link ngModel.NgModelController#$validators $validators} are run and
	   *   the validation status is set.
	   *
	   * This method is called by ngModel internally when the bound scope value changes.
	   * Application developers usually do not have to call this function themselves.
	   *
	   * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
	   * formatted and the `$modelValue` must be run through the `$formatters` again.
	   *
	   * @example
	   * Consider a text input with an autocomplete list (for fruit), where the items are
	   * objects with a name and an id.
	   * A user enters `ap` and then selects `Apricot` from the list.
	   * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
	   * but the rendered value will still be `ap`.
	   * The widget can then call `ctrl.$processModelValue()` to run the model -> view
	   * pipeline again, which formats the object to the string `Apricot`,
	   * then updates the `$viewValue`, and finally renders it in the DOM.
	   *
	   * <example module="inputExample" name="ng-model-process">
	     <file name="index.html">
	      <div ng-controller="inputController" style="display: flex;">
	        <div style="margin-right: 30px;">
	          Search Fruit:
	          <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
	        </div>
	        <div>
	          Model:<br>
	          <pre>{{selectedFruit | json}}</pre>
	        </div>
	      </div>
	     </file>
	     <file name="app.js">
	      angular.module('inputExample', [])
	        .controller('inputController', function($scope) {
	          $scope.items = [
	            {name: 'Apricot', id: 443},
	            {name: 'Clementine', id: 972},
	            {name: 'Durian', id: 169},
	            {name: 'Jackfruit', id: 982},
	            {name: 'Strawberry', id: 863}
	          ];
	        })
	        .component('basicAutocomplete', {
	          bindings: {
	            items: '<',
	            onSelect: '&'
	          },
	          templateUrl: 'autocomplete.html',
	          controller: function($element, $scope) {
	            var that = this;
	            var ngModel;
	
	            that.$postLink = function() {
	              ngModel = $element.find('input').controller('ngModel');
	
	              ngModel.$formatters.push(function(value) {
	                return (value && value.name) || value;
	              });
	
	              ngModel.$parsers.push(function(value) {
	                var match = value;
	                for (var i = 0; i < that.items.length; i++) {
	                  if (that.items[i].name === value) {
	                    match = that.items[i];
	                    break;
	                  }
	                }
	
	                return match;
	              });
	            };
	
	            that.selectItem = function(item) {
	              ngModel.$setViewValue(item);
	              ngModel.$processModelValue();
	              that.onSelect({item: item});
	            };
	          }
	        });
	     </file>
	     <file name="autocomplete.html">
	       <div>
	         <input type="search" ng-model="$ctrl.searchTerm" />
	         <ul>
	           <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
	             <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
	           </li>
	         </ul>
	       </div>
	     </file>
	   * </example>
	   *
	   */
	  $processModelValue: function() {
	    var viewValue = this.$$format();
	
	    if (this.$viewValue !== viewValue) {
	      this.$$updateEmptyClasses(viewValue);
	      this.$viewValue = this.$$lastCommittedViewValue = viewValue;
	      this.$render();
	      // It is possible that model and view value have been updated during render
	      this.$$runValidators(this.$modelValue, this.$viewValue, noop);
	    }
	  },
	
	  /**
	   * This method is called internally to run the $formatters on the $modelValue
	   */
	  $$format: function() {
	    var formatters = this.$formatters,
	        idx = formatters.length;
	
	    var viewValue = this.$modelValue;
	    while (idx--) {
	      viewValue = formatters[idx](viewValue);
	    }
	
	    return viewValue;
	  },
	
	  /**
	   * This method is called internally when the bound scope value changes.
	   */
	  $$setModelValue: function(modelValue) {
	    this.$modelValue = this.$$rawModelValue = modelValue;
	    this.$$parserValid = undefined;
	    this.$processModelValue();
	  },
	
	  $$setUpdateOnEvents: function() {
	    if (this.$$updateEvents) {
	      this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
	    }
	
	    this.$$updateEvents = this.$options.getOption('updateOn');
	    if (this.$$updateEvents) {
	      this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
	    }
	  },
	
	  $$updateEventHandler: function(ev) {
	    this.$$debounceViewValueCommit(ev && ev.type);
	  }
	};
	
	function setupModelWatcher(ctrl) {
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  ctrl.$$scope.$watch(function ngModelWatch(scope) {
	    var modelValue = ctrl.$$ngModelGet(scope);
	
	    // if scope model value and ngModel value are out of sync
	    // This cannot be moved to the action function, because it would not catch the
	    // case where the model is changed in the ngChange function or the model setter
	    if (modelValue !== ctrl.$modelValue &&
	      // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	      // eslint-disable-next-line no-self-compare
	      (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$$setModelValue(modelValue);
	    }
	
	    return modelValue;
	  });
	}
	
	/**
	 * @ngdoc method
	 * @name ngModel.NgModelController#$setValidity
	 *
	 * @description
	 * Change the validity state, and notify the form.
	 *
	 * This method can be called within $parsers/$formatters or a custom validation implementation.
	 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *                          Skipped is used by AngularJS when validators do not run because of parse errors and
	 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	 */
	addSetValidityMethod({
	  clazz: NgModelController,
	  set: function(object, property) {
	    object[property] = true;
	  },
	  unset: function(object, property) {
	    delete object[property];
	  }
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 * @restrict A
	 * @priority 1
	 * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * ## CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * @animations
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * ### Basic Usage
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * @example
	 * ### Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
	              optionsCtrl = ctrls[2];
	
	          if (optionsCtrl) {
	            modelCtrl.$options = optionsCtrl.$options;
	          }
	
	          modelCtrl.$$initGetterSetters();
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          modelCtrl.$$setUpdateOnEvents();
	
	          function setTouched() {
	            modelCtrl.$setTouched();
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(setTouched);
	            } else {
	              scope.$apply(setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	/* exported defaultModelOptions */
	var defaultModelOptions;
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc type
	 * @name ModelOptions
	 * @description
	 * A container for the options set by the {@link ngModelOptions} directive
	 */
	function ModelOptions(options) {
	  this.$$options = options;
	}
	
	ModelOptions.prototype = {
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#getOption
	   * @param {string} name the name of the option to retrieve
	   * @returns {*} the value of the option
	   * @description
	   * Returns the value of the given option
	   */
	  getOption: function(name) {
	    return this.$$options[name];
	  },
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#createChild
	   * @param {Object} options a hash of options for the new child that will override the parent's options
	   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
	   */
	  createChild: function(options) {
	    var inheritAll = false;
	
	    // make a shallow copy
	    options = extend({}, options);
	
	    // Inherit options from the parent if specified by the value `"$inherit"`
	    forEach(options, /** @this */ function(option, key) {
	      if (option === '$inherit') {
	        if (key === '*') {
	          inheritAll = true;
	        } else {
	          options[key] = this.$$options[key];
	          // `updateOn` is special so we must also inherit the `updateOnDefault` option
	          if (key === 'updateOn') {
	            options.updateOnDefault = this.$$options.updateOnDefault;
	          }
	        }
	      } else {
	        if (key === 'updateOn') {
	          // If the `updateOn` property contains the `default` event then we have to remove
	          // it from the event list and set the `updateOnDefault` flag.
	          options.updateOnDefault = false;
	          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
	            options.updateOnDefault = true;
	            return ' ';
	          }));
	        }
	      }
	    }, this);
	
	    if (inheritAll) {
	      // We have a property of the form: `"*": "$inherit"`
	      delete options['*'];
	      defaults(options, this.$$options);
	    }
	
	    // Finally add in any missing defaults
	    defaults(options, defaultModelOptions.$$options);
	
	    return new ModelOptions(options);
	  }
	};
	
	
	defaultModelOptions = new ModelOptions({
	  updateOn: '',
	  updateOnDefault: true,
	  debounce: 0,
	  getterSetter: false,
	  allowInvalid: false,
	  timezone: null
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 * @restrict A
	 * @priority 10
	 *
	 * @description
	 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
	 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
	 * directives will use the options of their nearest `ngModelOptions` ancestor.
	 *
	 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
	 * an AngularJS expression. This expression should evaluate to an object, whose properties contain
	 * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
	 *
	 * ## Inheriting Options
	 *
	 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
	 * directive by giving it the value of `"$inherit"`.
	 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
	 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
	 * will be used.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
	 * ```
	 *
	 * Notice that the `debounce` setting was not inherited and used the default value instead.
	 *
	 * You can specify that all undefined settings are automatically inherited from an ancestor by
	 * including a property with key of `"*"` and value of `"$inherit"`.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
	 * ```
	 *
	 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
	 *
	 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
	 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
	 *
	 *
	 * ## Triggering and debouncing model updates
	 *
	 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
	 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
	 * a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ### Overriding immediate updates
	 *
	 * The following example shows how to override immediate updates. Changes on the inputs within the
	 * form will update the model only when the control loses focus (blur event). If `escape` key is
	 * pressed while the input field is focused, the value is reset to the value in the current model.
	 *
	 * <example name="ngModelOptions-directive-blur" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ updateOn: 'blur' }"
	 *                  ng-keyup="cancel($event)" />
	 *         </label><br />
	 *         <label>
	 *           Other data:
	 *           <input type="text" ng-model="user.data" />
	 *         </label><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say', data: '' };
	 *
	 *         $scope.cancel = function(e) {
	 *           if (e.keyCode === 27) {
	 *             $scope.userForm.userName.$rollbackViewValue();
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var model = element(by.binding('user.name'));
	 *     var input = element(by.model('user.name'));
	 *     var other = element(by.model('user.data'));
	 *
	 *     it('should allow custom events', function() {
	 *       input.sendKeys(' hello');
	 *       input.click();
	 *       expect(model.getText()).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say hello');
	 *     });
	 *
	 *     it('should $rollbackViewValue when model changes', function() {
	 *       input.sendKeys(' hello');
	 *       expect(input.getAttribute('value')).toEqual('say hello');
	 *       input.sendKeys(protractor.Key.ESCAPE);
	 *       expect(input.getAttribute('value')).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Debouncing updates
	 *
	 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
	 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	 *
	 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         Name:
	 *         <input type="text" name="userName"
	 *                ng-model="user.name"
	 *                ng-model-options="{ debounce: 1000 }" />
	 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say' };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 * ### Default events, extra triggers, and catch-all debounce values
	 *
	 * This example shows the relationship between "default" update events and
	 * additional `updateOn` triggers.
	 *
	 * `default` events are those that are bound to the control, and when fired, update the `$viewValue`
	 * via {@link ngModel.NgModelController#$setViewValue $setViewValue}. Every event that is not listed
	 * in `updateOn` is considered a "default" event, since different control types have different
	 * default events.
	 *
	 * The control in this example updates by "default", "click", and "blur", with different `debounce`
	 * values. You can see that "click" doesn't have an individual `debounce` value -
	 * therefore it uses the `*` debounce value.
	 *
	 * There is also a button that calls {@link ngModel.NgModelController#$setViewValue $setViewValue}
	 * directly with a "custom" event. Since "custom" is not defined in the `updateOn` list,
	 * it is considered a "default" event and will update the
	 * control if "default" is defined in `updateOn`, and will receive the "default" debounce value.
	 * Note that this is just to illustrate how custom controls would possibly call `$setViewValue`.
	 *
	 * You can change the `updateOn` and `debounce` configuration to test different scenarios. This
	 * is done with {@link ngModel.NgModelController#$overrideModelOptions $overrideModelOptions}.
	 *
	  <example name="ngModelOptions-advanced" module="optionsExample">
	    <file name="index.html">
	       <model-update-demo></model-update-demo>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .component('modelUpdateDemo', {
	          templateUrl: 'template.html',
	          controller: function() {
	            this.name = 'Chinua';
	
	            this.options = {
	              updateOn: 'default blur click',
	              debounce: {
	                default: 2000,
	                blur: 0,
	                '*': 1000
	              }
	            };
	
	            this.updateEvents = function() {
	              var eventList = this.options.updateOn.split(' ');
	              eventList.push('*');
	              var events = {};
	
	              for (var i = 0; i < eventList.length; i++) {
	                events[eventList[i]] = this.options.debounce[eventList[i]];
	              }
	
	              this.events = events;
	            };
	
	            this.updateOptions = function() {
	              var options = angular.extend(this.options, {
	                updateOn: Object.keys(this.events).join(' ').replace('*', ''),
	                debounce: this.events
	              });
	
	              this.form.input.$overrideModelOptions(options);
	            };
	
	            // Initialize the event form
	            this.updateEvents();
	          }
	        });
	    </file>
	    <file name="template.html">
	      <form name="$ctrl.form">
	        Input: <input type="text" name="input" ng-model="$ctrl.name" ng-model-options="$ctrl.options" />
	      </form>
	      Model: <tt>{{$ctrl.name}}</tt>
	      <hr>
	      <button ng-click="$ctrl.form.input.$setViewValue('some value', 'custom')">Trigger setViewValue with 'some value' and 'custom' event</button>
	
	      <hr>
	      <form ng-submit="$ctrl.updateOptions()">
	        <b>updateOn</b><br>
	        <input type="text" ng-model="$ctrl.options.updateOn" ng-change="$ctrl.updateEvents()" ng-model-options="{debounce: 500}">
	
	        <table>
	          <tr>
	            <th>Option</th>
	            <th>Debounce value</th>
	          </tr>
	          <tr ng-repeat="(key, value) in $ctrl.events">
	            <td>{{key}}</td>
	            <td><input type="number" ng-model="$ctrl.events[key]" /></td>
	          </tr>
	        </table>
	
	        <br>
	        <input type="submit" value="Update options">
	      </form>
	    </file>
	  </example>
	 *
	 *
	 * ## Model updates and validation
	 *
	 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
	 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
	 * the model will still be updated even if the value is invalid.
	 *
	 *
	 * ## Connecting to the scope
	 *
	 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
	 * on the scope refers to a "getter/setter" function rather than the value itself.
	 *
	 * The following example shows how to bind to getter/setters:
	 *
	 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ getterSetter: true }" />
	 *         </label>
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('getterSetterExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         var _name = 'Brian';
	 *         $scope.user = {
	 *           name: function(newName) {
	 *             return angular.isDefined(newName) ? (_name = newName) : _name;
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Programmatically changing options
	 *
	 * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
	 * watched for changes. However, it is possible to override the options on a single
	 * {@link ngModel.NgModelController} instance with
	 * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
	 * See also the example for
	 * {@link ngModelOptions#default-events-extra-triggers-and-catch-all-debounce-values
	 * Default events, extra triggers, and catch-all debounce values}.
	 *
	 *
	 * ## Specifying timezones
	 *
	 * You can specify the timezone that date/time input directives expect by providing its name in the
	 * `timezone` property.
	 *
	 *
	 * ## Formatting the value of `time` and `datetime-local`
	 *
	 * With the options `timeSecondsFormat` and `timeStripZeroSeconds` it is possible to adjust the value
	 * that is displayed in the control. Note that browsers may apply their own formatting
	 * in the user interface.
	 *
	   <example name="ngModelOptions-time-format" module="timeExample">
	     <file name="index.html">
	       <time-example></time-example>
	     </file>
	     <file name="script.js">
	        angular.module('timeExample', [])
	          .component('timeExample', {
	            templateUrl: 'timeExample.html',
	            controller: function() {
	              this.time = new Date(1970, 0, 1, 14, 57, 0);
	
	              this.options = {
	                timeSecondsFormat: 'ss',
	                timeStripZeroSeconds: true
	              };
	
	              this.optionChange = function() {
	                this.timeForm.timeFormatted.$overrideModelOptions(this.options);
	                this.time = new Date(this.time);
	              };
	            }
	          });
	     </file>
	     <file name="timeExample.html">
	       <form name="$ctrl.timeForm">
	         <strong>Default</strong>:
	         <input type="time" ng-model="$ctrl.time" step="any" /><br>
	         <strong>With options</strong>:
	         <input type="time" name="timeFormatted" ng-model="$ctrl.time" step="any" ng-model-options="$ctrl.options" />
	         <br>
	
	         Options:<br>
	         <code>timeSecondsFormat</code>:
	         <input
	           type="text"
	           ng-model="$ctrl.options.timeSecondsFormat"
	           ng-change="$ctrl.optionChange()">
	         <br>
	         <code>timeStripZeroSeconds</code>:
	         <input
	           type="checkbox"
	           ng-model="$ctrl.options.timeStripZeroSeconds"
	           ng-change="$ctrl.optionChange()">
	        </form>
	      </file>
	 *  </example>
	 *
	 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
	 *   and its descendents.
	 *
	 * **General options**:
	 *
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging to the control. These are the events that are bound to
	 *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
	 *
	 *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
	 *     since different control types use different default events.
	 *
	 *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
	 *     Triggering and debouncing model updates}.
	 *
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur',
	 *       debounce: { 'default': 500, 'blur': 0 }
	 *     }"
	 *     ```
	 *     You can use the `*` key to specify a debounce value that applies to all events that are not
	 *     specifically listed. In the following example, `mouseup` would have a debounce delay of 1000:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur mouseup',
	 *       debounce: { 'default': 500, 'blur': 0, '*': 1000 }
	 *     }"
	 *     ```
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	 *     `ngModel` as getters/setters.
	 *
	 *
	 *  **Input-type specific options**:
	 *
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *     Note that changing the timezone will have no effect on the current date, and is only applied after
	 *     the next input / model change.
	 *
	 *   - `timeSecondsFormat`: Defines if the `time` and `datetime-local` types should show seconds and
	 *     milliseconds. The option follows the format string of {@link date date filter}.
	 *     By default, the options is `undefined` which is equal to `'ss.sss'` (seconds and milliseconds).
	 *     The other options are `'ss'` (strips milliseconds), and `''` (empty string), which strips both
	 *     seconds and milliseconds.
	 *     Note that browsers that support `time` and `datetime-local` require the hour and minutes
	 *     part of the time string, and may show the value differently in the user interface.
	 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
	 *
	 *   - `timeStripZeroSeconds`: Defines if the `time` and `datetime-local` types should strip the
	 *     seconds and milliseconds from the formatted value if they are zero. This option is applied
	 *     after `timeSecondsFormat`.
	 *     This option can be used to make the formatting consistent over different browsers, as some
	 *     browsers with support for `time` will natively hide the milliseconds and
	 *     seconds if they are zero, but others won't, and browsers that don't implement these input
	 *     types will always show the full string.
	 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
	 *
	 */
	var ngModelOptionsDirective = function() {
	  NgModelOptionsController.$inject = ['$attrs', '$scope'];
	  function NgModelOptionsController($attrs, $scope) {
	    this.$$attrs = $attrs;
	    this.$$scope = $scope;
	  }
	  NgModelOptionsController.prototype = {
	    $onInit: function() {
	      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
	      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
	
	      this.$options = parentOptions.createChild(modelOptionsDefinition);
	    }
	  };
	
	  return {
	    restrict: 'A',
	    // ngModelOptions needs to run before ngModel and input directives
	    priority: 10,
	    require: {parentCtrl: '?^^ngModelOptions'},
	    bindToController: true,
	    controller: NgModelOptionsController
	  };
	};
	
	
	// shallow copy over values from `src` that are not already specified on `dst`
	function defaults(dst, src) {
	  forEach(src, function(value, key) {
	    if (!isDefined(dst[key])) {
	      dst[key] = value;
	    }
	  });
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 * @element ANY
	 *
	 * @description
	 * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
	 * DOM element, including directives on the element itself that have a lower priority than
	 * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
	 * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
	 * that displays snippets of code, for instance.
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	  <example name="ng-non-bindable">
	    <file name="index.html">
	      <div>Normal: {{1 + 2}}</div>
	      <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	    </file>
	    <file name="protractor.js" type="protractor">
	     it('should check ng-non-bindable', function() {
	       expect(element(by.binding('1 + 2')).getText()).toContain('3');
	       expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	     });
	    </file>
	  </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* exported ngOptionsDirective */
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
	 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {comprehension_expression} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 * @example
	    <example module="selectExample" name="select">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	/* eslint-disable max-len */
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	/* eslint-enable */
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        'Expected expression in form of ' +
	        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
	        ' but got \'{0}\'. Element: {1}',
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          selectCtrl.hasEmptyOption = true;
	          selectCtrl.emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      // The empty option will be compiled and rendered before we first generate the options
	      selectElement.empty();
	
	      var providedEmptyOption = !!selectCtrl.emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      // Overwrite the implementation. ngOptions doesn't use hashes
	      selectCtrl.generateUnknownOptionValue = function(val) {
	        return '?';
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
	          var option = options.getOptionFromViewValue(value);
	
	          // Make sure to remove the selected attribute from the previously selected option
	          // Otherwise, screen readers might get confused
	          if (selectedOption) selectedOption.removeAttribute('selected');
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              selectCtrl.removeUnknownOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	            selectCtrl.selectUnknownOrEmptyOption(value);
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            selectCtrl.unselectEmptyOption();
	            selectCtrl.removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        // FIXME: When a user selects an option, this watch will fire needlessly
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
	          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
	          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
	
	          options.items.forEach(function(option) {
	            if (option.element.selected && !includes(selectedOptions, option)) {
	              option.element.selected = false;
	            }
	          });
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	      if (providedEmptyOption) {
	
	        // compile the element since there might be bindings in it
	        $compile(selectCtrl.emptyOption)(scope);
	
	        selectElement.prepend(selectCtrl.emptyOption);
	
	        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
	          // This means the empty option has currently no actual DOM node, probably because
	          // it has been modified by a transclusion directive.
	          selectCtrl.hasEmptyOption = false;
	
	          // Redefine the registerOption function, which will catch
	          // options that are added by ngIf etc. (rendering of the node is async because of
	          // lazy transclusion)
	          selectCtrl.registerOption = function(optionScope, optionEl) {
	            if (optionEl.val() === '') {
	              selectCtrl.hasEmptyOption = true;
	              selectCtrl.emptyOption = optionEl;
	              selectCtrl.emptyOption.removeClass('ng-scope');
	              // This ensures the new empty option is selected if previously no option was selected
	              ngModelCtrl.$render();
	
	              optionEl.on('$destroy', function() {
	                var needsRerender = selectCtrl.$isEmptyOptionSelected();
	
	                selectCtrl.hasEmptyOption = false;
	                selectCtrl.emptyOption = undefined;
	
	                if (needsRerender) ngModelCtrl.$render();
	              });
	            }
	          };
	
	        } else {
	          // remove the class, which is added automatically because we recompile the element and it
	          // becomes the compilation root
	          selectCtrl.emptyOption.removeClass('ng-scope');
	        }
	
	      }
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	      function getAndUpdateSelectedOption(viewValue) {
	        var option = options.getOptionFromViewValue(viewValue);
	        var element = option && option.element;
	
	        if (element && !element.selected) element.selected = true;
	
	        return option;
	      }
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // Support: IE 11 only, Edge 12-13 only
	        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * ## Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in AngularJS's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * ## Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * AngularJS expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, AngularJS will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * ## Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample" name="ng-pluralize">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNumberNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRef
	 * @restrict A
	 *
	 * @description
	 * The `ngRef` attribute tells AngularJS to assign the controller of a component (or a directive)
	 * to the given property in the current scope. It is also possible to add the jqlite-wrapped DOM
	 * element to the scope.
	 *
	 * If the element with `ngRef` is destroyed `null` is assigned to the property.
	 *
	 * Note that if you want to assign from a child into the parent scope, you must initialize the
	 * target property on the parent scope, otherwise `ngRef` will assign on the child scope.
	 * This commonly happens when assigning elements or components wrapped in {@link ngIf} or
	 * {@link ngRepeat}. See the second example below.
	 *
	 *
	 * @element ANY
	 * @param {string} ngRef property name - A valid AngularJS expression identifier to which the
	 *                       controller or jqlite-wrapped DOM element will be bound.
	 * @param {string=} ngRefRead read value - The name of a directive (or component) on this element,
	 *                            or the special string `$element`. If a name is provided, `ngRef` will
	 *                            assign the matching controller. If `$element` is provided, the element
	 *                            itself is assigned (even if a controller is available).
	 *
	 *
	 * @example
	 * ### Simple toggle
	 * This example shows how the controller of the component toggle
	 * is reused in the template through the scope to use its logic.
	 * <example name="ng-ref-component" module="myApp">
	 *   <file name="index.html">
	 *     <my-toggle ng-ref="myToggle"></my-toggle>
	 *     <button ng-click="myToggle.toggle()">Toggle</button>
	 *     <div ng-show="myToggle.isOpen()">
	 *       You are using a component in the same template to show it.
	 *     </div>
	 *   </file>
	 *   <file name="index.js">
	 *     angular.module('myApp', [])
	 *     .component('myToggle', {
	 *       controller: function ToggleController() {
	 *         var opened = false;
	 *         this.isOpen = function() { return opened; };
	 *         this.toggle = function() { opened = !opened; };
	 *       }
	 *     });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should publish the toggle into the scope', function() {
	 *        var toggle = element(by.buttonText('Toggle'));
	 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(false);
	 *        toggle.click();
	 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(true);
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### ngRef inside scopes
	 * This example shows how `ngRef` works with child scopes. The `ngRepeat`-ed `myWrapper` components
	 * are assigned to the scope of `myRoot`, because the `toggles` property has been initialized.
	 * The repeated `myToggle` components are published to the child scopes created by `ngRepeat`.
	 * `ngIf` behaves similarly - the assignment of `myToggle` happens in the `ngIf` child scope,
	 * because the target property has not been initialized on the `myRoot` component controller.
	 *
	 * <example name="ng-ref-scopes" module="myApp">
	 *   <file name="index.html">
	 *     <my-root></my-root>
	 *   </file>
	 *   <file name="index.js">
	 *     angular.module('myApp', [])
	 *     .component('myRoot', {
	 *       templateUrl: 'root.html',
	 *       controller: function() {
	 *         this.wrappers = []; // initialize the array so that the wrappers are assigned into the parent scope
	 *       }
	 *     })
	 *     .component('myToggle', {
	 *       template: '<strong>myToggle</strong><button ng-click="$ctrl.toggle()" ng-transclude></button>',
	 *       transclude: true,
	 *       controller: function ToggleController() {
	 *         var opened = false;
	 *         this.isOpen = function() { return opened; };
	 *         this.toggle = function() { opened = !opened; };
	 *       }
	 *     })
	 *     .component('myWrapper', {
	 *       transclude: true,
	 *       template: '<strong>myWrapper</strong>' +
	 *         '<div>ngRepeatToggle.isOpen(): {{$ctrl.ngRepeatToggle.isOpen() | json}}</div>' +
	 *         '<my-toggle ng-ref="$ctrl.ngRepeatToggle"><ng-transclude></ng-transclude></my-toggle>'
	 *     });
	 *   </file>
	 *   <file name="root.html">
	 *     <strong>myRoot</strong>
	 *     <my-toggle ng-ref="$ctrl.outerToggle">Outer Toggle</my-toggle>
	 *     <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *     <div><em>wrappers assigned to root</em><br>
	 *     <div ng-repeat="wrapper in $ctrl.wrappers">
	 *       wrapper.ngRepeatToggle.isOpen(): {{wrapper.ngRepeatToggle.isOpen() | json}}
	 *     </div>
	 *
	 *     <ul>
	 *       <li ng-repeat="(index, value) in [1,2,3]">
	 *         <strong>ngRepeat</strong>
	 *         <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *         <my-wrapper ng-ref="$ctrl.wrappers[index]">ngRepeat Toggle {{$index + 1}}</my-wrapper>
	 *       </li>
	 *     </ul>
	 *
	 *     <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen()}} // This is always undefined because it's
	 *       assigned to the child scope created by ngIf.
	 *     </div>
	 *     <div ng-if="true">
	          <strong>ngIf</strong>
	 *        <my-toggle ng-ref="ngIfToggle">ngIf Toggle</my-toggle>
	 *        <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen() | json}}</div>
	 *        <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *     </div>
	 *   </file>
	 *   <file name="styles.css">
	 *     ul {
	 *       list-style: none;
	 *       padding-left: 0;
	 *     }
	 *
	 *     li[ng-repeat] {
	 *       background: lightgreen;
	 *       padding: 8px;
	 *       margin: 8px;
	 *     }
	 *
	 *     [ng-if] {
	 *       background: lightgrey;
	 *       padding: 8px;
	 *     }
	 *
	 *     my-root {
	 *       background: lightgoldenrodyellow;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *
	 *     my-wrapper {
	 *       background: lightsalmon;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *
	 *     my-toggle {
	 *       background: lightblue;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      var OuterToggle = function() {
	 *        this.toggle = function() {
	 *          element(by.buttonText('Outer Toggle')).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return element.all(by.binding('outerToggle.isOpen()')).first().getText();
	 *        };
	 *      };
	 *      var NgRepeatToggle = function(i) {
	 *        var parent = element.all(by.repeater('(index, value) in [1,2,3]')).get(i - 1);
	 *        this.toggle = function() {
	 *          element(by.buttonText('ngRepeat Toggle ' + i)).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return parent.element(by.binding('ngRepeatToggle.isOpen() | json')).getText();
	 *        };
	 *        this.isOuterOpen = function() {
	 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
	 *        };
	 *      };
	 *      var NgRepeatToggles = function() {
	 *        var toggles = [1,2,3].map(function(i) { return new NgRepeatToggle(i); });
	 *        this.forEach = function(fn) {
	 *          toggles.forEach(fn);
	 *        };
	 *        this.isOuterOpen = function(i) {
	 *          return toggles[i - 1].isOuterOpen();
	 *        };
	 *      };
	 *      var NgIfToggle = function() {
	 *        var parent = element(by.css('[ng-if]'));
	 *        this.toggle = function() {
	 *          element(by.buttonText('ngIf Toggle')).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return by.binding('ngIfToggle.isOpen() | json').getText();
	 *        };
	 *        this.isOuterOpen = function() {
	 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
	 *        };
	 *      };
	 *
	 *      it('should toggle the outer toggle', function() {
	 *        var outerToggle = new OuterToggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
	 *        outerToggle.toggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
	 *      });
	 *
	 *      it('should toggle all outer toggles', function() {
	 *        var outerToggle = new OuterToggle();
	 *        var repeatToggles = new NgRepeatToggles();
	 *        var ifToggle = new NgIfToggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): false');
	 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *        outerToggle.toggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): true');
	 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): true');
	 *      });
	 *
	 *      it('should toggle each repeat iteration separately', function() {
	 *        var repeatToggles = new NgRepeatToggles();
	 *
	 *        repeatToggles.forEach(function(repeatToggle) {
	 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): false');
	 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *          repeatToggle.toggle();
	 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): true');
	 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *        });
	 *      });
	 *   </file>
	 * </example>
	 *
	 */
	
	var ngRefMinErr = minErr('ngRef');
	
	var ngRefDirective = ['$parse', function($parse) {
	  return {
	    priority: -1, // Needed for compatibility with element transclusion on the same element
	    restrict: 'A',
	    compile: function(tElement, tAttrs) {
	      // Get the expected controller name, converts <data-some-thing> into "someThing"
	      var controllerName = directiveNormalize(nodeName_(tElement));
	
	      // Get the expression for value binding
	      var getter = $parse(tAttrs.ngRef);
	      var setter = getter.assign || function() {
	        throw ngRefMinErr('nonassign', 'Expression in ngRef="{0}" is non-assignable!', tAttrs.ngRef);
	      };
	
	      return function(scope, element, attrs) {
	        var refValue;
	
	        if (attrs.hasOwnProperty('ngRefRead')) {
	          if (attrs.ngRefRead === '$element') {
	            refValue = element;
	          } else {
	            refValue = element.data('$' + attrs.ngRefRead + 'Controller');
	
	            if (!refValue) {
	              throw ngRefMinErr(
	                'noctrl',
	                'The controller for ngRefRead="{0}" could not be found on ngRef="{1}"',
	                attrs.ngRefRead,
	                tAttrs.ngRef
	              );
	            }
	          }
	        } else {
	          refValue = element.data('$' + controllerName + 'Controller');
	        }
	
	        refValue = refValue || element;
	
	        setter(scope, refValue);
	
	        // when the element is removed, remove it (nullify it)
	        element.on('$destroy', function() {
	          // only remove it if value has not changed,
	          // because animations (and other procedures) may duplicate elements
	          if (getter(scope) === refValue) {
	            setter(scope, null);
	          }
	        });
	      };
	    }
	  };
	}];
	
	/* exported ngRepeatDirective */
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 * @restrict A
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * ## Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a few limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so AngularJS relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * ## Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * All different types of tracking functions, their syntax, and their support for duplicate
	 * items in collections can be found in the
	 * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** If you are working with objects that have a unique identifier property, you
	 * should track by this identifier instead of the object instance,
	 * e.g. `item in items track by item.id`.
	 * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
	 * it has already rendered, even if the JavaScript objects in the collection have been substituted
	 * for new ones. For large collections, this significantly improves rendering performance.
	 * </div>
	 *
	 * ### Effects of DOM Element re-use
	 *
	 * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
	 * automatically update any active bindings on the template. However, other
	 * functionality will not be updated, because the element is not re-created:
	 *
	 * - Directives are not re-compiled
	 * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
	 * updated if they have stabilized.
	 *
	 * The above affects all kinds of element re-use due to tracking, but may be especially visible
	 * when tracking by `$index` due to the way ngRepeat re-uses elements.
	 *
	 * The following example shows the effects of different actions with tracking:
	
	  <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        var friends = [
	          {name:'John', age:25},
	          {name:'Mary', age:40},
	          {name:'Peter', age:85}
	        ];
	
	        $scope.removeFirst = function() {
	          $scope.friends.shift();
	        };
	
	        $scope.updateAge = function() {
	          $scope.friends.forEach(function(el) {
	            el.age = el.age + 5;
	          });
	        };
	
	        $scope.copy = function() {
	          $scope.friends = angular.copy($scope.friends);
	        };
	
	        $scope.reset = function() {
	          $scope.friends = angular.copy(friends);
	        };
	
	        $scope.reset();
	      });
	    </file>
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        <ol>
	          <li>When you click "Update Age", only the first list updates the age, because all others have
	          a one-time binding on the age property. If you then click "Copy", the current friend list
	          is copied, and now the second list updates the age, because the identity of the collection items
	          has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
	          items are already known according to their tracking functions.
	          </li>
	          <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
	          due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
	          DOM element for the new first collection item, and so on. Since the age property is one-time
	          bound, the value remains from the collection item which was previously at this index.
	          </li>
	        </ol>
	
	        <button ng-click="removeFirst()">Remove First</button>
	        <button ng-click="updateAge()">Update Age</button>
	        <button ng-click="copy()">Copy</button>
	        <br><button ng-click="reset()">Reset List</button>
	        <br>
	        <code>track by $id(friend)</code> (default):
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $id(friend)</code> (default), with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by friend.name</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
	            {{friend.name}}  is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $index</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by $index">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	  </example>
	
	 *
	 * ## Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
	 *     This implies that the DOM elements will be associated by item identity in the collection.
	 *
	 *     The built-in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the collection by identity. Moving the same object would move
	 *     the DOM element in the same way in the DOM.
	 *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
	 *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
	 *
	 *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
	 *     id, for example with a function, or using a property on the collection items.
	 *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
	 *     e.g. database id. In this case the object identity does not matter. Two objects are considered
	 *     equivalent as long as their `id` property is same.
	 *     Tracking by unique identifier is the most performant way and should be used whenever possible.
	 *
	 *     *$index*: This special property tracks the collection items by their index, and
	 *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
	 *     be used for a performance improvement if no unique identfier is available and the identity of
	 *     the collection items cannot be easily computed. It also allows duplicates.
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
	 *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
	 *       more info.
	 *     </div>
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
	 *       `item in items | filter:searchText as results  track by item.id`
	 *     </div>
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat
	 *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name or by age. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length === 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // eslint-disable-next-line no-bitwise
	    scope.$odd = !(scope.$even = (index & 1) === 0);
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	  var trackByIdArrayFn = function($scope, key, value) {
	    return hashKey(value);
	  };
	
	  var trackByIdObjFn = function($scope, key) {
	    return key;
	  };
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
	          aliasAs);
	      }
	
	      var trackByIdExpFn;
	
	      if (trackByExp) {
	        var hashFnLocals = {$id: hashKey};
	        var trackByExpGetter = $parse(trackByExp);
	
	        trackByIdExpFn = function($scope, key, value, index) {
	          // assign key, value, and $index to the locals so that they can be used in hash functions
	          if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	          hashFnLocals[valueIdentifier] = value;
	          hashFnLocals.$index = index;
	          return trackByExpGetter($scope, hashFnLocals);
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - clone: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn($scope, key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // Clear the value property from the hashFnLocals object to prevent a reference to the last value
	          // being leaked into the ngRepeatCompile function scope
	          if (hashFnLocals) {
	            hashFnLocals[valueIdentifier] = undefined;
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) !== nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngShow` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override anything in CSS and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                        |
	 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is shown/hidden respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element animate-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element funky-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * @knownIssue
	 *
	 * ### Flickering when using ngShow to toggle between elements
	 *
	 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
	 * happen that both the element to show and the element to hide are visible for a very short time.
	 *
	 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
	 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
	 * other browsers.
	 *
	 * There are several way to mitigate this problem:
	 *
	 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
	 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
	 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
	 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
	 * - Define an animation on the affected elements.
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngHide` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                     |
	 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is hidden/shown respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element animate-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element funky-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * @knownIssue
	 *
	 * ### Flickering when using ngHide to toggle between elements
	 *
	 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
	 * happen that both the element to show and the element to hide are visible for a very short time.
	 *
	 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
	 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
	 * other browsers.
	 *
	 * There are several way to mitigate this problem:
	 *
	 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
	 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
	 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
	 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
	 * - Define an animation on the affected elements.
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example name="ng-style">
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watchCollection(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, ''); });
	    }
	    if (newStyles) element.css(newStyles);
	  });
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed. It is possible to associate multiple values to
	 *   the same `ngSwitchWhen` by defining the optional attribute
	 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
	 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
	 *   if any of the `ngSwitch` evaluates to any of these tokens.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'options', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should change to settings via "options"', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(3).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function NgSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function(response) {
	            if (response !== false) array.splice(index, 1);
	          };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	
	        // Start with the last, in case the array is modified during the loop
	        while (previousLeaveAnimations.length) {
	          $animate.cancel(previousLeaveAnimations.pop());
	        }
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
	          runner.done(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	
	    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
	      // Filter duplicate cases
	      function(element, index, array) { return array[index - 1] !== element; }
	    );
	
	    forEach(cases, function(whenCase) {
	      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
	      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
	    });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
	 * content in the case that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}"><span>{{text}}</span></pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample" name="ng-transclude">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function() {
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = 'https://google.com';
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length && notWhitespace(clone)) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	
	        function notWhitespace(nodes) {
	          for (var i = 0, ii = nodes.length; i < ii; i++) {
	            var node = nodes[i];
	            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
	              return true;
	            }
	          }
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example  name="script-tag">
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type === 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	/* exported selectDirective, optionDirective */
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function setOptionSelectedStatus(optionEl, value) {
	  optionEl.prop('selected', value);
	  /**
	   * When unselecting an option, setting the property to null / false should be enough
	   * However, screenreaders might react to the selected attribute instead, see
	   * https://github.com/angular/angular.js/issues/14419
	   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
	   * or null
	   */
	  optionEl.attr('selected', value);
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 *
	 * @description
	 * The controller for the {@link ng.select select} directive. The controller exposes
	 * a few utility methods that can be used to augment the behavior of a regular or an
	 * {@link ng.ngOptions ngOptions} select element.
	 *
	 * @example
	 * ### Set a custom error when the unknown option is selected
	 *
	 * This example sets a custom error "unknownValue" on the ngModelController
	 * when the select element's unknown option is selected, i.e. when the model is set to a value
	 * that is not matched by any option.
	 *
	 * <example name="select-unknown-value-error" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Single select: </label><br>
	 *     <select name="testSelect" ng-model="selected" unknown-value-error>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
	 *       Error: The current model doesn't match any option</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueError', function() {
	 *     return {
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
	 *           if (selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return true;
	 *         };
	 *       }
	 *
	 *     };
	 *   });
	 * </file>
	 *</example>
	 *
	 *
	 * @example
	 * ### Set the "required" error when the unknown option is selected.
	 *
	 * By default, the "required" error on the ngModelController is only set on a required select
	 * when the empty option is selected. This example adds a custom directive that also sets the
	 * error when the unknown option is selected.
	 *
	 * <example name="select-unknown-value-required" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Select: </label><br>
	 *     <select name="testSelect" ng-model="selected" required unknown-value-required>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueRequired', function() {
	 *     return {
	 *       priority: 1, // This directive must run after the required directive has added its validator
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
	 *
	 *         ngModelCtrl.$validators.required = function() {
	 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return originalRequiredValidator.apply(this, arguments);
	 *         };
	 *       }
	 *     };
	 *   });
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 *  it('should show the error message when the unknown option is selected', function() {
	
	      var error = element(by.className('error'));
	
	      expect(error.getText()).toBe('Error: Please select a value');
	
	      element(by.cssContainingText('option', 'Option 1')).click();
	
	      expect(error.isPresent()).toBe(false);
	
	      element(by.tagName('button')).click();
	
	      expect(error.getText()).toBe('Error: Please select a value');
	    });
	 * </file>
	 *</example>
	 *
	 *
	 */
	var SelectController =
	        ['$element', '$scope', /** @this */ function($element, $scope) {
	
	  var self = this,
	      optionsMap = new NgMap();
	
	  self.selectValueMap = {}; // Keys are the hashed values, values the original values
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	  self.multiple = false;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	
	  // The empty option is an option with the value '' that the application developer can
	  // provide inside the select. It is always selectable and indicates that a "null" selection has
	  // been made by the user.
	  // If the select has an empty option, and the model of the select is set to "undefined" or "null",
	  // the empty option is selected.
	  // If the model is set to a different unmatched value, the unknown option is rendered and
	  // selected, i.e both are present, because a "null" selection and an unknown value are different.
	  self.hasEmptyOption = false;
	  self.emptyOption = undefined;
	
	  self.renderUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.updateUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.generateUnknownOptionValue = function(val) {
	    return '? ' + hashKey(val) + ' ?';
	  };
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	  self.selectEmptyOption = function() {
	    if (self.emptyOption) {
	      $element.val('');
	      setOptionSelectedStatus(self.emptyOption, true);
	    }
	  };
	
	  self.unselectEmptyOption = function() {
	    if (self.hasEmptyOption) {
	      setOptionSelectedStatus(self.emptyOption, false);
	    }
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    var val = $element.val();
	    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
	    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
	
	    if (self.hasOption(realVal)) {
	      return realVal;
	    }
	
	    return null;
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    // Make sure to remove the selected attribute from the previously selected option
	    // Otherwise, screen readers might get confused
	    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
	    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);
	
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	
	      var hashedVal = hashKey(value);
	      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);
	
	      // Set selected attribute and property on selected option for screen readers
	      var selectedOption = $element[0].options[$element[0].selectedIndex];
	      setOptionSelectedStatus(jqLite(selectedOption), true);
	    } else {
	      self.selectUnknownOrEmptyOption(value);
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.hasEmptyOption = true;
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.set(value, count + 1);
	    // Only render at the end of a digest. This improves render performance when many options
	    // are added during a digest and ensures all relevant options are correctly marked as selected
	    scheduleRender();
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.delete(value);
	        if (value === '') {
	          self.hasEmptyOption = false;
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.set(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$hasEmptyOption
	   *
	   * @description
	   *
	   * Returns `true` if the select element currently has an empty option
	   * element, i.e. an option that signifies that the select is empty / the selection is null.
	   *
	   */
	  self.$hasEmptyOption = function() {
	    return self.hasEmptyOption;
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isUnknownOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element's unknown option is selected. The unknown option is added
	   * and automatically selected whenever the select model doesn't match any option.
	   *
	   */
	  self.$isUnknownOptionSelected = function() {
	    // Presence of the unknown option means it is selected
	    return $element[0].options[0] === self.unknownOption[0];
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isEmptyOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element has an empty option and this empty option is currently
	   * selected. Returns `false` if the select element has no empty option or it is not selected.
	   *
	   */
	  self.$isEmptyOptionSelected = function() {
	    return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
	  };
	
	  self.selectUnknownOrEmptyOption = function(value) {
	    if (value == null && self.emptyOption) {
	      self.removeUnknownOption();
	      self.selectEmptyOption();
	    } else if (self.unknownOption.parent().length) {
	      self.updateUnknownOption(value);
	    } else {
	      self.renderUnknownOption(value);
	    }
	  };
	
	  var renderScheduled = false;
	  function scheduleRender() {
	    if (renderScheduled) return;
	    renderScheduled = true;
	    $scope.$$postDigest(function() {
	      renderScheduled = false;
	      self.ngModelCtrl.$render();
	    });
	  }
	
	  var updateScheduled = false;
	  function scheduleViewValueUpdate(renderAfter) {
	    if (updateScheduled) return;
	
	    updateScheduled = true;
	
	    $scope.$$postDigest(function() {
	      if ($scope.$$destroyed) return;
	
	      updateScheduled = false;
	      self.ngModelCtrl.$setViewValue(self.readValue());
	      if (renderAfter) self.ngModelCtrl.$render();
	    });
	  }
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (optionAttrs.$attr.ngValue) {
	      // The value attribute is set by ngValue
	      var oldVal, hashedVal;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(hashedVal)) {
	          self.removeOption(oldVal);
	          delete self.selectValueMap[hashedVal];
	          removal = true;
	        }
	
	        hashedVal = hashKey(newVal);
	        oldVal = newVal;
	        self.selectValueMap[hashedVal] = newVal;
	        self.addOption(newVal, optionElement);
	        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
	        // from firing a second time. Other $observers on value will also get the result of the
	        // ngValue expression, not the hashed value
	        optionElement.attr('value', hashedVal);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	
	      });
	    } else if (interpolateValueFn) {
	      // The value attribute is interpolated
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        // This method is overwritten in ngOptions and has side-effects!
	        self.readValue();
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	          removal = true;
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        var previouslySelected = optionElement.prop('selected');
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	
	        if (oldVal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	
	    optionAttrs.$observe('disabled', function(newVal) {
	
	      // Since model updates will also select disabled options (like ngOptions),
	      // we only have to handle options becoming disabled, not enabled
	
	      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
	        if (self.multiple) {
	          scheduleViewValueUpdate(true);
	        } else {
	          self.ngModelCtrl.$setViewValue(null);
	          self.ngModelCtrl.$render();
	        }
	      }
	    });
	
	    optionElement.on('$destroy', function() {
	      var currentValue = self.readValue();
	      var removeValue = optionAttrs.value;
	
	      self.removeOption(removeValue);
	      scheduleRender();
	
	      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
	          currentValue === removeValue
	      ) {
	        // When multiple (selected) options are destroyed at the same time, we don't want
	        // to run a model update for each of them. Instead, run a single update in the $$postDigest
	        scheduleViewValueUpdate(true);
	      }
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `select` element with AngularJS data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * Value and textContent can be interpolated.
	 *
	 * The {@link select.SelectController select controller} exposes utility functions that can be used
	 * to manipulate the select's behavior.
	 *
	 * ## Matching model and option values
	 *
	 * In general, the match between the model and an option is evaluated by strictly comparing the model
	 * value against the value of the available options.
	 *
	 * If you are setting the option value with the option's `value` attribute, or textContent, the
	 * value will always be a `string` which means that the model value must also be a string.
	 * Otherwise the `select` directive cannot match them correctly.
	 *
	 * To bind the model to a non-string value, you can use one of the following strategies:
	 * - the {@link ng.ngOptions `ngOptions`} directive
	 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
	 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
	 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
	 * - model $parsers / $formatters to convert the string value
	 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Choosing between `ngRepeat` and `ngOptions`
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * Specifically, select with repeated options slows down significantly starting at 2000 options in
	 * Chrome and Internet Explorer / Edge.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1'
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="select-ngrepeat" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>model = {{data.model}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngValue` to bind the model to an array of objects
	 * <example name="select-ngvalue" module="ngvalueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="ngvalueselect"> ngvalue select: </label>
	 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
	 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <pre>model = {{data.model | json}}</pre><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngvalueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	           {value: 'myString', name: 'string'},
	           {value: 1, name: 'integer'},
	           {value: true, name: 'boolean'},
	           {value: null, name: 'null'},
	           {value: {prop: 'value'}, name: 'object'},
	           {value: ['a'], name: 'array'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	
	      // if ngModel is not defined, we don't need to do anything but set the registerOption
	      // function to noop, so options don't get added internally
	      if (!ngModelCtrl) {
	        selectCtrl.registerOption = noop;
	        return;
	      }
	
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        selectCtrl.removeUnknownOption();
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	        selectCtrl.multiple = true;
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected && !option.disabled) {
	              var val = option.value;
	              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          forEach(element.find('option'), function(option) {
	            var shouldBeSelected = !!value && (includes(value, option.value) ||
	                                               includes(value, selectCtrl.selectValueMap[option.value]));
	            var currentlySelected = option.selected;
	
	            // Support: IE 9-11 only, Edge 12-15+
	            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
	            // will de-select already selected options if "selected" on those options was set
	            // more than once (i.e. when the options were already selected)
	            // So we only modify the selected property if necessary.
	            // Note: this behavior cannot be replicated via unit tests because it only shows in the
	            // actual user interface.
	            if (shouldBeSelected !== currentlySelected) {
	              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
	            }
	
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      var interpolateValueFn, interpolateTextFn;
	
	      if (isDefined(attr.ngValue)) {
	        // Will be handled by registerOption
	      } else if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
	 *                                `required` attribute to the element and adds the `required`
	 *                                {@link ngModel.NgModelController#$validators `validator`}.
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the AngularJS expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      // For boolean attributes like required, presence means true
	      var value = attr.hasOwnProperty('required') || $parse(attr.ngRequired)(scope);
	
	      if (!attr.ngRequired) {
	        // force truthy in case we are on non input element
	        // (input elements do this automatically for boolean attributes like required)
	        attr.required = true;
	      }
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !value || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function(newVal) {
	
	        if (value !== newVal) {
	          value = newVal;
	          ctrl.$validate();
	        }
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 * @restrict A
	 *
	 * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
	 *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
	 *                                      more details.
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained from the `ngPattern` attribute value:
	 * - the value is an AngularJS expression:
	 *   - If the expression evaluates to a RegExp object, then this is used directly.
	 *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    compile: function(tElm, tAttr) {
	      var patternExp;
	      var parseFn;
	
	      if (tAttr.ngPattern) {
	        patternExp = tAttr.ngPattern;
	
	        // ngPattern might be a scope expression, or an inlined regex, which is not parsable.
	        // We get value of the attribute here, so we can compare the old and the new value
	        // in the observer to avoid unnecessary validations
	        if (tAttr.ngPattern.charAt(0) === '/' && REGEX_STRING_REGEXP.test(tAttr.ngPattern)) {
	          parseFn = function() { return tAttr.ngPattern; };
	        } else {
	          parseFn = $parse(tAttr.ngPattern);
	        }
	      }
	
	      return function(scope, elm, attr, ctrl) {
	        if (!ctrl) return;
	
	        var attrVal = attr.pattern;
	
	        if (attr.ngPattern) {
	          attrVal = parseFn(scope);
	        } else {
	          patternExp = attr.pattern;
	        }
	
	        var regexp = parsePatternAttr(attrVal, patternExp, elm);
	
	        attr.$observe('pattern', function(newVal) {
	          var oldRegexp = regexp;
	
	          regexp = parsePatternAttr(newVal, patternExp, elm);
	
	          if ((oldRegexp && oldRegexp.toString()) !== (regexp && regexp.toString())) {
	            ctrl.$validate();
	          }
	        });
	
	        ctrl.$validators.pattern = function(modelValue, viewValue) {
	          // HTML5 pattern constraint validates the input value, so we validate the viewValue
	          return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	        };
	      };
	    }
	
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 * @restrict A
	 *
	 * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `maxlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = attr.maxlength || $parse(attr.ngMaxlength)(scope);
	      var maxlengthParsed = parseLength(maxlength);
	
	      attr.$observe('maxlength', function(value) {
	        if (maxlength !== value) {
	          maxlengthParsed = parseLength(value);
	          maxlength = value;
	          ctrl.$validate();
	        }
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlengthParsed < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlengthParsed);
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 * @restrict A
	 *
	 * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `minlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = attr.minlength || $parse(attr.ngMinlength)(scope);
	      var minlengthParsed = parseLength(minlength) || -1;
	
	      attr.$observe('minlength', function(value) {
	        if (minlength !== value) {
	          minlengthParsed = parseLength(value) || -1;
	          minlength = value;
	          ctrl.$validate();
	        }
	
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlengthParsed;
	      };
	    }
	  };
	}];
	
	
	function parsePatternAttr(regex, patternExp, elm) {
	  if (!regex) return undefined;
	
	  if (isString(regex)) {
	    regex = new RegExp('^' + regex + '$');
	  }
	
	  if (!regex.test) {
	    throw minErr('ngPattern')('noregexp',
	      'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	      regex, startingTag(elm));
	  }
	
	  return regex;
	}
	
	function parseLength(val) {
	  var intVal = toInt(val);
	  return isNumberNaN(intVal) ? -1 : intVal;
	}
	
	if (window.angular.bootstrap) {
	  // AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load AngularJS more than once.');
	  }
	  return;
	}
	
	// try to bind to jquery now so that one can write jqLite(fn)
	// but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(500);
	module.exports = angular;


/***/ }),
/* 502 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(504);

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	var bind = __webpack_require__(176);
	var Axios = __webpack_require__(506);
	var mergeConfig = __webpack_require__(173);
	var defaults = __webpack_require__(122);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  // Factory for creating new instances
	  instance.create = function create(instanceConfig) {
	    return createInstance(mergeConfig(defaultConfig, instanceConfig));
	  };
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Expose Cancel & CancelToken
	axios.CanceledError = __webpack_require__(88);
	axios.CancelToken = __webpack_require__(505);
	axios.isCancel = __webpack_require__(171);
	axios.VERSION = __webpack_require__(175).version;
	axios.toFormData = __webpack_require__(178);
	
	// Expose AxiosError class
	axios.AxiosError = __webpack_require__(67);
	
	// alias for CanceledError for backward compatibility
	axios.Cancel = axios.CanceledError;
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(520);
	
	// Expose isAxiosError
	axios.isAxiosError = __webpack_require__(514);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var CanceledError = __webpack_require__(88);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	
	  // eslint-disable-next-line func-names
	  this.promise.then(function(cancel) {
	    if (!token._listeners) return;
	
	    var i;
	    var l = token._listeners.length;
	
	    for (i = 0; i < l; i++) {
	      token._listeners[i](cancel);
	    }
	    token._listeners = null;
	  });
	
	  // eslint-disable-next-line func-names
	  this.promise.then = function(onfulfilled) {
	    var _resolve;
	    // eslint-disable-next-line func-names
	    var promise = new Promise(function(resolve) {
	      token.subscribe(resolve);
	      _resolve = resolve;
	    }).then(onfulfilled);
	
	    promise.cancel = function reject() {
	      token.unsubscribe(_resolve);
	    };
	
	    return promise;
	  };
	
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new CanceledError(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `CanceledError` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Subscribe to the cancel signal
	 */
	
	CancelToken.prototype.subscribe = function subscribe(listener) {
	  if (this.reason) {
	    listener(this.reason);
	    return;
	  }
	
	  if (this._listeners) {
	    this._listeners.push(listener);
	  } else {
	    this._listeners = [listener];
	  }
	};
	
	/**
	 * Unsubscribe from the cancel signal
	 */
	
	CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
	  if (!this._listeners) {
	    return;
	  }
	  var index = this._listeners.indexOf(listener);
	  if (index !== -1) {
	    this._listeners.splice(index, 1);
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	var buildURL = __webpack_require__(177);
	var InterceptorManager = __webpack_require__(507);
	var dispatchRequest = __webpack_require__(508);
	var mergeConfig = __webpack_require__(173);
	var buildFullPath = __webpack_require__(172);
	var validator = __webpack_require__(521);
	
	var validators = validator.validators;
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(configOrUrl, config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof configOrUrl === 'string') {
	    config = config || {};
	    config.url = configOrUrl;
	  } else {
	    config = configOrUrl || {};
	  }
	
	  config = mergeConfig(this.defaults, config);
	
	  // Set config.method
	  if (config.method) {
	    config.method = config.method.toLowerCase();
	  } else if (this.defaults.method) {
	    config.method = this.defaults.method.toLowerCase();
	  } else {
	    config.method = 'get';
	  }
	
	  var transitional = config.transitional;
	
	  if (transitional !== undefined) {
	    validator.assertOptions(transitional, {
	      silentJSONParsing: validators.transitional(validators.boolean),
	      forcedJSONParsing: validators.transitional(validators.boolean),
	      clarifyTimeoutError: validators.transitional(validators.boolean)
	    }, false);
	  }
	
	  // filter out skipped interceptors
	  var requestInterceptorChain = [];
	  var synchronousRequestInterceptors = true;
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
	      return;
	    }
	
	    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
	
	    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  var responseInterceptorChain = [];
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  var promise;
	
	  if (!synchronousRequestInterceptors) {
	    var chain = [dispatchRequest, undefined];
	
	    Array.prototype.unshift.apply(chain, requestInterceptorChain);
	    chain = chain.concat(responseInterceptorChain);
	
	    promise = Promise.resolve(config);
	    while (chain.length) {
	      promise = promise.then(chain.shift(), chain.shift());
	    }
	
	    return promise;
	  }
	
	
	  var newConfig = config;
	  while (requestInterceptorChain.length) {
	    var onFulfilled = requestInterceptorChain.shift();
	    var onRejected = requestInterceptorChain.shift();
	    try {
	      newConfig = onFulfilled(newConfig);
	    } catch (error) {
	      onRejected(error);
	      break;
	    }
	  }
	
	  try {
	    promise = dispatchRequest(newConfig);
	  } catch (error) {
	    return Promise.reject(error);
	  }
	
	  while (responseInterceptorChain.length) {
	    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
	  }
	
	  return promise;
	};
	
	Axios.prototype.getUri = function getUri(config) {
	  config = mergeConfig(this.defaults, config);
	  var fullPath = buildFullPath(config.baseURL, config.url);
	  return buildURL(fullPath, config.params, config.paramsSerializer);
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: (config || {}).data
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	
	  function generateHTTPMethod(isForm) {
	    return function httpMethod(url, data, config) {
	      return this.request(mergeConfig(config || {}, {
	        method: method,
	        headers: isForm ? {
	          'Content-Type': 'multipart/form-data'
	        } : {},
	        url: url,
	        data: data
	      }));
	    };
	  }
	
	  Axios.prototype[method] = generateHTTPMethod();
	
	  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
	});
	
	module.exports = Axios;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected,
	    synchronous: options ? options.synchronous : false,
	    runWhen: options ? options.runWhen : null
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	var transformData = __webpack_require__(510);
	var isCancel = __webpack_require__(171);
	var defaults = __webpack_require__(122);
	var CanceledError = __webpack_require__(88);
	
	/**
	 * Throws a `CanceledError` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	
	  if (config.signal && config.signal.aborted) {
	    throw new CanceledError();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData.call(
	    config,
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData.call(
	      config,
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData.call(
	          config,
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var AxiosError = __webpack_require__(67);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(new AxiosError(
	      'Request failed with status code ' + response.status,
	      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
	      response.config,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	var defaults = __webpack_require__(122);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  var context = this || defaults;
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn.call(context, data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 511 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));
	
	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }
	
	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }
	
	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }
	
	          if (secure === true) {
	            cookie.push('secure');
	          }
	
	          document.cookie = cookie.join('; ');
	        },
	
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },
	
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);


/***/ }),
/* 513 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */
	module.exports = function isAxiosError(payload) {
	  return utils.isObject(payload) && (payload.isAxiosError === true);
	};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	
	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;
	
	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }
	
	        urlParsingNode.setAttribute('href', href);
	
	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }
	
	      originURL = resolveURL(window.location.href);
	
	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 517 */
/***/ (function(module, exports) {

	// eslint-disable-next-line strict
	module.exports = null;


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 519 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function parseProtocol(url) {
	  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
	  return match && match[1] || '';
	};


/***/ }),
/* 520 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var VERSION = __webpack_require__(175).version;
	var AxiosError = __webpack_require__(67);
	
	var validators = {};
	
	// eslint-disable-next-line func-names
	['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
	  validators[type] = function validator(thing) {
	    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
	  };
	});
	
	var deprecatedWarnings = {};
	
	/**
	 * Transitional option validator
	 * @param {function|boolean?} validator - set to false if the transitional option has been removed
	 * @param {string?} version - deprecated version / removed since version
	 * @param {string?} message - some message with additional info
	 * @returns {function}
	 */
	validators.transitional = function transitional(validator, version, message) {
	  function formatMessage(opt, desc) {
	    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
	  }
	
	  // eslint-disable-next-line func-names
	  return function(value, opt, opts) {
	    if (validator === false) {
	      throw new AxiosError(
	        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
	        AxiosError.ERR_DEPRECATED
	      );
	    }
	
	    if (version && !deprecatedWarnings[opt]) {
	      deprecatedWarnings[opt] = true;
	      // eslint-disable-next-line no-console
	      console.warn(
	        formatMessage(
	          opt,
	          ' has been deprecated since v' + version + ' and will be removed in the near future'
	        )
	      );
	    }
	
	    return validator ? validator(value, opt, opts) : true;
	  };
	};
	
	/**
	 * Assert object's properties type
	 * @param {object} options
	 * @param {object} schema
	 * @param {boolean?} allowUnknown
	 */
	
	function assertOptions(options, schema, allowUnknown) {
	  if (typeof options !== 'object') {
	    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
	  }
	  var keys = Object.keys(options);
	  var i = keys.length;
	  while (i-- > 0) {
	    var opt = keys[i];
	    var validator = schema[opt];
	    if (validator) {
	      var value = options[opt];
	      var result = value === undefined || validator(value, opt, options);
	      if (result !== true) {
	        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
	      }
	      continue;
	    }
	    if (allowUnknown !== true) {
	      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
	    }
	  }
	}
	
	module.exports = {
	  assertOptions: assertOptions,
	  validators: validators
	};


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _segment = __webpack_require__(21);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable angular/document-service */
	
	
	(function module() {
	  angular.module('app.ui.form.ctrls').controller('AboutYouController', ['$location', 'usSpinnerService', 'logger', '$window', 'userService', '$scope', '$timeout', 'SharedApi', 'EmployersApi', 'CandidateProfileApi', '$uibModal', 'socket', function controller($location, usSpinnerService, logger, $window, userService, $scope, $timeout, SharedApi, EmployersApi, CandidateProfileApi, $uibModal, socket) {
	    var _this = this;
	
	    var vm = this;
	
	    socket.on('CANDIDATE_APPROVAL_STATUS_UPDATE', function (data) {
	      $timeout(function () {
	        if (vm.user.id === data && $location.url().contains('profile')) {
	          vm.initializeAboutYouPage();
	        }
	      }, 2000);
	    });
	    var approvalStatusEnum = {
	      NEW_USER: 'New User',
	      PENDING_APPROVAL: 'Pending Approval',
	      APPROVED: 'Approved',
	      REJECTED: 'Rejected',
	      LOCKED: 'Locked'
	    };
	
	    var startSpinner = function startSpinner() {
	      return usSpinnerService.spin('spinner-2');
	    };
	
	    var stopSpinner = function stopSpinner() {
	      return usSpinnerService.stop('spinner-2');
	    };
	
	    vm.connectToLinkedIn = function (candidateId) {
	      (0, _segment.signUpLinkedInConnect)();
	      $window.location.href = 'https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=77np1itngwj5tl&redirect_uri=' + ("https://api.lexstep.com") + '/api/v1/linkedin/callback&state=' + candidateId + '&scope=r_liteprofile%20r_emailaddress';
	    };
	
	    vm.isFormValid = function () {
	      if ((!vm.fetchEmployer && vm.legalEmployerTypes.includes(function (_ref) {
	        var isSelected = _ref.isSelected;
	        return isSelected;
	      }) || vm.fetchEmployer) && vm.candidate.pqe && vm.jurisdictionShow && vm.selectedPracticesShow && vm.selectedLocation && vm.candidate.nationality && vm.candidate.university && vm.candidate.phone && vm.candidate.location && vm.candidate.employer && !vm.phoneError && (vm.candidate.resume || vm.candidate.linkedinUrl || vm.candidate.linkedinData || vm.candidate.sraId)) {
	        return true;
	      }
	
	      vm.accessRequested = true;
	      logger.notify('error', 'Please complete all fields before requesting access');
	      return false;
	    };
	
	    vm.applyRequestAccess = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var payload, _ref3, status;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!vm.isFormValid()) {
	                _context.next = 7;
	                break;
	              }
	
	              payload = { approvalStatus: approvalStatusEnum.PENDING_APPROVAL };
	              _context.next = 4;
	              return CandidateProfileApi.updateCandidateApprovalStatus(vm.candidate.id, payload);
	
	            case 4:
	              _ref3 = _context.sent;
	              status = _ref3.status;
	
	              if (status === 200) {
	                vm.requestAccessClass = 'btn btn-lg btn-info disabled';
	                vm.candidate.isNewUser = false;
	                (0, _segment.signUpRequestAccess)(vm.candidate.nationality.code, vm.candidate.location, vm.candidate.phone, vm.candidate.pqe, vm.candidate.legalJurisdictions, vm.candidate.specialties, vm.isEnglandWalesSelected || false, Boolean(vm.candidate.linkedinUrl), vm.candidate.resume);
	                $scope.$apply();
	              }
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    var resetEmployerLegalTypes = function resetEmployerLegalTypes() {
	      vm.legalEmployerTypes = vm.legalEmployerTypes.map(function (employerType) {
	        return {
	          name: employerType.name,
	          id: employerType.id,
	          isSelected: false
	        };
	      });
	    };
	
	    var selectEmployerLegalTypes = function selectEmployerLegalTypes(name) {
	      vm.legalEmployerTypes = vm.legalEmployerTypes.map(function (employerType) {
	        return name === employerType.name ? { name: employerType.name, id: employerType.id, isSelected: true } : { name: employerType.name, id: employerType.id, isSelected: false };
	      });
	    };
	
	    vm.onEmployerTypeSelected = function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(selectedEmployerType) {
	        var employerDto;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                // eslint-disable-next-line no-negated-condition
	
	                vm.legalEmployerTypes = vm.legalEmployerTypes.map(function (employerType) {
	                  return selectedEmployerType.name === employerType.name ? { name: employerType.name, id: employerType.id, isSelected: true } : { name: employerType.name, id: employerType.id, isSelected: false };
	                });
	
	                employerDto = selectedEmployerType.id ? {
	                  employer: vm.candidate.employer,
	                  employerProfessions: ['law'],
	                  employerSpecialties: [selectedEmployerType.id],
	                  employerCategories: [2]
	                } : { employer: vm.candidate.employer };
	                _context2.next = 4;
	                return CandidateProfileApi.updateProfileData(vm.candidate.id, employerDto);
	
	              case 4:
	
	                vm.isNewCandidate.employer = vm.candidate.employer;
	                vm.fetchEmployer = true;
	                $scope.$apply();
	
	              case 7:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      return function (_x) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    var employerUpdateInProgress = false;
	    var universityUpdateInProgress = false;
	
	    vm.setEmployerTypesOpacity = function () {
	      if (vm.fetchEmployer) {
	        return {
	          opacity: '70%'
	        };
	      }
	    };
	
	    var fetchSelectedEmployer = function () {
	      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	        var employerLegalCategory;
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (!(vm.candidate.employer && vm.candidate.employer.id)) {
	                  _context3.next = 13;
	                  break;
	                }
	
	                _context3.prev = 1;
	                _context3.next = 4;
	                return EmployersApi.getEmployerById(vm.candidate.employer.id);
	
	              case 4:
	                vm.fetchEmployer = _context3.sent;
	
	
	                if (vm.fetchEmployer) {
	                  resetEmployerLegalTypes();
	                  employerLegalCategory = vm.fetchEmployer.data.categories.find(function (category) {
	                    return category.id === 2;
	                  });
	
	
	                  if (employerLegalCategory) {
	                    employerLegalCategory.specialties.map(function (_ref6) {
	                      var name = _ref6.name;
	                      return selectEmployerLegalTypes(name);
	                    });
	                  } else if (vm.fetchEmployer.professions && vm.fetchEmployer.professions.includes(function (_ref7) {
	                    var id = _ref7.id;
	                    return id !== 'law';
	                  })) selectEmployerLegalTypes('Other');
	                }
	                _context3.next = 11;
	                break;
	
	              case 8:
	                _context3.prev = 8;
	                _context3.t0 = _context3['catch'](1);
	
	                console.error('Error fetching employer', _context3.t0);
	
	              case 11:
	                _context3.next = 14;
	                break;
	
	              case 13:
	                vm.fetchEmployer = undefined;
	
	              case 14:
	
	                $scope.$apply();
	
	              case 15:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this, [[1, 8]]);
	      }));
	
	      return function fetchSelectedEmployer() {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    var updateCandidateEmployer = function updateCandidateEmployer(oldValue, newValue) {
	      if (!employerUpdateInProgress && vm.candidate.employer && oldValue !== newValue) {
	        employerUpdateInProgress = true;
	        $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
	          var employer;
	          return regeneratorRuntime.wrap(function _callee4$(_context4) {
	            while (1) {
	              switch (_context4.prev = _context4.next) {
	                case 0:
	                  _context4.next = 2;
	                  return fetchSelectedEmployer();
	
	                case 2:
	                  employer = vm.candidate.employer && vm.candidate.employer.id ? vm.candidate.employer.id : vm.candidate.employer;
	
	                  if (!(vm.candidate.employer.id || vm.legalEmployerTypes.includes(function (_ref9) {
	                    var isSelected = _ref9.isSelected;
	                    return isSelected;
	                  }))) {
	                    _context4.next = 10;
	                    break;
	                  }
	
	                  _context4.next = 6;
	                  return CandidateProfileApi.updateProfileData(vm.candidate.id, {
	                    employer: vm.candidate.employer.id
	                  });
	
	                case 6:
	                  vm.isNewCandidate.employer = vm.candidate.employer.name;
	
	                  $scope.$apply();
	                  _context4.next = 13;
	                  break;
	
	                case 10:
	                  vm.fetchEmployer = undefined;
	                  vm.legalEmployerTypes = vm.legalEmployerTypes.map(function (employerType) {
	                    return {
	                      id: employerType.id,
	                      name: employerType.name,
	                      isSelected: false
	                    };
	                  });
	                  logger.notify('error', 'Employer Type must be selected for new employer');
	
	                case 13:
	
	                  if (employer) employerUpdateInProgress = false;
	
	                  $scope.$apply();
	
	                case 15:
	                case 'end':
	                  return _context4.stop();
	              }
	            }
	          }, _callee4, _this);
	        })), 200);
	      }
	    };
	
	    var updateCandidateUniversity = function updateCandidateUniversity(oldValue, newValue) {
	      oldValue = oldValue ? JSON.parse(oldValue).name : oldValue;
	      if (!universityUpdateInProgress && vm.candidate.university && oldValue !== newValue) {
	        universityUpdateInProgress = true;
	        $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	          var university, existingSchool, school, _ref12, newSchool, statusSchool;
	
	          return regeneratorRuntime.wrap(function _callee5$(_context5) {
	            while (1) {
	              switch (_context5.prev = _context5.next) {
	                case 0:
	                  university = vm.candidate.university && vm.candidate.university.id ? vm.candidate.university.id : vm.candidate.university;
	                  existingSchool = vm.schoolList.find(function (_ref11) {
	                    var name = _ref11.name;
	                    return name === university;
	                  });
	                  school = existingSchool;
	
	                  if (existingSchool) {
	                    _context5.next = 10;
	                    break;
	                  }
	
	                  _context5.next = 6;
	                  return SharedApi.addSchool({ name: university });
	
	                case 6:
	                  _ref12 = _context5.sent;
	                  newSchool = _ref12.data;
	                  statusSchool = _ref12.status;
	
	                  if (statusSchool === 201) {
	                    vm.schoolList.push(newSchool);
	                    school = newSchool;
	                  }
	
	                case 10:
	                  _context5.next = 12;
	                  return CandidateProfileApi.updateProfileData(vm.candidate.id, {
	                    schoolId: school.id
	                  });
	
	                case 12:
	                  vm.isNewCandidate.university = {
	                    id: school.id,
	                    name: school.name
	                  };
	
	                  if (university) universityUpdateInProgress = false;
	                  $scope.$apply();
	
	                case 15:
	                case 'end':
	                  return _context5.stop();
	              }
	            }
	          }, _callee5, _this);
	        })), 200);
	      }
	    };
	
	    var updateCandidateNationality = function () {
	      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(oldValue, newValue) {
	        var newNationalityCode, oldNationalityCode;
	        return regeneratorRuntime.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                if (!(oldValue !== newValue && newValue !== 'Select Nationality')) {
	                  _context6.next = 8;
	                  break;
	                }
	
	                newNationalityCode = newValue ? vm.nationalitiesList.find(function (_ref14) {
	                  var name = _ref14.name;
	                  return name === newValue;
	                }).code : '';
	                oldNationalityCode = oldValue ? vm.nationalitiesList.find(function (_ref15) {
	                  var name = _ref15.name;
	                  return name === JSON.parse(oldValue).name;
	                }).code : '';
	
	                if (!(newNationalityCode !== oldNationalityCode)) {
	                  _context6.next = 6;
	                  break;
	                }
	
	                _context6.next = 6;
	                return CandidateProfileApi.updateProfileData(vm.candidate.id, {
	                  candidatePreference: {
	                    nationalities: [newNationalityCode]
	                  }
	                });
	
	              case 6:
	
	                vm.candidate.nationality = vm.nationalitiesList.find(function (_ref16) {
	                  var name = _ref16.name;
	                  return name === newValue;
	                });
	
	                vm.isNewCandidate.nationality = vm.candidate.nationality;
	
	              case 8:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this);
	      }));
	
	      return function updateCandidateNationality(_x2, _x3) {
	        return _ref13.apply(this, arguments);
	      };
	    }();
	
	    var updateCandidateLocation = function () {
	      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(oldValue, newValue) {
	        return regeneratorRuntime.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                if (!(newValue && Number(oldValue) !== newValue)) {
	                  _context7.next = 6;
	                  break;
	                }
	
	                _context7.next = 3;
	                return CandidateProfileApi.updateProfileData(vm.candidate.id, {
	                  location: Number(newValue)
	                });
	
	              case 3:
	
	                vm.candidate.location = newValue;
	                vm.isNewCandidate.location = vm.candidate.location;
	                $scope.$apply();
	
	              case 6:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this);
	      }));
	
	      return function updateCandidateLocation(_x4, _x5) {
	        return _ref17.apply(this, arguments);
	      };
	    }();
	
	    vm.candidateUpdate = function () {
	      var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(field, event) {
	        var oldValue, newValue, trimmed, phoneRegex;
	        return regeneratorRuntime.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                oldValue = event ? document.querySelectorAll('#' + field)[0].getAttribute('previous-value') : false;
	                newValue = event ? document.querySelectorAll('#' + field)[0].value : false;
	                _context8.t0 = field;
	                _context8.next = _context8.t0 === 'employer' ? 5 : _context8.t0 === 'location' ? 7 : _context8.t0 === 'university' ? 9 : _context8.t0 === 'nationality' ? 11 : _context8.t0 === 'preferredLocation' ? 13 : _context8.t0 === 'specialty' ? 16 : _context8.t0 === 'phone' ? 19 : _context8.t0 === 'pqe' ? 33 : _context8.t0 === 'sraId' ? 38 : 43;
	                break;
	
	              case 5:
	                updateCandidateEmployer(oldValue, newValue);
	                return _context8.abrupt('break', 44);
	
	              case 7:
	                updateCandidateLocation(oldValue, newValue);
	                return _context8.abrupt('break', 44);
	
	              case 9:
	                updateCandidateUniversity(oldValue, newValue);
	                return _context8.abrupt('break', 44);
	
	              case 11:
	                updateCandidateNationality(oldValue, newValue);
	                return _context8.abrupt('break', 44);
	
	              case 13:
	                _context8.next = 15;
	                return CandidateProfileApi.updateProfileData(vm.candidate.id, {
	                  candidatePreference: {
	                    preferredLocations: vm.candidateLocationIds
	                  }
	                });
	
	              case 15:
	                return _context8.abrupt('break', 44);
	
	              case 16:
	                _context8.next = 18;
	                return CandidateProfileApi.updateProfileData(vm.candidate.id, {
	                  candidatePreference: {
	                    specialtiesByCategory: [{ id: 1, specialties: vm.candidateSpecialtyIds }]
	                  }
	                });
	
	              case 18:
	                return _context8.abrupt('break', 44);
	
	              case 19:
	                vm.phoneError = false;
	                // eslint-disable-next-line no-case-declarations
	                trimmed = newValue.replace(/\s/g, '');
	
	                if (!(vm.candidate.phone && oldValue !== trimmed)) {
	                  _context8.next = 32;
	                  break;
	                }
	
	                phoneRegex = /^\+?\d{1,20}$/;
	
	                if (!trimmed.match(phoneRegex)) {
	                  _context8.next = 30;
	                  break;
	                }
	
	                _context8.next = 26;
	                return CandidateProfileApi.updateUserData(vm.candidate.id, {
	                  phone: trimmed
	                });
	
	              case 26:
	                vm.phoneError = false;
	                vm.isNewCandidate.phone = trimmed;
	                _context8.next = 32;
	                break;
	
	              case 30:
	                logger.notify('error', 'Please enter a valid phone number');
	                vm.phoneError = true;
	
	              case 32:
	                return _context8.abrupt('break', 44);
	
	              case 33:
	                if (!(vm.candidate.pqe && oldValue !== newValue)) {
	                  _context8.next = 37;
	                  break;
	                }
	
	                _context8.next = 36;
	                return CandidateProfileApi.updateProfileData(vm.candidate.id, {
	                  lawProfile: {
	                    qualificationDate: vm.candidate.pqe
	                  }
	                });
	
	              case 36:
	                vm.isNewCandidate.pqe = vm.candidate.pqe;
	
	              case 37:
	                return _context8.abrupt('break', 44);
	
	              case 38:
	                if (!(vm.candidate.sraId && oldValue !== newValue)) {
	                  _context8.next = 42;
	                  break;
	                }
	
	                _context8.next = 41;
	                return CandidateProfileApi.updateProfileData(vm.candidate.id, {
	                  lawProfile: {
	                    sraId: vm.candidate.sraId
	                  }
	                });
	
	              case 41:
	                vm.isNewCandidate.sraId = vm.candidate.sraId;
	
	              case 42:
	                return _context8.abrupt('break', 44);
	
	              case 43:
	                return _context8.abrupt('break', 44);
	
	              case 44:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this);
	      }));
	
	      return function (_x6, _x7) {
	        return _ref18.apply(this, arguments);
	      };
	    }();
	
	    vm.uploadResumeButton = function () {
	      var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(file, oldResume) {
	        var formData, _ref20, newResume, status;
	
	        return regeneratorRuntime.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                startSpinner();
	                vm.requestAccessClass = 'btn btn-lg btn-info disabled';
	
	                if (!oldResume) {
	                  _context9.next = 5;
	                  break;
	                }
	
	                _context9.next = 5;
	                return CandidateProfileApi.deleteUserResume(vm.candidate.id, oldResume);
	
	              case 5:
	                formData = new FormData();
	
	                formData.append('file', file[0]);
	                _context9.prev = 7;
	                _context9.next = 10;
	                return CandidateProfileApi.uploadResume(vm.candidate.id, formData);
	
	              case 10:
	                _ref20 = _context9.sent;
	                newResume = _ref20.data;
	                status = _ref20.status;
	
	                if (status === 201) {
	                  vm.candidate.resume = newResume[newResume.length - 1];
	                  vm.requestAccessClass = 'btn btn-lg btn-info';
	                  $scope.$apply();
	                  logger.notify('success', 'Resume uploaded successfully');
	                }
	                // eslint-disable-next-line unicorn/prefer-optional-catch-binding
	                _context9.next = 19;
	                break;
	
	              case 16:
	                _context9.prev = 16;
	                _context9.t0 = _context9['catch'](7);
	
	                logger.notify('error', 'Error occurred in Resume uploading');
	
	              case 19:
	
	                stopSpinner();
	
	              case 20:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this, [[7, 16]]);
	      }));
	
	      return function (_x8, _x9) {
	        return _ref19.apply(this, arguments);
	      };
	    }();
	
	    vm.openLocationModal = function (_selectedLocations, event) {
	      if (event) {
	        event.preventDefault();
	        event.stopPropagation();
	      }
	
	      var _displayNextButton = true;
	      var modalInstance = $uibModal.open({
	        templateUrl: 'locations-modal.html',
	        controller: 'LocationsModalController',
	        controllerAs: 'ctrl',
	        resolve: {
	          locationList: function locationList() {
	            return vm.locationsList;
	          },
	          selectedLocations: function selectedLocations() {
	            return _selectedLocations;
	          },
	          limit: function limit() {
	            return 0;
	          },
	          locationModalHeading: function locationModalHeading() {
	            return false;
	          },
	          displayNextButton: function displayNextButton() {
	            return _displayNextButton;
	          }
	        }
	      });
	      modalInstance.result.then(function (selectedLocations) {
	        vm.selectedLocations = selectedLocations;
	        vm.selectedLocation = selectedLocations.length > 0;
	        if (vm.selectedLocation) {
	          vm.candidate.preferredLocations = angular.copy(selectedLocations);
	          vm.candidateLocationIds = vm.candidate.preferredLocations.map(function (_ref21) {
	            var id = _ref21.id;
	            return id;
	          });
	          vm.candidateUpdate('preferredLocation');
	        }
	      }, function () {});
	    };
	
	    vm.jurisdictionUpdate = function () {
	      var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(event, selectedJurisdiction) {
	        return regeneratorRuntime.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                vm.openPracticeModal(vm.selectedPractice, event);
	                if (event) {
	                  event.stopPropagation();
	                } else {
	                  vm.jurisdictionShow = selectedJurisdiction;
	                  vm.selectedJurisdiction = selectedJurisdiction;
	                  vm.isEnglandWalesSelected = vm.selectedJurisdiction.find(function (_ref23) {
	                    var isSelected = _ref23.isSelected,
	                        name = _ref23.name;
	                    return isSelected === true && name === 'England & Wales';
	                  });
	                }
	
	              case 2:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this);
	      }));
	
	      return function (_x10, _x11) {
	        return _ref22.apply(this, arguments);
	      };
	    }();
	
	    vm.openPracticeModal = function (_selectedPractice, event) {
	      if (event) {
	        event.preventDefault();
	        event.stopPropagation();
	      }
	
	      var onlyParentPracticeArea = vm.legalPracticeAreaList.filter(function (_ref24) {
	        var parentId = _ref24.parentId;
	        return parentId === null;
	      });
	      var _displayNextButton2 = true;
	      var practiceModalInstance = $uibModal.open({
	        templateUrl: 'practice-area-modal.html',
	        controller: 'PracticeAreaController',
	        controllerAs: 'ctrl',
	        resolve: {
	          practiceAreaList: function practiceAreaList() {
	            return onlyParentPracticeArea;
	          },
	          selectedPractice: function selectedPractice() {
	            return _selectedPractice;
	          },
	          limit: function limit() {
	            return 20;
	          },
	          isAdminProfile: function isAdminProfile() {
	            return false;
	          },
	          displayNextButton: function displayNextButton() {
	            return _displayNextButton2;
	          }
	        }
	      });
	      practiceModalInstance.result.then(function (selectPractices) {
	        if (_displayNextButton2) vm.openLocationModal(vm.selectedLocations, event);
	        vm.selectPractices = selectPractices;
	        vm.selectedPracticesShow = selectPractices.length > 0;
	        if (vm.selectedPracticesShow) {
	          vm.candidate.specialties = vm.selectPractices.map(function (specialty) {
	            specialty.isSelected = true;
	            return specialty;
	          });
	          vm.candidateSpecialtyIds = vm.selectPractices.map(function (_ref25) {
	            var id = _ref25.id;
	            return id;
	          });
	          vm.candidateUpdate('specialty');
	        }
	      }, function () {});
	    };
	
	    var getLegalEmployerTypes = function () {
	      var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
	        var _ref27, legalEmployerTypes, convertName;
	
	        return regeneratorRuntime.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                _context11.next = 2;
	                return SharedApi.getCategoryById(2);
	
	              case 2:
	                _ref27 = _context11.sent;
	                legalEmployerTypes = _ref27.data;
	
	                // eslint-disable-next-line unicorn/consistent-function-scoping
	                convertName = function convertName(name) {
	                  switch (name) {
	                    case 'In-House':
	                      return 'In-House Legal';
	                    case 'Private Practice':
	                      return 'Private Practice Law Firm';
	                    default:
	                      return name;
	                  }
	                };
	
	                vm.legalEmployerTypes = legalEmployerTypes.specialties.map(function (_ref28) {
	                  var name = _ref28.name,
	                      id = _ref28.id;
	
	                  return { name: convertName(name), isSelected: false, id: id };
	                });
	
	                vm.legalEmployerTypes = [].concat(_toConsumableArray(vm.legalEmployerTypes), [{
	                  name: 'Other',
	                  isSelected: false,
	                  id: undefined
	                }]);
	
	              case 7:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, _this);
	      }));
	
	      return function getLegalEmployerTypes() {
	        return _ref26.apply(this, arguments);
	      };
	    }();
	
	    // eslint-disable-next-line complexity
	    vm.initializeAboutYouPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
	      var userId, _ref30, candidate, notifyMessage, _ref31, _ref32, locationsList, nationalitiesList, schoolList, employersList, legalPracticeAreaList, legalJurisdictionList, resumes, candidateJurisdictions;
	
	      return regeneratorRuntime.wrap(function _callee12$(_context12) {
	        while (1) {
	          switch (_context12.prev = _context12.next) {
	            case 0:
	              startSpinner();
	
	              _context12.next = 3;
	              return userService.getUser();
	
	            case 3:
	              vm.user = _context12.sent;
	
	              if ($location.search().user && !vm.user.isAdmin) {
	                $location.url('/views/pages/404.html');
	              }
	
	              if (!$location.search().user && vm.user.isAdmin) {
	                $location.url(vm.user.defaultRoute);
	              }
	
	              userId = $location.search().user && vm.user.isAdmin ? Number($location.search().user) : vm.user.id;
	              _context12.prev = 7;
	              _context12.next = 10;
	              return CandidateProfileApi.getUserProfile(userId, {
	                include: ['nationalities', 'preferredContractTypes', 'location', 'preferredLocations']
	              });
	
	            case 10:
	              _ref30 = _context12.sent;
	              candidate = _ref30.data;
	
	              vm.candidate = candidate;
	              _context12.next = 20;
	              break;
	
	            case 15:
	              _context12.prev = 15;
	              _context12.t0 = _context12['catch'](7);
	              notifyMessage = 'Error occurred in Initalizing User Profile Page';
	
	              if (_context12.t0.status === 404 && vm.user.isAdmin) notifyMessage = 'Unable to Access User About You Profile';
	              logger.notify('error', notifyMessage);
	
	            case 20:
	              _context12.next = 22;
	              return Promise.all([SharedApi.getAllLocations({
	                regions: true
	              }), SharedApi.getAllNationalities(), SharedApi.getAllSchools(), EmployersApi.getAllEmployers({
	                isDeleted: false,
	                include: ['id', 'name'],
	                isApproved: true
	              }), SharedApi.getCategoryById(1), SharedApi.getCategoryById(3), CandidateProfileApi.getUserResumes(userId)]);
	
	            case 22:
	              _ref31 = _context12.sent;
	              _ref32 = _slicedToArray(_ref31, 7);
	              locationsList = _ref32[0].data;
	              nationalitiesList = _ref32[1].data;
	              schoolList = _ref32[2].data;
	              employersList = _ref32[3].data;
	              legalPracticeAreaList = _ref32[4].data;
	              legalJurisdictionList = _ref32[5].data;
	              resumes = _ref32[6].data;
	
	
	              vm.nationalitiesList = nationalitiesList.map(function (nationality) {
	                return {
	                  code: nationality.code,
	                  name: nationality.demonyms[0]
	                };
	              }).filter(function (nationality) {
	                return nationality.name;
	              });
	
	              vm.locationsList = locationsList;
	              vm.schoolList = schoolList;
	              vm.employersList = employersList;
	              vm.legalPracticeAreaList = legalPracticeAreaList.specialties;
	
	              vm.legalJurisdiction = legalJurisdictionList.specialties;
	              vm.candidate.resumes = resumes;
	
	              vm.candidate.isNewUser = vm.candidate.approvalStatus === 'New User';
	              vm.candidate.university = vm.candidate.schoolId ? vm.schoolList.find(function (_ref33) {
	                var id = _ref33.id;
	                return id === vm.candidate.schoolId;
	              }) : undefined;
	
	              vm.candidate.resume = vm.candidate.resumes && vm.candidate.resumes.length > 0 ? vm.candidate.resumes[vm.candidate.resumes.length - 1] : undefined;
	              if (vm.candidate.preferredLocations.length > 0) vm.candidate.preferredLocations = vm.candidate.preferredLocations.map(function (location) {
	                location.isSelected = true;
	                return location;
	              });
	              vm.selectedLocation = vm.candidate.preferredLocations.length > 0;
	
	              vm.candidate.legalPracticeAreaSpecialties = vm.candidate.category.find(function (category) {
	                return category.id === 1;
	              });
	              if (vm.candidate.legalPracticeAreaSpecialties && vm.candidate.legalPracticeAreaSpecialties.specialties.length > 0) vm.candidate.specialties = vm.candidate.legalPracticeAreaSpecialties.specialties;
	              vm.candidate.specialties = vm.candidate.specialties ? vm.candidate.specialties.map(function (specialty) {
	                specialty.isSelected = true;
	                return specialty;
	              }) : [];
	              vm.selectedPracticesShow = vm.candidate.specialties.length > 0;
	
	              candidateJurisdictions = vm.candidate.category.find(function (category) {
	                return category.id === 3;
	              });
	
	              vm.candidate.legalJurisdictions = vm.legalJurisdiction.map(function (jurisdiction) {
	                return Object.assign({
	                  isSelected: Boolean(candidateJurisdictions && candidateJurisdictions.specialties.find(function (candidateJurisdiction) {
	                    return candidateJurisdiction.id === jurisdiction.id;
	                  }))
	                }, jurisdiction);
	              });
	              vm.jurisdictionShow = vm.candidate.legalJurisdictions.find(function (_ref34) {
	                var isSelected = _ref34.isSelected;
	                return isSelected === true;
	              });
	
	              vm.isEnglandWalesSelected = vm.candidate.legalJurisdictions.find(function (_ref35) {
	                var isSelected = _ref35.isSelected,
	                    name = _ref35.name;
	                return isSelected === true && name === 'England & Wales';
	              });
	              vm.candidate.phone = vm.candidate.user.phone;
	              vm.candidate.location = vm.candidate.location ? vm.candidate.location.id : undefined;
	              vm.candidate.nationality = vm.candidate.nationalities && vm.candidate.nationalities.length > 0 ? vm.candidate.nationalities.map(function (nationality) {
	                return {
	                  code: nationality.code,
	                  name: nationality.demonyms[0]
	                };
	              }).find(function (nationality) {
	                return nationality.name;
	              }) : undefined;
	              vm.candidate.pqe = vm.candidate.lawProfile.qualificationDate;
	              vm.candidate.sraId = vm.candidate.lawProfile.sraId;
	
	              vm.isNewCandidate = angular.copy(vm.candidate);
	              vm.requestAccessBtnLabel = vm.candidate.isNewUser ? 'Request Access' : 'Access Requested';
	              vm.requestAccessBtnClass = vm.requestAccessBtnLabel === 'Access Requested' ? 'btn btn-lg btn-info disabled' : 'btn btn-lg btn-info';
	
	              fetchSelectedEmployer();
	              stopSpinner();
	
	              $scope.$apply();
	
	            case 62:
	            case 'end':
	              return _context12.stop();
	          }
	        }
	      }, _callee12, _this, [[7, 15]]);
	    }));
	
	    getLegalEmployerTypes();
	    vm.initializeAboutYouPage();
	  }]);
	})();

/***/ }),
/* 523 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	  angular.module('app.ui.form.ctrls').controller('AdminAppliedJobs', ['$scope', '$log', '$http', 'sharedProperties', 'currentLawyer', 'usSpinnerService', 'logger', '$location', function ($scope, $log, $http, sharedProperties, currentLawyer, usSpinnerService, logger, $location) {
	    $scope.lawyerjobs = [];
	    sharedProperties.verifyUser(_.range(11, 18));
	    $scope.picSrc = 'images/firm-logo-default.jpg';
	    $scope.showSuccessMsg = false;
	    $scope.showErrorMsg = false;
	    $scope.alertMsg = '';
	    $scope.firms = [];
	    $scope.showNoJobs = false;
	    $scope.openJobs = [];
	    $scope.closedJobs = [];
	    $scope.isDataFetched = false;
	    $scope.jobStatus = [{
	      state: "Applied"
	    }, {
	      state: "Line"
	    }, {
	      state: "Review"
	    }, {
	      state: "Interview"
	    }, {
	      state: "Unsuccessful"
	    }, {
	      state: "Offer"
	    }];
	    $scope.jobOptionsList = [{
	      option: "Interview"
	    }, {
	      option: "Offer"
	    }, {
	      option: "Accepted"
	    }];
	    var liveJobsStatuses = ["Applied", "Line", "Review", "Interview", "Pending Interview"],
	        processedJobsStatues = ["Unsuccessful", "Offer", "Rejected by Firm"];
	    $scope.showClass = "";
	    $scope.showJobDetail = function (job) {
	      if (!job.expanded) {
	        job.expanded = true;
	        job.isExpanded = false;
	        $http.post('/api/fetch-job-practices', {
	          id: job.jobData.job_ID
	        }).then(function (_ref) {
	          var data = _ref.data;
	
	          job.targetedJobPracticeAreas = data;
	        }, function (error) {
	          $log.info('error: ', error);
	        });
	        $http.post('/api/fetch-job-locations', {
	          job_ID: job.jobData.job_ID
	        }).then(function (_ref2) {
	          var data = _ref2.data;
	
	          var location;
	          job.targetedLocations = data;
	          location = _.findWhere(data, {
	            "loc_name": job.jobData.job_location
	          });
	          if (location) {
	            job.loc_color = location.loc_color;
	          }
	        }, function (error) {
	          $log.info('error: ', error);
	        });
	      } else {
	        job.expanded = false;
	      }
	    };
	    $scope.hideDropDown = function () {
	      $scope.showClass = "";
	    };
	    $scope.showDropDown = function () {
	      if ($scope.showClass === "") {
	        $scope.showClass = "show";
	      } else {
	        $scope.showClass = "";
	      }
	    };
	
	    $scope.notify = function (type, message) {
	      switch (type) {
	        case 'info':
	          logger.log("Heads up! This alert needs your attention, but it's not super important.");
	          break;
	        case 'success':
	          logger.logSuccess(message);
	          break;
	        case 'warning':
	          logger.logWarning("Warning! Best check yo self, you're not looking too good.");
	          break;
	        case 'error':
	          logger.logError("Oh snap! Change a few things up and try submitting again.");
	      }
	    };
	    this.logOut = function () {
	      sharedProperties.logOut();
	    };
	    $scope.showLawyerProfile = function () {
	      $location.url('/admin/lawyer-profile');
	    };
	    var spinnerActive = true;
	    $scope.fetchLawyerJobs = function () {
	      setTimeout(function () {
	        if (spinnerActive) usSpinnerService.spin('spinner-ajl');
	      }, 1);
	      $http.post('/api/fetch-lawyer-jobs', {
	        id: $scope.loggedInLawyer.lawyer.lawyer_ID
	      }).then(function (_ref3) {
	        var data = _ref3.data;
	
	        $http.post('/api/fetch-lawyer-firms', {
	          id: $scope.loggedInLawyer.lawyer.lawyer_ID
	        }).then(function (_ref4) {
	          var data = _ref4.data;
	
	          var firmData = data;
	          $scope.lawyerfirms = firmData;
	          firmData.forEach(function (firm) {
	            if (_.contains(liveJobsStatuses, firm.status)) {
	              firm.liveStatus = "Live Firm Applications";
	            } else if (_.contains(processedJobsStatues, firm.status)) {
	              firm.liveStatus = "Processed Firm Applications";
	            }
	            if (firm.profile_Picture === null) {
	              firm.picSrc = $scope.picSrc;
	            } else {
	              firm.picSrc = sharedProperties.getImgSrc(firm.profile_Picture, firm.user_ID, true);
	            }
	            firm.job_title = "Connect with " + firm.firm_Name;
	          });
	        }, function (error) {
	          $log.info("error: ", error);
	        });
	        if (data.length <= 0) {
	          $scope.showNoJobs = true;
	        } else {
	          $scope.showNoJobs = false;
	        }
	
	        if (data.length > 0) {
	          $scope.lawyerjobs = [];
	          data.forEach(function (job, index) {
	            var tJob = {
	              createdAt: job.jobApplicationDate,
	              firmName: job.firm_Name,
	              is_accepted: job.is_accepted,
	              is_interviewed: job.is_interviewed,
	              is_offered: job.is_offered,
	              feedBack: job.feedBack,
	              jobData: job,
	              jobJobID: job.job_ID,
	              lawyerLawyerID: $scope.loggedInLawyer.lawyer.lawyer_ID,
	              sent: job.sent,
	              status: job.status,
	              appliedOffPlatform: job.appliedOffPlatform,
	              job_is_visible: job.job_is_visible,
	              firm_Visibility: job.firm_Visibility,
	              hiddenFirm: job.hiddenFirm,
	              hiddenJob: job.hiddenJob,
	              job_min_pqe: job.job_min_pqe,
	              job_max_pqe: job.job_max_pqe,
	              employerTypeID: job.employerTypeID,
	              parentStage: job.parentStage,
	              childState: job.childState,
	              parentStageId: job.parentStageId,
	              archived: job.archived,
	              lastStatusChange: job.lastStatusChange
	            };
	
	            if (job.archived == "Active" || job.archived == null) {
	              tJob.liveStatus = "Live Jobs";
	            } else {
	              tJob.liveStatus = "Archived";
	            }
	
	            if (job.profile_Picture === null) {
	              tJob.picSrc = $scope.picSrc;
	            } else {
	              tJob.picSrc = sharedProperties.getImgSrc(job.profile_Picture, job.firm_user_ID, true);
	            }
	            $scope.lawyerjobs.push(tJob);
	            if (index == data.length - 1) {
	              spinnerActive = false;
	              usSpinnerService.stop('spinner-ajl');
	            }
	
	            return $scope.isDataFetched = true;
	          });
	        } else {
	          spinnerActive = true;
	          usSpinnerService.stop('spinner-ajl');
	          $scope.showNoJobs = true;
	          $scope.isDataFetched = true;
	        }
	      }, function (_ref5) {
	        var error = _ref5.error,
	            status = _ref5.status;
	
	        $log.info('error: ', error);
	        if (status === 440) {
	          $location.url('/signin');
	        }
	      });
	    };
	
	    $scope.updateJobInfo = function (job) {
	      $http.post('/api/update-lawyer-job-info', job).then(function () {
	        var message;
	        message = 'Successfully updated.';
	        $scope.notify('success', message);
	      }, function (_ref6) {
	        var status = _ref6.status;
	
	        $scope.alertMsg = 'Internal Server Error.';
	        $scope.showErrorMsg = true;
	        if (status === 440) {
	          return $location.url('/signin');
	        }
	      });
	    };
	    $scope.updateFirmInfo = function (firm) {
	      $http.post('/api/update-lawyer-firm-info', firm).then(function () {
	        var message;
	        message = 'Successfully updated.';
	        $scope.notify('success', message);
	      }, function (_ref7) {
	        var status = _ref7.status;
	
	        $scope.alertMsg = 'Internal Server Error.';
	        $scope.showErrorMsg = true;
	        if (status === 440) {
	          return $location.url('/signin');
	        }
	      });
	    };
	
	    $scope.updateFirmStatus = function (firm, status) {
	      var updateJob;
	      updateJob = {
	        cur_firm: firm,
	        new_status: status
	      };
	      if (status.state === "Unsuccessful" || status.state === "Offer" || status.state === "Rejected by Firm") {
	        firm.liveStatus = "Processed Firm Applications";
	      } else {
	        firm.liveStatus = "Live Firm Applications";
	      }
	      $http.post('/api/update-lawyer-firm', updateJob).then(function () {
	        var message;
	        message = 'Status has been changed Successfuly.';
	        $scope.notify('success', message);
	      }, function (_ref8) {
	        var status = _ref8.status;
	
	        $scope.alertMsg = 'Internal Server Error.';
	        $scope.showErrorMsg = true;
	        if (status === 440) {
	          return $location.url('/signin');
	        }
	      });
	    };
	    $scope.populateLawyerjobs = function (data) {
	      $scope.lawyerjobs.forEach(function (lawyerjob) {
	        return data.forEach(function (jobs) {
	          if (lawyerjob.jobJobID === jobs.job_ID) {
	            lawyerjob.jobData = jobs;
	          }
	        });
	      });
	    };
	    $scope.populateFirmData = function () {
	      $scope.lawyerjobs.forEach(function (lawyer_job) {
	        if (lawyer_job.status === "Applied" || lawyer_job.status === "Line" || lawyer_job.status === "Review" || lawyer_job.status === "Interview" || lawyer_job.status === "Pending Interview") {
	          lawyer_job.liveStatus = "Live Jobs";
	        } else if (lawyer_job.status === "Unsuccessful" || lawyer_job.status === "Offer" || (lawyer_job.status = "Rejected by Firm")) {
	          lawyer_job.liveStatus = "Processed Jobs";
	        }
	        $scope.firms.forEach(function (firm) {
	          if (lawyer_job.jobData.firmFirmID === firm.firm_ID) {
	            lawyer_job.firmName = firm.user.firm_Name;
	            if (firm.user.profile_Picture === null) {
	              lawyer_job.picSrc = $scope.picSrc;
	            } else {
	              lawyer_job.picSrc = sharedProperties.getImgSrc(firm.user.profile_Picture, firm.user.user_ID, true);
	            }
	          }
	        });
	      });
	      $scope.isDataFetched = true;
	    };
	    var applicationstagelist = [{ "id": 2, "name": "Applied" }, { "id": 3, "name": "Shortlisted" }, { "id": 4, "name": "Submitted" }, { "id": 5, "name": "Interview" }, { "id": 6, "name": "Hired" }];
	    $scope.applicationPipeline = applicationstagelist;
	    $scope.fetchApplicationActiveTab = function (job_ID, stageid, parentid, status) {
	      if (stageid === parentid) {
	        // let color="#6ec56e";
	        var color = "#ffef00";
	        if (status == "Accepted") color = "#008000";else if (status == "Rejected by LexStep") color = "#ffa500";else if (status == "Employer Declined" || status == "Candidate Withdrew") color = "#ff0000";
	        var test = angular.element('#' + job_ID + stageid);
	        test.css('background', color);
	        if (test.length > 0) {
	          test[0].children[0].style.borderColor = color + " " + color + " transparent transparent";
	          test[0].children[0].style.boxShadow = "1.4px -1.4px 0px 0px " + color;
	        }
	      }
	    };
	    $scope.fetchLawyerJobs();
	  }]);
	})();

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _formatPqe = __webpack_require__(55);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable angular/window-service */
	/* eslint-disable angular/document-service */
	
	
	(function module() {
	  angular.module('app.ui.form.ctrls').controller('ApplicationListingController', ['logger', 'ApplicationsApi', 'SharedApi', 'ApplicationStagesApi', '$scope', '$rootScope', '$window', '$log', '$uibModal', '$sce', 'usSpinnerService', '$location', 'userService', 'CandidateProfileApi', 'socket', 'NotesApi', '$timeout', function controller(logger, ApplicationsApi, SharedApi, ApplicationStagesApi, $scope, $rootScope, $window, $log, $uibModal, $sce, usSpinnerService, $location, userService, CandidateProfileApi, socket, NotesApi, $timeout) {
	    var _this = this;
	
	    var onApplicationChange = function () {
	      var _ref25 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(parameter) {
	        var fieldName, headerName, applicationId;
	        return regeneratorRuntime.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                fieldName = parameter.colDef.field;
	                headerName = parameter.colDef.headerName;
	
	                if (!(parameter.newValue.trim() !== parameter.oldValue)) {
	                  _context12.next = 6;
	                  break;
	                }
	
	                applicationId = parameter.data.id;
	                _context12.next = 6;
	                return updateApplicationApi(headerName, applicationId, fieldName, parameter.newValue);
	
	              case 6:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, this);
	      }));
	
	      return function onApplicationChange(_x8) {
	        return _ref25.apply(this, arguments);
	      };
	    }();
	
	    var vm = this;
	
	    socket.on('APPLICATION_CREATE', function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(applicationId) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                  var _ref3, newApplication, formatApplication;
	
	                  return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          if (!$location.url().contains('application-listing')) {
	                            _context.next = 9;
	                            break;
	                          }
	
	                          _context.next = 3;
	                          return ApplicationsApi.getApplicationListing({
	                            id: applicationId
	                          });
	
	                        case 3:
	                          _ref3 = _context.sent;
	                          newApplication = _ref3.data;
	                          formatApplication = setApplicationsListingData(newApplication);
	
	
	                          vm.applicationListing = [].concat(_toConsumableArray(vm.applicationListing), _toConsumableArray(newApplication));
	                          vm.gridOptions.api.updateRowData({
	                            addIndex: vm.applicationListing.length,
	                            add: formatApplication
	                          });
	                          updateGridGroupPipeline();
	
	                        case 9:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this);
	                })), 1000);
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }());
	    socket.on('APPLICATION_UPDATE', function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(applicationId) {
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	                  var _ref6, updatedApplication, formatApplication, updateApplicationIndex, deletedApplication;
	
	                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                    while (1) {
	                      switch (_context3.prev = _context3.next) {
	                        case 0:
	                          if (!$location.url().contains('application-listing')) {
	                            _context3.next = 7;
	                            break;
	                          }
	
	                          _context3.next = 3;
	                          return ApplicationsApi.getApplicationListing({
	                            id: applicationId
	                          });
	
	                        case 3:
	                          _ref6 = _context3.sent;
	                          updatedApplication = _ref6.data;
	
	
	                          if (updatedApplication && updatedApplication.length > 0) {
	                            formatApplication = setApplicationsListingData(updatedApplication);
	                            updateApplicationIndex = vm.applicationListing.findIndex(function (_ref7) {
	                              var id = _ref7.id;
	                              return id === applicationId;
	                            });
	
	                            vm.applicationListing[updateApplicationIndex] = formatApplication[0];
	                            vm.gridOptions.api.updateRowData({ update: formatApplication });
	                          } else {
	                            deletedApplication = vm.applicationListing.filter(function (_ref8) {
	                              var id = _ref8.id;
	                              return id === applicationId;
	                            });
	
	                            vm.applicationListing = vm.applicationListing.filter(function (_ref9) {
	                              var id = _ref9.id;
	                              return id !== applicationId;
	                            });
	
	                            vm.gridOptions.api.updateRowData({ remove: deletedApplication });
	                            $rootScope.$broadcast('application-deleted', {
	                              applicationDeleted: applicationId
	                            });
	                          }
	
	                          updateGridGroupPipeline();
	
	                        case 7:
	                        case 'end':
	                          return _context3.stop();
	                      }
	                    }
	                  }, _callee3, _this);
	                })), 1000);
	
	              case 1:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this);
	      }));
	
	      return function (_x2) {
	        return _ref4.apply(this, arguments);
	      };
	    }());
	
	    socket.on('APPLICATION_DELETE', function () {
	      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(applicationId) {
	        return regeneratorRuntime.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	                  var deletedApplication;
	                  return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                    while (1) {
	                      switch (_context5.prev = _context5.next) {
	                        case 0:
	                          if ($location.url().contains('application-listing')) {
	                            vm.deletedApplicationId = applicationId;
	
	                            deletedApplication = vm.applicationListing.filter(function (_ref12) {
	                              var id = _ref12.id;
	                              return id === applicationId;
	                            });
	
	
	                            vm.gridOptions.api.updateRowData({ remove: deletedApplication });
	
	                            updateGridGroupPipeline();
	                          }
	
	                        case 1:
	                        case 'end':
	                          return _context5.stop();
	                      }
	                    }
	                  }, _callee5, _this);
	                })), 1000);
	
	              case 1:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this);
	      }));
	
	      return function (_x3) {
	        return _ref10.apply(this, arguments);
	      };
	    }());
	
	    socket.on('CANDIDATE_PROFILE_UPDATE', function () {
	      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(candidateId) {
	        return regeneratorRuntime.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
	                  var _ref15, updatedApplications, _ref17, schoolList, formatApplications;
	
	                  return regeneratorRuntime.wrap(function _callee7$(_context7) {
	                    while (1) {
	                      switch (_context7.prev = _context7.next) {
	                        case 0:
	                          if (!(vm.applicationListing.some(function (application) {
	                            return application.candidateId === candidateId;
	                          }) && $location.url().contains('application-listing'))) {
	                            _context7.next = 16;
	                            break;
	                          }
	
	                          _context7.next = 3;
	                          return ApplicationsApi.getApplicationListing({
	                            candidateId: candidateId
	                          });
	
	                        case 3:
	                          _ref15 = _context7.sent;
	                          updatedApplications = _ref15.data;
	
	                          if (!(updatedApplications && updatedApplications.length > 0)) {
	                            _context7.next = 16;
	                            break;
	                          }
	
	                          if (vm.schoolList.some(function (_ref16) {
	                            var id = _ref16.id;
	                            return id === updatedApplications[0].candidate.school;
	                          })) {
	                            _context7.next = 12;
	                            break;
	                          }
	
	                          _context7.next = 9;
	                          return SharedApi.getAllSchools();
	
	                        case 9:
	                          _ref17 = _context7.sent;
	                          schoolList = _ref17.data;
	
	                          vm.schoolList = schoolList;
	
	                        case 12:
	                          formatApplications = setApplicationsListingData(updatedApplications);
	
	
	                          formatApplications.forEach(function (application) {
	                            var index = vm.applicationListing.findIndex(function (_ref18) {
	                              var id = _ref18.id;
	                              return id === application.id;
	                            });
	                            vm.applicationListing[index] = application;
	                          });
	
	                          vm.gridOptions.api.updateRowData({ update: formatApplications });
	                          updateGridGroupPipeline();
	
	                        case 16:
	                        case 'end':
	                          return _context7.stop();
	                      }
	                    }
	                  }, _callee7, _this);
	                })), 1000);
	
	              case 1:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this);
	      }));
	
	      return function (_x4) {
	        return _ref13.apply(this, arguments);
	      };
	    }());
	
	    socket.on('EMPLOYER_UPDATE', function () {
	      var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(employerId) {
	        return regeneratorRuntime.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
	                  var _ref21, updatedApplications, formatApplications;
	
	                  return regeneratorRuntime.wrap(function _callee9$(_context9) {
	                    while (1) {
	                      switch (_context9.prev = _context9.next) {
	                        case 0:
	                          if (!(vm.applicationListing.some(function (application) {
	                            return application.employerId === employerId;
	                          }) && $location.url().contains('application-listing'))) {
	                            _context9.next = 6;
	                            break;
	                          }
	
	                          _context9.next = 3;
	                          return ApplicationsApi.getApplicationListing({
	                            employerId: employerId
	                          });
	
	                        case 3:
	                          _ref21 = _context9.sent;
	                          updatedApplications = _ref21.data;
	
	
	                          if (updatedApplications && updatedApplications.length > 0) {
	                            formatApplications = setApplicationsListingData(updatedApplications);
	
	
	                            formatApplications.forEach(function (application) {
	                              var index = vm.applicationListing.findIndex(function (_ref22) {
	                                var id = _ref22.id;
	                                return id === application.id;
	                              });
	                              vm.applicationListing[index] = application;
	                            });
	
	                            vm.gridOptions.api.updateRowData({ update: formatApplications });
	                            updateGridGroupPipeline();
	                          }
	
	                        case 6:
	                        case 'end':
	                          return _context9.stop();
	                      }
	                    }
	                  }, _callee9, _this);
	                })), 1000);
	
	              case 1:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this);
	      }));
	
	      return function (_x5) {
	        return _ref19.apply(this, arguments);
	      };
	    }());
	
	    var dateFilterParameters = {
	      suppressAndOrCondition: true,
	      inRangeInclusive: true,
	      comparator: function comparator(filterLocalDateAtMidnight, cellValue) {
	        var dateAsString = moment(cellValue).format('DD/MM/YYYY');
	        var dateParts = dateAsString.split('/');
	        var cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
	
	        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
	          return 0;
	        }
	
	        if (cellDate < filterLocalDateAtMidnight) {
	          return -1;
	        }
	
	        if (cellDate > filterLocalDateAtMidnight) {
	          return 1;
	        }
	      }
	
	      // eslint-disable-next-line unicorn/consistent-function-scoping
	    };function renderDateColumn(parameters) {
	      return parameters.value ? '<span>' + moment(parameters.value).format('DD-MMM-YYYY') + '</span>' : ' ';
	    }
	
	    // eslint-disable-next-line unicorn/consistent-function-scoping
	    function renderDateTimeColumn(parameters) {
	      return parameters.value ? '<span>' + moment(parameters.value).format('DD-MMM-YYYY HH:mm') + '</span>' : ' ';
	    }
	
	    var applicationStatusEnum = {
	      ACCEPTED: 'Accepted',
	      ACTIVE: 'Active',
	      WITHDRAWN: 'Candidate Withdrew',
	      DECLINED: 'Employer Declined',
	      REJECTED: 'Rejected by LexStep'
	    };
	
	    vm.applicationStatusList = [{
	      id: 1,
	      name: applicationStatusEnum.ACTIVE,
	      color: '#FFFF00'
	    }, {
	      id: 2,
	      name: applicationStatusEnum.REJECTED,
	      color: '#ffa500'
	    }, {
	      id: 3,
	      name: applicationStatusEnum.DECLINED,
	      color: '#ff0000'
	    }, {
	      id: 4,
	      name: applicationStatusEnum.WITHDRAWN,
	      color: '#ff0000'
	    }, {
	      id: 5,
	      name: applicationStatusEnum.ACCEPTED,
	      color: '#008000'
	    }];
	    Object.freeze(vm.applicationStatusList);
	
	    var columnDefs = [{
	      columnGroupShow: undefined,
	      headerCheckboxSelection: true,
	      headerCheckboxSelectionFilteredOnly: true,
	      checkboxSelection: true,
	      width: 134,
	      filter: false,
	      resizable: false
	    }, {
	      headerName: 'Candidate Details',
	      children: [{
	        headerName: 'Current Candidate Agent',
	        field: 'candidateAgentEmail'
	      }, {
	        headerName: 'Candidate ID',
	        field: 'candidate.id',
	        filter: 'agTextColumnFilter',
	        columnGroupShow: undefined
	      }]
	    }, {
	      headerName: 'Candidate Profile',
	      children: [{
	        headerName: 'Candidate Name',
	        field: 'candidateFullName',
	        columnGroupShow: undefined,
	        onCellClicked: openCandidateProfileModal,
	        cellRenderer: function cellRenderer(parameter) {
	          return parameter.value ? '<span class="text-info pointer"/>' + parameter.value + '</span>' : '';
	        },
	        filter: 'agTextColumnFilter'
	      }, {
	        headerName: 'Qualification Date',
	        field: 'candidate.qualificationDate',
	        cellRenderer: renderDateColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters
	      }, { headerName: 'PQE', field: 'candidate.pqe' }, { headerName: 'Current Location', field: 'candidate.location' }, { headerName: 'Languages', field: 'candidate.languages' }, {
	        headerName: 'Jurisdiction(s) of Qualification',
	        field: 'candidate.jurisdictions'
	      }, { headerName: 'University', field: 'candidate.school' }, { headerName: 'Nationality', field: 'candidate.nationality' }]
	    }, {
	      headerName: 'Candidate Experience',
	      children: [{
	        headerName: 'Current Employer',
	        field: 'currentExperience.employer.name',
	        columnGroupShow: undefined,
	        hide: true,
	        suppressSizeToFit: true
	      }, {
	        headerName: 'Current Employer Type',
	        field: 'currentExperience.employerType',
	        hide: true,
	        suppressSizeToFit: true
	      }, {
	        headerName: 'Current Employer Selectivity',
	        field: 'currentExperience.employer.selectivity',
	        hide: true,
	        suppressSizeToFit: true
	      }, {
	        headerName: 'Current Job Title',
	        field: 'currentExperience.jobTitle',
	        hide: true,
	        suppressSizeToFit: true
	      }, {
	        headerName: 'Current Practice Areas',
	        field: 'currentExperience.specialties',
	        hide: true,
	        suppressSizeToFit: true
	      }, {
	        headerName: 'Current Occupation',
	        field: 'currentExperience.occupation',
	        hide: true,
	        suppressSizeToFit: true
	      }, {
	        headerName: 'Current Contract',
	        field: 'currentExperience.contractType',
	        hide: true,
	        suppressSizeToFit: true
	      }, {
	        headerName: 'Current Salary Currency',
	        field: 'currentExperience.salary.salaryUnit',
	        hide: true,
	        suppressSizeToFit: true
	      }, {
	        headerName: 'Current Salary Amount',
	        field: 'currentExperience.salary.salaryAmount',
	        filter: 'agNumberColumnFilter',
	        hide: true,
	        suppressSizeToFit: true
	      }, {
	        headerName: 'Current Salary Period',
	        field: 'currentExperience.salary.salaryPeriod',
	        hide: true,
	        suppressSizeToFit: true
	      }, {
	        headerName: 'Current Bonus Currency',
	        field: 'currentExperience.salary.bonusUnit',
	        hide: true,
	        suppressSizeToFit: true
	      }, {
	        headerName: 'Current Bonus Amount',
	        field: 'currentExperience.salary.bonusAmount',
	        filter: 'agNumberColumnFilter',
	        hide: true,
	        suppressSizeToFit: true
	      }]
	    }, {
	      headerName: 'Target Employer Details',
	      children: [{
	        headerName: 'Employer',
	        field: 'employer.name',
	        columnGroupShow: undefined
	      }, {
	        headerName: 'Employer Selectivity',
	        field: 'employer.selectivity'
	      }, { headerName: 'Employer Type', field: 'employer.type' }, {
	        headerName: 'Current Employer Agent',
	        field: 'employerAgentEmail'
	      }]
	    }, {
	      headerName: 'Position Details',
	      children: [{
	        headerName: 'Position Title',
	        field: 'position.title',
	        cellRenderer: function cellRenderer(parameter) {
	          return parameter.value ? '<span class="text-info pointer"/>' + parameter.value + '</span>' : '';
	        },
	        columnGroupShow: undefined,
	        onCellClicked: openPositionDetailModal,
	        filter: 'agTextColumnFilter'
	      }, { headerName: 'Req. PQE', field: 'position.rPQE', width: 125 }, { headerName: 'Location', field: 'position.locations' }, { headerName: 'Practice Areas', field: 'position.specialties' }, { headerName: 'Contract', field: 'position.contractType' }, { headerName: 'Occupation', field: 'position.occupation' }, {
	        headerName: 'Regular ATS Link',
	        field: 'position.externalUrl',
	        filter: false,
	        cellRenderer: function cellRenderer(parameter) {
	          var positionUrl = parameter.value ? parameter.value.match(/http/) ? parameter.value : 'http://'.concat(parameter.value) : parameter.value;
	          return parameter.value ? '<span class="text-info pointer"/><a style="color:#4c9bda" href=' + positionUrl + ' target="_blank"/>' + parameter.value + '</span>' : '';
	        }
	      }]
	    }, {
	      headerName: 'Listing Details',
	      children: [{
	        headerName: 'LexStep Position ID',
	        field: 'position.id',
	        filter: 'agTextColumnFilter'
	      }, { headerName: '# Applicants', field: 'position.applicantCount' }, {
	        headerName: 'Listing Type',
	        field: 'position.type',
	        columnGroupShow: undefined
	      }, { headerName: 'Position Visibility', field: 'position.visible' }, {
	        headerName: 'Uploaded',
	        field: 'position.created',
	        cellRenderer: renderDateColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'Expired',
	        field: 'position.expiresAt',
	        cellRenderer: renderDateColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters
	      }]
	    }, {
	      headerName: 'Application Details',
	      children: [{
	        headerName: 'Application ID',
	        field: 'id',
	        columnGroupShow: undefined,
	        filter: 'agTextColumnFilter'
	      }, {
	        headerName: 'Internal Note',
	        field: 'note',
	        onCellClicked: openHistoryModal,
	        columnGroupShow: undefined,
	        filter: 'agTextColumnFilter',
	        cellClass: 'cellEditable'
	      }, {
	        headerName: 'Application Date',
	        field: 'created',
	        cellRenderer: renderDateColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'Submission Date',
	        field: 'submittedAt',
	        onCellDoubleClicked: openDateModal,
	        cellRenderer: renderDateColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters,
	        cellClass: 'cellEditable'
	      }, {
	        headerName: '1st Interview Date',
	        field: 'interview1Date',
	        onCellDoubleClicked: openDateModal,
	        cellRenderer: renderDateTimeColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters,
	        cellClass: 'cellEditable'
	      }, {
	        headerName: '2nd Interview Date',
	        field: 'interview2Date',
	        onCellDoubleClicked: openDateModal,
	        cellRenderer: renderDateTimeColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters,
	        cellClass: 'cellEditable'
	      }, {
	        headerName: '3rd Interview Date',
	        field: 'interview3Date',
	        onCellDoubleClicked: openDateModal,
	        cellRenderer: renderDateTimeColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters,
	        cellClass: 'cellEditable'
	      }, {
	        headerName: 'Offer {£ Value}',
	        field: 'offer',
	        editable: true,
	        onCellValueChanged: onApplicationChange,
	        filter: 'agTextColumnFilter',
	        cellClass: 'cellEditable'
	      }, {
	        headerName: 'Acceptance Date',
	        field: 'acceptedAt',
	        onCellDoubleClicked: openDateModal,
	        cellRenderer: renderDateColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters,
	        cellClass: 'cellEditable'
	      }, {
	        headerName: 'Start Date',
	        field: 'startDate',
	        onCellDoubleClicked: openDateModal,
	        cellRenderer: renderDateColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters,
	        cellClass: 'cellEditable'
	      }, {
	        headerName: 'Sponsorship required?',
	        field: 'sponsorship'
	      }, {
	        headerName: 'CV',
	        field: 'cvUrl',
	        onCellClicked: cvCellClicked,
	        filter: false,
	        columnGroupShow: undefined,
	        cellRenderer: function cellRenderer(parameter) {
	          if (parameter.value) return '<center class=""><img class="" style="width: 28px" src="/images/resume.png" /></center>';
	          if (parameter.value !== null) return '<center class=""><img class=" disabled-icon" style="width: 28px" src="/images/resume.png" /></center>';
	        },
	        width: 100
	      }, {
	        headerName: 'Stage',
	        field: 'parentApplicationStage',
	        rowGroupIndex: 0,
	        columnGroupShow: undefined
	      }, {
	        headerName: 'Sub-Stage',
	        field: 'applicationStage',
	        rowGroupIndex: 1,
	        editable: true,
	        columnGroupShow: undefined,
	        cellRenderer: 'subStageCellRenderer',
	        cellEditor: 'agRichSelectCellEditor',
	        onCellValueChanged: onApplicationChange,
	        cellEditorParams: {
	          values: [],
	          cellRenderer: 'subStageCellRenderer'
	        },
	        cellClass: 'cellEditable'
	      }, {
	        headerName: 'Last Stage Change',
	        field: 'lastStageChangeAt',
	        cellRenderer: renderDateColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'Status',
	        field: 'status',
	        rowGroupIndex: 2,
	        editable: true,
	        columnGroupShow: undefined,
	        cellRenderer: 'statusCellRenderer',
	        cellEditor: 'agRichSelectCellEditor',
	        onCellValueChanged: onApplicationChange,
	        cellEditorParams: {
	          values: vm.applicationStatusList.map(function (status) {
	            return status.name;
	          }),
	          cellRenderer: 'statusCellRenderer'
	        },
	        cellClass: 'cellEditable'
	      }, {
	        headerName: 'Admin Followers',
	        field: 'applicationAgentEmail',
	        onCellDoubleClicked: openAgentFollowersModal,
	        cellClass: 'cellEditable'
	      }, {
	        headerName: 'Feedback To Candidate',
	        field: 'feedback',
	        editable: true,
	        filter: 'agTextColumnFilter',
	        cellEditor: 'agLargeTextCellEditor',
	        onCellValueChanged: onApplicationChange,
	        cellClass: 'cellEditable'
	      }, {
	        headerName: 'Source',
	        field: 'isOffPlatform',
	        columnGroupShow: undefined,
	        width: 120
	      }, {
	        headerName: 'Application Candidate Agent',
	        field: 'applicationCandidateAgentEmail'
	      }, {
	        headerName: 'Application Employer Agent',
	        field: 'applicationEmployerAgentEmail'
	      }, {
	        headerName: 'Application History',
	        field: 'history',
	        filter: false,
	        cellRenderer: function cellRenderer() {
	          return '<center><span class="fa fa-history"/></center>';
	        },
	        onCellClicked: openHistoryModal
	      }]
	    }];
	
	    var gridOptions = {
	      defaultColDef: {
	        sortable: true,
	        filter: true,
	        enablePivot: true,
	        enableRowGroup: true,
	        enableValue: true,
	        columnGroupShow: 'open',
	        resizable: true,
	        menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab']
	      },
	      postProcessPopup: function postProcessPopup(parameters) {
	        // Check callback is for menu
	        if (parameters.type !== 'columnMenu') {
	          return;
	        }
	
	        var columnId = parameters.column.getId();
	        if (columnId === 'position.specialties' || columnId === 'currentExperience.specialties') {
	          parameters.ePopup.style.width = '350px';
	        }
	      },
	      onFilterChanged: onFilterChanged,
	      onGridReady: function onGridReady() {
	        initializeApplicationListing();
	      },
	      groupRowRenderer: 'agGroupCellRenderer',
	      groupRowRendererParams: {
	        checkbox: true
	      },
	      getRowStyle: function getRowStyle(parameters) {
	        if (!parameters.data && parameters.node.field === 'applicationStage') {
	          return {
	            background: hexToRGB(vm.applicationSubStagesList.find(function (row) {
	              return row.name === parameters.node.key;
	            }).color, 0.2)
	          };
	        }
	      },
	      floatingFilter: true,
	      suppressCsvExport: true,
	      groupDefaultExpanded: -1,
	      groupUseEntireRow: true,
	      defaultGroupSortComparator: function defaultGroupSortComparator(nodeA, nodeB) {
	        if (nodeA.field !== 'applicationStage' && nodeB.field !== 'parentApplicationStage') {
	          if (nodeA.key < nodeB.key) {
	            return -1;
	          }
	
	          if (nodeA.key > nodeB.key) {
	            return 1;
	          }
	
	          return 0;
	        }
	      },
	      columnDefs: columnDefs,
	      animateRows: true,
	      getRowNodeId: function getRowNodeId(data) {
	        return data.id;
	      },
	      enableCellChangeFlash: true,
	      groupSelectsChildren: true,
	      rowData: vm.applicationListing,
	      rowSelection: 'multiple',
	      rowGroupPanelShow: 'always',
	      pivotPanelShow: 'always',
	      groupSelectsFiltered: true,
	      sideBar: {
	        toolPanels: ['columns', 'filters'],
	        defaultToolPanel: false
	      },
	      statusBar: {
	        statusPanels: [{ statusPanel: 'agTotalRowCountComponent', align: 'left' }, { statusPanel: 'agFilteredRowCountComponent', align: 'left' }, { statusPanel: 'agSelectedRowCountComponent' }, { statusPanel: 'agAggregationComponent' }]
	      },
	      overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your data is loading</span>',
	      onSelectionChanged: onSelectionChanged,
	      onColumnRowGroupChanged: updateGridGroupPipeline,
	      components: {
	        statusCellRenderer: StatusCellRenderer,
	        subStageCellRenderer: SubStageCellRenderer
	      },
	      suppressCopyRowsToClipboard: true,
	      enableRangeSelection: true,
	      enableCharts: true,
	      getContextMenuItems: getContextMenuItems
	
	      // eslint-disable-next-line unicorn/consistent-function-scoping
	    };function StatusCellRenderer() {}
	    StatusCellRenderer.prototype.init = function (parameter) {
	      vm.eGui = document.createElement('div');
	      var status = vm.applicationStatusList.find(function (status) {
	        return status.name === parameter.value;
	      });
	      vm.eGui.innerHTML = '<span class="round-circle" style="background:' + status.color + ';"> </span>' + '<span> ' + parameter.value + '</span>';
	    };
	
	    StatusCellRenderer.prototype.getGui = function () {
	      return vm.eGui;
	    };
	
	    // eslint-disable-next-line unicorn/consistent-function-scoping
	    function SubStageCellRenderer() {}
	    SubStageCellRenderer.prototype.init = function (parameter) {
	      vm.eGui = document.createElement('div');
	      var stage = vm.applicationSubStagesList.find(function (stage) {
	        return stage.name === parameter.value;
	      });
	      if (stage) {
	        vm.eGui.innerHTML = '<span class="round-circle" style="background:' + stage.color + ';"> </span>' + '<span> ' + parameter.value + '</span>';
	      }
	    };
	
	    SubStageCellRenderer.prototype.getGui = function () {
	      return vm.eGui;
	    };
	
	    var startSpinner = function startSpinner(name) {
	      return usSpinnerService.spin(name);
	    };
	    var stopSpinner = function stopSpinner(name) {
	      return usSpinnerService.stop(name);
	    };
	    function cvCellClicked(parameter) {
	      if (parameter.data.cvUrl) getApplicationResume(parameter.data.id, parameter.data.cvUrl);
	    }
	
	    vm.applicationsResume = [];
	    var getApplicationResume = function () {
	      var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(applicationId, cvUrl) {
	        var resumeFound, _ref24, status, resume, arrayBufferView, blob, urlCreator, resumeUrl;
	
	        return regeneratorRuntime.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                vm.showCv = { applicationId: applicationId };
	                vm.showCv.isDoc = false;
	                if (cvUrl.includes('.doc')) {
	                  vm.showCv.isDoc = true;
	                } else vm.splitGrid(true);
	
	                resumeFound = vm.applicationsResume.find(function (resume) {
	                  return resume.applicationId === applicationId;
	                });
	
	                if (!resumeFound) {
	                  _context11.next = 9;
	                  break;
	                }
	
	                vm.showCv.path = $sce.trustAsResourceUrl(resumeFound.url);
	
	                if (vm.showCv.isDoc) vm.downloadDocFormatCV(cvUrl, vm.showCv.path, applicationId);else vm.showCv.display = vm.showCv.path;
	                _context11.next = 16;
	                break;
	
	              case 9:
	                startSpinner('spinner-resume');
	                _context11.next = 12;
	                return ApplicationsApi.getApplicationResume(applicationId);
	
	              case 12:
	                _ref24 = _context11.sent;
	                status = _ref24.status;
	                resume = _ref24.data;
	
	                if (status === 200) {
	                  if (resume.statusCode === 404) {
	                    if (cvUrl.includes('.doc')) vm.splitGrid(true);
	
	                    vm.showCv.isNotFound = true;
	                  } else {
	                    arrayBufferView = new Uint8Array(resume.data);
	                    blob = vm.showCv.isDoc ? new Blob([arrayBufferView], {
	                      type: 'application/msword;base64'
	                    }) : new Blob([arrayBufferView], {
	                      type: 'application/pdf;base64'
	                    });
	                    urlCreator = $window.URL || $window.webkitURL;
	                    resumeUrl = urlCreator.createObjectURL(blob);
	
	                    vm.showCv.path = $sce.trustAsResourceUrl(resumeUrl);
	                    if (vm.showCv.isDoc) vm.downloadDocFormatCV(cvUrl, vm.showCv.path, applicationId);else vm.showCv.display = vm.showCv.path;
	
	                    vm.applicationsResume = [].concat(_toConsumableArray(vm.applicationsResume), [{
	                      applicationId: applicationId,
	                      url: resumeUrl
	                    }]);
	                  }
	
	                  stopSpinner('spinner-resume');
	                }
	
	              case 16:
	
	                $scope.$applyAsync();
	
	              case 17:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, _this);
	      }));
	
	      return function getApplicationResume(_x6, _x7) {
	        return _ref23.apply(this, arguments);
	      };
	    }();
	
	    vm.downloadDocFormatCV = function (cvUrl, path, applicationId) {
	      var format = cvUrl.split('.').slice(1).join('');
	
	      var a = document.createElement('a');
	      document.body.append(a);
	      a.style = 'display: none';
	      a.href = path;
	      a.download = 'application-' + applicationId + '.' + format;
	      a.click();
	    };
	
	    vm.splitGrid = function (value) {
	      vm.showCv.isShow = value;
	      var agGridListingDiv = document.querySelector('#' + vm.gridName);
	      var cvDiv = document.querySelector('#myCV');
	      agGridListingDiv.style.height = window.innerHeight - 235 + 'px';
	      agGridListingDiv.style.padding = 0;
	      cvDiv.style.height = window.innerHeight - 235 + 'px';
	      if (value) {
	        agGridListingDiv.style.width = '65%';
	        agGridListingDiv.classList.add('col-md-7');
	      } else agGridListingDiv.style.width = '100%';
	    };
	
	    var updateApplicationApi = function () {
	      var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(headerName, id, fieldName, value) {
	        var applicationExist, selectedRow, stageIdValue, stageIdName, payload, _ref28, data, status, applicationStage;
	
	        return regeneratorRuntime.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                _context13.prev = 0;
	                applicationExist = vm.deletedApplicationId ? isApplicationExist(vm.deletedApplicationId, vm) : true;
	
	                if (!applicationExist) {
	                  _context13.next = 14;
	                  break;
	                }
	
	                selectedRow = vm.gridOptions.api.getSelectedRows();
	                stageIdValue = void 0;
	                stageIdName = void 0;
	
	                if (fieldName === 'applicationStage') {
	                  stageIdName = 'stageId';
	                  stageIdValue = vm.applicationSubStagesList.find(function (_ref27) {
	                    var name = _ref27.name;
	                    return name === value;
	                  }).id;
	                }
	
	                payload = _defineProperty({}, stageIdName ? stageIdName : fieldName, stageIdValue ? stageIdValue : value);
	                _context13.next = 10;
	                return ApplicationsApi.updateApplicationById(id, payload);
	
	              case 10:
	                _ref28 = _context13.sent;
	                data = _ref28.data;
	                status = _ref28.status;
	
	                if (status === 200) {
	                  logger.notify('success', 'Application Id: ' + id + ' ' + headerName + ': ' + (value === null ? ' deleted' : 'value: "' + value + '" updated') + ' successfully');
	                  if (fieldName === 'applicationStage') {
	                    selectedRow[0].lastStageChangeAt = data.lastStageChangeAt;
	                    selectedRow[0].stageId = data.stageId;
	                    applicationStage = vm.applicationSubStagesList.find(function (_ref29) {
	                      var id = _ref29.id;
	                      return data.stageId === id;
	                    });
	
	                    selectedRow[0].applicationStage = applicationStage.name;
	                    selectedRow[0].parentApplicationStage = vm.allApplicationStagesList.find(function (_ref30) {
	                      var id = _ref30.id;
	                      return applicationStage.parentId === id;
	                    }).name;
	                  } else selectedRow[0][fieldName] = value;
	
	                  vm.gridOptions.api.updateRowData({ update: selectedRow });
	                  updateGridGroupPipeline();
	                } else {
	                  logger.notify('error', 'Application Deleted by Other Admin');
	                }
	
	              case 14:
	                _context13.next = 19;
	                break;
	
	              case 16:
	                _context13.prev = 16;
	                _context13.t0 = _context13['catch'](0);
	
	                logger.notify('error', _context13.t0.data.message);
	
	              case 19:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, _this, [[0, 16]]);
	      }));
	
	      return function updateApplicationApi(_x9, _x10, _x11, _x12) {
	        return _ref26.apply(this, arguments);
	      };
	    }();
	
	    function openHistoryModal(parameter) {
	      var applicationHistoryModalInstance = $uibModal.open({
	        templateUrl: 'application-history-modal.html',
	        controller: 'ApplicationHistoryController',
	        controllerAs: 'ctrl',
	        windowClass: 'application-history-modal',
	        backdrop: 'static',
	        resolve: {
	          isNote: function isNote() {
	            return parameter.colDef.field === 'note';
	          },
	          applicationId: function applicationId() {
	            return parameter.data.id;
	          },
	          agentsList: function agentsList() {
	            return vm.agentsList;
	          },
	          isOffPlatform: function isOffPlatform() {
	            return parameter.data.isOffPlatform;
	          },
	          stagesList: function stagesList() {
	            return vm.allApplicationStagesList;
	          },
	          enableMasterGrid: function enableMasterGrid() {
	            return false;
	          }
	        }
	      });
	      applicationHistoryModalInstance.result.then(function (latestNote) {
	        var selectedRow = [Object.assign(parameter.data, { note: latestNote })];
	        vm.gridOptions.api.updateRowData({
	          update: selectedRow
	        });
	      }, function () {});
	    }
	
	    function openDateModal(parameter) {
	      var _this2 = this;
	
	      var fieldName = parameter.colDef.field;
	      var headerName = parameter.colDef.headerName;
	      vm.dateModal = {
	        title: headerName,
	        date: parameter.value ? new Date(parameter.value) : new Date(),
	        isDate: fieldName.contains('interview'),
	        isDelete: Boolean(parameter.value)
	      };
	      var modalInstance = $uibModal.open({
	        templateUrl: 'date-modal.html',
	        controller: 'DateModalController',
	        controllerAs: 'ctrl',
	        resolve: {
	          selectedModal: function selectedModal() {
	            return vm.dateModal;
	          },
	          id: function id() {
	            return parameter.data.id;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        var _ref31 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(selectedDate) {
	          return regeneratorRuntime.wrap(function _callee14$(_context14) {
	            while (1) {
	              switch (_context14.prev = _context14.next) {
	                case 0:
	                  _context14.next = 2;
	                  return selectedDate.isDeleted ? updateApplicationApi(headerName, parameter.data.id, fieldName,
	                  // eslint-disable-next-line unicorn/no-null
	                  null) : updateApplicationApi(headerName, parameter.data.id, fieldName, selectedDate.date);
	
	                case 2:
	                case 'end':
	                  return _context14.stop();
	              }
	            }
	          }, _callee14, _this2);
	        }));
	
	        return function (_x13) {
	          return _ref31.apply(this, arguments);
	        };
	      }(), function () {});
	    }
	
	    function openAgentFollowersModal(parameter) {
	      var headerName = parameter.colDef.headerName;
	      var applicationAgentModalInstance = $uibModal.open({
	        templateUrl: 'application-agent-modal.html',
	        controller: 'ApplicationAgentController',
	        controllerAs: 'ctrl',
	        resolve: {
	          applicationId: function applicationId() {
	            return parameter.data.id;
	          },
	          consultant: function consultant() {
	            return {
	              employerAgentEmail: parameter.data.employerAgentEmail,
	              candidateAgentEmail: parameter.data.candidateAgentEmail
	            };
	          },
	          applicationAgent: function applicationAgent() {
	            return parameter.value;
	          },
	          agentsList: function agentsList() {
	            return vm.agentsList;
	          }
	        }
	      });
	      applicationAgentModalInstance.result.then(function (selectedAgent) {
	        if (selectedAgent) {
	          logger.notify('success', 'Application Id: ' + parameter.data.id + ' ' + headerName + ' updated successfully');
	          setApplicationAgentEmail(parameter.data, vm, selectedAgent);
	          vm.gridOptions.api.updateRowData({ update: [parameter.data] });
	          updateGridGroupPipeline();
	        }
	      }, function () {});
	    }
	
	    function openCandidateProfileModal(parameter) {
	      if (parameter.data.candidate) {
	        vm.candidateProfile(parameter.data.candidate.id);
	      }
	    }
	
	    vm.candidateProfile = function (code) {
	      $uibModal.open({
	        templateUrl: 'candidateProfileModal.html',
	        windowClass: 'app-candidate-profile-modal-window',
	        controller: 'CandidateProfileModalController',
	        resolve: {
	          data: function data() {
	            return code;
	          }
	        }
	      });
	    };
	
	    function openPositionDetailModal(parameter) {
	      if (parameter.data.position) {
	        positionDetailModal(parameter.data.position, parameter.data.employer);
	      }
	    }
	
	    var positionDetailModal = function positionDetailModal(_position, employer) {
	      _position.employer = employer;
	      $uibModal.open({
	        templateUrl: 'position-details-modal.html',
	        windowClass: 'position-modal-window',
	        controller: 'PositionDetailsController',
	        controllerAs: 'ctrl',
	        resolve: {
	          position: function position() {
	            return _position;
	          },
	          listingName: function listingName() {
	            return vm.gridName;
	          }
	        }
	      });
	    };
	
	    function onSelectionChanged() {
	      vm.selectedRows = vm.gridOptions.api.getSelectedRows();
	      vm.selectedRowsLength = vm.selectedRows.length;
	      hideShowDropdownActionItem();
	    }
	
	    function onFilterChanged() {
	      vm.filterCount = Object.keys(vm.gridOptions.api.getFilterModel()).length;
	      var filterTextBoxValue = document.querySelector('#filter-text-box').value;
	      if (filterTextBoxValue.length > 0) {
	        vm.filterCount += 1;
	      }
	
	      updatePipelineCountFromGrid();
	    }
	
	    // TODO: on grid functionality
	    function updatePipelineCountFromGrid() {
	      vm.gridOptions.api.forEachNode(function (node) {
	        if (node.key) {
	          vm.groupList.map(function (row) {
	            if (row.id === node.id) {
	              row.applicationsCount = node.allChildrenCount;
	              return row;
	            }
	
	            return row;
	          });
	        }
	      });
	      $scope.$applyAsync();
	    }
	
	    // TODO: on grid action items functionality
	    function updateGridGroupPipeline() {
	      vm.groupList = [];
	
	      vm.gridOptions.api.forEachNode(function (node) {
	        if (node.key) {
	          var hasChild = true;
	          if (_.isEmpty(node.childrenMapped) || 'undefined' in node.childrenMapped) hasChild = false;
	          vm.groupList.push({
	            name: node.key,
	            applicationsCount: node.allChildrenCount,
	            color: node.leafGroup ? '#' + Math.trunc(Math.random() * 0xffffff).toString(16) : lighten('#5e5e5e', (node.level + 1) * 10),
	            id: node.id,
	            intId: Number(node.id) * -1,
	            level: node.level,
	            parentID: node.parent.id,
	            hasChild: hasChild,
	            isHidden: node.level !== 0
	          });
	        }
	      });
	      $log.debug('vm.groupList', vm.groupList);
	      $scope.$applyAsync();
	    }
	
	    var hideShowDropdownActionItem = function hideShowDropdownActionItem() {
	      vm.multiSelectOptions = undefined;
	
	      var functionName = vm.actionsFunctions[0].funcName;
	      var hideAccounts = vm.actionsFunctions[0].hideAccounts;
	      vm.actionsFunctions = [{
	        funcName: functionName,
	        leftClick: vm.hideAccounts,
	        values: vm.applicationListing,
	        hideAccounts: hideAccounts
	      }];
	      if (vm.selectedRowsLength > 0) {
	        vm.multiSelectOptions = [{
	          count: vm.selectedRowsLength
	        }, {
	          funcName: 'Clear Selection',
	          function: vm.clearSelection
	        }];
	        var _functionName = vm.actionsFunctions[0].funcName;
	        var _hideAccounts = vm.actionsFunctions[0].hideAccounts;
	        vm.actionsFunctions = [{
	          funcName: _functionName,
	          leftClick: vm.hideAccounts,
	          values: vm.applicationListing,
	          hideAccounts: _hideAccounts
	        }, {
	          funcName: 'Mass Delete',
	          leftClick: vm.deleteApplicationModal,
	          visible: true,
	          funcParameter: 'Application(s)',
	          masterOnly: vm.isAllowedAgent()
	        }];
	        vm.gridDataActions = [{
	          count: vm.selectedRowsLength
	        }];
	      }
	
	      $scope.$applyAsync();
	    };
	
	    var dropdownApplicationStatus = function () {
	      var _ref32 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(selectedStatus) {
	        var selectedRows, selectedApplicationIds, result;
	        return regeneratorRuntime.wrap(function _callee15$(_context15) {
	          while (1) {
	            switch (_context15.prev = _context15.next) {
	              case 0:
	                selectedRows = vm.gridOptions.api.getSelectedRows();
	                selectedApplicationIds = selectedRows.map(function (x) {
	                  return x.id;
	                });
	                _context15.next = 4;
	                return updateBulkApplicationsApi(selectedApplicationIds, selectedStatus.name, 'status');
	
	              case 4:
	                result = _context15.sent;
	
	
	                if (result === 200) {
	                  selectedRows.map(function (row) {
	                    row.status = selectedStatus.name;
	                    return row;
	                  });
	                  vm.gridOptions.api.updateRowData({ update: selectedRows });
	                  updateGridGroupPipeline();
	                  logger.notify('success', selectedApplicationIds.length + ' Application' + (selectedApplicationIds.length > 1 ? 's ' : ' ') + '\n              updated status to "' + selectedStatus.name + '"\n              ');
	
	                  vm.gridOptions.api.deselectAll();
	                  $('#applicationStatusDropdownList').hide();
	                }
	
	              case 6:
	              case 'end':
	                return _context15.stop();
	            }
	          }
	        }, _callee15, _this);
	      }));
	
	      return function dropdownApplicationStatus(_x14) {
	        return _ref32.apply(this, arguments);
	      };
	    }();
	
	    var dropdownApplicationStage = function () {
	      var _ref33 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(selectedStage) {
	        var selectedRows, selectedApplicationIds, result, parentStage;
	        return regeneratorRuntime.wrap(function _callee16$(_context16) {
	          while (1) {
	            switch (_context16.prev = _context16.next) {
	              case 0:
	                selectedRows = vm.gridOptions.api.getSelectedRows();
	                selectedApplicationIds = selectedRows.map(function (x) {
	                  return x.id;
	                });
	                _context16.next = 4;
	                return updateBulkApplicationsApi(selectedApplicationIds, selectedStage.id, 'stageId');
	
	              case 4:
	                result = _context16.sent;
	
	
	                if (result === 200) {
	                  parentStage = vm.allApplicationStagesList.find(function (_ref34) {
	                    var id = _ref34.id;
	                    return selectedStage.parentId === id;
	                  }).name;
	
	                  selectedRows.map(function (row) {
	                    row.applicationStage = selectedStage.name;
	                    row.parentApplicationStage = parentStage;
	                    return row;
	                  });
	                  vm.gridOptions.api.updateRowData({ update: selectedRows });
	                  updateGridGroupPipeline();
	                  logger.notify('success', selectedApplicationIds.length + ' Application' + (selectedApplicationIds.length > 1 ? 's ' : ' ') + '\n              updated stage to "' + selectedStage.name + '"');
	                  vm.gridOptions.api.deselectAll();
	                  $('#applicationStageDropdownList').hide();
	                }
	
	              case 6:
	              case 'end':
	                return _context16.stop();
	            }
	          }
	        }, _callee16, _this);
	      }));
	
	      return function dropdownApplicationStage(_x15) {
	        return _ref33.apply(this, arguments);
	      };
	    }();
	
	    var updateBulkApplicationsApi = function () {
	      var _ref35 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(applicationIds, selectedValue, column) {
	        var payload, _ref36, status;
	
	        return regeneratorRuntime.wrap(function _callee17$(_context17) {
	          while (1) {
	            switch (_context17.prev = _context17.next) {
	              case 0:
	                payload = _defineProperty({ applicationIds: applicationIds }, column, selectedValue);
	                _context17.prev = 1;
	                _context17.next = 4;
	                return ApplicationsApi.bulkApplicationUpdate(payload);
	
	              case 4:
	                _ref36 = _context17.sent;
	                status = _ref36.status;
	
	                if (!(status === 200)) {
	                  _context17.next = 8;
	                  break;
	                }
	
	                return _context17.abrupt('return', status);
	
	              case 8:
	                _context17.next = 13;
	                break;
	
	              case 10:
	                _context17.prev = 10;
	                _context17.t0 = _context17['catch'](1);
	
	                logger.notify('error', _context17.t0.data.message);
	
	              case 13:
	              case 'end':
	                return _context17.stop();
	            }
	          }
	        }, _callee17, _this, [[1, 10]]);
	      }));
	
	      return function updateBulkApplicationsApi(_x16, _x17, _x18) {
	        return _ref35.apply(this, arguments);
	      };
	    }();
	
	    vm.gridActionsDirective = {
	      applicationStatus: {
	        function: dropdownApplicationStatus,
	        applicationStatusList: vm.applicationStatusList
	      }
	    };
	
	    vm.deleteApplicationModal = function () {
	      var selectedRows = vm.gridOptions.api.getSelectedRows();
	      var selectedApplicationIds = selectedRows.map(function (x) {
	        return x.id;
	      });
	      var deleteModalInstance = $uibModal.open({
	        templateUrl: 'delete-application-modal.html',
	        controller: 'DeleteApplicationController',
	        controllerAs: 'ctrl',
	        resolve: {
	          type: function type() {
	            return 'Application(s)';
	          },
	          applicationIds: function applicationIds() {
	            return selectedApplicationIds;
	          }
	        }
	      });
	      deleteModalInstance.result.then(function () {
	        logger.notify('success', selectedApplicationIds.length + ' Application' + (selectedApplicationIds.length > 1 ? 's ' : ' ') + ' Deleted Successfully!');
	        vm.gridOptions.api.updateRowData({ remove: selectedRows });
	        selectedRows.forEach(function (row) {
	          vm.applicationListing.splice(_.findIndex(vm.applicationListing, row), 1);
	        });
	        updateGridGroupPipeline();
	      }, function () {});
	    };
	
	    function getContextMenuItems(parameter) {
	      var result = [{
	        name: 'Open profile in new tab ',
	        action: function action() {
	          $window.open('/admin/lawyer-profile?user=' + parameter.node.data.candidate.id, '_blank');
	        }
	      }, {
	        name: 'Expand All Columns',
	        action: function action() {
	          var columnApi = gridOptions.columnApi.getColumnGroupState();
	          columnApi.forEach(function (item) {
	            gridOptions.columnApi.setColumnGroupOpened(item.groupId, true);
	          });
	        }
	      }, {
	        name: 'Collapse All Columns',
	        action: function action() {
	          var columnApi = gridOptions.columnApi.getColumnGroupState();
	          columnApi.forEach(function (item) {
	            gridOptions.columnApi.setColumnGroupOpened(item.groupId, false);
	          });
	        }
	      }, 'separator', 'copy', 'copyWithHeaders', 'separator', 'chartRange'];
	      vm.isExportAllowed = vm.user.roles.some(function (role) {
	        return role.id === 'admin' || role.id === 'ops';
	      });
	      if (vm.isExportAllowed) result.push('export');
	      return result;
	    }
	
	    vm.hideAccounts = function () {
	      var currentActiveFilters = vm.gridOptions.api.getFilterModel();
	      if (vm.actionsFunctions[0].hideAccounts === true) {
	        var hiddenData = vm.applicationListing.filter(function (application) {
	          return application.user.email && application.user.email.toLowerCase().includes('@lexstep') === false && application.user.email && application.user.email.toLowerCase().includes('@emumba') === false;
	        });
	        vm.gridOptions.api.setRowData(hiddenData);
	      } else {
	        vm.gridOptions.api.setRowData(vm.applicationListing);
	      }
	
	      vm.gridOptions.api.setFilterModel(currentActiveFilters);
	      vm.actionsFunctions[0].hideAccounts = !vm.actionsFunctions[0].hideAccounts;
	      if (vm.actionsFunctions[0].funcName === 'Hide Test Accounts') vm.actionsFunctions[0].funcName = 'Show Test Accounts';else vm.actionsFunctions[0].funcName = 'Hide Test Accounts';
	      vm.gridOptions.api.deselectAll();
	      onSelectionChanged();
	      updateGridGroupPipeline();
	    };
	
	    vm.gridOptions = gridOptions;
	
	    vm.gridName = 'application';
	    vm.filterCount = 0;
	    vm.helpTooltip = {
	      name: 'Help',
	      content: $sce.trustAsHtml(applicationHelpContent)
	    };
	    vm.actionsFunctions = [{
	      funcName: 'Hide Test Accounts',
	      leftClick: vm.hideAccounts,
	      values: vm.applicationListing,
	      hideAccounts: true
	    }];
	
	    vm.hideDropDown = function () {
	      vm.showClass = '';
	    };
	
	    vm.showClass = '';
	    vm.showDropDown = function () {
	      if (vm.showClass === '') {
	        vm.showClass = 'show';
	      } else {
	        vm.showClass = '';
	      }
	    };
	
	    vm.isAllowedAgent = function () {
	      return vm.user.roles.some(function (role) {
	        return role.id === 'admin' || role.id === 'ops';
	      });
	    };
	
	    vm.loadActiveApplicationsListing = function (applicationRecord) {
	      vm.applicationListing = setApplicationsListingData(applicationRecord);
	      vm.updateApplicationStageAction(vm.applicationStagesHierarchialList);
	      vm.gridOptions.api.setRowData(vm.applicationListing);
	
	      updateGridGroupPipeline();
	      $scope.$apply();
	    };
	
	    vm.loadInactiveApplicationsListing = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
	      var footer, _ref38, _ref39, acceptedApplication, rejectedApplication, declinedApplication, withdrawnApplication, formatInactiveApplicationsChunk;
	
	      return regeneratorRuntime.wrap(function _callee18$(_context18) {
	        while (1) {
	          switch (_context18.prev = _context18.next) {
	            case 0:
	              formatInactiveApplicationsChunk = function formatInactiveApplicationsChunk(array, currentIndex) {
	                if (currentIndex >= array.length) {
	                  vm.applicationListing = [].concat(_toConsumableArray(vm.applicationListing), _toConsumableArray(vm.formattedApplications));
	                  vm.gridOptions.api.updateRowData({
	                    add: vm.formattedApplications
	                  });
	                  $rootScope.$broadcast('listing-loaded');
	
	                  footer.innerHTML = '<div style="text-align: center;align-self: center; display: flex;">\n              <i class="fa fa-check" style="font-size:20px; color:green" aria-hidden="true"></i>\n              <span style="padding-left: 15px" align-self: center;">Loaded In Active Application Successfully</span>\n              </div>';
	                  var existingFilters = vm.gridOptions.api.getFilterModel();
	                  if (Object.keys(existingFilters).length === 0) {
	                    var filter = {
	                      status: { values: ['Active'], filterType: 'set' }
	                    };
	                    vm.gridOptions.api.setFilterModel(filter);
	                  }
	
	                  updateGridGroupPipeline();
	                  $timeout(function () {
	                    footer.innerHTML = '';
	                  }, 1500);
	                  return;
	                }
	
	                var formattedApplications = setApplicationsListingData(array[currentIndex]);
	
	                vm.formattedApplications = [].concat(_toConsumableArray(vm.formattedApplications), _toConsumableArray(formattedApplications));
	
	                ++currentIndex;
	
	                $timeout(function () {
	                  formatInactiveApplicationsChunk(array, currentIndex);
	                }, 1);
	              };
	
	              vm.inActiveApplications = [];
	              vm.formattedApplications = [];
	
	              footer = document.querySelector('#' + vm.gridName).querySelector('.ag-status-bar-center');
	
	              footer.innerHTML = '<div style="text-align: center;align-self: center; display: flex;">\n                              <div class="agGridLoader"></div>\n                              <span style="padding-left: 15px">Loading In-Active Applications</span>\n                            </div> ';
	
	              _context18.next = 7;
	              return Promise.all([ApplicationsApi.getApplicationListing({
	                status: applicationStatusEnum.ACCEPTED
	              }), ApplicationsApi.getApplicationListing({
	                status: applicationStatusEnum.REJECTED
	              }), ApplicationsApi.getApplicationListing({
	                status: applicationStatusEnum.DECLINED
	              }), ApplicationsApi.getApplicationListing({
	                status: applicationStatusEnum.WITHDRAWN
	              })]);
	
	            case 7:
	              _ref38 = _context18.sent;
	              _ref39 = _slicedToArray(_ref38, 4);
	              acceptedApplication = _ref39[0].data;
	              rejectedApplication = _ref39[1].data;
	              declinedApplication = _ref39[2].data;
	              withdrawnApplication = _ref39[3].data;
	
	
	              vm.inActiveApplications = [].concat(_toConsumableArray(vm.inActiveApplications), _toConsumableArray(acceptedApplication), _toConsumableArray(rejectedApplication), _toConsumableArray(declinedApplication), _toConsumableArray(withdrawnApplication));
	
	              formatInactiveApplicationsChunk(splitArrayIntoChunksOfLength(vm.inActiveApplications, 1000), 0);
	
	            case 15:
	            case 'end':
	              return _context18.stop();
	          }
	        }
	      }, _callee18, _this);
	    }));
	
	    var setApplicationsListingData = function setApplicationsListingData(applicationRecord) {
	      return applicationRecord.map(function (data) {
	        setEmployerColumnsData(data, vm);
	        setCandidateColumnsData(data, vm);
	        setCurrentExperienceColumnsData(data, vm);
	        setPositionColumnData(data, vm, applicationRecord);
	        data.applicationCandidateAgentEmail = data.userAgentId ? vm.agentsList.find(function (agent) {
	          return agent.id === data.userAgentId;
	        }) ? vm.agentsList.find(function (agent) {
	          return agent.id === data.userAgentId;
	        }).email : 'unassigned' : 'unassigned';
	
	        data.applicationEmployerAgentEmail = data.employerAgentId ? vm.agentsList.find(function (agent) {
	          return agent.id === data.employerAgentId;
	        }) ? vm.agentsList.find(function (agent) {
	          return agent.id === data.employerAgentId;
	        }).email : 'unassigned' : 'unassigned';
	        setApplicationAgentEmail(data, vm);
	        if (data.stageId) {
	          var applicationStage = vm.applicationSubStagesList.find(function (_ref40) {
	            var id = _ref40.id;
	            return data.stageId === id;
	          });
	          if (applicationStage) {
	            data.applicationStageOrder = Boolean(applicationStage) && applicationStage.order;
	
	            data.applicationStage = applicationStage.name;
	            var parentApplicationStage = vm.allApplicationStagesList.find(function (_ref41) {
	              var id = _ref41.id;
	              return applicationStage.parentId === id;
	            });
	
	            data.parentStageId = parentApplicationStage.id;
	            data.parentStageOrder = parentApplicationStage.order;
	            data.parentApplicationStage = parentApplicationStage.name;
	            data.sponsorship = data.sponsorship ? 'Yes' : 'No';
	            data.isOffPlatform = data.isOffPlatform ? 'Off-Platform' : 'Platform';
	          }
	        }
	
	        var applicationNote = vm.allApplicationsNotes.find(function (_ref42) {
	          var applicationId = _ref42.applicationId;
	          return data.id === applicationId;
	        });
	        data.note = applicationNote ? applicationNote.body : '';
	        return data;
	      }).sort(function (a, b) {
	        return a.parentStageOrder > b.parentStageOrder ? 1 : -1;
	      }).sort(function (a, b) {
	        return a.applicationStageOrder > b.applicationStageOrder || a.parentStageOrder > b.parentStageOrder ? 1 : -1;
	      });
	    };
	
	    vm.updateApplicationStageAction = function (list, updateStageOnGrid) {
	      vm.gridOptions.columnDefs.find(function (column) {
	        return column.headerName === 'Application Details';
	      }).children.find(function (column) {
	        return column.field === 'applicationStage';
	      }).cellEditorParams.values = vm.applicationSubStagesList.map(function (stage) {
	        return stage.name;
	      });
	      vm.gridActionsDirective.applicationStage = {
	        function: dropdownApplicationStage,
	        applicationStageList: list
	      };
	
	      if (updateStageOnGrid) {
	        // TODO: implement it later
	      }
	    };
	
	    vm.applicationStagesHierarchialList = [];
	    var initializeApplicationListing = function () {
	      var _ref43 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
	        var _ref44, _ref45, agentsList, locationsList, languagesList, nationalitiesList, schoolList, legalPracticeAreaList, legalEmployerTypeList, legalJurisdictionList, contractTypeList, occupationList, applicationStagesList, applicationStagesHierarchialList, activeApplicationListing, applicationNoteResponse, uniqueApplicationsNotes;
	
	        return regeneratorRuntime.wrap(function _callee19$(_context19) {
	          while (1) {
	            switch (_context19.prev = _context19.next) {
	              case 0:
	                vm.innerHeight = $location.search().innerHeight;
	                vm.positionId = $location.search().positionId;
	
	                _context19.next = 4;
	                return userService.getUser();
	
	              case 4:
	                vm.user = _context19.sent;
	                _context19.next = 7;
	                return Promise.all([CandidateProfileApi.getAdminAndCorporateUsers(), SharedApi.getAllLocations({
	                  regions: true
	                }), SharedApi.getAllLanguages(), SharedApi.getAllNationalities(), SharedApi.getAllSchools(), SharedApi.getCategoryById(1), SharedApi.getCategoryById(2), SharedApi.getCategoryById(3), SharedApi.getAllContractTypes(), SharedApi.getAllOccupations(), ApplicationStagesApi.getAllApplicationStages(), ApplicationStagesApi.getAllApplicationStages({ hierarchy: true }), ApplicationsApi.getApplicationListing(vm.positionId ? {
	                  positionId: Number(vm.positionId)
	                } : { status: applicationStatusEnum.ACTIVE }), NotesApi.getAllNotes({
	                  type: 'application',
	                  order: 'DESC',
	                  includes: true
	                })]);
	
	              case 7:
	                _ref44 = _context19.sent;
	                _ref45 = _slicedToArray(_ref44, 14);
	                agentsList = _ref45[0].data;
	                locationsList = _ref45[1].data;
	                languagesList = _ref45[2].data;
	                nationalitiesList = _ref45[3].data;
	                schoolList = _ref45[4].data;
	                legalPracticeAreaList = _ref45[5].data;
	                legalEmployerTypeList = _ref45[6].data;
	                legalJurisdictionList = _ref45[7].data;
	                contractTypeList = _ref45[8].data;
	                occupationList = _ref45[9].data;
	                applicationStagesList = _ref45[10].data;
	                applicationStagesHierarchialList = _ref45[11].data;
	                activeApplicationListing = _ref45[12].data;
	                applicationNoteResponse = _ref45[13].data;
	                uniqueApplicationsNotes = [];
	
	                applicationNoteResponse.forEach(function (note) {
	                  if (!uniqueApplicationsNotes.some(function (application) {
	                    return note.applicationId === application.applicationId;
	                  })) uniqueApplicationsNotes.push(note);
	                });
	                vm.allApplicationsNotes = uniqueApplicationsNotes;
	                vm.agentsList = agentsList;
	                vm.legalPracticeAreaList = legalPracticeAreaList.specialties;
	                vm.legalEmployerTypeList = legalEmployerTypeList.specialties;
	                vm.jurisdictionList = legalJurisdictionList.specialties;
	                vm.locationsList = locationsList;
	                vm.languagesList = languagesList;
	                vm.nationalitiesList = nationalitiesList;
	                vm.schoolList = schoolList;
	                vm.contractTypesList = contractTypeList;
	                vm.occupationList = occupationList;
	                vm.applicationStagesHierarchialList = applicationStagesHierarchialList;
	                vm.applicationSubStagesList = applicationStagesList.filter(function (_ref46) {
	                  var parentId = _ref46.parentId;
	                  return parentId !== null;
	                }).sort(function (a, b) {
	                  return Number(a.parentId) - Number(b.parentId);
	                });
	                vm.allApplicationStagesList = applicationStagesList;
	                if (!vm.isAllowedAgent()) {
	                  vm.applicationSubStagesList = vm.applicationSubStagesList.filter(function (stage) {
	                    return stage.parentId !== 5;
	                  });
	                  vm.applicationStagesHierarchialList = vm.applicationStagesHierarchialList.filter(function (stage) {
	                    return stage.id !== 5;
	                  });
	                }
	
	                vm.loadActiveApplicationsListing(activeApplicationListing);
	                if (!vm.positionId) vm.loadInactiveApplicationsListing();
	
	              case 42:
	              case 'end':
	                return _context19.stop();
	            }
	          }
	        }, _callee19, _this);
	      }));
	
	      return function initializeApplicationListing() {
	        return _ref43.apply(this, arguments);
	      };
	    }();
	  }]);
	})();
	
	var isApplicationExist = function isApplicationExist(applicationId, vm) {
	  return vm.applicationListing.filter(function (_ref47) {
	    var id = _ref47.id;
	    return id === applicationId;
	  }).length > 0;
	};
	
	var addLight = function addLight(color, amount) {
	  var cc = Number.parseInt(color, 16) + amount;
	  var c = cc > 255 ? 255 : cc;
	  c = c.toString(16).length > 1 ? c.toString(16) : '0' + c.toString(16);
	  return c;
	};
	
	var lighten = function lighten(color, amount) {
	  color = color.includes('#') ? color.slice(1, color.length) : color;
	  // eslint-disable-next-line radix
	  amount = Number.parseInt(255 * amount / 100);
	  color = '#' + addLight(color.slice(0, 2), amount) + addLight(color.slice(2, 4), amount) + addLight(color.slice(4, 6), amount);
	  return color;
	};
	
	function hexToRGB(h, opacity) {
	  var r = 0;
	  var g = 0;
	  var b = 0;
	
	  // 3 digits
	  if (h.length === 4) {
	    r = '0x' + h[1] + h[1];
	    g = '0x' + h[2] + h[2];
	    b = '0x' + h[3] + h[3];
	
	    // 6 digits
	  } else if (h.length === 7) {
	    r = '0x' + h[1] + h[2];
	    g = '0x' + h[3] + h[4];
	    b = '0x' + h[5] + h[6];
	  }
	
	  return 'rgba(' + Number(r) + ',' + Number(g) + ',' + Number(b) + ', ' + opacity + ')';
	}
	
	var setCandidateColumnsData = function setCandidateColumnsData(data, vm) {
	  data.candidateAgentEmail = data.candidate.agentId ? vm.agentsList.find(function (agent) {
	    return agent.id === data.candidate.agentId;
	  }) ? vm.agentsList.find(function (agent) {
	    return agent.id === data.candidate.agentId;
	  }).email : 'unassigned' : 'unassigned';
	  data.candidateFullName = data.user.firstName + ' ' + data.user.lastName;
	  data.candidate.pqe = data.candidate.qualificationDate ? (0, _formatPqe.formatQualificationDateToPqe)(data.candidate.qualificationDate) : '';
	  data.candidate.location = data.candidate.location ? vm.locationsList.find(function (location) {
	    return location.id === data.candidate.location;
	  }).name : '';
	  data.candidate.languages = data.candidate.languages.length > 0 ? vm.languagesList.filter(function (_ref48) {
	    var code = _ref48.code;
	    return data.candidate.languages.find(function (language) {
	      return language.code === code;
	    });
	  }).map(function (language) {
	    return language.name;
	  }) : '';
	  data.candidate.jurisdictions = data.candidate.jurisdictions.length > 0 ? vm.jurisdictionList.filter(function (_ref49) {
	    var id = _ref49.id;
	    return data.candidate.jurisdictions.find(function (jurisdiction) {
	      return jurisdiction.id === id;
	    });
	  }).map(function (jurisdiction) {
	    return jurisdiction.name;
	  }) : '';
	  data.candidate.school = data.candidate.school ? vm.schoolList.find(function (school) {
	    return school.id === data.candidate.school;
	  }).name : '';
	  data.candidate.nationality = data.candidate.nationalities && data.candidate.nationalities.length > 0 ? vm.nationalitiesList.filter(function (_ref50) {
	    var code = _ref50.code;
	    return data.candidate.nationalities.find(function (nationality) {
	      return nationality.code === code;
	    });
	  }).map(function (nationality) {
	    return nationality.demonyms[0];
	  }) : '';
	  return data;
	};
	
	var setPositionColumnData = function setPositionColumnData(data, vm, applicationRecord) {
	  data.position.rPQE = '' + (data.position.lawPreferences.minPqe <= 0 ? 'NQ' : data.position.lawPreferences.minPqe) + (data.position.lawPreferences.maxPqe === 11 ? '+' : data.position.lawPreferences.maxPqe <= 0 || data.position.lawPreferences.maxPqe === data.position.lawPreferences.minPqe ? '' : '-' + data.position.lawPreferences.maxPqe.toString());
	  data.position.visible = data.position.visible ? 'Visible' : 'Invisible';
	
	  data.position.specialties = data.position.specialties.length > 0 ? vm.legalPracticeAreaList.filter(function (_ref51) {
	    var id = _ref51.id;
	    return data.position.specialties.find(function (specialty) {
	      return specialty.id === id;
	    });
	  }).map(function (specialty) {
	    return specialty.name;
	  }) : '';
	
	  data.position.locations = data.position.locations.length > 0 ? vm.locationsList.filter(function (_ref52) {
	    var id = _ref52.id;
	    return data.position.locations.find(function (location) {
	      return location.id === id;
	    });
	  }).map(function (location) {
	    return location.name;
	  }) : '';
	
	  data.position.contractType = data.position.contractTypeId !== undefined || data.position.contractTypeId !== null ? vm.contractTypesList.find(function (contract) {
	    return contract.id === data.position.contractTypeId;
	  }).name : '';
	  data.position.occupation = data.position.occupationId ? vm.occupationList.find(function (occupation) {
	    return occupation.id === data.position.occupationId;
	  }).name : '';
	  data.position.applicantCount = applicationRecord.filter(function (application) {
	    return application.position.id === data.position.id;
	  }).length;
	  return data;
	};
	
	var setEmployerColumnsData = function setEmployerColumnsData(data, vm) {
	  var employerSelectivity = '';
	  if (data.employer.selectivity) {
	    for (var index = 1; index <= data.employer.selectivity; index++) {
	      employerSelectivity += '$';
	    }
	  }
	
	  if (data.employer.selectivity === 0) employerSelectivity = 'Uncategorized';
	  data.employer.selectivity = employerSelectivity;
	  data.employer.type = data.employer.type.length > 0 ? vm.legalEmployerTypeList.filter(function (_ref53) {
	    var id = _ref53.id;
	    return data.employer.type.find(function (specialty) {
	      return specialty.id === id;
	    });
	  }).map(function (specialty) {
	    return specialty.name;
	  }).join() : 'Auto-Generated';
	
	  data.employerAgentEmail = data.employer.agentId ? vm.agentsList.find(function (agent) {
	    return agent.id === data.employer.agentId;
	  }) ? vm.agentsList.find(function (agent) {
	    return agent.id === data.employer.agentId;
	  }).email : 'unassigned' : 'unassigned';
	  return data;
	};
	
	var setCurrentExperienceColumnsData = function setCurrentExperienceColumnsData(data, vm) {
	  data.currentExperience.contractType = data.currentExperience.contractTypeId ? vm.contractTypesList.find(function (contract) {
	    return contract.id === data.currentExperience.contractTypeId;
	  }).name : '';
	  data.currentExperience.occupation = data.currentExperience.occupationId ? vm.occupationList.find(function (occupation) {
	    return occupation.id === data.currentExperience.occupationId;
	  }).name : '';
	  data.currentExperience.specialties = data.currentExperience.positionSpecialties.length > 0 ? vm.legalPracticeAreaList.filter(function (_ref54) {
	    var id = _ref54.id;
	    return data.currentExperience.positionSpecialties.find(function (specialty) {
	      return specialty.id === id;
	    });
	  }).map(function (specialty) {
	    return specialty.name;
	  }) : '';
	  data.currentExperience.employerType = data.currentExperience.employerSpecialties.length > 0 ? vm.legalEmployerTypeList.filter(function (_ref55) {
	    var id = _ref55.id;
	    return data.currentExperience.employerSpecialties.find(function (specialty) {
	      return specialty.id === id;
	    });
	  }).map(function (specialty) {
	    return specialty.name;
	  }).join() : 'Auto-Generated';
	  var currentEmployerSelectivity = '';
	  if (data.currentExperience.employer && data.currentExperience.employer.selectivity) {
	    for (var index = 1; index <= data.currentExperience.employer.selectivity; index++) {
	      currentEmployerSelectivity += '$';
	    }
	  }
	
	  if (data.currentExperience.employer && data.currentExperience.employer.selectivity === 0) currentEmployerSelectivity = 'Uncategorized';
	
	  if (data.currentExperience.employer) data.currentExperience.employer.selectivity = currentEmployerSelectivity;
	
	  return data;
	};
	
	var setApplicationAgentEmail = function setApplicationAgentEmail(data, vm, updatedAgent) {
	  if (updatedAgent) {
	    if (updatedAgent.some(function (_ref56) {
	      var id = _ref56.id;
	      return id === 0;
	    })) data.applicationAgentEmail = [];else data.applicationAgentEmail = updatedAgent.map(function (_ref57) {
	      var email = _ref57.email;
	      return email;
	    });
	  } else {
	    data.applicationAgentEmail = data.applicationAgents && data.applicationAgents.length > 0 ? vm.agentsList.filter(function (_ref58) {
	      var id = _ref58.id;
	      return data.applicationAgents.find(function (agent) {
	        return agent.id === id;
	      });
	    }).map(function (agent) {
	      return agent.email;
	    }) : [];
	  }
	
	  return data;
	};
	
	var applicationHelpContent = '<div>\n  <p>\tApplications displays indications of interest in positions and speculative opportunities made by (or on behalf of) LexStep candidates and allows you to update and track information relation to those applications.</p>\n  <b>My Candidates and My Employers</b>\n  <p>Filter by \u201CMy Candidates\u201D and/or \u201CMy Employers\u201D from the toolbar above the grid to see applications by candidates assigned to you and/or applications made to employers assigned to you.</p>\n  <b>Filtering</b>\n  <p>By default Applications filters archived applications and only shows those which have \u201CActive\u201D status.</p>\n  <p>Further filters can be applied by hovering over each column header and selecting the hamburger menu on the right. When a filter is applied to a column a purple filter icon appears in the header beside the column name.</p>\n  <b>Views</b>\n  <p>Personalise different list layouts by choosing the columns to display, adjusting their width and moving them to re-order to your preferences. You can save custom column layouts with filter criteria to easy access again later via the \u201CViews\u201D icon in the top right -- either as a Private \u201CSaved View\u201D or Shared with other team members.</p>\n  <b>Clear</b>\n  <p>When one or more filters are applied, a Clear filter icon will appear in the top right above the grid. Select to clear any applied filters and/or search and reset the grid data. The Clear filter icon also displays the number of filters currently active on the grid.</p>\n  <b>Group</b>\n  <p>The Applications grid is grouped by Stage, Sub-Stage, and Status by default. Drag and drop columns to the grouping drop zone in the grid\u2019s top row to group rows by a particular column. You can Expand/Collapse All Rows from the Views icon in the top right to view positions by group.</p>\n  <b>Sorting</b>\n  <p>You can change how the list is ordered by clicking the column headers to sort. To sort by multiple columns, hold down shift while clicking the column header.</p>\n  <b>Application Details</b>\n  <p>Expanding the Application Details column group reveals information on each application.</p>\n  <p>Internal Notes allow you to read and record comments on each application and view the history of any updates to that application.</p>\n  <p>Admin Followers allows admin to receive alerts to any updates made to an application they are following. Admin Followers always includes the assigned Current Candidate Agent and Current Employer Agent (from that application\u2019s Candidate Details and Target Employer Details column groups respectively) by default. You can choose to add or remove any other admin as an Admin Follower, which will include that admin on any email alerts.</p>\n  <p></p>\n  <p></p>\n  <p>Application Candidate Agent and Application Employer Agent columns show the relevant assigned Candidate Agent and assigned Employer Agent at the time the application was made. In contrast to the Current Candidate Agent and Current Employer Agent columns, the data in these columns will not change if after an application is made the relevant candidate or employer is assigned a new admin.</p>\n  <p>Feedback to Candidate (beta) allows admin to feed back to candidates in the form of leaving a text-string comment next to the relevant application on their Track page. (This feature is currently in beta and feedback is therefore only currently visible to admin).</p>\n  <p>Stage enables admin to update and track the pipeline stage and sub-stage of an application. Current application Stages are:</p>\n  <ul>\n  <li>Applied</li>\n  <li>Shortlisted</li>\n  <li>Submitted</li>\n  <li>Interview</li>\n  </ul>\n  <p>Status differentiates between active and archived applications. Status is independent of Stage and changing the status of an application at any Stage from Active to any of the other statuses will automatically archive the application whilst retaining the Stage, allowing you to track the Stage and Sub-Stage at which the application\u2019s process was terminated. Archived statuses include:</p>\n  <ul>\n  <li>Rejected by LexStep - used prior to Submission if not Shortlisting an application and after Submission if there has been no response from an Employer after e.g. 1 month.</li>\n  <li>Employer Declined - used when an Employer has directly fed back on the application</li>\n  <li>Candidate Withdrew - used when a Candidate chooses to withdraw at any stage of the process</li>\n  <li>Accepted - used when an offer is accepted.</li>\n  </ul>\n  <p>Source shows whether the candidate made the application themselves on Platform or whether the application was procured by a Candidate Agent Off-Platform and made on the candidate\u2019s behalf.</p>\n  <b>Actions</b>\n  <p>Current Stage and Status of an application can be changed by selecting one or more applications and using the \u201CChange Stage\u201D or \u201CChange Status\u201D icons from the toolbar above the grid.</p>\n  </div> ';
	
	var splitArrayIntoChunksOfLength = function splitArrayIntoChunksOfLength(array, length_) {
	  var chunks = [];
	  var index = 0;
	  var n = array.length;
	  while (index < n) {
	    chunks.push(array.slice(index, index += length_));
	  }
	
	  return chunks;
	};

/***/ }),
/* 525 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.api').factory('ApplicationsApi', ['api', function ApplicationsApi(api) {
	  var applicationApi = {
	    getApplicationListing: function getApplicationListing(payload) {
	      return api.get('listings/application', { params: payload });
	    },
	    updateApplicationById: function updateApplicationById(id, payload) {
	      return api.put('applications/' + id, payload);
	    },
	    getApplicationById: function getApplicationById(id) {
	      return api.get('application/' + id);
	    },
	    deleteApplicationById: function deleteApplicationById(id) {
	      return api.delete('applications/' + id);
	    },
	    createApplication: function createApplication(payload) {
	      return api.post('applications', payload);
	    },
	    bulkApplicationUpdate: function bulkApplicationUpdate(payload) {
	      return api.put('bulk/applications', payload);
	    },
	    getApplicationResume: function getApplicationResume(id) {
	      return api.get('applications/' + id + '/resume');
	    },
	    getApplicationHistoryById: function getApplicationHistoryById(id) {
	      return api.get('applications/' + id + '/history');
	    }
	  };
	  return applicationApi;
	}]);

/***/ }),
/* 526 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.api').factory('CandidateListingApi', ['api', function CandidateListingApi(api) {
	  var _this = this;
	
	  var candidateListingApi = {
	    getCandidateListing: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                return _context.abrupt('return', api.get('listings/user', { params: payload }));
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function getCandidateListing(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getCandidateListing;
	    }(),
	    updateBulkUserAgents: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                return _context2.abrupt('return', api.put('bulk/users/agent', data));
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      function updateBulkUserAgents(_x2) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return updateBulkUserAgents;
	    }(),
	    deleteUsers: function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(userIds) {
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                return _context3.abrupt('return', api.delete('bulk/users', { params: { userIds: userIds } }));
	
	              case 1:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this);
	      }));
	
	      function deleteUsers(_x3) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return deleteUsers;
	    }()
	  };
	  return candidateListingApi;
	}]);

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _locationFlagAndColor = __webpack_require__(192);
	
	var _formatPqe = __webpack_require__(55);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable angular/window-service */
	/* eslint-disable angular/document-service */
	/* eslint-disable unicorn/consistent-function-scoping */
	
	
	(function module() {
	  'use strict';
	
	  angular.module('app.ui.form.ctrls').controller('CandidateListingController', ['$scope', '$log', '$location', 'usSpinnerService', 'logger', '$window', '$uibModal', '$sce', 'SharedApi', 'CandidateListingApi', 'EmployersApi', 'CandidateProfileApi', 'ApplicationsApi', 'NotesApi', 'userService', 'socket', '$rootScope', function controller($scope, $log, $location, usSpinnerService, logger, $window, $uibModal, $sce, SharedApi, CandidateListingApi, EmployersApi, CandidateProfileApi, ApplicationsApi, NotesApi, userService, socket, $rootScope) {
	    var _this = this;
	
	    var vm = this;
	    var defaultFilter = void 0;
	
	    vm.candidateUpdated = function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(candidateId) {
	        var _ref2, updatedCandidate, formatCandidate, updateCandidateIndex;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return CandidateListingApi.getCandidateListing({ id: candidateId });
	
	              case 2:
	                _ref2 = _context.sent;
	                updatedCandidate = _ref2.data;
	                formatCandidate = setCandidateListingData(updatedCandidate);
	                updateCandidateIndex = vm.candidateListing && vm.candidateListing.findIndex(function (_ref3) {
	                  var id = _ref3.id;
	                  return id === candidateId;
	                });
	
	
	                vm.candidateListing[updateCandidateIndex] = formatCandidate[0];
	
	                vm.gridOptions.api.updateRowData({
	                  update: formatCandidate
	                });
	
	                updateGridGroupPipeline();
	                $scope.$apply();
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    socket.on('CANDIDATE_PROFILE_CREATE', function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(candidateId) {
	        var _ref5, newCandidate, formatCandidate;
	
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return CandidateListingApi.getCandidateListing({ id: candidateId });
	
	              case 2:
	                _ref5 = _context2.sent;
	                newCandidate = _ref5.data;
	                formatCandidate = setCandidateListingData(newCandidate);
	
	
	                vm.candidateListing = [].concat(_toConsumableArray(vm.candidateListing), _toConsumableArray(formatCandidate));
	                vm.gridOptions.api.updateRowData({
	                  addIndex: vm.candidateListing.length,
	                  add: formatCandidate
	                });
	                updateGridGroupPipeline();
	
	              case 8:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      return function (_x2) {
	        return _ref4.apply(this, arguments);
	      };
	    }());
	    socket.on('CANDIDATE_PROFILE_UPDATE', function () {
	      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(candidateId) {
	        var _ref7, updatedCandidate, _ref9, schoolList, formatCandidate, updateCandidateIndex;
	
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return CandidateListingApi.getCandidateListing({ id: candidateId });
	
	              case 2:
	                _ref7 = _context3.sent;
	                updatedCandidate = _ref7.data;
	
	                if (vm.schoolList.some(function (_ref8) {
	                  var id = _ref8.id;
	                  return id === updatedCandidate[0].candidateProfile.school;
	                })) {
	                  _context3.next = 10;
	                  break;
	                }
	
	                _context3.next = 7;
	                return SharedApi.getAllSchools();
	
	              case 7:
	                _ref9 = _context3.sent;
	                schoolList = _ref9.data;
	
	                vm.schoolList = schoolList;
	
	              case 10:
	                formatCandidate = setCandidateListingData(updatedCandidate);
	                updateCandidateIndex = vm.candidateListing && vm.candidateListing.findIndex(function (_ref10) {
	                  var id = _ref10.id;
	                  return id === candidateId;
	                });
	
	
	                vm.candidateListing[updateCandidateIndex] = formatCandidate[0];
	
	                vm.gridOptions.api.updateRowData({
	                  update: formatCandidate
	                });
	
	                updateGridGroupPipeline();
	                $scope.$apply();
	
	              case 16:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this);
	      }));
	
	      return function (_x3) {
	        return _ref6.apply(this, arguments);
	      };
	    }());
	
	    socket.on('CANDIDATE_ASSIGNED_AGENT_UPDATE', function () {
	      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(candidateId) {
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return vm.candidateUpdated(candidateId);
	
	              case 2:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this);
	      }));
	
	      return function (_x4) {
	        return _ref11.apply(this, arguments);
	      };
	    }());
	
	    socket.on('USER_DELETED', function () {
	      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(candidateId) {
	        var deleteCandidate;
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                deleteCandidate = vm.candidateListing.filter(function (_ref13) {
	                  var id = _ref13.id;
	                  return id === candidateId;
	                });
	
	                vm.candidateListing = vm.candidateListing.filter(function (_ref14) {
	                  var id = _ref14.id;
	                  return id !== candidateId;
	                });
	                vm.gridOptions.api.updateRowData({ remove: deleteCandidate });
	
	                updateGridGroupPipeline();
	                $rootScope.$broadcast('candidate-deleted', {
	                  candidateDeleted: candidateId
	                });
	
	              case 5:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this);
	      }));
	
	      return function (_x5) {
	        return _ref12.apply(this, arguments);
	      };
	    }());
	
	    socket.on('CANDIDATE_APPROVAL_STATUS_UPDATE', function () {
	      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(candidateId) {
	        return regeneratorRuntime.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _context6.next = 2;
	                return vm.candidateUpdated(candidateId);
	
	              case 2:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this);
	      }));
	
	      return function (_x6) {
	        return _ref15.apply(this, arguments);
	      };
	    }());
	
	    socket.on('USER_UPDATED', function () {
	      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(candidateId) {
	        return regeneratorRuntime.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _context7.next = 2;
	                return vm.candidateUpdated(candidateId);
	
	              case 2:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this);
	      }));
	
	      return function (_x7) {
	        return _ref16.apply(this, arguments);
	      };
	    }());
	    socket.on('SALARY_CREATED', function () {
	      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(candidateId) {
	        return regeneratorRuntime.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _context8.next = 2;
	                return vm.candidateUpdated(candidateId);
	
	              case 2:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this);
	      }));
	
	      return function (_x8) {
	        return _ref17.apply(this, arguments);
	      };
	    }());
	    socket.on('SALARY_UPDATED', function () {
	      var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(candidateId) {
	        return regeneratorRuntime.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                _context9.next = 2;
	                return vm.candidateUpdated(candidateId);
	
	              case 2:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this);
	      }));
	
	      return function (_x9) {
	        return _ref18.apply(this, arguments);
	      };
	    }());
	
	    socket.on('CANDIDATE_EMPLOYER_UPDATED', function () {
	      var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(candidateId) {
	        return regeneratorRuntime.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                _context10.next = 2;
	                return vm.candidateUpdated(candidateId);
	
	              case 2:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this);
	      }));
	
	      return function (_x10) {
	        return _ref19.apply(this, arguments);
	      };
	    }());
	    socket.on('CANDIDATE_POSITION_UPDATED', function () {
	      var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(candidateId) {
	        return regeneratorRuntime.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                _context11.next = 2;
	                return vm.candidateUpdated(candidateId);
	
	              case 2:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, _this);
	      }));
	
	      return function (_x11) {
	        return _ref20.apply(this, arguments);
	      };
	    }());
	
	    socket.on('EMPLOYER_UPDATE', function () {
	      var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(employerId) {
	        var _ref22, updatedCandidatesEmployer, formatUpdatedCandidates;
	
	        return regeneratorRuntime.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                if (!vm.candidateListing.some(function (candidate) {
	                  return candidate.employerId === employerId;
	                })) {
	                  _context12.next = 6;
	                  break;
	                }
	
	                _context12.next = 3;
	                return CandidateListingApi.getCandidateListing({
	                  employerId: employerId
	                });
	
	              case 3:
	                _ref22 = _context12.sent;
	                updatedCandidatesEmployer = _ref22.data;
	
	
	                if (updatedCandidatesEmployer && updatedCandidatesEmployer.length > 0) {
	                  formatUpdatedCandidates = setCandidateListingData(updatedCandidatesEmployer);
	
	
	                  formatUpdatedCandidates.forEach(function (candidate) {
	                    var index = vm.candidateListing && vm.candidateListing.findIndex(function (_ref23) {
	                      var id = _ref23.id;
	                      return id === candidate.id;
	                    });
	                    vm.candidateListing[index] = candidate;
	                  });
	
	                  vm.gridOptions.api.updateRowData({ update: formatUpdatedCandidates });
	                  updateGridGroupPipeline();
	                }
	
	              case 6:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, _this);
	      }));
	
	      return function (_x12) {
	        return _ref21.apply(this, arguments);
	      };
	    }());
	
	    socket.on('APPLICATION_CREATE', function () {
	      var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(applicationId) {
	        var _ref25, applicationCreated, updatedCandidate;
	
	        return regeneratorRuntime.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                _context13.next = 2;
	                return ApplicationsApi.getApplicationById(applicationId);
	
	              case 2:
	                _ref25 = _context13.sent;
	                applicationCreated = _ref25.data;
	                updatedCandidate = vm.candidateListing.find(function (_ref26) {
	                  var id = _ref26.id;
	                  return id === applicationCreated.userId;
	                });
	
	                if (!updatedCandidate) {
	                  _context13.next = 8;
	                  break;
	                }
	
	                _context13.next = 8;
	                return vm.candidateUpdated(updatedCandidate && updatedCandidate.id);
	
	              case 8:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, _this);
	      }));
	
	      return function (_x13) {
	        return _ref24.apply(this, arguments);
	      };
	    }());
	
	    var dateFilterParameters = {
	      suppressAndOrCondition: true,
	      inRangeInclusive: true,
	      comparator: function comparator(filterLocalDateAtMidnight, cellValue) {
	        var dateAsString = moment(cellValue).format('DD/MM/YYYY');
	        var dateParts = dateAsString.split('/');
	        var cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
	
	        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
	          return 0;
	        }
	
	        if (cellDate < filterLocalDateAtMidnight) {
	          return -1;
	        }
	
	        if (cellDate > filterLocalDateAtMidnight) {
	          return 1;
	        }
	      }
	    };
	
	    function renderDateTimeColumn(parameters) {
	      return parameters.value ? '<span>' + moment(parameters.value).format('DD-MMM-YYYY HH:mm') + '</span>' : ' ';
	    }
	
	    function renderDateMonthColumn(parameter) {
	      return parameter.value ? '<span>' + moment(parameter.value).format('MMM-YY') + '</span>' : ' ';
	    }
	
	    vm.viewProfile = function (parameter) {
	      if (parameter.data.candidateDetails.approvalStatus === 'New User') {
	        $window.open('/profile?user=' + parameter.data.candidateDetails.id, '_blank');
	      } else vm.candidateProfile(parameter.data.candidateDetails.id);
	    };
	
	    vm.candidateProfile = function (code) {
	      modalInstance = $uibModal.open({
	        templateUrl: 'candidateProfileModal.html',
	        windowClass: 'app-candidate-profile-modal-window',
	        controller: 'CandidateProfileModalController',
	        resolve: {
	          data: function data() {
	            return code;
	          }
	        }
	      });
	    };
	
	    var columnDefs = [{
	      columnGroupShow: undefined,
	      headerCheckboxSelection: true,
	      headerCheckboxSelectionFilteredOnly: true,
	      checkboxSelection: true,
	      width: 134,
	      filter: false,
	      resizable: false
	    }, {
	      headerName: 'Candidate Details',
	      children: [{
	        headerName: 'Status',
	        rowGroupIndex: 0,
	        field: 'candidateDetails.approvalStatus'
	      }, {
	        headerName: 'Candidate Agent',
	        field: 'candidateAgentEmail'
	      }, {
	        headerName: 'ID',
	        field: 'candidateDetails.id',
	        filter: 'agTextColumnFilter',
	        columnGroupShow: undefined
	      }, {
	        headerName: 'Email',
	        field: 'candidateDetails.email',
	        filter: 'agTextColumnFilter'
	      }, {
	        headerName: 'Phone #',
	        field: 'candidateDetails.phone',
	        filter: 'agTextColumnFilter'
	      }, {
	        headerName: 'Platform Access',
	        field: 'candidateDetails.platformAccess'
	      }]
	    }, {
	      headerName: 'Candidate Profile',
	      children: [{
	        headerName: 'Candidate Name',
	        field: 'candidateProfile.fullName',
	        onCellClicked: vm.viewProfile,
	        filter: 'agTextColumnFilter',
	        cellRenderer: function cellRenderer(parameter) {
	          return parameter.value ? '<span class="text-info pointer"/>' + parameter.value + '</span>' : '';
	        },
	        columnGroupShow: undefined
	      }, {
	        headerName: 'Qualification Date',
	        field: 'candidateProfile.qualificationDate',
	        cellRenderer: renderDateMonthColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'PQE',
	        field: 'candidateProfile.pqe',
	        filterParams: {
	          comparator: function comparator(a, b) {
	            var numberA = Number.parseFloat(a);
	            var numberB = Number.parseFloat(b);
	            if (numberA > numberB) {
	              return 1;
	            }
	
	            return numberA < numberB ? -1 : 0;
	          }
	        }
	      }, {
	        headerName: 'Current Location',
	        field: 'candidateProfile.currentLocation'
	      }, {
	        headerName: 'Languages',
	        field: 'candidateProfile.languages'
	      }, {
	        headerName: 'Jurisdiction(s) of Qualification',
	        field: 'candidateProfile.jurisdictions'
	      }, {
	        headerName: 'University',
	        field: 'candidateProfile.school'
	      }, {
	        headerName: 'Nationality',
	        field: 'candidateProfile.nationality'
	      }]
	    }, {
	      headerName: 'Candidate Experience',
	      children: [{
	        headerName: 'Current Employer',
	        field: 'currentExperience.employer.name',
	        columnGroupShow: undefined
	      }, {
	        headerName: 'Current Employer Type',
	        field: 'currentExperience.employerType'
	      }, {
	        headerName: 'Current Employer Selectivity',
	        field: 'currentExperience.employer.selectivity'
	      }, {
	        headerName: 'Current Job Title',
	        field: 'currentExperience.jobTitle'
	      }, {
	        headerName: 'Current Practice Areas',
	        field: 'currentExperience.specialties'
	      }, {
	        headerName: 'Current Occupation',
	        field: 'currentExperience.occupation'
	      }, {
	        headerName: 'Current Contract',
	        field: 'currentExperience.contractType'
	      }, {
	        headerName: 'Current Salary Currency',
	        field: 'currentExperience.salary.salaryUnit'
	      }, {
	        headerName: 'Current Salary Amount',
	        field: 'currentExperience.salary.salaryAmount'
	      }, {
	        headerName: 'Current Salary Period',
	        field: 'currentExperience.salary.salaryPeriod'
	      }, {
	        headerName: 'Current Bonus Currency ',
	        field: 'currentExperience.salary.bonusUnit'
	      }, {
	        headerName: 'Current Bonus Amount',
	        field: 'currentExperience.salary.bonusAmount'
	      }]
	    }, {
	      headerName: 'Candidate Preferences',
	      children: [{
	        headerName: 'Practice Area Preference',
	        field: 'legalCandidatePracticeAreas',
	        columnGroupShow: undefined,
	        filter: undefined
	      }, {
	        headerName: 'Location Preference',
	        field: 'candidatePreference.locations',
	        cellRenderer: function cellRenderer(parameter) {
	          return getLocationsTags(parameter.value);
	        }
	      }, {
	        headerName: 'Contract Preference',
	        field: 'candidatePreference.contracts',
	        cellRenderer: function cellRenderer(parameter) {
	          if (parameter.value) return ' <li class="label label-info text-uppercase margin-r5" style="background-color : #DEDEDE; color: black;">\n                ' + parameter.value + '\n              </li> ';
	        }
	      }, {
	        headerName: 'Occupation Preference',
	        field: 'candidatePreference.occupations',
	        cellRenderer: function cellRenderer(parameter) {
	          if (parameter.value) return ' <li class="label label-info text-uppercase margin-r5" style="background-color : #DEDEDE; color: black;">\n                ' + parameter.value + '\n              </li> ';
	        }
	      }, {
	        headerName: 'Employer Type Preference',
	        field: 'candidatePreference.legalEmployerType'
	      }, {
	        headerName: 'Employers Followed',
	        field: 'followEmployersName'
	      }, {
	        headerName: 'Employers Hidden',
	        field: 'hiddenEmployersName'
	      }, {
	        headerName: 'Positions Applied',
	        field: ''
	      }, {
	        headerName: 'Positions Hidden',
	        field: ''
	      }]
	    }, {
	      headerName: 'Candidate Activity',
	      children: [{
	        headerName: 'Candidate Status',
	        field: 'candidateActivity.candidateStatus'
	      }, {
	        headerName: 'Last Login',
	        field: 'candidateActivity.lastLogin',
	        cellRenderer: renderDateTimeColumn,
	        columnGroupShow: undefined,
	        filter: 'date',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'Approval Date',
	        field: 'candidateActivity.approvalAcceptDate',
	        cellRenderer: renderDateTimeColumn,
	        filter: 'date',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'Request Access Date',
	        field: 'candidateActivity.approvalRequestDate',
	        cellRenderer: renderDateTimeColumn,
	        filter: 'date',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'Signup Date',
	        field: 'candidateActivity.created',
	        cellRenderer: renderDateTimeColumn,
	        filter: 'date',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: '# Logins',
	        field: 'candidateActivity.loginCount'
	      }, {
	        headerName: '# Conversation Notes',
	        field: 'candidateActivity.totalConversationNote'
	      }, {
	        headerName: 'Last Conversation Date',
	        field: 'candidateActivity.lastConversationNote',
	        cellRenderer: renderDateTimeColumn,
	        filter: 'date',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: '# Employers Followed',
	        field: 'followEmployer.length'
	      }, {
	        headerName: '# Employers Hidden',
	        field: 'hiddenEmployer.length'
	      }, {
	        headerName: '# Positions Hidden',
	        field: 'hiddenPosition.length'
	      }, {
	        headerName: '# Positions Applied: Reg/Cust',
	        field: 'totalAppliedPositionRegularCustom'
	      }, {
	        headerName: '# MakeMeAnOffer',
	        field: 'totalAppliedPositionSpecConnect'
	      }, {
	        headerName: 'Recently Moved',
	        field: 'recentlyMoved'
	      }, {
	        headerName: 'Email Alerts: In-House ATS-Links',
	        field: 'emailAlertWeeklyInHouseATS'
	      }, {
	        headerName: 'Email Alerts: Daily + Adhoc Matches',
	        field: 'emailAlertDailyMatches'
	      }]
	    }];
	
	    var gridOptions = {
	      defaultColDef: {
	        sortable: true,
	        filter: true,
	        enablePivot: true,
	        enableRowGroup: true,
	        enableValue: true,
	        columnGroupShow: 'open',
	        resizable: true,
	        menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab']
	      },
	      embedFullWidthRows: true,
	      detailRowHeight: 300,
	      onFilterChanged: onFilterChanged,
	      onModelUpdated: updateGridGroupPipeline,
	      onGridReady: function onGridReady() {
	        initializeCandidateListing();
	      },
	      floatingFilter: true,
	      suppressCsvExport: true,
	      groupDefaultExpanded: 0,
	      groupUseEntireRow: true,
	      columnDefs: columnDefs,
	      animateRows: true,
	      enableCellChangeFlash: true,
	      groupSelectsChildren: true,
	      rowData: vm.candidateListing,
	      rowSelection: 'multiple',
	      rowMultiSelectWithClick: true,
	      rowGroupPanelShow: 'always',
	      pivotPanelShow: 'always',
	      groupSelectsFiltered: true,
	
	      postProcessPopup: function postProcessPopup(parameter) {
	        if (parameter.type !== 'columnMenu') {
	          return;
	        }
	
	        var columnId = parameter.column.getId();
	        if (columnId === 'candidatePreference.legalPractices' || columnId === 'currentExperience.specialties') {
	          parameter.ePopup.style.width = '350px';
	        }
	      },
	      groupRowRenderer: 'agGroupCellRenderer',
	      groupRowRendererParams: {
	        checkbox: true
	      },
	
	      getRowNodeId: function getRowNodeId(data) {
	        return data.id;
	      },
	      onSelectionChanged: onSelectionChanged,
	
	      sideBar: {
	        toolPanels: ['columns', 'filters'],
	        defaultToolPanel: false
	      },
	      statusBar: {
	        statusPanels: [{ statusPanel: 'agTotalRowCountComponent', align: 'left' }, { statusPanel: 'agFilteredRowCountComponent', align: 'left' }, { statusPanel: 'agSelectedRowCountComponent' }, { statusPanel: 'agAggregationComponent' }]
	      },
	
	      overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your data is loading</span>',
	      suppressCopyRowsToClipboard: true,
	      enableRangeSelection: true,
	      enableCharts: true,
	      onColumnRowGroupChanged: updateGridGroupPipeline,
	      getContextMenuItems: getContextMenuItems
	    };
	
	    vm.gridOptions = gridOptions;
	    vm.gridName = 'candidate';
	
	    vm.helpTooltip = {
	      name: 'Help',
	      content: $sce.trustAsHtml(candidateHelpContent)
	    };
	
	    function onFilterChanged() {
	      vm.filterCount = Object.keys(vm.gridOptions.api.getFilterModel()).length;
	      // eslint-disable-next-line angular/document-service
	      var filterTextBoxValue = document.querySelector('#filter-text-box').value;
	      if (filterTextBoxValue.length > 0) {
	        vm.filterCount += 1;
	      }
	
	      updatePipelineCountFromGrid();
	    }
	
	    // TODO: on grid functionality
	    function updatePipelineCountFromGrid() {
	      vm.gridOptions.api.forEachNode(function (node) {
	        if (node.key) {
	          vm.groupList.map(function (row) {
	            if (row.id === node.id) {
	              row.applicationsCount = node.allChildrenCount;
	              return row;
	            }
	
	            return row;
	          });
	        }
	      });
	      $scope.$applyAsync();
	    }
	
	    vm.activeActions = [{
	      funcName: 'Create Candidate',
	      function: function _function() {
	        $window.open('https://agent.lexstep.com/candidates/create', '_blank');
	      },
	      icon: '/images/plus-icon.svg',
	      visible: true
	    }];
	
	    // TODO: on grid action items functionality
	    function updateGridGroupPipeline() {
	      vm.groupList = [];
	
	      vm.gridOptions.api.forEachNode(function (node) {
	        if (node.key) {
	          var hasChild = true;
	          if (_.isEmpty(node.childrenMapped) || 'undefined' in node.childrenMapped) hasChild = false;
	          vm.groupList.push({
	            name: node.key,
	            applicationsCount: node.allChildrenCount,
	            color: node.leafGroup ? '#' + Math.trunc(Math.random() * 0xffffff).toString(16) : lighten('#5e5e5e', (node.level + 1) * 10),
	            id: node.id,
	            intId: Number(node.id) * -1,
	            level: node.level,
	            parentID: node.parent.id,
	            hasChild: hasChild,
	            isHidden: node.level !== 0
	          });
	        }
	      });
	      $log.debug('vm.groupList', vm.groupList);
	      $scope.$applyAsync();
	    }
	
	    vm.hideAccounts = function () {
	      var currentActiveFilters = vm.gridOptions.api.getFilterModel();
	      if (vm.actionsFunctions[0].hideAccounts === true) {
	        var hiddenData = vm.candidateListing.filter(function (_ref27) {
	          var candidateDetails = _ref27.candidateDetails;
	          return candidateDetails.email && candidateDetails.email.toLowerCase().includes('@lexstep') === false && candidateDetails.email && candidateDetails.email.toLowerCase().includes('@emumba') === false;
	        });
	        vm.gridOptions.api.setRowData(hiddenData);
	      } else {
	        vm.gridOptions.api.setRowData(vm.candidateListing);
	      }
	
	      vm.gridOptions.api.setFilterModel(currentActiveFilters);
	      vm.actionsFunctions[0].hideAccounts = !vm.actionsFunctions[0].hideAccounts;
	      if (vm.actionsFunctions[0].funcName === 'Hide Test Accounts') vm.actionsFunctions[0].funcName = 'Show Test Accounts';else vm.actionsFunctions[0].funcName = 'Hide Test Accounts';
	      vm.gridOptions.api.deselectAll();
	      onSelectionChanged();
	      updateGridGroupPipeline();
	    };
	
	    vm.splitGrid = function (value) {
	      vm.showCv.isShow = value;
	      var agGridListingDiv = document.querySelector('#' + vm.gridName);
	      var cvDiv = document.querySelector('#myCV');
	      agGridListingDiv.style.height = window.innerHeight - 235 + 'px';
	      agGridListingDiv.style.padding = 0;
	      cvDiv.style.height = window.innerHeight - 235 + 'px';
	      if (value) {
	        agGridListingDiv.style.width = '65%';
	        agGridListingDiv.classList.add('col-md-7');
	      } else agGridListingDiv.style.width = '100%';
	    };
	
	    vm.applicationsResume = [];
	
	    function onSelectionChanged() {
	      vm.selectedRows = vm.gridOptions.api.getSelectedRows();
	      vm.selectedRowsLength = vm.selectedRows.length;
	      hideShowDropdownActionItem();
	    }
	
	    var hideShowDropdownActionItem = function hideShowDropdownActionItem() {
	      vm.multiSelectOptions = undefined;
	
	      var functionName = vm.actionsFunctions[0].funcName;
	      var hideAccounts = vm.actionsFunctions[0].hideAccounts;
	      vm.actionsFunctions = [{
	        funcName: functionName,
	        leftClick: vm.hideAccounts,
	        values: vm.candidateListing,
	        hideAccounts: hideAccounts
	      }];
	      if (vm.selectedRowsLength > 0) {
	        vm.multiSelectOptions = [{
	          count: vm.selectedRowsLength
	        }, {
	          funcName: 'Clear Selection',
	          function: vm.clearSelection
	        }];
	        var _functionName = vm.actionsFunctions[0].funcName;
	        var _hideAccounts = vm.actionsFunctions[0].hideAccounts;
	        vm.actionsFunctions = [{
	          funcName: _functionName,
	          leftClick: vm.hideAccounts,
	          values: vm.candidateListing,
	          hideAccounts: _hideAccounts
	        }, {
	          funcName: 'Actions',
	          disabled: vm.selectedRowsLength !== 1,
	          leftClick: vm.openActionsModal
	        }, {
	          funcName: 'Delete',
	          leftClick: vm.deleteCandidate,
	          disabled: !(vm.selectedRowsLength > 0),
	          masterOnly: vm.isAllowedAgent()
	        }];
	        vm.gridDataActions = [{
	          count: vm.selectedRowsLength
	        }];
	      }
	
	      $scope.$applyAsync();
	    };
	
	    vm.isAllowedAgent = function () {
	      return vm.user.roles.some(function (role) {
	        return role.id === 'admin' || role.id === 'ops';
	      });
	    };
	
	    vm.openActionsModal = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
	      var selectedRows, modalData, _modalInstance;
	
	      return regeneratorRuntime.wrap(function _callee15$(_context15) {
	        while (1) {
	          switch (_context15.prev = _context15.next) {
	            case 0:
	              selectedRows = gridOptions.api.getSelectedRows();
	              // eslint-disable-next-line no-negated-condition
	
	              if (!(selectedRows[0].candidateDetails.approvalStatus !== 'New User')) {
	                _context15.next = 10;
	                break;
	              }
	
	              vm.selectedCandidate = selectedRows[0].candidateDetails.id;
	              modalData = void 0;
	              _context15.next = 6;
	              return Promise.allSettled([CandidateProfileApi.getUserProfile(vm.selectedCandidate), CandidateProfileApi.getUserBlockedEmployers(vm.selectedCandidate), CandidateProfileApi.getAdminAndCorporateUsers(), CandidateProfileApi.getUserSettings(vm.selectedCandidate), CandidateProfileApi.getEmployersList()]).then(function (results) {
	                var blockedEmployersList = results[4].value.data.map(function (employer) {
	                  return Object.assign({
	                    isSelected: Boolean(results[1].value.data.find(function (blockedEmployer) {
	                      return blockedEmployer.employerId === employer.id && blockedEmployer.block;
	                    }))
	                  }, employer);
	                });
	                vm.assignableAgents = results[2].value.data;
	                modalData = {
	                  candidate: results[0].value.data,
	                  blockedEmployers: results[1].value.data,
	                  assignableAgents: vm.assignableAgents,
	                  candidateSettings: results[3].value ? results[3].value.data : [{ id: 1, hasValue: false }],
	                  employersList: blockedEmployersList
	                };
	              });
	
	            case 6:
	              _modalInstance = $uibModal.open({
	                templateUrl: 'edit-candidate-modal.html',
	                controller: 'EditCandidateCtrl',
	                controllerAs: 'ctrl',
	                resolve: {
	                  data: function data() {
	                    return modalData;
	                  },
	                  candidateId: function candidateId() {
	                    return vm.selectedCandidate;
	                  }
	                }
	              });
	
	              _modalInstance.result.then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
	                return regeneratorRuntime.wrap(function _callee14$(_context14) {
	                  while (1) {
	                    switch (_context14.prev = _context14.next) {
	                      case 0:
	                      case 'end':
	                        return _context14.stop();
	                    }
	                  }
	                }, _callee14, _this);
	              })));
	              _context15.next = 11;
	              break;
	
	            case 10:
	              logger.notify('warning', 'Actions is not available for New User');
	
	            case 11:
	            case 'end':
	              return _context15.stop();
	          }
	        }
	      }, _callee15, _this);
	    }));
	
	    // Function for Delete Lawyer
	    vm.deleteCandidate = function () {
	      var selectedRows = gridOptions.api.getSelectedRows();
	      var selectedUserIds = selectedRows.map(function (x) {
	        return x.candidateDetails.id;
	      });
	      var modalInstance;
	      modalInstance = $uibModal.open({
	        templateUrl: 'deleteLawyerModal.html',
	        controller: 'deleteMatterModalCtrl',
	        resolve: {
	          data: function data() {
	            return vm.loggedInLawyer;
	          }
	        }
	      });
	      modalInstance.result.then(function (selectedItem) {
	        if (selectedItem) {
	          CandidateListingApi.deleteUsers(selectedUserIds).then(function () {
	            vm.gridOptions.api.updateRowData({ remove: selectedRows });
	            selectedRows.forEach(function (row) {
	              vm.candidateListing.splice(vm.candidateListing && vm.candidateListing.findIndex(function (x) {
	                return x.candidateDetails.id === row.candidateDetails.id;
	              }), 1);
	            });
	            var message = 'Successfully deleted';
	            logger.notify('success', message);
	            $rootScope.isCandidateDeleted = true;
	          }, function () {});
	        }
	      }, function () {});
	    };
	
	    // On clicking any referral code it will redirect on referral page with specific code filter
	    // eslint-disable-next-line no-unused-vars
	    function redirectToReferrals(parameter) {
	      if (parameter.data.candidateDetails.referredById && parameter.data.candidateDetails.referredBy !== '') $window.open('/admin/referral-listing?filterName=referralCode&filterValue=' + parameter.data.candidateDetails.referredById, '_blank');
	    }
	
	    function getContextMenuItems(parameter) {
	      var result = [{
	        name: 'Open profile in new tab ',
	        action: function action() {
	          if (parameter.node.data.candidateDetails.approvalStatus === 'New User') {
	            $window.open('/profile?user=' + parameter.node.data.candidateDetails.id, '_blank');
	          } else $window.open('/admin/lawyer-profile?user=' + parameter.node.data.candidateDetails.id, '_blank');
	        }
	      }, 'separator', {
	        name: 'Expand All Columns',
	        action: function action() {
	          var columnApi = parameter.columnApi.getColumnGroupState();
	          columnApi.forEach(function (item) {
	            parameter.columnApi.setColumnGroupOpened(item.groupId, true);
	          });
	        }
	      }, {
	        name: 'Collapse All Columns',
	        action: function action() {
	          var columnApi = parameter.columnApi.getColumnGroupState();
	          columnApi.forEach(function (item) {
	            parameter.columnApi.setColumnGroupOpened(item.groupId, false);
	          });
	        }
	      }, 'separator', 'copy', 'copyWithHeaders', 'separator', 'chartRange'];
	      vm.isExportAllowed = vm.user.roles.some(function (role) {
	        return role.id === 'admin' || role.id === 'ops';
	      });
	      if (vm.isExportAllowed) result.push('export');
	      return result;
	    }
	
	    vm.actionsFunctions = [{
	      funcName: 'Hide Test Accounts',
	      leftClick: vm.hideAccounts,
	      values: vm.candidateListing,
	      hideAccounts: true
	    }];
	
	    var modalInstance = void 0;
	    vm.profileLink = function (referralCode) {
	      modalInstance.close();
	      $window.open('/admin/lawyer-profile?user=' + referralCode, '_blank');
	    };
	
	    vm.loadCandidateListing = function (candidateRecord) {
	      vm.candidateListing = setCandidateListingData(candidateRecord);
	      vm.gridOptions.api.setRowData(vm.candidateListing);
	      if (defaultFilter) vm.gridOptions.api.setFilterModel(defaultFilter);
	      $rootScope.$broadcast('listing-loaded');
	
	      updateGridGroupPipeline();
	      $scope.$apply();
	    };
	
	    var setCandidateListingData = function setCandidateListingData(candidateRecord) {
	      return candidateRecord.map(function (data) {
	        data.matchingEmployerFollowed = data.followEmployer.length > 0 && data.followEmployer.find(function (employer) {
	          return employer.id === Number(vm.employerId);
	        }) ? 'Yes' : 'No';
	
	        data.matchingPositionHidden = data.hiddenPosition.length > 0 && data.hiddenPosition.find(function (position) {
	          return position.id === Number(vm.positionId);
	        }) ? 'Yes' : 'No';
	
	        data.matchingEmployerHidden = data.hiddenEmployer.length > 0 && data.hiddenEmployer.find(function (employer) {
	          return employer.id === Number(vm.employerId);
	        }) ? 'Yes' : 'No';
	
	        data.followEmployersName = data.followEmployer.length > 0 ? vm.employersNameList.filter(function (_ref30) {
	          var id = _ref30.id;
	          return data.followEmployer.find(function (employer) {
	            return employer.id === id;
	          });
	        }).map(function (employer) {
	          return employer.name;
	        }) : '';
	        data.hiddenEmployersName = data.hiddenEmployer.length > 0 ? vm.employersNameList.filter(function (_ref31) {
	          var id = _ref31.id;
	          return data.hiddenEmployer.find(function (employer) {
	            return employer.id === id;
	          });
	        }).map(function (employer) {
	          return employer.name;
	        }) : '';
	
	        if (data.appliedPosition.length > 0) {
	          var regularCustomAppliedPosition = data.appliedPosition.find(function (_ref32) {
	            var lastAppliedDateRegularCustom = _ref32.lastAppliedDateRegularCustom;
	            return lastAppliedDateRegularCustom !== null;
	          });
	          if (regularCustomAppliedPosition) {
	            data.lastAppliedDateRegularCustom = regularCustomAppliedPosition.lastAppliedDateRegularCustom;
	            data.totalAppliedPositionRegularCustom = regularCustomAppliedPosition.totalAppliedPositionRegularCustom;
	          }
	
	          var specConnectAppliedPosition = data.appliedPosition.find(function (_ref33) {
	            var lastAppliedDateSpecConnect = _ref33.lastAppliedDateSpecConnect;
	            return lastAppliedDateSpecConnect !== null;
	          });
	          if (specConnectAppliedPosition) {
	            data.lastAppliedDateSpecConnect = specConnectAppliedPosition.lastAppliedDateSpecConnect;
	            data.totalAppliedPositionSpecConnect = specConnectAppliedPosition.totalAppliedPositionSpecConnect;
	          }
	        }
	
	        setCandidateDetailsColumnsData(data, vm);
	        setCandidateProfileColumnsData(data, vm);
	        if (data.currentExperience.employer && data.currentExperience.employerId) setCurrentExperienceColumnsData(data, vm);
	        setCandidatePreferenceColumnsData(data, vm);
	        setCandidateActivityColumnsData(data, vm);
	        data.recentlyMoved = data.currentExperience.isLastJob && new Date(data.currentExperience.startDate) >= new Date(lastSixMonthDate()) ? '< 6 months' : 'No';
	        return data;
	      });
	    };
	
	    var startSpinner = function startSpinner(name) {
	      return usSpinnerService.spin(name);
	    };
	    var stopSpinner = function stopSpinner(name) {
	      return usSpinnerService.stop(name);
	    };
	
	    vm.sliderFilter = function (filterPqe) {
	      var separator = filterPqe.pqe.search(';');
	      var minPQE = Number(filterPqe.pqe.slice(0, separator));
	      var maxPQE = Number(filterPqe.pqe.slice(separator + 1, filterPqe.pqe.length));
	      if (maxPQE === 11) maxPQE = 50;
	      if (minPQE === -2) minPQE = -20;
	      var range = _.range(minPQE, maxPQE + 0.5, 0.5);
	      var filterValues = range.map(function (element) {
	        return String(element);
	      });
	      var currentActiveFilters = vm.gridOptions.api.getFilterModel();
	      if (maxPQE === 50 && minPQE === -20) {
	        delete currentActiveFilters['candidateProfile.pqe'];
	        gridOptions.api.setFilterModel(currentActiveFilters);
	      } else {
	        currentActiveFilters['candidateProfile.pqe'] = {
	          values: filterValues,
	          filterType: 'set'
	        };
	        gridOptions.api.setFilterModel(currentActiveFilters);
	      }
	
	      $scope.$applyAsync();
	    };
	
	    vm.updateSelectedCandidateAgent = function () {
	      var _ref34 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(selectedAgent) {
	        var selectedRow, selectedUserIds, result;
	        return regeneratorRuntime.wrap(function _callee16$(_context16) {
	          while (1) {
	            switch (_context16.prev = _context16.next) {
	              case 0:
	                selectedRow = vm.gridOptions.api.getSelectedRows();
	                selectedUserIds = selectedRow.map(function (x) {
	                  return x.candidateDetails.id;
	                });
	                _context16.next = 4;
	                return updateBulkUserAgentApi(selectedUserIds, selectedAgent.email, selectedRow);
	
	              case 4:
	                result = _context16.sent;
	
	
	                if (result === 200) {
	                  logger.notify('success', selectedUserIds.length + ' candidate' + (selectedUserIds.length > 1 ? 's' : '') + " assigned to '" + selectedAgent.email + "'");
	                  vm.gridOptions.api.deselectAll();
	                  $('#agentsDropdownList').hide();
	                }
	
	              case 6:
	              case 'end':
	                return _context16.stop();
	            }
	          }
	        }, _callee16, _this);
	      }));
	
	      return function (_x14) {
	        return _ref34.apply(this, arguments);
	      };
	    }();
	
	    var updateBulkUserAgentApi = function () {
	      var _ref35 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(userIds, selectedAgentEmail, selectedRow) {
	        var agent, payload, _ref37, status;
	
	        return regeneratorRuntime.wrap(function _callee17$(_context17) {
	          while (1) {
	            switch (_context17.prev = _context17.next) {
	              case 0:
	                agent = selectedAgentEmail === 'unassign' ? // eslint-disable-next-line unicorn/no-null
	                { id: null, email: 'unassigned' } : vm.agentsList.find(function (_ref36) {
	                  var email = _ref36.email;
	                  return email === selectedAgentEmail;
	                });
	                payload = { userIds: userIds, agentId: agent.id };
	                _context17.prev = 2;
	                _context17.next = 5;
	                return CandidateListingApi.updateBulkUserAgents(payload);
	
	              case 5:
	                _ref37 = _context17.sent;
	                status = _ref37.status;
	
	                if (!(status === 200)) {
	                  _context17.next = 11;
	                  break;
	                }
	
	                selectedRow.map(function (row) {
	                  row.candidateAgentEmail = agent.email;
	                  return row;
	                });
	                vm.gridOptions.api.updateRowData({ update: selectedRow });
	                return _context17.abrupt('return', status);
	
	              case 11:
	                _context17.next = 16;
	                break;
	
	              case 13:
	                _context17.prev = 13;
	                _context17.t0 = _context17['catch'](2);
	
	                logger.notify('error', _context17.t0.data.message);
	
	              case 16:
	              case 'end':
	                return _context17.stop();
	            }
	          }
	        }, _callee17, _this, [[2, 13]]);
	      }));
	
	      return function updateBulkUserAgentApi(_x15, _x16, _x17) {
	        return _ref35.apply(this, arguments);
	      };
	    }();
	
	    var initializeCandidateListing = function () {
	      var _ref38 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
	        var _ref39, _ref40, candidateList, agentsList, locationsList, languagesList, nationalitiesList, schoolList, legalPracticeAreaList, legalEmployerTypeList, legalJurisdictionList, contractTypeList, occupationList, employersNameList, userLoginActions, userAllConversationNotes, columnList, filterName, filterValue, employerName, column;
	
	        return regeneratorRuntime.wrap(function _callee18$(_context18) {
	          while (1) {
	            switch (_context18.prev = _context18.next) {
	              case 0:
	                _context18.next = 2;
	                return userService.getUser();
	
	              case 2:
	                vm.user = _context18.sent;
	
	                vm.positionId = $location.search().positionId;
	                vm.employerId = $location.search().employerId;
	                vm.innerHeight = $location.search().innerHeight;
	
	                startSpinner('candidate-listing');
	                _context18.next = 9;
	                return Promise.all([CandidateListingApi.getCandidateListing(), CandidateProfileApi.getAdminAndCorporateUsers(), SharedApi.getAllLocations({
	                  regions: true
	                }), SharedApi.getAllLanguages(), SharedApi.getAllNationalities(), SharedApi.getAllSchools(), SharedApi.getCategoryById(1), SharedApi.getCategoryById(2), SharedApi.getCategoryById(3), SharedApi.getAllContractTypes(), SharedApi.getAllOccupations(), EmployersApi.getAllEmployers({ include: ['id', 'name'] }), SharedApi.getAllActions({
	                  category: 'user',
	                  type: 'USER_LOGIN',
	                  include: true
	                }), NotesApi.getAllNotes({
	                  category: 'Conversation',
	                  type: 'user',
	                  includes: true
	                })]);
	
	              case 9:
	                _ref39 = _context18.sent;
	                _ref40 = _slicedToArray(_ref39, 14);
	                candidateList = _ref40[0].data;
	                agentsList = _ref40[1].data;
	                locationsList = _ref40[2].data;
	                languagesList = _ref40[3].data;
	                nationalitiesList = _ref40[4].data;
	                schoolList = _ref40[5].data;
	                legalPracticeAreaList = _ref40[6].data;
	                legalEmployerTypeList = _ref40[7].data;
	                legalJurisdictionList = _ref40[8].data;
	                contractTypeList = _ref40[9].data;
	                occupationList = _ref40[10].data;
	                employersNameList = _ref40[11].data;
	                userLoginActions = _ref40[12].data;
	                userAllConversationNotes = _ref40[13].data;
	
	                vm.userLoginActions = userLoginActions;
	                vm.userAllConversationNotes = userAllConversationNotes;
	                vm.agentsList = agentsList;
	                vm.legalPracticeAreaList = legalPracticeAreaList.specialties;
	                console.debug('initializeCandidateListing::legalPracticeAreaList', legalPracticeAreaList);
	                vm.legalEmployerTypeList = legalEmployerTypeList.specialties;
	                vm.jurisdictionList = legalJurisdictionList.specialties;
	                vm.locationsList = locationsList;
	                vm.languagesList = languagesList;
	                vm.nationalitiesList = nationalitiesList;
	                vm.schoolList = schoolList;
	                vm.contractTypesList = contractTypeList;
	                vm.occupationList = occupationList;
	                vm.employersNameList = employersNameList;
	                vm.onlyParentPracticeAreaList = vm.legalPracticeAreaList.filter(function (_ref41) {
	                  var parentId = _ref41.parentId;
	                  return parentId === null;
	                });
	
	                vm.gridActionsDirective = {
	                  pqeSlider: {
	                    function: vm.sliderFilter,
	                    params: {
	                      options: {
	                        round: 1,
	                        from: -2,
	                        to: 11,
	                        step: 0.5,
	                        dimension: ' years',
	                        scale: ['≤-2', -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '≥11']
	                      },
	                      filterPQE: {
	                        pqe: '-2;11'
	                      }
	                    },
	                    buttonId: 'lawyer-listing-pqe-slider',
	                    icon: 'images/stage.svg'
	                  },
	                  practices: {
	                    buttonId: 'candidate-listing-filter-prac',
	                    allPracticeAreaList: vm.onlyParentPracticeAreaList,
	                    iconLabel: 'Filter by Practice Area'
	                  },
	                  assignAgent: {
	                    buttonId: 'assignee-admin-filter',
	                    agentsList: vm.agentsList,
	                    function: vm.updateSelectedCandidateAgent,
	                    filteredAgentList: vm.agentsList
	                  }
	                };
	
	                if ($location.search().filterName && $location.search().filterValue) {
	                  columnList = [];
	
	                  columnDefs.forEach(function (row) {
	                    if (row.children) columnList.push(row.children);
	                  });
	                  filterName = $location.search().filterName;
	                  filterValue = $location.search().filterValue;
	                  employerName = vm.employersNameList.find(function (row) {
	                    return row.id === Number(filterValue);
	                  }).name;
	
	                  columnList = columnList.flat(Infinity);
	                  column = columnList.find(function (row) {
	                    return row.field === filterName;
	                  });
	
	                  if (column && column.field) {
	                    defaultFilter = JSON.parse(column.filter === 'agTextColumnFilter' ? '{"' + filterName + '":{"filterType":"text","type":"contains","filter":"' + employerName + '"}}' : '{"' + filterName + '":{"values":["' + employerName + '"],"filterType":"set"}}');
	                  }
	                }
	
	                vm.loadCandidateListing(candidateList);
	                stopSpinner('candidate-listing');
	
	              case 44:
	              case 'end':
	                return _context18.stop();
	            }
	          }
	        }, _callee18, _this);
	      }));
	
	      return function initializeCandidateListing() {
	        return _ref38.apply(this, arguments);
	      };
	    }();
	
	    var getLocationsTags = function getLocationsTags(locations) {
	      var locationTags = '';
	      // eslint-disable-next-line unicorn/explicit-length-check
	      if (locations && locations.length) {
	        locations.forEach(function (locationName) {
	          var _getLocationColorAndF = (0, _locationFlagAndColor.getLocationColorAndFlag)(locationName),
	              color = _getLocationColorAndF.color,
	              flag = _getLocationColorAndF.flag;
	
	          locationTags += ' <li class="label label-info text-uppercase margin-r5 location-' + color + '">\n          ' + flag + ' ' + locationName + '\n        </li> ';
	        });
	      }
	
	      return locationTags;
	    };
	  }]);
	})();
	
	var lastSixMonthDate = function lastSixMonthDate() {
	  var today = new Date();
	  return today.setMonth(today.getMonth() - 6);
	};
	
	var addLight = function addLight(color, amount) {
	  var cc = Number.parseInt(color, 16) + amount;
	  var c = cc > 255 ? 255 : cc;
	  c = c.toString(16).length > 1 ? c.toString(16) : '0' + c.toString(16);
	  return c;
	};
	
	var lighten = function lighten(color, amount) {
	  color = color.includes('#') ? color.slice(1, color.length) : color;
	  // eslint-disable-next-line radix
	  amount = Number.parseInt(255 * amount / 100);
	  color = '#' + addLight(color.slice(0, 2), amount) + addLight(color.slice(2, 4), amount) + addLight(color.slice(4, 6), amount);
	  return color;
	};
	
	var candidateHelpContent = '\n<div>\n\t\t\t\t\t<p>The Lawyers list displays LexStep candidates and allows you to search for candidates based on specific criteria you define.</p>\t\t\t\t\t\n\t\t\t\t\t<b>My Candidates</b>\n\t\t\t\t\t<p>Filter by \u201CMy Candidates\u201D from the toolbar above the grid to display your assigned candidates only.</p>\t\t\t\t\t\n\t\t\t\t\t<b>Filtering</b>\n\t\t\t\t\t<p> \u201CFilter by PQE\u201D and \u201CFilter by Practice Area Preference\u201D icons allow you to quickly refine your search. Further filters can be applied by hovering over each column header and selecting the hamburger menu on the right. </p>\n\t\t\t\t\t<b>Views</b>\n\t\t\t\t\t<p>Personalise different list layouts by choosing the columns to display, adjusting their width and moving them to re-order to your preferences. You can save custom column layouts with filter criteria to easy access again later via the \u201CViews\u201D icon in the top right -- either as a Private \u201CSaved View\u201D or Shared with other team members.</p>\n\t\t\t\t\t<b>Clear</b>\n\t\t\t\t\t<p>When one or more filters are applied, a Clear filter icon will appear in the top right above the grid. Select to clear any applied filters and/or search and reset the grid data to default. </p>\n          <b>Group</b>\n\t\t\t\t\t<p>Drag and drop columns to the grouping drop zone in the grid\u2019s top row to group rows by a particular column.</p>\n\t\t\t\t\t<b>Sorting </b>\n\t\t\t\t\t<p>Candidates are sorted by Candidate ID in descending order, showing the latest candidate to sign up first by default. You can change how the list is ordered by clicking the column headers to sort. To sort by multiple columns, hold down shift while clicking the column header.</p>\n\t\t\t\t\t<b>Candidate Profile</b>\n\t\t\t\t\t<p>You can quickly view more details about each candidate on the list by clicking their hyperlinked name. A preview pane will open that lets you toggle between the candidate\u2019s Profile, Preferences, Applications, Notes, Position Matches and Speculative Make-Me-An-Offer opportunities.</p>\n\t\t\t\t\t<b>Actions</b>\n          <p>Selecting one or more rows enables bulk actions like Assign Admin which are accessible from the toolbar icons above the grid.</p>\t\n          <b>New Users</b>\n          <p>Clicking a New User\u2019s hyperlinked name will open their incomplete sign up form allowing you to review their progress and any issues they may have experienced in Requesting Access.  </p>\n          <p>To preview a New User\u2019s full LexStep profile and, for example, leave an internal Note: (1) copy their Referral Code from the Candidate Details column group; and (2) paste in a new tab at the end of this URL\n          <a href="https://www.lexstep.com/admin/lawyer-profile?user=" target="_blank">https://www.lexstep.com/admin/lawyer-profile?user=</a>\n          </div> ';
	
	var setCandidateDetailsColumnsData = function setCandidateDetailsColumnsData(data, vm) {
	  data.candidateDetails.referralCode = data.candidateDetails.id;
	  data.candidateAgentEmail = data.candidateDetails.agentId;
	  data.candidateAgentEmail = data.candidateDetails.agentId;
	  data.candidateAgentEmail = data.candidateDetails.agentId ? vm.agentsList.find(function (agent) {
	    return agent.id === data.candidateDetails.agentId;
	  }) ? vm.agentsList.find(function (agent) {
	    return agent.id === data.candidateDetails.agentId;
	  }).email : 'unassigned' : 'unassigned';
	  var platformAccess = data.candidateDetails.platformAccess;
	  var leadAccount = data.candidateDetails.leadAccount;
	  data.candidateDetails.platformAccess = platformAccess ? 'Candidate Account' : leadAccount ? 'Lead Account' : 'No Platform Access';
	  return data;
	};
	
	var setCandidateProfileColumnsData = function setCandidateProfileColumnsData(data, vm) {
	  data.candidateProfile.fullName = data.candidateProfile.firstName + ' ' + data.candidateProfile.lastName;
	  data.candidateProfile.pqe = data.candidateProfile.qualificationDate ? (0, _formatPqe.formatQualificationDateToPqe)(data.candidateProfile.qualificationDate) : '';
	  if (data.candidateProfile.currentLocation) {
	    var location = vm.locationsList.find(function (location) {
	      return location.id === data.candidateProfile.currentLocation;
	    });
	    data.candidateProfile.currentLocation = location ? location.name : '';
	  }
	
	  data.candidateProfile.languages = data.candidateProfile.languages.length > 0 ? vm.languagesList.filter(function (_ref42) {
	    var code = _ref42.code;
	    return data.candidateProfile.languages.find(function (language) {
	      return language.code === code;
	    });
	  }).map(function (language) {
	    return language.name;
	  }) : '';
	  data.candidateProfile.jurisdictions = data.candidateProfile.jurisdictions.length > 0 ? vm.jurisdictionList.filter(function (_ref43) {
	    var id = _ref43.id;
	    return data.candidateProfile.jurisdictions.find(function (jurisdiction) {
	      return jurisdiction.id === id;
	    });
	  }).map(function (jurisdiction) {
	    return jurisdiction.name;
	  }) : '';
	
	  data.candidateProfile.school = data.candidateProfile.school ? vm.schoolList.find(function (school) {
	    return school.id === data.candidateProfile.school;
	  }).name : '';
	
	  data.candidateProfile.nationality = data.candidateProfile.nationalities && data.candidateProfile.nationalities.length > 0 ? vm.nationalitiesList.filter(function (_ref44) {
	    var code = _ref44.code;
	    return data.candidateProfile.nationalities.find(function (nationality) {
	      return nationality.code === code;
	    });
	  }).map(function (nationality) {
	    return nationality.demonyms[0];
	  }) : '';
	  return data;
	};
	
	var setCurrentExperienceColumnsData = function setCurrentExperienceColumnsData(data, vm) {
	  data.currentExperience.contractType = data.currentExperience.contractTypeId ? vm.contractTypesList.find(function (contract) {
	    return contract.id === data.currentExperience.contractTypeId;
	  }).name : undefined;
	  data.currentExperience.occupation = data.currentExperience.occupationId ? vm.occupationList.find(function (occupation) {
	    return occupation.id === data.currentExperience.occupationId;
	  }).name : undefined;
	  data.currentExperience.specialties = data.currentExperience.positionSpecialties.length > 0 ? vm.legalPracticeAreaList.filter(function (_ref45) {
	    var id = _ref45.id;
	    return data.currentExperience.positionSpecialties.find(function (specialty) {
	      return specialty.id === id;
	    });
	  }).map(function (specialty) {
	    return specialty.name;
	  }) : '';
	  data.currentExperience.employerType = data.currentExperience.employerSpecialties.length > 0 ? vm.legalEmployerTypeList.filter(function (_ref46) {
	    var id = _ref46.id;
	    return data.currentExperience.employerSpecialties.find(function (specialty) {
	      return specialty.id === id;
	    });
	  }).map(function (specialty) {
	    return specialty.name;
	  }) : '';
	  var currentEmployerSelectivity = '';
	  if (data.currentExperience.employer.selectivity) {
	    for (var index = 1; index <= data.currentExperience.employer.selectivity; index++) {
	      currentEmployerSelectivity += '$';
	    }
	  }
	
	  if (data.currentExperience.employer.selectivity === 0) currentEmployerSelectivity = 'Uncategorized';
	  data.currentExperience.employer.selectivity = currentEmployerSelectivity;
	
	  return data;
	};
	
	var setCandidateActivityColumnsData = function setCandidateActivityColumnsData(data, vm) {
	  data.candidateActivity.loginCount = vm.userLoginActions.find(function (_ref47) {
	    var userId = _ref47.userId;
	    return userId === data.id;
	  }) && Number(vm.userLoginActions.find(function (_ref48) {
	    var userId = _ref48.userId;
	    return userId === data.id;
	  }).count);
	  data.candidateActivity.totalConversationNote = vm.userAllConversationNotes.find(function (_ref49) {
	    var userId = _ref49.userId;
	    return userId === data.id;
	  }) && Number(vm.userAllConversationNotes.find(function (_ref50) {
	    var userId = _ref50.userId;
	    return userId === data.id;
	  }).count);
	  data.candidateActivity.lastConversationNote = vm.userAllConversationNotes.find(function (_ref51) {
	    var userId = _ref51.userId;
	    return userId === data.id;
	  }) && vm.userAllConversationNotes.find(function (_ref52) {
	    var userId = _ref52.userId;
	    return userId === data.id;
	  }).created;
	  data.emailAlertDailyMatches = data.candidateActivity.emailSubscription.length > 0 ? data.candidateActivity.emailSubscription.find(function (_ref53) {
	    var id = _ref53.id;
	    return id === 'daily_positions_ping';
	  }) && data.candidateActivity.emailSubscription.find(function (_ref54) {
	    var id = _ref54.id;
	    return id === 'daily_positions_ping';
	  }).status : 'Active';
	  data.emailAlertWeeklyInHouseATS = data.candidateActivity.emailSubscription.length > 0 ? data.candidateActivity.emailSubscription.find(function (_ref55) {
	    var id = _ref55.id;
	    return id === 'weekly_position_ping';
	  }) && data.candidateActivity.emailSubscription.find(function (_ref56) {
	    var id = _ref56.id;
	    return id === 'weekly_position_ping';
	  }).status : 'Active';
	
	  return data;
	};
	
	var setCandidatePreferenceColumnsData = function setCandidatePreferenceColumnsData(data, vm) {
	  data.legalCandidatePracticeAreas = data.candidatePreference.specialties.length > 0 ? vm.legalPracticeAreaList.filter(function (_ref57) {
	    var id = _ref57.id;
	    return data.candidatePreference.specialties.find(function (specialty) {
	      return specialty.id === id;
	    });
	  }).map(function (specialty) {
	    return specialty.name;
	  }) : '';
	  data.candidatePreference.legalEmployerType = data.candidatePreference.specialties.length > 0 ? vm.legalEmployerTypeList.filter(function (_ref58) {
	    var id = _ref58.id;
	    return data.candidatePreference.specialties.find(function (specialty) {
	      return specialty.id === id;
	    });
	  }).map(function (specialty) {
	    return specialty.name;
	  }) : '';
	  data.candidatePreference.contracts = data.candidatePreference.contracts.length > 0 ? vm.contractTypesList.filter(function (_ref59) {
	    var id = _ref59.id;
	    return data.candidatePreference.contracts.find(function (contractType) {
	      return contractType.id === id;
	    });
	  }).map(function (contractType) {
	    return contractType.name;
	  }) : undefined;
	  data.candidatePreference.occupations = data.candidatePreference.occupations.length > 0 ? vm.occupationList.filter(function (_ref60) {
	    var id = _ref60.id;
	    return data.candidatePreference.occupations.find(function (occupation) {
	      return occupation.id === id;
	    });
	  }).map(function (occupation) {
	    return occupation.name;
	  }) : undefined;
	
	  data.candidatePreference.locations = data.candidatePreference.locations.length > 0 ? vm.locationsList.filter(function (_ref61) {
	    var id = _ref61.id;
	    return data.candidatePreference.locations.find(function (location) {
	      return location.id === id;
	    });
	  }).map(function (location) {
	    return location.name;
	  }) : '';
	  // Data.candidatePreference.locations =
	  //   data.candidatePreference.locations.length > 0
	  //     ? vm.locationsList
	  //         .filter(({id}) =>
	  //           data.candidatePreference.locations.find(
	  //             location => location.id === id
	  //           )
	  //         )
	  //         .map(location => {
	  //           return {
	  //             name: location.name,
	  //             color:
	  //               location.countryCode === 'GB'
	  //                 ? 'london'
	  //                 : location.country.region.color,
	  //           }
	  //         })
	  //     : ''
	
	  return data;
	};

/***/ }),
/* 528 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.api').factory('EmailApi', ['api', function EmailApi(api) {
	  var emailApi = {
	    getAllEmails: function getAllEmails() {
	      return api.get('emails');
	    },
	    updateEmailById: function updateEmailById(emailId, payload) {
	      return api.put('emails/' + emailId, payload);
	    }
	  };
	  return emailApi;
	}]);

/***/ }),
/* 529 */
/***/ (function(module, exports) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('EmailListingController', ['usSpinnerService', '$q', 'logger', 'EmailApi', '$scope', 'userService', function controller(usSpinnerService, $q, logger, EmailApi, $scope, userService) {
	    var _this = this;
	
	    var vm = this;
	    vm.searchEmailQuery = '';
	    var originalEmailListing = [];
	    vm.numPerPageOpt = [10, 20, 50];
	    vm.numPerPage = vm.numPerPageOpt[2];
	    vm.currentPage = 1;
	    vm.currentPageItems = [];
	    vm.isEditedFieldCC = false;
	    vm.isEditedFieldBCC = false;
	    vm.hideDropDown = function () {
	      vm.showClass = '';
	    };
	
	    vm.showClass = '';
	    vm.showDropDown = function () {
	      if (vm.showClass === '') {
	        vm.showClass = 'show';
	      } else {
	        vm.showClass = '';
	      }
	    };
	
	    vm.startSpin = function (spinnerID) {
	      if (!vm.spinneractive) {
	        usSpinnerService.spin(spinnerID);
	        vm.spinneractive = true;
	        return vm.startcounter++;
	      }
	    };
	
	    vm.stopSpin = function (spinnerID) {
	      if (vm.spinneractive) {
	        usSpinnerService.stop(spinnerID);
	        vm.spinneractive = false;
	      }
	    };
	
	    vm.searchEmail = function () {
	      var filteredResult = void 0;
	      filteredResult = [];
	      if (vm.searchEmailQuery === '') {
	        vm.emailListing = originalEmailListing;
	      } else {
	        filteredResult = filterResult(vm.searchEmailQuery);
	        vm.emailListing = filteredResult;
	      }
	
	      vm.select(1);
	    };
	
	    var filterResult = function filterResult(searchQuery) {
	      var index = void 0;
	      var k = void 0;
	      var reference = void 0;
	      var searchResults = void 0;
	      searchResults = [];
	      for (index = 0, k = 0, reference = originalEmailListing.length; reference >= 0 ? k < reference : k > reference; index = reference >= 0 ? ++k : --k) {
	        if (originalEmailListing[index].label.toUpperCase().search(searchQuery.toUpperCase()) !== -1) {
	          searchResults.push(originalEmailListing[index]);
	        } else if (originalEmailListing[index].id && originalEmailListing[index].id.toUpperCase().search(searchQuery.toUpperCase()) !== -1) {
	          searchResults.push(originalEmailListing[index]);
	        }
	      }
	
	      return searchResults;
	    };
	
	    vm.editEmailField = function (email, type) {
	      if (type === 'cc') {
	        email.isEditedFieldCC = true;
	        vm.emailInputCCField = email[type];
	      } else {
	        vm.emailInputBCCField = email[type];
	        email.isEditedFieldBCC = true;
	      }
	    };
	    // TODO: Implement this functionality of display context of email from sendGrid in v1.1.0
	    // vm.openEmailBodyViewPage = email => {
	    //   $location.url('/admin/email-body').search({
	    //     email: email,
	    //   })
	    // }
	
	    vm.updateEmail = function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(updatedEmail, type) {
	        var existingValue, dto, _ref3, status;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (type === 'cc') vm.emailInputField = vm.emailInputCCField;else vm.emailInputField = vm.emailInputBCCField;
	
	                if (!(vm.emailInputField === '')) {
	                  _context.next = 5;
	                  break;
	                }
	
	                logger.notify('error', 'Email ' + type + ' should not be Empty');
	                _context.next = 23;
	                break;
	
	              case 5:
	                existingValue = originalEmailListing.find(function (_ref2) {
	                  var id = _ref2.id;
	                  return id === updatedEmail.id;
	                })[type];
	
	                if (!(existingValue === vm.emailInputField)) {
	                  _context.next = 10;
	                  break;
	                }
	
	                logger.notify('error', 'Email ' + type + ' should not be Same');
	                _context.next = 23;
	                break;
	
	              case 10:
	                dto = _defineProperty({}, type, vm.emailInputField.trim());
	                _context.prev = 11;
	                _context.next = 14;
	                return EmailApi.updateEmailById(updatedEmail.id, dto);
	
	              case 14:
	                _ref3 = _context.sent;
	                status = _ref3.status;
	
	                if (status === 200) {
	                  updatedEmail[type] = vm.emailInputField.trim();
	                  logger.notify('success', 'Email ' + type + ' successfully updated');
	                  // eslint-disable-next-line max-depth
	                  if (type === 'cc') {
	                    updatedEmail.isEditedFieldCC = false;
	                    $scope.$apply();
	                  } else {
	                    updatedEmail.isEditedFieldBCC = false;
	                    $scope.$apply();
	                  }
	                }
	                _context.next = 23;
	                break;
	
	              case 19:
	                _context.prev = 19;
	                _context.t0 = _context['catch'](11);
	
	                console.error('UpdateEmail Error:', _context.t0);
	                logger.notify('error', 'Email ' + type + ' failed');
	
	              case 23:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[11, 19]]);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    //  TODO: Removed as per discussion this will Implement History Functionality in v.1.1.0
	    // vm.showHistory = () => {
	    //   return $location.url('/admin/email-history')
	    // }
	
	    vm.loadEmailList = function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(start, end) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return userService.getUser();
	
	              case 2:
	                vm.user = _context2.sent;
	
	                vm.showEmailListing = true;
	                vm.listingTitle = 'Email Listing';
	                vm.numPerPage = vm.numPerPageOpt[2];
	                vm.startSpin('spinner-2');
	                if (!start) {
	                  start = 0;
	                }
	
	                if (!end) {
	                  end = vm.numPerPage;
	                }
	
	                return _context2.abrupt('return', $q.all([EmailApi.getAllEmails()]).then(function success(responses) {
	                  var emailListingResponse = responses[0];
	                  var data = emailListingResponse.data;
	                  vm.totalEmailList = data.length;
	                  originalEmailListing = data;
	                  originalEmailListing = originalEmailListing.map(function (email) {
	                    email.active = email.active ? 'Active' : 'Archived';
	                    return email;
	                  });
	                  vm.populateEmailList(data);
	                  vm.stopSpin('spinner-2');
	                }, function error() {
	                  vm.stopSpin('spinner-2');
	                }));
	
	              case 10:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      return function (_x3, _x4) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    vm.populateEmailList = function (data) {
	      vm.stopSpin('spinner-2');
	      vm.emailListing = data;
	      vm.select(1);
	    };
	
	    vm.onNumPerPageChange = function () {
	      vm.select(1);
	      vm.currentPage = 1;
	      return vm.currentPage;
	    };
	
	    vm.onOrderChange = function () {
	      vm.select(1);
	      vm.currentPage = 1;
	      return vm.currentPage;
	    };
	
	    vm.orderEmailListing = function (key, order) {
	      vm.sortBy = key + '_' + order;
	      if (order === 'asc') {
	        vm.emailListing = _.sortBy(vm.emailListing, key);
	      } else {
	        vm.emailListing = _.sortBy(vm.emailListing, key).reverse();
	      }
	
	      vm.onOrderChange();
	    };
	
	    vm.select = function (page) {
	      var start = (page - 1) * vm.numPerPage;
	      var end = start + vm.numPerPage;
	      vm.listing = vm.emailListing.slice(start, end);
	    };
	
	    vm.loadEmailList();
	  }]);
	})();

/***/ }),
/* 530 */
/***/ (function(module, exports) {

	'use strict';
	
	;(function module() {
	  angular.module('app.emailBodyView', ['pascalprecht.translate', 'angularFileUpload', 'angular.filter', 'ngSlider', 'ngCookies', 'ngAnimate', 'ngSanitize', 'angularSpinner', 'angular-clipboard', 'ui.nested.combobox']).controller('EmailPreviewController', ['$location', '$sce', function controller($location, $sce) {
	    var vm = this;
	    vm.email = $location.search().emailCategory;
	    vm.emailContent = $sce.trustAsHtml(vm.email.content);
	    // TODO: Removed as per discussion will Implement History Functionality in v.1.1.0
	    // vm.backButton = () => {
	    //   return $location.url('/admin/email-history')
	    // }
	
	    vm.navigateToEmailListing = function () {
	      $location.url('/admin/email-listing');
	    };
	
	    return vm.navigateToEmailListing();
	  }]);
	}).call(undefined);

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('EmployersListingController', ['logger', 'EmployersApi', 'SharedApi', 'PositionApi', '$scope', '$window', '$log', '$uibModal', 'userService', 'CandidateProfileApi', 'socket', '$rootScope', '$compile', function controller(logger, EmployersApi, SharedApi, PositionApi, $scope, $window, $log, $uibModal, userService, CandidateProfileApi, socket, $rootScope) {
	    var _this = this;
	
	    var onAgentChange = function () {
	      var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(parameter) {
	        var employerId, selectedRow;
	        return regeneratorRuntime.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                if (!(parameter.newValue !== parameter.oldValue)) {
	                  _context7.next = 5;
	                  break;
	                }
	
	                employerId = [parameter.data.id];
	                selectedRow = [parameter.data];
	                _context7.next = 5;
	                return updateEmployerAgentApi(employerId, parameter.newValue, selectedRow);
	
	              case 5:
	
	                logger.notify('success', 'Employer Id: ' + parameter.data.id + ' Agent ' + parameter.newValue + ' updated successfully');
	
	              case 6:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this);
	      }));
	
	      return function onAgentChange(_x7) {
	        return _ref19.apply(this, arguments);
	      };
	    }();
	
	    var vm = this;
	
	    socket.on('EMPLOYER_CREATE', function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(employerId) {
	        var _ref2, newEmployer, updatedEmployerIndex, formatEmployer;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return EmployersApi.getEmployerListing({
	                  id: employerId
	                });
	
	              case 2:
	                _ref2 = _context.sent;
	                newEmployer = _ref2.data;
	                updatedEmployerIndex = vm.employerListing.findIndex(function (_ref3) {
	                  var id = _ref3.id;
	                  return id === employerId;
	                });
	                formatEmployer = setEmployersListingData(newEmployer);
	
	                if (updatedEmployerIndex >= 0) {
	                  vm.employerListing[updatedEmployerIndex] = formatEmployer[0];
	                  vm.gridOptions.api.updateRowData({ update: formatEmployer });
	                } else {
	                  vm.employerListing = [].concat(_toConsumableArray(vm.employerListing), _toConsumableArray(newEmployer));
	                  vm.gridOptions.api.updateRowData({
	                    addIndex: 0,
	                    add: formatEmployer
	                  });
	                }
	
	                updateGridGroupPipeline();
	
	              case 8:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }());
	
	    socket.on('EMPLOYER_UPDATE', function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(employerId) {
	        var _ref5, updatedEmployer, formatEmployer, updatedEmployerIndex;
	
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return EmployersApi.getEmployerListing({
	                  id: employerId
	                });
	
	              case 2:
	                _ref5 = _context2.sent;
	                updatedEmployer = _ref5.data;
	                formatEmployer = setEmployersListingData(updatedEmployer);
	                updatedEmployerIndex = vm.employerListing.findIndex(function (_ref6) {
	                  var id = _ref6.id;
	                  return id === employerId;
	                });
	
	                vm.employerListing[updatedEmployerIndex] = formatEmployer[0];
	                vm.gridOptions.api.updateRowData({ update: formatEmployer });
	
	                updateGridGroupPipeline();
	
	              case 9:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      return function (_x2) {
	        return _ref4.apply(this, arguments);
	      };
	    }());
	
	    socket.on('EMPLOYER_ASSIGNED_AGENT_UPDATE', function () {
	      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(employerId) {
	        var _ref8, updatedEmployer, formatEmployer, updatedEmployerIndex;
	
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return EmployersApi.getEmployerListing({
	                  id: employerId
	                });
	
	              case 2:
	                _ref8 = _context3.sent;
	                updatedEmployer = _ref8.data;
	                formatEmployer = setEmployersListingData(updatedEmployer);
	                updatedEmployerIndex = vm.employerListing.findIndex(function (_ref9) {
	                  var id = _ref9.id;
	                  return id === employerId;
	                });
	
	                vm.employerListing[updatedEmployerIndex] = formatEmployer[0];
	                vm.gridOptions.api.updateRowData({ update: formatEmployer });
	
	                updateGridGroupPipeline();
	
	              case 9:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this);
	      }));
	
	      return function (_x3) {
	        return _ref7.apply(this, arguments);
	      };
	    }());
	
	    socket.on('EMPLOYER_DELETE', function () {
	      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(employerId) {
	        var deletedEmployer;
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                deletedEmployer = vm.employerListing.filter(function (_ref11) {
	                  var id = _ref11.id;
	                  return id === employerId;
	                });
	
	                vm.employerListing = vm.employerListing.filter(function (_ref12) {
	                  var id = _ref12.id;
	                  return id !== employerId;
	                });
	                vm.gridOptions.api.updateRowData({ remove: deletedEmployer });
	
	                updateGridGroupPipeline();
	                $rootScope.$broadcast('employer-deleted', {
	                  employerDeleted: employerId
	                });
	
	              case 5:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this);
	      }));
	
	      return function (_x4) {
	        return _ref10.apply(this, arguments);
	      };
	    }());
	
	    socket.on('POSITION_CREATE', function () {
	      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(positionId) {
	        var _ref14, positionCreated, updatedEmployerIndex;
	
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _context5.next = 2;
	                return PositionApi.getPositionById(positionId);
	
	              case 2:
	                _ref14 = _context5.sent;
	                positionCreated = _ref14.data;
	                updatedEmployerIndex = vm.employerListing.findIndex(function (_ref15) {
	                  var id = _ref15.id;
	                  return id === positionCreated.employerId;
	                });
	
	
	                vm.employerListing[updatedEmployerIndex].positionCount = Number.parseInt(vm.employerListing[updatedEmployerIndex].positionCount, 10) + 1;
	
	                vm.gridOptions.api.updateRowData({
	                  update: [].concat(_toConsumableArray(vm.employerListing[updatedEmployerIndex]))
	                });
	
	                updateGridGroupPipeline();
	
	              case 8:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this);
	      }));
	
	      return function (_x5) {
	        return _ref13.apply(this, arguments);
	      };
	    }());
	    var columnDefs = [{
	      headerCheckboxSelection: true,
	      headerCheckboxSelectionFilteredOnly: true,
	      checkboxSelection: true,
	      width: 60,
	      filter: false,
	      resizable: false
	    }, {
	      headerName: '',
	      field: '',
	      filter: false,
	      width: 60,
	      resizable: false,
	      cellRenderer: function cellRenderer(parameters) {
	        return parameters.data.isDeleted ? '<center class=""><i class="fa fa-pencil disabled-icon"></i></center>' : '<center class=""><i class="fa fa-pencil pointer"></i></center>';
	      },
	      onCellClicked: openEditEmployerModal
	    }, {
	      headerName: ' Assigned Agent ',
	      field: 'employerAgentEmail',
	      editable: true,
	      cellEditor: 'agRichSelectCellEditor',
	      onCellValueChanged: onAgentChange,
	      cellEditorParams: {
	        values: []
	      },
	      cellClass: 'cellEditable'
	    }, {
	      headerName: 'Notes',
	      columnGroupShow: undefined,
	      field: 'notes',
	      filter: false,
	      resizable: false,
	      width: 110,
	      cellStyle: {
	        background: '#95288f !important',
	        color: '#fff',
	        text: 'center'
	      },
	      cellRenderer: function cellRenderer() {
	        return 'View';
	      },
	      onCellClicked: openNotesPage
	    }, {
	      headerName: 'Employer Id',
	      field: 'id',
	      filter: 'agTextColumnFilter'
	    }, {
	      headerName: 'Employer Name',
	      filter: 'agTextColumnFilter',
	      field: 'name',
	      cellRenderer: function cellRenderer(parameters) {
	        return parameters.data.employerLogo ? '<img src=' + parameters.data.employerLogo + ' style="width: 25px;height:25px; border-radius:50%;margin-right: 5px;margin-bottom: 3px;" alt="pic"><span> ' + parameters.value + '</span>' : '<img src="/images/firmlogo_Default.png" style="width: 25px;height:25px; border-radius:50%;margin-right: 5px;margin-bottom: 3px;" alt="pic"><span> ' + parameters.value + '</span>';
	      }
	    }, {
	      headerName: 'Category',
	      field: 'category'
	    }, {
	      headerName: 'Selectivity',
	      field: 'selectivity'
	    }, {
	      headerName: 'Target Hours',
	      field: 'targetHours'
	    }, {
	      headerName: 'Size',
	      field: 'size',
	      filter: 'agTextColumnFilter'
	    }, {
	      headerName: ' Turnover (£)',
	      field: 'associatesPerPartner'
	    }, {
	      headerName: 'Per Equity Profit',
	      field: 'profitPerEquityPartner'
	    }, {
	      headerName: 'Positions',
	      field: 'positionCount',
	      filter: 'agTextColumnFilter'
	    }, {
	      headerName: 'Candidates Employed',
	      field: 'candidateEmployerCount',
	      filter: 'agTextColumnFilter',
	      cellRenderer: function cellRenderer(parameter) {
	        return parameter.data.candidateEmployerCount ? '<center class=""><a href=\'/admin/lawyer-listing?filterName=currentExperience.employer.name&filterValue=' + parameter.data.id + '\' style="color: #1a78cf;" target="_blank">\n              ' + parameter.data.candidateEmployerCount + ' </a></center>' : '<center class="">' + parameter.data.candidateEmployerCount + '</center>';
	      }
	    }, {
	      headerName: 'Visibility',
	      field: 'isVisible'
	    }];
	
	    var gridOptions = {
	      defaultColDef: {
	        sortable: true,
	        filter: true,
	        enablePivot: true,
	        enableRowGroup: true,
	        enableValue: true,
	        columnGroupShow: 'open',
	        resizable: true,
	        menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab']
	      },
	      groupRowRenderer: 'agGroupCellRenderer',
	      groupRowRendererParams: {
	        checkbox: true
	      },
	      floatingFilter: true,
	      groupDefaultExpanded: -1,
	      groupUseEntireRow: true,
	      columnDefs: columnDefs,
	      animateRows: true,
	      getRowNodeId: function getRowNodeId(data) {
	        return data.id;
	      },
	      enableCellChangeFlash: true,
	      groupSelectsChildren: true,
	      rowData: vm.employerListing,
	      rowSelection: 'multiple',
	      rowMultiSelectWithClick: true,
	      rowGroupPanelShow: 'always',
	      pivotPanelShow: 'always',
	      groupSelectsFiltered: true,
	      onFilterChanged: onFilterChanged,
	      onSelectionChanged: onSelectionChanged,
	      onGridReady: function onGridReady() {
	        initializeEmployersListing();
	      },
	      sideBar: {
	        toolPanels: ['columns', 'filters'],
	        defaultToolPanel: false
	      },
	      statusBar: {
	        statusPanels: [{ statusPanel: 'agTotalRowCountComponent', align: 'left' }, { statusPanel: 'agFilteredRowCountComponent', align: 'left' }, { statusPanel: 'agSelectedRowCountComponent' }, { statusPanel: 'agAggregationComponent' }]
	      },
	      overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your data is loading</span>',
	      suppressCopyRowsToClipboard: true,
	      enableRangeSelection: true,
	      enableCharts: true,
	
	      onColumnRowGroupChanged: updateGridGroupPipeline,
	      getContextMenuItems: getContextMenuItems
	    };
	
	    function openEmployerEditPage() {
	      if (vm.selectedRowsLength === 1) {
	        $window.open('/admin/firm-management?action=edit&id=' + vm.selectedRows[0].id, '_blank');
	      }
	    }
	
	    function onSelectionChanged() {
	      vm.selectedRows = vm.gridOptions.api.getSelectedRows();
	      vm.selectedRowsLength = vm.selectedRows.length;
	      hideShowDropdownActionItem();
	    }
	
	    function onFilterChanged() {
	      vm.filterCount = Object.keys(vm.gridOptions.api.getFilterModel()).length;
	      // eslint-disable-next-line angular/document-service
	      var filterTextBoxValue = document.querySelector('#filter-text-box').value;
	      if (filterTextBoxValue.length > 0) {
	        vm.filterCount += 1;
	      }
	
	      var temporaryFilter = JSON.stringify({
	        status: { values: ['Active'], filterType: 'set' }
	      });
	
	      if (JSON.stringify(vm.gridOptions.api.getFilterModel()) === '{}' || JSON.stringify(vm.gridOptions.api.getFilterModel()) === temporaryFilter) {
	        $log.debug('onFilterChanged', JSON.stringify(vm.gridOptions.api.getFilterModel()));
	        vm.showClearFilter = false;
	      } else vm.showClearFilter = true;
	      updatePipelineCountFromGrid();
	    }
	
	    // TODO: on grid functionality
	    function updatePipelineCountFromGrid() {
	      vm.gridOptions.api.forEachNode(function (node) {
	        if (node.key) {
	          vm.groupList.map(function (row) {
	            if (row.id === node.id) {
	              row.applicationsCount = node.allChildrenCount;
	              return row;
	            }
	
	            return row;
	          });
	        }
	      });
	      $scope.$applyAsync();
	    }
	
	    // TODO: on grid action items functionality
	    function updateGridGroupPipeline() {
	      vm.groupList = [];
	
	      vm.gridOptions.api.forEachNode(function (node) {
	        if (node.key) {
	          var hasChild = true;
	          if (_.isEmpty(node.childrenMapped) || 'undefined' in node.childrenMapped) hasChild = false;
	          vm.groupList.push({
	            name: node.key,
	            applicationsCount: node.allChildrenCount,
	            color: node.leafGroup ? '#' + Math.trunc(Math.random() * 0xffffff).toString(16) : lighten('#5e5e5e', (node.level + 1) * 10),
	            id: node.id,
	            intId: Number(node.id) * -1,
	            level: node.level,
	            parentID: node.parent.id,
	            hasChild: hasChild,
	            isHidden: node.level !== 0
	          });
	        }
	      });
	      $log.debug('vm.groupList', vm.groupList);
	      $scope.$applyAsync();
	    }
	
	    var hideShowDropdownActionItem = function hideShowDropdownActionItem() {
	      vm.multiSelectOptions = undefined;
	      vm.gridDataActions = [];
	      if (vm.selectedRowsLength > 0) {
	        var row = vm.gridOptions.api.getSelectedRows();
	        vm.multiSelectOptions = [{
	          count: vm.selectedRowsLength
	        }, {
	          funcName: 'Clear Selection',
	          function: vm.clearSelection
	        }];
	        vm.gridDataActions = [{
	          count: vm.selectedRowsLength
	        }, {
	          funcName: 'Edit Employer',
	          function: vm.editEmployerModal,
	          rightClick: openEmployerEditPage,
	          funcParameter: row,
	          visible: vm.selectedRowsLength === 1,
	          icon: '/images/edit-pencil.svg'
	        }];
	        $scope.$applyAsync();
	      }
	
	      $scope.$applyAsync();
	    };
	
	    function getContextMenuItems() {
	      var result = [{
	        name: 'Expand All Columns',
	        action: function action() {
	          var columnApi = vm.gridOptions.columnApi.getColumnGroupState();
	          columnApi.forEach(function (item) {
	            vm.gridOptions.columnApi.setColumnGroupOpened(item.groupId, true);
	          });
	        }
	      }, {
	        name: 'Collapse All Columns',
	        action: function action() {
	          var columnApi = vm.gridOptions.columnApi.getColumnGroupState();
	          columnApi.forEach(function (item) {
	            vm.gridOptions.columnApi.setColumnGroupOpened(item.groupId, false);
	          });
	        }
	      }, 'separator', 'copy', 'copyWithHeaders', 'separator', 'chartRange'];
	      vm.isExportAllowed = vm.user.roles.some(function (role) {
	        return role.id === 'admin' || role.id === 'ops';
	      });
	      if (vm.isExportAllowed) result.push('export');
	      return result;
	    }
	
	    function openAddEmployerPage() {
	      $window.open('/admin/firm-management?action=add', '_blank');
	    }
	
	    function openAddPositionPage() {
	      $window.open('/admin/job-creation', '_blank');
	    }
	
	    var positionModal = function positionModal(id) {
	      var modalInstance = $uibModal.open({
	        templateUrl: 'create-update-position-modal.html',
	        windowClass: 'app-firm-window',
	        controller: 'CreateUpdatePositionModalController',
	        controllerAs: 'ctrl',
	        resolve: {
	          selectedPositionId: function selectedPositionId() {
	            return id;
	          },
	          adminId: function adminId() {
	            return vm.user.id;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        modalInstance.dismiss('cancel');
	      }, function () {});
	    };
	
	    function openEditEmployerModal(parameter) {
	      if (parameter.data.id) {
	        employerModal(parameter.data.id);
	      }
	    }
	
	    function openNotesPage(parameter) {
	      var employerName = encodeURIComponent(parameter.data.name);
	      $window.open('/admin/firm-notes?employer=' + parameter.data.id + '&employerName=' + employerName, '_blank');
	    }
	
	    vm.editEmployerModal = function (selectedRow) {
	      var id = selectedRow.map(function (_ref16) {
	        var id = _ref16.id;
	        return id;
	      }).join();
	      employerModal(id);
	    };
	
	    var employerModal = function employerModal(id) {
	      var modalInstance = $uibModal.open({
	        templateUrl: 'create-update-employer-modal.html',
	        windowClass: 'app-firm-window',
	        controller: 'CreateUpdateEmployerModalController',
	        controllerAs: 'ctrl',
	        resolve: {
	          selectedEmployerId: function selectedEmployerId() {
	            return id;
	          }
	        }
	      });
	      modalInstance.result.then(function (result) {
	        modalInstance.dismiss('cancel');
	        var selectedRows = vm.gridOptions.api.getSelectedRows();
	        if (result.type === 'deleted') {
	          vm.gridOptions.api.updateRowData({ remove: selectedRows });
	        }
	
	        logger.notify('success', 'Employer Id: ' + result.employer.id + ' ' + result.employer.name + ' ' + result.type + ' successfully');
	      }, function () {});
	    };
	
	    vm.gridOptions = gridOptions;
	    vm.gridName = 'employer';
	    vm.filterCount = 0;
	
	    vm.actionsFunctions = [{
	      funcName: 'Add Position',
	      leftClick: positionModal
	    }];
	    vm.activeActions = [{
	      funcName: 'Add Employer',
	      function: employerModal,
	      visible: true,
	      icon: '/images/plus-icon.svg'
	    }];
	    var originalEmployersListing = [];
	    vm.hideDropDown = function () {
	      vm.showClass = '';
	    };
	
	    vm.showClass = '';
	    vm.showDropDown = function () {
	      if (vm.showClass === '') {
	        vm.showClass = 'show';
	      } else {
	        vm.showClass = '';
	      }
	    };
	
	    vm.loadEmployersListing = function (employersRecord) {
	      originalEmployersListing = setEmployersListingData(employersRecord);
	      vm.employerListing = originalEmployersListing;
	      vm.gridOptions.api.setRowData(vm.employerListing);
	      $rootScope.$broadcast('listing-loaded');
	
	      $scope.$apply();
	    };
	
	    var setEmployersListingData = function setEmployersListingData(employersRecord) {
	      return employersRecord.map(function (data) {
	        var employerSelectivity = '';
	        if (data.selectivity) {
	          for (var index = 1; index <= data.selectivity; index++) {
	            employerSelectivity += '$';
	          }
	        }
	
	        if (data.selectivity === 0) employerSelectivity = 'Uncategorized';
	        data.selectivity = employerSelectivity;
	        data.isVisible = data.isVisible ? 'Visible' : 'Invisible';
	        data.category = data.specialties.length > 0 ? vm.legalEmployerTypeList.specialties.filter(function (_ref17) {
	          var id = _ref17.id;
	          return data.specialties.find(function (specialty) {
	            return specialty.id === id;
	          });
	        }).map(function (employerType) {
	          return employerType.name;
	        }).join() : data.approved ? '' : 'Auto-Generated';
	        data.employerAgentEmail = data.agentId ? vm.agentsList.find(function (agent) {
	          return agent.id === data.agentId;
	        }) ? vm.agentsList.find(function (agent) {
	          return agent.id === data.agentId;
	        }).email : 'unassigned' : 'unassigned';
	        if (data.logo) data.employerLogo = ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/employers/' + data.id + '/logo/' + data.logo;
	
	        data.positionCount = Number(data.jobsCount);
	        data.candidateEmployerCount = Number(data.candidateEmployerCount);
	
	        return data;
	      });
	    };
	
	    vm.openEmployerCreationPage = function () {
	      $window.open('/admin/firm-management?action=add', '_blank');
	    };
	
	    vm.openPositionCreationPage = function () {
	      $window.open('/admin/job-creation', '_blank');
	    };
	
	    vm.updateSelectedEmployerAgent = function () {
	      var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(selectedAgent) {
	        var selectedRow, selectedEmployerIds, result;
	        return regeneratorRuntime.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                selectedRow = vm.gridOptions.api.getSelectedRows();
	                selectedEmployerIds = selectedRow.map(function (x) {
	                  return x.id;
	                });
	                _context6.next = 4;
	                return updateEmployerAgentApi(selectedEmployerIds, selectedAgent.email, selectedRow);
	
	              case 4:
	                result = _context6.sent;
	
	
	                if (result === 200) {
	                  logger.notify('success', selectedEmployerIds.length + ' employer' + (selectedEmployerIds.length > 1 ? 's' : '') + " assigned to '" + selectedAgent.email + "'");
	                  vm.gridOptions.api.deselectAll();
	                  $('#agentsDropdownList').hide();
	                }
	
	              case 6:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this);
	      }));
	
	      return function (_x6) {
	        return _ref18.apply(this, arguments);
	      };
	    }();
	
	    var updateEmployerAgentApi = function () {
	      var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(employerIds, selectedAgentEmail, selectedRow) {
	        var agent, payload, _ref22, status;
	
	        return regeneratorRuntime.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                agent = selectedAgentEmail === 'unassign' ? // eslint-disable-next-line unicorn/no-null
	                { id: null, email: 'unassigned' } : vm.agentsList.find(function (_ref21) {
	                  var email = _ref21.email;
	                  return email === selectedAgentEmail;
	                });
	                payload = { employerIds: employerIds, agentId: agent.id };
	                _context8.prev = 2;
	                _context8.next = 5;
	                return EmployersApi.updateEmployerAssignedAgent(payload);
	
	              case 5:
	                _ref22 = _context8.sent;
	                status = _ref22.status;
	
	                if (!(status === 200)) {
	                  _context8.next = 11;
	                  break;
	                }
	
	                selectedRow.map(function (row) {
	                  row.employerAgentEmail = agent.email;
	                  return row;
	                });
	                vm.gridOptions.api.updateRowData({ update: selectedRow });
	                return _context8.abrupt('return', status);
	
	              case 11:
	                _context8.next = 16;
	                break;
	
	              case 13:
	                _context8.prev = 13;
	                _context8.t0 = _context8['catch'](2);
	
	                logger.notify('error', _context8.t0.data.message);
	
	              case 16:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this, [[2, 13]]);
	      }));
	
	      return function updateEmployerAgentApi(_x8, _x9, _x10) {
	        return _ref20.apply(this, arguments);
	      };
	    }();
	
	    var initializeEmployersListing = function () {
	      var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
	        var _ref24, _ref25, agentsList, legalPracticeAreaList, legalEmployerTypeList, employersListingRecords, employersAgentsList;
	
	        return regeneratorRuntime.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                _context9.next = 2;
	                return userService.getUser();
	
	              case 2:
	                vm.user = _context9.sent;
	                _context9.next = 5;
	                return Promise.all([CandidateProfileApi.getAdminAndCorporateUsers(), SharedApi.getCategoryById(1), SharedApi.getCategoryById(2), EmployersApi.getEmployerListing()]);
	
	              case 5:
	                _ref24 = _context9.sent;
	                _ref25 = _slicedToArray(_ref24, 4);
	                agentsList = _ref25[0].data;
	                legalPracticeAreaList = _ref25[1].data;
	                legalEmployerTypeList = _ref25[2].data;
	                employersListingRecords = _ref25[3];
	
	
	                vm.agentsList = agentsList;
	                vm.legalPracticeAreaList = legalPracticeAreaList;
	                vm.legalEmployerTypeList = legalEmployerTypeList;
	
	                vm.gridActionsDirective = {
	                  assignAgent: {
	                    buttonId: 'assignee-admin-filter',
	                    agentsList: vm.agentsList,
	                    function: vm.updateSelectedEmployerAgent,
	                    filteredAgentList: vm.agentsList
	                  }
	                };
	
	                employersAgentsList = vm.agentsList.map(function (agent) {
	                  return agent.email;
	                });
	
	                employersAgentsList.unshift('unassign');
	                vm.gridOptions.columnDefs.find(function (column) {
	                  return column.field === 'employerAgentEmail';
	                }).cellEditorParams.values = employersAgentsList;
	                vm.loadEmployersListing(employersListingRecords.data);
	
	              case 19:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this);
	      }));
	
	      return function initializeEmployersListing() {
	        return _ref23.apply(this, arguments);
	      };
	    }();
	  }]);
	})();
	
	var addLight = function addLight(color, amount) {
	  var cc = Number.parseInt(color, 16) + amount;
	  var c = cc > 255 ? 255 : cc;
	  c = c.toString(16).length > 1 ? c.toString(16) : '0' + c.toString(16);
	  return c;
	};
	
	var lighten = function lighten(color, amount) {
	  color = color.includes('#') ? color.slice(1, color.length) : color;
	  // eslint-disable-next-line radix
	  amount = Number.parseInt(255 * amount / 100);
	  color = '#' + addLight(color.slice(0, 2), amount) + addLight(color.slice(2, 4), amount) + addLight(color.slice(4, 6), amount);
	  return color;
	};

/***/ }),
/* 532 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.api').factory('EmployersApi', ['api', function EmployersApi(api) {
	  var employersApi = {
	    getAllEmployers: function getAllEmployers(payload) {
	      return api.get('employers', { params: payload });
	    },
	    createEmployer: function createEmployer(payload) {
	      return api.post('employers', payload);
	    },
	    getEmployerById: function getEmployerById(id) {
	      return api.get('employers/' + id);
	    },
	
	    updateEmployerById: function updateEmployerById(id, payload) {
	      return api.put('employers/' + id, payload);
	    },
	    deleteEmployerById: function deleteEmployerById(id) {
	      return api.delete('employers/' + id);
	    },
	
	    getEmployerLogoByID: function getEmployerLogoByID(id) {
	      return api.get('employers/' + id + '/logo');
	    },
	    uploadEmployerLogo: function uploadEmployerLogo(id, payload) {
	      return api.post('employers/' + id + '/logo', payload, {
	        headers: { 'Content-Type': undefined }
	      });
	    },
	    getEmployerListing: function getEmployerListing(payload) {
	      return api.get('listings/employer', { params: payload });
	    },
	    updateEmployerAssignedAgent: function updateEmployerAssignedAgent(payload) {
	      return api.put('bulk/employers/agent', payload);
	    }
	  };
	  return employersApi;
	}]);

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _loadingOverlay = __webpack_require__(20);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	(function module() {
	  angular.module('app.ui.form.ctrls').controller('InactivePositionListingController', ['$window', 'PositionApi', '$sce', '$uibModal', '$log', 'logger', '$scope', 'SharedApi', 'userService', 'CandidateProfileApi', 'ApplicationsApi', 'socket', '$rootScope', '$timeout', '$location', function controller($window, PositionApi, $sce, $uibModal, $log, logger, $scope, SharedApi, userService, CandidateProfileApi, ApplicationsApi, socket, $rootScope, $timeout, $location) {
	    var _this = this;
	
	    var vm = this;
	
	    socket.on('POSITION_CREATE', function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(positionId) {
	        var _ref2, newPosition, formatPosition;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return PositionApi.getPositionListing({
	                  id: positionId
	                });
	
	              case 2:
	                _ref2 = _context.sent;
	                newPosition = _ref2.data;
	                _context.next = 6;
	                return setGridData(newPosition, vm, $window);
	
	              case 6:
	                formatPosition = _context.sent;
	
	
	                vm.positionListing = [].concat(_toConsumableArray(vm.positionListing), _toConsumableArray(formatPosition));
	                vm.gridOptions.api.updateRowData({
	                  addIndex: vm.positionListing.length,
	                  add: formatPosition
	                });
	                updateGridGroupPipeline();
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }());
	    socket.on('POSITION_UPDATE', function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(positionId) {
	        var _ref4, updatedPosition, formatUpdatedPosition, updatePositionIndex;
	
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return PositionApi.getPositionListing({
	                  id: positionId
	                });
	
	              case 2:
	                _ref4 = _context2.sent;
	                updatedPosition = _ref4.data;
	                _context2.next = 6;
	                return setGridData(updatedPosition, vm, $window);
	
	              case 6:
	                formatUpdatedPosition = _context2.sent;
	                updatePositionIndex = vm.positionListing.findIndex(function (_ref5) {
	                  var id = _ref5.id;
	                  return id === positionId;
	                });
	
	                vm.positionListing[updatePositionIndex] = formatUpdatedPosition[0];
	                vm.gridOptions.api.updateRowData({ update: formatUpdatedPosition });
	
	                updateGridGroupPipeline();
	
	              case 11:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }());
	
	    socket.on('EMPLOYER_UPDATE', function () {
	      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(employerId) {
	        var _ref7, updatedPositions, formatUpdatedPosition;
	
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (!vm.positionListing.some(function (position) {
	                  return position.employerId === employerId;
	                })) {
	                  _context3.next = 12;
	                  break;
	                }
	
	                _context3.next = 3;
	                return PositionApi.getPositionListing({
	                  employerId: employerId
	                });
	
	              case 3:
	                _ref7 = _context3.sent;
	                updatedPositions = _ref7.data;
	
	                if (!(updatedPositions && updatedPositions.length > 0)) {
	                  _context3.next = 12;
	                  break;
	                }
	
	                _context3.next = 8;
	                return setGridData(updatedPositions, vm, $window);
	
	              case 8:
	                formatUpdatedPosition = _context3.sent;
	
	                formatUpdatedPosition.forEach(function (position) {
	                  var index = vm.positionListing.findIndex(function (_ref8) {
	                    var id = _ref8.id;
	                    return id === position.id;
	                  });
	                  vm.positionListing[index] = position;
	                });
	
	                vm.gridOptions.api.updateRowData({ update: formatUpdatedPosition });
	                updateGridGroupPipeline();
	
	              case 12:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this);
	      }));
	
	      return function (_x3) {
	        return _ref6.apply(this, arguments);
	      };
	    }());
	
	    socket.on('APPLICATION_CREATE', function () {
	      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(applicationId) {
	        var _ref10, applicationCreated, updatedPositionIndex;
	
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return ApplicationsApi.getApplicationById(applicationId);
	
	              case 2:
	                _ref10 = _context4.sent;
	                applicationCreated = _ref10.data;
	                updatedPositionIndex = vm.positionListing.findIndex(function (_ref11) {
	                  var id = _ref11.id;
	                  return id === applicationCreated.positionId;
	                });
	
	
	                vm.positionListing[updatedPositionIndex].appliedJobsCount = Number.parseInt(vm.positionListing[updatedPositionIndex].appliedJobsCount, 10) + 1;
	
	                vm.gridOptions.api.updateRowData({
	                  update: [].concat(_toConsumableArray(vm.positionListing[updatedPositionIndex]))
	                });
	
	                updateGridGroupPipeline();
	
	              case 8:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this);
	      }));
	
	      return function (_x4) {
	        return _ref9.apply(this, arguments);
	      };
	    }());
	
	    socket.on('POSITION_DELETE', function () {
	      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(positionId) {
	        var deletedPosition;
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                deletedPosition = vm.positionListing.filter(function (_ref13) {
	                  var id = _ref13.id;
	                  return id === positionId;
	                });
	
	                vm.positionListing = vm.positionListing.filter(function (_ref14) {
	                  var id = _ref14.id;
	                  return id !== positionId;
	                });
	                vm.gridOptions.api.updateRowData({ remove: deletedPosition });
	                $rootScope.$broadcast('position-deleted', {
	                  positionDeleted: positionId
	                });
	                updateGridGroupPipeline();
	
	              case 5:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this);
	      }));
	
	      return function (_x5) {
	        return _ref12.apply(this, arguments);
	      };
	    }());
	    var dateFilterParameters = {
	      suppressAndOrCondition: true,
	      inRangeInclusive: true,
	      comparator: function comparator(filterLocalDateAtMidnight, cellValue) {
	        var dateAsString = moment(cellValue).format('DD/MM/YYYY');
	        var dateParts = dateAsString.split('/');
	        var cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
	
	        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
	          return 0;
	        }
	
	        if (cellDate < filterLocalDateAtMidnight) {
	          return -1;
	        }
	
	        if (cellDate > filterLocalDateAtMidnight) {
	          return 1;
	        }
	      }
	
	      // eslint-disable-next-line unicorn/consistent-function-scoping
	    };function renderDateColumn(parameters) {
	      return parameters.value ? '<span>' + moment(parameters.value).format('DD-MM-YYYY') + '</span>' : ' ';
	    }
	
	    var columnDefs = [{
	      columnGroupShow: undefined,
	      headerCheckboxSelection: true,
	      headerCheckboxSelectionFilteredOnly: true,
	      checkboxSelection: true,
	      width: 60,
	      filter: false,
	      resizable: false
	    }, {
	      headerName: 'Employer Details',
	      children: [{
	        headerName: '',
	        columnGroupShow: undefined,
	        field: '',
	        filter: false,
	        width: 60,
	        resizable: false,
	        cellRenderer: function cellRenderer(parameters) {
	          return parameters.data.archive ? '<center class=""><i class="fa fa-pencil disabled-icon"></i></center>' : '<center class=""><i class="fa fa-pencil pointer"></i></center>';
	        },
	        onCellClicked: openEditPositionModal
	      }, {
	        headerName: '',
	        columnGroupShow: undefined,
	        field: '',
	        filter: false,
	        resizable: false,
	        width: 60,
	        cellStyle: { background: '#95288f !important', color: '#fff' },
	        cellRenderer: function cellRenderer() {
	          return '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n                style="height: 22px;width: 22px;margin: 12px -5px;" viewBox="0 0 614.9 540" style="enable-background:new 0 0 614.9 540;" xml:space="preserve">\n               <style type="text/css">\n                 .pt0{fill:#ffffff;}\n               </style>\n               <g>\n                 <circle class="pt0" cx="282.2" cy="206.9" r="67.3"/>\n                 <path class="pt0" d="M562.6,472.1l-87.8-87.8l3.5-5.1c28-40.4,42.2-86.1,42.2-135.7c0-32.3-6.4-63.6-18.9-93\n                   c-12.5-29.5-29.7-55.3-51-76.6c-21.3-21.3-47.1-38.5-76.6-51C344.6,10.3,313.3,4,281,4c-32.3,0-63.6,6.4-93,18.9\n                   c-29.5,12.5-55.3,29.7-76.6,51C90,95.2,72.9,121,60.3,150.5c-12.5,29.5-18.9,60.8-18.9,93c0,32.3,6.4,63.6,18.9,93\n                   c12.5,29.5,29.7,55.3,51,76.6c21.3,21.3,47.1,38.5,76.6,51c29.5,12.5,60.8,18.9,93,18.9c49.7,0,95.3-14.2,135.7-42.2l5-3.5\n                   l87.9,87.5c7.2,7.6,15.5,11.1,26.3,11.1c10.1,0,18.9-3.8,26.4-11.2c7.4-7.4,11.2-16.3,11.2-26.4\n                   C573.5,488.2,569.8,479.3,562.6,472.1z M397.2,359.7c-0.8,0.8-1.6,1.6-2.5,2.4C363.2,392.6,324.9,408,281,408\n                   c-43.2,0-80.9-14.9-112.2-44.4c-1.6-1.5-2.8-2.7-4.1-3.9c-32-32-48.3-71.1-48.3-116.2c0-45.1,16.2-84.2,48.3-116.2\n                   c32-32,71.1-48.3,116.2-48.3c45.1,0,84.2,16.2,116.2,48.3c32,32,48.3,71.1,48.3,116.2C445.5,288.6,429.2,327.7,397.2,359.7z"/>\n                 <path class="pt0" d="M281.7,387.1c1.6,0,3.3,0,4.9-0.1c-1.7,0.1-3.5,0.1-5.3,0.1C281.5,387.1,281.6,387.1,281.7,387.1z"/>\n                 <path class="pt0" d="M380.4,333.5c-22.2-30.1-57.9-49.6-98.2-49.6c-40.5,0-76.4,19.8-98.6,50.2c23,28.6,58.3,47,97.8,47.1\n                   c1.7,0,3.4,0,5-0.1C324.5,379.6,358.2,361.4,380.4,333.5z"/>\n               </g>s\n               </svg>';
	        },
	        onCellClicked: matchingLawyerClicked
	      }, {
	        headerName: 'Employer',
	        field: 'employer.name',
	        columnGroupShow: undefined,
	        cellRenderer: function cellRenderer(parameters) {
	          return parameters.data.employer.picSrc ? '<img src=' + parameters.data.employer.picSrc + ' style="width: 25px;height:25px; border-radius:50%;margin-right: 5px;margin-bottom: 3px;" alt="pic"><span> ' + parameters.value + '</span>' : '<img src="/images/firmlogo_Default.png" style="width: 25px;height:25px; border-radius:50%;margin-right: 5px;margin-bottom: 3px;" alt="pic"><span> ' + parameters.value + '</span>';
	        }
	      }, {
	        headerName: 'Employer ID',
	        field: 'employerId'
	      }, {
	        headerName: 'Employer Selectivity',
	        field: 'employer.selectivity'
	      }, {
	        headerName: 'Employer Type',
	        field: 'employerType',
	        rowGroupIndex: 0
	      }, {
	        headerName: 'Employer Agent',
	        field: 'employerAgentEmail'
	      }, {
	        headerName: 'Employer Visibility',
	        field: 'employer.isVisible'
	      }]
	    }, {
	      headerName: 'Position Details',
	      children: [{
	        headerName: 'Position Title',
	        field: 'title',
	        filter: 'agTextColumnFilter',
	        cellRenderer: function cellRenderer(parameters) {
	          return parameters.value ? '<span class="text-info pointer"/>' + parameters.value + '</span>' : '';
	        },
	        onCellClicked: openPositionDetailModal,
	        columnGroupShow: undefined
	      }, {
	        headerName: 'Req. PQE',
	        width: 125,
	        field: 'rPQE',
	        columnGroupShow: undefined
	      }, {
	        headerName: 'Location',
	        field: 'locationsName',
	        cellRenderer: function cellRenderer(parameters) {
	          return getLocationsTags(parameters.data.locations);
	        }
	      }, {
	        headerName: 'Practice Areas',
	        field: 'specialtiesName',
	        filter: undefined
	      }, {
	        headerName: 'Contract',
	        field: 'contractType',
	        rowGroupIndex: 2,
	        cellRenderer: function cellRenderer(parameters) {
	          return ' <li class="label label-info text-uppercase margin-r5 position-contract-type-tag">\n                    ' + parameters.value + '\n                  </li> ';
	        }
	      }, {
	        headerName: 'Occupation',
	        field: 'occupation',
	        rowGroupIndex: 1,
	        cellRenderer: function cellRenderer(parameters) {
	          return ' <li class="label label-info text-uppercase margin-r5 position-occupation-tag">\n                    ' + parameters.value + '\n                  </li> ';
	        }
	      }, {
	        headerName: 'Source/External Link',
	        field: 'externalUrl',
	        filter: false,
	        cellRenderer: function cellRenderer(parameters) {
	          var jobUrl = parameters.value ? parameters.value.match(/http/) ? parameters.value : 'http://'.concat(parameters.value) : parameters.value;
	          return parameters.value ? '<span class="text-info pointer"/><a style="color:#4c9bda" href=' + jobUrl + ' target="_blank"/>' + parameters.value + '</span>' : '';
	        }
	      }]
	    }, {
	      headerName: 'Listing Details',
	      children: [{
	        headerName: 'Lexstep Position ID',
	        field: 'id',
	        columnGroupShow: undefined,
	        filter: 'agTextColumnFilter'
	      }, {
	        headerName: 'Current Stage',
	        width: 125,
	        field: 'activeStage',
	        columnGroupShow: undefined
	      }, {
	        headerName: 'Furthest Stage',
	        width: 125,
	        field: 'positionStatus',
	        columnGroupShow: undefined
	      }, {
	        headerName: '# Applicants',
	        field: 'appliedJobsCount'
	      }, {
	        headerName: 'Listing Type',
	        columnGroupShow: undefined,
	        field: 'type'
	      }, {
	        headerName: 'Position Visibility',
	        field: 'visible'
	      }, {
	        headerName: 'Created',
	        field: 'created',
	        cellRenderer: renderDateColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'Expired',
	        field: 'expiresAt',
	        onCellDoubleClicked: openExpiryDateModal,
	        cellRenderer: renderDateColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters,
	        cellClass: 'cellEditable'
	      }, {
	        headerName: 'Status',
	        field: 'status',
	        columnGroupShow: undefined,
	        cellRenderer: 'statusCellRenderer',
	        onCellValueChanged: onStatusChange,
	        editable: true,
	        cellClass: 'cellEditable',
	        cellEditor: 'agRichSelectCellEditor',
	        cellEditorParams: {
	          values: ['Active', 'Expired'],
	          cellRenderer: 'statusCellRenderer'
	        }
	      }]
	    }];
	
	    var gridOptions = {
	      defaultColDef: {
	        sortable: true,
	        filter: true,
	        enablePivot: true,
	        enableRowGroup: true,
	        enableValue: true,
	        columnGroupShow: 'open',
	        resizable: true,
	        menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab']
	      },
	      groupRowRenderer: 'agGroupCellRenderer',
	      groupRowRendererParams: {
	        checkbox: true
	      },
	      floatingFilter: true,
	      groupDefaultExpanded: -1,
	      groupUseEntireRow: true,
	      columnDefs: columnDefs,
	      animateRows: true,
	      getRowNodeId: function getRowNodeId(data) {
	        return data.id;
	      },
	      enableCellChangeFlash: true,
	      groupSelectsChildren: true,
	      rowData: vm.positionListing,
	      rowSelection: 'multiple',
	      rowMultiSelectWithClick: true,
	      rowGroupPanelShow: 'always',
	      pivotPanelShow: 'always',
	      groupSelectsFiltered: true,
	      onFilterChanged: onFilterChanged,
	      onSelectionChanged: onSelectionChanged,
	      onGridReady: function onGridReady() {
	        initializePositionListing();
	      },
	
	      sideBar: {
	        toolPanels: ['columns', 'filters'],
	        defaultToolPanel: false
	      },
	      statusBar: {
	        statusPanels: [{ statusPanel: 'agTotalRowCountComponent', align: 'left' }, { statusPanel: 'agFilteredRowCountComponent', align: 'left' }, { statusPanel: 'agSelectedRowCountComponent' }, { statusPanel: 'agAggregationComponent' }]
	      },
	      components: {
	        statusCellRenderer: StatusCellRenderer
	      },
	      overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your data is loading</span>',
	      suppressCopyRowsToClipboard: true,
	      enableRangeSelection: true,
	      enableCharts: true,
	      onColumnRowGroupChanged: updateGridGroupPipeline,
	      getContextMenuItems: getContextMenuItems
	    };
	
	    vm.gridOptions = gridOptions;
	
	    vm.loadPositionListing = function () {
	      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(positionListingRecords) {
	        return regeneratorRuntime.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                if (!(positionListingRecords.status === 200)) {
	                  _context6.next = 8;
	                  break;
	                }
	
	                _context6.next = 3;
	                return setGridData(positionListingRecords.data, vm, $window);
	
	              case 3:
	                vm.positionListing = _context6.sent;
	
	                vm.gridOptions.api.setRowData(vm.positionListing);
	
	                updateGridGroupPipeline();
	                _context6.next = 9;
	                break;
	
	              case 8:
	                vm.changeStatus(positionListingRecords.status);
	
	              case 9:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this);
	      }));
	
	      return function (_x6) {
	        return _ref15.apply(this, arguments);
	      };
	    }();
	
	    var employerModal = function employerModal() {
	      var modalInstance = $uibModal.open({
	        templateUrl: 'create-update-employer-modal.html',
	        windowClass: 'app-firm-window',
	        controller: 'CreateUpdateEmployerModalController',
	        controllerAs: 'ctrl',
	        resolve: {
	          selectedEmployerId: function selectedEmployerId() {}
	        }
	      });
	      modalInstance.result.then(function (result) {
	        var employer = result.employer;
	
	        modalInstance.dismiss('cancel');
	        logger.notify('success', 'Employer Id: ' + employer.id + ' ' + employer.name + ' created successfully');
	      }, function () {});
	    };
	
	    function openAddEmployerPage() {
	      $window.open('/admin/firm-management?action=add', '_blank');
	    }
	
	    var positionModal = function positionModal(id) {
	      var modalInstance = $uibModal.open({
	        templateUrl: 'create-update-position-modal.html',
	        windowClass: 'app-firm-window',
	        controller: 'CreateUpdatePositionModalController',
	        controllerAs: 'ctrl',
	        resolve: {
	          selectedPositionId: function selectedPositionId() {
	            return id;
	          },
	          adminId: function adminId() {
	            return vm.user.id;
	          }
	        }
	      });
	      modalInstance.result.then(function (_position) {
	        modalInstance.dismiss('cancel');
	      }, function () {});
	    };
	
	    // Function openAddPositionPage() {
	    //   $window.open('/admin/job-creation', '_blank')
	    // }
	
	    function openEditPositionModal(parameter) {
	      if (parameter.data.id) {
	        positionModal(parameter.data.id);
	      }
	    }
	
	    function openPositionDetailModal(parameter) {
	      if (parameter.data) {
	        positionDetailModal(parameter.data);
	      }
	    }
	
	    var positionDetailModal = function positionDetailModal(_position2) {
	      $uibModal.open({
	        templateUrl: 'position-details-modal.html',
	        windowClass: 'position-modal-window',
	        controller: 'PositionDetailsController',
	        controllerAs: 'ctrl',
	        resolve: {
	          position: function position() {
	            return _position2;
	          },
	          listingName: function listingName() {
	            return vm.gridName;
	          }
	        }
	      });
	    };
	
	    function openExpiryDateModal(parameter) {
	      var _this2 = this;
	
	      vm.dateModal = {
	        title: 'Expiry Date',
	        date: parameter.data.expiresAt
	      };
	      var modalInstance = $uibModal.open({
	        templateUrl: 'date-modal.html',
	        controller: 'DateModalController',
	        controllerAs: 'ctrl',
	        resolve: {
	          selectedModal: function selectedModal() {
	            return vm.dateModal;
	          },
	          id: function id() {
	            return parameter.data.id;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(selectedDate) {
	          return regeneratorRuntime.wrap(function _callee7$(_context7) {
	            while (1) {
	              switch (_context7.prev = _context7.next) {
	                case 0:
	                  if (selectedDate.date === vm.dateModal.date) {
	                    logger.notify('warning', 'Same Date not updated.');
	                  } else if (!selectedDate.date) {
	                    logger.notify('warning', 'Date is empty.');
	                  } else if (selectedDate.date !== vm.dateModal.date) {
	                    if (new Date(selectedDate.date).setHours(0, 0, 0, 0) === new Date(parameter.data.created).setHours(0, 0, 0, 0)) {
	                      selectedDate.date = new Date(parameter.data.created).setMinutes(new Date(parameter.data.created).getMinutes() + 1);
	                    }
	
	                    if (selectedDate.date < new Date()) parameter.data.status = 'Expired';else parameter.data.status = 'Active';
	                    updateExpiryDate(parameter.data, selectedDate.date, vm.dateModal.title);
	                  }
	
	                case 1:
	                case 'end':
	                  return _context7.stop();
	              }
	            }
	          }, _callee7, _this2);
	        }));
	
	        return function (_x7) {
	          return _ref16.apply(this, arguments);
	        };
	      }(), function () {});
	    }
	
	    var updateExpiryDate = function () {
	      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(row, date, title) {
	        var _ref18, data, status;
	
	        return regeneratorRuntime.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _context8.prev = 0;
	                _context8.next = 3;
	                return PositionApi.updatePositionById(row.id, {
	                  expiresAt: date
	                });
	
	              case 3:
	                _ref18 = _context8.sent;
	                data = _ref18.data;
	                status = _ref18.status;
	
	                if (status === 200) {
	                  logger.notify('success', 'Position Id: ' + data.id + ' ' + title + ' updated successfully');
	                  row.expiresAt = data.expiresAt;
	                  vm.gridOptions.api.updateRowData({ update: [row] });
	                }
	                _context8.next = 12;
	                break;
	
	              case 9:
	                _context8.prev = 9;
	                _context8.t0 = _context8['catch'](0);
	
	                logger.notify('error', _context8.t0.data.message);
	
	              case 12:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this, [[0, 9]]);
	      }));
	
	      return function updateExpiryDate(_x8, _x9, _x10) {
	        return _ref17.apply(this, arguments);
	      };
	    }();
	
	    function onStatusChange(parameter) {
	      if (parameter.newValue !== parameter.oldValue) {
	        // eslint-disable-next-line unicorn/no-null
	        var expiryDate = null;
	        if (parameter.newValue === 'Expired') expiryDate = new Date(parameter.data.created).setMinutes(new Date(parameter.data.created).getMinutes() + 1);
	        parameter.data.status = parameter.newValue;
	        updateExpiryDate(parameter.data, expiryDate, 'Status');
	      }
	    }
	
	    function onFilterChanged() {
	      vm.filterCount = Object.keys(vm.gridOptions.api.getFilterModel()).length;
	      var filterTextBoxValue = document.querySelector('#filter-text-box').value;
	      if (filterTextBoxValue.length > 0) {
	        vm.filterCount += 1;
	      }
	
	      var temporaryFilter = JSON.stringify({
	        status: { values: ['Active'], filterType: 'set' }
	      });
	
	      if (JSON.stringify(vm.gridOptions.api.getFilterModel()) === '{}' || JSON.stringify(vm.gridOptions.api.getFilterModel()) === temporaryFilter) {
	        $log.debug('onFilterChanged', JSON.stringify(vm.gridOptions.api.getFilterModel()));
	        vm.showClearFilter = false;
	      } else vm.showClearFilter = true;
	      updatePipelineCountFromGrid();
	    }
	
	    // TODO: on grid functionality
	    function updatePipelineCountFromGrid() {
	      vm.gridOptions.api.forEachNode(function (node) {
	        if (node.key) {
	          vm.groupList.map(function (row) {
	            if (row.id === node.id) {
	              row.applicationsCount = node.allChildrenCount;
	              return row;
	            }
	
	            return row;
	          });
	        }
	      });
	      $scope.$applyAsync();
	    }
	
	    // TODO: on grid action items functionality
	    function updateGridGroupPipeline() {
	      vm.groupList = [];
	
	      vm.gridOptions.api.forEachNode(function (node) {
	        if (node.key) {
	          var hasChild = true;
	          if (_.isEmpty(node.childrenMapped) || 'undefined' in node.childrenMapped) hasChild = false;
	          vm.groupList.push({
	            name: node.key,
	            applicationsCount: node.allChildrenCount,
	            color: node.leafGroup ? '#' + Math.trunc(Math.random() * 0xffffff).toString(16) : lighten('#5e5e5e', (node.level + 1) * 10),
	            id: node.id,
	            intId: Number(node.id) * -1,
	            level: node.level,
	            parentID: node.parent.id,
	            hasChild: hasChild,
	            isHidden: node.level !== 0
	          });
	        }
	      });
	      $log.debug('vm.groupList', vm.groupList);
	      $scope.$applyAsync();
	    }
	
	    function onSelectionChanged() {
	      vm.selectedRows = vm.gridOptions.api.getSelectedRows();
	      vm.selectedRowsLength = vm.selectedRows.length;
	      hideShowDropdownActionItem();
	    }
	
	    vm.editPositionModal = function (selectedRow) {
	      var id = selectedRow.map(function (_ref19) {
	        var id = _ref19.id;
	        return id;
	      }).join();
	      positionModal(id);
	    };
	
	    vm.openMatchesTab = function (tabData) {
	      if (tabData.employerId) $window.open('/admin/matching-lawyers?positionId=' + tabData.positionId + '&employerId=' + tabData.employerId + '&tab=' + tabData.tab, '_blank');else $window.open('/admin/matching-lawyers?positionId=' + tabData.positionId + '&tab=' + tabData.tab, '_blank');
	    };
	
	    vm.multipleUpdateExpiryDate = function (selectedRows) {
	      vm.dateModal = {
	        title: 'Expiry Date',
	        date: ''
	      };
	      var modalInstance = $uibModal.open({
	        templateUrl: 'date-modal.html',
	        controller: 'DateModalController',
	        controllerAs: 'ctrl',
	        resolve: {
	          selectedModal: function selectedModal() {
	            return vm.dateModal;
	          },
	          id: function id() {
	            return selectedRows.map(function (row) {
	              return { id: row.id };
	            });
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(selectedDate) {
	          var payload, _ref21, status;
	
	          return regeneratorRuntime.wrap(function _callee9$(_context9) {
	            while (1) {
	              switch (_context9.prev = _context9.next) {
	                case 0:
	                  if (!selectedDate.date) {
	                    _context9.next = 14;
	                    break;
	                  }
	
	                  if (new Date(selectedDate.date).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)) {
	                    selectedDate.date = new Date();
	                  }
	
	                  payload = selectedRows.map(function (row) {
	                    return {
	                      id: row.id,
	                      editPositionDto: {
	                        expiresAt: selectedDate.date
	                      }
	                    };
	                  });
	                  _context9.prev = 3;
	                  _context9.next = 6;
	                  return PositionApi.updateMultiplePositions(payload);
	
	                case 6:
	                  _ref21 = _context9.sent;
	                  status = _ref21.status;
	
	                  if (status === 200) {
	                    logger.notify('success', 'Multiple Expiry Date updated successfully');
	
	                    selectedRows.map(function (row) {
	                      row.expiresAt = selectedDate.date;
	                      row.status = selectedDate.date < new Date() ? 'Expired' : 'Active';
	                      return row;
	                    });
	
	                    vm.gridOptions.api.updateRowData({ update: selectedRows });
	                  }
	                  _context9.next = 14;
	                  break;
	
	                case 11:
	                  _context9.prev = 11;
	                  _context9.t0 = _context9['catch'](3);
	
	                  logger.notify('error', _context9.t0.data.message);
	
	                case 14:
	                case 'end':
	                  return _context9.stop();
	              }
	            }
	          }, _callee9, _this, [[3, 11]]);
	        }));
	
	        return function (_x11) {
	          return _ref20.apply(this, arguments);
	        };
	      }(), function () {});
	    };
	
	    vm.openClonePositions = function () {
	      var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(selectedRows, event) {
	        var getData, withData, clonePositionData, modalInstance;
	        return regeneratorRuntime.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                event.preventDefault();
	                event.stopPropagation();
	                console.debug('openClonePositions', selectedRows);
	
	                if (!(!selectedRows || selectedRows.length === 0)) {
	                  _context11.next = 5;
	                  break;
	                }
	
	                return _context11.abrupt('return');
	
	              case 5:
	                getData = function () {
	                  var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
	                    var _ref24, positionData, withData;
	
	                    return regeneratorRuntime.wrap(function _callee10$(_context10) {
	                      while (1) {
	                        switch (_context10.prev = _context10.next) {
	                          case 0:
	                            _context10.next = 2;
	                            return PositionApi.getAllPositions({
	                              params: {
	                                ids: selectedRows.map(function (_ref25) {
	                                  var id = _ref25.id;
	                                  return id;
	                                }),
	                                only: ['description']
	                              }
	                            });
	
	                          case 2:
	                            _ref24 = _context10.sent;
	                            positionData = _ref24.data;
	
	
	                            console.debug('got position data:', positionData);
	
	                            withData = selectedRows.map(function (item) {
	                              return _.extend(item, positionData.find(function (data) {
	                                return data.id === item.id;
	                              }));
	                            });
	
	                            console.debug('withData:', withData);
	                            return _context10.abrupt('return', withData);
	
	                          case 8:
	                          case 'end':
	                            return _context10.stop();
	                        }
	                      }
	                    }, _callee10, _this);
	                  }));
	
	                  return function getData() {
	                    return _ref23.apply(this, arguments);
	                  };
	                }();
	
	                _context11.next = 8;
	                return (0, _loadingOverlay.wrap)(getData);
	
	              case 8:
	                withData = _context11.sent;
	                clonePositionData = {
	                  positions: withData,
	                  selectOnReset: true,
	                  allPracticeArea: vm.onlyParentPracticeAreaList,
	                  allLocations: vm.locationsList,
	                  allOccupations: vm.occupationList,
	                  allContractType: vm.contractTypesList
	                };
	                modalInstance = $uibModal.open({
	                  templateUrl: 'clone-position-modal.html',
	                  controller: 'ClonePositionController',
	                  controllerAs: 'ctrl',
	                  resolve: {
	                    cloningData: function cloningData() {
	                      return clonePositionData;
	                    }
	                  }
	                });
	
	                modalInstance.result.then(function () {}, function () {});
	
	              case 12:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, _this);
	      }));
	
	      return function (_x12, _x13) {
	        return _ref22.apply(this, arguments);
	      };
	    }();
	
	    var hideShowDropdownActionItem = function hideShowDropdownActionItem() {
	      vm.gridDataActions = undefined;
	      vm.multiSelectOptions = undefined;
	      vm.multipleSelectionActions = undefined;
	      if (vm.selectedRowsLength > 0) {
	        var row = vm.gridOptions.api.getSelectedRows();
	        vm.multiSelectOptions = [{
	          count: vm.selectedRowsLength
	        }, {
	          funcName: 'Clear Selection',
	          function: vm.clearSelection
	        }];
	        vm.multipleSelectionActions = [{
	          funcName: 'Edit Expiry Date',
	          function: vm.multipleUpdateExpiryDate,
	          funcParameter: row,
	          visible: true,
	          icon: '/images/history-clock-button.svg'
	        }, {
	          funcName: 'Clone Position',
	          function: vm.openClonePositions,
	          visible: true,
	          funcParameter: row,
	          icon: '/images/clone-position.svg'
	        }];
	        vm.gridDataActions = [{
	          count: vm.selectedRowsLength
	        }, {
	          funcName: 'Edit Position',
	          function: vm.editPositionModal,
	          funcParameter: row,
	          visible: vm.selectedRowsLength === 1,
	          icon: '/images/edit-pencil.svg'
	        }, {
	          funcName: 'View Position',
	          function: vm.openMatchesTab,
	          visible: vm.selectedRowsLength === 1,
	          funcParameter: {
	            positionId: row[0].id,
	            tab: 3,
	            employerId: row[0].employerId
	          },
	          icon: '/images/view-position.svg'
	        }, {
	          funcName: 'Scout Matches',
	          function: vm.openMatchesTab,
	          visible: vm.selectedRowsLength === 1,
	          funcParameter: {
	            positionId: row[0].id,
	            tab: 1,
	            employerId: row[0].employerId
	          },
	          icon: '/images/Matches.svg'
	        }, {
	          funcName: 'Interest in Position',
	          function: vm.openMatchesTab,
	          visible: vm.selectedRowsLength === 1,
	          funcParameter: {
	            positionId: row[0].id,
	            tab: 2,
	            employerId: row[0].employerId
	          },
	          icon: '/images/Applications.svg'
	        }];
	        $scope.$applyAsync();
	      }
	
	      $scope.$applyAsync();
	    };
	
	    function getContextMenuItems() {
	      var result = [{
	        name: 'Expand All Columns',
	        action: function action() {
	          var columnApi = vm.gridOptions.columnApi.getColumnGroupState();
	          columnApi.forEach(function (item) {
	            vm.gridOptions.columnApi.setColumnGroupOpened(item.groupId, true);
	          });
	        }
	      }, {
	        name: 'Collapse All Columns',
	        action: function action() {
	          var columnApi = vm.gridOptions.columnApi.getColumnGroupState();
	          columnApi.forEach(function (item) {
	            vm.gridOptions.columnApi.setColumnGroupOpened(item.groupId, false);
	          });
	        }
	      }, 'separator', 'copy', 'copyWithHeaders', 'separator', 'chartRange'];
	
	      vm.isExportAllowed = vm.user.roles.some(function (role) {
	        return role.id === 'admin' || role.id === 'ops';
	      });
	      if (vm.isExportAllowed) result.push('export');
	      return result;
	    }
	
	    function matchingLawyerClicked(parameters) {
	      if (parameters.data.id) {
	        $window.open('/admin/matching-lawyers?positionId=' + parameters.data.id + '&employerId=' + parameters.data.employerId, '_blank');
	      }
	    }
	
	    // eslint-disable-next-line unicorn/consistent-function-scoping
	    function StatusCellRenderer() {}
	    StatusCellRenderer.prototype.init = function (parameters) {
	      vm.eGui = document.createElement('div');
	      var color = 'Red';
	      if (parameters.value === 'Active') {
	        color = 'Yellow';
	      }
	
	      vm.eGui.innerHTML = '<span style="display:inline-block;margin-bottom:-2px;width:15px;height:15px;background:' + color + ';border-radius:20px;"> </span>' + '<span> ' + parameters.value + '</span>';
	    };
	
	    StatusCellRenderer.prototype.getGui = function () {
	      return vm.eGui;
	    };
	
	    vm.gridName = 'position';
	    vm.filterCount = 0;
	    vm.helpTooltip = {
	      name: 'Help',
	      content: $sce.trustAsHtml(positionHelpContent)
	    };
	
	    vm.actionsFunctions = [{
	      funcName: 'Add Employer',
	      leftClick: employerModal
	    }];
	    vm.activeActions = [{
	      funcName: 'Add Position',
	      function: positionModal,
	      visible: true,
	      icon: '/images/plus-icon.svg'
	    }];
	
	    vm.sliderFilter = function (filterPqe) {
	      var separator = filterPqe.pqe.search(';');
	      var minPQE = Number(filterPqe.pqe.slice(0, separator));
	      var maxPQE = Number(filterPqe.pqe.slice(separator + 1, filterPqe.pqe.length));
	      if (maxPQE === 11) maxPQE = 50;
	      if (minPQE === -2) minPQE = -20;
	      var range = _.range(minPQE, maxPQE + 0.5, 0.5);
	      var filterValues = range.map(function (element) {
	        return String(element);
	      });
	      var currentActiveFilters = vm.gridOptions.api.getFilterModel();
	      if (maxPQE === 50 && minPQE === -20) {
	        delete currentActiveFilters.rPQE;
	        gridOptions.api.setFilterModel(currentActiveFilters);
	      } else {
	        currentActiveFilters.rPQE = {
	          values: filterValues,
	          filterType: 'set'
	        };
	        gridOptions.api.setFilterModel(currentActiveFilters);
	      }
	
	      $scope.$applyAsync();
	    };
	
	    vm.loadExpiredPositions = function () {
	      var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(totalExpiredPositionCount) {
	        var _vm$positionListing;
	
	        var offset, footer, existingFilters, filter;
	        return regeneratorRuntime.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                vm.expiredPositionListing = [];
	                offset = 0;
	                footer = document.querySelector('#' + vm.gridName).querySelector('.ag-status-bar-center');
	
	                footer.innerHTML = '<div style="text-align: center;align-self: center; display: flex;">\n                              <div class="agGridLoader"></div>\n                              <span style="padding-left: 15px">Loading Expired Positions </span>\n                            </div> ';
	
	                _context12.next = 6;
	                return new Promise(function (resolve, reject) {
	                  return getExpiredPosition(resolve, reject, offset, totalExpiredPositionCount);
	                });
	
	              case 6:
	                $rootScope.$broadcast('listing-loaded');
	                footer.innerHTML = '<div style="text-align: center;align-self: center; display: flex;">\n              <i class="fa fa-check" style="font-size:20px; color:green" aria-hidden="true"></i>\n              <span style="padding-left: 15px" align-self: center;">Loaded Expired Positions Successfully</span>\n              </div>';
	
	                (_vm$positionListing = vm.positionListing).push.apply(_vm$positionListing, _toConsumableArray(vm.expiredPositionListing));
	                existingFilters = vm.gridOptions.api.getFilterModel();
	
	                if (Object.keys(existingFilters).length === 0) {
	                  filter = {
	                    status: { values: ['Active'], filterType: 'set' }
	                  };
	
	                  vm.gridOptions.api.setFilterModel(filter);
	                }
	
	                updateGridGroupPipeline();
	                $timeout(function () {
	                  footer.innerHTML = '';
	                }, 1500);
	
	              case 13:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, _this);
	      }));
	
	      return function (_x14) {
	        return _ref26.apply(this, arguments);
	      };
	    }();
	
	    var getExpiredPosition = function () {
	      var _ref27 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(resolve, reject, offset, totalExpiredPositionCount) {
	        var payload, _ref28, expiredPositionList, _vm$expiredPositionLi, expiredPosition;
	
	        return regeneratorRuntime.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                payload = { active: false, limit: 10000 };
	
	                payload.offset = offset;
	                _context13.next = 4;
	                return PositionApi.getPositionListing(payload);
	
	              case 4:
	                _ref28 = _context13.sent;
	                expiredPositionList = _ref28.data;
	
	                if (!(offset <= totalExpiredPositionCount && $location.url().contains('admin/inactive-positions'))) {
	                  _context13.next = 16;
	                  break;
	                }
	
	                offset += payload.limit;
	                getExpiredPosition(resolve, reject, offset, totalExpiredPositionCount);
	                _context13.next = 11;
	                return setGridData(expiredPositionList, vm, $window);
	
	              case 11:
	                expiredPosition = _context13.sent;
	
	                (_vm$expiredPositionLi = vm.expiredPositionListing).push.apply(_vm$expiredPositionLi, _toConsumableArray(expiredPosition));
	
	                vm.gridOptions.api.updateRowData({ add: expiredPosition });
	                _context13.next = 17;
	                break;
	
	              case 16:
	                return _context13.abrupt('return', resolve());
	
	              case 17:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, _this);
	      }));
	
	      return function getExpiredPosition(_x15, _x16, _x17, _x18) {
	        return _ref27.apply(this, arguments);
	      };
	    }();
	
	    var initializePositionListing = function () {
	      var _ref29 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
	        var _ref30, _ref31, locationsList, contractTypeList, occupationList, legalPracticeAreaList, legalEmployerTypeList, candidateAgents, activePositionListingRecords, expiredPositionListingCount;
	
	        return regeneratorRuntime.wrap(function _callee14$(_context14) {
	          while (1) {
	            switch (_context14.prev = _context14.next) {
	              case 0:
	                _context14.next = 2;
	                return userService.getUser();
	
	              case 2:
	                vm.user = _context14.sent;
	                _context14.next = 5;
	                return Promise.all([SharedApi.getAllLocations({
	                  supported: true,
	                  regions: true
	                }), SharedApi.getAllContractTypes(), SharedApi.getAllOccupations(), SharedApi.getCategoryById(1), SharedApi.getCategoryById(2), CandidateProfileApi.getAdminAndCorporateUsers(), PositionApi.getPositionListing({ active: true }), PositionApi.getPositionListing({ active: false, count: true })]);
	
	              case 5:
	                _ref30 = _context14.sent;
	                _ref31 = _slicedToArray(_ref30, 8);
	                locationsList = _ref31[0].data;
	                contractTypeList = _ref31[1].data;
	                occupationList = _ref31[2].data;
	                legalPracticeAreaList = _ref31[3].data;
	                legalEmployerTypeList = _ref31[4].data;
	                candidateAgents = _ref31[5].data;
	                activePositionListingRecords = _ref31[6];
	                expiredPositionListingCount = _ref31[7].data;
	
	
	                vm.candidateAgentsList = candidateAgents;
	                vm.contractTypesList = contractTypeList;
	                vm.occupationList = occupationList;
	                vm.legalPracticeAreaList = legalPracticeAreaList;
	                vm.legalEmployerTypeList = legalEmployerTypeList;
	                vm.locationsList = locationsList;
	
	                vm.onlyParentPracticeAreaList = vm.legalPracticeAreaList.specialties.filter(function (_ref32) {
	                  var parentId = _ref32.parentId;
	                  return parentId === null;
	                });
	                vm.gridActionsDirective = {
	                  // PqeSlider: {
	                  //   function: vm.sliderFilter,
	                  //   params: {
	                  //     options: {
	                  //       round: 1,
	                  //       from: -2,
	                  //       to: 11,
	                  //       step: 0.5,
	                  //       dimension: ' years',
	                  //       scale: ['≤-2', -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '≥11'],
	                  //     },
	                  //     filterPQE: {
	                  //       pqe: '-2;11',
	                  //     },
	                  //   },
	                  //   buttonId: 'lawyer-listing-pqe-slider',
	                  //   icon: 'images/stage.svg',
	                  // },
	                  practices: {
	                    buttonId: 'position-listing-filter-prac',
	                    allPracticeAreaList: vm.onlyParentPracticeAreaList,
	                    iconLabel: 'Filter by Practice Area'
	                  }
	                };
	                vm.loadPositionListing(activePositionListingRecords);
	                vm.loadExpiredPositions(expiredPositionListingCount);
	
	              case 25:
	              case 'end':
	                return _context14.stop();
	            }
	          }
	        }, _callee14, _this);
	      }));
	
	      return function initializePositionListing() {
	        return _ref29.apply(this, arguments);
	      };
	    }();
	  }]);
	})();
	
	var addLight = function addLight(color, amount) {
	  var cc = Number.parseInt(color, 16) + amount;
	  var c = cc > 255 ? 255 : cc;
	  c = c.toString(16).length > 1 ? c.toString(16) : '0' + c.toString(16);
	  return c;
	};
	
	var lighten = function lighten(color, amount) {
	  color = color.includes('#') ? color.slice(1, color.length) : color;
	  // eslint-disable-next-line radix
	  amount = Number.parseInt(255 * amount / 100);
	  color = '#' + addLight(color.slice(0, 2), amount) + addLight(color.slice(2, 4), amount) + addLight(color.slice(4, 6), amount);
	  return color;
	};
	
	var getLocationsTags = function getLocationsTags(positionLocations) {
	  var locationTags = '';
	  if (positionLocations && positionLocations.length > 0) {
	    positionLocations.forEach(function (positionLocation) {
	      locationTags += ' <li class="label text-uppercase margin-r5 location-' + positionLocation.color + '" >\n          ' + positionLocation.name + '\n        </li> ';
	    });
	  }
	
	  return locationTags;
	};
	
	var setGridData = function setGridData(allPositionRecord, vm) {
	  return Promise.all(allPositionRecord.map(function () {
	    var _ref33 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(data) {
	      return regeneratorRuntime.wrap(function _callee15$(_context15) {
	        while (1) {
	          switch (_context15.prev = _context15.next) {
	            case 0:
	              if (data.employer) setEmployerForPositionListing(data, vm);
	              data.locations = data.locations.length > 0 ? vm.locationsList.filter(function (_ref34) {
	                var id = _ref34.id;
	                return data.locations.find(function (location) {
	                  return location.id === id;
	                });
	              }).map(function (location) {
	                return {
	                  id: location.id,
	                  name: location.name,
	                  parent: location.parent,
	                  color: location.country.region.color
	                };
	              }) : [];
	              data.locationsName = data.locations.length > 0 ? data.locations.map(function (location) {
	                return location.name;
	              }) : [];
	              data.specialties = data.specialties.length > 0 ? vm.legalPracticeAreaList.specialties.filter(function (_ref35) {
	                var id = _ref35.id;
	                return data.specialties.find(function (specialty) {
	                  return specialty.id === id;
	                });
	              }) : [];
	              data.specialtiesName = data.specialties.length > 0 ? data.specialties.map(function (practiceArea) {
	                return practiceArea.name;
	              }) : [];
	
	              data.contractType = data.contractTypeId !== null || data.contractTypeId !== undefined ? vm.contractTypesList.find(function (contract) {
	                return contract.id === data.contractTypeId;
	              }).name : '';
	              data.occupation = data.occupationId ? vm.occupationList.find(function (occupation) {
	                return occupation.id === data.occupationId;
	              }).name : '';
	              data.rPQE = '' + (data.lawPreferences.minPqe <= 0 ? 'NQ' : data.lawPreferences.minPqe) + (data.lawPreferences.maxPqe === 11 ? '+' : data.lawPreferences.maxPqe <= 0 || data.lawPreferences.maxPqe === data.lawPreferences.minPqe ? '' : '-' + data.lawPreferences.maxPqe.toString());
	              data.visible = data.visible ? 'Visible' : 'Invisible';
	              data.status = data.expiresAt ? new Date(data.expiresAt).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0) ? 'Expired' : 'Active' : 'Active';
	              return _context15.abrupt('return', data);
	
	            case 11:
	            case 'end':
	              return _context15.stop();
	          }
	        }
	      }, _callee15, undefined);
	    }));
	
	    return function (_x19) {
	      return _ref33.apply(this, arguments);
	    };
	  }()));
	};
	
	var setEmployerForPositionListing = function setEmployerForPositionListing(data, vm) {
	  var employerSelectivity = '';
	
	  if (data.employer.selectivity) {
	    for (var index = 1; index <= data.employer.selectivity; index++) {
	      employerSelectivity += '$';
	    }
	  }
	
	  if (data.employer.selectivity === 0) employerSelectivity = 'Uncategorized';
	
	  if (data.employer.logo) data.employer.picSrc = ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/employers/' + data.employerId + '/logo/' + data.employer.logo;
	
	  data.employer.selectivity = employerSelectivity;
	  data.employerAgentEmail = data.employer.agentId ? vm.candidateAgentsList.find(function (agent) {
	    return agent.id === data.employer.agentId;
	  }) ? vm.candidateAgentsList.find(function (agent) {
	    return agent.id === data.employer.agentId;
	  }).email : 'unassigned' : 'unassigned';
	  data.employer.isVisible = data.employer.isVisible ? 'Visible' : 'Invisible';
	  data.employerType = data.employerType.length > 0 ? vm.legalEmployerTypeList.specialties.filter(function (_ref36) {
	    var id = _ref36.id;
	    return data.employerType.find(function (employerType) {
	      return employerType.id === id;
	    });
	  }).map(function (employerType) {
	    return employerType.name;
	  }).join() : 'Auto-Generated';
	  return data;
	};
	
	var positionHelpContent = '\n<div>\n<p>\tPositions allows you to search for positions based on specific criteria you define.</p>\n<b>My Employers</b>\n<p>Filter by \u201CMy Employers\u201D from the toolbar above the grid to display positions at your assigned employers only.</p>\n<b>Filtering</b>\n<p>The \u201CFilter by Practice Area\u201D icon allows you to quickly refine your search. Further filters can be applied by hovering over each column header and selecting the hamburger menu on the right.</p>\n<b>Views</b>\n<p>Personalise different list layouts by choosing the columns to display, adjusting their width and moving them to re-order to your preferences. You can save custom column layouts with filter criteria to easy access again later via the \u201CViews\u201D icon in the top right -- either as a Private \u201CSaved View\u201D or Shared with other team members. The Views menu includes pre-set views that filter for Private Practice and In-House positions.</p>\n<b>Clear</b>\n<p>When one or more filters are applied, a Clear filter icon will appear in the top right above the grid. Select to clear any applied filters and/or search and reset the grid data to default.</p>\n<b>Group</b>\n<p>Drag and drop columns to the grouping drop zone in the grid\u2019s top row to group rows by a particular column.  You can Expand/Collapse All Rows from the Views icon in the top right to view positions by Group.</p>\n<b>Sorting</b>\n<p>Positions are sorted by Position ID in descending order, showing the latest position first by default. You can change how the list is ordered by clicking the column headers to sort. To sort by multiple columns, hold down shift while clicking the column header.</p>\n<b>Position Title</b>\n<p>You can quickly view more details about each position in the list by clicking its hyperlinked name to open a preview pane.</p>\n<b>Status</b>\n<p>The Positions grid shows Active positions only by default \u2013 i.e. those which do not have an expiry date in the past. Changing the status of a position to Archived, expires the Position with immediate effect. Use the Status column filters to view Archived positions which have expired.</p>\n<b>Actions</b>\n<p>Select Position Description to review employer requirements and edit.  Scout Matches to review LexStep matches and shortlist top candidates by promoting their match stage to \u201CScouted\u201D, and Review Interest in Position to manage Applications.</p>\n<b>Bulk Actions</b>\n<p>Selecting one or more rows enables bulk actions like Edit Expiry Date and Clone which are accessible from the toolbar icons above the grid. </p>\n</div> ';

/***/ }),
/* 534 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.api').factory('PositionApi', ['api', function PositionApi(api) {
	  var _this = this;
	
	  var positionApi = {
	    getPositionListing: function getPositionListing(payload) {
	      return api.get('listings/position', { params: payload });
	    },
	    getPositionById: function getPositionById(positionId) {
	      return api.get('positions/' + positionId);
	    },
	    getAllPositions: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload) {
	        var result;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.debug('getAllPositions', payload);
	                _context.next = 3;
	                return api.get('positions', payload);
	
	              case 3:
	                result = _context.sent;
	
	                console.debug('getAllPositions result', result);
	                return _context.abrupt('return', result);
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function getAllPositions(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getAllPositions;
	    }(),
	    getPositionsForClone: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(payload) {
	        var result;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                console.debug('getPositionsForClone', payload);
	                _context2.next = 3;
	                return api.get('positions/clone', payload);
	
	              case 3:
	                result = _context2.sent;
	
	                console.debug('getPositionsForClone result', result);
	                return _context2.abrupt('return', result);
	
	              case 6:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      function getPositionsForClone(_x2) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getPositionsForClone;
	    }(),
	    createPosition: function createPosition(payload) {
	      return api.post('positions', payload);
	    },
	    updatePositionById: function updatePositionById(positionId, payload) {
	      return api.put('positions/' + positionId, payload);
	    },
	    updateMultiplePositions: function updateMultiplePositions(payload) {
	      return api.put('positions', payload);
	    },
	    deletePositionById: function deletePositionById(positionId, payload) {
	      return api.delete('positions/' + positionId, payload);
	    },
	    createClonePositions: function createClonePositions(payload) {
	      return api.post('positions/clone', payload);
	    },
	    addPositionQuestion: function addPositionQuestion(positionId, payload) {
	      return api.post('positions/' + positionId + '/questions', payload);
	    }
	  };
	  return positionApi;
	}]);

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _loadingOverlay = __webpack_require__(20);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	(function module() {
	  angular.module('app.ui.form.ctrls').controller('PositionListingController', ['$window', 'PositionApi', '$sce', '$uibModal', '$log', 'logger', '$scope', 'SharedApi', 'userService', 'CandidateProfileApi', 'ApplicationsApi', 'socket', '$rootScope', '$timeout', '$location', function controller($window, PositionApi, $sce, $uibModal, $log, logger, $scope, SharedApi, userService, CandidateProfileApi, ApplicationsApi, socket, $rootScope, $timeout, $location) {
	    var _this = this;
	
	    var vm = this;
	
	    socket.on('POSITION_CREATE', function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(positionId) {
	        var _ref2, newPosition, formatPosition;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return PositionApi.getPositionListing({
	                  id: positionId
	                });
	
	              case 2:
	                _ref2 = _context.sent;
	                newPosition = _ref2.data;
	                _context.next = 6;
	                return setGridData(newPosition, vm, $window);
	
	              case 6:
	                formatPosition = _context.sent;
	
	
	                vm.positionListing = [].concat(_toConsumableArray(vm.positionListing), _toConsumableArray(formatPosition));
	                vm.gridOptions.api.updateRowData({
	                  addIndex: vm.positionListing.length,
	                  add: formatPosition
	                });
	                updateGridGroupPipeline();
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }());
	    socket.on('POSITION_UPDATE', function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(positionId) {
	        var _ref4, updatedPosition, formatUpdatedPosition, updatePositionIndex;
	
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return PositionApi.getPositionListing({
	                  id: positionId
	                });
	
	              case 2:
	                _ref4 = _context2.sent;
	                updatedPosition = _ref4.data;
	                _context2.next = 6;
	                return setGridData(updatedPosition, vm, $window);
	
	              case 6:
	                formatUpdatedPosition = _context2.sent;
	                updatePositionIndex = vm.positionListing.findIndex(function (_ref5) {
	                  var id = _ref5.id;
	                  return id === positionId;
	                });
	
	                vm.positionListing[updatePositionIndex] = formatUpdatedPosition[0];
	                vm.gridOptions.api.updateRowData({ update: formatUpdatedPosition });
	
	                updateGridGroupPipeline();
	
	              case 11:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }());
	
	    socket.on('EMPLOYER_UPDATE', function () {
	      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(employerId) {
	        var _ref7, updatedPositions, formatUpdatedPosition;
	
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (!vm.positionListing.some(function (position) {
	                  return position.employerId === employerId;
	                })) {
	                  _context3.next = 12;
	                  break;
	                }
	
	                _context3.next = 3;
	                return PositionApi.getPositionListing({
	                  employerId: employerId
	                });
	
	              case 3:
	                _ref7 = _context3.sent;
	                updatedPositions = _ref7.data;
	
	                if (!(updatedPositions && updatedPositions.length > 0)) {
	                  _context3.next = 12;
	                  break;
	                }
	
	                _context3.next = 8;
	                return setGridData(updatedPositions, vm, $window);
	
	              case 8:
	                formatUpdatedPosition = _context3.sent;
	
	                formatUpdatedPosition.forEach(function (position) {
	                  var index = vm.positionListing.findIndex(function (_ref8) {
	                    var id = _ref8.id;
	                    return id === position.id;
	                  });
	                  vm.positionListing[index] = position;
	                });
	
	                vm.gridOptions.api.updateRowData({ update: formatUpdatedPosition });
	                updateGridGroupPipeline();
	
	              case 12:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this);
	      }));
	
	      return function (_x3) {
	        return _ref6.apply(this, arguments);
	      };
	    }());
	
	    socket.on('APPLICATION_CREATE', function () {
	      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(applicationId) {
	        var _ref10, applicationCreated, updatedPositionIndex;
	
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return ApplicationsApi.getApplicationById(applicationId);
	
	              case 2:
	                _ref10 = _context4.sent;
	                applicationCreated = _ref10.data;
	                updatedPositionIndex = vm.positionListing.findIndex(function (_ref11) {
	                  var id = _ref11.id;
	                  return id === applicationCreated.positionId;
	                });
	
	
	                vm.positionListing[updatedPositionIndex].appliedJobsCount = Number.parseInt(vm.positionListing[updatedPositionIndex].appliedJobsCount, 10) + 1;
	
	                vm.gridOptions.api.updateRowData({
	                  update: [].concat(_toConsumableArray(vm.positionListing[updatedPositionIndex]))
	                });
	
	                updateGridGroupPipeline();
	
	              case 8:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this);
	      }));
	
	      return function (_x4) {
	        return _ref9.apply(this, arguments);
	      };
	    }());
	
	    socket.on('POSITION_DELETE', function () {
	      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(positionId) {
	        var deletedPosition;
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                deletedPosition = vm.positionListing.filter(function (_ref13) {
	                  var id = _ref13.id;
	                  return id === positionId;
	                });
	
	                vm.positionListing = vm.positionListing.filter(function (_ref14) {
	                  var id = _ref14.id;
	                  return id !== positionId;
	                });
	                vm.gridOptions.api.updateRowData({ remove: deletedPosition });
	                $rootScope.$broadcast('position-deleted', {
	                  positionDeleted: positionId
	                });
	                updateGridGroupPipeline();
	
	              case 5:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this);
	      }));
	
	      return function (_x5) {
	        return _ref12.apply(this, arguments);
	      };
	    }());
	    var dateFilterParameters = {
	      suppressAndOrCondition: true,
	      inRangeInclusive: true,
	      comparator: function comparator(filterLocalDateAtMidnight, cellValue) {
	        var dateAsString = moment(cellValue).format('DD/MM/YYYY');
	        var dateParts = dateAsString.split('/');
	        var cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
	
	        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
	          return 0;
	        }
	
	        if (cellDate < filterLocalDateAtMidnight) {
	          return -1;
	        }
	
	        if (cellDate > filterLocalDateAtMidnight) {
	          return 1;
	        }
	      }
	
	      // eslint-disable-next-line unicorn/consistent-function-scoping
	    };function renderDateColumn(parameters) {
	      return parameters.value ? '<span>' + moment(parameters.value).format('DD-MM-YYYY') + '</span>' : ' ';
	    }
	
	    var columnDefs = [{
	      columnGroupShow: undefined,
	      headerCheckboxSelection: true,
	      headerCheckboxSelectionFilteredOnly: true,
	      checkboxSelection: true,
	      width: 60,
	      filter: false,
	      resizable: false
	    }, {
	      headerName: 'Employer Details',
	      children: [{
	        headerName: '',
	        columnGroupShow: undefined,
	        field: '',
	        filter: false,
	        width: 60,
	        resizable: false,
	        cellRenderer: function cellRenderer(parameters) {
	          return parameters.data.archive ? '<center class=""><i class="fa fa-pencil disabled-icon"></i></center>' : '<center class=""><i class="fa fa-pencil pointer"></i></center>';
	        },
	        onCellClicked: openEditPositionModal
	      }, {
	        headerName: '',
	        columnGroupShow: undefined,
	        field: '',
	        filter: false,
	        resizable: false,
	        width: 60,
	        cellStyle: { background: '#95288f !important', color: '#fff' },
	        cellRenderer: function cellRenderer() {
	          return '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n                style="height: 22px;width: 22px;margin: 12px -5px;" viewBox="0 0 614.9 540" style="enable-background:new 0 0 614.9 540;" xml:space="preserve">\n               <style type="text/css">\n                 .pt0{fill:#ffffff;}\n               </style>\n               <g>\n                 <circle class="pt0" cx="282.2" cy="206.9" r="67.3"/>\n                 <path class="pt0" d="M562.6,472.1l-87.8-87.8l3.5-5.1c28-40.4,42.2-86.1,42.2-135.7c0-32.3-6.4-63.6-18.9-93\n                   c-12.5-29.5-29.7-55.3-51-76.6c-21.3-21.3-47.1-38.5-76.6-51C344.6,10.3,313.3,4,281,4c-32.3,0-63.6,6.4-93,18.9\n                   c-29.5,12.5-55.3,29.7-76.6,51C90,95.2,72.9,121,60.3,150.5c-12.5,29.5-18.9,60.8-18.9,93c0,32.3,6.4,63.6,18.9,93\n                   c12.5,29.5,29.7,55.3,51,76.6c21.3,21.3,47.1,38.5,76.6,51c29.5,12.5,60.8,18.9,93,18.9c49.7,0,95.3-14.2,135.7-42.2l5-3.5\n                   l87.9,87.5c7.2,7.6,15.5,11.1,26.3,11.1c10.1,0,18.9-3.8,26.4-11.2c7.4-7.4,11.2-16.3,11.2-26.4\n                   C573.5,488.2,569.8,479.3,562.6,472.1z M397.2,359.7c-0.8,0.8-1.6,1.6-2.5,2.4C363.2,392.6,324.9,408,281,408\n                   c-43.2,0-80.9-14.9-112.2-44.4c-1.6-1.5-2.8-2.7-4.1-3.9c-32-32-48.3-71.1-48.3-116.2c0-45.1,16.2-84.2,48.3-116.2\n                   c32-32,71.1-48.3,116.2-48.3c45.1,0,84.2,16.2,116.2,48.3c32,32,48.3,71.1,48.3,116.2C445.5,288.6,429.2,327.7,397.2,359.7z"/>\n                 <path class="pt0" d="M281.7,387.1c1.6,0,3.3,0,4.9-0.1c-1.7,0.1-3.5,0.1-5.3,0.1C281.5,387.1,281.6,387.1,281.7,387.1z"/>\n                 <path class="pt0" d="M380.4,333.5c-22.2-30.1-57.9-49.6-98.2-49.6c-40.5,0-76.4,19.8-98.6,50.2c23,28.6,58.3,47,97.8,47.1\n                   c1.7,0,3.4,0,5-0.1C324.5,379.6,358.2,361.4,380.4,333.5z"/>\n               </g>s\n               </svg>';
	        },
	        onCellClicked: matchingLawyerClicked
	      }, {
	        headerName: 'Employer',
	        field: 'employer.name',
	        columnGroupShow: undefined,
	        cellRenderer: function cellRenderer(parameters) {
	          return parameters.data.employer.picSrc ? '<img src=' + parameters.data.employer.picSrc + ' style="width: 25px;height:25px; border-radius:50%;margin-right: 5px;margin-bottom: 3px;" alt="pic"><span> ' + parameters.value + '</span>' : '<img src="/images/firmlogo_Default.png" style="width: 25px;height:25px; border-radius:50%;margin-right: 5px;margin-bottom: 3px;" alt="pic"><span> ' + parameters.value + '</span>';
	        }
	      }, {
	        headerName: 'Employer ID',
	        field: 'employerId'
	      }, {
	        headerName: 'Employer Selectivity',
	        field: 'employer.selectivity'
	      }, {
	        headerName: 'Employer Type',
	        field: 'employerType',
	        rowGroupIndex: 0
	      }, {
	        headerName: 'Employer Agent',
	        field: 'employerAgentEmail'
	      }, {
	        headerName: 'Employer Visibility',
	        field: 'employer.isVisible'
	      }]
	    }, {
	      headerName: 'Position Details',
	      children: [{
	        headerName: 'Position Title',
	        field: 'title',
	        filter: 'agTextColumnFilter',
	        cellRenderer: function cellRenderer(parameters) {
	          return parameters.value ? '<span class="text-info pointer"/>' + parameters.value + '</span>' : '';
	        },
	        onCellClicked: openPositionDetailModal,
	        columnGroupShow: undefined
	      }, {
	        headerName: 'Req. PQE',
	        width: 125,
	        field: 'rPQE',
	        columnGroupShow: undefined
	      }, {
	        headerName: 'Location',
	        field: 'locationsName',
	        cellRenderer: function cellRenderer(parameters) {
	          return getLocationsTags(parameters.data.locations);
	        }
	      }, {
	        headerName: 'Practice Areas',
	        field: 'specialtiesName',
	        filter: undefined
	      }, {
	        headerName: 'Contract',
	        field: 'contractType',
	        rowGroupIndex: 2,
	        cellRenderer: function cellRenderer(parameters) {
	          return ' <li class="label label-info text-uppercase margin-r5 position-contract-type-tag">\n                    ' + parameters.value + '\n                  </li> ';
	        }
	      }, {
	        headerName: 'Occupation',
	        field: 'occupation',
	        rowGroupIndex: 1,
	        cellRenderer: function cellRenderer(parameters) {
	          return ' <li class="label label-info text-uppercase margin-r5 position-occupation-tag">\n                    ' + parameters.value + '\n                  </li> ';
	        }
	      }, {
	        headerName: 'Source/External Link',
	        field: 'externalUrl',
	        filter: false,
	        cellRenderer: function cellRenderer(parameters) {
	          var jobUrl = parameters.value ? parameters.value.match(/http/) ? parameters.value : 'http://'.concat(parameters.value) : parameters.value;
	          return parameters.value ? '<span class="text-info pointer"/><a style="color:#4c9bda" href=' + jobUrl + ' target="_blank"/>' + parameters.value + '</span>' : '';
	        }
	      }]
	    }, {
	      headerName: 'Listing Details',
	      children: [{
	        headerName: 'Lexstep Position ID',
	        field: 'id',
	        columnGroupShow: undefined,
	        filter: 'agTextColumnFilter'
	      }, {
	        headerName: 'Current Stage',
	        width: 125,
	        field: 'activeStage',
	        columnGroupShow: undefined
	      }, {
	        headerName: 'Furthest Stage',
	        width: 125,
	        field: 'positionStatus',
	        columnGroupShow: undefined
	      }, {
	        headerName: '# Applicants',
	        field: 'appliedJobsCount'
	      }, {
	        headerName: 'Listing Type',
	        columnGroupShow: undefined,
	        field: 'type'
	      }, {
	        headerName: 'Position Visibility',
	        field: 'visible'
	      }, {
	        headerName: 'Created',
	        field: 'created',
	        cellRenderer: renderDateColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'Expired',
	        field: 'expiresAt',
	        onCellDoubleClicked: openExpiryDateModal,
	        cellRenderer: renderDateColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters,
	        cellClass: 'cellEditable'
	      }, {
	        headerName: 'Status',
	        field: 'status',
	        columnGroupShow: undefined,
	        cellRenderer: 'statusCellRenderer',
	        onCellValueChanged: onStatusChange,
	        editable: true,
	        cellClass: 'cellEditable',
	        cellEditor: 'agRichSelectCellEditor',
	        cellEditorParams: {
	          values: ['Active', 'Expired'],
	          cellRenderer: 'statusCellRenderer'
	        }
	      }]
	    }];
	
	    var gridOptions = {
	      defaultColDef: {
	        sortable: true,
	        filter: true,
	        enablePivot: true,
	        enableRowGroup: true,
	        enableValue: true,
	        columnGroupShow: 'open',
	        resizable: true,
	        menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab']
	      },
	      groupRowRenderer: 'agGroupCellRenderer',
	      groupRowRendererParams: {
	        checkbox: true
	      },
	      floatingFilter: true,
	      groupDefaultExpanded: -1,
	      groupUseEntireRow: true,
	      columnDefs: columnDefs,
	      animateRows: true,
	      getRowNodeId: function getRowNodeId(data) {
	        return data.id;
	      },
	      enableCellChangeFlash: true,
	      groupSelectsChildren: true,
	      rowData: vm.positionListing,
	      rowSelection: 'multiple',
	      rowMultiSelectWithClick: true,
	      rowGroupPanelShow: 'always',
	      pivotPanelShow: 'always',
	      groupSelectsFiltered: true,
	      onFilterChanged: onFilterChanged,
	      onSelectionChanged: onSelectionChanged,
	      onGridReady: function onGridReady() {
	        initializePositionListing();
	      },
	
	      sideBar: {
	        toolPanels: ['columns', 'filters'],
	        defaultToolPanel: false
	      },
	      statusBar: {
	        statusPanels: [{ statusPanel: 'agTotalRowCountComponent', align: 'left' }, { statusPanel: 'agFilteredRowCountComponent', align: 'left' }, { statusPanel: 'agSelectedRowCountComponent' }, { statusPanel: 'agAggregationComponent' }]
	      },
	      components: {
	        statusCellRenderer: StatusCellRenderer
	      },
	      overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your data is loading</span>',
	      suppressCopyRowsToClipboard: true,
	      enableRangeSelection: true,
	      enableCharts: true,
	      onColumnRowGroupChanged: updateGridGroupPipeline,
	      getContextMenuItems: getContextMenuItems
	    };
	
	    vm.gridOptions = gridOptions;
	
	    vm.loadPositionListing = function () {
	      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(positionListingRecords) {
	        return regeneratorRuntime.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                if (!(positionListingRecords.status === 200)) {
	                  _context6.next = 8;
	                  break;
	                }
	
	                _context6.next = 3;
	                return setGridData(positionListingRecords.data, vm, $window);
	
	              case 3:
	                vm.positionListing = _context6.sent;
	
	                vm.gridOptions.api.setRowData(vm.positionListing);
	
	                updateGridGroupPipeline();
	                _context6.next = 9;
	                break;
	
	              case 8:
	                vm.changeStatus(positionListingRecords.status);
	
	              case 9:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this);
	      }));
	
	      return function (_x6) {
	        return _ref15.apply(this, arguments);
	      };
	    }();
	
	    var employerModal = function employerModal() {
	      var modalInstance = $uibModal.open({
	        templateUrl: 'create-update-employer-modal.html',
	        windowClass: 'app-firm-window',
	        controller: 'CreateUpdateEmployerModalController',
	        controllerAs: 'ctrl',
	        resolve: {
	          selectedEmployerId: function selectedEmployerId() {}
	        }
	      });
	      modalInstance.result.then(function (result) {
	        var employer = result.employer;
	
	        modalInstance.dismiss('cancel');
	        logger.notify('success', 'Employer Id: ' + employer.id + ' ' + employer.name + ' created successfully');
	      }, function () {});
	    };
	
	    function openAddEmployerPage() {
	      $window.open('/admin/firm-management?action=add', '_blank');
	    }
	
	    function openInactivePositions() {
	      $window.open('/admin/inactive-positions', '_blank');
	    }
	
	    var positionModal = function positionModal(id) {
	      var modalInstance = $uibModal.open({
	        templateUrl: 'create-update-position-modal.html',
	        windowClass: 'app-firm-window',
	        controller: 'CreateUpdatePositionModalController',
	        controllerAs: 'ctrl',
	        resolve: {
	          selectedPositionId: function selectedPositionId() {
	            return id;
	          },
	          adminId: function adminId() {
	            return vm.user.id;
	          }
	        }
	      });
	      modalInstance.result.then(function (_position) {
	        modalInstance.dismiss('cancel');
	      }, function () {});
	    };
	
	    // Function openAddPositionPage() {
	    //   $window.open('/admin/job-creation', '_blank')
	    // }
	
	    function openEditPositionModal(parameter) {
	      if (parameter.data.id) {
	        positionModal(parameter.data.id);
	      }
	    }
	
	    function openPositionDetailModal(parameter) {
	      if (parameter.data) {
	        positionDetailModal(parameter.data);
	      }
	    }
	
	    var positionDetailModal = function positionDetailModal(_position2) {
	      $uibModal.open({
	        templateUrl: 'position-details-modal.html',
	        windowClass: 'position-modal-window',
	        controller: 'PositionDetailsController',
	        controllerAs: 'ctrl',
	        resolve: {
	          position: function position() {
	            return _position2;
	          },
	          listingName: function listingName() {
	            return vm.gridName;
	          }
	        }
	      });
	    };
	
	    function openExpiryDateModal(parameter) {
	      var _this2 = this;
	
	      vm.dateModal = {
	        title: 'Expiry Date',
	        date: parameter.data.expiresAt
	      };
	      var modalInstance = $uibModal.open({
	        templateUrl: 'date-modal.html',
	        controller: 'DateModalController',
	        controllerAs: 'ctrl',
	        resolve: {
	          selectedModal: function selectedModal() {
	            return vm.dateModal;
	          },
	          id: function id() {
	            return parameter.data.id;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(selectedDate) {
	          return regeneratorRuntime.wrap(function _callee7$(_context7) {
	            while (1) {
	              switch (_context7.prev = _context7.next) {
	                case 0:
	                  if (selectedDate.date === vm.dateModal.date) {
	                    logger.notify('warning', 'Same Date not updated.');
	                  } else if (!selectedDate.date) {
	                    logger.notify('warning', 'Date is empty.');
	                  } else if (selectedDate.date !== vm.dateModal.date) {
	                    if (new Date(selectedDate.date).setHours(0, 0, 0, 0) === new Date(parameter.data.created).setHours(0, 0, 0, 0)) {
	                      selectedDate.date = new Date(parameter.data.created).setMinutes(new Date(parameter.data.created).getMinutes() + 1);
	                    }
	
	                    if (selectedDate.date < new Date()) parameter.data.status = 'Expired';else parameter.data.status = 'Active';
	                    updateExpiryDate(parameter.data, selectedDate.date, vm.dateModal.title);
	                  }
	
	                case 1:
	                case 'end':
	                  return _context7.stop();
	              }
	            }
	          }, _callee7, _this2);
	        }));
	
	        return function (_x7) {
	          return _ref16.apply(this, arguments);
	        };
	      }(), function () {});
	    }
	
	    var updateExpiryDate = function () {
	      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(row, date, title) {
	        var _ref18, data, status;
	
	        return regeneratorRuntime.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                _context8.prev = 0;
	                _context8.next = 3;
	                return PositionApi.updatePositionById(row.id, {
	                  expiresAt: date
	                });
	
	              case 3:
	                _ref18 = _context8.sent;
	                data = _ref18.data;
	                status = _ref18.status;
	
	                if (status === 200) {
	                  logger.notify('success', 'Position Id: ' + data.id + ' ' + title + ' updated successfully');
	                  row.expiresAt = data.expiresAt;
	                  vm.gridOptions.api.updateRowData({ update: [row] });
	                }
	                _context8.next = 12;
	                break;
	
	              case 9:
	                _context8.prev = 9;
	                _context8.t0 = _context8['catch'](0);
	
	                logger.notify('error', _context8.t0.data.message);
	
	              case 12:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this, [[0, 9]]);
	      }));
	
	      return function updateExpiryDate(_x8, _x9, _x10) {
	        return _ref17.apply(this, arguments);
	      };
	    }();
	
	    function onStatusChange(parameter) {
	      if (parameter.newValue !== parameter.oldValue) {
	        // eslint-disable-next-line unicorn/no-null
	        var expiryDate = null;
	        if (parameter.newValue === 'Expired') expiryDate = new Date(parameter.data.created).setMinutes(new Date(parameter.data.created).getMinutes() + 1);
	        parameter.data.status = parameter.newValue;
	        updateExpiryDate(parameter.data, expiryDate, 'Status');
	      }
	    }
	
	    function onFilterChanged() {
	      vm.filterCount = Object.keys(vm.gridOptions.api.getFilterModel()).length;
	      var filterTextBoxValue = document.querySelector('#filter-text-box').value;
	      if (filterTextBoxValue.length > 0) {
	        vm.filterCount += 1;
	      }
	
	      var temporaryFilter = JSON.stringify({
	        status: { values: ['Active'], filterType: 'set' }
	      });
	
	      if (JSON.stringify(vm.gridOptions.api.getFilterModel()) === '{}' || JSON.stringify(vm.gridOptions.api.getFilterModel()) === temporaryFilter) {
	        $log.debug('onFilterChanged', JSON.stringify(vm.gridOptions.api.getFilterModel()));
	        vm.showClearFilter = false;
	      } else vm.showClearFilter = true;
	      updatePipelineCountFromGrid();
	    }
	
	    // TODO: on grid functionality
	    function updatePipelineCountFromGrid() {
	      vm.gridOptions.api.forEachNode(function (node) {
	        if (node.key) {
	          vm.groupList.map(function (row) {
	            if (row.id === node.id) {
	              row.applicationsCount = node.allChildrenCount;
	              return row;
	            }
	
	            return row;
	          });
	        }
	      });
	      $scope.$applyAsync();
	    }
	
	    // TODO: on grid action items functionality
	    function updateGridGroupPipeline() {
	      vm.groupList = [];
	
	      vm.gridOptions.api.forEachNode(function (node) {
	        if (node.key) {
	          var hasChild = true;
	          if (_.isEmpty(node.childrenMapped) || 'undefined' in node.childrenMapped) hasChild = false;
	          vm.groupList.push({
	            name: node.key,
	            applicationsCount: node.allChildrenCount,
	            color: node.leafGroup ? '#' + Math.trunc(Math.random() * 0xffffff).toString(16) : lighten('#5e5e5e', (node.level + 1) * 10),
	            id: node.id,
	            intId: Number(node.id) * -1,
	            level: node.level,
	            parentID: node.parent.id,
	            hasChild: hasChild,
	            isHidden: node.level !== 0
	          });
	        }
	      });
	      $log.debug('vm.groupList', vm.groupList);
	      $scope.$applyAsync();
	    }
	
	    function onSelectionChanged() {
	      vm.selectedRows = vm.gridOptions.api.getSelectedRows();
	      vm.selectedRowsLength = vm.selectedRows.length;
	      hideShowDropdownActionItem();
	    }
	
	    vm.editPositionModal = function (selectedRow) {
	      var id = selectedRow.map(function (_ref19) {
	        var id = _ref19.id;
	        return id;
	      }).join();
	      positionModal(id);
	    };
	
	    vm.openMatchesTab = function (tabData) {
	      if (tabData.employerId) $window.open('/admin/matching-lawyers?positionId=' + tabData.positionId + '&employerId=' + tabData.employerId + '&tab=' + tabData.tab, '_blank');else $window.open('/admin/matching-lawyers?positionId=' + tabData.positionId + '&tab=' + tabData.tab, '_blank');
	    };
	
	    vm.multipleUpdateExpiryDate = function (selectedRows) {
	      vm.dateModal = {
	        title: 'Expiry Date',
	        date: ''
	      };
	      var modalInstance = $uibModal.open({
	        templateUrl: 'date-modal.html',
	        controller: 'DateModalController',
	        controllerAs: 'ctrl',
	        resolve: {
	          selectedModal: function selectedModal() {
	            return vm.dateModal;
	          },
	          id: function id() {
	            return selectedRows.map(function (row) {
	              return { id: row.id };
	            });
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(selectedDate) {
	          var payload, _ref21, status;
	
	          return regeneratorRuntime.wrap(function _callee9$(_context9) {
	            while (1) {
	              switch (_context9.prev = _context9.next) {
	                case 0:
	                  if (!selectedDate.date) {
	                    _context9.next = 14;
	                    break;
	                  }
	
	                  if (new Date(selectedDate.date).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)) {
	                    selectedDate.date = new Date();
	                  }
	
	                  payload = selectedRows.map(function (row) {
	                    return {
	                      id: row.id,
	                      editPositionDto: {
	                        expiresAt: selectedDate.date
	                      }
	                    };
	                  });
	                  _context9.prev = 3;
	                  _context9.next = 6;
	                  return PositionApi.updateMultiplePositions(payload);
	
	                case 6:
	                  _ref21 = _context9.sent;
	                  status = _ref21.status;
	
	                  if (status === 200) {
	                    logger.notify('success', 'Multiple Expiry Date updated successfully');
	
	                    selectedRows.map(function (row) {
	                      row.expiresAt = selectedDate.date;
	                      row.status = selectedDate.date < new Date() ? 'Expired' : 'Active';
	                      return row;
	                    });
	
	                    vm.gridOptions.api.updateRowData({ update: selectedRows });
	                  }
	                  _context9.next = 14;
	                  break;
	
	                case 11:
	                  _context9.prev = 11;
	                  _context9.t0 = _context9['catch'](3);
	
	                  logger.notify('error', _context9.t0.data.message);
	
	                case 14:
	                case 'end':
	                  return _context9.stop();
	              }
	            }
	          }, _callee9, _this, [[3, 11]]);
	        }));
	
	        return function (_x11) {
	          return _ref20.apply(this, arguments);
	        };
	      }(), function () {});
	    };
	
	    vm.openClonePositions = function () {
	      var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(selectedRows, event) {
	        var getData, withData, clonePositionData, modalInstance;
	        return regeneratorRuntime.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                event.preventDefault();
	                event.stopPropagation();
	                console.debug('openClonePositions', selectedRows);
	
	                if (!(!selectedRows || selectedRows.length === 0)) {
	                  _context11.next = 5;
	                  break;
	                }
	
	                return _context11.abrupt('return');
	
	              case 5:
	                getData = function () {
	                  var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
	                    var requestParams, response, positionData, withData;
	                    return regeneratorRuntime.wrap(function _callee10$(_context10) {
	                      while (1) {
	                        switch (_context10.prev = _context10.next) {
	                          case 0:
	                            requestParams = {
	                              params: {
	                                ids: selectedRows.map(function (_ref24) {
	                                  var id = _ref24.id;
	                                  return id;
	                                }),
	                                only: ['description']
	                              }
	                            };
	
	
	                            console.debug('clone position request params:', requestParams);
	
	                            _context10.next = 4;
	                            return PositionApi.getAllPositions(requestParams);
	
	                          case 4:
	                            response = _context10.sent;
	                            positionData = response.data.positions;
	
	
	                            console.debug('got position data:', positionData);
	
	                            if (!positionData || positionData.length === 0) {
	                              console.error('no position data was retrieved');
	                            }
	
	                            withData = selectedRows.map(function (item) {
	                              return _.extend(item, positionData.find(function (data) {
	                                return data.id === item.id;
	                              }));
	                            });
	
	                            console.debug('withData:', withData);
	                            return _context10.abrupt('return', withData);
	
	                          case 11:
	                          case 'end':
	                            return _context10.stop();
	                        }
	                      }
	                    }, _callee10, _this);
	                  }));
	
	                  return function getData() {
	                    return _ref23.apply(this, arguments);
	                  };
	                }();
	
	                _context11.next = 8;
	                return (0, _loadingOverlay.wrap)(getData);
	
	              case 8:
	                withData = _context11.sent;
	                clonePositionData = {
	                  positions: withData,
	                  selectOnReset: true,
	                  allPracticeArea: vm.onlyParentPracticeAreaList,
	                  allLocations: vm.locationsList,
	                  allOccupations: vm.occupationList,
	                  allContractType: vm.contractTypesList
	                };
	                modalInstance = $uibModal.open({
	                  templateUrl: 'clone-position-modal.html',
	                  controller: 'ClonePositionController',
	                  controllerAs: 'ctrl',
	                  resolve: {
	                    cloningData: function cloningData() {
	                      return clonePositionData;
	                    }
	                  }
	                });
	
	                modalInstance.result.then(function () {}, function () {});
	
	              case 12:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, _this);
	      }));
	
	      return function (_x12, _x13) {
	        return _ref22.apply(this, arguments);
	      };
	    }();
	
	    var hideShowDropdownActionItem = function hideShowDropdownActionItem() {
	      vm.gridDataActions = undefined;
	      vm.multiSelectOptions = undefined;
	      vm.multipleSelectionActions = undefined;
	      if (vm.selectedRowsLength > 0) {
	        var row = vm.gridOptions.api.getSelectedRows();
	        vm.multiSelectOptions = [{
	          count: vm.selectedRowsLength
	        }, {
	          funcName: 'Clear Selection',
	          function: vm.clearSelection
	        }];
	        vm.multipleSelectionActions = [{
	          funcName: 'Edit Expiry Date',
	          function: vm.multipleUpdateExpiryDate,
	          funcParameter: row,
	          visible: true,
	          icon: '/images/history-clock-button.svg'
	        }, {
	          funcName: 'Clone Position',
	          function: vm.openClonePositions,
	          visible: true,
	          funcParameter: row,
	          icon: '/images/clone-position.svg'
	        }];
	        vm.gridDataActions = [{
	          count: vm.selectedRowsLength
	        }, {
	          funcName: 'Edit Position',
	          function: vm.editPositionModal,
	          funcParameter: row,
	          visible: vm.selectedRowsLength === 1,
	          icon: '/images/edit-pencil.svg'
	        }, {
	          funcName: 'View Position',
	          function: vm.openMatchesTab,
	          visible: vm.selectedRowsLength === 1,
	          funcParameter: {
	            positionId: row[0].id,
	            tab: 3,
	            employerId: row[0].employerId
	          },
	          icon: '/images/view-position.svg'
	        }, {
	          funcName: 'Scout Matches',
	          function: vm.openMatchesTab,
	          visible: vm.selectedRowsLength === 1,
	          funcParameter: {
	            positionId: row[0].id,
	            tab: 1,
	            employerId: row[0].employerId
	          },
	          icon: '/images/Matches.svg'
	        }, {
	          funcName: 'Interest in Position',
	          function: vm.openMatchesTab,
	          visible: vm.selectedRowsLength === 1,
	          funcParameter: {
	            positionId: row[0].id,
	            tab: 2,
	            employerId: row[0].employerId
	          },
	          icon: '/images/Applications.svg'
	        }];
	        $scope.$applyAsync();
	      }
	
	      $scope.$applyAsync();
	    };
	
	    function getContextMenuItems() {
	      var result = [{
	        name: 'Expand All Columns',
	        action: function action() {
	          var columnApi = vm.gridOptions.columnApi.getColumnGroupState();
	          columnApi.forEach(function (item) {
	            vm.gridOptions.columnApi.setColumnGroupOpened(item.groupId, true);
	          });
	        }
	      }, {
	        name: 'Collapse All Columns',
	        action: function action() {
	          var columnApi = vm.gridOptions.columnApi.getColumnGroupState();
	          columnApi.forEach(function (item) {
	            vm.gridOptions.columnApi.setColumnGroupOpened(item.groupId, false);
	          });
	        }
	      }, 'separator', 'copy', 'copyWithHeaders', 'separator', 'chartRange'];
	
	      vm.isExportAllowed = vm.user.roles.some(function (role) {
	        return role.id === 'admin' || role.id === 'ops';
	      });
	      if (vm.isExportAllowed) result.push('export');
	      return result;
	    }
	
	    function matchingLawyerClicked(parameters) {
	      if (parameters.data.id) {
	        $window.open('/admin/matching-lawyers?positionId=' + parameters.data.id + '&employerId=' + parameters.data.employerId, '_blank');
	      }
	    }
	
	    // eslint-disable-next-line unicorn/consistent-function-scoping
	    function StatusCellRenderer() {}
	    StatusCellRenderer.prototype.init = function (parameters) {
	      vm.eGui = document.createElement('div');
	      var color = 'Red';
	      if (parameters.value === 'Active') {
	        color = 'Yellow';
	      }
	
	      vm.eGui.innerHTML = '<span style="display:inline-block;margin-bottom:-2px;width:15px;height:15px;background:' + color + ';border-radius:20px;"> </span>' + '<span> ' + parameters.value + '</span>';
	    };
	
	    StatusCellRenderer.prototype.getGui = function () {
	      return vm.eGui;
	    };
	
	    vm.gridName = 'position';
	    vm.filterCount = 0;
	    vm.helpTooltip = {
	      name: 'Help',
	      content: $sce.trustAsHtml(positionHelpContent)
	    };
	
	    vm.actionsFunctions = [{
	      funcName: 'Show Inactive Positions',
	      leftClick: openInactivePositions
	    }, {
	      funcName: 'Add Employer',
	      leftClick: employerModal
	    }];
	    vm.activeActions = [{
	      funcName: 'Add Position',
	      function: positionModal,
	      visible: true,
	      icon: '/images/plus-icon.svg'
	    }];
	
	    vm.sliderFilter = function (filterPqe) {
	      var separator = filterPqe.pqe.search(';');
	      var minPQE = Number(filterPqe.pqe.slice(0, separator));
	      var maxPQE = Number(filterPqe.pqe.slice(separator + 1, filterPqe.pqe.length));
	      if (maxPQE === 11) maxPQE = 50;
	      if (minPQE === -2) minPQE = -20;
	      var range = _.range(minPQE, maxPQE + 0.5, 0.5);
	      var filterValues = range.map(function (element) {
	        return String(element);
	      });
	      var currentActiveFilters = vm.gridOptions.api.getFilterModel();
	      if (maxPQE === 50 && minPQE === -20) {
	        delete currentActiveFilters.rPQE;
	        gridOptions.api.setFilterModel(currentActiveFilters);
	      } else {
	        currentActiveFilters.rPQE = {
	          values: filterValues,
	          filterType: 'set'
	        };
	        gridOptions.api.setFilterModel(currentActiveFilters);
	      }
	
	      $scope.$applyAsync();
	    };
	
	    // vm.loadExpiredPositions = async totalExpiredPositionCount => {
	    //   vm.expiredPositionListing = []
	    //   const offset = 0
	    //   const footer = document
	    //     .querySelector(`#${vm.gridName}`)
	    //     .querySelector(`.ag-status-bar-center`)
	    //   footer.innerHTML = `<div style="text-align: center;align-self: center; display: flex;">
	    //                         <div class="agGridLoader"></div>
	    //                         <span style="padding-left: 15px">Loading Expired Positions </span>
	    //                       </div> `
	
	    //   await new Promise((resolve, reject) =>
	    //     getExpiredPosition(resolve, reject, offset, totalExpiredPositionCount)
	    //   )
	    //   $rootScope.$broadcast('listing-loaded')
	    //   footer.innerHTML = `<div style="text-align: center;align-self: center; display: flex;">
	    //         <i class="fa fa-check" style="font-size:20px; color:green" aria-hidden="true"></i>
	    //         <span style="padding-left: 15px" align-self: center;">Loaded Expired Positions Successfully</span>
	    //         </div>`
	
	    //   vm.positionListing.push(...vm.expiredPositionListing)
	    //   const existingFilters = vm.gridOptions.api.getFilterModel()
	    //   if (Object.keys(existingFilters).length === 0) {
	    //     const filter = {
	    //       status: {values: ['Active'], filterType: 'set'},
	    //     }
	    //     vm.gridOptions.api.setFilterModel(filter)
	    //   }
	
	    //   updateGridGroupPipeline()
	    //   $timeout(() => {
	    //     footer.innerHTML = ''
	    //   }, 1500)
	    // }
	
	    // const getExpiredPosition = async (
	    //   resolve,
	    //   reject,
	    //   offset,
	    //   totalExpiredPositionCount
	    // ) => {
	    //   const payload = {active: false, limit: 10000}
	    //   payload.offset = offset
	    //   const {
	    //     data: expiredPositionList,
	    //   } = await PositionApi.getPositionListing(payload)
	
	    //   if (
	    //     offset <= totalExpiredPositionCount &&
	    //     $location.url().contains('admin/admin-listings')
	    //   ) {
	    //     offset += payload.limit
	    //     getExpiredPosition(resolve, reject, offset, totalExpiredPositionCount)
	    //     const expiredPosition = await setGridData(
	    //       expiredPositionList,
	    //       vm,
	    //       $window
	    //     )
	    //     vm.expiredPositionListing.push(...expiredPosition)
	
	    //     vm.gridOptions.api.updateRowData({add: expiredPosition})
	    //   } else {
	    //     return resolve()
	    //   }
	    // }
	
	    var initializePositionListing = function () {
	      var _ref25 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
	        var _ref26, _ref27, locationsList, contractTypeList, occupationList, legalPracticeAreaList, legalEmployerTypeList, candidateAgents, activePositionListingRecords, expiredPositionListingCount;
	
	        return regeneratorRuntime.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                _context12.next = 2;
	                return userService.getUser();
	
	              case 2:
	                vm.user = _context12.sent;
	                _context12.next = 5;
	                return Promise.all([SharedApi.getAllLocations({
	                  supported: true,
	                  regions: true
	                }), SharedApi.getAllContractTypes(), SharedApi.getAllOccupations(), SharedApi.getCategoryById(1), SharedApi.getCategoryById(2), CandidateProfileApi.getAdminAndCorporateUsers(), PositionApi.getPositionListing({ active: true }), PositionApi.getPositionListing({ active: false, count: true })]);
	
	              case 5:
	                _ref26 = _context12.sent;
	                _ref27 = _slicedToArray(_ref26, 8);
	                locationsList = _ref27[0].data;
	                contractTypeList = _ref27[1].data;
	                occupationList = _ref27[2].data;
	                legalPracticeAreaList = _ref27[3].data;
	                legalEmployerTypeList = _ref27[4].data;
	                candidateAgents = _ref27[5].data;
	                activePositionListingRecords = _ref27[6];
	                expiredPositionListingCount = _ref27[7].data;
	
	
	                vm.candidateAgentsList = candidateAgents;
	                vm.contractTypesList = contractTypeList;
	                vm.occupationList = occupationList;
	                vm.legalPracticeAreaList = legalPracticeAreaList;
	                vm.legalEmployerTypeList = legalEmployerTypeList;
	                vm.locationsList = locationsList;
	
	                vm.onlyParentPracticeAreaList = vm.legalPracticeAreaList.specialties.filter(function (_ref28) {
	                  var parentId = _ref28.parentId;
	                  return parentId === null;
	                });
	                vm.gridActionsDirective = {
	                  // PqeSlider: {
	                  //   function: vm.sliderFilter,
	                  //   params: {
	                  //     options: {
	                  //       round: 1,
	                  //       from: -2,
	                  //       to: 11,
	                  //       step: 0.5,
	                  //       dimension: ' years',
	                  //       scale: ['≤-2', -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '≥11'],
	                  //     },
	                  //     filterPQE: {
	                  //       pqe: '-2;11',
	                  //     },
	                  //   },
	                  //   buttonId: 'lawyer-listing-pqe-slider',
	                  //   icon: 'images/stage.svg',
	                  // },
	                  practices: {
	                    buttonId: 'position-listing-filter-prac',
	                    allPracticeAreaList: vm.onlyParentPracticeAreaList,
	                    iconLabel: 'Filter by Practice Area'
	                  }
	                };
	                vm.loadPositionListing(activePositionListingRecords);
	                // vm.loadExpiredPositions(expiredPositionListingCount)
	
	              case 24:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, _this);
	      }));
	
	      return function initializePositionListing() {
	        return _ref25.apply(this, arguments);
	      };
	    }();
	  }]);
	})();
	
	var addLight = function addLight(color, amount) {
	  var cc = Number.parseInt(color, 16) + amount;
	  var c = cc > 255 ? 255 : cc;
	  c = c.toString(16).length > 1 ? c.toString(16) : '0' + c.toString(16);
	  return c;
	};
	
	var lighten = function lighten(color, amount) {
	  color = color.includes('#') ? color.slice(1, color.length) : color;
	  // eslint-disable-next-line radix
	  amount = Number.parseInt(255 * amount / 100);
	  color = '#' + addLight(color.slice(0, 2), amount) + addLight(color.slice(2, 4), amount) + addLight(color.slice(4, 6), amount);
	  return color;
	};
	
	var getLocationsTags = function getLocationsTags(positionLocations) {
	  var locationTags = '';
	  if (positionLocations && positionLocations.length > 0) {
	    positionLocations.forEach(function (positionLocation) {
	      locationTags += ' <li class="label text-uppercase margin-r5 location-' + positionLocation.color + '" >\n          ' + positionLocation.name + '\n        </li> ';
	    });
	  }
	
	  return locationTags;
	};
	
	var setGridData = function setGridData(allPositionRecord, vm) {
	  return Promise.all(allPositionRecord.map(function () {
	    var _ref29 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(data) {
	      return regeneratorRuntime.wrap(function _callee13$(_context13) {
	        while (1) {
	          switch (_context13.prev = _context13.next) {
	            case 0:
	              if (data.employer) setEmployerForPositionListing(data, vm);
	              data.locations = data.locations.length > 0 ? vm.locationsList.filter(function (_ref30) {
	                var id = _ref30.id;
	                return data.locations.find(function (location) {
	                  return location.id === id;
	                });
	              }).map(function (location) {
	                return {
	                  id: location.id,
	                  name: location.name,
	                  parent: location.parent,
	                  color: location.country.region.color
	                };
	              }) : [];
	              data.locationsName = data.locations.length > 0 ? data.locations.map(function (location) {
	                return location.name;
	              }) : [];
	              data.specialties = data.specialties.length > 0 ? vm.legalPracticeAreaList.specialties.filter(function (_ref31) {
	                var id = _ref31.id;
	                return data.specialties.find(function (specialty) {
	                  return specialty.id === id;
	                });
	              }) : [];
	              data.specialtiesName = data.specialties.length > 0 ? data.specialties.map(function (practiceArea) {
	                return practiceArea.name;
	              }) : [];
	
	              data.contractType = data.contractTypeId !== null || data.contractTypeId !== undefined ? vm.contractTypesList.find(function (contract) {
	                return contract.id === data.contractTypeId;
	              }).name : '';
	              data.occupation = data.occupationId ? vm.occupationList.find(function (occupation) {
	                return occupation.id === data.occupationId;
	              }).name : '';
	              data.rPQE = '' + (data.lawPreferences.minPqe <= 0 ? 'NQ' : data.lawPreferences.minPqe) + (data.lawPreferences.maxPqe === 11 ? '+' : data.lawPreferences.maxPqe <= 0 || data.lawPreferences.maxPqe === data.lawPreferences.minPqe ? '' : '-' + data.lawPreferences.maxPqe.toString());
	              data.visible = data.visible ? 'Visible' : 'Invisible';
	              data.status = data.expiresAt ? new Date(data.expiresAt).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0) ? 'Expired' : 'Active' : 'Active';
	              return _context13.abrupt('return', data);
	
	            case 11:
	            case 'end':
	              return _context13.stop();
	          }
	        }
	      }, _callee13, undefined);
	    }));
	
	    return function (_x14) {
	      return _ref29.apply(this, arguments);
	    };
	  }()));
	};
	
	var setEmployerForPositionListing = function setEmployerForPositionListing(data, vm) {
	  var employerSelectivity = '';
	
	  if (data.employer.selectivity) {
	    for (var index = 1; index <= data.employer.selectivity; index++) {
	      employerSelectivity += '$';
	    }
	  }
	
	  if (data.employer.selectivity === 0) employerSelectivity = 'Uncategorized';
	
	  if (data.employer.logo) data.employer.picSrc = ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/employers/' + data.employerId + '/logo/' + data.employer.logo;
	
	  data.employer.selectivity = employerSelectivity;
	  data.employerAgentEmail = data.employer.agentId ? vm.candidateAgentsList.find(function (agent) {
	    return agent.id === data.employer.agentId;
	  }) ? vm.candidateAgentsList.find(function (agent) {
	    return agent.id === data.employer.agentId;
	  }).email : 'unassigned' : 'unassigned';
	  data.employer.isVisible = data.employer.isVisible ? 'Visible' : 'Invisible';
	  data.employerType = data.employerType.length > 0 ? vm.legalEmployerTypeList.specialties.filter(function (_ref32) {
	    var id = _ref32.id;
	    return data.employerType.find(function (employerType) {
	      return employerType.id === id;
	    });
	  }).map(function (employerType) {
	    return employerType.name;
	  }).join() : 'Auto-Generated';
	  return data;
	};
	
	var positionHelpContent = '\n<div>\n<p>\tPositions allows you to search for positions based on specific criteria you define.</p>\n<b>My Employers</b>\n<p>Filter by \u201CMy Employers\u201D from the toolbar above the grid to display positions at your assigned employers only.</p>\n<b>Filtering</b>\n<p>The \u201CFilter by Practice Area\u201D icon allows you to quickly refine your search. Further filters can be applied by hovering over each column header and selecting the hamburger menu on the right.</p>\n<b>Views</b>\n<p>Personalise different list layouts by choosing the columns to display, adjusting their width and moving them to re-order to your preferences. You can save custom column layouts with filter criteria to easy access again later via the \u201CViews\u201D icon in the top right -- either as a Private \u201CSaved View\u201D or Shared with other team members. The Views menu includes pre-set views that filter for Private Practice and In-House positions.</p>\n<b>Clear</b>\n<p>When one or more filters are applied, a Clear filter icon will appear in the top right above the grid. Select to clear any applied filters and/or search and reset the grid data to default.</p>\n<b>Group</b>\n<p>Drag and drop columns to the grouping drop zone in the grid\u2019s top row to group rows by a particular column.  You can Expand/Collapse All Rows from the Views icon in the top right to view positions by Group.</p>\n<b>Sorting</b>\n<p>Positions are sorted by Position ID in descending order, showing the latest position first by default. You can change how the list is ordered by clicking the column headers to sort. To sort by multiple columns, hold down shift while clicking the column header.</p>\n<b>Position Title</b>\n<p>You can quickly view more details about each position in the list by clicking its hyperlinked name to open a preview pane.</p>\n<b>Status</b>\n<p>The Positions grid shows Active positions only by default \u2013 i.e. those which do not have an expiry date in the past. Changing the status of a position to Archived, expires the Position with immediate effect. Use the Status column filters to view Archived positions which have expired.</p>\n<b>Actions</b>\n<p>Select Position Description to review employer requirements and edit.  Scout Matches to review LexStep matches and shortlist top candidates by promoting their match stage to \u201CScouted\u201D, and Review Interest in Position to manage Applications.</p>\n<b>Bulk Actions</b>\n<p>Selecting one or more rows enables bulk actions like Edit Expiry Date and Clone which are accessible from the toolbar icons above the grid. </p>\n</div> ';

/***/ }),
/* 536 */
/***/ (function(module, exports) {

	'use strict';
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('RecommendationHelpDescriptionModalController', ['$uibModalInstance', 'isModalSet', 'showModalTab', function controller($uibModalInstance, isModalSet, showModalTab) {
	    var vm = this;
	    vm.isModalSet = isModalSet;
	    vm.showModalTab = showModalTab;
	    vm.cancel = function () {
	      $uibModalInstance.dismiss('cancel');
	    };
	  }]);
	})();

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _helpDescriptionModal = __webpack_require__(536);
	
	var recommendationHelpDescriptionModal = function recommendationHelpDescriptionModal() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    controller: _helpDescriptionModal.RecommendationHelpDescriptionModalController,
	    template: __webpack_require__(430)
	  };
	};
	
	angular.module('app.directives').directive('recommendationHelpDescriptionModal', recommendationHelpDescriptionModal);

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _isTestAccount = __webpack_require__(744);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function removeTestAccounts(data) {
	  return data.filter(function (item) {
	    var candidateDetails = item.candidateDetails;
	    var email = candidateDetails.email;
	
	    return !(0, _isTestAccount.isTestAccount)(email);
	  });
	}
	
	angular.module('app.api').factory('RecommendationListingApi', ['api', function RecommendationListingApi(api) {
	  var _this = this;
	
	  var recommendationApi = {
	    getPositionRecommendations: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
	        var result, withoutTestAccounts;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return api.get('recommendations/position/' + id);
	
	              case 2:
	                result = _context.sent;
	                withoutTestAccounts = _.extend(_.clone(result), {
	                  data: removeTestAccounts(result.data)
	                });
	
	                console.debug('getPositionRecommendations withoutTestAccounts', withoutTestAccounts);
	                return _context.abrupt('return', withoutTestAccounts);
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function getPositionRecommendations(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getPositionRecommendations;
	    }()
	  };
	  return recommendationApi;
	}]);

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _formatPqe = __webpack_require__(55);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable unicorn/no-null */
	/* eslint-disable angular/window-service */
	/* eslint-disable angular/document-service */
	/* eslint-disable unicorn/consistent-function-scoping */
	
	
	(function module() {
	  'use strict';
	
	  angular.module('app.ui.form.ctrls').controller('RecommendationListingController', ['$scope', '$log', '$location', 'usSpinnerService', '$window', '$uibModal', '$sce', 'SharedApi', 'RecommendationListingApi', 'EmployersApi', 'ApplicationsApi', 'ApplicationStagesApi', 'NotesApi', 'userService', 'CandidateProfileApi', '$rootScope', 'socket', '$timeout', 'PositionApi', function controller($scope, $log, $location, usSpinnerService, $window, $uibModal, $sce, SharedApi, RecommendationListingApi, EmployersApi, ApplicationsApi, ApplicationStagesApi, NotesApi, userService, CandidateProfileApi, $rootScope, socket, $timeout, PositionApi) {
	    var _this = this;
	
	    var vm = this;
	
	    socket.on('POSITION_RECOMMENDATION_GENERATED', function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(positionId) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                  var _ref3, recommendationList;
	
	                  return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          if (!(Number.parseInt(vm.positionId, 10) === Number.parseInt(positionId, 10) && $location.url().contains('matching-lawyers'))) {
	                            _context.next = 7;
	                            break;
	                          }
	
	                          _context.next = 3;
	                          return RecommendationListingApi.getPositionRecommendations(vm.positionId);
	
	                        case 3:
	                          _ref3 = _context.sent;
	                          recommendationList = _ref3.data;
	
	
	                          vm.loadRecommendationListing(recommendationList);
	                          $scope.$applyAsync();
	
	                        case 7:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this);
	                })), 1500);
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }());
	    var dateFilterParameters = {
	      suppressAndOrCondition: true,
	      inRangeInclusive: true,
	      comparator: function comparator(filterLocalDateAtMidnight, cellValue) {
	        var dateAsString = moment(cellValue).format('DD/MM/YYYY');
	        var dateParts = dateAsString.split('/');
	        var cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
	
	        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
	          return 0;
	        }
	
	        if (cellDate < filterLocalDateAtMidnight) {
	          return -1;
	        }
	
	        if (cellDate > filterLocalDateAtMidnight) {
	          return 1;
	        }
	      }
	    };
	
	    function renderDateTimeColumn(parameters) {
	      return parameters.value ? '<span>' + moment(parameters.value).format('DD-MMM-YYYY HH:mm') + '</span>' : ' ';
	    }
	
	    function renderDateMonthColumn(parameter) {
	      return parameter.value ? '<span>' + moment(parameter.value).format('MMM-YY') + '</span>' : ' ';
	    }
	
	    function renderDateColumn(parameter) {
	      return parameter.value ? '<span>' + moment(parameter.value).format('DD-MMM-YYYY') + '</span>' : ' ';
	    }
	
	    function renderStatusColumn(parameter) {
	      var color = 'Red';
	      if (parameter.value === 'Active') color = 'Yellow';else if (parameter.value === 'Accepted') color = 'Green';else if (parameter.value === 'Rejected by LexStep') color = 'Orange';
	      return '<span class="round-circle"style="background:' + color + ';"> </span>' + '<span> ' + parameter.value + '</span>';
	    }
	
	    function renderSubStageColumn(parameter) {
	      var substage = vm.allApplicationStagesList.find(function (stage) {
	        return stage.name === parameter.value;
	      });
	      return '<span class="round-circle" style="background:' + substage.color + ';"> </span>' + '<span> ' + parameter.value + '</span>';
	    }
	
	    function renderInterestColumn(parameter) {
	      return parameter.value ? parameter.value === 'Likely Interested' ? '<span class="round-circle" style="background:green;"></span><span>' + parameter.value + '</span>' : parameter.value === 'Not Interested' ? '<span class="round-circle" style="background:red;"></span><span>' + parameter.value + '</span>' : '<span>' + parameter.value + '</span>' : '<span>' + parameter.value + '</span>';
	    }
	
	    var columnDefs = [{
	      columnGroupShow: undefined,
	      headerCheckboxSelection: true,
	      headerCheckboxSelectionFilteredOnly: true,
	      checkboxSelection: true,
	      width: 134,
	      filter: false,
	      resizable: false
	    }, {
	      headerName: 'Match Details',
	      children: [{
	        headerName: 'Candidate Interest',
	        field: 'interest',
	        rowGroupIndex: 0,
	        columnGroupShow: undefined,
	        cellRenderer: renderInterestColumn
	      }, {
	        headerName: 'Prev-Applied to Employer (reg)',
	        field: 'lastAppliedDateRegularCustom',
	        cellRenderer: 'agGroupCellRenderer',
	        cellRendererParams: {
	          innerRenderer: renderDateTimeColumn
	        },
	        filter: 'date',
	        columnGroupShow: undefined,
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'Prev-Applied to Employer (spec)',
	        field: 'lastAppliedDateSpecConnect',
	        cellRenderer: 'agGroupCellRenderer',
	        cellRendererParams: {
	          innerRenderer: renderDateTimeColumn
	        },
	        filter: 'date',
	        columnGroupShow: undefined,
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'Employer Followed',
	        field: 'matchingEmployerFollowed'
	      }, {
	        headerName: 'Position Hidden',
	        field: 'matchingPositionHidden'
	      }, {
	        headerName: 'Employer Hidden',
	        field: 'matchingEmployerHidden'
	      }]
	    }, {
	      headerName: 'Candidate Details',
	      children: [{
	        headerName: 'Candidate Status',
	        field: 'candidateDetails.approvalStatus'
	      }, {
	        headerName: 'Candidate Agent',
	        field: 'candidateAgentEmail'
	      }, {
	        headerName: 'Candidate ID',
	        field: 'candidateDetails.id',
	        filter: 'agTextColumnFilter',
	        columnGroupShow: undefined
	      }, {
	        headerName: 'Email',
	        field: 'candidateDetails.email',
	        filter: 'agTextColumnFilter'
	      }, {
	        headerName: 'Phone #',
	        field: 'candidateDetails.phone',
	        filter: 'agTextColumnFilter'
	      }, {
	        headerName: 'Referral Code',
	        field: 'candidateDetails.referralCode',
	        filter: 'agTextColumnFilter'
	      }, {
	        headerName: 'Platform Access',
	        field: 'candidateDetails.platformAccess'
	      }, {
	        headerName: 'Referred By',
	        field: 'candidateDetails.referredBy',
	        filter: 'agTextColumnFilter',
	        onCellClicked: redirectToReferrals,
	        cellRenderer: function cellRenderer(parameter) {
	          return parameter.value ? '<span class="text-info pointer"/>' + parameter.value + '</span>' : '';
	        }
	      }, {
	        headerName: 'IP Address',
	        field: 'candidateDetails.ip'
	      }]
	    }, {
	      headerName: 'Candidate Profile',
	      children: [{
	        headerName: 'Candidate Name',
	        field: 'candidateProfile.fullName',
	        onCellClicked: viewProfile,
	        filter: 'agTextColumnFilter',
	        cellRenderer: function cellRenderer(parameter) {
	          return parameter.value ? '<span class="text-info pointer"/>' + parameter.value + '</span>' : '';
	        },
	        columnGroupShow: undefined
	      }, {
	        headerName: 'Qualification Date',
	        field: 'candidateProfile.qualificationDate',
	        cellRenderer: renderDateMonthColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'PQE',
	        field: 'candidateProfile.pqe',
	        filter: 'agNumberColumnFilter',
	
	        filterParams: {
	          comparator: function comparator(a, b) {
	            var numberA = Number.parseFloat(a);
	            var numberB = Number.parseFloat(b);
	            if (numberA > numberB) {
	              return 1;
	            }
	
	            return numberA < numberB ? -1 : 0;
	          },
	          numberParser: function numberParser(text) {
	            return Number.parseFloat(text);
	          },
	          inRangeInclusive: true,
	          includeBlanksInRange: true,
	          includeBlanksInLessThan: true,
	          includeBlanksInGreaterThan: true
	        }
	      }, {
	        headerName: 'Current Location',
	        field: 'candidateProfile.currentLocation'
	      }, {
	        headerName: 'Languages',
	        field: 'candidateProfile.languages'
	      }, {
	        headerName: 'Jurisdiction(s) of Qualification',
	        field: 'candidateProfile.jurisdictions'
	      }, {
	        headerName: 'University',
	        field: 'candidateProfile.school'
	      }, {
	        headerName: 'Nationality',
	        field: 'candidateProfile.nationality'
	      }]
	    }, {
	      headerName: 'Candidate Experience',
	      children: [{
	        headerName: 'Current Employer',
	        field: 'currentExperience.employer.name',
	        columnGroupShow: undefined
	      }, {
	        headerName: 'Current Employer Type',
	        field: 'currentExperience.employerType'
	      }, {
	        headerName: 'Current Employer Selectivity',
	        field: 'currentExperience.employer.selectivity'
	      }, {
	        headerName: 'Current Job Title',
	        field: 'currentExperience.jobTitle'
	      }, {
	        headerName: 'Current Practice Areas',
	        field: 'currentExperience.specialties'
	      }, {
	        headerName: 'Current Occupation',
	        field: 'currentExperience.occupation'
	      }, {
	        headerName: 'Current Contract',
	        field: 'currentExperience.contractType'
	      }, {
	        headerName: 'Current Salary Currency',
	        field: 'currentExperience.salary.salaryUnit'
	      }, {
	        headerName: 'Current Salary Amount',
	        field: 'currentExperience.salary.salaryAmount'
	      }, {
	        headerName: 'Current Salary Period',
	        field: 'currentExperience.salary.salaryPeriod'
	      }, {
	        headerName: 'Current Bonus Currency ',
	        field: 'currentExperience.salary.bonusUnit'
	      }, {
	        headerName: 'Current Bonus Amount',
	        field: 'currentExperience.salary.bonusAmount'
	      }]
	    }, {
	      headerName: 'Candidate Preferences',
	      children: [{
	        headerName: 'Practice Area Preference',
	        field: 'legalCandidatePracticeAreas',
	        columnGroupShow: undefined
	      }, {
	        headerName: 'Location Preference',
	        field: 'candidatePreference.locations',
	        columnGroupShow: undefined
	      }, {
	        headerName: 'Contract Preference',
	        field: 'candidatePreference.contracts',
	        cellRenderer: function cellRenderer(parameter) {
	          return ' <li class="label label-info text-uppercase margin-r5" style="background-color : #daf0f8; color: black;">\n                ' + parameter.value + '\n              </li> ';
	        }
	      }, {
	        headerName: 'Occupation Preference',
	        field: 'candidatePreference.occupations',
	        cellRenderer: function cellRenderer(parameter) {
	          return ' <li class="label label-info text-uppercase margin-r5" style="background-color : #daf0f8; color: black;">\n                ' + parameter.value + '\n              </li> ';
	        }
	      }, {
	        headerName: 'Employer Type Preference',
	        field: 'candidatePreference.legalEmployerType'
	      }, {
	        headerName: 'Employers Followed',
	        field: 'followEmployersName'
	      }, {
	        headerName: 'Employers Hidden',
	        field: 'hiddenEmployersName'
	      }, {
	        headerName: 'Positions Applied',
	        field: ''
	      }, {
	        headerName: 'Positions Hidden',
	        field: ''
	      }]
	    }, {
	      headerName: 'Candidate Activity',
	      children: [{
	        headerName: 'Candidate Status',
	        field: 'candidateActivity.candidateStatus'
	      }, {
	        headerName: 'Last Login',
	        field: 'candidateActivity.lastLogin',
	        cellRenderer: renderDateTimeColumn,
	        columnGroupShow: undefined,
	        filter: 'date',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'Approval Date',
	        field: 'candidateActivity.approvalAcceptDate',
	        cellRenderer: renderDateTimeColumn,
	        filter: 'date',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'Request Access Date',
	        field: 'candidateActivity.approvalRequestDate',
	        cellRenderer: renderDateTimeColumn,
	        filter: 'date',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'Signup Date',
	        field: 'candidateActivity.created',
	        cellRenderer: renderDateTimeColumn,
	        filter: 'date',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: '# Logins',
	        field: 'candidateActivity.loginCount'
	      }, {
	        headerName: '# Conversation Notes',
	        field: 'candidateActivity.totalConversationNote'
	      }, {
	        headerName: 'Last Conversation Date',
	        field: 'candidateActivity.lastConversationNote',
	        cellRenderer: renderDateTimeColumn,
	        filter: 'date',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: '# Employers Followed',
	        field: 'followEmployer.length'
	      }, {
	        headerName: '# Employers Hidden',
	        field: 'hiddenEmployer.length'
	      }, {
	        headerName: '# Positions Hidden',
	        field: 'hiddenPosition.length'
	      }, {
	        headerName: '# Positions Applied: Reg/Cust',
	        field: 'totalAppliedPositionRegularCustom'
	      }, {
	        headerName: '# Positions Applied: Spec/Con',
	        field: 'totalAppliedPositionSpecConnect'
	      }, {
	        headerName: 'Recently Moved',
	        field: 'recentlyMoved'
	      }, {
	        headerName: 'Email Alerts: In-House ATS-Links',
	        field: 'emailAlertWeeklyInHouseATS'
	      }, {
	        headerName: 'Email Alerts: Daily + Adhoc Matches',
	        field: 'emailAlertDailyMatches'
	      }]
	    }];
	    var masterDetailColumns = [{
	      headerName: 'Position Details',
	      children: [{
	        headerName: 'Position Title',
	        field: 'position.title',
	        cellRenderer: function cellRenderer(parameter) {
	          return parameter.value ? '<span class="text-info pointer"/>' + parameter.value + '</span>' : '';
	        },
	        columnGroupShow: undefined,
	        onCellClicked: openPositionDetailModal,
	        filter: 'agTextColumnFilter'
	      }, { headerName: 'Req. PQE', field: 'position.rPQE', width: 125 }, { headerName: 'Location', field: 'position.locations' }, { headerName: 'Practice Areas', field: 'position.specialties' }, { headerName: 'Contract', field: 'position.contractType' }, { headerName: 'Occupation', field: 'position.occupation' }, {
	        headerName: 'Regular ATS Link',
	        field: 'position.externalUrl',
	        filter: false,
	        cellRenderer: function cellRenderer(parameter) {
	          var positionUrl = parameter.value ? parameter.value.match(/http/) ? parameter.value : 'http://'.concat(parameter.value) : parameter.value;
	          return parameter.value ? '<span class="text-info pointer"/><a style="color:#4c9bda" href=' + positionUrl + ' target="_blank"/>' + parameter.value + '</span>' : '';
	        }
	      }]
	    }, {
	      headerName: 'Listing Details',
	      children: [{
	        headerName: 'LexStep Position ID',
	        field: 'position.id',
	        filter: 'agTextColumnFilter'
	      }, { headerName: '# Applicants', field: 'position.applicantCount' }, {
	        headerName: 'Listing Type',
	        field: 'position.type',
	        columnGroupShow: undefined
	      }, { headerName: 'Position Visibility', field: 'position.visible' }, {
	        headerName: 'Uploaded',
	        field: 'position.created',
	        cellRenderer: renderDateColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'Expired',
	        field: 'position.expiresAt',
	        cellRenderer: renderDateColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters
	      }]
	    }, {
	      headerName: 'Application Details',
	      children: [{
	        headerName: 'Application ID',
	        field: 'id',
	        filter: 'agTextColumnFilter'
	      }, {
	        headerName: 'Application Date',
	        field: 'created',
	        columnGroupShow: undefined,
	        cellRenderer: renderDateColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'Submission Date',
	        field: 'submittedAt',
	        columnGroupShow: undefined,
	        cellRenderer: renderDateColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters,
	        cellClass: 'cellEditable'
	      }, {
	        headerName: 'CV',
	        field: 'cvUrl',
	        filter: false,
	        columnGroupShow: undefined,
	        cellRenderer: function cellRenderer(parameter) {
	          if (parameter.value) return '<center class=""><img class="" style="width: 28px" src="/images/resume.png" /></center>';
	          if (parameter.value !== undefined) return '<center class=""><img class=" disabled-icon" style="width: 28px" src="/images/resume.png" /></center>';
	        },
	        width: 100,
	        onCellClicked: cvCellClicked
	      }, {
	        headerName: 'Stage',
	        field: 'parentApplicationStage'
	      }, {
	        headerName: 'Sub-Stage',
	        field: 'applicationStage',
	        columnGroupShow: undefined,
	        cellRenderer: renderSubStageColumn
	      }, {
	        headerName: 'Last Stage Change',
	        field: 'lastStageChangeAt',
	        cellRenderer: renderDateColumn,
	        filter: 'agDateColumnFilter',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'Status',
	        field: 'status',
	        columnGroupShow: undefined,
	        cellRenderer: renderStatusColumn
	      }, {
	        headerName: 'Source',
	        field: 'isOffPlatform',
	        width: 120
	      }, {
	        headerName: 'Application Candidate Agent',
	        field: 'applicationCandidateAgentEmail'
	      }, {
	        headerName: 'Application Employer Agent',
	        field: 'applicationEmployerAgentEmail'
	      }, {
	        headerName: 'Application History',
	        field: 'history',
	        columnGroupShow: undefined,
	        filter: false,
	        cellRenderer: function cellRenderer() {
	          return '<center><span class="fa fa-history"/></center>';
	        },
	        onCellClicked: openHistoryModal
	      }]
	    }];
	
	    var masterDetailColumnDef = {
	      detailGridOptions: {
	        defaultColDef: {
	          sortable: true,
	          filter: true,
	          enablePivot: true,
	          enableRowGroup: true,
	          enableValue: true,
	          resizable: true,
	          columnGroupShow: 'open',
	          menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab']
	        },
	        columnDefs: masterDetailColumns,
	        getContextMenuItems: getContextMenuItems
	      },
	      template: '<div class="master-grid">' + '  <div ref="eDetailGrid" style="height: 100%;"></div>' + '</div>',
	      getDetailRowData: function getDetailRowData(parameter) {
	        var _this2 = this;
	
	        var payload = {
	          candidateId: parameter.data.candidateDetails.id,
	          employerId: Number(vm.employerId),
	          miniGrid: true
	        };
	        ApplicationsApi.getApplicationListing(payload).then(function () {
	          var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref4) {
	            var data = _ref4.data,
	                status = _ref4.status;
	
	            var _ref6, _ref7, applicationStagesList, applicationStagesHierarchialList;
	
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	              while (1) {
	                switch (_context3.prev = _context3.next) {
	                  case 0:
	                    if (!(status === 200)) {
	                      _context3.next = 11;
	                      break;
	                    }
	
	                    _context3.next = 3;
	                    return Promise.all([ApplicationStagesApi.getAllApplicationStages(), ApplicationStagesApi.getAllApplicationStages({
	                      hierarchy: true
	                    })]);
	
	                  case 3:
	                    _ref6 = _context3.sent;
	                    _ref7 = _slicedToArray(_ref6, 2);
	                    applicationStagesList = _ref7[0].data;
	                    applicationStagesHierarchialList = _ref7[1].data;
	
	                    vm.applicationStagesHierarchialList = applicationStagesHierarchialList;
	                    vm.applicationSubStagesList = applicationStagesList.filter(function (_ref8) {
	                      var parentId = _ref8.parentId;
	                      return parentId !== null;
	                    }).sort(function (a, b) {
	                      return Number(a.parentId) - Number(b.parentId);
	                    });
	
	                    vm.allApplicationStagesList = applicationStagesList;
	                    parameter.successCallback(setMasterGridApplicationsListingData(data));
	
	                  case 11:
	                  case 'end':
	                    return _context3.stop();
	                }
	              }
	            }, _callee3, _this2);
	          }));
	
	          return function (_x2) {
	            return _ref5.apply(this, arguments);
	          };
	        }()).catch();
	      }
	    };
	
	    var gridOptions = {
	      defaultColDef: {
	        sortable: true,
	        filter: true,
	        enablePivot: true,
	        enableRowGroup: true,
	        enableValue: true,
	        columnGroupShow: 'open',
	        resizable: true,
	        menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab']
	      },
	      masterDetail: true,
	      embedFullWidthRows: true,
	      isRowMaster: function isRowMaster(dataItem) {
	        return Boolean(dataItem.lastAppliedDateRegularCustom || dataItem.lastAppliedDateSpecConnect);
	      },
	      detailRowHeight: 300,
	      detailCellRendererParams: masterDetailColumnDef,
	      onFilterChanged: onFilterChanged,
	      onModelUpdated: updateGridGroupPipeline,
	      onGridReady: function onGridReady() {
	        initializeRecommendationListing();
	      },
	      floatingFilter: true,
	      suppressCsvExport: true,
	      groupDefaultExpanded: 1,
	      groupUseEntireRow: true,
	      columnDefs: columnDefs,
	      animateRows: true,
	      enableCellChangeFlash: true,
	      groupSelectsChildren: true,
	      rowData: [],
	      rowSelection: 'multiple',
	      rowGroupPanelShow: 'always',
	      pivotPanelShow: 'always',
	      groupSelectsFiltered: true,
	
	      postProcessPopup: function postProcessPopup(parameter) {
	        if (parameter.type !== 'columnMenu') {
	          return;
	        }
	
	        var columnId = parameter.column.getId();
	        if (columnId === 'lawyerPractices' || columnId === 'currentPracticeArea' || columnId === 'state') {
	          parameter.ePopup.style.width = '350px';
	        }
	      },
	      groupRowRenderer: 'agGroupCellRenderer',
	      groupRowRendererParams: {
	        checkbox: true
	      },
	      onSelectionChanged: onSelectionChanged,
	
	      sideBar: {
	        toolPanels: ['columns', 'filters'],
	        defaultToolPanel: false
	      },
	      statusBar: {
	        statusPanels: [{ statusPanel: 'agTotalRowCountComponent', align: 'left' }, { statusPanel: 'agFilteredRowCountComponent', align: 'left' }, { statusPanel: 'agSelectedRowCountComponent' }, { statusPanel: 'agAggregationComponent' }]
	      },
	
	      overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your data is loading</span>',
	      suppressCopyRowsToClipboard: true,
	      enableRangeSelection: true,
	      enableCharts: true,
	      onColumnRowGroupChanged: updateGridGroupPipeline,
	      getContextMenuItems: getContextMenuItems
	    };
	
	    vm.gridOptions = gridOptions;
	    vm.gridName = 'recommendation';
	    function openHistoryModal(parameter) {
	      var applicationHistoryModalInstance = $uibModal.open({
	        templateUrl: 'application-history-modal.html',
	        controller: 'ApplicationHistoryController',
	        controllerAs: 'ctrl',
	        windowClass: 'application-history-modal',
	        backdrop: 'static',
	        resolve: {
	          isNote: function isNote() {
	            return parameter.colDef.field === 'note';
	          },
	          applicationId: function applicationId() {
	            return parameter.data.id;
	          },
	          agentsList: function agentsList() {
	            return vm.agentsList;
	          },
	          isOffPlatform: function isOffPlatform() {
	            return parameter.data.isOffPlatform;
	          },
	          stagesList: function stagesList() {
	            return vm.allApplicationStagesList;
	          },
	          enableMasterGrid: function enableMasterGrid() {
	            return true;
	          }
	        }
	      });
	      applicationHistoryModalInstance.result.then(function (latestNote) {
	        var selectedRow = [Object.assign(parameter.data, { note: latestNote })];
	        vm.gridOptions.api.updateRowData({
	          update: selectedRow
	        });
	      }, function () {});
	    }
	
	    vm.helpTooltip = {
	      name: 'Help',
	      content: $sce.trustAsHtml(recommendationHelpContent)
	    };
	
	    var setMasterGridApplicationsListingData = function setMasterGridApplicationsListingData(applicationRecord) {
	      return applicationRecord.map(function (data) {
	        setMasterGridPositionColumnData(data, vm, applicationRecord);
	        data.applicationCandidateAgentEmail = data.userAgentId ? vm.agentsList.find(function (agent) {
	          return agent.id === data.userAgentId;
	        }) && vm.agentsList.find(function (agent) {
	          return agent.id === data.userAgentId;
	        }).email : '';
	        data.applicationEmployerAgentEmail = data.employerAgentId ? vm.agentsList.find(function (agent) {
	          return agent.id === data.employerAgentId;
	        }) && vm.agentsList.find(function (agent) {
	          return agent.id === data.employerAgentId;
	        }).email : '';
	        var applicationStage = vm.applicationSubStagesList.find(function (_ref9) {
	          var id = _ref9.id;
	          return data.stageId === id;
	        });
	        data.applicationStage = applicationStage.name;
	        var parentApplicationStage = vm.allApplicationStagesList.find(function (_ref10) {
	          var id = _ref10.id;
	          return applicationStage.parentId === id;
	        });
	        data.parentStageId = parentApplicationStage.id;
	        data.parentApplicationStage = parentApplicationStage.name;
	        data.isOffPlatform = data.isOffPlatform ? 'OffPlatform' : 'Platform';
	        return data;
	      });
	    };
	
	    function openPositionDetailModal(parameter) {
	      if (parameter.data.position) {
	        positionDetailModal(parameter.data.position, parameter.data.employer);
	      }
	    }
	
	    var positionDetailModal = function positionDetailModal(_position, employer) {
	      employer.type = employer.type.length > 0 ? vm.legalEmployerTypeList.filter(function (_ref11) {
	        var id = _ref11.id;
	        return employer.type.find(function (specialty) {
	          return specialty.id === id;
	        });
	      }).map(function (specialty) {
	        return specialty.name;
	      }) : '';
	      _position.employer = employer;
	      $uibModal.open({
	        templateUrl: 'position-details-modal.html',
	        windowClass: 'position-modal-window',
	        controller: 'PositionDetailsController',
	        controllerAs: 'ctrl',
	        resolve: {
	          position: function position() {
	            return _position;
	          },
	          listingName: function listingName() {
	            return vm.gridName;
	          }
	        }
	      });
	    };
	
	    function onFilterChanged() {
	      var model = vm.gridOptions.api.getFilterModel();
	
	      vm.filterCount = Object.keys(model).length;
	      // eslint-disable-next-line angular/document-service
	      var filterTextBoxValue = document.querySelector('#filter-text-box').value;
	      if (filterTextBoxValue.length > 0) {
	        vm.filterCount += 1;
	      }
	
	      updatePipelineCountFromGrid();
	    }
	
	    // TODO: on grid functionality
	    function updatePipelineCountFromGrid() {
	      vm.gridOptions.api.forEachNode(function (node) {
	        if (node.key) {
	          vm.groupList.map(function (row) {
	            if (row.id === node.id) {
	              row.applicationsCount = node.allChildrenCount;
	              return row;
	            }
	
	            return row;
	          });
	        }
	      });
	      $scope.$applyAsync();
	    }
	
	    // TODO: on grid action items functionality
	    function updateGridGroupPipeline() {
	      vm.groupList = [];
	
	      vm.gridOptions.api.forEachNode(function (node) {
	        if (node.key) {
	          var hasChild = true;
	          if (_.isEmpty(node.childrenMapped) || 'undefined' in node.childrenMapped) hasChild = false;
	          vm.groupList.push({
	            name: node.key,
	            applicationsCount: node.allChildrenCount,
	            color: node.leafGroup ? '#' + Math.trunc(Math.random() * 0xffffff).toString(16) : lighten('#5e5e5e', (node.level + 1) * 10),
	            id: node.id,
	            intId: Number(node.id) * -1,
	            level: node.level,
	            parentID: node.parent.id,
	            hasChild: hasChild,
	            isHidden: node.level !== 0
	          });
	        }
	      });
	      $log.debug('vm.groupList', vm.groupList);
	      $scope.$applyAsync();
	    }
	
	    vm.hideAccounts = function () {
	      var currentActiveFilters = vm.gridOptions.api.getFilterModel();
	      if (vm.actionsFunctions[0].hideAccounts === true) {
	        var hiddenData = vm.recommendationListing.filter(function (_ref12) {
	          var candidateDetails = _ref12.candidateDetails;
	          return candidateDetails.email && candidateDetails.email.toLowerCase().includes('@lexstep') === false && candidateDetails.email && candidateDetails.email.toLowerCase().includes('@emumba') === false;
	        });
	        vm.gridOptions.api.setRowData(hiddenData);
	      } else {
	        vm.gridOptions.api.setRowData(vm.recommendationListing);
	      }
	
	      vm.gridOptions.api.setFilterModel(currentActiveFilters);
	      vm.actionsFunctions[0].hideAccounts = !vm.actionsFunctions[0].hideAccounts;
	      if (vm.actionsFunctions[0].funcName === 'Hide Test Accounts') vm.actionsFunctions[0].funcName = 'Show Test Accounts';else vm.actionsFunctions[0].funcName = 'Hide Test Accounts';
	      vm.gridOptions.api.deselectAll();
	      onSelectionChanged();
	      updateGridGroupPipeline();
	    };
	
	    function viewProfile(parameter) {
	      if (parameter.data.candidateDetails.approvalStatus === 'New User') {
	        $window.open('/profile?user=' + parameter.data.candidateDetails.id, '_blank');
	      } else vm.candidateProfile(parameter.data.candidateDetails.id);
	    }
	
	    vm.candidateProfile = function (code) {
	      modalInstance = $uibModal.open({
	        templateUrl: 'candidateProfileModal.html',
	        windowClass: 'app-candidate-profile-modal-window',
	        controller: 'CandidateProfileModalController',
	        resolve: {
	          data: function data() {
	            return code;
	          }
	        }
	      });
	    };
	
	    function cvCellClicked(parameter) {
	      if (parameter.data.cvUrl) getApplicationResume(parameter.data.id, parameter.data.cvUrl);
	    }
	
	    vm.splitGrid = function (value) {
	      vm.showCv.isShow = value;
	      var agGridListingDiv = document.querySelector('#' + vm.gridName);
	      var cvDiv = document.querySelector('#myCV');
	      agGridListingDiv.style.height = window.innerHeight - 235 + 'px';
	      agGridListingDiv.style.padding = 0;
	      cvDiv.style.height = window.innerHeight - 235 + 'px';
	      if (value) {
	        agGridListingDiv.style.width = '65%';
	        agGridListingDiv.classList.add('col-md-7');
	      } else agGridListingDiv.style.width = '100%';
	    };
	
	    vm.applicationsResume = [];
	    var getApplicationResume = function () {
	      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(applicationId, cvUrl) {
	        var resumeFound, _ref14, status, resume, arrayBufferView, blob, urlCreator, resumeUrl;
	
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                vm.showCv = { applicationId: applicationId };
	                vm.showCv.isDoc = false;
	                if (cvUrl.includes('.doc')) {
	                  vm.showCv.isDoc = true;
	                } else vm.splitGrid(true);
	                resumeFound = vm.applicationsResume.find(function (resume) {
	                  return resume.applicationId === applicationId;
	                });
	
	                if (!resumeFound) {
	                  _context4.next = 9;
	                  break;
	                }
	
	                vm.showCv.path = $sce.trustAsResourceUrl(resumeFound.url);
	                if (vm.showCv.isDoc) vm.downloadDocFormatCV(cvUrl, vm.showCv.path, applicationId);else vm.showCv.display = vm.showCv.path;
	                _context4.next = 16;
	                break;
	
	              case 9:
	                startSpinner('spinner-resume');
	                _context4.next = 12;
	                return ApplicationsApi.getApplicationResume(applicationId);
	
	              case 12:
	                _ref14 = _context4.sent;
	                status = _ref14.status;
	                resume = _ref14.data;
	
	                if (status === 200) {
	                  if (resume.statusCode === 404) {
	                    if (cvUrl.includes('.doc')) vm.splitGrid(true);
	                    vm.showCv.isNotFound = true;
	                  } else {
	                    arrayBufferView = new Uint8Array(resume.data);
	                    blob = vm.showCv.isDoc ? new Blob([arrayBufferView], {
	                      type: 'application/msword;base64'
	                    }) : new Blob([arrayBufferView], {
	                      type: 'application/pdf;base64'
	                    });
	                    urlCreator = $window.URL || $window.webkitURL;
	                    resumeUrl = urlCreator.createObjectURL(blob);
	
	                    vm.showCv.path = $sce.trustAsResourceUrl(resumeUrl);
	                    if (vm.showCv.isDoc) vm.downloadDocFormatCV(cvUrl, vm.showCv.path, applicationId);else vm.showCv.display = vm.showCv.path;
	
	                    vm.applicationsResume = [].concat(_toConsumableArray(vm.applicationsResume), [{
	                      applicationId: applicationId,
	                      url: resumeUrl
	                    }]);
	                  }
	
	                  stopSpinner('spinner-resume');
	                }
	
	              case 16:
	
	                $scope.$applyAsync();
	
	              case 17:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this);
	      }));
	
	      return function getApplicationResume(_x3, _x4) {
	        return _ref13.apply(this, arguments);
	      };
	    }();
	
	    vm.downloadDocFormatCV = function (cvUrl, path, applicationId) {
	      var format = cvUrl.split('.').slice(1).join('');
	
	      var a = document.createElement('a');
	      document.body.append(a);
	      a.style = 'display: none';
	      a.href = path;
	      a.download = 'application-' + applicationId + '.' + format;
	      a.click();
	    };
	
	    function onSelectionChanged() {
	      vm.selectedRows = vm.gridOptions.api.getSelectedRows();
	      vm.selectedRowsLength = vm.selectedRows.length;
	      hideShowDropdownActionItem();
	    }
	
	    var hideShowDropdownActionItem = function hideShowDropdownActionItem() {
	      vm.multiSelectOptions = undefined;
	
	      var functionName = vm.actionsFunctions[0].funcName;
	      var hideAccounts = vm.actionsFunctions[0].hideAccounts;
	      vm.actionsFunctions = [{
	        funcName: functionName,
	        leftClick: vm.hideAccounts,
	        values: vm.recommendationListing,
	        hideAccounts: hideAccounts
	      }];
	      if (vm.selectedRowsLength > 0) {
	        vm.multiSelectOptions = [{
	          count: vm.selectedRowsLength
	        }, {
	          funcName: 'Clear Selection',
	          function: vm.clearSelection
	        }];
	        var _functionName = vm.actionsFunctions[0].funcName;
	        var _hideAccounts = vm.actionsFunctions[0].hideAccounts;
	        vm.actionsFunctions = [{
	          funcName: _functionName,
	          leftClick: vm.hideAccounts,
	          values: vm.recommendationListing,
	          hideAccounts: _hideAccounts
	        }];
	        vm.gridDataActions = [{
	          count: vm.selectedRowsLength
	        }];
	      }
	
	      $scope.$applyAsync();
	    };
	
	    // On clicking any referral code it will redirect on referral page with specific code filter
	    function redirectToReferrals(parameter) {
	      if (parameter.data.candidateDetails.referredById && parameter.data.candidateDetails.referredBy !== '') $window.open('/admin/referral-listing?filterName=referralCode&filterValue=' + parameter.data.candidateDetails.referredById, '_blank');
	    }
	
	    function getContextMenuItems(parameter) {
	      var result = [{
	        name: 'Open profile in new tab ',
	        action: function action() {
	          if (parameter.node.data.lawyer_Status === 'NewUser') {
	            $window.open('/profile?user=' + parameter.node.data.candidateDetails.id, '_blank');
	          } else $window.open('/admin/lawyer-profile?user=' + parameter.node.data.candidateDetails.id, '_blank');
	        }
	      }, 'separator', {
	        name: 'Expand All Columns',
	        action: function action() {
	          var columnApi = parameter.columnApi.getColumnGroupState();
	          columnApi.forEach(function (item) {
	            parameter.columnApi.setColumnGroupOpened(item.groupId, true);
	          });
	        }
	      }, {
	        name: 'Collapse All Columns',
	        action: function action() {
	          var columnApi = parameter.columnApi.getColumnGroupState();
	          columnApi.forEach(function (item) {
	            parameter.columnApi.setColumnGroupOpened(item.groupId, false);
	          });
	        }
	      }, 'separator', 'copy', 'copyWithHeaders', 'separator', 'chartRange'];
	      vm.isExportAllowed = vm.user.roles.some(function (role) {
	        return role.id === 'admin' || role.id === 'ops';
	      });
	      if (vm.isExportAllowed) result.push('export');
	      return result;
	    }
	
	    vm.actionsFunctions = [{
	      funcName: 'Hide Test Accounts',
	      leftClick: vm.hideAccounts,
	      values: vm.recommendationListing,
	      hideAccounts: true
	    }];
	
	    var modalInstance = void 0;
	    vm.profileLink = function (id) {
	      modalInstance.close();
	      $window.open('/admin/lawyer-profile?user=' + id, '_blank');
	    };
	
	    vm.filterModel = {};
	
	    vm.createInitialFilterModel = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	      var currentFilterModel, position, employer, pqe, employerType, parsePqe, _parsePqe, minPqe, maxPqe, paddedMinPqe, paddedMaxPqe, categories, employerTypeSpecialties, occupation, hasLocations, location, hasContractType, contractType, practiceAreas, parentIds, mostSpecificPracticeAreas, legalCandidatePracticeAreas, result;
	
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              currentFilterModel = vm.gridOptions.api.getFilterModel();
	              position = vm.position;
	              employer = vm.employerFull;
	              pqe = position.professionId === 'law' ? {
	                filterType: 'number'
	              } : {};
	              employerType = position.professionId === 'law' ? {
	                filterType: 'set'
	              } : {};
	
	
	              if (position.professionId === 'law') {
	                parsePqe = function parsePqe(_ref16) {
	                  var minPqe = _ref16.minPqe,
	                      maxPqe = _ref16.maxPqe;
	
	                  return {
	                    minPqe: minPqe !== undefined && minPqe !== null ? Number.parseFloat(minPqe) : -2,
	                    maxPqe: maxPqe !== undefined && maxPqe !== null ? Number.parseFloat(maxPqe) : +11
	                  };
	                };
	
	                _parsePqe = parsePqe(position.lawPreferences), minPqe = _parsePqe.minPqe, maxPqe = _parsePqe.maxPqe;
	                paddedMinPqe = minPqe >= -1 ? minPqe - 1 : -2;
	                paddedMaxPqe = maxPqe <= 10 ? maxPqe + 1 : 11;
	
	
	                pqe.operator = 'AND';
	
	                pqe.condition1 = {
	                  filterType: 'number',
	                  type: 'greaterThanOrEqual',
	                  filter: paddedMinPqe,
	                  filterTo: null
	                };
	
	                pqe.condition2 = {
	                  filterType: 'number',
	                  type: 'lessThanOrEqual',
	                  filter: paddedMaxPqe,
	                  filterTo: null
	
	                  // Employer type
	                };categories = employer.categories;
	                employerTypeSpecialties = categories.find(function (category) {
	                  return category.name === 'Legal Employer Type';
	                }).specialties.map(function (_ref17) {
	                  var name = _ref17.name;
	                  return name;
	                });
	
	
	                employerType.values = employerTypeSpecialties;
	              }
	
	              // CandidatePreference.occupations
	              occupation = {
	                filterType: 'set',
	                values: [position.occupation.name]
	
	                // Locations
	              };
	              hasLocations = position.locations.length > 0;
	              location = hasLocations ? {
	                values: position.locations.map(function (location) {
	                  return location.name;
	                }),
	                filterType: 'set'
	              } : {};
	
	              // Contract type
	
	              hasContractType = position.contractType !== null && position.contractType !== undefined;
	              contractType = hasContractType ? {
	                filterType: 'set',
	                values: [position.contractType.name]
	              } : {};
	              practiceAreas = position.specialties.filter(function (_ref18) {
	                var categoryId = _ref18.categoryId;
	                return categoryId === 1;
	              });
	              parentIds = new Set(practiceAreas.map(function (_ref19) {
	                var parentId = _ref19.parentId;
	                return parentId;
	              }));
	              mostSpecificPracticeAreas = practiceAreas.filter(function (_ref20) {
	                var id = _ref20.id;
	                return !parentIds.has(id);
	              });
	              legalCandidatePracticeAreas = {
	                filterType: 'set',
	                values: mostSpecificPracticeAreas.map(function (_ref21) {
	                  var name = _ref21.name;
	                  return name;
	                })
	              };
	
	              $log.debug('legalCandidatePracticeAreas:', legalCandidatePracticeAreas);
	
	              vm.filterModel = currentFilterModel;
	
	              if (Object.keys(pqe).length > 1) {
	                vm.filterModel['candidateProfile.pqe'] = pqe;
	              }
	
	              if (legalCandidatePracticeAreas.values.length > 0) {
	                vm.filterModel.legalCandidatePracticeAreas = legalCandidatePracticeAreas;
	              }
	
	              if (Boolean(employerType) && Boolean(employerType.values) && Boolean(employerType.values.length)) {
	                vm.filterModel['candidatePreference.legalEmployerType'] = employerType;
	              }
	
	              if (hasContractType) {
	                vm.filterModel['candidatePreference.contracts'] = contractType;
	              }
	
	              if (occupation.values.length > 0) {
	                vm.filterModel['candidatePreference.occupations'] = occupation;
	              }
	
	              if (hasLocations) {
	                vm.filterModel['candidatePreference.locations'] = location;
	              }
	
	              vm.gridOptions.api.setFilterModel(vm.filterModel);
	
	              result = vm.gridOptions.api.getFilterModel();
	              return _context5.abrupt('return', result);
	
	            case 26:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this);
	    }));
	
	    vm.loadRecommendationListing = function (recommendationRecord) {
	      vm.recommendationListing = setRecommendationListingData(recommendationRecord).sort(function (a, b) {
	        return a.interestId > b.interestId ? 1 : -1;
	      });
	
	      vm.gridOptions.api.setRowData(vm.recommendationListing);
	      vm.createInitialFilterModel();
	      // eslint-disable-next-line no-unused-vars
	      var updatedFilterModel = vm.gridOptions.api.getFilterModel();
	      $rootScope.$broadcast('listing-loaded');
	
	      updateGridGroupPipeline();
	    };
	
	    var setRecommendationListingData = function setRecommendationListingData(recommendationRecord) {
	      return recommendationRecord.map(function (data) {
	        data.matchingEmployerFollowed = data.followEmployer.length > 0 && data.followEmployer.find(function (employer) {
	          return employer.id === Number(vm.employerId);
	        }) ? 'Yes' : 'No';
	
	        data.matchingPositionHidden = data.hiddenPosition.length > 0 && data.hiddenPosition.find(function (position) {
	          return position.id === Number(vm.positionId);
	        }) ? 'Yes' : 'No';
	
	        data.matchingEmployerHidden = data.hiddenEmployer.length > 0 && data.hiddenEmployer.find(function (employer) {
	          return employer.id === Number(vm.employerId);
	        }) ? 'Yes' : 'No';
	
	        data.followEmployersName = data.followEmployer.length > 0 ? vm.employersNameList.filter(function (_ref22) {
	          var id = _ref22.id;
	          return data.followEmployer.find(function (employer) {
	            return employer.id === id;
	          });
	        }).map(function (employer) {
	          return employer.name;
	        }) : '';
	        data.hiddenEmployersName = data.hiddenEmployer.length > 0 ? vm.employersNameList.filter(function (_ref23) {
	          var id = _ref23.id;
	          return data.hiddenEmployer.find(function (employer) {
	            return employer.id === id;
	          });
	        }).map(function (employer) {
	          return employer.name;
	        }) : '';
	
	        setRecommendationDetailsColumnData(data);
	        setCandidateDetailsColumnsData(data, vm);
	        setCandidateProfileColumnsData(data, vm);
	        if (data.currentExperience.employer && data.currentExperience.employerId) setCurrentExperienceColumnsData(data, vm);
	        setCandidatePreferenceColumnsData(data, vm);
	        setCandidateActivityColumnsData(data, vm);
	        data.recentlyMoved = data.currentExperience.isLastJob && new Date(data.currentExperience.startDate) >= new Date(lastSixMonthDate()) ? 'Yes' : 'No';
	        return data;
	      });
	    };
	
	    var startSpinner = function startSpinner(name) {
	      return usSpinnerService.spin(name);
	    };
	    var stopSpinner = function stopSpinner(name) {
	      return usSpinnerService.stop(name);
	    };
	
	    var initializeRecommendationListing = function () {
	      var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
	        var _ref25, _ref26, agentsList, locationsList, languagesList, nationalitiesList, schoolList, legalPracticeAreaList, legalEmployerTypeList, legalJurisdictionList, contractTypeList, occupationList, recommendationList, employersNameList, userLoginActions, userAllConversationNotes, position, employer;
	
	        return regeneratorRuntime.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _context6.next = 2;
	                return userService.getUser();
	
	              case 2:
	                vm.user = _context6.sent;
	
	                vm.positionId = $location.search().positionId;
	                vm.employerId = $location.search().employerId;
	                vm.innerHeight = $location.search().innerHeight;
	
	                startSpinner('recommendation-listing');
	                _context6.next = 9;
	                return Promise.all([CandidateProfileApi.getAdminAndCorporateUsers(), SharedApi.getAllLocations({
	                  regions: true
	                }), SharedApi.getAllLanguages(), SharedApi.getAllNationalities(), SharedApi.getAllSchools(), SharedApi.getCategoryById(1), SharedApi.getCategoryById(2), SharedApi.getCategoryById(3), SharedApi.getAllContractTypes(), SharedApi.getAllOccupations(), RecommendationListingApi.getPositionRecommendations(vm.positionId), EmployersApi.getAllEmployers({ include: ['id', 'name'] }), SharedApi.getAllActions({
	                  category: 'user',
	                  type: 'USER_LOGIN',
	                  include: true
	                }), NotesApi.getAllNotes({
	                  category: 'Conversation',
	                  type: 'user',
	                  includes: true
	                }), PositionApi.getPositionById(vm.positionId), EmployersApi.getEmployerById(vm.employerId)]);
	
	              case 9:
	                _ref25 = _context6.sent;
	                _ref26 = _slicedToArray(_ref25, 16);
	                agentsList = _ref26[0].data;
	                locationsList = _ref26[1].data;
	                languagesList = _ref26[2].data;
	                nationalitiesList = _ref26[3].data;
	                schoolList = _ref26[4].data;
	                legalPracticeAreaList = _ref26[5].data;
	                legalEmployerTypeList = _ref26[6].data;
	                legalJurisdictionList = _ref26[7].data;
	                contractTypeList = _ref26[8].data;
	                occupationList = _ref26[9].data;
	                recommendationList = _ref26[10].data;
	                employersNameList = _ref26[11].data;
	                userLoginActions = _ref26[12].data;
	                userAllConversationNotes = _ref26[13].data;
	                position = _ref26[14].data;
	                employer = _ref26[15].data;
	
	                vm.userLoginActions = userLoginActions;
	                vm.position = position;
	                vm.userAllConversationNotes = userAllConversationNotes;
	                vm.agentsList = agentsList;
	                vm.legalPracticeAreaList = legalPracticeAreaList.specialties;
	                vm.legalEmployerTypeList = legalEmployerTypeList.specialties;
	                vm.jurisdictionList = legalJurisdictionList.specialties;
	                vm.locationsList = locationsList;
	                vm.languagesList = languagesList;
	                vm.nationalitiesList = nationalitiesList;
	                vm.schoolList = schoolList;
	                vm.contractTypesList = contractTypeList;
	                vm.occupationList = occupationList;
	                vm.employersNameList = employersNameList;
	                vm.employerFull = employer;
	                vm.loadRecommendationListing(recommendationList);
	
	                stopSpinner('recommendation-listing');
	
	              case 44:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this);
	      }));
	
	      return function initializeRecommendationListing() {
	        return _ref24.apply(this, arguments);
	      };
	    }();
	  }]);
	})();
	
	var lastSixMonthDate = function lastSixMonthDate() {
	  var today = new Date();
	  return today.setMonth(today.getMonth() - 6);
	};
	
	var addLight = function addLight(color, amount) {
	  var cc = Number.parseInt(color, 16) + amount;
	  var c = cc > 255 ? 255 : cc;
	  c = c.toString(16).length > 1 ? c.toString(16) : '0' + c.toString(16);
	  return c;
	};
	
	var lighten = function lighten(color, amount) {
	  color = color.includes('#') ? color.slice(1, color.length) : color;
	  // eslint-disable-next-line radix
	  amount = Number.parseInt(255 * amount / 100);
	  color = '#' + addLight(color.slice(0, 2), amount) + addLight(color.slice(2, 4), amount) + addLight(color.slice(4, 6), amount);
	  return color;
	};
	
	var recommendationHelpContent = '\n<div>\n<p>\tMatches helps you identify relevant candidates to scout for each Position, based on LexStep\u2019s matching engine.  It also enables you keep tabs on the status of candidates that have been scouted for the Position at any time and saves a record for future reference; to help with scouting candidates for similar Positions in future.</p>\n<b>My Candidates</b>\n<p>Filter by \u201CMy Candidates\u201D from the toolbar above the grid to display matches from your assigned candidates only.</p>\n<b>Filtering</b>\n<p>Several Filters are automatically applied by the LexStep matching engine to produce an initial shortlist of Matches based on the Candidate\u2019s PQE, Preferences and the requirements of the Position, including:</p>\n<ul>\n<li>Practice Area Preference</li>\n<li>Location Preference</li>\n<li>Contract Preference</li>\n<li>Role Preference</li>\n<li>Employer Type Preference</li>\n<li>PQE</li>\n</ul>\n<p>A filter icon appears in each relevant column header to show which data points the LexStep matching engine has applied.  You can adjust any of the column filters to refine your search; either by expanding the search or narrowing to be more specific.</p>\n<b>Views</b>\n<p>Personalise different list layouts by choosing the columns to display, adjusting their width and moving them to re-order to your preferences. You can save custom column layouts with filter criteria to easy access again later via the \u201CViews\u201D icon in the top right -- either as a Private \u201CSaved View\u201D or Shared with other team members. </p>\n<b>Clear</b>\n<p>When one or more filters are applied, a Clear filter icon will appear in the top right above the grid. Select to clear any applied filters and/or search and reset the grid data.</p>\n<b>Group</b>\n<p>The Matches grid is grouped by Match Stage by default. Drag and drop columns to the grouping drop zone in the grid\u2019s top row to group rows by a particular column. You can Expand/Collapse All Rows from the Views icon in the top right to view positions by group.</p>\n<b>Sorting</b>\n<p>[Coming soon: Matches are sorted by Match Score in descending order, showing the most relevant match first by default.]</p>\n<p>You can change how the list is ordered by clicking the column headers to sort. To sort by multiple columns, hold down shift while clicking the column header.</p>\n<b>Match Details</b>\n<p>Expanding the Match Details column group reveals information on each Candidate\u2019s prior interactions with the relevant Position and Employer.  This data can be used to easily identify and scout candidates that have shown a prior interest in positions at that Employer.</p>\n<b>Scouting using Match Stage and Sub-Stage</b>\n<p>Match Stage enables you to keep a record of scouted matches for each Position by differentiating between \u201CMatched\u201D and \u201CScouted\u201D candidates.  Select one or more matches and use the star icon in the toolbar above the grid to change Match stage.</p>\n<p>Changing a match\u2019s sub-stage to \u201CScouted - Shortlisted by LexStep\u201D (or any of the other Scouted sub-stages) will automatically change its parent stage to \u201CScouted\u201D, and vice versa.  </p>\n<p>Once you have scouted the list of Matches to produce a shortlist, you can then use the sub-stage \u201CScouted - Awaiting Candidate\u2019s Response\u201D to record the status of candidates you have  specifically reached out to.  Likewise if a candidate has responded to your approach and is waiting for further information from you, you can use the sub-stage \u201CScouted - Candidate Awaiting Response\u201D to help manage the process prior to Application.</p>\n<p>If a Scouted candidate goes on to apply for the Position their Application will skip the usual Application sub-stage \u201CApplied - Pending Review\u201D and be fast-tracked to \u201CShortlisted - Shortlisted for Submission\u201D, to streamline the application management process and save duplicate review.</p>\n<b>Scouting using Scout Stage </b>\n<p>Scout Stage enables you to scout and keep a record of candidates by scout stage for each Position by differentiating between \u201CMatched\u201D and \u201CScouted\u201D candidates. </p>\n<p>Select one or more matches and use the thumbs up icon in the toolbar above the grid to change Scout Stage.</p>\n<p>Changing a match\u2019s stage to \u201CScouted - Shortlisted by Talent Agent\u201D (or any of the other Scouted sub-stages) will automatically change its parent stage to \u201CScouted\u201D, and vice versa.</p>\n<p>Once you have scouted the list of Matches to produce a shortlist, you can then use the stage \u201CScouted - Awaiting Candidate\u2019s Response\u201D to record the status of scouted candidates you have specifically reached out to about the Position.</p>\n<p>Likewise if a candidate has responded to your approach and is waiting for further information from you before putting themselves forward for the Position, you can use the stage \u201CScouted - Candidate Awaiting Response\u201D to help manage the process prior to Application.</p>\n<p>If a Scouted candidate goes on to apply for the Position their Application will skip the usual Application sub-stage \u201CApplied - Pending Review\u201D and be fast-tracked to \u201CShortlisted - Shortlisted for Submission\u201D, to streamline the application management process and save duplicate review.</p>\n<b>Match Status</b>\n<p>You can pass on matches by selecting one or more candidates and using the thumbs down  icon in the toolbar above the grid to change Match Status.</p>\n</div> ';
	
	var setCandidateDetailsColumnsData = function setCandidateDetailsColumnsData(data, vm) {
	  data.candidateDetails.referralCode = data.candidateDetails.id;
	  data.candidateAgentEmail = data.candidateDetails.agentId ? vm.agentsList.find(function (agent) {
	    return agent.id === data.candidateDetails.agentId;
	  }) && vm.agentsList.find(function (agent) {
	    return agent.id === data.candidateDetails.agentId;
	  }).email : 'unassigned';
	
	  var platformAccess = data.candidateDetails.platformAccess;
	  var leadAccount = data.candidateDetails.leadAccount;
	  data.candidateDetails.platformAccess = platformAccess ? 'Candidate Account' : leadAccount ? 'Lead Account' : 'No Platform Access';
	
	  return data;
	};
	
	var setCandidateProfileColumnsData = function setCandidateProfileColumnsData(data, vm) {
	  data.candidateProfile.fullName = data.candidateProfile.firstName + ' ' + data.candidateProfile.lastName;
	  data.candidateProfile.pqe = data.candidateProfile.qualificationDate ? (0, _formatPqe.formatQualificationDateToPqe)(data.candidateProfile.qualificationDate) : '';
	  var currentLocation = '';
	  if (data.candidateProfile.currentLocation) {
	    currentLocation = vm.locationsList.find(function (location) {
	      return location.id === data.candidateProfile.currentLocation;
	    });
	  }
	
	  data.candidateProfile.currentLocation = currentLocation ? currentLocation.name : currentLocation;
	  data.candidateProfile.languages = data.candidateProfile.languages.length > 0 ? vm.languagesList.filter(function (_ref27) {
	    var code = _ref27.code;
	    return data.candidateProfile.languages.find(function (language) {
	      return language.code === code;
	    });
	  }).map(function (language) {
	    return language.name;
	  }) : '';
	  data.candidateProfile.jurisdictions = data.candidateProfile.jurisdictions.length > 0 ? vm.jurisdictionList.filter(function (_ref28) {
	    var id = _ref28.id;
	    return data.candidateProfile.jurisdictions.find(function (jurisdiction) {
	      return jurisdiction.id === id;
	    });
	  }).map(function (jurisdiction) {
	    return jurisdiction.name;
	  }) : '';
	  data.candidateProfile.school = data.candidateProfile.school ? vm.schoolList.find(function (school) {
	    return school.id === data.candidateProfile.school;
	  }).name : '';
	  data.candidateProfile.nationality = data.candidateProfile.nationalities && data.candidateProfile.nationalities.length > 0 ? vm.nationalitiesList.filter(function (_ref29) {
	    var code = _ref29.code;
	    return data.candidateProfile.nationalities.find(function (nationality) {
	      return nationality.code === code;
	    });
	  }).map(function (nationality) {
	    return nationality.demonyms[0];
	  }) : '';
	  return data;
	};
	
	var setCurrentExperienceColumnsData = function setCurrentExperienceColumnsData(data, vm) {
	  data.currentExperience.contractType = data.currentExperience.contractTypeId ? vm.contractTypesList.find(function (contract) {
	    return contract.id === data.currentExperience.contractTypeId;
	  }).name : '';
	  data.currentExperience.occupation = data.currentExperience.occupationId ? vm.occupationList.find(function (occupation) {
	    return occupation.id === data.currentExperience.occupationId;
	  }).name : '';
	  data.currentExperience.specialties = data.currentExperience.positionSpecialties.length > 0 ? vm.legalPracticeAreaList.filter(function (_ref30) {
	    var id = _ref30.id;
	    return data.currentExperience.positionSpecialties.find(function (specialty) {
	      return specialty.id === id;
	    });
	  }).map(function (specialty) {
	    return specialty.name;
	  }) : '';
	  data.currentExperience.employerType = data.currentExperience.employerSpecialties.length > 0 ? vm.legalEmployerTypeList.filter(function (_ref31) {
	    var id = _ref31.id;
	    return data.currentExperience.employerSpecialties.find(function (specialty) {
	      return specialty.id === id;
	    });
	  }).map(function (specialty) {
	    return specialty.name;
	  }) : '';
	  var currentEmployerSelectivity = '';
	  if (data.currentExperience.employer.selectivity) {
	    for (var index = 1; index <= data.currentExperience.employer.selectivity; index++) {
	      currentEmployerSelectivity += '$';
	    }
	  }
	
	  if (data.currentExperience.employer.selectivity === 0) currentEmployerSelectivity = 'Uncategorized';
	  data.currentExperience.employer.selectivity = currentEmployerSelectivity;
	
	  return data;
	};
	
	var setCandidateActivityColumnsData = function setCandidateActivityColumnsData(data, vm) {
	  data.candidateActivity.loginCount = vm.userLoginActions.find(function (_ref32) {
	    var userId = _ref32.userId;
	    return userId === data.candidateDetails.id;
	  }) && Number(vm.userLoginActions.find(function (_ref33) {
	    var userId = _ref33.userId;
	    return userId === data.candidateDetails.id;
	  }).count);
	  data.candidateActivity.totalConversationNote = vm.userAllConversationNotes.find(function (_ref34) {
	    var userId = _ref34.userId;
	    return userId === data.candidateDetails.id;
	  }) && Number(vm.userAllConversationNotes.find(function (_ref35) {
	    var userId = _ref35.userId;
	    return userId === data.candidateDetails.id;
	  }).count);
	  data.candidateActivity.lastConversationNote = vm.userAllConversationNotes.find(function (_ref36) {
	    var userId = _ref36.userId;
	    return userId === data.candidateDetails.id;
	  }) && vm.userAllConversationNotes.find(function (_ref37) {
	    var userId = _ref37.userId;
	    return userId === data.candidateDetails.id;
	  }).created;
	  data.emailAlertDailyMatches = data.candidateActivity.emailSubscription.length > 0 ? data.candidateActivity.emailSubscription.find(function (_ref38) {
	    var id = _ref38.id;
	    return id === 'daily_positions_ping';
	  }) && data.candidateActivity.emailSubscription.find(function (_ref39) {
	    var id = _ref39.id;
	    return id === 'daily_positions_ping';
	  }).status : 'Active';
	  data.emailAlertWeeklyInHouseATS = data.candidateActivity.emailSubscription.length > 0 ? data.candidateActivity.emailSubscription.find(function (_ref40) {
	    var id = _ref40.id;
	    return id === 'weekly_position_ping';
	  }) && data.candidateActivity.emailSubscription.find(function (_ref41) {
	    var id = _ref41.id;
	    return id === 'weekly_position_ping';
	  }).status : 'Active';
	
	  return data;
	};
	
	var setCandidatePreferenceColumnsData = function setCandidatePreferenceColumnsData(data, vm) {
	  data.legalCandidatePracticeAreas = data.candidatePreference.specialties.length > 0 ? vm.legalPracticeAreaList.filter(function (_ref42) {
	    var id = _ref42.id;
	    return data.candidatePreference.specialties.find(function (specialty) {
	      return specialty.id === id;
	    });
	  }).map(function (specialty) {
	    return specialty.name;
	  }) : '';
	  data.candidatePreference.legalEmployerType = data.candidatePreference.specialties.length > 0 ? vm.legalEmployerTypeList.filter(function (_ref43) {
	    var id = _ref43.id;
	    return data.candidatePreference.specialties.find(function (specialty) {
	      return specialty.id === id;
	    });
	  }).map(function (specialty) {
	    return specialty.name;
	  }) : '';
	  data.candidatePreference.contracts = data.candidatePreference.contracts.length > 0 ? vm.contractTypesList.filter(function (_ref44) {
	    var id = _ref44.id;
	    return data.candidatePreference.contracts.find(function (contractType) {
	      return contractType.id === id;
	    });
	  }).map(function (contractType) {
	    return contractType.name;
	  }) : '';
	  data.candidatePreference.occupations = data.candidatePreference.occupations.length > 0 ? vm.occupationList.filter(function (_ref45) {
	    var id = _ref45.id;
	    return data.candidatePreference.occupations.find(function (occupation) {
	      return occupation.id === id;
	    });
	  }).map(function (occupation) {
	    return occupation.name;
	  }) : '';
	  data.candidatePreference.locations = data.candidatePreference.locations.length > 0 ? vm.locationsList.filter(function (_ref46) {
	    var id = _ref46.id;
	    return data.candidatePreference.locations.find(function (location) {
	      return location.id === id;
	    });
	  }).map(function (location) {
	    return location.name;
	  }) : '';
	  return data;
	};
	
	var setMasterGridPositionColumnData = function setMasterGridPositionColumnData(data, vm, applicationRecord) {
	  data.position.rPQE = '' + (data.position.lawPreferences.minPqe <= 0 ? 'NQ' : data.position.lawPreferences.minPqe) + (data.position.lawPreferences.maxPqe === 11 ? '+' : data.position.lawPreferences.maxPqe <= 0 || data.position.lawPreferences.maxPqe === data.position.lawPreferences.minPqe ? '' : '-' + data.position.lawPreferences.maxPqe.toString());
	  data.position.visible = data.position.visible ? 'Visible' : 'Invisible';
	
	  data.position.specialties = data.position.specialties.length > 0 ? vm.legalPracticeAreaList.filter(function (_ref47) {
	    var id = _ref47.id;
	    return data.position.specialties.find(function (specialty) {
	      return specialty.id === id;
	    });
	  }).map(function (specialty) {
	    return specialty.name;
	  }) : '';
	
	  data.position.locations = data.position.locations.length > 0 ? vm.locationsList.filter(function (_ref48) {
	    var id = _ref48.id;
	    return data.position.locations.find(function (location) {
	      return location.id === id;
	    });
	  }).map(function (location) {
	    return location.name;
	  }) : '';
	
	  data.position.contractType = data.position.contractTypeId ? vm.contractTypesList.find(function (contract) {
	    return contract.id === data.position.contractTypeId;
	  }).name : '';
	  data.position.occupation = data.position.occupationId ? vm.occupationList.find(function (occupation) {
	    return occupation.id === data.position.occupationId;
	  }).name : '';
	  data.position.applicantCount = applicationRecord.filter(function (application) {
	    return application.position.id === data.position.id;
	  }).length;
	  return data;
	};
	
	var setRecommendationDetailsColumnData = function setRecommendationDetailsColumnData(data) {
	  if (data.matchingPositionHidden === 'Yes' || data.matchingEmployerHidden === 'Yes') {
	    data.interestId = 3;
	    data.interest = 'Not Interested';
	  } else if (data.appliedPosition.length > 0 || data.matchingEmployerFollowed === 'Yes') {
	    data.interestId = 1;
	    data.interest = 'Likely Interested';
	    var regularCustomAppliedPosition = data.appliedPosition.find(function (_ref49) {
	      var lastAppliedDateRegularCustom = _ref49.lastAppliedDateRegularCustom;
	      return lastAppliedDateRegularCustom !== null;
	    });
	    if (regularCustomAppliedPosition) {
	      data.lastAppliedDateRegularCustom = regularCustomAppliedPosition.lastAppliedDateRegularCustom;
	      data.totalAppliedPositionRegularCustom = regularCustomAppliedPosition.totalAppliedPositionRegularCustom;
	    }
	
	    var specConnectAppliedPosition = data.appliedPosition.find(function (_ref50) {
	      var lastAppliedDateSpecConnect = _ref50.lastAppliedDateSpecConnect;
	      return lastAppliedDateSpecConnect !== null;
	    });
	    if (specConnectAppliedPosition) {
	      data.lastAppliedDateSpecConnect = specConnectAppliedPosition.lastAppliedDateSpecConnect;
	      data.totalAppliedPositionSpecConnect = specConnectAppliedPosition.totalAppliedPositionSpecConnect;
	    }
	  } else if (data.appliedPosition.length === 0) {
	    data.interestId = 2;
	    data.interest = 'Unknown';
	  }
	
	  return data;
	};

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	;(function module() {
	  'use strict';
	
	  angular.module('app.ui.form.ctrls').controller('RecommendationPageController', ['$scope', '$location', '$window', '$uibModal', 'PositionApi', 'SharedApi', 'userService', function controller($scope, $location, $window, $uibModal, PositionApi, SharedApi, userService) {
	    var _this = this;
	
	    var vm = this;
	
	    vm.toggle = {};
	    vm.source = {};
	    vm.tabDescription = 1;
	    vm.initializeListing = {};
	    vm.setTab = function (tabId, value) {
	      vm.tab = tabId;
	      if (value !== 'Description' || value !== 'Source') vm.initializeListingGrid();
	
	      if (value === 'Matches') {
	        vm.toggle.recommendationListing = true;
	        vm.toggle.applicationListing = false;
	        vm.toggle.description = false;
	      } else if (value === 'Applications') {
	        vm.toggle.recommendationListing = false;
	        vm.toggle.applicationListing = true;
	        vm.toggle.description = false;
	      } else if (value === 'Description') {
	        vm.toggle.description = true;
	        vm.toggle.applicationListing = false;
	        vm.toggle.recommendationListing = false;
	      } else {
	        $window.open('https://www.linkedin.com', '_blank');
	      }
	    };
	
	    vm.isSet = function (tabId) {
	      return vm.tab === tabId;
	    };
	
	    vm.showModalTab = function (tabId) {
	      vm.tabDescription = tabId;
	    };
	
	    vm.isModalSet = function (tabId) {
	      return vm.tabDescription === tabId;
	    };
	
	    vm.tabSwitch = function (value) {
	      vm.toggle.recommendationListing = value;
	    };
	
	    // Vm.openEditJob = positionId => {
	    //   $window.open(
	    //     '/admin/job-edit?job=' + positionId + '&isClone=false',
	    //     '_blank'
	    //   )
	    // }
	
	    vm.openEditJob = function () {
	      // eslint-disable-next-line no-alert
	      alert('This feature has been disabled. Please use the pencil icon to edit the position.');
	    };
	
	    vm.openHelpDescriptionModal = function () {
	      var helpModalInstance = $uibModal.open({
	        templateUrl: 'help-description-modal.html',
	        controller: 'RecommendationHelpDescriptionModalController',
	        controllerAs: 'ctrl',
	        resolve: {
	          isModalSet: function isModalSet() {
	            return vm.isModalSet;
	          },
	          showModalTab: function showModalTab() {
	            return vm.showModalTab;
	          }
	        }
	      });
	      helpModalInstance.result.then(function () {
	        helpModalInstance.dismiss();
	      }, function () {});
	    };
	
	    vm.matchingLawyerDescription = function (positionRecord) {
	      if (positionRecord.professionId === 'tech' || !positionRecord.lawPreferences) {
	        positionRecord.lawPreferences = {
	          minPqe: positionRecord.techPreferences && positionRecord.techPreferences.minExperience ? positionRecord.techPreferences.minExperience : -2,
	          maxPqe: 11
	        };
	      }
	
	      var employerSelectivity = '';
	      if (positionRecord.employer.selectivity) {
	        for (var index = 1; index <= positionRecord.employer.selectivity; index++) {
	          employerSelectivity += '$';
	        }
	      }
	
	      if (positionRecord.employer.selectivity === 0) employerSelectivity = 'Uncategorized';
	
	      vm.recommendationPositionDescription = {
	        employer: {
	          id: positionRecord.employer.id,
	          name: positionRecord.employer.name,
	          selectivity: employerSelectivity
	        },
	        id: positionRecord.id,
	        title: positionRecord.title,
	        created: positionRecord.created,
	        lawPreferences: {
	          minPqe: positionRecord.lawPreferences.minPqe,
	          maxPqe: positionRecord.lawPreferences.maxPqe
	        },
	        pqe: positionRecord.lawPreferences.minPqe + ';' + positionRecord.lawPreferences.maxPqe,
	        contractType: vm.contractTypesList.find(function (contract) {
	          return contract.id === positionRecord.contractTypeId;
	        }).name,
	        occupation: vm.occupationList.find(function (occupation) {
	          return occupation.id === positionRecord.occupationId;
	        }).name,
	        locations: positionRecord.locations.length > 0 ? vm.locationsList.filter(function (_ref) {
	          var id = _ref.id;
	          return positionRecord.locations.find(function (location) {
	            return location.id === id;
	          });
	        }).map(function (location) {
	          return {
	            id: location.id,
	            name: location.name,
	            parent: location.parent,
	            color: location.country.region.color
	          };
	        }) : [],
	        specialties: positionRecord.specialties.length > 0 ? vm.legalPracticeAreaList.specialties.filter(function (_ref2) {
	          var id = _ref2.id;
	          return positionRecord.specialties.find(function (specialty) {
	            return specialty.id === id;
	          });
	        }) : [],
	        expiresAt: positionRecord.expiresAt,
	        minPQE: positionRecord.lawPreferences.minPqe ? positionRecord.lawPreferences.minPqe : -2,
	        maxPQE: positionRecord.lawPreferences.maxPqe ? positionRecord.lawPreferences.maxPqe : 11,
	        visible: positionRecord.visible,
	        status: positionRecord.expiresAt ? new Date(positionRecord.expiresAt).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0) ? 'Expired' : 'Active' : 'Active',
	        description: positionRecord.description,
	        externalUrl: positionRecord.externalUrl,
	        type: positionRecord.type
	      };
	    };
	
	    // Vm.openEditPositionPage = id => {
	    //   $window.open(`/admin/job-edit?job=${id}&isClone=false`, '_blank')
	    // }
	
	    vm.openEditPositionPage = function () {
	      // eslint-disable-next-line no-alert
	      alert('This feature has been disabled. Please use the pencil icon to edit the position.');
	    };
	
	    vm.openPositionDetailModal = function () {
	      $uibModal.open({
	        templateUrl: 'position-details-modal.html',
	        windowClass: 'position-modal-window',
	        controller: 'PositionDetailsController',
	        controllerAs: 'ctrl',
	        resolve: {
	          position: function position() {
	            return vm.recommendationPositionDescription;
	          },
	          listingName: function listingName() {
	            return 'recommendation';
	          }
	        }
	      });
	    };
	
	    vm.editPositionModal = function (id) {
	      var modalInstance = $uibModal.open({
	        templateUrl: 'create-update-position-modal.html',
	        windowClass: 'app-firm-window',
	        controller: 'CreateUpdatePositionModalController',
	        controllerAs: 'ctrl',
	        resolve: {
	          selectedPositionId: function selectedPositionId() {
	            return id;
	          },
	          adminId: function adminId() {
	            return vm.user.id;
	          }
	        }
	      });
	      modalInstance.result.then(function (position) {
	        modalInstance.dismiss('cancel');
	      }, function () {});
	    };
	
	    vm.positionStatusColor = function (selectedPosition) {
	      return selectedPosition && selectedPosition.expiresAt && new Date(selectedPosition.expiresAt).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0) ? { background: 'Red' } : { background: 'Yellow' };
	    };
	
	    vm.pageStyle = function () {
	      return {
	        height: vm.innerHeight - 120 + 'px',
	        width: '100%'
	      };
	    };
	
	    vm.setLocationColor = function (color) {
	      if (color) {
	        return {
	          background: color
	        };
	      }
	    };
	
	    vm.initializeListingGrid = function () {
	      if (vm.tab === 1 && !vm.initializeListing.recommendation) {
	        vm.initializeListing.recommendation = true;
	        vm.source.matchesSource = '/admin/matching-lawyers-listing?positionId=' + vm.positionId + '&employerId=' + vm.employerId + '&innerHeight=' + vm.innerHeight;
	      }
	
	      if (vm.tab === 2 && !vm.initializeListing.application) {
	        vm.initializeListing.application = true;
	        vm.source.applicationsSource = '/admin/application-listing?positionId=' + vm.positionId + '&innerHeight=' + vm.innerHeight;
	      }
	    };
	
	    vm.loadRecommendationPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var _ref4, _ref5, _ref5$, positionRecord, positionStatus, locationsList, contractTypeList, occupationList, legalPracticeAreaList;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return userService.getUser();
	
	            case 2:
	              vm.user = _context.sent;
	
	              vm.positionId = $location.search().positionId;
	              vm.employerId = $location.search().employerId;
	              // eslint-disable-next-line angular/window-service
	              vm.innerHeight = window.innerHeight;
	              vm.tab = Number($location.search().tab);
	              vm.tab = vm.tab ? vm.tab : 1;
	              vm.setTab(vm.tab, getTabType(vm.tab));
	              _context.next = 11;
	              return Promise.all([PositionApi.getPositionById(vm.positionId), SharedApi.getAllLocations({
	                regions: true
	              }), SharedApi.getAllContractTypes(), SharedApi.getAllOccupations(), SharedApi.getCategoryById(1)]);
	
	            case 11:
	              _ref4 = _context.sent;
	              _ref5 = _slicedToArray(_ref4, 5);
	              _ref5$ = _ref5[0];
	              positionRecord = _ref5$.data;
	              positionStatus = _ref5$.status;
	              locationsList = _ref5[1].data;
	              contractTypeList = _ref5[2].data;
	              occupationList = _ref5[3].data;
	              legalPracticeAreaList = _ref5[4].data;
	
	              if (positionStatus === 200) {
	                vm.selectedPosition = positionRecord;
	
	                vm.contractTypesList = contractTypeList;
	                vm.occupationList = occupationList;
	                vm.legalPracticeAreaList = legalPracticeAreaList;
	                vm.locationsList = locationsList;
	                vm.employerLogo = vm.selectedPosition.employer.logo ? ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/employers/' + vm.selectedPosition.employer.id + '/logo/' + vm.selectedPosition.employer.logo : undefined;
	                vm.matchingLawyerDescription(vm.selectedPosition);
	                $scope.$apply();
	              }
	
	            case 21:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    vm.loadRecommendationPage();
	  }]);
	})();
	
	var getTabType = function getTabType(id) {
	  switch (id) {
	    case 1:
	      return 'Matches';
	    case 2:
	      return 'Applications';
	    case 3:
	      return 'Description';
	    default:
	      break;
	  }
	};

/***/ }),
/* 541 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.api').factory('ReferralApi', ['api', function ReferralApi(api) {
	  var _this = this;
	
	  var referralApi = {
	    getReferralsListing: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                return _context.abrupt('return', api.get('listings/referral', { params: payload }));
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function getReferralsListing(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getReferralsListing;
	    }(),
	    getAllReferralsByReferralCode: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(referralCode) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                return _context2.abrupt('return', api.get('referrals/' + referralCode));
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      function getAllReferralsByReferralCode(_x2) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getAllReferralsByReferralCode;
	    }()
	  };
	  return referralApi;
	}]);

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('ReferralListingController', ['$log', '$location', '$scope', '$modal', '$window', 'logger', 'ReferralApi', '$sce', '$uibModal', 'userService', 'socket', '$rootScope', function controller($log, $location, $scope, $modal, $window, logger, ReferralApi, $sce, $uibModal, userService, socket, $rootScope) {
	    var _this = this;
	
	    var vm = this;
	    socket.on('REFERRAL_CREATE', function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(referralCode) {
	        var _ref2, updatedReferral, formatReferral, updatedReferralIndex, _ref3, newReferral, _formatReferral;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!vm.referralList.some(function (referral) {
	                  return referral.referralCode === referralCode;
	                })) {
	                  _context.next = 11;
	                  break;
	                }
	
	                _context.next = 3;
	                return ReferralApi.getReferralsListing({
	                  referralCode: referralCode
	                });
	
	              case 3:
	                _ref2 = _context.sent;
	                updatedReferral = _ref2.data;
	                formatReferral = setGridData(updatedReferral);
	                updatedReferralIndex = vm.referralList.findIndex(function (referral) {
	                  return referral.referralCode === referralCode;
	                });
	
	
	                vm.referralList[updatedReferralIndex] = formatReferral[0];
	                vm.gridOptions.api.updateRowData({
	                  update: formatReferral
	                });
	                _context.next = 18;
	                break;
	
	              case 11:
	                _context.next = 13;
	                return ReferralApi.getReferralsListing({
	                  referralCode: referralCode
	                });
	
	              case 13:
	                _ref3 = _context.sent;
	                newReferral = _ref3.data;
	                _formatReferral = setGridData(newReferral);
	
	
	                vm.referralList = [].concat(_toConsumableArray(vm.referralList), _toConsumableArray(_formatReferral));
	                vm.gridOptions.api.updateRowData({
	                  addIndex: 0,
	                  add: _formatReferral
	                });
	
	              case 18:
	
	                $scope.$apply();
	                updateGridGroupPipeline();
	
	              case 20:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }());
	    var dateFilterParameters = {
	      suppressAndOrCondition: true,
	      inRangeInclusive: true,
	      comparator: function comparator(filterLocalDateAtMidnight, cellValue) {
	        var dateAsString = moment(cellValue).format('DD/MM/YYYY');
	        var dateParts = dateAsString.split('/');
	        var cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
	
	        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
	          return 0;
	        }
	
	        if (cellDate < filterLocalDateAtMidnight) {
	          return -1;
	        }
	
	        if (cellDate > filterLocalDateAtMidnight) {
	          return 1;
	        }
	      }
	
	      // eslint-disable-next-line unicorn/consistent-function-scoping
	    };function renderDateTimeColumn(parameters) {
	      return parameters.value ? '<span>' + moment(parameters.value).format('DD-MMM-YYYY HH:mm') + '</span>' : ' ';
	    }
	
	    var columnDefs = [{
	      headerName: 'Referrer Details',
	      children: [{
	        headerName: 'User ID',
	        field: 'id',
	        columnGroupShow: undefined,
	        filter: 'agTextColumnFilter',
	        cellRenderer: 'agGroupCellRenderer',
	        sort: 'desc'
	      }, {
	        headerName: 'Full Name',
	        field: 'fullName',
	        columnGroupShow: undefined,
	        onCellClicked: viewProfile,
	        filter: 'agTextColumnFilter',
	        cellRenderer: function cellRenderer(parameter) {
	          if (!parameter.data.referralCode.startsWith('e')) return parameter.value ? '<span class="text-info pointer"/>' + parameter.value + '</span>' : '';
	          return parameter.value;
	        }
	      }, {
	        headerName: 'Email',
	        field: 'email',
	        columnGroupShow: undefined,
	        filter: 'agTextColumnFilter'
	      }, {
	        headerName: 'Referral Code',
	        field: 'referralCode',
	        filter: 'agTextColumnFilter',
	        columnGroupShow: undefined,
	        onCellClicked: showReferralCodeModal
	      }, {
	        headerName: 'Referrer Type',
	        field: 'userType',
	        rowGroupIndex: 0
	      }, {
	        headerName: 'IP Address',
	        field: 'ip_Address',
	        filter: 'agTextColumnFilter'
	      }, {
	        headerName: '#Logins',
	        field: 'loginCount'
	      }, {
	        headerName: 'Last Login',
	        field: 'lastLogin',
	        cellRenderer: renderDateTimeColumn,
	        filter: 'date',
	        filterParams: dateFilterParameters
	      }, {
	        headerName: 'Signup Date',
	        field: 'created',
	        cellRenderer: renderDateTimeColumn,
	        filter: 'date',
	        filterParams: dateFilterParameters
	      }]
	    }, {
	      headerName: 'Referrals',
	      children: [{
	        headerName: 'Total Referred Candidates',
	        field: 'totalReferredUsers',
	        onCellClicked: function onCellClicked(parameters) {
	          if (parameters.value) parameters.api.getDisplayedRowAtIndex(parameters.rowIndex).setExpanded(!parameters.api.getDisplayedRowAtIndex(parameters.rowIndex).expanded);
	        }
	      }, {
	        headerName: 'Approved Referred Candidates',
	        field: 'totalApprovedUsers'
	      }, {
	        headerName: 'Successful Referrals',
	        field: 'totalHiredUsers'
	      }, {
	        headerName: 'Last Start Date',
	        field: 'lastHiredUserDate',
	        cellRenderer: renderDateTimeColumn,
	        filter: 'date',
	        filterParams: dateFilterParameters
	      }]
	    }];
	    var masterDetailColumnDef = {
	      detailGridOptions: {
	        defaultColDef: {
	          sortable: true,
	          filter: true,
	          enablePivot: true,
	          enableRowGroup: true,
	          enableValue: true,
	          resizable: true,
	          menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab']
	        },
	        columnDefs: [{
	          headerName: 'Candidate ID',
	          field: 'id'
	        }, {
	          headerName: 'Candidate Name',
	          field: 'fullName',
	          onCellClicked: viewProfile,
	          filter: 'agTextColumnFilter',
	          cellRenderer: function cellRenderer(parameters) {
	            return parameters.value ? '<span class="text-info pointer"/>' + parameters.value + '</span>' : '';
	          }
	        }, {
	          headerName: 'Candidate Status',
	          field: 'approvalStatus'
	        }, {
	          headerName: 'Hired',
	          field: 'hiredStatus'
	        }, {
	          headerName: 'Last Start Date',
	          field: 'hiredDate',
	          cellRenderer: renderDateTimeColumn,
	          filter: 'date',
	          filterParams: dateFilterParameters
	        }],
	        onFirstDataRendered: function onFirstDataRendered(parameters) {
	          parameters.columnApi.autoSizeColumns();
	        }
	      },
	      getDetailRowData: function getDetailRowData(parameters) {
	        ReferralApi.getAllReferralsByReferralCode(parameters.data.referralCode.toString()).then(function (response) {
	          response.data.forEach(function (row, index) {
	            response.data[index].fullName = row.firstName.concat(' ', row.lastName);
	            response.data[index].hiredStatus = row.hiredDate ? 1 : 0;
	          });
	
	          parameters.successCallback(response.data);
	        });
	      }
	    };
	
	    var gridOptions = {
	      defaultColDef: {
	        sortable: true,
	        filter: true,
	        enablePivot: true,
	        enableRowGroup: true,
	
	        enableValue: true,
	        columnGroupShow: 'open',
	        resizable: true,
	        menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab']
	      },
	      masterDetail: true,
	      isRowMaster: function isRowMaster(dataItem) {
	        return Boolean(dataItem.totalReferredUsers);
	      },
	      detailRowHeight: 250,
	      detailCellRendererParams: masterDetailColumnDef,
	      onFilterChanged: onFilterChanged,
	      onModelUpdated: updateGridGroupPipeline,
	      onGridReady: function onGridReady() {
	        getReferralsListing();
	      },
	      floatingFilter: true,
	      suppressCsvExport: true,
	      groupDefaultExpanded: 1,
	      groupUseEntireRow: true,
	      columnDefs: columnDefs,
	      animateRows: true,
	      getRowNodeId: function getRowNodeId(data) {
	        return data.referralCode;
	      },
	      enableCellChangeFlash: true,
	      groupSelectsChildren: true,
	      rowData: vm.referralList,
	      rowSelection: 'multiple',
	      rowGroupPanelShow: 'always',
	      pivotPanelShow: 'always',
	      groupSelectsFiltered: true,
	
	      sideBar: {
	        toolPanels: ['columns', 'filters'],
	        defaultToolPanel: false
	      },
	      statusBar: {
	        statusPanels: [{ statusPanel: 'agTotalRowCountComponent', align: 'left' }, { statusPanel: 'agFilteredRowCountComponent', align: 'left' }, { statusPanel: 'agSelectedRowCountComponent' }, { statusPanel: 'agAggregationComponent' }]
	      },
	      overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your data is loading</span>',
	      suppressCopyRowsToClipboard: true,
	      enableRangeSelection: true,
	      enableCharts: true,
	      getContextMenuItems: getContextMenuItems
	    };
	
	    vm.gridOptions = gridOptions;
	    vm.gridName = 'referral';
	
	    var getReferralsListing = function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	        var referralList;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return userService.getUser();
	
	              case 2:
	                vm.user = _context2.sent;
	                _context2.next = 5;
	                return ReferralApi.getReferralsListing();
	
	              case 5:
	                referralList = _context2.sent;
	
	
	                if (referralList.status === 200) {
	                  vm.referralList = setGridData(referralList.data);
	
	                  vm.gridOptions = gridOptions;
	                  vm.gridOptions.api.setRowData(vm.referralList);
	                  if (defaultFilter) vm.gridOptions.api.setFilterModel(defaultFilter);
	                  $rootScope.$broadcast('listing-loaded');
	                }
	
	              case 7:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      return function getReferralsListing() {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    var modalInstance;
	    var defaultFilter = void 0;
	
	    vm.profileLink = function (referralCode) {
	      modalInstance.close();
	      $window.open('/admin/lawyer-profile?user=' + referralCode, '_blank');
	    };
	
	    function onFilterChanged() {
	      vm.filterCount = Object.keys(vm.gridOptions.api.getFilterModel()).length;
	      // eslint-disable-next-line angular/document-service
	      var filterTextBoxValue = document.querySelector('#filter-text-box').value;
	      if (filterTextBoxValue.length > 0) {
	        vm.filterCount += 1;
	      }
	
	      updatePipelineCountFromGrid();
	    }
	
	    // TODO: on grid functionality
	    function updatePipelineCountFromGrid() {
	      vm.gridOptions.api.forEachNode(function (node) {
	        if (node.key) {
	          vm.groupList.map(function (row) {
	            if (row.id === node.id) {
	              row.applicationsCount = node.allChildrenCount;
	              return row;
	            }
	
	            return row;
	          });
	        }
	      });
	      $scope.$applyAsync();
	    }
	
	    // TODO: on grid action items functionality
	    function updateGridGroupPipeline() {
	      vm.groupList = [];
	
	      vm.gridOptions.api.forEachNode(function (node) {
	        if (node.key) {
	          var hasChild = true;
	          if (_.isEmpty(node.childrenMapped) || 'undefined' in node.childrenMapped) hasChild = false;
	          vm.groupList.push({
	            name: node.key,
	            applicationsCount: node.allChildrenCount,
	            color: node.leafGroup ? '#' + Math.trunc(Math.random() * 0xffffff).toString(16) : lighten('#5e5e5e', (node.level + 1) * 10),
	            id: node.id,
	            intId: Number(node.id) * -1,
	            level: node.level,
	            parentID: node.parent.id,
	            hasChild: hasChild,
	            isHidden: node.level !== 0
	          });
	        }
	      });
	      $log.debug('vm.groupList', vm.groupList);
	      $scope.$applyAsync();
	    }
	
	    function showReferralCodeModal(parameters) {
	      vm.referralCodeToShow = ("https://lexstep.com") + '/sign-up/' + parameters.value;
	      modalInstance = $modal.open({
	        templateUrl: 'referral-link-modal.html',
	        controller: function controller(referralCodeToShow) {
	          var vm = this;
	          vm.referralCodeToShow = referralCodeToShow;
	          vm.copySuccess = function () {
	            logger.notify('success', 'Referral link copied to clipboard.');
	          };
	
	          vm.copyFail = function (error) {
	            logger.notify('error', error);
	          };
	        },
	        controllerAs: 'ctrl',
	        resolve: {
	          referralCodeToShow: function referralCodeToShow() {
	            return vm.referralCodeToShow;
	          }
	        }
	      });
	      modalInstance.result.then(function () {}, function () {});
	    }
	
	    function getContextMenuItems(parameters) {
	      var result = [{
	        name: 'Open profile in new tab ',
	        action: function action() {
	          if (!parameters.node.data.referralCode.startsWith('e')) {
	            if (parameters.node.data.lawyer_Status === 'NewUser') {
	              $window.open('/profile?user=' + parameters.node.data.referralCode, '_blank');
	            } else $window.open('/admin/lawyer-profile?user=' + parameters.node.data.referralCode, '_blank');
	          }
	        }
	      }, 'separator', {
	        name: 'Expand All Columns',
	        action: function action() {
	          var columnApi = gridOptions.columnApi.getColumnGroupState();
	          columnApi.forEach(function (item) {
	            gridOptions.columnApi.setColumnGroupOpened(item.groupId, true);
	          });
	        }
	      }, {
	        name: 'Collapse All Columns',
	        action: function action() {
	          var columnApi = gridOptions.columnApi.getColumnGroupState();
	          columnApi.forEach(function (item) {
	            gridOptions.columnApi.setColumnGroupOpened(item.groupId, false);
	          });
	        }
	      }, 'separator', 'copy', 'copyWithHeaders', 'separator', 'chartRange'];
	      vm.isExportAllowed = vm.user.roles.some(function (role) {
	        return role.id === 'admin' || role.id === 'ops';
	      });
	      if (vm.isExportAllowed) result.push('export');
	      return result;
	    }
	
	    function viewProfile(parameters) {
	      if (parameters.data.userType !== 'Non-member') {
	        if (parameters.node.data.approvalStatus === 'New User') {
	          $window.open('/profile?user=' + parameters.node.data.referralCode, '_blank');
	        } else if (parameters.node.data.approvalStatus === 'Approved') {
	          if (parameters.data.referralCode) vm.candidateProfile(parameters.data.referralCode);else vm.candidateProfile(parameters.data.id);
	        }
	      }
	    }
	
	    vm.candidateProfile = function (code) {
	      modalInstance = $uibModal.open({
	        templateUrl: 'candidateProfileModal.html',
	        windowClass: 'app-candidate-profile-modal-window',
	        controller: 'CandidateProfileModalController',
	        resolve: {
	          data: function data() {
	            return code;
	          }
	        }
	      });
	    };
	
	    if ($location.search().filterName && $location.search().filterValue) {
	      var columnList = [];
	      columnDefs.forEach(function (row) {
	        if (row.children) columnList.push(row.children);
	      });
	      var filterName = $location.search().filterName;
	      columnList = columnList.flat(Infinity);
	      var column = columnList.find(function (row) {
	        return row.field === filterName;
	      });
	      if (column.field) {
	        defaultFilter = JSON.parse(column.filter === 'agTextColumnFilter' ? '{"' + filterName + '":{"filterType":"text","type":"contains","filter":"' + $location.search().filterValue + '"}}' : '{"' + filterName + '":{"values":["' + $location.search().filterValue + '"],"filterType":"set"}}');
	      }
	    }
	
	    vm.helpTooltip = {
	      name: 'Help',
	      content: $sce.trustAsHtml(referrerHelpContent)
	    };
	  }]);
	})();
	
	var setGridData = function setGridData(allReferrersRecord) {
	  return allReferrersRecord.map(function (data) {
	    data.fullName = data.firstName.concat(' ', data.lastName);
	    data.totalReferredUsers = Number(data.totalReferredUsers);
	    data.totalApprovedUsers = Number(data.totalApprovedUsers);
	    data.totalHiredUsers = Number(data.hiredApprovedUsers.totalHiredUsers);
	    data.lastHiredUserDate = data.hiredApprovedUsers.lastHiredUserDate;
	    data.userType = data.referralCode.startsWith('e') ? 'Non-member' : 'Member';
	    return data;
	  }).sort(function (a, b) {
	    return a.userType > b.userType ? 1 : -1;
	  });
	};
	
	var addLight = function addLight(color, amount) {
	  var cc = Number.parseInt(color, 16) + amount;
	  var c = cc > 255 ? 255 : cc;
	  c = c.toString(16).length > 1 ? c.toString(16) : '0' + c.toString(16);
	  return c;
	};
	
	var lighten = function lighten(color, amount) {
	  color = color.includes('#') ? color.slice(1, color.length) : color;
	  // eslint-disable-next-line radix
	  amount = Number.parseInt(255 * amount / 100);
	  color = '#' + addLight(color.slice(0, 2), amount) + addLight(color.slice(2, 4), amount) + addLight(color.slice(4, 6), amount);
	  return color;
	};
	
	var referrerHelpContent = '\n<div>\n<p>Referrals shows referrer details of (1) non-members who have signed up for a unique referral link; and (2) LexStep members who have made one or more referrals. Click the arrow on the left of a referror\u2019s User ID to see details of whom they have referred.\n</p>\n<p>A \u201CReferral\u201D is when a LexStep member uses a referral code to sign up.\n</p>\n<p>A \u201CSuccessful Referral\u201D is when a referred LexStep member is hired.\n</p>\n<b>Filtering</b>\n<p>Filters can be applied by hovering over each column header and selecting the hamburger menu on the right. When a filter is applied to a column a purple filter icon appears in the header beside the column name.\n</p>\n<p>Filters can be applied both to the columns showing the master information as well as the columns showing detailed information when expanding a row.\n</p>\n<b>Views</b>\n<p>Personalise different list layouts by choosing the columns to display, adjusting their width and moving them to re-order to your preferences. You can save custom column layouts with filter criteria to easy access again later via the \u201CViews\u201D icon in the top right -- either as a Private \u201CSaved View\u201D or Shared with other team members.\n</p>\n<b>Clear</b>\n<p>When one or more filters are applied, a Clear filter icon will appear in the top right above the grid. Select to clear any applied filters and/or search and reset the grid data. The Clear filter icon also displays the number of filters currently active on the grid.\n</p>\n<b>Group</b>\n<p>Drag and drop columns to the grouping drop zone in the grid\u2019s top row to group rows by a particular column. You can Expand/Collapse All Rows from the Views icon in the top right to view positions by groups.\n</p>\n<b>Sorting</b>\n<p>You can change how the list is ordered by clicking the column headers to sort. To sort by multiple columns, hold down shift while clicking the column header.\n</p>\n</div> ';

/***/ }),
/* 543 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.api').factory('AdminProfileApi', ['api', function AdminProfileApi(api) {
	  var _this = this;
	
	  var adminProfileApi = {
	    updateAgentSignature: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id, payload) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                return _context.abrupt('return', api.post('user/' + id + '/signature', payload));
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function updateAgentSignature(_x, _x2) {
	        return _ref.apply(this, arguments);
	      }
	
	      return updateAgentSignature;
	    }(),
	    getAgentSignature: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                return _context2.abrupt('return', api.get('user/' + id + '/signature'));
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      function getAgentSignature(_x3) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getAgentSignature;
	    }()
	  };
	  return adminProfileApi;
	}]);

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('AdminProfileController', ['$location', '$scope', 'usSpinnerService', 'logger', 'userService', 'CandidateProfileApi', 'SharedApi', 'AdminProfileApi', function controller($location, $scope, usSpinnerService, logger, userService, CandidateProfileApi, SharedApi, AdminProfileApi) {
	    var _this = this;
	
	    var vm = this;
	
	    vm.uploadProfilePicture = function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
	        var formData, _ref2, profilePicture;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!(file.length > 0)) {
	                  _context.next = 12;
	                  break;
	                }
	
	                vm.startSpin('spinner-dp');
	                formData = new FormData();
	
	                formData.append('file', file[0]);
	                _context.next = 6;
	                return CandidateProfileApi.uploadProfilePhoto(vm.user.id, formData);
	
	              case 6:
	                _ref2 = _context.sent;
	                profilePicture = _ref2.data;
	
	                vm.user.profilePicture = profilePicture;
	                vm.user.logoSrc = ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/user/' + vm.user.id + '/photo/' + vm.user.profilePicture;
	                vm.stopSpin('spinner-dp');
	                $scope.$apply();
	
	              case 12:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    vm.deleteProfilePic = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              vm.startSpin('spinner-dp');
	
	              _context2.next = 3;
	              return CandidateProfileApi.deleteProfilePhoto(vm.user.id);
	
	            case 3:
	              vm.user.profilePicture = undefined;
	              vm.user.logoSrc = 'images/defaultPic.jpg';
	
	              vm.stopSpin('spinner-dp');
	              logger.notify('success', 'Successfully removed');
	              $scope.$apply();
	
	            case 8:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this);
	    }));
	
	    var errorHandler = function errorHandler(response) {
	      var USER_NOT_LOGGED_IN = 440;
	
	      if (response.status === USER_NOT_LOGGED_IN) $location.url('/signin');else logger.notify('error', 'update Failed!');
	    };
	
	    var resetEditObjectForForm = function resetEditObjectForForm() {
	      var user = vm.user;
	      angular.extend(vm.adminUser, {
	        firstName: user.firstName,
	        lastName: user.lastName,
	        email: user.email,
	        phone: user.phone
	      });
	    };
	
	    function createEditObject() {
	      vm.adminUser = {};
	      resetEditObjectForForm();
	      vm.resetSignature();
	    }
	
	    vm.startSpin = function (spinnerID) {
	      if (!vm.spinnerActive) {
	        usSpinnerService.spin(spinnerID);
	        vm.spinnerActive = true;
	      }
	    };
	
	    vm.stopSpin = function (spinnerID) {
	      if (vm.spinnerActive) {
	        usSpinnerService.stop(spinnerID);
	        vm.spinnerActive = false;
	      } else {
	        usSpinnerService.stop(spinnerID);
	      }
	    };
	
	    vm.updateInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	      var adminUser, request, updatedUser;
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              adminUser = vm.adminUser;
	              request = {
	                firstName: adminUser.firstName ? adminUser.firstName : '',
	                lastName: adminUser.lastName ? adminUser.lastName : '',
	                email: adminUser.email,
	                phone: adminUser.phone ? adminUser.phone : ''
	              };
	
	              if (!(request.firstName === '')) {
	                _context3.next = 6;
	                break;
	              }
	
	              logger.notify('error', 'First Name is Required');
	              _context3.next = 25;
	              break;
	
	            case 6:
	              if (!(request.lastName === '')) {
	                _context3.next = 10;
	                break;
	              }
	
	              logger.notify('error', 'Last Name is Required');
	              // eslint-disable-next-line no-negated-condition
	              _context3.next = 25;
	              break;
	
	            case 10:
	              if (request.email) {
	                _context3.next = 14;
	                break;
	              }
	
	              logger.notify('error', 'Email is Required');
	              _context3.next = 25;
	              break;
	
	            case 14:
	              _context3.prev = 14;
	              _context3.next = 17;
	              return CandidateProfileApi.updateUserData(vm.user.id, request);
	
	            case 17:
	              updatedUser = _context3.sent;
	
	
	              if (updatedUser && updatedUser.status === 200) {
	                vm.user = updatedUser.data;
	                vm.user.logoSrc = 'images/defaultPic.jpg';
	                if (vm.user.profilePicture) vm.user.logoSrc = ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/user/' + vm.user.id + '/photo/' + vm.user.profilePicture;
	                vm.toggleEditDetailsForm();
	                logger.notify('success', 'Successfully updated');
	              }
	              _context3.next = 24;
	              break;
	
	            case 21:
	              _context3.prev = 21;
	              _context3.t0 = _context3['catch'](14);
	
	              logger.notify('error', _context3.t0.data.message);
	
	            case 24:
	
	              $scope.$applyAsync();
	
	            case 25:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this, [[14, 21]]);
	    }));
	
	    vm.updateSignature = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
	      var adminUser, request, updatedSignature;
	      return regeneratorRuntime.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              adminUser = vm.adminUser;
	              request = {
	                signature: adminUser.signature
	                // eslint-disable-next-line no-negated-condition
	              };
	              _context4.next = 4;
	              return AdminProfileApi.updateAgentSignature(vm.user.id, request);
	
	            case 4:
	              updatedSignature = _context4.sent;
	
	
	              if (updatedSignature.status === 201) {
	                vm.user.signature = updatedSignature.data.signature;
	
	                vm.toggleEditDetailsForm();
	                logger.notify('success', 'Successfully updated');
	              } else {
	                errorHandler(updatedSignature);
	              }
	
	            case 6:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this);
	    }));
	
	    vm.resetSignature = function () {
	      angular.extend(vm.adminUser, { signature: vm.user.signature });
	    };
	
	    vm.toggleEditDetailsForm = function () {
	      vm.showEditForm = !vm.showEditForm;
	      resetEditObjectForForm();
	    };
	
	    vm.initializeAdminProfile = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	      var agent;
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              vm.startSpin('spinner-dp');
	
	              _context5.next = 3;
	              return userService.getUser();
	
	            case 3:
	              vm.user = _context5.sent;
	              _context5.next = 6;
	              return AdminProfileApi.getAgentSignature(vm.user.id);
	
	            case 6:
	              agent = _context5.sent;
	
	
	              vm.user.signature = agent ? agent.data.signature : '';
	              if (vm.user.profilePicture) vm.user.logoSrc = ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/user/' + vm.user.id + '/photo/' + vm.user.profilePicture;
	              createEditObject();
	
	              vm.stopSpin('spinner-dp');
	
	            case 11:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this);
	    }));
	
	    vm.initializeAdminProfile();
	  }]);
	})();

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable angular/window-service */
	/* eslint-disable camelcase */
	/* eslint-disable angular/no-run-logic */
	__webpack_require__(769);
	__webpack_require__(1243);
	
	__webpack_require__(1241);
	__webpack_require__(499);
	
	window._ = __webpack_require__(1242);
	window.moment = __webpack_require__(2);
	window.rangy = __webpack_require__(167);
	window.rangy.saveSelection = __webpack_require__(429);
	__webpack_require__(740);
	__webpack_require__(755);
	
	// File upload on the admin-panel.html
	__webpack_require__(617);
	__webpack_require__(618);
	
	__webpack_require__(977);
	__webpack_require__(495);
	// Require('../olark-chat-box.js')
	/*****************************************************/
	/*          start:JQUERY-QUERY-BUILDER               */
	/*****************************************************/
	__webpack_require__(978);
	__webpack_require__(980);
	__webpack_require__(979);
	__webpack_require__(473);
	__webpack_require__(1237);
	__webpack_require__(772);
	__webpack_require__(985);
	window.SQLParser = __webpack_require__(1239);
	/*****************************************************/
	/*             end:JQUERY-QUERY-BUILDER              */
	/*****************************************************/
	
	__webpack_require__(976);
	
	__webpack_require__(981);
	__webpack_require__(982);
	__webpack_require__(1247);
	__webpack_require__(983);
	
	// Require('../styles/main.css');
	
	__webpack_require__(1240);
	
	__webpack_require__(767);
	__webpack_require__(768);
	__webpack_require__(480);
	__webpack_require__(475);
	__webpack_require__(478);
	__webpack_require__(477);
	__webpack_require__(479);
	window.toastr = __webpack_require__(493);
	__webpack_require__(483);
	__webpack_require__(491);
	__webpack_require__(485);
	__webpack_require__(487);
	__webpack_require__(486);
	__webpack_require__(488);
	__webpack_require__(484);
	__webpack_require__(489);
	__webpack_require__(490);
	__webpack_require__(496);
	__webpack_require__(476);
	__webpack_require__(975);
	__webpack_require__(498);
	__webpack_require__(482);
	__webpack_require__(481);
	__webpack_require__(492);
	
	__webpack_require__(568);
	__webpack_require__(569);
	__webpack_require__(570);
	__webpack_require__(573);
	__webpack_require__(577);
	__webpack_require__(578);
	
	/** *********  Start: APIs MODULE  **************/
	__webpack_require__(620);
	__webpack_require__(181);
	__webpack_require__(737);
	__webpack_require__(619);
	__webpack_require__(621);
	/** *********   End: APIs MODULE   **************/
	
	/** *********  Start: Controllers MODULE  **************/
	__webpack_require__(627);
	__webpack_require__(625);
	__webpack_require__(628);
	__webpack_require__(626);
	/** *********   End: Controllers MODULE   **************/
	
	/*****************************************************/
	/*                   DIRECTIVES                      */
	/*****************************************************/
	__webpack_require__(680);
	// Header
	__webpack_require__(688);
	__webpack_require__(687);
	// Footer
	__webpack_require__(684);
	__webpack_require__(683);
	// Angular-QueryBuilder
	// require('./shared/api/query-builder')
	// require('./shared/directives/angular-querybuilder/directive')
	// require('./shared/directives/angular-querybuilder/styles/angular-query-builder.css')
	// Column Selector
	__webpack_require__(666);
	__webpack_require__(667);
	// Lawyer Preferences
	__webpack_require__(691);
	
	// Grid Group Pipeline
	__webpack_require__(686);
	// Lawyer Salary
	__webpack_require__(693);
	// Actions PoPup
	__webpack_require__(630);
	
	// General
	__webpack_require__(711);
	__webpack_require__(712);
	__webpack_require__(715);
	__webpack_require__(714);
	__webpack_require__(703);
	__webpack_require__(702);
	__webpack_require__(713);
	__webpack_require__(704);
	__webpack_require__(706);
	__webpack_require__(661);
	__webpack_require__(707);
	
	/*****************************************************/
	/*                    FILTERS                        */
	/*****************************************************/
	__webpack_require__(730);
	__webpack_require__(718);
	__webpack_require__(717);
	__webpack_require__(728);
	__webpack_require__(735);
	__webpack_require__(726);
	__webpack_require__(733);
	__webpack_require__(727);
	__webpack_require__(720);
	__webpack_require__(191);
	__webpack_require__(191);
	__webpack_require__(723);
	__webpack_require__(719);
	__webpack_require__(732);
	__webpack_require__(734);
	__webpack_require__(731);
	__webpack_require__(724);
	__webpack_require__(721);
	__webpack_require__(729);
	__webpack_require__(722);
	__webpack_require__(725);
	/*****************************************************/
	/*                     SERVICES                      */
	/*****************************************************/
	__webpack_require__(748);
	__webpack_require__(746);
	__webpack_require__(749);
	__webpack_require__(745);
	__webpack_require__(747);
	__webpack_require__(753);
	__webpack_require__(752);
	__webpack_require__(741);
	__webpack_require__(750);
	__webpack_require__(742);
	__webpack_require__(751);
	__webpack_require__(743);
	/*****************************************************/
	/*                    CONSTANTS                      */
	/*****************************************************/
	__webpack_require__(624);
	__webpack_require__(623);
	
	__webpack_require__(614);
	__webpack_require__(616);
	__webpack_require__(756);
	__webpack_require__(576);
	__webpack_require__(615);
	
	__webpack_require__(760);
	__webpack_require__(759);
	__webpack_require__(580);
	__webpack_require__(579);
	
	__webpack_require__(598);
	__webpack_require__(597);
	__webpack_require__(596);
	
	/** ********* Start: Employment History DIRECTIVE **************/
	__webpack_require__(555);
	__webpack_require__(553);
	__webpack_require__(556);
	__webpack_require__(554);
	/** ********* End: Employment History DIRECTIVE **************/
	
	__webpack_require__(622);
	
	__webpack_require__(758);
	__webpack_require__(566);
	__webpack_require__(612);
	__webpack_require__(613);
	__webpack_require__(765);
	__webpack_require__(716);
	__webpack_require__(547);
	__webpack_require__(546);
	__webpack_require__(523);
	__webpack_require__(582);
	__webpack_require__(585);
	__webpack_require__(738);
	__webpack_require__(593);
	__webpack_require__(594);
	__webpack_require__(595);
	
	/** ********* WelcomePopup**************/
	
	__webpack_require__(605);
	__webpack_require__(168);
	
	__webpack_require__(701);
	
	__webpack_require__(587);
	__webpack_require__(586);
	__webpack_require__(699);
	
	__webpack_require__(603);
	__webpack_require__(602);
	
	__webpack_require__(600);
	__webpack_require__(599);
	
	__webpack_require__(581);
	
	__webpack_require__(574);
	__webpack_require__(575);
	
	__webpack_require__(590);
	__webpack_require__(591);
	__webpack_require__(592);
	
	__webpack_require__(601);
	
	/** *********NOTES MODULE**************/
	__webpack_require__(606);
	__webpack_require__(551);
	
	/** *********CANDIDATE PROFILE RECOMMENDATIONS MODULE**************/
	
	__webpack_require__(611);
	__webpack_require__(761);
	__webpack_require__(762);
	
	__webpack_require__(763);
	__webpack_require__(764);
	
	__webpack_require__(739);
	
	__webpack_require__(589);
	__webpack_require__(588);
	__webpack_require__(757);
	__webpack_require__(181);
	__webpack_require__(526);
	__webpack_require__(527);
	
	__webpack_require__(535);
	__webpack_require__(533);
	__webpack_require__(534);
	
	__webpack_require__(705);
	__webpack_require__(188);
	
	__webpack_require__(673);
	__webpack_require__(672);
	__webpack_require__(184);
	
	__webpack_require__(679);
	__webpack_require__(186);
	
	__webpack_require__(710);
	__webpack_require__(190);
	__webpack_require__(709);
	
	__webpack_require__(708);
	__webpack_require__(189);
	
	__webpack_require__(187);
	__webpack_require__(697);
	__webpack_require__(698);
	
	__webpack_require__(696);
	
	__webpack_require__(544);
	__webpack_require__(543);
	
	__webpack_require__(529);
	__webpack_require__(528);
	__webpack_require__(530);
	
	__webpack_require__(542);
	__webpack_require__(541);
	
	__webpack_require__(674);
	__webpack_require__(185);
	__webpack_require__(676);
	__webpack_require__(675);
	
	__webpack_require__(665);
	
	__webpack_require__(637);
	__webpack_require__(639);
	__webpack_require__(641);
	__webpack_require__(636);
	__webpack_require__(632);
	__webpack_require__(634);
	
	__webpack_require__(532);
	__webpack_require__(531);
	__webpack_require__(670);
	__webpack_require__(183);
	__webpack_require__(671);
	__webpack_require__(678);
	
	__webpack_require__(660);
	__webpack_require__(681);
	
	__webpack_require__(572);
	__webpack_require__(571);
	
	__webpack_require__(524);
	__webpack_require__(525);
	
	__webpack_require__(652);
	
	__webpack_require__(654);
	__webpack_require__(656);
	__webpack_require__(658);
	
	__webpack_require__(644);
	__webpack_require__(642);
	__webpack_require__(651);
	__webpack_require__(646);
	
	__webpack_require__(522);
	__webpack_require__(567);
	
	__webpack_require__(540);
	__webpack_require__(538);
	__webpack_require__(539);
	__webpack_require__(537);
	
	__webpack_require__(584);
	__webpack_require__(583);
	
	__webpack_require__(669);
	__webpack_require__(649);
	__webpack_require__(663);
	
	__webpack_require__(754);
	
	var ACCESS_DENIED = 406;
	var routesList = __webpack_require__(987);
	
	var _require = __webpack_require__(230),
	    version = _require.version;
	
	// Const environment = process.env.NODE_ENV
	
	// If (environment === 'production') {
	//   const SENTRY_DSN =
	//     process.env.SENTRY_DSN ||
	//     'https://e3109624ce5247099bf954b89cc8996a@o1414621.ingest.sentry.io/6754944'
	//
	//   // TODO: add datadog APM
	// }
	
	angular.module('app', ['ngRoute', 'ngAnimate', 'ui.bootstrap', 'textAngular', 'ngTagsInput', 'app.constants', 'app.lexstepHeader', 'app.notes', 'app.candidateProfile', 'app.LawyerProfile', 'app.services', 'app.controllers', 'app.directives', 'app.directives.lexstepFooter', 'app.filters', 'app.form.validation', 'app.ui.form.ctrls', 'app.ui.form.directives', 'app.jobApplicationHistory', 'app.editEmail', 'ngCkeditor', 'app.emailBodyView', 'isteven-multi-select', 'app.api', 'app.grid', 'dndLists', 'colorpicker.module']).config(['$routeProvider', '$locationProvider', '$logProvider', '$httpProvider', function config($routeProvider, $locationProvider, $logProvider, $httpProvider) {
	  angular.lowercase = angular.$$lowercase;
	  $httpProvider.interceptors.push(['$log', function () {
	    return {
	      request: function request(config) {
	        return config;
	      }
	    };
	  }]);
	  $logProvider.debugEnabled(false);
	
	  // Single resolve to verify lawyer status
	  var staticRequire = __webpack_require__(1246);
	
	  routesList.forEach(function (route) {
	    var providedRoute = Object.assign({
	      title: route.title ? route.title : 'LexStep - Find Jobs At The Best Law Firms',
	      resolve: {
	        checkPageAccess: function checkPageAccess(userService) {
	          return userService.authenticateRoute(route);
	        }
	      }
	    }, route.redirectTo && { redirectTo: route.redirectTo }, route.template && { template: staticRequire(route.template) }, route.templateUrl && { templateUrl: route.templateUrl }, route.css && { css: route.css });
	    $routeProvider.when(route.path, providedRoute);
	  });
	
	  $routeProvider.otherwise({
	    redirectTo: '/404'
	  });
	  return $locationProvider.html5Mode(true);
	}]).run(['$rootScope', '$log', '$window', '$location', function run($rootScope, $log, $window, $location) {
	  if (true) {
	    $window.ga('create', 'UA-63533389-1', 'auto');
	  } else {
	    $window.ga('create', 'UA-123651854-1', 'auto');
	  }
	
	  $log.info('LexStep/angularjs v' + version + ' initialized.');
	
	  $rootScope.envUrl = ("https://lexstep.com");
	  $rootScope.serverEnvUrl = ("https://api.lexstep.com");
	  $rootScope.$on('$routeChangeStart', function on(event, next) {
	    // Track pageview on state change
	    $window.ga('send', 'pageview', $location.path());
	    return $log.info('starting a route change to \'' + next.$$route.originalPath + '\'');
	  });
	  $rootScope.$on('$routeChangeError', function on(event, current, previous, rejection) {
	    if (rejection && rejection.reason === ACCESS_DENIED && rejection.redirectTo) {
	      $location.path(rejection.redirectTo);
	    }
	  });
	  return $rootScope.$on('$routeChangeSuccess', function on(event, current) {
	    if ($window.fbq) $window.fbq('track', 'ViewContent');
	
	    var path = $location.path();
	    var queryString = '';
	
	    if (path.includes('?')) {
	      // eslint-disable-next-line unicorn/prefer-string-slice
	      queryString = path.substring(path.indexOf('?'), path.length);
	    }
	
	    if (!path.startsWith('/admin')) {
	      analytics.page({
	        path: path,
	        search: queryString,
	        title: current.$$route.title,
	        url: $location.absUrl()
	      });
	    }
	
	    $rootScope.title = current.$$route.title;
	
	    return $rootScope.title;
	  });
	}]);

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.api').factory('CandidateApplicationApi', ['api', function CandidateApplicationApi(api) {
	  var _this = this;
	
	  var candidateApplicationApi = {
	    getCandidateApplications: function getCandidateApplications(payload) {
	      return api.get('applications', { params: payload });
	    },
	    getApplicationStages: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                return _context.abrupt('return', api.get('applications/stages'));
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function getApplicationStages() {
	        return _ref.apply(this, arguments);
	      }
	
	      return getApplicationStages;
	    }(),
	    getApplicationsCount: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
	        var result;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return api.get('applications/candidate/' + id + '/count');
	
	              case 2:
	                result = _context2.sent;
	                return _context2.abrupt('return', Number.parseInt(result.data, 10));
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      function getApplicationsCount(_x) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getApplicationsCount;
	    }()
	  };
	  return candidateApplicationApi;
	}]);

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('CandidateApplicationController', ['sharedProperties', '$location', 'usSpinnerService', 'SharedApi', 'CandidateApplicationApi', '$scope', 'userService', 'PositionApi', function controller(sharedProperties, $location, usSpinnerService, SharedApi, CandidateApplicationApi, $scope, userService, PositionApi) {
	    var _this = this;
	
	    var vm = this;
	
	    vm.spinnerActive = false;
	    vm.startSpin = function () {
	      if (!vm.spinnerActive) {
	        usSpinnerService.spin('spinner-2');
	        vm.spinnerActive = true;
	      }
	    };
	
	    vm.stopSpin = function () {
	      if (vm.spinnerActive) {
	        usSpinnerService.stop('spinner-2');
	        vm.spinnerActive = false;
	      }
	    };
	
	    vm.paginationOptions = {
	      limitOptions: [10, 20, 50],
	      selectedLimit: 10
	    };
	
	    vm.pagination = {
	      currentPage: 0,
	      totalItems: 0
	    };
	
	    vm.showSuccessMsg = false;
	    vm.showErrorMsg = false;
	    vm.alertMsg = '';
	    vm.showNoJobs = false;
	    vm.showInfo = false;
	    vm.firms = [];
	    vm.lawyerJobs = [];
	    vm.picSrc = 'images/firm-logo-default.jpg';
	    vm.showClass = '';
	
	    vm.applicationsPageChange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return vm.getCandidateApplication(vm.userId);
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    vm.getCandidateApplication = function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(userId) {
	        var getCandidateApplicationDto, candidateApplications, totalApplicationsCount, withoutOffPlatformSpeculativeConnect;
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                vm.startSpin();
	                getCandidateApplicationDto = {
	                  user: [userId],
	                  include: ['position', 'employer', 'stage'],
	                  limit: vm.paginationOptions.selectedLimit,
	                  page: vm.pagination.currentPage
	                };
	                _context3.next = 4;
	                return CandidateApplicationApi.getCandidateApplications(getCandidateApplicationDto);
	
	              case 4:
	                candidateApplications = _context3.sent;
	                _context3.next = 7;
	                return CandidateApplicationApi.getApplicationsCount(userId);
	
	              case 7:
	                totalApplicationsCount = _context3.sent;
	
	                vm.pagination.totalItems = totalApplicationsCount;
	
	                if (candidateApplications.status === 200) {
	                  withoutOffPlatformSpeculativeConnect = candidateApplications.data.filter(Boolean).filter(function (application) {
	                    // Filter out invisible employers and positions
	                    return application.positionVisible && application.employerVisible;
	                  }).filter(function (application) {
	                    // Filter out off-platform spec/connect
	                    var isSpecConnect = ['Speculative', 'Connect'].includes(application.positionType);
	                    var isOffPlatform = application.isOffPlatform;
	                    var result = !(isSpecConnect && isOffPlatform);
	                    console.debug('getApplications filter:', application, 'isSpecConnect: ' + isSpecConnect, 'isOffPlatform: ' + isOffPlatform, 'result: ' + result);
	                    return result;
	                  });
	
	
	                  vm.candidatePositions = {
	                    candidate: {
	                      positions: withoutOffPlatformSpeculativeConnect
	                    }
	                  };
	
	                  if (vm.candidatePositions.candidate.positions.length <= 0) {
	                    vm.showNoJobs = true;
	                    vm.mainAlert = 'You will be able to track your applications on this page.';
	                  } else {
	                    vm.showInfo = true;
	                  }
	
	                  vm.candidatePositions.candidate.positions.forEach(function () {
	                    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(position) {
	                      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                        while (1) {
	                          switch (_context2.prev = _context2.next) {
	                            case 0:
	                              position.employerLogoSrc = position.employerLogo ? ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/employers/' + position.employerId + '/logo/' + position.employerLogo : vm.picSrc;
	                              position.liveStatus = 'Live Jobs';
	                              position.positionDescription = 'Loading...';
	                              position.loaded = false;
	                              position.locations = position.positionLocations.length > 0 ? vm.locationsList.filter(function (_ref4) {
	                                var id = _ref4.id;
	                                return position.positionLocations.find(function (location) {
	                                  return location === id;
	                                });
	                              }).map(function (location) {
	                                return {
	                                  name: location.name,
	                                  parent: location.parent,
	                                  color: location.country.region.color
	                                };
	                              }) : [];
	
	                            case 5:
	                            case 'end':
	                              return _context2.stop();
	                          }
	                        }
	                      }, _callee2, _this);
	                    }));
	
	                    return function (_x2) {
	                      return _ref3.apply(this, arguments);
	                    };
	                  }());
	
	                  $scope.$applyAsync();
	                }
	
	                vm.stopSpin();
	
	                if (candidateApplications.status === 440) {
	                  $location.url('/signin');
	                }
	
	              case 12:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    vm.showJobDetail = function () {
	      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(job) {
	        var _ref6, data;
	
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                if (!job.expanded) {
	                  _context4.next = 4;
	                  break;
	                }
	
	                job.expanded = false;
	                _context4.next = 14;
	                break;
	
	              case 4:
	                job.expanded = true;
	                job.isExpanded = false;
	
	                if (job.loaded) {
	                  _context4.next = 13;
	                  break;
	                }
	
	                _context4.next = 9;
	                return PositionApi.getPositionById(job.positionId);
	
	              case 9:
	                _ref6 = _context4.sent;
	                data = _ref6.data;
	
	
	                job.positionDescription = data.description;
	                job.loaded = true;
	
	              case 13:
	
	                // eslint-disable-next-line angular/controller-as
	                $scope.$digest();
	
	              case 14:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this);
	      }));
	
	      return function (_x3) {
	        return _ref5.apply(this, arguments);
	      };
	    }();
	
	    vm.initializeCandidateApplication = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	      var user, _ref8, locationsList;
	
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              _context5.next = 2;
	              return userService.getUser();
	
	            case 2:
	              user = _context5.sent;
	              _context5.next = 5;
	              return SharedApi.getAllLocations({
	                supported: true,
	                regions: true
	              });
	
	            case 5:
	              _ref8 = _context5.sent;
	              locationsList = _ref8.data;
	
	              vm.locationsList = locationsList;
	              vm.userId = user.id;
	
	              _context5.next = 11;
	              return vm.getCandidateApplication(user.id);
	
	            case 11:
	
	              vm.contact = {
	                email: user.agent && user.agent.email ? user.agent.email : 'jobs@lexstep.com',
	                phone: user.agent && user.agent.phone ? user.agent.phone : '+442039977000'
	              };
	
	            case 12:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this);
	    }));
	
	    vm.initializeCandidateApplication();
	  }]);
	})();

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function generateDto(id, limit, page, offPlatform) {
	  var isOffPlatform = offPlatform !== null && offPlatform !== undefined ? offPlatform : undefined;
	  return {
	    user: [id],
	    include: ['position', 'employer', 'stage'],
	    limit: limit,
	    page: page,
	    isOffPlatform: isOffPlatform
	  };
	}
	
	function ApplicationsController($scope, CandidateApplicationApi, PositionApi) {
	  var _this = this;
	
	  $scope.paginationOptions = {
	    limitOptions: [10, 20, 50],
	    selectedLimit: 10
	  };
	
	  $scope.pagination = {
	    currentPage: 0,
	    totalItems: 0
	  };
	
	  $scope.applicationsPageChange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            $scope.getApplications();
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, _this);
	  }));
	
	  $scope.getApplications = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	    var getCandidateApplicationDto, _ref3, applicationStages, candidateApplications, candidateApplicationsCount;
	
	    return regeneratorRuntime.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            getCandidateApplicationDto = generateDto($scope.candidate.id, $scope.paginationOptions.selectedLimit, $scope.pagination.currentPage);
	            _context2.next = 3;
	            return CandidateApplicationApi.getApplicationStages();
	
	          case 3:
	            _ref3 = _context2.sent;
	            applicationStages = _ref3.data;
	
	            $scope.applicationStages = applicationStages;
	            _context2.next = 8;
	            return CandidateApplicationApi.getCandidateApplications(getCandidateApplicationDto);
	
	          case 8:
	            candidateApplications = _context2.sent;
	            _context2.next = 11;
	            return CandidateApplicationApi.getApplicationsCount($scope.candidate.id);
	
	          case 11:
	            candidateApplicationsCount = _context2.sent;
	
	
	            if (candidateApplications.status === 200) {
	              $scope.applications = candidateApplications.data;
	              if ($scope.applications.length <= 0) {
	                $scope.showNoJobs = true;
	                $scope.mainAlert = 'You will be able to track your applications on this page.';
	              } else {
	                $scope.showInfo = true;
	                $scope.totalApplications = candidateApplicationsCount;
	                $scope.pagination.totalItems = $scope.totalApplications;
	              }
	
	              $scope.applications = formatApplications($scope.applications);
	              $scope.$applyAsync();
	            }
	
	          case 13:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, _this);
	  }));
	
	  $scope.expandApplication = function (application) {
	    application.expanded = !application.expanded;
	    $scope.getApplicationPositionDetails(application);
	  };
	
	  var formatApplications = function formatApplications(applications) {
	    $scope.count = {
	      regularCustom: 0,
	      specConnect: 0
	    };
	    console.debug('formatApplications: initial state', applications);
	    var formatted = applications.map(function (application) {
	      if (application.employerLogo) application.employerPicture = ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/employers/' + application.employerId + '/logo/' + application.employerLogo;else application.employerPicture = 'images/firm-logo-default.jpg';
	      if (application.positionType === 'Regular' || application.positionType === 'Custom') $scope.count.regularCustom++;else $scope.count.specConnect++;
	      application.substage = $scope.applicationStages.find(function (stage) {
	        return stage.name === application.applicationStageName;
	      });
	      console.debug('substage:', application.substage);
	      application.stage = application.substage && $scope.applicationStages.find(function (stage) {
	        return stage.id === application.substage.parentId;
	      });
	
	      console.debug('stage:', application.stage);
	      if (application.stage.name === 'HIRED') application.liveStatus = 'Archived';else application.liveStatus = 'Live Jobs';
	      application.locations = application.positionLocations.map(function (location) {
	        return $scope.locations.find(function (loc) {
	          return location === loc.id;
	        });
	      });
	      application.legalPracticeAreas = application.positionPractices.map(function (practice) {
	        return $scope.legalPracticeAreas.find(function (legalPractice) {
	          return practice.id === legalPractice.id;
	        });
	      });
	      application.contract = $scope.contracts.find(function (contract) {
	        return contract.id === application.contractType;
	      });
	      application.occupation = $scope.occupations.find(function (occupation) {
	        return occupation.id === application.occupation;
	      });
	      application.positionDescription = 'Loading...';
	      return application;
	    });
	
	    console.debug('formatApplications::formatted:', formatted);
	    return formatted;
	  };
	
	  $scope.getApplicationPositionDetails = function () {
	    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(application) {
	      var id, positionId, _ref5, data, description, index;
	
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              id = application.id;
	              positionId = application.positionId;
	              _context3.next = 4;
	              return PositionApi.getPositionById(positionId);
	
	            case 4:
	              _ref5 = _context3.sent;
	              data = _ref5.data;
	              description = data.description;
	              index = $scope.applications.findIndex(function (app) {
	                return app.id === id;
	              });
	
	              $scope.applications[index].positionDescription = description;
	
	              $scope.$applyAsync();
	
	            case 10:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this);
	    }));
	
	    return function (_x) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	
	  $scope.fetchApplicationActiveTab = function (positionId, stageName, stageId, status) {
	    var color = '#ffef00';
	    if (stageName === 'HIRED' || status === 'Accepted') color = '#008000';else if (status === 'Rejected by LexStep') color = '#ffa500';else if (status === 'Employer Declined' || status === 'Candidate Withdrew') color = '#ff0000';
	    var test = angular.element('#' + positionId + stageId);
	    test.css('background', color);
	    if (test.length > 0) {
	      test[0].children[0].style.borderColor = color + ' ' + color + ' transparent transparent';
	      test[0].children[0].style.boxShadow = '1.4px -1.4px 0px 0px ' + color;
	    }
	  };
	
	  $scope.getApplications();
	}
	
	ApplicationsController.$inject = ['$scope', 'CandidateApplicationApi', 'PositionApi'];
	
	exports.ApplicationsController = ApplicationsController;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _applicationsCtrl = __webpack_require__(548);
	
	var adminApplicationsDirective = function adminApplicationsDirective() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      count: '=',
	      candidate: '=',
	      legalPracticeAreas: '=',
	      locations: '=',
	      contracts: '=',
	      occupations: '=',
	      employerTypes: '='
	    },
	    controller: _applicationsCtrl.ApplicationsController,
	    template: __webpack_require__(431)
	  };
	};
	
	angular.module('app.directives').directive('adminApplicationsDirective', adminApplicationsDirective);

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _candidateProfile = __webpack_require__(179);
	
	var candidateProfile = function candidateProfile() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      profileUser: '='
	    },
	    controller: _candidateProfile.CandidateProfileDirectiveController,
	    template: __webpack_require__(432)
	  };
	};
	
	angular.module('app.candidateProfile').directive('candidateProfile', candidateProfile);

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('app.candidateProfile', ['pascalprecht.translate', 'angularFileUpload', 'angular.filter', 'ngSlider', 'ngCookies', 'ngAnimate', 'ngSanitize', 'angularSpinner', 'angular-clipboard', 'ui.nested.combobox']);
	
	__webpack_require__(560);
	__webpack_require__(562);
	__webpack_require__(558);
	__webpack_require__(565);
	__webpack_require__(549);
	__webpack_require__(550);
	__webpack_require__(179);

/***/ }),
/* 552 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.api').factory('EmploymentHistoryApi', ['api', function EmploymentHistoryApi(api) {
	  var employmentHistoryApi = {
	    editExperience: function editExperience(id, experienceId, payload) {
	      return api.put('users/' + id + '/experience/' + experienceId, payload);
	    },
	    addExperience: function addExperience(id, payload) {
	      return api.post('users/' + id + '/experience', payload);
	    },
	    deleteExperience: function deleteExperience(id, experienceId) {
	      return api.delete('users/' + id + '/experience/' + experienceId);
	    }
	  };
	  return employmentHistoryApi;
	}]);

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _segment = __webpack_require__(21);
	
	var _loadingOverlay = __webpack_require__(20);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.LawyerProfile').directive('employmentHistory', employmentHistory);
	
	function employmentHistory() {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      candidate: '=',
	      lawyerId: '=',
	      lawyerApproved: '=',
	      currentEmployer: '=',
	      locations: '=',
	      contracts: '=',
	      occupations: '=',
	      practices: '=',
	      updateEmploymentInfo: '&'
	    },
	    template: __webpack_require__(434),
	    controller: employmentHistoryCtrl,
	    link: employmentHistoryLink
	  };
	}
	
	__webpack_require__(552);
	
	function employmentHistoryLink(scope) {
	  scope.showAddEmploymentHistoryForm = function () {
	    scope.addEmpHistory = true;
	    if (scope.candidate && scope.candidate.experiences && scope.candidate.experiences.length > 0) {
	      scope.candidate.experiences.forEach(function (history) {
	        history.editEmpHistory = false;
	      });
	    }
	
	    scope.resetEmployment();
	  };
	
	  scope.hideAddEmploymentHistoryForm = function () {
	    scope.addEmpHistory = false;
	  };
	
	  scope.showEditEmploymentHistoryForm = function (employment) {
	    scope.employment.refContractContractID = scope.employment.refContractContractID ? scope.employment.refContractContractID : 1;
	    scope.employment.refRoleRoleID = scope.employment.refRoleRoleID ? scope.employment.refRoleRoleID : 1;
	    scope.candidate.experiences.forEach(function (history) {
	      history.editEmpHistory = false;
	    });
	
	    scope.hideAddEmploymentHistoryForm();
	    employment.editEmpHistory = true;
	  };
	
	  scope.addEmploymentRecord = function (employment) {
	    if (scope.candidate.experiences.length > 0) {
	      scope.candidate.experiences.push(employment);
	    } else {
	      scope.candidate.experiences = [employment];
	    }
	  };
	
	  scope.removeEmploymentRecord = function (workIndex) {
	    scope.candidate.experiences.splice(workIndex, 1);
	  };
	
	  scope.editEmpHistory = function (employment, editIndex) {
	    scope.employment = angular.copy(employment);
	    scope.editIndex = editIndex;
	    scope.employment.isLastJob = !employment.end;
	
	    scope.showEditEmploymentHistoryForm(employment);
	  };
	
	  scope.updateEditedEmploymentRecord = function (employment) {
	    scope.candidate.experiences[scope.editIndex] = employment;
	    scope.editIndex = -1;
	  };
	
	  scope.cancelAddEditEmpHistory = function () {
	    scope.hideAddEmploymentHistoryForm();
	    scope.resetEmployment();
	  };
	
	  scope.cancelEditEmpHistory = function (employment) {
	    employment.editEmpHistory = false;
	    scope.resetEmployment();
	  };
	
	  scope.trackExperience = function (employment, eventName) {
	    console.debug('trackExperience', employment, eventName);
	    var empLocations = [employment.location.name];
	    var empPracticeAreas = [];
	
	    employment.specialties.forEach(function (pa) {
	      empPracticeAreas.push(pa.name);
	    });
	
	    empLocations = empLocations.join();
	    empPracticeAreas = empPracticeAreas.join();
	
	    var trackExpObject = {
	      employerName: employment.employer.name,
	      jobTitle: employment.jobTitle,
	      from: employment.start,
	      to: employment.end,
	      isLastJob: employment.isLastJob,
	      contract: employment.contractType.name,
	      role: employment.occupation.name,
	      location: empLocations,
	      practiceAreas: empPracticeAreas,
	      action: eventName
	    };
	
	    (0, _segment.profileExperienceAdd)(trackExpObject);
	
	    try {
	      if (employment.isLastJob) {
	        analytics.identify({
	          currentEmployerName: employment.employer.name,
	          currentEmployerId: employment.employer.id
	        });
	      }
	    } catch (error) {
	      console.error('Identify from experience', error);
	    }
	  };
	
	  scope.resetEmployment = function () {
	    scope.employment = {
	      employer: {
	        name: ''
	      },
	      jobTitle: '',
	      start: '',
	      end: '',
	      isLastJob: false,
	      contractTypeId: 1,
	      occupationId: 1,
	      comments: '',
	      location: undefined,
	      specialties: []
	    };
	  };
	}
	
	function employmentHistoryCtrl($scope, $modal, logger, sharedProperties, CandidateProfileApi, EmploymentHistoryApi) {
	  var _this = this;
	
	  $scope.resetEmployment = function () {
	    $scope.employment = {
	      employer: {
	        name: ''
	      },
	      jobTitle: '',
	      start: '',
	      end: '',
	      isLastJob: false,
	      contractTypeId: 1,
	      occupationId: 1,
	      comments: '',
	      location: undefined,
	      specialties: []
	    };
	  };
	
	  var initializeEmploymentHistory = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var _ref2, employersList, experiences, experienceList;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              $scope.resetEmployment();
	              _context.next = 3;
	              return CandidateProfileApi.getEmployersList();
	
	            case 3:
	              _ref2 = _context.sent;
	              employersList = _ref2.data;
	              _context.next = 7;
	              return CandidateProfileApi.getExperiences($scope.candidate.id);
	
	            case 7:
	              experiences = _context.sent;
	              experienceList = experiences && experiences.data ? experiences.data : [];
	
	
	              $scope.employers = employersList;
	              $scope.candidate.experiences = experienceList;
	              if ($scope.candidate && $scope.candidate.experiences) formatFirmLogo($scope.candidate.experiences);
	
	              $scope.$apply();
	
	            case 13:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function initializeEmploymentHistory() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  initializeEmploymentHistory();
	
	  $scope.hideAllEmpHistories = function (histories) {
	    histories.forEach(function (history) {
	      history.editEmpHistory = false;
	    });
	  };
	
	  var arePracticeAreasMandatory = function arePracticeAreasMandatory() {
	    var practiceAreas = $scope.employment.specialties;
	    return !sharedProperties.isAdminSession() && _.isEmpty(practiceAreas);
	  };
	
	  function validateEmploymentParameters() {
	    var employment = $scope.employment;
	    $scope.employment.errors = {};
	    if (!employment.start || !employment.isLastJob && !employment.end || _.isEmpty(employment.location) || arePracticeAreasMandatory()) {
	      var errorText = '';
	      var errorCount = 0;
	      if (!employment.start) {
	        $scope.employment.errors.start = 'input-error';
	        errorCount++;
	        errorText += " 'Start Date' ";
	      }
	
	      if (!employment.isLastJob && !employment.end) {
	        $scope.employment.errors.isCurrent = 'input-error';
	        errorCount++;
	        errorText += " 'End Date' ";
	      }
	
	      if (_.isEmpty(employment.location)) {
	        $scope.employment.errors.location = 'input-error';
	        errorCount++;
	        errorText += " 'Location' ";
	      }
	
	      if (arePracticeAreasMandatory()) {
	        $scope.employment.errors.specialties = 'input-error';
	        errorCount++;
	        errorText += " 'Practice Areas' ";
	      }
	
	      errorText += errorCount > 1 ? ' fields are missing' : ' field is missing';
	      logger.notify('error', errorText);
	      return false;
	    }
	
	    if (!employment.isLastJob && employment.start && employment.end && new Date(employment.start) > new Date(employment.end)) {
	      logger.notify('error', "Employment's start date cannot be greater than the end date");
	      return false;
	    }
	
	    if (employment.isLastJob && employment.start && new Date(employment.start) > new Date()) {
	      logger.notify('error', "Current Employment's start date cannot be greater than current date");
	      return false;
	    }
	
	    return true;
	  }
	
	  $scope.findEmployerId = function (currentEmployer) {
	    console.debug('findEmployerId(' + currentEmployer + ')');
	
	    var employerName = currentEmployer ? currentEmployer : $scope.employment.employer.name;
	
	    console.debug('employerName: ' + employerName);
	
	    var employerIndex = $scope.employers.findIndex(function (employer) {
	      return employer.name === employerName;
	    });
	
	    console.debug('employerIndex: ' + employerIndex);
	
	    if (employerIndex !== -1) {
	      if (!currentEmployer) {
	        if ($scope.employers[employerIndex].logo) {
	          console.debug('updating picture for $scope.employment');
	          $scope.employment.employerPicture = ("https://api.lexstep.com") + '/' + $scope.employers[employerIndex].user.user_ID + '/' + $scope.employers[employerIndex].logo;
	        } else {
	          $scope.employment.employerPicture = 'images/firm-logo-default.jpg';
	          $scope.employment.monthDiff = getTotalExperience($scope.employment.start, $scope.employment.end);
	        }
	      }
	
	      var found = $scope.employers[employerIndex];
	      var id = found && found.id;
	
	      if (id) {
	        console.debug('found employer ID: ' + id);
	      } else {
	        console.error('Could not find employer ID for employer name: ' + employerName);
	      }
	
	      return id;
	    }
	  };
	
	  $scope.updateCurrentEmployerAndResidence = function (isPresentHistoryDeleted) {
	    if ($scope.employment.isLastJob) {
	      console.debug('updateCurrentEmployerAndResidence: last job change detected', 'candidate.employer', $scope.candidate.employer, 'employment.employer', $scope.employment.employer);
	
	      $scope.candidate.employer = $scope.employment.employer;
	      if ($scope.candidateExperienceLocation && $scope.candidateExperienceLocation.id && $scope.employment && $scope.employment.location && $scope.employment.location.id) {
	        $scope.candidate.location = $scope.candidateExperienceLocation.id === $scope.employment.location.id ? $scope.candidate.location : $scope.employment.location;
	      }
	
	      $scope.$apply();
	    } else if (isPresentHistoryDeleted) {
	      $scope.candidate.employer = undefined;
	      $scope.candidate.location = undefined;
	      $scope.$apply();
	    }
	  };
	
	  $scope.manageEmployment = function () {
	    if ($scope.employment.id) {
	      $scope.editEmployment($scope.employment.id);
	    } else {
	      $scope.addEmployment();
	    }
	  };
	
	  $scope.addAdditionalEmpInfo = function () {
	    var employer = $scope.findEmployerId();
	    console.debug('addAdditionalEmpInfo: employer id is', employer);
	    var employerName = $scope.employment && $scope.employment.employer && $scope.employment.employer.name || '';
	    console.debug('employer name is "' + employerName + '"');
	
	    angular.extend($scope.employment, {
	      lawyerId: $scope.lawyerId,
	      end: $scope.employment.isLastJob ? undefined : $scope.employment.end,
	      id: $scope.employment.id,
	      isAdminChange: true,
	      employerId: employer ? employer : $scope.employment.employer.name
	    });
	    $scope.employment.contractType = $scope.contracts.find(function (contract) {
	      return $scope.employment.contractTypeId === contract.id;
	    });
	    $scope.employment.occupation = $scope.occupations.find(function (occupation) {
	      return $scope.employment.occupationId === occupation.id;
	    });
	  };
	
	  $scope.editEmployment = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	    var payload, _ref4, data, updatedExperience;
	
	    return regeneratorRuntime.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            console.debug('editEmployment: start', $scope.employment);
	            $scope.candidateExperienceLocation = angular.copy($scope.employment.location);
	
	            if (validateEmploymentParameters()) {
	              _context3.next = 4;
	              break;
	            }
	
	            return _context3.abrupt('return');
	
	          case 4:
	
	            $scope.addAdditionalEmpInfo();
	
	            console.debug('editEmployment: start is "' + $scope.employment.start + '" and end is "' + $scope.employment.end + '"');
	
	            payload = Object.assign({
	              start: $scope.employment.start,
	              isLastJob: $scope.employment.isLastJob,
	              jobTitle: $scope.employment.jobTitle,
	              employer: $scope.employment.employerId,
	              occupationId: $scope.employment.occupation.id,
	              contractTypeId: $scope.employment.contractType.id,
	              locationId: $scope.employment.location.id,
	              comments: $scope.employment.comments,
	              specialties: $scope.employment.specialties.map(function (specialty) {
	                return specialty.id;
	              })
	            }, $scope.employment.end && { end: $scope.employment.end });
	            _context3.next = 9;
	            return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	              return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                  switch (_context2.prev = _context2.next) {
	                    case 0:
	                      console.debug('editEmployment(' + $scope.candidate.id + ', ' + $scope.employment.id + '): payload is', payload);
	
	                      return _context2.abrupt('return', EmploymentHistoryApi.editExperience($scope.candidate.id, $scope.employment.id, payload));
	
	                    case 2:
	                    case 'end':
	                      return _context2.stop();
	                  }
	                }
	              }, _callee2, _this);
	            })));
	
	          case 9:
	            _ref4 = _context3.sent;
	            data = _ref4.data;
	
	
	            console.debug('editEmployment: updated data is', data);
	
	            updatedExperience = formatFirmLogo([data])[0];
	
	            $scope.employment = updatedExperience;
	            $scope.updateEditedEmploymentRecord(updatedExperience);
	            $scope.employment = updatedExperience;
	            $scope.hideAddEmploymentHistoryForm();
	
	            if (!$scope.findEmployerId(updatedExperience.employer.name)) $scope.employers.push({
	              id: updatedExperience.employer.id,
	              name: updatedExperience.employer.name
	            });
	
	            $scope.updateCurrentEmployerAndResidence();
	
	            // TODO: re-enable segment
	            // $scope.trackExperience($scope.employment, 'Edit')
	
	            $scope.resetEmployment();
	
	            $scope.$apply();
	            logger.notify('success', 'Candidate Experience Successfully Updated!');
	
	          case 22:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, _this);
	  }));
	
	  $scope.addEmployment = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	    var payload, _ref7, data, newExperience;
	
	    return regeneratorRuntime.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            console.debug('addEmployment: START');
	
	            if (validateEmploymentParameters()) {
	              _context5.next = 3;
	              break;
	            }
	
	            return _context5.abrupt('return');
	
	          case 3:
	
	            $scope.addAdditionalEmpInfo();
	
	            payload = Object.assign({
	              start: $scope.employment.start,
	              isLastJob: $scope.employment.isLastJob,
	              jobTitle: $scope.employment.jobTitle,
	              employer: $scope.employment.employerId,
	              occupationId: $scope.employment.occupation.id,
	              contractTypeId: $scope.employment.contractType.id,
	              locationId: $scope.employment.location.id,
	              comments: $scope.employment.comments,
	              specialties: $scope.employment.specialties.map(function (specialty) {
	                return specialty.id;
	              })
	            }, $scope.employment.end && { end: $scope.employment.end });
	            _context5.next = 7;
	            return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
	              return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                while (1) {
	                  switch (_context4.prev = _context4.next) {
	                    case 0:
	                      return _context4.abrupt('return', EmploymentHistoryApi.addExperience($scope.candidate.id, payload));
	
	                    case 1:
	                    case 'end':
	                      return _context4.stop();
	                  }
	                }
	              }, _callee4, _this);
	            })));
	
	          case 7:
	            _ref7 = _context5.sent;
	            data = _ref7.data;
	            newExperience = formatFirmLogo([data])[0];
	
	            $scope.employment = newExperience;
	            if (!$scope.findEmployerId(newExperience.employer.name)) $scope.employers.push({
	              id: newExperience.employer.id,
	              name: newExperience.employer.name
	            });
	            console.debug('addEmployment: calling addEmploymentRecord', $scope.employment);
	            $scope.addEmploymentRecord($scope.employment);
	            console.debug('addEmployment: calling hideAddEmploymentHistoryForm');
	            $scope.hideAddEmploymentHistoryForm();
	            console.debug('addEmployment: calling updateCurrentEmployerAndResidenc');
	            $scope.updateCurrentEmployerAndResidence();
	            console.debug('addEmployment: calling trackExperience', $scope.employment);
	            $scope.trackExperience($scope.employment, 'Add');
	            $scope.resetEmployment();
	            console.debug('addEmployment: DONE. will apply');
	
	            $scope.$apply();
	
	            console.debug('addEmployment: DONE. applied');
	            logger.notify('success', 'Candidate Experience Successfully Added!');
	            console.debug('addEmployment: NOTIFIED');
	
	          case 26:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, _this);
	  }));
	
	  $scope.deleteEmployment = function () {
	    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id, index) {
	      var modalInstance;
	      return regeneratorRuntime.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              modalInstance = $modal.open({
	                templateUrl: 'deleteExperienceModal.html',
	                controller: function controller($uibModalInstance) {
	                  var vm = this;
	                  vm.confirmAction = false;
	                  vm.yes = function () {
	                    vm.confirmAction = true;
	                    $uibModalInstance.close(vm.confirmAction);
	                  };
	
	                  vm.no = function () {
	                    $uibModalInstance.dismiss('cancel');
	                  };
	                },
	                controllerAs: 'deleteExperienceModalCtrl'
	              });
	              modalInstance.result.then(function () {
	                var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(selectedItem) {
	                  var isPresentHistoryDeleted, deletedEmployment;
	                  return regeneratorRuntime.wrap(function _callee7$(_context7) {
	                    while (1) {
	                      switch (_context7.prev = _context7.next) {
	                        case 0:
	                          if (!selectedItem) {
	                            _context7.next = 17;
	                            break;
	                          }
	
	                          _context7.prev = 1;
	                          _context7.next = 4;
	                          return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
	                            return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                              while (1) {
	                                switch (_context6.prev = _context6.next) {
	                                  case 0:
	                                    return _context6.abrupt('return', EmploymentHistoryApi.deleteExperience($scope.candidate.id, id));
	
	                                  case 1:
	                                  case 'end':
	                                    return _context6.stop();
	                                }
	                              }
	                            }, _callee6, _this);
	                          })));
	
	                        case 4:
	                          isPresentHistoryDeleted = !$scope.candidate.experiences[index].end;
	                          deletedEmployment = angular.copy($scope.candidate.experiences[index]);
	
	                          $scope.trackExperience(deletedEmployment, 'Profile - Deleting Experience');
	
	                          $scope.removeEmploymentRecord(index);
	                          $scope.updateCurrentEmployerAndResidence(isPresentHistoryDeleted);
	
	                          $scope.$apply();
	                          logger.notify('success', 'Candidate Experience Successfully Deleted!');
	                          _context7.next = 17;
	                          break;
	
	                        case 13:
	                          _context7.prev = 13;
	                          _context7.t0 = _context7['catch'](1);
	
	                          console.error('error:', _context7.t0);
	                          logger.notify('error', 'Error occurred on Candidate Experience Deletion');
	
	                        case 17:
	                        case 'end':
	                          return _context7.stop();
	                      }
	                    }
	                  }, _callee7, _this, [[1, 13]]);
	                }));
	
	                return function (_x3) {
	                  return _ref10.apply(this, arguments);
	                };
	              }(), function () {});
	
	            case 2:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, _this);
	    }));
	
	    return function (_x, _x2) {
	      return _ref9.apply(this, arguments);
	    };
	  }();
	}
	
	var formatFirmLogo = function formatFirmLogo(histories) {
	  histories.forEach(function (history) {
	    if (history.employer.logo) history.employerPicture = ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/employers/' + history.employer.id + '/logo/' + history.employer.logo;else history.employerPicture = 'images/firm-logo-default.jpg';
	    history.monthDiff = getTotalExperience(history.start, history.isLastJob ? new Date() : history.end);
	  });
	  return histories;
	};
	
	function getTotalExperience(from, to) {
	  var ends = to ? moment(to) : moment();
	  var starts = moment(from);
	  var duration = moment.duration(ends.diff(starts));
	
	  var totalExperience = '';
	  var years = duration.years();
	  var months = duration.months();
	  var days = duration.days();
	
	  if (days > 15) {
	    months += 1;
	    days = 0;
	  }
	
	  if (months >= 12) {
	    years += 1;
	    months = 0;
	  }
	
	  if (years > 0) {
	    var yearString = years === 1 ? ' year ' : ' years ';
	    totalExperience = totalExperience + years + yearString;
	  }
	
	  if (months > 0) {
	    var monthString = months === 1 ? ' month ' : ' months ';
	    totalExperience = totalExperience + months + monthString;
	  }
	
	  if (years === 0 && months === 0) {
	    var dayString = days === 1 ? ' day ' : ' days ';
	    totalExperience = totalExperience + days + dayString;
	  }
	
	  return totalExperience;
	}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/* eslint-disable unicorn/filename-case */
	
	angular.module('app.LawyerProfile').directive('employmentForm', function () {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      formName: '@',
	      candidate: '=',
	      submitHandler: '&',
	      cancelHandler: '&',
	      employment: '=',
	      employers: '=',
	      locations: '=',
	      practices: '=',
	      occupations: '=',
	      contracts: '='
	    },
	    template: __webpack_require__(433),
	    controller: employmentFormCtrl
	  };
	});
	
	function employmentFormCtrl($scope, $uibModal, sharedProperties) {
	  var _this = this;
	
	  $scope.isAdminSession = sharedProperties.isAdminSession();
	
	  $scope.today = new Date();
	
	  $scope.salaryDetailsDatePickerOptions = {
	    'datepicker-mode': "'day'",
	    'year-format': "'yy'",
	    'starting-day': 1,
	    defaultDate: '1'
	  };
	
	  $scope.employmentFormDatePickerOptions = {
	    'year-format': "'yy'",
	    'starting-day': 1,
	    'datepicker-mode': "'month'",
	    'min-mode': 'month',
	    defaultDate: '1'
	
	    // $scope.currencyList = cc.codes();
	
	  };$scope.verifyEmployerNameEscapeChar = function (string) {
	    if (string === void 0) {
	      $scope.employment.employer.name = '';
	    } else {
	      $scope.employment.employer.name = string.trim();
	    }
	  };
	
	  $scope.openLocModal = function () {
	    var modalInstance = $uibModal.open({
	      templateUrl: 'locations-modal.html',
	      controller: 'LocationsModalController',
	      controllerAs: 'ctrl',
	      resolve: {
	        locationList: function locationList() {
	          return $scope.locations;
	        },
	        selectedLocations: function selectedLocations() {
	          return $scope.employment.location ? [$scope.employment.location] : [];
	        },
	        limit: function limit() {
	          return 1;
	        },
	        locationModalHeading: function locationModalHeading() {
	          return true;
	        },
	        displayNextButton: function displayNextButton() {
	          return false;
	        }
	      }
	    });
	    modalInstance.result.then(function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(selectedLocations) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                $scope.employment.location = angular.copy(selectedLocations[0]);
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }(), function () {});
	  };
	
	  $scope.openPracticeAreasModal = function () {
	    var candidatePractices = $scope.employment.specialties.map(function (candidatePractice) {
	      return $scope.practices.find(function (practice) {
	        return practice.id === candidatePractice.id;
	      });
	    });
	    var modalInstance = $uibModal.open({
	      templateUrl: 'practice-area-modal.html',
	      controller: 'PracticeAreaController',
	      controllerAs: 'ctrl',
	      resolve: {
	        practiceAreaList: function practiceAreaList() {
	          return $scope.practices.filter(function (_ref2) {
	            var parentId = _ref2.parentId;
	            return parentId === null;
	          });
	        },
	        selectedPractice: function selectedPractice() {
	          return candidatePractices;
	        },
	        limit: function limit() {
	          return $scope.candidate.isAdminProfile ? 0 : 5;
	        },
	        isAdminProfile: function isAdminProfile() {
	          return Boolean($scope.candidate.isAdminProfile);
	        },
	        displayNextButton: function displayNextButton() {
	          return false;
	        }
	      }
	    });
	    modalInstance.result.then(function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(selectPractices) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                $scope.employment.specialties = angular.copy(selectPractices);
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }(), function () {});
	  };
	}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

	'use strict';
	
	/******************************************************************/
	/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
	/******************************************************************/
	
	angular.module('app.LawyerProfile').controller('locationModalController', locationModalController);
	
	function locationModalController($scope, $http, $log, $modalInstance, $location, data, $translate, logger) {
	  $translate.use('en');
	  $scope.notify = function (type, message) {
	    switch (type) {
	      case 'info':
	        logger.log(message);
	        break;
	      case 'success':
	        logger.logSuccess(message);
	        break;
	      case 'warning':
	        logger.logWarning(message);
	        break;
	      case 'error':
	        logger.logError(message);
	    }
	  };
	
	  $scope.count = 0;
	  $scope.data = data.data;
	  var isModalForHistorylocations = data.isModalForHistorylocations;
	  $scope.showLocations = true;
	  $scope.element = data.element;
	  $log.info("$scope.data", $scope.data);
	  if (isModalForHistorylocations) {
	    $scope.heading = "modal.employmentHistory.locations.Heading";
	    $scope.subHeading = "modal.employmentHistory.locations.subHeading";
	  } else {
	    $scope.heading = 'modal.locations.Heading';
	    $scope.subHeading = "Show locations";
	  }
	
	  $scope.isLocAlreadySelected = data.isLocAlreadySelected;
	  $scope.updatedData = {
	    data: $scope.data,
	    element: ''
	  };
	  $scope.showChildLocations = false;
	
	  $scope.displayChildLocations = function (region) {
	    region.showChildLocations = true;
	  };
	  $scope.hideChildLocations = function (region) {
	    region.showChildLocations = false;
	  };
	
	  $scope.selectLocation = function (event, current, level) {
	
	    var pCounter, sCounter, value;
	    pCounter = 0;
	    sCounter = 0;
	    $scope.updatedData.element = 'location';
	    value = event.target.checked;
	
	    if (value && $scope.isLocAlreadySelected) {
	      event.target.checked = false;
	      current.isSelected = false;
	      $scope.notify('error', 'An Employment can\'t have multiple locations');
	      return;
	    } else if (!value && !$scope.isLocAlreadySelected) $scope.isLocAlreadySelected = true;else $scope.isLocAlreadySelected = false;
	
	    if (level === 1) {
	      $scope.updatedData.data.forEach(function (region, index, array) {
	        region.locations.forEach(function (location, index, array) {
	          if (location.loc_ID === current.loc_ID) {
	
	            if (value) {
	              // if($scope.count < 1)
	              $scope.isLocAlreadySelected = true;
	              location.isSelected = value;
	
	              region.locations.forEach(function (p, i, a) {
	                if (p.isSelected) {
	                  pCounter++;
	                }
	              });
	              if (value) {
	                if (pCounter > 0) {
	                  region.isSelected = value;
	                }
	              } else {
	                if (pCounter <= 0) {
	                  region.isSelected = value;
	                }
	              }
	              $scope.count++;
	            } else if (!value) {
	              $scope.isLocAlreadySelected = false;
	              location.isSelected = value;
	              region.locations.forEach(function (p, i, a) {
	                if (p.isSelected) {
	                  pCounter++;
	                }
	              });
	              if (value) {
	                if (pCounter > 0) {
	                  region.isSelected = value;
	                }
	              } else {
	                if (pCounter <= 0) {
	                  region.isSelected = value;
	                }
	              }
	              $scope.count--;
	            }
	          }
	        });
	      });
	    } else if (level === 0) {
	      $scope.updatedData.data.forEach(function (region, index, array) {
	        region.locations.forEach(function (location, index, array) {
	          if (location.sub_areas.length > 0) {
	            location.sub_areas.forEach(function (sub, index, array) {
	              if (sub.loc_ID === current.loc_ID) {
	                if (value) {
	                  $scope.isLocAlreadySelected = true;
	                } else if (!value) $scope.isLocAlreadySelected = false;
	
	                sub.isSelected = value;
	                location.sub_areas.forEach(function (s, i, a) {
	                  if (s.isSelected) {
	                    sCounter++;
	                  }
	                });
	                if (value) {
	                  if (sCounter > 0) {
	                    region.isSelected = value;
	                    location.isSelected = value;
	                  }
	                } else {
	                  if (sCounter <= 0) {
	                    location.isSelected = value;
	                    region.locations.forEach(function (p, i, a) {
	                      if (p.isSelected) {
	                        pCounter++;
	                      }
	                    });
	                    if (value) {
	                      if (pCounter > 0) {
	                        region.isSelected = value;
	                      }
	                    } else {
	                      if (pCounter <= 0) {
	                        region.isSelected = value;
	                      }
	                    }
	                  }
	                }
	                if (value) {
	                  $scope.count++;
	                } else {
	                  $scope.count--;
	                }
	              }
	            });
	          }
	        });
	      });
	    }
	  };
	
	  $scope.save = function () {
	    var chosenLocations = $scope.updatedData.data,
	        linearizedLocations = [];
	    chosenLocations.forEach(function (location, index, array) {
	      if (location.isSelected) {
	        location.locations.forEach(function (loc, index, array) {
	          if (loc.isSelected) {
	            if (!loc.hasChild) {
	              linearizedLocations.push(loc);
	            }
	            loc.sub_areas.forEach(function (sub, index, array) {
	              if (sub.isSelected) {
	                linearizedLocations.push(sub);
	              }
	            });
	          }
	        });
	      }
	    });
	
	    if (_.isEmpty(linearizedLocations)) {
	      $scope.notify("info", "It is mandatory for a work experience to have a location");
	      return;
	    }
	
	    $modalInstance.close(linearizedLocations);
	  };
	  $scope.cancel = function () {
	    $modalInstance.dismiss("cancel");
	  };
	}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.LawyerProfile').factory('EmploymentHistoryService', function ($log, $http, $q, $filter) {
	  function mapHistory(history) {
	    history.forEach(function (employment, index, array) {
	      mapEmployment(employment);
	    });
	    return history;
	  }
	
	  function mapEmployment(employment) {
	    employment.workDescription = employment.work_description;
	    employment.workId = employment.work_ID;
	    employment.salaryDateToShow = employment.salaryDate && moment(employment.salaryDate).local().format('MM/DD/YYYY');
	    employment.bonusDateToShow = employment.bonusDate && moment(employment.bonusDate).local().format('MM/DD/YYYY');
	
	    delete employment.work_description;
	    delete employment.work_ID;
	
	    _.each(employment.practiceAreas, function (prac) {
	      prac.isSelected = true;
	    });
	
	    return employment;
	  }
	  function mapDatesToString(employment) {
	    employment = angular.copy(employment);
	
	    employment.from = $filter('date')(employment.from, 'yyyy/MM/dd');
	    employment.to = $filter('date')(employment.to, 'yyyy/MM/dd');
	
	    return employment;
	  }
	  return {
	    fetchLawyerResidence: function fetchLawyerResidence(lawyerId) {
	      var defer = $q.defer();
	
	      $http.post('/api/select-lawyer-residence', { lawyerId: lawyerId }, { contentType: 'application/json' }).then(function (_ref) {
	        var data = _ref.data,
	            status = _ref.status,
	            headers = _ref.headers,
	            config = _ref.config;
	
	        defer.resolve(data);
	      }, function (_ref2) {
	        var data = _ref2.data;
	
	        defer.reject(data);
	      });
	
	      return defer.promise;
	    },
	    add: function add(employment) {
	      var defer = $q.defer();
	      employment = mapDatesToString(employment);
	
	      $http.post('/api/add-lawyer-work', { work: employment }, { contentType: 'application/json' }).then(function (_ref3) {
	        var data = _ref3.data,
	            status = _ref3.status,
	            headers = _ref3.headers,
	            config = _ref3.config;
	
	        defer.resolve(mapEmployment(data));
	      }, function (_ref4) {
	        var data = _ref4.data;
	
	        defer.reject(data);
	      });
	
	      return defer.promise;
	    },
	    delete: function _delete(employment) {
	      var defer = $q.defer();
	
	      $http.post('/api/delete-lawyer-work', employment, {
	        contentType: 'application/json'
	      }).then(function (_ref5) {
	        var data = _ref5.data,
	            status = _ref5.status,
	            headers = _ref5.headers,
	            config = _ref5.config;
	
	        defer.resolve(data);
	      }, function (_ref6) {
	        var data = _ref6.data;
	
	        defer.reject(data);
	      });
	
	      return defer.promise;
	    },
	    edit: function edit(employment) {
	      var defer = $q.defer();
	      employment = mapDatesToString(employment);
	
	      $http.post('/api/edit-lawyer-work', employment, {
	        contentType: 'application/json'
	      }).then(function (_ref7) {
	        var data = _ref7.data,
	            status = _ref7.status,
	            headers = _ref7.headers,
	            config = _ref7.config;
	
	        defer.resolve(data);
	      }, function (_ref8) {
	        var data = _ref8.data;
	
	        defer.reject(data);
	      });
	
	      return defer.promise;
	    },
	    history: function history(lawyerId) {
	      var defer = $q.defer();
	
	      $http.post('/api/fetch-work-history', { lawyerId: lawyerId }).then(function (_ref9) {
	        var data = _ref9.data,
	            status = _ref9.status,
	            headers = _ref9.headers,
	            config = _ref9.config;
	
	        defer.resolve(mapHistory(data));
	      }, function (_ref10) {
	        var data = _ref10.data;
	
	        defer.reject(data);
	      });
	
	      return defer.promise;
	    }
	  };
	});

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LoginHistoryController = undefined;
	
	var _loadingOverlay = __webpack_require__(20);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var actionTypes = [{
	  typeId: 'APPLICATION_CREATE',
	  name: 'Application created',
	  category: 'application'
	}, {
	  typeId: 'APPLICATION_DELETE',
	  name: 'Application deleted',
	  category: 'application'
	}, {
	  typeId: 'APPLICATION_FOLLOW_CREATE',
	  name: 'Application Follower created',
	  category: 'application'
	}, {
	  typeId: 'APPLICATION_FOLLOW_DELETE',
	  name: 'Application Follower deleted',
	  category: 'application'
	}, {
	  typeId: 'APPLICATION_FOLLOW_UPDATE',
	  name: 'Application Follower updated',
	  category: 'application'
	}, {
	  typeId: 'APPLICATION_STAGE_CREATE',
	  name: 'Application stage created',
	  category: 'application_stage'
	}, {
	  typeId: 'APPLICATION_STAGE_UPDATE',
	  name: 'Application stage updated',
	  category: 'application_stage'
	}, {
	  typeId: 'APPLICATION_UPDATE',
	  name: 'Application updated',
	  category: 'application'
	}, {
	  typeId: 'APPROVAL_ACCEPT',
	  name: 'Candidate approval accepted',
	  category: 'user'
	}, {
	  typeId: 'APPROVAL_REJECT',
	  name: 'Candidate approval rejected',
	  category: 'user'
	}, {
	  typeId: 'APPROVAL_REQUEST',
	  name: 'Candidate requests approval',
	  category: 'user'
	}, {
	  typeId: 'APPROVAL_STATUS_UPDATE',
	  name: 'Candidate approval status updated',
	  category: 'user'
	}, {
	  typeId: 'BULK_CANDIDATE_ASSIGNED_AGENT_UPDATE',
	  name: 'Bulk candidates assigned agent updated',
	  category: 'user'
	}, {
	  typeId: 'CANDIDATE_ARCHIVE',
	  name: 'Candidate archived',
	  category: 'user'
	}, {
	  typeId: 'CANDIDATE_ASSIGNED_AGENT_UPDATE',
	  name: 'Candidate assigned agent updated',
	  category: 'user'
	}, {
	  typeId: 'CANDIDATE_EMPLOYER_BLOCK',
	  name: 'Candidate blocks an employer',
	  category: 'user'
	}, {
	  typeId: 'CANDIDATE_EMPLOYER_FOLLOW',
	  name: 'Candidate follows an employer',
	  category: 'user'
	}, {
	  typeId: 'CANDIDATE_EMPLOYER_HIDE',
	  name: 'Candidate hides an employer',
	  category: 'user'
	}, {
	  typeId: 'CANDIDATE_EMPLOYER_SHOW',
	  name: 'Candidate follows an employer',
	  category: 'user'
	}, {
	  typeId: 'CANDIDATE_LOCK',
	  name: "candidate approval status is updated to 'Locked'",
	  category: 'user'
	}, {
	  typeId: 'CANDIDATE_POSITION_HIDE',
	  name: 'Candidate hides a position',
	  category: 'user'
	}, {
	  typeId: 'CANDIDATE_POSITION_SHOW',
	  name: 'Candidate shows a position',
	  category: 'user'
	}, {
	  typeId: 'CANDIDATE_PROFILE_CREATE',
	  name: 'Candidate profile created',
	  category: 'user'
	}, {
	  typeId: 'CANDIDATE_PROFILE_DELETE',
	  name: 'Candidate profile created',
	  category: 'user'
	}, {
	  typeId: 'CANDIDATE_PROFILE_UPDATE',
	  name: 'Candidate updates their profile',
	  category: 'user'
	}, {
	  typeId: 'CANDIDATE_UNLOCK',
	  name: "candidate approval status is updated to 'Approved'",
	  category: 'user'
	}, {
	  typeId: 'EMAIL_PAUSE',
	  name: 'User have paused the Email',
	  category: 'email'
	}, {
	  typeId: 'EMAIL_SCHEDULED',
	  name: 'User email is scheduled',
	  category: 'email'
	}, {
	  typeId: 'EMAIL_SENT',
	  name: 'Email sent',
	  category: 'email'
	}, {
	  typeId: 'EMAIL_SUBSCRIBE',
	  name: 'User subscribed to Email',
	  category: 'email'
	}, {
	  typeId: 'EMAIL_UNPAUSE',
	  name: 'User have paused the Email',
	  category: 'email'
	}, {
	  typeId: 'EMAIL_UNSUBSCRIBE',
	  name: 'User unsubscribed to Email',
	  category: 'email'
	}, {
	  typeId: 'EMAIL_UPDATE',
	  name: 'Email CC or BCC updated',
	  category: 'email'
	}, {
	  typeId: 'EMPLOYER_ASSIGNED_AGENT_UPDATE',
	  name: 'Employer assigned agent updated',
	  category: 'employer'
	}, {
	  typeId: 'EMPLOYER_BLOCK',
	  name: 'Employer blocked',
	  category: 'employer'
	}, {
	  typeId: 'EMPLOYER_CREATE',
	  name: 'Employer created',
	  category: 'employer'
	}, {
	  typeId: 'EMPLOYER_DELETE',
	  name: 'Employer deleted',
	  category: 'employer'
	}, {
	  typeId: 'EMPLOYER_ENQUIRY',
	  name: 'Employer enquiry',
	  category: 'employer'
	}, {
	  typeId: 'EMPLOYER_FOLLOWED',
	  name: 'Employer followed',
	  category: 'employer'
	}, {
	  typeId: 'EMPLOYER_HIDE',
	  name: 'Employer hidden',
	  category: 'employer'
	}, {
	  typeId: 'EMPLOYER_SHOW',
	  name: 'Employer shown',
	  category: 'employer'
	}, {
	  typeId: 'EMPLOYER_UNBLOCK',
	  name: 'Employer unblocked',
	  category: 'employer'
	}, {
	  typeId: 'EMPLOYER_UN_FOLLOWED',
	  name: 'Employer un followed',
	  category: 'employer'
	}, {
	  typeId: 'EMPLOYER_UPDATE',
	  name: 'Employer updated',
	  category: 'employer'
	}, {
	  typeId: 'EXPERIENCE_CREATE',
	  name: 'Candidate created new experience',
	  category: 'user'
	}, {
	  typeId: 'EXPERIENCE_DELETE',
	  name: 'Candidate deleted experience',
	  category: 'user'
	}, {
	  typeId: 'EXPERIENCE_UPDATE',
	  name: 'Candidate updated experience',
	  category: 'user'
	}, {
	  typeId: 'EXTERNAL_USER_CREATE',
	  name: 'External User Created',
	  category: 'external_user'
	}, {
	  typeId: 'LOGIN',
	  name: 'User logs in',
	  category: 'user'
	}, {
	  typeId: 'LOGOUT',
	  name: 'User logs out',
	  category: 'user'
	}, {
	  typeId: 'NOTE_CREATE',
	  name: 'Note created',
	  category: 'note'
	}, {
	  typeId: 'NOTE_DELETE',
	  name: 'Note deleted',
	  category: 'note'
	}, {
	  typeId: 'NOTE_UPDATE',
	  name: 'Note updated',
	  category: 'note'
	}, {
	  typeId: 'PASSWORD_RESET',
	  name: 'Password reset',
	  category: 'user'
	}, {
	  typeId: 'POSITION_CREATE',
	  name: 'Position created',
	  category: 'position'
	}, {
	  typeId: 'POSITION_DELETE',
	  name: 'Position deleted',
	  category: 'position'
	}, {
	  typeId: 'POSITION_HIDE',
	  name: 'Position hidden',
	  category: 'position'
	}, {
	  typeId: 'POSITION_QUESTION',
	  name: 'Asked a question',
	  category: 'user'
	}, {
	  typeId: 'POSITION_QUESTION_SENT',
	  name: 'Question sent via email',
	  category: 'position'
	}, {
	  typeId: 'POSITION_SHOW',
	  name: 'Position shown',
	  category: 'position'
	}, {
	  typeId: 'POSITION_UPDATE',
	  name: 'Position updated',
	  category: 'position'
	}, {
	  typeId: 'POSITION_VIEW',
	  name: 'Candidate views a position',
	  category: 'user'
	}, {
	  typeId: 'PROFESSION_PROFILE_UPDATE',
	  name: 'user profession profile updated',
	  category: 'user'
	}, {
	  typeId: 'PROFILE_PHOTO_DELETE',
	  name: 'user profile photo deleted',
	  category: 'user'
	}, {
	  typeId: 'PROFILE_PHOTO_UPLOAD',
	  name: 'user profile photo uploaded',
	  category: 'user'
	}, {
	  typeId: 'REFERRAL_CREATE',
	  name: 'Referral Created',
	  category: 'referral'
	}, {
	  typeId: 'RESUME_CREATE',
	  name: 'Candidate resume created',
	  category: 'user'
	}, {
	  typeId: 'RESUME_DELETE',
	  name: 'Candidate resume deleted',
	  category: 'user'
	}, {
	  typeId: 'RESUME_UPDATE',
	  name: 'Candidate resume updated',
	  category: 'user'
	}, {
	  typeId: 'SALARY_CREATE',
	  name: 'Candidate Salary Created',
	  category: 'user'
	}, {
	  typeId: 'SALARY_DELETE',
	  name: 'Candidate Salary deleted',
	  category: 'user'
	}, {
	  typeId: 'SALARY_UPDATE',
	  name: 'Candidate Salary Updated',
	  category: 'user'
	}, {
	  typeId: 'TASK_FAIL',
	  name: 'Scheduled task failed',
	  category: 'scheduled_task'
	}, {
	  typeId: 'TASK_SUCCESS',
	  name: 'Scheduled task ran successfully',
	  category: 'scheduled_task'
	}, {
	  typeId: 'USER_ACTIVE',
	  name: 'User is Active',
	  category: 'user'
	}, {
	  typeId: 'USER_CORPORATE',
	  name: 'Corporate Role added to User ',
	  category: 'user'
	}, {
	  typeId: 'USER_CREATE',
	  name: 'User Created',
	  category: 'user'
	}, {
	  typeId: 'USER_DELETE',
	  name: 'User is archived in database',
	  category: 'user'
	}, {
	  typeId: 'USER_LOGIN',
	  name: 'User logged in',
	  category: 'user'
	}, {
	  typeId: 'USER_LOGOUT',
	  name: 'User logged in',
	  category: 'user'
	}, {
	  typeId: 'USER_SETTING_CREATE',
	  name: 'user created specific setting',
	  category: 'user'
	}, {
	  typeId: 'USER_SETTING_DELETE',
	  name: 'user deleted specific setting',
	  category: 'user'
	}, {
	  typeId: 'USER_SETTING_UPDATE',
	  name: 'user updated specific setting',
	  category: 'user'
	}, {
	  typeId: 'USER_SIGNUP',
	  name: 'User signed up',
	  category: 'user'
	}, {
	  typeId: 'USER_UPDATE',
	  name: 'User Updated',
	  category: 'user'
	}];
	function formatType(typeId) {
	  var match = actionTypes.find(function (actionType) {
	    return actionType.typeId === typeId;
	  });
	  // eslint-disable-next-line no-negated-condition,no-extra-boolean-cast
	  return match ? match.name : typeId;
	}
	
	var getInformationFromPositionHideAction = function getInformationFromPositionHideAction(action) {
	  var hasPayload = action && action.payload && action.payload[0];
	  var information = hasPayload ? action.payload[0] : false;
	  if (!information) {
	    console.debug('No information found in action', action);
	    return '';
	  }
	
	  console.debug('getInformationFromPositionHideAction', action);
	  return action.positionTitle + ' was hidden: "' + information.reason + '"';
	};
	
	function formatInfo(action) {
	  switch (action.typeId) {
	    case 'POSITION_HIDE':
	    case 'CANDIDATE_POSITION_HIDE':
	      return getInformationFromPositionHideAction(action);
	    default:
	      return '';
	  }
	}
	
	// eslint-disable-next-line unicorn/prefer-set-has
	var positionActionTypes = ['POSITION_HIDE', 'CANDIDATE_POSITION_HIDE'];
	
	var generatePositionInformation = function generatePositionInformation(action, positionTitleData) {
	  var titleData = positionTitleData.find(function (data) {
	    return data.id === action.payload[0].positionId;
	  });
	  var positionTitle = titleData && titleData.id && titleData.employer && titleData.title ? titleData.title + ' @ ' + titleData.employer + ' (' + titleData.id + ')' : '';
	  console.debug('addPositionDetails::positionTitle:', positionTitle);
	  var withTitle = _.extend(action, { positionTitle: positionTitle });
	  return formatInfo(withTitle);
	};
	
	var formatLoginHistory = function formatLoginHistory(actions, positionDetails) {
	  console.debug('formatLoginHistory:actions', actions);
	  console.debug('formatLoginHistory:positionDetails', positionDetails);
	
	  var extended = actions && actions.length > 0 && actions.map(function (action) {
	    return _.extend(action, {
	      type: formatType(action.typeId)
	    });
	  });
	
	  if (!positionDetails) {
	    return extended;
	  }
	
	  if (positionDetails && positionDetails.length > 0) {
	    var positionTitleData = positionDetails.map(function (position) {
	      return {
	        id: position.id,
	        employer: position.employer.name,
	        title: position.title
	      };
	    });
	    console.debug('formatLoginHistory: title data', positionTitleData);
	
	    var withInfo = extended && extended.length > 0 && extended.map(function (action) {
	      if (!positionActionTypes.includes(action.typeId)) {
	        return _.extend(action, { info: formatInfo(action) });
	      }
	
	      console.warn('withInfo: processing position action', action);
	
	      return _.extend(action, {
	        info: generatePositionInformation(action, positionTitleData)
	      });
	    });
	
	    return withInfo;
	  }
	
	  return actions;
	};
	
	var getPositionDetails = function () {
	  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(actions, api) {
	    var relevant, positionIds, asQueryParameters, response;
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            if (actions) {
	              _context.next = 2;
	              break;
	            }
	
	            return _context.abrupt('return', actions);
	
	          case 2:
	            relevant = actions.filter(function (action) {
	              return positionActionTypes.includes(action.typeId);
	            });
	            positionIds = relevant && relevant.map(function (action) {
	              return action.payload[0].positionId;
	            });
	
	            if (positionIds) {
	              _context.next = 6;
	              break;
	            }
	
	            return _context.abrupt('return', []);
	
	          case 6:
	            if (!(positionIds && positionIds.length > 0)) {
	              _context.next = 13;
	              break;
	            }
	
	            asQueryParameters = positionIds.map(function (id) {
	              return 'ids=' + id;
	            }).join('&');
	            _context.next = 10;
	            return api.get('positions?' + asQueryParameters);
	
	          case 10:
	            response = _context.sent;
	
	            console.log('getPositionDetails response:', response);
	            return _context.abrupt('return', response && response.data);
	
	          case 13:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function getPositionDetails(_x, _x2) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var LoginHistoryController = function LoginHistoryController($scope, CandidateProfileApi, api) {
	  $scope.paginationOptions = {
	    limitOptions: [10, 20, 50],
	    selectedLimit: 50
	  };
	
	  $scope.pagination = {
	    currentPage: 1,
	    totalItems: 0
	  };
	
	  $scope.pageChange = function () {
	    var start = $scope.paginationOptions.selectedLimit * ($scope.pagination.currentPage - 1);
	    var end = start + $scope.paginationOptions.selectedLimit;
	    $scope.history = $scope.allHistory.slice(start, end);
	    $scope.$apply();
	  };
	
	  $scope.initializeHistory = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	    return regeneratorRuntime.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	              var _ref4, actions, positionDetails, formatted;
	
	              return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                  switch (_context2.prev = _context2.next) {
	                    case 0:
	                      _context2.next = 2;
	                      return CandidateProfileApi.getLoginHistory($scope.candidate.id);
	
	                    case 2:
	                      _ref4 = _context2.sent;
	                      actions = _ref4.data;
	                      _context2.next = 6;
	                      return getPositionDetails(actions, api);
	
	                    case 6:
	                      positionDetails = _context2.sent;
	                      formatted = formatLoginHistory(actions, positionDetails);
	
	                      $scope.allHistory = formatted;
	                      $scope.pagination.totalItems = $scope.allHistory.length;
	                      $scope.pageChange();
	
	                    case 11:
	                    case 'end':
	                      return _context2.stop();
	                  }
	                }
	              }, _callee2, undefined);
	            }))));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  $scope.initializeHistory();
	};
	
	exports.LoginHistoryController = LoginHistoryController;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _loginHistory = __webpack_require__(557);
	
	var loginHistoryDirective = function loginHistoryDirective() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      candidate: '='
	    },
	    controller: _loginHistory.LoginHistoryController,
	    template: __webpack_require__(435)
	  };
	};
	
	angular.module('app.directives').directive('loginHistoryDirective', loginHistoryDirective);

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PreferencesController = undefined;
	
	var _loadingOverlay = __webpack_require__(20);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var PreferencesController = function PreferencesController($scope, $uibModal, logger, CandidatePreferencesApi, CandidateProfileApi) {
	  $scope.resetEditPreferences = function () {
	    $scope.editPreferences = {
	      contracts: angular.copy($scope.candidate.preferredContractTypes),
	      occupations: angular.copy($scope.candidate.occupations),
	      employerTypes: angular.copy($scope.candidate.legalEmployerTypes)
	    };
	  };
	
	  $scope.updateEmployerTypes = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	    var employerTypes;
	    return regeneratorRuntime.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            employerTypes = $scope.editPreferences.employerTypes.filter(function (employerType) {
	              return employerType.isSelected;
	            }).map(function (employerType) {
	              return employerType.id;
	            });
	            _context2.next = 3;
	            return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	              return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                  switch (_context.prev = _context.next) {
	                    case 0:
	                      return _context.abrupt('return', CandidatePreferencesApi.updateCandidatePreferences($scope.candidate.id, {
	                        specialtiesByCategory: [{ id: 2, specialties: employerTypes }]
	                      }));
	
	                    case 1:
	                    case 'end':
	                      return _context.stop();
	                  }
	                }
	              }, _callee, undefined);
	            })));
	
	          case 3:
	            $scope.candidate.legalEmployerTypes = $scope.editPreferences.employerTypes;
	            $scope.resetEditPreferences();
	            $scope.$apply();
	            logger.notify('success', 'Successfully Updated employer types');
	
	          case 7:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  $scope.updateContracts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
	    var contracts;
	    return regeneratorRuntime.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            contracts = $scope.editPreferences.contracts.filter(function (employerType) {
	              return employerType.isSelected;
	            }).map(function (employerType) {
	              return employerType.id;
	            });
	            _context4.next = 3;
	            return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	              return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                  switch (_context3.prev = _context3.next) {
	                    case 0:
	                      return _context3.abrupt('return', CandidatePreferencesApi.updateCandidatePreferences($scope.candidate.id, {
	                        preferredContractTypes: contracts
	                      }));
	
	                    case 1:
	                    case 'end':
	                      return _context3.stop();
	                  }
	                }
	              }, _callee3, undefined);
	            })));
	
	          case 3:
	            $scope.candidate.preferredContractTypes = $scope.editPreferences.contracts;
	            $scope.resetEditPreferences();
	            $scope.$apply();
	            logger.notify('success', 'Successfully Updated contracts');
	
	          case 7:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  $scope.updateOccupations = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
	    var occupations;
	    return regeneratorRuntime.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            occupations = $scope.editPreferences.occupations.filter(function (employerType) {
	              return employerType.isSelected;
	            }).map(function (employerType) {
	              return employerType.id;
	            });
	            _context6.next = 3;
	            return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	              return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                while (1) {
	                  switch (_context5.prev = _context5.next) {
	                    case 0:
	                      return _context5.abrupt('return', CandidatePreferencesApi.updateCandidatePreferences($scope.candidate.id, {
	                        occupations: occupations
	                      }));
	
	                    case 1:
	                    case 'end':
	                      return _context5.stop();
	                  }
	                }
	              }, _callee5, undefined);
	            })));
	
	          case 3:
	            $scope.candidate.occupations = $scope.editPreferences.occupations;
	            $scope.resetEditPreferences();
	            $scope.$apply();
	            logger.notify('success', 'Successfully Updated occupations');
	
	          case 7:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  $scope.unHideEmployer = function () {
	    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(candidateHidden) {
	      return regeneratorRuntime.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              _context7.next = 2;
	              return CandidateProfileApi.unHideEmployer(candidateHidden.userId, candidateHidden.employerId);
	
	            case 2:
	              logger.notify('success', 'Successfully unhidden employer: ' + candidateHidden.employer.name);
	              candidateHidden.hide = false;
	              $scope.$apply();
	
	            case 5:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, undefined);
	    }));
	
	    return function (_x) {
	      return _ref7.apply(this, arguments);
	    };
	  }();
	
	  $scope.updateEmailPause = function () {
	    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(emailType) {
	      return regeneratorRuntime.wrap(function _callee10$(_context10) {
	        while (1) {
	          switch (_context10.prev = _context10.next) {
	            case 0:
	              if (!($scope.candidate && $scope.candidate.emailSubscriptions && $scope.candidate.emailSubscriptions[emailType] && $scope.candidate.emailSubscriptions[emailType].paused)) {
	                _context10.next = 6;
	                break;
	              }
	
	              _context10.next = 3;
	              return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
	                return regeneratorRuntime.wrap(function _callee8$(_context8) {
	                  while (1) {
	                    switch (_context8.prev = _context8.next) {
	                      case 0:
	                        return _context8.abrupt('return', CandidateProfileApi.pauseEmail($scope.candidate.id, emailType));
	
	                      case 1:
	                      case 'end':
	                        return _context8.stop();
	                    }
	                  }
	                }, _callee8, undefined);
	              })));
	
	            case 3:
	              logger.notify('success', 'Successfully paused email subscription');
	              _context10.next = 9;
	              break;
	
	            case 6:
	              _context10.next = 8;
	              return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
	                return regeneratorRuntime.wrap(function _callee9$(_context9) {
	                  while (1) {
	                    switch (_context9.prev = _context9.next) {
	                      case 0:
	                        return _context9.abrupt('return', CandidateProfileApi.unpauseEmail($scope.candidate.id, emailType));
	
	                      case 1:
	                      case 'end':
	                        return _context9.stop();
	                    }
	                  }
	                }, _callee9, undefined);
	              })));
	
	            case 8:
	              logger.notify('success', 'Successfully un paused email subscription');
	
	            case 9:
	
	              $scope.$applyAsync();
	
	            case 10:
	            case 'end':
	              return _context10.stop();
	          }
	        }
	      }, _callee10, undefined);
	    }));
	
	    return function (_x2) {
	      return _ref8.apply(this, arguments);
	    };
	  }();
	
	  $scope.updateEmailSubscription = function () {
	    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(emailType) {
	      return regeneratorRuntime.wrap(function _callee13$(_context13) {
	        while (1) {
	          switch (_context13.prev = _context13.next) {
	            case 0:
	              if (!($scope.candidate && $scope.candidate.emailSubscriptions && $scope.candidate.emailSubscriptions[emailType] && $scope.candidate.emailSubscriptions[emailType].stopped)) {
	                _context13.next = 6;
	                break;
	              }
	
	              _context13.next = 3;
	              return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
	                return regeneratorRuntime.wrap(function _callee11$(_context11) {
	                  while (1) {
	                    switch (_context11.prev = _context11.next) {
	                      case 0:
	                        return _context11.abrupt('return', CandidateProfileApi.subscribe($scope.candidate.id, emailType));
	
	                      case 1:
	                      case 'end':
	                        return _context11.stop();
	                    }
	                  }
	                }, _callee11, undefined);
	              })));
	
	            case 3:
	              logger.notify('success', 'Successfully subscribed to email ping');
	              _context13.next = 9;
	              break;
	
	            case 6:
	              _context13.next = 8;
	              return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
	                return regeneratorRuntime.wrap(function _callee12$(_context12) {
	                  while (1) {
	                    switch (_context12.prev = _context12.next) {
	                      case 0:
	                        return _context12.abrupt('return', CandidateProfileApi.unsubscribe($scope.candidate.id, emailType));
	
	                      case 1:
	                      case 'end':
	                        return _context12.stop();
	                    }
	                  }
	                }, _callee12, undefined);
	              })));
	
	            case 8:
	              logger.notify('success', 'Successfully unsubscribed to email ping');
	
	            case 9:
	
	              $scope.$applyAsync();
	
	            case 10:
	            case 'end':
	              return _context13.stop();
	          }
	        }
	      }, _callee13, undefined);
	    }));
	
	    return function (_x3) {
	      return _ref11.apply(this, arguments);
	    };
	  }();
	
	  $scope.openLocationModal = function (selectedLocations, event) {
	    event.preventDefault();
	    event.stopPropagation();
	
	    var modalInstance = $uibModal.open({
	      templateUrl: 'locations-modal.html',
	      controller: 'LocationsModalController',
	      controllerAs: 'ctrl',
	      resolve: {
	        locationList: function locationList() {
	          return $scope.locations.filter(function (_ref14) {
	            var supported = _ref14.supported;
	            return supported;
	          });
	        },
	        selectedLocations: function selectedLocations() {
	          return $scope.candidate.preferredLocations;
	        },
	        limit: function limit() {
	          return 0;
	        },
	        locationModalHeading: function locationModalHeading() {
	          return false;
	        },
	        displayNextButton: function displayNextButton() {
	          return false;
	        }
	      }
	    });
	    modalInstance.result.then(function () {
	      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(selectedLocations) {
	        return regeneratorRuntime.wrap(function _callee15$(_context15) {
	          while (1) {
	            switch (_context15.prev = _context15.next) {
	              case 0:
	                $scope.candidate.preferredLocations = angular.copy(selectedLocations);
	                _context15.next = 3;
	                return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
	                  return regeneratorRuntime.wrap(function _callee14$(_context14) {
	                    while (1) {
	                      switch (_context14.prev = _context14.next) {
	                        case 0:
	                          return _context14.abrupt('return', CandidatePreferencesApi.updateCandidatePreferences($scope.candidate.id, {
	                            preferredLocations: selectedLocations.map(function (location) {
	                              return location.id;
	                            })
	                          }));
	
	                        case 1:
	                        case 'end':
	                          return _context14.stop();
	                      }
	                    }
	                  }, _callee14, undefined);
	                })));
	
	              case 3:
	                logger.notify('success', 'Successfully updated preferred locations');
	
	              case 4:
	              case 'end':
	                return _context15.stop();
	            }
	          }
	        }, _callee15, undefined);
	      }));
	
	      return function (_x4) {
	        return _ref15.apply(this, arguments);
	      };
	    }(), function () {});
	  };
	
	  $scope.initializePreferencesData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
	    var _ref18, data;
	
	    return regeneratorRuntime.wrap(function _callee16$(_context16) {
	      while (1) {
	        switch (_context16.prev = _context16.next) {
	          case 0:
	            if ($scope.preferredLocation) {
	              _context16.next = 6;
	              break;
	            }
	
	            _context16.next = 3;
	            return CandidateProfileApi.getUserProfile($scope.candidate.id, {
	              include: ['preferredLocations']
	            });
	
	          case 3:
	            _ref18 = _context16.sent;
	            data = _ref18.data;
	
	            $scope.candidate.preferredLocations = data ? data.preferredLocations : [];
	
	          case 6:
	
	            Promise.all([CandidateProfileApi.getEmailSubscriptions($scope.candidate.id), CandidateProfileApi.getUserFollowEmployers($scope.candidate.id), CandidateProfileApi.getUserHiddenEmployers($scope.candidate.id)]).then(function (result) {
	              // eslint-disable-next-line unicorn/no-reduce
	              $scope.candidate.emailSubscriptions = result[0].data.reduce(function (accumulator, current) {
	                accumulator[current.emailId] = current;
	                return accumulator;
	              }, {});
	              $scope.candidate.candidateFollow = result[1].data;
	              $scope.candidate.candidateHidden = result[2].data;
	              $scope.$apply();
	            });
	
	          case 7:
	          case 'end':
	            return _context16.stop();
	        }
	      }
	    }, _callee16, undefined);
	  }));
	
	  $scope.initializePreferencesData();
	};
	
	exports.PreferencesController = PreferencesController;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _preferences = __webpack_require__(559);
	
	var candidatePreferencesDirective = function candidatePreferencesDirective() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      candidate: '=',
	      locations: '=',
	      practiceAreas: '=',
	      contracts: '=',
	      occupations: '=',
	      employerTypes: '=',
	      preferredLocation: '='
	    },
	    controller: _preferences.PreferencesController,
	    template: __webpack_require__(436)
	  };
	};
	
	angular.module('app.directives').directive('candidatePreferencesDirective', candidatePreferencesDirective);

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProfileController = undefined;
	
	var _loadingOverlay = __webpack_require__(20);
	
	var _locationFlagAndColor = __webpack_require__(192);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/* eslint-disable camelcase */
	var ProfileController = function ProfileController($scope, $uibModal, logger, CandidatePreferencesApi, CandidateProfileApi, $sce, $window) {
	  $scope.getLocationColorAndFlag = _locationFlagAndColor.getLocationColorAndFlag;
	  $scope.openPracticeModal = function (selectedPractice, event) {
	    event.preventDefault();
	    event.stopPropagation();
	    console.debug('$scope.openPracticeModal', $scope);
	    var candidatePractices = $scope.candidate.legalPracticeAreas.map(function (candidatePractice) {
	      return $scope.practiceAreas.find(function (practice) {
	        return practice.id === candidatePractice.id;
	      });
	    });
	    var modalInstance = $uibModal.open({
	      templateUrl: 'practice-area-modal.html',
	      controller: 'PracticeAreaController',
	      controllerAs: 'ctrl',
	      resolve: {
	        practiceAreaList: function practiceAreaList() {
	          console.log('$scope.practiceAreas', $scope.practiceAreas);
	          return $scope.practiceAreas.filter(function (_ref) {
	            var parentId = _ref.parentId;
	            return parentId === null;
	          });
	        },
	        selectedPractice: function selectedPractice() {
	          return candidatePractices;
	        },
	        limit: function limit() {
	          return 20;
	        },
	        isAdminProfile: function isAdminProfile() {
	          return false;
	        },
	        displayNextButton: function displayNextButton() {
	          return false;
	        }
	      }
	    });
	    modalInstance.result.then(function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(selectPractices) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                $scope.candidate.legalPracticeAreas = angular.copy(selectPractices);
	                _context2.next = 3;
	                return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                  return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          return _context.abrupt('return', CandidatePreferencesApi.updateCandidatePreferences($scope.candidate.id, {
	                            specialtiesByCategory: [{
	                              id: 1,
	                              specialties: selectPractices.map(function (practice) {
	                                return practice.id;
	                              })
	                            }]
	                          }));
	
	                        case 1:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, undefined);
	                })));
	
	              case 3:
	                logger.notify('success', 'Successfully updated preferred practice areas');
	
	              case 4:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, undefined);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }(), function () {});
	  };
	
	  $scope.linkedInUrlPrefix = '';
	  var linkedInPrefixRequired = /^(https:\/\/|http:\/\/)/;
	
	  $scope.initializeProfileController = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	    return regeneratorRuntime.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            if ($scope.candidate.linkedinUrl && $scope.candidate.linkedinUrl.match(linkedInPrefixRequired) === null) $scope.linkedInUrlPrefix = '//';
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  $scope.editEmailAddress = function () {
	    $scope.editUserData.email = $scope.candidate.user.email;
	    $scope.editEmail = true;
	  };
	
	  $scope.updateEmail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
	    return regeneratorRuntime.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _context4.next = 2;
	            return CandidateProfileApi.updateUserData($scope.candidate.id, {
	              email: $scope.editUserData.email
	            });
	
	          case 2:
	            $scope.candidate.user.email = $scope.editUserData.email;
	            $scope.editEmail = false;
	            logger.notify('success', 'Email address Updated.');
	            $scope.$apply();
	
	          case 6:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  $scope.updatePhoneNumber = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	    var phoneRegex;
	    return regeneratorRuntime.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            phoneRegex = /^\+?\d{1,20}$/;
	
	            if (!$scope.editUserData.phone.match(phoneRegex)) {
	              _context5.next = 10;
	              break;
	            }
	
	            _context5.next = 4;
	            return CandidateProfileApi.updateUserData($scope.candidate.id, {
	              phone: $scope.editUserData.phone
	            });
	
	          case 4:
	            $scope.candidate.user.phone = $scope.editUserData.phone;
	            $scope.editPhone = false;
	            logger.notify('success', 'Phone number Updated.');
	            $scope.$apply();
	            _context5.next = 11;
	            break;
	
	          case 10:
	            logger.notify('error', 'Please enter a valid phone number (without spaces)');
	
	          case 11:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, undefined);
	  }));
	
	  $scope.editPhoneNumber = function () {
	    $scope.editUserData.phone = $scope.candidate.user.phone;
	    $scope.editPhone = true;
	  };
	
	  $scope.cancelEditPhone = function () {
	    $scope.editPhone = false;
	  };
	
	  $scope.editLinkedInUrlMethod = function () {
	    $scope.editUserData.linkedInUrl = $scope.candidate.linkedinUrl;
	    $scope.editLinkedInUrl = true;
	  };
	
	  $scope.updateLinkedInUrl = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
	    var linkedInProfileRegex;
	    return regeneratorRuntime.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            linkedInProfileRegex = /(https?)?:?(\/\/)?((w{3}||\w\w)\.)?linkedin.com(\w+:{0,1}\w*@)?(\S+)(:(\d)+)?(\/|\/([\w!#%&+./:=?@-]))?/g;
	
	            if (!($scope.editUserData.linkedInUrl.match(linkedInProfileRegex) === null)) {
	              _context6.next = 5;
	              break;
	            }
	
	            logger.notify('error', 'Please enter valid linkedIn URL.');
	            _context6.next = 12;
	            break;
	
	          case 5:
	            _context6.next = 7;
	            return CandidateProfileApi.updateProfileData($scope.candidate.id, {
	              linkedinUrl: $scope.editUserData.linkedInUrl
	            });
	
	          case 7:
	            $scope.candidate.linkedinUrl = $scope.editUserData.linkedInUrl;
	            if ($scope.candidate.linkedinUrl.match(linkedInPrefixRequired) === null) $scope.linkedInUrlPrefix = '//';else $scope.linkedInUrlPrefix = '';
	            logger.notify('success', 'LinkedIn URL Updated.');
	            $scope.editLinkedInUrl = false;
	            $scope.$apply();
	
	          case 12:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, undefined);
	  }));
	
	  $scope.closeEditLinkedIn = function () {
	    $scope.editLinkedInUrl = false;
	  };
	
	  $scope.editUserData = {
	    email: '',
	    phone: '',
	    linkedInUrl: ''
	  };
	
	  $scope.initializeProfileController();
	
	  // Resumes: start
	  $scope.editResumeName = function () {
	    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(resume) {
	      var oldName, splitByDot, oldExtension, newNameHasExtension, newName, payload;
	      return regeneratorRuntime.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              if (!(resume.name !== resume.newResumeName)) {
	                _context7.next = 12;
	                break;
	              }
	
	              oldName = resume.name;
	              splitByDot = oldName.split('.');
	              oldExtension = splitByDot && splitByDot.length > 0 ? splitByDot[splitByDot.length - 1] : '';
	              newNameHasExtension = resume.newResumeName.endsWith(oldExtension);
	              newName = newNameHasExtension ? resume.newResumeName : resume.newResumeName + '.' + oldExtension;
	              payload = { oldName: oldName, newName: newName };
	              _context7.next = 9;
	              return CandidateProfileApi.updateUserResumeName($scope.candidate.id, payload);
	
	            case 9:
	              resume.name = newName;
	              logger.notify('success', 'Resume name updated successfully');
	              $scope.$apply();
	
	            case 12:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, undefined);
	    }));
	
	    return function (_x2) {
	      return _ref8.apply(this, arguments);
	    };
	  }();
	
	  $scope.downloadResume = function () {
	    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(resume) {
	      var _ref10, file;
	
	      return regeneratorRuntime.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              _context8.next = 2;
	              return CandidateProfileApi.getResume(resume.id);
	
	            case 2:
	              _ref10 = _context8.sent;
	              file = _ref10.data;
	
	              console.debug('downloadResume: resume name is', resume.name);
	              if (file.statusCode === 404) {
	                logger.notify('error', file.message);
	              } else saveByteArray(resume.name, file.data);
	
	            case 6:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, undefined);
	    }));
	
	    return function (_x3) {
	      return _ref9.apply(this, arguments);
	    };
	  }();
	
	  var saveByteArray = function saveByteArray(reportName, byte) {
	    var arrayBufferView = new Uint8Array(byte);
	    var extension = reportName.split('.').pop();
	    var type = extension === 'pdf' ? 'application/pdf' : 'application/msword';
	    console.debug('type is', type);
	
	    var blob = new Blob([arrayBufferView], {
	      type: type + ';base64'
	    });
	    var urlCreator = $window.URL || $window.webkitURL;
	    var resumeUrl = urlCreator.createObjectURL(blob);
	
	    // eslint-disable-next-line angular/document-service
	    var a = document.createElement('a');
	    // eslint-disable-next-line angular/document-service
	    document.body.append(a);
	    a.style = 'display: none';
	    a.href = $sce.trustAsResourceUrl(resumeUrl);
	    a.download = reportName;
	    a.click();
	  };
	
	  $scope.deleteResume = function (resume) {
	    try {
	      analytics.track('Profile - Deleting CV', {
	        cv_name: resume.name,
	        lawyer_id: $scope.candidate.id
	      });
	    } catch (error) {
	      console.error('Profile', error);
	    }
	
	    var modalInstance;
	    modalInstance = $uibModal.open({
	      templateUrl: 'deleteCVModal.html',
	      controller: 'deleteMatterModalCtrl',
	      resolve: {
	        data: function data() {
	          return $scope.candidate;
	        }
	      }
	    });
	
	    modalInstance.result.then(function () {
	      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(deleteResume) {
	        var _ref12, updatedResumes;
	
	        return regeneratorRuntime.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                if (!deleteResume) {
	                  _context9.next = 7;
	                  break;
	                }
	
	                _context9.next = 3;
	                return CandidateProfileApi.deleteUserResume($scope.candidate.id, resume.id);
	
	              case 3:
	                _ref12 = _context9.sent;
	                updatedResumes = _ref12.data;
	
	                $scope.candidate.resumes = updatedResumes.filter(function (resume) {
	                  return resume.isDeleted === false;
	                });
	                logger.notify('success', 'Resume deleted successfully');
	
	              case 7:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, undefined);
	      }));
	
	      return function (_x4) {
	        return _ref11.apply(this, arguments);
	      };
	    }(), function () {});
	  };
	
	  // $scope.CVandPhoneCheck = function(){
	  //   if (($scope.loggedInLawyer.user.user_resumes.length > 0) && $scope.loggedInLawyer.lawyer.lawyer_phone) {
	  //     $scope.loggedInLawyer.lawyer.lexStepRequired = false;
	  //   } else {
	  //     $scope.loggedInLawyer.lawyer.lexStepRequired = true;
	  //   }
	  // }
	
	  $scope.uploadResumeButton = function () {
	    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(file) {
	      var formData, _ref14, newResume;
	
	      return regeneratorRuntime.wrap(function _callee10$(_context10) {
	        while (1) {
	          switch (_context10.prev = _context10.next) {
	            case 0:
	              formData = new FormData();
	
	              formData.append('file', file[0]);
	              _context10.next = 4;
	              return CandidateProfileApi.uploadResume($scope.candidate.id, formData);
	
	            case 4:
	              _ref14 = _context10.sent;
	              newResume = _ref14.data;
	
	              $scope.candidate.resumes = newResume;
	              $scope.$apply();
	              logger.notify('success', 'Resume updated successfully');
	
	            case 9:
	            case 'end':
	              return _context10.stop();
	          }
	        }
	      }, _callee10, undefined);
	    }));
	
	    return function (_x5) {
	      return _ref13.apply(this, arguments);
	    };
	  }();
	  // Resumes: End
	};
	
	exports.ProfileController = ProfileController;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _profile = __webpack_require__(561);
	
	var candidateProfileDirective = function candidateProfileDirective() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      candidate: '=',
	      practiceAreas: '=',
	      locations: '=',
	      contracts: '=',
	      occupations: '='
	    },
	    controller: _profile.ProfileController,
	    template: __webpack_require__(437)
	  };
	};
	
	angular.module('app.directives').directive('candidateProfileDirective', candidateProfileDirective);

/***/ }),
/* 563 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.api').factory('RecommendationsApi', ['api', function RecommendationsApi(api) {
	  var _this = this;
	
	  var recommendationsApi = {
	    unHideCandidateEmployer: function unHideCandidateEmployer(id, payload) {
	      return api.put('users/' + id + '/hidden', payload);
	    },
	    unHideCandidatePosition: function unHideCandidatePosition(id, payload) {
	      return api.put('users/' + id + '/positions/hidden', payload);
	    },
	    getCandidateRecommendations: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        var result;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return api.get('recommendations/candidate/' + id + '/admin', {
	                  params: options
	                });
	
	              case 2:
	                result = _context.sent;
	                return _context.abrupt('return', result);
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function getCandidateRecommendations(_x2) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getCandidateRecommendations;
	    }()
	  };
	  return recommendationsApi;
	}]);

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.recommendationsController = undefined;
	
	var _formatPqe = __webpack_require__(55);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var recommendationsController = function recommendationsController($scope, usSpinnerService, RecommendationsApi, locationsGenericService, practiceAreaService, CandidateProfileApi, socket, $timeout) {
	  socket.on('CANDIDATE_RECOMMENDATION_GENERATED', function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(candidateId) {
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!($scope.candidate.id === candidateId)) {
	                          _context.next = 3;
	                          break;
	                        }
	
	                        _context.next = 3;
	                        return $scope.getRecommendation();
	
	                      case 3:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, undefined);
	              })), 1500);
	
	            case 1:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }());
	
	  $scope.recommendationsPageChange = _.debounce(function () {
	    console.debug('recommendations page change');
	    options.sortBy = $scope.sortBy;
	    options.limit = $scope.paginationOptions.selectedLimit;
	    options.page = $scope.pagination.currentPage;
	    options.positionTypes = $scope.positionTypes;
	    $scope.getRecommendation();
	  }, 20);
	
	  $scope.initializeRecommendations = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	    var positionTypesLower, isRegularCustomTab, _ref4, data;
	
	    return regeneratorRuntime.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            // $scope.recommendationsLoading = true
	            $scope.sliderOptions = {
	              experience: {
	                round: 1,
	                from: -2,
	                to: 11,
	                step: 0.5,
	                dimension: '+ years',
	                scale: [-2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '11+']
	              },
	              selectivity: {
	                round: 1,
	                from: 1,
	                to: 6,
	                step: 1,
	                dimension: '$',
	                scale: ['$', '$$', '$$$', '$$$$', '$$$$$', '$$$$$$']
	              }
	
	              // eslint-disable-next-line no-negated-condition
	            };if (!$scope.sortBy) {
	              console.debug('$scope.positionTypes', $scope.positionTypes);
	              positionTypesLower = new Set($scope.positionTypes.map(function (x) {
	                return x.toLowerCase();
	              }));
	              isRegularCustomTab = positionTypesLower.has('regular') && positionTypesLower.has('custom');
	
	              $scope.sortBy = isRegularCustomTab ? 'recency' : 'alphabetical';
	            } else {
	              console.debug('not touching $scope.sortBy. current value is', $scope.sortBy);
	            }
	
	            $scope.uncategorizedSelectivity = true;
	
	            $scope.candidatePqe = (0, _formatPqe.formatQualificationDateToPqe)($scope.candidate.lawProfile.qualificationDate);
	
	            $scope.candidateMinPqe = $scope.candidatePqe <= -1 ? -2 : $scope.candidatePqe - 1;
	            $scope.candidateMaxPqe = $scope.candidatePqe >= 10 ? 11 : $scope.candidatePqe + 1;
	
	            $scope.sliderFilter = {
	              selectivity: '1;6',
	              experience: $scope.candidateMinPqe + ';' + $scope.candidateMaxPqe
	            };
	
	            $scope.paginationOptions = {
	              limitOptions: [10, 25, 50, 100],
	              selectedLimit: 50
	            };
	
	            $scope.pagination = {
	              currentPage: 1,
	              totalItems: 0
	            };
	
	            if ($scope.preferredLocation) {
	              _context3.next = 15;
	              break;
	            }
	
	            _context3.next = 12;
	            return CandidateProfileApi.getUserProfile($scope.candidate.id, {
	              include: ['preferredLocations']
	            });
	
	          case 12:
	            _ref4 = _context3.sent;
	            data = _ref4.data;
	
	
	            $scope.candidate.preferredLocations = data.preferredLocations;
	
	          case 15:
	
	            $scope.filterData = {
	              regionHierarchialListWithEuropeOnTop: locationsGenericService.makeCandidateLocationsHierarchy($scope.candidate.preferredLocations, $scope.locations),
	              locations: angular.copy($scope.candidate.preferredLocations),
	              candidateSpecialties: practiceAreaService.makeCandidatePracticeAreasHierarchy($scope.candidate.category, $scope.legalPracticeAreas),
	              employerTypes: $scope.employerTypes.map(function (employerType) {
	                return Object.assign({ ticked: true }, employerType);
	              }),
	              contracts: $scope.contracts.map(function (contract) {
	                return Object.assign({ ticked: true }, contract);
	              }),
	              occupations: $scope.occupations.map(function (occupation) {
	                return Object.assign({ ticked: true }, occupation);
	              })
	            };
	
	            $scope.recommendationsPageChange($scope.sortBy);
	
	          case 17:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  $scope.initializeRecommendations();
	
	  var refreshRecommendations = function refreshRecommendations(event, tab) {
	    console.debug('recommendationsController.refreshRecommendations', tab);
	    // $scope.recommendationsLoading = true
	    $scope.recommendations = [];
	    var isRecommendationsTab = tab === 'recommendations/showRegularCustom' || tab === 'recommendations/showSpecConnect';
	    if (isRecommendationsTab) {
	      switch (tab) {
	        case 'recommendations/showRegularCustom':
	          $scope.sortBy = 'recency';
	          break;
	        case 'recommendations/showSpecConnect':
	          $scope.sortBy = 'alphabetical';
	          break;
	        default:
	          break;
	      }
	
	      $scope.recommendationsPageChange($scope.sortBy);
	    } else {
	      console.log('not recommendations tab');
	    }
	  };
	
	  $scope.$on('tab:change', refreshRecommendations);
	  $scope.$on('candidate:updated', refreshRecommendations);
	
	  $scope.applySort = function () {
	    options.sortBy = $scope.sortBy;
	    $scope.recommendationsPageChange($scope.sortBy);
	  };
	
	  var options = {
	    limit: $scope.paginationOptions.selectedLimit,
	    page: $scope.pagination.currentPage,
	    positionTypes: $scope.positionTypes,
	    minPqe: $scope.candidateMinPqe,
	    maxPqe: $scope.candidateMaxPqe
	  };
	  $scope.getRecommendation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
	    var _ref6, recommendations;
	
	    return regeneratorRuntime.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            usSpinnerService.spin('spinner-recommendations');
	            console.debug('$scope.getRecommendation START', options);
	            _context4.next = 4;
	            return RecommendationsApi.getCandidateRecommendations($scope.candidate.id, options);
	
	          case 4:
	            _ref6 = _context4.sent;
	            recommendations = _ref6.data;
	
	            console.debug('getRecommendations::recommendations', recommendations);
	
	            $scope.recommendations = recommendations.positions;
	            if ($scope.sortBy === 'alphabetical') {
	              $scope.recommendations = _.sortBy($scope.recommendations, function (recommendation) {
	                return recommendation.employer.name.toLowerCase();
	              });
	            }
	
	            $scope.count = recommendations.positionsCount.totalPositions;
	            $scope.pagination.totalItems = recommendations.positionsCount.totalPositions;
	            formatRecommendations($scope.recommendations);
	            usSpinnerService.stop('spinner-recommendations');
	            console.debug('$scope.getRecommendation STOP');
	            $scope.$applyAsync();
	
	          case 15:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, undefined);
	  }));
	
	  var formatRecommendations = function formatRecommendations(recommendations) {
	    recommendations.forEach(function (recommendation) {
	      if (recommendation.employer.logo) recommendation.employer.logoSrc = ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/employers/' + recommendation.employerId + '/logo/' + recommendation.employer.logo;else recommendation.employer.logoSrc = 'images/firm-logo-default.jpg';
	      recommendation.locations = recommendation.locations.map(function (location) {
	        return $scope.locations.find(function (loc) {
	          return location.id === loc.id;
	        });
	      });
	      recommendation.legalPracticeAreas = recommendation.practiceAreas.map(function (practice) {
	        return $scope.legalPracticeAreas.find(function (legalPractice) {
	          return practice.id === legalPractice.id;
	        });
	      });
	      recommendation.contract = $scope.contracts.find(function (contract) {
	        return contract.id === recommendation.contractTypeId;
	      });
	      recommendation.occupation = $scope.occupations.find(function (occupation) {
	        return occupation.id === recommendation.occupationId;
	      });
	    });
	  };
	
	  $scope.expandPosition = function (position) {
	    position.expanded = !position.expanded;
	  };
	
	  $scope.onChangePracticeArea = function (event, selectedPracticeArea) {
	    options.practiceAreas = selectedPracticeArea.map(function (practice) {
	      return practice.id;
	    });
	    $scope.getRecommendation();
	  };
	
	  $scope.onChangeLocation = function (event, selectedLocations) {
	    options.locations = selectedLocations.map(function (location) {
	      return location.id;
	    });
	    $scope.getRecommendation();
	  };
	
	  $scope.applyFilter = function (type) {
	    switch (type) {
	      case 'experience':
	        // eslint-disable-next-line no-case-declarations
	        var experience = $scope.sliderFilter.experience.split(';');
	        options.minPqe = Number(experience[0]);
	        options.maxPqe = Number(experience[1]);
	        $scope.getRecommendation();
	        break;
	      case 'selectivity':
	        // eslint-disable-next-line no-case-declarations
	        var selectivity = $scope.sliderFilter.selectivity.split(';');
	        options.minSelectivity = Number(selectivity[0]);
	        options.maxSelectivity = Number(selectivity[1]);
	        options.uncategorizedSelectivity = $scope.uncategorizedSelectivity;
	        $scope.getRecommendation();
	        break;
	      case 'employerType':
	        options.employerTypes = $scope.filterData.employerTypes.filter(function (employerType) {
	          return employerType.ticked;
	        }).map(function (employerType) {
	          return employerType.id;
	        });
	        $scope.getRecommendation();
	        break;
	      case 'occupation':
	        options.occupations = $scope.filterData.occupations.filter(function (occupation) {
	          return occupation.ticked;
	        }).map(function (occupation) {
	          return occupation.id;
	        });
	        $scope.getRecommendation();
	        break;
	      case 'contract':
	        options.contractTypes = $scope.filterData.contracts.filter(function (contract) {
	          return contract.ticked;
	        }).map(function (contract) {
	          return contract.id;
	        });
	        $scope.getRecommendation();
	        break;
	      default:
	        break;
	    }
	  };
	
	  $scope.unHidePosition = function () {
	    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(position) {
	      var payload, _payload;
	
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              if (!position.positionHidden) {
	                _context5.next = 5;
	                break;
	              }
	
	              payload = {
	                positionIds: [position.id],
	                hide: false,
	                reason: ' '
	              };
	              _context5.next = 4;
	              return RecommendationsApi.unHideCandidatePosition($scope.candidate.id, payload);
	
	            case 4:
	              position.positionHidden = false;
	
	            case 5:
	              if (!position.employerHidden) {
	                _context5.next = 10;
	                break;
	              }
	
	              _payload = {
	                employerIds: [position.employerId],
	                updateValue: false
	              };
	              _context5.next = 9;
	              return RecommendationsApi.unHideCandidateEmployer($scope.candidate.id, _payload);
	
	            case 9:
	              position.employerHidden = false;
	
	            case 10:
	
	              $scope.$apply();
	
	            case 11:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, undefined);
	    }));
	
	    return function (_x2) {
	      return _ref7.apply(this, arguments);
	    };
	  }();
	
	  $scope.hideRecommendation = function (position, type) {
	    position[type + 'Hidden'] = true;
	    $scope.$apply();
	  };
	};
	
	exports.recommendationsController = recommendationsController;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _recommendationsCtrl = __webpack_require__(564);
	
	var recommendationsDirective = function recommendationsDirective() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      count: '=',
	      positionTypes: '=',
	      candidate: '=',
	      legalPracticeAreas: '=',
	      locations: '=',
	      contracts: '=',
	      occupations: '=',
	      employerTypes: '=',
	      user: '=',
	      preferredLocation: '='
	    },
	    controller: _recommendationsCtrl.recommendationsController,
	    template: __webpack_require__(438)
	  };
	};
	
	angular.module('app.directives').directive('recommendationsDirective', recommendationsDirective);
	
	__webpack_require__(563);

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _common = __webpack_require__(33);
	
	(function () {
	  angular.module('app.ui.form.ctrls').controller('ResetPassCtrl', ['$http', '$log', '$location', 'logger', '$scope', '$modal', 'sharedProperties', '$cookies', '$route', function ($http, $log, $location, logger, $scope, $modal, sharedProperties, $cookies, $route) {
	    $scope.notify = function (type, message) {
	      switch (type) {
	        case 'info':
	          logger.log("Heads up! This alert needs your attention, but it's not super important.");
	          break;
	        case 'success':
	          logger.logSuccess(message);
	          break;
	        case 'warning':
	          logger.logWarning("Warning! Best check yo self, you're not looking too good.");
	          break;
	        case 'error':
	          logger.logError(message);
	      }
	    };
	
	    var passwordToken = $route.current.params.token;
	    $scope.loggedInLawyer = {
	      first_Name: $cookies.firstName
	    };
	    $scope.showClass = '';
	    $scope.hideDropDown = function () {
	      $scope.showClass = '';
	    };
	
	    $scope.showDropDown = function () {
	      if ($scope.showClass === '') {
	        $scope.showClass = 'show';
	      } else {
	        $scope.showClass = '';
	      }
	    };
	
	    $scope.isAdmin = false;
	    $scope.notApproved = false;
	    $scope.newUser = false;
	    $scope.showProfileNavBar = false;
	    if ($location.url() === '/change-password') {
	      $http.post('/api/fetch-current-lawyer-refer', {
	        contentType: 'application/json'
	      }).then(function (_ref) {
	        var data = _ref.data,
	            status = _ref.status,
	            headers = _ref.headers,
	            config = _ref.config;
	
	        $scope.loggedInLawyer = data;
	        if ($scope.loggedInLawyer.user.refUserTypeUserTypeID === 1 || $scope.loggedInLawyer.user.refUserTypeUserTypeID === 7) {
	          $scope.isAdmin = true;
	          $scope.loggedInLawyer.user.first_Name = $cookies.firstName;
	        } else if ($scope.loggedInLawyer.user.refUserTypeUserTypeID === 2 && $scope.loggedInLawyer.lawyer.lawyer_Status !== 'Approved') {
	          if ($scope.loggedInLawyer.lawyer.lawyer_Status === 'Pending Approval' || $scope.loggedInLawyer.lawyer.lawyer_Status === 'NewUser') {
	            $scope.newUser = true;
	            $scope.notApproved = true;
	          } else if ($scope.loggedInLawyer.lawyer.lawyer_Status === 'locked') {
	            $scope.newUser = false;
	            $scope.notApproved = false;
	          } else {
	            $scope.notApproved = true;
	          }
	        } else {
	          $scope.showProfileNavBar = true;
	        }
	      });
	    }
	
	    this.userPass = '';
	    this.userConfirmPass = '';
	    this.userOldPass = '';
	    this.password = {
	      oldPassword: '',
	      newPassword: '',
	      confirmNewPassword: ''
	    };
	    this.updatePassword = function () {
	      var message;
	      if (this.password.newPassword === this.password.confirmNewPassword) {
	        if ($location.url() === '/change-password') {
	          $http.post('/api/change-password', {
	            userPass: this.password
	          }).then(function (_ref2) {
	            var data = _ref2.data,
	                status = _ref2.status,
	                headers = _ref2.headers,
	                config = _ref2.config;
	
	            var message;
	            message = 'Password updated successfully';
	            $scope.notify('success', message);
	            if ($scope.loggedInLawyer.user.refUserTypeUserTypeID === 1 || $scope.loggedInLawyer.user.refUserTypeUserTypeID === 7) {
	              $location.url('/admin/admin-listings');
	            } else if ($scope.loggedInLawyer.lawyer.lawyer_Status === 'Approved') {
	              $location.url('/user-profile');
	            } else {
	              $location.url('/profile');
	            }
	          }, function (error) {
	            $scope.notify('error', 'Your current password is incorrect.');
	          });
	        } else if ((0, _common.isResetPasswordPage)($location.url())) {
	          $http.post('/api/updatePassword', {
	            userPass: this.password,
	            passwordToken: passwordToken
	          }).then(function (_ref3) {
	            var data = _ref3.data,
	                status = _ref3.status,
	                headers = _ref3.headers,
	                config = _ref3.config;
	
	            var message;
	            message = 'Password updated successfully';
	            $scope.notify('success', message);
	            $location.url('/signin');
	          }, function (error) {});
	        }
	      } else {
	        message = 'Passwords do not match';
	        $scope.notify('error', message);
	      }
	    };
	
	    $scope.logOut = function () {
	      sharedProperties.logOut();
	    };
	  }]);
	})();

/***/ }),
/* 567 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('ChangePasswordController', ['ForgetPasswordApi', 'userService', 'logger', 'usSpinnerService', '$scope', function controller(ForgetPasswordApi, userService, logger, usSpinnerService, $scope) {
	    var _this = this;
	
	    var vm = this;
	    vm.hideDropDown = function () {
	      vm.showClass = '';
	    };
	
	    vm.showDropDown = function () {
	      if (vm.showClass === '') {
	        vm.showClass = 'show';
	      } else {
	        vm.showClass = '';
	      }
	    };
	
	    vm.changePassword = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var _ref2, status, message;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return ForgetPasswordApi.changePassword({
	                email: vm.user.email
	              });
	
	            case 3:
	              _ref2 = _context.sent;
	              status = _ref2.status;
	
	              vm.startSpin();
	              if (status === 201) {
	                vm.sentEmail = true;
	                message = 'Request sent. Please check your email inbox for\n              instructions on how to change your LexStep password.';
	
	                logger.notify('success', message);
	                vm.stopSpin();
	
	                $scope.$apply();
	              }
	              _context.next = 13;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context['catch'](0);
	
	              vm.stopSpin();
	              vm.notify('error', _context.t0.data.message);
	
	            case 13:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this, [[0, 9]]);
	    }));
	
	    vm.startSpin = function () {
	      usSpinnerService.spin('spinner-change-password');
	    };
	
	    vm.stopSpin = function () {
	      usSpinnerService.stop('spinner-change-password');
	    };
	
	    vm.initializePage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.next = 2;
	              return userService.getUser();
	
	            case 2:
	              vm.user = _context2.sent;
	
	            case 3:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this);
	    }));
	
	    vm.initializePage();
	  }]);
	})();

/***/ }),
/* 568 */
/***/ (function(module, exports) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  'use strict';
	
	  angular.module('app.chart.ctrls', []).controller('chartCtrl', ['$scope', function ($scope) {
	    $scope.easypiechart = {
	      percent: 65,
	      options: {
	        animate: {
	          duration: 1000,
	          enabled: true
	        },
	        barColor: '#31C0BE',
	        lineCap: 'round',
	        size: 180,
	        lineWidth: 5
	      }
	    };
	    $scope.easypiechart2 = {
	      percent: 35,
	      options: {
	        animate: {
	          duration: 1000,
	          enabled: true
	        },
	        barColor: '#66B5D7',
	        lineCap: 'round',
	        size: 180,
	        lineWidth: 10
	      }
	    };
	    $scope.easypiechart3 = {
	      percent: 68,
	      options: {
	        animate: {
	          duration: 1000,
	          enabled: true
	        },
	        barColor: '#60CD9B',
	        lineCap: 'square',
	        size: 180,
	        lineWidth: 20,
	        scaleLength: 0
	      }
	    };
	    $scope.gaugeChart1 = {
	      data: {
	        maxValue: 3000,
	        animationSpeed: 40,
	        val: 1375
	      },
	      options: {
	        lines: 12,
	        angle: 0,
	        lineWidth: 0.47,
	        pointer: {
	          length: 0.6,
	          strokeWidth: 0.03,
	          color: '#000000'
	        },
	        limitMax: 'false',
	        colorStart: '#A3C86D',
	        colorStop: '#A3C86D',
	        strokeColor: '#E0E0E0',
	        generateGradient: true,
	        percentColors: [[0.0, '#60CD9B'], [1.0, '#60CD9B']]
	      }
	    };
	    $scope.gaugeChart2 = {
	      data: {
	        maxValue: 3000,
	        animationSpeed: 45,
	        val: 1200
	      },
	      options: {
	        lines: 12,
	        angle: 0,
	        lineWidth: 0.47,
	        pointer: {
	          length: 0.6,
	          strokeWidth: 0.03,
	          color: '#464646'
	        },
	        limitMax: 'true',
	        colorStart: '#7ACBEE',
	        colorStop: '#7ACBEE',
	        strokeColor: '#F1F1F1',
	        generateGradient: true,
	        percentColors: [[0.0, '#66B5D7'], [1.0, '#66B5D7']]
	      }
	    };
	    return $scope.gaugeChart3 = {
	      data: {
	        maxValue: 3000,
	        animationSpeed: 50,
	        val: 1100
	      },
	      options: {
	        lines: 12,
	        angle: 0,
	        lineWidth: 0.47,
	        pointer: {
	          length: 0.6,
	          strokeWidth: 0.03,
	          color: '#464646'
	        },
	        limitMax: 'true',
	        colorStart: '#FF7857',
	        colorStop: '#FF7857',
	        strokeColor: '#F1F1F1',
	        generateGradient: true,
	        percentColors: [[0.0, '#E87352'], [1.0, '#E87352']]
	      }
	    };
	  }]).controller('morrisChartCtrl', ['$scope', function ($scope) {
	    $scope.mainData = [{
	      month: '2013-01',
	      xbox: 294000,
	      will: 136000,
	      playstation: 244000
	    }, {
	      month: '2013-02',
	      xbox: 228000,
	      will: 335000,
	      playstation: 127000
	    }, {
	      month: '2013-03',
	      xbox: 199000,
	      will: 159000,
	      playstation: 130000
	    }, {
	      month: '2013-04',
	      xbox: 174000,
	      will: 160000,
	      playstation: 82000
	    }, {
	      month: '2013-05',
	      xbox: 255000,
	      will: 318000,
	      playstation: 82000
	    }, {
	      month: '2013-06',
	      xbox: 298400,
	      will: 401800,
	      playstation: 98600
	    }, {
	      month: '2013-07',
	      xbox: 370000,
	      will: 225000,
	      playstation: 159000
	    }, {
	      month: '2013-08',
	      xbox: 376700,
	      will: 303600,
	      playstation: 130000
	    }, {
	      month: '2013-09',
	      xbox: 527800,
	      will: 301000,
	      playstation: 119400
	    }];
	    $scope.simpleData = [{
	      year: '2008',
	      value: 20
	    }, {
	      year: '2009',
	      value: 10
	    }, {
	      year: '2010',
	      value: 5
	    }, {
	      year: '2011',
	      value: 5
	    }, {
	      year: '2012',
	      value: 20
	    }, {
	      year: '2013',
	      value: 19
	    }];
	    $scope.comboData = [{
	      year: '2008',
	      a: 20,
	      b: 16,
	      c: 12
	    }, {
	      year: '2009',
	      a: 10,
	      b: 22,
	      c: 30
	    }, {
	      year: '2010',
	      a: 5,
	      b: 14,
	      c: 20
	    }, {
	      year: '2011',
	      a: 5,
	      b: 12,
	      c: 19
	    }, {
	      year: '2012',
	      a: 20,
	      b: 19,
	      c: 13
	    }, {
	      year: '2013',
	      a: 28,
	      b: 22,
	      c: 20
	    }];
	    return $scope.donutData = [{
	      label: "Download Sales",
	      value: 12
	    }, {
	      label: "In-Store Sales",
	      value: 30
	    }, {
	      label: "Mail-Order Sales",
	      value: 20
	    }, {
	      label: "Online Sales",
	      value: 19
	    }];
	  }]).controller('flotChartCtrl', ['$scope', function ($scope) {
	    var areaChart, barChart, lineChart1;
	    lineChart1 = {};
	    lineChart1.data1 = [[1, 15], [2, 20], [3, 14], [4, 10], [5, 10], [6, 20], [7, 28], [8, 26], [9, 22], [10, 23], [11, 24]];
	    lineChart1.data2 = [[1, 9], [2, 15], [3, 17], [4, 21], [5, 16], [6, 15], [7, 13], [8, 15], [9, 29], [10, 21], [11, 29]];
	    $scope.line1 = {};
	    $scope.line1.data = [{
	      data: lineChart1.data1,
	      label: 'Product A'
	    }, {
	      data: lineChart1.data2,
	      label: 'Product B',
	      lines: {
	        fill: false
	      }
	    }];
	    $scope.line1.options = {
	      series: {
	        lines: {
	          show: true,
	          fill: true,
	          fillColor: {
	            colors: [{
	              opacity: 0
	            }, {
	              opacity: 0.3
	            }]
	          }
	        },
	        points: {
	          show: true,
	          lineWidth: 2,
	          fill: true,
	          fillColor: "#ffffff",
	          symbol: "circle",
	          radius: 5
	        }
	      },
	      colors: ["#31C0BE", "#8170CA", "#E87352"],
	      tooltip: true,
	      tooltipOpts: {
	        defaultTheme: false
	      },
	      grid: {
	        hoverable: true,
	        clickable: true,
	        tickColor: "#f9f9f9",
	        borderWidth: 1,
	        borderColor: "#eeeeee"
	      },
	      xaxis: {
	        ticks: [[1, 'Jan.'], [2, 'Feb.'], [3, 'Mar.'], [4, 'Apr.'], [5, 'May'], [6, 'June'], [7, 'July'], [8, 'Aug.'], [9, 'Sept.'], [10, 'Oct.'], [11, 'Nov.'], [12, 'Dec.']]
	      }
	    };
	    areaChart = {};
	    areaChart.data1 = [[2007, 15], [2008, 20], [2009, 10], [2010, 5], [2011, 5], [2012, 20], [2013, 28]];
	    areaChart.data2 = [[2007, 15], [2008, 16], [2009, 22], [2010, 14], [2011, 12], [2012, 19], [2013, 22]];
	    $scope.area = {};
	    $scope.area.data = [{
	      data: areaChart.data1,
	      label: "Value A",
	      lines: {
	        fill: true
	      }
	    }, {
	      data: areaChart.data2,
	      label: "Value B",
	      points: {
	        show: true
	      },
	      yaxis: 2
	    }];
	    $scope.area.options = {
	      series: {
	        lines: {
	          show: true,
	          fill: false
	        },
	        points: {
	          show: true,
	          lineWidth: 2,
	          fill: true,
	          fillColor: "#ffffff",
	          symbol: "circle",
	          radius: 5
	        },
	        shadowSize: 0
	      },
	      grid: {
	        hoverable: true,
	        clickable: true,
	        tickColor: "#f9f9f9",
	        borderWidth: 1,
	        borderColor: "#eeeeee"
	      },
	      colors: ["#60CD9B", "#8170CA"],
	      tooltip: true,
	      tooltipOpts: {
	        defaultTheme: false
	      },
	      xaxis: {
	        mode: "time"
	      },
	      yaxes: [{}, {
	        position: "right"
	      }]
	    };
	    barChart = {};
	    barChart.data1 = [[2008, 20], [2009, 10], [2010, 5], [2011, 5], [2012, 20], [2013, 28]];
	    barChart.data2 = [[2008, 16], [2009, 22], [2010, 14], [2011, 12], [2012, 19], [2013, 22]];
	    barChart.data3 = [[2008, 12], [2009, 30], [2010, 20], [2011, 19], [2012, 13], [2013, 20]];
	    $scope.barChart = {};
	    $scope.barChart.data = [{
	      label: "Value A",
	      data: barChart.data1
	    }, {
	      label: "Value B",
	      data: barChart.data2
	    }, {
	      label: "Value C",
	      data: barChart.data3
	    }];
	    $scope.barChart.options = {
	      series: {
	        stack: true,
	        bars: {
	          show: true,
	          fill: 1,
	          barWidth: 0.3,
	          align: "center",
	          horizontal: false,
	          order: 1
	        }
	      },
	      grid: {
	        hoverable: true,
	        borderWidth: 1,
	        borderColor: "#eeeeee"
	      },
	      tooltip: true,
	      tooltipOpts: {
	        defaultTheme: false
	      },
	      colors: ["#60CD9B", "#66B5D7", "#EEC95A", "#E87352"]
	    };
	    $scope.pieChart = {};
	    $scope.pieChart.data = [{
	      label: "Download Sales",
	      data: 12
	    }, {
	      label: "In-Store Sales",
	      data: 30
	    }, {
	      label: "Mail-Order Sales",
	      data: 20
	    }, {
	      label: "Online Sales",
	      data: 19
	    }];
	    $scope.pieChart.options = {
	      series: {
	        pie: {
	          show: true
	        }
	      },
	      legend: {
	        show: true
	      },
	      grid: {
	        hoverable: true,
	        clickable: true
	      },
	      colors: ["#60CD9B", "#66B5D7", "#EEC95A", "#E87352"],
	      tooltip: true,
	      tooltipOpts: {
	        content: "%p.0%, %s",
	        defaultTheme: false
	      }
	    };
	    $scope.donutChart = {};
	    $scope.donutChart.data = [{
	      label: "Download Sales",
	      data: 12
	    }, {
	      label: "In-Store Sales",
	      data: 30
	    }, {
	      label: "Mail-Order Sales",
	      data: 20
	    }, {
	      label: "Online Sales",
	      data: 19
	    }];
	    $scope.donutChart.options = {
	      series: {
	        pie: {
	          show: true,
	          innerRadius: 0.5
	        }
	      },
	      legend: {
	        show: true
	      },
	      grid: {
	        hoverable: true,
	        clickable: true
	      },
	      colors: ["#60CD9B", "#66B5D7", "#EEC95A", "#E87352"],
	      tooltip: true,
	      tooltipOpts: {
	        content: "%p.0%, %s",
	        defaultTheme: false
	      }
	    };
	    $scope.donutChart2 = {};
	    $scope.donutChart2.data = [{
	      label: "Download Sales",
	      data: 12
	    }, {
	      label: "In-Store Sales",
	      data: 30
	    }, {
	      label: "Mail-Order Sales",
	      data: 20
	    }, {
	      label: "Online Sales",
	      data: 19
	    }, {
	      label: "Direct Sales",
	      data: 15
	    }];
	    return $scope.donutChart2.options = {
	      series: {
	        pie: {
	          show: true,
	          innerRadius: 0.5
	        }
	      },
	      legend: {
	        show: false
	      },
	      grid: {
	        hoverable: true,
	        clickable: true
	      },
	      colors: ["#1BB7A0", "#39B5B9", "#52A3BB", "#619CC4", "#6D90C5"],
	      tooltip: true,
	      tooltipOpts: {
	        content: "%p.0%, %s",
	        defaultTheme: false
	      }
	    };
	  }]).controller('flotChartCtrl.realtime', ['$scope', function ($scope) {}]).controller('sparklineCtrl', ['$scope', function ($scope) {
	    $scope.demoData1 = {
	      data: [3, 1, 2, 2, 4, 6, 4, 5, 2, 4, 5, 3, 4, 6, 4, 7],
	      options: {
	        type: 'line',
	        lineColor: '#fff',
	        highlightLineColor: '#fff',
	        fillColor: '#60CD9B',
	        spotColor: false,
	        minSpotColor: false,
	        maxSpotColor: false,
	        width: '100%',
	        height: '150px'
	      }
	    };
	    $scope.simpleChart1 = {
	      data: [3, 1, 2, 3, 5, 3, 4, 2],
	      options: {
	        type: 'line',
	        lineColor: '#31C0BE',
	        fillColor: '#bce0df',
	        spotColor: false,
	        minSpotColor: false,
	        maxSpotColor: false
	      }
	    };
	    $scope.simpleChart2 = {
	      data: [3, 1, 2, 3, 5, 3, 4, 2],
	      options: {
	        type: 'bar',
	        barColor: '#31C0BE'
	      }
	    };
	    $scope.simpleChart3 = {
	      data: [3, 1, 2, 3, 5, 3, 4, 2],
	      options: {
	        type: 'pie',
	        sliceColors: ['#31C0BE', '#60CD9B', '#E87352', '#8170CA', '#EEC95A', '#60CD9B']
	      }
	    };
	    $scope.tristateChart1 = {
	      data: [1, 2, -3, -5, 3, 1, -4, 2],
	      options: {
	        type: 'tristate',
	        posBarColor: '#95b75d',
	        negBarColor: '#fa8564'
	      }
	    };
	    $scope.largeChart1 = {
	      data: [3, 1, 2, 3, 5, 3, 4, 2],
	      options: {
	        type: 'line',
	        lineColor: '#674E9E',
	        highlightLineColor: '#7ACBEE',
	        fillColor: '#927ED1',
	        spotColor: false,
	        minSpotColor: false,
	        maxSpotColor: false,
	        width: '100%',
	        height: '150px'
	      }
	    };
	    $scope.largeChart2 = {
	      data: [3, 1, 2, 3, 5, 3, 4, 2],
	      options: {
	        type: 'bar',
	        barColor: '#31C0BE',
	        barWidth: 10,
	        width: '100%',
	        height: '150px'
	      }
	    };
	    return $scope.largeChart3 = {
	      data: [3, 1, 2, 3, 5],
	      options: {
	        type: 'pie',
	        sliceColors: ['#31C0BE', '#60CD9B', '#E87352', '#8170CA', '#EEC95A', '#60CD9B'],
	        width: '150px',
	        height: '150px'
	      }
	    };
	  }]);
	}).call(undefined);

/***/ }),
/* 569 */
/***/ (function(module, exports) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  'use strict';
	
	  angular.module('app.chart.directives', []).directive('gaugeChart', [function () {
	    return {
	      restrict: 'A',
	      scope: {
	        data: '=',
	        options: '='
	      },
	      link: function link(scope, ele, attrs) {
	        var data, gauge, options;
	        data = scope.data;
	        options = scope.options;
	        gauge = new Gauge(ele[0]).setOptions(options);
	        gauge.maxValue = data.maxValue;
	        gauge.animationSpeed = data.animationSpeed;
	        return gauge.set(data.val);
	      }
	    };
	  }]).directive('flotChart', [function () {
	    return {
	      restrict: 'A',
	      scope: {
	        data: '=',
	        options: '='
	      },
	      link: function link(scope, ele, attrs) {
	        var data, options, plot;
	        data = scope.data;
	        options = scope.options;
	        return plot = $.plot(ele[0], data, options);
	      }
	    };
	  }]).directive('flotChartRealtime', [function () {
	    return {
	      restrict: 'A',
	      link: function link(scope, ele, attrs) {
	        var data, getRandomData, plot, totalPoints, _update, updateInterval;
	        data = [];
	        totalPoints = 300;
	        getRandomData = function getRandomData() {
	          var i, prev, res, y;
	          if (data.length > 0) {
	            data = data.slice(1);
	          }
	          while (data.length < totalPoints) {
	            prev = data.length > 0 ? data[data.length - 1] : 50;
	            y = prev + Math.random() * 10 - 5;
	            if (y < 0) {
	              y = 0;
	            } else {
	              if (y > 100) {
	                y = 100;
	              }
	            }
	            data.push(y);
	          }
	          res = [];
	          i = 0;
	          while (i < data.length) {
	            res.push([i, data[i]]);
	            ++i;
	          }
	          return res;
	        };
	        _update = function update() {
	          plot.setData([getRandomData()]);
	          plot.draw();
	          setTimeout(_update, updateInterval);
	        };
	        data = [];
	        totalPoints = 300;
	        updateInterval = 200;
	        plot = $.plot(ele[0], [getRandomData()], {
	          series: {
	            lines: {
	              show: true,
	              fill: true
	            },
	            shadowSize: 0
	          },
	          yaxis: {
	            min: 0,
	            max: 100
	          },
	          xaxis: {
	            show: false
	          },
	          grid: {
	            hoverable: true,
	            borderWidth: 1,
	            borderColor: '#eeeeee'
	          },
	          colors: ["#5BDDDC"]
	        });
	        return _update();
	      }
	    };
	  }]).directive('sparkline', [function () {
	    return {
	      restrict: 'A',
	      scope: {
	        data: '=',
	        options: '='
	      },
	      link: function link(scope, ele, attrs) {
	        var data, options, sparkResize, sparklineDraw;
	        data = scope.data;
	        options = scope.options;
	        sparkResize = void 0;
	        sparklineDraw = function sparklineDraw() {
	          return ele.sparkline(data, options);
	        };
	        $(window).resize(function (e) {
	          clearTimeout(sparkResize);
	          return sparkResize = setTimeout(sparklineDraw, 200);
	        });
	        return sparklineDraw();
	      }
	    };
	  }]).directive('morrisChart', [function () {
	    return {
	      restrict: 'A',
	      scope: {
	        data: '='
	      },
	      link: function link(scope, ele, attrs) {
	        var colors, data, func, options;
	        data = scope.data;
	        switch (attrs.type) {
	          case 'line':
	            if (attrs.lineColors === void 0 || attrs.lineColors === '') {
	              colors = null;
	            } else {
	              colors = JSON.parse(attrs.lineColors);
	            }
	            options = {
	              element: ele[0],
	              data: data,
	              xkey: attrs.xkey,
	              ykeys: JSON.parse(attrs.ykeys),
	              labels: JSON.parse(attrs.labels),
	              lineWidth: attrs.lineWidth || 2,
	              lineColors: colors || ['#0b62a4', '#7a92a3', '#4da74d', '#afd8f8', '#edc240', '#cb4b4b', '#9440ed']
	            };
	            return new Morris.Line(options);
	          case 'area':
	            if (attrs.lineColors === void 0 || attrs.lineColors === '') {
	              colors = null;
	            } else {
	              colors = JSON.parse(attrs.lineColors);
	            }
	            options = {
	              element: ele[0],
	              data: data,
	              xkey: attrs.xkey,
	              ykeys: JSON.parse(attrs.ykeys),
	              labels: JSON.parse(attrs.labels),
	              lineWidth: attrs.lineWidth || 2,
	              lineColors: colors || ['#0b62a4', '#7a92a3', '#4da74d', '#afd8f8', '#edc240', '#cb4b4b', '#9440ed'],
	              behaveLikeLine: attrs.behaveLikeLine || false,
	              fillOpacity: attrs.fillOpacity || 'auto',
	              pointSize: attrs.pointSize || 4
	            };
	            return new Morris.Area(options);
	          case 'bar':
	            if (attrs.barColors === void 0 || attrs.barColors === '') {
	              colors = null;
	            } else {
	              colors = JSON.parse(attrs.barColors);
	            }
	            options = {
	              element: ele[0],
	              data: data,
	              xkey: attrs.xkey,
	              ykeys: JSON.parse(attrs.ykeys),
	              labels: JSON.parse(attrs.labels),
	              barColors: colors || ['#0b62a4', '#7a92a3', '#4da74d', '#afd8f8', '#edc240', '#cb4b4b', '#9440ed'],
	              stacked: attrs.stacked || null
	            };
	            return new Morris.Bar(options);
	          case 'donut':
	            if (attrs.colors === void 0 || attrs.colors === '') {
	              colors = null;
	            } else {
	              colors = JSON.parse(attrs.colors);
	            }
	            options = {
	              element: ele[0],
	              data: data,
	              colors: colors || ['#0B62A4', '#3980B5', '#679DC6', '#95BBD7', '#B0CCE1', '#095791', '#095085', '#083E67', '#052C48', '#042135']
	            };
	            if (attrs.formatter) {
	              func = new Function('y', 'data', attrs.formatter);
	              options.formatter = func;
	            }
	            return new Morris.Donut(options);
	        }
	      }
	    };
	  }]);
	}).call(undefined);

/***/ }),
/* 570 */
/***/ (function(module, exports) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	angular.module('app.editEmail', ['pascalprecht.translate', 'angularFileUpload', 'angular.filter', 'ngSlider', 'ngCookies', 'ngAnimate', 'ngSanitize', 'angularSpinner', 'angular-clipboard', 'ui.nested.combobox', 'ngCkeditor']).controller('EditEmailCtrl', ['$scope', '$log', '$http', '$modal', 'sharedProperties', 'currentLawyer', '$location', '$cookies', 'usSpinnerService', '$timeout', 'logger', '$window', '$filter', function ($scope, $log, $http, $modal, sharedProperties, currentLawyer, $location, $cookies, usSpinnerService, $timeout, logger, $window, $filter) {
	  var transformCCRecepients, transformRecepients;
	  $log.info("EditEmailCtrl initialized");
	  $scope.emailCategory = "";
	  $scope.emailBodyChanged = false;
	  $scope.editorOptions = {
	    extraPlugins: 'colorbutton'
	  };
	
	  $scope.logOut = function () {
	    sharedProperties.logOut();
	  };
	
	  $scope.openTestEmailPopUp = function () {
	    var allPlaceholders, data, emailBodyPlaceholderPattern, emailBodyPlaceholders, generalPlaceholderPattern, i, index, ref, subjectPlaceholders;
	    usSpinnerService.spin('spinner-1');
	    emailBodyPlaceholderPattern = /\&lt;%(.*?)%&gt;/g;
	    generalPlaceholderPattern = /\<%(.*?)%>/g;
	    emailBodyPlaceholders = $scope.emailCategory.content.match(emailBodyPlaceholderPattern);
	    subjectPlaceholders = $scope.emailCategory.subject.match(generalPlaceholderPattern);
	    if (subjectPlaceholders !== null) {
	      allPlaceholders = emailBodyPlaceholders.concat(subjectPlaceholders);
	    } else {
	      allPlaceholders = emailBodyPlaceholders;
	    }
	    if (allPlaceholders) {
	      for (index = i = 0, ref = allPlaceholders.length; 0 <= ref ? i < ref : i > ref; index = 0 <= ref ? ++i : --i) {
	        allPlaceholders[index] = allPlaceholders[index].replace(/&lt;/g, "<");
	        allPlaceholders[index] = allPlaceholders[index].replace(/&gt;/g, ">");
	      }
	    }
	    data = {
	      placeholders: allPlaceholders,
	      emailCategory: $scope.emailCategory.category_ID
	    };
	    $http.post('/api/validate-email-body', data).then(function (_ref) {
	      var data = _ref.data,
	          status = _ref.status,
	          headers = _ref.headers,
	          config = _ref.config;
	
	      var modalInstance;
	      usSpinnerService.stop('spinner-1');
	      $scope.placeholdersModified = false;
	      if (data.samePlaceholders === true) {
	        $scope.placeholdersModified = false;
	        $scope.emailCategory.recepient = "";
	        modalInstance = $modal.open({
	          templateUrl: "sendTestEmail.html",
	          controller: 'sendTestEmailCtrl',
	          resolve: {
	            modalData: function modalData() {
	              return $scope.emailCategory;
	            }
	          }
	        });
	        return modalInstance.result.then(function (updatedData) {
	          $scope.emailBodyChanged = false;
	        }, function () {});
	      } else {
	        return $scope.placeholdersModified = true;
	      }
	    }, function (_ref2) {
	      var data = _ref2.data;
	
	      $log.info("error in validating placeholders");
	      return $log.info(data);
	    });
	  };
	  $scope.closePopUp = function () {
	    $modalInstance.dismiss("close");
	  };
	  $scope.fetchEmailCategory = function () {
	    if ($location.search().emailCategory.category_ID) {
	      $scope.emailCategory = $location.search().emailCategory;
	      transformRecepients();
	      transformCCRecepients();
	      $http.post('/api/admin/save-email-listing-in-session', {
	        emailCategory: $scope.emailCategory
	      }).then(function (_ref3) {
	        var data = _ref3.data,
	            status = _ref3.status,
	            headers = _ref3.headers,
	            config = _ref3.config;
	      }, function (data) {
	        $log.info("error in saving email info in session");
	      });
	    } else {
	      $http.post('/api/fetch-current-user', {
	        'contentType': 'application/json'
	      }).then(function (_ref4) {
	        var data = _ref4.data,
	            status = _ref4.status,
	            headers = _ref4.headers,
	            config = _ref4.config;
	
	        if (data.emailCategory) {
	          $scope.emailCategory = data.emailCategory;
	          transformRecepients();
	          transformCCRecepients();
	          $http.post('/api/admin/save-email-listing-in-session', {
	            emailCategory: $scope.emailCategory
	          }).then(function (_ref5) {
	            var data = _ref5.data,
	                status = _ref5.status,
	                headers = _ref5.headers,
	                config = _ref5.config;
	          }, function (data) {
	            $log.info("error in saving email info in session");
	          });
	        } else {}
	        $log.info("nothing found in session");
	      }, function (data) {
	        if (status === 440) {
	          $location.url('/signin');
	        }
	      });
	    }
	  };
	  transformRecepients = function transformRecepients() {
	    var bccRecepients, bccRecepientsSize, i, index, ref;
	    bccRecepients = "";
	    bccRecepientsSize = $scope.emailCategory.email_bccs.length;
	    for (index = i = 0, ref = bccRecepientsSize; 0 <= ref ? i < ref : i > ref; index = 0 <= ref ? ++i : --i) {
	      if (index === bccRecepientsSize) {
	        bccRecepients = bccRecepients + $scope.emailCategory.email_bccs[index].email_address;
	      } else {}
	      bccRecepients = bccRecepients + ", " + $scope.emailCategory.email_bccs[index].email_address;
	    }
	    bccRecepients = bccRecepients.slice(1);
	    $scope.emailCategory.bcc = bccRecepients.trim();
	  };
	  transformCCRecepients = function transformCCRecepients() {
	    var ccRecepients, ccRecepientsSize, i, index, ref;
	    ccRecepients = "";
	    ccRecepientsSize = $scope.emailCategory.email_ccs.length;
	    for (index = i = 0, ref = ccRecepientsSize; 0 <= ref ? i < ref : i > ref; index = 0 <= ref ? ++i : --i) {
	      if (index === ccRecepientsSize) {
	        ccRecepients = ccRecepients + $scope.emailCategory.email_ccs[index].email_address;
	      } else {}
	      ccRecepients = ccRecepients + ", " + $scope.emailCategory.email_ccs[index].email_address;
	    }
	    ccRecepients = ccRecepients.slice(1);
	    $scope.emailCategory.cc = ccRecepients.trim();
	  };
	  $scope.saveEmailCategory = function () {
	    var allPlaceholders, data, emailBodyPlaceholderPattern, emailBodyPlaceholders, generalPlaceholderPattern, i, index, ref, subjectPlaceholders;
	    usSpinnerService.spin('spinner-1');
	    emailBodyPlaceholderPattern = /\&lt;%(.*?)%&gt;/g;
	    generalPlaceholderPattern = /\<%(.*?)%>/g;
	    emailBodyPlaceholders = $scope.emailCategory.content.match(emailBodyPlaceholderPattern);
	    subjectPlaceholders = $scope.emailCategory.subject.match(generalPlaceholderPattern);
	    if (subjectPlaceholders !== null) {
	      allPlaceholders = emailBodyPlaceholders.concat(subjectPlaceholders);
	    } else {
	      allPlaceholders = emailBodyPlaceholders;
	    }
	    if (allPlaceholders) {
	      for (index = i = 0, ref = allPlaceholders.length; 0 <= ref ? i < ref : i > ref; index = 0 <= ref ? ++i : --i) {
	        allPlaceholders[index] = allPlaceholders[index].replace(/&lt;/g, "<");
	        allPlaceholders[index] = allPlaceholders[index].replace(/&gt;/g, ">");
	      }
	    }
	    data = {
	      placeholders: allPlaceholders,
	      emailCategory: $scope.emailCategory.category_ID
	    };
	    $http.post('/api/validate-email-body', data).then(function (_ref6) {
	      var data = _ref6.data,
	          status = _ref6.status,
	          headers = _ref6.headers,
	          config = _ref6.config;
	
	      $scope.placeholdersModified = false;
	      if (data.samePlaceholders === true) {
	        $scope.placeholdersModified = false;
	        return $http.post('/api/update-email-category', $scope.emailCategory).then(function (success) {
	          return $http.post('/api/admin/navigate-email-listing').then(function (_ref7) {
	            var data = _ref7.data,
	                status = _ref7.status,
	                headers = _ref7.headers,
	                config = _ref7.config;
	
	            return $location.url("/admin/email-listing");
	          });
	        });
	      } else {
	        usSpinnerService.stop('spinner-1');
	        return $scope.placeholdersModified = true;
	      }
	    }, function (_ref8) {
	      var data = _ref8.data;
	
	      $log.info("error in validating placeholders");
	      return $log.info(data);
	    });
	  };
	  return $scope.navigateToEmailListing = function () {
	    $location.url('/admin/email-listing');
	  };
	}]).controller('sendTestEmailCtrl', ['$scope', '$http', '$log', '$modalInstance', '$location', 'modalData', function ($scope, $http, $log, $modalInstance, $location, modalData) {
	  $scope.modalData = modalData;
	  $scope.sendEmail = function () {
	    $http.post('/api/send-test-email', $scope.modalData).then(function (_ref9) {
	      var data = _ref9.data,
	          status = _ref9.status,
	          headers = _ref9.headers,
	          config = _ref9.config;
	
	      return $log.info("Sent Test Email Users");
	    }, function (data) {
	      return $log.info('error');
	    });
	    $modalInstance.close();
	  };
	  return $scope.close = function () {
	    $modalInstance.dismiss("cancel");
	  };
	}]);

/***/ }),
/* 571 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.api').factory('ForgetPasswordApi', ['api', function ForgetPasswordApi(api) {
	  var forgetPasswordApi = {
	    changePassword: function changePassword(payload) {
	      return api.post('auth/change-password', payload);
	    }
	  };
	  return forgetPasswordApi;
	}]);

/***/ }),
/* 572 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('ForgotPasswordController', ['logger', 'ForgetPasswordApi', '$scope', function controller(logger, ForgetPasswordApi, $scope) {
	    var _this = this;
	
	    var vm = this;
	    vm.userEmail = '';
	    vm.btnLabel = 'Continue';
	    vm.notify = function (type, message) {
	      switch (type) {
	        case 'info':
	          logger.log("Heads up! This alert needs your attention, but it's not super important.");
	          break;
	        case 'success':
	          logger.logSuccess(message);
	          break;
	        case 'warning':
	          logger.logWarning("Warning! Best check yo self, you're not looking too good.");
	          break;
	        case 'error':
	          logger.logError(message);
	          break;
	        default:
	          break;
	      }
	    };
	
	    vm.showClass = '';
	    vm.hideDropDown = function () {
	      vm.showClass = '';
	    };
	
	    vm.showDropDown = function () {
	      if (vm.showClass === '') vm.showClass = 'show';else vm.showClass = '';
	    };
	
	    vm.linkRequested = false;
	    vm.sendLink = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var _ref2, status, message;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _context.next = 3;
	              return ForgetPasswordApi.changePassword({
	                email: vm.userEmail
	              });
	
	            case 3:
	              _ref2 = _context.sent;
	              status = _ref2.status;
	
	              if (status === 201) {
	                vm.btnLabel = 'Sent';
	                message = 'A link has been emailed to you. Please check your inbox and junk folder and follow the given instructions to reset your password.';
	
	                vm.notify('success', message);
	                vm.linkRequested = true;
	                $scope.$apply();
	              }
	              _context.next = 11;
	              break;
	
	            case 8:
	              _context.prev = 8;
	              _context.t0 = _context['catch'](0);
	
	              vm.notify('error', _context.t0.data.message);
	
	            case 11:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this, [[0, 8]]);
	    }));
	  }]);
	})();

/***/ }),
/* 573 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	  angular.module('app.ui.form.ctrls', ['pascalprecht.translate', 'angularFileUpload', 'angular.filter', 'ngSlider', 'ngCookies', 'ngAnimate', 'ngSanitize', 'angularSpinner', 'angular-clipboard', 'ui.nested.combobox']).config(function ($translateProvider) {
	    $translateProvider.useStaticFilesLoader({
	      prefix: 'i18n/resourceBundle-',
	      suffix: '.json'
	    });
	    $translateProvider.preferredLanguage('en');
	  });
	})();

/***/ }),
/* 574 */
/***/ (function(module, exports) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  angular.module('app.ui.form.directives', []).directive('uiRangeSlider', [function () {
	    return {
	      restrict: 'A',
	      link: function link(scope, ele) {
	        return ele.slider();
	      }
	    };
	  }]).directive('uiFileUpload', [function () {
	    return {
	      restrict: 'A',
	      link: function link(scope, ele) {
	        return ele.bootstrapFileInput();
	      }
	    };
	  }]).directive('uiSpinner', [function () {
	    return {
	      restrict: 'A',
	      compile: function compile(ele, attrs) {
	        ele.addClass('ui-spinner');
	        return {
	          post: function post() {
	            return ele.spinner();
	          }
	        };
	      }
	    };
	  }]).directive('uiWizardForm', [function () {
	    return {
	      link: function link(scope, ele) {
	        return ele.steps();
	      }
	    };
	  }]);
	}).call(undefined);

/***/ }),
/* 575 */
/***/ (function(module, exports) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	;(function () {
	  'use strict';
	
	  angular.module('app.form.validation', []).controller('wizardFormCtrl', ['$scope', function ($scope) {
	    $scope.wizard = {
	      firstName: 'some name',
	      lastName: '',
	      email: '',
	      password: '',
	      age: '',
	      address: ''
	    };
	    $scope.isValidateStep1 = function () {
	      return console.log($scope.wizard.firstName !== '' && $scope.wizard.lastName !== '');
	    };
	    return $scope.finishedWizard = function () {
	      return;
	    };
	  }]).controller('formConstraintsCtrl', ['$scope', function ($scope) {
	    var original;
	    $scope.form = {
	      required: '',
	      minlength: '',
	      maxlength: '',
	      length_rage: '',
	      type_something: '',
	      confirm_type: '',
	      foo: '',
	      email: '',
	      url: '',
	      num: '',
	      minVal: '',
	      maxVal: '',
	      valRange: '',
	      pattern: ''
	    };
	    original = angular.copy($scope.form);
	    $scope.revert = function () {
	      $scope.form = angular.copy(original);
	      return $scope.form_constraints.$setPristine();
	    };
	    $scope.canRevert = function () {
	      return !angular.equals($scope.form, original) || !$scope.form_constraints.$pristine;
	    };
	    return $scope.canSubmit = function () {
	      return $scope.form_constraints.$valid && !angular.equals($scope.form, original);
	    };
	  }]).controller('signinCtrl', ['$scope', function ($scope) {
	    var original;
	    $scope.user = {
	      email: '',
	      password: ''
	    };
	    $scope.showInfoOnSubmit = false;
	    original = angular.copy($scope.user);
	    $scope.revert = function () {
	      $scope.user = angular.copy(original);
	      return $scope.form_signin.$setPristine();
	    };
	    $scope.canRevert = function () {
	      return !angular.equals($scope.user, original) || !$scope.form_signin.$pristine;
	    };
	    $scope.canSubmit = function () {
	      return $scope.form_signin.$valid && !angular.equals($scope.user, original);
	    };
	    return $scope.submitForm = function () {
	      $scope.showInfoOnSubmit = true;
	      return $scope.revert();
	    };
	  }]).controller('SignUpController', ['$scope', function ($scope) {
	    var original;
	    $scope.user = {
	      name: '',
	      email: '',
	      password: '',
	      confirmPassword: '',
	      age: ''
	    };
	    $scope.showInfoOnSubmit = false;
	    original = angular.copy($scope.user);
	    $scope.revert = function () {
	      $scope.user = angular.copy(original);
	      $scope.form_signup.$setPristine();
	      return $scope.form_signup.confirmPassword.$setPristine();
	    };
	    $scope.canRevert = function () {
	      return !angular.equals($scope.user, original) || !$scope.form_signup.$pristine;
	    };
	    $scope.canSubmit = function () {
	      return $scope.form_signup.$valid && !angular.equals($scope.user, original);
	    };
	    return $scope.submitForm = function () {
	      $scope.showInfoOnSubmit = true;
	      return $scope.revert();
	    };
	  }]).directive('validateEquals', [function () {
	    return {
	      require: 'ngModel',
	      link: function link(scope, ele, attrs, ngModelCtrl) {
	        var validateEqual;
	        validateEqual = function validateEqual(value) {
	          var valid;
	          valid = value === scope.$eval(attrs.validateEquals);
	          ngModelCtrl.$setValidity('equal', valid);
	          return typeof valid === 'function' ? valid({
	            value: void 0
	          }) : void 0;
	        };
	        ngModelCtrl.$parsers.push(validateEqual);
	        ngModelCtrl.$formatters.push(validateEqual);
	        return scope.$watch(attrs.validateEquals, function (newValue, oldValue) {
	          if (newValue !== oldValue) {
	            return ngModelCtrl.$setViewValue(ngModelCtrl.$ViewValue);
	          }
	        });
	      }
	    };
	  }]);
	}).call(undefined);

/***/ }),
/* 576 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	  angular.module('app.ui.form.ctrls').controller('RatingDemoCtrl', ['$scope', function ($scope) {
	    $scope.rate = 7;
	    $scope.max = 10;
	    $scope.isReadonly = false;
	    $scope.hoveringOver = function (value) {
	      $scope.overStar = value;
	      return $scope.percent = 100 * (value / $scope.max);
	    };
	    return $scope.ratingStates = [{
	      stateOn: 'glyphicon-ok-sign',
	      stateOff: 'glyphicon-ok-circle'
	    }, {
	      stateOn: 'glyphicon-star',
	      stateOff: 'glyphicon-star-empty'
	    }, {
	      stateOn: 'glyphicon-heart',
	      stateOff: 'glyphicon-ban-circle'
	    }, {
	      stateOn: 'glyphicon-heart'
	    }, {
	      stateOff: 'glyphicon-off'
	    }];
	  }]);
	})();

/***/ }),
/* 577 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	  angular.module('app.ui.form.ctrls').controller('TabsDemoCtrl', ['$scope', function ($scope) {
	    $scope.tabs = [{
	      title: "Dynamic Title 1",
	      content: "Dynamic content 1.  Consectetur adipisicing elit. Nihil, quidem, officiis, et ex laudantium sed cupiditate voluptatum libero nobis sit illum voluptates beatae ab. Ad, repellendus non sequi et at."
	    }, {
	      title: "Disabled",
	      content: "Dynamic content 2.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nihil, quidem, officiis, et ex laudantium sed cupiditate voluptatum libero nobis sit illum voluptates beatae ab. Ad, repellendus non sequi et at.",
	      disabled: true
	    }];
	    return $scope.navType = "pills";
	  }]);
	})();

/***/ }),
/* 578 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	  angular.module('app.ui.form.ctrls').controller('TagsDemoCtrl', ['$scope', function ($scope) {
	    return $scope.tags = ['foo', 'bar'];
	  }]);
	})();

/***/ }),
/* 579 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	  angular.module('app.ui.form.ctrls').controller('deleteEducationModalCtrl', ['$scope', '$http', '$log', '$modalInstance', '$location', 'data', '$translate', function ($scope, $http, $log, $modalInstance, $location, data, $translate) {
	    $scope.confirmDeletion = false;
	    $scope.yes = function () {
	      $scope.confirmDeletion = true;
	      $modalInstance.close($scope.confirmDeletion);
	    };
	    $scope.no = function () {
	      $modalInstance.dismiss("cancel");
	    };
	  }]);
	})();

/***/ }),
/* 580 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	  angular.module('app.ui.form.ctrls').controller('deleteMatterModalCtrl', ['$scope', '$http', '$log', '$modalInstance', '$location', 'data', '$translate', function ($scope, $http, $log, $modalInstance, $location, data, $translate) {
	    $scope.confirmAction = false;
	    $scope.yes = function () {
	      $scope.confirmAction = true;
	      $modalInstance.close($scope.confirmAction);
	    };
	    $scope.no = function () {
	      $modalInstance.dismiss("cancel");
	    };
	  }]);
	})();

/***/ }),
/* 581 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/* eslint-disable angular/function-type */
	;(function () {
	  angular.module('app.ui.form.ctrls').controller('EmailSubscriptionController', ['logger', 'CandidateProfileApi', '$scope', '$location',
	  // eslint-disable-next-line func-names
	  function EmailSubscriptionController(logger, CandidateProfileApi, $scope, $location) {
	    var _this = this;
	
	    var vm = this;
	    vm.succeeded = false;
	    vm.pauseFlag = false;
	    var url = $location.url();
	    console.debug('url is ' + $location.url());
	    var start = url.indexOf('=') + 1;
	    var end = url.indexOf('-');
	    // eslint-disable-next-line unicorn/prefer-string-slice
	    var candidateId = url.substring(start, end);
	    console.debug('candidateId is ' + candidateId);
	    vm.emailTypeName = '';
	    var emailTypeID = Number.parseInt(url.slice(Math.max(0, end + 1)), 10);
	    console.debug('emailTypeID', emailTypeID);
	    vm.emailType = '';
	
	    if (emailTypeID === 1) {
	      vm.emailType = 'Weekly';
	      vm.emailTypeName = 'weekly_position_ping';
	    } else if (emailTypeID === 2) {
	      vm.emailType = 'Daily';
	      vm.emailTypeName = 'daily_positions_ping';
	    }
	
	    console.debug('email type and email type name', {
	      emailType: vm.emailType,
	      emailTypeName: vm.emailTypeName
	    });
	
	    vm.unsubscribe = true;
	    vm.succeeded = false;
	
	    vm.initializeEmailSubscription = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var _ref2, emailSubscriptions, emailSubscribed, date, dateAfterThreeMonths;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              console.debug('initializeEmailSubscription');
	              _context.next = 3;
	              return CandidateProfileApi.getEmailSubscriptions(candidateId);
	
	            case 3:
	              _ref2 = _context.sent;
	              emailSubscriptions = _ref2.data;
	              emailSubscribed = emailSubscriptions.find(function (_ref3) {
	                var emailId = _ref3.emailId;
	                return vm.emailTypeName === emailId;
	              });
	
	              if (url.includes('pause')) {
	                console.warn('pause detected in url. checking if should pause');
	                if (emailSubscribed && !emailSubscribed.paused) {
	                  vm.unsubscribe = true;
	                  date = new Date();
	                  dateAfterThreeMonths = new Date(date.setMonth(date.getMonth() + 3));
	
	                  vm.daysBetweenDates = Math.ceil((dateAfterThreeMonths.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
	                } else {
	                  console.debug('should not pause. email already paused');
	                  vm.unsubscribe = false;
	                }
	              }
	
	              if (url.includes('unsubscribe')) {
	                console.warn('unsubscribe detected in url. checking if should pause');
	                if (emailSubscribed && !emailSubscribed.stopped) {
	                  console.warn('should unsubscribe');
	                  vm.unsubscribe = true;
	                } else {
	                  console.debug('should not unsubscribe. email already stopped');
	                  vm.unsubscribe = false;
	                }
	              }
	
	              $scope.$applyAsync();
	
	            case 9:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    vm.doUnsubscribe = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              console.debug('attempting to unsubscribe');
	              _context2.prev = 1;
	              _context2.next = 4;
	              return CandidateProfileApi.unsubscribe(candidateId, vm.emailTypeName);
	
	            case 4:
	              logger.notify('success', 'Email Successfully Unsubscribed!');
	              vm.succeeded = true;
	              _context2.next = 12;
	              break;
	
	            case 8:
	              _context2.prev = 8;
	              _context2.t0 = _context2['catch'](1);
	
	              console.error(_context2.t0);
	              logger.notify('error', 'Could not Unsubscribe from email');
	
	            case 12:
	
	              $scope.$applyAsync();
	
	            case 13:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this, [[1, 8]]);
	    }));
	
	    vm.doSubscribe = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              console.debug('attempting to resubscribe');
	              _context3.prev = 1;
	              _context3.next = 4;
	              return CandidateProfileApi.subscribe(candidateId, vm.emailTypeName);
	
	            case 4:
	              logger.notify('success', 'Email Successfully subscribed!');
	              vm.succeeded = true;
	              _context3.next = 12;
	              break;
	
	            case 8:
	              _context3.prev = 8;
	              _context3.t0 = _context3['catch'](1);
	
	              console.error(_context3.t0);
	              logger.notify('error', 'Could not Subscribe to email ');
	
	            case 12:
	
	              $scope.$applyAsync();
	
	            case 13:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this, [[1, 8]]);
	    }));
	
	    vm.doUnpause = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
	      return regeneratorRuntime.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              console.debug('attempting to unpause');
	              _context4.prev = 1;
	              _context4.next = 4;
	              return CandidateProfileApi.unpauseEmail(candidateId, vm.emailTypeName);
	
	            case 4:
	              vm.succeeded = true;
	              logger.notify('success', 'Email Successfully Un Paused!');
	              _context4.next = 12;
	              break;
	
	            case 8:
	              _context4.prev = 8;
	              _context4.t0 = _context4['catch'](1);
	
	              console.error(_context4.t0);
	              logger.notify('error', 'Could not Un Pause email ');
	
	            case 12:
	
	              $scope.$applyAsync();
	
	            case 13:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this, [[1, 8]]);
	    }));
	
	    vm.doPause = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              console.debug('attempting to pause', vm.daysBetweenDates);
	              _context5.prev = 1;
	              _context5.next = 4;
	              return CandidateProfileApi.pauseEmail(candidateId, vm.emailTypeName, vm.daysBetweenDates);
	
	            case 4:
	              logger.notify('success', 'Email Successfully Paused!');
	              vm.succeeded = true;
	              _context5.next = 12;
	              break;
	
	            case 8:
	              _context5.prev = 8;
	              _context5.t0 = _context5['catch'](1);
	
	              console.error(_context5.t0);
	              logger.notify('error', 'Could not Pause email ');
	
	            case 12:
	
	              $scope.$applyAsync();
	
	            case 13:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this, [[1, 8]]);
	    }));
	
	    vm.initializeEmailSubscription();
	  }]);
	})();

/***/ }),
/* 582 */
/***/ (function(module, exports) {

	'use strict';
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('IsOldBrowserController', ['$log', 'sharedProperties', function controller($log, sharedProperties) {
	    var vm = this;
	    vm.showOldBrowser = false;
	    vm.whichBrowser = {
	      type: '',
	      version: ''
	    };
	    vm.browser = sharedProperties.detectBrowser();
	    if (vm.browser.includes('Chrome')) {
	      vm.whichBrowser = {
	        type: 'Chrome',
	        version: vm.browser.slice(7, vm.browser.length)
	      };
	    } else if (vm.browser.includes('IE')) {
	      vm.whichBrowser = {
	        type: 'IE',
	        version: vm.browser.slice(3, vm.browser.length)
	      };
	      if (vm.whichBrowser.version.includes('E')) {
	        if (vm.whichBrowser.version === 'E 10') {
	          vm.showOldBrowser = false;
	        } else if (vm.whichBrowser.version <= 'E 9') {
	          vm.showOldBrowser = true;
	        }
	      } else if (vm.whichBrowser.version >= '11') {
	        vm.showOldBrowser = false;
	      }
	    } else if (vm.browser.includes('Firefox')) {
	      vm.whichBrowser = {
	        type: 'Firefox',
	        version: vm.browser.slice(8, vm.browser.length)
	      };
	    }
	
	    return $log.info(vm.whichBrowser);
	  }]);
	})();

/***/ }),
/* 583 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.api').factory('HiringApi', ['api', function HiringApi(api) {
	  var hiringApi = {
	    createEmployerEnquiry: function createEmployerEnquiry(payload) {
	      return api.post('landing/new-employer', payload);
	    }
	  };
	  return hiringApi;
	}]);

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _segment = __webpack_require__(21);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	(function module() {
	  angular.module('app.ui.form.ctrls').controller('HiringController', ['$log', '$scope', 'logger', 'HiringApi', function controller($log, $scope, logger, HiringApi) {
	    var _this = this;
	
	    var vm = this;
	    vm.hiring = {
	      aboutUs: 'How did you hear about us?',
	      jobType: 'Job/project type'
	    };
	    vm.notify = function (type, message) {
	      switch (type) {
	        case 'info':
	          logger.log(message);
	          break;
	        case 'success':
	          logger.logSuccess(message);
	          break;
	        case 'warning':
	          logger.logWarning(message);
	          break;
	        case 'error':
	          logger.logError(message);
	          break;
	        default:
	          break;
	      }
	    };
	
	    var isValidForm = function isValidForm() {
	      if (vm.hiring.jobType === 'Job/project type') return false;
	      if (vm.hiring.aboutUs === 'How did you hear about us?') return false;
	      return true;
	    };
	
	    vm.isHideForm = false;
	    vm.employerApply = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var _ref2, status;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!isValidForm()) {
	                _context.next = 15;
	                break;
	              }
	
	              _context.prev = 1;
	              _context.next = 4;
	              return HiringApi.createEmployerEnquiry(vm.hiring);
	
	            case 4:
	              _ref2 = _context.sent;
	              status = _ref2.status;
	
	              if (status === 201) {
	                vm.isHideForm = true;
	                (0, _segment.hiringFormSubmission)(vm.hiring.name, vm.hiring.email, vm.hiring.employerName, vm.hiring.jobType, vm.hiring.aboutUs);
	                $scope.$apply();
	              } else vm.notify('error', 'There has been an error in sending your email. Please try again');
	              _context.next = 13;
	              break;
	
	            case 9:
	              _context.prev = 9;
	              _context.t0 = _context['catch'](1);
	
	              $log.error('error', _context.t0);
	              vm.notify('error', 'There has been an error in sending your email. Please try again');
	
	            case 13:
	              _context.next = 17;
	              break;
	
	            case 15:
	              if (vm.hiring.jobType === 'Job/project type') vm.notify('warning', 'Please fill Job/project type field');
	              if (vm.hiring.aboutUs === 'How did you hear about us?') vm.notify('warning', 'Please fill How did you hear about us? field');
	
	            case 17:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this, [[1, 9]]);
	    }));
	  }]);
	})();

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _segment = __webpack_require__(21);
	
	(function () {
	  angular.module('app.ui.form.ctrls').controller('HomePageCtrl', ['$http', '$log', '$location', '$scope', '$filter', '$modal', 'sharedProperties', 'currentLawyer', '$window', 'logger', '$cookies', '$route', '$rootScope', 'userService', function ($http, $log, $location, $scope, $filter, $modal, sharedProperties, currentLawyer, $window, logger, $cookies, $route, $rootScope, userService) {
	    __webpack_require__(474);
	    $scope.showProfileNavBar = false;
	    $scope.showAdminNavBar = false;
	
	    $scope.newUser = true;
	    $scope.pattern = /^[a-z]+[\d._a-z]+@[a-z]+\.[.a-z]{2,5}$/;
	    $scope.getParameterByName = function (name) {
	      var regex;
	      var results;
	      name = name.replace(/\[/, '\\[').replace(/]/, '\\]');
	      regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	      results = regex.exec($window.location.href);
	      if (results === null) {
	        return '';
	      }
	
	      return decodeURIComponent(results[1].replace(/\+/g, ' '));
	    };
	
	    $cookies.referralCode = $scope.getParameterByName('referralCode');
	    if ($route.current.params.referralCode) {
	      $rootScope.referralCode = $route.current.params.referralCode;
	    }
	
	    $scope.showClass = '';
	    $scope.showDropDown = function () {
	      if ($scope.showClass === '') {
	        $scope.showClass = 'show';
	      } else {
	        $scope.showClass = '';
	      }
	    };
	
	    $scope.hideDropDown = function () {
	      $scope.showClass = '';
	    };
	
	    $scope.notify = function (type, message) {
	      switch (type) {
	        case 'info':
	          logger.log("Heads up! This alert needs your attention, but it's not super important.");
	          break;
	        case 'success':
	          logger.logSuccess(message);
	          break;
	        case 'warning':
	          logger.logWarning("Warning! Best check yo self, you're not looking too good.");
	          break;
	        case 'error':
	          logger.logError('Oh snap! Change a few things up and try submitting again.');
	          break;
	        default:
	          logger.logError('Unknown error');
	      }
	    };
	
	    $scope.loadLawyers = function () {
	      $http.post('/api/show-lawyers').then(function () {
	        $location.url('/admin/admin-listings');
	      }, function (error) {
	        $log.info('error', error);
	      });
	    };
	
	    $scope.loadFirms = function () {
	      $http.post('/api/show-firms').then(function () {
	        $location.url('/admin/admin-listings');
	      }, function (error) {
	        $log.info('error', error);
	      });
	    };
	
	    $scope.loadInhouseJobs = function () {
	      $http.post('/api/show-inhouse-firms').then(function () {
	        $location.url('/admin/admin-listings?list=inhouse-jobs');
	      }, function (error) {
	        $log.info('error', error);
	      });
	    };
	
	    $scope.navigateToinHouseJobs = function () {
	      $http.post('/api/admin/navigate-email-listing').then(function () {
	        $location.url('/admin/admin-listings?list=inhouse-jobs');
	      }, function (error) {
	        $log.info('error', error);
	      });
	    };
	
	    $scope.homepageControls = function (type) {
	      userService.getUser().then(function (user) {
	        var roles = user && user.roles && user.roles.map(function (role) {
	          return role.id;
	        }) || [];
	        var isUser = roles.includes('user');
	        if (!isUser) {
	          $location.url('/signup');
	        } else if (roles.includes('approved')) {
	          $location.url('/matches');
	        } else if (roles.includes('candidate')) {
	          $location.url('/profile');
	        } else if (roles.includes('agent') || roles.includes('admin')) {
	          $location.url('/admin/admin-listings');
	        } else if (!$scope.newUser) {
	          $location.url('/user-profile');
	        } else if ($scope.newUser && user && !user.isNewUser) {
	          $location.url('/signup');
	        } else if ($scope.newUser && user && user.isNewUser) {
	          $location.url('profile');
	        } else {
	          $location.url('/signup');
	        }
	
	        homepageMainCTA(type);
	      });
	    };
	
	    $scope.getStarted = function () {
	      (0, _segment.getStarted)();
	    };
	
	    this.logOut = function () {
	      $http.post('/api/logout', {
	        withCredentials: 'true'
	      }).then(function (_ref) {
	        var data = _ref.data,
	            status = _ref.status,
	            headers = _ref.headers,
	            config = _ref.config;
	
	        analytics.reset();
	        $cookies.firstName = null;
	        $cookies.lastName = null;
	        $cookies.userType = null;
	        $cookies.lawyerStatus = null;
	        $scope.showProfileNavBar = false;
	        $scope.showAdminNavBar = false;
	        $scope.showClass = '';
	        $scope.notify('success', 'You have successfully signed out.');
	      }, function (error) {});
	    };
	  }]);
	})(); /* eslint-disable angular/controller-as */
	/* eslint-disable func-names */
	/* eslint-disable angular/function-type */
	/* eslint-disable angular/controller-name */
	/* eslint-disable unicorn/filename-case */

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.api').factory('InHouseJobsApi', ['api', function InHouseJobsApi(api) {
	  var _this = this;
	
	  var inHouseJobsApi = {
	    getCandidateExternalMatchesData: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id, payload) {
	        var response;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return api.get('recommendations/candidate/' + id + '/external', {
	                  params: payload
	                });
	
	              case 2:
	                response = _context.sent;
	
	
	                console.debug('getCandidateExternalMatchesData', response);
	
	                return _context.abrupt('return', response);
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function getCandidateExternalMatchesData(_x, _x2) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getCandidateExternalMatchesData;
	    }(),
	
	    unHideCandidateEmployer: function unHideCandidateEmployer(id, payload) {
	      return api.put('users/' + id + '/hidden', payload);
	    },
	    unHideCandidatePosition: function unHideCandidatePosition(id, payload) {
	      return api.put('users/' + id + '/positions/hidden', payload);
	    }
	  };
	  return inHouseJobsApi;
	}]);

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/* eslint-disable unicorn/prevent-abbreviations */
	/* eslint-disable unicorn/catch-error-name */
	/* eslint-disable camelcase */
	/* eslint-disable radix */
	
	var inHouseJobsView = exports.inHouseJobsView = function inHouseJobsView(input) {
	  try {
	    var job_id = input.job_id,
	        job_company = input.job_company,
	        job_title = input.job_title,
	        job_contract = input.job_contract,
	        job_role = input.job_role,
	        job_type = input.job_type,
	        firm_name = input.firm_name,
	        firm_id = input.firm_id;
	
	    analytics.track('in-house jobs - view', {
	      eventCategory: 'post-user acquisition',
	      eventAction: 'in-house jobs - view',
	      eventLabel: 'submit',
	      job_id: job_id,
	      job_company: job_company,
	      job_title: job_title,
	      job_contract: job_contract,
	      job_role: job_role,
	      job_type: job_type,
	      firm_name: firm_name,
	      firm_id: firm_id
	    });
	  } catch (e) {
	    console.log('Track: inHouseJobsView', e);
	  }
	};
	
	var inHouseJobsInterested = exports.inHouseJobsInterested = function inHouseJobsInterested(input) {
	  try {
	    var job_id = input.job_id,
	        job_company = input.job_company,
	        job_title = input.job_title,
	        job_pqe = input.job_pqe,
	        job_contract = input.job_contract,
	        job_role = input.job_role,
	        job_address = input.job_address,
	        job_type = input.job_type,
	        firm_name = input.firm_name,
	        firm_id = input.firm_id;
	
	    analytics.track('in-house jobs - interested', {
	      eventCategory: 'post-user acquisition',
	      eventAction: 'in-house jobs - interested',
	      eventLabel: 'submit',
	      job_id: job_id,
	      job_company: job_company,
	      job_title: job_title,
	      job_pqe: job_pqe,
	      job_contract: job_contract,
	      job_role: job_role,
	      job_address: job_address,
	      job_type: job_type,
	      firm_name: firm_name,
	      firm_id: firm_id
	    });
	  } catch (e) {
	    console.log('Track: inHouseJobsInterested', e);
	  }
	};(function module() {
	  angular.module('app.ui.form.ctrls').controller('InHouseJobsController', ['SharedApi', 'InHouseJobsApi', '$window', '$translate', 'logger', 'usSpinnerService', '$location', '$scope', 'practiceAreaService', 'locationsGenericService', '$timeout', '$anchorScroll', 'CandidateProfileApi', 'userService', 'socket', function controller(SharedApi, InHouseJobsApi, $window, $translate, logger, usSpinnerService, $location, $scope, practiceAreaService, locationsGenericService, $timeout, $anchorScroll, CandidateProfileApi, userService, socket) {
	    var _this = this;
	
	    $translate.use('en');
	
	    var vm = this;
	    socket.on('CANDIDATE_APPROVAL_STATUS_UPDATE', function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                $timeout(function () {
	                  if (vm.user.id === data && $location.url().contains('inhouse-jobs')) {
	                    vm.initializeInHouseJobs();
	                  }
	                }, 2000);
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }());
	
	    socket.on('CANDIDATE_RECOMMENDATION_GENERATED', function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(candidateId) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                $timeout(function () {
	                  if (vm.user.id === candidateId && $location.url().contains('inhouse-jobs')) {
	                    vm.select(vm.currentPage);
	                  }
	                }, 1500);
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }());
	    vm.candidateExternalMatchesData = [];
	    vm.currentPage = 1;
	    vm.noJob = false;
	    vm.selectedPracticeArea = undefined;
	    vm.selectedLocations = undefined;
	    vm.minPqe = undefined;
	    vm.maxPqe = undefined;
	    vm.candidateLocations = [];
	    vm.candidateSpecialties = [];
	    vm.fetchHiddenJobs = false;
	    vm.numPerPageOpt = [10, 20, 50];
	    vm.numPerPage = vm.numPerPageOpt[2];
	    vm.totalPositions = 0;
	    vm.countRefreshReq = false;
	    vm.today = new Date();
	    vm.picSrc = 'images/firm-logo-default.jpg';
	    vm.hideJobFilterButton = false;
	    vm.toolTipText = 'You have already shared your profile.';
	    vm.pageName = 'in-house';
	    vm.filterPQE = '0;11';
	
	    vm.options = {
	      round: 1,
	      from: 0,
	      to: 11,
	      step: 0.5,
	      dimension: '+ PQE',
	      scale: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '11+']
	    };
	    vm.spinnerActive = false;
	    vm.alertOne = 'Unfortunately there are no current opportunities on LexStep for which your profile is a relevant match.  You will be alerted when a relevant opportunity match arises.  You can also edit your ';
	    vm.alertTwo = ' to refine your search parameters and reveal potential opportunities.';
	    vm.startSpin = function () {
	      if (!vm.spinnerActive) {
	        usSpinnerService.spin('spinner-2');
	        vm.spinnerActive = true;
	      }
	    };
	
	    vm.stopSpin = function () {
	      if (vm.spinnerActive) {
	        usSpinnerService.stop('spinner-2');
	        vm.spinnerActive = false;
	      }
	    };
	
	    vm.getCandidateExternalMatchesData = function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id, payload) {
	        var _ref4, candidateExternalMatchesData;
	
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.prev = 0;
	
	                vm.startSpin();
	
	                _context4.next = 4;
	                return InHouseJobsApi.getCandidateExternalMatchesData(id, payload);
	
	              case 4:
	                _ref4 = _context4.sent;
	                candidateExternalMatchesData = _ref4.data;
	
	
	                vm.candidateExternalMatchesData = candidateExternalMatchesData.positions;
	                vm.noJob = vm.candidateExternalMatchesData.length <= 0;
	                vm.positionsCount = candidateExternalMatchesData.positionsCount;
	                vm.totalPositions = vm.positionsCount.totalPositions - vm.positionsCount.hiddenPositions;
	                vm.hiddenPositions = vm.positionsCount.hiddenPositions;
	
	                vm.candidateExternalMatchesData.forEach(function () {
	                  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(position) {
	                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                      while (1) {
	                        switch (_context3.prev = _context3.next) {
	                          case 0:
	                            position.expanded = false;
	                            vm.formatPositionDescription(position);
	                            vm.checkPositionIsNew(position);
	                            position.locations = position.locations.length > 0 ? vm.locationsList.filter(function (_ref6) {
	                              var id = _ref6.id;
	                              return position.locations.find(function (location) {
	                                return location === id;
	                              });
	                            }).map(function (location) {
	                              return {
	                                name: location.name,
	                                parent: location.parent,
	                                color: location.country.region.color
	                              };
	                            }) : [];
	
	                          case 4:
	                          case 'end':
	                            return _context3.stop();
	                        }
	                      }
	                    }, _callee3, _this);
	                  }));
	
	                  return function (_x5) {
	                    return _ref5.apply(this, arguments);
	                  };
	                }());
	                vm.getAllEmployerLogos(vm.candidateExternalMatchesData);
	                vm.applyFilterCheck = true;
	
	                vm.stopSpin();
	                vm.disabledToolTip(vm.candidate);
	                $scope.$applyAsync();
	                _context4.next = 23;
	                break;
	
	              case 19:
	                _context4.prev = 19;
	                _context4.t0 = _context4['catch'](0);
	
	                vm.stopSpin();
	                logger.notify('error', 'something went wrong: ' + _context4.t0.statusText);
	
	              case 23:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this, [[0, 19]]);
	      }));
	
	      return function (_x3, _x4) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    vm.select = function () {
	      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(page) {
	        var payload;
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                vm.currentPage = page;
	
	                payload = {
	                  limit: vm.numPerPage,
	                  page: page,
	                  hiddenPositions: vm.fetchHiddenJobs,
	                  practiceAreas: vm.selectedPracticeArea ? vm.selectedPracticeArea.length > 0 ? vm.selectedPracticeArea.map(function (_ref8) {
	                    var id = _ref8.id;
	                    return id;
	                  }) : [0] : undefined,
	                  locations: vm.selectedLocations ? vm.selectedLocations.length > 0 ? vm.selectedLocations.map(function (_ref9) {
	                    var id = _ref9.id;
	                    return id;
	                  }) : [0] : undefined,
	                  minPqe: vm.minPQE,
	                  maxPqe: vm.maxPQE,
	                  employerTypes: [54]
	                };
	                _context5.next = 4;
	                return vm.getCandidateExternalMatchesData(vm.user.id, payload);
	
	              case 4:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this);
	      }));
	
	      return function (_x6) {
	        return _ref7.apply(this, arguments);
	      };
	    }();
	
	    vm.hidePositionFromUI = function (position) {
	      position.isHidden = true;
	      vm.hiddenPositions++;
	      vm['jobRow' + position.id] = 'zoomOutRight';
	
	      try {
	        analytics.track('Selected Job Not For Me', {
	          lawyer_id: vm.user.id,
	          job_id: position.id,
	          job_title: position.title,
	          job_max_pqe: position.lawPreferences.maxPqe,
	          job_min_pqe: position.lawPreferences.minPqe,
	          job_contract: position.contractTypeName,
	          job_role: position.occupationName,
	          employer_type: position.employerTypes && position.employerTypes.length > 0 ? position.employerTypes[0].name : undefined,
	          firm_id: position.employerId,
	          firm_name: position.employer.name,
	          page: 'In-House'
	        });
	      } catch (error) {
	        console.error('In-House', error);
	      }
	
	      $timeout(function () {
	        vm.candidateExternalMatchesData = vm.candidateExternalMatchesData.filter(function (_ref10) {
	          var id = _ref10.id;
	          return id !== position.id;
	        });
	
	        vm.noJob = vm.candidateExternalMatchesData.length <= 0;
	        vm.totalPositions--;
	        vm.countRefreshReq = true;
	        vm['jobRow' + position.id] = '';
	      }, 500);
	    };
	
	    vm.hideEmployerFromUI = function (position) {
	      position.expanded = false;
	      var hiddenEmployerPositions = vm.candidateExternalMatchesData.filter(function (_ref11) {
	        var employerId = _ref11.employerId;
	        return employerId === position.employerId;
	      });
	      hiddenEmployerPositions.forEach(function (hiddenEmployerPosition) {
	        vm['jobRow' + hiddenEmployerPosition.id] = 'zoomOutRight';
	      });
	      try {
	        analytics.track('Selected Firm Not For Me', {
	          lawyer_id: vm.user.id,
	          employer_type: position.employerTypes && position.employerTypes.length > 0 ? position.employerTypes[0].name : undefined,
	          firm_id: position.firm_ID,
	          firm_name: position.firm_Name,
	          page: 'In-House'
	        });
	      } catch (e) {
	        console.error('In-House', e);
	      }
	
	      $timeout(function () {
	        hiddenEmployerPositions.forEach(function (hiddenEmployerPosition) {
	          vm.candidateExternalMatchesData = vm.candidateExternalMatchesData.filter(function (_ref12) {
	            var id = _ref12.id;
	            return id !== hiddenEmployerPosition.id;
	          });
	          vm['jobRow' + hiddenEmployerPosition.id] = '';
	        });
	
	        vm.noJob = vm.candidateExternalMatchesData.length <= 0;
	        vm.totalPositions = Number.parseInt(vm.totalPositions) - Number.parseInt(hiddenEmployerPositions.length);
	        vm.hiddenPositions = Number.parseInt(vm.hiddenPositions) + Number.parseInt(hiddenEmployerPositions.length);
	        vm.countRefreshReq = true;
	      }, 500);
	    };
	
	    vm.unHidePosition = function () {
	      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(position) {
	        var payload, unHiddenEmployerPositions, _payload, positionUnHidePayLoad, employerUnHidePayLoad, _unHiddenEmployerPositions;
	
	        return regeneratorRuntime.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                if (!(position.employerHidden && !position.positionHidden)) {
	                  _context6.next = 19;
	                  break;
	                }
	
	                payload = {
	                  employerIds: [Number.parseInt(position.employerId)],
	                  updateValue: false
	                };
	                _context6.prev = 2;
	                _context6.next = 5;
	                return InHouseJobsApi.unHideCandidateEmployer(position.userId, payload);
	
	              case 5:
	                vm.candidateExternalMatchesData.forEach(function (candidateExternalMatch) {
	                  if (candidateExternalMatch.employerId === position.employerId) {
	                    candidateExternalMatch.employerHidden = false;
	                  }
	                });
	                position.expanded = false;
	                unHiddenEmployerPositions = vm.candidateExternalMatchesData.filter(function (externalMatch) {
	                  return externalMatch.employerId === position.employerId && !externalMatch.positionHidden;
	                });
	
	                unHiddenEmployerPositions.forEach(function (unHiddenEmployerPosition) {
	                  vm['jobRow' + unHiddenEmployerPosition.id] = 'zoomOutLeft';
	                });
	                $scope.$apply();
	
	                $timeout(function () {
	                  unHiddenEmployerPositions.forEach(function (unHiddenEmployerPosition) {
	                    vm.candidateExternalMatchesData = vm.candidateExternalMatchesData.filter(function (_ref14) {
	                      var id = _ref14.id;
	                      return id !== unHiddenEmployerPosition.id;
	                    });
	                    vm['jobRow' + unHiddenEmployerPosition.id] = '';
	                  });
	
	                  vm.noJob = vm.candidateExternalMatchesData.length <= 0;
	                  vm.totalPositions = Number.parseInt(vm.totalPositions) + Number.parseInt(unHiddenEmployerPositions.length);
	                  vm.hiddenPositions = Number.parseInt(vm.hiddenPositions) - Number.parseInt(unHiddenEmployerPositions.length);
	                  vm.countRefreshReq = true;
	                }, 500);
	                _context6.next = 17;
	                break;
	
	              case 13:
	                _context6.prev = 13;
	                _context6.t0 = _context6['catch'](2);
	
	                vm['jobRow' + position.id] = 'fadeIn';
	                logger.notify('error', 'somthing went wrong: ' + _context6.t0.statusText);
	
	              case 17:
	                _context6.next = 58;
	                break;
	
	              case 19:
	                if (!(!position.employerHidden && position.positionHidden)) {
	                  _context6.next = 37;
	                  break;
	                }
	
	                _payload = {
	                  positionIds: [Number.parseInt(position.id)],
	                  hide: false,
	                  reason: ' '
	                };
	                _context6.prev = 21;
	                _context6.next = 24;
	                return InHouseJobsApi.unHideCandidatePosition(position.userId, _payload);
	
	              case 24:
	                position.isHidden = true;
	                vm.totalPositions++;
	                vm['jobRow' + position.id] = 'zoomOutLeft';
	                $scope.$apply();
	                $timeout(function () {
	                  vm.candidateExternalMatchesData = vm.candidateExternalMatchesData.filter(function (_ref15) {
	                    var id = _ref15.id;
	                    return id !== position.id;
	                  });
	                  vm.noJob = vm.candidateExternalMatchesData.length <= 0;
	                  vm.hiddenPositions--;
	                  vm.countRefreshReq = true;
	                  vm['jobRow' + position.id] = '';
	                }, 500);
	                _context6.next = 35;
	                break;
	
	              case 31:
	                _context6.prev = 31;
	                _context6.t1 = _context6['catch'](21);
	
	                vm['jobRow' + position.id] = 'fadeIn';
	
	                logger.notify('error', 'somthing went wrong: ' + _context6.t1.statusText);
	
	              case 35:
	                _context6.next = 58;
	                break;
	
	              case 37:
	                if (!(position.employerHidden && position.positionHidden)) {
	                  _context6.next = 58;
	                  break;
	                }
	
	                positionUnHidePayLoad = {
	                  positionIds: [Number.parseInt(position.id)],
	                  hide: false,
	                  reason: ' '
	                };
	                employerUnHidePayLoad = {
	                  employerIds: [Number.parseInt(position.employerId)],
	                  updateValue: false
	                };
	                _context6.prev = 40;
	                _context6.next = 43;
	                return InHouseJobsApi.unHideCandidatePosition(position.userId, positionUnHidePayLoad);
	
	              case 43:
	                _context6.next = 45;
	                return InHouseJobsApi.unHideCandidateEmployer(position.userId, employerUnHidePayLoad);
	
	              case 45:
	                vm.candidateExternalMatchesData.forEach(function (candidateExternalMatch) {
	                  if (candidateExternalMatch.employerId === position.employerId) {
	                    candidateExternalMatch.employerHidden = false;
	                  }
	                });
	                position.isHidden = true;
	                _unHiddenEmployerPositions = vm.candidateExternalMatchesData.filter(function (externalMatch) {
	                  return externalMatch.employerId === position.employerId && !externalMatch.positionHidden;
	                });
	
	                _unHiddenEmployerPositions.forEach(function (unHiddenEmployerPosition) {
	                  vm['jobRow' + unHiddenEmployerPosition.id] = 'zoomOutLeft';
	                });
	                vm['jobRow' + position.id] = 'zoomOutLeft';
	                $scope.$apply();
	                $timeout(function () {
	                  vm.candidateExternalMatchesData = vm.candidateExternalMatchesData.filter(function (_ref16) {
	                    var id = _ref16.id;
	                    return id !== position.id;
	                  });
	
	                  _unHiddenEmployerPositions.forEach(function (unHiddenEmployerPosition) {
	                    vm.candidateExternalMatchesData = vm.candidateExternalMatchesData.filter(function (_ref17) {
	                      var id = _ref17.id;
	                      return id !== unHiddenEmployerPosition.id;
	                    });
	                    vm['jobRow' + unHiddenEmployerPosition.id] = '';
	                  });
	                  vm.noJob = vm.candidateExternalMatchesData.length <= 0;
	                  vm.totalPositions = Number.parseInt(vm.totalPositions) + Number.parseInt(_unHiddenEmployerPositions.length) + 1;
	                  vm.hiddenPositions = Number.parseInt(vm.hiddenPositions) - Number.parseInt(_unHiddenEmployerPositions.length) - 1;
	                  vm.countRefreshReq = true;
	                  vm['jobRow' + position.id] = '';
	                }, 500);
	                _context6.next = 58;
	                break;
	
	              case 54:
	                _context6.prev = 54;
	                _context6.t2 = _context6['catch'](40);
	
	                vm['jobRow' + position.id] = 'fadeIn';
	
	                logger.notify('error', 'somthing went wrong: ' + _context6.t2.statusText);
	
	              case 58:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this, [[2, 13], [21, 31], [40, 54]]);
	      }));
	
	      return function (_x7) {
	        return _ref13.apply(this, arguments);
	      };
	    }();
	
	    vm.redirectToAtsLink = function (position) {
	      var maxPqe = position.maxPqe,
	          minPqe = position.minPqe;
	
	      var positionPqe = minPqe <= 0 ? 'NQ' : minPqe + maxPqe === 11 ? '+' : maxPqe <= 0 || maxPqe === minPqe ? '' : '-' + maxPqe;
	
	      inHouseJobsInterested(position.id, position.employer.name, position.title, positionPqe, position.contractTypeName, position.occupationName, position.Address, position.type, vm.user.agent.name, vm.user.agent.id);
	
	      // eslint-disable-next-line no-negated-condition
	      var positionUrl = !position.externalUrl.match(/http/) ? 'http://'.concat(position.externalUrl) : position.externalUrl;
	      $window.open(positionUrl, '_blank');
	    };
	
	    vm.notify = function (type, message) {
	      // eslint-disable-next-line default-case
	      switch (type) {
	        case 'info':
	          logger.log(message);
	          break;
	        case 'success':
	          logger.logSuccess(message);
	          break;
	        case 'warning':
	          logger.logWarning(message);
	          break;
	        case 'error':
	          logger.logError(message);
	      }
	    };
	
	    vm.disabledToolTip = function (candidate) {
	      if (candidate.approvalStatus === 'Locked') vm.toolTipText = 'Your profile is locked, wait for reapproval to apply for jobs.';else if (candidate.user.phone && !(!candidate.user.phone || candidate.user.phone === '')) vm.toolTipText = 'Upload your CV to connect with employers.';else if (!candidate.user.phone || candidate.user.phone === '') vm.toolTipText = 'Please add your contact number in order to connect with firms.';
	      return true;
	    };
	
	    vm.loadPrivateJobs = function () {
	      $location.url('/matches');
	    };
	
	    vm.onExpandJob = function (position) {
	      var maxPqe = position.maxPqe,
	          minPqe = position.minPqe;
	
	      var positionPqe = minPqe <= 0 ? 'NQ' : minPqe + maxPqe === 11 ? '+' : maxPqe <= 0 || maxPqe === minPqe ? '' : '-' + maxPqe;
	
	      inHouseJobsView({
	        job_id: position.id,
	        job_company: position.employer.name,
	        job_title: position.title,
	        job_pqe: positionPqe,
	        job_contract: position.contractTypeName,
	        job_role: position.occupationName,
	        firm_name: position.employer.name,
	        firm_id: position.employer.id
	      });
	    };
	
	    vm.getAllEmployerLogos = function (inHousePositions) {
	      inHousePositions.map(function () {
	        var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(inHousePositions) {
	          var employer;
	          return regeneratorRuntime.wrap(function _callee7$(_context7) {
	            while (1) {
	              switch (_context7.prev = _context7.next) {
	                case 0:
	                  employer = inHousePositions.employer;
	
	                  if (!employer.logo) {
	                    _context7.next = 4;
	                    break;
	                  }
	
	                  employer.logoSrc = ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/employers/' + inHousePositions.employerId + '/logo/' + employer.logo;
	                  return _context7.abrupt('return', employer);
	
	                case 4:
	
	                  employer.logoSrc = vm.picSrc;
	                  return _context7.abrupt('return', employer);
	
	                case 6:
	                case 'end':
	                  return _context7.stop();
	              }
	            }
	          }, _callee7, _this);
	        }));
	
	        return function (_x8) {
	          return _ref18.apply(this, arguments);
	        };
	      }());
	      $scope.$apply();
	    };
	
	    vm.showJobs = function (position) {
	      if (position.expanded) {
	        position.expanded = false;
	      } else if (position.expanded === false) {
	        position.expanded = true;
	
	        vm.onExpandJob(position);
	      }
	    };
	
	    vm.onNumPerPageChange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
	      return regeneratorRuntime.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              _context8.next = 2;
	              return vm.select(1);
	
	            case 2:
	              vm.currentPage = 1;
	
	            case 3:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, _this);
	    }));
	
	    vm.hiddenJobFilter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
	      return regeneratorRuntime.wrap(function _callee9$(_context9) {
	        while (1) {
	          switch (_context9.prev = _context9.next) {
	            case 0:
	              if (vm.fetchHiddenJobs) {
	                vm.fetchHiddenJobs = false;
	              } else {
	                vm.fetchHiddenJobs = true;
	              }
	
	              _context9.next = 3;
	              return vm.select(1);
	
	            case 3:
	            case 'end':
	              return _context9.stop();
	          }
	        }
	      }, _callee9, _this);
	    }));
	
	    vm.OnChangePracticeArea = function () {
	      var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(event, selectedPracticeArea) {
	        return regeneratorRuntime.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                if (!event) {
	                  _context10.next = 4;
	                  break;
	                }
	
	                event.stopPropagation();
	                _context10.next = 10;
	                break;
	
	              case 4:
	                vm.selectedPracticeArea = selectedPracticeArea;
	
	                if (!vm.selectedPracticeArea) {
	                  _context10.next = 10;
	                  break;
	                }
	
	                try {
	                  analytics.track('Practice Areas Filter Selected', {
	                    // eslint-disable-next-line camelcase
	                    lawyer_id: vm.user.id,
	                    // eslint-disable-next-line camelcase
	                    filtered_practice_area: vm.selectedPracticeArea.name,
	                    page: 'In-House'
	                  });
	                } catch (error) {
	                  console.error('In-House', error);
	                }
	
	                _context10.next = 9;
	                return vm.select(vm.currentPage);
	
	              case 9:
	                vm.applyFilterCheck = false;
	
	              case 10:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this);
	      }));
	
	      return function (_x9, _x10) {
	        return _ref21.apply(this, arguments);
	      };
	    }();
	
	    vm.onChangeLocation = function () {
	      var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(event, selectedLocations) {
	        return regeneratorRuntime.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                if (!event) {
	                  _context11.next = 4;
	                  break;
	                }
	
	                event.stopPropagation();
	                _context11.next = 10;
	                break;
	
	              case 4:
	                vm.selectedLocations = selectedLocations;
	
	                if (!vm.selectedLocations) {
	                  _context11.next = 10;
	                  break;
	                }
	
	                try {
	                  analytics.track('Practice Areas Filter Selected', {
	                    // eslint-disable-next-line camelcase
	                    lawyer_id: vm.user.id,
	                    // eslint-disable-next-line camelcase
	                    filtered_location: vm.selectedLocations.name,
	                    page: 'In-House'
	                  });
	                } catch (error) {
	                  console.error('In-House', error);
	                }
	
	                _context11.next = 9;
	                return vm.select(vm.currentPage);
	
	              case 9:
	                vm.applyFilterCheck = false;
	
	              case 10:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, _this);
	      }));
	
	      return function (_x11, _x12) {
	        return _ref22.apply(this, arguments);
	      };
	    }();
	
	    vm.pqeChanged = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
	      var separator, minPQE, maxPQE;
	      return regeneratorRuntime.wrap(function _callee12$(_context12) {
	        while (1) {
	          switch (_context12.prev = _context12.next) {
	            case 0:
	              separator = vm.filterPQE.search(';');
	              minPQE = vm.filterPQE.slice(0, separator);
	              maxPQE = vm.filterPQE.slice(separator + 1, vm.filterPQE.length);
	
	              vm.minPQE = minPQE;
	              vm.maxPQE = maxPQE;
	
	              try {
	                analytics.track('PQE Filter Selected', {
	                  // eslint-disable-next-line camelcase
	                  lawyer_id: vm.user.id,
	                  // eslint-disable-next-line camelcase
	                  min_pqe: minPQE,
	                  // eslint-disable-next-line camelcase
	                  max_pqe: maxPQE,
	                  page: 'In-House'
	                });
	              } catch (error) {
	                console.error('In-House', error);
	              }
	
	              _context12.next = 8;
	              return vm.select(vm.currentPage);
	
	            case 8:
	              vm.applyFilterCheck = false;
	
	            case 9:
	            case 'end':
	              return _context12.stop();
	          }
	        }
	      }, _callee12, _this);
	    }));
	
	    vm.hideDropDown = function () {
	      vm.showClass = '';
	    };
	
	    vm.loadPrivateJobs = function () {
	      $location.url('/matches');
	    };
	
	    vm.formatJobs = function (position) {
	      position.isCollapsed = true;
	      position.moreDetail = true;
	      if (position.description !== null) {
	        if (position.description.length > 600) {
	          position.showButton = true;
	        }
	      }
	    };
	
	    vm.showMore = function (job) {
	      job.isCollapsed = !job.isCollapsed;
	    };
	
	    vm.jumpToLink = function (id) {
	      var oldHash;
	      oldHash = $location.hash();
	      $location.hash(id);
	      $anchorScroll();
	      $location.hash(oldHash);
	    };
	
	    vm.showLess = function (job) {
	      job.isCollapsed = !job.isCollapsed;
	      vm.jumpToLink(job.id);
	    };
	
	    vm.formatPositionDescription = function (position) {
	      position.isCollapsed = true;
	      position.moreDetail = true;
	      if (position.description !== null) {
	        if (position.description.length > 600) {
	          position.showButton = true;
	        }
	      }
	    };
	
	    vm.checkPositionIsNew = function (position) {
	      var timeDiff = Math.abs(vm.today.getTime() - new Date(position.created).getTime());
	
	      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
	
	      if (diffDays < 7) {
	        position.isNewJob = true;
	      }
	    };
	
	    vm.locationBackgroundColor = function (color) {
	      if (color) {
	        return {
	          background: color
	        };
	      }
	    };
	
	    vm.updateProfileAlertStatus = function (alertType, status) {
	      if (alertType === 'both') {
	        vm.candidate.profileCvAlertCollapsed = status;
	        vm.candidate.profilePhoneAlertCollapsed = status;
	      } else {
	        vm.candidate[alertType] = status;
	      }
	    };
	
	    vm.initializeInHouseJobs = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
	      var user, _ref25, locationsList, _ref26, candidate, _ref27, data, _ref28, legalPracticeAreaList;
	
	      return regeneratorRuntime.wrap(function _callee13$(_context13) {
	        while (1) {
	          switch (_context13.prev = _context13.next) {
	            case 0:
	              _context13.next = 2;
	              return userService.getUser();
	
	            case 2:
	              user = _context13.sent;
	
	              vm.user = user;
	              _context13.next = 6;
	              return SharedApi.getAllLocations({
	                supported: true,
	                regions: true
	              });
	
	            case 6:
	              _ref25 = _context13.sent;
	              locationsList = _ref25.data;
	
	              vm.locationsList = locationsList;
	
	              _context13.next = 11;
	              return CandidateProfileApi.getUserProfile(user.id, {
	                include: ['occupations', 'preferredContractTypes']
	              });
	
	            case 11:
	              _ref26 = _context13.sent;
	              candidate = _ref26.data;
	
	              vm.candidate = candidate;
	
	              _context13.next = 16;
	              return CandidateProfileApi.getUserProfile(user.id, {
	                include: ['preferredLocations']
	              });
	
	            case 16:
	              _ref27 = _context13.sent;
	              data = _ref27.data;
	
	              vm.candidate.preferredLocations = data.preferredLocations;
	              _context13.next = 21;
	              return SharedApi.getCategoryById(1);
	
	            case 21:
	              _ref28 = _context13.sent;
	              legalPracticeAreaList = _ref28.data;
	
	              vm.legalPracticeAreaList = legalPracticeAreaList;
	
	              vm.candidateSpecialties = practiceAreaService.makeCandidatePracticeAreasHierarchy(candidate.category, vm.legalPracticeAreaList.specialties);
	
	              vm.regionHierarchialListWithEuropeOnTop = locationsGenericService.makeCandidateLocationsHierarchy(vm.candidate.preferredLocations, vm.locationsList);
	
	              vm.curLawyer = {
	                user: {
	                  firstName: vm.user.firstName
	                },
	                candidate: {
	                  profileCvAlertCollapsed: false,
	                  profilePhoneAlertCollapsed: false
	                }
	              };
	              _context13.next = 29;
	              return vm.onNumPerPageChange();
	
	            case 29:
	              $scope.$applyAsync();
	
	            case 30:
	            case 'end':
	              return _context13.stop();
	          }
	        }
	      }, _callee13, _this);
	    }));
	
	    vm.initializeInHouseJobs();
	  }]);
	})();

/***/ }),
/* 588 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.api').factory('InviteFriendApi', ['api', function InviteFriendApi(api) {
	  var _this = this;
	
	  var inviteFriendApi = {
	    getInviteFriendsEmail: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                return _context.abrupt('return', api.get('invite-friends/email'));
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function getInviteFriendsEmail() {
	        return _ref.apply(this, arguments);
	      }
	
	      return getInviteFriendsEmail;
	    }(),
	    sendReferralEmails: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(userId, friendsList, isExternal) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                return _context2.abrupt('return', api.post('invite-friends/user/' + userId + '/isExternal/' + isExternal, friendsList));
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      function sendReferralEmails(_x, _x2, _x3) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return sendReferralEmails;
	    }(),
	    createExternalUser: function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(payload) {
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                return _context3.abrupt('return', api.post('users/external', payload));
	
	              case 1:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this);
	      }));
	
	      function createExternalUser(_x4) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return createExternalUser;
	    }()
	  };
	  return inviteFriendApi;
	}]);

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _segment = __webpack_require__(21);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	(function module() {
	  angular.module('app.ui.form.ctrls').controller('InviteFriendController', ['$log', '$scope', '$location', '$anchorScroll', 'logger', 'InviteFriendApi', function controller($log, $scope, $location, $anchorScroll, logger, InviteFriendApi) {
	    var _this = this;
	
	    var friendNameAndEmail = void 0;
	    var vm = this;
	    vm.user = { firstName: '', lastName: '', email: '' };
	    vm.pattern = /^[A-Za-z]+[\w+.]+@[.A-Za-z-]+\.[.A-Za-z]{2,5}$/;
	    vm.textToCopy = angular.element('.refer-message').text();
	    vm.editorOptions = {
	      extraPlugins: 'colorbutton'
	    };
	
	    vm.referralCode = '';
	    vm.friendsList = [];
	    friendNameAndEmail = {
	      name: '',
	      email: ''
	    };
	    vm.friendsList.push(friendNameAndEmail);
	    vm.hideDropDown = function () {
	      vm.showClass = '';
	    };
	
	    vm.showClass = '';
	    vm.showDropDown = function () {
	      if (vm.showClass === '') {
	        vm.showClass = 'show';
	      } else {
	        vm.showClass = '';
	      }
	    };
	
	    vm.copySuccess = function () {
	      (0, _segment.copyLinkClipboard)();
	      logger.notify('success', 'Link successfully copied to clipboard');
	    };
	
	    vm.showEmailInvalid = false;
	    vm.validateEmail = function (event) {
	      var index = event.target.attributes.class.value.search(' ng-invalid ');
	      if (index >= 0) {
	        vm.showEmailInvalid = true;
	      } else {
	        vm.showEmailInvalid = false;
	      }
	    };
	
	    vm.showClass = '';
	    vm.copyFail = function (error) {
	      logger.notify('error', 'Unable to copy.');
	      $log.info(error);
	    };
	
	    vm.hideDropDown = function () {
	      vm.showClass = '';
	    };
	
	    vm.showDropDown = function () {
	      if (vm.showClass === '') {
	        vm.showClass = 'show';
	      } else {
	        vm.showClass = '';
	      }
	    };
	
	    vm.populateCode = function (data) {
	      vm.referralCode = data;
	      var lexstepReferUrl = ("https://lexstep.com") + '/sign-up/' + vm.referralCode;
	      var encodedReferUrl = encodeURIComponent(lexstepReferUrl);
	      vm.shareLink = 'https://www.facebook.com/sharer/sharer.php?u=' + encodedReferUrl + '&amp;src=sdkpreparse';
	      vm.dataLink = lexstepReferUrl;
	      vm.textToCopy = lexstepReferUrl;
	      vm.referEmail.subject = 'Invitation from your friend ' + vm.user.firstName + ' ' + vm.user.lastName;
	      $scope.$apply();
	    };
	
	    vm.changeStatus = function (status) {
	      if (status === 404) {
	        vm.alertMsg = 'Error! Passwords do not match. Please try again.';
	        vm.showOnError = true;
	      } else if (status === 400) {
	        vm.alertMsg = 'Error! Emails do not match. Please try again.';
	        vm.showOnError = true;
	      } else if (status === 409) {
	        vm.alertMsg = 'Error! Email already in use. Please use another email.';
	        vm.showOnError = true;
	      } else if (status === 500) {
	        vm.alertMsg = 'Could not connect to the server. Please try again later.';
	        vm.showOnError = true;
	      } else {
	        vm.alertMsg = 'An error has occurred. Please try the action again.';
	        vm.showOnError = true;
	      }
	    };
	
	    vm.showCode = false;
	    vm.jumpToLink = function () {
	      var oldHash = $location.hash();
	      $location.hash('referralLink');
	      $anchorScroll();
	      $location.hash(oldHash);
	    };
	
	    vm.getEmailText = function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(refer) {
	        var _ref2, data, status;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return InviteFriendApi.getInviteFriendsEmail();
	
	              case 2:
	                _ref2 = _context.sent;
	                data = _ref2.data;
	                status = _ref2.status;
	
	
	                if (status === 440) $location.url('/signin');
	                vm.referEmail.emailText = stringReplaceAll(data.versions[0].html_content, '<%-referralCode%>', ("https://lexstep.com") + '/sign-up/' + refer);
	                vm.referEmail.emailText = stringReplaceAll(vm.referEmail.emailText, '{{publicURL}}', ("https://lexstep.com"));
	
	                vm.referEmail.emailText = stringReplaceAll(vm.referEmail.emailText, '{{referredPerson.name}}', '[name]');
	
	                vm.referEmail.emailText = stringReplaceAll(vm.referEmail.emailText, '{{user.firstName}}', vm.user.firstName);
	                vm.referEmail.emailText = stringReplaceAll(vm.referEmail.emailText, '{{ user.lastName}}', vm.user.lastName);
	                vm.referEmail.emailText = stringReplaceAll(vm.referEmail.emailText, '{{user.referralCode}}', vm.referralCode);
	                $scope.$apply();
	
	              case 13:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    vm.referEmail = {
	      friendsName: [],
	      friendsEmail: [],
	      subject: '',
	      frCount: 0,
	      emailText: '',
	      friends: []
	    };
	    vm.isFriendsListFilled = function () {
	      var friendsListSize = void 0;
	      var index = void 0;
	      var k = void 0;
	      var reference = void 0;
	      friendsListSize = vm.friendsList.length;
	      for (index = 0, k = 0, reference = friendsListSize; reference >= 0 ? k < reference : k > reference; index = reference >= 0 ? ++k : --k) {
	        if (!vm.friendsList[index].email) {
	          return false;
	        }
	      }
	
	      return true;
	    };
	
	    vm.sendReferEmail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	      var _ref4, status;
	
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              vm.referEmail.friends = vm.friendsList;
	              vm.referEmail.emailText = vm.referEmail.emailText.replace('[yourFirstName]', vm.user.firstName);
	              vm.referEmail.emailText = vm.referEmail.emailText.replace('[yourLastName]', vm.user.lastName);
	
	              _context2.next = 5;
	              return InviteFriendApi.sendReferralEmails(vm.user.id, vm.friendsList, true);
	
	            case 5:
	              _ref4 = _context2.sent;
	              status = _ref4.status;
	
	              if (!(status !== 201)) {
	                _context2.next = 9;
	                break;
	              }
	
	              return _context2.abrupt('return', logger.notify('error', 'There has been an error in sending your emails. Please try again'));
	
	            case 9:
	              if (!(status === 201)) {
	                _context2.next = 11;
	                break;
	              }
	
	              return _context2.abrupt('return', logger.notify('success', 'Email(s) have been sent successfully.'));
	
	            case 11:
	
	              (0, _segment.sendEmailEvent)();
	
	            case 12:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this);
	    }));
	
	    vm.anotherFriend = function () {
	      friendNameAndEmail = {
	        name: '',
	        email: ''
	      };
	      if (vm.friendsList.length < 5) {
	        vm.friendsList.push(friendNameAndEmail);
	      }
	    };
	
	    vm.removeFriend = function (removedFriend) {
	      var itemToBeRemovedIndex = vm.friendsList.indexOf(removedFriend);
	      vm.friendsList.splice(itemToBeRemovedIndex, 1);
	    };
	
	    vm.addUser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	      var externalUserResponse, externalUser;
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              vm.showOnError = false;
	              _context3.next = 3;
	              return InviteFriendApi.createExternalUser(vm.user);
	
	            case 3:
	              externalUserResponse = _context3.sent;
	
	
	              if (externalUserResponse.status === 201) {
	                externalUser = externalUserResponse.data;
	
	                vm.referralCode = 'e' + externalUser.id;
	                vm.getEmailText(vm.referralCode);
	                (0, _segment.earnOneThousandGetYourLink)(externalUser.firstName, externalUser.lastName, externalUser.email);
	                vm.user.id = externalUser.id;
	                vm.showCode = true;
	                vm.showOnError = false;
	                vm.jumpToLink();
	                vm.linkOnly = 'col-md-offset-1 col-md-10';
	                vm.populateCode(vm.referralCode);
	
	                $scope.$applyAsync();
	              } else vm.changeStatus(externalUserResponse.status);
	
	            case 5:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this);
	    }));
	
	    vm.onClickShareFacebook = function () {
	      (0, _segment.shareFacebook)();
	    };
	  }]);
	})();
	
	var stringReplaceAll = function stringReplaceAll(target, search, replacement) {
	  return target.replace(new RegExp(search, 'g'), replacement);
	};

/***/ }),
/* 590 */
/***/ (function(module, exports) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  'use strict';
	
	  angular.module('app.jobApplicationHistory', ['pascalprecht.translate', 'angularFileUpload', 'angular.filter', 'ngSlider', 'ngCookies', 'ngAnimate', 'ngSanitize', 'angularSpinner', 'angular-clipboard', 'ui.nested.combobox']).controller('jobApplicationHistoryCtrl', ['$http', '$log', '$location', '$scope', 'currentLawyer', '$modal', '$window', '$translate', '$cookies', 'logger', '$filter', 'usSpinnerService', 'jobApplicationEmailID', 'sharedProperties', 'lawyerAndAdminID', function ($http, $log, $location, $scope, currentLawyer, $modal, $window, $translate, $cookies, logger, $filter, usSpinnerService, jobApplicationEmailID, sharedProperties, lawyerAndAdminID) {
	    sharedProperties.verifyUser(_.range(11, 18));
	    $http.post('/api/fetch-current-user', {
	      'contentType': 'application/json'
	    }).then(function (_ref) {
	      var data = _ref.data,
	          status = _ref.status,
	          headers = _ref.headers,
	          config = _ref.config;
	
	      $scope.user = data;
	      lawyerAndAdminID.setModel('user', $scope.user.userType);
	    }, function (data) {
	      $log.info('error');
	    });
	    $scope.emailHistoryList = [];
	    $scope.numPerPageOpt = [10, 20, 50];
	    $scope.numPerPage = $scope.numPerPageOpt[2];
	    $scope.currentPage = 1;
	    $scope.currentPageItems = [];
	    $scope.row = '';
	    $scope.rorder = '';
	    $scope.totalEmailHistoryList = 0;
	
	    // Start the spinning loader
	    usSpinnerService.spin('lexstep-spinner');
	    // Fetch the Application History Records
	    $http.post('/api/fetch-job-application-history').then(function (_ref2) {
	      var data = _ref2.data,
	          status = _ref2.status,
	          headers = _ref2.headers,
	          config = _ref2.config;
	
	      $scope.emailHistoryList = data;
	      $scope.totalEmailHistoryList = $scope.emailHistoryList.length;
	
	      // Format UI for fetched records to be used as for the
	      // pagination
	      $scope.select(1);
	      // Stop the spinning loader to show that the application
	      // records has been loaded
	      usSpinnerService.stop('lexstep-spinner');
	    }).catch(function (_ref3) {
	      var data = _ref3.data,
	          status = _ref3.status,
	          headers = _ref3.headers,
	          config = _ref3.config;
	
	      if (status === 440) {
	        $location.url('/signin');
	      }
	      // Stop the spinning loader to show that the request
	      // is completed
	      usSpinnerService.stop('lexstep-spinner');
	    });
	
	    $scope.logOut = function () {
	      sharedProperties.logOut();
	    };
	
	    $scope.select = function (page) {
	      var end, start;
	      start = (page - 1) * $scope.numPerPage;
	      end = start + $scope.numPerPage;
	      return $scope.currentPageItems = $scope.emailHistoryList.slice(start, end);
	    };
	    $scope.onNumPerPageChange = function () {
	      $scope.select(1);
	      return $scope.currentPage = 1;
	    };
	    $scope.onOrderChange = function () {
	      $scope.select(1);
	      return $scope.currentPage = 1;
	    };
	    $scope.order = function (rowName, rorder) {
	      if (rorder === "desc") {
	        rowName = '-' + rowName;
	      }
	      if ($scope.row === rowName && $scope.rorder === rorder) {
	        return;
	      }
	      $scope.row = rowName;
	      $scope.emailHistoryList = $filter('orderBy')($scope.emailHistoryList, rowName);
	      return $scope.onOrderChange();
	    };
	    $scope.viewJobApplicationEmail = function (emailID) {
	      $log.info(emailID);
	      jobApplicationEmailID.setModel('emailID', emailID);
	      $log.info("Again");
	      $log.info(jobApplicationEmailID.getModel('emailID'));
	      $location.url('/admin/email-history-view');
	    };
	    $scope.logOut = function () {
	      sharedProperties.logOut();
	    };
	    $scope.backButton = function () {
	      $http.post('/api/show-inhouse-firms').then(function (_ref4) {
	        var data = _ref4.data,
	            status = _ref4.status,
	            headers = _ref4.headers,
	            config = _ref4.config;
	
	        $location.url('/admin/admin-listings');
	      }, function (data) {
	        $log.info('error');
	      });
	    };
	
	    return $scope.navigateToEmailListing = function () {
	      $location.url('/admin/email-listing');
	    };
	  }]);
	}).call(undefined);

/***/ }),
/* 591 */
/***/ (function(module, exports) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  'use strict';
	
	  angular.module('app.jobApplicationHistory').factory('jobApplicationCRUD', ['$log', '$http', function ($log, $http) {}, {}]).factory('jobApplicationEmailID', [function () {
	    var factory, model;
	    factory = {};
	    model = {};
	    factory.setModel = function (key, value) {
	      model[key] = value;
	    };
	    factory.getModel = function (key) {
	      return model[key];
	    };
	    return factory;
	  }]);
	}).call(undefined);

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  angular.module('app.jobApplicationHistory').controller('viewApplicationBodyCtrl', ['$http', '$log', '$location', '$scope', 'currentLawyer', '$modal', '$window', '$translate', '$cookies', 'logger', '$filter', 'jobApplicationEmailID', '$sce', 'lawyerAndAdminID', function ($http, $log, $location, $scope, currentLawyer, $modal, $window, $translate, $cookies, logger, $filter, jobApplicationEmailID, $sce, lawyerAndAdminID) {
	    $http.post('/api/fetch-current-user', {
	      'contentType': 'application/json'
	    }).then(function (_ref) {
	      var data = _ref.data,
	          status = _ref.status,
	          headers = _ref.headers,
	          config = _ref.config;
	
	      $scope.user = data;
	      lawyerAndAdminID.setModel('user', $scope.user.userType);
	    }, function (data) {
	      $log.info('error');
	    });
	    $scope.emailID = jobApplicationEmailID.getModel('emailID');
	    if (!$scope.emailID) {
	      $location.url('/admin/email-history');
	    }
	    $scope.email = [];
	    $http.post('/api/fetch-job-application-history-by-id', {
	      emailID: $scope.emailID
	    }).then(function (_ref2) {
	      var data = _ref2.data,
	          status = _ref2.status,
	          headers = _ref2.headers,
	          config = _ref2.config;
	
	      $scope.email = data;
	      $scope.emailContent = $sce.trustAsHtml($scope.email.email_data);
	    }, function (_ref3) {
	      var data = _ref3.data,
	          status = _ref3.status;
	
	      if (status === 440) {
	        $location.url('/signin');
	      }
	    });
	    $scope.downloadCV = function () {
	      var loc;
	      loc = $scope.email.cv_url.replace('' + ("https://api.lexstep.com"), "");
	      $window.open(loc, '_blank');
	    };
	    $scope.backButton = function () {
	      return $location.url('/admin/email-history');
	    };
	
	    return $scope.navigateToEmailListing = function () {
	      $http.post('/api/admin/navigate-email-listing'.then(function (_ref4) {
	        var data = _ref4.data,
	            status = _ref4.status,
	            headers = _ref4.headers,
	            config = _ref4.config;
	
	        $location.url('/admin/email-listing');
	      }, function (data) {
	        $log.info('error');
	      }));
	    };
	  }]);
	}).call(undefined);

/***/ }),
/* 593 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	  angular.module('app.ui.form.ctrls').controller('JobCreateCtrl', ['$http', '$log', '$location', '$scope', 'sharedProperties', '$modal', 'lawyerAndAdminID', 'logger', function ($http, $log, $location, $scope, sharedProperties, $modal, lawyerAndAdminID, logger) {
	    var searchQuery;
	    sharedProperties.verifyUser(_.range(11, 18));
	    this.showOnSuccess = false;
	    this.showOnError = false;
	    $scope.newJobData = {
	      pqe: "-2;11",
	      firm: {},
	      location: [],
	      min_pqe: -2,
	      max_pqe: 11,
	      jobCategory: 1,
	      visibility: true
	    };
	    $scope.editorOptions = {
	      extraPlugins: 'colorbutton'
	    };
	    this.firmNames = [];
	    $scope.practiceAreas = [];
	    $scope.locations = [];
	    $scope.nrefLocations = [];
	    this.alertMsg = '';
	    $scope.minValue = 2;
	    $scope.maxValue = 11;
	    $scope.editPractices = false;
	    $scope.options = {
	      round: 1,
	      from: -2,
	      to: 11,
	      step: 1,
	      dimension: "+ years",
	      scale: [-2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, "11+"]
	    };
	    $scope.jobExp = [];
	    $scope.visibleFirms = [];
	    $scope.inVisibleFirms = [];
	    $scope.newJobData.description = "";
	    $scope.newJobData.jobContract = 1;
	    $scope.newJobData.jobRole = 1;
	    searchQuery = $location.search().isInhouseJob;
	    if (searchQuery) {
	      $scope.newJobData.firm = searchQuery;
	    }
	    $http.post('/api/job-firm-name', {
	      'contentType': 'application/json'
	    }).then(function (_ref) {
	      var data = _ref.data;
	
	      $scope.populateFirms(data);
	    }, function (_ref2) {
	      var status = _ref2.status;
	
	      $log.info('error');
	      $scope.changeStatus(status);
	    });
	    $http.post('/api/fetch-all-contracts', {
	      'contentType': 'application/json'
	    }).then(function (_ref3) {
	      var data = _ref3.data;
	
	      $scope.refContracts = data;
	    }, function () {
	      $log.info('error');
	    });
	    $http.post('/api/fetch-all-roles', {
	      'contentType': 'application/json'
	    }).then(function (_ref4) {
	      var data = _ref4.data;
	
	      $scope.refRoles = data;
	    }, function () {
	      $log.info('error');
	    });
	    $scope.modalPractices = [];
	    $scope.notify = function (type, message) {
	      switch (type) {
	        case 'info':
	          logger.log(message);
	          break;
	        case 'success':
	          logger.logSuccess(message);
	          break;
	        case 'warning':
	          logger.logWarning(message);
	          break;
	        case 'error':
	          logger.logError(message);
	      }
	    };
	    $scope.showClass = "";
	    $scope.hideDropDown = function () {
	      $scope.showClass = "";
	    };
	    $scope.showDropDown = function () {
	      if ($scope.showClass === "") {
	        $scope.showClass = "show";
	      } else {
	        $scope.showClass = "";
	      }
	    };
	    $scope.pqeChange = function () {
	      var seperator;
	      seperator = $scope.newJobData.pqe.search(";");
	      if (seperator === 1) {
	        $scope.newJobData.min_pqe = parseInt($scope.newJobData.pqe.slice(0, 1));
	        $scope.newJobData.max_pqe = parseInt($scope.newJobData.pqe.slice(2, 5));
	      } else if (seperator === 2) {
	        $scope.newJobData.min_pqe = parseInt($scope.newJobData.pqe.slice(0, 2));
	        $scope.newJobData.max_pqe = parseInt($scope.newJobData.pqe.slice(3, 5));
	      }
	    };
	    $scope.navigateToEmailListing = function () {
	      $http.post('/api/admin/navigate-email-listing').then(function () {
	        $location.url('/admin/email-listing');
	      }, function () {
	        $log.info('error');
	      });
	    };
	    $scope.firmNames = [];
	    $scope.populateFirms = function (data) {
	      var ADMIN_USER_TYPE_ID = 1,
	          ADMIN2_USER_TYPE_ID = 7;
	      $scope.firmNames = data;
	      $scope.firmNames.forEach(function (firm) {
	        if (firm.firm.refCategoryCatID !== 2 && $scope.user.refUserTypeUserTypeID === 5 || firm.firm.refCategoryCatID === 2 && $scope.user.refUserTypeUserTypeID === 6 || $scope.user.refUserTypeUserTypeID === ADMIN_USER_TYPE_ID || $scope.user.userType === ADMIN_USER_TYPE_ID || $scope.user.userType === ADMIN2_USER_TYPE_ID) {
	          if (firm.firm.firm_Visibility) {
	            firm.group = "VISIBLE FIRMS";
	          } else {
	            firm.group = "INVISIBLE FIRMS";
	          }
	        }
	      });
	      if (searchQuery) {
	        $scope.setPrePopulatedJobValues();
	      }
	    };
	
	    $scope.setPrePopulatedJobValues = function () {
	      $scope.firmNames.forEach(function (firm) {
	        if (firm.user_ID === $scope.newJobData.firm.user_ID) {
	          $scope.newJobData.jobCategory = 1;
	          $scope.newJobData.firmCategory = firm.firm.refCategoryCatID;
	          $scope.newJobData.job_Address = angular.copy(firm.firm.firm_Address);
	        }
	      });
	    };
	
	    $scope.navigateToinHouseJobs = function () {
	      $http.post('/api/admin/navigate-email-listing').then(function () {
	        $location.url('/admin/admin-listings?inhouse-jobs');
	      }, function () {
	        $log.info('error');
	      });
	    };
	    $scope.mapAddress = function () {
	      this.firmNames.forEach(function (firm) {
	        if (firm.user_ID === $scope.newJobData.firm.user_ID) {
	          $scope.newJobData.jobCategory = 1;
	          $scope.newJobData.firmCategory = firm.firm.refCategoryCatID;
	          $scope.newJobData.job_Address = angular.copy(firm.firm.firm_Address);
	        }
	        if (firm.firm && firm.firm.firm_Visibility) {
	          $scope.visibleFirms.push(firm);
	        } else {
	          $scope.inVisibleFirms.push(firm);
	        }
	      });
	    };
	    $scope.setJobCategory = function () {
	      $scope.newJobData.location = $scope.locations;
	      if ($scope.newJobData.jobCategory === 1) {
	        $scope.newJobData.is_custom = false;
	        $scope.newJobData.is_connected = false;
	        $scope.newJobData.isSpeculative = false;
	        $scope.newJobData.ATS_link = null;
	      }
	      if ($scope.newJobData.jobCategory === 2) {
	        $scope.newJobData.is_custom = true;
	        $scope.newJobData.is_connected = false;
	        $scope.newJobData.isSpeculative = false;
	        $scope.newJobData.ATS_link = null;
	      }
	      if ($scope.newJobData.jobCategory === 3) {
	        $scope.newJobData.is_connected = true;
	        $scope.newJobData.isSpeculative = false;
	        $scope.newJobData.is_custom = false;
	        $scope.newJobData.ATS_link = null;
	      }
	      if ($scope.newJobData.jobCategory === 4) {
	        $scope.newJobData.isSpeculative = true;
	        $scope.newJobData.is_connected = false;
	        $scope.newJobData.is_custom = false;
	        $scope.newJobData.ATS_link = null;
	      }
	      if ($scope.newJobData.jobCategory === 5) {
	        $scope.newJobData.isSpeculative = false;
	        $scope.newJobData.is_connected = false;
	        $scope.newJobData.is_custom = false;
	      }
	    };
	    $scope.addJob = function () {
	      var message;
	      $scope.setJobCategory();
	      if ($scope.newJobData.description === null) {
	        $scope.newJobData.description = "";
	      }
	      if ($scope.editPractices && $scope.editLocations) {
	        $http.post('/api/job-create', $scope.newJobData).then(function () {
	          $scope.areasToShow.forEach(function (practice) {
	            if (practice.isSelected) {
	              practice.isSelected = false;
	            }
	          });
	          $scope.tempPrac = angular.copy($scope.areasToShow);
	          $scope.formatPractices($scope.areasToShow);
	          $scope.newJobData = {};
	          $scope.newJobData.min_pqe = -2;
	          $scope.newJobData.max_pqe = 11;
	          $scope.newJobData.jobContract = 1;
	          $scope.newJobData.jobRole = 1;
	          $scope.newJobData.pqe = "-2;11";
	          $scope.modalPractices = [];
	          $scope.newJobData.practices = [];
	          $scope.newJobData.locations = [];
	          $scope.locations = [];
	          $scope.newJobData.jobCategory = 1;
	          $scope.editPractices = false;
	          $scope.editLocations = false;
	          $scope.newJobData.visibility = true;
	          $scope.nrefLocations.forEach(function (loc) {
	            if (loc.isSelected === true) {
	              loc.isSelected = false;
	              return loc.locations.forEach(function (locations) {
	                if (locations.isSelected === true) {
	                  locations.isSelected = false;
	                  return locations.sub_areas.forEach(function (sub_areas) {
	                    if (sub_areas.isSelected === true) {
	                      return sub_areas.isSelected = false;
	                    }
	                  });
	                }
	              });
	            }
	          });
	          $scope.notify('success', 'Job has been added successfully.');
	        }, function () {
	          $scope.notify('error', 'An error has occurred. Please try again.');
	        });
	      } else {
	        if (!$scope.editLocations) {
	          message = "Please select at least one Location.";
	          $scope.notify("error", message);
	        }
	        if (!$scope.editPractices) {
	          message = "Please select at least one practice area.";
	          $scope.notify("error", message);
	        }
	      }
	    };
	    $scope.ifInHouseInvisibleFirm = function (firm) {
	      if (firm.firm_Name === searchQuery) {
	        return true;
	      } else {
	        return "";
	      }
	    };
	    $scope.ifInHouseVisibleFirm = function (firm) {
	      if (firm.firm_Name === searchQuery) {
	        return true;
	      } else {
	        return "";
	      }
	    };
	    $scope.openPracticeModal = function (event) {
	      var count, modalInstance;
	      event.preventDefault();
	      event.stopPropagation();
	      $scope.modalPractices = angular.copy($scope.refPractices);
	      count = 0;
	      modalInstance = $modal.open({
	        templateUrl: "SelectPracticesModal.html",
	        controller: 'jobPracticesModalCtrl',
	        resolve: {
	          data: function data() {
	            return $scope.modalPractices;
	          }
	        }
	      });
	      modalInstance.result.then(function (selectedItem) {
	        $scope.newJobData.practices = angular.copy(selectedItem.linearPractices);
	        $scope.areasToShow = angular.copy(selectedItem.linearPractices);
	        $scope.refPractices = angular.copy(selectedItem.data);
	        selectedItem.linearPractices.forEach(function (practice) {
	          if (practice.isSelected) {
	            count++;
	          }
	        });
	        if (count > 0) {
	          $scope.editPractices = true;
	        } else {
	          $scope.editPractices = false;
	        }
	      }, function () {
	        $scope.modalPractices = [];
	      });
	    };
	    $scope.openModal = function (event) {
	      var id, modalInstance;
	      id = event.target.attributes.id.value;
	      $scope.modalData = {
	        element: '',
	        data: []
	      };
	      if (id === 'select-locations') {
	        $scope.modalData.element = 'location';
	        $scope.tempLocations = angular.copy($scope.nrefLocations);
	        $scope.modalData.data = angular.copy($scope.tempLocations);
	      } else if (id === 'select-practices') {
	        $scope.modalData.element = 'practice';
	        $scope.tempPractices = angular.copy($scope.refPractices);
	        $scope.modalData.data = angular.copy($scope.tempPractices);
	        $scope.modalData.linearPractices = angular.copy($scope.areasToShow);
	      }
	      modalInstance = $modal.open({
	        templateUrl: "AddJobModal.html",
	        controller: 'CreateProfileModalCtrl',
	        resolve: {
	          data: function data() {
	            return $scope.modalData;
	          }
	        }
	      });
	      return modalInstance.result.then(function (selectedItem) {
	        var count;
	        if (selectedItem.element === 'location') {
	          $scope.nrefLocations = angular.copy(selectedItem.data);
	          $scope.requestedData = {
	            updated_data: angular.copy($scope.tempLocations)
	          };
	          count = 0;
	          $scope.locations = [];
	          selectedItem.data.forEach(function (location) {
	            if (location.isSelected) {
	              $scope.locations.push(location);
	              location.locations.forEach(function (loc) {
	                if (loc.isSelected) {
	                  $scope.locations.push(loc);
	                  count++;
	                  loc.sub_areas.forEach(function (sub) {
	                    if (sub.isSelected) {
	                      $scope.locations.push(sub);
	                      count++;
	                    }
	                  });
	                }
	              });
	            }
	          });
	          if (count > 0) {
	            $scope.editLocations = true;
	          } else {
	            $scope.editLocations = false;
	          }
	        } else if (selectedItem.element === 'practice') {
	          $scope.tempPractices = angular.copy(selectedItem.data);
	          $scope.requestedData = {
	            currentLawyer: $scope.loggedInLawyer.lawyer.lawyer_ID,
	            updated_data: angular.copy($scope.tempPractices),
	            linearPractices: angular.copy(selectedItem.linearPractices)
	          };
	          $scope.selectPractices($scope.requestedData);
	        }
	      }, function () {
	        $scope.tempLocations = {};
	        $scope.tempPractices = {};
	      });
	    };
	    $scope.changeStatus = function (status) {
	      if (status === 200) {
	        this.alertMsg = 'Congratulations! Job has been Successfully created.';
	        this.showOnSuccess = true;
	      } else if (status === 440) {
	        $location.url('/signin');
	      } else {
	        this.alertMsg = 'An error has occurred. Please try again.';
	        this.showOnError = true;
	      }
	    };
	    this.logOut = function () {
	      sharedProperties.logOut();
	    };
	    $http.post('/api/fetchJobExp', {
	      'contentType': 'application/json'
	    }).then(function (_ref5) {
	      var data = _ref5.data;
	
	      $scope.jobExp = data;
	    }, function () {});
	    $scope.areasToShow = [];
	    $scope.refPractices = [];
	    $scope.showPracticeButton = false;
	    $http.post('/api/profile-practice-areas', {
	      'contentType': 'application/json'
	    }).then(function (_ref6) {
	      var data = _ref6.data;
	
	      $scope.formatPractices(data);
	      $scope.showPracticeButton = true;
	    }, function (_ref7) {
	      var status = _ref7.status;
	
	      $log.info('error');
	      $scope.changeStatus(status);
	    });
	    $scope.formatPractices = function (data) {
	      $scope.areasToShow = [];
	      $scope.refPractices = [];
	      data.forEach(function (area) {
	        $scope.areasToShow.push(area);
	        if (area.law_area === null && area.practice_area === null) {
	          area.practices = [];
	          $scope.refPractices.push(area);
	          data.forEach(function (prac_area) {
	            if (prac_area.law_area === area.practice_ID && prac_area.practice_area === null) {
	              prac_area.sub_areas = [];
	              area.practices.push(prac_area);
	              data.forEach(function (sub_area) {
	                if (sub_area.law_area !== null && sub_area.practice_area === prac_area.practice_ID) {
	                  prac_area.sub_areas.push(sub_area);
	                }
	              });
	            }
	          });
	        }
	      });
	    };
	    $scope.populateLocation = function (data) {
	      data.forEach(function (loc) {
	        if (loc.region === null && loc.area === null) {
	          loc.locations = [];
	          $scope.nrefLocations.push(loc);
	          data.forEach(function (region_area) {
	            if (region_area.region === loc.loc_ID && region_area.area === null) {
	              region_area.sub_areas = [];
	              loc.locations.push(region_area);
	              data.forEach(function (sub_area) {
	                if (sub_area.region !== null && sub_area.area === region_area.loc_ID) {
	                  region_area.sub_areas.push(sub_area);
	                }
	              });
	            }
	          });
	        }
	      });
	      $scope.refLocations = data;
	    };
	    $http.post('/api/profile-location', {
	      'contentType': 'application/json'
	    }).then(function (_ref8) {
	      var data = _ref8.data;
	
	      $scope.locations = data;
	      $scope.populateLocation(data);
	    }, function (_ref9) {
	      var status = _ref9.status;
	
	      $log.info('error');
	      $scope.changeStatus(status);
	    });
	  }]);
	})();

/***/ }),
/* 594 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	(function () {
	  angular.module('app.ui.form.ctrls').controller('JobEditCtrl', ['INHOUSE_CATEGORY', '$http', '$log', '$location', '$scope', 'sharedProperties', '$modal', 'usSpinnerService', 'logger', '$timeout', function (INHOUSE_CATEGORY, $http, $log, $location, $scope, sharedProperties, $modal, usSpinnerService, logger, $timeout) {
	    var cloneJob = void 0,
	        updateJob = void 0;
	    $scope.editorOptions = {
	      extraPlugins: 'colorbutton'
	    };
	    $scope.jobID = $location.search().job;
	    if ($location.search().isClone === "true") $scope.isCloneJob = true;else $scope.isCloneJob = false;
	    sharedProperties.verifyUser(_.range(11, 18));
	
	    function navigateBackToTheRespectiveListing(categoryId) {
	      $location.url('/admin/admin-listings?list=' + (categoryId === INHOUSE_CATEGORY ? 'inhouse-jobs' : 'jobs'));
	    }
	
	    $scope.startSpin = function () {
	      if (!$scope.spinneractive && !$scope.recordFetched) {
	        usSpinnerService.spin('spinner-2');
	        $scope.spinneractive = true;
	        $scope.startcounter++;
	      }
	    };
	    $scope.stopSpin = function () {
	      if ($scope.spinneractive) {
	        usSpinnerService.stop('spinner-2');
	        $scope.spinneractive = false;
	      }
	    };
	    $scope.updatedJob = {
	      pqe: "-2;11"
	    };
	    $scope.firms = [];
	    $scope.jobPractices = [];
	    $scope.practiceAreas = [];
	    $scope.jobExp = [];
	    $scope.showClass = "";
	    $scope.hideDropDown = function () {
	      $scope.showClass = "";
	    };
	    $scope.showDropDown = function () {
	      if ($scope.showClass === "") {
	        $scope.showClass = "show";
	      } else {
	        $scope.showClass = "";
	      }
	    };
	    $scope.mapAddress = function () {
	      $scope.firms.forEach(function (firm, index, array) {
	        if (firm.user.firm_Name === $scope.updatedJob.firm.user.firm_Name) {
	          $scope.updatedJob.jobCategory = 1;
	          $scope.updatedJob.firmCategory = firm.refCategoryCatID;
	          $scope.updatedJob.job_Address = angular.copy(firm.firm_Address);
	        }
	      });
	    };
	    $scope.getJobCategory = function () {
	      if ($scope.updatedJob.is_custom) {
	        $scope.updatedJob.jobCategory = "2";
	      } else if ($scope.updatedJob.is_connected) {
	        $scope.updatedJob.jobCategory = "3";
	      } else if ($scope.updatedJob.isSpeculative) {
	        $scope.updatedJob.jobCategory = "4";
	      } else if ($scope.updatedJob.ATS_link) {
	        $scope.updatedJob.jobCategory = "5";
	      } else {
	        $scope.updatedJob.jobCategory = "1";
	      }
	    };
	    // $http.post('/api/get-edit-job', {
	    //   'contentType': 'application/json'
	    // }).then(function({data, status, headers, config}) {
	    var getJobInformation = function getJobInformation() {
	      $scope.startSpin('spinner-2');
	      if ($scope.isCloneJob) {
	        $scope.pageTitle = "Clone Job";
	        $scope.actionTitle = "Clone";
	      } else {
	        $scope.pageTitle = "Edit Position";
	        $scope.actionTitle = "Update";
	      }
	      $http.post('/api/job-firm-name', {
	        'contentType': 'application/json'
	      }).then(function (_ref) {
	        var data = _ref.data,
	            status = _ref.status,
	            headers = _ref.headers,
	            config = _ref.config;
	
	        $scope.populateFirms(data);
	        $scope.stopSpin('spinner-2');
	      }, function (_ref2) {
	        var data = _ref2.data,
	            status = _ref2.status;
	
	        $log.info('error');
	        $scope.changeStatus(status);
	      });
	      $http.post('/api/fetch-all-contracts', {
	        'contentType': 'application/json'
	      }).then(function (_ref3) {
	        var data = _ref3.data,
	            status = _ref3.status,
	            headers = _ref3.headers,
	            config = _ref3.config;
	
	        $scope.refContracts = data;
	      }, function (data) {
	        $log.info('error');
	      });
	      $http.post('/api/fetch-all-roles', {
	        'contentType': 'application/json'
	      }).then(function (_ref4) {
	        var data = _ref4.data,
	            status = _ref4.status,
	            headers = _ref4.headers,
	            config = _ref4.config;
	
	        $scope.refRoles = data;
	      }, function (data) {
	        $log.info('error');
	      });
	
	      $scope.locations = [];
	      $http.post('/api/profile-practice-areas', {
	        'contentType': 'application/json'
	      }).then(function (_ref5) {
	        var data = _ref5.data,
	            status = _ref5.status,
	            headers = _ref5.headers,
	            config = _ref5.config;
	
	        $scope.practiceAreas = data;
	        $http.post('/api/fetch-job-practices', {
	          id: $scope.jobID
	        }).then(function (_ref6) {
	          var data = _ref6.data,
	              status = _ref6.status,
	              headers = _ref6.headers,
	              config = _ref6.config;
	
	          $scope.jobPractices = data;
	          $scope.updatedJob.practices = $scope.jobPractices;
	          if ($scope.jobPractices.length > 0) {
	            $scope.showTags = true;
	          } else {
	            $scope.showTags = false;
	          }
	          $scope.mapPractices();
	        }, function (_ref7) {
	          var data = _ref7.data,
	              status = _ref7.status;
	
	          if (status === 440) {
	            $location.url('/signin');
	          }
	        });
	      }, function (_ref8) {
	        var data = _ref8.data,
	            status = _ref8.status;
	
	        $log.info('error');
	        $scope.changeStatus(status);
	      });
	    };
	    getJobInformation();
	    // },function(data) {});
	    $http.post('/api/fetchJobExp', {
	      'contentType': 'application/json'
	    }).then(function (_ref9) {
	      var data = _ref9.data,
	          status = _ref9.status,
	          headers = _ref9.headers,
	          config = _ref9.config;
	
	      $scope.jobExp = data;
	    }, function (data) {});
	    $scope.mapJobLocations = function () {
	      return $scope.nrefLocations.forEach(function (loc, index, array) {
	        $scope.jobLocations.forEach(function (uloc, index, array) {
	          if (loc.loc_ID === uloc.loc_ID) {
	            loc.isSelected = true;
	          }
	          return loc.locations.forEach(function (region_area, index, array) {
	            $scope.jobLocations.forEach(function (rloc, index, array) {
	              if (region_area.loc_ID === rloc.loc_ID) {
	                region_area.isSelected = true;
	              }
	              return region_area.sub_areas.forEach(function (sub_area, index, array) {
	                $scope.jobLocations.forEach(function (rloc, index, array) {
	                  if (sub_area.loc_ID === rloc.loc_ID) {
	                    return sub_area.isSelected = true;
	                  }
	                });
	              });
	            });
	          });
	        });
	      });
	    };
	
	    $scope.areasToShow = [];
	    $scope.mapPractices = function () {
	      $scope.jobPractices.forEach(function (job_area, index, array) {
	        $scope.practiceAreas.forEach(function (area, index, array) {
	          if (job_area.refPracticePracticeID === area.practice_ID) {
	            area.isSelected = true;
	          }
	        });
	      });
	      $scope.practiceAreas.forEach(function (area, index, array) {
	        $scope.areasToShow.push(area);
	        if (area.law_area === null && area.practice_area === null) {
	          area.practices = [];
	          $scope.refPractices.push(area);
	          $scope.practiceAreas.forEach(function (prac_area, index, array) {
	            if (prac_area.law_area === area.practice_ID && prac_area.practice_area === null) {
	              prac_area.sub_areas = [];
	              area.practices.push(prac_area);
	              $scope.practiceAreas.forEach(function (sub_area, index, array) {
	                if (sub_area.law_area !== null && sub_area.practice_area === prac_area.practice_ID) {
	                  prac_area.sub_areas.push(sub_area);
	                }
	              });
	            }
	          });
	        }
	      });
	      $scope.jobPractices = angular.copy($scope.practiceAreas);
	    };
	    this.showOnSuccess = false;
	    this.showOnError = false;
	    $scope.curFirm = {};
	    this.firmNames = [];
	    $scope.locations = [];
	    $scope.nrefLocations = [];
	    this.alertMsg = '';
	    $scope.minValue = -2;
	    $scope.maxValue = 11;
	    $scope.options = {
	      round: 1,
	      from: -2,
	      to: 11,
	      step: 1,
	      dimension: "+ years",
	      scale: [-2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, "11+"]
	    };
	    $scope.jobLastDateChanged = function () {
	      return $scope.updatedJob.reopen_date = new Date();
	    };
	    $scope.pqeChange = function () {
	      var seperator;
	      seperator = $scope.updatedJob.pqe.search(";");
	      if (seperator === 1) {
	        $scope.updatedJob.min_pqe = parseInt($scope.updatedJob.pqe.slice(0, 1));
	        $scope.updatedJob.max_pqe = parseInt($scope.updatedJob.pqe.slice(2, 5));
	      } else if (seperator === 2) {
	        $scope.updatedJob.min_pqe = parseInt($scope.updatedJob.pqe.slice(0, 2));
	        $scope.updatedJob.max_pqe = parseInt($scope.updatedJob.pqe.slice(3, 5));
	      }
	    };
	    $scope.visibleFirms = [];
	    $scope.inVisibleFirms = [];
	    $scope.populateFirms = function () {
	      $scope.firms = _.sortBy($scope.firms, function (firm) {
	        return -firm.firm_Visibility;
	      });
	      $scope.firms.forEach(function (firm, index, array) {
	        if (firm.firm_Visibility) {
	          firm.firm_Visibility = "VISIBLE FIRMS";
	        } else {
	          firm.firm_Visibility = "INVISIBLE FIRMS";
	        }
	        if (firm.firm_ID === $scope.updatedJob.firmFirmID) {
	          $scope.curFirm.name = firm.firm_Name;
	          $scope.curFirm.id = firm.firm_ID;
	          $scope.updatedJob.firm = firm;
	          return false;
	        }
	      });
	    };
	    $scope.mapFirms = function () {
	      $scope.firms.forEach(function (firm, index, array) {
	        firm.firm_Name = firm.user.firm_Name;
	      });
	      $scope.populateFirms();
	    };
	    $scope.openPracticeModal = function (event) {
	      var modalInstance;
	      event.preventDefault();
	      event.stopPropagation();
	      $scope.tempPractices = angular.copy($scope.refPractices);
	      modalInstance = $modal.open({
	        templateUrl: "SelectPracticesModal.html",
	        controller: 'jobPracticesModalCtrl',
	        resolve: {
	          data: function data() {
	            return $scope.tempPractices;
	          }
	        }
	      });
	      return modalInstance.result.then(function (selectedItem) {
	        var count;
	        $scope.practiceAreas = angular.copy(selectedItem.linearPractices);
	        count = 0;
	        selectedItem.linearPractices.forEach(function (prac, index, array) {
	          if (prac.isSelected) {
	            count++;
	          }
	        });
	        if (count > 0) {
	          $scope.showTags = true;
	        } else {
	          $scope.showTags = false;
	        }
	        $scope.refPractices = angular.copy(selectedItem.data);
	        $scope.updatedJob.practices = angular.copy(selectedItem.linearPractices);
	        $scope.jobPractices = angular.copy(selectedItem.linearPractices);
	      }, function () {
	        $scope.tempPractices = {};
	      });
	    };
	    $scope.openModal = function (event) {
	      var id, modalInstance;
	      id = event.target.attributes.id.value;
	      $scope.modalData = {
	        element: '',
	        data: []
	      };
	      if (id === 'select-locations') {
	        $scope.modalData.element = 'location';
	        $scope.tempLocations = angular.copy($scope.nrefLocations);
	        $scope.modalData.data = angular.copy($scope.tempLocations);
	      } else if (id === 'select-practices') {
	        $scope.modalData.element = 'practice';
	        $scope.tempPractices = angular.copy($scope.refPractices);
	        $scope.modalData.data = angular.copy($scope.tempPractices);
	        $scope.modalData.linearPractices = angular.copy($scope.areasToShow);
	      }
	      modalInstance = $modal.open({
	        templateUrl: "EditJobModal.html",
	        controller: 'CreateProfileModalCtrl',
	        resolve: {
	          data: function data() {
	            return $scope.modalData;
	          }
	        }
	      });
	      return modalInstance.result.then(function (selectedItem) {
	        var count;
	        if (selectedItem.element === 'location') {
	          $scope.nrefLocations = angular.copy(selectedItem.data);
	          $scope.requestedData = {
	            updated_data: angular.copy($scope.tempLocations)
	          };
	          count = 0;
	          $scope.jobLocations = [];
	          selectedItem.data.forEach(function (location, index, array) {
	            if (location.isSelected) {
	              $scope.jobLocations.push(location);
	              location.locations.forEach(function (loc, index, array) {
	                if (loc.isSelected) {
	                  $scope.jobLocations.push(loc);
	                  count++;
	                  loc.sub_areas.forEach(function (sub, index, array) {
	                    if (sub.isSelected) {
	                      $scope.jobLocations.push(sub);
	                      count++;
	                    }
	                  });
	                }
	              });
	            }
	          });
	          if (count > 0) {
	            $scope.editLocations = true;
	          } else {
	            $scope.editLocations = false;
	          }
	        } else if (selectedItem.element === 'practice') {
	          $scope.tempPractices = angular.copy(selectedItem.data);
	          $scope.requestedData = {
	            currentLawyer: $scope.loggedInLawyer.lawyer.lawyer_ID,
	            updated_data: angular.copy($scope.tempPractices),
	            linearPractices: angular.copy(selectedItem.linearPractices)
	          };
	          $scope.selectPractices($scope.requestedData);
	        }
	      }, function () {
	        $scope.tempLocations = {};
	        $scope.tempPractices = {};
	      });
	    };
	    $scope.changeStatus = function (status) {
	      if (status === 200) {
	        this.alertMsg = 'Congratulations! Job has been Successfully created.';
	        this.showOnSuccess = true;
	      } else if (status === 440) {
	        $location.url('/signin');
	      } else {
	        this.alertMsg = 'An error has occurred. Please try again.';
	        this.showOnError = true;
	      }
	    };
	    this.logOut = function () {
	      sharedProperties.logOut();
	    };
	    this.editJob = function () {
	      if ($scope.updatedJob.job_description === null) {
	        $scope.updatedJob.job_description = "";
	      }
	      if ($scope.isCloneJob) {
	        cloneJob();
	      } else {
	        updateJob();
	      }
	    };
	    this.cancelEditing = function () {
	      navigateBackToTheRespectiveListing($scope.updatedJob.firm.refCategoryCatID);
	    };
	    cloneJob = function cloneJob() {
	      var message;
	      $scope.setJobCategory();
	      if ($scope.showTags && $scope.editLocations) {
	        $http.post('/api/admin/cloneJob', $scope.updatedJob).then(function (_ref10) {
	          var data = _ref10.data,
	              status = _ref10.status,
	              headers = _ref10.headers,
	              config = _ref10.config;
	
	          var message;
	          message = 'Job cloned successfully.';
	          logger.notify('success', message);
	          navigateBackToTheRespectiveListing($scope.updatedJob.firm.refCategoryCatID);
	        }, function (data) {
	          var message;
	          $log.info('error');
	          message = 'An error has occurred. Please try again.';
	          logger.notify('error', message);
	        });
	        return;
	      } else {
	        if (!$scope.editLocations) {
	          message = "Please select at least one Location.";
	          logger.notify("error", message);
	        }
	        if (!$scope.showTags) {
	          message = "Please select at least one practice area.";
	          logger.notify("error", message);
	        }
	      }
	    };
	    $scope.setJobCategory = function () {
	      $scope.updatedJob.location = $scope.jobLocations;
	      if ($scope.updatedJob.jobCategory === "2") {
	        $scope.updatedJob.is_custom = true;
	        $scope.updatedJob.is_connected = false;
	        $scope.updatedJob.isSpeculative = false;
	        $scope.updatedJob.ATS_link = null;
	      }
	      if ($scope.updatedJob.jobCategory === "3") {
	        $scope.updatedJob.is_connected = true;
	        $scope.updatedJob.is_custom = false;
	        $scope.updatedJob.isSpeculative = false;
	        $scope.updatedJob.ATS_link = null;
	      }
	      if ($scope.updatedJob.jobCategory === "4") {
	        $scope.updatedJob.isSpeculative = true;
	        $scope.updatedJob.is_connected = false;
	        $scope.updatedJob.is_custom = false;
	        $scope.updatedJob.ATS_link = null;
	      }
	      if ($scope.updatedJob.jobCategory === "1") {
	        $scope.updatedJob.isSpeculative = false;
	        $scope.updatedJob.is_connected = false;
	        $scope.updatedJob.is_custom = false;
	        $scope.updatedJob.ATS_link = null;
	      }
	      if ($scope.updatedJob.jobCategory === "5") {
	        $scope.updatedJob.isSpeculative = false;
	        $scope.updatedJob.is_connected = false;
	        $scope.updatedJob.is_custom = false;
	      }
	    };
	    updateJob = function updateJob() {
	      var message;
	      $scope.setJobCategory();
	      if ($scope.showTags && $scope.editLocations) {
	        $http.post('/api/admin/updateJob', $scope.updatedJob).then(function (_ref11) {
	          var data = _ref11.data,
	              status = _ref11.status,
	              headers = _ref11.headers,
	              config = _ref11.config;
	
	          $scope.startSpin('spinner-2');
	          $timeout(function () {
	            $scope.stopSpin('spinner-2');
	            var message;
	            message = 'Job edited successfully.';
	            logger.notify('success', message);
	            navigateBackToTheRespectiveListing($scope.updatedJob.firm.refCategoryCatID);
	          }, 3000);
	        }, function (data) {
	          var message;
	          $log.info('error');
	          message = 'An error has occurred. Please try again.';
	          logger.notify('error', message);
	        });
	        return;
	      } else {
	        if (!$scope.editLocations) {
	          message = "Please select at least one Location.";
	          logger.notify("error", message);
	        }
	        if (!$scope.showTags) {
	          message = "Please select at least one practice area.";
	          logger.notify("error", message);
	        }
	      }
	    };
	    this.deleteJob = function () {
	      var modalInstance;
	      modalInstance = $modal.open({
	        templateUrl: "deleteJobModal.html",
	        controller: 'deleteJobModalCtrl',
	        resolve: {
	          data: function data() {
	            return $scope.jobID;
	          }
	        }
	      });
	      return modalInstance.result.then(function (selectedItem) {
	        if (selectedItem) {
	          $http.post('/api/admin/deleteJob', {
	            id: $scope.jobID
	          }).then(function (_ref12) {
	            var data = _ref12.data,
	                status = _ref12.status,
	                headers = _ref12.headers,
	                config = _ref12.config;
	
	            $scope.changeStatus(status, 'delete');
	            navigateBackToTheRespectiveListing($scope.updatedJob.firm.refCategoryCatID);
	          }, function (_ref13) {
	            var data = _ref13.data,
	                status = _ref13.status;
	
	            return $scope.changeStatus(status, '');
	          });
	        }
	      }, function () {
	        return;
	      });
	    };
	    $scope.refPractices = [];
	    $scope.populateAreas = function (data) {
	      this.practiceAreas = data;
	    };
	    $scope.populateLocation = function (data) {
	      data.forEach(function (loc, index, array) {
	        if (loc.region === null && loc.area === null) {
	          loc.locations = [];
	          $scope.nrefLocations.push(loc);
	          data.forEach(function (region_area, index, array) {
	            if (region_area.region === loc.loc_ID && region_area.area === null) {
	              region_area.sub_areas = [];
	              loc.locations.push(region_area);
	              data.forEach(function (sub_area, index, array) {
	                if (sub_area.region !== null && sub_area.area === region_area.loc_ID) {
	                  region_area.sub_areas.push(sub_area);
	                }
	              });
	            }
	          });
	        }
	      });
	      $scope.refLocations = data;
	    };
	
	    var fetchAndMapRefLocations = function fetchAndMapRefLocations() {
	      return $http.post('/api/profile-location', {
	        'contentType': 'application/json'
	      }).then(function (_ref14) {
	        var data = _ref14.data,
	            status = _ref14.status,
	            headers = _ref14.headers,
	            config = _ref14.config;
	
	        $scope.locations = data;
	        $scope.populateLocation(data);
	      }, function (_ref15) {
	        var data = _ref15.data,
	            status = _ref15.status;
	
	        $log.info('error');
	        $scope.changeStatus(status);
	      });
	    };
	
	    var getJobInfo = function getJobInfo(jobId) {
	      $http.post('/api/admin/getJob', { id: jobId }).then(function (_ref16) {
	        var data = _ref16.data,
	            status = _ref16.status,
	            headers = _ref16.headers,
	            config = _ref16.config;
	
	        $scope.updatedJob = Object.assign($scope.updatedJob, data);
	        $scope.updatedJob.pqe = data.job_min_pqe + ';' + data.job_max_pqe;
	        $scope.updatedJob.last_date_to_apply = $scope.updatedJob.last_date_to_apply ? new Date($scope.updatedJob.last_date_to_apply) : $scope.updatedJob.last_date_to_apply;
	        $scope.getJobCategory();
	        $scope.jobLocations = $scope.updatedJob.ref_locations;
	        $scope.jobLocations.forEach(function (loc, index, array) {
	          return loc.isSelected = true;
	        });
	        $scope.mapJobLocations();
	        if ($scope.jobLocations.length > 0) {
	          $scope.editLocations = true;
	        } else {
	          $scope.editLocations = false;
	        }
	        $http.post('/api/admin/fetchAllFirms', {
	          'contentType': 'application/json'
	        }).then(function (_ref17) {
	          var data = _ref17.data,
	              status = _ref17.status,
	              headers = _ref17.headers,
	              config = _ref17.config;
	
	          data.forEach(function (firm, index, array) {
	            if (!firm.firm_isDeleted) {
	              $scope.firms.push(firm);
	            }
	          });
	          $scope.mapFirms();
	        }, function (_ref18) {
	          var data = _ref18.data,
	              status = _ref18.status;
	
	          $scope.changeStatus(status);
	        });
	      }, function (_ref19) {
	        var data = _ref19.data,
	            status = _ref19.status;
	
	        $scope.changeStatus(status, '');
	      });
	    };
	
	    (function () {
	      var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return fetchAndMapRefLocations();
	
	              case 2:
	                getJobInfo($scope.jobID);
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function loadJobDetails() {
	        return _ref20.apply(this, arguments);
	      }
	
	      return loadJobDetails;
	    })()();
	  }]);
	})();

/***/ }),
/* 595 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	  angular.module('app.ui.form.ctrls').controller('deleteJobModalCtrl', ['$scope', '$http', '$log', '$modalInstance', '$location', 'data', function ($scope, $http, $log, $modalInstance, $location, data) {
	    $scope.confirmDeletion = false;
	    $scope.yes = function () {
	      $scope.confirmDeletion = true;
	      $modalInstance.close($scope.confirmDeletion);
	    };
	    $scope.no = function () {
	      $modalInstance.dismiss("cancel");
	    };
	  }]);
	})();

/***/ }),
/* 596 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	  'use strict';
	
	  angular.module('app.LawyerProfile').factory('LawyerProfileService', function ($log, $http, $q) {
	    return {
	      fetchDataForSharingProfile: function fetchDataForSharingProfile(user_ID, firm_ID, job_ID) {
	        var defer = $q.defer(),
	            data = {
	          user_resumes: null,
	          firm: null,
	          practices: null
	        };
	
	        $q.all([$http.post('/api/fetch-user-resumes', { id: user_ID }, { 'contentType': 'application/json' }), $http.post('/api/admin/getFirm', { id: firm_ID }, { 'contentType': 'application/json' }), $http.post('/api/fetch-job-practices', { id: job_ID }, { 'contentType': 'application/json' })]).then(function (responses) {
	          data.user_resumes = responses[0].data;
	          data.firm = responses[1].data;
	          data.practices = responses[2].data;
	          defer.resolve(data);
	        }, function (error) {
	          defer.reject(error);
	        });
	
	        return defer.promise;
	      },
	      fetchDataForSharingProfileSuggestedFirm: function fetchDataForSharingProfileSuggestedFirm(user_ID, firm_ID, job_ID) {
	        var defer = $q.defer(),
	            data = {
	          user_resumes: null,
	          firm: null,
	          practices: null
	        };
	
	        $q.all([$http.post('/api/fetch-user-resumes', { id: user_ID }, { 'contentType': 'application/json' }), $http.post('/api/admin/getFirm', { id: firm_ID }, { 'contentType': 'application/json' })]).then(function (responses) {
	          data.user_resumes = responses[0].data;
	          data.firm = responses[1].data;
	          defer.resolve(data);
	        }, function (error) {
	          defer.reject(error);
	        });
	
	        return defer.promise;
	      },
	      fetchAllFirms: function fetchAllFirms() {
	        var defer = $q.defer();
	
	        $http.post('/api/fetchFirms', {
	          'contentType': 'application/json'
	        }).then(function (_ref) {
	          var data = _ref.data,
	              status = _ref.status,
	              headers = _ref.headers,
	              config = _ref.config;
	
	          $log.info("****Admin fetch firms****");
	          defer.resolve(data);
	        }, function (error) {
	          defer.reject(error);
	        });
	
	        return defer.promise;
	      },
	      applyForJob: function applyForJob(jobData) {
	        var defer = $q.defer();
	
	        $http.post('/api/apply-lawyer-job', jobData).then(function (_ref2) {
	          var data = _ref2.data,
	              status = _ref2.status,
	              headers = _ref2.headers,
	              config = _ref2.config;
	
	          defer.resolve("success");
	        }, function (error) {
	          defer.reject(error);
	        });
	
	        return defer.promise;
	      },
	      applyForInhouseJob: function applyForInhouseJob(jobData) {
	        var defer = $q.defer();
	
	        $http.post('/api/apply-lawyer-inhouse-job', jobData).then(function (_ref3) {
	          var data = _ref3.data,
	              status = _ref3.status,
	              headers = _ref3.headers,
	              config = _ref3.config;
	
	          defer.resolve("success");
	        }, function (error) {
	          defer.reject(error);
	        });
	
	        return defer.promise;
	      },
	      applyForSuggestedFirm: function applyForSuggestedFirm(jobData) {
	        var defer = $q.defer();
	        $log.info("jobData", jobData);
	        $http.post('/api/apply-lawyer-firm', jobData).then(function (_ref4) {
	          var data = _ref4.data,
	              status = _ref4.status,
	              headers = _ref4.headers,
	              config = _ref4.config;
	
	          defer.resolve("success");
	        }, function (error) {
	          defer.reject(error);
	        });
	
	        return defer.promise;
	      }
	    };
	  });
	}).call(undefined);

/***/ }),
/* 597 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var nameSorter = function nameSorter(employer) {
	  return employer.name.toLowerCase();
	};
	
	angular.module('app.api').factory('CandidateProfileApi', ['api', 'userService', '$rootScope', function CandidateProfileApi(api, userService, $rootScope) {
	  var _this = this;
	
	  var candidateProfileAPi = {
	    followEmployer: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(userId, employerId) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                return _context.abrupt('return', api.post('users/' + userId + '/follow/' + employerId));
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function followEmployer(_x, _x2) {
	        return _ref.apply(this, arguments);
	      }
	
	      return followEmployer;
	    }(),
	    unFollowEmployer: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(userId, employerId) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                return _context2.abrupt('return', api.delete('users/' + userId + '/follow/' + employerId));
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      function unFollowEmployer(_x3, _x4) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return unFollowEmployer;
	    }(),
	    getUserProfile: function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id, payload) {
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                return _context3.abrupt('return', api.get('users/' + id + '/profile', {
	                  params: payload
	                }));
	
	              case 1:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this);
	      }));
	
	      function getUserProfile(_x5, _x6) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return getUserProfile;
	    }(),
	    getUserFollowEmployers: function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                return _context4.abrupt('return', api.get('users/' + id + '/follow'));
	
	              case 1:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this);
	      }));
	
	      function getUserFollowEmployers(_x7) {
	        return _ref4.apply(this, arguments);
	      }
	
	      return getUserFollowEmployers;
	    }(),
	    getUserHiddenEmployers: function () {
	      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                return _context5.abrupt('return', api.get('users/' + id + '/hidden'));
	
	              case 1:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this);
	      }));
	
	      function getUserHiddenEmployers(_x8) {
	        return _ref5.apply(this, arguments);
	      }
	
	      return getUserHiddenEmployers;
	    }(),
	    getUserBlockedEmployers: function () {
	      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
	        return regeneratorRuntime.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                return _context6.abrupt('return', api.get('users/' + id + '/blocked'));
	
	              case 1:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this);
	      }));
	
	      function getUserBlockedEmployers(_x9) {
	        return _ref6.apply(this, arguments);
	      }
	
	      return getUserBlockedEmployers;
	    }(),
	    updateUserBlockedEmployers: function () {
	      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id, payload) {
	        return regeneratorRuntime.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                return _context7.abrupt('return', api.put('users/' + id + '/blocked', payload));
	
	              case 1:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this);
	      }));
	
	      function updateUserBlockedEmployers(_x10, _x11) {
	        return _ref7.apply(this, arguments);
	      }
	
	      return updateUserBlockedEmployers;
	    }(),
	    getUserResumes: function () {
	      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
	        return regeneratorRuntime.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                return _context8.abrupt('return', api.get('users/' + id + '/profile/resumes'));
	
	              case 1:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this);
	      }));
	
	      function getUserResumes(_x12) {
	        return _ref8.apply(this, arguments);
	      }
	
	      return getUserResumes;
	    }(),
	    getResume: function () {
	      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
	        return regeneratorRuntime.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                return _context9.abrupt('return', api.get('resumes/' + id));
	
	              case 1:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this);
	      }));
	
	      function getResume(_x13) {
	        return _ref9.apply(this, arguments);
	      }
	
	      return getResume;
	    }(),
	    deleteUserResume: function () {
	      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(id, resumeId) {
	        return regeneratorRuntime.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                return _context10.abrupt('return', api.delete('users/' + id + '/profile/resume', { params: { resumeId: resumeId } }));
	
	              case 1:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this);
	      }));
	
	      function deleteUserResume(_x14, _x15) {
	        return _ref10.apply(this, arguments);
	      }
	
	      return deleteUserResume;
	    }(),
	    updateUserResumeName: function () {
	      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(id, parameters) {
	        return regeneratorRuntime.wrap(function _callee11$(_context11) {
	          while (1) {
	            switch (_context11.prev = _context11.next) {
	              case 0:
	                return _context11.abrupt('return', api.put('users/' + id + '/profile/resume/name', {}, { params: parameters }));
	
	              case 1:
	              case 'end':
	                return _context11.stop();
	            }
	          }
	        }, _callee11, _this);
	      }));
	
	      function updateUserResumeName(_x16, _x17) {
	        return _ref11.apply(this, arguments);
	      }
	
	      return updateUserResumeName;
	    }(),
	    getLoginHistory: function () {
	      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(id) {
	        return regeneratorRuntime.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                return _context12.abrupt('return', api.get('actions?category=user&target=' + id));
	
	              case 1:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, _this);
	      }));
	
	      function getLoginHistory(_x18) {
	        return _ref12.apply(this, arguments);
	      }
	
	      return getLoginHistory;
	    }(),
	    unHideEmployer: function () {
	      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(userId, employerId) {
	        return regeneratorRuntime.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                return _context13.abrupt('return', api.delete('users/' + userId + '/hidden/' + employerId));
	
	              case 1:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, _this);
	      }));
	
	      function unHideEmployer(_x19, _x20) {
	        return _ref13.apply(this, arguments);
	      }
	
	      return unHideEmployer;
	    }(),
	    getEmailSubscriptions: function () {
	      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(userId) {
	        return regeneratorRuntime.wrap(function _callee14$(_context14) {
	          while (1) {
	            switch (_context14.prev = _context14.next) {
	              case 0:
	                return _context14.abrupt('return', api.get('users/' + userId + '/subscriptions'));
	
	              case 1:
	              case 'end':
	                return _context14.stop();
	            }
	          }
	        }, _callee14, _this);
	      }));
	
	      function getEmailSubscriptions(_x21) {
	        return _ref14.apply(this, arguments);
	      }
	
	      return getEmailSubscriptions;
	    }(),
	
	    pauseEmail: function () {
	      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(userId, emailType, noOfDays) {
	        var payload;
	        return regeneratorRuntime.wrap(function _callee15$(_context15) {
	          while (1) {
	            switch (_context15.prev = _context15.next) {
	              case 0:
	                payload = {
	                  days: noOfDays ? noOfDays : 30
	                };
	                return _context15.abrupt('return', api.put('users/' + userId + '/subscriptions/' + emailType + '/pause', payload));
	
	              case 2:
	              case 'end':
	                return _context15.stop();
	            }
	          }
	        }, _callee15, _this);
	      }));
	
	      function pauseEmail(_x22, _x23, _x24) {
	        return _ref15.apply(this, arguments);
	      }
	
	      return pauseEmail;
	    }(),
	    unpauseEmail: function () {
	      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(userId, emailType) {
	        return regeneratorRuntime.wrap(function _callee16$(_context16) {
	          while (1) {
	            switch (_context16.prev = _context16.next) {
	              case 0:
	                return _context16.abrupt('return', api.put('users/' + userId + '/subscriptions/' + emailType + '/unpause'));
	
	              case 1:
	              case 'end':
	                return _context16.stop();
	            }
	          }
	        }, _callee16, _this);
	      }));
	
	      function unpauseEmail(_x25, _x26) {
	        return _ref16.apply(this, arguments);
	      }
	
	      return unpauseEmail;
	    }(),
	    subscribe: function () {
	      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(userId, emailType) {
	        return regeneratorRuntime.wrap(function _callee17$(_context17) {
	          while (1) {
	            switch (_context17.prev = _context17.next) {
	              case 0:
	                return _context17.abrupt('return', api.post('users/' + userId + '/subscriptions/' + emailType));
	
	              case 1:
	              case 'end':
	                return _context17.stop();
	            }
	          }
	        }, _callee17, _this);
	      }));
	
	      function subscribe(_x27, _x28) {
	        return _ref17.apply(this, arguments);
	      }
	
	      return subscribe;
	    }(),
	    unsubscribe: function () {
	      var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(userId, emailType) {
	        return regeneratorRuntime.wrap(function _callee18$(_context18) {
	          while (1) {
	            switch (_context18.prev = _context18.next) {
	              case 0:
	                return _context18.abrupt('return', api.delete('users/' + userId + '/subscriptions/' + emailType));
	
	              case 1:
	              case 'end':
	                return _context18.stop();
	            }
	          }
	        }, _callee18, _this);
	      }));
	
	      function unsubscribe(_x29, _x30) {
	        return _ref18.apply(this, arguments);
	      }
	
	      return unsubscribe;
	    }(),
	    uploadResume: function () {
	      var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(userId, file) {
	        return regeneratorRuntime.wrap(function _callee19$(_context19) {
	          while (1) {
	            switch (_context19.prev = _context19.next) {
	              case 0:
	                return _context19.abrupt('return', api.post('users/' + userId + '/profile/resume', file, {
	                  headers: { 'Content-Type': undefined }
	                }));
	
	              case 1:
	              case 'end':
	                return _context19.stop();
	            }
	          }
	        }, _callee19, _this);
	      }));
	
	      function uploadResume(_x31, _x32) {
	        return _ref19.apply(this, arguments);
	      }
	
	      return uploadResume;
	    }(),
	    uploadProfilePhoto: function () {
	      var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(userId, file) {
	        return regeneratorRuntime.wrap(function _callee20$(_context20) {
	          while (1) {
	            switch (_context20.prev = _context20.next) {
	              case 0:
	                return _context20.abrupt('return', api.post('users/' + userId + '/profile/photo', file, {
	                  headers: { 'Content-Type': undefined }
	                }));
	
	              case 1:
	              case 'end':
	                return _context20.stop();
	            }
	          }
	        }, _callee20, _this);
	      }));
	
	      function uploadProfilePhoto(_x33, _x34) {
	        return _ref20.apply(this, arguments);
	      }
	
	      return uploadProfilePhoto;
	    }(),
	    deleteProfilePhoto: function () {
	      var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(userId) {
	        return regeneratorRuntime.wrap(function _callee21$(_context21) {
	          while (1) {
	            switch (_context21.prev = _context21.next) {
	              case 0:
	                return _context21.abrupt('return', api.delete('users/' + userId + '/profile/photo'));
	
	              case 1:
	              case 'end':
	                return _context21.stop();
	            }
	          }
	        }, _callee21, _this);
	      }));
	
	      function deleteProfilePhoto(_x35) {
	        return _ref21.apply(this, arguments);
	      }
	
	      return deleteProfilePhoto;
	    }(),
	    getExperiences: function () {
	      var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(userId) {
	        return regeneratorRuntime.wrap(function _callee22$(_context22) {
	          while (1) {
	            switch (_context22.prev = _context22.next) {
	              case 0:
	                return _context22.abrupt('return', api.get('users/' + userId + '/experience'));
	
	              case 1:
	              case 'end':
	                return _context22.stop();
	            }
	          }
	        }, _callee22, _this);
	      }));
	
	      function getExperiences(_x36) {
	        return _ref22.apply(this, arguments);
	      }
	
	      return getExperiences;
	    }(),
	    getEmployersList: function () {
	      var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
	        var unsorted;
	        return regeneratorRuntime.wrap(function _callee23$(_context23) {
	          while (1) {
	            switch (_context23.prev = _context23.next) {
	              case 0:
	                _context23.next = 2;
	                return api.get('employers?include=id&include=name');
	
	              case 2:
	                unsorted = _context23.sent;
	                return _context23.abrupt('return', {
	                  config: unsorted.config,
	                  headers: unsorted.headers,
	                  status: unsorted.status,
	                  statusText: unsorted.statusText,
	                  xhrStatus: unsorted.xhrStatus,
	                  data: _.sortBy(unsorted.data, nameSorter)
	                });
	
	              case 4:
	              case 'end':
	                return _context23.stop();
	            }
	          }
	        }, _callee23, _this);
	      }));
	
	      function getEmployersList() {
	        return _ref23.apply(this, arguments);
	      }
	
	      return getEmployersList;
	    }(),
	    getCandidateList: function () {
	      var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
	        return regeneratorRuntime.wrap(function _callee24$(_context24) {
	          while (1) {
	            switch (_context24.prev = _context24.next) {
	              case 0:
	                return _context24.abrupt('return', api.get('users/candidates'));
	
	              case 1:
	              case 'end':
	                return _context24.stop();
	            }
	          }
	        }, _callee24, _this);
	      }));
	
	      function getCandidateList() {
	        return _ref24.apply(this, arguments);
	      }
	
	      return getCandidateList;
	    }(),
	    updateUserData: function () {
	      var _ref25 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(id, payload) {
	        var user, updatedUser;
	        return regeneratorRuntime.wrap(function _callee25$(_context25) {
	          while (1) {
	            switch (_context25.prev = _context25.next) {
	              case 0:
	                _context25.next = 2;
	                return userService.getUser();
	
	              case 2:
	                user = _context25.sent;
	                _context25.next = 5;
	                return api.put('users/' + id, payload);
	
	              case 5:
	                updatedUser = _context25.sent;
	
	                if (!(updatedUser.data.id === user.id)) {
	                  _context25.next = 10;
	                  break;
	                }
	
	                _context25.next = 9;
	                return userService.setUser(updatedUser.data);
	
	              case 9:
	                $rootScope.user = updatedUser.data;
	
	              case 10:
	                return _context25.abrupt('return', updatedUser);
	
	              case 11:
	              case 'end':
	                return _context25.stop();
	            }
	          }
	        }, _callee25, _this);
	      }));
	
	      function updateUserData(_x37, _x38) {
	        return _ref25.apply(this, arguments);
	      }
	
	      return updateUserData;
	    }(),
	    updateProfileData: function () {
	      var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26(id, payload) {
	        return regeneratorRuntime.wrap(function _callee26$(_context26) {
	          while (1) {
	            switch (_context26.prev = _context26.next) {
	              case 0:
	                console.debug('updateProfileData(' + id + ')', payload);
	                return _context26.abrupt('return', api.put('users/' + id + '/profile', payload));
	
	              case 2:
	              case 'end':
	                return _context26.stop();
	            }
	          }
	        }, _callee26, _this);
	      }));
	
	      function updateProfileData(_x39, _x40) {
	        return _ref26.apply(this, arguments);
	      }
	
	      return updateProfileData;
	    }(),
	    getAdminAndCorporateUsers: function () {
	      var _ref27 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
	        return regeneratorRuntime.wrap(function _callee27$(_context27) {
	          while (1) {
	            switch (_context27.prev = _context27.next) {
	              case 0:
	                return _context27.abrupt('return', api.get('users?role=admin&role=corporate&isArchived=false'));
	
	              case 1:
	              case 'end':
	                return _context27.stop();
	            }
	          }
	        }, _callee27, _this);
	      }));
	
	      function getAdminAndCorporateUsers() {
	        return _ref27.apply(this, arguments);
	      }
	
	      return getAdminAndCorporateUsers;
	    }(),
	    getUserSettings: function () {
	      var _ref28 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28(id) {
	        return regeneratorRuntime.wrap(function _callee28$(_context28) {
	          while (1) {
	            switch (_context28.prev = _context28.next) {
	              case 0:
	                return _context28.abrupt('return', api.get('users/' + id + '/settings'));
	
	              case 1:
	              case 'end':
	                return _context28.stop();
	            }
	          }
	        }, _callee28, _this);
	      }));
	
	      function getUserSettings(_x41) {
	        return _ref28.apply(this, arguments);
	      }
	
	      return getUserSettings;
	    }(),
	    updateUserSettings: function () {
	      var _ref29 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29(userId, settingId, enable) {
	        return regeneratorRuntime.wrap(function _callee29$(_context29) {
	          while (1) {
	            switch (_context29.prev = _context29.next) {
	              case 0:
	                return _context29.abrupt('return', api.put('users/' + userId + '/setting/' + settingId + '?enable=' + enable));
	
	              case 1:
	              case 'end':
	                return _context29.stop();
	            }
	          }
	        }, _callee29, _this);
	      }));
	
	      function updateUserSettings(_x42, _x43, _x44) {
	        return _ref29.apply(this, arguments);
	      }
	
	      return updateUserSettings;
	    }(),
	    getLastConversation: function () {
	      var _ref30 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30(userId) {
	        return regeneratorRuntime.wrap(function _callee30$(_context30) {
	          while (1) {
	            switch (_context30.prev = _context30.next) {
	              case 0:
	                return _context30.abrupt('return', api.get('users/' + userId + '/agent/last-conversation'));
	
	              case 1:
	              case 'end':
	                return _context30.stop();
	            }
	          }
	        }, _callee30, _this);
	      }));
	
	      function getLastConversation(_x45) {
	        return _ref30.apply(this, arguments);
	      }
	
	      return getLastConversation;
	    }(),
	    updateCandidateApprovalStatus: function updateCandidateApprovalStatus(userId, payload) {
	      return api.put('users/' + userId + '/approval-status', payload);
	    }
	  };
	  return candidateProfileAPi;
	}]);

/***/ }),
/* 598 */
/***/ (function(module, exports) {

	'use strict';
	
	// eslint-disable-next-line unicorn/filename-case
	angular.module('app.LawyerProfile', ['pascalprecht.translate', 'angular.filter', 'ngSlider', 'ngCookies', 'ngAnimate', 'ngSanitize', 'angularSpinner', 'angular-clipboard', 'ui.nested.combobox']);

/***/ }),
/* 599 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.api').factory('MakeMeAnOfferApi', ['api', function MakeMeAnOfferApi(api) {
	  var _this = this;
	
	  var makeMeAnOfferApi = {
	    getCandidateEmployerRecommendations: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id, payload, candidate) {
	        var result;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.debug('MMO::getCandidateEmployerRecommendations', {
	                  id: id,
	                  payload: payload,
	                  candidate: candidate
	                });
	                _context.next = 3;
	                return api.get('recommendations/candidate/' + id + '/employer', {
	                  params: payload
	                });
	
	              case 3:
	                result = _context.sent;
	
	
	                console.debug('MMO::result', result);
	
	                return _context.abrupt('return', result);
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function getCandidateEmployerRecommendations(_x, _x2, _x3) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getCandidateEmployerRecommendations;
	    }()
	  };
	  return makeMeAnOfferApi;
	}]);

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _loadingOverlay = __webpack_require__(20);
	
	var _formatPqe = __webpack_require__(55);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable camelcase */
	
	
	(function module() {
	  angular.module('app.ui.form.ctrls').controller('MakeMeAnOfferController', ['$location', '$scope', 'logger', '$translate', '$anchorScroll', 'SharedApi', 'CandidateProfileApi', 'practiceAreaService', 'locationsGenericService', 'MakeMeAnOfferApi', 'MatchesApi', 'usSpinnerService', '$timeout', '$uibModal', 'userService', 'socket', 'sharedProperties', function controller($location, $scope, logger, $translate, $anchorScroll, SharedApi, CandidateProfileApi, practiceAreaService, locationsGenericService, MakeMeAnOfferApi, MatchesApi, usSpinnerService, $timeout, $uibModal, userService, socket, sharedProperties) {
	    var _this = this;
	
	    $translate.use('en');
	    var vm = this;
	    socket.on('CANDIDATE_APPROVAL_STATUS_UPDATE', function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                $timeout(function () {
	                  if (vm.user.id === data && $location.url().contains('opportunities')) {
	                    vm.initializeMakeMeAnOfferPage();
	                  }
	                }, 2000);
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }());
	
	    socket.on('CANDIDATE_RECOMMENDATION_GENERATED', function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(candidateId) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                $timeout(function () {
	                  if (vm.user.id === candidateId && $location.url().contains('opportunities')) {
	                    vm.select(vm.currentPage);
	                  }
	                }, 1500);
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      return function (_x2) {
	        return _ref2.apply(this, arguments);
	      };
	    }());
	
	    socket.on('CANDIDATE_ASSIGNED_AGENT_UPDATE', function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(candidateId) {
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	                  var _ref5, candidate;
	
	                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                    while (1) {
	                      switch (_context3.prev = _context3.next) {
	                        case 0:
	                          if (!(vm.user.id === candidateId && $location.url().contains('opportunities'))) {
	                            _context3.next = 9;
	                            break;
	                          }
	
	                          _context3.next = 3;
	                          return CandidateProfileApi.getUserProfile(vm.user.id);
	
	                        case 3:
	                          _ref5 = _context3.sent;
	                          candidate = _ref5.data;
	                          _context3.next = 7;
	                          return sharedProperties.getAgentDetails(candidate.agent);
	
	                        case 7:
	                          vm.candidateAgent = _context3.sent;
	
	                          $scope.$applyAsync();
	
	                        case 9:
	                        case 'end':
	                          return _context3.stop();
	                      }
	                    }
	                  }, _callee3, _this);
	                })), 1000);
	
	              case 1:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this);
	      }));
	
	      return function (_x3) {
	        return _ref3.apply(this, arguments);
	      };
	    }());
	
	    socket.on('CANDIDATE_PROFILE_AGENT_UPDATE', function () {
	      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(candidateId) {
	        return regeneratorRuntime.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	                  var _ref8, candidate;
	
	                  return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                    while (1) {
	                      switch (_context5.prev = _context5.next) {
	                        case 0:
	                          if (!(vm.user.id === candidateId && $location.url().contains('opportunities'))) {
	                            _context5.next = 9;
	                            break;
	                          }
	
	                          _context5.next = 3;
	                          return CandidateProfileApi.getUserProfile(vm.user.id);
	
	                        case 3:
	                          _ref8 = _context5.sent;
	                          candidate = _ref8.data;
	                          _context5.next = 7;
	                          return sharedProperties.getAgentDetails(candidate.agent);
	
	                        case 7:
	                          vm.candidateAgent = _context5.sent;
	
	                          $scope.$applyAsync();
	
	                        case 9:
	                        case 'end':
	                          return _context5.stop();
	                      }
	                    }
	                  }, _callee5, _this);
	                })), 1000);
	
	              case 1:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this);
	      }));
	
	      return function (_x4) {
	        return _ref6.apply(this, arguments);
	      };
	    }());
	
	    vm.candidateEmployerRecommendations = [];
	    vm.currentPage = 1;
	    vm.noEmployers = false;
	    vm.selectedPracticeArea = undefined;
	    vm.selectedLocations = undefined;
	    vm.candidateLocations = [];
	    vm.candidateSpecialties = [];
	    vm.fetchHiddenJobs = false;
	    vm.numPerPageOpt = [10, 20, 50];
	    vm.numPerPage = vm.numPerPageOpt[2];
	    vm.totalPositions = 0;
	    vm.countRefreshReq = false;
	    vm.today = new Date();
	    vm.picSrc = 'images/firm-logo-default.jpg';
	    vm.hideJobFilterButton = false;
	    vm.toolTipText = 'You have already shared your profile.';
	    vm.pageName = 'opportunities';
	
	    vm.spinnerActive = false;
	    vm.alertOne = 'Unfortunately there are no current opportunities on LexStep for which your profile is a relevant match.  You will be alerted when a relevant opportunity match arises.  You can also edit your ';
	    vm.alertTwo = ' to refine your search parameters and reveal potential opportunities.';
	
	    vm.startSpin = function () {
	      if (!vm.spinnerActive) {
	        usSpinnerService.spin('spinner-2');
	        vm.spinnerActive = true;
	      }
	    };
	
	    vm.stopSpin = function () {
	      if (vm.spinnerActive) {
	        usSpinnerService.stop('spinner-2');
	        vm.spinnerActive = false;
	      }
	    };
	
	    vm.hidePositionFromUI = function (position) {
	      var selectedEmployer = vm.candidateEmployerRecommendations.find(function (_ref9) {
	        var employer = _ref9.employer;
	        return employer.id === position.employerId;
	      });
	      vm.hiddenPositions++;
	
	      if (selectedEmployer.totalPositions > 1) vm['jobRow' + position.id] = 'zoomOutRight';else {
	        selectedEmployer.expanded = false;
	        vm['firmRow' + position.employerId] = 'zoomOutRight';
	      }
	
	      try {
	        console.debug('analytics: not for me', position);
	        analytics.track('Selected Team Not For Me', {
	          lawyer_id: vm.user.id,
	          job_id: position.id,
	          job_title: position.title,
	          job_max_pqe: position.lawPreferences.maxPqe,
	          job_min_pqe: position.lawPreferences.minPqe,
	          job_contract: position.contractTypeName,
	          job_role: position.occupationId,
	          firm_id: position.employerId,
	          firm_name: position.employerName,
	          employer_type: position.employerTypes.filter(function (_ref10) {
	            var name = _ref10.name;
	            return name === 'Private Practice';
	          }).length > 0 ? 'Private Practice' : 'In-House',
	          page: 'Make Me An Offer'
	        });
	      } catch (error) {
	        console.error('Make Me An Offer', error);
	      }
	
	      $timeout(function () {
	        vm.totalPositions--;
	        vm.countRefreshReq = true;
	
	        if (selectedEmployer.totalPositions > 1) {
	          selectedEmployer.positions = selectedEmployer.positions.filter(function (_ref11) {
	            var id = _ref11.id;
	            return id !== position.id;
	          });
	          vm['jobRow' + position.id] = '';
	          selectedEmployer.totalPositions--;
	        } else {
	          vm.candidateEmployerRecommendations = vm.candidateEmployerRecommendations.filter(function (_ref12) {
	            var employer = _ref12.employer;
	            return employer.id !== position.employerId;
	          });
	          vm.noEmployers = vm.candidateEmployerRecommendations.length <= 0;
	
	          vm['firmRow' + position.employerId] = '';
	        }
	      }, 900);
	    };
	
	    vm.hideEmployerFromUI = function (position) {
	      var selectedEmployer = vm.candidateEmployerRecommendations.find(function (_ref13) {
	        var employer = _ref13.employer;
	        return employer.id === position.employerId;
	      });
	      selectedEmployer.expanded = false;
	      vm['firmRow' + position.employerId] = 'zoomOutRight';
	      try {
	        analytics.track('Selected Firm Not For Me', {
	          lawyer_id: vm.user.id,
	          employer_type: position.employerTypes.filter(function (_ref14) {
	            var name = _ref14.name;
	            return name === 'Private Practice';
	          }).length > 0 ? 'Private Practice' : 'In-House',
	          firm_id: position.employerId,
	          firm_name: position.employer.name,
	          page: 'Make Me An Offer'
	        });
	      } catch (error) {
	        console.error('Make Me An Offer', error);
	      }
	
	      $timeout(function () {
	        vm.candidateEmployerRecommendations = vm.candidateEmployerRecommendations.filter(function (_ref15) {
	          var employer = _ref15.employer;
	          return employer.id !== position.employerId;
	        });
	        vm.noEmployers = vm.candidateEmployerRecommendations.length <= 0;
	        vm.totalPositions = Number.parseInt(vm.totalPositions, 10) - Number.parseInt(selectedEmployer.totalPositions, 10);
	        vm.hiddenPositions = Number.parseInt(vm.hiddenPositions, 10) + Number.parseInt(selectedEmployer.totalPositions, 10);
	
	        vm.countRefreshReq = true;
	        vm['firmRow' + position.employerId] = '';
	      }, 900);
	    };
	
	    vm.unHidePosition = function () {
	      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(position) {
	        var unHiddenEmployer, payload, _payload, positionUnHidePayLoad, employerUnHidePayLoad;
	
	        return regeneratorRuntime.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                unHiddenEmployer = vm.candidateEmployerRecommendations.find(function (_ref17) {
	                  var employer = _ref17.employer;
	                  return employer.id === position.employerId;
	                });
	
	                if (!(position.employerHidden && !position.positionHidden)) {
	                  _context7.next = 18;
	                  break;
	                }
	
	                payload = {
	                  employerIds: [Number.parseInt(position.employerId, 10)],
	                  updateValue: false
	                };
	                _context7.prev = 3;
	                _context7.next = 6;
	                return MatchesApi.unHideCandidateEmployer(position.userId, payload);
	
	              case 6:
	                unHiddenEmployer.positions.forEach(function (unHiddenEmployerPosition) {
	                  unHiddenEmployerPosition.employerHidden = false;
	                });
	
	                if (unHiddenEmployer.positions.find(function (_ref18) {
	                  var positionHidden = _ref18.positionHidden;
	                  return positionHidden === true;
	                })) {
	                  unHiddenEmployer.positions.forEach(function (unHiddenEmployerPosition) {
	                    if (!unHiddenEmployerPosition.positionHidden) {
	                      vm['jobRow' + unHiddenEmployerPosition.id] = 'zoomOutLeft';
	                    }
	                  });
	                } else {
	                  unHiddenEmployer.expanded = false;
	                  vm['firmRow' + unHiddenEmployer.employer.id] = 'zoomOutLeft';
	                }
	
	                $scope.$apply();
	
	                $timeout(function () {
	                  if (unHiddenEmployer.positions.find(function (_ref19) {
	                    var positionHidden = _ref19.positionHidden;
	                    return positionHidden === true;
	                  })) {
	                    unHiddenEmployer.positions.forEach(function (unHiddenEmployerPosition) {
	                      if (!unHiddenEmployerPosition.positionHidden) {
	                        vm['jobRow' + unHiddenEmployerPosition.id] = '';
	                      }
	                    });
	
	                    unHiddenEmployer.positions = unHiddenEmployer.positions.filter(function (_ref20) {
	                      var positionHidden = _ref20.positionHidden;
	                      return positionHidden;
	                    });
	                    vm.totalPositions = Number.parseInt(vm.totalPositions, 10) + Number.parseInt(unHiddenEmployer.totalPositions, 10) - unHiddenEmployer.positions.length;
	                    vm.hiddenPositions = Number.parseInt(vm.hiddenPositions, 10) - Number.parseInt(unHiddenEmployer.totalPositions, 10) + unHiddenEmployer.positions.length;
	                    unHiddenEmployer.totalPositions = unHiddenEmployer.positions.length;
	                  } else {
	                    vm.candidateEmployerRecommendations = vm.candidateEmployerRecommendations.filter(function (_ref21) {
	                      var employer = _ref21.employer;
	                      return employer.id !== position.employerId;
	                    });
	                    vm.noEmployers = vm.candidateEmployerRecommendations.length <= 0;
	
	                    vm['firmRow' + unHiddenEmployer.employer.id] = '';
	
	                    vm.noEmployers = vm.candidateEmployerRecommendations.length <= 0;
	                    vm.totalPositions = Number.parseInt(vm.totalPositions, 10) + Number.parseInt(unHiddenEmployer.totalPositions, 10);
	                    vm.hiddenPositions = Number.parseInt(vm.hiddenPositions, 10) - Number.parseInt(unHiddenEmployer.totalPositions, 10);
	                  }
	
	                  vm.countRefreshReq = true;
	                }, 900);
	                _context7.next = 16;
	                break;
	
	              case 12:
	                _context7.prev = 12;
	                _context7.t0 = _context7['catch'](3);
	
	                vm['firmRow' + position.employerId] = 'fadeIn';
	                logger.notify('error', 'somthing went wrong: ' + _context7.t0.statusText);
	
	              case 16:
	                _context7.next = 53;
	                break;
	
	              case 18:
	                if (!(!position.employerHidden && position.positionHidden)) {
	                  _context7.next = 35;
	                  break;
	                }
	
	                _payload = {
	                  positionIds: [Number.parseInt(position.id, 10)],
	                  hide: false,
	                  reason: ' '
	                };
	                _context7.prev = 20;
	                _context7.next = 23;
	                return MatchesApi.unHideCandidatePosition(position.userId, _payload);
	
	              case 23:
	                vm.totalPositions++;
	                if (unHiddenEmployer.totalPositions > 1) vm['jobRow' + position.id] = 'zoomOutLeft';else {
	                  unHiddenEmployer.expanded = false;
	                  vm['firmRow' + position.employerId] = 'zoomOutLeft';
	                }
	
	                $scope.$apply();
	                $timeout(function () {
	                  vm.hiddenPositions--;
	                  vm.countRefreshReq = true;
	                  vm['jobRow' + position.id] = '';
	                  if (unHiddenEmployer.totalPositions > 1) {
	                    unHiddenEmployer.positions = unHiddenEmployer.positions.filter(function (_ref22) {
	                      var id = _ref22.id;
	                      return id !== position.id;
	                    });
	                    unHiddenEmployer.totalPositions--;
	                    vm['jobRow' + position.id] = '';
	                  } else {
	                    vm.candidateEmployerRecommendations = vm.candidateEmployerRecommendations.filter(function (_ref23) {
	                      var employer = _ref23.employer;
	                      return employer.id !== position.employerId;
	                    });
	                    vm.noEmployers = vm.candidateEmployerRecommendations.length <= 0;
	
	                    vm['firmRow' + position.employerId] = '';
	                  }
	                }, 900);
	                _context7.next = 33;
	                break;
	
	              case 29:
	                _context7.prev = 29;
	                _context7.t1 = _context7['catch'](20);
	
	                vm['jobRow' + position.id] = 'fadeIn';
	
	                logger.notify('error', 'somthing went wrong: ' + _context7.t1.statusText);
	
	              case 33:
	                _context7.next = 53;
	                break;
	
	              case 35:
	                if (!(position.employerHidden && position.positionHidden)) {
	                  _context7.next = 53;
	                  break;
	                }
	
	                positionUnHidePayLoad = {
	                  positionIds: [Number.parseInt(position.id, 10)],
	                  hide: false,
	                  reason: ' '
	                };
	                employerUnHidePayLoad = {
	                  employerIds: [Number.parseInt(position.employerId, 10)],
	                  updateValue: false
	                };
	                _context7.prev = 38;
	                _context7.next = 41;
	                return MatchesApi.unHideCandidatePosition(position.userId, positionUnHidePayLoad);
	
	              case 41:
	                _context7.next = 43;
	                return MatchesApi.unHideCandidateEmployer(position.userId, employerUnHidePayLoad);
	
	              case 43:
	                unHiddenEmployer.positions.forEach(function (unHiddenEmployerPosition) {
	                  unHiddenEmployerPosition.employerHidden = false;
	                });
	                if (unHiddenEmployer.positions.find(function (unHiddenEmployerPosition) {
	                  return unHiddenEmployerPosition.positionHidden === true && unHiddenEmployerPosition.id !== position.id;
	                })) {
	                  unHiddenEmployer.positions.forEach(function (unHiddenEmployerPosition) {
	                    if (!unHiddenEmployerPosition.positionHidden || unHiddenEmployerPosition.id === position.id) {
	                      vm['jobRow' + unHiddenEmployerPosition.id] = 'zoomOutLeft';
	                    }
	                  });
	                } else {
	                  unHiddenEmployer.expanded = false;
	                  vm['firmRow' + unHiddenEmployer.employer.id] = 'zoomOutLeft';
	                }
	
	                $scope.$apply();
	
	                $timeout(function () {
	                  if (unHiddenEmployer.positions.find(function (unHiddenEmployerPosition) {
	                    return unHiddenEmployerPosition.positionHidden === true && unHiddenEmployerPosition.id !== position.id;
	                  })) {
	                    unHiddenEmployer.positions.forEach(function (unHiddenEmployerPosition) {
	                      if (!unHiddenEmployerPosition.positionHidden || unHiddenEmployerPosition.id === position.id) {
	                        vm['jobRow' + unHiddenEmployerPosition.id] = '';
	                      }
	                    });
	
	                    unHiddenEmployer.positions = unHiddenEmployer.positions.filter(function (unHiddenEmployerPosition) {
	                      return unHiddenEmployerPosition.positionHidden === true && unHiddenEmployerPosition.id !== position.id;
	                    });
	                    vm.totalPositions = Number.parseInt(vm.totalPositions, 10) + Number.parseInt(unHiddenEmployer.totalPositions, 10) - unHiddenEmployer.positions.length;
	                    vm.hiddenPositions = Number.parseInt(vm.hiddenPositions, 10) - Number.parseInt(unHiddenEmployer.totalPositions, 10) + unHiddenEmployer.positions.length;
	                    unHiddenEmployer.totalPositions = unHiddenEmployer.positions.length;
	                  } else {
	                    vm.candidateEmployerRecommendations = vm.candidateEmployerRecommendations.filter(function (_ref24) {
	                      var employer = _ref24.employer;
	                      return employer.id !== position.employerId;
	                    });
	                    vm.noEmployers = vm.candidateEmployerRecommendations.length <= 0;
	
	                    vm['firmRow' + unHiddenEmployer.employer.id] = '';
	
	                    vm.noEmployers = vm.candidateEmployerRecommendations.length <= 0;
	                    vm.totalPositions = Number.parseInt(vm.totalPositions, 10) + Number.parseInt(unHiddenEmployer.totalPositions, 10);
	                    vm.hiddenPositions = Number.parseInt(vm.hiddenPositions, 10) - Number.parseInt(unHiddenEmployer.totalPositions, 10);
	                  }
	
	                  vm.countRefreshReq = true;
	                }, 900);
	                _context7.next = 53;
	                break;
	
	              case 49:
	                _context7.prev = 49;
	                _context7.t2 = _context7['catch'](38);
	
	                vm['jobRow' + position.id] = 'fadeIn';
	
	                logger.notify('error', 'somthing went wrong: ' + _context7.t2.statusText);
	
	              case 53:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this, [[3, 12], [20, 29], [38, 49]]);
	      }));
	
	      return function (_x5) {
	        return _ref16.apply(this, arguments);
	      };
	    }();
	
	    vm.onExpandEmployer = function (employerDetails, employerPositions) {
	      try {
	        /* eslint-disable camelcase */
	        analytics.track('Explored Firm', {
	          lawyer_id: vm.candidate.user.id,
	          employer_type: employerDetails.employerTypes.filter(function (_ref25) {
	            var name = _ref25.name;
	            return name === 'Private Practice';
	          }).length > 0 ? 'Private Practice' : 'In-House',
	          firm_id: employerDetails.employer.id,
	          firm_name: employerDetails.employer.name,
	          job_count: employerDetails.totalPositions,
	          job_ids: employerPositions,
	          page: 'Make Me An Offer'
	        });
	        /* eslint-enable camelcase */
	      } catch (error) {
	        console.error('Make Me An Offer', error);
	      }
	    };
	
	    vm.notify = function (type, message) {
	      switch (type) {
	        case 'info':
	          logger.log(message);
	          break;
	        case 'success':
	          logger.logSuccess(message);
	          break;
	        case 'warning':
	          logger.logWarning(message);
	          break;
	        case 'error':
	          logger.logError(message);
	          break;
	        default:
	      }
	    };
	
	    vm.getAllEmployerLogos = function (employers) {
	      employers.map(function () {
	        var _ref27 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref26) {
	          var employer = _ref26.employer;
	          return regeneratorRuntime.wrap(function _callee8$(_context8) {
	            while (1) {
	              switch (_context8.prev = _context8.next) {
	                case 0:
	                  if (!employer.logo) {
	                    _context8.next = 3;
	                    break;
	                  }
	
	                  employer.logoSrc = ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/employers/' + employer.id + '/logo/' + employer.logo;
	                  return _context8.abrupt('return', employer);
	
	                case 3:
	
	                  employer.logoSrc = vm.picSrc;
	                  return _context8.abrupt('return', employer);
	
	                case 5:
	                case 'end':
	                  return _context8.stop();
	              }
	            }
	          }, _callee8, _this);
	        }));
	
	        return function (_x6) {
	          return _ref27.apply(this, arguments);
	        };
	      }());
	      $scope.$apply();
	    };
	
	    vm.OnChangePracticeArea = function () {
	      var _ref28 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(event, selectedPracticeArea) {
	        return regeneratorRuntime.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                if (!event) {
	                  _context9.next = 4;
	                  break;
	                }
	
	                event.stopPropagation();
	                _context9.next = 10;
	                break;
	
	              case 4:
	                vm.selectedPracticeArea = selectedPracticeArea;
	
	                if (!vm.selectedPracticeArea) {
	                  _context9.next = 10;
	                  break;
	                }
	
	                try {
	                  analytics.track('Practice Areas Filter Selected', {
	                    // eslint-disable-next-line camelcase
	                    lawyer_id: vm.user.id,
	                    // eslint-disable-next-line camelcase
	                    filtered_practice_area: vm.selectedPracticeArea.name,
	                    page: 'Make Me An Offer'
	                  });
	                } catch (error) {
	                  console.error('Make Me An Offer:', error);
	                }
	
	                _context9.next = 9;
	                return vm.select(vm.currentPage);
	
	              case 9:
	                vm.applyFilterCheck = false;
	
	              case 10:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this);
	      }));
	
	      return function (_x7, _x8) {
	        return _ref28.apply(this, arguments);
	      };
	    }();
	
	    vm.onChangeLocation = function () {
	      var _ref29 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(event, selectedLocations) {
	        return regeneratorRuntime.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                if (!event) {
	                  _context10.next = 4;
	                  break;
	                }
	
	                event.stopPropagation();
	                _context10.next = 10;
	                break;
	
	              case 4:
	                vm.selectedLocations = selectedLocations;
	
	                if (!vm.selectedLocations) {
	                  _context10.next = 10;
	                  break;
	                }
	
	                try {
	                  analytics.track('Locations Filter Selected', {
	                    // eslint-disable-next-line camelcase
	                    lawyer_id: vm.user.id,
	                    // eslint-disable-next-line camelcase
	                    filtered_location: vm.selectedLocations.name,
	                    page: 'Make Me An Offer'
	                  });
	                } catch (error) {
	                  console.error('Make Me An Offer', error);
	                }
	
	                _context10.next = 9;
	                return vm.select(vm.currentPage);
	
	              case 9:
	                vm.applyFilterCheck = false;
	
	              case 10:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, _this);
	      }));
	
	      return function (_x9, _x10) {
	        return _ref29.apply(this, arguments);
	      };
	    }();
	
	    vm.hiddenJobFilter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
	      return regeneratorRuntime.wrap(function _callee11$(_context11) {
	        while (1) {
	          switch (_context11.prev = _context11.next) {
	            case 0:
	              vm.noEmployers = false;
	              if (vm.fetchHiddenJobs) {
	                vm.fetchHiddenJobs = false;
	              } else {
	                vm.fetchHiddenJobs = true;
	              }
	
	              _context11.next = 4;
	              return vm.select(1);
	
	            case 4:
	            case 'end':
	              return _context11.stop();
	          }
	        }
	      }, _callee11, _this);
	    }));
	
	    var getPositionsForEmployers = function () {
	      var _ref31 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(userId, employerId) {
	        var doGet;
	        return regeneratorRuntime.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                doGet = function () {
	                  var _ref32 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(userId, employerId) {
	                    var payload, _ref35, matches, candidatePqe, parsePqe, matchedByPQE, processed;
	
	                    return regeneratorRuntime.wrap(function _callee12$(_context12) {
	                      while (1) {
	                        switch (_context12.prev = _context12.next) {
	                          case 0:
	                            console.debug('MakeMeAnOffer::getPositionsForEmployers', userId, employerId);
	
	                            _context12.prev = 1;
	                            payload = {
	                              hiddenPositions: vm.fetchHiddenJobs,
	                              locations: vm.selectedLocations ? vm.selectedLocations.length > 0 ? vm.selectedLocations.map(function (_ref33) {
	                                var id = _ref33.id;
	                                return id;
	                              }) : [0] : undefined,
	                              practiceAreas: vm.selectedPracticeArea ? vm.selectedPracticeArea.length > 0 ? vm.selectedPracticeArea.map(function (_ref34) {
	                                var id = _ref34.id;
	                                return id;
	                              }) : [0] : undefined,
	                              positionTypes: ['Speculative', 'Connect'],
	                              employers: [employerId]
	                            };
	
	                            console.log('payload', payload);
	                            _context12.next = 6;
	                            return MatchesApi.getCandidateMatchesData(userId, payload);
	
	                          case 6:
	                            _ref35 = _context12.sent;
	                            matches = _ref35.data;
	
	
	                            console.debug('getPositionsForEmployers::matches', matches);
	
	                            candidatePqe = vm.candidate && vm.candidate.lawProfile && vm.candidate.lawProfile.qualificationDate ? (0, _formatPqe.formatQualificationDateToPqe)(vm.candidate.lawProfile.qualificationDate) : false;
	
	
	                            console.log('candidatePqe:', candidatePqe, vm.candidate);
	
	                            parsePqe = function parsePqe(_ref36) {
	                              var minPqe = _ref36.minPqe,
	                                  maxPqe = _ref36.maxPqe;
	
	                              return {
	                                minPqe: minPqe !== undefined && minPqe !== null ? Number.parseFloat(minPqe) : -2,
	                                maxPqe: maxPqe !== undefined && maxPqe !== null ? Number.parseFloat(maxPqe) : +11
	                              };
	                            };
	
	                            matchedByPQE = matches.positions.filter(function (match) {
	                              var lawPreferences = match.lawPreferences;
	
	                              var _parsePqe = parsePqe(lawPreferences),
	                                  minPqe = _parsePqe.minPqe,
	                                  maxPqe = _parsePqe.maxPqe;
	
	                              var paddedMinPqe = minPqe >= -1 ? minPqe - 1 : -2;
	                              var paddedMaxPqe = maxPqe <= 10 ? maxPqe + 1 : 11;
	
	                              if (!candidatePqe) {
	                                return true;
	                              }
	
	                              return candidatePqe >= paddedMinPqe && candidatePqe <= paddedMaxPqe;
	                            });
	                            processed = matchedByPQE.map(function (position) {
	                              var employerSource = vm.candidateEmployerRecommendations.find(function (_ref37) {
	                                var employer = _ref37.employer;
	                                return employer.id === position.employerId;
	                              });
	
	                              var logoSource = employerSource && employerSource.employer && employerSource.employer.logoSrc;
	
	                              var employer = _.extend(position.employer, {
	                                logoSrc: logoSource
	                              });
	
	                              var processDescription = function processDescription(position) {
	                                var hasDescription = position && position.description;
	                                var longDescription = hasDescription && position.description.length > 600;
	                                return {
	                                  isCollapsed: true,
	                                  moreDetail: true,
	                                  showButton: longDescription
	                                };
	                              };
	
	                              var extras = processDescription(position);
	
	                              var locations = position.locations.length > 0 ? vm.locationsList.filter(function (_ref38) {
	                                var id = _ref38.id;
	                                return position.locations.find(function (location) {
	                                  return location === id;
	                                });
	                              }).map(function (location) {
	                                return {
	                                  name: location.name,
	                                  parent: location.parent,
	                                  color: location.country.region.color
	                                };
	                              }) : [];
	
	                              var withEmployer = _.extend(position, employer);
	                              var withExtras = _.extend(withEmployer, extras);
	                              var withLocations = _.extend(withExtras, { locations: locations });
	                              return withLocations;
	                            });
	
	
	                            vm.employerPositions = processed;
	                            vm.applyFilterCheck = true;
	                            // Vm.disabledToolTip(vm.candidate)
	
	                            console.debug('MakeMeAnOffer::getPositionsForEmployers:loaded', vm.employerPositions);
	
	                            $scope.$applyAsync();
	                            return _context12.abrupt('return', processed);
	
	                          case 21:
	                            _context12.prev = 21;
	                            _context12.t0 = _context12['catch'](1);
	
	                            logger.notify('error', 'something went wrong: ' + _context12.t0.statusText);
	                            return _context12.abrupt('return', []);
	
	                          case 25:
	                          case 'end':
	                            return _context12.stop();
	                        }
	                      }
	                    }, _callee12, _this, [[1, 21]]);
	                  }));
	
	                  return function doGet(_x13, _x14) {
	                    return _ref32.apply(this, arguments);
	                  };
	                }();
	
	                // Return wrap(async () => doGet(userId, employerId))
	
	
	                return _context13.abrupt('return', doGet(userId, employerId));
	
	              case 2:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, _this);
	      }));
	
	      return function getPositionsForEmployers(_x11, _x12) {
	        return _ref31.apply(this, arguments);
	      };
	    }();
	
	    vm.showPositions = function () {
	      var _ref39 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(employerDetails) {
	        var positionsForEmployers;
	        return regeneratorRuntime.wrap(function _callee14$(_context14) {
	          while (1) {
	            switch (_context14.prev = _context14.next) {
	              case 0:
	                console.debug('MakeMeAnOffer::showPositions', employerDetails);
	                _context14.prev = 1;
	
	                if (!(employerDetails.expanded === true)) {
	                  _context14.next = 7;
	                  break;
	                }
	
	                console.debug('MakeMeAnOffer::showPositions::expanded', true);
	                employerDetails.expanded = false;
	                _context14.next = 18;
	                break;
	
	              case 7:
	                if (!(employerDetails.expanded === false && employerDetails.totalPositions > 0 && (!employerDetails.positions || employerDetails.positions.length === 0))) {
	                  _context14.next = 17;
	                  break;
	                }
	
	                // Vm.startSpin()
	                console.debug('MakeMeAnOffer::showPositions::expanding (and loading positions)');
	                _context14.next = 11;
	                return getPositionsForEmployers(vm.candidate.user.id, employerDetails.employer.id);
	
	              case 11:
	                positionsForEmployers = _context14.sent;
	
	
	                employerDetails.positions = positionsForEmployers;
	                // Vm.stopSpin()
	                employerDetails.expanded = true;
	
	                vm.onExpandEmployer(employerDetails, vm.employerPositions.map(function (_ref40) {
	                  var id = _ref40.id;
	                  return id;
	                }));
	                _context14.next = 18;
	                break;
	
	              case 17:
	                if (employerDetails.expanded === false && (employerDetails.positions || employerDetails.positions.length > 0)) {
	                  console.debug('MakeMeAnOffer::showPositions::expanding (have positions already)', true);
	                  employerDetails.expanded = true;
	                }
	
	              case 18:
	                _context14.next = 25;
	                break;
	
	              case 20:
	                _context14.prev = 20;
	                _context14.t0 = _context14['catch'](1);
	
	                console.error(_context14.t0);
	                vm.stopSpin();
	                logger.notify('error', 'something went wrong: ' + _context14.t0.statusText);
	
	              case 25:
	              case 'end':
	                return _context14.stop();
	            }
	          }
	        }, _callee14, _this, [[1, 20]]);
	      }));
	
	      return function (_x15) {
	        return _ref39.apply(this, arguments);
	      };
	    }();
	
	    vm.getCandidateEmployerRecommendations = function () {
	      var _ref41 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(id, payload) {
	        var _ref42, candidateEmployerRecommendations;
	
	        return regeneratorRuntime.wrap(function _callee15$(_context15) {
	          while (1) {
	            switch (_context15.prev = _context15.next) {
	              case 0:
	                _context15.prev = 0;
	
	                vm.startSpin();
	
	                _context15.next = 4;
	                return MakeMeAnOfferApi.getCandidateEmployerRecommendations(id, payload, vm.candidate);
	
	              case 4:
	                _ref42 = _context15.sent;
	                candidateEmployerRecommendations = _ref42.data;
	
	
	                vm.candidateEmployerRecommendations = candidateEmployerRecommendations.employers;
	
	                vm.noEmployers = vm.candidateEmployerRecommendations.length <= 0;
	                vm.positionsCount = candidateEmployerRecommendations.positionsCount;
	                vm.totalPositions = vm.positionsCount.totalPositions - vm.positionsCount.hiddenPositions;
	                vm.hiddenPositions = vm.positionsCount.hiddenPositions;
	
	                vm.getAllEmployerLogos(vm.candidateEmployerRecommendations);
	                vm.applyFilterCheck = true;
	                vm.stopSpin();
	                // Vm.disabledToolTip(vm.candidate)
	                $scope.$applyAsync();
	                _context15.next = 21;
	                break;
	
	              case 17:
	                _context15.prev = 17;
	                _context15.t0 = _context15['catch'](0);
	
	                vm.stopSpin();
	                logger.notify('error', 'something went wrong: ' + _context15.t0.statusText);
	
	              case 21:
	              case 'end':
	                return _context15.stop();
	            }
	          }
	        }, _callee15, _this, [[0, 17]]);
	      }));
	
	      return function (_x16, _x17) {
	        return _ref41.apply(this, arguments);
	      };
	    }();
	
	    vm.select = function () {
	      var _ref43 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(page) {
	        var payload;
	        return regeneratorRuntime.wrap(function _callee16$(_context16) {
	          while (1) {
	            switch (_context16.prev = _context16.next) {
	              case 0:
	                vm.currentPage = page;
	
	                payload = {
	                  limit: vm.numPerPage,
	                  page: page,
	                  hiddenPositions: vm.fetchHiddenJobs,
	                  locations: vm.selectedLocations ? vm.selectedLocations.length > 0 ? vm.selectedLocations.map(function (_ref44) {
	                    var id = _ref44.id;
	                    return id;
	                  }) : [0] : undefined,
	                  practiceAreas: vm.selectedPracticeArea ? vm.selectedPracticeArea.length > 0 ? vm.selectedPracticeArea.map(function (_ref45) {
	                    var id = _ref45.id;
	                    return id;
	                  }) : [0] : undefined,
	                  positionTypes: ['Speculative', 'Connect']
	                };
	                _context16.next = 4;
	                return vm.getCandidateEmployerRecommendations(vm.user.id, payload);
	
	              case 4:
	              case 'end':
	                return _context16.stop();
	            }
	          }
	        }, _callee16, _this);
	      }));
	
	      return function (_x18) {
	        return _ref43.apply(this, arguments);
	      };
	    }();
	
	    vm.onNumPerPageChange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
	      return regeneratorRuntime.wrap(function _callee17$(_context17) {
	        while (1) {
	          switch (_context17.prev = _context17.next) {
	            case 0:
	              _context17.next = 2;
	              return vm.select(1);
	
	            case 2:
	              vm.currentPage = 1;
	
	            case 3:
	            case 'end':
	              return _context17.stop();
	          }
	        }
	      }, _callee17, _this);
	    }));
	
	    vm.getEmployerTypeLogo = function (employerDetails) {
	      return employerDetails.employerTypes.filter(function (_ref47) {
	        var name = _ref47.name;
	        return name === 'Private Practice';
	      }).length > 0 ? '/images/Private.png' : '/images/Inhouse.png';
	    };
	
	    vm.loadMatchesJobs = function () {
	      $location.url('/matches');
	    };
	
	    vm.updateProfileAlertStatus = function (alertType, status) {
	      if (alertType === 'both') {
	        vm.candidate.profileCvAlertCollapsed = status;
	        vm.candidate.profilePhoneAlertCollapsed = status;
	      } else {
	        vm.candidate[alertType] = status;
	      }
	    };
	
	    vm.toggleFollowEmployer = function () {
	      var _ref48 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(employerDetail, event) {
	        return regeneratorRuntime.wrap(function _callee19$(_context19) {
	          while (1) {
	            switch (_context19.prev = _context19.next) {
	              case 0:
	                event.stopPropagation();
	                event.preventDefault();
	                _context19.next = 4;
	                return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
	                  return regeneratorRuntime.wrap(function _callee18$(_context18) {
	                    while (1) {
	                      switch (_context18.prev = _context18.next) {
	                        case 0:
	                          _context18.prev = 0;
	
	                          if (!employerDetail.candidateFollowing) {
	                            _context18.next = 8;
	                            break;
	                          }
	
	                          employerDetail.followLabel = 'Follow';
	                          _context18.next = 5;
	                          return CandidateProfileApi.unFollowEmployer(vm.candidate.user.id, employerDetail.employer.id);
	
	                        case 5:
	                          employerDetail.candidateFollowing = false;
	                          _context18.next = 12;
	                          break;
	
	                        case 8:
	                          employerDetail.followLabel = 'Following';
	                          _context18.next = 11;
	                          return CandidateProfileApi.followEmployer(vm.candidate.user.id, employerDetail.employer.id);
	
	                        case 11:
	                          employerDetail.candidateFollowing = true;
	
	                        case 12:
	                          _context18.next = 17;
	                          break;
	
	                        case 14:
	                          _context18.prev = 14;
	                          _context18.t0 = _context18['catch'](0);
	
	                          logger.notify('error', 'something went wrong: ' + _context18.t0.statusText);
	
	                        case 17:
	                        case 'end':
	                          return _context18.stop();
	                      }
	                    }
	                  }, _callee18, _this, [[0, 14]]);
	                })));
	
	              case 4:
	              case 'end':
	                return _context19.stop();
	            }
	          }
	        }, _callee19, _this);
	      }));
	
	      return function (_x19, _x20) {
	        return _ref48.apply(this, arguments);
	      };
	    }();
	
	    vm.showMore = function (job) {
	      job.isCollapsed = !job.isCollapsed;
	    };
	
	    vm.showLess = function (position) {
	      position.isCollapsed = !position.isCollapsed;
	      vm.jumpToLink(position.id);
	    };
	
	    vm.jumpToLink = function (id) {
	      var oldHash;
	      oldHash = $location.hash();
	      $location.hash(id);
	      $anchorScroll();
	      $location.hash(oldHash);
	    };
	
	    vm.locationBackgroundColor = function (location) {
	      if (location) {
	        var color = location.color;
	        var parent = location.parent;
	        var countryCode = parent && parent.countryCode ? parent.countryCode : '';
	        if (countryCode === 'GB') {
	          return 'london';
	        }
	
	        return color;
	      }
	
	      return 'grey';
	    };
	
	    vm.askQuestion = function (position, event) {
	      event.preventDefault();
	      event.stopPropagation();
	
	      $uibModal.open({
	        backdrop: 'static',
	        templateUrl: 'contact-admin-modal.html',
	        controller: 'ContactAdminController',
	        controllerAs: 'ctrl',
	        resolve: {
	          selectedPosition: function selectedPosition() {
	            return position;
	          }
	        }
	      });
	    };
	
	    vm.initializeMakeMeAnOfferPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
	      var user, _ref51, locationsList, _ref52, candidate, _ref53, data, _ref54, resumes, _ref55, legalPracticeAreaList;
	
	      return regeneratorRuntime.wrap(function _callee20$(_context20) {
	        while (1) {
	          switch (_context20.prev = _context20.next) {
	            case 0:
	              _context20.next = 2;
	              return userService.getUser();
	
	            case 2:
	              user = _context20.sent;
	
	              vm.user = user;
	              _context20.next = 6;
	              return SharedApi.getAllLocations({
	                supported: true,
	                regions: true
	              });
	
	            case 6:
	              _ref51 = _context20.sent;
	              locationsList = _ref51.data;
	
	              vm.locationsList = locationsList;
	
	              _context20.next = 11;
	              return CandidateProfileApi.getUserProfile(user.id, {
	                include: ['occupations', 'preferredContractTypes', 'school']
	              });
	
	            case 11:
	              _ref52 = _context20.sent;
	              candidate = _ref52.data;
	
	              vm.candidate = candidate;
	
	              _context20.next = 16;
	              return CandidateProfileApi.getUserProfile(user.id, {
	                include: ['preferredLocations']
	              });
	
	            case 16:
	              _ref53 = _context20.sent;
	              data = _ref53.data;
	
	              vm.candidate.preferredLocations = data.preferredLocations;
	
	              vm.candidate.user.logoSrc = vm.candidate.user.profilePicture ? ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/user/' + candidate.user.id + '/photo/' + candidate.user.profilePicture : 'images/defaultPic.jpg';
	
	              _context20.next = 22;
	              return CandidateProfileApi.getUserResumes(user.id);
	
	            case 22:
	              _ref54 = _context20.sent;
	              resumes = _ref54.data;
	
	
	              vm.candidate.resumes = resumes;
	              vm.candidate.profileCvAlertCollapsed = false;
	              vm.candidate.profilePhoneAlertCollapsed = false;
	              _context20.next = 29;
	              return sharedProperties.getAgentDetails(vm.candidate.agent);
	
	            case 29:
	              vm.candidateAgent = _context20.sent;
	              _context20.next = 32;
	              return SharedApi.getCategoryById(1);
	
	            case 32:
	              _ref55 = _context20.sent;
	              legalPracticeAreaList = _ref55.data;
	
	              vm.legalPracticeAreaList = legalPracticeAreaList;
	
	              vm.candidateSpecialties = practiceAreaService.makeCandidatePracticeAreasHierarchy(candidate.category, vm.legalPracticeAreaList.specialties);
	
	              vm.regionHierarchialListWithEuropeOnTop = locationsGenericService.makeCandidateLocationsHierarchy(vm.candidate.preferredLocations, vm.locationsList);
	
	              _context20.next = 39;
	              return vm.onNumPerPageChange();
	
	            case 39:
	              $scope.$applyAsync();
	
	            case 40:
	            case 'end':
	              return _context20.stop();
	          }
	        }
	      }, _callee20, _this);
	    }));
	
	    vm.initializeMakeMeAnOfferPage();
	  }]);
	})();

/***/ }),
/* 601 */
/***/ (function(module, exports) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  'use strict';
	
	  angular.module('app.map', []).directive('uiJqvmap', [function () {
	    return {
	      restrict: 'A',
	      scope: {
	        options: '='
	      },
	      link: function link(scope, ele, attrs) {
	        var options;
	        options = scope.options;
	        return ele.vectorMap(options);
	      }
	    };
	  }]).controller('jqvmapCtrl', ['$scope', function ($scope) {
	    var sample_data;
	    sample_data = {
	      "af": "16.63",
	      "al": "11.58",
	      "dz": "158.97",
	      "ao": "85.81",
	      "ag": "1.1",
	      "ar": "351.02",
	      "am": "8.83",
	      "au": "1219.72",
	      "at": "366.26",
	      "az": "52.17",
	      "bs": "7.54",
	      "bh": "21.73",
	      "bd": "105.4",
	      "bb": "3.96",
	      "by": "52.89",
	      "be": "461.33",
	      "bz": "1.43",
	      "bj": "6.49",
	      "bt": "1.4",
	      "bo": "19.18",
	      "ba": "16.2",
	      "bw": "12.5",
	      "br": "2023.53",
	      "bn": "11.96",
	      "bg": "44.84",
	      "bf": "8.67",
	      "bi": "1.47",
	      "kh": "11.36",
	      "cm": "21.88",
	      "ca": "1563.66",
	      "cv": "1.57",
	      "cf": "2.11",
	      "td": "7.59",
	      "cl": "199.18",
	      "cn": "5745.13",
	      "co": "283.11",
	      "km": "0.56",
	      "cd": "12.6",
	      "cg": "11.88",
	      "cr": "35.02",
	      "ci": "22.38",
	      "hr": "59.92",
	      "cy": "22.75",
	      "cz": "195.23",
	      "dk": "304.56",
	      "dj": "1.14",
	      "dm": "0.38",
	      "do": "50.87",
	      "ec": "61.49",
	      "eg": "216.83",
	      "sv": "21.8",
	      "gq": "14.55",
	      "er": "2.25",
	      "ee": "19.22",
	      "et": "30.94",
	      "fj": "3.15",
	      "fi": "231.98",
	      "fr": "2555.44",
	      "ga": "12.56",
	      "gm": "1.04",
	      "ge": "11.23",
	      "de": "3305.9",
	      "gh": "18.06",
	      "gr": "305.01",
	      "gd": "0.65",
	      "gt": "40.77",
	      "gn": "4.34",
	      "gw": "0.83",
	      "gy": "2.2",
	      "ht": "6.5",
	      "hn": "15.34",
	      "hk": "226.49",
	      "hu": "132.28",
	      "is": "12.77",
	      "in": "1430.02",
	      "id": "695.06",
	      "ir": "337.9",
	      "iq": "84.14",
	      "ie": "204.14",
	      "il": "201.25",
	      "it": "2036.69",
	      "jm": "13.74",
	      "jp": "5390.9",
	      "jo": "27.13",
	      "kz": "129.76",
	      "ke": "32.42",
	      "ki": "0.15",
	      "kr": "986.26",
	      "undefined": "5.73",
	      "kw": "117.32",
	      "kg": "4.44",
	      "la": "6.34",
	      "lv": "23.39",
	      "lb": "39.15",
	      "ls": "1.8",
	      "lr": "0.98",
	      "ly": "77.91",
	      "lt": "35.73",
	      "lu": "52.43",
	      "mk": "9.58",
	      "mg": "8.33",
	      "mw": "5.04",
	      "my": "218.95",
	      "mv": "1.43",
	      "ml": "9.08",
	      "mt": "7.8",
	      "mr": "3.49",
	      "mu": "9.43",
	      "mx": "1004.04",
	      "md": "5.36",
	      "mn": "5.81",
	      "me": "3.88",
	      "ma": "91.7",
	      "mz": "10.21",
	      "mm": "35.65",
	      "na": "11.45",
	      "np": "15.11",
	      "nl": "770.31",
	      "nz": "138",
	      "ni": "6.38",
	      "ne": "5.6",
	      "ng": "206.66",
	      "no": "413.51",
	      "om": "53.78",
	      "pk": "174.79",
	      "pa": "27.2",
	      "pg": "8.81",
	      "py": "17.17",
	      "pe": "153.55",
	      "ph": "189.06",
	      "pl": "438.88",
	      "pt": "223.7",
	      "qa": "126.52",
	      "ro": "158.39",
	      "ru": "1476.91",
	      "rw": "5.69",
	      "ws": "0.55",
	      "st": "0.19",
	      "sa": "434.44",
	      "sn": "12.66",
	      "rs": "38.92",
	      "sc": "0.92",
	      "sl": "1.9",
	      "sg": "217.38",
	      "sk": "86.26",
	      "si": "46.44",
	      "sb": "0.67",
	      "za": "354.41",
	      "es": "1374.78",
	      "lk": "48.24",
	      "kn": "0.56",
	      "lc": "1",
	      "vc": "0.58",
	      "sd": "65.93",
	      "sr": "3.3",
	      "sz": "3.17",
	      "se": "444.59",
	      "ch": "522.44",
	      "sy": "59.63",
	      "tw": "426.98",
	      "tj": "5.58",
	      "tz": "22.43",
	      "th": "312.61",
	      "tl": "0.62",
	      "tg": "3.07",
	      "to": "0.3",
	      "tt": "21.2",
	      "tn": "43.86",
	      "tr": "729.05",
	      "tm": 0,
	      "ug": "17.12",
	      "ua": "136.56",
	      "ae": "239.65",
	      "gb": "2258.57",
	      "us": "14624.18",
	      "uy": "40.71",
	      "uz": "37.72",
	      "vu": "0.72",
	      "ve": "285.21",
	      "vn": "101.99",
	      "ye": "30.02",
	      "zm": "15.69",
	      "zw": "5.57"
	    };
	    $scope.worldMap = {
	      map: 'world_en',
	      backgroundColor: null,
	      color: '#ffffff',
	      hoverOpacity: 0.7,
	      selectedColor: '#666666',
	      enableZoom: true,
	      showTooltip: true,
	      values: sample_data,
	      scaleColors: ['#C4FFFF', '#07C0BB'],
	      normalizeFunction: 'polynomial'
	    };
	    $scope.USAMap = {
	      map: 'usa_en',
	      backgroundColor: null,
	      color: '#ffffff',
	      hoverColor: '#999999',
	      selectedColor: '#666666',
	      enableZoom: true,
	      showTooltip: true,
	      selectedRegion: 'MO'
	    };
	    return $scope.europeMap = {
	      map: 'europe_en',
	      backgroundColor: null,
	      color: '#ffffff',
	      hoverOpacity: 0.7,
	      hoverColor: '#999999',
	      enableZoom: false,
	      showTooltip: false,
	      values: sample_data,
	      scaleColors: ['#C4FFFF', '#07C0BB'],
	      normalizeFunction: 'polynomial'
	    };
	  }]);
	}).call(undefined);

/***/ }),
/* 602 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function hasExpired(input) {
	  if (input === undefined || input === null) {
	    return false; // Treat undefined/null expiration as not expired
	  }
	
	  var currentDate = new Date();
	  var providedDate = new Date(input);
	
	  return providedDate < currentDate;
	}
	
	angular.module('app.api').factory('MatchesApi', ['api', function MatchesApi(api) {
	  var _this = this;
	
	  var matchesAPi = {
	    getCandidateMatchesData: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id, payload) {
	        var result, withoutExpiredOrInvisible, toReturn;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return api.get('recommendations/candidate/' + id, {
	                  params: payload
	                });
	
	              case 2:
	                result = _context.sent;
	
	                console.debug('MatchesApi::getCandidateMatchesData', id, payload, 'result:', result);
	
	                withoutExpiredOrInvisible = result.data.positions.filter(function (item) {
	                  return !hasExpired(item.expiresAt) && item.visible;
	                });
	                toReturn = _.extend({}, result, {
	                  data: {
	                    positions: withoutExpiredOrInvisible,
	                    positionsCount: {
	                      totalPositions: result.data.positionsCount.totalPositions,
	                      hiddenPositions: result.data.positionsCount.hiddenPositions
	                    }
	                  }
	                });
	
	
	                console.debug('MatchesApi::getCandidateMatchesData', toReturn);
	                return _context.abrupt('return', toReturn);
	
	              case 8:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function getCandidateMatchesData(_x, _x2) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getCandidateMatchesData;
	    }(),
	
	    unHideCandidateEmployer: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id, payload) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                return _context2.abrupt('return', api.put('users/' + id + '/hidden', payload));
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      function unHideCandidateEmployer(_x3, _x4) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return unHideCandidateEmployer;
	    }(),
	    unHideCandidatePosition: function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id, payload) {
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                return _context3.abrupt('return', api.put('users/' + id + '/positions/hidden', payload));
	
	              case 1:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this);
	      }));
	
	      function unHideCandidatePosition(_x5, _x6) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return unHideCandidatePosition;
	    }()
	  };
	  return matchesAPi;
	}]);

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _segment = __webpack_require__(21);
	
	var _loadingOverlay = __webpack_require__(20);
	
	var _formatPqe = __webpack_require__(55);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable camelcase */
	/* eslint-disable radix */
	/* eslint-disable angular/controller-as */
	
	(function module() {
	  angular.module('app.ui.form.ctrls').controller('MatchesController', ['$location', '$scope', 'logger', '$anchorScroll', 'usSpinnerService', '$timeout', 'practiceAreaService', 'locationsGenericService', 'MatchesApi', 'SharedApi', 'CandidateProfileApi', '$uibModal', 'userService', 'socket', 'sharedProperties', function controller($location, $scope, logger, $anchorScroll, usSpinnerService, $timeout, practiceAreaService, locationsGenericService, MatchesApi, SharedApi, CandidateProfileApi, $uibModal, userService, socket, sharedProperties) {
	    var _this = this;
	
	    var vm = this;
	
	    $scope.$on('candidate:wizard:completed', _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	      var go;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              go = function () {
	                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                  var reload;
	                  return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          console.debug('wizard completed!');
	
	                          reload = function reload() {
	                            vm.initializeMatches();
	                          };
	
	                          _context.next = 4;
	                          return $timeout(reload, 1000);
	
	                        case 4:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this);
	                }));
	
	                return function go() {
	                  return _ref2.apply(this, arguments);
	                };
	              }();
	
	              _context2.next = 3;
	              return (0, _loadingOverlay.wrap)(go);
	
	            case 3:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this);
	    })));
	    socket.on('CANDIDATE_APPROVAL_STATUS_UPDATE', function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(candidateId) {
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                $timeout(function () {
	                  if (vm.user.id === candidateId && $location.url().contains('matches')) {
	                    vm.initializeMatches();
	                  }
	                }, 2000);
	
	              case 1:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this);
	      }));
	
	      return function (_x) {
	        return _ref3.apply(this, arguments);
	      };
	    }());
	
	    socket.on('CANDIDATE_RECOMMENDATION_GENERATED', function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(candidateId) {
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                $timeout(function () {
	                  if (vm.user.id === candidateId && $location.url().contains('matches')) {
	                    vm.select(vm.currentPage);
	                  }
	                }, 1500);
	
	              case 1:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this);
	      }));
	
	      return function (_x2) {
	        return _ref4.apply(this, arguments);
	      };
	    }());
	
	    socket.on('CANDIDATE_ASSIGNED_AGENT_UPDATE', function () {
	      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(candidateId) {
	        return regeneratorRuntime.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	                  var _ref7, candidate;
	
	                  return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                    while (1) {
	                      switch (_context5.prev = _context5.next) {
	                        case 0:
	                          if (!(vm.user.id === candidateId && $location.url().contains('matches'))) {
	                            _context5.next = 9;
	                            break;
	                          }
	
	                          _context5.next = 3;
	                          return CandidateProfileApi.getUserProfile(vm.user.id);
	
	                        case 3:
	                          _ref7 = _context5.sent;
	                          candidate = _ref7.data;
	                          _context5.next = 7;
	                          return sharedProperties.getAgentDetails(candidate.agent);
	
	                        case 7:
	                          vm.candidateAgent = _context5.sent;
	
	                          $scope.$applyAsync();
	
	                        case 9:
	                        case 'end':
	                          return _context5.stop();
	                      }
	                    }
	                  }, _callee5, _this);
	                })), 1000);
	
	              case 1:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this);
	      }));
	
	      return function (_x3) {
	        return _ref5.apply(this, arguments);
	      };
	    }());
	
	    socket.on('CANDIDATE_PROFILE_AGENT_UPDATE', function () {
	      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(candidateId) {
	        return regeneratorRuntime.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
	                  var _ref10, candidate;
	
	                  return regeneratorRuntime.wrap(function _callee7$(_context7) {
	                    while (1) {
	                      switch (_context7.prev = _context7.next) {
	                        case 0:
	                          if (!(vm.user.id === candidateId && $location.url().contains('matches'))) {
	                            _context7.next = 9;
	                            break;
	                          }
	
	                          _context7.next = 3;
	                          return CandidateProfileApi.getUserProfile(vm.user.id);
	
	                        case 3:
	                          _ref10 = _context7.sent;
	                          candidate = _ref10.data;
	                          _context7.next = 7;
	                          return sharedProperties.getAgentDetails(candidate.agent);
	
	                        case 7:
	                          vm.candidateAgent = _context7.sent;
	
	                          $scope.$applyAsync();
	
	                        case 9:
	                        case 'end':
	                          return _context7.stop();
	                      }
	                    }
	                  }, _callee7, _this);
	                })), 1000);
	
	              case 1:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, _this);
	      }));
	
	      return function (_x4) {
	        return _ref8.apply(this, arguments);
	      };
	    }());
	    vm.candidateMatchesData = [];
	    vm.currentPage = 1;
	    vm.noJob = false;
	    vm.selectedPracticeArea = undefined;
	    vm.selectedLocations = undefined;
	    vm.selectedContracts = undefined;
	    vm.selectedEmployerTypes = undefined;
	    vm.selectedOccupations = undefined;
	    vm.minPqe = undefined;
	    vm.maxPqe = undefined;
	    vm.candidateLocations = [];
	    vm.candidateSpecialties = [];
	    vm.fetchHiddenJobs = false;
	    vm.numPerPageOpt = [10, 20, 50];
	    vm.numPerPage = vm.numPerPageOpt[2];
	    vm.totalPositions = 0;
	    vm.countRefreshReq = false;
	    vm.today = new Date();
	    vm.picSrc = 'images/firm-logo-default.jpg';
	    vm.hideJobFilterButton = false;
	    vm.toolTipText = 'You have already shared your profile.';
	    vm.pageName = 'matches';
	    vm.filterPQE = '0;11';
	
	    vm.options = {
	      round: 1,
	      from: 0,
	      to: 11,
	      step: 0.5,
	      dimension: '+ PQE',
	      scale: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '11+']
	    };
	    vm.spinnerActive = false;
	    vm.alertOne = 'Unfortunately there are no current opportunities on LexStep for which your profile is a relevant match.  You will be alerted when a relevant opportunity match arises.  You can also edit your ';
	    vm.alertTwo = ' to refine your search parameters and reveal potential opportunities.';
	
	    vm.startSpin = function () {
	      if (!vm.spinnerActive) {
	        usSpinnerService.spin('spinner-2');
	        vm.spinnerActive = true;
	      }
	    };
	
	    vm.stopSpin = function () {
	      if (vm.spinnerActive) {
	        usSpinnerService.stop('spinner-2');
	        vm.spinnerActive = false;
	      }
	    };
	
	    vm.hidePositionFromUI = function (position) {
	      position.isHidden = true;
	      vm.hiddenPositions++;
	      vm['jobRow' + position.id] = 'zoomOutRight';
	
	      try {
	        analytics.track('Selected Job Not For Me', {
	          lawyer_id: (0, _segment.identifyUser)().id,
	          job_id: position.id,
	          job_title: position.title,
	          job_max_pqe: position.lawPreferences.maxPqe,
	          job_min_pqe: position.lawPreferences.minPqe,
	          job_contract: position.lawPreferences.contractTypeId,
	          job_role: position.occupationId,
	          employer_type: position.employerTypes && position.employerTypes.length > 0 && position.employerTypes[0] && position.employerTypes[0].name,
	          firm_id: position.employerId,
	          firm_name: position.employer.name,
	          page: 'In-House',
	          name: vm.candidate.firstName + ' ' + vm.candidate.lastName
	        });
	        // eslint-disable-next-line unicorn/catch-error-name, unicorn/prevent-abbreviations
	      } catch (e) {
	        console.error('Track: Selected Job Not For Me', e);
	      }
	
	      $timeout(function () {
	        vm.candidateMatchesData = vm.candidateMatchesData.filter(function (_ref11) {
	          var id = _ref11.id;
	          return id !== position.id;
	        });
	
	        vm.noJob = vm.candidateMatchesData.length <= 0;
	        vm.totalPositions--;
	        vm.countRefreshReq = true;
	        vm['jobRow' + position.id] = '';
	      }, 300);
	    };
	
	    vm.hideEmployerFromUI = function (position) {
	      position.expanded = false;
	      var hiddenEmployerPositions = vm.candidateMatchesData.filter(function (_ref12) {
	        var employerId = _ref12.employerId;
	        return employerId === position.employerId;
	      });
	      hiddenEmployerPositions.forEach(function (hiddenEmployerPosition) {
	        vm['jobRow' + hiddenEmployerPosition.id] = 'zoomOutRight';
	      });
	      try {
	        analytics.track('Selected Firm Not For Me', {
	          lawyer_id: (0, _segment.identifyUser)().id,
	          employer_type: position.employerTypes && position.employerTypes.length > 0 && position.employerTypes[0] && position.employerTypes[0].name,
	          firm_id: position.employerId,
	          firm_name: position.employer.name,
	          page: 'In-House',
	          name: vm.candidate.firstName + ' ' + vm.candidate.lastName
	        });
	        // eslint-disable-next-line unicorn/catch-error-name, unicorn/prevent-abbreviations
	      } catch (e) {
	        console.error('Track: Selected Firm Not For Me Error', e);
	      }
	
	      $timeout(function () {
	        hiddenEmployerPositions.forEach(function (hiddenEmployerPosition) {
	          vm.candidateMatchesData = vm.candidateMatchesData.filter(function (_ref13) {
	            var id = _ref13.id;
	            return id !== hiddenEmployerPosition.id;
	          });
	          vm['jobRow' + hiddenEmployerPosition.id] = '';
	        });
	
	        vm.noJob = vm.candidateMatchesData.length <= 0;
	        vm.totalPositions = Number.parseInt(vm.totalPositions) - Number.parseInt(hiddenEmployerPositions.length);
	        vm.hiddenPositions = Number.parseInt(vm.hiddenPositions) + Number.parseInt(hiddenEmployerPositions.length);
	        vm.countRefreshReq = true;
	      }, 300);
	    };
	
	    vm.unHidePosition = function () {
	      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(position) {
	        var payload, unHiddenEmployerPositions, _payload, positionUnHidePayLoad, employerUnHidePayLoad, _unHiddenEmployerPositions;
	
	        return regeneratorRuntime.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                if (!(position.employerHidden && !position.positionHidden)) {
	                  _context9.next = 19;
	                  break;
	                }
	
	                payload = {
	                  employerIds: [Number.parseInt(position.employerId)],
	                  updateValue: false
	                };
	                _context9.prev = 2;
	                _context9.next = 5;
	                return MatchesApi.unHideCandidateEmployer(position.userId, payload);
	
	              case 5:
	                position.expanded = false;
	                unHiddenEmployerPositions = vm.candidateMatchesData.filter(function (candidateMatch) {
	                  return candidateMatch.employerId === position.employerId && !candidateMatch.positionHidden;
	                });
	
	                vm.candidateMatchesData.forEach(function (candidateMatch) {
	                  if (candidateMatch.employerId === position.employerId) {
	                    candidateMatch.employerHidden = false;
	                  }
	                });
	                unHiddenEmployerPositions.forEach(function (unHiddenEmployerPosition) {
	                  vm['jobRow' + unHiddenEmployerPosition.id] = 'zoomOutLeft';
	                });
	                $scope.$apply();
	
	                $timeout(function () {
	                  unHiddenEmployerPositions.forEach(function (unHiddenEmployerPosition) {
	                    vm.candidateMatchesData = vm.candidateMatchesData.filter(function (_ref15) {
	                      var id = _ref15.id;
	                      return id !== unHiddenEmployerPosition.id;
	                    });
	                    vm['jobRow' + unHiddenEmployerPosition.id] = '';
	                  });
	
	                  vm.noJob = vm.candidateMatchesData.length <= 0;
	                  vm.totalPositions = Number.parseInt(vm.totalPositions) + Number.parseInt(unHiddenEmployerPositions.length);
	                  vm.hiddenPositions = Number.parseInt(vm.hiddenPositions) - Number.parseInt(unHiddenEmployerPositions.length);
	                  vm.countRefreshReq = true;
	                }, 500);
	                _context9.next = 17;
	                break;
	
	              case 13:
	                _context9.prev = 13;
	                _context9.t0 = _context9['catch'](2);
	
	                vm['jobRow' + position.id] = 'fadeIn';
	                logger.notify('error', 'somthing went wrong: ' + _context9.t0.statusText);
	
	              case 17:
	                _context9.next = 58;
	                break;
	
	              case 19:
	                if (!(!position.employerHidden && position.positionHidden)) {
	                  _context9.next = 37;
	                  break;
	                }
	
	                _payload = {
	                  positionIds: [Number.parseInt(position.id)],
	                  hide: false,
	                  reason: ' '
	                };
	                _context9.prev = 21;
	                _context9.next = 24;
	                return MatchesApi.unHideCandidatePosition(position.userId, _payload);
	
	              case 24:
	                position.isHidden = true;
	                vm.totalPositions++;
	                vm['jobRow' + position.id] = 'zoomOutLeft';
	                $scope.$apply();
	                $timeout(function () {
	                  vm.candidateMatchesData = vm.candidateMatchesData.filter(function (_ref16) {
	                    var id = _ref16.id;
	                    return id !== position.id;
	                  });
	                  vm.noJob = vm.candidateMatchesData.length <= 0;
	                  vm.hiddenPositions--;
	                  vm.countRefreshReq = true;
	                  vm['jobRow' + position.id] = '';
	                }, 500);
	                _context9.next = 35;
	                break;
	
	              case 31:
	                _context9.prev = 31;
	                _context9.t1 = _context9['catch'](21);
	
	                vm['jobRow' + position.id] = 'fadeIn';
	
	                logger.notify('error', 'somthing went wrong: ' + _context9.t1.statusText);
	
	              case 35:
	                _context9.next = 58;
	                break;
	
	              case 37:
	                if (!(position.employerHidden && position.positionHidden)) {
	                  _context9.next = 58;
	                  break;
	                }
	
	                positionUnHidePayLoad = {
	                  positionIds: [Number.parseInt(position.id)],
	                  hide: false,
	                  reason: ' '
	                };
	                employerUnHidePayLoad = {
	                  employerIds: [Number.parseInt(position.employerId)],
	                  updateValue: false
	                };
	                _context9.prev = 40;
	                _context9.next = 43;
	                return MatchesApi.unHideCandidatePosition(position.userId, positionUnHidePayLoad);
	
	              case 43:
	                _context9.next = 45;
	                return MatchesApi.unHideCandidateEmployer(position.userId, employerUnHidePayLoad);
	
	              case 45:
	                vm.candidateMatchesData.forEach(function (candidateMatch) {
	                  if (candidateMatch.employerId === position.employerId) {
	                    candidateMatch.employerHidden = false;
	                  }
	                });
	
	                position.isHidden = true;
	                _unHiddenEmployerPositions = vm.candidateMatchesData.filter(function (externalMatch) {
	                  return externalMatch.employerId === position.employerId && !externalMatch.positionHidden;
	                });
	
	                _unHiddenEmployerPositions.forEach(function (unHiddenEmployerPosition) {
	                  vm['jobRow' + unHiddenEmployerPosition.id] = 'zoomOutLeft';
	                });
	                vm['jobRow' + position.id] = 'zoomOutLeft';
	                $scope.$apply();
	                $timeout(function () {
	                  vm.candidateMatchesData = vm.candidateMatchesData.filter(function (_ref17) {
	                    var id = _ref17.id;
	                    return id !== position.id;
	                  });
	
	                  _unHiddenEmployerPositions.forEach(function (unHiddenEmployerPosition) {
	                    vm.candidateMatchesData = vm.candidateMatchesData.filter(function (_ref18) {
	                      var id = _ref18.id;
	                      return id !== unHiddenEmployerPosition.id;
	                    });
	                    vm['jobRow' + unHiddenEmployerPosition.id] = '';
	                  });
	                  vm.noJob = vm.candidateMatchesData.length <= 0;
	                  vm.totalPositions = Number.parseInt(vm.totalPositions) + Number.parseInt(_unHiddenEmployerPositions.length) + 1;
	                  vm.hiddenPositions = Number.parseInt(vm.hiddenPositions) - Number.parseInt(_unHiddenEmployerPositions.length) - 1;
	                  vm.countRefreshReq = true;
	                  vm['jobRow' + position.id] = '';
	                }, 500);
	                _context9.next = 58;
	                break;
	
	              case 54:
	                _context9.prev = 54;
	                _context9.t2 = _context9['catch'](40);
	
	                vm['jobRow' + position.id] = 'fadeIn';
	
	                logger.notify('error', 'somthing went wrong: ' + _context9.t2.statusText);
	
	              case 58:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, _this, [[2, 13], [21, 31], [40, 54]]);
	      }));
	
	      return function (_x5) {
	        return _ref14.apply(this, arguments);
	      };
	    }();
	
	    vm.getAllEmployerLogos = function (matches) {
	      matches.map(function () {
	        var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(match) {
	          var employer;
	          return regeneratorRuntime.wrap(function _callee10$(_context10) {
	            while (1) {
	              switch (_context10.prev = _context10.next) {
	                case 0:
	                  employer = match.employer;
	
	                  if (!employer.logo) {
	                    _context10.next = 4;
	                    break;
	                  }
	
	                  employer.logoSrc = ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/employers/' + match.employerId + '/logo/' + employer.logo;
	                  return _context10.abrupt('return', employer);
	
	                case 4:
	
	                  employer.logoSrc = vm.picSrc;
	                  return _context10.abrupt('return', employer);
	
	                case 6:
	                case 'end':
	                  return _context10.stop();
	              }
	            }
	          }, _callee10, _this);
	        }));
	
	        return function (_x6) {
	          return _ref19.apply(this, arguments);
	        };
	      }());
	      $scope.$apply();
	    };
	
	    vm.getCandidateMatches = function () {
	      var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(id, payload) {
	        var _ref21, candidateMatchesData;
	
	        return regeneratorRuntime.wrap(function _callee12$(_context12) {
	          while (1) {
	            switch (_context12.prev = _context12.next) {
	              case 0:
	                _context12.prev = 0;
	
	                vm.startSpin();
	
	                // Console.debug('getCandidateMatches: payload', payload)
	                console.debug('getCandidateMatches: vm', vm);
	
	                _context12.next = 5;
	                return MatchesApi.getCandidateMatchesData(id, payload);
	
	              case 5:
	                _ref21 = _context12.sent;
	                candidateMatchesData = _ref21.data;
	
	
	                vm.candidateMatchesData = candidateMatchesData.positions;
	                vm.noJob = vm.candidateMatchesData.length <= 0;
	                vm.positionsCount = candidateMatchesData.positionsCount;
	                vm.totalPositions = vm.positionsCount.totalPositions - vm.positionsCount.hiddenPositions;
	                vm.hiddenPositions = vm.positionsCount.hiddenPositions;
	
	                vm.candidateMatchesData.forEach(function () {
	                  var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(position) {
	                    return regeneratorRuntime.wrap(function _callee11$(_context11) {
	                      while (1) {
	                        switch (_context11.prev = _context11.next) {
	                          case 0:
	                            position.expanded = false;
	                            vm.formatPositionDescription(position);
	                            vm.checkPositionIsNew(position);
	                            position.locations = position.locations.length > 0 ? vm.locationsList.filter(function (_ref23) {
	                              var id = _ref23.id;
	                              return position.locations.find(function (location) {
	                                return location === id;
	                              });
	                            }).map(function (location) {
	                              return {
	                                name: location.name,
	                                parent: location.parent,
	                                color: location.country.region.color
	                              };
	                            }) : [];
	
	                          case 4:
	                          case 'end':
	                            return _context11.stop();
	                        }
	                      }
	                    }, _callee11, _this);
	                  }));
	
	                  return function (_x9) {
	                    return _ref22.apply(this, arguments);
	                  };
	                }());
	                vm.getAllEmployerLogos(vm.candidateMatchesData);
	                vm.applyFilterCheck = true;
	                vm.stopSpin();
	                vm.disabledToolTip(vm.candidate);
	                $scope.$applyAsync();
	                _context12.next = 24;
	                break;
	
	              case 20:
	                _context12.prev = 20;
	                _context12.t0 = _context12['catch'](0);
	
	                vm.stopSpin();
	                logger.notify('error', 'something went wrong: ' + _context12.t0.statusText);
	
	              case 24:
	              case 'end':
	                return _context12.stop();
	            }
	          }
	        }, _callee12, _this, [[0, 20]]);
	      }));
	
	      return function (_x7, _x8) {
	        return _ref20.apply(this, arguments);
	      };
	    }();
	
	    vm.select = function () {
	      var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(page) {
	        var preferences, payload;
	        return regeneratorRuntime.wrap(function _callee13$(_context13) {
	          while (1) {
	            switch (_context13.prev = _context13.next) {
	              case 0:
	                vm.currentPage = page;
	
	                console.debug('matches.select: selectedEmployerTypes =', vm.selectedEmployerTypes, 'candidate', vm.candidate);
	
	                preferences = {
	                  occupations: vm.candidate.occupations ? vm.candidate.occupations.map(function (item) {
	                    return item.id;
	                  }) : []
	                };
	
	
	                console.debug('matches.select: preferences =', preferences);
	
	                payload = {
	                  limit: vm.numPerPage,
	                  page: page,
	                  hiddenPositions: vm.fetchHiddenJobs,
	                  practiceAreas: vm.selectedPracticeArea ? vm.selectedPracticeArea.length > 0 ? vm.selectedPracticeArea.map(function (_ref25) {
	                    var id = _ref25.id;
	                    return id;
	                  }) : [0] : undefined,
	                  locations: vm.selectedLocations ? vm.selectedLocations.length > 0 ? vm.selectedLocations.map(function (_ref26) {
	                    var id = _ref26.id;
	                    return id;
	                  }) : [0] : undefined,
	                  minPqe: vm.minPqe,
	                  maxPqe: vm.maxPqe,
	
	                  employerTypes: vm.selectedEmployerTypes ? vm.selectedEmployerTypes.length > 0 ? vm.selectedEmployerTypes.map(function (_ref27) {
	                    var id = _ref27.id;
	                    return id;
	                  }) : [0] : undefined,
	
	                  contractTypes: vm.contractTypes ? vm.contractTypes.length > 0 ? vm.contractTypes.map(function (_ref28) {
	                    var id = _ref28.id;
	                    return id;
	                  }) : [1] : undefined,
	
	                  occupations: vm.selectedOccupations ? vm.selectedOccupations.length > 0 ? vm.selectedOccupations.map(function (_ref29) {
	                    var id = _ref29.id;
	                    return id;
	                  }) : [0] : undefined,
	                  positionTypes: ['Regular', 'Custom']
	                };
	                _context13.next = 7;
	                return vm.getCandidateMatches(vm.user.id, _.extend(payload, {
	                  occupations: payload.occupations ? payload.occupations.filter(function (id) {
	                    return preferences.occupations.includes(id);
	                  }) : preferences.occupations
	                }));
	
	              case 7:
	              case 'end':
	                return _context13.stop();
	            }
	          }
	        }, _callee13, _this);
	      }));
	
	      return function (_x10) {
	        return _ref24.apply(this, arguments);
	      };
	    }();
	
	    vm.onNumPerPageChange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
	      return regeneratorRuntime.wrap(function _callee14$(_context14) {
	        while (1) {
	          switch (_context14.prev = _context14.next) {
	            case 0:
	              _context14.next = 2;
	              return vm.select(1);
	
	            case 2:
	              vm.currentPage = 1;
	
	            case 3:
	            case 'end':
	              return _context14.stop();
	          }
	        }
	      }, _callee14, _this);
	    }));
	
	    vm.OnChangePracticeArea = function () {
	      var _ref31 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(event, selectedPracticeArea) {
	        return regeneratorRuntime.wrap(function _callee15$(_context15) {
	          while (1) {
	            switch (_context15.prev = _context15.next) {
	              case 0:
	                if (!event) {
	                  _context15.next = 4;
	                  break;
	                }
	
	                event.stopPropagation();
	                _context15.next = 10;
	                break;
	
	              case 4:
	                vm.selectedPracticeArea = selectedPracticeArea;
	
	                if (!vm.selectedPracticeArea) {
	                  _context15.next = 10;
	                  break;
	                }
	
	                try {
	                  analytics.track('Practice Areas Filter Selected', {
	                    // eslint-disable-next-line camelcase
	                    lawyer_id: vm.user.id,
	                    // eslint-disable-next-line camelcase
	                    filtered_practice_area: vm.selectedPracticeArea.name,
	                    page: 'In-House',
	                    name: vm.candidate.firstName + ' ' + vm.candidate.lastName
	                  });
	                } catch (error) {
	                  console.error('In-House', error);
	                }
	
	                _context15.next = 9;
	                return vm.select(vm.currentPage);
	
	              case 9:
	                vm.applyFilterCheck = false;
	
	              case 10:
	              case 'end':
	                return _context15.stop();
	            }
	          }
	        }, _callee15, _this);
	      }));
	
	      return function (_x11, _x12) {
	        return _ref31.apply(this, arguments);
	      };
	    }();
	
	    vm.onChangeLocation = function () {
	      var _ref32 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(event, selectedLocations) {
	        return regeneratorRuntime.wrap(function _callee16$(_context16) {
	          while (1) {
	            switch (_context16.prev = _context16.next) {
	              case 0:
	                if (!event) {
	                  _context16.next = 4;
	                  break;
	                }
	
	                event.stopPropagation();
	                _context16.next = 10;
	                break;
	
	              case 4:
	                vm.selectedLocations = selectedLocations;
	
	                if (!vm.selectedLocations) {
	                  _context16.next = 10;
	                  break;
	                }
	
	                try {
	                  analytics.track('Practice Areas Filter Selected', {
	                    // eslint-disable-next-line camelcase
	                    lawyer_id: vm.user.id,
	                    // eslint-disable-next-line camelcase
	                    filtered_location: vm.selectedLocations.name,
	                    page: 'In-House',
	                    name: vm.candidate.firstName + ' ' + vm.candidate.lastName
	                  });
	                } catch (error) {
	                  console.error('In-House', error);
	                }
	
	                _context16.next = 9;
	                return vm.select(vm.currentPage);
	
	              case 9:
	                vm.applyFilterCheck = false;
	
	              case 10:
	              case 'end':
	                return _context16.stop();
	            }
	          }
	        }, _callee16, _this);
	      }));
	
	      return function (_x13, _x14) {
	        return _ref32.apply(this, arguments);
	      };
	    }();
	
	    vm.pqeChanged = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
	      var separator, minPqe, maxPqe;
	      return regeneratorRuntime.wrap(function _callee17$(_context17) {
	        while (1) {
	          switch (_context17.prev = _context17.next) {
	            case 0:
	              separator = vm.filterPQE.search(';');
	              minPqe = vm.filterPQE.slice(0, separator);
	              maxPqe = vm.filterPQE.slice(separator + 1, vm.filterPQE.length);
	
	              vm.minPqe = minPqe;
	              vm.maxPqe = maxPqe;
	
	              try {
	                analytics.track('PQE Filter Selected', {
	                  // eslint-disable-next-line camelcase
	                  lawyer_id: vm.user.id,
	                  // eslint-disable-next-line camelcase
	                  min_pqe: minPqe,
	                  // eslint-disable-next-line camelcase
	                  max_pqe: maxPqe,
	                  page: 'In-House'
	                });
	              } catch (error) {
	                console.error('In-House', error);
	              }
	
	              _context17.next = 8;
	              return vm.select(vm.currentPage);
	
	            case 8:
	              vm.applyFilterCheck = false;
	
	            case 9:
	            case 'end':
	              return _context17.stop();
	          }
	        }
	      }, _callee17, _this);
	    }));
	
	    vm.applyFilters = function () {
	      var _ref34 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(type) {
	        return regeneratorRuntime.wrap(function _callee18$(_context18) {
	          while (1) {
	            switch (_context18.prev = _context18.next) {
	              case 0:
	                _context18.t0 = type;
	                _context18.next = _context18.t0 === 'employerType' ? 3 : _context18.t0 === 'occupation' ? 8 : _context18.t0 === 'contract' ? 13 : 18;
	                break;
	
	              case 3:
	                vm.selectedEmployerTypes = vm.employerTypes.filter(function (employerType) {
	                  return employerType.ticked;
	                });
	                _context18.next = 6;
	                return vm.select(vm.currentPage);
	
	              case 6:
	                vm.applyFilterCheck = false;
	
	                return _context18.abrupt('break', 19);
	
	              case 8:
	                vm.selectedOccupations = vm.occupations.filter(function (occupation) {
	                  return occupation.ticked;
	                });
	                _context18.next = 11;
	                return vm.select(vm.currentPage);
	
	              case 11:
	                vm.applyFilterCheck = false;
	
	                return _context18.abrupt('break', 19);
	
	              case 13:
	                vm.selectedContracts = vm.contractTypes.filter(function (contractType) {
	                  return contractType.ticked;
	                });
	                _context18.next = 16;
	                return vm.select(vm.currentPage);
	
	              case 16:
	                vm.applyFilterCheck = false;
	
	                return _context18.abrupt('break', 19);
	
	              case 18:
	                return _context18.abrupt('break', 19);
	
	              case 19:
	              case 'end':
	                return _context18.stop();
	            }
	          }
	        }, _callee18, _this);
	      }));
	
	      return function (_x15) {
	        return _ref34.apply(this, arguments);
	      };
	    }();
	
	    vm.hiddenJobFilter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
	      return regeneratorRuntime.wrap(function _callee19$(_context19) {
	        while (1) {
	          switch (_context19.prev = _context19.next) {
	            case 0:
	              vm.noJob = false;
	              if (vm.fetchHiddenJobs) {
	                vm.fetchHiddenJobs = false;
	              } else {
	                vm.fetchHiddenJobs = true;
	              }
	
	              _context19.next = 4;
	              return vm.select(1);
	
	            case 4:
	            case 'end':
	              return _context19.stop();
	          }
	        }
	      }, _callee19, _this);
	    }));
	
	    vm.showJobs = function (position) {
	      console.debug('showJobs');
	      if (position.expanded) {
	        console.debug('showJobs - hiding');
	        position.expanded = false;
	      } else if (position.expanded === false) {
	        console.debug('showJobs - showing', vm);
	        try {
	          var analyticsData = {
	            eventCategory: 'post-user acquisition',
	            eventAction: 'job - view',
	            eventLabel: 'click',
	            job_id: position.id,
	            firm_name: position.employer.name,
	            job_company: position.employer.name,
	            firm_id: position.employerId,
	            job_title: position.title,
	            job_pqe: position.lawPreferences.minPqe + ' - ' + position.lawPreferences.maxPqe,
	            job_contract: position.contractTypeName,
	            currentEmployerName: vm.candidate.employer.name,
	            currentEmployerId: vm.candidate.employer.id,
	            current_emp: vm.candidate.employer.name,
	            Name: vm.candidate.firstName + ' ' + vm.candidate.lastName,
	            name: vm.candidate.firstName + ' ' + vm.candidate.lastName
	          };
	          analytics.track('job - view', analyticsData);
	        } catch (error) {
	          console.error('Track - show jobs error', error);
	        }
	
	        position.expanded = true;
	      }
	    };
	
	    vm.locationBackgroundColor = function (location) {
	      var color = location.color;
	      var parent = location.parent;
	      var countryCode = Boolean(parent) && Boolean(parent.countryCode) ? parent.countryCode : '';
	      if (countryCode === 'GB') {
	        return 'london';
	      }
	
	      return color;
	    };
	
	    vm.showMore = function (job) {
	      job.isCollapsed = !job.isCollapsed;
	    };
	
	    vm.jumpToLink = function (id) {
	      var oldHash;
	      oldHash = $location.hash();
	      $location.hash(id);
	      $anchorScroll();
	      $location.hash(oldHash);
	    };
	
	    vm.showLess = function (job) {
	      job.isCollapsed = !job.isCollapsed;
	      vm.jumpToLink(job.id);
	    };
	
	    vm.formatPositionDescription = function (position) {
	      position.isCollapsed = true;
	      position.moreDetail = true;
	      if (position.description !== null) {
	        if (position.description.length > 600) {
	          position.showButton = true;
	        }
	      }
	    };
	
	    vm.checkPositionIsNew = function (position) {
	      var timeDiff = Math.abs(vm.today.getTime() - new Date(position.created).getTime());
	
	      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
	
	      if (diffDays < 7) {
	        position.isNewJob = true;
	      }
	    };
	
	    vm.askQuestion = function (position, event) {
	      event.preventDefault();
	      event.stopPropagation();
	
	      $uibModal.open({
	        backdrop: 'static',
	        templateUrl: 'contact-admin-modal.html',
	        controller: 'ContactAdminController',
	        controllerAs: 'ctrl',
	        resolve: {
	          selectedPosition: function selectedPosition() {
	            return position;
	          }
	        }
	      });
	    };
	
	    vm.formatPqeToYears = function (qualificationDate) {
	      return (0, _formatPqe.formatQualificationDateToPqe)(qualificationDate);
	    };
	
	    vm.hideDropDown = function () {
	      $scope.showClass = '';
	    };
	
	    vm.loadPrivateJobs = function () {
	      $location.url('/opportunities');
	    };
	
	    vm.disabledToolTip = function (candidate) {
	      if (candidate.approvalStatus === 'Locked') vm.toolTipText = 'Your profile is locked, wait for reapproval to apply for jobs.';else if (candidate.resumes.length === 0) vm.toolTipText = 'Upload your CV to connect with employers.';else if (!candidate.user.phone) vm.toolTipText = 'Please add your contact number in order to connect with firms.';
	      return true;
	    };
	
	    vm.updateProfileAlertStatus = function (alertType, status) {
	      if (alertType === 'both') {
	        vm.candidate.profileCvAlertCollapsed = status;
	        vm.candidate.profilePhoneAlertCollapsed = status;
	      } else {
	        vm.candidate[alertType] = status;
	      }
	    };
	
	    vm.findPositionEmployerType = function (position) {
	      return position.employerTypes.filter(function (_ref36) {
	        var name = _ref36.name;
	        return name === 'Private Practice';
	      }).length > 0 ? '/images/Private.png' : '/images/Inhouse.png';
	    };
	
	    vm.initializeMatches = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
	      var user, _ref38, locationsList, _ref39, candidate, _ref40, data, _ref41, userSetting, _ref42, resumes, welcomePopupSetting, pqeYears, _ref45, legalPracticeAreaList, _ref46, employerTypes;
	
	      return regeneratorRuntime.wrap(function _callee20$(_context20) {
	        while (1) {
	          switch (_context20.prev = _context20.next) {
	            case 0:
	              _context20.next = 2;
	              return userService.getUser();
	
	            case 2:
	              user = _context20.sent;
	
	              vm.user = user;
	              _context20.next = 6;
	              return SharedApi.getAllLocations({
	                supported: true,
	                regions: true
	              });
	
	            case 6:
	              _ref38 = _context20.sent;
	              locationsList = _ref38.data;
	
	              vm.locationsList = locationsList;
	
	              _context20.next = 11;
	              return CandidateProfileApi.getUserProfile(user.id, {
	                include: ['occupations', 'preferredContractTypes', 'school']
	              });
	
	            case 11:
	              _ref39 = _context20.sent;
	              candidate = _ref39.data;
	
	
	              vm.candidate = candidate;
	              _context20.next = 16;
	              return CandidateProfileApi.getUserProfile(user.id, {
	                include: ['preferredLocations']
	              });
	
	            case 16:
	              _ref40 = _context20.sent;
	              data = _ref40.data;
	
	              vm.candidate.preferredLocations = data.preferredLocations;
	              _context20.next = 21;
	              return CandidateProfileApi.getUserSettings(vm.user.id);
	
	            case 21:
	              _ref41 = _context20.sent;
	              userSetting = _ref41.data;
	              _context20.next = 25;
	              return CandidateProfileApi.getUserResumes(user.id);
	
	            case 25:
	              _ref42 = _context20.sent;
	              resumes = _ref42.data;
	
	
	              vm.candidate.resumes = resumes;
	              welcomePopupSetting = userSetting.find(function (_ref43) {
	                var id = _ref43.id;
	                return id === 1;
	              });
	
	
	              if (vm.candidate.approvalStatus !== 'Locked' && welcomePopupSetting && welcomePopupSetting.userSettings.find(function (_ref44) {
	                var settingId = _ref44.settingId;
	                return settingId === 1;
	              }).enable) {
	                $uibModal.open({
	                  templateUrl: 'welcome-modal.html',
	                  controller: 'WelcomeModalController',
	                  controllerAs: 'ctrl',
	                  resolve: {
	                    candidate: function candidate() {
	                      return vm.candidate;
	                    }
	                  }
	                }).result.then(function () {}, function () {});
	              }
	
	              vm.candidate.user.logoSrc = vm.candidate.user.profilePicture ? ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/user/' + vm.candidate.user.id + '/photo/' + vm.candidate.user.profilePicture : 'images/defaultPic.jpg';
	
	              vm.candidate.profileCvAlertCollapsed = false;
	              vm.candidate.profilePhoneAlertCollapsed = false;
	              _context20.next = 35;
	              return sharedProperties.getAgentDetails(vm.candidate.agent);
	
	            case 35:
	              vm.candidateAgent = _context20.sent;
	              pqeYears = vm.formatPqeToYears(candidate.lawProfile.qualificationDate);
	
	              vm.minPqe = pqeYears === '-' ? 0 : pqeYears - 1 <= 0 ? 0 : pqeYears - 1;
	              vm.maxPqe = pqeYears === '-' ? 11 : pqeYears + 1 <= 0 ? 0 : pqeYears + 1;
	              vm.filterPQE = vm.minPqe + ';' + vm.maxPqe;
	
	              _context20.next = 42;
	              return SharedApi.getCategoryById(1);
	
	            case 42:
	              _ref45 = _context20.sent;
	              legalPracticeAreaList = _ref45.data;
	
	              vm.legalPracticeAreaList = legalPracticeAreaList;
	
	              _context20.next = 47;
	              return SharedApi.getCategoryById(2);
	
	            case 47:
	              _ref46 = _context20.sent;
	              employerTypes = _ref46.data;
	
	
	              vm.employerTypes = employerTypes.specialties.map(function (employerType) {
	                return Object.assign({ ticked: true }, employerType);
	              });
	              vm.contractTypes = candidate.preferredContractTypes.map(function (contract) {
	                return Object.assign({ ticked: true }, contract);
	              });
	
	              vm.occupations = candidate.occupations.map(function (occupation) {
	                return Object.assign({ ticked: true }, occupation);
	              });
	
	              vm.candidateSpecialties = practiceAreaService.makeCandidatePracticeAreasHierarchy(candidate.category, vm.legalPracticeAreaList.specialties);
	
	              vm.regionHierarchialListWithEuropeOnTop = locationsGenericService.makeCandidateLocationsHierarchy(vm.candidate.preferredLocations, vm.locationsList);
	
	              vm.curLawyer = {
	                user: {
	                  firstName: vm.user.firstName
	                },
	                candidate: {
	                  profileCvAlertCollapsed: false,
	                  profilePhoneAlertCollapsed: false
	                }
	              };
	              _context20.next = 57;
	              return vm.onNumPerPageChange();
	
	            case 57:
	              $scope.$applyAsync();
	
	            case 58:
	            case 'end':
	              return _context20.stop();
	          }
	        }
	      }, _callee20, _this);
	    }));
	
	    vm.initializeMatches();
	  }]);
	})();

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _loadingOverlay = __webpack_require__(20);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	(function module() {
	  angular.module('app.ui.form.ctrls').controller('WelcomeModalController', ['candidate', 'SharedApi', '$scope', '$rootScope', 'logger', 'CandidateProfileApi', '$uibModalInstance', function controller(candidate, SharedApi, $scope, $rootScope, logger, CandidateProfileApi, $uibModalInstance) {
	    var _this = this;
	
	    var vm = this;
	    vm.contractsFilterData = [];
	    vm.occupationsFilterData = [];
	    vm.employerTypeFilterData = [];
	    vm.getAllPreferences = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var _ref2, contracts, _ref4, occupations, _ref6, employerTypes;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return SharedApi.getAllContractTypes();
	
	            case 2:
	              _ref2 = _context.sent;
	              contracts = _ref2.data;
	
	
	              contracts.forEach(function (contract) {
	                vm.contractsFilterData.push({
	                  id: contract.id,
	                  name: contract.name,
	                  ticked: candidate.preferredContractTypes.some(function (_ref3) {
	                    var id = _ref3.id;
	                    return id === contract.id;
	                  }),
	                  value: contract.id
	                });
	              });
	              _context.next = 7;
	              return SharedApi.getAllOccupations();
	
	            case 7:
	              _ref4 = _context.sent;
	              occupations = _ref4.data;
	
	
	              occupations.forEach(function (occupation) {
	                vm.occupationsFilterData.push({
	                  id: occupation.id,
	                  name: occupation.name,
	                  ticked: candidate.occupations.some(function (_ref5) {
	                    var id = _ref5.id;
	                    return id === occupation.id;
	                  }),
	                  value: occupation.id
	                });
	              });
	
	              _context.next = 12;
	              return SharedApi.getCategoryById(2);
	
	            case 12:
	              _ref6 = _context.sent;
	              employerTypes = _ref6.data;
	
	              employerTypes.specialties.forEach(function (employerType) {
	                vm.employerTypeFilterData.push({
	                  id: employerType.id,
	                  name: employerType.name,
	                  ticked: candidate.category.find(function (_ref7) {
	                    var id = _ref7.id;
	                    return id === 2;
	                  }).specialties.some(function (_ref8) {
	                    var id = _ref8.id;
	                    return id === employerType.id;
	                  }),
	                  value: employerType.id
	                });
	              });
	
	              $scope.$apply();
	
	            case 16:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    vm.validatePreferences = function () {
	      var isPreferenceValid = true;
	      var isPreferenceInValid = true;
	
	      vm.employerTypeFilterData.forEach(function (employerType) {
	        if (employerType.ticked) {
	          isPreferenceInValid = false;
	        }
	      });
	
	      if (isPreferenceInValid) {
	        isPreferenceValid = false;
	        logger.notify('error', 'At least one employer preference should be selected.');
	      }
	
	      isPreferenceInValid = true;
	      vm.contractsFilterData.forEach(function (contract) {
	        if (contract.ticked) {
	          isPreferenceInValid = false;
	        }
	      });
	
	      if (isPreferenceInValid) {
	        isPreferenceValid = false;
	        logger.notify('error', 'At least one contract preference should be selected.');
	      }
	
	      isPreferenceInValid = true;
	      vm.occupationsFilterData.forEach(function (occupation) {
	        if (occupation.ticked) {
	          isPreferenceInValid = false;
	        }
	      });
	
	      if (isPreferenceInValid) {
	        isPreferenceValid = false;
	        logger.notify('error', 'At least one occupation preference should be selected.');
	      }
	
	      return isPreferenceValid;
	    };
	
	    vm.updateCandidatePreference = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
	      var doUpdate;
	      return regeneratorRuntime.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              if (!vm.validatePreferences()) {
	                _context4.next = 12;
	                break;
	              }
	
	              _context4.prev = 1;
	
	              doUpdate = function () {
	                var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	                  var preferences;
	                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                      switch (_context2.prev = _context2.next) {
	                        case 0:
	                          preferences = {
	                            candidatePreference: {
	                              preferredContractTypes: vm.contractsFilterData.filter(function (contract) {
	                                return contract.ticked;
	                              }).map(function (_ref11) {
	                                var id = _ref11.id;
	                                return id;
	                              }),
	                              occupations: vm.occupationsFilterData.filter(function (occupation) {
	                                return occupation.ticked;
	                              }).map(function (_ref12) {
	                                var id = _ref12.id;
	                                return id;
	                              }),
	                              specialtiesByCategory: [{
	                                id: 2,
	                                specialties: vm.employerTypeFilterData.filter(function (employerType) {
	                                  return employerType.ticked;
	                                }).map(function (_ref13) {
	                                  var id = _ref13.id;
	                                  return id;
	                                })
	                              }]
	                            }
	                          };
	
	
	                          console.log('Welcome Modal: candidate preferences are:', preferences);
	
	                          _context2.next = 4;
	                          return CandidateProfileApi.updateProfileData(candidate.user.id, preferences);
	
	                        case 4:
	                          _context2.next = 6;
	                          return CandidateProfileApi.updateUserSettings(candidate.user.id, 1, false);
	
	                        case 6:
	
	                          $rootScope.$broadcast('candidate:wizard:completed');
	
	                          logger.notify('success', 'Preference updated successfully. Welcome to LexStep.');
	
	                        case 8:
	                        case 'end':
	                          return _context2.stop();
	                      }
	                    }
	                  }, _callee2, _this);
	                }));
	
	                return function doUpdate() {
	                  return _ref10.apply(this, arguments);
	                };
	              }();
	
	              _context4.next = 5;
	              return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                  while (1) {
	                    switch (_context3.prev = _context3.next) {
	                      case 0:
	                        return _context3.abrupt('return', doUpdate());
	
	                      case 1:
	                      case 'end':
	                        return _context3.stop();
	                    }
	                  }
	                }, _callee3, _this);
	              })));
	
	            case 5:
	              _context4.next = 11;
	              break;
	
	            case 7:
	              _context4.prev = 7;
	              _context4.t0 = _context4['catch'](1);
	
	              logger.notify('error', 'Failed to Update Preference');
	              if (_context4.t0) {
	                console.error('welcome wizard error:', _context4.t0);
	              }
	
	            case 11:
	
	              $uibModalInstance.close();
	
	            case 12:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this, [[1, 7]]);
	    }));
	
	    vm.getAllPreferences();
	  }]);
	})();

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _welcomeModal = __webpack_require__(604);
	
	var welcomeModalPopup = function welcomeModalPopup() {
	  return {
	    restrict: 'AE', // E for element/tag, A for attribute
	    template: __webpack_require__(168),
	    controller: _welcomeModal.WelcomeModalController
	  };
	};
	
	angular.module('app.directives').directive('welcomeModalPopup', welcomeModalPopup);

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('app.notes', ['pascalprecht.translate', 'angularFileUpload', 'angular.filter', 'ngSlider', 'ngCookies', 'ngAnimate', 'ngSanitize', 'angularSpinner', 'angular-clipboard', 'ui.nested.combobox']);
	
	__webpack_require__(608);
	__webpack_require__(180);
	__webpack_require__(610);
	__webpack_require__(609);
	__webpack_require__(607);

/***/ }),
/* 607 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/* eslint-disable angular/controller-as */
	angular.module('app.notes').controller('NoteModalController', ['$scope', '$modalInstance', 'noteData', 'NotesApi', 'logger', function notesModalCtrl($scope, $modalInstance, noteData, NotesApi, logger) {
	  var _this = this;
	
	  var fullName = function fullName(candidate) {
	    if (!candidate) {
	      return '';
	    }
	
	    if (candidate.firstName && candidate.lastName) {
	      return candidate.firstName.toLowerCase() + ' ' + candidate.lastName.toLowerCase();
	    }
	
	    return candidate.firstName || candidate.lastName || '';
	  };
	
	  var sortByName = function sortByName(list) {
	    return list.sort(function (a, b) {
	      var aName = fullName(a);
	      var bName = fullName(b);
	
	      if (aName < bName) {
	        return -1;
	      }
	
	      if (aName > bName) {
	        return 1;
	      }
	
	      return 0;
	    });
	  };
	
	  var format = function format(data) {
	    var candidates = data && data.candidates ? sortByName(data.candidates) : [];
	    return data && _.extend(data, { candidates: candidates });
	  };
	
	  $scope.timeOptions = {
	    hourStep: 1,
	    minStep: 1,
	    isMeridian: true
	  };
	  $scope.modalData = format(noteData);
	  console.debug('NotesModalCtrl::modalData', $scope.modalData);
	  if ($scope.modalData.note) $scope.modalData.note.date = $scope.modalData.note.date ? new Date($scope.modalData.note.date) : $scope.modalData.note.date;
	  $scope.editorOptions = {
	    extraPlugins: 'colorbutton'
	  };
	  $scope.medium = ['Call', 'Email', 'Meeting', 'Sms', 'Other'];
	  if ($scope.modalData.note) $scope.modalData.dateOptions = {
	    'datepicker-mode': "'day'",
	    'year-format': "'yy'",
	    'starting-day': 1,
	    defaultDate: '1'
	  };
	  $scope.addButtonClicked = false;
	  $scope.editButtonClicked = false;
	  $scope.typeChanged = function (data) {
	    $scope.modalData.note.noteTypeID = data;
	  };
	
	  $scope.addNote = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	    var updatedNote, _ref2, newNote;
	
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            updatedNote = {
	              body: $scope.modalData.note.body,
	              subject: $scope.modalData.note.subject,
	              attendees: $scope.modalData.note.attendees,
	              medium: $scope.modalData.note.medium,
	              category: $scope.modalData.note.category,
	              date: $scope.modalData.note.date,
	              userId: $scope.modalData.note.userId,
	              authorId: $scope.modalData.note.authorId,
	              employerId: $scope.modalData.note.employerId
	            };
	            _context.next = 3;
	            return NotesApi.createNote(updatedNote);
	
	          case 3:
	            _ref2 = _context.sent;
	            newNote = _ref2.data;
	
	
	            logger.notify('success', 'Note created successfully');
	            return _context.abrupt('return', $modalInstance.close(newNote));
	
	          case 7:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, _this);
	  }));
	
	  $scope.editNote = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	    var updatedNote, _ref4, note;
	
	    return regeneratorRuntime.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            updatedNote = {
	              body: $scope.modalData.note.body,
	              subject: $scope.modalData.note.subject,
	              attendees: $scope.modalData.note.attendees,
	              medium: $scope.modalData.note.medium,
	              category: $scope.modalData.note.category,
	              date: $scope.modalData.note.date,
	              authorId: $scope.modalData.note.authorId,
	              employerId: $scope.modalData.note.employerId,
	              userId: $scope.modalData.note.userId
	            };
	            _context2.next = 3;
	            return NotesApi.updateNote($scope.modalData.note.id, updatedNote);
	
	          case 3:
	            _ref4 = _context2.sent;
	            note = _ref4.data;
	
	
	            logger.notify('success', 'Note updated successfully');
	            return _context2.abrupt('return', $modalInstance.close(note));
	
	          case 7:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, _this);
	  }));
	
	  $scope.no = function () {
	    $modalInstance.dismiss('cancel');
	  };
	
	  $scope.deleteNote = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	    return regeneratorRuntime.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.next = 2;
	            return NotesApi.deleteNote(noteData);
	
	          case 2:
	            logger.notify('success', 'Note delete successfully');
	            return _context3.abrupt('return', $modalInstance.close(true));
	
	          case 4:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, _this);
	  }));
	}]);

/***/ }),
/* 608 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable angular/function-type */
	angular.module('app.notes').factory('notesModal', ['$modal', function notesModal($modal) {
	  return {
	    openAddNoteModal: function openAddNoteModal(modalData, Notes, noNotes) {
	      var modalInstance;
	      modalData.sNotes = Notes;
	      modalData.note.category = 'Conversation';
	      modalInstance = $modal.open({
	        templateUrl: 'notesModal.html',
	        controller: 'NoteModalController',
	        windowClass: 'notes-modal-window',
	        resolve: {
	          noteData: function noteData() {
	            return modalData;
	          }
	        }
	      });
	      modalInstance.result.then(function (updatedData) {
	        updatedData.employer = updatedData.employerId ? modalData.employers.find(function (employer) {
	          return employer.id === updatedData.employerId;
	        }) : undefined;
	        updatedData.author = updatedData.authorId ? modalData.authors.find(function (author) {
	          return author.id === updatedData.authorId;
	        }) : undefined;
	        updatedData.displayDate = updatedData.created;
	        // eslint-disable-next-line no-unused-vars
	        if (Notes.length === 0) noNotes = false;
	        Notes.unshift(updatedData);
	
	        return Notes;
	      }, function () {});
	      return Notes;
	    },
	    openDeleteNoteModal: function openDeleteNoteModal(noteID, notes, index) {
	      var modalInstance;
	      modalInstance = $modal.open({
	        templateUrl: 'deleteNoteModal.html',
	        controller: 'NoteModalController',
	        windowClass: 'notes-modal-window',
	        resolve: {
	          noteData: function noteData() {
	            return noteID;
	          }
	        }
	      });
	      modalInstance.result.then(function () {
	        notes.splice(index, 1);
	        return notes;
	      }, function () {});
	      return notes;
	    },
	    openEditNoteModal: function openEditNoteModal(notes, index, modalData) {
	      var modalInstance;
	      modalInstance = $modal.open({
	        templateUrl: 'editNoteModal.html',
	        controller: 'NoteModalController',
	        windowClass: 'notes-modal-window',
	        resolve: {
	          noteData: function noteData() {
	            return modalData;
	          }
	        }
	      });
	      modalInstance.result.then(function (updatedData) {
	        updatedData.employer = updatedData.employerId ? modalData.employers.find(function (employer) {
	          return employer.id === updatedData.employerId;
	        }) : undefined;
	        updatedData.author = updatedData.authorId ? modalData.authors.find(function (author) {
	          return author.id === updatedData.authorId;
	        }) : undefined;
	        notes[index] = Object.assign({}, updatedData);
	
	        return notes;
	      }, function () {});
	    },
	    openNoteHistoryModal: function openNoteHistoryModal(NoteHistory) {
	      var modalInstance;
	      modalInstance = $modal.open({
	        templateUrl: 'noteHistoryModal.html',
	        controller: 'NoteModalController',
	        resolve: {
	          noteData: function noteData() {
	            return NoteHistory;
	          }
	        }
	      });
	      modalInstance.result.then();
	      return NoteHistory;
	    }
	  };
	}]).factory('lawyerAndAdminID', [
	// eslint-disable-next-line func-names
	function () {
	  var factory;
	  var model;
	  factory = {};
	  model = {};
	  // eslint-disable-next-line func-names
	  factory.setModel = function (key, value) {
	    model[key] = value;
	  };
	
	  // eslint-disable-next-line func-names
	  factory.getModel = function (key) {
	    return model[key];
	  };
	
	  return factory;
	}]);

/***/ }),
/* 609 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.api').factory('NotesApi', ['api', function NotesApi(api) {
	  var _this = this;
	
	  var notesApi = {
	    getAllNotes: function getAllNotes(payload) {
	      return api.get('notes', { params: payload });
	    },
	    createNote: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                return _context.abrupt('return', api.post('notes', payload));
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function createNote(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return createNote;
	    }(),
	    updateNote: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id, payload) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                return _context2.abrupt('return', api.put('notes/' + id, payload));
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      function updateNote(_x2, _x3) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return updateNote;
	    }(),
	    deleteNote: function deleteNote(id, parameter) {
	      return api.delete('notes/' + id, { params: parameter });
	    },
	    getNoteHistory: function getNoteHistory(payload) {
	      return api.get('actions', { params: payload });
	    }
	  };
	  return notesApi;
	}]);

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _notes = __webpack_require__(180);
	
	var notesDirective = function notesDirective() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      user: '='
	    },
	    controller: _notes.NotesController,
	    template: __webpack_require__(439)
	  };
	};
	
	angular.module('app.directives').directive('notesDirective', notesDirective);

/***/ }),
/* 611 */
/***/ (function(module, exports) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  'use strict';
	
	  angular.module('app.page.ctrls', []).controller('invoiceCtrl', ['$scope', '$window', function ($scope, $window) {
	    return $scope.printInvoice = function () {
	      var originalContents, popupWin, printContents;
	      printContents = document.getElementById('invoice').innerHTML;
	      originalContents = document.body.innerHTML;
	      popupWin = window.open();
	      popupWin.document.open();
	      popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="styles/main.css" /></head><body onload="window.print()">' + printContents + '</html>');
	      return popupWin.document.close();
	    };
	  }]);
	}).call(undefined);

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/* eslint-disable camelcase */
	angular.module('app.ui.form.ctrls').controller('ReferFriendController', ['InviteFriendApi', '$location', '$scope', 'sharedProperties', 'userService', '$translate', '$cookies', 'logger', function controller(InviteFriendApi, $location, $scope, sharedProperties, userService, $translate, $cookies, logger) {
	  var _this = this;
	
	  var initializeData = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return userService.getUser();
	
	            case 2:
	              vm.user = _context.sent;
	
	              vm.populateCode(vm.user.id);
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    return function initializeData() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  initializeData();
	
	  var friendNameAndEmail;
	
	  var vm = this;
	
	  vm.textTocopy = angular.element('.refer-message').text();
	
	  vm.notify = function (type, message) {
	    switch (type) {
	      case 'info':
	        logger.log(message);
	        break;
	      case 'success':
	        logger.logSuccess(message);
	        break;
	      case 'warning':
	        logger.logWarning(message);
	        break;
	      case 'error':
	        logger.logError(message);
	        break;
	      default:
	        break;
	    }
	  };
	
	  vm.editorOptions = {
	    extraPlugins: 'colorbutton'
	  };
	  vm.curLawyer = {
	    user: {
	      first_Name: $cookies.firstName
	    }
	  };
	  $translate.use('en');
	  vm.referralCode = '';
	  vm.friendsList = [];
	  friendNameAndEmail = {
	    name: '',
	    email: ''
	  };
	  vm.friendsList.push(friendNameAndEmail);
	  vm.hideDropDown = function () {
	    vm.showClass = '';
	  };
	
	  vm.showClass = '';
	  vm.showDropDown = function () {
	    if (vm.showClass === '') {
	      vm.showClass = 'show';
	    } else {
	      vm.showClass = '';
	    }
	  };
	
	  vm.copySuccess = function () {
	    vm.notify('success', 'Message successfully copied to clipboard');
	  };
	
	  vm.copyFail = function (error) {
	    vm.notify('error', 'Unable to copy.');
	  };
	
	  vm.showClass = '';
	  vm.showDropDown = function () {
	    if (vm.showClass === '') {
	      vm.showClass = 'show';
	    } else {
	      vm.showClass = '';
	    }
	  };
	
	  vm.getEmailText = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(refer) {
	      var _ref3, data, status;
	
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.next = 2;
	              return InviteFriendApi.getInviteFriendsEmail();
	
	            case 2:
	              _ref3 = _context2.sent;
	              data = _ref3.data;
	              status = _ref3.status;
	
	
	              if (status === 440) $location.url('/signin');
	              vm.referEmail.emailText = stringReplaceAll(data.versions[0].html_content, '<%-referralCode%>', ("https://lexstep.com") + '/sign-up/' + refer);
	              vm.referEmail.emailText = stringReplaceAll(vm.referEmail.emailText, '{{publicURL}}', ("https://lexstep.com"));
	
	              vm.referEmail.emailText = stringReplaceAll(vm.referEmail.emailText, '{{referredPerson.name}}', '[name]');
	
	              vm.referEmail.emailText = stringReplaceAll(vm.referEmail.emailText, '{{user.firstName}}', vm.user.firstName);
	              vm.referEmail.emailText = stringReplaceAll(vm.referEmail.emailText, '{{ user.lastName}}', vm.user.lastName);
	              vm.referEmail.emailText = stringReplaceAll(vm.referEmail.emailText, '{{user.referralCode}}', vm.referralCode);
	              $scope.$apply();
	
	            case 13:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this);
	    }));
	
	    return function (_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  vm.referEmail = {
	    friendsName: [],
	    friendsEmail: [],
	    subject: '',
	    frCount: 0,
	    emailText: '',
	    friends: []
	  };
	  vm.isFriendsListFilled = function () {
	    var friendsListSize;
	    var index;
	    var k;
	    var reference;
	    friendsListSize = vm.friendsList.length;
	    for (
	    // eslint-disable-next-line no-multi-assign
	    index = k = 0, reference = friendsListSize; reference >= 0 ? k < reference : k > reference; index = reference >= 0 ? ++k : --k) {
	      if (!vm.friendsList[index].email) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  vm.trackReferFriend = function (friendsList) {
	    try {
	      analytics.track('Refering Friends', {
	        referral_code: vm.referralCode,
	        friends_list: friendsList
	      });
	    } catch (error) {
	      console.error('Refer A Friend', error);
	    }
	  };
	
	  vm.sendReferEmail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	    var _ref5, status;
	
	    return regeneratorRuntime.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            vm.referEmail.friends = vm.friendsList;
	            vm.referEmail.emailText = vm.referEmail.emailText.replace('[yourFirstName]', vm.user.firstName);
	            vm.referEmail.emailText = vm.referEmail.emailText.replace('[yourLastName]', vm.user.lastName);
	
	            _context3.next = 5;
	            return InviteFriendApi.sendReferralEmails(vm.user.id, vm.friendsList, false);
	
	          case 5:
	            _ref5 = _context3.sent;
	            status = _ref5.status;
	
	            if (!(status !== 201)) {
	              _context3.next = 9;
	              break;
	            }
	
	            return _context3.abrupt('return', vm.notify('error', 'There has been an error in sending your emails. Please try again'));
	
	          case 9:
	            if (!(status === 201)) {
	              _context3.next = 11;
	              break;
	            }
	
	            return _context3.abrupt('return', logger.notify('success', 'Email(s) have been sent successfully.'));
	
	          case 11:
	
	            vm.trackReferFriend(vm.friendsList);
	
	          case 12:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, _this);
	  }));
	
	  vm.anotherFriend = function () {
	    friendNameAndEmail = {
	      name: '',
	      email: ''
	    };
	    if (vm.friendsList.length < 5) {
	      vm.friendsList.push(friendNameAndEmail);
	    }
	  };
	
	  vm.removeFriend = function (removedFriend) {
	    var itemToBeRemovedIndex;
	    itemToBeRemovedIndex = vm.friendsList.indexOf(removedFriend);
	    vm.friendsList.splice(itemToBeRemovedIndex, 1);
	  };
	
	  vm.logOut = function () {
	    sharedProperties.logOut();
	  };
	
	  vm.populateCode = function (data) {
	    vm.referralCode = data;
	    var lexstepReferUrl = ("https://lexstep.com") + '/sign-up/' + vm.referralCode;
	    var encodedReferUrl = encodeURIComponent(lexstepReferUrl);
	    vm.shareLink = 'https://www.facebook.com/sharer/sharer.php?u=' + encodedReferUrl + '&amp;src=sdkpreparse';
	    vm.dataLink = lexstepReferUrl;
	    vm.getEmailText(vm.referralCode);
	    vm.textTocopy = lexstepReferUrl;
	    vm.referEmail.subject = 'Invitation from your friend ' + vm.curLawyer.user.first_Name + ' ' + vm.curLawyer.user.last_Name;
	    $scope.$applyAsync();
	  };
	
	  vm.referFriend = function () {
	    $location.url('/refer-friend');
	  };
	
	  vm.firmsAndJobs = function () {
	    $location.url('/opportunities');
	  };
	
	  vm.loadProfile = function () {
	    $location.url('/user-profile');
	  };
	
	  vm.AppliedJobs = function () {
	    $location.url('/connections');
	  };
	}]);
	var stringReplaceAll = function stringReplaceAll(target, search, replacement) {
	  return target.replace(new RegExp(search, 'g'), replacement);
	};

/***/ }),
/* 613 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	  angular.module('app.ui.form.ctrls').controller('CreateProfileModalCtrl', ['$scope', '$log', '$modalInstance', 'practicesService', 'data', 'logger', function ($scope, $log, $modalInstance, practicesService, data, logger) {
	    $scope.data = [];
	    $scope.data = data.data;
	    $scope.showLocations = false;
	    $scope.showPractices = false;
	    $scope.showCategories = false;
	    $scope.showJurisdictions = false;
	    $scope.jurisdictions = [];
	    $scope.element = data.element;
	    $scope.heading = '';
	    $scope.CheckBox = '';
	    $scope.updatedData = {
	      data: $scope.data,
	      element: $scope.element
	    };
	    $scope.selectedAll = false;
	    $scope.count = 0;
	
	    $scope.saveButtonText = 'save';
	
	    // This method hides all the components(locations, Practice Areas, jurisdictions, categories)
	    // available in the modal
	    function hideAllModalComponents() {
	      angular.extend($scope, {
	        showLocations: false,
	        showPractices: false,
	        showCategories: false,
	        showJurisdictions: false
	      });
	    }
	
	    // This Method gets the value for a property from the input object i.e data.data
	    // used as an input model for the modal, if not found just returns the default
	    // data object
	    function getDataPropertyFromInputModel(property) {
	      return data.data[property] || data.data;
	    }
	
	    // This Method gets the value for the object used as a model to save temporarily
	    // the selection made by the user
	    function getUpdatedObjectForHoldingDataForSelection(elementId) {
	      switch (elementId) {
	        case 'jurisdiction':
	          $scope.updatedData.otherJurisdictions = !_.isEmpty(data.otherJurisdictions) ? data.otherJurisdictions : '';
	          $scope.jurisdictions = getDataPropertyFromInputModel('jurisdictions');
	          return $scope.jurisdictions;
	        case 'practice':
	          return getDataPropertyFromInputModel('practiceAreas');
	        case 'location':
	          return getDataPropertyFromInputModel('locations');
	        default:
	          return getDataPropertyFromInputModel(null);
	      }
	    }
	
	    // This method transitions the data for locations/Practice Areas to edit when user
	    // either opens this modal for practice ares or presses the next button on the
	    // Practice Area Settings
	    function updateModalForNextFunctionality(elementId) {
	      $scope.saveButtonText = 'Next';
	      $scope.data = getUpdatedObjectForHoldingDataForSelection(elementId);
	      $scope.updatedData.data = $scope.data;
	
	      // set the response object to be sent back as the updated data
	      angular.extend($scope.updatedData, getUpdatedResponseModelNextFunctionality());
	    }
	
	    // This method updates the object that is to be returned when user has finished updating
	    // either locations or the practicr areas
	    function getUpdatedResponseModelNextFunctionality() {
	      if ($scope.showJurisdictions) {
	        return {
	          jurisdictions: $scope.updatedData.data,
	          element: 'jurisdiction'
	        };
	      } else if ($scope.showPractices) {
	        return {
	          practiceAreas: $scope.updatedData.data,
	          element: 'practice'
	        };
	      } else if ($scope.showLocations) {
	        return {
	          locations: $scope.updatedData.data,
	          element: 'location'
	        };
	      }
	    }
	
	    // This methd updates modal for the locations settings
	    function askToSelectLocations() {
	      hideAllModalComponents();
	      $scope.heading = 'createProfile.locationsModal.Heading';
	      $scope.subHeading = 'createProfile.locationsModal.subHeading';
	
	      $scope.showLocations = true;
	      $scope.isHeadingBold = true;
	
	      //ask to update data for locations change
	      updateModalForNextFunctionality('location');
	    }
	
	    // This methd updates modal for the Practice Area settings
	    function askToSelectPracticeAreas() {
	      hideAllModalComponents();
	      $scope.heading = 'createProfile.practiceAreasModal.Heading';
	      $scope.subHeading = 'createProfile.practiceAreasModal.subHeading';
	
	      $scope.showPractices = true;
	      $scope.isHeadingBold = true;
	
	      //ask to update data for Practice Areas change
	      updateModalForNextFunctionality('practice');
	
	      //count the already selected Practice Areas
	      data.linearPractices.forEach(function (practice, index, array) {
	        if (practice.isSelected && !practice.hasChild) {
	          $scope.count++;
	        }
	      });
	    }
	
	    // This methed updates modal for the Jurisdiction selection settings
	    function askToSelectJurisdictions() {
	      hideAllModalComponents();
	      $scope.element = 'jurisdiction';
	      $scope.heading = 'createProfile.jurisdictionsModal.Heading';
	      $scope.subHeading = 'createProfile.jurisdictionsModal.subHeading';
	
	      $scope.showJurisdictions = true;
	      $scope.isHeadingBold = true;
	
	      updateModalForNextFunctionality('jurisdiction');
	    }
	
	    // find and set the values for the practice areas that are changed,
	    // This value is to be returned as the changed selection made by the user
	    function determineChangedPractices() {
	      $scope.updatedData.linearPractices = [];
	      $scope.updatedData.data.forEach(function (law_area, index, array) {
	        $scope.updatedData.linearPractices.push(law_area);
	        law_area.practices.forEach(function (practice, index, array) {
	          $scope.updatedData.linearPractices.push(practice);
	          practice.sub_areas.forEach(function (sub, index, array) {
	            return $scope.updatedData.linearPractices.push(sub);
	          });
	        });
	      });
	    }
	
	    // This method return a data when the modal is closed, if no data is given i.e canceled
	    // it just closes without returning any thing
	    function closeModalWithData(newData) {
	      $modalInstance.close(newData);
	    }
	
	    // This method prepares data & UI to display for the next selection
	    function displayNextSelection() {
	      $scope.hasUserMadeAnyUpdates = true;
	
	      if ($scope.updatedData.element === 'jurisdiction') {
	        askToSelectPracticeAreas();
	      } else if ($scope.updatedData.element === 'practice') {
	        determineChangedPractices();
	        askToSelectLocations();
	      } else closeModalWithData($scope.updatedData);
	    }
	
	    // This method determines whether the modal has been asked to activate the
	    // multiple selection views one by one or is it to just behave like a single popup
	    function determineWhetherToDisplayNextSelectionOrClose() {
	      if (data.displayNextFunctionality) displayNextSelection();else closeModalWithData($scope.updatedData);
	    }
	
	    $scope.displayChildLocations = function (region) {
	      return region.showChildLocations = true;
	    };
	    $scope.hideChildLocations = function (region) {
	      return region.showChildLocations = false;
	    };
	    $scope.isHeadingBold = false;
	
	    //determine whether to display the Jurisdictions for editing
	    if ($scope.element === 'jurisdiction') askToSelectJurisdictions();
	    //determine whether to display the Practice Areas for editing
	    else if ($scope.element === 'practice') askToSelectPracticeAreas();
	      //determine whether to display the locations for editing
	      else if ($scope.element === 'location') askToSelectLocations();else if ($scope.element === 'category') {
	          $scope.heading = 'createProfile.firmCategoryModal.Heading';
	          $scope.subHeading = 'createProfile.firmCateforyModal.subHeading';
	          $scope.showCategories = true;
	        }
	
	    $scope.updateData = function (event, cur_box) {
	      var message, value;
	      if ($scope.showLocations) {
	        $scope.updatedData.element = $scope.element;
	        value = event.target.checked;
	        $scope.updatedData.data.forEach(function (chkbox, index, array) {
	          if (chkbox.loc_ID === cur_box.loc_ID) {
	            chkbox.isSelected = value;
	          }
	        });
	      } else if ($scope.showJurisdictions) {
	        $scope.updatedData.element = $scope.element;
	        value = event.target.checked;
	        $scope.updatedData.data.forEach(function (chkbox, index, array) {
	          if (chkbox.loc_ID === cur_box.loc_ID) {
	            chkbox.isSelected = value;
	          }
	        });
	      } else if ($scope.showPractices) {
	        $scope.updatedData.element = $scope.element;
	        value = event.target.checked;
	        if (value) {
	          $scope.count++;
	          if ($scope.count > 20) {
	            message = 'You are allowed to choose a maximum of 20 practice areas.';
	            logger.notify('error', message);
	            event.target.checked = false;
	            value = false;
	            $scope.count = 20;
	          } else if ($scope.count === 15) {
	            message = 'You are approaching the limit for practice area selections.';
	            logger.notify('warning', message);
	          } else if ($scope.count === 20) {
	            message = 'You have reached the limit for practice area selections, please refine your expertise to only those practice areas you have actual experience in.';
	            logger.notify('warning', message);
	          }
	        } else {
	          $scope.count--;
	        }
	        if ($scope.count <= 20) {
	          $scope.updatedData.data.forEach(function (chkbox, index, array) {
	            if (chkbox.practice_ID === cur_box.practice_ID) {
	              chkbox.isSelected = value;
	            }
	          });
	        }
	      } else if ($scope.showCategories) {
	        $scope.updatedData.element = $scope.element;
	        value = event.target.checked;
	        $scope.updatedData.data.forEach(function (chkbox, index, array) {
	          if (chkbox.cat_ID === cur_box.cat_ID) {
	            chkbox.isSelected = value;
	          }
	        });
	      }
	    };
	    $scope.displaySubPracticeAreas = function (law_area) {
	      return law_area.showSubPracticeAreas = true;
	    };
	    $scope.hideSubPracticeAreas = function (law_area) {
	      return law_area.showSubPracticeAreas = false;
	    };
	    $scope.displayChildLocations = function (region) {
	      $log.info("plus clicked");
	      return region.showChildLocations = true;
	    };
	    $scope.hideChildLocations = function (region) {
	      $log.info("minus clicked");
	      return region.showChildLocations = false;
	    };
	    $scope.selectPractices = function (event, current, level) {
	      var message = void 0,
	          pCounter = void 0,
	          sCounter = void 0,
	          value = void 0;
	      $log.info("law_area selected on signup profile");
	      $log.info(current);
	      pCounter = 0;
	      sCounter = 0;
	      $scope.updatedData.element = 'practice';
	      value = event.target.checked;
	      if ($scope.count >= 20 && value) {
	        message = 'You are allowed to choose a maximum of 20 practice areas.';
	        logger.notify('error', message);
	        event.target.checked = false;
	        return false;
	      } else {
	        if (level === 2) {
	          $scope.updatedData.data.forEach(function (law_area, index, array) {
	            if (law_area.practice_ID === current.practice_ID) {
	              law_area.isSelected = value;
	              if (law_area.practices.length > 0) {
	                law_area.practices.forEach(function (practice, index, array) {
	                  if (practice.sub_areas.length > 0 && $scope.count < 20) {
	                    practice.isSelected = value;
	                    practice.sub_areas.forEach(function (sub, index, array) {
	                      if (sub.isSelected !== value) {
	                        if ($scope.count < 20 && value) {
	                          sub.isSelected = value;
	                          $scope.count++;
	                        } else if (!value) {
	                          sub.isSelected = value;
	                          $scope.count--;
	                        }
	                      }
	                    });
	                  } else {
	                    if ($scope.count < 20 && value) {
	                      practice.isSelected = value;
	                      $scope.count++;
	                    } else if (!value && practice.isSelected) {
	                      practice.isSelected = value;
	                      $scope.count--;
	                    }
	                  }
	                });
	              } else {
	                if (value && $scope.count < 20) {
	                  law_area.isSelected = value;
	                  $scope.count++;
	                } else if (!value) {
	                  law_area.isSelected = value;
	                  $scope.count--;
	                }
	              }
	
	              practicesService.checkForLinking($scope.updatedData.data, current.practice_ID, value);
	            }
	          });
	          // return;
	        } else if (level === 1) {
	          $scope.updatedData.data.forEach(function (law_area, index, array) {
	            return law_area.practices.forEach(function (practice, index, array) {
	              if (practice.practice_ID === current.practice_ID) {
	                $log.info("level 1 pa selected");
	                $log.info(practice);
	                if (practice.sub_areas.length > 0) {
	                  practice.isSelected = value;
	                  law_area.practices.forEach(function (p, i, a) {
	                    if (p.isSelected) {
	                      pCounter++;
	                    }
	                  });
	                  if (value) {
	                    if (pCounter > 0) {
	                      law_area.isSelected = value;
	                    }
	                  } else {
	                    if (pCounter <= 0) {
	                      law_area.isSelected = value;
	                    }
	                  }
	                  practice.sub_areas.forEach(function (sub, index, array) {
	                    if (sub.isSelected !== value) {
	                      if ($scope.count < 20 && value) {
	                        sub.isSelected = value;
	                        $scope.count++;
	                      } else if (!value) {
	                        if (sub.isSelected) {
	                          sub.isSelected = value;
	                          $scope.count--;
	                        }
	                      }
	                    }
	                  });
	                } else {
	                  if ($scope.count < 20 && value) {
	                    $log.info("updating checked value");
	                    practice.isSelected = value;
	                    law_area.practices.forEach(function (p, i, a) {
	                      if (p.isSelected) {
	                        pCounter++;
	                      }
	                    });
	                    if (value) {
	                      if (pCounter > 0) {
	                        law_area.isSelected = value;
	                      }
	                    } else {
	                      if (pCounter <= 0) {
	                        law_area.isSelected = value;
	                      }
	                    }
	                    $scope.count++;
	                  } else if (!value) {
	                    practice.isSelected = value;
	                    law_area.practices.forEach(function (p, i, a) {
	                      if (p.isSelected) {
	                        pCounter++;
	                      }
	                    });
	                    if (value) {
	                      if (pCounter > 0) {
	                        law_area.isSelected = value;
	                      }
	                    } else {
	                      if (pCounter <= 0) {
	                        law_area.isSelected = value;
	                      }
	                    }
	                    $scope.count--;
	                  }
	                }
	
	                practicesService.checkForLinking($scope.updatedData.data, current.practice_ID, value);
	              }
	            });
	          });
	          // return;
	        } else if (level === 0) {
	          $scope.updatedData.data.forEach(function (law_area, index, array) {
	            law_area.practices.forEach(function (practice, index, array) {
	              if (practice.sub_areas.length > 0) {
	                practice.sub_areas.forEach(function (sub, index, array) {
	                  if (sub.practice_ID === current.practice_ID) {
	                    sub.isSelected = value;
	                    practice.sub_areas.forEach(function (s, i, a) {
	                      if (s.isSelected) {
	                        sCounter++;
	                      }
	                    });
	                    if (value) {
	                      if (sCounter > 0) {
	                        law_area.isSelected = value;
	                        practice.isSelected = value;
	                      }
	                    } else {
	                      if (sCounter <= 0) {
	                        practice.isSelected = value;
	                        law_area.practices.forEach(function (p, i, a) {
	                          if (p.isSelected) {
	                            pCounter++;
	                          }
	                        });
	                        if (value) {
	                          if (pCounter > 0) {
	                            law_area.isSelected = value;
	                          }
	                        } else {
	                          if (pCounter <= 0) {
	                            law_area.isSelected = value;
	                          }
	                        }
	                      }
	                    }
	                    if (value) {
	                      $scope.count++;
	                    } else {
	                      $scope.count--;
	                    }
	
	                    practicesService.checkForLinking($scope.updatedData.data, current.practice_ID, value);
	                  }
	                });
	              }
	            });
	          });
	        }
	        if ($scope.count === 20) {
	          message = 'You have reached the limit for practice area selections, please refine your expertise to only those practice areas you have actual experience in.';
	          logger.notify('warning', message);
	        } else if ($scope.count === 15) {
	          message = 'You are approaching the limit for practice area selections';
	          logger.notify('warning', message);
	        }
	      }
	    };
	
	    $scope.selectLocation = function (event, current, level) {
	      var pCounter, sCounter, value;
	      pCounter = 0;
	      sCounter = 0;
	      $scope.updatedData.element = 'location';
	      value = event.target.checked;
	      if (level === 2) {
	        $scope.updatedData.data.forEach(function (region, index, array) {
	          if (region.loc_ID === current.loc_ID) {
	            region.isSelected = value;
	            if (region.locations.length > 0) {
	              region.locations.forEach(function (location, index, array) {
	                location.isSelected = value;
	                location.sub_areas.forEach(function (sub, index, array) {
	                  if (sub.isSelected !== value) {
	                    if (value) {
	                      sub.isSelected = value;
	                    } else if (!value) {
	                      sub.isSelected = value;
	                    }
	                  }
	                });
	                if (value) {
	                  return location.isSelected = value;
	                } else if (!value && location.isSelected) {
	                  return location.isSelected = value;
	                }
	              });
	            } else {
	              if (value) {
	                return region.isSelected = value;
	              } else if (!value) {
	                return region.isSelected = value;
	              }
	            }
	          }
	        });
	        return;
	      } else if (level === 1) {
	        $scope.updatedData.data.forEach(function (region, index, array) {
	          return region.locations.forEach(function (location, index, array) {
	            if (location.loc_ID === current.loc_ID) {
	              if (location.sub_areas.length > 0) {
	                location.isSelected = value;
	                region.locations.forEach(function (p, i, a) {
	                  if (p.isSelected) {
	                    pCounter++;
	                  }
	                });
	                if (value) {
	                  if (pCounter > 0) {
	                    region.isSelected = value;
	                  }
	                } else {
	                  if (pCounter <= 0) {
	                    region.isSelected = value;
	                  }
	                }
	                location.sub_areas.forEach(function (sub, index, array) {
	                  if (sub.isSelected !== value) {
	                    if (value) {
	                      sub.isSelected = value;
	                    } else if (!value) {
	                      if (sub.isSelected) {
	                        sub.isSelected = value;
	                      }
	                    }
	                  }
	                });
	              } else {
	                if (value) {
	                  location.isSelected = value;
	                  region.locations.forEach(function (p, i, a) {
	                    if (p.isSelected) {
	                      pCounter++;
	                    }
	                  });
	                  if (value) {
	                    if (pCounter > 0) {
	                      region.isSelected = value;
	                    }
	                  } else {
	                    if (pCounter <= 0) {
	                      region.isSelected = value;
	                    }
	                  }
	                } else if (!value) {
	                  location.isSelected = value;
	                  region.locations.forEach(function (p, i, a) {
	                    if (p.isSelected) {
	                      pCounter++;
	                    }
	                  });
	                  if (value) {
	                    if (pCounter > 0) {
	                      region.isSelected = value;
	                    }
	                  } else {
	                    if (pCounter <= 0) {
	                      region.isSelected = value;
	                    }
	                  }
	                }
	              }
	            }
	          });
	        });
	        return;
	      } else if (level === 0) {
	        $scope.updatedData.data.forEach(function (region, index, array) {
	          region.locations.forEach(function (location, index, array) {
	            if (location.sub_areas.length > 0) {
	              location.sub_areas.forEach(function (sub, index, array) {
	                if (sub.loc_ID === current.loc_ID) {
	                  sub.isSelected = value;
	                  location.sub_areas.forEach(function (s, i, a) {
	                    if (s.isSelected) {
	                      sCounter++;
	                    }
	                  });
	                  if (value) {
	                    if (sCounter > 0) {
	                      region.isSelected = value;
	                      location.isSelected = value;
	                    }
	                  } else {
	                    if (sCounter <= 0) {
	                      location.isSelected = value;
	                      region.locations.forEach(function (p, i, a) {
	                        if (p.isSelected) {
	                          pCounter++;
	                        }
	                      });
	                      if (value) {
	                        if (pCounter > 0) {
	                          region.isSelected = value;
	                        }
	                      } else {
	                        if (pCounter <= 0) {
	                          region.isSelected = value;
	                        }
	                      }
	                    }
	                  }
	                }
	              });
	            }
	          });
	        });
	      }
	    };
	    $scope.countCheckbox = function (value, level) {
	      if (value) {
	        $scope.count++;
	      } else if (!value) {
	        $scope.count--;
	      }
	    };
	    $scope.selectAll = function (event) {
	      var mainCheckBox = void 0,
	          message = void 0,
	          value = void 0;
	      mainCheckBox = event.target.attributes.data.value;
	      value = event.target.checked;
	      if (value) {
	        if ($scope.count > 20) {
	          message = 'You are allowed to choose a maximum of 20 practice areas.';
	          logger.notify('error', message);
	          event.target.checked = false;
	          return false;
	        } else if ($scope.count <= 20) {
	          if ($scope.count === 20) {
	            message = 'You have reached the limit for practice area selections, please refine your expertise to only those practice areas you have actual experience in.';
	            logger.notify('warning', message);
	          } else if ($scope.count === 15) {
	            message = 'You are approaching the limit for practice area selections.';
	            logger.notify('warning', message);
	          }
	
	          $scope.data.forEach(function (chkbox, index, array) {
	            if (chkbox.lawArea_ID === parseInt(mainCheckBox) && !chkbox.isSelected && $scope.count < 20) {
	              $scope.countCheckbox(value, 1);
	              chkbox.isSelected = value;
	            }
	          });
	        }
	      } else {
	        $scope.data.forEach(function (chkbox, index, array) {
	          if (chkbox.lawArea_ID === parseInt(mainCheckBox) && chkbox.isSelected) {
	            $scope.countCheckbox(value, 1);
	            chkbox.isSelected = value;
	          }
	        });
	      }
	    };
	    $scope.save = function () {
	      determineWhetherToDisplayNextSelectionOrClose();
	    };
	    $scope.cancel = function () {
	      // determine if locations settings are displayed then
	      // the user might have tried to update Practice Areas
	      // so save them and hide the form
	      if ($scope.hasUserMadeAnyUpdates) closeModalWithData($scope.updatedData);
	      // just close the modal
	      else $modalInstance.dismiss("cancel");
	    };
	  }]);
	})();

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable no-negated-condition */
	/* eslint-disable unicorn/no-null */
	/* eslint-disable func-names, no-unused-vars, no-undef, no-return-assign, unicorn/filename-case, angular/function-type, angular/controller-name, angular/controller-as */
	;(function () {
	  angular.module('app.ui.form.ctrls').controller('DatepickerDemoCtrl', ['$scope', '$location', '$log', function ($scope, $location, $log) {
	    var allowedUrlsForMonthFormat = new Set(['/profile', '/user-profile', '/profile#!', '/admin/lawyer-profile', '/admin/lawyer-listing']);
	    var oldDate = new Date();
	    $scope.maxDate = new Date();
	    $scope.today = function () {
	      $scope.dt = new Date();
	      $scope.dt.setHours(24, 0, 0, 0);
	      oldDate.setDate(oldDate.getDate() + 1);
	    };
	
	    $scope.today();
	    $scope.showWeeks = true;
	    $scope.toggleWeeks = function () {
	      return $scope.showWeeks = !$scope.showWeeks;
	    };
	
	    $scope.clear = function () {
	      return $scope.dt = null;
	    };
	
	    // $location;
	    // $scope.disabled = function(date, mode) {
	    //   if ($location.url() !== '/profile') {
	    //     if (mode === 'month') {
	    //       return mode === 'month' && date > $scope.dt
	    //     }
	
	    //     if (mode === 'day') {
	    //       return mode === 'day' && date < $scope.dt
	    //     }
	    //   }
	    // }
	
	    $scope.reverseDisabled = function (date, mode) {
	      if ($location.url() !== '/profile') {
	        if (mode === 'month') {
	          return mode === 'month' && date < $scope.dt;
	        }
	
	        if (mode === 'day') {
	          return mode === 'day' && date > oldDate;
	        }
	      }
	    };
	
	    $scope.toggleMin = function () {
	      var reference;
	      return $scope.minDate = (reference = $scope.minDate) !== undefined ? reference : {
	        null: new Date()
	      };
	    };
	
	    $scope.toggleMin();
	    $scope.open = function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	      return $scope.opened = true;
	    };
	
	    function isMonthFormatRequested(isMonthRequested) {
	      var value = allowedUrlsForMonthFormat.has($location.path());
	
	      console.debug('DatePickerDemoCtrl.isMonthFormatRequested', isMonthRequested, value, $location.path());
	      return value;
	    }
	
	    $scope.setPickerStyle = function (isMonthRequested) {
	      if (isMonthFormatRequested(isMonthRequested)) {
	        console.debug('DatePickerCtrl: detected month format');
	        $scope.dateOptions = {
	          'year-format': "'yy'",
	          'starting-day': 1,
	          'datepicker-mode': "'month'",
	          'min-mode': 'month',
	          defaultDate: '1'
	        };
	        $scope.formats = ['MMMM-yyyy', 'yyyy/MM', 'shortDate'];
	      } else {
	        console.debug('DatePickerCtrl: detected day format');
	        $scope.dateOptions = {
	          'datepicker-mode': "'day'",
	          'year-format': "'yy'",
	          'starting-day': 1,
	          defaultDate: '1'
	        };
	        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM', 'shortDate'];
	      }
	
	      return $scope.format = $scope.formats[0];
	    };
	
	    $scope.setPickerStyle();
	  }]);
	})();

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	'use strict';
	
	;(function () {
	  angular.module('app.ui.form.ctrls').controller('ProfileModalCtrl', ['$scope', '$http', '$log', '$modalInstance', '$location', 'data', '$translate', 'logger', 'sharedProperties', 'practicesService', function ($scope, $http, $log, $modalInstance, $location, data, $translate, logger, sharedProperties, practicesService) {
	    $translate.use('en');
	    $scope.nextButtonShow = data.displayNextButton;
	    var isModalForHistoryPracticeAreas = data.isModalForHistoryPracticeAreas,
	        corporatePracticeId = 3,
	        capMarketPracticeId = 19,
	        equityCapMarketPracticeIdForCapMarket = 22,
	        equityCapMarketPracticeIdForCorporate = 61;
	
	    var isEquityCapMarketAlreadyCounted = false,
	        maxSelectablePracticeAreas = data.maxSelectablePracticeAreas ? data.maxSelectablePracticeAreas : 20;
	    //assign max PAs to be selected as per given, if not default to 20
	
	    $scope.count = 0;
	    $scope.data = data.data;
	    $scope.showLocations = false;
	    $scope.showPractices = false;
	    $scope.showCategories = false;
	    $scope.showLanguages = false;
	    $scope.showTextArea = false;
	    $scope.showJurisdictions = false;
	    $scope.showAdditionalInfo = false;
	    $scope.element = data.element;
	    $scope.heading = '';
	    $scope.CheckBox = '';
	    $scope.updatedData = {
	      data: $scope.data,
	      element: ''
	    };
	    $scope.showChildLocations = false;
	
	    function isEquityCapitalPractice(practiceId) {
	      return practiceId === equityCapMarketPracticeIdForCapMarket || practiceId === equityCapMarketPracticeIdForCorporate;
	    }
	
	    function isAnyEquityCapMarketSelected(practiceId) {
	      if (isEquityCapitalPractice(practiceId) && !isEquityCapMarketAlreadyCounted) {
	        var isEquityCapMarketSelectedForCapMarkets = isEquityCapMarketSelected($scope.updatedData.data, capMarketPracticeId, equityCapMarketPracticeIdForCapMarket),
	            isEquityCapMarketSelectedForCorporate = isEquityCapMarketSelected($scope.updatedData.data, corporatePracticeId, equityCapMarketPracticeIdForCorporate);
	
	        isEquityCapMarketAlreadyCounted = true;
	        return isEquityCapMarketSelectedForCapMarkets || isEquityCapMarketSelectedForCorporate;
	      } else {
	        return false;
	      }
	    }
	    $scope.isHeadingBold = false;
	    if ($scope.element === 'location') {
	      $scope.heading = 'modal.locations.Heading';
	      $scope.subHeading = 'modal.locations.subHeading';
	      $scope.showLocations = true;
	      $scope.isHeadingBold = true;
	    } else if ($scope.element === 'practice') {
	      data.linearPractices.forEach(function (practice, index, array) {
	        if (practice.isSelected && !practice.hasChild && !isAnyEquityCapMarketSelected(practice.practice_ID)) {
	          $scope.count++;
	        }
	      });
	      $scope.heading = 'modal.practiceAreas.Heading';
	      if (isModalForHistoryPracticeAreas) {
	        $scope.subHeading = 'modal.employmentHistory.practiceAreas.subHeading';
	      } else $scope.subHeading = 'modal.practiceAreas.subHeading';
	
	      $scope.showPractices = true;
	      $scope.isHeadingBold = true;
	      $scope.updatedData;
	    } else if ($scope.element === 'language') {
	      $scope.updatedData.element = data.element;
	      if (data.otherLanguages !== '' || data.otherLanguages !== null || data.otherLanguages !== void 0) {
	        $scope.updatedData.otherLanguages = data.otherLanguages;
	      }
	      $scope.heading = 'modal.languages.Heading';
	      $scope.showLanguages = true;
	    } else if ($scope.element === 'jurisdiction') {
	      $scope.updatedData.element = data.element;
	      if (data.other_Jurisdictions !== '' || data.other_Jurisdictions !== null || data.other_Jurisdictions !== void 0) {
	        $scope.updatedData.other_Jurisdictions = data.other_Jurisdictions;
	      }
	      $scope.heading = 'modal.updateJurisdictions.Heading';
	      $scope.subHeading = 'modal.updateJurisdictions.subHeading';
	      $scope.showJurisdictions = true;
	      $scope.isHeadingBold = true;
	    } else if ($scope.element === 'category') {
	      $scope.heading = 'modal.firmTypes.Heading';
	      $scope.showCategories = true;
	    } else if ($scope.element === 'move') {
	      $scope.heading = 'modal.moveQuestion.Heading';
	      $scope.showTextArea = true;
	      $scope.updatedData.element = 'move';
	    } else if ($scope.element === 'info') {
	      $scope.heading = 'modal.moreInfoQuestion.Heading';
	      $scope.showAdditionalInfo = true;
	      $scope.updatedData.element = 'info';
	    }
	    $scope.updateData = function (event, cur_box) {
	      var message, value;
	      if ($scope.showLocations) {
	        $scope.updatedData.element = $scope.element;
	        value = event.target.checked;
	        $scope.updatedData.data.forEach(function (chkbox, index, array) {
	          if (chkbox.loc_ID === cur_box.loc_ID) {
	            chkbox.isSelected = value;
	          }
	        });
	      } else if ($scope.showPractices) {
	        $scope.updatedData.element = $scope.element;
	        value = event.target.checked;
	        $scope.countCheckbox(value, 2);
	        if ($scope.count > maxSelectablePracticeAreas) {
	          message = 'You are allowed to choose a maximum of ' + maxSelectablePracticeAreas + ' practice areas.';
	          logger.notify('error', message);
	          event.target.checked = false;
	          value = false;
	          $scope.count = maxSelectablePracticeAreas;
	        } else if ($scope.count <= maxSelectablePracticeAreas) {
	          if ($scope.count === maxSelectablePracticeAreas) {
	            message = 'You have reached the limit for practice area selections, please refine your expertise to only those practice areas you have actual experience in';
	            logger.notify('warning', message);
	          } else if ($scope.count < maxSelectablePracticeAreas && $scope.count === 15) {
	            message = 'You are approaching the limit for practice area selections';
	            logger.notify('warning', message);
	          }
	
	          $scope.updatedData.data.forEach(function (chkbox, index, array) {
	            if (chkbox.practice_ID === cur_box.practice_ID) {
	              chkbox.isSelected = value;
	            }
	          });
	        }
	      } else if ($scope.showLanguages) {
	        $scope.updatedData.element = $scope.element;
	        value = event.target.checked;
	        $scope.updatedData.data.forEach(function (chkbox, index, array) {
	          if (chkbox.code === cur_box.code) {
	            chkbox.isSelected = value;
	          }
	        });
	      } else if ($scope.showJurisdictions) {
	        $scope.updatedData.element = $scope.element;
	        value = event.target.checked;
	        $scope.updatedData.data.forEach(function (chkbox, index, array) {
	          if (chkbox.id === cur_box.id) {
	            chkbox.isSelected = value;
	          }
	        });
	      } else if ($scope.showCategories) {
	        $scope.updatedData.element = $scope.element;
	        value = event.target.checked;
	        $scope.updatedData.data.forEach(function (chkbox, index, array) {
	          if (chkbox.cat_ID === cur_box.cat_ID) {
	            chkbox.isSelected = value;
	          }
	        });
	      }
	    };
	    $scope.displaySubPracticeAreas = function (law_area) {
	      return law_area.showSubPracticeAreas = true;
	    };
	    $scope.hideSubPracticeAreas = function (law_area) {
	      return law_area.showSubPracticeAreas = false;
	    };
	    $scope.displayChildLocations = function (region) {
	      return region.showChildLocations = true;
	    };
	    $scope.hideChildLocations = function (region) {
	      return region.showChildLocations = false;
	    };
	
	    function decrementCount() {
	      if ($scope.count > 0) $scope.count--;
	    }
	
	    function isEquityCapMarketSelected(practiceAreas, parentPracticeId, childPracticeId) {
	      var parentPractice = findPractice(practiceAreas, parentPracticeId),
	          childPractice = findPractice(parentPractice.practices, childPracticeId);
	
	      return childPractice.isSelected;
	    }
	
	    function findPractice(listOfPractices, practiceId) {
	      return _.find(listOfPractices, function (practice) {
	        return practice.practice_ID === practiceId;
	      });
	    }
	    $scope.selectPractices = function (event, current, level) {
	      var message = void 0,
	          pCounter = 0,
	          sCounter = 0,
	          value = event.target.checked;
	
	      $scope.updatedData.element = 'practice';
	      if ($scope.count >= maxSelectablePracticeAreas && value) {
	        message = 'You are allowed to choose a maximum of ' + maxSelectablePracticeAreas + ' practice areas.';
	        logger.notify('error', message);
	        event.target.checked = false;
	        return false;
	      } else {
	        if (level === 2) {
	          $scope.updatedData.data.forEach(function (law_area, index, array) {
	            if (law_area.practice_ID === current.practice_ID) {
	              law_area.isSelected = value;
	              if (law_area.practices.length > 0) {
	                law_area.practices.forEach(function (practice, index, array) {
	                  if (practice.sub_areas.length > 0 && (!value || $scope.count < maxSelectablePracticeAreas)) {
	                    practice.isSelected = value;
	                    practice.sub_areas.forEach(function (sub, index, array) {
	                      if (sub.isSelected !== value) {
	                        if ($scope.count < maxSelectablePracticeAreas && value) {
	                          sub.isSelected = value;
	                          $scope.count++;
	                        } else if (!value && sub.isSelected) {
	                          decrementCount();
	                          sub.isSelected = value;
	                        }
	                      }
	                    });
	                  } else {
	                    if ($scope.count < maxSelectablePracticeAreas && value) {
	                      practice.isSelected = value;
	                      $scope.count++;
	                    } else if (!value && practice.isSelected) {
	                      practice.isSelected = value;
	                      decrementCount();
	                    }
	                  }
	                });
	              } else {
	                if (value && $scope.count < maxSelectablePracticeAreas) {
	                  law_area.isSelected = value;
	                  $scope.count++;
	                } else if (!value) {
	                  law_area.isSelected = value;
	                  decrementCount();
	                }
	              }
	
	              practicesService.checkForLinking($scope.updatedData.data, current.practice_ID, value);
	            }
	          });
	        } else if (level === 1) {
	          $scope.updatedData.data.forEach(function (law_area, index, array) {
	            return law_area.practices.forEach(function (practice, index, array) {
	              if (practice.practice_ID === current.practice_ID) {
	                if (practice.sub_areas.length > 0) {
	                  practice.isSelected = value;
	                  law_area.practices.forEach(function (p, i, a) {
	                    if (p.isSelected) {
	                      pCounter++;
	                    }
	                  });
	                  if (value) {
	                    if (pCounter > 0) {
	                      law_area.isSelected = value;
	                    }
	                  } else {
	                    if (pCounter <= 0) {
	                      law_area.isSelected = value;
	                    }
	                  }
	                  practice.sub_areas.forEach(function (sub, index, array) {
	                    if (sub.isSelected !== value) {
	                      if ($scope.count < maxSelectablePracticeAreas && value) {
	                        sub.isSelected = value;
	                        $scope.count++;
	                      } else if (!value) {
	                        if (sub.isSelected) {
	                          sub.isSelected = value;
	                          decrementCount();
	                        }
	                      }
	                    }
	                  });
	                } else {
	                  if ($scope.count < maxSelectablePracticeAreas && value) {
	                    practice.isSelected = value;
	
	                    law_area.practices.forEach(function (p, i, a) {
	                      if (p.isSelected) {
	                        pCounter++;
	                      }
	                    });
	                    if (value) {
	                      if (pCounter > 0) {
	                        law_area.isSelected = value;
	                      }
	                    } else {
	                      if (pCounter <= 0) {
	                        law_area.isSelected = value;
	                      }
	                    }
	                    $scope.count++;
	                  } else if (!value) {
	                    practice.isSelected = value;
	                    law_area.practices.forEach(function (p, i, a) {
	                      if (p.isSelected) {
	                        pCounter++;
	                      }
	                    });
	                    if (value) {
	                      if (pCounter > 0) {
	                        law_area.isSelected = value;
	                      }
	                    } else {
	                      if (pCounter <= 0) {
	                        law_area.isSelected = value;
	                      }
	                    }
	                    decrementCount();
	                  }
	                }
	
	                practicesService.checkForLinking($scope.updatedData.data, current.practice_ID, value);
	              }
	            });
	          });
	        } else if (level === 0) {
	          $scope.updatedData.data.forEach(function (law_area, index, array) {
	            law_area.practices.forEach(function (practice, index, array) {
	              if (practice.sub_areas.length > 0) {
	                practice.sub_areas.forEach(function (sub, index, array) {
	                  if (sub.practice_ID === current.practice_ID) {
	                    sub.isSelected = value;
	                    practice.sub_areas.forEach(function (s, i, a) {
	                      if (s.isSelected) {
	                        sCounter++;
	                      }
	                    });
	                    if (value) {
	                      if (sCounter > 0) {
	                        law_area.isSelected = value;
	                        practice.isSelected = value;
	                      }
	                    } else {
	                      if (sCounter <= 0) {
	                        practice.isSelected = value;
	                        law_area.practices.forEach(function (p, i, a) {
	                          if (p.isSelected) {
	                            pCounter++;
	                          }
	                        });
	                        if (value) {
	                          if (pCounter > 0) {
	                            law_area.isSelected = value;
	                          }
	                        } else {
	                          if (pCounter <= 0) {
	                            law_area.isSelected = value;
	                          }
	                        }
	                      }
	                    }
	                    if (value) {
	                      $scope.count++;
	                    } else {
	                      decrementCount();
	                    }
	
	                    practicesService.checkForLinking($scope.updatedData.data, current.practice_ID, value);
	                  }
	                });
	              }
	            });
	          });
	        }
	
	        if ($scope.count === maxSelectablePracticeAreas) {
	          message = 'You have reached the limit for practice area selections, please refine your expertise to only those practice areas you have actual experience in.';
	          logger.notify('warning', message);
	        } else if ($scope.count < maxSelectablePracticeAreas && $scope.count === 15) {
	          message = 'You are approaching the limit for practice area selections';
	          logger.notify('warning', message);
	        }
	      }
	    };
	
	    $scope.selectLocation = function (event, current, level) {
	      var pCounter, sCounter, value;
	      pCounter = 0;
	      sCounter = 0;
	      $scope.updatedData.element = 'location';
	      value = event.target.checked;
	      if (level === 2) {
	        $scope.updatedData.data.forEach(function (region, index, array) {
	          if (region.loc_ID === current.loc_ID) {
	            region.isSelected = value;
	            if (region.locations.length > 0) {
	              region.locations.forEach(function (location, index, array) {
	                location.isSelected = value;
	                location.sub_areas.forEach(function (sub, index, array) {
	                  if (sub.isSelected !== value) {
	                    if (value) {
	                      sub.isSelected = value;
	                      $scope.count++;
	                    } else if (!value) {
	                      sub.isSelected = value;
	                      decrementCount();
	                    }
	                  }
	                });
	                if (value) {
	                  location.isSelected = value;
	                  return $scope.count++;
	                } else if (!value && location.isSelected) {
	                  location.isSelected = value;
	                  return decrementCount();
	                }
	              });
	            } else {
	              if (value) {
	                region.isSelected = value;
	                return $scope.count++;
	              } else if (!value) {
	                region.isSelected = value;
	                return decrementCount();
	              }
	            }
	          }
	        });
	        return;
	      } else if (level === 1) {
	        $scope.updatedData.data.forEach(function (region, index, array) {
	          return region.locations.forEach(function (location, index, array) {
	            if (location.loc_ID === current.loc_ID) {
	              if (location.sub_areas.length > 0) {
	                location.isSelected = value;
	                region.locations.forEach(function (p, i, a) {
	                  if (p.isSelected) {
	                    pCounter++;
	                  }
	                });
	                if (value) {
	                  if (pCounter > 0) {
	                    region.isSelected = value;
	                  }
	                } else {
	                  if (pCounter <= 0) {
	                    region.isSelected = value;
	                  }
	                }
	                location.sub_areas.forEach(function (sub, index, array) {
	                  if (sub.isSelected !== value) {
	                    if (value) {
	                      sub.isSelected = value;
	                      $scope.count++;
	                    } else if (!value) {
	                      if (sub.isSelected) {
	                        sub.isSelected = value;
	                        decrementCount();
	                      }
	                    }
	                  }
	                });
	              } else {
	                if (value) {
	                  location.isSelected = value;
	                  region.locations.forEach(function (p, i, a) {
	                    if (p.isSelected) {
	                      pCounter++;
	                    }
	                  });
	                  if (value) {
	                    if (pCounter > 0) {
	                      region.isSelected = value;
	                    }
	                  } else {
	                    if (pCounter <= 0) {
	                      region.isSelected = value;
	                    }
	                  }
	                  $scope.count++;
	                } else if (!value) {
	                  location.isSelected = value;
	                  region.locations.forEach(function (p, i, a) {
	                    if (p.isSelected) {
	                      pCounter++;
	                    }
	                  });
	                  if (value) {
	                    if (pCounter > 0) {
	                      region.isSelected = value;
	                    }
	                  } else {
	                    if (pCounter <= 0) {
	                      region.isSelected = value;
	                    }
	                  }
	                  decrementCount();
	                }
	              }
	            }
	          });
	        });
	        return;
	      } else if (level === 0) {
	        $scope.updatedData.data.forEach(function (region, index, array) {
	          region.locations.forEach(function (location, index, array) {
	            if (location.sub_areas.length > 0) {
	              location.sub_areas.forEach(function (sub, index, array) {
	                if (sub.loc_ID === current.loc_ID) {
	                  sub.isSelected = value;
	                  location.sub_areas.forEach(function (s, i, a) {
	                    if (s.isSelected) {
	                      sCounter++;
	                    }
	                  });
	                  if (value) {
	                    if (sCounter > 0) {
	                      region.isSelected = value;
	                      location.isSelected = value;
	                    }
	                  } else {
	                    if (sCounter <= 0) {
	                      location.isSelected = value;
	                      region.locations.forEach(function (p, i, a) {
	                        if (p.isSelected) {
	                          pCounter++;
	                        }
	                      });
	                      if (value) {
	                        if (pCounter > 0) {
	                          region.isSelected = value;
	                        }
	                      } else {
	                        if (pCounter <= 0) {
	                          region.isSelected = value;
	                        }
	                      }
	                    }
	                  }
	                  if (value) {
	                    $scope.count++;
	                  } else {
	                    decrementCount();
	                  }
	                }
	              });
	            }
	          });
	        });
	      }
	    };
	    $scope.countCheckbox = function (value, level) {
	      if (value) {
	        $scope.count++;
	      } else if (!value) {
	        decrementCount();
	      }
	    };
	    $scope.selectAll = function (event) {
	      var mainCheckBox = void 0,
	          message = void 0,
	          value = void 0;
	      mainCheckBox = event.target.attributes.data.value;
	      value = event.target.checked;
	      if (value) {
	        if ($scope.count >= maxSelectablePracticeAreas) {
	          message = 'You are allowed to choose a maximum of ' + maxSelectablePracticeAreas + ' practice areas.';
	          logger.notify('error', message);
	          event.target.checked = false;
	          return false;
	        } else if ($scope.count < maxSelectablePracticeAreas) {
	          $scope.data.forEach(function (chkbox, index, array) {
	            if (chkbox.lawArea_ID === parseInt(mainCheckBox) && !chkbox.isSelected && $scope.count < maxSelectablePracticeAreas) {
	              $scope.countCheckbox(value, 1);
	              chkbox.isSelected = value;
	            }
	          });
	        }
	      } else {
	        $scope.data.forEach(function (chkbox, index, array) {
	          if (chkbox.lawArea_ID === parseInt(mainCheckBox) && chkbox.isSelected) {
	            $scope.countCheckbox(value, 1);
	            chkbox.isSelected = value;
	          }
	        });
	      }
	    };
	    $scope.save = function () {
	      if ($scope.updatedData.element === 'practice' || isModalForHistoryPracticeAreas) {
	        if ($scope.count <= maxSelectablePracticeAreas) {
	          $scope.updatedData.linearPractices = [];
	          $scope.updatedData.data.forEach(function (law_area, index, array) {
	            $scope.updatedData.linearPractices.push(law_area);
	            law_area.practices.forEach(function (practice, index, array) {
	              $scope.updatedData.linearPractices.push(practice);
	              practice.sub_areas.forEach(function (sub, index, array) {
	                return $scope.updatedData.linearPractices.push(sub);
	              });
	            });
	          });
	          var categorizedPractices = _.countBy($scope.updatedData.linearPractices, function (practice) {
	            return practice.isSelected ? 'selected' : 'unselected';
	          });
	
	          if (isModalForHistoryPracticeAreas && !sharedProperties.isAdminSession() && !categorizedPractices.selected) {
	            logger.notify('info', 'It is mandatory for a work experience to have practice areas');
	            return;
	          }
	
	          $modalInstance.close($scope.updatedData);
	        } else {
	          $modalInstance.dismiss('cancel');
	        }
	      } else {
	        if ($scope.updatedData.element === 'jurisdiction') {
	          if ($scope.updatedData.data.find(function (data) {
	            return data.isSelected === true;
	          })) $modalInstance.close($scope.updatedData);else logger.notify('warning', 'This is a required field, you have to choose at least one jurisdiction.');
	        } else $modalInstance.close($scope.updatedData);
	      }
	    };
	    $scope.cancel = function () {
	      $modalInstance.dismiss('cancel');
	    };
	  }]);
	})();

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	  angular.module('app.ui.form.ctrls').controller('TimepickerDemoCtrl', ['$scope', '$log', function ($scope, $log) {
	    $scope.mytime = new Date();
	    $scope.hstep = 1;
	    $scope.mstep = 1;
	    $scope.options = {
	      hstep: [1, 2, 3],
	      mstep: [1, 5, 10, 15, 25, 30]
	    };
	    $scope.ismeridian = true;
	    $scope.toggleMode = function () {
	      return $scope.ismeridian = !$scope.ismeridian;
	    };
	    $scope.update = function () {
	      var d;
	      d = new Date();
	      d.setHours(14);
	      d.setMinutes(0);
	      return $scope.mytime = d;
	    };
	    $scope.changed = function () {
	      return $log.info('Time changed to: ' + $scope.mytime);
	    };
	    return $scope.clear = function () {
	      return $scope.mytime = null;
	    };
	  }]);
	})();

/***/ }),
/* 617 */
/***/ (function(module, exports) {

	'use strict';
	
	/**!
	 * AngularJS file upload/drop directive and service with progress and abort
	 * FileAPI Flash shim for old browsers not supporting FormData 
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 3.1.0
	 */
	
	(function () {
	
		var hasFlash = function hasFlash() {
			try {
				var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
				if (fo) return true;
			} catch (e) {
				if (navigator.mimeTypes['application/x-shockwave-flash'] != undefined) return true;
			}
			return false;
		};
	
		function patchXHR(fnName, newFn) {
			window.XMLHttpRequest.prototype[fnName] = newFn(window.XMLHttpRequest.prototype[fnName]);
		};
	
		if (window.XMLHttpRequest && !window.FormData || window.FileAPI && FileAPI.forceLoad) {
			var redefineProp = function redefineProp(xhr, prop, fn) {
				try {
					Object.defineProperty(xhr, prop, { get: fn });
				} catch (e) {/*ignore*/}
			};
	
			var initializeUploadListener = function initializeUploadListener(xhr) {
				if (!xhr.__listeners) {
					if (!xhr.upload) xhr.upload = {};
					xhr.__listeners = [];
					var origAddEventListener = xhr.upload.addEventListener;
					xhr.upload.addEventListener = function (t, fn, b) {
						xhr.__listeners[t] = fn;
						origAddEventListener && origAddEventListener.apply(this, arguments);
					};
				}
			};
	
			patchXHR('open', function (orig) {
				return function (m, url, b) {
					initializeUploadListener(this);
					this.__url = url;
					try {
						orig.apply(this, [m, url, b]);
					} catch (e) {
						if (e.message.indexOf('Access is denied') > -1) {
							this.__origError = e;
							orig.apply(this, [m, '_fix_for_ie_crossdomain__', b]);
						}
					}
				};
			});
	
			patchXHR('getResponseHeader', function (orig) {
				return function (h) {
					return this.__fileApiXHR && this.__fileApiXHR.getResponseHeader ? this.__fileApiXHR.getResponseHeader(h) : orig == null ? null : orig.apply(this, [h]);
				};
			});
	
			patchXHR('getAllResponseHeaders', function (orig) {
				return function () {
					return this.__fileApiXHR && this.__fileApiXHR.getAllResponseHeaders ? this.__fileApiXHR.getAllResponseHeaders() : orig == null ? null : orig.apply(this);
				};
			});
	
			patchXHR('abort', function (orig) {
				return function () {
					return this.__fileApiXHR && this.__fileApiXHR.abort ? this.__fileApiXHR.abort() : orig == null ? null : orig.apply(this);
				};
			});
	
			patchXHR('setRequestHeader', function (orig) {
				return function (header, value) {
					if (header === '__setXHR_') {
						initializeUploadListener(this);
						var val = value(this);
						// fix for angular < 1.2.0
						if (val instanceof Function) {
							val(this);
						}
					} else {
						this.__requestHeaders = this.__requestHeaders || {};
						this.__requestHeaders[header] = value;
						orig.apply(this, arguments);
					}
				};
			});
	
			patchXHR('send', function (orig) {
				return function () {
					var xhr = this;
					if (arguments[0] && arguments[0].__isFileAPIShim) {
						var formData = arguments[0];
						var config = {
							url: xhr.__url,
							jsonp: false, //removes the callback form param
							cache: true, //removes the ?fileapiXXX in the url
							complete: function complete(err, fileApiXHR) {
								xhr.__completed = true;
								if (!err && xhr.__listeners['load']) xhr.__listeners['load']({ type: 'load', loaded: xhr.__loaded, total: xhr.__total, target: xhr, lengthComputable: true });
								if (!err && xhr.__listeners['loadend']) xhr.__listeners['loadend']({ type: 'loadend', loaded: xhr.__loaded, total: xhr.__total, target: xhr, lengthComputable: true });
								if (err === 'abort' && xhr.__listeners['abort']) xhr.__listeners['abort']({ type: 'abort', loaded: xhr.__loaded, total: xhr.__total, target: xhr, lengthComputable: true });
								if (fileApiXHR.status !== undefined) redefineProp(xhr, 'status', function () {
									return fileApiXHR.status == 0 && err && err !== 'abort' ? 500 : fileApiXHR.status;
								});
								if (fileApiXHR.statusText !== undefined) redefineProp(xhr, 'statusText', function () {
									return fileApiXHR.statusText;
								});
								redefineProp(xhr, 'readyState', function () {
									return 4;
								});
								if (fileApiXHR.response !== undefined) redefineProp(xhr, 'response', function () {
									return fileApiXHR.response;
								});
								var resp = fileApiXHR.responseText || (err && fileApiXHR.status == 0 && err !== 'abort' ? err : undefined);
								redefineProp(xhr, 'responseText', function () {
									return resp;
								});
								redefineProp(xhr, 'response', function () {
									return resp;
								});
								if (err) redefineProp(xhr, 'err', function () {
									return err;
								});
								xhr.__fileApiXHR = fileApiXHR;
								if (xhr.onreadystatechange) xhr.onreadystatechange();
								if (xhr.onload) xhr.onload();
							},
							fileprogress: function fileprogress(e) {
								e.target = xhr;
								xhr.__listeners['progress'] && xhr.__listeners['progress'](e);
								xhr.__total = e.total;
								xhr.__loaded = e.loaded;
								if (e.total === e.loaded) {
									// fix flash issue that doesn't call complete if there is no response text from the server  
									var _this = this;
									setTimeout(function () {
										if (!xhr.__completed) {
											xhr.getAllResponseHeaders = function () {};
											_this.complete(null, { status: 204, statusText: 'No Content' });
										}
									}, FileAPI.noContentTimeout || 10000);
								}
							},
							headers: xhr.__requestHeaders
						};
						config.data = {};
						config.files = {};
						for (var i = 0; i < formData.data.length; i++) {
							var item = formData.data[i];
							if (item.val != null && item.val.name != null && item.val.size != null && item.val.type != null) {
								config.files[item.key] = item.val;
							} else {
								config.data[item.key] = item.val;
							}
						}
	
						setTimeout(function () {
							if (!hasFlash()) {
								throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
							}
							xhr.__fileApiXHR = FileAPI.upload(config);
						}, 1);
					} else {
						if (this.__origError) {
							throw this.__origError;
						}
						orig.apply(xhr, arguments);
					}
				};
			});
			window.XMLHttpRequest.__isFileAPIShim = true;
	
			var addFlash = function addFlash(elem) {
				if (!hasFlash()) {
					throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
				}
				var el = angular.element(elem);
				if (!el.attr('disabled')) {
					var hasFileSelect = false;
					for (var i = 0; i < el[0].attributes.length; i++) {
						var attrib = el[0].attributes[i];
						if (attrib.name.indexOf('file-select') !== -1) {
							hasFileSelect = true;
							break;
						}
					}
					if (!el.hasClass('js-fileapi-wrapper') && (hasFileSelect || el.attr('__afu_gen__') != null)) {
	
						el.addClass('js-fileapi-wrapper');
						if (el.attr('__afu_gen__') != null) {
							var ref = el[0].__refElem__ && angular.element(el[0].__refElem__) || el;
							while (ref && !ref.attr('__refElem__')) {
								ref = angular.element(ref[0].nextSibling);
							}
							ref.bind('mouseover', function () {
								if (el.parent().css('position') === '' || el.parent().css('position') === 'static') {
									el.parent().css('position', 'relative');
								}
								el.css('position', 'absolute').css('top', ref[0].offsetTop + 'px').css('left', ref[0].offsetLeft + 'px').css('width', ref[0].offsetWidth + 'px').css('height', ref[0].offsetHeight + 'px').css('padding', ref.css('padding')).css('margin', ref.css('margin')).css('filter', 'alpha(opacity=0)');
								ref.attr('onclick', '');
								el.css('z-index', '1000');
							});
						}
					}
				}
			};
			var changeFnWrapper = function changeFnWrapper(fn) {
				return function (evt) {
					var files = FileAPI.getFiles(evt);
					//just a double check for #233
					for (var i = 0; i < files.length; i++) {
						if (files[i].size === undefined) files[i].size = 0;
						if (files[i].name === undefined) files[i].name = 'file';
						if (files[i].type === undefined) files[i].type = 'undefined';
					}
					if (!evt.target) {
						evt.target = {};
					}
					evt.target.files = files;
					// if evt.target.files is not writable use helper field
					if (evt.target.files != files) {
						evt.__files_ = files;
					}
					(evt.__files_ || evt.target.files).item = function (i) {
						return (evt.__files_ || evt.target.files)[i] || null;
					};
					if (fn) fn.apply(this, [evt]);
				};
			};
			var isFileChange = function isFileChange(elem, e) {
				return (e.toLowerCase() === 'change' || e.toLowerCase() === 'onchange') && elem.getAttribute('type') == 'file';
			};
			if (HTMLInputElement.prototype.addEventListener) {
				HTMLInputElement.prototype.addEventListener = function (origAddEventListener) {
					return function (e, fn, b, d) {
						if (isFileChange(this, e)) {
							addFlash(this);
							origAddEventListener.apply(this, [e, changeFnWrapper(fn), b, d]);
						} else {
							origAddEventListener.apply(this, [e, fn, b, d]);
						}
					};
				}(HTMLInputElement.prototype.addEventListener);
			}
			if (HTMLInputElement.prototype.attachEvent) {
				HTMLInputElement.prototype.attachEvent = function (origAttachEvent) {
					return function (e, fn) {
						if (isFileChange(this, e)) {
							addFlash(this);
							if (window.jQuery) {
								// fix for #281 jQuery on IE8
								angular.element(this).bind('change', changeFnWrapper(null));
							} else {
								origAttachEvent.apply(this, [e, changeFnWrapper(fn)]);
							}
						} else {
							origAttachEvent.apply(this, [e, fn]);
						}
					};
				}(HTMLInputElement.prototype.attachEvent);
			}
	
			window.FormData = FormData = function FormData() {
				return {
					append: function append(key, val, name) {
						if (val.__isFileAPIBlobShim) {
							val = val.data[0];
						}
						this.data.push({
							key: key,
							val: val,
							name: name
						});
					},
					data: [],
					__isFileAPIShim: true
				};
			};
	
			window.Blob = Blob = function Blob(b) {
				return {
					data: b,
					__isFileAPIBlobShim: true
				};
			};
	
			(function () {
				//load FileAPI
				if (!window.FileAPI) {
					window.FileAPI = {};
				}
				if (FileAPI.forceLoad) {
					FileAPI.html5 = false;
				}
	
				if (!FileAPI.upload) {
					var jsUrl,
					    basePath,
					    script = document.createElement('script'),
					    allScripts = document.getElementsByTagName('script'),
					    i,
					    index,
					    src;
					if (window.FileAPI.jsUrl) {
						jsUrl = window.FileAPI.jsUrl;
					} else if (window.FileAPI.jsPath) {
						basePath = window.FileAPI.jsPath;
					} else {
						for (i = 0; i < allScripts.length; i++) {
							src = allScripts[i].src;
							index = src.search(/\/angular\-file\-upload[\-a-zA-z0-9\.]*\.js/);
							if (index > -1) {
								basePath = src.substring(0, index + 1);
								break;
							}
						}
					}
	
					if (FileAPI.staticPath == null) FileAPI.staticPath = basePath;
					script.setAttribute('src', jsUrl || basePath + 'FileAPI.min.js');
					document.getElementsByTagName('head')[0].appendChild(script);
					FileAPI.hasFlash = hasFlash();
				}
			})();
			FileAPI.disableFileInput = function (elem, disable) {
				if (disable) {
					elem.removeClass('js-fileapi-wrapper');
				} else {
					elem.addClass('js-fileapi-wrapper');
				}
			};
		}
	
		if (!window.FileReader) {
			window.FileReader = function () {
				var _this = this,
				    loadStarted = false;
				this.listeners = {};
				this.addEventListener = function (type, fn) {
					_this.listeners[type] = _this.listeners[type] || [];
					_this.listeners[type].push(fn);
				};
				this.removeEventListener = function (type, fn) {
					_this.listeners[type] && _this.listeners[type].splice(_this.listeners[type].indexOf(fn), 1);
				};
				this.dispatchEvent = function (evt) {
					var list = _this.listeners[evt.type];
					if (list) {
						for (var i = 0; i < list.length; i++) {
							list[i].call(_this, evt);
						}
					}
				};
				this.onabort = this.onerror = this.onload = this.onloadstart = this.onloadend = this.onprogress = null;
	
				var constructEvent = function constructEvent(type, evt) {
					var e = { type: type, target: _this, loaded: evt.loaded, total: evt.total, error: evt.error };
					if (evt.result != null) e.target.result = evt.result;
					return e;
				};
				var listener = function listener(evt) {
					if (!loadStarted) {
						loadStarted = true;
						_this.onloadstart && _this.onloadstart(constructEvent('loadstart', evt));
					}
					if (evt.type === 'load') {
						_this.onloadend && _this.onloadend(constructEvent('loadend', evt));
						var e = constructEvent('load', evt);
						_this.onload && _this.onload(e);
						_this.dispatchEvent(e);
					} else if (evt.type === 'progress') {
						var e = constructEvent('progress', evt);
						_this.onprogress && _this.onprogress(e);
						_this.dispatchEvent(e);
					} else {
						var e = constructEvent('error', evt);
						_this.onerror && _this.onerror(e);
						_this.dispatchEvent(e);
					}
				};
				this.readAsArrayBuffer = function (file) {
					FileAPI.readAsBinaryString(file, listener);
				};
				this.readAsBinaryString = function (file) {
					FileAPI.readAsBinaryString(file, listener);
				};
				this.readAsDataURL = function (file) {
					FileAPI.readAsDataURL(file, listener);
				};
				this.readAsText = function (file) {
					FileAPI.readAsText(file, listener);
				};
			};
		}
	})();

/***/ }),
/* 618 */
/***/ (function(module, exports) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*! 3.1.0 */
	!function () {
	  function a(a, b) {
	    window.XMLHttpRequest.prototype[a] = b(window.XMLHttpRequest.prototype[a]);
	  }function b(a, b, c, d, f, g, h) {
	    function i() {
	      return "input" === b[0].tagName.toLowerCase() && b.attr("type") && "file" === b.attr("type").toLowerCase();
	    }function j(c) {
	      g(function () {
	        b.parent().length && p.push(a.$watch(c, function (a, b) {
	          a != b && k();
	        }));
	      });
	    }function k() {
	      var c = b.clone();if (b.attr("__afu_gen__") && angular.element(document.getElementById(b.attr("id").substring(1))).remove(), b.parent().length) {
	        for (var d = 0; d < p.length; d++) {
	          p[d]();
	        }b.replaceWith(c), h(c)(a);
	      }return c;
	    }function l(d, e) {
	      if (d) {
	        j(d);var g = f(d)(a);g ? (b.attr(e, g), c[e] = g) : (b.attr(e, null), delete c[e]);
	      }
	    }function m(b) {
	      var e;e = b.__files_ || b.target && b.target.files, o(e, c, d, a, b);
	    }function n(a) {
	      if (null != q[0].value && "" != q[0].value && (q[0].value = null, -1 === navigator.userAgent.indexOf("Trident/7") && m({ target: { files: [] } })), b.attr("__afu_clone__")) b.attr("__afu_clone__", null);else if (-1 !== navigator.appVersion.indexOf("MSIE 10") || -1 !== navigator.userAgent.indexOf("Trident/7")) {
	        var c = k();return c.attr("__afu_clone__", !0), c[0].click(), a.preventDefault(), a.stopPropagation(), !0;
	      }
	    }function o(a, b, c, d, h) {
	      for (var i = [], j = [], k = f(b.ngAccept)(d), l = angular.isString(k) && k ? new RegExp(e(k), "gi") : null, m = l ? null : b.ngAccept, n = 0; n < a.length; n++) {
	        var o = a.item(n);!(!l || o.type.match(l) || null != o.name && o.name.match(l)) || m && !f(m)(d, { $file: o, $event: h }) ? j.push(o) : i.push(o);
	      }g(function () {
	        c && (f(b.ngModel).assign(d, i), c && c.$setViewValue(null != i && 0 == i.length ? "" : i), b.ngModelRejected && f(b.ngModelRejected).assign(d, j)), b.ngFileChange && "" != b.ngFileChange && f(b.ngFileChange)(d, { $files: i, $rejectedFiles: j, $event: h });
	      });
	    }var p = [];l(c.ngMultiple, "multiple"), l(c.ngAccept, "accept"), l(c.ngCapture, "capture"), "" != c.ngFileSelect && (c.ngFileChange = c.ngFileSelect);var q = b;if (i()) b.bind("click", n);else {
	      q = angular.element('<input type="file">'), c.multiple && q.attr("multiple", c.multiple), c.accept && q.attr("accept", c.accept), c.capture && q.attr("capture", c.capture);for (var r in c) {
	        if (0 == r.indexOf("inputFile")) {
	          var s = r.substring("inputFile".length);s = s[0].toLowerCase() + s.substring(1), q.attr(s, c[r]);
	        }
	      }q.css("width", "0px").css("height", "0px").css("position", "absolute").css("padding", 0).css("margin", 0).css("overflow", "hidden").attr("tabindex", "-1").css("opacity", 0).attr("__afu_gen__", !0), b.attr("__refElem__", !0), q[0].__refElem__ = b[0], b.parent()[0].insertBefore(q[0], b[0]), b.css("overflow", "hidden"), b.bind("click", function (a) {
	        n(a) || q[0].click();
	      });
	    }q.bind("change", m), b.on("$destroy", function () {
	      for (var a = 0; a < p.length; a++) {
	        p[a]();
	      }b[0] != q[0] && q.remove();
	    }), p.push(a.$watch(c.ngModel, function (a, b) {
	      a == b || null != a && a.length || (-1 !== navigator.appVersion.indexOf("MSIE 10") ? k() : q[0].value = null);
	    }));
	  }function c(a, b, c, f, g, h, i) {
	    function j(a, b, c) {
	      var d = !0;if (r || s) {
	        var e = c.dataTransfer.items;if (null != e) for (var f = 0; f < e.length && d; f++) {
	          d = d && ("file" == e[f].kind || "" == e[f].kind) && (s && g(s)(a, { $file: e[f], $event: c }) || r && null != e[f].type && e[f].type.match(r) || null != e[f].name && e[f].name.match(r));
	        }
	      }var h = g(b.dragOverClass)(a, { $event: c });return h && (h.delay && (p = h.delay), h.accept && (h = d ? h.accept : h.reject)), h || b.dragOverClass || "dragover";
	    }function k(b, c, d, e) {
	      function f(c) {
	        !(!r || c.type.match(r) || null != c.name && c.name.match(r)) || s && !g(s)(a, { $file: c, $event: b }) ? l.push(c) : k.push(c);
	      }function j(a, b, c) {
	        if (null != b) if (b.isDirectory) {
	          var d = (c || "") + b.name;f({ name: b.name, type: "directory", path: d });var e = b.createReader(),
	              g = [];n++;var h = function h() {
	            e.readEntries(function (d) {
	              try {
	                if (d.length) g = g.concat(Array.prototype.slice.call(d || [], 0)), h();else {
	                  for (var e = 0; e < g.length; e++) {
	                    j(a, g[e], (c ? c : "") + b.name + "/");
	                  }n--;
	                }
	              } catch (f) {
	                n--, console.error(f);
	              }
	            }, function () {
	              n--;
	            });
	          };h();
	        } else n++, b.file(function (a) {
	          try {
	            n--, a.path = (c ? c : "") + a.name, f(a);
	          } catch (b) {
	            n--, console.error(b);
	          }
	        }, function () {
	          n--;
	        });
	      }var k = [],
	          l = [],
	          m = b.dataTransfer.items,
	          n = 0;if (m && m.length > 0 && "file" != i.protocol()) for (var o = 0; o < m.length; o++) {
	        if (m[o].webkitGetAsEntry && m[o].webkitGetAsEntry() && m[o].webkitGetAsEntry().isDirectory) {
	          var p = m[o].webkitGetAsEntry();if (p.isDirectory && !d) continue;null != p && j(k, p);
	        } else {
	          var q = m[o].getAsFile();null != q && f(q);
	        }if (!e && k.length > 0) break;
	      } else {
	        var t = b.dataTransfer.files;if (null != t) for (var o = 0; o < t.length && (f(t.item(o)), e || !(k.length > 0)); o++) {}
	      }var u = 0;!function v(a) {
	        h(function () {
	          if (n) 10 * u++ < 2e4 && v(10);else {
	            if (!e && k.length > 1) {
	              for (var a = 0; "directory" == k[a].type;) {
	                a++;
	              }k = [k[a]];
	            }c(k, l);
	          }
	        }, a || 0);
	      }();
	    }var l = d();if (c.dropAvailable && h(function () {
	      a.dropAvailable ? a.dropAvailable.value = l : a.dropAvailable = l;
	    }), !l) return 0 != g(c.hideOnDropNotAvailable)(a) && b.css("display", "none"), void 0;var m,
	        n = null,
	        o = g(c.stopPropagation)(a),
	        p = 1,
	        q = g(c.ngAccept)(a) || c.accept,
	        r = angular.isString(q) && q ? new RegExp(e(q), "gi") : null,
	        s = r ? null : c.ngAccept;b[0].addEventListener("dragover", function (d) {
	      if (d.preventDefault(), o && d.stopPropagation(), navigator.userAgent.indexOf("Chrome") > -1) {
	        var e = d.dataTransfer.effectAllowed;d.dataTransfer.dropEffect = "move" === e || "linkMove" === e ? "move" : "copy";
	      }h.cancel(n), a.actualDragOverClass || (m = j(a, c, d)), b.addClass(m);
	    }, !1), b[0].addEventListener("dragenter", function (a) {
	      a.preventDefault(), o && a.stopPropagation();
	    }, !1), b[0].addEventListener("dragleave", function () {
	      n = h(function () {
	        b.removeClass(m), m = null;
	      }, p || 1);
	    }, !1), "" != c.ngFileDrop && (c.ngFileChange = a.ngFileDrop), b[0].addEventListener("drop", function (d) {
	      d.preventDefault(), o && d.stopPropagation(), b.removeClass(m), m = null, k(d, function (b, e) {
	        h(function () {
	          f && (g(c.ngModel).assign(a, b), f && f.$setViewValue(null != b && 0 == b.length ? "" : b)), c.ngModelRejected && a[c.ngModelRejected] && g(c.ngModelRejected).assign(a, e);
	        }), h(function () {
	          g(c.ngFileChange)(a, { $files: b, $rejectedFiles: e, $event: d });
	        });
	      }, 0 != g(c.allowDir)(a), c.multiple || g(c.ngMultiple)(a));
	    }, !1);
	  }function d() {
	    var a = document.createElement("div");return "draggable" in a && "ondrop" in a;
	  }function e(a) {
	    if (a.length > 2 && "/" === a[0] && "/" === a[a.length - 1]) return a.substring(1, a.length - 1);var b = a.split(","),
	        c = "";if (b.length > 1) for (var d = 0; d < b.length; d++) {
	      c += "(" + e(b[d]) + ")", d < b.length - 1 && (c += "|");
	    } else 0 == a.indexOf(".") && (a = "*" + a), c = "^" + a.replace(new RegExp("[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]", "g"), "\\$&") + "$", c = c.replace(/\\\*/g, ".*").replace(/\\\?/g, ".");return c;
	  }window.XMLHttpRequest && !window.XMLHttpRequest.__isFileAPIShim && a("setRequestHeader", function (a) {
	    return function (b, c) {
	      if ("__setXHR_" === b) {
	        var d = c(this);d instanceof Function && d(this);
	      } else a.apply(this, arguments);
	    };
	  });var f = angular.module("angularFileUpload", []);f.version = "3.1.0", f.service("$upload", ["$http", "$q", "$timeout", function (a, b, c) {
	    function d(d) {
	      d.method = d.method || "POST", d.headers = d.headers || {}, d.transformRequest = d.transformRequest || function (b, c) {
	        return window.ArrayBuffer && b instanceof window.ArrayBuffer ? b : a.defaults.transformRequest[0](b, c);
	      };var e = b.defer(),
	          f = e.promise;return d.headers.__setXHR_ = function () {
	        return function (a) {
	          a && (d.__XHR = a, d.xhrFn && d.xhrFn(a), a.upload.addEventListener("progress", function (a) {
	            a.config = d, e.notify ? e.notify(a) : f.progress_fn && c(function () {
	              f.progress_fn(a);
	            });
	          }, !1), a.upload.addEventListener("load", function (a) {
	            a.lengthComputable && (a.config = d, e.notify ? e.notify(a) : f.progress_fn && c(function () {
	              f.progress_fn(a);
	            }));
	          }, !1));
	        };
	      }, a(d).then(function (a) {
	        e.resolve(a);
	      }, function (a) {
	        e.reject(a);
	      }, function (a) {
	        e.notify(a);
	      }), f.success = function (a) {
	        return f.then(function (b) {
	          a(b.data, b.status, b.headers, d);
	        }), f;
	      }, f.error = function (a) {
	        return f.then(null, function (b) {
	          a(b.data, b.status, b.headers, d);
	        }), f;
	      }, f.progress = function (a) {
	        return f.progress_fn = a, f.then(null, null, function (b) {
	          a(b);
	        }), f;
	      }, f.abort = function () {
	        return d.__XHR && c(function () {
	          d.__XHR.abort();
	        }), f;
	      }, f.xhr = function (a) {
	        return d.xhrFn = function (b) {
	          return function () {
	            b && b.apply(f, arguments), a.apply(f, arguments);
	          };
	        }(d.xhrFn), f;
	      }, f;
	    }this.upload = function (a) {
	      a.headers = a.headers || {}, a.headers["Content-Type"] = void 0;a.transformRequest;return a.transformRequest = a.transformRequest ? "[object Array]" === Object.prototype.toString.call(a.transformRequest) ? a.transformRequest : [a.transformRequest] : [], a.transformRequest.push(function (b) {
	        var c = new FormData(),
	            d = {};for (var e in a.fields) {
	          d[e] = a.fields[e];
	        }if (b && (d.data = b), a.formDataAppender) for (var e in d) {
	          a.formDataAppender(c, e, d[e]);
	        } else for (var e in d) {
	          var f = d[e];void 0 !== f && ("[object String]" === Object.prototype.toString.call(f) ? c.append(e, f) : a.sendObjectsAsJsonBlob && "object" == (typeof f === "undefined" ? "undefined" : _typeof(f)) ? c.append(e, new Blob([f], { type: "application/json" })) : c.append(e, JSON.stringify(f)));
	        }if (null != a.file) {
	          var g = a.fileFormDataName || "file";if ("[object Array]" === Object.prototype.toString.call(a.file)) for (var h = "[object String]" === Object.prototype.toString.call(g), i = 0; i < a.file.length; i++) {
	            c.append(h ? g : g[i], a.file[i], a.fileName && a.fileName[i] || a.file[i].name);
	          } else c.append(g, a.file, a.fileName || a.file.name);
	        }return c;
	      }), d(a);
	    }, this.http = function (a) {
	      return d(a);
	    };
	  }]), f.directive("ngFileSelect", ["$parse", "$timeout", "$compile", function (a, c, d) {
	    return { restrict: "AEC", require: "?ngModel", link: function link(e, f, g, h) {
	        b(e, f, g, h, a, c, d);
	      } };
	  }]), f.directive("ngFileDrop", ["$parse", "$timeout", "$location", function (a, b, d) {
	    return { restrict: "AEC", require: "?ngModel", link: function link(e, f, g, h) {
	        c(e, f, g, h, a, b, d);
	      } };
	  }]), f.directive("ngNoFileDrop", function () {
	    return function (a, b) {
	      d() && b.css("display", "none");
	    };
	  }), f.directive("ngFileDropAvailable", ["$parse", "$timeout", function (a, b) {
	    return function (c, e, f) {
	      if (d()) {
	        var g = a(f.ngFileDropAvailable);b(function () {
	          g(c);
	        });
	      }
	    };
	  }]);var g = angular.module("ngFileUpload", []);for (var h in f) {
	    g[h] = f[h];
	  }
	}();

/***/ }),
/* 619 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.api').factory('apiLegacy', ['$http', function ($http) {
	  function makeRequest(methodToUse, urlToHit, DataToSend, headersToSend) {
	    return $http({
	      method: methodToUse,
	      url: urlToHit,
	      data: DataToSend,
	      headers: headersToSend
	    });
	  }
	
	  var api = {
	    request: makeRequest,
	    fetchCurrentUser: function fetchCurrentUser() {
	      return $http.post('/api/fetch-current-user', {
	        contentType: 'application/json'
	      });
	    },
	    fetchSelectedLawyer: function fetchSelectedLawyer(payload) {
	      return makeRequest('POST', '/api/fetch-selected-lawyer', payload, {
	        contentType: 'application/json'
	      });
	    },
	    logoutUser: function logoutUser() {
	      return $http.post('/api/logout', { withCredentials: 'true' });
	    },
	    searchNonRegisterUsers: function searchNonRegisterUsers(payload) {
	      return $http.post('/api/fetch-search-non-registered-users', payload);
	    },
	    searchLawyers: function searchLawyers(payload) {
	      // return makeRequest('POST', '/api/admin/fetchLawyers', payload, {gzip:true })
	      return $http.post('/api/admin/fetchLawyers', payload);
	    },
	    setSelectedTabStateToLawyers: function setSelectedTabStateToLawyers() {
	      return $http.post('/api/show-lawyers');
	    },
	    searchFirms: function searchFirms(payload) {
	      return $http.post('/api/admin/fetchFirms', payload);
	    },
	    setSelectedTabStateToFirms: function setSelectedTabStateToFirms() {
	      return $http.post('/api/show-firms');
	    },
	    setSelectedTabStateToInhouseJobs: function setSelectedTabStateToInhouseJobs() {
	      return $http.post('/api/show-inhouse-firms');
	    },
	    fetchEmailListings: function fetchEmailListings(page) {
	      return $http.post('/api/admin/fetch-email-listing', page);
	    },
	    setSelectedTabStateToEmailListing: function setSelectedTabStateToEmailListing() {
	      return $http.post('/api/admin/navigate-email-listing');
	    },
	    fetchRelevantJobsCount: function fetchRelevantJobsCount(lawyers, regular) {
	      return $http.post('/api/fetch-relevant-roles-count', { lawyers: lawyers, isRegular: regular }, { contentType: 'application/json' });
	    },
	    fetchJobs: function fetchJobs(payload) {
	      return $http.post('/api/jobs/fetch-jobs-listing', { queryOptions: payload }, { contentType: 'application/json' });
	    },
	    fetchActiveJobs: function fetchActiveJobs(payload) {
	      return $http.post('/api/jobs/fetch-active-jobs-listing', { queryOptions: payload }, { contentType: 'application/json' });
	    },
	    fetchExpiredJobs: function fetchExpiredJobs(payload) {
	      return $http.post('/api/jobs/fetch-expired-jobs-listing', { queryOptions: payload }, { contentType: 'application/json' });
	    },
	    updateAssignedAdmin: function updateAssignedAdmin(payload) {
	      return $http.post('/api/update-user-assigned-admin', payload);
	    },
	    fetchAllConsultants: function fetchAllConsultants() {
	      return $http.post('/api/fetch-assignee-admins', {
	        contentType: 'application/json'
	      });
	    },
	    fetchRefSelectivities: function fetchRefSelectivities() {
	      return makeRequest('GET', '/api/fetch-ref-selectivity');
	    },
	    fetchRefCategories: function fetchRefCategories() {
	      return makeRequest('POST', '/api/profile-category');
	    },
	    fetchRefPractices: function fetchRefPractices() {
	      return makeRequest('POST', '/api/profile-practice-areas');
	    },
	    fetchRefLocations: function fetchRefLocations() {
	      return makeRequest('POST', '/api/profile-location');
	    },
	    updateUser: function updateUser(payload) {
	      return $http.post('/api/update-user', payload, {
	        contentType: 'application/json'
	      });
	    },
	    getProfilePicture: function getProfilePicture(payload) {
	      return $http.post('/api/get-profile-pic', payload);
	    },
	    updateExpiryForMultipleJobs: function updateExpiryForMultipleJobs(payload) {
	      return makeRequest('POST', '/api/admin/updateMulitpleJobsExpiry', payload);
	    },
	    updateLocationsForLawyer: function updateLocationsForLawyer(payload) {
	      return makeRequest('POST', '/api/update-lawyer-locations', payload);
	    },
	    updatePracticesForLawyer: function updatePracticesForLawyer(payload) {
	      return makeRequest('POST', '/api/update-lawyer-practices', payload);
	    },
	    updateJurisdictionsForLawyer: function updateJurisdictionsForLawyer(payload) {
	      return makeRequest('POST', '/api/update-lawyer-jurisdictions', payload);
	    },
	    updateOtherJurisdictionsForLawyer: function updateOtherJurisdictionsForLawyer(payload) {
	      return makeRequest('POST', '/api/update-lawyer-otherJurisdictions', payload);
	    },
	    updateLanguagesForLawyer: function updateLanguagesForLawyer(payload) {
	      return makeRequest('POST', '/api/update-lawyer-languages', payload);
	    },
	    updateOtherLanguagesForLawyer: function updateOtherLanguagesForLawyer(payload) {
	      return makeRequest('POST', '/api/update-lawyer-otherLanguages', payload);
	    },
	    // updateShownFirmCategoriesForLawyer: (payload) => makeRequest('POST', '/api/update-lawyer-categories' , payload),
	    updateMoveReasonForLawyer: function updateMoveReasonForLawyer(payload) {
	      return makeRequest('POST', '/api/update-lawyer-move', payload);
	    },
	    updateAdditionalInfoForLawyer: function updateAdditionalInfoForLawyer(payload) {
	      return makeRequest('POST', '/api/update-lawyer-info', payload);
	    },
	    hideJobForLawyer: function hideJobForLawyer(payload) {
	      return makeRequest('POST', '/api/hide-lawyer-job', payload);
	    },
	    unHideJobForLawyer: function unHideJobForLawyer(payload) {
	      return makeRequest('POST', '/api/un-hide-lawyer-job', payload);
	    },
	    hideEmployerForLawyer: function hideEmployerForLawyer(payload) {
	      return makeRequest('POST', '/api/hide-lawyer-firm', payload);
	    },
	    unHideEmployerForLawyer: function unHideEmployerForLawyer(payload) {
	      return makeRequest('POST', '/api/un-hide-lawyer-firm', payload);
	    },
	    fetchLawyerSalary: function fetchLawyerSalary(payload) {
	      return makeRequest('POST', '/api/fetch-lawyer-salary', payload);
	    },
	    fetchLawyerSalaryHistory: function fetchLawyerSalaryHistory(payload) {
	      return makeRequest('POST', '/api/fetch-lawyer-salary-history', payload);
	    },
	    editLawyerSalary: function editLawyerSalary(payload) {
	      return makeRequest('POST', '/api/edit-lawyer-salary', payload);
	    },
	    fetchAllLawyerContracts: function fetchAllLawyerContracts(payload) {
	      return makeRequest('POST', '/api/fetch-all-lawyer-contracts', payload);
	    },
	    fetchAllLawyerRoles: function fetchAllLawyerRoles(payload) {
	      return makeRequest('POST', '/api/fetch-all-lawyer-roles', payload);
	    },
	    fetchAllLawyerEmployerType: function fetchAllLawyerEmployerType(payload) {
	      return makeRequest('POST', '/api/fetch-all-lawyer-employer-type', payload);
	    },
	    fetchLocations: function fetchLocations(payload) {
	      return makeRequest('POST', '/api/profile-location', payload);
	    },
	    fetchPractices: function fetchPractices(payload) {
	      return makeRequest('POST', '/api/profile-practice-areas', payload);
	    },
	    fetchAllContracts: function fetchAllContracts(payload) {
	      return makeRequest('POST', '/api/fetch-all-contracts', payload);
	    },
	    fetchAllRoles: function fetchAllRoles(payload) {
	      return makeRequest('POST', '/api/fetch-all-roles', payload);
	    },
	    fetchAllFirms: function fetchAllFirms(payload) {
	      return makeRequest('POST', '/api/fetchAllFirms', payload);
	    },
	    // fetchLawyerLanguages: (payload) => makeRequest('POST', '/api/fetch-all-lawyer-languagesOtherLanguages' , payload),
	    // fetchLawyerJurisdiction: (payload) => makeRequest('POST', '/api/fetch-all-lawyer-jurisdictionsOtherJurisdiction' , payload),
	    updateLawyerPreferences: function updateLawyerPreferences(payload) {
	      return makeRequest('POST', '/api/update-lawyer-preferences', payload);
	    },
	    updateLawyerPreferencesFlag: function updateLawyerPreferencesFlag(payload) {
	      return makeRequest('POST', '/api/update-lawyer-preferences-flag', payload);
	    },
	    updateLawyerLinkedlin: function updateLawyerLinkedlin(payload) {
	      return makeRequest('POST', '/api/update-lawyer-linkedlin', payload);
	    },
	    addLawyerSalary: function addLawyerSalary(payload) {
	      return makeRequest('POST', '/api/add-lawyer-salary', payload);
	    },
	    fetchHeirarchyApplicationStages: function fetchHeirarchyApplicationStages(payload) {
	      return makeRequest('POST', '/api/stages/fetch-all-hierarchy-application-stages', payload);
	    },
	    fetchLinearApplicationStages: function fetchLinearApplicationStages(payload) {
	      return makeRequest('POST', '/api/stages/fetch-all-linear-application-stages', payload);
	    },
	    fetchHeirarchyMatchesStages: function fetchHeirarchyMatchesStages(payload) {
	      return makeRequest('POST', '/api/stages/fetch-all-hierarchy-matches-stages', payload);
	    },
	    fetchLinearMatchesStages: function fetchLinearMatchesStages(payload) {
	      return makeRequest('POST', '/api/stages/fetch-all-linear-matches-stages', payload);
	    },
	    fetchLastConversation: function fetchLastConversation(payload) {
	      return makeRequest('POST', '/api/fetch-last-conversation', payload);
	    },
	    // updateJobListingType: (payload) => makeRequest( 'POST','/api/admin/updateJobListingType',payload ),
	
	    addStage: function addStage(payload) {
	      return makeRequest('POST', '/api/stages/insert-application-stage', payload);
	    },
	    deleteStage: function deleteStage(payload) {
	      return makeRequest('POST', '/api/stages/delete-application-stage', payload);
	    },
	    updateStage: function updateStage(payload) {
	      return makeRequest('POST', '/api/stages/update-application-stage', payload);
	    },
	    fetchApplicationRecordList: function fetchApplicationRecordList(payload) {
	      return makeRequest('POST', '/api/admin/fetch-applications', payload);
	    },
	    updateOrderStage: function updateOrderStage(payload) {
	      return makeRequest('POST', '/api/stages/update-order-application-stage', payload);
	    },
	    changeApplicationStage: function changeApplicationStage(payload) {
	      return makeRequest('POST', '/api/admin/change-application-stage', payload);
	    },
	    fetchApplicationsCount: function fetchApplicationsCount(payload) {
	      return makeRequest('POST', '/api/admin/fetch-applications-count', payload);
	    },
	    fetchApplicationHistory: function fetchApplicationHistory(payload) {
	      return makeRequest('POST', '/api/admin/fetch-application-history', payload);
	    },
	    updateApplicationData: function updateApplicationData(payload) {
	      return makeRequest('POST', '/api/admin/update-application-data', payload);
	    },
	    updateApplicationHistory: function updateApplicationHistory(payload) {
	      return makeRequest('POST', '/api/admin/update-application-history', payload);
	    },
	    updateApplicationFollowers: function updateApplicationFollowers(payload) {
	      return makeRequest('POST', '/api/admin/update-application-followers', payload);
	    },
	    updateApplicationHistoryNote: function updateApplicationHistoryNote(payload) {
	      return makeRequest('POST', '/api/admin/update-application-history-note', payload);
	    },
	    deleteApplicationHistoryNote: function deleteApplicationHistoryNote(payload) {
	      return makeRequest('POST', '/api/admin/delete-application-history-note', payload);
	    },
	    deleteInterviewDate: function deleteInterviewDate(payload) {
	      return makeRequest('POST', '/api/admin/delete-interview-date', payload);
	    },
	    fetchSavedRulesForUsers: function fetchSavedRulesForUsers(fetchFilterPayload) {
	      return api.request('POST', '/api/admin/applied-filters/fetch', fetchFilterPayload);
	    },
	    saveFilter: function saveFilter(filterPayload) {
	      return api.request('PUT', '/api/admin/applied-filters/save', filterPayload);
	    },
	    deleteSavedFilter: function deleteSavedFilter(filterId) {
	      return api.request('DELETE', '/api/admin/applied-filters/delete/' + filterId);
	    },
	    updateSavedFilter: function updateSavedFilter(filterId, updatedFilterPayload) {
	      return api.request('PUT', '/api/admin/applied-filters/save/' + filterId, updatedFilterPayload);
	    },
	    fetchDefaultViewForUsers: function fetchDefaultViewForUsers(fetchFilterPayload) {
	      return api.request('POST', '/api/admin/default-view-filter-user/fetch', fetchFilterPayload);
	    },
	    deleteDefaultViewForUsers: function deleteDefaultViewForUsers(fetchFilterPayload) {
	      return api.request('POST', '/api/admin/default-view-filter-user/delete', fetchFilterPayload);
	    },
	    saveDefaultViewForUsers: function saveDefaultViewForUsers(fetchFilterPayload) {
	      return api.request('POST', '/api/admin/default-view-filter-user/save', fetchFilterPayload);
	    },
	    fetchFirmByID: function fetchFirmByID(firmId) {
	      return api.request('POST', '/api/admin/fetchFirmByID', firmId);
	    },
	    createEventHistory: function createEventHistory(payload) {
	      return makeRequest('POST', '/api/events/create-event', payload);
	    },
	
	    changeMatchesStage: function changeMatchesStage(payload) {
	      return makeRequest('POST', '/api/admin/change-matches-stage', payload);
	    },
	    changeMatchesStatus: function changeMatchesStatus(payload) {
	      return makeRequest('POST', '/api/admin/change-matches-status', payload);
	    },
	    fetchMatchesJob: function fetchMatchesJob(payload) {
	      return makeRequest('POST', '/api/admin/fetch-matches-job', payload);
	    },
	    fetchJobDescriptionById: function fetchJobDescriptionById(payload) {
	      return makeRequest('POST', '/api/jobs/fetchJobDescriptionById', payload);
	    },
	
	    fetchSearchNonRegisteredUsers: function fetchSearchNonRegisteredUsers(payload) {
	      return makeRequest('POST', '/api/fetch-search-non-registered-users', payload);
	    },
	    fetchtotalReferredUsers: function fetchtotalReferredUsers(payload) {
	      return makeRequest('POST', '/api/fetch-total-referred-users', payload);
	    },
	    fetchsuccessfulRefUsers: function fetchsuccessfulRefUsers(payload) {
	      return makeRequest('POST', '/api/fetch-successful-ref-users', payload);
	    },
	    fetchNonRegisteredReferrals: function fetchNonRegisteredReferrals(payload) {
	      return makeRequest('POST', '/api/fetch-non-registered-referrals', payload);
	    },
	    addErrorNotification: function addErrorNotification(payload) {
	      return makeRequest('POST', '/api/notification/notifyError', payload);
	    },
	
	    fetchMasterDetailApplications: function fetchMasterDetailApplications(payload) {
	      return makeRequest('POST', '/api/admin/fetch-applications-matches-job', payload);
	    }
	  };
	  return api;
	}]);

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.api', []);

/***/ }),
/* 621 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.api').factory('PreferencesApi', ['api', function PreferencesApi(api) {
	  var _this = this;
	
	  var preferencesApi = {
	    getLocations: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                return _context.abrupt('return', api.get('locations?regions=true'));
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function getLocations() {
	        return _ref.apply(this, arguments);
	      }
	
	      return getLocations;
	    }(),
	    getCategoryById: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                return _context2.abrupt('return', api.get('categories/' + id));
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      function getCategoryById(_x) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getCategoryById;
	    }(),
	    getLanguages: function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	        var languages, sorted, withSorted;
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return api.get('languages');
	
	              case 2:
	                languages = _context3.sent;
	                sorted = languages.data.sort(function (a, b) {
	                  return a.name.localeCompare(b.name);
	                });
	                withSorted = _.extend(languages, { data: sorted });
	                return _context3.abrupt('return', withSorted);
	
	              case 6:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this);
	      }));
	
	      function getLanguages() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return getLanguages;
	    }(),
	    getContractTypes: function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                return _context4.abrupt('return', api.get('contract-types'));
	
	              case 1:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this);
	      }));
	
	      function getContractTypes() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return getContractTypes;
	    }(),
	    getOccupationsByProfession: function () {
	      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(profession) {
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                return _context5.abrupt('return', api.get('occupations' + (profession ? '?profession=' + profession : '')));
	
	              case 1:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this);
	      }));
	
	      function getOccupationsByProfession(_x2) {
	        return _ref5.apply(this, arguments);
	      }
	
	      return getOccupationsByProfession;
	    }()
	  };
	  return preferencesApi;
	}]);

/***/ }),
/* 622 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.ui.form.ctrls').directive('clearIcon', ['$compile', function ($compile) {
		return {
			restrict: 'A',
			link: function link(scope, elem, attrs) {
				var model = attrs.ngModel;
				var template = '<span ng-click=\"clearText(\'' + model + '\')\" class="clearIcon"             style="display:none;">x</span>';
				elem.parent().append($compile(template)(scope));
				var clearIconToggle = function clearIconToggle(toggleParam) {
					if (elem.val().trim().length) elem.next().css("display", "inline");else {
						if (elem.next().css("display") == "inline") elem.next().css("display", "none");
					}
				};
				var clearText = function clearText(clearParam) {
					elem.val('');
					clearIconToggle(clearParam);
				};
				elem.on("focus", function (event) {
					clearIconToggle(model);
				});
				elem.on("keyup", function (event) {
					clearIconToggle(model);
				});
				elem.next().on("click", function (event) {
					elem.val('');
					elem.next().css("display", "none");
				});
			}
		};
	}]);

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	'use strict';
	
	/******************************************************************/
	/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
	/******************************************************************/
	
	angular.module('app.constants').constant('REDIRECT_TO_404', true).constant('INHOUSE_CATEGORY', 2).constant('AUTOGENERATED_CATEGORY', 3).constant('SELECTIVITY_NO_CATEGORY', 'SELECTIVITY_NO_CATEGORY');

/***/ }),
/* 624 */
/***/ (function(module, exports) {

	'use strict';
	
	/******************************************************************/
	/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
	/******************************************************************/
	
	angular.module('app.constants', []);

/***/ }),
/* 625 */
/***/ (function(module, exports) {

	'use strict';
	
	function appController($scope, $location, $rootScope, $timeout, userService, logger) {
	  var specificPages = ['/', '/404', '/502', '/500', '/login', '/signin', '/reset-password', '/change-password', '/profile', '/signup', '/admin/firm-management', '/invite-friend', '/admin/lawyer-listing', '/admin/referral-listing', '/admin/matching-lawyers-listing', '/admin/email-listing', '/admin/job-creation', '/admin/admin-listings', '/admin/inactive-positions', '/signup1', '/signup2', '/forgot', '/lock-screen', '/admin/applied-jobs', '/user-profile', '/opportunities', '/connections', '/home', '/admin/lawyer-profile', '/admin/job-edit', '/admin/job-clone', '/for-employers', '/about', '/faqs', '/terms-conditions', '/privacy-policy', '/invite-friends', '/sitemap', '/sitemap.xml', '/new-lawyer-referral', '/admin/matching-lawyers', '/site-maintenance', '/get-in-touch', '/inhouse-jobs', '/matches', '/unsubscribedWeekly', '/pausedWeekly', '/admin/firm-notes', '/admin/email-history', '/admin/email-history-view', '/admin/edit-email', '/admin/email-body'];
	
	  var loginFailureMsgTimer = undefined;
	
	  var displayErrorMessage = function displayErrorMessage(errorResponse) {
	    logger.notify('error', '\n      An Error Occurred while performing the request.\n      <br/>\n      <strong>Error Reason:</strong> ' + errorResponse.statusText + '\n      ');
	  };
	
	  var disableLoginFailureMsgTimer = function disableLoginFailureMsgTimer() {
	    loginFailureMsgTimer = undefined;
	  };
	
	  var startLoginFailureMsgDisplayTimer = function startLoginFailureMsgDisplayTimer() {
	    loginFailureMsgTimer = $timeout(disableLoginFailureMsgTimer, 10 * 1000);
	  };
	
	  var preventMultipleLoginErrorMessages = function preventMultipleLoginErrorMessages() {
	    if (loginFailureMsgTimer) return true;else {
	      startLoginFailureMsgDisplayTimer();
	      return false;
	    }
	  };
	
	  $scope.isSpecificPage = function () {
	    return _.contains(specificPages, $location.path());
	  };
	
	  $scope.refreshUser = function () {
	    userService.setUser().then(function (user) {
	      $rootScope.user = user;
	    });
	  };
	
	  $rootScope.errorHandler = function (errorResponse) {
	    if (Object.is(errorResponse.status, 440)) {
	      if (preventMultipleLoginErrorMessages()) return;
	
	      errorResponse.statusText = 'Not Signed in';
	    }
	
	    displayErrorMessage(errorResponse);
	  };
	
	  $rootScope.changeStatus = function (status, controller, operation) {
	    if (status === 404) {
	      controller.alertMsg = 'Page Not Found. Please try again.';
	      controller.showOnError = true;
	    } else if (status === 502) {
	      controller.alertMsg = 'Server is not Responded with Bad Request Gateway';
	      controller.showOnError = true;
	    } else if (status === 500) {
	      controller.alertMsg = 'Could not connect to the server. Please try again later.';
	      controller.showOnError = true;
	    } else if (status === 100) {
	      controller.alertMsg = 'Please select a firm by clicking the checkboxes before deleting.';
	      controller.showOnError = true;
	    } else if (status === 409) {
	      controller.alertMsg = 'Another firm with the same name already exists. Please enter a unique firm name';
	      controller.showOnError = true;
	    } else if (status === 200 && operation === 'delete') {
	      controller.alertMsg = 'The Firm has been deleted successfully.';
	      $scope.isDeleted = true;
	      controller.showOnSuccess = true;
	    } else if (status === 200 && operation === 'edit') {
	      controller.alertMsg = 'The Firm has been updated successfully.';
	      controller.showOnSuccess = true;
	    } else if (status === 440) {
	      $location.url('/signin');
	    } else {
	      controller.alertMsg = 'An error has occurred. Please try the action again.';
	      controller.showOnError = true;
	    }
	  };
	}
	
	angular.module('app.controllers').controller('AppCtrl', ['$scope', '$location', '$rootScope', '$timeout', 'userService', 'logger', appController]);

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _controller = __webpack_require__(182);
	
	angular.module('app.controllers').controller('columnSelectModalCtrl', _controller.columnSelectorCtrl); /********************************************************************/
	/*** Initially Implemeneted By Fahad Akbar(fahadakbar24@gmail.com) **/
	/********************************************************************/

/***/ }),
/* 627 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.controllers', []);

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	'use strict';
	
	function navController($scope, taskStorage, filterFilter) {
	  var tasks;
	  tasks = $scope.tasks = taskStorage.get();
	  $scope.taskRemainingCount = filterFilter(tasks, {
	    completed: false
	  }).length;
	  return $scope.$on('taskRemaining:changed', function (event, count) {
	    return $scope.taskRemainingCount = count;
	  });
	}
	
	angular.module('app.controllers').controller('NavCtrl', ['$scope', 'taskStorage', 'filterFilter', navController]);

/***/ }),
/* 629 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/* eslint-disable camelcase */
	/* eslint-disable no-return-assign */
	/* eslint-disable no-unused-vars, func-names */
	var editLawyerController = function editLawyerController($scope, $rootScope, $modal, $http, api, logger, $log, $q, usSpinnerService) {
	  $scope.startSpin = function (spinnerID) {
	    if (!$scope.spinneractive) {
	      usSpinnerService.spin(spinnerID);
	      $scope.spinneractive = true;
	      return $scope.startcounter++;
	    }
	  };
	
	  $scope.stopSpin = function (spinnerID) {
	    if ($scope.spinneractive) {
	      usSpinnerService.stop(spinnerID);
	      $scope.spinneractive = false;
	    }
	  };
	
	  function fetchAllConsultants() {
	    // If already fetched all admins just return from here
	    if (!_.isEmpty($scope.allConsultants)) return;
	    // If already fetched all admins just return from here
	    return api.fetchAllConsultants().then(function (response) {
	      return $scope.allConsultants = response.data;
	    }, function (error) {
	      return $log.info('error', error);
	    });
	  }
	
	  $scope.openModal = function (userID, lawyerID, event) {
	    var data;
	    event.preventDefault();
	    event.stopPropagation();
	    $scope.showActionsSpinner = true;
	    $scope.startSpin('spinner-' + lawyerID);
	    if ($scope.loggedInLawyer) {
	      $scope.selectedLawyer = $scope.loggedInLawyer.lawyer;
	      $scope.selectedLawyer.user = $scope.loggedInLawyer.user;
	    } else {
	      $scope.selectedLawyer = _.where($scope.currentPageItems, {
	        lawyer_ID: lawyerID
	      })[0];
	    }
	
	    if (!$scope.showNonRegisteredUser && $scope.selectedLawyer.lawyer_Status !== 'NewUser') {
	      $scope.dataValues = {};
	      // eslint-disable-next-line no-unused-expressions
	      // $scope.selectedLawyer
	      $scope.blockFirms = [];
	      $scope.dataValues = {};
	      data = {
	        searchKeywords: '',
	        filter: {},
	        orderBy: {},
	        showExpiredJobs: false
	      };
	      $q.all([$http.post('/api/fetch-block-firms', {
	        id: $scope.selectedLawyer.lawyer_ID
	      }, {
	        contentType: 'application/json'
	      }).then(function (_ref) {
	        var data = _ref.data,
	            status = _ref.status,
	            headers = _ref.headers,
	            config = _ref.config;
	
	        $scope.blockFirms = data;
	      }, function (_ref2) {
	        var data = _ref2.data,
	            status = _ref2.status,
	            headers = _ref2.headers,
	            config = _ref2.config;
	
	        $scope.changeStatus(status);
	      }), $http.post('/api/fetch-lawyer-categories', {
	        id: $scope.selectedLawyer.lawyer_ID
	      }, {
	        contentType: 'application/json'
	      }).then(function (_ref3) {
	        var data = _ref3.data,
	            status = _ref3.status,
	            headers = _ref3.headers,
	            config = _ref3.config;
	
	        $scope.lawyerCategories = data;
	      }, function (_ref4) {
	        var data = _ref4.data,
	            status = _ref4.status,
	            headers = _ref4.headers,
	            config = _ref4.config;
	
	        $scope.changeStatus(status);
	      }), $http.post('/api/fetch-lawyer-selectivity', {
	        id: $scope.selectedLawyer.lawyer_ID
	      }, {
	        contentType: 'application/json'
	      }).then(function (_ref5) {
	        var data = _ref5.data,
	            status = _ref5.status,
	            headers = _ref5.headers,
	            config = _ref5.config;
	
	        $scope.lawyerSelectivity = data;
	      }, function (_ref6) {
	        var data = _ref6.data,
	            status = _ref6.status,
	            headers = _ref6.headers,
	            config = _ref6.config;
	
	        $scope.changeStatus(status);
	      }), $http.post('/api/fetch-lawyer-preferences-flag', {
	        userId: $scope.selectedLawyer.userUserID
	      }).then(function (data) {
	        $scope.lawyerPreferencesFlag = data.showPreferencesWizard;
	      }, function (_ref7) {
	        var error = _ref7.error,
	            status = _ref7.status;
	
	        $scope.changeStatus(status);
	      })]).then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return fetchAllConsultants();
	
	              case 2:
	                $scope.initializeModal();
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      })));
	    }
	  };
	
	  $scope.resetData = function () {
	    $scope.modalFirms.forEach(function (firm, index, array) {
	      firm.isApproved = false;
	    });
	    $scope.modalCategories.forEach(function (category, index, array) {
	      category.isApproved = false;
	    });
	  };
	
	  $scope.tempDataValues = {
	    categories: [],
	    lawyer: {},
	    blockFirms: []
	  };
	
	  $scope.initializeModal = function () {
	    var modalInstance = void 0;
	    $scope.dataValues.lawyer = angular.copy($scope.selectedLawyer);
	    $scope.tempDataValues.lawyer = angular.copy($scope.selectedLawyer);
	    $scope.tempDataValues.lawyerPreferencesFlag = $scope.lawyerPreferencesFlag;
	    $scope.modalFirms.forEach(function (firm, index, array) {
	      $scope.blockFirms.forEach(function (block_firm, index, array) {
	        if (firm.firm_ID === block_firm.firmFirmID && block_firm.isApproved === true) {
	          firm.isApproved = true;
	        }
	      });
	    });
	    $scope.tempDataValues.selectivity = [];
	    var temporarySelectivity = angular.copy($scope.refSelectivities);
	    temporarySelectivity.forEach(function (selectivity) {
	      $scope.lawyerSelectivity.forEach(function (lawyerSelectivity) {
	        if (selectivity.selectivity_ID === lawyerSelectivity.selectivity_ID) selectivity.isSelected = true;
	      });
	      $scope.tempDataValues.selectivity.push(selectivity);
	    });
	    $scope.dataValues.blockFirms = $scope.modalFirms;
	    $scope.tempDataValues.blockFirms = angular.copy($scope.modalFirms);
	    $scope.lawyerCategories.forEach(function (lawyer_category, index, array) {
	      $scope.modalCategories.forEach(function (category, index, array) {
	        if (category.cat_ID === lawyer_category.refCategoryCatID && lawyer_category.isApproved) {
	          category.isApproved = true;
	        }
	      });
	    });
	    $scope.dataValues.categories = $scope.modalCategories;
	    $scope.tempDataValues.categories = angular.copy($scope.modalCategories);
	    $scope.tempDataValues.lawyer.PQE_Date = $scope.tempDataValues.lawyer.PQE;
	    $scope.tempDataValues.allConsultants = $scope.allConsultants;
	
	    $scope.stopSpin('spinner-' + $scope.selectedLawyer.lawyer_ID);
	
	    modalInstance = $modal.open({
	      templateUrl: 'myModalContent.html',
	      controller: 'EditCandidateCtrl',
	      resolve: {
	        data: function data() {
	          return $scope.tempDataValues;
	        }
	      }
	    });
	    modalInstance.result.then(function (updatedData) {
	      $scope.startSpin('spinner-' + $scope.selectedLawyer.lawyer_ID);
	
	      if (updatedData.categories) {
	        updatedData.categories.forEach(function (cat) {
	          $scope.refEmployerTypes.forEach(function (empCat) {
	            if (cat.cat_ID === empCat.value) {
	              empCat.isSelected = cat.isApproved;
	              empCat.originalSelection = cat.isApproved;
	            }
	          });
	        });
	      }
	
	      updatedData.lawyer.PQE = updatedData.lawyer.PQE_Date;
	      $scope.selectedLawyer = updatedData.lawyer;
	
	      $http.post('/api/edit-lawyer', updatedData).then(function (_ref9) {
	        var data = _ref9.data,
	            status = _ref9.status,
	            headers = _ref9.headers,
	            config = _ref9.config;
	
	        $scope.successCallBack({ updatedData: updatedData, data: data });
	      }, function (_ref10) {
	        var data = _ref10.data,
	            status = _ref10.status,
	            headers = _ref10.headers,
	            config = _ref10.config;
	      });
	    }, function () {
	      $scope.resetData();
	      $scope.dataValues = '';
	    });
	  };
	};
	
	exports.editLawyerController = editLawyerController;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _controller = __webpack_require__(629);
	
	// <edit-lawyer-pop-up user_id="loggedInLawyer.user.user_ID" lawyer-id="loggedInLawyer.lawyer.lawyer_ID" logged-in-lawyer="loggedInLawyer" modal-firms="modalFirms" ref-selectivities="refSelectivities"
	//                 modal-categories="modalCategories" ref-employer-types="refEmployerTypes" is-lawyers-action-allowed-to-view="isLawyersActionAllowedToView"
	//                 success-call-back="callBackForLawyerEditPopup(updatedData,data)"></edit-lawyer-pop-up>
	
	var editLawyerPopUp = function editLawyerPopUp() {
	
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      userId: '=',
	      lawyerId: '=',
	      loggedInLawyer: '=',
	      modalFirms: '=',
	      refSelectivities: '=',
	      modalCategories: '=',
	      refEmployerTypes: '=',
	      currentPageItems: '=',
	      isLawyersActionAllowedToView: '=',
	      successCallBack: '&'
	    },
	    controller: _controller.editLawyerController,
	    template: __webpack_require__(440)
	  };
	};
	
	angular.module('app.directives').directive('editLawyerPopUp', editLawyerPopUp);

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	'use strict';
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('AddAgGridFiltersController', ['filterOptions', 'gridOptions', 'logger', '$uibModalInstance', '$rootScope', 'GridApi', function controller(filterOptions, gridOptions, logger, $uibModalInstance, $rootScope, GridApi) {
	    var vm = this;
	    vm.filterOptions = filterOptions;
	    vm.gridOptions = gridOptions;
	    vm.filterSwitch = { filter: false };
	
	    vm.cancel = function () {
	      $uibModalInstance.dismiss('cancel');
	    };
	
	    vm.saveFilter = function (filterName) {
	      var filterOptionsSelected = false;
	      if (vm.filterOptions.saveFilter || vm.filterOptions.saveColumnSetting || vm.filterOptions.currentPositionInGrid || vm.filterOptions.sorting) filterOptionsSelected = true;
	      if (!filterName) {
	        logger.notify('warning', 'A Saved View name is required to save the filter');
	        return false;
	      }
	
	      if (!filterOptionsSelected) {
	        logger.notify('warning', 'Please select at least one filter options!');
	        return false;
	      }
	
	      vm.saveAgGridFilter(filterName);
	    };
	
	    vm.saveAgGridFilter = function (filterName) {
	      var view = {
	        filter: vm.filterOptions.saveFilter ? vm.gridOptions.api.getFilterModel() : undefined,
	        columnState: vm.filterOptions.saveColumnSetting ? {
	          state: vm.gridOptions.columnApi.getColumnState(),
	          group: vm.gridOptions.columnApi.getColumnGroupState()
	        } : undefined,
	        sort: vm.filterOptions.sorting ? vm.gridOptions.api.getSortModel() : undefined,
	        index: vm.filterOptions.currentPositionInGrid ? Number((vm.gridOptions.api.getFirstDisplayedRow() + vm.gridOptions.api.getLastDisplayedRow()) / 2) : undefined
	      };
	
	      var newFilter = {
	        name: filterName,
	        isPublic: Boolean(vm.filterSwitch.filter),
	        userId: $rootScope.user.id,
	        gridId: vm.filterOptions.gridName,
	        filter: view
	      };
	
	      var onSaveSuccess = function onSaveSuccess(successResponse) {
	        Object.assign(newFilter, {
	          id: successResponse.data.id
	        });
	        logger.notify('success', 'New Saved View: \'' + newFilter.name + '\' created!');
	        $uibModalInstance.close(newFilter);
	      };
	
	      var onSaveFailure = function onSaveFailure(failureResponse) {
	        logger.notify('error', 'Save Current Views failed! <br/> Error Code: ' + failureResponse.statusText);
	      };
	
	      if (newFilter.filter === '{}') logger.notify('warning', 'Select one or more filters from grid before saving!');else {
	        GridApi.createGridFilter(newFilter).then(onSaveSuccess).catch(onSaveFailure);
	      }
	    };
	  }]);
	})();

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _addFilters = __webpack_require__(631);
	
	var addAgGridFilters = function addAgGridFilters() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    controller: _addFilters.AddAgGridFiltersController,
	    template: __webpack_require__(441)
	  };
	};
	
	angular.module('app.directives').directive('addAgGridFilters', addAgGridFilters);

/***/ }),
/* 633 */
/***/ (function(module, exports) {

	'use strict';
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('DeleteAgGridFiltersController', ['filter', 'type', '$uibModalInstance', 'logger', 'GridApi', function controller(filter, type, $uibModalInstance, logger, GridApi) {
	    var vm = this;
	    vm.filter = filter;
	    vm.type = type;
	
	    vm.cancel = function () {
	      $uibModalInstance.dismiss('cancel');
	    };
	
	    vm.confirmDelete = function () {
	      if (vm.filter.isPublic) {
	        if (vm.confirmationInput === 'DELETE') vm.removeSavedFilter(filter);else return logger.notify('warning', 'Wrong confirmation text');
	      } else vm.removeSavedFilter(vm.filter);
	    };
	
	    vm.removeSavedFilter = function (filter) {
	      var onDeleteSuccess = function onDeleteSuccess() {
	        logger.notify('success', 'Saved View \'' + filter.name + '\' has been deleted.');
	        $uibModalInstance.close(filter);
	      };
	
	      var onDeleteFailure = function onDeleteFailure(errorResponse) {
	        logger.notify('error', 'Saved View \'' + filter.name + '\' could NOT be deleted. <br/> Error Reason: ' + errorResponse.statusText);
	      };
	
	      GridApi.deleteGridFilterById(vm.filter.id).then(onDeleteSuccess).catch(onDeleteFailure);
	    };
	  }]);
	})();

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _deleteFilters = __webpack_require__(633);
	
	var deleteAgGridFilters = function deleteAgGridFilters() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    controller: _deleteFilters.DeleteAgGridFiltersController,
	    template: __webpack_require__(442)
	  };
	};
	
	angular.module('app.directives').directive('deleteAgGridFilters', deleteAgGridFilters);

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var AgGridFiltersController = exports.AgGridFiltersController = function AgGridFiltersController($scope, $uibModal, $log, logger, $rootScope, GridApi) {
	  $scope.openSaveFilterModal = function () {
	    $scope.filterOptions = {
	      saveFilter: $scope.gridName !== 'MatchingLawyers',
	      saveColumnSetting: true,
	      currentPositionInGrid: true,
	      sorting: true,
	      gridName: $scope.gridName
	    };
	
	    var saveRulesModalInstance = $uibModal.open({
	      templateUrl: 'add-filters-modal.html',
	      windowClass: 'builder-save-dialog', // This property adds the class "builder-save-dialog" to the modal container
	      controller: 'AddAgGridFiltersController',
	      controllerAs: 'ctrl',
	      resolve: {
	        filterOptions: function filterOptions() {
	          return $scope.filterOptions;
	        },
	        gridOptions: function gridOptions() {
	          return $scope.gridOptions;
	        }
	      }
	    });
	    saveRulesModalInstance.result.then(function (newFilter) {
	      $scope.savedFilters.push(newFilter);
	    }, function () {
	      return errorHandler;
	    });
	  };
	
	  var errorHandler = function errorHandler(errorResponse) {
	    return $log.info('An Error occurred while trying to make an API call. Please find further details in this object:', errorResponse);
	  };
	
	  $scope.setFilter = function (selectedFilter) {
	    $scope.setFilterOnGrid({ selectedFilter: selectedFilter });
	  };
	
	  $scope.setDefaultViewFilter = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(filter, isDefault, event) {
	      var payload, _ref2, status;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              event.stopPropagation();
	              payload = {
	                filterId: filter.id,
	                gridId: $scope.gridName,
	                isDeleted: !isDefault
	              };
	
	
	              $scope.savedFilters.map(function (row) {
	                row.default = false;
	                return row;
	              });
	              _context.prev = 3;
	              _context.next = 6;
	              return GridApi.editDefaultGridFilter($rootScope.user.id, payload);
	
	            case 6:
	              _ref2 = _context.sent;
	              status = _ref2.status;
	
	              if (status === 200) {
	                if (isDefault) {
	                  logger.notify('success', 'New Default View created!');
	                  $scope.savedFilters.find(function (row) {
	                    return row.id === filter.id;
	                  }).default = isDefault;
	                  $scope.$apply();
	                } else logger.notify('success', 'Removed Default View !');
	              }
	              _context.next = 14;
	              break;
	
	            case 11:
	              _context.prev = 11;
	              _context.t0 = _context['catch'](3);
	
	              errorHandler(_context.t0);
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[3, 11]]);
	    }));
	
	    return function (_x, _x2, _x3) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  $scope.expandCollapseGrid = function () {
	    if ($scope.gridOptions.groupDefaultExpanded < 2) {
	      $scope.gridOptions.api.collapseAll();
	      $scope.gridOptions.groupDefaultExpanded = 2;
	    } else if ($scope.gridOptions.groupDefaultExpanded === 2) {
	      $scope.gridOptions.groupDefaultExpanded = -1;
	      $scope.gridOptions.api.expandAll();
	    }
	  };
	
	  $scope.resetColumnGrid = function () {
	    $scope.gridOptions.columnApi.setColumnState($scope.getColumnStateValue);
	  };
	
	  $scope.openDeleteFilterModal = function (_type, _filter, event) {
	    event.stopPropagation();
	    if (_filter.isPublic) {
	      logger.notify('warning', 'Are you sure you want to delete this Saved View?');
	    }
	
	    var deleteModalInstance = $uibModal.open({
	      templateUrl: 'delete-filters-modal.html',
	      controller: 'DeleteAgGridFiltersController',
	      controllerAs: 'ctrl',
	      resolve: {
	        filter: function filter() {
	          return _filter;
	        },
	        type: function type() {
	          return _type;
	        }
	      }
	    });
	    deleteModalInstance.result.then(function () {
	      $scope.savedFilters.splice(_.findIndex($scope.savedFilters, _filter), 1);
	    }, function () {});
	  };
	};

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _filters = __webpack_require__(635);
	
	var agGridFilters = function agGridFilters() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      gridOptions: '=',
	      getColumnStateValue: '=',
	      savedFilters: '=',
	      setFilterOnGrid: '&',
	      gridName: '='
	    },
	    controller: _filters.AgGridFiltersController,
	    template: __webpack_require__(443)
	  };
	};
	
	angular.module('app.directives').directive('agGridFilters', agGridFilters);

/***/ }),
/* 637 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.api').factory('GridApi', ['api', function GridApi(api) {
	  var gridApi = {
	    createGridFilter: function createGridFilter(payload) {
	      return api.post('grid-filters', payload);
	    },
	
	    getGridFilterById: function getGridFilterById(id) {
	      return api.get('grid-filters/' + id);
	    },
	
	    updateGridFilterById: function updateGridFilterById(id, payload) {
	      return api.put('grid-filters/' + id, payload);
	    },
	    deleteGridFilterById: function deleteGridFilterById(id) {
	      return api.delete('grid-filters/' + id);
	    },
	
	    getFiltersByGridId: function getFiltersByGridId(id) {
	      return api.get('grids/' + id + '/filters');
	    },
	
	    getSharedFiltersByGridIdAndPrivateFiltersByUserId: function getSharedFiltersByGridIdAndPrivateFiltersByUserId(gridId, userId) {
	      return api.get('grids/' + gridId + '/filters/users/' + userId);
	    },
	    getFiltersByUserId: function getFiltersByUserId(id) {
	      return api.get('users/' + id + '/filters');
	    },
	    editDefaultGridFilter: function editDefaultGridFilter(id, payload) {
	      return api.put('users/' + id + '/filters', payload);
	    }
	  };
	  return gridApi;
	}]);

/***/ }),
/* 638 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/* eslint-disable angular/window-service */
	/* eslint-disable angular/document-service */
	var agGridListingController = exports.agGridListingController = function agGridListingController($scope, userService, $uibModal, accountPermission, $timeout, GridApi, practiceAreaService, $rootScope) {
	  agGrid.LicenseManager.setLicenseKey('LexStep_Ltd_LEXSTEP__1Devs21_August_2020__MTU5Nzk2NDQwMDAwMA==ccf6c50aaa7d5ba943262bab558d1876');
	
	  $scope.gridOptions.floatingFilter = false;
	  function setGridSize() {
	    var pageHeight = $scope.innerHeight ? $scope.innerHeight - 100 : window.innerHeight;
	    var agGridListingDiv = document.querySelector('#' + $scope.gridName);
	    agGridListingDiv.style.width = '100%';
	    agGridListingDiv.style.height = pageHeight - 235 + 'px';
	  }
	
	  $scope.clearSelection = function () {
	    $scope.gridOptions.api.deselectAll();
	  };
	
	  $scope.applyFavRules = function (rule) {
	    if (rule.isDefault) {
	      var filter = $scope.gridOptions.api.getFilterModel();
	      var viewFilter = JSON.parse(rule.filter);
	      rule.isApplied = !rule.isApplied;
	      switch ($scope.gridName) {
	        case 'position':
	          positionListingFilter(rule, filter, viewFilter);
	          break;
	        case 'candidate':
	          candidateListingFilter(rule, filter, viewFilter);
	          break;
	        case 'application':
	          applicationListingFilter(rule, filter, viewFilter);
	          break;
	        case 'referral':
	          break;
	        case 'employer':
	          employerListingFilter(rule, filter, viewFilter);
	          break;
	        case 'recommendation':
	          recommendationListingFilter(rule, filter, viewFilter);
	          break;
	        default:
	          break;
	      }
	
	      $scope.gridOptions.api.setFilterModel(filter);
	    } else {
	      $scope.setFilterOnGrid(rule);
	    }
	
	    $scope.$applyAsync();
	  };
	
	  $scope.resetSearchFilter = function () {
	    document.querySelector('#filter-text-box').value = '';
	    $scope.gridOptions.api.setQuickFilter();
	
	    $scope.groupList.map(function (item) {
	      if (item.isHidden === false && item.parentID !== 'ROOT_NODE_ID') item.isHidden = true;
	      return item;
	    });
	    var elements = document.querySelectorAll('.active');[].forEach.call(elements, function (element) {
	      element.classList.remove('active');
	    });
	  };
	
	  $scope.resetOnlyFilter = function () {
	    $scope.gridOptions.api.setSortModel([]);
	    $scope.gridOptions.api.setFilterModel([]);
	    $scope.savedFilters.map(function (row) {
	      row.isApplied = false;
	      return row;
	    });
	    $scope.groupList.map(function (item) {
	      if (item.isHidden === false && item.parentID !== 'ROOT_NODE_ID') item.isHidden = true;
	      return item;
	    });
	    var elements = document.querySelectorAll('.active');[].forEach.call(elements, function (element) {
	      element.classList.remove('active');
	    });
	    $scope.$broadcast('ag-grid-reset-filters');
	  };
	
	  $scope.resetAllFilter = function () {
	    $scope.gridOptions.api.deselectAll();
	    $scope.gridOptions.columnApi.resetColumnGroupState();
	    $scope.gridOptions.api.setSortModel([]);
	    $scope.gridOptions.api.ensureIndexVisible(0, 'top');
	    $scope.savedFilters.map(function (row) {
	      row.isApplied = false;
	      return row;
	    });
	    $scope.gridOptions.api.setFilterModel([]);
	    document.querySelector('#filter-text-box').value = '';
	    $scope.gridOptions.api.setQuickFilter(document.querySelector('#filter-text-box').value);
	    $scope.groupList.map(function (item) {
	      if (item.isHidden === false && item.parentID !== 'ROOT_NODE_ID') item.isHidden = true;
	      return item;
	    });
	    var elements = document.querySelectorAll('.active');[].forEach.call(elements, function (element) {
	      element.classList.remove('active');
	    });
	    $scope.$broadcast('ag-grid-reset-filters');
	  };
	
	  $scope.setFilterOnGrid = function (selectedFilter) {
	    if (selectedFilter.isApplied) {
	      selectedFilter.isApplied = false;
	      $scope.gridOptions.columnApi.setColumnState($scope.getColumnStateValue);
	      $scope.gridOptions.columnApi.resetColumnGroupState();
	      $scope.gridOptions.api.setSortModel([]);
	      $scope.gridOptions.api.ensureIndexVisible(0, 'top');
	      $scope.savedFilters.map(function (row) {
	        row.isApplied = false;
	        return row;
	      });
	      if ($scope.gridName !== 'MatchingLawyers') $scope.gridOptions.api.setFilterModel([]);
	      document.querySelector('#filter-text-box').value = '';
	      $scope.gridOptions.api.setQuickFilter();
	      $scope.groupList.map(function (item) {
	        if (item.isHidden === false && item.parentID !== 'ROOT_NODE_ID') item.isHidden = true;
	        return item;
	      });
	      var elements = document.querySelectorAll('.active');[].forEach.call(elements, function (element) {
	        element.classList.remove('active');
	      });
	      // $scope.$broadcast('ag-grid-reset-filters')
	    } else {
	      $scope.savedFilters.map(function (row) {
	        row.isApplied = false;
	        return row;
	      });
	      selectedFilter.isApplied = true;
	      var view = selectedFilter.filter;
	      if (view.columnState) {
	        if (view.columnState.group) {
	          $scope.gridOptions.columnApi.setColumnState(view.columnState.state);
	          $scope.gridOptions.columnApi.setColumnGroupState(view.columnState.group);
	        } else $scope.gridOptions.columnApi.setColumnState(view.columnState);
	      }
	
	      if (view.sort) $scope.gridOptions.api.setSortModel(view.sort);
	      if (view.filter) $scope.gridOptions.api.setFilterModel(view.filter);
	      if (Number(view.index) > 1) $scope.gridOptions.api.ensureIndexVisible(Math.round(view.index), 'middle');
	    }
	  };
	
	  $scope.cvClose = function () {
	    $scope.halfGrid({ value: false });
	  };
	
	  $scope.downloadCV = function (path, applicationId) {
	    var a = document.createElement('a');
	    document.body.append(a);
	    a.style = 'display: none';
	    a.href = path;
	    a.download = 'application-' + applicationId;
	    a.click();
	  };
	
	  $scope.onFilterTextBoxChanged = function () {
	    var searchField = document.querySelector('#filter-text-box').value;
	    $scope.gridOptions.api.setQuickFilter(searchField);
	  };
	
	  $scope.openHelp = function () {
	    $uibModal.open({
	      templateUrl: 'help-modal.html',
	      controller: 'HelpModalController',
	      controllerAs: 'ctrl',
	      resolve: {
	        helpModal: function helpModal() {
	          return $scope.helpTooltip;
	        }
	      }
	    });
	  };
	
	  $scope.successCallBack = function (list, updateStageOnGrid) {
	    $scope.updateDropDownStages({ list: list, updateStageOnGrid: updateStageOnGrid });
	  };
	
	  var getRulesSavedByUsers = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(user) {
	      var prepareSavedFiltersUI;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              prepareSavedFiltersUI = function prepareSavedFiltersUI(savedFiltersResponse) {
	                $scope.savedFilters = savedFiltersResponse.data.length > 0 ? savedFiltersResponse.data[0].gridFilters : [];
	                setSavedFilter($scope.savedFilters, $scope.gridName, user);
	                var defaultFilter = $scope.savedFilters.find(function (x) {
	                  return x.default === true;
	                });
	                $rootScope.$on('listing-loaded', function (_event) {
	                  if (defaultFilter) displayDefaultView(defaultFilter);
	                  $scope.$apply();
	                });
	              };
	
	              GridApi.getSharedFiltersByGridIdAndPrivateFiltersByUserId($scope.gridName, user.id).then(prepareSavedFiltersUI).catch();
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function getRulesSavedByUsers(_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var displayDefaultView = function displayDefaultView(defaultFilter) {
	    defaultFilter.isApplied = true;
	    var view = defaultFilter.filter;
	    if (view.columnState) {
	      if (view.columnState.group) {
	        $scope.gridOptions.columnApi.setColumnState(view.columnState.state);
	        $scope.gridOptions.columnApi.setColumnGroupState(view.columnState.group);
	      } else $scope.gridOptions.columnApi.setColumnState(view.columnState);
	    }
	
	    if (view.sort) $scope.gridOptions.api.setSortModel(view.sort);
	    if (view.filter) $scope.gridOptions.api.setFilterModel(view.filter);
	    if (Number(view.index) > 1) $scope.gridOptions.api.ensureIndexVisible(Math.round(view.index), 'middle');
	    $scope.$applyAsync();
	  };
	
	  $scope.gridOnChangePracticeArea = function (event, selectedPracticeArea) {
	    if (event) {
	      event.stopPropagation();
	    } else {
	      var currentActiveFilters = $scope.gridOptions.api.getFilterModel();
	      var onlyChildrenPractices = practiceAreaService.onlyChildrenPractices($scope.gridActionsDirective.practices.allPracticeAreaList, []);
	      selectedPracticeArea = selectedPracticeArea.map(function (practiceArea) {
	        return practiceArea.name;
	      });
	      if (onlyChildrenPractices.length === selectedPracticeArea.length) {
	        if ($scope.gridName === 'position') delete currentActiveFilters.specialtiesName;else delete currentActiveFilters.legalCandidatePracticeAreas;
	        $scope.gridOptions.api.setFilterModel(currentActiveFilters);
	        $scope.$applyAsync();
	      } else {
	        if ($scope.gridName === 'position') currentActiveFilters.specialtiesName = {
	          values: selectedPracticeArea,
	          filterType: 'set'
	        };else currentActiveFilters.legalCandidatePracticeAreas = {
	          values: selectedPracticeArea,
	          filterType: 'set'
	        };
	        $scope.gridOptions.api.setFilterModel(currentActiveFilters);
	        $scope.$applyAsync();
	      }
	    }
	  };
	
	  var applicationColumnFields = ['position.type', 'position.rPQE', 'id', 'parentApplicationStage', 'applicationStage', 'status', 'isOffPlatform'];
	
	  $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	    var agGridListingDiv, columnStateValue;
	    return regeneratorRuntime.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return userService.getUser();
	
	          case 2:
	            $scope.user = _context2.sent;
	
	            getRulesSavedByUsers($scope.user);
	            agGridListingDiv = document.querySelector('#' + $scope.gridName);
	            // eslint-disable-next-line no-new
	
	            new agGrid.Grid(agGridListingDiv, $scope.gridOptions);
	            if ($scope.gridName === 'application') $scope.gridOptions.columnApi.autoSizeColumns(applicationColumnFields);
	            if ($scope.gridName === 'recommendation') $scope.gridOptions.columnApi.autoSizeColumns(['interest']);
	            setGridSize();
	            $scope.isApplicationStagesSettingAllowed = function () {
	              return $scope.user.roles.some(function (role) {
	                return role.id === 'admin' || role.id === 'ops';
	              });
	            };
	
	            columnStateValue = $scope.gridOptions.columnApi.getColumnState();
	
	            $scope.gridOptions.columnApi.getColumnGroupState();
	            $scope.getColumnStateValue = columnStateValue;
	
	          case 13:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  })), 100);
	};
	
	var setSavedFilter = function setSavedFilter(filters, gridName, user) {
	  switch (gridName) {
	    case 'position':
	      filters.unshift({
	        name: 'My Employers',
	        isDefault: true,
	        gridId: gridName,
	        filter: '{"employerAgentEmail":{"values":["' + user.email + '"],"filterType":"set"}}',
	        icon: '/images/myemployers.svg'
	      }, {
	        name: 'Private Practice',
	        isDefault: true,
	        filter: '{"employerType":{"values":["Private Practice"],"filterType":"set"}}',
	        showOnDropdown: true
	      }, {
	        name: 'In-House',
	        isDefault: true,
	        filter: '{"employerType":{"values":["In-House"],"filterType":"set"}}',
	        showOnDropdown: true
	      });
	      break;
	    case 'candidate':
	    case 'recommendation':
	      filters.unshift({
	        name: 'My Candidates',
	        isDefault: true,
	        gridId: gridName,
	        filter: '{"candidateAgentEmail":{"values":["' + user.email + '"],"filterType":"set"}}',
	        icon: '/images/mycandidate.svg'
	      });
	      break;
	    case 'employer':
	      filters.unshift({
	        name: 'My Employers',
	        isDefault: true,
	        gridId: gridName,
	        filter: '{"employerAgentEmail":{"values":["' + user.email + '"],"filterType":"set"}}',
	        icon: '/images/myemployers.svg'
	      });
	      break;
	
	    case 'application':
	      filters.unshift({
	        name: 'My Candidates',
	        isDefault: true,
	        gridId: gridName,
	        filter: '{"candidateAgentEmail":{"values":["' + user.email + '"],"filterType":"set"}}',
	        icon: '/images/mycandidate.svg'
	      }, {
	        name: 'My Employers',
	        isDefault: true,
	        gridId: gridName,
	        filter: '{"employerAgentEmail":{"values":["' + user.email + '"],"filterType":"set"}}',
	        icon: '/images/myemployers.svg'
	      });
	      break;
	    default:
	      break;
	  }
	};
	
	var positionListingFilter = function positionListingFilter(rule, filter, viewFilter) {
	  switch (rule.isApplied) {
	    case true:
	      if (viewFilter.employerAgentEmail) filter.employerAgentEmail = viewFilter.employerAgentEmail;
	      if (viewFilter.employerType) {
	        if (filter.employerType) viewFilter.employerType.values.push(filter.employerType.values[0]);
	        filter.employerType = viewFilter.employerType;
	      }
	
	      break;
	
	    default:
	      if (viewFilter.employerAgentEmail) delete filter.employerAgentEmail;
	      if (viewFilter.employerType) {
	        if (filter.employerType && filter.employerType.values.length > 1) {
	          filter.employerType = filter.employerType.values.filter(function (type) {
	            return type !== viewFilter.employerType.values[0];
	          });
	        } else delete filter.employerType;
	      }
	
	      break;
	  }
	};
	
	var candidateListingFilter = function candidateListingFilter(rule, filter, viewFilter) {
	  switch (rule.isApplied) {
	    case true:
	      if (viewFilter.candidateAgentEmail) filter.candidateAgentEmail = viewFilter.candidateAgentEmail;
	
	      break;
	
	    default:
	      if (viewFilter.candidateAgentEmail) delete filter.candidateAgentEmail;
	
	      break;
	  }
	};
	
	var recommendationListingFilter = function recommendationListingFilter(rule, filter, viewFilter) {
	  switch (rule.isApplied) {
	    case true:
	      if (viewFilter.candidateAgentEmail) filter.candidateAgentEmail = viewFilter.candidateAgentEmail;
	
	      break;
	
	    default:
	      if (viewFilter.candidateAgentEmail) delete filter.candidateAgentEmail;
	
	      break;
	  }
	};
	
	var applicationListingFilter = function applicationListingFilter(rule, filter, viewFilter) {
	  switch (rule.isApplied) {
	    case true:
	      if (viewFilter.employerAgentEmail) filter.employerAgentEmail = viewFilter.employerAgentEmail;
	      if (viewFilter.candidateAgentEmail) filter.candidateAgentEmail = viewFilter.candidateAgentEmail;
	      break;
	
	    default:
	      if (viewFilter.employerAgentEmail) delete filter.employerAgentEmail;
	      if (viewFilter.candidateAgentEmail) delete filter.candidateAgentEmail;
	      break;
	  }
	};
	
	var employerListingFilter = function employerListingFilter(rule, filter, viewFilter) {
	  switch (rule.isApplied) {
	    case true:
	      if (viewFilter.employerAgentEmail) filter.employerAgentEmail = viewFilter.employerAgentEmail;
	      break;
	
	    default:
	      if (viewFilter.employerAgentEmail) delete filter.employerAgentEmail;
	      break;
	  }
	};

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _agGridListing = __webpack_require__(638);
	
	var agGridListing = function agGridListing() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      gridName: '=',
	      gridOptions: '=',
	      helpTooltip: '=',
	      filterCount: '=',
	      gridActionsDirective: '=',
	      activeActions: '=',
	      actionsFunctions: '=',
	      gridDataActions: '=',
	      multipleSelectionActions: '=',
	      multiSelectOptions: '=',
	      groupList: '=',
	      isAllowedAgent: '=',
	      showCv: '=',
	      halfGrid: '&',
	      hierarchialApplicationStages: '=',
	      allApplicationStagesList: '=',
	      updateDropDownStages: '&',
	      innerHeight: '='
	    },
	    controller: _agGridListing.agGridListingController,
	    template: __webpack_require__(444)
	  };
	};
	
	angular.module('app.directives').directive('agGridListing', agGridListing);

/***/ }),
/* 640 */
/***/ (function(module, exports) {

	'use strict';
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('HelpModalController', ['$uibModalInstance', 'helpModal', function controller($uibModalInstance, helpModal) {
	    var vm = this;
	    vm.helpModal = helpModal;
	    vm.cancel = function () {
	      $uibModalInstance.dismiss('cancel');
	    };
	  }]);
	})();

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _helpModal = __webpack_require__(640);
	
	var helpModal = function helpModal() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    controller: _helpModal.HelpModalController,
	    template: __webpack_require__(445)
	  };
	};
	
	angular.module('app.directives').directive('helpModal', helpModal);

/***/ }),
/* 642 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.api').factory('ApplicationAgentsApi', ['api', function ApplicationAgentsApi(api) {
	  var applicationAgentsApi = {
	    getApplicationFollowers: function getApplicationFollowers(id) {
	      return api.get('applications/' + id + '/followers');
	    },
	    getApplicationFollowerById: function getApplicationFollowerById(applicationId, userId) {
	      return api.get('applications/' + applicationId + '/followers/' + userId);
	    },
	    updateApplicationFollowers: function updateApplicationFollowers(id, payload) {
	      return api.put('applications/' + id + '/followers', payload);
	    },
	    deleteApplicationFollower: function deleteApplicationFollower(applicationId, userId, payload) {
	      return api.delete('applications/' + applicationId + '/followers/' + userId, payload);
	    },
	    followApplicationById: function followApplicationById(applicationId, userId, payload) {
	      return api.post('applications/' + applicationId + '/followers/' + userId, payload);
	    }
	  };
	  return applicationAgentsApi;
	}]);

/***/ }),
/* 643 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('ApplicationAgentController', ['$uibModalInstance', 'applicationId', 'consultant', 'ApplicationAgentsApi', 'logger', 'applicationAgent', 'agentsList', '$rootScope', function controller($uibModalInstance, applicationId, consultant, ApplicationAgentsApi, logger, applicationAgent, agentsList, $rootScope) {
	    var _this = this;
	
	    var vm = this;
	    $rootScope.$on('application-deleted', function (event, _ref) {
	      var applicationDeleted = _ref.applicationDeleted;
	
	      if (applicationId === applicationDeleted) {
	        logger.notify('error', 'Application Deleted by Other Admin');
	        $uibModalInstance.dismiss('cancel');
	      }
	    });
	    vm.applicationAgent = applicationAgent;
	    vm.agentsList = agentsList;
	    vm.applicationId = applicationId;
	    vm.consultant = consultant;
	    vm.agentsList = [{
	      id: 0,
	      name: 'Select None',
	      email: 'none',
	      ticked: !(vm.applicationAgent.length > 0)
	    }].concat(_toConsumableArray(vm.agentsList.map(function (agent) {
	      return agent.email === consultant.employerAgentEmail || agent.email === consultant.candidateAgentEmail ? undefined : {
	        id: agent.id,
	        name: agent.firstName + ' ' + agent.lastName,
	        email: agent.email,
	        ticked: Boolean(vm.applicationAgent.find(function (email) {
	          return email === agent.email;
	        }))
	      };
	    }))).filter(function (agent) {
	      return agent;
	    });
	
	    vm.cancel = function () {
	      $uibModalInstance.dismiss('cancel');
	    };
	
	    vm.selectedAgent = function (selectedAgent) {
	      vm.agentsList = selectedAgent.id === 0 ? vm.agentsList.map(function (agent) {
	        if (agent.id !== 0) agent.ticked = false;
	        return agent;
	      }) : vm.agentsList.map(function (agent) {
	        if (agent.id === 0) agent.ticked = false;
	        return agent;
	      });
	    };
	
	    vm.updateApplicationAgent = function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(selectedAgent) {
	        var userIds, selectedNone, oldAgentsId, payload, _ref5, status;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                userIds = selectedAgent.map(function (_ref3) {
	                  var id = _ref3.id;
	                  return id;
	                });
	                selectedNone = userIds.some(function (id) {
	                  return id === 0;
	                });
	                oldAgentsId = void 0;
	
	                if (selectedNone) oldAgentsId = vm.applicationAgent.map(function (agent) {
	                  return vm.agentsList.find(function (_ref4) {
	                    var email = _ref4.email;
	                    return email === agent;
	                  }).id;
	                });
	                payload = {
	                  userIds: selectedNone ? oldAgentsId : userIds,
	                  follow: !selectedNone
	                };
	                _context.prev = 5;
	                _context.next = 8;
	                return ApplicationAgentsApi.updateApplicationFollowers(vm.applicationId, payload);
	
	              case 8:
	                _ref5 = _context.sent;
	                status = _ref5.status;
	
	                if (status === 200) $uibModalInstance.close(selectedAgent);
	                _context.next = 17;
	                break;
	
	              case 13:
	                _context.prev = 13;
	                _context.t0 = _context['catch'](5);
	
	                logger.notify('error', _context.t0.data.message);
	                $uibModalInstance.close(false);
	
	              case 17:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[5, 13]]);
	      }));
	
	      return function (_x) {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	  }]);
	})();

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _applicationAgent = __webpack_require__(643);
	
	var applicationAgent = function applicationAgent() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    controller: _applicationAgent.ApplicationAgentController,
	    template: __webpack_require__(446)
	  };
	};
	
	angular.module('app.directives').directive('applicationAgent', applicationAgent);

/***/ }),
/* 645 */
/***/ (function(module, exports) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('ApplicationHistoryController', ['$uibModalInstance', 'applicationId', 'SharedApi', 'agentsList', 'isOffPlatform', 'isNote', 'stagesList', '$rootScope', 'logger', '$uibModal', '$scope', 'enableMasterGrid', 'NotesApi', function controller($uibModalInstance, applicationId, SharedApi, agentsList, isOffPlatform, isNote, stagesList, $rootScope, logger, $uibModal, $scope, enableMasterGrid, NotesApi) {
	    var _this = this;
	
	    var vm = this;
	    $rootScope.$on('application-deleted', function (event, _ref) {
	      var applicationDeleted = _ref.applicationDeleted;
	
	      if (applicationId === applicationDeleted) {
	        logger.notify('error', 'Application Deleted by Other Admin');
	        vm.close();
	      }
	    });
	
	    vm.applicationId = applicationId;
	    vm.agentsList = agentsList;
	    vm.isNote = isNote;
	    vm.enableMasterGrid = enableMasterGrid;
	    vm.stagesList = stagesList;
	    vm.source = isOffPlatform ? 'Off-Platform' : 'On-Platform';
	
	    vm.close = function () {
	      var latestNote = vm.allApplication.find(function (note) {
	        return note.isNote;
	      });
	      $uibModalInstance.close(latestNote ? latestNote.body : '');
	    };
	
	    vm.loadApplicationNoteAndHistory = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var _ref3, _ref4, applicationNotes, applicationActionHistory;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return Promise.all([NotesApi.getAllNotes({
	                application: [vm.applicationId]
	              }), SharedApi.getAllActions({
	                category: 'application',
	                target: vm.applicationId
	              })]);
	
	            case 2:
	              _ref3 = _context.sent;
	              _ref4 = _slicedToArray(_ref3, 2);
	              applicationNotes = _ref4[0].data;
	              applicationActionHistory = _ref4[1].data;
	
	
	              vm.applicationActionHistory = applicationActionHistory.map(function (history) {
	                var author = vm.agentsList.find(function (_ref5) {
	                  var id = _ref5.id;
	                  return id === history.authorId;
	                });
	
	                if (!history.payload) {
	                  history.payload = {};
	                }
	
	                var applicationAgent = history.typeId === 'APPLICATION_FOLLOW_UPDATE' && history.payload ? history.payload.userIds.map(function (user) {
	                  return vm.agentsList.find(function (_ref6) {
	                    var id = _ref6.id;
	                    return id === user;
	                  }).email;
	                }).join(' ,') : '';
	
	                history.payload.current = history.payload && history.payload.current ? Object.assign.apply(Object, [{}].concat(_toConsumableArray(Object.keys(history.payload.current).map(function (key) {
	                  if (key === 'stageId') history.payload.current[key] = vm.stagesList.find(function (_ref7) {
	                    var id = _ref7.id;
	                    return id === history.payload.current.stageId;
	                  }).name;
	                  return _defineProperty({}, key, history.payload.current[key]);
	                })))) : '';
	
	                history.payload.old = history.payload && history.payload.old ? Object.assign.apply(Object, [{}].concat(_toConsumableArray(Object.keys(history.payload.old).map(function (key) {
	                  if (key === 'stageId') history.payload.old[key] = vm.stagesList.find(function (_ref9) {
	                    var id = _ref9.id;
	                    return id === history.payload.old.stageId;
	                  }).name;
	                  return _defineProperty({}, key, history.payload.old[key]);
	                })))) : '';
	                var keyName = history.payload && history.payload.current ? Object.keys(history.payload.current).map(function (key) {
	                  var headerName = keyValue(key);
	                  return headerName;
	                }).filter(function (x) {
	                  return x;
	                }).join(' , ') : '';
	                return {
	                  payload: history.payload,
	                  keyName: keyName,
	                  current: history.payload && history.payload.current ? Object.values(history.payload.current).join(' ,') : '',
	                  old: history.payload && history.payload.old ? Object.values(history.payload.old).join(' ,') : '',
	                  created: history.created,
	                  typeId: history.typeId,
	                  applicationAgent: applicationAgent,
	                  author: author ? author.email : ''
	                };
	              });
	              vm.applicationNotes = applicationNotes.map(function (note) {
	                var author = vm.agentsList.find(function (_ref11) {
	                  var id = _ref11.id;
	                  return id === note.authorId;
	                });
	                return {
	                  id: note.id,
	                  isNote: true,
	                  body: note.body,
	                  created: note.created,
	                  author: author ? author.email : ''
	                };
	              });
	              vm.toggleHistory();
	
	            case 9:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    vm.toggleHistory = function () {
	      if (vm.isNote) {
	        vm.allApplication = [].concat(_toConsumableArray(vm.applicationActionHistory), _toConsumableArray(vm.applicationNotes)).filter(function (history) {
	          return history.isNote === true;
	        }).sort(function (a, b) {
	          return a.created < b.created ? 1 : -1;
	        });
	      } else vm.allApplication = [].concat(_toConsumableArray(vm.applicationActionHistory), _toConsumableArray(vm.applicationNotes)).sort(function (a, b) {
	        return a.created < b.created ? 1 : -1;
	      });
	    };
	
	    vm.editNote = function (history) {
	      history.temporaryNote = history.body;
	      history.isEditable = true;
	    };
	
	    vm.updateNote = function () {
	      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(history) {
	        var payload, _ref13, status;
	
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!(history.temporaryNote && history.temporaryNote !== '')) {
	                  _context2.next = 13;
	                  break;
	                }
	
	                _context2.prev = 1;
	                payload = {
	                  body: history.temporaryNote,
	                  authorId: $rootScope.user.id
	                };
	                _context2.next = 5;
	                return NotesApi.updateNote(history.id, payload);
	
	              case 5:
	                _ref13 = _context2.sent;
	                status = _ref13.status;
	
	                if (status === 200) {
	                  history.body = history.temporaryNote;
	                  history.isEditable = false;
	                  $scope.$apply();
	                  logger.notify('success', 'Internal Note updated successfully!');
	                }
	                _context2.next = 13;
	                break;
	
	              case 10:
	                _context2.prev = 10;
	                _context2.t0 = _context2['catch'](1);
	
	                logger.notify('error', _context2.t0.data.message);
	
	              case 13:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this, [[1, 10]]);
	      }));
	
	      return function (_x) {
	        return _ref12.apply(this, arguments);
	      };
	    }();
	
	    vm.createNote = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	      var payload, _ref15, data, status, newNote;
	
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              if (!(vm.newNote && vm.newNote !== '')) {
	                _context3.next = 14;
	                break;
	              }
	
	              payload = {
	                body: vm.newNote,
	                subject: 'Internal Note',
	                category: 'Comment',
	                applicationId: vm.applicationId,
	                authorId: $rootScope.user.id
	              };
	              _context3.prev = 2;
	              _context3.next = 5;
	              return NotesApi.createNote(payload);
	
	            case 5:
	              _ref15 = _context3.sent;
	              data = _ref15.data;
	              status = _ref15.status;
	
	              if (status === 201) {
	                vm.newNote = '';
	                newNote = {
	                  isNote: true,
	                  id: data.id,
	                  body: data.body,
	                  created: data.created,
	                  author: $rootScope.user ? $rootScope.user.email : ''
	                };
	
	                vm.applicationNotes.push(newNote);
	                vm.allApplication = [newNote].concat(_toConsumableArray(vm.allApplication));
	                $scope.$apply();
	                logger.notify('success', 'Internal Note added to Application');
	              } else {
	                logger.notify('error', 'Error occurred', status);
	              }
	              _context3.next = 14;
	              break;
	
	            case 11:
	              _context3.prev = 11;
	              _context3.t0 = _context3['catch'](2);
	
	              logger.notify('error', _context3.t0.data.message);
	
	            case 14:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this, [[2, 11]]);
	    }));
	
	    vm.discardNote = function (history) {
	      history.isEditable = false;
	    };
	
	    vm.deleteNoteModal = function (id) {
	      var deleteModalInstance = $uibModal.open({
	        templateUrl: 'delete-internal-note-modal.html',
	        controllerAs: 'deleteNoteCtrl',
	        controller: function controller() {
	          var vm = this;
	          vm.cancel = function () {
	            deleteModalInstance.dismiss('cancel');
	          };
	
	          vm.confirmDelete = function () {
	            deleteModalInstance.close();
	          };
	        }
	      });
	      deleteModalInstance.result.then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
	        var _ref17, status;
	
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.prev = 0;
	                _context4.next = 3;
	                return NotesApi.deleteNote(id);
	
	              case 3:
	                _ref17 = _context4.sent;
	                status = _ref17.status;
	
	                if (status === 200) {
	                  vm.applicationNotes = vm.applicationNotes.filter(function (note) {
	                    return note.id !== id;
	                  });
	                  vm.allApplication = vm.allApplication.filter(function (note) {
	                    return note.id !== id;
	                  });
	                  $scope.$apply();
	                  logger.notify('success', 'Internal Note deleted successfully!');
	                } else {
	                  logger.notify('error', 'Error occurred', status);
	                }
	                _context4.next = 11;
	                break;
	
	              case 8:
	                _context4.prev = 8;
	                _context4.t0 = _context4['catch'](0);
	
	                logger.notify('error', _context4.t0.data.message);
	
	              case 11:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this, [[0, 8]]);
	      })), function () {});
	    };
	
	    vm.loadApplicationNoteAndHistory();
	  }]);
	})();
	
	var keyValue = function keyValue(key) {
	  switch (key) {
	    case 'submittedAt':
	      return 'Submission Date';
	    case 'interview1Date':
	      return '1st Interview Date';
	    case 'interview2Date':
	      return '2nd Interview Date';
	    case 'interview3Date':
	      return '3rd Interview Date';
	    case 'offer':
	      return 'Offer {£ Value}';
	    case 'acceptedAt':
	      return 'Acceptance Date';
	    case 'startDate':
	      return 'Start Date';
	    case 'feedback':
	      return 'Feedback To Candidate';
	    case 'status':
	      return 'Status';
	    case 'stageId':
	      return 'Stage';
	    default:
	      break;
	  }
	};

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _applicationHistory = __webpack_require__(645);
	
	var applicationHistory = function applicationHistory() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    controller: _applicationHistory.ApplicationHistoryController,
	    template: __webpack_require__(447)
	  };
	};
	
	angular.module('app.directives').directive('applicationHistory', applicationHistory);

/***/ }),
/* 647 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.api').factory('ApplicationModalApi', ['api', function ApplicationModalApi(api) {
	  var _this = this;
	
	  var applicationModalApi = {
	    createApplication: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                return _context.abrupt('return', api.post('applications', payload));
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function createApplication(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return createApplication;
	    }()
	  };
	  return applicationModalApi;
	}]);

/***/ }),
/* 648 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/* eslint-disable camelcase */
	var applicationModalController = function applicationModalController($scope, $modal, logger, ApplicationModalApi, $rootScope) {
	  var modalInstance = void 0;
	
	  if ($scope.position.isApplied) $scope.position.tooltip = 'Already applied to position';else if ($scope.candidate.resumes.length === 0) $scope.position.tooltip = 'Upload your CV to apply.';else if ($scope.candidate.approvalStatus === 'Locked') $scope.position.tooltip = 'Your profile is locked, wait for reapproval to apply for jobs';else $scope.position.tooltip = undefined;
	
	  $scope.shareProfile = function (position, event) {
	    var resumes = $scope.candidate.resumes;
	
	    console.debug('resumes:', resumes);
	
	    var sortedResumes = resumes && resumes.length > 0 && resumes.filter(Boolean).sort(function (a, b) {
	      console.debug('sortedResumes', { a: a, b: b });
	      var x = Date.parse(a.created);
	      var y = Date.parse(b.created);
	      console.debug('sortedResumes', { x: x, y: y });
	
	      var tx = x && x.getTime && x.getTime();
	      var ty = y && y.getTime && y.getTime();
	
	      if (tx < ty) {
	        return -1;
	      }
	
	      if (tx > ty) {
	        return 1;
	      }
	
	      return 0;
	    });
	
	    var mostRecentResume = sortedResumes && sortedResumes.length > 0 ? sortedResumes[sortedResumes.length - 1] : undefined;
	
	    var modalData = {
	      position: $scope.position,
	      candidate: _.extend($scope.candidate, { resumes: sortedResumes }),
	      sponsorship: false,
	      resume: mostRecentResume && mostRecentResume.id
	    };
	    console.debug('applicationModalController::shareProfile:modalData', modalData);
	    $scope.modalData = modalData;
	
	    $scope.locationBackgroundColor = function (color) {
	      if (color) {
	        return {
	          background: color
	        };
	      }
	    };
	
	    event.preventDefault();
	    event.stopPropagation();
	
	    modalInstance = $modal.open({
	      backdrop: 'static',
	      templateUrl: 'application-modal.html',
	      scope: $scope,
	      resolve: {
	        data: function data() {
	          return $scope.modalData;
	        }
	      }
	    });
	
	    modalInstance.result.then(function (_selectedItem) {
	      $scope.position.isApplied = true;
	      $scope.position.appliedOffPlatform = true;
	      $scope.position.applicationDate = new Date();
	    }, function () {});
	  };
	
	  $scope.applyForApplication = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	    var application;
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            application = {
	              user: $scope.candidate.id,
	              position: $scope.position.id,
	              resume: $scope.modalData.resume,
	              isOffPlatform: !$scope.client,
	              sponsorship: $scope.modalData.sponsorship
	            };
	
	
	            try {
	              analytics.track('job - share profile', {
	                job_company: $scope.position.employer.name,
	                user_id: $scope.candidate.id,
	                job_id: $scope.position.id,
	                job_title: $scope.position.title,
	                currentEmployerName: $scope.candidate.employer.name,
	                currentEmployerId: $scope.candidate.employer.id,
	                current_emp: $scope.candidate.employer.name,
	                name: $scope.candidate.firstName + ' ' + $scope.candidate.lastName
	              });
	            } catch (error) {
	              console.error('analytics: job - share profile error', error);
	            }
	
	            _context.next = 4;
	            return ApplicationModalApi.createApplication(application).then(function () {
	              if ($scope.client) logger.notify('success', 'Thank you for your application. You can track the status of your applications on the Track page');
	            });
	
	          case 4:
	
	            console.debug('broadcasting application:created');
	            $rootScope.$broadcast('application:created');
	
	            modalInstance.close(application);
	
	          case 7:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  $scope.cancel = function () {
	    modalInstance.dismiss('cancel');
	  };
	};
	
	exports.applicationModalController = applicationModalController;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _applicationModalCtrl = __webpack_require__(648);
	
	var applicationModalDirective = function applicationModalDirective() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      candidate: '=',
	      position: '=',
	      client: '=',
	      user: '='
	    },
	    controller: _applicationModalCtrl.applicationModalController,
	    template: __webpack_require__(448)
	  };
	};
	
	angular.module('app.directives').directive('applicationModalDirective', applicationModalDirective);
	
	__webpack_require__(647);

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var applicationStagesSettingController = exports.applicationStagesSettingController = function applicationStagesSettingController($scope, $uibModal, $location, logger, ApplicationStagesApi, $timeout) {
	  var modalInstance;
	
	  $scope.openStageSettingModal = function () {
	    $scope.applicationStagesList = angular.copy($scope.hierarchialApplicationStages);
	    modalInstance = $uibModal.open({
	      animation: true,
	      templateUrl: 'application-stages-setting-modal.html',
	      windowClass: 'app-modal-window',
	      backdrop: 'static',
	      scope: $scope
	    });
	
	    return modalInstance.result;
	  };
	
	  $scope.expandStage = function (stage) {
	    stage.expand = !stage.expand;
	  };
	
	  $scope.onEditClick = function (stage) {
	    $scope.inputField = true;
	    stage.temporaryName = stage.name;
	    stage.temporaryIsDefault = stage.isDefault;
	    stage.temporaryColor = stage.color;
	    stage.isEditable = true;
	  };
	
	  $scope.onInputFieldCloseClick = function (stage) {
	    stage.newStage = false;
	    stage.isEditable = false;
	    $scope.inputField = false;
	  };
	
	  function makeDefault(selectedStage) {
	    if (selectedStage.isDefault) {
	      $scope.applicationStagesList.forEach(function (stage) {
	        if (stage.children) {
	          if (stage.children.length > 0) {
	            stage.children.forEach(function (subStage) {
	              if (subStage.id !== selectedStage.id) subStage.isDefault = false;
	            });
	          }
	        }
	      });
	    } else {
	      var isDefault = $scope.applicationStagesList.find(function (x) {
	        return x.children.find(function (child) {
	          return child.isDefault === true;
	        });
	      });
	      if (!isDefault || !(isDefault.children.length > 0)) $scope.applicationStagesList[0].children[0].isDefault = true;
	    }
	  }
	
	  function errorHandler(status) {
	    var USER_NOT_LOGGED_IN = 440;
	    var INTERNAL_SERVER_ERROR = 500;
	
	    if (Number(status) === USER_NOT_LOGGED_IN) $location.url('/signin');
	    if (Number(status) === INTERNAL_SERVER_ERROR) logger.notify('error', "Can't Delete Stage. Application Records exist in it!");else logger.notify('error', 'update Failed!');
	  }
	
	  $scope.updateStage = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(stage) {
	      var ifExist, payload, _ref2, status;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              $scope.inputField = false;
	
	              if (!(stage.temporaryName === '' || stage.temporaryName === null)) {
	                _context.next = 5;
	                break;
	              }
	
	              logger.notify('warning', 'Stage Name is empty');
	              _context.next = 16;
	              break;
	
	            case 5:
	              ifExist = nameAlreadyExist(stage.temporaryName, stage.id);
	
	              if (!(ifExist > 0)) {
	                _context.next = 10;
	                break;
	              }
	
	              logger.notify('warning', 'Name is Already Used');
	              _context.next = 16;
	              break;
	
	            case 10:
	              payload = {
	                name: stage.temporaryName,
	                color: stage.temporaryColor ? stage.temporaryColor : '#5e5e5e',
	                isDefault: stage.temporaryIsDefault
	              };
	              _context.next = 13;
	              return ApplicationStagesApi.updateApplicationStage(stage.id, payload);
	
	            case 13:
	              _ref2 = _context.sent;
	              status = _ref2.status;
	
	              if (status === 200) {
	                stage.isEditable = false;
	                stage.name = stage.temporaryName;
	                stage.isDefault = stage.temporaryIsDefault;
	                stage.color = stage.temporaryColor;
	                makeDefault(stage);
	                angular.copy($scope.applicationStagesList, $scope.hierarchialApplicationStages);
	                updateLinearApplication($scope.applicationStagesList, stage);
	                logger.notify('success', 'Stage Updated');
	                $scope.$apply();
	              } else errorHandler(status);
	
	            case 16:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  $scope.deleteStage = function (name, stage, list, index, event) {
	    if (name === 'parent') {
	      if (stage.children === undefined) {
	        deleteModal(event, stage, list, index);
	      } else if (stage.children.length > 0) {
	        logger.notify('warning', "Can't Delete Stage. Sub-stages exist in it.");
	      } else {
	        deleteModal(event, stage, list, index);
	      }
	    } else if (stage.isDefault === true) logger.notify('warning', "Can't Delete Default Sub-stage.");else deleteModal(event, stage, list, index);
	  };
	
	  var deleteModalInstance = void 0;
	  $scope.cancelDelete = function () {
	    deleteModalInstance.dismiss('cancel');
	  };
	
	  $scope.confirmDelete = function () {
	    return deleteModalInstance.close();
	  };
	  function deleteModal(event, stage, list, index) {
	    var _this = this;
	
	    event.stopPropagation();
	    deleteModalInstance = $uibModal.open({
	      templateUrl: 'deleteStageModal.html',
	      scope: $scope
	    });
	    deleteModalInstance.result.then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	      var _ref4, status;
	
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;
	              _context2.next = 3;
	              return ApplicationStagesApi.deleteApplicationStage(stage.id);
	
	            case 3:
	              _ref4 = _context2.sent;
	              status = _ref4.status;
	
	              if (status === 200) {
	                logger.notify('success', 'Stage Deleted');
	                list.splice(index, 1);
	                angular.copy($scope.applicationStagesList, $scope.hierarchialApplicationStages);
	                updateLinearApplication($scope.applicationStagesList);
	              } else errorHandler(status);
	              _context2.next = 11;
	              break;
	
	            case 8:
	              _context2.prev = 8;
	              _context2.t0 = _context2['catch'](0);
	
	              errorHandler(_context2.t0.status);
	
	            case 11:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this, [[0, 8]]);
	    })), function () {});
	  }
	
	  $scope.parentStage = {};
	  $scope.insertParentStage = function () {
	    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(stage) {
	      var parentStage, isNameExist, payload, _ref6, data, status;
	
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              parentStage = $scope.parentStage;
	
	              if (!(parentStage.name === '' || parentStage.name === null || parentStage.name === undefined)) {
	                _context3.next = 5;
	                break;
	              }
	
	              logger.notify('warning', 'Stage Name is empty');
	              _context3.next = 19;
	              break;
	
	            case 5:
	              isNameExist = nameAlreadyExist(parentStage.name);
	
	              if (!(isNameExist > 0)) {
	                _context3.next = 10;
	                break;
	              }
	
	              logger.notify('warning', 'Name is Already Used');
	              _context3.next = 19;
	              break;
	
	            case 10:
	              $scope.inputField = false;
	              stage.newStage = false;
	              payload = {
	                name: parentStage.name ? parentStage.name : '',
	                color: parentStage.color ? parentStage.color : '#5e5e5e',
	                isDefault: parentStage.isDefault ? 1 : 0,
	                order: $scope.applicationStagesList.length + 1
	              };
	              _context3.next = 15;
	              return ApplicationStagesApi.createApplicationStage(payload);
	
	            case 15:
	              _ref6 = _context3.sent;
	              data = _ref6.data;
	              status = _ref6.status;
	
	              if (status === 201) {
	                logger.notify('success', 'New Stage Added');
	
	                data.children = [];
	                $scope.hierarchialApplicationStages.push(data);
	                $scope.parentStage = {};
	                $scope.applicationStagesList = angular.copy($scope.hierarchialApplicationStages);
	                updateLinearApplication($scope.applicationStagesList, false);
	                angular.copy($scope.applicationStagesList, $scope.hierarchialApplicationStages);
	                $scope.$apply();
	              } else errorHandler(status);
	
	            case 19:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined);
	    }));
	
	    return function (_x2) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	
	  function nameAlreadyExist(name, id) {
	    var existingName = 0;
	    $scope.applicationStagesList.forEach(function (stage) {
	      if (stage.id !== id && stage.name.toLowerCase().localeCompare(name.toLowerCase()) === 0) {
	        existingName = 2;
	        return existingName;
	      }
	
	      if (stage.children) {
	        if (stage.children.length > 0) {
	          stage.children.forEach(function (subStage) {
	            if (subStage.id !== id && subStage.name.toLowerCase().localeCompare(name.toLowerCase()) === 0) {
	              existingName++;
	            }
	          });
	        }
	      }
	    });
	    return existingName;
	  }
	
	  $scope.insertSubStage = function () {
	    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(state, stage) {
	      var isNameExist, payload, _ref8, data, status;
	
	      return regeneratorRuntime.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              if (!(state.name === '' || state.name === null || state.name === undefined)) {
	                _context4.next = 4;
	                break;
	              }
	
	              logger.notify('warning', 'Stage Name is empty');
	              _context4.next = 17;
	              break;
	
	            case 4:
	              isNameExist = nameAlreadyExist(state.name, state.id);
	
	              if (!(isNameExist > 0)) {
	                _context4.next = 9;
	                break;
	              }
	
	              logger.notify('warning', 'Name is Already Used');
	              _context4.next = 17;
	              break;
	
	            case 9:
	              $scope.inputField = false;
	
	              payload = {
	                name: state.name,
	                color: state.color ? state.color : '#5e5e5e',
	                parentId: stage.id,
	                isDefault: state.isDefault ? 1 : 0,
	                order: stage.children.length
	              };
	              _context4.next = 13;
	              return ApplicationStagesApi.createApplicationStage(payload);
	
	            case 13:
	              _ref8 = _context4.sent;
	              data = _ref8.data;
	              status = _ref8.status;
	
	              if (status === 201) {
	                logger.notify('success', 'New Sub-Stage Added');
	                stage.newSubStage = false;
	                stage.children.pop();
	                data.displayIcon = false;
	                makeDefault(data);
	                stage.children.push(data);
	                updateLinearApplication($scope.applicationStagesList);
	                angular.copy($scope.applicationStagesList, $scope.hierarchialApplicationStages);
	                $scope.$apply();
	              }
	
	            case 17:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, undefined);
	    }));
	
	    return function (_x3, _x4) {
	      return _ref7.apply(this, arguments);
	    };
	  }();
	
	  function updateLinearApplication(applicationStagesList, updateStageOnGrid) {
	    var listAllStages = [];
	    applicationStagesList.forEach(function (stage) {
	      listAllStages = [].concat(_toConsumableArray(listAllStages), [stage]);
	      if (stage.children) {
	        if (stage.children.length > 0) {
	          stage.children.forEach(function (subStage) {
	            subStage.isHidden = true;
	            subStage.parentName = stage.name;
	            subStage.parentId = stage.id;
	            listAllStages.push(subStage);
	          });
	        }
	      }
	    });
	    $scope.successCallBack({ list: applicationStagesList, updateStageOnGrid: updateStageOnGrid });
	
	    $scope.allApplicationStages.length = 0;[].push.apply($scope.allApplicationStages, listAllStages);
	  }
	
	  $scope.inputField = false;
	  $scope.updateStagesOrder = function () {
	    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(stage) {
	      var payload, _ref10, data, status, _ref11, stages;
	
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              if (!$scope.inputField) {
	                _context5.next = 4;
	                break;
	              }
	
	              logger.notify('warning', ' Please Complete and Save the Changes');
	              _context5.next = 23;
	              break;
	
	            case 4:
	              payload = [];
	
	              stage.forEach(function (parent, stageIndex) {
	                payload.push({
	                  id: parent.id,
	                  order: stageIndex + 1,
	                  parentId: undefined
	                });
	                parent.children.forEach(function (child, subStageIndex) {
	                  if (child.id !== undefined) {
	                    payload.push({
	                      id: child.id,
	                      order: subStageIndex + 1,
	                      parentId: parent.id
	                    });
	                  }
	                });
	              });
	              _context5.next = 8;
	              return ApplicationStagesApi.updateApplicationStageOrder(payload);
	
	            case 8:
	              _ref10 = _context5.sent;
	              data = _ref10.data;
	              status = _ref10.status;
	
	              if (!(status === 200)) {
	                _context5.next = 22;
	                break;
	              }
	
	              logger.notify('success', data);
	              _context5.next = 15;
	              return ApplicationStagesApi.getAllApplicationStages({
	                hierarchy: true
	              });
	
	            case 15:
	              _ref11 = _context5.sent;
	              stages = _ref11.data;
	
	              angular.copy($scope.applicationStagesList, stages);
	              updateLinearApplication($scope.applicationStagesList);
	              modalInstance.dismiss('cancel');
	              _context5.next = 23;
	              break;
	
	            case 22:
	              errorHandler(status);
	
	            case 23:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, undefined);
	    }));
	
	    return function (_x5) {
	      return _ref9.apply(this, arguments);
	    };
	  }();
	
	  $scope.addNewSubStage = function (stage) {
	    var index = {};
	    $scope.inputField = true;
	    if (stage.children === undefined) {
	      stage.children = [];
	      stage.children.push(index);
	      stage.newSubStage = true;
	    } else {
	      stage.children.push(index);
	      stage.newSubStage = true;
	    }
	  };
	
	  $scope.addStageShow = function (parentStage) {
	    parentStage.newStage = true;
	    $scope.inputField = true;
	    $timeout(function () {
	      // eslint-disable-next-line angular/document-service
	      document.querySelector('#input-newParentStage').focus();
	    }, 50);
	  };
	
	  $scope.closeSubStage = function (stage) {
	    $scope.inputField = false;
	    stage.children.pop();
	    stage.newSubStage = false;
	  };
	
	  $scope.cancelModal = function () {
	    modalInstance.dismiss('cancel');
	  };
	
	  $scope.colorChildren = function (color) {
	    if (color) {
	      var faddedColor = hexToRGB(color, 0.1);
	      return {
	        background: faddedColor,
	        border: '1px solid ' + color
	      };
	    }
	  };
	};
	
	function hexToRGB(h, opacity) {
	  var r = 0;
	  var g = 0;
	  var b = 0;
	
	  // 3 digits
	  if (h.length === 4) {
	    r = '0x' + h[1] + h[1];
	    g = '0x' + h[2] + h[2];
	    b = '0x' + h[3] + h[3];
	
	    // 6 digits
	  } else if (h.length === 7) {
	    r = '0x' + h[1] + h[2];
	    g = '0x' + h[3] + h[4];
	    b = '0x' + h[5] + h[6];
	  }
	
	  return 'rgba(' + Number(r) + ',' + Number(g) + ',' + Number(b) + ', ' + opacity + ')';
	}

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _applicationStagesSetting = __webpack_require__(650);
	
	var applicationStagesSetting = function applicationStagesSetting() {
	  return {
	    restrict: 'AE',
	    scope: {
	      hierarchialApplicationStages: '=',
	      allApplicationStages: '=',
	      successCallBack: '&'
	    },
	    replace: true,
	    controller: _applicationStagesSetting.applicationStagesSettingController,
	    template: __webpack_require__(449)
	  };
	};
	
	angular.module('app.directives').directive('applicationStagesSetting', applicationStagesSetting);

/***/ }),
/* 652 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.api').factory('ApplicationStagesApi', ['api', function ApplicationStagesApi(api) {
	  var applicationStagesApi = {
	    getAllApplicationStages: function getAllApplicationStages(payload) {
	      return api.get('applications/stages', { params: payload });
	    },
	    createApplicationStage: function createApplicationStage(payload) {
	      return api.post('applications/stages', payload);
	    },
	    updateApplicationStage: function updateApplicationStage(id, payload) {
	      return api.put('applications/stage/' + id, payload);
	    },
	    deleteApplicationStage: function deleteApplicationStage(id) {
	      return api.delete('applications/stage/' + id);
	    },
	    updateApplicationStageOrder: function updateApplicationStageOrder(payload) {
	      return api.put('applications/stages/order', payload);
	    }
	  };
	  return applicationStagesApi;
	}]);

/***/ }),
/* 653 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var applicationStatusDropdownController = exports.applicationStatusDropdownController = function applicationStatusDropdownController($scope, $document) {
	  $scope.openApplicationStatusDropdown = function (event) {
	    event.stopPropagation();
	  };
	
	  $scope.statusColor = function (color) {
	    if (color) {
	      return {
	        background: color
	      };
	    }
	  };
	
	  $scope.selectApplicationStatus = function (selectedValue) {
	    var elements = $document[0].querySelectorAll('.clickedSelected');[].forEach.call(elements, function (element) {
	      element.classList.remove('clickedSelected');
	    });
	    var status = $document[0].querySelector('#status' + selectedValue.id).firstElementChild;
	    status.classList.add('clickedSelected');
	    $scope.selectedApplicationStatus = selectedValue;
	  };
	
	  $scope.closeApplicationDropdown = function () {
	    $scope.gridOptions.api.deselectAll();
	    $('#applicationStatusDropdownList').hide();
	  };
	};

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _applicationStatusDropdown = __webpack_require__(653);
	
	var applicationStatusDropdown = function applicationStatusDropdown() {
	  return {
	    restrict: 'AE',
	    scope: {
	      data: '=',
	      gridOptions: '='
	    },
	    replace: true,
	    template: __webpack_require__(450),
	    controller: _applicationStatusDropdown.applicationStatusDropdownController
	  };
	};
	
	angular.module('app.directives').directive('applicationStatusDropdown', applicationStatusDropdown);

/***/ }),
/* 655 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var applicationStageDropdownController = exports.applicationStageDropdownController = function applicationStageDropdownController($scope, $document) {
	  $scope.openApplicationStageDropdown = function (event) {
	    event.stopPropagation();
	  };
	
	  $scope.stageColor = function (color) {
	    if (color) {
	      return {
	        background: color
	      };
	    }
	  };
	
	  $scope.selectApplicationStage = function (selectedValue) {
	    var element = $document[0].querySelectorAll('.clickedSelected');[].forEach.call(element, function (element_) {
	      element_.classList.remove('clickedSelected');
	    });
	    var childStage = $document[0].querySelector('#stage' + selectedValue.id).firstElementChild;
	    var parentStage = $document[0].querySelector('#stage' + selectedValue.parentId).firstElementChild;
	    childStage.classList.add('clickedSelected');
	    parentStage.classList.add('clickedSelected');
	    $scope.selectedApplicationStage = selectedValue;
	  };
	
	  $scope.closeApplicationStageModal = function () {
	    $scope.gridOptions.api.deselectAll();
	    $('#applicationStageDropdownList').hide();
	  };
	};

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _applicationStageDropdown = __webpack_require__(655);
	
	var applicationStageDropdown = function applicationStageDropdown() {
	  return {
	    restrict: 'AE',
	    scope: {
	      data: '=',
	      gridOptions: '='
	    },
	    replace: true,
	    template: __webpack_require__(451),
	    controller: _applicationStageDropdown.applicationStageDropdownController
	  };
	};
	
	angular.module('app.directives').directive('applicationStageDropdown', applicationStageDropdown);

/***/ }),
/* 657 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('DeleteApplicationController', ['$uibModalInstance', 'applicationIds', 'ApplicationsApi', 'logger', 'type', function controller($uibModalInstance, applicationIds, ApplicationsApi, logger, type) {
	    var _this = this;
	
	    var vm = this;
	    vm.type = type;
	
	    vm.cancel = function () {
	      $uibModalInstance.dismiss('cancel');
	    };
	
	    var bulkApplicationDelete = function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var payload, _ref2, status;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                payload = { applicationIds: applicationIds, isDeleted: true };
	                _context.prev = 1;
	                _context.next = 4;
	                return ApplicationsApi.bulkApplicationUpdate(payload);
	
	              case 4:
	                _ref2 = _context.sent;
	                status = _ref2.status;
	
	                if (status === 200) {
	                  $uibModalInstance.close(true);
	                }
	                _context.next = 13;
	                break;
	
	              case 9:
	                _context.prev = 9;
	                _context.t0 = _context['catch'](1);
	
	                logger.notify('error', _context.t0.data.message);
	                $uibModalInstance.close(false);
	
	              case 13:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[1, 9]]);
	      }));
	
	      return function bulkApplicationDelete() {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    vm.confirmDelete = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              if (vm.confirmationInput === 'DELETE') bulkApplicationDelete();else if (vm.confirmationInput !== 'DELETE') logger.notify('warning', 'Wrong confirmation text');
	
	            case 1:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this);
	    }));
	  }]);
	})();

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _deleteApplication = __webpack_require__(657);
	
	var deleteApplication = function deleteApplication() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    controller: _deleteApplication.DeleteApplicationController,
	    template: __webpack_require__(452)
	  };
	};
	
	angular.module('app.directives').directive('deleteApplication', deleteApplication);

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable angular/document-service */
	var assignAgentDropdownController = exports.assignAgentDropdownController = function assignAgentDropdownController($scope) {
	  $scope.openAgentDropdown = function (event) {
	    event.stopPropagation();
	  };
	
	  $scope.filterAssignAgent = function () {
	    $scope.data.filteredAgentList = $scope.data.agentsList.filter(function (x) {
	      return x.email.contains(document.querySelector('#filter-agents').value);
	    });
	  };
	
	  $scope.selectedAgent = function (selectedvalue) {
	    var elements = document.querySelectorAll('.clickedSelected');[].forEach.call(elements, function (element) {
	      element.classList.remove('clickedSelected');
	    });
	    // eslint-disable-next-line unicorn/prefer-query-selector
	    var selectedAgentValue = document.getElementById(selectedvalue.id).firstElementChild;
	    selectedAgentValue.classList.add('clickedSelected');
	    $scope.selectedAgentValue = selectedvalue;
	  };
	
	  $scope.closeAgentList = function () {
	    var elements = document.querySelectorAll('.clickedSelected');[].forEach.call(elements, function (element) {
	      element.classList.remove('clickedSelected');
	    });
	    $scope.gridOptions.api.deselectAll();
	    $('#agentsDropdownList').hide();
	  };
	};

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assignAgentDropdown = __webpack_require__(659);
	
	var assignAgentDropdown = function assignAgentDropdown() {
	  return {
	    restrict: 'AE',
	    scope: {
	      data: '=',
	      gridOptions: '='
	    },
	    replace: true,
	    template: __webpack_require__(453),
	    controller: _assignAgentDropdown.assignAgentDropdownController
	  };
	};
	
	angular.module('app.directives').directive('assignAgentDropdown', assignAgentDropdown);

/***/ }),
/* 661 */
/***/ (function(module, exports) {

	'use strict';
	
	// Template for the Dropdown
	var assigneeAdminDropdownTemplate = '\n  <div uib-dropdown class="filters-action">\n    <style>\n    .multi-select-dropdown .dropdown-toggle,\n    .multi-select-dropdown .dropdown-toggle:active,  \n    .multi-select-dropdown .dropdown-toggle:hover,\n    .multi-select-dropdown .dropdown-button.dropdown-toggle:focus {\n      border: none;\n    }\n    .dropdown-button{\n      color: #242633;\n      padding: 6px 10px 6px 10px;\n      width: 100%;\n      font-size: 14px;\n      font-weight: inherit;\n      letter-spacing: normal;\n      text-transform: unset;\n      border-color: transparent;\n      margin: 0;\n      text-align: left;\n    }\n    .dropdown-button:hover, .dropdown-button:focus, .dropdown-button:active {\n      background-color: transparent;\n      color: #242633;\n    }\n    </style>\n    <button uib-dropdown-toggle id="{{data.buttonId}}" class="btn" type="button" id="menu1"data-tooltip-check="Assign Admin" >\t\t\t\t\t\t\t\t\t\n     <svg version="1.1" width="20" height="20" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n            viewBox="0 0 614.9 540" style="enable-background:new 0 0 614.9 540;" xml:space="preserve">\n        <style type="text/css">\n          .st0{fill:#9D9D9D;}          \n        </style>\n        <g>\n          <path class="st0" d="M237.5,258.4c35,0,65.3-12.6,90.1-37.3C352.4,196.3,365,166,365,131c0-35-12.6-65.3-37.3-90.1\n            c-24.8-24.8-55.1-37.3-90.1-37.3c-35,0-65.3,12.6-90.1,37.3S110,95.9,110,131c0,35,12.6,65.3,37.3,90.1\n            C172.2,245.9,202.5,258.4,237.5,258.4z"/>\n          <g>\n            <path class="st0" d="M357.4,524.6l-0.2-1.7l-1.4,1c-16,12-40.8,10.9-56.6-2.5c-7.2-6.1-13.9-12.8-20-20\n              c-13.4-15.8-14.5-40.7-2.5-56.6c0.4-0.5,0.7-0.9,1-1.4l-1.7-0.2c-19.6-2.8-35.9-18.8-37.8-37.2c-0.7-6.2-1-12.5-1-18.8\n              c0-6.4,0.3-12.7,1-18.9c2-18.3,18.2-34.3,37.8-37l1.7-0.2l-1-1.4c-6.2-8.3-9-19.5-8-30.5c-9.2,2.4-18.6,3.7-27.8,3.7\n              c-11.3,0-22.8-1.9-34.2-5.5c-11.6-3.7-21-7.9-27.9-12.3c-8-5.1-15.3-9.8-21.6-13.9c-10.1-6.6-15.3-8.8-20.7-8.8\n              c-13.8,0-26.6,2.3-38.2,6.9c-11.6,4.6-21.7,10.9-29.9,18.8c-7.9,7.5-14.9,16.7-20.8,27.2c-5.7,10.1-10.4,20.7-13.8,31.4\n              c-3.3,10.3-6.1,21.7-8.2,33.6c-2.1,11.9-3.6,23.1-4.3,33.5c-0.7,10.1-1.1,20.6-1.1,31.3c0,27.6,8.8,50,26.1,66.5\n              c17.1,16.3,39.7,24.5,67.3,24.5h247.2C359.1,532.2,358,528.4,357.4,524.6z"/>\n          </g>\n          <path class="st0" d="M593.9,364.3c-1-9.1-10.5-17.5-20.2-18.9l-17.5-2.5c-2-6.1-4.5-12.1-7.4-17.8c0,0,4.8-6.4,10.6-14.2\n            c5.9-7.8,5.7-22.1-1.7-30.8c-5.4-6.3-11.3-12.2-17.7-17.6c-8.7-7.4-23-7.6-30.8-1.7l-14.2,10.6c-5.7-2.9-11.6-5.4-17.8-7.4\n            c0,0-1.1-7.9-2.5-17.5c-1.4-9.7-9.8-19.2-18.9-20.2c-5.5-0.6-11-0.9-16.6-0.9c-5.6,0-11.1,0.3-16.6,0.9c-9.1,1-17.5,10.5-18.9,20.2\n            l-2,14l-0.5,3.6c-6.2,2-12.1,4.5-17.9,7.4c0,0-6.3-4.8-14.2-10.6c-1.8-1.3-3.9-2.3-6.1-3c-7.8-2.4-17.9-1-24.7,4.8\n            c-6.3,5.4-12.3,11.3-17.7,17.6c-1.2,1.4-2.1,2.9-2.9,4.4c-4.4,8.6-3.8,19.8,1.2,26.4l10.6,14.2c-2.9,5.7-5.4,11.7-7.4,17.8\n            c0,0-7.9,1.1-17.5,2.5c-9.7,1.4-19.2,9.8-20.2,18.9c-0.6,5.5-0.9,11-0.9,16.6c0,5.6,0.3,11.2,0.9,16.6c1,9.1,10.5,17.5,20.2,18.9\n            l17.5,2.5c2,6.2,4.5,12.1,7.4,17.8c0,0-4.8,6.3-10.6,14.2c-5.9,7.8-5.7,22.1,1.7,30.8c5.4,6.3,11.3,12.2,17.7,17.7\n            c8.7,7.4,23,7.6,30.8,1.7l14.2-10.6c5.7,2.9,11.7,5.4,17.9,7.4c0,0,1.1,7.9,2.5,17.5c0.7,4.8,3.1,9.5,6.4,13.2\n            c3.4,3.8,7.9,6.5,12.5,7c5.4,0.6,11,0.9,16.6,0.9c5.6,0,11.1-0.3,16.6-0.9c9.1-1,17.5-10.5,18.9-20.2l2.5-17.5\n            c6.2-2,12.1-4.5,17.8-7.4c0,0,6.3,4.8,14.2,10.6c7.8,5.9,22.1,5.7,30.8-1.7c6.3-5.4,12.3-11.3,17.7-17.7c7.4-8.7,7.6-23,1.7-30.8\n            l-10.6-14.2c2.9-5.7,5.4-11.7,7.4-17.8c0,0,7.9-1.1,17.5-2.5c9.7-1.4,19.2-9.8,20.2-18.9c0.6-5.4,0.9-11,0.9-16.6\n            C594.8,375.3,594.5,369.8,593.9,364.3z M487.4,430.7c-12.5,12.1-29.4,19.5-48.1,19.5c-38.2,0-69.2-31-69.2-69.2s31-69.2,69.2-69.2\n            c8.7,0,17.1,1.6,24.7,4.6c26,10,44.5,35.2,44.5,64.7C508.5,400.5,500.4,418.1,487.4,430.7z"/>\n        </g>\t\t\t\t\t\t\t\t\t\t   \n    </svg>\n      \n\n</button>\n<ul uib-dropdown-menu id="assigneeAdminList" class="savedfilterlist assigneAdminDropDownC" ng-click="assignedadminEvent()">\n  <li>\n      <div class="assigneadmin has-search">\n          <input type="text" id="filter-assigneAdmin" class="form-control" placeholder="Search" data-ng-keyup="filterAssigneAdmin()">\n      </div>\n  </li>\n    \n    <ul class="savedfilterlist fixedAssigneAdmin">\n      <li role="presentation" id={{assigneeAdmin.user_ID}} class="dropdownfilter"  ng-repeat="assigneeAdmin in data.updatedfuncList">\t\t\t\t\t\t\t\t\t\n            <a  role="menuitem" tabindex="-1" ng-click="selectedAdmin(assigneeAdmin)"\t\t\t\t\t\t\t\t\t\t\t\n            >{{assigneeAdmin.email}}\n            </a>\n      </li>\n      <label ng-if="data.updatedfuncList.length==0">No record found!</label>\n    </ul>\n  \n  <li role="presentation" class="divider"></li>\t\n  <li>\n    <center>\n      <button class="btn btn-info" ng-disabled=" (selectedassigneeAdmin) ?  false : true"ng-click="data.function(selectedassigneeAdmin)">Assign</button>\n      <button class="btn btn-default" ng-click="cancelAssigneAdminModal()">Cancel</button>\n  </center>\n  </li>\t\t\t\t\t\t\t\t\t\t\n</ul>\n  ';
	
	// Controller for the dropdown directive
	var assigneeAdminDropdownController = function assigneeAdminDropdownController($scope, $timeout, locationsService) {
	  var stopEventExecution = function stopEventExecution(event) {
	    event.stopPropagation();
	  };
	
	  $('#assigneeAdminList').click(stopEventExecution);
	  $scope.filterAssigneAdmin = function () {
	    var txtvalue = document.getElementById('filter-assigneAdmin').value;
	    $scope.data.updatedfuncList = $scope.data.funcList.filter(function (x) {
	      return x.email.contains(txtvalue);
	    });
	    $scope.$apply();
	  };
	
	  $scope.assignedadminEvent = function () {
	    event.stopPropagation();
	  };
	  $scope.selectedAdmin = function (selectedvalue) {
	    var elems = document.querySelectorAll('.clickedSelected');[].forEach.call(elems, function (el) {
	      el.classList.remove('clickedSelected');
	    });
	    var selectedAdminValue = document.getElementById(selectedvalue.user_ID).firstElementChild;
	    selectedAdminValue.classList.add('clickedSelected');
	    $scope.selectedassigneeAdmin = selectedvalue;
	    // $scope.$apply();
	  };
	  $scope.cancelAssigneAdminModal = function () {
	    var elems = document.querySelectorAll('.clickedSelected');[].forEach.call(elems, function (el) {
	      el.classList.remove('clickedSelected');
	    });
	    $scope.gridOptions.api.deselectAll();
	    $('#assigneeAdminList').hide();
	  };
	
	  // Resets the selection of all
	};
	
	// returns DDO for the dropdown
	var assigneeAdminDropdown = function assigneeAdminDropdown() {
	  return {
	    restrict: 'AE',
	    scope: {
	      data: '=',
	      gridOptions: '='
	    },
	    replace: true,
	    template: assigneeAdminDropdownTemplate,
	    controller: assigneeAdminDropdownController
	  };
	};
	
	angular.module('app.directives').directive('assigneeAdminDropdown', assigneeAdminDropdown);

/***/ }),
/* 662 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.ui.form.ctrls').controller('CandidateProfileModalController', ['$scope', '$uibModalInstance', 'data', '$rootScope', 'logger', function controller($scope, $uibModalInstance, data, $rootScope, logger) {
	  // eslint-disable-next-line angular/controller-as
	  $scope.candidateId = data;
	
	  $rootScope.$on('candidate-deleted', function (event, _ref) {
	    var candidateDeleted = _ref.candidateDeleted;
	
	    if ($scope.candidateId === candidateDeleted && !$rootScope.isCandidateDeleted) {
	      logger.notify('error', 'Candidate is Deleted by Other Admin');
	      $uibModalInstance.dismiss('cancel');
	    }
	  });
	}]);

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _candidateProfileModal = __webpack_require__(662);
	
	var candidateProfileModal = function candidateProfileModal() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    controller: _candidateProfileModal.CandidateProfileModalController,
	    template: __webpack_require__(454)
	  };
	};
	
	angular.module('app.directives').directive('candidateProfileModal', candidateProfileModal);

/***/ }),
/* 664 */
/***/ (function(module, exports) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('ClonePositionController', ['$uibModalInstance', 'cloningData', 'usSpinnerService', 'logger', '$timeout', 'PositionApi', 'practiceAreaService', 'locationsGenericService', '$window', function controller($uibModalInstance, cloningData, usSpinnerService, logger, $timeout, PositionApi, practiceAreaService, locationsGenericService, $window) {
	    var vm = this;
	    console.debug('cloningData', cloningData);
	
	    vm.positions = angular.copy(cloningData.positions);
	    vm.allContractType = angular.copy(cloningData.allContractType);
	    vm.allOccupations = angular.copy(cloningData.allOccupations);
	    vm.allPracticeArea = angular.copy(cloningData.allPracticeArea);
	    vm.allLocations = angular.copy(cloningData.allLocations);
	
	    vm.positions = vm.positions.map(function (position) {
	      return initializeClonePosition(position);
	    });
	
	    vm.currentIndex = 0;
	    vm.pqeOptions = {
	      round: 1,
	      from: -2,
	      to: 11,
	      step: 0.5,
	      dimension: '+ years',
	      scale: [-2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '11+']
	    };
	
	    var clonePositionSuccessHandler = function clonePositionSuccessHandler(clone) {
	      $timeout(function () {
	        logger.notify('success', 'Successfully cloned \'' + vm.positions.length + '\' ' + (vm.positions.length === 1 ? 'position' : 'position(s)'));
	        usSpinnerService.stop('spinner-clone-jobs');
	        return $uibModalInstance.close(clone.data);
	      }, 3000);
	
	      $timeout(function () {
	        $window.location.reload();
	      }, 4000);
	    };
	
	    var clonePositionErrorHandler = function clonePositionErrorHandler(errorResponse) {
	      logger.notify('error', 'Error Cloning Jobs.\n          Error Reason: ' + errorResponse.statusText + '\n          ');
	      usSpinnerService.stop('spinner-clone-jobs');
	    };
	
	    vm.pqeChange = function () {
	      var separator;
	      var currentPosition = vm.positions[vm.currentIndex];
	      separator = currentPosition.pqe.search(';');
	      if (separator === 1) {
	        currentPosition.minPQE = Number(currentPosition.pqe.slice(0, 1));
	        currentPosition.maxPQE = Number(currentPosition.pqe.slice(2, 5));
	      } else if (separator === 2) {
	        currentPosition.minPQE = Number(currentPosition.pqe.slice(0, 2));
	        currentPosition.maxPQE = Number(currentPosition.pqe.slice(3, 5));
	      }
	    };
	
	    vm.nextPage = function () {
	      if (vm.currentIndex < vm.positions.length - 1) {
	        vm.currentIndex += 1;
	      }
	
	      populateCloneLocationsAndPractices(vm.currentIndex);
	    };
	
	    vm.lastPage = function () {
	      vm.currentIndex = vm.positions.length - 1;
	      populateCloneLocationsAndPractices(vm.currentIndex);
	    };
	
	    vm.previousPage = function () {
	      if (vm.currentIndex > 0) {
	        vm.currentIndex -= 1;
	      }
	
	      populateCloneLocationsAndPractices(vm.currentIndex);
	    };
	
	    vm.firstPage = function () {
	      vm.currentIndex = 0;
	      populateCloneLocationsAndPractices(vm.currentIndex);
	    };
	
	    vm.onChangePracticeArea = function (event, selectedPracticeArea) {
	      if (event) {
	        event.stopPropagation();
	      } else {
	        vm.positions[vm.currentIndex].specialties = selectedPracticeArea;
	      }
	    };
	
	    var initializePracticeAreas = function initializePracticeAreas(currentIndex) {
	      practiceAreaService.initialize(vm.positions[currentIndex].specialties, vm.allPracticeArea, false);
	    };
	
	    vm.onChangeLocation = function (event, selectedLocation) {
	      if (event) {
	        event.stopPropagation();
	      } else {
	        vm.positions[vm.currentIndex].locations = selectedLocation;
	      }
	    };
	
	    var initializeLocations = function initializeLocations(currentIndex) {
	      var regionHierarchialList = locationsGenericService.initialize(vm.positions[currentIndex].locations, vm.allLocations);
	
	      regionHierarchialList.sort(function (a, b) {
	        return a.name > b.name ? 1 : -1;
	      });
	      vm.regionHierarchialListWithEuropeOnTop = [].concat(_toConsumableArray(regionHierarchialList.filter(function (region) {
	        return region.name === 'Europe';
	      })), _toConsumableArray(regionHierarchialList.filter(function (region) {
	        return region.name !== 'Europe';
	      })));
	    };
	
	    var populateCloneLocationsAndPractices = function populateCloneLocationsAndPractices(currentIndex) {
	      initializePracticeAreas(currentIndex);
	      initializeLocations(currentIndex);
	    };
	
	    populateCloneLocationsAndPractices(vm.currentIndex);
	
	    vm.setPositionType = function (position) {
	      if (position.positionType === 1) position.type = 'Regular';
	      if (position.positionType === 2) position.type = 'Custom';
	      if (position.positionType === 3) position.type = 'Connect';
	      if (position.positionType === 4) position.type = 'Speculative';
	      if (position.positionType === 5) position.type = 'External';
	      if (position.positionType !== 1 && position.positionType !== 5) position.externalUrl = undefined;
	    };
	
	    var validateClonePosition = function validateClonePosition(payload) {
	      return payload.map(function (position, index) {
	        if (position.expiresAt && new Date(position.expiresAt) < new Date()) {
	          logger.notify('error', 'Expiry Date is less than today for the clone Position # ' + (index + 1));
	          return false;
	        }
	
	        if (position.locations === undefined || position.locations.length === 0) {
	          logger.notify('error', 'Locations are empty for the clone Position # ' + (index + 1));
	          return false;
	        }
	
	        if (position.specialties === undefined || position.specialties.length === 0) {
	          logger.notify('error', 'Practice Areas are empty for the clone Position # ' + (index + 1));
	          return false;
	        }
	
	        return true;
	      }).every(function (x) {
	        return x === true;
	      });
	    };
	
	    vm.clonePositions = function () {
	      var payload = vm.positions.map(function (position) {
	        vm.setPositionType(position);
	        var specialties = practiceAreaService.setIsSelectedChildrenPracticeArea(position.specialties, []);
	
	        return {
	          title: position.title,
	          description: position.description,
	          expiresAt: position.expiresAt,
	          locations: position.locations,
	          specialties: specialties,
	          visible: position.visible,
	          externalUrl: position.externalUrl,
	          employerId: position.employerId,
	          contractTypeId: position.contractTypeId,
	          occupationId: position.occupationId,
	          type: position.type,
	          professionId: 'law',
	          skills: [],
	          lawPreferences: {
	            minPqe: position.minPQE,
	            maxPqe: position.maxPQE
	          }
	        };
	      });
	      if (validateClonePosition(payload)) {
	        usSpinnerService.spin('spinner-clone-jobs');
	        logger.notify('info', 'Cloning \'' + vm.positions.length + ' position(s)\'');
	        console.debug('Cloning Positions', payload);
	        PositionApi.createClonePositions(payload).then(function (data) {
	          return clonePositionSuccessHandler(data);
	        }).catch(clonePositionErrorHandler);
	      }
	    };
	
	    vm.cancel = function () {
	      $uibModalInstance.dismiss('cancel');
	    };
	  }]);
	})();
	
	var initializeClonePosition = function initializeClonePosition(position) {
	  console.debug('initializeClonePosition:', position);
	  if (position.professionId === 'tech' || !position.lawPreferences) {
	    position.lawPreferences = {
	      minPqe: position.techPreferences.minExperience ? position.techPreferences.minExperience : -2,
	      maxPqe: 11
	    };
	  }
	
	  position.minPQE = position.lawPreferences && position.lawPreferences.minPqe ? position.lawPreferences.minPqe : -2;
	  position.maxPQE = position.lawPreferences && position.lawPreferences.maxPqe ? position.lawPreferences.maxPqe : 11;
	  position.pqe = position.lawPreferences.minPqe + ';' + position.lawPreferences.maxPqe;
	  if (position.type === 'Regular') position.positionType = 1;
	  if (position.type === 'Custom') position.positionType = 2;
	  if (position.type === 'Connect') position.positionType = 3;
	  if (position.type === 'Speculative') position.positionType = 4;
	  if (position.type === 'External') position.positionType = 5;
	  // Position.visible = position.visible === 'Visible'
	  if (position.specialties.length > 0) position.specialties = position.specialties.map(function (specialty) {
	    specialty.isSelected = true;
	    return specialty;
	  });
	  if (position.locations.length > 0) position.locations = position.locations.map(function (location) {
	    location.isSelected = true;
	    return location;
	  });
	  return position;
	};

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _clonePositionCtrl = __webpack_require__(664);
	
	var clonePositionModal = function clonePositionModal() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    controller: _clonePositionCtrl.ClonePositionController,
	    template: __webpack_require__(455)
	  };
	};
	
	angular.module('app.directives').directive('clonePositionModal', clonePositionModal);

/***/ }),
/* 666 */
/***/ (function(module, exports) {

	'use strict';
	
	/**************************************************************************/
	/*** ML Query Builder implemented By Fahad Akbar(fahadakbar24@gmail.com)***/
	/**************************************************************************/
	
	angular.module('app.api').factory('columnSelectionApi', ['api', function (api) {
	
	  var columnSelectionApi = {
	    fetch: function fetch(pageId) {
	      return api.request('GET', '/api/admin/column-selection/fetch/' + pageId);
	    },
	    save: function save(selectionPayload) {
	      return api.request('PUT', '/api/admin/column-selection/save', selectionPayload);
	    }
	  };
	
	  return columnSelectionApi;
	}]);

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _controller = __webpack_require__(182);
	
	var columnSelector = function columnSelector() {
	  // Directive Definition object for Column Selector
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      columnsList: '=', // list of Colums that are to be selected from
	      openColumnsPopup: '=', // The method outside the directive's controller that is responsible
	      // for asking to open the modal
	      pageId: "=",
	      isColumnSelectionToBeSaved: "=saveSelection"
	    },
	    template: '\n        <script type="text/ng-template" id="columnSelectTemplate.html">\n        <div class="modal-header">\n          <center>\n            <h3>Columns</h3>\n            <h5>Select Columns to show</h5>\n          </center>\n        </div>\n        <div class="modal-row">\n          <div class="col-md-12 lang-modal" >\n              <br>\n              <ul class="checkbox-grid pref-language-list clearfix">\n                  <li ng-repeat = "column in columnsList" >\n                      <label class="ui-checkbox">\n                          <input name="column.ref_column.column_label"\n                              type="checkbox"\n                              ng-model="column.show"\n                              ng-checked="column.show"\n                           >\n                          <span>{{column.ref_column.column_label || column.label}}</span>\n                      </label>\n                  </li>\n              </ul>\n              <br>\n          </div>\n        </div>\n        <div class="modal-footer">\n          <center>\n            <button class="btn btn-gap-v btn-default" ng-click="closeSelectionPopup()">Close</button>\n          </center>\n        </div>\n      </script>\n        ',
	    controller: _controller.columnSelectorCtrl
	  };
	};
	
	// Define the Column Selector
	/**************************************************************************/
	/*** 'Column Selector' implemented By Fahad Akbar(fahadakbar24@gmail.com)**/
	/**************************************************************************/
	
	// Import the Column Selector's Controller
	angular.module('app.directives').directive('columnSelector', columnSelector);

/***/ }),
/* 668 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/* eslint-disable camelcase */
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('ContactAdminController', ['$uibModalInstance', 'PositionApi', 'selectedPosition', 'logger', function controller($uibModalInstance, PositionApi, selectedPosition, logger) {
	    var _this = this;
	
	    var vm = this;
	    vm.submitQuestion = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var response;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              try {
	                analytics.track('Question Asked', {
	                  question: vm.lawyerQuestion,
	                  lawyer_id: selectedPosition.userId,
	                  job_id: selectedPosition.id,
	                  job_title: selectedPosition.title,
	                  job_max_pqe: selectedPosition.lawPreferences.maxPqe,
	                  job_min_pqe: selectedPosition.lawPreferences.minPqe,
	                  job_contract: selectedPosition.contractTypeName,
	                  job_role: selectedPosition.occupationName,
	                  job_address: '',
	                  employer_type: selectedPosition.employerTypes.filter(function (_ref2) {
	                    var name = _ref2.name;
	                    return name === 'Private Practice';
	                  }).length > 0 ? 'Private Practice' : 'In-House',
	                  firm_id: selectedPosition.employerId,
	                  firm_name: selectedPosition.employer.name,
	                  page: 'My LexStep Matches'
	                });
	              } catch (error) {
	                console.error('My LexStep Matches', error);
	              }
	
	              _context.prev = 1;
	              _context.next = 4;
	              return PositionApi.addPositionQuestion(selectedPosition.id, { userId: selectedPosition.userId, body: vm.lawyerQuestion });
	
	            case 4:
	              response = _context.sent;
	
	              if (response.status === 201) {
	                logger.notify('success', 'Your question has been submitted successfully! We will get back to you as soon as possible');
	              }
	              _context.next = 11;
	              break;
	
	            case 8:
	              _context.prev = 8;
	              _context.t0 = _context['catch'](1);
	
	              logger.notify('error', 'There was an error in submitting your question. Please try again');
	
	            case 11:
	
	              $uibModalInstance.close(vm.lawyerQuestion);
	
	            case 12:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this, [[1, 8]]);
	    }));
	
	    vm.cancel = function () {
	      $uibModalInstance.dismiss('cancel');
	    };
	  }]);
	})();

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _contactAdmin = __webpack_require__(668);
	
	var contactAdmin = function contactAdmin() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    controller: _contactAdmin.ContactAdminController,
	    template: __webpack_require__(456)
	  };
	};
	
	angular.module('app.directives').directive('contactAdmin', contactAdmin);

/***/ }),
/* 670 */
/***/ (function(module, exports) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('CreateUpdateEmployerController', ['$log', '$timeout', '$uibModal', '$location', '$scope', 'usSpinnerService', 'EmployersApi', 'SharedApi', 'userService', 'CandidateProfileApi', 'logger', function controller($log, $timeout, $uibModal, $location, $scope, usSpinnerService, EmployersApi, SharedApi, userService, CandidateProfileApi, logger) {
	    var _this = this;
	
	    var vm = this;
	    vm.showOnError = false;
	    vm.showOnSuccess = false;
	    vm.alertMsg = '';
	    vm.employerSpinnerId = 'spinner-firm-management';
	    if ($location.search().action === 'edit') {
	      vm.selectedEmployerId = $location.search().id;
	    }
	
	    var pageInitialize = function pageInitialize() {
	      vm.page = {
	        entityPlaceholder: 'Employer',
	        mandatoryPlaceholder: vm.isPrivatePractice === false ? '' : '*',
	        behaviorPlaceholder: vm.selectedEmployerId ? 'Edit' : 'Create'
	      };
	    };
	
	    pageInitialize();
	    $scope.$root.title = vm.page.behaviorPlaceholder + ' ' + vm.page.entityPlaceholder + ' | Lexstep';
	
	    // $scope.canViewAddFirmAssignedAdmin = () => {
	    //   return accountPermission.canViewAddFirmAssignedAdmin($scope.user)
	    // }
	
	    vm.changeStatus = function (status, message) {
	      switch (status) {
	        case 201:
	          vm.alertMsg = 'Congratulations! Employers has been Successfully created.';
	          vm.showOnSuccess = true;
	          break;
	        case 200:
	          vm.alertMsg = 'Congratulations! Employers has been Successfully updated.';
	          vm.showOnSuccess = true;
	          break;
	        case 440:
	          $location.url('/signin');
	          break;
	        case 404:
	          vm.alertMsg = 'Page Not Found. Please try again.';
	          vm.showOnError = true;
	          break;
	        case 400:
	          vm.alertMsg = message;
	          vm.showOnError = true;
	          break;
	        case 500:
	          vm.alertMsg = 'Could not connect to the server. Please try again later.';
	          vm.showOnError = true;
	          break;
	        case 100:
	          vm.alertMsg = 'Please select a Employer by clicking the checkboxes before deleting.';
	          vm.showOnError = true;
	          break;
	        default:
	          vm.alertMsg = 'An error has occurred. Please try again.';
	          vm.showOnError = true;
	          break;
	      }
	    };
	
	    var discardMultipleField = function discardMultipleField() {
	      vm.employer.lawProfile = {
	        nqSalary: vm.employer.lawProfile.nqSalary,
	        nqSalaryVisible: vm.employer.lawProfile.nqSalaryVisible
	      };
	    };
	
	    vm.addEmployer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	      var payload;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              if (!vm.isPrivatePractice && vm.employer.lawProfile) discardMultipleField();
	              payload = employerDto();
	
	              startSpinner();
	              EmployersApi.createEmployer(payload).then(function () {
	                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(successResponse) {
	                  var file, formData;
	                  return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          if (!vm.selectedFile) {
	                            _context.next = 6;
	                            break;
	                          }
	
	                          file = vm.selectedFile;
	                          formData = new FormData();
	
	                          formData.append('file', file);
	                          _context.next = 6;
	                          return EmployersApi.uploadEmployerLogo(successResponse.data.id, formData);
	
	                        case 6:
	
	                          stopSpinner();
	                          vm.changeStatus(successResponse.status, successResponse.message);
	                          $location.url('/admin/employers-listing');
	                          $scope.$apply();
	
	                        case 10:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this);
	                }));
	
	                return function (_x) {
	                  return _ref2.apply(this, arguments);
	                };
	              }()).catch(addUpdateErrorResponseHandler).finally(stopSpinner);
	
	            case 4:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this);
	    }));
	
	    vm.updateEmployer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
	      var payload;
	      return regeneratorRuntime.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              if (!vm.isPrivatePractice && vm.employer.lawProfile) discardMultipleField();
	              startSpinner();
	              payload = employerDto();
	
	
	              EmployersApi.updateEmployerById(vm.selectedEmployerId, payload).then(function () {
	                var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(successResponse) {
	                  var file, formData;
	                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                    while (1) {
	                      switch (_context3.prev = _context3.next) {
	                        case 0:
	                          if (!vm.selectedFile) {
	                            _context3.next = 6;
	                            break;
	                          }
	
	                          file = vm.selectedFile;
	                          formData = new FormData();
	
	                          formData.append('file', file);
	                          _context3.next = 6;
	                          return EmployersApi.uploadEmployerLogo(vm.selectedEmployerId, formData);
	
	                        case 6:
	
	                          stopSpinner();
	                          vm.changeStatus(successResponse.status, successResponse.message);
	                          $scope.$apply();
	
	                        case 9:
	                        case 'end':
	                          return _context3.stop();
	                      }
	                    }
	                  }, _callee3, _this);
	                }));
	
	                return function (_x2) {
	                  return _ref4.apply(this, arguments);
	                };
	              }()).catch(addUpdateErrorResponseHandler).finally(stopSpinner);
	
	            case 4:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this);
	    }));
	
	    var employerDto = function employerDto() {
	      var payload = angular.copy(vm.employer);
	
	      // eslint-disable-next-line unicorn/no-null
	      payload.agentId = payload.agentId === 0 ? null : payload.agentId;
	      payload.approved = vm.employer.approved;
	      payload.professions = ['law'];
	      payload.contactEmail = vm.employer.contactEmail ? vm.employer.contactEmail : undefined;
	      payload.specialties = vm.employer.practiceAreas;
	      payload.specialties = vm.selectedCategory ? [].concat(_toConsumableArray(payload.specialties), [vm.selectedCategory]) : payload.specialties;
	      payload.categories = [].concat(_toConsumableArray(new Set(payload.specialties && payload.specialties.map(function (specialty) {
	        return specialty.categoryId;
	      }))));
	
	      if (vm.editableEmployerName && payload.name.trim() === vm.editableEmployerName.trim()) delete payload.name;
	      delete payload.practiceAreas;
	      delete payload.categoryId;
	      delete payload.id;
	      delete payload.logo;
	      return payload;
	    };
	
	    var startSpinner = function startSpinner() {
	      return usSpinnerService.spin(vm.employerSpinnerId);
	    };
	
	    var stopSpinner = function stopSpinner() {
	      return usSpinnerService.stop(vm.employerSpinnerId);
	    };
	
	    var addUpdateErrorResponseHandler = function addUpdateErrorResponseHandler(errorResponse) {
	      $log.info('Error occurred in Add/Update Employer', errorResponse);
	      vm.changeStatus(errorResponse.status, errorResponse.message);
	    };
	
	    vm.changeEmployerCategory = function (categoryId) {
	      if (categoryId) {
	        vm.employer.approved = true;
	
	        vm.selectedCategory = vm.categories.find(function (category) {
	          return category.id === categoryId;
	        });
	
	        if (vm.selectedCategory.name === 'Private Practice') vm.isPrivatePractice = true;else vm.isPrivatePractice = false;
	        pageInitialize();
	      } else {
	        vm.selectedCategory = undefined;
	      }
	    };
	
	    vm.openDeleteEmployerModal = function (_employerId) {
	      var modalInstance = $uibModal.open({
	        templateUrl: 'delete-employer-modal.html',
	        controller: 'DeleteEmployerController',
	        controllerAs: 'ctrl',
	        resolve: {
	          employerId: function employerId() {
	            return _employerId;
	          }
	        }
	      });
	      modalInstance.result.then(function (deletedEmployer) {
	        if (deletedEmployer) {
	          vm.alertMsg = 'Employer deleted successfully.';
	          vm.showOnSuccess = true;
	          $location.url('/admin/employers-listing');
	        } else {
	          vm.alertMsg = 'An error has occurred. Please try again.';
	          vm.showOnError = true;
	        }
	      }, function () {});
	    };
	
	    vm.onEmployerApproved = function (approvedCheckBoxValue) {
	      if (approvedCheckBoxValue === false) {
	        vm.employer.categoryId = undefined;
	        vm.selectedCategory = undefined;
	      }
	
	      if (approvedCheckBoxValue === true && vm.employer.categoryId === undefined) {
	        logger.notify('error', 'Category must be selected for approved employer');
	        vm.employer.approved = false;
	      }
	
	      pageInitialize();
	    };
	
	    vm.openLocationModal = function (_selectedLocations, event) {
	      event.preventDefault();
	      event.stopPropagation();
	      var modalInstance = $uibModal.open({
	        templateUrl: 'locations-modal.html',
	        controller: 'LocationsModalController',
	        controllerAs: 'ctrl',
	        resolve: {
	          locationList: function locationList() {
	            return vm.locationsList;
	          },
	          selectedLocations: function selectedLocations() {
	            return _selectedLocations;
	          },
	          limit: function limit() {
	            return 0;
	          },
	          locationModalHeading: function locationModalHeading() {
	            return false;
	          },
	          displayNextButton: function displayNextButton() {
	            return false;
	          }
	        }
	      });
	      modalInstance.result.then(function (selectedLocations) {
	        vm.selectedLocation = selectedLocations.length > 0;
	        vm.employer.locations = angular.copy(selectedLocations);
	      }, function () {});
	    };
	
	    vm.openPracticeModal = function (_selectedPractice, event) {
	      event.preventDefault();
	      event.stopPropagation();
	      var onlyParentPracticeArea = vm.legalPracticeAreaList.filter(function (_ref5) {
	        var parentId = _ref5.parentId;
	        return parentId === null;
	      });
	      var modalInstance = $uibModal.open({
	        templateUrl: 'practice-area-modal.html',
	        controller: 'PracticeAreaController',
	        controllerAs: 'ctrl',
	        resolve: {
	          practiceAreaList: function practiceAreaList() {
	            return onlyParentPracticeArea;
	          },
	          selectedPractice: function selectedPractice() {
	            return _selectedPractice;
	          },
	          limit: function limit() {
	            return 0;
	          },
	          isAdminProfile: function isAdminProfile() {
	            return true;
	          },
	          displayNextButton: function displayNextButton() {
	            return false;
	          }
	        }
	      });
	      modalInstance.result.then(function (selectPractices) {
	        vm.selectedPracticesShow = selectPractices.length > 0;
	        vm.employer.practiceAreas = angular.copy(selectPractices);
	      }, function () {});
	    };
	
	    vm.loadEmployer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	      var _ref7, employerRecord, employerStatus, _ref8, _ref9, locationsList, legalPracticeAreaList, legalEmployerTypeList, candidateAgents;
	
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              _context5.next = 2;
	              return userService.getUser();
	
	            case 2:
	              vm.user = _context5.sent;
	
	              startSpinner();
	
	              if (!vm.selectedEmployerId) {
	                _context5.next = 17;
	                break;
	              }
	
	              _context5.prev = 5;
	              _context5.next = 8;
	              return EmployersApi.getEmployerById(vm.selectedEmployerId);
	
	            case 8:
	              _ref7 = _context5.sent;
	              employerRecord = _ref7.data;
	              employerStatus = _ref7.status;
	
	              if (employerStatus === 200) {
	                vm.employerRecord = employerRecord;
	              }
	              _context5.next = 17;
	              break;
	
	            case 14:
	              _context5.prev = 14;
	              _context5.t0 = _context5['catch'](5);
	
	              vm.changeStatus(_context5.t0.status);
	
	            case 17:
	              _context5.next = 19;
	              return Promise.all([SharedApi.getAllLocations({
	                supported: true,
	                regions: true
	              }), SharedApi.getCategoryById(1), SharedApi.getCategoryById(2), CandidateProfileApi.getAdminAndCorporateUsers()]);
	
	            case 19:
	              _ref8 = _context5.sent;
	              _ref9 = _slicedToArray(_ref8, 4);
	              locationsList = _ref9[0].data;
	              legalPracticeAreaList = _ref9[1].data;
	              legalEmployerTypeList = _ref9[2].data;
	              candidateAgents = _ref9[3].data;
	
	              vm.candidateAgentsList = candidateAgents;
	              vm.legalPracticeAreaList = legalPracticeAreaList.specialties;
	              vm.legalEmployerTypeList = legalEmployerTypeList;
	              vm.locationsList = locationsList;
	              $timeout(function () {
	                vm.initializeEmployer();
	                stopSpinner();
	              }, 300);
	
	            case 30:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this, [[5, 14]]);
	    }));
	
	    vm.initializeEmployer = function () {
	      vm.employer = { professions: ['law'], practiceAreas: [], locations: [] };
	      vm.isPrivatePractice = true;
	      vm.employer.lawProfile = {};
	      vm.modalTitle = 'Create Employer';
	      vm.selectedPracticesShow = false;
	      vm.showPracticeButton = true;
	      vm.selectedLocation = false;
	      vm.showLocationButton = true;
	      vm.categories = vm.legalEmployerTypeList.specialties;
	      vm.selectivity = [];
	      var employerSelectivity = '';
	      for (var index = 1; index <= 6; index++) {
	        employerSelectivity += '$';
	        vm.selectivity = [].concat(_toConsumableArray(vm.selectivity), [{ id: index, name: employerSelectivity }]);
	      }
	
	      vm.selectivity = [].concat(_toConsumableArray(vm.selectivity), [{ id: 0, name: 'Uncategorized' }]);
	      if (vm.employerRecord) {
	        vm.initializeEditEmployer(vm.employerRecord);
	      }
	    };
	
	    vm.initializeEditEmployer = function (existingEmployer) {
	      vm.modalTitle = 'Edit Employer';
	      vm.editEmployerModal = true;
	      vm.employer = {
	        logo: existingEmployer.logo,
	        id: existingEmployer.id,
	        name: existingEmployer.name,
	        selectivity: existingEmployer.selectivity,
	        contactName: existingEmployer.contactName,
	        contactEmail: existingEmployer.contactEmail,
	        address: existingEmployer.address,
	        isVisible: existingEmployer.isVisible,
	        description: existingEmployer.description,
	        agentId: existingEmployer.agentId,
	        practiceAreas: [],
	        locations: []
	      };
	      vm.editableEmployerName = angular.copy(existingEmployer.name);
	      // TODO: TechPreference to be discussed
	      if (existingEmployer.professions.find(function (profession) {
	        return profession.id === 'law';
	      })) {
	        vm.employer.lawProfile = {
	          size: existingEmployer.lawProfile.size,
	          sizeVisible: existingEmployer.lawProfile.sizeVisible,
	          targetHours: existingEmployer.lawProfile.targetHours,
	          targetHoursVisible: existingEmployer.lawProfile.targetHoursVisible,
	          associatesPerPartner: existingEmployer.lawProfile.associatesPerPartner,
	          associatesPerPartnerVisible: existingEmployer.lawProfile.associatesPerPartnerVisible,
	          profitPerEquityPartner: existingEmployer.lawProfile.profitPerEquityPartner,
	          profitPerEquityPartnerVisible: existingEmployer.lawProfile.profitPerEquityPartnerVisible,
	          nqSalary: existingEmployer.lawProfile.nqSalary,
	          nqSalaryVisible: existingEmployer.lawProfile.nqSalaryVisible
	        };
	      }
	
	      if (existingEmployer.categories.length > 0) {
	        var practiceAreas = existingEmployer.categories.find(function (category) {
	          return category.id === 1;
	        });
	        var category = existingEmployer.categories.find(function (category) {
	          return category.id === 2;
	        });
	        if (practiceAreas && practiceAreas.specialties.length > 0) {
	          vm.employer.practiceAreas = practiceAreas.specialties.map(function (practiceArea) {
	            practiceArea.isSelected = true;
	            return practiceArea;
	          });
	          vm.selectedPracticesShow = practiceAreas.specialties.length > 0;
	          vm.showPracticeButton = practiceAreas.specialties.length === 0;
	        }
	
	        if (category && category.specialties.length > 0) {
	          vm.employer.categoryId = category.specialties.find(function (specialty) {
	            return specialty.categoryId === 2;
	          }).id;
	          vm.changeEmployerCategory(vm.employer.categoryId);
	        }
	      }
	
	      if (existingEmployer.locations.length > 0) vm.employer.locations = existingEmployer.locations.map(function (location) {
	        location.isSelected = true;
	        return location;
	      });
	      vm.selectedLocation = existingEmployer.locations.length > 0;
	      vm.showLocationButton = existingEmployer.locations.length === 0;
	    };
	
	    vm.loadEmployer();
	  }]);
	})();

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createUpdateEmployerModal = __webpack_require__(183);
	
	var createUpdateEmployerModal = function createUpdateEmployerModal() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    controller: _createUpdateEmployerModal.CreateUpdateEmployerController,
	    template: __webpack_require__(457)
	  };
	};
	
	angular.module('app.directives').directive('createUpdateEmployerModal', createUpdateEmployerModal);

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _loadingOverlay = __webpack_require__(20);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	(function module() {
	  angular.module('app.ui.form.ctrls').controller('CreateUpdatePositionModalController', ['$location', '$uibModal', 'logger', 'SharedApi', 'PositionApi', 'EmployersApi', '$uibModalInstance', 'selectedPositionId', 'adminId', 'userService', '$rootScope', '$window', '$timeout', '$scope', function controller($location, $uibModal, logger, SharedApi, PositionApi, EmployersApi, $uibModalInstance, selectedPositionId, adminId, userService, $rootScope, $window, $timeout, $scope) {
	    var _this = this;
	
	    var vm = this;
	
	    vm.pqeValues = [-2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
	
	    $rootScope.$on('position-deleted', function (event, _ref) {
	      var positionDeleted = _ref.positionDeleted;
	
	      if (vm.positionRecord.id === positionDeleted && !$rootScope.isPositionDeleted) {
	        logger.notify('error', 'Position is Deleted by Other Admin');
	        vm.closePositionModal();
	      }
	    });
	    vm.showOnSuccess = false;
	    vm.showOnError = false;
	    vm.alertMsg = '';
	
	    vm.pqeOptions = {
	      round: 1,
	      from: -2,
	      to: 11,
	      step: 1,
	      dimension: '+ years',
	      scale: [-2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '11+']
	    };
	
	    vm.initializePosition = function () {
	      console.debug('initializePosition');
	      vm.modalTitle = 'Add Position';
	      vm.editPositionModal = false;
	      vm.position = {
	        employer: {},
	        locations: [],
	        practiceAreas: [],
	        minPqe: -2,
	        maxPqe: 11,
	        pqe: '-2;11',
	        positionType: 1,
	        visible: true,
	        contractTypeId: 1,
	        occupationId: 1,
	        description: ''
	      };
	      vm.selectedMinPqe = -2;
	      vm.selectedMaxPqe = 11;
	      vm.selectedPracticesShow = false;
	      vm.showPracticeButton = true;
	      vm.selectedLocation = false;
	      vm.showLocationButton = true;
	    };
	
	    vm.initializeEditPosition = function (existingPosition) {
	      console.debug('initializeEditPosition');
	      vm.modalTitle = 'Edit Position';
	      vm.editPositionModal = true;
	      // TODO: TechPreference to be discussed
	      if (existingPosition.professionId === 'tech' || !existingPosition.lawPreferences) {
	        existingPosition.lawPreferences = {
	          minPqe: existingPosition.techPreferences && existingPosition.techPreferences.minExperience ? existingPosition.techPreferences.minExperience : -2,
	          maxPqe: 11
	        };
	      }
	
	      vm.pqeOptions = {
	        round: 1,
	        from: -2,
	        to: 11,
	        step: 1,
	        dimension: '+ years',
	        scale: [-2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '11+']
	      };
	
	      console.debug('existingPosition', existingPosition);
	
	      vm.position = {
	        title: existingPosition.title,
	        locations: existingPosition.locations,
	        expiresAt: existingPosition.expiresAt,
	        minPqe: existingPosition.lawPreferences.minPqe ? Number.parseFloat(existingPosition.lawPreferences.minPqe) : -2,
	        maxPqe: existingPosition.lawPreferences.maxPqe ? Number.parseFloat(existingPosition.lawPreferences.maxPqe) : 11,
	        pqe: existingPosition.lawPreferences.minPqe + ';' + existingPosition.lawPreferences.maxPqe,
	        visible: existingPosition.visible,
	        contractTypeId: existingPosition.contractTypeId,
	        occupationId: existingPosition.occupationId,
	        description: existingPosition.description,
	        externalUrl: existingPosition.externalUrl
	      };
	      if (existingPosition.type === 'Regular') vm.position.positionType = 1;
	      if (existingPosition.type === 'Custom') vm.position.positionType = 2;
	      if (existingPosition.type === 'Connect') vm.position.positionType = 3;
	      if (existingPosition.type === 'Speculative') vm.position.positionType = 4;
	      if (existingPosition.type === 'External') vm.position.positionType = 5;
	      if (existingPosition.specialties.length > 0) vm.position.practiceAreas = existingPosition.specialties.map(function (practiceArea) {
	        practiceArea.isSelected = true;
	        return practiceArea;
	      });
	
	      vm.selectedPracticesShow = existingPosition.specialties.length > 0;
	      vm.showPracticeButton = existingPosition.specialties.length === 0;
	
	      if (existingPosition.locations.length > 0) vm.position.locations = existingPosition.locations.map(function (location) {
	        location.isSelected = true;
	        return location;
	      });
	      vm.selectedLocation = existingPosition.locations.length > 0;
	      vm.showLocationButton = existingPosition.locations.length === 0;
	      console.log('CreateUpdatePositionModalCtrl', vm);
	      $scope.$applyAsync();
	    };
	
	    vm.positionDetailEditorOptions = {
	      extraPlugins: 'colorbutton'
	    };
	
	    vm.notify = function (type, message) {
	      switch (type) {
	        case 'info':
	          logger.log(message);
	          break;
	        case 'success':
	          logger.logSuccess(message);
	          break;
	        case 'warning':
	          logger.logWarning(message);
	          break;
	        case 'error':
	          logger.logError(message);
	          break;
	        default:
	          break;
	      }
	    };
	
	    vm.pqeChange = function () {
	      var separator;
	      separator = vm.position.pqe.search(';');
	      if (separator === 1) {
	        vm.position.minPqe = Number(vm.position.pqe.slice(0, 1));
	        vm.position.maxPqe = Number(vm.position.pqe.slice(2, 5));
	      } else if (separator === 2) {
	        vm.position.minPqe = Number(vm.position.pqe.slice(0, 2));
	        vm.position.maxPqe = Number(vm.position.pqe.slice(3, 5));
	      }
	    };
	
	    vm.changeEmployer = function (employer) {
	      vm.position.employer = employer;
	      vm.position.employerId = employer.id;
	      vm.position.employer.address = employer.address;
	      vm.position.employer.isInHouse = false;
	      var employerType = employer.specialties.filter(function (_ref2) {
	        var categoryId = _ref2.categoryId;
	        return categoryId === 2;
	      }).map(function (employerType) {
	        return employerType.name;
	      }).join();
	      if (employerType === 'In-House') vm.position.employer.isInHouse = true;
	    };
	
	    vm.setPositionType = function (positionType) {
	      if (positionType === 1) vm.position.type = 'Regular';
	      if (positionType === 2) vm.position.type = 'Custom';
	      if (positionType === 3) vm.position.type = 'Connect';
	      if (positionType === 4) vm.position.type = 'Speculative';
	      if (positionType === 5) vm.position.type = 'External';
	      if (positionType !== 1 && positionType !== 5) vm.position.externalUrl = undefined;
	    };
	
	    var createPosition = function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var payload, _ref4, data, status, message, _message;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                vm.setPositionType(vm.position.positionType);
	                vm.position.description = vm.position.description ? vm.position.description : '';
	
	                if (!(vm.position.practiceAreas.length > 0 && vm.position.locations.length > 0)) {
	                  _context.next = 21;
	                  break;
	                }
	
	                payload = angular.copy(vm.position);
	                // TODO: To be discussed professionId
	
	                payload.professionId = 'law';
	                payload.lawPreferences = {
	                  minPqe: payload.minPqe,
	                  maxPqe: payload.maxPqe
	                };
	                payload.specialties = payload.practiceAreas;
	
	                delete payload.employer;
	                delete payload.positionType;
	                delete payload.pqe;
	                delete payload.practiceAreas;
	                delete payload.minPqe;
	                delete payload.maxPqe;
	
	                _context.next = 15;
	                return PositionApi.createPosition(payload);
	
	              case 15:
	                _ref4 = _context.sent;
	                data = _ref4.data;
	                status = _ref4.status;
	
	                if (status === 201) {
	                  vm.initializePosition();
	                  vm.notify('success', 'Position has been added successfully.');
	                  $uibModalInstance.close({
	                    method: 'created',
	                    id: data.id,
	                    data: data
	                  });
	                  $timeout(function () {
	                    $window.location.reload();
	                  }, 500);
	                } else vm.notify('error', 'An error has occurred. Please try again.');
	                _context.next = 23;
	                break;
	
	              case 21:
	                if (vm.position.locations.length === 0) {
	                  message = 'Please select at least one Location.';
	
	                  vm.notify('error', message);
	                }
	
	                if (vm.position.practiceAreas.length === 0) {
	                  _message = 'Please select at least one practice area.';
	
	                  vm.notify('error', _message);
	                }
	
	              case 23:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      return function createPosition() {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    vm.createPosition = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              return _context2.abrupt('return', (0, _loadingOverlay.wrap)(createPosition));
	
	            case 1:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this);
	    }));
	
	    var updatePosition = function () {
	      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	        var payload, _ref7, data, status, message, _message2;
	
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                vm.setPositionType(vm.position.positionType);
	                vm.position.description = vm.position.description ? vm.position.description : '';
	
	                if (!(vm.position.practiceAreas.length > 0 && vm.position.locations.length > 0)) {
	                  _context3.next = 20;
	                  break;
	                }
	
	                payload = angular.copy(vm.position);
	
	                // To be discussed professionId
	                // payload.professionId = 'law'
	
	                payload.lawPreferences = {
	                  minPqe: payload.minPqe,
	                  maxPqe: payload.maxPqe
	                };
	                payload.specialties = payload.practiceAreas;
	
	                delete payload.employer;
	                delete payload.positionType;
	                delete payload.pqe;
	                delete payload.practiceAreas;
	                delete payload.minPqe;
	                delete payload.maxPqe;
	
	                // TODO: only update that field which are new in editable field in V1
	                // let updateDto = {}
	                // Object.keys(payload).forEach(data => {
	                //   if (payload[data] !== vm.positionRecord[data])
	                //     updateDto[data] = payload[data]
	                //   if (data === 'specialties' || data === 'locations') {
	                //     if (payload[data].length !== vm.positionRecord[data].length)
	                //       updateDto[data] = payload[data]
	                //   }
	                // })
	                // Object.keys(updateDto).forEach(
	                //   key => updateDto[key] === undefined && delete updateDto[key]
	                // )
	                //
	                _context3.next = 14;
	                return PositionApi.updatePositionById(vm.positionRecord.id, payload);
	
	              case 14:
	                _ref7 = _context3.sent;
	                data = _ref7.data;
	                status = _ref7.status;
	
	                if (status === 200) {
	                  vm.notify('success', 'Position updated successfully.');
	                  $uibModalInstance.close({
	                    method: 'updated',
	                    id: vm.positionRecord.id,
	                    data: data
	                  });
	                } else vm.notify('error', 'An error has occurred. Please try again.');
	                _context3.next = 22;
	                break;
	
	              case 20:
	                if (vm.position.locations.length === 0) {
	                  message = 'Please select at least one Location.';
	
	                  vm.notify('error', message);
	                }
	
	                if (vm.position.practiceAreas.length === 0) {
	                  _message2 = 'Please select at least one practice area.';
	
	                  vm.notify('error', _message2);
	                }
	
	              case 22:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this);
	      }));
	
	      return function updatePosition() {
	        return _ref6.apply(this, arguments);
	      };
	    }();
	
	    vm.updatePosition = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
	      return regeneratorRuntime.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              return _context4.abrupt('return', (0, _loadingOverlay.wrap)(updatePosition));
	
	            case 1:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this);
	    }));
	
	    vm.openDeletePositionModal = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	      var modalInstance;
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              modalInstance = $uibModal.open({
	                templateUrl: 'delete-position-modal.html',
	                controller: 'DeletePositionController',
	                controllerAs: 'ctrl',
	                resolve: {
	                  positionId: function positionId() {
	                    return vm.positionRecord.id;
	                  }
	                }
	              });
	
	              modalInstance.result.then(function (deletedPosition) {
	                if (deletedPosition) {
	                  vm.alertMsg = 'Position deleted successfully.';
	                  vm.showOnSuccess = true;
	                  vm.notify('success', 'Position deleted successfully.');
	                  $uibModalInstance.close({
	                    method: 'deleted',
	                    id: vm.positionRecord.id
	                  });
	                } else {
	                  vm.alertMsg = 'An error has occurred. Please try again.';
	                  vm.showOnError = true;
	                }
	              }, function () {});
	
	            case 2:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this);
	    }));
	
	    vm.openPracticeModal = function (_selectedPractice, event) {
	      event.preventDefault();
	      event.stopPropagation();
	      var onlyParentPracticeArea = vm.legalPracticeAreaList.filter(function (_ref10) {
	        var parentId = _ref10.parentId;
	        return parentId === null;
	      });
	      var modalInstance = $uibModal.open({
	        templateUrl: 'practice-area-modal.html',
	        controller: 'PracticeAreaController',
	        controllerAs: 'ctrl',
	        resolve: {
	          practiceAreaList: function practiceAreaList() {
	            return onlyParentPracticeArea;
	          },
	          selectedPractice: function selectedPractice() {
	            return _selectedPractice;
	          },
	          limit: function limit() {
	            return 0;
	          },
	          isAdminProfile: function isAdminProfile() {
	            return false;
	          },
	          displayNextButton: function displayNextButton() {
	            return false;
	          }
	        }
	      });
	      modalInstance.result.then(function (selectPractices) {
	        vm.selectedPracticesShow = selectPractices.length > 0;
	        vm.position.practiceAreas = angular.copy(selectPractices);
	      }, function () {});
	    };
	
	    vm.openLocationModal = function (_selectedLocations, event) {
	      event.preventDefault();
	      event.stopPropagation();
	      var modalInstance = $uibModal.open({
	        templateUrl: 'locations-modal.html',
	        controller: 'LocationsModalController',
	        controllerAs: 'ctrl',
	        resolve: {
	          locationList: function locationList() {
	            return vm.locationsList;
	          },
	          selectedLocations: function selectedLocations() {
	            return _selectedLocations;
	          },
	          limit: function limit() {
	            return 0;
	          },
	          locationModalHeading: function locationModalHeading() {
	            return false;
	          },
	          displayNextButton: function displayNextButton() {
	            return false;
	          }
	        }
	      });
	      modalInstance.result.then(function (selectedLocations) {
	        vm.selectedLocation = selectedLocations.length > 0;
	        vm.position.locations = angular.copy(selectedLocations);
	      }, function () {});
	    };
	
	    vm.changeStatus = function (status) {
	      if (status === 200) {
	        vm.alertMsg = 'Congratulations! Position has been Successfully created.';
	        vm.showOnSuccess = true;
	      } else if (status === 440) {
	        $location.url('/signin');
	      } else {
	        vm.alertMsg = 'An error has occurred. Please try again.';
	        vm.showOnError = true;
	      }
	    };
	
	    vm.showClass = '';
	    vm.hideDropDown = function () {
	      vm.showClass = '';
	    };
	
	    vm.closePositionModal = function () {
	      $uibModalInstance.dismiss('cancel');
	    };
	
	    vm.startPosition = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
	      var _ref12, positionRecord, positionStatus, _ref13, employersList, employersStatus, employer, _ref15, legalPracticeAreaList, legalPracticeAreaStatus, _ref16, contractTypeList, _ref17, occupationList, locationDto, _ref18, locationsList, locationsStatus;
	
	      return regeneratorRuntime.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              console.debug('startPosition');
	              _context6.next = 3;
	              return userService.getUser();
	
	            case 3:
	              vm.user = _context6.sent;
	
	              vm.initializePosition();
	
	              if (!selectedPositionId) {
	                _context6.next = 12;
	                break;
	              }
	
	              _context6.next = 8;
	              return PositionApi.getPositionById(selectedPositionId);
	
	            case 8:
	              _ref12 = _context6.sent;
	              positionRecord = _ref12.data;
	              positionStatus = _ref12.status;
	
	              if (positionStatus === 200) {
	                vm.positionRecord = positionRecord;
	                vm.initializeEditPosition(vm.positionRecord);
	              }
	
	            case 12:
	              _context6.next = 14;
	              return EmployersApi.getAllEmployers({
	                isDeleted: false,
	                include: ['id', 'name', 'address', 'specialties']
	              });
	
	            case 14:
	              _ref13 = _context6.sent;
	              employersList = _ref13.data;
	              employersStatus = _ref13.status;
	
	              if (employersStatus === 200) {
	                vm.employersList = employersList.sort(function (a, b) {
	                  return a.name > b.name ? 1 : -1;
	                });
	                if (selectedPositionId) {
	                  employer = vm.employersList.find(function (_ref14) {
	                    var id = _ref14.id;
	                    return vm.positionRecord.employerId === id;
	                  });
	
	                  vm.changeEmployer(employer);
	                }
	              } else vm.changeStatus(employersStatus);
	              _context6.next = 20;
	              return SharedApi.getCategoryById(1);
	
	            case 20:
	              _ref15 = _context6.sent;
	              legalPracticeAreaList = _ref15.data;
	              legalPracticeAreaStatus = _ref15.status;
	
	              if (legalPracticeAreaStatus === 200) {
	                vm.legalPracticeAreaList = legalPracticeAreaList.specialties;
	              } else vm.changeStatus(legalPracticeAreaStatus);
	              _context6.next = 26;
	              return SharedApi.getAllContractTypes();
	
	            case 26:
	              _ref16 = _context6.sent;
	              contractTypeList = _ref16.data;
	              _context6.next = 30;
	              return SharedApi.getAllOccupations();
	
	            case 30:
	              _ref17 = _context6.sent;
	              occupationList = _ref17.data;
	
	              vm.contractType = contractTypeList;
	              vm.occupations = occupationList;
	              locationDto = {
	                supported: true,
	                regions: true
	              };
	              _context6.next = 37;
	              return SharedApi.getAllLocations(locationDto);
	
	            case 37:
	              _ref18 = _context6.sent;
	              locationsList = _ref18.data;
	              locationsStatus = _ref18.status;
	
	              if (locationsStatus === 200) {
	                vm.locationsList = locationsList;
	              } else vm.changeStatus(locationsStatus);
	
	            case 41:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, _this);
	    }));
	
	    vm.startPosition();
	  }]);
	})();

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createUpdatePositionPageCtrl = __webpack_require__(184);
	
	var createUpdatePositionModal = function createUpdatePositionModal() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    controller: _createUpdatePositionPageCtrl.CreateUpdatePositionController,
	    template: __webpack_require__(458)
	  };
	};
	
	angular.module('app.directives').directive('createUpdatePositionModal', createUpdatePositionModal);

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dateModalCtrl = __webpack_require__(185);
	
	var dateModal = function dateModal() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    controller: _dateModalCtrl.DateModalController,
	    template: __webpack_require__(459)
	  };
	};
	
	angular.module('app.directives').directive('dateModal', dateModal);

/***/ }),
/* 675 */
/***/ (function(module, exports) {

	'use strict';
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('DatePickerController', ['$location', function controller($location) {
	    var vm = this;
	    var allowedUrlsForMonthFormat = ['/profile', '/user-profile', '/profile#!', '/admin/lawyer-profile'];
	    var oldDate = new Date();
	    vm.maxDate = new Date();
	    vm.today = function () {
	      vm.dt = new Date();
	      vm.dt.setHours(24, 0, 0, 0);
	      oldDate.setDate(oldDate.getDate() + 1);
	    };
	
	    vm.today();
	    vm.showWeeks = true;
	    vm.toggleWeeks = function () {
	      vm.showWeeks = !vm.showWeeks;
	      return vm.showWeeks;
	    };
	
	    vm.clear = function () {
	      vm.dt = undefined;
	      return vm.dt;
	    };
	
	    // $location;
	    // vm.disabled = (date, mode) => {
	    //   if ($location.url() !== '/profile') {
	    //     if (mode === 'month') {
	    //       return mode === 'month' && date > vm.dt
	    //     }
	
	    //     if (mode === 'day') {
	    //       return mode === 'day' && date < vm.dt
	    //     }
	    //   }
	    // }
	
	    vm.reverseDisabled = function (date, mode) {
	      if ($location.url() !== '/profile') {
	        if (mode === 'month') {
	          return mode === 'month' && date < vm.dt;
	        }
	
	        if (mode === 'day') {
	          return mode === 'day' && date > oldDate;
	        }
	      }
	    };
	
	    vm.toggleMin = function () {
	      var reference = void 0;
	      vm.minDate =
	      // eslint-disable-next-line no-negated-condition
	      (reference = vm.minDate) !== undefined ? reference : {
	        null: new Date()
	      };
	
	      return vm.minDate;
	    };
	
	    vm.toggleMin();
	
	    vm.open = function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	      vm.opened = true;
	      return vm.opened;
	    };
	
	    function isMonthFormatRequested(isMonthRequested) {
	      return _.contains(allowedUrlsForMonthFormat, $location.path()) || isMonthRequested;
	    }
	
	    vm.setPickerStyle = function (isMonthRequested) {
	      if (isMonthFormatRequested(isMonthRequested)) {
	        vm.dateOptions = {
	          'year-format': "'yy'",
	          'starting-day': 1,
	          'datepicker-mode': "'month'",
	          'min-mode': 'month',
	          defaultDate: '1'
	        };
	        vm.formats = ['MMMM-yyyy', 'yyyy/MM', 'shortDate'];
	      } else {
	        vm.dateOptions = {
	          'datepicker-mode': "'day'",
	          'year-format': "'yy'",
	          'starting-day': 1,
	          defaultDate: '1'
	        };
	        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM', 'shortDate'];
	      }
	
	      vm.format = vm.formats[0];
	      return vm.format;
	    };
	
	    vm.setPickerStyle();
	  }]);
	})();

/***/ }),
/* 676 */
/***/ (function(module, exports) {

	'use strict';
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('TimePickerController', ['$log', function controller($log) {
	    var vm = this;
	    vm.selectedTime = new Date();
	    vm.hourStep = 1;
	    vm.minStep = 1;
	    vm.options = {
	      hourStep: [1, 2, 3],
	      minStep: [1, 5, 10, 15, 25, 30]
	    };
	    vm.isMeridian = true;
	
	    vm.toggleMode = function () {
	      vm.isMeridian = !vm.isMeridian;
	      return vm.isMeridian;
	    };
	
	    vm.update = function () {
	      var d;
	      d = new Date();
	      d.setHours(14);
	      d.setMinutes(0);
	      vm.selectedTime = d;
	      return vm.selectedTime;
	    };
	
	    vm.changed = function () {
	      return $log.info('Time changed to: ' + vm.selectedTime);
	    };
	
	    vm.clear = function () {
	      vm.selectedTime = undefined;
	      return vm.selectedTime;
	    };
	  }]);
	})();

/***/ }),
/* 677 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('DeleteEmployerController', ['employerId', '$uibModalInstance', 'EmployersApi', '$log', '$rootScope', function controller(employerId, $uibModalInstance, EmployersApi, $log, $rootScope) {
	    var _this = this;
	
	    var vm = this;
	    vm.employerId = employerId;
	
	    vm.cancel = function () {
	      $uibModalInstance.dismiss('cancel');
	    };
	
	    vm.delete = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var _ref2, status, data;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              // eslint-disable-next-line angular/controller-as
	              $rootScope.isEmployerDeleted = true;
	
	              _context.prev = 1;
	              _context.next = 4;
	              return EmployersApi.deleteEmployerById(vm.employerId);
	
	            case 4:
	              _ref2 = _context.sent;
	              status = _ref2.status;
	              data = _ref2.data;
	
	              if (status === 200) $uibModalInstance.close(data);else $uibModalInstance.close(false);
	              _context.next = 14;
	              break;
	
	            case 10:
	              _context.prev = 10;
	              _context.t0 = _context['catch'](1);
	
	              $log.error(_context.t0);
	              $uibModalInstance.close(false);
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this, [[1, 10]]);
	    }));
	  }]);
	})();

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _deleteEmployerCtrl = __webpack_require__(677);
	
	var deleteEmployer = function deleteEmployer() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    controller: _deleteEmployerCtrl.DeleteEmployerController,
	    template: __webpack_require__(460)
	  };
	};
	
	angular.module('app.directives').directive('deleteEmployer', deleteEmployer);

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _deletePositionCtrl = __webpack_require__(186);
	
	var deletePosition = function deletePosition() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    controller: _deletePositionCtrl.DeletePositionController,
	    template: __webpack_require__(461)
	  };
	};
	
	angular.module('app.directives').directive('deletePosition', deletePosition);

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _common = __webpack_require__(33);
	
	(function () {
	  angular.module('app.directives', []).directive('imgHolder', [function () {
	    return {
	      restrict: 'A',
	      link: function link(scope, ele, attrs) {
	        return Holder.run({
	          images: ele[0]
	        });
	      }
	    };
	  }]).directive('customBackground', function () {
	    var getClass = function getClass() {
	      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      if ((0, _common.isSignUpPage)(path) || (0, _common.isResetPasswordPage)(path)) {
	        return 'body-special';
	      }
	
	      switch (path) {
	        case '/':
	        case '/404':
	        case '/502':
	        case '/500':
	        case '/signin':
	        case '/forgot':
	        case '/admin/firm-management':
	        case '/admin/job-creation':
	        case '/admin/applied-jobs':
	        case '/invite-friend':
	        case '/profile':
	        case '/user-profile':
	        case '/admin/admin-listings':
	        case '/admin/inactive-positions':
	        case '/admin/lawyer-listing':
	        case '/admin/referral-listing':
	        case '/admin/email-listing':
	        case '/admin/employers-listing':
	        case '/admin/application-listing':
	        case '/admin/matching-lawyers-listing':
	        case '/opportunities':
	        case '/connections':
	        case '/home':
	        case '/change-password':
	        case '/admin/lawyer-profile':
	        case '/admin/job-edit':
	        case '/admin/job-clone':
	        case '/for-employers':
	        case '/about':
	        case '/faqs':
	        case '/terms-conditions':
	        case '/privacy-policy':
	        case '/invite-friends':
	        case '/sitemap':
	        case '/sitemap.xml':
	        case '/new-lawyer-referral':
	        case '/admin/matching-lawyers':
	        case '/site-maintenance':
	        case '/get-in-touch':
	        case '/inhouse-jobs':
	        case '/matches':
	        case '/unsubscribe':
	        case '/admin/firm-notes':
	        case '/pause':
	        case '/admin/email-history':
	        case '/admin/email-history-view':
	        case '/admin/edit-email':
	        case '/admin/email-body':
	          return 'body-special';
	        case '/pages/lock-screen':
	          return 'body-special body-lock';
	        case '/tasks':
	          return 'body-tasks';
	        default:
	          return '';
	      }
	    };
	
	    return {
	      restrict: 'A',
	      controller: ['$scope', '$element', '$location', function ($scope, $element, $location) {
	        var addBg, path;
	        path = function path() {
	          return $location.path();
	        };
	        addBg = function addBg(path) {
	          $element.removeClass('body-home body-special body-tasks body-lock');
	          $element.addClass(getClass(path));
	        };
	        addBg($location.path());
	        return $scope.$watch(path, function (newVal, oldVal) {
	          if (newVal === oldVal) {
	            return;
	          }
	          return addBg($location.path());
	        });
	      }]
	    };
	  }).directive('uiColorSwitch', [function () {
	    return {
	      restrict: 'A',
	      link: function link(scope, ele, attrs) {
	        return ele.find('.color-option').on('click', function (event) {
	          var $this, hrefUrl, style;
	          $this = $(this);
	          hrefUrl = void 0;
	          style = $this.data('style');
	          if (style === 'loulou') {
	            hrefUrl = 'styles/main.css';
	            $('link[href^="styles/main"]').attr('href', hrefUrl);
	          } else if (style) {
	            style = '-' + style;
	            hrefUrl = 'styles/main' + style + '.css';
	            $('link[href^="styles/main"]').attr('href', hrefUrl);
	          } else {
	            return false;
	          }
	          return event.preventDefault();
	        });
	      }
	    };
	  }]).directive('toggleMinNav', ['$rootScope', function ($rootScope) {
	    return {
	      restrict: 'A',
	      link: function link(scope, ele, attrs) {
	        var $content, $nav, $window, Timer, app, updateClass;
	        app = $('#app');
	        $window = $(window);
	        $nav = $('#nav-container');
	        $content = $('#content');
	        ele.on('click', function (e) {
	          if (app.hasClass('nav-min')) {
	            app.removeClass('nav-min');
	          } else {
	            app.addClass('nav-min');
	            $rootScope.$broadcast('minNav:enabled');
	          }
	          return e.preventDefault();
	        });
	        Timer = void 0;
	        updateClass = function updateClass() {
	          var width;
	          width = $window.width();
	          if (width < 768) {
	            return app.removeClass('nav-min');
	          }
	        };
	        return $window.resize(function () {
	          var t;
	          clearTimeout(t);
	          return t = setTimeout(updateClass, 300);
	        });
	      }
	    };
	  }]).directive('collapseNav', [function () {
	    return {
	      restrict: 'A',
	      link: function link(scope, ele, attrs) {
	        var $a, $aRest, $lists, $listsRest, app;
	        $lists = ele.find('ul').parent('li');
	        $lists.append('<i class="fa fa-caret-right icon-has-ul"></i>');
	        $a = $lists.children('a');
	        $listsRest = ele.children('li').not($lists);
	        $aRest = $listsRest.children('a');
	        app = $('#app');
	        $a.on('click', function (event) {
	          var $parent, $this;
	          if (app.hasClass('nav-min')) {
	            return false;
	          }
	          $this = $(this);
	          $parent = $this.parent('li');
	          $lists.not($parent).removeClass('open').find('ul').slideUp();
	          $parent.toggleClass('open').find('ul').stop().slideToggle();
	          return event.preventDefault();
	        });
	        $aRest.on('click', function (event) {
	          return $lists.removeClass('open').find('ul').slideUp();
	        });
	        return scope.$on('minNav:enabled', function (event) {
	          return $lists.removeClass('open').find('ul').slideUp();
	        });
	      }
	    };
	  }]).directive('highlightActive', [function () {
	    return {
	      restrict: 'A',
	      controller: ['$scope', '$element', '$attrs', '$location', function ($scope, $element, $attrs, $location) {
	        var highlightActive, links, path;
	        links = $element.find('a');
	        path = function path() {
	          return $location.path();
	        };
	        highlightActive = function highlightActive(links, path) {
	          path = '#' + path;
	          return angular.forEach(links, function (link) {
	            var $li, $link, href;
	            $link = angular.element(link);
	            $li = $link.parent('li');
	            href = $link.attr('href');
	            if ($li.hasClass('active')) {
	              $li.removeClass('active');
	            }
	            if (path.indexOf(href) === 0) {
	              return $li.addClass('active');
	            }
	          });
	        };
	        highlightActive(links, $location.path());
	        return $scope.$watch(path, function (newVal, oldVal) {
	          if (newVal === oldVal) {
	            return;
	          }
	          return highlightActive(links, $location.path());
	        });
	      }]
	    };
	  }]).directive('toggleOffCanvas', [function () {
	    return {
	      restrict: 'A',
	      link: function link(scope, ele, attrs) {
	        return ele.on('click', function () {
	          return $('#app').toggleClass('on-canvas');
	        });
	      }
	    };
	  }]).directive('slimScroll', [function () {
	    return {
	      restrict: 'A',
	      link: function link(scope, ele, attrs) {
	        return ele.slimScroll({
	          height: attrs.scrollHeight || '100%'
	        });
	      }
	    };
	  }]).directive('goBack', [function () {
	    return {
	      restrict: 'A',
	      controller: ['$scope', '$element', '$window', function ($scope, $element, $window) {
	        return $element.on('click', function () {
	          return $window.history.back();
	        });
	      }]
	    };
	  }]).directive('readMore', function ($sce) {
	    return {
	      restrict: 'AE',
	      scope: {
	        hmtext: '@',
	        hmlimit: '@',
	        hmfulltext: '@',
	        hmMoreText: '@',
	        hmLessText: '@',
	        hmMoreClass: '@',
	        hmLessClass: '@'
	      },
	      template: '\n          <span ng-if="hmtext.length > hmlimit">\n            <span ng-hide="hmfulltext" ng-bind-html="hmtext | limitTo:hmlimit"></span>\n            <span ng-hide="hmfulltext">\n              ... &nbsp;&nbsp;\n              <a class="more-class" href="" ng-click="toggleValue()">{{ hmMoreText }}</a>\n            </span>\n            <p ng-show="hmfulltext" ng-bind-html="hmtext"></p>\n            <span ng-show="hmfulltext">\n              <br>\n              <a class="more-class" href="" ng-click="toggleValue()">{{ hmLessText }}</a>\n            </span>\n          </span>\n\n          <span ng-if="hmtext.length <= hmlimit" ng-bind-html="hmtext"></span>\n\n          <style type="text/css">\n            .more-class {\n              color: #4c9bda;\n            }\n          </style>\n      ',
	      transclude: true,
	      controller: function controller($scope) {
	        $scope.toggleValue = function () {
	          $scope.hmfulltext = !$scope.hmfulltext;
	        };
	      }
	    };
	  }).directive('onlyAlphabets', function () {
	    var isALetter,
	        allowedChars = [' ', '&', "'", '’', ',', '-', '_'];
	    isALetter = function isALetter(charVal) {
	      return charVal.toUpperCase() !== charVal.toLowerCase() || allowedChars.includes(charVal) ? true : false;
	    };
	    return {
	      restrict: 'A',
	      require: '?ngModel',
	      link: function link(scope, element, attrs, ngModel) {
	        if (!ngModel) {
	          return;
	        }
	        ngModel.$parsers.unshift(function (inputValue) {
	          var alphabets;
	          alphabets = inputValue.split('').filter(function (s) {
	            return isALetter(s);
	          }).join('');
	          ngModel.$viewValue = alphabets;
	          ngModel.$render();
	          return alphabets;
	        });
	      }
	    };
	  }).directive('isAlphabet', function () {
	    var isALetter,
	        allowedChars = [' ', '-', "'"];
	    isALetter = function isALetter(charVal) {
	      return charVal.toUpperCase() !== charVal.toLowerCase() || allowedChars.includes(charVal) ? true : false;
	    };
	    return {
	      restrict: 'A',
	      require: '?ngModel',
	      link: function link(scope, element, attrs, ngModel) {
	        if (!ngModel) {
	          return;
	        }
	        ngModel.$parsers.unshift(function (inputValue) {
	          var alphabets;
	          alphabets = inputValue.split('').filter(function (s) {
	            return isALetter(s);
	          }).join('');
	          ngModel.$viewValue = alphabets;
	          ngModel.$render();
	          return alphabets;
	        });
	      }
	    };
	  }).directive('onlyNumbers', function () {
	    var isALetter;
	    isALetter = function isALetter(charVal) {
	      if (charVal.toUpperCase() !== charVal.toLowerCase() || charVal === ' ' || charVal === ',' || charVal === '.' || charVal === 'm') {
	        return false;
	      } else {
	        return true;
	      }
	    };
	    return {
	      restrict: 'A',
	      require: '?ngModel',
	      link: function link(scope, element, attrs, ngModel) {
	        if (!ngModel) {
	          return;
	        }
	        ngModel.$parsers.unshift(function (inputValue) {
	          var alphabets;
	          alphabets = inputValue.split('').filter(function (s) {
	            return isALetter(s);
	          }).join('');
	          ngModel.$viewValue = alphabets;
	          ngModel.$render();
	          return alphabets;
	        });
	      }
	    };
	  }).directive('alphabetsNumbers', function () {
	    var isALetter;
	    isALetter = function isALetter(charVal) {
	      if (charVal.toUpperCase() !== charVal.toLowerCase() || charVal === ' ' || charVal === '_' || charVal === '-' || charVal === '.' || ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].indexOf(charVal) >= 0) {
	        return true;
	      } else {
	        return false;
	      }
	    };
	    return {
	      restrict: 'A',
	      require: '?ngModel',
	      link: function link(scope, element, attrs, ngModel) {
	        if (!ngModel) {
	          return;
	        }
	        ngModel.$parsers.unshift(function (inputValue) {
	          var alphabets;
	          alphabets = inputValue.split('').filter(function (s) {
	            return isALetter(s);
	          }).join('');
	          ngModel.$viewValue = alphabets;
	          ngModel.$render();
	          return alphabets;
	        });
	      }
	    };
	  }).directive('limitTo', [function () {
	    return {
	      restrict: 'A',
	      link: function link(scope, elem, attrs) {
	        var limit;
	        limit = parseInt(attrs.limitTo);
	        angular.element(elem).on('keypress', function (e) {
	          if (this.value.length === limit) {
	            e.preventDefault();
	          }
	        });
	      }
	    };
	  }]).directive('addfields', function ($compile) {
	    return function (scope, element, attrs) {
	      element.bind('click', function () {
	        scope.educationFields = false;
	        angular.element(document.getElementById('space-for-fields')).append($compile('')(scope));
	      });
	    };
	  }).directive('alert', function () {
	    return function (scope, element, attrs) {
	      element.bind('click', function () {
	        // alert('This is alert #' + attrs.alert)
	      });
	    };
	  }).directive('ngRightClick', function ($parse) {
	    return function (scope, element, attrs) {
	      var fn;
	      fn = $parse(attrs.ngRightClick);
	      element.bind('contextmenu', function (event) {
	        scope.$apply(function () {
	          event.preventDefault();
	          fn(scope, {
	            $event: event
	          });
	        });
	      });
	    };
	  });
	}).call(undefined);

/***/ }),
/* 681 */
/***/ (function(module, exports) {

	'use strict';
	
	var fileUpload = function fileUpload($parse) {
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attributes) {
	      var model = $parse(attributes.fileUpload);
	      var modelSetter = model.assign;
	
	      element.bind('change', function () {
	        scope.$apply(function () {
	          modelSetter(scope, element[0].files[0]);
	        });
	      });
	    }
	  };
	};
	
	angular.module('app.directives').directive('fileUpload', ['$parse', fileUpload]);

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.lexstepFooterCtrl = exports.getDefaultContactDetails = undefined;
	
	var _segment = __webpack_require__(21);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var lexstepFooterCtrl = function lexstepFooterCtrl($scope, sharedProperties, socket, userService, $timeout) {
	  socket.on('CANDIDATE_ASSIGNED_AGENT_UPDATE', function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(candidateId) {
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        if (!($scope.user.id === candidateId)) {
	                          _context.next = 6;
	                          break;
	                        }
	
	                        _context.next = 3;
	                        return userService.refreshUser($scope.user);
	
	                      case 3:
	                        $scope.user = _context.sent;
	
	                        prepareFooter();
	                        $scope.$applyAsync();
	
	                      case 6:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, undefined);
	              })), 1500);
	
	            case 1:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }());
	
	  socket.on('CANDIDATE_PROFILE_AGENT_UPDATE', function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(candidateId) {
	      return regeneratorRuntime.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                  while (1) {
	                    switch (_context3.prev = _context3.next) {
	                      case 0:
	                        if (!($scope.user.id === candidateId)) {
	                          _context3.next = 6;
	                          break;
	                        }
	
	                        _context3.next = 3;
	                        return userService.refreshUser($scope.user);
	
	                      case 3:
	                        $scope.user = _context3.sent;
	
	                        prepareFooter();
	                        $scope.$applyAsync();
	
	                      case 6:
	                      case 'end':
	                        return _context3.stop();
	                    }
	                  }
	                }, _callee3, undefined);
	              })), 1500);
	
	            case 1:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, undefined);
	    }));
	
	    return function (_x2) {
	      return _ref3.apply(this, arguments);
	    };
	  }());
	
	  var getContactDetailsForOthers = function getContactDetailsForOthers() {
	    var assignedAdmin = $scope.user.agent;
	    return getContactDetails(assignedAdmin, sharedProperties);
	  };
	
	  var setDefaultContactDetails = function setDefaultContactDetails() {
	    angular.extend($scope, getDefaultContactDetails(sharedProperties));
	  };
	
	  var setAgentContactDetailsForOthers = function setAgentContactDetailsForOthers() {
	    angular.extend($scope, getContactDetailsForOthers());
	  };
	
	  var prepareFooter = function prepareFooter() {
	    if ($scope.user) {
	      if (userHaveNoAgentAssign($scope)) setDefaultContactDetails();else setAgentContactDetailsForOthers();
	    }
	  };
	
	  $scope.socialLinkClick = function (type) {
	    (0, _segment.socialButtonClick)(type);
	  };
	
	  $scope.$on('user-load', prepareFooter);
	
	  $scope.currentYear = new Date().getFullYear();
	};
	
	var userHaveNoAgentAssign = function userHaveNoAgentAssign($scope) {
	  var agent = $scope.user && $scope.user.agent;
	  return agent ? Object.keys(agent).length === 0 : true;
	};
	
	var getDefaultContactDetails = exports.getDefaultContactDetails = function getDefaultContactDetails(sharedProperties) {
	  return {
	    contactUsername: sharedProperties.getDefaultContactUsername(),
	    contactEmail: sharedProperties.getDefaultContactEmail(),
	    contactPhone: sharedProperties.getDefaultContactPhone()
	  };
	};
	
	var getContactDetails = function getContactDetails(assignedAdmin, sharedProperties) {
	  return {
	    contactUsername: (assignedAdmin.lastName && assignedAdmin.firstName ? assignedAdmin.firstName + ' ' + assignedAdmin.lastName : assignedAdmin.firstName) || sharedProperties.getDefaultContactUsername(),
	    contactEmail: assignedAdmin.email || sharedProperties.getDefaultContactEmail(),
	    contactPhone: assignedAdmin.phone || sharedProperties.getDefaultContactPhone()
	  };
	};
	
	exports.lexstepFooterCtrl = lexstepFooterCtrl;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _footer = __webpack_require__(682);
	
	function lexstepFooter() {
	  return {
	    restrict: 'AE',
	    scope: false,
	    replace: true,
	    template: __webpack_require__(462),
	    controller: _footer.lexstepFooterCtrl
	  };
	}
	
	angular.module('app.directives.lexstepFooter').directive('lexstepFooter', lexstepFooter);

/***/ }),
/* 684 */
/***/ (function(module, exports) {

	'use strict';
	
	/********************************************************************/
	/*** Initially Implemeneted By Fahad Akbar(fahadakbar24@gmail.com) **/
	/********************************************************************/
	
	angular.module('app.directives.lexstepFooter', []);

/***/ }),
/* 685 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable angular/document-service */
	/* eslint-disable unicorn/prefer-query-selector */
	var groupPipelineController = exports.groupPipelineController = function groupPipelineController($scope, $timeout) {
	  $scope.onClickPipeline = function (data) {
	    if (data.parentID === 'ROOT_NODE_ID' && data.selected) {
	      $scope.groupList.map(function (row) {
	        row.selected = false;
	        row.isActive = false;
	        if (row.parentID !== 'ROOT_NODE_ID') row.isHidden = true;
	        return row;
	      });
	    } else if (data.selected) {
	      $scope.groupList.forEach(function (row) {
	        if (data.parentID !== 'ROOT_NODE_ID' && data.id === row.parentID && data.selected) {
	          if (row.hasChild && row.selected) {
	            hasChildGroup(row);
	          }
	
	          data.isActive = false;
	          row.isHidden = true;
	          row.selected = false;
	        }
	      });
	      data.selected = false;
	    } else {
	      $scope.groupList.map(function (row) {
	        if (row.id === data.id) {
	          row.selected = true;
	        } else {
	          row.isHidden = true;
	          row.selected = false;
	        }
	      });
	      if (data.hasChild) {
	        $scope.groupList.map(function (row) {
	          if (row.parentID === data.id) {
	            if (row.selected) {
	              row.selected = false;
	              openCloseGroups(row);
	            } else {
	              data.selected = true;
	              data.isHidden = false;
	              setActiveGridItem(data);
	              scrollTo(data.id);
	            }
	
	            row.isHidden = !row.isHidden;
	          }
	        });
	      } else {
	        data.selected = true;
	        data.isHidden = false;
	        setActiveGridItem(data);
	        scrollTo(data.id);
	      }
	    }
	
	    var maxLevel = Math.max.apply(Math, $scope.groupList.map(function (o) {
	      return o.level;
	    }));
	    if (maxLevel !== data.level) {
	      $scope.groupList.map(function (row) {
	        if (data.selected && data.parentID === 'ROOT_NODE_ID' && row.parentID === 'ROOT_NODE_ID') {
	          row.prevActive = false;
	          row.isActive = false;
	        }
	
	        if (row.level > data.level && data.selected) {
	          row.prevActive = false;
	          row.isActive = false;
	        }
	
	        if (row.level === data.level && !row.selected) {
	          row.isActive = false;
	        }
	      });
	    }
	
	    var currentIndex = $scope.groupList.indexOf(data);
	
	    var temporaryData = $scope.groupList.find(function (row) {
	      if (!row.isHidden && $scope.groupList.indexOf(row) > currentIndex && (row.level <= data.level || row.level === data.level && !row.level)) return row;
	    });
	    if (maxLevel !== data.level && data.selected) {
	      if (temporaryData) {
	        var index = $scope.groupList.indexOf(temporaryData) - 1;
	        while (index) {
	          if (!$scope.groupList[index].isHidden && $scope.groupList[index].level !== maxLevel && !$scope.groupList[index].selected) {
	            $scope.groupList[index].prevActive = true;
	            index = 0;
	          } else if ($scope.groupList[$scope.groupList.indexOf(temporaryData) - 1].level === maxLevel && !$scope.groupList[index].isHidden && $scope.groupList[index].level) {
	            index = 0;
	          } else index--;
	        }
	      }
	
	      data.isActive = true;
	    }
	
	    $timeout(function () {
	      angular.element('#emptyClick').triggerHandler('click');
	    }, 50);
	  };
	
	  var setActiveGridItem = function setActiveGridItem(item) {
	    $scope.groupList.forEach(function (row) {
	      if (item.parentID === row.parentID) row.isHidden = false;
	      if (row.id === item.parentID) {
	        if (row.id !== 'ROOT_NODE_ID') setActiveGridItem(row);
	        row.selected = true;
	        row.isHidden = false;
	      }
	    });
	  };
	
	  var scrollTo = function scrollTo(state) {
	    var index = $scope.gridOptions.api.getModel().rowsToDisplay.findIndex(function (row) {
	      return row.id === state;
	    });
	    $scope.gridOptions.api.ensureIndexVisible(index, 'top');
	  };
	
	  var openCloseGroups = function openCloseGroups(data) {
	    $scope.groupList.forEach(function (row) {
	      if (row.parentID === data.id) {
	        if (data.hasChild) openCloseGroups(row);
	        row.selected = false;
	        row.isHidden = true;
	        return row;
	      }
	    });
	  };
	
	  var hasChildGroup = function hasChildGroup(data) {
	    var dataChildren = $scope.groupList.filter(function (x) {
	      return x.parentID === data.id;
	    });
	    dataChildren.map(function (child) {
	      if (child.hasChild && child.selected) openCloseGroups(child);
	      child.selected = false;
	      child.isHidden = true;
	      return child;
	    });
	  };
	
	  $scope.fetchArrowStyle = function (color) {
	    return {
	      'border-top': '1px solid ' + color,
	      'border-right': '1px solid ' + color
	    };
	  };
	
	  $scope.fetchActiveTab = function (color, stage) {
	    var faddedColor = void 0;
	    faddedColor = color ? lighten(color, 60) : '#fffff';
	    var activeClass = document.getElementById(stage.id);
	    if (activeClass.classList.contains('active')) {
	      if (stage.hasChild) {
	        activeClass.style.background = '#95288f';
	        activeClass.style.color = '#ffffff';
	        activeClass.querySelector('.triangular-tabs').style.boxShadow = '1.4px -1.4px 0px 0px #ffffff';
	        activeClass.querySelector('.triangular-tabs').style.borderColor = '#95288f #95288f transparent transparent';
	      } else {
	        activeClass.style.background = faddedColor;
	        activeClass.style.boxShadow = '8px 2px 7px 2px #ccc';
	        activeClass.querySelector('.triangular-tabs').style.boxShadow = '1.4px -1.4px 0px 0px ' + color + ',6.4px -6.4px 6px -1px #ccc';
	
	        activeClass.querySelector('.triangular-tabs').style.borderColor = faddedColor + ' ' + faddedColor + ' transparent transparent';
	        activeClass.style.borderTop = '1px solid ' + color;
	        activeClass.style.borderBottom = '1px solid ' + color;
	        activeClass.style.borderRight = '0px';
	        activeClass.style.borderLeft = '0px';
	      }
	
	      activeClass.querySelector('.triangular-tabs').style.borderWidth = '18px';
	      activeClass.querySelector('.triangular-tabs').style.borderStyle = 'solid';
	    } else {
	      if (stage.hasChild) {
	        activeClass.style.background = stage.color;
	        if (activeClass.style.background === 'rgb(247, 247, 247)' || activeClass.style.background === 'rgb(255, 255, 255)') activeClass.style.color = '#000000';else activeClass.style.color = '#ffffff';
	        activeClass.querySelector('.triangular-tabs').style.borderColor = stage.color + ' ' + stage.color + ' transparent transparent';
	        activeClass.querySelector('.triangular-tabs').style.boxShadow = '1.4px -1.4px 0px 0px  #ffffff';
	      } else {
	        activeClass.style.background = 'transparent';
	        activeClass.querySelector('.triangular-tabs').style.borderColor = 'white white transparent transparent';
	        activeClass.querySelector('.triangular-tabs').style.boxShadow = '1.4px -1.4px 0px 0px ' + color;
	        activeClass.style.borderTop = '1px solid ' + color;
	        activeClass.style.borderBottom = '1px solid ' + color;
	        activeClass.style.borderRight = '0px';
	        activeClass.style.borderLeft = '0px';
	      }
	
	      activeClass.querySelector('.triangular-tabs').style.borderWidth = '18px';
	      activeClass.querySelector('.triangular-tabs').style.borderStyle = 'solid';
	    }
	  };
	};
	
	var addLight = function addLight(color, amount) {
	  var cc = Number.parseInt(color, 16) + amount;
	  var c = cc > 255 ? 255 : cc;
	  c = c.toString(16).length > 1 ? c.toString(16) : '0' + c.toString(16);
	  return c;
	};
	
	var lighten = function lighten(color, amount) {
	  color = color.includes('#') ? color.slice(1, color.length) : color;
	  amount = Number(255 * amount / 100);
	  color = '#' + addLight(color.slice(0, 2), amount) + addLight(color.slice(2, 4), amount) + addLight(color.slice(4, 6), amount);
	  return color;
	};

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _controller = __webpack_require__(685);
	
	var groupPipeline = function groupPipeline() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      groupList: '=',
	      gridOptions: '='
	    },
	    controller: _controller.groupPipelineController,
	    template: __webpack_require__(463)
	  };
	};
	
	angular.module('app.directives').directive('groupPipeline', groupPipeline);

/***/ }),
/* 687 */
/***/ (function(module, exports) {

	'use strict';
	
	/**************************************************************************/
	/*** ML Query Builder implemented By Fahad Akbar(fahadakbar24@gmail.com)***/
	/**************************************************************************/
	
	angular.module('app.lexstepHeader').factory('headerApi', ['api', function (api) {
	
	  var headerApi = {
	    updateMeMoveAlert: function updateMeMoveAlert(payload) {
	      return api.request('POST', '/api/lawyer/update/alert/me-move', payload);
	    }
	  };
	
	  return headerApi;
	}]);

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _segment = __webpack_require__(21);
	
	var _package = __webpack_require__(230);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-undef */
	
	
	(function module() {
	  angular.module('app.lexstepHeader', []).directive('lexstepHeader', function directive() {
	    return {
	      // eslint-disable-next-line angular/directive-restrict
	      restrict: 'AE',
	      replace: true,
	      template: __webpack_require__(464),
	      controller: headerCtrl
	    };
	  });
	  function headerCtrl($rootScope, $scope, $location, userService, accountPermission, headerApi, logger, $window, api) {
	    var _this = this;
	
	    $window.addEventListener('storage', function syncLogout(event) {
	      if (event.key === 'logout') {
	        $window.localStorage.setItem('logout', Date.now());
	        $window.localStorage.removeItem('token');
	        $window.localStorage.removeItem('user');
	        $window.location.href = '/signin';
	      }
	
	      if (event.key === 'signIn') {
	        var user = JSON.parse($window.localStorage.getItem('user'));
	        if (user) $location.path(user.defaultRoute);
	        $scope.$apply();
	      }
	
	      if (event.key === 'tokenInMemoryUpdated') {
	        var token = $window.localStorage.getItem('token');
	        if (token) {
	          api.updateInMemoryToken(JSON.parse(token));
	        }
	      }
	    });
	
	    $scope.applicationInfo = {
	      version: _package.version
	    };
	
	    $scope.serverInfo = {
	      version: ''
	    };
	
	    var getServerVersion = function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var result;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return api.get('health/info');
	
	              case 2:
	                result = _context.sent;
	
	                $scope.serverInfo = result;
	                return _context.abrupt('return', result);
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      return function getServerVersion() {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    var setServerInfo = function setServerInfo() {
	      getServerVersion().then(function (_ref2) {
	        var data = _ref2.data;
	
	        $scope.serverInfo = data;
	        $scope.$applyAsync();
	      });
	    };
	
	    setServerInfo();
	
	    $rootScope.$on('$routeChangeStart', function on(_event, _current) {
	      setServerInfo();
	    });
	
	    $scope.path = $location.url();
	    // eslint-disable-next-line unicorn/consistent-function-scoping
	    var notifyControllersThatTheUserIsLoaded = function notifyControllersThatTheUserIsLoaded(rootScope, user) {
	      rootScope.$broadcast('user-load', user);
	    };
	
	    function updateUserModel(result) {
	      $rootScope.user = result;
	      setUserProfilePic($rootScope.user);
	      notifyControllersThatTheUserIsLoaded($rootScope, $rootScope.user);
	      $scope.$apply();
	      if (result) {
	        showMeMoveAlert();
	      }
	    }
	
	    var resetUserModel = function resetUserModel() {
	      userService.setUser().then(updateUserModel);
	    };
	
	    var hideMeMoveNotification = function hideMeMoveNotification() {
	      var hideAlert = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $rootScope.hideMeMoveAlert;
	      var hidePopup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $rootScope.hideMeMoveAlertPopup;
	
	      headerApi.updateMeMoveAlert({
	        userId: $rootScope.user.user_ID,
	        isAlertSeen: hideAlert,
	        isPopupSeen: hidePopup
	      }).then(function () {
	        $scope.meMoveAlert = 'zoomOutRight';
	        $rootScope.hideMeMoveAlert = hideAlert;
	        $rootScope.user.lawyer.meMoveAlert = hideAlert;
	        $rootScope.hideMeMoveAlertPopup = hidePopup;
	        $rootScope.user.lawyer.meMoveAlertPopup = hidePopup;
	
	        if (hidePopup) {
	          toastr.clear();
	        }
	      });
	    };
	
	    var updateMeMoveAlertPopup = function updateMeMoveAlertPopup() {
	      hideMeMoveNotification(undefined, true);
	    };
	
	    var showMeMoveAlert = function showMeMoveAlert() {
	      if ($rootScope.user && $rootScope.user.lawyer) {
	        var profileUrl = '/user-profile';
	        var currentUrl = $location.url();
	        $rootScope.hideMeMoveAlert = $rootScope.user.lawyer.meMoveAlert;
	        $rootScope.hideMeMoveAlertPopup = $rootScope.user.lawyer.meMoveAlertPopup;
	
	        if (!$rootScope.hideMeMoveAlert && currentUrl === profileUrl) {
	          hideMeMoveNotification(true, true);
	        }
	
	        if (!$rootScope.hideMeMoveAlertPopup && !$rootScope.isVisibleMeMoveAlert) {
	          logger.notify('warning', "<span class='meMoveAlertPopupText'> Select 'My Profile' under your name above to edit your LexStep Profile and Preferences.</span>", {
	            onHidden: updateMeMoveAlertPopup,
	            onShown: customizeMeMovePopup,
	            timeOut: 0,
	            extendedTimeOut: 0,
	            preventDuplicates: true
	          });
	          $rootScope.isVisibleMeMoveAlert = true;
	        }
	      }
	    };
	
	    var initializeSettings = function initializeSettings() {
	      showMeMoveAlert();
	      $rootScope.isSpecOppsUrl = $location.path() === '/opportunities';
	    };
	
	    $scope.showClass = '';
	    userService.verifySession().then(updateUserModel);
	
	    $scope.hideAllNotifications = function () {
	      updateMeMoveAlertPopup();
	    };
	
	    $scope.hideDropDown = function (type) {
	      $scope.showClass = '';
	      if (type === 'videos') {
	        (0, _segment.menuVideos)();
	      } else if (type === 'sign-up') {
	        (0, _segment.signUpPageView)();
	      }
	    };
	
	    $scope.trackPageRedirection = function () {
	      (0, _segment.trackOpen)();
	    };
	
	    $scope.isEmailListingAllowed = function () {
	      return accountPermission.isEmailListingAllowed($rootScope.user);
	    };
	
	    $scope.isLawyerListingAllowed = function () {
	      return accountPermission.isLawyerListingAllowed($rootScope.user);
	    };
	
	    $scope.openClassOnList = function (id) {
	      // eslint-disable-next-line angular/document-service
	      var element = angular.element(document.querySelector(String(String(id))));
	      element.addClass('open');
	    };
	
	    $scope.logOut = function () {
	      toastr.remove();
	      $rootScope.user = {};
	      api.endSession();
	    };
	
	    $scope.showDropDown = function () {
	      if ($scope.showClass === '') {
	        $scope.showClass = 'show';
	      } else {
	        $scope.showClass = '';
	      }
	    };
	
	    $scope.onClickNavItem = function (title) {
	      var user = $rootScope.user;
	      var eventLabel = 'User(' + user.user_ID + '): ' + user.first_Name;
	
	      // eslint-disable-next-line angular/window-service
	      window.ga('send', 'event', {
	        eventCategory: title,
	        eventAction: 'expand',
	        eventLabel: eventLabel
	      });
	    };
	
	    $rootScope.$on('user-update', resetUserModel);
	    $rootScope.$on('$routeChangeStart', initializeSettings);
	  }
	})();
	
	var setUserProfilePic = function setUserProfilePic(user) {
	  if (user) {
	    if (user.profilePicture && user.profilePicture.contains('https')) user.profilePicSrc = user.profilePicture;else user.profilePicSrc = user.profilePicture ? ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/user/' + user.id + '/photo/' + user.profilePicture : 'images/defaultPic.jpg';
	  }
	};
	
	var customizeMeMovePopup = function customizeMeMovePopup() {
	  var meMoveAlertPopup = $('.meMoveAlertPopupText');
	  meMoveAlertPopup.parents('.toast').css({ opacity: '1' });
	  meMoveAlertPopup.parents('#toast-container').css({
	    // eslint-disable-next-line angular/window-service
	    top: window.innerWidth > 1024 ? '140px' : '64px'
	  });
	};

/***/ }),
/* 689 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.api').factory('CandidatePreferencesApi', ['api', function CandidatePreferencesApi(api) {
	  var _this = this;
	
	  var candidatePreferencesApi = {
	    updateCandidatePreferences: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id, preferences) {
	        var payload;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                payload = {
	                  candidatePreference: preferences
	                };
	                return _context.abrupt('return', api.put('users/' + id + '/profile', payload));
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function updateCandidatePreferences(_x, _x2) {
	        return _ref.apply(this, arguments);
	      }
	
	      return updateCandidatePreferences;
	    }()
	  };
	  return candidatePreferencesApi;
	}]);

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.lawyerPreferencesController = undefined;
	
	var _segment = __webpack_require__(21);
	
	var _loadingOverlay = __webpack_require__(20);
	
	var _common = __webpack_require__(33);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable unicorn/no-null */
	/* eslint-disable unicorn/consistent-function-scoping */
	
	
	var lawyerPreferencesController = function lawyerPreferencesController($scope, $rootScope, $modal, api, logger, locationsService, CandidatePreferencesApi, CandidateProfileApi) {
	  var updateLocations = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(request) {
	      var _this = this;
	
	      var temporarySelectedLocations, trackLocations, updateLocationsModel;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              temporarySelectedLocations = locationsService.linearize(request.updated_data);
	              trackLocations = [];
	
	              temporarySelectedLocations.forEach(function (loc) {
	                trackLocations.push(loc.loc_name);
	              });
	
	              trackLocations = trackLocations.join();
	
	              (0, _segment.profileTargetLocationsUpdate)(trackLocations);
	
	              updateLocationsModel = function updateLocationsModel() {
	                $scope.linearLocations = temporarySelectedLocations;
	                $scope.nestedLocations = request.updated_data;
	
	                logger.notify('success', 'Your target Locations have been successfully updated');
	              };
	
	              if (!(0, _common.isAnyObjectSelected)(temporarySelectedLocations)) {
	                _context2.next = 11;
	                break;
	              }
	
	              _context2.next = 9;
	              return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        return _context.abrupt('return', api.updateLocationsForLawyer(request).then(updateLocationsModel).catch($rootScope.errorHandler));
	
	                      case 1:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this);
	              })));
	
	            case 9:
	              _context2.next = 12;
	              break;
	
	            case 11:
	              logger.notify('error', 'This is a required field, you have to choose at least one location.');
	
	            case 12:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, this);
	    }));
	
	    return function updateLocations(_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var updatePractices = function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(request) {
	      var _this2 = this;
	
	      var updatePracticesModel;
	      return regeneratorRuntime.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              updatePracticesModel = function updatePracticesModel() {
	                $scope.linearPractices = request.linearPractices;
	                $scope.nestedPractices = request.updated_data;
	
	                var trackPracticeAreas = [];
	                $scope.linearPractices.forEach(function (pa) {
	                  if (pa.isSelected) {
	                    trackPracticeAreas.push(pa.practice_name);
	                  }
	                });
	
	                trackPracticeAreas = trackPracticeAreas.join();
	
	                (0, _segment.profilePracticeAreaUpdate)(trackPracticeAreas);
	
	                logger.notify('success', 'Your target Practice Areas have been successfully updated');
	              };
	
	              if (!(0, _common.isAnyObjectSelected)(request.linearPractices)) {
	                _context4.next = 6;
	                break;
	              }
	
	              _context4.next = 4;
	              return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                  while (1) {
	                    switch (_context3.prev = _context3.next) {
	                      case 0:
	                        return _context3.abrupt('return', api.updatePracticesForLawyer(request).then(updatePracticesModel).catch($rootScope.errorHandler));
	
	                      case 1:
	                      case 'end':
	                        return _context3.stop();
	                    }
	                  }
	                }, _callee3, _this2);
	              })));
	
	            case 4:
	              _context4.next = 7;
	              break;
	
	            case 6:
	              logger.notify('error', 'This is a required field, you have to choose at least one practice area.');
	
	            case 7:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, this);
	    }));
	
	    return function updatePractices(_x2) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  var updateJurisdictions = function () {
	    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(request) {
	      var _this3 = this;
	
	      var updateJurisdictionsModel, jurisdictions;
	      return regeneratorRuntime.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              updateJurisdictionsModel = function () {
	                var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
	                  var trackJurisdictions;
	                  return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                    while (1) {
	                      switch (_context5.prev = _context5.next) {
	                        case 0:
	                          $scope.jurisdictions = angular.copy(request.updated_data);
	                          $scope.onJurisdictionUpdate({ selectedJurisdiction: $scope.jurisdictions });
	
	                          trackJurisdictions = [];
	
	
	                          $scope.jurisdictions.forEach(function (juris) {
	                            if (juris.isSelected) {
	                              trackJurisdictions.push(juris.name);
	                            }
	                          });
	
	                          trackJurisdictions = trackJurisdictions.join();
	
	                          (0, _segment.profileJuridictionUpdate)(trackJurisdictions);
	                          $scope.$apply();
	
	                          if (!$scope.loggerInActive) logger.notify('success', 'Your target Jurisdictions have been successfully updated');
	
	                        case 8:
	                        case 'end':
	                          return _context5.stop();
	                      }
	                    }
	                  }, _callee5, _this3);
	                }));
	
	                return function updateJurisdictionsModel() {
	                  return _ref6.apply(this, arguments);
	                };
	              }();
	
	              jurisdictions = request.updated_data.filter(function (jurisdiction) {
	                return jurisdiction.isSelected;
	              }).map(function (jurisdiction) {
	                return jurisdiction.id;
	              });
	
	              if (!(0, _common.isAnyObjectSelected)(request.updated_data)) {
	                _context7.next = 7;
	                break;
	              }
	
	              _context7.next = 5;
	              return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
	                return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                  while (1) {
	                    switch (_context6.prev = _context6.next) {
	                      case 0:
	                        return _context6.abrupt('return', CandidatePreferencesApi.updateCandidatePreferences($scope.candidate.id, {
	                          specialtiesByCategory: [{ id: 3, specialties: jurisdictions }]
	                        }).then(updateJurisdictionsModel).catch($rootScope.errorHandler));
	
	                      case 1:
	                      case 'end':
	                        return _context6.stop();
	                    }
	                  }
	                }, _callee6, _this3);
	              })));
	
	            case 5:
	              _context7.next = 8;
	              break;
	
	            case 7:
	              logger.notify('warning', 'Please select at least one Jurisdiction.');
	
	            case 8:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, this);
	    }));
	
	    return function updateJurisdictions(_x3) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	
	  var updateLanguages = function () {
	    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(request) {
	      var updateLanguagesModel, languages;
	      return regeneratorRuntime.wrap(function _callee9$(_context9) {
	        while (1) {
	          switch (_context9.prev = _context9.next) {
	            case 0:
	              updateLanguagesModel = function updateLanguagesModel() {
	                $scope.languages = angular.copy(request.updated_data);
	
	                var trackLanguages = [];
	                $scope.languages.forEach(function (lang) {
	                  if (lang.isSelected) {
	                    trackLanguages.push(lang.language_name);
	                  }
	                });
	
	                trackLanguages = trackLanguages.join();
	
	                (0, _segment.profileLanguageUpdate)(trackLanguages);
	                $scope.$apply();
	                logger.notify('success', 'Successfully updated the lawyer\'s selected languages');
	              };
	
	              languages = request.updated_data.filter(function (language) {
	                return language.isSelected;
	              }).map(function (language) {
	                return language.code;
	              });
	              _context9.next = 4;
	              return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
	                return regeneratorRuntime.wrap(function _callee8$(_context8) {
	                  while (1) {
	                    switch (_context8.prev = _context8.next) {
	                      case 0:
	                        return _context8.abrupt('return', CandidatePreferencesApi.updateCandidatePreferences($scope.candidate.id, {
	                          languages: languages
	                        }));
	
	                      case 1:
	                      case 'end':
	                        return _context8.stop();
	                    }
	                  }
	                }, _callee8, undefined);
	              }))).then(updateLanguagesModel).catch($rootScope.errorHandler);
	
	            case 4:
	            case 'end':
	              return _context9.stop();
	          }
	        }
	      }, _callee9, undefined);
	    }));
	
	    return function updateLanguages(_x4) {
	      return _ref8.apply(this, arguments);
	    };
	  }();
	
	  var updateMove = function () {
	    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
	      var _this4 = this;
	
	      var updateMoveModel;
	      return regeneratorRuntime.wrap(function _callee11$(_context11) {
	        while (1) {
	          switch (_context11.prev = _context11.next) {
	            case 0:
	              updateMoveModel = function updateMoveModel() {
	                if ($scope.candidate.infoMotivation === '') {
	                  $scope.candidate.infoMotivation = null;
	                } else {
	                  (0, _segment.profileAboutYouUpdate)({
	                    question: 'Why are you looking to make a move?',
	                    answer: $scope.candidate.infoMotivation
	                  });
	                }
	
	                logger.notify('success', 'Successfully updated');
	              };
	
	              _context11.next = 3;
	              return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
	                return regeneratorRuntime.wrap(function _callee10$(_context10) {
	                  while (1) {
	                    switch (_context10.prev = _context10.next) {
	                      case 0:
	                        return _context10.abrupt('return', CandidateProfileApi.updateProfileData($scope.candidate.id, {
	                          infoMotivation: $scope.candidate.infoMotivation
	                        }).then(updateMoveModel).catch($rootScope.errorHandler));
	
	                      case 1:
	                      case 'end':
	                        return _context10.stop();
	                    }
	                  }
	                }, _callee10, _this4);
	              })));
	
	            case 3:
	            case 'end':
	              return _context11.stop();
	          }
	        }
	      }, _callee11, this);
	    }));
	
	    return function updateMove() {
	      return _ref10.apply(this, arguments);
	    };
	  }();
	
	  var updateInfo = function () {
	    var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
	      var _this5 = this;
	
	      var updateMoveModel;
	      return regeneratorRuntime.wrap(function _callee13$(_context13) {
	        while (1) {
	          switch (_context13.prev = _context13.next) {
	            case 0:
	              updateMoveModel = function updateMoveModel() {
	                if ($scope.candidate.infoAdditional === '') {
	                  $scope.candidate.infoAdditional = null;
	                } else {
	                  (0, _segment.profileAboutYouUpdate)({
	                    question: 'Is there any additional information that you would like to add?',
	                    answer: $scope.candidate.infoAdditional
	                  });
	                }
	
	                logger.notify('success', 'Successfully updated');
	              };
	
	              _context13.next = 3;
	              return (0, _loadingOverlay.wrap)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
	                return regeneratorRuntime.wrap(function _callee12$(_context12) {
	                  while (1) {
	                    switch (_context12.prev = _context12.next) {
	                      case 0:
	                        return _context12.abrupt('return', CandidateProfileApi.updateProfileData($scope.candidate.id, {
	                          infoAdditional: $scope.candidate.infoAdditional
	                        }).then(updateMoveModel).catch($rootScope.errorHandler));
	
	                      case 1:
	                      case 'end':
	                        return _context12.stop();
	                    }
	                  }
	                }, _callee12, _this5);
	              })));
	
	            case 3:
	            case 'end':
	              return _context13.stop();
	          }
	        }
	      }, _callee13, this);
	    }));
	
	    return function updateInfo() {
	      return _ref12.apply(this, arguments);
	    };
	  }();
	
	  var getLocationsModalData = function getLocationsModalData() {
	    return {
	      element: 'location',
	      data: angular.copy($scope.nestedLocations)
	    };
	  };
	
	  var getPracticesModalData = function getPracticesModalData() {
	    return {
	      element: 'practice',
	      data: angular.copy($scope.nestedPractices),
	      linearPractices: angular.copy($scope.linearPractices)
	    };
	  };
	
	  var getMoveModalData = function getMoveModalData() {
	    return {
	      element: 'move',
	      data: angular.copy($scope.candidate.infoMotivation)
	    };
	  };
	
	  var getInfoModalData = function getInfoModalData() {
	    return {
	      element: 'info',
	      data: angular.copy($scope.candidate.infoAdditional)
	    };
	  };
	
	  var getJurisdictionsModalData = function getJurisdictionsModalData() {
	    return {
	      element: 'jurisdiction',
	      data: angular.copy($scope.jurisdictions)
	    };
	  };
	
	  var getLanguagesModalData = function getLanguagesModalData() {
	    return {
	      element: 'language',
	      data: angular.copy($scope.languages)
	    };
	  };
	
	  var getDataObjectForTheModal = function getDataObjectForTheModal(elementId) {
	    var modalDataObject = {
	      displayNextButton: $scope.displayNextButton
	    };
	
	    switch (elementId) {
	      case 'edit-locations':
	        Object.assign(modalDataObject, getLocationsModalData());
	        break;
	      case 'edit-practices':
	        Object.assign(modalDataObject, getPracticesModalData());
	        break;
	      case 'edit-move':
	        Object.assign(modalDataObject, getMoveModalData());
	        break;
	      case 'edit-info':
	        Object.assign(modalDataObject, getInfoModalData());
	        break;
	      case 'edit-jurisdictions':
	        Object.assign(modalDataObject, getJurisdictionsModalData());
	        break;
	      case 'edit-languages':
	        Object.assign(modalDataObject, getLanguagesModalData());
	        break;
	      default:
	        modalDataObject = undefined;
	    }
	
	    return modalDataObject;
	  };
	
	  var updateRespectivePreference = function updateRespectivePreference(selectedItem) {
	    var updatedData = {
	      currentLawyer: $scope.candidate.id,
	      // eslint-disable-next-line camelcase
	      updated_data: selectedItem.data
	    };
	    switch (selectedItem.element) {
	      case 'location':
	        updateLocations(updatedData);
	        break;
	      case 'practice':
	        updatedData.linearPractices = selectedItem.linearPractices;
	        updatePractices(updatedData);
	        break;
	      case 'move':
	        $scope.candidate.infoMotivation = selectedItem.data;
	        updateMove(updatedData);
	        break;
	      case 'info':
	        $scope.candidate.infoAdditional = selectedItem.data;
	        updateInfo(updatedData);
	        break;
	      case 'jurisdiction':
	        updateJurisdictions(updatedData);
	        break;
	      case 'language':
	        updateLanguages(updatedData);
	        break;
	      default:
	    }
	  };
	
	  var modalOpenHandler = function modalOpenHandler(elementId) {
	    var modalInstance = void 0;
	
	    modalInstance = $modal.open({
	      backdrop: 'static',
	      templateUrl: 'lawyer-preferences-template.html',
	      controller: 'ProfileModalCtrl',
	      resolve: {
	        data: function data() {
	          return getDataObjectForTheModal(elementId);
	        }
	      }
	    });
	
	    return modalInstance.result.then(updateRespectivePreference);
	  };
	
	  $scope.modalOpenHandler = modalOpenHandler;
	};
	
	exports.lawyerPreferencesController = lawyerPreferencesController;

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _controller = __webpack_require__(690);
	
	var lawyerPreferences = function lawyerPreferences() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      modalOpenHandler: '=',
	      candidate: '=',
	      linearLocations: '=',
	      nestedLocations: '=',
	      linearPractices: '=',
	      nestedPractices: '=',
	      jurisdictions: '=',
	      languages: '=',
	      onJurisdictionUpdate: '&',
	      loggerInActive: '=',
	      displayNextButton: '='
	    },
	    controller: _controller.lawyerPreferencesController,
	    template: __webpack_require__(465)
	  };
	};
	
	angular.module('app.directives').directive('lawyerPreferences', lawyerPreferences);
	
	__webpack_require__(689);

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.lawyerSalaryController = undefined;
	
	var _segment = __webpack_require__(21);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var lawyerSalaryController = function lawyerSalaryController($scope, $rootScope, logger, SalaryApi) {
	  var getSymbolFromCurrency = __webpack_require__(974);
	  var currencyToSymbolMap = __webpack_require__(229);
	
	  $scope.salaryCurrencySymbol = getSymbolFromCurrency('GBP');
	  $scope.bonusCurrencySymbol = getSymbolFromCurrency('GBP');
	
	  $scope.notify = function (type, message) {
	    logger.notify(type, message);
	  };
	
	  $scope.initializeSalary = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	    var _ref2, salaryData;
	
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.prev = 0;
	            _context.next = 3;
	            return SalaryApi.getCandidateSalary($scope.candidate.id);
	
	          case 3:
	            _ref2 = _context.sent;
	            salaryData = _ref2.data;
	
	            $scope.candidate.salary = populateSalaryDetails(salaryData);
	            // eslint-disable-next-line unicorn/prefer-optional-catch-binding
	            _context.next = 10;
	            break;
	
	          case 8:
	            _context.prev = 8;
	            _context.t0 = _context['catch'](0);
	
	          case 10:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined, [[0, 8]]);
	  }));
	
	  $scope.initializeSalary();
	
	  $scope.salaryDetails = {
	    unit: '',
	    amount: '',
	    salaryDate: '',
	    salaryDateToShow: '',
	    bonusUnit: '',
	    bonusAmount: '',
	    bonusDate: '',
	    bonusDateToShow: ''
	  };
	  $scope.salaryDetailsDatePickerOptions = {
	    'datepicker-mode': "'day'",
	    'year-format': "'yy'",
	    'starting-day': 1,
	    defaultDate: '1'
	  };
	  $scope.currencyList = Object.keys(currencyToSymbolMap);
	
	  var sorting = {
	    GBP: 'GBP',
	    USD: 'USD',
	    EUR: 'EUR',
	    JPY: 'JPY',
	    CHF: 'CHF',
	    AUD: 'AUD',
	    CAD: 'CAD',
	    CNY: 'CNY',
	    NZD: 'NZD',
	    INR: 'INR',
	    SEK: 'SEK',
	    ZAR: 'ZAR',
	    HKD: 'HKD'
	  };
	  var result = [];
	
	  $scope.updateSalarySymbol = function (code) {
	    $scope.salaryCurrencySymbol = getSymbolFromCurrency(code);
	  };
	
	  $scope.updateBonusSymbol = function (code) {
	    $scope.bonusCurrencySymbol = getSymbolFromCurrency(code);
	  };
	
	  $scope.currencyList = $scope.currencyList.filter(function (current) {
	    // eslint-disable-next-line no-prototype-builtins
	    return !sorting.hasOwnProperty(current);
	  });
	
	  result.push(Object.values(sorting));
	  result.push($scope.currencyList);
	
	  $scope.currencyList = result.flatten();
	
	  $scope.lockedSalary = { isSelected: false };
	  $scope.lockUnlockSalary = function () {
	    $scope.lockedSalary.isSelected = !$scope.lockedSalary.isSelected;
	    $scope.showHistory = false;
	    $scope.addingSalaryDetails = false;
	    $scope.editingSalaryDetails = false;
	  };
	
	  var populateSalaryDetails = function populateSalaryDetails(candidateSalary) {
	    $scope.salaryDetails = candidateSalary[0];
	    $scope.salaryDetails.salaryAmountToShow = $scope.salaryDetails.amount && $scope.salaryDetails.amount.toString().replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,');
	    $scope.salaryDetails.bonusAmountToShow = $scope.salaryDetails.bonusAmount ? $scope.salaryDetails.bonusAmount.toString().replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,') : undefined;
	    $scope.salaryDetails.salaryDateToShow = $scope.salaryDetails.salaryDate && moment($scope.salaryDetails.salaryDate).local().format('DD MMM YYYY');
	    $scope.salaryDetails.bonusDateToShow = $scope.salaryDetails.bonusDate && moment($scope.salaryDetails.bonusDate).local().format('DD MMM YYYY');
	  };
	
	  $scope.fetchSalaryHistory = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	    return regeneratorRuntime.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            $scope.addingSalaryDetails = false;
	            $scope.editingSalaryDetails = false;
	            if ($scope.showHistory === false) {
	              SalaryApi.getCandidateSalary($scope.candidate.id, false).then(function (salaryHistory) {
	                if (salaryHistory.data.length > 1) {
	                  $scope.salaryHistory = salaryHistory.data;
	                  $scope.salaryHistory.forEach(function (salary) {
	                    salary.salaryDateToShow = salary.salaryDate && moment(salary.salaryDate).local().format('DD MMM YYYY');
	                    salary.bonusDateToShow = salary.bonusDate && moment(salary.bonusDate).local().format('DD MMM YYYY');
	                    salary.salaryAmountToShow = salary.amount && salary.amount.toString().replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,');
	                    salary.bonusAmountToShow = salary.bonusAmount ? salary.bonusAmount.toString().replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,') : undefined;
	                  });
	                  $scope.showHistory = true;
	                  $scope.$apply();
	                } else {
	                  $scope.notify('warning', 'No salary history found.');
	                }
	              }).catch($rootScope.errorHandler);
	            } else {
	              $scope.showHistory = false;
	            }
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  $scope.AddSalaryDetails = function () {
	    if ($scope.candidate.employer) {
	      $scope.editableSalary = {
	        unit: 'GBP',
	        amount: undefined,
	        payPeriod: 'per year',
	        locationId: $scope.candidate.location.id,
	        employerId: $scope.candidate.employer.id,
	        salaryDate: undefined,
	        bonusUnit: 'GBP',
	        bonusAmount: undefined,
	        bonusDate: undefined
	      };
	      $scope.addingSalaryDetails = true;
	      $scope.showHistory = false;
	    } else {
	      $scope.notify('error', "Please add 'Current Experience' to add salary.");
	    }
	  };
	
	  $scope.editSalaryDetails = function () {
	    $scope.editableSalary = $scope.salaryDetails;
	    $scope.editingSalaryDetails = true;
	  };
	
	  $scope.editHistorySalaryDetails = function (salary, index) {
	    $scope.salaryHistoryIndex = index;
	    $scope.editableSalary = salary;
	    $scope.editingSalaryDetails = true;
	  };
	
	  $scope.trackSalary = function (salary, eventName) {
	    (0, _segment.profileSalaryDetailsAdd)({
	      salary: salary.unit + ' ' + salary.amount + ' per ' + salary.salaryPayPeriod,
	      salaryDate: salary.salaryDateToShow,
	      bonus: salary.bonusAmount ? salary.bonusUnit + ' ' + salary.bonusAmount : '',
	      bonusDate: salary.bonusDate ? salary.bonusDateToShow : '',
	      employerId: salary.firmID,
	      employerName: salary.firmName,
	      candidateId: salary.lawyerID,
	      location: salary.location,
	      action: eventName
	    });
	  };
	
	  // eslint-disable-next-line complexity
	  $scope.saveSalaryDetails = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	    var editError, isBonusEdited, isBonusEmpty, bonusEditError, salaryPayload, _ref5, addSalaryResponse;
	
	    return regeneratorRuntime.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            editError = false;
	            isBonusEdited = false;
	            isBonusEmpty = false;
	            bonusEditError = false;
	
	
	            if (!$scope.editableSalary.unit || _.isEmpty($scope.editableSalary.unit)) {
	              $scope.notify('error', 'Please provide your current salary currency code.');
	              editError = true;
	            } else if (!$scope.editableSalary.amount || $scope.editableSalary.amount === '') {
	              $scope.notify('error', 'Please provide your current salary.');
	              editError = true;
	            } else if (!$scope.editableSalary.salaryDate || $scope.editableSalary.salaryDate === '') {
	              $scope.notify('error', 'Please provide your current salary date.');
	              editError = true;
	            } else if ($scope.editableSalary.amount && !$scope.editableSalary.payPeriod) {
	              $scope.notify('error', 'Please provide Salary Pay Period.');
	              editError = true;
	            }
	
	            if (!$scope.editableSalary.bonusAmount || $scope.editableSalary.bonusAmount === '' || $scope.editableSalary.bonusAmount === 0) {
	              $scope.editableSalary.bonusAmount = undefined;
	              isBonusEmpty = true;
	            } else {
	              isBonusEdited = true;
	            }
	
	            if ($scope.editableSalary.bonusDate || $scope.editableSalary.bonusUnit) {
	              bonusEditError = true;
	            }
	
	            if (isBonusEdited && (!$scope.editableSalary.bonusDate || $scope.editableSalary.bonusDate === '' || !$scope.editableSalary.bonusUnit || _.isEmpty($scope.editableSalary.bonusUnit))) {
	              editError = true;
	              $scope.notify('error', 'Please provide last bonus complete details.');
	            } else if (!editError && bonusEditError && isBonusEmpty) {
	              $scope.editableSalary.bonusDate = undefined;
	              $scope.editableSalary.bonusUnit = undefined;
	              $scope.editableSalary.bonusAmount = undefined;
	            }
	
	            if (editError) {
	              _context3.next = 31;
	              break;
	            }
	
	            $scope.editableSalary.salaryDateToShow = $scope.editableSalary.salaryDate && moment($scope.editableSalary.salaryDate).local().format('DD MMM YYYY');
	            $scope.editableSalary.bonusDateToShow = $scope.editableSalary.bonusDate && moment($scope.editableSalary.bonusDate).local().format('DD MMM YYYY');
	            $scope.editableSalary.salaryAmountToShow = $scope.editableSalary.amount && $scope.editableSalary.amount.toString().replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,');
	            $scope.editableSalary.bonusAmountToShow = $scope.editableSalary.bonusAmount ? $scope.editableSalary.bonusAmount.toString().replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,') : undefined;
	            $scope.editingeditableSalary = false;
	
	            salaryPayload = {
	              unit: $scope.editableSalary.unit,
	              amount: $scope.editableSalary.amount,
	              payPeriod: $scope.editableSalary.payPeriod,
	              locationId: $scope.editableSalary.locationId,
	              employerId: $scope.editableSalary.employerId,
	              salaryDate: moment($scope.editableSalary.salaryDate).format('YYYY-MM-DD'),
	              bonusUnit: $scope.editableSalary.bonusUnit,
	              bonusAmount: $scope.editableSalary.bonusAmount,
	              bonusDate: moment($scope.editableSalary.bonusDate).format('YYYY-MM-DD')
	            };
	
	            if (!$scope.addingSalaryDetails) {
	              _context3.next = 30;
	              break;
	            }
	
	            _context3.next = 18;
	            return SalaryApi.addCandidateSalary($scope.candidate.id, salaryPayload);
	
	          case 18:
	            _ref5 = _context3.sent;
	            addSalaryResponse = _ref5.data;
	
	            $scope.salaryDetails = $scope.editableSalary;
	            $scope.salaryDetails.id = addSalaryResponse.id;
	            $scope.salaryDetails.location = { name: $scope.candidate.location.name };
	            $scope.salaryDetails.employer = { name: $scope.candidate.employer.name };
	            $scope.addingSalaryDetails = false;
	            $scope.notify('success', 'Successfully updated');
	            $scope.trackSalary($scope.salaryDetails, 'Add');
	            $scope.$apply();
	            _context3.next = 31;
	            break;
	
	          case 30:
	            if ($scope.editingSalaryDetails) {
	              delete salaryPayload.locationId;
	              delete salaryPayload.employerId;
	              SalaryApi.updateCandidateSalary($scope.editableSalary.id, salaryPayload).then(function (_data) {
	                if ($scope.showHistory) {
	                  $scope.salaryHistory[$scope.salaryHistoryIndex] = $scope.editableSalary;
	                  if ($scope.salaryHistoryIndex === 0) {
	                    $scope.salaryDetails = $scope.editableSalary;
	                  }
	                } else {
	                  $scope.salaryDetails = $scope.editableSalary;
	                }
	
	                $scope.trackSalary($scope.salaryDetails, 'Edit');
	                $scope.editingSalaryDetails = false;
	                $scope.$apply();
	              }).catch(function (_error) {
	                return $scope.notify('error', 'Error updating salary.');
	              });
	            }
	
	          case 31:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined);
	  }));
	
	  $scope.cancelSalaryDetails = function () {
	    if (!$scope.editableSalary.bonusAmountToShow) {
	      $scope.editableSalary.bonusDate = undefined;
	      $scope.editableSalary.bonusUnit = undefined;
	    }
	
	    $scope.editingSalaryDetails = false;
	    $scope.addingSalaryDetails = false;
	  };
	};
	
	exports.lawyerSalaryController = lawyerSalaryController;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _controller = __webpack_require__(692);
	
	__webpack_require__(694);
	
	var lawyerSalary = function lawyerSalary() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      candidate: '=',
	      lockedSalary: '=',
	      lawyerApproved: '='
	    },
	    controller: _controller.lawyerSalaryController,
	    template: __webpack_require__(466)
	  };
	};
	
	angular.module('app.directives').directive('lawyerSalary', lawyerSalary);

/***/ }),
/* 694 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.api').factory('SalaryApi', ['api', function SalaryApi(api) {
	  var salaryApi = {
	    getCandidateSalary: function getCandidateSalary(userId) {
	      var latest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      return api.get('users/' + userId + '/salary?latest=' + latest);
	    },
	    addCandidateSalary: function addCandidateSalary(userId, payload) {
	      return api.post('users/' + userId + '/salary', payload);
	    },
	    updateCandidateSalary: function updateCandidateSalary(salaryId, payload) {
	      return api.put('user/salary/' + salaryId, payload);
	    }
	  };
	  return salaryApi;
	}]);

/***/ }),
/* 695 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LocationsDropdownController = exports.LocationsDropdownController = function LocationsDropdownController($scope, locationsGenericService) {
	  $scope.openLocationDropDown = function (event) {
	    event.stopPropagation();
	  };
	
	  $scope.selectAllLocations = function () {
	    locationsGenericService.selectOrDeselectAllLocations($scope.regionsList, true);
	    updateLocationDropdown();
	  };
	
	  $scope.deselectAllLocations = function () {
	    locationsGenericService.selectOrDeselectAllLocations($scope.regionsList, false);
	
	    updateLocationDropdown();
	  };
	
	  $scope.selectLocation = function (selectedValue, event) {
	    locationsGenericService.selectLocation($scope.regionsList, selectedValue, event);
	    updateLocationDropdown();
	  };
	
	  var updateLocationDropdown = function updateLocationDropdown() {
	    var selectedLocation = locationsGenericService.setIsSelectedChildrenLocation($scope.regionsList, []);
	    $scope.onLocationChange({ selectedLocation: selectedLocation });
	  };
	};

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _locationsDropdownCtrl = __webpack_require__(695);
	
	var locationsDropdown = function locationsDropdown() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      width: '=',
	      buttonId: '@',
	      selectOnReset: '=?',
	      locationsList: '=',
	      regionsList: '=',
	      onLocationChange: '&',
	      placeholder: '='
	    },
	    controller: _locationsDropdownCtrl.LocationsDropdownController,
	    template: __webpack_require__(467)
	  };
	};
	
	angular.module('app.directives').directive('locationsDropdown', locationsDropdown);

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _locationsModalCtrl = __webpack_require__(187);
	
	var locationsModal = function locationsModal() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    controller: _locationsModalCtrl.LocationsModalController,
	    template: __webpack_require__(468)
	  };
	};
	
	angular.module('app.directives').directive('locationsModal', locationsModal);

/***/ }),
/* 698 */
/***/ (function(module, exports) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/* eslint-disable array-callback-return */
	
	angular.module('app.services').factory('locationsGenericService', [function locationsGenericService() {
	  var instance = {
	    selectLocation: function selectLocation(allLocationList, selectedValue, event) {
	      var checked = event.target.checked;
	      if (selectedValue.locations) {
	        selectedValue.locations.map(function (location) {
	          location.isSelected = checked;
	          if (location.children && location.children.length > 0) assignSelectedLocationsChildren(location.children, checked);
	          return location;
	        });
	      }
	
	      if (selectedValue.children && selectedValue.children.length > 0) assignSelectedLocationsChildren(selectedValue.children, checked);
	
	      if (selectedValue.regionId) {
	        var region = getLocationById(allLocationList, selectedValue.regionId);
	        region.isSelected = checked === false ? getSiblingLocationById(region.locations, selectedValue.id) : checked;
	      }
	
	      if (selectedValue.parentId) {
	        var parentLocation = allLocationList.map(function (location) {
	          if (location.locations) {
	            var foundLocation = getLocationById(location.locations, selectedValue.parentId);
	
	            // eslint-disable-next-line no-negated-condition
	            return !foundLocation ? location.locations.map(function (child) {
	              if (child.children && child.children.length > 0) return getLocationById(child.children, selectedValue.parentId);
	            }).find(function (location) {
	              return location;
	            }) : foundLocation;
	          }
	        }).find(function (location) {
	          return location;
	        });
	
	        parentLocation.isSelected = checked === false ? getSiblingLocationById(parentLocation.children, selectedValue.id) : checked;
	
	        if (parentLocation.regionId) {
	          var _region = getLocationById(allLocationList, parentLocation.regionId);
	          _region.isSelected = parentLocation.isSelected ? parentLocation.isSelected : checked === false ? getSiblingLocationById(_region.locations, selectedValue.parentId) : checked;
	        }
	
	        if (parentLocation.parentId) {
	          var grandParentLocation = allLocationList.map(function (location) {
	            if (location.locations) {
	              return getLocationById(location.locations, parentLocation.parentId);
	            }
	          }).find(function (location) {
	            return location;
	          });
	
	          grandParentLocation.isSelected = parentLocation.isSelected ? parentLocation.isSelected : checked === false ? getSiblingLocationById(grandParentLocation.children, selectedValue.parentId) : checked;
	
	          if (grandParentLocation.regionId) {
	            var _region2 = getLocationById(allLocationList, grandParentLocation.regionId);
	            _region2.isSelected = grandParentLocation.isSelected ? grandParentLocation.isSelected : checked === false ? getSiblingLocationById(_region2.locations, grandParentLocation.id) : checked;
	          }
	        }
	      }
	
	      selectedValue.isSelected = checked;
	    },
	    makeCandidateLocationsHierarchy: function makeCandidateLocationsHierarchy(candidateLocations, allLocations) {
	      var allCandidateLocationsWithParent = [];
	      var allCandidateLocationsWithChildren = [];
	
	      candidateLocations = allLocations.filter(function (location) {
	        return candidateLocations.find(function (_ref) {
	          var id = _ref.id;
	          return location.id === id;
	        });
	      });
	
	      candidateLocations.forEach(function (location) {
	        getAllCandidateLocationChildren(location, allLocations, allCandidateLocationsWithChildren);
	        getAllCandidateLocationWithParents(location, allLocations, allCandidateLocationsWithParent);
	      });
	
	      allCandidateLocationsWithParent = [].concat(allCandidateLocationsWithChildren, _toConsumableArray(allCandidateLocationsWithParent)).filter(function (v, index, a) {
	        return a.findIndex(function (t) {
	          return t.id === v.id;
	        }) === index;
	      });
	
	      var regionHierarchialList = instance.initialize(allCandidateLocationsWithParent, allCandidateLocationsWithParent, true);
	      regionHierarchialList.sort(function (a, b) {
	        return a.name > b.name ? 1 : -1;
	      });
	      return [].concat(_toConsumableArray(regionHierarchialList.filter(function (region) {
	        return region.name === 'Europe';
	      })), _toConsumableArray(regionHierarchialList.filter(function (region) {
	        return region.name !== 'Europe';
	      })));
	    },
	    setIsSelectedChildrenLocation: function setIsSelectedChildrenLocation(allLocationList, selectedLocations) {
	      allLocationList.forEach(function (region) {
	        if (region.isSelected === true) {
	          region.locations.forEach(function (location) {
	            saveLocationWithNoChildren(location, selectedLocations);
	          });
	        }
	      });
	      return selectedLocations;
	    },
	
	    initialize: function initialize(selectedLocations, allLocationList) {
	      instance.clearSelection(allLocationList, false);
	      if (selectedLocations) {
	        selectedLocations.map(function (selectedValue) {
	          assignSelectedLocations(selectedValue, true, allLocationList);
	        });
	      }
	
	      return parseLocationByRegion(allLocationList);
	    },
	    clearSelection: function clearSelection(allLocationList, selection) {
	      instance.locationSelection(allLocationList, selection);
	    },
	    locationSelection: function locationSelection(allLocationList, selection) {
	      allLocationList.forEach(function (region) {
	        region.isSelected = selection;
	        if (region.locations) {
	          region.locations.map(function (location) {
	            try {
	              location.isSelected = selection;
	              if (location.children && location.children.length > 0) assignSelectedLocationsChildren(location.children, selection);
	              return location;
	            } catch (error) {
	              console.error(error);
	            }
	          });
	        }
	      });
	    },
	    selectOrDeselectAllLocations: function selectOrDeselectAllLocations(allLocationList, selection) {
	      instance.locationSelection(allLocationList, selection);
	    }
	  };
	
	  return instance;
	}]);
	
	/** This function called when location exists and make selected locations checked in hierarchial way.
	 * @param  {} selectedValue //Specific location
	 * @param  {} checked  //true
	 * @param  {} allLocationList // all locations list
	 */
	var assignSelectedLocations = function assignSelectedLocations(selectedValue, checked, allLocationList) {
	  var location = allLocationList.find(function (_ref2) {
	    var id = _ref2.id;
	    return selectedValue.id === id;
	  });
	  if (location) {
	    location.isSelected = checked;
	    location.country.region.isSelected = checked;
	    if (location.parent) assignSelectedLocations(location.parent, checked, allLocationList);
	  }
	};
	
	/** This method get children of selected regions until location has no child when saving locations
	 * @param  {} list
	 * @param  {} selectedLocations
	 */
	var saveLocationWithNoChildren = function saveLocationWithNoChildren(list, selectedLocations) {
	  if (list.isSelected === true && list.children && list.children.length > 0) {
	    var subChildren = list.children.filter(function (subChild) {
	      return subChild.isSelected === true;
	    });
	    if (subChildren.length > 0) {
	      subChildren.forEach(function (subChild) {
	        saveLocationWithNoChildren(subChild, selectedLocations);
	      });
	    }
	  } else if (list.isSelected === true) {
	    selectedLocations.push(list);
	  }
	};
	
	/** This method will find and return record of location by id
	 * @param  {} list  either locations or location children
	 * @param  {} id id
	 */
	var getLocationById = function getLocationById(list, id) {
	  return list.find(function (row) {
	    return row.id === id;
	  });
	};
	
	/** This method will assign isSelected checked and unchecked of selected locations children
	 * @param  {} list either locations or location children
	 * @param  {} checked either checked true or falls
	 */
	var assignSelectedLocationsChildren = function assignSelectedLocationsChildren(list, checked) {
	  return list.map(function (location) {
	    try {
	      if (location.children && location.children.length > 0) assignSelectedLocationsChildren(location.children, checked);
	
	      location.isSelected = checked;
	      return location;
	    } catch (error) {
	      console.error(error);
	    }
	  }).filter(Boolean);
	};
	
	/** This method will find sibling of locations
	 * @param  {} list either locations or location children
	 * @param  {} id id
	 */
	var getSiblingLocationById = function getSiblingLocationById(list, id) {
	  return list.some(function (sibling) {
	    return sibling.isSelected === true && sibling.id !== id;
	  });
	};
	
	/** This method parse location to make region with respected locations
	 * @param  {} list // locationList
	 */
	function parseLocationByRegion(list) {
	  var ids = [].concat(_toConsumableArray(new Set(list.filter(function (row) {
	    return row.country.region.supported === true;
	  }).map(function (row) {
	    return row.country.region.id;
	  }))));
	  var names = [].concat(_toConsumableArray(new Set(list.filter(function (row) {
	    return row.country.region.supported === true;
	  }).map(function (row) {
	    return row.country.region.name;
	  }))));
	
	  return names.map(function (name, index) {
	    var location = list.find(function (row) {
	      return row.country.region.id === ids[index] && row.country.region.isSelected === true;
	    });
	    return {
	      id: ids[index],
	      name: name,
	      isSelected: location && location.isSelected ? location.isSelected : false,
	      locations: locationsHierarchy(list, name, ids[index])
	    };
	  });
	}
	
	/** This method will make hierarchial locations of specific region
	 * @param  {} list locationList
	 * @param  {} regionName specific region Name
	 * @param  {} regionId specific region Id
	 */
	var locationsHierarchy = function locationsHierarchy(list, regionName, regionId) {
	  var linearList = angular.copy(list);
	  var locationsHierarchy = list.filter(function (row) {
	    return row.country.region.name === regionName && row.parent === null;
	  }).map(function (location) {
	    location.regionId = regionId;
	    regionLocationsHierarchy(linearList, location);
	    // eslint-disable-next-line you-dont-need-lodash-underscore/omit
	    return _.omit(location, ['country']);
	  });
	  locationsHierarchy.sort(function (a, b) {
	    return a.name > b.name ? 1 : -1;
	  });
	  var ukId = locationsHierarchy.find(function (item) {
	    return item.name === 'United Kingdom';
	  });
	
	  var uk = [].concat(_toConsumableArray(locationsHierarchy.filter(function (item) {
	    return item.parentId === ukId;
	  })), _toConsumableArray(locationsHierarchy.filter(function (region) {
	    return region.name === 'United Kingdom';
	  })));
	  var result = [].concat(_toConsumableArray(uk), _toConsumableArray(locationsHierarchy.filter(function (region) {
	    return region.name !== 'United Kingdom' && region.parentId !== ukId;
	  })));
	
	  return result;
	};
	
	/** This method will make region location hierarchy
	 * @param  {} list  locationList
	 * @param  {} location specific location object
	 */
	var regionLocationsHierarchy = function regionLocationsHierarchy(list, location) {
	  if (location.regionId) location.children = [];
	  list.sort(function (a, b) {
	    return a.name > b.name ? 1 : -1;
	  }).find(function (child) {
	    delete child.country;
	    if (child.parent) {
	      child.children = [];
	      childrenLocationsHierarchy(list, child);
	      if (child.parent.id === location.id) {
	        child.parentId = child.parent.id;
	        delete child.parent;
	        location.children.push(child);
	      }
	    }
	  });
	};
	
	/** This method will make children location hierarchy
	 * @param  {} list locationList
	 * @param  {} child specific child object
	 */
	var childrenLocationsHierarchy = function childrenLocationsHierarchy(list, child) {
	  list.sort(function (a, b) {
	    return a.name > b.name ? 1 : -1;
	  }).find(function (subChild) {
	    if (subChild.parent) {
	      if (subChild.parent.id === child.id) {
	        subChild.parentId = subChild.parent.id;
	        delete subChild.parent;
	        child.children.push(subChild);
	      }
	    }
	  });
	};
	
	var getAllCandidateLocationWithParents = function getAllCandidateLocationWithParents(location, allLocations, allCandidateLocationsWithParent) {
	  if (!location.parent || location.parent === null) {
	    allCandidateLocationsWithParent.push(location);
	    return;
	  }
	
	  var parentId = allLocations.findIndex(function (_ref3) {
	    var id = _ref3.id;
	    return location.parent && location.parent.id === id;
	  });
	  var parent = allLocations[parentId];
	
	  allCandidateLocationsWithParent.push(location);
	
	  location = Object.assign(parent);
	
	  getAllCandidateLocationWithParents(location, allLocations, allCandidateLocationsWithParent);
	};
	
	var getAllCandidateLocationChildren = function getAllCandidateLocationChildren(location, allLocations, allCandidateLocationsWithChildren) {
	  var parents = allLocations.filter(function (_ref4) {
	    var parent = _ref4.parent;
	    return parent && parent.id === location.id;
	  });
	
	  if (parents.every(function (location) {
	    return allCandidateLocationsWithChildren.includes(location);
	  })) {
	    return;
	  }
	
	  allCandidateLocationsWithChildren.push.apply(allCandidateLocationsWithChildren, _toConsumableArray(parents));
	
	  parents.forEach(function (location) {
	    getAllCandidateLocationChildren(location, allLocations, allCandidateLocationsWithChildren);
	  });
	};

/***/ }),
/* 699 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.api').factory('HidePositionEmployerApi', ['api', function HidePositionEmployerApi(api) {
	  var hidePositionEmployerApi = {
	    hideEmployer: function hideEmployer(id, employerId) {
	      return api.post('users/' + id + '/hidden/' + employerId);
	    },
	    hidePosition: function hidePosition(id, positionId, reason) {
	      return api.post('users/' + id + '/positions/hidden/' + positionId + '?reason=' + reason);
	    }
	  };
	  return hidePositionEmployerApi;
	}]);

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function hidePositionEmployerController($scope, $modal, $log, logger, HidePositionEmployerApi) {
	  var resetModalOptions = function resetModalOptions() {
	    $scope.modalInstance = undefined;
	    $scope.options = {
	      alreadyApplied: {
	        position: 1,
	        selected: false,
	        label: 'Hide this opportunity, I\'m interested but have already applied within the last 6 months.',
	        reason: 'Position Already Applied'
	      },
	      hideOpportunity: {
	        position: 2,
	        selected: false,
	        label: 'Hide this opportunity specifically, this team is not for me.',
	        reason: 'Position Not For Me'
	      },
	      hideEmployer: {
	        position: 3,
	        selected: false,
	        label: 'Hide this and all future opportunities at this firm, this employer is not for me.',
	        reason: 'Employer Not For Me'
	      }
	    };
	  };
	
	  var errorHandler = function errorHandler(errorResponse) {
	    $log.error(errorResponse);
	    logger.notify('error', 'something went wrong: ' + errorResponse.statusText);
	  };
	
	  var successHandler = function successHandler(message, data, callback) {
	    logger.notify('success', message);
	    callback({ position: data });
	  };
	
	  var hidePosition = function hidePosition(modalData) {
	    var message = 'This position is now hidden and will appear under the hidden positions section';
	
	    if ($scope.page === 'matches') {
	      message = 'This match is now hidden and can be found by switching to the Hidden matches view';
	    } else if ($scope.page === 'in-house') {
	      message = 'This position is now hidden and can be found by switching to the Hidden positions view';
	    } else if ($scope.page === 'opportunities') {
	      message = 'This team is now hidden and can be found by switching to the Hidden teams view';
	    }
	
	    HidePositionEmployerApi.hidePosition(modalData.userId, modalData.id, modalData.option.reason).then(function () {
	      return successHandler(message, modalData, $scope.onPositionHide);
	    }).catch(errorHandler);
	  };
	
	  var hideEmployer = function hideEmployer(modalData) {
	    var message = 'The employer is now hidden for you and will be not be shown in the future';
	
	    HidePositionEmployerApi.hideEmployer(modalData.userId, modalData.employerId).then(function () {
	      return successHandler(message, modalData, $scope.onEmployerHide);
	    }).catch(errorHandler);
	  };
	
	  var setModalData = function setModalData(modalData) {
	    $scope.modalData = modalData;
	  };
	
	  var modalSuccessHandler = function modalSuccessHandler(modalData) {
	    var options = $scope.options;
	
	    if (options.alreadyApplied.selected || $scope.options.hideOpportunity.selected) {
	      modalData.option = options.alreadyApplied.selected ? options.alreadyApplied : options.hideOpportunity;
	      hidePosition(modalData);
	    } else if (options.hideEmployer.selected) {
	      modalData.option = options.hideEmployer;
	      hideEmployer(modalData);
	    }
	  };
	
	  var modalOpenHandler = function modalOpenHandler(jobInfo, event) {
	    stopEvents(event);
	    resetModalOptions();
	    setModalData(jobInfo);
	
	    $scope.modalInstance = $modal.open({
	      backdrop: 'static',
	      templateUrl: 'modal-template-position-hide-options',
	      scope: $scope
	    });
	
	    return $scope.modalInstance.result.then(modalSuccessHandler);
	  };
	
	  $scope.modalOpenHandler = modalOpenHandler;
	  $scope.closeModal = function () {
	    return $scope.modalInstance.dismiss('cancel');
	  };
	  $scope.hidePositionOrEmployer = function () {
	    var options = $scope.options;
	    var isAnyOptionSelected = _.some(options, function (option) {
	      return option.selected;
	    });
	
	    if (!isAnyOptionSelected) {
	      logger.notify('warning', "Please select your choice before clicking 'Hide'");
	      return;
	    }
	
	    $scope.modalInstance.close($scope.modalData);
	  };
	}
	
	var stopEvents = function stopEvents(event) {
	  if (event) {
	    event.preventDefault();
	    event.stopPropagation();
	  }
	};
	
	exports.hidePositionEmployerController = hidePositionEmployerController;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _hidePositionEmployerCtrl = __webpack_require__(700);
	
	var hidePositionEmployerModal = function hidePositionEmployerModal() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      modalOpenHandler: '=',
	      lawyer: '=',
	      consultant: '=',
	      page: '=',
	      onEmployerHide: '&',
	      onPositionHide: '&'
	    },
	    template: __webpack_require__(469),
	    controller: _hidePositionEmployerCtrl.hidePositionEmployerController
	  };
	};
	
	angular.module('app.directives').directive('hidePositionEmployerModal', hidePositionEmployerModal);

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _common = __webpack_require__(33);
	
	var locationsModalTemplate = '\n    <div class="row">\n        <div class="col-md-12 text-left" ng-show="!editLocations">\n            <button class="btn btn-line-info" id="{{buttonId}}" ng-click="openModal($event)">Click to specify</button>\n        </div>\n\n        <div class="divider clearfix"></div>\n\n        <div class="col-md-11 text-left" ng-show="editLocations">\n            <ul id="taglist" class="list-inline list-practice-area margin-b0">\n                <li class="tags-box" ng-if = "location.isSelected && !location.hasChild" ng-repeat="location in linearLocations">{{location.loc_name}}</li>\n                <a href="" class="fa fa-pencil" id="{{buttonId + \'-edit\'}}" ng-click="openModal($event)"></a>\n            </ul>\n        </div>\n\n        <script type="text/ng-template" id="modal-locations-template.html">\n            <div class="modal-header">\n                <center>\n                    <h3>{{heading|translate}}</h3>\n                    <h5>{{subHeading|translate}}</h5>\n                </center>\n            </div>\n            <div class="modal-body clearfix">\n                <div class="modal-row custom-modal">\n                    <div class="col-md-12">\n                        <div class="" data-ng-repeat="region in data | orderBy: \'loc_ID\'">\n                            <span>\n                                <i ng-hide="region.showChildLocations" ng-click="displayChildLocations(region)" class="fa fa-plus expand-collapse-button" aria-hidden="true"></i>\n                            </span>\n                            <span>\n                                <i ng-hide="!region.showChildLocations" ng-click="hideChildLocations(region)" class="fa fa-minus expand-collapse-button" aria-hidden="true"></i>\n                            </span>\n                            <label class="ui-checkbox">\n                                <input type="checkbox" ng-click="selectLocation($event , region , 2)" data="{{loc_ID}}" ng-checked="region.isSelected">\n                                <span class="checkbox-group-heading">\n                                    <strong>{{region.loc_name}}</strong>\n                                </span>\n                            </label>\n                            <ul class=" practice-area-list clearfix" ng-show="region.showChildLocations">\n                                <li data-ng-repeat="location in region.locations">\n                                    <label class="ui-checkbox">\n                                        <input type="checkbox" data="{{location.loc_ID}}" ng-click="selectLocation($event , location , 1)" ng-checked="location.isSelected">\n                                        <span>{{location.loc_name}}</span>\n                                    </label>\n                                    <ul class=" sub-list clearfix">\n                                        <li data-ng-repeat="sub in location.sub_areas">\n                                            <label class="ui-checkbox">\n                                                <input type="checkbox" ng-click="selectLocation($event , sub , 0)" ng-checked="sub.isSelected">\n                                                <span>{{sub.loc_name}}</span>\n                                            </label>\n                                        </li>\n                                    </ul>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div class="modal-footer">\n                <center>\n                    <button class="btn btn-info" ng-click="save()">Save</button>\n                    <button class="btn btn-gap-v btn-default" ng-click="cancel()">Cancel</button>\n                </center>\n            </div>\n        </script>\n    </div>\n'; /******************************************************************/
	/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
	/******************************************************************/
	
	function locationsModalController($scope, $modal, locationsService) {
	
	    var toggleEditBehavior = function toggleEditBehavior(locations) {
	        $scope.editLocations = (0, _common.isAnyObjectSelected)(locations);
	    };
	
	    var determineEditBehavior = function determineEditBehavior(newPAvalue, oldPAvalue) {
	        if (!_.isEqual(newPAvalue, oldPAvalue)) toggleEditBehavior($scope.nestedLocations);
	    };
	
	    var updateLocationsModel = function updateLocationsModel(locationsData) {
	        $scope.linearLocations = locationsData.linearLocations;
	        $scope.nestedLocations = locationsData.nestedLocations;
	    };
	
	    var updateLocationsUI = function updateLocationsUI(locationsData) {
	        var updatedData = {
	            linearLocations: locationsService.linearize(locationsData.data),
	            nestedLocations: locationsData.data
	        };
	
	        updateLocationsModel(updatedData);
	        toggleEditBehavior(updatedData.linearLocations);
	    };
	
	    var stopEvents = function stopEvents(event) {
	        if (event) {
	            event.preventDefault();
	            event.stopPropagation();
	        }
	    };
	
	    var getLocationsModalData = function getLocationsModalData() {
	        return {
	            element: 'location',
	            data: angular.copy($scope.nestedLocations)
	        };
	    };
	
	    $scope.openModal = function (event) {
	        stopEvents(event);
	
	        var modalInstance = $modal.open({
	            backdrop: 'static',
	            templateUrl: "modal-locations-template.html",
	            controller: 'ProfileModalCtrl',
	            resolve: {
	                data: function data() {
	                    return getLocationsModalData();
	                }
	            }
	        });
	
	        return modalInstance.result.then(updateLocationsUI);
	    };
	
	    $scope.$watch('nestedLocations', determineEditBehavior, true);
	}
	
	var getDefinationObject = function getDefinationObject() {
	    return {
	        restrict: 'AE',
	        replace: true,
	        scope: {
	            buttonId: '@',
	            linearLocations: '=',
	            nestedLocations: '=',
	            onLocationsChange: '&'
	        },
	        template: locationsModalTemplate,
	        controller: locationsModalController
	    };
	};
	
	angular.module('app.directives').directive('modalLocations', getDefinationObject);

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _common = __webpack_require__(33);
	
	angular.module('app.directives').directive('modalPracticeAreas', function () {
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      buttonId: '@',
	      linearPractices: '=',
	      nestedPractices: '=',
	      onPracChange: '&',
	      selectionLimit: '='
	    },
	    template: '\n  <div class="row">\n\n    <div class="col-md-12 text-left" ng-show="!editPractices">\n      <button id="{{buttonId}}" class="btn btn-line-info" ng-click="openModal($event)">\n        Click to specify\n      </button>\n    </div>\n\n    <div class="divider clearfix"></div>\n\n    <div class="col-md-12 text-left" ng-show="editPractices ">\n      <ul id="taglist" class="list-inline list-practice-area margin-b0">\n        <li class="tags-box" ng-if = "area.isSelected && !area.hasChild" ng-repeat="area in linearPractices">\n          {{area.practice_name}}\n        </li>\n        <a href=""class="fa fa-pencil" id="{{buttonId + \'-edit\'}}" ng-click="openModal($event)"></a>\n      </ul>\n    </div>\n\n    <script type="text/ng-template" id="modal-practices-template.html">\n      <div class="modal-header">\n        <center>\n          <h3>{{heading|translate}}</h3>\n          <h5>{{subHeading|translate}}</h5>\n        </center>\n      </div>\n      <div class="modal-body clearfix">\n        <div class="modal-row custom-modal">\n          <div class="col-md-12">\n            <div class="" data-ng-repeat="law_area in data">\n              <span ng-class="{\'no-child\': law_area.practices.length === 0}">\n                <i ng-hide="law_area.showSubPracticeAreas || law_area.practices.length === 0" ng-click="displaySubPracticeAreas(law_area)"\n                  class="fa fa-plus expand-collapse-button" aria-hidden="true"></i>\n              </span>\n              <span ng-class="{\'no-child\': law_area.practices.length === 0}">\n                <i ng-hide="!law_area.showSubPracticeAreas" ng-click="hideSubPracticeAreas(law_area)" class="fa fa-minus expand-collapse-button"\n                  aria-hidden="true"></i>\n              </span>\n              <label class="ui-checkbox">\n                <input type="checkbox" ng-click="selectPractices($event , law_area , 2)" data="{{practice_ID}}" ng-checked="law_area.isSelected">\n                <span class="checkbox-group-heading" ng-style="law_area.practices.length > 0 && {\'font-weight\': \'bold\'}">{{law_area.practice_name}}\n                </span>\n              </label>\n              <ul ng-show="law_area.showSubPracticeAreas" class=" practice-area-list clearfix">\n                <li data-ng-repeat="practice in law_area.practices">\n                  <label class="ui-checkbox">\n                    <input type="checkbox" data="{{practice.loc_ID}}" ng-click="selectPractices($event , practice , 1)" ng-checked="practice.isSelected">\n                    <span>{{practice.practice_name}}</span>\n                  </label>\n                  <ul class=" sub-list clearfix">\n                    <li data-ng-repeat="sub in practice.sub_areas">\n                      <label class="ui-checkbox">\n                        <input type="checkbox" ng-click="selectPractices($event , sub , 0)" ng-checked="sub.isSelected">\n                        <span>{{sub.practice_name}}</span>\n                      </label>\n                    </li>\n                  </ul>\n                </li>\n              </ul>\n            </div>\n          </div>\n        </div>\n      </div>\n  \n      <div class="modal-footer">\n        <center>\n          <button class="btn btn-info" ng-click="save()">Save</button>\n          <button class="btn btn-gap-v btn-default" ng-click="cancel()">Cancel</button>\n        </center>\n      </div>\n    </script>\n  </div>\n  ',
	    controller: function controller($scope, $modal) {
	
	      var toggleEditBehavior = function toggleEditBehavior(practices) {
	        $scope.editPractices = (0, _common.isAnyObjectSelected)(practices);
	      };
	
	      var determineEditBehavior = function determineEditBehavior(newPAvalue, oldPAvalue) {
	        if (!_.isEqual(newPAvalue, oldPAvalue)) toggleEditBehavior($scope.linearPractices);
	      };
	
	      var updatePracticesModel = function updatePracticesModel(practicesData) {
	        $scope.linearPractices = angular.copy(practicesData.linearPractices);
	        $scope.nestedPractices = angular.copy(practicesData.updated_data);
	        $scope.$applyAsync();
	      };
	
	      var getPracticesModalData = function getPracticesModalData() {
	        return {
	          element: 'practice',
	          data: angular.copy($scope.nestedPractices),
	          linearPractices: angular.copy($scope.linearPractices),
	          maxSelectablePracticeAreas: $scope.selectionLimit || 9999999 //a max value for maximum selection
	        };
	      };
	
	      var updatePracticesUI = function updatePracticesUI(selectedItem) {
	        if (!selectedItem.linearPractices) return;
	
	        var updatedData = {
	          updated_data: selectedItem.data,
	          linearPractices: selectedItem.linearPractices
	        };
	
	        updatePracticesModel(updatedData);
	        toggleEditBehavior(updatedData.linearPractices);
	      };
	
	      $scope.openModal = function (event) {
	        if (event) {
	          event.preventDefault();
	          event.stopPropagation();
	        }
	
	        var modalInstance = $modal.open({
	          backdrop: 'static',
	          templateUrl: "modal-practices-template.html",
	          controller: 'ProfileModalCtrl',
	          resolve: {
	            data: function data() {
	              return getPracticesModalData();
	            }
	          }
	        });
	
	        return modalInstance.result.then(updatePracticesUI);
	      };
	
	      $scope.$watch('linearPractices', determineEditBehavior, true);
	    }
	  };
	}); /******************************************************************/
	/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
	/******************************************************************/

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _common = __webpack_require__(33);
	
	// Template for the Dropdown
	var multiSelectDropdownTemplate = '\n<div uib-dropdown class="multi-select-dropdown  inlineBlock margin-r20 ui-select color-dropdown-ml" style="margin-left: 0;width: 100%;" >\n  <style>\n  .multi-select-dropdown .dropdown-toggle,\n  .multi-select-dropdown .dropdown-toggle:active,  \n  .multi-select-dropdown .dropdown-toggle:hover,\n  .multi-select-dropdown .dropdown-button.dropdown-toggle:focus {\n    border: none;\n  }\n  .dropdown-button{\n    color: #242633;\n    padding: 6px 10px 6px 10px;\n    width: 100%;\n    font-size: 14px;\n    font-weight: inherit;\n    letter-spacing: normal;\n    text-transform: unset;\n    border-color: transparent;\n    margin: 0;\n    text-align: left;\n  }\n  .dropdown-button:hover, .dropdown-button:focus, .dropdown-button:active {\n    background-color: transparent;\n    color: #242633;\n  }\n  .dropdown .locationsDropdown{\n    max-height: 300px;\n    width: 285px;\n  }\n  @media only screen and (min-width: 767px) and (max-width: 768px) {\n    .dropdown .locationsDropdown{\n      max-height: 300px;\n      width: 245px;\n    }\n  }\n  @media only screen and (min-width: 320px) and (max-width: 767px) {\n    .dropdown .locationsDropdown{\n      max-height: 300px;\n      width: 175px;\n    }\n  }\n  .practice-area-list {\n    padding-left: 38px;\n    max-height: 220px;\n    overflow-y: auto;\n  }\n  .practice-area-list li{\n    padding: 2px 0;\n  }\n  </style>\n  <div uib-dropdown>\n    <button uib-dropdown-toggle id="{{buttonId}}" class="btn-noline-info btn-xs dropdown-button " type="button">\n      {{placeholder}}\n  </button>\n    <div uib-dropdown-menu class="bootstrapDropdown locationsDropdown">\n      <div class = "pull-right padding-b5">\n      <button ng-click="selectAll()" class="btn btn-info btn-xs">Select All</button>\n      <button ng-click="unselectAll()" class="btn btn-info btn-xs">Deselect All</button>\n      </div>\n      <br />\n\n      <div class="" data-ng-repeat = "item in baseList | orderBy: \'value\'">\n        <label class="ui-checkbox margin-r10">\n            <input type="checkbox" ng-click="selectItem(item)" data="{{value}}" ng-model="item.ticked">\n            <span>{{item.name}}</span>\n        </label>\n      </div>\n    </div>\n  </div>\n</div>\n';
	
	// Controller for the dropdown directive
	var multiSelectDropdownController = function multiSelectDropdownController($scope, $timeout, locationsService) {
	  var stopEventExecution = function stopEventExecution(event) {
	    event.stopPropagation();
	  };
	
	  $('.bootstrapDropdown').click(stopEventExecution);
	
	  $scope.selectItem = function (item) {
	    item.ticked = !item.ticked;
	    $scope.onChange();
	  };
	
	  // Resets the selection of all
	  $scope.unselectAll = function () {
	    $scope.baseList.forEach(function (item) {
	      item.ticked = false;
	    });
	    $scope.onChange();
	  };
	
	  $scope.selectAll = function () {
	    $scope.baseList.forEach(function (item) {
	      item.ticked = true;
	    });
	    $scope.onChange();
	  };
	};
	
	// returns DDO for the dropdown
	var multiSelectDropdown = function multiSelectDropdown() {
	  return {
	    restrict: 'AE',
	    scope: {
	      buttonId: '@',
	      placeholder: '=',
	      baseList: '=',
	      onChange: '&'
	    },
	    replace: true,
	    template: multiSelectDropdownTemplate,
	    controller: multiSelectDropdownController
	  };
	};
	
	angular.module('app.directives').directive('multiSelectDropdown', multiSelectDropdown);

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _positionDetailsCtrl = __webpack_require__(188);
	
	var positionDetails = function positionDetails() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    controller: _positionDetailsCtrl.PositionDetailsController,
	    template: __webpack_require__(470)
	  };
	};
	
	angular.module('app.directives').directive('positionDetails', positionDetails);

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _common = __webpack_require__(33);
	
	// Template for the Dropdown
	var multiSelectDropdownTemplate = '\n  <div uib-dropdown class="filters-action">\n    <style>  \n    .pqeSilderDropdown {\n      width: 451px !important;\n      height: 70px !important;\n      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    }\n    .dropdown .bootstrapDropdown{\n      overflow:unset;\n    }\n    </style>\n      <button uib-dropdown-toggle id="{{data.buttonId}}" class="btn" type="button" data-tooltip-check="Filter by PQE">\n        <svg version="1.1"  width="24" height="24" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n          viewBox="0 0 614.9 540" style="enable-background:new 0 0 614.9 540;" xml:space="preserve">\n            <style type="text/css">    \n            .st0{fill:#9D9D9D;}\n            .st1{clip-path:url(#SVGID_2_);fill:#848485;}\n            .st2{clip-path:url(#SVGID_2_);fill:#B7333D;}          \n              .st3{fill-rule:evenodd;clip-rule:evenodd;fill:#9D9D9D;}\n              .st4{fill:#9D9D9D;}\n            </style>\n            <g>\n              <path class="st3" d="M475.2,286.8c1.2-21.4,4.3-42.7,18-60.3c16.7-21.6,14.4-42.5-0.1-63.9c-11.9-17.6-17.9-37.3-18.6-58.4\n                c-0.8-22.9-12.1-38.1-33.6-44.8c-19.6-6.1-34.7-17.6-46.4-33.7c-15.5-21.3-35.7-26-59.7-18.3c-16.8,5.4-33.5,4.6-50.5,1.1\n                c-8.3-1.7-16.6-3.4-21.3-4.4c-16.8,0.1-28.6,4.6-35.7,15c-15.6,22.8-36.7,36.6-62.4,44.9c-15.8,5.1-24.4,16.6-23.3,33.1\n                c1.7,27-7.3,50-22.6,71.5c-11,15.5-12.5,33-1.7,47.9c16.2,22.4,21.7,47.2,23.6,73.5c1.3,18,11.1,29.4,27.7,34.6\n                c14.3,4.5,26.9,11.1,37.9,20c-19.7,39.7-59.9,102.1-76,137.8c-4.7,10.3-1.3,14.4,11.2,11.1c17-4.4,34.3-8.1,51.2-13.1\n                c8.1-2.4,11.9-0.8,15.5,5.8c7.3,13.5,15.4,26.7,23.3,39.9c2.3,3.8,3.3,9.5,9.2,9.7c7.2,0.3,8-6.1,10-10.5\n                c12-26.1,35.3-65.2,55.4-100.6c18,30.5,53.5,80.7,63.9,103.2c1.5,3.2,2.8,6.9,7.4,7.3c5.7,0.5,7.3-4,9.3-7.3\n                c8.3-13.6,16.6-27.2,24.3-41.2c4.1-7.5,8.2-10.4,18-7.1c15,5.2,30.6,9,46.1,12.7c4.4,1.1,9.5,5.3,13.9,1.2\n                c4.9-4.6,0.5-9.5-1.4-13.9c-14.5-32.6-59.3-97.9-78-134.8c10.7-7.8,22.7-13.7,35.7-18.5C464,319.9,474.1,307,475.2,286.8z\n                  M164.1,199c0-78.8,66.1-144.3,144.9-143.7c79.1,0.6,143.9,66.6,143,145.6c-0.9,77.9-66.7,142.4-144.9,142\n                C229.1,342.4,164,277,164.1,199z"/>\n              <path class="st3" d="M424.1,199.6c0-63.4-51.4-114.8-114.8-114.8c-63.4,0-114.8,51.4-114.8,114.8c0,63.4,51.4,114.8,114.8,114.8\n                C372.8,314.4,424.1,263,424.1,199.6z"/>\n            </g>\n        </svg>\n       </button>\n        <div uib-dropdown-menu class="bootstrapDropdown locationsDropdown pqeSilderDropdown pqe-slider-dropdown" >\n            <div class="browse-opps-pqe-filter">\n                <input ng-model="data.params.filterPQE.pqe" ng-change="data.function(data.params.filterPQE)" autocomplete="off" type="text" id="mySlider2" slider options="data.params.options"/>\n            </div>\n        </div>\n    </div>\n  ';
	
	// Controller for the dropdown directive
	var pqeSliderDropdownController = function pqeSliderDropdownController($scope, $timeout, locationsService) {
	  var stopEventExecution = function stopEventExecution(event) {
	    event.stopPropagation();
	  };
	
	  $('.pqe-slider-dropdown').click(stopEventExecution);
	
	  $scope.$on('ag-grid-reset-filters', function (evt) {
	    $scope.data.params.filterPQE.pqe = "-2;11";
	    $scope.$apply();
	  });
	
	  $scope.selectItem = function (item) {
	    item.ticked = !item.ticked;
	    $scope.onChange();
	  };
	
	  // Resets the selection of all
	};
	
	// returns DDO for the dropdown
	var pqeSliderDropdown = function pqeSliderDropdown() {
	  return {
	    restrict: 'AE',
	    scope: {
	      data: '='
	    },
	    replace: true,
	    template: multiSelectDropdownTemplate,
	    controller: pqeSliderDropdownController
	  };
	};
	
	angular.module('app.directives').directive('pqeSliderDropdown', pqeSliderDropdown);

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _common = __webpack_require__(33);
	
	// Template for the Dropdown
	var selectPracticesTemplate = '\n  <div uib-dropdown class="filters-action">\n    <style>\n      .select-practice-areas .dropdown-toggle,\n      .select-practice-areas .dropdown-toggle:hover,\n      .select-practice-areas .dropdown-toggle:active,\n      .select-practice-areas .dropdown-button.dropdown-toggle:focus {\n        border: none;\n      }\n      .dropdown-button{\n        color: #242633;\n        padding: 8px 10px;\n        width: 100%;\n        font-size: 14px;\n        font-weight: inherit;\n        letter-spacing: normal;\n        text-transform: unset;\n        border-color: transparent;\n        text-align: left;\n      }\n      .dropdown-button:hover, .dropdown-button:focus, .dropdown-button:active {\n        background-color: transparent;\n        color: #242633;\n      }\n      .dropdown .bootstrapDropdown{\n        max-height: 300px;\n        width: 383px;\n        // z-index: 1;\n      }\n      .practiceAreasDropdownAgGrid{\n        width: 450px !important;\n        max-height: 450px !important;\n        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n      }\n      .practice-area-list {\n        padding-left: 70px;\n      }\n      .practice-area-list li{\n        padding: 3px 0;\n      }\n\n      .practiceAreasPadding {\n        padding-left: 2px;\n      }\n      .resetSelectAllButton {\n        position: absolute;\n        background: white;\n        z-index: 1;\n        padding-bottom: 15px;\n        text-align: right;\n      }\n      .agGridTempReset:focus{\n        border: 1px solid transparent !important;\n        background-color: #95288f !important;\n        border-color: #95288f !important;\n      }\n    </style>\n    <button uib-dropdown-toggle id="{{data.buttonId}}" class="btn" type="button" data-tooltip-check={{data.iconlabel}}>\n        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n        <style type="text/css">\n          .st0{fill:#9D9D9D;}          \n        </style>\n            <path fill="none" d="M0 0h24v24H0V0z"/>\n            <path class="st0" d="M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z"/></svg>\n          \n        </button>\n  \n    <div uib-dropdown-menu  class="bootstrapDropdown practiceAreasDropdownAgGrid">\n    <div class="modal-row custom-modal">\n      <div class="row resetSelectAllButton col-md-12">\n        <button ng-click="resetPractices()" class="btn btn-info btn-xs agGridTempReset">Select All</button>\n        <button ng-click="deselectPractices()" class="btn btn-info btn-xs agGridTempReset">Deselect All</button>\n      </div>\n      <div class="col-md-12 margin-t15">\n      <br />\n        <div ng-class="{\'practiceAreasPadding\': law_area.practices.length}" data-ng-repeat="law_area in data.nrefPractices">\n          <span ng-class="{\'no-child\': law_area.practices.length === 0}">\n            <i ng-hide="law_area.showSubPracticeAreas || law_area.practices.length === 0" ng-click="displaySubPracticeAreas(law_area)"\n              class="fa fa-plus expand-collapse-button" aria-hidden="true"></i>\n          </span>\n          <span ng-class="{\'no-child\': law_area.practices.length === 0}">\n            <i ng-hide="!law_area.showSubPracticeAreas" ng-click="hideSubPracticeAreas(law_area)" class="fa fa-minus expand-collapse-button"\n              aria-hidden="true"></i>\n          </span>\n          <label class="ui-checkbox">\n            <input type="checkbox" id="{{law_area.practice_name}}" ng-click="selectPractices($event , law_area , 2)" data="{{practice_ID}}" ng-checked="law_area.isSelected">\n            <span class="checkbox-group-heading" ng-style="law_area.practices.length > 0 && {\'font-weight\': \'bold\'}">{{law_area.practice_name}}\n            </span>\n          </label>\n          <ul ng-show="law_area.showSubPracticeAreas" class=" practice-area-list clearfix">\n            <li data-ng-repeat="practice in law_area.practices">\n              <label class="ui-checkbox">\n                <input type="checkbox" id="{{practice.practice_name}}" data="{{practice.loc_ID}}" ng-click="selectPractices($event , practice , 1)" ng-checked="practice.isSelected">\n                <span>{{practice.practice_name}}</span>\n              </label>\n              <ul class=" sub-list clearfix">\n                <li data-ng-repeat="sub in practice.sub_areas">\n                  <label class="ui-checkbox">\n                    <input type="checkbox" id="{{sub.practice_name}}" ng-click="selectPractices($event , sub , 0)" ng-checked="sub.isSelected">\n                    <span>{{sub.practice_name}}</span>\n                  </label>\n                </li>\n              </ul>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n      \n  </div>\n  ';
	
	// Controller for the dropdown directive
	/******************************************************************/
	/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
	/******************************************************************/
	
	var selectPracticesController = function selectPracticesController($scope, $timeout, practicesService) {
	  var stopEventExecution = function stopEventExecution(event) {
	    event.stopPropagation();
	  };
	
	  $('.practiceAreasDropdownAgGrid').click(stopEventExecution);
	
	  // Method to update the outside scope's practices model
	  // model will be used outside the directive(inside parent's
	  // controller)
	
	  $scope.$on('ag-grid-reset-filters', function (evt) {
	    $scope.resetPractices();
	  });
	
	  $scope.displaySubPracticeAreas = function (law_area) {
	    return law_area.showSubPracticeAreas = true;
	  };
	  $scope.hideSubPracticeAreas = function (law_area) {
	    return law_area.showSubPracticeAreas = false;
	  };
	  var updatePracticesModel = function updatePracticesModel() {
	    var allowUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    var updateAndNotify = function updateAndNotify() {
	      var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      $scope.pracsModel = values;
	      $scope.data.onPracChange();
	      $timeout(function () {
	        return $scope.$apply();
	      });
	    };
	
	    //If model is not provided just notify the parent
	    // to update itself
	    if (!$scope.hasOwnProperty('pracsModel') || !allowUpdate) {
	      updateAndNotify([]);
	      return;
	    }
	
	    //If model is provided, filter the ids of the selected
	    // objects and notify parent
	    (0, _common.getSelectedObjectsProperty)(practicesService.linearize($scope.data.nrefPractices), 'practice_ID').then(updateAndNotify);
	  };
	
	  // Resets the selection of all Practices
	  $scope.resetPractices = function () {
	    practicesService.clearSelection($scope.data.nrefPractices, $scope.data.selectOnReset);
	    updatePracticesModel(false);
	  };
	
	  $scope.deselectPractices = function () {
	    practicesService.deselectSelection($scope.data.nrefPractices, false);
	    updatePracticesModel(false);
	  };
	
	  // Selects a particular practice
	  $scope.selectPractices = function (event, current, level) {
	    practicesService.select($scope.data.nrefPractices, event, current, level);
	    updatePracticesModel();
	  };
	};
	
	// returns DDO for the dropdown
	var practiceAreaDropdownAgGridTemp = function practiceAreaDropdownAgGridTemp() {
	  return {
	    restrict: 'AE',
	    scope: {
	      pracsModel: '=?',
	      data: '='
	    },
	    replace: true,
	    template: selectPracticesTemplate,
	    controller: selectPracticesController
	  };
	};
	
	angular.module('app.directives').directive('practiceAreaDropdownAgGridTemp', practiceAreaDropdownAgGridTemp);

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _practiceAreaDropdown = __webpack_require__(189);
	
	var practiceAreaDropdown = function practiceAreaDropdown() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    scope: {
	      buttonId: '@',
	      practiceAreasList: '=',
	      onPracticeChange: '&',
	      grid: '=',
	      iconLabel: '=',
	      allChecked: '=',
	      width: '=',
	      placeholder: '='
	    },
	    controller: _practiceAreaDropdown.PracticeAreaDropdownController,
	    template: __webpack_require__(471)
	  };
	};
	
	angular.module('app.directives').directive('practiceAreaDropdown', practiceAreaDropdown);

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _practiceAreaModal = __webpack_require__(190);
	
	var practiceArea = function practiceArea() {
	  return {
	    restrict: 'AE',
	    replace: true,
	    controller: _practiceAreaModal.PracticeArea,
	    template: __webpack_require__(472)
	  };
	};
	
	angular.module('app.directives').directive('practiceArea', practiceArea);

/***/ }),
/* 710 */
/***/ (function(module, exports) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	angular.module('app.services').factory('practiceAreaService', [function practiceAreaService() {
	  var instance = {
	    selectPracticeArea: function selectPracticeArea(practiceAreasList, selectedValue, event) {
	      var checked = event.target.checked;
	      if (selectedValue.parentId) {
	        var parentPracticeArea = getPracticeAreaById(practiceAreasList, selectedValue.parentId);
	        if (!parentPracticeArea) {
	          parentPracticeArea = practiceAreasList.map(function (practiceArea) {
	            return practiceArea.children ? getPracticeAreaById(practiceArea.children, selectedValue.parentId) : undefined;
	          }).find(function (practiceArea) {
	            return practiceArea;
	          });
	        }
	
	        parentPracticeArea.isSelected = checked === false ? getSiblingPracticeAreaById(parentPracticeArea.children, selectedValue.id) : checked;
	
	        if (parentPracticeArea.parentId) {
	          var grandParentPracticeArea = getPracticeAreaById(practiceAreasList, parentPracticeArea.parentId);
	          grandParentPracticeArea.isSelected = checked === false ? getSiblingPracticeAreaById(grandParentPracticeArea.children, selectedValue.id) : checked;
	        }
	      }
	
	      if (selectedValue.children) {
	        selectedValue.children.map(function (child) {
	          if (child.children) {
	            child.children.map(function (subChild) {
	              subChild.isSelected = checked;
	              return subChild;
	            });
	          }
	
	          child.isSelected = checked;
	          return child;
	        });
	      }
	
	      selectedValue.isSelected = checked;
	    },
	    setIsSelectedChildrenPracticeArea: function setIsSelectedChildrenPracticeArea(allPracticeAreasList, selectedPractice) {
	      allPracticeAreasList.forEach(function (practiceArea) {
	        if (practiceArea.isSelected === true && practiceArea.children) {
	          practiceArea.children.forEach(function (child) {
	            if (child.isSelected === true && child.children) {
	              var subChildren = child.children.filter(function (subChild) {
	                return subChild.isSelected === true;
	              });
	              if (subChildren.length > 0) {
	                subChildren.forEach(function (subChild) {
	                  selectedPractice.push(subChild);
	                });
	              }
	            } else if (child.isSelected === true) {
	              selectedPractice.push(child);
	            }
	          });
	        } else if (practiceArea.isSelected === true) {
	          selectedPractice.push(practiceArea);
	        }
	      });
	      return selectedPractice;
	    },
	
	    initialize: function initialize(selectedPractices, allPracticeAreasList, checked) {
	      instance.clearSelection(allPracticeAreasList, checked);
	      selectedPractices.forEach(function (selectedValue) {
	        assignSelectedPracticeAreaHierarchy(selectedValue, true, allPracticeAreasList, instance);
	      });
	    },
	    makeCandidatePracticeAreasHierarchy: function makeCandidatePracticeAreasHierarchy(candidateCategories, allPracticeAreas) {
	      var practiceAreasWithParent = [];
	      var candidatePracticeAreas = new Set(candidateCategories && candidateCategories.find(function (_ref) {
	        var id = _ref.id;
	        return id === 1;
	      }).specialties.map(function (_ref2) {
	        var id = _ref2.id;
	        return id;
	      }));
	
	      var candidatePracticeAreasFromList = allPracticeAreas.filter(function (_ref3) {
	        var id = _ref3.id;
	        return candidatePracticeAreas.has(id);
	      });
	      candidatePracticeAreasFromList.forEach(function (practiceArea) {
	        assignParentsToPracticeAreas(practiceArea, allPracticeAreas, practiceAreasWithParent);
	      });
	      practiceAreasWithParent = practiceAreasWithParent.filter(function (v, index, a) {
	        return a.findIndex(function (t) {
	          return t.id === v.id;
	        }) === index;
	      }).sort(function (a, b) {
	        return a.id > b.id ? 1 : -1;
	      });
	
	      instance.initialize([], practiceAreasWithParent, true);
	      return practiceAreasWithParent;
	    },
	    clearSelection: function clearSelection(allPracticeAreasList, selection) {
	      instance.selectPracticeAreas(allPracticeAreasList, selection);
	    },
	    selectPracticeAreas: function selectPracticeAreas(allPracticeAreasList, selection) {
	      allPracticeAreasList.forEach(function (practice) {
	        practice.isSelected = selection;
	        if (practice.children && practice.children.length > 0) instance.selectPracticeAreas(practice.children, selection);
	      });
	    },
	    selectOrDeselectAllPractices: function selectOrDeselectAllPractices(allPracticeAreasList, selection) {
	      instance.selectPracticeAreas(allPracticeAreasList, selection);
	    },
	    onlyChildrenPractices: function onlyChildrenPractices(allPracticeAreasList, _onlyChildrenPractices) {
	      allPracticeAreasList.forEach(function (practiceArea) {
	        if (practiceArea.children) {
	          practiceArea.children.forEach(function (child) {
	            if (child.children) {
	              var subChildren = child.children.filter(function (subChild) {
	                return subChild.parentId !== null;
	              });
	              if (subChildren.length > 0) {
	                subChildren.forEach(function (subChild) {
	                  _onlyChildrenPractices.push(subChild);
	                });
	              }
	            } else if (child.parentId !== null) _onlyChildrenPractices.push(child);
	          });
	        } else if (practiceArea.parentId === null && !practiceArea.children) {
	          _onlyChildrenPractices.push(practiceArea);
	        }
	      });
	      return _onlyChildrenPractices;
	    }
	  };
	
	  return instance;
	}]);
	
	/** This method will assign isSelected checked and unchecked of selected Practice area  in hierarchial way.
	 * @param  {} selectedValue
	 * @param  {} checked
	 * @param  {} vm
	 */
	var assignSelectedPracticeAreaHierarchy = function assignSelectedPracticeAreaHierarchy(selectedValue, checked, allPracticeAreasList, instance) {
	  if (selectedValue.parentId) {
	    var parentPracticeArea = allPracticeAreasList.find(function (_ref4) {
	      var id = _ref4.id;
	      return id === selectedValue.parentId;
	    });
	
	    if (!parentPracticeArea) {
	      parentPracticeArea = allPracticeAreasList.map(function (practiceArea) {
	        return practiceArea.children ? practiceArea.children.find(function (_ref5) {
	          var id = _ref5.id;
	          return id === selectedValue.parentId;
	        }) : undefined;
	      }).find(function (practiceArea) {
	        return practiceArea;
	      });
	    }
	
	    parentPracticeArea.isSelected = checked;
	    if (parentPracticeArea.parentId) {
	      allPracticeAreasList.find(function (_ref6) {
	        var id = _ref6.id;
	        return id === parentPracticeArea.parentId;
	      }).isSelected = checked;
	    }
	
	    if (parentPracticeArea.children) {
	      parentPracticeArea.children.find(function (_ref7) {
	        var id = _ref7.id;
	        return id === selectedValue.id;
	      }).isSelected = checked;
	    }
	  } else {
	    var practiceArea = allPracticeAreasList.filter(function (_ref8) {
	      var id = _ref8.id;
	      return id === selectedValue.id;
	    });
	    instance.selectPracticeAreas(practiceArea, checked);
	  }
	};
	
	/** This method will find sibling of Practice Area
	 * @param  {} list either practice area or children of practice area
	 * @param  {} id id
	 */
	var getSiblingPracticeAreaById = function getSiblingPracticeAreaById(list, id) {
	  return list.some(function (sibling) {
	    return sibling.isSelected === true && sibling.id !== id;
	  });
	};
	
	/** This method will find and return record of PracticeArea by id
	 * @param  {} list  either PracticeAreas or PracticeArea children
	 * @param  {} id id
	 */
	var getPracticeAreaById = function getPracticeAreaById(list, id) {
	  return list.find(function (row) {
	    return row.id === id;
	  });
	};
	
	var assignParentsToPracticeAreas = function assignParentsToPracticeAreas(practiceArea, allPracticeAreas, practiceAreasWithParent) {
	  if (practiceArea.parentId === null) {
	    practiceAreasWithParent.push(practiceArea);
	    return;
	  }
	
	  if (practiceAreasWithParent.findIndex(function (_ref9) {
	    var id = _ref9.id;
	    return practiceArea.parentId === id;
	  }) >= 0) {
	    var parentId = practiceAreasWithParent.findIndex(function (_ref10) {
	      var id = _ref10.id;
	      return practiceArea.parentId === id;
	    });
	    var parent = practiceAreasWithParent[parentId];
	
	    parent.children = [].concat(_toConsumableArray(parent.children), [practiceArea]);
	    practiceArea = Object.assign(parent);
	  } else {
	    var _parentId = allPracticeAreas.findIndex(function (_ref11) {
	      var id = _ref11.id;
	      return practiceArea.parentId === id;
	    });
	    var _parent = allPracticeAreas[_parentId];
	
	    _parent.children = [practiceArea];
	    practiceArea = Object.assign(_parent);
	  }
	
	  assignParentsToPracticeAreas(practiceArea, allPracticeAreas, practiceAreasWithParent);
	};

/***/ }),
/* 711 */
/***/ (function(module, exports) {

	'use strict';
	
	/******************************************************************/
	/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
	/******************************************************************/
	
	angular.module('app.directives').directive('readMoreWords', function ($sce) {
	  return {
	    restrict: 'AE',
	    scope: {
	      hmtext: '@',
	      hmlimit: '@',
	      hmfulltext: '@',
	      hmMoreText: '@',
	      hmLessText: '@',
	      hmMoreClass: '@',
	      hmLessClass: '@'
	    },
	    template: '\n        <span ng-if="hmtext.length > hmlimit">\n          <span class="pull-left" ng-hide="hmfulltext" ng-bind-html="hmtext | limitWord:hmlimit"></span>\n\n          <span ng-hide="hmfulltext">\n            &nbsp; ...\n            <a class="more-class" href="" ng-click="toggleValue()">\n              {{ hmMoreText }}\n            </a>\n          </span>\n\n          <p ng-show="hmfulltext" ng-bind-html="hmtext"></p>\n\n          <span ng-show="hmfulltext">\n            <a class="more-class" href="" ng-click="toggleValue()">{{ hmLessText }}</a>\n          </span>\n\n        </span>\n\n        <span ng-if="hmtext.length <= hmlimit" ng-bind-html="hmtext"></span>\n\n        <style type="text/css">\n          .more-class {\n            color: #4c9bda;\n          }\n        </style>\n    ',
	    transclude: true,
	    controller: function controller($scope) {
	      $scope.toggleValue = function () {
	        $scope.hmfulltext = !$scope.hmfulltext;
	      };
	    }
	  };
	});

/***/ }),
/* 712 */
/***/ (function(module, exports) {

	'use strict';
	
	var htmlTemplate = '<ul class="list-inline list-practice-area margin-b0" ng-init="hmLimitGiven = hmLimit; hmFilteredObjectArray = (hmObjectArray | filter: hmFilter); hmLength =hmFilteredObjectArray.length">\n<li ng-if="hmStyle" class="label label-info text-uppercase margin-r5" ng-repeat="object in hmFilteredObjectArray | limitTo:hmLimitGiven track by $index" ng-style="{{styles}}">\n  {{(hmProperty !== UNDEFINED && hmProperty !== NULL) ? object[hmProperty] :object}} &nbsp;\n</li>\n\n <li ng-if="!hmStyle" ng-repeat="object in hmFilteredObjectArray | limitTo:hmLimitGiven track by $index">\n     {{(hmProperty !== UNDEFINED && hmProperty !== NULL) ? object[hmProperty] :object}}\n     <span ng-if="!$last">,  </span>\n </li>\n\n&nbsp;\n<div ng-repeat-end="" class="more-less-text display-inline padding-5">\n  <a ng-if="hmLimitGiven < hmLength" ng-click="displayMoreObjects();" class="text-info pointer">{{hmLength - hmLimit}}&nbsp;{{hmMoreText}}</a>\n  <a ng-if="hmLimitGiven === (hmLength + 1)" ng-click="displayLessObjects();" class="text-info pointer"> &nbsp;{{hmLessText}}</a>\n</div>\n</ul>';
	
	angular.module('app.directives').directive('seeMore', function seeMore() {
	  return {
	    scope: {
	      hmStyle: '@',
	      hmLimit: '@',
	      hmObjectArray: '=',
	      hmMoreText: '@',
	      hmLessText: '@',
	      hmMoreClass: '@',
	      hmLessClass: '@',
	      hmFilter: '=',
	      hmProperty: '@'
	    },
	    replace: true,
	    template: htmlTemplate,
	    controller: function controller($scope) {
	      var getStyles = function getStyles() {
	        if (!_.isEmpty($scope.hmStyle)) {
	          return $scope.hmStyle.replace('this', 'object');
	        }
	
	        return {};
	      };
	
	      $scope.styles = getStyles($scope.hmStyle);
	
	      $scope.displayMoreObjects = function () {
	        $scope.hmLimitGiven = $scope.hmLength + 1;
	      };
	
	      $scope.displayLessObjects = function () {
	        $scope.hmLimitGiven = $scope.hmLimit;
	      };
	    }
	  };
	});

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _common = __webpack_require__(33);
	
	// Template for the Dropdown
	var selectLocationsTemplate = '\n<div uib-dropdown class="select-locations inlineBlock margin-r20 ui-select color-dropdown-ml" style="margin-left: 0;width: 100%;" >\n  <style>\n  .select-locations .dropdown-toggle,\n  .select-locations .dropdown-toggle:active,  \n  .select-locations .dropdown-toggle:hover,\n  .select-locations .dropdown-button.dropdown-toggle:focus {\n    border: none;\n  }\n  .dropdown-button{\n    color: #242633;\n    padding: 6px 10px 6px 10px;\n    width: 100%;\n    font-size: 14px;\n    font-weight: inherit;\n    letter-spacing: normal;\n    text-transform: unset;\n    border-color: transparent;\n    margin: 0;\n    text-align: left;\n  }\n  .dropdown-button:hover, .dropdown-button:focus, .dropdown-button:active {\n    background-color: transparent;\n    color: #242633;\n  }\n  .dropdown .locationsDropdown{\n    max-height: 300px;\n    width: 285px;\n  }\n  .practice-area-list {\n    padding-left: 38px;    \n  }\n  .practice-area-list li{\n    padding: 2px 0;\n  }\n  </style>\n  <div uib-dropdown>\n    <button uib-dropdown-toggle id="{{buttonId}}" class="btn-noline-info btn-xs dropdown-button" type="button">\n      Locations\n  </button>\n    <div uib-dropdown-menu class="bootstrapDropdown locationsDropdown">\n      <div class = "pull-right">\n      <button ng-click="selectAllLocations()" class="btn btn-info btn-xs">Select All</button>\n        <button ng-click="unselectAllLocations()" class="btn btn-info btn-xs">Deselect All</button>\n      </div>\n      <br />\n\n      <div class="" data-ng-repeat = "region in nrefLocations | orderBy: \'loc_ID\'">\n        <label class="ui-checkbox">\n            <input type="checkbox" ng-click="selectLocation($event , region , 2)" data="{{loc_ID}}" ng-model="region.isSelected">\n            <span class="checkbox-group-heading"><strong>{{region.loc_name}}</strong></span>\n        </label>\n        <ul class=" practice-area-list clearfix">\n            <li data-ng-repeat="location in region.locations">\n                <label class="ui-checkbox">\n                    <input type="checkbox"\n                        data="{{location.loc_ID}}"\n                        ng-click="selectLocation($event , location , 1)"\n                        ng-checked="location.isSelected"\n                        ng-model="location.isSelected"\n                    >\n                    <span>{{location.loc_name}}</span>\n                </label>\n              <ul class=" sub-list clearfix">\n                <li data-ng-repeat = "sub in location.sub_areas">\n                    <label class="ui-checkbox">\n                        <input type="checkbox"\n                            ng-click="selectLocation($event , sub , 0)"\n                            ng-checked="sub.isSelected"\n                            ng-model="sub.isSelected">\n                        <span>{{sub.loc_name}}</span>\n                    </label>\n                  </li>\n              </ul>\n            </li>\n        </ul>\n      </div>\n    </div>\n  </div>\n</div>\n';
	
	// Controller for the dropdown directive
	/******************************************************************/
	/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
	/******************************************************************/
	
	var selectLocationsController = function selectLocationsController($scope, $timeout, locationsService) {
	  var stopEventExecution = function stopEventExecution(event) {
	    event.stopPropagation();
	  };
	
	  $('.bootstrapDropdown').click(stopEventExecution);
	
	  // Method to update the outside scope's locations model
	  // model will be used outside the directive(inside parent's
	  // controller)
	  var updateLocsModel = function updateLocsModel() {
	    var allowUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    var updateAndNotify = function updateAndNotify() {
	      var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      $scope.locsModel = values;
	      $scope.onLocsChange();
	      $timeout(function () {
	        return $scope.$apply();
	      });
	    };
	
	    //If model is not provided just notify the parent
	    // to update itself
	    if (!$scope.hasOwnProperty('locsModel') || !allowUpdate) {
	      updateAndNotify([]);
	      return;
	    }
	
	    //If model is provided, filter the ids of the selected
	    // objects and notify parent
	    (0, _common.getSelectedObjectsProperty)(locationsService.linearize($scope.nrefLocations), 'loc_ID').then(updateAndNotify);
	  };
	
	  // Unselection of all Locations
	  $scope.unselectAllLocations = function () {
	    locationsService.clearSelection($scope.nrefLocations, false);
	    updateLocsModel(false);
	  };
	
	  $scope.selectAllLocations = function () {
	    locationsService.clearSelection($scope.nrefLocations, true);
	    updateLocsModel(false);
	  };
	
	  // Selects a particular location
	  $scope.selectLocation = function (event, current, level) {
	    locationsService.select($scope.nrefLocations, event, current, level, $scope.count);
	    updateLocsModel();
	  };
	};
	
	// returns DDO for the dropdown
	var selectLocations = function selectLocations() {
	  return {
	    restrict: 'AE',
	    scope: {
	      buttonId: '@',
	      locsModel: '=?',
	      nrefLocations: '=',
	      onLocsChange: '&',
	      selectOnReset: '=?'
	    },
	    replace: true,
	    template: selectLocationsTemplate,
	    controller: selectLocationsController
	  };
	};
	
	angular.module('app.directives').directive('selectLocations', selectLocations);

/***/ }),
/* 714 */
/***/ (function(module, exports) {

	'use strict';
	
	/******************************************************************/
	/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
	/******************************************************************/
	
	angular.module('app.directives').directive('selectPracticeAreasSimple', function () {
	  return {
	    restrict: 'AE',
	    scope: {
	      practicesModel: "=",
	      practiceAreas: "=",
	      onPracChange: '&'
	    },
	    replace: true,
	    template: '\n    <span class="ui-select margin-0">\n      <select class="admin-filter practice-filter width-inherit" ng-change="onPracChange(\'practice\');" ng-model="practicesModel">\n        <option value=\'\' disabled selected style=\'display:none;\'>Practice Area</option>\n        <option value="All">All</option>\n        <option ng-repeat="area in practiceAreas" value="{{area.practice_ID}}">{{area.practice_name}}</option>\n      </select>\n    </span>\n  ',
	    controller: function controller($scope, $log, practicesService) {}
	  };
	});

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _common = __webpack_require__(33);
	
	// Template for the Dropdown
	var selectPracticesTemplate = '\n<div uib-dropdown class="select-practice-areas  inlineBlock margin-r20 ui-select full-width" style="margin-left: 0;">\n  <style>\n    .select-practice-areas .dropdown-toggle,\n    .select-practice-areas .dropdown-toggle:hover,\n    .select-practice-areas .dropdown-toggle:active,\n    .select-practice-areas .dropdown-button.dropdown-toggle:focus {\n      border: none;\n    }\n    .dropdown-button{\n      color: #242633;\n      padding: 8px 10px;\n      width: 100%;\n      font-size: 14px;\n      font-weight: inherit;\n      letter-spacing: normal;\n      text-transform: unset;\n      border-color: transparent;\n      text-align: left;\n    }\n    .dropdown-button:hover, .dropdown-button:focus, .dropdown-button:active {\n      background-color: transparent;\n      color: #242633;\n    }\n    .dropdown .bootstrapDropdown{\n      max-height: 300px;\n      width: 383px;\n    }\n    .practice-area-list {\n      padding-left: 38px;\n    }\n    .practice-area-list li{\n      padding: 3px 0;\n    }\n  </style>\n\n\n  <button uib-dropdown-toggle id="{{buttonId}}" class="btn-noline-info btn-xs dropdown-button" type="button">\n    Practice Areas\n  </button>\n\n  <div uib-dropdown-menu class="bootstrapDropdown">\n    <div class = "pull-right">\n      <button ng-click="resetPractices()" class="btn btn-info btn-xs">Select All</button>\n      <button ng-click="deselectPractices()" class="btn btn-info btn-xs">Deselect All</button>\n    </div>\n    <br />\n    <div data-ng-repeat="law_area in nrefPractices">\n      <label class="ui-checkbox">\n        <input type="checkbox" ng-model="law_area.isSelected" ng-click="selectPractices($event , law_area , 2)" data="{{practice_ID}}" ng-checked="law_area.isSelected" />\n        <span class="checkbox-group-heading" ng-style="law_area.practices.length > 0 && {\'font-weight\': \'bold\'}">{{law_area.practice_name}}</span>\n      </label>\n      <ul class=" practice-area-list clearfix">\n        <li data-ng-repeat="practice in law_area.practices track by $index">\n          <label class="ui-checkbox">\n            <input type="checkbox"\n              data="{{practice.loc_ID}}"\n              ng-click="selectPractices($event , practice , 1)" ng-style="law_area.practices.length > 0 && {\'font-weight\': \'bold\'}"\n              ng-checked="practice.isSelected" ng-model="practice.isSelected" />\n            <span>{{practice.practice_name}}</span>\n          </label>\n          <ul class=" sub-list clearfix">\n            <li data-ng-repeat="sub in practice.sub_areas track by $index">\n              <label class="ui-checkbox">\n                <input type="checkbox"\n                    ng-click="selectPractices($event , sub , 0)"\n                    ng-checked="sub.isSelected" ng-model="sub.isSelected" />\n                <span>{{sub.practice_name}}</span>\n              </label>\n            </li>\n          </ul>\n        </li>\n      </ul>\n    </div>\n  </div>\n</div>\n';
	
	// Controller for the dropdown directive
	/******************************************************************/
	/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
	/******************************************************************/
	
	var selectPracticesController = function selectPracticesController($scope, $timeout, practicesService) {
	  var stopEventExecution = function stopEventExecution(event) {
	    event.stopPropagation();
	  };
	
	  $('.bootstrapDropdown').click(stopEventExecution);
	
	  // Method to update the outside scope's practices model
	  // model will be used outside the directive(inside parent's
	  // controller)
	  var updatePracticesModel = function updatePracticesModel() {
	    var allowUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    var updateAndNotify = function updateAndNotify() {
	      var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      $scope.pracsModel = values;
	      $scope.onPracChange();
	      $timeout(function () {
	        return $scope.$apply();
	      });
	    };
	
	    //If model is not provided just notify the parent
	    // to update itself
	    if (!$scope.hasOwnProperty('pracsModel') || !allowUpdate) {
	      updateAndNotify([]);
	      return;
	    }
	
	    //If model is provided, filter the ids of the selected
	    // objects and notify parent
	    (0, _common.getSelectedObjectsProperty)(practicesService.linearize($scope.nrefPractices), 'practice_ID').then(updateAndNotify);
	  };
	
	  // Resets the selection of all Practices
	  $scope.resetPractices = function () {
	    practicesService.clearSelection($scope.nrefPractices, true);
	    updatePracticesModel(false);
	  };
	
	  $scope.deselectPractices = function () {
	    practicesService.deselectSelection($scope.nrefPractices, false);
	    updatePracticesModel(false);
	  };
	
	  // Selects a particular practice
	  $scope.selectPractices = function (event, current, level) {
	    practicesService.select($scope.nrefPractices, event, current, level);
	    updatePracticesModel();
	  };
	};
	
	// returns DDO for the dropdown
	var selectPraciceAreas = function selectPraciceAreas() {
	  return {
	    restrict: 'AE',
	    scope: {
	      buttonId: '@',
	      pracsModel: '=?',
	      nrefPractices: '=',
	      onPracChange: '&',
	      selectOnReset: '=?'
	    },
	    replace: true,
	    template: selectPracticesTemplate,
	    controller: selectPracticesController
	  };
	};
	
	angular.module('app.directives').directive('selectPraciceAreas', selectPraciceAreas);

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _loadingOverlay = __webpack_require__(20);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// eslint-disable-next-line angular/controller-name
	angular.module('app.ui.form.ctrls').controller('EditCandidateCtrl', ['$uibModalInstance', 'data', 'logger', '$rootScope', 'CandidateProfileApi', 'candidateId', function controller($uibModalInstance, data, logger, $rootScope, CandidateProfileApi, candidateId) {
	  var _this = this;
	
	  var vm = this;
	  var broadcastUpdate = function broadcastUpdate() {
	    console.debug('EditCandidateCtrl: broadcasting candidate:update');
	    $rootScope.$broadcast('candidate:updated');
	  };
	
	  vm.updatedData = {};
	
	  vm.sliderOptions = {
	    selectivity: {
	      round: 1,
	      from: 1,
	      to: 6,
	      step: 1,
	      dimension: '$',
	      scale: ['$', '$$', '$$$', '$$$$', '$$$$$', '$$$$$$']
	    }
	  };
	
	  console.debug('EditCandidateCtrl data', data);
	
	  if (data.candidate.minSelectivity === null) {
	    data.candidate.minSelectivity = 0;
	  }
	
	  if (data.candidate.maxSelectivity === null || data.candidate.maxSelectivity === 0) {
	    data.candidate.maxSelectivity = 6;
	  }
	
	  vm.sliderFilter = {
	    selectivity: data.candidate.minSelectivity + ';' + data.candidate.maxSelectivity,
	    defaultSelectivity: data.candidate.minSelectivity + ';' + data.candidate.maxSelectivity
	  };
	
	  $rootScope.$on('candidate-deleted', function (_event, _ref) {
	    var candidateDeleted = _ref.candidateDeleted;
	
	    if (data.candidate.id === candidateDeleted && !$rootScope.isCandidateDeleted) {
	      logger.notify('error', 'Candidate is Deleted by Other Admin');
	      vm.cancel();
	    }
	  });
	  vm.notify = function (type, message) {
	    switch (type) {
	      case 'info':
	        logger.log(message);
	        break;
	      case 'success':
	        logger.logSuccess(message);
	        break;
	      case 'warning':
	        logger.logWarning(message);
	        break;
	      case 'error':
	        logger.logError(message);
	        break;
	      default:
	        break;
	    }
	  };
	
	  // Vm.updatedData.UncategorizedSelectivity = Boolean(
	  //   data.candidate.minSelectivity === 0 &&
	  //     (data.candidate.maxSelectivity === 0 ||
	  //       data.candidate.maxSelectivity === 6)
	  // )
	
	  vm.updateSelectivity = function () {
	    // If (vm.updatedData.UncategorizedSelectivity)
	    //   vm.sliderFilter.selectivity = `0;0`
	    // else
	    vm.sliderFilter.selectivity = data.candidate.minSelectivity + ';' + data.candidate.maxSelectivity;
	  };
	
	  vm.preferencesWizardSetting = data.candidateSettings.find(function (setting) {
	    return setting.name === 'hide_preferences_wizard';
	  });
	
	  if (vm.preferencesWizardSetting === undefined) {
	    vm.newSetting = true;
	    vm.preferencesWizardSetting = {
	      userSettings: [{ id: 1, hasValue: false, enable: false }]
	    };
	  }
	
	  vm.noEmail = false;
	  vm.updatedData.preferencesWizardSetting = angular.copy(vm.preferencesWizardSetting);
	  vm.selectedCandidate = data.candidate;
	  if (data.candidate.approvalAcceptDate) {
	    vm.updatedData.approvedCandidateWelcome = true;
	    vm.updatedData.approvedCandidateConfirmation = false;
	    vm.updatedData.approvedCandidate12HourReminder = false;
	  } else {
	    vm.updatedData.approvedCandidateWelcome = true;
	    vm.updatedData.approvedCandidateConfirmation = false;
	    vm.updatedData.approvedCandidate12HourReminder = true;
	  }
	
	  if (data.candidate.approvalStatus === 'Approved') {
	    vm.noEmail = true;
	    vm.updatedData.approvedCandidateWelcome = false;
	    vm.updatedData.approvedCandidateConfirmation = false;
	    vm.updatedData.approvedCandidate12HourReminder = false;
	  }
	
	  vm.consultants = data.assignableAgents;
	  vm.blockEmployers = data.employersList;
	  vm.updatedData.candidate = angular.copy(data.candidate);
	  vm.updatedData.candidate.LexStepRequired = vm.selectedCandidate.LexStepRequired;
	
	  vm.changeLawyerStatus = function (status) {
	    if (status === 'lock') {
	      vm.updatedData.candidate.approvalStatus = 'Locked';
	    } else {
	      vm.updatedData.candidate.approvalStatus = 'Approved';
	    }
	  };
	
	  vm.showHideWelcomeWizard = function (lawyerPreferencesFlag) {
	    vm.lawyerPreferencesFlag = lawyerPreferencesFlag;
	  };
	
	  vm.getBlockUnBlockEmployers = function () {
	    var updatedBlockedEmployer = vm.blockEmployers.filter(function (employer) {
	      return Boolean(employer) && employer.isSelected === true;
	    });
	
	    updatedBlockedEmployer.forEach(function (employer) {
	      employer.alreadyBlocked = Boolean(data.blockedEmployers.find(function (blockedEmployer) {
	        return Boolean(blockedEmployer) && blockedEmployer.employerId === employer.id;
	      }));
	    });
	
	    var unblockedEmployers = data.blockedEmployers.map(function (blockedEmployer) {
	      var blocked = vm.blockEmployers.find(function (employer) {
	        return Boolean(blockedEmployer) && blockedEmployer.employerId === employer.id;
	      });
	      blockedEmployer.block = blocked ? blocked.isSelected : undefined;
	      return blockedEmployer;
	    }).filter(function (employer) {
	      return employer.block === false;
	    });
	    return {
	      unblockedEmployers: unblockedEmployers,
	      updatedBlockedEmployers: updatedBlockedEmployer.filter(function (employer) {
	        return employer.alreadyBlocked === false;
	      })
	    };
	  };
	
	  var doSave = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var employersData, modalData;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              console.debug('EditCandidateCtrl::doSave:updatedData', vm.updatedData);
	              employersData = vm.getBlockUnBlockEmployers();
	              modalData = {};
	
	              if (vm.updatedData.candidate.approvalStatus !== data.candidate.approvalStatus) {
	                modalData.updatedApprovalStatus = vm.updatedData.candidate.approvalStatus;
	                modalData.approvedCandidateWelcome = vm.updatedData.approvedCandidateWelcome;
	                modalData.approvedCandidateConfirmation = vm.updatedData.approvedCandidateConfirmation;
	                modalData.approvedCandidate12HourReminder = vm.updatedData.approvedCandidate12HourReminder;
	              }
	
	              if (vm.updatedData.candidate.lawProfile.qualificationDate !== data.candidate.lawProfile.qualificationDate) {
	                modalData.updatedQualificationDate = vm.updatedData.candidate.lawProfile.qualificationDate;
	              }
	
	              if (data.candidate.agent === null && vm.updatedData.candidate.agent && vm.updatedData.candidate.agent.id !== 0 || data.candidate.agent && vm.updatedData.candidate.agent && vm.updatedData.candidate.agent.id !== data.candidate.agent.id) {
	                modalData.updatedAgent = vm.updatedData.candidate.agent.id;
	              }
	
	              if (vm.sliderFilter.selectivity !== vm.sliderFilter.defaultSelectivity) modalData.updatedSelectivityRange = vm.sliderFilter.selectivity;
	
	              if (vm.newSetting || vm.updatedData.preferencesWizardSetting.userSettings[0].enable !== vm.preferencesWizardSetting.userSettings[0].enable) {
	                CandidateProfileApi.updateUserSettings(candidateId, 1, vm.updatedData.preferencesWizardSetting.userSettings[0].enable);
	              }
	
	              if (employersData.unblockedEmployers.length > 0) vm.updateCandidateUnblockedEmployers(candidateId, employersData.unblockedEmployers);
	
	              if (employersData.updatedBlockedEmployers.length > 0) vm.updateCandidateBlockedEmployers(candidateId, employersData.updatedBlockedEmployers);
	
	              _context.next = 12;
	              return vm.updateCandidateProfile(modalData, candidateId);
	
	            case 12:
	              $rootScope.$broadcast('candidate:edited');
	              console.debug('EditCandidateCtrl::doSave:modalData', modalData);
	              $uibModalInstance.close(modalData);
	
	            case 15:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function doSave() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  vm.save = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	    return regeneratorRuntime.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', (0, _loadingOverlay.wrap)(doSave));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, _this);
	  }));
	
	  vm.updateCandidateProfile = function () {
	    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data, candidateId) {
	      var updateProfileDto, selectivityArray, _ref5, updatedCandidate, payload;
	
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;
	
	              console.debug('updateCandidateProfile', data, candidateId);
	              updateProfileDto = {};
	
	              if (data.updatedSelectivityRange) {
	                selectivityArray = data.updatedSelectivityRange.split(';');
	
	                updateProfileDto.minSelectivity = Number(selectivityArray[0]);
	                updateProfileDto.maxSelectivity = Number(selectivityArray[1]);
	              }
	
	              if (data.updatedQualificationDate) updateProfileDto.lawProfile = {
	                qualificationDate: data.updatedQualificationDate
	              };
	
	              if (data.updatedAgent !== undefined) updateProfileDto.agentId =
	              // eslint-disable-next-line unicorn/no-null
	              data.updatedAgent === 0 ? null : data.updatedAgent;
	
	              if (!(Object.keys(updateProfileDto).length > 0)) {
	                _context3.next = 12;
	                break;
	              }
	
	              _context3.next = 9;
	              return CandidateProfileApi.updateProfileData(candidateId, updateProfileDto);
	
	            case 9:
	              _ref5 = _context3.sent;
	              updatedCandidate = _ref5.data;
	
	              data.updatedCandidateProfile = updatedCandidate;
	
	            case 12:
	              if (!data.updatedApprovalStatus) {
	                _context3.next = 18;
	                break;
	              }
	
	              console.debug('EditCandidateCtrl: approval status has been updated');
	              payload = {
	                approvalStatus: data.updatedApprovalStatus,
	                approvedCandidateWelcome: data.approvedCandidateWelcome,
	                approvedCandidateConfirmation: data.approvedCandidateConfirmation,
	                approvedCandidate12HourReminder: data.approvedCandidate12HourReminder
	              };
	              _context3.next = 17;
	              return CandidateProfileApi.updateCandidateApprovalStatus(candidateId, payload);
	
	            case 17:
	              console.debug('CandidateProfileApi.updateCandidateApprovalStatus OK');
	
	            case 18:
	              _context3.next = 23;
	              break;
	
	            case 20:
	              _context3.prev = 20;
	              _context3.t0 = _context3['catch'](0);
	
	              console.error(_context3.t0);
	
	            case 23:
	
	              broadcastUpdate();
	
	            case 24:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this, [[0, 20]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	
	  vm.updateCandidateUnblockedEmployers = function () {
	    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(candidateId, unblockedEmployers) {
	      var unBlockPayload;
	      return regeneratorRuntime.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              unBlockPayload = {
	                employerIds: unblockedEmployers.map(function (employer) {
	                  return employer.employerId;
	                }),
	                updateValue: false
	              };
	
	              if (!(unBlockPayload.employerIds.length > 0)) {
	                _context4.next = 4;
	                break;
	              }
	
	              _context4.next = 4;
	              return CandidateProfileApi.updateUserBlockedEmployers(candidateId, unBlockPayload);
	
	            case 4:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this);
	    }));
	
	    return function (_x3, _x4) {
	      return _ref6.apply(this, arguments);
	    };
	  }();
	
	  vm.updateCandidateBlockedEmployers = function () {
	    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(candidateId, blockedEmployers) {
	      var blockPayload;
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              blockPayload = {
	                employerIds: blockedEmployers.map(function (employer) {
	                  return employer.id;
	                }),
	                updateValue: true
	              };
	
	              if (!(blockPayload.employerIds.length > 0)) {
	                _context5.next = 4;
	                break;
	              }
	
	              _context5.next = 4;
	              return CandidateProfileApi.updateUserBlockedEmployers(candidateId, blockPayload);
	
	            case 4:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, _this);
	    }));
	
	    return function (_x5, _x6) {
	      return _ref7.apply(this, arguments);
	    };
	  }();
	
	  vm.cancel = function () {
	    $uibModalInstance.dismiss('cancel');
	    broadcastUpdate();
	  };
	}]);

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('employerTypeAheadFilter', function filter() {
	  return function employerTypeAhead(employers, query) {
	    employers = employers || [];
	
	    var employerName = '';
	    var employerNameWithoutApostrophe = '';
	    var queryWithoutApostrophe = query.replaceAll('’', '').toLowerCase();
	
	    return employers.filter(function (employer) {
	      employerName = employer.name;
	      employerNameWithoutApostrophe = employerName ? employerName.replaceAll('’', "'").toLowerCase() : '';
	
	      return employerNameWithoutApostrophe.contains(queryWithoutApostrophe);
	    });
	  };
	});

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('firmsTypeAheadFilter', function () {
	    return function (allFirms, query) {
	        allFirms = allFirms || [];
	
	        var firmName = '',
	            firmNameWithoutApostrophe = '',
	            queryWithoutApostrophe = query.replaceAll("’", '').toLowerCase();
	
	        return _.filter(allFirms, function (firm) {
	            firmName = firm.user.firm_Name;
	            firmNameWithoutApostrophe = firmName ? firmName.replaceAll("’", "'").toLowerCase() : "";
	
	            return firmNameWithoutApostrophe.contains(queryWithoutApostrophe);
	        });
	    };
	});

/***/ }),
/* 719 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('filterFirms', ["$log", "$filter", function ($log, $filter) {
	  return function (filterCategory, filterVisibility, firmsList) {
	    var filteredFirms;
	    filteredFirms = angular.copy(firmsList);
	    $log.info(filterCategory);
	    if (filterCategory !== "" && filterCategory !== "All") {
	      filteredFirms = $filter('filter')(filteredFirms, {
	        ref_category: {
	          cat_ID: filterCategory
	        }
	      });
	    }
	    if (filterVisibility !== "" && filterVisibility !== "All") {
	      filteredFirms = $filter('filter')(filteredFirms, {
	        firm_Visibility: filterVisibility
	      }, true);
	    }
	    return filteredFirms;
	  };
	}]);

/***/ }),
/* 720 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('greaterThanFilter', ["$log", "$filter", function ($log, $filter) {
	  return function (list, filterProperty, filterValue) {
	    var filterList, filteredList;
	    filterList = angular.copy(list);
	    filteredList = [];
	    filterList.forEach(function (item, index, array) {
	      if (item[filterProperty] > filterValue) {
	        filteredList.push(item);
	      }
	    });
	    return filteredList;
	  };
	}]);

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('filterInhouseJobsByPQE', ['$log', function ($log) {
	  return function (jobsList, selectedPQE) {
	    var count, filteredFirms, maxPQE, minPQE, seperator;
	    filteredFirms = [];
	    seperator = selectedPQE.search(";");
	    minPQE = selectedPQE.slice(0, seperator);
	    maxPQE = selectedPQE.slice(seperator + 1, selectedPQE.length);
	    var selected_jobs = [],
	        uniqueJobs = [];
	    jobsList.forEach(function (job, index, array) {
	      if ((minPQE <= 0 || minPQE === -2 || minPQE === -1) && job.job_exp === "NQ") {
	        return selected_jobs.push(job);
	      } else if (job.job_exp === "NQ+") {
	        return selected_jobs.push(job);
	      } else if (job.start_exp >= minPQE && job.end_exp <= maxPQE) {
	        return selected_jobs.push(job);
	      } else if (job.start_exp >= minPQE && job.start_exp <= maxPQE) {
	        return selected_jobs.push(job);
	      } else if (job.end_exp >= minPQE && job.end_exp < maxPQE) {
	        return selected_jobs.push(job);
	      } else if (job.start_exp <= minPQE && job.end_exp >= maxPQE || job.start_exp === "NQ" && job.end_exp >= maxPQE) {
	        return selected_jobs.push(job);
	      }
	    });
	    uniqueJobs = _.uniq(selected_jobs, 'job_ID');
	    jobsList = angular.copy(uniqueJobs);
	    return jobsList;
	  };
	}]);

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('filterInhouseLocations', ['$log', 'sharedProperties', function ($log, sharedProperties) {
	  return function (jobsList, selectedLocation) {
	    var count, selected_jobs;
	    selected_jobs = [];
	    count = 0;
	    jobsList.forEach(function (job, index, array) {
	      if (job.ref_locations) {
	        job.ref_locations.forEach(function (rloc, index, array) {
	          if (sharedProperties.isNotNullOrEmpty(_.find(selectedLocation, function (loc) {
	            return loc.loc_name === rloc.loc_name;
	          }))) {
	            selected_jobs.push(job);
	          }
	        });
	      }
	      jobsList = _.uniq(selected_jobs, 'job_ID');
	    });
	    return jobsList;
	  };
	}]);

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('filterInhouseOpportunities', ["$log", "$filter", 'sharedProperties', function ($log, $filter, sharedProperties) {
	  return function (filterPractice, filterLocation, filterPQE, jobsList) {
	    var filteredFirms;
	    filteredFirms = angular.copy(jobsList);
	    if (sharedProperties.isNotNullOrEmpty(filterLocation) && filterLocation !== "All") {
	      filteredFirms = $filter('filterInhouseLocations')(filteredFirms, filterLocation);
	    }
	    if (sharedProperties.isNotNullOrEmpty(filterPractice)) {
	      filteredFirms = $filter('selectedInhouseTags')(filteredFirms, filterPractice);
	    }
	    if (!_.isEmpty(filterPQE) && filterPQE !== "All") {
	      filteredFirms = $filter('filterInhouseJobsByPQE')(filteredFirms, filterPQE);
	    }
	    return filteredFirms;
	  };
	}]);

/***/ }),
/* 724 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('filterJobsByPQE', ['$log', function ($log) {
	  return function (firmList, selectedPQE) {
	    var count, filteredFirms, maxPQE, minPQE, seperator;
	    filteredFirms = [];
	    seperator = selectedPQE.search(";");
	    minPQE = selectedPQE.slice(0, seperator);
	    maxPQE = selectedPQE.slice(seperator + 1, selectedPQE.length);
	    $log.info("selectedPQE", selectedPQE, "minPQE", minPQE, "maxPQE", maxPQE);
	    firmList.forEach(function (firm, index, array) {
	      firm.selected_jobs = [];
	      firm.uniqueJobs = [];
	      firm.available_jobs.forEach(function (job, j_index, array) {
	        if ((minPQE <= 0 || minPQE === -2 || minPQE === -1) && job.job_exp === "NQ") {
	          firm.selected_jobs.push(job);
	        } else if (minPQE >= 7 && job.end_exp === 11) {
	          firm.selected_jobs.push(job);
	        } else if (job.job_exp === "NQ+") {
	          firm.selected_jobs.push(job);
	        } else if (job.start_exp >= minPQE && job.end_exp <= maxPQE) {
	          firm.selected_jobs.push(job);
	        } else if (job.start_exp >= minPQE && job.start_exp <= maxPQE && job.end_exp != 11 || job.start_exp >= minPQE && job.start_exp <= maxPQE && job.end_exp == 11) {
	          firm.selected_jobs.push(job);
	        } else if (job.end_exp >= minPQE && job.end_exp < maxPQE) {
	          firm.selected_jobs.push(job);
	        } else if (job.start_exp <= minPQE && job.end_exp >= maxPQE || job.start_exp === "NQ" && job.end_exp >= maxPQE) {
	          firm.selected_jobs.push(job);
	        }
	      });
	      firm.uniqueJobs = _.uniq(firm.selected_jobs, 'job_ID');
	      firm.available_jobs = angular.copy(firm.uniqueJobs);
	    });
	    return firmList;
	  };
	}]);

/***/ }),
/* 725 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('jobsInTargetLocations', ['$log', 'sharedProperties', function ($log, sharedProperties) {
	  return function (firmList, targetLocation) {
	    firmList.forEach(function (firm, index, array) {
	      firm.selected_jobs = [];
	      firm.available_jobs.forEach(function (job, j_index, array) {
	        if (job.ref_locations) {
	          return job.ref_locations.forEach(function (rloc, index, array) {
	            if (sharedProperties.isNotNullOrEmpty(_.find(targetLocation, function (loc) {
	              return loc.loc_name === rloc.loc_name;
	            }))) {
	              firm.selected_jobs.push(job);
	            }
	          });
	        }
	      });
	      firm.available_jobs = angular.copy(firm.selected_jobs);
	    });
	    return firmList;
	  };
	}]);

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('filterLawyers', ["$log", "$filter", function ($log, $filter) {
	  return function (filterStatus, filterPQE, filterPractice, lawyersList) {
	    var filteredLawyers;
	    filteredLawyers = angular.copy(lawyersList);
	    if (filterStatus !== "" && filterStatus !== "All") {
	      filteredLawyers = $filter('filter')(filteredLawyers, {
	        'lawyer_Status': filterStatus
	      });
	    }
	    if (filterPQE !== "" && filterPQE !== "All") {
	      if (filterPQE !== "< 0" && filterPQE !== "> 10") {
	        filteredLawyers = $filter('filter')(filteredLawyers, {
	          'PQE': parseInt(filterPQE)
	        }, true);
	      } else if (filterPQE === "< 0") {
	        filteredLawyers = $filter('lessThanFilter')(filteredLawyers, "PQE", 0);
	      } else if (filterPQE === "> 10") {
	        filteredLawyers = $filter('greaterThanFilter')(filteredLawyers, "PQE", 10);
	      }
	    }
	    if (!_.isEmpty(filterPractice) && filterPractice.practice_ID !== 0) {
	      filteredLawyers = $filter('selectedTagsLawyers')(filteredLawyers, filterPractice.practice_ID);
	    }
	    return filteredLawyers;
	  };
	}]);

/***/ }),
/* 727 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('lessThanFilter', ["$log", "$filter", function ($log, $filter) {
	  return function (list, filterProperty, filterValue) {
	    var filterList, filteredList;
	    filteredList = [];
	    filterList = angular.copy(list);
	    filterList.forEach(function (item, index, array) {
	      if (item[filterProperty] < filterValue) {
	        filteredList.push(item);
	      }
	    });
	    return filteredList;
	  };
	}]);

/***/ }),
/* 728 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('limitWord', function () {
	  return function (text, limit, moreChar) {
	    limit = parseInt(limit) || 8;
	    return limitWord(text, limit, moreChar);
	  };
	});
	
	function limitWord(text, limit, moreChar) {
	  var i = 0;
	  var escapedTrimmedText = text.replace(/[\n,'↵']/g, ' ').trim(),
	      limitedText = escapedTrimmedText.split(' ');
	
	  if (limitedText.length < limit) {
	    return text;
	  } else {
	    limitedText = escapedTrimmedText.split(' ', limit);
	    text = limitedText.join(' ');
	    return text;
	  }
	}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('filterLocations', ['$log', 'sharedProperties', function ($log, sharedProperties) {
	  return function (firmList, selectedLocation) {
	    var count, filteredFirms;
	    filteredFirms = [];
	    count = 0;
	    firmList.forEach(function (firm, index, array) {
	      firm.selected_jobs = [];
	      firm.available_jobs.forEach(function (job, j_sindex, array) {
	        if (job.ref_locations) {
	          return job.ref_locations.forEach(function (rloc, index, array) {
	            if (sharedProperties.isNotNullOrEmpty(_.find(selectedLocation, function (loc) {
	              return loc.loc_name === rloc.loc_name;
	            }))) {
	              if (!(firm.selected_jobs.indexOf(job) > -1)) {
	                firm.selected_jobs.push(job);
	              }
	            }
	          });
	        }
	      });
	      firm.available_jobs = angular.copy(firm.selected_jobs);
	    });
	    return firmList;
	  };
	}]);

/***/ }),
/* 730 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters', []);

/***/ }),
/* 731 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('selectedInhouseTags', ['$log', 'sharedProperties', function ($log, sharedProperties) {
	  return function (jobsList, selectedPractice) {
	    var count, selected_jobs;
	    selected_jobs = [];
	    count = 0;
	    jobsList.forEach(function (job, index, array) {
	      job.ref_practices.forEach(function (pa, index, array) {
	        if (sharedProperties.isNotNullOrEmpty(_.find(selectedPractice, function (prac) {
	          return prac.practice_ID === pa.refPracticePracticeID;
	        })) && pa.isSelected) {
	          job.dontExist = false;
	          if (!(selected_jobs.indexOf(job) > -1)) {
	            selected_jobs.push(job);
	          }
	        }
	      });
	      jobsList = angular.copy(selected_jobs);
	    });
	    return jobsList;
	  };
	}]);

/***/ }),
/* 732 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('filterSelectedPractices', ['$log', function ($log) {
	  return function (selectedPractice, firmList) {
	    var count, filteredFirms;
	    filteredFirms = [];
	    count = 0;
	    firmList.forEach(function (firm, index, array) {
	      firm.selected_jobs = [];
	      firm.available_jobs.forEach(function (job, j_index, array) {
	        count = 0;
	        selectedPractice.forEach(function (sp, sp_index, array) {
	          job.ref_practices.forEach(function (pa, index, array) {
	            if (sp.practice_ID === pa.practice_ID && pa.job_practice_areas.isSelected && sp.lawyer_practices.isApproved && !sp.hasChild) {
	              count++;
	            }
	          });
	        });
	        if (count > 0) {
	          firm.selected_jobs.push(job);
	        }
	      });
	      firm.available_jobs = angular.copy(firm.selected_jobs);
	    });
	    return firmList;
	  };
	}]);

/***/ }),
/* 733 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('selectedTagsLawyers', ['$log', function ($log) {
	  return function (lawyersList, selectedPractice) {
	    var filteredLawyers;
	    filteredLawyers = [];
	    lawyersList.forEach(function (lawyer, index, array) {
	      if (lawyer.ref_practices) {
	        lawyer.ref_practices.forEach(function (pa, p_index, array) {
	          if (pa.practice_ID === selectedPractice && pa.lawyer_practices.isSelected) {
	            filteredLawyers.push(lawyer);
	          }
	        });
	      }
	    });
	    return filteredLawyers;
	  };
	}]);

/***/ }),
/* 734 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('selectedTags', ['$log', 'sharedProperties', function ($log, sharedProperties) {
	  return function (firmList, selectedPractice) {
	    var count, filteredFirms;
	    filteredFirms = [];
	    count = 0;
	    firmList.forEach(function (firm, index, array) {
	      firm.selected_jobs = [];
	      firm.available_jobs.forEach(function (job, j_index, array) {
	        return job.ref_practices.forEach(function (pa, index, array) {
	          if (sharedProperties.isNotNullOrEmpty(_.find(selectedPractice, function (prac) {
	            return prac.practice_ID === pa.refPracticePracticeID;
	          })) && pa.isSelected) {
	            job.dontExist = false;
	            if (!(firm.selected_jobs.indexOf(job) > -1)) {
	              firm.selected_jobs.push(job);
	            }
	          }
	        });
	      });
	      firm.available_jobs = angular.copy(firm.selected_jobs);
	    });
	    return firmList;
	  };
	}]);

/***/ }),
/* 735 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.filters').filter('trustAsResourceUrl', ['$sce', function ($sce) {
	  return function (val) {
	    return $sce.trustAsResourceUrl(val);
	  };
	}]);

/***/ }),
/* 736 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getFlagEmoji = exports.getFlagEmoji = function getFlagEmoji(countryCode) {
	  if (!countryCode) return '';
	
	  return String.fromCodePoint.apply(String, _toConsumableArray([].concat(_toConsumableArray(countryCode.toUpperCase())).map(function (x) {
	    return 0x1f1a5 + x.charCodeAt();
	  })));
	};

/***/ }),
/* 737 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.grid', []);

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	  angular.module('app.ui.form.ctrls').controller('jobPracticesModalCtrl', ['$scope', '$log', '$modalInstance', 'practicesService', 'data', function ($scope, $log, $modalInstance, practicesService, data) {
	    $scope.data = [];
	    $scope.data = data;
	    $scope.CheckBox = '';
	    $scope.updatedData = {
	      data: [],
	      linearPractices: []
	    };
	    $log.info("data", data);
	    $scope.updatedData.data = $scope.data;
	    $scope.displaySubPracticeAreas = function (law_area) {
	      return law_area.showSubPracticeAreas = true;
	    };
	    $scope.hideSubPracticeAreas = function (law_area) {
	      return law_area.showSubPracticeAreas = false;
	    };
	    $scope.updateData = function (event, cur_box) {
	      var value;
	      value = event.target.checked;
	      $scope.updatedData.forEach(function (chkbox, index, array) {
	        if (chkbox.practice_ID === cur_box.practice_ID) {
	          chkbox.isSelected = value;
	        }
	      });
	    };
	
	    $scope.selectPractices = function (event, current, level) {
	      var pCounter, sCounter, value;
	      pCounter = 0;
	      sCounter = 0;
	      value = event.target.checked;
	      if (level === 2) {
	        // $log.info('level 2');
	        $log.info(current);
	        $scope.updatedData.data.forEach(function (law_area, index, array) {
	          if (law_area.practice_ID === current.practice_ID) {
	            law_area.isSelected = value;
	            law_area.practices.forEach(function (practice, index, array) {
	              practice.isSelected = value;
	              practice.sub_areas.forEach(function (sub, index, array) {
	                if (sub.isSelected !== value) {
	                  sub.isSelected = value;
	                }
	              });
	            });
	
	            practicesService.checkForLinking($scope.updatedData.data, current.practice_ID, value);
	          }
	        });
	        return;
	      } else if (level === 1) {
	        $scope.updatedData.data.forEach(function (law_area, index, array) {
	          return law_area.practices.forEach(function (practice, index, array) {
	            if (practice.practice_ID === current.practice_ID) {
	              $log.info(current.practice_ID);
	              practice.isSelected = value;
	              law_area.practices.forEach(function (p, i, a) {
	                if (p.isSelected) {
	                  pCounter++;
	                }
	              });
	              $log.info('pCounter : ' + pCounter);
	              if (value) {
	                if (pCounter > 0) {
	                  law_area.isSelected = value;
	                }
	              } else {
	                if (pCounter <= 0) {
	                  law_area.isSelected = value;
	                }
	              }
	              practice.sub_areas.forEach(function (sub, index, array) {
	                if (sub.isSelected !== value) {
	                  sub.isSelected = value;
	                }
	              });
	
	              practicesService.checkForLinking($scope.updatedData.data, current.practice_ID, value);
	            }
	          });
	        });
	        return;
	      } else if (level === 0) {
	        $scope.updatedData.data.forEach(function (law_area, index, array) {
	          law_area.practices.forEach(function (practice, index, array) {
	            if (practice.sub_areas.length > 0) {
	              practice.sub_areas.forEach(function (sub, index, array) {
	                if (sub.practice_ID === current.practice_ID) {
	                  sub.isSelected = value;
	                  practice.sub_areas.forEach(function (s, i, a) {
	                    if (s.isSelected) {
	                      sCounter++;
	                    }
	                  });
	                  $log.info('pCounter : ' + pCounter);
	                  if (value) {
	                    if (sCounter > 0) {
	                      law_area.isSelected = value;
	                      practice.isSelected = value;
	                    }
	                  } else {
	                    if (sCounter <= 0) {
	                      practice.isSelected = value;
	                      law_area.practices.forEach(function (p, i, a) {
	                        if (p.isSelected) {
	                          pCounter++;
	                        }
	                      });
	                      $log.info('pCounter : ' + pCounter);
	                      if (value) {
	                        if (pCounter > 0) {
	                          law_area.isSelected = value;
	                        }
	                      } else {
	                        if (pCounter <= 0) {
	                          law_area.isSelected = value;
	                        }
	                      }
	                    }
	                  }
	                  practicesService.checkForLinking($scope.updatedData.data, current.practice_ID, value);
	                }
	              });
	            }
	          });
	        });
	      }
	    };
	    $scope.save = function () {
	      $scope.updatedData.linearPractices = [];
	      $scope.updatedData.data.forEach(function (law_area, index, array) {
	        $scope.updatedData.linearPractices.push(law_area);
	        law_area.practices.forEach(function (practice, index, array) {
	          $scope.updatedData.linearPractices.push(practice);
	          practice.sub_areas.forEach(function (sub, index, array) {
	            return $scope.updatedData.linearPractices.push(sub);
	          });
	        });
	      });
	      $modalInstance.close($scope.updatedData);
	    };
	    $scope.cancel = function () {
	      $modalInstance.dismiss("cancel");
	    };
	  }]);
	})();

/***/ }),
/* 739 */
/***/ (function(module, exports) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  'use strict';
	
	  angular.module('app.localization', []).factory('localize', ['$http', '$rootScope', '$window', function ($http, $rootScope, $window) {
	    var localize;
	    localize = {
	      language: '',
	      url: void 0,
	      resourceFileLoaded: false,
	      successCallback: function successCallback(data) {
	        localize.dictionary = data;
	        localize.resourceFileLoaded = true;
	        return $rootScope.$broadcast('localizeResourcesUpdated');
	      },
	      setLanguage: function setLanguage(value) {
	        localize.language = value.toLowerCase().split("-")[0];
	        return localize.initLocalizedResources();
	      },
	      setUrl: function setUrl(value) {
	        localize.url = value;
	        return localize.initLocalizedResources();
	      },
	      buildUrl: function buildUrl() {
	        if (!localize.language) {
	          localize.language = ($window.navigator.userLanguage || $window.navigator.language).toLowerCase();
	          localize.language = localize.language.split("-")[0];
	        }
	        return 'i18n/resources-locale_' + localize.language + '.js';
	      },
	      initLocalizedResources: function initLocalizedResources() {
	        var url;
	        url = localize.url || localize.buildUrl();
	        return $http({
	          method: "GET",
	          url: url,
	          cache: false
	        }).then(localize.successCallback, function (error) {
	          return $rootScope.$broadcast('localizeResourcesUpdated');
	        });
	      },
	      getLocalizedString: function getLocalizedString(value) {
	        var result, valueLowerCase;
	        result = void 0;
	        if (localize.dictionary && value) {
	          valueLowerCase = value.toLowerCase();
	          if (localize.dictionary[valueLowerCase] === '') {
	            result = value;
	          } else {
	            result = localize.dictionary[valueLowerCase];
	          }
	        } else {
	          result = value;
	        }
	        return result;
	      }
	    };
	    return localize;
	  }]).directive('i18n', ['localize', function (localize) {
	    var i18nDirective;
	    i18nDirective = {
	      restrict: "EA",
	      updateText: function updateText(ele, input, placeholder) {
	        var result;
	        result = void 0;
	        if (input === 'i18n-placeholder') {
	          result = localize.getLocalizedString(placeholder);
	          return ele.attr('placeholder', result);
	        } else if (input.length >= 1) {
	          result = localize.getLocalizedString(input);
	          return ele.text(result);
	        }
	      },
	      link: function link(scope, ele, attrs) {
	        scope.$on('localizeResourcesUpdated', function () {
	          return i18nDirective.updateText(ele, attrs.i18n, attrs.placeholder);
	        });
	        return attrs.$observe('i18n', function (value) {
	          return i18nDirective.updateText(ele, value, attrs.placeholder);
	        });
	      }
	    };
	    return i18nDirective;
	  }]);
	
	  /*.controller('LangCtrl', [
	      '$scope', 'localize'
	      ($scope, localize) ->
	          $scope.lang = 'English'
	  
	          $scope.setLang = (lang) ->
	              switch lang
	                  when 'English' then localize.setLanguage('EN-US')
	                  when 'Español' then localize.setLanguage('ES-ES')
	                  when '日本語' then localize.setLanguage('JA-JP')
	                  when '中文' then localize.setLanguage('ZH-TW')
	                  when 'Deutsch' then localize.setLanguage('DE-DE')
	                  when 'français' then localize.setLanguage('FR-FR')
	                  when 'Italiano' then localize.setLanguage('IT-IT')
	                  when 'Portugal' then localize.setLanguage('PT-BR')
	                  when 'Русский язык' then localize.setLanguage('RU-RU')
	                  when '한국어' then localize.setLanguage('KO-KR')
	  
	              $scope.lang = lang
	          
	          $scope.getFlag = () ->
	              lang = $scope.lang
	              switch lang
	                  when 'English' then return 'flags-american'
	                  when 'Español' then return 'flags-spain'
	                  when '日本語' then return 'flags-japan'
	                  when '中文' then return 'flags-china'
	                  when 'Deutsch' then return 'flags-germany'
	                  when 'français' then return 'flags-france'
	                  when 'Italiano' then return 'flags-italy'
	                  when 'Portugal' then return 'flags-portugal'
	                  when 'Русский язык' then return 'flags-russia'
	                  when '한국어' then return 'flags-korea'
	  ])
	   */
	}).call(undefined);

/***/ }),
/* 740 */
/***/ (function(module, exports) {

	"use strict";
	
	!function (e, n, o) {
	  "use strict";
	  n.module("ui.nested.combobox", []).constant("nestedComboBoxConfig", { options: { childrenParam: "children" } }).controller("NestedComboBoxController", ["$scope", "$element", "$attrs", "nestedComboBoxConfig", "$timeout", function (e, o, l, t, i) {
	    var r = this;this.isOpen = !1, this.options = n.isDefined(e.options) ? e.options : t.options, this.toggleOpen = function () {
	      return e.controlDisabled ? (this.isOpen = !1, !1) : void (this.isOpen = !this.isOpen);
	    }, this.toggleBlur = function () {
	      i(function () {
	        r.isOpen = !1;
	      }, 200);
	    }, this.toggleFocus = function () {
	      return e.controlDisabled ? (this.isOpen = !1, !1) : void (r.isOpen = !1);
	    }, e.findNode = function (o, l) {
	      var t, i, c;if (o === l.id) return l;if (n.isArray(l[r.options.childrenParam])) for (t = 0; t < l[r.options.childrenParam].length; t += 1) {
	        if (i = l[r.options.childrenParam][t], c = e.findNode(o, i), c !== !1) return c;
	      }return !1;
	    };
	  }]).directive("nestedComboBox", ["$templateCache", function (e) {
	    var o = function o(e, _o, l, t) {
	      function i(o) {
	        var l = null;if (e.collection) {
	          var t = n.isObject(o) ? o.id : o;n.isArray(e.collection) || (e.collection = [e.collection]);for (var i = 0; i < e.collection.length; i += 1) {
	            var r = e.findNode(t, e.collection[i]);r && (l = r);
	          }e.selectValue(null, l);
	        }
	      }e.ngModelController = t, t && (e.selectValue = function (o, l) {
	        n.isFunction(e.changeEvent) && e.changeEvent(l), e.ngModelController.$setViewValue(l), e.ngModelController.$render();
	      }, e.$watch("model", function (e) {
	        i(e);
	      }), e.$watchCollection("collection", function () {
	        e.ngModelController.$modelValue && i(e.ngModelController.$modelValue), n.isFunction(e.changeEvent) && e.changeEvent();
	      }));
	    };return { restrict: "E", controller: "NestedComboBoxController", controllerAs: "gs", link: o, require: "ngModel", replace: !0, template: e.get("select-group.html"), scope: { collection: "=?", controlClass: "@?", controlDisabled: "=?", changeEvent: "=?", options: "=?", model: "=ngModel" } };
	  }]);
	}(window, window.angular), function (e) {
	  try {
	    e = angular.module("ui.nested.combobox");
	  } catch (n) {
	    e = angular.module("ui.nested.combobox", []);
	  }e.run(["$templateCache", function (e) {
	    e.put("select-group.html", '<div class="custom-select" data-ng-disabled="controlDisabled" data-ng-class="controlClass" data-ng-click="gs.toggleOpen()"  >\n    <input data-ng-model="ngModelController.$modelValue.name" ng-blur="gs.toggleBlur()" ng-focus="gs.toggleFocus()"\n           readonly />\n    <span><i class="icon-sort-down"></i></span>\n    <div class="list" data-ng-show="gs.isOpen">\n        <ul>\n            <li data-ng-class="{\'active\':ngModelController.$modelValue.id === member.id}" data-ng-include="\'sub-level.html\'"\n                data-ng-repeat="member in collection track by member.id"></li>\n        </ul>\n    </div>\n</div>');
	  }]);
	}(), function (e) {
	  try {
	    e = angular.module("ui.nested.combobox");
	  } catch (n) {
	    e = angular.module("ui.nested.combobox", []);
	  }e.run(["$templateCache", function (e) {
	    e.put("sub-level.html", '<a href="" data-ng-click="selectValue(e,member)"><span>{{member.name}}</span></a>\n<ul>\n    <li data-ng-class="{\'active\':ngModelController.$modelValue.id === member.id}"\n        ng-repeat="member in member[gs.options.childrenParam] track by member.id" ng-include="\'sub-level.html\'"></li>\n</ul>\n');
	  }]);
	}();

/***/ }),
/* 741 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.services').factory('accountPermission', ['userService', '$http', '$q', '$location', '$log', 'api', 'sharedProperties', function (userService, $http, $q, $location, $log, api, sharedProperties) {
	  function hasPermission(user, permissionName) {
	    if (user && user.ref_user_type) return Boolean(_.findWhere(user.ref_user_type.ref_permissions, {
	      name: permissionName
	    }));
	  }
	
	  var instance = {
	    checkUserType: function checkUserType(userTypes, REDIRECT_TO_404_IF_PAGE_NOT_ALLOWED_TO_VIEW) {
	      var deferred = $q.defer();
	
	      api.fetchCurrentUser().then(function (response) {
	        if (!userTypes.includes(response.data.userType)) {
	          deferred.reject();
	          if (REDIRECT_TO_404_IF_PAGE_NOT_ALLOWED_TO_VIEW) {
	            $location.url('/404');
	          } else {
	            sharedProperties.logOut();
	          }
	        } else {
	          deferred.resolve();
	        }
	      }, function (error) {
	        if (error.status === 440) {
	          // $log.error("account-permission: error", response);
	          userService.setUser().then(function (user) {
	            // $log.error("account-permission: error", user);
	            deferred.reject();
	            $location.url('/signin');
	          });
	        }
	      });
	
	      return deferred.promise;
	    },
	    isEmailListingAllowed: function isEmailListingAllowed(user) {
	      return hasPermission(user, 'canViewEmailListingPage');
	    },
	    isLawyerListingAllowed: function isLawyerListingAllowed(user) {
	      return hasPermission(user, 'canViewLawyersListingPage');
	    },
	    isMatchingLawyersAllowed: function isMatchingLawyersAllowed(user) {
	      return hasPermission(user, 'canViewMatchingLawyersButton');
	    },
	    isLawyersActionsAllowed: function isLawyersActionsAllowed(user) {
	      return hasPermission(user, 'canViewLawyerlistingActionButton');
	    },
	    isAssignedToActionAllowed: function isAssignedToActionAllowed(user) {
	      return hasPermission(user, 'canViewAssignedAdminActionButton');
	    },
	    canViewEmployersExportButton: function canViewEmployersExportButton(user) {
	      return hasPermission(user, 'canViewEmployersExportButton');
	    },
	    canViewJobsExportButton: function canViewJobsExportButton(user) {
	      return hasPermission(user, 'canViewJobsExportButton');
	    },
	    canViewLawyersExportButton: function canViewLawyersExportButton(user) {
	      return hasPermission(user, 'canViewLawyersExportButton');
	    },
	    canExportAllLawyersLawyersListing: function canExportAllLawyersLawyersListing(user) {
	      return hasPermission(user, 'canExportAllLawyersLawyersListing');
	    },
	    canViewMasterAssignedToFilter: function canViewMasterAssignedToFilter(user) {
	      return hasPermission(user, 'canViewMasterAssignedToFilter');
	    },
	    canAddNotesForEmployers: function canAddNotesForEmployers(user) {
	      return hasPermission(user, 'canAddNotesForEmployers');
	    },
	    canViewAddFirmAssignedAdmin: function canViewAddFirmAssignedAdmin(user) {
	      return hasPermission(user, 'canViewAddFirmAssignedAdmin');
	    },
	    canNotEditNewUserProfile: function canNotEditNewUserProfile(user) {
	      return hasPermission(user, 'canNotEditNewUserProfile');
	    },
	    canEditApplicationStages: function canEditApplicationStages(user) {
	      return hasPermission(user, 'canEditApplicationStages');
	    }
	  };
	
	  return instance;
	}]);

/***/ }),
/* 742 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.services').service('currentLawyer', ['$log', function ($log) {
	  var selectedLawyer;
	  selectedLawyer = {};
	  this.setLawyer = function (lawyer) {
	    selectedLawyer = lawyer;
	  };
	  this.getLawyer = function () {
	    return selectedLawyer;
	  };
	}]);

/***/ }),
/* 743 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.services').factory('defaultFilterService', ['api', function (api) {
	  var instance = {
	    fetchDefaultViewFilter: function fetchDefaultViewFilter(fetchFilterPayload) {
	      return api.fetchDefaultViewForUsers(fetchFilterPayload).then(function (data) {
	        if (data.data) {
	          return data.data.filterId;
	        }
	      }).catch(function (err) {
	        return err;
	      });
	    },
	    displayDefaultView: function displayDefaultView(savedFilters, defaultViewFilter, gridOptions) {
	      gridOptions.api.getFilterModel();
	      var filter = savedFilters.filter(function (x) {
	        return x.id == defaultViewFilter;
	      });
	      filter[0].defaultView = true;
	      filter[0].isApplied = true;
	      var view = JSON.parse(filter[0].filter);
	      if (view.columnState) {
	        if (view.columnState.group) {
	          gridOptions.columnApi.setColumnState(view.columnState.state);
	          gridOptions.columnApi.setColumnGroupState(view.columnState.group);
	        } else gridOptions.columnApi.setColumnState(view.columnState);
	      }
	      if (view.sort) gridOptions.api.setSortModel(view.sort);
	      if (view.filter) gridOptions.api.setFilterModel(view.filter);
	      if (view.index) gridOptions.api.ensureIndexVisible(view.index, 'middle');
	    }
	  };
	
	  return instance;
	}]);

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isTestAccount = isTestAccount;
	function isTestAccount(email) {
	  if (Boolean(email) && typeof email === 'string') {
	    var username = email.split('@')[0].toLowerCase();
	    var isLexstepTestAccount = email.toLowerCase().endsWith('@lexstep.com') && username.contains('+') && username.contains('test');
	
	    var isEmumba = email.toLowerCase().endsWith('@emumba.com');
	
	    if (isLexstepTestAccount || isEmumba) return true;
	    return false;
	  }
	
	  return true;
	}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

	'use strict';
	
	/******************************************************************/
	/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
	/******************************************************************/
	
	angular.module('app.services').factory('jobsService', ['$http', function ($http) {
	
	  var CATEGORY = {
	    "regular": "1",
	    "custom": "2",
	    "connect": "3",
	    "speculative": "4",
	    "ats": "5"
	  };
	
	  var instance = {
	    setJobCategory: function setJobCategory(jobs) {
	      jobs.forEach(function (job) {
	
	        Object.assign(job, {
	          isSpeculative: false,
	          is_connected: false,
	          is_custom: false
	        });
	
	        if (Object.is(job.jobCategory, CATEGORY.custom)) {
	          job.is_custom = true;
	        } else if (Object.is(job.jobCategory, CATEGORY.connect)) {
	          job.is_connected = true;
	        } else if (Object.is(job.jobCategory, CATEGORY.speculative)) {
	          job.isSpeculative = true;
	        }
	      });
	    }
	  };
	
	  return instance;
	}]);

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _common = __webpack_require__(33);
	
	angular.module('app.services').factory('locationsService', ['$http', function ($http) {
	
	  var instance = {
	    isSelected: function isSelected(location) {
	      return (0, _common.isSelected)(location);
	    },
	    createHeirarchy: function createHeirarchy(linearLocations) {
	      var heirarchicalLocations = [];
	
	      linearLocations.forEach(function (loc, index, array) {
	        if (loc.region === null && loc.area === null) {
	          loc.locations = [];
	          heirarchicalLocations.push(loc);
	          linearLocations.forEach(function (region_area, index, array) {
	            if (region_area.region === loc.loc_ID && region_area.area === null) {
	              region_area.sub_areas = [];
	              loc.locations.push(region_area);
	              linearLocations.forEach(function (sub_area, index, array) {
	                if (sub_area.region !== null && sub_area.area === region_area.loc_ID) {
	                  region_area.sub_areas.push(sub_area);
	                }
	              });
	            }
	          });
	        }
	      });
	
	      return heirarchicalLocations;
	    },
	    linearize: function linearize(heirarchicalLocations) {
	      var linearLocations = [];
	
	      heirarchicalLocations.forEach(function (region, index, array) {
	        if (instance.isSelected(region)) {
	          linearLocations.push(region);
	        }
	
	        region.locations.forEach(function (location, index, array) {
	          if (instance.isSelected(location)) {
	            linearLocations.push(location);
	          }
	
	          location.sub_areas.forEach(function (subArea, index, array) {
	            if (instance.isSelected(subArea)) {
	              linearLocations.push(subArea);
	            }
	          });
	        });
	      });
	
	      return linearLocations;
	    },
	    clearSelection: function clearSelection(heirarchicalLocations) {
	      var selection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      heirarchicalLocations.forEach(function (region) {
	        region.isSelected = selection;
	
	        region.locations.forEach(function (location) {
	          location.isSelected = selection;
	
	          location.sub_areas.forEach(function (sub) {
	            sub.isSelected = selection;
	          });
	        });
	      });
	    },
	    map: function map(linearLocations, heirarchicalLocations) {
	      instance.clearSelection(heirarchicalLocations);
	
	      linearLocations.forEach(function (tLoc, index, array) {
	        heirarchicalLocations.forEach(function (loc) {
	
	          loc.locations.forEach(function (region_area) {
	            if (tLoc.loc_ID === region_area.loc_ID) {
	              loc.isSelected = true;
	              region_area.isSelected = true;
	            }
	            region_area.sub_areas.forEach(function (sub_area) {
	              if (tLoc.loc_ID === sub_area.loc_ID) {
	                loc.isSelected = true;
	                region_area.isSelected = true;
	                sub_area.isSelected = true;
	              }
	            });
	          });
	        });
	      });
	    },
	    select: function select(heirarchicalLocations, event, current, level, count) {
	
	      var pCounter = void 0,
	          sCounter = void 0,
	          value = void 0;
	      pCounter = 0;
	      sCounter = 0;
	      value = event.target.checked;
	      if (level === 2) {
	        heirarchicalLocations.forEach(function (region, index, array) {
	          if (region.loc_ID === current.loc_ID) {
	            region.isSelected = value;
	            if (region.locations.length > 0) {
	              region.locations.forEach(function (location, index, array) {
	                location.isSelected = value;
	                location.sub_areas.forEach(function (sub, index, array) {
	                  if (sub.isSelected !== value) {
	                    if (value) {
	                      sub.isSelected = value;
	                      count++;
	                    } else if (!value) {
	                      sub.isSelected = value;
	                      count--;
	                    }
	                  }
	                });
	                if (value) {
	                  location.isSelected = value;
	                  count++;
	                } else if (!value && location.isSelected) {
	                  location.isSelected = value;
	                  count--;
	                }
	              });
	            } else {
	              if (value) {
	                region.isSelected = value;
	                count++;
	              } else if (!value) {
	                region.isSelected = value;
	                count--;
	              }
	            }
	          }
	        });
	      } else if (level === 1) {
	        heirarchicalLocations.forEach(function (region, index, array) {
	          region.locations.forEach(function (location, index, array) {
	            if (location.loc_ID === current.loc_ID) {
	              if (location.sub_areas.length > 0) {
	                location.isSelected = value;
	                region.locations.forEach(function (p, i, a) {
	                  if (p.isSelected) {
	                    pCounter++;
	                  }
	                });
	                if (value) {
	                  if (pCounter > 0) {
	                    region.isSelected = value;
	                  }
	                } else {
	                  if (pCounter <= 0) {
	                    region.isSelected = value;
	                  }
	                }
	                location.sub_areas.forEach(function (sub, index, array) {
	                  if (sub.isSelected !== value) {
	                    if (value) {
	                      sub.isSelected = value;
	                      count++;
	                    } else if (!value) {
	                      if (sub.isSelected) {
	                        sub.isSelected = value;
	                        count--;
	                      }
	                    }
	                  }
	                });
	              } else {
	                if (value) {
	                  location.isSelected = value;
	                  region.locations.forEach(function (p, i, a) {
	                    if (p.isSelected) {
	                      pCounter++;
	                    }
	                  });
	                  if (value) {
	                    if (pCounter > 0) {
	                      region.isSelected = value;
	                    }
	                  } else {
	                    if (pCounter <= 0) {
	                      region.isSelected = value;
	                    }
	                  }
	                  count++;
	                } else if (!value) {
	                  location.isSelected = value;
	                  region.locations.forEach(function (p, i, a) {
	                    if (p.isSelected) {
	                      pCounter++;
	                    }
	                  });
	                  if (value) {
	                    if (pCounter > 0) {
	                      region.isSelected = value;
	                    }
	                  } else {
	                    if (pCounter <= 0) {
	                      region.isSelected = value;
	                    }
	                  }
	                  count--;
	                }
	              }
	            }
	          });
	        });
	      } else if (level === 0) {
	        heirarchicalLocations.forEach(function (region, index, array) {
	          region.locations.forEach(function (location, index, array) {
	            if (location.sub_areas.length > 0) {
	              location.sub_areas.forEach(function (sub, index, array) {
	                if (sub.loc_ID === current.loc_ID) {
	                  sub.isSelected = value;
	                  location.sub_areas.forEach(function (s, i, a) {
	                    if (s.isSelected) {
	                      sCounter++;
	                    }
	                  });
	                  if (value) {
	                    if (sCounter > 0) {
	                      region.isSelected = value;
	                      location.isSelected = value;
	                    }
	                  } else {
	                    if (sCounter <= 0) {
	                      location.isSelected = value;
	                      region.locations.forEach(function (p, i, a) {
	                        if (p.isSelected) {
	                          pCounter++;
	                        }
	                      });
	                      if (value) {
	                        if (pCounter > 0) {
	                          region.isSelected = value;
	                        }
	                      } else {
	                        if (pCounter <= 0) {
	                          region.isSelected = value;
	                        }
	                      }
	                    }
	                  }
	                  if (value) {
	                    count++;
	                  } else {
	                    count--;
	                  }
	                }
	              });
	            }
	          });
	        });
	      }
	    }
	  };
	
	  return instance;
	}]); /******************************************************************/
	/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
	/******************************************************************/

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	'use strict';
	
	angular.module('app.services').factory('logger', [function () {
	
	  var toastrOptions = {
	    "closeButton": true,
	    "positionClass": "toast-top-right",
	    "timeOut": "6000"
	  };
	
	  var logIt = function logIt(message, type) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    toastr.options = Object.assign({}, toastrOptions, options);;
	    return toastr[type](message);
	  };
	
	  var instance = {
	    log: function log(message) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      logIt(message, 'info', options);
	    },
	    logWarning: function logWarning(message) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      logIt(message, 'warning', options);
	    },
	    logSuccess: function logSuccess(message) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      logIt(message, 'success', options);
	    },
	    logError: function logError(message) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      logIt(message, 'error', options);
	    },
	    notify: function notify(type, message) {
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      switch (type) {
	        case 'info':
	        default:
	          instance.log(message, options);
	          break;
	        case 'success':
	          instance.logSuccess(message, options);
	          break;
	        case 'warning':
	          instance.logWarning(message, options);
	          break;
	        case 'error':
	          instance.logError(message, options);
	      }
	    }
	  };
	
	  return instance;
	}]);

/***/ }),
/* 748 */
/***/ (function(module, exports) {

	'use strict';
	
	/******************************************************************/
	/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
	/******************************************************************/
	
	angular.module('app.services', []);

/***/ }),
/* 749 */
/***/ (function(module, exports) {

	'use strict';
	
	/******************************************************************/
	/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
	/******************************************************************/
	
	angular.module('app.services').factory('practicesService', ['$http', '$log', function ($http, $log) {
	
	  var instance = {
	    isSelected: function isSelected(practice) {
	      return practice.isSelected;
	    },
	    selectAreas: function selectAreas(law_areas, selection) {
	      _.each(law_areas, function (area) {
	        area.isSelected = selection;
	        selectPractices(area.practices, selection);
	      });
	
	      function selectPractices(practices, selection) {
	        _.each(practices, function (practice) {
	          practice.isSelected = selection;
	          selectSubAreas(practice.sub_areas, selection);
	        });
	
	        function selectSubAreas(subAreas, selection) {
	          _.each(subAreas, function (subArea) {
	            subArea.isSelected = selection;
	          });
	        }
	      }
	    },
	    createHeirarchy: function createHeirarchy(linearPractices) {
	      var heirarchicalPractices = [];
	
	      _.each(linearPractices, function (area) {
	        if (area.law_area === null && area.practice_area === null) {
	          area.practices = [];
	          heirarchicalPractices.push(area);
	
	          _.each(linearPractices, function (prac_area) {
	            if (prac_area.law_area === area.practice_ID && prac_area.practice_area === null) {
	              prac_area.sub_areas = [];
	              area.practices.push(prac_area);
	
	              _.each(linearPractices, function (sub_area) {
	                if (sub_area.law_area !== null && sub_area.practice_area === prac_area.practice_ID) {
	                  prac_area.sub_areas.push(sub_area);
	                }
	              });
	            }
	          });
	        }
	      });
	
	      return heirarchicalPractices;
	    },
	    linearize: function linearize(heirarchicalPractices) {
	      var linearPractices = [];
	
	      heirarchicalPractices.forEach(function (prac, index, array) {
	        if (instance.isSelected(prac)) {
	          linearPractices.push(prac);
	        }
	
	        prac.practices.forEach(function (law, index, array) {
	          if (instance.isSelected(law)) {
	            linearPractices.push(law);
	          }
	
	          law.sub_areas.forEach(function (sub, index, array) {
	            if (instance.isSelected(sub)) {
	              linearPractices.push(sub);
	            }
	          });
	        });
	      });
	
	      return linearPractices;
	    },
	    clearSelection: function clearSelection(heirarchicalPractices) {
	      var selection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      instance.selectAreas(heirarchicalPractices, selection);
	    },
	    map: function map(linearPractices, heirarchicalPractices) {
	      instance.clearSelection(heirarchicalPractices);
	      linearPractices.forEach(function (tPrac, index, array) {
	        heirarchicalPractices.forEach(function (area) {
	          if (tPrac.practice_ID === area.practice_ID) {
	            area.isSelected = true;
	          }
	
	          area.practices.forEach(function (practice) {
	            if (tPrac.practice_ID === practice.practice_ID) {
	              area.isSelected = true;
	              practice.isSelected = true;
	            }
	            practice.sub_areas.forEach(function (sub_area) {
	              if (tPrac.practice_ID === sub_area.practice_ID) {
	                area.isSelected = true;
	                practice.isSelected = true;
	                sub_area.isSelected = true;
	              }
	            });
	          });
	        });
	      });
	    },
	    deselectSelection: function deselectSelection(heirarchicalPractices) {
	      var selection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      instance.selectAreas(heirarchicalPractices, selection);
	      $log.info("heirarchicalPractices", heirarchicalPractices);
	    },
	    checkForLinking: function checkForLinking(allPracticeAreas, currentPracticeId, checkboxValue) {
	      var practiceIds = {
	        corporate: 3,
	        property: 76,
	        projectFinance: 24,
	        equityCapMarketForCapMarket: 22,
	        equityCapMarketForCorporate: 61,
	        bankingFinance: 1,
	        capMarket: 19,
	        constructionForProject: 25,
	        constructionForProperty: 84
	      };
	
	      var parent = void 0;
	      var child = void 0;
	
	      if (_.contains(practiceIds, currentPracticeId)) {
	
	        switch (currentPracticeId) {
	          case practiceIds.equityCapMarketForCapMarket:
	            parent = practiceIds.corporate;
	            child = practiceIds.equityCapMarketForCorporate;
	            break;
	
	          case practiceIds.equityCapMarketForCorporate:
	            parent = practiceIds.capMarket;
	            child = practiceIds.equityCapMarketForCapMarket;
	            break;
	
	          case practiceIds.capMarket:
	            parent = practiceIds.corporate;
	            child = practiceIds.equityCapMarketForCorporate;
	            break;
	
	          case practiceIds.corporate:
	            parent = practiceIds.capMarket;
	            child = practiceIds.equityCapMarketForCapMarket;
	            break;
	
	          case practiceIds.bankingFinance:
	          case practiceIds.projectFinance:
	          case practiceIds.constructionForProject:
	            parent = practiceIds.property;
	            child = practiceIds.constructionForProperty;
	            break;
	
	          case practiceIds.property:
	          case practiceIds.constructionForProperty:
	            parent = practiceIds.bankingFinance;
	            child = practiceIds.constructionForProject;
	            break;
	
	          default:
	            break;
	        }
	
	        var keepParentSelected = void 0;
	        var keepChildParentSelected = void 0;
	        return allPracticeAreas.forEach(function (lawArea, index, array) {
	          if (lawArea.practice_ID === parent) {
	            keepParentSelected = false;
	            lawArea.practices.forEach(function (PracticeArea, index, array) {
	              if (PracticeArea.practice_ID === child) {
	                PracticeArea.isSelected = checkboxValue;
	              }
	
	              if (!PracticeArea.hasChild && PracticeArea.isSelected) {
	                keepParentSelected = true;
	              } else {
	                keepChildParentSelected = false;
	                PracticeArea.sub_areas.forEach(function (area, index, array) {
	                  if (area.practice_ID === child) {
	                    area.isSelected = checkboxValue;
	                  }
	                  if (area.isSelected) {
	                    keepParentSelected = true;
	                    keepChildParentSelected = true;
	                  }
	                });
	                PracticeArea.isSelected = keepChildParentSelected;
	              }
	            });
	
	            lawArea.isSelected = keepParentSelected;
	          }
	        });
	      }
	    },
	    select: function select(heirarchicalPractices, event, current, level) {
	      var pCounter = void 0,
	          sCounter = void 0,
	          value = void 0;
	      pCounter = 0;
	      sCounter = 0;
	      value = event.target.checked;
	      if (level === 2) {
	        heirarchicalPractices.forEach(function (law_area, index, array) {
	          if (law_area.practice_ID === current.practice_ID) {
	            law_area.isSelected = value;
	            law_area.practices.forEach(function (practice, index, array) {
	              practice.isSelected = value;
	              practice.sub_areas.forEach(function (sub, index, array) {
	                if (sub.isSelected !== value) {
	                  sub.isSelected = value;
	                }
	              });
	            });
	          }
	        });
	      } else if (level === 1) {
	        heirarchicalPractices.forEach(function (law_area, index, array) {
	          law_area.practices.forEach(function (practice, index, array) {
	            if (practice.practice_ID === current.practice_ID) {
	              practice.isSelected = value;
	              law_area.practices.forEach(function (p, i, a) {
	                if (p.isSelected) {
	                  pCounter++;
	                }
	              });
	              if (value) {
	                if (pCounter > 0) {
	                  law_area.isSelected = value;
	                }
	              } else {
	                if (pCounter <= 0) {
	                  law_area.isSelected = value;
	                }
	              }
	              practice.sub_areas.forEach(function (sub, index, array) {
	                if (sub.isSelected !== value) {
	                  sub.isSelected = value;
	                }
	              });
	            }
	          });
	        });
	      } else if (level === 0) {
	        heirarchicalPractices.forEach(function (law_area, index, array) {
	          law_area.practices.forEach(function (practice, index, array) {
	            if (practice.sub_areas.length > 0) {
	              practice.sub_areas.forEach(function (sub, index, array) {
	                if (sub.practice_ID === current.practice_ID) {
	                  sub.isSelected = value;
	                  practice.sub_areas.forEach(function (s, i, a) {
	                    if (s.isSelected) {
	                      sCounter++;
	                    }
	                  });
	                  if (value) {
	                    if (sCounter > 0) {
	                      law_area.isSelected = value;
	                      practice.isSelected = value;
	                    }
	                  } else {
	                    if (sCounter <= 0) {
	                      practice.isSelected = value;
	                      law_area.practices.forEach(function (p, i, a) {
	                        if (p.isSelected) {
	                          pCounter++;
	                        }
	                      });
	                      if (value) {
	                        if (pCounter > 0) {
	                          law_area.isSelected = value;
	                        }
	                      } else {
	                        if (pCounter <= 0) {
	                          law_area.isSelected = value;
	                        }
	                      }
	                    }
	                  }
	                }
	              });
	            }
	          });
	        });
	      }
	    }
	
	  };
	
	  return instance;
	}]);

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/* eslint-disable angular/no-service-method */
	angular.module('app.services').service('sharedProperties', ['$rootScope', '$log', '$filter', '$window', function controller($rootScope, $log, $filter, $window) {
	  var _this = this;
	
	  var vm = this;
	
	  vm.isAdminSession = function () {
	    return !_.isEmpty($rootScope.user) && $rootScope.user.roles.some(function (role) {
	      return role.id === 'admin' || role.id === 'corporate';
	    });
	  };
	
	  vm.detectBrowser = function () {
	    var M = void 0;
	    var tem = void 0;
	    var ua = void 0;
	    ua = navigator.userAgent;
	    tem = undefined;
	    M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
	    if (/trident/i.test(M[1])) {
	      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
	      return 'IE ' + (tem[1] || '');
	    }
	
	    if (M[1] === 'Chrome') {
	      tem = ua.match(/\bOPR\/(\d+)/);
	      if (tem !== null) {
	        return 'Opera ' + tem[1];
	      }
	    }
	
	    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
	    if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
	      M.splice(1, 1, tem[1]);
	    }
	
	    return M.join(' ');
	  };
	
	  vm.logOut = function () {
	    $window.localStorage.setItem('logout', Date.now());
	    $window.localStorage.removeItem('token');
	    $window.localStorage.removeItem('user');
	    $window.location.href = '/signin';
	    return true;
	  };
	
	  vm.isNullOrEmpty = function (data) {
	    var isValid;
	    isValid = false;
	    isValid = Boolean(data === null || data === undefined || $.trim(data) === '');
	    return isValid;
	  };
	
	  vm.setCVName = function (firstName, lastName, cvCounter) {
	    var updatedFileName;
	    $log.info(firstName + lastName);
	    $log.info(cvCounter);
	    cvCounter++;
	    updatedFileName = $filter('date')(new Date(), 'yyMMdd') + '_' + firstName + lastName + '_CV' + cvCounter;
	    return updatedFileName;
	  };
	
	  vm.isNotNullOrEmpty = function (data) {
	    return !vm.isNullOrEmpty(data);
	  };
	
	  vm.getImgSrc = function (img) {
	    var userId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var useBackendUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    if (useBackendUrl) {
	      return ("https://api.lexstep.com") + '/' + userId + '/' + img;
	    }
	
	    return ("https://lexstep.com") + '/' + userId + '/' + img;
	  };
	
	  vm.getDefaultContactUsername = function () {
	    return 'Lexstep';
	  };
	
	  vm.getDefaultContactEmail = function () {
	    return 'jobs@lexstep.com';
	  };
	
	  vm.getDefaultContactPhone = function () {
	    return '+44 (0)20 7060 9516';
	  };
	
	  vm.getAgentDetails = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(agent) {
	      var imageUrl;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              imageUrl = 'images/defaultPic.jpg';
	
	              if (!(!agent || Object.keys(agent).length === 0)) {
	                _context.next = 4;
	                break;
	              }
	
	              imageUrl = 'images/lexstep_logo.jpeg';
	              return _context.abrupt('return', {
	                firstName: vm.getDefaultContactUsername(),
	                lastName: '',
	                email: vm.getDefaultContactEmail(),
	                phone: vm.getDefaultContactPhone(),
	                logoSrc: imageUrl
	              });
	
	            case 4:
	
	              if (agent.profilePicture) {
	                imageUrl = ("https://lexstep-nest-public.s3.eu-west-2.amazonaws.com") + '/user/' + agent.id + '/photo/' + agent.profilePicture;
	              }
	
	              return _context.abrupt('return', {
	                firstName: agent.firstName || vm.getDefaultContactUsername(),
	                lastName: agent.lastName,
	                email: agent.email || vm.getDefaultContactEmail(),
	                phone: agent.phone || vm.getDefaultContactPhone(),
	                logoSrc: imageUrl
	              });
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function (_x3) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	}]);

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	angular.module('app.services').factory('socket', ['$rootScope', function socketFunction($rootScope) {
	  var io = __webpack_require__(473);
	  var socket = io.connect(("https://api.lexstep.com") + '/client-update', {
	    transports: ['websocket']
	  });
	  return {
	    on: function on(eventName, callback) {
	      socket.on(eventName, function () {
	        var args = arguments;
	        $rootScope.$apply(function () {
	          callback.apply(socket, args);
	        });
	      });
	    },
	    emit: function emit(eventName, data, callback) {
	      socket.emit(eventName, data, function () {
	        var args = arguments;
	        $rootScope.$apply(function () {
	          if (callback) {
	            callback.apply(socket, args);
	          }
	        });
	      });
	    }
	  };
	}]);

/***/ }),
/* 752 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.api').factory('UserServiceApi', ['api', function UserServiceApi(api) {
	  var _this = this;
	
	  var userServiceApi = {
	    getUser: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(userId) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                return _context.abrupt('return', api.get('users/' + userId));
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function getUser(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getUser;
	    }(),
	    getUserAssignedAgent: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(userId) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                return _context2.abrupt('return', api.get('users/' + userId + '/agent'));
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      function getUserAssignedAgent(_x2) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getUserAssignedAgent;
	    }()
	  };
	  return userServiceApi;
	}]);

/***/ }),
/* 753 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.services').factory('userService', ['$q', '$http', '$location', '$window', 'UserServiceApi', 'SharedApi', 'api', 'socket', function userService($q, _$http, $location, $window, UserServiceApi, SharedApi, api, socket) {
	  var _this = this;
	
	  var defaultRoutes = {
	    admin: '/admin/admin-listings',
	    candidate: '/matches',
	    newUser: '/profile'
	  };
	
	  socket.on('USER_ROLE_UPDATED', function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
	      var user;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return instance.getUser();
	
	            case 2:
	              user = _context.sent;
	
	              if (user.id === data) {
	                instance.refreshUser(user);
	              }
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }());
	
	  var instance = {
	    getUser: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
	        var user, currentPath, firstPartOfPath, publicRoutes, isPublicRoute;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                user = JSON.parse($window.localStorage.getItem('user'));
	
	                console.debug('userService.getUser:', user);
	
	                if (!user) {
	                  _context2.next = 4;
	                  break;
	                }
	
	                return _context2.abrupt('return', user);
	
	              case 4:
	                currentPath = $location.path();
	
	                console.debug('currentPath is', currentPath);
	                firstPartOfPath = currentPath.split('/')[1];
	                publicRoutes = ['signin', 'signup', 'forgot', 'invite-friends', 'get-in-touch', 'about', 'blog', 'faqs', 'terms-conditions', 'pause', 'privacy-policy', 'unsubscribe'];
	                isPublicRoute = currentPath === '' || currentPath === '/' || publicRoutes.includes(firstPartOfPath);
	
	                if (!(!user && !isPublicRoute)) {
	                  _context2.next = 13;
	                  break;
	                }
	
	                console.debug('No user found for private page, redirecting to signin');
	                $location.path('/signin');
	                return _context2.abrupt('return', false);
	
	              case 13:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      function getUser() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return getUser;
	    }(),
	    verifySession: function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	        var userData, user, sessionRefreshed;
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                userData = $window.localStorage.getItem('user');
	                user = userData ? JSON.parse(userData) : undefined;
	
	                if (!(user && api.verifySessionToken())) {
	                  _context3.next = 4;
	                  break;
	                }
	
	                return _context3.abrupt('return', user);
	
	              case 4:
	                if (!(user && !api.verifySessionToken())) {
	                  _context3.next = 11;
	                  break;
	                }
	
	                _context3.next = 7;
	                return api.refreshSession();
	
	              case 7:
	                sessionRefreshed = _context3.sent;
	
	                if (!sessionRefreshed) {
	                  _context3.next = 10;
	                  break;
	                }
	
	                return _context3.abrupt('return', user);
	
	              case 10:
	                return _context3.abrupt('return', instance.endSessionRedirect());
	
	              case 11:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this);
	      }));
	
	      function verifySession() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return verifySession;
	    }(),
	    getUserPromise: function getUserPromise() {
	      var user = JSON.parse($window.localStorage.getItem('user', user));
	      return new Promise(function (resolve, _reject) {
	        if (user) {
	          resolve($q.when(user));
	        }
	      });
	    },
	    refreshUser: function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(user) {
	        var currentDefaultRoute, _ref5, userData, updatedUser;
	
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                currentDefaultRoute = user.defaultRoute;
	                _context4.next = 3;
	                return SharedApi.getUserById(user.id);
	
	              case 3:
	                _ref5 = _context4.sent;
	                userData = _ref5.data;
	                _context4.next = 7;
	                return instance.setUser(userData);
	
	              case 7:
	                updatedUser = _context4.sent;
	
	                if (currentDefaultRoute !== updatedUser.defaultRoute) {
	                  $window.location.href = updatedUser.defaultRoute;
	                }
	
	                return _context4.abrupt('return', updatedUser);
	
	              case 10:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this);
	      }));
	
	      function refreshUser(_x2) {
	        return _ref4.apply(this, arguments);
	      }
	
	      return refreshUser;
	    }(),
	    setUser: function () {
	      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(user) {
	        var _ref7, agent;
	
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                // TODO: Permissions
	                if (user.roles.find(function (role) {
	                  return role.id === 'admin';
	                })) {
	                  user.defaultRoute = defaultRoutes.admin;
	                  user.isAdmin = true;
	                  user.type = 'admin';
	                } else if (user.roles.find(function (role) {
	                  return role.id === 'agent';
	                })) {
	                  user.defaultRoute = defaultRoutes.admin;
	                  user.isAdmin = true;
	                  user.type = 'agent';
	                } else if (user.roles.find(function (role) {
	                  return role.id === 'ops';
	                })) {
	                  user.defaultRoute = defaultRoutes.admin;
	                  user.isAdmin = true;
	                  user.type = 'ops';
	                } else if (user.roles.find(function (role) {
	                  return role.id === 'intern';
	                })) {
	                  user.defaultRoute = defaultRoutes.admin;
	                  user.isAdmin = true;
	                  user.type = 'intern';
	                } else if (user.roles.find(function (role) {
	                  return role.id === 'position-creator';
	                })) {
	                  user.defaultRoute = defaultRoutes.admin;
	                  user.isAdmin = true;
	                  user.type = 'position-creator';
	                } else if (user.roles.find(function (role) {
	                  return role.id === 'position-creator-inhouse';
	                })) {
	                  user.defaultRoute = defaultRoutes.admin;
	                  user.isAdmin = true;
	                  user.type = 'position-creator-inhouse';
	                } else if (user.roles.length === 1 && user.roles.find(function (role) {
	                  return role.id === 'user';
	                })) {
	                  user.defaultRoute = defaultRoutes.newUser;
	                  user.isNewUser = true;
	                } else if (user.roles.find(function (role) {
	                  return role.id === 'candidate';
	                }) && !user.roles.find(function (role) {
	                  return role.id === 'approved';
	                })) {
	                  user.defaultRoute = defaultRoutes.newUser;
	                  user.isNewUser = true;
	                } else if (user.roles.find(function (role) {
	                  return role.id === 'candidate';
	                }) && user.roles.find(function (role) {
	                  return role.id === 'approved';
	                })) {
	                  user.defaultRoute = defaultRoutes.candidate;
	                  user.isCandidate = true;
	                }
	
	                // TODO: add candidate role when sign up?
	
	                if (!user.isCandidate) {
	                  _context5.next = 14;
	                  break;
	                }
	
	                _context5.prev = 2;
	                _context5.next = 5;
	                return UserServiceApi.getUserAssignedAgent(user.id);
	
	              case 5:
	                _ref7 = _context5.sent;
	                agent = _ref7.data;
	
	                user.agent = agent;
	
	                // TODO: get approval status of candidate if rejected then defaultRoute will be matches
	                _context5.next = 14;
	                break;
	
	              case 10:
	                _context5.prev = 10;
	                _context5.t0 = _context5['catch'](2);
	
	                console.error('Error loading user agent: ' + _context5.t0);
	                user.agent = undefined;
	
	              case 14:
	                // TODO: profile picture
	
	                $window.localStorage.setItem('user', JSON.stringify(user));
	                return _context5.abrupt('return', user);
	
	              case 16:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this, [[2, 10]]);
	      }));
	
	      function setUser(_x3) {
	        return _ref6.apply(this, arguments);
	      }
	
	      return setUser;
	    }(),
	    destroyUser: function destroyUser() {
	      // eslint-disable-next-line unicorn/no-null
	      $window.localStorage.setItem('user', null);
	    },
	    endSessionRedirect: function endSessionRedirect() {
	      instance.destroyUser();
	      $location.path('/signin');
	      return false;
	    },
	    authenticateRoute: function authenticateRoute(route) {
	      return instance.getUser().then(function (user) {
	        var deferred = $q.defer();
	        if (route.roles && route.roles.length > 0) {
	          if (user) {
	            var commonRoles = user.roles.filter(function (role) {
	              return route.roles.includes(role.id);
	            });
	            if (commonRoles.length === 0) {
	              deferred.reject({
	                reason: 403,
	                redirectTo: user.defaultRoute
	              });
	            }
	          }
	
	          if (!user) {
	            deferred.reject({
	              reason: 403,
	              redirectTo: '/signin'
	            });
	          }
	        }
	
	        if (user && route.hideWhenSession) {
	          deferred.reject({
	            reason: 403,
	            redirectTo: user.defaultRoute
	          });
	        }
	
	        deferred.resolve(user);
	        return deferred.promise;
	      });
	    }
	  };
	
	  return instance;
	}]);

/***/ }),
/* 754 */
/***/ (function(module, exports) {

	'use strict';
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.api').factory('SharedApi', ['api', function SharedApi(api) {
	  var _this = this;
	
	  var sharedApi = {
	    uploadUserProfilePicture: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(userId, payload) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                return _context.abrupt('return', api.post('users/' + userId + '/profile/photo', payload));
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function uploadUserProfilePicture(_x, _x2) {
	        return _ref.apply(this, arguments);
	      }
	
	      return uploadUserProfilePicture;
	    }(),
	    deleteUserProfilePicture: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(userId) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                return _context2.abrupt('return', api.delete('users/' + userId + '/profile/photo'));
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this);
	      }));
	
	      function deleteUserProfilePicture(_x3) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return deleteUserProfilePicture;
	    }(),
	
	    getAllContractTypes: function getAllContractTypes() {
	      return api.get('contract-types');
	    },
	    getAllOccupations: function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
	        var result, data, filtered;
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return api.get('occupations');
	
	              case 2:
	                result = _context3.sent;
	                data = result.data;
	                filtered = data.filter(Boolean).filter(function (item) {
	                  return item && item.professionId && item.professionId === 'law';
	                });
	                return _context3.abrupt('return', {
	                  status: result.status,
	                  headers: result.headers,
	                  config: result.config,
	                  statusText: result.statusText,
	                  xhrStatus: result.xhrStatus,
	                  data: filtered
	                });
	
	              case 6:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this);
	      }));
	
	      function getAllOccupations() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return getAllOccupations;
	    }(),
	    getAllCategories: function getAllCategories() {
	      return api.get('categories');
	    },
	    getReferrer: function () {
	      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(userId) {
	        var raw, referral;
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.prev = 0;
	                _context4.next = 3;
	                return api.get('referrals?targetUser=' + userId);
	
	              case 3:
	                raw = _context4.sent;
	
	                if (!(raw.data.length > 0)) {
	                  _context4.next = 8;
	                  break;
	                }
	
	                referral = raw.data[0];
	
	                if (!referral.referrerName) {
	                  _context4.next = 8;
	                  break;
	                }
	
	                return _context4.abrupt('return', referral.referrerName);
	
	              case 8:
	                return _context4.abrupt('return', '');
	
	              case 11:
	                _context4.prev = 11;
	                _context4.t0 = _context4['catch'](0);
	
	                console.debug('could not find referrer for ' + userId);
	                console.error(_context4.t0);
	                return _context4.abrupt('return', '');
	
	              case 16:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this, [[0, 11]]);
	      }));
	
	      function getReferrer(_x4) {
	        return _ref4.apply(this, arguments);
	      }
	
	      return getReferrer;
	    }(),
	    getCategoryById: function () {
	      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(categoryId) {
	        var raw, data, status, headers, config, statusText, xhrStatus, success, created, description, enabled, name, id, type, updated, specialties, other, england, rest, sortedRest, sorted, sortedData, result;
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _context5.next = 2;
	                return api.get('categories/' + categoryId);
	
	              case 2:
	                raw = _context5.sent;
	                data = raw.data, status = raw.status, headers = raw.headers, config = raw.config, statusText = raw.statusText, xhrStatus = raw.xhrStatus;
	
	                success = function success(response) {
	                  return response;
	                };
	
	                if (!(categoryId !== 3)) {
	                  _context5.next = 7;
	                  break;
	                }
	
	                return _context5.abrupt('return', success(raw));
	
	              case 7:
	
	                // Sort jurisdictions
	                console.debug('sorting jurisdictions');
	                created = data.created, description = data.description, enabled = data.enabled, name = data.name, id = data.id, type = data.type, updated = data.updated, specialties = data.specialties;
	                other = specialties.find(function (x) {
	                  return x.name === 'Other Jurisdiction';
	                });
	                england = specialties.find(function (x) {
	                  return x.name.startsWith('England');
	                });
	                rest = specialties.filter(function (x) {
	                  return x.name !== 'Other Jurisdiction' && !x.name.startsWith('England');
	                });
	
	                // Sort rest alphabetically
	
	                sortedRest = _.sortBy(rest, function (x) {
	                  return x.name.toLowerCase();
	                });
	                sorted = [england].concat(_toConsumableArray(sortedRest), [other]);
	                sortedData = {
	                  created: created,
	                  description: description,
	                  enabled: enabled,
	                  name: name,
	                  id: id,
	                  type: type,
	                  updated: updated,
	                  specialties: sorted
	                };
	                result = {
	                  status: status,
	                  headers: headers,
	                  config: config,
	                  statusText: statusText,
	                  xhrStatus: xhrStatus,
	                  data: sortedData
	                };
	                return _context5.abrupt('return', result);
	
	              case 17:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this);
	      }));
	
	      function getCategoryById(_x5) {
	        return _ref5.apply(this, arguments);
	      }
	
	      return getCategoryById;
	    }(),
	    getAllLocations: function () {
	      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(payload) {
	        var locations, uk, germany, london, ukChildren, germanyChildren, ukChildrenIds, isAGrandchildOfUk, restOfUk, ukLocations, nonUkLocations, sortedNonUk, aToF, gToZ, nonUk, result;
	        return regeneratorRuntime.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _context6.next = 2;
	                return api.get('locations', { params: payload });
	
	              case 2:
	                locations = _context6.sent;
	                uk = locations.data.find(function (x) {
	                  return x.name === 'United Kingdom';
	                });
	                germany = locations.data.find(function (x) {
	                  return x.name === 'Germany';
	                });
	                london = locations.data.find(function (x) {
	                  return x.name === 'London';
	                });
	                ukChildren = locations.data.filter(function (x) {
	                  return x.name !== 'London' && x.name !== 'United Kingdom' && x.parentId === uk.id;
	                });
	                germanyChildren = _.sortBy(locations.data.filter(function (x) {
	                  return x.name !== 'Germany' && x.parentId === germany.id;
	                }), function (x) {
	                  return x.name.toLowerCase();
	                });
	                ukChildrenIds = new Set(ukChildren.map(function (x) {
	                  return x.id;
	                }));
	
	                isAGrandchildOfUk = function isAGrandchildOfUk(location) {
	                  return (
	                    // eslint-disable-next-line no-implicit-coercion
	                    !!location.parentId && ukChildrenIds.has(location.parentId)
	                  );
	                };
	
	                restOfUk = locations.data.filter(function (x) {
	                  return isAGrandchildOfUk(x);
	                });
	                // eslint-disable-next-line you-dont-need-lodash-underscore/uniq
	
	                ukLocations = _.uniq([london].concat(_toConsumableArray(ukChildren), _toConsumableArray(restOfUk), [uk]));
	                nonUkLocations = locations.data.filter(function (x) {
	                  return x.name !== 'United Kingdom' && x.parentId !== uk.id && x.name !== 'Germany' && x.parentId !== germany.id;
	                });
	                sortedNonUk = _.sortBy(nonUkLocations, function (x) {
	                  return x.name.toLowerCase();
	                });
	                aToF = sortedNonUk.filter(function (x) {
	                  return x.name.match(/^[A-Fa-f]/);
	                });
	                gToZ = sortedNonUk.filter(function (x) {
	                  return x.name.match(/^[G-Zg-z]/);
	                });
	                nonUk = [].concat(_toConsumableArray(aToF), [germany], _toConsumableArray(germanyChildren), _toConsumableArray(gToZ));
	
	                // eslint-disable-next-line you-dont-need-lodash-underscore/uniq
	
	                result = _.uniq([].concat(_toConsumableArray(ukLocations), _toConsumableArray(nonUk)));
	                return _context6.abrupt('return', _.extend(locations, { data: result }));
	
	              case 19:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this);
	      }));
	
	      function getAllLocations(_x6) {
	        return _ref6.apply(this, arguments);
	      }
	
	      return getAllLocations;
	    }(),
	    getAllRegions: function getAllRegions() {
	      return api.get('regions');
	    },
	    getAllLanguages: function getAllLanguages() {
	      return api.get('languages');
	    },
	    getAllNationalities: function () {
	      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
	        var countries, nationalities, data, status, headers, config, statusText, xhrStatus, formatted, british, rest, sorted;
	        return regeneratorRuntime.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                _context7.next = 2;
	                return api.get('countries');
	
	              case 2:
	                countries = _context7.sent;
	                _context7.next = 5;
	                return api.get('nationalities');
	
	              case 5:
	                nationalities = _context7.sent;
	                data = nationalities.data, status = nationalities.status, headers = nationalities.headers, config = nationalities.config, statusText = nationalities.statusText, xhrStatus = nationalities.xhrStatus;
	                formatted = data.filter(function (nationality) {
	                  return nationality.demonyms.length;
	                }).map(function (nationality) {
	                  var code = nationality.code,
	                      demonyms = nationality.demonyms;
	
	                  var country = countries.data.find(function (x) {
	                    return x.code === code;
	                  });
	                  if (country !== undefined && country !== null) {
	                    var name = country.name;
	
	                    var nonEmptyDemonyms = demonyms.filter(function (x) {
	                      return x && x.length > 0;
	                    }).length > 0;
	
	                    var _demonyms = _toArray(demonyms),
	                        first = _demonyms[0],
	                        other = _demonyms.slice(1);
	
	                    var _formatted = nonEmptyDemonyms ? first + ' (' + name + ')' : name;
	                    var formattedDemonyms = nonEmptyDemonyms ? [_formatted].concat(_toConsumableArray(other)) : [_formatted];
	                    return {
	                      code: code,
	                      demonyms: formattedDemonyms
	                    };
	                  }
	
	                  return {
	                    code: code,
	                    demonyms: demonyms
	                  };
	                });
	                british = formatted.find(function (nationality) {
	                  return nationality.code === 'GB';
	                });
	                rest = formatted.filter(function (nationality) {
	                  return nationality.code !== 'GB';
	                });
	                sorted = [british].concat(_toConsumableArray(rest));
	                return _context7.abrupt('return', {
	                  status: status,
	                  headers: headers,
	                  config: config,
	                  statusText: statusText,
	                  xhrStatus: xhrStatus,
	                  data: sorted
	                });
	
	              case 12:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, _this);
	      }));
	
	      function getAllNationalities() {
	        return _ref7.apply(this, arguments);
	      }
	
	      return getAllNationalities;
	    }(),
	    getAllSchools: function getAllSchools() {
	      return api.get('schools');
	    },
	    getUserById: function getUserById(id) {
	      return api.get('users/' + id);
	    },
	    getAllActions: function getAllActions(payload) {
	      return api.get('actions', { params: payload });
	    },
	    addSchool: function addSchool(payload) {
	      return api.post('schools', payload);
	    }
	  };
	
	  return sharedApi;
	}]);

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// http://spin.js.org/#v2.3.2
	!function (a, b) {
	  "object" == ( false ? "undefined" : _typeof(module)) && module.exports ? module.exports = b() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (b), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : a.Spinner = b();
	}(undefined, function () {
	  "use strict";
	  function a(a, b) {
	    var c,
	        d = document.createElement(a || "div");for (c in b) {
	      d[c] = b[c];
	    }return d;
	  }function b(a) {
	    for (var b = 1, c = arguments.length; c > b; b++) {
	      a.appendChild(arguments[b]);
	    }return a;
	  }function c(a, b, c, d) {
	    var e = ["opacity", b, ~~(100 * a), c, d].join("-"),
	        f = .01 + c / d * 100,
	        g = Math.max(1 - (1 - a) / b * (100 - f), a),
	        h = j.substring(0, j.indexOf("Animation")).toLowerCase(),
	        i = h && "-" + h + "-" || "";return m[e] || (k.insertRule("@" + i + "keyframes " + e + "{0%{opacity:" + g + "}" + f + "%{opacity:" + a + "}" + (f + .01) + "%{opacity:1}" + (f + b) % 100 + "%{opacity:" + a + "}100%{opacity:" + g + "}}", k.cssRules.length), m[e] = 1), e;
	  }function d(a, b) {
	    var c,
	        d,
	        e = a.style;if (b = b.charAt(0).toUpperCase() + b.slice(1), void 0 !== e[b]) return b;for (d = 0; d < l.length; d++) {
	      if (c = l[d] + b, void 0 !== e[c]) return c;
	    }
	  }function e(a, b) {
	    for (var c in b) {
	      a.style[d(a, c) || c] = b[c];
	    }return a;
	  }function f(a) {
	    for (var b = 1; b < arguments.length; b++) {
	      var c = arguments[b];for (var d in c) {
	        void 0 === a[d] && (a[d] = c[d]);
	      }
	    }return a;
	  }function g(a, b) {
	    return "string" == typeof a ? a : a[b % a.length];
	  }function h(a) {
	    this.opts = f(a || {}, h.defaults, n);
	  }function i() {
	    function c(b, c) {
	      return a("<" + b + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', c);
	    }k.addRule(".spin-vml", "behavior:url(#default#VML)"), h.prototype.lines = function (a, d) {
	      function f() {
	        return e(c("group", { coordsize: k + " " + k, coordorigin: -j + " " + -j }), { width: k, height: k });
	      }function h(a, h, i) {
	        b(m, b(e(f(), { rotation: 360 / d.lines * a + "deg", left: ~~h }), b(e(c("roundrect", { arcsize: d.corners }), { width: j, height: d.scale * d.width, left: d.scale * d.radius, top: -d.scale * d.width >> 1, filter: i }), c("fill", { color: g(d.color, a), opacity: d.opacity }), c("stroke", { opacity: 0 }))));
	      }var i,
	          j = d.scale * (d.length + d.width),
	          k = 2 * d.scale * j,
	          l = -(d.width + d.length) * d.scale * 2 + "px",
	          m = e(f(), { position: "absolute", top: l, left: l });if (d.shadow) for (i = 1; i <= d.lines; i++) {
	        h(i, -2, "progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)");
	      }for (i = 1; i <= d.lines; i++) {
	        h(i);
	      }return b(a, m);
	    }, h.prototype.opacity = function (a, b, c, d) {
	      var e = a.firstChild;d = d.shadow && d.lines || 0, e && b + d < e.childNodes.length && (e = e.childNodes[b + d], e = e && e.firstChild, e = e && e.firstChild, e && (e.opacity = c));
	    };
	  }var j,
	      k,
	      l = ["webkit", "Moz", "ms", "O"],
	      m = {},
	      n = { lines: 12, length: 7, width: 5, radius: 10, scale: 1, corners: 1, color: "#000", opacity: .25, rotate: 0, direction: 1, speed: 1, trail: 100, fps: 20, zIndex: 2e9, className: "spinner", top: "50%", left: "50%", shadow: !1, hwaccel: !1, position: "absolute" };if (h.defaults = {}, f(h.prototype, { spin: function spin(b) {
	      this.stop();var c = this,
	          d = c.opts,
	          f = c.el = a(null, { className: d.className });if (e(f, { position: d.position, width: 0, zIndex: d.zIndex, left: d.left, top: d.top }), b && b.insertBefore(f, b.firstChild || null), f.setAttribute("role", "progressbar"), c.lines(f, c.opts), !j) {
	        var g,
	            h = 0,
	            i = (d.lines - 1) * (1 - d.direction) / 2,
	            k = d.fps,
	            l = k / d.speed,
	            m = (1 - d.opacity) / (l * d.trail / 100),
	            n = l / d.lines;!function o() {
	          h++;for (var a = 0; a < d.lines; a++) {
	            g = Math.max(1 - (h + (d.lines - a) * n) % l * m, d.opacity), c.opacity(f, a * d.direction + i, g, d);
	          }c.timeout = c.el && setTimeout(o, ~~(1e3 / k));
	        }();
	      }return c;
	    }, stop: function stop() {
	      var a = this.el;return a && (clearTimeout(this.timeout), a.parentNode && a.parentNode.removeChild(a), this.el = void 0), this;
	    }, lines: function lines(d, f) {
	      function h(b, c) {
	        return e(a(), { position: "absolute", width: f.scale * (f.length + f.width) + "px", height: f.scale * f.width + "px", background: b, boxShadow: c, transformOrigin: "left", transform: "rotate(" + ~~(360 / f.lines * k + f.rotate) + "deg) translate(" + f.scale * f.radius + "px,0)", borderRadius: (f.corners * f.scale * f.width >> 1) + "px" });
	      }for (var i, k = 0, l = (f.lines - 1) * (1 - f.direction) / 2; k < f.lines; k++) {
	        i = e(a(), { position: "absolute", top: 1 + ~(f.scale * f.width / 2) + "px", transform: f.hwaccel ? "translate3d(0,0,0)" : "", opacity: f.opacity, animation: j && c(f.opacity, f.trail, l + k * f.direction, f.lines) + " " + 1 / f.speed + "s linear infinite" }), f.shadow && b(i, e(h("#000", "0 0 4px #000"), { top: "2px" })), b(d, b(i, h(g(f.color, k), "0 0 1px rgba(0,0,0,.1)")));
	      }return d;
	    }, opacity: function opacity(a, b, c) {
	      b < a.childNodes.length && (a.childNodes[b].style.opacity = c);
	    } }), "undefined" != typeof document) {
	    k = function () {
	      var c = a("style", { type: "text/css" });return b(document.getElementsByTagName("head")[0], c), c.sheet || c.styleSheet;
	    }();var o = e(a("group"), { behavior: "url(#default#VML)" });!d(o, "transform") && o.adj ? i() : j = d(o, "animation");
	  }return h;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(169)(module)))

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	;(function module() {
	  angular.module('app.ui.form.ctrls').controller('TypeAheadController', ['SharedApi', 'EmployersApi', '$location', function controller(SharedApi, EmployersApi, $location) {
	    var _this = this;
	
	    var vm = this;
	    // vm.lawFirms = []
	    // vm.jobExp = [];
	    // // eslint-disable-next-line no-void
	    // vm.selected = void 0;
	    // vm.universities = []
	    // vm.nations = []
	    // vm.countries = []
	    vm.initializeAboutYouPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var _ref2, _ref3, locationsList, nationalitiesList, schoolList, employersList;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return Promise.all([SharedApi.getAllLocations({
	                regions: true
	              }), SharedApi.getAllNationalities(), SharedApi.getAllSchools(), EmployersApi.getAllEmployers({
	                isDeleted: false,
	                include: ['id', 'name']
	              })]);
	
	            case 2:
	              _ref2 = _context.sent;
	              _ref3 = _slicedToArray(_ref2, 4);
	              locationsList = _ref3[0].data;
	              nationalitiesList = _ref3[1].data;
	              schoolList = _ref3[2].data;
	              employersList = _ref3[3].data;
	
	
	              vm.locationsList = locationsList;
	              vm.nationalitiesList = nationalitiesList;
	              vm.schoolList = schoolList;
	              vm.employersList = employersList;
	
	            case 12:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    if ($location.url() !== '/user-profile') {
	      vm.initializeAboutYouPage();
	      // $http
	      //   .post('/api/fetchAllFirms', {
	      //     contentType: 'application/json',
	      //   })
	      //   .then(
	      //     ({data}) => {
	      //       vm.lawFirms = data
	      //     },
	      //     () => {}
	      //   )
	      // $http
	      //   .post('/api/fetch-nationalities', {
	      //     contentType: 'application/json',
	      //   })
	      //   .then(
	      //     ({data}) => {
	      //       vm.nations = data
	      //     },
	      //     () => {}
	      //   )
	      // $http
	      //   .post('/api/fetchUniversities', {
	      //     contentType: 'application/json',
	      //   })
	      //   .then(
	      //     ({data}) => {
	      //       vm.universities = data
	      //     },
	      //     () => {}
	      //   )
	      // return $http
	      //   .post('/api/fetch-countries', {
	      //     contentType: 'application/json',
	      //   })
	      //   .then(
	      //     ({data}) => {
	      //       vm.countries = data
	      //     },
	      //     () => {}
	      //   )
	    }
	  }]);
	})();

/***/ }),
/* 757 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.api').factory('LogInApi', ['api', function LogInApi(api) {
	  var _this = this;
	
	  var logApi = {
	    logIn: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload) {
	        var result;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                result = api.post('auth/login', payload, { withCredentials: true });
	
	                console.debug('LogInApi.logIn', result);
	                return _context.abrupt('return', result);
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function logIn(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return logIn;
	    }()
	  };
	  return logApi;
	}]);

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _segment = __webpack_require__(21);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable camelcase */
	
	
	function NotFoundError(message) {
	  var error = new Error(message);
	  error.status = 404;
	  return error;
	}
	
	NotFoundError.prototype = Object.create(Error.prototype);(function module() {
	  angular.module('app.ui.form.ctrls').controller('SignInController', ['api', 'usSpinnerService', 'userService', '$window', 'LogInApi', '$scope', function controller(api, usSpinnerService, userService, $window, LogInApi, $scope) {
	    var _this = this;
	
	    __webpack_require__(474);
	    var vm = this;
	
	    vm.idToken = '';
	
	    vm.startcounter = 0;
	    vm.spinneractive = false;
	
	    vm.startSpin = function () {
	      if (!vm.spinneractive) {
	        usSpinnerService.spin('spinner-1');
	        vm.spinneractive = true;
	        return vm.startcounter++;
	      }
	    };
	
	    vm.stopSpin = function () {
	      if (vm.spinneractive) {
	        usSpinnerService.stop('spinner-1');
	        vm.spinneractive = false;
	      }
	    };
	
	    vm.user = {};
	    vm.showOnError = false;
	    vm.alertMsg = ' ';
	    vm.showClass = '';
	    vm.hideDropDown = function () {
	      vm.showClass = '';
	    };
	
	    vm.showDropDown = function () {
	      if (vm.showClass === '') {
	        vm.showClass = 'show';
	      } else {
	        vm.showClass = '';
	      }
	    };
	
	    vm.changeStatus = function (status) {
	      console.debug('changeStatus', status);
	      if (typeof status === 'string') vm.alertMsg = status;else if (status === 404) {
	        vm.alertMsg = 'Invalid username/password entered. Please try again.';
	      } else if (status === 500) {
	        vm.alertMsg = 'Could not connect to the server. Please try again later.';
	      } else {
	        vm.alertMsg = 'An error has occurred. Please try the action again.';
	      }
	
	      vm.showOnError = true;
	    };
	
	    vm.AuthenticateUser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var loginResponse, data, user, _user;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              console.debug('AuthenticateUser: start');
	              vm.startSpin();
	
	              _context.prev = 2;
	              _context.next = 5;
	              return LogInApi.logIn({
	                email: vm.user.email,
	                password: vm.user.password
	              });
	
	            case 5:
	              loginResponse = _context.sent;
	
	              if (loginResponse) {
	                _context.next = 8;
	                break;
	              }
	
	              throw new NotFoundError('No user found');
	
	            case 8:
	              data = loginResponse.data;
	
	
	              console.debug('AuthenticateUser: got login response');
	              vm.idToken = data.tokenResponse.id_token;
	              api.startSession(data.tokenResponse);
	              vm.stopSpin();
	              _context.next = 15;
	              return userService.setUser(data.user);
	
	            case 15:
	              user = _context.sent;
	
	              $window.localStorage.setItem('signIn', Date.now());
	              try {
	                _user = (0, _segment.identifyUser)();
	
	                (0, _segment.trackLogin)(_user);
	              } catch (error) {
	                console.error('AuthenticateUser: tracking failed', error);
	              }
	
	              $window.location.href = user.defaultRoute;
	              _context.next = 25;
	              break;
	
	            case 21:
	              _context.prev = 21;
	              _context.t0 = _context['catch'](2);
	
	              vm.stopSpin();
	              if (_context.t0 && _context.t0.data && _context.t0.data.error_description) {
	                console.error('AuthenticateUser: failed', _context.t0, 'description', _context.t0.data.error_description);
	                vm.changeStatus(_context.t0.data.error_description);
	              } else if (_context.t0 && _context.t0.status) {
	                console.warn('AuthenticateUser: changing status - ' + _context.t0.status, _context.t0);
	                vm.changeStatus(_context.t0.status);
	              } else {
	                console.warn('AuthenticateUser: unknown error', _context.t0);
	                vm.changeStatus(_context.t0);
	              }
	
	            case 25:
	
	              $scope.$apply();
	
	            case 26:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this, [[2, 21]]);
	    }));
	  }]);
	})();

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	'use strict';
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	angular.module('app.api').factory('SignUpApi', ['api', function SignUpApi(api) {
	  var _this = this;
	
	  var signUpApi = {
	    signUp: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload) {
	        var result;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return api.post('auth/signup', payload, {
	                  withCredentials: true
	                }, undefined, true);
	
	              case 2:
	                result = _context.sent;
	
	                console.debug('SignUpApi result', result);
	                return _context.abrupt('return', result);
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      function signUp(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return signUp;
	    }()
	  };
	  return signUpApi;
	}]);

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _segment = __webpack_require__(21);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable camelcase */
	
	
	angular.module('app.ui.form.ctrls').controller('SignUpController', ['$window', 'logger', '$route', '$rootScope', 'SignUpApi', 'api', 'userService', '$scope', function controller($window, logger, $route, $rootScope, SignUpApi, api, userService, $scope) {
	  var _this = this;
	
	  var vm = this;
	
	  vm.notify = function (type, message) {
	    switch (type) {
	      case 'info':
	        logger.log(message);
	        break;
	      case 'success':
	        logger.logSuccess(message);
	        break;
	      case 'warning':
	        logger.logWarning(message);
	        break;
	      case 'error':
	        logger.logError(message);
	        break;
	      default:
	        break;
	    }
	  };
	
	  vm.hideDropDown = function () {
	    vm.showClass = '';
	  };
	
	  vm.user = {
	    referralId: ''
	  };
	  if ($route.current.params.referralCode) {
	    $rootScope.referralCode = $route.current.params.referralCode;
	  }
	
	  if ($rootScope.referralCode !== '') {
	    vm.user.referralId = $rootScope.referralCode;
	  }
	
	  vm.pattern = /^[a-z]+ [A-Z]+ [\d._a-z]+@[a-z]+\.[.a-z]{2,5}$/;
	  vm.getParameterByName = function (name) {
	    var regex;
	    var results;
	    name = name.replace(/\[/, '\\[').replace(/]/, '\\]');
	    regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	    results = regex.exec($window.location.href);
	    if (results === null) {
	      return '';
	    }
	
	    return decodeURIComponent(results[1].replace(/\+/g, ' '));
	  };
	
	  vm.showOnError = false;
	  vm.alertMsg = ' ';
	  vm.showClass = '';
	  vm.showDropDown = function () {
	    if (vm.showClass === '') {
	      vm.showClass = 'show';
	    } else {
	      vm.showClass = '';
	    }
	  };
	
	  vm.showEmailInvalid = false;
	  vm.validateEmail = function (event) {
	    var index;
	    index = event.target.attributes.class.value.search(' ng-invalid ');
	    if (index >= 0) {
	      vm.notify('error', 'Please enter a valid email address.');
	    }
	  };
	
	  var isEmailValid = function isEmailValid(email) {
	    var result = email && email.length && email.length > 2 && email.includes('@') && email.indexOf('@') > 0;
	    vm.showEmailInvalid = !result;
	    return result;
	  };
	
	  vm.changeStatus = function (status) {
	    console.debug('vm.changeStatus', status);
	    if (typeof status === 'string') {
	      vm.alertMsg = status === 'ERR_BAD_REQUEST' ? 'Invalid email detected. Is this email already in use? Please get in contact if you believe this is a mistake.' : vm.capitalize(status);
	      vm.showOnError = true;
	      vm.showEmailInvalid = status === 'ERR_BAD_REQUEST';
	
	      vm.notify('error', status);
	    } else if (status === 404) {
	      vm.showOnError = true;
	      vm.alertMsg = 'Error! Passwords do not match. Please try again.';
	      vm.notify('error', 'Error! Passwords do not match. Please try again.');
	    } else if (status === 400) {
	      vm.showOnError = true;
	
	      vm.alertMsg = 'Error! Emails do not match. Please try again.';
	      vm.notify('error', 'Error! Emails do not match. Please try again.');
	    } else if (status === 401) {
	      vm.showEmailInvalid = true;
	      vm.notify('error', 'Email is invalid. Please enter a valid email address.');
	    } else if (status === 500) {
	      vm.showOnError = true;
	      vm.alertMsg = 'Could not connect to the server. Please try again later.';
	      vm.notify('error', 'Could not connect to the server. Please try again later.');
	    } else if (status === 300) {
	      vm.showOnError = true;
	      vm.alertMsg = 'Please agree to the terms & conditions and privacy policy of LexStep before you get started.';
	      vm.notify('error', 'Please agree to the terms & conditions and privacy policy of LexStep before you get started.');
	    } else if (status >= 401 && status < 500) {
	      vm.showOnError = true;
	      vm.alertMsg = 'Unable to sign up. Is this email already registered with us?';
	      vm.notify('error', vm.alertMsg);
	    } else {
	      vm.showOnError = true;
	      vm.alertMsg = 'An error has occurred. Please try the action again.';
	      vm.notify('error', 'An error has occurred. Please try the action again.');
	    }
	  };
	
	  vm.capitalize = function (string) {
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  };
	
	  vm.AddLawyer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	    var signUpData, response, data, user;
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            signUpData = Object.assign({
	              email: vm.user.email,
	              password: vm.user.password,
	              firstName: vm.user.firstName,
	              lastName: vm.user.lastName,
	              professions: ['law']
	            }, vm.user.referralId && { referralId: vm.user.referralId });
	
	
	            vm.disableSignupBtnClass = true;
	
	            if (isEmailValid(vm.user.email)) {
	              _context.next = 5;
	              break;
	            }
	
	            vm.disableSignupBtnClass = false;
	            return _context.abrupt('return', vm.changeStatus(401));
	
	          case 5:
	            if (!(vm.user.password.length >= 6)) {
	              _context.next = 32;
	              break;
	            }
	
	            vm.showOnError = false;
	            _context.prev = 7;
	            _context.next = 10;
	            return SignUpApi.signUp(signUpData);
	
	          case 10:
	            response = _context.sent;
	
	            console.debug('sign up response', response);
	            data = response.data;
	
	            vm.idToken = data.tokenResponse.id_token;
	            api.startSession(data.tokenResponse);
	            _context.next = 17;
	            return userService.setUser(data.user);
	
	          case 17:
	            user = _context.sent;
	
	            $window.localStorage.setItem('signIn', Date.now());
	            (0, _segment.signUpGetStartedEvent)();
	            try {
	              analytics.identify(data.user.id, {
	                first_Name: data.user.firstName,
	                last_Name: data.user.lastName,
	                email: data.user.email
	              });
	            } catch (error) {
	              console.error('Sign Up', error);
	            }
	
	            $window.location.href = user.defaultRoute;
	            _context.next = 30;
	            break;
	
	          case 24:
	            _context.prev = 24;
	            _context.t0 = _context['catch'](7);
	
	            console.error('sign up error', _context.t0);
	
	            if (_context.t0 && _context.t0.data && _context.t0.data.message) {
	              vm.changeStatus(_context.t0.data.message);
	            } else if (_context.t0 && _context.t0.status) {
	              vm.changeStatus(_context.t0.status);
	            } else if (_context.t0 && _context.t0.code) {
	              vm.changeStatus(_context.t0.code);
	            }
	
	            vm.disableSignupBtnClass = false;
	            $scope.$apply();
	
	          case 30:
	            _context.next = 35;
	            break;
	
	          case 32:
	            vm.disableSignupBtnClass = false;
	            vm.notify('error', 'Error! Password must be at least 6 characters.');
	            $scope.$apply();
	
	          case 35:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, _this, [[7, 24]]);
	  }));
	}]);

/***/ }),
/* 761 */
/***/ (function(module, exports) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	;(function () {
	  'use strict';
	
	  angular.module('app.tables', []).controller('tableCtrl', ['$scope', '$filter', function ($scope, $filter) {
	    var init;
	    $scope.stores = [{
	      name: 'Nijiya Market',
	      price: '$$',
	      sales: 292,
	      rating: 4.0
	    }, {
	      name: 'Eat On Monday Truck',
	      price: '$',
	      sales: 119,
	      rating: 4.3
	    }, {
	      name: 'Tea Era',
	      price: '$',
	      sales: 874,
	      rating: 4.0
	    }, {
	      name: 'Rogers Deli',
	      price: '$',
	      sales: 347,
	      rating: 4.2
	    }, {
	      name: 'MoBowl',
	      price: '$$$',
	      sales: 24,
	      rating: 4.6
	    }, {
	      name: 'The Milk Pail Market',
	      price: '$',
	      sales: 543,
	      rating: 4.5
	    }, {
	      name: 'Nob Hill Foods',
	      price: '$$',
	      sales: 874,
	      rating: 4.0
	    }, {
	      name: 'Scratch',
	      price: '$$$',
	      sales: 643,
	      rating: 3.6
	    }, {
	      name: 'Gochi Japanese Fusion Tapas',
	      price: '$$$',
	      sales: 56,
	      rating: 4.1
	    }, {
	      name: 'Cost Plus World Market',
	      price: '$$',
	      sales: 79,
	      rating: 4.0
	    }, {
	      name: 'Bumble Bee Health Foods',
	      price: '$$',
	      sales: 43,
	      rating: 4.3
	    }, {
	      name: 'Costco',
	      price: '$$',
	      sales: 219,
	      rating: 3.6
	    }, {
	      name: 'Red Rock Coffee Co',
	      price: '$',
	      sales: 765,
	      rating: 4.1
	    }, {
	      name: '99 Ranch Market',
	      price: '$',
	      sales: 181,
	      rating: 3.4
	    }, {
	      name: 'Mi Pueblo Food Center',
	      price: '$',
	      sales: 78,
	      rating: 4.0
	    }, {
	      name: 'Cucina Venti',
	      price: '$$',
	      sales: 163,
	      rating: 3.3
	    }, {
	      name: 'Sufi Coffee Shop',
	      price: '$',
	      sales: 113,
	      rating: 3.3
	    }, {
	      name: 'Dana Street Roasting',
	      price: '$',
	      sales: 316,
	      rating: 4.1
	    }, {
	      name: 'Pearl Cafe',
	      price: '$',
	      sales: 173,
	      rating: 3.4
	    }, {
	      name: 'Posh Bagel',
	      price: '$',
	      sales: 140,
	      rating: 4.0
	    }, {
	      name: 'Artisan Wine Depot',
	      price: '$$',
	      sales: 26,
	      rating: 4.1
	    }, {
	      name: 'Hong Kong Chinese Bakery',
	      price: '$',
	      sales: 182,
	      rating: 3.4
	    }, {
	      name: 'Starbucks',
	      price: '$$',
	      sales: 97,
	      rating: 3.7
	    }, {
	      name: 'Tapioca Express',
	      price: '$',
	      sales: 301,
	      rating: 3.0
	    }, {
	      name: 'House of Bagels',
	      price: '$',
	      sales: 82,
	      rating: 4.4
	    }];
	    $scope.searchKeywords = '';
	    $scope.filteredStores = [];
	    $scope.row = '';
	    $scope.select = function (page) {
	      var end, start;
	      start = (page - 1) * $scope.numPerPage;
	      end = start + $scope.numPerPage;
	
	      return $scope.currentPageStores = $scope.filteredStores.slice(start, end);
	    };
	    $scope.onFilterChange = function () {
	      $scope.select(1);
	      $scope.currentPage = 1;
	      return $scope.row = '';
	    };
	    $scope.onNumPerPageChange = function () {
	      $scope.select(1);
	      return $scope.currentPage = 1;
	    };
	    $scope.onOrderChange = function () {
	      $scope.select(1);
	      return $scope.currentPage = 1;
	    };
	    $scope.search = function () {
	      $scope.filteredStores = $filter('filter')($scope.stores, $scope.searchKeywords);
	      return $scope.onFilterChange();
	    };
	    $scope.order = function (rowName) {
	      if ($scope.row === rowName) {
	        return;
	      }
	      $scope.row = rowName;
	      $scope.filteredStores = $filter('orderBy')($scope.stores, rowName);
	      return $scope.onOrderChange();
	    };
	    $scope.numPerPageOpt = [3, 5, 10, 20];
	    $scope.numPerPage = $scope.numPerPageOpt[2];
	    $scope.currentPage = 1;
	    $scope.currentPageStores = [];
	    init = function init() {
	      $scope.search();
	      return $scope.select($scope.currentPage);
	    };
	    return init();
	  }]);
	}).call(undefined);

/***/ }),
/* 762 */
/***/ (function(module, exports) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  'use strict';
	
	  angular.module('app.task', []).factory('taskStorage', function () {
	    var DEMO_TASKS, STORAGE_ID;
	    STORAGE_ID = 'tasks';
	    DEMO_TASKS = '[ {"title": "Finish homework", "completed": true}, {"title": "Make a call", "completed": true}, {"title": "Build a snowman!", "completed": false}, {"title": "Tango! Tango! Tango!", "completed": false}, {"title": "Play games with friends", "completed": false}, {"title": "Shopping", "completed": false} ]';
	    return {
	      get: function get() {
	        return JSON.parse(localStorage.getItem(STORAGE_ID) || DEMO_TASKS);
	      },
	      put: function put(tasks) {
	        return localStorage.setItem(STORAGE_ID, JSON.stringify(tasks));
	      }
	    };
	  }).directive('taskFocus', ['$timeout', function ($timeout) {
	    return {
	      link: function link(scope, ele, attrs) {
	        return scope.$watch(attrs.taskFocus, function (newVal) {
	          if (newVal) {
	            return $timeout(function () {
	              return ele[0].focus();
	            }, 0, false);
	          }
	        });
	      }
	    };
	  }]).controller('taskCtrl', ['$scope', 'taskStorage', 'filterFilter', '$rootScope', 'logger', function ($scope, taskStorage, filterFilter, $rootScope, logger) {
	    var tasks;
	    tasks = $scope.tasks = taskStorage.get();
	    $scope.newTask = '';
	    $scope.remainingCount = filterFilter(tasks, {
	      completed: false
	    }).length;
	    $scope.editedTask = null;
	    $scope.statusFilter = {
	      completed: false
	    };
	    $scope.filter = function (filter) {
	      switch (filter) {
	        case 'all':
	          return $scope.statusFilter = '';
	        case 'active':
	          return $scope.statusFilter = {
	            completed: false
	          };
	        case 'completed':
	          return $scope.statusFilter = {
	            completed: true
	          };
	      }
	    };
	    $scope.add = function () {
	      var newTask;
	      newTask = $scope.newTask.trim();
	      if (newTask.length === 0) {
	        return;
	      }
	      tasks.push({
	        title: newTask,
	        completed: false
	      });
	      logger.logSuccess('New task: "' + newTask + '" added');
	      taskStorage.put(tasks);
	      $scope.newTask = '';
	      return $scope.remainingCount++;
	    };
	    $scope.edit = function (task) {
	      return $scope.editedTask = task;
	    };
	    $scope.doneEditing = function (task) {
	      $scope.editedTask = null;
	      task.title = task.title.trim();
	      if (!task.title) {
	        $scope.remove(task);
	      } else {
	        logger.log('Task updated');
	      }
	      return taskStorage.put(tasks);
	    };
	    $scope.remove = function (task) {
	      var index;
	      $scope.remainingCount -= task.completed ? 0 : 1;
	      index = $scope.tasks.indexOf(task);
	      $scope.tasks.splice(index, 1);
	      taskStorage.put(tasks);
	      return logger.logError('Task removed');
	    };
	    $scope.completed = function (task) {
	      $scope.remainingCount += task.completed ? -1 : 1;
	      taskStorage.put(tasks);
	      if (task.completed) {
	        if ($scope.remainingCount > 0) {
	          if ($scope.remainingCount === 1) {
	            return logger.log('Almost there! Only ' + $scope.remainingCount + ' task left');
	          } else {
	            return logger.log('Good job! Only ' + $scope.remainingCount + ' tasks left');
	          }
	        } else {
	          return logger.logSuccess('Congrats! All done :)');
	        }
	      }
	    };
	    $scope.clearCompleted = function () {
	      $scope.tasks = tasks = tasks.filter(function (val) {
	        return !val.completed;
	      });
	      return taskStorage.put(tasks);
	    };
	    $scope.markAll = function (completed) {
	      tasks.forEach(function (task) {
	        return task.completed = completed;
	      });
	      $scope.remainingCount = completed ? 0 : tasks.length;
	      taskStorage.put(tasks);
	      if (completed) {
	        return logger.logSuccess('Congrats! All done :)');
	      }
	    };
	    $scope.$watch('remainingCount == 0', function (val) {
	      return $scope.allChecked = val;
	    });
	    return $scope.$watch('remainingCount', function (newVal, oldVal) {
	      return $rootScope.$broadcast('taskRemaining:changed', newVal);
	    });
	  }]);
	}).call(undefined);

/***/ }),
/* 763 */
/***/ (function(module, exports) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  'use strict';
	
	  angular.module('app.ui.ctrls', []).controller('NotifyCtrl', ['$scope', 'logger', function ($scope, logger) {
	    return $scope.notify = function (type) {
	      switch (type) {
	        case 'info':
	          return logger.log("Heads up! This alert needs your attention, but it's not super important.");
	        case 'success':
	          return logger.logSuccess("Well done! You successfully read this important alert message.");
	        case 'warning':
	          return logger.logWarning("Warning! Best check yo self, you're not looking too good.");
	        case 'error':
	          return logger.logError("Oh snap! Change a few things up and try submitting again.");
	      }
	    };
	  }]).controller('AlertDemoCtrl', ['$scope', function ($scope) {
	    $scope.alerts = [{
	      type: 'success',
	      msg: 'Well done! You successfully read this important alert message.'
	    }, {
	      type: 'info',
	      msg: 'Heads up! This alert needs your attention, but it is not super important.'
	    }, {
	      type: 'warning',
	      msg: "Warning! Best check yo self, you're not looking too good."
	    }, {
	      type: 'danger',
	      msg: 'Oh snap! Change a few things up and try submitting again.'
	    }];
	    $scope.addAlert = function () {
	      var num, type;
	      num = Math.ceil(Math.random() * 4);
	      type = void 0;
	      switch (num) {
	        case 0:
	          type = 'info';
	          break;
	        case 1:
	          type = 'success';
	          break;
	        case 2:
	          type = 'info';
	          break;
	        case 3:
	          type = 'warning';
	          break;
	        case 4:
	          type = 'danger';
	      }
	      return $scope.alerts.push({
	        type: type,
	        msg: "Another alert!"
	      });
	    };
	    return $scope.closeAlert = function (index) {
	      return $scope.alerts.splice(index, 1);
	    };
	  }]).controller('ProgressDemoCtrl', ['$scope', function ($scope) {
	    $scope.max = 200;
	    $scope.random = function () {
	      var type, value;
	      value = Math.floor(Math.random() * 100 + 10);
	      type = void 0;
	      if (value < 25) {
	        type = "success";
	      } else if (value < 50) {
	        type = "info";
	      } else if (value < 75) {
	        type = "warning";
	      } else {
	        type = "danger";
	      }
	      $scope.showWarning = type === "danger" || type === "warning";
	      $scope.dynamic = value;
	      $scope.type = type;
	    };
	    return $scope.random();
	  }]).controller('AccordionDemoCtrl', ['$scope', function ($scope) {
	    $scope.oneAtATime = true;
	    $scope.groups = [{
	      title: "Dynamic Group Header - 1",
	      content: "Dynamic Group Body - 1"
	    }, {
	      title: "Dynamic Group Header - 2",
	      content: "Dynamic Group Body - 2"
	    }, {
	      title: "Dynamic Group Header - 3",
	      content: "Dynamic Group Body - 3"
	    }];
	    $scope.items = ["Item 1", "Item 2", "Item 3"];
	    $scope.status = {
	      isFirstOpen: true,
	      isFirstOpen1: true,
	      isFirstOpen2: true,
	      isFirstOpen3: true,
	      isFirstOpen4: true,
	      isFirstOpen5: true,
	      isFirstOpen6: true
	    };
	    $scope.addItem = function () {
	      var newItemNo;
	      newItemNo = $scope.items.length + 1;
	      $scope.items.push("Item " + newItemNo);
	    };
	  }]).controller('CollapseDemoCtrl', ['$scope', function ($scope) {
	    return $scope.isCollapsed = false;
	  }]).controller('ModalDemoCtrl', ['$scope', '$modal', '$log', function ($scope, $modal, $log) {
	    $scope.items = ["item1", "item2", "item3"];
	    $scope.open = function () {
	      var modalInstance;
	      modalInstance = $modal.open({
	        templateUrl: "myModalContent.html",
	        controller: 'ModalInstanceCtrl',
	        resolve: {
	          items: function items() {
	            return $scope.items;
	          }
	        }
	      });
	      modalInstance.result.then(function (selectedItem) {
	        $scope.selected = selectedItem;
	      }, function () {
	        $log.info("Modal dismissed at: " + new Date());
	      });
	    };
	  }]).controller('ModalInstanceCtrl', ['$scope', '$modalInstance', 'items', function ($scope, $modalInstance, items) {
	    $scope.items = items;
	    $scope.selected = {
	      item: $scope.items[0]
	    };
	    $scope.ok = function () {
	      $modalInstance.close($scope.selected.item);
	    };
	    $scope.cancel = function () {
	      $modalInstance.dismiss("cancel");
	    };
	  }]).controller('PaginationDemoCtrl', ['$scope', function ($scope) {
	    $scope.totalItems = 64;
	    $scope.currentPage = 4;
	    $scope.maxSize = 5;
	    $scope.setPage = function (pageNo) {
	      return $scope.currentPage = pageNo;
	    };
	    $scope.bigTotalItems = 175;
	    return $scope.bigCurrentPage = 1;
	  }]).controller('TabsDemoCtrl', ['$scope', function ($scope) {
	    $scope.tabs = [{
	      title: "Dynamic Title 1",
	      content: "Dynamic content 1.  Consectetur adipisicing elit. Nihil, quidem, officiis, et ex laudantium sed cupiditate voluptatum libero nobis sit illum voluptates beatae ab. Ad, repellendus non sequi et at."
	    }, {
	      title: "Disabled",
	      content: "Dynamic content 2.  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nihil, quidem, officiis, et ex laudantium sed cupiditate voluptatum libero nobis sit illum voluptates beatae ab. Ad, repellendus non sequi et at.",
	      disabled: true
	    }];
	    return $scope.navType = "pills";
	  }]).controller('TreeDemoCtrl', ['$scope', function ($scope) {
	    $scope.list = [{
	      id: 1,
	      title: "Item 1",
	      items: []
	    }, {
	      id: 2,
	      title: "Item 2",
	      items: [{
	        id: 21,
	        title: "Item 2.1",
	        items: [{
	          id: 211,
	          title: "Item 2.1.1",
	          items: []
	        }, {
	          id: 212,
	          title: "Item 2.1.2",
	          items: []
	        }]
	      }, {
	        id: 22,
	        title: "Item 2.2",
	        items: [{
	          id: 221,
	          title: "Item 2.2.1",
	          items: []
	        }, {
	          id: 222,
	          title: "Item 2.2.2",
	          items: []
	        }]
	      }]
	    }, {
	      id: 3,
	      title: "Item 3",
	      items: []
	    }, {
	      id: 4,
	      title: "Item 4",
	      items: [{
	        id: 41,
	        title: "Item 4.1",
	        items: []
	      }]
	    }, {
	      id: 5,
	      title: "Item 5",
	      items: []
	    }, {
	      id: 6,
	      title: "Item 6",
	      items: []
	    }, {
	      id: 7,
	      title: "Item 7",
	      items: []
	    }];
	    $scope.selectedItem = {};
	    $scope.options = {};
	    $scope.remove = function (scope) {
	      scope.remove();
	    };
	    $scope.toggle = function (scope) {
	      scope.toggle();
	    };
	    return $scope.newSubItem = function (scope) {
	      var nodeData;
	      nodeData = scope.$modelValue;
	      nodeData.items.push({
	        id: nodeData.id * 10 + nodeData.items.length,
	        title: nodeData.title + "." + (nodeData.items.length + 1),
	        items: []
	      });
	    };
	  }]).controller('MapDemoCtrl', ['$scope', '$http', '$interval', function ($scope, $http, $interval) {
	    var i, markers;
	    markers = [];
	    i = 0;
	    while (i < 8) {
	      markers[i] = new google.maps.Marker({
	        title: "Marker: " + i
	      });
	      i++;
	    }
	    $scope.GenerateMapMarkers = function () {
	      var d, lat, lng, loc, numMarkers;
	      d = new Date();
	      $scope.date = d.toLocaleString();
	      numMarkers = Math.floor(Math.random() * 4) + 4;
	      i = 0;
	      while (i < numMarkers) {
	        lat = 43.6600000 + Math.random() / 100;
	        lng = -79.4103000 + Math.random() / 100;
	        loc = new google.maps.LatLng(lat, lng);
	        markers[i].setPosition(loc);
	        markers[i].setMap($scope.map);
	        i++;
	      }
	    };
	    $interval($scope.GenerateMapMarkers, 2000);
	  }]);
	}).call(undefined);

/***/ }),
/* 764 */
/***/ (function(module, exports) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  'use strict';
	
	  angular.module('app.ui.directives', []).directive('uiTime', [function () {
	    return {
	      restrict: 'A',
	      link: function link(scope, ele) {
	        var checkTime, _startTime;
	        _startTime = function startTime() {
	          var h, m, s, t, time, today;
	          today = new Date();
	          h = today.getHours();
	          m = today.getMinutes();
	          s = today.getSeconds();
	          m = checkTime(m);
	          s = checkTime(s);
	          time = h + ":" + m + ":" + s;
	          ele.html(time);
	          return t = setTimeout(_startTime, 500);
	        };
	        checkTime = function checkTime(i) {
	          if (i < 10) {
	            i = "0" + i;
	          }
	          return i;
	        };
	        return _startTime();
	      }
	    };
	  }]).directive('uiWeather', [function () {
	    return {
	      restrict: 'A',
	      link: function link(scope, ele, attrs) {
	        var color, icon, skycons;
	        color = attrs.color;
	        icon = Skycons[attrs.icon];
	        skycons = new Skycons({
	          "color": color,
	          "resizeClear": true
	        });
	        skycons.add(ele[0], icon);
	        return skycons.play();
	      }
	    };
	  }]);
	}).call(undefined);

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _segment = __webpack_require__(21);
	
	(function () {
	  angular.module('app.ui.form.ctrls').controller('ProfileCtrl', ['$scope', '$http', '$location', '$log', '$upload', '$element', 'sharedProperties', 'currentLawyer', '$modal', 'usSpinnerService', 'logger', '$cookies', '$window', '$anchorScroll', '$filter', 'userService', 'accountPermission', '$timeout', function ($scope, $http, $location, $log, $upload, $element, sharedProperties, currentLawyer, $modal, usSpinnerService, logger, $cookies, $window, $anchorScroll, $filter, userService, accountPermission, $timeout) {
	    var applyErrorClasses;
	    var totalCvAttachedCounter;
	    $scope.startSpin = function () {
	      if (!$scope.spinneractive && !$scope.recordFetched) {
	        usSpinnerService.spin('spinner-2');
	        $scope.spinneractive = true;
	        $scope.startcounter++;
	      }
	    };
	
	    $scope.stopSpin = function () {
	      if ($scope.spinneractive) {
	        usSpinnerService.stop('spinner-2');
	        $scope.spinneractive = false;
	      }
	    };
	
	    function determineElementToEdit(elementId) {
	      switch (elementId) {
	        case 'select-jurisdiction':
	          return 'jurisdiction';
	        case 'edit-jurisdiction':
	          return 'jurisdiction';
	        case 'select-practices':
	          return 'practice';
	        case 'edit-practices':
	          return 'practice';
	        case 'select-locations':
	          return 'location';
	        case 'edit-locations':
	          return 'location';
	        default:
	          return '';
	      }
	    }
	
	    $scope.showPracticeTick = false;
	    $scope.showLocationsTick = false;
	    $scope.showCategoryTick = false;
	    $scope.showjurisdictionTick = false;
	    $scope.hidePQE = false;
	    $scope.editJurisdictions = false;
	    $scope.editPractices = false;
	    $scope.editLocations = false;
	    $scope.lawyerData = {};
	    $scope.jurisdictions = [];
	    $scope.Class = '';
	    $scope.newUser = true;
	    $scope.lawyerPractices = [];
	    $scope.lawyerLocations = [];
	    $scope.lawyerJurisdictions = [];
	    $scope.isCVAdded = false;
	    $scope.loggedInLawyer = {
	      user: {
	        first_Name: $cookies.firstName,
	        last_Name: $cookies.lastName
	      },
	      lawyer: {}
	    };
	    $scope.areas = [];
	    $scope.refPractices = [];
	    $scope.categories = [];
	    $scope.locations = [];
	    $scope.other = '';
	    $scope.requestBtnCaption = 'Request Access';
	    $scope.jurisdictionLabel = 'In which jurisdictions are you qualified?*';
	    $scope.pqeLabel = 'Date commenced practice (date of qualification or, if you are a trainee, expected date of qualification)*';
	    $scope.linkedInRequired = true;
	    $scope.cvRequired = true;
	    $scope.modalData = {
	      element: '',
	      data: []
	    };
	
	    $scope.currentEmpErrorClass = '';
	    $scope.universityErrorClass = '';
	    $scope.nationalityErrorClass = '';
	    $scope.currLocationErrorClass = '';
	    $scope.contactNumberErrorClass = '';
	
	    $scope.pqeErrorClass = '';
	    $scope.jurisdictionsErrorClass = '';
	    $scope.practicesErrorClass = '';
	    $scope.locationsErrorClass = '';
	    $scope.regNumberErrorClass = '';
	    $scope.cvErrorClass = '';
	    $scope.requestAccessClass = 'btn btn-lg btn-info disabled';
	    $scope.canEditNewbeeProfile = function () {
	      return accountPermission.canNotEditNewUserProfile($scope.user);
	    };
	
	    $scope.profileValidation = function () {
	      var count;
	      count = 0;
	      if ($scope.lawyerData.currentEmp) {
	        count++;
	      }
	
	      if ($scope.lawyerData.university) {
	        count++;
	      }
	
	      if ($scope.lawyerData.nationality) {
	        count++;
	      }
	
	      if ($scope.lawyerData.currentLocation) {
	        count++;
	      }
	
	      if ($scope.lawyerData.lawyer_phone) {
	        count++;
	      }
	
	      if ($scope.lawyerData.pqe) {
	        count++;
	      }
	
	      if ($scope.editJurisdictions) {
	        count++;
	      }
	
	      if ($scope.editPractices) {
	        count++;
	      }
	
	      if ($scope.editLocations) {
	        count++;
	      }
	
	      if (count === 9 && !$scope.loggedInLawyer.isAdmin && $scope.newUser) {
	        return $scope.requestAccessClass = 'btn btn-lg btn-info';
	      }
	
	      return $scope.requestBtnCaption === 'Access Requested' ? $scope.requestAccessClass = 'btn btn-lg btn-info disabled' : $scope.requestAccessClass = 'btn btn-lg btn-info';
	    };
	
	    $scope.connectToLinkedIn = function () {
	      (0, _segment.signUpLinkedInConnect)();
	      $window.location.href = 'https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=77np1itngwj5tl&redirect_uri=' + ("https://api.lexstep.com") + '/auth/linkedin/callback&state=fooobar&scope=r_liteprofile%20r_emailaddress';
	      // $window.location.href = `${process.env.LEXSTEP_URL}/api/linkedin-auth`
	    };
	
	    $scope.pqeChanged = function () {
	      $scope.pqeErrorClass = '';
	      $scope.lawyerData.user_ID = $scope.loggedInLawyer.user.user_ID;
	      $scope.lawyerData.tempPqe = angular.copy(new Date(new Date($scope.lawyerData.pqe).setMonth($scope.lawyerData.pqe.getMonth() + 1)));
	      $http.post('/api/select-lawyer-pqe', $scope.lawyerData, {
	        contentType: 'application/json'
	      }).then(function (_ref) {
	        var data = _ref.data,
	            status = _ref.status,
	            headers = _ref.headers,
	            config = _ref.config;
	
	        var message;
	        message = 'Your PQE has been saved successfully';
	      }, function (error) {});
	      $scope.profileValidation();
	    };
	
	    var currentEmpUpdateInProgress = false;
	    $scope.currentEmpChanged = function () {
	      if (!currentEmpUpdateInProgress) {
	        currentEmpUpdateInProgress = true;
	        $timeout(function () {
	          var temporaryEmployer = {};
	          if ($scope.lawyerData.currentEmp && $scope.lawyerData.currentEmp.firm_ID) {
	            temporaryEmployer.firm_name = $scope.lawyerData.currentEmp.user.firm_Name;
	            temporaryEmployer.ref_firm_ID = $scope.lawyerData.currentEmp.firm_ID;
	          } else {
	            temporaryEmployer.firm_name = $scope.lawyerData.currentEmp;
	            temporaryEmployer.ref_firm_ID = null;
	          }
	
	          $scope.lawyerData.employer = temporaryEmployer;
	          temporaryEmployer.user_ID = $scope.loggedInLawyer.user.user_ID;
	          if (temporaryEmployer.firm_name !== void 0) {
	            $http.post('/api/select-lawyer-currentEmp', temporaryEmployer, {
	              contentType: 'application/json'
	            }).then(function (_ref2) {
	              var data = _ref2.data,
	                  status = _ref2.status,
	                  headers = _ref2.headers,
	                  config = _ref2.config;
	
	              var message;
	              message = 'Your current employer has been saved successfully';
	              currentEmpUpdateInProgress = false;
	            }, function (error) {});
	          } else {
	            currentEmpUpdateInProgress = false;
	          }
	        }, 500);
	      }
	    };
	
	    var universityUpdateInProgress = false;
	    $scope.universityChanged = function () {
	      if (!universityUpdateInProgress) {
	        universityUpdateInProgress = true;
	        $timeout(function () {
	          $scope.lawyerData.user_ID = $scope.loggedInLawyer.user.user_ID;
	          if ($scope.lawyerData.university !== void 0) {
	            $http.post('/api/select-lawyer-university', $scope.lawyerData, {
	              contentType: 'application/json'
	            }).then(function (_ref3) {
	              var data = _ref3.data,
	                  status = _ref3.status,
	                  headers = _ref3.headers,
	                  config = _ref3.config;
	
	              var message;
	              message = 'Your University has been saved successfully';
	              universityUpdateInProgress = false;
	            }, function (error) {});
	          }
	        }, 500);
	      }
	    };
	
	    $scope.degreeDateChanged = function () {
	      $scope.lawyerData.user_ID = $scope.loggedInLawyer.user.user_ID;
	      if ($scope.lawyerData.degree_date !== void 0) {
	        $http.post('/api/select-lawyer-degree_date', $scope.lawyerData, {
	          contentType: 'application/json'
	        }).then(function (_ref4) {
	          var data = _ref4.data,
	              status = _ref4.status,
	              headers = _ref4.headers,
	              config = _ref4.config;
	
	          var message;
	          message = 'Your Degree completion date has been saved successfully';
	        }, function (error) {});
	      }
	    };
	
	    $scope.nationalityChanged = function () {
	      $scope.lawyerData.user_ID = $scope.loggedInLawyer.user.user_ID;
	      if ($scope.lawyerData.nationality !== void 0) {
	        $http.post('/api/select-lawyer-nationality', $scope.lawyerData, {
	          contentType: 'application/json'
	        }).then(function (_ref5) {
	          var data = _ref5.data,
	              status = _ref5.status,
	              headers = _ref5.headers,
	              config = _ref5.config;
	
	          var message;
	          message = 'Your nationality has been saved successfully';
	        }, function (error) {});
	      }
	    };
	
	    $scope.currentLocationChanged = function () {
	      $scope.lawyerData.user_ID = $scope.loggedInLawyer.user.user_ID;
	      if ($scope.lawyerData.currentLocation !== void 0) {
	        $http.post('/api/select-lawyer-current-location', $scope.lawyerData, {
	          contentType: 'application/json'
	        }).then(function (_ref6) {
	          var data = _ref6.data,
	              status = _ref6.status,
	              headers = _ref6.headers,
	              config = _ref6.config;
	
	          var message;
	          message = 'Your current location has been saved successfully';
	        }, function (error) {});
	      }
	    };
	
	    $scope.phoneNumberChanged = function () {
	      $scope.lawyerData.user_ID = $scope.loggedInLawyer.user.user_ID;
	      if ($scope.lawyerData.lawyer_phone !== void 0) {
	        $http.post('/api/select-lawyer-phone', $scope.lawyerData, {
	          contentType: 'application/json'
	        }).then(function (_ref7) {
	          var data = _ref7.data,
	              status = _ref7.status,
	              headers = _ref7.headers,
	              config = _ref7.config;
	
	          var message;
	          message = 'Your phone number has been saved successfully';
	        }, function (error) {});
	      }
	    };
	
	    $scope.sraIdChanged = function () {
	      $scope.lawyerData.user_ID = $scope.loggedInLawyer.user.user_ID;
	      if ($scope.lawyerData.regNumber !== void 0) {
	        $scope.regNumberErrorClass = '';
	        $http.post('/api/select-lawyer-sraId', $scope.lawyerData, {
	          contentType: 'application/json'
	        }).then(function (_ref8) {
	          var data = _ref8.data,
	              status = _ref8.status,
	              headers = _ref8.headers,
	              config = _ref8.config;
	
	          var message;
	          message = 'Your current location has been saved successfully';
	        }, function (error) {});
	      }
	    };
	
	    $scope.linkedInURLChanged = function () {
	      if ($scope.lawyerData.linkedInURL !== void 0 && $scope.lawyerData.linkedInURL !== '') {
	        $http.post('/api/select-lawyer-linkedIn', $scope.lawyerData, {
	          contentType: 'application/json'
	        }).then(function (_ref9) {
	          var data = _ref9.data,
	              status = _ref9.status,
	              headers = _ref9.headers,
	              config = _ref9.config;
	
	          var message;
	          $scope.linkedInRequired = false;
	          message = 'Your current linkedIn profile link has been saved successfully';
	        }, function (error) {});
	      } else {
	        $scope.linkedInRequired = true;
	      }
	    };
	
	    $scope.requiresSponsorshipChanged = function () {
	      $scope.lawyerData.user_ID = $scope.loggedInLawyer.user.user_ID;
	      if ($scope.lawyerData.reqSponsorship !== void 0) {
	        $http.post('/api/select-lawyer-sponsorship', $scope.lawyerData, {
	          contentType: 'application/json'
	        }).then(function (_ref10) {
	          var data = _ref10.data,
	              status = _ref10.status,
	              headers = _ref10.headers,
	              config = _ref10.config;
	
	          var message;
	          message = 'Your sponsorship status has been saved successfully';
	        }, function (error) {});
	      }
	    };
	
	    $scope.fetchLawyerData = function () {
	      $http.post('/api/fetch-lawyer-locations', {
	        id: $scope.loggedInLawyer.lawyer.lawyer_ID
	      }).then(function (_ref11) {
	        var data = _ref11.data,
	            status = _ref11.status,
	            headers = _ref11.headers,
	            config = _ref11.config;
	
	        $scope.lawyerLocations = data;
	        $scope.mapLocations();
	      }, function (_ref12) {
	        var data = _ref12.data,
	            status = _ref12.status;
	
	        if (status === 440) {
	          $location.url('/signin');
	        }
	      });
	      $http.post('/api/fetch-lawyer-practices', {
	        id: $scope.loggedInLawyer.lawyer.lawyer_ID
	      }).then(function (_ref13) {
	        var data = _ref13.data,
	            status = _ref13.status,
	            headers = _ref13.headers,
	            config = _ref13.config;
	
	        $scope.lawyerPractices = data;
	        $scope.mapPractices();
	      }, function (_ref14) {
	        var data = _ref14.data,
	            status = _ref14.status;
	
	        if (status === 440) {
	          $location.url('/signin');
	        }
	      });
	      $http.post('/api/fetch-lawyer-jurisdictions', {
	        id: $scope.loggedInLawyer.lawyer.lawyer_ID
	      }).then(function (_ref15) {
	        var data = _ref15.data,
	            status = _ref15.status,
	            headers = _ref15.headers,
	            config = _ref15.config;
	
	        $scope.lawyerJurisdictions = data;
	        $scope.mapJurisdictions();
	      }, function (_ref16) {
	        var data = _ref16.data,
	            status = _ref16.status;
	
	        if (status === 440) {
	          $location.url('/signin');
	        }
	      });
	    };
	
	    $scope.mapLocations = function () {
	      $scope.locations = [];
	      $scope.refLocations.forEach(function (loc) {
	        return $scope.lawyerLocations.forEach(function (lLoc) {
	          if (lLoc.refLocationLocID === loc.loc_ID) {
	            loc.isSelected = true;
	            $scope.showLocationsTick = true;
	            $scope.editLocations = true;
	            if (!loc.hasChild) {
	              return $scope.locations.push(loc);
	            }
	          }
	        });
	      });
	      $scope.lawyerLocations.forEach(function (lawyerloc, index, array) {
	        return $scope.nrefLocations.forEach(function (refloc, index, array) {
	          if (lawyerloc.loc_ID === refloc.loc_ID) {
	            refloc.isSelected = true;
	            if (!refloc.hasChild) {
	              $scope.locations.push(refloc);
	            }
	
	            if (refloc.hasChild) {
	              if (refloc.locations) {
	                refloc.locations.forEach(function (loc, index, array) {
	                  if (loc.hasChild) {
	                    return loc.sub_areas.forEach(function (sub, index, array) {
	                      return $scope.refLocations.push(sub);
	                    });
	                  }
	
	                  return $scope.refLocations.push(loc);
	                });
	              } else if (refloc.sub_areas) {
	                refloc.sub_areas.forEach(function (sub, index, array) {
	                  return $scope.refLocations.push(sub);
	                });
	              }
	            } else {
	              $scope.refLocations.push(refloc);
	            }
	          }
	        });
	      });
	    };
	
	    $scope.areasToShow = [];
	    $scope.mapPractices = function () {
	      $scope.lawyerPractices.forEach(function (lawyer_area, index, array) {
	        $scope.areas.forEach(function (area, index, array) {
	          if (lawyer_area.refPracticePracticeID === area.practice_ID) {
	            lawyer_area.practice_name = area.practice_name;
	            lawyer_area.law_area = area.law_area;
	            lawyer_area.hasChild = area.hasChild;
	            if (lawyer_area.isSelected) {
	              area.isSelected = true;
	              $scope.editPractices = true;
	              $scope.showPracticeTick = true;
	            }
	          }
	        });
	      });
	      $scope.profileValidation();
	    };
	
	    $scope.mapJurisdictions = function () {
	      $scope.lawyerJurisdictions.forEach(function (lawyer_juri, index, array) {
	        $scope.locations.forEach(function (location, index, array) {
	          if (lawyer_juri.refJurisdictionLocID === location.loc_ID) {
	            lawyer_juri.loc_name = location.loc_name;
	            lawyer_juri.isSelected = true;
	          }
	        });
	        $scope.jurisdictions.forEach(function (juri, index, array) {
	          if (lawyer_juri.refJurisdictionLocID === juri.loc_ID) {
	            juri.isSelected = true;
	            $scope.editJurisdictions = true;
	            $scope.showjurisdictionTick = true;
	          }
	        });
	      });
	      $scope.other = $scope.loggedInLawyer.lawyer.other_Jurisdictions;
	      if ($scope.other) {
	        $scope.editJurisdictions = true;
	        $scope.showjurisdictionTick = true;
	      }
	
	      $scope.isEnglandWalesSelected = _.findWhere($scope.jurisdictions, {
	        loc_ID: 20
	      }).isSelected;
	      $scope.profileValidation();
	    };
	
	    $scope.jumpToLink = function (id) {
	      var oldHash;
	      oldHash = $location.hash();
	      $location.hash(id);
	      $anchorScroll();
	      $location.hash(oldHash);
	    };
	
	    $scope.populateLawyerDate = function () {
	      $scope.lawyerData.currentEmp = angular.copy($scope.loggedInLawyer.lawyer.lawyer_currentEmp);
	      $scope.lawyerData.university = angular.copy($scope.loggedInLawyer.lawyer.university);
	      $scope.lawyerData.nationality = angular.copy($scope.loggedInLawyer.lawyer.nationality);
	      $scope.lawyerData.currentLocation = angular.copy($scope.loggedInLawyer.lawyer.currentLocation);
	      $scope.lawyerData.reqSponsorship = angular.copy($scope.loggedInLawyer.lawyer.reqSponsorship);
	      $scope.lawyerData.lawyer_phone = angular.copy($scope.loggedInLawyer.lawyer.lawyer_phone);
	      $scope.lawyerData.pqe = angular.copy($scope.loggedInLawyer.lawyer.PQE);
	      $scope.lawyerData.regNumber = angular.copy($scope.loggedInLawyer.lawyer.lawyer_regNumber);
	      $scope.lawyerData.linkedInURL = angular.copy($scope.loggedInLawyer.lawyer.linkedInURL);
	      $scope.lawyerData.linkedInData = angular.copy($scope.loggedInLawyer.lawyer.linkedInData);
	      $scope.selectedFile = $scope.loggedInLawyer.user.user_CV;
	      $scope.fetchLawyerData();
	      $scope.cvRequired = !$scope.selectedFile;
	      if ($scope.hasLawyerAppliedForApproval) {
	        if ($scope.lawyerStatus === 'Approved') {
	          $scope.refreshUser();
	          $location.url($scope.loggedInLawyer.isAdmin ? '/admin/lawyer-profile' : '/user-profile');
	        }
	
	        $scope.newUser = $scope.lawyerStatus === 'NewUser';
	        $scope.requestBtnCaption = $scope.newUser ? 'Request Access' : 'Access Requested';
	      } else {
	        $scope.newUser = true;
	      }
	
	      $scope.profileValidation();
	    };
	
	    if ($location.search().user) {
	      $http.post('/api/fetch-lawyer-by-referral-code', { user: $location.search().user }, {
	        contentType: 'application/json'
	      }).then(function (_ref17) {
	        var data = _ref17.data,
	            status = _ref17.status,
	            headers = _ref17.headers,
	            config = _ref17.config;
	
	        $scope.lawyerStatus = data.lawyer.lawyer_Status;
	        $scope.hasLawyerAppliedForApproval = data.lawyer.hasApplied;
	        $scope.loggedInLawyer = data;
	        $scope.populateLawyerDate();
	      }, function (_ref18) {
	        var data = _ref18.data,
	            status = _ref18.status;
	
	        if (status === 440) {
	          $location.url('/signin');
	        }
	      });
	    } else {
	      $http.post('/api/fetch-current-lawyer', {
	        contentType: 'application/json'
	      }).then(function (_ref19) {
	        var data = _ref19.data,
	            status = _ref19.status,
	            headers = _ref19.headers,
	            config = _ref19.config;
	
	        $scope.lawyerStatus = data.lawyer.lawyer_Status;
	        $scope.hasLawyerAppliedForApproval = data.lawyer.hasApplied;
	        $scope.loggedInLawyer = data;
	        $scope.populateLawyerDate();
	      }, function (_ref20) {
	        var data = _ref20.data,
	            status = _ref20.status;
	
	        if (status === 440) {
	          $location.url('/signin');
	        }
	      });
	    }
	
	    $scope.lawyerPractices = [];
	    $scope.lawyerLocations = [];
	    $scope.lawyerJurisdictions = [];
	    $scope.loggedInLawyer = {};
	    $scope.areas = [];
	    $scope.categories = [];
	    $scope.locations = [];
	    $scope.nrefLocations = [];
	    $scope.selectedFile = '';
	    totalCvAttachedCounter = 1;
	    $scope.upload = function (files) {
	      var file;
	      var fileFlag;
	      var fileType;
	      var index;
	      var indexConvert;
	      var indexFileSize;
	      var modifiedFileName;
	      var sFileExtension;
	      var sFileName;
	      if (files && files.length) {
	        index = 0;
	        fileType = '';
	        fileFlag = 1;
	        $scope.imgSrc = '';
	        this.uploadURL = '';
	        while (index < files.length) {
	          file = files[index];
	          sFileName = file.name;
	          modifiedFileName = sFileName;
	          sFileExtension = sFileName.split('.')[sFileName.split('.').length - 1].toLowerCase();
	          if (totalCvAttachedCounter > 1) {
	            $scope.selectedFile = sharedProperties.setCVName($scope.loggedInLawyer.user.first_Name, $scope.loggedInLawyer.user.last_Name, $scope.loggedInLawyer.user.cv_counter) + '_' + totalCvAttachedCounter + '.' + sFileExtension;
	          } else {
	            $scope.selectedFile = sharedProperties.setCVName($scope.loggedInLawyer.user.first_Name, $scope.loggedInLawyer.user.last_Name, $scope.loggedInLawyer.user.cv_counter) + '.' + sFileExtension;
	          }
	
	          indexFileSize = file.size;
	          indexConvert = (file.size / 1048576).toFixed(2);
	          if (sFileExtension === 'pdf' || sFileExtension === 'doc' || sFileExtension === 'docx') {
	            fileType = 'resume';
	            this.uploadURL = '/api/upload-cv-before-approval';
	            modifiedFileName = totalCvAttachedCounter > 1 ? sharedProperties.setCVName($scope.loggedInLawyer.user.first_Name, $scope.loggedInLawyer.user.last_Name, $scope.loggedInLawyer.user.cv_counter) + '_' + totalCvAttachedCounter + '.' + sFileExtension : sharedProperties.setCVName($scope.loggedInLawyer.user.first_Name, $scope.loggedInLawyer.user.last_Name, $scope.loggedInLawyer.user.cv_counter) + '.' + sFileExtension;
	
	            totalCvAttachedCounter += 1;
	            fileFlag = 1;
	            $scope.startSpin('spinner-2');
	          } else {
	            $scope.selectedFile = null;
	            logger.notify('error', 'Incorrect format selection. Please try again.');
	            return false;
	          }
	
	          $upload.upload({
	            url: '/api/upload-cv-before-approval',
	            data: {
	              id: $scope.loggedInLawyer.user.user_ID,
	              name: fileType + '.' + sFileExtension,
	              modifiedFileName: modifiedFileName
	            },
	            file: file,
	            sendObjectsAsJsonBlob: false
	          }).progress(function (event_) {
	            var progressPercentage;
	            progressPercentage = Number.parseInt(100 * event_.loaded / event_.total);
	          }).then(function (_ref21) {
	            var data = _ref21.data,
	                status = _ref21.status,
	                headers = _ref21.headers,
	                config = _ref21.config;
	
	            if (fileFlag === 1) {
	              (0, _segment.signUpCVUpload)();
	            }
	
	            $scope.isCVAdded = true;
	            $scope.cvRequired = false;
	            $scope.loggedInLawyer.user.user_CV = $scope.selectedFile;
	            $scope.stopSpin('spinner-2');
	            if (!fileFlag) {
	              $http.post('/api/get-profile-pic', {
	                id: $scope.loggedInLawyer.user.user_ID
	              }).then(function (_ref22) {
	                var data = _ref22.data,
	                    status = _ref22.status,
	                    headers = _ref22.headers,
	                    config = _ref22.config;
	
	                if (data && data.contains('https') == true) {
	                  $scope.picSrc = data;
	                } else $scope.picSrc = sharedProperties.getImgSrc(data, $scope.loggedInLawyer.user.user_ID, true);
	              }, function (_ref23) {
	                var data = _ref23.data,
	                    status = _ref23.status;
	
	                if (status === 440) {
	                  $location.url('/signin');
	                }
	              });
	            }
	          });
	          index++;
	        }
	      }
	    };
	
	    this.logOut = function () {
	      sharedProperties.logOut();
	    };
	
	    this.referFriend = function () {
	      $location.url('/refer-friend');
	    };
	
	    this.firmsAndJobs = function () {
	      $location.url('/opportunities');
	    };
	
	    this.loadProfile = function () {
	      $location.url('/profile');
	    };
	
	    $scope.openModal = function (event) {
	      var id;
	      var modalInstance;
	      id = event.target.attributes.id.value;
	      $scope.modalData = {
	        displayNextFunctionality: true,
	        element: '',
	        data: []
	
	        // Determine Whether the change being made is for either jurisdictions, locations or practice areas
	      };if (_.include(['select-locations', 'select-practices', 'select-jurisdiction', 'edit-jurisdiction', 'edit-practices', 'edit-locations'], id)) {
	        // Set required values in order to update jurisdictions, locations and practice areas
	        angular.extend($scope.modalData, {
	          element: determineElementToEdit(id),
	          data: {
	            locations: angular.copy($scope.nrefLocations),
	            practiceAreas: angular.copy($scope.refPractices),
	            jurisdictions: angular.copy($scope.jurisdictions)
	          },
	          linearPractices: angular.copy($scope.areasToShow),
	          otherJurisdictions: !_.isEmpty($scope.other) ? $scope.other : ''
	        });
	      } else if (id === 'select-categories') {
	        $scope.modalData.element = 'category';
	        $scope.tempCategories = angular.copy($scope.categories);
	        $scope.modalData.data = $scope.tempCategories;
	      }
	
	      modalInstance = $modal.open({
	        templateUrl: 'ModalScript.html',
	        controller: 'CreateProfileModalCtrl',
	        backdrop: 'static',
	        keyboard: false,
	        resolve: {
	          data: function data() {
	            return $scope.modalData;
	          }
	        }
	      });
	      return modalInstance.result.then(function (selectedItem) {
	        // Determine Whether the change was made for either of the two
	        // locations or practice areas
	        if (_.include(['practice', 'location', 'jurisdiction'], selectedItem.element)) {
	          // 'practice' added in condition only for the sake of understanding
	          // its not that the returning element property will contain this string
	          // because of the Next button feature for locations and Practice Areas
	          // will always be 'location'
	
	          // Update Jurisdictions If User changed them
	          if (!_.isEmpty(selectedItem.jurisdictions)) {
	            updateselectedJurisdictions({
	              currentLawyer: $scope.loggedInLawyer.user && $scope.loggedInLawyer.user.user_ID,
	              updated_data: selectedItem.jurisdictions,
	              otherJurisdictions: !_.isEmpty(selectedItem.otherJurisdictions) ? selectedItem.otherJurisdictions : ''
	            });
	          }
	
	          // Update Practice areas If User changed them
	          if (!_.isEmpty(selectedItem.linearPractices)) updateSeletedPractices({
	            currentLawyer: $scope.loggedInLawyer.lawyer && $scope.loggedInLawyer.lawyer.lawyer_ID,
	            updated_data: selectedItem.practiceAreas,
	            linearPractices: selectedItem.linearPractices
	          });
	
	          // Update Locations If User changed them
	          if (!_.isEmpty(selectedItem.locations)) updateSeletedLocations({
	            currentLawyer: $scope.loggedInLawyer.lawyer && $scope.loggedInLawyer.lawyer.lawyer_ID,
	            updated_data: selectedItem.locations
	          });
	        } else if (selectedItem.element === 'category') {
	          $scope.tempCategories = angular.copy(selectedItem.data);
	          $scope.requestedData = {
	            currentLawyer: $scope.loggedInLawyer.user.user_ID,
	            updated_data: angular.copy($scope.tempCategories)
	          };
	          $scope.selectCategories($scope.requestedData);
	        }
	      }, function () {
	        $scope.profileValidation();
	        $scope.tempJurisdictions = {};
	      });
	    };
	
	    function updateselectedJurisdictions(request) {
	      var count = 0;
	      var message = '';
	      $scope.isEnglandWalesSelected = _.findWhere(request.updated_data, {
	        loc_ID: 20
	      }).isSelected;
	      $scope.selectedJurisdictions = [];
	
	      request.updated_data.forEach(function (jurisdiction) {
	        if (jurisdiction.isSelected) {
	          count++;
	          $scope.selectedJurisdictions.push(jurisdiction.loc_name);
	        }
	      });
	
	      request.otherJurisdictions && $scope.selectedJurisdictions.push(request.otherJurisdictions);
	
	      if (count > 0 || request.otherJurisdictions) {
	        $http.post('/api/select-lawyer-jurisdictions', request, {
	          contentType: 'application/json'
	        }).then(function (_ref24) {
	          var data = _ref24.data,
	              status = _ref24.status,
	              headers = _ref24.headers,
	              config = _ref24.config;
	
	          $scope.jurisdictions = request.updated_data;
	
	          $http.post('/api/select-lawyer-otherJurisdictions', request, {
	            contentType: 'application/json'
	          }).then(function (_ref25) {
	            var data = _ref25.data,
	                status = _ref25.status,
	                headers = _ref25.headers,
	                config = _ref25.config;
	
	            $scope.other = request.otherJurisdictions;
	            $scope.showjurisdictionTick = true;
	            $scope.editJurisdictions = true;
	            $scope.profileValidation();
	          }, function (error) {});
	        }, function (error) {});
	      } else {
	        logger.notify('error', 'This is a required field, you need to provide at least one jurisdiction.');
	      }
	
	      $scope.profileValidation();
	    }
	
	    function updateSeletedLocations(request) {
	      var count;
	      var message;
	      count = 0;
	      request.updated_data.forEach(function (location, index, array) {
	        if (location.isSelected) {
	          location.locations.forEach(function (loc, index, array) {
	            if (loc.isSelected) {
	              count++;
	              loc.sub_areas.forEach(function (sub, index, array) {
	                if (sub.isSelected) {
	                  count++;
	                }
	              });
	            }
	          });
	        }
	      });
	      request.currentLawyer = $scope.loggedInLawyer.lawyer.lawyer_ID;
	      if (count > 0) {
	        $http.post('/api/update-lawyer-locations', request, {
	          contentType: 'application/json'
	        }).then(function (_ref26) {
	          var data = _ref26.data,
	              status = _ref26.status,
	              headers = _ref26.headers,
	              config = _ref26.config;
	
	          $scope.locations = [];
	          $scope.nrefLocations = angular.copy(request.updated_data);
	          request.updated_data.forEach(function (location, index, array) {
	            if (location.isSelected) {
	              location.locations.forEach(function (loc, index, array) {
	                if (loc.isSelected) {
	                  if (!loc.hasChild) {
	                    $scope.locations.push(loc);
	                  }
	
	                  loc.sub_areas.forEach(function (sub, index, array) {
	                    if (sub.isSelected) {
	                      $scope.locations.push(sub);
	                    }
	                  });
	                }
	              });
	            }
	          });
	          $scope.showLocationsTick = true;
	          $scope.editLocations = true;
	          $scope.profileValidation();
	        }, function (error) {});
	      } else {
	        $scope.profileValidation();
	        message = 'This is a required field, you have to choose at least one location.';
	        logger.notify('error', message);
	      }
	    }
	
	    $scope.selectCategories = function (request) {
	      var count;
	      var message;
	      count = 0;
	      request.updated_data.forEach(function (category, index, array) {
	        if (category.isSelected) {
	          count++;
	        }
	      });
	      if (count > 0) {
	        $http.post('/api/select-lawyer-categories', request, {
	          contentType: 'application/json'
	        }).then(function (_ref27) {
	          var data = _ref27.data,
	              status = _ref27.status,
	              headers = _ref27.headers,
	              config = _ref27.config;
	
	          var message;
	          $scope.category = angular.copy(request.updated_data);
	          message = 'Your Firm Categories have been saved successfully';
	          $scope.showCategoryTick = true;
	        }, function (error) {});
	      } else {
	        message = 'This is a required field, you have to choose at least one firm type.';
	        logger.notify('error', message);
	      }
	    };
	
	    function updateSeletedPractices(request) {
	      var count;
	      var message;
	      count = 0;
	      $scope.selectedPracAreas = [];
	      request.linearPractices.forEach(function (practice, index, array) {
	        if (practice.isSelected) {
	          count++;
	          if (practice.hasChild === false) {
	            $scope.selectedPracAreas.push(practice.practice_name);
	          }
	        }
	      });
	      if (count > 0) {
	        $http.post('/api/select-lawyer-practices', request, {
	          contentType: 'application/json'
	        }).then(function (_ref28) {
	          var data = _ref28.data,
	              status = _ref28.status,
	              headers = _ref28.headers,
	              config = _ref28.config;
	
	          $scope.areas = angular.copy(request.linearPractices);
	          $scope.areasToShow = angular.copy(request.linearPractices);
	          $scope.refPractices = angular.copy(request.updated_data);
	          $scope.showPracticeTick = true;
	          $scope.editPractices = true;
	          $scope.profileValidation();
	        }, function (error) {});
	      } else {
	        message = 'This is a required field, you have to choose at least one practice area.';
	        logger.notify('error', message);
	      }
	
	      $scope.profileValidation();
	    }
	
	    $scope.applyForApproval = function () {
	      $scope.requestAccessClass = 'btn btn-lg btn-info disabled';
	      var message;
	      if (!$scope.lawyerData.employer) {
	        $scope.lawyerData.employer = {
	          firm_name: $scope.loggedInLawyer.lawyer.lawyer_currentEmp,
	          ref_firm_ID: $scope.loggedInLawyer.lawyer.firmFirmID
	        };
	      }
	
	      if ($scope.validateForm()) {
	        if ($scope.lawyerData.pqe === '' || $scope.lawyerData.pqe === null || typeof $scope.lawyerData.pqe === 'undefined') {
	          $scope.pqeErrorClass = 'input-error';
	          message = 'Please complete all fields before requesting access';
	          logger.notify('error', message);
	        } else {
	          $scope.counter = 0;
	
	          if ($scope.cvRequired) {
	            $scope.counter++;
	          }
	
	          if ($scope.lawyerData.linkedInURL === '' || $scope.lawyerData.linkedInURL === null || typeof $scope.lawyerData.linkedInURL === 'undefined') {
	            $scope.counter++;
	          }
	
	          if ($scope.lawyerData.linkedInData === '' || $scope.lawyerData.linkedInData === null || typeof $scope.lawyerData.linkedInData === 'undefined') {
	            $scope.counter++;
	          }
	
	          if ($scope.lawyerData.regNumber === '' || $scope.lawyerData.regNumber === null || typeof $scope.lawyerData.regNumber === 'undefined' || !$scope.isEnglandWalesSelected) {
	            $scope.counter++;
	          }
	
	          if ($scope.counter < 4) {
	            $scope.newUser = false;
	            $scope.lawyerData.lawyer_ID = $scope.loggedInLawyer.lawyer.lawyer_ID;
	            var request = {
	              university: $scope.lawyerData.university,
	              nationality: $scope.lawyerData.nationality,
	              currentLocation: $scope.lawyerData.currentLocation,
	              lawyer_phone: $scope.lawyerData.lawyer_phone,
	              pqe: $scope.lawyerData.pqe,
	              regNumber: $scope.lawyerData.regNumber,
	              linkedInURL: $scope.lawyerData.linkedInURL,
	              employer: $scope.lawyerData.employer,
	              user_ID: $scope.lawyerData.user_ID,
	              tempPqe: $scope.lawyerData.tempPqe,
	              lawyer_ID: $scope.lawyerData.lawyer_ID
	            };
	
	            (0, _segment.signUpRequestAccess)($scope.lawyerData.nationality, $scope.lawyerData.currentLocation, $scope.lawyerData.lawyer_phone, $scope.lawyerData.pqe, $scope.selectedJurisdictions, $scope.selectedPracAreas, $scope.isEnglandWalesSelected || false, Boolean($scope.lawyerData.linkedInURL), $scope.isCVAdded);
	
	            // $http.post('/api/apply-for-approval', $scope.lawyerData, {
	            $http.post('/api/apply-for-approval', request, {
	              contentType: 'application/json'
	            }).then(function (_ref29) {
	              var data = _ref29.data,
	                  status = _ref29.status,
	                  headers = _ref29.headers,
	                  config = _ref29.config;
	
	              message = 'Your request has been sent to admin for Approval';
	
	              $scope.requestAccessClass = 'btn btn-lg btn-info disabled';
	
	              $scope.newUser = false;
	              $http.post('/api/fetch-current-lawyer', {
	                contentType: 'application/json'
	              }).then(function (_ref30) {
	                var data = _ref30.data,
	                    status = _ref30.status,
	                    headers = _ref30.headers,
	                    config = _ref30.config;
	
	                $scope.requestBtnCaption = 'Access Requested';
	                $scope.loggedInLawyer = data;
	                $scope.fetchLawyerData();
	              }, function (_ref31) {
	                var data = _ref31.data,
	                    status = _ref31.status;
	
	                $scope.newUser = true;
	                if (status === 440) {
	                  $location.url('/signin');
	                }
	              });
	            }, function (error) {
	              $scope.requestAccessClass = 'btn btn-lg btn-info';
	              return $scope.newUser = true;
	            });
	          } else {
	            $scope.regNumberErrorClass = 'input-error';
	            message = 'Please complete all fields before requesting access';
	            $scope.requestAccessClass = 'btn btn-lg btn-info';
	            logger.notify('error', message);
	          }
	        }
	      } else {
	        $scope.requestAccessClass = 'btn btn-lg btn-info';
	        message = 'Please complete all fields before requesting access';
	        logger.notify('error', message);
	      }
	    };
	
	    $scope.formIsValid = function () {
	      var area_count;
	      var juri_count;
	      juri_count = 0;
	      area_count = 0;
	      if ($scope.other && $scope.other !== '') {
	        juri_count++;
	      }
	
	      $scope.jurisdictions.forEach(function (juri, index, array) {
	        if (juri.isSelected) {
	          return juri_count++;
	        }
	      });
	      $scope.areas.forEach(function (area, index, array) {
	        if (area.isSelected) {
	          return area_count++;
	        }
	      });
	      applyErrorClasses(juri_count, area_count);
	      if (area_count === 0 || juri_count === 0) {
	        return false;
	      }
	
	      return true;
	    };
	
	    $scope.validateForm = function () {
	      var isValid = true;
	      var area_count = void 0;
	      var juri_count = void 0;
	      var loc_count = void 0;
	      juri_count = 0;
	      area_count = 0;
	      loc_count = 0;
	      if ($scope.other && $scope.other !== '') {
	        juri_count++;
	      }
	
	      $scope.jurisdictions.forEach(function (juri, index, array) {
	        if (juri.isSelected) {
	          return juri_count++;
	        }
	      });
	      $scope.areas.forEach(function (area, index, array) {
	        if (area.isSelected) {
	          return area_count++;
	        }
	      });
	      applyErrorClasses(juri_count, area_count);
	
	      if (juri_count === 0 || area_count === 0) {
	        isValid = false;
	      }
	
	      if ($scope.locations.length === 0) {
	        isValid = false;
	      }
	
	      if (_.isEmpty($scope.lawyerData.currentEmp)) {
	        isValid = false;
	        $scope.currentEmpErrorClass = 'input-error';
	      }
	
	      if (_.isEmpty($scope.lawyerData.university)) {
	        isValid = false;
	        $scope.universityErrorClass = 'input-error';
	      }
	
	      if (_.isEmpty($scope.lawyerData.nationality)) {
	        isValid = false;
	        $scope.nationalityErrorClass = 'input-error';
	      }
	
	      if (_.isEmpty($scope.lawyerData.currentLocation)) {
	        isValid = false;
	        $scope.currLocationErrorClass = 'input-error';
	      }
	
	      if (_.isEmpty($scope.lawyerData.lawyer_phone)) {
	        isValid = false;
	        $scope.contactNumberErrorClass = 'input-error';
	      }
	
	      return isValid;
	    };
	
	    applyErrorClasses = function applyErrorClasses(juri_count, area_count) {
	      if ($scope.lawyerData.pqe === '' || $scope.lawyerData.pqe === null || typeof $scope.lawyerData.pqe === 'undefined') {
	        $scope.pqeErrorClass = 'input-error';
	      }
	
	      if (juri_count === 0) {
	        $scope.jurisdictionsErrorClass = 'input-error';
	      }
	
	      if (area_count === 0) {
	        $scope.practicesErrorClass = 'input-error';
	      }
	
	      if ($scope.locations.length === 0) {
	        $scope.locationsErrorClass = 'input-error';
	      }
	
	      if ($scope.cvRequired && ($scope.lawyerData.linkedInURL === '' || $scope.lawyerData.linkedInURL === null || typeof $scope.lawyerData.linkedInURL === 'undefined') && ($scope.lawyerData.regNumber === '' || $scope.lawyerData.regNumber === null || typeof $scope.lawyerData.regNumber === 'undefined' || !$scope.isEnglandWalesSelected)) {
	        $scope.cvErrorClass = 'input-error';
	      } else {
	        $scope.cvErrorClass = '';
	      }
	    };
	
	    $scope.populateCategory = function (data) {
	      $scope.categories = data;
	    };
	
	    $scope.populateLocation = function (data) {
	      $scope.lawyerLocations.forEach(function (lawyerloc, index, array) {
	        return data.forEach(function (refloc, index, array) {
	          if (lawyerloc.loc_ID === refloc.loc_ID) {
	            refloc.isSelected = true;
	          }
	        });
	      });
	      data.forEach(function (loc, index, array) {
	        if (loc.region === null && loc.area === null) {
	          loc.locations = [];
	          $scope.nrefLocations.push(loc);
	          data.forEach(function (region_area, index, array) {
	            if (region_area.region === loc.loc_ID && region_area.area === null) {
	              region_area.sub_areas = [];
	              loc.locations.push(region_area);
	              data.forEach(function (sub_area, index, array) {
	                if (sub_area.region !== null && sub_area.area === region_area.loc_ID) {
	                  region_area.sub_areas.push(sub_area);
	                }
	              });
	            }
	          });
	        }
	      });
	      $scope.refLocations = data;
	    };
	
	    $scope.areasToShow = [];
	    $http.post('/api/profile-practice-areas', {
	      contentType: 'application/json'
	    }).then(function (_ref32) {
	      var data = _ref32.data,
	          status = _ref32.status,
	          headers = _ref32.headers,
	          config = _ref32.config;
	
	      $scope.areas = data;
	      $scope.areas.forEach(function (area, index, array) {
	        $scope.areasToShow.push(area);
	        if (area.law_area === null && area.practice_area === null) {
	          area.practices = [];
	          $scope.refPractices.push(area);
	          $scope.areas.forEach(function (prac_area, index, array) {
	            if (prac_area.law_area === area.practice_ID && prac_area.practice_area === null) {
	              prac_area.sub_areas = [];
	              area.practices.push(prac_area);
	              $scope.areas.forEach(function (sub_area, index, array) {
	                if (sub_area.law_area !== null && sub_area.practice_area === prac_area.practice_ID) {
	                  prac_area.sub_areas.push(sub_area);
	                }
	              });
	            }
	          });
	        }
	      });
	    }, function (_ref33) {
	      var data = _ref33.data,
	          status = _ref33.status;
	
	      if (status === 440) {
	        $location.url('/signin');
	      }
	    });
	    $http.post('/api/profile-category', {
	      contentType: 'application/json'
	    }).then(function (_ref34) {
	      var data = _ref34.data,
	          status = _ref34.status,
	          headers = _ref34.headers,
	          config = _ref34.config;
	
	      $scope.populateCategory(data);
	    }, function (error) {
	      if (status === 440) {
	        $location.url('/signin');
	      }
	    });
	    $http.post('/api/profile-location', {
	      contentType: 'application/json'
	    }).then(function (_ref35) {
	      var data = _ref35.data,
	          status = _ref35.status,
	          headers = _ref35.headers,
	          config = _ref35.config;
	
	      $scope.populateLocation(data);
	    }, function (_ref36) {
	      var data = _ref36.data,
	          status = _ref36.status;
	
	      if (status === 440) {
	        $location.url('/signin');
	      }
	    });
	    $http.post('/api/profile-jurisdiction', {
	      contentType: 'application/json'
	    }).then(function (_ref37) {
	      var data = _ref37.data,
	          status = _ref37.status,
	          headers = _ref37.headers,
	          config = _ref37.config;
	
	      $scope.jurisdictions = data;
	    }, function (_ref38) {
	      var data = _ref38.data,
	          status = _ref38.status;
	
	      if (status === 440) {
	        $location.url('/signin');
	      }
	    });
	  }]);
	})();

/***/ }),
/* 766 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : _typeof(ex)) === 'object' && 'default' in ex ? ex.default : ex;
	}
	
	var denyList = new Set(['ENOTFOUND', 'ENETUNREACH',
	
	// SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
	'UNABLE_TO_GET_ISSUER_CERT', 'UNABLE_TO_GET_CRL', 'UNABLE_TO_DECRYPT_CERT_SIGNATURE', 'UNABLE_TO_DECRYPT_CRL_SIGNATURE', 'UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY', 'CERT_SIGNATURE_FAILURE', 'CRL_SIGNATURE_FAILURE', 'CERT_NOT_YET_VALID', 'CERT_HAS_EXPIRED', 'CRL_NOT_YET_VALID', 'CRL_HAS_EXPIRED', 'ERROR_IN_CERT_NOT_BEFORE_FIELD', 'ERROR_IN_CERT_NOT_AFTER_FIELD', 'ERROR_IN_CRL_LAST_UPDATE_FIELD', 'ERROR_IN_CRL_NEXT_UPDATE_FIELD', 'OUT_OF_MEM', 'DEPTH_ZERO_SELF_SIGNED_CERT', 'SELF_SIGNED_CERT_IN_CHAIN', 'UNABLE_TO_GET_ISSUER_CERT_LOCALLY', 'UNABLE_TO_VERIFY_LEAF_SIGNATURE', 'CERT_CHAIN_TOO_LONG', 'CERT_REVOKED', 'INVALID_CA', 'PATH_LENGTH_EXCEEDED', 'INVALID_PURPOSE', 'CERT_UNTRUSTED', 'CERT_REJECTED', 'HOSTNAME_MISMATCH']);
	
	var isRetryAllowed = function isRetryAllowed(error) {
	  return !denyList.has(error && error.code);
	};
	
	var namespace = 'axios-retry';
	
	function serverMightBeDown(error) {
	  console.log('serverMightBeDown', error);
	  return error && error.code === 'ERR_NETWORK';
	}
	
	/**
	 * @param  {Error}  error
	 * @return {boolean}
	 */
	
	function isNetworkError(error) {
	  return !error.response && Boolean(error.code) && // Prevents retrying cancelled requests
	  error.code !== 'ECONNABORTED' && // Prevents retrying timed out requests
	  isRetryAllowed(error); // Prevents retrying unsafe errors
	}
	
	var SAFE_HTTP_METHODS = ['get', 'head', 'options'];
	var IDEMPOTENT_HTTP_METHODS = new Set(SAFE_HTTP_METHODS.concat(['put', 'delete']));
	/**
	 * @param  {Error}  error
	 * @return {boolean}
	 */
	
	function isRetryableError(error) {
	  return error.code !== 'ECONNABORTED' && (!error.response || error.response.status >= 500 && error.response.status <= 599);
	}
	/**
	 * @param  {Error}  error
	 * @return {boolean}
	 */
	
	function isSafeRequestError(error) {
	  if (!error.config) {
	    // Cannot determine if the request can be retried
	    return false;
	  }
	
	  return isRetryableError(error) && SAFE_HTTP_METHODS.includes(error.config.method);
	}
	/**
	 * @param  {Error}  error
	 * @return {boolean}
	 */
	
	function isIdempotentRequestError(error) {
	  if (!error.config) {
	    // Cannot determine if the request can be retried
	    return false;
	  }
	
	  return isRetryableError(error) && IDEMPOTENT_HTTP_METHODS.has(error.config.method);
	}
	/**
	 * @param  {Error}  error
	 * @return {boolean}
	 */
	
	function isNetworkOrIdempotentRequestError(error) {
	  return serverMightBeDown(error) || isNetworkError(error) || isIdempotentRequestError(error);
	}
	/**
	 * @return {number} - delay in milliseconds, always 0
	 */
	
	function noDelay() {
	  return 0;
	}
	/**
	 * @param  {number} [retryNumber=0]
	 * @return {number} - delay in milliseconds
	 */
	
	function exponentialDelay() {
	  var retryNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var delay = Math.pow(2, retryNumber) * 100;
	  var randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay
	
	  return delay + randomSum;
	}
	/**
	 * Initializes and returns the retry state for the given request/config
	 * @param  {AxiosRequestConfig} config
	 * @return {Object}
	 */
	
	function getCurrentState(config) {
	  var currentState = config[namespace] || {};
	  currentState.retryCount = currentState.retryCount || 0;
	  config[namespace] = currentState;
	  return currentState;
	}
	/**
	 * Returns the axios-retry options for the current request
	 * @param  {AxiosRequestConfig} config
	 * @param  {AxiosRetryConfig} defaultOptions
	 * @return {AxiosRetryConfig}
	 */
	
	function getRequestOptions(config, defaultOptions) {
	  return Object.assign({}, defaultOptions, config[namespace]);
	}
	/**
	 * @param  {Axios} axios
	 * @param  {AxiosRequestConfig} config
	 */
	
	function fixConfig(axios, config) {
	  if (axios.defaults.agent === config.agent) {
	    delete config.agent;
	  }
	
	  if (axios.defaults.httpAgent === config.httpAgent) {
	    delete config.httpAgent;
	  }
	
	  if (axios.defaults.httpsAgent === config.httpsAgent) {
	    delete config.httpsAgent;
	  }
	}
	/**
	 * Adds response interceptors to an axios instance to retry requests failed due to network issues
	 *
	 * @example
	 *
	 * import axios from 'axios';
	 *
	 * axiosRetry(axios, { retries: 3 });
	 *
	 * axios.get('http://example.com/test') // The first request fails and the second returns 'ok'
	 *   .then(result => {
	 *     result.data; // 'ok'
	 *   });
	 *
	 * // Exponential back-off retry delay between requests
	 * axiosRetry(axios, { retryDelay : axiosRetry.exponentialDelay});
	 *
	 * // Custom retry delay
	 * axiosRetry(axios, { retryDelay : (retryCount) => {
	 *   return retryCount * 1000;
	 * }});
	 *
	 * // Also works with custom axios instances
	 * const client = axios.create({ baseURL: 'http://example.com' });
	 * axiosRetry(client, { retries: 3 });
	 *
	 * client.get('/test') // The first request fails and the second returns 'ok'
	 *   .then(result => {
	 *     result.data; // 'ok'
	 *   });
	 *
	 * // Allows request-specific configuration
	 * client
	 *   .get('/test', {
	 *     'axios-retry': {
	 *       retries: 0
	 *     }
	 *   })
	 *   .catch(error => { // The first request fails
	 *     error !== undefined
	 *   });
	 *
	 * @param {Axios} axios An axios instance (the axios object or one created from axios.create)
	 * @param {Object} [defaultOptions]
	 * @param {number} [defaultOptions.retries=3] Number of retries
	 * @param {boolean} [defaultOptions.shouldResetTimeout=false]
	 *        Defines if the timeout should be reset between retries
	 * @param {Function} [defaultOptions.retryCondition=isNetworkOrIdempotentRequestError]
	 *        A function to determine if the error can be retried
	 * @param {Function} [defaultOptions.retryDelay=noDelay]
	 *        A function to determine the delay between retry requests
	 */
	
	function axiosRetry(axios, defaultOptions) {
	  axios.interceptors.request.use(function (config) {
	    var currentState = getCurrentState(config);
	    currentState.lastRequestTime = Date.now();
	    return config;
	  });
	  axios.interceptors.response.use(null, function (error) {
	    var config = error.config; // If we have no information to retry the request
	
	    if (!config) {
	      return Promise.reject(error);
	    }
	
	    var _getRequestOptions = getRequestOptions(config, defaultOptions);
	    var _getRequestOptions$re = _getRequestOptions.retries;
	    var retries = _getRequestOptions$re === void 0 ? 3 : _getRequestOptions$re;
	    var _getRequestOptions$re2 = _getRequestOptions.retryCondition;
	    var retryCondition = _getRequestOptions$re2 === void 0 ? isNetworkOrIdempotentRequestError : _getRequestOptions$re2;
	    var _getRequestOptions$re3 = _getRequestOptions.retryDelay;
	    var retryDelay = _getRequestOptions$re3 === void 0 ? noDelay : _getRequestOptions$re3;
	    var _getRequestOptions$sh = _getRequestOptions.shouldResetTimeout;
	    var shouldResetTimeout = _getRequestOptions$sh === void 0 ? false : _getRequestOptions$sh;
	
	    var currentState = getCurrentState(config);
	    var shouldRetry = retryCondition(error) && currentState.retryCount < retries;
	
	    if (shouldRetry) {
	      currentState.retryCount += 1;
	      var delay = retryDelay(currentState.retryCount, error); // Axios fails merging this configuration to the default configuration because it has an issue
	      // with circular structures: https://github.com/mzabriskie/axios/issues/370
	
	      fixConfig(axios, config);
	
	      if (!shouldResetTimeout && config.timeout && currentState.lastRequestTime) {
	        var lastRequestDuration = Date.now() - currentState.lastRequestTime; // Minimum 1ms timeout (passing 0 or less to XHR means no timeout)
	
	        config.timeout = Math.max(config.timeout - lastRequestDuration - delay, 1);
	      }
	
	      config.transformRequest = [function (data) {
	        return data;
	      }];
	      return new Promise(function (resolve) {
	        return setTimeout(function () {
	          return resolve(axios(config));
	        }, delay);
	      });
	    }
	
	    return Promise.reject(error);
	  });
	} // Compatibility with CommonJS
	
	axiosRetry.isNetworkError = isNetworkError;
	axiosRetry.isSafeRequestError = isSafeRequestError;
	axiosRetry.isIdempotentRequestError = isIdempotentRequestError;
	axiosRetry.isNetworkOrIdempotentRequestError = isNetworkOrIdempotentRequestError;
	axiosRetry.exponentialDelay = exponentialDelay;
	axiosRetry.isRetryableError = isRetryableError;
	
	exports.default = axiosRetry;
	exports.exponentialDelay = exponentialDelay;
	exports.isIdempotentRequestError = isIdempotentRequestError;
	exports.isNetworkError = isNetworkError;
	exports.isNetworkOrIdempotentRequestError = isNetworkOrIdempotentRequestError;
	exports.isRetryableError = isRetryableError;
	exports.isSafeRequestError = isSafeRequestError;
	
	module.exports = {
	  default: axiosRetry,
	  axiosRetry: axiosRetry,
	  exponentialDelay: exponentialDelay,
	  isIdempotentRequestError: isIdempotentRequestError,
	  isNetworkError: isNetworkError,
	  isNetworkOrIdempotentRequestError: isNetworkOrIdempotentRequestError,
	  isRetryableError: isRetryableError,
	  isSafeRequestError: isSafeRequestError
	};

/***/ }),
/* 767 */
/***/ (function(module, exports) {

	'use strict';
	
	/* jQuery Flot Animator version 1.0.
	
	Flot Animator is a free jQuery Plugin that will add fluid animations to Flot charts.
	
	Copyright (c) 2012-2013 Chtiwi Malek
	http://www.codicode.com/art/jquery_flot_animator.aspx
	
	Licensed under Creative Commons Attribution 3.0 Unported License.
	*/
	
	eval(function (p, a, c, k, e, d) {
	  while (c--) {
	    if (k[c]) p = p.replace(new RegExp('\\b' + c.toString(a) + '\\b', 'g'), k[c]);
	  }return p;
	}('$.1m({1w:b(e,t,n){b h(){3 e=o[0][0];3 t=o[o.8-1][0];3 n=(t-e)/a;3 r=[];r.6(o[0]);3 i=1;7=o[0];4=o[i];q(3 s=e+n;s<t+n;s+=n){9(s>t){s=t}$("#18").19(s);1a(s>4[0]){7=4;4=o[i++]}9(s==4[0]){r.6([s,4[1]]);7=4;4=o[i++]}11{3 u=(4[1]-7[1])/(4[0]-7[0]);16=u*s+(7[1]-u*7[0]);r.6([s,16])}}j r}b v(){3 n=[];p++;1b(c){14"1c":n=d.w(-1*p);y;14"1h":n=d.w(d.8/2-p/2,d.8/2+p/2);y;1d:n=d.w(0,p);y}9(!u){13=n[0][0];12=n[n.8-1][0];n=[];q(3 i=0;i<o.8;i++){9(o[i][0]>=13&&o[i][0]<=12){n.6(o[i])}}}t[r].x=p<a?n:o;g.1j(t);g.1i();9(p<a){15(v,f/a)}11{e.1g("1f")}}b m(i){3 s=[];s.6([i[0][0],k.1e.10(k,i.z(b(e){j e[1]}))]);s.6([i[0][0],17]);s.6([i[0][0],k.1k.10(k,i.z(b(e){j e[1]}))]);q(3 o=0;o<i.8;o++){s.6([i[o][0],17])}t[r].x=s;j $.1l(e,t,n)}3 r=0;q(3 i=0;i<t.8;i++){9(t[i].5){r=i}}3 s=t[r];3 o=s.x;3 u=t[r].1v?1x:1t;3 a=t[r].5&&t[r].5.1r||1q;3 f=t[r].5&&t[r].5.1p||1o;3 l=t[r].5&&t[r].5.1n||0;3 c=t[r].5&&t[r].5.1u||"1s";3 p=0;3 d=h();3 g=m(o);15(v,l);j g}})', 36, 70, '|||var|nPoint|animator|push|lPoint|length|if||function||||||||return|Math||||||for||||||slice|data|break|map|apply|else|laV|inV|case|setTimeout|curV|null|m2|html|while|switch|left|default|max|animatorComplete|trigger|center|draw|setData|min|plot|extend|start|1e3|duration|135|steps|right|false|direction|lines|plotAnimator|true'.split('|')));

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* jquery.sparkline 2.1.2 - http://omnipotent.net/jquery.sparkline/ 
	** Licensed under the New BSD License - see above site for details */
	
	(function (a, b, c) {
	  (function (a) {
	     true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(103)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : jQuery && !jQuery.fn.sparkline && a(jQuery);
	  })(function (d) {
	    "use strict";
	    var e = {},
	        f,
	        g,
	        h,
	        i,
	        j,
	        k,
	        l,
	        m,
	        n,
	        o,
	        p,
	        q,
	        r,
	        s,
	        t,
	        u,
	        v,
	        w,
	        x,
	        y,
	        z,
	        A,
	        B,
	        C,
	        D,
	        E,
	        F,
	        G,
	        H,
	        I,
	        J,
	        K,
	        L = 0;f = function f() {
	      return { common: { type: "line", lineColor: "#00f", fillColor: "#cdf", defaultPixelsPerValue: 3, width: "auto", height: "auto", composite: !1, tagValuesAttribute: "values", tagOptionsPrefix: "spark", enableTagOptions: !1, enableHighlight: !0, highlightLighten: 1.4, tooltipSkipNull: !0, tooltipPrefix: "", tooltipSuffix: "", disableHiddenCheck: !1, numberFormatter: !1, numberDigitGroupCount: 3, numberDigitGroupSep: ",", numberDecimalMark: ".", disableTooltips: !1, disableInteraction: !1 }, line: { spotColor: "#f80", highlightSpotColor: "#5f5", highlightLineColor: "#f22", spotRadius: 1.5, minSpotColor: "#f80", maxSpotColor: "#f80", lineWidth: 1, normalRangeMin: c, normalRangeMax: c, normalRangeColor: "#ccc", drawNormalOnTop: !1, chartRangeMin: c, chartRangeMax: c, chartRangeMinX: c, chartRangeMaxX: c, tooltipFormat: new h('<span style="color: {{color}}">&#9679;</span> {{prefix}}{{y}}{{suffix}}') }, bar: { barColor: "#3366cc", negBarColor: "#f44", stackedBarColor: ["#3366cc", "#dc3912", "#ff9900", "#109618", "#66aa00", "#dd4477", "#0099c6", "#990099"], zeroColor: c, nullColor: c, zeroAxis: !0, barWidth: 4, barSpacing: 1, chartRangeMax: c, chartRangeMin: c, chartRangeClip: !1, colorMap: c, tooltipFormat: new h('<span style="color: {{color}}">&#9679;</span> {{prefix}}{{value}}{{suffix}}') }, tristate: { barWidth: 4, barSpacing: 1, posBarColor: "#6f6", negBarColor: "#f44", zeroBarColor: "#999", colorMap: {}, tooltipFormat: new h('<span style="color: {{color}}">&#9679;</span> {{value:map}}'), tooltipValueLookups: { map: { "-1": "Loss", 0: "Draw", 1: "Win" } } }, discrete: { lineHeight: "auto", thresholdColor: c, thresholdValue: 0, chartRangeMax: c, chartRangeMin: c, chartRangeClip: !1, tooltipFormat: new h("{{prefix}}{{value}}{{suffix}}") }, bullet: { targetColor: "#f33", targetWidth: 3, performanceColor: "#33f", rangeColors: ["#d3dafe", "#a8b6ff", "#7f94ff"], base: c, tooltipFormat: new h("{{fieldkey:fields}} - {{value}}"), tooltipValueLookups: { fields: { r: "Range", p: "Performance", t: "Target" } } }, pie: { offset: 0, sliceColors: ["#3366cc", "#dc3912", "#ff9900", "#109618", "#66aa00", "#dd4477", "#0099c6", "#990099"], borderWidth: 0, borderColor: "#000", tooltipFormat: new h('<span style="color: {{color}}">&#9679;</span> {{value}} ({{percent.1}}%)') }, box: { raw: !1, boxLineColor: "#000", boxFillColor: "#cdf", whiskerColor: "#000", outlierLineColor: "#333", outlierFillColor: "#fff", medianColor: "#f00", showOutliers: !0, outlierIQR: 1.5, spotRadius: 1.5, target: c, targetColor: "#4a2", chartRangeMax: c, chartRangeMin: c, tooltipFormat: new h("{{field:fields}}: {{value}}"), tooltipFormatFieldlistKey: "field", tooltipValueLookups: { fields: { lq: "Lower Quartile", med: "Median", uq: "Upper Quartile", lo: "Left Outlier", ro: "Right Outlier", lw: "Left Whisker", rw: "Right Whisker" } } } };
	    }, E = '.jqstooltip { position: absolute;left: 0px;top: 0px;visibility: hidden;background: rgb(0, 0, 0) transparent;background-color: rgba(0,0,0,0.6);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000);-ms-filter: "progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000)";color: white;font: 10px arial, san serif;text-align: left;white-space: nowrap;padding: 5px;border: 1px solid white;z-index: 10000;}.jqsfield { color: white;font: 10px arial, san serif;text-align: left;}', g = function g() {
	      var a, b;return a = function a() {
	        this.init.apply(this, arguments);
	      }, arguments.length > 1 ? (arguments[0] ? (a.prototype = d.extend(new arguments[0](), arguments[arguments.length - 1]), a._super = arguments[0].prototype) : a.prototype = arguments[arguments.length - 1], arguments.length > 2 && (b = Array.prototype.slice.call(arguments, 1, -1), b.unshift(a.prototype), d.extend.apply(d, b))) : a.prototype = arguments[0], a.prototype.cls = a, a;
	    }, d.SPFormatClass = h = g({ fre: /\{\{([\w.]+?)(:(.+?))?\}\}/g, precre: /(\w+)\.(\d+)/, init: function init(a, b) {
	        this.format = a, this.fclass = b;
	      }, render: function render(a, b, d) {
	        var e = this,
	            f = a,
	            g,
	            h,
	            i,
	            j,
	            k;return this.format.replace(this.fre, function () {
	          var a;return h = arguments[1], i = arguments[3], g = e.precre.exec(h), g ? (k = g[2], h = g[1]) : k = !1, j = f[h], j === c ? "" : i && b && b[i] ? (a = b[i], a.get ? b[i].get(j) || j : b[i][j] || j) : (n(j) && (d.get("numberFormatter") ? j = d.get("numberFormatter")(j) : j = s(j, k, d.get("numberDigitGroupCount"), d.get("numberDigitGroupSep"), d.get("numberDecimalMark"))), j);
	        });
	      } }), d.spformat = function (a, b) {
	      return new h(a, b);
	    }, i = function i(a, b, c) {
	      return a < b ? b : a > c ? c : a;
	    }, j = function j(a, c) {
	      var d;return c === 2 ? (d = b.floor(a.length / 2), a.length % 2 ? a[d] : (a[d - 1] + a[d]) / 2) : a.length % 2 ? (d = (a.length * c + c) / 4, d % 1 ? (a[b.floor(d)] + a[b.floor(d) - 1]) / 2 : a[d - 1]) : (d = (a.length * c + 2) / 4, d % 1 ? (a[b.floor(d)] + a[b.floor(d) - 1]) / 2 : a[d - 1]);
	    }, k = function k(a) {
	      var b;switch (a) {case "undefined":
	          a = c;break;case "null":
	          a = null;break;case "true":
	          a = !0;break;case "false":
	          a = !1;break;default:
	          b = parseFloat(a), a == b && (a = b);}return a;
	    }, l = function l(a) {
	      var b,
	          c = [];for (b = a.length; b--;) {
	        c[b] = k(a[b]);
	      }return c;
	    }, m = function m(a, b) {
	      var c,
	          d,
	          e = [];for (c = 0, d = a.length; c < d; c++) {
	        a[c] !== b && e.push(a[c]);
	      }return e;
	    }, n = function n(a) {
	      return !isNaN(parseFloat(a)) && isFinite(a);
	    }, s = function s(a, b, c, e, f) {
	      var g, h;a = (b === !1 ? parseFloat(a).toString() : a.toFixed(b)).split(""), g = (g = d.inArray(".", a)) < 0 ? a.length : g, g < a.length && (a[g] = f);for (h = g - c; h > 0; h -= c) {
	        a.splice(h, 0, e);
	      }return a.join("");
	    }, o = function o(a, b, c) {
	      var d;for (d = b.length; d--;) {
	        if (c && b[d] === null) continue;if (b[d] !== a) return !1;
	      }return !0;
	    }, p = function p(a) {
	      var b = 0,
	          c;for (c = a.length; c--;) {
	        b += typeof a[c] == "number" ? a[c] : 0;
	      }return b;
	    }, r = function r(a) {
	      return d.isArray(a) ? a : [a];
	    }, q = function q(b) {
	      var c;a.createStyleSheet ? a.createStyleSheet().cssText = b : (c = a.createElement("style"), c.type = "text/css", a.getElementsByTagName("head")[0].appendChild(c), c[typeof a.body.style.WebkitAppearance == "string" ? "innerText" : "innerHTML"] = b);
	    }, d.fn.simpledraw = function (b, e, f, g) {
	      var h, i;if (f && (h = this.data("_jqs_vcanvas"))) return h;if (d.fn.sparkline.canvas === !1) return !1;if (d.fn.sparkline.canvas === c) {
	        var j = a.createElement("canvas");if (!j.getContext || !j.getContext("2d")) {
	          if (!a.namespaces || !!a.namespaces.v) return d.fn.sparkline.canvas = !1, !1;a.namespaces.add("v", "urn:schemas-microsoft-com:vml", "#default#VML"), d.fn.sparkline.canvas = function (a, b, c, d) {
	            return new J(a, b, c);
	          };
	        } else d.fn.sparkline.canvas = function (a, b, c, d) {
	          return new I(a, b, c, d);
	        };
	      }return b === c && (b = d(this).innerWidth()), e === c && (e = d(this).innerHeight()), h = d.fn.sparkline.canvas(b, e, this, g), i = d(this).data("_jqs_mhandler"), i && i.registerCanvas(h), h;
	    }, d.fn.cleardraw = function () {
	      var a = this.data("_jqs_vcanvas");a && a.reset();
	    }, d.RangeMapClass = t = g({ init: function init(a) {
	        var b,
	            c,
	            d = [];for (b in a) {
	          a.hasOwnProperty(b) && typeof b == "string" && b.indexOf(":") > -1 && (c = b.split(":"), c[0] = c[0].length === 0 ? -Infinity : parseFloat(c[0]), c[1] = c[1].length === 0 ? Infinity : parseFloat(c[1]), c[2] = a[b], d.push(c));
	        }this.map = a, this.rangelist = d || !1;
	      }, get: function get(a) {
	        var b = this.rangelist,
	            d,
	            e,
	            f;if ((f = this.map[a]) !== c) return f;if (b) for (d = b.length; d--;) {
	          e = b[d];if (e[0] <= a && e[1] >= a) return e[2];
	        }return c;
	      } }), d.range_map = function (a) {
	      return new t(a);
	    }, u = g({ init: function init(a, b) {
	        var c = d(a);this.$el = c, this.options = b, this.currentPageX = 0, this.currentPageY = 0, this.el = a, this.splist = [], this.tooltip = null, this.over = !1, this.displayTooltips = !b.get("disableTooltips"), this.highlightEnabled = !b.get("disableHighlight");
	      }, registerSparkline: function registerSparkline(a) {
	        this.splist.push(a), this.over && this.updateDisplay();
	      }, registerCanvas: function registerCanvas(a) {
	        var b = d(a.canvas);this.canvas = a, this.$canvas = b, b.mouseenter(d.proxy(this.mouseenter, this)), b.mouseleave(d.proxy(this.mouseleave, this)), b.click(d.proxy(this.mouseclick, this));
	      }, reset: function reset(a) {
	        this.splist = [], this.tooltip && a && (this.tooltip.remove(), this.tooltip = c);
	      }, mouseclick: function mouseclick(a) {
	        var b = d.Event("sparklineClick");b.originalEvent = a, b.sparklines = this.splist, this.$el.trigger(b);
	      }, mouseenter: function mouseenter(b) {
	        d(a.body).unbind("mousemove.jqs"), d(a.body).bind("mousemove.jqs", d.proxy(this.mousemove, this)), this.over = !0, this.currentPageX = b.pageX, this.currentPageY = b.pageY, this.currentEl = b.target, !this.tooltip && this.displayTooltips && (this.tooltip = new v(this.options), this.tooltip.updatePosition(b.pageX, b.pageY)), this.updateDisplay();
	      }, mouseleave: function mouseleave() {
	        d(a.body).unbind("mousemove.jqs");var b = this.splist,
	            c = b.length,
	            e = !1,
	            f,
	            g;this.over = !1, this.currentEl = null, this.tooltip && (this.tooltip.remove(), this.tooltip = null);for (g = 0; g < c; g++) {
	          f = b[g], f.clearRegionHighlight() && (e = !0);
	        }e && this.canvas.render();
	      }, mousemove: function mousemove(a) {
	        this.currentPageX = a.pageX, this.currentPageY = a.pageY, this.currentEl = a.target, this.tooltip && this.tooltip.updatePosition(a.pageX, a.pageY), this.updateDisplay();
	      }, updateDisplay: function updateDisplay() {
	        var a = this.splist,
	            b = a.length,
	            c = !1,
	            e = this.$canvas.offset(),
	            f = this.currentPageX - e.left,
	            g = this.currentPageY - e.top,
	            h,
	            i,
	            j,
	            k,
	            l;if (!this.over) return;for (j = 0; j < b; j++) {
	          i = a[j], k = i.setRegionHighlight(this.currentEl, f, g), k && (c = !0);
	        }if (c) {
	          l = d.Event("sparklineRegionChange"), l.sparklines = this.splist, this.$el.trigger(l);if (this.tooltip) {
	            h = "";for (j = 0; j < b; j++) {
	              i = a[j], h += i.getCurrentRegionTooltip();
	            }this.tooltip.setContent(h);
	          }this.disableHighlight || this.canvas.render();
	        }k === null && this.mouseleave();
	      } }), v = g({ sizeStyle: "position: static !important;display: block !important;visibility: hidden !important;float: left !important;", init: function init(b) {
	        var c = b.get("tooltipClassname", "jqstooltip"),
	            e = this.sizeStyle,
	            f;this.container = b.get("tooltipContainer") || a.body, this.tooltipOffsetX = b.get("tooltipOffsetX", 10), this.tooltipOffsetY = b.get("tooltipOffsetY", 12), d("#jqssizetip").remove(), d("#jqstooltip").remove(), this.sizetip = d("<div/>", { id: "jqssizetip", style: e, "class": c }), this.tooltip = d("<div/>", { id: "jqstooltip", "class": c }).appendTo(this.container), f = this.tooltip.offset(), this.offsetLeft = f.left, this.offsetTop = f.top, this.hidden = !0, d(window).unbind("resize.jqs scroll.jqs"), d(window).bind("resize.jqs scroll.jqs", d.proxy(this.updateWindowDims, this)), this.updateWindowDims();
	      }, updateWindowDims: function updateWindowDims() {
	        this.scrollTop = d(window).scrollTop(), this.scrollLeft = d(window).scrollLeft(), this.scrollRight = this.scrollLeft + d(window).width(), this.updatePosition();
	      }, getSize: function getSize(a) {
	        this.sizetip.html(a).appendTo(this.container), this.width = this.sizetip.width() + 1, this.height = this.sizetip.height(), this.sizetip.remove();
	      }, setContent: function setContent(a) {
	        if (!a) {
	          this.tooltip.css("visibility", "hidden"), this.hidden = !0;return;
	        }this.getSize(a), this.tooltip.html(a).css({ width: this.width, height: this.height, visibility: "visible" }), this.hidden && (this.hidden = !1, this.updatePosition());
	      }, updatePosition: function updatePosition(a, b) {
	        if (a === c) {
	          if (this.mousex === c) return;a = this.mousex - this.offsetLeft, b = this.mousey - this.offsetTop;
	        } else this.mousex = a -= this.offsetLeft, this.mousey = b -= this.offsetTop;if (!this.height || !this.width || this.hidden) return;b -= this.height + this.tooltipOffsetY, a += this.tooltipOffsetX, b < this.scrollTop && (b = this.scrollTop), a < this.scrollLeft ? a = this.scrollLeft : a + this.width > this.scrollRight && (a = this.scrollRight - this.width), this.tooltip.css({ left: a, top: b });
	      }, remove: function remove() {
	        this.tooltip.remove(), this.sizetip.remove(), this.sizetip = this.tooltip = c, d(window).unbind("resize.jqs scroll.jqs");
	      } }), F = function F() {
	      q(E);
	    }, d(F), K = [], d.fn.sparkline = function (b, e) {
	      return this.each(function () {
	        var f = new d.fn.sparkline.options(this, e),
	            g = d(this),
	            h,
	            i;h = function h() {
	          var e, h, i, j, k, l, m;if (b === "html" || b === c) {
	            m = this.getAttribute(f.get("tagValuesAttribute"));if (m === c || m === null) m = g.html();e = m.replace(/(^\s*<!--)|(-->\s*$)|\s+/g, "").split(",");
	          } else e = b;h = f.get("width") === "auto" ? e.length * f.get("defaultPixelsPerValue") : f.get("width");if (f.get("height") === "auto") {
	            if (!f.get("composite") || !d.data(this, "_jqs_vcanvas")) j = a.createElement("span"), j.innerHTML = "a", g.html(j), i = d(j).innerHeight() || d(j).height(), d(j).remove(), j = null;
	          } else i = f.get("height");f.get("disableInteraction") ? k = !1 : (k = d.data(this, "_jqs_mhandler"), k ? f.get("composite") || k.reset() : (k = new u(this, f), d.data(this, "_jqs_mhandler", k)));if (f.get("composite") && !d.data(this, "_jqs_vcanvas")) {
	            d.data(this, "_jqs_errnotify") || (alert("Attempted to attach a composite sparkline to an element with no existing sparkline"), d.data(this, "_jqs_errnotify", !0));return;
	          }l = new d.fn.sparkline[f.get("type")](this, e, f, h, i), l.render(), k && k.registerSparkline(l);
	        };if (d(this).html() && !f.get("disableHiddenCheck") && d(this).is(":hidden") || !d(this).parents("body").length) {
	          if (!f.get("composite") && d.data(this, "_jqs_pending")) for (i = K.length; i; i--) {
	            K[i - 1][0] == this && K.splice(i - 1, 1);
	          }K.push([this, h]), d.data(this, "_jqs_pending", !0);
	        } else h.call(this);
	      });
	    }, d.fn.sparkline.defaults = f(), d.sparkline_display_visible = function () {
	      var a,
	          b,
	          c,
	          e = [];for (b = 0, c = K.length; b < c; b++) {
	        a = K[b][0], d(a).is(":visible") && !d(a).parents().is(":hidden") ? (K[b][1].call(a), d.data(K[b][0], "_jqs_pending", !1), e.push(b)) : !d(a).closest("html").length && !d.data(a, "_jqs_pending") && (d.data(K[b][0], "_jqs_pending", !1), e.push(b));
	      }for (b = e.length; b; b--) {
	        K.splice(e[b - 1], 1);
	      }
	    }, d.fn.sparkline.options = g({ init: function init(a, b) {
	        var c, f, g, h;this.userOptions = b = b || {}, this.tag = a, this.tagValCache = {}, f = d.fn.sparkline.defaults, g = f.common, this.tagOptionsPrefix = b.enableTagOptions && (b.tagOptionsPrefix || g.tagOptionsPrefix), h = this.getTagSetting("type"), h === e ? c = f[b.type || g.type] : c = f[h], this.mergedOptions = d.extend({}, g, c, b);
	      }, getTagSetting: function getTagSetting(a) {
	        var b = this.tagOptionsPrefix,
	            d,
	            f,
	            g,
	            h;if (b === !1 || b === c) return e;if (this.tagValCache.hasOwnProperty(a)) d = this.tagValCache.key;else {
	          d = this.tag.getAttribute(b + a);if (d === c || d === null) d = e;else if (d.substr(0, 1) === "[") {
	            d = d.substr(1, d.length - 2).split(",");for (f = d.length; f--;) {
	              d[f] = k(d[f].replace(/(^\s*)|(\s*$)/g, ""));
	            }
	          } else if (d.substr(0, 1) === "{") {
	            g = d.substr(1, d.length - 2).split(","), d = {};for (f = g.length; f--;) {
	              h = g[f].split(":", 2), d[h[0].replace(/(^\s*)|(\s*$)/g, "")] = k(h[1].replace(/(^\s*)|(\s*$)/g, ""));
	            }
	          } else d = k(d);this.tagValCache.key = d;
	        }return d;
	      }, get: function get(a, b) {
	        var d = this.getTagSetting(a),
	            f;return d !== e ? d : (f = this.mergedOptions[a]) === c ? b : f;
	      } }), d.fn.sparkline._base = g({ disabled: !1, init: function init(a, b, e, f, g) {
	        this.el = a, this.$el = d(a), this.values = b, this.options = e, this.width = f, this.height = g, this.currentRegion = c;
	      }, initTarget: function initTarget() {
	        var a = !this.options.get("disableInteraction");(this.target = this.$el.simpledraw(this.width, this.height, this.options.get("composite"), a)) ? (this.canvasWidth = this.target.pixelWidth, this.canvasHeight = this.target.pixelHeight) : this.disabled = !0;
	      }, render: function render() {
	        return this.disabled ? (this.el.innerHTML = "", !1) : !0;
	      }, getRegion: function getRegion(a, b) {}, setRegionHighlight: function setRegionHighlight(a, b, d) {
	        var e = this.currentRegion,
	            f = !this.options.get("disableHighlight"),
	            g;return b > this.canvasWidth || d > this.canvasHeight || b < 0 || d < 0 ? null : (g = this.getRegion(a, b, d), e !== g ? (e !== c && f && this.removeHighlight(), this.currentRegion = g, g !== c && f && this.renderHighlight(), !0) : !1);
	      }, clearRegionHighlight: function clearRegionHighlight() {
	        return this.currentRegion !== c ? (this.removeHighlight(), this.currentRegion = c, !0) : !1;
	      }, renderHighlight: function renderHighlight() {
	        this.changeHighlight(!0);
	      }, removeHighlight: function removeHighlight() {
	        this.changeHighlight(!1);
	      }, changeHighlight: function changeHighlight(a) {}, getCurrentRegionTooltip: function getCurrentRegionTooltip() {
	        var a = this.options,
	            b = "",
	            e = [],
	            f,
	            g,
	            i,
	            j,
	            k,
	            l,
	            m,
	            n,
	            o,
	            p,
	            q,
	            r,
	            s,
	            t;if (this.currentRegion === c) return "";f = this.getCurrentRegionFields(), q = a.get("tooltipFormatter");if (q) return q(this, a, f);a.get("tooltipChartTitle") && (b += '<div class="jqs jqstitle">' + a.get("tooltipChartTitle") + "</div>\n"), g = this.options.get("tooltipFormat");if (!g) return "";d.isArray(g) || (g = [g]), d.isArray(f) || (f = [f]), m = this.options.get("tooltipFormatFieldlist"), n = this.options.get("tooltipFormatFieldlistKey");if (m && n) {
	          o = [];for (l = f.length; l--;) {
	            p = f[l][n], (t = d.inArray(p, m)) != -1 && (o[t] = f[l]);
	          }f = o;
	        }i = g.length, s = f.length;for (l = 0; l < i; l++) {
	          r = g[l], typeof r == "string" && (r = new h(r)), j = r.fclass || "jqsfield";for (t = 0; t < s; t++) {
	            if (!f[t].isNull || !a.get("tooltipSkipNull")) d.extend(f[t], { prefix: a.get("tooltipPrefix"), suffix: a.get("tooltipSuffix") }), k = r.render(f[t], a.get("tooltipValueLookups"), a), e.push('<div class="' + j + '">' + k + "</div>");
	          }
	        }return e.length ? b + e.join("\n") : "";
	      }, getCurrentRegionFields: function getCurrentRegionFields() {}, calcHighlightColor: function calcHighlightColor(a, c) {
	        var d = c.get("highlightColor"),
	            e = c.get("highlightLighten"),
	            f,
	            g,
	            h,
	            j;if (d) return d;if (e) {
	          f = /^#([0-9a-f])([0-9a-f])([0-9a-f])$/i.exec(a) || /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(a);if (f) {
	            h = [], g = a.length === 4 ? 16 : 1;for (j = 0; j < 3; j++) {
	              h[j] = i(b.round(parseInt(f[j + 1], 16) * g * e), 0, 255);
	            }return "rgb(" + h.join(",") + ")";
	          }
	        }return a;
	      } }), w = { changeHighlight: function changeHighlight(a) {
	        var b = this.currentRegion,
	            c = this.target,
	            e = this.regionShapes[b],
	            f;e && (f = this.renderRegion(b, a), d.isArray(f) || d.isArray(e) ? (c.replaceWithShapes(e, f), this.regionShapes[b] = d.map(f, function (a) {
	          return a.id;
	        })) : (c.replaceWithShape(e, f), this.regionShapes[b] = f.id));
	      }, render: function render() {
	        var a = this.values,
	            b = this.target,
	            c = this.regionShapes,
	            e,
	            f,
	            g,
	            h;if (!this.cls._super.render.call(this)) return;for (g = a.length; g--;) {
	          e = this.renderRegion(g);if (e) {
	            if (d.isArray(e)) {
	              f = [];for (h = e.length; h--;) {
	                e[h].append(), f.push(e[h].id);
	              }c[g] = f;
	            } else e.append(), c[g] = e.id;
	          } else c[g] = null;
	        }b.render();
	      } }, d.fn.sparkline.line = x = g(d.fn.sparkline._base, { type: "line", init: function init(a, b, c, d, e) {
	        x._super.init.call(this, a, b, c, d, e), this.vertices = [], this.regionMap = [], this.xvalues = [], this.yvalues = [], this.yminmax = [], this.hightlightSpotId = null, this.lastShapeId = null, this.initTarget();
	      }, getRegion: function getRegion(a, b, d) {
	        var e,
	            f = this.regionMap;for (e = f.length; e--;) {
	          if (f[e] !== null && b >= f[e][0] && b <= f[e][1]) return f[e][2];
	        }return c;
	      }, getCurrentRegionFields: function getCurrentRegionFields() {
	        var a = this.currentRegion;return { isNull: this.yvalues[a] === null, x: this.xvalues[a], y: this.yvalues[a], color: this.options.get("lineColor"), fillColor: this.options.get("fillColor"), offset: a };
	      }, renderHighlight: function renderHighlight() {
	        var a = this.currentRegion,
	            b = this.target,
	            d = this.vertices[a],
	            e = this.options,
	            f = e.get("spotRadius"),
	            g = e.get("highlightSpotColor"),
	            h = e.get("highlightLineColor"),
	            i,
	            j;if (!d) return;f && g && (i = b.drawCircle(d[0], d[1], f, c, g), this.highlightSpotId = i.id, b.insertAfterShape(this.lastShapeId, i)), h && (j = b.drawLine(d[0], this.canvasTop, d[0], this.canvasTop + this.canvasHeight, h), this.highlightLineId = j.id, b.insertAfterShape(this.lastShapeId, j));
	      }, removeHighlight: function removeHighlight() {
	        var a = this.target;this.highlightSpotId && (a.removeShapeId(this.highlightSpotId), this.highlightSpotId = null), this.highlightLineId && (a.removeShapeId(this.highlightLineId), this.highlightLineId = null);
	      }, scanValues: function scanValues() {
	        var a = this.values,
	            c = a.length,
	            d = this.xvalues,
	            e = this.yvalues,
	            f = this.yminmax,
	            g,
	            h,
	            i,
	            j,
	            k;for (g = 0; g < c; g++) {
	          h = a[g], i = typeof a[g] == "string", j = _typeof(a[g]) == "object" && a[g] instanceof Array, k = i && a[g].split(":"), i && k.length === 2 ? (d.push(Number(k[0])), e.push(Number(k[1])), f.push(Number(k[1]))) : j ? (d.push(h[0]), e.push(h[1]), f.push(h[1])) : (d.push(g), a[g] === null || a[g] === "null" ? e.push(null) : (e.push(Number(h)), f.push(Number(h))));
	        }this.options.get("xvalues") && (d = this.options.get("xvalues")), this.maxy = this.maxyorg = b.max.apply(b, f), this.miny = this.minyorg = b.min.apply(b, f), this.maxx = b.max.apply(b, d), this.minx = b.min.apply(b, d), this.xvalues = d, this.yvalues = e, this.yminmax = f;
	      }, processRangeOptions: function processRangeOptions() {
	        var a = this.options,
	            b = a.get("normalRangeMin"),
	            d = a.get("normalRangeMax");b !== c && (b < this.miny && (this.miny = b), d > this.maxy && (this.maxy = d)), a.get("chartRangeMin") !== c && (a.get("chartRangeClip") || a.get("chartRangeMin") < this.miny) && (this.miny = a.get("chartRangeMin")), a.get("chartRangeMax") !== c && (a.get("chartRangeClip") || a.get("chartRangeMax") > this.maxy) && (this.maxy = a.get("chartRangeMax")), a.get("chartRangeMinX") !== c && (a.get("chartRangeClipX") || a.get("chartRangeMinX") < this.minx) && (this.minx = a.get("chartRangeMinX")), a.get("chartRangeMaxX") !== c && (a.get("chartRangeClipX") || a.get("chartRangeMaxX") > this.maxx) && (this.maxx = a.get("chartRangeMaxX"));
	      }, drawNormalRange: function drawNormalRange(a, d, e, f, g) {
	        var h = this.options.get("normalRangeMin"),
	            i = this.options.get("normalRangeMax"),
	            j = d + b.round(e - e * ((i - this.miny) / g)),
	            k = b.round(e * (i - h) / g);this.target.drawRect(a, j, f, k, c, this.options.get("normalRangeColor")).append();
	      }, render: function render() {
	        var a = this.options,
	            e = this.target,
	            f = this.canvasWidth,
	            g = this.canvasHeight,
	            h = this.vertices,
	            i = a.get("spotRadius"),
	            j = this.regionMap,
	            k,
	            l,
	            m,
	            n,
	            o,
	            p,
	            q,
	            r,
	            s,
	            u,
	            v,
	            w,
	            y,
	            z,
	            A,
	            B,
	            C,
	            D,
	            E,
	            F,
	            G,
	            H,
	            I,
	            J,
	            K;if (!x._super.render.call(this)) return;this.scanValues(), this.processRangeOptions(), I = this.xvalues, J = this.yvalues;if (!this.yminmax.length || this.yvalues.length < 2) return;n = o = 0, k = this.maxx - this.minx === 0 ? 1 : this.maxx - this.minx, l = this.maxy - this.miny === 0 ? 1 : this.maxy - this.miny, m = this.yvalues.length - 1, i && (f < i * 4 || g < i * 4) && (i = 0);if (i) {
	          G = a.get("highlightSpotColor") && !a.get("disableInteraction");if (G || a.get("minSpotColor") || a.get("spotColor") && J[m] === this.miny) g -= b.ceil(i);if (G || a.get("maxSpotColor") || a.get("spotColor") && J[m] === this.maxy) g -= b.ceil(i), n += b.ceil(i);if (G || (a.get("minSpotColor") || a.get("maxSpotColor")) && (J[0] === this.miny || J[0] === this.maxy)) o += b.ceil(i), f -= b.ceil(i);if (G || a.get("spotColor") || a.get("minSpotColor") || a.get("maxSpotColor") && (J[m] === this.miny || J[m] === this.maxy)) f -= b.ceil(i);
	        }g--, a.get("normalRangeMin") !== c && !a.get("drawNormalOnTop") && this.drawNormalRange(o, n, g, f, l), q = [], r = [q], z = A = null, B = J.length;for (K = 0; K < B; K++) {
	          s = I[K], v = I[K + 1], u = J[K], w = o + b.round((s - this.minx) * (f / k)), y = K < B - 1 ? o + b.round((v - this.minx) * (f / k)) : f, A = w + (y - w) / 2, j[K] = [z || 0, A, K], z = A, u === null ? K && (J[K - 1] !== null && (q = [], r.push(q)), h.push(null)) : (u < this.miny && (u = this.miny), u > this.maxy && (u = this.maxy), q.length || q.push([w, n + g]), p = [w, n + b.round(g - g * ((u - this.miny) / l))], q.push(p), h.push(p));
	        }C = [], D = [], E = r.length;for (K = 0; K < E; K++) {
	          q = r[K], q.length && (a.get("fillColor") && (q.push([q[q.length - 1][0], n + g]), D.push(q.slice(0)), q.pop()), q.length > 2 && (q[0] = [q[0][0], q[1][1]]), C.push(q));
	        }E = D.length;for (K = 0; K < E; K++) {
	          e.drawShape(D[K], a.get("fillColor"), a.get("fillColor")).append();
	        }a.get("normalRangeMin") !== c && a.get("drawNormalOnTop") && this.drawNormalRange(o, n, g, f, l), E = C.length;for (K = 0; K < E; K++) {
	          e.drawShape(C[K], a.get("lineColor"), c, a.get("lineWidth")).append();
	        }if (i && a.get("valueSpots")) {
	          F = a.get("valueSpots"), F.get === c && (F = new t(F));for (K = 0; K < B; K++) {
	            H = F.get(J[K]), H && e.drawCircle(o + b.round((I[K] - this.minx) * (f / k)), n + b.round(g - g * ((J[K] - this.miny) / l)), i, c, H).append();
	          }
	        }i && a.get("spotColor") && J[m] !== null && e.drawCircle(o + b.round((I[I.length - 1] - this.minx) * (f / k)), n + b.round(g - g * ((J[m] - this.miny) / l)), i, c, a.get("spotColor")).append(), this.maxy !== this.minyorg && (i && a.get("minSpotColor") && (s = I[d.inArray(this.minyorg, J)], e.drawCircle(o + b.round((s - this.minx) * (f / k)), n + b.round(g - g * ((this.minyorg - this.miny) / l)), i, c, a.get("minSpotColor")).append()), i && a.get("maxSpotColor") && (s = I[d.inArray(this.maxyorg, J)], e.drawCircle(o + b.round((s - this.minx) * (f / k)), n + b.round(g - g * ((this.maxyorg - this.miny) / l)), i, c, a.get("maxSpotColor")).append())), this.lastShapeId = e.getLastShapeId(), this.canvasTop = n, e.render();
	      } }), d.fn.sparkline.bar = y = g(d.fn.sparkline._base, w, { type: "bar", init: function init(a, e, f, g, h) {
	        var j = parseInt(f.get("barWidth"), 10),
	            n = parseInt(f.get("barSpacing"), 10),
	            o = f.get("chartRangeMin"),
	            p = f.get("chartRangeMax"),
	            q = f.get("chartRangeClip"),
	            r = Infinity,
	            s = -Infinity,
	            u,
	            v,
	            w,
	            x,
	            z,
	            A,
	            B,
	            C,
	            D,
	            E,
	            F,
	            G,
	            H,
	            I,
	            J,
	            K,
	            L,
	            M,
	            N,
	            O,
	            P,
	            Q,
	            R;y._super.init.call(this, a, e, f, g, h);for (A = 0, B = e.length; A < B; A++) {
	          O = e[A], u = typeof O == "string" && O.indexOf(":") > -1;if (u || d.isArray(O)) J = !0, u && (O = e[A] = l(O.split(":"))), O = m(O, null), v = b.min.apply(b, O), w = b.max.apply(b, O), v < r && (r = v), w > s && (s = w);
	        }this.stacked = J, this.regionShapes = {}, this.barWidth = j, this.barSpacing = n, this.totalBarWidth = j + n, this.width = g = e.length * j + (e.length - 1) * n, this.initTarget(), q && (H = o === c ? -Infinity : o, I = p === c ? Infinity : p), z = [], x = J ? [] : z;var S = [],
	            T = [];for (A = 0, B = e.length; A < B; A++) {
	          if (J) {
	            K = e[A], e[A] = N = [], S[A] = 0, x[A] = T[A] = 0;for (L = 0, M = K.length; L < M; L++) {
	              O = N[L] = q ? i(K[L], H, I) : K[L], O !== null && (O > 0 && (S[A] += O), r < 0 && s > 0 ? O < 0 ? T[A] += b.abs(O) : x[A] += O : x[A] += b.abs(O - (O < 0 ? s : r)), z.push(O));
	            }
	          } else O = q ? i(e[A], H, I) : e[A], O = e[A] = k(O), O !== null && z.push(O);
	        }this.max = G = b.max.apply(b, z), this.min = F = b.min.apply(b, z), this.stackMax = s = J ? b.max.apply(b, S) : G, this.stackMin = r = J ? b.min.apply(b, z) : F, f.get("chartRangeMin") !== c && (f.get("chartRangeClip") || f.get("chartRangeMin") < F) && (F = f.get("chartRangeMin")), f.get("chartRangeMax") !== c && (f.get("chartRangeClip") || f.get("chartRangeMax") > G) && (G = f.get("chartRangeMax")), this.zeroAxis = D = f.get("zeroAxis", !0), F <= 0 && G >= 0 && D ? E = 0 : D == 0 ? E = F : F > 0 ? E = F : E = G, this.xaxisOffset = E, C = J ? b.max.apply(b, x) + b.max.apply(b, T) : G - F, this.canvasHeightEf = D && F < 0 ? this.canvasHeight - 2 : this.canvasHeight - 1, F < E ? (Q = J && G >= 0 ? s : G, P = (Q - E) / C * this.canvasHeight, P !== b.ceil(P) && (this.canvasHeightEf -= 2, P = b.ceil(P))) : P = this.canvasHeight, this.yoffset = P, d.isArray(f.get("colorMap")) ? (this.colorMapByIndex = f.get("colorMap"), this.colorMapByValue = null) : (this.colorMapByIndex = null, this.colorMapByValue = f.get("colorMap"), this.colorMapByValue && this.colorMapByValue.get === c && (this.colorMapByValue = new t(this.colorMapByValue))), this.range = C;
	      }, getRegion: function getRegion(a, d, e) {
	        var f = b.floor(d / this.totalBarWidth);return f < 0 || f >= this.values.length ? c : f;
	      }, getCurrentRegionFields: function getCurrentRegionFields() {
	        var a = this.currentRegion,
	            b = r(this.values[a]),
	            c = [],
	            d,
	            e;for (e = b.length; e--;) {
	          d = b[e], c.push({ isNull: d === null, value: d, color: this.calcColor(e, d, a), offset: a });
	        }return c;
	      }, calcColor: function calcColor(a, b, e) {
	        var f = this.colorMapByIndex,
	            g = this.colorMapByValue,
	            h = this.options,
	            i,
	            j;return this.stacked ? i = h.get("stackedBarColor") : i = b < 0 ? h.get("negBarColor") : h.get("barColor"), b === 0 && h.get("zeroColor") !== c && (i = h.get("zeroColor")), g && (j = g.get(b)) ? i = j : f && f.length > e && (i = f[e]), d.isArray(i) ? i[a % i.length] : i;
	      }, renderRegion: function renderRegion(a, e) {
	        var f = this.values[a],
	            g = this.options,
	            h = this.xaxisOffset,
	            i = [],
	            j = this.range,
	            k = this.stacked,
	            l = this.target,
	            m = a * this.totalBarWidth,
	            n = this.canvasHeightEf,
	            p = this.yoffset,
	            q,
	            r,
	            s,
	            t,
	            u,
	            v,
	            w,
	            x,
	            y,
	            z;f = d.isArray(f) ? f : [f], w = f.length, x = f[0], t = o(null, f), z = o(h, f, !0);if (t) return g.get("nullColor") ? (s = e ? g.get("nullColor") : this.calcHighlightColor(g.get("nullColor"), g), q = p > 0 ? p - 1 : p, l.drawRect(m, q, this.barWidth - 1, 0, s, s)) : c;u = p;for (v = 0; v < w; v++) {
	          x = f[v];if (k && x === h) {
	            if (!z || y) continue;y = !0;
	          }j > 0 ? r = b.floor(n * (b.abs(x - h) / j)) + 1 : r = 1, x < h || x === h && p === 0 ? (q = u, u += r) : (q = p - r, p -= r), s = this.calcColor(v, x, a), e && (s = this.calcHighlightColor(s, g)), i.push(l.drawRect(m, q, this.barWidth - 1, r - 1, s, s));
	        }return i.length === 1 ? i[0] : i;
	      } }), d.fn.sparkline.tristate = z = g(d.fn.sparkline._base, w, { type: "tristate", init: function init(a, b, e, f, g) {
	        var h = parseInt(e.get("barWidth"), 10),
	            i = parseInt(e.get("barSpacing"), 10);z._super.init.call(this, a, b, e, f, g), this.regionShapes = {}, this.barWidth = h, this.barSpacing = i, this.totalBarWidth = h + i, this.values = d.map(b, Number), this.width = f = b.length * h + (b.length - 1) * i, d.isArray(e.get("colorMap")) ? (this.colorMapByIndex = e.get("colorMap"), this.colorMapByValue = null) : (this.colorMapByIndex = null, this.colorMapByValue = e.get("colorMap"), this.colorMapByValue && this.colorMapByValue.get === c && (this.colorMapByValue = new t(this.colorMapByValue))), this.initTarget();
	      }, getRegion: function getRegion(a, c, d) {
	        return b.floor(c / this.totalBarWidth);
	      }, getCurrentRegionFields: function getCurrentRegionFields() {
	        var a = this.currentRegion;return { isNull: this.values[a] === c, value: this.values[a], color: this.calcColor(this.values[a], a), offset: a };
	      }, calcColor: function calcColor(a, b) {
	        var c = this.values,
	            d = this.options,
	            e = this.colorMapByIndex,
	            f = this.colorMapByValue,
	            g,
	            h;return f && (h = f.get(a)) ? g = h : e && e.length > b ? g = e[b] : c[b] < 0 ? g = d.get("negBarColor") : c[b] > 0 ? g = d.get("posBarColor") : g = d.get("zeroBarColor"), g;
	      }, renderRegion: function renderRegion(a, c) {
	        var d = this.values,
	            e = this.options,
	            f = this.target,
	            g,
	            h,
	            i,
	            j,
	            k,
	            l;g = f.pixelHeight, i = b.round(g / 2), j = a * this.totalBarWidth, d[a] < 0 ? (k = i, h = i - 1) : d[a] > 0 ? (k = 0, h = i - 1) : (k = i - 1, h = 2), l = this.calcColor(d[a], a);if (l === null) return;return c && (l = this.calcHighlightColor(l, e)), f.drawRect(j, k, this.barWidth - 1, h - 1, l, l);
	      } }), d.fn.sparkline.discrete = A = g(d.fn.sparkline._base, w, { type: "discrete", init: function init(a, e, f, g, h) {
	        A._super.init.call(this, a, e, f, g, h), this.regionShapes = {}, this.values = e = d.map(e, Number), this.min = b.min.apply(b, e), this.max = b.max.apply(b, e), this.range = this.max - this.min, this.width = g = f.get("width") === "auto" ? e.length * 2 : this.width, this.interval = b.floor(g / e.length), this.itemWidth = g / e.length, f.get("chartRangeMin") !== c && (f.get("chartRangeClip") || f.get("chartRangeMin") < this.min) && (this.min = f.get("chartRangeMin")), f.get("chartRangeMax") !== c && (f.get("chartRangeClip") || f.get("chartRangeMax") > this.max) && (this.max = f.get("chartRangeMax")), this.initTarget(), this.target && (this.lineHeight = f.get("lineHeight") === "auto" ? b.round(this.canvasHeight * .3) : f.get("lineHeight"));
	      }, getRegion: function getRegion(a, c, d) {
	        return b.floor(c / this.itemWidth);
	      }, getCurrentRegionFields: function getCurrentRegionFields() {
	        var a = this.currentRegion;return { isNull: this.values[a] === c, value: this.values[a], offset: a };
	      }, renderRegion: function renderRegion(a, c) {
	        var d = this.values,
	            e = this.options,
	            f = this.min,
	            g = this.max,
	            h = this.range,
	            j = this.interval,
	            k = this.target,
	            l = this.canvasHeight,
	            m = this.lineHeight,
	            n = l - m,
	            o,
	            p,
	            q,
	            r;return p = i(d[a], f, g), r = a * j, o = b.round(n - n * ((p - f) / h)), q = e.get("thresholdColor") && p < e.get("thresholdValue") ? e.get("thresholdColor") : e.get("lineColor"), c && (q = this.calcHighlightColor(q, e)), k.drawLine(r, o, r, o + m, q);
	      } }), d.fn.sparkline.bullet = B = g(d.fn.sparkline._base, { type: "bullet", init: function init(a, d, e, f, g) {
	        var h, i, j;B._super.init.call(this, a, d, e, f, g), this.values = d = l(d), j = d.slice(), j[0] = j[0] === null ? j[2] : j[0], j[1] = d[1] === null ? j[2] : j[1], h = b.min.apply(b, d), i = b.max.apply(b, d), e.get("base") === c ? h = h < 0 ? h : 0 : h = e.get("base"), this.min = h, this.max = i, this.range = i - h, this.shapes = {}, this.valueShapes = {}, this.regiondata = {}, this.width = f = e.get("width") === "auto" ? "4.0em" : f, this.target = this.$el.simpledraw(f, g, e.get("composite")), d.length || (this.disabled = !0), this.initTarget();
	      }, getRegion: function getRegion(a, b, d) {
	        var e = this.target.getShapeAt(a, b, d);return e !== c && this.shapes[e] !== c ? this.shapes[e] : c;
	      }, getCurrentRegionFields: function getCurrentRegionFields() {
	        var a = this.currentRegion;return { fieldkey: a.substr(0, 1), value: this.values[a.substr(1)], region: a };
	      }, changeHighlight: function changeHighlight(a) {
	        var b = this.currentRegion,
	            c = this.valueShapes[b],
	            d;delete this.shapes[c];switch (b.substr(0, 1)) {case "r":
	            d = this.renderRange(b.substr(1), a);break;case "p":
	            d = this.renderPerformance(a);break;case "t":
	            d = this.renderTarget(a);}this.valueShapes[b] = d.id, this.shapes[d.id] = b, this.target.replaceWithShape(c, d);
	      }, renderRange: function renderRange(a, c) {
	        var d = this.values[a],
	            e = b.round(this.canvasWidth * ((d - this.min) / this.range)),
	            f = this.options.get("rangeColors")[a - 2];return c && (f = this.calcHighlightColor(f, this.options)), this.target.drawRect(0, 0, e - 1, this.canvasHeight - 1, f, f);
	      }, renderPerformance: function renderPerformance(a) {
	        var c = this.values[1],
	            d = b.round(this.canvasWidth * ((c - this.min) / this.range)),
	            e = this.options.get("performanceColor");return a && (e = this.calcHighlightColor(e, this.options)), this.target.drawRect(0, b.round(this.canvasHeight * .3), d - 1, b.round(this.canvasHeight * .4) - 1, e, e);
	      }, renderTarget: function renderTarget(a) {
	        var c = this.values[0],
	            d = b.round(this.canvasWidth * ((c - this.min) / this.range) - this.options.get("targetWidth") / 2),
	            e = b.round(this.canvasHeight * .1),
	            f = this.canvasHeight - e * 2,
	            g = this.options.get("targetColor");return a && (g = this.calcHighlightColor(g, this.options)), this.target.drawRect(d, e, this.options.get("targetWidth") - 1, f - 1, g, g);
	      }, render: function render() {
	        var a = this.values.length,
	            b = this.target,
	            c,
	            d;if (!B._super.render.call(this)) return;for (c = 2; c < a; c++) {
	          d = this.renderRange(c).append(), this.shapes[d.id] = "r" + c, this.valueShapes["r" + c] = d.id;
	        }this.values[1] !== null && (d = this.renderPerformance().append(), this.shapes[d.id] = "p1", this.valueShapes.p1 = d.id), this.values[0] !== null && (d = this.renderTarget().append(), this.shapes[d.id] = "t0", this.valueShapes.t0 = d.id), b.render();
	      } }), d.fn.sparkline.pie = C = g(d.fn.sparkline._base, { type: "pie", init: function init(a, c, e, f, g) {
	        var h = 0,
	            i;C._super.init.call(this, a, c, e, f, g), this.shapes = {}, this.valueShapes = {}, this.values = c = d.map(c, Number), e.get("width") === "auto" && (this.width = this.height);if (c.length > 0) for (i = c.length; i--;) {
	          h += c[i];
	        }this.total = h, this.initTarget(), this.radius = b.floor(b.min(this.canvasWidth, this.canvasHeight) / 2);
	      }, getRegion: function getRegion(a, b, d) {
	        var e = this.target.getShapeAt(a, b, d);return e !== c && this.shapes[e] !== c ? this.shapes[e] : c;
	      }, getCurrentRegionFields: function getCurrentRegionFields() {
	        var a = this.currentRegion;return { isNull: this.values[a] === c, value: this.values[a], percent: this.values[a] / this.total * 100, color: this.options.get("sliceColors")[a % this.options.get("sliceColors").length], offset: a };
	      }, changeHighlight: function changeHighlight(a) {
	        var b = this.currentRegion,
	            c = this.renderSlice(b, a),
	            d = this.valueShapes[b];delete this.shapes[d], this.target.replaceWithShape(d, c), this.valueShapes[b] = c.id, this.shapes[c.id] = b;
	      }, renderSlice: function renderSlice(a, d) {
	        var e = this.target,
	            f = this.options,
	            g = this.radius,
	            h = f.get("borderWidth"),
	            i = f.get("offset"),
	            j = 2 * b.PI,
	            k = this.values,
	            l = this.total,
	            m = i ? 2 * b.PI * (i / 360) : 0,
	            n,
	            o,
	            p,
	            q,
	            r;q = k.length;for (p = 0; p < q; p++) {
	          n = m, o = m, l > 0 && (o = m + j * (k[p] / l));if (a === p) return r = f.get("sliceColors")[p % f.get("sliceColors").length], d && (r = this.calcHighlightColor(r, f)), e.drawPieSlice(g, g, g - h, n, o, c, r);m = o;
	        }
	      }, render: function render() {
	        var a = this.target,
	            d = this.values,
	            e = this.options,
	            f = this.radius,
	            g = e.get("borderWidth"),
	            h,
	            i;if (!C._super.render.call(this)) return;g && a.drawCircle(f, f, b.floor(f - g / 2), e.get("borderColor"), c, g).append();for (i = d.length; i--;) {
	          d[i] && (h = this.renderSlice(i).append(), this.valueShapes[i] = h.id, this.shapes[h.id] = i);
	        }a.render();
	      } }), d.fn.sparkline.box = D = g(d.fn.sparkline._base, { type: "box", init: function init(a, b, c, e, f) {
	        D._super.init.call(this, a, b, c, e, f), this.values = d.map(b, Number), this.width = c.get("width") === "auto" ? "4.0em" : e, this.initTarget(), this.values.length || (this.disabled = 1);
	      }, getRegion: function getRegion() {
	        return 1;
	      }, getCurrentRegionFields: function getCurrentRegionFields() {
	        var a = [{ field: "lq", value: this.quartiles[0] }, { field: "med", value: this.quartiles[1] }, { field: "uq", value: this.quartiles[2] }];return this.loutlier !== c && a.push({ field: "lo", value: this.loutlier }), this.routlier !== c && a.push({ field: "ro", value: this.routlier }), this.lwhisker !== c && a.push({ field: "lw", value: this.lwhisker }), this.rwhisker !== c && a.push({ field: "rw", value: this.rwhisker }), a;
	      }, render: function render() {
	        var a = this.target,
	            d = this.values,
	            e = d.length,
	            f = this.options,
	            g = this.canvasWidth,
	            h = this.canvasHeight,
	            i = f.get("chartRangeMin") === c ? b.min.apply(b, d) : f.get("chartRangeMin"),
	            k = f.get("chartRangeMax") === c ? b.max.apply(b, d) : f.get("chartRangeMax"),
	            l = 0,
	            m,
	            n,
	            o,
	            p,
	            q,
	            r,
	            s,
	            t,
	            u,
	            v,
	            w;if (!D._super.render.call(this)) return;if (f.get("raw")) f.get("showOutliers") && d.length > 5 ? (n = d[0], m = d[1], p = d[2], q = d[3], r = d[4], s = d[5], t = d[6]) : (m = d[0], p = d[1], q = d[2], r = d[3], s = d[4]);else {
	          d.sort(function (a, b) {
	            return a - b;
	          }), p = j(d, 1), q = j(d, 2), r = j(d, 3), o = r - p;if (f.get("showOutliers")) {
	            m = s = c;for (u = 0; u < e; u++) {
	              m === c && d[u] > p - o * f.get("outlierIQR") && (m = d[u]), d[u] < r + o * f.get("outlierIQR") && (s = d[u]);
	            }n = d[0], t = d[e - 1];
	          } else m = d[0], s = d[e - 1];
	        }this.quartiles = [p, q, r], this.lwhisker = m, this.rwhisker = s, this.loutlier = n, this.routlier = t, w = g / (k - i + 1), f.get("showOutliers") && (l = b.ceil(f.get("spotRadius")), g -= 2 * b.ceil(f.get("spotRadius")), w = g / (k - i + 1), n < m && a.drawCircle((n - i) * w + l, h / 2, f.get("spotRadius"), f.get("outlierLineColor"), f.get("outlierFillColor")).append(), t > s && a.drawCircle((t - i) * w + l, h / 2, f.get("spotRadius"), f.get("outlierLineColor"), f.get("outlierFillColor")).append()), a.drawRect(b.round((p - i) * w + l), b.round(h * .1), b.round((r - p) * w), b.round(h * .8), f.get("boxLineColor"), f.get("boxFillColor")).append(), a.drawLine(b.round((m - i) * w + l), b.round(h / 2), b.round((p - i) * w + l), b.round(h / 2), f.get("lineColor")).append(), a.drawLine(b.round((m - i) * w + l), b.round(h / 4), b.round((m - i) * w + l), b.round(h - h / 4), f.get("whiskerColor")).append(), a.drawLine(b.round((s - i) * w + l), b.round(h / 2), b.round((r - i) * w + l), b.round(h / 2), f.get("lineColor")).append(), a.drawLine(b.round((s - i) * w + l), b.round(h / 4), b.round((s - i) * w + l), b.round(h - h / 4), f.get("whiskerColor")).append(), a.drawLine(b.round((q - i) * w + l), b.round(h * .1), b.round((q - i) * w + l), b.round(h * .9), f.get("medianColor")).append(), f.get("target") && (v = b.ceil(f.get("spotRadius")), a.drawLine(b.round((f.get("target") - i) * w + l), b.round(h / 2 - v), b.round((f.get("target") - i) * w + l), b.round(h / 2 + v), f.get("targetColor")).append(), a.drawLine(b.round((f.get("target") - i) * w + l - v), b.round(h / 2), b.round((f.get("target") - i) * w + l + v), b.round(h / 2), f.get("targetColor")).append()), a.render();
	      } }), G = g({ init: function init(a, b, c, d) {
	        this.target = a, this.id = b, this.type = c, this.args = d;
	      }, append: function append() {
	        return this.target.appendShape(this), this;
	      } }), H = g({ _pxregex: /(\d+)(px)?\s*$/i, init: function init(a, b, c) {
	        if (!a) return;this.width = a, this.height = b, this.target = c, this.lastShapeId = null, c[0] && (c = c[0]), d.data(c, "_jqs_vcanvas", this);
	      }, drawLine: function drawLine(a, b, c, d, e, f) {
	        return this.drawShape([[a, b], [c, d]], e, f);
	      }, drawShape: function drawShape(a, b, c, d) {
	        return this._genShape("Shape", [a, b, c, d]);
	      }, drawCircle: function drawCircle(a, b, c, d, e, f) {
	        return this._genShape("Circle", [a, b, c, d, e, f]);
	      }, drawPieSlice: function drawPieSlice(a, b, c, d, e, f, g) {
	        return this._genShape("PieSlice", [a, b, c, d, e, f, g]);
	      }, drawRect: function drawRect(a, b, c, d, e, f) {
	        return this._genShape("Rect", [a, b, c, d, e, f]);
	      }, getElement: function getElement() {
	        return this.canvas;
	      }, getLastShapeId: function getLastShapeId() {
	        return this.lastShapeId;
	      }, reset: function reset() {
	        alert("reset not implemented");
	      }, _insert: function _insert(a, b) {
	        d(b).html(a);
	      }, _calculatePixelDims: function _calculatePixelDims(a, b, c) {
	        var e;e = this._pxregex.exec(b), e ? this.pixelHeight = e[1] : this.pixelHeight = d(c).height(), e = this._pxregex.exec(a), e ? this.pixelWidth = e[1] : this.pixelWidth = d(c).width();
	      }, _genShape: function _genShape(a, b) {
	        var c = L++;return b.unshift(c), new G(this, c, a, b);
	      }, appendShape: function appendShape(a) {
	        alert("appendShape not implemented");
	      }, replaceWithShape: function replaceWithShape(a, b) {
	        alert("replaceWithShape not implemented");
	      }, insertAfterShape: function insertAfterShape(a, b) {
	        alert("insertAfterShape not implemented");
	      }, removeShapeId: function removeShapeId(a) {
	        alert("removeShapeId not implemented");
	      }, getShapeAt: function getShapeAt(a, b, c) {
	        alert("getShapeAt not implemented");
	      }, render: function render() {
	        alert("render not implemented");
	      } }), I = g(H, { init: function init(b, e, f, g) {
	        I._super.init.call(this, b, e, f), this.canvas = a.createElement("canvas"), f[0] && (f = f[0]), d.data(f, "_jqs_vcanvas", this), d(this.canvas).css({ display: "inline-block", width: b, height: e, verticalAlign: "top" }), this._insert(this.canvas, f), this._calculatePixelDims(b, e, this.canvas), this.canvas.width = this.pixelWidth, this.canvas.height = this.pixelHeight, this.interact = g, this.shapes = {}, this.shapeseq = [], this.currentTargetShapeId = c, d(this.canvas).css({ width: this.pixelWidth, height: this.pixelHeight });
	      }, _getContext: function _getContext(a, b, d) {
	        var e = this.canvas.getContext("2d");return a !== c && (e.strokeStyle = a), e.lineWidth = d === c ? 1 : d, b !== c && (e.fillStyle = b), e;
	      }, reset: function reset() {
	        var a = this._getContext();a.clearRect(0, 0, this.pixelWidth, this.pixelHeight), this.shapes = {}, this.shapeseq = [], this.currentTargetShapeId = c;
	      }, _drawShape: function _drawShape(a, b, d, e, f) {
	        var g = this._getContext(d, e, f),
	            h,
	            i;g.beginPath(), g.moveTo(b[0][0] + .5, b[0][1] + .5);for (h = 1, i = b.length; h < i; h++) {
	          g.lineTo(b[h][0] + .5, b[h][1] + .5);
	        }d !== c && g.stroke(), e !== c && g.fill(), this.targetX !== c && this.targetY !== c && g.isPointInPath(this.targetX, this.targetY) && (this.currentTargetShapeId = a);
	      }, _drawCircle: function _drawCircle(a, d, e, f, g, h, i) {
	        var j = this._getContext(g, h, i);j.beginPath(), j.arc(d, e, f, 0, 2 * b.PI, !1), this.targetX !== c && this.targetY !== c && j.isPointInPath(this.targetX, this.targetY) && (this.currentTargetShapeId = a), g !== c && j.stroke(), h !== c && j.fill();
	      }, _drawPieSlice: function _drawPieSlice(a, b, d, e, f, g, h, i) {
	        var j = this._getContext(h, i);j.beginPath(), j.moveTo(b, d), j.arc(b, d, e, f, g, !1), j.lineTo(b, d), j.closePath(), h !== c && j.stroke(), i && j.fill(), this.targetX !== c && this.targetY !== c && j.isPointInPath(this.targetX, this.targetY) && (this.currentTargetShapeId = a);
	      }, _drawRect: function _drawRect(a, b, c, d, e, f, g) {
	        return this._drawShape(a, [[b, c], [b + d, c], [b + d, c + e], [b, c + e], [b, c]], f, g);
	      }, appendShape: function appendShape(a) {
	        return this.shapes[a.id] = a, this.shapeseq.push(a.id), this.lastShapeId = a.id, a.id;
	      }, replaceWithShape: function replaceWithShape(a, b) {
	        var c = this.shapeseq,
	            d;this.shapes[b.id] = b;for (d = c.length; d--;) {
	          c[d] == a && (c[d] = b.id);
	        }delete this.shapes[a];
	      }, replaceWithShapes: function replaceWithShapes(a, b) {
	        var c = this.shapeseq,
	            d = {},
	            e,
	            f,
	            g;for (f = a.length; f--;) {
	          d[a[f]] = !0;
	        }for (f = c.length; f--;) {
	          e = c[f], d[e] && (c.splice(f, 1), delete this.shapes[e], g = f);
	        }for (f = b.length; f--;) {
	          c.splice(g, 0, b[f].id), this.shapes[b[f].id] = b[f];
	        }
	      }, insertAfterShape: function insertAfterShape(a, b) {
	        var c = this.shapeseq,
	            d;for (d = c.length; d--;) {
	          if (c[d] === a) {
	            c.splice(d + 1, 0, b.id), this.shapes[b.id] = b;return;
	          }
	        }
	      }, removeShapeId: function removeShapeId(a) {
	        var b = this.shapeseq,
	            c;for (c = b.length; c--;) {
	          if (b[c] === a) {
	            b.splice(c, 1);break;
	          }
	        }delete this.shapes[a];
	      }, getShapeAt: function getShapeAt(a, b, c) {
	        return this.targetX = b, this.targetY = c, this.render(), this.currentTargetShapeId;
	      }, render: function render() {
	        var a = this.shapeseq,
	            b = this.shapes,
	            c = a.length,
	            d = this._getContext(),
	            e,
	            f,
	            g;d.clearRect(0, 0, this.pixelWidth, this.pixelHeight);for (g = 0; g < c; g++) {
	          e = a[g], f = b[e], this["_draw" + f.type].apply(this, f.args);
	        }this.interact || (this.shapes = {}, this.shapeseq = []);
	      } }), J = g(H, { init: function init(b, c, e) {
	        var f;J._super.init.call(this, b, c, e), e[0] && (e = e[0]), d.data(e, "_jqs_vcanvas", this), this.canvas = a.createElement("span"), d(this.canvas).css({ display: "inline-block", position: "relative", overflow: "hidden", width: b, height: c, margin: "0px", padding: "0px", verticalAlign: "top" }), this._insert(this.canvas, e), this._calculatePixelDims(b, c, this.canvas), this.canvas.width = this.pixelWidth, this.canvas.height = this.pixelHeight, f = '<v:group coordorigin="0 0" coordsize="' + this.pixelWidth + " " + this.pixelHeight + '"' + ' style="position:absolute;top:0;left:0;width:' + this.pixelWidth + "px;height=" + this.pixelHeight + 'px;"></v:group>', this.canvas.insertAdjacentHTML("beforeEnd", f), this.group = d(this.canvas).children()[0], this.rendered = !1, this.prerender = "";
	      }, _drawShape: function _drawShape(a, b, d, e, f) {
	        var g = [],
	            h,
	            i,
	            j,
	            k,
	            l,
	            m,
	            n;for (n = 0, m = b.length; n < m; n++) {
	          g[n] = "" + b[n][0] + "," + b[n][1];
	        }return h = g.splice(0, 1), f = f === c ? 1 : f, i = d === c ? ' stroked="false" ' : ' strokeWeight="' + f + 'px" strokeColor="' + d + '" ', j = e === c ? ' filled="false"' : ' fillColor="' + e + '" filled="true" ', k = g[0] === g[g.length - 1] ? "x " : "", l = '<v:shape coordorigin="0 0" coordsize="' + this.pixelWidth + " " + this.pixelHeight + '" ' + ' id="jqsshape' + a + '" ' + i + j + ' style="position:absolute;left:0px;top:0px;height:' + this.pixelHeight + "px;width:" + this.pixelWidth + 'px;padding:0px;margin:0px;" ' + ' path="m ' + h + " l " + g.join(", ") + " " + k + 'e">' + " </v:shape>", l;
	      }, _drawCircle: function _drawCircle(a, b, d, e, f, g, h) {
	        var i, j, k;return b -= e, d -= e, i = f === c ? ' stroked="false" ' : ' strokeWeight="' + h + 'px" strokeColor="' + f + '" ', j = g === c ? ' filled="false"' : ' fillColor="' + g + '" filled="true" ', k = '<v:oval  id="jqsshape' + a + '" ' + i + j + ' style="position:absolute;top:' + d + "px; left:" + b + "px; width:" + e * 2 + "px; height:" + e * 2 + 'px"></v:oval>', k;
	      }, _drawPieSlice: function _drawPieSlice(a, d, e, f, g, h, i, j) {
	        var k, l, m, n, o, p, q, r;if (g === h) return "";h - g === 2 * b.PI && (g = 0, h = 2 * b.PI), l = d + b.round(b.cos(g) * f), m = e + b.round(b.sin(g) * f), n = d + b.round(b.cos(h) * f), o = e + b.round(b.sin(h) * f);if (l === n && m === o) {
	          if (h - g < b.PI) return "";l = n = d + f, m = o = e;
	        }return l === n && m === o && h - g < b.PI ? "" : (k = [d - f, e - f, d + f, e + f, l, m, n, o], p = i === c ? ' stroked="false" ' : ' strokeWeight="1px" strokeColor="' + i + '" ', q = j === c ? ' filled="false"' : ' fillColor="' + j + '" filled="true" ', r = '<v:shape coordorigin="0 0" coordsize="' + this.pixelWidth + " " + this.pixelHeight + '" ' + ' id="jqsshape' + a + '" ' + p + q + ' style="position:absolute;left:0px;top:0px;height:' + this.pixelHeight + "px;width:" + this.pixelWidth + 'px;padding:0px;margin:0px;" ' + ' path="m ' + d + "," + e + " wa " + k.join(", ") + ' x e">' + " </v:shape>", r);
	      }, _drawRect: function _drawRect(a, b, c, d, e, f, g) {
	        return this._drawShape(a, [[b, c], [b, c + e], [b + d, c + e], [b + d, c], [b, c]], f, g);
	      }, reset: function reset() {
	        this.group.innerHTML = "";
	      }, appendShape: function appendShape(a) {
	        var b = this["_draw" + a.type].apply(this, a.args);return this.rendered ? this.group.insertAdjacentHTML("beforeEnd", b) : this.prerender += b, this.lastShapeId = a.id, a.id;
	      }, replaceWithShape: function replaceWithShape(a, b) {
	        var c = d("#jqsshape" + a),
	            e = this["_draw" + b.type].apply(this, b.args);c[0].outerHTML = e;
	      }, replaceWithShapes: function replaceWithShapes(a, b) {
	        var c = d("#jqsshape" + a[0]),
	            e = "",
	            f = b.length,
	            g;for (g = 0; g < f; g++) {
	          e += this["_draw" + b[g].type].apply(this, b[g].args);
	        }c[0].outerHTML = e;for (g = 1; g < a.length; g++) {
	          d("#jqsshape" + a[g]).remove();
	        }
	      }, insertAfterShape: function insertAfterShape(a, b) {
	        var c = d("#jqsshape" + a),
	            e = this["_draw" + b.type].apply(this, b.args);c[0].insertAdjacentHTML("afterEnd", e);
	      }, removeShapeId: function removeShapeId(a) {
	        var b = d("#jqsshape" + a);this.group.removeChild(b[0]);
	      }, getShapeAt: function getShapeAt(a, b, c) {
	        var d = a.id.substr(8);return d;
	      }, render: function render() {
	        this.rendered || (this.group.innerHTML = this.prerender, this.rendered = !0);
	      } });
	  });
	})(document, Math);

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(973);
	
	__webpack_require__(770);
	
	__webpack_require__(774);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 770 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 771 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Bootstrap-select v1.13.18 (https://developer.snapappointments.com/bootstrap-select)
	 *
	 * Copyright 2012-2020 SnapAppointments, LLC
	 * Licensed under MIT (https://github.com/snapappointments/bootstrap-select/blob/master/LICENSE)
	 */
	
	(function (root, factory) {
	  if (root === undefined && window !== undefined) root = window;
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(103)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
	      return (factory(a0));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory(require("jquery"));
	  } else {
	    factory(root["jQuery"]);
	  }
	}(this, function (jQuery) {
	
	(function ($) {
	  'use strict';
	
	  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn'];
	
	  var uriAttrs = [
	    'background',
	    'cite',
	    'href',
	    'itemtype',
	    'longdesc',
	    'poster',
	    'src',
	    'xlink:href'
	  ];
	
	  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
	
	  var DefaultWhitelist = {
	    // Global attributes allowed on any supplied element below.
	    '*': ['class', 'dir', 'id', 'lang', 'role', 'tabindex', 'style', ARIA_ATTRIBUTE_PATTERN],
	    a: ['target', 'href', 'title', 'rel'],
	    area: [],
	    b: [],
	    br: [],
	    col: [],
	    code: [],
	    div: [],
	    em: [],
	    hr: [],
	    h1: [],
	    h2: [],
	    h3: [],
	    h4: [],
	    h5: [],
	    h6: [],
	    i: [],
	    img: ['src', 'alt', 'title', 'width', 'height'],
	    li: [],
	    ol: [],
	    p: [],
	    pre: [],
	    s: [],
	    small: [],
	    span: [],
	    sub: [],
	    sup: [],
	    strong: [],
	    u: [],
	    ul: []
	  }
	
	  /**
	   * A pattern that recognizes a commonly useful subset of URLs that are safe.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;
	
	  /**
	   * A pattern that matches safe data URLs. Only matches image, video and audio types.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;
	
	  function allowedAttribute (attr, allowedAttributeList) {
	    var attrName = attr.nodeName.toLowerCase()
	
	    if ($.inArray(attrName, allowedAttributeList) !== -1) {
	      if ($.inArray(attrName, uriAttrs) !== -1) {
	        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
	      }
	
	      return true
	    }
	
	    var regExp = $(allowedAttributeList).filter(function (index, value) {
	      return value instanceof RegExp
	    })
	
	    // Check if a regular expression validates the attribute.
	    for (var i = 0, l = regExp.length; i < l; i++) {
	      if (attrName.match(regExp[i])) {
	        return true
	      }
	    }
	
	    return false
	  }
	
	  function sanitizeHtml (unsafeElements, whiteList, sanitizeFn) {
	    if (sanitizeFn && typeof sanitizeFn === 'function') {
	      return sanitizeFn(unsafeElements);
	    }
	
	    var whitelistKeys = Object.keys(whiteList);
	
	    for (var i = 0, len = unsafeElements.length; i < len; i++) {
	      var elements = unsafeElements[i].querySelectorAll('*');
	
	      for (var j = 0, len2 = elements.length; j < len2; j++) {
	        var el = elements[j];
	        var elName = el.nodeName.toLowerCase();
	
	        if (whitelistKeys.indexOf(elName) === -1) {
	          el.parentNode.removeChild(el);
	
	          continue;
	        }
	
	        var attributeList = [].slice.call(el.attributes);
	        var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || []);
	
	        for (var k = 0, len3 = attributeList.length; k < len3; k++) {
	          var attr = attributeList[k];
	
	          if (!allowedAttribute(attr, whitelistedAttributes)) {
	            el.removeAttribute(attr.nodeName);
	          }
	        }
	      }
	    }
	  }
	
	  // Polyfill for browsers with no classList support
	  // Remove in v2
	  if (!('classList' in document.createElement('_'))) {
	    (function (view) {
	      if (!('Element' in view)) return;
	
	      var classListProp = 'classList',
	          protoProp = 'prototype',
	          elemCtrProto = view.Element[protoProp],
	          objCtr = Object,
	          classListGetter = function () {
	            var $elem = $(this);
	
	            return {
	              add: function (classes) {
	                classes = Array.prototype.slice.call(arguments).join(' ');
	                return $elem.addClass(classes);
	              },
	              remove: function (classes) {
	                classes = Array.prototype.slice.call(arguments).join(' ');
	                return $elem.removeClass(classes);
	              },
	              toggle: function (classes, force) {
	                return $elem.toggleClass(classes, force);
	              },
	              contains: function (classes) {
	                return $elem.hasClass(classes);
	              }
	            }
	          };
	
	      if (objCtr.defineProperty) {
	        var classListPropDesc = {
	          get: classListGetter,
	          enumerable: true,
	          configurable: true
	        };
	        try {
	          objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	        } catch (ex) { // IE 8 doesn't support enumerable:true
	          // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
	          // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
	          if (ex.number === undefined || ex.number === -0x7FF5EC54) {
	            classListPropDesc.enumerable = false;
	            objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	          }
	        }
	      } else if (objCtr[protoProp].__defineGetter__) {
	        elemCtrProto.__defineGetter__(classListProp, classListGetter);
	      }
	    }(window));
	  }
	
	  var testElement = document.createElement('_');
	
	  testElement.classList.add('c1', 'c2');
	
	  if (!testElement.classList.contains('c2')) {
	    var _add = DOMTokenList.prototype.add,
	        _remove = DOMTokenList.prototype.remove;
	
	    DOMTokenList.prototype.add = function () {
	      Array.prototype.forEach.call(arguments, _add.bind(this));
	    }
	
	    DOMTokenList.prototype.remove = function () {
	      Array.prototype.forEach.call(arguments, _remove.bind(this));
	    }
	  }
	
	  testElement.classList.toggle('c3', false);
	
	  // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
	  // support the second argument.
	  if (testElement.classList.contains('c3')) {
	    var _toggle = DOMTokenList.prototype.toggle;
	
	    DOMTokenList.prototype.toggle = function (token, force) {
	      if (1 in arguments && !this.contains(token) === !force) {
	        return force;
	      } else {
	        return _toggle.call(this, token);
	      }
	    };
	  }
	
	  testElement = null;
	
	  // shallow array comparison
	  function isEqual (array1, array2) {
	    return array1.length === array2.length && array1.every(function (element, index) {
	      return element === array2[index];
	    });
	  };
	
	  // <editor-fold desc="Shims">
	  if (!String.prototype.startsWith) {
	    (function () {
	      'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
	      var defineProperty = (function () {
	        // IE 8 only supports `Object.defineProperty` on DOM elements
	        try {
	          var object = {};
	          var $defineProperty = Object.defineProperty;
	          var result = $defineProperty(object, object, object) && $defineProperty;
	        } catch (error) {
	        }
	        return result;
	      }());
	      var toString = {}.toString;
	      var startsWith = function (search) {
	        if (this == null) {
	          throw new TypeError();
	        }
	        var string = String(this);
	        if (search && toString.call(search) == '[object RegExp]') {
	          throw new TypeError();
	        }
	        var stringLength = string.length;
	        var searchString = String(search);
	        var searchLength = searchString.length;
	        var position = arguments.length > 1 ? arguments[1] : undefined;
	        // `ToInteger`
	        var pos = position ? Number(position) : 0;
	        if (pos != pos) { // better `isNaN`
	          pos = 0;
	        }
	        var start = Math.min(Math.max(pos, 0), stringLength);
	        // Avoid the `indexOf` call if no match is possible
	        if (searchLength + start > stringLength) {
	          return false;
	        }
	        var index = -1;
	        while (++index < searchLength) {
	          if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
	            return false;
	          }
	        }
	        return true;
	      };
	      if (defineProperty) {
	        defineProperty(String.prototype, 'startsWith', {
	          'value': startsWith,
	          'configurable': true,
	          'writable': true
	        });
	      } else {
	        String.prototype.startsWith = startsWith;
	      }
	    }());
	  }
	
	  if (!Object.keys) {
	    Object.keys = function (
	      o, // object
	      k, // key
	      r  // result array
	    ) {
	      // initialize object and result
	      r = [];
	      // iterate over object keys
	      for (k in o) {
	        // fill result array with non-prototypical keys
	        r.hasOwnProperty.call(o, k) && r.push(k);
	      }
	      // return result
	      return r;
	    };
	  }
	
	  if (HTMLSelectElement && !HTMLSelectElement.prototype.hasOwnProperty('selectedOptions')) {
	    Object.defineProperty(HTMLSelectElement.prototype, 'selectedOptions', {
	      get: function () {
	        return this.querySelectorAll(':checked');
	      }
	    });
	  }
	
	  function getSelectedOptions (select, ignoreDisabled) {
	    var selectedOptions = select.selectedOptions,
	        options = [],
	        opt;
	
	    if (ignoreDisabled) {
	      for (var i = 0, len = selectedOptions.length; i < len; i++) {
	        opt = selectedOptions[i];
	
	        if (!(opt.disabled || opt.parentNode.tagName === 'OPTGROUP' && opt.parentNode.disabled)) {
	          options.push(opt);
	        }
	      }
	
	      return options;
	    }
	
	    return selectedOptions;
	  }
	
	  // much faster than $.val()
	  function getSelectValues (select, selectedOptions) {
	    var value = [],
	        options = selectedOptions || select.selectedOptions,
	        opt;
	
	    for (var i = 0, len = options.length; i < len; i++) {
	      opt = options[i];
	
	      if (!(opt.disabled || opt.parentNode.tagName === 'OPTGROUP' && opt.parentNode.disabled)) {
	        value.push(opt.value);
	      }
	    }
	
	    if (!select.multiple) {
	      return !value.length ? null : value[0];
	    }
	
	    return value;
	  }
	
	  // set data-selected on select element if the value has been programmatically selected
	  // prior to initialization of bootstrap-select
	  // * consider removing or replacing an alternative method *
	  var valHooks = {
	    useDefault: false,
	    _set: $.valHooks.select.set
	  };
	
	  $.valHooks.select.set = function (elem, value) {
	    if (value && !valHooks.useDefault) $(elem).data('selected', true);
	
	    return valHooks._set.apply(this, arguments);
	  };
	
	  var changedArguments = null;
	
	  var EventIsSupported = (function () {
	    try {
	      new Event('change');
	      return true;
	    } catch (e) {
	      return false;
	    }
	  })();
	
	  $.fn.triggerNative = function (eventName) {
	    var el = this[0],
	        event;
	
	    if (el.dispatchEvent) { // for modern browsers & IE9+
	      if (EventIsSupported) {
	        // For modern browsers
	        event = new Event(eventName, {
	          bubbles: true
	        });
	      } else {
	        // For IE since it doesn't support Event constructor
	        event = document.createEvent('Event');
	        event.initEvent(eventName, true, false);
	      }
	
	      el.dispatchEvent(event);
	    } else if (el.fireEvent) { // for IE8
	      event = document.createEventObject();
	      event.eventType = eventName;
	      el.fireEvent('on' + eventName, event);
	    } else {
	      // fall back to jQuery.trigger
	      this.trigger(eventName);
	    }
	  };
	  // </editor-fold>
	
	  function stringSearch (li, searchString, method, normalize) {
	    var stringTypes = [
	          'display',
	          'subtext',
	          'tokens'
	        ],
	        searchSuccess = false;
	
	    for (var i = 0; i < stringTypes.length; i++) {
	      var stringType = stringTypes[i],
	          string = li[stringType];
	
	      if (string) {
	        string = string.toString();
	
	        // Strip HTML tags. This isn't perfect, but it's much faster than any other method
	        if (stringType === 'display') {
	          string = string.replace(/<[^>]+>/g, '');
	        }
	
	        if (normalize) string = normalizeToBase(string);
	        string = string.toUpperCase();
	
	        if (method === 'contains') {
	          searchSuccess = string.indexOf(searchString) >= 0;
	        } else {
	          searchSuccess = string.startsWith(searchString);
	        }
	
	        if (searchSuccess) break;
	      }
	    }
	
	    return searchSuccess;
	  }
	
	  function toInteger (value) {
	    return parseInt(value, 10) || 0;
	  }
	
	  // Borrowed from Lodash (_.deburr)
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboMarksExtendedRange = '\\u1ab0-\\u1aff',
	      rsComboMarksSupplementRange = '\\u1dc0-\\u1dff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange + rsComboMarksExtendedRange + rsComboMarksSupplementRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsCombo = '[' + rsComboRange + ']';
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  function deburrLetter (key) {
	    return deburredLetters[key];
	  };
	
	  function normalizeToBase (string) {
	    string = string.toString();
	    return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	  }
	
	  // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function (map) {
	    var escaper = function (match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped.
	    var source = '(?:' + Object.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function (string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	
	  var htmlEscape = createEscaper(escapeMap);
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var keyCodeMap = {
	    32: ' ',
	    48: '0',
	    49: '1',
	    50: '2',
	    51: '3',
	    52: '4',
	    53: '5',
	    54: '6',
	    55: '7',
	    56: '8',
	    57: '9',
	    59: ';',
	    65: 'A',
	    66: 'B',
	    67: 'C',
	    68: 'D',
	    69: 'E',
	    70: 'F',
	    71: 'G',
	    72: 'H',
	    73: 'I',
	    74: 'J',
	    75: 'K',
	    76: 'L',
	    77: 'M',
	    78: 'N',
	    79: 'O',
	    80: 'P',
	    81: 'Q',
	    82: 'R',
	    83: 'S',
	    84: 'T',
	    85: 'U',
	    86: 'V',
	    87: 'W',
	    88: 'X',
	    89: 'Y',
	    90: 'Z',
	    96: '0',
	    97: '1',
	    98: '2',
	    99: '3',
	    100: '4',
	    101: '5',
	    102: '6',
	    103: '7',
	    104: '8',
	    105: '9'
	  };
	
	  var keyCodes = {
	    ESCAPE: 27, // KeyboardEvent.which value for Escape (Esc) key
	    ENTER: 13, // KeyboardEvent.which value for Enter key
	    SPACE: 32, // KeyboardEvent.which value for space key
	    TAB: 9, // KeyboardEvent.which value for tab key
	    ARROW_UP: 38, // KeyboardEvent.which value for up arrow key
	    ARROW_DOWN: 40 // KeyboardEvent.which value for down arrow key
	  }
	
	  var version = {
	    success: false,
	    major: '3'
	  };
	
	  try {
	    version.full = ($.fn.dropdown.Constructor.VERSION || '').split(' ')[0].split('.');
	    version.major = version.full[0];
	    version.success = true;
	  } catch (err) {
	    // do nothing
	  }
	
	  var selectId = 0;
	
	  var EVENT_KEY = '.bs.select';
	
	  var classNames = {
	    DISABLED: 'disabled',
	    DIVIDER: 'divider',
	    SHOW: 'open',
	    DROPUP: 'dropup',
	    MENU: 'dropdown-menu',
	    MENURIGHT: 'dropdown-menu-right',
	    MENULEFT: 'dropdown-menu-left',
	    // to-do: replace with more advanced template/customization options
	    BUTTONCLASS: 'btn-default',
	    POPOVERHEADER: 'popover-title',
	    ICONBASE: 'glyphicon',
	    TICKICON: 'glyphicon-ok'
	  }
	
	  var Selector = {
	    MENU: '.' + classNames.MENU
	  }
	
	  var elementTemplates = {
	    div: document.createElement('div'),
	    span: document.createElement('span'),
	    i: document.createElement('i'),
	    subtext: document.createElement('small'),
	    a: document.createElement('a'),
	    li: document.createElement('li'),
	    whitespace: document.createTextNode('\u00A0'),
	    fragment: document.createDocumentFragment()
	  }
	
	  elementTemplates.noResults = elementTemplates.li.cloneNode(false);
	  elementTemplates.noResults.className = 'no-results';
	
	  elementTemplates.a.setAttribute('role', 'option');
	  elementTemplates.a.className = 'dropdown-item';
	
	  elementTemplates.subtext.className = 'text-muted';
	
	  elementTemplates.text = elementTemplates.span.cloneNode(false);
	  elementTemplates.text.className = 'text';
	
	  elementTemplates.checkMark = elementTemplates.span.cloneNode(false);
	
	  var REGEXP_ARROW = new RegExp(keyCodes.ARROW_UP + '|' + keyCodes.ARROW_DOWN);
	  var REGEXP_TAB_OR_ESCAPE = new RegExp('^' + keyCodes.TAB + '$|' + keyCodes.ESCAPE);
	
	  var generateOption = {
	    li: function (content, classes, optgroup) {
	      var li = elementTemplates.li.cloneNode(false);
	
	      if (content) {
	        if (content.nodeType === 1 || content.nodeType === 11) {
	          li.appendChild(content);
	        } else {
	          li.innerHTML = content;
	        }
	      }
	
	      if (typeof classes !== 'undefined' && classes !== '') li.className = classes;
	      if (typeof optgroup !== 'undefined' && optgroup !== null) li.classList.add('optgroup-' + optgroup);
	
	      return li;
	    },
	
	    a: function (text, classes, inline) {
	      var a = elementTemplates.a.cloneNode(true);
	
	      if (text) {
	        if (text.nodeType === 11) {
	          a.appendChild(text);
	        } else {
	          a.insertAdjacentHTML('beforeend', text);
	        }
	      }
	
	      if (typeof classes !== 'undefined' && classes !== '') a.classList.add.apply(a.classList, classes.split(/\s+/));
	      if (inline) a.setAttribute('style', inline);
	
	      return a;
	    },
	
	    text: function (options, useFragment) {
	      var textElement = elementTemplates.text.cloneNode(false),
	          subtextElement,
	          iconElement;
	
	      if (options.content) {
	        textElement.innerHTML = options.content;
	      } else {
	        textElement.textContent = options.text;
	
	        if (options.icon) {
	          var whitespace = elementTemplates.whitespace.cloneNode(false);
	
	          // need to use <i> for icons in the button to prevent a breaking change
	          // note: switch to span in next major release
	          iconElement = (useFragment === true ? elementTemplates.i : elementTemplates.span).cloneNode(false);
	          iconElement.className = this.options.iconBase + ' ' + options.icon;
	
	          elementTemplates.fragment.appendChild(iconElement);
	          elementTemplates.fragment.appendChild(whitespace);
	        }
	
	        if (options.subtext) {
	          subtextElement = elementTemplates.subtext.cloneNode(false);
	          subtextElement.textContent = options.subtext;
	          textElement.appendChild(subtextElement);
	        }
	      }
	
	      if (useFragment === true) {
	        while (textElement.childNodes.length > 0) {
	          elementTemplates.fragment.appendChild(textElement.childNodes[0]);
	        }
	      } else {
	        elementTemplates.fragment.appendChild(textElement);
	      }
	
	      return elementTemplates.fragment;
	    },
	
	    label: function (options) {
	      var textElement = elementTemplates.text.cloneNode(false),
	          subtextElement,
	          iconElement;
	
	      textElement.innerHTML = options.display;
	
	      if (options.icon) {
	        var whitespace = elementTemplates.whitespace.cloneNode(false);
	
	        iconElement = elementTemplates.span.cloneNode(false);
	        iconElement.className = this.options.iconBase + ' ' + options.icon;
	
	        elementTemplates.fragment.appendChild(iconElement);
	        elementTemplates.fragment.appendChild(whitespace);
	      }
	
	      if (options.subtext) {
	        subtextElement = elementTemplates.subtext.cloneNode(false);
	        subtextElement.textContent = options.subtext;
	        textElement.appendChild(subtextElement);
	      }
	
	      elementTemplates.fragment.appendChild(textElement);
	
	      return elementTemplates.fragment;
	    }
	  }
	
	  function showNoResults (searchMatch, searchValue) {
	    if (!searchMatch.length) {
	      elementTemplates.noResults.innerHTML = this.options.noneResultsText.replace('{0}', '"' + htmlEscape(searchValue) + '"');
	      this.$menuInner[0].firstChild.appendChild(elementTemplates.noResults);
	    }
	  }
	
	  var Selectpicker = function (element, options) {
	    var that = this;
	
	    // bootstrap-select has been initialized - revert valHooks.select.set back to its original function
	    if (!valHooks.useDefault) {
	      $.valHooks.select.set = valHooks._set;
	      valHooks.useDefault = true;
	    }
	
	    this.$element = $(element);
	    this.$newElement = null;
	    this.$button = null;
	    this.$menu = null;
	    this.options = options;
	    this.selectpicker = {
	      main: {},
	      search: {},
	      current: {}, // current changes if a search is in progress
	      view: {},
	      isSearching: false,
	      keydown: {
	        keyHistory: '',
	        resetKeyHistory: {
	          start: function () {
	            return setTimeout(function () {
	              that.selectpicker.keydown.keyHistory = '';
	            }, 800);
	          }
	        }
	      }
	    };
	
	    this.sizeInfo = {};
	
	    // If we have no title yet, try to pull it from the html title attribute (jQuery doesnt' pick it up as it's not a
	    // data-attribute)
	    if (this.options.title === null) {
	      this.options.title = this.$element.attr('title');
	    }
	
	    // Format window padding
	    var winPad = this.options.windowPadding;
	    if (typeof winPad === 'number') {
	      this.options.windowPadding = [winPad, winPad, winPad, winPad];
	    }
	
	    // Expose public methods
	    this.val = Selectpicker.prototype.val;
	    this.render = Selectpicker.prototype.render;
	    this.refresh = Selectpicker.prototype.refresh;
	    this.setStyle = Selectpicker.prototype.setStyle;
	    this.selectAll = Selectpicker.prototype.selectAll;
	    this.deselectAll = Selectpicker.prototype.deselectAll;
	    this.destroy = Selectpicker.prototype.destroy;
	    this.remove = Selectpicker.prototype.remove;
	    this.show = Selectpicker.prototype.show;
	    this.hide = Selectpicker.prototype.hide;
	
	    this.init();
	  };
	
	  Selectpicker.VERSION = '1.13.18';
	
	  // part of this is duplicated in i18n/defaults-en_US.js. Make sure to update both.
	  Selectpicker.DEFAULTS = {
	    noneSelectedText: 'Nothing selected',
	    noneResultsText: 'No results matched {0}',
	    countSelectedText: function (numSelected, numTotal) {
	      return (numSelected == 1) ? '{0} item selected' : '{0} items selected';
	    },
	    maxOptionsText: function (numAll, numGroup) {
	      return [
	        (numAll == 1) ? 'Limit reached ({n} item max)' : 'Limit reached ({n} items max)',
	        (numGroup == 1) ? 'Group limit reached ({n} item max)' : 'Group limit reached ({n} items max)'
	      ];
	    },
	    selectAllText: 'Select All',
	    deselectAllText: 'Deselect All',
	    doneButton: false,
	    doneButtonText: 'Close',
	    multipleSeparator: ', ',
	    styleBase: 'btn',
	    style: classNames.BUTTONCLASS,
	    size: 'auto',
	    title: null,
	    selectedTextFormat: 'values',
	    width: false,
	    container: false,
	    hideDisabled: false,
	    showSubtext: false,
	    showIcon: true,
	    showContent: true,
	    dropupAuto: true,
	    header: false,
	    liveSearch: false,
	    liveSearchPlaceholder: null,
	    liveSearchNormalize: false,
	    liveSearchStyle: 'contains',
	    actionsBox: false,
	    iconBase: classNames.ICONBASE,
	    tickIcon: classNames.TICKICON,
	    showTick: false,
	    template: {
	      caret: '<span class="caret"></span>'
	    },
	    maxOptions: false,
	    mobile: false,
	    selectOnTab: false,
	    dropdownAlignRight: false,
	    windowPadding: 0,
	    virtualScroll: 600,
	    display: false,
	    sanitize: true,
	    sanitizeFn: null,
	    whiteList: DefaultWhitelist
	  };
	
	  Selectpicker.prototype = {
	
	    constructor: Selectpicker,
	
	    init: function () {
	      var that = this,
	          id = this.$element.attr('id'),
	          element = this.$element[0],
	          form = element.form;
	
	      selectId++;
	      this.selectId = 'bs-select-' + selectId;
	
	      element.classList.add('bs-select-hidden');
	
	      this.multiple = this.$element.prop('multiple');
	      this.autofocus = this.$element.prop('autofocus');
	
	      if (element.classList.contains('show-tick')) {
	        this.options.showTick = true;
	      }
	
	      this.$newElement = this.createDropdown();
	      this.buildData();
	      this.$element
	        .after(this.$newElement)
	        .prependTo(this.$newElement);
	
	      // ensure select is associated with form element if it got unlinked after moving it inside newElement
	      if (form && element.form === null) {
	        if (!form.id) form.id = 'form-' + this.selectId;
	        element.setAttribute('form', form.id);
	      }
	
	      this.$button = this.$newElement.children('button');
	      this.$menu = this.$newElement.children(Selector.MENU);
	      this.$menuInner = this.$menu.children('.inner');
	      this.$searchbox = this.$menu.find('input');
	
	      element.classList.remove('bs-select-hidden');
	
	      if (this.options.dropdownAlignRight === true) this.$menu[0].classList.add(classNames.MENURIGHT);
	
	      if (typeof id !== 'undefined') {
	        this.$button.attr('data-id', id);
	      }
	
	      this.checkDisabled();
	      this.clickListener();
	
	      if (this.options.liveSearch) {
	        this.liveSearchListener();
	        this.focusedParent = this.$searchbox[0];
	      } else {
	        this.focusedParent = this.$menuInner[0];
	      }
	
	      this.setStyle();
	      this.render();
	      this.setWidth();
	      if (this.options.container) {
	        this.selectPosition();
	      } else {
	        this.$element.on('hide' + EVENT_KEY, function () {
	          if (that.isVirtual()) {
	            // empty menu on close
	            var menuInner = that.$menuInner[0],
	                emptyMenu = menuInner.firstChild.cloneNode(false);
	
	            // replace the existing UL with an empty one - this is faster than $.empty() or innerHTML = ''
	            menuInner.replaceChild(emptyMenu, menuInner.firstChild);
	            menuInner.scrollTop = 0;
	          }
	        });
	      }
	      this.$menu.data('this', this);
	      this.$newElement.data('this', this);
	      if (this.options.mobile) this.mobile();
	
	      this.$newElement.on({
	        'hide.bs.dropdown': function (e) {
	          that.$element.trigger('hide' + EVENT_KEY, e);
	        },
	        'hidden.bs.dropdown': function (e) {
	          that.$element.trigger('hidden' + EVENT_KEY, e);
	        },
	        'show.bs.dropdown': function (e) {
	          that.$element.trigger('show' + EVENT_KEY, e);
	        },
	        'shown.bs.dropdown': function (e) {
	          that.$element.trigger('shown' + EVENT_KEY, e);
	        }
	      });
	
	      if (element.hasAttribute('required')) {
	        this.$element.on('invalid' + EVENT_KEY, function () {
	          that.$button[0].classList.add('bs-invalid');
	
	          that.$element
	            .on('shown' + EVENT_KEY + '.invalid', function () {
	              that.$element
	                .val(that.$element.val()) // set the value to hide the validation message in Chrome when menu is opened
	                .off('shown' + EVENT_KEY + '.invalid');
	            })
	            .on('rendered' + EVENT_KEY, function () {
	              // if select is no longer invalid, remove the bs-invalid class
	              if (this.validity.valid) that.$button[0].classList.remove('bs-invalid');
	              that.$element.off('rendered' + EVENT_KEY);
	            });
	
	          that.$button.on('blur' + EVENT_KEY, function () {
	            that.$element.trigger('focus').trigger('blur');
	            that.$button.off('blur' + EVENT_KEY);
	          });
	        });
	      }
	
	      setTimeout(function () {
	        that.buildList();
	        that.$element.trigger('loaded' + EVENT_KEY);
	      });
	    },
	
	    createDropdown: function () {
	      // Options
	      // If we are multiple or showTick option is set, then add the show-tick class
	      var showTick = (this.multiple || this.options.showTick) ? ' show-tick' : '',
	          multiselectable = this.multiple ? ' aria-multiselectable="true"' : '',
	          inputGroup = '',
	          autofocus = this.autofocus ? ' autofocus' : '';
	
	      if (version.major < 4 && this.$element.parent().hasClass('input-group')) {
	        inputGroup = ' input-group-btn';
	      }
	
	      // Elements
	      var drop,
	          header = '',
	          searchbox = '',
	          actionsbox = '',
	          donebutton = '';
	
	      if (this.options.header) {
	        header =
	          '<div class="' + classNames.POPOVERHEADER + '">' +
	            '<button type="button" class="close" aria-hidden="true">&times;</button>' +
	              this.options.header +
	          '</div>';
	      }
	
	      if (this.options.liveSearch) {
	        searchbox =
	          '<div class="bs-searchbox">' +
	            '<input type="search" class="form-control" autocomplete="off"' +
	              (
	                this.options.liveSearchPlaceholder === null ? ''
	                :
	                ' placeholder="' + htmlEscape(this.options.liveSearchPlaceholder) + '"'
	              ) +
	              ' role="combobox" aria-label="Search" aria-controls="' + this.selectId + '" aria-autocomplete="list">' +
	          '</div>';
	      }
	
	      if (this.multiple && this.options.actionsBox) {
	        actionsbox =
	          '<div class="bs-actionsbox">' +
	            '<div class="btn-group btn-group-sm btn-block">' +
	              '<button type="button" class="actions-btn bs-select-all btn ' + classNames.BUTTONCLASS + '">' +
	                this.options.selectAllText +
	              '</button>' +
	              '<button type="button" class="actions-btn bs-deselect-all btn ' + classNames.BUTTONCLASS + '">' +
	                this.options.deselectAllText +
	              '</button>' +
	            '</div>' +
	          '</div>';
	      }
	
	      if (this.multiple && this.options.doneButton) {
	        donebutton =
	          '<div class="bs-donebutton">' +
	            '<div class="btn-group btn-block">' +
	              '<button type="button" class="btn btn-sm ' + classNames.BUTTONCLASS + '">' +
	                this.options.doneButtonText +
	              '</button>' +
	            '</div>' +
	          '</div>';
	      }
	
	      drop =
	        '<div class="dropdown bootstrap-select' + showTick + inputGroup + '">' +
	          '<button type="button" tabindex="-1" class="' + this.options.styleBase + ' dropdown-toggle" ' + (this.options.display === 'static' ? 'data-display="static"' : '') + 'data-toggle="dropdown"' + autofocus + ' role="combobox" aria-owns="' + this.selectId + '" aria-haspopup="listbox" aria-expanded="false">' +
	            '<div class="filter-option">' +
	              '<div class="filter-option-inner">' +
	                '<div class="filter-option-inner-inner"></div>' +
	              '</div> ' +
	            '</div>' +
	            (
	              version.major === '4' ? ''
	              :
	              '<span class="bs-caret">' +
	                this.options.template.caret +
	              '</span>'
	            ) +
	          '</button>' +
	          '<div class="' + classNames.MENU + ' ' + (version.major === '4' ? '' : classNames.SHOW) + '">' +
	            header +
	            searchbox +
	            actionsbox +
	            '<div class="inner ' + classNames.SHOW + '" role="listbox" id="' + this.selectId + '" tabindex="-1" ' + multiselectable + '>' +
	                '<ul class="' + classNames.MENU + ' inner ' + (version.major === '4' ? classNames.SHOW : '') + '" role="presentation">' +
	                '</ul>' +
	            '</div>' +
	            donebutton +
	          '</div>' +
	        '</div>';
	
	      return $(drop);
	    },
	
	    setPositionData: function () {
	      this.selectpicker.view.canHighlight = [];
	      this.selectpicker.view.size = 0;
	      this.selectpicker.view.firstHighlightIndex = false;
	
	      for (var i = 0; i < this.selectpicker.current.data.length; i++) {
	        var li = this.selectpicker.current.data[i],
	            canHighlight = true;
	
	        if (li.type === 'divider') {
	          canHighlight = false;
	          li.height = this.sizeInfo.dividerHeight;
	        } else if (li.type === 'optgroup-label') {
	          canHighlight = false;
	          li.height = this.sizeInfo.dropdownHeaderHeight;
	        } else {
	          li.height = this.sizeInfo.liHeight;
	        }
	
	        if (li.disabled) canHighlight = false;
	
	        this.selectpicker.view.canHighlight.push(canHighlight);
	
	        if (canHighlight) {
	          this.selectpicker.view.size++;
	          li.posinset = this.selectpicker.view.size;
	          if (this.selectpicker.view.firstHighlightIndex === false) this.selectpicker.view.firstHighlightIndex = i;
	        }
	
	        li.position = (i === 0 ? 0 : this.selectpicker.current.data[i - 1].position) + li.height;
	      }
	    },
	
	    isVirtual: function () {
	      return (this.options.virtualScroll !== false) && (this.selectpicker.main.elements.length >= this.options.virtualScroll) || this.options.virtualScroll === true;
	    },
	
	    createView: function (isSearching, setSize, refresh) {
	      var that = this,
	          scrollTop = 0,
	          active = [],
	          selected,
	          prevActive;
	
	      this.selectpicker.isSearching = isSearching;
	      this.selectpicker.current = isSearching ? this.selectpicker.search : this.selectpicker.main;
	
	      this.setPositionData();
	
	      if (setSize) {
	        if (refresh) {
	          scrollTop = this.$menuInner[0].scrollTop;
	        } else if (!that.multiple) {
	          var element = that.$element[0],
	              selectedIndex = (element.options[element.selectedIndex] || {}).liIndex;
	
	          if (typeof selectedIndex === 'number' && that.options.size !== false) {
	            var selectedData = that.selectpicker.main.data[selectedIndex],
	                position = selectedData && selectedData.position;
	
	            if (position) {
	              scrollTop = position - ((that.sizeInfo.menuInnerHeight + that.sizeInfo.liHeight) / 2);
	            }
	          }
	        }
	      }
	
	      scroll(scrollTop, true);
	
	      this.$menuInner.off('scroll.createView').on('scroll.createView', function (e, updateValue) {
	        if (!that.noScroll) scroll(this.scrollTop, updateValue);
	        that.noScroll = false;
	      });
	
	      function scroll (scrollTop, init) {
	        var size = that.selectpicker.current.elements.length,
	            chunks = [],
	            chunkSize,
	            chunkCount,
	            firstChunk,
	            lastChunk,
	            currentChunk,
	            prevPositions,
	            positionIsDifferent,
	            previousElements,
	            menuIsDifferent = true,
	            isVirtual = that.isVirtual();
	
	        that.selectpicker.view.scrollTop = scrollTop;
	
	        chunkSize = Math.ceil(that.sizeInfo.menuInnerHeight / that.sizeInfo.liHeight * 1.5); // number of options in a chunk
	        chunkCount = Math.round(size / chunkSize) || 1; // number of chunks
	
	        for (var i = 0; i < chunkCount; i++) {
	          var endOfChunk = (i + 1) * chunkSize;
	
	          if (i === chunkCount - 1) {
	            endOfChunk = size;
	          }
	
	          chunks[i] = [
	            (i) * chunkSize + (!i ? 0 : 1),
	            endOfChunk
	          ];
	
	          if (!size) break;
	
	          if (currentChunk === undefined && scrollTop - 1 <= that.selectpicker.current.data[endOfChunk - 1].position - that.sizeInfo.menuInnerHeight) {
	            currentChunk = i;
	          }
	        }
	
	        if (currentChunk === undefined) currentChunk = 0;
	
	        prevPositions = [that.selectpicker.view.position0, that.selectpicker.view.position1];
	
	        // always display previous, current, and next chunks
	        firstChunk = Math.max(0, currentChunk - 1);
	        lastChunk = Math.min(chunkCount - 1, currentChunk + 1);
	
	        that.selectpicker.view.position0 = isVirtual === false ? 0 : (Math.max(0, chunks[firstChunk][0]) || 0);
	        that.selectpicker.view.position1 = isVirtual === false ? size : (Math.min(size, chunks[lastChunk][1]) || 0);
	
	        positionIsDifferent = prevPositions[0] !== that.selectpicker.view.position0 || prevPositions[1] !== that.selectpicker.view.position1;
	
	        if (that.activeIndex !== undefined) {
	          prevActive = that.selectpicker.main.elements[that.prevActiveIndex];
	          active = that.selectpicker.main.elements[that.activeIndex];
	          selected = that.selectpicker.main.elements[that.selectedIndex];
	
	          if (init) {
	            if (that.activeIndex !== that.selectedIndex) {
	              that.defocusItem(active);
	            }
	            that.activeIndex = undefined;
	          }
	
	          if (that.activeIndex && that.activeIndex !== that.selectedIndex) {
	            that.defocusItem(selected);
	          }
	        }
	
	        if (that.prevActiveIndex !== undefined && that.prevActiveIndex !== that.activeIndex && that.prevActiveIndex !== that.selectedIndex) {
	          that.defocusItem(prevActive);
	        }
	
	        if (init || positionIsDifferent) {
	          previousElements = that.selectpicker.view.visibleElements ? that.selectpicker.view.visibleElements.slice() : [];
	
	          if (isVirtual === false) {
	            that.selectpicker.view.visibleElements = that.selectpicker.current.elements;
	          } else {
	            that.selectpicker.view.visibleElements = that.selectpicker.current.elements.slice(that.selectpicker.view.position0, that.selectpicker.view.position1);
	          }
	
	          that.setOptionStatus();
	
	          // if searching, check to make sure the list has actually been updated before updating DOM
	          // this prevents unnecessary repaints
	          if (isSearching || (isVirtual === false && init)) menuIsDifferent = !isEqual(previousElements, that.selectpicker.view.visibleElements);
	
	          // if virtual scroll is disabled and not searching,
	          // menu should never need to be updated more than once
	          if ((init || isVirtual === true) && menuIsDifferent) {
	            var menuInner = that.$menuInner[0],
	                menuFragment = document.createDocumentFragment(),
	                emptyMenu = menuInner.firstChild.cloneNode(false),
	                marginTop,
	                marginBottom,
	                elements = that.selectpicker.view.visibleElements,
	                toSanitize = [];
	
	            // replace the existing UL with an empty one - this is faster than $.empty()
	            menuInner.replaceChild(emptyMenu, menuInner.firstChild);
	
	            for (var i = 0, visibleElementsLen = elements.length; i < visibleElementsLen; i++) {
	              var element = elements[i],
	                  elText,
	                  elementData;
	
	              if (that.options.sanitize) {
	                elText = element.lastChild;
	
	                if (elText) {
	                  elementData = that.selectpicker.current.data[i + that.selectpicker.view.position0];
	
	                  if (elementData && elementData.content && !elementData.sanitized) {
	                    toSanitize.push(elText);
	                    elementData.sanitized = true;
	                  }
	                }
	              }
	
	              menuFragment.appendChild(element);
	            }
	
	            if (that.options.sanitize && toSanitize.length) {
	              sanitizeHtml(toSanitize, that.options.whiteList, that.options.sanitizeFn);
	            }
	
	            if (isVirtual === true) {
	              marginTop = (that.selectpicker.view.position0 === 0 ? 0 : that.selectpicker.current.data[that.selectpicker.view.position0 - 1].position);
	              marginBottom = (that.selectpicker.view.position1 > size - 1 ? 0 : that.selectpicker.current.data[size - 1].position - that.selectpicker.current.data[that.selectpicker.view.position1 - 1].position);
	
	              menuInner.firstChild.style.marginTop = marginTop + 'px';
	              menuInner.firstChild.style.marginBottom = marginBottom + 'px';
	            } else {
	              menuInner.firstChild.style.marginTop = 0;
	              menuInner.firstChild.style.marginBottom = 0;
	            }
	
	            menuInner.firstChild.appendChild(menuFragment);
	
	            // if an option is encountered that is wider than the current menu width, update the menu width accordingly
	            // switch to ResizeObserver with increased browser support
	            if (isVirtual === true && that.sizeInfo.hasScrollBar) {
	              var menuInnerInnerWidth = menuInner.firstChild.offsetWidth;
	
	              if (init && menuInnerInnerWidth < that.sizeInfo.menuInnerInnerWidth && that.sizeInfo.totalMenuWidth > that.sizeInfo.selectWidth) {
	                menuInner.firstChild.style.minWidth = that.sizeInfo.menuInnerInnerWidth + 'px';
	              } else if (menuInnerInnerWidth > that.sizeInfo.menuInnerInnerWidth) {
	                // set to 0 to get actual width of menu
	                that.$menu[0].style.minWidth = 0;
	
	                var actualMenuWidth = menuInner.firstChild.offsetWidth;
	
	                if (actualMenuWidth > that.sizeInfo.menuInnerInnerWidth) {
	                  that.sizeInfo.menuInnerInnerWidth = actualMenuWidth;
	                  menuInner.firstChild.style.minWidth = that.sizeInfo.menuInnerInnerWidth + 'px';
	                }
	
	                // reset to default CSS styling
	                that.$menu[0].style.minWidth = '';
	              }
	            }
	          }
	        }
	
	        that.prevActiveIndex = that.activeIndex;
	
	        if (!that.options.liveSearch) {
	          that.$menuInner.trigger('focus');
	        } else if (isSearching && init) {
	          var index = 0,
	              newActive;
	
	          if (!that.selectpicker.view.canHighlight[index]) {
	            index = 1 + that.selectpicker.view.canHighlight.slice(1).indexOf(true);
	          }
	
	          newActive = that.selectpicker.view.visibleElements[index];
	
	          that.defocusItem(that.selectpicker.view.currentActive);
	
	          that.activeIndex = (that.selectpicker.current.data[index] || {}).index;
	
	          that.focusItem(newActive);
	        }
	      }
	
	      $(window)
	        .off('resize' + EVENT_KEY + '.' + this.selectId + '.createView')
	        .on('resize' + EVENT_KEY + '.' + this.selectId + '.createView', function () {
	          var isActive = that.$newElement.hasClass(classNames.SHOW);
	
	          if (isActive) scroll(that.$menuInner[0].scrollTop);
	        });
	    },
	
	    focusItem: function (li, liData, noStyle) {
	      if (li) {
	        liData = liData || this.selectpicker.main.data[this.activeIndex];
	        var a = li.firstChild;
	
	        if (a) {
	          a.setAttribute('aria-setsize', this.selectpicker.view.size);
	          a.setAttribute('aria-posinset', liData.posinset);
	
	          if (noStyle !== true) {
	            this.focusedParent.setAttribute('aria-activedescendant', a.id);
	            li.classList.add('active');
	            a.classList.add('active');
	          }
	        }
	      }
	    },
	
	    defocusItem: function (li) {
	      if (li) {
	        li.classList.remove('active');
	        if (li.firstChild) li.firstChild.classList.remove('active');
	      }
	    },
	
	    setPlaceholder: function () {
	      var that = this,
	          updateIndex = false;
	
	      if (this.options.title && !this.multiple) {
	        if (!this.selectpicker.view.titleOption) this.selectpicker.view.titleOption = document.createElement('option');
	
	        // this option doesn't create a new <li> element, but does add a new option at the start,
	        // so startIndex should increase to prevent having to check every option for the bs-title-option class
	        updateIndex = true;
	
	        var element = this.$element[0],
	            selectTitleOption = false,
	            titleNotAppended = !this.selectpicker.view.titleOption.parentNode,
	            selectedIndex = element.selectedIndex,
	            selectedOption = element.options[selectedIndex],
	            navigation = window.performance && window.performance.getEntriesByType('navigation'),
	            // Safari doesn't support getEntriesByType('navigation') - fall back to performance.navigation
	            isNotBackForward = (navigation && navigation.length) ? navigation[0].type !== 'back_forward' : window.performance.navigation.type !== 2;
	
	        if (titleNotAppended) {
	          // Use native JS to prepend option (faster)
	          this.selectpicker.view.titleOption.className = 'bs-title-option';
	          this.selectpicker.view.titleOption.value = '';
	
	          // Check if selected or data-selected attribute is already set on an option. If not, select the titleOption option.
	          // the selected item may have been changed by user or programmatically before the bootstrap select plugin runs,
	          // if so, the select will have the data-selected attribute
	          selectTitleOption = !selectedOption || (selectedIndex === 0 && selectedOption.defaultSelected === false && this.$element.data('selected') === undefined);
	        }
	
	        if (titleNotAppended || this.selectpicker.view.titleOption.index !== 0) {
	          element.insertBefore(this.selectpicker.view.titleOption, element.firstChild);
	        }
	
	        // Set selected *after* appending to select,
	        // otherwise the option doesn't get selected in IE
	        // set using selectedIndex, as setting the selected attr to true here doesn't work in IE11
	        if (selectTitleOption && isNotBackForward) {
	          element.selectedIndex = 0;
	        } else if (document.readyState !== 'complete') {
	          // if navigation type is back_forward, there's a chance the select will have its value set by BFCache
	          // wait for that value to be set, then run render again
	          window.addEventListener('pageshow', function () {
	            if (that.selectpicker.view.displayedValue !== element.value) that.render();
	          });
	        }
	      }
	
	      return updateIndex;
	    },
	
	    buildData: function () {
	      var optionSelector = ':not([hidden]):not([data-hidden="true"])',
	          mainData = [],
	          optID = 0,
	          startIndex = this.setPlaceholder() ? 1 : 0; // append the titleOption if necessary and skip the first option in the loop
	
	      if (this.options.hideDisabled) optionSelector += ':not(:disabled)';
	
	      var selectOptions = this.$element[0].querySelectorAll('select > *' + optionSelector);
	
	      function addDivider (config) {
	        var previousData = mainData[mainData.length - 1];
	
	        // ensure optgroup doesn't create back-to-back dividers
	        if (
	          previousData &&
	          previousData.type === 'divider' &&
	          (previousData.optID || config.optID)
	        ) {
	          return;
	        }
	
	        config = config || {};
	        config.type = 'divider';
	
	        mainData.push(config);
	      }
	
	      function addOption (option, config) {
	        config = config || {};
	
	        config.divider = option.getAttribute('data-divider') === 'true';
	
	        if (config.divider) {
	          addDivider({
	            optID: config.optID
	          });
	        } else {
	          var liIndex = mainData.length,
	              cssText = option.style.cssText,
	              inlineStyle = cssText ? htmlEscape(cssText) : '',
	              optionClass = (option.className || '') + (config.optgroupClass || '');
	
	          if (config.optID) optionClass = 'opt ' + optionClass;
	
	          config.optionClass = optionClass.trim();
	          config.inlineStyle = inlineStyle;
	          config.text = option.textContent;
	
	          config.content = option.getAttribute('data-content');
	          config.tokens = option.getAttribute('data-tokens');
	          config.subtext = option.getAttribute('data-subtext');
	          config.icon = option.getAttribute('data-icon');
	
	          option.liIndex = liIndex;
	
	          config.display = config.content || config.text;
	          config.type = 'option';
	          config.index = liIndex;
	          config.option = option;
	          config.selected = !!option.selected;
	          config.disabled = config.disabled || !!option.disabled;
	
	          mainData.push(config);
	        }
	      }
	
	      function addOptgroup (index, selectOptions) {
	        var optgroup = selectOptions[index],
	            // skip placeholder option
	            previous = index - 1 < startIndex ? false : selectOptions[index - 1],
	            next = selectOptions[index + 1],
	            options = optgroup.querySelectorAll('option' + optionSelector);
	
	        if (!options.length) return;
	
	        var config = {
	              display: htmlEscape(optgroup.label),
	              subtext: optgroup.getAttribute('data-subtext'),
	              icon: optgroup.getAttribute('data-icon'),
	              type: 'optgroup-label',
	              optgroupClass: ' ' + (optgroup.className || '')
	            },
	            headerIndex,
	            lastIndex;
	
	        optID++;
	
	        if (previous) {
	          addDivider({ optID: optID });
	        }
	
	        config.optID = optID;
	
	        mainData.push(config);
	
	        for (var j = 0, len = options.length; j < len; j++) {
	          var option = options[j];
	
	          if (j === 0) {
	            headerIndex = mainData.length - 1;
	            lastIndex = headerIndex + len;
	          }
	
	          addOption(option, {
	            headerIndex: headerIndex,
	            lastIndex: lastIndex,
	            optID: config.optID,
	            optgroupClass: config.optgroupClass,
	            disabled: optgroup.disabled
	          });
	        }
	
	        if (next) {
	          addDivider({ optID: optID });
	        }
	      }
	
	      for (var len = selectOptions.length, i = startIndex; i < len; i++) {
	        var item = selectOptions[i];
	
	        if (item.tagName !== 'OPTGROUP') {
	          addOption(item, {});
	        } else {
	          addOptgroup(i, selectOptions);
	        }
	      }
	
	      this.selectpicker.main.data = this.selectpicker.current.data = mainData;
	    },
	
	    buildList: function () {
	      var that = this,
	          selectData = this.selectpicker.main.data,
	          mainElements = [],
	          widestOptionLength = 0;
	
	      if ((that.options.showTick || that.multiple) && !elementTemplates.checkMark.parentNode) {
	        elementTemplates.checkMark.className = this.options.iconBase + ' ' + that.options.tickIcon + ' check-mark';
	        elementTemplates.a.appendChild(elementTemplates.checkMark);
	      }
	
	      function buildElement (item) {
	        var liElement,
	            combinedLength = 0;
	
	        switch (item.type) {
	          case 'divider':
	            liElement = generateOption.li(
	              false,
	              classNames.DIVIDER,
	              (item.optID ? item.optID + 'div' : undefined)
	            );
	
	            break;
	
	          case 'option':
	            liElement = generateOption.li(
	              generateOption.a(
	                generateOption.text.call(that, item),
	                item.optionClass,
	                item.inlineStyle
	              ),
	              '',
	              item.optID
	            );
	
	            if (liElement.firstChild) {
	              liElement.firstChild.id = that.selectId + '-' + item.index;
	            }
	
	            break;
	
	          case 'optgroup-label':
	            liElement = generateOption.li(
	              generateOption.label.call(that, item),
	              'dropdown-header' + item.optgroupClass,
	              item.optID
	            );
	
	            break;
	        }
	
	        item.element = liElement;
	        mainElements.push(liElement);
	
	        // count the number of characters in the option - not perfect, but should work in most cases
	        if (item.display) combinedLength += item.display.length;
	        if (item.subtext) combinedLength += item.subtext.length;
	        // if there is an icon, ensure this option's width is checked
	        if (item.icon) combinedLength += 1;
	
	        if (combinedLength > widestOptionLength) {
	          widestOptionLength = combinedLength;
	
	          // guess which option is the widest
	          // use this when calculating menu width
	          // not perfect, but it's fast, and the width will be updating accordingly when scrolling
	          that.selectpicker.view.widestOption = mainElements[mainElements.length - 1];
	        }
	      }
	
	      for (var len = selectData.length, i = 0; i < len; i++) {
	        var item = selectData[i];
	
	        buildElement(item);
	      }
	
	      this.selectpicker.main.elements = this.selectpicker.current.elements = mainElements;
	    },
	
	    findLis: function () {
	      return this.$menuInner.find('.inner > li');
	    },
	
	    render: function () {
	      var that = this,
	          element = this.$element[0],
	          // ensure titleOption is appended and selected (if necessary) before getting selectedOptions
	          placeholderSelected = this.setPlaceholder() && element.selectedIndex === 0,
	          selectedOptions = getSelectedOptions(element, this.options.hideDisabled),
	          selectedCount = selectedOptions.length,
	          button = this.$button[0],
	          buttonInner = button.querySelector('.filter-option-inner-inner'),
	          multipleSeparator = document.createTextNode(this.options.multipleSeparator),
	          titleFragment = elementTemplates.fragment.cloneNode(false),
	          showCount,
	          countMax,
	          hasContent = false;
	
	      button.classList.toggle('bs-placeholder', that.multiple ? !selectedCount : !getSelectValues(element, selectedOptions));
	
	      if (!that.multiple && selectedOptions.length === 1) {
	        that.selectpicker.view.displayedValue = getSelectValues(element, selectedOptions);
	      }
	
	      if (this.options.selectedTextFormat === 'static') {
	        titleFragment = generateOption.text.call(this, { text: this.options.title }, true);
	      } else {
	        showCount = this.multiple && this.options.selectedTextFormat.indexOf('count') !== -1 && selectedCount > 1;
	
	        // determine if the number of selected options will be shown (showCount === true)
	        if (showCount) {
	          countMax = this.options.selectedTextFormat.split('>');
	          showCount = (countMax.length > 1 && selectedCount > countMax[1]) || (countMax.length === 1 && selectedCount >= 2);
	        }
	
	        // only loop through all selected options if the count won't be shown
	        if (showCount === false) {
	          if (!placeholderSelected) {
	            for (var selectedIndex = 0; selectedIndex < selectedCount; selectedIndex++) {
	              if (selectedIndex < 50) {
	                var option = selectedOptions[selectedIndex],
	                    thisData = this.selectpicker.main.data[option.liIndex],
	                    titleOptions = {};
	
	                if (this.multiple && selectedIndex > 0) {
	                  titleFragment.appendChild(multipleSeparator.cloneNode(false));
	                }
	
	                if (option.title) {
	                  titleOptions.text = option.title;
	                } else if (thisData) {
	                  if (thisData.content && that.options.showContent) {
	                    titleOptions.content = thisData.content.toString();
	                    hasContent = true;
	                  } else {
	                    if (that.options.showIcon) {
	                      titleOptions.icon = thisData.icon;
	                    }
	                    if (that.options.showSubtext && !that.multiple && thisData.subtext) titleOptions.subtext = ' ' + thisData.subtext;
	                    titleOptions.text = option.textContent.trim();
	                  }
	                }
	
	                titleFragment.appendChild(generateOption.text.call(this, titleOptions, true));
	              } else {
	                break;
	              }
	            }
	
	            // add ellipsis
	            if (selectedCount > 49) {
	              titleFragment.appendChild(document.createTextNode('...'));
	            }
	          }
	        } else {
	          var optionSelector = ':not([hidden]):not([data-hidden="true"]):not([data-divider="true"])';
	          if (this.options.hideDisabled) optionSelector += ':not(:disabled)';
	
	          // If this is a multiselect, and selectedTextFormat is count, then show 1 of 2 selected, etc.
	          var totalCount = this.$element[0].querySelectorAll('select > option' + optionSelector + ', optgroup' + optionSelector + ' option' + optionSelector).length,
	              tr8nText = (typeof this.options.countSelectedText === 'function') ? this.options.countSelectedText(selectedCount, totalCount) : this.options.countSelectedText;
	
	          titleFragment = generateOption.text.call(this, {
	            text: tr8nText.replace('{0}', selectedCount.toString()).replace('{1}', totalCount.toString())
	          }, true);
	        }
	      }
	
	      if (this.options.title == undefined) {
	        // use .attr to ensure undefined is returned if title attribute is not set
	        this.options.title = this.$element.attr('title');
	      }
	
	      // If the select doesn't have a title, then use the default, or if nothing is set at all, use noneSelectedText
	      if (!titleFragment.childNodes.length) {
	        titleFragment = generateOption.text.call(this, {
	          text: typeof this.options.title !== 'undefined' ? this.options.title : this.options.noneSelectedText
	        }, true);
	      }
	
	      // strip all HTML tags and trim the result, then unescape any escaped tags
	      button.title = titleFragment.textContent.replace(/<[^>]*>?/g, '').trim();
	
	      if (this.options.sanitize && hasContent) {
	        sanitizeHtml([titleFragment], that.options.whiteList, that.options.sanitizeFn);
	      }
	
	      buttonInner.innerHTML = '';
	      buttonInner.appendChild(titleFragment);
	
	      if (version.major < 4 && this.$newElement[0].classList.contains('bs3-has-addon')) {
	        var filterExpand = button.querySelector('.filter-expand'),
	            clone = buttonInner.cloneNode(true);
	
	        clone.className = 'filter-expand';
	
	        if (filterExpand) {
	          button.replaceChild(clone, filterExpand);
	        } else {
	          button.appendChild(clone);
	        }
	      }
	
	      this.$element.trigger('rendered' + EVENT_KEY);
	    },
	
	    /**
	     * @param [style]
	     * @param [status]
	     */
	    setStyle: function (newStyle, status) {
	      var button = this.$button[0],
	          newElement = this.$newElement[0],
	          style = this.options.style.trim(),
	          buttonClass;
	
	      if (this.$element.attr('class')) {
	        this.$newElement.addClass(this.$element.attr('class').replace(/selectpicker|mobile-device|bs-select-hidden|validate\[.*\]/gi, ''));
	      }
	
	      if (version.major < 4) {
	        newElement.classList.add('bs3');
	
	        if (newElement.parentNode.classList && newElement.parentNode.classList.contains('input-group') &&
	            (newElement.previousElementSibling || newElement.nextElementSibling) &&
	            (newElement.previousElementSibling || newElement.nextElementSibling).classList.contains('input-group-addon')
	        ) {
	          newElement.classList.add('bs3-has-addon');
	        }
	      }
	
	      if (newStyle) {
	        buttonClass = newStyle.trim();
	      } else {
	        buttonClass = style;
	      }
	
	      if (status == 'add') {
	        if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(' '));
	      } else if (status == 'remove') {
	        if (buttonClass) button.classList.remove.apply(button.classList, buttonClass.split(' '));
	      } else {
	        if (style) button.classList.remove.apply(button.classList, style.split(' '));
	        if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(' '));
	      }
	    },
	
	    liHeight: function (refresh) {
	      if (!refresh && (this.options.size === false || Object.keys(this.sizeInfo).length)) return;
	
	      var newElement = elementTemplates.div.cloneNode(false),
	          menu = elementTemplates.div.cloneNode(false),
	          menuInner = elementTemplates.div.cloneNode(false),
	          menuInnerInner = document.createElement('ul'),
	          divider = elementTemplates.li.cloneNode(false),
	          dropdownHeader = elementTemplates.li.cloneNode(false),
	          li,
	          a = elementTemplates.a.cloneNode(false),
	          text = elementTemplates.span.cloneNode(false),
	          header = this.options.header && this.$menu.find('.' + classNames.POPOVERHEADER).length > 0 ? this.$menu.find('.' + classNames.POPOVERHEADER)[0].cloneNode(true) : null,
	          search = this.options.liveSearch ? elementTemplates.div.cloneNode(false) : null,
	          actions = this.options.actionsBox && this.multiple && this.$menu.find('.bs-actionsbox').length > 0 ? this.$menu.find('.bs-actionsbox')[0].cloneNode(true) : null,
	          doneButton = this.options.doneButton && this.multiple && this.$menu.find('.bs-donebutton').length > 0 ? this.$menu.find('.bs-donebutton')[0].cloneNode(true) : null,
	          firstOption = this.$element.find('option')[0];
	
	      this.sizeInfo.selectWidth = this.$newElement[0].offsetWidth;
	
	      text.className = 'text';
	      a.className = 'dropdown-item ' + (firstOption ? firstOption.className : '');
	      newElement.className = this.$menu[0].parentNode.className + ' ' + classNames.SHOW;
	      newElement.style.width = 0; // ensure button width doesn't affect natural width of menu when calculating
	      if (this.options.width === 'auto') menu.style.minWidth = 0;
	      menu.className = classNames.MENU + ' ' + classNames.SHOW;
	      menuInner.className = 'inner ' + classNames.SHOW;
	      menuInnerInner.className = classNames.MENU + ' inner ' + (version.major === '4' ? classNames.SHOW : '');
	      divider.className = classNames.DIVIDER;
	      dropdownHeader.className = 'dropdown-header';
	
	      text.appendChild(document.createTextNode('\u200b'));
	
	      if (this.selectpicker.current.data.length) {
	        for (var i = 0; i < this.selectpicker.current.data.length; i++) {
	          var data = this.selectpicker.current.data[i];
	          if (data.type === 'option') {
	            li = data.element;
	            break;
	          }
	        }
	      } else {
	        li = elementTemplates.li.cloneNode(false);
	        a.appendChild(text);
	        li.appendChild(a);
	      }
	
	      dropdownHeader.appendChild(text.cloneNode(true));
	
	      if (this.selectpicker.view.widestOption) {
	        menuInnerInner.appendChild(this.selectpicker.view.widestOption.cloneNode(true));
	      }
	
	      menuInnerInner.appendChild(li);
	      menuInnerInner.appendChild(divider);
	      menuInnerInner.appendChild(dropdownHeader);
	      if (header) menu.appendChild(header);
	      if (search) {
	        var input = document.createElement('input');
	        search.className = 'bs-searchbox';
	        input.className = 'form-control';
	        search.appendChild(input);
	        menu.appendChild(search);
	      }
	      if (actions) menu.appendChild(actions);
	      menuInner.appendChild(menuInnerInner);
	      menu.appendChild(menuInner);
	      if (doneButton) menu.appendChild(doneButton);
	      newElement.appendChild(menu);
	
	      document.body.appendChild(newElement);
	
	      var liHeight = li.offsetHeight,
	          dropdownHeaderHeight = dropdownHeader ? dropdownHeader.offsetHeight : 0,
	          headerHeight = header ? header.offsetHeight : 0,
	          searchHeight = search ? search.offsetHeight : 0,
	          actionsHeight = actions ? actions.offsetHeight : 0,
	          doneButtonHeight = doneButton ? doneButton.offsetHeight : 0,
	          dividerHeight = $(divider).outerHeight(true),
	          // fall back to jQuery if getComputedStyle is not supported
	          menuStyle = window.getComputedStyle ? window.getComputedStyle(menu) : false,
	          menuWidth = menu.offsetWidth,
	          $menu = menuStyle ? null : $(menu),
	          menuPadding = {
	            vert: toInteger(menuStyle ? menuStyle.paddingTop : $menu.css('paddingTop')) +
	                  toInteger(menuStyle ? menuStyle.paddingBottom : $menu.css('paddingBottom')) +
	                  toInteger(menuStyle ? menuStyle.borderTopWidth : $menu.css('borderTopWidth')) +
	                  toInteger(menuStyle ? menuStyle.borderBottomWidth : $menu.css('borderBottomWidth')),
	            horiz: toInteger(menuStyle ? menuStyle.paddingLeft : $menu.css('paddingLeft')) +
	                  toInteger(menuStyle ? menuStyle.paddingRight : $menu.css('paddingRight')) +
	                  toInteger(menuStyle ? menuStyle.borderLeftWidth : $menu.css('borderLeftWidth')) +
	                  toInteger(menuStyle ? menuStyle.borderRightWidth : $menu.css('borderRightWidth'))
	          },
	          menuExtras = {
	            vert: menuPadding.vert +
	                  toInteger(menuStyle ? menuStyle.marginTop : $menu.css('marginTop')) +
	                  toInteger(menuStyle ? menuStyle.marginBottom : $menu.css('marginBottom')) + 2,
	            horiz: menuPadding.horiz +
	                  toInteger(menuStyle ? menuStyle.marginLeft : $menu.css('marginLeft')) +
	                  toInteger(menuStyle ? menuStyle.marginRight : $menu.css('marginRight')) + 2
	          },
	          scrollBarWidth;
	
	      menuInner.style.overflowY = 'scroll';
	
	      scrollBarWidth = menu.offsetWidth - menuWidth;
	
	      document.body.removeChild(newElement);
	
	      this.sizeInfo.liHeight = liHeight;
	      this.sizeInfo.dropdownHeaderHeight = dropdownHeaderHeight;
	      this.sizeInfo.headerHeight = headerHeight;
	      this.sizeInfo.searchHeight = searchHeight;
	      this.sizeInfo.actionsHeight = actionsHeight;
	      this.sizeInfo.doneButtonHeight = doneButtonHeight;
	      this.sizeInfo.dividerHeight = dividerHeight;
	      this.sizeInfo.menuPadding = menuPadding;
	      this.sizeInfo.menuExtras = menuExtras;
	      this.sizeInfo.menuWidth = menuWidth;
	      this.sizeInfo.menuInnerInnerWidth = menuWidth - menuPadding.horiz;
	      this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth;
	      this.sizeInfo.scrollBarWidth = scrollBarWidth;
	      this.sizeInfo.selectHeight = this.$newElement[0].offsetHeight;
	
	      this.setPositionData();
	    },
	
	    getSelectPosition: function () {
	      var that = this,
	          $window = $(window),
	          pos = that.$newElement.offset(),
	          $container = $(that.options.container),
	          containerPos;
	
	      if (that.options.container && $container.length && !$container.is('body')) {
	        containerPos = $container.offset();
	        containerPos.top += parseInt($container.css('borderTopWidth'));
	        containerPos.left += parseInt($container.css('borderLeftWidth'));
	      } else {
	        containerPos = { top: 0, left: 0 };
	      }
	
	      var winPad = that.options.windowPadding;
	
	      this.sizeInfo.selectOffsetTop = pos.top - containerPos.top - $window.scrollTop();
	      this.sizeInfo.selectOffsetBot = $window.height() - this.sizeInfo.selectOffsetTop - this.sizeInfo.selectHeight - containerPos.top - winPad[2];
	      this.sizeInfo.selectOffsetLeft = pos.left - containerPos.left - $window.scrollLeft();
	      this.sizeInfo.selectOffsetRight = $window.width() - this.sizeInfo.selectOffsetLeft - this.sizeInfo.selectWidth - containerPos.left - winPad[1];
	      this.sizeInfo.selectOffsetTop -= winPad[0];
	      this.sizeInfo.selectOffsetLeft -= winPad[3];
	    },
	
	    setMenuSize: function (isAuto) {
	      this.getSelectPosition();
	
	      var selectWidth = this.sizeInfo.selectWidth,
	          liHeight = this.sizeInfo.liHeight,
	          headerHeight = this.sizeInfo.headerHeight,
	          searchHeight = this.sizeInfo.searchHeight,
	          actionsHeight = this.sizeInfo.actionsHeight,
	          doneButtonHeight = this.sizeInfo.doneButtonHeight,
	          divHeight = this.sizeInfo.dividerHeight,
	          menuPadding = this.sizeInfo.menuPadding,
	          menuInnerHeight,
	          menuHeight,
	          divLength = 0,
	          minHeight,
	          _minHeight,
	          maxHeight,
	          menuInnerMinHeight,
	          estimate,
	          isDropup;
	
	      if (this.options.dropupAuto) {
	        // Get the estimated height of the menu without scrollbars.
	        // This is useful for smaller menus, where there might be plenty of room
	        // below the button without setting dropup, but we can't know
	        // the exact height of the menu until createView is called later
	        estimate = liHeight * this.selectpicker.current.elements.length + menuPadding.vert;
	
	        isDropup = this.sizeInfo.selectOffsetTop - this.sizeInfo.selectOffsetBot > this.sizeInfo.menuExtras.vert && estimate + this.sizeInfo.menuExtras.vert + 50 > this.sizeInfo.selectOffsetBot;
	
	        // ensure dropup doesn't change while searching (so menu doesn't bounce back and forth)
	        if (this.selectpicker.isSearching === true) {
	          isDropup = this.selectpicker.dropup;
	        }
	
	        this.$newElement.toggleClass(classNames.DROPUP, isDropup);
	        this.selectpicker.dropup = isDropup;
	      }
	
	      if (this.options.size === 'auto') {
	        _minHeight = this.selectpicker.current.elements.length > 3 ? this.sizeInfo.liHeight * 3 + this.sizeInfo.menuExtras.vert - 2 : 0;
	        menuHeight = this.sizeInfo.selectOffsetBot - this.sizeInfo.menuExtras.vert;
	        minHeight = _minHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
	        menuInnerMinHeight = Math.max(_minHeight - menuPadding.vert, 0);
	
	        if (this.$newElement.hasClass(classNames.DROPUP)) {
	          menuHeight = this.sizeInfo.selectOffsetTop - this.sizeInfo.menuExtras.vert;
	        }
	
	        maxHeight = menuHeight;
	        menuInnerHeight = menuHeight - headerHeight - searchHeight - actionsHeight - doneButtonHeight - menuPadding.vert;
	      } else if (this.options.size && this.options.size != 'auto' && this.selectpicker.current.elements.length > this.options.size) {
	        for (var i = 0; i < this.options.size; i++) {
	          if (this.selectpicker.current.data[i].type === 'divider') divLength++;
	        }
	
	        menuHeight = liHeight * this.options.size + divLength * divHeight + menuPadding.vert;
	        menuInnerHeight = menuHeight - menuPadding.vert;
	        maxHeight = menuHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
	        minHeight = menuInnerMinHeight = '';
	      }
	
	      this.$menu.css({
	        'max-height': maxHeight + 'px',
	        'overflow': 'hidden',
	        'min-height': minHeight + 'px'
	      });
	
	      this.$menuInner.css({
	        'max-height': menuInnerHeight + 'px',
	        'overflow-y': 'auto',
	        'min-height': menuInnerMinHeight + 'px'
	      });
	
	      // ensure menuInnerHeight is always a positive number to prevent issues calculating chunkSize in createView
	      this.sizeInfo.menuInnerHeight = Math.max(menuInnerHeight, 1);
	
	      if (this.selectpicker.current.data.length && this.selectpicker.current.data[this.selectpicker.current.data.length - 1].position > this.sizeInfo.menuInnerHeight) {
	        this.sizeInfo.hasScrollBar = true;
	        this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth + this.sizeInfo.scrollBarWidth;
	      }
	
	      if (this.options.dropdownAlignRight === 'auto') {
	        this.$menu.toggleClass(classNames.MENURIGHT, this.sizeInfo.selectOffsetLeft > this.sizeInfo.selectOffsetRight && this.sizeInfo.selectOffsetRight < (this.sizeInfo.totalMenuWidth - selectWidth));
	      }
	
	      if (this.dropdown && this.dropdown._popper) this.dropdown._popper.update();
	    },
	
	    setSize: function (refresh) {
	      this.liHeight(refresh);
	
	      if (this.options.header) this.$menu.css('padding-top', 0);
	
	      if (this.options.size !== false) {
	        var that = this,
	            $window = $(window);
	
	        this.setMenuSize();
	
	        if (this.options.liveSearch) {
	          this.$searchbox
	            .off('input.setMenuSize propertychange.setMenuSize')
	            .on('input.setMenuSize propertychange.setMenuSize', function () {
	              return that.setMenuSize();
	            });
	        }
	
	        if (this.options.size === 'auto') {
	          $window
	            .off('resize' + EVENT_KEY + '.' + this.selectId + '.setMenuSize' + ' scroll' + EVENT_KEY + '.' + this.selectId + '.setMenuSize')
	            .on('resize' + EVENT_KEY + '.' + this.selectId + '.setMenuSize' + ' scroll' + EVENT_KEY + '.' + this.selectId + '.setMenuSize', function () {
	              return that.setMenuSize();
	            });
	        } else if (this.options.size && this.options.size != 'auto' && this.selectpicker.current.elements.length > this.options.size) {
	          $window.off('resize' + EVENT_KEY + '.' + this.selectId + '.setMenuSize' + ' scroll' + EVENT_KEY + '.' + this.selectId + '.setMenuSize');
	        }
	      }
	
	      this.createView(false, true, refresh);
	    },
	
	    setWidth: function () {
	      var that = this;
	
	      if (this.options.width === 'auto') {
	        requestAnimationFrame(function () {
	          that.$menu.css('min-width', '0');
	
	          that.$element.on('loaded' + EVENT_KEY, function () {
	            that.liHeight();
	            that.setMenuSize();
	
	            // Get correct width if element is hidden
	            var $selectClone = that.$newElement.clone().appendTo('body'),
	                btnWidth = $selectClone.css('width', 'auto').children('button').outerWidth();
	
	            $selectClone.remove();
	
	            // Set width to whatever's larger, button title or longest option
	            that.sizeInfo.selectWidth = Math.max(that.sizeInfo.totalMenuWidth, btnWidth);
	            that.$newElement.css('width', that.sizeInfo.selectWidth + 'px');
	          });
	        });
	      } else if (this.options.width === 'fit') {
	        // Remove inline min-width so width can be changed from 'auto'
	        this.$menu.css('min-width', '');
	        this.$newElement.css('width', '').addClass('fit-width');
	      } else if (this.options.width) {
	        // Remove inline min-width so width can be changed from 'auto'
	        this.$menu.css('min-width', '');
	        this.$newElement.css('width', this.options.width);
	      } else {
	        // Remove inline min-width/width so width can be changed
	        this.$menu.css('min-width', '');
	        this.$newElement.css('width', '');
	      }
	      // Remove fit-width class if width is changed programmatically
	      if (this.$newElement.hasClass('fit-width') && this.options.width !== 'fit') {
	        this.$newElement[0].classList.remove('fit-width');
	      }
	    },
	
	    selectPosition: function () {
	      this.$bsContainer = $('<div class="bs-container" />');
	
	      var that = this,
	          $container = $(this.options.container),
	          pos,
	          containerPos,
	          actualHeight,
	          getPlacement = function ($element) {
	            var containerPosition = {},
	                // fall back to dropdown's default display setting if display is not manually set
	                display = that.options.display || (
	                  // Bootstrap 3 doesn't have $.fn.dropdown.Constructor.Default
	                  $.fn.dropdown.Constructor.Default ? $.fn.dropdown.Constructor.Default.display
	                  : false
	                );
	
	            that.$bsContainer.addClass($element.attr('class').replace(/form-control|fit-width/gi, '')).toggleClass(classNames.DROPUP, $element.hasClass(classNames.DROPUP));
	            pos = $element.offset();
	
	            if (!$container.is('body')) {
	              containerPos = $container.offset();
	              containerPos.top += parseInt($container.css('borderTopWidth')) - $container.scrollTop();
	              containerPos.left += parseInt($container.css('borderLeftWidth')) - $container.scrollLeft();
	            } else {
	              containerPos = { top: 0, left: 0 };
	            }
	
	            actualHeight = $element.hasClass(classNames.DROPUP) ? 0 : $element[0].offsetHeight;
	
	            // Bootstrap 4+ uses Popper for menu positioning
	            if (version.major < 4 || display === 'static') {
	              containerPosition.top = pos.top - containerPos.top + actualHeight;
	              containerPosition.left = pos.left - containerPos.left;
	            }
	
	            containerPosition.width = $element[0].offsetWidth;
	
	            that.$bsContainer.css(containerPosition);
	          };
	
	      this.$button.on('click.bs.dropdown.data-api', function () {
	        if (that.isDisabled()) {
	          return;
	        }
	
	        getPlacement(that.$newElement);
	
	        that.$bsContainer
	          .appendTo(that.options.container)
	          .toggleClass(classNames.SHOW, !that.$button.hasClass(classNames.SHOW))
	          .append(that.$menu);
	      });
	
	      $(window)
	        .off('resize' + EVENT_KEY + '.' + this.selectId + ' scroll' + EVENT_KEY + '.' + this.selectId)
	        .on('resize' + EVENT_KEY + '.' + this.selectId + ' scroll' + EVENT_KEY + '.' + this.selectId, function () {
	          var isActive = that.$newElement.hasClass(classNames.SHOW);
	
	          if (isActive) getPlacement(that.$newElement);
	        });
	
	      this.$element.on('hide' + EVENT_KEY, function () {
	        that.$menu.data('height', that.$menu.height());
	        that.$bsContainer.detach();
	      });
	    },
	
	    setOptionStatus: function (selectedOnly) {
	      var that = this;
	
	      that.noScroll = false;
	
	      if (that.selectpicker.view.visibleElements && that.selectpicker.view.visibleElements.length) {
	        for (var i = 0; i < that.selectpicker.view.visibleElements.length; i++) {
	          var liData = that.selectpicker.current.data[i + that.selectpicker.view.position0],
	              option = liData.option;
	
	          if (option) {
	            if (selectedOnly !== true) {
	              that.setDisabled(
	                liData.index,
	                liData.disabled
	              );
	            }
	
	            that.setSelected(
	              liData.index,
	              option.selected
	            );
	          }
	        }
	      }
	    },
	
	    /**
	     * @param {number} index - the index of the option that is being changed
	     * @param {boolean} selected - true if the option is being selected, false if being deselected
	     */
	    setSelected: function (index, selected) {
	      var li = this.selectpicker.main.elements[index],
	          liData = this.selectpicker.main.data[index],
	          activeIndexIsSet = this.activeIndex !== undefined,
	          thisIsActive = this.activeIndex === index,
	          prevActive,
	          a,
	          // if current option is already active
	          // OR
	          // if the current option is being selected, it's NOT multiple, and
	          // activeIndex is undefined:
	          //  - when the menu is first being opened, OR
	          //  - after a search has been performed, OR
	          //  - when retainActive is false when selecting a new option (i.e. index of the newly selected option is not the same as the current activeIndex)
	          keepActive = thisIsActive || (selected && !this.multiple && !activeIndexIsSet);
	
	      liData.selected = selected;
	
	      a = li.firstChild;
	
	      if (selected) {
	        this.selectedIndex = index;
	      }
	
	      li.classList.toggle('selected', selected);
	
	      if (keepActive) {
	        this.focusItem(li, liData);
	        this.selectpicker.view.currentActive = li;
	        this.activeIndex = index;
	      } else {
	        this.defocusItem(li);
	      }
	
	      if (a) {
	        a.classList.toggle('selected', selected);
	
	        if (selected) {
	          a.setAttribute('aria-selected', true);
	        } else {
	          if (this.multiple) {
	            a.setAttribute('aria-selected', false);
	          } else {
	            a.removeAttribute('aria-selected');
	          }
	        }
	      }
	
	      if (!keepActive && !activeIndexIsSet && selected && this.prevActiveIndex !== undefined) {
	        prevActive = this.selectpicker.main.elements[this.prevActiveIndex];
	
	        this.defocusItem(prevActive);
	      }
	    },
	
	    /**
	     * @param {number} index - the index of the option that is being disabled
	     * @param {boolean} disabled - true if the option is being disabled, false if being enabled
	     */
	    setDisabled: function (index, disabled) {
	      var li = this.selectpicker.main.elements[index],
	          a;
	
	      this.selectpicker.main.data[index].disabled = disabled;
	
	      a = li.firstChild;
	
	      li.classList.toggle(classNames.DISABLED, disabled);
	
	      if (a) {
	        if (version.major === '4') a.classList.toggle(classNames.DISABLED, disabled);
	
	        if (disabled) {
	          a.setAttribute('aria-disabled', disabled);
	          a.setAttribute('tabindex', -1);
	        } else {
	          a.removeAttribute('aria-disabled');
	          a.setAttribute('tabindex', 0);
	        }
	      }
	    },
	
	    isDisabled: function () {
	      return this.$element[0].disabled;
	    },
	
	    checkDisabled: function () {
	      if (this.isDisabled()) {
	        this.$newElement[0].classList.add(classNames.DISABLED);
	        this.$button.addClass(classNames.DISABLED).attr('aria-disabled', true);
	      } else {
	        if (this.$button[0].classList.contains(classNames.DISABLED)) {
	          this.$newElement[0].classList.remove(classNames.DISABLED);
	          this.$button.removeClass(classNames.DISABLED).attr('aria-disabled', false);
	        }
	      }
	    },
	
	    clickListener: function () {
	      var that = this,
	          $document = $(document);
	
	      $document.data('spaceSelect', false);
	
	      this.$button.on('keyup', function (e) {
	        if (/(32)/.test(e.keyCode.toString(10)) && $document.data('spaceSelect')) {
	          e.preventDefault();
	          $document.data('spaceSelect', false);
	        }
	      });
	
	      this.$newElement.on('show.bs.dropdown', function () {
	        if (version.major > 3 && !that.dropdown) {
	          that.dropdown = that.$button.data('bs.dropdown');
	          that.dropdown._menu = that.$menu[0];
	        }
	      });
	
	      this.$button.on('click.bs.dropdown.data-api', function () {
	        if (!that.$newElement.hasClass(classNames.SHOW)) {
	          that.setSize();
	        }
	      });
	
	      function setFocus () {
	        if (that.options.liveSearch) {
	          that.$searchbox.trigger('focus');
	        } else {
	          that.$menuInner.trigger('focus');
	        }
	      }
	
	      function checkPopperExists () {
	        if (that.dropdown && that.dropdown._popper && that.dropdown._popper.state.isCreated) {
	          setFocus();
	        } else {
	          requestAnimationFrame(checkPopperExists);
	        }
	      }
	
	      this.$element.on('shown' + EVENT_KEY, function () {
	        if (that.$menuInner[0].scrollTop !== that.selectpicker.view.scrollTop) {
	          that.$menuInner[0].scrollTop = that.selectpicker.view.scrollTop;
	        }
	
	        if (version.major > 3) {
	          requestAnimationFrame(checkPopperExists);
	        } else {
	          setFocus();
	        }
	      });
	
	      // ensure posinset and setsize are correct before selecting an option via a click
	      this.$menuInner.on('mouseenter', 'li a', function (e) {
	        var hoverLi = this.parentElement,
	            position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0,
	            index = Array.prototype.indexOf.call(hoverLi.parentElement.children, hoverLi),
	            hoverData = that.selectpicker.current.data[index + position0];
	
	        that.focusItem(hoverLi, hoverData, true);
	      });
	
	      this.$menuInner.on('click', 'li a', function (e, retainActive) {
	        var $this = $(this),
	            element = that.$element[0],
	            position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0,
	            clickedData = that.selectpicker.current.data[$this.parent().index() + position0],
	            clickedIndex = clickedData.index,
	            prevValue = getSelectValues(element),
	            prevIndex = element.selectedIndex,
	            prevOption = element.options[prevIndex],
	            triggerChange = true;
	
	        // Don't close on multi choice menu
	        if (that.multiple && that.options.maxOptions !== 1) {
	          e.stopPropagation();
	        }
	
	        e.preventDefault();
	
	        // Don't run if the select is disabled
	        if (!that.isDisabled() && !$this.parent().hasClass(classNames.DISABLED)) {
	          var option = clickedData.option,
	              $option = $(option),
	              state = option.selected,
	              $optgroup = $option.parent('optgroup'),
	              $optgroupOptions = $optgroup.find('option'),
	              maxOptions = that.options.maxOptions,
	              maxOptionsGrp = $optgroup.data('maxOptions') || false;
	
	          if (clickedIndex === that.activeIndex) retainActive = true;
	
	          if (!retainActive) {
	            that.prevActiveIndex = that.activeIndex;
	            that.activeIndex = undefined;
	          }
	
	          if (!that.multiple) { // Deselect all others if not multi select box
	            if (prevOption) prevOption.selected = false;
	            option.selected = true;
	            that.setSelected(clickedIndex, true);
	          } else { // Toggle the one we have chosen if we are multi select.
	            option.selected = !state;
	
	            that.setSelected(clickedIndex, !state);
	            that.focusedParent.focus();
	
	            if (maxOptions !== false || maxOptionsGrp !== false) {
	              var maxReached = maxOptions < getSelectedOptions(element).length,
	                  maxReachedGrp = maxOptionsGrp < $optgroup.find('option:selected').length;
	
	              if ((maxOptions && maxReached) || (maxOptionsGrp && maxReachedGrp)) {
	                if (maxOptions && maxOptions == 1) {
	                  element.selectedIndex = -1;
	                  option.selected = true;
	                  that.setOptionStatus(true);
	                } else if (maxOptionsGrp && maxOptionsGrp == 1) {
	                  for (var i = 0; i < $optgroupOptions.length; i++) {
	                    var _option = $optgroupOptions[i];
	                    _option.selected = false;
	                    that.setSelected(_option.liIndex, false);
	                  }
	
	                  option.selected = true;
	                  that.setSelected(clickedIndex, true);
	                } else {
	                  var maxOptionsText = typeof that.options.maxOptionsText === 'string' ? [that.options.maxOptionsText, that.options.maxOptionsText] : that.options.maxOptionsText,
	                      maxOptionsArr = typeof maxOptionsText === 'function' ? maxOptionsText(maxOptions, maxOptionsGrp) : maxOptionsText,
	                      maxTxt = maxOptionsArr[0].replace('{n}', maxOptions),
	                      maxTxtGrp = maxOptionsArr[1].replace('{n}', maxOptionsGrp),
	                      $notify = $('<div class="notify"></div>');
	                  // If {var} is set in array, replace it
	                  /** @deprecated */
	                  if (maxOptionsArr[2]) {
	                    maxTxt = maxTxt.replace('{var}', maxOptionsArr[2][maxOptions > 1 ? 0 : 1]);
	                    maxTxtGrp = maxTxtGrp.replace('{var}', maxOptionsArr[2][maxOptionsGrp > 1 ? 0 : 1]);
	                  }
	
	                  option.selected = false;
	
	                  that.$menu.append($notify);
	
	                  if (maxOptions && maxReached) {
	                    $notify.append($('<div>' + maxTxt + '</div>'));
	                    triggerChange = false;
	                    that.$element.trigger('maxReached' + EVENT_KEY);
	                  }
	
	                  if (maxOptionsGrp && maxReachedGrp) {
	                    $notify.append($('<div>' + maxTxtGrp + '</div>'));
	                    triggerChange = false;
	                    that.$element.trigger('maxReachedGrp' + EVENT_KEY);
	                  }
	
	                  setTimeout(function () {
	                    that.setSelected(clickedIndex, false);
	                  }, 10);
	
	                  $notify[0].classList.add('fadeOut');
	
	                  setTimeout(function () {
	                    $notify.remove();
	                  }, 1050);
	                }
	              }
	            }
	          }
	
	          if (!that.multiple || (that.multiple && that.options.maxOptions === 1)) {
	            that.$button.trigger('focus');
	          } else if (that.options.liveSearch) {
	            that.$searchbox.trigger('focus');
	          }
	
	          // Trigger select 'change'
	          if (triggerChange) {
	            if (that.multiple || prevIndex !== element.selectedIndex) {
	              // $option.prop('selected') is current option state (selected/unselected). prevValue is the value of the select prior to being changed.
	              changedArguments = [option.index, $option.prop('selected'), prevValue];
	              that.$element
	                .triggerNative('change');
	            }
	          }
	        }
	      });
	
	      this.$menu.on('click', 'li.' + classNames.DISABLED + ' a, .' + classNames.POPOVERHEADER + ', .' + classNames.POPOVERHEADER + ' :not(.close)', function (e) {
	        if (e.currentTarget == this) {
	          e.preventDefault();
	          e.stopPropagation();
	          if (that.options.liveSearch && !$(e.target).hasClass('close')) {
	            that.$searchbox.trigger('focus');
	          } else {
	            that.$button.trigger('focus');
	          }
	        }
	      });
	
	      this.$menuInner.on('click', '.divider, .dropdown-header', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	        if (that.options.liveSearch) {
	          that.$searchbox.trigger('focus');
	        } else {
	          that.$button.trigger('focus');
	        }
	      });
	
	      this.$menu.on('click', '.' + classNames.POPOVERHEADER + ' .close', function () {
	        that.$button.trigger('click');
	      });
	
	      this.$searchbox.on('click', function (e) {
	        e.stopPropagation();
	      });
	
	      this.$menu.on('click', '.actions-btn', function (e) {
	        if (that.options.liveSearch) {
	          that.$searchbox.trigger('focus');
	        } else {
	          that.$button.trigger('focus');
	        }
	
	        e.preventDefault();
	        e.stopPropagation();
	
	        if ($(this).hasClass('bs-select-all')) {
	          that.selectAll();
	        } else {
	          that.deselectAll();
	        }
	      });
	
	      this.$button
	        .on('focus' + EVENT_KEY, function (e) {
	          var tabindex = that.$element[0].getAttribute('tabindex');
	
	          // only change when button is actually focused
	          if (tabindex !== undefined && e.originalEvent && e.originalEvent.isTrusted) {
	            // apply select element's tabindex to ensure correct order is followed when tabbing to the next element
	            this.setAttribute('tabindex', tabindex);
	            // set element's tabindex to -1 to allow for reverse tabbing
	            that.$element[0].setAttribute('tabindex', -1);
	            that.selectpicker.view.tabindex = tabindex;
	          }
	        })
	        .on('blur' + EVENT_KEY, function (e) {
	          // revert everything to original tabindex
	          if (that.selectpicker.view.tabindex !== undefined && e.originalEvent && e.originalEvent.isTrusted) {
	            that.$element[0].setAttribute('tabindex', that.selectpicker.view.tabindex);
	            this.setAttribute('tabindex', -1);
	            that.selectpicker.view.tabindex = undefined;
	          }
	        });
	
	      this.$element
	        .on('change' + EVENT_KEY, function () {
	          that.render();
	          that.$element.trigger('changed' + EVENT_KEY, changedArguments);
	          changedArguments = null;
	        })
	        .on('focus' + EVENT_KEY, function () {
	          if (!that.options.mobile) that.$button[0].focus();
	        });
	    },
	
	    liveSearchListener: function () {
	      var that = this;
	
	      this.$button.on('click.bs.dropdown.data-api', function () {
	        if (!!that.$searchbox.val()) {
	          that.$searchbox.val('');
	          that.selectpicker.search.previousValue = undefined;
	        }
	      });
	
	      this.$searchbox.on('click.bs.dropdown.data-api focus.bs.dropdown.data-api touchend.bs.dropdown.data-api', function (e) {
	        e.stopPropagation();
	      });
	
	      this.$searchbox.on('input propertychange', function () {
	        var searchValue = that.$searchbox[0].value;
	
	        that.selectpicker.search.elements = [];
	        that.selectpicker.search.data = [];
	
	        if (searchValue) {
	          var i,
	              searchMatch = [],
	              q = searchValue.toUpperCase(),
	              cache = {},
	              cacheArr = [],
	              searchStyle = that._searchStyle(),
	              normalizeSearch = that.options.liveSearchNormalize;
	
	          if (normalizeSearch) q = normalizeToBase(q);
	
	          for (var i = 0; i < that.selectpicker.main.data.length; i++) {
	            var li = that.selectpicker.main.data[i];
	
	            if (!cache[i]) {
	              cache[i] = stringSearch(li, q, searchStyle, normalizeSearch);
	            }
	
	            if (cache[i] && li.headerIndex !== undefined && cacheArr.indexOf(li.headerIndex) === -1) {
	              if (li.headerIndex > 0) {
	                cache[li.headerIndex - 1] = true;
	                cacheArr.push(li.headerIndex - 1);
	              }
	
	              cache[li.headerIndex] = true;
	              cacheArr.push(li.headerIndex);
	
	              cache[li.lastIndex + 1] = true;
	            }
	
	            if (cache[i] && li.type !== 'optgroup-label') cacheArr.push(i);
	          }
	
	          for (var i = 0, cacheLen = cacheArr.length; i < cacheLen; i++) {
	            var index = cacheArr[i],
	                prevIndex = cacheArr[i - 1],
	                li = that.selectpicker.main.data[index],
	                liPrev = that.selectpicker.main.data[prevIndex];
	
	            if (li.type !== 'divider' || (li.type === 'divider' && liPrev && liPrev.type !== 'divider' && cacheLen - 1 !== i)) {
	              that.selectpicker.search.data.push(li);
	              searchMatch.push(that.selectpicker.main.elements[index]);
	            }
	          }
	
	          that.activeIndex = undefined;
	          that.noScroll = true;
	          that.$menuInner.scrollTop(0);
	          that.selectpicker.search.elements = searchMatch;
	          that.createView(true);
	          showNoResults.call(that, searchMatch, searchValue);
	        } else if (that.selectpicker.search.previousValue) { // for IE11 (#2402)
	          that.$menuInner.scrollTop(0);
	          that.createView(false);
	        }
	
	        that.selectpicker.search.previousValue =  searchValue;
	      });
	    },
	
	    _searchStyle: function () {
	      return this.options.liveSearchStyle || 'contains';
	    },
	
	    val: function (value) {
	      var element = this.$element[0];
	
	      if (typeof value !== 'undefined') {
	        var prevValue = getSelectValues(element);
	
	        changedArguments = [null, null, prevValue];
	
	        this.$element
	          .val(value)
	          .trigger('changed' + EVENT_KEY, changedArguments);
	
	        if (this.$newElement.hasClass(classNames.SHOW)) {
	          if (this.multiple) {
	            this.setOptionStatus(true);
	          } else {
	            var liSelectedIndex = (element.options[element.selectedIndex] || {}).liIndex;
	
	            if (typeof liSelectedIndex === 'number') {
	              this.setSelected(this.selectedIndex, false);
	              this.setSelected(liSelectedIndex, true);
	            }
	          }
	        }
	
	        this.render();
	
	        changedArguments = null;
	
	        return this.$element;
	      } else {
	        return this.$element.val();
	      }
	    },
	
	    changeAll: function (status) {
	      if (!this.multiple) return;
	      if (typeof status === 'undefined') status = true;
	
	      var element = this.$element[0],
	          previousSelected = 0,
	          currentSelected = 0,
	          prevValue = getSelectValues(element);
	
	      element.classList.add('bs-select-hidden');
	
	      for (var i = 0, data = this.selectpicker.current.data, len = data.length; i < len; i++) {
	        var liData = data[i],
	            option = liData.option;
	
	        if (option && !liData.disabled && liData.type !== 'divider') {
	          if (liData.selected) previousSelected++;
	          option.selected = status;
	          if (status === true) currentSelected++;
	        }
	      }
	
	      element.classList.remove('bs-select-hidden');
	
	      if (previousSelected === currentSelected) return;
	
	      this.setOptionStatus();
	
	      changedArguments = [null, null, prevValue];
	
	      this.$element
	        .triggerNative('change');
	    },
	
	    selectAll: function () {
	      return this.changeAll(true);
	    },
	
	    deselectAll: function () {
	      return this.changeAll(false);
	    },
	
	    toggle: function (e) {
	      e = e || window.event;
	
	      if (e) e.stopPropagation();
	
	      this.$button.trigger('click.bs.dropdown.data-api');
	    },
	
	    keydown: function (e) {
	      var $this = $(this),
	          isToggle = $this.hasClass('dropdown-toggle'),
	          $parent = isToggle ? $this.closest('.dropdown') : $this.closest(Selector.MENU),
	          that = $parent.data('this'),
	          $items = that.findLis(),
	          index,
	          isActive,
	          liActive,
	          activeLi,
	          offset,
	          updateScroll = false,
	          downOnTab = e.which === keyCodes.TAB && !isToggle && !that.options.selectOnTab,
	          isArrowKey = REGEXP_ARROW.test(e.which) || downOnTab,
	          scrollTop = that.$menuInner[0].scrollTop,
	          isVirtual = that.isVirtual(),
	          position0 = isVirtual === true ? that.selectpicker.view.position0 : 0;
	
	      // do nothing if a function key is pressed
	      if (e.which >= 112 && e.which <= 123) return;
	
	      isActive = that.$newElement.hasClass(classNames.SHOW);
	
	      if (
	        !isActive &&
	        (
	          isArrowKey ||
	          (e.which >= 48 && e.which <= 57) ||
	          (e.which >= 96 && e.which <= 105) ||
	          (e.which >= 65 && e.which <= 90)
	        )
	      ) {
	        that.$button.trigger('click.bs.dropdown.data-api');
	
	        if (that.options.liveSearch) {
	          that.$searchbox.trigger('focus');
	          return;
	        }
	      }
	
	      if (e.which === keyCodes.ESCAPE && isActive) {
	        e.preventDefault();
	        that.$button.trigger('click.bs.dropdown.data-api').trigger('focus');
	      }
	
	      if (isArrowKey) { // if up or down
	        if (!$items.length) return;
	
	        liActive = that.selectpicker.main.elements[that.activeIndex];
	        index = liActive ? Array.prototype.indexOf.call(liActive.parentElement.children, liActive) : -1;
	
	        if (index !== -1) {
	          that.defocusItem(liActive);
	        }
	
	        if (e.which === keyCodes.ARROW_UP) { // up
	          if (index !== -1) index--;
	          if (index + position0 < 0) index += $items.length;
	
	          if (!that.selectpicker.view.canHighlight[index + position0]) {
	            index = that.selectpicker.view.canHighlight.slice(0, index + position0).lastIndexOf(true) - position0;
	            if (index === -1) index = $items.length - 1;
	          }
	        } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) { // down
	          index++;
	          if (index + position0 >= that.selectpicker.view.canHighlight.length) index = that.selectpicker.view.firstHighlightIndex;
	
	          if (!that.selectpicker.view.canHighlight[index + position0]) {
	            index = index + 1 + that.selectpicker.view.canHighlight.slice(index + position0 + 1).indexOf(true);
	          }
	        }
	
	        e.preventDefault();
	
	        var liActiveIndex = position0 + index;
	
	        if (e.which === keyCodes.ARROW_UP) { // up
	          // scroll to bottom and highlight last option
	          if (position0 === 0 && index === $items.length - 1) {
	            that.$menuInner[0].scrollTop = that.$menuInner[0].scrollHeight;
	
	            liActiveIndex = that.selectpicker.current.elements.length - 1;
	          } else {
	            activeLi = that.selectpicker.current.data[liActiveIndex];
	            offset = activeLi.position - activeLi.height;
	
	            updateScroll = offset < scrollTop;
	          }
	        } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) { // down
	          // scroll to top and highlight first option
	          if (index === that.selectpicker.view.firstHighlightIndex) {
	            that.$menuInner[0].scrollTop = 0;
	
	            liActiveIndex = that.selectpicker.view.firstHighlightIndex;
	          } else {
	            activeLi = that.selectpicker.current.data[liActiveIndex];
	            offset = activeLi.position - that.sizeInfo.menuInnerHeight;
	
	            updateScroll = offset > scrollTop;
	          }
	        }
	
	        liActive = that.selectpicker.current.elements[liActiveIndex];
	
	        that.activeIndex = that.selectpicker.current.data[liActiveIndex].index;
	
	        that.focusItem(liActive);
	
	        that.selectpicker.view.currentActive = liActive;
	
	        if (updateScroll) that.$menuInner[0].scrollTop = offset;
	
	        if (that.options.liveSearch) {
	          that.$searchbox.trigger('focus');
	        } else {
	          $this.trigger('focus');
	        }
	      } else if (
	        (!$this.is('input') && !REGEXP_TAB_OR_ESCAPE.test(e.which)) ||
	        (e.which === keyCodes.SPACE && that.selectpicker.keydown.keyHistory)
	      ) {
	        var searchMatch,
	            matches = [],
	            keyHistory;
	
	        e.preventDefault();
	
	        that.selectpicker.keydown.keyHistory += keyCodeMap[e.which];
	
	        if (that.selectpicker.keydown.resetKeyHistory.cancel) clearTimeout(that.selectpicker.keydown.resetKeyHistory.cancel);
	        that.selectpicker.keydown.resetKeyHistory.cancel = that.selectpicker.keydown.resetKeyHistory.start();
	
	        keyHistory = that.selectpicker.keydown.keyHistory;
	
	        // if all letters are the same, set keyHistory to just the first character when searching
	        if (/^(.)\1+$/.test(keyHistory)) {
	          keyHistory = keyHistory.charAt(0);
	        }
	
	        // find matches
	        for (var i = 0; i < that.selectpicker.current.data.length; i++) {
	          var li = that.selectpicker.current.data[i],
	              hasMatch;
	
	          hasMatch = stringSearch(li, keyHistory, 'startsWith', true);
	
	          if (hasMatch && that.selectpicker.view.canHighlight[i]) {
	            matches.push(li.index);
	          }
	        }
	
	        if (matches.length) {
	          var matchIndex = 0;
	
	          $items.removeClass('active').find('a').removeClass('active');
	
	          // either only one key has been pressed or they are all the same key
	          if (keyHistory.length === 1) {
	            matchIndex = matches.indexOf(that.activeIndex);
	
	            if (matchIndex === -1 || matchIndex === matches.length - 1) {
	              matchIndex = 0;
	            } else {
	              matchIndex++;
	            }
	          }
	
	          searchMatch = matches[matchIndex];
	
	          activeLi = that.selectpicker.main.data[searchMatch];
	
	          if (scrollTop - activeLi.position > 0) {
	            offset = activeLi.position - activeLi.height;
	            updateScroll = true;
	          } else {
	            offset = activeLi.position - that.sizeInfo.menuInnerHeight;
	            // if the option is already visible at the current scroll position, just keep it the same
	            updateScroll = activeLi.position > scrollTop + that.sizeInfo.menuInnerHeight;
	          }
	
	          liActive = that.selectpicker.main.elements[searchMatch];
	
	          that.activeIndex = matches[matchIndex];
	
	          that.focusItem(liActive);
	
	          if (liActive) liActive.firstChild.focus();
	
	          if (updateScroll) that.$menuInner[0].scrollTop = offset;
	
	          $this.trigger('focus');
	        }
	      }
	
	      // Select focused option if "Enter", "Spacebar" or "Tab" (when selectOnTab is true) are pressed inside the menu.
	      if (
	        isActive &&
	        (
	          (e.which === keyCodes.SPACE && !that.selectpicker.keydown.keyHistory) ||
	          e.which === keyCodes.ENTER ||
	          (e.which === keyCodes.TAB && that.options.selectOnTab)
	        )
	      ) {
	        if (e.which !== keyCodes.SPACE) e.preventDefault();
	
	        if (!that.options.liveSearch || e.which !== keyCodes.SPACE) {
	          that.$menuInner.find('.active a').trigger('click', true); // retain active class
	          $this.trigger('focus');
	
	          if (!that.options.liveSearch) {
	            // Prevent screen from scrolling if the user hits the spacebar
	            e.preventDefault();
	            // Fixes spacebar selection of dropdown items in FF & IE
	            $(document).data('spaceSelect', true);
	          }
	        }
	      }
	    },
	
	    mobile: function () {
	      // ensure mobile is set to true if mobile function is called after init
	      this.options.mobile = true;
	      this.$element[0].classList.add('mobile-device');
	    },
	
	    refresh: function () {
	      // update options if data attributes have been changed
	      var config = $.extend({}, this.options, this.$element.data());
	      this.options = config;
	
	      this.checkDisabled();
	      this.buildData();
	      this.setStyle();
	      this.render();
	      this.buildList();
	      this.setWidth();
	
	      this.setSize(true);
	
	      this.$element.trigger('refreshed' + EVENT_KEY);
	    },
	
	    hide: function () {
	      this.$newElement.hide();
	    },
	
	    show: function () {
	      this.$newElement.show();
	    },
	
	    remove: function () {
	      this.$newElement.remove();
	      this.$element.remove();
	    },
	
	    destroy: function () {
	      this.$newElement.before(this.$element).remove();
	
	      if (this.$bsContainer) {
	        this.$bsContainer.remove();
	      } else {
	        this.$menu.remove();
	      }
	
	      if (this.selectpicker.view.titleOption && this.selectpicker.view.titleOption.parentNode) {
	        this.selectpicker.view.titleOption.parentNode.removeChild(this.selectpicker.view.titleOption);
	      }
	
	      this.$element
	        .off(EVENT_KEY)
	        .removeData('selectpicker')
	        .removeClass('bs-select-hidden selectpicker');
	
	      $(window).off(EVENT_KEY + '.' + this.selectId);
	    }
	  };
	
	  // SELECTPICKER PLUGIN DEFINITION
	  // ==============================
	  function Plugin (option) {
	    // get the args of the outer function..
	    var args = arguments;
	    // The arguments of the function are explicitly re-defined from the argument list, because the shift causes them
	    // to get lost/corrupted in android 2.3 and IE9 #715 #775
	    var _option = option;
	
	    [].shift.apply(args);
	
	    // if the version was not set successfully
	    if (!version.success) {
	      // try to retreive it again
	      try {
	        version.full = ($.fn.dropdown.Constructor.VERSION || '').split(' ')[0].split('.');
	      } catch (err) {
	        // fall back to use BootstrapVersion if set
	        if (Selectpicker.BootstrapVersion) {
	          version.full = Selectpicker.BootstrapVersion.split(' ')[0].split('.');
	        } else {
	          version.full = [version.major, '0', '0'];
	
	          console.warn(
	            'There was an issue retrieving Bootstrap\'s version. ' +
	            'Ensure Bootstrap is being loaded before bootstrap-select and there is no namespace collision. ' +
	            'If loading Bootstrap asynchronously, the version may need to be manually specified via $.fn.selectpicker.Constructor.BootstrapVersion.',
	            err
	          );
	        }
	      }
	
	      version.major = version.full[0];
	      version.success = true;
	    }
	
	    if (version.major === '4') {
	      // some defaults need to be changed if using Bootstrap 4
	      // check to see if they have already been manually changed before forcing them to update
	      var toUpdate = [];
	
	      if (Selectpicker.DEFAULTS.style === classNames.BUTTONCLASS) toUpdate.push({ name: 'style', className: 'BUTTONCLASS' });
	      if (Selectpicker.DEFAULTS.iconBase === classNames.ICONBASE) toUpdate.push({ name: 'iconBase', className: 'ICONBASE' });
	      if (Selectpicker.DEFAULTS.tickIcon === classNames.TICKICON) toUpdate.push({ name: 'tickIcon', className: 'TICKICON' });
	
	      classNames.DIVIDER = 'dropdown-divider';
	      classNames.SHOW = 'show';
	      classNames.BUTTONCLASS = 'btn-light';
	      classNames.POPOVERHEADER = 'popover-header';
	      classNames.ICONBASE = '';
	      classNames.TICKICON = 'bs-ok-default';
	
	      for (var i = 0; i < toUpdate.length; i++) {
	        var option = toUpdate[i];
	        Selectpicker.DEFAULTS[option.name] = classNames[option.className];
	      }
	    }
	
	    var value;
	    var chain = this.each(function () {
	      var $this = $(this);
	      if ($this.is('select')) {
	        var data = $this.data('selectpicker'),
	            options = typeof _option == 'object' && _option;
	
	        if (!data) {
	          var dataAttributes = $this.data();
	
	          for (var dataAttr in dataAttributes) {
	            if (Object.prototype.hasOwnProperty.call(dataAttributes, dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
	              delete dataAttributes[dataAttr];
	            }
	          }
	
	          var config = $.extend({}, Selectpicker.DEFAULTS, $.fn.selectpicker.defaults || {}, dataAttributes, options);
	          config.template = $.extend({}, Selectpicker.DEFAULTS.template, ($.fn.selectpicker.defaults ? $.fn.selectpicker.defaults.template : {}), dataAttributes.template, options.template);
	          $this.data('selectpicker', (data = new Selectpicker(this, config)));
	        } else if (options) {
	          for (var i in options) {
	            if (Object.prototype.hasOwnProperty.call(options, i)) {
	              data.options[i] = options[i];
	            }
	          }
	        }
	
	        if (typeof _option == 'string') {
	          if (data[_option] instanceof Function) {
	            value = data[_option].apply(data, args);
	          } else {
	            value = data.options[_option];
	          }
	        }
	      }
	    });
	
	    if (typeof value !== 'undefined') {
	      // noinspection JSUnusedAssignment
	      return value;
	    } else {
	      return chain;
	    }
	  }
	
	  var old = $.fn.selectpicker;
	  $.fn.selectpicker = Plugin;
	  $.fn.selectpicker.Constructor = Selectpicker;
	
	  // SELECTPICKER NO CONFLICT
	  // ========================
	  $.fn.selectpicker.noConflict = function () {
	    $.fn.selectpicker = old;
	    return this;
	  };
	
	  // get Bootstrap's keydown event handler for either Bootstrap 4 or Bootstrap 3
	  function keydownHandler () {
	    if ($.fn.dropdown) {
	      // wait to define until function is called in case Bootstrap isn't loaded yet
	      var bootstrapKeydown = $.fn.dropdown.Constructor._dataApiKeydownHandler || $.fn.dropdown.Constructor.prototype.keydown;
	      return bootstrapKeydown.apply(this, arguments);
	    }
	  }
	
	  $(document)
	    .off('keydown.bs.dropdown.data-api')
	    .on('keydown.bs.dropdown.data-api', ':not(.bootstrap-select) > [data-toggle="dropdown"]', keydownHandler)
	    .on('keydown.bs.dropdown.data-api', ':not(.bootstrap-select) > .dropdown-menu', keydownHandler)
	    .on('keydown' + EVENT_KEY, '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', Selectpicker.prototype.keydown)
	    .on('focusin.modal', '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', function (e) {
	      e.stopPropagation();
	    });
	
	  // SELECTPICKER DATA-API
	  // =====================
	  $(window).on('load' + EVENT_KEY + '.data-api', function () {
	    $('.selectpicker').each(function () {
	      var $selectpicker = $(this);
	      Plugin.call($selectpicker, $selectpicker.data());
	    })
	  });
	})(jQuery);
	
	
	}));
	//# sourceMappingURL=bootstrap-select.js.map

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(771)
	var ieee754 = __webpack_require__(984)
	var isArray = __webpack_require__(986)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(781);
	module.exports = __webpack_require__(35).RegExp.escape;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(9);
	var isArray = __webpack_require__(92);
	var SPECIES = __webpack_require__(10)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(8);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(6);
	var toPrimitive = __webpack_require__(46);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(60);
	var gOPS = __webpack_require__(96);
	var pIE = __webpack_require__(77);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(78)('native-function-to-string', Function.toString);


/***/ }),
/* 780 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(3);
	var $re = __webpack_require__(780)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(194) });
	
	__webpack_require__(51)('copyWithin');


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $every = __webpack_require__(43)(4);
	
	$export($export.P + $export.F * !__webpack_require__(37)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Array', { fill: __webpack_require__(124) });
	
	__webpack_require__(51)('fill');


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $filter = __webpack_require__(43)(2);
	
	$export($export.P + $export.F * !__webpack_require__(37)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(3);
	var $find = __webpack_require__(43)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(51)(KEY);


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(3);
	var $find = __webpack_require__(43)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(51)(KEY);


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $forEach = __webpack_require__(43)(0);
	var STRICT = __webpack_require__(37)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(36);
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(14);
	var call = __webpack_require__(205);
	var isArrayIter = __webpack_require__(132);
	var toLength = __webpack_require__(11);
	var createProperty = __webpack_require__(126);
	var getIterFn = __webpack_require__(148);
	
	$export($export.S + $export.F * !__webpack_require__(94)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $indexOf = __webpack_require__(89)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(37)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(92) });


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(3);
	var toIObject = __webpack_require__(30);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(76) != Object || !__webpack_require__(37)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toIObject = __webpack_require__(30);
	var toInteger = __webpack_require__(38);
	var toLength = __webpack_require__(11);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(37)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $map = __webpack_require__(43)(1);
	
	$export($export.P + $export.F * !__webpack_require__(37)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var createProperty = __webpack_require__(126);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(8)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $reduce = __webpack_require__(196);
	
	$export($export.P + $export.F * !__webpack_require__(37)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $reduce = __webpack_require__(196);
	
	$export($export.P + $export.F * !__webpack_require__(37)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var html = __webpack_require__(130);
	var cof = __webpack_require__(34);
	var toAbsoluteIndex = __webpack_require__(64);
	var toLength = __webpack_require__(11);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(8)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $some = __webpack_require__(43)(3);
	
	$export($export.P + $export.F * !__webpack_require__(37)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var aFunction = __webpack_require__(19);
	var toObject = __webpack_require__(14);
	var fails = __webpack_require__(8);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(37)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(63)('Array');


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(3);
	var toISOString = __webpack_require__(776);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(14);
	var toPrimitive = __webpack_require__(46);
	
	$export($export.P + $export.F * __webpack_require__(8)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(10)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(22)(proto, TO_PRIMITIVE, __webpack_require__(777));


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(23)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Function', { bind: __webpack_require__(197) });


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(9);
	var getPrototypeOf = __webpack_require__(29);
	var HAS_INSTANCE = __webpack_require__(10)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(13).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(13).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(12) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(3);
	var log1p = __webpack_require__(208);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(3);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(3);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(3);
	var sign = __webpack_require__(136);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(3);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(3);
	var $expm1 = __webpack_require__(135);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { fround: __webpack_require__(207) });


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(3);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(3);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(8)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(208) });


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { sign: __webpack_require__(136) });


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(3);
	var expm1 = __webpack_require__(135);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(8)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(3);
	var expm1 = __webpack_require__(135);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(7);
	var has = __webpack_require__(27);
	var cof = __webpack_require__(34);
	var inheritIfRequired = __webpack_require__(131);
	var toPrimitive = __webpack_require__(46);
	var fails = __webpack_require__(8);
	var gOPN = __webpack_require__(59).f;
	var gOPD = __webpack_require__(28).f;
	var dP = __webpack_require__(13).f;
	var $trim = __webpack_require__(71).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(58)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(12) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(23)(global, NUMBER, $Number);
	}


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(3);
	var _isFinite = __webpack_require__(7).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(204) });


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(3);
	var isInteger = __webpack_require__(204);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseFloat = __webpack_require__(216);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseInt = __webpack_require__(217);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toInteger = __webpack_require__(38);
	var aNumberValue = __webpack_require__(193);
	var repeat = __webpack_require__(143);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(8)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $fails = __webpack_require__(8);
	var aNumberValue = __webpack_require__(193);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(3);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(210) });


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(58) });


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(12), 'Object', { defineProperties: __webpack_require__(211) });


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(12), 'Object', { defineProperty: __webpack_require__(13).f });


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(9);
	var meta = __webpack_require__(53).onFreeze;
	
	__webpack_require__(45)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(30);
	var $getOwnPropertyDescriptor = __webpack_require__(28).f;
	
	__webpack_require__(45)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(45)('getOwnPropertyNames', function () {
	  return __webpack_require__(212).f;
	});


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(14);
	var $getPrototypeOf = __webpack_require__(29);
	
	__webpack_require__(45)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(9);
	
	__webpack_require__(45)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(9);
	
	__webpack_require__(45)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(9);
	
	__webpack_require__(45)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(3);
	$export($export.S, 'Object', { is: __webpack_require__(220) });


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(14);
	var $keys = __webpack_require__(60);
	
	__webpack_require__(45)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(9);
	var meta = __webpack_require__(53).onFreeze;
	
	__webpack_require__(45)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(9);
	var meta = __webpack_require__(53).onFreeze;
	
	__webpack_require__(45)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(3);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(140).set });


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(68);
	var test = {};
	test[__webpack_require__(10)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(23)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseFloat = __webpack_require__(216);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseInt = __webpack_require__(217);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(52);
	var global = __webpack_require__(7);
	var ctx = __webpack_require__(36);
	var classof = __webpack_require__(68);
	var $export = __webpack_require__(3);
	var isObject = __webpack_require__(9);
	var aFunction = __webpack_require__(19);
	var anInstance = __webpack_require__(56);
	var forOf = __webpack_require__(57);
	var speciesConstructor = __webpack_require__(79);
	var task = __webpack_require__(145).set;
	var microtask = __webpack_require__(137)();
	var newPromiseCapabilityModule = __webpack_require__(138);
	var perform = __webpack_require__(218);
	var userAgent = __webpack_require__(102);
	var promiseResolve = __webpack_require__(219);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(10)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(62)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(70)($Promise, PROMISE);
	__webpack_require__(63)(PROMISE);
	Wrapper = __webpack_require__(35)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(94)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(3);
	var aFunction = __webpack_require__(19);
	var anObject = __webpack_require__(6);
	var rApply = (__webpack_require__(7).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(8)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(3);
	var create = __webpack_require__(58);
	var aFunction = __webpack_require__(19);
	var anObject = __webpack_require__(6);
	var isObject = __webpack_require__(9);
	var fails = __webpack_require__(8);
	var bind = __webpack_require__(197);
	var rConstruct = (__webpack_require__(7).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(13);
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(6);
	var toPrimitive = __webpack_require__(46);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(8)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(3);
	var gOPD = __webpack_require__(28).f;
	var anObject = __webpack_require__(6);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(6);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(133)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(28);
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(6);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(3);
	var getProto = __webpack_require__(29);
	var anObject = __webpack_require__(6);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(28);
	var getPrototypeOf = __webpack_require__(29);
	var has = __webpack_require__(27);
	var $export = __webpack_require__(3);
	var isObject = __webpack_require__(9);
	var anObject = __webpack_require__(6);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(6);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(215) });


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(6);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(3);
	var setProto = __webpack_require__(140);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(13);
	var gOPD = __webpack_require__(28);
	var getPrototypeOf = __webpack_require__(29);
	var has = __webpack_require__(27);
	var $export = __webpack_require__(3);
	var createDesc = __webpack_require__(61);
	var anObject = __webpack_require__(6);
	var isObject = __webpack_require__(9);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(7);
	var inheritIfRequired = __webpack_require__(131);
	var dP = __webpack_require__(13).f;
	var gOPN = __webpack_require__(59).f;
	var isRegExp = __webpack_require__(93);
	var $flags = __webpack_require__(75);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(12) && (!CORRECT_NEW || __webpack_require__(8)(function () {
	  re2[__webpack_require__(10)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(23)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(63)('RegExp');


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(6);
	var toLength = __webpack_require__(11);
	var advanceStringIndex = __webpack_require__(123);
	var regExpExec = __webpack_require__(97);
	
	// @@match logic
	__webpack_require__(91)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(6);
	var toObject = __webpack_require__(14);
	var toLength = __webpack_require__(11);
	var toInteger = __webpack_require__(38);
	var advanceStringIndex = __webpack_require__(123);
	var regExpExec = __webpack_require__(97);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(91)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(6);
	var sameValue = __webpack_require__(220);
	var regExpExec = __webpack_require__(97);
	
	// @@search logic
	__webpack_require__(91)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(93);
	var anObject = __webpack_require__(6);
	var speciesConstructor = __webpack_require__(79);
	var advanceStringIndex = __webpack_require__(123);
	var toLength = __webpack_require__(11);
	var callRegExpExec = __webpack_require__(97);
	var regexpExec = __webpack_require__(139);
	var fails = __webpack_require__(8);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(91)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(226);
	var anObject = __webpack_require__(6);
	var $flags = __webpack_require__(75);
	var DESCRIPTORS = __webpack_require__(12);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(23)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(8)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(24)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(24)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(24)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(24)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $at = __webpack_require__(100)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(3);
	var toLength = __webpack_require__(11);
	var context = __webpack_require__(142);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(129)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(24)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(24)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(24)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var toAbsoluteIndex = __webpack_require__(64);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(3);
	var context = __webpack_require__(142);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(129)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(24)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(100)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(134)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(24)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var toIObject = __webpack_require__(30);
	var toLength = __webpack_require__(11);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(143)
	});


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(24)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(3);
	var toLength = __webpack_require__(11);
	var context = __webpack_require__(142);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(129)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(24)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(24)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(24)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(71)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(7);
	var has = __webpack_require__(27);
	var DESCRIPTORS = __webpack_require__(12);
	var $export = __webpack_require__(3);
	var redefine = __webpack_require__(23);
	var META = __webpack_require__(53).KEY;
	var $fails = __webpack_require__(8);
	var shared = __webpack_require__(78);
	var setToStringTag = __webpack_require__(70);
	var uid = __webpack_require__(65);
	var wks = __webpack_require__(10);
	var wksExt = __webpack_require__(223);
	var wksDefine = __webpack_require__(147);
	var enumKeys = __webpack_require__(778);
	var isArray = __webpack_require__(92);
	var anObject = __webpack_require__(6);
	var isObject = __webpack_require__(9);
	var toObject = __webpack_require__(14);
	var toIObject = __webpack_require__(30);
	var toPrimitive = __webpack_require__(46);
	var createDesc = __webpack_require__(61);
	var _create = __webpack_require__(58);
	var gOPNExt = __webpack_require__(212);
	var $GOPD = __webpack_require__(28);
	var $GOPS = __webpack_require__(96);
	var $DP = __webpack_require__(13);
	var $keys = __webpack_require__(60);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(59).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(77).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(52)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(22)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $typed = __webpack_require__(101);
	var buffer = __webpack_require__(146);
	var anObject = __webpack_require__(6);
	var toAbsoluteIndex = __webpack_require__(64);
	var toLength = __webpack_require__(11);
	var isObject = __webpack_require__(9);
	var ArrayBuffer = __webpack_require__(7).ArrayBuffer;
	var speciesConstructor = __webpack_require__(79);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(8)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(63)(ARRAY_BUFFER);


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	$export($export.G + $export.W + $export.F * !__webpack_require__(101).ABV, {
	  DataView: __webpack_require__(146).DataView
	});


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(200);
	var validate = __webpack_require__(66);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(90)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(3);
	var flattenIntoArray = __webpack_require__(201);
	var toObject = __webpack_require__(14);
	var toLength = __webpack_require__(11);
	var aFunction = __webpack_require__(19);
	var arraySpeciesCreate = __webpack_require__(125);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(51)('flatMap');


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(3);
	var flattenIntoArray = __webpack_require__(201);
	var toObject = __webpack_require__(14);
	var toLength = __webpack_require__(11);
	var toInteger = __webpack_require__(38);
	var arraySpeciesCreate = __webpack_require__(125);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(51)('flatten');


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(3);
	var $includes = __webpack_require__(89)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(51)('includes');


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(3);
	var microtask = __webpack_require__(137)();
	var process = __webpack_require__(7).process;
	var isNode = __webpack_require__(34)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(3);
	var cof = __webpack_require__(34);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(3);
	
	$export($export.G, { global: __webpack_require__(7) });


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(98)('Map');


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(99)('Map');


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(199)('Map') });


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	var scale = __webpack_require__(209);
	var fround = __webpack_require__(207);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { scale: __webpack_require__(209) });


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(14);
	var aFunction = __webpack_require__(19);
	var $defineProperty = __webpack_require__(13);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(12) && $export($export.P + __webpack_require__(95), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(14);
	var aFunction = __webpack_require__(19);
	var $defineProperty = __webpack_require__(13);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(12) && $export($export.P + __webpack_require__(95), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(3);
	var $entries = __webpack_require__(214)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(3);
	var ownKeys = __webpack_require__(215);
	var toIObject = __webpack_require__(30);
	var gOPD = __webpack_require__(28);
	var createProperty = __webpack_require__(126);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(14);
	var toPrimitive = __webpack_require__(46);
	var getPrototypeOf = __webpack_require__(29);
	var getOwnPropertyDescriptor = __webpack_require__(28).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(12) && $export($export.P + __webpack_require__(95), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(14);
	var toPrimitive = __webpack_require__(46);
	var getPrototypeOf = __webpack_require__(29);
	var getOwnPropertyDescriptor = __webpack_require__(28).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(12) && $export($export.P + __webpack_require__(95), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(3);
	var $values = __webpack_require__(214)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(3);
	var global = __webpack_require__(7);
	var core = __webpack_require__(35);
	var microtask = __webpack_require__(137)();
	var OBSERVABLE = __webpack_require__(10)('observable');
	var aFunction = __webpack_require__(19);
	var anObject = __webpack_require__(6);
	var anInstance = __webpack_require__(56);
	var redefineAll = __webpack_require__(62);
	var hide = __webpack_require__(22);
	var forOf = __webpack_require__(57);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(63)('Observable');


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(3);
	var core = __webpack_require__(35);
	var global = __webpack_require__(7);
	var speciesConstructor = __webpack_require__(79);
	var promiseResolve = __webpack_require__(219);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(3);
	var newPromiseCapability = __webpack_require__(138);
	var perform = __webpack_require__(218);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(48);
	var anObject = __webpack_require__(6);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(48);
	var anObject = __webpack_require__(6);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(227);
	var from = __webpack_require__(195);
	var metadata = __webpack_require__(48);
	var anObject = __webpack_require__(6);
	var getPrototypeOf = __webpack_require__(29);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(48);
	var anObject = __webpack_require__(6);
	var getPrototypeOf = __webpack_require__(29);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(48);
	var anObject = __webpack_require__(6);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(48);
	var anObject = __webpack_require__(6);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(48);
	var anObject = __webpack_require__(6);
	var getPrototypeOf = __webpack_require__(29);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(48);
	var anObject = __webpack_require__(6);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(48);
	var anObject = __webpack_require__(6);
	var aFunction = __webpack_require__(19);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(98)('Set');


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(99)('Set');


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(199)('Set') });


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(3);
	var $at = __webpack_require__(100)(true);
	var $fails = __webpack_require__(8);
	
	var FORCED = $fails(function () {
	  return '𠮷'.at(0) !== '𠮷';
	});
	
	$export($export.P + $export.F * FORCED, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(3);
	var defined = __webpack_require__(44);
	var toLength = __webpack_require__(11);
	var isRegExp = __webpack_require__(93);
	var getFlags = __webpack_require__(75);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(133)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3);
	var $pad = __webpack_require__(221);
	var userAgent = __webpack_require__(102);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3);
	var $pad = __webpack_require__(221);
	var userAgent = __webpack_require__(102);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(71)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(71)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(147)('asyncIterator');


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(147)('observable');


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(3);
	
	$export($export.S, 'System', { global: __webpack_require__(7) });


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(98)('WeakMap');


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(99)('WeakMap');


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(98)('WeakSet');


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(99)('WeakSet');


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(149);
	var getKeys = __webpack_require__(60);
	var redefine = __webpack_require__(23);
	var global = __webpack_require__(7);
	var hide = __webpack_require__(22);
	var Iterators = __webpack_require__(69);
	var wks = __webpack_require__(10);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $task = __webpack_require__(145);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(7);
	var $export = __webpack_require__(3);
	var userAgent = __webpack_require__(102);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(901);
	__webpack_require__(840);
	__webpack_require__(842);
	__webpack_require__(841);
	__webpack_require__(844);
	__webpack_require__(846);
	__webpack_require__(851);
	__webpack_require__(845);
	__webpack_require__(843);
	__webpack_require__(853);
	__webpack_require__(852);
	__webpack_require__(848);
	__webpack_require__(849);
	__webpack_require__(847);
	__webpack_require__(839);
	__webpack_require__(850);
	__webpack_require__(854);
	__webpack_require__(855);
	__webpack_require__(807);
	__webpack_require__(809);
	__webpack_require__(808);
	__webpack_require__(857);
	__webpack_require__(856);
	__webpack_require__(827);
	__webpack_require__(837);
	__webpack_require__(838);
	__webpack_require__(828);
	__webpack_require__(829);
	__webpack_require__(830);
	__webpack_require__(831);
	__webpack_require__(832);
	__webpack_require__(833);
	__webpack_require__(834);
	__webpack_require__(835);
	__webpack_require__(836);
	__webpack_require__(810);
	__webpack_require__(811);
	__webpack_require__(812);
	__webpack_require__(813);
	__webpack_require__(814);
	__webpack_require__(815);
	__webpack_require__(816);
	__webpack_require__(817);
	__webpack_require__(818);
	__webpack_require__(819);
	__webpack_require__(820);
	__webpack_require__(821);
	__webpack_require__(822);
	__webpack_require__(823);
	__webpack_require__(824);
	__webpack_require__(825);
	__webpack_require__(826);
	__webpack_require__(888);
	__webpack_require__(893);
	__webpack_require__(900);
	__webpack_require__(891);
	__webpack_require__(883);
	__webpack_require__(884);
	__webpack_require__(889);
	__webpack_require__(894);
	__webpack_require__(896);
	__webpack_require__(879);
	__webpack_require__(880);
	__webpack_require__(881);
	__webpack_require__(882);
	__webpack_require__(885);
	__webpack_require__(886);
	__webpack_require__(887);
	__webpack_require__(890);
	__webpack_require__(892);
	__webpack_require__(895);
	__webpack_require__(897);
	__webpack_require__(898);
	__webpack_require__(899);
	__webpack_require__(802);
	__webpack_require__(804);
	__webpack_require__(803);
	__webpack_require__(806);
	__webpack_require__(805);
	__webpack_require__(791);
	__webpack_require__(789);
	__webpack_require__(795);
	__webpack_require__(792);
	__webpack_require__(798);
	__webpack_require__(800);
	__webpack_require__(788);
	__webpack_require__(794);
	__webpack_require__(785);
	__webpack_require__(799);
	__webpack_require__(783);
	__webpack_require__(797);
	__webpack_require__(796);
	__webpack_require__(790);
	__webpack_require__(793);
	__webpack_require__(782);
	__webpack_require__(784);
	__webpack_require__(787);
	__webpack_require__(786);
	__webpack_require__(801);
	__webpack_require__(149);
	__webpack_require__(873);
	__webpack_require__(225);
	__webpack_require__(878);
	__webpack_require__(226);
	__webpack_require__(874);
	__webpack_require__(875);
	__webpack_require__(876);
	__webpack_require__(877);
	__webpack_require__(858);
	__webpack_require__(224);
	__webpack_require__(227);
	__webpack_require__(228);
	__webpack_require__(913);
	__webpack_require__(902);
	__webpack_require__(903);
	__webpack_require__(908);
	__webpack_require__(911);
	__webpack_require__(912);
	__webpack_require__(906);
	__webpack_require__(909);
	__webpack_require__(907);
	__webpack_require__(910);
	__webpack_require__(904);
	__webpack_require__(905);
	__webpack_require__(859);
	__webpack_require__(860);
	__webpack_require__(861);
	__webpack_require__(862);
	__webpack_require__(863);
	__webpack_require__(866);
	__webpack_require__(864);
	__webpack_require__(865);
	__webpack_require__(867);
	__webpack_require__(868);
	__webpack_require__(869);
	__webpack_require__(870);
	__webpack_require__(872);
	__webpack_require__(871);
	__webpack_require__(916);
	__webpack_require__(914);
	__webpack_require__(915);
	__webpack_require__(957);
	__webpack_require__(960);
	__webpack_require__(959);
	__webpack_require__(961);
	__webpack_require__(962);
	__webpack_require__(958);
	__webpack_require__(963);
	__webpack_require__(964);
	__webpack_require__(938);
	__webpack_require__(941);
	__webpack_require__(937);
	__webpack_require__(935);
	__webpack_require__(936);
	__webpack_require__(939);
	__webpack_require__(940);
	__webpack_require__(922);
	__webpack_require__(956);
	__webpack_require__(921);
	__webpack_require__(955);
	__webpack_require__(967);
	__webpack_require__(969);
	__webpack_require__(920);
	__webpack_require__(954);
	__webpack_require__(966);
	__webpack_require__(968);
	__webpack_require__(919);
	__webpack_require__(965);
	__webpack_require__(918);
	__webpack_require__(923);
	__webpack_require__(924);
	__webpack_require__(925);
	__webpack_require__(926);
	__webpack_require__(927);
	__webpack_require__(929);
	__webpack_require__(928);
	__webpack_require__(930);
	__webpack_require__(931);
	__webpack_require__(932);
	__webpack_require__(934);
	__webpack_require__(933);
	__webpack_require__(943);
	__webpack_require__(944);
	__webpack_require__(945);
	__webpack_require__(946);
	__webpack_require__(948);
	__webpack_require__(947);
	__webpack_require__(950);
	__webpack_require__(949);
	__webpack_require__(951);
	__webpack_require__(952);
	__webpack_require__(953);
	__webpack_require__(917);
	__webpack_require__(942);
	__webpack_require__(972);
	__webpack_require__(971);
	__webpack_require__(970);
	module.exports = __webpack_require__(35);


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	var currencySymbolMap = __webpack_require__(229)
	
	module.exports = function getSymbolFromCurrency (currencyCode) {
	  if (typeof currencyCode !== 'string') return undefined
	  var code = currencyCode.toUpperCase()
	  if (!currencySymbolMap.hasOwnProperty(code)) return undefined
	  return currencySymbolMap[code]
	}
	
	module.exports.currencySymbolMap = currencySymbolMap


/***/ }),
/* 975 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 976 */
975,
/* 977 */
975,
/* 978 */
975,
/* 979 */
975,
/* 980 */
975,
/* 981 */
975,
/* 982 */
975,
/* 983 */
975,
/* 984 */
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * interact.js v1.2.8
	 *
	 * Copyright (c) 2012-2015 Taye Adeyemi <dev@taye.me>
	 * Open source under the MIT License.
	 * https://raw.github.com/taye/interact.js/master/LICENSE
	 */
	(function (realWindow) {
	    'use strict';
	
	    // return early if there's no window to work with (eg. Node.js)
	    if (!realWindow) { return; }
	
	    var // get wrapped window if using Shadow DOM polyfill
	        window = (function () {
	            // create a TextNode
	            var el = realWindow.document.createTextNode('');
	
	            // check if it's wrapped by a polyfill
	            if (el.ownerDocument !== realWindow.document
	                && typeof realWindow.wrap === 'function'
	                && realWindow.wrap(el) === el) {
	                // return wrapped window
	                return realWindow.wrap(realWindow);
	            }
	
	            // no Shadow DOM polyfil or native implementation
	            return realWindow;
	        }()),
	
	        document           = window.document,
	        DocumentFragment   = window.DocumentFragment   || blank,
	        SVGElement         = window.SVGElement         || blank,
	        SVGSVGElement      = window.SVGSVGElement      || blank,
	        SVGElementInstance = window.SVGElementInstance || blank,
	        HTMLElement        = window.HTMLElement        || window.Element,
	
	        PointerEvent = (window.PointerEvent || window.MSPointerEvent),
	        pEventTypes,
	
	        hypot = Math.hypot || function (x, y) { return Math.sqrt(x * x + y * y); },
	
	        tmpXY = {},     // reduce object creation in getXY()
	
	        documents       = [],   // all documents being listened to
	
	        interactables   = [],   // all set interactables
	        interactions    = [],   // all interactions
	
	        dynamicDrop     = false,
	
	        // {
	        //      type: {
	        //          selectors: ['selector', ...],
	        //          contexts : [document, ...],
	        //          listeners: [[listener, useCapture], ...]
	        //      }
	        //  }
	        delegatedEvents = {},
	
	        defaultOptions = {
	            base: {
	                accept        : null,
	                actionChecker : null,
	                styleCursor   : true,
	                preventDefault: 'auto',
	                origin        : { x: 0, y: 0 },
	                deltaSource   : 'page',
	                allowFrom     : null,
	                ignoreFrom    : null,
	                _context      : document,
	                dropChecker   : null
	            },
	
	            drag: {
	                enabled: false,
	                manualStart: true,
	                max: Infinity,
	                maxPerElement: 1,
	
	                snap: null,
	                restrict: null,
	                inertia: null,
	                autoScroll: null,
	
	                axis: 'xy'
	            },
	
	            drop: {
	                enabled: false,
	                accept: null,
	                overlap: 'pointer'
	            },
	
	            resize: {
	                enabled: false,
	                manualStart: false,
	                max: Infinity,
	                maxPerElement: 1,
	
	                snap: null,
	                restrict: null,
	                inertia: null,
	                autoScroll: null,
	
	                square: false,
	                preserveAspectRatio: false,
	                axis: 'xy',
	
	                // use default margin
	                margin: NaN,
	
	                // object with props left, right, top, bottom which are
	                // true/false values to resize when the pointer is over that edge,
	                // CSS selectors to match the handles for each direction
	                // or the Elements for each handle
	                edges: null,
	
	                // a value of 'none' will limit the resize rect to a minimum of 0x0
	                // 'negate' will alow the rect to have negative width/height
	                // 'reposition' will keep the width/height positive by swapping
	                // the top and bottom edges and/or swapping the left and right edges
	                invert: 'none'
	            },
	
	            gesture: {
	                manualStart: false,
	                enabled: false,
	                max: Infinity,
	                maxPerElement: 1,
	
	                restrict: null
	            },
	
	            perAction: {
	                manualStart: false,
	                max: Infinity,
	                maxPerElement: 1,
	
	                snap: {
	                    enabled     : false,
	                    endOnly     : false,
	                    range       : Infinity,
	                    targets     : null,
	                    offsets     : null,
	
	                    relativePoints: null
	                },
	
	                restrict: {
	                    enabled: false,
	                    endOnly: false
	                },
	
	                autoScroll: {
	                    enabled     : false,
	                    container   : null,     // the item that is scrolled (Window or HTMLElement)
	                    margin      : 60,
	                    speed       : 300       // the scroll speed in pixels per second
	                },
	
	                inertia: {
	                    enabled          : false,
	                    resistance       : 10,    // the lambda in exponential decay
	                    minSpeed         : 100,   // target speed must be above this for inertia to start
	                    endSpeed         : 10,    // the speed at which inertia is slow enough to stop
	                    allowResume      : true,  // allow resuming an action in inertia phase
	                    zeroResumeDelta  : true,  // if an action is resumed after launch, set dx/dy to 0
	                    smoothEndDuration: 300    // animate to snap/restrict endOnly if there's no inertia
	                }
	            },
	
	            _holdDuration: 600
	        },
	
	        // Things related to autoScroll
	        autoScroll = {
	            interaction: null,
	            i: null,    // the handle returned by window.setInterval
	            x: 0, y: 0, // Direction each pulse is to scroll in
	
	            // scroll the window by the values in scroll.x/y
	            scroll: function () {
	                var options = autoScroll.interaction.target.options[autoScroll.interaction.prepared.name].autoScroll,
	                    container = options.container || getWindow(autoScroll.interaction.element),
	                    now = new Date().getTime(),
	                    // change in time in seconds
	                    dtx = (now - autoScroll.prevTimeX) / 1000,
	                    dty = (now - autoScroll.prevTimeY) / 1000,
	                    vx, vy, sx, sy;
	
	                // displacement
	                if (options.velocity) {
	                  vx = options.velocity.x;
	                  vy = options.velocity.y;
	                }
	                else {
	                  vx = vy = options.speed
	                }
	 
	                sx = vx * dtx;
	                sy = vy * dty;
	
	                if (sx >= 1 || sy >= 1) {
	                    if (isWindow(container)) {
	                        container.scrollBy(autoScroll.x * sx, autoScroll.y * sy);
	                    }
	                    else if (container) {
	                        container.scrollLeft += autoScroll.x * sx;
	                        container.scrollTop  += autoScroll.y * sy;
	                    }
	
	                    if (sx >=1) autoScroll.prevTimeX = now;
	                    if (sy >= 1) autoScroll.prevTimeY = now;
	                }
	
	                if (autoScroll.isScrolling) {
	                    cancelFrame(autoScroll.i);
	                    autoScroll.i = reqFrame(autoScroll.scroll);
	                }
	            },
	
	            isScrolling: false,
	            prevTimeX: 0,
	            prevTimeY: 0,
	
	            start: function (interaction) {
	                autoScroll.isScrolling = true;
	                cancelFrame(autoScroll.i);
	
	                autoScroll.interaction = interaction;
	                autoScroll.prevTimeX = new Date().getTime();
	                autoScroll.prevTimeY = new Date().getTime();
	                autoScroll.i = reqFrame(autoScroll.scroll);
	            },
	
	            stop: function () {
	                autoScroll.isScrolling = false;
	                cancelFrame(autoScroll.i);
	            }
	        },
	
	        // Does the browser support touch input?
	        supportsTouch = (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch),
	
	        // Does the browser support PointerEvents
	        // Avoid PointerEvent bugs introduced in Chrome 55
	        supportsPointerEvent = PointerEvent && !/Chrome/.test(navigator.userAgent),
	
	        // Less Precision with touch input
	        margin = supportsTouch || supportsPointerEvent? 20: 10,
	
	        pointerMoveTolerance = 1,
	
	        // for ignoring browser's simulated mouse events
	        prevTouchTime = 0,
	
	        // Allow this many interactions to happen simultaneously
	        maxInteractions = Infinity,
	
	        // Check if is IE9 or older
	        actionCursors = (document.all && !window.atob) ? {
	            drag    : 'move',
	            resizex : 'e-resize',
	            resizey : 's-resize',
	            resizexy: 'se-resize',
	
	            resizetop        : 'n-resize',
	            resizeleft       : 'w-resize',
	            resizebottom     : 's-resize',
	            resizeright      : 'e-resize',
	            resizetopleft    : 'se-resize',
	            resizebottomright: 'se-resize',
	            resizetopright   : 'ne-resize',
	            resizebottomleft : 'ne-resize',
	
	            gesture : ''
	        } : {
	            drag    : 'move',
	            resizex : 'ew-resize',
	            resizey : 'ns-resize',
	            resizexy: 'nwse-resize',
	
	            resizetop        : 'ns-resize',
	            resizeleft       : 'ew-resize',
	            resizebottom     : 'ns-resize',
	            resizeright      : 'ew-resize',
	            resizetopleft    : 'nwse-resize',
	            resizebottomright: 'nwse-resize',
	            resizetopright   : 'nesw-resize',
	            resizebottomleft : 'nesw-resize',
	
	            gesture : ''
	        },
	
	        actionIsEnabled = {
	            drag   : true,
	            resize : true,
	            gesture: true
	        },
	
	        // because Webkit and Opera still use 'mousewheel' event type
	        wheelEvent = 'onmousewheel' in document? 'mousewheel': 'wheel',
	
	        eventTypes = [
	            'dragstart',
	            'dragmove',
	            'draginertiastart',
	            'dragend',
	            'dragenter',
	            'dragleave',
	            'dropactivate',
	            'dropdeactivate',
	            'dropmove',
	            'drop',
	            'resizestart',
	            'resizemove',
	            'resizeinertiastart',
	            'resizeend',
	            'gesturestart',
	            'gesturemove',
	            'gestureinertiastart',
	            'gestureend',
	
	            'down',
	            'move',
	            'up',
	            'cancel',
	            'tap',
	            'doubletap',
	            'hold'
	        ],
	
	        globalEvents = {},
	
	        // Opera Mobile must be handled differently
	        isOperaMobile = navigator.appName == 'Opera' &&
	            supportsTouch &&
	            navigator.userAgent.match('Presto'),
	
	        // scrolling doesn't change the result of getClientRects on iOS 7
	        isIOS7 = (/iP(hone|od|ad)/.test(navigator.platform)
	                         && /OS 7[^\d]/.test(navigator.appVersion)),
	
	        // prefix matchesSelector
	        prefixedMatchesSelector = 'matches' in Element.prototype?
	                'matches': 'webkitMatchesSelector' in Element.prototype?
	                    'webkitMatchesSelector': 'mozMatchesSelector' in Element.prototype?
	                        'mozMatchesSelector': 'oMatchesSelector' in Element.prototype?
	                            'oMatchesSelector': 'msMatchesSelector',
	
	        // will be polyfill function if browser is IE8
	        ie8MatchesSelector,
	
	        // native requestAnimationFrame or polyfill
	        reqFrame = realWindow.requestAnimationFrame,
	        cancelFrame = realWindow.cancelAnimationFrame,
	
	        // Events wrapper
	        events = (function () {
	            var useAttachEvent = ('attachEvent' in window) && !('addEventListener' in window),
	                addEvent       = useAttachEvent?  'attachEvent': 'addEventListener',
	                removeEvent    = useAttachEvent?  'detachEvent': 'removeEventListener',
	                on             = useAttachEvent? 'on': '',
	
	                elements          = [],
	                targets           = [],
	                attachedListeners = [];
	
	            function add (element, type, listener, useCapture) {
	                var elementIndex = indexOf(elements, element),
	                    target = targets[elementIndex];
	
	                if (!target) {
	                    target = {
	                        events: {},
	                        typeCount: 0
	                    };
	
	                    elementIndex = elements.push(element) - 1;
	                    targets.push(target);
	
	                    attachedListeners.push((useAttachEvent ? {
	                            supplied: [],
	                            wrapped : [],
	                            useCount: []
	                        } : null));
	                }
	
	                if (!target.events[type]) {
	                    target.events[type] = [];
	                    target.typeCount++;
	                }
	
	                if (!contains(target.events[type], listener)) {
	                    var ret;
	
	                    if (useAttachEvent) {
	                        var listeners = attachedListeners[elementIndex],
	                            listenerIndex = indexOf(listeners.supplied, listener);
	
	                        var wrapped = listeners.wrapped[listenerIndex] || function (event) {
	                            if (!event.immediatePropagationStopped) {
	                                event.target = event.srcElement;
	                                event.currentTarget = element;
	
	                                event.preventDefault = event.preventDefault || preventDef;
	                                event.stopPropagation = event.stopPropagation || stopProp;
	                                event.stopImmediatePropagation = event.stopImmediatePropagation || stopImmProp;
	
	                                if (/mouse|click/.test(event.type)) {
	                                    event.pageX = event.clientX + getWindow(element).document.documentElement.scrollLeft;
	                                    event.pageY = event.clientY + getWindow(element).document.documentElement.scrollTop;
	                                }
	
	                                listener(event);
	                            }
	                        };
	
	                        ret = element[addEvent](on + type, wrapped, Boolean(useCapture));
	
	                        if (listenerIndex === -1) {
	                            listeners.supplied.push(listener);
	                            listeners.wrapped.push(wrapped);
	                            listeners.useCount.push(1);
	                        }
	                        else {
	                            listeners.useCount[listenerIndex]++;
	                        }
	                    }
	                    else {
	                        ret = element[addEvent](type, listener, useCapture || false);
	                    }
	                    target.events[type].push(listener);
	
	                    return ret;
	                }
	            }
	
	            function remove (element, type, listener, useCapture) {
	                var i,
	                    elementIndex = indexOf(elements, element),
	                    target = targets[elementIndex],
	                    listeners,
	                    listenerIndex,
	                    wrapped = listener;
	
	                if (!target || !target.events) {
	                    return;
	                }
	
	                if (useAttachEvent) {
	                    listeners = attachedListeners[elementIndex];
	                    listenerIndex = indexOf(listeners.supplied, listener);
	                    wrapped = listeners.wrapped[listenerIndex];
	                }
	
	                if (type === 'all') {
	                    for (type in target.events) {
	                        if (target.events.hasOwnProperty(type)) {
	                            remove(element, type, 'all');
	                        }
	                    }
	                    return;
	                }
	
	                if (target.events[type]) {
	                    var len = target.events[type].length;
	
	                    if (listener === 'all') {
	                        for (i = 0; i < len; i++) {
	                            remove(element, type, target.events[type][i], Boolean(useCapture));
	                        }
	                        return;
	                    } else {
	                        for (i = 0; i < len; i++) {
	                            if (target.events[type][i] === listener) {
	                                element[removeEvent](on + type, wrapped, useCapture || false);
	                                target.events[type].splice(i, 1);
	
	                                if (useAttachEvent && listeners) {
	                                    listeners.useCount[listenerIndex]--;
	                                    if (listeners.useCount[listenerIndex] === 0) {
	                                        listeners.supplied.splice(listenerIndex, 1);
	                                        listeners.wrapped.splice(listenerIndex, 1);
	                                        listeners.useCount.splice(listenerIndex, 1);
	                                    }
	                                }
	
	                                break;
	                            }
	                        }
	                    }
	
	                    if (target.events[type] && target.events[type].length === 0) {
	                        target.events[type] = null;
	                        target.typeCount--;
	                    }
	                }
	
	                if (!target.typeCount) {
	                    targets.splice(elementIndex, 1);
	                    elements.splice(elementIndex, 1);
	                    attachedListeners.splice(elementIndex, 1);
	                }
	            }
	
	            function preventDef () {
	                this.returnValue = false;
	            }
	
	            function stopProp () {
	                this.cancelBubble = true;
	            }
	
	            function stopImmProp () {
	                this.cancelBubble = true;
	                this.immediatePropagationStopped = true;
	            }
	
	            return {
	                add: add,
	                remove: remove,
	                useAttachEvent: useAttachEvent,
	
	                _elements: elements,
	                _targets: targets,
	                _attachedListeners: attachedListeners
	            };
	        }());
	
	    function blank () {}
	
	    function isElement (o) {
	        if (!o || (typeof o !== 'object')) { return false; }
	
	        var _window = getWindow(o) || window;
	
	        return (/object|function/.test(typeof _window.Element)
	            ? o instanceof _window.Element //DOM2
	            : o.nodeType === 1 && typeof o.nodeName === "string");
	    }
	    function isWindow (thing) { return thing === window || !!(thing && thing.Window) && (thing instanceof thing.Window); }
	    function isDocFrag (thing) { return !!thing && thing instanceof DocumentFragment; }
	    function isArray (thing) {
	        return isObject(thing)
	                && (typeof thing.length !== undefined)
	                && isFunction(thing.splice);
	    }
	    function isObject   (thing) { return !!thing && (typeof thing === 'object'); }
	    function isFunction (thing) { return typeof thing === 'function'; }
	    function isNumber   (thing) { return typeof thing === 'number'  ; }
	    function isBool     (thing) { return typeof thing === 'boolean' ; }
	    function isString   (thing) { return typeof thing === 'string'  ; }
	
	    function trySelector (value) {
	        if (!isString(value)) { return false; }
	
	        // an exception will be raised if it is invalid
	        document.querySelector(value);
	        return true;
	    }
	
	    function extend (dest, source) {
	        for (var prop in source) {
	            dest[prop] = source[prop];
	        }
	        return dest;
	    }
	
	    var prefixedPropREs = {
	      webkit: /(Movement[XY]|Radius[XY]|RotationAngle|Force)$/
	    };
	
	    function pointerExtend (dest, source) {
	        for (var prop in source) {
	          var deprecated = false;
	
	          // skip deprecated prefixed properties
	          for (var vendor in prefixedPropREs) {
	            if (prop.indexOf(vendor) === 0 && prefixedPropREs[vendor].test(prop)) {
	              deprecated = true;
	              break;
	            }
	          }
	
	          if (!deprecated) {
	            dest[prop] = source[prop];
	          }
	        }
	        return dest;
	    }
	
	    function copyCoords (dest, src) {
	        dest.page = dest.page || {};
	        dest.page.x = src.page.x;
	        dest.page.y = src.page.y;
	
	        dest.client = dest.client || {};
	        dest.client.x = src.client.x;
	        dest.client.y = src.client.y;
	
	        dest.timeStamp = src.timeStamp;
	    }
	
	    function setEventXY (targetObj, pointers, interaction) {
	        var pointer = (pointers.length > 1
	                       ? pointerAverage(pointers)
	                       : pointers[0]);
	
	        getPageXY(pointer, tmpXY, interaction);
	        targetObj.page.x = tmpXY.x;
	        targetObj.page.y = tmpXY.y;
	
	        getClientXY(pointer, tmpXY, interaction);
	        targetObj.client.x = tmpXY.x;
	        targetObj.client.y = tmpXY.y;
	
	        targetObj.timeStamp = new Date().getTime();
	    }
	
	    function setEventDeltas (targetObj, prev, cur) {
	        targetObj.page.x     = cur.page.x      - prev.page.x;
	        targetObj.page.y     = cur.page.y      - prev.page.y;
	        targetObj.client.x   = cur.client.x    - prev.client.x;
	        targetObj.client.y   = cur.client.y    - prev.client.y;
	        targetObj.timeStamp = new Date().getTime() - prev.timeStamp;
	
	        // set pointer velocity
	        var dt = Math.max(targetObj.timeStamp / 1000, 0.001);
	        targetObj.page.speed   = hypot(targetObj.page.x, targetObj.page.y) / dt;
	        targetObj.page.vx      = targetObj.page.x / dt;
	        targetObj.page.vy      = targetObj.page.y / dt;
	
	        targetObj.client.speed = hypot(targetObj.client.x, targetObj.page.y) / dt;
	        targetObj.client.vx    = targetObj.client.x / dt;
	        targetObj.client.vy    = targetObj.client.y / dt;
	    }
	
	    function isNativePointer (pointer) {
	        return (pointer instanceof window.Event
	            || (supportsTouch && window.Touch && pointer instanceof window.Touch));
	    }
	
	    // Get specified X/Y coords for mouse or event.touches[0]
	    function getXY (type, pointer, xy) {
	        xy = xy || {};
	        type = type || 'page';
	
	        xy.x = pointer[type + 'X'];
	        xy.y = pointer[type + 'Y'];
	
	        return xy;
	    }
	
	    function getPageXY (pointer, page) {
	        page = page || {};
	
	        // Opera Mobile handles the viewport and scrolling oddly
	        if (isOperaMobile && isNativePointer(pointer)) {
	            getXY('screen', pointer, page);
	
	            page.x += window.scrollX;
	            page.y += window.scrollY;
	        }
	        else {
	            getXY('page', pointer, page);
	        }
	
	        return page;
	    }
	
	    function getClientXY (pointer, client) {
	        client = client || {};
	
	        if (isOperaMobile && isNativePointer(pointer)) {
	            // Opera Mobile handles the viewport and scrolling oddly
	            getXY('screen', pointer, client);
	        }
	        else {
	          getXY('client', pointer, client);
	        }
	
	        return client;
	    }
	
	    function getScrollXY (win) {
	        win = win || window;
	        return {
	            x: win.scrollX || win.document.documentElement.scrollLeft,
	            y: win.scrollY || win.document.documentElement.scrollTop
	        };
	    }
	
	    function getPointerId (pointer) {
	        return isNumber(pointer.pointerId)? pointer.pointerId : pointer.identifier;
	    }
	
	    function getActualElement (element) {
	        return (element instanceof SVGElementInstance
	            ? element.correspondingUseElement
	            : element);
	    }
	
	    function getWindow (node) {
	        if (isWindow(node)) {
	            return node;
	        }
	
	        var rootNode = (node.ownerDocument || node);
	
	        return rootNode.defaultView || rootNode.parentWindow || window;
	    }
	
	    function getElementClientRect (element) {
	        var clientRect = (element instanceof SVGElement
	                            ? element.getBoundingClientRect()
	                            : element.getClientRects()[0]);
	
	        return clientRect && {
	            left  : clientRect.left,
	            right : clientRect.right,
	            top   : clientRect.top,
	            bottom: clientRect.bottom,
	            width : clientRect.width || clientRect.right - clientRect.left,
	            height: clientRect.height || clientRect.bottom - clientRect.top
	        };
	    }
	
	    function getElementRect (element) {
	        var clientRect = getElementClientRect(element);
	
	        if (!isIOS7 && clientRect) {
	            var scroll = getScrollXY(getWindow(element));
	
	            clientRect.left   += scroll.x;
	            clientRect.right  += scroll.x;
	            clientRect.top    += scroll.y;
	            clientRect.bottom += scroll.y;
	        }
	
	        return clientRect;
	    }
	
	    function getTouchPair (event) {
	        var touches = [];
	
	        // array of touches is supplied
	        if (isArray(event)) {
	            touches[0] = event[0];
	            touches[1] = event[1];
	        }
	        // an event
	        else {
	            if (event.type === 'touchend') {
	                if (event.touches.length === 1) {
	                    touches[0] = event.touches[0];
	                    touches[1] = event.changedTouches[0];
	                }
	                else if (event.touches.length === 0) {
	                    touches[0] = event.changedTouches[0];
	                    touches[1] = event.changedTouches[1];
	                }
	            }
	            else {
	                touches[0] = event.touches[0];
	                touches[1] = event.touches[1];
	            }
	        }
	
	        return touches;
	    }
	
	    function pointerAverage (pointers) {
	        var average = {
	            pageX  : 0,
	            pageY  : 0,
	            clientX: 0,
	            clientY: 0,
	            screenX: 0,
	            screenY: 0
	        };
	        var prop;
	
	        for (var i = 0; i < pointers.length; i++) {
	            for (prop in average) {
	                average[prop] += pointers[i][prop];
	            }
	        }
	        for (prop in average) {
	            average[prop] /= pointers.length;
	        }
	
	        return average;
	    }
	
	    function touchBBox (event) {
	        if (!event.length && !(event.touches && event.touches.length > 1)) {
	            return;
	        }
	
	        var touches = getTouchPair(event),
	            minX = Math.min(touches[0].pageX, touches[1].pageX),
	            minY = Math.min(touches[0].pageY, touches[1].pageY),
	            maxX = Math.max(touches[0].pageX, touches[1].pageX),
	            maxY = Math.max(touches[0].pageY, touches[1].pageY);
	
	        return {
	            x: minX,
	            y: minY,
	            left: minX,
	            top: minY,
	            width: maxX - minX,
	            height: maxY - minY
	        };
	    }
	
	    function touchDistance (event, deltaSource) {
	        deltaSource = deltaSource || defaultOptions.deltaSource;
	
	        var sourceX = deltaSource + 'X',
	            sourceY = deltaSource + 'Y',
	            touches = getTouchPair(event);
	
	
	        var dx = touches[0][sourceX] - touches[1][sourceX],
	            dy = touches[0][sourceY] - touches[1][sourceY];
	
	        return hypot(dx, dy);
	    }
	
	    function touchAngle (event, prevAngle, deltaSource) {
	        deltaSource = deltaSource || defaultOptions.deltaSource;
	
	        var sourceX = deltaSource + 'X',
	            sourceY = deltaSource + 'Y',
	            touches = getTouchPair(event),
	            dx = touches[0][sourceX] - touches[1][sourceX],
	            dy = touches[0][sourceY] - touches[1][sourceY],
	            angle = 180 * Math.atan(dy / dx) / Math.PI;
	
	        if (isNumber(prevAngle)) {
	            var dr = angle - prevAngle,
	                drClamped = dr % 360;
	
	            if (drClamped > 315) {
	                angle -= 360 + (angle / 360)|0 * 360;
	            }
	            else if (drClamped > 135) {
	                angle -= 180 + (angle / 360)|0 * 360;
	            }
	            else if (drClamped < -315) {
	                angle += 360 + (angle / 360)|0 * 360;
	            }
	            else if (drClamped < -135) {
	                angle += 180 + (angle / 360)|0 * 360;
	            }
	        }
	
	        return  angle;
	    }
	
	    function getOriginXY (interactable, element) {
	        var origin = interactable
	                ? interactable.options.origin
	                : defaultOptions.origin;
	
	        if (origin === 'parent') {
	            origin = parentElement(element);
	        }
	        else if (origin === 'self') {
	            origin = interactable.getRect(element);
	        }
	        else if (trySelector(origin)) {
	            origin = closest(element, origin) || { x: 0, y: 0 };
	        }
	
	        if (isFunction(origin)) {
	            origin = origin(interactable && element);
	        }
	
	        if (isElement(origin))  {
	            origin = getElementRect(origin);
	        }
	
	        origin.x = ('x' in origin)? origin.x : origin.left;
	        origin.y = ('y' in origin)? origin.y : origin.top;
	
	        return origin;
	    }
	
	    // http://stackoverflow.com/a/5634528/2280888
	    function _getQBezierValue(t, p1, p2, p3) {
	        var iT = 1 - t;
	        return iT * iT * p1 + 2 * iT * t * p2 + t * t * p3;
	    }
	
	    function getQuadraticCurvePoint(startX, startY, cpX, cpY, endX, endY, position) {
	        return {
	            x:  _getQBezierValue(position, startX, cpX, endX),
	            y:  _getQBezierValue(position, startY, cpY, endY)
	        };
	    }
	
	    // http://gizma.com/easing/
	    function easeOutQuad (t, b, c, d) {
	        t /= d;
	        return -c * t*(t-2) + b;
	    }
	
	    function nodeContains (parent, child) {
	        while (child) {
	            if (child === parent) {
	                return true;
	            }
	
	            child = child.parentNode;
	        }
	
	        return false;
	    }
	
	    function closest (child, selector) {
	        var parent = parentElement(child);
	
	        while (isElement(parent)) {
	            if (matchesSelector(parent, selector)) { return parent; }
	
	            parent = parentElement(parent);
	        }
	
	        return null;
	    }
	
	    function parentElement (node) {
	        var parent = node.parentNode;
	
	        if (isDocFrag(parent)) {
	            // skip past #shado-root fragments
	            while ((parent = parent.host) && isDocFrag(parent)) {}
	
	            return parent;
	        }
	
	        return parent;
	    }
	
	    function inContext (interactable, element) {
	        return interactable._context === element.ownerDocument
	                || nodeContains(interactable._context, element);
	    }
	
	    function testIgnore (interactable, interactableElement, element) {
	        var ignoreFrom = interactable.options.ignoreFrom;
	
	        if (!ignoreFrom || !isElement(element)) { return false; }
	
	        if (isString(ignoreFrom)) {
	            return matchesUpTo(element, ignoreFrom, interactableElement);
	        }
	        else if (isElement(ignoreFrom)) {
	            return nodeContains(ignoreFrom, element);
	        }
	
	        return false;
	    }
	
	    function testAllow (interactable, interactableElement, element) {
	        var allowFrom = interactable.options.allowFrom;
	
	        if (!allowFrom) { return true; }
	
	        if (!isElement(element)) { return false; }
	
	        if (isString(allowFrom)) {
	            return matchesUpTo(element, allowFrom, interactableElement);
	        }
	        else if (isElement(allowFrom)) {
	            return nodeContains(allowFrom, element);
	        }
	
	        return false;
	    }
	
	    function checkAxis (axis, interactable) {
	        if (!interactable) { return false; }
	
	        var thisAxis = interactable.options.drag.axis;
	
	        return (axis === 'xy' || thisAxis === 'xy' || thisAxis === axis);
	    }
	
	    function checkSnap (interactable, action) {
	        var options = interactable.options;
	
	        if (/^resize/.test(action)) {
	            action = 'resize';
	        }
	
	        return options[action].snap && options[action].snap.enabled;
	    }
	
	    function checkRestrict (interactable, action) {
	        var options = interactable.options;
	
	        if (/^resize/.test(action)) {
	            action = 'resize';
	        }
	
	        return  options[action].restrict && options[action].restrict.enabled;
	    }
	
	    function checkAutoScroll (interactable, action) {
	        var options = interactable.options;
	
	        if (/^resize/.test(action)) {
	            action = 'resize';
	        }
	
	        return  options[action].autoScroll && options[action].autoScroll.enabled;
	    }
	
	    function withinInteractionLimit (interactable, element, action) {
	        var options = interactable.options,
	            maxActions = options[action.name].max,
	            maxPerElement = options[action.name].maxPerElement,
	            activeInteractions = 0,
	            targetCount = 0,
	            targetElementCount = 0;
	
	        for (var i = 0, len = interactions.length; i < len; i++) {
	            var interaction = interactions[i],
	                otherAction = interaction.prepared.name,
	                active = interaction.interacting();
	
	            if (!active) { continue; }
	
	            activeInteractions++;
	
	            if (activeInteractions >= maxInteractions) {
	                return false;
	            }
	
	            if (interaction.target !== interactable) { continue; }
	
	            targetCount += (otherAction === action.name)|0;
	
	            if (targetCount >= maxActions) {
	                return false;
	            }
	
	            if (interaction.element === element) {
	                targetElementCount++;
	
	                if (otherAction !== action.name || targetElementCount >= maxPerElement) {
	                    return false;
	                }
	            }
	        }
	
	        return maxInteractions > 0;
	    }
	
	    // Test for the element that's "above" all other qualifiers
	    function indexOfDeepestElement (elements) {
	        var dropzone,
	            deepestZone = elements[0],
	            index = deepestZone? 0: -1,
	            parent,
	            deepestZoneParents = [],
	            dropzoneParents = [],
	            child,
	            i,
	            n;
	
	        for (i = 1; i < elements.length; i++) {
	            dropzone = elements[i];
	
	            // an element might belong to multiple selector dropzones
	            if (!dropzone || dropzone === deepestZone) {
	                continue;
	            }
	
	            if (!deepestZone) {
	                deepestZone = dropzone;
	                index = i;
	                continue;
	            }
	
	            // check if the deepest or current are document.documentElement or document.rootElement
	            // - if the current dropzone is, do nothing and continue
	            if (dropzone.parentNode === dropzone.ownerDocument) {
	                continue;
	            }
	            // - if deepest is, update with the current dropzone and continue to next
	            else if (deepestZone.parentNode === dropzone.ownerDocument) {
	                deepestZone = dropzone;
	                index = i;
	                continue;
	            }
	
	            if (!deepestZoneParents.length) {
	                parent = deepestZone;
	                while (parent.parentNode && parent.parentNode !== parent.ownerDocument) {
	                    deepestZoneParents.unshift(parent);
	                    parent = parent.parentNode;
	                }
	            }
	
	            // if this element is an svg element and the current deepest is
	            // an HTMLElement
	            if (deepestZone instanceof HTMLElement
	                && dropzone instanceof SVGElement
	                && !(dropzone instanceof SVGSVGElement)) {
	
	                if (dropzone === deepestZone.parentNode) {
	                    continue;
	                }
	
	                parent = dropzone.ownerSVGElement;
	            }
	            else {
	                parent = dropzone;
	            }
	
	            dropzoneParents = [];
	
	            while (parent.parentNode !== parent.ownerDocument) {
	                dropzoneParents.unshift(parent);
	                parent = parent.parentNode;
	            }
	
	            n = 0;
	
	            // get (position of last common ancestor) + 1
	            while (dropzoneParents[n] && dropzoneParents[n] === deepestZoneParents[n]) {
	                n++;
	            }
	
	            var parents = [
	                dropzoneParents[n - 1],
	                dropzoneParents[n],
	                deepestZoneParents[n]
	            ];
	
	            child = parents[0].lastChild;
	
	            while (child) {
	                if (child === parents[1]) {
	                    deepestZone = dropzone;
	                    index = i;
	                    deepestZoneParents = [];
	
	                    break;
	                }
	                else if (child === parents[2]) {
	                    break;
	                }
	
	                child = child.previousSibling;
	            }
	        }
	
	        return index;
	    }
	
	    function Interaction () {
	        this.target          = null; // current interactable being interacted with
	        this.element         = null; // the target element of the interactable
	        this.dropTarget      = null; // the dropzone a drag target might be dropped into
	        this.dropElement     = null; // the element at the time of checking
	        this.prevDropTarget  = null; // the dropzone that was recently dragged away from
	        this.prevDropElement = null; // the element at the time of checking
	
	        this.prepared        = {     // action that's ready to be fired on next move event
	            name : null,
	            axis : null,
	            edges: null
	        };
	
	        this.matches         = [];   // all selectors that are matched by target element
	        this.matchElements   = [];   // corresponding elements
	
	        this.inertiaStatus = {
	            active       : false,
	            smoothEnd    : false,
	            ending       : false,
	
	            startEvent: null,
	            upCoords: {},
	
	            xe: 0, ye: 0,
	            sx: 0, sy: 0,
	
	            t0: 0,
	            vx0: 0, vys: 0,
	            duration: 0,
	
	            resumeDx: 0,
	            resumeDy: 0,
	
	            lambda_v0: 0,
	            one_ve_v0: 0,
	            i  : null
	        };
	
	        if (isFunction(Function.prototype.bind)) {
	            this.boundInertiaFrame = this.inertiaFrame.bind(this);
	            this.boundSmoothEndFrame = this.smoothEndFrame.bind(this);
	        }
	        else {
	            var that = this;
	
	            this.boundInertiaFrame = function () { return that.inertiaFrame(); };
	            this.boundSmoothEndFrame = function () { return that.smoothEndFrame(); };
	        }
	
	        this.activeDrops = {
	            dropzones: [],      // the dropzones that are mentioned below
	            elements : [],      // elements of dropzones that accept the target draggable
	            rects    : []       // the rects of the elements mentioned above
	        };
	
	        // keep track of added pointers
	        this.pointers    = [];
	        this.pointerIds  = [];
	        this.downTargets = [];
	        this.downTimes   = [];
	        this.holdTimers  = [];
	
	        // Previous native pointer move event coordinates
	        this.prevCoords = {
	            page     : { x: 0, y: 0 },
	            client   : { x: 0, y: 0 },
	            timeStamp: 0
	        };
	        // current native pointer move event coordinates
	        this.curCoords = {
	            page     : { x: 0, y: 0 },
	            client   : { x: 0, y: 0 },
	            timeStamp: 0
	        };
	
	        // Starting InteractEvent pointer coordinates
	        this.startCoords = {
	            page     : { x: 0, y: 0 },
	            client   : { x: 0, y: 0 },
	            timeStamp: 0
	        };
	
	        // Change in coordinates and time of the pointer
	        this.pointerDelta = {
	            page     : { x: 0, y: 0, vx: 0, vy: 0, speed: 0 },
	            client   : { x: 0, y: 0, vx: 0, vy: 0, speed: 0 },
	            timeStamp: 0
	        };
	
	        this.downEvent   = null;    // pointerdown/mousedown/touchstart event
	        this.downPointer = {};
	
	        this._eventTarget    = null;
	        this._curEventTarget = null;
	
	        this.prevEvent = null;      // previous action event
	        this.tapTime   = 0;         // time of the most recent tap event
	        this.prevTap   = null;
	
	        this.startOffset    = { left: 0, right: 0, top: 0, bottom: 0 };
	        this.restrictOffset = { left: 0, right: 0, top: 0, bottom: 0 };
	        this.snapOffsets    = [];
	
	        this.gesture = {
	            start: { x: 0, y: 0 },
	
	            startDistance: 0,   // distance between two touches of touchStart
	            prevDistance : 0,
	            distance     : 0,
	
	            scale: 1,           // gesture.distance / gesture.startDistance
	
	            startAngle: 0,      // angle of line joining two touches
	            prevAngle : 0       // angle of the previous gesture event
	        };
	
	        this.snapStatus = {
	            x       : 0, y       : 0,
	            dx      : 0, dy      : 0,
	            realX   : 0, realY   : 0,
	            snappedX: 0, snappedY: 0,
	            targets : [],
	            locked  : false,
	            changed : false
	        };
	
	        this.restrictStatus = {
	            dx         : 0, dy         : 0,
	            restrictedX: 0, restrictedY: 0,
	            snap       : null,
	            restricted : false,
	            changed    : false
	        };
	
	        this.restrictStatus.snap = this.snapStatus;
	
	        this.pointerIsDown   = false;
	        this.pointerWasMoved = false;
	        this.gesturing       = false;
	        this.dragging        = false;
	        this.resizing        = false;
	        this.resizeAxes      = 'xy';
	
	        this.mouse = false;
	
	        interactions.push(this);
	    }
	
	    Interaction.prototype = {
	        getPageXY  : function (pointer, xy) { return   getPageXY(pointer, xy, this); },
	        getClientXY: function (pointer, xy) { return getClientXY(pointer, xy, this); },
	        setEventXY : function (target, ptr) { return  setEventXY(target, ptr, this); },
	
	        pointerOver: function (pointer, event, eventTarget) {
	            if (this.prepared.name || !this.mouse) { return; }
	
	            var curMatches = [],
	                curMatchElements = [],
	                prevTargetElement = this.element;
	
	            this.addPointer(pointer);
	
	            if (this.target
	                && (testIgnore(this.target, this.element, eventTarget)
	                    || !testAllow(this.target, this.element, eventTarget))) {
	                // if the eventTarget should be ignored or shouldn't be allowed
	                // clear the previous target
	                this.target = null;
	                this.element = null;
	                this.matches = [];
	                this.matchElements = [];
	            }
	
	            var elementInteractable = interactables.get(eventTarget),
	                elementAction = (elementInteractable
	                                 && !testIgnore(elementInteractable, eventTarget, eventTarget)
	                                 && testAllow(elementInteractable, eventTarget, eventTarget)
	                                 && validateAction(
	                                     elementInteractable.getAction(pointer, event, this, eventTarget),
	                                     elementInteractable));
	
	            if (elementAction && !withinInteractionLimit(elementInteractable, eventTarget, elementAction)) {
	                 elementAction = null;
	            }
	
	            function pushCurMatches (interactable, selector) {
	                if (interactable
	                    && inContext(interactable, eventTarget)
	                    && !testIgnore(interactable, eventTarget, eventTarget)
	                    && testAllow(interactable, eventTarget, eventTarget)
	                    && matchesSelector(eventTarget, selector)) {
	
	                    curMatches.push(interactable);
	                    curMatchElements.push(eventTarget);
	                }
	            }
	
	            if (elementAction) {
	                this.target = elementInteractable;
	                this.element = eventTarget;
	                this.matches = [];
	                this.matchElements = [];
	            }
	            else {
	                interactables.forEachSelector(pushCurMatches);
	
	                if (this.validateSelector(pointer, event, curMatches, curMatchElements)) {
	                    this.matches = curMatches;
	                    this.matchElements = curMatchElements;
	
	                    this.pointerHover(pointer, event, this.matches, this.matchElements);
	                    events.add(eventTarget,
	                                        supportsPointerEvent? pEventTypes.move : 'mousemove',
	                                        listeners.pointerHover);
	                }
	                else if (this.target) {
	                    if (nodeContains(prevTargetElement, eventTarget)) {
	                        this.pointerHover(pointer, event, this.matches, this.matchElements);
	                        events.add(this.element,
	                                            supportsPointerEvent? pEventTypes.move : 'mousemove',
	                                            listeners.pointerHover);
	                    }
	                    else {
	                        this.target = null;
	                        this.element = null;
	                        this.matches = [];
	                        this.matchElements = [];
	                    }
	                }
	            }
	        },
	
	        // Check what action would be performed on pointerMove target if a mouse
	        // button were pressed and change the cursor accordingly
	        pointerHover: function (pointer, event, eventTarget, curEventTarget, matches, matchElements) {
	            var target = this.target;
	
	            if (!this.prepared.name && this.mouse) {
	
	                var action;
	
	                // update pointer coords for defaultActionChecker to use
	                this.setEventXY(this.curCoords, [pointer]);
	
	                if (matches) {
	                    action = this.validateSelector(pointer, event, matches, matchElements);
	                }
	                else if (target) {
	                    action = validateAction(target.getAction(this.pointers[0], event, this, this.element), this.target);
	                }
	
	                if (target && target.options.styleCursor) {
	                    if (action) {
	                        target._doc.documentElement.style.cursor = getActionCursor(action);
	                    }
	                    else {
	                        target._doc.documentElement.style.cursor = '';
	                    }
	                }
	            }
	            else if (this.prepared.name) {
	                this.checkAndPreventDefault(event, target, this.element);
	            }
	        },
	
	        pointerOut: function (pointer, event, eventTarget) {
	            if (this.prepared.name) { return; }
	
	            // Remove temporary event listeners for selector Interactables
	            if (!interactables.get(eventTarget)) {
	                events.remove(eventTarget,
	                                       supportsPointerEvent? pEventTypes.move : 'mousemove',
	                                       listeners.pointerHover);
	            }
	
	            if (this.target && this.target.options.styleCursor && !this.interacting()) {
	                this.target._doc.documentElement.style.cursor = '';
	            }
	        },
	
	        selectorDown: function (pointer, event, eventTarget, curEventTarget) {
	            var that = this,
	                // copy event to be used in timeout for IE8
	                eventCopy = events.useAttachEvent? extend({}, event) : event,
	                element = eventTarget,
	                pointerIndex = this.addPointer(pointer),
	                action;
	
	            this.holdTimers[pointerIndex] = setTimeout(function () {
	                that.pointerHold(events.useAttachEvent? eventCopy : pointer, eventCopy, eventTarget, curEventTarget);
	            }, defaultOptions._holdDuration);
	
	            this.pointerIsDown = true;
	
	            // Check if the down event hits the current inertia target
	            if (this.inertiaStatus.active && this.target.selector) {
	                // climb up the DOM tree from the event target
	                while (isElement(element)) {
	
	                    // if this element is the current inertia target element
	                    if (element === this.element
	                        // and the prospective action is the same as the ongoing one
	                        && validateAction(this.target.getAction(pointer, event, this, this.element), this.target).name === this.prepared.name) {
	
	                        // stop inertia so that the next move will be a normal one
	                        cancelFrame(this.inertiaStatus.i);
	                        this.inertiaStatus.active = false;
	
	                        this.collectEventTargets(pointer, event, eventTarget, 'down');
	                        return;
	                    }
	                    element = parentElement(element);
	                }
	            }
	
	            // do nothing if interacting
	            if (this.interacting()) {
	                this.collectEventTargets(pointer, event, eventTarget, 'down');
	                return;
	            }
	
	            function pushMatches (interactable, selector, context) {
	                var elements = ie8MatchesSelector
	                    ? context.querySelectorAll(selector)
	                    : undefined;
	
	                if (inContext(interactable, element)
	                    && !testIgnore(interactable, element, eventTarget)
	                    && testAllow(interactable, element, eventTarget)
	                    && matchesSelector(element, selector, elements)) {
	
	                    that.matches.push(interactable);
	                    that.matchElements.push(element);
	                }
	            }
	
	            // update pointer coords for defaultActionChecker to use
	            this.setEventXY(this.curCoords, [pointer]);
	            this.downEvent = event;
	
	            while (isElement(element) && !action) {
	                this.matches = [];
	                this.matchElements = [];
	
	                interactables.forEachSelector(pushMatches);
	
	                action = this.validateSelector(pointer, event, this.matches, this.matchElements);
	                element = parentElement(element);
	            }
	
	            if (action) {
	                this.prepared.name  = action.name;
	                this.prepared.axis  = action.axis;
	                this.prepared.edges = action.edges;
	
	                this.collectEventTargets(pointer, event, eventTarget, 'down');
	
	                return this.pointerDown(pointer, event, eventTarget, curEventTarget, action);
	            }
	            else {
	                // do these now since pointerDown isn't being called from here
	                this.downTimes[pointerIndex] = new Date().getTime();
	                this.downTargets[pointerIndex] = eventTarget;
	                pointerExtend(this.downPointer, pointer);
	
	                copyCoords(this.prevCoords, this.curCoords);
	                this.pointerWasMoved = false;
	            }
	
	            this.collectEventTargets(pointer, event, eventTarget, 'down');
	        },
	
	        // Determine action to be performed on next pointerMove and add appropriate
	        // style and event Listeners
	        pointerDown: function (pointer, event, eventTarget, curEventTarget, forceAction) {
	            if (!forceAction && !this.inertiaStatus.active && this.pointerWasMoved && this.prepared.name) {
	                this.checkAndPreventDefault(event, this.target, this.element);
	
	                return;
	            }
	
	            this.pointerIsDown = true;
	            this.downEvent = event;
	
	            var pointerIndex = this.addPointer(pointer),
	                action;
	
	            // If it is the second touch of a multi-touch gesture, keep the
	            // target the same and get a new action if a target was set by the
	            // first touch
	            if (this.pointerIds.length > 1 && this.target._element === this.element) {
	                var newAction = validateAction(forceAction || this.target.getAction(pointer, event, this, this.element), this.target);
	
	                if (withinInteractionLimit(this.target, this.element, newAction)) {
	                    action = newAction;
	                }
	
	                this.prepared.name = null;
	            }
	            // Otherwise, set the target if there is no action prepared
	            else if (!this.prepared.name) {
	                var interactable = interactables.get(curEventTarget);
	
	                if (interactable
	                    && !testIgnore(interactable, curEventTarget, eventTarget)
	                    && testAllow(interactable, curEventTarget, eventTarget)
	                    && (action = validateAction(forceAction || interactable.getAction(pointer, event, this, curEventTarget), interactable, eventTarget))
	                    && withinInteractionLimit(interactable, curEventTarget, action)) {
	                    this.target = interactable;
	                    this.element = curEventTarget;
	                }
	            }
	
	            var target = this.target,
	                options = target && target.options;
	
	            if (target && (forceAction || !this.prepared.name)) {
	                action = action || validateAction(forceAction || target.getAction(pointer, event, this, curEventTarget), target, this.element);
	
	                this.setEventXY(this.startCoords, this.pointers);
	
	                if (!action) { return; }
	
	                if (options.styleCursor) {
	                    target._doc.documentElement.style.cursor = getActionCursor(action);
	                }
	
	                this.resizeAxes = action.name === 'resize'? action.axis : null;
	
	                if (action === 'gesture' && this.pointerIds.length < 2) {
	                    action = null;
	                }
	
	                this.prepared.name  = action.name;
	                this.prepared.axis  = action.axis;
	                this.prepared.edges = action.edges;
	
	                this.snapStatus.snappedX = this.snapStatus.snappedY =
	                    this.restrictStatus.restrictedX = this.restrictStatus.restrictedY = NaN;
	
	                this.downTimes[pointerIndex] = new Date().getTime();
	                this.downTargets[pointerIndex] = eventTarget;
	                pointerExtend(this.downPointer, pointer);
	
	                copyCoords(this.prevCoords, this.startCoords);
	                this.pointerWasMoved = false;
	
	                this.checkAndPreventDefault(event, target, this.element);
	            }
	            // if inertia is active try to resume action
	            else if (this.inertiaStatus.active
	                && curEventTarget === this.element
	                && validateAction(target.getAction(pointer, event, this, this.element), target).name === this.prepared.name) {
	
	                cancelFrame(this.inertiaStatus.i);
	                this.inertiaStatus.active = false;
	
	                this.checkAndPreventDefault(event, target, this.element);
	            }
	        },
	
	        setModifications: function (coords, preEnd) {
	            var target         = this.target,
	                shouldMove     = true,
	                shouldSnap     = checkSnap(target, this.prepared.name)     && (!target.options[this.prepared.name].snap.endOnly     || preEnd),
	                shouldRestrict = checkRestrict(target, this.prepared.name) && (!target.options[this.prepared.name].restrict.endOnly || preEnd);
	
	            if (shouldSnap    ) { this.setSnapping   (coords); } else { this.snapStatus    .locked     = false; }
	            if (shouldRestrict) { this.setRestriction(coords); } else { this.restrictStatus.restricted = false; }
	
	            if (shouldSnap && this.snapStatus.locked && !this.snapStatus.changed) {
	                shouldMove = shouldRestrict && this.restrictStatus.restricted && this.restrictStatus.changed;
	            }
	            else if (shouldRestrict && this.restrictStatus.restricted && !this.restrictStatus.changed) {
	                shouldMove = false;
	            }
	
	            return shouldMove;
	        },
	
	        setStartOffsets: function (action, interactable, element) {
	            var rect = interactable.getRect(element),
	                origin = getOriginXY(interactable, element),
	                snap = interactable.options[this.prepared.name].snap,
	                restrict = interactable.options[this.prepared.name].restrict,
	                width, height;
	
	            if (rect) {
	                this.startOffset.left = this.startCoords.page.x - rect.left;
	                this.startOffset.top  = this.startCoords.page.y - rect.top;
	
	                this.startOffset.right  = rect.right  - this.startCoords.page.x;
	                this.startOffset.bottom = rect.bottom - this.startCoords.page.y;
	
	                if ('width' in rect) { width = rect.width; }
	                else { width = rect.right - rect.left; }
	                if ('height' in rect) { height = rect.height; }
	                else { height = rect.bottom - rect.top; }
	            }
	            else {
	                this.startOffset.left = this.startOffset.top = this.startOffset.right = this.startOffset.bottom = 0;
	            }
	
	            this.snapOffsets.splice(0);
	
	            var snapOffset = snap && snap.offset === 'startCoords'
	                                ? {
	                                    x: this.startCoords.page.x - origin.x,
	                                    y: this.startCoords.page.y - origin.y
	                                }
	                                : snap && snap.offset || { x: 0, y: 0 };
	
	            if (rect && snap && snap.relativePoints && snap.relativePoints.length) {
	                for (var i = 0; i < snap.relativePoints.length; i++) {
	                    this.snapOffsets.push({
	                        x: this.startOffset.left - (width  * snap.relativePoints[i].x) + snapOffset.x,
	                        y: this.startOffset.top  - (height * snap.relativePoints[i].y) + snapOffset.y
	                    });
	                }
	            }
	            else {
	                this.snapOffsets.push(snapOffset);
	            }
	
	            if (rect && restrict.elementRect) {
	                this.restrictOffset.left = this.startOffset.left - (width  * restrict.elementRect.left);
	                this.restrictOffset.top  = this.startOffset.top  - (height * restrict.elementRect.top);
	
	                this.restrictOffset.right  = this.startOffset.right  - (width  * (1 - restrict.elementRect.right));
	                this.restrictOffset.bottom = this.startOffset.bottom - (height * (1 - restrict.elementRect.bottom));
	            }
	            else {
	                this.restrictOffset.left = this.restrictOffset.top = this.restrictOffset.right = this.restrictOffset.bottom = 0;
	            }
	        },
	
	        /*\
	         * Interaction.start
	         [ method ]
	         *
	         * Start an action with the given Interactable and Element as tartgets. The
	         * action must be enabled for the target Interactable and an appropriate number
	         * of pointers must be held down – 1 for drag/resize, 2 for gesture.
	         *
	         * Use it with `interactable.<action>able({ manualStart: false })` to always
	         * [start actions manually](https://github.com/taye/interact.js/issues/114)
	         *
	         - action       (object)  The action to be performed - drag, resize, etc.
	         - interactable (Interactable) The Interactable to target
	         - element      (Element) The DOM Element to target
	         = (object) interact
	         **
	         | interact(target)
	         |   .draggable({
	         |     // disable the default drag start by down->move
	         |     manualStart: true
	         |   })
	         |   // start dragging after the user holds the pointer down
	         |   .on('hold', function (event) {
	         |     var interaction = event.interaction;
	         |
	         |     if (!interaction.interacting()) {
	         |       interaction.start({ name: 'drag' },
	         |                         event.interactable,
	         |                         event.currentTarget);
	         |     }
	         | });
	        \*/
	        start: function (action, interactable, element) {
	            if (this.interacting()
	                || !this.pointerIsDown
	                || this.pointerIds.length < (action.name === 'gesture'? 2 : 1)) {
	                return;
	            }
	
	            // if this interaction had been removed after stopping
	            // add it back
	            if (indexOf(interactions, this) === -1) {
	                interactions.push(this);
	            }
	
	            // set the startCoords if there was no prepared action
	            if (!this.prepared.name) {
	                this.setEventXY(this.startCoords, this.pointers);
	            }
	
	            this.prepared.name  = action.name;
	            this.prepared.axis  = action.axis;
	            this.prepared.edges = action.edges;
	            this.target         = interactable;
	            this.element        = element;
	
	            this.setStartOffsets(action.name, interactable, element);
	            this.setModifications(this.startCoords.page);
	
	            this.prevEvent = this[this.prepared.name + 'Start'](this.downEvent);
	        },
	
	        pointerMove: function (pointer, event, eventTarget, curEventTarget, preEnd) {
	            if (this.inertiaStatus.active) {
	                var pageUp   = this.inertiaStatus.upCoords.page;
	                var clientUp = this.inertiaStatus.upCoords.client;
	
	                var inertiaPosition = {
	                    pageX  : pageUp.x   + this.inertiaStatus.sx,
	                    pageY  : pageUp.y   + this.inertiaStatus.sy,
	                    clientX: clientUp.x + this.inertiaStatus.sx,
	                    clientY: clientUp.y + this.inertiaStatus.sy
	                };
	
	                this.setEventXY(this.curCoords, [inertiaPosition]);
	            }
	            else {
	                this.recordPointer(pointer);
	                this.setEventXY(this.curCoords, this.pointers);
	            }
	
	            var duplicateMove = (this.curCoords.page.x === this.prevCoords.page.x
	                                 && this.curCoords.page.y === this.prevCoords.page.y
	                                 && this.curCoords.client.x === this.prevCoords.client.x
	                                 && this.curCoords.client.y === this.prevCoords.client.y);
	
	            var dx, dy,
	                pointerIndex = this.mouse? 0 : indexOf(this.pointerIds, getPointerId(pointer));
	
	            // register movement greater than pointerMoveTolerance
	            if (this.pointerIsDown && !this.pointerWasMoved) {
	                dx = this.curCoords.client.x - this.startCoords.client.x;
	                dy = this.curCoords.client.y - this.startCoords.client.y;
	
	                this.pointerWasMoved = hypot(dx, dy) > pointerMoveTolerance;
	            }
	
	            if (!duplicateMove && (!this.pointerIsDown || this.pointerWasMoved)) {
	                if (this.pointerIsDown) {
	                    clearTimeout(this.holdTimers[pointerIndex]);
	                }
	
	                this.collectEventTargets(pointer, event, eventTarget, 'move');
	            }
	
	            if (!this.pointerIsDown) { return; }
	
	            if (duplicateMove && this.pointerWasMoved && !preEnd) {
	                this.checkAndPreventDefault(event, this.target, this.element);
	                return;
	            }
	
	            // set pointer coordinate, time changes and speeds
	            setEventDeltas(this.pointerDelta, this.prevCoords, this.curCoords);
	
	            if (!this.prepared.name) { return; }
	
	            if (this.pointerWasMoved
	                // ignore movement while inertia is active
	                && (!this.inertiaStatus.active || (pointer instanceof InteractEvent && /inertiastart/.test(pointer.type)))) {
	
	                // if just starting an action, calculate the pointer speed now
	                if (!this.interacting()) {
	                    setEventDeltas(this.pointerDelta, this.prevCoords, this.curCoords);
	
	                    // check if a drag is in the correct axis
	                    if (this.prepared.name === 'drag') {
	                        var absX = Math.abs(dx),
	                            absY = Math.abs(dy),
	                            targetAxis = this.target.options.drag.axis,
	                            axis = (absX > absY ? 'x' : absX < absY ? 'y' : 'xy');
	
	                        // if the movement isn't in the axis of the interactable
	                        if (axis !== 'xy' && targetAxis !== 'xy' && targetAxis !== axis) {
	                            // cancel the prepared action
	                            this.prepared.name = null;
	
	                            // then try to get a drag from another ineractable
	
	                            var element = eventTarget;
	
	                            // check element interactables
	                            while (isElement(element)) {
	                                var elementInteractable = interactables.get(element);
	
	                                if (elementInteractable
	                                    && elementInteractable !== this.target
	                                    && !elementInteractable.options.drag.manualStart
	                                    && elementInteractable.getAction(this.downPointer, this.downEvent, this, element).name === 'drag'
	                                    && checkAxis(axis, elementInteractable)) {
	
	                                    this.prepared.name = 'drag';
	                                    this.target = elementInteractable;
	                                    this.element = element;
	                                    break;
	                                }
	
	                                element = parentElement(element);
	                            }
	
	                            // if there's no drag from element interactables,
	                            // check the selector interactables
	                            if (!this.prepared.name) {
	                                var thisInteraction = this;
	
	                                var getDraggable = function (interactable, selector, context) {
	                                    var elements = ie8MatchesSelector
	                                        ? context.querySelectorAll(selector)
	                                        : undefined;
	
	                                    if (interactable === thisInteraction.target) { return; }
	
	                                    if (inContext(interactable, eventTarget)
	                                        && !interactable.options.drag.manualStart
	                                        && !testIgnore(interactable, element, eventTarget)
	                                        && testAllow(interactable, element, eventTarget)
	                                        && matchesSelector(element, selector, elements)
	                                        && interactable.getAction(thisInteraction.downPointer, thisInteraction.downEvent, thisInteraction, element).name === 'drag'
	                                        && checkAxis(axis, interactable)
	                                        && withinInteractionLimit(interactable, element, 'drag')) {
	
	                                        return interactable;
	                                    }
	                                };
	
	                                element = eventTarget;
	
	                                while (isElement(element)) {
	                                    var selectorInteractable = interactables.forEachSelector(getDraggable);
	
	                                    if (selectorInteractable) {
	                                        this.prepared.name = 'drag';
	                                        this.target = selectorInteractable;
	                                        this.element = element;
	                                        break;
	                                    }
	
	                                    element = parentElement(element);
	                                }
	                            }
	                        }
	                    }
	                }
	
	                var starting = !!this.prepared.name && !this.interacting();
	
	                if (starting
	                    && (this.target.options[this.prepared.name].manualStart
	                        || !withinInteractionLimit(this.target, this.element, this.prepared))) {
	                    this.stop(event);
	                    return;
	                }
	
	                if (this.prepared.name && this.target) {
	                    if (starting) {
	                        this.start(this.prepared, this.target, this.element);
	                    }
	
	                    var shouldMove = this.setModifications(this.curCoords.page, preEnd);
	
	                    // move if snapping or restriction doesn't prevent it
	                    if (shouldMove || starting) {
	                        this.prevEvent = this[this.prepared.name + 'Move'](event);
	                    }
	
	                    this.checkAndPreventDefault(event, this.target, this.element);
	                }
	            }
	
	            copyCoords(this.prevCoords, this.curCoords);
	
	            if (this.dragging || this.resizing) {
	                this.autoScrollMove(pointer);
	            }
	        },
	
	        dragStart: function (event) {
	            var dragEvent = new InteractEvent(this, event, 'drag', 'start', this.element);
	
	            this.dragging = true;
	            this.target.fire(dragEvent);
	
	            // reset active dropzones
	            this.activeDrops.dropzones = [];
	            this.activeDrops.elements  = [];
	            this.activeDrops.rects     = [];
	
	            if (!this.dynamicDrop) {
	                this.setActiveDrops(this.element);
	            }
	
	            var dropEvents = this.getDropEvents(event, dragEvent);
	
	            if (dropEvents.activate) {
	                this.fireActiveDrops(dropEvents.activate);
	            }
	
	            return dragEvent;
	        },
	
	        dragMove: function (event) {
	            var target = this.target,
	                dragEvent  = new InteractEvent(this, event, 'drag', 'move', this.element),
	                draggableElement = this.element,
	                drop = this.getDrop(dragEvent, event, draggableElement);
	
	            this.dropTarget = drop.dropzone;
	            this.dropElement = drop.element;
	
	            var dropEvents = this.getDropEvents(event, dragEvent);
	
	            target.fire(dragEvent);
	
	            if (dropEvents.leave) { this.prevDropTarget.fire(dropEvents.leave); }
	            if (dropEvents.enter) {     this.dropTarget.fire(dropEvents.enter); }
	            if (dropEvents.move ) {     this.dropTarget.fire(dropEvents.move ); }
	
	            this.prevDropTarget  = this.dropTarget;
	            this.prevDropElement = this.dropElement;
	
	            return dragEvent;
	        },
	
	        resizeStart: function (event) {
	            var resizeEvent = new InteractEvent(this, event, 'resize', 'start', this.element);
	
	            if (this.prepared.edges) {
	                var startRect = this.target.getRect(this.element);
	
	                /*
	                 * When using the `resizable.square` or `resizable.preserveAspectRatio` options, resizing from one edge
	                 * will affect another. E.g. with `resizable.square`, resizing to make the right edge larger will make
	                 * the bottom edge larger by the same amount. We call these 'linked' edges. Any linked edges will depend
	                 * on the active edges and the edge being interacted with.
	                 */
	                if (this.target.options.resize.square || this.target.options.resize.preserveAspectRatio) {
	                    var linkedEdges = extend({}, this.prepared.edges);
	
	                    linkedEdges.top    = linkedEdges.top    || (linkedEdges.left   && !linkedEdges.bottom);
	                    linkedEdges.left   = linkedEdges.left   || (linkedEdges.top    && !linkedEdges.right );
	                    linkedEdges.bottom = linkedEdges.bottom || (linkedEdges.right  && !linkedEdges.top   );
	                    linkedEdges.right  = linkedEdges.right  || (linkedEdges.bottom && !linkedEdges.left  );
	
	                    this.prepared._linkedEdges = linkedEdges;
	                }
	                else {
	                    this.prepared._linkedEdges = null;
	                }
	
	                // if using `resizable.preserveAspectRatio` option, record aspect ratio at the start of the resize
	                if (this.target.options.resize.preserveAspectRatio) {
	                    this.resizeStartAspectRatio = startRect.width / startRect.height;
	                }
	
	                this.resizeRects = {
	                    start     : startRect,
	                    current   : extend({}, startRect),
	                    restricted: extend({}, startRect),
	                    previous  : extend({}, startRect),
	                    delta     : {
	                        left: 0, right : 0, width : 0,
	                        top : 0, bottom: 0, height: 0
	                    }
	                };
	
	                resizeEvent.rect = this.resizeRects.restricted;
	                resizeEvent.deltaRect = this.resizeRects.delta;
	            }
	
	            this.target.fire(resizeEvent);
	
	            this.resizing = true;
	
	            return resizeEvent;
	        },
	
	        resizeMove: function (event) {
	            var resizeEvent = new InteractEvent(this, event, 'resize', 'move', this.element);
	
	            var edges = this.prepared.edges,
	                invert = this.target.options.resize.invert,
	                invertible = invert === 'reposition' || invert === 'negate';
	
	            if (edges) {
	                var dx = resizeEvent.dx,
	                    dy = resizeEvent.dy,
	
	                    start      = this.resizeRects.start,
	                    current    = this.resizeRects.current,
	                    restricted = this.resizeRects.restricted,
	                    delta      = this.resizeRects.delta,
	                    previous   = extend(this.resizeRects.previous, restricted),
	
	                    originalEdges = edges;
	
	                // `resize.preserveAspectRatio` takes precedence over `resize.square`
	                if (this.target.options.resize.preserveAspectRatio) {
	                    var resizeStartAspectRatio = this.resizeStartAspectRatio;
	
	                    edges = this.prepared._linkedEdges;
	
	                    if ((originalEdges.left && originalEdges.bottom)
	                        || (originalEdges.right && originalEdges.top)) {
	                        dy = -dx / resizeStartAspectRatio;
	                    }
	                    else if (originalEdges.left || originalEdges.right) { dy = dx / resizeStartAspectRatio; }
	                    else if (originalEdges.top || originalEdges.bottom) { dx = dy * resizeStartAspectRatio; }
	                }
	                else if (this.target.options.resize.square) {
	                    edges = this.prepared._linkedEdges;
	
	                    if ((originalEdges.left && originalEdges.bottom)
	                        || (originalEdges.right && originalEdges.top)) {
	                        dy = -dx;
	                    }
	                    else if (originalEdges.left || originalEdges.right) { dy = dx; }
	                    else if (originalEdges.top || originalEdges.bottom) { dx = dy; }
	                }
	
	                // update the 'current' rect without modifications
	                if (edges.top   ) { current.top    += dy; }
	                if (edges.bottom) { current.bottom += dy; }
	                if (edges.left  ) { current.left   += dx; }
	                if (edges.right ) { current.right  += dx; }
	
	                if (invertible) {
	                    // if invertible, copy the current rect
	                    extend(restricted, current);
	
	                    if (invert === 'reposition') {
	                        // swap edge values if necessary to keep width/height positive
	                        var swap;
	
	                        if (restricted.top > restricted.bottom) {
	                            swap = restricted.top;
	
	                            restricted.top = restricted.bottom;
	                            restricted.bottom = swap;
	                        }
	                        if (restricted.left > restricted.right) {
	                            swap = restricted.left;
	
	                            restricted.left = restricted.right;
	                            restricted.right = swap;
	                        }
	                    }
	                }
	                else {
	                    // if not invertible, restrict to minimum of 0x0 rect
	                    restricted.top    = Math.min(current.top, start.bottom);
	                    restricted.bottom = Math.max(current.bottom, start.top);
	                    restricted.left   = Math.min(current.left, start.right);
	                    restricted.right  = Math.max(current.right, start.left);
	                }
	
	                restricted.width  = restricted.right  - restricted.left;
	                restricted.height = restricted.bottom - restricted.top ;
	
	                for (var edge in restricted) {
	                    delta[edge] = restricted[edge] - previous[edge];
	                }
	
	                resizeEvent.edges = this.prepared.edges;
	                resizeEvent.rect = restricted;
	                resizeEvent.deltaRect = delta;
	            }
	
	            this.target.fire(resizeEvent);
	
	            return resizeEvent;
	        },
	
	        gestureStart: function (event) {
	            var gestureEvent = new InteractEvent(this, event, 'gesture', 'start', this.element);
	
	            gestureEvent.ds = 0;
	
	            this.gesture.startDistance = this.gesture.prevDistance = gestureEvent.distance;
	            this.gesture.startAngle = this.gesture.prevAngle = gestureEvent.angle;
	            this.gesture.scale = 1;
	
	            this.gesturing = true;
	
	            this.target.fire(gestureEvent);
	
	            return gestureEvent;
	        },
	
	        gestureMove: function (event) {
	            if (!this.pointerIds.length) {
	                return this.prevEvent;
	            }
	
	            var gestureEvent;
	
	            gestureEvent = new InteractEvent(this, event, 'gesture', 'move', this.element);
	            gestureEvent.ds = gestureEvent.scale - this.gesture.scale;
	
	            this.target.fire(gestureEvent);
	
	            this.gesture.prevAngle = gestureEvent.angle;
	            this.gesture.prevDistance = gestureEvent.distance;
	
	            if (gestureEvent.scale !== Infinity &&
	                gestureEvent.scale !== null &&
	                gestureEvent.scale !== undefined  &&
	                !isNaN(gestureEvent.scale)) {
	
	                this.gesture.scale = gestureEvent.scale;
	            }
	
	            return gestureEvent;
	        },
	
	        pointerHold: function (pointer, event, eventTarget) {
	            this.collectEventTargets(pointer, event, eventTarget, 'hold');
	        },
	
	        pointerUp: function (pointer, event, eventTarget, curEventTarget) {
	            var pointerIndex = this.mouse? 0 : indexOf(this.pointerIds, getPointerId(pointer));
	
	            clearTimeout(this.holdTimers[pointerIndex]);
	
	            this.collectEventTargets(pointer, event, eventTarget, 'up' );
	            this.collectEventTargets(pointer, event, eventTarget, 'tap');
	
	            this.pointerEnd(pointer, event, eventTarget, curEventTarget);
	
	            this.removePointer(pointer);
	        },
	
	        pointerCancel: function (pointer, event, eventTarget, curEventTarget) {
	            var pointerIndex = this.mouse? 0 : indexOf(this.pointerIds, getPointerId(pointer));
	
	            clearTimeout(this.holdTimers[pointerIndex]);
	
	            this.collectEventTargets(pointer, event, eventTarget, 'cancel');
	            this.pointerEnd(pointer, event, eventTarget, curEventTarget);
	
	            this.removePointer(pointer);
	        },
	
	        // http://www.quirksmode.org/dom/events/click.html
	        // >Events leading to dblclick
	        //
	        // IE8 doesn't fire down event before dblclick.
	        // This workaround tries to fire a tap and doubletap after dblclick
	        ie8Dblclick: function (pointer, event, eventTarget) {
	            if (this.prevTap
	                && event.clientX === this.prevTap.clientX
	                && event.clientY === this.prevTap.clientY
	                && eventTarget   === this.prevTap.target) {
	
	                this.downTargets[0] = eventTarget;
	                this.downTimes[0] = new Date().getTime();
	                this.collectEventTargets(pointer, event, eventTarget, 'tap');
	            }
	        },
	
	        // End interact move events and stop auto-scroll unless inertia is enabled
	        pointerEnd: function (pointer, event, eventTarget, curEventTarget) {
	            var endEvent,
	                target = this.target,
	                options = target && target.options,
	                inertiaOptions = options && this.prepared.name && options[this.prepared.name].inertia,
	                inertiaStatus = this.inertiaStatus;
	
	            if (this.interacting()) {
	
	                if (inertiaStatus.active && !inertiaStatus.ending) { return; }
	
	                var pointerSpeed,
	                    now = new Date().getTime(),
	                    inertiaPossible = false,
	                    inertia = false,
	                    smoothEnd = false,
	                    endSnap = checkSnap(target, this.prepared.name) && options[this.prepared.name].snap.endOnly,
	                    endRestrict = checkRestrict(target, this.prepared.name) && options[this.prepared.name].restrict.endOnly,
	                    dx = 0,
	                    dy = 0,
	                    startEvent;
	
	                if (this.dragging) {
	                    if      (options.drag.axis === 'x' ) { pointerSpeed = Math.abs(this.pointerDelta.client.vx); }
	                    else if (options.drag.axis === 'y' ) { pointerSpeed = Math.abs(this.pointerDelta.client.vy); }
	                    else   /*options.drag.axis === 'xy'*/{ pointerSpeed = this.pointerDelta.client.speed; }
	                }
	                else {
	                    pointerSpeed = this.pointerDelta.client.speed;
	                }
	
	                // check if inertia should be started
	                inertiaPossible = (inertiaOptions && inertiaOptions.enabled
	                                   && this.prepared.name !== 'gesture'
	                                   && event !== inertiaStatus.startEvent);
	
	                inertia = (inertiaPossible
	                           && (now - this.curCoords.timeStamp) < 50
	                           && pointerSpeed > inertiaOptions.minSpeed
	                           && pointerSpeed > inertiaOptions.endSpeed);
	
	                if (inertiaPossible && !inertia && (endSnap || endRestrict)) {
	
	                    var snapRestrict = {};
	
	                    snapRestrict.snap = snapRestrict.restrict = snapRestrict;
	
	                    if (endSnap) {
	                        this.setSnapping(this.curCoords.page, snapRestrict);
	                        if (snapRestrict.locked) {
	                            dx += snapRestrict.dx;
	                            dy += snapRestrict.dy;
	                        }
	                    }
	
	                    if (endRestrict) {
	                        this.setRestriction(this.curCoords.page, snapRestrict);
	                        if (snapRestrict.restricted) {
	                            dx += snapRestrict.dx;
	                            dy += snapRestrict.dy;
	                        }
	                    }
	
	                    if (dx || dy) {
	                        smoothEnd = true;
	                    }
	                }
	
	                if (inertia || smoothEnd) {
	                    copyCoords(inertiaStatus.upCoords, this.curCoords);
	
	                    this.pointers[0] = inertiaStatus.startEvent = startEvent =
	                        new InteractEvent(this, event, this.prepared.name, 'inertiastart', this.element);
	
	                    inertiaStatus.t0 = now;
	
	                    target.fire(inertiaStatus.startEvent);
	
	                    if (inertia) {
	                        inertiaStatus.vx0 = this.pointerDelta.client.vx;
	                        inertiaStatus.vy0 = this.pointerDelta.client.vy;
	                        inertiaStatus.v0 = pointerSpeed;
	
	                        this.calcInertia(inertiaStatus);
	
	                        var page = extend({}, this.curCoords.page),
	                            origin = getOriginXY(target, this.element),
	                            statusObject;
	
	                        page.x = page.x + inertiaStatus.xe - origin.x;
	                        page.y = page.y + inertiaStatus.ye - origin.y;
	
	                        statusObject = {
	                            useStatusXY: true,
	                            x: page.x,
	                            y: page.y,
	                            dx: 0,
	                            dy: 0,
	                            snap: null
	                        };
	
	                        statusObject.snap = statusObject;
	
	                        dx = dy = 0;
	
	                        if (endSnap) {
	                            var snap = this.setSnapping(this.curCoords.page, statusObject);
	
	                            if (snap.locked) {
	                                dx += snap.dx;
	                                dy += snap.dy;
	                            }
	                        }
	
	                        if (endRestrict) {
	                            var restrict = this.setRestriction(this.curCoords.page, statusObject);
	
	                            if (restrict.restricted) {
	                                dx += restrict.dx;
	                                dy += restrict.dy;
	                            }
	                        }
	
	                        inertiaStatus.modifiedXe += dx;
	                        inertiaStatus.modifiedYe += dy;
	
	                        inertiaStatus.i = reqFrame(this.boundInertiaFrame);
	                    }
	                    else {
	                        inertiaStatus.smoothEnd = true;
	                        inertiaStatus.xe = dx;
	                        inertiaStatus.ye = dy;
	
	                        inertiaStatus.sx = inertiaStatus.sy = 0;
	
	                        inertiaStatus.i = reqFrame(this.boundSmoothEndFrame);
	                    }
	
	                    inertiaStatus.active = true;
	                    return;
	                }
	
	                if (endSnap || endRestrict) {
	                    // fire a move event at the snapped coordinates
	                    this.pointerMove(pointer, event, eventTarget, curEventTarget, true);
	                }
	            }
	
	            if (this.dragging) {
	                endEvent = new InteractEvent(this, event, 'drag', 'end', this.element);
	
	                var draggableElement = this.element,
	                    drop = this.getDrop(endEvent, event, draggableElement);
	
	                this.dropTarget = drop.dropzone;
	                this.dropElement = drop.element;
	
	                var dropEvents = this.getDropEvents(event, endEvent);
	
	                if (dropEvents.leave) { this.prevDropTarget.fire(dropEvents.leave); }
	                if (dropEvents.enter) {     this.dropTarget.fire(dropEvents.enter); }
	                if (dropEvents.drop ) {     this.dropTarget.fire(dropEvents.drop ); }
	                if (dropEvents.deactivate) {
	                    this.fireActiveDrops(dropEvents.deactivate);
	                }
	
	                target.fire(endEvent);
	            }
	            else if (this.resizing) {
	                endEvent = new InteractEvent(this, event, 'resize', 'end', this.element);
	                target.fire(endEvent);
	            }
	            else if (this.gesturing) {
	                endEvent = new InteractEvent(this, event, 'gesture', 'end', this.element);
	                target.fire(endEvent);
	            }
	
	            this.stop(event);
	        },
	
	        collectDrops: function (element) {
	            var drops = [],
	                elements = [],
	                i;
	
	            element = element || this.element;
	
	            // collect all dropzones and their elements which qualify for a drop
	            for (i = 0; i < interactables.length; i++) {
	                if (!interactables[i].options.drop.enabled) { continue; }
	
	                var current = interactables[i],
	                    accept = current.options.drop.accept;
	
	                // test the draggable element against the dropzone's accept setting
	                if ((isElement(accept) && accept !== element)
	                    || (isString(accept)
	                        && !matchesSelector(element, accept))) {
	
	                    continue;
	                }
	
	                // query for new elements if necessary
	                var dropElements = current.selector? current._context.querySelectorAll(current.selector) : [current._element];
	
	                for (var j = 0, len = dropElements.length; j < len; j++) {
	                    var currentElement = dropElements[j];
	
	                    if (currentElement === element) {
	                        continue;
	                    }
	
	                    drops.push(current);
	                    elements.push(currentElement);
	                }
	            }
	
	            return {
	                dropzones: drops,
	                elements: elements
	            };
	        },
	
	        fireActiveDrops: function (event) {
	            var i,
	                current,
	                currentElement,
	                prevElement;
	
	            // loop through all active dropzones and trigger event
	            for (i = 0; i < this.activeDrops.dropzones.length; i++) {
	                current = this.activeDrops.dropzones[i];
	                currentElement = this.activeDrops.elements [i];
	
	                // prevent trigger of duplicate events on same element
	                if (currentElement !== prevElement) {
	                    // set current element as event target
	                    event.target = currentElement;
	                    current.fire(event);
	                }
	                prevElement = currentElement;
	            }
	        },
	
	        // Collect a new set of possible drops and save them in activeDrops.
	        // setActiveDrops should always be called when a drag has just started or a
	        // drag event happens while dynamicDrop is true
	        setActiveDrops: function (dragElement) {
	            // get dropzones and their elements that could receive the draggable
	            var possibleDrops = this.collectDrops(dragElement, true);
	
	            this.activeDrops.dropzones = possibleDrops.dropzones;
	            this.activeDrops.elements  = possibleDrops.elements;
	            this.activeDrops.rects     = [];
	
	            for (var i = 0; i < this.activeDrops.dropzones.length; i++) {
	                this.activeDrops.rects[i] = this.activeDrops.dropzones[i].getRect(this.activeDrops.elements[i]);
	            }
	        },
	
	        getDrop: function (dragEvent, event, dragElement) {
	            var validDrops = [];
	
	            if (dynamicDrop) {
	                this.setActiveDrops(dragElement);
	            }
	
	            // collect all dropzones and their elements which qualify for a drop
	            for (var j = 0; j < this.activeDrops.dropzones.length; j++) {
	                var current        = this.activeDrops.dropzones[j],
	                    currentElement = this.activeDrops.elements [j],
	                    rect           = this.activeDrops.rects    [j];
	
	                validDrops.push(current.dropCheck(dragEvent, event, this.target, dragElement, currentElement, rect)
	                                ? currentElement
	                                : null);
	            }
	
	            // get the most appropriate dropzone based on DOM depth and order
	            var dropIndex = indexOfDeepestElement(validDrops),
	                dropzone  = this.activeDrops.dropzones[dropIndex] || null,
	                element   = this.activeDrops.elements [dropIndex] || null;
	
	            return {
	                dropzone: dropzone,
	                element: element
	            };
	        },
	
	        getDropEvents: function (pointerEvent, dragEvent) {
	            var dropEvents = {
	                enter     : null,
	                leave     : null,
	                activate  : null,
	                deactivate: null,
	                move      : null,
	                drop      : null
	            };
	
	            if (this.dropElement !== this.prevDropElement) {
	                // if there was a prevDropTarget, create a dragleave event
	                if (this.prevDropTarget) {
	                    dropEvents.leave = {
	                        target       : this.prevDropElement,
	                        dropzone     : this.prevDropTarget,
	                        relatedTarget: dragEvent.target,
	                        draggable    : dragEvent.interactable,
	                        dragEvent    : dragEvent,
	                        interaction  : this,
	                        timeStamp    : dragEvent.timeStamp,
	                        type         : 'dragleave'
	                    };
	
	                    dragEvent.dragLeave = this.prevDropElement;
	                    dragEvent.prevDropzone = this.prevDropTarget;
	                }
	                // if the dropTarget is not null, create a dragenter event
	                if (this.dropTarget) {
	                    dropEvents.enter = {
	                        target       : this.dropElement,
	                        dropzone     : this.dropTarget,
	                        relatedTarget: dragEvent.target,
	                        draggable    : dragEvent.interactable,
	                        dragEvent    : dragEvent,
	                        interaction  : this,
	                        timeStamp    : dragEvent.timeStamp,
	                        type         : 'dragenter'
	                    };
	
	                    dragEvent.dragEnter = this.dropElement;
	                    dragEvent.dropzone = this.dropTarget;
	                }
	            }
	
	            if (dragEvent.type === 'dragend' && this.dropTarget) {
	                dropEvents.drop = {
	                    target       : this.dropElement,
	                    dropzone     : this.dropTarget,
	                    relatedTarget: dragEvent.target,
	                    draggable    : dragEvent.interactable,
	                    dragEvent    : dragEvent,
	                    interaction  : this,
	                    timeStamp    : dragEvent.timeStamp,
	                    type         : 'drop'
	                };
	
	                dragEvent.dropzone = this.dropTarget;
	            }
	            if (dragEvent.type === 'dragstart') {
	                dropEvents.activate = {
	                    target       : null,
	                    dropzone     : null,
	                    relatedTarget: dragEvent.target,
	                    draggable    : dragEvent.interactable,
	                    dragEvent    : dragEvent,
	                    interaction  : this,
	                    timeStamp    : dragEvent.timeStamp,
	                    type         : 'dropactivate'
	                };
	            }
	            if (dragEvent.type === 'dragend') {
	                dropEvents.deactivate = {
	                    target       : null,
	                    dropzone     : null,
	                    relatedTarget: dragEvent.target,
	                    draggable    : dragEvent.interactable,
	                    dragEvent    : dragEvent,
	                    interaction  : this,
	                    timeStamp    : dragEvent.timeStamp,
	                    type         : 'dropdeactivate'
	                };
	            }
	            if (dragEvent.type === 'dragmove' && this.dropTarget) {
	                dropEvents.move = {
	                    target       : this.dropElement,
	                    dropzone     : this.dropTarget,
	                    relatedTarget: dragEvent.target,
	                    draggable    : dragEvent.interactable,
	                    dragEvent    : dragEvent,
	                    interaction  : this,
	                    dragmove     : dragEvent,
	                    timeStamp    : dragEvent.timeStamp,
	                    type         : 'dropmove'
	                };
	                dragEvent.dropzone = this.dropTarget;
	            }
	
	            return dropEvents;
	        },
	
	        currentAction: function () {
	            return (this.dragging && 'drag') || (this.resizing && 'resize') || (this.gesturing && 'gesture') || null;
	        },
	
	        interacting: function () {
	            return this.dragging || this.resizing || this.gesturing;
	        },
	
	        clearTargets: function () {
	            this.target = this.element = null;
	
	            this.dropTarget = this.dropElement = this.prevDropTarget = this.prevDropElement = null;
	        },
	
	        stop: function (event) {
	            if (this.interacting()) {
	                autoScroll.stop();
	                this.matches = [];
	                this.matchElements = [];
	
	                var target = this.target;
	
	                if (target.options.styleCursor) {
	                    target._doc.documentElement.style.cursor = '';
	                }
	
	                // prevent Default only if were previously interacting
	                if (event && isFunction(event.preventDefault)) {
	                    this.checkAndPreventDefault(event, target, this.element);
	                }
	
	                if (this.dragging) {
	                    this.activeDrops.dropzones = this.activeDrops.elements = this.activeDrops.rects = null;
	                }
	            }
	
	            this.clearTargets();
	
	            this.pointerIsDown = this.snapStatus.locked = this.dragging = this.resizing = this.gesturing = false;
	            this.prepared.name = this.prevEvent = null;
	            this.inertiaStatus.resumeDx = this.inertiaStatus.resumeDy = 0;
	
	            // remove pointers if their ID isn't in this.pointerIds
	            for (var i = 0; i < this.pointers.length; i++) {
	                if (indexOf(this.pointerIds, getPointerId(this.pointers[i])) === -1) {
	                    this.pointers.splice(i, 1);
	                }
	            }
	        },
	
	        inertiaFrame: function () {
	            var inertiaStatus = this.inertiaStatus,
	                options = this.target.options[this.prepared.name].inertia,
	                lambda = options.resistance,
	                t = new Date().getTime() / 1000 - inertiaStatus.t0;
	
	            if (t < inertiaStatus.te) {
	
	                var progress =  1 - (Math.exp(-lambda * t) - inertiaStatus.lambda_v0) / inertiaStatus.one_ve_v0;
	
	                if (inertiaStatus.modifiedXe === inertiaStatus.xe && inertiaStatus.modifiedYe === inertiaStatus.ye) {
	                    inertiaStatus.sx = inertiaStatus.xe * progress;
	                    inertiaStatus.sy = inertiaStatus.ye * progress;
	                }
	                else {
	                    var quadPoint = getQuadraticCurvePoint(
	                            0, 0,
	                            inertiaStatus.xe, inertiaStatus.ye,
	                            inertiaStatus.modifiedXe, inertiaStatus.modifiedYe,
	                            progress);
	
	                    inertiaStatus.sx = quadPoint.x;
	                    inertiaStatus.sy = quadPoint.y;
	                }
	
	                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);
	
	                inertiaStatus.i = reqFrame(this.boundInertiaFrame);
	            }
	            else {
	                inertiaStatus.ending = true;
	
	                inertiaStatus.sx = inertiaStatus.modifiedXe;
	                inertiaStatus.sy = inertiaStatus.modifiedYe;
	
	                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);
	                this.pointerEnd(inertiaStatus.startEvent, inertiaStatus.startEvent);
	
	                inertiaStatus.active = inertiaStatus.ending = false;
	            }
	        },
	
	        smoothEndFrame: function () {
	            var inertiaStatus = this.inertiaStatus,
	                t = new Date().getTime() - inertiaStatus.t0,
	                duration = this.target.options[this.prepared.name].inertia.smoothEndDuration;
	
	            if (t < duration) {
	                inertiaStatus.sx = easeOutQuad(t, 0, inertiaStatus.xe, duration);
	                inertiaStatus.sy = easeOutQuad(t, 0, inertiaStatus.ye, duration);
	
	                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);
	
	                inertiaStatus.i = reqFrame(this.boundSmoothEndFrame);
	            }
	            else {
	                inertiaStatus.ending = true;
	
	                inertiaStatus.sx = inertiaStatus.xe;
	                inertiaStatus.sy = inertiaStatus.ye;
	
	                this.pointerMove(inertiaStatus.startEvent, inertiaStatus.startEvent);
	                this.pointerEnd(inertiaStatus.startEvent, inertiaStatus.startEvent);
	
	                inertiaStatus.smoothEnd =
	                  inertiaStatus.active = inertiaStatus.ending = false;
	            }
	        },
	
	        addPointer: function (pointer) {
	            var id = getPointerId(pointer),
	                index = this.mouse? 0 : indexOf(this.pointerIds, id);
	
	            if (index === -1) {
	                index = this.pointerIds.length;
	            }
	
	            this.pointerIds[index] = id;
	            this.pointers[index] = pointer;
	
	            return index;
	        },
	
	        removePointer: function (pointer) {
	            var id = getPointerId(pointer),
	                index = this.mouse? 0 : indexOf(this.pointerIds, id);
	
	            if (index === -1) { return; }
	
	            this.pointers   .splice(index, 1);
	            this.pointerIds .splice(index, 1);
	            this.downTargets.splice(index, 1);
	            this.downTimes  .splice(index, 1);
	            this.holdTimers .splice(index, 1);
	        },
	
	        recordPointer: function (pointer) {
	            var index = this.mouse? 0: indexOf(this.pointerIds, getPointerId(pointer));
	
	            if (index === -1) { return; }
	
	            this.pointers[index] = pointer;
	        },
	
	        collectEventTargets: function (pointer, event, eventTarget, eventType) {
	            var pointerIndex = this.mouse? 0 : indexOf(this.pointerIds, getPointerId(pointer));
	
	            // do not fire a tap event if the pointer was moved before being lifted
	            if (eventType === 'tap' && (this.pointerWasMoved
	                // or if the pointerup target is different to the pointerdown target
	                || !(this.downTargets[pointerIndex] && this.downTargets[pointerIndex] === eventTarget))) {
	                return;
	            }
	
	            var targets = [],
	                elements = [],
	                element = eventTarget;
	
	            function collectSelectors (interactable, selector, context) {
	                var els = ie8MatchesSelector
	                        ? context.querySelectorAll(selector)
	                        : undefined;
	
	                if (interactable._iEvents[eventType]
	                    && isElement(element)
	                    && inContext(interactable, element)
	                    && !testIgnore(interactable, element, eventTarget)
	                    && testAllow(interactable, element, eventTarget)
	                    && matchesSelector(element, selector, els)) {
	
	                    targets.push(interactable);
	                    elements.push(element);
	                }
	            }
	
	            while (element) {
	                if (interact.isSet(element) && interact(element)._iEvents[eventType]) {
	                    targets.push(interact(element));
	                    elements.push(element);
	                }
	
	                interactables.forEachSelector(collectSelectors);
	
	                element = parentElement(element);
	            }
	
	            // create the tap event even if there are no listeners so that
	            // doubletap can still be created and fired
	            if (targets.length || eventType === 'tap') {
	                this.firePointers(pointer, event, eventTarget, targets, elements, eventType);
	            }
	        },
	
	        firePointers: function (pointer, event, eventTarget, targets, elements, eventType) {
	            var pointerIndex = this.mouse? 0 : indexOf(this.pointerIds, getPointerId(pointer)),
	                pointerEvent = {},
	                i,
	                // for tap events
	                interval, createNewDoubleTap;
	
	            // if it's a doubletap then the event properties would have been
	            // copied from the tap event and provided as the pointer argument
	            if (eventType === 'doubletap') {
	                pointerEvent = pointer;
	            }
	            else {
	                pointerExtend(pointerEvent, event);
	                if (event !== pointer) {
	                    pointerExtend(pointerEvent, pointer);
	                }
	
	                pointerEvent.preventDefault           = preventOriginalDefault;
	                pointerEvent.stopPropagation          = InteractEvent.prototype.stopPropagation;
	                pointerEvent.stopImmediatePropagation = InteractEvent.prototype.stopImmediatePropagation;
	                pointerEvent.interaction              = this;
	
	                pointerEvent.timeStamp       = new Date().getTime();
	                pointerEvent.originalEvent   = event;
	                pointerEvent.originalPointer = pointer;
	                pointerEvent.type            = eventType;
	                pointerEvent.pointerId       = getPointerId(pointer);
	                pointerEvent.pointerType     = this.mouse? 'mouse' : !supportsPointerEvent? 'touch'
	                                                    : isString(pointer.pointerType)
	                                                        ? pointer.pointerType
	                                                        : [,,'touch', 'pen', 'mouse'][pointer.pointerType];
	            }
	
	            if (eventType === 'tap') {
	                pointerEvent.dt = pointerEvent.timeStamp - this.downTimes[pointerIndex];
	
	                interval = pointerEvent.timeStamp - this.tapTime;
	                createNewDoubleTap = !!(this.prevTap && this.prevTap.type !== 'doubletap'
	                       && this.prevTap.target === pointerEvent.target
	                       && interval < 500);
	
	                pointerEvent.double = createNewDoubleTap;
	
	                this.tapTime = pointerEvent.timeStamp;
	            }
	
	            for (i = 0; i < targets.length; i++) {
	                pointerEvent.currentTarget = elements[i];
	                pointerEvent.interactable = targets[i];
	                targets[i].fire(pointerEvent);
	
	                if (pointerEvent.immediatePropagationStopped
	                    ||(pointerEvent.propagationStopped && elements[i + 1] !== pointerEvent.currentTarget)) {
	                    break;
	                }
	            }
	
	            if (createNewDoubleTap) {
	                var doubleTap = {};
	
	                extend(doubleTap, pointerEvent);
	
	                doubleTap.dt   = interval;
	                doubleTap.type = 'doubletap';
	
	                this.collectEventTargets(doubleTap, event, eventTarget, 'doubletap');
	
	                this.prevTap = doubleTap;
	            }
	            else if (eventType === 'tap') {
	                this.prevTap = pointerEvent;
	            }
	        },
	
	        validateSelector: function (pointer, event, matches, matchElements) {
	            for (var i = 0, len = matches.length; i < len; i++) {
	                var match = matches[i],
	                    matchElement = matchElements[i],
	                    action = validateAction(match.getAction(pointer, event, this, matchElement), match);
	
	                if (action && withinInteractionLimit(match, matchElement, action)) {
	                    this.target = match;
	                    this.element = matchElement;
	
	                    return action;
	                }
	            }
	        },
	
	        setSnapping: function (pageCoords, status) {
	            var snap = this.target.options[this.prepared.name].snap,
	                targets = [],
	                target,
	                page,
	                i;
	
	            status = status || this.snapStatus;
	
	            if (status.useStatusXY) {
	                page = { x: status.x, y: status.y };
	            }
	            else {
	                var origin = getOriginXY(this.target, this.element);
	
	                page = extend({}, pageCoords);
	
	                page.x -= origin.x;
	                page.y -= origin.y;
	            }
	
	            status.realX = page.x;
	            status.realY = page.y;
	
	            page.x = page.x - this.inertiaStatus.resumeDx;
	            page.y = page.y - this.inertiaStatus.resumeDy;
	
	            var len = snap.targets? snap.targets.length : 0;
	
	            for (var relIndex = 0; relIndex < this.snapOffsets.length; relIndex++) {
	                var relative = {
	                    x: page.x - this.snapOffsets[relIndex].x,
	                    y: page.y - this.snapOffsets[relIndex].y
	                };
	
	                for (i = 0; i < len; i++) {
	                    if (isFunction(snap.targets[i])) {
	                        target = snap.targets[i](relative.x, relative.y, this);
	                    }
	                    else {
	                        target = snap.targets[i];
	                    }
	
	                    if (!target) { continue; }
	
	                    targets.push({
	                        x: isNumber(target.x) ? (target.x + this.snapOffsets[relIndex].x) : relative.x,
	                        y: isNumber(target.y) ? (target.y + this.snapOffsets[relIndex].y) : relative.y,
	
	                        range: isNumber(target.range)? target.range: snap.range
	                    });
	                }
	            }
	
	            var closest = {
	                    target: null,
	                    inRange: false,
	                    distance: 0,
	                    range: 0,
	                    dx: 0,
	                    dy: 0
	                };
	
	            for (i = 0, len = targets.length; i < len; i++) {
	                target = targets[i];
	
	                var range = target.range,
	                    dx = target.x - page.x,
	                    dy = target.y - page.y,
	                    distance = hypot(dx, dy),
	                    inRange = distance <= range;
	
	                // Infinite targets count as being out of range
	                // compared to non infinite ones that are in range
	                if (range === Infinity && closest.inRange && closest.range !== Infinity) {
	                    inRange = false;
	                }
	
	                if (!closest.target || (inRange
	                    // is the closest target in range?
	                    ? (closest.inRange && range !== Infinity
	                        // the pointer is relatively deeper in this target
	                        ? distance / range < closest.distance / closest.range
	                        // this target has Infinite range and the closest doesn't
	                        : (range === Infinity && closest.range !== Infinity)
	                            // OR this target is closer that the previous closest
	                            || distance < closest.distance)
	                    // The other is not in range and the pointer is closer to this target
	                    : (!closest.inRange && distance < closest.distance))) {
	
	                    if (range === Infinity) {
	                        inRange = true;
	                    }
	
	                    closest.target = target;
	                    closest.distance = distance;
	                    closest.range = range;
	                    closest.inRange = inRange;
	                    closest.dx = dx;
	                    closest.dy = dy;
	
	                    status.range = range;
	                }
	            }
	
	            var snapChanged;
	
	            if (closest.target) {
	                snapChanged = (status.snappedX !== closest.target.x || status.snappedY !== closest.target.y);
	
	                status.snappedX = closest.target.x;
	                status.snappedY = closest.target.y;
	            }
	            else {
	                snapChanged = true;
	
	                status.snappedX = NaN;
	                status.snappedY = NaN;
	            }
	
	            status.dx = closest.dx;
	            status.dy = closest.dy;
	
	            status.changed = (snapChanged || (closest.inRange && !status.locked));
	            status.locked = closest.inRange;
	
	            return status;
	        },
	
	        setRestriction: function (pageCoords, status) {
	            var target = this.target,
	                restrict = target && target.options[this.prepared.name].restrict,
	                restriction = restrict && restrict.restriction,
	                page;
	
	            if (!restriction) {
	                return status;
	            }
	
	            status = status || this.restrictStatus;
	
	            page = status.useStatusXY
	                    ? page = { x: status.x, y: status.y }
	                    : page = extend({}, pageCoords);
	
	            if (status.snap && status.snap.locked) {
	                page.x += status.snap.dx || 0;
	                page.y += status.snap.dy || 0;
	            }
	
	            page.x -= this.inertiaStatus.resumeDx;
	            page.y -= this.inertiaStatus.resumeDy;
	
	            status.dx = 0;
	            status.dy = 0;
	            status.restricted = false;
	
	            var rect, restrictedX, restrictedY;
	
	            if (isString(restriction)) {
	                if (restriction === 'parent') {
	                    restriction = parentElement(this.element);
	                }
	                else if (restriction === 'self') {
	                    restriction = target.getRect(this.element);
	                }
	                else {
	                    restriction = closest(this.element, restriction);
	                }
	
	                if (!restriction) { return status; }
	            }
	
	            if (isFunction(restriction)) {
	                restriction = restriction(page.x, page.y, this.element);
	            }
	
	            if (isElement(restriction)) {
	                restriction = getElementRect(restriction);
	            }
	
	            rect = restriction;
	
	            if (!restriction) {
	                restrictedX = page.x;
	                restrictedY = page.y;
	            }
	            // object is assumed to have
	            // x, y, width, height or
	            // left, top, right, bottom
	            else if ('x' in restriction && 'y' in restriction) {
	                restrictedX = Math.max(Math.min(rect.x + rect.width  - this.restrictOffset.right , page.x), rect.x + this.restrictOffset.left);
	                restrictedY = Math.max(Math.min(rect.y + rect.height - this.restrictOffset.bottom, page.y), rect.y + this.restrictOffset.top );
	            }
	            else {
	                restrictedX = Math.max(Math.min(rect.right  - this.restrictOffset.right , page.x), rect.left + this.restrictOffset.left);
	                restrictedY = Math.max(Math.min(rect.bottom - this.restrictOffset.bottom, page.y), rect.top  + this.restrictOffset.top );
	            }
	
	            status.dx = restrictedX - page.x;
	            status.dy = restrictedY - page.y;
	
	            status.changed = status.restrictedX !== restrictedX || status.restrictedY !== restrictedY;
	            status.restricted = !!(status.dx || status.dy);
	
	            status.restrictedX = restrictedX;
	            status.restrictedY = restrictedY;
	
	            return status;
	        },
	
	        checkAndPreventDefault: function (event, interactable, element) {
	            if (!(interactable = interactable || this.target)) { return; }
	
	            var options = interactable.options,
	                prevent = options.preventDefault;
	
	            if (prevent === 'auto' && element && !/^(input|select|textarea)$/i.test(event.target.nodeName)) {
	                // do not preventDefault on pointerdown if the prepared action is a drag
	                // and dragging can only start from a certain direction - this allows
	                // a touch to pan the viewport if a drag isn't in the right direction
	                if (/down|start/i.test(event.type)
	                    && this.prepared.name === 'drag' && options.drag.axis !== 'xy') {
	
	                    return;
	                }
	
	                // with manualStart, only preventDefault while interacting
	                if (options[this.prepared.name] && options[this.prepared.name].manualStart
	                    && !this.interacting()) {
	                    return;
	                }
	
	                event.preventDefault();
	                return;
	            }
	
	            if (prevent === 'always') {
	                event.preventDefault();
	                return;
	            }
	        },
	
	        calcInertia: function (status) {
	            var inertiaOptions = this.target.options[this.prepared.name].inertia,
	                lambda = inertiaOptions.resistance,
	                inertiaDur = -Math.log(inertiaOptions.endSpeed / status.v0) / lambda;
	
	            status.x0 = this.prevEvent.pageX;
	            status.y0 = this.prevEvent.pageY;
	            status.t0 = status.startEvent.timeStamp / 1000;
	            status.sx = status.sy = 0;
	
	            status.modifiedXe = status.xe = (status.vx0 - inertiaDur) / lambda;
	            status.modifiedYe = status.ye = (status.vy0 - inertiaDur) / lambda;
	            status.te = inertiaDur;
	
	            status.lambda_v0 = lambda / status.v0;
	            status.one_ve_v0 = 1 - inertiaOptions.endSpeed / status.v0;
	        },
	
	        autoScrollMove: function (pointer) {
	            if (!(this.interacting()
	                && checkAutoScroll(this.target, this.prepared.name))) {
	                return;
	            }
	
	            if (this.inertiaStatus.active) {
	                autoScroll.x = autoScroll.y = 0;
	                return;
	            }
	
	            var top,
	                right,
	                bottom,
	                left,
	                options = this.target.options[this.prepared.name].autoScroll,
	                container = options.container || getWindow(this.element);
	
	            if (isWindow(container)) {
	                left   = pointer.clientX < autoScroll.margin;
	                top    = pointer.clientY < autoScroll.margin;
	                right  = pointer.clientX > container.innerWidth  - autoScroll.margin;
	                bottom = pointer.clientY > container.innerHeight - autoScroll.margin;
	            }
	            else {
	                var rect = getElementClientRect(container);
	
	                left   = pointer.clientX < rect.left   + autoScroll.margin;
	                top    = pointer.clientY < rect.top    + autoScroll.margin;
	                right  = pointer.clientX > rect.right  - autoScroll.margin;
	                bottom = pointer.clientY > rect.bottom - autoScroll.margin;
	            }
	
	            autoScroll.x = (right ? 1: left? -1: 0);
	            autoScroll.y = (bottom? 1:  top? -1: 0);
	
	            if (!autoScroll.isScrolling) {
	                // set the autoScroll properties to those of the target
	                autoScroll.margin = options.margin;
	                autoScroll.speed  = options.speed;
	
	                autoScroll.start(this);
	            }
	        },
	
	        _updateEventTargets: function (target, currentTarget) {
	            this._eventTarget    = target;
	            this._curEventTarget = currentTarget;
	        }
	
	    };
	
	    function getInteractionFromPointer (pointer, eventType, eventTarget) {
	        var i = 0, len = interactions.length,
	            mouseEvent = (/mouse/i.test(pointer.pointerType || eventType)
	                          // MSPointerEvent.MSPOINTER_TYPE_MOUSE
	                          || pointer.pointerType === 4),
	            interaction;
	
	        var id = getPointerId(pointer);
	
	        // try to resume inertia with a new pointer
	        if (/down|start/i.test(eventType)) {
	            for (i = 0; i < len; i++) {
	                interaction = interactions[i];
	
	                var element = eventTarget;
	
	                if (interaction.inertiaStatus.active && interaction.target.options[interaction.prepared.name].inertia.allowResume
	                    && (interaction.mouse === mouseEvent)) {
	                    while (element) {
	                        // if the element is the interaction element
	                        if (element === interaction.element) {
	                            return interaction;
	                        }
	                        element = parentElement(element);
	                    }
	                }
	            }
	        }
	
	        // if it's a mouse interaction
	        if (mouseEvent || !(supportsTouch || supportsPointerEvent)) {
	
	            // find a mouse interaction that's not in inertia phase
	            for (i = 0; i < len; i++) {
	                if (interactions[i].mouse && !interactions[i].inertiaStatus.active) {
	                    return interactions[i];
	                }
	            }
	
	            // find any interaction specifically for mouse.
	            // if the eventType is a mousedown, and inertia is active
	            // ignore the interaction
	            for (i = 0; i < len; i++) {
	                if (interactions[i].mouse && !(/down/.test(eventType) && interactions[i].inertiaStatus.active)) {
	                    return interaction;
	                }
	            }
	
	            // create a new interaction for mouse
	            interaction = new Interaction();
	            interaction.mouse = true;
	
	            return interaction;
	        }
	
	        // get interaction that has this pointer
	        for (i = 0; i < len; i++) {
	            if (contains(interactions[i].pointerIds, id)) {
	                return interactions[i];
	            }
	        }
	
	        // at this stage, a pointerUp should not return an interaction
	        if (/up|end|out/i.test(eventType)) {
	            return null;
	        }
	
	        // get first idle interaction
	        for (i = 0; i < len; i++) {
	            interaction = interactions[i];
	
	            if ((!interaction.prepared.name || (interaction.target.options.gesture.enabled))
	                && !interaction.interacting()
	                && !(!mouseEvent && interaction.mouse)) {
	
	                return interaction;
	            }
	        }
	
	        return new Interaction();
	    }
	
	    function doOnInteractions (method) {
	        return (function (event) {
	            var interaction,
	                eventTarget = getActualElement(event.path
	                                               ? event.path[0]
	                                               : event.target),
	                curEventTarget = getActualElement(event.currentTarget),
	                i;
	
	            if (supportsTouch && /touch/.test(event.type)) {
	                prevTouchTime = new Date().getTime();
	
	                for (i = 0; i < event.changedTouches.length; i++) {
	                    var pointer = event.changedTouches[i];
	
	                    interaction = getInteractionFromPointer(pointer, event.type, eventTarget);
	
	                    if (!interaction) { continue; }
	
	                    interaction._updateEventTargets(eventTarget, curEventTarget);
	
	                    interaction[method](pointer, event, eventTarget, curEventTarget);
	                }
	            }
	            else {
	                if (!supportsPointerEvent && /mouse/.test(event.type)) {
	                    // ignore mouse events while touch interactions are active
	                    for (i = 0; i < interactions.length; i++) {
	                        if (!interactions[i].mouse && interactions[i].pointerIsDown) {
	                            return;
	                        }
	                    }
	
	                    // try to ignore mouse events that are simulated by the browser
	                    // after a touch event
	                    if (new Date().getTime() - prevTouchTime < 500) {
	                        return;
	                    }
	                }
	
	                interaction = getInteractionFromPointer(event, event.type, eventTarget);
	
	                if (!interaction) { return; }
	
	                interaction._updateEventTargets(eventTarget, curEventTarget);
	
	                interaction[method](event, event, eventTarget, curEventTarget);
	            }
	        });
	    }
	
	    function InteractEvent (interaction, event, action, phase, element, related) {
	        var client,
	            page,
	            target      = interaction.target,
	            snapStatus  = interaction.snapStatus,
	            restrictStatus  = interaction.restrictStatus,
	            pointers    = interaction.pointers,
	            deltaSource = (target && target.options || defaultOptions).deltaSource,
	            sourceX     = deltaSource + 'X',
	            sourceY     = deltaSource + 'Y',
	            options     = target? target.options: defaultOptions,
	            origin      = getOriginXY(target, element),
	            starting    = phase === 'start',
	            ending      = phase === 'end',
	            coords      = starting? interaction.startCoords : interaction.curCoords;
	
	        element = element || interaction.element;
	
	        page   = extend({}, coords.page);
	        client = extend({}, coords.client);
	
	        page.x -= origin.x;
	        page.y -= origin.y;
	
	        client.x -= origin.x;
	        client.y -= origin.y;
	
	        var relativePoints = options[action].snap && options[action].snap.relativePoints ;
	
	        if (checkSnap(target, action) && !(starting && relativePoints && relativePoints.length)) {
	            this.snap = {
	                range  : snapStatus.range,
	                locked : snapStatus.locked,
	                x      : snapStatus.snappedX,
	                y      : snapStatus.snappedY,
	                realX  : snapStatus.realX,
	                realY  : snapStatus.realY,
	                dx     : snapStatus.dx,
	                dy     : snapStatus.dy
	            };
	
	            if (snapStatus.locked) {
	                page.x += snapStatus.dx;
	                page.y += snapStatus.dy;
	                client.x += snapStatus.dx;
	                client.y += snapStatus.dy;
	            }
	        }
	
	        if (checkRestrict(target, action) && !(starting && options[action].restrict.elementRect) && restrictStatus.restricted) {
	            page.x += restrictStatus.dx;
	            page.y += restrictStatus.dy;
	            client.x += restrictStatus.dx;
	            client.y += restrictStatus.dy;
	
	            this.restrict = {
	                dx: restrictStatus.dx,
	                dy: restrictStatus.dy
	            };
	        }
	
	        this.pageX     = page.x;
	        this.pageY     = page.y;
	        this.clientX   = client.x;
	        this.clientY   = client.y;
	
	        this.x0        = interaction.startCoords.page.x - origin.x;
	        this.y0        = interaction.startCoords.page.y - origin.y;
	        this.clientX0  = interaction.startCoords.client.x - origin.x;
	        this.clientY0  = interaction.startCoords.client.y - origin.y;
	        this.ctrlKey   = event.ctrlKey;
	        this.altKey    = event.altKey;
	        this.shiftKey  = event.shiftKey;
	        this.metaKey   = event.metaKey;
	        this.button    = event.button;
	        this.buttons   = event.buttons;
	        this.target    = element;
	        this.t0        = interaction.downTimes[0];
	        this.type      = action + (phase || '');
	
	        this.interaction = interaction;
	        this.interactable = target;
	
	        var inertiaStatus = interaction.inertiaStatus;
	
	        if (inertiaStatus.active) {
	            this.detail = 'inertia';
	        }
	
	        if (related) {
	            this.relatedTarget = related;
	        }
	
	        // end event dx, dy is difference between start and end points
	        if (ending) {
	            if (deltaSource === 'client') {
	                this.dx = client.x - interaction.startCoords.client.x;
	                this.dy = client.y - interaction.startCoords.client.y;
	            }
	            else {
	                this.dx = page.x - interaction.startCoords.page.x;
	                this.dy = page.y - interaction.startCoords.page.y;
	            }
	        }
	        else if (starting) {
	            this.dx = 0;
	            this.dy = 0;
	        }
	        // copy properties from previousmove if starting inertia
	        else if (phase === 'inertiastart') {
	            this.dx = interaction.prevEvent.dx;
	            this.dy = interaction.prevEvent.dy;
	        }
	        else {
	            if (deltaSource === 'client') {
	                this.dx = client.x - interaction.prevEvent.clientX;
	                this.dy = client.y - interaction.prevEvent.clientY;
	            }
	            else {
	                this.dx = page.x - interaction.prevEvent.pageX;
	                this.dy = page.y - interaction.prevEvent.pageY;
	            }
	        }
	        if (interaction.prevEvent && interaction.prevEvent.detail === 'inertia'
	            && !inertiaStatus.active
	            && options[action].inertia && options[action].inertia.zeroResumeDelta) {
	
	            inertiaStatus.resumeDx += this.dx;
	            inertiaStatus.resumeDy += this.dy;
	
	            this.dx = this.dy = 0;
	        }
	
	        if (action === 'resize' && interaction.resizeAxes) {
	            if (options.resize.square) {
	                if (interaction.resizeAxes === 'y') {
	                    this.dx = this.dy;
	                }
	                else {
	                    this.dy = this.dx;
	                }
	                this.axes = 'xy';
	            }
	            else {
	                this.axes = interaction.resizeAxes;
	
	                if (interaction.resizeAxes === 'x') {
	                    this.dy = 0;
	                }
	                else if (interaction.resizeAxes === 'y') {
	                    this.dx = 0;
	                }
	            }
	        }
	        else if (action === 'gesture') {
	            this.touches = [pointers[0], pointers[1]];
	
	            if (starting) {
	                this.distance = touchDistance(pointers, deltaSource);
	                this.box      = touchBBox(pointers);
	                this.scale    = 1;
	                this.ds       = 0;
	                this.angle    = touchAngle(pointers, undefined, deltaSource);
	                this.da       = 0;
	            }
	            else if (ending || event instanceof InteractEvent) {
	                this.distance = interaction.prevEvent.distance;
	                this.box      = interaction.prevEvent.box;
	                this.scale    = interaction.prevEvent.scale;
	                this.ds       = this.scale - 1;
	                this.angle    = interaction.prevEvent.angle;
	                this.da       = this.angle - interaction.gesture.startAngle;
	            }
	            else {
	                this.distance = touchDistance(pointers, deltaSource);
	                this.box      = touchBBox(pointers);
	                this.scale    = this.distance / interaction.gesture.startDistance;
	                this.angle    = touchAngle(pointers, interaction.gesture.prevAngle, deltaSource);
	
	                this.ds = this.scale - interaction.gesture.prevScale;
	                this.da = this.angle - interaction.gesture.prevAngle;
	            }
	        }
	
	        if (starting) {
	            this.timeStamp = interaction.downTimes[0];
	            this.dt        = 0;
	            this.duration  = 0;
	            this.speed     = 0;
	            this.velocityX = 0;
	            this.velocityY = 0;
	        }
	        else if (phase === 'inertiastart') {
	            this.timeStamp = interaction.prevEvent.timeStamp;
	            this.dt        = interaction.prevEvent.dt;
	            this.duration  = interaction.prevEvent.duration;
	            this.speed     = interaction.prevEvent.speed;
	            this.velocityX = interaction.prevEvent.velocityX;
	            this.velocityY = interaction.prevEvent.velocityY;
	        }
	        else {
	            this.timeStamp = new Date().getTime();
	            this.dt        = this.timeStamp - interaction.prevEvent.timeStamp;
	            this.duration  = this.timeStamp - interaction.downTimes[0];
	
	            if (event instanceof InteractEvent) {
	                var dx = this[sourceX] - interaction.prevEvent[sourceX],
	                    dy = this[sourceY] - interaction.prevEvent[sourceY],
	                    dt = this.dt / 1000;
	
	                this.speed = hypot(dx, dy) / dt;
	                this.velocityX = dx / dt;
	                this.velocityY = dy / dt;
	            }
	            // if normal move or end event, use previous user event coords
	            else {
	                // speed and velocity in pixels per second
	                this.speed = interaction.pointerDelta[deltaSource].speed;
	                this.velocityX = interaction.pointerDelta[deltaSource].vx;
	                this.velocityY = interaction.pointerDelta[deltaSource].vy;
	            }
	        }
	
	        if ((ending || phase === 'inertiastart')
	            && interaction.prevEvent.speed > 600 && this.timeStamp - interaction.prevEvent.timeStamp < 150) {
	
	            var angle = 180 * Math.atan2(interaction.prevEvent.velocityY, interaction.prevEvent.velocityX) / Math.PI,
	                overlap = 22.5;
	
	            if (angle < 0) {
	                angle += 360;
	            }
	
	            var left = 135 - overlap <= angle && angle < 225 + overlap,
	                up   = 225 - overlap <= angle && angle < 315 + overlap,
	
	                right = !left && (315 - overlap <= angle || angle <  45 + overlap),
	                down  = !up   &&   45 - overlap <= angle && angle < 135 + overlap;
	
	            this.swipe = {
	                up   : up,
	                down : down,
	                left : left,
	                right: right,
	                angle: angle,
	                speed: interaction.prevEvent.speed,
	                velocity: {
	                    x: interaction.prevEvent.velocityX,
	                    y: interaction.prevEvent.velocityY
	                }
	            };
	        }
	    }
	
	    InteractEvent.prototype = {
	        preventDefault: blank,
	        stopImmediatePropagation: function () {
	            this.immediatePropagationStopped = this.propagationStopped = true;
	        },
	        stopPropagation: function () {
	            this.propagationStopped = true;
	        }
	    };
	
	    function preventOriginalDefault () {
	        this.originalEvent.preventDefault();
	    }
	
	    function getActionCursor (action) {
	        var cursor = '';
	
	        if (action.name === 'drag') {
	            cursor =  actionCursors.drag;
	        }
	        if (action.name === 'resize') {
	            if (action.axis) {
	                cursor =  actionCursors[action.name + action.axis];
	            }
	            else if (action.edges) {
	                var cursorKey = 'resize',
	                    edgeNames = ['top', 'bottom', 'left', 'right'];
	
	                for (var i = 0; i < 4; i++) {
	                    if (action.edges[edgeNames[i]]) {
	                        cursorKey += edgeNames[i];
	                    }
	                }
	
	                cursor = actionCursors[cursorKey];
	            }
	        }
	
	        return cursor;
	    }
	
	    function checkResizeEdge (name, value, page, element, interactableElement, rect, margin) {
	        // false, '', undefined, null
	        if (!value) { return false; }
	
	        // true value, use pointer coords and element rect
	        if (value === true) {
	            // if dimensions are negative, "switch" edges
	            var width = isNumber(rect.width)? rect.width : rect.right - rect.left,
	                height = isNumber(rect.height)? rect.height : rect.bottom - rect.top;
	
	            if (width < 0) {
	                if      (name === 'left' ) { name = 'right'; }
	                else if (name === 'right') { name = 'left' ; }
	            }
	            if (height < 0) {
	                if      (name === 'top'   ) { name = 'bottom'; }
	                else if (name === 'bottom') { name = 'top'   ; }
	            }
	
	            if (name === 'left'  ) { return page.x < ((width  >= 0? rect.left: rect.right ) + margin); }
	            if (name === 'top'   ) { return page.y < ((height >= 0? rect.top : rect.bottom) + margin); }
	
	            if (name === 'right' ) { return page.x > ((width  >= 0? rect.right : rect.left) - margin); }
	            if (name === 'bottom') { return page.y > ((height >= 0? rect.bottom: rect.top ) - margin); }
	        }
	
	        // the remaining checks require an element
	        if (!isElement(element)) { return false; }
	
	        return isElement(value)
	                    // the value is an element to use as a resize handle
	                    ? value === element
	                    // otherwise check if element matches value as selector
	                    : matchesUpTo(element, value, interactableElement);
	    }
	
	    function defaultActionChecker (pointer, interaction, element) {
	        var rect = this.getRect(element),
	            shouldResize = false,
	            action = null,
	            resizeAxes = null,
	            resizeEdges,
	            page = extend({}, interaction.curCoords.page),
	            options = this.options;
	
	        if (!rect) { return null; }
	
	        if (actionIsEnabled.resize && options.resize.enabled) {
	            var resizeOptions = options.resize;
	
	            resizeEdges = {
	                left: false, right: false, top: false, bottom: false
	            };
	
	            // if using resize.edges
	            if (isObject(resizeOptions.edges)) {
	                for (var edge in resizeEdges) {
	                    resizeEdges[edge] = checkResizeEdge(edge,
	                                                        resizeOptions.edges[edge],
	                                                        page,
	                                                        interaction._eventTarget,
	                                                        element,
	                                                        rect,
	                                                        resizeOptions.margin || margin);
	                }
	
	                resizeEdges.left = resizeEdges.left && !resizeEdges.right;
	                resizeEdges.top  = resizeEdges.top  && !resizeEdges.bottom;
	
	                shouldResize = resizeEdges.left || resizeEdges.right || resizeEdges.top || resizeEdges.bottom;
	            }
	            else {
	                var right  = options.resize.axis !== 'y' && page.x > (rect.right  - margin),
	                    bottom = options.resize.axis !== 'x' && page.y > (rect.bottom - margin);
	
	                shouldResize = right || bottom;
	                resizeAxes = (right? 'x' : '') + (bottom? 'y' : '');
	            }
	        }
	
	        action = shouldResize
	            ? 'resize'
	            : actionIsEnabled.drag && options.drag.enabled
	                ? 'drag'
	                : null;
	
	        if (actionIsEnabled.gesture
	            && interaction.pointerIds.length >=2
	            && !(interaction.dragging || interaction.resizing)) {
	            action = 'gesture';
	        }
	
	        if (action) {
	            return {
	                name: action,
	                axis: resizeAxes,
	                edges: resizeEdges
	            };
	        }
	
	        return null;
	    }
	
	    // Check if action is enabled globally and the current target supports it
	    // If so, return the validated action. Otherwise, return null
	    function validateAction (action, interactable) {
	        if (!isObject(action)) { return null; }
	
	        var actionName = action.name,
	            options = interactable.options;
	
	        if ((  (actionName  === 'resize'   && options.resize.enabled )
	            || (actionName      === 'drag'     && options.drag.enabled  )
	            || (actionName      === 'gesture'  && options.gesture.enabled))
	            && actionIsEnabled[actionName]) {
	
	            if (actionName === 'resize' || actionName === 'resizeyx') {
	                actionName = 'resizexy';
	            }
	
	            return action;
	        }
	        return null;
	    }
	
	    var listeners = {},
	        interactionListeners = [
	            'dragStart', 'dragMove', 'resizeStart', 'resizeMove', 'gestureStart', 'gestureMove',
	            'pointerOver', 'pointerOut', 'pointerHover', 'selectorDown',
	            'pointerDown', 'pointerMove', 'pointerUp', 'pointerCancel', 'pointerEnd',
	            'addPointer', 'removePointer', 'recordPointer', 'autoScrollMove'
	        ];
	
	    for (var i = 0, len = interactionListeners.length; i < len; i++) {
	        var name = interactionListeners[i];
	
	        listeners[name] = doOnInteractions(name);
	    }
	
	    // bound to the interactable context when a DOM event
	    // listener is added to a selector interactable
	    function delegateListener (event, useCapture) {
	        var fakeEvent = {},
	            delegated = delegatedEvents[event.type],
	            eventTarget = getActualElement(event.path
	                                           ? event.path[0]
	                                           : event.target),
	            element = eventTarget;
	
	        useCapture = useCapture? true: false;
	
	        // duplicate the event so that currentTarget can be changed
	        for (var prop in event) {
	            fakeEvent[prop] = event[prop];
	        }
	
	        fakeEvent.originalEvent = event;
	        fakeEvent.preventDefault = preventOriginalDefault;
	
	        // climb up document tree looking for selector matches
	        while (isElement(element)) {
	            for (var i = 0; i < delegated.selectors.length; i++) {
	                var selector = delegated.selectors[i],
	                    context = delegated.contexts[i];
	
	                if (matchesSelector(element, selector)
	                    && nodeContains(context, eventTarget)
	                    && nodeContains(context, element)) {
	
	                    var listeners = delegated.listeners[i];
	
	                    fakeEvent.currentTarget = element;
	
	                    for (var j = 0; j < listeners.length; j++) {
	                        if (listeners[j][1] === useCapture) {
	                            listeners[j][0](fakeEvent);
	                        }
	                    }
	                }
	            }
	
	            element = parentElement(element);
	        }
	    }
	
	    function delegateUseCapture (event) {
	        return delegateListener.call(this, event, true);
	    }
	
	    interactables.indexOfElement = function indexOfElement (element, context) {
	        context = context || document;
	
	        for (var i = 0; i < this.length; i++) {
	            var interactable = this[i];
	
	            if ((interactable.selector === element
	                && (interactable._context === context))
	                || (!interactable.selector && interactable._element === element)) {
	
	                return i;
	            }
	        }
	        return -1;
	    };
	
	    interactables.get = function interactableGet (element, options) {
	        return this[this.indexOfElement(element, options && options.context)];
	    };
	
	    interactables.forEachSelector = function (callback) {
	        for (var i = 0; i < this.length; i++) {
	            var interactable = this[i];
	
	            if (!interactable.selector) {
	                continue;
	            }
	
	            var ret = callback(interactable, interactable.selector, interactable._context, i, this);
	
	            if (ret !== undefined) {
	                return ret;
	            }
	        }
	    };
	
	    /*\
	     * interact
	     [ method ]
	     *
	     * The methods of this variable can be used to set elements as
	     * interactables and also to change various default settings.
	     *
	     * Calling it as a function and passing an element or a valid CSS selector
	     * string returns an Interactable object which has various methods to
	     * configure it.
	     *
	     - element (Element | string) The HTML or SVG Element to interact with or CSS selector
	     = (object) An @Interactable
	     *
	     > Usage
	     | interact(document.getElementById('draggable')).draggable(true);
	     |
	     | var rectables = interact('rect');
	     | rectables
	     |     .gesturable(true)
	     |     .on('gesturemove', function (event) {
	     |         // something cool...
	     |     })
	     |     .autoScroll(true);
	    \*/
	    function interact (element, options) {
	        return interactables.get(element, options) || new Interactable(element, options);
	    }
	
	    /*\
	     * Interactable
	     [ property ]
	     **
	     * Object type returned by @interact
	    \*/
	    function Interactable (element, options) {
	        this._element = element;
	        this._iEvents = this._iEvents || {};
	
	        var _window;
	
	        if (trySelector(element)) {
	            this.selector = element;
	
	            var context = options && options.context;
	
	            _window = context? getWindow(context) : window;
	
	            if (context && (_window.Node
	                    ? context instanceof _window.Node
	                    : (isElement(context) || context === _window.document))) {
	
	                this._context = context;
	            }
	        }
	        else {
	            _window = getWindow(element);
	
	            if (isElement(element, _window)) {
	
	                if (supportsPointerEvent) {
	                    events.add(this._element, pEventTypes.down, listeners.pointerDown );
	                    events.add(this._element, pEventTypes.move, listeners.pointerHover);
	                }
	                else {
	                    events.add(this._element, 'mousedown' , listeners.pointerDown );
	                    events.add(this._element, 'mousemove' , listeners.pointerHover);
	                    events.add(this._element, 'touchstart', listeners.pointerDown );
	                    events.add(this._element, 'touchmove' , listeners.pointerHover);
	                }
	            }
	        }
	
	        this._doc = _window.document;
	
	        if (!contains(documents, this._doc)) {
	            listenToDocument(this._doc);
	        }
	
	        interactables.push(this);
	
	        this.set(options);
	    }
	
	    Interactable.prototype = {
	        setOnEvents: function (action, phases) {
	            if (action === 'drop') {
	                if (isFunction(phases.ondrop)          ) { this.ondrop           = phases.ondrop          ; }
	                if (isFunction(phases.ondropactivate)  ) { this.ondropactivate   = phases.ondropactivate  ; }
	                if (isFunction(phases.ondropdeactivate)) { this.ondropdeactivate = phases.ondropdeactivate; }
	                if (isFunction(phases.ondragenter)     ) { this.ondragenter      = phases.ondragenter     ; }
	                if (isFunction(phases.ondragleave)     ) { this.ondragleave      = phases.ondragleave     ; }
	                if (isFunction(phases.ondropmove)      ) { this.ondropmove       = phases.ondropmove      ; }
	            }
	            else {
	                action = 'on' + action;
	
	                if (isFunction(phases.onstart)       ) { this[action + 'start'         ] = phases.onstart         ; }
	                if (isFunction(phases.onmove)        ) { this[action + 'move'          ] = phases.onmove          ; }
	                if (isFunction(phases.onend)         ) { this[action + 'end'           ] = phases.onend           ; }
	                if (isFunction(phases.oninertiastart)) { this[action + 'inertiastart'  ] = phases.oninertiastart  ; }
	            }
	
	            return this;
	        },
	
	        /*\
	         * Interactable.draggable
	         [ method ]
	         *
	         * Gets or sets whether drag actions can be performed on the
	         * Interactable
	         *
	         = (boolean) Indicates if this can be the target of drag events
	         | var isDraggable = interact('ul li').draggable();
	         * or
	         - options (boolean | object) #optional true/false or An object with event listeners to be fired on drag events (object makes the Interactable draggable)
	         = (object) This Interactable
	         | interact(element).draggable({
	         |     onstart: function (event) {},
	         |     onmove : function (event) {},
	         |     onend  : function (event) {},
	         |
	         |     // the axis in which the first movement must be
	         |     // for the drag sequence to start
	         |     // 'xy' by default - any direction
	         |     axis: 'x' || 'y' || 'xy',
	         |
	         |     // max number of drags that can happen concurrently
	         |     // with elements of this Interactable. Infinity by default
	         |     max: Infinity,
	         |
	         |     // max number of drags that can target the same element+Interactable
	         |     // 1 by default
	         |     maxPerElement: 2
	         | });
	        \*/
	        draggable: function (options) {
	            if (isObject(options)) {
	                this.options.drag.enabled = options.enabled === false? false: true;
	                this.setPerAction('drag', options);
	                this.setOnEvents('drag', options);
	
	                if (/^x$|^y$|^xy$/.test(options.axis)) {
	                    this.options.drag.axis = options.axis;
	                }
	                else if (options.axis === null) {
	                    delete this.options.drag.axis;
	                }
	
	                return this;
	            }
	
	            if (isBool(options)) {
	                this.options.drag.enabled = options;
	
	                return this;
	            }
	
	            return this.options.drag;
	        },
	
	        setPerAction: function (action, options) {
	            // for all the default per-action options
	            for (var option in options) {
	                // if this option exists for this action
	                if (option in defaultOptions[action]) {
	                    // if the option in the options arg is an object value
	                    if (isObject(options[option])) {
	                        // duplicate the object
	                        this.options[action][option] = extend(this.options[action][option] || {}, options[option]);
	
	                        if (isObject(defaultOptions.perAction[option]) && 'enabled' in defaultOptions.perAction[option]) {
	                            this.options[action][option].enabled = options[option].enabled === false? false : true;
	                        }
	                    }
	                    else if (isBool(options[option]) && isObject(defaultOptions.perAction[option])) {
	                        this.options[action][option].enabled = options[option];
	                    }
	                    else if (options[option] !== undefined) {
	                        // or if it's not undefined, do a plain assignment
	                        this.options[action][option] = options[option];
	                    }
	                }
	            }
	        },
	
	        /*\
	         * Interactable.dropzone
	         [ method ]
	         *
	         * Returns or sets whether elements can be dropped onto this
	         * Interactable to trigger drop events
	         *
	         * Dropzones can receive the following events:
	         *  - `dropactivate` and `dropdeactivate` when an acceptable drag starts and ends
	         *  - `dragenter` and `dragleave` when a draggable enters and leaves the dropzone
	         *  - `dragmove` when a draggable that has entered the dropzone is moved
	         *  - `drop` when a draggable is dropped into this dropzone
	         *
	         *  Use the `accept` option to allow only elements that match the given CSS selector or element.
	         *
	         *  Use the `overlap` option to set how drops are checked for. The allowed values are:
	         *   - `'pointer'`, the pointer must be over the dropzone (default)
	         *   - `'center'`, the draggable element's center must be over the dropzone
	         *   - a number from 0-1 which is the `(intersection area) / (draggable area)`.
	         *       e.g. `0.5` for drop to happen when half of the area of the
	         *       draggable is over the dropzone
	         *
	         - options (boolean | object | null) #optional The new value to be set.
	         | interact('.drop').dropzone({
	         |   accept: '.can-drop' || document.getElementById('single-drop'),
	         |   overlap: 'pointer' || 'center' || zeroToOne
	         | }
	         = (boolean | object) The current setting or this Interactable
	        \*/
	        dropzone: function (options) {
	            if (isObject(options)) {
	                this.options.drop.enabled = options.enabled === false? false: true;
	                this.setOnEvents('drop', options);
	
	                if (/^(pointer|center)$/.test(options.overlap)) {
	                    this.options.drop.overlap = options.overlap;
	                }
	                else if (isNumber(options.overlap)) {
	                    this.options.drop.overlap = Math.max(Math.min(1, options.overlap), 0);
	                }
	                if ('accept' in options) {
	                  this.options.drop.accept = options.accept;
	                }
	                if ('checker' in options) {
	                  this.options.drop.checker = options.checker;
	                }
	
	                return this;
	            }
	
	            if (isBool(options)) {
	                this.options.drop.enabled = options;
	
	                return this;
	            }
	
	            return this.options.drop;
	        },
	
	        dropCheck: function (dragEvent, event, draggable, draggableElement, dropElement, rect) {
	            var dropped = false;
	
	            // if the dropzone has no rect (eg. display: none)
	            // call the custom dropChecker or just return false
	            if (!(rect = rect || this.getRect(dropElement))) {
	                return (this.options.drop.checker
	                    ? this.options.drop.checker(dragEvent, event, dropped, this, dropElement, draggable, draggableElement)
	                    : false);
	            }
	
	            var dropOverlap = this.options.drop.overlap;
	
	            if (dropOverlap === 'pointer') {
	                var page = getPageXY(dragEvent),
	                    origin = getOriginXY(draggable, draggableElement),
	                    horizontal,
	                    vertical;
	
	                page.x += origin.x;
	                page.y += origin.y;
	
	                horizontal = (page.x > rect.left) && (page.x < rect.right);
	                vertical   = (page.y > rect.top ) && (page.y < rect.bottom);
	
	                dropped = horizontal && vertical;
	            }
	
	            var dragRect = draggable.getRect(draggableElement);
	
	            if (dropOverlap === 'center') {
	                var cx = dragRect.left + dragRect.width  / 2,
	                    cy = dragRect.top  + dragRect.height / 2;
	
	                dropped = cx >= rect.left && cx <= rect.right && cy >= rect.top && cy <= rect.bottom;
	            }
	
	            if (isNumber(dropOverlap)) {
	                var overlapArea  = (Math.max(0, Math.min(rect.right , dragRect.right ) - Math.max(rect.left, dragRect.left))
	                                  * Math.max(0, Math.min(rect.bottom, dragRect.bottom) - Math.max(rect.top , dragRect.top ))),
	                    overlapRatio = overlapArea / (dragRect.width * dragRect.height);
	
	                dropped = overlapRatio >= dropOverlap;
	            }
	
	            if (this.options.drop.checker) {
	                dropped = this.options.drop.checker(dragEvent, event, dropped, this, dropElement, draggable, draggableElement);
	            }
	
	            return dropped;
	        },
	
	        /*\
	         * Interactable.dropChecker
	         [ method ]
	         *
	         * DEPRECATED. Use interactable.dropzone({ checker: function... }) instead.
	         *
	         * Gets or sets the function used to check if a dragged element is
	         * over this Interactable.
	         *
	         - checker (function) #optional The function that will be called when checking for a drop
	         = (Function | Interactable) The checker function or this Interactable
	         *
	         * The checker function takes the following arguments:
	         *
	         - dragEvent (InteractEvent) The related dragmove or dragend event
	         - event (TouchEvent | PointerEvent | MouseEvent) The user move/up/end Event related to the dragEvent
	         - dropped (boolean) The value from the default drop checker
	         - dropzone (Interactable) The dropzone interactable
	         - dropElement (Element) The dropzone element
	         - draggable (Interactable) The Interactable being dragged
	         - draggableElement (Element) The actual element that's being dragged
	         *
	         > Usage:
	         | interact(target)
	         | .dropChecker(function(dragEvent,         // related dragmove or dragend event
	         |                       event,             // TouchEvent/PointerEvent/MouseEvent
	         |                       dropped,           // bool result of the default checker
	         |                       dropzone,          // dropzone Interactable
	         |                       dropElement,       // dropzone elemnt
	         |                       draggable,         // draggable Interactable
	         |                       draggableElement) {// draggable element
	         |
	         |   return dropped && event.target.hasAttribute('allow-drop');
	         | }
	        \*/
	        dropChecker: function (checker) {
	            if (isFunction(checker)) {
	                this.options.drop.checker = checker;
	
	                return this;
	            }
	            if (checker === null) {
	                delete this.options.getRect;
	
	                return this;
	            }
	
	            return this.options.drop.checker;
	        },
	
	        /*\
	         * Interactable.accept
	         [ method ]
	         *
	         * Deprecated. add an `accept` property to the options object passed to
	         * @Interactable.dropzone instead.
	         *
	         * Gets or sets the Element or CSS selector match that this
	         * Interactable accepts if it is a dropzone.
	         *
	         - newValue (Element | string | null) #optional
	         * If it is an Element, then only that element can be dropped into this dropzone.
	         * If it is a string, the element being dragged must match it as a selector.
	         * If it is null, the accept options is cleared - it accepts any element.
	         *
	         = (string | Element | null | Interactable) The current accept option if given `undefined` or this Interactable
	        \*/
	        accept: function (newValue) {
	            if (isElement(newValue)) {
	                this.options.drop.accept = newValue;
	
	                return this;
	            }
	
	            // test if it is a valid CSS selector
	            if (trySelector(newValue)) {
	                this.options.drop.accept = newValue;
	
	                return this;
	            }
	
	            if (newValue === null) {
	                delete this.options.drop.accept;
	
	                return this;
	            }
	
	            return this.options.drop.accept;
	        },
	
	        /*\
	         * Interactable.resizable
	         [ method ]
	         *
	         * Gets or sets whether resize actions can be performed on the
	         * Interactable
	         *
	         = (boolean) Indicates if this can be the target of resize elements
	         | var isResizeable = interact('input[type=text]').resizable();
	         * or
	         - options (boolean | object) #optional true/false or An object with event listeners to be fired on resize events (object makes the Interactable resizable)
	         = (object) This Interactable
	         | interact(element).resizable({
	         |     onstart: function (event) {},
	         |     onmove : function (event) {},
	         |     onend  : function (event) {},
	         |
	         |     edges: {
	         |       top   : true,       // Use pointer coords to check for resize.
	         |       left  : false,      // Disable resizing from left edge.
	         |       bottom: '.resize-s',// Resize if pointer target matches selector
	         |       right : handleEl    // Resize if pointer target is the given Element
	         |     },
	         |
	         |     // Width and height can be adjusted independently. When `true`, width and
	         |     // height are adjusted at a 1:1 ratio.
	         |     square: false,
	         |
	         |     // Width and height can be adjusted independently. When `true`, width and
	         |     // height maintain the aspect ratio they had when resizing started.
	         |     preserveAspectRatio: false,
	         |
	         |     // a value of 'none' will limit the resize rect to a minimum of 0x0
	         |     // 'negate' will allow the rect to have negative width/height
	         |     // 'reposition' will keep the width/height positive by swapping
	         |     // the top and bottom edges and/or swapping the left and right edges
	         |     invert: 'none' || 'negate' || 'reposition'
	         |
	         |     // limit multiple resizes.
	         |     // See the explanation in the @Interactable.draggable example
	         |     max: Infinity,
	         |     maxPerElement: 1,
	         | });
	        \*/
	        resizable: function (options) {
	            if (isObject(options)) {
	                this.options.resize.enabled = options.enabled === false? false: true;
	                this.setPerAction('resize', options);
	                this.setOnEvents('resize', options);
	
	                if (/^x$|^y$|^xy$/.test(options.axis)) {
	                    this.options.resize.axis = options.axis;
	                }
	                else if (options.axis === null) {
	                    this.options.resize.axis = defaultOptions.resize.axis;
	                }
	
	                if (isBool(options.preserveAspectRatio)) {
	                    this.options.resize.preserveAspectRatio = options.preserveAspectRatio;
	                }
	                else if (isBool(options.square)) {
	                    this.options.resize.square = options.square;
	                }
	
	                return this;
	            }
	            if (isBool(options)) {
	                this.options.resize.enabled = options;
	
	                return this;
	            }
	            return this.options.resize;
	        },
	
	        /*\
	         * Interactable.squareResize
	         [ method ]
	         *
	         * Deprecated. Add a `square: true || false` property to @Interactable.resizable instead
	         *
	         * Gets or sets whether resizing is forced 1:1 aspect
	         *
	         = (boolean) Current setting
	         *
	         * or
	         *
	         - newValue (boolean) #optional
	         = (object) this Interactable
	        \*/
	        squareResize: function (newValue) {
	            if (isBool(newValue)) {
	                this.options.resize.square = newValue;
	
	                return this;
	            }
	
	            if (newValue === null) {
	                delete this.options.resize.square;
	
	                return this;
	            }
	
	            return this.options.resize.square;
	        },
	
	        /*\
	         * Interactable.gesturable
	         [ method ]
	         *
	         * Gets or sets whether multitouch gestures can be performed on the
	         * Interactable's element
	         *
	         = (boolean) Indicates if this can be the target of gesture events
	         | var isGestureable = interact(element).gesturable();
	         * or
	         - options (boolean | object) #optional true/false or An object with event listeners to be fired on gesture events (makes the Interactable gesturable)
	         = (object) this Interactable
	         | interact(element).gesturable({
	         |     onstart: function (event) {},
	         |     onmove : function (event) {},
	         |     onend  : function (event) {},
	         |
	         |     // limit multiple gestures.
	         |     // See the explanation in @Interactable.draggable example
	         |     max: Infinity,
	         |     maxPerElement: 1,
	         | });
	        \*/
	        gesturable: function (options) {
	            if (isObject(options)) {
	                this.options.gesture.enabled = options.enabled === false? false: true;
	                this.setPerAction('gesture', options);
	                this.setOnEvents('gesture', options);
	
	                return this;
	            }
	
	            if (isBool(options)) {
	                this.options.gesture.enabled = options;
	
	                return this;
	            }
	
	            return this.options.gesture;
	        },
	
	        /*\
	         * Interactable.autoScroll
	         [ method ]
	         **
	         * Deprecated. Add an `autoscroll` property to the options object
	         * passed to @Interactable.draggable or @Interactable.resizable instead.
	         *
	         * Returns or sets whether dragging and resizing near the edges of the
	         * window/container trigger autoScroll for this Interactable
	         *
	         = (object) Object with autoScroll properties
	         *
	         * or
	         *
	         - options (object | boolean) #optional
	         * options can be:
	         * - an object with margin, distance and interval properties,
	         * - true or false to enable or disable autoScroll or
	         = (Interactable) this Interactable
	        \*/
	        autoScroll: function (options) {
	            if (isObject(options)) {
	                options = extend({ actions: ['drag', 'resize']}, options);
	            }
	            else if (isBool(options)) {
	                options = { actions: ['drag', 'resize'], enabled: options };
	            }
	
	            return this.setOptions('autoScroll', options);
	        },
	
	        /*\
	         * Interactable.snap
	         [ method ]
	         **
	         * Deprecated. Add a `snap` property to the options object passed
	         * to @Interactable.draggable or @Interactable.resizable instead.
	         *
	         * Returns or sets if and how action coordinates are snapped. By
	         * default, snapping is relative to the pointer coordinates. You can
	         * change this by setting the
	         * [`elementOrigin`](https://github.com/taye/interact.js/pull/72).
	         **
	         = (boolean | object) `false` if snap is disabled; object with snap properties if snap is enabled
	         **
	         * or
	         **
	         - options (object | boolean | null) #optional
	         = (Interactable) this Interactable
	         > Usage
	         | interact(document.querySelector('#thing')).snap({
	         |     targets: [
	         |         // snap to this specific point
	         |         {
	         |             x: 100,
	         |             y: 100,
	         |             range: 25
	         |         },
	         |         // give this function the x and y page coords and snap to the object returned
	         |         function (x, y) {
	         |             return {
	         |                 x: x,
	         |                 y: (75 + 50 * Math.sin(x * 0.04)),
	         |                 range: 40
	         |             };
	         |         },
	         |         // create a function that snaps to a grid
	         |         interact.createSnapGrid({
	         |             x: 50,
	         |             y: 50,
	         |             range: 10,              // optional
	         |             offset: { x: 5, y: 10 } // optional
	         |         })
	         |     ],
	         |     // do not snap during normal movement.
	         |     // Instead, trigger only one snapped move event
	         |     // immediately before the end event.
	         |     endOnly: true,
	         |
	         |     relativePoints: [
	         |         { x: 0, y: 0 },  // snap relative to the top left of the element
	         |         { x: 1, y: 1 },  // and also to the bottom right
	         |     ],  
	         |
	         |     // offset the snap target coordinates
	         |     // can be an object with x/y or 'startCoords'
	         |     offset: { x: 50, y: 50 }
	         |   }
	         | });
	        \*/
	        snap: function (options) {
	            var ret = this.setOptions('snap', options);
	
	            if (ret === this) { return this; }
	
	            return ret.drag;
	        },
	
	        setOptions: function (option, options) {
	            var actions = options && isArray(options.actions)
	                    ? options.actions
	                    : ['drag'];
	
	            var i;
	
	            if (isObject(options) || isBool(options)) {
	                for (i = 0; i < actions.length; i++) {
	                    var action = /resize/.test(actions[i])? 'resize' : actions[i];
	
	                    if (!isObject(this.options[action])) { continue; }
	
	                    var thisOption = this.options[action][option];
	
	                    if (isObject(options)) {
	                        extend(thisOption, options);
	                        thisOption.enabled = options.enabled === false? false: true;
	
	                        if (option === 'snap') {
	                            if (thisOption.mode === 'grid') {
	                                thisOption.targets = [
	                                    interact.createSnapGrid(extend({
	                                        offset: thisOption.gridOffset || { x: 0, y: 0 }
	                                    }, thisOption.grid || {}))
	                                ];
	                            }
	                            else if (thisOption.mode === 'anchor') {
	                                thisOption.targets = thisOption.anchors;
	                            }
	                            else if (thisOption.mode === 'path') {
	                                thisOption.targets = thisOption.paths;
	                            }
	
	                            if ('elementOrigin' in options) {
	                                thisOption.relativePoints = [options.elementOrigin];
	                            }
	                        }
	                    }
	                    else if (isBool(options)) {
	                        thisOption.enabled = options;
	                    }
	                }
	
	                return this;
	            }
	
	            var ret = {},
	                allActions = ['drag', 'resize', 'gesture'];
	
	            for (i = 0; i < allActions.length; i++) {
	                if (option in defaultOptions[allActions[i]]) {
	                    ret[allActions[i]] = this.options[allActions[i]][option];
	                }
	            }
	
	            return ret;
	        },
	
	
	        /*\
	         * Interactable.inertia
	         [ method ]
	         **
	         * Deprecated. Add an `inertia` property to the options object passed
	         * to @Interactable.draggable or @Interactable.resizable instead.
	         *
	         * Returns or sets if and how events continue to run after the pointer is released
	         **
	         = (boolean | object) `false` if inertia is disabled; `object` with inertia properties if inertia is enabled
	         **
	         * or
	         **
	         - options (object | boolean | null) #optional
	         = (Interactable) this Interactable
	         > Usage
	         | // enable and use default settings
	         | interact(element).inertia(true);
	         |
	         | // enable and use custom settings
	         | interact(element).inertia({
	         |     // value greater than 0
	         |     // high values slow the object down more quickly
	         |     resistance     : 16,
	         |
	         |     // the minimum launch speed (pixels per second) that results in inertia start
	         |     minSpeed       : 200,
	         |
	         |     // inertia will stop when the object slows down to this speed
	         |     endSpeed       : 20,
	         |
	         |     // boolean; should actions be resumed when the pointer goes down during inertia
	         |     allowResume    : true,
	         |
	         |     // boolean; should the jump when resuming from inertia be ignored in event.dx/dy
	         |     zeroResumeDelta: false,
	         |
	         |     // if snap/restrict are set to be endOnly and inertia is enabled, releasing
	         |     // the pointer without triggering inertia will animate from the release
	         |     // point to the snaped/restricted point in the given amount of time (ms)
	         |     smoothEndDuration: 300,
	         |
	         |     // an array of action types that can have inertia (no gesture)
	         |     actions        : ['drag', 'resize']
	         | });
	         |
	         | // reset custom settings and use all defaults
	         | interact(element).inertia(null);
	        \*/
	        inertia: function (options) {
	            var ret = this.setOptions('inertia', options);
	
	            if (ret === this) { return this; }
	
	            return ret.drag;
	        },
	
	        getAction: function (pointer, event, interaction, element) {
	            var action = this.defaultActionChecker(pointer, interaction, element);
	
	            if (this.options.actionChecker) {
	                return this.options.actionChecker(pointer, event, action, this, element, interaction);
	            }
	
	            return action;
	        },
	
	        defaultActionChecker: defaultActionChecker,
	
	        /*\
	         * Interactable.actionChecker
	         [ method ]
	         *
	         * Gets or sets the function used to check action to be performed on
	         * pointerDown
	         *
	         - checker (function | null) #optional A function which takes a pointer event, defaultAction string, interactable, element and interaction as parameters and returns an object with name property 'drag' 'resize' or 'gesture' and optionally an `edges` object with boolean 'top', 'left', 'bottom' and right props.
	         = (Function | Interactable) The checker function or this Interactable
	         *
	         | interact('.resize-drag')
	         |   .resizable(true)
	         |   .draggable(true)
	         |   .actionChecker(function (pointer, event, action, interactable, element, interaction) {
	         |
	         |   if (interact.matchesSelector(event.target, '.drag-handle') {
	         |     // force drag with handle target
	         |     action.name = drag;
	         |   }
	         |   else {
	         |     // resize from the top and right edges
	         |     action.name  = 'resize';
	         |     action.edges = { top: true, right: true };
	         |   }
	         |
	         |   return action;
	         | });
	        \*/
	        actionChecker: function (checker) {
	            if (isFunction(checker)) {
	                this.options.actionChecker = checker;
	
	                return this;
	            }
	
	            if (checker === null) {
	                delete this.options.actionChecker;
	
	                return this;
	            }
	
	            return this.options.actionChecker;
	        },
	
	        /*\
	         * Interactable.getRect
	         [ method ]
	         *
	         * The default function to get an Interactables bounding rect. Can be
	         * overridden using @Interactable.rectChecker.
	         *
	         - element (Element) #optional The element to measure.
	         = (object) The object's bounding rectangle.
	         o {
	         o     top   : 0,
	         o     left  : 0,
	         o     bottom: 0,
	         o     right : 0,
	         o     width : 0,
	         o     height: 0
	         o }
	        \*/
	        getRect: function rectCheck (element) {
	            element = element || this._element;
	
	            if (this.selector && !(isElement(element))) {
	                element = this._context.querySelector(this.selector);
	            }
	
	            return getElementRect(element);
	        },
	
	        /*\
	         * Interactable.rectChecker
	         [ method ]
	         *
	         * Returns or sets the function used to calculate the interactable's
	         * element's rectangle
	         *
	         - checker (function) #optional A function which returns this Interactable's bounding rectangle. See @Interactable.getRect
	         = (function | object) The checker function or this Interactable
	        \*/
	        rectChecker: function (checker) {
	            if (isFunction(checker)) {
	                this.getRect = checker;
	
	                return this;
	            }
	
	            if (checker === null) {
	                delete this.options.getRect;
	
	                return this;
	            }
	
	            return this.getRect;
	        },
	
	        /*\
	         * Interactable.styleCursor
	         [ method ]
	         *
	         * Returns or sets whether the action that would be performed when the
	         * mouse on the element are checked on `mousemove` so that the cursor
	         * may be styled appropriately
	         *
	         - newValue (boolean) #optional
	         = (boolean | Interactable) The current setting or this Interactable
	        \*/
	        styleCursor: function (newValue) {
	            if (isBool(newValue)) {
	                this.options.styleCursor = newValue;
	
	                return this;
	            }
	
	            if (newValue === null) {
	                delete this.options.styleCursor;
	
	                return this;
	            }
	
	            return this.options.styleCursor;
	        },
	
	        /*\
	         * Interactable.preventDefault
	         [ method ]
	         *
	         * Returns or sets whether to prevent the browser's default behaviour
	         * in response to pointer events. Can be set to:
	         *  - `'always'` to always prevent
	         *  - `'never'` to never prevent
	         *  - `'auto'` to let interact.js try to determine what would be best
	         *
	         - newValue (string) #optional `true`, `false` or `'auto'`
	         = (string | Interactable) The current setting or this Interactable
	        \*/
	        preventDefault: function (newValue) {
	            if (/^(always|never|auto)$/.test(newValue)) {
	                this.options.preventDefault = newValue;
	                return this;
	            }
	
	            if (isBool(newValue)) {
	                this.options.preventDefault = newValue? 'always' : 'never';
	                return this;
	            }
	
	            return this.options.preventDefault;
	        },
	
	        /*\
	         * Interactable.origin
	         [ method ]
	         *
	         * Gets or sets the origin of the Interactable's element.  The x and y
	         * of the origin will be subtracted from action event coordinates.
	         *
	         - origin (object | string) #optional An object eg. { x: 0, y: 0 } or string 'parent', 'self' or any CSS selector
	         * OR
	         - origin (Element) #optional An HTML or SVG Element whose rect will be used
	         **
	         = (object) The current origin or this Interactable
	        \*/
	        origin: function (newValue) {
	            if (trySelector(newValue)) {
	                this.options.origin = newValue;
	                return this;
	            }
	            else if (isObject(newValue)) {
	                this.options.origin = newValue;
	                return this;
	            }
	
	            return this.options.origin;
	        },
	
	        /*\
	         * Interactable.deltaSource
	         [ method ]
	         *
	         * Returns or sets the mouse coordinate types used to calculate the
	         * movement of the pointer.
	         *
	         - newValue (string) #optional Use 'client' if you will be scrolling while interacting; Use 'page' if you want autoScroll to work
	         = (string | object) The current deltaSource or this Interactable
	        \*/
	        deltaSource: function (newValue) {
	            if (newValue === 'page' || newValue === 'client') {
	                this.options.deltaSource = newValue;
	
	                return this;
	            }
	
	            return this.options.deltaSource;
	        },
	
	        /*\
	         * Interactable.restrict
	         [ method ]
	         **
	         * Deprecated. Add a `restrict` property to the options object passed to
	         * @Interactable.draggable, @Interactable.resizable or @Interactable.gesturable instead.
	         *
	         * Returns or sets the rectangles within which actions on this
	         * interactable (after snap calculations) are restricted. By default,
	         * restricting is relative to the pointer coordinates. You can change
	         * this by setting the
	         * [`elementRect`](https://github.com/taye/interact.js/pull/72).
	         **
	         - options (object) #optional an object with keys drag, resize, and/or gesture whose values are rects, Elements, CSS selectors, or 'parent' or 'self'
	         = (object) The current restrictions object or this Interactable
	         **
	         | interact(element).restrict({
	         |     // the rect will be `interact.getElementRect(element.parentNode)`
	         |     drag: element.parentNode,
	         |
	         |     // x and y are relative to the the interactable's origin
	         |     resize: { x: 100, y: 100, width: 200, height: 200 }
	         | })
	         |
	         | interact('.draggable').restrict({
	         |     // the rect will be the selected element's parent
	         |     drag: 'parent',
	         |
	         |     // do not restrict during normal movement.
	         |     // Instead, trigger only one restricted move event
	         |     // immediately before the end event.
	         |     endOnly: true,
	         |
	         |     // https://github.com/taye/interact.js/pull/72#issue-41813493
	         |     elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
	         | });
	        \*/
	        restrict: function (options) {
	            if (!isObject(options)) {
	                return this.setOptions('restrict', options);
	            }
	
	            var actions = ['drag', 'resize', 'gesture'],
	                ret;
	
	            for (var i = 0; i < actions.length; i++) {
	                var action = actions[i];
	
	                if (action in options) {
	                    var perAction = extend({
	                            actions: [action],
	                            restriction: options[action]
	                        }, options);
	
	                    ret = this.setOptions('restrict', perAction);
	                }
	            }
	
	            return ret;
	        },
	
	        /*\
	         * Interactable.context
	         [ method ]
	         *
	         * Gets the selector context Node of the Interactable. The default is `window.document`.
	         *
	         = (Node) The context Node of this Interactable
	         **
	        \*/
	        context: function () {
	            return this._context;
	        },
	
	        _context: document,
	
	        /*\
	         * Interactable.ignoreFrom
	         [ method ]
	         *
	         * If the target of the `mousedown`, `pointerdown` or `touchstart`
	         * event or any of it's parents match the given CSS selector or
	         * Element, no drag/resize/gesture is started.
	         *
	         - newValue (string | Element | null) #optional a CSS selector string, an Element or `null` to not ignore any elements
	         = (string | Element | object) The current ignoreFrom value or this Interactable
	         **
	         | interact(element, { ignoreFrom: document.getElementById('no-action') });
	         | // or
	         | interact(element).ignoreFrom('input, textarea, a');
	        \*/
	        ignoreFrom: function (newValue) {
	            if (trySelector(newValue)) {            // CSS selector to match event.target
	                this.options.ignoreFrom = newValue;
	                return this;
	            }
	
	            if (isElement(newValue)) {              // specific element
	                this.options.ignoreFrom = newValue;
	                return this;
	            }
	
	            return this.options.ignoreFrom;
	        },
	
	        /*\
	         * Interactable.allowFrom
	         [ method ]
	         *
	         * A drag/resize/gesture is started only If the target of the
	         * `mousedown`, `pointerdown` or `touchstart` event or any of it's
	         * parents match the given CSS selector or Element.
	         *
	         - newValue (string | Element | null) #optional a CSS selector string, an Element or `null` to allow from any element
	         = (string | Element | object) The current allowFrom value or this Interactable
	         **
	         | interact(element, { allowFrom: document.getElementById('drag-handle') });
	         | // or
	         | interact(element).allowFrom('.handle');
	        \*/
	        allowFrom: function (newValue) {
	            if (trySelector(newValue)) {            // CSS selector to match event.target
	                this.options.allowFrom = newValue;
	                return this;
	            }
	
	            if (isElement(newValue)) {              // specific element
	                this.options.allowFrom = newValue;
	                return this;
	            }
	
	            return this.options.allowFrom;
	        },
	
	        /*\
	         * Interactable.element
	         [ method ]
	         *
	         * If this is not a selector Interactable, it returns the element this
	         * interactable represents
	         *
	         = (Element) HTML / SVG Element
	        \*/
	        element: function () {
	            return this._element;
	        },
	
	        /*\
	         * Interactable.fire
	         [ method ]
	         *
	         * Calls listeners for the given InteractEvent type bound globally
	         * and directly to this Interactable
	         *
	         - iEvent (InteractEvent) The InteractEvent object to be fired on this Interactable
	         = (Interactable) this Interactable
	        \*/
	        fire: function (iEvent) {
	            if (!(iEvent && iEvent.type) || !contains(eventTypes, iEvent.type)) {
	                return this;
	            }
	
	            var listeners,
	                i,
	                len,
	                onEvent = 'on' + iEvent.type,
	                funcName = '';
	
	            // Interactable#on() listeners
	            if (iEvent.type in this._iEvents) {
	                listeners = this._iEvents[iEvent.type];
	
	                for (i = 0, len = listeners.length; i < len && !iEvent.immediatePropagationStopped; i++) {
	                    funcName = listeners[i].name;
	                    listeners[i](iEvent);
	                }
	            }
	
	            // interactable.onevent listener
	            if (isFunction(this[onEvent])) {
	                funcName = this[onEvent].name;
	                this[onEvent](iEvent);
	            }
	
	            // interact.on() listeners
	            if (iEvent.type in globalEvents && (listeners = globalEvents[iEvent.type]))  {
	
	                for (i = 0, len = listeners.length; i < len && !iEvent.immediatePropagationStopped; i++) {
	                    funcName = listeners[i].name;
	                    listeners[i](iEvent);
	                }
	            }
	
	            return this;
	        },
	
	        /*\
	         * Interactable.on
	         [ method ]
	         *
	         * Binds a listener for an InteractEvent or DOM event.
	         *
	         - eventType  (string | array | object) The types of events to listen for
	         - listener   (function) The function to be called on the given event(s)
	         - useCapture (boolean) #optional useCapture flag for addEventListener
	         = (object) This Interactable
	        \*/
	        on: function (eventType, listener, useCapture) {
	            var i;
	
	            if (isString(eventType) && eventType.search(' ') !== -1) {
	                eventType = eventType.trim().split(/ +/);
	            }
	
	            if (isArray(eventType)) {
	                for (i = 0; i < eventType.length; i++) {
	                    this.on(eventType[i], listener, useCapture);
	                }
	
	                return this;
	            }
	
	            if (isObject(eventType)) {
	                for (var prop in eventType) {
	                    this.on(prop, eventType[prop], listener);
	                }
	
	                return this;
	            }
	
	            if (eventType === 'wheel') {
	                eventType = wheelEvent;
	            }
	
	            // convert to boolean
	            useCapture = useCapture? true: false;
	
	            if (contains(eventTypes, eventType)) {
	                // if this type of event was never bound to this Interactable
	                if (!(eventType in this._iEvents)) {
	                    this._iEvents[eventType] = [listener];
	                }
	                else {
	                    this._iEvents[eventType].push(listener);
	                }
	            }
	            // delegated event for selector
	            else if (this.selector) {
	                if (!delegatedEvents[eventType]) {
	                    delegatedEvents[eventType] = {
	                        selectors: [],
	                        contexts : [],
	                        listeners: []
	                    };
	
	                    // add delegate listener functions
	                    for (i = 0; i < documents.length; i++) {
	                        events.add(documents[i], eventType, delegateListener);
	                        events.add(documents[i], eventType, delegateUseCapture, true);
	                    }
	                }
	
	                var delegated = delegatedEvents[eventType],
	                    index;
	
	                for (index = delegated.selectors.length - 1; index >= 0; index--) {
	                    if (delegated.selectors[index] === this.selector
	                        && delegated.contexts[index] === this._context) {
	                        break;
	                    }
	                }
	
	                if (index === -1) {
	                    index = delegated.selectors.length;
	
	                    delegated.selectors.push(this.selector);
	                    delegated.contexts .push(this._context);
	                    delegated.listeners.push([]);
	                }
	
	                // keep listener and useCapture flag
	                delegated.listeners[index].push([listener, useCapture]);
	            }
	            else {
	                events.add(this._element, eventType, listener, useCapture);
	            }
	
	            return this;
	        },
	
	        /*\
	         * Interactable.off
	         [ method ]
	         *
	         * Removes an InteractEvent or DOM event listener
	         *
	         - eventType  (string | array | object) The types of events that were listened for
	         - listener   (function) The listener function to be removed
	         - useCapture (boolean) #optional useCapture flag for removeEventListener
	         = (object) This Interactable
	        \*/
	        off: function (eventType, listener, useCapture) {
	            var i;
	
	            if (isString(eventType) && eventType.search(' ') !== -1) {
	                eventType = eventType.trim().split(/ +/);
	            }
	
	            if (isArray(eventType)) {
	                for (i = 0; i < eventType.length; i++) {
	                    this.off(eventType[i], listener, useCapture);
	                }
	
	                return this;
	            }
	
	            if (isObject(eventType)) {
	                for (var prop in eventType) {
	                    this.off(prop, eventType[prop], listener);
	                }
	
	                return this;
	            }
	
	            var eventList,
	                index = -1;
	
	            // convert to boolean
	            useCapture = useCapture? true: false;
	
	            if (eventType === 'wheel') {
	                eventType = wheelEvent;
	            }
	
	            // if it is an action event type
	            if (contains(eventTypes, eventType)) {
	                eventList = this._iEvents[eventType];
	
	                if (eventList && (index = indexOf(eventList, listener)) !== -1) {
	                    this._iEvents[eventType].splice(index, 1);
	                }
	            }
	            // delegated event
	            else if (this.selector) {
	                var delegated = delegatedEvents[eventType],
	                    matchFound = false;
	
	                if (!delegated) { return this; }
	
	                // count from last index of delegated to 0
	                for (index = delegated.selectors.length - 1; index >= 0; index--) {
	                    // look for matching selector and context Node
	                    if (delegated.selectors[index] === this.selector
	                        && delegated.contexts[index] === this._context) {
	
	                        var listeners = delegated.listeners[index];
	
	                        // each item of the listeners array is an array: [function, useCaptureFlag]
	                        for (i = listeners.length - 1; i >= 0; i--) {
	                            var fn = listeners[i][0],
	                                useCap = listeners[i][1];
	
	                            // check if the listener functions and useCapture flags match
	                            if (fn === listener && useCap === useCapture) {
	                                // remove the listener from the array of listeners
	                                listeners.splice(i, 1);
	
	                                // if all listeners for this interactable have been removed
	                                // remove the interactable from the delegated arrays
	                                if (!listeners.length) {
	                                    delegated.selectors.splice(index, 1);
	                                    delegated.contexts .splice(index, 1);
	                                    delegated.listeners.splice(index, 1);
	
	                                    // remove delegate function from context
	                                    events.remove(this._context, eventType, delegateListener);
	                                    events.remove(this._context, eventType, delegateUseCapture, true);
	
	                                    // remove the arrays if they are empty
	                                    if (!delegated.selectors.length) {
	                                        delegatedEvents[eventType] = null;
	                                    }
	                                }
	
	                                // only remove one listener
	                                matchFound = true;
	                                break;
	                            }
	                        }
	
	                        if (matchFound) { break; }
	                    }
	                }
	            }
	            // remove listener from this Interatable's element
	            else {
	                events.remove(this._element, eventType, listener, useCapture);
	            }
	
	            return this;
	        },
	
	        /*\
	         * Interactable.set
	         [ method ]
	         *
	         * Reset the options of this Interactable
	         - options (object) The new settings to apply
	         = (object) This Interactable
	        \*/
	        set: function (options) {
	            if (!isObject(options)) {
	                options = {};
	            }
	
	            this.options = extend({}, defaultOptions.base);
	
	            var i,
	                actions = ['drag', 'drop', 'resize', 'gesture'],
	                methods = ['draggable', 'dropzone', 'resizable', 'gesturable'],
	                perActions = extend(extend({}, defaultOptions.perAction), options[action] || {});
	
	            for (i = 0; i < actions.length; i++) {
	                var action = actions[i];
	
	                this.options[action] = extend({}, defaultOptions[action]);
	
	                this.setPerAction(action, perActions);
	
	                this[methods[i]](options[action]);
	            }
	
	            var settings = [
	                    'accept', 'actionChecker', 'allowFrom', 'deltaSource',
	                    'dropChecker', 'ignoreFrom', 'origin', 'preventDefault',
	                    'rectChecker', 'styleCursor'
	                ];
	
	            for (i = 0, len = settings.length; i < len; i++) {
	                var setting = settings[i];
	
	                this.options[setting] = defaultOptions.base[setting];
	
	                if (setting in options) {
	                    this[setting](options[setting]);
	                }
	            }
	
	            return this;
	        },
	
	        /*\
	         * Interactable.unset
	         [ method ]
	         *
	         * Remove this interactable from the list of interactables and remove
	         * it's drag, drop, resize and gesture capabilities
	         *
	         = (object) @interact
	        \*/
	        unset: function () {
	            events.remove(this._element, 'all');
	
	            if (!isString(this.selector)) {
	                events.remove(this, 'all');
	                if (this.options.styleCursor) {
	                    this._element.style.cursor = '';
	                }
	            }
	            else {
	                // remove delegated events
	                for (var type in delegatedEvents) {
	                    var delegated = delegatedEvents[type];
	
	                    for (var i = 0; i < delegated.selectors.length; i++) {
	                        if (delegated.selectors[i] === this.selector
	                            && delegated.contexts[i] === this._context) {
	
	                            delegated.selectors.splice(i, 1);
	                            delegated.contexts .splice(i, 1);
	                            delegated.listeners.splice(i, 1);
	
	                            // remove the arrays if they are empty
	                            if (!delegated.selectors.length) {
	                                delegatedEvents[type] = null;
	                            }
	                        }
	
	                        events.remove(this._context, type, delegateListener);
	                        events.remove(this._context, type, delegateUseCapture, true);
	
	                        break;
	                    }
	                }
	            }
	
	            this.dropzone(false);
	
	            interactables.splice(indexOf(interactables, this), 1);
	
	            return interact;
	        }
	    };
	
	    function warnOnce (method, message) {
	        var warned = false;
	
	        return function () {
	            if (!warned) {
	                window.console.warn(message);
	                warned = true;
	            }
	
	            return method.apply(this, arguments);
	        };
	    }
	
	    Interactable.prototype.snap = warnOnce(Interactable.prototype.snap,
	         'Interactable#snap is deprecated. See the new documentation for snapping at http://interactjs.io/docs/snapping');
	    Interactable.prototype.restrict = warnOnce(Interactable.prototype.restrict,
	         'Interactable#restrict is deprecated. See the new documentation for resticting at http://interactjs.io/docs/restriction');
	    Interactable.prototype.inertia = warnOnce(Interactable.prototype.inertia,
	         'Interactable#inertia is deprecated. See the new documentation for inertia at http://interactjs.io/docs/inertia');
	    Interactable.prototype.autoScroll = warnOnce(Interactable.prototype.autoScroll,
	         'Interactable#autoScroll is deprecated. See the new documentation for autoScroll at http://interactjs.io/docs/#autoscroll');
	    Interactable.prototype.squareResize = warnOnce(Interactable.prototype.squareResize,
	         'Interactable#squareResize is deprecated. See http://interactjs.io/docs/#resize-square');
	
	    Interactable.prototype.accept = warnOnce(Interactable.prototype.accept,
	         'Interactable#accept is deprecated. use Interactable#dropzone({ accept: target }) instead');
	    Interactable.prototype.dropChecker = warnOnce(Interactable.prototype.dropChecker,
	         'Interactable#dropChecker is deprecated. use Interactable#dropzone({ dropChecker: checkerFunction }) instead');
	    Interactable.prototype.context = warnOnce(Interactable.prototype.context,
	         'Interactable#context as a method is deprecated. It will soon be a DOM Node instead');
	
	    /*\
	     * interact.isSet
	     [ method ]
	     *
	     * Check if an element has been set
	     - element (Element) The Element being searched for
	     = (boolean) Indicates if the element or CSS selector was previously passed to interact
	    \*/
	    interact.isSet = function(element, options) {
	        return interactables.indexOfElement(element, options && options.context) !== -1;
	    };
	
	    /*\
	     * interact.on
	     [ method ]
	     *
	     * Adds a global listener for an InteractEvent or adds a DOM event to
	     * `document`
	     *
	     - type       (string | array | object) The types of events to listen for
	     - listener   (function) The function to be called on the given event(s)
	     - useCapture (boolean) #optional useCapture flag for addEventListener
	     = (object) interact
	    \*/
	    interact.on = function (type, listener, useCapture) {
	        if (isString(type) && type.search(' ') !== -1) {
	            type = type.trim().split(/ +/);
	        }
	
	        if (isArray(type)) {
	            for (var i = 0; i < type.length; i++) {
	                interact.on(type[i], listener, useCapture);
	            }
	
	            return interact;
	        }
	
	        if (isObject(type)) {
	            for (var prop in type) {
	                interact.on(prop, type[prop], listener);
	            }
	
	            return interact;
	        }
	
	        // if it is an InteractEvent type, add listener to globalEvents
	        if (contains(eventTypes, type)) {
	            // if this type of event was never bound
	            if (!globalEvents[type]) {
	                globalEvents[type] = [listener];
	            }
	            else {
	                globalEvents[type].push(listener);
	            }
	        }
	        // If non InteractEvent type, addEventListener to document
	        else {
	            events.add(document, type, listener, useCapture);
	        }
	
	        return interact;
	    };
	
	    /*\
	     * interact.off
	     [ method ]
	     *
	     * Removes a global InteractEvent listener or DOM event from `document`
	     *
	     - type       (string | array | object) The types of events that were listened for
	     - listener   (function) The listener function to be removed
	     - useCapture (boolean) #optional useCapture flag for removeEventListener
	     = (object) interact
	     \*/
	    interact.off = function (type, listener, useCapture) {
	        if (isString(type) && type.search(' ') !== -1) {
	            type = type.trim().split(/ +/);
	        }
	
	        if (isArray(type)) {
	            for (var i = 0; i < type.length; i++) {
	                interact.off(type[i], listener, useCapture);
	            }
	
	            return interact;
	        }
	
	        if (isObject(type)) {
	            for (var prop in type) {
	                interact.off(prop, type[prop], listener);
	            }
	
	            return interact;
	        }
	
	        if (!contains(eventTypes, type)) {
	            events.remove(document, type, listener, useCapture);
	        }
	        else {
	            var index;
	
	            if (type in globalEvents
	                && (index = indexOf(globalEvents[type], listener)) !== -1) {
	                globalEvents[type].splice(index, 1);
	            }
	        }
	
	        return interact;
	    };
	
	    /*\
	     * interact.enableDragging
	     [ method ]
	     *
	     * Deprecated.
	     *
	     * Returns or sets whether dragging is enabled for any Interactables
	     *
	     - newValue (boolean) #optional `true` to allow the action; `false` to disable action for all Interactables
	     = (boolean | object) The current setting or interact
	    \*/
	    interact.enableDragging = warnOnce(function (newValue) {
	        if (newValue !== null && newValue !== undefined) {
	            actionIsEnabled.drag = newValue;
	
	            return interact;
	        }
	        return actionIsEnabled.drag;
	    }, 'interact.enableDragging is deprecated and will soon be removed.');
	
	    /*\
	     * interact.enableResizing
	     [ method ]
	     *
	     * Deprecated.
	     *
	     * Returns or sets whether resizing is enabled for any Interactables
	     *
	     - newValue (boolean) #optional `true` to allow the action; `false` to disable action for all Interactables
	     = (boolean | object) The current setting or interact
	    \*/
	    interact.enableResizing = warnOnce(function (newValue) {
	        if (newValue !== null && newValue !== undefined) {
	            actionIsEnabled.resize = newValue;
	
	            return interact;
	        }
	        return actionIsEnabled.resize;
	    }, 'interact.enableResizing is deprecated and will soon be removed.');
	
	    /*\
	     * interact.enableGesturing
	     [ method ]
	     *
	     * Deprecated.
	     *
	     * Returns or sets whether gesturing is enabled for any Interactables
	     *
	     - newValue (boolean) #optional `true` to allow the action; `false` to disable action for all Interactables
	     = (boolean | object) The current setting or interact
	    \*/
	    interact.enableGesturing = warnOnce(function (newValue) {
	        if (newValue !== null && newValue !== undefined) {
	            actionIsEnabled.gesture = newValue;
	
	            return interact;
	        }
	        return actionIsEnabled.gesture;
	    }, 'interact.enableGesturing is deprecated and will soon be removed.');
	
	    interact.eventTypes = eventTypes;
	
	    /*\
	     * interact.debug
	     [ method ]
	     *
	     * Returns debugging data
	     = (object) An object with properties that outline the current state and expose internal functions and variables
	    \*/
	    interact.debug = function () {
	        var interaction = interactions[0] || new Interaction();
	
	        return {
	            interactions          : interactions,
	            target                : interaction.target,
	            dragging              : interaction.dragging,
	            resizing              : interaction.resizing,
	            gesturing             : interaction.gesturing,
	            prepared              : interaction.prepared,
	            matches               : interaction.matches,
	            matchElements         : interaction.matchElements,
	
	            prevCoords            : interaction.prevCoords,
	            startCoords           : interaction.startCoords,
	
	            pointerIds            : interaction.pointerIds,
	            pointers              : interaction.pointers,
	            addPointer            : listeners.addPointer,
	            removePointer         : listeners.removePointer,
	            recordPointer        : listeners.recordPointer,
	
	            snap                  : interaction.snapStatus,
	            restrict              : interaction.restrictStatus,
	            inertia               : interaction.inertiaStatus,
	
	            downTime              : interaction.downTimes[0],
	            downEvent             : interaction.downEvent,
	            downPointer           : interaction.downPointer,
	            prevEvent             : interaction.prevEvent,
	
	            Interactable          : Interactable,
	            interactables         : interactables,
	            pointerIsDown         : interaction.pointerIsDown,
	            defaultOptions        : defaultOptions,
	            defaultActionChecker  : defaultActionChecker,
	
	            actionCursors         : actionCursors,
	            dragMove              : listeners.dragMove,
	            resizeMove            : listeners.resizeMove,
	            gestureMove           : listeners.gestureMove,
	            pointerUp             : listeners.pointerUp,
	            pointerDown           : listeners.pointerDown,
	            pointerMove           : listeners.pointerMove,
	            pointerHover          : listeners.pointerHover,
	
	            eventTypes            : eventTypes,
	
	            events                : events,
	            globalEvents          : globalEvents,
	            delegatedEvents       : delegatedEvents,
	
	            prefixedPropREs       : prefixedPropREs
	        };
	    };
	
	    // expose the functions used to calculate multi-touch properties
	    interact.getPointerAverage = pointerAverage;
	    interact.getTouchBBox     = touchBBox;
	    interact.getTouchDistance = touchDistance;
	    interact.getTouchAngle    = touchAngle;
	
	    interact.getElementRect         = getElementRect;
	    interact.getElementClientRect   = getElementClientRect;
	    interact.matchesSelector        = matchesSelector;
	    interact.closest                = closest;
	
	    /*\
	     * interact.margin
	     [ method ]
	     *
	     * Deprecated. Use `interact(target).resizable({ margin: number });` instead.
	     * Returns or sets the margin for autocheck resizing used in
	     * @Interactable.getAction. That is the distance from the bottom and right
	     * edges of an element clicking in which will start resizing
	     *
	     - newValue (number) #optional
	     = (number | interact) The current margin value or interact
	    \*/
	    interact.margin = warnOnce(function (newvalue) {
	        if (isNumber(newvalue)) {
	            margin = newvalue;
	
	            return interact;
	        }
	        return margin;
	    },
	    'interact.margin is deprecated. Use interact(target).resizable({ margin: number }); instead.') ;
	
	    /*\
	     * interact.supportsTouch
	     [ method ]
	     *
	     = (boolean) Whether or not the browser supports touch input
	    \*/
	    interact.supportsTouch = function () {
	        return supportsTouch;
	    };
	
	    /*\
	     * interact.supportsPointerEvent
	     [ method ]
	     *
	     = (boolean) Whether or not the browser supports PointerEvents
	    \*/
	    interact.supportsPointerEvent = function () {
	        return supportsPointerEvent;
	    };
	
	    /*\
	     * interact.stop
	     [ method ]
	     *
	     * Cancels all interactions (end events are not fired)
	     *
	     - event (Event) An event on which to call preventDefault()
	     = (object) interact
	    \*/
	    interact.stop = function (event) {
	        for (var i = interactions.length - 1; i >= 0; i--) {
	            interactions[i].stop(event);
	        }
	
	        return interact;
	    };
	
	    /*\
	     * interact.dynamicDrop
	     [ method ]
	     *
	     * Returns or sets whether the dimensions of dropzone elements are
	     * calculated on every dragmove or only on dragstart for the default
	     * dropChecker
	     *
	     - newValue (boolean) #optional True to check on each move. False to check only before start
	     = (boolean | interact) The current setting or interact
	    \*/
	    interact.dynamicDrop = function (newValue) {
	        if (isBool(newValue)) {
	            //if (dragging && dynamicDrop !== newValue && !newValue) {
	                //calcRects(dropzones);
	            //}
	
	            dynamicDrop = newValue;
	
	            return interact;
	        }
	        return dynamicDrop;
	    };
	
	    /*\
	     * interact.pointerMoveTolerance
	     [ method ]
	     * Returns or sets the distance the pointer must be moved before an action
	     * sequence occurs. This also affects tolerance for tap events.
	     *
	     - newValue (number) #optional The movement from the start position must be greater than this value
	     = (number | Interactable) The current setting or interact
	    \*/
	    interact.pointerMoveTolerance = function (newValue) {
	        if (isNumber(newValue)) {
	            pointerMoveTolerance = newValue;
	
	            return this;
	        }
	
	        return pointerMoveTolerance;
	    };
	
	    /*\
	     * interact.maxInteractions
	     [ method ]
	     **
	     * Returns or sets the maximum number of concurrent interactions allowed.
	     * By default only 1 interaction is allowed at a time (for backwards
	     * compatibility). To allow multiple interactions on the same Interactables
	     * and elements, you need to enable it in the draggable, resizable and
	     * gesturable `'max'` and `'maxPerElement'` options.
	     **
	     - newValue (number) #optional Any number. newValue <= 0 means no interactions.
	    \*/
	    interact.maxInteractions = function (newValue) {
	        if (isNumber(newValue)) {
	            maxInteractions = newValue;
	
	            return this;
	        }
	
	        return maxInteractions;
	    };
	
	    interact.createSnapGrid = function (grid) {
	        return function (x, y) {
	            var offsetX = 0,
	                offsetY = 0;
	
	            if (isObject(grid.offset)) {
	                offsetX = grid.offset.x;
	                offsetY = grid.offset.y;
	            }
	
	            var gridx = Math.round((x - offsetX) / grid.x),
	                gridy = Math.round((y - offsetY) / grid.y),
	
	                newX = gridx * grid.x + offsetX,
	                newY = gridy * grid.y + offsetY;
	
	            return {
	                x: newX,
	                y: newY,
	                range: grid.range
	            };
	        };
	    };
	
	    function endAllInteractions (event) {
	        for (var i = 0; i < interactions.length; i++) {
	            interactions[i].pointerEnd(event, event);
	        }
	    }
	
	    function listenToDocument (doc) {
	        if (contains(documents, doc)) { return; }
	
	        var win = doc.defaultView || doc.parentWindow;
	
	        // add delegate event listener
	        for (var eventType in delegatedEvents) {
	            events.add(doc, eventType, delegateListener);
	            events.add(doc, eventType, delegateUseCapture, true);
	        }
	
	        if (supportsPointerEvent) {
	            if (PointerEvent === win.MSPointerEvent) {
	                pEventTypes = {
	                    up: 'MSPointerUp', down: 'MSPointerDown', over: 'mouseover',
	                    out: 'mouseout', move: 'MSPointerMove', cancel: 'MSPointerCancel' };
	            }
	            else {
	                pEventTypes = {
	                    up: 'pointerup', down: 'pointerdown', over: 'pointerover',
	                    out: 'pointerout', move: 'pointermove', cancel: 'pointercancel' };
	            }
	
	            events.add(doc, pEventTypes.down  , listeners.selectorDown );
	            events.add(doc, pEventTypes.move  , listeners.pointerMove  );
	            events.add(doc, pEventTypes.over  , listeners.pointerOver  );
	            events.add(doc, pEventTypes.out   , listeners.pointerOut   );
	            events.add(doc, pEventTypes.up    , listeners.pointerUp    );
	            events.add(doc, pEventTypes.cancel, listeners.pointerCancel);
	
	            // autoscroll
	            events.add(doc, pEventTypes.move, listeners.autoScrollMove);
	        }
	        else {
	            events.add(doc, 'mousedown', listeners.selectorDown);
	            events.add(doc, 'mousemove', listeners.pointerMove );
	            events.add(doc, 'mouseup'  , listeners.pointerUp   );
	            events.add(doc, 'mouseover', listeners.pointerOver );
	            events.add(doc, 'mouseout' , listeners.pointerOut  );
	
	            events.add(doc, 'touchstart' , listeners.selectorDown );
	            events.add(doc, 'touchmove'  , listeners.pointerMove  );
	            events.add(doc, 'touchend'   , listeners.pointerUp    );
	            events.add(doc, 'touchcancel', listeners.pointerCancel);
	
	            // autoscroll
	            events.add(doc, 'mousemove', listeners.autoScrollMove);
	            events.add(doc, 'touchmove', listeners.autoScrollMove);
	        }
	
	        events.add(win, 'blur', endAllInteractions);
	
	        try {
	            if (win.frameElement) {
	                var parentDoc = win.frameElement.ownerDocument,
	                    parentWindow = parentDoc.defaultView;
	
	                events.add(parentDoc   , 'mouseup'      , listeners.pointerEnd);
	                events.add(parentDoc   , 'touchend'     , listeners.pointerEnd);
	                events.add(parentDoc   , 'touchcancel'  , listeners.pointerEnd);
	                events.add(parentDoc   , 'pointerup'    , listeners.pointerEnd);
	                events.add(parentDoc   , 'MSPointerUp'  , listeners.pointerEnd);
	                events.add(parentWindow, 'blur'         , endAllInteractions );
	            }
	        }
	        catch (error) {
	            interact.windowParentError = error;
	        }
	
	        // prevent native HTML5 drag on interact.js target elements
	        events.add(doc, 'dragstart', function (event) {
	            for (var i = 0; i < interactions.length; i++) {
	                var interaction = interactions[i];
	
	                if (interaction.element
	                    && (interaction.element === event.target
	                        || nodeContains(interaction.element, event.target))) {
	
	                    interaction.checkAndPreventDefault(event, interaction.target, interaction.element);
	                    return;
	                }
	            }
	        });
	
	        if (events.useAttachEvent) {
	            // For IE's lack of Event#preventDefault
	            events.add(doc, 'selectstart', function (event) {
	                var interaction = interactions[0];
	
	                if (interaction.currentAction()) {
	                    interaction.checkAndPreventDefault(event);
	                }
	            });
	
	            // For IE's bad dblclick event sequence
	            events.add(doc, 'dblclick', doOnInteractions('ie8Dblclick'));
	        }
	
	        documents.push(doc);
	    }
	
	    listenToDocument(document);
	
	    function indexOf (array, target) {
	        for (var i = 0, len = array.length; i < len; i++) {
	            if (array[i] === target) {
	                return i;
	            }
	        }
	
	        return -1;
	    }
	
	    function contains (array, target) {
	        return indexOf(array, target) !== -1;
	    }
	
	    function matchesSelector (element, selector, nodeList) {
	        if (ie8MatchesSelector) {
	            return ie8MatchesSelector(element, selector, nodeList);
	        }
	
	        // remove /deep/ from selectors if shadowDOM polyfill is used
	        if (window !== realWindow) {
	            selector = selector.replace(/\/deep\//g, ' ');
	        }
	
	        return element[prefixedMatchesSelector](selector);
	    }
	
	    function matchesUpTo (element, selector, limit) {
	        while (isElement(element)) {
	            if (matchesSelector(element, selector)) {
	                return true;
	            }
	
	            element = parentElement(element);
	
	            if (element === limit) {
	                return matchesSelector(element, selector);
	            }
	        }
	
	        return false;
	    }
	
	    // For IE8's lack of an Element#matchesSelector
	    // taken from http://tanalin.com/en/blog/2012/12/matches-selector-ie8/ and modified
	    if (!(prefixedMatchesSelector in Element.prototype) || !isFunction(Element.prototype[prefixedMatchesSelector])) {
	        ie8MatchesSelector = function (element, selector, elems) {
	            elems = elems || element.parentNode.querySelectorAll(selector);
	
	            for (var i = 0, len = elems.length; i < len; i++) {
	                if (elems[i] === element) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    // requestAnimationFrame polyfill
	    (function() {
	        var lastTime = 0,
	            vendors = ['ms', 'moz', 'webkit', 'o'];
	
	        for(var x = 0; x < vendors.length && !realWindow.requestAnimationFrame; ++x) {
	            reqFrame = realWindow[vendors[x]+'RequestAnimationFrame'];
	            cancelFrame = realWindow[vendors[x]+'CancelAnimationFrame'] || realWindow[vendors[x]+'CancelRequestAnimationFrame'];
	        }
	
	        if (!reqFrame) {
	            reqFrame = function(callback) {
	                var currTime = new Date().getTime(),
	                    timeToCall = Math.max(0, 16 - (currTime - lastTime)),
	                    id = setTimeout(function() { callback(currTime + timeToCall); },
	                  timeToCall);
	                lastTime = currTime + timeToCall;
	                return id;
	            };
	        }
	
	        if (!cancelFrame) {
	            cancelFrame = function(id) {
	                clearTimeout(id);
	            };
	        }
	    }());
	
	    /* global exports: true, module, define */
	
	    // http://documentcloud.github.io/underscore/docs/underscore.html#section-11
	    if (true) {
	        if (typeof module !== 'undefined' && module.exports) {
	            exports = module.exports = interact;
	        }
	        exports.interact = interact;
	    }
	    // AMD
	    else if (typeof define === 'function' && define.amd) {
	        define('interact', function() {
	            return interact;
	        });
	    }
	    else {
	        realWindow.interact = interact;
	    }
	
	} (typeof window === 'undefined'? undefined : window));


/***/ }),
/* 986 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 987 */
/***/ (function(module, exports) {

	module.exports = [{"path":"/blank","templateUrl":"views/pages/blank.html"},{"path":"/dashboard","templateUrl":"views/dashboard.html"},{"path":"/invoice","templateUrl":"views/pages/invoice.html"},{"path":"/services","templateUrl":"views/pages/services.html"},{"path":"/lock-screen","templateUrl":"views/pages/lock-screen.html"},{"path":"/contact","templateUrl":"views/pages/contact.html"},{"path":"/tasks","templateUrl":"views/tasks/tasks.html"},{"path":"/ui/typography","templateUrl":"views/ui/typography.html"},{"path":"/ui/buttons","templateUrl":"views/ui/buttons.html"},{"path":"/ui/icons","templateUrl":"views/ui/icons.html"},{"path":"/ui/grids","templateUrl":"views/ui/grids.html"},{"path":"/ui/widgets","templateUrl":"views/ui/widgets.html"},{"path":"/ui/components","templateUrl":"views/ui/components.html"},{"path":"/ui/timeline","templateUrl":"views/ui/timeline.html"},{"path":"/ui/nested-lists","templateUrl":"views/ui/nested-lists.html"},{"path":"/ui/pricing-tables","templateUrl":"views/ui/pricing-tables.html"},{"path":"/forms/elements","templateUrl":"views/forms/elements.html"},{"path":"/forms/layouts","templateUrl":"views/forms/layouts.html"},{"path":"/forms/validation","templateUrl":"views/forms/validation.html"},{"path":"/forms/wizard","templateUrl":"views/forms/wizard.html"},{"path":"/maps/gmap","templateUrl":"views/maps/gmap.html"},{"path":"/maps/jqvmap","templateUrl":"views/maps/jqvmap.html"},{"path":"/tables/static","templateUrl":"views/tables/static.html"},{"path":"/tables/responsive","templateUrl":"views/tables/responsive.html"},{"path":"/tables/dynamic","templateUrl":"views/tables/dynamic.html"},{"path":"/charts/others","templateUrl":"views/charts/charts.html"},{"path":"/charts/morris","templateUrl":"views/charts/morris.html"},{"path":"/charts/flot","templateUrl":"views/charts/flot.html"},{"path":"/mail/inbox","templateUrl":"views/mail/inbox.html"},{"path":"/mail/compose","templateUrl":"views/mail/compose.html"},{"path":"/mail/single","templateUrl":"views/mail/single.html"},{"path":"/pages/features","templateUrl":"views/pages/features.html"},{"path":"/for-employers","templateUrl":"views/pages/for-employers.html","title":"For Employers | LexStep","unUsed":true},{"path":"/","template":"./home/home.html","title":"LexStep - Find Jobs At The Best Law Firms"},{"path":"/sitemap","templateUrl":"views/pages/sitemap.html"},{"path":"/sitemap.xml","templateUrl":"views/pages/sitemap.xml"},{"path":"/admin/job-creation","roles":["admin","corporate"],"template":"./shared/directives/create-update-position/create-update-position-page.html","title":"Add Position | LexStep"},{"path":"/admin/job-clone","roles":["admin","corporate"],"template":"./job/job-edit.html","title":"Clone Job | LexStep"},{"path":"/admin/firm-management","roles":["admin","corporate"],"template":"./shared/directives/create-update-employer/create-update-employer-page.html","title":"Firm Management | LexStep"},{"path":"/admin/firm-notes","roles":["admin","corporate"],"template":"./notes/employer-notes.html","title":"Employer Notes | LexStep"},{"path":"/admin/matching-lawyers","roles":["admin","corporate"],"template":"./admin-panel/recommendation-listing/recommendation-page.html","title":"Matching Lawyers | LexStep"},{"path":"/invite-friends","roles":[],"template":"./invite-friend/invite-friend.html","title":"Invite Your Friends | LexStep"},{"path":"/invite-friend","roles":["candidate","approved"],"template":"./refer-friend/refer-friend.html","title":"Invite Your Friends | LexStep"},{"path":"/admin/applied-jobs","roles":["admin","corporate"],"templateUrl":"views/pages/admin-applied-jobs.html","title":"Applied Jobs | LexStep"},{"path":"/connections","roles":["approved"],"template":"./candidate-applications/candidate-application.html","title":"Track | LexStep"},{"path":"/opportunities","roles":["approved"],"template":"./make-me-offer/make-me-an-offer.html","title":"Make Me An Offer | LexStep"},{"path":"/inhouse-jobs","roles":["approved"],"template":"./inhouse-jobs/in-house.html","title":"In-House Jobs | LexStep"},{"path":"/matches","roles":["approved"],"template":"./matches/matches.html","title":"Matches | LexStep"},{"path":"/admin/admin-listings","roles":["admin","corporate"],"template":"./admin-panel/position-listing/position-listing.html","title":"Active Positions | LexStep"},{"path":"/admin/inactive-positions","roles":["admin","corporate"],"template":"./admin-panel/position-listing/inactive-position-listing.html","title":"All Positions | LexStep"},{"css":"ng-slider.min.css","path":"/admin/lawyer-listing","roles":["admin","corporate"],"template":"./admin-panel/candidate-listing/candidate-listing.html","title":"Lawyer Listings | LexStep"},{"css":"ng-slider.min.css","path":"/admin/referral-listing","roles":["admin","corporate"],"template":"./admin-panel/referral-listing/referral-listing.html","title":"Referral Listings | LexStep"},{"path":"/admin/employers-listing","roles":["admin","corporate"],"template":"./admin-panel/employers-listing/employers-listing.html","title":"Employers Listings | LexStep"},{"path":"/admin/email-listing","roles":["admin","ops"],"template":"./admin-panel/email-listing/email-listing.html","title":"Email Listings | LexStep"},{"path":"/admin/application-listing","roles":["admin","ops","agent","intern"],"template":"./admin-panel/application-listing/application-listing.html","title":"Application Listings | LexStep"},{"path":"/admin/matching-lawyers-listing","roles":["admin","corporate"],"template":"./admin-panel/recommendation-listing/recommendation-listing.html","title":"Matching Lawyers | LexStep"},{"path":"/forgot","template":"./forgot-password/forgot-password.html","title":"Forgot Password - LexStep"},{"path":"/reset-password","template":"./change-password/reset-password.html","title":"Reset Password | LexStep"},{"path":"/reset-password:token?","template":"./change-password/reset-password.html","title":"Reset Password | LexStep"},{"path":"/change-password","template":"./change-password/change-password.html","title":"Change Password | LexStep"},{"hideWhenSession":true,"path":"/signin","template":"./sign-in/signin.html","title":"Login | LexStep"},{"hideWhenSession":true,"path":"/signup/:referralCode?","template":"./sign-up/signup.html","title":"Sign Up | LexStep"},{"hideWhenSession":true,"path":"/sign-up/:referralCode?","template":"./sign-up/signup.html","title":"Sign Up | LexStep"},{"path":"/referral/:referralCode?","redirectTo":"/"},{"path":"/profile","roles":["user","candidate"],"template":"./about-you/about-you.html","title":"Create Profile | LexStep"},{"path":"/user-profile","roles":["approved"],"template":"./approved-profile/profile-approved.html","title":"My Profile | LexStep"},{"path":"/admin/lawyer-profile","roles":["admin","corporate"],"template":"./lawyer-profile/candidate-profile.html","title":"Lawyer's Profile | LexStep"},{"path":"/admin/profile","roles":["admin","corporate"],"template":"./admin-profile/admin-profile.html","title":"My Profile | LexStep"},{"path":"/404","templateUrl":"views/pages/404.html"},{"path":"/502","templateUrl":"views/pages/502.html"},{"path":"/500","templateUrl":"views/pages/500.html"},{"path":"/about","templateUrl":"views/pages/about.html","title":"About Us | LexStep"},{"path":"/faqs","templateUrl":"views/pages/faqs.html","title":"FAQ | LexStep"},{"path":"/terms-conditions","templateUrl":"views/pages/terms-conditions.html","title":"Terms Of Service | LexStep"},{"path":"/privacy-policy","templateUrl":"views/pages/privacy-policy.html","title":"Privacy Policy | LexStep"},{"path":"/site-maintenance","templateUrl":"views/pages/site-maintenance.html","title":"We will be back shortly | LexStep"},{"path":"/get-in-touch","template":"./hiring/hiring.html","title":"Get in touch | LexStep"},{"path":"/unsubscribe","templateUrl":"views/pages/unsubscribe-notification.html","title":"unsubscribe Email | LexStep"},{"path":"/pause","templateUrl":"views/pages/pause-weekly-emails.html","title":"Paused Email | LexStep"},{"path":"/admin/email-history","roles":["admin","corporate"],"template":"./job-application-history/email-history.html","title":"Job Application History | LexStep"},{"path":"/admin/email-history-view","roles":["admin","corporate"],"template":"./job-application-history/view-job-application-body.html","title":"Job Application Email History View"},{"path":"/admin/edit-email","roles":["admin","corporate"],"template":"./edit-email/edit-email.html","title":"Edit email | LexStep"},{"path":"/admin/email-listing/email-preview","roles":["admin","corporate"],"template":"./admin-panel/email-listing/email-preview/email-preview.html","title":"View email | LexStep"}]

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * microplugin.js
	 * Copyright (c) 2013 Brian Reavis & contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 * @author Brian Reavis <brian@thirdroute.com>
	 */
	
	(function(root, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory();
		} else {
			root.MicroPlugin = factory();
		}
	}(this, function() {
		var MicroPlugin = {};
	
		MicroPlugin.mixin = function(Interface) {
			Interface.plugins = {};
	
			/**
			 * Initializes the listed plugins (with options).
			 * Acceptable formats:
			 *
			 * List (without options):
			 *   ['a', 'b', 'c']
			 *
			 * List (with options):
			 *   [{'name': 'a', options: {}}, {'name': 'b', options: {}}]
			 *
			 * Hash (with options):
			 *   {'a': { ... }, 'b': { ... }, 'c': { ... }}
			 *
			 * @param {mixed} plugins
			 */
			Interface.prototype.initializePlugins = function(plugins) {
				var i, n, key;
				var self  = this;
				var queue = [];
	
				self.plugins = {
					names     : [],
					settings  : {},
					requested : {},
					loaded    : {}
				};
	
				if (utils.isArray(plugins)) {
					for (i = 0, n = plugins.length; i < n; i++) {
						if (typeof plugins[i] === 'string') {
							queue.push(plugins[i]);
						} else {
							self.plugins.settings[plugins[i].name] = plugins[i].options;
							queue.push(plugins[i].name);
						}
					}
				} else if (plugins) {
					for (key in plugins) {
						if (plugins.hasOwnProperty(key)) {
							self.plugins.settings[key] = plugins[key];
							queue.push(key);
						}
					}
				}
	
				while (queue.length) {
					self.require(queue.shift());
				}
			};
	
			Interface.prototype.loadPlugin = function(name) {
				var self    = this;
				var plugins = self.plugins;
				var plugin  = Interface.plugins[name];
	
				if (!Interface.plugins.hasOwnProperty(name)) {
					throw new Error('Unable to find "' +  name + '" plugin');
				}
	
				plugins.requested[name] = true;
				plugins.loaded[name] = plugin.fn.apply(self, [self.plugins.settings[name] || {}]);
				plugins.names.push(name);
			};
	
			/**
			 * Initializes a plugin.
			 *
			 * @param {string} name
			 */
			Interface.prototype.require = function(name) {
				var self = this;
				var plugins = self.plugins;
	
				if (!self.plugins.loaded.hasOwnProperty(name)) {
					if (plugins.requested[name]) {
						throw new Error('Plugin has circular dependency ("' + name + '")');
					}
					self.loadPlugin(name);
				}
	
				return plugins.loaded[name];
			};
	
			/**
			 * Registers a plugin.
			 *
			 * @param {string} name
			 * @param {function} fn
			 */
			Interface.define = function(name, fn) {
				Interface.plugins[name] = {
					'name' : name,
					'fn'   : fn
				};
			};
		};
	
		var utils = {
			isArray: Array.isArray || function(vArg) {
				return Object.prototype.toString.call(vArg) === '[object Array]';
			}
		};
	
		return MicroPlugin;
	}));

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 231,
		"./af.js": 231,
		"./ar": 238,
		"./ar-dz": 232,
		"./ar-dz.js": 232,
		"./ar-kw": 233,
		"./ar-kw.js": 233,
		"./ar-ly": 234,
		"./ar-ly.js": 234,
		"./ar-ma": 235,
		"./ar-ma.js": 235,
		"./ar-sa": 236,
		"./ar-sa.js": 236,
		"./ar-tn": 237,
		"./ar-tn.js": 237,
		"./ar.js": 238,
		"./az": 239,
		"./az.js": 239,
		"./be": 240,
		"./be.js": 240,
		"./bg": 241,
		"./bg.js": 241,
		"./bm": 242,
		"./bm.js": 242,
		"./bn": 244,
		"./bn-bd": 243,
		"./bn-bd.js": 243,
		"./bn.js": 244,
		"./bo": 245,
		"./bo.js": 245,
		"./br": 246,
		"./br.js": 246,
		"./bs": 247,
		"./bs.js": 247,
		"./ca": 248,
		"./ca.js": 248,
		"./cs": 249,
		"./cs.js": 249,
		"./cv": 250,
		"./cv.js": 250,
		"./cy": 251,
		"./cy.js": 251,
		"./da": 252,
		"./da.js": 252,
		"./de": 255,
		"./de-at": 253,
		"./de-at.js": 253,
		"./de-ch": 254,
		"./de-ch.js": 254,
		"./de.js": 255,
		"./dv": 256,
		"./dv.js": 256,
		"./el": 257,
		"./el.js": 257,
		"./en-au": 258,
		"./en-au.js": 258,
		"./en-ca": 259,
		"./en-ca.js": 259,
		"./en-gb": 260,
		"./en-gb.js": 260,
		"./en-ie": 261,
		"./en-ie.js": 261,
		"./en-il": 262,
		"./en-il.js": 262,
		"./en-in": 263,
		"./en-in.js": 263,
		"./en-nz": 264,
		"./en-nz.js": 264,
		"./en-sg": 265,
		"./en-sg.js": 265,
		"./eo": 266,
		"./eo.js": 266,
		"./es": 270,
		"./es-do": 267,
		"./es-do.js": 267,
		"./es-mx": 268,
		"./es-mx.js": 268,
		"./es-us": 269,
		"./es-us.js": 269,
		"./es.js": 270,
		"./et": 271,
		"./et.js": 271,
		"./eu": 272,
		"./eu.js": 272,
		"./fa": 273,
		"./fa.js": 273,
		"./fi": 274,
		"./fi.js": 274,
		"./fil": 275,
		"./fil.js": 275,
		"./fo": 276,
		"./fo.js": 276,
		"./fr": 279,
		"./fr-ca": 277,
		"./fr-ca.js": 277,
		"./fr-ch": 278,
		"./fr-ch.js": 278,
		"./fr.js": 279,
		"./fy": 280,
		"./fy.js": 280,
		"./ga": 281,
		"./ga.js": 281,
		"./gd": 282,
		"./gd.js": 282,
		"./gl": 283,
		"./gl.js": 283,
		"./gom-deva": 284,
		"./gom-deva.js": 284,
		"./gom-latn": 285,
		"./gom-latn.js": 285,
		"./gu": 286,
		"./gu.js": 286,
		"./he": 287,
		"./he.js": 287,
		"./hi": 288,
		"./hi.js": 288,
		"./hr": 289,
		"./hr.js": 289,
		"./hu": 290,
		"./hu.js": 290,
		"./hy-am": 291,
		"./hy-am.js": 291,
		"./id": 292,
		"./id.js": 292,
		"./is": 293,
		"./is.js": 293,
		"./it": 295,
		"./it-ch": 294,
		"./it-ch.js": 294,
		"./it.js": 295,
		"./ja": 296,
		"./ja.js": 296,
		"./jv": 297,
		"./jv.js": 297,
		"./ka": 298,
		"./ka.js": 298,
		"./kk": 299,
		"./kk.js": 299,
		"./km": 300,
		"./km.js": 300,
		"./kn": 301,
		"./kn.js": 301,
		"./ko": 302,
		"./ko.js": 302,
		"./ku": 303,
		"./ku.js": 303,
		"./ky": 304,
		"./ky.js": 304,
		"./lb": 305,
		"./lb.js": 305,
		"./lo": 306,
		"./lo.js": 306,
		"./lt": 307,
		"./lt.js": 307,
		"./lv": 308,
		"./lv.js": 308,
		"./me": 309,
		"./me.js": 309,
		"./mi": 310,
		"./mi.js": 310,
		"./mk": 311,
		"./mk.js": 311,
		"./ml": 312,
		"./ml.js": 312,
		"./mn": 313,
		"./mn.js": 313,
		"./mr": 314,
		"./mr.js": 314,
		"./ms": 316,
		"./ms-my": 315,
		"./ms-my.js": 315,
		"./ms.js": 316,
		"./mt": 317,
		"./mt.js": 317,
		"./my": 318,
		"./my.js": 318,
		"./nb": 319,
		"./nb.js": 319,
		"./ne": 320,
		"./ne.js": 320,
		"./nl": 322,
		"./nl-be": 321,
		"./nl-be.js": 321,
		"./nl.js": 322,
		"./nn": 323,
		"./nn.js": 323,
		"./oc-lnc": 324,
		"./oc-lnc.js": 324,
		"./pa-in": 325,
		"./pa-in.js": 325,
		"./pl": 326,
		"./pl.js": 326,
		"./pt": 328,
		"./pt-br": 327,
		"./pt-br.js": 327,
		"./pt.js": 328,
		"./ro": 329,
		"./ro.js": 329,
		"./ru": 330,
		"./ru.js": 330,
		"./sd": 331,
		"./sd.js": 331,
		"./se": 332,
		"./se.js": 332,
		"./si": 333,
		"./si.js": 333,
		"./sk": 334,
		"./sk.js": 334,
		"./sl": 335,
		"./sl.js": 335,
		"./sq": 336,
		"./sq.js": 336,
		"./sr": 338,
		"./sr-cyrl": 337,
		"./sr-cyrl.js": 337,
		"./sr.js": 338,
		"./ss": 339,
		"./ss.js": 339,
		"./sv": 340,
		"./sv.js": 340,
		"./sw": 341,
		"./sw.js": 341,
		"./ta": 342,
		"./ta.js": 342,
		"./te": 343,
		"./te.js": 343,
		"./tet": 344,
		"./tet.js": 344,
		"./tg": 345,
		"./tg.js": 345,
		"./th": 346,
		"./th.js": 346,
		"./tk": 347,
		"./tk.js": 347,
		"./tl-ph": 348,
		"./tl-ph.js": 348,
		"./tlh": 349,
		"./tlh.js": 349,
		"./tr": 350,
		"./tr.js": 350,
		"./tzl": 351,
		"./tzl.js": 351,
		"./tzm": 353,
		"./tzm-latn": 352,
		"./tzm-latn.js": 352,
		"./tzm.js": 353,
		"./ug-cn": 354,
		"./ug-cn.js": 354,
		"./uk": 355,
		"./uk.js": 355,
		"./ur": 356,
		"./ur.js": 356,
		"./uz": 358,
		"./uz-latn": 357,
		"./uz-latn.js": 357,
		"./uz.js": 358,
		"./vi": 359,
		"./vi.js": 359,
		"./x-pseudo": 360,
		"./x-pseudo.js": 360,
		"./yo": 361,
		"./yo.js": 361,
		"./zh-cn": 362,
		"./zh-cn.js": 362,
		"./zh-hk": 363,
		"./zh-hk.js": 363,
		"./zh-mo": 364,
		"./zh-mo.js": 364,
		"./zh-tw": 365,
		"./zh-tw.js": 365
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 989;


/***/ }),
/* 990 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(367);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(367);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ }),
/* 993 */
/***/ (function(module, exports) {

	
	
	/**
	 * A function that always returns `false`. Any passed in parameters are ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig * -> Boolean
	 * @param {*}
	 * @return {Boolean}
	 * @see R.T
	 * @example
	 *
	 *      R.F(); //=> false
	 */
	var F = function () {
	  return false;
	};
	module.exports = F;

/***/ }),
/* 994 */
/***/ (function(module, exports) {

	
	
	/**
	 * A function that always returns `true`. Any passed in parameters are ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig * -> Boolean
	 * @param {*}
	 * @return {Boolean}
	 * @see R.F
	 * @example
	 *
	 *      R.T(); //=> true
	 */
	var T = function () {
	  return true;
	};
	module.exports = T;

/***/ }),
/* 995 */
/***/ (function(module, exports) {

	/**
	 * A special placeholder value used to specify "gaps" within curried functions,
	 * allowing partial application of any combination of arguments, regardless of
	 * their positions.
	 *
	 * If `g` is a curried ternary function and `_` is `R.__`, the following are
	 * equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2, _)(1, 3)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @name __
	 * @constant
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @example
	 *
	 *      const greet = R.replace('{name}', R.__, 'Hello, {name}!');
	 *      greet('Alice'); //=> 'Hello, Alice!'
	 */
	module.exports = { '@@functional/placeholder': true };

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(40);
	
	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var curryN = /*#__PURE__*/__webpack_require__(18);
	
	/**
	 * Creates a new list iteration function from an existing one by adding two new
	 * parameters to its callback function: the current index, and the entire list.
	 *
	 * This would turn, for instance, [`R.map`](#map) function into one that
	 * more closely resembles `Array.prototype.map`. Note that this will only work
	 * for functions in which the iteration callback function is the first
	 * parameter, and where the list is the last parameter. (This latter might be
	 * unimportant if the list parameter is not used.)
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Function
	 * @category List
	 * @sig ((a ... -> b) ... -> [a] -> *) -> ((a ..., Int, [a] -> b) ... -> [a] -> *)
	 * @param {Function} fn A list iteration function that does not pass index or list to its callback
	 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
	 * @example
	 *
	 *      const mapIndexed = R.addIndex(R.map);
	 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
	 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
	 */
	
	
	var addIndex = /*#__PURE__*/_curry1(function addIndex(fn) {
	  return curryN(fn.length, function () {
	    var idx = 0;
	    var origFn = arguments[0];
	    var list = arguments[arguments.length - 1];
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = function () {
	      var result = origFn.apply(this, _concat(arguments, [idx, list]));
	      idx += 1;
	      return result;
	    };
	    return fn.apply(this, args);
	  });
	});
	module.exports = addIndex;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var curryN = /*#__PURE__*/__webpack_require__(18);
	
	var max = /*#__PURE__*/__webpack_require__(73);
	
	var pluck = /*#__PURE__*/__webpack_require__(86);
	
	var reduce = /*#__PURE__*/__webpack_require__(47);
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if every one of the provided predicates is satisfied
	 * by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.anyPass
	 * @example
	 *
	 *      const isQueen = R.propEq('rank', 'Q');
	 *      const isSpade = R.propEq('suit', '♠︎');
	 *      const isQueenOfSpades = R.allPass([isQueen, isSpade]);
	 *
	 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
	 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
	 */
	
	
	var allPass = /*#__PURE__*/_curry1(function allPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function () {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (!preds[idx].apply(this, arguments)) {
	        return false;
	      }
	      idx += 1;
	    }
	    return true;
	  });
	});
	module.exports = allPass;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _xany = /*#__PURE__*/__webpack_require__(1072);
	
	/**
	 * Returns `true` if at least one of the elements of the list match the predicate,
	 * `false` otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
	 *         otherwise.
	 * @see R.all, R.none, R.transduce
	 * @example
	 *
	 *      const lessThan0 = R.flip(R.lt)(0);
	 *      const lessThan2 = R.flip(R.lt)(2);
	 *      R.any(lessThan0)([1, 2]); //=> false
	 *      R.any(lessThan2)([1, 2]); //=> true
	 */
	
	
	var any = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['any'], _xany, function any(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (fn(list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	}));
	module.exports = any;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var curryN = /*#__PURE__*/__webpack_require__(18);
	
	var max = /*#__PURE__*/__webpack_require__(73);
	
	var pluck = /*#__PURE__*/__webpack_require__(86);
	
	var reduce = /*#__PURE__*/__webpack_require__(47);
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if at least one of the provided predicates is
	 * satisfied by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.allPass
	 * @example
	 *
	 *      const isClub = R.propEq('suit', '♣');
	 *      const isSpade = R.propEq('suit', '♠');
	 *      const isBlackCard = R.anyPass([isClub, isSpade]);
	 *
	 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
	 */
	
	
	var anyPass = /*#__PURE__*/_curry1(function anyPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function () {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (preds[idx].apply(this, arguments)) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  });
	});
	module.exports = anyPass;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	var _aperture = /*#__PURE__*/__webpack_require__(1056);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _xaperture = /*#__PURE__*/__webpack_require__(1073);
	
	/**
	 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
	 * greater than the length of the list, an empty list is returned.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig Number -> [a] -> [[a]]
	 * @param {Number} n The size of the tuples to create
	 * @param {Array} list The list to split into `n`-length tuples
	 * @return {Array} The resulting list of `n`-length tuples
	 * @see R.transduce
	 * @example
	 *
	 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
	 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
	 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
	 */
	
	
	var aperture = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable([], _xaperture, _aperture));
	module.exports = aperture;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(40);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns a new list containing the contents of the given list, followed by
	 * the given element.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The element to add to the end of the new list.
	 * @param {Array} list The list of elements to add a new item to.
	 *        list.
	 * @return {Array} A new list containing the elements of the old list followed by `el`.
	 * @see R.prepend
	 * @example
	 *
	 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
	 *      R.append('tests', []); //=> ['tests']
	 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
	 */
	
	
	var append = /*#__PURE__*/_curry2(function append(el, list) {
	  return _concat(list, [el]);
	});
	module.exports = append;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var apply = /*#__PURE__*/__webpack_require__(371);
	
	var curryN = /*#__PURE__*/__webpack_require__(18);
	
	var max = /*#__PURE__*/__webpack_require__(73);
	
	var pluck = /*#__PURE__*/__webpack_require__(86);
	
	var reduce = /*#__PURE__*/__webpack_require__(47);
	
	var keys = /*#__PURE__*/__webpack_require__(41);
	
	var values = /*#__PURE__*/__webpack_require__(427);
	
	// Use custom mapValues function to avoid issues with specs that include a "map" key and R.map
	// delegating calls to .map
	
	
	function mapValues(fn, obj) {
	  return keys(obj).reduce(function (acc, key) {
	    acc[key] = fn(obj[key]);
	    return acc;
	  }, {});
	}
	
	/**
	 * Given a spec object recursively mapping properties to functions, creates a
	 * function producing an object of the same structure, by mapping each property
	 * to the result of calling its associated function with the supplied arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
	 * @param {Object} spec an object recursively mapping properties to functions for
	 *        producing the values for these properties.
	 * @return {Function} A function that returns an object of the same structure
	 * as `spec', with each property set to the value returned by calling its
	 * associated function with the supplied arguments.
	 * @see R.converge, R.juxt
	 * @example
	 *
	 *      const getMetrics = R.applySpec({
	 *        sum: R.add,
	 *        nested: { mul: R.multiply }
	 *      });
	 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
	 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
	 */
	var applySpec = /*#__PURE__*/_curry1(function applySpec(spec) {
	  spec = mapValues(function (v) {
	    return typeof v == 'function' ? v : applySpec(v);
	  }, spec);
	
	  return curryN(reduce(max, 0, pluck('length', values(spec))), function () {
	    var args = arguments;
	    return mapValues(function (f) {
	      return apply(f, args);
	    }, spec);
	  });
	});
	module.exports = applySpec;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Takes a value and applies a function to it.
	 *
	 * This function is also known as the `thrush` combinator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.25.0
	 * @category Function
	 * @sig a -> (a -> b) -> b
	 * @param {*} x The value
	 * @param {Function} f The function to apply
	 * @return {*} The result of applying `f` to `x`
	 * @example
	 *
	 *      const t42 = R.applyTo(42);
	 *      t42(R.identity); //=> 42
	 *      t42(R.add(1)); //=> 43
	 */
	
	
	var applyTo = /*#__PURE__*/_curry2(function applyTo(x, f) {
	  return f(x);
	});
	module.exports = applyTo;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Makes an ascending comparator function out of a function that returns a value
	 * that can be compared with `<` and `>`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Function
	 * @sig Ord b => (a -> b) -> a -> a -> Number
	 * @param {Function} fn A function of arity one that returns a value that can be compared
	 * @param {*} a The first item to be compared.
	 * @param {*} b The second item to be compared.
	 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
	 * @see R.descend
	 * @example
	 *
	 *      const byAge = R.ascend(R.prop('age'));
	 *      const people = [
	 *        { name: 'Emma', age: 70 },
	 *        { name: 'Peter', age: 78 },
	 *        { name: 'Mikhail', age: 62 },
	 *      ];
	 *      const peopleByYoungestFirst = R.sort(byAge, people);
	 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
	 */
	
	
	var ascend = /*#__PURE__*/_curry3(function ascend(fn, a, b) {
	  var aa = fn(a);
	  var bb = fn(b);
	  return aa < bb ? -1 : aa > bb ? 1 : 0;
	});
	module.exports = ascend;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var nAry = /*#__PURE__*/__webpack_require__(117);
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly 2 parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Function
	 * @sig (* -> c) -> (a, b -> c)
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity 2.
	 * @see R.nAry, R.unary
	 * @example
	 *
	 *      const takesThreeArgs = function(a, b, c) {
	 *        return [a, b, c];
	 *      };
	 *      takesThreeArgs.length; //=> 3
	 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      const takesTwoArgs = R.binary(takesThreeArgs);
	 *      takesTwoArgs.length; //=> 2
	 *      // Only 2 arguments are passed to the wrapped function
	 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
	 * @symb R.binary(f)(a, b, c) = f(a, b)
	 */
	
	
	var binary = /*#__PURE__*/_curry1(function binary(fn) {
	  return nAry(2, fn);
	});
	module.exports = binary;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _isFunction = /*#__PURE__*/__webpack_require__(81);
	
	var and = /*#__PURE__*/__webpack_require__(370);
	
	var lift = /*#__PURE__*/__webpack_require__(115);
	
	/**
	 * A function which calls the two provided functions and returns the `&&`
	 * of the results.
	 * It returns the result of the first function if it is false-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * false-y value.
	 *
	 * In addition to functions, `R.both` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f A predicate
	 * @param {Function} g Another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
	 * @see R.and
	 * @example
	 *
	 *      const gt10 = R.gt(R.__, 10)
	 *      const lt20 = R.lt(R.__, 20)
	 *      const f = R.both(gt10, lt20);
	 *      f(15); //=> true
	 *      f(30); //=> false
	 *
	 *      R.both(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(false)
	 *      R.both([false, false, 'a'], [11]); //=> [false, false, 11]
	 */
	
	
	var both = /*#__PURE__*/_curry2(function both(f, g) {
	  return _isFunction(f) ? function _both() {
	    return f.apply(this, arguments) && g.apply(this, arguments);
	  } : lift(and)(f, g);
	});
	module.exports = both;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	var curry = /*#__PURE__*/__webpack_require__(154);
	
	/**
	 * Returns the result of calling its first argument with the remaining
	 * arguments. This is occasionally useful as a converging function for
	 * [`R.converge`](#converge): the first branch can produce a function while the
	 * remaining branches produce values to be passed to that function as its
	 * arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig (*... -> a),*... -> a
	 * @param {Function} fn The function to apply to the remaining arguments.
	 * @param {...*} args Any number of positional arguments.
	 * @return {*}
	 * @see R.apply
	 * @example
	 *
	 *      R.call(R.add, 1, 2); //=> 3
	 *
	 *      const indentN = R.pipe(R.repeat(' '),
	 *                           R.join(''),
	 *                           R.replace(/^(?!$)/gm));
	 *
	 *      const format = R.converge(R.call, [
	 *                                  R.pipe(R.prop('indent'), indentN),
	 *                                  R.prop('value')
	 *                              ]);
	 *
	 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
	 * @symb R.call(f, a, b) = f(a, b)
	 */
	
	
	var call = /*#__PURE__*/curry(function call(fn) {
	  return fn.apply(this, Array.prototype.slice.call(arguments, 1));
	});
	module.exports = call;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Restricts a number to be within a range.
	 *
	 * Also works for other ordered types such as Strings and Dates.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a -> a
	 * @param {Number} minimum The lower limit of the clamp (inclusive)
	 * @param {Number} maximum The upper limit of the clamp (inclusive)
	 * @param {Number} value Value to be clamped
	 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
	 * @example
	 *
	 *      R.clamp(1, 10, -5) // => 1
	 *      R.clamp(1, 10, 15) // => 10
	 *      R.clamp(1, 10, 4)  // => 4
	 */
	
	
	var clamp = /*#__PURE__*/_curry3(function clamp(min, max, value) {
	  if (min > max) {
	    throw new Error('min must not be greater than max in clamp(min, max, value)');
	  }
	  return value < min ? min : value > max ? max : value;
	});
	module.exports = clamp;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	var _clone = /*#__PURE__*/__webpack_require__(388);
	
	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Creates a deep copy of the value which may contain (nested) `Array`s and
	 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
	 * assigned by reference rather than copied
	 *
	 * Dispatches to a `clone` method if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {*} -> {*}
	 * @param {*} value The object or array to clone
	 * @return {*} A deeply cloned copy of `val`
	 * @example
	 *
	 *      const objects = [{}, {}, {}];
	 *      const objectsClone = R.clone(objects);
	 *      objects === objectsClone; //=> false
	 *      objects[0] === objectsClone[0]; //=> false
	 */
	
	
	var clone = /*#__PURE__*/_curry1(function clone(value) {
	  return value != null && typeof value.clone === 'function' ? value.clone() : _clone(value, [], [], true);
	});
	module.exports = clone;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Makes a comparator function out of a function that reports whether the first
	 * element is less than the second.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((a, b) -> Boolean) -> ((a, b) -> Number)
	 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
	 * is less than the second, `false` otherwise
	 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
	 * @example
	 *
	 *      const byAge = R.comparator((a, b) => a.age < b.age);
	 *      const people = [
	 *        { name: 'Emma', age: 70 },
	 *        { name: 'Peter', age: 78 },
	 *        { name: 'Mikhail', age: 62 },
	 *      ];
	 *      const peopleByIncreasingAge = R.sort(byAge, people);
	 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
	 */
	
	
	var comparator = /*#__PURE__*/_curry1(function comparator(pred) {
	  return function (a, b) {
	    return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
	  };
	});
	module.exports = comparator;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	var lift = /*#__PURE__*/__webpack_require__(115);
	
	var not = /*#__PURE__*/__webpack_require__(408);
	
	/**
	 * Takes a function `f` and returns a function `g` such that if called with the same arguments
	 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
	 *
	 * `R.complement` may be applied to any functor
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> *) -> (*... -> Boolean)
	 * @param {Function} f
	 * @return {Function}
	 * @see R.not
	 * @example
	 *
	 *      const isNotNil = R.complement(R.isNil);
	 *      isNil(null); //=> true
	 *      isNotNil(null); //=> false
	 *      isNil(7); //=> false
	 *      isNotNil(7); //=> true
	 */
	
	
	var complement = /*#__PURE__*/lift(not);
	module.exports = complement;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	var pipeP = /*#__PURE__*/__webpack_require__(415);
	
	var reverse = /*#__PURE__*/__webpack_require__(87);
	
	/**
	 * Performs right-to-left composition of one or more Promise-returning
	 * functions. The rightmost function may have any arity; the remaining
	 * functions must be unary.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((y -> Promise z), (x -> Promise y), ..., (a -> Promise b)) -> (a -> Promise z)
	 * @param {...Function} functions The functions to compose
	 * @return {Function}
	 * @see R.pipeP
	 * @deprecated since v0.26.0
	 * @example
	 *
	 *      const db = {
	 *        users: {
	 *          JOE: {
	 *            name: 'Joe',
	 *            followers: ['STEVE', 'SUZY']
	 *          }
	 *        }
	 *      }
	 *
	 *      // We'll pretend to do a db lookup which returns a promise
	 *      const lookupUser = (userId) => Promise.resolve(db.users[userId])
	 *      const lookupFollowers = (user) => Promise.resolve(user.followers)
	 *      lookupUser('JOE').then(lookupFollowers)
	 *
	 *      //  followersForUser :: String -> Promise [UserId]
	 *      const followersForUser = R.composeP(lookupFollowers, lookupUser);
	 *      followersForUser('JOE').then(followers => console.log('Followers:', followers))
	 *      // Followers: ["STEVE","SUZY"]
	 */
	
	
	function composeP() {
	  if (arguments.length === 0) {
	    throw new Error('composeP requires at least one argument');
	  }
	  return pipeP.apply(this, reverse(arguments));
	}
	module.exports = composeP;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var pipeWith = /*#__PURE__*/__webpack_require__(416);
	
	var reverse = /*#__PURE__*/__webpack_require__(87);
	
	/**
	 * Performs right-to-left function composition using transforming function. The rightmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * **Note:** The result of compose is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @category Function
	 * @sig ((* -> *), [(y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)]) -> ((a, b, ..., n) -> z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.compose, R.pipeWith
	 * @example
	 *
	 *      const composeWhileNotNil = R.composeWith((f, res) => R.isNil(res) ? res : f(res));
	 *
	 *      composeWhileNotNil([R.inc, R.prop('age')])({age: 1}) //=> 2
	 *      composeWhileNotNil([R.inc, R.prop('age')])({}) //=> undefined
	 *
	 * @symb R.composeWith(f)([g, h, i])(...args) = f(g, f(h, f(i, ...args)))
	 */
	
	
	var composeWith = /*#__PURE__*/_curry2(function composeWith(xf, list) {
	  return pipeWith.apply(this, [xf, reverse(list)]);
	});
	module.exports = composeWith;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(39);
	
	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var map = /*#__PURE__*/__webpack_require__(32);
	
	var max = /*#__PURE__*/__webpack_require__(73);
	
	var reduce = /*#__PURE__*/__webpack_require__(47);
	
	/**
	 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
	 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
	 * to `fn` are applied to each of the predicates in turn until one returns a
	 * "truthy" value, at which point `fn` returns the result of applying its
	 * arguments to the corresponding transformer. If none of the predicates
	 * matches, `fn` returns undefined.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Logic
	 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
	 * @param {Array} pairs A list of [predicate, transformer]
	 * @return {Function}
	 * @see R.ifElse, R.unless, R.when
	 * @example
	 *
	 *      const fn = R.cond([
	 *        [R.equals(0),   R.always('water freezes at 0°C')],
	 *        [R.equals(100), R.always('water boils at 100°C')],
	 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
	 *      ]);
	 *      fn(0); //=> 'water freezes at 0°C'
	 *      fn(50); //=> 'nothing special happens at 50°C'
	 *      fn(100); //=> 'water boils at 100°C'
	 */
	
	
	var cond = /*#__PURE__*/_curry1(function cond(pairs) {
	  var arity = reduce(max, 0, map(function (pair) {
	    return pair[0].length;
	  }, pairs));
	  return _arity(arity, function () {
	    var idx = 0;
	    while (idx < pairs.length) {
	      if (pairs[idx][0].apply(this, arguments)) {
	        return pairs[idx][1].apply(this, arguments);
	      }
	      idx += 1;
	    }
	  });
	});
	module.exports = cond;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var constructN = /*#__PURE__*/__webpack_require__(375);
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> {*}) -> (* -> {*})
	 * @param {Function} fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @see R.invoker
	 * @example
	 *
	 *      // Constructor function
	 *      function Animal(kind) {
	 *        this.kind = kind;
	 *      };
	 *      Animal.prototype.sighting = function() {
	 *        return "It's a " + this.kind + "!";
	 *      }
	 *
	 *      const AnimalConstructor = R.construct(Animal)
	 *
	 *      // Notice we no longer need the 'new' keyword:
	 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
	 *
	 *      const animalTypes = ["Lion", "Tiger", "Bear"];
	 *      const animalSighting = R.invoker(0, 'sighting');
	 *      const sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
	 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
	 */
	
	
	var construct = /*#__PURE__*/_curry1(function construct(Fn) {
	  return constructN(Fn.length, Fn);
	});
	module.exports = construct;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	var _includes = /*#__PURE__*/__webpack_require__(72);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
	 * terms, to at least one element of the given list; `false` otherwise.
	 * Works also with strings.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Boolean
	 * @param {Object} a The item to compare against.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
	 * @see R.includes
	 * @deprecated since v0.26.0
	 * @example
	 *
	 *      R.contains(3, [1, 2, 3]); //=> true
	 *      R.contains(4, [1, 2, 3]); //=> false
	 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
	 *      R.contains([42], [[42]]); //=> true
	 *      R.contains('ba', 'banana'); //=>true
	 */
	
	
	var contains = /*#__PURE__*/_curry2(_includes);
	module.exports = contains;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	var reduceBy = /*#__PURE__*/__webpack_require__(118);
	
	/**
	 * Counts the elements of a list according to how many match each value of a
	 * key generated by the supplied function. Returns an object mapping the keys
	 * produced by `fn` to the number of occurrences in the list. Note that all
	 * keys are coerced to strings because of how JavaScript objects work.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig (a -> String) -> [a] -> {*}
	 * @param {Function} fn The function used to map values to keys.
	 * @param {Array} list The list to count elements from.
	 * @return {Object} An object mapping keys to number of occurrences in the list.
	 * @example
	 *
	 *      const numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
	 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
	 *
	 *      const letters = ['a', 'b', 'A', 'a', 'B', 'c'];
	 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
	 */
	
	
	var countBy = /*#__PURE__*/reduceBy(function (acc, elem) {
	  return acc + 1;
	}, 0);
	module.exports = countBy;

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	var add = /*#__PURE__*/__webpack_require__(104);
	
	/**
	 * Decrements its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number} n - 1
	 * @see R.inc
	 * @example
	 *
	 *      R.dec(42); //=> 41
	 */
	
	
	var dec = /*#__PURE__*/add(-1);
	module.exports = dec;

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Makes a descending comparator function out of a function that returns a value
	 * that can be compared with `<` and `>`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Function
	 * @sig Ord b => (a -> b) -> a -> a -> Number
	 * @param {Function} fn A function of arity one that returns a value that can be compared
	 * @param {*} a The first item to be compared.
	 * @param {*} b The second item to be compared.
	 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
	 * @see R.ascend
	 * @example
	 *
	 *      const byAge = R.descend(R.prop('age'));
	 *      const people = [
	 *        { name: 'Emma', age: 70 },
	 *        { name: 'Peter', age: 78 },
	 *        { name: 'Mikhail', age: 62 },
	 *      ];
	 *      const peopleByOldestFirst = R.sort(byAge, people);
	 *        //=> [{ name: 'Peter', age: 78 }, { name: 'Emma', age: 70 }, { name: 'Mikhail', age: 62 }]
	 */
	
	
	var descend = /*#__PURE__*/_curry3(function descend(fn, a, b) {
	  var aa = fn(a);
	  var bb = fn(b);
	  return aa > bb ? -1 : aa < bb ? 1 : 0;
	});
	module.exports = descend;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _isInteger = /*#__PURE__*/__webpack_require__(158);
	
	var _isArray = /*#__PURE__*/__webpack_require__(50);
	
	var assoc = /*#__PURE__*/__webpack_require__(106);
	
	var dissoc = /*#__PURE__*/__webpack_require__(380);
	
	var remove = /*#__PURE__*/__webpack_require__(419);
	
	var update = /*#__PURE__*/__webpack_require__(166);
	
	/**
	 * Makes a shallow clone of an object, omitting the property at the given path.
	 * Note that this copies and flattens prototype properties onto the new object
	 * as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.11.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> {k: v} -> {k: v}
	 * @param {Array} path The path to the value to omit
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object without the property at path
	 * @see R.assocPath
	 * @example
	 *
	 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
	 */
	
	
	var dissocPath = /*#__PURE__*/_curry2(function dissocPath(path, obj) {
	  switch (path.length) {
	    case 0:
	      return obj;
	    case 1:
	      return _isInteger(path[0]) && _isArray(obj) ? remove(path[0], 1, obj) : dissoc(path[0], obj);
	    default:
	      var head = path[0];
	      var tail = Array.prototype.slice.call(path, 1);
	      if (obj[head] == null) {
	        return obj;
	      } else if (_isInteger(head) && _isArray(obj)) {
	        return update(head, dissocPath(tail, obj[head]), obj);
	      } else {
	        return assoc(head, dissocPath(tail, obj[head]), obj);
	      }
	  }
	});
	module.exports = dissocPath;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Divides two numbers. Equivalent to `a / b`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a / b`.
	 * @see R.multiply
	 * @example
	 *
	 *      R.divide(71, 100); //=> 0.71
	 *
	 *      const half = R.divide(R.__, 2);
	 *      half(42); //=> 21
	 *
	 *      const reciprocal = R.divide(1);
	 *      reciprocal(4);   //=> 0.25
	 */
	
	
	var divide = /*#__PURE__*/_curry2(function divide(a, b) {
	  return a / b;
	});
	module.exports = divide;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _dropLast = /*#__PURE__*/__webpack_require__(1058);
	
	var _xdropLast = /*#__PURE__*/__webpack_require__(1076);
	
	/**
	 * Returns a list containing all but the last `n` elements of the given `list`.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n The number of elements of `list` to skip.
	 * @param {Array} list The list of elements to consider.
	 * @return {Array} A copy of the list with only the first `list.length - n` elements
	 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
	 * @example
	 *
	 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
	 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
	 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
	 *      R.dropLast(3, 'ramda');               //=> 'ra'
	 */
	
	
	var dropLast = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable([], _xdropLast, _dropLast));
	module.exports = dropLast;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _dropLastWhile = /*#__PURE__*/__webpack_require__(1059);
	
	var _xdropLastWhile = /*#__PURE__*/__webpack_require__(1077);
	
	/**
	 * Returns a new list excluding all the tailing elements of a given list which
	 * satisfy the supplied predicate function. It passes each value from the right
	 * to the supplied predicate function, skipping elements until the predicate
	 * function returns a `falsy` value. The predicate function is applied to one argument:
	 * *(value)*.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @sig (a -> Boolean) -> String -> String
	 * @param {Function} predicate The function to be called on each element
	 * @param {Array} xs The collection to iterate over.
	 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
	 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
	 * @example
	 *
	 *      const lteThree = x => x <= 3;
	 *
	 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
	 *
	 *      R.dropLastWhile(x => x !== 'd' , 'Ramda'); //=> 'Ramd'
	 */
	
	
	var dropLastWhile = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable([], _xdropLastWhile, _dropLastWhile));
	module.exports = dropLastWhile;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _xdropRepeatsWith = /*#__PURE__*/__webpack_require__(398);
	
	var dropRepeatsWith = /*#__PURE__*/__webpack_require__(382);
	
	var equals = /*#__PURE__*/__webpack_require__(31);
	
	/**
	 * Returns a new list without any consecutively repeating elements.
	 * [`R.equals`](#equals) is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig [a] -> [a]
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
	 */
	
	
	var dropRepeats = /*#__PURE__*/_curry1( /*#__PURE__*/_dispatchable([], /*#__PURE__*/_xdropRepeatsWith(equals), /*#__PURE__*/dropRepeatsWith(equals)));
	module.exports = dropRepeats;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _xdropWhile = /*#__PURE__*/__webpack_require__(1078);
	
	var slice = /*#__PURE__*/__webpack_require__(42);
	
	/**
	 * Returns a new list excluding the leading elements of a given list which
	 * satisfy the supplied predicate function. It passes each value to the supplied
	 * predicate function, skipping elements while the predicate function returns
	 * `true`. The predicate function is applied to one argument: *(value)*.
	 *
	 * Dispatches to the `dropWhile` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @sig (a -> Boolean) -> String -> String
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} xs The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.takeWhile, R.transduce, R.addIndex
	 * @example
	 *
	 *      const lteTwo = x => x <= 2;
	 *
	 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
	 *
	 *      R.dropWhile(x => x !== 'd' , 'Ramda'); //=> 'da'
	 */
	
	
	var dropWhile = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['dropWhile'], _xdropWhile, function dropWhile(pred, xs) {
	  var idx = 0;
	  var len = xs.length;
	  while (idx < len && pred(xs[idx])) {
	    idx += 1;
	  }
	  return slice(idx, Infinity, xs);
	}));
	module.exports = dropWhile;

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _isFunction = /*#__PURE__*/__webpack_require__(81);
	
	var lift = /*#__PURE__*/__webpack_require__(115);
	
	var or = /*#__PURE__*/__webpack_require__(410);
	
	/**
	 * A function wrapping calls to the two functions in an `||` operation,
	 * returning the result of the first function if it is truth-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * truth-y value.
	 *
	 * In addition to functions, `R.either` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f a predicate
	 * @param {Function} g another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
	 * @see R.or
	 * @example
	 *
	 *      const gt10 = x => x > 10;
	 *      const even = x => x % 2 === 0;
	 *      const f = R.either(gt10, even);
	 *      f(101); //=> true
	 *      f(8); //=> true
	 *
	 *      R.either(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(55)
	 *      R.either([false, false, 'a'], [11]) // => [11, 11, "a"]
	 */
	
	
	var either = /*#__PURE__*/_curry2(function either(f, g) {
	  return _isFunction(f) ? function _either() {
	    return f.apply(this, arguments) || g.apply(this, arguments);
	  } : lift(or)(f, g);
	});
	module.exports = either;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var equals = /*#__PURE__*/__webpack_require__(31);
	
	var takeLast = /*#__PURE__*/__webpack_require__(422);
	
	/**
	 * Checks if a list ends with the provided sublist.
	 *
	 * Similarly, checks if a string ends with the provided substring.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category List
	 * @sig [a] -> [a] -> Boolean
	 * @sig String -> String -> Boolean
	 * @param {*} suffix
	 * @param {*} list
	 * @return {Boolean}
	 * @see R.startsWith
	 * @example
	 *
	 *      R.endsWith('c', 'abc')                //=> true
	 *      R.endsWith('b', 'abc')                //=> false
	 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
	 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
	 */
	
	
	var endsWith = /*#__PURE__*/_curry2(function (suffix, list) {
	  return equals(takeLast(suffix.length, list), suffix);
	});
	module.exports = endsWith;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var equals = /*#__PURE__*/__webpack_require__(31);
	
	/**
	 * Takes a function and two values in its domain and returns `true` if the
	 * values map to the same value in the codomain; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Relation
	 * @sig (a -> b) -> a -> a -> Boolean
	 * @param {Function} f
	 * @param {*} x
	 * @param {*} y
	 * @return {Boolean}
	 * @example
	 *
	 *      R.eqBy(Math.abs, 5, -5); //=> true
	 */
	
	
	var eqBy = /*#__PURE__*/_curry3(function eqBy(f, x, y) {
	  return equals(f(x), f(y));
	});
	module.exports = eqBy;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var equals = /*#__PURE__*/__webpack_require__(31);
	
	/**
	 * Reports whether two objects have the same value, in [`R.equals`](#equals)
	 * terms, for the specified property. Useful as a curried predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig k -> {k: v} -> {k: v} -> Boolean
	 * @param {String} prop The name of the property to compare
	 * @param {Object} obj1
	 * @param {Object} obj2
	 * @return {Boolean}
	 *
	 * @example
	 *
	 *      const o1 = { a: 1, b: 2, c: 3, d: 4 };
	 *      const o2 = { a: 10, b: 20, c: 3, d: 40 };
	 *      R.eqProps('a', o1, o2); //=> false
	 *      R.eqProps('c', o1, o2); //=> true
	 */
	
	
	var eqProps = /*#__PURE__*/_curry3(function eqProps(prop, obj1, obj2) {
	  return equals(obj1[prop], obj2[prop]);
	});
	module.exports = eqProps;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Creates a new object by recursively evolving a shallow copy of `object`,
	 * according to the `transformation` functions. All non-primitive properties
	 * are copied by reference.
	 *
	 * A `transformation` function will not be invoked if its corresponding key
	 * does not exist in the evolved object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
	 * @param {Object} transformations The object specifying transformation functions to apply
	 *        to the object.
	 * @param {Object} object The object to be transformed.
	 * @return {Object} The transformed object.
	 * @example
	 *
	 *      const tomato = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
	 *      const transformations = {
	 *        firstName: R.trim,
	 *        lastName: R.trim, // Will not get invoked.
	 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
	 *      };
	 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
	 */
	
	
	var evolve = /*#__PURE__*/_curry2(function evolve(transformations, object) {
	  var result = object instanceof Array ? [] : {};
	  var transformation, key, type;
	  for (key in object) {
	    transformation = transformations[key];
	    type = typeof transformation;
	    result[key] = type === 'function' ? transformation(object[key]) : transformation && type === 'object' ? evolve(transformation, object[key]) : object[key];
	  }
	  return result;
	});
	module.exports = evolve;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _xfind = /*#__PURE__*/__webpack_require__(1080);
	
	/**
	 * Returns the first element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Dispatches to the `find` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 *        desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
	 *      R.find(R.propEq('a', 4))(xs); //=> undefined
	 */
	
	
	var find = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['find'], _xfind, function find(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx += 1;
	  }
	}));
	module.exports = find;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _xfindIndex = /*#__PURE__*/__webpack_require__(1081);
	
	/**
	 * Returns the index of the first element of the list which matches the
	 * predicate, or `-1` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Number
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Number} The index of the element found, or `-1`.
	 * @see R.transduce
	 * @example
	 *
	 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
	 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
	 */
	
	
	var findIndex = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable([], _xfindIndex, function findIndex(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	}));
	module.exports = findIndex;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _xfindLast = /*#__PURE__*/__webpack_require__(1082);
	
	/**
	 * Returns the last element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
	 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
	 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
	 */
	
	
	var findLast = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable([], _xfindLast, function findLast(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx -= 1;
	  }
	}));
	module.exports = findLast;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _xfindLastIndex = /*#__PURE__*/__webpack_require__(1083);
	
	/**
	 * Returns the index of the last element of the list which matches the
	 * predicate, or `-1` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Number
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Number} The index of the element found, or `-1`.
	 * @see R.transduce
	 * @example
	 *
	 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
	 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
	 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
	 */
	
	
	var findLastIndex = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable([], _xfindLastIndex, function findLastIndex(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    if (fn(list[idx])) {
	      return idx;
	    }
	    idx -= 1;
	  }
	  return -1;
	}));
	module.exports = findLastIndex;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _makeFlat = /*#__PURE__*/__webpack_require__(395);
	
	/**
	 * Returns a new list by pulling every item out of it (and all its sub-arrays)
	 * and putting them in a new array, depth-first.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b]
	 * @param {Array} list The array to consider.
	 * @return {Array} The flattened list.
	 * @see R.unnest
	 * @example
	 *
	 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
	 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
	 */
	
	
	var flatten = /*#__PURE__*/_curry1( /*#__PURE__*/_makeFlat(true));
	module.exports = flatten;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = /*#__PURE__*/__webpack_require__(80);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Iterate over an input `list`, calling a provided function `fn` for each
	 * element in the list.
	 *
	 * `fn` receives one argument: *(value)*.
	 *
	 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.forEach` method. For more
	 * details on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
	 *
	 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
	 * the original array. In some libraries this function is named `each`.
	 *
	 * Dispatches to the `forEach` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> *) -> [a] -> [a]
	 * @param {Function} fn The function to invoke. Receives one argument, `value`.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} The original list.
	 * @see R.addIndex
	 * @example
	 *
	 *      const printXPlusFive = x => console.log(x + 5);
	 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
	 *      // logs 6
	 *      // logs 7
	 *      // logs 8
	 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
	 */
	
	
	var forEach = /*#__PURE__*/_curry2( /*#__PURE__*/_checkForMethod('forEach', function forEach(fn, list) {
	  var len = list.length;
	  var idx = 0;
	  while (idx < len) {
	    fn(list[idx]);
	    idx += 1;
	  }
	  return list;
	}));
	module.exports = forEach;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var keys = /*#__PURE__*/__webpack_require__(41);
	
	/**
	 * Iterate over an input `object`, calling a provided function `fn` for each
	 * key and value in the object.
	 *
	 * `fn` receives three argument: *(value, key, obj)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Object
	 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
	 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
	 * @param {Object} obj The object to iterate over.
	 * @return {Object} The original object.
	 * @example
	 *
	 *      const printKeyConcatValue = (value, key) => console.log(key + ':' + value);
	 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
	 *      // logs x:1
	 *      // logs y:2
	 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
	 */
	
	
	var forEachObjIndexed = /*#__PURE__*/_curry2(function forEachObjIndexed(fn, obj) {
	  var keyList = keys(obj);
	  var idx = 0;
	  while (idx < keyList.length) {
	    var key = keyList[idx];
	    fn(obj[key], key, obj);
	    idx += 1;
	  }
	  return obj;
	});
	module.exports = forEachObjIndexed;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Creates a new object from a list key-value pairs. If a key appears in
	 * multiple pairs, the rightmost pair is included in the object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [[k,v]] -> {k: v}
	 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
	 * @return {Object} The object made by pairing up `keys` and `values`.
	 * @see R.toPairs, R.pair
	 * @example
	 *
	 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
	 */
	
	
	var fromPairs = /*#__PURE__*/_curry1(function fromPairs(pairs) {
	  var result = {};
	  var idx = 0;
	  while (idx < pairs.length) {
	    result[pairs[idx][0]] = pairs[idx][1];
	    idx += 1;
	  }
	  return result;
	});
	module.exports = fromPairs;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = /*#__PURE__*/__webpack_require__(80);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var reduceBy = /*#__PURE__*/__webpack_require__(118);
	
	/**
	 * Splits a list into sub-lists stored in an object, based on the result of
	 * calling a String-returning function on each element, and grouping the
	 * results according to values returned.
	 *
	 * Dispatches to the `groupBy` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> String) -> [a] -> {String: [a]}
	 * @param {Function} fn Function :: a -> String
	 * @param {Array} list The array to group
	 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
	 *         that produced that key when passed to `fn`.
	 * @see R.reduceBy, R.transduce
	 * @example
	 *
	 *      const byGrade = R.groupBy(function(student) {
	 *        const score = student.score;
	 *        return score < 65 ? 'F' :
	 *               score < 70 ? 'D' :
	 *               score < 80 ? 'C' :
	 *               score < 90 ? 'B' : 'A';
	 *      });
	 *      const students = [{name: 'Abby', score: 84},
	 *                      {name: 'Eddy', score: 58},
	 *                      // ...
	 *                      {name: 'Jack', score: 69}];
	 *      byGrade(students);
	 *      // {
	 *      //   'A': [{name: 'Dianne', score: 99}],
	 *      //   'B': [{name: 'Abby', score: 84}]
	 *      //   // ...,
	 *      //   'F': [{name: 'Eddy', score: 58}]
	 *      // }
	 */
	
	
	var groupBy = /*#__PURE__*/_curry2( /*#__PURE__*/_checkForMethod('groupBy', /*#__PURE__*/reduceBy(function (acc, item) {
	  if (acc == null) {
	    acc = [];
	  }
	  acc.push(item);
	  return acc;
	}, null)));
	module.exports = groupBy;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Takes a list and returns a list of lists where each sublist's elements are
	 * all satisfied pairwise comparison according to the provided function.
	 * Only adjacent elements are passed to the comparison function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.21.0
	 * @category List
	 * @sig ((a, a) → Boolean) → [a] → [[a]]
	 * @param {Function} fn Function for determining whether two given (adjacent)
	 *        elements should be in the same group
	 * @param {Array} list The array to group. Also accepts a string, which will be
	 *        treated as a list of characters.
	 * @return {List} A list that contains sublists of elements,
	 *         whose concatenations are equal to the original list.
	 * @example
	 *
	 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
	 *
	 * R.groupWith((a, b) => a + 1 === b, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0, 1], [1, 2, 3], [5], [8], [13], [21]]
	 *
	 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
	 *
	 * R.groupWith(R.eqBy(isVowel), 'aestiou')
	 * //=> ['ae', 'st', 'iou']
	 */
	
	
	var groupWith = /*#__PURE__*/_curry2(function (fn, list) {
	  var res = [];
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    var nextidx = idx + 1;
	    while (nextidx < len && fn(list[nextidx - 1], list[nextidx])) {
	      nextidx += 1;
	    }
	    res.push(list.slice(idx, nextidx));
	    idx = nextidx;
	  }
	  return res;
	});
	module.exports = groupWith;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns `true` if the first argument is greater than the second; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @see R.lt
	 * @example
	 *
	 *      R.gt(2, 1); //=> true
	 *      R.gt(2, 2); //=> false
	 *      R.gt(2, 3); //=> false
	 *      R.gt('a', 'z'); //=> false
	 *      R.gt('z', 'a'); //=> true
	 */
	
	
	var gt = /*#__PURE__*/_curry2(function gt(a, b) {
	  return a > b;
	});
	module.exports = gt;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns `true` if the first argument is greater than or equal to the second;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Boolean}
	 * @see R.lte
	 * @example
	 *
	 *      R.gte(2, 1); //=> true
	 *      R.gte(2, 2); //=> true
	 *      R.gte(2, 3); //=> false
	 *      R.gte('a', 'z'); //=> false
	 *      R.gte('z', 'a'); //=> true
	 */
	
	
	var gte = /*#__PURE__*/_curry2(function gte(a, b) {
	  return a >= b;
	});
	module.exports = gte;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var hasPath = /*#__PURE__*/__webpack_require__(384);
	
	/**
	 * Returns whether or not an object has an own property with the specified name
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Object
	 * @sig s -> {s: x} -> Boolean
	 * @param {String} prop The name of the property to check for.
	 * @param {Object} obj The object to query.
	 * @return {Boolean} Whether the property exists.
	 * @example
	 *
	 *      const hasName = R.has('name');
	 *      hasName({name: 'alice'});   //=> true
	 *      hasName({name: 'bob'});     //=> true
	 *      hasName({});                //=> false
	 *
	 *      const point = {x: 0, y: 0};
	 *      const pointHas = R.has(R.__, point);
	 *      pointHas('x');  //=> true
	 *      pointHas('y');  //=> true
	 *      pointHas('z');  //=> false
	 */
	
	
	var has = /*#__PURE__*/_curry2(function has(prop, obj) {
	  return hasPath([prop], obj);
	});
	module.exports = has;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns whether or not an object or its prototype chain has a property with
	 * the specified name
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Object
	 * @sig s -> {s: x} -> Boolean
	 * @param {String} prop The name of the property to check for.
	 * @param {Object} obj The object to query.
	 * @return {Boolean} Whether the property exists.
	 * @example
	 *
	 *      function Rectangle(width, height) {
	 *        this.width = width;
	 *        this.height = height;
	 *      }
	 *      Rectangle.prototype.area = function() {
	 *        return this.width * this.height;
	 *      };
	 *
	 *      const square = new Rectangle(2, 2);
	 *      R.hasIn('width', square);  //=> true
	 *      R.hasIn('area', square);  //=> true
	 */
	
	
	var hasIn = /*#__PURE__*/_curry2(function hasIn(prop, obj) {
	  return prop in obj;
	});
	module.exports = hasIn;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	var _objectIs = /*#__PURE__*/__webpack_require__(396);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns true if its arguments are identical, false otherwise. Values are
	 * identical if they reference the same memory. `NaN` is identical to `NaN`;
	 * `0` and `-0` are not identical.
	 *
	 * Note this is merely a curried version of ES6 `Object.is`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      const o = {};
	 *      R.identical(o, o); //=> true
	 *      R.identical(1, 1); //=> true
	 *      R.identical(1, '1'); //=> false
	 *      R.identical([], []); //=> false
	 *      R.identical(0, -0); //=> false
	 *      R.identical(NaN, NaN); //=> true
	 */
	
	
	var identical = /*#__PURE__*/_curry2(_objectIs);
	module.exports = identical;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var curryN = /*#__PURE__*/__webpack_require__(18);
	
	/**
	 * Creates a function that will process either the `onTrue` or the `onFalse`
	 * function depending upon the result of the `condition` predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
	 * @param {Function} condition A predicate function
	 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
	 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
	 * @return {Function} A new function that will process either the `onTrue` or the `onFalse`
	 *                    function depending upon the result of the `condition` predicate.
	 * @see R.unless, R.when, R.cond
	 * @example
	 *
	 *      const incCount = R.ifElse(
	 *        R.has('count'),
	 *        R.over(R.lensProp('count'), R.inc),
	 *        R.assoc('count', 1)
	 *      );
	 *      incCount({});           //=> { count: 1 }
	 *      incCount({ count: 1 }); //=> { count: 2 }
	 */
	
	
	var ifElse = /*#__PURE__*/_curry3(function ifElse(condition, onTrue, onFalse) {
	  return curryN(Math.max(condition.length, onTrue.length, onFalse.length), function _ifElse() {
	    return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
	  });
	});
	module.exports = ifElse;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	var add = /*#__PURE__*/__webpack_require__(104);
	
	/**
	 * Increments its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number} n + 1
	 * @see R.dec
	 * @example
	 *
	 *      R.inc(42); //=> 43
	 */
	
	
	var inc = /*#__PURE__*/add(1);
	module.exports = inc;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	var _includes = /*#__PURE__*/__webpack_require__(72);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
	 * terms, to at least one element of the given list; `false` otherwise.
	 * Works also with strings.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Boolean
	 * @param {Object} a The item to compare against.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
	 * @see R.any
	 * @example
	 *
	 *      R.includes(3, [1, 2, 3]); //=> true
	 *      R.includes(4, [1, 2, 3]); //=> false
	 *      R.includes({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
	 *      R.includes([42], [[42]]); //=> true
	 *      R.includes('ba', 'banana'); //=>true
	 */
	
	
	var includes = /*#__PURE__*/_curry2(_includes);
	module.exports = includes;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {};
	module.exports.F = /*#__PURE__*/__webpack_require__(993);
	module.exports.T = /*#__PURE__*/__webpack_require__(994);
	module.exports.__ = /*#__PURE__*/__webpack_require__(995);
	module.exports.add = /*#__PURE__*/__webpack_require__(104);
	module.exports.addIndex = /*#__PURE__*/__webpack_require__(996);
	module.exports.adjust = /*#__PURE__*/__webpack_require__(368);
	module.exports.all = /*#__PURE__*/__webpack_require__(369);
	module.exports.allPass = /*#__PURE__*/__webpack_require__(997);
	module.exports.always = /*#__PURE__*/__webpack_require__(105);
	module.exports.and = /*#__PURE__*/__webpack_require__(370);
	module.exports.any = /*#__PURE__*/__webpack_require__(998);
	module.exports.anyPass = /*#__PURE__*/__webpack_require__(999);
	module.exports.ap = /*#__PURE__*/__webpack_require__(150);
	module.exports.aperture = /*#__PURE__*/__webpack_require__(1000);
	module.exports.append = /*#__PURE__*/__webpack_require__(1001);
	module.exports.apply = /*#__PURE__*/__webpack_require__(371);
	module.exports.applySpec = /*#__PURE__*/__webpack_require__(1002);
	module.exports.applyTo = /*#__PURE__*/__webpack_require__(1003);
	module.exports.ascend = /*#__PURE__*/__webpack_require__(1004);
	module.exports.assoc = /*#__PURE__*/__webpack_require__(106);
	module.exports.assocPath = /*#__PURE__*/__webpack_require__(372);
	module.exports.binary = /*#__PURE__*/__webpack_require__(1005);
	module.exports.bind = /*#__PURE__*/__webpack_require__(373);
	module.exports.both = /*#__PURE__*/__webpack_require__(1006);
	module.exports.call = /*#__PURE__*/__webpack_require__(1007);
	module.exports.chain = /*#__PURE__*/__webpack_require__(151);
	module.exports.clamp = /*#__PURE__*/__webpack_require__(1008);
	module.exports.clone = /*#__PURE__*/__webpack_require__(1009);
	module.exports.comparator = /*#__PURE__*/__webpack_require__(1010);
	module.exports.complement = /*#__PURE__*/__webpack_require__(1011);
	module.exports.compose = /*#__PURE__*/__webpack_require__(152);
	module.exports.composeK = /*#__PURE__*/__webpack_require__(374);
	module.exports.composeP = /*#__PURE__*/__webpack_require__(1012);
	module.exports.composeWith = /*#__PURE__*/__webpack_require__(1013);
	module.exports.concat = /*#__PURE__*/__webpack_require__(153);
	module.exports.cond = /*#__PURE__*/__webpack_require__(1014);
	module.exports.construct = /*#__PURE__*/__webpack_require__(1015);
	module.exports.constructN = /*#__PURE__*/__webpack_require__(375);
	module.exports.contains = /*#__PURE__*/__webpack_require__(1016);
	module.exports.converge = /*#__PURE__*/__webpack_require__(376);
	module.exports.countBy = /*#__PURE__*/__webpack_require__(1017);
	module.exports.curry = /*#__PURE__*/__webpack_require__(154);
	module.exports.curryN = /*#__PURE__*/__webpack_require__(18);
	module.exports.dec = /*#__PURE__*/__webpack_require__(1018);
	module.exports.defaultTo = /*#__PURE__*/__webpack_require__(377);
	module.exports.descend = /*#__PURE__*/__webpack_require__(1019);
	module.exports.difference = /*#__PURE__*/__webpack_require__(378);
	module.exports.differenceWith = /*#__PURE__*/__webpack_require__(379);
	module.exports.dissoc = /*#__PURE__*/__webpack_require__(380);
	module.exports.dissocPath = /*#__PURE__*/__webpack_require__(1020);
	module.exports.divide = /*#__PURE__*/__webpack_require__(1021);
	module.exports.drop = /*#__PURE__*/__webpack_require__(381);
	module.exports.dropLast = /*#__PURE__*/__webpack_require__(1022);
	module.exports.dropLastWhile = /*#__PURE__*/__webpack_require__(1023);
	module.exports.dropRepeats = /*#__PURE__*/__webpack_require__(1024);
	module.exports.dropRepeatsWith = /*#__PURE__*/__webpack_require__(382);
	module.exports.dropWhile = /*#__PURE__*/__webpack_require__(1025);
	module.exports.either = /*#__PURE__*/__webpack_require__(1026);
	module.exports.empty = /*#__PURE__*/__webpack_require__(383);
	module.exports.endsWith = /*#__PURE__*/__webpack_require__(1027);
	module.exports.eqBy = /*#__PURE__*/__webpack_require__(1028);
	module.exports.eqProps = /*#__PURE__*/__webpack_require__(1029);
	module.exports.equals = /*#__PURE__*/__webpack_require__(31);
	module.exports.evolve = /*#__PURE__*/__webpack_require__(1030);
	module.exports.filter = /*#__PURE__*/__webpack_require__(155);
	module.exports.find = /*#__PURE__*/__webpack_require__(1031);
	module.exports.findIndex = /*#__PURE__*/__webpack_require__(1032);
	module.exports.findLast = /*#__PURE__*/__webpack_require__(1033);
	module.exports.findLastIndex = /*#__PURE__*/__webpack_require__(1034);
	module.exports.flatten = /*#__PURE__*/__webpack_require__(1035);
	module.exports.flip = /*#__PURE__*/__webpack_require__(107);
	module.exports.forEach = /*#__PURE__*/__webpack_require__(1036);
	module.exports.forEachObjIndexed = /*#__PURE__*/__webpack_require__(1037);
	module.exports.fromPairs = /*#__PURE__*/__webpack_require__(1038);
	module.exports.groupBy = /*#__PURE__*/__webpack_require__(1039);
	module.exports.groupWith = /*#__PURE__*/__webpack_require__(1040);
	module.exports.gt = /*#__PURE__*/__webpack_require__(1041);
	module.exports.gte = /*#__PURE__*/__webpack_require__(1042);
	module.exports.has = /*#__PURE__*/__webpack_require__(1043);
	module.exports.hasIn = /*#__PURE__*/__webpack_require__(1044);
	module.exports.hasPath = /*#__PURE__*/__webpack_require__(384);
	module.exports.head = /*#__PURE__*/__webpack_require__(385);
	module.exports.identical = /*#__PURE__*/__webpack_require__(1045);
	module.exports.identity = /*#__PURE__*/__webpack_require__(108);
	module.exports.ifElse = /*#__PURE__*/__webpack_require__(1046);
	module.exports.inc = /*#__PURE__*/__webpack_require__(1047);
	module.exports.includes = /*#__PURE__*/__webpack_require__(1048);
	module.exports.indexBy = /*#__PURE__*/__webpack_require__(1050);
	module.exports.indexOf = /*#__PURE__*/__webpack_require__(1051);
	module.exports.init = /*#__PURE__*/__webpack_require__(1052);
	module.exports.innerJoin = /*#__PURE__*/__webpack_require__(1053);
	module.exports.insert = /*#__PURE__*/__webpack_require__(1054);
	module.exports.insertAll = /*#__PURE__*/__webpack_require__(1055);
	module.exports.intersection = /*#__PURE__*/__webpack_require__(1089);
	module.exports.intersperse = /*#__PURE__*/__webpack_require__(1090);
	module.exports.into = /*#__PURE__*/__webpack_require__(1091);
	module.exports.invert = /*#__PURE__*/__webpack_require__(1092);
	module.exports.invertObj = /*#__PURE__*/__webpack_require__(1093);
	module.exports.invoker = /*#__PURE__*/__webpack_require__(84);
	module.exports.is = /*#__PURE__*/__webpack_require__(400);
	module.exports.isEmpty = /*#__PURE__*/__webpack_require__(1094);
	module.exports.isNil = /*#__PURE__*/__webpack_require__(401);
	module.exports.join = /*#__PURE__*/__webpack_require__(1095);
	module.exports.juxt = /*#__PURE__*/__webpack_require__(402);
	module.exports.keys = /*#__PURE__*/__webpack_require__(41);
	module.exports.keysIn = /*#__PURE__*/__webpack_require__(1096);
	module.exports.last = /*#__PURE__*/__webpack_require__(403);
	module.exports.lastIndexOf = /*#__PURE__*/__webpack_require__(1097);
	module.exports.length = /*#__PURE__*/__webpack_require__(404);
	module.exports.lens = /*#__PURE__*/__webpack_require__(114);
	module.exports.lensIndex = /*#__PURE__*/__webpack_require__(1098);
	module.exports.lensPath = /*#__PURE__*/__webpack_require__(1099);
	module.exports.lensProp = /*#__PURE__*/__webpack_require__(1100);
	module.exports.lift = /*#__PURE__*/__webpack_require__(115);
	module.exports.liftN = /*#__PURE__*/__webpack_require__(405);
	module.exports.lt = /*#__PURE__*/__webpack_require__(1101);
	module.exports.lte = /*#__PURE__*/__webpack_require__(1102);
	module.exports.map = /*#__PURE__*/__webpack_require__(32);
	module.exports.mapAccum = /*#__PURE__*/__webpack_require__(1103);
	module.exports.mapAccumRight = /*#__PURE__*/__webpack_require__(1104);
	module.exports.mapObjIndexed = /*#__PURE__*/__webpack_require__(1105);
	module.exports.match = /*#__PURE__*/__webpack_require__(1106);
	module.exports.mathMod = /*#__PURE__*/__webpack_require__(1107);
	module.exports.max = /*#__PURE__*/__webpack_require__(73);
	module.exports.maxBy = /*#__PURE__*/__webpack_require__(1108);
	module.exports.mean = /*#__PURE__*/__webpack_require__(406);
	module.exports.median = /*#__PURE__*/__webpack_require__(1109);
	module.exports.memoizeWith = /*#__PURE__*/__webpack_require__(1110);
	module.exports.merge = /*#__PURE__*/__webpack_require__(1111);
	module.exports.mergeAll = /*#__PURE__*/__webpack_require__(1112);
	module.exports.mergeDeepLeft = /*#__PURE__*/__webpack_require__(1113);
	module.exports.mergeDeepRight = /*#__PURE__*/__webpack_require__(1114);
	module.exports.mergeDeepWith = /*#__PURE__*/__webpack_require__(1115);
	module.exports.mergeDeepWithKey = /*#__PURE__*/__webpack_require__(116);
	module.exports.mergeLeft = /*#__PURE__*/__webpack_require__(1116);
	module.exports.mergeRight = /*#__PURE__*/__webpack_require__(1117);
	module.exports.mergeWith = /*#__PURE__*/__webpack_require__(1118);
	module.exports.mergeWithKey = /*#__PURE__*/__webpack_require__(161);
	module.exports.min = /*#__PURE__*/__webpack_require__(1119);
	module.exports.minBy = /*#__PURE__*/__webpack_require__(1120);
	module.exports.modulo = /*#__PURE__*/__webpack_require__(1121);
	module.exports.move = /*#__PURE__*/__webpack_require__(1122);
	module.exports.multiply = /*#__PURE__*/__webpack_require__(407);
	module.exports.nAry = /*#__PURE__*/__webpack_require__(117);
	module.exports.negate = /*#__PURE__*/__webpack_require__(1123);
	module.exports.none = /*#__PURE__*/__webpack_require__(1124);
	module.exports.not = /*#__PURE__*/__webpack_require__(408);
	module.exports.nth = /*#__PURE__*/__webpack_require__(85);
	module.exports.nthArg = /*#__PURE__*/__webpack_require__(1125);
	module.exports.o = /*#__PURE__*/__webpack_require__(1126);
	module.exports.objOf = /*#__PURE__*/__webpack_require__(409);
	module.exports.of = /*#__PURE__*/__webpack_require__(1127);
	module.exports.omit = /*#__PURE__*/__webpack_require__(1128);
	module.exports.once = /*#__PURE__*/__webpack_require__(1129);
	module.exports.or = /*#__PURE__*/__webpack_require__(410);
	module.exports.otherwise = /*#__PURE__*/__webpack_require__(1130);
	module.exports.over = /*#__PURE__*/__webpack_require__(411);
	module.exports.pair = /*#__PURE__*/__webpack_require__(1131);
	module.exports.partial = /*#__PURE__*/__webpack_require__(1132);
	module.exports.partialRight = /*#__PURE__*/__webpack_require__(1133);
	module.exports.partition = /*#__PURE__*/__webpack_require__(1134);
	module.exports.path = /*#__PURE__*/__webpack_require__(74);
	module.exports.pathEq = /*#__PURE__*/__webpack_require__(1135);
	module.exports.pathOr = /*#__PURE__*/__webpack_require__(412);
	module.exports.pathSatisfies = /*#__PURE__*/__webpack_require__(1136);
	module.exports.pick = /*#__PURE__*/__webpack_require__(1137);
	module.exports.pickAll = /*#__PURE__*/__webpack_require__(413);
	module.exports.pickBy = /*#__PURE__*/__webpack_require__(1138);
	module.exports.pipe = /*#__PURE__*/__webpack_require__(414);
	module.exports.pipeK = /*#__PURE__*/__webpack_require__(1139);
	module.exports.pipeP = /*#__PURE__*/__webpack_require__(415);
	module.exports.pipeWith = /*#__PURE__*/__webpack_require__(416);
	module.exports.pluck = /*#__PURE__*/__webpack_require__(86);
	module.exports.prepend = /*#__PURE__*/__webpack_require__(417);
	module.exports.product = /*#__PURE__*/__webpack_require__(1140);
	module.exports.project = /*#__PURE__*/__webpack_require__(1141);
	module.exports.prop = /*#__PURE__*/__webpack_require__(162);
	module.exports.propEq = /*#__PURE__*/__webpack_require__(1142);
	module.exports.propIs = /*#__PURE__*/__webpack_require__(1143);
	module.exports.propOr = /*#__PURE__*/__webpack_require__(1144);
	module.exports.propSatisfies = /*#__PURE__*/__webpack_require__(1145);
	module.exports.props = /*#__PURE__*/__webpack_require__(1146);
	module.exports.range = /*#__PURE__*/__webpack_require__(1147);
	module.exports.reduce = /*#__PURE__*/__webpack_require__(47);
	module.exports.reduceBy = /*#__PURE__*/__webpack_require__(118);
	module.exports.reduceRight = /*#__PURE__*/__webpack_require__(418);
	module.exports.reduceWhile = /*#__PURE__*/__webpack_require__(1148);
	module.exports.reduced = /*#__PURE__*/__webpack_require__(1149);
	module.exports.reject = /*#__PURE__*/__webpack_require__(119);
	module.exports.remove = /*#__PURE__*/__webpack_require__(419);
	module.exports.repeat = /*#__PURE__*/__webpack_require__(1150);
	module.exports.replace = /*#__PURE__*/__webpack_require__(1151);
	module.exports.reverse = /*#__PURE__*/__webpack_require__(87);
	module.exports.scan = /*#__PURE__*/__webpack_require__(1152);
	module.exports.sequence = /*#__PURE__*/__webpack_require__(420);
	module.exports.set = /*#__PURE__*/__webpack_require__(1153);
	module.exports.slice = /*#__PURE__*/__webpack_require__(42);
	module.exports.sort = /*#__PURE__*/__webpack_require__(1154);
	module.exports.sortBy = /*#__PURE__*/__webpack_require__(1155);
	module.exports.sortWith = /*#__PURE__*/__webpack_require__(1156);
	module.exports.split = /*#__PURE__*/__webpack_require__(1157);
	module.exports.splitAt = /*#__PURE__*/__webpack_require__(1158);
	module.exports.splitEvery = /*#__PURE__*/__webpack_require__(1159);
	module.exports.splitWhen = /*#__PURE__*/__webpack_require__(1160);
	module.exports.startsWith = /*#__PURE__*/__webpack_require__(1161);
	module.exports.subtract = /*#__PURE__*/__webpack_require__(1162);
	module.exports.sum = /*#__PURE__*/__webpack_require__(421);
	module.exports.symmetricDifference = /*#__PURE__*/__webpack_require__(1163);
	module.exports.symmetricDifferenceWith = /*#__PURE__*/__webpack_require__(1164);
	module.exports.tail = /*#__PURE__*/__webpack_require__(120);
	module.exports.take = /*#__PURE__*/__webpack_require__(163);
	module.exports.takeLast = /*#__PURE__*/__webpack_require__(422);
	module.exports.takeLastWhile = /*#__PURE__*/__webpack_require__(1165);
	module.exports.takeWhile = /*#__PURE__*/__webpack_require__(1166);
	module.exports.tap = /*#__PURE__*/__webpack_require__(1167);
	module.exports.test = /*#__PURE__*/__webpack_require__(1168);
	module.exports.then = /*#__PURE__*/__webpack_require__(1169);
	module.exports.times = /*#__PURE__*/__webpack_require__(423);
	module.exports.toLower = /*#__PURE__*/__webpack_require__(1171);
	module.exports.toPairs = /*#__PURE__*/__webpack_require__(1172);
	module.exports.toPairsIn = /*#__PURE__*/__webpack_require__(1173);
	module.exports.toString = /*#__PURE__*/__webpack_require__(121);
	module.exports.toUpper = /*#__PURE__*/__webpack_require__(1174);
	module.exports.transduce = /*#__PURE__*/__webpack_require__(1175);
	module.exports.transpose = /*#__PURE__*/__webpack_require__(1176);
	module.exports.traverse = /*#__PURE__*/__webpack_require__(1177);
	module.exports.trim = /*#__PURE__*/__webpack_require__(1178);
	module.exports.tryCatch = /*#__PURE__*/__webpack_require__(1179);
	module.exports.type = /*#__PURE__*/__webpack_require__(164);
	module.exports.unapply = /*#__PURE__*/__webpack_require__(1180);
	module.exports.unary = /*#__PURE__*/__webpack_require__(1181);
	module.exports.uncurryN = /*#__PURE__*/__webpack_require__(1182);
	module.exports.unfold = /*#__PURE__*/__webpack_require__(1183);
	module.exports.union = /*#__PURE__*/__webpack_require__(1184);
	module.exports.unionWith = /*#__PURE__*/__webpack_require__(1185);
	module.exports.uniq = /*#__PURE__*/__webpack_require__(165);
	module.exports.uniqBy = /*#__PURE__*/__webpack_require__(424);
	module.exports.uniqWith = /*#__PURE__*/__webpack_require__(425);
	module.exports.unless = /*#__PURE__*/__webpack_require__(1186);
	module.exports.unnest = /*#__PURE__*/__webpack_require__(1187);
	module.exports.until = /*#__PURE__*/__webpack_require__(1188);
	module.exports.update = /*#__PURE__*/__webpack_require__(166);
	module.exports.useWith = /*#__PURE__*/__webpack_require__(426);
	module.exports.values = /*#__PURE__*/__webpack_require__(427);
	module.exports.valuesIn = /*#__PURE__*/__webpack_require__(1189);
	module.exports.view = /*#__PURE__*/__webpack_require__(1190);
	module.exports.when = /*#__PURE__*/__webpack_require__(1191);
	module.exports.where = /*#__PURE__*/__webpack_require__(428);
	module.exports.whereEq = /*#__PURE__*/__webpack_require__(1192);
	module.exports.without = /*#__PURE__*/__webpack_require__(1193);
	module.exports.xprod = /*#__PURE__*/__webpack_require__(1194);
	module.exports.zip = /*#__PURE__*/__webpack_require__(1195);
	module.exports.zipObj = /*#__PURE__*/__webpack_require__(1196);
	module.exports.zipWith = /*#__PURE__*/__webpack_require__(1197);
	module.exports.thunkify = /*#__PURE__*/__webpack_require__(1170);

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	var reduceBy = /*#__PURE__*/__webpack_require__(118);
	
	/**
	 * Given a function that generates a key, turns a list of objects into an
	 * object indexing the objects by the given key. Note that if multiple
	 * objects generate the same value for the indexing key only the last value
	 * will be included in the generated object.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
	 * @param {Function} fn Function :: a -> String
	 * @param {Array} array The array of objects to index
	 * @return {Object} An object indexing each array element by the given property.
	 * @example
	 *
	 *      const list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
	 *      R.indexBy(R.prop('id'), list);
	 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
	 */
	
	
	var indexBy = /*#__PURE__*/reduceBy(function (acc, elem) {
	  return elem;
	}, null);
	module.exports = indexBy;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _indexOf = /*#__PURE__*/__webpack_require__(392);
	
	var _isArray = /*#__PURE__*/__webpack_require__(50);
	
	/**
	 * Returns the position of the first occurrence of an item in an array, or -1
	 * if the item is not included in the array. [`R.equals`](#equals) is used to
	 * determine equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Number
	 * @param {*} target The item to find.
	 * @param {Array} xs The array to search in.
	 * @return {Number} the index of the target, or -1 if the target is not found.
	 * @see R.lastIndexOf
	 * @example
	 *
	 *      R.indexOf(3, [1,2,3,4]); //=> 2
	 *      R.indexOf(10, [1,2,3,4]); //=> -1
	 */
	
	
	var indexOf = /*#__PURE__*/_curry2(function indexOf(target, xs) {
	  return typeof xs.indexOf === 'function' && !_isArray(xs) ? xs.indexOf(target) : _indexOf(xs, target, 0);
	});
	module.exports = indexOf;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	var slice = /*#__PURE__*/__webpack_require__(42);
	
	/**
	 * Returns all but the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.last, R.head, R.tail
	 * @example
	 *
	 *      R.init([1, 2, 3]);  //=> [1, 2]
	 *      R.init([1, 2]);     //=> [1]
	 *      R.init([1]);        //=> []
	 *      R.init([]);         //=> []
	 *
	 *      R.init('abc');  //=> 'ab'
	 *      R.init('ab');   //=> 'a'
	 *      R.init('a');    //=> ''
	 *      R.init('');     //=> ''
	 */
	
	
	var init = /*#__PURE__*/slice(0, -1);
	module.exports = init;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	var _includesWith = /*#__PURE__*/__webpack_require__(110);
	
	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var _filter = /*#__PURE__*/__webpack_require__(156);
	
	/**
	 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
	 * `xs'` comprising each of the elements of `xs` which is equal to one or more
	 * elements of `ys` according to `pred`.
	 *
	 * `pred` must be a binary function expecting an element from each list.
	 *
	 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
	 * not be significant, but since `xs'` is ordered the implementation guarantees
	 * that its values are in the same order as they appear in `xs`. Duplicates are
	 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Relation
	 * @sig ((a, b) -> Boolean) -> [a] -> [b] -> [a]
	 * @param {Function} pred
	 * @param {Array} xs
	 * @param {Array} ys
	 * @return {Array}
	 * @see R.intersection
	 * @example
	 *
	 *      R.innerJoin(
	 *        (record, id) => record.id === id,
	 *        [{id: 824, name: 'Richie Furay'},
	 *         {id: 956, name: 'Dewey Martin'},
	 *         {id: 313, name: 'Bruce Palmer'},
	 *         {id: 456, name: 'Stephen Stills'},
	 *         {id: 177, name: 'Neil Young'}],
	 *        [177, 456, 999]
	 *      );
	 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
	 */
	
	
	var innerJoin = /*#__PURE__*/_curry3(function innerJoin(pred, xs, ys) {
	  return _filter(function (x) {
	    return _includesWith(pred, x, ys);
	  }, xs);
	});
	module.exports = innerJoin;

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Inserts the supplied element into the list, at the specified `index`. _Note that
	
	 * this is not destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} index The position to insert the element
	 * @param {*} elt The element to insert into the Array
	 * @param {Array} list The list to insert into
	 * @return {Array} A new Array with `elt` inserted at `index`.
	 * @example
	 *
	 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
	 */
	
	
	var insert = /*#__PURE__*/_curry3(function insert(idx, elt, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  var result = Array.prototype.slice.call(list, 0);
	  result.splice(idx, 0, elt);
	  return result;
	});
	module.exports = insert;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
	 * destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig Number -> [a] -> [a] -> [a]
	 * @param {Number} index The position to insert the sub-list
	 * @param {Array} elts The sub-list to insert into the Array
	 * @param {Array} list The list to insert the sub-list into
	 * @return {Array} A new Array with `elts` inserted starting at `index`.
	 * @example
	 *
	 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
	 */
	
	
	var insertAll = /*#__PURE__*/_curry3(function insertAll(idx, elts, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  return [].concat(Array.prototype.slice.call(list, 0, idx), elts, Array.prototype.slice.call(list, idx));
	});
	module.exports = insertAll;

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

	function _aperture(n, list) {
	  var idx = 0;
	  var limit = list.length - (n - 1);
	  var acc = new Array(limit >= 0 ? limit : 0);
	  while (idx < limit) {
	    acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
	    idx += 1;
	  }
	  return acc;
	}
	module.exports = _aperture;

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

	function _arrayFromIterator(iter) {
	  var list = [];
	  var next;
	  while (!(next = iter.next()).done) {
	    list.push(next.value);
	  }
	  return list;
	}
	module.exports = _arrayFromIterator;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	var take = /*#__PURE__*/__webpack_require__(163);
	
	function dropLast(n, xs) {
	  return take(n < xs.length ? xs.length - n : 0, xs);
	}
	module.exports = dropLast;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	var slice = /*#__PURE__*/__webpack_require__(42);
	
	function dropLastWhile(pred, xs) {
	  var idx = xs.length - 1;
	  while (idx >= 0 && pred(xs[idx])) {
	    idx -= 1;
	  }
	  return slice(0, idx + 1, xs);
	}
	module.exports = dropLastWhile;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	var _arrayFromIterator = /*#__PURE__*/__webpack_require__(1057);
	
	var _includesWith = /*#__PURE__*/__webpack_require__(110);
	
	var _functionName = /*#__PURE__*/__webpack_require__(1063);
	
	var _has = /*#__PURE__*/__webpack_require__(25);
	
	var _objectIs = /*#__PURE__*/__webpack_require__(396);
	
	var keys = /*#__PURE__*/__webpack_require__(41);
	
	var type = /*#__PURE__*/__webpack_require__(164);
	
	/**
	 * private _uniqContentEquals function.
	 * That function is checking equality of 2 iterator contents with 2 assumptions
	 * - iterators lengths are the same
	 * - iterators values are unique
	 *
	 * false-positive result will be returned for comparision of, e.g.
	 * - [1,2,3] and [1,2,3,4]
	 * - [1,1,1] and [1,2,3]
	 * */
	
	function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
	  var a = _arrayFromIterator(aIterator);
	  var b = _arrayFromIterator(bIterator);
	
	  function eq(_a, _b) {
	    return _equals(_a, _b, stackA.slice(), stackB.slice());
	  }
	
	  // if *a* array contains any element that is not included in *b*
	  return !_includesWith(function (b, aItem) {
	    return !_includesWith(eq, aItem, b);
	  }, b, a);
	}
	
	function _equals(a, b, stackA, stackB) {
	  if (_objectIs(a, b)) {
	    return true;
	  }
	
	  var typeA = type(a);
	
	  if (typeA !== type(b)) {
	    return false;
	  }
	
	  if (a == null || b == null) {
	    return false;
	  }
	
	  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
	    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
	  }
	
	  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
	    return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
	  }
	
	  switch (typeA) {
	    case 'Arguments':
	    case 'Array':
	    case 'Object':
	      if (typeof a.constructor === 'function' && _functionName(a.constructor) === 'Promise') {
	        return a === b;
	      }
	      break;
	    case 'Boolean':
	    case 'Number':
	    case 'String':
	      if (!(typeof a === typeof b && _objectIs(a.valueOf(), b.valueOf()))) {
	        return false;
	      }
	      break;
	    case 'Date':
	      if (!_objectIs(a.valueOf(), b.valueOf())) {
	        return false;
	      }
	      break;
	    case 'Error':
	      return a.name === b.name && a.message === b.message;
	    case 'RegExp':
	      if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
	        return false;
	      }
	      break;
	  }
	
	  var idx = stackA.length - 1;
	  while (idx >= 0) {
	    if (stackA[idx] === a) {
	      return stackB[idx] === b;
	    }
	    idx -= 1;
	  }
	
	  switch (typeA) {
	    case 'Map':
	      if (a.size !== b.size) {
	        return false;
	      }
	
	      return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));
	    case 'Set':
	      if (a.size !== b.size) {
	        return false;
	      }
	
	      return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));
	    case 'Arguments':
	    case 'Array':
	    case 'Object':
	    case 'Boolean':
	    case 'Number':
	    case 'String':
	    case 'Date':
	    case 'Error':
	    case 'RegExp':
	    case 'Int8Array':
	    case 'Uint8Array':
	    case 'Uint8ClampedArray':
	    case 'Int16Array':
	    case 'Uint16Array':
	    case 'Int32Array':
	    case 'Uint32Array':
	    case 'Float32Array':
	    case 'Float64Array':
	    case 'ArrayBuffer':
	      break;
	    default:
	      // Values of other types are only equal if identical.
	      return false;
	  }
	
	  var keysA = keys(a);
	  if (keysA.length !== keys(b).length) {
	    return false;
	  }
	
	  var extendedStackA = stackA.concat([a]);
	  var extendedStackB = stackB.concat([b]);
	
	  idx = keysA.length - 1;
	  while (idx >= 0) {
	    var key = keysA[idx];
	    if (!(_has(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
	      return false;
	    }
	    idx -= 1;
	  }
	  return true;
	}
	module.exports = _equals;

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	var _forceReduced = /*#__PURE__*/__webpack_require__(1062);
	
	var _isArrayLike = /*#__PURE__*/__webpack_require__(111);
	
	var _reduce = /*#__PURE__*/__webpack_require__(26);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var preservingReduced = function (xf) {
	  return {
	    '@@transducer/init': _xfBase.init,
	    '@@transducer/result': function (result) {
	      return xf['@@transducer/result'](result);
	    },
	    '@@transducer/step': function (result, input) {
	      var ret = xf['@@transducer/step'](result, input);
	      return ret['@@transducer/reduced'] ? _forceReduced(ret) : ret;
	    }
	  };
	};
	
	var _flatCat = function _xcat(xf) {
	  var rxf = preservingReduced(xf);
	  return {
	    '@@transducer/init': _xfBase.init,
	    '@@transducer/result': function (result) {
	      return rxf['@@transducer/result'](result);
	    },
	    '@@transducer/step': function (result, input) {
	      return !_isArrayLike(input) ? _reduce(rxf, result, [input]) : _reduce(rxf, result, input);
	    }
	  };
	};
	
	module.exports = _flatCat;

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

	function _forceReduced(x) {
	  return {
	    '@@transducer/value': x,
	    '@@transducer/reduced': true
	  };
	}
	module.exports = _forceReduced;

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

	function _functionName(f) {
	  // String(x => x) evaluates to "x => x", so the pattern may not match.
	  var match = String(f).match(/^function (\w*)/);
	  return match == null ? '' : match[1];
	}
	module.exports = _functionName;

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

	function _isRegExp(x) {
	  return Object.prototype.toString.call(x) === '[object RegExp]';
	}
	module.exports = _isRegExp;

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

	function _of(x) {
	  return [x];
	}
	module.exports = _of;

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

	function _pipe(f, g) {
	  return function () {
	    return g.call(this, f.apply(this, arguments));
	  };
	}
	module.exports = _pipe;

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

	function _pipeP(f, g) {
	  return function () {
	    var ctx = this;
	    return f.apply(ctx, arguments).then(function (x) {
	      return g.call(ctx, x);
	    });
	  };
	}
	module.exports = _pipeP;

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

	function _quote(s) {
	  var escaped = s.replace(/\\/g, '\\\\').replace(/[\b]/g, '\\b') // \b matches word boundary; [\b] matches backspace
	  .replace(/\f/g, '\\f').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\v/g, '\\v').replace(/\0/g, '\\0');
	
	  return '"' + escaped.replace(/"/g, '\\"') + '"';
	}
	module.exports = _quote;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	var _objectAssign = /*#__PURE__*/__webpack_require__(83);
	
	var _identity = /*#__PURE__*/__webpack_require__(157);
	
	var _isArrayLike = /*#__PURE__*/__webpack_require__(111);
	
	var _isTransformer = /*#__PURE__*/__webpack_require__(160);
	
	var objOf = /*#__PURE__*/__webpack_require__(409);
	
	var _stepCatArray = {
	  '@@transducer/init': Array,
	  '@@transducer/step': function (xs, x) {
	    xs.push(x);
	    return xs;
	  },
	  '@@transducer/result': _identity
	};
	var _stepCatString = {
	  '@@transducer/init': String,
	  '@@transducer/step': function (a, b) {
	    return a + b;
	  },
	  '@@transducer/result': _identity
	};
	var _stepCatObject = {
	  '@@transducer/init': Object,
	  '@@transducer/step': function (result, input) {
	    return _objectAssign(result, _isArrayLike(input) ? objOf(input[0], input[1]) : input);
	  },
	  '@@transducer/result': _identity
	};
	
	function _stepCat(obj) {
	  if (_isTransformer(obj)) {
	    return obj;
	  }
	  if (_isArrayLike(obj)) {
	    return _stepCatArray;
	  }
	  if (typeof obj === 'string') {
	    return _stepCatString;
	  }
	  if (typeof obj === 'object') {
	    return _stepCatObject;
	  }
	  throw new Error('Cannot create transformer for ' + obj);
	}
	module.exports = _stepCat;

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

	/**
	 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
	 */
	var pad = function pad(n) {
	  return (n < 10 ? '0' : '') + n;
	};
	
	var _toISOString = typeof Date.prototype.toISOString === 'function' ? function _toISOString(d) {
	  return d.toISOString();
	} : function _toISOString(d) {
	  return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds()) + '.' + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
	};
	
	module.exports = _toISOString;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _reduced = /*#__PURE__*/__webpack_require__(54);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var XAll = /*#__PURE__*/function () {
	
	  function XAll(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.all = true;
	  }
	  XAll.prototype['@@transducer/init'] = _xfBase.init;
	  XAll.prototype['@@transducer/result'] = function (result) {
	    if (this.all) {
	      result = this.xf['@@transducer/step'](result, true);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAll.prototype['@@transducer/step'] = function (result, input) {
	    if (!this.f(input)) {
	      this.all = false;
	      result = _reduced(this.xf['@@transducer/step'](result, false));
	    }
	    return result;
	  };
	
	  return XAll;
	}();
	
	var _xall = /*#__PURE__*/_curry2(function _xall(f, xf) {
	  return new XAll(f, xf);
	});
	module.exports = _xall;

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _reduced = /*#__PURE__*/__webpack_require__(54);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var XAny = /*#__PURE__*/function () {
	
	  function XAny(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.any = false;
	  }
	  XAny.prototype['@@transducer/init'] = _xfBase.init;
	  XAny.prototype['@@transducer/result'] = function (result) {
	    if (!this.any) {
	      result = this.xf['@@transducer/step'](result, false);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAny.prototype['@@transducer/step'] = function (result, input) {
	    if (this.f(input)) {
	      this.any = true;
	      result = _reduced(this.xf['@@transducer/step'](result, true));
	    }
	    return result;
	  };
	
	  return XAny;
	}();
	
	var _xany = /*#__PURE__*/_curry2(function _xany(f, xf) {
	  return new XAny(f, xf);
	});
	module.exports = _xany;

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(40);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var XAperture = /*#__PURE__*/function () {
	
	  function XAperture(n, xf) {
	    this.xf = xf;
	    this.pos = 0;
	    this.full = false;
	    this.acc = new Array(n);
	  }
	  XAperture.prototype['@@transducer/init'] = _xfBase.init;
	  XAperture.prototype['@@transducer/result'] = function (result) {
	    this.acc = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XAperture.prototype['@@transducer/step'] = function (result, input) {
	    this.store(input);
	    return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
	  };
	  XAperture.prototype.store = function (input) {
	    this.acc[this.pos] = input;
	    this.pos += 1;
	    if (this.pos === this.acc.length) {
	      this.pos = 0;
	      this.full = true;
	    }
	  };
	  XAperture.prototype.getCopy = function () {
	    return _concat(Array.prototype.slice.call(this.acc, this.pos), Array.prototype.slice.call(this.acc, 0, this.pos));
	  };
	
	  return XAperture;
	}();
	
	var _xaperture = /*#__PURE__*/_curry2(function _xaperture(n, xf) {
	  return new XAperture(n, xf);
	});
	module.exports = _xaperture;

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _flatCat = /*#__PURE__*/__webpack_require__(1061);
	
	var map = /*#__PURE__*/__webpack_require__(32);
	
	var _xchain = /*#__PURE__*/_curry2(function _xchain(f, xf) {
	  return map(f, _flatCat(xf));
	});
	module.exports = _xchain;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var XDrop = /*#__PURE__*/function () {
	
	  function XDrop(n, xf) {
	    this.xf = xf;
	    this.n = n;
	  }
	  XDrop.prototype['@@transducer/init'] = _xfBase.init;
	  XDrop.prototype['@@transducer/result'] = _xfBase.result;
	  XDrop.prototype['@@transducer/step'] = function (result, input) {
	    if (this.n > 0) {
	      this.n -= 1;
	      return result;
	    }
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return XDrop;
	}();
	
	var _xdrop = /*#__PURE__*/_curry2(function _xdrop(n, xf) {
	  return new XDrop(n, xf);
	});
	module.exports = _xdrop;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var XDropLast = /*#__PURE__*/function () {
	
	  function XDropLast(n, xf) {
	    this.xf = xf;
	    this.pos = 0;
	    this.full = false;
	    this.acc = new Array(n);
	  }
	  XDropLast.prototype['@@transducer/init'] = _xfBase.init;
	  XDropLast.prototype['@@transducer/result'] = function (result) {
	    this.acc = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropLast.prototype['@@transducer/step'] = function (result, input) {
	    if (this.full) {
	      result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
	    }
	    this.store(input);
	    return result;
	  };
	  XDropLast.prototype.store = function (input) {
	    this.acc[this.pos] = input;
	    this.pos += 1;
	    if (this.pos === this.acc.length) {
	      this.pos = 0;
	      this.full = true;
	    }
	  };
	
	  return XDropLast;
	}();
	
	var _xdropLast = /*#__PURE__*/_curry2(function _xdropLast(n, xf) {
	  return new XDropLast(n, xf);
	});
	module.exports = _xdropLast;

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _reduce = /*#__PURE__*/__webpack_require__(26);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var XDropLastWhile = /*#__PURE__*/function () {
	
	  function XDropLastWhile(fn, xf) {
	    this.f = fn;
	    this.retained = [];
	    this.xf = xf;
	  }
	  XDropLastWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XDropLastWhile.prototype['@@transducer/result'] = function (result) {
	    this.retained = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropLastWhile.prototype['@@transducer/step'] = function (result, input) {
	    return this.f(input) ? this.retain(result, input) : this.flush(result, input);
	  };
	  XDropLastWhile.prototype.flush = function (result, input) {
	    result = _reduce(this.xf['@@transducer/step'], result, this.retained);
	    this.retained = [];
	    return this.xf['@@transducer/step'](result, input);
	  };
	  XDropLastWhile.prototype.retain = function (result, input) {
	    this.retained.push(input);
	    return result;
	  };
	
	  return XDropLastWhile;
	}();
	
	var _xdropLastWhile = /*#__PURE__*/_curry2(function _xdropLastWhile(fn, xf) {
	  return new XDropLastWhile(fn, xf);
	});
	module.exports = _xdropLastWhile;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var XDropWhile = /*#__PURE__*/function () {
	
	  function XDropWhile(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XDropWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XDropWhile.prototype['@@transducer/result'] = _xfBase.result;
	  XDropWhile.prototype['@@transducer/step'] = function (result, input) {
	    if (this.f) {
	      if (this.f(input)) {
	        return result;
	      }
	      this.f = null;
	    }
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return XDropWhile;
	}();
	
	var _xdropWhile = /*#__PURE__*/_curry2(function _xdropWhile(f, xf) {
	  return new XDropWhile(f, xf);
	});
	module.exports = _xdropWhile;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var XFilter = /*#__PURE__*/function () {
	
	  function XFilter(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFilter.prototype['@@transducer/init'] = _xfBase.init;
	  XFilter.prototype['@@transducer/result'] = _xfBase.result;
	  XFilter.prototype['@@transducer/step'] = function (result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
	  };
	
	  return XFilter;
	}();
	
	var _xfilter = /*#__PURE__*/_curry2(function _xfilter(f, xf) {
	  return new XFilter(f, xf);
	});
	module.exports = _xfilter;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _reduced = /*#__PURE__*/__webpack_require__(54);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var XFind = /*#__PURE__*/function () {
	
	  function XFind(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.found = false;
	  }
	  XFind.prototype['@@transducer/init'] = _xfBase.init;
	  XFind.prototype['@@transducer/result'] = function (result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, void 0);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFind.prototype['@@transducer/step'] = function (result, input) {
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, input));
	    }
	    return result;
	  };
	
	  return XFind;
	}();
	
	var _xfind = /*#__PURE__*/_curry2(function _xfind(f, xf) {
	  return new XFind(f, xf);
	});
	module.exports = _xfind;

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _reduced = /*#__PURE__*/__webpack_require__(54);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var XFindIndex = /*#__PURE__*/function () {
	
	  function XFindIndex(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.idx = -1;
	    this.found = false;
	  }
	  XFindIndex.prototype['@@transducer/init'] = _xfBase.init;
	  XFindIndex.prototype['@@transducer/result'] = function (result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, -1);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFindIndex.prototype['@@transducer/step'] = function (result, input) {
	    this.idx += 1;
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, this.idx));
	    }
	    return result;
	  };
	
	  return XFindIndex;
	}();
	
	var _xfindIndex = /*#__PURE__*/_curry2(function _xfindIndex(f, xf) {
	  return new XFindIndex(f, xf);
	});
	module.exports = _xfindIndex;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var XFindLast = /*#__PURE__*/function () {
	
	  function XFindLast(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFindLast.prototype['@@transducer/init'] = _xfBase.init;
	  XFindLast.prototype['@@transducer/result'] = function (result) {
	    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
	  };
	  XFindLast.prototype['@@transducer/step'] = function (result, input) {
	    if (this.f(input)) {
	      this.last = input;
	    }
	    return result;
	  };
	
	  return XFindLast;
	}();
	
	var _xfindLast = /*#__PURE__*/_curry2(function _xfindLast(f, xf) {
	  return new XFindLast(f, xf);
	});
	module.exports = _xfindLast;

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var XFindLastIndex = /*#__PURE__*/function () {
	
	  function XFindLastIndex(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.idx = -1;
	    this.lastIdx = -1;
	  }
	  XFindLastIndex.prototype['@@transducer/init'] = _xfBase.init;
	  XFindLastIndex.prototype['@@transducer/result'] = function (result) {
	    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
	  };
	  XFindLastIndex.prototype['@@transducer/step'] = function (result, input) {
	    this.idx += 1;
	    if (this.f(input)) {
	      this.lastIdx = this.idx;
	    }
	    return result;
	  };
	
	  return XFindLastIndex;
	}();
	
	var _xfindLastIndex = /*#__PURE__*/_curry2(function _xfindLastIndex(f, xf) {
	  return new XFindLastIndex(f, xf);
	});
	module.exports = _xfindLastIndex;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var XMap = /*#__PURE__*/function () {
	
	  function XMap(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XMap.prototype['@@transducer/init'] = _xfBase.init;
	  XMap.prototype['@@transducer/result'] = _xfBase.result;
	  XMap.prototype['@@transducer/step'] = function (result, input) {
	    return this.xf['@@transducer/step'](result, this.f(input));
	  };
	
	  return XMap;
	}();
	
	var _xmap = /*#__PURE__*/_curry2(function _xmap(f, xf) {
	  return new XMap(f, xf);
	});
	module.exports = _xmap;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	var _curryN = /*#__PURE__*/__webpack_require__(109);
	
	var _has = /*#__PURE__*/__webpack_require__(25);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var XReduceBy = /*#__PURE__*/function () {
	
	  function XReduceBy(valueFn, valueAcc, keyFn, xf) {
	    this.valueFn = valueFn;
	    this.valueAcc = valueAcc;
	    this.keyFn = keyFn;
	    this.xf = xf;
	    this.inputs = {};
	  }
	  XReduceBy.prototype['@@transducer/init'] = _xfBase.init;
	  XReduceBy.prototype['@@transducer/result'] = function (result) {
	    var key;
	    for (key in this.inputs) {
	      if (_has(key, this.inputs)) {
	        result = this.xf['@@transducer/step'](result, this.inputs[key]);
	        if (result['@@transducer/reduced']) {
	          result = result['@@transducer/value'];
	          break;
	        }
	      }
	    }
	    this.inputs = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XReduceBy.prototype['@@transducer/step'] = function (result, input) {
	    var key = this.keyFn(input);
	    this.inputs[key] = this.inputs[key] || [key, this.valueAcc];
	    this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
	    return result;
	  };
	
	  return XReduceBy;
	}();
	
	var _xreduceBy = /*#__PURE__*/_curryN(4, [], function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
	  return new XReduceBy(valueFn, valueAcc, keyFn, xf);
	});
	module.exports = _xreduceBy;

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _reduced = /*#__PURE__*/__webpack_require__(54);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var XTake = /*#__PURE__*/function () {
	
	  function XTake(n, xf) {
	    this.xf = xf;
	    this.n = n;
	    this.i = 0;
	  }
	  XTake.prototype['@@transducer/init'] = _xfBase.init;
	  XTake.prototype['@@transducer/result'] = _xfBase.result;
	  XTake.prototype['@@transducer/step'] = function (result, input) {
	    this.i += 1;
	    var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
	    return this.n >= 0 && this.i >= this.n ? _reduced(ret) : ret;
	  };
	
	  return XTake;
	}();
	
	var _xtake = /*#__PURE__*/_curry2(function _xtake(n, xf) {
	  return new XTake(n, xf);
	});
	module.exports = _xtake;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _reduced = /*#__PURE__*/__webpack_require__(54);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var XTakeWhile = /*#__PURE__*/function () {
	
	  function XTakeWhile(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XTakeWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XTakeWhile.prototype['@@transducer/result'] = _xfBase.result;
	  XTakeWhile.prototype['@@transducer/step'] = function (result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : _reduced(result);
	  };
	
	  return XTakeWhile;
	}();
	
	var _xtakeWhile = /*#__PURE__*/_curry2(function _xtakeWhile(f, xf) {
	  return new XTakeWhile(f, xf);
	});
	module.exports = _xtakeWhile;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(16);
	
	var XTap = /*#__PURE__*/function () {
	
	  function XTap(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XTap.prototype['@@transducer/init'] = _xfBase.init;
	  XTap.prototype['@@transducer/result'] = _xfBase.result;
	  XTap.prototype['@@transducer/step'] = function (result, input) {
	    this.f(input);
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return XTap;
	}();
	
	var _xtap = /*#__PURE__*/_curry2(function _xtap(f, xf) {
	  return new XTap(f, xf);
	});
	module.exports = _xtap;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	var _includes = /*#__PURE__*/__webpack_require__(72);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _filter = /*#__PURE__*/__webpack_require__(156);
	
	var flip = /*#__PURE__*/__webpack_require__(107);
	
	var uniq = /*#__PURE__*/__webpack_require__(165);
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of those
	 * elements common to both lists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The list of elements found in both `list1` and `list2`.
	 * @see R.innerJoin
	 * @example
	 *
	 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
	 */
	
	
	var intersection = /*#__PURE__*/_curry2(function intersection(list1, list2) {
	  var lookupList, filteredList;
	  if (list1.length > list2.length) {
	    lookupList = list1;
	    filteredList = list2;
	  } else {
	    lookupList = list2;
	    filteredList = list1;
	  }
	  return uniq(_filter(flip(_includes)(lookupList), filteredList));
	});
	module.exports = intersection;

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = /*#__PURE__*/__webpack_require__(80);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Creates a new list with the separator interposed between elements.
	 *
	 * Dispatches to the `intersperse` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} separator The element to add to the list.
	 * @param {Array} list The list to be interposed.
	 * @return {Array} The new list.
	 * @example
	 *
	 *      R.intersperse('a', ['b', 'n', 'n', 's']); //=> ['b', 'a', 'n', 'a', 'n', 'a', 's']
	 */
	
	
	var intersperse = /*#__PURE__*/_curry2( /*#__PURE__*/_checkForMethod('intersperse', function intersperse(separator, list) {
	  var out = [];
	  var idx = 0;
	  var length = list.length;
	  while (idx < length) {
	    if (idx === length - 1) {
	      out.push(list[idx]);
	    } else {
	      out.push(list[idx], separator);
	    }
	    idx += 1;
	  }
	  return out;
	}));
	module.exports = intersperse;

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	var _clone = /*#__PURE__*/__webpack_require__(388);
	
	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var _isTransformer = /*#__PURE__*/__webpack_require__(160);
	
	var _reduce = /*#__PURE__*/__webpack_require__(26);
	
	var _stepCat = /*#__PURE__*/__webpack_require__(1069);
	
	/**
	 * Transforms the items of the list with the transducer and appends the
	 * transformed items to the accumulator using an appropriate iterator function
	 * based on the accumulator type.
	 *
	 * The accumulator can be an array, string, object or a transformer. Iterated
	 * items will be appended to arrays and concatenated to strings. Objects will
	 * be merged directly or 2-item arrays will be merged as key, value pairs.
	 *
	 * The accumulator can also be a transformer object that provides a 2-arity
	 * reducing iterator function, step, 0-arity initial value function, init, and
	 * 1-arity result extraction function result. The step function is used as the
	 * iterator function in reduce. The result function is used to convert the
	 * final accumulator into the return type and in most cases is R.identity. The
	 * init function is used to provide the initial accumulator.
	 *
	 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
	 * transducer.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig a -> (b -> b) -> [c] -> a
	 * @param {*} acc The initial accumulator value.
	 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.transduce
	 * @example
	 *
	 *      const numbers = [1, 2, 3, 4];
	 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
	 *
	 *      R.into([], transducer, numbers); //=> [2, 3]
	 *
	 *      const intoArray = R.into([]);
	 *      intoArray(transducer, numbers); //=> [2, 3]
	 */
	
	
	var into = /*#__PURE__*/_curry3(function into(acc, xf, list) {
	  return _isTransformer(acc) ? _reduce(xf(acc), acc['@@transducer/init'](), list) : _reduce(xf(_stepCat(acc)), _clone(acc, [], [], false), list);
	});
	module.exports = into;

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _has = /*#__PURE__*/__webpack_require__(25);
	
	var keys = /*#__PURE__*/__webpack_require__(41);
	
	/**
	 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
	 * duplicate values by putting the values into an array.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {s: x} -> {x: [ s, ... ]}
	 * @param {Object} obj The object or array to invert
	 * @return {Object} out A new object with keys in an array.
	 * @see R.invertObj
	 * @example
	 *
	 *      const raceResultsByFirstName = {
	 *        first: 'alice',
	 *        second: 'jake',
	 *        third: 'alice',
	 *      };
	 *      R.invert(raceResultsByFirstName);
	 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
	 */
	
	
	var invert = /*#__PURE__*/_curry1(function invert(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var idx = 0;
	  var out = {};
	
	  while (idx < len) {
	    var key = props[idx];
	    var val = obj[key];
	    var list = _has(val, out) ? out[val] : out[val] = [];
	    list[list.length] = key;
	    idx += 1;
	  }
	  return out;
	});
	module.exports = invert;

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var keys = /*#__PURE__*/__webpack_require__(41);
	
	/**
	 * Returns a new object with the keys of the given object as values, and the
	 * values of the given object, which are coerced to strings, as keys. Note
	 * that the last key found is preferred when handling the same value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {s: x} -> {x: s}
	 * @param {Object} obj The object or array to invert
	 * @return {Object} out A new object
	 * @see R.invert
	 * @example
	 *
	 *      const raceResults = {
	 *        first: 'alice',
	 *        second: 'jake'
	 *      };
	 *      R.invertObj(raceResults);
	 *      //=> { 'alice': 'first', 'jake':'second' }
	 *
	 *      // Alternatively:
	 *      const raceResults = ['alice', 'jake'];
	 *      R.invertObj(raceResults);
	 *      //=> { 'alice': '0', 'jake':'1' }
	 */
	
	
	var invertObj = /*#__PURE__*/_curry1(function invertObj(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var idx = 0;
	  var out = {};
	
	  while (idx < len) {
	    var key = props[idx];
	    out[obj[key]] = key;
	    idx += 1;
	  }
	  return out;
	});
	module.exports = invertObj;

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var empty = /*#__PURE__*/__webpack_require__(383);
	
	var equals = /*#__PURE__*/__webpack_require__(31);
	
	/**
	 * Returns `true` if the given value is its type's empty value; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> Boolean
	 * @param {*} x
	 * @return {Boolean}
	 * @see R.empty
	 * @example
	 *
	 *      R.isEmpty([1, 2, 3]);   //=> false
	 *      R.isEmpty([]);          //=> true
	 *      R.isEmpty('');          //=> true
	 *      R.isEmpty(null);        //=> false
	 *      R.isEmpty({});          //=> true
	 *      R.isEmpty({length: 0}); //=> false
	 */
	
	
	var isEmpty = /*#__PURE__*/_curry1(function isEmpty(x) {
	  return x != null && equals(x, empty(x));
	});
	module.exports = isEmpty;

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = /*#__PURE__*/__webpack_require__(84);
	
	/**
	 * Returns a string made by inserting the `separator` between each element and
	 * concatenating all the elements into a single string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig String -> [a] -> String
	 * @param {Number|String} separator The string used to separate the elements.
	 * @param {Array} xs The elements to join into a string.
	 * @return {String} str The string made by concatenating `xs` with `separator`.
	 * @see R.split
	 * @example
	 *
	 *      const spacer = R.join(' ');
	 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
	 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
	 */
	
	
	var join = /*#__PURE__*/invoker(1, 'join');
	module.exports = join;

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Returns a list containing the names of all the properties of the supplied
	 * object, including prototype properties.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own and prototype properties.
	 * @see R.keys, R.valuesIn
	 * @example
	 *
	 *      const F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      const f = new F();
	 *      R.keysIn(f); //=> ['x', 'y']
	 */
	
	
	var keysIn = /*#__PURE__*/_curry1(function keysIn(obj) {
	  var prop;
	  var ks = [];
	  for (prop in obj) {
	    ks[ks.length] = prop;
	  }
	  return ks;
	});
	module.exports = keysIn;

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _isArray = /*#__PURE__*/__webpack_require__(50);
	
	var equals = /*#__PURE__*/__webpack_require__(31);
	
	/**
	 * Returns the position of the last occurrence of an item in an array, or -1 if
	 * the item is not included in the array. [`R.equals`](#equals) is used to
	 * determine equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Number
	 * @param {*} target The item to find.
	 * @param {Array} xs The array to search in.
	 * @return {Number} the index of the target, or -1 if the target is not found.
	 * @see R.indexOf
	 * @example
	 *
	 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
	 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
	 */
	
	
	var lastIndexOf = /*#__PURE__*/_curry2(function lastIndexOf(target, xs) {
	  if (typeof xs.lastIndexOf === 'function' && !_isArray(xs)) {
	    return xs.lastIndexOf(target);
	  } else {
	    var idx = xs.length - 1;
	    while (idx >= 0) {
	      if (equals(xs[idx], target)) {
	        return idx;
	      }
	      idx -= 1;
	    }
	    return -1;
	  }
	});
	module.exports = lastIndexOf;

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var lens = /*#__PURE__*/__webpack_require__(114);
	
	var nth = /*#__PURE__*/__webpack_require__(85);
	
	var update = /*#__PURE__*/__webpack_require__(166);
	
	/**
	 * Returns a lens whose focus is the specified index.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Number -> Lens s a
	 * @param {Number} n
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      const headLens = R.lensIndex(0);
	 *
	 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
	 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
	 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
	 */
	
	
	var lensIndex = /*#__PURE__*/_curry1(function lensIndex(n) {
	  return lens(nth(n), update(n));
	});
	module.exports = lensIndex;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var assocPath = /*#__PURE__*/__webpack_require__(372);
	
	var lens = /*#__PURE__*/__webpack_require__(114);
	
	var path = /*#__PURE__*/__webpack_require__(74);
	
	/**
	 * Returns a lens whose focus is the specified path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig [Idx] -> Lens s a
	 * @param {Array} path The path to use.
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      const xHeadYLens = R.lensPath(['x', 0, 'y']);
	 *
	 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> 2
	 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
	 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
	 */
	
	
	var lensPath = /*#__PURE__*/_curry1(function lensPath(p) {
	  return lens(path(p), assocPath(p));
	});
	module.exports = lensPath;

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var assoc = /*#__PURE__*/__webpack_require__(106);
	
	var lens = /*#__PURE__*/__webpack_require__(114);
	
	var prop = /*#__PURE__*/__webpack_require__(162);
	
	/**
	 * Returns a lens whose focus is the specified property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig String -> Lens s a
	 * @param {String} k
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      const xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	
	
	var lensProp = /*#__PURE__*/_curry1(function lensProp(k) {
	  return lens(prop(k), assoc(k));
	});
	module.exports = lensProp;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns `true` if the first argument is less than the second; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @see R.gt
	 * @example
	 *
	 *      R.lt(2, 1); //=> false
	 *      R.lt(2, 2); //=> false
	 *      R.lt(2, 3); //=> true
	 *      R.lt('a', 'z'); //=> true
	 *      R.lt('z', 'a'); //=> false
	 */
	
	
	var lt = /*#__PURE__*/_curry2(function lt(a, b) {
	  return a < b;
	});
	module.exports = lt;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns `true` if the first argument is less than or equal to the second;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Boolean}
	 * @see R.gte
	 * @example
	 *
	 *      R.lte(2, 1); //=> false
	 *      R.lte(2, 2); //=> true
	 *      R.lte(2, 3); //=> true
	 *      R.lte('a', 'z'); //=> true
	 *      R.lte('z', 'a'); //=> false
	 */
	
	
	var lte = /*#__PURE__*/_curry2(function lte(a, b) {
	  return a <= b;
	});
	module.exports = lte;

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * The `mapAccum` function behaves like a combination of map and reduce; it
	 * applies a function to each element of a list, passing an accumulating
	 * parameter from left to right, and returning a final value of this
	 * accumulator together with the new list.
	 *
	 * The iterator function receives two arguments, *acc* and *value*, and should
	 * return a tuple *[acc, value]*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.scan, R.addIndex, R.mapAccumRight
	 * @example
	 *
	 *      const digits = ['1', '2', '3', '4'];
	 *      const appender = (a, b) => [a + b, a + b];
	 *
	 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
	 * @symb R.mapAccum(f, a, [b, c, d]) = [
	 *   f(f(f(a, b)[0], c)[0], d)[0],
	 *   [
	 *     f(a, b)[1],
	 *     f(f(a, b)[0], c)[1],
	 *     f(f(f(a, b)[0], c)[0], d)[1]
	 *   ]
	 * ]
	 */
	
	
	var mapAccum = /*#__PURE__*/_curry3(function mapAccum(fn, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	  var tuple = [acc];
	  while (idx < len) {
	    tuple = fn(tuple[0], list[idx]);
	    result[idx] = tuple[1];
	    idx += 1;
	  }
	  return [tuple[0], result];
	});
	module.exports = mapAccum;

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * The `mapAccumRight` function behaves like a combination of map and reduce; it
	 * applies a function to each element of a list, passing an accumulating
	 * parameter from right to left, and returning a final value of this
	 * accumulator together with the new list.
	 *
	 * Similar to [`mapAccum`](#mapAccum), except moves through the input list from
	 * the right to the left.
	 *
	 * The iterator function receives two arguments, *acc* and *value*, and should
	 * return a tuple *[acc, value]*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.addIndex, R.mapAccum
	 * @example
	 *
	 *      const digits = ['1', '2', '3', '4'];
	 *      const appender = (a, b) => [b + a, b + a];
	 *
	 *      R.mapAccumRight(appender, 5, digits); //=> ['12345', ['12345', '2345', '345', '45']]
	 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
	 *   f(f(f(a, d)[0], c)[0], b)[0],
	 *   [
	 *     f(a, d)[1],
	 *     f(f(a, d)[0], c)[1],
	 *     f(f(f(a, d)[0], c)[0], b)[1]
	 *   ]
	 * ]
	 */
	
	
	var mapAccumRight = /*#__PURE__*/_curry3(function mapAccumRight(fn, acc, list) {
	  var idx = list.length - 1;
	  var result = [];
	  var tuple = [acc];
	  while (idx >= 0) {
	    tuple = fn(tuple[0], list[idx]);
	    result[idx] = tuple[1];
	    idx -= 1;
	  }
	  return [tuple[0], result];
	});
	module.exports = mapAccumRight;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _reduce = /*#__PURE__*/__webpack_require__(26);
	
	var keys = /*#__PURE__*/__webpack_require__(41);
	
	/**
	 * An Object-specific version of [`map`](#map). The function is applied to three
	 * arguments: *(value, key, obj)*. If only the value is significant, use
	 * [`map`](#map) instead.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig ((*, String, Object) -> *) -> Object -> Object
	 * @param {Function} fn
	 * @param {Object} obj
	 * @return {Object}
	 * @see R.map
	 * @example
	 *
	 *      const xyz = { x: 1, y: 2, z: 3 };
	 *      const prependKeyAndDouble = (num, key, obj) => key + (num * 2);
	 *
	 *      R.mapObjIndexed(prependKeyAndDouble, xyz); //=> { x: 'x2', y: 'y4', z: 'z6' }
	 */
	
	
	var mapObjIndexed = /*#__PURE__*/_curry2(function mapObjIndexed(fn, obj) {
	  return _reduce(function (acc, key) {
	    acc[key] = fn(obj[key], key, obj);
	    return acc;
	  }, {}, keys(obj));
	});
	module.exports = mapObjIndexed;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Tests a regular expression against a String. Note that this function will
	 * return an empty array when there are no matches. This differs from
	 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
	 * which returns `null` when there are no matches.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category String
	 * @sig RegExp -> String -> [String | Undefined]
	 * @param {RegExp} rx A regular expression.
	 * @param {String} str The string to match against
	 * @return {Array} The list of matches or empty array.
	 * @see R.test
	 * @example
	 *
	 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
	 *      R.match(/a/, 'b'); //=> []
	 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
	 */
	
	
	var match = /*#__PURE__*/_curry2(function match(rx, str) {
	  return str.match(rx) || [];
	});
	module.exports = match;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _isInteger = /*#__PURE__*/__webpack_require__(158);
	
	/**
	 * `mathMod` behaves like the modulo operator should mathematically, unlike the
	 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
	 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
	 * arguments, and returns NaN when the modulus is zero or negative.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} m The dividend.
	 * @param {Number} p the modulus.
	 * @return {Number} The result of `b mod a`.
	 * @see R.modulo
	 * @example
	 *
	 *      R.mathMod(-17, 5);  //=> 3
	 *      R.mathMod(17, 5);   //=> 2
	 *      R.mathMod(17, -5);  //=> NaN
	 *      R.mathMod(17, 0);   //=> NaN
	 *      R.mathMod(17.2, 5); //=> NaN
	 *      R.mathMod(17, 5.3); //=> NaN
	 *
	 *      const clock = R.mathMod(R.__, 12);
	 *      clock(15); //=> 3
	 *      clock(24); //=> 0
	 *
	 *      const seventeenMod = R.mathMod(17);
	 *      seventeenMod(3);  //=> 2
	 *      seventeenMod(4);  //=> 1
	 *      seventeenMod(10); //=> 7
	 */
	
	
	var mathMod = /*#__PURE__*/_curry2(function mathMod(m, p) {
	  if (!_isInteger(m)) {
	    return NaN;
	  }
	  if (!_isInteger(p) || p < 1) {
	    return NaN;
	  }
	  return (m % p + p) % p;
	});
	module.exports = mathMod;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Takes a function and two values, and returns whichever value produces the
	 * larger result when passed to the provided function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> a -> a -> a
	 * @param {Function} f
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.max, R.minBy
	 * @example
	 *
	 *      //  square :: Number -> Number
	 *      const square = n => n * n;
	 *
	 *      R.maxBy(square, -3, 2); //=> -3
	 *
	 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
	 *      R.reduce(R.maxBy(square), 0, []); //=> 0
	 */
	
	
	var maxBy = /*#__PURE__*/_curry3(function maxBy(f, a, b) {
	  return f(b) > f(a) ? b : a;
	});
	module.exports = maxBy;

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var mean = /*#__PURE__*/__webpack_require__(406);
	
	/**
	 * Returns the median of the given list of numbers.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list
	 * @return {Number}
	 * @see R.mean
	 * @example
	 *
	 *      R.median([2, 9, 7]); //=> 7
	 *      R.median([7, 2, 10, 9]); //=> 8
	 *      R.median([]); //=> NaN
	 */
	
	
	var median = /*#__PURE__*/_curry1(function median(list) {
	  var len = list.length;
	  if (len === 0) {
	    return NaN;
	  }
	  var width = 2 - len % 2;
	  var idx = (len - width) / 2;
	  return mean(Array.prototype.slice.call(list, 0).sort(function (a, b) {
	    return a < b ? -1 : a > b ? 1 : 0;
	  }).slice(idx, idx + width));
	});
	module.exports = median;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(39);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _has = /*#__PURE__*/__webpack_require__(25);
	
	/**
	 * Creates a new function that, when invoked, caches the result of calling `fn`
	 * for a given argument set and returns the result. Subsequent calls to the
	 * memoized `fn` with the same argument set will not result in an additional
	 * call to `fn`; instead, the cached result for that set of arguments will be
	 * returned.
	 *
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Function
	 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
	 * @param {Function} fn The function to generate the cache key.
	 * @param {Function} fn The function to memoize.
	 * @return {Function} Memoized version of `fn`.
	 * @example
	 *
	 *      let count = 0;
	 *      const factorial = R.memoizeWith(R.identity, n => {
	 *        count += 1;
	 *        return R.product(R.range(1, n + 1));
	 *      });
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      count; //=> 1
	 */
	
	
	var memoizeWith = /*#__PURE__*/_curry2(function memoizeWith(mFn, fn) {
	  var cache = {};
	  return _arity(fn.length, function () {
	    var key = mFn.apply(this, arguments);
	    if (!_has(key, cache)) {
	      cache[key] = fn.apply(this, arguments);
	    }
	    return cache[key];
	  });
	});
	module.exports = memoizeWith;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	var _objectAssign = /*#__PURE__*/__webpack_require__(83);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Create a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects,
	 * the value from the second object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> {k: v} -> {k: v}
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeRight, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
	 * @deprecated
	 * @example
	 *
	 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
	 *      //=> { 'name': 'fred', 'age': 40 }
	 *
	 *      const withDefaults = R.merge({x: 0, y: 0});
	 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
	 * @symb R.merge(a, b) = {...a, ...b}
	 */
	
	
	var merge = /*#__PURE__*/_curry2(function merge(l, r) {
	  return _objectAssign({}, l, r);
	});
	module.exports = merge;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	var _objectAssign = /*#__PURE__*/__webpack_require__(83);
	
	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Merges a list of objects together into one object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig [{k: v}] -> {k: v}
	 * @param {Array} list An array of objects
	 * @return {Object} A merged object.
	 * @see R.reduce
	 * @example
	 *
	 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
	 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
	 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
	 */
	
	
	var mergeAll = /*#__PURE__*/_curry1(function mergeAll(list) {
	  return _objectAssign.apply(null, [{}].concat(list));
	});
	module.exports = mergeAll;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var mergeDeepWithKey = /*#__PURE__*/__webpack_require__(116);
	
	/**
	 * Creates a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects:
	 * - and both values are objects, the two values will be recursively merged
	 * - otherwise the value from the first object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Object
	 * @sig {a} -> {a} -> {a}
	 * @param {Object} lObj
	 * @param {Object} rObj
	 * @return {Object}
	 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
	 * @example
	 *
	 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
	 *                      { age: 40, contact: { email: 'baa@example.com' }});
	 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
	 */
	
	
	var mergeDeepLeft = /*#__PURE__*/_curry2(function mergeDeepLeft(lObj, rObj) {
	  return mergeDeepWithKey(function (k, lVal, rVal) {
	    return lVal;
	  }, lObj, rObj);
	});
	module.exports = mergeDeepLeft;

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var mergeDeepWithKey = /*#__PURE__*/__webpack_require__(116);
	
	/**
	 * Creates a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects:
	 * - and both values are objects, the two values will be recursively merged
	 * - otherwise the value from the second object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Object
	 * @sig {a} -> {a} -> {a}
	 * @param {Object} lObj
	 * @param {Object} rObj
	 * @return {Object}
	 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
	 * @example
	 *
	 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
	 *                       { age: 40, contact: { email: 'baa@example.com' }});
	 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
	 */
	
	
	var mergeDeepRight = /*#__PURE__*/_curry2(function mergeDeepRight(lObj, rObj) {
	  return mergeDeepWithKey(function (k, lVal, rVal) {
	    return rVal;
	  }, lObj, rObj);
	});
	module.exports = mergeDeepRight;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var mergeDeepWithKey = /*#__PURE__*/__webpack_require__(116);
	
	/**
	 * Creates a new object with the own properties of the two provided objects.
	 * If a key exists in both objects:
	 * - and both associated values are also objects then the values will be
	 *   recursively merged.
	 * - otherwise the provided function is applied to associated values using the
	 *   resulting value as the new value associated with the key.
	 * If a key only exists in one object, the value will be associated with the key
	 * of the resulting object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Object
	 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} lObj
	 * @param {Object} rObj
	 * @return {Object}
	 * @see R.mergeWith, R.mergeDeepWithKey
	 * @example
	 *
	 *      R.mergeDeepWith(R.concat,
	 *                      { a: true, c: { values: [10, 20] }},
	 *                      { b: true, c: { values: [15, 35] }});
	 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
	 */
	
	
	var mergeDeepWith = /*#__PURE__*/_curry3(function mergeDeepWith(fn, lObj, rObj) {
	  return mergeDeepWithKey(function (k, lVal, rVal) {
	    return fn(lVal, rVal);
	  }, lObj, rObj);
	});
	module.exports = mergeDeepWith;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	var _objectAssign = /*#__PURE__*/__webpack_require__(83);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Create a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects,
	 * the value from the first object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @category Object
	 * @sig {k: v} -> {k: v} -> {k: v}
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeRight, R.mergeDeepLeft, R.mergeWith, R.mergeWithKey
	 * @example
	 *
	 *      R.mergeLeft({ 'age': 40 }, { 'name': 'fred', 'age': 10 });
	 *      //=> { 'name': 'fred', 'age': 40 }
	 *
	 *      const resetToDefault = R.mergeLeft({x: 0});
	 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
	 * @symb R.mergeLeft(a, b) = {...b, ...a}
	 */
	
	
	var mergeLeft = /*#__PURE__*/_curry2(function mergeLeft(l, r) {
	  return _objectAssign({}, r, l);
	});
	module.exports = mergeLeft;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	var _objectAssign = /*#__PURE__*/__webpack_require__(83);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Create a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects,
	 * the value from the second object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @category Object
	 * @sig {k: v} -> {k: v} -> {k: v}
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeLeft, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
	 * @example
	 *
	 *      R.mergeRight({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
	 *      //=> { 'name': 'fred', 'age': 40 }
	 *
	 *      const withDefaults = R.mergeRight({x: 0, y: 0});
	 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
	 * @symb R.mergeRight(a, b) = {...a, ...b}
	 */
	
	
	var mergeRight = /*#__PURE__*/_curry2(function mergeRight(l, r) {
	  return _objectAssign({}, l, r);
	});
	module.exports = mergeRight;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var mergeWithKey = /*#__PURE__*/__webpack_require__(161);
	
	/**
	 * Creates a new object with the own properties of the two provided objects. If
	 * a key exists in both objects, the provided function is applied to the values
	 * associated with the key in each object, with the result being used as the
	 * value associated with the key in the returned object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeDeepWith, R.merge, R.mergeWithKey
	 * @example
	 *
	 *      R.mergeWith(R.concat,
	 *                  { a: true, values: [10, 20] },
	 *                  { b: true, values: [15, 35] });
	 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
	 */
	
	
	var mergeWith = /*#__PURE__*/_curry3(function mergeWith(fn, l, r) {
	  return mergeWithKey(function (_, _l, _r) {
	    return fn(_l, _r);
	  }, l, r);
	});
	module.exports = mergeWith;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns the smaller of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.minBy, R.max
	 * @example
	 *
	 *      R.min(789, 123); //=> 123
	 *      R.min('a', 'b'); //=> 'a'
	 */
	
	
	var min = /*#__PURE__*/_curry2(function min(a, b) {
	  return b < a ? b : a;
	});
	module.exports = min;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Takes a function and two values, and returns whichever value produces the
	 * smaller result when passed to the provided function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> a -> a -> a
	 * @param {Function} f
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.min, R.maxBy
	 * @example
	 *
	 *      //  square :: Number -> Number
	 *      const square = n => n * n;
	 *
	 *      R.minBy(square, -3, 2); //=> 2
	 *
	 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
	 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
	 */
	
	
	var minBy = /*#__PURE__*/_curry3(function minBy(f, a, b) {
	  return f(b) < f(a) ? b : a;
	});
	module.exports = minBy;

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Divides the first parameter by the second and returns the remainder. Note
	 * that this function preserves the JavaScript-style behavior for modulo. For
	 * mathematical modulo see [`mathMod`](#mathMod).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The value to the divide.
	 * @param {Number} b The pseudo-modulus
	 * @return {Number} The result of `b % a`.
	 * @see R.mathMod
	 * @example
	 *
	 *      R.modulo(17, 3); //=> 2
	 *      // JS behavior:
	 *      R.modulo(-17, 3); //=> -2
	 *      R.modulo(17, -3); //=> 2
	 *
	 *      const isOdd = R.modulo(R.__, 2);
	 *      isOdd(42); //=> 0
	 *      isOdd(21); //=> 1
	 */
	
	
	var modulo = /*#__PURE__*/_curry2(function modulo(a, b) {
	  return a % b;
	});
	module.exports = modulo;

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Move an item, at index `from`, to index `to`, in a list of elements.
	 * A new list will be created containing the new elements order.
	 *
	 * @func
	 * @memberOf R
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @param {Number} from The source index
	 * @param {Number} to The destination index
	 * @param {Array} list The list which will serve to realise the move
	 * @return {Array} The new list reordered
	 * @example
	 *
	 *      R.move(0, 2, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['b', 'c', 'a', 'd', 'e', 'f']
	 *      R.move(-1, 0, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['f', 'a', 'b', 'c', 'd', 'e'] list rotation
	 */
	
	
	var move = /*#__PURE__*/_curry3(function (from, to, list) {
	  var length = list.length;
	  var result = list.slice();
	  var positiveFrom = from < 0 ? length + from : from;
	  var positiveTo = to < 0 ? length + to : to;
	  var item = result.splice(positiveFrom, 1);
	
	  return positiveFrom < 0 || positiveFrom >= list.length || positiveTo < 0 || positiveTo >= list.length ? list : [].concat(result.slice(0, positiveTo)).concat(item).concat(result.slice(positiveTo, list.length));
	});
	
	module.exports = move;

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Negates its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number}
	 * @example
	 *
	 *      R.negate(42); //=> -42
	 */
	
	
	var negate = /*#__PURE__*/_curry1(function negate(n) {
	  return -n;
	});
	module.exports = negate;

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	var _complement = /*#__PURE__*/__webpack_require__(390);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var all = /*#__PURE__*/__webpack_require__(369);
	
	/**
	 * Returns `true` if no elements of the list match the predicate, `false`
	 * otherwise.
	 *
	 * Dispatches to the `all` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
	 * @see R.all, R.any
	 * @example
	 *
	 *      const isEven = n => n % 2 === 0;
	 *      const isOdd = n => n % 2 === 1;
	 *
	 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
	 *      R.none(isOdd, [1, 3, 5, 7, 8, 11]); //=> false
	 */
	
	
	var none = /*#__PURE__*/_curry2(function none(fn, input) {
	  return all(_complement(fn), input);
	});
	module.exports = none;

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var curryN = /*#__PURE__*/__webpack_require__(18);
	
	var nth = /*#__PURE__*/__webpack_require__(85);
	
	/**
	 * Returns a function which returns its nth argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig Number -> *... -> *
	 * @param {Number} n
	 * @return {Function}
	 * @example
	 *
	 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
	 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
	 * @symb R.nthArg(-1)(a, b, c) = c
	 * @symb R.nthArg(0)(a, b, c) = a
	 * @symb R.nthArg(1)(a, b, c) = b
	 */
	
	
	var nthArg = /*#__PURE__*/_curry1(function nthArg(n) {
	  var arity = n < 0 ? 1 : n + 1;
	  return curryN(arity, function () {
	    return nth(n, arguments);
	  });
	});
	module.exports = nthArg;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * `o` is a curried composition function that returns a unary function.
	 * Like [`compose`](#compose), `o` performs right-to-left function composition.
	 * Unlike [`compose`](#compose), the rightmost function passed to `o` will be
	 * invoked with only one argument. Also, unlike [`compose`](#compose), `o` is
	 * limited to accepting only 2 unary functions. The name o was chosen because
	 * of its similarity to the mathematical composition operator ∘.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Function
	 * @sig (b -> c) -> (a -> b) -> a -> c
	 * @param {Function} f
	 * @param {Function} g
	 * @return {Function}
	 * @see R.compose, R.pipe
	 * @example
	 *
	 *      const classyGreeting = name => "The name's " + name.last + ", " + name.first + " " + name.last
	 *      const yellGreeting = R.o(R.toUpper, classyGreeting);
	 *      yellGreeting({first: 'James', last: 'Bond'}); //=> "THE NAME'S BOND, JAMES BOND"
	 *
	 *      R.o(R.multiply(10), R.add(10))(-4) //=> 60
	 *
	 * @symb R.o(f, g, x) = f(g(x))
	 */
	
	
	var o = /*#__PURE__*/_curry3(function o(f, g, x) {
	  return f(g(x));
	});
	module.exports = o;

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _of = /*#__PURE__*/__webpack_require__(1065);
	
	/**
	 * Returns a singleton array containing the value provided.
	 *
	 * Note this `of` is different from the ES6 `of`; See
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> [a]
	 * @param {*} x any value
	 * @return {Array} An array wrapping `x`.
	 * @example
	 *
	 *      R.of(null); //=> [null]
	 *      R.of([42]); //=> [[42]]
	 */
	
	
	var of = /*#__PURE__*/_curry1(_of);
	module.exports = of;

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns a partial copy of an object omitting the keys specified.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [String] -> {String: *} -> {String: *}
	 * @param {Array} names an array of String property names to omit from the new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with properties from `names` not on it.
	 * @see R.pick
	 * @example
	 *
	 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
	 */
	
	
	var omit = /*#__PURE__*/_curry2(function omit(names, obj) {
	  var result = {};
	  var index = {};
	  var idx = 0;
	  var len = names.length;
	
	  while (idx < len) {
	    index[names[idx]] = 1;
	    idx += 1;
	  }
	
	  for (var prop in obj) {
	    if (!index.hasOwnProperty(prop)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});
	module.exports = omit;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(39);
	
	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Accepts a function `fn` and returns a function that guards invocation of
	 * `fn` such that `fn` can only ever be called once, no matter how many times
	 * the returned function is invoked. The first value calculated is returned in
	 * subsequent invocations.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a... -> b) -> (a... -> b)
	 * @param {Function} fn The function to wrap in a call-only-once wrapper.
	 * @return {Function} The wrapped function.
	 * @example
	 *
	 *      const addOneOnce = R.once(x => x + 1);
	 *      addOneOnce(10); //=> 11
	 *      addOneOnce(addOneOnce(50)); //=> 11
	 */
	
	
	var once = /*#__PURE__*/_curry1(function once(fn) {
	  var called = false;
	  var result;
	  return _arity(fn.length, function () {
	    if (called) {
	      return result;
	    }
	    called = true;
	    result = fn.apply(this, arguments);
	    return result;
	  });
	});
	module.exports = once;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _assertPromise = /*#__PURE__*/__webpack_require__(387);
	
	/**
	 * Returns the result of applying the onFailure function to the value inside
	 * a failed promise. This is useful for handling rejected promises
	 * inside function compositions.
	 *
	 * @func
	 * @memberOf R
	 * @category Function
	 * @sig (e -> b) -> (Promise e a) -> (Promise e b)
	 * @sig (e -> (Promise f b)) -> (Promise e a) -> (Promise f b)
	 * @param {Function} onFailure The function to apply. Can return a value or a promise of a value.
	 * @param {Promise} p
	 * @return {Promise} The result of calling `p.then(null, onFailure)`
	 * @see R.then
	 * @example
	 *
	 *      var failedFetch = (id) => Promise.reject('bad ID');
	 *      var useDefault = () => ({ firstName: 'Bob', lastName: 'Loblaw' })
	 *
	 *      //recoverFromFailure :: String -> Promise ({firstName, lastName})
	 *      var recoverFromFailure = R.pipe(
	 *        failedFetch,
	 *        R.otherwise(useDefault),
	 *        R.then(R.pick(['firstName', 'lastName'])),
	 *      );
	 *      recoverFromFailure(12345).then(console.log)
	 */
	
	
	var otherwise = /*#__PURE__*/_curry2(function otherwise(f, p) {
	  _assertPromise('otherwise', p);
	
	  return p.then(null, f);
	});
	module.exports = otherwise;

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category List
	 * @sig a -> b -> (a,b)
	 * @param {*} fst
	 * @param {*} snd
	 * @return {Array}
	 * @see R.objOf, R.of
	 * @example
	 *
	 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
	 */
	
	
	var pair = /*#__PURE__*/_curry2(function pair(fst, snd) {
	  return [fst, snd];
	});
	module.exports = pair;

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(40);
	
	var _createPartialApplicator = /*#__PURE__*/__webpack_require__(391);
	
	/**
	 * Takes a function `f` and a list of arguments, and returns a function `g`.
	 * When applied, `g` returns the result of applying `f` to the arguments
	 * provided initially followed by the arguments provided to `g`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
	 * @param {Function} f
	 * @param {Array} args
	 * @return {Function}
	 * @see R.partialRight, R.curry
	 * @example
	 *
	 *      const multiply2 = (a, b) => a * b;
	 *      const double = R.partial(multiply2, [2]);
	 *      double(2); //=> 4
	 *
	 *      const greet = (salutation, title, firstName, lastName) =>
	 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	 *
	 *      const sayHello = R.partial(greet, ['Hello']);
	 *      const sayHelloToMs = R.partial(sayHello, ['Ms.']);
	 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
	 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
	 */
	
	
	var partial = /*#__PURE__*/_createPartialApplicator(_concat);
	module.exports = partial;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(40);
	
	var _createPartialApplicator = /*#__PURE__*/__webpack_require__(391);
	
	var flip = /*#__PURE__*/__webpack_require__(107);
	
	/**
	 * Takes a function `f` and a list of arguments, and returns a function `g`.
	 * When applied, `g` returns the result of applying `f` to the arguments
	 * provided to `g` followed by the arguments provided initially.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
	 * @param {Function} f
	 * @param {Array} args
	 * @return {Function}
	 * @see R.partial
	 * @example
	 *
	 *      const greet = (salutation, title, firstName, lastName) =>
	 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	 *
	 *      const greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
	 *
	 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
	 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
	 */
	
	
	var partialRight = /*#__PURE__*/_createPartialApplicator( /*#__PURE__*/flip(_concat));
	module.exports = partialRight;

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	var filter = /*#__PURE__*/__webpack_require__(155);
	
	var juxt = /*#__PURE__*/__webpack_require__(402);
	
	var reject = /*#__PURE__*/__webpack_require__(119);
	
	/**
	 * Takes a predicate and a list or other `Filterable` object and returns the
	 * pair of filterable objects of the same type of elements which do and do not
	 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
	 * that has a filter method such as `Array`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
	 * @param {Function} pred A predicate to determine which side the element belongs to.
	 * @param {Array} filterable the list (or other filterable) to partition.
	 * @return {Array} An array, containing first the subset of elements that satisfy the
	 *         predicate, and second the subset of elements that do not satisfy.
	 * @see R.filter, R.reject
	 * @example
	 *
	 *      R.partition(R.includes('s'), ['sss', 'ttt', 'foo', 'bars']);
	 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
	 *
	 *      R.partition(R.includes('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
	 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
	 */
	
	
	var partition = /*#__PURE__*/juxt([filter, reject]);
	module.exports = partition;

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var equals = /*#__PURE__*/__webpack_require__(31);
	
	var path = /*#__PURE__*/__webpack_require__(74);
	
	/**
	 * Determines whether a nested path on an object has a specific value, in
	 * [`R.equals`](#equals) terms. Most likely used to filter a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Relation
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> Boolean
	 * @param {Array} path The path of the nested property to use
	 * @param {*} val The value to compare the nested property with
	 * @param {Object} obj The object to check the nested property in
	 * @return {Boolean} `true` if the value equals the nested object property,
	 *         `false` otherwise.
	 * @example
	 *
	 *      const user1 = { address: { zipCode: 90210 } };
	 *      const user2 = { address: { zipCode: 55555 } };
	 *      const user3 = { name: 'Bob' };
	 *      const users = [ user1, user2, user3 ];
	 *      const isFamous = R.pathEq(['address', 'zipCode'], 90210);
	 *      R.filter(isFamous, users); //=> [ user1 ]
	 */
	
	
	var pathEq = /*#__PURE__*/_curry3(function pathEq(_path, val, obj) {
	  return equals(path(_path, obj), val);
	});
	module.exports = pathEq;

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var path = /*#__PURE__*/__webpack_require__(74);
	
	/**
	 * Returns `true` if the specified object property at given path satisfies the
	 * given predicate; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Logic
	 * @typedefn Idx = String | Int
	 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
	 * @param {Function} pred
	 * @param {Array} propPath
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.propSatisfies, R.path
	 * @example
	 *
	 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
	 */
	
	
	var pathSatisfies = /*#__PURE__*/_curry3(function pathSatisfies(pred, propPath, obj) {
	  return propPath.length > 0 && pred(path(propPath, obj));
	});
	module.exports = pathSatisfies;

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns a partial copy of an object containing only the keys specified. If
	 * the key does not exist, the property is ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.omit, R.props
	 * @example
	 *
	 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
	 */
	
	
	var pick = /*#__PURE__*/_curry2(function pick(names, obj) {
	  var result = {};
	  var idx = 0;
	  while (idx < names.length) {
	    if (names[idx] in obj) {
	      result[names[idx]] = obj[names[idx]];
	    }
	    idx += 1;
	  }
	  return result;
	});
	module.exports = pick;

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns a partial copy of an object containing only the keys that satisfy
	 * the supplied predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig ((v, k) -> Boolean) -> {k: v} -> {k: v}
	 * @param {Function} pred A predicate to determine whether or not a key
	 *        should be included on the output object.
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties that satisfy `pred`
	 *         on it.
	 * @see R.pick, R.filter
	 * @example
	 *
	 *      const isUpperCase = (val, key) => key.toUpperCase() === key;
	 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
	 */
	
	
	var pickBy = /*#__PURE__*/_curry2(function pickBy(test, obj) {
	  var result = {};
	  for (var prop in obj) {
	    if (test(obj[prop], prop, obj)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});
	module.exports = pickBy;

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	var composeK = /*#__PURE__*/__webpack_require__(374);
	
	var reverse = /*#__PURE__*/__webpack_require__(87);
	
	/**
	 * Returns the left-to-right Kleisli composition of the provided functions,
	 * each of which must return a value of a type supported by [`chain`](#chain).
	 *
	 * `R.pipeK(f, g, h)` is equivalent to `R.pipe(f, R.chain(g), R.chain(h))`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Function
	 * @sig Chain m => ((a -> m b), (b -> m c), ..., (y -> m z)) -> (a -> m z)
	 * @param {...Function}
	 * @return {Function}
	 * @see R.composeK
	 * @deprecated since v0.26.0
	 * @example
	 *
	 *      //  parseJson :: String -> Maybe *
	 *      //  get :: String -> Object -> Maybe *
	 *
	 *      //  getStateCode :: Maybe String -> Maybe String
	 *      const getStateCode = R.pipeK(
	 *        parseJson,
	 *        get('user'),
	 *        get('address'),
	 *        get('state'),
	 *        R.compose(Maybe.of, R.toUpper)
	 *      );
	 *
	 *      getStateCode('{"user":{"address":{"state":"ny"}}}');
	 *      //=> Just('NY')
	 *      getStateCode('[Invalid JSON]');
	 *      //=> Nothing()
	 * @symb R.pipeK(f, g, h)(a) = R.chain(h, R.chain(g, f(a)))
	 */
	
	
	function pipeK() {
	  if (arguments.length === 0) {
	    throw new Error('pipeK requires at least one argument');
	  }
	  return composeK.apply(this, reverse(arguments));
	}
	module.exports = pipeK;

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	var multiply = /*#__PURE__*/__webpack_require__(407);
	
	var reduce = /*#__PURE__*/__webpack_require__(47);
	
	/**
	 * Multiplies together all the elements of a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list An array of numbers
	 * @return {Number} The product of all the numbers in the list.
	 * @see R.reduce
	 * @example
	 *
	 *      R.product([2,4,6,8,100,1]); //=> 38400
	 */
	
	
	var product = /*#__PURE__*/reduce(multiply, 1);
	module.exports = product;

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	var _map = /*#__PURE__*/__webpack_require__(113);
	
	var identity = /*#__PURE__*/__webpack_require__(108);
	
	var pickAll = /*#__PURE__*/__webpack_require__(413);
	
	var useWith = /*#__PURE__*/__webpack_require__(426);
	
	/**
	 * Reasonable analog to SQL `select` statement.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @category Relation
	 * @sig [k] -> [{k: v}] -> [{k: v}]
	 * @param {Array} props The property names to project
	 * @param {Array} objs The objects to query
	 * @return {Array} An array of objects with just the `props` properties.
	 * @example
	 *
	 *      const abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
	 *      const fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
	 *      const kids = [abby, fred];
	 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
	 */
	
	
	var project = /*#__PURE__*/useWith(_map, [pickAll, identity]); // passing `identity` gives correct arity
	module.exports = project;

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var equals = /*#__PURE__*/__webpack_require__(31);
	
	/**
	 * Returns `true` if the specified object property is equal, in
	 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
	 * You can test multiple properties with [`R.whereEq`](#whereEq).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig String -> a -> Object -> Boolean
	 * @param {String} name
	 * @param {*} val
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.whereEq, R.propSatisfies, R.equals
	 * @example
	 *
	 *      const abby = {name: 'Abby', age: 7, hair: 'blond'};
	 *      const fred = {name: 'Fred', age: 12, hair: 'brown'};
	 *      const rusty = {name: 'Rusty', age: 10, hair: 'brown'};
	 *      const alois = {name: 'Alois', age: 15, disposition: 'surly'};
	 *      const kids = [abby, fred, rusty, alois];
	 *      const hasBrownHair = R.propEq('hair', 'brown');
	 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
	 */
	
	
	var propEq = /*#__PURE__*/_curry3(function propEq(name, val, obj) {
	  return equals(val, obj[name]);
	});
	module.exports = propEq;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var is = /*#__PURE__*/__webpack_require__(400);
	
	/**
	 * Returns `true` if the specified object property is of the given type;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Type
	 * @sig Type -> String -> Object -> Boolean
	 * @param {Function} type
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.is, R.propSatisfies
	 * @example
	 *
	 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
	 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
	 *      R.propIs(Number, 'x', {});            //=> false
	 */
	
	
	var propIs = /*#__PURE__*/_curry3(function propIs(type, name, obj) {
	  return is(type, obj[name]);
	});
	module.exports = propIs;

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var pathOr = /*#__PURE__*/__webpack_require__(412);
	
	/**
	 * If the given, non-null object has an own property with the specified name,
	 * returns the value of that property. Otherwise returns the provided default
	 * value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Object
	 * @sig a -> String -> Object -> a
	 * @param {*} val The default value.
	 * @param {String} p The name of the property to return.
	 * @param {Object} obj The object to query.
	 * @return {*} The value of given property of the supplied object or the default value.
	 * @example
	 *
	 *      const alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      const favorite = R.prop('favoriteLibrary');
	 *      const favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
	 *
	 *      favorite(alice);  //=> undefined
	 *      favoriteWithDefault(alice);  //=> 'Ramda'
	 */
	
	
	var propOr = /*#__PURE__*/_curry3(function propOr(val, p, obj) {
	  return pathOr(val, [p], obj);
	});
	module.exports = propOr;

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Returns `true` if the specified object property satisfies the given
	 * predicate; `false` otherwise. You can test multiple properties with
	 * [`R.where`](#where).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Logic
	 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
	 * @param {Function} pred
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.where, R.propEq, R.propIs
	 * @example
	 *
	 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
	 */
	
	
	var propSatisfies = /*#__PURE__*/_curry3(function propSatisfies(pred, name, obj) {
	  return pred(obj[name]);
	});
	module.exports = propSatisfies;

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> [v]
	 * @param {Array} ps The property names to fetch
	 * @param {Object} obj The object to query
	 * @return {Array} The corresponding values or partially applied function.
	 * @example
	 *
	 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
	 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
	 *
	 *      const fullName = R.compose(R.join(' '), R.props(['first', 'last']));
	 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
	 */
	
	
	var props = /*#__PURE__*/_curry2(function props(ps, obj) {
	  var len = ps.length;
	  var out = [];
	  var idx = 0;
	
	  while (idx < len) {
	    out[idx] = obj[ps[idx]];
	    idx += 1;
	  }
	
	  return out;
	});
	module.exports = props;

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _isNumber = /*#__PURE__*/__webpack_require__(394);
	
	/**
	 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> Number -> [Number]
	 * @param {Number} from The first number in the list.
	 * @param {Number} to One more than the last number in the list.
	 * @return {Array} The list of numbers in the set `[a, b)`.
	 * @example
	 *
	 *      R.range(1, 5);    //=> [1, 2, 3, 4]
	 *      R.range(50, 53);  //=> [50, 51, 52]
	 */
	
	
	var range = /*#__PURE__*/_curry2(function range(from, to) {
	  if (!(_isNumber(from) && _isNumber(to))) {
	    throw new TypeError('Both arguments to range must be numbers');
	  }
	  var result = [];
	  var n = from;
	  while (n < to) {
	    result.push(n);
	    n += 1;
	  }
	  return result;
	});
	module.exports = range;

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	var _curryN = /*#__PURE__*/__webpack_require__(109);
	
	var _reduce = /*#__PURE__*/__webpack_require__(26);
	
	var _reduced = /*#__PURE__*/__webpack_require__(54);
	
	/**
	 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
	 * through the list, successively calling the iterator function. `reduceWhile`
	 * also takes a predicate that is evaluated before each step. If the predicate
	 * returns `false`, it "short-circuits" the iteration and returns the current
	 * value of the accumulator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.22.0
	 * @category List
	 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} pred The predicate. It is passed the accumulator and the
	 *        current element.
	 * @param {Function} fn The iterator function. Receives two values, the
	 *        accumulator and the current element.
	 * @param {*} a The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.reduced
	 * @example
	 *
	 *      const isOdd = (acc, x) => x % 2 === 1;
	 *      const xs = [1, 3, 5, 60, 777, 800];
	 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
	 *
	 *      const ys = [2, 4, 6]
	 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
	 */
	
	
	var reduceWhile = /*#__PURE__*/_curryN(4, [], function _reduceWhile(pred, fn, a, list) {
	  return _reduce(function (acc, x) {
	    return pred(acc, x) ? fn(acc, x) : _reduced(acc);
	  }, a, list);
	});
	module.exports = reduceWhile;

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _reduced = /*#__PURE__*/__webpack_require__(54);
	
	/**
	 * Returns a value wrapped to indicate that it is the final value of the reduce
	 * and transduce functions. The returned value should be considered a black
	 * box: the internal structure is not guaranteed to be stable.
	 *
	 * Note: this optimization is only available to the below functions:
	 * - [`reduce`](#reduce)
	 * - [`reduceWhile`](#reduceWhile)
	 * - [`transduce`](#transduce)
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category List
	 * @sig a -> *
	 * @param {*} x The final value of the reduce.
	 * @return {*} The wrapped value.
	 * @see R.reduce, R.reduceWhile, R.transduce
	 * @example
	 *
	 *     R.reduce(
	 *       (acc, item) => item > 3 ? R.reduced(acc) : acc.concat(item),
	 *       [],
	 *       [1, 2, 3, 4, 5]) // [1, 2, 3]
	 */
	
	
	var reduced = /*#__PURE__*/_curry1(_reduced);
	module.exports = reduced;

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var always = /*#__PURE__*/__webpack_require__(105);
	
	var times = /*#__PURE__*/__webpack_require__(423);
	
	/**
	 * Returns a fixed list of size `n` containing a specified identical value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig a -> n -> [a]
	 * @param {*} value The value to repeat.
	 * @param {Number} n The desired size of the output list.
	 * @return {Array} A new array containing `n` `value`s.
	 * @see R.times
	 * @example
	 *
	 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
	 *
	 *      const obj = {};
	 *      const repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
	 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
	 * @symb R.repeat(a, 0) = []
	 * @symb R.repeat(a, 1) = [a]
	 * @symb R.repeat(a, 2) = [a, a]
	 */
	
	
	var repeat = /*#__PURE__*/_curry2(function repeat(value, n) {
	  return times(always(value), n);
	});
	module.exports = repeat;

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Replace a substring or regex match in a string with a replacement.
	 *
	 * The first two parameters correspond to the parameters of the
	 * `String.prototype.replace()` function, so the second parameter can also be a
	 * function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category String
	 * @sig RegExp|String -> String -> String -> String
	 * @param {RegExp|String} pattern A regular expression or a substring to match.
	 * @param {String} replacement The string to replace the matches with.
	 * @param {String} str The String to do the search and replacement in.
	 * @return {String} The result.
	 * @example
	 *
	 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
	 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
	 *
	 *      // Use the "g" (global) flag to replace all occurrences:
	 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
	 */
	
	
	var replace = /*#__PURE__*/_curry3(function replace(regex, replacement, str) {
	  return str.replace(regex, replacement);
	});
	module.exports = replace;

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Scan is similar to [`reduce`](#reduce), but returns a list of successively
	 * reduced values from the left
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> [b] -> [a]
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} A list of all intermediately reduced values.
	 * @see R.reduce, R.mapAccum
	 * @example
	 *
	 *      const numbers = [1, 2, 3, 4];
	 *      const factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
	 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
	 */
	
	
	var scan = /*#__PURE__*/_curry3(function scan(fn, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [acc];
	  while (idx < len) {
	    acc = fn(acc, list[idx]);
	    result[idx + 1] = acc;
	    idx += 1;
	  }
	  return result;
	});
	module.exports = scan;

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var always = /*#__PURE__*/__webpack_require__(105);
	
	var over = /*#__PURE__*/__webpack_require__(411);
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> a -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      const xLens = R.lensProp('x');
	 *
	 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
	 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
	 */
	
	
	var set = /*#__PURE__*/_curry3(function set(lens, v, x) {
	  return over(lens, always(v), x);
	});
	module.exports = set;

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Returns a copy of the list, sorted according to the comparator function,
	 * which should accept two values at a time and return a negative number if the
	 * first value is smaller, a positive number if it's larger, and zero if they
	 * are equal. Please note that this is a **copy** of the list. It does not
	 * modify the original.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, a) -> Number) -> [a] -> [a]
	 * @param {Function} comparator A sorting function :: a -> b -> Int
	 * @param {Array} list The list to sort
	 * @return {Array} a new array with its elements sorted by the comparator function.
	 * @example
	 *
	 *      const diff = function(a, b) { return a - b; };
	 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
	 */
	
	
	var sort = /*#__PURE__*/_curry2(function sort(comparator, list) {
	  return Array.prototype.slice.call(list, 0).sort(comparator);
	});
	module.exports = sort;

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Sorts the list according to the supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> [a] -> [a]
	 * @param {Function} fn
	 * @param {Array} list The list to sort.
	 * @return {Array} A new list sorted by the keys generated by `fn`.
	 * @example
	 *
	 *      const sortByFirstItem = R.sortBy(R.prop(0));
	 *      const pairs = [[-1, 1], [-2, 2], [-3, 3]];
	 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
	 *
	 *      const sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
	 *      const alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      const bob = {
	 *        name: 'Bob',
	 *        age: -10
	 *      };
	 *      const clara = {
	 *        name: 'clara',
	 *        age: 314.159
	 *      };
	 *      const people = [clara, bob, alice];
	 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
	 */
	
	
	var sortBy = /*#__PURE__*/_curry2(function sortBy(fn, list) {
	  return Array.prototype.slice.call(list, 0).sort(function (a, b) {
	    var aa = fn(a);
	    var bb = fn(b);
	    return aa < bb ? -1 : aa > bb ? 1 : 0;
	  });
	});
	module.exports = sortBy;

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Sorts a list according to a list of comparators.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Relation
	 * @sig [(a, a) -> Number] -> [a] -> [a]
	 * @param {Array} functions A list of comparator functions.
	 * @param {Array} list The list to sort.
	 * @return {Array} A new list sorted according to the comarator functions.
	 * @example
	 *
	 *      const alice = {
	 *        name: 'alice',
	 *        age: 40
	 *      };
	 *      const bob = {
	 *        name: 'bob',
	 *        age: 30
	 *      };
	 *      const clara = {
	 *        name: 'clara',
	 *        age: 40
	 *      };
	 *      const people = [clara, bob, alice];
	 *      const ageNameSort = R.sortWith([
	 *        R.descend(R.prop('age')),
	 *        R.ascend(R.prop('name'))
	 *      ]);
	 *      ageNameSort(people); //=> [alice, clara, bob]
	 */
	
	
	var sortWith = /*#__PURE__*/_curry2(function sortWith(fns, list) {
	  return Array.prototype.slice.call(list, 0).sort(function (a, b) {
	    var result = 0;
	    var i = 0;
	    while (result === 0 && i < fns.length) {
	      result = fns[i](a, b);
	      i += 1;
	    }
	    return result;
	  });
	});
	module.exports = sortWith;

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = /*#__PURE__*/__webpack_require__(84);
	
	/**
	 * Splits a string into an array of strings based on the given
	 * separator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category String
	 * @sig (String | RegExp) -> String -> [String]
	 * @param {String|RegExp} sep The pattern.
	 * @param {String} str The string to separate into an array.
	 * @return {Array} The array of strings from `str` separated by `str`.
	 * @see R.join
	 * @example
	 *
	 *      const pathComponents = R.split('/');
	 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
	 *
	 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
	 */
	
	
	var split = /*#__PURE__*/invoker(1, 'split');
	module.exports = split;

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var length = /*#__PURE__*/__webpack_require__(404);
	
	var slice = /*#__PURE__*/__webpack_require__(42);
	
	/**
	 * Splits a given list or string at a given index.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig Number -> [a] -> [[a], [a]]
	 * @sig Number -> String -> [String, String]
	 * @param {Number} index The index where the array/string is split.
	 * @param {Array|String} array The array/string to be split.
	 * @return {Array}
	 * @example
	 *
	 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
	 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
	 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
	 */
	
	
	var splitAt = /*#__PURE__*/_curry2(function splitAt(index, array) {
	  return [slice(0, index, array), slice(index, length(array), array)];
	});
	module.exports = splitAt;

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var slice = /*#__PURE__*/__webpack_require__(42);
	
	/**
	 * Splits a collection into slices of the specified length.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [[a]]
	 * @sig Number -> String -> [String]
	 * @param {Number} n
	 * @param {Array} list
	 * @return {Array}
	 * @example
	 *
	 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
	 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
	 */
	
	
	var splitEvery = /*#__PURE__*/_curry2(function splitEvery(n, list) {
	  if (n <= 0) {
	    throw new Error('First argument to splitEvery must be a positive integer');
	  }
	  var result = [];
	  var idx = 0;
	  while (idx < list.length) {
	    result.push(slice(idx, idx += n, list));
	  }
	  return result;
	});
	module.exports = splitEvery;

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Takes a list and a predicate and returns a pair of lists with the following properties:
	 *
	 *  - the result of concatenating the two output lists is equivalent to the input list;
	 *  - none of the elements of the first output list satisfies the predicate; and
	 *  - if the second output list is non-empty, its first element satisfies the predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
	 * @param {Function} pred The predicate that determines where the array is split.
	 * @param {Array} list The array to be split.
	 * @return {Array}
	 * @example
	 *
	 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
	 */
	
	
	var splitWhen = /*#__PURE__*/_curry2(function splitWhen(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  var prefix = [];
	
	  while (idx < len && !pred(list[idx])) {
	    prefix.push(list[idx]);
	    idx += 1;
	  }
	
	  return [prefix, Array.prototype.slice.call(list, idx)];
	});
	module.exports = splitWhen;

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var equals = /*#__PURE__*/__webpack_require__(31);
	
	var take = /*#__PURE__*/__webpack_require__(163);
	
	/**
	 * Checks if a list starts with the provided sublist.
	 *
	 * Similarly, checks if a string starts with the provided substring.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category List
	 * @sig [a] -> [a] -> Boolean
	 * @sig String -> String -> Boolean
	 * @param {*} prefix
	 * @param {*} list
	 * @return {Boolean}
	 * @see R.endsWith
	 * @example
	 *
	 *      R.startsWith('a', 'abc')                //=> true
	 *      R.startsWith('b', 'abc')                //=> false
	 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
	 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
	 */
	
	
	var startsWith = /*#__PURE__*/_curry2(function (prefix, list) {
	  return equals(take(prefix.length, list), prefix);
	});
	module.exports = startsWith;

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Subtracts its second argument from its first argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a - b`.
	 * @see R.add
	 * @example
	 *
	 *      R.subtract(10, 8); //=> 2
	 *
	 *      const minus5 = R.subtract(R.__, 5);
	 *      minus5(17); //=> 12
	 *
	 *      const complementaryAngle = R.subtract(90);
	 *      complementaryAngle(30); //=> 60
	 *      complementaryAngle(72); //=> 18
	 */
	
	
	var subtract = /*#__PURE__*/_curry2(function subtract(a, b) {
	  return Number(a) - Number(b);
	});
	module.exports = subtract;

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var concat = /*#__PURE__*/__webpack_require__(153);
	
	var difference = /*#__PURE__*/__webpack_require__(378);
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements contained in the first or
	 * second list, but not both.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` or `list2`, but not both.
	 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
	 * @example
	 *
	 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
	 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
	 */
	
	
	var symmetricDifference = /*#__PURE__*/_curry2(function symmetricDifference(list1, list2) {
	  return concat(difference(list1, list2), difference(list2, list1));
	});
	module.exports = symmetricDifference;

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var concat = /*#__PURE__*/__webpack_require__(153);
	
	var differenceWith = /*#__PURE__*/__webpack_require__(379);
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements contained in the first or
	 * second list, but not both. Duplication is determined according to the value
	 * returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` or `list2`, but not both.
	 * @see R.symmetricDifference, R.difference, R.differenceWith
	 * @example
	 *
	 *      const eqA = R.eqBy(R.prop('a'));
	 *      const l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
	 *      const l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
	 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
	 */
	
	
	var symmetricDifferenceWith = /*#__PURE__*/_curry3(function symmetricDifferenceWith(pred, list1, list2) {
	  return concat(differenceWith(pred, list1, list2), differenceWith(pred, list2, list1));
	});
	module.exports = symmetricDifferenceWith;

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var slice = /*#__PURE__*/__webpack_require__(42);
	
	/**
	 * Returns a new list containing the last `n` elements of a given list, passing
	 * each value to the supplied predicate function, and terminating when the
	 * predicate function returns `false`. Excludes the element that caused the
	 * predicate function to fail. The predicate function is passed one argument:
	 * *(value)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @sig (a -> Boolean) -> String -> String
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} xs The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.dropLastWhile, R.addIndex
	 * @example
	 *
	 *      const isNotOne = x => x !== 1;
	 *
	 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
	 *
	 *      R.takeLastWhile(x => x !== 'R' , 'Ramda'); //=> 'amda'
	 */
	
	
	var takeLastWhile = /*#__PURE__*/_curry2(function takeLastWhile(fn, xs) {
	  var idx = xs.length - 1;
	  while (idx >= 0 && fn(xs[idx])) {
	    idx -= 1;
	  }
	  return slice(idx + 1, Infinity, xs);
	});
	module.exports = takeLastWhile;

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _xtakeWhile = /*#__PURE__*/__webpack_require__(1087);
	
	var slice = /*#__PURE__*/__webpack_require__(42);
	
	/**
	 * Returns a new list containing the first `n` elements of a given list,
	 * passing each value to the supplied predicate function, and terminating when
	 * the predicate function returns `false`. Excludes the element that caused the
	 * predicate function to fail. The predicate function is passed one argument:
	 * *(value)*.
	 *
	 * Dispatches to the `takeWhile` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @sig (a -> Boolean) -> String -> String
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} xs The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.dropWhile, R.transduce, R.addIndex
	 * @example
	 *
	 *      const isNotFour = x => x !== 4;
	 *
	 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
	 *
	 *      R.takeWhile(x => x !== 'd' , 'Ramda'); //=> 'Ram'
	 */
	
	
	var takeWhile = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['takeWhile'], _xtakeWhile, function takeWhile(fn, xs) {
	  var idx = 0;
	  var len = xs.length;
	  while (idx < len && fn(xs[idx])) {
	    idx += 1;
	  }
	  return slice(0, idx, xs);
	}));
	module.exports = takeWhile;

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(15);
	
	var _xtap = /*#__PURE__*/__webpack_require__(1088);
	
	/**
	 * Runs the given function with the supplied object, then returns the object.
	 *
	 * Acts as a transducer if a transformer is given as second parameter.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a -> *) -> a -> a
	 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
	 * @param {*} x
	 * @return {*} `x`.
	 * @example
	 *
	 *      const sayX = x => console.log('x is ' + x);
	 *      R.tap(sayX, 100); //=> 100
	 *      // logs 'x is 100'
	 * @symb R.tap(f, a) = a
	 */
	
	
	var tap = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable([], _xtap, function tap(fn, x) {
	  fn(x);
	  return x;
	}));
	module.exports = tap;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	var _cloneRegExp = /*#__PURE__*/__webpack_require__(389);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _isRegExp = /*#__PURE__*/__webpack_require__(1064);
	
	var toString = /*#__PURE__*/__webpack_require__(121);
	
	/**
	 * Determines whether a given string matches a given regular expression.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category String
	 * @sig RegExp -> String -> Boolean
	 * @param {RegExp} pattern
	 * @param {String} str
	 * @return {Boolean}
	 * @see R.match
	 * @example
	 *
	 *      R.test(/^x/, 'xyz'); //=> true
	 *      R.test(/^y/, 'xyz'); //=> false
	 */
	
	
	var test = /*#__PURE__*/_curry2(function test(pattern, str) {
	  if (!_isRegExp(pattern)) {
	    throw new TypeError('‘test’ requires a value of type RegExp as its first argument; received ' + toString(pattern));
	  }
	  return _cloneRegExp(pattern).test(str);
	});
	module.exports = test;

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var _assertPromise = /*#__PURE__*/__webpack_require__(387);
	
	/**
	 * Returns the result of applying the onSuccess function to the value inside
	 * a successfully resolved promise. This is useful for working with promises
	 * inside function compositions.
	 *
	 * @func
	 * @memberOf R
	 * @category Function
	 * @sig (a -> b) -> (Promise e a) -> (Promise e b)
	 * @sig (a -> (Promise e b)) -> (Promise e a) -> (Promise e b)
	 * @param {Function} onSuccess The function to apply. Can return a value or a promise of a value.
	 * @param {Promise} p
	 * @return {Promise} The result of calling `p.then(onSuccess)`
	 * @see R.otherwise
	 * @example
	 *
	 *      var makeQuery = (email) => ({ query: { email }});
	 *
	 *      //getMemberName :: String -> Promise ({firstName, lastName})
	 *      var getMemberName = R.pipe(
	 *        makeQuery,
	 *        fetchMember,
	 *        R.then(R.pick(['firstName', 'lastName']))
	 *      );
	 */
	
	
	var then = /*#__PURE__*/_curry2(function then(f, p) {
	  _assertPromise('then', p);
	
	  return p.then(f);
	});
	module.exports = then;

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	var curryN = /*#__PURE__*/__webpack_require__(18);
	
	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Creates a thunk out of a function. A thunk delays a calculation until
	 * its result is needed, providing lazy evaluation of arguments.
	 *
	 * @func
	 * @memberOf R
	 * @category Function
	 * @sig ((a, b, ..., j) -> k) -> (a, b, ..., j) -> (() -> k)
	 * @param {Function} fn A function to wrap in a thunk
	 * @return {Function} Expects arguments for `fn` and returns a new function
	 *  that, when called, applies those arguments to `fn`.
	 * @see R.partial, R.partialRight
	 * @example
	 *
	 *      R.thunkify(R.identity)(42)(); //=> 42
	 *      R.thunkify((a, b) => a + b)(25, 17)(); //=> 42
	 */
	
	
	var thunkify = /*#__PURE__*/_curry1(function thunkify(fn) {
	  return curryN(fn.length, function createThunk() {
	    var fnArgs = arguments;
	    return function invokeThunk() {
	      return fn.apply(this, fnArgs);
	    };
	  });
	});
	
	module.exports = thunkify;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = /*#__PURE__*/__webpack_require__(84);
	
	/**
	 * The lower case version of a string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to lower case.
	 * @return {String} The lower case version of `str`.
	 * @see R.toUpper
	 * @example
	 *
	 *      R.toLower('XYZ'); //=> 'xyz'
	 */
	
	
	var toLower = /*#__PURE__*/invoker(0, 'toLowerCase');
	module.exports = toLower;

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _has = /*#__PURE__*/__webpack_require__(25);
	
	/**
	 * Converts an object into an array of key, value arrays. Only the object's
	 * own properties are used.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own properties.
	 * @see R.fromPairs
	 * @example
	 *
	 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
	 */
	
	
	var toPairs = /*#__PURE__*/_curry1(function toPairs(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    if (_has(prop, obj)) {
	      pairs[pairs.length] = [prop, obj[prop]];
	    }
	  }
	  return pairs;
	});
	module.exports = toPairs;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Converts an object into an array of key, value arrays. The object's own
	 * properties and prototype properties are used. Note that the order of the
	 * output array is not guaranteed to be consistent across different JS
	 * platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own
	 *         and prototype properties.
	 * @example
	 *
	 *      const F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      const f = new F();
	 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
	 */
	
	
	var toPairsIn = /*#__PURE__*/_curry1(function toPairsIn(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    pairs[pairs.length] = [prop, obj[prop]];
	  }
	  return pairs;
	});
	module.exports = toPairsIn;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = /*#__PURE__*/__webpack_require__(84);
	
	/**
	 * The upper case version of a string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to upper case.
	 * @return {String} The upper case version of `str`.
	 * @see R.toLower
	 * @example
	 *
	 *      R.toUpper('abc'); //=> 'ABC'
	 */
	
	
	var toUpper = /*#__PURE__*/invoker(0, 'toUpperCase');
	module.exports = toUpper;

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	var _reduce = /*#__PURE__*/__webpack_require__(26);
	
	var _xwrap = /*#__PURE__*/__webpack_require__(399);
	
	var curryN = /*#__PURE__*/__webpack_require__(18);
	
	/**
	 * Initializes a transducer using supplied iterator function. Returns a single
	 * item by iterating through the list, successively calling the transformed
	 * iterator function and passing it an accumulator value and the current value
	 * from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It will be
	 * wrapped as a transformer to initialize the transducer. A transformer can be
	 * passed directly in place of an iterator function. In both cases, iteration
	 * may be stopped early with the [`R.reduced`](#reduced) function.
	 *
	 * A transducer is a function that accepts a transformer and returns a
	 * transformer and can be composed directly.
	 *
	 * A transformer is an an object that provides a 2-arity reducing iterator
	 * function, step, 0-arity initial value function, init, and 1-arity result
	 * extraction function, result. The step function is used as the iterator
	 * function in reduce. The result function is used to convert the final
	 * accumulator into the return type and in most cases is
	 * [`R.identity`](#identity). The init function can be used to provide an
	 * initial accumulator, but is ignored by transduce.
	 *
	 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array. Wrapped as transformer, if necessary, and used to
	 *        initialize the transducer
	 * @param {*} acc The initial accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.reduced, R.into
	 * @example
	 *
	 *      const numbers = [1, 2, 3, 4];
	 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
	 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
	 *
	 *      const isOdd = (x) => x % 2 === 1;
	 *      const firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
	 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
	 */
	
	
	var transduce = /*#__PURE__*/curryN(4, function transduce(xf, fn, acc, list) {
	  return _reduce(xf(typeof fn === 'function' ? _xwrap(fn) : fn), acc, list);
	});
	module.exports = transduce;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Transposes the rows and columns of a 2D list.
	 * When passed a list of `n` lists of length `x`,
	 * returns a list of `x` lists of length `n`.
	 *
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [[a]] -> [[a]]
	 * @param {Array} list A 2D list
	 * @return {Array} A 2D list
	 * @example
	 *
	 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
	 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	 *
	 *      // If some of the rows are shorter than the following rows, their elements are skipped:
	 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
	 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
	 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
	 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
	 */
	
	
	var transpose = /*#__PURE__*/_curry1(function transpose(outerlist) {
	  var i = 0;
	  var result = [];
	  while (i < outerlist.length) {
	    var innerlist = outerlist[i];
	    var j = 0;
	    while (j < innerlist.length) {
	      if (typeof result[j] === 'undefined') {
	        result[j] = [];
	      }
	      result[j].push(innerlist[j]);
	      j += 1;
	    }
	    i += 1;
	  }
	  return result;
	});
	module.exports = transpose;

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var map = /*#__PURE__*/__webpack_require__(32);
	
	var sequence = /*#__PURE__*/__webpack_require__(420);
	
	/**
	 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
	 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
	 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
	 * into an Applicative of Traversable.
	 *
	 * Dispatches to the `traverse` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
	 * @param {Function} of
	 * @param {Function} f
	 * @param {*} traversable
	 * @return {*}
	 * @see R.sequence
	 * @example
	 *
	 *      // Returns `Maybe.Nothing` if the given divisor is `0`
	 *      const safeDiv = n => d => d === 0 ? Maybe.Nothing() : Maybe.Just(n / d)
	 *
	 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Maybe.Just([5, 2.5, 2])
	 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Maybe.Nothing
	 */
	
	
	var traverse = /*#__PURE__*/_curry3(function traverse(of, f, traversable) {
	  return typeof traversable['fantasy-land/traverse'] === 'function' ? traversable['fantasy-land/traverse'](f, of) : sequence(of, map(f, traversable));
	});
	module.exports = traverse;

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' + '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' + '\u2029\uFEFF';
	var zeroWidth = '\u200b';
	var hasProtoTrim = typeof String.prototype.trim === 'function';
	/**
	 * Removes (strips) whitespace from both ends of the string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to trim.
	 * @return {String} Trimmed version of `str`.
	 * @example
	 *
	 *      R.trim('   xyz  '); //=> 'xyz'
	 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
	 */
	var trim = !hasProtoTrim || /*#__PURE__*/ws.trim() || ! /*#__PURE__*/zeroWidth.trim() ? /*#__PURE__*/_curry1(function trim(str) {
	  var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
	  var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
	  return str.replace(beginRx, '').replace(endRx, '');
	}) : /*#__PURE__*/_curry1(function trim(str) {
	  return str.trim();
	});
	module.exports = trim;

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(39);
	
	var _concat = /*#__PURE__*/__webpack_require__(40);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
	 * function evaluates the `tryer`; if it does not throw, it simply returns the
	 * result. If the `tryer` *does* throw, the returned function evaluates the
	 * `catcher` function and returns its result. Note that for effective
	 * composition with this function, both the `tryer` and `catcher` functions
	 * must return the same type of results.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
	 * @param {Function} tryer The function that may throw.
	 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
	 * @return {Function} A new function that will catch exceptions and send then to the catcher.
	 * @example
	 *
	 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
	 *      R.tryCatch(() => { throw 'foo'}, R.always('catched'))('bar') // => 'catched'
	 *      R.tryCatch(R.times(R.identity), R.always([]))('s') // => []
	 `` */
	
	
	var tryCatch = /*#__PURE__*/_curry2(function _tryCatch(tryer, catcher) {
	  return _arity(tryer.length, function () {
	    try {
	      return tryer.apply(this, arguments);
	    } catch (e) {
	      return catcher.apply(this, _concat([e], arguments));
	    }
	  });
	});
	module.exports = tryCatch;

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Takes a function `fn`, which takes a single array argument, and returns a
	 * function which:
	 *
	 *   - takes any number of positional arguments;
	 *   - passes these arguments to `fn` as an array; and
	 *   - returns the result.
	 *
	 * In other words, `R.unapply` derives a variadic function from a function which
	 * takes an array. `R.unapply` is the inverse of [`R.apply`](#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Function
	 * @sig ([*...] -> a) -> (*... -> a)
	 * @param {Function} fn
	 * @return {Function}
	 * @see R.apply
	 * @example
	 *
	 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
	 * @symb R.unapply(f)(a, b) = f([a, b])
	 */
	
	
	var unapply = /*#__PURE__*/_curry1(function unapply(fn) {
	  return function () {
	    return fn(Array.prototype.slice.call(arguments, 0));
	  };
	});
	module.exports = unapply;

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var nAry = /*#__PURE__*/__webpack_require__(117);
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly 1 parameter. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Function
	 * @sig (* -> b) -> (a -> b)
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity 1.
	 * @see R.binary, R.nAry
	 * @example
	 *
	 *      const takesTwoArgs = function(a, b) {
	 *        return [a, b];
	 *      };
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      const takesOneArg = R.unary(takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only 1 argument is passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 * @symb R.unary(f)(a, b, c) = f(a)
	 */
	
	
	var unary = /*#__PURE__*/_curry1(function unary(fn) {
	  return nAry(1, fn);
	});
	module.exports = unary;

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var curryN = /*#__PURE__*/__webpack_require__(18);
	
	/**
	 * Returns a function of arity `n` from a (manually) curried function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Function
	 * @sig Number -> (a -> b) -> (a -> c)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to uncurry.
	 * @return {Function} A new function.
	 * @see R.curry
	 * @example
	 *
	 *      const addFour = a => b => c => d => a + b + c + d;
	 *
	 *      const uncurriedAddFour = R.uncurryN(4, addFour);
	 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
	 */
	
	
	var uncurryN = /*#__PURE__*/_curry2(function uncurryN(depth, fn) {
	  return curryN(depth, function () {
	    var currentDepth = 1;
	    var value = fn;
	    var idx = 0;
	    var endIdx;
	    while (currentDepth <= depth && typeof value === 'function') {
	      endIdx = currentDepth === depth ? arguments.length : idx + value.length;
	      value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
	      currentDepth += 1;
	      idx = endIdx;
	    }
	    return value;
	  });
	});
	module.exports = uncurryN;

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Builds a list from a seed value. Accepts an iterator function, which returns
	 * either false to stop iteration or an array of length 2 containing the value
	 * to add to the resulting list and the seed to be used in the next call to the
	 * iterator function.
	 *
	 * The iterator function receives one argument: *(seed)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (a -> [b]) -> * -> [b]
	 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
	 *        either false to quit iteration or an array of length two to proceed. The element
	 *        at index 0 of this array will be added to the resulting array, and the element
	 *        at index 1 will be passed to the next call to `fn`.
	 * @param {*} seed The seed value.
	 * @return {Array} The final list.
	 * @example
	 *
	 *      const f = n => n > 50 ? false : [-n, n + 10];
	 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
	 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
	 */
	
	
	var unfold = /*#__PURE__*/_curry2(function unfold(fn, seed) {
	  var pair = fn(seed);
	  var result = [];
	  while (pair && pair.length) {
	    result[result.length] = pair[0];
	    pair = fn(pair[1]);
	  }
	  return result;
	});
	module.exports = unfold;

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(40);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var compose = /*#__PURE__*/__webpack_require__(152);
	
	var uniq = /*#__PURE__*/__webpack_require__(165);
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of the elements
	 * of each list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} as The first list.
	 * @param {Array} bs The second list.
	 * @return {Array} The first and second lists concatenated, with
	 *         duplicates removed.
	 * @example
	 *
	 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
	 */
	
	
	var union = /*#__PURE__*/_curry2( /*#__PURE__*/compose(uniq, _concat));
	module.exports = union;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(40);
	
	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var uniqWith = /*#__PURE__*/__webpack_require__(425);
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of the elements
	 * of each list. Duplication is determined according to the value returned by
	 * applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [*] -> [*] -> [*]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The first and second lists concatenated, with
	 *         duplicates removed.
	 * @see R.union
	 * @example
	 *
	 *      const l1 = [{a: 1}, {a: 2}];
	 *      const l2 = [{a: 1}, {a: 4}];
	 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
	 */
	
	
	var unionWith = /*#__PURE__*/_curry3(function unionWith(pred, list1, list2) {
	  return uniqWith(pred, _concat(list1, list2));
	});
	module.exports = unionWith;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is not satisfied, the function will return the result of
	 * calling the `whenFalseFn` function with the same argument. If the predicate
	 * is satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred        A predicate function
	 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
	 *                               to a falsy value.
	 * @param {*}        x           An object to test with the `pred` function and
	 *                               pass to `whenFalseFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
	 * @see R.ifElse, R.when, R.cond
	 * @example
	 *
	 *      let safeInc = R.unless(R.isNil, R.inc);
	 *      safeInc(null); //=> null
	 *      safeInc(1); //=> 2
	 */
	
	
	var unless = /*#__PURE__*/_curry3(function unless(pred, whenFalseFn, x) {
	  return pred(x) ? x : whenFalseFn(x);
	});
	module.exports = unless;

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	var _identity = /*#__PURE__*/__webpack_require__(157);
	
	var chain = /*#__PURE__*/__webpack_require__(151);
	
	/**
	 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
	 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig Chain c => c (c a) -> c a
	 * @param {*} list
	 * @return {*}
	 * @see R.flatten, R.chain
	 * @example
	 *
	 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
	 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
	 */
	
	
	var unnest = /*#__PURE__*/chain(_identity);
	module.exports = unnest;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Takes a predicate, a transformation function, and an initial value,
	 * and returns a value of the same type as the initial value.
	 * It does so by applying the transformation until the predicate is satisfied,
	 * at which point it returns the satisfactory value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred A predicate function
	 * @param {Function} fn The iterator function
	 * @param {*} init Initial value
	 * @return {*} Final value that satisfies predicate
	 * @example
	 *
	 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
	 */
	
	
	var until = /*#__PURE__*/_curry3(function until(pred, fn, init) {
	  var val = init;
	  while (!pred(val)) {
	    val = fn(val);
	  }
	  return val;
	});
	module.exports = until;

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Returns a list of all the properties, including prototype properties, of the
	 * supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @sig {k: v} -> [v]
	 * @param {Object} obj The object to extract values from
	 * @return {Array} An array of the values of the object's own and prototype properties.
	 * @see R.values, R.keysIn
	 * @example
	 *
	 *      const F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      const f = new F();
	 *      R.valuesIn(f); //=> ['X', 'Y']
	 */
	
	
	var valuesIn = /*#__PURE__*/_curry1(function valuesIn(obj) {
	  var prop;
	  var vs = [];
	  for (prop in obj) {
	    vs[vs.length] = obj[prop];
	  }
	  return vs;
	});
	module.exports = valuesIn;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	// `Const` is a functor that effectively ignores the function given to `map`.
	
	
	var Const = function (x) {
	  return { value: x, 'fantasy-land/map': function () {
	      return this;
	    } };
	};
	
	/**
	 * Returns a "view" of the given data structure, determined by the given lens.
	 * The lens's focus determines which portion of the data structure is visible.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> s -> a
	 * @param {Lens} lens
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      const xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});  //=> 1
	 *      R.view(xLens, {x: 4, y: 2});  //=> 4
	 */
	var view = /*#__PURE__*/_curry2(function view(lens, x) {
	  // Using `Const` effectively ignores the setter function of the `lens`,
	  // leaving the value returned by the getter function unmodified.
	  return lens(Const)(x).value;
	});
	module.exports = view;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is satisfied, the function will return the result of calling
	 * the `whenTrueFn` function with the same argument. If the predicate is not
	 * satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred       A predicate function
	 * @param {Function} whenTrueFn A function to invoke when the `condition`
	 *                              evaluates to a truthy value.
	 * @param {*}        x          An object to test with the `pred` function and
	 *                              pass to `whenTrueFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
	 * @see R.ifElse, R.unless, R.cond
	 * @example
	 *
	 *      // truncate :: String -> String
	 *      const truncate = R.when(
	 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
	 *        R.pipe(R.take(10), R.append('…'), R.join(''))
	 *      );
	 *      truncate('12345');         //=> '12345'
	 *      truncate('0123456789ABC'); //=> '0123456789…'
	 */
	
	
	var when = /*#__PURE__*/_curry3(function when(pred, whenTrueFn, x) {
	  return pred(x) ? whenTrueFn(x) : x;
	});
	module.exports = when;

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var equals = /*#__PURE__*/__webpack_require__(31);
	
	var map = /*#__PURE__*/__webpack_require__(32);
	
	var where = /*#__PURE__*/__webpack_require__(428);
	
	/**
	 * Takes a spec object and a test object; returns true if the test satisfies
	 * the spec, false otherwise. An object satisfies the spec if, for each of the
	 * spec's own properties, accessing that property of the object gives the same
	 * value (in [`R.equals`](#equals) terms) as accessing that property of the
	 * spec.
	 *
	 * `whereEq` is a specialization of [`where`](#where).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @sig {String: *} -> {String: *} -> Boolean
	 * @param {Object} spec
	 * @param {Object} testObj
	 * @return {Boolean}
	 * @see R.propEq, R.where
	 * @example
	 *
	 *      // pred :: Object -> Boolean
	 *      const pred = R.whereEq({a: 1, b: 2});
	 *
	 *      pred({a: 1});              //=> false
	 *      pred({a: 1, b: 2});        //=> true
	 *      pred({a: 1, b: 2, c: 3});  //=> true
	 *      pred({a: 1, b: 1});        //=> false
	 */
	
	
	var whereEq = /*#__PURE__*/_curry2(function whereEq(spec, testObj) {
	  return where(map(equals, spec), testObj);
	});
	module.exports = whereEq;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	var _includes = /*#__PURE__*/__webpack_require__(72);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	var flip = /*#__PURE__*/__webpack_require__(107);
	
	var reject = /*#__PURE__*/__webpack_require__(119);
	
	/**
	 * Returns a new list without values in the first argument.
	 * [`R.equals`](#equals) is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @param {Array} list1 The values to be removed from `list2`.
	 * @param {Array} list2 The array to remove values from.
	 * @return {Array} The new array without values in `list1`.
	 * @see R.transduce, R.difference, R.remove
	 * @example
	 *
	 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
	 */
	
	
	var without = /*#__PURE__*/_curry2(function (xs, list) {
	  return reject(flip(_includes)(xs), list);
	});
	module.exports = without;

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Creates a new list out of the two supplied by creating each possible pair
	 * from the lists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b] -> [[a,b]]
	 * @param {Array} as The first list.
	 * @param {Array} bs The second list.
	 * @return {Array} The list made by combining each possible pair from
	 *         `as` and `bs` into pairs (`[a, b]`).
	 * @example
	 *
	 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
	 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
	 */
	
	
	var xprod = /*#__PURE__*/_curry2(function xprod(a, b) {
	  // = xprodWith(prepend); (takes about 3 times as long...)
	  var idx = 0;
	  var ilen = a.length;
	  var j;
	  var jlen = b.length;
	  var result = [];
	  while (idx < ilen) {
	    j = 0;
	    while (j < jlen) {
	      result[result.length] = [a[idx], b[j]];
	      j += 1;
	    }
	    idx += 1;
	  }
	  return result;
	});
	module.exports = xprod;

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Creates a new list out of the two supplied by pairing up equally-positioned
	 * items from both lists. The returned list is truncated to the length of the
	 * shorter of the two input lists.
	 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b] -> [[a,b]]
	 * @param {Array} list1 The first array to consider.
	 * @param {Array} list2 The second array to consider.
	 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
	 * @example
	 *
	 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
	 */
	
	
	var zip = /*#__PURE__*/_curry2(function zip(a, b) {
	  var rv = [];
	  var idx = 0;
	  var len = Math.min(a.length, b.length);
	  while (idx < len) {
	    rv[idx] = [a[idx], b[idx]];
	    idx += 1;
	  }
	  return rv;
	});
	module.exports = zip;

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(1);
	
	/**
	 * Creates a new object out of a list of keys and a list of values.
	 * Key/value pairing is truncated to the length of the shorter of the two lists.
	 * Note: `zipObj` is equivalent to `pipe(zip, fromPairs)`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [String] -> [*] -> {String: *}
	 * @param {Array} keys The array that will be properties on the output object.
	 * @param {Array} values The list of values on the output object.
	 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
	 * @example
	 *
	 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
	 */
	
	
	var zipObj = /*#__PURE__*/_curry2(function zipObj(keys, values) {
	  var idx = 0;
	  var len = Math.min(keys.length, values.length);
	  var out = {};
	  while (idx < len) {
	    out[keys[idx]] = values[idx];
	    idx += 1;
	  }
	  return out;
	});
	module.exports = zipObj;

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Creates a new list out of the two supplied by applying the function to each
	 * equally-positioned pair in the lists. The returned list is truncated to the
	 * length of the shorter of the two input lists.
	 *
	 * @function
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> c) -> [a] -> [b] -> [c]
	 * @param {Function} fn The function used to combine the two elements into one value.
	 * @param {Array} list1 The first array to consider.
	 * @param {Array} list2 The second array to consider.
	 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
	 *         using `fn`.
	 * @example
	 *
	 *      const f = (x, y) => {
	 *        // ...
	 *      };
	 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
	 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
	 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
	 */
	
	
	var zipWith = /*#__PURE__*/_curry3(function zipWith(fn, a, b) {
	  var rv = [];
	  var idx = 0;
	  var len = Math.min(a.length, b.length);
	  while (idx < len) {
	    rv[idx] = fn(a[idx], b[idx]);
	    idx += 1;
	  }
	  return rv;
	});
	module.exports = zipWith;

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-signin\" data-ng-controller=\"AboutYouController as ctrl\">\n  <div lexstep-header></div>\n\n  <div\n    data-ng-controller=\"IsOldBrowserController as isOldBrowser\"\n    class=\"container\"\n  >\n    <div class=\"old-browser-alert\" ng-show=\"isOldBrowser.showOldBrowser\">\n      <div class=\"callout bg-warning margin-t0\" type=\"info\">\n        You are using an older version of the browser that may not support\n        LexStep features. Please\n        <a\n          target=\"_blank\"\n          class=\"text-info\"\n          href=\"http://windows.microsoft.com/en-us/internet-explorer/download-ie\"\n          >upgrade</a\n        >\n        for improved experience.\n      </div>\n    </div>\n  </div>\n  <div class=\"container margin-t20\" ng-click=\"ctrl.hideDropDown()\">\n    <section class=\"page ng-scope\">\n      <div class=\"row\">\n        <div\n          ng-show=\"ctrl.candidate.isNewUser\"\n          class=\"panel-heading bg-info clearfix\"\n        >\n          <h2 class=\"ng-binding margin-t10\">\n            Welcome to LexStep {{ctrl.candidate.firstName}}!\n          </h2>\n          <h4>\n            Please tell us a bit more about yourself so that we can show you\n            relevant opportunities.<br />\n            <div class=\"divider\"></div>\n            This information is <b>strictly confidential.</b> No law firm will\n            know that you have joined LexStep unless you see a job that you are\n            interested in and explicitly give that firm permission to view your\n            profile. Your current employer will never know that you have signed\n            up.\n          </h4>\n        </div>\n        <div\n          ng-show=\"!ctrl.candidate.isNewUser\"\n          class=\"panel-heading bg-info clearfix\"\n        >\n          <h2 class=\"ng-binding margin-t10\">\n            Welcome to LexStep {{ctrl.candidate.firstName}}!\n          </h2>\n          <h4>{{'createProfile.accessRequestedMsg'|translate}}</h4>\n        </div>\n        <div class=\"panel panel-default create-profile-new\">\n          <div class=\"panel-body\">\n            <div class=\"row\">\n              <div class=\"col-md-12 text-center\">\n                <h3 class=\"margin-t0\">\n                  {{'createProfile.Section1.Heading'| translate}}\n                </h3>\n                <div class=\"divider\"></div>\n              </div>\n            </div>\n            <form name=\"userProfile\">\n              <div>\n                <div class=\"row\">\n                  <div class=\"col-md-6 h5 text-right\">Current Employer*</div>\n                  <div class=\"col-md-4 text-left\">\n                    <input\n                      data-testid=\"current-employer\"\n                      type=\"text\"\n                      ng-disabled=\"!ctrl.candidate.isNewUser || ctrl.user.isAdmin\"\n                      placeholder=\"Current Employer\"\n                      class=\"form-control typeahead\"\n                      uib-typeahead=\"employer as employer.name for employer in ctrl.employersList | employerTypeAheadFilter:$viewValue | limitTo:8\"\n                      ng-blur=\"ctrl.candidateUpdate('employer',$event)\"\n                      ng-model=\"ctrl.candidate.employer\"\n                      previous-value=\"{{ctrl.isNewCandidate.employer.name}}\"\n                      id=\"employer\"\n                      required\n                      only-alphabets\n                      ng-class=\"{'input-error': (ctrl.accessRequested && !ctrl.candidate.employer)}\"\n                    />\n                  </div>\n                  <div\n                    ng-if=\"ctrl.candidate.isNewUser\"\n                    class=\"col-md-1 col-xs-12 current-employer-tooltip\"\n                  >\n                    <a\n                      href=\"\"\n                      tooltip=\"{{'createProfile.currentEmployer.tooltip'|translate}}\"\n                      tooltip-placement=\"bottom\"\n                      class=\"ng-scope hidden-xs hidden-sm\"\n                    >\n                      <span\n                        data-testid=\"employer-tooltip\"\n                        class=\"badge badge-grey employer-badge\"\n                        ><i class=\"fa fa-info\"></i\n                      ></span>\n                    </a>\n                    <span class=\"visible-xs visible-sm\">\n                      {{'createProfile.currentEmployer.tooltip'|translate}}\n                    </span>\n                  </div>\n                </div>\n                <div class=\"row\" ng-show=\"!ctrl.fetchEmployer\">\n                  <div class=\"col-md-6 h5 text-right\">Employer Type*</div>\n                </div>\n                <div\n                  class=\"row\"\n                  ng-repeat=\"employerType in ctrl.legalEmployerTypes \"\n                >\n                  <div\n                    ng-show=\"!ctrl.fetchEmployer\"\n                    ng-disabled=\"ctrl.fetchEmployer\"\n                    ng-style=\"ctrl.setEmployerTypesOpacity()\"\n                    class=\"col-md-6 h5 about-you-employer-types\"\n                  >\n                    <label ng-disabled=\"ctrl.fetchEmployer\" class=\"ui-checkbox\">\n                      <input\n                        ng-disabled=\"ctrl.fetchEmployer\"\n                        data-testid=\"employer-approved\"\n                        id=\"firm-mgt-target-chkbx\"\n                        ng-change=\"ctrl.onEmployerTypeSelected(employerType)\"\n                        ng-model=\"employerType.isSelected\"\n                        name=\"show-employer-approved\"\n                        type=\"checkbox\"\n                        value=\"show\"\n                      />\n                      <span>{{employerType.name}}</span>\n                    </label>\n                  </div>\n                </div>\n                <div class=\"divider clearfix\"></div>\n\n                <div class=\"row\">\n                  <div class=\"col-md-6 h5 text-right\">\n                    Undergraduate University*\n                  </div>\n                  <div class=\"col-md-4 text-left\">\n                    <input\n                      data-testid=\"university-name\"\n                      type=\"text\"\n                      ng-disabled=\"!ctrl.candidate.isNewUser || ctrl.user.isAdmin\"\n                      class=\"form-control\"\n                      placeholder=\"University Name\"\n                      uib-typeahead=\"school.name for school in ctrl.schoolList | filter:$viewValue | limitTo:8\"\n                      ng-blur=\"ctrl.candidateUpdate('university',$event)\"\n                      id=\"university\"\n                      ng-model=\"ctrl.candidate.university\"\n                      previous-value=\"{{ctrl.isNewCandidate.university}}\"\n                      required\n                      ng-class=\"{'input-error': (ctrl.accessRequested && !ctrl.candidate.university)}\"\n                    />\n                  </div>\n                </div>\n                <div class=\"divider clearfix\"></div>\n\n                <div class=\"row\">\n                  <div class=\"col-md-6 h5 text-right\">\n                    Nationality*\n                  </div>\n                  <div class=\"col-md-4 text-left\">\n                    <select\n                      data-testid=\"nationality\"\n                      ng-disabled=\"!ctrl.candidate.isNewUser|| ctrl.user.isAdmin\"\n                      class=\"form-control no-arrow-select\"\n                      style=\"padding: 8px 10px; width: 100%;\"\n                      ng-blur=\"ctrl.candidateUpdate('nationality',$event)\"\n                      previous-value=\"{{ctrl.isNewCandidate.nationality}}\"\n                      id=\"nationality\"\n                      required\n                      ng-class=\"{'input-error': (ctrl.accessRequested && !ctrl.candidate.nationality)}\"\n                    >\n                      <option\n                        selected\n                        ng-disabled=\"!ctrl.candidate.isNewUser || ctrl.user.isAdmin\"\n                        style=\"display:none;\"\n                        >Select Nationality</option\n                      >\n                      <option\n                        ng-disabled=\"!ctrl.candidate.isNewUser || ctrl.user.isAdmin\"\n                        ng-value=\"{{nationality.code}}\"\n                        ng-repeat=\"nationality in ctrl.nationalitiesList\"\n                        ng-selected=\"nationality.code === ctrl.candidate.nationality.code\"\n                      >\n                        {{nationality.name}}\n                      </option>\n                    </select>\n                  </div>\n                </div>\n                <div class=\"divider clearfix\"></div>\n\n                <div class=\"row\">\n                  <h5 class=\"col-md-6 text-right\">\n                    Current Location*\n                  </h5>\n                  <div class=\"col-md-4 text-left\">\n                    <select\n                      data-testid=\"country\"\n                      ng-disabled=\"!ctrl.candidate.isNewUser || ctrl.user.isAdmin\"\n                      class=\"form-control no-arrow-select\"\n                      style=\"padding: 8px 10px; width: 100%;\"\n                      ng-blur=\"ctrl.candidateUpdate('location',$event)\"\n                      previous-value=\"{{ctrl.isNewCandidate.location}}\"\n                      id=\"location\"\n                      required\n                      ng-class=\"{'input-error': (ctrl.accessRequested && !ctrl.candidate.location)}\"\n                    >\n                      <option\n                        value=\"\"\n                        selected\n                        ng-disabled=\"!ctrl.candidate.isNewUser || ctrl.user.isAdmin\"\n                        style=\"display:none;\"\n                        >Select Locations</option\n                      >\n                      <option\n                        ng-disabled=\"!ctrl.candidate.isNewUser || ctrl.user.isAdmin\"\n                        ng-value=\"{{location.id}}\"\n                        ng-repeat=\"location in ctrl.locationsList\"\n                        ng-selected=\"location.id === ctrl.candidate.location\"\n                      >\n                        {{location.name}}\n                      </option>\n                    </select>\n                  </div>\n                </div>\n              </div>\n              <div class=\"divider clearfix\"></div>\n\n              <div class=\"row\">\n                <h5 class=\"col-md-6 text-right\">Contact Number*</h5>\n                <div class=\"col-md-4 text-left\">\n                  <input\n                    data-testid=\"phone\"\n                    type=\"tel\"\n                    required\n                    ng-disabled=\"!ctrl.candidate.isNewUser || ctrl.user.isAdmin\"\n                    placeholder=\"Phone/Mobile Number\"\n                    class=\"form-control\"\n                    ng-model=\"ctrl.candidate.phone\"\n                    ng-blur=\"ctrl.candidateUpdate('phone',$event)\"\n                    previous-value=\"{{ctrl.isNewCandidate.phone}}\"\n                    id=\"phone\"\n                    ng-class=\"{'input-error': (ctrl.phoneError||(ctrl.accessRequested && !ctrl.candidate.phone))}\"\n                  />\n                </div>\n              </div>\n              <div class=\"divider clearfix\"></div>\n\n              <div ng-class=\"\" class=\"solicitor-highlight\">\n                <div class=\"row\">\n                  <div class=\"col-md-12 text-center\">\n                    <h3 class=\"margin-t0\">\n                      {{'createProfile.Section2.Heading'| translate}}\n                    </h3>\n                    <div class=\"divider\"></div>\n                  </div>\n                </div>\n\n                <div class=\"divider clearfix\"></div>\n\n                <div class=\"row\">\n                  <div\n                    class=\"col-sm-4 col-md-6 col-lg-offset-2 col-lg-4 h5 text-right margin-t0\"\n                  >\n                    Date commenced practice (date of qualification or, if you\n                    are a trainee, expected date of qualification)*\n                  </div>\n                  <div class=\"col-sm-4 col-md-4\">\n                    <div\n                      name=\"pqe\"\n                      data-ng-controller=\"DatePickerController as datePickerCtrl\"\n                    >\n                      <div class=\"input-group ui-datepicker\">\n                        <input\n                          ng-disabled=\"!ctrl.candidate.isNewUser || ctrl.user.isAdmin\"\n                          type=\"text\"\n                          class=\"custom-readonly form-control\"\n                          placeholder=\"Month-Year\"\n                          uib-datepicker-popup=\"{{datePickerCtrl.format}}\"\n                          ng-model=\"ctrl.candidate.pqe\"\n                          is-open=\"datePickerCtrl.opened\"\n                          min=\"minDate\"\n                          max=\"'2015-06-22'\"\n                          datepicker-options=\"datePickerCtrl.dateOptions\"\n                          date-disabled=\"datePickerCtrl.disabled(date, mode)\"\n                          close-text=\"Close\"\n                          required\n                          ng-blur=\"ctrl.candidateUpdate('pqe',$event)\"\n                          previous-value=\"{{ctrl.isNewCandidate.pqe}}\"\n                          id=\"pqe\"\n                          ng-class=\"{'input-error': (ctrl.accessRequested && !ctrl.candidate.pqe)}\"\n                        />\n                        <span\n                          data-testid=\"calender\"\n                          class=\"input-group-addon\"\n                          ng-disabled=\"!ctrl.candidate.isNewUser || ctrl.user.isAdmin\"\n                          ng-click=\"ctrl.candidate.isNewUser  &&!ctrl.user.isAdmin && datePickerCtrl.open($event)\"\n                          ><i class=\"fa fa-calendar\"></i\n                        ></span>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"divider\"></div>\n                <div class=\"row\">\n                  <div class=\"col-md-6 col-sm-4 col-xs-12 h5 text-right\">\n                    In which jurisdictions are you qualified?*\n                  </div>\n                  <div\n                    class=\"col-md-6 text-left\"\n                    ng-show=\"!ctrl.jurisdictionShow && ctrl.candidate.isNewUser\"\n                  >\n                    <button\n                      data-testid=\"select-jurisdiction\"\n                      ng-if=\"ctrl.candidate.isNewUser && !ctrl.user.isAdmin\"\n                      ng-click=\"openLawyerPreferencesModal('edit-jurisdictions')\"\n                      ng-touch=\"openLawyerPreferencesModal('edit-jurisdictions')\"\n                      id=\"select-jurisdictions\"\n                      class=\"btn btn-line-info\"\n                      ng-class=\"{'input-error': (ctrl.accessRequested && !ctrl.jurisdictionShow)}\"\n                    >\n                      Click to specify\n                    </button>\n                  </div>\n\n                  <div class=\"divider clearfix\"></div>\n                  <div\n                    class=\"col-md-5 text-left\"\n                    ng-show=\"ctrl.jurisdictionShow\"\n                  >\n                    <ul\n                      id=\"taglist\"\n                      class=\"list-inline list-practice-area margin-b0\"\n                    >\n                      <li\n                        class=\"tags-box\"\n                        ng-if=\"jurisdiction.isSelected\"\n                        ng-repeat=\"jurisdiction in ctrl.candidate.legalJurisdictions\"\n                      >\n                        {{jurisdiction.name}}\n                      </li>\n                      <a\n                        href=\"\"\n                        class=\"fa fa-pencil\"\n                        ng-if=\"ctrl.candidate.isNewUser && !ctrl.user.isAdmin\"\n                        ng-click=\"openLawyerPreferencesModal('edit-jurisdictions')\"\n                        ng-touch=\"openLawyerPreferencesModal('edit-jurisdictions')\"\n                      ></a>\n                    </ul>\n                  </div>\n                </div>\n\n                <div class=\"divider\" ng-show=\"ctrl.jurisdictionShow\"></div>\n              </div>\n\n              <div class=\"row\">\n                <div class=\"col-md-12 text-center\">\n                  <h3>{{'createProfile.Section3.Heading'| translate}}</h3>\n                  <div class=\"divider\"></div>\n                </div>\n              </div>\n\n              <div>\n                <div class=\"row\">\n                  <div class=\"col-md-6 col-sm-4 col-xs-12 h5 text-right\">\n                    Practice Areas*\n                  </div>\n                  <div\n                    class=\"col-md-6 text-left\"\n                    ng-show=\"!ctrl.selectedPracticesShow && ctrl.candidate.isNewUser\"\n                  >\n                    <button\n                      data-testid=\"job-practice-area\"\n                      ng-if=\"ctrl.candidate.isNewUser && !ctrl.user.isAdmin\"\n                      class=\"btn btn-line-info\"\n                      ng-click=\"ctrl.openPracticeModal(null,$event)\"\n                      ng-class=\"{'input-error': (ctrl.accessRequested && !ctrl.selectedPracticesShow)}\"\n                    >\n                      Click to specify\n                    </button>\n                  </div>\n                  <div class=\"divider clearfix\"></div>\n                  <div\n                    class=\"col-md-5 text-left\"\n                    ng-show=\"ctrl.selectedPracticesShow\"\n                  >\n                    <ul\n                      id=\"taglist\"\n                      class=\"list-inline list-practice-area margin-b0\"\n                    >\n                      <li\n                        class=\"tags-box\"\n                        ng-if=\"practiceArea.isSelected\"\n                        ng-repeat=\"practiceArea in ctrl.candidate.specialties\"\n                      >\n                        {{practiceArea.name}}\n                      </li>\n                      <a\n                        href=\"\"\n                        ng-if=\"ctrl.candidate.isNewUser && !ctrl.user.isAdmin\"\n                        class=\"fa fa-pencil\"\n                        ng-click=\"ctrl.openPracticeModal(ctrl.candidate.specialties ,$event)\"\n                      ></a>\n                    </ul>\n                  </div>\n                </div>\n              </div>\n              <div class=\"divider clearfix\"></div>\n\n              <div>\n                <div class=\"row\">\n                  <div class=\"col-md-6 col-sm-4 col-xs-12 h5 text-right\">\n                    Target Locations *\n                  </div>\n                  <div\n                    class=\"col-md-6 text-left\"\n                    ng-show=\"!ctrl.selectedLocation && ctrl.candidate.isNewUser\"\n                  >\n                    <button\n                      data-testid=\"job-location\"\n                      ng-if=\"ctrl.candidate.isNewUser && !ctrl.user.isAdmin\"\n                      class=\"btn btn-line-info\"\n                      id=\"select-locations\"\n                      ng-click=\"ctrl.openLocationModal(null,$event)\"\n                      ng-class=\"{'input-error': (ctrl.accessRequested && !ctrl.selectedLocation)}\"\n                    >\n                      Click to specify\n                    </button>\n                  </div>\n                  <div class=\"divider clearfix\"></div>\n                  <div\n                    class=\"col-md-6 text-left\"\n                    ng-show=\"ctrl.selectedLocation\"\n                  >\n                    <ul\n                      id=\"taglist\"\n                      class=\"list-inline list-practice-area margin-b0\"\n                    >\n                      <li\n                        class=\"tags-box\"\n                        ng-if=\"location.isSelected\"\n                        ng-repeat=\"location in ctrl.candidate.preferredLocations\"\n                      >\n                        {{location.name}}\n                      </li>\n                      <a\n                        href=\"\"\n                        class=\"fa fa-pencil\"\n                        id=\"select-locations\"\n                        ng-if=\"ctrl.candidate.isNewUser && !ctrl.user.isAdmin\"\n                        ng-click=\"ctrl.openLocationModal(ctrl.candidate.preferredLocations,$event)\"\n                      ></a>\n                    </ul>\n                  </div>\n                </div>\n              </div>\n              <div class=\"divider clearfix\"></div>\n\n              <hr />\n\n              <div class=\"row\">\n                <div class=\"col-md-12 text-center\">\n                  <h3 class=\"margin-t0\">\n                    LexStep is for top lawyers only - please provide\n                    <b>at least one</b> of the below*\n                  </h3>\n                  <div class=\"divider\"></div>\n                </div>\n              </div>\n              <div class=\"row\" ng-if=\"ctrl.isEnglandWalesSelected\">\n                <div class=\"col-md-6 col-sm-4 h5 text-right\">Your SRA ID</div>\n                <div class=\"col-md-4 col-sm-8 text-left\">\n                  <input\n                    data-testid=\"sra-id\"\n                    type=\"text\"\n                    ng-if=\"ctrl.candidate.isNewUser && !ctrl.user.isAdmin\"\n                    ng-model=\"ctrl.candidate.sraId\"\n                    placeholder=\"Your SRA ID\"\n                    class=\"form-control\"\n                    ng-blur=\"ctrl.candidateUpdate('sraId',$event)\"\n                    previous-value=\"{{ctrl.isNewCandidate.sraId}}\"\n                    id=\"sraId\"\n                  />\n                  <h5 ng-if=\"!ctrl.candidate.isNewUser || ctrl.user.isAdmin\">\n                    {{ctrl.candidate.sraId}}\n                  </h5>\n                  <br\n                    ng-if=\"!ctrl.candidate.isNewUser && !ctrl.candidate.sraId && !ctrl.user.isAdmin\"\n                  />\n                  <h4 class=\"\" ng-if=\"ctrl.candidate.isNewUser\">\n                    <a\n                      target=\"_blank\"\n                      class=\"text-info\"\n                      href=\" http://solicitors.lawsociety.org.uk/?Pro=True\"\n                      >Click here to find your SRA ID</a\n                    >\n                  </h4>\n                  <h3 class=\"and-or\"><b>OR</b></h3>\n                </div>\n              </div>\n              <div class=\"divider clearfix\"></div>\n\n              <div class=\"row\" id=\"third-section\">\n                <div class=\"col-md-6 col-sm-4 h5 text-right\">\n                  LinkedIn Profile\n                </div>\n                <div\n                  class=\"col-md-6 col-sm-8 text-left\"\n                  ng-if=\"!ctrl.candidate.linkedinUrl && !ctrl.candidate.linkedinData && !ctrl.user.isAdmin\"\n                >\n                  <a\n                    data-testid=\"linkedin\"\n                    href=\"\"\n                    class=\"btn btn-linkedin-l full-width-xs\"\n                    ng-show=\"ctrl.candidate.isNewUser\"\n                    ng-disabled=\"ctrl.user.isAdmin\"\n                    ng-click=\"ctrl.connectToLinkedIn(ctrl.candidate.id)\"\n                    ><i class=\"fa fa-linkedin\"></i> | Connect with LinkedIn</a\n                  >\n                </div>\n\n                <div\n                  class=\"col-md-4 text-left\"\n                  ng-if=\"ctrl.candidate.linkedinUrl || ctrl.candidate.linkedinData\"\n                >\n                  <h4 class=\"linkedin-success\">\n                    <span>\n                      {{ctrl.candidate.linkedinUrl}}\n                    </span>\n                    <span>\n                      Successfully connected with LinkedIn\n                      <span class=\"fa fa-check\"></span>\n                    </span>\n                  </h4>\n                </div>\n              </div>\n\n              <div class=\"row \">\n                <h3\n                  class=\"and-or col-md-offset-6 col-md-2 col-sm-offset-4 col-sm-4 col-xs-12\"\n                >\n                  <b>OR</b>\n                </h3>\n              </div>\n              <div class=\"divider clearfix\"></div>\n\n              <div class=\"row\">\n                <div class=\"col-md-6 col-sm-4 h5 text-right\">\n                  Upload draft CV\n                </div>\n                <div\n                  ng-if=\"ctrl.candidate.isNewUser\"\n                  class=\"col-md-6 col-sm-8 text-left\"\n                >\n                  <button\n                    data-testid=\"cv-upload\"\n                    ng-if=\"ctrl.candidate.isNewUser && !ctrl.user.isAdmin\"\n                    type=\"file\"\n                    ng-file-select=\"ctrl.uploadResumeButton($files);\"\n                    class=\"btn btn-w-md btn-gap-v btn-line-info pull-left full-width-xs\"\n                    ng-multiple=\"false\"\n                    allow-dir=\"true\"\n                    accept=\".docx,.pdf,.doc\"\n                    ng-show=\"!ctrl.candidate.resume\"\n                    ng-class=\"{'input-error': (ctrl.accessRequested && !ctrl.candidate.resume && ( !ctrl.candidate.linkedinData || !ctrl.candidate.sraId))}\"\n                  >\n                    Choose File\n                  </button>\n                  <div\n                    ng-show=\"!ctrl.candidate.resume && !ctrl.user.isAdmin\"\n                    class=\"edit-cv-txt\"\n                  >\n                    &nbsp;(you can edit this later)\n                  </div>\n                  <h5 ng-if=\"ctrl.candidate.resume\">\n                    {{ctrl.candidate.resume.name}} &nbsp;&nbsp;\n                    <a\n                      href=\"\"\n                      type=\"file\"\n                      class=\"fa fa-pencil\"\n                      ng-file-select=\"ctrl.uploadResumeButton($files,ctrl.candidate.resume.id);\"\n                      ng-multiple=\"false\"\n                      allow-dir=\"true\"\n                      accept=\".pdf\"\n                      ng-if=\"!ctrl.user.isAdmin\"\n                    ></a>\n                  </h5>\n                </div>\n\n                <div\n                  ng-if=\"!ctrl.candidate.isNewUser && ctrl.candidate.resume\"\n                  class=\"col-md-6 text-left\"\n                >\n                  <strong><h5>{{ctrl.candidate.resume.name}}</h5></strong>\n                </div>\n                <span\n                  us-spinner=\"{radius:10, width:2, length: 12, color: 'black'}\"\n                  spinner-key=\"spinner-2\"\n                ></span>\n              </div>\n              <hr />\n              <div class=\"divider clearfix\"></div>\n\n              <div class=\"row\">\n                <center>\n                  <button\n                    data-testid=\"request-access\"\n                    type=\"submit\"\n                    ng-disabled=\"!ctrl.candidate.isNewUser || ctrl.user.isAdmin\"\n                    ng-class=\"ctrl.requestAccessBtnClass\"\n                    ng-click=\"ctrl.applyRequestAccess()\"\n                  >\n                    {{ctrl.requestAccessBtnLabel}}\n                  </button>\n                </center>\n              </div>\n            </form>\n\n            <div class=\"row\">\n              <center>\n                <strong>\n                  <h4\n                    ng-if=\"!ctrl.candidate.isNewUser\"\n                    class=\"text-success access-requested\"\n                  >\n                    <span class=\"fa fa-check\"></span>\n                    {{'createProfile.accessRequestedMsg'|translate}}\n                  </h4>\n                  <h4 ng-if=\"ctrl.candidate.isNewUser\" class=\" margin-t20\">\n                    <span class=\"glyphicon glyphicon-lock\"></span>This\n                    information is <b>strictly confidential</b> and will not be\n                    shared without your permission.\n                  </h4>\n                </strong>\n              </center>\n            </div>\n          </div>\n        </div>\n      </div>\n    </section>\n  </div>\n  <!-- Container Ends -->\n\n  <!-- Footer -->\n  <div lexstep-footer></div>\n\n  <script type=\"text/ng-template\" id=\"practice-area-modal.html\">\n    <practice-Area></practice-Area>\n  </script>\n\n  <script type=\"text/ng-template\" id=\"locations-modal.html\">\n    <locations-Modal></locations-Modal>\n  </script>\n  <lawyer-preferences\n    modal-open-handler=\"openLawyerPreferencesModal\"\n    candidate=\"ctrl.candidate\"\n    jurisdictions=\"ctrl.candidate.legalJurisdictions\"\n    on-jurisdiction-update=\"ctrl.jurisdictionUpdate($event,selectedJurisdiction)\"\n    logger-in-active=\"true\"\n    display-next-button=\"true\"\n  ></lawyer-preferences>\n</div>\n"

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

	module.exports = "<script type=\"text/ng-template\" id=\"applicationProfileModal.html\">\n\t<div class=\"modal-bodyclearfix\">\n\t\t<candidate-profile />\n\t</div>\n\t<script>"

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"application-listing\"\n  ng-cloak\n  data-ng-controller=\"ApplicationListingController as ctrl\"\n>\n  <div lexstep-header ng-if=\"!ctrl.positionId\"></div>\n  <span\n    us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n    spinner-key=\"application-listing\"\n    class=\"spinner-static-center\"\n  ></span>\n  <div class=\"container-fluid bg-white\" ng-click=\"hideDropDown()\">\n    <ag-Grid-Listing\n      ng-if=\"ctrl.gridOptions\"\n      grid-name=\"ctrl.gridName\"\n      grid-options=\"ctrl.gridOptions\"\n      help-tooltip=\"ctrl.helpTooltip\"\n      filter-count=\"ctrl.filterCount\"\n      grid-actions-directive=\"ctrl.gridActionsDirective\"\n      active-actions=\"ctrl.activeActions\"\n      actions-functions=\"ctrl.actionsFunctions\"\n      grid-data-actions=\"ctrl.gridDataActions\"\n      multiple-selection-actions=\"ctrl.multipleSelectionActions\"\n      multi-select-options=\"ctrl.multiSelectOptions\"\n      group-list=\"ctrl.groupList\"\n      action-directives=\"ctrl.actionDirectives\"\n      is-allowed-agent=\"ctrl.isAllowedAgent\"\n      show-cv=\"ctrl.showCv\"\n      half-grid=\"ctrl.splitGrid(value)\"\n      update-drop-down-stages=\"ctrl.updateApplicationStageAction(list,updateStageOnGrid)\"\n      all-application-stages-list=\"ctrl.allApplicationStagesList\"\n      hierarchial-application-stages=\"ctrl.applicationStagesHierarchialList\"\n      inner-height=\"ctrl.innerHeight\"\n    />\n  </div>\n</div>\n<application-history></application-history>\n\n<application-agent></application-agent>\n<position-Details></position-Details>\n<delete-application></delete-application>\n<date-Modal></date-Modal>\n"

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"page-signin\"\n  ng-cloak\n  data-ng-controller=\"CandidateListingController as ctrl\"\n>\n  <div lexstep-header></div>\n  <span\n    us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n    spinner-key=\"candidate-listing\"\n    class=\"spinner-static-center\"\n  ></span>\n\n  <script type=\"text/ng-template\" id=\"deleteLawyerModal.html\">\n    <div class=\"modal-header\">\n        <center>\n            <h3>Delete Lawyer</h3>\n            <h5>Are you sure you want to delete this lawyer?</h5>\n        </center>\n    </div>\n    <div class=\"modal-footer\">\n        <center>\n            <button class=\"btn btn-info\" ng-click=\"yes()\">Yes</button>\n            <button class=\"btn btn-gap-v btn-default\" ng-click=\"no()\">No</button>\n        </center>\n    </div>\n  </script>\n  <div ng-include src=\"'views/modals/edit-candidate-modal.html'\"></div>\n\n  <ag-Grid-Listing\n    ng-if=\"ctrl.gridOptions\"\n    grid-name=\"ctrl.gridName\"\n    grid-options=\"ctrl.gridOptions\"\n    help-tooltip=\"ctrl.helpTooltip\"\n    filter-count=\"ctrl.filterCount\"\n    grid-actions-directive=\"ctrl.gridActionsDirective\"\n    active-actions=\"ctrl.activeActions\"\n    actions-functions=\"ctrl.actionsFunctions\"\n    grid-data-actions=\"ctrl.gridDataActions\"\n    multiple-selection-actions=\"ctrl.multipleSelectionActions\"\n    multi-select-options=\"ctrl.multiSelectOptions\"\n    group-list=\"ctrl.groupList\"\n    inner-height=\"ctrl.innerHeight\"\n    show-cv=\"ctrl.showCv\"\n    half-grid=\"ctrl.splitGrid(value)\"\n  />\n</div>\n"

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"page-signin\"\n  ng-cloak\n  data-ng-controller=\"EmailListingController as ctrl\"\n>\n  <div lexstep-header></div>\n\n  <div class=\"container-fluid\" ng-click=\"hideDropDown()\">\n    <div class=\"panel-body heading-jobs-listings row\">\n      <center>\n        <h1 class=\"text-thin hdng-tshadow\">{{ctrl.listingTitle}}</h1>\n      </center>\n    </div>\n    <!--listings div starts-->\n    <div class=\"panel-body bg-white\">\n      <form class=\"col-md-4 margin-b10\" style=\"margin-left: -14px\">\n        <input\n          data-testid=\"search-email\"\n          type=\"text\"\n          placeholder=\"Search Email\"\n          class=\"form-control\"\n          data-ng-model=\"ctrl.searchEmailQuery\"\n          data-ng-keyup=\"ctrl.searchEmail()\"\n        />\n      </form>\n\n      <span\n        us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n        spinner-key=\"spinner-2\"\n      ></span>\n      <div class=\"responsive-table table-dynamic\">\n        <!--table for lawyer listing-->\n        <table\n          data-testid=\"email-table\"\n          class=\"table table-bordered table-responsive\"\n        >\n          <thead data-testid=\"columns-row\" class=\"nowrap\">\n            <tr>\n              <th>\n                <div data-testid=\"id\" class=\"th\">\n                  Id\n                  <span\n                    class=\"glyphicon glyphicon-chevron-up\"\n                    data-ng-click=\" ctrl.orderEmailListing('id', 'asc') \"\n                    data-ng-class=\"{active: ctrl.sortBy == 'id_asc'}\"\n                  ></span>\n                  <span\n                    class=\"glyphicon glyphicon-chevron-down\"\n                    data-ng-click=\" ctrl.orderEmailListing('id' , 'desc') \"\n                    data-ng-class=\"{active: ctrl.sortBy == 'id_desc'}\"\n                  ></span>\n                </div>\n              </th>\n              <th>\n                <div data-testid=\"label\" class=\"th\">\n                  Label\n                  <span\n                    class=\"glyphicon glyphicon-chevron-up\"\n                    data-ng-click=\" ctrl.orderEmailListing('label', 'asc') \"\n                    data-ng-class=\"{active: ctrl.sortBy == 'label_asc'}\"\n                  ></span>\n                  <span\n                    class=\"glyphicon glyphicon-chevron-down\"\n                    data-ng-click=\" ctrl.orderEmailListing('label' , 'desc') \"\n                    data-ng-class=\"{active: ctrl.sortBy == 'label_desc'}\"\n                  ></span>\n                </div>\n              </th>\n              <th>\n                <div data-testid=\"description\" class=\"th\">\n                  Email Description\n                  <span\n                    class=\"glyphicon glyphicon-chevron-up\"\n                    data-ng-click=\" ctrl.orderEmailListing('description', 'asc') \"\n                    data-ng-class=\"{active: ctrl.sortBy == 'description_asc'}\"\n                  ></span>\n                  <span\n                    class=\"glyphicon glyphicon-chevron-down\"\n                    data-ng-click=\" ctrl.orderEmailListing('description', 'desc') \"\n                    data-ng-class=\"{active: ctrl.sortBy == 'description_desc'}\"\n                  ></span>\n                </div>\n              </th>\n              <th>\n                <div data-testid=\"sendgridTemplateId\" class=\"th\">\n                  SendGrid ID\n                  <span\n                    class=\"glyphicon glyphicon-chevron-up\"\n                    data-ng-click=\" ctrl.orderEmailListing('sendgridTemplateId' , 'asc') \"\n                    data-ng-class=\"{active: ctrl.sortBy == 'sendgridTemplateId_asc'}\"\n                  ></span>\n                  <span\n                    class=\"glyphicon glyphicon-chevron-down\"\n                    data-ng-click=\" ctrl.orderEmailListing('sendgridTemplateId', 'desc') \"\n                    data-ng-class=\"{active: ctrl.sortBy == 'sendgridTemplateId_desc'}\"\n                  ></span>\n                </div>\n              </th>\n              <th>\n                <div data-testid=\"to\" class=\"th\">\n                  To\n                  <span\n                    class=\"glyphicon glyphicon-chevron-up\"\n                    data-ng-click=\" ctrl.orderEmailListing('to', 'asc') \"\n                    data-ng-class=\"{active: ctrl.sortBy == 'to_asc'}\"\n                  ></span>\n                  <span\n                    class=\"glyphicon glyphicon-chevron-down\"\n                    data-ng-click=\" ctrl.orderEmailListing('to','desc') \"\n                    data-ng-class=\"{active: ctrl.sortBy == 'to_desc'}\"\n                  ></span>\n                </div>\n              </th>\n              <th>\n                <div data-testid=\"from\" class=\"th\">\n                  From\n                  <span\n                    class=\"glyphicon glyphicon-chevron-up\"\n                    data-ng-click=\" ctrl.orderEmailListing('from', 'asc') \"\n                    data-ng-class=\"{active: ctrl.sortBy == 'from_asc'}\"\n                  ></span>\n                  <span\n                    class=\"glyphicon glyphicon-chevron-down\"\n                    data-ng-click=\" ctrl.orderEmailListing('from', 'desc') \"\n                    data-ng-class=\"{active: ctrl.sortBy == 'from_desc'}\"\n                  ></span>\n                </div>\n              </th>\n              <th>\n                <div data-testid=\"fromName\" fromclass=\"th\">\n                  From Name\n                  <span\n                    class=\"glyphicon glyphicon-chevron-up\"\n                    data-ng-click=\" ctrl.orderEmailListing('fromName', 'asc') \"\n                    data-ng-class=\"{active: ctrl.sortBy == 'fromName_asc'}\"\n                  ></span>\n                  <span\n                    class=\"glyphicon glyphicon-chevron-down\"\n                    data-ng-click=\" ctrl.orderEmailListing('fromName', 'desc') \"\n                    data-ng-class=\"{active: ctrl.sortBy == 'fromName_desc'}\"\n                  ></span>\n                </div>\n              </th>\n              <th>\n                <div data-testid=\"bcc\" class=\"th\">\n                  BCC\n                  <span\n                    class=\"glyphicon glyphicon-chevron-up\"\n                    data-ng-click=\" ctrl.orderEmailListing('bcc', 'asc') \"\n                    data-ng-class=\"{active: ctrl.sortBy == 'bcc_asc'}\"\n                  ></span>\n                  <span\n                    class=\"glyphicon glyphicon-chevron-down\"\n                    data-ng-click=\" ctrl.orderEmailListing('bcc', 'desc') \"\n                    data-ng-class=\"{active: ctrl.sortBy == 'bcc_desc'}\"\n                  ></span>\n                </div>\n              </th>\n\n              <th>\n                <div data-testid=\"cc\" class=\"th\">\n                  CC\n                  <span\n                    class=\"glyphicon glyphicon-chevron-up\"\n                    data-ng-click=\" ctrl.orderEmailListing('cc', 'asc') \"\n                    data-ng-class=\"{active: ctrl.sortBy == 'cc_asc'}\"\n                  ></span>\n                  <span\n                    class=\"glyphicon glyphicon-chevron-down\"\n                    data-ng-click=\" ctrl.orderEmailListing('cc', 'desc') \"\n                    data-ng-class=\"{active: ctrl.sortBy == 'cc_desc'}\"\n                  ></span>\n                </div>\n              </th>\n\n              <th>\n                <div data-testid=\"status\" class=\"th\">\n                  Status\n                </div>\n              </th>\n              <!-- TODO: Implement this functionality of display context of email from sendGrid in v1.1.0  -->\n              <!-- <th>\n                <div class=\"th\">\n                  Actions\n                </div>\n              </th> -->\n            </tr>\n          </thead>\n          <tbody>\n            <tr data-ng-repeat=\"email in ctrl.listing\">\n              <td data-testid=\"id\">{{email.id}}</td>\n              <td data-testid=\"label\">{{email.label}}</td>\n              <td data-testid=\"description\">\n                {{email.description}}\n              </td>\n              <td data-testid=\"sendgridTemplateId\">\n                {{email.sendgridTemplateId}}\n              </td>\n              <td data-testid=\"to\">{{email.to}}</td>\n              <td data-testid=\"from\">{{email.from}}</td>\n              <td data-testid=\"fromName\">{{email.fromName}}</td>\n              <td data-testid=\"bcc\">\n                <span ng-if=\"!email.isEditedFieldBCC\">\n                  {{email.bcc}}\n                </span>\n                <input\n                  ng-if=\"email.isEditedFieldBCC\"\n                  data-testid=\"bcc-input-field\"\n                  type=\"text\"\n                  data-ng-model=\"ctrl.emailInputBCCField\"\n                  class=\"form-control\"\n                />\n                <span ng-if=\"!email.isEditedFieldBCC\" class=\"email-edit-button\">\n                  <a\n                    href=\"\"\n                    data-testid=\"email-edit\"\n                    class=\"btn btn-noline-info btn-xs\"\n                    ng-click=\"ctrl.editEmailField(email,'bcc')\"\n                  >\n                    <i\n                      class=\"fa fa-pencil\"\n                      data-testid=\"bcc-edit-pencil\"\n                      aria-hidden=\"true\"\n                    ></i>\n                  </a>\n                </span>\n                <span ng-if=\"email.isEditedFieldBCC\" class=\"email-edit-button\">\n                  <a\n                    href=\"\"\n                    data-testid=\"email-save\"\n                    class=\"btn btn-noline-info btn-xs\"\n                    ng-click=\"ctrl.updateEmail(email,'bcc')\"\n                  >\n                    <i class=\"fa fa-floppy-o\"></i>\n                  </a>\n                  <a\n                    href=\"\"\n                    data-testid=\"email-cancel\"\n                    class=\"btn btn-noline-info btn-xs\"\n                    ng-click=\"email.isEditedFieldBCC=false\"\n                  >\n                    <i class=\"fa fa-times\"></i>\n                  </a>\n                </span>\n              </td>\n              <td data-testid=\"cc\">\n                <span ng-show=\"!email.isEditedFieldCC\"> {{email.cc}} </span>\n                <input\n                  ng-if=\"email.isEditedFieldCC\"\n                  data-testid=\"cc-input-field\"\n                  type=\"text\"\n                  data-ng-model=\"ctrl.emailInputCCField\"\n                  class=\"form-control\"\n                />\n                <span ng-if=\"!email.isEditedFieldCC\" class=\"email-edit-button\">\n                  <a\n                    href=\"\"\n                    data-testid=\"email-edit\"\n                    class=\"btn btn-noline-info btn-xs\"\n                    ng-click=\"ctrl.editEmailField(email,'cc')\"\n                  >\n                    <i\n                      data-testid=\"cc-edit-pencil\"\n                      class=\"fa fa-pencil\"\n                      aria-hidden=\"true\"\n                    ></i>\n                  </a>\n                </span>\n                <span ng-if=\"email.isEditedFieldCC\" class=\"email-edit-button\">\n                  <a\n                    href=\"\"\n                    data-testid=\"email-save\"\n                    class=\"btn btn-noline-info btn-xs\"\n                    ng-click=\"ctrl.updateEmail(email,'cc')\"\n                  >\n                    <i class=\"fa fa-floppy-o\"></i>\n                  </a>\n                  <a\n                    href=\"\"\n                    data-testid=\"email-cancel\"\n                    class=\"btn btn-noline-info btn-xs\"\n                    ng-click=\"email.isEditedFieldCC=false\"\n                  >\n                    <i class=\"fa fa-times\"></i>\n                  </a>\n                </span>\n              </td>\n              <td data-testid=\"status\">{{email.active}}</td>\n              <!-- TODO: Implement this functionality of display context of email from sendGrid in v1.1.0  -->\n              <!-- <td class=\"nowrap\">\n                <button\n                  data-testid=\"view-email\"\n                  class=\"btn btn-info btn-xs\"\n                  id=\"delete-lawyer\"\n                  ng-click=\"ctrl.openEmailBodyViewPage(email,$event)\"\n                >\n                  View\n                </button>\n                //Removed as per discussion will Implement History Functionality in v.1.1.0\n                <div\n                  class=\"history-wrapper\"\n                  ng-if=\"email.category_ID == 4 ||\n                                          email.category_ID == 22 ||\n                                          email.category_ID == 23 ||\n                                          email.category_ID == 24\"\n                >\n                  <a ng-click=\"ctrl.showHistory()\">History</a>\n                </div> \n              </td> -->\n            </tr>\n          </tbody>\n        </table>\n      </div>\n\n      <footer class=\"table-footer table-dynamic\">\n        <div class=\"row\">\n          <span\n            us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n            spinner-key=\"spinner-1\"\n          ></span>\n          <div class=\"page-num-info\">\n            <span>\n              Show\n              <span class=\"ui-select select-enty-count\">\n                <select\n                  data-ng-model=\"ctrl.numPerPage\"\n                  data-ng-options=\"num for num in ctrl.numPerPageOpt\"\n                  data-ng-change=\"ctrl.onNumPerPageChange()\"\n                >\n                </select>\n              </span>\n              entries per page\n            </span>\n          </div>\n\n          <div class=\"text-right pagination-container custom-pagination\">\n            <pagination\n              class=\"pagination-sm\"\n              data-ng-model=\"ctrl.currentPage\"\n              total-items=\"ctrl.totalEmailList\"\n              max-size=\"4\"\n              data-ng-change=\"ctrl.select(ctrl.currentPage)\"\n              items-per-page=\"ctrl.numPerPage\"\n              rotate=\"false\"\n              boundary-links=\"true\"\n            >\n            </pagination>\n          </div>\n        </div>\n      </footer>\n    </div>\n    <footer class=\"footer\">\n      <div class=\"container\">\n        <div ng-include src=\"'views/pages/admin-footer.html'\"></div>\n      </div>\n      <!-- / .container -->\n    </footer>\n  </div>\n</div>\n"

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-signin\" data-ng-controller=\"EmailPreviewController as ctrl\">\n  <div lexstep-header></div>\n\n  <i\n    class=\"fa fa-arrow-left fa-2x padding-tl1020 pointer\"\n    aria-hidden=\"true\"\n    ng-click=\"ctrl.navigateToEmailListing()\"\n  ></i>\n  <div class=\"container\" ng-click=\"hideDropDown()\">\n    <div class=\"panel-body heading-jobs-listings row\">\n      <center>\n        <h1 class=\"text-thin hdng-tshadow\">{{ctrl.email.subject}}</h1>\n      </center>\n    </div>\n\n    <div class=\"panel panel-default\" ng-show=\"true\">\n      <section class=\"panel-body margin-b50\">\n        <div class=\"panel-body heading-jobs-listings row\">\n          <div\n            data-testid=\"email-content\"\n            class=\"padding-l40\"\n            ng-bind-html=\"ctrl.emailContent\"\n          ></div>\n        </div>\n      </section>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"page-signin\"\n  ng-cloak\n  data-ng-controller=\"EmployersListingController as ctrl\"\n>\n  <div lexstep-header></div>\n  <div class=\"container-fluid\" ng-click=\"ctrl.hideDropDown()\">\n    <div class=\"clearfix\">\n      <alert type=\"danger\" class=\"col-md-12\" ng-show=\"ctrl.showOnError\">\n        <strong><center>{{ctrl.alertMsg}}</center></strong>\n      </alert>\n      <alert type=\"success\" class=\"col-md-12\" ng-show=\"ctrl.showOnSuccess\">\n        <strong><center>{{ctrl.alertMsg}}</center></strong>\n      </alert>\n    </div>\n    <div class=\"admin-table\">\n      <ag-Grid-Listing\n        ng-if=\"ctrl.gridOptions\"\n        grid-name=\"ctrl.gridName\"\n        grid-options=\"ctrl.gridOptions\"\n        grid-actions-directive=\"ctrl.gridActionsDirective\"\n        filter-count=\"ctrl.filterCount\"\n        multi-select-options=\"ctrl.multiSelectOptions\"\n        group-list=\"ctrl.groupList\"\n        active-actions=\"ctrl.activeActions\"\n        actions-functions=\"ctrl.actionsFunctions\"\n        grid-data-actions=\"ctrl.gridDataActions\"\n      />\n    </div>\n  </div>\n</div>\n\n<script type=\"text/ng-template\" id=\"create-update-position-modal.html\">\n  <create-Update-Position-Modal></create-Update-Position-Modal>\n</script>\n\n<script type=\"text/ng-template\" id=\"create-update-employer-modal.html\">\n  <create-Update-Employer-Modal></create-Update-Employer-Modal>\n</script>\n"

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-signin\" ng-cloak data-ng-controller=\"InactivePositionListingController as ctrl\">\n  <div lexstep-header></div>\n\n  <div class=\"container-fluid\" ng-click=\"hideDropDown()\">\n    <div class=\"clearfix\">\n      <alert type=\"danger\" class=\"col-md-12\" ng-show=\"ctrl.showOnError\">\n        <strong><center>{{ctrl.alertMsg}}</center></strong>\n      </alert>\n      <alert type=\"success\" class=\"col-md-12\" ng-show=\"ctrl.showOnSuccess\">\n        <strong><center>{{ctrl.alertMsg}}</center></strong>\n      </alert>\n    </div>\n    <div class=\"admin-table\">\n      <ag-Grid-Listing ng-if=\"ctrl.gridOptions\"\n      grid-name=\"ctrl.gridName\"\n      grid-options=\"ctrl.gridOptions\"\n      help-tooltip=\"ctrl.helpTooltip\"\n      filter-count=\"ctrl.filterCount\"\t\n      grid-actions-directive=\"ctrl.gridActionsDirective\"\n      active-actions=\"ctrl.activeActions\"\n      actions-functions=\"ctrl.actionsFunctions\"\n      grid-data-actions=\"ctrl.gridDataActions\"\n      multiple-selection-actions=\"ctrl.multipleSelectionActions\"\n      multi-select-options=\"ctrl.multiSelectOptions\"\n      group-list=\"ctrl.groupList\"\n      />\n    </div>\n    </div>\n  </div>\n\n\n<script type=\"text/ng-template\" id=\"create-update-position-modal.html\">\n    <create-Update-Position-Modal></create-Update-Position-Modal>\n</script>\n\n<script type=\"text/ng-template\" id=\"create-update-employer-modal.html\">\n  <create-Update-Employer-Modal></create-Update-Employer-Modal>\n</script>\n<clone-Position-Modal></clone-Position-Modal>\n</div>\n<date-Modal></date-Modal>\n<position-Details></position-Details>\n\n"

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-signin\" ng-cloak data-ng-controller=\"PositionListingController as ctrl\">\n  <div lexstep-header></div>\n\n  <div class=\"container-fluid\" ng-click=\"hideDropDown()\">\n    <div class=\"clearfix\">\n      <alert type=\"danger\" class=\"col-md-12\" ng-show=\"ctrl.showOnError\">\n        <strong><center>{{ctrl.alertMsg}}</center></strong>\n      </alert>\n      <alert type=\"success\" class=\"col-md-12\" ng-show=\"ctrl.showOnSuccess\">\n        <strong><center>{{ctrl.alertMsg}}</center></strong>\n      </alert>\n    </div>\n    <div class=\"admin-table\">\n      <ag-Grid-Listing ng-if=\"ctrl.gridOptions\"\n      grid-name=\"ctrl.gridName\"\n      grid-options=\"ctrl.gridOptions\"\n      help-tooltip=\"ctrl.helpTooltip\"\n      filter-count=\"ctrl.filterCount\"\t\n      grid-actions-directive=\"ctrl.gridActionsDirective\"\n      active-actions=\"ctrl.activeActions\"\n      actions-functions=\"ctrl.actionsFunctions\"\n      grid-data-actions=\"ctrl.gridDataActions\"\n      multiple-selection-actions=\"ctrl.multipleSelectionActions\"\n      multi-select-options=\"ctrl.multiSelectOptions\"\n      group-list=\"ctrl.groupList\"\n      />\n    </div>\n    </div>\n  </div>\n\n\n<script type=\"text/ng-template\" id=\"create-update-position-modal.html\">\n    <create-Update-Position-Modal></create-Update-Position-Modal>\n</script>\n\n<script type=\"text/ng-template\" id=\"create-update-employer-modal.html\">\n  <create-Update-Employer-Modal></create-Update-Employer-Modal>\n</script>\n<clone-Position-Modal></clone-Position-Modal>\n</div>\n<date-Modal></date-Modal>\n<position-Details></position-Details>\n"

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"page-signin\"\n  ng-cloak\n  data-ng-controller=\"RecommendationListingController as ctrl\"\n>\n  <div lexstep-header hidden></div>\n\n  <span\n    us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n    spinner-key=\"recommendation-listing\"\n    class=\"spinner-static-center\"\n  ></span>\n  <div class=\"container-fluid bg-white\" ng-click=\"hideDropDown()\">\n    <ag-Grid-Listing\n      ng-if=\"ctrl.gridOptions\"\n      grid-name=\"ctrl.gridName\"\n      grid-options=\"ctrl.gridOptions\"\n      help-tooltip=\"ctrl.helpTooltip\"\n      filter-count=\"ctrl.filterCount\"\n      grid-actions-directive=\"ctrl.gridActionsDirective\"\n      active-actions=\"ctrl.activeActions\"\n      actions-functions=\"ctrl.actionsFunctions\"\n      grid-data-actions=\"ctrl.gridDataActions\"\n      multiple-selection-actions=\"ctrl.multipleSelectionActions\"\n      multi-select-options=\"ctrl.multiSelectOptions\"\n      group-list=\"ctrl.groupList\"\n      inner-height=\"ctrl.innerHeight\"\n      show-cv=\"ctrl.showCv\"\n      half-grid=\"ctrl.splitGrid(value)\"\n      update-drop-down-stages=\"ctrl.updateApplicationStageAction(list,updateStageOnGrid)\"\n      all-application-stages-list=\"ctrl.allApplicationStagesList\"\n      hierarchial-application-stages=\"ctrl.applicationStagesHierarchialList\"\n    />\n  </div>\n</div>\n<application-history></application-history>\n<position-Details></position-Details>\n"

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

	module.exports = "<div lexstep-header></div>\n<div\n  ng-cloak\n  data-ng-controller=\"RecommendationPageController as ctrl\"\n  ng-style=\"ctrl.pageStyle()\"\n>\n  <div data-testid=\"matching-lawyer-header\" class=\"matching-lawyer-header\">\n    <ul class=\"nav nav-pills tab-Matches\" style=\"padding:0 0 0 40px\">\n      <li ng-class=\"{active:ctrl.isSet(3)}\">\n        <a\n          ng-click=\"ctrl.setTab(3,'Description')\"\n          tooltip-matchinglawyer=\"Review Position description to understand employer requirements.\"\n        >\n          <svg\n            version=\"1.1\"\n            id=\"Layer_1\"\n            xmlns=\"http://www.w3.org/2000/svg\"\n            xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n            x=\"0px\"\n            y=\"0px\"\n            style=\"width: auto;height: 23px;margin-right: 10px;\"\n            viewBox=\"0 0 614.9 540\"\n            style=\"enable-background:new 0 0 614.9 540;\"\n            xml:space=\"preserve\"\n          >\n            <style type=\"text/css\">\n              .st0 {\n                fill: #9d9d9d;\n              }\n            </style>\n            <path\n              class=\"st0\"\n              d=\"M512.9,3.8H102c-16.6,0-30,13.4-30,30v472.4c0,16.6,13.4,30,30,30h410.9c16.6,0,30-13.4,30-30V33.8\n\t\t\t\t\tC542.9,17.2,529.5,3.8,512.9,3.8z M433.7,425.5H181.2c-15.1,0-27.3-12.2-27.3-27.3c0-15.1,12.2-27.3,27.3-27.3h252.6\n\t\t\t\t\tc15.1,0,27.3,12.2,27.3,27.3C461,413.3,448.8,425.5,433.7,425.5z M433.7,302H181.2c-15.1,0-27.3-12.2-27.3-27.3\n\t\t\t\t\tc0-15.1,12.2-27.3,27.3-27.3h252.6c15.1,0,27.3,12.2,27.3,27.3C461,289.8,448.8,302,433.7,302z M433.7,178.6H181.2\n\t\t\t\t\tc-15.1,0-27.3-12.2-27.3-27.3c0-15.1,12.2-27.3,27.3-27.3h252.6c15.1,0,27.3,12.2,27.3,27.3C461,166.4,448.8,178.6,433.7,178.6z\"\n            />\n          </svg>\n          Description\n        </a>\n      </li>\n      <li style=\"border-bottom: 1px solid #b3b3b3;height: 20px;width: 2%;\"></li>\n      <li ng-class=\"{active:ctrl.isSet(1)}\">\n        <a\n          ng-click=\"ctrl.setTab(1,'Matches')\"\n          tooltip-matchinglawyer=\"Review LexStep Matches - use filters to refine search and shortlist top candidates by promoting their match stage to “Scouted”.  Reach out to your assigned candidates and ask other Talent Agents to reach out to theirs to encourage interest in the Position. \"\n        >\n          <svg\n            version=\"1.1\"\n            id=\"Layer_1\"\n            xmlns=\"http://www.w3.org/2000/svg\"\n            xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n            x=\"0px\"\n            y=\"0px\"\n            style=\"width: auto;height: 23px;margin-right: 10px;\"\n            viewBox=\"0 0 614.9 540\"\n            style=\"enable-background:new 0 0 614.9 540;\"\n            xml:space=\"preserve\"\n          >\n            <style type=\"text/css\">\n              .st0 {\n                fill: #9d9d9d;\n              }\n            </style>\n            <g>\n              <circle class=\"st0\" cx=\"282.2\" cy=\"206.9\" r=\"67.3\" />\n              <path\n                class=\"st0\"\n                d=\"M562.6,472.1l-87.8-87.8l3.5-5.1c28-40.4,42.2-86.1,42.2-135.7c0-32.3-6.4-63.6-18.9-93\n\t\t   c-12.5-29.5-29.7-55.3-51-76.6c-21.3-21.3-47.1-38.5-76.6-51C344.6,10.3,313.3,4,281,4c-32.3,0-63.6,6.4-93,18.9\n\t\t   c-29.5,12.5-55.3,29.7-76.6,51C90,95.2,72.9,121,60.3,150.5c-12.5,29.5-18.9,60.8-18.9,93c0,32.3,6.4,63.6,18.9,93\n\t\t   c12.5,29.5,29.7,55.3,51,76.6c21.3,21.3,47.1,38.5,76.6,51c29.5,12.5,60.8,18.9,93,18.9c49.7,0,95.3-14.2,135.7-42.2l5-3.5\n\t\t   l87.9,87.5c7.2,7.6,15.5,11.1,26.3,11.1c10.1,0,18.9-3.8,26.4-11.2c7.4-7.4,11.2-16.3,11.2-26.4\n\t\t   C573.5,488.2,569.8,479.3,562.6,472.1z M397.2,359.7c-0.8,0.8-1.6,1.6-2.5,2.4C363.2,392.6,324.9,408,281,408\n\t\t   c-43.2,0-80.9-14.9-112.2-44.4c-1.6-1.5-2.8-2.7-4.1-3.9c-32-32-48.3-71.1-48.3-116.2c0-45.1,16.2-84.2,48.3-116.2\n\t\t   c32-32,71.1-48.3,116.2-48.3c45.1,0,84.2,16.2,116.2,48.3c32,32,48.3,71.1,48.3,116.2C445.5,288.6,429.2,327.7,397.2,359.7z\"\n              />\n              <path\n                class=\"st0\"\n                d=\"M281.7,387.1c1.6,0,3.3,0,4.9-0.1c-1.7,0.1-3.5,0.1-5.3,0.1C281.5,387.1,281.6,387.1,281.7,387.1z\"\n              />\n              <path\n                class=\"st0\"\n                d=\"M380.4,333.5c-22.2-30.1-57.9-49.6-98.2-49.6c-40.5,0-76.4,19.8-98.6,50.2c23,28.6,58.3,47,97.8,47.1\n\t\t   c1.7,0,3.4,0,5-0.1C324.5,379.6,358.2,361.4,380.4,333.5z\"\n              />\n            </g>\n          </svg>\n          Matches\n        </a>\n      </li>\n      <li style=\"border-bottom: 1px solid #b3b3b3;height: 20px;width: 2%;\"></li>\n      <li ng-class=\"{active:ctrl.isSet(2)}\">\n        <a\n          ng-click=\"ctrl.setTab(2,'Applications')\"\n          tooltip-matchinglawyer=\"Review Applications to manage Interest in the Position.\"\n        >\n          <svg\n            version=\"1.1\"\n            id=\"Layer_1\"\n            xmlns=\"http://www.w3.org/2000/svg\"\n            xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n            x=\"0px\"\n            y=\"0px\"\n            style=\"width: auto;height: 23px;margin-right: 10px;\"\n            viewBox=\"0 0 614.9 540\"\n            style=\"enable-background:new 0 0 614.9 540;\"\n            xml:space=\"preserve\"\n          >\n            <style type=\"text/css\">\n              .st0 {\n                fill: #9d9d9d;\n              }\n            </style>\n            <g>\n              <path\n                class=\"st0\"\n                d=\"M22.7,338.7l301.1,92.6c2.2,0.7,4.5,1,6.8,1c3.3,0,6.6-0.7,9.6-2.1l254.7-115.8c11.6-5.3,16.8-19,11.5-30.7\n\t\t\t\t\tc-5.3-11.6-18.9-16.8-30.7-11.5L329,384.5L36.3,294.4c-12.2-3.8-25.2,3.1-28.9,15.3C3.6,322,10.5,334.9,22.7,338.7z\"\n              />\n              <path\n                class=\"st0\"\n                d=\"M22.7,246.1l301.1,92.6c2.2,0.7,4.5,1,6.8,1c3.4,0,6.8-0.7,9.9-2.2c1-0.5,104.2-49.2,160.4-72.9\n\t\t\t\t\tc83.9-35.4,83.9-80.6,83.9-149.1V112c0-10.7-7.3-19.9-17.6-22.5L267.4,15.7c-6.9-1.7-14.2-0.1-19.8,4.3c-5.6,4.4-8.9,11.1-8.9,18.2\n\t\t\t\t\tc0,61.6-15.8,79.1-49.1,93.1L20.5,202.6c-9,3.8-14.6,12.8-14.1,22.5C6.9,234.8,13.4,243.2,22.7,246.1z\"\n              />\n              <path\n                class=\"st0\"\n                d=\"M575.8,365L329,477.1L36.3,387.1c-12.2-3.8-25.2,3.1-28.9,15.3c-3.8,12.2,3.1,25.2,15.3,28.9L323.8,524\n\t\t\t\t\tc2.2,0.7,4.5,1,6.8,1c3.3,0,6.6-0.7,9.6-2.1l254.7-115.8c11.6-5.3,16.8-19,11.5-30.7C601.2,364.8,587.5,359.6,575.8,365z\"\n              />\n            </g>\n          </svg>\n          Applications</a\n        >\n      </li>\n      <li style=\"border-bottom: 1px solid #b3b3b3;height: 20px;width: 2%;\"></li>\n      <li ng-class=\"{active:ctrl.isSet(4)}\">\n        <a\n          ng-click=\"ctrl.setTab(4,'Source')\"\n          tooltip-matchinglawyer=\"Source additional off-platform candidate leads for the Position via LinkedIn.\"\n        >\n          <svg\n            version=\"1.1\"\n            id=\"Layer_1\"\n            xmlns=\"http://www.w3.org/2000/svg\"\n            xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n            x=\"0px\"\n            y=\"0px\"\n            style=\"width: auto;height: 23px;margin-right: 10px; margin-top: -4px;\"\n            viewBox=\"0 0 614.9 540\"\n            style=\"enable-background:new 0 0 614.9 540;\"\n            xml:space=\"preserve\"\n          >\n            <style type=\"text/css\">\n              .st0 {\n                fill: #9d9d9d;\n              }\n            </style>\n            <g>\n              <path\n                class=\"st0\"\n                d=\"M334.9,223.6c7.1-9,13.1-16.6,20.6-22.9c13.9-11.7,30-18.8,47.6-22.2c24.4-4.7,48.8-5.1,73.2,0.2\n\t\t\t\t\tc38.7,8.4,64,32.1,78.3,68.3c7.9,19.9,11.5,40.8,13.1,62.1c3,40.1,1.4,80.2,1.7,120.4c0.2,28.5,0.1,57,0,85.5\n\t\t\t\t\tc0,12.2-6.6,19-18.7,19c-25.5,0.1-51,0.1-76.6,0c-12.2,0-18.9-6.8-18.9-18.9c0-55.9,0.1-111.7-0.1-167.6c0-13.5-1.4-26.9-6.1-39.8\n\t\t\t\t\tc-9-25-26.6-37.2-53.1-36.7c-26,0.5-45.2,15.4-54.3,42.1c-4.6,13.6-7,27.5-6.9,41.9c0.2,52.5,0.1,105.1,0.1,157.6\n\t\t\t\t\tc0,15.4-6.1,21.4-21.5,21.4c-23.5,0-47,0-70.5,0c-13.2,0-19.8-6.6-19.8-19.7c0-104.7,0-209.4,0-314.1c0-13.5,6.6-20,20-20\n\t\t\t\t\tc24,0,48.1,0,72.1,0c12.7,0,19.5,6.8,19.5,19.5C334.9,207,334.9,214.5,334.9,223.6z\"\n              />\n              <path\n                class=\"st0\"\n                d=\"M61.3,356.7c0-51.6,0-103.2,0-154.8c0-14.9,6.8-21.7,21.7-21.7c23.1,0,46.2,0,69.4,0\n\t\t\t\t\tc13.5,0,20.6,6.9,20.6,20.5c0,104.3,0,208.7,0,313c0,13.3-7,20.3-20.2,20.3c-23.7,0.1-47.4,0.1-71,0c-13.4,0-20.4-7.2-20.4-20.7\n\t\t\t\t\tC61.3,461,61.3,408.8,61.3,356.7z\"\n              />\n              <path\n                class=\"st0\"\n                d=\"M45.3,78.1c0-39.8,32-71.9,71.8-72.1c39.5-0.2,72.1,32.2,72.4,71.8c0.3,39.6-32.5,72.4-72.3,72.3\n\t\t\t\t\tC77.2,150,45.3,118,45.3,78.1z\"\n              />\n            </g>\n          </svg>\n          Source</a\n        >\n      </li>\n      <li\n        style=\"border: 0.4px inset;width:1px;height: 20px; margin-top: 20px;\"\n      ></li>\n      <li\n        data-testid=\"matching-lawyer-help-icon\"\n        style=\"margin-left:5px\"\n        ng-click=\"ctrl.openHelpDescriptionModal()\"\n      >\n        <span class=\"badge badge-grey\" style=\"margin-top:7px\">\n          <svg\n            xmlns=\"http://www.w3.org/2000/svg\"\n            width=\"24\"\n            height=\"24\"\n            viewBox=\"0 0 24 24\"\n          >\n            <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n            <path\n              class=\"st0\"\n              fill=\"#9D9D9D\"\n              d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z\"\n            />\n          </svg>\n        </span>\n      </li>\n    </ul>\n    <div class=\"rightside-matching-lawyer\">\n      <img\n        src=\"{{ctrl.employerLogo}}\"\n        style=\"width: 35px;height: 35px; border-radius:50%;margin:0px 5px 5px 0;\"\n        alt=\"pic\"\n      />\n      <h4 class=\"inline\"><b>{{ctrl.selectedPosition.employer.name}}</b></h4>\n      -\n      <h4\n        style=\"color:#4c9bda\"\n        class=\"inline setting-text\"\n        ng-click=\"ctrl.openPositionDetailModal()\"\n      >\n        <!-- ng-click=\"jobProfileModal()\" -->\n        <b>{{ctrl.selectedPosition.title}}</b>\n      </h4>\n      <h4 class=\"inline\">\n        <b\n          >({{ctrl.selectedPosition.employer.id}}-{{ctrl.selectedPosition.id}})</b\n        >\n      </h4>\n      <span\n        ng-style=\"ctrl.positionStatusColor(ctrl.selectedPosition)\"\n        class=\"recommendation-status-icon\"\n      >\n      </span>\n    </div>\n  </div>\n  <iframe\n    ng-if=\"ctrl.initializeListing.recommendation\"\n    ng-show=\"ctrl.toggle.recommendationListing\"\n    ng-src=\"{{ctrl.source.matchesSource}}\"\n    style=\"height: 100%; width: 100%;border-width: 0;\"\n  ></iframe>\n  <iframe\n    ng-if=\"ctrl.initializeListing.application\"\n    ng-show=\"ctrl.toggle.applicationListing\"\n    ng-src=\"{{ctrl.source.applicationsSource}}\"\n    style=\"height: 100%; width: 100%;border-width: 0;\"\n  ></iframe>\n\n  <div ng-if=\"ctrl.toggle.description\">\n    <div class=\"description-matches\">\n      <div\n        data-testid=\"matches-header-description\"\n        class=\"padding-b20 padding-t20 list-item-inhouse clearfix\"\n      >\n        <div class=\"col-md-8 col-sm-12 col-xs-12 list-col-firm\">\n          <div class=\"row\">\n            <div class=\"col-xs-4 list-firm-logo\">\n              <img\n                class=\"\"\n                alt=\"{{ctrl.recommendationPositionDescription.employer.name}}\"\n                ng-src=\"{{ctrl.employerLogo}}\"\n              />\n            </div>\n            <div class=\"col-xs-8 list-job-title\">\n              <h2 class=\"margin-t0 margin-b0 text-thin\">\n                {{ctrl.recommendationPositionDescription.employer.name}}\n                <i\n                  data-testid=\"edit-position\"\n                  class=\"fa fa-pencil pointer\"\n                  style=\"color: #9D9D9D;\"\n                  ng-click=\"ctrl.editPositionModal(ctrl.recommendationPositionDescription.id)\"\n                  ng-right-click=\"ctrl.openEditPositionPage(ctrl.recommendationPositionDescription.id)\"\n                  style=\"color:#4c9bda\"\n                ></i>\n              </h2>\n              <h3\n                class=\"padding-b10\"\n                id=\"{{ctrl.recommendationPositionDescription.id}}\"\n              >\n                {{ctrl.recommendationPositionDescription.title}}\n              </h3>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"col-md-3 col-sm-10 col-xs-12 col-inhouse-pqe\">\n          <h5>\n            PQE: {{ctrl.recommendationPositionDescription.minPQE <= 0\n            ?\"NQ\":ctrl.recommendationPositionDescription.minPQE}}{{ctrl.recommendationPositionDescription.maxPQE\n            == 11?\"+\":(ctrl.recommendationPositionDescription.maxPQE <= 0 ||\n            ctrl.recommendationPositionDescription.maxPQE ==\n            ctrl.recommendationPositionDescription.minPQE)?\"\":\"-\"+ctrl.recommendationPositionDescription.maxPQE}}\n          </h5>\n          <h5>\n            Contract: {{ctrl.recommendationPositionDescription.contractType}}\n          </h5>\n          <h5>\n            Occupation: {{ctrl.recommendationPositionDescription.occupation}}\n          </h5>\n          <div class=\"location-cloud\">\n            <div class=\"content\">\n              <h5\n                ng-repeat=\"location in ctrl.recommendationPositionDescription.locations\"\n                class=\"label label-info text-uppercase\"\n                ng-style=\"setLocationColor(location.color)\"\n              >\n                <!-- ng-if=\"location.parent\" -->\n                {{location.name}}\n              </h5>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div\n        data-testid=\"matches-detail-description\"\n        class=\"row inner-list\"\n        ng-class=\"{customjob: job.is_custom, connectedjob: job.is_connected, speculativejob: job.isSpeculative}\"\n        style=\"margin: 0 0 10px\"\n      >\n        <div class=\"col-md-3 col-xs-3\">\n          <div>\n            <h4>\n              <strong>{{ctrl.recommendationPositionDescription.title}}</strong>\n            </h4>\n          </div>\n          <h5>\n            Position ID:\n            {{ctrl.recommendationPositionDescription.employer.id}}-{{ctrl.recommendationPositionDescription.id}}\n          </h5>\n          <h5>\n            Required PQE: {{ctrl.recommendationPositionDescription.minPQE <= 0\n            ?\"NQ\":ctrl.recommendationPositionDescription.minPQE}}{{ctrl.recommendationPositionDescription.maxPQE\n            == 11?\"+\":(ctrl.recommendationPositionDescription.maxPQE <= 0 ||\n            ctrl.recommendationPositionDescription.maxPQE ==\n            ctrl.recommendationPositionDescription.minPQE)?\"\":\"-\"+ctrl.recommendationPositionDescription.maxPQE}}\n          </h5>\n          <h5 ng-if=\"ctrl.recommendationPositionDescription\">\n            Listing Type: {{ctrl.recommendationPositionDescription.type}}\n          </h5>\n          <h5 ng-show=\"ctrl.recommendationPositionDescription.visible\">\n            Job Visibility: Visible\n          </h5>\n          <h5\n            ng-show=\"!ctrl.recommendationPositionDescription.visible\"\n            class=\"red-color\"\n          >\n            Job Visibility: Invisible\n          </h5>\n\n          <h5>\n            Uploaded:\n            {{ctrl.recommendationPositionDescription.created|date:\"dd-MM-yyyy\"}}\n          </h5>\n          <h5>Status: {{ctrl.recommendationPositionDescription.status}}</h5>\n          <h5 ng-if=\"ctrl.recommendationPositionDescription.externalUrl\">\n            Source/External Link:\n            <a\n              style=\"color:#4c9bda;word-break: break-all;\"\n              target=\"_blank\"\n              href=\"{{ctrl.recommendationPositionDescription.externalUrl}} \"\n            >\n              {{ctrl.recommendationPositionDescription.externalUrl}}</a\n            >\n          </h5>\n          <h5>\n            Employer Selectivity:\n            {{ctrl.recommendationPositionDescription.employer.selectivity}}\n          </h5>\n          <span class=\"h5\"\n            >Expiry Date:\n            {{ctrl.recommendationPositionDescription.expiresAt|date:\"dd/MM/yyyy\"}}\n          </span>\n        </div>\n\n        <div class=\"col-md-9 col-xs-9\">\n          <div class=\"\" style=\"padding-top: 9px;\">\n            <p\n              data-testid=\"detail-description\"\n              ng-bind-html=\"ctrl.recommendationPositionDescription.description\"\n              class=\"padding-jobdescription80 ng-binding\"\n              align=\"justify\"\n            ></p>\n            <div class=\"content\">\n              <ul id=\"taglist\" class=\"list-inline list-practice-area margin-b0\">\n                <li\n                  class=\"tags-box\"\n                  ng-if=\"specialty.parentId\"\n                  ng-repeat=\"specialty in ctrl.recommendationPositionDescription.specialties\"\n                >\n                  <!-- ng-if=\"!area.hasChild\" -->\n                  {{specialty.name}}\n                </li>\n              </ul>\n            </div>\n            <hr class=\"job-practice-sep\" />\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <script type=\"text/ng-template\" id=\"create-update-position-modal.html\">\n    <create-Update-Position-Modal></create-Update-Position-Modal>\n  </script>\n\n  <date-Modal></date-Modal>\n  <position-Details></position-Details>\n  <recommendation-help-description-modal></recommendation-help-description-modal>\n</div>\n"

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"page-signin\"\n  ng-cloak\n  data-ng-controller=\"ReferralListingController as ctrl\"\n>\n  <div lexstep-header></div>\n  <ag-Grid-Listing\n    ng-if=\"ctrl.gridOptions\"\n    grid-name=\"ctrl.gridName\"\n    grid-options=\"ctrl.gridOptions\"\n    help-tooltip=\"ctrl.helpTooltip\"\n    filter-count=\"ctrl.filterCount\"\n    group-list=\"ctrl.groupList\"\n  />\n</div>\n\n<script type=\"text/ng-template\" id=\"referral-link-modal.html\">\n     <div class=\"modal-header\" >\n       <center>\n     \t<h3>Referral Link</h3>\n       </center>\n     </div>\n     <div class=\"modal-body\"\n  >\n       <center>\n     \t\t<h5><a data-testid=\"referral-link-copy\" clipboard text=\"ctrl.referralCodeToShow\" on-copied=\"ctrl.copySuccess()\" on-error=\"ctrl.copyFail(err)\" class=\"pointer\">{{ctrl.referralCodeToShow}}</a></h5>\n       </center>\n     </div>\n</script>\n"

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

	module.exports = "\n<div class=\"page-signin\" ng-cloak data-ng-controller= \"AdminProfileController as profile\">\n    <style>\n      #content{\n        top: 0;\n        left: 0;\n      }\n    </style>\n        <!-- widgets -->\n    \n      <div lexstep-header></div>\n        <!-- Header Ends -->\n    \n        <div data-ng-controller=\"IsOldBrowserController as isOldBrowser\"  class=\"container\">\n          <div class=\"old-browser-alert\" ng-show=\"isOldBrowser.showOldBrowser\" >\n            <div class=\"callout bg-warning margin-t0\"  type=\"info\">You are using an older version of the browser that may not support LexStep features. Please <a target=\"_blank\" class=\"text-info\" href=\"http://windows.microsoft.com/en-us/internet-explorer/download-ie\">upgrade</a> for improved experience.\n            </div>\n          </div>\n        </div>\n      \n\n        <fieldset ng-disabled =\"profile.spinnerActive\">\n          <div class=\"container\" ng-click=\"hideDropDown()\">\n            <section class=\"page page-approved-profile ng-scope\">      \n    \n              <div class=\"panel panel-default section-about margin-b0\">\n                <div class=\"panel-body row\">\n                  <div class=\"clearfix margin-t31\"></div>\n    \n                  <div class=\"col-md-3 col-sm-4 col-xs-12\" >\n                    <div class=\"pull-left profile-image text-center\">\n                      <span class=\"spinner-profilepic\" us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\" spinner-key=\"spinner-dp\"></span>\n    \n                      <img id=\"profilePic\"\n                      ng-file-drop\n                      ng-file-select=\"profile.uploadProfilePicture($files);\"\n                      ng-model=\"profile.user.profilePicture\" class=\"drop-box\"\n                      drag-over-class=\"dragover\"\n                      ng-multiple=\"false\" allow-dir=\"true\"\n                      accept=\".jpg,.jpeg,.png\"\n                      style=\"padding-top:0px; height:inherit;\"\n                      ng-src='{{profile.user.logoSrc }}'\n                      tooltip-placement=\"bottom\" tooltip=\"Format: jpg/jpeg Resolution: 200x200px File Size limit is 8MB\" />\n    \n                      <div ng-no-file-drop>File Drag/Drop is not supported for this browser</div>\n                      <i class=\"fa fa-user fa-5x\"></i>\n    \n                      <button id=\"uploadPicBtn\" type=\"file\" ng-file-select=\"profile.uploadProfilePicture($files)\" class=\" btn btn-info btn-w-lg\" ng-multiple=\"false\" allow-dir=\"true\" accept=\".jpg,.jpeg,.png\"><i class=\"fa fa-camera\"></i> {{'btn.upload.label'|translate}}</button>\n                      <button id=\"removePicBtn\" class=\"btn btn-danger btn-xs\" ng-show=\"profile.user.profilePicture\" ng-click=\"profile.deleteProfilePic()\"><i class=\"fa fa-times\"></i></button>\n                    </div>\n                  </div>\n    \n                  <div ng-show=\"!profile.showEditForm\" class=\"col-md-9 col-sm-8 col-xs-12\">\n                    <div class=\"row margin-t5\">\n                      <h1 \n                      class=\"col-md-9 margin-r15 pull-left username\">\n                        <span class=\"\"> {{profile.user.firstName }} {{profile.user.lastName }} </span>\n                      </h1>\n                    </div>\n                    <div class=\"row margin-t15 medium-font\">\n                      <span class=\"col-md-9 pull-left username\">\n                        <span class=\" margin-r15\">\n                          <i class=\"glyphicon glyphicon-envelope\"></i>\n                        </span>\n                        <span>\n                          <a href=\"mailto:{{profile.user.email}}\" class=\"text-info \">{{ profile.user.email }}</a>\n                        </span>\n                      </span>\n                    </div>\n                    <div class=\"row margin-t15 medium-font\">\n                      <div class=\"col-md-9 pull-left username\"\n                      ng-disabled=\"profile.user.phone== null\"\n                      >\n                        <span class=\"margin-r15\">\n                          <i class=\"fa fa-phone\"></i>\n                        </span>\n                        <span>\n                          {{profile.user.phone}}\n                        </span>\n                      </div>\n    \n                      <div class=\"col-md-3\">\n                          <a href=\"\" id=\"\" ng-click=\"profile.toggleEditDetailsForm()\" class=\"btn btn-success\"> Edit Profile </a>\n                      </div>\n                    </div>\n                  </div>\n    \n                  <div ng-show=\"profile.showEditForm\" class=\"col-md-9 col-sm-8 col-xs-12\">\n                    <div class=\"row margin-t20\">\n                      <span class=\"col-md-3\">\n                        <input type=\"text\" class=\"form-control\" placeholder=\"First Name\" value=\"Alex\" ng-model=\"profile.adminUser.firstName\" required/>\n                      </span>\n                      <span class=\"col-md-3\">\n                        <input type=\"text\" class=\"form-control\" placeholder=\"Last Name\" value=\"Isaacs\" ng-model=\"profile.adminUser.lastName\" required/>\n                      </span>\n                    </div>\n                    <div class=\"row margin-t15\">\n                      <span class=\"col-md-6 pull-left username\">\n                       <div class=\"input-group\">\n                          <span class=\"input-group-addon\" id=\"basic-envelope-addon\"><i class=\"glyphicon glyphicon-envelope\"></i></span>\n                          <input type=\"email\" class=\"form-control\" placeholder=\"Email\" ng-model=\"profile.adminUser.email\" aria-describedby=\"basic-envelope-addon\" required>\n                        </div>\n                      </span>\n                    </div>\n                    <div class=\"row margin-t15\">\n                      <div class=\"col-md-6 pull-left username\">\n                          <div class=\"input-group\">\n                            <span class=\"input-group-addon\" id=\"basic-phone-addon\"><i class=\"fa fa-phone\"></i></span>\n                            <input type=\"text\" class=\"form-control\" placeholder=\"Phone Number\" ng-model=\"profile.adminUser.phone\" aria-describedby=\"basic-phone-addon\" required>\n                          </div>\n                        </span>\n                      </div>\n    \n                      <div class=\"col-md-offset-3 col-md-3\">\n                          <a href=\"\" ng-click=\"profile.updateInfo()\" class=\"btn btn-success\"> Save  </a>\n                          <a href=\"\" ng-click=\"profile.toggleEditDetailsForm($event)\" class=\"btn btn-default\"> Cancel  </a>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n    \n                <div class=\"panel-body row\">\n                  <div class=\"col-md-12\">\n                    <hr>\n    \n                    <div class=\"\">\n                        <div class=\"email-body-wrapper\">\n                          <textarea name=\"emailBody\" ng-change=\"emailBodyChanged=true\" class=\"form-control\" ckeditor=\"editorOptions\" ng-model=\"profile.adminUser.signature\" required></textarea>\n                        </div>\n                      </div>\n    \n                  </div>\n                </div>\n    \n                <div class=\"panel-body row\">\n                    <div class=\"col-md-offset-10 col-md-2 margin-b30\">\n                        <a href=\"\" ng-click=\"profile.updateSignature()\" class=\"btn btn-success\"> Save  </a>\n                        <a href=\"\" ng-click=\"profile.resetSignature()\" class=\"btn btn-default\"> Cancel  </a>\n                    </div>\n                </div>\n              </div>\n              <!-- About Section End -->\n    \n              </div>\n            </section>\n          </div>\n        <!-- Body Ends -->\n        </fieldset>\n    \n        <!-- Footer -->\n        <footer class=\"footer\">\n            <div class=\"container\">\n                <div ng-include src=\"'views/pages/admin-footer.html'\"></div>\n            </div>\n            <!-- / .container -->\n        </footer>\n    \n      </div>"

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"page-signin\"\n  ng-cloak\n  ng-init=\"showAlert = true ; showProfileAlert = true;\"\n>\n  <!-- data-ng-controller=\"ApprovedProfileCtrl as profile\" -->\n  <!-- widgets -->\n  <div lexstep-header></div>\n  <!-- Header Ends -->\n  <div class=\"container margin-t20\">\n    <candidate-profile profile-user=\"false\" />\n  </div>\n</div>\n"

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

	module.exports = "\n<div class=\"page-signin\" ng-cloak data-ng-controller=\"CandidateApplicationController as ctrl\">\n    <div lexstep-header></div>\n  <!-- Header Ends -->\n  <!-- old browser top alert -->\n  <div data-ng-controller=\"IsOldBrowserController as isOldBrowser\" class=\"container\">\n    <div class=\"old-browser-alert\" ng-show=\"isOldBrowser.showOldBrowser\" >\n      <div class=\"callout bg-warning margin-t0\"  type=\"info\">You are using an older version of the browser that may not support LexStep features. Please <a target=\"_blank\" class=\"text-info\" href=\"http://windows.microsoft.com/en-us/internet-explorer/download-ie\">upgrade</a> for improved experience.\n      </div>\n    </div>\n  </div>\n\n  <div class=\"container\" ng-click=\"hideDropDown()\">\n    <div  class=\"panel-body heading-jobs-listings row\">\n      <center>\n        <h1 class=\"text-thin hdng-tshadow margin-b0\">{{'navBar.connections.label'| translate}}</h1>\n        <h4 class=\"hdng-tshadow\">Track the status of the opportunities you’ve shown interest in</h4>\n        <h4 class=\"text-thin hdng-tshadow TrackMessagePadding\">If there is interest from an employer you should expect to hear back from the team there within 4 weeks (but normally much sooner).</h4>      \n      </center>\n    </div>\n\n    <div class=\"panel panel-default \">\n      <div class=\"panel-body row hidden\">\n        <alert class=\"alert-position\" type=\"success\" ng-show=\"ctrl.showSuccessMsg\"><strong>{{ctrl.alertMsg}}</strong></alert></center>\n        <alert class=\"alert-position\" type=\"error\" ng-show=\"ctrl.showErrorMsg\"><strong>{{ctrl.alertMsg}}</strong></alert>\n      </div>\n\n      <div class=\"panel-body row\" ng-class=\"{ 'bg-white': ctrl.showNoJobs, 'bg-grey': !ctrl.showNoJobs }\">\n        <section class=\"page page-table table-dynamic custom-table-body\">\n            <div class=\" row bg-white\">\n              <div class=\"col-sm-12\" ng-show=\"ctrl.showInfo\">\n                <div class=\"callout callout-danger\">\n                  Email <b>(<a class=\"callout-danger\" href=\"mailto:{{ctrl.contact.email}}\">{{ctrl.contact.email}}</a>) or call  <a class=\"callout-danger\" href=\"tel:{{ctrl.contact.phone}}\">{{ctrl.contact.phone}}</a></b> if you have any questions relating to the below applications.\n                </div>\n              </div>\n            </div>\n            <!-- Alert Box End-->\n\n            <div class=\"text-center col-sm-12\" ng-show=\"ctrl.showNoJobs\">\n              <h2>{{ctrl.mainAlert|translate}}</h2>\n              <br>\n              <center>\n                <a class=\"btn btn-success\"href=\"/matches\">Explore Opportunities</a>\n              </center>\n            </div>\n            <span\n              class=\"spinner-browse\"\n              id=\"spinner\"\n              us-spinner = \"{radius:20, width:3, length: 12, color: 'black'}\"\n              spinner-key=\"spinner-2\">\n            </span>\n\n            <!-- Lawyer Job listing -->\n            <div class=\"row\" data-ng-repeat= \"(key, positionGroup) in ctrl.candidatePositions.candidate.positions | groupBy: 'liveStatus'\">\n              <br>\n              <div class=\"margin-b20 job-group-title\" ng-if=\"key == 'Processed Jobs'\">\n                <span class=\"margin-0 job-groups\">{{key}} ({{positionGroup.length}})</span>\n                <!-- <span class=\"badge badge-job-counter\"></span> -->\n              </div>\n              <div data-testid=\"job-detail-{{position.positionId}}\"  class=\"list-item list-item-applied-jobs clearfix\" data-ng-repeat-start=\"position in positionGroup  | orderBy:'-applicationCreatedDate'\" ng-click=\"ctrl.showJobDetail(position, $event)\">\n                <div class=\"col-md-5 col-sm-12 list-col-firm\">\n                  <div class=\"pull-left list-firm-logo\">\n                    <img class=\"\" alt=\"{{job.employerName}}\" ng-src=\"{{position.employerLogoSrc}}\" />\n\n                  </div>\n                  <div class=\"media-body\">\n                    <table border=\"0\" cellspacing=\"0\" cellpadding=\"0\" width=\"100%\">\n                      <tr>\n                        <td class=\"list-job-title\"><h2 class=\"margin-t0 margin-b0 text-thin\">{{position.employerName}}</h2></td>\n                      </tr>\n                    </table>\n                  </div>\n                </div>\n\n                <div class=\"col-md-4 col-sm-6\">\n                  <table border=\"0\" cellspacing=\"0\" cellpadding=\"0\" width=\"100%\">\n                    <tr>\n                      <td class=\"list-job-title\">\n                        <h4 class=\"margin-t0 margin-b0\">{{position.positionTitle}}</h4>\n                        <h5>PQE: {{position.lawPreferences.minPqe <= 0 ?\"NQ\":position.lawPreferences.minPqe}}{{position.lawPreferences.maxPqe == 11?\"+\":(position.lawPreferences.maxPqe <= 0 || position.lawPreferences.maxPqe == position.lawPreferences.minPqe)?\"\":\"-\"+position.lawPreferences.maxPqe }}</h5>\n                        <div class=\"location-cloud\">\n                          <h5 ng-repeat=\"location in position.locations\" class=\"label label-info text-uppercase location-{{(location.countryCode === 'GB' || location.name.toLowerCase() === 'london') ? 'london' : location.color}}\" \">{{location.name}}</h5>\n                        </div>\n                      </td>\n                    </tr>\n                  </table>\n                </div>\n\n                <div class=\"col-md-3 col-sm-6\">\n                  <span class=\"margin-b5 text-muted\">ID: &nbsp;</span>\n                  <span class=\"margin-b0\">{{position.employerId}}_{{position.positionId}}</span>\n                  <br>\n                  <span class=\"margin-b5 text-muted\">INDICATED INTEREST ON: &nbsp;</span><br>\n                  <span class=\"margin-b0\">{{position.applicationCreatedDate|date:\"dd-MMMM-yyyy\"}}</span>\n                  <br>\n                  <!-- <span class=\"margin-b5 text-muted\">STATUS: &nbsp;</span>\n                  <span class=\"margin-b0\">{{job.status}}</span> -->\n                </div>\n\n                <div class=\"col-md-2 hidden\">\n                  <table border=\"0\" cellspacing=\"0\" cellpadding=\"0\" width=\"100%\">\n                    <tr>\n                      <td class=\"list-job-title \">\n                        <h4 class=\"text-warning margin-t0 margin-b0\">{{position.applicationStatus}}</h4>\n                      </td>\n                    </tr>\n                  </table>\n                </div>\n                \n              </div>\n              <!-- Job Detail -->\n              <div ng-if=\"position.expanded\" data-ng-repeat-end=\"\">\n                 <div colspan=\"9\" class=\"padding-t0\">\n                  <div class=\"row inner-list\" ng-class=\"{connectedjob:  (position.positionType==='Connect'), speculativejob: (position.positionType==='Speculative')}\" style=\"margin: 0 0 10px\" >\n\n                      <div id=\"{{position.positionId}}\" class=\"col-md-12 col-xs-12\" >\n                        <div class=\"\" style=\"padding-top: 9px;\">\n                          <div class=\"job-description-text\" ng-class=\"{expanded: position.isExpanded}\">\n                            <p data-testid=\"job-description\" ng-bind-html=\"position.positionDescription\" class=\"\" align=\"justify\"></p>\n                          </div>\n                          <!-- {{job.isExpanded}} - {{job.job_description.length > 100}} -->\n                          <a href=\"\" class=\"text-info\" ng-show=\"!position.isExpanded && position.positionDescription.length > 600\" ng-click=\"position.isExpanded = !position.isExpanded; $event.stopPropagation()\">more</a>\n                          <a href=\"\" class=\"text-info\" ng-show=\"position.isExpanded && position.positionDescription.length > 600\" ng-click=\"position.isExpanded = !position.isExpanded; $event.stopPropagation()\">less</a>\n                          <hr class=\"job-practice-sep\">\n                        </div>\n                       \n                      </div>\n                    </div>\n                 </div>\n              </div>\n            <!-- Job detail end -->\n                    <footer class=\"table-footer table-dynamic\" style=\"margin-top: 10px;\">\n          <div class=\"row\">\n            <div class=\"page-num-info col-md-6\">\n              <span>\n                Show\n                <span class=\"ui-select select-enty-count\">\n                  <select\n                    data-ng-model=\"ctrl.paginationOptions.selectedLimit\"\n                    data-ng-options=\"num for num in ctrl.paginationOptions.limitOptions\"\n                    data-ng-change=\"ctrl.applicationsPageChange()\"\n                  >\n                  </select>\n                </span>\n                entries per page\n              </span>\n            </div>\n            <div\n              class=\"text-right pagination-container custom-pagination col-md-6\"\n            >\n              <pagination\n                class=\"pagination-sm\"\n                ng-model=\"ctrl.pagination.currentPage\"\n                total-items=\"ctrl.pagination.totalItems\"\n                max-size=\"4\"\n                ng-change=\"ctrl.applicationsPageChange()\"\n                items-per-page=\"ctrl.paginationOptions.selectedLimit\"\n                rotate=\"false\"\n                boundary-links=\"true\"\n              >\n              </pagination>\n            </div>\n          </div>\n        </footer>\n            </div>\n            <!-- Lawyer Job listing End -->\n        </section>\n      </div>\n    </div>\n  </div>\n  <!-- Body Ends -->\n\n  <!-- Footer -->\n  <div lexstep-footer></div>\n  <!-- Footer Ends-->\n</footer>\n</div>"

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

	module.exports = ""

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"page-reset-password\"\n  data-ng-controller=\"ChangePasswordController as ctrl\"\n>\n  <div lexstep-header></div>\n  <div\n    data-ng-controller=\"IsOldBrowserController as isOldBrowser\"\n    class=\"container\"\n  >\n    <div class=\"old-browser-alert\" ng-show=\"isOldBrowser.showOldBrowser\">\n      <div class=\"callout bg-warning margin-t0\" type=\"info\">\n        You are using an older version of the browser that may not support\n        LexStep features. Please\n        <a\n          target=\"_blank\"\n          class=\"text-info\"\n          href=\"http://windows.microsoft.com/en-us/internet-explorer/download-ie\"\n          >upgrade</a\n        >\n        for improved experience.\n      </div>\n    </div>\n  </div>\n  <div class=\"main-body\" ng-click=\"ctrl.hideDropDown()\">\n    <div class=\"container\">\n      <div class=\"info text-center\">\n        <h2>Would you like to change your password?</h2>\n        <p class=\"text-small\">\n          Click the button below to send an email to\n          <strong>\"{{user.email}}”</strong> containing a link that you can use\n          to change your password.\n        </p>\n      </div>\n\n      <div class=\"form-container\">\n        <form\n          class=\"form-horizontal\"\n          name=\"changePassword\"\n          ng-submit=\"ctrl.changePassword()\"\n        >\n          <span\n            us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n            spinner-key=\"spinner-change-password\"\n          ></span>\n          <div class=\"form-group\">\n            <input\n              data-testid=\"button-change-password\"\n              type=\"submit\"\n              value=\"Change My Password\"\n              class=\"btn btn-info btn-block btn-lg\"\n              ng-disabled=\"ctrl.sentEmail\"\n            />\n          </div>\n        </form>\n      </div>\n      <div class=\"row\" ng-if=\"ctrl.sentEmail\">\n        <center>\n          Didn’t receive an email? Click\n          <a href=\"\" class=\"purple-color\" ng-click=\"ctrl.changePassword()\"\n            >here\n          </a>\n          to try again.\n        </center>\n      </div>\n    </div>\n\n    <!-- Footer -->\n    <div lexstep-footer></div>\n  </div>\n</div>\n"

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-reset-password\" data-ng-controller=\"ResetPassCtrl as resetPass\">\n    <div lexstep-header></div>\n  <!-- Header Ends -->\n\n  <div class=\"main-body\" ng-click=\"hideDropDown()\">\n    <div class=\"container\">\n      <div class=\"info text-center\">\n          <h2>Reset Your Password</h2>\n          <p class=\"text-small\">Please enter your new password. After updating your password you will be able to access your account with this password.</p>\n          <form  class=\"form-horizontal\" name=\"resetPasswordForm\" ng-submit=\"resetPasswordForm.$valid&&resetPass.updatePassword()\">\n              <div class=\"form-group\">\n                  <div class=\"input-group input-group-lg\">\n                      <span class=\"input-group-addon\">\n                          <span class=\"glyphicon glyphicon-lock\"></span>\n                      </span>\n                      <input type=\"password\"\n                             class=\"form-control\"\n                             placeholder=\"New Password\"\n                             ng-model=\"resetPass.password.newPassword\"\n                             ng-minlength='6'\n                             required>\n                  </div>\n              </div>\n\n              <div class=\"form-group\">\n                  <div class=\"input-group input-group-lg\">\n                      <span class=\"input-group-addon\">\n                          <span class=\"glyphicon glyphicon-lock\"></span>\n                      </span>\n                      <input type=\"password\"\n                             class=\"form-control\"\n                             ng-model=\"resetPass.password.confirmNewPassword\"\n                             placeholder=\"Confirm New Password\"\n                             ng-minlength='6'\n                             required\n                             >\n                  </div>\n              </div>\n              <div class=\"form-group\">\n                <input type=\"submit\" value=\"Change My Password\" class=\"btn btn-info btn-block btn-lg\">\n              </div>\n          </form>\n      </div>\n    </div>\n  </div>\n   <!-- Footer -->\n   <div lexstep-footer></div>\n</div>"

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-signin\" data-ng-controller=\"EditEmailCtrl as editEmail\" ng-init=\"fetchEmailCategory()\">\n\n  <div lexstep-header></div>\n<!-- Header Ends -->\n\n  <div class=\"container\" ng-click=\"hideDropDown()\">\n\n      <div class=\"panel-body heading-jobs-listings row\">\n          <center >\n              <h1 ng-hide=\"inHouseJob\" class=\"text-thin hdng-tshadow\">Edit Email</h1>\n          </center>\n      </div>\n\n          <!-- nav bar row-->\n      <div class=\"row\" style=\"padding: 0 15px;\">\n          <alert type=\"danger\"  class=\"col-md-12\" ng-show=\"showOnError\"><center><strong>{{alertMsg}} </strong></center></alert>\n          <alert type=\"success\" class=\"col-md-12\" ng-show=\"showOnSuccess\"><center><strong>{{alertMsg}} </strong></center></alert>\n      </div>\n\n\n      <div class=\"panel panel-default\">\n          <div class=\"panel-body\">\n              <br />\n              <form name=\"editEmailForm\" class=\"form-horizontal firm-creation\">\n                  <br>\n\n                  <!-- Email Scenario -->\n                  <div class=\"row\">\n                      <div class=\"h5 col-md-4 text-right\">Email Scenario</div>\n                      <div class=\"col-md-5\">\n                          <input type=\"text\"\n                          autocomplete=\"off\"\n                          placeholder=\"Enter email scenario\"\n                          readonly=\"true\"\n                          class=\"form-control custom-readonly\"\n                          ng-model=\"emailCategory.email_scenario\">\n                      </div>\n                  </div>\n                  <br>\n\n                  <!-- Subject -->\n                  <div class=\"row\">\n                      <div class=\"h5 col-md-4 text-right\">Subject</div>\n                      <div class=\"col-md-5\">\n                          <input data-testid=\"subject\" type=\"text\"\n                          autocomplete=\"off\"\n                          placeholder=\"Subject\"\n                          class=\"form-control\"\n                          ng-model=\"emailCategory.subject\"\n                          required>\n                          <div class=\"space\"></div>\n                      </div>\n                  </div>\n\n                  <!-- From -->\n                  <div class=\"row\">\n                    <div class=\"h5 col-md-4 text-right\" >From</div>\n                    <div class=\"col-md-5\">\n                      <input data-testid=\"sender-email\" type=\"email\"\n                      autocomplete=\"off\"\n                      placeholder=\"Sender email\"\n                      class=\"form-control\"\n                      ng-model=\"emailCategory.from\"\n                      required\n                      >\n                      <div class=\"space\"></div>\n                    </div>\n                  </div>\n\n                  <!-- From Name-->\n                  <div class=\"row\" ng-hide=\"inHouseJob\">\n                    <div class=\"h5 col-md-4 text-right\">From Name</div>\n                    <div class=\"col-md-5\">\n                        <input data-testid=\"from-name\" type=\"text\"\n                        autocomplete=\"off\"\n                        placeholder=\"Enter From Name\"\n                        class=\"form-control\"\n                        ng-model=\"emailCategory.fromName\"\n                        >\n                    </div>\n                  </div>\n\n                  <br>\n\n                  <!-- To -->\n                  <div class=\"row\">\n                    <div class=\"h5 col-md-4 text-right\" >To</div>\n                    <div class=\"col-md-5\">\n                      <input type=\"text\"\n                      autocomplete=\"off\"\n                      readonly=\"true\"\n                      placeholder=\"Recepient\"\n                      class=\"form-control\"\n                      ng-model=\"emailCategory.to\"\n                      >\n                      <div class=\"space\"></div>\n                    </div>\n                  </div>\n\n                  <!-- CC -->\n                  <div class=\"row\">\n                    <div class=\"h5 col-md-4 text-right\">CC</div>\n                    <div class=\"col-md-5\">\n                        <input data-testid=\"CC\" type=\"text\"\n                        autocomplete=\"off\"\n                        class=\"form-control\"\n                        placeholder=\"Enter comma seperated CC recepients\"\n                        ng-model=\"emailCategory.cc\"\n                        >\n                    </div>\n                  </div>\n\n                  <br>\n\n                  <!-- BCC -->\n                  <div class=\"row\">\n                    <div class=\"h5 col-md-4 text-right\">BCC</div>\n                    <div class=\"col-md-5\">\n                        <input data-testid=\"BCC\" type=\"text\"\n                        autocomplete=\"off\"\n                        class=\"form-control\"\n                        placeholder=\"Enter comma seperated BCC recepients\"\n                        ng-model=\"emailCategory.bcc\"\n                        >\n                    </div>\n                  </div>\n\n                  <br>\n\n                  <div class=\"row\"><div class=\"col-md-4 text-right\">Email Body</div></div>\n\n                  <!-- email body -->\n                  <div class=\"row\">\n                    <!-- <div class=\"h5 col-md-4 text-right\">Email body</div> -->\n                    <div data-testid= \"email-body\" class=\"email-body-wrapper\">\n                      <textarea  name=\"emailBody\" ng-change=\"emailBodyChanged=true\" class=\"form-control\" ckeditor=\"editorOptions\" ng-model=\"emailCategory.content\" required></textarea>\n                        <!-- <textarea ng-model=\"emailCategory.content\" name=\"\" id=\"\" class=\"form-control\" style = \"resize:none\"></textarea> -->\n\n                      <p class=\"email-body-error-message\" ng-show=\"placeholdersModified\">Placeholders cannot be changed from Email body and Subject line</p>\n                    </div>\n                  </div>\n\n\n\n                  <br>\n                  <!-- submit button -->\n                  <div style=\"padding-right: 15px; padding-left: 15px;\"class=\"row\">\n                    <span us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\" spinner-key=\"spinner-1\"></span>\n                    <div class=\"col-md-6 text-left\">\n                      <button class=\"btn btn-success\"\n                          ng-click=\"openTestEmailPopUp()\">Send Test Email</button>\n                  </div>\n                    <div class=\"col-md-6 text-right\">\n                        <button type=\"submit\" ng-style=\"emailBodyChanged && {'background-color': '#95288F', 'border-color': '#95288F'}\" ng-show=\"true\" class=\"btn btn-success\" ng-disabled=\"emailBodyChanged\"\n                        ng-click=\"editEmailForm.$valid && saveEmailCategory()\">Save Changes</button>\n                        <a class=\"btn btn-default \" ng-click=\"navigateToEmailListing()\">Cancel</a>\n                    </div>\n\n                  </div>\n              </form>\n          </div>\n      </div>\n\n\n  </div>\n\n<!-- Footer -->\n<footer class=\"footer\">\n  <div class=\"container\">\n    <div ng-include src = \"'views/pages/admin-footer.html'\"></div>\n  </div>\n  <!-- / .container -->\n</footer>\n\n\n\n<script type=\"text/ng-template\" id=\"sendTestEmail.html\">\n<div class=\"modal-header\">\n  <center>\n    <h3>Send Test email</h3>\n  </center>\n</div>\n<div class=\"modal-body custom-modal-addnotes clearfix\">\n  <center>\n    <form name=\"sendTestEmailForm\">\n      <div class=\"row send-test-email-input-wrapper\">\n        <div class=\"col-xs-6 send-test-email-label\">\n          Enter Email Id to send test email to\n        </div>\n        <div class=\"col-xs-6\">\n          <Input\n          data-testid=\"email-input-field\"\n             type=\"email\"\n             style=\" min-width:0px; padding-top: 6px;padding-bottom: 6px; width:90%; padding-left: 10px\"\n             ng-model=\"modalData.recepient\"\n             required>\n          </Input>\n        </div>\n      </div>\n    </form>\n  </center>\n</div>\n<div class=\"modal-footer\">\n  <center>\n    <button data-testid=\"modal-send-test-email\" class=\"btn btn-info\" ng-disabled=\"sendTestEmailForm.$invalid\" ng-click=\"sendEmail()\">Send Test Email</button>\n    <button class=\"btn btn-default\" ng-click=\"close()\">Cancel</button>\n  </center>\n</div>\n</script>\n</div>"

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-forgot\" data-ng-controller=\"ForgotPasswordController as ctrl\">\n  <div lexstep-header></div>\n  <!-- Header Ends -->\n\n  <div class=\"main-body\" ng-click=\"hideDropDown()\">\n    <div class=\"container\">\n      <div class=\"info text-center\">\n        <h1 class=\"text-thin hdng-tshadow margin-t0\">\n          {{'forgotPassword.Heading'|translate}}\n        </h1>\n        <p class=\"text-small\">{{'forgotPassword.caption'|translate}}</p>\n      </div>\n\n      <div class=\"form-container\">\n        <div class=\"form-container\">\n          <form\n            class=\"form-horizontal\"\n            name=\"forgotPasswordForm\"\n            ng-submit=\"forgotPasswordForm.$valid&&ctrl.sendLink()\"\n          >\n            <div class=\"form-group\">\n              <input\n                data-testid=\"forget-email\"\n                type=\"email\"\n                class=\"form-control input-lg\"\n                ng-model=\"ctrl.userEmail\"\n                placeholder=\"Email\"\n                required\n              />\n            </div>\n            <div class=\"form-group\">\n              <button\n                data-testid=\"continue\"\n                class=\"btn btn-lg btn-block btn-info\"\n                ng-disabled=\"ctrl.linkRequested\"\n                type=\"submit\"\n              >\n                {{ctrl.btnLabel}}\n              </button>\n            </div>\n          </form>\n        </div>\n      </div>\n    </div>\n  </div>\n  <!-- Footer -->\n  <div lexstep-footer></div>\n</div>\n"

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-signin\" data-ng-controller=\"SignInController\">\n  <div lexstep-header></div>\n\n  <div\n    data-ng-controller=\"IsOldBrowserController as isOldBrowser\"\n    class=\"container\"\n  >\n    <div class=\"old-browser-alert\" ng-show=\"isOldBrowser.showOldBrowser\">\n      <div class=\"callout bg-warning margin-t0\" type=\"info\">\n        You are using an older version of the browser that may not support\n        LexStep features. Please\n        <a\n          target=\"_blank\"\n          class=\"text-info\"\n          href=\"http://windows.microsoft.com/en-us/internet-explorer/download-ie\"\n          >upgrade</a\n        >\n        for improved experience.\n      </div>\n    </div>\n  </div>\n\n  <div class=\"container page-about\">\n    <h1>\n      <strong>Where Employers Hire Lawyers</strong>\n    </h1>\n  </div>\n  <div align=\"center\" class=\"container\">\n    <p class=\"lead\" align=\"justify\">\n      LexStep is an award winning talent marketplace that intelligently matches\n      a curated network of top-tier lawyers with opportunities at the world's\n      best legal employers.\n    </p>\n    <p class=\"lead\" align=\"justify\">\n      Launched in 2015 by global 'magic circle' lawyers, we've been featured\n      prominently in a number of legal press publications, won innovation\n      awards, participated in prestigious accelerators and are facilitating\n      interviews worth £millions in salary offers through the platform each\n      month.\n    </p>\n    <p class=\"lead\" align=\"justify\">\n      We work with Magic Circle, US and international firms in the UK and\n      internationally in relation to their associate and partner hiring needs.\n    </p>\n    <h2>\n\n      Get <strong>instant access</strong> to a curated pool of responsive top legal talent\n      actively seeking their next role</strong\n    >\n    </h2>\n    \n    <div\n        class=\"form-container getintouch-form\"\n        ng-controller=\"HiringController as ctrl\"\n      >\n    <br />\n    <p ng-show=\"ctrl.isHideForm\" class=\"get-in-touch-text lead\">\n      Thanks for your interest in LexStep! Your enquiry has been submitted and a\n      member of the team will be in touch shortly.\n    </p>\n    <form\n      ng-hide=\"ctrl.isHideForm\"\n      class=\"form-horizontal\"\n      ng-submit=\"ctrl.employerApply()\"\n    >\n      <div class=\"form-group\">\n        <div class=\"input-group input-group-lg\" style=\"display: block;\">\n          <input\n            type=\"text\"\n            autocomplete=\"off\"\n            class=\"form-control\"\n            placeholder=\"Name*\"\n            ng-model=\"ctrl.hiring.name\"\n            required\n            \n          />\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <div class=\"input-group input-group-lg\" style=\"display: block;\">\n          <input\n            type=\"email\"\n            autocomplete=\"off\"\n            class=\"form-control\"\n            placeholder=\"Your email address*\"\n            ng-model=\"ctrl.hiring.email\"\n            required\n          />\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <div class=\"input-group input-group-lg\" style=\"display: block;\">\n          <input\n            type=\"text\"\n            autocomplete=\"off\"\n            class=\"form-control\"\n            placeholder=\"Employer/Company name*\"\n            ng-model=\"ctrl.hiring.employerName\"\n            required\n            \n          />\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <div class=\"input-group input-group-lg\" style=\"display: block;\">\n          <input\n            type=\"tel\"\n            autocomplete=\"off\"\n            class=\"form-control\"\n            placeholder=\"Phone number*\"\n            ng-model=\"ctrl.hiring.phoneNumber\"\n            required\n            only-numbers\n          />\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <div class=\"input-group input-group-lg\" style=\"display: block;\">\n          <input\n            type=\"text\"\n            autocomplete=\"off\"\n            class=\"form-control\"\n            placeholder=\"Experience requirements you are looking to hire\"\n            ng-model=\"ctrl.hiring.experience\"\n            \n          />\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <div class=\"input-group input-group-lg\" style=\"display: block;\">\n          <select\n            required\n            class=\"customSelect\"\n            ng-model=\"ctrl.hiring.jobType\"\n            required\n          >\n            <option selected>Job/project type</option>\n            <option>Permanent</option>\n            <option>Freelance</option>\n            <option>Both</option>\n          </select>\n        </div>\n      </div>\n\n      <div class=\"form-group\">\n        <div class=\"input-group input-group-lg\" style=\"display: block;\">\n          <select\n            required\n            class=\"customSelect\"\n            ng-model=\"ctrl.hiring.aboutUs\"\n            required\n          >\n            <option selected>How did you hear about us?</option>\n            <option>I am a candidate on the site</option>\n            <option>Email received from LexStep</option>\n            <option>Saw an advert on Google</option>\n            <option>Saw an advert on Facebook</option>\n            <option>Saw an advert on LinkedIn</option>\n            <option>Recommended by employer on site</option>\n            <option>Recommended by candidate on site</option>\n            <option>Came across on Google</option>\n            <option>Came across on Facebook</option>\n            <option>Came across on LinkedIn</option>\n            <option>Other</option>\n          </select>\n        </div>\n      </div>\n\n      <center>\n        <input type=\"submit\" class=\"btn btn-info\" value=\"Get in touch\" />\n      </center>\n      </form>\n    </div>\n  </div>\n\n  <div class=\"container page-about\">\n    <h2>\n      Access our curated network of vetted candidates and shorten your\n      time-to-hire\n    </h2>\n\n    <p class=\"lead\" align=\"justify\">\n      Our pre-screened membership is made up of thousands of highly qualified\n      lawyers across all practice areas, PQE levels, global financial centres\n      and Common Law jurisdictions including Australia, Canada, England & Wales,\n      Ireland, Hong Kong, New Zealand, Singapore, UAE, the US and offshore,\n      saving you tens of sourcing hours per hire.\n    </p>\n\n    <h2>\n      Lean on expert Talent Agents\n    </h2>\n\n    <p class=\"lead\" align=\"justify\">\n      LexStep's platform is powered by a ferociously talented team of responsive\n      experts who ensure success for both candidates and employers throughout\n      the entire LexStep process. All LexStep talent Agents have either\n      received a formal legal education, practiced as lawyers at the highest\n      level and/or have gained extensive recruitment industry experience.\n    </p>\n\n    <h2>\n      Experience the power of our proprietary technology, without the hassle\n    </h2>\n\n    <p class=\"lead\" align=\"justify\">\n      As a LexStep client, you will be assigned a LexStep talent Agent who\n      will be your primary point of contact and take the time to get to know\n      your recruitment team, practice heads and understand your business and\n      hiring needs. Your LexStep Agent will leverage our platform and\n      talent scouting network to present you with a bespoke shortlist of only\n      the right candidates for your job requirements, supporting you throughout\n      the recruitment process to help schedule interviews and liaise with\n      candidates on your behalf. Our talent Agents operate at the same\n      service level that you offer your own clients on their bet-the-company\n      matters, so you can enjoy their professional support with the highest\n      level of responsiveness from initial contact to offer acceptance and\n      beyond.\n    </p>\n  </div>\n\n  <div lexstep-footer></div>\n</div>\n"

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-signin\" ng-cloak data-ng-controller=\"HomePageCtrl as home\">\n  <div lexstep-header></div>\n\n  <section class=\"landing-banner\" ng-click=\"hideDropDown()\">\n    <div class=\"container\">\n      <div class=\"banner-text text-center\">\n        <div class=\"tagline-container\">\n          <img width=\"70\" src=\"images/lexstep_logo.jpeg\" class=\"hidden-xs\" />\n          <h3 class=\"home-tagline\">{{'homePage.tagline'|translate}}</h3>\n        </div>\n        <h1>\nTHE GLOBAL MARKETPLACE FOR WORLD-CLASS LEGAL TALENT\n        </h1>\n        <h3 class=\"hidden-xs subHeading\">\n        where global elite, US, magic circle, international, boutique law firms and in-house legal employers hire lawyers\n          <div class=\"break-mob half-divider\"></div>\n        </h3>\n\n        <a\n          class=\"btn btn-info btn-apply\"\n          ng-click=\"homepageControls('Who Is Hiring')\"\n          >{{'homePage.subHeading2'|translate}}\n          <i class=\"fa fa-angle-right apply-arrow \"></i\n        ></a>\n      </div>\n    </div>\n  </section>\n  <!-- Banner Section End -->\n\n  <section class=\"landing-firms\" ng-click=\"hideDropDown()\">\n    <!-- <h4 class=\"text-center\">{{'homePage.requestAccessHeading'|translate}}</h4> -->\n    <div class=\"container firm-container\">\n      <ul class=\"landing-firms-images list-inline clearfix margin-b0\">\n        <!-- first row -->\n        <div class=\"row row-logo wfw-logo\">\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Addleshaw Goddard\"\n              src=\"images/addleshaw-goddard.jpg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Akin Gump\"\n              src=\"images/akin.svg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"A&O Shearman\"\n              src=\"images/aoshearman.svg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Ashurst\"\n              src=\"images/ashrst_logo.jpg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Bake McKenzie\"\n              src=\"images/bake-mckenzie_logo.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Bevan Brittan\"\n              src=\"images/bevan-brittan-logo.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Bird & Bird\"\n              src=\"images/bird-n-bird_logo.jpg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Berwin Leighton Paisner\"\n              src=\"images/bclp.png\"\n            />\n          </li>\n        </div>\n\n        <!-- second row -->\n        <div class=\"row row-logo\">\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"King &amp; Wood Mallesons\"\n              src=\"images/kwm_logo.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Burges\"\n              src=\"images/logo_burges.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Cary Olsen\"\n              src=\"images/cary_olsen.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Charles Russell Speechlys\"\n              src=\"images/charles.svg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Cleary Gottlieb\"\n              src=\"images/cleary-gottlieb-logo.jpg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Clifford Chance\"\n              src=\"images/clifford-chance_logo.jpg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Covington\"\n              src=\"images/covington.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Dentos\"\n              src=\"images/dentons.png\"\n            />\n          </li>\n        </div>\n\n        <!-- third row -->\n        <div class=\"row row-logo\">\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Fledgate\"\n              src=\"images/fladge-logo.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Goodwin\"\n              src=\"images/goodwin_logo.jpg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo square-logo\"\n              alt=\"Gowling WLG\"\n              src=\"images/wraggeLogo.jpg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo square-logo\"\n              alt=\"Gibson Dunn\"\n              src=\"images/gibsondunn.svg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo square-logo\"\n              alt=\"Gunner Cooke\"\n              src=\"images/gunner-cooke.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Harbottle & Lewis\"\n              src=\"images/harbottle-logo.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Hausfeld\"\n              src=\"images/hausfeld.svg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Herbert Smith Freehills\"\n              src=\"images/hsf_logo.jpg\"\n            />\n          </li>\n        </div>\n\n        <!-- fourth row -->\n        <div class=\"row row-logo\">\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Ignition\"\n              src=\"images/Logo_IgnitionLaw2.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Lightsource bp\"\n              src=\"images/lightsource_logo.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Morgan\"\n              src=\"images/morgan.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Norton Rose Fullbright\"\n              src=\"images/Norton-Rose.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Orrick\"\n              src=\"images/orrick-new.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Osborne Clarke\"\n              src=\"images/osborneclarkelogo.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Paul Hastings\"\n              src=\"images/paul-hastings_logo.jpg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Peerpoint\"\n              src=\"images/peerpoint-new.png\"\n            />\n          </li>\n        </div>\n\n        <!--fifth row-->\n        <div class=\"row row-logo\">\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Pennings\"\n              src=\"images/pennnings-logo.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Pillsbury\"\n              src=\"images/logo_pillsbury.jpg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Quinn Emanuel Trial Lawyers\"\n              src=\"images/QuinnLogo.jpg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Shoosmiths\"\n              src=\"images/Logo_Shoosmiths.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Sidley Austin\"\n              src=\"images/Sidley-Austin.jpg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Simmons &amp; Simmons\"\n              src=\"images/simmons.svg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Simpson Thacher\"\n              src=\"images/simpson-thacher_logo.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Skadden\"\n              src=\"images/skadden-logo-2.png\"\n            />\n          </li>\n        </div>\n\n        <!-- sixth row -->\n        <div class=\"row row-logo\">\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Smart Up\"\n              src=\"images/smart-up.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Square Pattons Boggs\"\n              src=\"images/square-pattons.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Taylor Wessing\"\n              src=\"images/Logo_TaylorWessing.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Travers Smith\"\n              src=\"images/Logo_TraversSmith.jpg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Trinity International LLP\"\n              src=\"images/Trinity.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo square-logo\"\n              alt=\"Vinson & Elkins\"\n              src=\"images/vinson&elkins.png\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Watson Farley\"\n              src=\"images/WFW.jpg\"\n            />\n          </li>\n          <li class=\"text-center col-md-3 col-lg-1 col-sm-3 col-xs-6\">\n            <img\n              class=\"img-responsive firm-logo\"\n              alt=\"Wiggin\"\n              src=\"images/logo_wiggin.png\"\n            />\n          </li>\n        </div>\n      </ul>\n      <h4 class=\"text-center margin-t25\">\n        {{'homePage.anonymityText' | translate}}\n      </h4>\n      <h4 class=\"text-center\">\nBuilt upon the foundation of cutting edge human-centric technology and exceptional talent, LexStep is a pioneering global talent platform servicing the legal market. We are agile and dynamic in our approach, delivering world-class talent to our premium private practice and in-house client base on a daily basis.\n\n      </h4>\n      <h4 class=\"text-center\">\nSign up to see who's hiring or talk to one of our talent agents to discover exclusive off-market career opportunities.\n\n\n      </h4>\n    </div>\n  </section>\n\n  <section class=\"great-product\" ng-click=\"hideDropDown()\">\n    <div class=\"row\">\n      <center>\n        <h3 class=\" legalweek-feedback text-center padding-lr20\">\n          <i\n            >\"A great product that allows lawyers to keep tabs on the jobs\n            market themselves.\"</i\n          >\n        </h3>\n\n        <img\n          class=\"img-responsive\"\n          style=\"margin-top: 20px;\"\n          alt=\"Legal Week\"\n          src=\"images/legal.png\"\n        />\n      </center>\n    </div>\n    <h3 class=\"text-center margin-t25\">\n      <strong>{{'homePage.winnerLegalWeek.label'|translate}}</strong>\n    </h3>\n  </section>\n\n  <section\n    class=\"landing-firms\"\n    ng-click=\"hideDropDown()\"\n    style=\"padding-top: 0px\"\n  >\n    <div class=\"container firm-container\">\n      <h3 class=\"text-center\">{{'homePage.featuredin.label'|translate}}</h3>\n\n      <!-- <h3 class=\"text-center margin-b0\">\n        {{'homePage.firmLogos.Heading'|translate}}\n      </h3> -->\n      <ul\n        class=\"ui-timline-container list-inline clearfix margin-b0 padding-0 margin-t20\"\n      >\n        <div class=\"row row-logo\">\n          <div class=\"col-md-4\">\n            <div class=\"row\">\n              <li class=\"text-center col-sm-6 col-xs-12 margin-t10 margin-b10\">\n                <a\n                  href=\"{{'homePage.legalweekAwards.label'|translate}}\"\n                  target=\"_blank\"\n                >\n                  <img\n                    class=\"img-responsive featured-logo\"\n                    alt=\"Legal Week Awards\"\n                    src=\"images/publishers/awards.jpg\"\n                  />\n                </a>\n              </li>\n              <li class=\"text-center col-sm-6 col-xs-12 margin-t10 margin-b10\">\n                <a\n                  href=\"{{'homePage.thelawyer.label'|translate}}\"\n                  target=\"_blank\"\n                >\n                  <img\n                    class=\"img-responsive featured-logo\"\n                    alt=\"Legal Week Awards\"\n                    src=\"images/publishers/tl.png\"\n                  />\n                </a>\n              </li>\n            </div>\n            <div class=\"row\">\n              <li class=\"text-center col-sm-6 col-xs-12 margin-t10 margin-b10\">\n                <a\n                  href=\"{{'homePage.thelegaltechnology.label'|translate}}\"\n                  target=\"_blank\"\n                >\n                  <img\n                    class=\"img-responsive featured-logo\"\n                    alt=\"LegalWeek\"\n                    src=\"images/publishers/it.png\"\n                  />\n                </a>\n              </li>\n              <li class=\"text-center col-sm-6 col-xs-12 margin-t10 margin-b10\">\n                <a\n                  href=\"{{'homePage.LawSociety.label'|translate}}\"\n                  target=\"_blank\"\n                >\n                  <img\n                    class=\"img-responsive featured-logo\"\n                    alt=\"Law Society\"\n                    src=\"images/publishers/LawSociety.png\"\n                  />\n                </a>\n              </li>\n            </div>\n          </div>\n          <li\n            class=\"hidden-xs text-center col-md-4 col-sm-8 col-md-offset-0 col-sm-offset-2 col-xs-12 margin-t40 margin-b10\"\n          >\n            <a href=\"https://business.london/\" target=\"_blank\">\n              <img\n                class=\"img-responsive featured-logo\"\n                alt=\"Business London\"\n                src=\"images/publishers/Badges-Company-without-header.jpg\"\n              />\n            </a>\n          </li>\n          <div class=\"col-md-4\">\n            <div class=\"row\">\n              <li class=\"text-center col-sm-6 col-xs-12 margin-t10 margin-b10\">\n                <a\n                  href=\"{{'homePage.legalweek.label'|translate}}\"\n                  target=\"_blank\"\n                >\n                  <img\n                    class=\"img-responsive featured-logo\"\n                    alt=\"Legal Week\"\n                    src=\"images/publishers/lw.png\"\n                  />\n                </a>\n              </li>\n              <li class=\"text-center col-sm-6 col-xs-12 margin-t10 margin-b10\">\n                <a\n                  href=\"{{'homePage.thelawyer2b.label'|translate}}\"\n                  target=\"_blank\"\n                >\n                  <img\n                    class=\"img-responsive featured-logo\"\n                    alt=\"Lawyers 2B\"\n                    src=\"images/publishers/2b.png\"\n                  />\n                </a>\n              </li>\n            </div>\n            <div class=\"row\">\n              <li class=\"text-center col-sm-6 col-xs-12 margin-t10 margin-b10\">\n                <a\n                  href=\"https://www.legalgeek.co/startup-map/lexstep/\"\n                  target=\"_blank\"\n                >\n                  <img\n                    class=\"img-responsive featured-logo\"\n                    alt=\"Legal Geek Startup Map\"\n                    src=\"images/publishers/legal-geek.png\"\n                  />\n                </a>\n              </li>\n              <li class=\"text-center col-sm-6 col-xs-12 margin-t10 margin-b10\">\n                <a\n                  href=\"http://www.thelegalinnovationawards.com/\"\n                  target=\"_blank\"\n                >\n                  <img\n                    class=\"img-responsive featured-logo\"\n                    alt=\"Legal Innovation Awards\"\n                    src=\"images/publishers/LegalInnovationAwardsFinalists.png\"\n                  />\n                </a>\n              </li>\n            </div>\n          </div>\n\n          <!--<li class=\"visible-xs hidden-lg hidden-md hidden-sm text-center col-md-4 col-sm-8 col-md-offset-0 col-sm-offset-2 col-xs-12 margin-b10\">\n            <a href=\"https://business.london/\" target=\"_blank\">\n              <img class=\"img-responsive featured-logo\" alt=\"Business London\" src=\"images/publishers/Badges-Company-without-header.jpg\">\n            </a>\n          </li>-->\n\n          <li\n            class=\"visible-xs hidden-lg hidden-md hidden-sm text-center col-md-4 col-sm-8 col-md-offset-0 col-sm-offset-2 col-xs-12 margin-t10 margin-b10\"\n          >\n            <a href=\"https://business.london/\" target=\"_blank\">\n              <img\n                class=\"img-responsive featured-logo\"\n                alt=\"Business London\"\n                src=\"images/publishers/EURDF.png\"\n              />\n            </a>\n          </li>\n\n          <li\n            class=\"visible-xs hidden-lg hidden-md hidden-sm text-center col-md-4 col-sm-8 col-md-offset-0 col-sm-offset-2 col-xs-12 margin-t10 margin-b10\"\n          >\n            <a href=\"https://business.london/\" target=\"_blank\">\n              <img\n                class=\"img-responsive featured-logo\"\n                alt=\"Business London\"\n                src=\"images/publishers/london-partners.png\"\n              />\n            </a>\n          </li>\n        </div>\n      </ul>\n    </div>\n    <span class=\"arrow-down\"><i class=\"fa fa-arrow-down\"></i></span>\n  </section>\n  <!-- Firms Logo Section End -->\n\n  <!-- Feedback Quotes -->\n  <section class=\"feedback-quotes\" ng-click=\"hideDropDown()\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-md-4\">\n          <div class=\"quote margin-r15\">\n            <img\n              alt=\"\"\n              src=\"images/quotes-icon.png\"\n              class=\"hidden img-circle quote-image img64_64 center-block\"\n            />\n            <div class=\"quote-body\">\n              <em class=\"text-justify\">\n                <p>\n                  \"{{\"homepage.feedback-quotes.quote-one\" | translate}}\"\n                </p>\n              </em>\n              <h4 class=\"media-heading text-center\" style=\"\">\n                {{\"homepage.feedback-quotes.quote-one-heading\" | translate}}\n              </h4>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"col-md-4\">\n          <div class=\"quote margin-r15\">\n            <img\n              alt=\"\"\n              src=\"images/quotes-icon.png\"\n              class=\"hidden img-circle quote-image img64_64 center-block\"\n            />\n            <div class=\"quote-body\">\n              <em class=\"text-justify\">\n                <p>\n                  \"{{\"homepage.feedback-quotes.quote-two\" | translate}}\"\n                </p>\n              </em>\n              <h4 class=\"media-heading text-center\" style=\"\">\n                {{\"homepage.feedback-quotes.quote-two-heading\" | translate}}\n              </h4>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"col-md-4\">\n          <div class=\"quote\">\n            <img\n              alt=\"\"\n              src=\"images/quotes-icon.png\"\n              class=\"hidden img-circle quote-image img64_64 center-block\"\n            />\n            <div class=\"quote-body\">\n              <em class=\"text-justify\">\n                <p>\n                  \"{{\"homepage.feedback-quotes.quote-three\" | translate}}\"\n                </p>\n              </em>\n              <h4 class=\"media-heading text-center\" style=\"\">\n                {{\"homepage.feedback-quotes.quote-three-heading\" | translate}}\n              </h4>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <span class=\"arrow-down arrow-quotes\"\n      ><i class=\"fa fa-arrow-down\"></i\n    ></span>\n  </section>\n  <!-- Featured in Section Ends -->\n\n  <section class=\"landing-3steps\" ng-click=\"hideDropDown()\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-md-4\">\n          <div class=\"mini-box\">\n            <span class=\"box-icon\"><i class=\"fa fa-check\"></i></span>\n            <div class=\"box-info\">\n              <b><h3>{{'homePage.bullet1.heading'|translate}}</h3></b>\n              <p class=\"text-justify\">{{'homePage.bullet1.text'|translate}}</p>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"col-md-4\">\n          <div class=\"mini-box\">\n            <span class=\"box-icon\"><i class=\"fa fa-check\"></i></span>\n            <div class=\"box-info\">\n              <b><h3>{{'homePage.bullet2.heading'|translate}}</h3></b>\n              <p class=\"text-justify\">{{'homePage.bullet2.text'|translate}}</p>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"col-md-4\">\n          <div class=\"mini-box\">\n            <span class=\"box-icon\"><i class=\"fa fa-check\"></i></span>\n            <div class=\"box-info\">\n              <b><h3>{{'homePage.bullet3.heading'|translate}}</h3></b>\n              <p class=\"text-justify\">{{'homePage.bullet3.text'|translate}}</p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <span class=\"arrow-down arrow-steps\"><i class=\"fa fa-arrow-down\"></i></span>\n  </section>\n  <!-- 3Steps Section End -->\n\n  <section class=\"landing-bonus\" ng-click=\"hideDropDown()\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-sm-8 col-xs-12 text-center\">\n          <h1>{{'homePage.bonusSection.Heading1'|translate}}</h1>\n          <h4>{{'homePage.bonusSection.Heading2'|translate}}</h4>\n        </div>\n        <div class=\"col-sm-4 col-xs-12 text-center\">\n          <a\n            class=\"btn btn-info btn-lg ng-binding margin-t31\"\n            ng-click=\"homepageControls('Request Access Now')\"\n          >\n            {{'homePage.requestAccessNow'| translate}}\n            <i class=\"fa fa-angle-right request-arrow \"></i\n          ></a>\n        </div>\n      </div>\n    </div>\n    <span class=\"arrow-down arrow-landing-bonus\"\n      ><i class=\"fa fa-arrow-down\"></i\n    ></span>\n  </section>\n  <!-- bonus section ends -->\n\n  <section class=\"landing-howitworks\" ng-click=\"hideDropDown()\">\n    <div class=\"container\">\n      <h2 class=\"text-center\">{{'homePage.howItWorks.label'|translate}}</h2>\n\n      <div class=\"ui-timline-container\">\n        <section class=\"ui-timeline\">\n          <article class=\"tl-item alt\">\n            <div class=\"tl-body\">\n              <div class=\"tl-entry\">\n                <div class=\"tl-time hidden\">3 min ago</div>\n                <div\n                  class=\"tl-icon square-icon sm bg-info-green text-color-white\"\n                >\n                  1\n                </div>\n                <div class=\"tl-content\">\n                  <h3 class=\"tl-tile\">Sign up</h3>\n                  <p>\n                    Sign up in under 90 seconds and create your LexStep Profile.\n                  </p>\n                </div>\n              </div>\n            </div>\n          </article>\n\n          <article class=\"tl-item\">\n            <div class=\"tl-body\">\n              <div class=\"tl-entry\">\n                <div class=\"tl-time hidden\">1 hour ago</div>\n                <div\n                  class=\"tl-icon square-icon sm  bg-info-green text-color-white\"\n                >\n                  2\n                </div>\n                <div class=\"tl-content\">\n                  <h3 class=\"tl-tile\">See what's out there</h3>\n                  <p>\n                    Explore relevant opportunities and share your LexStep\n                    Profile with employers you're interested in connecting with.\n                  </p>\n                </div>\n              </div>\n            </div>\n          </article>\n\n          <article class=\"tl-item alt\">\n            <div class=\"tl-body\">\n              <div class=\"tl-entry\">\n                <div class=\"tl-time hidden\">3 hours ago</div>\n                <div\n                  class=\"tl-icon square-icon sm  bg-info-green text-color-white\"\n                >\n                  3\n                </div>\n                <div class=\"tl-content\">\n                  <h3 class=\"tl-tile\">Receive offers</h3>\n                  <p>\n                    Receive offers for a commitment-free coffee or interview and\n                    keep track of who you’ve shared your profile with.\n                  </p>\n                </div>\n              </div>\n            </div>\n          </article>\n\n          <article class=\"tl-item\">\n            <div class=\"tl-body\">\n              <div class=\"tl-entry\">\n                <div class=\"tl-time hidden\">7 hours ago</div>\n                <div\n                  class=\"tl-icon square-icon sm  bg-info-green text-color-white\"\n                >\n                  4\n                </div>\n                <div class=\"tl-content\">\n                  <h3 class=\"tl-tile\">Celebrate!</h3>\n                  <p>\n                    Sit back, let our talent Agents negotiate your new package\n                    on your behalf and celebrate!\n                  </p>\n                </div>\n              </div>\n            </div>\n          </article>\n        </section>\n      </div>\n    </div>\n    <div class=\"row\">\n      <center>\n        <a\n          class=\"btn btn-info btn-lg\"\n          ng-click=\"homepageControls('Get Started Now')\"\n        >\n          Get Started Now <i class=\"fa fa-angle-right get-started-arrow\"></i\n        ></a>\n      </center>\n    </div>\n  </section>\n  <!-- Steps Section End -->\n\n  <!-- Footer -->\n  <div lexstep-footer></div>\n</div>\n"

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"page-signin\"\n  id=\"browse-jobs\"\n  ng-cloak\n  data-ng-controller=\"InHouseJobsController as inHouseJobsController\"\n  ng-init=\"showAlert = true\"\n>\n  <!-- mobile navbar -->\n  <div lexstep-header></div>\n  <!-- Header Ends -->\n  <div data-ng-controller=\"IsOldBrowserController as isOldBrowser\" class=\"container\">\n    <div class=\"old-browser-alert\" ng-show=\"isOldBrowser.showOldBrowser\">\n      <div class=\"callout bg-warning margin-t0\" type=\"info\">\n        You are using an older version of the browser that may not support\n        LexStep features. Please\n        <a\n          target=\"_blank\"\n          class=\"text-info\"\n          href=\"http://windows.microsoft.com/en-us/internet-explorer/download-ie\"\n          >upgrade</a\n        >\n        for improved experience.\n      </div>\n    </div>\n  </div>\n\n  <div class=\"container\" ng-click=\"inHouseJobsController.hideDropDown()\">\n    <div class=\"panel-body heading-jobs-listings row\">\n      <center>\n        <h1 class=\"text-thin hdng-tshadow margin-b10\">\n          In-House Jobs Database\n        </h1>\n        <div class=\"inlineBlock\">\n          <h4 class=\"display-inline text-thin hdng-tshadow margin-b0\">\n            Brought to you by LexStep: a live database of in-house positions\n            aggregated from around the web.\n          </h4>\n          <a\n            class=\"display-inline no-text-decoration subheading-tooltip\"\n            href=\"\"\n            tooltip=\"Use the filters below to refine your search and connect directly with in-house employers of interest.\"\n            tooltip-placement=\"bottom\"\n          >\n            <span class=\"badge badge-grey\">\n              <i class=\"fa fa-info\"></i>\n            </span>\n          </a>\n        </div>\n\n        <div>\n          <button\n            class=\"btn btn-info margin-t20\"\n            ng-click=\"inHouseJobsController.loadPrivateJobs()\"\n          >\n            Explore My LexStep Matches\n          </button>\n        </div>\n        <div class=\"badge badge-info hidden\">\n          <span class=\"badge badge-info\">\n            <h5 class=\"margin-t5 margin-b5\">\n              <span>Questions? &nbsp; Give us a call:</span>\n              <span>&nbsp;{{contactPhone}}</span>\n            </h5>\n          </span>\n        </div>\n      </center>\n    </div>\n\n    <!-- Main Alert Section -->\n    <div hidden class=\"callout bg-danger\" type=\"info\">\n      <span class=\"glyphicon glyphicon-lock\"></span> &nbsp;<strong\n        class=\"ng-binding\"\n        >{{'main.alert'| translate}}</strong\n      >\n    </div>\n    <!-- Main Alert Section End -->\n\n    <!-- Get Start Section -->\n    <div\n      class=\"row\"\n      ng-show=\"inHouseJobsController.candidate.approvalStatus === 'Locked'\"\n    >\n      <div class=\"col-md-12\">\n        <div class=\"alert alert-danger alert-dismissable  margin-t10\">\n          <div>\n            <span\n              ><i class=\"fa fa-warning\"></i>&nbsp;Your profile has been locked\n              and is waiting for re-approval. For now you cannot apply to any\n              job or edit your profile.</span\n            >\n            <!-- <a href=\"\" class=\"fa fa-times pull-right\" ng-click=\"profileAlert = 'fadeOutDown'; crossAnimate='fadeInUp'; showProfileAlert = false\"></a> -->\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- Get Start Section End -->\n\n    <div class=\"panel panel-default \">\n      <div class=\"panel-body row hidden\">\n        <alert\n          type=\"danger\"\n          class=\"col-md-6 col-md-offset-3 alert-position\"\n          ng-show=\"showOnError\"\n          ><strong><center>{{alertMsg}}</center></strong></alert\n        >\n        <alert\n          type=\"success\"\n          class=\"col-md-6 col-md-offset-3 alert-position\"\n          ng-show=\"showOnSuccess\"\n          ><strong><center>{{alertMsg}}</center></strong></alert\n        >\n      </div>\n\n      <!---###### FIRMS LISTING #######-->\n      <div class=\"panel-body row\">\n        <!--listings div starts-->\n        <section class=\"page page-table table-dynamic\">\n          <span\n            class=\"spinner-static-center\"\n            us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n            spinner-key=\"spinner-2\"\n          >\n          </span>\n          <!-- ## FILTERS MOBILE VIEW -->\n\n          <div\n            class=\"row matches-filter-section-inhouse firm-filter-box firm-filter-box-mob visible-xs\"\n          >\n            <div class=\"clearfix hidden\">\n              <div class=\"col-sm-5 col-xs-11 mob-sticky-msg\">\n                <span class=\"badge badge-info custom-badge\">\n                  <h5>\n                    <span>Questions? &nbsp; Give us a call:</span>\n                    <span>&nbsp;{{contactPhone}}</span>\n                  </h5>\n                </span>\n              </div>\n            </div>\n            <div class=\"clearfix\">\n              <div class=\"col-xs-12\">\n                <practice-Area-Dropdown\n                  width=\"true\"\n                  placeholder=\"'FILTER BY PRACTICE AREA(S)'\"\n                  practice-areas-list=\"inHouseJobsController.candidateSpecialties\"\n                  on-practice-change=\"inHouseJobsController.OnChangePracticeArea($event,selectedPracticeArea)\"\n                ></practice-Area-Dropdown>\n              </div>\n              <div class=\"col-xs-12 filter-mt\">\n                <locations-Dropdown\n                width=\"true\"\n                  placeholder=\"'FILTER BY LOCATION(S)'\"\n                  locations-list=\"inHouseJobsController.candidateLocations\"\n                  regions-list=\"inHouseJobsController.regionHierarchialListWithEuropeOnTop\"\n                  on-location-change=\"ctrl.onChangeLocation($event,selectedLocation)\"\n                ></locations-Dropdown>\n              </div>\n              <div class=\"col-xs-12 browse-opps-pqe-filter\">\n                <input\n                  ng-model=\"inHouseJobsController.filterPQE\"\n                  ng-change=\"inHouseJobsController.pqeChanged();\"\n                  type=\"text\"\n                  id=\"mySlider1\"\n                  slider\n                  options=\"inHouseJobsController.options\"\n                />\n              </div>\n\n              <div class=\"col-xs-12 job-switch-fillter switch-mt\">\n                <span class=\"text-switch-all hidden-jobs-switch-inhouse\"\n                  >All({{(inHouseJobsController.totalPositions &&\n                  inHouseJobsController.totalPositions > 0)?\n                  inHouseJobsController.totalPositions: 0}}\n                  <span\n                    ng-if=\"inHouseJobsController.countRefreshReq === true\"\n                    >*</span>\n                    \n                  )</span\n                >\n                <label class=\"switch switch-info\">\n                  <input\n                    ng-change=\"inHouseJobsController.hiddenJobFilter()\"\n                    data-ng-model=\"inHouseJobsController.hideJobFilterButton\"\n                    ng-checked=\"inHouseJobsController.hideJobFilterButton\"\n                    class=\"\"\n                    type=\"checkbox\"\n                  />\n                  <i></i>\n                </label>\n                <span class=\"text-switch-save hidden-jobs-switch-inhouse\"\n                  >Hidden({{(inHouseJobsController.hiddenPositions &&\n                  inHouseJobsController.hiddenPositions > 0)?\n                  inHouseJobsController.hiddenPositions: 0}}\n                  <span\n                    ng-if=\"inHouseJobsController.countRefreshReq === true\"\n                    >*</span>\n                  )</span\n                >\n              </div>\n              <div class=\"pull-right col-xs-3 animated\" ng-class=\"lockAnimate\">\n                <div\n                  class=\"animated\"\n                  ng-class=\"cvAnimate\"\n                  ng-show=\"(inHouseJobsController.candidate.resumes.length === 0)\"\n                >\n                  <span\n                    class=\"btn\"\n                    ng-show=\"inHouseJobsController.curLawyer.profileCvAlertCollapsed\"\n                    ng-click=\"CVAlert='zoomInUpLeft'; cvAnimate='fadeOut'; inHouseJobsController.updateProfileAlertStatus('profileCvAlertCollapsed', false)\"\n                  >\n                    <i class=\"text-warning fa fa-warning\"></i>\n                  </span>\n                </div>\n                <div class=\"animated\" ng-show=\"!inHouseJobsController.candidate.user.phone\">\n                  <span\n                    class=\"btn\"\n                    ng-class=\"phoneAnimate\"\n                    ng-show=\"inHouseJobsController.curLawyer.profilePhoneAlertCollapsed\"\n                    ng-click=\"PhoneAlert='zoomInUpLeft'; phoneAnimate='fadeOut';inHouseJobsController.updateProfileAlertStatus('profilePhoneAlertCollapsed', false)\"\n                  >\n                    <i class=\"text-warning fa fa-warning\"></i>\n                  </span>\n                </div>\n              </div>\n            </div>\n          </div>\n          <!-- ## FILTERS DESKTOP VIEW -->\n\n          <div\n            class=\"row matches-filter-section-inhouse firm-filter-box firm-filter-box-dsk hidden-xs\"\n          >\n            <div class=\"col-lg-3 col-sm-6\">\n              <practice-Area-Dropdown\n              placeholder=\"'FILTER BY PRACTICE AREA(S)'\"\n              practice-areas-list=\"inHouseJobsController.candidateSpecialties\"\n              on-practice-change=\"inHouseJobsController.OnChangePracticeArea($event,selectedPracticeArea)\"\n\n              ></practice-Area-Dropdown>\n            </div>\n            <div class=\"col-lg-3 col-sm-6\">\n              <locations-Dropdown\n              placeholder=\"'FILTER BY LOCATION(S)'\"\n              locations-list=\"inHouseJobsController.candidateLocations\"\n                regions-list=\"inHouseJobsController.regionHierarchialListWithEuropeOnTop\"\n                on-location-change=\"inHouseJobsController.onChangeLocation($event,selectedLocation)\"\n              ></locations-Dropdown>\n            </div>\n\n            <div class=\"col-lg-6 col-sm-12\">\n              <div class=\"row\">\n                <div\n                  class=\"col-lg-7 col-sm-6 browse-opps-pqe-filter filter-bar\"\n                >\n                  <input\n                    ng-model=\"inHouseJobsController.filterPQE\"\n                    ng-change=\"inHouseJobsController.pqeChanged();\"\n                    autocomplete=\"off\"\n                    type=\"text\"\n                    id=\"mySlider1\"\n                    slider\n                    options=\"inHouseJobsController.options\"\n                    class=\"hidden-jobs-switch-inhouse\"\n                  />\n                </div>\n\n                <div\n                  class=\"col-lg-5 col-sm-6 job-switch-fillter margin-t5 switch-mt\"\n                >\n                  <div class=\"text-center\">\n                    <span class=\"text-switch-all hidden-jobs-switch-inhouse\"\n                      >All({{(inHouseJobsController.totalPositions &&\n                      inHouseJobsController.totalPositions > 0)?\n                      inHouseJobsController.totalPositions: 0}}\n                      <span\n                        ng-if=\"inHouseJobsController.countRefreshReq === true\"\n                        >*</span>\n                        \n                      )</span\n                    >\n                    <label class=\"switch switch-info\">\n                      <input\n                        ng-change=\"inHouseJobsController.hiddenJobFilter()\"\n                        data-ng-model=\"inHouseJobsController.hideJobFilterButton\"\n                        ng-checked=\"inHouseJobsController.hideJobFilterButton\"\n                        class=\"\"\n                        data-testid=\"hide-toggle\"\n                        type=\"checkbox\"\n                      />\n                      <i></i>\n                    </label>\n                    <span class=\"text-switch-save hidden-jobs-switch-inhouse\"\n                      >Hidden({{(inHouseJobsController.hiddenPositions &&\n                      inHouseJobsController.hiddenPositions > 0)?\n                      inHouseJobsController.hiddenPositions: 0}}\n                      <span\n                        ng-if=\"inHouseJobsController.countRefreshReq === true\"\n                        >*</span>\n                      )</span\n                    >\n                    <div\n                      class=\"pull-right inhouse-cv-alert\"\n                    >\n                      <div\n                        class=\"animated\"\n                        ng-class=\"cvAnimate\"\n                        ng-show=\"!inHouseJobsController.candidate.resumes.length === 0\"\n                      >\n                        <span\n                          class=\"btn\"\n                          ng-show=\"inHouseJobsController.curLawyer.profileCvAlertCollapsed\"\n                          ng-click=\"CVAlert='zoomInUpLeft'; cvAnimate='fadeOut'; inHouseJobsController.updateProfileAlertStatus('profileCvAlertCollapsed', false)\"\n                        >\n                          <i class=\"text-warning fa fa-warning\"></i>\n                        </span>\n                      </div>\n                      <div class=\"animated\" ng-show=\"!inHouseJobsController.candidate.user.phone\">\n                        <span\n                          class=\"btn\"\n                          ng-class=\"phoneAnimate\"\n                          ng-show=\"inHouseJobsController.curLawyer.profilePhoneAlertCollapsed\"\n                          ng-click=\"PhoneAlert='zoomInUpLeft'; phoneAnimate='fadeOut'; inHouseJobsController.updateProfileAlertStatus('profilePhoneAlertCollapsed', false)\"\n                        >\n                          <i class=\"text-warning fa fa-warning\"></i>\n                        </span>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"col-sm-offset-5 col-sm-4 col-xs-5 hidden\">\n              <form>\n                <input\n                  type=\"text\"\n                  placeholder=\"Search\"\n                  class=\"form-control\"\n                  data-ng-model=\"searchKeywords\"\n                  data-ng-keyup=\"search()\"\n                />\n              </form>\n            </div>\n          </div>\n          <div\n            class=\"custom-table-body\"\n            ng-if=\"!noJob && !inHouseJobsController.spinnerActive\"\n          >\n            <div\n              class=\"animated\"\n              ng-class=\"inHouseJobsController.jobRow{{job.id}}\"\n              ng-if=\"job.visible\"\n              data-ng-repeat=\"job in inHouseJobsController.candidateExternalMatchesData\"\n              ng-init=\"job.expanded=false\"\n              data-testid=\"job-details-div\"\n              >\n              <div\n                class=\"list-item list-item-inhouse clearfix\"\n                data-ng-click=\"inHouseJobsController.showJobs(job)\"\n                title=\"Click to view job\"\n              >\n                <img\n                  ng-if=\"job.isNewJob\"\n                  src=\"images/new-role-indicator.png\"\n                  class=\"new-jobs-indictaor\"\n                />\n                <div class=\"col-md-6 col-sm-12 col-xs-12 list-col-firm\">\n                  <div class=\"row\">\n                    <div class=\"col-xs-4 list-firm-logo\">\n                      <img\n                        class=\"\"\n                        alt=\"{{job.employer.name}}\"\n                        ng-src=\"{{job.employer.logoSrc}}\"\n                      />\n                    </div>\n                    <div class=\"col-xs-8 list-job-title\">\n                      <h2 class=\"margin-t0 margin-b0 text-thin\">\n                        {{job.employer.name}}\n                        <img\n                          ng-src=\"{{(job.employerTypeID == 1)?'/images/Private.png':'/images/Inhouse.png'}}\"\n                        />\n                      </h2>\n                      <h3 id=\"{{job.id}}\">\n                        {{job.title}}\n                      </h3>\n                      <div\n                      ng-if=\"inHouseJobsController.fetchHiddenJobs\"\n                      style=\"margin-bottom: 1em; margin-top: 1em;\"\n                    >\n                      <h5\n                        ng-if=\"job.positionHidden\"\n                        class=\"label label-info text-uppercase\"\n                        style=\"margin-right: 1em;background-color: #e6b36a; color:black;width: 52px;font-weight:normal; \"\n                      >\n                        {{job.positionHiddenReason}}\n                      </h5>\n                      <h5\n                        ng-if=\"job.employerHidden\"\n                        class=\"label label-info text-uppercase\"\n                        style= \"background-color: #e6b36a; color:black;width: 52px;font-weight:normal;\"\n                      >\n                        Employer not for me\n                      </h5>\n                    </div>\n                    </div>\n                  </div>\n                </div>\n\n                <div class=\"col-md-5 col-sm-10 col-xs-12 col-inhouse-pqe\">\n                  <h5>\n                    PQE: {{job.lawPreferences.minPqe <= 0\n                    ?\"NQ\":job.lawPreferences.minPqe}}{{job.lawPreferences.maxPqe\n                    == 11?\"+\":(job.lawPreferences.maxPqe <= 0 ||\n                    job.lawPreferences.maxPqe ==\n                    job.lawPreferences.minPqe)?\"\":\"-\"+job.lawPreferences.maxPqe}}\n                  </h5>\n                  <h5>\n                    Contract: {{job.contractTypeName}}\n                  </h5>\n                  <h5>Occupation: {{job.occupationName}}</h5>\n                  <div class=\"location-cloud\">\n                    <h5\n                      ng-repeat=\"location in job.locations\"\n                      class=\"label label-info text-uppercase\"\n                      ng-style=\"inHouseJobsController.locationBackgroundColor(location.color)\"\n                      >\n                      {{location.name}}\n                    </h5>\n                  </div>\n                </div>\n\n                <div\n                  class=\"col-md-1 col-sm-2 col-xs-12 text-center list-col-explore\"\n                >\n                  <div\n                    class=\"btn-noline btn-xs btn-explore \"\n                    >\n                    <i\n                      ng-show=\"!job.expanded\"\n                      class=\"btn btn-sm btn-line-info fa fa-plus\"\n                    ></i>\n                    <i\n                      ng-show=\"job.expanded\"\n                      class=\"btn btn-sm btn-line-info fa fa-minus\"\n                    ></i>\n                    <span class=\"h5\">Explore Role</span>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"inner-list-inhouse clearfix\" ng-if=\"job.expanded\">\n                <!--\n                  <div class=\"col-xs-12 inhouse-action visible-xs\"> Show Action Buttons in mobile</div>\n                -->\n\n                <div\n                  id=\"{{job.id}}\"\n                  class=\"col-md-10 col-sm-9 col-xs-12 pading-0\"\n                >\n                  <div class=\"list-job-desc-col job-description\">\n                    <div\n                      class=\"job-description-text\"\n                      ng-class=\"{expanded: !job.isCollapsed}\"\n                    >\n                      <p\n                        ng-bind-html=\"job.description\"\n                        class=\"\"\n                        align=\"justify\"\n                      ></p>\n                    </div>\n                    <a\n                      href=\"\"\n                      class=\"text-info\"\n                      ng-show=\"job.isCollapsed && job.showButton\"\n                      ng-click=\"inHouseJobsController.showMore(job);\"\n                      ><b class=\"text-more\">more</b></a\n                    >\n                    <a\n                      href=\"\"\n                      class=\"text-info\"\n                      ng-show=\"!job.isCollapsed && job.showButton\"\n                      ng-click=\"inHouseJobsController.showLess(job);\"\n                      ><b class=\"text-more\">less</b></a\n                    >\n                  </div>\n                </div>\n\n                <!--\n                  <div class=\"col-xs-12 inhouse-action hidden-xs\"> Hide Action Buttons in mobile</div>\n                -->\n\n                <div\n                  class=\"pull-right col-md-2 col-sm-3 col-xs-12 inhouse-action\"\n                >\n                  <!-- not Applied button -->\n                  <div\n                    class=\"pull-right list-job-desc-col\"\n                  >\n                    <div>\n                      <span\n                        ng-if=\"job.externalUrl\"\n                        class=\"inline disabled-tooltip\"\n                      >\n                        <button\n                          class=\"btn btn-info btn-job-apply\"\n                          ng-disabled=\"inHouseJobsController.candidate.approvalStatus === 'Locked'\"\n                          ng-click=\"inHouseJobsController.redirectToAtsLink(job)\"\n                        >\n                          <span ng-if=\"!job.Applied\" class=\"fa fa-plus\"></span>\n                          Interested\n                        </button>\n                      </span>\n                      <button\n                        ng-if=\"!inHouseJobsController.fetchHiddenJobs\"\n                        ng-click=\"showHideJobModal(job, $event)\"\n                        class=\"btn btn-save\"\n                      >\n                        <span class=\"fa fa-eye-slash\"></span>&nbsp;Not for me\n                        <!--<span class=\"fa fa-save\"></span>  Save-->\n                      </button>\n                      <button\n                        ng-if=\"inHouseJobsController.fetchHiddenJobs\"\n                        ng-click=\"inHouseJobsController.unHidePosition(job)\"\n                        class=\"btn btn-saved\"\n                      >\n                        <span class=\"text-save fa fa-eye-slash\"\n                          ><span\n                            style='font-family:\"Lato\", \"Helvetica Neue\", Arial, sans-serif;'\n                            >&nbsp;Hidden</span\n                          ></span\n                        >\n                        <span class=\"text-unsave fa fa-eye\"\n                          ><span\n                            style='font-family:\"Lato\", \"Helvetica Neue\", Arial, sans-serif;'\n                            >&nbsp;Unhide</span\n                          ></span\n                        >\n                        <!--<span class=\"text-save\">Saved</span>-->\n                        <!--<span class=\"text-unsave\">Unsave</span>-->\n                      </button>\n                    </div>\n\n                    <div class=\"Job-id text-right margin-t5\">\n                      ID: {{job.employerId}}_{{job.id}}\n                    </div>\n                  </div>\n\n                 \n                </div>\n                <div\n                  class=\"clearfix col-md-12 col-sm-12 col-xs-12 custom-width pad-r0\"\n                >\n                  <div\n                    class=\"inner-list-inhouse clearfix hidden-xs\"\n                    ng-show=\"!job.isCollapsed && job.showButton\"\n                  >\n                    <div\n                      class=\"pull-right list-job-desc-col\"\n                      ng-if=\"inHouseJobsController.candidate.approvalStatus !== 'Locked'\"\n                    >\n\n                    <div\n                      class=\"pull-right list-job-desc-col\"\n                      ng-if=\"inHouseJobsController.candidate.approvalStatus !== 'Locked'\"\n                    >\n                      <button\n                        ng-if=\"job.externalUrl\"\n                        class=\"btn btn-info btn-job-apply margin-r3 margin-t5\"\n                        ng-click=\"inHouseJobsController.redirectToAtsLink(job)\"\n                      >\n                        <span ng-if=\"!job.Applied\" class=\"fa fa-plus\"></span>\n                        Interested\n                      </button>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div\n            class=\"custom-table-body\"\n            ng-if=\"inHouseJobsController.spinnerActive\"\n          ></div>\n          <div ng-if=\"inHouseJobsController.noJob && !inHouseJobsController.fetchHiddenJobs\">\n            <center>\n              <p class=\"inhouse-blank-slate\">\n                {{inHouseJobsController.alertOne}}<a\n                  href=\"/user-profile?tab=preferences\"\n                  style=\"color: #95288f;\"\n                  >Preferences</a\n                >{{inHouseJobsController.alertTwo}}\n              </p>\n            </center>\n          </div>\n          <div ng-if=\"inHouseJobsController.noJob && inHouseJobsController.fetchHiddenJobs\">\n            <center>\n              <p class=\"inhouse-blank-slate\">\n                You currently have no Hidden Jobs.\n              </p>\n            </center>\n          </div>\n          <!-- Firm List Item End -->\n          <footer class=\"table-footer table-dynamic bt-1\">\n            <div class=\"row\">\n              <div class=\"page-num-info\">\n                <span>\n                  Show\n                  <span class=\"ui-select select-enty-count\">\n                    <select\n                      data-ng-model=\"inHouseJobsController.numPerPage\"\n                      data-ng-options=\"num for num in inHouseJobsController.numPerPageOpt\"\n                      data-ng-change=\"inHouseJobsController.onNumPerPageChange()\"\n                    >\n                    </select>\n                  </span>\n                  entries per page\n                </span>\n              </div>\n\n              <div class=\"text-right pagination-container custom-pagination\">\n                <pagination\n                  class=\"pagination-sm\"\n                  ng-model=\"inHouseJobsController.currentPage\"\n                  total-items=\"!inHouseJobsController.fetchHiddenJobs ? inHouseJobsController.totalPositions:inHouseJobsController.hiddenPositions\"\n                  max-size=\"4\"\n                  ng-change=\"inHouseJobsController.select(inHouseJobsController.currentPage)\"\n                  items-per-page=\"inHouseJobsController.numPerPage\"\n                  rotate=\"false\"\n                  boundary-links=\"true\"\n                >\n                </pagination>\n              </div>\n            </div>\n          </footer>\n        </section>\n      </div>\n    </div>\n  </div>\n  <!-- End Container -->\n\n  <!-- Footer -->\n  <div lexstep-footer></div>\n  <!-- Footer Ends-->\n\n  <hide-position-employer-modal\n    modal-open-handler=\"showHideJobModal\"\n    page=\"inHouseJobsController.pageName\"\n    consultant=\"user.assignedAdminDetails\"\n    on-position-hide=\"inHouseJobsController.hidePositionFromUI(position)\"\n    on-employer-hide=\"inHouseJobsController.hideEmployerFromUI(position)\"\n  >\n  </hide-position-employer-modal>\n\n  <!--Script for read more directive -->\n  <script type=\"text/ng-template\" id=\"template.html\">\n    <span ng-if=\"hmtext.length > hmlimit\">\n      <span style=\"display:block;\" ng-hide=\"hmfulltext\">\n        {{ hmtext | limitTo:hmlimit }}...\n        <a ngclass=\"{{ hmMoreClass }}\" ng-click=\"toggleValue()\">{{ hmMoreText }}</a>\n      </span>\n\n      <span style=\"display:block;\" ng-show=\"hmfulltext\">\n        {{ hmtext }}\n        <a ng-class=\"{{ hmLessClass }}\" ng-click=\"toggleValue()\">{{ hmLessText }}</a>\n      </span>\n    </span>\n\n    <span ng-if=\"hmtext.length <= hmlimit\">\n      {{ hmtext }}\n    </span>\n  </script>\n\n  <script type=\"text/ng-template\" id=\"ModalScript.html\">\n    <div class=\"modal-header\">\n      <center><h3>{{'jobApplyModalHeading'|translate}}</h3></center>\n    </div>\n\n    <div class=\"modal-body\">\n\n     <center>\n      <div class=\"row\">\n        <alert type=\"danger\" class=\"col-md-6 col-md-offset-3 alert-position\" ng-show=\"showOnError\"><strong><center>{{alertMsg}}</center></strong></alert>\n      </div>\n\n      <div class=\"row\">\n        <div class=\"col-md-3 col-md-offset-2\">\n          <img ng-src=\"{{picSrc}}\" height=\"110\" width=\"110\" alt=\"{{username}}\">\n        </div>\n        <div class=\"col-md-6 applier-detail hidden-xs\">\n          <h3 style=\"margin-top:10px\">\n            <strong>{{username}}</strong>\n          </h3>\n          <h5>{{currentEmployer}}</h5>\n          <h5>{{university}}</h5>\n        </div  class=\"hidden-xs\">\n        <center class=\"visible-xs\">\n          <div class=\"col-md-6 visible-xs\">\n            <h3 style=\"margin-top:10px\">\n              <strong>{{username}}</strong>\n            </h3>\n            <h5>{{currentEmployer}}</h5>\n            <h5>{{university}}</h5>\n          </div  class=\"visible-xs\">\n        </center class=\"visible-xs\">\n      </div>\n\n      <hr>\n\n      <div>\n        <div class=\"row\">\n          <center>\n            <div class=\"col-md-3 col-md-offset-2\">\n              <div class=\"row\">\n                <img align=\"center\" class=\"img-circle list-firm-logo\" alt=\"{{firmName}}\" height=\"50%\" width=\"30%\"\n                  ng-src=\"{{firmLogo}}\">\n                <div align=\"center\">\n                  <h4><b>{{firmName}}</b></h4>\n                </div>\n              </div>\n            </div>\n          </center>\n          <div class=\"col-md-5 applier-detail padding-l18 hidden-xs\">\n            <h4 style=\"margin-bottom:0px\"><strong>{{curJob.job_title}}</strong></h4>\n            <span>Required Experience {{curJobjob_min_pqe <= 0 ?\"NQ\":curJobjob_min_pqe}}{{curJobjob_max_pqe == 11?\"+\":\"-\"+curJobjob_max_pqe}} year(s)</span><br>\n          </div  class=\"hidden-xs\">\n          <div class=\"col-md-5 visible-xs\">\n            <center class=\"visible-xs\">\n              <h4 style=\"margin-bottom:0px\"><strong>{{curJob.job_title}}</strong></h4>\n              <span>Required Experience {{curJob.job_min_pqe <= 0 ?\"NQ\":curJob.job_min_pqe}}{{curJob.job_max_pqe == 11?\"+\":\"-\"+curJob.job_max_pqe}} year(s)</span><br>\n            </center class=\"visible-xs\">\n          </div  class=\"visible-xs\">\n        </div>\n      </div>\n      <hr ng-if=\"curLawyer.user.user_resumes.length > 0\">\n      <div class=\"row\" ng-if=\"curLawyer.user.user_resumes.length > 0\">\n        <div class=\"col-md-3 col-md-offset-2\"><h5>Select a CV to share</h5></div>\n        <div class=\"col-md-7\">\n          <span class=\"ui-select\" style=\"width:100%;\">\n            <select class=\"select-cv\"\n              style=\" min-width:0px; padding-top: 6px;padding-bottom: 6px; width:100%;\"\n              ng-model=\"selectedCv\"\n              ng-change= \"updateCV(selectedCv)\"\n              ng-options=\"cv.cv_name for cv in curLawyer.user.user_resumes track by cv.cv_ID\">\n            </select>\n          </span>\n        </div>\n      </div>\n      <hr>\n      <br>\n      <div class=\"clearfix\">\n        <span class=\"col-md-5 text-right\">Do you have the right to work in this location without sponsorship?</span>\n        <br class=\"visible-xs\">\n        <span ng-show=\"true\" ng-init=\"\" class=\"col-md-6 text-left padding-t10 display-inline-block padding-l25\">\n            <span>\n\n              <span class=\"center email-alert-on\">\n                <span ng-show=\"sponsorshipSwitch\">Yes</span>\n                <strong ng-show=\"!sponsorshipSwitch\">Yes</strong>\n              </span>\n\n              <label class=\"switch switch-info switch-sponsorship\">\n                <input ng-model=\"sponsorshipSwitch\" type=\"checkbox\" />\n                <i></i>\n              </label>\n\n              <span class=\"center email-alert-pause\">\n                <strong ng-show=\"sponsorshipSwitch\">No</strong>\n                <span ng-show=\"!sponsorshipSwitch\">No</span>\n              </span>\n\n              &nbsp;\n              &nbsp;\n              <a href=\"\" tooltip=\"Switch slider to No if you DO NOT have the right to work in this location without sponsorship\" tooltip-placement=\"top\">\n                <span class=\"badge badge-grey email-pause-info\">\n                  <i class=\"fa fa-info\"></i>\n                </span>\n              </a>\n            </span>\n          </span>\n      </div>\n     </center>\n    </div>\n\n    <div class=\"modal-footer-apply-job\">\n      <center>\n        <div class=\"apply-job-info\">\n          <span>By clicking Share Profile below you confirm that you have not applied to this employer directly or via a recruitment agency within the last 6 months.</span>\n        </div>\n        <button class=\"btn btn-info\" ng-click=\"applyToJob()\">{{'browseFirms.applyToJobPopUpBtn.label'|translate}}</button>\n        <button class=\"btn btn-default\" ng-click=\"cancel()\">{{'btn.cancel.label'|translate}}</button>\n      </center>\n    </div>\n  </script>\n\n  <script type=\"text/ng-template\" id=\"contactAdmin.html\">\n    <div class=\"modal-header\">\n      <center>\n        <h3>{{'contactAdminEmailHeading'|translate}}</h3>\n      </center>\n    </div>\n\n    <div class=\"modal-body\">\n      <div class=\"clearfix\">\n        <textarea rows=\"20\" data-ng-model=\"lawyerQuestion\" class=\n        \"col-md-12 col-xs-12 contact-admin-textarea\">\n        </textarea>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\">\n      <center>\n        <button class=\"btn btn-info\" ng-disabled=\"!lawyerQuestion\" ng-click=\n        \"submitQuestion()\">{{'contactAdminEmailBtnLabel'|translate}}</button>\n        <button class=\"btn btn-default\" ng-click=\n        \"cancel()\">{{'btn.cancel.label'|translate}}</button>\n      </center>\n    </div>\n  </script>\n</div>\n"

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"page-signin\"\n  ng-cloak\n  data-ng-controller=\"InviteFriendController as ctrl\"\n>\n  <!--mobile navbar-->\n  <div lexstep-header></div>\n  <!-- Header Ends -->\n\n  <div class=\"container\" ng-click=\"hideDropDown()\">\n    <div class=\"panel-body heading-jobs-listings row\">\n      <center>\n        <h1 class=\"text-thin hdng-tshadow margin-b0\">\n          Invite your friends to LexStep and earn £1,000s!\n        </h1>\n      </center>\n    </div>\n\n    <div class=\"panel panel-default \">\n      <div class=\"panel-body row\">\n        <div class=\"col-md-6\" ng-hide=\"ctrl.showCode\">\n          <h4 class=\"margin-t0 lead\">\n            Receive £1,000 for each friend you invite that gets hired using\n            LexStep! Take advantage of unlimited referrals to maximize your\n            potential earnings.\n          </h4>\n          <p class=\"lead\">\n            <a\n              href=\"https://www.lexstep.com/terms-conditions\"\n              class=\"text-info\"\n            >\n              Terms and Conditions</a\n            >\n            apply.\n          </p>\n          <h4 class=\"margin-t0 lead\">\n            Enter your name and email to generate a unique LexStep URL that you\n            can share:\n          </h4>\n          <alert class=\"\" type=\"danger\" ng-show=\"ctrl.showEmailInvalid\"\n            >{{'signUp.invalidEmailError'|translate}}</alert\n          >\n          <alert class=\"\" type=\"danger\" ng-show=\"ctrl.showOnError\"\n            ><center>{{ctrl.alertMsg}}</center></alert\n          >\n          <div class=\"col-md-10\">\n            <form\n              class=\"form-horizontal\"\n              name=\"inviteForm\"\n              ng-submit=\"inviteForm.$valid && ctrl.addUser()\"\n            >\n              <fieldset>\n                <div class=\"form-group\">\n                  <div class=\"input-group input-group-lg\">\n                    <span class=\"input-group-addon\">\n                      <span class=\"glyphicon glyphicon-user\"></span>\n                    </span>\n                    <input\n                      data-testid=\"first-name\"\n                      type=\"text\"\n                      class=\"form-control\"\n                      placeholder=\"Your First Name\"\n                      ng-model=\"ctrl.user.firstName\"\n                      required\n                    />\n                  </div>\n                </div>\n\n                <div class=\"form-group\">\n                  <div class=\"input-group input-group-lg\">\n                    <span class=\"input-group-addon\">\n                      <span class=\"glyphicon glyphicon-user\"></span>\n                    </span>\n                    <input\n                      data-testid=\"last-name\"\n                      type=\"text\"\n                      class=\"form-control\"\n                      placeholder=\"Your Last Name\"\n                      ng-model=\"ctrl.user.lastName\"\n                      required\n                    />\n                  </div>\n                </div>\n\n                <div class=\"form-group\">\n                  <div class=\"input-group input-group-lg\">\n                    <span class=\"input-group-addon\">\n                      <span class=\"glyphicon glyphicon-envelope\"></span>\n                    </span>\n                    <input\n                      data-testid=\"your-email\"\n                      type=\"email\"\n                      class=\"form-control\"\n                      ng-model=\"ctrl.user.email\"\n                      ng-pattern=\"pattern\"\n                      ng-blur=\"ctrl.validateEmail($event)\"\n                      placeholder=\"Your Email\"\n                      required\n                    />\n                  </div>\n                </div>\n                <div data-testid=\"invite-form\" class=\"form-group\">\n                  <button\n                    data-testid=\"get-your-link\"\n                    type=\"submit\"\n                    class=\"btn btn-info btn-lg btn-block\"\n                  >\n                    Get your link\n                  </button>\n                </div>\n              </fieldset>\n            </form>\n          </div>\n        </div>\n\n        <div class=\"col-md-6\" ng-class=\"ctrl.linkOnly\" align=\"justify\">\n          <h4 class=\"margin-t0 lead\" ng-hide=\"ctrl.showCode\">\n            Or <a href=\"/signin\" class=\"text-info\">Sign In</a> if you already\n            have a lawyer account with LexStep. If you have previously generated\n            a referral link, please re-enter your name and email address.\n          </h4>\n          <div ng-hide=\"ctrl.showCode\">\n            <div class=\"row\">\n              <div class=\"col-md-5\">\n                <center>\n                  <img\n                    src=\"images/dina-fahmy.png\"\n                    class=\"referral-quote-image img-circle\"\n                  />\n                  <h4 class=\"text-center\">Dina Fahmy</h4>\n                  <p class=\"text-center\">Associate at Powell Gilbert LLP</p>\n                </center>\n              </div>\n              <div class=\"col-md-7\">\n                <h4 class=\"lead referral-quote-text\">\n                  <i class=\"fa fa-quote-left quotes\"></i> LexStep is a great\n                  initiative! I will continue to spread the word, and hope that\n                  more and more candidates can find a suitable fit this way. My\n                  £1,000 referral bonus is going towards some holidays coming\n                  up!\n                </h4>\n              </div>\n            </div>\n          </div>\n          <div\n            class=\"row\"\n            ng-show=\"ctrl.showCode\"\n            ng-click=\"ctrl.hideDropDown()\"\n          >\n            <section class=\"refer-section\">\n              <br />\n              <div class=\"col-md-12\" align=\"justify\">\n                <h2 class=\"options\">\n                  <strong>How to refer your friends:</strong>\n                </h2>\n                <div class=\"information\">\n                  <p class=\"lead\">\n                    Here is your unique referral link:\n                    <b\n                      ><a\n                        style=\" text-decoration: none;\"\n                        ng-href=\"{{ctrl.dataLink}}\"\n                        target=\"_blank\"\n                        class=\"text-info refer-message\"\n                        >{{ctrl.dataLink}}</a\n                      ></b\n                    >.\n                  </p>\n\n                  <p class=\"lead\">\n                    Anyone who registers with LexStep via this link will be\n                    tracked to your account and we will send you £1,000 for each\n                    friend that finds a new role!\n                  </p>\n                </div>\n\n                <div class=\"options\">\n                  <div class=\"first-step\">\n                    <h3 class=\"options-heading\">\n                      Option 1. Copy and share your personalised link below\n                    </h3>\n                    <div class=\"clearfix clip-board\">\n                      <div class=\"col-md-5 col-sm-6 col-xs-11 steps\">\n                        <input\n                          data-testid=\"referal-link-field\"\n                          type=\"text\"\n                          id=\"ref-code\"\n                          class=\"form-control ng-pristine ng-invalid ng-invalid-required ng-valid-email\"\n                          ng-model=\"ctrl.dataLink\"\n                          required=\"\"\n                        />\n                      </div>\n                      <div class=\"col-md-3 steps\">\n                        <button\n                          clipboard\n                          text=\"ctrl.textToCopy\"\n                          on-copied=\"ctrl.copySuccess()\"\n                          on-error=\"ctrl.copyFail(err)\"\n                          class=\"btn btn-w-md btn-info btn-default margin-r15\"\n                        >\n                          Copy to Clipboard\n                        </button>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"third-step\">\n                    <h3 class=\"options-heading\">\n                      Option 2. We send an email on your behalf\n                    </h3>\n                    <div\n                      class=\"clearfix clip-board\"\n                      ng-repeat=\"friend in ctrl.friendsList track by $index\"\n                    >\n                      <div class=\"col-md-4 col-sm-5 col-xs-11 steps\">\n                        <input\n                          data-testid=\"friend-name\"\n                          type=\"text\"\n                          class=\"info-inputs form-control ng-pristine\"\n                          ng-model=\"friend.name\"\n                          placeholder=\"Name\"\n                        />\n                      </div>\n\n                      <div class=\"col-md-4 col-sm-5 col-xs-11 steps\">\n                        <input\n                          data-testid=\"friend-email\"\n                          type=\"email\"\n                          class=\"info-inputs form-control ng-pristine ng-invalid ng-invalid-required ng-valid-email\"\n                          ng-model=\"friend.email\"\n                          placeholder=\"Enter email address\"\n                          ng-change=\"showOnError = false;\"\n                          required=\"\"\n                        />\n                      </div>\n\n                      <div\n                        class=\"col-md-4 col-sm-2 col-xs-1 finish-btn\"\n                        ng-hide=\"ctrl.friendsList.length < 2\"\n                        ng-click=\"ctrl.removeFriend(friend)\"\n                      >\n                        <a\n                          href=\"\"\n                          id=\"edit-phone\"\n                          class=\"btn btn-noline-info btn-xs\"\n                          ng-click=\"editPhone = false; cancelPhone()\"\n                          ><i\n                            data-testid=\"cancel\"\n                            class=\"fa fa-times refer-close\"\n                          ></i\n                        ></a>\n                      </div>\n                    </div>\n                    <div class=\"row \">\n                      <div class=\"col-md-4 col-xs-6 steps\">\n                        <button\n                          data-testid=\"add-another-friend\"\n                          type=\"button\"\n                          class=\"btn btn-link\"\n                          ng-click=\"ctrl.anotherFriend()\"\n                          ng-disabled=\"ctrl.friendsList.length === 5\"\n                        >\n                          + Add another friend\n                        </button>\n                      </div>\n\n                      <div class=\"col-md-4 col-xs-6\">\n                        <p class=\"new\">(Up to 5)</p>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div\n                  style=\"margin-top: 6px; margin-left: -18px\"\n                  class=\"clearfix\"\n                >\n                  <div class=\"col-md-12\">\n                    <p\n                      class=\"send-button-state-info\"\n                      ng-show=\"!ctrl.isFriendsListFilled()\"\n                    >\n                      Please enter valid email(s)\n                    </p>\n                    <button\n                      class=\"btn btn-info\"\n                      ng-click=\"ctrl.sendReferEmail()\"\n                      ng-disabled=\"!ctrl.isFriendsListFilled()\"\n                    >\n                      Send Email\n                    </button>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"col-md-offset-2 col-md-8\">\n                <h6>&nbsp;</h6>\n              </div>\n            </section>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <!-- Footer -->\n  <div lexstep-footer></div>\n</div>\n"

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-signin\" data-ng-controller=\"jobApplicationHistoryCtrl as applicationHistory\">\n\n  <div lexstep-header></div>\n\n  <i class=\"fa fa-arrow-left fa-2x padding-tl1020 pointer\" aria-hidden=\"true\" ng-click=\"navigateToEmailListing()\"></i>\n  <div class=\"container-fluid\" ng-click=\"hideDropDown()\">\n\n      <div class=\"panel-body heading-jobs-listings row\">\n        <center>\n            <h1 class=\"text-thin hdng-tshadow\">Email History</h1>\n        </center>\n      </div>\n\n      <div class=\"panel panel-default\" ng-show=\"true\">\n\n        <!--listings div starts-->\n        <section class=\"panel-body margin-b50\">\n\n          <div class=\"panel-body heading-jobs-listings row\">\n            <center>\n                <h2 class=\"margin-t0\">Job Application Email</h2>\n            </center>\n          </div>\n\n          <div class=\"responsive-table table-dynamic\">\n            <!--table for lawyer listing-->\n            <table class=\"table table-bordered table-responsive admin-firms-table\">\n              <thead>\n                <tr>\n                  <th style=\"width: 5%\"><div class=\"th\">\n                      No.\n                      <span class=\"glyphicon glyphicon-chevron-up\"\n                            data-ng-click=\" order('email_history_ID', 'asc') \"\n                            data-ng-class=\"{active: sortBy == 'email_history_ID_asc'}\"></span>\n                      <span class=\"glyphicon glyphicon-chevron-down\"\n                            data-ng-click=\" order('email_history_ID', 'desc') \"\n                            data-ng-class=\"{active: sortBy == 'email_history_ID_desc'}\"></span>\n                  </div></th>\n                  <th style=\"width: 15%\"><div class=\"th\">\n                      Time Stamp\n                      <span class=\"glyphicon glyphicon-chevron-up\"\n                            data-ng-click=\" order('createdAt', 'asc') \"\n                            data-ng-class=\"{active: sortBy == 'createdAt_asc'}\"></span>\n                      <span class=\"glyphicon glyphicon-chevron-down\"\n                            data-ng-click=\" order('createdAt', 'desc') \"\n                            data-ng-class=\"{active: sortBy == 'createdAt_desc'}\"></span>\n                  </div></th>\n                  <th ><div class=\"th\">\n                      Subject\n                      <span class=\"glyphicon glyphicon-chevron-up\"\n                            data-ng-click=\" order('email_subject', 'asc') \"\n                            data-ng-class=\"{active: sortBy == 'email_subject_asc'}\"></span>\n                      <span class=\"glyphicon glyphicon-chevron-down\"\n                            data-ng-click=\" order('email_subject', 'desc') \"\n                            data-ng-class=\"{active: sortBy == 'email_subject_desc'}\"></span>\n                  </div></th>\n                  <th style=\"width: 1%\"><div class=\"th\">\n                      To\n                      <span class=\"glyphicon glyphicon-chevron-up\"\n                            data-ng-click=\" order('email_to', 'asc') \"\n                            data-ng-class=\"{active: sortBy == 'email_to_asc'}\"></span>\n                      <span class=\"glyphicon glyphicon-chevron-down\"\n                            data-ng-click=\" order('email_to', 'desc') \"\n                            data-ng-class=\"{active: sortBy == 'email_to_desc'}\"></span>\n                  </div></th>\n                  <th style=\"width: 25%\"><div class=\"th\">\n                      From\n                      <span class=\"glyphicon glyphicon-chevron-up\"\n                            data-ng-click=\" order('email_from', 'asc') \"\n                            data-ng-class=\"{active: sortBy == 'email_from_asc'}\"></span>\n                      <span class=\"glyphicon glyphicon-chevron-down\"\n                            data-ng-click=\" order('email_from', 'desc') \"\n                            data-ng-class=\"{active: sortBy == 'email_from_desc'}\"></span>\n                  </div></th>\n                  <th style=\"width: 5%;\"><div class=\"th\">\n                      Action\n                  </div></th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr ng-repeat=\"email in currentPageItems\">\n\n                  <td>{{email.email_history_ID}}</td>\n                  <td>{{email.createdAt |date:\"dd-MM-yyyy HH:mm\"}}</td>\n                  <td>{{email.email_subject}}</td>\n                  <td>{{email.email_to}}</td>\n                  <td>{{email.email_from}}</td>\n                  <td class=\"nowrap\">\n                    <center>\n                      <button class=\"btn btn-info btn-xs\" id=\"view-lawyer\"\n                      ng-click=\"viewJobApplicationEmail(email.email_history_ID)\"\n                      ng-right-click = \"viewJobApplicationEmail(email.email_history_ID)\"\n                      >View</button>\n                    </center>\n                  </td>\n\n                </tr>\n              </tbody>\n            </table>\n          </div>\n\n          <footer class=\"table-footer table-dynamic\">\n            <div class=\"row\">\n              <span us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\" spinner-key=\"spinner-1\"></span>\n              <div class=\"page-num-info\">\n                <span>\n                  Show\n                  <span class=\"ui-select select-enty-count\">\n                      <select data-ng-model=\"numPerPage\"\n                              data-ng-options=\"num for num in numPerPageOpt\"\n                              data-ng-change=\"onNumPerPageChange()\">\n                      </select>\n                  </span>\n                  entries per page\n                </span>\n              </div>\n\n              <div class=\"text-right pagination-container custom-pagination\">\n                <pagination class=\"pagination-sm\"\n                  ng-model=\"currentPage\"\n                  total-items=\"totalEmailHistoryList\"\n                  max-size=\"4\"\n                  ng-change=\"select(currentPage)\"\n                  items-per-page=\"numPerPage\"\n                  rotate=\"false\"\n                  boundary-links=\"true\">\n                </pagination>\n              </div>\n            </div>\n          </footer>\n        </section>\n      </div>\n\n  </div>\n\n</div>"

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-signin\" data-ng-controller=\"viewApplicationBodyCtrl as applicationHistory\">\n\n  <div lexstep-header></div>\n\n  <i class=\"fa fa-arrow-left fa-2x padding-tl1020 pointer\" aria-hidden=\"true\" ng-click=\"backButton()\"></i>\n  <div class=\"container\" ng-click=\"hideDropDown()\">\n      <div class=\"panel-body heading-jobs-listings row\">\n        <center>\n            <h1 class=\"text-thin hdng-tshadow\">Email History</h1>\n        </center>\n      </div>\n\n      <div class=\"panel panel-default\" ng-show=\"true\">\n\n        <!--listings div starts-->\n        <section class=\"panel-body margin-b50\">\n\n          <div class=\"container jobApplicationEmailDetalBox\">\n            <strong class=\"\">\n              <span class=\"col-md-5\">From: {{email.email_from}}</span> <span>Via amazonses.com</span><br>\n              <span class=\"col-md-5\">To: {{email.email_to}}</span> <span>Date: {{email.createdAt | date: \"EEE, MMM dd, yyyy 'at' h:mma\"}}</span><br>\n              <span class=\"col-md-12\">Subject: {{email.email_subject}}</span><br>\n              <span class=\"col-md-5\">Mailed-by: eu-west-1.amazonses.com</span> <span>Signed-by: amazonses.com</span><br>\n            </strong>\n          </div>\n\n          <div class=\"panel-body heading-jobs-listings row\">\n            <div class=\"padding-l40\" ng-bind-html=\"emailContent\"></div>\n            <center>\n              <div>\n                <strong>\n                  <a ng-show=\"true\" href=\"javascript://\" ng-click=\"downloadCV()\" class=\"job-application-view-cv-link\">\n                  {{email.cv_name}}\n                  <span class=\"glyphicon glyphicon-save\"/>\n                  </a>\n                </strong>\n              </div>\n            </center>\n          </div>\n\n        </section>\n      </div>\n\n  </div>\n\n</div>"

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-signin\" data-ng-controller=\"JobCreateCtrl as jobCreator\">\n    <div lexstep-header></div>\n\n    <div class=\"container\" ng-click=\"hideDropDown()\">\n\n            <div class=\"panel-body heading-jobs-listings row\">\n                <center >\n\t                <h1 class=\"text-thin hdng-tshadow\">Add Position</h1>\n                </center>\n            </div>\n\n     <div class=\"panel panel-default\">\n      \t  <div class=\"panel-body\">\n                 <form name=\"jobForm\" class=\"form-horizontal job-creation\">\n                            <br>\n                            <!-- Firm name -->\n                            <div class=\"row\">\n                                <div ng-show = \"newJobData.firmCategory == 2\" class=\"h5 col-md-4 text-right\">Employer Name *</div>\n                                <div ng-show = \"newJobData.firmCategory != 2\" class=\"h5 col-md-4 text-right\">Firm Name *</div>\n                                <div class=\"col-md-5\">\n                                    <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n                                            <select data-testid=\"select-firm-name\" ng-model=\"newJobData.firm\" ng-change=\"mapAddress();\" required\n                                            ng-options=\"firm.firm_Name group by firm.group for firm in firmNames | orderBy:['-group','firm_Name']\">\n                                                <option></option>\n                                            </select>\n                                    </span>\n                                </div>\n                            </div>\n                            <br>\n                            <!-- Practice areas -->\n                            <div class=\"row\">\n                                <div class=\"h5 col-md-4 text-right\">Practice Areas *</div>\n                                <div class=\"col-md-6 text-left\" ng-show=\"!editPractices  && showPracticeButton\">\n                                  <button data-testid=\"job-practice-area\" class=\"btn btn-line-info\" ng-click=\"openPracticeModal($event)\">Click to specify</button>\n                                </div>\n                                <div class=\"divider clearfix\"></div>\n                                <div class=\"col-md-5 text-left\" ng-show=\"editPractices \">\n                                    <ul id=\"taglist\" class=\"list-inline list-practice-area margin-b0\">\n                                        <li class=\"tags-box\" ng-if = \"area.isSelected && !area.hasChild\" ng-repeat=\"area in areasToShow\">{{area.practice_name}}</li>\n                                        <a href=\"\"class=\"fa fa-pencil\" ng-click=\"openPracticeModal($event)\"></a>\n                                    </ul>\n                                </div>\n                            </div>\n                                <br>\n\n                                <!-- job title -->\n                                <div class=\"row\">\n                                    <div class=\"h5 col-md-4 text-right\">Job Title *</div>\n                                    <div class=\"col-md-5\">\n                                        <input type=\"text\"\n                                        data-testid=\"job-title\"\n                                        autocomplete=\"off\"\n                                        class=\"form-control\"\n                                        placeholder=\"Job Title\"\n                                        data-ng-model=\"newJobData.title\"\n                                        required>\n                                    </div>\n                                </div>\n                                <br>\n                                <div class=\"row\">\n                                  <div class=\"h5 col-md-4 text-right\">Locations *</div>\n                                    <div class=\"col-md-6 text-left\" ng-show=\"!editLocations\">\n                                      <button data-testid=\"job-location\"  class=\"btn btn-line-info\" id=\"select-locations\" ng-click=\"openModal($event)\">Click to specify</button>\n                                    </div>\n                                    <div class=\"divider clearfix\"></div>\n                                    <div class=\"col-md-5 text-left\" ng-show=\"editLocations\">\n                                        <ul id=\"taglist\" class=\"list-inline list-practice-area margin-b0\">\n                                            <li class=\"tags-box\" ng-if = \"location.isSelected && !location.hasChild\" ng-repeat=\"location in locations\">{{location.loc_name}}</li>\n                                            <a href=\"\" class=\"fa fa-pencil\" id=\"select-locations\" ng-click=\"openModal($event)\"></a>\n                                        </ul>\n                                    </div>\n                                </div>\n                                <br>\n\n                                <!-- Address -->\n                                <div class=\"row\">\n                                  <div class=\"h5 col-md-4 text-right\" >Address</div>\n                                  <div class=\"col-md-5\">\n                                    <input type=\"text\"\n                                    data-testid=\"job-address\"\n                                    autocomplete=\"off\"\n                                    placeholder=\"Address\"\n                                    class=\"form-control\"\n                                    ng-model=\"newJobData.job_Address\"\n                                    >\n                                    <!-- <div class=\"space\"></div> -->\n                                  </div>\n                                </div>\n                                <br>\n                                <div class=\"row\">\n                                    <div class=\"h5 col-md-4 text-right\">Job Expires on </div>\n\n                                    <div class=\"col-md-5\" name=\"pqe\" data-ng-controller=\"DatepickerDemoCtrl\">\n                                        <div data-testid=\"job-expiry-date\" class=\"input-group add-new-job-ui-datepicker\">\n                                            <input type=\"text\"                                            \n                                            disabled\n                                            placeholder=\"Job Expiry date\"\n                                            class=\"form-control custom-readonly\"\n                                            uib-datepicker-popup=\"{{format}}\"\n                                            ng-model=\"newJobData.expireDate\"\n                                            is-open=\"opened\"\n                                            datepicker-options=\"dateOptions\"\n                                            date-disabled=\"disabled(date, mode)\"\n                                            close-text=\"Close\">\n                                            <span class=\"input-group-addon\" ng-click=\"open($event)\">\n                                                <i class=\"fa fa-calendar\"></i>\n                                            </span>\n                                        </div>\n                                    </div>\n                                </div>\n                                <br><br>\n\n                                <div class=\"row\">\n                                  <div class=\"h5 col-md-4 text-right\" >Required Experience *</div>\n                                  <div class=\"col-md-5\">\n                                    <input data-testid=\"job-pqe\" ng-model=\"newJobData.pqe\" ng-change=\"pqeChange()\" autocomplete=\"off\" type=\"text\" id=\"mySlider1\" slider options=\"options\" />\n                                    <div class=\"space\"></div>\n                                  </div>\n                                 </div>\n                                <br> \n                                <div class=\"row\">\n                                    <div class=\"h5 col-md-4 text-right\" >Contract: *</div>\n                                    <div class=\" col-md-5\">\n                                        <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\" >\n                                          <select data-testid=\"job-contract\" data-ng-model=\"newJobData.jobContract\" style=\"padding: 8px 10px; width: 100%;\" required>\n                                            <option ng-repeat=\"contract in refContracts\" ng-value=\"{{contract.contract_ID}}\">{{contract.contract_name}}</option>\n                                          </select>\n                                        </span>\n                                      </div>\n                                </div>\n                                <br>\n                                <div class=\"row\">\n                                    <div class=\"h5 col-md-4 text-right\" >Role: *</div>\n                                    <div class=\" col-md-5\">\n                                        <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\" >\n                                          <select data-testid=\"job-role\" data-ng-model=\"newJobData.jobRole\" style=\"padding: 8px 10px; width: 100%;\" required>\n                                            <option ng-repeat=\"role in refRoles\" ng-value=\"{{role.role_ID}}\">{{role.role_name}}</option>\n                                          </select>\n                                        </span>\n                                      </div>\n                                </div>\n                                <br>\n\n                                <!-- extra field 1 -->\n                                <div class=\"row\">\n                                    <div class=\"h5 col-md-4 text-right\" >Job Description</div>\n                                    <div class=\"col-md-5\">\n                                        <div class=\"text-editor\">\n                                        <textarea data-testid=\"job-description\" name=\"jobDescription\" class=\"form-control\" ckeditor=\"editorOptions\" ng-model=\"newJobData.description\">\n                                        </textarea>\n\n                                        <p class=\"email-body-error-message\" ng-show=\"placeholdersModified\">Placeholders cannot be changed from Email body and Subject line</p>\n                                      </div>\n                                       </div>\n                                </div>\n                                <br>\n\n                                <div class=\"row\">\n                                    <div class=\"h5 col-md-4 text-right margin-t0\" >Listing Type</div>\n                                    <div class=\"col-md-5\">\n                                        <dd>\n                                            <label class=\"ui-radio\"><input data-testid=\"job-category\" name=\"job_category\" type=\"radio\" ng-value=\"1\" ng-model=\"newJobData.jobCategory\" checked><span>Regular</span></label>\n                                            <label class=\"ui-radio\"><input data-testid=\"job-category\" name=\"job_category\" type=\"radio\" ng-value=\"2\" ng-model=\"newJobData.jobCategory\" ><span>Custom</span></label>\n\n                                            <label class=\"ui-radio\"><input data-testid=\"job-category\" name=\"job_category\" type=\"radio\" ng-value=\"3\" ng-model=\"newJobData.jobCategory\" ><span>Connect</span></label>\n\n                                            <label class=\"ui-radio\"><input data-testid=\"job-category\" name=\"job_category\" type=\"radio\" ng-value=\"4\" ng-model=\"newJobData.jobCategory\" ><span>Speculative</span></label>\n\n                                            <label class=\"ui-radio\" ng-show=\"newJobData.firmCategory == 2\"><input data-testid=\"job-category\" name=\"job_category\" type=\"radio\" ng-value=\"5\" ng-model=\"newJobData.jobCategory\" ><span>ATS Direct Link</span></label>\n                                        </dd>\n                                    </div>\n\n                                </div>\n\n                     <div ng-show = \"newJobData.jobCategory == 1\" class=\"row\">\n                         <div class=\"h5 col-md-4 text-right\" >Regular ATS Link</div>\n                         <div class=\"col-md-5\">\n                             <input data-testid=\"job-reference\" ng-disabled=\"newJobData.jobCategory != 1\" type=\"text\"\n                                    autocomplete=\"off\"\n                                    placeholder=\"Enter your link..\"\n                                    class=\"form-control\"\n                                    ng-model=\"newJobData.reference\"\n                             >\n                         </div>\n                     </div>\n\n                                <div ng-show = \"newJobData.jobCategory == 5\" class=\"row\">\n                                  <div class=\"h5 col-md-4 text-right\" >ATS Direct Link *</div>\n                                  <div class=\"col-md-5\">\n                                    <input data-testid=\"job-atsLink\" ng-disabled=\"newJobData.jobCategory != 5\" type=\"text\"\n                                    autocomplete=\"off\"\n                                    placeholder=\"Enter your link..\"\n                                    class=\"form-control\"\n                                    ng-model=\"newJobData.ATS_link\"\n                                    ng-required = \"newJobData.jobCategory == 5\"\n                                    >\n                                  </div>\n                                </div>\n                                <br ng-show = \"newJobData.jobCategory == 5 || newJobData.jobCategory == 1\">\n                                <div class=\"row\">\n                                    <div class=\"h5 col-md-4 text-right\">Job Visibility *</div>\n                                    <div class=\" col-md-5\">\n                                        <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n                                            <select data-testid=\"job-visibility\" data-ng-model=\"newJobData.visibility\" style=\"padding: 8px 10px; width: 100%;\" required>\n                                                <option ng-value='' selected style='display:none;'>Visibility</option>\n                                                <option ng-selected=\"newJobData.visibility == true\" ng-value=\"true\">Visible to Applicants</option>\n                                                <option ng-selected=\"newJobData.visibility == false\" ng-value=\"false\">Invisible to Applicants</option>\n                                            </select>\n                                        </span>\n                                     </div>\n                                </div>\n                                <br>\n\n\n                                <!-- submit button -->\n                                <div class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <center>\n                                        <input data-testid=\"job-creation\"  type=\"submit\" class=\"btn btn-success\" value=\"Create\" ng-click=\"jobForm.$valid && addJob()\"/>\n                                        <a data-testid=\"job-cancel\"  class=\"btn btn-default\" href=\"/admin/admin-listings?list=jobs\">Cancel</a>\n                                    </center>\n                                \t</div>\n                            \t</div>\n                        </form>\n            </div>\n        </div>\n     </div>\n\n\n\n\n  <!-- Footer -->\n  <footer class=\"footer\">\n    <div class=\"container\">\n      <div ng-include src = \"'views/pages/admin-footer.html'\"></div>\n    </div>\n    <!-- / .container -->\n  </footer>\n\n\n      <!--Template for the lawyer's action Modal-->\n<script type=\"text/ng-template\" id=\"SelectPracticesModal.html\">\n    <div class=\"modal-header\">\n        <center><h3>Select Practice Areas</h3>\n                <h5 hidden>Sub heading section</h5>\n        </center>\n    </div>\n\n    <div class=\"modal-body\">\n      <div class=\"row custom-modal\">\n        <div class=\"col-md-12\">\n                <div class=\"\" data-ng-repeat = \"law_area in data\">\n        <span ng-class=\"{'no-child': law_area.practices.length === 0}\"><i ng-hide=\"law_area.showSubPracticeAreas || law_area.practices.length === 0\" ng-click=\"displaySubPracticeAreas(law_area)\" class=\"fa fa-plus expand-collapse-button\" aria-hidden=\"true\"></i>\n        </span>\n        <span ng-class=\"{'no-child': law_area.practices.length === 0}\"><i ng-hide=\"!law_area.showSubPracticeAreas\" ng-click=\"hideSubPracticeAreas(law_area)\" class=\"fa fa-minus expand-collapse-button\" aria-hidden=\"true\"></i>\n        </span>\n        <label class=\"ui-checkbox\">\n            <input type=\"checkbox\" ng-click=\"selectPractices($event , law_area , 2)\" data=\"{{practice_ID}}\" ng-checked=\"law_area.isSelected\">\n            <span class=\"checkbox-group-heading\" ng-style=\"law_area.practices.length > 0 && {'font-weight': 'bold'}\">{{law_area.practice_name}}</span>\n        </label>\n        <ul ng-show=\"law_area.showSubPracticeAreas\" class=\" practice-area-list clearfix\">\n            <li data-ng-repeat=\"practice in law_area.practices\">\n                <label class=\"ui-checkbox\">\n                    <input type=\"checkbox\"\n                        data=\"{{practice.loc_ID}}\"\n                        ng-click=\"selectPractices($event , practice , 1)\"ng-style=\"law_area.practices.length > 0 && {'font-weight': 'bold'}\"\n                        ng-checked=\"practice.isSelected\"\n                    >\n                    <span>{{practice.practice_name}}</span>\n                </label>\n              <ul class=\" sub-list clearfix\">\n                <li data-ng-repeat = \"sub in practice.sub_areas\">\n                    <label class=\"ui-checkbox\">\n                        <input type=\"checkbox\"\n                            ng-click=\"selectPractices($event , sub , 0)\"\n                            ng-checked=\"sub.isSelected\">\n                        <span>{{sub.practice_name}}</span>\n                    </label>\n                  </li>\n              </ul>\n            </li>\n        </ul>\n      </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <center>\n          <button class=\"btn btn-info\" ng-click=\"save()\">Save</button>\n          <button class=\"btn btn-gap-v btn-default\" ng-click=\"cancel()\">Cancel</button>\n        </center>\n    </div>\n  </script>\n\n  <script type=\"text/ng-template\" id=\"AddJobModal.html\">\n    <div class=\"modal-header\">\n      <center>\n        <h3>{{heading|translate}}</h3>\n        <h5>{{subHeading|translate}}</h5>\n        Show locations\n      </center>\n    </div>\n\n    <div class=\"modal-body\">\n      <div class=\"modal-row custom-modal\" ng-show=\"showLocations\">\n    <div class=\"col-md-12\">\n        <div class=\"\" data-ng-repeat = \"region in data | orderBy: 'loc_ID'\">\n          <span><i ng-hide=\"region.showChildLocations\" data-ng-click=\"displayChildLocations(region)\" class=\"fa fa-plus expand-collapse-button\" aria-hidden=\"true\"></i>\n          </span>\n          <span><i ng-hide=\"!region.showChildLocations\" ng-click=\"hideChildLocations(region)\" class=\"fa fa-minus expand-collapse-button\" aria-hidden=\"true\"></i>\n          </span>\n          <label class=\"ui-checkbox\">\n              <input type=\"checkbox\" ng-click=\"selectLocation($event , region , 2)\" data=\"{{loc_ID}}\" ng-checked=\"region.isSelected\">\n              <span class=\"checkbox-group-heading\"><strong>{{region.loc_name}}</strong></span>\n          </label>\n          <ul class=\" practice-area-list clearfix\" ng-show=\"region.showChildLocations\">\n              <li data-ng-repeat=\"location in region.locations\">\n                  <label class=\"ui-checkbox\">\n                      <input type=\"checkbox\"\n                          data=\"{{location.loc_ID}}\"\n                          ng-click=\"selectLocation($event , location , 1)\"\n                          ng-checked=\"location.isSelected\"\n                      >\n                      <span>{{location.loc_name}}</span>\n                  </label>\n                <ul class=\" sub-list clearfix\">\n                  <li data-ng-repeat = \"sub in location.sub_areas\">\n                      <label class=\"ui-checkbox\">\n                          <input type=\"checkbox\"\n                              ng-click=\"selectLocation($event , sub , 0)\"\n                              ng-checked=\"sub.isSelected\">\n                          <span>{{sub.loc_name}}</span>\n                      </label>\n                    </li>\n                </ul>\n              </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n    </div>\n    <div class=\"modal-footer\">\n        <center>\n          <button class=\"btn btn-info\" ng-click=\"save()\">Save</button>\n          <button class=\"btn btn-gap-v btn-default\" ng-click=\"cancel()\">Cancel</button>\n        </center>\n    </div>\n  </script>\n</div>\n"

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-signin\" data-testid=\"job-edit-component\" ng-cloak data-ng-controller=\"JobEditCtrl as jobEditor\">\n\n<div lexstep-header></div>\n\n<div class=\"container\" ng-click=\"hideDropDown()\">\n\t<div class=\"panel-body heading-jobs-listings row\">\n    <center >\n        <h1 class=\"text-thin hdng-tshadow\">{{pageTitle}}</h1>\n    </center>\n  </div>\n\n  <!-- nav bar row-->\n  <div class=\"row\" style=\"padding: 0 15px;\">\n    <alert type=\"success\" class=\"col-md-12\" ng-show=\"showOnSuccess\"><center><strong>{{alertMsg}} </strong></center></alert>\n    <alert type=\"danger\"  class=\"col-md-12\" ng-show=\"showOnError\"><center><strong>{{alertMsg}} </strong></center></alert>\n  </div>\n\n  <div class=\"panel panel-default\">\n\t  <div class=\"panel-body\">\n      <form name=\"job-creation-form\" class=\"form-horizontal job-creation\">\n        <br>\n        <!-- Firm name -->\n        <div class=\"row\">\n        \t<div class=\"col-md-3 text-center mobile-show\" data-testid=\"job-edit-delete\">\n            <button class=\"btn btn-danger\" ng-hide=\"isCloneJob\" ng-disabled=\"isDeleted\" ng-click=\"jobEditor.deleteJob(); $event.preventDefault();$event.stopPropagation();\">Delete Job</button>\n          </div>\n          <div ng-show = \"updatedJob.firm.refCategoryCatID == 2\" class=\"h5 col-md-4 text-right\" >Employer Name *</div>\n          <div ng-show = \"updatedJob.firm.refCategoryCatID != 2\" class=\"h5 col-md-4 text-right\" >Firm Name *</div>\n          <div class=\"col-md-5\" data-testid=\"job-edit-firm\">\n              <span class=\"ui-select firm-name\" style=\"margin-left: 0; width: 60%;\" >\n                <select required\n                ng-options=\"firm.firm_Name group by firm.firm_Visibility for firm in firms\"\n                data-ng-model=\"updatedJob.firm\"\n                style=\"padding: 8px 10px; width: 100%;\"\n                ng-change=\"mapAddress();\"\n                ng-disabled=\"isCloneJob\">\n                    <option value='' disabled selected style='display:none;'>{{curFirm.name}}</option>\n\n                </select>\n              </span>\n          </div>\n          <div class=\"col-md-3 text-center mobile-hide\">\n            <button class=\"btn btn-danger\" ng-hide=\"isCloneJob\" ng-disabled=\"isDeleted\" ng-click=\"jobEditor.deleteJob()\">Delete Job</button>\n          </div>\n          <span class=\"spinner-static-center\" us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\" spinner-key=\"spinner-2\"></span>\n        </div>\n        <br>\n        <!-- practice areas -->\n        <div class=\"row\" data-testid=\"job-edit-practices\">\n          <div class=\"col-md-4 h5 text-right\">Practice Areas *</div>\n          <div class=\"col-md-5 text-left\" ng-show=\"!showTags\">\n            <a href=\"\" class=\"btn btn-line-info\"  ng-click=\"openPracticeModal($event)\" >Click to specify</a> &nbsp;\n          </div>\n          <div class=\"divider clearfix\"></div>\n          <div class=\"col-md-6 text-left\" ng-show=\"showTags\">\n            <ul id=\"taglist\" class=\"list-inline list-practice-area margin-b0\">\n              <li class=\"tags-box\" ng-if=\"area.isSelected && !area.hasChild\" ng-repeat=\"area in jobPractices\">{{area.practice_name}}</li>\n              <a href=\"\"class=\"fa fa-pencil\" ng-click=\"openPracticeModal($event)\"></a>\n            </ul>\n          </div>\n        </div>\n        <br><br>\n\n        <!-- job title -->\n        <div class=\"row\" data-testid=\"job-edit-title\">\n          <div class=\"h5 col-md-4 text-right\" >Job Title *</div>\n          <div class=\"col-md-5\">\n            <input type=\"text\"\n            autocomplete=\"off\"\n            class=\"form-control\"\n            placeholder=\"Job Title\"\n            data-ng-model=\"updatedJob.job_title\"\n            required>\n          </div>\n        </div>\n        <br>\n\n        <!-- locations -->\n        <!-- <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\" >Location *</div>\n          <div class=\"col-md-5\">\n            <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\" >\n              <select data-ng-model=\"updatedJob.job_location\" style=\"padding: 8px 10px; width: 100%;\">\n                <option value='' disabled selected style='display:none;'>Location</option>\n                <option ng-repeat=\"location in locations\" ng-if=\"!location.isJurisdiction\" value=\"{{location.loc_name}}\">{{location.loc_name}}</option>\n              </select>\n            </span>\n           </div>\n        </div> -->\n        <div class=\"row\" data-testid=\"job-edit-locations\">\n          <div class=\"h5 col-md-4 text-right\">Locations *</div>\n            <div class=\"col-md-6 text-left\" ng-show=\"!editLocations\">\n              <button class=\"btn btn-line-info\" id=\"select-locations\" ng-click=\"openModal($event)\">Click to specify</button>\n            </div>\n            <div class=\"divider clearfix\"></div>\n            <div class=\"col-md-5 text-left\" ng-show=\"editLocations\">\n                <ul id=\"taglist\" class=\"list-inline list-practice-area margin-b0\">\n                    <li class=\"tags-box\" ng-if = \"location.isSelected && !location.hasChild\" ng-repeat=\"location in jobLocations\">{{location.loc_name}}</li>\n                    <a href=\"\" class=\"fa fa-pencil\" id=\"select-locations\" ng-click=\"openModal($event)\"></a>\n                </ul>\n            </div>\n        </div>\n        <br>\n        <div class=\"row\" data-testid=\"job-edit-address\">\n          <div class=\"h5 col-md-4 text-right\" >Address</div>\n          <div class=\"col-md-5\">\n            <input type=\"text\"\n            autocomplete=\"off\"\n            placeholder=\"Address\"\n            class=\"form-control\"\n            ng-model=\"updatedJob.job_Address\"\n            >\n            <!-- <div class=\"space\"></div> -->\n          </div>\n        </div>\n        <br>\n        <div class=\"row\" data-testid=\"job-edit-expiry\">\n            <div class=\"h5 col-md-4 text-right\" >Job Expires on</div>\n            <div class=\"col-md-5\" name=\"pqe\" data-ng-controller=\"DatepickerDemoCtrl\">\n              <div class=\"input-group ui-datepicker\" >\n                  <input type=\"text\"\n                  class=\"form-control custom-readonly\"\n                  disabled\n                  placeholder=\"Job Expiry date\"\n                  uib-datepicker-popup=\"{{format}}\"\n                  ng-model=\"updatedJob.last_date_to_apply\"\n                  ng-change=\"jobLastDateChanged();\"\n                  is-open=\"opened\"\n                  min=\"minDate\"\n                  max=\"'2015-06-22'\"\n                  datepicker-options=\"dateOptions\"\n                  close-text=\"Close\">\n                  <span class=\"input-group-addon\" ng-click=\"open($event)\">\n                      <i class=\"fa fa-calendar\"></i>\n                  </span>\n              </div>\n\n            </div>\n            <span class=\"btn btn-danger\"\n                ng-disabled=\"!updatedJob.last_date_to_apply\"\n                title=\"Remove Expiry Date\"\n                ng-click=\"updatedJob.last_date_to_apply = null;\">\n                <i class=\"fa fa-times\"></i>\n            </span>\n        </div>\n        <br><br>\n\n        <div class=\"row\" data-testid=\"job-edit-experience\">\n          <div class=\"h5 col-md-4 text-right\">Required Experience *</div>\n          <div class=\"col-md-5\">\n            <input ng-model=\"updatedJob.pqe\" autocomplete=\"off\" ng-change=\"pqeChange()\" type=\"text\" id=\"mySlider1\" slider options=\"options\" />\n            <div class=\"space\"></div>\n          </div>\n          <!-- <div class=\" col-md-5\">\n            <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\" >\n              <select data-ng-model=\"updatedJob.ref_job_exp.job_exp_ID\" style=\"padding: 8px 10px; width: 100%;\" required>\n                <option value='' disabled selected style='display:none;'>{{updatedJob.ref_job_exp.job_exp}}</option>\n                <option ng-repeat=\"exp in jobExp\" value=\"{{exp.job_exp_ID}}\">{{exp.job_exp}}</option>\n              </select>\n            </span>\n          </div> -->\n        </div>\n        <br>\n        <div class=\"row\" data-testid=\"job-edit-contract\">\n          <div class=\"h5 col-md-4 text-right\">Contract: *</div>\n          <div class=\" col-md-5\">\n            <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\" >\n              <select data-ng-model=\"updatedJob.refContractContractID\" style=\"padding: 8px 10px; width: 100%;\" required>\n                <option value='' disabled selected style='display:none;'>{{updatedJob.refContractContractID}}</option>\n                <option ng-repeat=\"contract in refContracts\" ng-value=\"{{contract.contract_ID}}\">{{contract.contract_name}}</option>\n              </select>\n            </span>\n          </div>\n        </div>\n        <br>\n        <div class=\"row\" data-testid=\"job-edit-role\">\n          <div class=\"h5 col-md-4 text-right\">Role: *</div>\n          <div class=\" col-md-5\">\n            <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\" >\n              <select data-ng-model=\"updatedJob.refRoleRoleID\" style=\"padding: 8px 10px; width: 100%;\" required>\n                <option value='' disabled selected style='display:none;'>{{updatedJob.refRoleRoleID}}</option>\n                <option ng-repeat=\"role in refRoles\" ng-value=\"{{role.role_ID}}\">{{role.role_name}}</option>\n              </select>\n            </span>\n          </div>\n        </div>\n        <br>\n\n        <!-- extra field 1 -->\n        <div class=\"row\" data-testid=\"job-edit-description\">\n          <div class=\"h5 col-md-4 text-right\" >Job Description</div>\n          <div class=\"col-md-5\">\n            <div class=\"text-editor\">\n            <textarea name=\"jobDescription\" class=\"form-control\" ckeditor=\"editorOptions\" ng-model=\"updatedJob.job_description\">\n            </textarea>\n<!-- <textarea ng-model=\"emailCategory.content\" name=\"\" id=\"\" class=\"form-control\" style = \"resize:none\"></textarea> -->\n\n            <p class=\"email-body-error-message\" ng-show=\"placeholdersModified\">Placeholders cannot be changed from Email body and Subject line</p>\n          </div>\n            <!-- <div text-angular text-align=\"left\" data-ng-model=\"newJobData.description\" class=\"ui-editor\" >\n            </div> -->\n            <!-- <textarea ng-model=\"newJobData.description\" rows='5' name=\"\" id=\"\" class=\"form-control\" style = \"resize:none\"></textarea> -->\n        </div>\n          <!-- <div class=\"col-md-5\">\n            <div text-angular text-align=\"left\" data-ng-model=\"updatedJob.job_description\" class=\"ui-editor\" >\n            </div>\n            <textarea ng-model=\"updatedJob.job_description\" rows='5' name=\"\" id=\"\" class=\"form-control\" style = \"resize:none\"></textarea>\n          </div> -->\n        </div>\n        <br>\n\n        <div class=\"row\" data-testid=\"job-edit-type\">\n          <div class=\"h5 col-md-4 text-right margin-t0\" >Listing Type</div>\n          <div class=\"col-md-5\">\n              <dd>\n                  <label class=\"ui-radio\"><input name=\"job_category\" type=\"radio\" value=\"1\" ng-model=\"updatedJob.jobCategory\" checked><span>Regular</span></label>\n\n                  <label class=\"ui-radio\"><input name=\"job_category\" type=\"radio\" value=\"2\" ng-model=\"updatedJob.jobCategory\" ><span>Custom</span></label>\n\n                  <label class=\"ui-radio\"><input name=\"job_category\" type=\"radio\" value=\"3\" ng-model=\"updatedJob.jobCategory\"><span>Connect</span></label>\n\n                  <label class=\"ui-radio\"><input name=\"job_category\" type=\"radio\" value=\"4\" ng-model=\"updatedJob.jobCategory\"><span>Speculative</span></label>\n\n                  <label class=\"ui-radio\" ng-show=\"updatedJob.firm.refCategoryCatID == 2\"><input name=\"job_category\" type=\"radio\" value=\"5\" ng-model=\"updatedJob.jobCategory\"><span>ATS Direct Link</span></label>\n              </dd>\n          </div>\n        </div>\n\n          <div ng-show = \"updatedJob.jobCategory == 1\" data-testid=\"job-edit-ats-link\" class=\"row\">\n              <div class=\"h5 col-md-4 text-right\" >Regular ATS Link</div>\n              <div class=\"col-md-5\">\n                  <input ng-disabled=\"updatedJob.jobCategory != 1\" type=\"text\"\n                         autocomplete=\"off\"\n                         placeholder=\"Enter your link..\"\n                         class=\"form-control\"\n                         ng-model=\"updatedJob.job_Reference\"\n                  >\n                  <!-- <div class=\"space\"></div> -->\n              </div>\n          </div>\n\n        <div ng-show = \"updatedJob.jobCategory == 5\" data-testid=\"job-edit-ats-direct\" class=\"row\">\n          <div class=\"h5 col-md-4 text-right\" >ATS Direct Link *</div>\n          <div class=\"col-md-5\">\n            <input ng-disabled=\"updatedJob.jobCategory != 5\" type=\"text\"\n            autocomplete=\"off\"\n            placeholder=\"Enter your link..\"\n            class=\"form-control\"\n            ng-model=\"updatedJob.ATS_link\"\n            ng-required = \"updatedJob.jobCategory == 5\"\n            >\n            <!-- <div class=\"space\"></div> -->\n          </div>\n        </div>\n        <br ng-show = \"updatedJob.jobCategory == 5 || updatedJob.jobCategory == 1\">\n\n        <!-- <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\" ></div>\n          <div class=\"col-md-5\">\n            <label class=\"ui-checkbox\">\n              <input type=\"checkbox\" ng-checked=\"updatedJob.isSpeculative\" ng-model=\"updatedJob.isSpeculative\">\n              <span class=\"checkbox-group-heading\">Speculative Application</span>\n            </label>\n          </div>\n        </div>\n        <br>\n\n        <div class=\"row\">\n          <div class=\"h5 col-md-4 text-right\" ></div>\n          <div class=\"col-md-5\">\n            <label class=\"ui-checkbox\">\n              <input type=\"checkbox\" ng-checked=\"updatedJob.is_connected\" ng-model=\"updatedJob.is_connected\">\n              <span class=\"checkbox-group-heading\">Connected Application</span>\n            </label>\n          </div>\n        </div>\n        <br> -->\n\n        <div class=\"row\" data-testid=\"job-edit-visibility\">\n          <div class=\"h5 col-md-4 text-right\" >Job Visibility *</div>\n          <div class=\"col-md-5\">\n            <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\" >\n              <select data-ng-model=\"updatedJob.job_is_visible\" style=\"padding: 8px 10px; width: 100%;\">\n                <option value='' disabled selected style='display:none;'>Visibility</option>\n                <option value=\"true\" ng-selected=\"updatedJob.job_is_visible\">Visible to Applicants</option>\n                <option value=\"false\" ng-selected=\"updatedJob.job_is_visible == false\">Invisible to Applicants</option>\n              </select>\n            </span>\n          </div>\n        </div>\n        <br>\n\n        <!-- submit button -->\n        <div class=\"row\" data-testid=\"job-edit-footer\">\n          <div class=\"col-md-12\">\n            <center>\n              <!-- <input type=\"submit\" class=\"btn btn-info \" value=\"Update\"> -->\n              <button class=\"btn btn-info \" ng-click=\"jobEditor.editJob()\">{{actionTitle}}</button>\n              <button class=\"btn btn-default\" ng-click=\"jobEditor.cancelEditing()\">Cancel</button>\n            </center>\n          </div>\n        </div>\n      </form>\n\t\t</div>\n  </div>\n</div>\n\n\n<!-- Footer -->\n  <footer class=\"footer\">\n    <div class=\"container\">\n      <div ng-include src = \"'views/pages/admin-footer.html'\"></div>\n    </div>\n    <!-- / .container -->\n  </footer>\n\n\n      <!--Template for the lawyer's action Modal-->\n<script type=\"text/ng-template\" id=\"SelectPracticesModal.html\">\n  <div data-testid=\"select-practice-areas-modal\">\n    <div class=\"modal-header\">\n      <center>\n          <h3>Select Practice Areas</h3>\n          <h5 hidden>Sub heading section</h5>\n      </center>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"row custom-modal\">\n          <div class=\"col-md-12\">\n            <div class=\"\" data-ng-repeat = \"law_area in data\">\n                <span ng-class=\"{'no-child': law_area.practices.length === 0}\" ><i ng-hide=\"law_area.showSubPracticeAreas || law_area.practices.length === 0\" ng-click=\"displaySubPracticeAreas(law_area)\" class=\"fa fa-plus expand-collapse-button\" aria-hidden=\"true\"></i>\n                </span>\n                <span ng-class=\"{'no-child': law_area.practices.length === 0}\" ><i ng-hide=\"!law_area.showSubPracticeAreas\" ng-click=\"hideSubPracticeAreas(law_area)\" class=\"fa fa-minus expand-collapse-button\" aria-hidden=\"true\"></i>\n                </span>\n                <label class=\"ui-checkbox\">\n                <input type=\"checkbox\" ng-click=\"selectPractices($event , law_area , 2)\" data=\"{{practice_ID}}\" ng-checked=\"law_area.isSelected\">\n                <span ng-style=\"law_area.practices.length > 0 && {'font-weight': 'bold'}\" class=\"checkbox-group-heading\">{{law_area.practice_name}}</span>\n                </label>\n                <ul ng-show=\"law_area.showSubPracticeAreas\" class=\" practice-area-list clearfix\">\n                  <li data-ng-repeat=\"practice in law_area.practices\">\n                      <label class=\"ui-checkbox\">\n                      <input type=\"checkbox\"expand-collapse-button\n                        data=\"{{practice.loc_ID}}\"\n                        ng-click=\"selectPractices($event , practice , 1)\"\n                        ng-checked=\"practice.isSelected\"\n                        >\n                      <span>{{practice.practice_name}}</span>\n                      </label>\n                      <ul class=\" sub-list clearfix\">\n                        <li data-ng-repeat = \"sub in practice.sub_areas\">\n                            <label class=\"ui-checkbox\">\n                            <input type=\"checkbox\"\n                              ng-click=\"selectPractices($event , sub , 0)\"\n                              ng-checked=\"sub.isSelected\">\n                            <span>{{sub.practice_name}}</span>\n                            </label>\n                        </li>\n                      </ul>\n                  </li>\n                </ul>\n            </div>\n          </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <center>\n          <button class=\"btn btn-info\" ng-click=\"save()\">Save</button>\n          <button class=\"btn btn-gap-v btn-default\" ng-click=\"cancel()\">Cancel</button>\n      </center>\n    </div>\n  </div>\n</script>\n\n<script type=\"text/ng-template\" id=\"deleteJobModal.html\">\n  <div class=\"modal-header\">\n    <center>\n      <h3>Delete Job</h3>\n      <h5>Are you sure you want to delete this job?</h5>\n    </center>\n  </div>\n  <div class=\"modal-footer\">\n    <center>\n      <button class=\"btn btn-info\" ng-click=\"yes()\">Yes</button>\n      <button class=\"btn btn-gap-v btn-default\" ng-click=\"no()\">No</button>\n    </center>\n  </div>\n</script>\n\n<script type=\"text/ng-template\" id=\"EditJobModal.html\" >\n  <div data-testid=\"job-edit-component\">\n    <div class=\"modal-header\">\n      <center>\n        <h3>{{heading|translate}}</h3>\n        <h5>{{subHeading|translate}}</h5>\n      </center>\n    </div>\n\n    <div class=\"modal-body\">\n      <div class=\"modal-row custom-modal\" ng-show=\"showLocations\">\n    <div class=\"col-md-12\">\n        <div class=\"\" data-ng-repeat = \"region in data | orderBy: 'loc_ID'\">\n          <span ng-hide=\"region.showChildLocations\" data-ng-click=\"displayChildLocations(region)\"><i class=\"fa fa-plus expand-collapse-button\" aria-hidden=\"true\"></i>\n          </span>\n          <span ng-hide=\"!region.showChildLocations\" ng-click=\"hideChildLocations(region)\"><i class=\"fa fa-minus expand-collapse-button\" aria-hidden=\"true\"></i>\n          </span>\n          <label class=\"ui-checkbox\">\n              <input type=\"checkbox\" ng-click=\"selectLocation($event , region , 2)\" data=\"{{loc_ID}}\" ng-checked=\"region.isSelected\">\n              <span class=\"checkbox-group-heading\"><strong>{{region.loc_name}}</strong></span>\n          </label>\n          <ul ng-show=\"region.showChildLocations\" class=\" practice-area-list clearfix\">\n              <li data-ng-repeat=\"location in region.locations\">\n                  <label class=\"ui-checkbox\">\n                      <input type=\"checkbox\"\n                          data=\"{{location.loc_ID}}\"\n                          ng-click=\"selectLocation($event , location , 1)\"\n                          ng-checked=\"location.isSelected\"\n                      >\n                      <span>{{location.loc_name}}</span>\n                  </label>\n                <ul class=\" sub-list clearfix\">\n                  <li data-ng-repeat = \"sub in location.sub_areas\">\n                      <label class=\"ui-checkbox\">\n                          <input type=\"checkbox\"\n                              ng-click=\"selectLocation($event , sub , 0)\"\n                              ng-checked=\"sub.isSelected\">\n                          <span>{{sub.loc_name}}</span>\n                      </label>\n                    </li>\n                </ul>\n              </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n    </div>\n    <div class=\"modal-footer\" data-testid=\"job-edit-footer\">\n        <center>\n          <button class=\"btn btn-info\" ng-click=\"save()\">Save</button>\n          <button class=\"btn btn-gap-v btn-default\" ng-click=\"cancel()\">Cancel</button>\n        </center>\n    </div>\n  </div>\n</script>\n\n</div>\n"

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-signin\" ng-cloak ng-init=\"showProfileAlert = true ;\">\n  <!-- widgets -->\n  <div lexstep-header></div>\n  <!-- Header Ends -->\n  <div class=\"container margin-t20\">\n    <candidate-profile />\n  </div>\n</div>\n"

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"page-signin\"\n  id=\"browse-jobs\"\n  ng-cloak\n  data-ng-controller=\"MakeMeAnOfferController as ctrl\"\n  ng-init=\"showAlert = true\"\n>\n  <!-- mobile navbar -->\n  <div lexstep-header></div>\n  <!-- Header Ends -->\n\n  <div\n    data-ng-controller=\"IsOldBrowserController as isOldBrowser\"\n    class=\"container\"\n  >\n    <div class=\"old-browser-alert\" ng-show=\"isOldBrowser.showOldBrowser\">\n      <div class=\"callout bg-warning margin-t0\" type=\"info\">\n        You are using an older version of the browser that may not support\n        LexStep features. Please\n        <a\n          target=\"_blank\"\n          class=\"text-info\"\n          href=\"http://windows.microsoft.com/en-us/internet-explorer/download-ie\"\n          >upgrade</a\n        >\n        for improved experience.\n      </div>\n    </div>\n  </div>\n\n  <div class=\"container\" ng-click=\"hideDropDown()\">\n    <div class=\"panel-body heading-jobs-listings row\">\n      <center>\n        <!--<h1 class=\"text-thin hdng-tshadow margin-b0\">Select a firm to research their teams and reveal your interest in being headhunted for special opportunities</h1>-->\n        <h1 class=\"text-thin hdng-tshadow margin-b10\">Make Me An Offer</h1>\n        <div class=\"inlineBlock\">\n          <h4 class=\"display-inline text-thin hdng-tshadow margin-b0\">\n            Reveal your LexStep Profile to Partners and GCs and they'll get back\n            to you if they're interested or when a relevant opportunity arises\n          </h4>\n          <a\n            class=\"display-inline no-text-decoration subheading-tooltip\"\n            href=\"\"\n            tooltip=\"Some firms hire on a rolling basis, outside of the formal recruiting process, and don't necessarily advertise some or all of their team's vacancies. Share your profile with an employer speculatively and they'll get back to you if they're interested or when a relevant opportunity arises.\"\n            tooltip-placement=\"bottom\"\n          >\n            <span class=\"badge badge-grey\">\n              <i class=\"fa fa-info\"></i>\n            </span>\n          </a>\n        </div>\n        <h4 class=\"text-thin hdng-tshadow margin-t20 margin-b20\">\n          <img\n            src=\"{{ctrl.candidateAgent.logoSrc}}\"\n            class=\"img-circle margin-r15\"\n            alt=\"Consultant Image\"\n            width=\"85\"\n            height=\"85\"\n          />\n\n          <div class=\"clearfix visible-xs-block\"></div>\n          <div class=\"inlineBlock\">\n            <span>\n              Contact {{ctrl.candidateAgent.firstName}}\n              {{ctrl.candidateAgent.lastName}}\n            </span>\n            <span>\n              <br class=\"visible-xs\" />\n              <span class=\"hidden-xs\">&nbsp;|&nbsp;</span>\n            </span>\n            <a href=\"mailto:{{ctrl.candidateAgent.email}}\"\n              >{{ctrl.candidateAgent.email}}</a\n            >\n            <span>\n              <br class=\"visible-xs\" />\n              <span class=\"hidden-xs\">&nbsp;|&nbsp;</span>\n            </span>\n            <a href=\"tel:{{ctrl.candidateAgent.phone}}\"\n              >{{ctrl.candidateAgent.phone}}</a\n            >\n          </div>\n        </h4>\n        <button\n          data-testid=\"redirect-matches\"\n          class=\"btn btn-info\"\n          ng-click=\"ctrl.loadMatchesJobs()\"\n        >\n          Explore My LexStep Matches\n        </button>\n        <div class=\"badge badge-info hidden\">\n          <span class=\"badge badge-info\">\n            <h5 class=\"margin-t5 margin-b5\">\n              <span>Questions? &nbsp; Give us a call:</span>\n              <span>&nbsp;{{contactPhone}}</span>\n            </h5>\n          </span>\n        </div>\n      </center>\n    </div>\n\n    <!-- Main Alert Section -->\n    <div hidden class=\"callout bg-danger\" type=\"info\">\n      <span class=\"glyphicon glyphicon-lock\"></span> &nbsp;<strong\n        class=\"ng-binding\"\n        >{{'main.alert'| translate}}</strong\n      >\n    </div>\n    <!-- Main Alert Section End -->\n\n    <!-- Get Start Section -->\n    <div class=\"row\" ng-show=\"ctrl.candidate.approvalStatus === 'Locked'\">\n      <div class=\"col-md-12\">\n        <div class=\"alert alert-danger alert-dismissable  margin-t10\">\n          <div>\n            <span\n              ><i class=\"fa fa-warning\"></i>&nbsp;Your profile has been locked\n              and is waiting for re-approval. For now you cannot apply to any\n              job or edit your profile.</span\n            >\n            <!-- <a href=\"\" class=\"fa fa-times pull-right\" ng-click=\"profileAlert = 'fadeOutDown'; crossAnimate='fadeInUp'; showProfileAlert = false\"></a> -->\n          </div>\n        </div>\n      </div>\n    </div>\n    <div\n      class=\"row animated\"\n      ng-class=\"mainAlert\"\n      ng-show=\"!ctrl.candidate.profileCvAlertCollapse && !ctrl.candidate.profilePhoneAlertCollapse\"\n    >\n      <div class=\"hidden col-md-6\">\n        <h2 class=\"ng-binding margin-t10 hidden\">\n          {{'browseFirms.GetStarted.Heading'|translate}}\n        </h2>\n        <h5>\n          {{'browseFirms.GetStarted.Greeting1'|translate}}{{'browseFirms.GetStarted.Greeting2'|translate}}\n        </h5>\n      </div>\n\n      <div class=\"col-md-12 animated\" ng-class=\"profileAlert\">\n        <div ng-show=\"ctrl.candidate.resumes.length === 0\">\n          <div\n            class=\"alert alert-danger alert-dismissable margin-t10\"\n            ng-hide=\"ctrl.candidate.profileCvAlertCollapsed\"\n            ng-class=\"\"\n          >\n            <button\n              class=\"close\"\n              type=\"button\"\n              ng-click=\"ctrl.updateProfileAlertStatus('profileCvAlertCollapsed', true)\"\n            >\n              <span aria-hidden=\"true\">×</span>\n              <span class=\"sr-only\">Close</span>\n            </button>\n            <span class=\"ng-binding ng-scope\">\n              <i class=\"fa fa-warning\"></i>\n              <span>\n                &nbsp;Upload your <b>CV</b> to connect with employers. &nbsp;\n                <a href=\"/user-profile\" class=\"text-info\"\n                  >Go to your profile page</a\n                >\n              </span>\n            </span>\n          </div>\n        </div>\n\n        <div ng-show=\"!ctrl.candidate.user.phone\">\n          <!--<div class=\" animated\">-->\n          <div\n            class=\"alert alert-danger alert-dismissable  margin-t10\"\n            ng-hide=\"ctrl.candidate.profilePhoneAlertCollapsed\"\n          >\n            <button\n              class=\"close\"\n              type=\"button\"\n              ng-click=\"ctrl.updateProfileAlertStatus('profilePhoneAlertCollapsed', true)\"\n            >\n              <span aria-hidden=\"true\">×</span>\n              <span class=\"sr-only\">Close</span>\n            </button>\n            <span class=\"ng-binding ng-scope\">\n              <i class=\"fa fa-warning\"></i>\n              <span>\n                &nbsp;Please add a <b>contact number</b> in order to be able to\n                connect with employers.\n                <a href=\"/user-profile\" class=\"text-info\"\n                  >Go to your profile page</a\n                >\n              </span>\n            </span>\n            <!-- <a href=\"\" class=\"fa fa-times pull-right\" ng-click=\"profileAlert = 'fadeOutDown'; crossAnimate='fadeInUp'; showProfileAlert = false\"></a> -->\n          </div>\n          <!--</div>-->\n        </div>\n      </div>\n    </div>\n    <!-- Get Start Section End -->\n\n    <div class=\"panel panel-default \">\n      <!---###### FIRMS LISTING #######-->\n      <div class=\"panel-body row\">\n        <!--listings div starts-->\n        <section class=\"page page-table table-dynamic\">\n          <span\n            class=\"spinner-static-center\"\n            us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n            spinner-key=\"spinner-2\"\n          >\n          </span>\n          <!-- ## FILTERS MOBILE VIEW -->\n          <div class=\"row browsefirm-filter-box firm-filter-box-mob visible-xs\">\n            <div class=\"clearfix hidden\">\n              <div class=\"col-xs-12 mob-sticky-msg\">\n                <span class=\"badge badge-info custom-badge\">\n                  <h5>\n                    <span>Questions? &nbsp; Give us a call:</span>\n                    <span>&nbsp;{{contactPhone}}</span>\n                  </h5>\n                </span>\n              </div>\n            </div>\n            <div class=\"clearfix\">\n              <div class=\"col-xs-12\">\n                <practice-Area-Dropdown\n                  width=\"true\"\n                  placeholder=\"'My Practice Areas'\"\n                  practice-areas-list=\"ctrl.candidateSpecialties\"\n                  on-practice-change=\"ctrl.OnChangePracticeArea($event,selectedPracticeArea)\"\n                ></practice-Area-Dropdown>\n              </div>\n              <div class=\"col-xs-12 filter-mt\">\n                <locations-Dropdown\n                  width=\"true\"\n                  placeholder=\"'My Target Locations'\"\n                  locations-list=\"ctrl.candidateLocations\"\n                  regions-list=\"ctrl.regionHierarchialListWithEuropeOnTop\"\n                  on-location-change=\"ctrl.onChangeLocation($event,selectedLocation)\"\n                ></locations-Dropdown>\n              </div>\n\n              <div\n                class=\"col-xs-12 job-switch-fillter hidden-jobs-switch-inhouse margin-t5 switch-mt\"\n              >\n                <div class=\"text-center\">\n                  <span\n                    ng-class=\"{'pull-right': curLawyer.profileCvAlertCollapsed === false && curLawyer.profilePhoneAlertCollapsed === false}\"\n                  >\n                    <span class=\"text-switch-all hidden-jobs-switch-inhouse\"\n                      >All({{(ctrl.totalPositions && ctrl.totalPositions > 0)?\n                      ctrl.totalPositions: 0}}<span\n                        ng-if=\"ctrl.countRefreshReq === true\"\n                        >*</span\n                      >)\n                    </span>\n                    <label class=\"switch switch-info\">\n                      <input\n                        ng-change=\"ctrl.hiddenJobFilter()\"\n                        data-ng-model=\"ctrl.hideJobFilterButton\"\n                        ng-checked=\"ctrl.hideJobFilterButton\"\n                        class=\"\"\n                        data-testid=\"hide-toggle\"\n                        type=\"checkbox\"\n                      />\n                      <i></i>\n                    </label>\n                    <span class=\"text-switch-save hidden-jobs-switch-inhouse\"\n                      >Hidden({{(ctrl.hiddenPositions && ctrl.hiddenPositions >\n                      0)? ctrl.hiddenPositions: 0}}<span\n                        ng-if=\"ctrl.countRefreshReq === true\"\n                        >*</span\n                      >)\n                    </span>\n                  </span>\n                  <div\n                    class=\"pull-right inhouse-cv-alert\"\n                    ng-if=\"(curLawyer.user.user_resumes.length === 0) || !curLawyer.lawyer_phone\"\n                  >\n                    <span\n                      class=\"btn\"\n                      ng-show=\"curLawyer.profileCvAlertCollapsed || curLawyer.profilePhoneAlertCollapsed\"\n                      ng-click=\"updateProfileAlertStatus((curLawyer.user.user_resumes.length === 0 && !curLawyer.lawyer_phone)? 'both': (!curLawyer.lawyer_phone? 'profilePhoneAlertCollapsed': 'profileCvAlertCollapsed'), false)\"\n                    >\n                      <i class=\"text-warning fa fa-warning\"></i>\n                    </span>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <!-- ## FILTERS DESKTOP VIEW -->\n          <div class=\"row browsefirm-filter-box firm-filter-box-dsk hidden-xs\">\n            <div data-testid=\"practiceArea-filter\" class=\"col-lg-3 col-sm-6\">\n              <practice-Area-Dropdown\n                placeholder=\"'My Practice Areas'\"\n                practice-areas-list=\"ctrl.candidateSpecialties\"\n                on-practice-change=\"ctrl.OnChangePracticeArea($event,selectedPracticeArea)\"\n              ></practice-Area-Dropdown>\n            </div>\n\n            <div\n              data-testid=\"target-locations-filter\"\n              class=\"col-lg-3 col-sm-6\"\n            >\n              <locations-Dropdown\n                placeholder=\"'My Target Locations'\"\n                locations-list=\"ctrl.candidateLocations\"\n                regions-list=\"ctrl.regionHierarchialListWithEuropeOnTop\"\n                on-location-change=\"ctrl.onChangeLocation($event,selectedLocation)\"\n              ></locations-Dropdown>\n            </div>\n\n            <div\n              class=\"col-lg-6 col-sm-12 job-switch-fillter margin-t5 switch-mt\"\n            >\n              <div class=\"text-center pull-right\">\n                <span\n                  ng-class=\"{'pull-right': curLawyer.profileCvAlertCollapsed === false && curLawyer.profilePhoneAlertCollapsed === false}\"\n                >\n                  <span class=\"text-switch-all hidden-jobs-switch-inhouse\"\n                    >All({{(ctrl.totalPositions && ctrl.totalPositions > 0)?\n                    ctrl.totalPositions: 0}}<span\n                      ng-if=\"ctrl.countRefreshReq === true\"\n                      >*</span\n                    >)\n                  </span>\n                  <label class=\"switch switch-info\">\n                    <input\n                      ng-change=\"ctrl.hiddenJobFilter()\"\n                      data-ng-model=\"ctrl.hideJobFilterButton\"\n                      ng-checked=\"ctrl.hideJobFilterButton\"\n                      class=\"\"\n                      type=\"checkbox\"\n                    />\n                    <i></i>\n                  </label>\n                  <span class=\"text-switch-save hidden-jobs-switch-inhouse\"\n                    >Hidden({{(ctrl.hiddenPositions && ctrl.hiddenPositions >\n                    0)? ctrl.hiddenPositions: 0}}<span\n                      ng-if=\"ctrl.countRefreshReq === true\"\n                      >*</span\n                    >)\n                  </span>\n                </span>\n                <div\n                  class=\"pull-right inhouse-cv-alert\"\n                  ng-if=\"(ctrl.candidate.resumes.length === 0) || !ctrl.candidate.user.phone\"\n                >\n                  <span\n                    class=\"btn\"\n                    ng-show=\"ctrl.candidate.profileCvAlertCollapsed || ctrl.candidate.profilePhoneAlertCollapsed\"\n                    ng-click=\"ctrl.updateProfileAlertStatus((ctrl.candidate.resumes.length === 0 && !ctrl.candidate.user.phone)? 'both': (!ctrl.candidate.user.phone? 'profilePhoneAlertCollapsed': 'profileCvAlertCollapsed'), false)\"\n                  >\n                    <i class=\"text-warning fa fa-warning\"></i>\n                  </span>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div\n            class=\"custom-table-body\"\n            ng-if=\"!ctrl.noEmployers && !ctrl.spinnerActive\"\n          >\n            <div\n              class=\"animated\"\n              ng-if=\"employerDetails.employer.isVisible\"\n              ng-class=\"ctrl.firmRow{{employerDetails.employer.id}}\"\n              data-ng-repeat=\"employerDetails in ctrl.candidateEmployerRecommendations\"\n              ng-init=\"employerDetails.expanded=false\"\n            >\n              <div\n                class=\"list-item clearfix\"\n                title=\"Click to view jobs\"\n                data-ng-click=\"ctrl.showPositions(employerDetails)\"\n              >\n                <div class=\"col-md-5 col-sm-12 col-xs-12 list-col-firm\">\n                  <div class=\"row\">\n                    <div\n                      class=\"col-sm-3 visible-sm text-center list-col-explore pull-right\"\n                    >\n                      <div\n                        class=\"btn-noline btn-xs btn-explore \"\n                        ng-hide=\"employerDetails.totalPositions == 0\"\n                      >\n                        <i\n                          ng-show=\"!employerDetails.expanded\"\n                          class=\"btn btn-sm btn-line-info fa fa-plus\"\n                        >\n                        </i>\n                        <i\n                          ng-show=\"employerDetails.expanded\"\n                          class=\"btn btn-sm btn-line-info fa fa-minus\"\n                        ></i>\n                        <span class=\"h5\">Explore Roles</span>\n                      </div>\n                    </div>\n                    <div class=\"col-md-2 col-xs-4 list-firm-logo\">\n                      <img\n                        class=\"\"\n                        alt=\"{{employerDetails.employer.name}}\"\n                        ng-src=\"{{employerDetails.employer.logoSrc}}\"\n                      />\n                    </div>\n\n                    <div class=\"col-md-9 col-xs-8 col-sm-5 list-job-title\">\n                      <h2 class=\"margin-t0 margin-b0 text-thin\">\n                        {{employerDetails.employer.name}}\n                        <img\n                          ng-src=\"{{ctrl.getEmployerTypeLogo(employerDetails)}}\"\n                        />\n                      </h2>\n                      <span\n                        class=\"follow-star\"\n                        ng-click=\"ctrl.toggleFollowEmployer(employerDetails, $event)\"\n                        tooltip-placement=\"right\"\n                        tooltip=\"Anonymously follow {{employerDetails.employer.name}} and get notified as soon as a relevant opportunity opens.\"\n                      >\n                        <i\n                          ng-class=\"{ 'glyphicon glyphicon-star': employerDetails.candidateFollowing,\n                            'glyphicon glyphicon-star-empty': !employerDetails.candidateFollowing }\"\n                        ></i>\n                        <span ng-if=\"employerDetails.candidateFollowing\"\n                          >Following</span\n                        >\n                        <span ng-if=\"!employerDetails.candidateFollowing\"\n                          >Follow</span\n                        >\n                      </span>\n                    </div>\n                  </div>\n                </div>\n\n                <div class=\"col-md-4 col-sm-6 col-xs-9 list-col-info\"></div>\n                <div\n                  class=\"col-md-2 col-sm-6 col-xs-3 text-center list-col-jobs\"\n                >\n                  <div class=\"visible-sm pull-right padding-r15\">\n                    <p>SUGGESTED TEAMS</p>\n                    <span\n                      ng-if=\"(employerDetails.speculativePositions !== employerDetails.totalPositions && employerDetails.totalPositions>0)\"\n                      class=\"text-purple list-job-count\"\n                      >{{employerDetails.totalPositions}}</span\n                    >\n                    <span\n                      ng-if=\"(employerDetails.speculativePositions === employerDetails.totalPositions)\"\n                      class=\"text-purple list-job-spec\"\n                      >Spec Only</span\n                    >\n                  </div>\n                  <div class=\"hidden-sm\">\n                    <p>SUGGESTED TEAMS</p>\n                    <span\n                      ng-if=\"(employerDetails.speculativePositions !== employerDetails.totalPositions && employerDetails.totalPositions>0)\"\n                      class=\"text-purple list-job-count\"\n                      >{{employerDetails.totalPositions}}</span\n                    >\n                    <span\n                      ng-if=\"(employerDetails.speculativePositions === employerDetails.totalPositions)\"\n                      class=\"text-purple list-job-spec\"\n                      >Spec Only</span\n                    >\n                  </div>\n                </div>\n                <div\n                  class=\"col-md-1 col-sm-3 col-xs-12 hidden-sm text-center list-col-explore pull-right\"\n                >\n                  <div\n                    class=\"btn-noline btn-xs btn-explore \"\n                    ng-hide=\"employerDetails.totalPositions === 0\"\n                  >\n                    <i\n                      ng-show=\"!employerDetails.expanded\"\n                      class=\"btn btn-sm btn-line-info fa fa-plus\"\n                    ></i>\n                    <i\n                      ng-show=\"employerDetails.expanded\"\n                      class=\"btn btn-sm btn-line-info fa fa-minus\"\n                    ></i>\n                    <span data-testid=\"explore-role\" class=\"h5\"\n                      >Explore Roles</span\n                    >\n                  </div>\n                </div>\n              </div>\n\n              <div\n                data-testid=\"job-details-div\"\n                class=\"list-firm-expanded\"\n                ng-if=\"employerDetails.expanded\"\n              >\n                <div\n                  class=\"animated clearfix inner-list\"\n                  ng-class=\"[ctrl.jobRow{{job.id}}, {speculative: job.isSpeculative}]\"\n                  ng-repeat=\"job in employerDetails.positions\"\n                  ng-if=\"job.visible\"\n                >\n                  <div class=\"col-md-3 col-sm-3 col-xs-12 pading-0\">\n                    <span\n                      ng-if=\"job.isNewJob\"\n                      class=\"label label-new-job text-uppercase ng-binding\"\n                      >NEW</span\n                    >\n                    <h4\n                      data-testid=\"jobTitle{{job.id}}\"\n                      id=\"{{job.id}}\"\n                      class=\"sm-pad-rt-15\"\n                    >\n                      <strong>\n                        {{job.title}}\n                      </strong>\n                    </h4>\n                    <div\n                      ng-if=\"ctrl.fetchHiddenJobs\"\n                      style=\"margin-bottom: 1em;\"\n                    >\n                      <h5\n                        ng-if=\"job.positionHidden\"\n                        class=\"label label-info text-uppercase\"\n                        style=\"margin-right: 1em;background-color: #e6b36a; color:black;width: 52px;font-weight:normal; \"\n                      >\n                        {{job.positionHiddenReason}}\n                      </h5>\n                      <h5\n                        ng-if=\"job.employerHidden\"\n                        class=\"label label-info text-uppercase\"\n                        style=\"background-color: #e6b36a; color:black;width: 52px;font-weight:normal;\"\n                      >\n                        Employer not for me\n                      </h5>\n                    </div>\n\n                    <div class=\"location-cloud\">\n                      <h5\n                        data-testid=\"jobLocations{{job.id}}\"\n                        ng-repeat=\"location in job.locations\"\n                        class=\"label label-info text-uppercase location-{{ctrl.locationBackgroundColor(location)}}\"\n                      >\n                        {{location.name}}\n                      </h5>\n                    </div>\n                    <h5 data-testid=\"jobContract{{job.id}}\">\n                      Contract: {{job.contractTypeName}}\n                    </h5>\n                    <h5 data-testid=\"jobRole{{job.id}}\">\n                      Occupation: {{job.occupationName}}\n                    </h5>\n                    &nbsp;&nbsp;\n                    <a\n                      title=\"View on Google Maps\"\n                      ng-show=\"{{employerDetails.employer.address}}\"\n                      target=\"_blank\"\n                      href=\"https://maps.google.com/?q={{employerDetails.employer.address}}\"\n                      ><i class=\"fa fa-map-marker\"></i\n                    ></a>\n                    <h5 data-testid=\"jobId{{job.id}}\">\n                      ID: {{job.employerId}}_{{job.id}}\n                    </h5>\n                    <h5\n                      class=\"text-danger\"\n                      ng-if=\"job.last_date_to_apply != null\"\n                    >\n                      Expires: {{job.last_date_to_apply|date:\"dd-MM-yyyy\"}}\n                    </h5>\n                  </div>\n                  <!--- ## MOBILE TOP VIEW DIV  -->\n                  <div class=\"col-md-2 col-sm-2 col-xs-12 apply-mob pading-0\">\n                    <div class=\"row\">\n                      <button\n                        data-testid=\"hideModal{{job.id}}\"\n                        ng-if=\"!ctrl.fetchHiddenJobs\"\n                        ng-disabled=\"job.isApplied\"\n                        ng-click=\"showHideJobModal(job, $event)\"\n                        class=\"pull-right btn btn-save margin-l6\"\n                      >\n                        <span class=\"fa fa-eye-slash\"></span> Not for me\n                      </button>\n\n                      <button\n                        ng-if=\"ctrl.fetchHiddenJobs\"\n                        data-testid=\"unHideModal{{job.id}}\"\n                        ng-click=\"ctrl.unHidePosition(job)\"\n                        class=\"pull-right btn btn-saved margin-l6\"\n                      >\n                        <span class=\"text-save fa fa-eye-slash\"\n                          ><span\n                            style='font-family:\"Lato\", \"Helvetica Neue\", Arial, sans-serif;'\n                            >&nbsp;Hidden</span\n                          ></span\n                        >\n                        <span class=\"text-unsave fa fa-eye\"\n                          ><span\n                            style='font-family:\"Lato\", \"Helvetica Neue\", Arial, sans-serif;'\n                            >&nbsp;Unhide</span\n                          ></span\n                        >\n                      </button>\n                      <div class=\"pull-right\">\n                        <div class=\"pull-right list-job-desc-col\">\n                          <application-modal-directive\n                            user=\"ctrl.user\"\n                            candidate=\"ctrl.candidate\"\n                            position=\"job\"\n                            client=\"true\"\n                          ></application-modal-directive>\n                        </div>\n                        <!-- applied button -->\n                        <!-- <div\n                          class=\"pull-right list-job-desc-col\"\n                          ng-if=\"job.isApplied\"\n                        >\n                          <a\n                            tooltip-placement=\"bottom\"\n                            tooltip=\"You have already shared your profile.\"\n                            ><span class=\" info-browse badge badge-grey\"\n                              ><i class=\"fa fa-info info-icon\"></i></span\n                          ></a>\n                          &nbsp;\n                          <div\n                            class=\"apply-wrapper\"\n                            tooltip-placement=\"bottom\"\n                            tooltip=\"You have already shared your profile.\"\n                          >\n                            <button\n                              class=\"btn btn-info\"\n                              ng-disabled=\"job.applied || curLawyer.lexStepRequired || curLawyer.adminLock || curLawyer.lawyer_Status=='locked' || curLawyer.lock\"\n                              ng-click=\"shareProfile(firm, job,$event)\"\n                              firmName=\"{{firm.firm_Name}}\"\n                              firmID=\"{{firm.user_ID}}\"\n                              firmLogo=\"{{firm.picSrc}}\"\n                            >\n                              <span\n                                ng-if=\"!job.applied\"\n                                class=\"fa fa-plus\"\n                              ></span>\n                              {{job.shareLabel | translate}}\n                            </button>\n                          </div>\n                        </div> -->\n                        <!-- not applied button -->\n                        <!-- <div\n                          class=\"pull-right list-job-desc-col\"\n                          ng-if=\"!job.applied && (curLawyer.lexStepRequired || curLawyer.adminLock || curLawyer.lawyer_Status=='locked' || curLawyer.lock)\"\n                        >\n                          <a\n                            tooltip-placement=\"bottom\"\n                            tooltip=\"{{toolTipText}}\"\n                            ><span class=\"info-browse badge badge-grey\"\n                              ><i class=\"fa fa-info info-icon\"></i></span\n                          ></a>\n                          &nbsp;\n                          <div\n                            class=\"apply-wrapper\"\n                            tooltip-placement=\"bottom\"\n                            tooltip=\"{{toolTipText}}\"\n                          >\n                            <button\n                              class=\"btn btn-info\"\n                              disabled\n                              ng-click=\"shareProfile(firm, job,$event)\"\n                              firmName=\"{{firm.firm_Name}}\"\n                              firmID=\"{{firm.user_ID}}\"\n                              firmLogo=\"{{firm.picSrc}}\"\n                            >\n                              <span\n                                ng-if=\"!job.applied\"\n                                class=\"fa fa-plus\"\n                              ></span>\n                              {{job.shareLabel | translate}}\n                            </button>\n                          </div>\n                        </div> -->\n                        <!-- <div\n                          class=\"pull-right list-job-desc-col\"\n                          ng-if=\"!job.applied && !curLawyer.lexStepRequired && !curLawyer.adminLock && curLawyer.lawyer_Status!='locked' && !curLawyer.lock\"\n                        >\n                          <button\n                            class=\"btn btn-info btn-job-apply\"\n                            ng-click=\"shareProfile(firm, job,$event)\"\n                            firmName=\"{{firm.firm_Name}}\"\n                            firmID=\"{{firm.user_ID}}\"\n                            firmLogo=\"{{firm.picSrc}}\"\n                          >\n                            <span\n                              ng-if=\"!job.applied\"\n                              class=\"fa fa-plus\"\n                            ></span>\n                            {{job.shareLabel | translate}}\n                          </button>\n                        </div> -->\n                      </div>\n                    </div>\n                    <div\n                      class=\"pull-right list-job-desc-col askQuestionContainer\"\n                    >\n                      <button\n                        class=\"btn btn-link text-info padding-0 pull-right\"\n                        ng-click=\"ctrl.askQuestion(job,$event)\"\n                        firmName=\"{{firm.firm_Name}}\"\n                        firmID=\"{{firm.user_ID}}\"\n                      >\n                        {{'browseFirms.askQuestion.label' |translate}}\n                      </button>\n                    </div>\n                  </div>\n                  <div\n                    id=\"{{job.job_ID}}\"\n                    class=\"col-md-6 col-sm-6 col-xs-12 margin-t10 pading-0\"\n                  >\n                    <div class=\"list-job-desc-col job-description\">\n                      <div\n                        class=\"job-description-text\"\n                        ng-class=\"{expanded: !job.isCollapsed}\"\n                      >\n                        <p\n                          ng-bind-html=\"job.description\"\n                          class=\"\"\n                          align=\"justify\"\n                        ></p>\n                      </div>\n\n                      <a\n                        href=\"\"\n                        class=\"text-info\"\n                        ng-show=\"job.isCollapsed && job.showButton\"\n                        ng-click=\"ctrl.showMore(job);\"\n                        ><b class=\"text-more\">more</b></a\n                      >\n\n                      <a\n                        href=\"\"\n                        class=\"text-info\"\n                        ng-show=\"!job.isCollapsed && job.showButton\"\n                        ng-click=\"ctrl.showLess(job);\"\n                        ><b class=\"text-more\">less</b></a\n                      >\n                    </div>\n                  </div>\n                  <!-- Desktop View Div -->\n                  <div\n                    class=\"col-md-3 margin-t10 pading-0 col-sm-3 pull-right apply-desk\"\n                  >\n                    <div class=\"apply-desk\">\n                      <div class=\"pull-right list-job-desc-col\">\n                        <application-modal-directive\n                          data-testid=\"applyModal{{job.id}}\"\n                          user=\"ctrl.user\"\n                          candidate=\"ctrl.candidate\"\n                          position=\"job\"\n                          client=\"true\"\n                        ></application-modal-directive>\n                      </div>\n                      <!-- applied button-->\n                      <!-- <div\n                        class=\"pull-right list-job-desc-col\"\n                        ng-if=\"job.applied\"\n                      >\n                        <a\n                          tooltip-placement=\"bottom\"\n                          tooltip=\"You have already shared your profile.\"\n                          ><span class=\"info-browse-ipad badge badge-grey\"\n                            ><i class=\"fa fa-info info-icon\"></i></span\n                        ></a>\n                        &nbsp;\n                        <div\n                          class=\"apply-wrapper\"\n                          tooltip-placement=\"bottom\"\n                          tooltip=\"You have already shared your profile.\"\n                        >\n                          <button\n                            class=\"btn btn-info btn-job-apply\"\n                            ng-disabled=\"job.applied || curLawyer.lexStepRequired || curLawyer.adminLock || curLawyer.lawyer_Status=='locked' || curLawyer.lock\"\n                            ng-click=\"shareProfile(firm, job,$event)\"\n                            firmName=\"{{firm.firm_Name}}\"\n                            firmID=\"{{firm.user_ID}}\"\n                            firmLogo=\"{{firm.picSrc}}\"\n                          >\n                            <span\n                              ng-if=\"!job.applied\"\n                              class=\"fa fa-plus\"\n                            ></span>\n                            {{job.shareLabel | translate}}\n                          </button>\n                        </div>\n                      </div> -->\n                      <!-- disabled button-->\n                      <!-- <div\n                        class=\"pull-right list-job-desc-col\"\n                        ng-if=\"!job.applied && (curLawyer.lexStepRequired || curLawyer.adminLock || curLawyer.lawyer_Status=='locked' || curLawyer.lock)\"\n                      >\n                        <a tooltip-placement=\"bottom\" tooltip=\"{{toolTipText}}\"\n                          ><span class=\"info-browse-ipad badge badge-grey\"\n                            ><i class=\"fa fa-info info-icon\"></i></span\n                        ></a>\n                        &nbsp;\n                        <div\n                          class=\"apply-wrapper\"\n                          tooltip-placement=\"bottom\"\n                          tooltip=\"{{toolTipText}}\"\n                        >\n                          <button\n                            class=\"btn btn-info btn-job-apply\"\n                            disabled\n                            ng-click=\"shareProfile(firm, job,$event)\"\n                            firmName=\"{{firm.firm_Name}}\"\n                            firmID=\"{{firm.user_ID}}\"\n                            firmLogo=\"{{firm.picSrc}}\"\n                          >\n                            <span\n                              ng-if=\"!job.applied\"\n                              class=\"fa fa-plus\"\n                            ></span>\n                            {{job.shareLabel | translate}}\n                          </button>\n                        </div>\n                      </div> -->\n                      <!-- <div\n                        class=\"pull-right list-job-desc-col\"\n                        ng-if=\"!job.applied && !curLawyer.lexStepRequired && !curLawyer.adminLock && curLawyer.lawyer_Status!='locked' && !curLawyer.lock\"\n                      >\n                        <button\n                          class=\"btn btn-info btn-job-apply btn-job-apply\"\n                          ng-click=\"shareProfile(firm, job,$event)\"\n                          firmName=\"{{firm.firm_Name}}\"\n                          firmID=\"{{firm.user_ID}}\"\n                          firmLogo=\"{{firm.picSrc}}\"\n                        >\n                          <span ng-if=\"!job.applied\" class=\"fa fa-plus\"></span>\n                          {{job.shareLabel | translate}}\n                        </button>\n                      </div> -->\n\n                      <button\n                        ng-if=\"!ctrl.fetchHiddenJobs\"\n                        ng-disabled=\"job.isApplied\"\n                        ng-click=\"showHideJobModal(job, $event)\"\n                        class=\"pull-right btn btn-save\"\n                      >\n                        <span class=\"fa fa-eye-slash\"></span> Not for me\n                      </button>\n\n                      <button\n                        ng-if=\"ctrl.fetchHiddenJobs\"\n                        ng-click=\"ctrl.unHidePosition(job)\"\n                        data-testid=\"unHideModal{{job.id}}\"\n                        class=\"pull-right btn btn-saved\"\n                      >\n                        <span class=\"text-save fa fa-eye-slash\"\n                          ><span\n                            style='font-family:\"Lato\", \"Helvetica Neue\", Arial, sans-serif;'\n                            >&nbsp;Hidden</span\n                          ></span\n                        >\n                        <span class=\"text-unsave fa fa-eye\"\n                          ><span\n                            style='font-family:\"Lato\", \"Helvetica Neue\", Arial, sans-serif;'\n                            >&nbsp;Unhide</span\n                          ></span\n                        >\n                      </button>\n\n                      <div\n                        class=\"pull-right list-job-desc-col col-md-6 askQuestionContainer\"\n                      >\n                        <button\n                          data-testid=\"askQuestion\"\n                          class=\"btn btn-link text-info padding-0 pull-right\"\n                          ng-click=\"ctrl.askQuestion(job,$event)\"\n                        >\n                          {{'browseFirms.askQuestion.label' |translate}}\n                        </button>\n                      </div>\n                    </div>\n\n                    <div\n                      class=\"apply-mob\"\n                      ng-show=\"!job.isCollapsed && job.showButton\"\n                    >\n                      <div\n                        class=\"pull-left list-job-desc-col askQuestionContainer\"\n                      >\n                        <button\n                          class=\"btn btn-link text-info padding-0 pull-right\"\n                          ng-click=\"ctrl.askQuestion(job,$event)\"\n                        >\n                          {{'browseFirms.askQuestion.label' |translate}}\n                        </button>\n                      </div>\n\n                      <div class=\"pull-right list-job-desc-col\">\n                        <application-modal-directive\n                          user=\"ctrl.user\"\n                          candidate=\"ctrl.candidate\"\n                          position=\"job\"\n                          client=\"true\"\n                        ></application-modal-directive>\n                      </div>\n\n                      <!-- <div\n                        class=\"pull-right list-job-desc-col\"\n                        ng-if=\"job.applied\"\n                        tooltip-placement=\"bottom\"\n                        tooltip=\"You have already shared your profile.\"\n                      >\n                        <button\n                          class=\"btn btn-info btn-job-apply\"\n                          ng-disabled=\"job.applied || curLawyer.lexStepRequired || curLawyer.adminLock || curLawyer.lawyer_Status=='locked' || curLawyer.lock\"\n                          ng-click=\"shareProfile(firm, job,$event)\"\n                          firmName=\"{{firm.firm_Name}}\"\n                          firmID=\"{{firm.user_ID}}\"\n                          firmLogo=\"{{firm.picSrc}}\"\n                        >\n                          <span ng-if=\"!job.applied\" class=\"fa fa-plus\"></span>\n                          {{job.shareLabel | translate}}\n                        </button>\n                      </div> -->\n                      <!-- <div\n                        class=\"pull-right list-job-desc-col\"\n                        ng-if=\"!job.applied && (curLawyer.lexStepRequired || curLawyer.adminLock || curLawyer.lawyer_Status=='locked' || curLawyer.lock) \"\n                        tooltip-placement=\"bottom\"\n                        tooltip=\"{{toolTipText}}\"\n                      >\n                        <button\n                          class=\"btn btn-info btn-job-apply\"\n                          disabled\n                          ng-click=\"shareProfile(firm, job,$event)\"\n                          firmName=\"{{firm.firm_Name}}\"\n                          firmID=\"{{firm.user_ID}}\"\n                          firmLogo=\"{{firm.picSrc}}\"\n                        >\n                          <span ng-if=\"!job.applied\" class=\"fa fa-plus\"></span>\n                          {{job.shareLabel | translate}}\n                        </button>\n                      </div> -->\n                      <!-- <div\n                        class=\"pull-right list-job-desc-col\"\n                        ng-if=\"!job.applied && !curLawyer.lexStepRequired && !curLawyer.adminLock && curLawyer.lawyer_Status!='locked' && !curLawyer.lock\"\n                      >\n                        <button\n                          class=\"btn btn-info btn-job-apply btn-job-apply\"\n                          ng-click=\"shareProfile(firm, job,$event)\"\n                          firmName=\"{{firm.firm_Name}}\"\n                          firmID=\"{{firm.user_ID}}\"\n                          firmLogo=\"{{firm.picSrc}}\"\n                        >\n                          <span ng-if=\"!job.applied\" class=\"fa fa-plus\"></span>\n                          {{job.shareLabel | translate}}\n                        </button>\n                      </div> -->\n\n                      <button\n                        ng-if=\"!ctrl.fetchHiddenJobs\"\n                        ng-disabled=\"job.isApplied\"\n                        ng-click=\"showHideJobModal(job, $event)\"\n                        class=\"pull-right btn btn-save\"\n                      >\n                        <span class=\"fa fa-eye-slash\"></span> Not for me\n                      </button>\n\n                      <button\n                        ng-if=\"ctrl.fetchHiddenJobs\"\n                        ng-click=\"ctrl.unHidePosition(job)\"\n                        data-testid=\"unHideModal{{job.id}}\"\n                        class=\"pull-right btn btn-saved\"\n                      >\n                        <span class=\"text-save fa fa-eye-slash\"\n                          ><span\n                            style='font-family:\"Lato\", \"Helvetica Neue\", Arial, sans-serif;'\n                            >&nbsp;Hidden</span\n                          ></span\n                        >\n                        <span class=\"text-unsave fa fa-eye\"\n                          ><span\n                            style='font-family:\"Lato\", \"Helvetica Neue\", Arial, sans-serif;'\n                            >&nbsp;Unhide</span\n                          ></span\n                        >\n                      </button>\n                    </div>\n                  </div>\n                  <div\n                    class=\"clearfix col-md-12 col-sm-12 col-xs-12 custom-width pad-r0\"\n                  >\n                    <div\n                      class=\"pull-right \"\n                      ng-show=\"!job.isCollapsed && job.showButton\"\n                    >\n                      <div class=\"pull-right list-job-desc-col\">\n                        <application-modal-directive\n                          user=\"ctrl.user\"\n                          candidate=\"ctrl.candidate\"\n                          position=\"job\"\n                          client=\"true\"\n                        ></application-modal-directive>\n                      </div>\n                      <!-- <div\n                        class=\"pull-right list-job-desc-col\"\n                        ng-if=\"job.applied\"\n                      >\n                        <a\n                          tooltip-placement=\"bottom\"\n                          tooltip=\"You have already shared your profile.\"\n                          ><span class=\" info-browse-ipad badge badge-grey\"\n                            ><i class=\"fa fa-info info-icon\"></i></span\n                        ></a>\n                        &nbsp;\n                        <div\n                          class=\"apply-wrapper\"\n                          tooltip-placement=\"bottom\"\n                          tooltip=\"You have already shared your profile.\"\n                        >\n                          <button\n                            class=\"btn btn-info btn-job-apply\"\n                            ng-disabled=\"job.applied || curLawyer.lexStepRequired || curLawyer.adminLock || curLawyer.lawyer_Status=='locked' || curLawyer.lock\"\n                            ng-click=\"shareProfile(firm, job,$event)\"\n                            firmName=\"{{firm.firm_Name}}\"\n                            firmID=\"{{firm.user_ID}}\"\n                            firmLogo=\"{{firm.picSrc}}\"\n                          >\n                            <span\n                              ng-if=\"!job.applied\"\n                              class=\"fa fa-plus\"\n                            ></span>\n                            {{job.shareLabel | translate}}\n                          </button>\n                        </div>\n                      </div> -->\n                      <!-- <div\n                        class=\"pull-right list-job-desc-col\"\n                        ng-if=\"!job.applied && (curLawyer.lexStepRequired || curLawyer.adminLock || curLawyer.lawyer_Status=='locked' || curLawyer.lock)\"\n                      >\n                        <a tooltip-placement=\"bottom\" tooltip=\"{{toolTipText}}\"\n                          ><span class=\"info-browse badge badge-grey\"\n                            ><i class=\"fa fa-info info-icon\"></i></span\n                        ></a>\n                        &nbsp;\n                        <div\n                          class=\"apply-wrapper\"\n                          tooltip-placement=\"bottom\"\n                          tooltip=\"{{toolTipText}}\"\n                        >\n                          <button\n                            class=\"btn btn-info btn-job-apply\"\n                            disabled\n                            ng-click=\"shareProfile(firm, job,$event)\"\n                            firmName=\"{{firm.firm_Name}}\"\n                            firmID=\"{{firm.user_ID}}\"\n                            firmLogo=\"{{firm.picSrc}}\"\n                          >\n                            <span\n                              ng-if=\"!job.applied\"\n                              class=\"fa fa-plus\"\n                            ></span>\n                            {{job.shareLabel | translate}}\n                          </button>\n                        </div>\n                      </div> -->\n                      <!-- <div\n                        class=\"pull-right list-job-desc-col\"\n                        ng-if=\"!job.applied && !curLawyer.lexStepRequired && !curLawyer.adminLock && curLawyer.lawyer_Status!='locked' && !curLawyer.lock\"\n                      >\n                        <button\n                          class=\"btn btn-info btn-job-apply btn-job-apply\"\n                          ng-click=\"shareProfile(firm, job,$event)\"\n                          firmName=\"{{firm.firm_Name}}\"\n                          firmID=\"{{firm.user_ID}}\"\n                          firmLogo=\"{{firm.picSrc}}\"\n                        >\n                          <span ng-if=\"!job.applied\" class=\"fa fa-plus\"></span>\n                          {{job.shareLabel | translate}}\n                        </button>\n                      </div> -->\n                      <br class=\"visible-sm visible-xs\" />\n                      <div\n                        class=\"pull-right list-job-desc-col col-md-6 askQuestionContainer\"\n                      >\n                        <button\n                          class=\"btn btn-link text-info padding-0 pull-right\"\n                          ng-click=\"ctrl.askQuestion(job,$event)\"\n                          firmName=\"{{firm.firm_Name}}\"\n                          firmID=\"{{firm.user_ID}}\"\n                        >\n                          {{'browseFirms.askQuestion.label' |translate}}\n                        </button>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"custom-table-body\" ng-if=\"ctrl.spinnerActive\"></div>\n          <div ng-if=\"ctrl.noEmployers && !ctrl.fetchHiddenJobs\">\n            <center>\n              <p class=\"inhouse-blank-slate\">\n                {{ctrl.alertOne}}<a\n                  href=\"/user-profile?tab=preferences\"\n                  style=\"color: #95288f;\"\n                  >Preferences</a\n                >{{ctrl.alertTwo}}\n              </p>\n            </center>\n          </div>\n          <div ng-if=\"ctrl.noEmployers && ctrl.fetchHiddenJobs\">\n            <center>\n              <p class=\"inhouse-blank-slate\">\n                You currently have no Hidden Jobs.\n              </p>\n            </center>\n          </div>\n          <!-- Firm List Item End -->\n\n          <footer class=\"table-footer table-dynamic\" ng-show=\"!ctrl.noJob\">\n            <div class=\"row\">\n              <div class=\"page-num-info\">\n                <span>\n                  Show\n                  <span class=\"ui-select select-enty-count\">\n                    <select\n                      data-ng-model=\"ctrl.numPerPage\"\n                      data-ng-options=\"num for num in ctrl.numPerPageOpt\"\n                      data-ng-change=\"ctrl.onNumPerPageChange()\"\n                    >\n                    </select>\n                  </span>\n                  entries per page\n                </span>\n              </div>\n\n              <div class=\"text-right pagination-container custom-pagination\">\n                <pagination\n                  class=\"pagination-sm\"\n                  ng-model=\"ctrl.currentPage\"\n                  total-items=\"ctrl.candidateEmployerRecommendations.length\"\n                  max-size=\"4\"\n                  ng-change=\"ctrl.select(ctrl.currentPage)\"\n                  items-per-page=\"ctrl.numPerPage\"\n                  rotate=\"false\"\n                  boundary-links=\"true\"\n                >\n                </pagination>\n              </div>\n            </div>\n          </footer>\n        </section>\n      </div>\n    </div>\n  </div>\n  <!-- End Container -->\n\n  <!-- Footer -->\n  <div lexstep-footer></div>\n  <!-- Footer Ends-->\n\n  <hide-position-employer-modal\n    modal-open-handler=\"showHideJobModal\"\n    page=\"ctrl.pageName\"\n    consultant=\"user.assignedAdminDetails\"\n    on-position-hide=\"ctrl.hidePositionFromUI(position)\"\n    on-employer-hide=\"ctrl.hideEmployerFromUI(position)\"\n  >\n  </hide-position-employer-modal>\n\n  <!--Script for read more directive -->\n  <script type=\"text/ng-template\" id=\"template.html\">\n    <span ng-if=\"hmtext.length > hmlimit\">\n      <span style=\"display:block;\" ng-hide=\"hmfulltext\">\n        {{ hmtext | limitTo:hmlimit }}...\n        <a ngclass=\"{{ hmMoreClass }}\" ng-click=\"toggleValue()\">{{ hmMoreText }}</a>\n      </span>\n\n      <span style=\"display:block;\" ng-show=\"hmfulltext\">\n        {{ hmtext }}\n        <a ng-class=\"{{ hmLessClass }}\" ng-click=\"toggleValue()\">{{ hmLessText }}</a>\n      </span>\n    </span>\n\n    <span ng-if=\"hmtext.length <= hmlimit\">\n      {{ hmtext }}\n    </span>\n  </script>\n</div>\n\n<contact-admin> </contact-admin>\n"

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"page-signin\"\n  id=\"browse-jobs\"\n  ng-cloak\n  data-ng-controller=\"MatchesController as matchesController\"\n  ng-init=\"showAlert = true\"\n>\n  <!-- mobile navbar -->\n  <div lexstep-header></div>\n  <!-- Header Ends -->\n  <div\n    data-ng-controller=\"IsOldBrowserController as isOldBrowser\"\n    class=\"container\"\n  >\n    <div class=\"old-browser-alert\" ng-show=\"isOldBrowser.showOldBrowser\">\n      <div class=\"callout bg-warning margin-t0\" type=\"info\">\n        You are using an older version of the browser that may not support\n        LexStep features. Please\n        <a\n          target=\"_blank\"\n          class=\"text-info\"\n          href=\"http://windows.microsoft.com/en-us/internet-explorer/download-ie\"\n          >upgrade</a\n        >\n        for improved experience.\n      </div>\n    </div>\n  </div>\n\n  <div class=\"container\" ng-click=\"hideDropDown()\">\n    <div class=\"panel-body heading-jobs-listings row\">\n      <center>\n        <!--<h1 class=\"text-thin hdng-tshadow margin-b0\">Click/Tap on a company to explore current openings</h1>-->\n        <h1 class=\"text-thin hdng-tshadow margin-b10\">My LexStep Matches</h1>\n        <div class=\"inlineBlock\">\n          <h4 class=\"display-inline text-thin hdng-tshadow margin-b0\">\n            Select an opportunity match to explore and indicate your interest in\n            meeting the hiring partner or GC via LexStep.\n          </h4>\n          <a\n            class=\"display-inline no-text-decoration subheading-tooltip\"\n            href=\"\"\n            tooltip=\"Use the filters to refine your LexStep Matches below.  Visit MY PROFILE under your name above to set your  PREFERENCES and help LexStep suggest better matches in future.\"\n            tooltip-placement=\"bottom\"\n          >\n            <span class=\"badge badge-grey\">\n              <i class=\"fa fa-info\"></i>\n            </span>\n          </a>\n        </div>\n        <h4 class=\"text-thin hdng-tshadow margin-t20 margin-b20\">\n          <img\n            src=\"{{matchesController.candidateAgent.logoSrc}}\"\n            class=\"img-circle margin-r15\"\n            alt=\"Consultant Image\"\n            width=\"85\"\n            height=\"85\"\n          />\n\n          <div class=\"clearfix visible-xs-block\"></div>\n          <div class=\"inlineBlock\">\n            <span>\n              Contact {{matchesController.candidateAgent.firstName}}\n              {{matchesController.candidateAgent.lastName}}\n            </span>\n            <span>\n              <br class=\"visible-xs\" />\n              <span class=\"hidden-xs\">&nbsp;|&nbsp;</span>\n            </span>\n            <a href=\"mailto:{{matchesController.candidateAgent.email}}\"\n              >{{matchesController.candidateAgent.email}}</a\n            >\n            <span>\n              <br class=\"visible-xs\" />\n              <span class=\"hidden-xs\">&nbsp;|&nbsp;</span>\n            </span>\n            <a href=\"tel:{{matchesController.candidateAgent.phone}}\"\n              >{{matchesController.candidateAgent.phone}}</a\n            >\n          </div>\n        </h4>\n        <button\n          data-testid=\"make-me-an-offer-button\"\n          class=\"btn btn-lg btn-info\"\n          ng-click=\"matchesController.loadPrivateJobs()\"\n        >\n          Make Me An Offer\n        </button>\n        <div class=\"badge badge-info hidden\">\n          <span class=\"badge badge-info\">\n            <h5 class=\"margin-t5 margin-b5\">\n              <span>Questions? &nbsp; Give us a call:</span>\n              <span>&nbsp;{{contactPhone}}</span>\n            </h5>\n          </span>\n        </div>\n      </center>\n    </div>\n\n    <!-- Main Alert Section -->\n    <div hidden class=\"callout bg-danger\" type=\"info\">\n      <span class=\"glyphicon glyphicon-lock\"></span> &nbsp;<strong\n        class=\"ng-binding\"\n        >{{'main.alert'| translate}}</strong\n      >\n    </div>\n    <!-- Main Alert Section End -->\n\n    <!-- Get Start Section -->\n    <div\n      class=\"row\"\n      ng-show=\"matchesController.candidate.approvalStatus === 'Locked'\"\n    >\n      <div class=\"col-md-12\">\n        <div class=\"alert alert-danger alert-dismissable  margin-t10\">\n          <div>\n            <span\n              ><i class=\"fa fa-warning\"></i>&nbsp;Your profile has been locked\n              and is waiting for re-approval. For now you cannot apply to any\n              job or edit your profile.</span\n            >\n          </div>\n        </div>\n      </div>\n    </div>\n    <div\n      class=\"row animated\"\n      ng-class=\"mainAlert\"\n      ng-show=\"!matchesController.candidate.profileCvAlertCollapse && !matchesController.candidate.profilePhoneAlertCollapse\"\n    >\n      <div class=\"hidden col-md-6\">\n        <h2 class=\"ng-binding margin-t10 hidden\">\n          {{'browseFirms.GetStarted.Heading'|translate}}\n        </h2>\n        <h5>\n          {{'Firms.GetStarted.Greeting2'|translate}}\n        </h5>\n      </div>\n      <div class=\"col-md-12\">\n        <div ng-show=\"matchesController.candidate.resumes.length === 0\">\n          <div\n            class=\"alert alert-danger alert-dismissable margin-t10\"\n            ng-hide=\"matchesController.candidate.profileCvAlertCollapsed\"\n            ng-class=\"CVAlert\"\n          >\n            <button\n              class=\"close\"\n              type=\"button\"\n              ng-click=\"matchesController.updateProfileAlertStatus('profileCvAlertCollapsed', true)\"\n            >\n              <span aria-hidden=\"true\">×</span>\n              <span class=\"sr-only\">Close</span>\n            </button>\n            <span class=\"ng-binding ng-scope\">\n              <i class=\"fa fa-warning\"></i>\n              <span>\n                &nbsp;Upload your <b>CV</b> to connect with employers. &nbsp;\n                <a href=\"/user-profile\" class=\"text-info\"\n                  >Go to your profile page</a\n                >\n              </span>\n            </span>\n          </div>\n        </div>\n\n        <div ng-show=\"!matchesController.candidate.user.phone\">\n          <div ng-hide=\"matchesController.candidate.profilePhoneAlertCollapsed\">\n            <div class=\"alert alert-danger alert-dismissable  margin-t10\">\n              <button\n                class=\"close\"\n                type=\"button\"\n                ng-click=\"matchesController.updateProfileAlertStatus('profilePhoneAlertCollapsed', true)\"\n              >\n                <span aria-hidden=\"true\">×</span>\n                <span class=\"sr-only\">Close</span>\n              </button>\n              <span class=\"ng-binding ng-scope\">\n                <i class=\"fa fa-warning\"></i>\n                <span>\n                  &nbsp;Please add a <b>contact number</b> in order to be able\n                  to connect with employers.\n                  <a href=\"/user-profile\" class=\"text-info\"\n                    >Go to your profile page</a\n                  >\n                </span>\n              </span>\n              <!-- <a href=\"\" class=\"fa fa-times pull-right\" ng-click=\"profileAlert = 'fadeOutDown'; crossAnimate='fadeInUp'; showProfileAlert = false\"></a> -->\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- Get Start Section End -->\n\n    <div class=\"panel panel-default \">\n      <!---###### FIRMS LISTING #######-->\n      <div class=\"panel-body row\">\n        <!--listings div starts-->\n        <section class=\"page page-table table-dynamic\">\n          <span\n            class=\"spinner-static-center\"\n            us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n            spinner-key=\"spinner-2\"\n          >\n          </span>\n          <!-- ## FILTERS MOBILE VIEW -->\n          <div\n            class=\"row matches-filter-section firm-filter-box-matches firm-filter-box-mob visible-xs\"\n          >\n            <div class=\"clearfix hidden\">\n              <div class=\"col-sm-5 col-xs-11 mob-sticky-msg\">\n                <span class=\"badge badge-info custom-badge\">\n                  <h5>\n                    <span>Questions? &nbsp; Give us a call:</span>\n                    <span>&nbsp;{{contactPhone}}</span>\n                  </h5>\n                </span>\n              </div>\n            </div>\n            <div class=\"clearfix\">\n              <div\n                class=\"pull-right inhouse-cv-alert\"\n                ng-if=\"(matchesController.candidate.resumes.length === 0) || ! matchesController.candidate.user.phone\"\n              >\n                <span\n                  class=\"btn\"\n                  ng-show=\" matchesController.candidate.profileCvAlertCollapsed || matchesController.candidate.profilePhoneAlertCollapsed\"\n                  ng-click=\"matchesController.updateProfileAlertStatus((matchesController.candidate.resumes.length === 0 && !matchesController.candidate.user.phone)? 'both': (!matchesController.candidate.user.phone? 'profilePhoneAlertCollapsed': 'profileCvAlertCollapsed'), false)\"\n                >\n                  <i class=\"text-error fa fa-warning\"></i>\n                </span>\n              </div>\n              <div class=\"col-xs-12\">\n                <practice-Area-Dropdown\n                  width=\"true\"\n                  placeholder=\"'My Practice Areas'\"\n                  practice-areas-list=\"matchesController.candidateSpecialties\"\n                  on-practice-change=\"matchesController.OnChangePracticeArea($event,selectedPracticeArea)\"\n                ></practice-Area-Dropdown>\n              </div>\n              <div class=\"col-xs-12 filter-mt\">\n                <locations-Dropdown\n                  width=\"true\"\n                  placeholder=\"'My Target Locations'\"\n                  locations-list=\"matchesController.candidateLocations\"\n                  regions-list=\"matchesController.regionHierarchialListWithEuropeOnTop\"\n                  on-location-change=\"matchesController.onChangeLocation($event,selectedLocation)\"\n                ></locations-Dropdown>\n              </div>\n              <div class=\"col-xs-12 browse-opps-pqe-filter\">\n                <input\n                  ng-model=\"matchesController.filterPQE\"\n                  ng-change=\"matchesController.pqeChanged();\"\n                  type=\"text\"\n                  id=\"mySlider1\"\n                  slider\n                  options=\"matchesController.options\"\n                />\n              </div>\n              <div\n                class=\"col-xs-12 job-switch-fillter hidden-jobs-switch margin-t5 switch-mt\"\n              >\n                <div class=\"text-center\">\n                  <span ng-class=\"\">\n                    <span class=\"text-switch-all hidden-jobs-switch\"\n                      >All({{(matchesController.totalPositions &&\n                      matchesController.totalPositions > 0)?\n                      matchesController.totalPositions: 0}}\n                      <span ng-if=\"matchesController.countRefreshReq === true\"\n                        >*</span\n                      >)\n                    </span>\n                    <label class=\"switch switch-info\">\n                      <input\n                        ng-change=\"matchesController.hiddenJobFilter()\"\n                        data-ng-model=\"matchesController.hideJobFilterButton\"\n                        ng-checked=\"matchesController.hideJobFilterButton\"\n                        class=\"\"\n                        type=\"checkbox\"\n                      />\n                      <i></i>\n                    </label>\n                    <span class=\"text-switch-save hidden-jobs-switch\"\n                      >Hidden({{(matchesController.hiddenPositions &&\n                      matchesController.hiddenPositions > 0)?\n                      matchesController.hiddenPositions: 0}}<span\n                        ng-if=\"matchesController.countRefreshReq === true\"\n                        >*</span\n                      >)\n                    </span>\n                  </span>\n                </div>\n              </div>\n            </div>\n            <div\n              class=\"clearfix text-purple pointer more-less-matches\"\n              ng-init=\"showAdvancedFilters = false\"\n            >\n              <!-- advanced filters Heading section  -->\n              <a\n                class=\"for-text-decoration text-info pull-right padding-0-10-0-0 margin-t20\"\n                ng-click=\"showAdvancedFilters = !showAdvancedFilters\"\n              >\n                <img\n                  ng-src=\"/images/caret-{{showAdvancedFilters ?'down' : 'up'}}-blue.png\"\n                />\n                <span> {{showAdvancedFilters?\"less\":\"more\"}}</span>\n              </a>\n            </div>\n          </div>\n          <!-- ## FILTERS DESKTOP VIEW -->\n          <div\n            class=\"row matches-filter-section firm-filter-box-matches firm-filter-box-dsk hidden-xs\"\n          >\n            <div class=\"col-lg-5 col-sm-12 padding-lr0\">\n              <div data-testid=\"practiceArea-filter\" class=\"col-lg-6 col-sm-6\">\n                <practice-Area-Dropdown\n                  placeholder=\"'My Practice Areas'\"\n                  practice-areas-list=\"matchesController.candidateSpecialties\"\n                  on-practice-change=\"matchesController.OnChangePracticeArea($event,selectedPracticeArea)\"\n                ></practice-Area-Dropdown>\n              </div>\n\n              <div data-testid=\"locations-filter\" class=\"col-lg-6 col-sm-6\">\n                <locations-Dropdown\n                  placeholder=\"'My Target Locations'\"\n                  locations-list=\"matchesController.candidateLocations\"\n                  regions-list=\"matchesController.regionHierarchialListWithEuropeOnTop\"\n                  on-location-change=\"matchesController.onChangeLocation($event,selectedLocation)\"\n                ></locations-Dropdown>\n              </div>\n            </div>\n\n            <div class=\"col-lg-7 col-sm-12\">\n              <div class=\"row\">\n                <div\n                  data-testid=\"pqe-bar\"\n                  class=\"col-lg-6 col-sm-6 browse-opps-pqe-filter filter-bar\"\n                >\n                  <input\n                    ng-model=\"matchesController.filterPQE\"\n                    ng-change=\"matchesController.pqeChanged();\"\n                    type=\"text\"\n                    id=\"mySlider1\"\n                    options=\"matchesController.options\"\n                    autocomplete=\"off\"\n                    slider\n                    class=\"hidden-jobs-switch\"\n                  />\n                </div>\n\n                <div\n                  class=\"col-lg-5 col-sm-5 job-switch-fillter margin-t5 switch-mt\"\n                >\n                  <div class=\"\">\n                    <span ng-class=\"center\">\n                      <span class=\"text-switch-all hidden-jobs-switch\"\n                        >All({{(matchesController.totalPositions &&\n                        matchesController.totalPositions > 0)?\n                        matchesController.totalPositions: 0}}<span\n                          ng-if=\"matchesController.countRefreshReq === true\"\n                          >*</span\n                        >)</span\n                      >\n                      <label class=\"switch switch-info\">\n                        <input\n                          ng-change=\"matchesController.hiddenJobFilter()\"\n                          data-ng-model=\"matchesController.hideJobFilterButton\"\n                          ng-checked=\"matchesController.hideJobFilterButton\"\n                          class=\"\"\n                          data-testid=\"hide-toggle\"\n                          type=\"checkbox\"\n                        />\n                        <i></i>\n                      </label>\n                      <span class=\"text-switch-save hidden-jobs-switch\"\n                        >Hidden({{(matchesController.hiddenPositions &&\n                        matchesController.hiddenPositions > 0)?\n                        matchesController.hiddenPositions: 0}}<span\n                          ng-if=\"matchesController.countRefreshReq === true\"\n                          >*</span\n                        >)</span\n                      >\n                    </span>\n                    <div\n                      class=\"inhouse-cv-alert pull-right\"\n                      ng-if=\"(matchesController.candidate.resumes.length === 0) || !matchesController.candidate.user.phone\"\n                    >\n                      <span\n                        class=\"btn\"\n                        ng-show=\"matchesController.candidate.profileCvAlertCollapsed || matchesController.candidate.profilePhoneAlertCollapsed\"\n                        ng-click=\"matchesController.updateProfileAlertStatus((matchesController.candidate.resumes.length === 0 && !matchesController.candidate.user.phone)? 'both': (!matchesController.candidate.user.phone? 'profilePhoneAlertCollapsed': 'profileCvAlertCollapsed'), false)\"\n                      >\n                        <i class=\"text-error fa fa-warning\"></i>\n                      </span>\n                    </div>\n                  </div>\n                </div>\n                <div\n                  data-testid=\"more-less\"\n                  class=\"text-purple pointer col-lg-1 margin-t-10 more-less-matches\"\n                  ng-init=\"showAdvancedFilters = false\"\n                >\n                  <!-- advanced filters Heading section  -->\n                  <a\n                    class=\"for-text-decoration text-info pull-right padding-0-10-0-0 margin-t20\"\n                    ng-click=\"showAdvancedFilters = !showAdvancedFilters\"\n                  >\n                    <img\n                      ng-src=\"/images/caret-{{showAdvancedFilters ?'down' : 'up'}}-blue.png\"\n                    />\n                    <span> {{showAdvancedFilters?\"less\":\"more\"}}</span>\n                  </a>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div\n            class=\"row firm-filter-box-matches padding-l15\"\n            ng-show=\"showAdvancedFilters\"\n          >\n            <div class=\"col-lg-5 col-sm-8 col-xs-12 padding-l0\">\n              <div\n                data-testid=\"matches-contract-filter\"\n                class=\"col-xs-6 col-sm-6 col-md-6 hidden-xs show-sm show-md show-lg padding-l0\"\n                style=\"padding-right: 19px;\"\n              >\n                <multi-select-dropdown\n                  base-list=\"matchesController.contractTypes\"\n                  on-change=\"matchesController.applyFilters('contract')\"\n                  placeholder=\"'Contract'\"\n                  button-id=\"filter-contract\"\n                ></multi-select-dropdown>\n              </div>\n              <div\n                class=\"col-xs-6 col-sm-6 col-md-6 show-xs hidden-sm hidden-md hidden-lg padding-l0\"\n                style=\"padding-right: 15px;\"\n              >\n                <multi-select-dropdown\n                  base-list=\"matchesController.contractTypes\"\n                  on-change=\"matchesController.applyFilters('contract')\"\n                  placeholder=\"'contract'\"\n                  button-id=\"filter-contract\"\n                ></multi-select-dropdown>\n              </div>\n              <div\n                data-testid=\"matches-role-filter\"\n                class=\"col-xs-6 col-sm-6 col-md-6 padding-l0 matches-role-filter\"\n              >\n                <multi-select-dropdown\n                  base-list=\"matchesController.occupations\"\n                  on-change=\"matchesController.applyFilters('occupation')\"\n                  placeholder=\"'Occupation'\"\n                  button-id=\"filter-roles\"\n                ></multi-select-dropdown>\n              </div>\n            </div>\n            <div\n              data-testid=\"matches-employertype-filter\"\n              class=\"col-lg-5 col-sm-4 col-xs-6 padding-l0\"\n            >\n              <div\n                class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 hidden-xs\"\n                style=\"padding-right: 0px;padding-left: 6px;\"\n              >\n                <multi-select-dropdown\n                  base-list=\"matchesController.employerTypes\"\n                  on-change=\"matchesController.applyFilters('employerType')\"\n                  placeholder=\"'Employer Type'\"\n                  button-id=\"filter-target-employer\"\n                ></multi-select-dropdown>\n              </div>\n            </div>\n            <div\n              class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 padding-l0 show-xs hidden-sm hidden-md hidden-lg padding-t5\"\n              style=\"padding-right: 20px;\"\n            >\n              <multi-select-dropdown\n                base-list=\"matchesController.employerTypes\"\n                on-change=\"matchesController.applyFilters('employerType')\"\n                placeholder=\"'Employer Type'\"\n                button-id=\"filter-target-employer\"\n              ></multi-select-dropdown>\n            </div>\n          </div>\n          <div\n            class=\"custom-table-body\"\n            ng-if=\"!matchesController.noJob && !matchesController.spinnerActive\"\n          >\n            <div\n              data-testid=\"job-details-div\"\n              class=\"animated\"\n              ng-class=\"matchesController.jobRow{{job.id}}\"\n              ng-if=\"job.visible\"\n              data-ng-repeat=\"job in matchesController.candidateMatchesData\"\n              ng-init=\"job.expanded=false\"\n            >\n              <div\n                class=\"list-item list-item-inhouse clearfix\"\n                title=\"Click to view job\"\n                data-ng-click=\"matchesController.showJobs(job)\"\n              >\n                <img\n                  ng-if=\"job.isNewJob\"\n                  src=\"images/new-role-indicator.png\"\n                  class=\"new-jobs-indictaor\"\n                />\n                <div class=\"col-md-8 col-sm-12 col-xs-12 list-col-firm\">\n                  <div class=\"row\">\n                    <div class=\"col-xs-4 list-firm-logo\">\n                      <img\n                        class=\"\"\n                        alt=\"{{job.employer.name}}\"\n                        ng-src=\"{{job.employer.logoSrc}}\"\n                      />\n                    </div>\n                    <div class=\"col-xs-8 list-job-title\">\n                      <h2\n                        data-testid=\"firmName\"\n                        class=\"margin-t0 margin-b0 text-thin\"\n                      >\n                        {{job.employer.name}}\n                        <img\n                          ng-src=\"{{matchesController.findPositionEmployerType(job)}}\"\n                        />\n                      </h2>\n                      <h3 data-testid=\"jobTitle\" id=\"{{job.id}\">\n                        {{job.title}}\n                      </h3>\n                      <div\n                        ng-if=\"matchesController.fetchHiddenJobs\"\n                        style=\"margin-bottom: 1em; margin-top: 1em;\"\n                      >\n                        <h5\n                          ng-if=\"job.positionHidden\"\n                          class=\"label label-info text-uppercase\"\n                          style=\"margin-right: 1em;background-color: #e6b36a; color:black;width: 52px;font-weight:normal; \"\n                        >\n                          {{job.positionHiddenReason}}\n                        </h5>\n                        <h5\n                          ng-if=\"job.employerHidden\"\n                          class=\"label label-info text-uppercase\"\n                          style=\"background-color: #e6b36a; color:black;width: 52px;font-weight:normal;\"\n                        >\n                          Employer not for me\n                        </h5>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n\n                <div class=\"col-md-3 col-sm-10 col-xs-12 col-inhouse-pqe\">\n                  <h5 data-testid=\"jobPQE\">\n                    PQE: {{job.lawPreferences.minPqe <= 0\n                    ?\"NQ\":job.lawPreferences.minPqe}}{{job.lawPreferences.maxPqe\n                    == 11?\"+\":(job.lawPreferences.maxPqe <= 0 ||\n                    job.lawPreferences.maxPqe ==\n                    job.lawPreferences.minPqe)?\"\":\"-\"+job.lawPreferences.maxPqe}}\n                  </h5>\n                  <h5 data-testid=\"jobContract\">\n                    Contract: {{job.contractTypeName}}\n                  </h5>\n                  <h5 data-testid=\"jobRole\">\n                    Occupation: {{job.occupationName}}\n                  </h5>\n                  <div data-testid=\"jobLocations\" class=\"location-cloud\">\n                    <h5\n                      ng-repeat=\"location in job.locations\"\n                      class=\"label label-info text-uppercase location-{{matchesController.locationBackgroundColor(location)}}\"\n                    >\n                      {{location.name}}\n                    </h5>\n                  </div>\n                </div>\n\n                <div\n                  class=\"col-md-1 col-sm-2 col-xs-12 text-center list-col-explore\"\n                >\n                  <div class=\"btn-noline btn-xs btn-explore \">\n                    <i\n                      ng-show=\"!job.expanded\"\n                      class=\"btn btn-sm btn-line-info fa fa-plus\"\n                    ></i>\n                    <i\n                      ng-show=\"job.expanded\"\n                      class=\"btn btn-sm btn-line-info fa fa-minus\"\n                    >\n                    </i>\n                    <span data-testid=\"explore-role\" class=\"h5\"\n                      >Explore Role</span\n                    >\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"inner-list-inhouse clearfix\" ng-if=\"job.expanded\">\n                <div\n                  id=\"{{job.id}}\"\n                  class=\"col-md-9 col-sm-9 col-xs-12 pading-0\"\n                >\n                  <div class=\"list-job-desc-col job-description\">\n                    <div\n                      class=\"job-description-text\"\n                      ng-class=\"{expanded: !job.isCollapsed}\"\n                    >\n                      <p\n                        ng-bind-html=\"job.description\"\n                        class=\"\"\n                        align=\"justify\"\n                      ></p>\n                    </div>\n                    <a\n                      href=\"\"\n                      class=\"text-info\"\n                      ng-show=\"job.isCollapsed && job.showButton\"\n                      ng-click=\"matchesController.showMore(job);\"\n                      ><b class=\"text-more\">more</b></a\n                    >\n                    <a\n                      href=\"\"\n                      class=\"text-info\"\n                      ng-show=\"!job.isCollapsed && job.showButton\"\n                      ng-click=\"matchesController.showLess(job);\"\n                      ><b class=\"text-more\">less</b></a\n                    >\n                  </div>\n                </div>\n                <div\n                  class=\"pull-right col-lg-2 col-md-2 col-sm-3 col-xs-12 inhouse-action\"\n                >\n                  <div class=\"pull-right list-job-desc-col\">\n                    <div>\n                      <application-modal-directive\n                        user=\"matchesController.user\"\n                        candidate=\"matchesController.candidate\"\n                        position=\"job\"\n                        client=\"true\"\n                      ></application-modal-directive>\n\n                      <button\n                        ng-if=\"!matchesController.fetchHiddenJobs\"\n                        ng-disabled=\"job.isApplied\"\n                        ng-click=\"showHideJobModal(job, $event)\"\n                        class=\"btn btn-save\"\n                      >\n                        <span class=\"fa fa-eye-slash\"></span>&nbsp;Not for me\n                      </button>\n\n                      <button\n                        ng-if=\"matchesController.fetchHiddenJobs\"\n                        ng-click=\"matchesController.unHidePosition(job)\"\n                        class=\"btn btn-saved\"\n                      >\n                        <span class=\"text-save fa fa-eye-slash\"\n                          ><span\n                            style='font-family:\"Lato\", \"Helvetica Neue\", Arial, sans-serif;'\n                            >&nbsp;Hidden</span\n                          ></span\n                        >\n                        <span class=\"text-unsave fa fa-eye\"\n                          ><span\n                            style='font-family:\"Lato\", \"Helvetica Neue\", Arial, sans-serif;'\n                            >&nbsp;Unhide</span\n                          ></span\n                        >\n                      </button>\n                    </div>\n\n                    <button\n                      data-testid=\"askQuestion\"\n                      class=\"btn btn-link text-info padding-0\"\n                      ng-click=\"matchesController.askQuestion(job,$event)\"\n                      firmName=\"{{firm.firm_Name}}\"\n                      firmID=\"{{firm.user_ID}}\"\n                    >\n                      {{'browseFirms.askQuestion.label' |translate}}\n                    </button>\n                    <div class=\"Job-id text-right margin-t5\">\n                      ID: {{job.employerId}}_{{job.id}}\n                    </div>\n                  </div>\n                </div>\n                <div\n                  class=\"clearfix col-md-12 col-sm-12 col-xs-12 custom-width pad-r0\"\n                >\n                  <div\n                    class=\"inner-list-inhouse clearfix hidden-xs\"\n                    ng-show=\"!job.isCollapsed && job.showButton\"\n                  >\n                    <div class=\"pull-right list-job-desc-col\">\n                      <application-modal-directive\n                        user=\"matchesController.user\"\n                        candidate=\"matchesController.candidate\"\n                        position=\"job\"\n                        client=\"true\"\n                      ></application-modal-directive>\n                      <br />\n                      <button\n                        class=\"btn btn-link text-info pull-right padding-0 margin-r5\"\n                        ng-click=\"matchesController.askQuestion(job,$event)\"\n                        firmName=\"{{firm.firm_Name}}\"\n                        firmID=\"{{firm.user_ID}}\"\n                      >\n                        {{'browseFirms.askQuestion.label' |translate}}\n                      </button>\n                    </div>\n                  </div>\n                </div>\n              </div>\n\n              <!-- End of exxplore Div -->\n            </div>\n          </div>\n          <div class=\"custom-table-body\" ng-if=\"spinneractive\"></div>\n          <div\n            ng-if=\"matchesController.noJob && !matchesController.fetchHiddenJobs\"\n          >\n            <center>\n              <p class=\"inhouse-blank-slate\">\n                {{matchesController.alertOne}}<a\n                  href=\"/user-profile?tab=preferences\"\n                  style=\"color: #95288f;\"\n                  >Preferences</a\n                >{{matchesController.alertTwo}}\n              </p>\n            </center>\n          </div>\n          <div\n            ng-if=\"matchesController.noJob && matchesController.fetchHiddenJobs\"\n          >\n            <center>\n              <p class=\"inhouse-blank-slate\">\n                You currently have no Hidden Jobs.\n              </p>\n            </center>\n          </div>\n          <!-- Firm List Item End -->\n\n          <footer\n            class=\"table-footer table-dynamic bt-1\"\n            ng-show=\"!matchesController.noJob\"\n          >\n            <div class=\"row\">\n              <div class=\"page-num-info\">\n                <span>\n                  Show\n                  <span class=\"ui-select select-enty-count\">\n                    <select\n                      data-ng-model=\"matchesController.numPerPage\"\n                      data-ng-options=\"num for num in matchesController.numPerPageOpt\"\n                      data-ng-change=\"matchesController.onNumPerPageChange()\"\n                    >\n                    </select>\n                  </span>\n                  entries per page\n                </span>\n              </div>\n\n              <div class=\"text-right pagination-container custom-pagination\">\n                <pagination\n                  class=\"pagination-sm\"\n                  ng-model=\"matchesController.currentPage\"\n                  total-items=\"!matchesController.fetchHiddenJobs ? matchesController.totalPositions:matchesController.hiddenPositions\"\n                  max-size=\"4\"\n                  ng-change=\"matchesController.select(matchesController.currentPage)\"\n                  items-per-page=\"matchesController.numPerPage\"\n                  rotate=\"false\"\n                  boundary-links=\"true\"\n                >\n                </pagination>\n              </div>\n            </div>\n          </footer>\n        </section>\n      </div>\n    </div>\n  </div>\n  <!-- End Container -->\n\n  <!-- Footer -->\n  <div lexstep-footer></div>\n  <!-- Footer Ends-->\n\n  <script type=\"text/ng-template\" id=\"welcome-modal.html\">\n    <welcome-modal-popup>  </welcome-modal-popup>\n  </script>\n\n  <hide-position-employer-modal\n    modal-open-handler=\"showHideJobModal\"\n    page=\"matchesController.pageName\"\n    consultant=\"user.assignedAdminDetails\"\n    on-position-hide=\"matchesController.hidePositionFromUI(position)\"\n    on-employer-hide=\"matchesController.hideEmployerFromUI(position)\"\n  >\n  </hide-position-employer-modal>\n\n  <!--Script for read more directive -->\n  <script type=\"text/ng-template\" id=\"template.html\">\n    <span ng-if=\"hmtext.length > hmlimit\">\n      <span style=\"display:block;\" ng-hide=\"hmfulltext\">\n        {{ hmtext | limitTo:hmlimit }}...\n        <a ngclass=\"{{ hmMoreClass }}\" ng-click=\"toggleValue()\">{{ hmMoreText }}</a>\n      </span>\n\n      <span style=\"display:block;\" ng-show=\"hmfulltext\">\n        {{ hmtext }}\n        <a ng-class=\"{{ hmLessClass }}\" ng-click=\"toggleValue()\">{{ hmLessText }}</a>\n      </span>\n    </span>\n\n    <span ng-if=\"hmtext.length <= hmlimit\">\n      {{ hmtext }}\n    </span>\n  </script>\n</div>\n<contact-admin> </contact-admin>\n"

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-signin\">\n  <div lexstep-header></div>\n  <notes-directive></notes-directive>\n\n  <footer class=\"footer\">\n    <div class=\"container\">\n      <div ng-include src=\"'views/pages/admin-footer.html'\"></div>\n    </div>\n  </footer>\n</div>\n"

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"page-signin\"\n  data-ng-controller=\"ReferFriendController as referCtrl\"\n>\n  <div lexstep-header></div>\n  <!-- Header Ends -->\n\n  <!-- old browser top alert -->\n  <div\n    data-ng-controller=\"IsOldBrowserController as isOldBrowser\"\n    class=\"container\"\n  >\n    <div class=\"old-browser-alert\" ng-show=\"isOldBrowser.showOldBrowser\">\n      <div class=\"callout bg-warning margin-t0\" type=\"info\">\n        You are using an older version of the browser that may not support\n        LexStep features. Please\n        <a\n          target=\"_blank\"\n          class=\"text-info\"\n          href=\"http://windows.microsoft.com/en-us/internet-explorer/download-ie\"\n          >upgrade</a\n        >\n        for improved experience.\n      </div>\n    </div>\n  </div>\n\n  <div class=\"container\" ng-click=\"referCtrl.hideDropDown()\">\n    <div class=\"panel-body heading-jobs-listings row\">\n      <center>\n        <h1 class=\"text-thin hdng-tshadow margin-b0\">\n          Invite your friends to LexStep and we'll send you £1,000 for every\n          friend that ever moves throughout their career using LexStep!\n        </h1>\n        <br />\n        <h4 class=\"hidden col-md-offset-2 col-md-8 text-thin hdng-tshadow\">\n          Invite your friends to LexStep and we'll send you £1,000 for every\n          friend that ever moves throughout their career using LexStep!\n        </h4>\n      </center>\n    </div>\n\n    <div class=\"panel panel-default \">\n      <div class=\"panel-body row\">\n        <section class=\"refer-section\">\n          <br />\n          <div class=\"col-md-offset-1 col-md-10\" align=\"justify\">\n            <h2 class=\"options\">\n              <strong>How to refer your friends:</strong>\n            </h2>\n            <div class=\"information\">\n              <p class=\"lead\">\n                Here is your unique referral link:\n                <b\n                  ><a\n                    style=\" text-decoration: none;\"\n                    ng-href=\"{{referCtrl.dataLink}}\"\n                    target=\"_blank\"\n                    class=\"text-info refer-message\"\n                    >{{referCtrl.dataLink}}</a\n                  ></b\n                >.\n              </p>\n              <p class=\"lead\">\n                Anyone who registers with LexStep via this link will be tracked\n                to your account and we will send you £1,000 for each friend that\n                finds a new role!\n              </p>\n            </div>\n\n            <div class=\"options\">\n              <div class=\"first-step\">\n                <h3 class=\"options-heading\">\n                  Option 1. Copy and share your personalised link below\n                </h3>\n                <div class=\"clearfix clip-board\">\n                  <div class=\"col-md-4 col-sm-6 col-xs-11 steps\">\n                    <input\n                      data-testid=\"referal-link-field\"\n                      type=\"text\"\n                      id=\"ref-code\"\n                      class=\"form-control ng-pristine ng-invalid ng-invalid-required ng-valid-email\"\n                      value=\"{{referCtrl.dataLink}}\"\n                      required=\"\"\n                    />\n                  </div>\n                  <div class=\"col-md-3 steps\">\n                    <button\n                      clipboard\n                      text=\"referCtrl.textTocopy\"\n                      on-copied=\"referCtrl.copySuccess()\"\n                      on-error=\"referCtrl.copyFail(err)\"\n                      class=\"btn btn-w-md btn-info btn-default margin-r15\"\n                    >\n                      Copy to Clipboard\n                    </button>\n                  </div>\n                </div>\n              </div>\n              <div class=\"third-step\">\n                <h3 class=\"options-heading\">\n                  Option 2. We send an email on your behalf\n                </h3>\n                <div\n                  class=\"clearfix clip-board\"\n                  ng-repeat=\"friend in referCtrl.friendsList track by $index\"\n                >\n                  <div class=\"col-md-4 col-sm-5 col-xs-11 steps\">\n                    <input\n                      data-testid=\"friend-name\"\n                      type=\"text\"\n                      class=\"info-inputs form-control ng-pristine\"\n                      ng-model=\"friend.name\"\n                      placeholder=\"Name\"\n                    />\n                  </div>\n\n                  <div class=\"col-md-4 col-sm-5 col-xs-11 steps\">\n                    <input\n                      data-testid=\"friend-email\"\n                      type=\"email\"\n                      class=\"info-inputs form-control ng-pristine ng-invalid ng-invalid-required ng-valid-email\"\n                      ng-model=\"friend.email\"\n                      placeholder=\"Enter email address\"\n                      ng-change=\"showOnError = false;\"\n                      required=\"\"\n                    />\n                  </div>\n\n                  <div\n                    class=\"col-md-4 col-sm-2 col-xs-1 finish-btn\"\n                    ng-hide=\"referCtrl.friendsList.length < 2\"\n                    ng-click=\"referCtrl.removeFriend(friend)\"\n                  >\n                    <a\n                      data-testid=\"cancel\"\n                      href=\"\"\n                      id=\"edit-phone\"\n                      class=\"btn btn-noline-info btn-xs\"\n                      ng-click=\"referCtrl.editPhone = false; referCtrl.cancelPhone()\"\n                      ><i class=\"fa fa-times refer-close\"></i\n                    ></a>\n                  </div>\n                </div>\n                <div class=\"row \">\n                  <div class=\"col-md-4 col-xs-6 steps\">\n                    <button\n                      data-testid=\"add-another-friend\"\n                      type=\"button\"\n                      class=\"btn btn-link\"\n                      ng-click=\"referCtrl.anotherFriend()\"\n                      ng-disabled=\"referCtrl.friendsList.length === 5\"\n                    >\n                      + Add another friend\n                    </button>\n                  </div>\n\n                  <div class=\"col-md-4 col-xs-6\">\n                    <p class=\"new\">(Up to 5)</p>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"clearfix\">\n              <div\n                style=\"margin-top: 6px; margin-left: -18px\"\n                class=\"col-md-12\"\n              >\n                <p\n                  class=\"send-button-state-info\"\n                  ng-show=\"!referCtrl.isFriendsListFilled()\"\n                >\n                  Please enter valid email(s)\n                </p>\n                <button\n                  class=\"btn btn-info\"\n                  ng-click=\"referCtrl.sendReferEmail()\"\n                  ng-disabled=\"!referCtrl.isFriendsListFilled()\"\n                >\n                  Send Email\n                </button>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"col-md-offset-2 col-md-8\">\n            <h6>&nbsp;</h6>\n          </div>\n        </section>\n      </div>\n    </div>\n  </div>\n  <!-- Body Ends -->\n\n  <!-- Footer -->\n  <div lexstep-footer></div>\n  <!-- Footer Ends-->\n</div>\n"

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

	module.exports = "\n<div class=\"cleafix\">\n  <!--\n  /**************************************************************************/\n  /*** ML Query Builder implemented By Fahad Akbar(fahadakbar24@gmail.com)***/\n  /**************************************************************************/\n  -->\n\n  <!-- START: saved filters section -->\n  <div class=\"clearfix\">\n    <div class=\"col-sm-12\">\n\n      <h4 class=\"inlineBlock margin-r5\"> Saved Filters </h4>\n      <a href=\"\" tooltip=\"\n      Selecting a Saved Filter will refine the initial search in accordance\n       with the pre configured rules for that Saved Filter.\n      \" tooltip-placement=\"right\">\n          <span class=\"badge badge-grey\">\n              <i class=\"fa fa-info\"></i>\n          </span>\n      </a>\n\n    </div>\n  </div>\n\n  <div class=\"clearfix\">\n    <div class=\"col-md-12\">\n      <!-- List of saved filters -->\n      <ul class=\"list-inline margin-b0 margin-t10 for-position\">\n        <!-- A single Filter  -->\n        <li ng-repeat=\"savedFilter in savedFilters\" class=\"margin-t5\">\n          <!-- filter's name  -->\n          <span\n            class=\"btn\"\n            ng-click=\"applyRules(savedFilter)\"\n            ng-class=\"{\n              'btn-border': !savedFilter.isApplied && !savedFilter.isBeingEdited,\n              'btn-info': savedFilter.isApplied || savedFilter.isBeingEdited\n            }\">\n\n            <span>{{savedFilter.name}}</span>\n            <!-- Edit Icon -->\n            <span ng-class=\"{'show-on-hover': (savedFilter.isApplied && savedFilter.isBeingEdited) || (!savedFilter.isApplied && !savedFilter.isBeingEdited) }\" ng-click=\"editSavedFilter($event, savedFilter)\" class=\"padding-l10 pointer\" tooltip=\"Edit This Filter\" tooltip-placement=\"top\">\n              <i class=\"fa fa-pencil\"></i>\n            </span>\n            <!-- Delete Icon -->\n            <span ng-click=\"removeSavedFilter($event, savedFilter)\" class=\"show-on-hover padding-L5 pointer\" tooltip=\"Delete This Filter\" tooltip-placement=\"top\">\n              <i class=\"fa fa-trash-o\"></i>\n            </span>\n          </span>\n        </li>\n      </ul>\n      <!-- Create Filter Link -->\n      <!-- <div class=\"padding-l10 margin-t20\">\n        <a class=\"pointer text-info\" ng-click=\"createNewRules()\" >\n          Create New Filter\n        </a>\n      </div> -->\n    </div>\n  </div>\n\n  <!-- END: saved filters section -->\n\n  <!-- START: ADVANCED filters section -->\n  <div class=\"clearfix text-purple pointer\" ng-init=\"showAdvancedFilters = false\">\n    <!-- advanced filters Heading section  -->\n    <a class=\"for-text-decoration text-info pull-right padding-0-10-0-0\" ng-click=\"setVisibilityForAdvancedFilters(!showAdvancedFilters)\">\n      <img ng-src=\"/images/caret-{{showAdvancedFilters ?'down' : 'up'}}-blue.png\">\n      <span> Advanced Filters </span>\n    </a>\n  </div>\n\n  <hr>\n\n  <!-- Builder's Ui  -->\n  <div class=\"clearfix\" ng-show=\"showAdvancedFilters\">\n    <div class=\"clearfix\">\n      <div class=\"col-sm-10\">\n        <h4>{{isBuilderShownForEditing ? 'Edit ' :'Select '}}Additional Candidate Activity and Profile Filters</h4>\n\n        <div class=\"margin-b20\">\n          <span class=\"color-gray text-normal display-block\">\n            Select / Edit the rules and lawyer profile/activity filters to refine your search.\n\n            <a href=\"\" class=\"margin-l5\" tooltip=\"\n              Tip: Selecting AND will return lawyers that match all rules nested after it. Selecting OR will return lawyers that match any rules nested after it (i.e. selecting OR will return a wider search).\n              \" tooltip-placement=\"right\">\n                  <span class=\"badge badge-grey\">\n                    <i class=\"fa fa-info\"></i>\n                  </span>\n            </a>\n          </span>\n        </div>\n\n        <div class=\"edit-heading-filter-name\" ng-if=\"isBuilderShownForEditing\">\n          <input type=\"text\" ng-show=\"filterToUpdate.editFilterName\" placeholder=\"Filter Name\" class=\"form-control inline\" ng-model=\"filterToUpdate.name\" ng-blur=\"checkNameAndRulesChangeToToggleUpdateButton()\" ng-change=\"checkNameAndRulesChangeToToggleUpdateButton()\"/>\n\n          <span ng-show=\"!filterToUpdate.editFilterName\">\n            {{filterToUpdate.name}}\n            <a ng-href=\"\" class=\"btn btn-noline-info btn-xs margin-l5\" ng-click=\"toggleFilterNameEdit()\">\n              <span id=\"edit-email\" class=\"fa fa-pencil\"></span>\n            </a>\n          </span>\n        </div>\n\n        <!-- Container to hold and apply the Jquery query builder plugin -->\n        <div id=\"builder\"></div>\n\n        <!-- Action buttons for builder -->\n        <div class=\" margin-t10\">\n          <!-- <button ng-disabled=\"!isAnyRuleDefined\" class=\"btn btn-success builder-actions\" ng-click=\"applyRules()\">\n            Apply Filters\n          </button> -->\n\n          <span class=\"builder-actions padding-0-10-0-0 padding-l15 margin-t20\">\n            <a class=\"btn btn-border\" ng-disabled=\"!isAnyRuleDefined\" href=\"javascript://\" class=\"text-purple\" ng-show=\"!isBuilderShownForEditing\" ng-click=\"saveRules()\">\n              Save Filter\n            </a>\n\n            <a class=\"btn btn-border\" ng-disabled=\"!isAnyRuleDefined || isUpdateFilterButtonDisabled\" href=\"javascript://\" class=\"text-purple\" ng-show=\"isBuilderShownForEditing\" ng-click=\"updateSavedFilter(filterToUpdate)\">\n              Update Filter\n            </a>\n          </span>\n          <!-- Reset Button -->\n          <button class=\"btn btn-border\" ng-click=\"resetRules()\">Reset Filters</button>\n        </div>\n      </div>\n\n    </div>\n\n    <div class=\"clearfix\">\n      <hr />\n    </div>\n  </div>\n  <!-- END: ADVANCED filters section -->\n\n  <!-- START: Save filters with a name popup section -->\n  <script type=\"text/ng-template\" id=\"saveRulesModal.html\">\n    <div class=\"modal-header\">\n      <!-- popup heading -->\n      <center>\n        <h3>Save Filter</h3>\n      </center>\n    </div>\n\n    <div class=\"modal-body\">\n      <div class=\"modal-row\">\n        <!-- Name to be used -->\n        <div class=\"clearfix\">\n          <form name=\"saveRulesForm\">\n            <div class=\"col-sm-4 text-center padding-t10\"> Name Your Filter </div>\n            <div class=\"col-sm-8\">\n              <input class=\"form-control\" type=\"text\" name=\"saveRulesName\" ng-model=\"saveRulesName\" placeholder=\"Type your filter's name\" required/>\n            </div>\n          </form>\n        </div>\n\n      </div>\n    </div>\n\n    <!-- Action buttons for save name popup -->\n    <div class=\"modal-footer\">\n        <center>\n          <button class=\"btn btn-info\" ng-click=\"saveName(saveRulesName)\">Save</button>\n          <button class=\"btn btn-gap-v btn-default\" ng-click=\"cancelSavingName()\">Cancel</button>\n        </center>\n    </div>\n  </script>\n  <!-- END: Save filters with a name popup section -->\n\n</div>"

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"page-signin\"\n  data-ng-controller=\"CreateUpdateEmployerController as ctrl\"\n>\n  <div lexstep-header></div>\n\n  <div class=\"container\">\n    <span\n      us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n      spinner-key=\"{{ctrl.employerSpinnerId}}\"\n      class=\"spinner-static-center\"\n    ></span>\n\n    <div class=\"panel-body heading-jobs-listings row\">\n      <center>\n        <h1 class=\"text-thin hdng-tshadow\">\n          {{ctrl.page.behaviorPlaceholder}} {{ctrl.page.entityPlaceholder}}\n        </h1>\n      </center>\n    </div>\n\n    <div class=\"clearfix\">\n      <alert\n        type=\"{{ctrl.showOnError ?'danger' :'success'}}\"\n        class=\"col-md-12\"\n        ng-show=\"ctrl.showOnError || ctrl.showOnSuccess\"\n      >\n        <center>\n          <strong>{{ctrl.alertMsg}}</strong>\n        </center>\n      </alert>\n    </div>\n\n    <div class=\"panel panel-default\">\n      <div class=\"panel-body\">\n        <form class=\"form-horizontal firm-creation\" name=\"employerForm\">\n          <!-- Firm logo -->\n          <br />\n          <div class=\"row\" ng-init=\"logoUpdated=false\">\n            <div class=\"h5 col-md-4 text-right\">\n              {{ctrl.page.entityPlaceholder}} Logo\n            </div>\n            <div class=\"col-md-5\">\n              <input\n                type=\"file\"\n                file-upload=\"ctrl.selectedFile\"\n                accept=\"image/*\"\n              />\n\n              <span>{{ctrl.selectedFile ? '' :ctrl.employer.logo}}</span>\n            </div>\n            <div class=\"col-md-3\">\n              <p ng-if=\"!ctrl.selectedEmployerId\">\n                200 x 200 pixels recommended\n              </p>\n              <button\n                class=\"btn btn-danger text-center\"\n                ng-if=\"ctrl.selectedEmployerId\"\n                ng-click=\"ctrl.openDeleteEmployerModal(ctrl.selectedEmployerId)\"\n                ng-disabled=\"ctrl.showOnError\"\n              >\n                Delete {{ctrl.page.entityPlaceholder}}\n              </button>\n            </div>\n          </div>\n          <br ng-if=\"ctrl.selectedEmployerId\" />\n\n          <div class=\"row\" ng-if=\"ctrl.selectedEmployerId\">\n            <div class=\"h5 col-md-4 text-right\">\n              {{ctrl.page.entityPlaceholder}} ID\n            </div>\n            <div class=\"col-md-5\">\n              <span data-testid=\"employer-id\" class=\"inlineBlock margin-t10\">\n                {{ ctrl.employer.id }}\n              </span>\n            </div>\n          </div>\n          <br />\n\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">\n              {{ctrl.page.entityPlaceholder}} Name *\n            </div>\n            <div class=\"col-md-5\">\n              <input\n                type=\"text\"\n                data-testid=\"employer-name\"\n                autocomplete=\"off\"\n                placeholder=\"Employer Name\"\n                class=\"form-control\"\n                ng-model=\"ctrl.employer.name\"\n                required\n              />\n              <div class=\"space\"></div>\n            </div>\n          </div>\n          <div class=\"row\" ng-hide=\"!ctrl.isPrivatePractice\">\n            <div class=\"h5 col-md-4 text-right\">\n              {{ctrl.page.entityPlaceholder}} Size *\n            </div>\n            <div class=\"col-md-5\">\n              <input\n                type=\"number\"\n                data-testid=\"employer-size\"\n                id=\"firm-mgt-size\"\n                autocomplete=\"off\"\n                min=\"0\"\n                placeholder=\"Employer Size\"\n                class=\"form-control\"\n                ng-model=\"ctrl.employer.lawProfile.size\"\n                ng-required=\"ctrl.isPrivatePractice\"\n                only-numbers\n              />\n            </div>\n\n            <div class=\"col-md-3\">\n              <label class=\"ui-checkbox\" style=\"margin-top:5px\">\n                <input\n                  name=\"show-firm-size\"\n                  data-testid=\"employer-size-visibility\"\n                  id=\"firm-mgt-size-chkbx\"\n                  type=\"checkbox\"\n                  ng-model=\"ctrl.employer.lawProfile.sizeVisible\"\n                />\n                <span>Show Publicly</span>\n              </label>\n            </div>\n          </div>\n          <br ng-hide=\"!ctrl.isPrivatePractice\" />\n\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">\n              {{ctrl.page.entityPlaceholder}} Category *\n            </div>\n            <div class=\"col-md-5\">\n              <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n                <select\n                  style=\"padding: 8px 10px; width: 100%;\"\n                  data-testid=\"employer-category\"\n                  id=\"firm-mgt-category\"\n                  ng-change=\"ctrl.changeEmployerCategory(ctrl.employer.categoryId)\"\n                  ng-model=\"ctrl.employer.categoryId\"\n                  ng-required=\"ctrl.selectedEmployerId? ctrl.employer.approved:true\"\n                >\n                  <option value=\"\" disabled selected style=\"display:none;\"\n                    >{{ctrl.page.entityPlaceholder}} Category</option\n                  >\n                  <option\n                    ng-repeat=\"category in ctrl.categories\"\n                    ng-value=\"{{category.id}}\"\n                    ng-selected=\"category.id == ctrl.employer.categoryId\"\n                  >\n                    {{category.name}}\n                  </option>\n                </select>\n              </span>\n            </div>\n            <div ng-if=\"ctrl.selectedEmployerId\" class=\"col-md-3\">\n              <label class=\"ui-checkbox\" style=\"margin-top:5px\">\n                <input\n                  data-testid=\"employer-approved\"\n                  id=\"firm-mgt-target-chkbx\"\n                  ng-change=\"ctrl.onEmployerApproved(ctrl.employer.approved)\"\n                  ng-model=\"ctrl.employer.approved\"\n                  name=\"show-employer-approved\"\n                  type=\"checkbox\"\n                  value=\"show\"\n                />\n                <span>Approved</span>\n              </label>\n            </div>\n          </div>\n          <br />\n          <div class=\"row\">\n            <div class=\"clearfix\">\n              <div class=\"h5 col-md-4 text-right\">\n                {{ctrl.page.entityPlaceholder}} Selectivity *\n              </div>\n\n              <div class=\"col-md-5\">\n                <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n                  <select\n                    data-testid=\"employer-selectivity\"\n                    id=\"firm-mgt-selectivity\"\n                    style=\"padding: 8px 10px; width: 100%;\"\n                    ng-model=\"ctrl.employer.selectivity\"\n                    required\n                  >\n                    <option class=\"hidden\" value=\"\" selected disabled\n                      >{{ctrl.page.entityPlaceholder}} Selectivity</option\n                    >\n                    <option\n                      ng-repeat=\"selectivity in ctrl.selectivity\"\n                      ng-value=\"{{selectivity.id}}\"\n                      ng-selected=\"selectivity.id == ctrl.employer.selectivity\"\n                    >\n                      {{selectivity.name}}\n                    </option>\n                  </select>\n                </span>\n              </div>\n            </div>\n\n            <br />\n          </div>\n\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">\n              <span ng-if=\"ctrl.selectedEmployerId\"\n                >{{ctrl.page.entityPlaceholder}} Practice Areas\n              </span>\n              <span ng-if=\"!ctrl.selectedEmployerId\"\n                >{{ctrl.page.entityPlaceholder}} Practice Areas\n              </span>\n            </div>\n            <div\n              class=\"col-md-6 text-left\"\n              ng-show=\"!ctrl.selectedPracticesShow  && ctrl.showPracticeButton\"\n            >\n              <button\n                data-testid=\"employer-practice-area\"\n                class=\"btn btn-line-info\"\n                ng-click=\"ctrl.openPracticeModal(null,$event)\"\n              >\n                Click to specify\n              </button>\n            </div>\n            <div class=\"divider clearfix\"></div>\n            <div\n              class=\"col-md-5 text-left\"\n              ng-show=\"ctrl.selectedPracticesShow\"\n            >\n              <ul\n                data-testid=\"employer-selected-practice-area\"\n                id=\"taglist\"\n                class=\"list-inline list-practice-area margin-b0\"\n              >\n                <li\n                  class=\"tags-box\"\n                  ng-if=\"practiceArea.isSelected\"\n                  ng-repeat=\"practiceArea in ctrl.employer.practiceAreas \"\n                >\n                  {{practiceArea.name}}\n                </li>\n                <a\n                  href=\"\"\n                  class=\"fa fa-pencil\"\n                  ng-click=\"ctrl.openPracticeModal(ctrl.employer.practiceAreas ,$event)\"\n                ></a>\n              </ul>\n            </div>\n          </div>\n          <br />\n\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">\n              <span ng-if=\"ctrl.selectedEmployerId\"\n                >{{ctrl.page.entityPlaceholder}} Office Locations\n              </span>\n              <span ng-if=\"!ctrl.selectedEmployerId\"\n                >{{ctrl.page.entityPlaceholder}} Office Locations\n              </span>\n            </div>\n            <div\n              class=\"col-md-6 text-left\"\n              ng-show=\"!ctrl.selectedLocation && ctrl.showLocationButton\"\n            >\n              <button\n                data-testid=\"employer-locations\"\n                class=\"btn btn-line-info\"\n                id=\"select-locations\"\n                ng-click=\"ctrl.openLocationModal(null,$event)\"\n              >\n                Click to specify\n              </button>\n            </div>\n            <div class=\"divider clearfix\"></div>\n            <div class=\"col-md-6 text-left\" ng-show=\"ctrl.selectedLocation\">\n              <ul\n                data-testid=\"employer-selected-locations\"\n                id=\"taglist\"\n                class=\"list-inline list-practice-area margin-b0\"\n              >\n                <li\n                  class=\"tags-box\"\n                  ng-if=\"location.isSelected\"\n                  ng-repeat=\"location in ctrl.employer.locations\"\n                >\n                  {{location.name}}\n                </li>\n                <a\n                  href=\"\"\n                  class=\"fa fa-pencil\"\n                  id=\"select-locations\"\n                  ng-click=\"ctrl.openLocationModal(ctrl.employer.locations,$event)\"\n                ></a>\n              </ul>\n            </div>\n          </div>\n          <br />\n\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">\n              {{ctrl.page.entityPlaceholder}} Contact Name\n            </div>\n            <div class=\"col-md-5\">\n              <input\n                type=\"text\"\n                data-testid=\"employer-contact-name\"\n                id=\"firm-mgt-contact-name\"\n                autocomplete=\"off\"\n                placeholder=\"Employer Contact Name\"\n                class=\"form-control\"\n                ng-model=\"ctrl.employer.contactName\"\n              />\n              <div class=\"space\"></div>\n            </div>\n          </div>\n          <!-- firm email -->\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">\n              {{ctrl.page.entityPlaceholder}} Contact Email\n            </div>\n            <div class=\"col-md-5\">\n              <input\n                type=\"email\"\n                data-testid=\"employer-contact-email\"\n                id=\"firm-mgt-contact-email\"\n                autocomplete=\"off\"\n                pattern=\"^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9]{2,6}$\"\n                placeholder=\"Employer Contact Email\"\n                class=\"form-control\"\n                ng-model=\"ctrl.employer.contactEmail\"\n                oninvalid=\"setCustomValidity('Please enter valid email')\"\n                oninput=\"setCustomValidity('')\"\n              />\n              <div class=\"space\"></div>\n            </div>\n          </div>\n          <div class=\"row\" ng-hide=\"!ctrl.isPrivatePractice\">\n            <div class=\"h5 col-md-4 text-right\">Target Hours</div>\n            <div class=\"col-md-5\">\n              <input\n                type=\"text\"\n                data-testid=\"employer-target-hours\"\n                id=\"firm-mgt-target-hrs\"\n                autocomplete=\"off\"\n                placeholder=\"Target Hours\"\n                class=\"form-control\"\n                ng-model=\"ctrl.employer.lawProfile.targetHours\"\n              />\n            </div>\n            <div class=\"col-md-3\">\n              <label class=\"ui-checkbox\" style=\"margin-top:5px\">\n                <input\n                  data-testid=\"employer-target-hours-visibility\"\n                  id=\"firm-mgt-target-chkbx\"\n                  ng-model=\"ctrl.employer.lawProfile.targetHoursVisible\"\n                  name=\"show-firm-targetHours\"\n                  type=\"checkbox\"\n                  value=\"show\"\n                />\n                <span>Show Publicly</span>\n              </label>\n            </div>\n          </div>\n          <br ng-hide=\"!ctrl.isPrivatePractice\" />\n          <div class=\"row\" ng-hide=\"!ctrl.isPrivatePractice\">\n            <div class=\"h5 col-md-4 text-right\">£/$ Turnover</div>\n            <div class=\"col-md-5\">\n              <input\n                type=\"text\"\n                data-testid=\"employer-associatesPerPartner\"\n                id=\"firm-mgt-app\"\n                autocomplete=\"off\"\n                placeholder=\"£/$ Turnover\"\n                class=\"form-control\"\n                ng-model=\"ctrl.employer.lawProfile.associatesPerPartner\"\n                ng-pattern=\"/^[\\$\\£][\\ ]?[\\d,]+(\\.\\d*)?$/\"\n              />\n              <div class=\"space\"></div>\n            </div>\n            <div class=\"col-md-3\">\n              <label class=\"ui-checkbox\" style=\"margin-top:5px\">\n                <input\n                  name=\"show-firm-app\"\n                  data-testid=\"employer-associatesPerPartner-visibility\"\n                  id=\"firm-mgt-app-chkbx\"\n                  type=\"checkbox\"\n                  ng-model=\"ctrl.employer.lawProfile.associatesPerPartnerVisible\"\n                />\n                <span>Show Publicly</span>\n              </label>\n            </div>\n          </div>\n          <div class=\"row\" ng-hide=\"!ctrl.isPrivatePractice\">\n            <div class=\"h5 col-md-4 text-right\">\n              £/$ Profit per Equity Partner\n            </div>\n            <div class=\"col-md-5\">\n              <input\n                type=\"text\"\n                data-testid=\"employer-pep\"\n                id=\"firm-mgt-pep\"\n                autocomplete=\"off\"\n                class=\"form-control\"\n                placeholder=\"£/$ Profit per Equity Partner\"\n                ng-model=\"ctrl.employer.lawProfile.profitPerEquityPartner\"\n                ng-pattern=\"/^[\\$\\£][\\ ]?[\\d,]+(\\.\\d*)?$/\"\n              />\n            </div>\n            <div class=\"col-md-3\">\n              <label class=\"ui-checkbox\" style=\"margin-top:5px\">\n                <input\n                  name=\"show-firm-pep\"\n                  data-testid=\"employer-pep-visibility\"\n                  id=\"firm-mgt-chkbx\"\n                  type=\"checkbox\"\n                  ng-model=\"ctrl.employer.lawProfile.profitPerEquityPartnerVisible\"\n                />\n                <span>Show Publicly</span>\n              </label>\n            </div>\n          </div>\n          <br ng-hide=\"!ctrl.isPrivatePractice\" />\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">Salary</div>\n            <div class=\"col-md-5\">\n              <input\n                type=\"text\"\n                data-testid=\"employer-salary\"\n                id=\"firm-mgt-salary\"\n                autocomplete=\"off\"\n                class=\"form-control\"\n                placeholder=\"Salary\"\n                ng-model=\"ctrl.employer.lawProfile.nqSalary\"\n              />\n            </div>\n            <div class=\"col-md-3\">\n              <label class=\"ui-checkbox\" style=\"margin-top:5px\">\n                <input\n                  name=\"show-firm-salary\"\n                  data-testid=\"employer-salary-visibility\"\n                  id=\"firm-mgt-salary-chkbx\"\n                  type=\"checkbox\"\n                  ng-model=\"ctrl.employer.lawProfile.nqSalaryVisible\"\n                />\n                <span>Show Publicly</span>\n              </label>\n            </div>\n          </div>\n          <br />\n\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">\n              Address {{ctrl.page.mandatoryPlaceholder}}\n            </div>\n            <div class=\"col-md-5\">\n              <input\n                type=\"text\"\n                data-testid=\"employer-address\"\n                id=\"firm-mgt-address\"\n                autocomplete=\"off\"\n                placeholder=\"Address\"\n                class=\"form-control\"\n                ng-model=\"ctrl.employer.address\"\n                ng-required=\"ctrl.isPrivatePractice\"\n              />\n              <div class=\"space\"></div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">\n              {{ctrl.page.entityPlaceholder}} Visibility *\n            </div>\n            <div class=\"col-md-5\">\n              <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n                <select\n                  data-testid=\"employer-isVisible\"\n                  id=\"firm-mgt-visibility\"\n                  style=\"padding: 8px 10px; width: 100%;\"\n                  ng-model=\"ctrl.employer.isVisible\"\n                  required\n                >\n                  <option value=\"\" disabled selected style=\"display:none;\"\n                    >Visibility</option\n                  >\n                  <option\n                    ng-selected=\"ctrl.employer.isVisible===true\"\n                    ng-value=\"true\"\n                    >Visible to Applicants</option\n                  >\n                  <option\n                    ng-selected=\"ctrl.employer.isVisible===false\"\n                    ng-value=\"false\"\n                    >Invisible to Applicants</option\n                  >\n                </select>\n              </span>\n            </div>\n          </div>\n          <!-- Assigned Agent -->\n          <div class=\"row\" ng-if=\"ctrl.user\">\n            <!-- <div class=\"row\" ng-if=\"canViewAddFirmAssignedAdmin()\"> -->\n            <br />\n            <div class=\"h5 col-md-4 text-right\">Assigned Agent *</div>\n            <div class=\"col-md-5\">\n              <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n                <select\n                  data-testid=\"employer-assigned-admin\"\n                  id=\"firm-mgt-admin\"\n                  style=\"padding: 8px 10px; width: 100%;\"\n                  ng-model=\"ctrl.employer.agentId\"\n                  required\n                >\n                  <option value=\"\" disabled selected style=\"display:none;\"\n                    >Assign Admin</option\n                  >\n                  <option ng-value=\"0\" ng-selected=\"!ctrl.employer.agentId\">\n                    unassign\n                  </option>\n                  <option\n                    ng-value=\"{{agent.id}}\"\n                    ng-repeat=\"agent in ctrl.candidateAgentsList\"\n                    ng-selected=\"agent.id === ctrl.employer.agentId\"\n                  >\n                    {{agent.email}}\n                  </option>\n                </select>\n              </span>\n            </div>\n          </div>\n          <br />\n          <!-- description field -->\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">\n              {{ctrl.page.entityPlaceholder}} Description\n            </div>\n            <div class=\"col-md-5\">\n              <textarea\n                data-testid=\"employer-description\"\n                id=\"firm-mgt-description\"\n                ng-model=\"ctrl.employer.description\"\n                name=\"\"\n                id=\"\"\n                class=\"form-control\"\n                style=\"margin-bottom:10px; resize:none\"\n              ></textarea>\n            </div>\n          </div>\n          <br />\n          <!-- submit button -->\n          <div class=\"row\">\n            <div class=\"col-md-12\">\n              <center>\n                <button\n                  data-testid=\"employer-create\"\n                  id=\"firm-mgt-create-btn\"\n                  type=\"submit\"\n                  class=\"btn btn-info\"\n                  ng-if=\"!ctrl.selectedEmployerId\"\n                  ng-click=\"employerForm.$valid&&ctrl.addEmployer()\"\n                >\n                  Create\n                </button>\n\n                <button\n                  data-testid=\"employer-update\"\n                  id=\"firm-mgt-update-btn\"\n                  ng-if=\"ctrl.selectedEmployerId\"\n                  class=\"btn btn-success\"\n                  ng-click=\"employerForm.$valid && ctrl.updateEmployer()\"\n                  ng-disabled=\"ctrl.showOnError\"\n                >\n                  Save\n                </button>\n\n                <a\n                  data-testid=\"firm-cancel\"\n                  id=\"firm-mgt-cancel-btn\"\n                  class=\"btn btn-default\"\n                  href=\"/admin/employers-listing\"\n                  >Cancel</a\n                >\n              </center>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n  <script type=\"text/ng-template\" id=\"practice-area-modal.html\">\n    <practice-Area></practice-Area>\n  </script>\n\n  <script type=\"text/ng-template\" id=\"locations-modal.html\">\n    <locations-Modal></locations-Modal>\n  </script>\n\n  <footer class=\"footer\">\n    <div class=\"container\">\n      <div ng-include src=\"'views/pages/admin-footer.html'\"></div>\n    </div>\n  </footer>\n</div>\n<delete-Employer></delete-Employer>\n"

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"page-signin\"\n  data-ng-controller=\"CreateUpdatePositionController as ctrl\"\n>\n  <div lexstep-header></div>\n\n  <div class=\"container\" ng-click=\"ctrl.hideDropDown()\">\n    <div class=\"panel-body heading-jobs-listings row\">\n      <center>\n        <h1 class=\"text-thin hdng-tshadow\">{{ctrl.modalTitle}}</h1>\n      </center>\n    </div>\n\n    <div class=\"panel panel-default\">\n      <div class=\"panel-body\">\n        <form name=\"positionForm\" class=\"form-horizontal btn-position-creation\">\n          <br />\n          <!-- Firm name -->\n          <div class=\"row\">\n            <div class=\"col-md-3 text-center mobile-show\">\n              <button\n                class=\"btn btn-danger\"\n                ng-if=\"ctrl.editPositionModal\"\n                ng-click=\"ctrl.openDeletePositionModal(); $event.preventDefault();$event.stopPropagation();\"\n              >\n                Delete Position\n              </button>\n            </div>\n            <div class=\"h5 col-md-4 text-right\">\n              Employer Name *\n            </div>\n            <div class=\"col-md-5\">\n              <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n                <select\n                  data-testid=\"position-employers\"\n                  data-ng-model=\"ctrl.position.employer\"\n                  ng-change=\"ctrl.changeEmployer(ctrl.position.employer);\"\n                  ng-options=\"employer as employer.name for employer in ctrl.employersList\"\n                  required\n                >\n                </select>\n              </span>\n            </div>\n\n            <div class=\"col-md-3 text-center mobile-hide\">\n              <button\n                class=\"btn btn-danger\"\n                ng-if=\"ctrl.editPositionModal\"\n                ng-click=\"ctrl.openDeletePositionModal(); $event.preventDefault();$event.stopPropagation();\"\n              >\n                Delete Position\n              </button>\n            </div>\n          </div>\n          <br />\n          <!-- Practice areas -->\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">Practice Areas *</div>\n            <div\n              class=\"col-md-6 text-left\"\n              ng-show=\"!ctrl.selectedPracticesShow  && ctrl.showPracticeButton\"\n            >\n              <button\n                data-testid=\"position-practices\"\n                class=\"btn btn-line-info\"\n                ng-click=\"ctrl.openPracticeModal(null,$event)\"\n              >\n                Click to specify\n              </button>\n            </div>\n            <div class=\"divider clearfix\"></div>\n            <div\n              class=\"col-md-5 text-left\"\n              ng-show=\"ctrl.selectedPracticesShow\"\n            >\n              <ul\n                data-testid=\"position-selected-practices\"\n                id=\"taglist\"\n                class=\"list-inline list-practice-area margin-b0\"\n              >\n                <li\n                  class=\"tags-box\"\n                  ng-if=\"practiceArea.isSelected\"\n                  ng-repeat=\"practiceArea in ctrl.position.practiceAreas \"\n                >\n                  {{practiceArea.name}}\n                </li>\n                <a\n                  href=\"\"\n                  class=\"fa fa-pencil\"\n                  ng-click=\"ctrl.openPracticeModal(ctrl.position.practiceAreas ,$event)\"\n                ></a>\n              </ul>\n            </div>\n          </div>\n          <br />\n\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">Position Title *</div>\n            <div class=\"col-md-5\">\n              <input\n                type=\"text\"\n                data-testid=\"position-title\"\n                autocomplete=\"off\"\n                class=\"form-control\"\n                placeholder=\"Position Title\"\n                data-ng-model=\"ctrl.position.title\"\n                required\n              />\n            </div>\n          </div>\n          <br />\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">Locations *</div>\n            <div\n              class=\"col-md-6 text-left\"\n              ng-show=\"!ctrl.selectedLocation && ctrl.showLocationButton\"\n            >\n              <button\n                data-testid=\"position-locations\"\n                class=\"btn btn-line-info\"\n                id=\"select-locations\"\n                ng-click=\"ctrl.openLocationModal(null,$event)\"\n              >\n                Click to specify\n              </button>\n            </div>\n            <div class=\"divider clearfix\"></div>\n            <div class=\"col-md-6 text-left\" ng-show=\"ctrl.selectedLocation\">\n              <ul\n                data-testid=\"position-selected-locations\"\n                id=\"taglist\"\n                class=\"list-inline list-practice-area margin-b0\"\n              >\n                <li\n                  class=\"tags-box\"\n                  ng-if=\"location.isSelected\"\n                  ng-repeat=\"location in ctrl.position.locations\"\n                >\n                  {{location.name}}\n                </li>\n                <a\n                  href=\"\"\n                  class=\"fa fa-pencil\"\n                  id=\"select-locations\"\n                  ng-click=\"ctrl.openLocationModal(ctrl.position.locations,$event)\"\n                ></a>\n              </ul>\n            </div>\n          </div>\n          <br />\n\n          <!-- Address -->\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">Address</div>\n            <div class=\"col-md-5\">\n              <input\n                type=\"text\"\n                data-testid=\"position-address\"\n                autocomplete=\"off\"\n                placeholder=\"Address\"\n                class=\"form-control\"\n                ng-model=\"ctrl.position.employer.address\"\n              />\n              <!-- <div class=\"space\"></div> -->\n            </div>\n          </div>\n          <br />\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">Position Expires on</div>\n\n            <div\n              class=\"col-md-5\"\n              name=\"pqe\"\n              data-ng-controller=\"DatePickerController as datePickerCtrl\"\n            >\n              <div\n                data-testid=\"position-expiryAt\"\n                class=\"input-group add-new-job-ui-datepicker\"\n              >\n                <input\n                  type=\"text\"\n                  disabled\n                  class=\"form-control custom-readonly\"\n                  placeholder=\"Position Expiry date\"\n                  uib-datepicker-popup=\"{{datePickerCtrl.format}}\"\n                  ng-model=\"ctrl.position.expiresAt\"\n                  is-open=\"datePickerCtrl.opened\"\n                  datepicker-options=\"datePickerCtrl.dateOptions\"\n                  ng-class=\"ctrl.selectedModal.errorClass\"\n                  close-text=\"Close\"\n                />\n                <span\n                  class=\"input-group-addon\"\n                  ng-click=\"datePickerCtrl.open($event)\"\n                >\n                  <i class=\"fa fa-calendar\"></i>\n                </span>\n              </div>\n            </div>\n          </div>\n          <br /><br />\n\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">Min PQE *</div>\n            <div class=\"col-md-5\">\n              <input\n                data-testid=\"job-pqe\"\n                ng-model=\"ctrl.position.\"\n                ng-change=\"ctrl.pqeChange()\"\n                autocomplete=\"off\"\n                type=\"text\"\n                id=\"mySlider1\"\n                slider\n                options=\"ctrl.pqeOptions\"\n              />\n              <div class=\"space\"></div>\n            </div>\n          </div>\n\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">Required Experience *</div>\n            <div class=\"col-md-5\">\n              <input\n                data-testid=\"job-pqe\"\n                ng-model=\"ctrl.position.pqe\"\n                ng-change=\"ctrl.pqeChange()\"\n                autocomplete=\"off\"\n                type=\"text\"\n                id=\"mySlider1\"\n                slider\n                options=\"ctrl.pqeOptions\"\n              />\n              <div class=\"space\"></div>\n            </div>\n          </div>\n          <br />\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">Contract: *</div>\n            <div class=\" col-md-5\">\n              <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n                <select\n                  data-testid=\"position-contract\"\n                  data-ng-model=\"ctrl.position.contractTypeId\"\n                  style=\"padding: 8px 10px; width: 100%;\"\n                  required\n                >\n                  <option\n                    ng-repeat=\"contract in ctrl.contractType\"\n                    ng-value=\"{{contract.id}}\"\n                    >{{contract.name}}</option\n                  >\n                </select>\n              </span>\n            </div>\n          </div>\n          <br />\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">Occupation: *</div>\n            <div class=\" col-md-5\">\n              <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n                <select\n                  data-testid=\"position-occupation\"\n                  data-ng-model=\"ctrl.position.occupationId\"\n                  style=\"padding: 8px 10px; width: 100%;\"\n                  required\n                >\n                  <option\n                    ng-repeat=\"occupation in ctrl.occupations\"\n                    ng-value=\"{{occupation.id}}\"\n                    >{{occupation.name}}</option\n                  >\n                </select>\n              </span>\n            </div>\n          </div>\n          <br />\n\n          <!-- extra field 1 -->\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">Position Description</div>\n            <div class=\"col-md-5\">\n              <div class=\"text-editor\" data-testid=\"position-description\">\n                <textarea\n                  name=\"positionDescription\"\n                  class=\"form-control\"\n                  ckeditor=\"ctrl.positionDetailEditorOptions\"\n                  ng-model=\"ctrl.position.description\"\n                >\n                </textarea>\n\n                <p\n                  class=\"email-body-error-message\"\n                  ng-show=\"placeholdersModified\"\n                >\n                  Placeholders cannot be changed from Email body and Subject\n                  line\n                </p>\n              </div>\n            </div>\n          </div>\n          <br />\n\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right margin-t0\">Listing Type</div>\n            <div class=\"col-md-5\">\n              <dd>\n                <label class=\"ui-radio\"\n                  ><input\n                    data-testid=\"position-type\"\n                    name=\"positionType\"\n                    type=\"radio\"\n                    ng-value=\"1\"\n                    ng-model=\"ctrl.position.positionType\"\n                    checked\n                  /><span>Regular</span></label\n                >\n                <label class=\"ui-radio\"\n                  ><input\n                    data-testid=\"position-type\"\n                    name=\"positionType\"\n                    type=\"radio\"\n                    ng-value=\"2\"\n                    ng-model=\"ctrl.position.positionType\"\n                  /><span>Custom</span></label\n                >\n\n                <label class=\"ui-radio\"\n                  ><input\n                    data-testid=\"position-type\"\n                    name=\"positionType\"\n                    type=\"radio\"\n                    ng-value=\"3\"\n                    ng-model=\"ctrl.position.positionType\"\n                  /><span>Connect</span></label\n                >\n\n                <label class=\"ui-radio\"\n                  ><input\n                    data-testid=\"position-type\"\n                    name=\"positionType\"\n                    type=\"radio\"\n                    ng-value=\"4\"\n                    ng-model=\"ctrl.position.positionType\"\n                  /><span>Speculative</span></label\n                >\n\n                <label\n                  class=\"ui-radio\"\n                  ng-show=\"ctrl.position.employer.isInHouse\"\n                  ><input\n                    data-testid=\"position-type\"\n                    name=\"positionType\"\n                    type=\"radio\"\n                    ng-value=\"5\"\n                    ng-model=\"ctrl.position.positionType\"\n                  /><span>ATS Direct Link</span></label\n                >\n              </dd>\n            </div>\n          </div>\n\n          <div ng-show=\"ctrl.position.positionType == 1\" class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">Source/External Link</div>\n            <div class=\"col-md-5\">\n              <input\n                data-testid=\"position-regular-externalUrl\"\n                ng-disabled=\"ctrl.position.positionType !=1\"\n                type=\"text\"\n                autocomplete=\"off\"\n                placeholder=\"Enter your link..\"\n                class=\"form-control\"\n                ng-model=\"ctrl.position.externalUrl\"\n              />\n            </div>\n          </div>\n\n          <div ng-show=\"ctrl.position.positionType == 5\" class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">ATS Direct Link *</div>\n            <div class=\"col-md-5\">\n              <input\n                data-testid=\"position-ats-externalUrl\"\n                ng-disabled=\"ctrl.position.positionType != 5\"\n                type=\"text\"\n                autocomplete=\"off\"\n                placeholder=\"Enter your link..\"\n                class=\"form-control\"\n                ng-model=\"ctrl.position.externalUrl\"\n                ng-required=\"ctrl.position.positionType == 5\"\n              />\n            </div>\n          </div>\n          <br\n            ng-show=\"ctrl.position.positionType == 5 || ctrl.position.positionType == 1\"\n          />\n          <div class=\"row\">\n            <div class=\"h5 col-md-4 text-right\">Position Visibility *</div>\n            <div class=\" col-md-5\">\n              <span class=\"ui-select\" style=\"margin-left: 0; width: 60%;\">\n                <select\n                  data-testid=\"position-visibility\"\n                  data-ng-model=\"ctrl.position.visible\"\n                  style=\"padding: 8px 10px; width: 100%;\"\n                  required\n                >\n                  <option ng-value=\"\" selected style=\"display:none;\"\n                    >Visibility</option\n                  >\n                  <option\n                    ng-selected=\"ctrl.position.visible == true\"\n                    ng-value=\"true\"\n                    >Visible to Applicants</option\n                  >\n                  <option\n                    ng-selected=\"ctrl.position.visible == false\"\n                    ng-value=\"false\"\n                    >Invisible to Applicants</option\n                  >\n                </select>\n              </span>\n            </div>\n          </div>\n          <br />\n\n          <!-- submit button -->\n          <div class=\"row\">\n            <div class=\"col-md-12\">\n              <center>\n                <input\n                  ng-if=\"!ctrl.editPositionModal\"\n                  data-testid=\"btn-position-creation\"\n                  type=\"submit\"\n                  class=\"btn btn-success\"\n                  value=\"Create\"\n                  ng-click=\"positionForm.$valid && ctrl.createPosition()\"\n                />\n                <input\n                  ng-if=\"ctrl.editPositionModal\"\n                  data-testid=\"btn-update-position\"\n                  type=\"submit\"\n                  class=\"btn btn-success\"\n                  value=\"Update\"\n                  ng-click=\"ctrl.updatePosition()\"\n                />\n                <a\n                  data-testid=\"job-cancel\"\n                  class=\"btn btn-default\"\n                  href=\"/admin/admin-listings?list=jobs\"\n                  >Cancel</a\n                >\n              </center>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n\n  <footer class=\"footer\">\n    <div class=\"container\">\n      <div ng-include src=\"'views/pages/admin-footer.html'\"></div>\n    </div>\n  </footer>\n\n  <script type=\"text/ng-template\" id=\"practice-area-modal.html\">\n    <practice-Area></practice-Area>\n  </script>\n  <delete-Position></delete-Position>\n\n  <script type=\"text/ng-template\" id=\"locations-modal.html\">\n    <locations-Modal></locations-Modal>\n  </script>\n</div>\n"

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-signin\" data-ng-controller=\"SignInController as ctrl\">\n  <!--### mobile navbars -->\n  <div lexstep-header></div>\n  <!-- Header Ends -->\n\n  <div\n    data-ng-controller=\"IsOldBrowserController as isOldBrowser\"\n    class=\"container\"\n  >\n    <div class=\"old-browser-alert\" ng-show=\"isOldBrowser.showOldBrowser\">\n      <div class=\"callout bg-warning margin-t0\" type=\"info\">\n        You are using an older version of the browser that may not support\n        LexStep features. Please\n        <a\n          target=\"_blank\"\n          class=\"text-info\"\n          href=\"http://windows.microsoft.com/en-us/internet-explorer/download-ie\"\n          >upgrade</a\n        >\n        for improved experience.\n      </div>\n    </div>\n  </div>\n\n  <div class=\"signin-body\" ng-click=\"ctrl.hideDropDown()\">\n    <div class=\"container\">\n      <div class=\"panel-body heading-jobs-listings row\">\n        <center>\n          <h1 class=\"margin-t0\">\n            <strong>{{'signIn.Heading'|translate}}</strong>\n          </h1>\n        </center>\n      </div>\n\n      <div class=\"row\">\n        <center>\n          <alert\n            class=\"col-md-offset-4 col-sm-offset-3 col-md-4 col-sm-6\"\n            type=\"danger\"\n            ng-show=\"ctrl.showOnError\"\n          >\n            {{ctrl.alertMsg}}\n          </alert>\n        </center>\n      </div>\n\n      <div class=\"form-container\">\n        <form\n          class=\"form-horizontal\"\n          name=\"signInForm\"\n          ng-submit=\"signInForm.$valid && ctrl.AuthenticateUser()\"\n        >\n          <fieldset ng-disabled=\"ctrl.spinneractive\">\n            <div class=\"form-group\">\n              <div class=\"input-group input-group-lg\">\n                <span class=\"input-group-addon\">\n                  <span class=\"glyphicon glyphicon-envelope\"></span>\n                </span>\n                <input\n                  type=\"email\"\n                  class=\"form-control\"\n                  ng-model=\"ctrl.user.email\"\n                  placeholder=\"Email\"\n                  ng-change=\"ctrl.showOnError = false;\"\n                  required\n                />\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <div class=\"input-group input-group-lg\">\n                <span class=\"input-group-addon\">\n                  <span class=\"glyphicon glyphicon-lock\"></span>\n                </span>\n                <input\n                  type=\"password\"\n                  class=\"form-control\"\n                  ng-model=\"ctrl.user.password\"\n                  placeholder=\"Password\"\n                  ng-change=\"ctrl.showOnError = false;\"\n                  required\n                />\n              </div>\n            </div>\n            <div class=\"form-group\">\n              <span\n                us-spinner=\"{radius:20, width:3, length: 12, color: 'black'}\"\n                spinner-key=\"spinner-1\"\n              ></span>\n              <button type=\"submit\" class=\"btn btn-info btn-lg btn-block\">\n                {{'btn.signIn.label'|translate}}\n              </button>\n            </div>\n          </fieldset>\n        </form>\n        <section>\n          <p class=\"text-center\">\n            <a class=\"text-info\" href=\"/forgot\"\n              >{{'signIn.caption1'|translate}}</a\n            >\n          </p>\n          <p class=\"text-center text-muted text-small get-started-text\">\n            {{'signIn.caption2'|translate}}\n            <a class=\"text-info\" href=\"/signup\"\n              >{{'signIn.caption3'|translate}}</a\n            >\n          </p>\n        </section>\n      </div>\n    </div>\n  </div>\n\n  <!-- Footer -->\n  <div lexstep-footer></div>\n</div>\n"

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-signup\" data-ng-controller=\"SignUpController as ctrl\">\n  <!-- mobile navbar-->\n  <div lexstep-header></div>\n\n  <div\n    data-ng-controller=\"IsOldBrowserController as isOldBrowser\"\n    class=\"container\"\n  >\n    <div class=\"old-browser-alert\" ng-show=\"isOldBrowser.showOldBrowser\">\n      <div class=\"callout bg-warning margin-t0\" type=\"info\">\n        You are using an older version of the browser that may not support\n        LexStep features. Please\n        <a\n          target=\"_blank\"\n          class=\"text-info\"\n          href=\"http://windows.microsoft.com/en-us/internet-explorer/download-ie\"\n          >upgrade</a\n        >\n        for improved experience.\n      </div>\n    </div>\n  </div>\n  <div class=\"signin-body\" ng-click=\"hideDropDown()\">\n    <div class=\"container\">\n      <div class=\"panel-body heading-jobs-listings row\">\n        <center>\n          <h1 class=\"margin-t0\">\n            <strong>{{'signUp.Heading'|translate}}</strong>\n          </h1>\n          <p class=\"row col-md-offset-3 col-md-6 text-small hidden\">\n            {{'signUp.caption3'|translate}}\n          </p>\n          <div class=\"row col-md-offset-4 col-md-4\">\n            <p>\n              <span class=\"glyphicon glyphicon-lock\"></span> Your profile will\n              remain <strong>anonymous</strong> allowing you to discreetly\n              explore opportunities. &nbsp;\n              <a\n                tooltip-placement=\"bottom\"\n                tooltip=\"No law firm will know that you have joined LexStep unless you see a job that you are interested in and explicitly give that firm permission to view your profile. Your current employer will never know that you have signed up.\"\n                ><span class=\"badge badge-grey\"><i class=\"fa fa-info\"></i></span\n              ></a>\n            </p>\n          </div>\n        </center>\n      </div>\n      <div class=\"row\">\n        <center></center>\n      </div>\n      <div class=\"row clearfix\">\n        <center>\n          <alert ng-if=\"ctrl.showOnError\" class=\"alert-signup\" type=\"danger\"\n            >{{ctrl.alertMsg}}</alert\n          >\n          <alert\n            class=\"alert-signup\"\n            type=\"danger\"\n            ng-if=\"ctrl.showEmailInvalid\"\n            >{{'signUp.invalidEmailError'|translate}}</alert\n          >\n        </center>\n      </div>\n\n      <div class=\"form-container signup-form\">\n        <section>\n          <!-- lawyers Sign Up Form start -->\n          <form\n            class=\"form-horizontal\"\n            name=\"lawyerSignUpForm\"\n            ng-submit=\"lawyerSignUpForm.$valid && ctrl.AddLawyer()\"\n          >\n            <div class=\"form-group\">\n              <div class=\"input-group input-group-lg\">\n                <span class=\"input-group-addon\">\n                  <span class=\"glyphicon glyphicon-user\"></span>\n                </span>\n                <input\n                  type=\"text\"\n                  autocomplete=\"off\"\n                  class=\"form-control\"\n                  placeholder=\"First Name\"\n                  ng-model=\"ctrl.user.firstName\"\n                  required\n                  is-alphabet\n                />\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"input-group input-group-lg\">\n                <span class=\"input-group-addon\">\n                  <span class=\"glyphicon glyphicon-user\"></span>\n                </span>\n                <input\n                  type=\"text\"\n                  autocomplete=\"off\"\n                  class=\"form-control\"\n                  placeholder=\"Last Name\"\n                  ng-model=\"ctrl.user.lastName\"\n                  required\n                  is-alphabet\n                />\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"input-group input-group-lg\">\n                <span class=\"input-group-addon\">\n                  <span class=\"glyphicon glyphicon-envelope\"></span>\n                </span>\n                <input\n                  type=\"email\"\n                  autocomplete=\"off\"\n                  class=\"form-control\"\n                  placeholder=\"Email\"\n                  ng-model=\"ctrl.user.email\"\n                  required\n                />\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"input-group input-group-lg\">\n                <span class=\"input-group-addon\">\n                  <span class=\"glyphicon glyphicon-lock\"></span>\n                </span>\n                <input\n                  type=\"password\"\n                  autocomplete=\"off\"\n                  class=\"form-control\"\n                  placeholder=\"Password (at least 6 characters)\"\n                  ng-model=\"ctrl.user.password\"\n                  minlength=\"6\"\n                  required\n                />\n              </div>\n            </div>\n\n            <div class=\"form-group hidden\">\n              <div class=\"input-group input-group-lg\">\n                <span class=\"input-group-addon\">\n                  <span class=\"glyphicon glyphicon-bullhorn\"></span>\n                </span>\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  placeholder=\"Referral Code (optional)\"\n                  ng-model=\"ctrl.user.referredBy\"\n                  ng-minlength=\"6\"\n                />\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <p>\n                By signing up, you agree to our\n                <a target=\"_blank\" class=\"text-info\" href=\"/terms-conditions\"\n                  >Terms Of Service</a\n                >\n                and\n                <a target=\"_blank\" class=\"text-info\" href=\"/privacy-policy\"\n                  >Privacy Policy</a\n                >\n              </p>\n              <!-- <label class=\"ui-checkbox\"><input name=\"agreeCheckBox\" ng-model = \"ctrl.user.agreed\" type=\"checkbox\" value=\"option1\"><span>I agree to the <a href=\"javascript:;\" class=\"text-info\">Terms Of Service</a> and <a href=\"javascript:;\" class=\"text-info\">Privacy Policy</a></span></label> -->\n              <br />\n              <button\n                type=\"submit\"\n                class=\"btn btn-info btn-block btn-lg\"\n                ng-class=\"{disabled: ctrl.disableSignupBtnClass}\"\n              >\n                {{'btn.signUp.label'|translate}}\n              </button>\n            </div>\n          </form>\n        </section>\n\n        <section>\n          <p class=\"text-center text-muted\">\n            {{'signUp.caption1'|translate}}\n            <a href=\"/signin\" class=\"text-info\">Sign in</a>\n          </p>\n        </section>\n      </div>\n    </div>\n  </div>\n\n  <!-- Footer -->\n  <div lexstep-footer></div>\n</div>\n"

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"page-signin\" data-ng-controller=\"ProfileCtrl as profile\">\n  <!-- Header Starts -->\n  <div lexstep-header></div>\n  <!-- Header Ends -->\n\n  <div\n    data-ng-controller=\"IsOldBrowserController as isOldBrowser\"\n    class=\"container\"\n  >\n    <div class=\"old-browser-alert\" ng-show=\"isOldBrowser.showOldBrowser\">\n      <div class=\"callout bg-warning margin-t0\" type=\"info\">\n        You are using an older version of the browser that may not support\n        LexStep features. Please\n        <a\n          target=\"_blank\"\n          class=\"text-info\"\n          href=\"http://windows.microsoft.com/en-us/internet-explorer/download-ie\"\n          >upgrade</a\n        >\n        for improved experience.\n      </div>\n    </div>\n  </div>\n\n  <!-- Contianer -->\n  <div class=\"container margin-t20\" ng-click=\"hideDropDown()\">\n    <section class=\"page ng-scope\">\n      <div class=\"row\">\n        <div ng-show=\"newUser\" class=\"panel-heading bg-info clearfix\">\n          <h2 class=\"ng-binding margin-t10\">\n            Welcome to LexStep {{loggedInLawyer.user.first_Name}}!\n          </h2>\n          <h4>\n            Please tell us a bit more about yourself so that we can show you\n            relevant opportunities.<br />\n            <div class=\"divider\"></div>\n            This information is <b>strictly confidential.</b> No law firm will\n            know that you have joined LexStep unless you see a job that you are\n            interested in and explicitly give that firm permission to view your\n            profile. Your current employer will never know that you have signed\n            up.\n          </h4>\n        </div>\n        <div ng-show=\"!newUser\" class=\"panel-heading bg-info clearfix\">\n          <h2 class=\"ng-binding margin-t10\">\n            Welcome to LexStep {{loggedInLawyer.user.first_Name}}!\n          </h2>\n          <h4>{{'createProfile.accessRequestedMsg'|translate}}</h4>\n        </div>\n        <!-- form div starts -->\n        <div class=\"panel panel-default create-profile-new\">\n          <div class=\"panel-body\">\n            <div class=\"row\">\n              <div class=\"col-md-12 text-center\">\n                <h3 class=\"margin-t0\">\n                  {{'createProfile.Section1.Heading'| translate}}\n                </h3>\n                <div class=\"divider\"></div>\n              </div>\n            </div>\n            <form name=\"userProfile\">\n              <div data-ng-controller=\"TypeaheadCtrl\">\n                <div class=\"row\">\n                  <div class=\"col-md-6 h5 text-right\">Current Employer*</div>\n                  <div class=\"col-md-4 text-left\">\n                    <input\n                      data-testid=\"current-employer\"\n                      type=\"text\"\n                      ng-if=\"newUser && !canEditNewbeeProfile()\"\n                      placeholder=\"Current Employer\"\n                      class=\"form-control\"\n                      typeahead=\"firm as firm.user.firm_Name for firm in lawFirms | firmsTypeAheadFilter:$viewValue | limitTo:8\"\n                      ng-model=\"lawyerData.currentEmp\"\n                      ng-blur=\"currentEmpChanged()\"\n                      ng-change=\"profileValidation()\"\n                      required\n                      only-alphabets\n                    />\n                    <input\n                      type=\"text\"\n                      disabled\n                      ng-if=\"!newUser || canEditNewbeeProfile()\"\n                      placeholder=\"Current Employer\"\n                      class=\"custom-readonly form-control\"\n                      ng-model=\"loggedInLawyer.lawyer.lawyer_currentEmp\"\n                    />\n                  </div>\n                  <div\n                    ng-if=\"newUser\"\n                    class=\"col-md-1 col-xs-12 current-employer-tooltip\"\n                  >\n                    <a\n                      href=\"\"\n                      tooltip=\"{{'createProfile.currentEmployer.tooltip'|translate}}\"\n                      tooltip-placement=\"bottom\"\n                      class=\"ng-scope hidden-xs hidden-sm\"\n                    >\n                      <span\n                        data-testid=\"employer-tooltip\"\n                        class=\"badge badge-grey employer-badge\"\n                        ><i class=\"fa fa-info\"></i\n                      ></span>\n                    </a>\n                    <span class=\"visible-xs visible-sm\">\n                      {{'createProfile.currentEmployer.tooltip'|translate}}\n                    </span>\n                  </div>\n                </div>\n                <div class=\"divider clearfix\"></div>\n\n                <div class=\"row\">\n                  <div class=\"col-md-6 h5 text-right\">\n                    Undergraduate University*\n                  </div>\n                  <div class=\"col-md-4 text-left\">\n                    <input\n                      data-testid=\"university-name\"\n                      type=\"text\"\n                      ng-if=\"newUser && !canEditNewbeeProfile()\"\n                      ng-model=\"lawyerData.university\"\n                      typeahead=\"university.university_name for university in universities | filter:$viewValue | limitTo:8\"\n                      class=\"form-control\"\n                      placeholder=\"University Name\"\n                      ng-blur=\"universityChanged()\"\n                      ng-change=\"profileValidation()\"\n                      required\n                    />\n                    <input\n                      type=\"text\"\n                      disabled\n                      ng-if=\"!newUser || canEditNewbeeProfile()\"\n                      ng-model=\"loggedInLawyer.lawyer.university\"\n                      typeahead=\"university for university in universities | filter:$viewValue | limitTo:8\"\n                      class=\"custom-readonly form-control\"\n                      placeholder=\"University Name\"\n                    />\n                  </div>\n                </div>\n                <div class=\"divider clearfix\"></div>\n\n                <div class=\"row\">\n                  <div class=\"col-md-6 h5 text-right\">Nationality*</div>\n                  <div class=\"col-md-4 text-left\">\n                    <input\n                      data-testid=\"nationality\"\n                      type=\"text\"\n                      ng-if=\"newUser && !canEditNewbeeProfile()\"\n                      placeholder=\"Nationality\"\n                      class=\"form-control\"\n                      typeahead=\"nation.nationality_name for nation in nations | filter:$viewValue | limitTo:8\"\n                      ng-model=\"lawyerData.nationality\"\n                      ng-blur=\"nationalityChanged()\"\n                      ng-change=\"profileValidation()\"\n                      required\n                      only-alphabets\n                    />\n\n                    <input\n                      type=\"text\"\n                      disabled\n                      ng-if=\"!newUser || canEditNewbeeProfile()\"\n                      placeholder=\"Nationality\"\n                      class=\"custom-readonly form-control\"\n                      ng-model=\"loggedInLawyer.lawyer.nationality\"\n                    />\n                  </div>\n                </div>\n                <div class=\"divider clearfix\"></div>\n\n                <div class=\"row\">\n                  <h5 class=\"col-md-6 text-right\">\n                    Current Location*\n                  </h5>\n                  <div class=\"col-md-4 text-left\">\n                    <input\n                      data-testid=\"country\"\n                      type=\"text\"\n                      ng-if=\"newUser && !canEditNewbeeProfile()\"\n                      placeholder=\"Country\"\n                      class=\"form-control\"\n                      typeahead=\"country.country_name for country in countries | filter:$viewValue | limitTo:8\"\n                      ng-model=\"lawyerData.currentLocation\"\n                      ng-blur=\"currentLocationChanged()\"\n                      ng-change=\"profileValidation()\"\n                      required\n                      only-alphabets\n                    />\n\n                    <input\n                      type=\"text\"\n                      disabled\n                      ng-if=\"!newUser || canEditNewbeeProfile()\"\n                      placeholder=\"Country\"\n                      class=\"custom-readonly form-control\"\n                      ng-model=\"loggedInLawyer.lawyer.currentLocation\"\n                    />\n                  </div>\n                </div>\n              </div>\n              <div class=\"divider clearfix\"></div>\n\n              <div class=\"row\">\n                <h5 class=\"col-md-6 text-right\">Contact Number*</h5>\n                <div class=\"col-md-4 text-left\">\n                  <input\n                    data-testid=\"phone\"\n                    type=\"tel\"\n                    required\n                    ng-change=\"profileValidation()\"\n                    ng-if=\"newUser && !canEditNewbeeProfile()\"\n                    placeholder=\"Phone/Mobile Number\"\n                    class=\"form-control\"\n                    ng-model=\"lawyerData.lawyer_phone\"\n                    ng-blur=\"phoneNumberChanged()\"\n                  />\n\n                  <input\n                    type=\"tel\"\n                    disabled\n                    ng-if=\"!newUser || canEditNewbeeProfile()\"\n                    placeholder=\"Phone/Mobile Number\"\n                    class=\"custom-readonly form-control\"\n                    ng-model=\"loggedInLawyer.lawyer.lawyer_phone\"\n                  />\n                </div>\n              </div>\n              <div class=\"divider clearfix\"></div>\n\n              <!-- <hr> -->\n              <div ng-class=\"\" class=\"solicitor-highlight\">\n                <!-- solicitor div starts-->\n\n                <div class=\"row\">\n                  <div class=\"col-md-12 text-center\">\n                    <h3 class=\"margin-t0\">\n                      {{'createProfile.Section2.Heading'| translate}}\n                    </h3>\n                    <div class=\"divider\"></div>\n                  </div>\n                </div>\n\n                <div class=\"divider clearfix\"></div>\n\n                <div class=\"row\" ng-show=\"!hidePQE\">\n                  <div\n                    class=\"col-sm-4 col-md-6 col-lg-offset-2 col-lg-4 h5 text-right margin-t0\"\n                  >\n                    {{pqeLabel}}\n                  </div>\n                  <div class=\"col-sm-4 col-md-4\">\n                    <div name=\"pqe\" data-ng-controller=\"DatepickerDemoCtrl\">\n                      <div class=\"input-group ui-datepicker\">\n                        <input\n                          id=\"datepicker\"\n                          ng-show=\"newUser && !canEditNewbeeProfile()\"\n                          type=\"text\"\n                          disabled\n                          class=\"custom-readonly form-control\"\n                          placeholder=\"Month-Year\"\n                          uib-datepicker-popup=\"{{format}}\"\n                          ng-model=\"lawyerData.pqe\"\n                          is-open=\"opened\"\n                          min=\"minDate\"\n                          max=\"'2015-06-22'\"\n                          datepicker-options=\"dateOptions\"\n                          date-disabled=\"disabled(date, mode)\"\n                          ng-class=\"pqeErrorClass\"\n                          ng-change=\"pqeChanged()\"\n                          close-text=\"Close\"\n                          ng-change=\"profileValidation()\"\n                          required\n                        />\n                        <span\n                          data-testid=\"calender\"\n                          class=\"input-group-addon\"\n                          ng-show=\"newUser && !canEditNewbeeProfile()\"\n                          ng-click=\"newUser && !canEditNewbeeProfile() && open($event)\"\n                          ><i class=\"fa fa-calendar\"></i\n                        ></span>\n\n                        <input\n                          id=\"datepicker\"\n                          ng-show=\"!newUser || canEditNewbeeProfile()\"\n                          type=\"text\"\n                          disabled\n                          class=\"custom-readonly form-control\"\n                          placeholder=\"Month-Year\"\n                          uib-datepicker-popup=\"{{format}}\"\n                          ng-model=\"loggedInLawyer.lawyer.PQE\"\n                          is-open=\"false\"\n                          min=\"minDate\"\n                          max=\"'2015-06-22'\"\n                          datepicker-options=\"dateOptions\"\n                          date-disabled=\"disabled(date, mode)\"\n                          close-text=\"Close\"\n                        />\n                        <span\n                          ng-show=\"!newUser || canEditNewbeeProfile()\"\n                          class=\"input-group-addon\"\n                          ng-click=\"newUser && !canEditNewbeeProfile() && open($event)\"\n                          ><i class=\"fa fa-calendar\"></i\n                        ></span>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class=\"divider\"></div>\n                <div class=\"row\" ng-show=\"(!newUser || canEditNewbeeProfile())\">\n                  <div class=\"col-md-6 col-sm-4 col-xs-12 h5 text-right\">\n                    {{jurisdictionLabel}}\n                  </div>\n\n                  <div class=\"divider clearfix\"></div>\n                  <div class=\"col-md-4 col-sm-8 col-xs-12 text-left\">\n                    <ul\n                      id=\"taglist\"\n                      class=\"list-inline list-practice-area margin-b0\"\n                    >\n                      <li\n                        class=\"tags-box\"\n                        ng-if=\"jurisdiction.isSelected\"\n                        ng-repeat=\"jurisdiction in jurisdictions\"\n                      >\n                        {{jurisdiction.loc_name}}\n                      </li>\n                      <li class=\"tags-box\">\n                        {{loggedInLawyer.lawyer.other_Jurisdictions}}\n                      </li>\n                    </ul>\n                  </div>\n                </div>\n\n                <div class=\"row\" ng-show=\"(newUser && !canEditNewbeeProfile())\">\n                  <div class=\"col-md-6 col-sm-4 col-xs-12 h5 text-right\">\n                    {{jurisdictionLabel}}\n                  </div>\n                  <div\n                    class=\"col-md-4 col-sm-8 col-xs-12 text-left\"\n                    ng-show=\"!editJurisdictions \"\n                  >\n                    <a\n                      data-testid=\"select-jurisdiction\"\n                      href=\"\"\n                      class=\"btn btn-line-info full-width-xs\"\n                      ng-class=\"jurisdictionsErrorClass\"\n                      ng-click=\"openModal($event)\"\n                      id=\"select-jurisdiction\"\n                      >Click to specify</a\n                    >\n                    &nbsp;\n                  </div>\n\n                  <div class=\"divider clearfix\"></div>\n\n                  <div\n                    class=\"col-md-6 col-sm-8 col-xs-12 text-left\"\n                    ng-show=\"editJurisdictions \"\n                  >\n                    <ul\n                      id=\"taglist\"\n                      class=\"list-inline list-practice-area margin-b0\"\n                    >\n                      <li\n                        class=\"tags-box\"\n                        ng-if=\"jurisdiction.isSelected\"\n                        ng-repeat=\"jurisdiction in jurisdictions\"\n                      >\n                        {{jurisdiction.loc_name}}\n                      </li>\n                      <li ng-show=\"other\" class=\"tags-box\">{{other}}</li>\n                      <a\n                        data-testid=\"edit-jurisdiction\"\n                        href=\"\"\n                        class=\"fa fa-pencil\"\n                        ng-click=\"openModal($event)\"\n                        id=\"edit-jurisdiction\"\n                        ng-show=\"showjurisdictionTick\"\n                      ></a>\n                    </ul>\n                  </div>\n                </div>\n\n                <div class=\"divider\" ng-show=\"editJurisdictions\"></div>\n              </div>\n              <!--solicitor div ends-->\n\n              <div class=\"row\">\n                <div class=\"col-md-12 text-center\">\n                  <h3>{{'createProfile.Section3.Heading'| translate}}</h3>\n                  <div class=\"divider\"></div>\n                </div>\n              </div>\n\n              <div ng-if=\"newUser && !canEditNewbeeProfile()\">\n                <div class=\"row\">\n                  <div class=\"col-md-6 col-sm-4 col-xs-12 h5 text-right\">\n                    Practice Areas*\n                  </div>\n                  <div class=\"col-md-6 col-sm-8 col-xs-12 text-left\">\n                    <span ng-show=\"!editPractices\">\n                      <a\n                        href=\"\"\n                        class=\"btn btn-line-info full-width-xs\"\n                        ng-class=\"practicesErrorClass\"\n                        ng-click=\"openModal($event)\"\n                        id=\"select-practices\"\n                        >Click to specify</a\n                      >\n                      &nbsp;\n                    </span>\n                    <div class=\"divider clearfix\"></div>\n                    <div ng-show=\"editPractices \">\n                      <ul\n                        id=\"taglist\"\n                        class=\"list-inline list-practice-area margin-b0\"\n                      >\n                        <li\n                          class=\"tags-box\"\n                          ng-if=\"area.isSelected && !area.hasChild\"\n                          ng-repeat=\"area in areas\"\n                        >\n                          {{area.practice_name}}\n                        </li>\n                        <a\n                          href=\"\"\n                          class=\"fa fa-pencil\"\n                          ng-click=\"openModal($event)\"\n                          id=\"edit-practices\"\n                          ng-show=\"showPracticeTick\"\n                        ></a>\n                      </ul>\n                    </div>\n                  </div>\n                </div>\n              </div>\n\n              <div ng-if=\"!newUser || canEditNewbeeProfile()\">\n                <div class=\"row\">\n                  <div class=\"col-md-6 col-sm-4 col-xs-12 h5 text-right\">\n                    Practice Areas*\n                  </div>\n                  <div class=\"divider clearfix\"></div>\n                  <div class=\"col-md-6 col-sm-8 col-xs-12 text-left\">\n                    <ul\n                      id=\"taglist\"\n                      class=\"list-inline list-practice-area margin-b0\"\n                    >\n                      <li\n                        class=\"tags-box\"\n                        ng-if=\"!area.hasChild && area.isSelected\"\n                        ng-repeat=\"area in lawyerPractices\"\n                      >\n                        {{area.practice_name}}\n                      </li>\n                    </ul>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"divider clearfix\"></div>\n\n              <div ng-if=\"newUser && !canEditNewbeeProfile()\">\n                <div class=\"row\">\n                  <div class=\"col-md-6 col-sm-4 col-xs-12 h5 text-right\">\n                    Target Locations *\n                  </div>\n                  <div class=\"col-md-6 col-sm-8 col-xs-12 text-left\">\n                    <a\n                      href=\"\"\n                      class=\"btn btn-line-info full-width-xs\"\n                      ng-class=\"locationsErrorClass\"\n                      ng-show=\"!editLocations\"\n                      ng-click=\"openModal($event)\"\n                      id=\"select-locations\"\n                      >Click to specify</a\n                    >\n                    <ul\n                      id=\"taglist\"\n                      class=\"list-inline list-practice-area margin-b0 list-location\"\n                      ng-show=\"editLocations\"\n                    >\n                      <li\n                        class=\"tags-box\"\n                        ng-if=\"location.isSelected\"\n                        ng-repeat=\"location in locations\"\n                      >\n                        {{location.loc_name}}\n                      </li>\n                      <a\n                        href=\"\"\n                        class=\"fa fa-pencil\"\n                        ng-show=\"showLocationsTick\"\n                        id=\"edit-locations\"\n                        ng-click=\"openModal($event)\"\n                      ></a>\n                    </ul>\n                  </div>\n                </div>\n              </div>\n\n              <div ng-if=\"!newUser || canEditNewbeeProfile()\">\n                <div class=\"row\">\n                  <div class=\"col-md-6 col-sm-4 col-xs-12 h5 text-right\">\n                    Target Locations\n                  </div>\n                  <div class=\"divider clearfix\"></div>\n                  <div class=\"col-md-6 col-sm-8 col-xs-12 text-left\">\n                    <ul\n                      id=\"taglist\"\n                      class=\"list-inline list-practice-area margin-b0\"\n                    >\n                      <li class=\"tags-box\" ng-repeat=\"location in locations\">\n                        {{location.loc_name}}\n                      </li>\n                    </ul>\n                  </div>\n                </div>\n              </div>\n              <div class=\"divider clearfix\"></div>\n\n              <hr />\n\n              <div class=\"row\">\n                <div class=\"col-md-12 text-center\">\n                  <h3 class=\"margin-t0\">\n                    LexStep is for top lawyers only - please provide\n                    <b>at least one</b> of the below*\n                  </h3>\n                  <div class=\"divider\"></div>\n                </div>\n              </div>\n              <div class=\"row\" ng-if=\"isEnglandWalesSelected\">\n                <div class=\"col-md-6 col-sm-4 h5 text-right\">Your SRA ID</div>\n                <div class=\"col-md-4 col-sm-8 text-left\">\n                  <input\n                    data-testid=\"sra-id\"\n                    type=\"text\"\n                    ng-if=\"newUser && !canEditNewbeeProfile()\"\n                    ng-model=\"lawyerData.regNumber\"\n                    placeholder=\"Your SRA ID\"\n                    class=\"form-control\"\n                    ng-class=\"cvErrorClass\"\n                    ng-blur=\"sraIdChanged()\"\n                  />\n                  <h5 ng-if=\"!newUser || canEditNewbeeProfile()\">\n                    {{loggedInLawyer.lawyer.lawyer_regNumber}}\n                  </h5>\n                  <br\n                    ng-if=\"(!newUser || canEditNewbeeProfile() )&& !loggedInLawyer.lawyer.lawyer_regNumber\"\n                  />\n                  <h4 class=\"\" ng-if=\"newUser && !canEditNewbeeProfile()\">\n                    <a\n                      target=\"_blank\"\n                      class=\"text-info\"\n                      href=\" http://solicitors.lawsociety.org.uk/?Pro=True\"\n                      >Click here to find your SRA ID</a\n                    >\n                  </h4>\n                  <!-- <div class=\"divider clearfix\"></div> -->\n                  <h3 class=\"and-or\"><b>OR</b></h3>\n                </div>\n              </div>\n              <div class=\"divider clearfix\"></div>\n\n              <div class=\"row\" id=\"third-section\">\n                <div class=\"col-md-6 col-sm-4 h5 text-right\">\n                  LinkedIn Profile\n                </div>\n                <div\n                  class=\"col-md-6 col-sm-8 text-left\"\n                  ng-if=\"!loggedInLawyer.lawyer.linkedInURL && !loggedInLawyer.lawyer.linkedInData\"\n                >\n                  <a\n                    data-testid=\"linkedin\"\n                    href=\"\"\n                    class=\"btn btn-linkedin-l full-width-xs\"\n                    ng-show=\"newUser && !canEditNewbeeProfile()\"\n                    ng-disabled=\"user.isAdmin\"\n                    ng-click=\"connectToLinkedIn()\"\n                    ><i class=\"fa fa-linkedin\"></i> | Connect with LinkedIn</a\n                  >\n                </div>\n\n                <div\n                  class=\"col-md-4 text-left\"\n                  ng-if=\"loggedInLawyer.lawyer.linkedInURL || loggedInLawyer.lawyer.linkedInData\"\n                >\n                  <h4 class=\"linkedin-success\">\n                    <span ng-if=\"canEditNewbeeProfile()\">\n                      {{loggedInLawyer.lawyer.linkedInURL}}\n                    </span>\n                    <span ng-if=\"!canEditNewbeeProfile()\">\n                      Successfully connected with LinkedIn\n                      <span class=\"fa fa-check\"></span>\n                    </span>\n                  </h4>\n                </div>\n              </div>\n\n              <div class=\"row \">\n                <h3\n                  class=\"and-or col-md-offset-6 col-md-2 col-sm-offset-4 col-sm-4 col-xs-12\"\n                >\n                  <b>OR</b>\n                </h3>\n              </div>\n              <div class=\"divider clearfix\"></div>\n\n              <div class=\"row\">\n                <div class=\"col-md-6 col-sm-4 h5 text-right\">\n                  Upload draft CV\n                </div>\n                <div\n                  ng-if=\"newUser && !canEditNewbeeProfile()\"\n                  class=\"col-md-6 col-sm-8 text-left\"\n                >\n                  <button\n                    data-testid=\"cv-upload\"\n                    type=\"file\"\n                    ng-show=\"selectedFile === null\"\n                    class=\"btn btn-w-md btn-gap-v btn-line-info pull-left full-width-xs\"\n                    ng-class=\"cvErrorClass\"\n                    ng-file-select=\"upload($files)\"\n                    accept=\".docx,.pdf,.doc\"\n                  >\n                    Choose File\n                  </button>\n                  <div ng-show=\"selectedFile === null\" class=\"edit-cv-txt\">\n                    &nbsp;(you can edit this later)\n                  </div>\n                  <h5>\n                    {{selectedFile}} &nbsp;&nbsp;\n                    <a\n                      href=\"\"\n                      type=\"file\"\n                      class=\"fa fa-pencil\"\n                      ng-file-select=\"upload($files)\"\n                      accept=\".docx,.pdf,.doc\"\n                      ng-show=\"selectedFile != null\"\n                    ></a>\n                  </h5>\n                </div>\n                <div\n                  ng-if=\"!newUser || canEditNewbeeProfile()\"\n                  class=\"col-md-6 text-left\"\n                >\n                  <strong><h5>{{loggedInLawyer.user.user_CV}}</h5></strong>\n                </div>\n                <span\n                  us-spinner=\"{radius:10, width:2, length: 12, color: 'black'}\"\n                  spinner-key=\"spinner-2\"\n                ></span>\n              </div>\n\n              <!-- <div class=\"divider clearfix\"></div>\n -->\n              <hr />\n\n              <div class=\"divider clearfix\"></div>\n\n              <div class=\"row\">\n                <center>\n                  <button\n                    data-testid=\"request-access\"\n                    type=\"submit\"\n                    ng-disabled=\"canEditNewbeeProfile()\"\n                    class=\"{{requestAccessClass}}\"\n                    ng-click=\"applyForApproval()\"\n                  >\n                    {{requestBtnCaption}}\n                  </button>\n                  <!-- ng-disabled=\"!newUser || canEditNewbeeProfile() || userProfile.$invalid\" -->\n                </center>\n              </div>\n            </form>\n\n            <div class=\"row\">\n              <center>\n                <strong>\n                  <h4 ng-if=\"!newUser\" class=\"text-success access-requested\">\n                    <span class=\"fa fa-check\"></span>\n                    {{'createProfile.accessRequestedMsg'|translate}}\n                  </h4>\n                  <h4 ng-if=\"newUser\" class=\" margin-t20\">\n                    <span class=\"glyphicon glyphicon-lock\"></span>This\n                    information is <b>strictly confidential</b> and will not be\n                    shared without your permission.\n                  </h4>\n                </strong>\n              </center>\n            </div>\n          </div>\n        </div>\n      </div>\n    </section>\n  </div>\n  <!-- Container Ends -->\n\n  <!-- Footer -->\n  <div lexstep-footer></div>\n\n  <!--Template for the lawyer's action Modal-->\n  <script type=\"text/ng-template\" id=\"ModalScript.html\">\n    <div class=\"modal-header\">\n      <center>\n        <h3 ng-if=\"isHeadingBold\"><b>{{heading|translate}}</b></h3 ng-if=\"isHeadingBold\">\n        <h3 ng-if=\"!isHeadingBold\">{{heading|translate}}</h3 ng-if=\"!isHeadingBold\">\n    \t\t<h5>{{subHeading|translate}}</h5>\n    \t</center>\n    </div>\n\n    <div data-testid=\"preference-modal\" class=\"modal-body\">\n      <div class=\"modal-row custom-modal\" ng-show=\"showLocations\">\n        <div class=\"col-md-12 nowrap\">\n          <div class=\"\" data-ng-repeat = \"region in data | orderBy: 'loc_ID'\">\n            <span ng-hide=\"region.showChildLocations\" data-ng-click=\"displayChildLocations(region)\">\n              <i class=\"fa fa-plus expand-collapse-button\" aria-hidden=\"true\"></i>\n            </span>\n            <span ng-hide=\"!region.showChildLocations\" ng-click=\"hideChildLocations(region)\">\n              <i class=\"fa fa-minus expand-collapse-button\" aria-hidden=\"true\"></i>\n            </span>\n            <label class=\"ui-checkbox\">\n                <input type=\"checkbox\" ng-click=\"selectLocation($event , region , 2)\" data=\"{{loc_ID}}\" ng-checked=\"region.isSelected\">\n                <span class=\"checkbox-group-heading\">\n                  <strong>{{region.loc_name}}</strong>\n                </span>\n            </label>\n            <ul ng-show=\"region.showChildLocations\" class=\"practice-area-list clearfix\">\n              <li data-ng-repeat=\"location in region.locations\">\n                <label class=\"ui-checkbox\">\n                  <input type=\"checkbox\"\n                    data=\"{{location.loc_ID}}\"\n                    ng-click=\"selectLocation($event , location , 1)\"\n                    ng-checked=\"location.isSelected\"\n                  >\n                  <span>{{location.loc_name}}</span>\n                </label>\n                <ul class=\"sub-list clearfix\">\n                  <li data-ng-repeat = \"sub in location.sub_areas\">\n                    <label class=\"ui-checkbox\">\n                      <input type=\"checkbox\"\n                        ng-click=\"selectLocation($event , sub , 0)\"\n                        ng-checked=\"sub.isSelected\">\n                      <span>{{sub.loc_name}}</span>\n                    </label>\n                    </li>\n                </ul>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div>\n\n      <div data-testid=\"jurisdiction-modal\" class=\"modal-row custom-modal custom-modal-overflow-x-hidden\" ng-show=\"showJurisdictions\">\n        <div class=\"row\">\n          <div class=\"col-md-12\" >\n            <ul class=\"checkbox-grid pref-location-list clearfix\">\n              <li ng-show = \"juri.isJurisdiction\" data-ng-repeat=\"juri in jurisdictions\">\n                <label class=\"ui-checkbox\">\n                    <input name=\"juri.loc_name\"\n                        type=\"checkbox\"\n                        ng-true-value=\"{{juri.loc_name}}\"\n                        ng-false-value = \"false\"\n                        data=\"{{juri.loc_ID}}\"\n                        ng-click=\"updateData($event , juri)\"\n                        ng-checked=\"{{juri.isSelected}}\"\n                    >\n                    <span>{{juri.loc_name}}</span>\n                </label>\n              </li>\n            </ul>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-md-12 pref-location-list\">\n            <h5 class=\"col-md-1 col-sm-1 col-xs-1\">OR</h5>\n            <div class= \"col-md-6 col-sm-6 col-xs-8\">\n              <input\n                type='text'\n                ng-model=\"updatedData.otherJurisdictions\"\n                placeholder='Type a Jurisdiction'\n                class=\"form-control\">\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"modal-row custom-modal\" ng-show=\"showPractices\">\n        <div class=\"col-md-12\">\n          <div class=\"nowrap\" data-ng-repeat = \"law_area in data\">\n            <span ng-class=\"{'no-child': law_area.practices.length === 0}\"><i class=\"fa fa-plus expand-collapse-button\" ng-hide=\"law_area.showSubPracticeAreas || law_area.practices.length === 0\" ng-click=\"displaySubPracticeAreas(law_area)\" aria-hidden=\"true\"></i>\n              </span>\n              <span ng-class=\"{'no-child': law_area.practices.length === 0}\"><i class=\"fa fa-minus expand-collapse-button\" ng-hide=\"!law_area.showSubPracticeAreas\" ng-click=\"hideSubPracticeAreas(law_area)\" aria-hidden=\"true\"></i>\n              </span>\n            <label class=\"ui-checkbox practice-area-ui-checkbox\">\n                <input type=\"checkbox\" ng-click=\"selectPractices($event , law_area , 2)\" data=\"{{practice_ID}}\" ng-checked=\"law_area.isSelected\">\n                <span class=\"checkbox-group-heading\" ng-style=\"law_area.practices.length > 0 && {'font-weight': 'bold'}\">{{law_area.practice_name}}</span>\n            </label>\n            <ul ng-show=\"law_area.showSubPracticeAreas\" class=\"wrap practice-area-list clearfix\">\n                <li data-ng-repeat=\"practice in law_area.practices\">\n                    <label class=\"ui-checkbox\">\n                        <input type=\"checkbox\"\n                            data=\"{{practice.loc_ID}}\"\n                            ng-click=\"selectPractices($event , practice , 1)\"\n                            ng-checked=\"practice.isSelected\"\n                        >\n                        <span>{{practice.practice_name}}</span>\n                    </label>\n                  <ul class=\"sub-list clearfix\">\n                    <li data-ng-repeat = \"sub in practice.sub_areas\">\n                        <label class=\"ui-checkbox\">\n                            <input type=\"checkbox\"\n                                ng-click=\"selectPractices($event , sub , 0)\"\n                                ng-checked=\"sub.isSelected\">\n                            <span>{{sub.practice_name}}</span>\n                        </label>\n                      </li>\n                  </ul>\n                </li>\n            </ul>\n          </div>\n        </div>\n    </div>\n\n      <div class=\"row\" ng-show=\"showCategories\">\n          <div class=\"col-md-12\" >\n              <ul class=\"checkbox-grid\">\n                  <li data-ng-repeat = \"user_data in data\">\n                      <label class=\"ui-checkbox\">\n                          <input name=\"user_data.cat_name\"\n                              type=\"checkbox\"\n                              ng-true-value=\"{{user_data.cat_name}}\"\n                              ng-false-value = \"false\"\n                              data=\"{{user_data.cat_ID}}\"\n                              ng-click=\"updateData($event , user_data)\"\n                              ng-checked=\"{{user_data.isSelected}}\"\n                           >\n                          <span>{{user_data.cat_name}}</span>\n                      </label>\n                  </li>\n              </ul>\n          </div>\n      </div>\n    </div>\n\n    <div class=\"modal-footer\">\n        <center>\n          <button class=\"btn btn-info\" ng-click=\"save()\">{{saveButtonText}}</button>\n          <button class=\"btn btn-gap-v btn-default\" ng-click=\"cancel()\">Cancel</button>\n        </center>\n    </div>\n  </script>\n</div>\n"

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * selectize.js (v0.12.6)
	 * Copyright (c) 2013–2015 Brian Reavis & contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 * @author Brian Reavis <brian@thirdroute.com>
	 */
	
	/*jshint curly:false */
	/*jshint browser:true */
	
	(function(root, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(103),__webpack_require__(1238),__webpack_require__(988)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory(require('jquery'), require('sifter'), require('microplugin'));
		} else {
			root.Selectize = factory(root.jQuery, root.Sifter, root.MicroPlugin);
		}
	}(this, function($, Sifter, MicroPlugin) {
		'use strict';
	
		var highlight = function($element, pattern) {
			if (typeof pattern === 'string' && !pattern.length) return;
			var regex = (typeof pattern === 'string') ? new RegExp(pattern, 'i') : pattern;
		
			var highlight = function(node) {
				var skip = 0;
				// Wrap matching part of text node with highlighting <span>, e.g.
				// Soccer  ->  <span class="highlight">Soc</span>cer  for regex = /soc/i
				if (node.nodeType === 3) {
					var pos = node.data.search(regex);
					if (pos >= 0 && node.data.length > 0) {
						var match = node.data.match(regex);
						var spannode = document.createElement('span');
						spannode.className = 'highlight';
						var middlebit = node.splitText(pos);
						var endbit = middlebit.splitText(match[0].length);
						var middleclone = middlebit.cloneNode(true);
						spannode.appendChild(middleclone);
						middlebit.parentNode.replaceChild(spannode, middlebit);
						skip = 1;
					}
				} 
				// Recurse element node, looking for child text nodes to highlight, unless element 
				// is childless, <script>, <style>, or already highlighted: <span class="hightlight">
				else if (node.nodeType === 1 && node.childNodes && !/(script|style)/i.test(node.tagName) && ( node.className !== 'highlight' || node.tagName !== 'SPAN' )) {
					for (var i = 0; i < node.childNodes.length; ++i) {
						i += highlight(node.childNodes[i]);
					}
				}
				return skip;
			};
		
			return $element.each(function() {
				highlight(this);
			});
		};
		
		/**
		 * removeHighlight fn copied from highlight v5 and
		 * edited to remove with() and pass js strict mode
		 */
		$.fn.removeHighlight = function() {
			return this.find("span.highlight").each(function() {
				this.parentNode.firstChild.nodeName;
				var parent = this.parentNode;
				parent.replaceChild(this.firstChild, this);
				parent.normalize();
			}).end();
		};
		
		
		var MicroEvent = function() {};
		MicroEvent.prototype = {
			on: function(event, fct){
				this._events = this._events || {};
				this._events[event] = this._events[event] || [];
				this._events[event].push(fct);
			},
			off: function(event, fct){
				var n = arguments.length;
				if (n === 0) return delete this._events;
				if (n === 1) return delete this._events[event];
		
				this._events = this._events || {};
				if (event in this._events === false) return;
				this._events[event].splice(this._events[event].indexOf(fct), 1);
			},
			trigger: function(event /* , args... */){
				this._events = this._events || {};
				if (event in this._events === false) return;
				for (var i = 0; i < this._events[event].length; i++){
					this._events[event][i].apply(this, Array.prototype.slice.call(arguments, 1));
				}
			}
		};
		
		/**
		 * Mixin will delegate all MicroEvent.js function in the destination object.
		 *
		 * - MicroEvent.mixin(Foobar) will make Foobar able to use MicroEvent
		 *
		 * @param {object} the object which will support MicroEvent
		 */
		MicroEvent.mixin = function(destObject){
			var props = ['on', 'off', 'trigger'];
			for (var i = 0; i < props.length; i++){
				destObject.prototype[props[i]] = MicroEvent.prototype[props[i]];
			}
		};
		
		var IS_MAC        = /Mac/.test(navigator.userAgent);
		
		var KEY_A         = 65;
		var KEY_COMMA     = 188;
		var KEY_RETURN    = 13;
		var KEY_ESC       = 27;
		var KEY_LEFT      = 37;
		var KEY_UP        = 38;
		var KEY_P         = 80;
		var KEY_RIGHT     = 39;
		var KEY_DOWN      = 40;
		var KEY_N         = 78;
		var KEY_BACKSPACE = 8;
		var KEY_DELETE    = 46;
		var KEY_SHIFT     = 16;
		var KEY_CMD       = IS_MAC ? 91 : 17;
		var KEY_CTRL      = IS_MAC ? 18 : 17;
		var KEY_TAB       = 9;
		
		var TAG_SELECT    = 1;
		var TAG_INPUT     = 2;
		
		// for now, android support in general is too spotty to support validity
		var SUPPORTS_VALIDITY_API = !/android/i.test(window.navigator.userAgent) && !!document.createElement('input').validity;
		
		
		var isset = function(object) {
			return typeof object !== 'undefined';
		};
		
		/**
		 * Converts a scalar to its best string representation
		 * for hash keys and HTML attribute values.
		 *
		 * Transformations:
		 *   'str'     -> 'str'
		 *   null      -> ''
		 *   undefined -> ''
		 *   true      -> '1'
		 *   false     -> '0'
		 *   0         -> '0'
		 *   1         -> '1'
		 *
		 * @param {string} value
		 * @returns {string|null}
		 */
		var hash_key = function(value) {
			if (typeof value === 'undefined' || value === null) return null;
			if (typeof value === 'boolean') return value ? '1' : '0';
			return value + '';
		};
		
		/**
		 * Escapes a string for use within HTML.
		 *
		 * @param {string} str
		 * @returns {string}
		 */
		var escape_html = function(str) {
			return (str + '')
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;');
		};
		
		/**
		 * Escapes "$" characters in replacement strings.
		 *
		 * @param {string} str
		 * @returns {string}
		 */
		var escape_replace = function(str) {
			return (str + '').replace(/\$/g, '$$$$');
		};
		
		var hook = {};
		
		/**
		 * Wraps `method` on `self` so that `fn`
		 * is invoked before the original method.
		 *
		 * @param {object} self
		 * @param {string} method
		 * @param {function} fn
		 */
		hook.before = function(self, method, fn) {
			var original = self[method];
			self[method] = function() {
				fn.apply(self, arguments);
				return original.apply(self, arguments);
			};
		};
		
		/**
		 * Wraps `method` on `self` so that `fn`
		 * is invoked after the original method.
		 *
		 * @param {object} self
		 * @param {string} method
		 * @param {function} fn
		 */
		hook.after = function(self, method, fn) {
			var original = self[method];
			self[method] = function() {
				var result = original.apply(self, arguments);
				fn.apply(self, arguments);
				return result;
			};
		};
		
		/**
		 * Wraps `fn` so that it can only be invoked once.
		 *
		 * @param {function} fn
		 * @returns {function}
		 */
		var once = function(fn) {
			var called = false;
			return function() {
				if (called) return;
				called = true;
				fn.apply(this, arguments);
			};
		};
		
		/**
		 * Wraps `fn` so that it can only be called once
		 * every `delay` milliseconds (invoked on the falling edge).
		 *
		 * @param {function} fn
		 * @param {int} delay
		 * @returns {function}
		 */
		var debounce = function(fn, delay) {
			var timeout;
			return function() {
				var self = this;
				var args = arguments;
				window.clearTimeout(timeout);
				timeout = window.setTimeout(function() {
					fn.apply(self, args);
				}, delay);
			};
		};
		
		/**
		 * Debounce all fired events types listed in `types`
		 * while executing the provided `fn`.
		 *
		 * @param {object} self
		 * @param {array} types
		 * @param {function} fn
		 */
		var debounce_events = function(self, types, fn) {
			var type;
			var trigger = self.trigger;
			var event_args = {};
		
			// override trigger method
			self.trigger = function() {
				var type = arguments[0];
				if (types.indexOf(type) !== -1) {
					event_args[type] = arguments;
				} else {
					return trigger.apply(self, arguments);
				}
			};
		
			// invoke provided function
			fn.apply(self, []);
			self.trigger = trigger;
		
			// trigger queued events
			for (type in event_args) {
				if (event_args.hasOwnProperty(type)) {
					trigger.apply(self, event_args[type]);
				}
			}
		};
		
		/**
		 * A workaround for http://bugs.jquery.com/ticket/6696
		 *
		 * @param {object} $parent - Parent element to listen on.
		 * @param {string} event - Event name.
		 * @param {string} selector - Descendant selector to filter by.
		 * @param {function} fn - Event handler.
		 */
		var watchChildEvent = function($parent, event, selector, fn) {
			$parent.on(event, selector, function(e) {
				var child = e.target;
				while (child && child.parentNode !== $parent[0]) {
					child = child.parentNode;
				}
				e.currentTarget = child;
				return fn.apply(this, [e]);
			});
		};
		
		/**
		 * Determines the current selection within a text input control.
		 * Returns an object containing:
		 *   - start
		 *   - length
		 *
		 * @param {object} input
		 * @returns {object}
		 */
		var getSelection = function(input) {
			var result = {};
			if ('selectionStart' in input) {
				result.start = input.selectionStart;
				result.length = input.selectionEnd - result.start;
			} else if (document.selection) {
				input.focus();
				var sel = document.selection.createRange();
				var selLen = document.selection.createRange().text.length;
				sel.moveStart('character', -input.value.length);
				result.start = sel.text.length - selLen;
				result.length = selLen;
			}
			return result;
		};
		
		/**
		 * Copies CSS properties from one element to another.
		 *
		 * @param {object} $from
		 * @param {object} $to
		 * @param {array} properties
		 */
		var transferStyles = function($from, $to, properties) {
			var i, n, styles = {};
			if (properties) {
				for (i = 0, n = properties.length; i < n; i++) {
					styles[properties[i]] = $from.css(properties[i]);
				}
			} else {
				styles = $from.css();
			}
			$to.css(styles);
		};
		
		/**
		 * Measures the width of a string within a
		 * parent element (in pixels).
		 *
		 * @param {string} str
		 * @param {object} $parent
		 * @returns {int}
		 */
		var measureString = function(str, $parent) {
			if (!str) {
				return 0;
			}
		
			if (!Selectize.$testInput) {
				Selectize.$testInput = $('<span />').css({
					position: 'absolute',
					top: -99999,
					left: -99999,
					width: 'auto',
					padding: 0,
					whiteSpace: 'pre'
				}).appendTo('body');
			}
		
			Selectize.$testInput.text(str);
		
			transferStyles($parent, Selectize.$testInput, [
				'letterSpacing',
				'fontSize',
				'fontFamily',
				'fontWeight',
				'textTransform'
			]);
		
			return Selectize.$testInput.width();
		};
		
		/**
		 * Sets up an input to grow horizontally as the user
		 * types. If the value is changed manually, you can
		 * trigger the "update" handler to resize:
		 *
		 * $input.trigger('update');
		 *
		 * @param {object} $input
		 */
		var autoGrow = function($input) {
			var currentWidth = null;
		
			var update = function(e, options) {
				var value, keyCode, printable, placeholder, width;
				var shift, character, selection;
				e = e || window.event || {};
				options = options || {};
		
				if (e.metaKey || e.altKey) return;
				if (!options.force && $input.data('grow') === false) return;
		
				value = $input.val();
				if (e.type && e.type.toLowerCase() === 'keydown') {
					keyCode = e.keyCode;
					printable = (
						(keyCode >= 48 && keyCode <= 57)  || // 0-9
						(keyCode >= 65 && keyCode <= 90)   || // a-z
						(keyCode >= 96 && keyCode <= 111)  || // numpad 0-9, numeric operators
						(keyCode >= 186 && keyCode <= 222) || // semicolon, equal, comma, dash, etc.
						keyCode === 32 // space
					);
		
					if (keyCode === KEY_DELETE || keyCode === KEY_BACKSPACE) {
						selection = getSelection($input[0]);
						if (selection.length) {
							value = value.substring(0, selection.start) + value.substring(selection.start + selection.length);
						} else if (keyCode === KEY_BACKSPACE && selection.start) {
							value = value.substring(0, selection.start - 1) + value.substring(selection.start + 1);
						} else if (keyCode === KEY_DELETE && typeof selection.start !== 'undefined') {
							value = value.substring(0, selection.start) + value.substring(selection.start + 1);
						}
					} else if (printable) {
						shift = e.shiftKey;
						character = String.fromCharCode(e.keyCode);
						if (shift) character = character.toUpperCase();
						else character = character.toLowerCase();
						value += character;
					}
				}
		
				placeholder = $input.attr('placeholder');
				if (!value && placeholder) {
					value = placeholder;
				}
		
				width = measureString(value, $input) + 4;
				if (width !== currentWidth) {
					currentWidth = width;
					$input.width(width);
					$input.triggerHandler('resize');
				}
			};
		
			$input.on('keydown keyup update blur', update);
			update();
		};
		
		var domToString = function(d) {
			var tmp = document.createElement('div');
		
			tmp.appendChild(d.cloneNode(true));
		
			return tmp.innerHTML;
		};
		
		var logError = function(message, options){
			if(!options) options = {};
			var component = "Selectize";
		
			console.error(component + ": " + message)
		
			if(options.explanation){
				// console.group is undefined in <IE11
				if(console.group) console.group();
				console.error(options.explanation);
				if(console.group) console.groupEnd();
			}
		}
		
		
		var Selectize = function($input, settings) {
			var key, i, n, dir, input, self = this;
			input = $input[0];
			input.selectize = self;
		
			// detect rtl environment
			var computedStyle = window.getComputedStyle && window.getComputedStyle(input, null);
			dir = computedStyle ? computedStyle.getPropertyValue('direction') : input.currentStyle && input.currentStyle.direction;
			dir = dir || $input.parents('[dir]:first').attr('dir') || '';
		
			// setup default state
			$.extend(self, {
				order            : 0,
				settings         : settings,
				$input           : $input,
				tabIndex         : $input.attr('tabindex') || '',
				tagType          : input.tagName.toLowerCase() === 'select' ? TAG_SELECT : TAG_INPUT,
				rtl              : /rtl/i.test(dir),
		
				eventNS          : '.selectize' + (++Selectize.count),
				highlightedValue : null,
				isBlurring       : false,
				isOpen           : false,
				isDisabled       : false,
				isRequired       : $input.is('[required]'),
				isInvalid        : false,
				isLocked         : false,
				isFocused        : false,
				isInputHidden    : false,
				isSetup          : false,
				isShiftDown      : false,
				isCmdDown        : false,
				isCtrlDown       : false,
				ignoreFocus      : false,
				ignoreBlur       : false,
				ignoreHover      : false,
				hasOptions       : false,
				currentResults   : null,
				lastValue        : '',
				caretPos         : 0,
				loading          : 0,
				loadedSearches   : {},
		
				$activeOption    : null,
				$activeItems     : [],
		
				optgroups        : {},
				options          : {},
				userOptions      : {},
				items            : [],
				renderCache      : {},
				onSearchChange   : settings.loadThrottle === null ? self.onSearchChange : debounce(self.onSearchChange, settings.loadThrottle)
			});
		
			// search system
			self.sifter = new Sifter(this.options, {diacritics: settings.diacritics});
		
			// build options table
			if (self.settings.options) {
				for (i = 0, n = self.settings.options.length; i < n; i++) {
					self.registerOption(self.settings.options[i]);
				}
				delete self.settings.options;
			}
		
			// build optgroup table
			if (self.settings.optgroups) {
				for (i = 0, n = self.settings.optgroups.length; i < n; i++) {
					self.registerOptionGroup(self.settings.optgroups[i]);
				}
				delete self.settings.optgroups;
			}
		
			// option-dependent defaults
			self.settings.mode = self.settings.mode || (self.settings.maxItems === 1 ? 'single' : 'multi');
			if (typeof self.settings.hideSelected !== 'boolean') {
				self.settings.hideSelected = self.settings.mode === 'multi';
			}
		
			self.initializePlugins(self.settings.plugins);
			self.setupCallbacks();
			self.setupTemplates();
			self.setup();
		};
		
		// mixins
		// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
		
		MicroEvent.mixin(Selectize);
		
		if(typeof MicroPlugin !== "undefined"){
			MicroPlugin.mixin(Selectize);
		}else{
			logError("Dependency MicroPlugin is missing",
				{explanation:
					"Make sure you either: (1) are using the \"standalone\" "+
					"version of Selectize, or (2) require MicroPlugin before you "+
					"load Selectize."}
			);
		}
		
		
		// methods
		// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
		
		$.extend(Selectize.prototype, {
		
			/**
			 * Creates all elements and sets up event bindings.
			 */
			setup: function() {
				var self      = this;
				var settings  = self.settings;
				var eventNS   = self.eventNS;
				var $window   = $(window);
				var $document = $(document);
				var $input    = self.$input;
		
				var $wrapper;
				var $control;
				var $control_input;
				var $dropdown;
				var $dropdown_content;
				var $dropdown_parent;
				var inputMode;
				var timeout_blur;
				var timeout_focus;
				var classes;
				var classes_plugins;
				var inputId;
		
				inputMode         = self.settings.mode;
				classes           = $input.attr('class') || '';
		
				$wrapper          = $('<div>').addClass(settings.wrapperClass).addClass(classes).addClass(inputMode);
				$control          = $('<div>').addClass(settings.inputClass).addClass('items').appendTo($wrapper);
				$control_input    = $('<input type="text" autocomplete="off" />').appendTo($control).attr('tabindex', $input.is(':disabled') ? '-1' : self.tabIndex);
				$dropdown_parent  = $(settings.dropdownParent || $wrapper);
				$dropdown         = $('<div>').addClass(settings.dropdownClass).addClass(inputMode).hide().appendTo($dropdown_parent);
				$dropdown_content = $('<div>').addClass(settings.dropdownContentClass).appendTo($dropdown);
		
				if(inputId = $input.attr('id')) {
					$control_input.attr('id', inputId + '-selectized');
					$("label[for='"+inputId+"']").attr('for', inputId + '-selectized');
				}
		
				if(self.settings.copyClassesToDropdown) {
					$dropdown.addClass(classes);
				}
		
				$wrapper.css({
					width: $input[0].style.width
				});
		
				if (self.plugins.names.length) {
					classes_plugins = 'plugin-' + self.plugins.names.join(' plugin-');
					$wrapper.addClass(classes_plugins);
					$dropdown.addClass(classes_plugins);
				}
		
				if ((settings.maxItems === null || settings.maxItems > 1) && self.tagType === TAG_SELECT) {
					$input.attr('multiple', 'multiple');
				}
		
				if (self.settings.placeholder) {
					$control_input.attr('placeholder', settings.placeholder);
				}
		
				// if splitOn was not passed in, construct it from the delimiter to allow pasting universally
				if (!self.settings.splitOn && self.settings.delimiter) {
					var delimiterEscaped = self.settings.delimiter.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
					self.settings.splitOn = new RegExp('\\s*' + delimiterEscaped + '+\\s*');
				}
		
				if ($input.attr('autocorrect')) {
					$control_input.attr('autocorrect', $input.attr('autocorrect'));
				}
		
				if ($input.attr('autocapitalize')) {
					$control_input.attr('autocapitalize', $input.attr('autocapitalize'));
				}
				$control_input[0].type = $input[0].type;
		
				self.$wrapper          = $wrapper;
				self.$control          = $control;
				self.$control_input    = $control_input;
				self.$dropdown         = $dropdown;
				self.$dropdown_content = $dropdown_content;
		
				$dropdown.on('mouseenter mousedown click', '[data-disabled]>[data-selectable]', function(e) { e.stopImmediatePropagation(); });
				$dropdown.on('mouseenter', '[data-selectable]', function() { return self.onOptionHover.apply(self, arguments); });
				$dropdown.on('mousedown click', '[data-selectable]', function() { return self.onOptionSelect.apply(self, arguments); });
				watchChildEvent($control, 'mousedown', '*:not(input)', function() { return self.onItemSelect.apply(self, arguments); });
				autoGrow($control_input);
		
				$control.on({
					mousedown : function() { return self.onMouseDown.apply(self, arguments); },
					click     : function() { return self.onClick.apply(self, arguments); }
				});
		
				$control_input.on({
					mousedown : function(e) { e.stopPropagation(); },
					keydown   : function() { return self.onKeyDown.apply(self, arguments); },
					keyup     : function() { return self.onKeyUp.apply(self, arguments); },
					keypress  : function() { return self.onKeyPress.apply(self, arguments); },
					resize    : function() { self.positionDropdown.apply(self, []); },
					blur      : function() { return self.onBlur.apply(self, arguments); },
					focus     : function() { self.ignoreBlur = false; return self.onFocus.apply(self, arguments); },
					paste     : function() { return self.onPaste.apply(self, arguments); }
				});
		
				$document.on('keydown' + eventNS, function(e) {
					self.isCmdDown = e[IS_MAC ? 'metaKey' : 'ctrlKey'];
					self.isCtrlDown = e[IS_MAC ? 'altKey' : 'ctrlKey'];
					self.isShiftDown = e.shiftKey;
				});
		
				$document.on('keyup' + eventNS, function(e) {
					if (e.keyCode === KEY_CTRL) self.isCtrlDown = false;
					if (e.keyCode === KEY_SHIFT) self.isShiftDown = false;
					if (e.keyCode === KEY_CMD) self.isCmdDown = false;
				});
		
				$document.on('mousedown' + eventNS, function(e) {
					if (self.isFocused) {
						// prevent events on the dropdown scrollbar from causing the control to blur
						if (e.target === self.$dropdown[0] || e.target.parentNode === self.$dropdown[0]) {
							return false;
						}
						// blur on click outside
						if (!self.$control.has(e.target).length && e.target !== self.$control[0]) {
							self.blur(e.target);
						}
					}
				});
		
				$window.on(['scroll' + eventNS, 'resize' + eventNS].join(' '), function() {
					if (self.isOpen) {
						self.positionDropdown.apply(self, arguments);
					}
				});
				$window.on('mousemove' + eventNS, function() {
					self.ignoreHover = false;
				});
		
				// store original children and tab index so that they can be
				// restored when the destroy() method is called.
				this.revertSettings = {
					$children : $input.children().detach(),
					tabindex  : $input.attr('tabindex')
				};
		
				$input.attr('tabindex', -1).hide().after(self.$wrapper);
		
				if ($.isArray(settings.items)) {
					self.setValue(settings.items);
					delete settings.items;
				}
		
				// feature detect for the validation API
				if (SUPPORTS_VALIDITY_API) {
					$input.on('invalid' + eventNS, function(e) {
						e.preventDefault();
						self.isInvalid = true;
						self.refreshState();
					});
				}
		
				self.updateOriginalInput();
				self.refreshItems();
				self.refreshState();
				self.updatePlaceholder();
				self.isSetup = true;
		
				if ($input.is(':disabled')) {
					self.disable();
				}
		
				self.on('change', this.onChange);
		
				$input.data('selectize', self);
				$input.addClass('selectized');
				self.trigger('initialize');
		
				// preload options
				if (settings.preload === true) {
					self.onSearchChange('');
				}
		
			},
		
			/**
			 * Sets up default rendering functions.
			 */
			setupTemplates: function() {
				var self = this;
				var field_label = self.settings.labelField;
				var field_optgroup = self.settings.optgroupLabelField;
		
				var templates = {
					'optgroup': function(data) {
						return '<div class="optgroup">' + data.html + '</div>';
					},
					'optgroup_header': function(data, escape) {
						return '<div class="optgroup-header">' + escape(data[field_optgroup]) + '</div>';
					},
					'option': function(data, escape) {
						return '<div class="option">' + escape(data[field_label]) + '</div>';
					},
					'item': function(data, escape) {
						return '<div class="item">' + escape(data[field_label]) + '</div>';
					},
					'option_create': function(data, escape) {
						return '<div class="create">Add <strong>' + escape(data.input) + '</strong>&hellip;</div>';
					}
				};
		
				self.settings.render = $.extend({}, templates, self.settings.render);
			},
		
			/**
			 * Maps fired events to callbacks provided
			 * in the settings used when creating the control.
			 */
			setupCallbacks: function() {
				var key, fn, callbacks = {
					'initialize'      : 'onInitialize',
					'change'          : 'onChange',
					'item_add'        : 'onItemAdd',
					'item_remove'     : 'onItemRemove',
					'clear'           : 'onClear',
					'option_add'      : 'onOptionAdd',
					'option_remove'   : 'onOptionRemove',
					'option_clear'    : 'onOptionClear',
					'optgroup_add'    : 'onOptionGroupAdd',
					'optgroup_remove' : 'onOptionGroupRemove',
					'optgroup_clear'  : 'onOptionGroupClear',
					'dropdown_open'   : 'onDropdownOpen',
					'dropdown_close'  : 'onDropdownClose',
					'type'            : 'onType',
					'load'            : 'onLoad',
					'focus'           : 'onFocus',
					'blur'            : 'onBlur'
				};
		
				for (key in callbacks) {
					if (callbacks.hasOwnProperty(key)) {
						fn = this.settings[callbacks[key]];
						if (fn) this.on(key, fn);
					}
				}
			},
		
			/**
			 * Triggered when the main control element
			 * has a click event.
			 *
			 * @param {object} e
			 * @return {boolean}
			 */
			onClick: function(e) {
				var self = this;
		
				// necessary for mobile webkit devices (manual focus triggering
				// is ignored unless invoked within a click event)
		    // also necessary to reopen a dropdown that has been closed by
		    // closeAfterSelect
				if (!self.isFocused || !self.isOpen) {
					self.focus();
					e.preventDefault();
				}
			},
		
			/**
			 * Triggered when the main control element
			 * has a mouse down event.
			 *
			 * @param {object} e
			 * @return {boolean}
			 */
			onMouseDown: function(e) {
				var self = this;
				var defaultPrevented = e.isDefaultPrevented();
				var $target = $(e.target);
		
				if (self.isFocused) {
					// retain focus by preventing native handling. if the
					// event target is the input it should not be modified.
					// otherwise, text selection within the input won't work.
					if (e.target !== self.$control_input[0]) {
						if (self.settings.mode === 'single') {
							// toggle dropdown
							self.isOpen ? self.close() : self.open();
						} else if (!defaultPrevented) {
							self.setActiveItem(null);
						}
						return false;
					}
				} else {
					// give control focus
					if (!defaultPrevented) {
						window.setTimeout(function() {
							self.focus();
						}, 0);
					}
				}
			},
		
			/**
			 * Triggered when the value of the control has been changed.
			 * This should propagate the event to the original DOM
			 * input / select element.
			 */
			onChange: function() {
				this.$input.trigger('change');
			},
		
			/**
			 * Triggered on <input> paste.
			 *
			 * @param {object} e
			 * @returns {boolean}
			 */
			onPaste: function(e) {
				var self = this;
		
				if (self.isFull() || self.isInputHidden || self.isLocked) {
					e.preventDefault();
					return;
				}
		
				// If a regex or string is included, this will split the pasted
				// input and create Items for each separate value
				if (self.settings.splitOn) {
		
					// Wait for pasted text to be recognized in value
					setTimeout(function() {
						var pastedText = self.$control_input.val();
						if(!pastedText.match(self.settings.splitOn)){ return }
		
						var splitInput = $.trim(pastedText).split(self.settings.splitOn);
						for (var i = 0, n = splitInput.length; i < n; i++) {
							self.createItem(splitInput[i]);
						}
					}, 0);
				}
			},
		
			/**
			 * Triggered on <input> keypress.
			 *
			 * @param {object} e
			 * @returns {boolean}
			 */
			onKeyPress: function(e) {
				if (this.isLocked) return e && e.preventDefault();
				var character = String.fromCharCode(e.keyCode || e.which);
				if (this.settings.create && this.settings.mode === 'multi' && character === this.settings.delimiter) {
					this.createItem();
					e.preventDefault();
					return false;
				}
			},
		
			/**
			 * Triggered on <input> keydown.
			 *
			 * @param {object} e
			 * @returns {boolean}
			 */
			onKeyDown: function(e) {
				var isInput = e.target === this.$control_input[0];
				var self = this;
		
				if (self.isLocked) {
					if (e.keyCode !== KEY_TAB) {
						e.preventDefault();
					}
					return;
				}
		
				switch (e.keyCode) {
					case KEY_A:
						if (self.isCmdDown) {
							self.selectAll();
							return;
						}
						break;
					case KEY_ESC:
						if (self.isOpen) {
							e.preventDefault();
							e.stopPropagation();
							self.close();
						}
						return;
					case KEY_N:
						if (!e.ctrlKey || e.altKey) break;
					case KEY_DOWN:
						if (!self.isOpen && self.hasOptions) {
							self.open();
						} else if (self.$activeOption) {
							self.ignoreHover = true;
							var $next = self.getAdjacentOption(self.$activeOption, 1);
							if ($next.length) self.setActiveOption($next, true, true);
						}
						e.preventDefault();
						return;
					case KEY_P:
						if (!e.ctrlKey || e.altKey) break;
					case KEY_UP:
						if (self.$activeOption) {
							self.ignoreHover = true;
							var $prev = self.getAdjacentOption(self.$activeOption, -1);
							if ($prev.length) self.setActiveOption($prev, true, true);
						}
						e.preventDefault();
						return;
					case KEY_RETURN:
						if (self.isOpen && self.$activeOption) {
							self.onOptionSelect({currentTarget: self.$activeOption});
							e.preventDefault();
						}
						return;
					case KEY_LEFT:
						self.advanceSelection(-1, e);
						return;
					case KEY_RIGHT:
						self.advanceSelection(1, e);
						return;
					case KEY_TAB:
						if (self.settings.selectOnTab && self.isOpen && self.$activeOption) {
							self.onOptionSelect({currentTarget: self.$activeOption});
		
							// Default behaviour is to jump to the next field, we only want this
							// if the current field doesn't accept any more entries
							if (!self.isFull()) {
								e.preventDefault();
							}
						}
						if (self.settings.create && self.createItem()) {
							e.preventDefault();
						}
						return;
					case KEY_BACKSPACE:
					case KEY_DELETE:
						self.deleteSelection(e);
						return;
				}
		
				if ((self.isFull() || self.isInputHidden) && !(IS_MAC ? e.metaKey : e.ctrlKey)) {
					e.preventDefault();
					return;
				}
			},
		
			/**
			 * Triggered on <input> keyup.
			 *
			 * @param {object} e
			 * @returns {boolean}
			 */
			onKeyUp: function(e) {
				var self = this;
		
				if (self.isLocked) return e && e.preventDefault();
				var value = self.$control_input.val() || '';
				if (self.lastValue !== value) {
					self.lastValue = value;
					self.onSearchChange(value);
					self.refreshOptions();
					self.trigger('type', value);
				}
			},
		
			/**
			 * Invokes the user-provide option provider / loader.
			 *
			 * Note: this function is debounced in the Selectize
			 * constructor (by `settings.loadThrottle` milliseconds)
			 *
			 * @param {string} value
			 */
			onSearchChange: function(value) {
				var self = this;
				var fn = self.settings.load;
				if (!fn) return;
				if (self.loadedSearches.hasOwnProperty(value)) return;
				self.loadedSearches[value] = true;
				self.load(function(callback) {
					fn.apply(self, [value, callback]);
				});
			},
		
			/**
			 * Triggered on <input> focus.
			 *
			 * @param {object} e (optional)
			 * @returns {boolean}
			 */
			onFocus: function(e) {
				var self = this;
				var wasFocused = self.isFocused;
		
				if (self.isDisabled) {
					self.blur();
					e && e.preventDefault();
					return false;
				}
		
				if (self.ignoreFocus) return;
				self.isFocused = true;
				if (self.settings.preload === 'focus') self.onSearchChange('');
		
				if (!wasFocused) self.trigger('focus');
		
				if (!self.$activeItems.length) {
					self.showInput();
					self.setActiveItem(null);
					self.refreshOptions(!!self.settings.openOnFocus);
				}
		
				self.refreshState();
			},
		
			/**
			 * Triggered on <input> blur.
			 *
			 * @param {object} e
			 * @param {Element} dest
			 */
			onBlur: function(e, dest) {
				var self = this;
				if (!self.isFocused) return;
				self.isFocused = false;
		
				if (self.ignoreFocus) {
					return;
				} else if (!self.ignoreBlur && document.activeElement === self.$dropdown_content[0]) {
					// necessary to prevent IE closing the dropdown when the scrollbar is clicked
					self.ignoreBlur = true;
					self.onFocus(e);
					return;
				}
		
				var deactivate = function() {
					self.close();
					self.setTextboxValue('');
					self.setActiveItem(null);
					self.setActiveOption(null);
					self.setCaret(self.items.length);
					self.refreshState();
		
					// IE11 bug: element still marked as active
					dest && dest.focus && dest.focus();
		
					self.isBlurring = false;
					self.ignoreFocus = false;
					self.trigger('blur');
				};
		
				self.isBlurring = true;
				self.ignoreFocus = true;
				if (self.settings.create && self.settings.createOnBlur) {
					self.createItem(null, false, deactivate);
				} else {
					deactivate();
				}
			},
		
			/**
			 * Triggered when the user rolls over
			 * an option in the autocomplete dropdown menu.
			 *
			 * @param {object} e
			 * @returns {boolean}
			 */
			onOptionHover: function(e) {
				if (this.ignoreHover) return;
				this.setActiveOption(e.currentTarget, false);
			},
		
			/**
			 * Triggered when the user clicks on an option
			 * in the autocomplete dropdown menu.
			 *
			 * @param {object} e
			 * @returns {boolean}
			 */
			onOptionSelect: function(e) {
				var value, $target, $option, self = this;
		
				if (e.preventDefault) {
					e.preventDefault();
					e.stopPropagation();
				}
		
				$target = $(e.currentTarget);
				if ($target.hasClass('create')) {
					self.createItem(null, function() {
						if (self.settings.closeAfterSelect) {
							self.close();
						}
					});
				} else {
					value = $target.attr('data-value');
					if (typeof value !== 'undefined') {
						self.lastQuery = null;
						self.setTextboxValue('');
						self.addItem(value);
						if (self.settings.closeAfterSelect) {
							self.close();
						} else if (!self.settings.hideSelected && e.type && /mouse/.test(e.type)) {
							self.setActiveOption(self.getOption(value));
						}
					}
				}
			},
		
			/**
			 * Triggered when the user clicks on an item
			 * that has been selected.
			 *
			 * @param {object} e
			 * @returns {boolean}
			 */
			onItemSelect: function(e) {
				var self = this;
		
				if (self.isLocked) return;
				if (self.settings.mode === 'multi') {
					e.preventDefault();
					self.setActiveItem(e.currentTarget, e);
				}
			},
		
			/**
			 * Invokes the provided method that provides
			 * results to a callback---which are then added
			 * as options to the control.
			 *
			 * @param {function} fn
			 */
			load: function(fn) {
				var self = this;
				var $wrapper = self.$wrapper.addClass(self.settings.loadingClass);
		
				self.loading++;
				fn.apply(self, [function(results) {
					self.loading = Math.max(self.loading - 1, 0);
					if (results && results.length) {
						self.addOption(results);
						self.refreshOptions(self.isFocused && !self.isInputHidden);
					}
					if (!self.loading) {
						$wrapper.removeClass(self.settings.loadingClass);
					}
					self.trigger('load', results);
				}]);
			},
		
			/**
			 * Sets the input field of the control to the specified value.
			 *
			 * @param {string} value
			 */
			setTextboxValue: function(value) {
				var $input = this.$control_input;
				var changed = $input.val() !== value;
				if (changed) {
					$input.val(value).triggerHandler('update');
					this.lastValue = value;
				}
			},
		
			/**
			 * Returns the value of the control. If multiple items
			 * can be selected (e.g. <select multiple>), this returns
			 * an array. If only one item can be selected, this
			 * returns a string.
			 *
			 * @returns {mixed}
			 */
			getValue: function() {
				if (this.tagType === TAG_SELECT && this.$input.attr('multiple')) {
					return this.items;
				} else {
					return this.items.join(this.settings.delimiter);
				}
			},
		
			/**
			 * Resets the selected items to the given value.
			 *
			 * @param {mixed} value
			 */
			setValue: function(value, silent) {
				var events = silent ? [] : ['change'];
		
				debounce_events(this, events, function() {
					this.clear(silent);
					this.addItems(value, silent);
				});
			},
		
			/**
			 * Sets the selected item.
			 *
			 * @param {object} $item
			 * @param {object} e (optional)
			 */
			setActiveItem: function($item, e) {
				var self = this;
				var eventName;
				var i, idx, begin, end, item, swap;
				var $last;
		
				if (self.settings.mode === 'single') return;
				$item = $($item);
		
				// clear the active selection
				if (!$item.length) {
					$(self.$activeItems).removeClass('active');
					self.$activeItems = [];
					if (self.isFocused) {
						self.showInput();
					}
					return;
				}
		
				// modify selection
				eventName = e && e.type.toLowerCase();
		
				if (eventName === 'mousedown' && self.isShiftDown && self.$activeItems.length) {
					$last = self.$control.children('.active:last');
					begin = Array.prototype.indexOf.apply(self.$control[0].childNodes, [$last[0]]);
					end   = Array.prototype.indexOf.apply(self.$control[0].childNodes, [$item[0]]);
					if (begin > end) {
						swap  = begin;
						begin = end;
						end   = swap;
					}
					for (i = begin; i <= end; i++) {
						item = self.$control[0].childNodes[i];
						if (self.$activeItems.indexOf(item) === -1) {
							$(item).addClass('active');
							self.$activeItems.push(item);
						}
					}
					e.preventDefault();
				} else if ((eventName === 'mousedown' && self.isCtrlDown) || (eventName === 'keydown' && this.isShiftDown)) {
					if ($item.hasClass('active')) {
						idx = self.$activeItems.indexOf($item[0]);
						self.$activeItems.splice(idx, 1);
						$item.removeClass('active');
					} else {
						self.$activeItems.push($item.addClass('active')[0]);
					}
				} else {
					$(self.$activeItems).removeClass('active');
					self.$activeItems = [$item.addClass('active')[0]];
				}
		
				// ensure control has focus
				self.hideInput();
				if (!this.isFocused) {
					self.focus();
				}
			},
		
			/**
			 * Sets the selected item in the dropdown menu
			 * of available options.
			 *
			 * @param {object} $object
			 * @param {boolean} scroll
			 * @param {boolean} animate
			 */
			setActiveOption: function($option, scroll, animate) {
				var height_menu, height_item, y;
				var scroll_top, scroll_bottom;
				var self = this;
		
				if (self.$activeOption) self.$activeOption.removeClass('active');
				self.$activeOption = null;
		
				$option = $($option);
				if (!$option.length) return;
		
				self.$activeOption = $option.addClass('active');
		
				if (scroll || !isset(scroll)) {
		
					height_menu   = self.$dropdown_content.height();
					height_item   = self.$activeOption.outerHeight(true);
					scroll        = self.$dropdown_content.scrollTop() || 0;
					y             = self.$activeOption.offset().top - self.$dropdown_content.offset().top + scroll;
					scroll_top    = y;
					scroll_bottom = y - height_menu + height_item;
		
					if (y + height_item > height_menu + scroll) {
						self.$dropdown_content.stop().animate({scrollTop: scroll_bottom}, animate ? self.settings.scrollDuration : 0);
					} else if (y < scroll) {
						self.$dropdown_content.stop().animate({scrollTop: scroll_top}, animate ? self.settings.scrollDuration : 0);
					}
		
				}
			},
		
			/**
			 * Selects all items (CTRL + A).
			 */
			selectAll: function() {
				var self = this;
				if (self.settings.mode === 'single') return;
		
				self.$activeItems = Array.prototype.slice.apply(self.$control.children(':not(input)').addClass('active'));
				if (self.$activeItems.length) {
					self.hideInput();
					self.close();
				}
				self.focus();
			},
		
			/**
			 * Hides the input element out of view, while
			 * retaining its focus.
			 */
			hideInput: function() {
				var self = this;
		
				self.setTextboxValue('');
				self.$control_input.css({opacity: 0, position: 'absolute', left: self.rtl ? 10000 : -10000});
				self.isInputHidden = true;
			},
		
			/**
			 * Restores input visibility.
			 */
			showInput: function() {
				this.$control_input.css({opacity: 1, position: 'relative', left: 0});
				this.isInputHidden = false;
			},
		
			/**
			 * Gives the control focus.
			 */
			focus: function() {
				var self = this;
				if (self.isDisabled) return;
		
				self.ignoreFocus = true;
				self.$control_input[0].focus();
				window.setTimeout(function() {
					self.ignoreFocus = false;
					self.onFocus();
				}, 0);
			},
		
			/**
			 * Forces the control out of focus.
			 *
			 * @param {Element} dest
			 */
			blur: function(dest) {
				this.$control_input[0].blur();
				this.onBlur(null, dest);
			},
		
			/**
			 * Returns a function that scores an object
			 * to show how good of a match it is to the
			 * provided query.
			 *
			 * @param {string} query
			 * @param {object} options
			 * @return {function}
			 */
			getScoreFunction: function(query) {
				return this.sifter.getScoreFunction(query, this.getSearchOptions());
			},
		
			/**
			 * Returns search options for sifter (the system
			 * for scoring and sorting results).
			 *
			 * @see https://github.com/brianreavis/sifter.js
			 * @return {object}
			 */
			getSearchOptions: function() {
				var settings = this.settings;
				var sort = settings.sortField;
				if (typeof sort === 'string') {
					sort = [{field: sort}];
				}
		
				return {
					fields      : settings.searchField,
					conjunction : settings.searchConjunction,
					sort        : sort,
					nesting     : settings.nesting
				};
			},
		
			/**
			 * Searches through available options and returns
			 * a sorted array of matches.
			 *
			 * Returns an object containing:
			 *
			 *   - query {string}
			 *   - tokens {array}
			 *   - total {int}
			 *   - items {array}
			 *
			 * @param {string} query
			 * @returns {object}
			 */
			search: function(query) {
				var i, value, score, result, calculateScore;
				var self     = this;
				var settings = self.settings;
				var options  = this.getSearchOptions();
		
				// validate user-provided result scoring function
				if (settings.score) {
					calculateScore = self.settings.score.apply(this, [query]);
					if (typeof calculateScore !== 'function') {
						throw new Error('Selectize "score" setting must be a function that returns a function');
					}
				}
		
				// perform search
				if (query !== self.lastQuery) {
					self.lastQuery = query;
					result = self.sifter.search(query, $.extend(options, {score: calculateScore}));
					self.currentResults = result;
				} else {
					result = $.extend(true, {}, self.currentResults);
				}
		
				// filter out selected items
				if (settings.hideSelected) {
					for (i = result.items.length - 1; i >= 0; i--) {
						if (self.items.indexOf(hash_key(result.items[i].id)) !== -1) {
							result.items.splice(i, 1);
						}
					}
				}
		
				return result;
			},
		
			/**
			 * Refreshes the list of available options shown
			 * in the autocomplete dropdown menu.
			 *
			 * @param {boolean} triggerDropdown
			 */
			refreshOptions: function(triggerDropdown) {
				var i, j, k, n, groups, groups_order, option, option_html, optgroup, optgroups, html, html_children, has_create_option;
				var $active, $active_before, $create;
		
				if (typeof triggerDropdown === 'undefined') {
					triggerDropdown = true;
				}
		
				var self              = this;
				var query             = $.trim(self.$control_input.val());
				var results           = self.search(query);
				var $dropdown_content = self.$dropdown_content;
				var active_before     = self.$activeOption && hash_key(self.$activeOption.attr('data-value'));
		
				// build markup
				n = results.items.length;
				if (typeof self.settings.maxOptions === 'number') {
					n = Math.min(n, self.settings.maxOptions);
				}
		
				// render and group available options individually
				groups = {};
				groups_order = [];
		
				for (i = 0; i < n; i++) {
					option      = self.options[results.items[i].id];
					option_html = self.render('option', option);
					optgroup    = option[self.settings.optgroupField] || '';
					optgroups   = $.isArray(optgroup) ? optgroup : [optgroup];
		
					for (j = 0, k = optgroups && optgroups.length; j < k; j++) {
						optgroup = optgroups[j];
						if (!self.optgroups.hasOwnProperty(optgroup)) {
							optgroup = '';
						}
						if (!groups.hasOwnProperty(optgroup)) {
							groups[optgroup] = document.createDocumentFragment();
							groups_order.push(optgroup);
						}
						groups[optgroup].appendChild(option_html);
					}
				}
		
				// sort optgroups
				if (this.settings.lockOptgroupOrder) {
					groups_order.sort(function(a, b) {
						var a_order = self.optgroups[a].$order || 0;
						var b_order = self.optgroups[b].$order || 0;
						return a_order - b_order;
					});
				}
		
				// render optgroup headers & join groups
				html = document.createDocumentFragment();
				for (i = 0, n = groups_order.length; i < n; i++) {
					optgroup = groups_order[i];
					if (self.optgroups.hasOwnProperty(optgroup) && groups[optgroup].childNodes.length) {
						// render the optgroup header and options within it,
						// then pass it to the wrapper template
						html_children = document.createDocumentFragment();
						html_children.appendChild(self.render('optgroup_header', self.optgroups[optgroup]));
						html_children.appendChild(groups[optgroup]);
		
						html.appendChild(self.render('optgroup', $.extend({}, self.optgroups[optgroup], {
							html: domToString(html_children),
							dom:  html_children
						})));
					} else {
						html.appendChild(groups[optgroup]);
					}
				}
		
				$dropdown_content.html(html);
		
				// highlight matching terms inline
				if (self.settings.highlight) {
					$dropdown_content.removeHighlight();
					if (results.query.length && results.tokens.length) {
						for (i = 0, n = results.tokens.length; i < n; i++) {
							highlight($dropdown_content, results.tokens[i].regex);
						}
					}
				}
		
				// add "selected" class to selected options
				if (!self.settings.hideSelected) {
					for (i = 0, n = self.items.length; i < n; i++) {
						self.getOption(self.items[i]).addClass('selected');
					}
				}
		
				// add create option
				has_create_option = self.canCreate(query);
				if (has_create_option) {
					$dropdown_content.prepend(self.render('option_create', {input: query}));
					$create = $($dropdown_content[0].childNodes[0]);
				}
		
				// activate
				self.hasOptions = results.items.length > 0 || has_create_option;
				if (self.hasOptions) {
					if (results.items.length > 0) {
						$active_before = active_before && self.getOption(active_before);
						if ($active_before && $active_before.length) {
							$active = $active_before;
						} else if (self.settings.mode === 'single' && self.items.length) {
							$active = self.getOption(self.items[0]);
						}
						if (!$active || !$active.length) {
							if ($create && !self.settings.addPrecedence) {
								$active = self.getAdjacentOption($create, 1);
							} else {
								$active = $dropdown_content.find('[data-selectable]:first');
							}
						}
					} else {
						$active = $create;
					}
					self.setActiveOption($active);
					if (triggerDropdown && !self.isOpen) { self.open(); }
				} else {
					self.setActiveOption(null);
					if (triggerDropdown && self.isOpen) { self.close(); }
				}
			},
		
			/**
			 * Adds an available option. If it already exists,
			 * nothing will happen. Note: this does not refresh
			 * the options list dropdown (use `refreshOptions`
			 * for that).
			 *
			 * Usage:
			 *
			 *   this.addOption(data)
			 *
			 * @param {object|array} data
			 */
			addOption: function(data) {
				var i, n, value, self = this;
		
				if ($.isArray(data)) {
					for (i = 0, n = data.length; i < n; i++) {
						self.addOption(data[i]);
					}
					return;
				}
		
				if (value = self.registerOption(data)) {
					self.userOptions[value] = true;
					self.lastQuery = null;
					self.trigger('option_add', value, data);
				}
			},
		
			/**
			 * Registers an option to the pool of options.
			 *
			 * @param {object} data
			 * @return {boolean|string}
			 */
			registerOption: function(data) {
				var key = hash_key(data[this.settings.valueField]);
				if (typeof key === 'undefined' || key === null || this.options.hasOwnProperty(key)) return false;
				data.$order = data.$order || ++this.order;
				this.options[key] = data;
				return key;
			},
		
			/**
			 * Registers an option group to the pool of option groups.
			 *
			 * @param {object} data
			 * @return {boolean|string}
			 */
			registerOptionGroup: function(data) {
				var key = hash_key(data[this.settings.optgroupValueField]);
				if (!key) return false;
		
				data.$order = data.$order || ++this.order;
				this.optgroups[key] = data;
				return key;
			},
		
			/**
			 * Registers a new optgroup for options
			 * to be bucketed into.
			 *
			 * @param {string} id
			 * @param {object} data
			 */
			addOptionGroup: function(id, data) {
				data[this.settings.optgroupValueField] = id;
				if (id = this.registerOptionGroup(data)) {
					this.trigger('optgroup_add', id, data);
				}
			},
		
			/**
			 * Removes an existing option group.
			 *
			 * @param {string} id
			 */
			removeOptionGroup: function(id) {
				if (this.optgroups.hasOwnProperty(id)) {
					delete this.optgroups[id];
					this.renderCache = {};
					this.trigger('optgroup_remove', id);
				}
			},
		
			/**
			 * Clears all existing option groups.
			 */
			clearOptionGroups: function() {
				this.optgroups = {};
				this.renderCache = {};
				this.trigger('optgroup_clear');
			},
		
			/**
			 * Updates an option available for selection. If
			 * it is visible in the selected items or options
			 * dropdown, it will be re-rendered automatically.
			 *
			 * @param {string} value
			 * @param {object} data
			 */
			updateOption: function(value, data) {
				var self = this;
				var $item, $item_new;
				var value_new, index_item, cache_items, cache_options, order_old;
		
				value     = hash_key(value);
				value_new = hash_key(data[self.settings.valueField]);
		
				// sanity checks
				if (value === null) return;
				if (!self.options.hasOwnProperty(value)) return;
				if (typeof value_new !== 'string') throw new Error('Value must be set in option data');
		
				order_old = self.options[value].$order;
		
				// update references
				if (value_new !== value) {
					delete self.options[value];
					index_item = self.items.indexOf(value);
					if (index_item !== -1) {
						self.items.splice(index_item, 1, value_new);
					}
				}
				data.$order = data.$order || order_old;
				self.options[value_new] = data;
		
				// invalidate render cache
				cache_items = self.renderCache['item'];
				cache_options = self.renderCache['option'];
		
				if (cache_items) {
					delete cache_items[value];
					delete cache_items[value_new];
				}
				if (cache_options) {
					delete cache_options[value];
					delete cache_options[value_new];
				}
		
				// update the item if it's selected
				if (self.items.indexOf(value_new) !== -1) {
					$item = self.getItem(value);
					$item_new = $(self.render('item', data));
					if ($item.hasClass('active')) $item_new.addClass('active');
					$item.replaceWith($item_new);
				}
		
				// invalidate last query because we might have updated the sortField
				self.lastQuery = null;
		
				// update dropdown contents
				if (self.isOpen) {
					self.refreshOptions(false);
				}
			},
		
			/**
			 * Removes a single option.
			 *
			 * @param {string} value
			 * @param {boolean} silent
			 */
			removeOption: function(value, silent) {
				var self = this;
				value = hash_key(value);
		
				var cache_items = self.renderCache['item'];
				var cache_options = self.renderCache['option'];
				if (cache_items) delete cache_items[value];
				if (cache_options) delete cache_options[value];
		
				delete self.userOptions[value];
				delete self.options[value];
				self.lastQuery = null;
				self.trigger('option_remove', value);
				self.removeItem(value, silent);
			},
		
			/**
			 * Clears all options.
			 */
			clearOptions: function() {
				var self = this;
		
				self.loadedSearches = {};
				self.userOptions = {};
				self.renderCache = {};
				var options = self.options;
				$.each(self.options, function(key, value) {
					if(self.items.indexOf(key) == -1) {
						delete options[key];
					}
				});
				self.options = self.sifter.items = options;
				self.lastQuery = null;
				self.trigger('option_clear');
			},
		
			/**
			 * Returns the jQuery element of the option
			 * matching the given value.
			 *
			 * @param {string} value
			 * @returns {object}
			 */
			getOption: function(value) {
				return this.getElementWithValue(value, this.$dropdown_content.find('[data-selectable]'));
			},
		
			/**
			 * Returns the jQuery element of the next or
			 * previous selectable option.
			 *
			 * @param {object} $option
			 * @param {int} direction  can be 1 for next or -1 for previous
			 * @return {object}
			 */
			getAdjacentOption: function($option, direction) {
				var $options = this.$dropdown.find('[data-selectable]');
				var index    = $options.index($option) + direction;
		
				return index >= 0 && index < $options.length ? $options.eq(index) : $();
			},
		
			/**
			 * Finds the first element with a "data-value" attribute
			 * that matches the given value.
			 *
			 * @param {mixed} value
			 * @param {object} $els
			 * @return {object}
			 */
			getElementWithValue: function(value, $els) {
				value = hash_key(value);
		
				if (typeof value !== 'undefined' && value !== null) {
					for (var i = 0, n = $els.length; i < n; i++) {
						if ($els[i].getAttribute('data-value') === value) {
							return $($els[i]);
						}
					}
				}
		
				return $();
			},
		
			/**
			 * Returns the jQuery element of the item
			 * matching the given value.
			 *
			 * @param {string} value
			 * @returns {object}
			 */
			getItem: function(value) {
				return this.getElementWithValue(value, this.$control.children());
			},
		
			/**
			 * "Selects" multiple items at once. Adds them to the list
			 * at the current caret position.
			 *
			 * @param {string} value
			 * @param {boolean} silent
			 */
			addItems: function(values, silent) {
				this.buffer = document.createDocumentFragment();
		
				var childNodes = this.$control[0].childNodes;
				for (var i = 0; i < childNodes.length; i++) {
					this.buffer.appendChild(childNodes[i]);
				}
		
				var items = $.isArray(values) ? values : [values];
				for (var i = 0, n = items.length; i < n; i++) {
					this.isPending = (i < n - 1);
					this.addItem(items[i], silent);
				}
		
				var control = this.$control[0];
				control.insertBefore(this.buffer, control.firstChild);
		
				this.buffer = null;
			},
		
			/**
			 * "Selects" an item. Adds it to the list
			 * at the current caret position.
			 *
			 * @param {string} value
			 * @param {boolean} silent
			 */
			addItem: function(value, silent) {
				var events = silent ? [] : ['change'];
		
				debounce_events(this, events, function() {
					var $item, $option, $options;
					var self = this;
					var inputMode = self.settings.mode;
					var i, active, value_next, wasFull;
					value = hash_key(value);
		
					if (self.items.indexOf(value) !== -1) {
						if (inputMode === 'single') self.close();
						return;
					}
		
					if (!self.options.hasOwnProperty(value)) return;
					if (inputMode === 'single') self.clear(silent);
					if (inputMode === 'multi' && self.isFull()) return;
		
					$item = $(self.render('item', self.options[value]));
					wasFull = self.isFull();
					self.items.splice(self.caretPos, 0, value);
					self.insertAtCaret($item);
					if (!self.isPending || (!wasFull && self.isFull())) {
						self.refreshState();
					}
		
					if (self.isSetup) {
						$options = self.$dropdown_content.find('[data-selectable]');
		
						// update menu / remove the option (if this is not one item being added as part of series)
						if (!self.isPending) {
							$option = self.getOption(value);
							value_next = self.getAdjacentOption($option, 1).attr('data-value');
							self.refreshOptions(self.isFocused && inputMode !== 'single');
							if (value_next) {
								self.setActiveOption(self.getOption(value_next));
							}
						}
		
						// hide the menu if the maximum number of items have been selected or no options are left
						if (!$options.length || self.isFull()) {
							self.close();
						} else if (!self.isPending) {
							self.positionDropdown();
						}
		
						self.updatePlaceholder();
						self.trigger('item_add', value, $item);
		
						if (!self.isPending) {
							self.updateOriginalInput({silent: silent});
						}
					}
				});
			},
		
			/**
			 * Removes the selected item matching
			 * the provided value.
			 *
			 * @param {string} value
			 */
			removeItem: function(value, silent) {
				var self = this;
				var $item, i, idx;
		
				$item = (value instanceof $) ? value : self.getItem(value);
				value = hash_key($item.attr('data-value'));
				i = self.items.indexOf(value);
		
				if (i !== -1) {
					$item.remove();
					if ($item.hasClass('active')) {
						idx = self.$activeItems.indexOf($item[0]);
						self.$activeItems.splice(idx, 1);
					}
		
					self.items.splice(i, 1);
					self.lastQuery = null;
					if (!self.settings.persist && self.userOptions.hasOwnProperty(value)) {
						self.removeOption(value, silent);
					}
		
					if (i < self.caretPos) {
						self.setCaret(self.caretPos - 1);
					}
		
					self.refreshState();
					self.updatePlaceholder();
					self.updateOriginalInput({silent: silent});
					self.positionDropdown();
					self.trigger('item_remove', value, $item);
				}
			},
		
			/**
			 * Invokes the `create` method provided in the
			 * selectize options that should provide the data
			 * for the new item, given the user input.
			 *
			 * Once this completes, it will be added
			 * to the item list.
			 *
			 * @param {string} value
			 * @param {boolean} [triggerDropdown]
			 * @param {function} [callback]
			 * @return {boolean}
			 */
			createItem: function(input, triggerDropdown) {
				var self  = this;
				var caret = self.caretPos;
				input = input || $.trim(self.$control_input.val() || '');
		
				var callback = arguments[arguments.length - 1];
				if (typeof callback !== 'function') callback = function() {};
		
				if (typeof triggerDropdown !== 'boolean') {
					triggerDropdown = true;
				}
		
				if (!self.canCreate(input)) {
					callback();
					return false;
				}
		
				self.lock();
		
				var setup = (typeof self.settings.create === 'function') ? this.settings.create : function(input) {
					var data = {};
					data[self.settings.labelField] = input;
					data[self.settings.valueField] = input;
					return data;
				};
		
				var create = once(function(data) {
					self.unlock();
		
					if (!data || typeof data !== 'object') return callback();
					var value = hash_key(data[self.settings.valueField]);
					if (typeof value !== 'string') return callback();
		
					self.setTextboxValue('');
					self.addOption(data);
					self.setCaret(caret);
					self.addItem(value);
					self.refreshOptions(triggerDropdown && self.settings.mode !== 'single');
					callback(data);
				});
		
				var output = setup.apply(this, [input, create]);
				if (typeof output !== 'undefined') {
					create(output);
				}
		
				return true;
			},
		
			/**
			 * Re-renders the selected item lists.
			 */
			refreshItems: function() {
				this.lastQuery = null;
		
				if (this.isSetup) {
					this.addItem(this.items);
				}
		
				this.refreshState();
				this.updateOriginalInput();
			},
		
			/**
			 * Updates all state-dependent attributes
			 * and CSS classes.
			 */
			refreshState: function() {
				this.refreshValidityState();
				this.refreshClasses();
			},
		
			/**
			 * Update the `required` attribute of both input and control input.
			 *
			 * The `required` property needs to be activated on the control input
			 * for the error to be displayed at the right place. `required` also
			 * needs to be temporarily deactivated on the input since the input is
			 * hidden and can't show errors.
			 */
			refreshValidityState: function() {
				if (!this.isRequired) return false;
		
				var invalid = !this.items.length;
		
				this.isInvalid = invalid;
				this.$control_input.prop('required', invalid);
				this.$input.prop('required', !invalid);
			},
		
			/**
			 * Updates all state-dependent CSS classes.
			 */
			refreshClasses: function() {
				var self     = this;
				var isFull   = self.isFull();
				var isLocked = self.isLocked;
		
				self.$wrapper
					.toggleClass('rtl', self.rtl);
		
				self.$control
					.toggleClass('focus', self.isFocused)
					.toggleClass('disabled', self.isDisabled)
					.toggleClass('required', self.isRequired)
					.toggleClass('invalid', self.isInvalid)
					.toggleClass('locked', isLocked)
					.toggleClass('full', isFull).toggleClass('not-full', !isFull)
					.toggleClass('input-active', self.isFocused && !self.isInputHidden)
					.toggleClass('dropdown-active', self.isOpen)
					.toggleClass('has-options', !$.isEmptyObject(self.options))
					.toggleClass('has-items', self.items.length > 0);
		
				self.$control_input.data('grow', !isFull && !isLocked);
			},
		
			/**
			 * Determines whether or not more items can be added
			 * to the control without exceeding the user-defined maximum.
			 *
			 * @returns {boolean}
			 */
			isFull: function() {
				return this.settings.maxItems !== null && this.items.length >= this.settings.maxItems;
			},
		
			/**
			 * Refreshes the original <select> or <input>
			 * element to reflect the current state.
			 */
			updateOriginalInput: function(opts) {
				var i, n, options, label, self = this;
				opts = opts || {};
		
				if (self.tagType === TAG_SELECT) {
					options = [];
					for (i = 0, n = self.items.length; i < n; i++) {
						label = self.options[self.items[i]][self.settings.labelField] || '';
						options.push('<option value="' + escape_html(self.items[i]) + '" selected="selected">' + escape_html(label) + '</option>');
					}
					if (!options.length && !this.$input.attr('multiple')) {
						options.push('<option value="" selected="selected"></option>');
					}
					self.$input.html(options.join(''));
				} else {
					self.$input.val(self.getValue());
					self.$input.attr('value',self.$input.val());
				}
		
				if (self.isSetup) {
					if (!opts.silent) {
						self.trigger('change', self.$input.val());
					}
				}
			},
		
			/**
			 * Shows/hide the input placeholder depending
			 * on if there items in the list already.
			 */
			updatePlaceholder: function() {
				if (!this.settings.placeholder) return;
				var $input = this.$control_input;
		
				if (this.items.length) {
					$input.removeAttr('placeholder');
				} else {
					$input.attr('placeholder', this.settings.placeholder);
				}
				$input.triggerHandler('update', {force: true});
			},
		
			/**
			 * Shows the autocomplete dropdown containing
			 * the available options.
			 */
			open: function() {
				var self = this;
		
				if (self.isLocked || self.isOpen || (self.settings.mode === 'multi' && self.isFull())) return;
				self.focus();
				self.isOpen = true;
				self.refreshState();
				self.$dropdown.css({visibility: 'hidden', display: 'block'});
				self.positionDropdown();
				self.$dropdown.css({visibility: 'visible'});
				self.trigger('dropdown_open', self.$dropdown);
			},
		
			/**
			 * Closes the autocomplete dropdown menu.
			 */
			close: function() {
				var self = this;
				var trigger = self.isOpen;
		
				if (self.settings.mode === 'single' && self.items.length) {
					self.hideInput();
		
					// Do not trigger blur while inside a blur event,
					// this fixes some weird tabbing behavior in FF and IE.
					// See #1164
					if (!self.isBlurring) {
						self.$control_input.blur(); // close keyboard on iOS
					}
				}
		
				self.isOpen = false;
				self.$dropdown.hide();
				self.setActiveOption(null);
				self.refreshState();
		
				if (trigger) self.trigger('dropdown_close', self.$dropdown);
			},
		
			/**
			 * Calculates and applies the appropriate
			 * position of the dropdown.
			 */
			positionDropdown: function() {
				var $control = this.$control;
				var offset = this.settings.dropdownParent === 'body' ? $control.offset() : $control.position();
				offset.top += $control.outerHeight(true);
		
				this.$dropdown.css({
					width : $control[0].getBoundingClientRect().width,
					top   : offset.top,
					left  : offset.left
				});
			},
		
			/**
			 * Resets / clears all selected items
			 * from the control.
			 *
			 * @param {boolean} silent
			 */
			clear: function(silent) {
				var self = this;
		
				if (!self.items.length) return;
				self.$control.children(':not(input)').remove();
				self.items = [];
				self.lastQuery = null;
				self.setCaret(0);
				self.setActiveItem(null);
				self.updatePlaceholder();
				self.updateOriginalInput({silent: silent});
				self.refreshState();
				self.showInput();
				self.trigger('clear');
			},
		
			/**
			 * A helper method for inserting an element
			 * at the current caret position.
			 *
			 * @param {object} $el
			 */
			insertAtCaret: function($el) {
				var caret = Math.min(this.caretPos, this.items.length);
				var el = $el[0];
				var target = this.buffer || this.$control[0];
		
				if (caret === 0) {
					target.insertBefore(el, target.firstChild);
				} else {
					target.insertBefore(el, target.childNodes[caret]);
				}
		
				this.setCaret(caret + 1);
			},
		
			/**
			 * Removes the current selected item(s).
			 *
			 * @param {object} e (optional)
			 * @returns {boolean}
			 */
			deleteSelection: function(e) {
				var i, n, direction, selection, values, caret, option_select, $option_select, $tail;
				var self = this;
		
				direction = (e && e.keyCode === KEY_BACKSPACE) ? -1 : 1;
				selection = getSelection(self.$control_input[0]);
		
				if (self.$activeOption && !self.settings.hideSelected) {
					option_select = self.getAdjacentOption(self.$activeOption, -1).attr('data-value');
				}
		
				// determine items that will be removed
				values = [];
		
				if (self.$activeItems.length) {
					$tail = self.$control.children('.active:' + (direction > 0 ? 'last' : 'first'));
					caret = self.$control.children(':not(input)').index($tail);
					if (direction > 0) { caret++; }
		
					for (i = 0, n = self.$activeItems.length; i < n; i++) {
						values.push($(self.$activeItems[i]).attr('data-value'));
					}
					if (e) {
						e.preventDefault();
						e.stopPropagation();
					}
				} else if ((self.isFocused || self.settings.mode === 'single') && self.items.length) {
					if (direction < 0 && selection.start === 0 && selection.length === 0) {
						values.push(self.items[self.caretPos - 1]);
					} else if (direction > 0 && selection.start === self.$control_input.val().length) {
						values.push(self.items[self.caretPos]);
					}
				}
		
				// allow the callback to abort
				if (!values.length || (typeof self.settings.onDelete === 'function' && self.settings.onDelete.apply(self, [values]) === false)) {
					return false;
				}
		
				// perform removal
				if (typeof caret !== 'undefined') {
					self.setCaret(caret);
				}
				while (values.length) {
					self.removeItem(values.pop());
				}
		
				self.showInput();
				self.positionDropdown();
				self.refreshOptions(true);
		
				// select previous option
				if (option_select) {
					$option_select = self.getOption(option_select);
					if ($option_select.length) {
						self.setActiveOption($option_select);
					}
				}
		
				return true;
			},
		
			/**
			 * Selects the previous / next item (depending
			 * on the `direction` argument).
			 *
			 * > 0 - right
			 * < 0 - left
			 *
			 * @param {int} direction
			 * @param {object} e (optional)
			 */
			advanceSelection: function(direction, e) {
				var tail, selection, idx, valueLength, cursorAtEdge, $tail;
				var self = this;
		
				if (direction === 0) return;
				if (self.rtl) direction *= -1;
		
				tail = direction > 0 ? 'last' : 'first';
				selection = getSelection(self.$control_input[0]);
		
				if (self.isFocused && !self.isInputHidden) {
					valueLength = self.$control_input.val().length;
					cursorAtEdge = direction < 0
						? selection.start === 0 && selection.length === 0
						: selection.start === valueLength;
		
					if (cursorAtEdge && !valueLength) {
						self.advanceCaret(direction, e);
					}
				} else {
					$tail = self.$control.children('.active:' + tail);
					if ($tail.length) {
						idx = self.$control.children(':not(input)').index($tail);
						self.setActiveItem(null);
						self.setCaret(direction > 0 ? idx + 1 : idx);
					}
				}
			},
		
			/**
			 * Moves the caret left / right.
			 *
			 * @param {int} direction
			 * @param {object} e (optional)
			 */
			advanceCaret: function(direction, e) {
				var self = this, fn, $adj;
		
				if (direction === 0) return;
		
				fn = direction > 0 ? 'next' : 'prev';
				if (self.isShiftDown) {
					$adj = self.$control_input[fn]();
					if ($adj.length) {
						self.hideInput();
						self.setActiveItem($adj);
						e && e.preventDefault();
					}
				} else {
					self.setCaret(self.caretPos + direction);
				}
			},
		
			/**
			 * Moves the caret to the specified index.
			 *
			 * @param {int} i
			 */
			setCaret: function(i) {
				var self = this;
		
				if (self.settings.mode === 'single') {
					i = self.items.length;
				} else {
					i = Math.max(0, Math.min(self.items.length, i));
				}
		
				if(!self.isPending) {
					// the input must be moved by leaving it in place and moving the
					// siblings, due to the fact that focus cannot be restored once lost
					// on mobile webkit devices
					var j, n, fn, $children, $child;
					$children = self.$control.children(':not(input)');
					for (j = 0, n = $children.length; j < n; j++) {
						$child = $($children[j]).detach();
						if (j <  i) {
							self.$control_input.before($child);
						} else {
							self.$control.append($child);
						}
					}
				}
		
				self.caretPos = i;
			},
		
			/**
			 * Disables user input on the control. Used while
			 * items are being asynchronously created.
			 */
			lock: function() {
				this.close();
				this.isLocked = true;
				this.refreshState();
			},
		
			/**
			 * Re-enables user input on the control.
			 */
			unlock: function() {
				this.isLocked = false;
				this.refreshState();
			},
		
			/**
			 * Disables user input on the control completely.
			 * While disabled, it cannot receive focus.
			 */
			disable: function() {
				var self = this;
				self.$input.prop('disabled', true);
				self.$control_input.prop('disabled', true).prop('tabindex', -1);
				self.isDisabled = true;
				self.lock();
			},
		
			/**
			 * Enables the control so that it can respond
			 * to focus and user input.
			 */
			enable: function() {
				var self = this;
				self.$input.prop('disabled', false);
				self.$control_input.prop('disabled', false).prop('tabindex', self.tabIndex);
				self.isDisabled = false;
				self.unlock();
			},
		
			/**
			 * Completely destroys the control and
			 * unbinds all event listeners so that it can
			 * be garbage collected.
			 */
			destroy: function() {
				var self = this;
				var eventNS = self.eventNS;
				var revertSettings = self.revertSettings;
		
				self.trigger('destroy');
				self.off();
				self.$wrapper.remove();
				self.$dropdown.remove();
		
				self.$input
					.html('')
					.append(revertSettings.$children)
					.removeAttr('tabindex')
					.removeClass('selectized')
					.attr({tabindex: revertSettings.tabindex})
					.show();
		
				self.$control_input.removeData('grow');
				self.$input.removeData('selectize');
		
				if (--Selectize.count == 0 && Selectize.$testInput) {
					Selectize.$testInput.remove();
					Selectize.$testInput = undefined;
				}
		
				$(window).off(eventNS);
				$(document).off(eventNS);
				$(document.body).off(eventNS);
		
				delete self.$input[0].selectize;
			},
		
			/**
			 * A helper method for rendering "item" and
			 * "option" templates, given the data.
			 *
			 * @param {string} templateName
			 * @param {object} data
			 * @returns {string}
			 */
			render: function(templateName, data) {
				var value, id, label;
				var html = '';
				var cache = false;
				var self = this;
				var regex_tag = /^[\t \r\n]*<([a-z][a-z0-9\-_]*(?:\:[a-z][a-z0-9\-_]*)?)/i;
		
				if (templateName === 'option' || templateName === 'item') {
					value = hash_key(data[self.settings.valueField]);
					cache = !!value;
				}
		
				// pull markup from cache if it exists
				if (cache) {
					if (!isset(self.renderCache[templateName])) {
						self.renderCache[templateName] = {};
					}
					if (self.renderCache[templateName].hasOwnProperty(value)) {
						return self.renderCache[templateName][value];
					}
				}
		
				// render markup
				html = $(self.settings.render[templateName].apply(this, [data, escape_html]));
		
				// add mandatory attributes
				if (templateName === 'option' || templateName === 'option_create') {
					if (!data[self.settings.disabledField]) {
						html.attr('data-selectable', '');
					}
				}
				else if (templateName === 'optgroup') {
					id = data[self.settings.optgroupValueField] || '';
					html.attr('data-group', id);
					if(data[self.settings.disabledField]) {
						html.attr('data-disabled', '');
					}
				}
				if (templateName === 'option' || templateName === 'item') {
					html.attr('data-value', value || '');
				}
		
				// update cache
				if (cache) {
					self.renderCache[templateName][value] = html[0];
				}
		
				return html[0];
			},
		
			/**
			 * Clears the render cache for a template. If
			 * no template is given, clears all render
			 * caches.
			 *
			 * @param {string} templateName
			 */
			clearCache: function(templateName) {
				var self = this;
				if (typeof templateName === 'undefined') {
					self.renderCache = {};
				} else {
					delete self.renderCache[templateName];
				}
			},
		
			/**
			 * Determines whether or not to display the
			 * create item prompt, given a user input.
			 *
			 * @param {string} input
			 * @return {boolean}
			 */
			canCreate: function(input) {
				var self = this;
				if (!self.settings.create) return false;
				var filter = self.settings.createFilter;
				return input.length
					&& (typeof filter !== 'function' || filter.apply(self, [input]))
					&& (typeof filter !== 'string' || new RegExp(filter).test(input))
					&& (!(filter instanceof RegExp) || filter.test(input));
			}
		
		});
		
		
		Selectize.count = 0;
		Selectize.defaults = {
			options: [],
			optgroups: [],
		
			plugins: [],
			delimiter: ',',
			splitOn: null, // regexp or string for splitting up values from a paste command
			persist: true,
			diacritics: true,
			create: false,
			createOnBlur: false,
			createFilter: null,
			highlight: true,
			openOnFocus: true,
			maxOptions: 1000,
			maxItems: null,
			hideSelected: null,
			addPrecedence: false,
			selectOnTab: false,
			preload: false,
			allowEmptyOption: false,
			closeAfterSelect: false,
		
			scrollDuration: 60,
			loadThrottle: 300,
			loadingClass: 'loading',
		
			dataAttr: 'data-data',
			optgroupField: 'optgroup',
			valueField: 'value',
			labelField: 'text',
			disabledField: 'disabled',
			optgroupLabelField: 'label',
			optgroupValueField: 'value',
			lockOptgroupOrder: false,
		
			sortField: '$order',
			searchField: ['text'],
			searchConjunction: 'and',
		
			mode: null,
			wrapperClass: 'selectize-control',
			inputClass: 'selectize-input',
			dropdownClass: 'selectize-dropdown',
			dropdownContentClass: 'selectize-dropdown-content',
		
			dropdownParent: null,
		
			copyClassesToDropdown: true,
		
			/*
			load                 : null, // function(query, callback) { ... }
			score                : null, // function(search) { ... }
			onInitialize         : null, // function() { ... }
			onChange             : null, // function(value) { ... }
			onItemAdd            : null, // function(value, $item) { ... }
			onItemRemove         : null, // function(value) { ... }
			onClear              : null, // function() { ... }
			onOptionAdd          : null, // function(value, data) { ... }
			onOptionRemove       : null, // function(value) { ... }
			onOptionClear        : null, // function() { ... }
			onOptionGroupAdd     : null, // function(id, data) { ... }
			onOptionGroupRemove  : null, // function(id) { ... }
			onOptionGroupClear   : null, // function() { ... }
			onDropdownOpen       : null, // function($dropdown) { ... }
			onDropdownClose      : null, // function($dropdown) { ... }
			onType               : null, // function(str) { ... }
			onDelete             : null, // function(values) { ... }
			*/
		
			render: {
				/*
				item: null,
				optgroup: null,
				optgroup_header: null,
				option: null,
				option_create: null
				*/
			}
		};
		
		
		$.fn.selectize = function(settings_user) {
			var defaults             = $.fn.selectize.defaults;
			var settings             = $.extend({}, defaults, settings_user);
			var attr_data            = settings.dataAttr;
			var field_label          = settings.labelField;
			var field_value          = settings.valueField;
			var field_disabled       = settings.disabledField;
			var field_optgroup       = settings.optgroupField;
			var field_optgroup_label = settings.optgroupLabelField;
			var field_optgroup_value = settings.optgroupValueField;
		
			/**
			 * Initializes selectize from a <input type="text"> element.
			 *
			 * @param {object} $input
			 * @param {object} settings_element
			 */
			var init_textbox = function($input, settings_element) {
				var i, n, values, option;
		
				var data_raw = $input.attr(attr_data);
		
				if (!data_raw) {
					var value = $.trim($input.val() || '');
					if (!settings.allowEmptyOption && !value.length) return;
					values = value.split(settings.delimiter);
					for (i = 0, n = values.length; i < n; i++) {
						option = {};
						option[field_label] = values[i];
						option[field_value] = values[i];
						settings_element.options.push(option);
					}
					settings_element.items = values;
				} else {
					settings_element.options = JSON.parse(data_raw);
					for (i = 0, n = settings_element.options.length; i < n; i++) {
						settings_element.items.push(settings_element.options[i][field_value]);
					}
				}
			};
		
			/**
			 * Initializes selectize from a <select> element.
			 *
			 * @param {object} $input
			 * @param {object} settings_element
			 */
			var init_select = function($input, settings_element) {
				var i, n, tagName, $children, order = 0;
				var options = settings_element.options;
				var optionsMap = {};
		
				var readData = function($el) {
					var data = attr_data && $el.attr(attr_data);
					if (typeof data === 'string' && data.length) {
						return JSON.parse(data);
					}
					return null;
				};
		
				var addOption = function($option, group) {
					$option = $($option);
		
					var value = hash_key($option.val());
					if (!value && !settings.allowEmptyOption) return;
		
					// if the option already exists, it's probably been
					// duplicated in another optgroup. in this case, push
					// the current group to the "optgroup" property on the
					// existing option so that it's rendered in both places.
					if (optionsMap.hasOwnProperty(value)) {
						if (group) {
							var arr = optionsMap[value][field_optgroup];
							if (!arr) {
								optionsMap[value][field_optgroup] = group;
							} else if (!$.isArray(arr)) {
								optionsMap[value][field_optgroup] = [arr, group];
							} else {
								arr.push(group);
							}
						}
						return;
					}
		
					var option             = readData($option) || {};
					option[field_label]    = option[field_label] || $option.text();
					option[field_value]    = option[field_value] || value;
					option[field_disabled] = option[field_disabled] || $option.prop('disabled');
					option[field_optgroup] = option[field_optgroup] || group;
		
					optionsMap[value] = option;
					options.push(option);
		
					if ($option.is(':selected')) {
						settings_element.items.push(value);
					}
				};
		
				var addGroup = function($optgroup) {
					var i, n, id, optgroup, $options;
		
					$optgroup = $($optgroup);
					id = $optgroup.attr('label');
		
					if (id) {
						optgroup = readData($optgroup) || {};
						optgroup[field_optgroup_label] = id;
						optgroup[field_optgroup_value] = id;
						optgroup[field_disabled] = $optgroup.prop('disabled');
						settings_element.optgroups.push(optgroup);
					}
		
					$options = $('option', $optgroup);
					for (i = 0, n = $options.length; i < n; i++) {
						addOption($options[i], id);
					}
				};
		
				settings_element.maxItems = $input.attr('multiple') ? null : 1;
		
				$children = $input.children();
				for (i = 0, n = $children.length; i < n; i++) {
					tagName = $children[i].tagName.toLowerCase();
					if (tagName === 'optgroup') {
						addGroup($children[i]);
					} else if (tagName === 'option') {
						addOption($children[i]);
					}
				}
			};
		
			return this.each(function() {
				if (this.selectize) return;
		
				var instance;
				var $input = $(this);
				var tag_name = this.tagName.toLowerCase();
				var placeholder = $input.attr('placeholder') || $input.attr('data-placeholder');
				if (!placeholder && !settings.allowEmptyOption) {
					placeholder = $input.children('option[value=""]').text();
				}
		
				var settings_element = {
					'placeholder' : placeholder,
					'options'     : [],
					'optgroups'   : [],
					'items'       : []
				};
		
				if (tag_name === 'select') {
					init_select($input, settings_element);
				} else {
					init_textbox($input, settings_element);
				}
		
				instance = new Selectize($input, $.extend(true, {}, defaults, settings_element, settings_user));
			});
		};
		
		$.fn.selectize.defaults = Selectize.defaults;
		$.fn.selectize.support = {
			validity: SUPPORTS_VALIDITY_API
		};
		
		
		Selectize.define('drag_drop', function(options) {
			if (!$.fn.sortable) throw new Error('The "drag_drop" plugin requires jQuery UI "sortable".');
			if (this.settings.mode !== 'multi') return;
			var self = this;
		
			self.lock = (function() {
				var original = self.lock;
				return function() {
					var sortable = self.$control.data('sortable');
					if (sortable) sortable.disable();
					return original.apply(self, arguments);
				};
			})();
		
			self.unlock = (function() {
				var original = self.unlock;
				return function() {
					var sortable = self.$control.data('sortable');
					if (sortable) sortable.enable();
					return original.apply(self, arguments);
				};
			})();
		
			self.setup = (function() {
				var original = self.setup;
				return function() {
					original.apply(this, arguments);
		
					var $control = self.$control.sortable({
						items: '[data-value]',
						forcePlaceholderSize: true,
						disabled: self.isLocked,
						start: function(e, ui) {
							ui.placeholder.css('width', ui.helper.css('width'));
							$control.css({overflow: 'visible'});
						},
						stop: function() {
							$control.css({overflow: 'hidden'});
							var active = self.$activeItems ? self.$activeItems.slice() : null;
							var values = [];
							$control.children('[data-value]').each(function() {
								values.push($(this).attr('data-value'));
							});
							self.setValue(values);
							self.setActiveItem(active);
						}
					});
				};
			})();
		
		});
		
		Selectize.define('dropdown_header', function(options) {
			var self = this;
		
			options = $.extend({
				title         : 'Untitled',
				headerClass   : 'selectize-dropdown-header',
				titleRowClass : 'selectize-dropdown-header-title',
				labelClass    : 'selectize-dropdown-header-label',
				closeClass    : 'selectize-dropdown-header-close',
		
				html: function(data) {
					return (
						'<div class="' + data.headerClass + '">' +
							'<div class="' + data.titleRowClass + '">' +
								'<span class="' + data.labelClass + '">' + data.title + '</span>' +
								'<a href="javascript:void(0)" class="' + data.closeClass + '">&times;</a>' +
							'</div>' +
						'</div>'
					);
				}
			}, options);
		
			self.setup = (function() {
				var original = self.setup;
				return function() {
					original.apply(self, arguments);
					self.$dropdown_header = $(options.html(options));
					self.$dropdown.prepend(self.$dropdown_header);
				};
			})();
		
		});
		
		Selectize.define('optgroup_columns', function(options) {
			var self = this;
		
			options = $.extend({
				equalizeWidth  : true,
				equalizeHeight : true
			}, options);
		
			this.getAdjacentOption = function($option, direction) {
				var $options = $option.closest('[data-group]').find('[data-selectable]');
				var index    = $options.index($option) + direction;
		
				return index >= 0 && index < $options.length ? $options.eq(index) : $();
			};
		
			this.onKeyDown = (function() {
				var original = self.onKeyDown;
				return function(e) {
					var index, $option, $options, $optgroup;
		
					if (this.isOpen && (e.keyCode === KEY_LEFT || e.keyCode === KEY_RIGHT)) {
						self.ignoreHover = true;
						$optgroup = this.$activeOption.closest('[data-group]');
						index = $optgroup.find('[data-selectable]').index(this.$activeOption);
		
						if(e.keyCode === KEY_LEFT) {
							$optgroup = $optgroup.prev('[data-group]');
						} else {
							$optgroup = $optgroup.next('[data-group]');
						}
		
						$options = $optgroup.find('[data-selectable]');
						$option  = $options.eq(Math.min($options.length - 1, index));
						if ($option.length) {
							this.setActiveOption($option);
						}
						return;
					}
		
					return original.apply(this, arguments);
				};
			})();
		
			var getScrollbarWidth = function() {
				var div;
				var width = getScrollbarWidth.width;
				var doc = document;
		
				if (typeof width === 'undefined') {
					div = doc.createElement('div');
					div.innerHTML = '<div style="width:50px;height:50px;position:absolute;left:-50px;top:-50px;overflow:auto;"><div style="width:1px;height:100px;"></div></div>';
					div = div.firstChild;
					doc.body.appendChild(div);
					width = getScrollbarWidth.width = div.offsetWidth - div.clientWidth;
					doc.body.removeChild(div);
				}
				return width;
			};
		
			var equalizeSizes = function() {
				var i, n, height_max, width, width_last, width_parent, $optgroups;
		
				$optgroups = $('[data-group]', self.$dropdown_content);
				n = $optgroups.length;
				if (!n || !self.$dropdown_content.width()) return;
		
				if (options.equalizeHeight) {
					height_max = 0;
					for (i = 0; i < n; i++) {
						height_max = Math.max(height_max, $optgroups.eq(i).height());
					}
					$optgroups.css({height: height_max});
				}
		
				if (options.equalizeWidth) {
					width_parent = self.$dropdown_content.innerWidth() - getScrollbarWidth();
					width = Math.round(width_parent / n);
					$optgroups.css({width: width});
					if (n > 1) {
						width_last = width_parent - width * (n - 1);
						$optgroups.eq(n - 1).css({width: width_last});
					}
				}
			};
		
			if (options.equalizeHeight || options.equalizeWidth) {
				hook.after(this, 'positionDropdown', equalizeSizes);
				hook.after(this, 'refreshOptions', equalizeSizes);
			}
		
		
		});
		
		Selectize.define('remove_button', function(options) {
			options = $.extend({
					label     : '&times;',
					title     : 'Remove',
					className : 'remove',
					append    : true
				}, options);
		
				var singleClose = function(thisRef, options) {
		
					options.className = 'remove-single';
		
					var self = thisRef;
					var html = '<a href="javascript:void(0)" class="' + options.className + '" tabindex="-1" title="' + escape_html(options.title) + '">' + options.label + '</a>';
		
					/**
					 * Appends an element as a child (with raw HTML).
					 *
					 * @param {string} html_container
					 * @param {string} html_element
					 * @return {string}
					 */
					var append = function(html_container, html_element) {
						return $('<span>').append(html_container)
							.append(html_element);
					};
		
					thisRef.setup = (function() {
						var original = self.setup;
						return function() {
							// override the item rendering method to add the button to each
							if (options.append) {
								var id = $(self.$input.context).attr('id');
								var selectizer = $('#'+id);
		
								var render_item = self.settings.render.item;
								self.settings.render.item = function(data) {
									return append(render_item.apply(thisRef, arguments), html);
								};
							}
		
							original.apply(thisRef, arguments);
		
							// add event listener
							thisRef.$control.on('click', '.' + options.className, function(e) {
								e.preventDefault();
								if (self.isLocked) return;
		
								self.clear();
							});
		
						};
					})();
				};
		
				var multiClose = function(thisRef, options) {
		
					var self = thisRef;
					var html = '<a href="javascript:void(0)" class="' + options.className + '" tabindex="-1" title="' + escape_html(options.title) + '">' + options.label + '</a>';
		
					/**
					 * Appends an element as a child (with raw HTML).
					 *
					 * @param {string} html_container
					 * @param {string} html_element
					 * @return {string}
					 */
					var append = function(html_container, html_element) {
						var pos = html_container.search(/(<\/[^>]+>\s*)$/);
						return html_container.substring(0, pos) + html_element + html_container.substring(pos);
					};
		
					thisRef.setup = (function() {
						var original = self.setup;
						return function() {
							// override the item rendering method to add the button to each
							if (options.append) {
								var render_item = self.settings.render.item;
								self.settings.render.item = function(data) {
									return append(render_item.apply(thisRef, arguments), html);
								};
							}
		
							original.apply(thisRef, arguments);
		
							// add event listener
							thisRef.$control.on('click', '.' + options.className, function(e) {
								e.preventDefault();
								if (self.isLocked) return;
		
								var $item = $(e.currentTarget).parent();
								self.setActiveItem($item);
								if (self.deleteSelection()) {
									self.setCaret(self.items.length);
								}
							});
		
						};
					})();
				};
		
				if (this.settings.mode === 'single') {
					singleClose(this, options);
					return;
				} else {
					multiClose(this, options);
				}
		});
		
		
		Selectize.define('restore_on_backspace', function(options) {
			var self = this;
		
			options.text = options.text || function(option) {
				return option[this.settings.labelField];
			};
		
			this.onKeyDown = (function() {
				var original = self.onKeyDown;
				return function(e) {
					var index, option;
					if (e.keyCode === KEY_BACKSPACE && this.$control_input.val() === '' && !this.$activeItems.length) {
						index = this.caretPos - 1;
						if (index >= 0 && index < this.items.length) {
							option = this.options[this.items[index]];
							if (this.deleteSelection(e)) {
								this.setTextboxValue(options.text.apply(this, [option]));
								this.refreshOptions(true);
							}
							e.preventDefault();
							return;
						}
					}
					return original.apply(this, arguments);
				};
			})();
		});
		
	
		return Selectize;
	}));

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * sifter.js
	 * Copyright (c) 2013 Brian Reavis & contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 * @author Brian Reavis <brian@thirdroute.com>
	 */
	
	(function(root, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory();
		} else {
			root.Sifter = factory();
		}
	}(this, function() {
	
		/**
		 * Textually searches arrays and hashes of objects
		 * by property (or multiple properties). Designed
		 * specifically for autocomplete.
		 *
		 * @constructor
		 * @param {array|object} items
		 * @param {object} items
		 */
		var Sifter = function(items, settings) {
			this.items = items;
			this.settings = settings || {diacritics: true};
		};
	
		/**
		 * Splits a search string into an array of individual
		 * regexps to be used to match results.
		 *
		 * @param {string} query
		 * @returns {array}
		 */
		Sifter.prototype.tokenize = function(query) {
			query = trim(String(query || '').toLowerCase());
			if (!query || !query.length) return [];
	
			var i, n, regex, letter;
			var tokens = [];
			var words = query.split(/ +/);
	
			for (i = 0, n = words.length; i < n; i++) {
				regex = escape_regex(words[i]);
				if (this.settings.diacritics) {
					for (letter in DIACRITICS) {
						if (DIACRITICS.hasOwnProperty(letter)) {
							regex = regex.replace(new RegExp(letter, 'g'), DIACRITICS[letter]);
						}
					}
				}
				tokens.push({
					string : words[i],
					regex  : new RegExp(regex, 'i')
				});
			}
	
			return tokens;
		};
	
		/**
		 * Iterates over arrays and hashes.
		 *
		 * ```
		 * this.iterator(this.items, function(item, id) {
		 *    // invoked for each item
		 * });
		 * ```
		 *
		 * @param {array|object} object
		 */
		Sifter.prototype.iterator = function(object, callback) {
			var iterator;
			if (is_array(object)) {
				iterator = Array.prototype.forEach || function(callback) {
					for (var i = 0, n = this.length; i < n; i++) {
						callback(this[i], i, this);
					}
				};
			} else {
				iterator = function(callback) {
					for (var key in this) {
						if (this.hasOwnProperty(key)) {
							callback(this[key], key, this);
						}
					}
				};
			}
	
			iterator.apply(object, [callback]);
		};
	
		/**
		 * Returns a function to be used to score individual results.
		 *
		 * Good matches will have a higher score than poor matches.
		 * If an item is not a match, 0 will be returned by the function.
		 *
		 * @param {object|string} search
		 * @param {object} options (optional)
		 * @returns {function}
		 */
		Sifter.prototype.getScoreFunction = function(search, options) {
			var self, fields, tokens, token_count, nesting;
	
			self        = this;
			search      = self.prepareSearch(search, options);
			tokens      = search.tokens;
			fields      = search.options.fields;
			token_count = tokens.length;
			nesting     = search.options.nesting;
	
			/**
			 * Calculates how close of a match the
			 * given value is against a search token.
			 *
			 * @param {mixed} value
			 * @param {object} token
			 * @return {number}
			 */
			var scoreValue = function(value, token) {
				var score, pos;
	
				if (!value) return 0;
				value = String(value || '');
				pos = value.search(token.regex);
				if (pos === -1) return 0;
				score = token.string.length / value.length;
				if (pos === 0) score += 0.5;
				return score;
			};
	
			/**
			 * Calculates the score of an object
			 * against the search query.
			 *
			 * @param {object} token
			 * @param {object} data
			 * @return {number}
			 */
			var scoreObject = (function() {
				var field_count = fields.length;
				if (!field_count) {
					return function() { return 0; };
				}
				if (field_count === 1) {
					return function(token, data) {
						return scoreValue(getattr(data, fields[0], nesting), token);
					};
				}
				return function(token, data) {
					for (var i = 0, sum = 0; i < field_count; i++) {
						sum += scoreValue(getattr(data, fields[i], nesting), token);
					}
					return sum / field_count;
				};
			})();
	
			if (!token_count) {
				return function() { return 0; };
			}
			if (token_count === 1) {
				return function(data) {
					return scoreObject(tokens[0], data);
				};
			}
	
			if (search.options.conjunction === 'and') {
				return function(data) {
					var score;
					for (var i = 0, sum = 0; i < token_count; i++) {
						score = scoreObject(tokens[i], data);
						if (score <= 0) return 0;
						sum += score;
					}
					return sum / token_count;
				};
			} else {
				return function(data) {
					for (var i = 0, sum = 0; i < token_count; i++) {
						sum += scoreObject(tokens[i], data);
					}
					return sum / token_count;
				};
			}
		};
	
		/**
		 * Returns a function that can be used to compare two
		 * results, for sorting purposes. If no sorting should
		 * be performed, `null` will be returned.
		 *
		 * @param {string|object} search
		 * @param {object} options
		 * @return function(a,b)
		 */
		Sifter.prototype.getSortFunction = function(search, options) {
			var i, n, self, field, fields, fields_count, multiplier, multipliers, get_field, implicit_score, sort;
	
			self   = this;
			search = self.prepareSearch(search, options);
			sort   = (!search.query && options.sort_empty) || options.sort;
	
			/**
			 * Fetches the specified sort field value
			 * from a search result item.
			 *
			 * @param  {string} name
			 * @param  {object} result
			 * @return {mixed}
			 */
			get_field = function(name, result) {
				if (name === '$score') return result.score;
				return getattr(self.items[result.id], name, options.nesting);
			};
	
			// parse options
			fields = [];
			if (sort) {
				for (i = 0, n = sort.length; i < n; i++) {
					if (search.query || sort[i].field !== '$score') {
						fields.push(sort[i]);
					}
				}
			}
	
			// the "$score" field is implied to be the primary
			// sort field, unless it's manually specified
			if (search.query) {
				implicit_score = true;
				for (i = 0, n = fields.length; i < n; i++) {
					if (fields[i].field === '$score') {
						implicit_score = false;
						break;
					}
				}
				if (implicit_score) {
					fields.unshift({field: '$score', direction: 'desc'});
				}
			} else {
				for (i = 0, n = fields.length; i < n; i++) {
					if (fields[i].field === '$score') {
						fields.splice(i, 1);
						break;
					}
				}
			}
	
			multipliers = [];
			for (i = 0, n = fields.length; i < n; i++) {
				multipliers.push(fields[i].direction === 'desc' ? -1 : 1);
			}
	
			// build function
			fields_count = fields.length;
			if (!fields_count) {
				return null;
			} else if (fields_count === 1) {
				field = fields[0].field;
				multiplier = multipliers[0];
				return function(a, b) {
					return multiplier * cmp(
						get_field(field, a),
						get_field(field, b)
					);
				};
			} else {
				return function(a, b) {
					var i, result, a_value, b_value, field;
					for (i = 0; i < fields_count; i++) {
						field = fields[i].field;
						result = multipliers[i] * cmp(
							get_field(field, a),
							get_field(field, b)
						);
						if (result) return result;
					}
					return 0;
				};
			}
		};
	
		/**
		 * Parses a search query and returns an object
		 * with tokens and fields ready to be populated
		 * with results.
		 *
		 * @param {string} query
		 * @param {object} options
		 * @returns {object}
		 */
		Sifter.prototype.prepareSearch = function(query, options) {
			if (typeof query === 'object') return query;
	
			options = extend({}, options);
	
			var option_fields     = options.fields;
			var option_sort       = options.sort;
			var option_sort_empty = options.sort_empty;
	
			if (option_fields && !is_array(option_fields)) options.fields = [option_fields];
			if (option_sort && !is_array(option_sort)) options.sort = [option_sort];
			if (option_sort_empty && !is_array(option_sort_empty)) options.sort_empty = [option_sort_empty];
	
			return {
				options : options,
				query   : String(query || '').toLowerCase(),
				tokens  : this.tokenize(query),
				total   : 0,
				items   : []
			};
		};
	
		/**
		 * Searches through all items and returns a sorted array of matches.
		 *
		 * The `options` parameter can contain:
		 *
		 *   - fields {string|array}
		 *   - sort {array}
		 *   - score {function}
		 *   - filter {bool}
		 *   - limit {integer}
		 *
		 * Returns an object containing:
		 *
		 *   - options {object}
		 *   - query {string}
		 *   - tokens {array}
		 *   - total {int}
		 *   - items {array}
		 *
		 * @param {string} query
		 * @param {object} options
		 * @returns {object}
		 */
		Sifter.prototype.search = function(query, options) {
			var self = this, value, score, search, calculateScore;
			var fn_sort;
			var fn_score;
	
			search  = this.prepareSearch(query, options);
			options = search.options;
			query   = search.query;
	
			// generate result scoring function
			fn_score = options.score || self.getScoreFunction(search);
	
			// perform search and sort
			if (query.length) {
				self.iterator(self.items, function(item, id) {
					score = fn_score(item);
					if (options.filter === false || score > 0) {
						search.items.push({'score': score, 'id': id});
					}
				});
			} else {
				self.iterator(self.items, function(item, id) {
					search.items.push({'score': 1, 'id': id});
				});
			}
	
			fn_sort = self.getSortFunction(search, options);
			if (fn_sort) search.items.sort(fn_sort);
	
			// apply limits
			search.total = search.items.length;
			if (typeof options.limit === 'number') {
				search.items = search.items.slice(0, options.limit);
			}
	
			return search;
		};
	
		// utilities
		// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	
		var cmp = function(a, b) {
			if (typeof a === 'number' && typeof b === 'number') {
				return a > b ? 1 : (a < b ? -1 : 0);
			}
			a = asciifold(String(a || ''));
			b = asciifold(String(b || ''));
			if (a > b) return 1;
			if (b > a) return -1;
			return 0;
		};
	
		var extend = function(a, b) {
			var i, n, k, object;
			for (i = 1, n = arguments.length; i < n; i++) {
				object = arguments[i];
				if (!object) continue;
				for (k in object) {
					if (object.hasOwnProperty(k)) {
						a[k] = object[k];
					}
				}
			}
			return a;
		};
	
		/**
		 * A property getter resolving dot-notation
		 * @param  {Object}  obj     The root object to fetch property on
		 * @param  {String}  name    The optionally dotted property name to fetch
		 * @param  {Boolean} nesting Handle nesting or not
		 * @return {Object}          The resolved property value
		 */
		var getattr = function(obj, name, nesting) {
		    if (!obj || !name) return;
		    if (!nesting) return obj[name];
		    var names = name.split(".");
		    while(names.length && (obj = obj[names.shift()]));
		    return obj;
		};
	
		var trim = function(str) {
			return (str + '').replace(/^\s+|\s+$|/g, '');
		};
	
		var escape_regex = function(str) {
			return (str + '').replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
		};
	
		var is_array = Array.isArray || (typeof $ !== 'undefined' && $.isArray) || function(object) {
			return Object.prototype.toString.call(object) === '[object Array]';
		};
	
		var DIACRITICS = {
			'a': '[aḀḁĂăÂâǍǎȺⱥȦȧẠạÄäÀàÁáĀāÃãÅåąĄÃąĄ]',
			'b': '[b␢βΒB฿𐌁ᛒ]',
			'c': '[cĆćĈĉČčĊċC̄c̄ÇçḈḉȻȼƇƈɕᴄＣｃ]',
			'd': '[dĎďḊḋḐḑḌḍḒḓḎḏĐđD̦d̦ƉɖƊɗƋƌᵭᶁᶑȡᴅＤｄð]',
			'e': '[eÉéÈèÊêḘḙĚěĔĕẼẽḚḛẺẻĖėËëĒēȨȩĘęᶒɆɇȄȅẾếỀềỄễỂểḜḝḖḗḔḕȆȇẸẹỆệⱸᴇＥｅɘǝƏƐε]',
			'f': '[fƑƒḞḟ]',
			'g': '[gɢ₲ǤǥĜĝĞğĢģƓɠĠġ]',
			'h': '[hĤĥĦħḨḩẖẖḤḥḢḣɦʰǶƕ]',
			'i': '[iÍíÌìĬĭÎîǏǐÏïḮḯĨĩĮįĪīỈỉȈȉȊȋỊịḬḭƗɨɨ̆ᵻᶖİiIıɪＩｉ]',
			'j': '[jȷĴĵɈɉʝɟʲ]',
			'k': '[kƘƙꝀꝁḰḱǨǩḲḳḴḵκϰ₭]',
			'l': '[lŁłĽľĻļĹĺḶḷḸḹḼḽḺḻĿŀȽƚⱠⱡⱢɫɬᶅɭȴʟＬｌ]',
			'n': '[nŃńǸǹŇňÑñṄṅŅņṆṇṊṋṈṉN̈n̈ƝɲȠƞᵰᶇɳȵɴＮｎŊŋ]',
			'o': '[oØøÖöÓóÒòÔôǑǒŐőŎŏȮȯỌọƟɵƠơỎỏŌōÕõǪǫȌȍՕօ]',
			'p': '[pṔṕṖṗⱣᵽƤƥᵱ]',
			'q': '[qꝖꝗʠɊɋꝘꝙq̃]',
			'r': '[rŔŕɌɍŘřŖŗṘṙȐȑȒȓṚṛⱤɽ]',
			's': '[sŚśṠṡṢṣꞨꞩŜŝŠšŞşȘșS̈s̈]',
			't': '[tŤťṪṫŢţṬṭƮʈȚțṰṱṮṯƬƭ]',
			'u': '[uŬŭɄʉỤụÜüÚúÙùÛûǓǔŰűŬŭƯưỦủŪūŨũŲųȔȕ∪]',
			'v': '[vṼṽṾṿƲʋꝞꝟⱱʋ]',
			'w': '[wẂẃẀẁŴŵẄẅẆẇẈẉ]',
			'x': '[xẌẍẊẋχ]',
			'y': '[yÝýỲỳŶŷŸÿỸỹẎẏỴỵɎɏƳƴ]',
			'z': '[zŹźẐẑŽžŻżẒẓẔẕƵƶ]'
		};
	
		var asciifold = (function() {
			var i, n, k, chunk;
			var foreignletters = '';
			var lookup = {};
			for (k in DIACRITICS) {
				if (DIACRITICS.hasOwnProperty(k)) {
					chunk = DIACRITICS[k].substring(2, DIACRITICS[k].length - 1);
					foreignletters += chunk;
					for (i = 0, n = chunk.length; i < n; i++) {
						lookup[chunk.charAt(i)] = k;
					}
				}
			}
			var regexp = new RegExp('[' +  foreignletters + ']', 'g');
			return function(str) {
				return str.replace(regexp, function(foreignletter) {
					return lookup[foreignletter];
				}).toLowerCase();
			};
		})();
	
	
		// export
		// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	
		return Sifter;
	}));
	


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process, module) {(function(root) {
	  var SQLParser = function() {
	    function require(path){ return require[path]; }
	    require['./lexer'] = new function() {
	  var exports = this;
	  // Generated by CoffeeScript 1.8.0
	(function() {
	  var Lexer;
	
	  Lexer = (function() {
	    var BOOLEAN, DBLSTRING, LITERAL, MATH, MATH_MULTI, NUMBER, PARAMETER, SEPARATOR, SQL_CONDITIONALS, SQL_FUNCTIONS, SQL_OPERATORS, SQL_SORT_ORDERS, STAR, STRING, SUB_SELECT_OP, SUB_SELECT_UNARY_OP, WHITESPACE;
	
	    function Lexer(sql, opts) {
	      var bytesConsumed, i;
	      if (opts == null) {
	        opts = {};
	      }
	      this.sql = sql;
	      this.preserveWhitespace = opts.preserveWhitespace || false;
	      this.tokens = [];
	      this.currentLine = 1;
	      i = 0;
	      while (this.chunk = sql.slice(i)) {
	        bytesConsumed = this.keywordToken() || this.starToken() || this.booleanToken() || this.functionToken() || this.windowExtension() || this.sortOrderToken() || this.seperatorToken() || this.operatorToken() || this.mathToken() || this.dotToken() || this.conditionalToken() || this.subSelectOpToken() || this.subSelectUnaryOpToken() || this.numberToken() || this.stringToken() || this.parameterToken() || this.parensToken() || this.whitespaceToken() || this.literalToken();
	        if (bytesConsumed < 1) {
	          throw new Error("NOTHING CONSUMED: Stopped at - '" + (this.chunk.slice(0, 30)) + "'");
	        }
	        i += bytesConsumed;
	      }
	      this.token('EOF', '');
	      this.postProcess();
	    }
	
	    Lexer.prototype.postProcess = function() {
	      var i, next_token, token, _i, _len, _ref, _results;
	      _ref = this.tokens;
	      _results = [];
	      for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
	        token = _ref[i];
	        if (token[0] === 'STAR') {
	          next_token = this.tokens[i + 1];
	          if (!(next_token[0] === 'SEPARATOR' || next_token[0] === 'FROM')) {
	            _results.push(token[0] = 'MATH_MULTI');
	          } else {
	            _results.push(void 0);
	          }
	        } else {
	          _results.push(void 0);
	        }
	      }
	      return _results;
	    };
	
	    Lexer.prototype.token = function(name, value) {
	      return this.tokens.push([name, value, this.currentLine]);
	    };
	
	    Lexer.prototype.tokenizeFromRegex = function(name, regex, part, lengthPart, output) {
	      var match, partMatch;
	      if (part == null) {
	        part = 0;
	      }
	      if (lengthPart == null) {
	        lengthPart = part;
	      }
	      if (output == null) {
	        output = true;
	      }
	      if (!(match = regex.exec(this.chunk))) {
	        return 0;
	      }
	      partMatch = match[part];
	      if (output) {
	        this.token(name, partMatch);
	      }
	      return match[lengthPart].length;
	    };
	
	    Lexer.prototype.tokenizeFromWord = function(name, word) {
	      var match, matcher;
	      if (word == null) {
	        word = name;
	      }
	      word = this.regexEscape(word);
	      matcher = /^\w+$/.test(word) ? new RegExp("^(" + word + ")\\b", 'ig') : new RegExp("^(" + word + ")", 'ig');
	      match = matcher.exec(this.chunk);
	      if (!match) {
	        return 0;
	      }
	      this.token(name, match[1]);
	      return match[1].length;
	    };
	
	    Lexer.prototype.tokenizeFromList = function(name, list) {
	      var entry, ret, _i, _len;
	      ret = 0;
	      for (_i = 0, _len = list.length; _i < _len; _i++) {
	        entry = list[_i];
	        ret = this.tokenizeFromWord(name, entry);
	        if (ret > 0) {
	          break;
	        }
	      }
	      return ret;
	    };
	
	    Lexer.prototype.keywordToken = function() {
	      return this.tokenizeFromWord('SELECT') || this.tokenizeFromWord('DISTINCT') || this.tokenizeFromWord('FROM') || this.tokenizeFromWord('WHERE') || this.tokenizeFromWord('GROUP') || this.tokenizeFromWord('ORDER') || this.tokenizeFromWord('BY') || this.tokenizeFromWord('HAVING') || this.tokenizeFromWord('LIMIT') || this.tokenizeFromWord('JOIN') || this.tokenizeFromWord('LEFT') || this.tokenizeFromWord('RIGHT') || this.tokenizeFromWord('INNER') || this.tokenizeFromWord('OUTER') || this.tokenizeFromWord('ON') || this.tokenizeFromWord('AS') || this.tokenizeFromWord('UNION') || this.tokenizeFromWord('ALL') || this.tokenizeFromWord('LIMIT') || this.tokenizeFromWord('OFFSET') || this.tokenizeFromWord('FETCH') || this.tokenizeFromWord('ROW') || this.tokenizeFromWord('ROWS') || this.tokenizeFromWord('ONLY') || this.tokenizeFromWord('NEXT') || this.tokenizeFromWord('FIRST');
	    };
	
	    Lexer.prototype.dotToken = function() {
	      return this.tokenizeFromWord('DOT', '.');
	    };
	
	    Lexer.prototype.operatorToken = function() {
	      return this.tokenizeFromList('OPERATOR', SQL_OPERATORS);
	    };
	
	    Lexer.prototype.mathToken = function() {
	      return this.tokenizeFromList('MATH', MATH) || this.tokenizeFromList('MATH_MULTI', MATH_MULTI);
	    };
	
	    Lexer.prototype.conditionalToken = function() {
	      return this.tokenizeFromList('CONDITIONAL', SQL_CONDITIONALS);
	    };
	
	    Lexer.prototype.subSelectOpToken = function() {
	      return this.tokenizeFromList('SUB_SELECT_OP', SUB_SELECT_OP);
	    };
	
	    Lexer.prototype.subSelectUnaryOpToken = function() {
	      return this.tokenizeFromList('SUB_SELECT_UNARY_OP', SUB_SELECT_UNARY_OP);
	    };
	
	    Lexer.prototype.functionToken = function() {
	      return this.tokenizeFromList('FUNCTION', SQL_FUNCTIONS);
	    };
	
	    Lexer.prototype.sortOrderToken = function() {
	      return this.tokenizeFromList('DIRECTION', SQL_SORT_ORDERS);
	    };
	
	    Lexer.prototype.booleanToken = function() {
	      return this.tokenizeFromList('BOOLEAN', BOOLEAN);
	    };
	
	    Lexer.prototype.starToken = function() {
	      return this.tokenizeFromRegex('STAR', STAR);
	    };
	
	    Lexer.prototype.seperatorToken = function() {
	      return this.tokenizeFromRegex('SEPARATOR', SEPARATOR);
	    };
	
	    Lexer.prototype.literalToken = function() {
	      return this.tokenizeFromRegex('LITERAL', LITERAL, 1, 0);
	    };
	
	    Lexer.prototype.numberToken = function() {
	      return this.tokenizeFromRegex('NUMBER', NUMBER);
	    };
	
	    Lexer.prototype.parameterToken = function() {
	      return this.tokenizeFromRegex('PARAMETER', PARAMETER);
	    };
	
	    Lexer.prototype.stringToken = function() {
	      return this.tokenizeFromRegex('STRING', STRING, 1, 0) || this.tokenizeFromRegex('DBLSTRING', DBLSTRING, 1, 0);
	    };
	
	    Lexer.prototype.parensToken = function() {
	      return this.tokenizeFromRegex('LEFT_PAREN', /^\(/) || this.tokenizeFromRegex('RIGHT_PAREN', /^\)/);
	    };
	
	    Lexer.prototype.windowExtension = function() {
	      var match;
	      match = /^\.(win):(length|time)/i.exec(this.chunk);
	      if (!match) {
	        return 0;
	      }
	      this.token('WINDOW', match[1]);
	      this.token('WINDOW_FUNCTION', match[2]);
	      return match[0].length;
	    };
	
	    Lexer.prototype.whitespaceToken = function() {
	      var match, newlines, partMatch;
	      if (!(match = WHITESPACE.exec(this.chunk))) {
	        return 0;
	      }
	      partMatch = match[0];
	      newlines = partMatch.replace(/[^\n]/, '').length;
	      this.currentLine += newlines;
	      if (this.preserveWhitespace) {
	        this.token(name, partMatch);
	      }
	      return partMatch.length;
	    };
	
	    Lexer.prototype.regexEscape = function(str) {
	      return str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
	    };
	
	    SQL_FUNCTIONS = ['AVG', 'COUNT', 'MIN', 'MAX', 'SUM'];
	
	    SQL_SORT_ORDERS = ['ASC', 'DESC'];
	
	    SQL_OPERATORS = ['=', '!=', '>=', '>', '<=', '<>', '<', 'LIKE', 'IS NOT', 'IS'];
	
	    SUB_SELECT_OP = ['IN', 'NOT IN', 'ANY', 'ALL', 'SOME'];
	
	    SUB_SELECT_UNARY_OP = ['EXISTS'];
	
	    SQL_CONDITIONALS = ['AND', 'OR'];
	
	    BOOLEAN = ['TRUE', 'FALSE', 'NULL'];
	
	    MATH = ['+', '-'];
	
	    MATH_MULTI = ['/', '*'];
	
	    STAR = /^\*/;
	
	    SEPARATOR = /^,/;
	
	    WHITESPACE = /^[ \n\r]+/;
	
	    LITERAL = /^`?([a-z_][a-z0-9_]{0,})`?/i;
	
	    PARAMETER = /^\$[0-9]+/;
	
	    NUMBER = /^[0-9]+(\.[0-9]+)?/;
	
	    STRING = /^'([^\\']*(?:\\.[^\\']*)*)'/;
	
	    DBLSTRING = /^"([^\\"]*(?:\\.[^\\"]*)*)"/;
	
	    return Lexer;
	
	  })();
	
	  exports.tokenize = function(sql, opts) {
	    return (new Lexer(sql, opts)).tokens;
	  };
	
	}).call(this);
	
	};require['./compiled_parser'] = new function() {
	  var exports = this;
	  /* parser generated by jison 0.4.15 */
	/*
	  Returns a Parser object of the following structure:
	
	  Parser: {
	    yy: {}
	  }
	
	  Parser.prototype: {
	    yy: {},
	    trace: function(),
	    symbols_: {associative list: name ==> number},
	    terminals_: {associative list: number ==> name},
	    productions_: [...],
	    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
	    table: [...],
	    defaultActions: {...},
	    parseError: function(str, hash),
	    parse: function(input),
	
	    lexer: {
	        EOF: 1,
	        parseError: function(str, hash),
	        setInput: function(input),
	        input: function(),
	        unput: function(str),
	        more: function(),
	        less: function(n),
	        pastInput: function(),
	        upcomingInput: function(),
	        showPosition: function(),
	        test_match: function(regex_match_array, rule_index),
	        next: function(),
	        lex: function(),
	        begin: function(condition),
	        popState: function(),
	        _currentRules: function(),
	        topState: function(),
	        pushState: function(condition),
	
	        options: {
	            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
	            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
	            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
	        },
	
	        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
	        rules: [...],
	        conditions: {associative list: name ==> set},
	    }
	  }
	
	
	  token location info (@$, _$, etc.): {
	    first_line: n,
	    last_line: n,
	    first_column: n,
	    last_column: n,
	    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
	  }
	
	
	  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
	    text:        (matched text)
	    token:       (the produced terminal token, if any)
	    line:        (yylineno)
	  }
	  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
	    loc:         (yylloc)
	    expected:    (string describing the set of expected tokens)
	    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
	  }
	*/
	var parser = (function(){
	var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,8],$V1=[5,26],$V2=[1,14],$V3=[1,13],$V4=[5,26,31,42],$V5=[1,17],$V6=[5,26,31,42,45,62],$V7=[1,27],$V8=[1,29],$V9=[1,38],$Va=[1,42],$Vb=[1,43],$Vc=[1,39],$Vd=[1,40],$Ve=[1,37],$Vf=[1,41],$Vg=[1,25],$Vh=[5,26,31],$Vi=[5,26,31,42,45],$Vj=[1,55],$Vk=[18,43],$Vl=[1,58],$Vm=[1,59],$Vn=[1,60],$Vo=[1,61],$Vp=[5,18,23,26,31,34,37,38,41,42,43,45,62,64,65,66,67,68],$Vq=[5,18,23,26,31,34,37,38,41,42,43,44,45,51,62,64,65,66,67,68,69],$Vr=[1,66],$Vs=[2,80],$Vt=[1,80],$Vu=[1,81],$Vv=[1,96],$Vw=[5,26,31,42,43,44],$Vx=[1,104],$Vy=[5,26,31,42,43,45,64],$Vz=[5,26,31,41,42,45,62],$VA=[1,107],$VB=[1,108],$VC=[1,109],$VD=[5,26,31,34,35,37,38,41,42,45,62],$VE=[5,26,31,34,37,38,41,42,45,62],$VF=[5,26,31,42,56,58];
	var parser = {trace: function trace() { },
	yy: {},
	symbols_: {"error":2,"Root":3,"Query":4,"EOF":5,"SelectQuery":6,"Unions":7,"SelectWithLimitQuery":8,"BasicSelectQuery":9,"Select":10,"OrderClause":11,"GroupClause":12,"LimitClause":13,"SelectClause":14,"WhereClause":15,"SELECT":16,"Fields":17,"FROM":18,"Table":19,"DISTINCT":20,"Joins":21,"Literal":22,"AS":23,"LEFT_PAREN":24,"List":25,"RIGHT_PAREN":26,"WINDOW":27,"WINDOW_FUNCTION":28,"Number":29,"Union":30,"UNION":31,"ALL":32,"Join":33,"JOIN":34,"ON":35,"Expression":36,"LEFT":37,"RIGHT":38,"INNER":39,"OUTER":40,"WHERE":41,"LIMIT":42,"SEPARATOR":43,"OFFSET":44,"ORDER":45,"BY":46,"OrderArgs":47,"OffsetClause":48,"OrderArg":49,"Value":50,"DIRECTION":51,"OffsetRows":52,"FetchClause":53,"ROW":54,"ROWS":55,"FETCH":56,"FIRST":57,"ONLY":58,"NEXT":59,"GroupBasicClause":60,"HavingClause":61,"GROUP":62,"ArgumentList":63,"HAVING":64,"MATH":65,"MATH_MULTI":66,"OPERATOR":67,"CONDITIONAL":68,"SUB_SELECT_OP":69,"SubSelectExpression":70,"SUB_SELECT_UNARY_OP":71,"String":72,"Function":73,"UserFunction":74,"Boolean":75,"Parameter":76,"NUMBER":77,"BOOLEAN":78,"PARAMETER":79,"STRING":80,"DBLSTRING":81,"LITERAL":82,"DOT":83,"FUNCTION":84,"AggregateArgumentList":85,"Field":86,"STAR":87,"$accept":0,"$end":1},
	terminals_: {2:"error",5:"EOF",16:"SELECT",18:"FROM",20:"DISTINCT",23:"AS",24:"LEFT_PAREN",26:"RIGHT_PAREN",27:"WINDOW",28:"WINDOW_FUNCTION",31:"UNION",32:"ALL",34:"JOIN",35:"ON",37:"LEFT",38:"RIGHT",39:"INNER",40:"OUTER",41:"WHERE",42:"LIMIT",43:"SEPARATOR",44:"OFFSET",45:"ORDER",46:"BY",51:"DIRECTION",54:"ROW",55:"ROWS",56:"FETCH",57:"FIRST",58:"ONLY",59:"NEXT",62:"GROUP",64:"HAVING",65:"MATH",66:"MATH_MULTI",67:"OPERATOR",68:"CONDITIONAL",69:"SUB_SELECT_OP",71:"SUB_SELECT_UNARY_OP",77:"NUMBER",78:"BOOLEAN",79:"PARAMETER",80:"STRING",81:"DBLSTRING",82:"LITERAL",83:"DOT",84:"FUNCTION",87:"STAR"},
	productions_: [0,[3,2],[4,1],[4,2],[6,1],[6,1],[9,1],[9,2],[9,2],[9,3],[8,2],[10,1],[10,2],[14,4],[14,5],[14,5],[14,6],[19,1],[19,2],[19,3],[19,3],[19,3],[19,4],[19,6],[7,1],[7,2],[30,2],[30,3],[21,1],[21,2],[33,4],[33,5],[33,5],[33,6],[33,6],[33,6],[33,6],[15,2],[13,2],[13,4],[13,4],[11,3],[11,4],[47,1],[47,3],[49,1],[49,2],[48,2],[48,3],[52,2],[52,2],[53,4],[53,4],[12,1],[12,2],[60,3],[61,2],[36,3],[36,3],[36,3],[36,3],[36,3],[36,5],[36,3],[36,2],[36,1],[70,3],[50,1],[50,1],[50,1],[50,1],[50,1],[50,1],[50,1],[25,1],[29,1],[75,1],[76,1],[72,1],[72,1],[22,1],[22,3],[73,4],[74,4],[85,1],[85,2],[63,1],[63,3],[17,1],[17,3],[86,1],[86,1],[86,3]],
	performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
	/* this == yyval */
	
	var $0 = $$.length - 1;
	switch (yystate) {
	case 1:
	return this.$ = $$[$0-1];
	break;
	case 2: case 4: case 5: case 6: case 11: case 53: case 65: case 67: case 68: case 69: case 70: case 71: case 72: case 73:
	this.$ = $$[$0];
	break;
	case 3:
	this.$ = (function () {
	        $$[$0-1].unions = $$[$0];
	        return $$[$0-1];
	      }());
	break;
	case 7:
	this.$ = (function () {
	        $$[$0-1].order = $$[$0];
	        return $$[$0-1];
	      }());
	break;
	case 8:
	this.$ = (function () {
	        $$[$0-1].group = $$[$0];
	        return $$[$0-1];
	      }());
	break;
	case 9:
	this.$ = (function () {
	        $$[$0-2].group = $$[$0-1];
	        $$[$0-2].order = $$[$0];
	        return $$[$0-2];
	      }());
	break;
	case 10:
	this.$ = (function () {
	        $$[$0-1].limit = $$[$0];
	        return $$[$0-1];
	      }());
	break;
	case 12:
	this.$ = (function () {
	        $$[$0-1].where = $$[$0];
	        return $$[$0-1];
	      }());
	break;
	case 13:
	this.$ = new yy.Select($$[$0-2], $$[$0], false);
	break;
	case 14:
	this.$ = new yy.Select($$[$0-2], $$[$0], true);
	break;
	case 15:
	this.$ = new yy.Select($$[$0-3], $$[$0-1], false, $$[$0]);
	break;
	case 16:
	this.$ = new yy.Select($$[$0-3], $$[$0-1], true, $$[$0]);
	break;
	case 17:
	this.$ = new yy.Table($$[$0]);
	break;
	case 18:
	this.$ = new yy.Table($$[$0-1], $$[$0]);
	break;
	case 19:
	this.$ = new yy.Table($$[$0-2], $$[$0]);
	break;
	case 20: case 49: case 50: case 51: case 52: case 57:
	this.$ = $$[$0-1];
	break;
	case 21: case 66:
	this.$ = new yy.SubSelect($$[$0-1]);
	break;
	case 22:
	this.$ = new yy.SubSelect($$[$0-2], $$[$0]);
	break;
	case 23:
	this.$ = new yy.Table($$[$0-5], null, $$[$0-4], $$[$0-3], $$[$0-1]);
	break;
	case 24: case 28: case 43: case 86: case 88:
	this.$ = [$$[$0]];
	break;
	case 25:
	this.$ = $$[$0-1].concat($$[$01]);
	break;
	case 26:
	this.$ = new yy.Union($$[$0]);
	break;
	case 27:
	this.$ = new yy.Union($$[$0], true);
	break;
	case 29:
	this.$ = $$[$0-1].concat($$[$0]);
	break;
	case 30:
	this.$ = new yy.Join($$[$0-2], $$[$0]);
	break;
	case 31:
	this.$ = new yy.Join($$[$0-2], $$[$0], 'LEFT');
	break;
	case 32:
	this.$ = new yy.Join($$[$0-2], $$[$0], 'RIGHT');
	break;
	case 33:
	this.$ = new yy.Join($$[$0-2], $$[$0], 'LEFT', 'INNER');
	break;
	case 34:
	this.$ = new yy.Join($$[$0-2], $$[$0], 'RIGHT', 'INNER');
	break;
	case 35:
	this.$ = new yy.Join($$[$0-2], $$[$0], 'LEFT', 'OUTER');
	break;
	case 36:
	this.$ = new yy.Join($$[$0-2], $$[$0], 'RIGHT', 'OUTER');
	break;
	case 37:
	this.$ = new yy.Where($$[$0]);
	break;
	case 38:
	this.$ = new yy.Limit($$[$0]);
	break;
	case 39:
	this.$ = new yy.Limit($$[$0], $$[$0-2]);
	break;
	case 40:
	this.$ = new yy.Limit($$[$0-2], $$[$0]);
	break;
	case 41:
	this.$ = new yy.Order($$[$0]);
	break;
	case 42:
	this.$ = new yy.Order($$[$0-1], $$[$0]);
	break;
	case 44: case 87: case 89:
	this.$ = $$[$0-2].concat($$[$0]);
	break;
	case 45:
	this.$ = new yy.OrderArgument($$[$0], 'ASC');
	break;
	case 46:
	this.$ = new yy.OrderArgument($$[$0-1], $$[$0]);
	break;
	case 47:
	this.$ = new yy.Offset($$[$0]);
	break;
	case 48:
	this.$ = new yy.Offset($$[$0-1], $$[$0]);
	break;
	case 54:
	this.$ = (function () {
	        $$[$0-1].having = $$[$0];
	        return $$[$0-1];
	      }());
	break;
	case 55:
	this.$ = new yy.Group($$[$0]);
	break;
	case 56:
	this.$ = new yy.Having($$[$0]);
	break;
	case 58: case 59: case 60: case 61: case 63:
	this.$ = new yy.Op($$[$0-1], $$[$0-2], $$[$0]);
	break;
	case 62:
	this.$ = new yy.Op($$[$0-3], $$[$0-4], $$[$0-1]);
	break;
	case 64:
	this.$ = new yy.UnaryOp($$[$0-1], $$[$0]);
	break;
	case 74:
	this.$ = new yy.ListValue($$[$0]);
	break;
	case 75:
	this.$ = new yy.NumberValue($$[$0]);
	break;
	case 76:
	this.$ = new yy.BooleanValue($$[$0]);
	break;
	case 77:
	this.$ = new yy.ParameterValue($$[$0]);
	break;
	case 78:
	this.$ = new yy.StringValue($$[$0], "'");
	break;
	case 79:
	this.$ = new yy.StringValue($$[$0], '"');
	break;
	case 80:
	this.$ = new yy.LiteralValue($$[$0]);
	break;
	case 81:
	this.$ = new yy.LiteralValue($$[$0-2], $$[$0]);
	break;
	case 82:
	this.$ = new yy.FunctionValue($$[$0-3], $$[$0-1]);
	break;
	case 83:
	this.$ = new yy.FunctionValue($$[$0-3], $$[$0-1], true);
	break;
	case 84:
	this.$ = new yy.ArgumentListValue($$[$0]);
	break;
	case 85:
	this.$ = new yy.ArgumentListValue($$[$0], true);
	break;
	case 90:
	this.$ = new yy.Star();
	break;
	case 91:
	this.$ = new yy.Field($$[$0]);
	break;
	case 92:
	this.$ = new yy.Field($$[$0-2], $$[$0]);
	break;
	}
	},
	table: [{3:1,4:2,6:3,8:4,9:5,10:6,14:7,16:$V0},{1:[3]},{5:[1,9]},o($V1,[2,2],{7:10,13:11,30:12,31:$V2,42:$V3}),o($V4,[2,4]),o($V4,[2,5]),o($V4,[2,6],{11:15,12:16,60:18,45:$V5,62:[1,19]}),o($V6,[2,11],{15:20,41:[1,21]}),{17:22,20:[1,23],22:30,24:$V7,29:31,36:26,50:28,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf,86:24,87:$Vg},{1:[2,1]},o($V1,[2,3],{30:44,31:$V2}),o($V4,[2,10]),o($Vh,[2,24]),{29:45,77:$V9},{6:46,8:4,9:5,10:6,14:7,16:$V0,32:[1,47]},o($V4,[2,7]),o($V4,[2,8],{11:48,45:$V5}),{46:[1,49]},o($Vi,[2,53],{61:50,64:[1,51]}),{46:[1,52]},o($V6,[2,12]),{22:30,24:$V7,29:31,36:53,50:28,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},{18:[1,54],43:$Vj},{17:56,22:30,24:$V7,29:31,36:26,50:28,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf,86:24,87:$Vg},o($Vk,[2,88]),o($Vk,[2,90]),o($Vk,[2,91],{23:[1,57],65:$Vl,66:$Vm,67:$Vn,68:$Vo}),{22:30,24:$V7,29:31,36:62,50:28,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},o($Vp,[2,65],{69:[1,63]}),{24:[1,65],70:64},o($Vq,[2,67],{83:$Vr}),o($Vq,[2,68]),o($Vq,[2,69]),o($Vq,[2,70]),o($Vq,[2,71]),o($Vq,[2,72]),o($Vq,[2,73]),o([5,18,23,26,31,34,37,38,41,42,43,44,45,51,62,64,65,66,67,68,69,83],$Vs,{24:[1,67]}),o([5,18,23,26,31,34,37,38,41,42,43,44,45,51,54,55,62,64,65,66,67,68,69],[2,75]),o($Vq,[2,78]),o($Vq,[2,79]),{24:[1,68]},o($Vq,[2,76]),o($Vq,[2,77]),o($Vh,[2,25]),o($V4,[2,38],{43:[1,69],44:[1,70]}),o($Vh,[2,26],{13:11,42:$V3}),{6:71,8:4,9:5,10:6,14:7,16:$V0},o($V4,[2,9]),{22:30,29:31,47:72,49:73,50:74,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},o($Vi,[2,54]),{22:30,24:$V7,29:31,36:75,50:28,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},{22:30,24:$V7,29:31,36:77,50:28,63:76,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},o($V6,[2,37],{65:$Vl,66:$Vm,67:$Vn,68:$Vo}),{19:78,22:79,24:$Vt,82:$Vu},{22:30,24:$V7,29:31,36:26,50:28,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf,86:82,87:$Vg},{18:[1,83],43:$Vj},{22:84,82:$Vu},{22:30,24:$V7,29:31,36:85,50:28,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},{22:30,24:$V7,29:31,36:86,50:28,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},{22:30,24:$V7,29:31,36:87,50:28,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},{22:30,24:$V7,29:31,36:88,50:28,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},{26:[1,89],65:$Vl,66:$Vm,67:$Vn,68:$Vo},{24:[1,90],70:91},o($Vp,[2,64]),{4:92,6:3,8:4,9:5,10:6,14:7,16:$V0},{82:[1,93]},{20:$Vv,22:30,24:$V7,29:31,36:77,50:28,63:95,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf,85:94},{20:$Vv,22:30,24:$V7,29:31,36:77,50:28,63:95,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf,85:97},{29:98,77:$V9},{29:99,77:$V9},o($Vh,[2,27],{13:11,42:$V3}),o($V4,[2,41],{48:100,43:[1,101],44:[1,102]}),o($Vw,[2,43]),o($Vw,[2,45],{51:[1,103]}),o($Vi,[2,56],{65:$Vl,66:$Vm,67:$Vn,68:$Vo}),o([5,26,31,42,45,64],[2,55],{43:$Vx}),o($Vy,[2,86],{65:$Vl,66:$Vm,67:$Vn,68:$Vo}),o($Vz,[2,13],{21:105,33:106,34:$VA,37:$VB,38:$VC}),o($VD,[2,17],{22:110,23:[1,111],27:[1,112],82:$Vu,83:$Vr}),{4:114,6:3,8:4,9:5,10:6,14:7,16:$V0,22:30,24:$V7,25:113,29:31,36:77,50:28,63:115,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},o([5,18,23,26,27,31,34,35,37,38,41,42,43,45,62,82,83],$Vs),o($Vk,[2,89]),{19:116,22:79,24:$Vt,82:$Vu},o($Vk,[2,92],{83:$Vr}),o([5,18,23,26,31,34,37,38,41,42,43,45,62,64,65,67,68],[2,58],{66:$Vm}),o($Vp,[2,59]),o([5,18,23,26,31,34,37,38,41,42,43,45,62,64,67,68],[2,60],{65:$Vl,66:$Vm}),o([5,18,23,26,31,34,37,38,41,42,43,45,62,64,68],[2,61],{65:$Vl,66:$Vm,67:$Vn}),o($Vp,[2,57]),{4:92,6:3,8:4,9:5,10:6,14:7,16:$V0,22:30,24:$V7,25:117,29:31,36:77,50:28,63:115,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},o($Vp,[2,63]),{26:[1,118]},o([5,18,23,26,27,31,34,35,37,38,41,42,43,44,45,51,62,64,65,66,67,68,69,82,83],[2,81]),{26:[1,119]},{26:[2,84],43:$Vx},{22:30,24:$V7,29:31,36:77,50:28,63:120,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},{26:[1,121]},o($V4,[2,39]),o($V4,[2,40]),o($V4,[2,42]),{22:30,29:31,49:122,50:74,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},{29:124,52:123,77:$V9},o($Vw,[2,46]),{22:30,29:31,50:125,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},o($Vz,[2,15],{33:126,34:$VA,37:$VB,38:$VC}),o($VE,[2,28]),{19:127,22:79,24:$Vt,82:$Vu},{34:[1,128],39:[1,129],40:[1,130]},{34:[1,131],39:[1,132],40:[1,133]},o($VD,[2,18],{83:$Vr}),{22:134,82:$Vu},{28:[1,135]},{26:[1,136]},{26:[1,137]},{26:[2,74],43:$Vx},o($Vz,[2,14],{33:106,21:138,34:$VA,37:$VB,38:$VC}),{26:[1,139]},o($Vp,[2,66]),o($Vq,[2,83]),{26:[2,85],43:$Vx},o($Vq,[2,82]),o($Vw,[2,44]),o($V4,[2,47],{53:140,56:[1,141]}),{54:[1,142],55:[1,143]},o($Vy,[2,87]),o($VE,[2,29]),{35:[1,144]},{19:145,22:79,24:$Vt,82:$Vu},{34:[1,146]},{34:[1,147]},{19:148,22:79,24:$Vt,82:$Vu},{34:[1,149]},{34:[1,150]},o($VD,[2,19],{83:$Vr}),{24:[1,151]},o($VD,[2,20]),o($VD,[2,21],{22:152,82:$Vu}),o($Vz,[2,16],{33:126,34:$VA,37:$VB,38:$VC}),o($Vp,[2,62]),o($V4,[2,48]),{57:[1,153],59:[1,154]},o($VF,[2,49]),o($VF,[2,50]),{22:30,24:$V7,29:31,36:155,50:28,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},{35:[1,156]},{19:157,22:79,24:$Vt,82:$Vu},{19:158,22:79,24:$Vt,82:$Vu},{35:[1,159]},{19:160,22:79,24:$Vt,82:$Vu},{19:161,22:79,24:$Vt,82:$Vu},{29:162,77:$V9},o($VD,[2,22],{83:$Vr}),{29:124,52:163,77:$V9},{29:124,52:164,77:$V9},o($VE,[2,30],{65:$Vl,66:$Vm,67:$Vn,68:$Vo}),{22:30,24:$V7,29:31,36:165,50:28,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},{35:[1,166]},{35:[1,167]},{22:30,24:$V7,29:31,36:168,50:28,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},{35:[1,169]},{35:[1,170]},{26:[1,171]},{58:[1,172]},{58:[1,173]},o($VE,[2,31],{65:$Vl,66:$Vm,67:$Vn,68:$Vo}),{22:30,24:$V7,29:31,36:174,50:28,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},{22:30,24:$V7,29:31,36:175,50:28,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},o($VE,[2,32],{65:$Vl,66:$Vm,67:$Vn,68:$Vo}),{22:30,24:$V7,29:31,36:176,50:28,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},{22:30,24:$V7,29:31,36:177,50:28,71:$V8,72:32,73:33,74:34,75:35,76:36,77:$V9,78:$Va,79:$Vb,80:$Vc,81:$Vd,82:$Ve,84:$Vf},o($VD,[2,23]),o($V4,[2,51]),o($V4,[2,52]),o($VE,[2,33],{65:$Vl,66:$Vm,67:$Vn,68:$Vo}),o($VE,[2,35],{65:$Vl,66:$Vm,67:$Vn,68:$Vo}),o($VE,[2,34],{65:$Vl,66:$Vm,67:$Vn,68:$Vo}),o($VE,[2,36],{65:$Vl,66:$Vm,67:$Vn,68:$Vo})],
	defaultActions: {9:[2,1]},
	parseError: function parseError(str, hash) {
	    if (hash.recoverable) {
	        this.trace(str);
	    } else {
	        throw new Error(str);
	    }
	},
	parse: function parse(input) {
	    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
	    var args = lstack.slice.call(arguments, 1);
	    var lexer = Object.create(this.lexer);
	    var sharedState = { yy: {} };
	    for (var k in this.yy) {
	        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
	            sharedState.yy[k] = this.yy[k];
	        }
	    }
	    lexer.setInput(input, sharedState.yy);
	    sharedState.yy.lexer = lexer;
	    sharedState.yy.parser = this;
	    if (typeof lexer.yylloc == 'undefined') {
	        lexer.yylloc = {};
	    }
	    var yyloc = lexer.yylloc;
	    lstack.push(yyloc);
	    var ranges = lexer.options && lexer.options.ranges;
	    if (typeof sharedState.yy.parseError === 'function') {
	        this.parseError = sharedState.yy.parseError;
	    } else {
	        this.parseError = Object.getPrototypeOf(this).parseError;
	    }
	    function popStack(n) {
	        stack.length = stack.length - 2 * n;
	        vstack.length = vstack.length - n;
	        lstack.length = lstack.length - n;
	    }
	    _token_stack:
	        function lex() {
	            var token;
	            token = lexer.lex() || EOF;
	            if (typeof token !== 'number') {
	                token = self.symbols_[token] || token;
	            }
	            return token;
	        }
	    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
	    while (true) {
	        state = stack[stack.length - 1];
	        if (this.defaultActions[state]) {
	            action = this.defaultActions[state];
	        } else {
	            if (symbol === null || typeof symbol == 'undefined') {
	                symbol = lex();
	            }
	            action = table[state] && table[state][symbol];
	        }
	                    if (typeof action === 'undefined' || !action.length || !action[0]) {
	                var errStr = '';
	                expected = [];
	                for (p in table[state]) {
	                    if (this.terminals_[p] && p > TERROR) {
	                        expected.push('\'' + this.terminals_[p] + '\'');
	                    }
	                }
	                if (lexer.showPosition) {
	                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
	                } else {
	                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
	                }
	                this.parseError(errStr, {
	                    text: lexer.match,
	                    token: this.terminals_[symbol] || symbol,
	                    line: lexer.yylineno,
	                    loc: yyloc,
	                    expected: expected
	                });
	            }
	        if (action[0] instanceof Array && action.length > 1) {
	            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
	        }
	        switch (action[0]) {
	        case 1:
	            stack.push(symbol);
	            vstack.push(lexer.yytext);
	            lstack.push(lexer.yylloc);
	            stack.push(action[1]);
	            symbol = null;
	            if (!preErrorSymbol) {
	                yyleng = lexer.yyleng;
	                yytext = lexer.yytext;
	                yylineno = lexer.yylineno;
	                yyloc = lexer.yylloc;
	                if (recovering > 0) {
	                    recovering--;
	                }
	            } else {
	                symbol = preErrorSymbol;
	                preErrorSymbol = null;
	            }
	            break;
	        case 2:
	            len = this.productions_[action[1]][1];
	            yyval.$ = vstack[vstack.length - len];
	            yyval._$ = {
	                first_line: lstack[lstack.length - (len || 1)].first_line,
	                last_line: lstack[lstack.length - 1].last_line,
	                first_column: lstack[lstack.length - (len || 1)].first_column,
	                last_column: lstack[lstack.length - 1].last_column
	            };
	            if (ranges) {
	                yyval._$.range = [
	                    lstack[lstack.length - (len || 1)].range[0],
	                    lstack[lstack.length - 1].range[1]
	                ];
	            }
	            r = this.performAction.apply(yyval, [
	                yytext,
	                yyleng,
	                yylineno,
	                sharedState.yy,
	                action[1],
	                vstack,
	                lstack
	            ].concat(args));
	            if (typeof r !== 'undefined') {
	                return r;
	            }
	            if (len) {
	                stack = stack.slice(0, -1 * len * 2);
	                vstack = vstack.slice(0, -1 * len);
	                lstack = lstack.slice(0, -1 * len);
	            }
	            stack.push(this.productions_[action[1]][0]);
	            vstack.push(yyval.$);
	            lstack.push(yyval._$);
	            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
	            stack.push(newState);
	            break;
	        case 3:
	            return true;
	        }
	    }
	    return true;
	}};
	
	function Parser () {
	  this.yy = {};
	}
	Parser.prototype = parser;parser.Parser = Parser;
	return new Parser;
	})();
	
	
	if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
	exports.parser = parser;
	exports.Parser = parser.Parser;
	exports.parse = function () { return parser.parse.apply(parser, arguments); };
	exports.main = function commonjsMain(args) {
	    if (!args[1]) {
	        console.log('Usage: '+args[0]+' FILE');
	        process.exit(1);
	    }
	    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
	    return exports.parser.parse(source);
	};
	if (typeof module !== 'undefined' && require.main === module) {
	  exports.main(process.argv.slice(1));
	}
	}
	};require['./nodes'] = new function() {
	  var exports = this;
	  // Generated by CoffeeScript 1.8.0
	(function() {
	  var ArgumentListValue, Field, FunctionValue, Group, Having, Join, Limit, ListValue, LiteralValue, Offset, Op, Order, OrderArgument, ParameterValue, Select, Star, StringValue, SubSelect, Table, UnaryOp, Union, Where, indent;
	
	  indent = function(str) {
	    var line;
	    return ((function() {
	      var _i, _len, _ref, _results;
	      _ref = str.split("\n");
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        line = _ref[_i];
	        _results.push("  " + line);
	      }
	      return _results;
	    })()).join("\n");
	  };
	
	  exports.Select = Select = (function() {
	    function Select(fields, source, distinct, joins, unions) {
	      this.fields = fields;
	      this.source = source;
	      this.distinct = distinct != null ? distinct : false;
	      this.joins = joins != null ? joins : [];
	      this.unions = unions != null ? unions : [];
	      this.order = null;
	      this.group = null;
	      this.where = null;
	      this.limit = null;
	    }
	
	    Select.prototype.toString = function() {
	      var join, ret, union, _i, _j, _len, _len1, _ref, _ref1;
	      ret = ["SELECT " + (this.fields.join(', '))];
	      ret.push(indent("FROM " + this.source));
	      _ref = this.joins;
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        join = _ref[_i];
	        ret.push(indent(join.toString()));
	      }
	      if (this.where) {
	        ret.push(indent(this.where.toString()));
	      }
	      if (this.group) {
	        ret.push(indent(this.group.toString()));
	      }
	      if (this.order) {
	        ret.push(indent(this.order.toString()));
	      }
	      if (this.limit) {
	        ret.push(indent(this.limit.toString()));
	      }
	      _ref1 = this.unions;
	      for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
	        union = _ref1[_j];
	        ret.push(union.toString());
	      }
	      return ret.join("\n");
	    };
	
	    return Select;
	
	  })();
	
	  exports.SubSelect = SubSelect = (function() {
	    function SubSelect(select, name) {
	      this.select = select;
	      this.name = name != null ? name : null;
	      null;
	    }
	
	    SubSelect.prototype.toString = function() {
	      var ret;
	      ret = [];
	      ret.push('(');
	      ret.push(indent(this.select.toString()));
	      ret.push(this.name ? ") " + (this.name.toString()) : ")");
	      return ret.join("\n");
	    };
	
	    return SubSelect;
	
	  })();
	
	  exports.Join = Join = (function() {
	    function Join(right, conditions, side, mode) {
	      this.right = right;
	      this.conditions = conditions != null ? conditions : null;
	      this.side = side != null ? side : null;
	      this.mode = mode != null ? mode : null;
	      null;
	    }
	
	    Join.prototype.toString = function() {
	      var ret;
	      ret = '';
	      if (this.side != null) {
	        ret += "" + this.side + " ";
	      }
	      if (this.mode != null) {
	        ret += "" + this.mode + " ";
	      }
	      return ret + ("JOIN " + this.right + "\n") + indent("ON " + this.conditions);
	    };
	
	    return Join;
	
	  })();
	
	  exports.Union = Union = (function() {
	    function Union(query, all) {
	      this.query = query;
	      this.all = all != null ? all : false;
	      null;
	    }
	
	    Union.prototype.toString = function() {
	      var all;
	      all = this.all ? ' ALL' : '';
	      return "UNION" + all + "\n" + (this.query.toString());
	    };
	
	    return Union;
	
	  })();
	
	  exports.LiteralValue = LiteralValue = (function() {
	    function LiteralValue(value, value2) {
	      this.value = value;
	      this.value2 = value2 != null ? value2 : null;
	      if (this.value2) {
	        this.nested = true;
	        this.values = this.value.values;
	        this.values.push(value2);
	      } else {
	        this.nested = false;
	        this.values = [this.value];
	      }
	    }
	
	    LiteralValue.prototype.toString = function() {
	      return "`" + (this.values.join('.')) + "`";
	    };
	
	    return LiteralValue;
	
	  })();
	
	  exports.StringValue = StringValue = (function() {
	    function StringValue(value, quoteType) {
	      this.value = value;
	      this.quoteType = quoteType != null ? quoteType : "''";
	      null;
	    }
	
	    StringValue.prototype.toString = function() {
	      return "" + this.quoteType + this.value + this.quoteType;
	    };
	
	    return StringValue;
	
	  })();
	
	  exports.NumberValue = LiteralValue = (function() {
	    function LiteralValue(value) {
	      this.value = Number(value);
	    }
	
	    LiteralValue.prototype.toString = function() {
	      return this.value.toString();
	    };
	
	    return LiteralValue;
	
	  })();
	
	  exports.ListValue = ListValue = (function() {
	    function ListValue(value) {
	      this.value = value;
	    }
	
	    ListValue.prototype.toString = function() {
	      return "(" + (this.value.join(', ')) + ")";
	    };
	
	    return ListValue;
	
	  })();
	
	  exports.ParameterValue = ParameterValue = (function() {
	    function ParameterValue(value) {
	      this.value = value;
	      this.index = parseInt(value.substr(1), 10) - 1;
	    }
	
	    ParameterValue.prototype.toString = function() {
	      return "" + this.value;
	    };
	
	    return ParameterValue;
	
	  })();
	
	  exports.ArgumentListValue = ArgumentListValue = (function() {
	    function ArgumentListValue(value, distinct) {
	      this.value = value;
	      this.distinct = distinct != null ? distinct : false;
	      null;
	    }
	
	    ArgumentListValue.prototype.toString = function() {
	      if (this.distinct) {
	        return "DISTINCT " + (this.value.join(', '));
	      } else {
	        return "" + (this.value.join(', '));
	      }
	    };
	
	    return ArgumentListValue;
	
	  })();
	
	  exports.BooleanValue = LiteralValue = (function() {
	    function LiteralValue(value) {
	      this.value = (function() {
	        switch (value.toLowerCase()) {
	          case 'true':
	            return true;
	          case 'false':
	            return false;
	          default:
	            return null;
	        }
	      })();
	    }
	
	    LiteralValue.prototype.toString = function() {
	      if (this.value != null) {
	        return this.value.toString().toUpperCase();
	      } else {
	        return 'NULL';
	      }
	    };
	
	    return LiteralValue;
	
	  })();
	
	  exports.FunctionValue = FunctionValue = (function() {
	    function FunctionValue(name, _arguments, udf) {
	      this.name = name;
	      this["arguments"] = _arguments != null ? _arguments : null;
	      this.udf = udf != null ? udf : false;
	      null;
	    }
	
	    FunctionValue.prototype.toString = function() {
	      if (this["arguments"]) {
	        return "" + (this.name.toUpperCase()) + "(" + (this["arguments"].toString()) + ")";
	      } else {
	        return "" + (this.name.toUpperCase()) + "()";
	      }
	    };
	
	    return FunctionValue;
	
	  })();
	
	  exports.Order = Order = (function() {
	    function Order(orderings, offset) {
	      this.orderings = orderings;
	      this.offset = offset;
	    }
	
	    Order.prototype.toString = function() {
	      return ("ORDER BY " + (this.orderings.join(', '))) + (this.offset ? "\n" + this.offset.toString() : "");
	    };
	
	    return Order;
	
	  })();
	
	  exports.OrderArgument = OrderArgument = (function() {
	    function OrderArgument(value, direction) {
	      this.value = value;
	      this.direction = direction != null ? direction : 'ASC';
	      null;
	    }
	
	    OrderArgument.prototype.toString = function() {
	      return "" + this.value + " " + this.direction;
	    };
	
	    return OrderArgument;
	
	  })();
	
	  exports.Offset = Offset = (function() {
	    function Offset(row_count, limit) {
	      this.row_count = row_count;
	      this.limit = limit;
	      null;
	    }
	
	    Offset.prototype.toString = function() {
	      return ("OFFSET " + this.row_count + " ROWS") + (this.limit ? "\nFETCH NEXT " + this.limit + " ROWS ONLY" : "");
	    };
	
	    return Offset;
	
	  })();
	
	  exports.Limit = Limit = (function() {
	    function Limit(value, offset) {
	      this.value = value;
	      this.offset = offset;
	      null;
	    }
	
	    Limit.prototype.toString = function() {
	      return ("LIMIT " + this.value) + (this.offset ? "\nOFFSET " + this.offset : "");
	    };
	
	    return Limit;
	
	  })();
	
	  exports.Table = Table = (function() {
	    function Table(name, alias, win, winFn, winArg) {
	      this.name = name;
	      this.alias = alias != null ? alias : null;
	      this.win = win != null ? win : null;
	      this.winFn = winFn != null ? winFn : null;
	      this.winArg = winArg != null ? winArg : null;
	      null;
	    }
	
	    Table.prototype.toString = function() {
	      if (this.win) {
	        return "" + this.name + "." + this.win + ":" + this.winFn + "(" + this.winArg + ")";
	      } else if (this.alias) {
	        return "" + this.name + " AS " + this.alias;
	      } else {
	        return this.name.toString();
	      }
	    };
	
	    return Table;
	
	  })();
	
	  exports.Group = Group = (function() {
	    function Group(fields) {
	      this.fields = fields;
	      this.having = null;
	    }
	
	    Group.prototype.toString = function() {
	      var ret;
	      ret = ["GROUP BY " + (this.fields.join(', '))];
	      if (this.having) {
	        ret.push(this.having.toString());
	      }
	      return ret.join("\n");
	    };
	
	    return Group;
	
	  })();
	
	  exports.Where = Where = (function() {
	    function Where(conditions) {
	      this.conditions = conditions;
	      null;
	    }
	
	    Where.prototype.toString = function() {
	      return "WHERE " + this.conditions;
	    };
	
	    return Where;
	
	  })();
	
	  exports.Having = Having = (function() {
	    function Having(conditions) {
	      this.conditions = conditions;
	      null;
	    }
	
	    Having.prototype.toString = function() {
	      return "HAVING " + this.conditions;
	    };
	
	    return Having;
	
	  })();
	
	  exports.Op = Op = (function() {
	    function Op(operation, left, right) {
	      this.operation = operation;
	      this.left = left;
	      this.right = right;
	      null;
	    }
	
	    Op.prototype.toString = function() {
	      return "(" + this.left + " " + (this.operation.toUpperCase()) + " " + this.right + ")";
	    };
	
	    return Op;
	
	  })();
	
	  exports.UnaryOp = UnaryOp = (function() {
	    function UnaryOp(operator, operand) {
	      this.operator = operator;
	      this.operand = operand;
	      null;
	    }
	
	    UnaryOp.prototype.toString = function() {
	      return "(" + (this.operator.toUpperCase()) + " " + this.operand + ")";
	    };
	
	    return UnaryOp;
	
	  })();
	
	  exports.Field = Field = (function() {
	    function Field(field, name) {
	      this.field = field;
	      this.name = name != null ? name : null;
	      null;
	    }
	
	    Field.prototype.toString = function() {
	      if (this.name) {
	        return "" + this.field + " AS " + this.name;
	      } else {
	        return this.field.toString();
	      }
	    };
	
	    return Field;
	
	  })();
	
	  exports.Star = Star = (function() {
	    function Star() {
	      null;
	    }
	
	    Star.prototype.toString = function() {
	      return '*';
	    };
	
	    Star.prototype.star = true;
	
	    return Star;
	
	  })();
	
	}).call(this);
	
	};require['./parser'] = new function() {
	  var exports = this;
	  // Generated by CoffeeScript 1.8.0
	(function() {
	  var buildParser;
	
	  buildParser = function() {
	    var parser;
	    parser = require('./compiled_parser').parser;
	    parser.lexer = {
	      lex: function() {
	        var tag, _ref;
	        _ref = this.tokens[this.pos++] || [''], tag = _ref[0], this.yytext = _ref[1], this.yylineno = _ref[2];
	        return tag;
	      },
	      setInput: function(tokens) {
	        this.tokens = tokens;
	        return this.pos = 0;
	      },
	      upcomingInput: function() {
	        return "";
	      }
	    };
	    parser.yy = require('./nodes');
	    return parser;
	  };
	
	  exports.parser = buildParser();
	
	  exports.parse = function(str) {
	    return buildParser().parse(str);
	  };
	
	}).call(this);
	
	};require['./sql_parser'] = new function() {
	  var exports = this;
	  // Generated by CoffeeScript 1.8.0
	(function() {
	  exports.lexer = require('./lexer');
	
	  exports.parser = require('./parser');
	
	  exports.nodes = require('./nodes');
	
	  exports.parse = function(sql) {
	    return exports.parser.parse(exports.lexer.tokenize(sql));
	  };
	
	}).call(this);
	
	};
	    return require['./sql_parser']
	  }();
	
	  if(true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return SQLParser }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else { root.SQLParser = SQLParser }
	}(this));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(366), __webpack_require__(169)(module)))

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.3.10
	 * (c) 2010-2014 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular, undefined) {'use strict';
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/*
	 * HTML Parser By Misko Hevery (misko@hevery.com)
	 * based on:  HTML Parser By John Resig (ejohn.org)
	 * Original code by Erik Arvidsson, Mozilla Public License
	 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
	 *
	 * // Use like so:
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string, however, since our parser is more strict than a typical browser
	 *   parser, it's possible that some obscure input, which would be recognized as valid HTML by a
	 *   browser, won't make it through the sanitizer. The input may also contain SVG markup.
	 *   The whitelist is configured using the functions `aHrefSanitizationWhitelist` and
	 *   `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider `$compileProvider`}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getInnerHtml()).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	function $SanitizeProvider() {
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    return function(html) {
	      if (typeof arguments[1] != 'undefined') {
	        arguments[1].version = 'taSanitize';
	      }
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, angular.noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// Regular Expressions for parsing tags and attributes
	var START_TAG_REGEXP =
	       /^<((?:[a-zA-Z])[\w:-]*)((?:\s+[\w:-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)\s*(>?)/,
	  END_TAG_REGEXP = /^<\/\s*([\w:-]+)[^>]*>/,
	  ATTR_REGEXP = /([\w:-]+)(?:\s*=\s*(?:(?:"((?:[^"])*)")|(?:'((?:[^'])*)')|([^>\s]+)))?/g,
	  BEGIN_TAG_REGEXP = /^</,
	  BEGING_END_TAGE_REGEXP = /^<\//,
	  COMMENT_REGEXP = /<!--(.*?)-->/g,
	  SINGLE_COMMENT_REGEXP = /(^<!--.*?-->)/,
	  DOCTYPE_REGEXP = /<!DOCTYPE([^>]*?)>/i,
	  CDATA_REGEXP = /<!\[CDATA\[(.*?)]]>/g,
	  SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	  // Match everything outside of normal chars and " (quote character)
	  NON_ALPHANUMERIC_REGEXP = /([^\#-~| |!])/g,
	  WHITE_SPACE_REGEXP = /^(\s+)/;
	
	
	// Good source of info about elements and attributes
	// http://dev.w3.org/html5/spec/Overview.html#semantics
	// http://simon.html5.org/html-elements
	
	// Safe Void Elements - HTML5
	// http://dev.w3.org/html5/spec/Overview.html#void-elements
	var voidElements = makeMap("area,br,col,hr,img,wbr,input");
	
	// Elements that you can, intentionally, leave open (and which close themselves)
	// http://dev.w3.org/html5/spec/Overview.html#optional-tags
	var optionalEndTagBlockElements = makeMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
	    optionalEndTagInlineElements = makeMap("rp,rt"),
	    optionalEndTagElements = angular.extend({},
	                                            optionalEndTagInlineElements,
	                                            optionalEndTagBlockElements);
	
	// Safe Block Elements - HTML5
	var blockElements = angular.extend({}, optionalEndTagBlockElements, makeMap("address,article," +
	        "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," +
	        "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,script,section,table,ul"));
	
	// Inline Elements - HTML5
	var inlineElements = angular.extend({}, optionalEndTagInlineElements, makeMap("a,abbr,acronym,b," +
	        "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," +
	        "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));
	
	// SVG Elements
	// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	var svgElements = makeMap("animate,animateColor,animateMotion,animateTransform,circle,defs," +
	        "desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,hkern,image,linearGradient," +
	        "line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,radialGradient,rect,set," +
	        "stop,svg,switch,text,title,tspan,use");
	
	// Special Elements (can contain anything)
	var specialElements = makeMap("script,style");
	
	var validElements = angular.extend({},
	                                   voidElements,
	                                   blockElements,
	                                   inlineElements,
	                                   optionalEndTagElements,
	                                   svgElements);
	
	//Attributes that have href and hence need to be sanitized
	var uriAttrs = makeMap("background,cite,href,longdesc,src,usemap,xlink:href");
	
	var htmlAttrs = makeMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,'+
	    'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,'+
	    'id,ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,'+
	    'scope,scrolling,shape,size,span,start,summary,target,title,type,'+
	    'valign,value,vspace,width');
	
	// SVG attributes (without "id" and "name" attributes)
	// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	var svgAttrs = makeMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	    'attributeName,attributeType,baseProfile,bbox,begin,by,calcMode,cap-height,class,color,' +
	    'color-rendering,content,cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,' +
	    'font-size,font-stretch,font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,' +
	    'gradientUnits,hanging,height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,' +
	    'keySplines,keyTimes,lang,marker-end,marker-mid,marker-start,markerHeight,markerUnits,' +
	    'markerWidth,mathematical,max,min,offset,opacity,orient,origin,overline-position,' +
	    'overline-thickness,panose-1,path,pathLength,points,preserveAspectRatio,r,refX,refY,' +
	    'repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,' +
	    'stemv,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,stroke,' +
	    'stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,' +
	    'stroke-opacity,stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,' +
	    'underline-position,underline-thickness,unicode,unicode-range,units-per-em,values,version,' +
	    'viewBox,visibility,width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,' +
	    'xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,' +
	    'zoomAndPan');
	
	var validAttrs = angular.extend({},
	                                uriAttrs,
	                                svgAttrs,
	                                htmlAttrs);
	
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) obj[items[i]] = true;
	  return obj;
	}
	
	
	/**
	 * @example
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 * @param {string} html string
	 * @param {object} handler
	 */
	function htmlParser(html, handler) {
	  if (typeof html !== 'string') {
	    if (html === null || typeof html === 'undefined') {
	      html = '';
	    } else {
	      html = '' + html;
	    }
	  }
	  var index, chars, match, stack = [], last = html, text;
	  stack.last = function() { return stack[ stack.length - 1 ]; };
	
	  while (html) {
	    text = '';
	    chars = true;
	
	    // Make sure we're not in a script or style element
	    if (!stack.last() || !specialElements[ stack.last() ]) {
	
	      // White space
	      if (WHITE_SPACE_REGEXP.test(html)) {
	        match = html.match(WHITE_SPACE_REGEXP);
	
	        if (match) {
	          var mat = match[0];
	          if (handler.whitespace) handler.whitespace(match[0]);
	          html = html.replace(match[0], '');
	          chars = false;
	        }
	      //Comment
	      } else if (SINGLE_COMMENT_REGEXP.test(html)) {
	        match = html.match(SINGLE_COMMENT_REGEXP);
	
	        if (match) {
	          if (handler.comment) handler.comment(match[1]);
	          html = html.replace(match[0], '');
	          chars = false;
	        }
	      // DOCTYPE
	      } else if (DOCTYPE_REGEXP.test(html)) {
	        match = html.match(DOCTYPE_REGEXP);
	
	        if (match) {
	          html = html.replace(match[0], '');
	          chars = false;
	        }
	      // end tag
	      } else if (BEGING_END_TAGE_REGEXP.test(html)) {
	        match = html.match(END_TAG_REGEXP);
	
	        if (match) {
	          html = html.substring(match[0].length);
	          match[0].replace(END_TAG_REGEXP, parseEndTag);
	          chars = false;
	        }
	
	      // start tag
	      } else if (BEGIN_TAG_REGEXP.test(html)) {
	        match = html.match(START_TAG_REGEXP);
	
	        if (match) {
	          // We only have a valid start-tag if there is a '>'.
	          if (match[4]) {
	            html = html.substring(match[0].length);
	            match[0].replace(START_TAG_REGEXP, parseStartTag);
	          }
	          chars = false;
	        } else {
	          // no ending tag found --- this piece should be encoded as an entity.
	          text += '<';
	          html = html.substring(1);
	        }
	      }
	
	      if (chars) {
	        index = html.indexOf("<");
	
	        text += index < 0 ? html : html.substring(0, index);
	        html = index < 0 ? "" : html.substring(index);
	
	        if (handler.chars) handler.chars(decodeEntities(text));
	      }
	
	    } else {
	      html = html.replace(new RegExp("([^]*)<\\s*\\/\\s*" + stack.last() + "[^>]*>", 'i'),
	        function(all, text) {
	          text = text.replace(COMMENT_REGEXP, "$1").replace(CDATA_REGEXP, "$1");
	
	          if (handler.chars) handler.chars(decodeEntities(text));
	
	          return "";
	      });
	
	      parseEndTag("", stack.last());
	    }
	
	    if (html == last) {
	      throw $sanitizeMinErr('badparse', "The sanitizer was unable to parse the following block " +
	                                        "of html: {0}", html);
	    }
	    last = html;
	  }
	
	  // Clean up any remaining tags
	  parseEndTag();
	
	  function parseStartTag(tag, tagName, rest, unary) {
	    tagName = angular.lowercase(tagName);
	    if (blockElements[ tagName ]) {
	      while (stack.last() && inlineElements[ stack.last() ]) {
	        parseEndTag("", stack.last());
	      }
	    }
	
	    if (optionalEndTagElements[ tagName ] && stack.last() == tagName) {
	      parseEndTag("", tagName);
	    }
	
	    unary = voidElements[ tagName ] || !!unary;
	
	    if (!unary)
	      stack.push(tagName);
	
	    var attrs = {};
	
	    rest.replace(ATTR_REGEXP,
	      function(match, name, doubleQuotedValue, singleQuotedValue, unquotedValue) {
	        var value = doubleQuotedValue
	          || singleQuotedValue
	          || unquotedValue
	          || '';
	
	        attrs[name] = decodeEntities(value);
	    });
	    if (handler.start) handler.start(tagName, attrs, unary);
	  }
	
	  function parseEndTag(tag, tagName) {
	    var pos = 0, i;
	    tagName = angular.lowercase(tagName);
	    if (tagName)
	      // Find the closest opened tag of the same type
	      for (pos = stack.length - 1; pos >= 0; pos--)
	        if (stack[ pos ] == tagName)
	          break;
	
	    if (pos >= 0) {
	      // Close all the open elements, up the stack
	      for (i = stack.length - 1; i >= pos; i--)
	        if (handler.end) handler.end(stack[ i ]);
	
	      // Remove the open elements from the stack
	      stack.length = pos;
	    }
	  }
	}
	
	var hiddenPre=document.createElement("pre");
	var spaceRe = /^(\s*)([\s\S]*?)(\s*)$/;
	/**
	 * decodes all entities into regular string
	 * @param value
	 * @returns {string} A string with decoded entities.
	 */
	function decodeEntities(value) {
	  if (!value) { return ''; }
	
	  // Note: IE8 does not preserve spaces at the start/end of innerHTML
	  // so we must capture them and reattach them afterward
	  var parts = spaceRe.exec(value);
	  var spaceBefore = parts[1];
	  var spaceAfter = parts[3];
	  var content = parts[2];
	  if (content) {
	    hiddenPre.innerHTML=content.replace(/</g,"&lt;");
	    // innerText depends on styling as it doesn't display hidden elements.
	    // Therefore, it's better to use textContent not to cause unnecessary
	    // reflows. However, IE<9 don't support textContent so the innerText
	    // fallback is necessary.
	    content = 'textContent' in hiddenPre ?
	      hiddenPre.textContent : hiddenPre.innerText;
	  }
	  return spaceBefore + content + spaceAfter;
	}
	
	/**
	 * Escapes all potentially dangerous characters, so that the
	 * resulting string can be safely inserted into attribute or
	 * element text.
	 * @param value
	 * @returns {string} escaped text
	 */
	function encodeEntities(value) {
	  return value.
	    replace(/&/g, '&amp;').
	    replace(SURROGATE_PAIR_REGEXP, function(value) {
	      var hi = value.charCodeAt(0);
	      var low = value.charCodeAt(1);
	      return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	    }).
	    replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	      // unsafe chars are: \u0000-\u001f \u007f-\u009f \u00ad \u0600-\u0604 \u070f \u17b4 \u17b5 \u200c-\u200f \u2028-\u202f \u2060-\u206f \ufeff \ufff0-\uffff from jslint.com/lint.html
	      // decimal values are: 0-31, 127-159, 173, 1536-1540, 1807, 6068, 6069, 8204-8207, 8232-8239, 8288-8303, 65279, 65520-65535
	      var c = value.charCodeAt(0);
	      // if unsafe character encode
	      if(c <= 159 ||
	        c == 173 ||
	        (c >= 1536 && c <= 1540) ||
	        c == 1807 ||
	        c == 6068 ||
	        c == 6069 ||
	        (c >= 8204 && c <= 8207) ||
	        (c >= 8232 && c <= 8239) ||
	        (c >= 8288 && c <= 8303) ||
	        c == 65279 ||
	        (c >= 65520 && c <= 65535)) return '&#' + c + ';';
	      return value; // avoids multilingual issues
	    }).
	    replace(/</g, '&lt;').
	    replace(/>/g, '&gt;');
	}
	
	var trim = (function() {
	  // native trim is way faster: http://jsperf.com/angular-trim-test
	  // but IE doesn't have it... :-(
	  // TODO: we should move this into IE/ES5 polyfill
	  if (!String.prototype.trim) {
	    return function(value) {
	      return angular.isString(value) ? value.replace(/^\s\s*/, '').replace(/\s\s*$/, '') : value;
	    };
	  }
	  return function(value) {
	    return angular.isString(value) ? value.trim() : value;
	  };
	})();
	
	// Custom logic for accepting certain style options only - textAngular
	// Currently allows only the color, background-color, text-align, float, width and height attributes
	// all other attributes should be easily done through classes.
	function validStyles(styleAttr){
		var result = '';
		var styleArray = styleAttr.split(';');
		angular.forEach(styleArray, function(value){
			var v = value.split(':');
			if(v.length == 2){
				var key = trim(angular.lowercase(v[0]));
				var value = trim(angular.lowercase(v[1]));
				if(
					(key === 'color' || key === 'background-color') && (
						value.match(/^rgb\([0-9%,\. ]*\)$/i)
						|| value.match(/^rgba\([0-9%,\. ]*\)$/i)
						|| value.match(/^hsl\([0-9%,\. ]*\)$/i)
						|| value.match(/^hsla\([0-9%,\. ]*\)$/i)
						|| value.match(/^#[0-9a-f]{3,6}$/i)
						|| value.match(/^[a-z]*$/i)
					)
				||
					key === 'text-align' && (
						value === 'left'
						|| value === 'right'
						|| value === 'center'
						|| value === 'justify'
					)
				||
	        key === 'text-decoration' && (
	            value === 'underline'
	            || value === 'line-through'
	        )
	      || 
	        key === 'font-weight' && (
	            value === 'bold'
	        )
	      ||
	        key === 'font-style' && (
	          value === 'italic'
	        )
	      ||
	        key === 'float' && (
	            value === 'left'
	            || value === 'right'
	            || value === 'none'
	        )
	      ||
	        key === 'vertical-align' && (
	            value === 'baseline'
	            || value === 'sub'
	            || value === 'super'
	            || value === 'test-top'
	            || value === 'text-bottom'
	            || value === 'middle'
	            || value === 'top'
	            || value === 'bottom'
	            || value.match(/[0-9]*(px|em)/)
	            || value.match(/[0-9]+?%/)
	        )
	      ||
	        key === 'font-size' && (
	            value === 'xx-small'
	            || value === 'x-small'
	            || value === 'small'
	            || value === 'medium'
	            || value === 'large'
	            || value === 'x-large'
	            || value === 'xx-large'
	            || value === 'larger'
	            || value === 'smaller'
	            || value.match(/[0-9]*\.?[0-9]*(px|em|rem|mm|q|cm|in|pt|pc|%)/)
	                               )
				||
					(key === 'width' || key === 'height') && (
						value.match(/[0-9\.]*(px|em|rem|%)/)
					)
				|| // Reference #520
					(key === 'direction' && value.match(/^ltr|rtl|initial|inherit$/))
				) result += key + ': ' + value + ';';
			}
		});
		return result;
	}
	
	// this function is used to manually allow specific attributes on specific tags with certain prerequisites
	function validCustomTag(tag, attrs, lkey, value){
		// catch the div placeholder for the iframe replacement
	    if (tag === 'img' && attrs['ta-insert-video']){
	        if(lkey === 'ta-insert-video' || lkey === 'allowfullscreen' || lkey === 'frameborder' || (lkey === 'contenteditable' && value === 'false')) return true;
	    }
	    return false;
	}
	
	/**
	 * create an HTML/XML writer which writes to buffer
	 * @param {Array} buf use buf.jain('') to get out sanitized html string
	 * @returns {object} in the form of {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * }
	 */
	function htmlSanitizeWriter(buf, uriValidator) {
	  var ignore = false;
	  var out = angular.bind(buf, buf.push);
	  return {
	    start: function(tag, attrs, unary) {
	      tag = angular.lowercase(tag);
	      if (!ignore && specialElements[tag]) {
	        ignore = tag;
	      }
	      if (!ignore && validElements[tag] === true) {
	        out('<');
	        out(tag);
	        angular.forEach(attrs, function(value, key) {
	          var lkey=angular.lowercase(key);
	          var isImage=(tag === 'img' && lkey === 'src') || (lkey === 'background');
	          if ((lkey === 'style' && (value = validStyles(value)) !== '') || validCustomTag(tag, attrs, lkey, value) || validAttrs[lkey] === true &&
	            (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	            out(' ');
	            out(key);
	            out('="');
	            out(encodeEntities(value));
	            out('"');
	          }
	        });
	        out(unary ? '/>' : '>');
	      }
	    },
	    comment: function (com) {
	      out(com);
	    },
	    whitespace: function (ws) {
	      out(encodeEntities(ws));
	    },
	    end: function(tag) {
	        tag = angular.lowercase(tag);
	        if (!ignore && validElements[tag] === true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        if (tag == ignore) {
	          ignore = false;
	        }
	      },
	    chars: function(chars) {
	        if (!ignore) {
	          out(encodeEntities(chars));
	        }
	      }
	  };
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	/* global sanitizeText: false */
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports http/https/ftp/mailto and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (_blank|_self|_parent|_top) or named frame to open links in.
	 * @returns {string} Html-linkified text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <script>
	         angular.module('linkyExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.snippet =
	               'Pretty text with some links:\n'+
	               'http://angularjs.org/,\n'+
	               'mailto:us@somewhere.org,\n'+
	               'another@somewhere.org,\n'+
	               'and one more: ftp://127.0.0.1/.';
	             $scope.snippetWithTarget = 'http://angularjs.org/';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Filter</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithTarget | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithTarget | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithTarget | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"”’]/,
	      MAILTO_REGEXP = /^mailto:/;
	
	  return function(text, target) {
	    if (!text) return text;
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      html.push('<a ');
	      if (angular.isDefined(target)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(167),__webpack_require__(429)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0,b1) {
	      return (root['textAngular.name'] = factory(a0,b1));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory(require("rangy"),require("rangy/lib/rangy-selectionsaverestore"));
	  } else {
	    root['textAngular'] = factory(rangy);
	  }
	}(this, function (rangy) {
	
	
	// tests against the current jqLite/jquery implementation if this can be an element
	function validElementString(string){
	    try{
	        return angular.element(string).length !== 0;
	    }catch(any){
	        return false;
	    }
	}
	// setup the global contstant functions for setting up the toolbar
	
	// all tool definitions
	var taTools = {};
	/*
	    A tool definition is an object with the following key/value parameters:
	        action: [function(deferred, restoreSelection)]
	                a function that is executed on clicking on the button - this will allways be executed using ng-click and will
	                overwrite any ng-click value in the display attribute.
	                The function is passed a deferred object ($q.defer()), if this is wanted to be used `return false;` from the action and
	                manually call `deferred.resolve();` elsewhere to notify the editor that the action has finished.
	                restoreSelection is only defined if the rangy library is included and it can be called as `restoreSelection()` to restore the users
	                selection in the WYSIWYG editor.
	        display: [string]?
	                Optional, an HTML element to be displayed as the button. The `scope` of the button is the tool definition object with some additional functions
	                If set this will cause buttontext and iconclass to be ignored
	        class: [string]?
	                Optional, if set will override the taOptions.classes.toolbarButton class.
	        buttontext: [string]?
	                if this is defined it will replace the contents of the element contained in the `display` element
	        iconclass: [string]?
	                if this is defined an icon (<i>) will be appended to the `display` element with this string as it's class
	        tooltiptext: [string]?
	                Optional, a plain text description of the action, used for the title attribute of the action button in the toolbar by default.
	        activestate: [function(commonElement)]?
	                this function is called on every caret movement, if it returns true then the class taOptions.classes.toolbarButtonActive
	                will be applied to the `display` element, else the class will be removed
	        disabled: [function()]?
	                if this function returns true then the tool will have the class taOptions.classes.disabled applied to it, else it will be removed
	    Other functions available on the scope are:
	        name: [string]
	                the name of the tool, this is the first parameter passed into taRegisterTool
	        isDisabled: [function()]
	                returns true if the tool is disabled, false if it isn't
	        displayActiveToolClass: [function(boolean)]
	                returns true if the tool is 'active' in the currently focussed toolbar
	        onElementSelect: [Object]
	                This object contains the following key/value pairs and is used to trigger the ta-element-select event
	                element: [String]
	                    an element name, will only trigger the onElementSelect action if the tagName of the element matches this string
	                filter: [function(element)]?
	                    an optional filter that returns a boolean, if true it will trigger the onElementSelect.
	                action: [function(event, element, editorScope)]
	                    the action that should be executed if the onElementSelect function runs
	*/
	// name and toolDefinition to add into the tools available to be added on the toolbar
	function registerTextAngularTool(name, toolDefinition){
	    if(!name || name === '' || taTools.hasOwnProperty(name)) throw('textAngular Error: A unique name is required for a Tool Definition');
	    if(
	        (toolDefinition.display && (toolDefinition.display === '' || !validElementString(toolDefinition.display))) ||
	        (!toolDefinition.display && !toolDefinition.buttontext && !toolDefinition.iconclass)
	    )
	        throw('textAngular Error: Tool Definition for "' + name + '" does not have a valid display/iconclass/buttontext value');
	    taTools[name] = toolDefinition;
	}
	
	angular.module('textAngularSetup', [])
	.constant('taRegisterTool', registerTextAngularTool)
	.value('taTools', taTools)
	// Here we set up the global display defaults, to set your own use a angular $provider#decorator.
	.value('taOptions',  {
	    //////////////////////////////////////////////////////////////////////////////////////
	    // forceTextAngularSanitize
	    // set false to allow the textAngular-sanitize provider to be replaced
	    // with angular-sanitize or a custom provider.
	    forceTextAngularSanitize: true,
	    ///////////////////////////////////////////////////////////////////////////////////////
	    // keyMappings
	    // allow customizable keyMappings for specialized key boards or languages
	    //
	    // keyMappings provides key mappings that are attached to a given commandKeyCode.
	    // To modify a specific keyboard binding, simply provide function which returns true
	    // for the event you wish to map to.
	    // Or to disable a specific keyboard binding, provide a function which returns false.
	    // Note: 'RedoKey' and 'UndoKey' are internally bound to the redo and undo functionality.
	    // At present, the following commandKeyCodes are in use:
	    // 98, 'TabKey', 'ShiftTabKey', 105, 117, 'UndoKey', 'RedoKey'
	    //
	    // To map to an new commandKeyCode, add a new key mapping such as:
	    // {commandKeyCode: 'CustomKey', testForKey: function (event) {
	    //  if (event.keyCode=57 && event.ctrlKey && !event.shiftKey && !event.altKey) return true;
	    // } }
	    // to the keyMappings. This example maps ctrl+9 to 'CustomKey'
	    // Then where taRegisterTool(...) is called, add a commandKeyCode: 'CustomKey' and your
	    // tool will be bound to ctrl+9.
	    //
	    // To disble one of the already bound commandKeyCodes such as 'RedoKey' or 'UndoKey' add:
	    // {commandKeyCode: 'RedoKey', testForKey: function (event) { return false; } },
	    // {commandKeyCode: 'UndoKey', testForKey: function (event) { return false; } },
	    // to disable them.
	    //
	    keyMappings : [],
	    toolbar: [
	        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
	        ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
	        ['justifyLeft','justifyCenter','justifyRight','justifyFull','indent','outdent'],
	        ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
	    ],
	    classes: {
	        focussed: "focussed",
	        toolbar: "btn-toolbar",
	        toolbarGroup: "btn-group",
	        toolbarButton: "btn btn-default",
	        toolbarButtonActive: "active",
	        disabled: "disabled",
	        textEditor: 'form-control',
	        htmlEditor: 'form-control'
	    },
	    defaultTagAttributes : {
	        a: {target:""}
	    },
	    setup: {
	        // wysiwyg mode
	        textEditorSetup: function($element){ /* Do some processing here */ },
	        // raw html
	        htmlEditorSetup: function($element){ /* Do some processing here */ }
	    },
	    defaultFileDropHandler:
	        /* istanbul ignore next: untestable image processing */
	        function(file, insertAction){
	            var reader = new FileReader();
	            if(file.type.substring(0, 5) === 'image'){
	                reader.onload = function() {
	                    if(reader.result !== '') insertAction('insertImage', reader.result, true);
	                };
	
	                reader.readAsDataURL(file);
	                // NOTE: For async procedures return a promise and resolve it when the editor should update the model.
	                return true;
	            }
	            return false;
	        }
	})
	
	// This is the element selector string that is used to catch click events within a taBind, prevents the default and $emits a 'ta-element-select' event
	// these are individually used in an angular.element().find() call. What can go here depends on whether you have full jQuery loaded or just jQLite with angularjs.
	// div is only used as div.ta-insert-video caught in filter.
	.value('taSelectableElements', ['a','img'])
	
	// This is an array of objects with the following options:
	//				selector: <string> a jqLite or jQuery selector string
	//				customAttribute: <string> an attribute to search for
	//				renderLogic: <function(element)>
	// Both or one of selector and customAttribute must be defined.
	.value('taCustomRenderers', [
	    {
	        // Parse back out: '<div class="ta-insert-video" ta-insert-video src="' + urlLink + '" allowfullscreen="true" width="300" frameborder="0" height="250"></div>'
	        // To correct video element. For now only support youtube
	        selector: 'img',
	        customAttribute: 'ta-insert-video',
	        renderLogic: function(element){
	            var iframe = angular.element('<iframe></iframe>');
	            var attributes = element.prop("attributes");
	            // loop through element attributes and apply them on iframe
	            angular.forEach(attributes, function(attr) {
	                iframe.attr(attr.name, attr.value);
	            });
	            iframe.attr('src', iframe.attr('ta-insert-video'));
	            element.replaceWith(iframe);
	        }
	    }
	])
	
	.value('taTranslations', {
	    // moved to sub-elements
	    //toggleHTML: "Toggle HTML",
	    //insertImage: "Please enter a image URL to insert",
	    //insertLink: "Please enter a URL to insert",
	    //insertVideo: "Please enter a youtube URL to embed",
	    html: {
	        tooltip: 'Toggle html / Rich Text'
	    },
	    // tooltip for heading - might be worth splitting
	    heading: {
	        tooltip: 'Heading '
	    },
	    p: {
	        tooltip: 'Paragraph'
	    },
	    pre: {
	        tooltip: 'Preformatted text'
	    },
	    ul: {
	        tooltip: 'Unordered List'
	    },
	    ol: {
	        tooltip: 'Ordered List'
	    },
	    quote: {
	        tooltip: 'Quote/unquote selection or paragraph'
	    },
	    undo: {
	        tooltip: 'Undo'
	    },
	    redo: {
	        tooltip: 'Redo'
	    },
	    bold: {
	        tooltip: 'Bold'
	    },
	    italic: {
	        tooltip: 'Italic'
	    },
	    underline: {
	        tooltip: 'Underline'
	    },
	    strikeThrough:{
	        tooltip: 'Strikethrough'
	    },
	    justifyLeft: {
	        tooltip: 'Align text left'
	    },
	    justifyRight: {
	        tooltip: 'Align text right'
	    },
	    justifyFull: {
	        tooltip: 'Justify text'
	    },
	    justifyCenter: {
	        tooltip: 'Center'
	    },
	    indent: {
	        tooltip: 'Increase indent'
	    },
	    outdent: {
	        tooltip: 'Decrease indent'
	    },
	    clear: {
	        tooltip: 'Clear formatting'
	    },
	    insertImage: {
	        dialogPrompt: 'Please enter an image URL to insert',
	        tooltip: 'Insert image',
	        hotkey: 'the - possibly language dependent hotkey ... for some future implementation'
	    },
	    insertVideo: {
	        tooltip: 'Insert video',
	        dialogPrompt: 'Please enter a youtube URL to embed'
	    },
	    insertLink: {
	        tooltip: 'Insert / edit link',
	        dialogPrompt: "Please enter a URL to insert"
	    },
	    editLink: {
	        reLinkButton: {
	            tooltip: "Relink"
	        },
	        unLinkButton: {
	            tooltip: "Unlink"
	        },
	        targetToggle: {
	            buttontext: "Open in New Window"
	        }
	    },
	    wordcount: {
	        tooltip: 'Display words Count'
	    },
	        charcount: {
	        tooltip: 'Display characters Count'
	    }
	})
	.factory('taToolFunctions', ['$window','taTranslations', function($window, taTranslations) {
	    return {
	        imgOnSelectAction: function(event, $element, editorScope){
	            // setup the editor toolbar
	            // Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic/display
	            var finishEdit = function(){
	                editorScope.updateTaBindtaTextElement();
	                editorScope.hidePopover();
	            };
	            event.preventDefault();
	            editorScope.displayElements.popover.css('width', '375px');
	            var container = editorScope.displayElements.popoverContainer;
	            container.empty();
	            var buttonGroup = angular.element('<div class="btn-group" style="padding-right: 6px;">');
	            var fullButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">100% </button>');
	            fullButton.on('click', function(event){
	                event.preventDefault();
	                $element.css({
	                    'width': '100%',
	                    'height': ''
	                });
	                finishEdit();
	            });
	            var halfButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">50% </button>');
	            halfButton.on('click', function(event){
	                event.preventDefault();
	                $element.css({
	                    'width': '50%',
	                    'height': ''
	                });
	                finishEdit();
	            });
	            var quartButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">25% </button>');
	            quartButton.on('click', function(event){
	                event.preventDefault();
	                $element.css({
	                    'width': '25%',
	                    'height': ''
	                });
	                finishEdit();
	            });
	            var resetButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">Reset</button>');
	            resetButton.on('click', function(event){
	                event.preventDefault();
	                $element.css({
	                    width: '',
	                    height: ''
	                });
	                finishEdit();
	            });
	            buttonGroup.append(fullButton);
	            buttonGroup.append(halfButton);
	            buttonGroup.append(quartButton);
	            buttonGroup.append(resetButton);
	            container.append(buttonGroup);
	
	            buttonGroup = angular.element('<div class="btn-group" style="padding-right: 6px;">');
	            var floatLeft = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-left"></i></button>');
	            floatLeft.on('click', function(event){
	                event.preventDefault();
	                // webkit
	                $element.css('float', 'left');
	                // firefox
	                $element.css('cssFloat', 'left');
	                // IE < 8
	                $element.css('styleFloat', 'left');
	                finishEdit();
	            });
	            var floatRight = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-right"></i></button>');
	            floatRight.on('click', function(event){
	                event.preventDefault();
	                // webkit
	                $element.css('float', 'right');
	                // firefox
	                $element.css('cssFloat', 'right');
	                // IE < 8
	                $element.css('styleFloat', 'right');
	                finishEdit();
	            });
	            var floatNone = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-justify"></i></button>');
	            floatNone.on('click', function(event){
	                event.preventDefault();
	                // webkit
	                $element.css('float', '');
	                // firefox
	                $element.css('cssFloat', '');
	                // IE < 8
	                $element.css('styleFloat', '');
	                finishEdit();
	            });
	            buttonGroup.append(floatLeft);
	            buttonGroup.append(floatNone);
	            buttonGroup.append(floatRight);
	            container.append(buttonGroup);
	
	            buttonGroup = angular.element('<div class="btn-group">');
	            var remove = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-trash-o"></i></button>');
	            remove.on('click', function(event){
	                event.preventDefault();
	                $element.remove();
	                finishEdit();
	            });
	            buttonGroup.append(remove);
	            container.append(buttonGroup);
	
	            editorScope.showPopover($element);
	            editorScope.showResizeOverlay($element);
	        },
	        aOnSelectAction: function(event, $element, editorScope){
	            // setup the editor toolbar
	            // Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic
	            event.preventDefault();
	            editorScope.displayElements.popover.css('width', '436px');
	            var container = editorScope.displayElements.popoverContainer;
	            container.empty();
	            container.css('line-height', '28px');
	            var link = angular.element('<a href="' + $element.attr('href') + '" target="_blank">' + $element.attr('href') + '</a>');
	            link.css({
	                'display': 'inline-block',
	                'max-width': '200px',
	                'overflow': 'hidden',
	                'text-overflow': 'ellipsis',
	                'white-space': 'nowrap',
	                'vertical-align': 'middle'
	            });
	            container.append(link);
	            var buttonGroup = angular.element('<div class="btn-group pull-right">');
	            var reLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.reLinkButton.tooltip + '"><i class="fa fa-edit icon-edit"></i></button>');
	            reLinkButton.on('click', function(event){
	                event.preventDefault();
	                var urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, $element.attr('href'));
	                if(urlLink && urlLink !== '' && urlLink !== 'http://'){
	                    $element.attr('href', urlLink);
	                    editorScope.updateTaBindtaTextElement();
	                }
	                editorScope.hidePopover();
	            });
	            buttonGroup.append(reLinkButton);
	            var unLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.unLinkButton.tooltip + '"><i class="fa fa-unlink icon-unlink"></i></button>');
	            // directly before this click event is fired a digest is fired off whereby the reference to $element is orphaned off
	            unLinkButton.on('click', function(event){
	                event.preventDefault();
	                $element.replaceWith($element.contents());
	                editorScope.updateTaBindtaTextElement();
	                editorScope.hidePopover();
	            });
	            buttonGroup.append(unLinkButton);
	            var targetToggle = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on">' + taTranslations.editLink.targetToggle.buttontext + '</button>');
	            if($element.attr('target') === '_blank'){
	                targetToggle.addClass('active');
	            }
	            targetToggle.on('click', function(event){
	                event.preventDefault();
	                $element.attr('target', ($element.attr('target') === '_blank') ? '' : '_blank');
	                targetToggle.toggleClass('active');
	                editorScope.updateTaBindtaTextElement();
	            });
	            buttonGroup.append(targetToggle);
	            container.append(buttonGroup);
	            editorScope.showPopover($element);
	        },
	        extractYoutubeVideoId: function(url) {
	            var re = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
	            var match = url.match(re);
	            return (match && match[1]) || null;
	        }
	    };
	}])
	.run(['taRegisterTool', '$window', 'taTranslations', 'taSelection', 'taToolFunctions', '$sanitize', 'taOptions', '$log',
	    function(taRegisterTool, $window, taTranslations, taSelection, taToolFunctions, $sanitize, taOptions, $log){
	    // test for the version of $sanitize that is in use
	    // You can disable this check by setting taOptions.textAngularSanitize == false
	    var gv = {}; $sanitize('', gv);
	    /* istanbul ignore next, throws error */
	    if ((taOptions.forceTextAngularSanitize===true) && (gv.version !== 'taSanitize')) {
	        throw angular.$$minErr('textAngular')("textAngularSetup", "The textAngular-sanitize provider has been replaced by another -- have you included angular-sanitize by mistake?");
	    }
	    taRegisterTool("html", {
	        iconclass: 'fa fa-code',
	        tooltiptext: taTranslations.html.tooltip,
	        action: function(){
	            this.$editor().switchView();
	        },
	        activeState: function(){
	            return this.$editor().showHtml;
	        }
	    });
	    // add the Header tools
	    // convenience functions so that the loop works correctly
	    var _retActiveStateFunction = function(q){
	        return function(){ return this.$editor().queryFormatBlockState(q); };
	    };
	    var headerAction = function(){
	        return this.$editor().wrapSelection("formatBlock", "<" + this.name.toUpperCase() +">");
	    };
	    angular.forEach(['h1','h2','h3','h4','h5','h6'], function(h){
	        taRegisterTool(h.toLowerCase(), {
	            buttontext: h.toUpperCase(),
	            tooltiptext: taTranslations.heading.tooltip + h.charAt(1),
	            action: headerAction,
	            activeState: _retActiveStateFunction(h.toLowerCase())
	        });
	    });
	    taRegisterTool('p', {
	        buttontext: 'P',
	        tooltiptext: taTranslations.p.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("formatBlock", "<P>");
	        },
	        activeState: function(){ return this.$editor().queryFormatBlockState('p'); }
	    });
	    // key: pre -> taTranslations[key].tooltip, taTranslations[key].buttontext
	    taRegisterTool('pre', {
	        buttontext: 'pre',
	        tooltiptext: taTranslations.pre.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("formatBlock", "<PRE>");
	        },
	        activeState: function(){ return this.$editor().queryFormatBlockState('pre'); }
	    });
	    taRegisterTool('ul', {
	        iconclass: 'fa fa-list-ul',
	        tooltiptext: taTranslations.ul.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("insertUnorderedList", null);
	        },
	        activeState: function(){ return this.$editor().queryCommandState('insertUnorderedList'); }
	    });
	    taRegisterTool('ol', {
	        iconclass: 'fa fa-list-ol',
	        tooltiptext: taTranslations.ol.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("insertOrderedList", null);
	        },
	        activeState: function(){ return this.$editor().queryCommandState('insertOrderedList'); }
	    });
	    taRegisterTool('quote', {
	        iconclass: 'fa fa-quote-right',
	        tooltiptext: taTranslations.quote.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("formatBlock", "<BLOCKQUOTE>");
	        },
	        activeState: function(){ return this.$editor().queryFormatBlockState('blockquote'); }
	    });
	    taRegisterTool('undo', {
	        iconclass: 'fa fa-undo',
	        tooltiptext: taTranslations.undo.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("undo", null);
	        }
	    });
	    taRegisterTool('redo', {
	        iconclass: 'fa fa-repeat',
	        tooltiptext: taTranslations.redo.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("redo", null);
	        }
	    });
	    taRegisterTool('bold', {
	        iconclass: 'fa fa-bold',
	        tooltiptext: taTranslations.bold.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("bold", null);
	        },
	        activeState: function(){
	            return this.$editor().queryCommandState('bold');
	        },
	        commandKeyCode: 98
	    });
	    taRegisterTool('justifyLeft', {
	        iconclass: 'fa fa-align-left',
	        tooltiptext: taTranslations.justifyLeft.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("justifyLeft", null);
	        },
	        activeState: function(commonElement){
	            /* istanbul ignore next: */
	            if (commonElement && commonElement.nodeName === '#document') return false;
	            var result = false;
	            if (commonElement) {
	                // commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	                // so we do try catch here...
	                try {
	                    result =
	                        commonElement.css('text-align') === 'left' ||
	                        commonElement.attr('align') === 'left' ||
	                        (
	                            commonElement.css('text-align') !== 'right' &&
	                            commonElement.css('text-align') !== 'center' &&
	                            commonElement.css('text-align') !== 'justify' && !this.$editor().queryCommandState('justifyRight') && !this.$editor().queryCommandState('justifyCenter')
	                        ) && !this.$editor().queryCommandState('justifyFull');
	                } catch(e) {
	                    /* istanbul ignore next: error handler */
	                    //console.log(e);
	                    result = false;
	                }
	            }
	            result = result || this.$editor().queryCommandState('justifyLeft');
	            return result;
	        }
	    });
	    taRegisterTool('justifyRight', {
	        iconclass: 'fa fa-align-right',
	        tooltiptext: taTranslations.justifyRight.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("justifyRight", null);
	        },
	        activeState: function(commonElement){
	            /* istanbul ignore next: */
	            if (commonElement && commonElement.nodeName === '#document') return false;
	            var result = false;
	            if(commonElement) {
	                // commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	                // so we do try catch here...
	                try {
	                    result = commonElement.css('text-align') === 'right';
	                } catch(e) {
	                    /* istanbul ignore next: error handler */
	                    //console.log(e);
	                    result = false;
	                }
	            }
	            result = result || this.$editor().queryCommandState('justifyRight');
	            return result;
	        }
	    });
	    taRegisterTool('justifyFull', {
	        iconclass: 'fa fa-align-justify',
	        tooltiptext: taTranslations.justifyFull.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("justifyFull", null);
	        },
	        activeState: function(commonElement){
	            var result = false;
	            if(commonElement) {
	                // commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	                // so we do try catch here...
	                try {
	                    result = commonElement.css('text-align') === 'justify';
	                } catch(e) {
	                    /* istanbul ignore next: error handler */
	                    //console.log(e);
	                    result = false;
	                }
	            }
	            result = result || this.$editor().queryCommandState('justifyFull');
	            return result;
	        }
	    });
	    taRegisterTool('justifyCenter', {
	        iconclass: 'fa fa-align-center',
	        tooltiptext: taTranslations.justifyCenter.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("justifyCenter", null);
	        },
	        activeState: function(commonElement){
	            /* istanbul ignore next: */
	            if (commonElement && commonElement.nodeName === '#document') return false;
	            var result = false;
	            if(commonElement) {
	                // commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	                // so we do try catch here...
	                try {
	                    result = commonElement.css('text-align') === 'center';
	                } catch(e) {
	                    /* istanbul ignore next: error handler */
	                    //console.log(e);
	                    result = false;
	                }
	
	            }
	            result = result || this.$editor().queryCommandState('justifyCenter');
	            return result;
	        }
	    });
	    taRegisterTool('indent', {
	        iconclass: 'fa fa-indent',
	        tooltiptext: taTranslations.indent.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("indent", null);
	        },
	        activeState: function(){
	            return this.$editor().queryFormatBlockState('blockquote');
	        },
	        commandKeyCode: 'TabKey'
	    });
	    taRegisterTool('outdent', {
	        iconclass: 'fa fa-outdent',
	        tooltiptext: taTranslations.outdent.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("outdent", null);
	        },
	        activeState: function(){
	            return false;
	        },
	        commandKeyCode: 'ShiftTabKey'
	    });
	    taRegisterTool('italics', {
	        iconclass: 'fa fa-italic',
	        tooltiptext: taTranslations.italic.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("italic", null);
	        },
	        activeState: function(){
	            return this.$editor().queryCommandState('italic');
	        },
	        commandKeyCode: 105
	    });
	    taRegisterTool('underline', {
	        iconclass: 'fa fa-underline',
	        tooltiptext: taTranslations.underline.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("underline", null);
	        },
	        activeState: function(){
	            return this.$editor().queryCommandState('underline');
	        },
	        commandKeyCode: 117
	    });
	    taRegisterTool('strikeThrough', {
	        iconclass: 'fa fa-strikethrough',
	        tooltiptext: taTranslations.strikeThrough.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("strikeThrough", null);
	        },
	        activeState: function(){
	            return document.queryCommandState('strikeThrough');
	        }
	    });
	    taRegisterTool('clear', {
	        iconclass: 'fa fa-ban',
	        tooltiptext: taTranslations.clear.tooltip,
	        action: function(deferred, restoreSelection){
	            var i, selectedElements, elementsSeen;
	
	            this.$editor().wrapSelection("removeFormat", null);
	            var possibleNodes = angular.element(taSelection.getSelectionElement());
	            selectedElements = taSelection.getAllSelectedElements();
	            //$log.log('selectedElements:', selectedElements);
	            // remove lists
	            var removeListElements = function(list, pe){
	                list = angular.element(list);
	                var prevElement = pe;
	                if (!pe) {
	                    prevElement = list;
	                }
	                angular.forEach(list.children(), function(liElem){
	                    if (liElem.tagName.toLowerCase() === 'ul' ||
	                        liElem.tagName.toLowerCase() === 'ol') {
	                        prevElement = removeListElements(liElem, prevElement);
	                    } else {
	                        var newElem = angular.element('<p></p>');
	                        newElem.html(angular.element(liElem).html());
	                        prevElement.after(newElem);
	                        prevElement = newElem;
	                    }
	                });
	                list.remove();
	                return prevElement;
	            };
	
	            angular.forEach(selectedElements, function(element) {
	                if (element.nodeName.toLowerCase() === 'ul' ||
	                    element.nodeName.toLowerCase() === 'ol') {
	                    //console.log('removeListElements', element);
	                    removeListElements(element);
	                }
	            });
	
	            angular.forEach(possibleNodes.find("ul"), removeListElements);
	            angular.forEach(possibleNodes.find("ol"), removeListElements);
	
	            // clear out all class attributes. These do not seem to be cleared via removeFormat
	            var $editor = this.$editor();
	            var recursiveRemoveClass = function(node){
	                node = angular.element(node);
	                /* istanbul ignore next: this is not triggered in tests any longer since we now never select the whole displayELement */
	                if(node[0] !== $editor.displayElements.text[0]) {
	                    node.removeAttr('class');
	                }
	                angular.forEach(node.children(), recursiveRemoveClass);
	            };
	            angular.forEach(possibleNodes, recursiveRemoveClass);
	            // check if in list. If not in list then use formatBlock option
	            if(possibleNodes[0] && possibleNodes[0].tagName.toLowerCase() !== 'li' &&
	                possibleNodes[0].tagName.toLowerCase() !== 'ol' &&
	                possibleNodes[0].tagName.toLowerCase() !== 'ul' &&
	                possibleNodes[0].getAttribute("contenteditable") !== "true") {
	                this.$editor().wrapSelection("formatBlock", "default");
	            }
	            restoreSelection();
	        }
	    });
	
	        /* jshint -W099 */
	    /****************************
	     //  we don't use this code - since the previous way CLEAR is expected to work does not clear partially selected <li>
	
	     var removeListElement = function(listE){
	                console.log(listE);
	                var _list = listE.parentNode.childNodes;
	                console.log('_list', _list);
	                var _preLis = [], _postLis = [], _found = false;
	                for (i = 0; i < _list.length; i++) {
	                    if (_list[i] === listE) {
	                        _found = true;
	                    } else if (!_found) _preLis.push(_list[i]);
	                    else _postLis.push(_list[i]);
	                }
	                var _parent = angular.element(listE.parentNode);
	                var newElem = angular.element('<p></p>');
	                newElem.html(angular.element(listE).html());
	                if (_preLis.length === 0 || _postLis.length === 0) {
	                    if (_postLis.length === 0) _parent.after(newElem);
	                    else _parent[0].parentNode.insertBefore(newElem[0], _parent[0]);
	
	                    if (_preLis.length === 0 && _postLis.length === 0) _parent.remove();
	                    else angular.element(listE).remove();
	                } else {
	                    var _firstList = angular.element('<' + _parent[0].tagName + '></' + _parent[0].tagName + '>');
	                    var _secondList = angular.element('<' + _parent[0].tagName + '></' + _parent[0].tagName + '>');
	                    for (i = 0; i < _preLis.length; i++) _firstList.append(angular.element(_preLis[i]));
	                    for (i = 0; i < _postLis.length; i++) _secondList.append(angular.element(_postLis[i]));
	                    _parent.after(_secondList);
	                    _parent.after(newElem);
	                    _parent.after(_firstList);
	                    _parent.remove();
	                }
	                taSelection.setSelectionToElementEnd(newElem[0]);
	            };
	
	     elementsSeen = [];
	     if (selectedElements.length !==0) console.log(selectedElements);
	     angular.forEach(selectedElements, function (element) {
	                if (elementsSeen.indexOf(element) !== -1 || elementsSeen.indexOf(element.parentElement) !== -1) {
	                    return;
	                }
	                elementsSeen.push(element);
	                if (element.nodeName.toLowerCase() === 'li') {
	                    console.log('removeListElement', element);
	                    removeListElement(element);
	                }
	                else if (element.parentElement && element.parentElement.nodeName.toLowerCase() === 'li') {
	                    console.log('removeListElement', element.parentElement);
	                    elementsSeen.push(element.parentElement);
	                    removeListElement(element.parentElement);
	                }
	            });
	     **********************/
	
	    /**********************
	     if(possibleNodes[0].tagName.toLowerCase() === 'li'){
	                var _list = possibleNodes[0].parentNode.childNodes;
	                var _preLis = [], _postLis = [], _found = false;
	                for(i = 0; i < _list.length; i++){
	                    if(_list[i] === possibleNodes[0]){
	                        _found = true;
	                    }else if(!_found) _preLis.push(_list[i]);
	                    else _postLis.push(_list[i]);
	                }
	                var _parent = angular.element(possibleNodes[0].parentNode);
	                var newElem = angular.element('<p></p>');
	                newElem.html(angular.element(possibleNodes[0]).html());
	                if(_preLis.length === 0 || _postLis.length === 0){
	                    if(_postLis.length === 0) _parent.after(newElem);
	                    else _parent[0].parentNode.insertBefore(newElem[0], _parent[0]);
	
	                    if(_preLis.length === 0 && _postLis.length === 0) _parent.remove();
	                    else angular.element(possibleNodes[0]).remove();
	                }else{
	                    var _firstList = angular.element('<'+_parent[0].tagName+'></'+_parent[0].tagName+'>');
	                    var _secondList = angular.element('<'+_parent[0].tagName+'></'+_parent[0].tagName+'>');
	                    for(i = 0; i < _preLis.length; i++) _firstList.append(angular.element(_preLis[i]));
	                    for(i = 0; i < _postLis.length; i++) _secondList.append(angular.element(_postLis[i]));
	                    _parent.after(_secondList);
	                    _parent.after(newElem);
	                    _parent.after(_firstList);
	                    _parent.remove();
	                }
	                taSelection.setSelectionToElementEnd(newElem[0]);
	            }
	     *******************/
	
	
	    /* istanbul ignore next: if it's javascript don't worry - though probably should show some kind of error message */
	    var blockJavascript = function (link) {
	        if (link.toLowerCase().indexOf('javascript')!==-1) {
	            return true;
	        }
	        return false;
	    };
	
	    taRegisterTool('insertImage', {
	        iconclass: 'fa fa-picture-o',
	        tooltiptext: taTranslations.insertImage.tooltip,
	        action: function(){
	            var imageLink;
	            imageLink = $window.prompt(taTranslations.insertImage.dialogPrompt, 'http://');
	            if(imageLink && imageLink !== '' && imageLink !== 'http://'){
	                /* istanbul ignore next: don't know how to test this... since it needs a dialogPrompt */
	                // block javascript here
	                if (!blockJavascript(imageLink)) {
	                    if (taSelection.getSelectionElement().tagName && taSelection.getSelectionElement().tagName.toLowerCase() === 'a') {
	                        // due to differences in implementation between FireFox and Chrome, we must move the
	                        // insertion point past the <a> element, otherwise FireFox inserts inside the <a>
	                        // With this change, both FireFox and Chrome behave the same way!
	                        taSelection.setSelectionAfterElement(taSelection.getSelectionElement());
	                    }
	                    // In the past we used the simple statement:
	                    //return this.$editor().wrapSelection('insertImage', imageLink, true);
	                    //
	                    // However on Firefox only, when the content is empty this is a problem
	                    // See Issue #1201
	                    // Investigation reveals that Firefox only inserts a <p> only!!!!
	                    // So now we use insertHTML here and all is fine.
	                    // NOTE: this is what 'insertImage' is supposed to do anyway!
	                    var embed = '<img src="' + imageLink + '">';
	                    return this.$editor().wrapSelection('insertHTML', embed, true);
	                }
	            }
	        },
	        onElementSelect: {
	            element: 'img',
	            action: taToolFunctions.imgOnSelectAction
	        }
	    });
	    taRegisterTool('insertVideo', {
	        iconclass: 'fa fa-youtube-play',
	        tooltiptext: taTranslations.insertVideo.tooltip,
	        action: function(){
	            var urlPrompt;
	            urlPrompt = $window.prompt(taTranslations.insertVideo.dialogPrompt, 'https://');
	            // block javascript here
	            /* istanbul ignore else: if it's javascript don't worry - though probably should show some kind of error message */
	            if (!blockJavascript(urlPrompt)) {
	
	                if (urlPrompt && urlPrompt !== '' && urlPrompt !== 'https://') {
	
	                    videoId = taToolFunctions.extractYoutubeVideoId(urlPrompt);
	
	                    /* istanbul ignore else: if it's invalid don't worry - though probably should show some kind of error message */
	                    if (videoId) {
	                        // create the embed link
	                        var urlLink = "https://www.youtube.com/embed/" + videoId;
	                        // create the HTML
	                        // for all options see: http://stackoverflow.com/questions/2068344/how-do-i-get-a-youtube-video-thumbnail-from-the-youtube-api
	                        // maxresdefault.jpg seems to be undefined on some.
	                        var embed = '<img class="ta-insert-video" src="https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg" ta-insert-video="' + urlLink + '" contenteditable="false" allowfullscreen="true" frameborder="0" />';
	                        /* istanbul ignore next: don't know how to test this... since it needs a dialogPrompt */
	                        if (taSelection.getSelectionElement().tagName && taSelection.getSelectionElement().tagName.toLowerCase() === 'a') {
	                            // due to differences in implementation between FireFox and Chrome, we must move the
	                            // insertion point past the <a> element, otherwise FireFox inserts inside the <a>
	                            // With this change, both FireFox and Chrome behave the same way!
	                            taSelection.setSelectionAfterElement(taSelection.getSelectionElement());
	                        }
	                        // insert
	                        return this.$editor().wrapSelection('insertHTML', embed, true);
	                    }
	                }
	            }
	        },
	        onElementSelect: {
	            element: 'img',
	            onlyWithAttrs: ['ta-insert-video'],
	            action: taToolFunctions.imgOnSelectAction
	        }
	    });
	    taRegisterTool('insertLink', {
	        tooltiptext: taTranslations.insertLink.tooltip,
	        iconclass: 'fa fa-link',
	        action: function(){
	            var urlLink;
	            // if this link has already been set, we need to just edit the existing link
	            /* istanbul ignore if: we do not test this */
	            if (taSelection.getSelectionElement().tagName && taSelection.getSelectionElement().tagName.toLowerCase() === 'a') {
	                urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, taSelection.getSelectionElement().href);
	            } else {
	                urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, 'http://');
	            }
	            if(urlLink && urlLink !== '' && urlLink !== 'http://'){
	                // block javascript here
	                /* istanbul ignore else: if it's javascript don't worry - though probably should show some kind of error message */
	                if (!blockJavascript(urlLink)) {
	                    return this.$editor().wrapSelection('createLink', urlLink, true);
	                }
	            }
	        },
	        activeState: function(commonElement){
	            if(commonElement) return commonElement[0].tagName === 'A';
	            return false;
	        },
	        onElementSelect: {
	            element: 'a',
	            action: taToolFunctions.aOnSelectAction
	        }
	    });
	    taRegisterTool('wordcount', {
	        display: '<div id="toolbarWC" style="display:block; min-width:100px;">Words: <span ng-bind="wordcount"></span></div>',
	        disabled: true,
	        wordcount: 0,
	        activeState: function(){ // this fires on keyup
	            var textElement = this.$editor().displayElements.text;
	            /* istanbul ignore next: will default to '' when undefined */
	            var workingHTML = textElement[0].innerHTML || '';
	            var noOfWords = 0;
	
	            /* istanbul ignore if: will default to '' when undefined */
	            if (workingHTML.replace(/\s*<[^>]*?>\s*/g, '') !== '') {
	                if (workingHTML.trim() !== '') {
	                    noOfWords = workingHTML.replace(/<\/?(b|i|em|strong|span|u|strikethrough|a|img|small|sub|sup|label)( [^>*?])?>/gi, '') // remove inline tags without adding spaces
	                        .replace(/(<[^>]*?>\s*<[^>]*?>)/ig, ' ') // replace adjacent tags with possible space between with a space
	                        .replace(/(<[^>]*?>)/ig, '') // remove any singular tags
	                        .replace(/\s+/ig, ' ') // condense spacing
	                        .match(/\S+/g).length; // count remaining non-space strings
	                }
	            }
	
	            //Set current scope
	            this.wordcount = noOfWords;
	            //Set editor scope
	            this.$editor().wordcount = noOfWords;
	
	            return false;
	        }
	    });
	    taRegisterTool('charcount', {
	        display: '<div id="toolbarCC" style="display:block; min-width:120px;">Characters: <span ng-bind="charcount"></span></div>',
	        disabled: true,
	        charcount: 0,
	        activeState: function(){ // this fires on keyup
	            var textElement = this.$editor().displayElements.text;
	            var sourceText = textElement[0].innerText || textElement[0].textContent; // to cover the non-jquery use case.
	
	            // Caculate number of chars
	            var noOfChars = sourceText.replace(/(\r\n|\n|\r)/gm,"").replace(/^\s+/g,' ').replace(/\s+$/g, ' ').length;
	            //Set current scope
	            this.charcount = noOfChars;
	            //Set editor scope
	            this.$editor().charcount = noOfChars;
	            return false;
	        }
	    });
	}]);
	
	/*
	@license textAngular
	Author : Austin Anderson
	License : 2013 MIT
	Version 1.5.16
	
	See README.md or https://github.com/fraywing/textAngular/wiki for requirements and use.
	*/
	
	/*
	Commonjs package manager support (eg componentjs).
	*/
	
	
	"use strict";// NOTE: textAngularVersion must match the Gruntfile.js 'setVersion' task.... and have format v/d+./d+./d+
	var textAngularVersion = 'v1.5.16';   // This is automatically updated during the build process to the current release!
	
	
	// IE version detection - http://stackoverflow.com/questions/4169160/javascript-ie-detection-why-not-use-simple-conditional-comments
	// We need this as IE sometimes plays funny tricks with the contenteditable.
	// ----------------------------------------------------------
	// If you're not in IE (or IE version is less than 5) then:
	// ie === undefined
	// If you're in IE (>=5) then you can determine which version:
	// ie === 7; // IE7
	// Thus, to detect IE:
	// if (ie) {}
	// And to detect the version:
	// ie === 6 // IE6
	// ie > 7 // IE8, IE9, IE10 ...
	// ie < 9 // Anything less than IE9
	// ----------------------------------------------------------
	/* istanbul ignore next: untestable browser check */
	var _browserDetect = {
		ie: (function(){
			var undef,
				v = 3,
				div = document.createElement('div'),
				all = div.getElementsByTagName('i');
	
			while (
				div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
				all[0]
			);
	
			return v > 4 ? v : undef;
		}()),
		webkit: /AppleWebKit\/([\d.]+)/i.test(navigator.userAgent),
		isFirefox: navigator.userAgent.toLowerCase().indexOf('firefox') > -1
	};
	
	// Global to textAngular to measure performance where needed
	/* istanbul ignore next: untestable browser check */
	var performance = performance || {};
	/* istanbul ignore next: untestable browser check */
	performance.now = (function() {
		return performance.now       ||
			performance.mozNow    ||
			performance.msNow     ||
			performance.oNow      ||
			performance.webkitNow ||
			function() { return new Date().getTime(); };
	})();
	// usage is:
	// var t0 = performance.now();
	// doSomething();
	// var t1 = performance.now();
	// console.log('Took', (t1 - t0).toFixed(4), 'milliseconds to do something!');
	//
	
	// turn html into pure text that shows visiblity
	function stripHtmlToText(html)
	{
		var tmp = document.createElement("DIV");
		tmp.innerHTML = html;
		var res = tmp.textContent || tmp.innerText || '';
		res.replace('\u200B', ''); // zero width space
		res = res.trim();
		return res;
	}
	// get html
	function getDomFromHtml(html)
	{
		var tmp = document.createElement("DIV");
		tmp.innerHTML = html;
		return tmp;
	}
	
	
	// Global to textAngular REGEXP vars for block and list elements.
	
	var BLOCKELEMENTS = /^(address|article|aside|audio|blockquote|canvas|center|dd|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|noscript|ol|output|p|pre|section|table|tfoot|ul|video)$/i;
	var LISTELEMENTS = /^(ul|li|ol)$/i;
	// updated VALIDELEMENTS to include #text and span so that we can use nodeName instead of tagName
	var VALIDELEMENTS = /^(#text|span|address|article|aside|audio|blockquote|canvas|center|dd|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|noscript|ol|output|p|pre|section|table|tfoot|ul|video|li)$/i;
	
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Compatibility
	/* istanbul ignore next: trim shim for older browsers */
	if (!String.prototype.trim) {
		String.prototype.trim = function () {
			return this.replace(/^\s+|\s+$/g, '');
		};
	}
	
	/*
		Custom stylesheet for the placeholders rules.
		Credit to: http://davidwalsh.name/add-rules-stylesheets
	*/
	var sheet, addCSSRule, removeCSSRule, _addCSSRule, _removeCSSRule, _getRuleIndex;
	/* istanbul ignore else: IE <8 test*/
	if(_browserDetect.ie > 8 || _browserDetect.ie === undefined){
		var _sheets = document.styleSheets;
		/* istanbul ignore next: preference for stylesheet loaded externally */
		for(var i = 0; i < _sheets.length; i++){
			if(_sheets[i].media.length === 0 || _sheets[i].media.mediaText.match(/(all|screen)/ig)){
				if(_sheets[i].href){
					if(_sheets[i].href.match(/textangular\.(min\.|)css/ig)){
						sheet = _sheets[i];
						break;
					}
				}
			}
		}
		/* istanbul ignore next: preference for stylesheet loaded externally */
		if(!sheet){
			// this sheet is used for the placeholders later on.
			sheet = (function() {
				// Create the <style> tag
				var style = document.createElement("style");
				/* istanbul ignore else : WebKit hack :( */
				if(_browserDetect.webkit) style.appendChild(document.createTextNode(""));
	
				// Add the <style> element to the page, add as first so the styles can be overridden by custom stylesheets
				document.getElementsByTagName('head')[0].appendChild(style);
	
				return style.sheet;
			})();
		}
	
		// use as: addCSSRule("header", "float: left");
		addCSSRule = function(selector, rules) {
			return _addCSSRule(sheet, selector, rules);
		};
		_addCSSRule = function(_sheet, selector, rules){
			var insertIndex;
			var insertedRule;
			// This order is important as IE 11 has both cssRules and rules but they have different lengths - cssRules is correct, rules gives an error in IE 11
			/* istanbul ignore next: browser catches */
			if(_sheet.cssRules) insertIndex = Math.max(_sheet.cssRules.length - 1, 0);
			else if(_sheet.rules) insertIndex = Math.max(_sheet.rules.length - 1, 0);
	
			/* istanbul ignore else: untestable IE option */
			if(_sheet.insertRule) {
				_sheet.insertRule(selector + "{" + rules + "}", insertIndex);
			}
			else {
				_sheet.addRule(selector, rules, insertIndex);
			}
			/* istanbul ignore next: browser catches */
			if(sheet.rules) insertedRule = sheet.rules[insertIndex];
			else if(sheet.cssRules) insertedRule = sheet.cssRules[insertIndex];
			// return the inserted stylesheet rule
			return insertedRule;
		};
	
		_getRuleIndex = function(rule, rules) {
			var i, ruleIndex;
			for (i=0; i < rules.length; i++) {
				/* istanbul ignore else: check for correct rule */
				if (rules[i].cssText === rule.cssText) {
					ruleIndex = i;
					break;
				}
			}
			return ruleIndex;
		};
	
		removeCSSRule = function(rule){
			_removeCSSRule(sheet, rule);
		};
		/* istanbul ignore next: tests are browser specific */
		_removeCSSRule = function(sheet, rule){
			var rules = sheet.cssRules || sheet.rules;
			if(!rules || rules.length === 0) return;
			var ruleIndex = _getRuleIndex(rule, rules);
			if(sheet.removeRule){
				sheet.removeRule(ruleIndex);
			}else{
				sheet.deleteRule(ruleIndex);
			}
		};
	}
	
	angular.module('textAngular.factories', [])
	.factory('taBrowserTag', [function(){
	    return function(tag){
	        /* istanbul ignore next: ie specific test */
	        if(!tag) return (_browserDetect.ie <= 8)? 'P' : 'p';
	        else if(tag === '') return (_browserDetect.ie === undefined)? 'div' : (_browserDetect.ie <= 8)? 'P' : 'p';
	        else return (_browserDetect.ie <= 8)? tag.toUpperCase() : tag;
	    };
	}]).factory('taApplyCustomRenderers', ['taCustomRenderers', 'taDOM', function(taCustomRenderers, taDOM){
	    return function(val){
	        var element = angular.element('<div></div>');
	        element[0].innerHTML = val;
	
	        angular.forEach(taCustomRenderers, function(renderer){
	            var elements = [];
	            // get elements based on what is defined. If both defined do secondary filter in the forEach after using selector string
	            if(renderer.selector && renderer.selector !== '')
	                elements = element.find(renderer.selector);
	            /* istanbul ignore else: shouldn't fire, if it does we're ignoring everything */
	            else if(renderer.customAttribute && renderer.customAttribute !== '')
	                elements = taDOM.getByAttribute(element, renderer.customAttribute);
	            // process elements if any found
	            angular.forEach(elements, function(_element){
	                _element = angular.element(_element);
	                if(renderer.selector && renderer.selector !== '' && renderer.customAttribute && renderer.customAttribute !== ''){
	                    if(_element.attr(renderer.customAttribute) !== undefined) renderer.renderLogic(_element);
	                } else renderer.renderLogic(_element);
	            });
	        });
	
	        return element[0].innerHTML;
	    };
	}]).factory('taFixChrome', function(){
	    // get whaterever rubbish is inserted in chrome
	    // should be passed an html string, returns an html string
	    var taFixChrome = function(html, keepStyles){
	        if(!html || !angular.isString(html) || html.length <= 0) return html;
	        // grab all elements with a style attibute
	        // a betterSpanMatch matches only a style=... with matching quotes
	        // this captures the whole:
	        // 'style="background-color: rgb(255, 255, 255);"'
	        var betterSpanMatch = /style\s?=\s?(["'])(?:(?=(\\?))\2.)*?\1/ig;
	        // where the original spanMatch = /<([^>\/]+?)style=("([^\"]+)"|'([^']+)')([^>]*)>/ig;
	        // captures too much and includes the front tag!
	        var spanMatch = /<([^>\/]+?)style=("([^\"]+)"|'([^']+)')([^>]*)>/ig;
	        var appleConvertedSpaceMatch = /<span class="Apple-converted-space">([^<]+)<\/span>/ig;
	        var match, styleVal, appleSpaceVal, newTag, finalHtml = '', lastIndex = 0;
	        // remove all the Apple-converted-space spans and replace with the content of the span
	        //console.log('before:', html);
	        /* istanbul ignore next: apple-contereted-space span match */
	        while(match = appleConvertedSpaceMatch.exec(html)){
	            appleSpaceVal = match[1];
	            appleSpaceVal = appleSpaceVal.replace(/&nbsp;/ig, ' ');
	            finalHtml += html.substring(lastIndex, match.index) + appleSpaceVal;
	            lastIndex = match.index + match[0].length;
	        }
	        /* istanbul ignore next: apple-contereted-space span has matched */
	        if (lastIndex) {
	            // modified....
	            finalHtml += html.substring(lastIndex);
	            html=finalHtml;
	            finalHtml='';
	            lastIndex=0;
	        }
	        /////////////////////////////////////////////////////////////
	        //
	        // Allow control of this modification
	        // taKeepStyles: False - removes these modification
	        //
	        // taFixChrome removes the following styles:
	        //    font-family: inherit;
	        //    line-height: <number>
	        //    color: inherit;
	        //    color: rgb( <rgb-component>#{3} )
	        //    background-color: rgb( <rgb-component>#{3} )
	        //
	        /////////////////////////////////////////////////////////////
	        if (!keepStyles) {
	            while (match = betterSpanMatch.exec(html)) {
	                finalHtml += html.substring(lastIndex, match.index-1);
	                styleVal = match[0];
	                // test for chrome inserted junk
	                match = /font-family: inherit;|line-height: 1.[0-9]{3,12};|color: inherit; line-height: 1.1;|color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);|background-color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);/gi.exec(styleVal);
	                if (match) {
	                    styleVal = styleVal.replace(/( |)font-family: inherit;|( |)line-height: 1.[0-9]{3,12};|( |)color: inherit;|( |)color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);|( |)background-color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);/ig, '');
	                    //console.log(styleVal, styleVal.length);
	                    if (styleVal.length > 8) {
	                        finalHtml += ' ' + styleVal;
	                    }
	                } else {
	                    finalHtml += ' ' + styleVal;
	                }
	                lastIndex = betterSpanMatch.lastIndex;
	            }
	            finalHtml += html.substring(lastIndex);
	        }
	        //console.log('final:', finalHtml);
	        // only replace when something has changed, else we get focus problems on inserting lists
	        if(lastIndex > 0){
	            // replace all empty strings
	            var fe = finalHtml.replace(/<span\s?>(.*?)<\/span>(<br(\/|)>|)/ig, '$1');
	            return fe;
	        } else return html;
	    };
	    return taFixChrome;
	}).factory('taSanitize', ['$sanitize', function taSanitizeFactory($sanitize){
	
	    var convert_infos = [
	        {
	            property: 'font-weight',
	            values: [ 'bold' ],
	            tag: 'b'
	        },
	        {
	            property: 'font-style',
	            values: [ 'italic' ],
	            tag: 'i'
	        }
	    ];
	
	    var styleMatch = [];
	    for(var i = 0; i < convert_infos.length; i++){
	        var _partialStyle = '(' + convert_infos[i].property + ':\\s*(';
	        for(var j = 0; j < convert_infos[i].values.length; j++){
	            /* istanbul ignore next: not needed to be tested yet */
	            if(j > 0) _partialStyle += '|';
	            _partialStyle += convert_infos[i].values[j];
	        }
	        _partialStyle += ');)';
	        styleMatch.push(_partialStyle);
	    }
	    var styleRegexString = '(' + styleMatch.join('|') + ')';
	
	    function wrapNested(html, wrapTag) {
	        var depth = 0;
	        var lastIndex = 0;
	        var match;
	        var tagRegex = /<[^>]*>/ig;
	        while(match = tagRegex.exec(html)){
	            lastIndex = match.index;
	            if(match[0].substr(1, 1) === '/'){
	                if(depth === 0) break;
	                else depth--;
	            }else depth++;
	        }
	        return wrapTag +
	            html.substring(0, lastIndex) +
	            // get the start tags reversed - this is safe as we construct the strings with no content except the tags
	            angular.element(wrapTag)[0].outerHTML.substring(wrapTag.length) +
	            html.substring(lastIndex);
	    }
	
	    function transformLegacyStyles(html){
	        if(!html || !angular.isString(html) || html.length <= 0) return html;
	        var i;
	        var styleElementMatch = /<([^>\/]+?)style=("([^"]+)"|'([^']+)')([^>]*)>/ig;
	        var match, subMatch, styleVal, newTag, lastNewTag = '', newHtml, finalHtml = '', lastIndex = 0;
	        while(match = styleElementMatch.exec(html)){
	            // one of the quoted values ' or "
	            /* istanbul ignore next: quotations match */
	            styleVal = match[3] || match[4];
	            var styleRegex = new RegExp(styleRegexString, 'i');
	            // test for style values to change
	            if(angular.isString(styleVal) && styleRegex.test(styleVal)){
	                // remove build tag list
	                newTag = '';
	                // init regex here for exec
	                var styleRegexExec = new RegExp(styleRegexString, 'ig');
	                // find relevand tags and build a string of them
	                while(subMatch = styleRegexExec.exec(styleVal)){
	                    for(i = 0; i < convert_infos.length; i++){
	                        if(!!subMatch[(i*2) + 2]){
	                            newTag += '<' + convert_infos[i].tag + '>';
	                        }
	                    }
	                }
	                // recursively find more legacy styles in html before this tag and after the previous match (if any)
	                newHtml = transformLegacyStyles(html.substring(lastIndex, match.index));
	                // build up html
	                if(lastNewTag.length > 0){
	                    finalHtml += wrapNested(newHtml, lastNewTag);
	                }else finalHtml += newHtml;
	                // grab the style val without the transformed values
	                styleVal = styleVal.replace(new RegExp(styleRegexString, 'ig'), '');
	                // build the html tag
	                finalHtml += '<' + match[1].trim();
	                if(styleVal.length > 0) finalHtml += ' style="' + styleVal + '"';
	                finalHtml += match[5] + '>';
	                // update the start index to after this tag
	                lastIndex = match.index + match[0].length;
	                lastNewTag = newTag;
	            }
	        }
	        if(lastNewTag.length > 0){
	            finalHtml += wrapNested(html.substring(lastIndex), lastNewTag);
	        }
	        else finalHtml += html.substring(lastIndex);
	        return finalHtml;
	    }
	
	    function transformLegacyAttributes(html){
	        if(!html || !angular.isString(html) || html.length <= 0) return html;
	        // replace all align='...' tags with text-align attributes
	        var attrElementMatch = /<([^>\/]+?)align=("([^"]+)"|'([^']+)')([^>]*)>/ig;
	        var match, finalHtml = '', lastIndex = 0;
	        // match all attr tags
	        while(match = attrElementMatch.exec(html)){
	            // add all html before this tag
	            finalHtml += html.substring(lastIndex, match.index);
	            // record last index after this tag
	            lastIndex = match.index + match[0].length;
	            // construct tag without the align attribute
	            var newTag = '<' + match[1] + match[5];
	            // add the style attribute
	            if(/style=("([^"]+)"|'([^']+)')/ig.test(newTag)){
	                /* istanbul ignore next: quotations match */
	                newTag = newTag.replace(/style=("([^"]+)"|'([^']+)')/i, 'style="$2$3 text-align:' + (match[3] || match[4]) + ';"');
	            }else{
	                /* istanbul ignore next: quotations match */
	                newTag += ' style="text-align:' + (match[3] || match[4]) + ';"';
	            }
	            newTag += '>';
	            // add to html
	            finalHtml += newTag;
	        }
	        // return with remaining html
	        return finalHtml + html.substring(lastIndex);
	    }
	
	    // use precompiled regexp for speed
	    var rsb1 = new RegExp(/<span id="selectionBoundary_\d+_\d+" class="rangySelectionBoundary">[^<>]+?<\/span>/ig);
	    var rsb2 = new RegExp(/<span class="rangySelectionBoundary" id="selectionBoundary_\d+_\d+">[^<>]+?<\/span>/ig);
	    var rsb3 = new RegExp(/<span id="selectionBoundary_\d+_\d+" class="rangySelectionBoundary">[^<>]+?<\/span>/ig);
	
	    return function taSanitize(unsafe, oldsafe, ignore){
	        // unsafe html should NEVER built into a DOM object via angular.element. This allows XSS to be inserted and run.
	        if ( !ignore ) {
	            try {
	                unsafe = transformLegacyStyles(unsafe);
	            } catch (e) {
	            }
	        }
	
	        // unsafe and oldsafe should be valid HTML strings
	        // any exceptions (lets say, color for example) should be made here but with great care
	        // setup unsafe element for modification
	        unsafe = transformLegacyAttributes(unsafe);
	
	        // we had an issue in the past, where we dumped a whole bunch of <span>'s into the content...
	        // so we remove them here
	        // IN A FUTURE release this can be removed after all have updated through release 1.5.9
	        if (unsafe) {
	            try {
	                unsafe = unsafe.replace(rsb1, '');
	                unsafe = unsafe.replace(rsb2, '');
	                unsafe = unsafe.replace(rsb1, '');
	                unsafe = unsafe.replace(rsb3, '');
	            } catch (e) {
	            }
	        }
	
	        var safe;
	        try {
	            safe = $sanitize(unsafe);
	            // do this afterwards, then the $sanitizer should still throw for bad markup
	            if(ignore) safe = unsafe;
	        } catch (e){
	            safe = oldsafe || '';
	        }
	
	        // Do processing for <pre> tags, removing tabs and return carriages outside of them
	
	        var _preTags = safe.match(/(<pre[^>]*>.*?<\/pre[^>]*>)/ig);
	        var processedSafe = safe.replace(/(&#(9|10);)*/ig, '');
	        var re = /<pre[^>]*>.*?<\/pre[^>]*>/ig;
	        var index = 0;
	        var lastIndex = 0;
	        var origTag;
	        safe = '';
	        while((origTag = re.exec(processedSafe)) !== null && index < _preTags.length){
	            safe += processedSafe.substring(lastIndex, origTag.index) + _preTags[index];
	            lastIndex = origTag.index + origTag[0].length;
	            index++;
	        }
	        return safe + processedSafe.substring(lastIndex);
	    };
	}]).factory('taToolExecuteAction', ['$q', '$log', function($q, $log){
	    // this must be called on a toolScope or instance
	    return function(editor){
	        if(editor !== undefined) this.$editor = function(){ return editor; };
	        var deferred = $q.defer(),
	            promise = deferred.promise,
	            _editor = this.$editor();
	        // pass into the action the deferred function and also the function to reload the current selection if rangy available
	        var result;
	        try{
	            result = this.action(deferred, _editor.startAction());
	            // We set the .finally callback here to make sure it doesn't get executed before any other .then callback.
	            promise['finally'](function(){
	                _editor.endAction.call(_editor);
	            });
	        }catch(exc){
	            $log.error(exc);
	        }
	        if(result || result === undefined){
	            // if true or undefined is returned then the action has finished. Otherwise the deferred action will be resolved manually.
	            deferred.resolve();
	        }
	    };
	}]);
	
	angular.module('textAngular.DOM', ['textAngular.factories'])
	.factory('taExecCommand', ['taSelection', 'taBrowserTag', '$document', function(taSelection, taBrowserTag, $document){
	    var listToDefault = function(listElement, defaultWrap){
	        var $target, i;
	        // if all selected then we should remove the list
	        // grab all li elements and convert to taDefaultWrap tags
	        var children = listElement.find('li');
	        for(i = children.length - 1; i >= 0; i--){
	            $target = angular.element('<' + defaultWrap + '>' + children[i].innerHTML + '</' + defaultWrap + '>');
	            listElement.after($target);
	        }
	        listElement.remove();
	        taSelection.setSelectionToElementEnd($target[0]);
	    };
	    var listElementToSelfTag = function(list, listElement, selfTag, bDefault, defaultWrap){
	        var $target, i;
	        // if all selected then we should remove the list
	        // grab all li elements
	        var priorElement;
	        var nextElement;
	        var children = list.find('li');
	        var foundIndex;
	        for (i = 0; i<children.length; i++) {
	            if (children[i].outerHTML === listElement[0].outerHTML) {
	                // found it...
	                foundIndex = i;
	                if (i>0) {
	                    priorElement = children[i-1];
	                }
	                if (i+1<children.length) {
	                    nextElement = children[i+1];
	                }
	                break;
	            }
	        }
	        //console.log('listElementToSelfTag', list, listElement, selfTag, bDefault, priorElement, nextElement);
	        // un-list the listElement
	        var html = '';
	        if (bDefault) {
	            html += '<' + defaultWrap + '>' + listElement[0].innerHTML + '</' + defaultWrap + '>';
	        } else {
	            html += '<' + taBrowserTag(selfTag) + '>';
	            html += '<li>' + listElement[0].innerHTML + '</li>';
	            html += '</' + taBrowserTag(selfTag) + '>';
	        }
	        $target = angular.element(html);
	        //console.log('$target', $target[0]);
	        if (!priorElement) {
	            // this is the first the list, so we just remove it...
	            listElement.remove();
	            list.after(angular.element(list[0].outerHTML));
	            list.after($target);
	            list.remove();
	            taSelection.setSelectionToElementEnd($target[0]);
	            return;
	        } else if (!nextElement) {
	            // this is the last in the list, so we just remove it..
	            listElement.remove();
	            list.after($target);
	            taSelection.setSelectionToElementEnd($target[0]);
	        } else {
	            var p = list.parent();
	            // okay it was some where in the middle... so we need to break apart the list...
	            var html1 = '';
	            var listTag = list[0].nodeName.toLowerCase();
	            html1 += '<' + listTag + '>';
	            for(i = 0; i < foundIndex; i++){
	                html1 += '<li>' + children[i].innerHTML + '</li>';
	            }
	            html1 += '</' + listTag + '>';
	            var html2 = '';
	            html2 += '<' + listTag + '>';
	            for(i = foundIndex+1; i < children.length; i++){
	                html2 += '<li>' + children[i].innerHTML + '</li>';
	            }
	            html2 += '</' + listTag + '>';
	            //console.log(html1, $target[0], html2);
	            list.after(angular.element(html2));
	            list.after($target);
	            list.after(angular.element(html1));
	            list.remove();
	            //console.log('parent ******XXX*****', p[0]);
	            taSelection.setSelectionToElementEnd($target[0]);
	        }
	    };
	    var listElementsToSelfTag = function(list, listElements, selfTag, bDefault, defaultWrap){
	        var $target, i, j, p;
	        // grab all li elements
	        var priorElement;
	        var afterElement;
	        //console.log('list:', list, 'listElements:', listElements, 'selfTag:', selfTag, 'bDefault:', bDefault);
	        var children = list.find('li');
	        var foundIndexes = [];
	        for (i = 0; i<children.length; i++) {
	            for (j = 0; j<listElements.length; j++) {
	                if (children[i].isEqualNode(listElements[j])) {
	                    // found it...
	                    foundIndexes[j] = i;
	                }
	            }
	        }
	        if (foundIndexes[0] > 0) {
	            priorElement = children[foundIndexes[0] - 1];
	        }
	        if (foundIndexes[listElements.length-1] + 1 < children.length) {
	            afterElement = children[foundIndexes[listElements.length-1] + 1];
	        }
	        //console.log('listElementsToSelfTag', list, listElements, selfTag, bDefault, !priorElement, !afterElement, foundIndexes[listElements.length-1], children.length);
	        // un-list the listElements
	        var html = '';
	        if (bDefault) {
	            for (j = 0; j < listElements.length; j++) {
	                html += '<' + defaultWrap + '>' + listElements[j].innerHTML + '</' + defaultWrap + '>';
	                listElements[j].remove();
	            }
	        } else {
	            html += '<' + taBrowserTag(selfTag) + '>';
	            for (j = 0; j < listElements.length; j++) {
	                html += listElements[j].outerHTML;
	                listElements[j].remove();
	            }
	            html += '</' + taBrowserTag(selfTag) + '>';
	        }
	        $target = angular.element(html);
	        if (!priorElement) {
	            // this is the first the list, so we just remove it...
	            list.after(angular.element(list[0].outerHTML));
	            list.after($target);
	            list.remove();
	            taSelection.setSelectionToElementEnd($target[0]);
	            return;
	        } else if (!afterElement) {
	            // this is the last in the list, so we just remove it..
	            list.after($target);
	            taSelection.setSelectionToElementEnd($target[0]);
	            return;
	        } else {
	            // okay it was some where in the middle... so we need to break apart the list...
	            var html1 = '';
	            var listTag = list[0].nodeName.toLowerCase();
	            html1 += '<' + listTag + '>';
	            for(i = 0; i < foundIndexes[0]; i++){
	                html1 += '<li>' + children[i].innerHTML + '</li>';
	            }
	            html1 += '</' + listTag + '>';
	            var html2 = '';
	            html2 += '<' + listTag + '>';
	            for(i = foundIndexes[listElements.length-1]+1; i < children.length; i++){
	                html2 += '<li>' + children[i].innerHTML + '</li>';
	            }
	            html2 += '</' + listTag + '>';
	            list.after(angular.element(html2));
	            list.after($target);
	            list.after(angular.element(html1));
	            list.remove();
	            //console.log('parent ******YYY*****', list.parent()[0]);
	            taSelection.setSelectionToElementEnd($target[0]);
	        }
	    };
	    var selectLi = function(liElement){
	        if(/(<br(|\/)>)$/i.test(liElement.innerHTML.trim())) taSelection.setSelectionBeforeElement(angular.element(liElement).find("br")[0]);
	        else taSelection.setSelectionToElementEnd(liElement);
	    };
	    var listToList = function(listElement, newListTag){
	        var $target = angular.element('<' + newListTag + '>' + listElement[0].innerHTML + '</' + newListTag + '>');
	        listElement.after($target);
	        listElement.remove();
	        selectLi($target.find('li')[0]);
	    };
	    var childElementsToList = function(elements, listElement, newListTag){
	        var html = '';
	        for(var i = 0; i < elements.length; i++){
	            html += '<' + taBrowserTag('li') + '>' + elements[i].innerHTML + '</' + taBrowserTag('li') + '>';
	        }
	        var $target = angular.element('<' + newListTag + '>' + html + '</' + newListTag + '>');
	        listElement.after($target);
	        listElement.remove();
	        selectLi($target.find('li')[0]);
	    };
	    var turnBlockIntoBlocks = function(element, options) {
	        for(var i = 0; i<element.childNodes.length; i++) {
	            var _n = element.childNodes[i];
	            /* istanbul ignore next - more complex testing*/
	            if (_n.tagName && _n.tagName.match(BLOCKELEMENTS)) {
	                turnBlockIntoBlocks(_n, options);
	            }
	        }
	        /* istanbul ignore next - very rare condition that we do not test*/
	        if (element.parentNode === null) {
	            // nothing left to do..
	            return element;
	        }
	        /* istanbul ignore next - not sure have to test this */
	        if (options === '<br>'){
	            return element;
	        }
	        else {
	            var $target = angular.element(options);
	            $target[0].innerHTML = element.innerHTML;
	            element.parentNode.insertBefore($target[0], element);
	            element.parentNode.removeChild(element);
	            return $target;
	        }
	    };
	    return function(taDefaultWrap, topNode){
	        // NOTE: here we are dealing with the html directly from the browser and not the html the user sees.
	        // IF you want to modify the html the user sees, do it when the user does a switchView
	        taDefaultWrap = taBrowserTag(taDefaultWrap);
	        return function(command, showUI, options, defaultTagAttributes){
	            var i, $target, html, _nodes, next, optionsTagName, selectedElement, ourSelection;
	            var defaultWrapper = angular.element('<' + taDefaultWrap + '>');
	            try{
	                if (taSelection.getSelection) {
	                    ourSelection = taSelection.getSelection();
	                }
	                selectedElement = taSelection.getSelectionElement();
	                // special checks and fixes when we are selecting the whole container
	                var __h, _innerNode;
	                /* istanbul ignore next */
	                if (selectedElement.tagName !== undefined) {
	                    if (selectedElement.tagName.toLowerCase() === 'div' &&
	                        /taTextElement.+/.test(selectedElement.id) &&
	                        ourSelection && ourSelection.start &&
	                        ourSelection.start.offset === 1 &&
	                        ourSelection.end.offset === 1) {
	                        // opps we are actually selecting the whole container!
	                        //console.log('selecting whole container!');
	                        __h = selectedElement.innerHTML;
	                        if (/<br>/i.test(__h)) {
	                            // Firefox adds <br>'s and so we remove the <br>
	                            __h = __h.replace(/<br>/i, '&#8203;');  // no space-space
	                        }
	                        if (/<br\/>/i.test(__h)) {
	                            // Firefox adds <br/>'s and so we remove the <br/>
	                            __h = __h.replace(/<br\/>/i, '&#8203;');  // no space-space
	                        }
	                        // remove stacked up <span>'s
	                        if (/<span>(<span>)+/i.test(__h)) {
	                            __h = __.replace(/<span>(<span>)+/i, '<span>');
	                        }
	                        // remove stacked up </span>'s
	                        if (/<\/span>(<\/span>)+/i.test(__h)) {
	                            __h = __.replace(/<\/span>(<\/span>)+/i, '<\/span>');
	                        }
	                        if (/<span><\/span>/i.test(__h)) {
	                            // if we end up with a <span></span> here we remove it...
	                            __h = __h.replace(/<span><\/span>/i, '');
	                        }
	                        //console.log('inner whole container', selectedElement.childNodes);
	                        _innerNode = '<div>' + __h + '</div>';
	                        selectedElement.innerHTML = _innerNode;
	                        taSelection.setSelectionToElementEnd(selectedElement.childNodes[0]);
	                        selectedElement = taSelection.getSelectionElement();
	                    } else if (selectedElement.tagName.toLowerCase() === 'span' &&
	                        ourSelection && ourSelection.start &&
	                        ourSelection.start.offset === 1 &&
	                        ourSelection.end.offset === 1) {
	                        // just a span -- this is a problem...
	                        //console.log('selecting span!');
	                        __h = selectedElement.innerHTML;
	                        if (/<br>/i.test(__h)) {
	                            // Firefox adds <br>'s and so we remove the <br>
	                            __h = __h.replace(/<br>/i, '&#8203;');  // no space-space
	                        }
	                        if (/<br\/>/i.test(__h)) {
	                            // Firefox adds <br/>'s and so we remove the <br/>
	                            __h = __h.replace(/<br\/>/i, '&#8203;');  // no space-space
	                        }
	                        // remove stacked up <span>'s
	                        if (/<span>(<span>)+/i.test(__h)) {
	                            __h = __.replace(/<span>(<span>)+/i, '<span>');
	                        }
	                        // remove stacked up </span>'s
	                        if (/<\/span>(<\/span>)+/i.test(__h)) {
	                            __h = __.replace(/<\/span>(<\/span>)+/i, '<\/span>');
	                        }
	                        if (/<span><\/span>/i.test(__h)) {
	                            // if we end up with a <span></span> here we remove it...
	                            __h = __h.replace(/<span><\/span>/i, '');
	                        }
	                        //console.log('inner span', selectedElement.childNodes);
	                        // we wrap this in a <div> because otherwise the browser get confused when we attempt to select the whole node
	                        // and the focus is not set correctly no matter what we do
	                        _innerNode = '<div>' + __h + '</div>';
	                        selectedElement.innerHTML = _innerNode;
	                        taSelection.setSelectionToElementEnd(selectedElement.childNodes[0]);
	                        selectedElement = taSelection.getSelectionElement();
	                        //console.log(selectedElement.innerHTML);
	                    } else if (selectedElement.tagName.toLowerCase() === 'p' &&
	                        ourSelection && ourSelection.start &&
	                        ourSelection.start.offset === 1 &&
	                        ourSelection.end.offset === 1) {
	                        //console.log('p special');
	                        // we need to remove the </br> that firefox adds!
	                        __h = selectedElement.innerHTML;
	                        if (/<br>/i.test(__h)) {
	                            // Firefox adds <br>'s and so we remove the <br>
	                            __h = __h.replace(/<br>/i, '&#8203;');  // no space-space
	                            selectedElement.innerHTML = __h;
	                        }
	                    } else if (selectedElement.tagName.toLowerCase() === 'li' &&
	                        ourSelection && ourSelection.start &&
	                        ourSelection.start.offset === ourSelection.end.offset) {
	                        // we need to remove the </br> that firefox adds!
	                        __h = selectedElement.innerHTML;
	                        if (/<br>/i.test(__h)) {
	                            // Firefox adds <br>'s and so we remove the <br>
	                            __h = __h.replace(/<br>/i, '');  // nothing
	                            selectedElement.innerHTML = __h;
	                        }
	                    }
	                }
	            }catch(e){}
	            //console.log('************** selectedElement:', selectedElement);
	            /* istanbul ignore if: */
	            if (!selectedElement){return;}
	            var $selected = angular.element(selectedElement);
	            var tagName = (selectedElement && selectedElement.tagName && selectedElement.tagName.toLowerCase()) ||
	                /* istanbul ignore next: */ "";
	            if(command.toLowerCase() === 'insertorderedlist' || command.toLowerCase() === 'insertunorderedlist'){
	                var selfTag = taBrowserTag((command.toLowerCase() === 'insertorderedlist')? 'ol' : 'ul');
	                var selectedElements = taSelection.getOnlySelectedElements();
	                //console.log('PPPPPPPPPPPPP', tagName, selfTag, selectedElements, tagName.match(BLOCKELEMENTS), $selected.hasClass('ta-bind'), $selected.parent()[0].tagName);
	                if (selectedElements.length>1 && (tagName === 'ol' ||  tagName === 'ul' )) {
	                    return listElementsToSelfTag($selected, selectedElements, selfTag, selfTag===tagName, taDefaultWrap);
	                }
	                if(tagName === selfTag){
	                    // if all selected then we should remove the list
	                    // grab all li elements and convert to taDefaultWrap tags
	                    //console.log('tagName===selfTag');
	                    if ($selected[0].childNodes.length !== selectedElements.length && selectedElements.length===1) {
	                        $selected = angular.element(selectedElements[0]);
	                        return listElementToSelfTag($selected.parent(), $selected, selfTag, true, taDefaultWrap);
	                    } else {
	                        return listToDefault($selected, taDefaultWrap);
	                    }
	                }else if(tagName === 'li' &&
	                    $selected.parent()[0].tagName.toLowerCase() === selfTag &&
	                    $selected.parent().children().length === 1){
	                    // catch for the previous statement if only one li exists
	                    return listToDefault($selected.parent(), taDefaultWrap);
	                }else if(tagName === 'li' &&
	                    $selected.parent()[0].tagName.toLowerCase() !== selfTag &&
	                    $selected.parent().children().length === 1){
	                    // catch for the previous statement if only one li exists
	                    return listToList($selected.parent(), selfTag);
	                }else if(tagName.match(BLOCKELEMENTS) && !$selected.hasClass('ta-bind')){
	                    // if it's one of those block elements we have to change the contents
	                    // if it's a ol/ul we are changing from one to the other
	                    if (selectedElements.length) {
	                        if ($selected[0].childNodes.length !== selectedElements.length && selectedElements.length===1) {
	                            //console.log('&&&&&&&&&&&&&&& --------- &&&&&&&&&&&&&&&&', selectedElements[0], $selected[0].childNodes);
	                            $selected = angular.element(selectedElements[0]);
	                            return listElementToSelfTag($selected.parent(), $selected, selfTag, selfTag===tagName, taDefaultWrap);
	                        }
	                    }
	                    if(tagName === 'ol' || tagName === 'ul'){
	                        // now if this is a set of selected elements... behave diferently
	                        return listToList($selected, selfTag);
	                    }else{
	                        var childBlockElements = false;
	                        angular.forEach($selected.children(), function(elem){
	                            if(elem.tagName.match(BLOCKELEMENTS)) {
	                                childBlockElements = true;
	                            }
	                        });
	                        if(childBlockElements){
	                            return childElementsToList($selected.children(), $selected, selfTag);
	                        }else{
	                            return childElementsToList([angular.element('<div>' + selectedElement.innerHTML + '</div>')[0]], $selected, selfTag);
	                        }
	                    }
	                }else if(tagName.match(BLOCKELEMENTS)){
	                    // if we get here then the contents of the ta-bind are selected
	                    _nodes = taSelection.getOnlySelectedElements();
	                    //console.log('_nodes', _nodes, tagName);
	                    if(_nodes.length === 0){
	                        // here is if there is only text in ta-bind ie <div ta-bind>test content</div>
	                        $target = angular.element('<' + selfTag + '><li>' + selectedElement.innerHTML + '</li></' + selfTag + '>');
	                        $selected.html('');
	                        $selected.append($target);
	                    }else if(_nodes.length === 1 && (_nodes[0].tagName.toLowerCase() === 'ol' || _nodes[0].tagName.toLowerCase() === 'ul')){
	                        if(_nodes[0].tagName.toLowerCase() === selfTag){
	                            // remove
	                            return listToDefault(angular.element(_nodes[0]), taDefaultWrap);
	                        }else{
	                            return listToList(angular.element(_nodes[0]), selfTag);
	                        }
	                    }else{
	                        html = '';
	                        var $nodes = [];
	                        for(i = 0; i < _nodes.length; i++){
	                            /* istanbul ignore else: catch for real-world can't make it occur in testing */
	                            if(_nodes[i].nodeType !== 3){
	                                var $n = angular.element(_nodes[i]);
	                                /* istanbul ignore if: browser check only, phantomjs doesn't return children nodes but chrome at least does */
	                                if(_nodes[i].tagName.toLowerCase() === 'li') continue;
	                                else if(_nodes[i].tagName.toLowerCase() === 'ol' || _nodes[i].tagName.toLowerCase() === 'ul'){
	                                    html += $n[0].innerHTML; // if it's a list, add all it's children
	                                }else if(_nodes[i].tagName.toLowerCase() === 'span' && (_nodes[i].childNodes[0].tagName.toLowerCase() === 'ol' || _nodes[i].childNodes[0].tagName.toLowerCase() === 'ul')){
	                                    html += $n[0].childNodes[0].innerHTML; // if it's a list, add all it's children
	                                }else{
	                                    html += '<' + taBrowserTag('li') + '>' + $n[0].innerHTML + '</' + taBrowserTag('li') + '>';
	                                }
	                                $nodes.unshift($n);
	                            }
	                        }
	                        //console.log('$nodes', $nodes);
	                        $target = angular.element('<' + selfTag + '>' + html + '</' + selfTag + '>');
	                        $nodes.pop().replaceWith($target);
	                        angular.forEach($nodes, function($node){ $node.remove(); });
	                    }
	                    taSelection.setSelectionToElementEnd($target[0]);
	                    return;
	                }
	            }else if(command.toLowerCase() === 'formatblock'){
	                optionsTagName = options.toLowerCase().replace(/[<>]/ig, '');
	                if(optionsTagName.trim() === 'default') {
	                    optionsTagName = taDefaultWrap;
	                    options = '<' + taDefaultWrap + '>';
	                }
	                if(tagName === 'li') {
	                    $target = $selected.parent();
	                }
	                else {
	                    $target = $selected;
	                }
	                // find the first blockElement
	                while(!$target[0].tagName || !$target[0].tagName.match(BLOCKELEMENTS) && !$target.parent().attr('contenteditable')){
	                    $target = $target.parent();
	                    /* istanbul ignore next */
	                    tagName = ($target[0].tagName || '').toLowerCase();
	                }
	                if(tagName === optionsTagName){
	                    // $target is wrap element
	                    _nodes = $target.children();
	                    var hasBlock = false;
	                    for(i = 0; i < _nodes.length; i++){
	                        hasBlock = hasBlock || _nodes[i].tagName.match(BLOCKELEMENTS);
	                    }
	                    if(hasBlock){
	                        $target.after(_nodes);
	                        next = $target.next();
	                        $target.remove();
	                        $target = next;
	                    }else{
	                        defaultWrapper.append($target[0].childNodes);
	                        $target.after(defaultWrapper);
	                        $target.remove();
	                        $target = defaultWrapper;
	                    }
	                }else if($target.parent()[0].tagName.toLowerCase() === optionsTagName &&
	                    !$target.parent().hasClass('ta-bind')){
	                    //unwrap logic for parent
	                    var blockElement = $target.parent();
	                    var contents = blockElement.contents();
	                    for(i = 0; i < contents.length; i ++){
	                        /* istanbul ignore next: can't test - some wierd thing with how phantomjs works */
	                        if(blockElement.parent().hasClass('ta-bind') && contents[i].nodeType === 3){
	                            defaultWrapper = angular.element('<' + taDefaultWrap + '>');
	                            defaultWrapper[0].innerHTML = contents[i].outerHTML;
	                            contents[i] = defaultWrapper[0];
	                        }
	                        blockElement.parent()[0].insertBefore(contents[i], blockElement[0]);
	                    }
	                    blockElement.remove();
	                }else if(tagName.match(LISTELEMENTS)){
	                    // wrapping a list element
	                    $target.wrap(options);
	                }else{
	                    // default wrap behaviour
	                    _nodes = taSelection.getOnlySelectedElements();
	                    if(_nodes.length === 0) {
	                        // no nodes at all....
	                        _nodes = [$target[0]];
	                    }
	                    // find the parent block element if any of the nodes are inline or text
	                    for(i = 0; i < _nodes.length; i++){
	                        if(_nodes[i].nodeType === 3 || !_nodes[i].tagName.match(BLOCKELEMENTS)){
	                            while(_nodes[i].nodeType === 3 || !_nodes[i].tagName || !_nodes[i].tagName.match(BLOCKELEMENTS)){
	                                _nodes[i] = _nodes[i].parentNode;
	                            }
	                        }
	                    }
	                    // remove any duplicates from the array of _nodes!
	                    _nodes = _nodes.filter(function(value, index, self) {
	                        return self.indexOf(value) === index;
	                    });
	                    // remove all whole taTextElement if it is here... unless it is the only element!
	                    if (_nodes.length>1) {
	                        _nodes = _nodes.filter(function (value, index, self) {
	                            return !(value.nodeName.toLowerCase() === 'div' && /^taTextElement/.test(value.id));
	                        });
	                    }
	                    if(angular.element(_nodes[0]).hasClass('ta-bind')){
	                        $target = angular.element(options);
	                        $target[0].innerHTML = _nodes[0].innerHTML;
	                        _nodes[0].innerHTML = $target[0].outerHTML;
	                    }else if(optionsTagName === 'blockquote'){
	                        // blockquotes wrap other block elements
	                        html = '';
	                        for(i = 0; i < _nodes.length; i++){
	                            html += _nodes[i].outerHTML;
	                        }
	                        $target = angular.element(options);
	                        $target[0].innerHTML = html;
	                        _nodes[0].parentNode.insertBefore($target[0],_nodes[0]);
	                        for(i = _nodes.length - 1; i >= 0; i--){
	                            /* istanbul ignore else:  */
	                            if (_nodes[i].parentNode) _nodes[i].parentNode.removeChild(_nodes[i]);
	                        }
	                    } else /* istanbul ignore next: not tested since identical to blockquote */
	                    if (optionsTagName === 'pre' && taSelection.getStateShiftKey()) {
	                        //console.log('shift pre', _nodes);
	                        // pre wrap other block elements
	                        html = '';
	                        for (i = 0; i < _nodes.length; i++) {
	                            html += _nodes[i].outerHTML;
	                        }
	                        $target = angular.element(options);
	                        $target[0].innerHTML = html;
	                        _nodes[0].parentNode.insertBefore($target[0], _nodes[0]);
	                        for (i = _nodes.length - 1; i >= 0; i--) {
	                            /* istanbul ignore else:  */
	                            if (_nodes[i].parentNode) _nodes[i].parentNode.removeChild(_nodes[i]);
	                        }
	                    }
	                    else {
	                        //console.log(optionsTagName, _nodes);
	                        // regular block elements replace other block elements
	                        for (i = 0; i < _nodes.length; i++) {
	                            var newBlock = turnBlockIntoBlocks(_nodes[i], options);
	                            if (_nodes[i] === $target[0]) {
	                                $target = angular.element(newBlock);
	                            }
	                        }
	                    }
	                }
	                taSelection.setSelectionToElementEnd($target[0]);
	                // looses focus when we have the whole container selected and no text!
	                // refocus on the shown display element, this fixes a bug when using firefox
	                $target[0].focus();
	                return;
	            }else if(command.toLowerCase() === 'createlink'){
	                /* istanbul ignore next: firefox specific fix */
	                if (tagName === 'a') {
	                    // already a link!!! we are just replacing it...
	                    taSelection.getSelectionElement().href = options;
	                    return;
	                }
	                var tagBegin = '<a href="' + options + '" target="' +
	                        (defaultTagAttributes.a.target ? defaultTagAttributes.a.target : '') +
	                        '">',
	                    tagEnd = '</a>',
	                    _selection = taSelection.getSelection();
	                if(_selection.collapsed){
	                    //console.log('collapsed');
	                    // insert text at selection, then select then just let normal exec-command run
	                    taSelection.insertHtml(tagBegin + options + tagEnd, topNode);
	                }else if(rangy.getSelection().getRangeAt(0).canSurroundContents()){
	                    var node = angular.element(tagBegin + tagEnd)[0];
	                    rangy.getSelection().getRangeAt(0).surroundContents(node);
	                }
	                return;
	            }else if(command.toLowerCase() === 'inserthtml'){
	                //console.log('inserthtml');
	                taSelection.insertHtml(options, topNode);
	                return;
	            }
	            try{
	                $document[0].execCommand(command, showUI, options);
	            }catch(e){}
	        };
	    };
	}]).service('taSelection', ['$document', 'taDOM', '$log',
	/* istanbul ignore next: all browser specifics and PhantomJS dosen't seem to support half of it */
	function($document, taDOM, $log){
	    // need to dereference the document else the calls don't work correctly
	    var _document = $document[0];
	    var bShiftState;
	    var brException = function (element, offset) {
	        /* check if selection is a BR element at the beginning of a container. If so, get
	        * the parentNode instead.
	        * offset should be zero in this case. Otherwise, return the original
	        * element.
	        */
	        if (element.tagName && element.tagName.match(/^br$/i) && offset === 0 && !element.previousSibling) {
	            return {
	                element: element.parentNode,
	                offset: 0
	            };
	        } else {
	            return {
	                element: element,
	                offset: offset
	            };
	        }
	    };
	    var api = {
	        getSelection: function(){
	            var range;
	            try {
	                // catch any errors from rangy and ignore the issue
	                range = rangy.getSelection().getRangeAt(0);
	            } catch(e) {
	                //console.info(e);
	                return undefined;
	            }
	            var container = range.commonAncestorContainer;
	            var selection = {
	                start: brException(range.startContainer, range.startOffset),
	                end: brException(range.endContainer, range.endOffset),
	                collapsed: range.collapsed
	            };
	            // This has problems under Firefox.
	            // On Firefox with
	            // <p>Try me !</p>
	            // <ul>
	            // <li>line 1</li>
	            // <li>line 2</li>
	            // </ul>
	            // <p>line 3</p>
	            // <ul>
	            // <li>line 4</li>
	            // <li>line 5</li>
	            // </ul>
	            // <p>Hello textAngular</p>
	            // WITH the cursor after the 3 on line 3, it gets the commonAncestorContainer as:
	            // <TextNode textContent='line 3'>
	            // AND Chrome gets the commonAncestorContainer as:
	            // <p>line 3</p>
	            //
	            // Check if the container is a text node and return its parent if so
	            // unless this is the whole taTextElement.  If so we return the textNode
	            if (container.nodeType === 3) {
	                if (container.parentNode.nodeName.toLowerCase() === 'div' &&
	                    /^taTextElement/.test(container.parentNode.id)) {
	                    // textNode where the parent is the whole <div>!!!
	                    //console.log('textNode ***************** container:', container);
	                } else {
	                    container = container.parentNode;
	                }
	            }
	            if (container.nodeName.toLowerCase() === 'div' &&
	                /^taTextElement/.test(container.id)) {
	                //console.log('*********taTextElement************');
	                //console.log('commonAncestorContainer:', container);
	                selection.start.element = container.childNodes[selection.start.offset];
	                selection.end.element = container.childNodes[selection.end.offset];
	                selection.container = container;
	            } else {
	                if (container.parentNode === selection.start.element ||
	                    container.parentNode === selection.end.element) {
	                    selection.container = container.parentNode;
	                } else {
	                    selection.container = container;
	                }
	            }
	            //console.log('***selection container:', selection.container.nodeName, selection.start.offset, selection.container);
	            return selection;
	        },
	        // if we use the LEFT_ARROW and we are at the special place <span>&#65279;</span> we move the cursor over by one...
	        // Chrome and Firefox behave differently so so fix this for Firefox here.  No adjustment needed for Chrome.
	        updateLeftArrowKey: function(element) {
	            var range = rangy.getSelection().getRangeAt(0);
	            if (range && range.collapsed) {
	                var _nodes = api.getFlattenedDom(range);
	                if (!_nodes.findIndex) return;
	                var _node = range.startContainer;
	                var indexStartContainer = _nodes.findIndex(function(element, index){
	                    if (element.node===_node) return true;
	                    var _indexp = element.parents.indexOf(_node);
	                    return (_indexp !== -1);
	                });
	                var m;
	                var nextNodeToRight;
	                //console.log('indexStartContainer', indexStartContainer, _nodes.length, 'startContainer:', _node, _node === _nodes[indexStartContainer].node);
	                _nodes.forEach(function (n, i) {
	                    //console.log(i, n.node);
	                    n.parents.forEach(function (nn, j){
	                        //console.log(i, j, nn);
	                    });
	                });
	                if (indexStartContainer+1 < _nodes.length) {
	                    // we need the node just after this startContainer
	                    // so we can check and see it this is a special place
	                    nextNodeToRight = _nodes[indexStartContainer+1].node;
	                    //console.log(nextNodeToRight, range.startContainer);
	                }
	                //console.log('updateLeftArrowKey', range.startOffset, range.startContainer.textContent);
	                // this first section handles the case for Chrome browser
	                // if the first character of the nextNode is a \ufeff we know that we are just before the special span...
	                // and so we most left by one character
	                if (nextNodeToRight && nextNodeToRight.textContent) {
	                    m = /^\ufeff([^\ufeff]*)$/.exec(nextNodeToRight.textContent);
	                    if (m) {
	                        // we are before the special node with begins with a \ufeff character
	                        //console.log('LEFT ...found it...', 'startOffset:', range.startOffset, m[0].length, m[1].length);
	                        // no need to change anything in this case
	                        return;
	                    }
	                }
	                var nextNodeToLeft;
	                if (indexStartContainer > 0) {
	                    // we need the node just after this startContainer
	                    // so we can check and see it this is a special place
	                    nextNodeToLeft = _nodes[indexStartContainer-1].node;
	                    //console.log(nextNodeToLeft, nextNodeToLeft);
	                }
	                if (range.startOffset === 0 && nextNodeToLeft) {
	                    //console.log(nextNodeToLeft, range.startOffset, nextNodeToLeft.textContent);
	                    m = /^\ufeff([^\ufeff]*)$/.exec(nextNodeToLeft.textContent);
	                    if (m) {
	                        //console.log('LEFT &&&&&&&&&&&&&&&&&&&...found it...&&&&&&&&&&&', nextNodeToLeft, m[0].length, m[1].length);
	                        // move over to the left my one -- Firefox triggers this case
	                        api.setSelectionToElementEnd(nextNodeToLeft);
	                        return;
	                    }
	                }
	            }
	            return;
	        },
	        // if we use the RIGHT_ARROW and we are at the special place <span>&#65279;</span> we move the cursor over by one...
	        updateRightArrowKey: function(element) {
	            // we do not need to make any adjustments here, so we ignore all this code
	            if (false) {
	                var range = rangy.getSelection().getRangeAt(0);
	                if (range && range.collapsed) {
	                    var _nodes = api.getFlattenedDom(range);
	                    if (!_nodes.findIndex) return;
	                    var _node = range.startContainer;
	                    var indexStartContainer = _nodes.findIndex(function (element, index) {
	                        if (element.node === _node) return true;
	                        var _indexp = element.parents.indexOf(_node);
	                        return (_indexp !== -1);
	                    });
	                    var _sel;
	                    var i;
	                    var m;
	
	                    // if the last character is a \ufeff we know that we are just before the special span...
	                    // and so we most right by one character
	                    var indexFound = _nodes.findIndex(function (n, index) {
	                        if (n.textContent) {
	                            var m = /^\ufeff([^\ufeff]*)$/.exec(n.textContent);
	                            if (m) {
	                                return true;
	                            } else {
	                                return false;
	                            }
	                        } else {
	                            return false;
	                        }
	                    });
	                    if (indexFound === -1) {
	                        return;
	                    }
	                    //console.log(indexFound, range.startContainer, range.startOffset);
	                    _node = _nodes[indexStartContainer];
	                    //console.log('indexStartContainer', indexStartContainer);
	                    if (_node && _node.textContent) {
	                        m = /^\ufeff([^\ufeff]*)$/.exec(_node.textContent);
	                        if (m && range.startOffset - 1 === m[1].length) {
	                            //console.log('RIGHT found it...&&&&&&&&&&&', range.startOffset);
	                            // no need to make any adjustment
	                            return;
	                        }
	                    }
	                    //console.log(range.startOffset);
	                    if (_nodes && range.startOffset === 0) {
	                        indexStartContainer = _nodes.indexOf(range.startContainer);
	                        if (indexStartContainer !== -1 && indexStartContainer > 0) {
	                            _node = _nodes[indexStartContainer - 1];
	                            if (_node.textContent) {
	                                m = /\ufeff([^\ufeff]*)$/.exec(_node.textContent);
	                                if (m && true || range.startOffset === m[1].length + 1) {
	                                    //console.log('RIGHT &&&&&&&&&&&&&&&&&&&...found it...&&&&&&&&&&&', range.startOffset, m[1].length);
	                                    // no need to make any adjustment
	                                    return;
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        },
	        getFlattenedDom: function(range) {
	            var parent = range.commonAncestorContainer.parentNode;
	            if (!parent) {
	                return range.commonAncestorContainer.childNodes;
	            }
	            var nodes = Array.prototype.slice.call(parent.childNodes); // converts NodeList to Array
	            var indexStartContainer = nodes.indexOf(range.startContainer);
	            // make sure that we have a big enough set of nodes
	            if (indexStartContainer+1 < nodes.length && indexStartContainer > 0) {
	                // we are good
	                // we can go down one node or up one node
	            } else {
	                if (parent.parentNode) {
	                    parent = parent.parentNode;
	                }
	            }
	            // now walk the parent
	            nodes = [];
	            function addNodes(_set) {
	                if (_set.node.childNodes.length) {
	                    var childNodes = Array.prototype.slice.call(_set.node.childNodes); // converts NodeList to Array
	                    childNodes.forEach(function(n) {
	                        var _t = _set.parents.slice();
	                        if (_t.slice(-1)[0]!==_set.node) {
	                            _t.push(_set.node);
	                        }
	                        addNodes({parents: _t, node: n});
	                    });
	                } else {
	                    nodes.push({parents: _set.parents, node: _set.node});
	                }
	            }
	            addNodes({parents: [parent], node: parent});
	            return nodes;
	        },
	        getOnlySelectedElements: function(){
	            var range = rangy.getSelection().getRangeAt(0);
	            var container = range.commonAncestorContainer;
	            // Node.TEXT_NODE === 3
	            // Node.ELEMENT_NODE === 1
	            // Node.COMMENT_NODE === 8
	            // Check if the container is a text node and return its parent if so
	            container = container.nodeType === 3 ? container.parentNode : container;
	            // get the nodes in the range that are ELEMENT_NODE and are children of the container
	            // in this range...
	            return range.getNodes([1], function(node){
	                return node.parentNode === container;
	            });
	        },
	        // this includes the container element if all children are selected
	        getAllSelectedElements: function(){
	            var range = rangy.getSelection().getRangeAt(0);
	            var container = range.commonAncestorContainer;
	            // Node.TEXT_NODE === 3
	            // Node.ELEMENT_NODE === 1
	            // Node.COMMENT_NODE === 8
	            // Check if the container is a text node and return its parent if so
	            container = container.nodeType === 3 ? container.parentNode : container;
	            // get the nodes in the range that are ELEMENT_NODE and are children of the container
	            // in this range...
	            var selectedNodes = range.getNodes([1], function(node){
	                return node.parentNode === container;
	            });
	            var innerHtml = container.innerHTML;
	            // remove the junk that rangy has put down
	            innerHtml = innerHtml.replace(/<span id=.selectionBoundary[^>]+>\ufeff?<\/span>/ig, '');
	            //console.log(innerHtml);
	            //console.log(range.toHtml());
	            //console.log(innerHtml === range.toHtml());
	            if (innerHtml === range.toHtml() &&
	                // not the whole taTextElement
	                (!(container.nodeName.toLowerCase() === 'div' &&  /^taTextElement/.test(container.id)))
	            ) {
	                var arr = [];
	                for(var i = selectedNodes.length; i--; arr.unshift(selectedNodes[i]));
	                selectedNodes = arr;
	                selectedNodes.push(container);
	                //$log.debug(selectedNodes);
	            }
	            return selectedNodes;
	        },
	        // Some basic selection functions
	        getSelectionElement: function () {
	            var s = api.getSelection();
	            if (s) {
	                return api.getSelection().container;
	            } else {
	                return undefined;
	            }
	        },
	        setSelection: function(elStart, elEnd, start, end){
	            var range = rangy.createRange();
	
	            range.setStart(elStart, start);
	            range.setEnd(elEnd, end);
	
	            rangy.getSelection().setSingleRange(range);
	        },
	        setSelectionBeforeElement: function (el){
	            var range = rangy.createRange();
	
	            range.selectNode(el);
	            range.collapse(true);
	
	            rangy.getSelection().setSingleRange(range);
	        },
	        setSelectionAfterElement: function (el){
	            var range = rangy.createRange();
	
	            range.selectNode(el);
	            range.collapse(false);
	
	            rangy.getSelection().setSingleRange(range);
	        },
	        setSelectionToElementStart: function (el){
	            var range = rangy.createRange();
	
	            range.selectNodeContents(el);
	            range.collapse(true);
	
	            rangy.getSelection().setSingleRange(range);
	        },
	        setSelectionToElementEnd: function (el){
	            var range = rangy.createRange();
	
	            range.selectNodeContents(el);
	            range.collapse(false);
	            if(el.childNodes && el.childNodes[el.childNodes.length - 1] && el.childNodes[el.childNodes.length - 1].nodeName === 'br'){
	                range.startOffset = range.endOffset = range.startOffset - 1;
	            }
	            rangy.getSelection().setSingleRange(range);
	        },
	        setStateShiftKey: function(bS) {
	            bShiftState = bS;
	        },
	        getStateShiftKey: function() {
	            return bShiftState;
	        },
	        // from http://stackoverflow.com/questions/6690752/insert-html-at-caret-in-a-contenteditable-div
	        // topNode is the contenteditable normally, all manipulation MUST be inside this.
	        insertHtml: function(html, topNode){
	            var parent, secondParent, _childI, nodes, i, lastNode, _tempFrag;
	            var element = angular.element("<div>" + html + "</div>");
	            var range = rangy.getSelection().getRangeAt(0);
	            var frag = _document.createDocumentFragment();
	            var children = element[0].childNodes;
	            var isInline = true;
	
	            if(children.length > 0){
	                // NOTE!! We need to do the following:
	                // check for blockelements - if they exist then we have to split the current element in half (and all others up to the closest block element) and insert all children in-between.
	                // If there are no block elements, or there is a mixture we need to create textNodes for the non wrapped text (we don't want them spans messing up the picture).
	                nodes = [];
	                for(_childI = 0; _childI < children.length; _childI++){
	                    var _cnode = children[_childI];
	                    if (_cnode.nodeName.toLowerCase() === 'p' &&
	                        _cnode.innerHTML.trim() === '') { // empty p element
	                        continue;
	                    }
	                    /****************
	                     *  allow any text to be inserted...
	                    if((   _cnode.nodeType === 3 &&
	                           _cnode.nodeValue === '\ufeff'[0] &&
	                           _cnode.nodeValue.trim() === '') // empty no-space space element
	                        ) {
	                        // no change to isInline
	                        nodes.push(_cnode);
	                        continue;
	                    }
	                    if(_cnode.nodeType === 3 &&
	                         _cnode.nodeValue.trim() === '') { // empty text node
	                        continue;
	                    }
	                    *****************/
	                    isInline = isInline && !BLOCKELEMENTS.test(_cnode.nodeName);
	                    nodes.push(_cnode);
	                }
	                for(var _n = 0; _n < nodes.length; _n++) {
	                    lastNode = frag.appendChild(nodes[_n]);
	                }
	                if( !isInline &&
	                    range.collapsed &&
	                    /^(|<br(|\/)>)$/i.test(range.startContainer.innerHTML) ) {
	                    range.selectNode(range.startContainer);
	                }
	            }else{
	                isInline = true;
	                // paste text of some sort
	                lastNode = frag = _document.createTextNode(html);
	            }
	
	            // Other Edge case - selected data spans multiple blocks.
	            if(isInline){
	                range.deleteContents();
	            }else{ // not inline insert
	                if(range.collapsed && range.startContainer !== topNode){
	                    if(range.startContainer.innerHTML && range.startContainer.innerHTML.match(/^<[^>]*>$/i)){
	                        // this log is to catch when innerHTML is something like `<img ...>`
	                        parent = range.startContainer;
	                        if(range.startOffset === 1){
	                            // before single tag
	                            range.setStartAfter(parent);
	                            range.setEndAfter(parent);
	                        }else{
	                            // after single tag
	                            range.setStartBefore(parent);
	                            range.setEndBefore(parent);
	                        }
	                    }else{
	                        // split element into 2 and insert block element in middle
	                        if(range.startContainer.nodeType === 3 && range.startContainer.parentNode !== topNode){ // if text node
	                            parent = range.startContainer.parentNode;
	                            secondParent = parent.cloneNode();
	                            // split the nodes into two lists - before and after, splitting the node with the selection into 2 text nodes.
	                            taDOM.splitNodes(parent.childNodes, parent, secondParent, range.startContainer, range.startOffset);
	
	                            // Escape out of the inline tags like b
	                            while(!VALIDELEMENTS.test(parent.nodeName)){
	                                angular.element(parent).after(secondParent);
	                                parent = parent.parentNode;
	                                var _lastSecondParent = secondParent;
	                                secondParent = parent.cloneNode();
	                                // split the nodes into two lists - before and after, splitting the node with the selection into 2 text nodes.
	                                taDOM.splitNodes(parent.childNodes, parent, secondParent, _lastSecondParent);
	                            }
	                        }else{
	                            parent = range.startContainer;
	                            secondParent = parent.cloneNode();
	                            taDOM.splitNodes(parent.childNodes, parent, secondParent, undefined, undefined, range.startOffset);
	                        }
	
	                        angular.element(parent).after(secondParent);
	                        // put cursor to end of inserted content
	                        //console.log('setStartAfter', parent);
	                        range.setStartAfter(parent);
	                        range.setEndAfter(parent);
	
	                        if(/^(|<br(|\/)>)$/i.test(parent.innerHTML.trim())){
	                            range.setStartBefore(parent);
	                            range.setEndBefore(parent);
	                            angular.element(parent).remove();
	                        }
	                        if(/^(|<br(|\/)>)$/i.test(secondParent.innerHTML.trim())) angular.element(secondParent).remove();
	                        if(parent.nodeName.toLowerCase() === 'li'){
	                            _tempFrag = _document.createDocumentFragment();
	                            for(i = 0; i < frag.childNodes.length; i++){
	                                element = angular.element('<li>');
	                                taDOM.transferChildNodes(frag.childNodes[i], element[0]);
	                                taDOM.transferNodeAttributes(frag.childNodes[i], element[0]);
	                                _tempFrag.appendChild(element[0]);
	                            }
	                            frag = _tempFrag;
	                            if(lastNode){
	                                lastNode = frag.childNodes[frag.childNodes.length - 1];
	                                lastNode = lastNode.childNodes[lastNode.childNodes.length - 1];
	                            }
	                        }
	                    }
	                }else{
	                    range.deleteContents();
	                }
	            }
	
	            range.insertNode(frag);
	            if(lastNode){
	                api.setSelectionToElementEnd(lastNode);
	            }
	        }
	
	        /* NOT FUNCTIONAL YET
	         // under Firefox, we may have a selection that needs to be normalized
	         isSelectionContainerWhole_taTextElement: function (){
	         var range = rangy.getSelection().getRangeAt(0);
	         var container = range.commonAncestorContainer;
	         if (container.nodeName.toLowerCase() === 'div' &&
	         /^taTextElement/.test(container.id)) {
	         // container is the whole taTextElement
	         return true;
	         }
	         return false;
	         },
	         setNormalizedSelection: function (){
	         var range = rangy.getSelection().getRangeAt(0);
	         var container = range.commonAncestorContainer;
	         console.log(range);
	         console.log(container.childNodes);
	         if (range.collapsed) {
	         // we know what to do...
	         console.log(container.childNodes[range.startOffset]);
	         api.setSelectionToElementStart(container.childNodes[range.startOffset]);
	         }
	         },
	         */
	    };
	    return api;
	}]).service('taDOM', function(){
	    var taDOM = {
	        // recursive function that returns an array of angular.elements that have the passed attribute set on them
	        getByAttribute: function(element, attribute){
	            var resultingElements = [];
	            var childNodes = element.children();
	            if(childNodes.length){
	                angular.forEach(childNodes, function(child){
	                    resultingElements = resultingElements.concat(taDOM.getByAttribute(angular.element(child), attribute));
	                });
	            }
	            if(element.attr(attribute) !== undefined) resultingElements.push(element);
	            return resultingElements;
	        },
	
	        transferChildNodes: function(source, target){
	            // clear out target
	            target.innerHTML = '';
	            while(source.childNodes.length > 0) target.appendChild(source.childNodes[0]);
	            return target;
	        },
	
	        splitNodes: function(nodes, target1, target2, splitNode, subSplitIndex, splitIndex){
	            if(!splitNode && isNaN(splitIndex)) throw new Error('taDOM.splitNodes requires a splitNode or splitIndex');
	            var startNodes = document.createDocumentFragment();
	            var endNodes = document.createDocumentFragment();
	            var index = 0;
	
	            while(nodes.length > 0 && (isNaN(splitIndex) || splitIndex !== index) && nodes[0] !== splitNode){
	                startNodes.appendChild(nodes[0]); // this removes from the nodes array (if proper childNodes object.
	                index++;
	            }
	
	            if(!isNaN(subSplitIndex) && subSplitIndex >= 0 && nodes[0]){
	                startNodes.appendChild(document.createTextNode(nodes[0].nodeValue.substring(0, subSplitIndex)));
	                nodes[0].nodeValue = nodes[0].nodeValue.substring(subSplitIndex);
	            }
	            while(nodes.length > 0) endNodes.appendChild(nodes[0]);
	
	            taDOM.transferChildNodes(startNodes, target1);
	            taDOM.transferChildNodes(endNodes, target2);
	        },
	
	        transferNodeAttributes: function(source, target){
	            for(var i = 0; i < source.attributes.length; i++) target.setAttribute(source.attributes[i].name, source.attributes[i].value);
	            return target;
	        }
	    };
	    return taDOM;
	});
	
	angular.module('textAngular.validators', [])
	.directive('taMaxText', function(){
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        link: function(scope, elem, attrs, ctrl){
	            var max = parseInt(scope.$eval(attrs.taMaxText));
	            if (isNaN(max)){
	                throw('Max text must be an integer');
	            }
	            attrs.$observe('taMaxText', function(value){
	                max = parseInt(value);
	                if (isNaN(max)){
	                    throw('Max text must be an integer');
	                }
	                if (ctrl.$dirty){
	                    ctrl.$validate();
	                }
	            });
	            ctrl.$validators.taMaxText = function(viewValue){
	                var source = angular.element('<div/>');
	                source.html(viewValue);
	                return source.text().length <= max;
	            };
	        }
	    };
	}).directive('taMinText', function(){
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        link: function(scope, elem, attrs, ctrl){
	            var min = parseInt(scope.$eval(attrs.taMinText));
	            if (isNaN(min)){
	                throw('Min text must be an integer');
	            }
	            attrs.$observe('taMinText', function(value){
	                min = parseInt(value);
	                if (isNaN(min)){
	                    throw('Min text must be an integer');
	                }
	                if (ctrl.$dirty){
	                    ctrl.$validate();
	                }
	            });
	            ctrl.$validators.taMinText = function(viewValue){
	                var source = angular.element('<div/>');
	                source.html(viewValue);
	                return !source.text().length || source.text().length >= min;
	            };
	        }
	    };
	});
	angular.module('textAngular.taBind', ['textAngular.factories', 'textAngular.DOM'])
	.service('_taBlankTest', [function(){
	    return function(_blankVal){
	        // we radically restructure this code.
	        // what was here before was incredibly fragile.
	        // What we do now is to check that the html is non-blank visually
	        // which we check by looking at html->text
	        if(!_blankVal) return true;
	        // find first non-tag match - ie start of string or after tag that is not whitespace
	        // var t0 = performance.now();
	        // Takes a small fraction of a mSec to do this...
	        var _text_ = stripHtmlToText(_blankVal);
	        // var t1 = performance.now();
	        // console.log('Took', (t1 - t0).toFixed(4), 'milliseconds to generate:');
	        if (_text_=== '') {
	            // img generates a visible item so it is not blank!
	            if (/<img[^>]+>/.test(_blankVal)) {
	                return false;
	            }
	            return true;
	        } else {
	            return false;
	        }
	    };
	}])
	.directive('taButton', [function(){
	    return {
	        link: function(scope, element, attrs){
	            element.attr('unselectable', 'on');
	            element.on('mousedown', function(e, eventData){
	                /* istanbul ignore else: this is for catching the jqLite testing*/
	                if(eventData) angular.extend(e, eventData);
	                // this prevents focusout from firing on the editor when clicking toolbar buttons
	                e.preventDefault();
	                return false;
	            });
	        }
	    };
	}])
	.directive('taBind', [
	        'taSanitize', '$timeout', '$document', 'taFixChrome', 'taBrowserTag',
	        'taSelection', 'taSelectableElements', 'taApplyCustomRenderers', 'taOptions',
	        '_taBlankTest', '$parse', 'taDOM', 'textAngularManager',
	        function(
	            taSanitize, $timeout, $document, taFixChrome, taBrowserTag,
	            taSelection, taSelectableElements, taApplyCustomRenderers, taOptions,
	            _taBlankTest, $parse, taDOM, textAngularManager){
	    // Uses for this are textarea or input with ng-model and ta-bind='text'
	    // OR any non-form element with contenteditable="contenteditable" ta-bind="html|text" ng-model
	    return {
	        priority: 2, // So we override validators correctly
	        require: ['ngModel','?ngModelOptions'],
	        link: function(scope, element, attrs, controller){
	            var ngModel = controller[0];
	            var ngModelOptions = controller[1] || {};
	            // the option to use taBind on an input or textarea is required as it will sanitize all input into it correctly.
	            var _isContentEditable = element.attr('contenteditable') !== undefined && element.attr('contenteditable');
	            var _isInputFriendly = _isContentEditable || element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input';
	            var _isReadonly = false;
	            var _focussed = false;
	            var _skipRender = false;
	            var _disableSanitizer = attrs.taUnsafeSanitizer || taOptions.disableSanitizer;
	            var _keepStyles = attrs.taKeepStyles || taOptions.keepStyles;
	            var _lastKey;
	            // see http://www.javascripter.net/faq/keycodes.htm for good information
	            // NOTE Mute On|Off 173 (Opera MSIE Safari Chrome) 181 (Firefox)
	            // BLOCKED_KEYS are special keys...
	            // Tab, pause/break, CapsLock, Esc, Page Up, End, Home,
	            // Left arrow, Up arrow, Right arrow, Down arrow, Insert, Delete,
	            // f1, f2, f3, f4, f5, f6, f7, f8, f9, f10, f11, f12
	            // NumLock, ScrollLock
	            var BLOCKED_KEYS = /^(9|19|20|27|33|34|35|36|37|38|39|40|45|112|113|114|115|116|117|118|119|120|121|122|123|144|145)$/i;
	            // UNDO_TRIGGER_KEYS - spaces, enter, delete, backspace, all punctuation
	            // Backspace, Enter, Space, Delete, (; :) (Firefox), (= +) (Firefox),
	            // Numpad +, Numpad -, (; :), (= +),
	            // (, <), (- _), (. >), (/ ?), (` ~), ([ {), (\ |), (] }), (' ")
	            // NOTE - Firefox: 173 = (- _) -- adding this to UNDO_TRIGGER_KEYS
	            var UNDO_TRIGGER_KEYS = /^(8|13|32|46|59|61|107|109|173|186|187|188|189|190|191|192|219|220|221|222)$/i;
	            var _pasteHandler;
	
	            // defaults to the paragraph element, but we need the line-break or it doesn't allow you to type into the empty element
	            // non IE is '<p><br/></p>', ie is '<p></p>' as for once IE gets it correct...
	            var _defaultVal, _defaultTest;
	
	            var _CTRL_KEY = 0x0001;
	            var _META_KEY = 0x0002;
	            var _ALT_KEY = 0x0004;
	            var _SHIFT_KEY = 0x0008;
	            // KEYCODEs we use
	            var _ENTER_KEYCODE = 13;
	            var _SHIFT_KEYCODE = 16;
	            var _TAB_KEYCODE = 9;
	            var _LEFT_ARROW_KEYCODE = 37;
	            var _RIGHT_ARROW_KEYCODE = 39;
	            // map events to special keys...
	            // mappings is an array of maps from events to specialKeys as declared in textAngularSetup
	            var _keyMappings = [
	                //		ctrl/command + z
	                {
	                    specialKey: 'UndoKey',
	                    forbiddenModifiers: _ALT_KEY + _SHIFT_KEY,
	                    mustHaveModifiers: [_META_KEY + _CTRL_KEY],
	                    keyCode: 90
	                },
	                //		ctrl/command + shift + z
	                {
	                    specialKey: 'RedoKey',
	                    forbiddenModifiers: _ALT_KEY,
	                    mustHaveModifiers: [_META_KEY + _CTRL_KEY, _SHIFT_KEY],
	                    keyCode: 90
	                },
	                //		ctrl/command + y
	                {
	                    specialKey: 'RedoKey',
	                    forbiddenModifiers: _ALT_KEY + _SHIFT_KEY,
	                    mustHaveModifiers: [_META_KEY + _CTRL_KEY],
	                    keyCode: 89
	                },
	                //		TabKey
	                {
	                    specialKey: 'TabKey',
	                    forbiddenModifiers: _META_KEY + _SHIFT_KEY + _ALT_KEY + _CTRL_KEY,
	                    mustHaveModifiers: [],
	                    keyCode: _TAB_KEYCODE
	                },
	                //		shift + TabKey
	                {
	                    specialKey: 'ShiftTabKey',
	                    forbiddenModifiers: _META_KEY + _ALT_KEY + _CTRL_KEY,
	                    mustHaveModifiers: [_SHIFT_KEY],
	                    keyCode: _TAB_KEYCODE
	                }
	            ];
	            function _mapKeys(event) {
	                var specialKey;
	                _keyMappings.forEach(function (map){
	                    if (map.keyCode === event.keyCode) {
	                        var netModifiers = (event.metaKey ? _META_KEY: 0) +
	                            (event.ctrlKey ? _CTRL_KEY: 0) +
	                            (event.shiftKey ? _SHIFT_KEY: 0) +
	                            (event.altKey ? _ALT_KEY: 0);
	                        if (map.forbiddenModifiers & netModifiers) return;
	                        if (map.mustHaveModifiers.every(function (modifier) { return netModifiers & modifier; })){
	                            specialKey = map.specialKey;
	                        }
	                    }
	                });
	                return specialKey;
	            }
	
	            // set the default to be a paragraph value
	            if(attrs.taDefaultWrap === undefined) attrs.taDefaultWrap = 'p';
	            /* istanbul ignore next: ie specific test */
	            if(attrs.taDefaultWrap === ''){
	                _defaultVal = '';
	                _defaultTest = (_browserDetect.ie === undefined)? '<div><br></div>' : (_browserDetect.ie >= 11)? '<p><br></p>' : (_browserDetect.ie <= 8)? '<P>&nbsp;</P>' : '<p>&nbsp;</p>';
	            }else{
	                _defaultVal = (_browserDetect.ie === undefined || _browserDetect.ie >= 11)?
	                    (attrs.taDefaultWrap.toLowerCase() === 'br' ? '<BR><BR>' : '<' + attrs.taDefaultWrap + '><br></' + attrs.taDefaultWrap + '>') :
	                    (_browserDetect.ie <= 8)?
	                        '<' + attrs.taDefaultWrap.toUpperCase() + '></' + attrs.taDefaultWrap.toUpperCase() + '>' :
	                        '<' + attrs.taDefaultWrap + '></' + attrs.taDefaultWrap + '>';
	                _defaultTest = (_browserDetect.ie === undefined || _browserDetect.ie >= 11)?
	                    (attrs.taDefaultWrap.toLowerCase() === 'br' ? '<br><br>' : '<' + attrs.taDefaultWrap + '><br></' + attrs.taDefaultWrap + '>') :
	                    (_browserDetect.ie <= 8)?
	                        '<' + attrs.taDefaultWrap.toUpperCase() + '>&nbsp;</' + attrs.taDefaultWrap.toUpperCase() + '>' :
	                        '<' + attrs.taDefaultWrap + '>&nbsp;</' + attrs.taDefaultWrap + '>';
	            }
	
	            /* istanbul ignore else */
	            if(!ngModelOptions.$options) ngModelOptions.$options = {}; // ng-model-options support
	
	            var _ensureContentWrapped = function(value) {
	                if (_taBlankTest(value)) return value;
	                var domTest = angular.element("<div>" + value + "</div>");
	                //console.log('domTest.children().length():', domTest.children().length);
	                //console.log('_ensureContentWrapped', domTest.children());
	                //console.log(value, attrs.taDefaultWrap);
	                if (domTest.children().length === 0) {
	                    // if we have a <br> and the attrs.taDefaultWrap is a <p> we need to remove the <br>
	                    //value = value.replace(/<br>/i, '');
	                    value = "<" + attrs.taDefaultWrap + ">" + value + "</" + attrs.taDefaultWrap + ">";
	                } else {
	                    var _children = domTest[0].childNodes;
	                    var i;
	                    var _foundBlockElement = false;
	                    for (i = 0; i < _children.length; i++) {
	                        if (_foundBlockElement = _children[i].nodeName.toLowerCase().match(BLOCKELEMENTS)) break;
	                    }
	                    if (!_foundBlockElement) {
	                        value = "<" + attrs.taDefaultWrap + ">" + value + "</" + attrs.taDefaultWrap + ">";
	                    }
	                    else{
	                        value = "";
	                        for(i = 0; i < _children.length; i++){
	                            var node = _children[i];
	                            var nodeName = node.nodeName.toLowerCase();
	                            //console.log('node#:', i, 'name:', nodeName);
	                            if(nodeName === '#comment') {
	                                value += '<!--' + node.nodeValue + '-->';
	                            } else if(nodeName === '#text') {
	                                // determine if this is all whitespace, if so, we will leave it as it is.
	                                // otherwise, we will wrap it as it is
	                                var text = node.textContent;
	                                if (!text.trim()) {
	                                    // just whitespace
	                                    value += text;
	                                } else {
	                                    // not pure white space so wrap in <p>...</p> or whatever attrs.taDefaultWrap is set to.
	                                    value += "<" + attrs.taDefaultWrap + ">" + text + "</" + attrs.taDefaultWrap + ">";
	                                }
	                            } else if(!nodeName.match(BLOCKELEMENTS)){
	                                /* istanbul ignore  next: Doesn't seem to trigger on tests */
	                                var _subVal = (node.outerHTML || node.nodeValue);
	                                /* istanbul ignore else: Doesn't seem to trigger on tests, is tested though */
	                                if(_subVal.trim() !== '')
	                                    value += "<" + attrs.taDefaultWrap + ">" + _subVal + "</" + attrs.taDefaultWrap + ">";
	                                else value += _subVal;
	                            } else {
	                                value += node.outerHTML;
	                            }
	                            //console.log(value);
	                        }
	                    }
	                }
	                //console.log(value);
	                return value;
	            };
	
	            if(attrs.taPaste) {
	                _pasteHandler = $parse(attrs.taPaste);
	            }
	
	            element.addClass('ta-bind');
	
	            var _undoKeyupTimeout;
	
	            scope['$undoManager' + (attrs.id || '')] = ngModel.$undoManager = {
	                _stack: [],
	                _index: 0,
	                _max: 1000,
	                push: function(value){
	                    if((typeof value === "undefined" || value === null) ||
	                        ((typeof this.current() !== "undefined" && this.current() !== null) && value === this.current())) return value;
	                    if(this._index < this._stack.length - 1){
	                        this._stack = this._stack.slice(0,this._index+1);
	                    }
	                    this._stack.push(value);
	                    if(_undoKeyupTimeout) $timeout.cancel(_undoKeyupTimeout);
	                    if(this._stack.length > this._max) this._stack.shift();
	                    this._index = this._stack.length - 1;
	                    return value;
	                },
	                undo: function(){
	                    return this.setToIndex(this._index-1);
	                },
	                redo: function(){
	                    return this.setToIndex(this._index+1);
	                },
	                setToIndex: function(index){
	                    if(index < 0 || index > this._stack.length - 1){
	                        return undefined;
	                    }
	                    this._index = index;
	                    return this.current();
	                },
	                current: function(){
	                    return this._stack[this._index];
	                }
	            };
	
	            // in here we are undoing the converts used elsewhere to prevent the < > and & being displayed when they shouldn't in the code.
	            var _compileHtml = function(){
	                if(_isContentEditable) {
	                    return element[0].innerHTML;
	                }
	                if(_isInputFriendly) {
	                    return element.val();
	                }
	                throw ('textAngular Error: attempting to update non-editable taBind');
	            };
	
	            var selectorClickHandler = function(event){
	                // emit the element-select event, pass the element
	                scope.$emit('ta-element-select', this);
	                event.preventDefault();
	                return false;
	            };
	
	            //used for updating when inserting wrapped elements
	            var _reApplyOnSelectorHandlers = scope['reApplyOnSelectorHandlers' + (attrs.id || '')] = function(){
	                /* istanbul ignore else */
	                if(!_isReadonly) angular.forEach(taSelectableElements, function(selector){
	                    // check we don't apply the handler twice
	                    element.find(selector)
	                        .off('click', selectorClickHandler)
	                        .on('click', selectorClickHandler);
	                });
	            };
	
	            var _setViewValue = function(_val, triggerUndo, skipRender){
	                _skipRender = skipRender || false;
	                if(typeof triggerUndo === "undefined" || triggerUndo === null) triggerUndo = true && _isContentEditable; // if not contentEditable then the native undo/redo is fine
	                if(typeof _val === "undefined" || _val === null) _val = _compileHtml();
	                if(_taBlankTest(_val)){
	                    // this avoids us from tripping the ng-pristine flag if we click in and out with out typing
	                    if(ngModel.$viewValue !== '') ngModel.$setViewValue('');
	                    if(triggerUndo && ngModel.$undoManager.current() !== '') ngModel.$undoManager.push('');
	                }else{
	                    _reApplyOnSelectorHandlers();
	                    if(ngModel.$viewValue !== _val){
	                        ngModel.$setViewValue(_val);
	                        if(triggerUndo) ngModel.$undoManager.push(_val);
	                    }
	                }
	                ngModel.$render();
	            };
	
	            var _setInnerHTML = function(newval){
	                element[0].innerHTML = newval;
	            };
	
	            var _redoUndoTimeout;
	            var _undo = scope['$undoTaBind' + (attrs.id || '')] = function(){
	                /* istanbul ignore else: can't really test it due to all changes being ignored as well in readonly */
	                if(!_isReadonly && _isContentEditable){
	                    var content = ngModel.$undoManager.undo();
	                    if(typeof content !== "undefined" && content !== null){
	                        _setInnerHTML(content);
	                        _setViewValue(content, false);
	                        if(_redoUndoTimeout) $timeout.cancel(_redoUndoTimeout);
	                        _redoUndoTimeout = $timeout(function(){
	                            element[0].focus();
	                            taSelection.setSelectionToElementEnd(element[0]);
	                        }, 1);
	                    }
	                }
	            };
	
	            var _redo = scope['$redoTaBind' + (attrs.id || '')] = function(){
	                /* istanbul ignore else: can't really test it due to all changes being ignored as well in readonly */
	                if(!_isReadonly && _isContentEditable){
	                    var content = ngModel.$undoManager.redo();
	                    if(typeof content !== "undefined" && content !== null){
	                        _setInnerHTML(content);
	                        _setViewValue(content, false);
	                        /* istanbul ignore next */
	                        if(_redoUndoTimeout) $timeout.cancel(_redoUndoTimeout);
	                        _redoUndoTimeout = $timeout(function(){
	                            element[0].focus();
	                            taSelection.setSelectionToElementEnd(element[0]);
	                        }, 1);
	                    }
	                }
	            };
	
	            //used for updating when inserting wrapped elements
	            scope['updateTaBind' + (attrs.id || '')] = function(){
	                if(!_isReadonly) _setViewValue(undefined, undefined, true);
	            };
	
	            // catch DOM XSS via taSanitize
	            // Sanitizing both ways is identical
	            var _sanitize = function(unsafe){
	                return (ngModel.$oldViewValue = taSanitize(taFixChrome(unsafe, _keepStyles), ngModel.$oldViewValue, _disableSanitizer));
	            };
	
	            // trigger the validation calls
	            if(element.attr('required')) ngModel.$validators.required = function(modelValue, viewValue) {
	                return !_taBlankTest(modelValue || viewValue);
	            };
	            // parsers trigger from the above keyup function or any other time that the viewValue is updated and parses it for storage in the ngModel
	            ngModel.$parsers.push(_sanitize);
	            ngModel.$parsers.unshift(_ensureContentWrapped);
	            // because textAngular is bi-directional (which is awesome) we need to also sanitize values going in from the server
	            ngModel.$formatters.push(_sanitize);
	            ngModel.$formatters.unshift(_ensureContentWrapped);
	            ngModel.$formatters.unshift(function(value){
	                return ngModel.$undoManager.push(value || '');
	            });
	
	            //this code is used to update the models when data is entered/deleted
	            if(_isInputFriendly){
	                scope.events = {};
	                if(!_isContentEditable){
	                    // if a textarea or input just add in change and blur handlers, everything else is done by angulars input directive
	                    element.on('change blur', scope.events.change = scope.events.blur = function(){
	                        if(!_isReadonly) ngModel.$setViewValue(_compileHtml());
	                    });
	
	                    element.on('keydown', scope.events.keydown = function(event, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(event, eventData);
	                        // Reference to http://stackoverflow.com/questions/6140632/how-to-handle-tab-in-textarea
	                        /* istanbul ignore else: otherwise normal functionality */
	                        if(event.keyCode === _TAB_KEYCODE){ // tab was pressed
	                            // get caret position/selection
	                            var start = this.selectionStart;
	                            var end = this.selectionEnd;
	
	                            var value = element.val();
	                            if(event.shiftKey){
	                                // find \t
	                                var _linebreak = value.lastIndexOf('\n', start), _tab = value.lastIndexOf('\t', start);
	                                if(_tab !== -1 && _tab >= _linebreak){
	                                    // set textarea value to: text before caret + tab + text after caret
	                                    element.val(value.substring(0, _tab) + value.substring(_tab + 1));
	
	                                    // put caret at right position again (add one for the tab)
	                                    this.selectionStart = this.selectionEnd = start - 1;
	                                }
	                            }else{
	                                // set textarea value to: text before caret + tab + text after caret
	                                element.val(value.substring(0, start) + "\t" + value.substring(end));
	
	                                // put caret at right position again (add one for the tab)
	                                this.selectionStart = this.selectionEnd = start + 1;
	                            }
	                            // prevent the focus lose
	                            event.preventDefault();
	                        }
	                    });
	
	                    var _repeat = function(string, n){
	                        var result = '';
	                        for(var _n = 0; _n < n; _n++) result += string;
	                        return result;
	                    };
	
	                    // add a forEach function that will work on a NodeList, etc..
	                    var forEach = function (array, callback, scope) {
	                        for (var i= 0; i<array.length; i++) {
	                            callback.call(scope, i, array[i]);
	                        }
	                    };
	
	                    // handle <ul> or <ol> nodes
	                    var recursiveListFormat = function(listNode, tablevel){
	                        var _html = '';
	                        var _subnodes = listNode.childNodes;
	                        tablevel++;
	                        // tab out and add the <ul> or <ol> html piece
	                        _html += _repeat('\t', tablevel-1) + listNode.outerHTML.substring(0, 4);
	                        forEach(_subnodes, function (index, node) {
	                            /* istanbul ignore next: browser catch */
	                            var nodeName = node.nodeName.toLowerCase();
	                            if (nodeName === '#comment') {
	                                _html += '<!--' + node.nodeValue + '-->';
	                                return;
	                            }
	                            if (nodeName === '#text') {
	                                _html += node.textContent;
	                                return;
	                            }
	                            /* istanbul ignore next: not tested, and this was original code -- so not wanting to possibly cause an issue, leaving it... */
	                            if(!node.outerHTML) {
	                                // no html to add
	                                return;
	                            }
	                            if(nodeName === 'ul' || nodeName === 'ol') {
	                                _html += '\n' + recursiveListFormat(node, tablevel);
	                            }
	                            else {
	                                // no reformatting within this subnode, so just do the tabing...
	                                _html += '\n' + _repeat('\t', tablevel) + node.outerHTML;
	                            }
	                        });
	                        // now add on the </ol> or </ul> piece
	                        _html += '\n' + _repeat('\t', tablevel-1) + listNode.outerHTML.substring(listNode.outerHTML.lastIndexOf('<'));
	                        return _html;
	                    };
	                    // handle formating of something like:
	                    // <ol><!--First comment-->
	                    //  <li>Test Line 1<!--comment test list 1--></li>
	                    //    <ul><!--comment ul-->
	                    //      <li>Nested Line 1</li>
	                    //        <!--comment between nested lines--><li>Nested Line 2</li>
	                    //    </ul>
	                    //  <li>Test Line 3</li>
	                    // </ol>
	                    ngModel.$formatters.unshift(function(htmlValue){
	                        // tabulate the HTML so it looks nicer
	                        //
	                        // first get a list of the nodes...
	                        // we do this by using the element parser...
	                        //
	                        // doing this -- which is simpiler -- breaks our tests...
	                        //var _nodes=angular.element(htmlValue);
	                        var _nodes = angular.element('<div>' + htmlValue + '</div>')[0].childNodes;
	                        if(_nodes.length > 0){
	                            // do the reformatting of the layout...
	                            htmlValue = '';
	                            forEach(_nodes, function (index, node) {
	                                var nodeName = node.nodeName.toLowerCase();
	                                if (nodeName === '#comment') {
	                                    htmlValue += '<!--' + node.nodeValue + '-->';
	                                    return;
	                                }
	                                if (nodeName === '#text') {
	                                    htmlValue += node.textContent;
	                                    return;
	                                }
	                                /* istanbul ignore next: not tested, and this was original code -- so not wanting to possibly cause an issue, leaving it... */
	                                if(!node.outerHTML)
	                                {
	                                    // nothing to format!
	                                    return;
	                                }
	                                if(htmlValue.length > 0) {
	                                    // we aready have some content, so drop to a new line
	                                    htmlValue += '\n';
	                                }
	                                if(nodeName === 'ul' || nodeName === 'ol') {
	                                    // okay a set of list stuff we want to reformat in a nested way
	                                    htmlValue += '' + recursiveListFormat(node, 0);
	                                }
	                                else {
	                                    // just use the original without any additional formating
	                                    htmlValue += '' + node.outerHTML;
	                                }
	                            });
	                        }
	                        return htmlValue;
	                    });
	                }else{
	                    // all the code specific to contenteditable divs
	                    var _processingPaste = false;
	                    /* istanbul ignore next: phantom js cannot test this for some reason */
	                    var processpaste = function(text) {
	                       var _isOneNote = text!==undefined? text.match(/content=["']*OneNote.File/i): false;
	                        /* istanbul ignore else: don't care if nothing pasted */
	                        //console.log(text);
	                        if(text && text.trim().length){
	                            // test paste from word/microsoft product
	                            if(text.match(/class=["']*Mso(Normal|List)/i) || text.match(/content=["']*Word.Document/i) || text.match(/content=["']*OneNote.File/i)){
	                                var textFragment = text.match(/<!--StartFragment-->([\s\S]*?)<!--EndFragment-->/i);
	                                if(!textFragment) textFragment = text;
	                                else textFragment = textFragment[1];
	                                textFragment = textFragment.replace(/<o:p>[\s\S]*?<\/o:p>/ig, '').replace(/class=(["']|)MsoNormal(["']|)/ig, '');
	                                var dom = angular.element("<div>" + textFragment + "</div>");
	                                var targetDom = angular.element("<div></div>");
	                                var _list = {
	                                    element: null,
	                                    lastIndent: [],
	                                    lastLi: null,
	                                    isUl: false
	                                };
	                                _list.lastIndent.peek = function(){
	                                    var n = this.length;
	                                    if (n>0) return this[n-1];
	                                };
	                                var _resetList = function(isUl){
	                                    _list.isUl = isUl;
	                                    _list.element = angular.element(isUl ? "<ul>" : "<ol>");
	                                    _list.lastIndent = [];
	                                    _list.lastIndent.peek = function(){
	                                        var n = this.length;
	                                        if (n>0) return this[n-1];
	                                    };
	                                    _list.lastLevelMatch = null;
	                                };
	                                for(var i = 0; i <= dom[0].childNodes.length; i++){
	                                    if(!dom[0].childNodes[i] || dom[0].childNodes[i].nodeName === "#text"){
	                                        continue;
	                                    } else {
	                                        var tagName = dom[0].childNodes[i].tagName.toLowerCase();
	                                        if(tagName !== 'p' &&
	                                            tagName !== 'ul' &&
	                                            tagName !== 'h1' &&
	                                            tagName !== 'h2' &&
	                                            tagName !== 'h3' &&
	                                            tagName !== 'h4' &&
	                                            tagName !== 'h5' &&
	                                            tagName !== 'h6' &&
	                                            tagName !== 'table'){
	                                            continue;
	                                        }
	                                    }
	                                    var el = angular.element(dom[0].childNodes[i]);
	                                    var _listMatch = (el.attr('class') || '').match(/MsoList(Bullet|Number|Paragraph)(CxSp(First|Middle|Last)|)/i);
	
	                                    if(_listMatch){
	                                        if(el[0].childNodes.length < 2 || el[0].childNodes[1].childNodes.length < 1){
	                                            continue;
	                                        }
	                                        var isUl = _listMatch[1].toLowerCase() === 'bullet' || (_listMatch[1].toLowerCase() !== 'number' && !(/^[^0-9a-z<]*[0-9a-z]+[^0-9a-z<>]</i.test(el[0].childNodes[1].innerHTML) || /^[^0-9a-z<]*[0-9a-z]+[^0-9a-z<>]</i.test(el[0].childNodes[1].childNodes[0].innerHTML)));
	                                        var _indentMatch = (el.attr('style') || '').match(/margin-left:([\-\.0-9]*)/i);
	                                        var indent = parseFloat((_indentMatch)?_indentMatch[1]:0);
	                                        var _levelMatch = (el.attr('style') || '').match(/mso-list:l([0-9]+) level([0-9]+) lfo[0-9+]($|;)/i);
	                                        // prefers the mso-list syntax
	
	                                        if(_levelMatch && _levelMatch[2]) indent = parseInt(_levelMatch[2]);
	
	                                        if ((_levelMatch && (!_list.lastLevelMatch || _levelMatch[1] !== _list.lastLevelMatch[1])) || !_listMatch[3] || _listMatch[3].toLowerCase() === 'first' || (_list.lastIndent.peek() === null) || (_list.isUl !== isUl && _list.lastIndent.peek() === indent)) {
	                                            _resetList(isUl);
	                                            targetDom.append(_list.element);
	                                        } else if (_list.lastIndent.peek() != null && _list.lastIndent.peek() < indent){
	                                            _list.element = angular.element(isUl ? '<ul>' : '<ol>');
	                                            _list.lastLi.append(_list.element);
	                                        } else if (_list.lastIndent.peek() != null && _list.lastIndent.peek() > indent){
	                                            while(_list.lastIndent.peek() != null && _list.lastIndent.peek() > indent){
	                                                if(_list.element.parent()[0].tagName.toLowerCase() === 'li'){
	                                                    _list.element = _list.element.parent();
	                                                    continue;
	                                                }else if(/[uo]l/i.test(_list.element.parent()[0].tagName.toLowerCase())){
	                                                    _list.element = _list.element.parent();
	                                                }else{ // else it's it should be a sibling
	                                                    break;
	                                                }
	                                                _list.lastIndent.pop();
	                                            }
	                                            _list.isUl = _list.element[0].tagName.toLowerCase() === 'ul';
	                                            if (isUl !== _list.isUl) {
	                                                _resetList(isUl);
	                                                targetDom.append(_list.element);
	                                            }
	                                        }
	
	                                        _list.lastLevelMatch = _levelMatch;
	                                        if(indent !== _list.lastIndent.peek()) _list.lastIndent.push(indent);
	                                        _list.lastLi = angular.element('<li>');
	                                        _list.element.append(_list.lastLi);
	                                        _list.lastLi.html(el.html().replace(/<!(--|)\[if !supportLists\](--|)>[\s\S]*?<!(--|)\[endif\](--|)>/ig, ''));
	                                        el.remove();
	                                    }else{
	                                        _resetList(false);
	                                        targetDom.append(el);
	                                    }
	                                }
	                                var _unwrapElement = function(node){
	                                    node = angular.element(node);
	                                    for(var _n = node[0].childNodes.length - 1; _n >= 0; _n--) node.after(node[0].childNodes[_n]);
	                                    node.remove();
	                                };
	
	                                angular.forEach(targetDom.find('span'), function(node){
	                                    node.removeAttribute('lang');
	                                    if(node.attributes.length <= 0) _unwrapElement(node);
	                                });
	                                angular.forEach(targetDom.find('font'), _unwrapElement);
	
	                                text = targetDom.html();
	                                if(_isOneNote){
	                                    text = targetDom.html() || dom.html();
	                                }
	                                // LF characters instead of spaces in some spots and they are replaced by '/n', so we need to just swap them to spaces
	                                text = text.replace(/\n/g, ' ');
	                            }else{
	                                // remove unnecessary chrome insert
	                                text = text.replace(/<(|\/)meta[^>]*?>/ig, '');
	                                if(text.match(/<[^>]*?(ta-bind)[^>]*?>/)){
	                                    // entire text-angular or ta-bind has been pasted, REMOVE AT ONCE!!
	                                    if(text.match(/<[^>]*?(text-angular)[^>]*?>/)){
	                                        var _el = angular.element('<div>' + text + '</div>');
	                                        _el.find('textarea').remove();
	                                        for(var _b = 0; _b < binds.length; _b++){
	                                            var _target = binds[_b][0].parentNode.parentNode;
	                                            for(var _c = 0; _c < binds[_b][0].childNodes.length; _c++){
	                                                _target.parentNode.insertBefore(binds[_b][0].childNodes[_c], _target);
	                                            }
	                                            _target.parentNode.removeChild(_target);
	                                        }
	                                        text = _el.html().replace('<br class="Apple-interchange-newline">', '');
	                                    }
	                                }else if(text.match(/^<span/)){
	                                    // in case of pasting only a span - chrome paste, remove them. THis is just some wierd formatting
	                                    // if we remove the '<span class="Apple-converted-space"> </span>' here we destroy the spacing
	                                    // on paste from even ourselves!
	                                    if (!text.match(/<span class=(\"Apple-converted-space\"|\'Apple-converted-space\')>.<\/span>/ig)) {
	                                        text = text.replace(/<(|\/)span[^>]*?>/ig, '');
	                                    }
	                                }
	                                // Webkit on Apple tags
	                                text = text.replace(/<br class="Apple-interchange-newline"[^>]*?>/ig, '').replace(/<span class="Apple-converted-space">( |&nbsp;)<\/span>/ig, '&nbsp;');
	                            }
	
	                            if (/<li(\s.*)?>/i.test(text) && /(<ul(\s.*)?>|<ol(\s.*)?>).*<li(\s.*)?>/i.test(text) === false) {
	                                // insert missing parent of li element
	                                text = text.replace(/<li(\s.*)?>.*<\/li(\s.*)?>/i, '<ul>$&</ul>');
	                            }
	
	                            // parse whitespace from plaintext input, starting with preceding spaces that get stripped on paste
	                            text = text.replace(/^[ |\u00A0]+/gm, function (match) {
	                                var result = '';
	                                for (var i = 0; i < match.length; i++) {
	                                    result += '&nbsp;';
	                                }
	                                return result;
	                            }).replace(/\n|\r\n|\r/g, '<br />').replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;');
	
	                            if(_pasteHandler) text = _pasteHandler(scope, {$html: text}) || text;
	
	                            // turn span vertical-align:super into <sup></sup>
	                            text = text.replace(/<span style=("|')([^<]*?)vertical-align\s*:\s*super;?([^>]*?)("|')>([^<]+?)<\/span>/g, "<sup style='$2$3'>$5</sup>");
	
	                            text = taSanitize(text, '', _disableSanitizer);
	                            //console.log('DONE\n', text);
	
	                            taSelection.insertHtml(text, element[0]);
	                            $timeout(function(){
	                                ngModel.$setViewValue(_compileHtml());
	                                _processingPaste = false;
	                                element.removeClass('processing-paste');
	                            }, 0);
	                        }else{
	                            _processingPaste = false;
	                            element.removeClass('processing-paste');
	                        }
	                    };
	
	                    element.on('paste', scope.events.paste = function(e, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(e, eventData);
	                        if(_isReadonly || _processingPaste){
	                            e.stopPropagation();
	                            e.preventDefault();
	                            return false;
	                        }
	
	                        // Code adapted from http://stackoverflow.com/questions/2176861/javascript-get-clipboard-data-on-paste-event-cross-browser/6804718#6804718
	                        _processingPaste = true;
	                        element.addClass('processing-paste');
	                        var pastedContent;
	                        var clipboardData = (e.originalEvent || e).clipboardData;
	                        /* istanbul ignore next: Handle legacy IE paste */
	                        if ( !clipboardData && window.clipboardData && window.clipboardData.getData ){
	                            pastedContent = window.clipboardData.getData("Text");
	                            processpaste(pastedContent);
	                            e.stopPropagation();
	                            e.preventDefault();
	                            return false;
	                        }
	                        if (clipboardData && clipboardData.getData && clipboardData.types.length > 0) {// Webkit - get data from clipboard, put into editdiv, cleanup, then cancel event
	                            var _types = "";
	                            for(var _t = 0; _t < clipboardData.types.length; _t++){
	                                _types += " " + clipboardData.types[_t];
	                            }
	                            /* istanbul ignore next: browser tests */
	                            if (/text\/html/i.test(_types)) {
	                                pastedContent = clipboardData.getData('text/html');
	                            } else if (/text\/plain/i.test(_types)) {
	                                pastedContent = clipboardData.getData('text/plain');
	                            }
	                            processpaste(pastedContent);
	                            e.stopPropagation();
	                            e.preventDefault();
	                            return false;
	                        } else {// Everything else - empty editdiv and allow browser to paste content into it, then cleanup
	                            var _savedSelection = rangy.saveSelection(),
	                                _tempDiv = angular.element('<div class="ta-hidden-input" contenteditable="true"></div>');
	                            $document.find('body').append(_tempDiv);
	                            _tempDiv[0].focus();
	                            $timeout(function(){
	                                // restore selection
	                                rangy.restoreSelection(_savedSelection);
	                                processpaste(_tempDiv[0].innerHTML);
	                                element[0].focus();
	                                _tempDiv.remove();
	                            }, 0);
	                        }
	                    });
	                    element.on('cut', scope.events.cut = function(e){
	                        // timeout to next is needed as otherwise the paste/cut event has not finished actually changing the display
	                        if(!_isReadonly) $timeout(function(){
	                            ngModel.$setViewValue(_compileHtml());
	                        }, 0);
	                        else e.preventDefault();
	                    });
	
	                    element.on('keydown', scope.events.keydown = function(event, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(event, eventData);
	                        if (event.keyCode === _SHIFT_KEYCODE) {
	                            taSelection.setStateShiftKey(true);
	                        } else {
	                            taSelection.setStateShiftKey(false);
	                        }
	                        event.specialKey = _mapKeys(event);
	                        var userSpecialKey;
	                        /* istanbul ignore next: difficult to test */
	                        taOptions.keyMappings.forEach(function (mapping) {
	                            if (event.specialKey === mapping.commandKeyCode) {
	                                // taOptions has remapped this binding... so
	                                // we disable our own
	                                event.specialKey = undefined;
	                            }
	                            if (mapping.testForKey(event)) {
	                                userSpecialKey = mapping.commandKeyCode;
	                            }
	                            if ((mapping.commandKeyCode === 'UndoKey') || (mapping.commandKeyCode === 'RedoKey')) {
	                                // this is necessary to fully stop the propagation.
	                                if (!mapping.enablePropagation) {
	                                    event.preventDefault();
	                                }
	                            }
	                        });
	                        /* istanbul ignore next: difficult to test */
	                        if (typeof userSpecialKey !== 'undefined') {
	                            event.specialKey = userSpecialKey;
	                        }
	                        /* istanbul ignore next: difficult to test as can't seem to select */
	                        if ((typeof event.specialKey !== 'undefined') && (
	                                event.specialKey !== 'UndoKey' || event.specialKey !== 'RedoKey'
	                            )) {
	                            event.preventDefault();
	                            textAngularManager.sendKeyCommand(scope, event);
	                        }
	                        /* istanbul ignore else: readonly check */
	                        if(!_isReadonly){
	                            if (event.specialKey==='UndoKey') {
	                                _undo();
	                                event.preventDefault();
	                            }
	                            if (event.specialKey==='RedoKey') {
	                                _redo();
	                                event.preventDefault();
	                            }
	                            /* istanbul ignore next: difficult to test as can't seem to select */
	                            if(event.keyCode === _ENTER_KEYCODE && !event.shiftKey && !event.ctrlKey && !event.metaKey && !event.altKey)
	                            {
	                                var contains = function(a, obj) {
	                                    for (var i = 0; i < a.length; i++) {
	                                        if (a[i] === obj) {
	                                            return true;
	                                        }
	                                    }
	                                    return false;
	                                };
	                                var $selection;
	                                var selection = taSelection.getSelectionElement();
	                                // shifted to nodeName here from tagName since it is more widely supported see: http://stackoverflow.com/questions/4878484/difference-between-tagname-and-nodename
	                                if(!selection.nodeName.match(VALIDELEMENTS)) return;
	                                var _new = angular.element(_defaultVal);
	                                // if we are in the last element of a blockquote, or ul or ol and the element is blank
	                                // we need to pull the element outside of the said type
	                                var moveOutsideElements = ['blockquote', 'ul', 'ol'];
	                                if (contains(moveOutsideElements, selection.parentNode.tagName.toLowerCase())) {
	                                    if (/^<br(|\/)>$/i.test(selection.innerHTML.trim()) && !selection.nextSibling) {
	                                        // if last element is blank, pull element outside.
	                                        $selection = angular.element(selection);
	                                        var _parent = $selection.parent();
	                                        _parent.after(_new);
	                                        $selection.remove();
	                                        if (_parent.children().length === 0) _parent.remove();
	                                        taSelection.setSelectionToElementStart(_new[0]);
	                                        event.preventDefault();
	                                    }
	                                    if (/^<[^>]+><br(|\/)><\/[^>]+>$/i.test(selection.innerHTML.trim())) {
	                                        $selection = angular.element(selection);
	                                        $selection.after(_new);
	                                        $selection.remove();
	                                        taSelection.setSelectionToElementStart(_new[0]);
	                                        event.preventDefault();
	                                    }
	                                }
	                            }
	                        }
	                    });
	                    var _keyupTimeout;
	                    element.on('keyup', scope.events.keyup = function(event, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(event, eventData);
	                        taSelection.setStateShiftKey(false);	// clear the ShiftKey state
	                        /* istanbul ignore next: FF specific bug fix */
	                        if (event.keyCode === _TAB_KEYCODE) {
	                            var _selection = taSelection.getSelection();
	                            if(_selection.start.element === element[0] && element.children().length) taSelection.setSelectionToElementStart(element.children()[0]);
	                            return;
	                        }
	                        // we do this here during the 'keyup' so that the browser has already moved the slection by one character...
	                        if (event.keyCode === _LEFT_ARROW_KEYCODE && !event.shiftKey) {
	                            taSelection.updateLeftArrowKey(element);
	                        }
	                        // we do this here during the 'keyup' so that the browser has already moved the slection by one character...
	                        if (event.keyCode === _RIGHT_ARROW_KEYCODE && !event.shiftKey) {
	                            taSelection.updateRightArrowKey(element);
	                        }
	                        if(_undoKeyupTimeout) $timeout.cancel(_undoKeyupTimeout);
	                        if(!_isReadonly && !BLOCKED_KEYS.test(event.keyCode)){
	                            /* istanbul ignore next: Ignore any _ENTER_KEYCODE that has ctrlKey, metaKey or alKey */
	                            if (event.keyCode === _ENTER_KEYCODE && (event.ctrlKey || event.metaKey || event.altKey)) {
	                                // we ignore any ENTER_	KEYCODE that is anything but plain or a shift one...
	                            } else {
	                                // if enter - insert new taDefaultWrap, if shift+enter insert <br/>
	                                if(_defaultVal !== '' && _defaultVal !== '<BR><BR>' && event.keyCode === _ENTER_KEYCODE && !event.ctrlKey && !event.metaKey && !event.altKey){
	                                    var selection = taSelection.getSelectionElement();
	                                    while(!selection.nodeName.match(VALIDELEMENTS) && selection !== element[0]){
	                                        selection = selection.parentNode;
	                                    }
	                                    if(!event.shiftKey){
	                                        // new paragraph, br should be caught correctly
	                                        // shifted to nodeName here from tagName since it is more widely supported see: http://stackoverflow.com/questions/4878484/difference-between-tagname-and-nodename
	                                        //console.log('Enter', selection.nodeName, attrs.taDefaultWrap, selection.innerHTML.trim());
	                                        if(selection.tagName.toLowerCase() !==
	                                            attrs.taDefaultWrap &&
	                                            selection.nodeName.toLowerCase() !== 'li' &&
	                                            (selection.innerHTML.trim() === '' || selection.innerHTML.trim() === '<br>')
	                                        ) {
	                                            // Chrome starts with a <div><br></div> after an EnterKey
	                                            // so we replace this with the _defaultVal
	                                            var _new = angular.element(_defaultVal);
	                                            angular.element(selection).replaceWith(_new);
	                                            taSelection.setSelectionToElementStart(_new[0]);
	                                        }
	                                    } else {
	                                        // shift + Enter
	                                        var tagName = selection.tagName.toLowerCase();
	                                        //console.log('Shift+Enter', selection.tagName, attrs.taDefaultWrap, selection.innerHTML.trim());
	                                        // For an LI: We see: LI p ....<br><br>
	                                        // For a P: We see: P p ....<br><br>
	                                        // on Safari, the browser ignores the Shift+Enter and acts just as an Enter Key
	                                        // For an LI: We see: LI p <br>
	                                        // For a P: We see: P p <br>
	                                        if((tagName === attrs.taDefaultWrap ||
	                                            tagName === 'li' ||
	                                            tagName === 'pre' ||
	                                            tagName === 'div') &&
	                                            !/.+<br><br>/.test(selection.innerHTML.trim())) {
	                                            var ps = selection.previousSibling;
	                                            //console.log('wrong....', ps);
	                                            // we need to remove this selection and fix the previousSibling up...
	                                            if (ps) {
	                                                ps.innerHTML = ps.innerHTML + '<br><br>';
	                                                angular.element(selection).remove();
	                                                taSelection.setSelectionToElementEnd(ps);
	                                            }
	                                        }
	                                    }
	                                }
	                                var val = _compileHtml();
	                                if(_defaultVal !== '' && (val.trim() === '' || val.trim() === '<br>')){
	                                    _setInnerHTML(_defaultVal);
	                                    taSelection.setSelectionToElementStart(element.children()[0]);
	                                }else if(val.substring(0, 1) !== '<' && attrs.taDefaultWrap !== ''){
	                                    /* we no longer do this, since there can be comments here and white space
	                                     var _savedSelection = rangy.saveSelection();
	                                     val = _compileHtml();
	                                     val = "<" + attrs.taDefaultWrap + ">" + val + "</" + attrs.taDefaultWrap + ">";
	                                     _setInnerHTML(val);
	                                     rangy.restoreSelection(_savedSelection);
	                                     */
	                                }
	                                var triggerUndo = _lastKey !== event.keyCode && UNDO_TRIGGER_KEYS.test(event.keyCode);
	                                if(_keyupTimeout) $timeout.cancel(_keyupTimeout);
	                                _keyupTimeout = $timeout(function() {
	                                    _setViewValue(val, triggerUndo, true);
	                                }, ngModelOptions.$options.debounce || 400);
	                                if(!triggerUndo) _undoKeyupTimeout = $timeout(function(){ ngModel.$undoManager.push(val); }, 250);
	                                _lastKey = event.keyCode;
	                            }
	                        }
	                    });
	
	                    // when there is a change from a spelling correction in the browser, the only
	                    // change that is seen is a 'input' and the $watch('html') sees nothing... So
	                    // we added this element.on('input') to catch this change and call the _setViewValue()
	                    // so the ngModel is updated and all works as it should.
	                    var _inputTimeout;
	                    element.on('input', function() {
	                        if (_compileHtml() !== ngModel.$viewValue) {
	                            // we wait a time now to allow the natural $watch('html') to handle this change
	                            // and then after a 1 second delay, if there is still a difference we will do the
	                            // _setViewValue() call.
	                            /* istanbul ignore if: can't test */
	                            if(_inputTimeout) $timeout.cancel(_inputTimeout);
	                            /* istanbul ignore next: cant' test? */
	                            _inputTimeout = $timeout(function() {
	                                var _savedSelection = rangy.saveSelection();
	                                var _val = _compileHtml();
	                                if (_val !== ngModel.$viewValue) {
	                                    //console.log('_setViewValue');
	                                    //console.log('old:', ngModel.$viewValue);
	                                    //console.log('new:', _val);
	                                    _setViewValue(_val, true);
	                                }
	                                // if the savedSelection marker is gone at this point, we cannot restore the selection!!!
	                                //console.log('rangy.restoreSelection', ngModel.$viewValue.length, _savedSelection);
	                                if (ngModel.$viewValue.length !== 0) {
	                                    rangy.restoreSelection(_savedSelection);
	                                }
	                            }, 1000);
	                        }
	                    });
	
	                    element.on('blur', scope.events.blur = function(){
	                        _focussed = false;
	                        /* istanbul ignore else: if readonly don't update model */
	                        if(!_isReadonly){
	                            _setViewValue(undefined, undefined, true);
	                        }else{
	                            _skipRender = true; // don't redo the whole thing, just check the placeholder logic
	                            ngModel.$render();
	                        }
	                    });
	
	                    // Placeholders not supported on ie 8 and below
	                    if(attrs.placeholder && (_browserDetect.ie > 8 || _browserDetect.ie === undefined)){
	                        var rule;
	                        if(attrs.id) rule = addCSSRule('#' + attrs.id + '.placeholder-text:before', 'content: "' + attrs.placeholder + '"');
	                        else throw('textAngular Error: An unique ID is required for placeholders to work');
	
	                        scope.$on('$destroy', function(){
	                            removeCSSRule(rule);
	                        });
	                    }
	
	                    element.on('focus', scope.events.focus = function(){
	                        _focussed = true;
	                        element.removeClass('placeholder-text');
	                        _reApplyOnSelectorHandlers();
	                    });
	
	                    element.on('mouseup', scope.events.mouseup = function(){
	                        var _selection = taSelection.getSelection();
	                        if(_selection && _selection.start.element === element[0] && element.children().length) taSelection.setSelectionToElementStart(element.children()[0]);
	                    });
	
	                    // prevent propagation on mousedown in editor, see #206
	                    element.on('mousedown', scope.events.mousedown = function(event, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(event, eventData);
	                        event.stopPropagation();
	                    });
	                }
	            }
	
	            var fileDropHandler = function(event, eventData){
	                /* istanbul ignore else: this is for catching the jqLite testing*/
	                if(eventData) angular.extend(event, eventData);
	                // emit the drop event, pass the element, preventing should be done elsewhere
	                if(!dropFired && !_isReadonly){
	                    dropFired = true;
	                    var dataTransfer;
	                    if(event.originalEvent) dataTransfer = event.originalEvent.dataTransfer;
	                    else dataTransfer = event.dataTransfer;
	                    scope.$emit('ta-drop-event', this, event, dataTransfer);
	                    $timeout(function(){
	                        dropFired = false;
	                        _setViewValue(undefined, undefined, true);
	                    }, 100);
	                }
	            };
	
	            var _renderTimeout;
	            var _renderInProgress = false;
	            // changes to the model variable from outside the html/text inputs
	            ngModel.$render = function(){
	                /* istanbul ignore if: Catches rogue renders, hard to replicate in tests */
	                if(_renderInProgress) return;
	                else _renderInProgress = true;
	                // catch model being null or undefined
	                var val = ngModel.$viewValue || '';
	                // if the editor isn't focused it needs to be updated, otherwise it's receiving user input
	                if(!_skipRender){
	                    /* istanbul ignore else: in other cases we don't care */
	                    if(_isContentEditable && _focussed){
	                        // update while focussed
	                        element.removeClass('placeholder-text');
	                        /* istanbul ignore next: don't know how to test this */
	                        if(_renderTimeout) $timeout.cancel(_renderTimeout);
	                        _renderTimeout = $timeout(function(){
	                            /* istanbul ignore if: Can't be bothered testing this... */
	                            if(!_focussed){
	                                element[0].focus();
	                                taSelection.setSelectionToElementEnd(element.children()[element.children().length - 1]);
	                            }
	                            _renderTimeout = undefined;
	                        }, 1);
	                    }
	                    if(_isContentEditable){
	                        // WYSIWYG Mode
	                        if(attrs.placeholder){
	                            if(val === ''){
	                                // blank
	                                _setInnerHTML(_defaultVal);
	                            }else{
	                                // not-blank
	                                _setInnerHTML(val);
	                            }
	                        }else{
	                            _setInnerHTML((val === '') ? _defaultVal : val);
	                        }
	                        // if in WYSIWYG and readOnly we kill the use of links by clicking
	                        if(!_isReadonly){
	                            _reApplyOnSelectorHandlers();
	                            element.on('drop', fileDropHandler);
	                        }else{
	                            element.off('drop', fileDropHandler);
	                        }
	                    }else if(element[0].tagName.toLowerCase() !== 'textarea' && element[0].tagName.toLowerCase() !== 'input'){
	                        // make sure the end user can SEE the html code as a display. This is a read-only display element
	                        _setInnerHTML(taApplyCustomRenderers(val));
	                    }else{
	                        // only for input and textarea inputs
	                        element.val(val);
	                    }
	                }
	                if(_isContentEditable && attrs.placeholder){
	                    if(val === ''){
	                        if(_focussed) element.removeClass('placeholder-text');
	                        else element.addClass('placeholder-text');
	                    }else{
	                        element.removeClass('placeholder-text');
	                    }
	                }
	                _renderInProgress = _skipRender = false;
	            };
	
	            if(attrs.taReadonly){
	                //set initial value
	                _isReadonly = scope.$eval(attrs.taReadonly);
	                if(_isReadonly){
	                    element.addClass('ta-readonly');
	                    // we changed to readOnly mode (taReadonly='true')
	                    if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
	                        element.attr('disabled', 'disabled');
	                    }
	                    if(element.attr('contenteditable') !== undefined && element.attr('contenteditable')){
	                        element.removeAttr('contenteditable');
	                    }
	                }else{
	                    element.removeClass('ta-readonly');
	                    // we changed to NOT readOnly mode (taReadonly='false')
	                    if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
	                        element.removeAttr('disabled');
	                    }else if(_isContentEditable){
	                        element.attr('contenteditable', 'true');
	                    }
	                }
	                // taReadonly only has an effect if the taBind element is an input or textarea or has contenteditable='true' on it.
	                // Otherwise it is readonly by default
	                scope.$watch(attrs.taReadonly, function(newVal, oldVal){
	                    if(oldVal === newVal) return;
	                    if(newVal){
	                        element.addClass('ta-readonly');
	                        // we changed to readOnly mode (taReadonly='true')
	                        if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
	                            element.attr('disabled', 'disabled');
	                        }
	                        if(element.attr('contenteditable') !== undefined && element.attr('contenteditable')){
	                            element.removeAttr('contenteditable');
	                        }
	                        // turn ON selector click handlers
	                        angular.forEach(taSelectableElements, function(selector){
	                            element.find(selector).on('click', selectorClickHandler);
	                        });
	                        element.off('drop', fileDropHandler);
	                    }else{
	                        element.removeClass('ta-readonly');
	                        // we changed to NOT readOnly mode (taReadonly='false')
	                        if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
	                            element.removeAttr('disabled');
	                        }else if(_isContentEditable){
	                            element.attr('contenteditable', 'true');
	                        }
	                        // remove the selector click handlers
	                        angular.forEach(taSelectableElements, function(selector){
	                            element.find(selector).off('click', selectorClickHandler);
	                        });
	                        element.on('drop', fileDropHandler);
	                    }
	                    _isReadonly = newVal;
	                });
	            }
	
	            // Initialise the selectableElements
	            // if in WYSIWYG and readOnly we kill the use of links by clicking
	            if(_isContentEditable && !_isReadonly){
	                angular.forEach(taSelectableElements, function(selector){
	                    element.find(selector).on('click', selectorClickHandler);
	                });
	                element.on('drop', fileDropHandler);
	            }
	        }
	    };
	}]);
	
	// this global var is used to prevent multiple fires of the drop event. Needs to be global to the textAngular file.
	var dropFired = false;
	var textAngular = angular.module("textAngular", ['ngSanitize', 'textAngularSetup', 'textAngular.factories', 'textAngular.DOM', 'textAngular.validators', 'textAngular.taBind']); //This makes ngSanitize required
	
	textAngular.config([function(){
	    // clear taTools variable. Just catches testing and any other time that this config may run multiple times...
	    angular.forEach(taTools, function(value, key){ delete taTools[key];	});
	}]);
	
	textAngular.directive("textAngular", [
	    '$compile', '$timeout', 'taOptions', 'taSelection', 'taExecCommand',
	    'textAngularManager', '$document', '$animate', '$log', '$q', '$parse',
	    function($compile, $timeout, taOptions, taSelection, taExecCommand,
	        textAngularManager, $document, $animate, $log, $q, $parse){
	        return {
	            require: '?ngModel',
	            scope: {},
	            restrict: "EA",
	            priority: 2, // So we override validators correctly
	            link: function(scope, element, attrs, ngModel){
	                // all these vars should not be accessable outside this directive
	                var _keydown, _keyup, _keypress, _mouseup, _focusin, _focusout,
	                    _originalContents, _editorFunctions,
	                    _serial = (attrs.serial) ? attrs.serial : Math.floor(Math.random() * 10000000000000000),
	                    _taExecCommand, _resizeMouseDown, _updateSelectedStylesTimeout;
	                var _resizeTimeout;
	
	                scope._name = (attrs.name) ? attrs.name : 'textAngularEditor' + _serial;
	
	                var oneEvent = function(_element, event, action){
	                    $timeout(function(){
	                        _element.one(event, action);
	                    }, 100);
	                };
	                _taExecCommand = taExecCommand(attrs.taDefaultWrap);
	                // get the settings from the defaults and add our specific functions that need to be on the scope
	                angular.extend(scope, angular.copy(taOptions), {
	                    // wraps the selection in the provided tag / execCommand function. Should only be called in WYSIWYG mode.
	                    wrapSelection: function(command, opt, isSelectableElementTool){
	                        // we restore the saved selection that was saved when focus was lost
	                        /* NOT FUNCTIONAL YET */
	                        /* textAngularManager.restoreFocusSelection(scope._name, scope); */
	                        if(command.toLowerCase() === "undo"){
	                            scope['$undoTaBindtaTextElement' + _serial]();
	                        }else if(command.toLowerCase() === "redo"){
	                            scope['$redoTaBindtaTextElement' + _serial]();
	                        }else{
	                            // catch errors like FF erroring when you try to force an undo with nothing done
	                            _taExecCommand(command, false, opt, scope.defaultTagAttributes);
	                            if(isSelectableElementTool){
	                                // re-apply the selectable tool events
	                                scope['reApplyOnSelectorHandlerstaTextElement' + _serial]();
	                            }
	                            // refocus on the shown display element, this fixes a display bug when using :focus styles to outline the box.
	                            // You still have focus on the text/html input it just doesn't show up
	                            scope.displayElements.text[0].focus();
	                        }
	                    },
	                    showHtml: scope.$eval(attrs.taShowHtml) || false
	                });
	                // setup the options from the optional attributes
	                if(attrs.taFocussedClass)			scope.classes.focussed = attrs.taFocussedClass;
	                if(attrs.taTextEditorClass)			scope.classes.textEditor = attrs.taTextEditorClass;
	                if(attrs.taHtmlEditorClass)			scope.classes.htmlEditor = attrs.taHtmlEditorClass;
	                if(attrs.taDefaultTagAttributes){
	                    try	{
	                        //	TODO: This should use angular.merge to enhance functionality once angular 1.4 is required
	                        angular.extend(scope.defaultTagAttributes, angular.fromJson(attrs.taDefaultTagAttributes));
	                    } catch (error) {
	                        $log.error(error);
	                    }
	                }
	                // optional setup functions
	                if(attrs.taTextEditorSetup)			scope.setup.textEditorSetup = scope.$parent.$eval(attrs.taTextEditorSetup);
	                if(attrs.taHtmlEditorSetup)			scope.setup.htmlEditorSetup = scope.$parent.$eval(attrs.taHtmlEditorSetup);
	                // optional fileDropHandler function
	                if(attrs.taFileDrop)				scope.fileDropHandler = scope.$parent.$eval(attrs.taFileDrop);
	                else								scope.fileDropHandler = scope.defaultFileDropHandler;
	
	                _originalContents = element[0].innerHTML;
	                // clear the original content
	                element[0].innerHTML = '';
	
	                // Setup the HTML elements as variable references for use later
	                scope.displayElements = {
	                    // we still need the hidden input even with a textarea as the textarea may have invalid/old input in it,
	                    // wheras the input will ALLWAYS have the correct value.
	                    forminput: angular.element("<input type='hidden' tabindex='-1' style='display: none;'>"),
	                    html: angular.element("<textarea></textarea>"),
	                    text: angular.element("<div></div>"),
	                    // other toolbased elements
	                    scrollWindow: angular.element("<div class='ta-scroll-window'></div>"),
	                    popover: angular.element('<div class="popover fade bottom" style="max-width: none; width: 305px;"></div>'),
	                    popoverArrow: angular.element('<div class="arrow"></div>'),
	                    popoverContainer: angular.element('<div class="popover-content"></div>'),
	                    resize: {
	                        overlay: angular.element('<div class="ta-resizer-handle-overlay"></div>'),
	                        background: angular.element('<div class="ta-resizer-handle-background"></div>'),
	                        anchors: [
	                            angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tl"></div>'),
	                            angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tr"></div>'),
	                            angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-bl"></div>'),
	                            angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-br"></div>')
	                        ],
	                        info: angular.element('<div class="ta-resizer-handle-info"></div>')
	                    }
	                };
	
	                // Setup the popover
	                scope.displayElements.popover.append(scope.displayElements.popoverArrow);
	                scope.displayElements.popover.append(scope.displayElements.popoverContainer);
	                scope.displayElements.scrollWindow.append(scope.displayElements.popover);
	
	                scope.displayElements.popover.on('mousedown', function(e, eventData){
	                    /* istanbul ignore else: this is for catching the jqLite testing*/
	                    if(eventData) angular.extend(e, eventData);
	                    // this prevents focusout from firing on the editor when clicking anything in the popover
	                    e.preventDefault();
	                    return false;
	                });
	
	                /* istanbul ignore next: popover resize and scroll events handled */
	                scope.handlePopoverEvents = function() {
	                    if (scope.displayElements.popover.css('display')==='block') {
	                        if(_resizeTimeout) $timeout.cancel(_resizeTimeout);
	                        _resizeTimeout = $timeout(function() {
	                            //console.log('resize', scope.displayElements.popover.css('display'));
	                            scope.reflowPopover(scope.resizeElement);
	                            scope.reflowResizeOverlay(scope.resizeElement);
	                        }, 100);
	                    }
	                };
	
	                /* istanbul ignore next: browser resize check */
	                angular.element(window).on('resize', scope.handlePopoverEvents);
	
	                /* istanbul ignore next: browser scroll check */
	                angular.element(window).on('scroll', scope.handlePopoverEvents);
	
	                // we want to know if a given node has a scrollbar!
	                // credit to lotif on http://stackoverflow.com/questions/4880381/check-whether-html-element-has-scrollbars
	                var isScrollable = function(node) {
	                    var cs;
	                    var _notScrollable = {
	                        vertical: false,
	                        horizontal: false,
	                    };
	                    try {
	                        cs = window.getComputedStyle(node);
	                        if (cs === null) {
	                            return _notScrollable;
	                        }
	                    } catch (e) {
	                        /* istanbul ignore next: error handler */
	                        return _notScrollable;
	                    }
	                    var overflowY = cs['overflow-y'];
	                    var overflowX = cs['overflow-x'];
	                    return {
	                        vertical: (overflowY === 'scroll' || overflowY === 'auto') &&
	                                    /* istanbul ignore next: not tested */
	                                    node.scrollHeight > node.clientHeight,
	                        horizontal: (overflowX === 'scroll' || overflowX === 'auto') &&
	                                    /* istanbul ignore next: not tested */
	                                    node.scrollWidth > node.clientWidth,
	                    };
	                };
	
	                // getScrollTop
	                //
	                // we structure this so that it can climb the parents of the _el and when it finds
	                // one with scrollbars, it adds an EventListener, so that no matter how the
	                // DOM is structured in the user APP, if there is a scrollbar not as part of the
	                // ta-scroll-window, we will still capture the 'scroll' events...
	                // and handle the scroll event properly and do the resize, etc.
	                //
	                scope.getScrollTop = function (_el, bAddListener) {
	                    var scrollTop = _el.scrollTop;
	                    if (typeof scrollTop === 'undefined') {
	                        scrollTop = 0;
	                    }
	                    /* istanbul ignore next: triggered only if has scrollbar */
	                    if (bAddListener && isScrollable(_el).vertical) {
	                        // remove element eventListener
	                        _el.removeEventListener('scroll', scope._scrollListener, false);
	                        _el.addEventListener('scroll', scope._scrollListener, false);
	                    }
	                    /* istanbul ignore next: triggered only if has scrollbar and scrolled */
	                    if (scrollTop !== 0) {
	                        return { node:_el.nodeName, top:scrollTop };
	                    }
	                    /* istanbul ignore else: catches only if no scroll */
	                    if (_el.parentNode) {
	                        return scope.getScrollTop(_el.parentNode, bAddListener);
	                    } else {
	                        return { node:'<none>', top:0 };
	                    }
	                };
	
	                // define the popover show and hide functions
	                scope.showPopover = function(_el){
	                    scope.getScrollTop(scope.displayElements.scrollWindow[0], true);
	                    scope.displayElements.popover.css('display', 'block');
	                    // we must use a $timeout here, or the css change to the
	                    // displayElements.resize.overlay will not take!!!
	                    // WHY???
	                    $timeout(function() {
	                        scope.displayElements.resize.overlay.css('display', 'block');
	                    });
	                    scope.resizeElement = _el;
	                    scope.reflowPopover(_el);
	                    $animate.addClass(scope.displayElements.popover, 'in');
	                    oneEvent($document.find('body'), 'click keyup', function(){scope.hidePopover();});
	                };
	
	                /* istanbul ignore next: browser scroll event handler */
	                scope._scrollListener = function (e, eventData){
	                    scope.handlePopoverEvents();
	                };
	
	                scope.reflowPopover = function(_el){
	                    var scrollTop = scope.getScrollTop(scope.displayElements.scrollWindow[0], false);
	                    var spaceAboveImage = _el[0].offsetTop-scrollTop.top;
	                    //var spaceBelowImage = scope.displayElements.text[0].offsetHeight - _el[0].offsetHeight - spaceAboveImage;
	                    //console.log(spaceAboveImage, spaceBelowImage);
	
	                    /* istanbul ignore if: catches only if near bottom of editor */
	                    if(spaceAboveImage < 51) {
	                        scope.displayElements.popover.css('top', _el[0].offsetTop + _el[0].offsetHeight + scope.displayElements.scrollWindow[0].scrollTop + 'px');
	                        scope.displayElements.popover.removeClass('top').addClass('bottom');
	                    } else {
	                        scope.displayElements.popover.css('top', _el[0].offsetTop - 54 + scope.displayElements.scrollWindow[0].scrollTop + 'px');
	                        scope.displayElements.popover.removeClass('bottom').addClass('top');
	                    }
	                    var _maxLeft = scope.displayElements.text[0].offsetWidth - scope.displayElements.popover[0].offsetWidth;
	                    var _targetLeft = _el[0].offsetLeft + (_el[0].offsetWidth / 2.0) - (scope.displayElements.popover[0].offsetWidth / 2.0);
	                    var _rleft = Math.max(0, Math.min(_maxLeft, _targetLeft));
	                    var _marginLeft = (Math.min(_targetLeft, (Math.max(0, _targetLeft - _maxLeft))) - 11);
	                    _rleft += window.scrollX;
	                    _marginLeft -= window.scrollX;
	                    scope.displayElements.popover.css('left', _rleft + 'px');
	                    scope.displayElements.popoverArrow.css('margin-left', _marginLeft + 'px');
	                };
	                scope.hidePopover = function(){
	                    scope.displayElements.popover.css('display', 'none');
	                    scope.displayElements.popoverContainer.attr('style', '');
	                    scope.displayElements.popoverContainer.attr('class', 'popover-content');
	                    scope.displayElements.popover.removeClass('in');
	                    scope.displayElements.resize.overlay.css('display', 'none');
	                };
	
	                // setup the resize overlay
	                scope.displayElements.resize.overlay.append(scope.displayElements.resize.background);
	                angular.forEach(scope.displayElements.resize.anchors, function(anchor){ scope.displayElements.resize.overlay.append(anchor);});
	                scope.displayElements.resize.overlay.append(scope.displayElements.resize.info);
	                scope.displayElements.scrollWindow.append(scope.displayElements.resize.overlay);
	
	                // A click event on the resize.background will now shift the focus to the editor
	                /* istanbul ignore next: click on the resize.background to focus back to editor */
	                scope.displayElements.resize.background.on('click', function(e) {
	                    scope.displayElements.text[0].focus();
	                });
	
	                // define the show and hide events
	                scope.reflowResizeOverlay = function(_el){
	                    _el = angular.element(_el)[0];
	                    scope.displayElements.resize.overlay.css({
	                        'display': 'block',
	                        'left': _el.offsetLeft - 5 + 'px',
	                        'top': _el.offsetTop - 5 + 'px',
	                        'width': _el.offsetWidth + 10 + 'px',
	                        'height': _el.offsetHeight + 10 + 'px'
	                    });
	                    scope.displayElements.resize.info.text(_el.offsetWidth + ' x ' + _el.offsetHeight);
	                };
	                /* istanbul ignore next: pretty sure phantomjs won't test this */
	                scope.showResizeOverlay = function(_el){
	                    var _body = $document.find('body');
	                    _resizeMouseDown = function(event){
	                        var startPosition = {
	                            width: parseInt(_el.attr('width')),
	                            height: parseInt(_el.attr('height')),
	                            x: event.clientX,
	                            y: event.clientY
	                        };
	                        if(startPosition.width === undefined || isNaN(startPosition.width)) startPosition.width = _el[0].offsetWidth;
	                        if(startPosition.height === undefined || isNaN(startPosition.height)) startPosition.height = _el[0].offsetHeight;
	                        scope.hidePopover();
	                        var ratio = startPosition.height / startPosition.width;
	                        var mousemove = function(event){
	                            // calculate new size
	                            var pos = {
	                                x: Math.max(0, startPosition.width + (event.clientX - startPosition.x)),
	                                y: Math.max(0, startPosition.height + (event.clientY - startPosition.y))
	                            };
	
	                            // DEFAULT: the aspect ratio is not locked unless the Shift key is pressed.
	                            //
	                            // attribute: ta-resize-force-aspect-ratio -- locks resize into maintaing the aspect ratio
	                            var bForceAspectRatio = (attrs.taResizeForceAspectRatio !== undefined);
	                            // attribute: ta-resize-maintain-aspect-ratio=true causes the space ratio to remain locked
	                            // unless the Shift key is pressed
	                            var bFlipKeyBinding = attrs.taResizeMaintainAspectRatio;
	                            var bKeepRatio =  bForceAspectRatio || (bFlipKeyBinding && !event.shiftKey);
	                            if(bKeepRatio) {
	                                var newRatio = pos.y / pos.x;
	                                pos.x = ratio > newRatio ? pos.x : pos.y / ratio;
	                                pos.y = ratio > newRatio ? pos.x * ratio : pos.y;
	                            }
	                            var el = angular.element(_el);
	                            function roundedMaxVal(val) {
	                                return Math.round(Math.max(0, val));
	                            }
	                            el.css('height', roundedMaxVal(pos.y) + 'px');
	                            el.css('width', roundedMaxVal(pos.x) + 'px');
	
	                            // reflow the popover tooltip
	                            scope.reflowResizeOverlay(_el);
	                        };
	                        _body.on('mousemove', mousemove);
	                        oneEvent(_body, 'mouseup', function(event){
	                            event.preventDefault();
	                            event.stopPropagation();
	                            _body.off('mousemove', mousemove);
	                            // at this point, we need to force the model to update! since the css has changed!
	                            // this fixes bug: #862 - we now hide the popover -- as this seems more consitent.
	                            // there are still issues under firefox, the window does not repaint. -- not sure
	                            // how best to resolve this, but clicking anywhere works.
	                            scope.$apply(function (){
	                                scope.hidePopover();
	                                scope.updateTaBindtaTextElement();
	                            }, 100);
	                        });
	                        event.stopPropagation();
	                        event.preventDefault();
	                    };
	
	                    scope.displayElements.resize.anchors[3].off('mousedown');
	                    scope.displayElements.resize.anchors[3].on('mousedown', _resizeMouseDown);
	
	                    scope.reflowResizeOverlay(_el);
	                    oneEvent(_body, 'click', function(){scope.hideResizeOverlay();});
	                };
	                /* istanbul ignore next: pretty sure phantomjs won't test this */
	                scope.hideResizeOverlay = function(){
	                    scope.displayElements.resize.anchors[3].off('mousedown', _resizeMouseDown);
	                    scope.displayElements.resize.overlay.css('display', 'none');
	                };
	
	                // allow for insertion of custom directives on the textarea and div
	                scope.setup.htmlEditorSetup(scope.displayElements.html);
	                scope.setup.textEditorSetup(scope.displayElements.text);
	                scope.displayElements.html.attr({
	                    'id': 'taHtmlElement' + _serial,
	                    'ng-show': 'showHtml',
	                    'ta-bind': 'ta-bind',
	                    'ng-model': 'html',
	                    'ng-model-options': element.attr('ng-model-options')
	                });
	                scope.displayElements.text.attr({
	                    'id': 'taTextElement' + _serial,
	                    'contentEditable': 'true',
	                    'ta-bind': 'ta-bind',
	                    'ng-model': 'html',
	                    'ng-model-options': element.attr('ng-model-options')
	                });
	                scope.displayElements.scrollWindow.attr({'ng-hide': 'showHtml'});
	                if(attrs.taDefaultWrap) {
	                    // taDefaultWrap is only applied to the text and not the html view
	                    scope.displayElements.text.attr('ta-default-wrap', attrs.taDefaultWrap);
	                }
	
	                if(attrs.taUnsafeSanitizer){
	                    scope.displayElements.text.attr('ta-unsafe-sanitizer', attrs.taUnsafeSanitizer);
	                    scope.displayElements.html.attr('ta-unsafe-sanitizer', attrs.taUnsafeSanitizer);
	                }
	
	                if(attrs.taKeepStyles){
	                    scope.displayElements.text.attr('ta-keep-styles', attrs.taKeepStyles);
	                    scope.displayElements.html.attr('ta-keep-styles', attrs.taKeepStyles);
	                }
	
	                // add the main elements to the origional element
	                scope.displayElements.scrollWindow.append(scope.displayElements.text);
	                element.append(scope.displayElements.scrollWindow);
	                element.append(scope.displayElements.html);
	
	                scope.displayElements.forminput.attr('name', scope._name);
	                element.append(scope.displayElements.forminput);
	
	                if(attrs.tabindex){
	                    element.removeAttr('tabindex');
	                    scope.displayElements.text.attr('tabindex', attrs.tabindex);
	                    scope.displayElements.html.attr('tabindex', attrs.tabindex);
	                }
	
	                if (attrs.placeholder) {
	                    scope.displayElements.text.attr('placeholder', attrs.placeholder);
	                    scope.displayElements.html.attr('placeholder', attrs.placeholder);
	                }
	
	                if(attrs.taDisabled){
	                    scope.displayElements.text.attr('ta-readonly', 'disabled');
	                    scope.displayElements.html.attr('ta-readonly', 'disabled');
	                    scope.disabled = scope.$parent.$eval(attrs.taDisabled);
	                    scope.$parent.$watch(attrs.taDisabled, function(newVal){
	                        scope.disabled = newVal;
	                        if(scope.disabled){
	                            element.addClass(scope.classes.disabled);
	                        }else{
	                            element.removeClass(scope.classes.disabled);
	                        }
	                    });
	                }
	
	                if(attrs.taPaste){
	                    scope._pasteHandler = function(_html){
	                        return $parse(attrs.taPaste)(scope.$parent, {$html: _html});
	                    };
	                    scope.displayElements.text.attr('ta-paste', '_pasteHandler($html)');
	                }
	
	                // compile the scope with the text and html elements only - if we do this with the main element it causes a compile loop
	                $compile(scope.displayElements.scrollWindow)(scope);
	                $compile(scope.displayElements.html)(scope);
	
	                scope.updateTaBindtaTextElement = scope['updateTaBindtaTextElement' + _serial];
	                scope.updateTaBindtaHtmlElement = scope['updateTaBindtaHtmlElement' + _serial];
	
	                // add the classes manually last
	                element.addClass("ta-root");
	                scope.displayElements.scrollWindow.addClass("ta-text ta-editor " + scope.classes.textEditor);
	                scope.displayElements.html.addClass("ta-html ta-editor " + scope.classes.htmlEditor);
	
	                var testAndSet = function(choice, beforeState) {
	                    /* istanbul ignore next: this is only here because of a bug in rangy where rangy.saveSelection() has cleared the state */
	                    if (beforeState !== $document[0].queryCommandState(choice)) {
	                        $document[0].execCommand(choice, false, null);
	                    }
	                };
	                // used in the toolbar actions
	                scope._actionRunning = false;
	                var _savedSelection = false;
	                scope.startAction = function(){
	                    var _beforeStateBold = false;
	                    var _beforeStateItalic = false;
	                    var _beforeStateUnderline = false;
	                    var _beforeStateStrikethough = false;
	                    scope._actionRunning = true;
	                    _beforeStateBold = $document[0].queryCommandState('bold');
	                    _beforeStateItalic = $document[0].queryCommandState('italic');
	                    _beforeStateUnderline = $document[0].queryCommandState('underline');
	                    _beforeStateStrikethough = $document[0].queryCommandState('strikeThrough');
	                    //console.log('B', _beforeStateBold, 'I', _beforeStateItalic, '_', _beforeStateUnderline, 'S', _beforeStateStrikethough);
	                    // if rangy library is loaded return a function to reload the current selection
	                    _savedSelection = rangy.saveSelection();
	                    // rangy.saveSelection() clear the state of bold, italic, underline, strikethrough
	                    // so we reset them here....!!!
	                    // this fixes bugs #423, #1129, #1105, #693 which are actually rangy bugs!
	                    testAndSet('bold', _beforeStateBold);
	                    testAndSet('italic', _beforeStateItalic);
	                    testAndSet('underline', _beforeStateUnderline);
	                    testAndSet('strikeThrough', _beforeStateStrikethough);
	                    //console.log('B', $document[0].queryCommandState('bold'), 'I', $document[0].queryCommandState('italic'), '_', $document[0].queryCommandState('underline'), 'S', $document[0].queryCommandState('strikeThrough') );
	                    return function(){
	                        if(_savedSelection) rangy.restoreSelection(_savedSelection);
	                        // perhaps if we restore the selections here, we would do better overall???
	                        // BUT what we do above does well in 90% of the cases...
	                    };
	                };
	                scope.endAction = function(){
	                    scope._actionRunning = false;
	                    if(_savedSelection){
	                        if(scope.showHtml){
	                            scope.displayElements.html[0].focus();
	                        }else{
	                            scope.displayElements.text[0].focus();
	                        }
	                        // rangy.restoreSelection(_savedSelection);
	                        rangy.removeMarkers(_savedSelection);
	                    }
	                    _savedSelection = false;
	                    scope.updateSelectedStyles();
	                    // only update if in text or WYSIWYG mode
	                    if(!scope.showHtml) scope['updateTaBindtaTextElement' + _serial]();
	                };
	
	                // note that focusout > focusin is called everytime we click a button - except bad support: http://www.quirksmode.org/dom/events/blurfocus.html
	                // cascades to displayElements.text and displayElements.html automatically.
	                _focusin = function(e){
	                    scope.focussed = true;
	                    element.addClass(scope.classes.focussed);
	/*******  NOT FUNCTIONAL YET
	                    if (e.target.id === 'taTextElement' + _serial) {
	                        console.log('_focusin taTextElement');
	                        // we only do this if NOT focussed
	                        textAngularManager.restoreFocusSelection(scope._name);
	                    }
	*******/
	                    _editorFunctions.focus();
	                    element.triggerHandler('focus');
	                    // we call editorScope.updateSelectedStyles() here because we want the toolbar to be focussed
	                    // as soon as we have focus.  Otherwise this only happens on mousedown or keydown etc...
	                    /* istanbul ignore else: don't run if already running */
	                    if(scope.updateSelectedStyles && !scope._bUpdateSelectedStyles){
	                        // we don't set editorScope._bUpdateSelectedStyles here, because we do not want the
	                        // updateSelectedStyles() to run twice which it will do after 200 msec if we have
	                        // set editorScope._bUpdateSelectedStyles
	                        //
	                        // WOW, normally I would do a scope.$apply here, but this causes ERRORs when doing tests!
	                        $timeout(function () {
	                            scope.updateSelectedStyles();
	                        }, 0);
	                    }
	                };
	                scope.displayElements.html.on('focus', _focusin);
	                scope.displayElements.text.on('focus', _focusin);
	                _focusout = function(e){
	                    /****************** NOT FUNCTIONAL YET
	                    try {
	                        var _s = rangy.getSelection();
	                        if (_s) {
	                            // we save the selection when we loose focus so that if do a wrapSelection, the
	                            // apropriate selection in the editor is restored before action.
	                            var _savedFocusRange = rangy.saveRange(_s.getRangeAt(0));
	                            textAngularManager.saveFocusSelection(scope._name, _savedFocusRange);
	                        }
	                    } catch(error) { }
	                    *****************/
	                    // if we are NOT runnig an action and have NOT focussed again on the text etc then fire the blur events
	                    if(!scope._actionRunning &&
	                        $document[0].activeElement !== scope.displayElements.html[0] &&
	                        $document[0].activeElement !== scope.displayElements.text[0])
	                    {
	                        element.removeClass(scope.classes.focussed);
	                        _editorFunctions.unfocus();
	                        // to prevent multiple apply error defer to next seems to work.
	                        $timeout(function(){
	                            scope._bUpdateSelectedStyles = false;
	                            element.triggerHandler('blur');
	                            scope.focussed = false;
	                        }, 0);
	                    }
	                    e.preventDefault();
	                    return false;
	                };
	                scope.displayElements.html.on('blur', _focusout);
	                scope.displayElements.text.on('blur', _focusout);
	
	                scope.displayElements.text.on('paste', function(event){
	                    element.triggerHandler('paste', event);
	                });
	
	                // Setup the default toolbar tools, this way allows the user to add new tools like plugins.
	                // This is on the editor for future proofing if we find a better way to do this.
	                scope.queryFormatBlockState = function(command){
	                    // $document[0].queryCommandValue('formatBlock') errors in Firefox if we call this when focussed on the textarea
	                    return !scope.showHtml && command.toLowerCase() === $document[0].queryCommandValue('formatBlock').toLowerCase();
	                };
	                scope.queryCommandState = function(command){
	                    // $document[0].queryCommandValue('formatBlock') errors in Firefox if we call this when focussed on the textarea
	                    return (!scope.showHtml) ? $document[0].queryCommandState(command) : '';
	                };
	                scope.switchView = function(){
	                    scope.showHtml = !scope.showHtml;
	                    $animate.enabled(false, scope.displayElements.html);
	                    $animate.enabled(false, scope.displayElements.text);
	                    //Show the HTML view
	                    /* istanbul ignore next: ngModel exists check */
	/* THIS is not the correct thing to do, here....
	   The ngModel is correct, but it is not formatted as the user as done it...
	                    var _model;
	                    if (ngModel) {
	                        _model = ngModel.$viewValue;
	                    } else {
	                        _model = scope.html;
	                    }
	                    var _html = scope.displayElements.html[0].value;
	                    if (getDomFromHtml(_html).childElementCount !== getDomFromHtml(_model).childElementCount) {
	                        // the model and the html do not agree
	                        // they can get out of sync and when they do, we correct that here...
	                        scope.displayElements.html.val(_model);
	                    }
	*/
	                    if(scope.showHtml){
	                        //defer until the element is visible
	                        $timeout(function(){
	                            $animate.enabled(true, scope.displayElements.html);
	                            $animate.enabled(true, scope.displayElements.text);
	                            // [0] dereferences the DOM object from the angular.element
	                            return scope.displayElements.html[0].focus();
	                        }, 100);
	                    }else{
	                        //Show the WYSIWYG view
	                        //defer until the element is visible
	                        $timeout(function(){
	                            $animate.enabled(true, scope.displayElements.html);
	                            $animate.enabled(true, scope.displayElements.text);
	                            // [0] dereferences the DOM object from the angular.element
	                            return scope.displayElements.text[0].focus();
	                        }, 100);
	                    }
	                };
	
	                // changes to the model variable from outside the html/text inputs
	                // if no ngModel, then the only input is from inside text-angular
	                if(attrs.ngModel){
	                    var _firstRun = true;
	                    ngModel.$render = function(){
	                        if(_firstRun){
	                            // we need this firstRun to set the originalContents otherwise it gets overrided by the setting of ngModel to undefined from NaN
	                            _firstRun = false;
	                            // if view value is null or undefined initially and there was original content, set to the original content
	                            var _initialValue = scope.$parent.$eval(attrs.ngModel);
	                            if((_initialValue === undefined || _initialValue === null) && (_originalContents && _originalContents !== '')){
	                                // on passing through to taBind it will be sanitised
	                                ngModel.$setViewValue(_originalContents);
	                            }
	                        }
	                        scope.displayElements.forminput.val(ngModel.$viewValue);
	                        // if the editors aren't focused they need to be updated, otherwise they are doing the updating
	                        scope.html = ngModel.$viewValue || '';
	                    };
	                    // trigger the validation calls
	                    if(element.attr('required')) ngModel.$validators.required = function(modelValue, viewValue) {
	                        var value = modelValue || viewValue;
	                        return !(!value || value.trim() === '');
	                    };
	                }else{
	                    // if no ngModel then update from the contents of the origional html.
	                    scope.displayElements.forminput.val(_originalContents);
	                    scope.html = _originalContents;
	                }
	
	                // changes from taBind back up to here
	                scope.$watch('html', function(newValue, oldValue){
	                    if(newValue !== oldValue){
	                        if(attrs.ngModel && ngModel.$viewValue !== newValue) {
	                            ngModel.$setViewValue(newValue);
	                        }
	                        scope.displayElements.forminput.val(newValue);
	                    }
	                });
	
	                if(attrs.taTargetToolbars) {
	                    _editorFunctions = textAngularManager.registerEditor(scope._name, scope, attrs.taTargetToolbars.split(','));
	                }
	                else{
	                    var _toolbar = angular.element('<div text-angular-toolbar name="textAngularToolbar' + _serial + '">');
	                    // passthrough init of toolbar options
	                    if(attrs.taToolbar)						_toolbar.attr('ta-toolbar', attrs.taToolbar);
	                    if(attrs.taToolbarClass)				_toolbar.attr('ta-toolbar-class', attrs.taToolbarClass);
	                    if(attrs.taToolbarGroupClass)			_toolbar.attr('ta-toolbar-group-class', attrs.taToolbarGroupClass);
	                    if(attrs.taToolbarButtonClass)			_toolbar.attr('ta-toolbar-button-class', attrs.taToolbarButtonClass);
	                    if(attrs.taToolbarActiveButtonClass)	_toolbar.attr('ta-toolbar-active-button-class', attrs.taToolbarActiveButtonClass);
	                    if(attrs.taFocussedClass)				_toolbar.attr('ta-focussed-class', attrs.taFocussedClass);
	
	                    element.prepend(_toolbar);
	                    $compile(_toolbar)(scope.$parent);
	                    _editorFunctions = textAngularManager.registerEditor(scope._name, scope, ['textAngularToolbar' + _serial]);
	                }
	
	                scope.$on('$destroy', function(){
	                    textAngularManager.unregisterEditor(scope._name);
	                    angular.element(window).off('blur');
	                    angular.element(window).off('resize', scope.handlePopoverEvents);
	                    angular.element(window).off('scroll', scope.handlePopoverEvents);
	                });
	
	                // catch element select event and pass to toolbar tools
	                scope.$on('ta-element-select', function(event, element){
	                    if(_editorFunctions.triggerElementSelect(event, element)){
	                        scope['reApplyOnSelectorHandlerstaTextElement' + _serial]();
	                    }
	                });
	
	/******************* no working fully
	                var distanceFromPoint = function (px, py, x, y) {
	                    return Math.sqrt((px-x)*(px-x)+(py-y)*(py-y));
	                };
	                // because each object is a rectangle and we have a single point,
	                // we need to give priority if the point is inside the rectangle
	                var getPositionDistance = function(el, x, y) {
	                    var range = document.createRange();
	                    range.selectNode(el);
	                    var rect = range.getBoundingClientRect();
	                    console.log(el, rect);
	                    range.detach();
	                    var bcr = rect;
	                    // top left
	                    var d1 = distanceFromPoint(bcr.left, bcr.top, x, y);
	                    // bottom left
	                    var d2 = distanceFromPoint(bcr.left, bcr.bottom, x, y);
	                    // top right
	                    var d3 = distanceFromPoint(bcr.right, bcr.top, x, y);
	                    // bottom right
	                    var d4 = distanceFromPoint(bcr.right, bcr.bottom, x, y);
	                    return Math.min(d1, d2, d3, d4);
	                };
	                var findClosest = function(el, minElement, maxDistance, x, y) {
	                    var _d=0;
	                    for (var i = 0; i < el.childNodes.length; i++) {
	                        var _n = el.childNodes[i];
	                        if (!_n.childNodes.length) {
	                            _d = getPositionDistance(_n, x, y);
	                            //console.log(_n, _n.childNodes, _d);
	                            if (_d < maxDistance) {
	                                maxDistance = _d;
	                                minElement = _n;
	                            }
	                        }
	                        var res = findClosest(_n, minElement, maxDistance, x, y);
	                        if (res.max < maxDistance) {
	                            maxDistance = res.max;
	                            minElement = res.min;
	                        }
	                    }
	                    return { max: maxDistance, min: minElement };
	                };
	                var getClosestElement = function (el, x, y) {
	                    return findClosest(el, null, 12341234124, x, y);
	                };
	****************/
	
	                scope.$on('ta-drop-event', function(event, element, dropEvent, dataTransfer){
	                    if(dataTransfer && dataTransfer.files && dataTransfer.files.length > 0){
	                        scope.displayElements.text[0].focus();
	                        // we must set the location of the drop!
	                        //console.log(dropEvent.clientX, dropEvent.clientY, dropEvent.target);
	                        taSelection.setSelectionToElementEnd(dropEvent.target);
	                        angular.forEach(dataTransfer.files, function(file){
	                            // taking advantage of boolean execution, if the fileDropHandler returns true, nothing else after it is executed
	                            // If it is false then execute the defaultFileDropHandler if the fileDropHandler is NOT the default one
	                            // Once one of these has been executed wrap the result as a promise, if undefined or variable update the taBind, else we should wait for the promise
	                            try{
	                                $q.when(scope.fileDropHandler(file, scope.wrapSelection) ||
	                                    (scope.fileDropHandler !== scope.defaultFileDropHandler &&
	                                    $q.when(scope.defaultFileDropHandler(file, scope.wrapSelection)))).then(function(){
	                                        scope['updateTaBindtaTextElement' + _serial]();
	                                    });
	                            }catch(error){
	                                $log.error(error);
	                            }
	                        });
	                        dropEvent.preventDefault();
	                        dropEvent.stopPropagation();
	                    /* istanbul ignore else, the updates if moved text */
	                    }else{
	                        $timeout(function(){
	                            scope['updateTaBindtaTextElement' + _serial]();
	                        }, 0);
	                    }
	                });
	
	                // the following is for applying the active states to the tools that support it
	                scope._bUpdateSelectedStyles = false;
	                /* istanbul ignore next: browser window/tab leave check */
	                angular.element(window).on('blur', function(){
	                    scope._bUpdateSelectedStyles = false;
	                    scope.focussed = false;
	                });
	                // loop through all the tools polling their activeState function if it exists
	                scope.updateSelectedStyles = function(){
	                    var _selection;
	                    /* istanbul ignore next: This check is to ensure multiple timeouts don't exist */
	                    if(_updateSelectedStylesTimeout) $timeout.cancel(_updateSelectedStylesTimeout);
	                    // test if the common element ISN'T the root ta-text node
	                    if((_selection = taSelection.getSelectionElement()) !== undefined && _selection.parentNode !== scope.displayElements.text[0]){
	                        _editorFunctions.updateSelectedStyles(angular.element(_selection));
	                    }else _editorFunctions.updateSelectedStyles();
	                    // used to update the active state when a key is held down, ie the left arrow
	                    /* istanbul ignore else: browser only check */
	                    if(scope._bUpdateSelectedStyles) _updateSelectedStylesTimeout = $timeout(scope.updateSelectedStyles, 200);
	                };
	                // start updating on keydown
	                _keydown = function(){
	                    /* istanbul ignore next: ie catch */
	                    if(!scope.focussed){
	                        scope._bUpdateSelectedStyles = false;
	                        return;
	                    }
	                    /* istanbul ignore else: don't run if already running */
	                    if(!scope._bUpdateSelectedStyles){
	                        scope._bUpdateSelectedStyles = true;
	                        scope.$apply(function(){
	                            scope.updateSelectedStyles();
	                        });
	                    }
	                };
	                scope.displayElements.html.on('keydown', _keydown);
	                scope.displayElements.text.on('keydown', _keydown);
	                // stop updating on key up and update the display/model
	                _keyup = function(){
	                    scope._bUpdateSelectedStyles = false;
	                };
	                scope.displayElements.html.on('keyup', _keyup);
	                scope.displayElements.text.on('keyup', _keyup);
	                // stop updating on key up and update the display/model
	                _keypress = function(event, eventData){
	                    // bug fix for Firefox.  If we are selecting a <a> already, any characters will
	                    // be added within the <a> which is bad!
	                    /* istanbul ignore next: don't see how to test this... */
	                    if (taSelection.getSelection) {
	                        var _selection = taSelection.getSelection();
	                        // in a weird case (can't reproduce) taSelection.getSelectionElement() can be undefined!!
	                        // this comes from range.commonAncestorContainer;
	                        // so I check for this here which fixes the error case
	                        if (taSelection.getSelectionElement() && taSelection.getSelectionElement().nodeName.toLowerCase() === 'a') {
	                            // check and see if we are at the edge of the <a>
	                            if (_selection.start.element.nodeType === 3 &&
	                                _selection.start.element.textContent.length === _selection.end.offset) {
	                                // we are at the end of the <a>!!!
	                                // so move the selection to after the <a>!!
	                                taSelection.setSelectionAfterElement(taSelection.getSelectionElement());
	                            }
	                            if (_selection.start.element.nodeType === 3 &&
	                                _selection.start.offset === 0) {
	                                // we are at the start of the <a>!!!
	                                // so move the selection before the <a>!!
	                                taSelection.setSelectionBeforeElement(taSelection.getSelectionElement());
	                            }
	                        }
	                    }
	                    /* istanbul ignore else: this is for catching the jqLite testing*/
	                    if(eventData) angular.extend(event, eventData);
	                    scope.$apply(function(){
	                        if(_editorFunctions.sendKeyCommand(event)){
	                            /* istanbul ignore else: don't run if already running */
	                            if(!scope._bUpdateSelectedStyles){
	                                scope.updateSelectedStyles();
	                            }
	                            event.preventDefault();
	                            return false;
	                        }
	                    });
	                };
	                scope.displayElements.html.on('keypress', _keypress);
	                scope.displayElements.text.on('keypress', _keypress);
	                // update the toolbar active states when we click somewhere in the text/html boxed
	                _mouseup = function(){
	                    // ensure only one execution of updateSelectedStyles()
	                    scope._bUpdateSelectedStyles = false;
	                    // for some reason, unless we do a $timeout here, after a _mouseup when the line is
	                    // highlighted, and instead use a scope.$apply(function(){ scope.updateSelectedStyles(); });
	                    // doesn't work properly, so we replaced this with:
	                    /* istanbul ignore next: not tested  */
	                    $timeout(function() { scope.updateSelectedStyles(); }, 0);
	                };
	                scope.displayElements.html.on('mouseup', _mouseup);
	                scope.displayElements.text.on('mouseup', _mouseup);
	            }
	        };
	    }
	]);
	textAngular.service('textAngularManager', ['taToolExecuteAction', 'taTools', 'taRegisterTool', '$interval', '$rootScope', '$log',
	    function(taToolExecuteAction, taTools, taRegisterTool, $interval, $rootScope, $log){
	    // this service is used to manage all textAngular editors and toolbars.
	    // All publicly published functions that modify/need to access the toolbar or editor scopes should be in here
	    // these contain references to all the editors and toolbars that have been initialised in this app
	    var toolbars = {}, editors = {};
	    // we touch the time any change occurs through register of an editor or tool so that we
	    // in the future will fire and event to trigger an updateSelection
	    var timeRecentModification = 0;
	    var updateStyles = function(selectedElement){
	        angular.forEach(editors, function(editor) {
	            editor.editorFunctions.updateSelectedStyles(selectedElement);
	        });
	    };
	    var triggerInterval = 50;
	    var triggerIntervalTimer;
	    var setupTriggerUpdateStyles = function() {
	        timeRecentModification = Date.now();
	        /* istanbul ignore next: setup a one time updateStyles() */
	        triggerIntervalTimer = $interval(function() {
	            updateStyles();
	            triggerIntervalTimer = undefined;
	        }, triggerInterval, 1); // only trigger once
	    };
	    /* istanbul ignore next: make sure clean up on destroy */
	    $rootScope.$on('destroy', function() {
	        if (triggerIntervalTimer) {
	            $interval.cancel(triggerIntervalTimer);
	            triggerIntervalTimer = undefined;
	        }
	    });
	    var touchModification = function() {
	        if (Math.abs(Date.now() - timeRecentModification) > triggerInterval) {
	            // we have already triggered the updateStyles a long time back... so setup it again...
	            setupTriggerUpdateStyles();
	        }
	    };
	    // when we focus into a toolbar, we need to set the TOOLBAR's $parent to be the toolbars it's linked to.
	    // We also need to set the tools to be updated to be the toolbars...
	    return {
	        // register an editor and the toolbars that it is affected by
	        registerEditor: function(editorName, editorScope, targetToolbars){
	            // NOTE: name === editorScope._name
	            // targetToolbars is an [] of 'toolbar name's
	            // targetToolbars are optional, we don't require a toolbar to function
	            if(!editorName || editorName === '') throw('textAngular Error: An editor requires a name');
	            if(!editorScope) throw('textAngular Error: An editor requires a scope');
	            if(editors[editorName]) throw('textAngular Error: An Editor with name "' + editorName + '" already exists');
	            editors[editorName] = {
	                scope: editorScope,
	                toolbars: targetToolbars,
	                // toolbarScopes used by this editor
	                toolbarScopes: [],
	                _registerToolbarScope: function(toolbarScope){
	                    // add to the list late
	                    if(this.toolbars.indexOf(toolbarScope.name) >= 0) {
	                        // if this toolbarScope is being used by this editor we add it as one of the scopes
	                        this.toolbarScopes.push(toolbarScope);
	                    }
	                },
	                // this is a suite of functions the editor should use to update all it's linked toolbars
	                editorFunctions: {
	                    disable: function(){
	                        // disable all linked toolbars
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            toolbarScope.disabled = true;
	                        });
	                    },
	                    enable: function(){
	                        // enable all linked toolbars
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            toolbarScope.disabled = false;
	                        });
	                    },
	                    focus: function(){
	                        // this should be called when the editor is focussed
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            toolbarScope._parent = editorScope;
	                            toolbarScope.disabled = false;
	                            toolbarScope.focussed = true;
	                        });
	                        editorScope.focussed = true;
	                    },
	                    unfocus: function(){
	                        // this should be called when the editor becomes unfocussed
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            toolbarScope.disabled = true;
	                            toolbarScope.focussed = false;
	                        });
	                        editorScope.focussed = false;
	                    },
	                    updateSelectedStyles: function(selectedElement){
	                        // update the active state of all buttons on liked toolbars
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            angular.forEach(toolbarScope.tools, function(toolScope){
	                                if(toolScope.activeState){
	                                    toolbarScope._parent = editorScope;
	                                    // selectedElement may be undefined if nothing selected
	                                    toolScope.active = toolScope.activeState(selectedElement);
	                                }
	                            });
	                        });
	                    },
	                    sendKeyCommand: function(event){
	                        // we return true if we applied an action, false otherwise
	                        var result = false;
	                        if(event.ctrlKey || event.metaKey || event.specialKey) angular.forEach(taTools, function(tool, name){
	                            if(tool.commandKeyCode && (tool.commandKeyCode === event.which || tool.commandKeyCode === event.specialKey)){
	                                for(var _t = 0; _t < editors[editorName].toolbarScopes.length; _t++){
	                                    if(editors[editorName].toolbarScopes[_t].tools[name] !== undefined){
	                                        taToolExecuteAction.call(editors[editorName].toolbarScopes[_t].tools[name], editorScope);
	                                        result = true;
	                                        break;
	                                    }
	                                }
	                            }
	                        });
	                        return result;
	                    },
	                    triggerElementSelect: function(event, element){
	                        // search through the taTools to see if a match for the tag is made.
	                        // if there is, see if the tool is on a registered toolbar and not disabled.
	                        // NOTE: This can trigger on MULTIPLE tools simultaneously.
	                        var elementHasAttrs = function(_element, attrs){
	                            var result = true;
	                            for(var i = 0; i < attrs.length; i++) result = result && _element.attr(attrs[i]);
	                            return result;
	                        };
	                        var workerTools = [];
	                        var unfilteredTools = {};
	                        var result = false;
	                        element = angular.element(element);
	                        // get all valid tools by element name, keep track if one matches the
	                        var onlyWithAttrsFilter = false;
	                        angular.forEach(taTools, function(tool, name){
	                            if(
	                                tool.onElementSelect &&
	                                tool.onElementSelect.element &&
	                                tool.onElementSelect.element.toLowerCase() === element[0].tagName.toLowerCase() &&
	                                (!tool.onElementSelect.filter || tool.onElementSelect.filter(element))
	                            ){
	                                // this should only end up true if the element matches the only attributes
	                                onlyWithAttrsFilter = onlyWithAttrsFilter ||
	                                    (angular.isArray(tool.onElementSelect.onlyWithAttrs) && elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs));
	                                if(!tool.onElementSelect.onlyWithAttrs || elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs)) unfilteredTools[name] = tool;
	                            }
	                        });
	                        // if we matched attributes to filter on, then filter, else continue
	                        if(onlyWithAttrsFilter){
	                            angular.forEach(unfilteredTools, function(tool, name){
	                                if(tool.onElementSelect.onlyWithAttrs && elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs)) workerTools.push({'name': name, 'tool': tool});
	                            });
	                            // sort most specific (most attrs to find) first
	                            workerTools.sort(function(a,b){
	                                return b.tool.onElementSelect.onlyWithAttrs.length - a.tool.onElementSelect.onlyWithAttrs.length;
	                            });
	                        }else{
	                            angular.forEach(unfilteredTools, function(tool, name){
	                                workerTools.push({'name': name, 'tool': tool});
	                            });
	                        }
	                        // Run the actions on the first visible filtered tool only
	                        if(workerTools.length > 0){
	                            for(var _i = 0; _i < workerTools.length; _i++){
	                                var tool = workerTools[_i].tool;
	                                var name = workerTools[_i].name;
	                                for(var _t = 0; _t < editors[editorName].toolbarScopes.length; _t++){
	                                    if(editors[editorName].toolbarScopes[_t].tools[name] !== undefined){
	                                        tool.onElementSelect.action.call(editors[editorName].toolbarScopes[_t].tools[name], event, element, editorScope);
	                                        result = true;
	                                        break;
	                                    }
	                                }
	                                if(result) break;
	                            }
	                        }
	                        return result;
	                    }
	                }
	            };
	            angular.forEach(targetToolbars, function(_name){
	                if(toolbars[_name]) {
	                    editors[editorName].toolbarScopes.push(toolbars[_name]);
	                }
	                // if it doesn't exist it may not have been compiled yet and it will be added later
	            });
	            touchModification();
	            return editors[editorName].editorFunctions;
	        },
	        // retrieve editor by name, largely used by testing suites only
	        retrieveEditor: function(name){
	            return editors[name];
	        },
	        unregisterEditor: function(name){
	            delete editors[name];
	            touchModification();
	        },
	        // registers a toolbar such that it can be linked to editors
	        registerToolbar: function(toolbarScope){
	            if(!toolbarScope) throw('textAngular Error: A toolbar requires a scope');
	            if(!toolbarScope.name || toolbarScope.name === '') throw('textAngular Error: A toolbar requires a name');
	            if(toolbars[toolbarScope.name]) throw('textAngular Error: A toolbar with name "' + toolbarScope.name + '" already exists');
	            toolbars[toolbarScope.name] = toolbarScope;
	            // walk all the editors and connect this toolbarScope to the editors.... if we need to.  This way, it does
	            // not matter if we register the editors after the toolbars or not
	            // Note the editor will ignore this toolbarScope if it is not connected to it...
	            angular.forEach(editors, function(_editor){
	                _editor._registerToolbarScope(toolbarScope);
	            });
	            touchModification();
	        },
	        // retrieve toolbar by name, largely used by testing suites only
	        retrieveToolbar: function(name){
	            return toolbars[name];
	        },
	        // retrieve toolbars by editor name, largely used by testing suites only
	        retrieveToolbarsViaEditor: function(name){
	            var result = [], _this = this;
	            angular.forEach(this.retrieveEditor(name).toolbars, function(name){
	                result.push(_this.retrieveToolbar(name));
	            });
	            return result;
	        },
	        unregisterToolbar: function(name){
	            delete toolbars[name];
	            touchModification();
	        },
	        // functions for updating the toolbar buttons display
	        updateToolsDisplay: function(newTaTools){
	            // pass a partial struct of the taTools, this allows us to update the tools on the fly, will not change the defaults.
	            var _this = this;
	            angular.forEach(newTaTools, function(_newTool, key){
	                _this.updateToolDisplay(key, _newTool);
	            });
	        },
	        // this function resets all toolbars to their default tool definitions
	        resetToolsDisplay: function(){
	            var _this = this;
	            angular.forEach(taTools, function(_newTool, key){
	                _this.resetToolDisplay(key);
	            });
	            touchModification();
	        },
	        // update a tool on all toolbars
	        updateToolDisplay: function(toolKey, _newTool){
	            var _this = this;
	            angular.forEach(toolbars, function(toolbarScope, toolbarKey){
	                _this.updateToolbarToolDisplay(toolbarKey, toolKey, _newTool);
	            });
	            touchModification();
	        },
	        // resets a tool to the default/starting state on all toolbars
	        resetToolDisplay: function(toolKey){
	            var _this = this;
	            angular.forEach(toolbars, function(toolbarScope, toolbarKey){
	                _this.resetToolbarToolDisplay(toolbarKey, toolKey);
	            });
	            touchModification();
	        },
	        // update a tool on a specific toolbar
	        updateToolbarToolDisplay: function(toolbarKey, toolKey, _newTool){
	            if(toolbars[toolbarKey]) toolbars[toolbarKey].updateToolDisplay(toolKey, _newTool);
	            else throw('textAngular Error: No Toolbar with name "' + toolbarKey + '" exists');
	        },
	        // reset a tool on a specific toolbar to it's default starting value
	        resetToolbarToolDisplay: function(toolbarKey, toolKey){
	            if(toolbars[toolbarKey]) toolbars[toolbarKey].updateToolDisplay(toolKey, taTools[toolKey], true);
	            else throw('textAngular Error: No Toolbar with name "' + toolbarKey + '" exists');
	        },
	        // removes a tool from all toolbars and it's definition
	        removeTool: function(toolKey){
	            delete taTools[toolKey];
	            angular.forEach(toolbars, function(toolbarScope){
	                delete toolbarScope.tools[toolKey];
	                for(var i = 0; i < toolbarScope.toolbar.length; i++){
	                    var toolbarIndex;
	                    for(var j = 0; j < toolbarScope.toolbar[i].length; j++){
	                        if(toolbarScope.toolbar[i][j] === toolKey){
	                            toolbarIndex = {
	                                group: i,
	                                index: j
	                            };
	                            break;
	                        }
	                        if(toolbarIndex !== undefined) break;
	                    }
	                    if(toolbarIndex !== undefined){
	                        toolbarScope.toolbar[toolbarIndex.group].slice(toolbarIndex.index, 1);
	                        toolbarScope._$element.children().eq(toolbarIndex.group).children().eq(toolbarIndex.index).remove();
	                    }
	                }
	            });
	            touchModification();
	        },
	        // toolkey, toolDefinition are required. If group is not specified will pick the last group, if index isnt defined will append to group
	        addTool: function(toolKey, toolDefinition, group, index){
	            taRegisterTool(toolKey, toolDefinition);
	            angular.forEach(toolbars, function(toolbarScope){
	                toolbarScope.addTool(toolKey, toolDefinition, group, index);
	            });
	            touchModification();
	        },
	        // adds a Tool but only to one toolbar not all
	        addToolToToolbar: function(toolKey, toolDefinition, toolbarKey, group, index){
	            taRegisterTool(toolKey, toolDefinition);
	            toolbars[toolbarKey].addTool(toolKey, toolDefinition, group, index);
	            touchModification();
	        },
	        // this is used when externally the html of an editor has been changed and textAngular needs to be notified to update the model.
	        // this will call a $digest if not already happening
	        refreshEditor: function(name){
	            if(editors[name]){
	                editors[name].scope.updateTaBindtaTextElement();
	                /* istanbul ignore else: phase catch */
	                if(!editors[name].scope.$$phase) editors[name].scope.$digest();
	            }else throw('textAngular Error: No Editor with name "' + name + '" exists');
	            touchModification();
	        },
	        // this is used by taBind to send a key command in response to a special key event
	        sendKeyCommand: function(scope, event){
	            var _editor = editors[scope._name];
	            /* istanbul ignore else: if nothing to do, do nothing */
	            if (_editor && _editor.editorFunctions.sendKeyCommand(event)) {
	                /* istanbul ignore else: don't run if already running */
	                if(!scope._bUpdateSelectedStyles){
	                    scope.updateSelectedStyles();
	                }
	                event.preventDefault();
	                return false;
	            }
	        },
	        //
	        // When a toolbar and tools are created, it isn't until there is a key event or mouse event
	        // that the updateSelectedStyles() is called behind the scenes.
	        // This function forces an update through the existing editors to help the application make sure
	        // the inital state is correct.
	        //
	        updateStyles: updateStyles,
	        // return the current version of textAngular in use to the user
	        getVersion: function () { return textAngularVersion; },
	        // for testing
	        getToolbarScopes: function () {
	            var tmp=[];
	            angular.forEach(editors, function (_editor) {
	                tmp = tmp.concat(_editor.toolbarScopes);
	            });
	            return tmp;
	        }
	/********************** not functional yet
	        // save the selection ('range') for the given editor
	        saveFocusSelection: function (name, range) {
	            editors[name].savedFocusRange = range;
	        },
	        // restore the saved selection from when the focus was lost
	        restoreFocusSelection: function(name, scope) {
	            // we only do this if NOT focussed and saved...
	            if (editors[name].savedFocusRange && !scope.focussed) {
	                try {
	                    var _r = rangy.restoreRange(editors[name].savedFocusRange);
	                    var _sel = rangy.getSelection();
	                    _sel.addRange(_r);
	                } catch(e) {}
	            }
	        }
	*************/
	    };
	}]);
	textAngular.directive('textAngularToolbar', [
	    '$compile', 'textAngularManager', 'taOptions', 'taTools', 'taToolExecuteAction', '$window',
	    function($compile, textAngularManager, taOptions, taTools, taToolExecuteAction, $window){
	        return {
	            scope: {
	                name: '@' // a name IS required
	            },
	            restrict: "EA",
	            link: function(scope, element, attrs){
	                if(!scope.name || scope.name === '') throw('textAngular Error: A toolbar requires a name');
	                angular.extend(scope, angular.copy(taOptions));
	                if(attrs.taToolbar)						scope.toolbar = scope.$parent.$eval(attrs.taToolbar);
	                if(attrs.taToolbarClass)				scope.classes.toolbar = attrs.taToolbarClass;
	                if(attrs.taToolbarGroupClass)			scope.classes.toolbarGroup = attrs.taToolbarGroupClass;
	                if(attrs.taToolbarButtonClass)			scope.classes.toolbarButton = attrs.taToolbarButtonClass;
	                if(attrs.taToolbarActiveButtonClass)	scope.classes.toolbarButtonActive = attrs.taToolbarActiveButtonClass;
	                if(attrs.taFocussedClass)				scope.classes.focussed = attrs.taFocussedClass;
	
	                scope.disabled = true;
	                scope.focussed = false;
	                scope._$element = element;
	                element[0].innerHTML = '';
	                element.addClass("ta-toolbar " + scope.classes.toolbar);
	
	                scope.$watch('focussed', function(){
	                    if(scope.focussed) element.addClass(scope.classes.focussed);
	                    else element.removeClass(scope.classes.focussed);
	                });
	
	                var setupToolElement = function(toolDefinition, toolScope){
	                    var toolElement;
	                    if(toolDefinition && toolDefinition.display){
	                        toolElement = angular.element(toolDefinition.display);
	                    }
	                    else toolElement = angular.element("<button type='button'>");
	
	                    if(toolDefinition && toolDefinition["class"]) toolElement.addClass(toolDefinition["class"]);
	                    else toolElement.addClass(scope.classes.toolbarButton);
	
	                    toolElement.attr('name', toolScope.name);
	                    // important to not take focus from the main text/html entry
	                    toolElement.attr('ta-button', 'ta-button');
	                    toolElement.attr('ng-disabled', 'isDisabled()');
	                    toolElement.attr('tabindex', '-1');
	                    toolElement.attr('ng-click', 'executeAction()');
	                    toolElement.attr('ng-class', 'displayActiveToolClass(active)');
	
	                    if (toolDefinition && toolDefinition.tooltiptext) {
	                        toolElement.attr('title', toolDefinition.tooltiptext);
	                    }
	                    if(toolDefinition && !toolDefinition.display && !toolScope._display){
	                        // first clear out the current contents if any
	                        toolElement[0].innerHTML = '';
	                        // add the buttonText
	                        if(toolDefinition.buttontext) toolElement[0].innerHTML = toolDefinition.buttontext;
	                        // add the icon to the front of the button if there is content
	                        if(toolDefinition.iconclass){
	                            var icon = angular.element('<i>'), content = toolElement[0].innerHTML;
	                            icon.addClass(toolDefinition.iconclass);
	                            toolElement[0].innerHTML = '';
	                            toolElement.append(icon);
	                            if(content && content !== '') toolElement.append('&nbsp;' + content);
	                        }
	                    }
	
	                    toolScope._lastToolDefinition = angular.copy(toolDefinition);
	
	                    return $compile(toolElement)(toolScope);
	                };
	
	                // Keep a reference for updating the active states later
	                scope.tools = {};
	                // create the tools in the toolbar
	                // default functions and values to prevent errors in testing and on init
	                scope._parent = {
	                    disabled: true,
	                    showHtml: false,
	                    queryFormatBlockState: function(){ return false; },
	                    queryCommandState: function(){ return false; }
	                };
	                var defaultChildScope = {
	                    $window: $window,
	                    $editor: function(){
	                        // dynamically gets the editor as it is set
	                        return scope._parent;
	                    },
	                    isDisabled: function(){
	                        // view selection button is always enabled since it doesn not depend on a selction!
	                        if (this.name === 'html' && scope._parent.startAction) {
	                            return false;
	                        }
	                        // to set your own disabled logic set a function or boolean on the tool called 'disabled'
	                        return ( // this bracket is important as without it it just returns the first bracket and ignores the rest
	                            // when the button's disabled function/value evaluates to true
	                            (typeof this.$eval('disabled') !== 'function' && this.$eval('disabled')) || this.$eval('disabled()') ||
	                            // all buttons except the HTML Switch button should be disabled in the showHtml (RAW html) mode
	                            (this.name !== 'html' && this.$editor().showHtml) ||
	                            // if the toolbar is disabled
	                            this.$parent.disabled ||
	                            // if the current editor is disabled
	                            this.$editor().disabled
	                        );
	                    },
	                    displayActiveToolClass: function(active){
	                        return (active)? scope.classes.toolbarButtonActive : '';
	                    },
	                    executeAction: taToolExecuteAction
	                };
	
	                angular.forEach(scope.toolbar, function(group){
	                    // setup the toolbar group
	                    var groupElement = angular.element("<div>");
	                    groupElement.addClass(scope.classes.toolbarGroup);
	                    angular.forEach(group, function(tool){
	                        // init and add the tools to the group
	                        // a tool name (key name from taTools struct)
	                        //creates a child scope of the main angularText scope and then extends the childScope with the functions of this particular tool
	                        // reference to the scope and element kept
	                        scope.tools[tool] = angular.extend(scope.$new(true), taTools[tool], defaultChildScope, {name: tool});
	                        scope.tools[tool].$element = setupToolElement(taTools[tool], scope.tools[tool]);
	                        // append the tool compiled with the childScope to the group element
	                        groupElement.append(scope.tools[tool].$element);
	                    });
	                    // append the group to the toolbar
	                    element.append(groupElement);
	                });
	
	                // update a tool
	                // if a value is set to null, remove from the display
	                // when forceNew is set to true it will ignore all previous settings, used to reset to taTools definition
	                // to reset to defaults pass in taTools[key] as _newTool and forceNew as true, ie `updateToolDisplay(key, taTools[key], true);`
	                scope.updateToolDisplay = function(key, _newTool, forceNew){
	                    var toolInstance = scope.tools[key];
	                    if(toolInstance){
	                        // get the last toolDefinition, then override with the new definition
	                        if(toolInstance._lastToolDefinition && !forceNew) _newTool = angular.extend({}, toolInstance._lastToolDefinition, _newTool);
	                        if(_newTool.buttontext === null && _newTool.iconclass === null && _newTool.display === null)
	                            throw('textAngular Error: Tool Definition for updating "' + key + '" does not have a valid display/iconclass/buttontext value');
	
	                        // if tool is defined on this toolbar, update/redo the tool
	                        if(_newTool.buttontext === null){
	                            delete _newTool.buttontext;
	                        }
	                        if(_newTool.iconclass === null){
	                            delete _newTool.iconclass;
	                        }
	                        if(_newTool.display === null){
	                            delete _newTool.display;
	                        }
	
	                        var toolElement = setupToolElement(_newTool, toolInstance);
	                        toolInstance.$element.replaceWith(toolElement);
	                        toolInstance.$element = toolElement;
	                    }
	                };
	
	                // we assume here that all values passed are valid and correct
	                scope.addTool = function(key, _newTool, groupIndex, index){
	                    scope.tools[key] = angular.extend(scope.$new(true), taTools[key], defaultChildScope, {name: key});
	                    scope.tools[key].$element = setupToolElement(taTools[key], scope.tools[key]);
	                    var group;
	                    if(groupIndex === undefined) groupIndex = scope.toolbar.length - 1;
	                    group = angular.element(element.children()[groupIndex]);
	
	                    if(index === undefined){
	                        group.append(scope.tools[key].$element);
	                        scope.toolbar[groupIndex][scope.toolbar[groupIndex].length - 1] = key;
	                    }else{
	                        group.children().eq(index).after(scope.tools[key].$element);
	                        scope.toolbar[groupIndex][index] = key;
	                    }
	                };
	
	                textAngularManager.registerToolbar(scope);
	
	                scope.$on('$destroy', function(){
	                    textAngularManager.unregisterToolbar(scope.name);
	                });
	            }
	        };
	    }
	]);
	textAngular.directive('textAngularVersion', ['textAngularManager',
	    function(textAngularManager) {
	        var version = textAngularManager.getVersion();
	        return {
	            restrict: "EA",
	            link: function (scope, element, attrs) {
	                element.html(version);
	            }
	        };
	    }
	]);
	
	return textAngular.name;
	
	}));


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define('underscore', factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
	    var current = global._;
	    var exports = global._ = factory();
	    exports.noConflict = function () { global._ = current; return exports; };
	  }()));
	}(this, (function () {
	  //     Underscore.js 1.13.4
	  //     https://underscorejs.org
	  //     (c) 2009-2022 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
	  //     Underscore may be freely distributed under the MIT license.
	
	  // Current version.
	  var VERSION = '1.13.4';
	
	  // Establish the root object, `window` (`self`) in the browser, `global`
	  // on the server, or `this` in some virtual machines. We use `self`
	  // instead of `window` for `WebWorker` support.
	  var root = (typeof self == 'object' && self.self === self && self) ||
	            (typeof global == 'object' && global.global === global && global) ||
	            Function('return this')() ||
	            {};
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
	  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push = ArrayProto.push,
	      slice = ArrayProto.slice,
	      toString = ObjProto.toString,
	      hasOwnProperty = ObjProto.hasOwnProperty;
	
	  // Modern feature detection.
	  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
	      supportsDataView = typeof DataView !== 'undefined';
	
	  // All **ECMAScript 5+** native function implementations that we hope to use
	  // are declared here.
	  var nativeIsArray = Array.isArray,
	      nativeKeys = Object.keys,
	      nativeCreate = Object.create,
	      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;
	
	  // Create references to these builtin functions because we override them.
	  var _isNaN = isNaN,
	      _isFinite = isFinite;
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  // The largest integer that can be represented exactly.
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	
	  // Some functions take a variable number of arguments, or a few expected
	  // arguments at the beginning and then a variable number of values to operate
	  // on. This helper accumulates all remaining arguments past the function’s
	  // argument length (or an explicit `startIndex`), into an array that becomes
	  // the last argument. Similar to ES6’s "rest parameter".
	  function restArguments(func, startIndex) {
	    startIndex = startIndex == null ? func.length - 1 : +startIndex;
	    return function() {
	      var length = Math.max(arguments.length - startIndex, 0),
	          rest = Array(length),
	          index = 0;
	      for (; index < length; index++) {
	        rest[index] = arguments[index + startIndex];
	      }
	      switch (startIndex) {
	        case 0: return func.call(this, rest);
	        case 1: return func.call(this, arguments[0], rest);
	        case 2: return func.call(this, arguments[0], arguments[1], rest);
	      }
	      var args = Array(startIndex + 1);
	      for (index = 0; index < startIndex; index++) {
	        args[index] = arguments[index];
	      }
	      args[startIndex] = rest;
	      return func.apply(this, args);
	    };
	  }
	
	  // Is a given variable an object?
	  function isObject(obj) {
	    var type = typeof obj;
	    return type === 'function' || (type === 'object' && !!obj);
	  }
	
	  // Is a given value equal to null?
	  function isNull(obj) {
	    return obj === null;
	  }
	
	  // Is a given variable undefined?
	  function isUndefined(obj) {
	    return obj === void 0;
	  }
	
	  // Is a given value a boolean?
	  function isBoolean(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  }
	
	  // Is a given value a DOM element?
	  function isElement(obj) {
	    return !!(obj && obj.nodeType === 1);
	  }
	
	  // Internal function for creating a `toString`-based type tester.
	  function tagTester(name) {
	    var tag = '[object ' + name + ']';
	    return function(obj) {
	      return toString.call(obj) === tag;
	    };
	  }
	
	  var isString = tagTester('String');
	
	  var isNumber = tagTester('Number');
	
	  var isDate = tagTester('Date');
	
	  var isRegExp = tagTester('RegExp');
	
	  var isError = tagTester('Error');
	
	  var isSymbol = tagTester('Symbol');
	
	  var isArrayBuffer = tagTester('ArrayBuffer');
	
	  var isFunction = tagTester('Function');
	
	  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
	  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
	  var nodelist = root.document && root.document.childNodes;
	  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
	    isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  var isFunction$1 = isFunction;
	
	  var hasObjectTag = tagTester('Object');
	
	  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
	  // In IE 11, the most common among them, this problem also applies to
	  // `Map`, `WeakMap` and `Set`.
	  var hasStringTagBug = (
	        supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8)))
	      ),
	      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));
	
	  var isDataView = tagTester('DataView');
	
	  // In IE 10 - Edge 13, we need a different heuristic
	  // to determine whether an object is a `DataView`.
	  function ie10IsDataView(obj) {
	    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
	  }
	
	  var isDataView$1 = (hasStringTagBug ? ie10IsDataView : isDataView);
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native `Array.isArray`.
	  var isArray = nativeIsArray || tagTester('Array');
	
	  // Internal function to check whether `key` is an own property name of `obj`.
	  function has$1(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  }
	
	  var isArguments = tagTester('Arguments');
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  (function() {
	    if (!isArguments(arguments)) {
	      isArguments = function(obj) {
	        return has$1(obj, 'callee');
	      };
	    }
	  }());
	
	  var isArguments$1 = isArguments;
	
	  // Is a given object a finite number?
	  function isFinite$1(obj) {
	    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
	  }
	
	  // Is the given value `NaN`?
	  function isNaN$1(obj) {
	    return isNumber(obj) && _isNaN(obj);
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function constant(value) {
	    return function() {
	      return value;
	    };
	  }
	
	  // Common internal logic for `isArrayLike` and `isBufferLike`.
	  function createSizePropertyCheck(getSizeProperty) {
	    return function(collection) {
	      var sizeProperty = getSizeProperty(collection);
	      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
	    }
	  }
	
	  // Internal helper to generate a function to obtain property `key` from `obj`.
	  function shallowProperty(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  }
	
	  // Internal helper to obtain the `byteLength` property of an object.
	  var getByteLength = shallowProperty('byteLength');
	
	  // Internal helper to determine whether we should spend extensive checks against
	  // `ArrayBuffer` et al.
	  var isBufferLike = createSizePropertyCheck(getByteLength);
	
	  // Is a given value a typed array?
	  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
	  function isTypedArray(obj) {
	    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
	    // Otherwise, fall back on the above regular expression.
	    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
	                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
	  }
	
	  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);
	
	  // Internal helper to obtain the `length` property of an object.
	  var getLength = shallowProperty('length');
	
	  // Internal helper to create a simple lookup structure.
	  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
	  // circular imports. `emulatedSet` is a one-off solution that only works for
	  // arrays of strings.
	  function emulatedSet(keys) {
	    var hash = {};
	    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
	    return {
	      contains: function(key) { return hash[key] === true; },
	      push: function(key) {
	        hash[key] = true;
	        return keys.push(key);
	      }
	    };
	  }
	
	  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
	  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
	  // needed.
	  function collectNonEnumProps(obj, keys) {
	    keys = emulatedSet(keys);
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (isFunction$1(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (has$1(obj, prop) && !keys.contains(prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`.
	  function keys(obj) {
	    if (!isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (has$1(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  function isEmpty(obj) {
	    if (obj == null) return true;
	    // Skip the more expensive `toString`-based type checks if `obj` has no
	    // `.length`.
	    var length = getLength(obj);
	    if (typeof length == 'number' && (
	      isArray(obj) || isString(obj) || isArguments$1(obj)
	    )) return length === 0;
	    return getLength(keys(obj)) === 0;
	  }
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  function isMatch(object, attrs) {
	    var _keys = keys(attrs), length = _keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = _keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  }
	
	  // If Underscore is called as a function, it returns a wrapped object that can
	  // be used OO-style. This wrapper holds altered versions of all functions added
	  // through `_.mixin`. Wrapped objects may be chained.
	  function _$1(obj) {
	    if (obj instanceof _$1) return obj;
	    if (!(this instanceof _$1)) return new _$1(obj);
	    this._wrapped = obj;
	  }
	
	  _$1.VERSION = VERSION;
	
	  // Extracts the result from a wrapped and chained object.
	  _$1.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxies for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value;
	
	  _$1.prototype.toString = function() {
	    return String(this._wrapped);
	  };
	
	  // Internal function to wrap or shallow-copy an ArrayBuffer,
	  // typed array or DataView to a new view, reusing the buffer.
	  function toBufferView(bufferSource) {
	    return new Uint8Array(
	      bufferSource.buffer || bufferSource,
	      bufferSource.byteOffset || 0,
	      getByteLength(bufferSource)
	    );
	  }
	
	  // We use this string twice, so give it a name for minification.
	  var tagDataView = '[object DataView]';
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null) return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a) return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
	    return deepEq(a, b, aStack, bStack);
	  }
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function deepEq(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    if (a instanceof _$1) a = a._wrapped;
	    if (b instanceof _$1) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    // Work around a bug in IE 10 - Edge 13.
	    if (hasStringTagBug && className == '[object Object]' && isDataView$1(a)) {
	      if (!isDataView$1(b)) return false;
	      className = tagDataView;
	    }
	    switch (className) {
	      // These types are compared by value.
	      case '[object RegExp]':
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN.
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	      case '[object Symbol]':
	        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
	      case '[object ArrayBuffer]':
	      case tagDataView:
	        // Coerce to typed array so we can fall through.
	        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays && isTypedArray$1(a)) {
	        var byteLength = getByteLength(a);
	        if (byteLength !== getByteLength(b)) return false;
	        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
	        areArrays = true;
	    }
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
	                               isFunction$1(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var _keys = keys(a), key;
	      length = _keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = _keys[length];
	        if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  }
	
	  // Perform a deep comparison to check if two objects are equal.
	  function isEqual(a, b) {
	    return eq(a, b);
	  }
	
	  // Retrieve all the enumerable property names of an object.
	  function allKeys(obj) {
	    if (!isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Since the regular `Object.prototype.toString` type tests don't work for
	  // some types in IE 11, we use a fingerprinting heuristic instead, based
	  // on the methods. It's not great, but it's the best we got.
	  // The fingerprint method lists are defined below.
	  function ie11fingerprint(methods) {
	    var length = getLength(methods);
	    return function(obj) {
	      if (obj == null) return false;
	      // `Map`, `WeakMap` and `Set` have no enumerable keys.
	      var keys = allKeys(obj);
	      if (getLength(keys)) return false;
	      for (var i = 0; i < length; i++) {
	        if (!isFunction$1(obj[methods[i]])) return false;
	      }
	      // If we are testing against `WeakMap`, we need to ensure that
	      // `obj` doesn't have a `forEach` method in order to distinguish
	      // it from a regular `Map`.
	      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
	    };
	  }
	
	  // In the interest of compact minification, we write
	  // each string in the fingerprints only once.
	  var forEachName = 'forEach',
	      hasName = 'has',
	      commonInit = ['clear', 'delete'],
	      mapTail = ['get', hasName, 'set'];
	
	  // `Map`, `WeakMap` and `Set` each have slightly different
	  // combinations of the above sublists.
	  var mapMethods = commonInit.concat(forEachName, mapTail),
	      weakMapMethods = commonInit.concat(mapTail),
	      setMethods = ['add'].concat(commonInit, forEachName, hasName);
	
	  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');
	
	  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');
	
	  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');
	
	  var isWeakSet = tagTester('WeakSet');
	
	  // Retrieve the values of an object's properties.
	  function values(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[_keys[i]];
	    }
	    return values;
	  }
	
	  // Convert an object into a list of `[key, value]` pairs.
	  // The opposite of `_.object` with one argument.
	  function pairs(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [_keys[i], obj[_keys[i]]];
	    }
	    return pairs;
	  }
	
	  // Invert the keys and values of an object. The values must be serializable.
	  function invert(obj) {
	    var result = {};
	    var _keys = keys(obj);
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      result[obj[_keys[i]]] = _keys[i];
	    }
	    return result;
	  }
	
	  // Return a sorted list of the function names available on the object.
	  function functions(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (isFunction$1(obj[key])) names.push(key);
	    }
	    return names.sort();
	  }
	
	  // An internal function for creating assigner functions.
	  function createAssigner(keysFunc, defaults) {
	    return function(obj) {
	      var length = arguments.length;
	      if (defaults) obj = Object(obj);
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!defaults || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  }
	
	  // Extend a given object with all the properties in passed-in object(s).
	  var extend = createAssigner(allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in
	  // object(s).
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  var extendOwn = createAssigner(keys);
	
	  // Fill in a given object with default properties.
	  var defaults = createAssigner(allKeys, true);
	
	  // Create a naked function reference for surrogate-prototype-swapping.
	  function ctor() {
	    return function(){};
	  }
	
	  // An internal function for creating a new object that inherits from another.
	  function baseCreate(prototype) {
	    if (!isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    var Ctor = ctor();
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  }
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  function create(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) extendOwn(result, props);
	    return result;
	  }
	
	  // Create a (shallow-cloned) duplicate of an object.
	  function clone(obj) {
	    if (!isObject(obj)) return obj;
	    return isArray(obj) ? obj.slice() : extend({}, obj);
	  }
	
	  // Invokes `interceptor` with the `obj` and then returns `obj`.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  function tap(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  }
	
	  // Normalize a (deep) property `path` to array.
	  // Like `_.iteratee`, this function can be customized.
	  function toPath$1(path) {
	    return isArray(path) ? path : [path];
	  }
	  _$1.toPath = toPath$1;
	
	  // Internal wrapper for `_.toPath` to enable minification.
	  // Similar to `cb` for `_.iteratee`.
	  function toPath(path) {
	    return _$1.toPath(path);
	  }
	
	  // Internal function to obtain a nested property in `obj` along `path`.
	  function deepGet(obj, path) {
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      if (obj == null) return void 0;
	      obj = obj[path[i]];
	    }
	    return length ? obj : void 0;
	  }
	
	  // Get the value of the (deep) property on `path` from `object`.
	  // If any property in `path` does not exist or if the value is
	  // `undefined`, return `defaultValue` instead.
	  // The `path` is normalized through `_.toPath`.
	  function get(object, path, defaultValue) {
	    var value = deepGet(object, toPath(path));
	    return isUndefined(value) ? defaultValue : value;
	  }
	
	  // Shortcut function for checking if an object has a given property directly on
	  // itself (in other words, not on a prototype). Unlike the internal `has`
	  // function, this public version can also traverse nested properties.
	  function has(obj, path) {
	    path = toPath(path);
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      var key = path[i];
	      if (!has$1(obj, key)) return false;
	      obj = obj[key];
	    }
	    return !!length;
	  }
	
	  // Keep the identity function around for default iteratees.
	  function identity(value) {
	    return value;
	  }
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  function matcher(attrs) {
	    attrs = extendOwn({}, attrs);
	    return function(obj) {
	      return isMatch(obj, attrs);
	    };
	  }
	
	  // Creates a function that, when passed an object, will traverse that object’s
	  // properties down the given `path`, specified as an array of keys or indices.
	  function property(path) {
	    path = toPath(path);
	    return function(obj) {
	      return deepGet(obj, path);
	    };
	  }
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  function optimizeCb(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      // The 2-argument case is omitted because we’re not using it.
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  }
	
	  // An internal function to generate callbacks that can be applied to each
	  // element in a collection, returning the desired result — either `_.identity`,
	  // an arbitrary callback, a property matcher, or a property accessor.
	  function baseIteratee(value, context, argCount) {
	    if (value == null) return identity;
	    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
	    if (isObject(value) && !isArray(value)) return matcher(value);
	    return property(value);
	  }
	
	  // External wrapper for our callback generator. Users may customize
	  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
	  // This abstraction hides the internal-only `argCount` argument.
	  function iteratee(value, context) {
	    return baseIteratee(value, context, Infinity);
	  }
	  _$1.iteratee = iteratee;
	
	  // The function we call internally to generate a callback. It invokes
	  // `_.iteratee` if overridden, otherwise `baseIteratee`.
	  function cb(value, context, argCount) {
	    if (_$1.iteratee !== iteratee) return _$1.iteratee(value, context);
	    return baseIteratee(value, context, argCount);
	  }
	
	  // Returns the results of applying the `iteratee` to each element of `obj`.
	  // In contrast to `_.map` it returns an object.
	  function mapObject(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = keys(obj),
	        length = _keys.length,
	        results = {};
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys[index];
	      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function noop(){}
	
	  // Generates a function for a given object that returns a given property.
	  function propertyOf(obj) {
	    if (obj == null) return noop;
	    return function(path) {
	      return get(obj, path);
	    };
	  }
	
	  // Run a function **n** times.
	  function times(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  }
	
	  // Return a random integer between `min` and `max` (inclusive).
	  function random(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  }
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  var now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	  // Internal helper to generate functions for escaping and unescaping strings
	  // to/from HTML interpolation.
	  function createEscaper(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped.
	    var source = '(?:' + keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  }
	
	  // Internal list of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	
	  // Function for escaping strings to HTML interpolation.
	  var _escape = createEscaper(escapeMap);
	
	  // Internal list of HTML entities for unescaping.
	  var unescapeMap = invert(escapeMap);
	
	  // Function for unescaping strings from HTML interpolation.
	  var _unescape = createEscaper(unescapeMap);
	
	  // By default, Underscore uses ERB-style template delimiters. Change the
	  // following template settings to use alternative delimiters.
	  var templateSettings = _$1.templateSettings = {
	    evaluate: /<%([\s\S]+?)%>/g,
	    interpolate: /<%=([\s\S]+?)%>/g,
	    escape: /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `_.templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'": "'",
	    '\\': '\\',
	    '\r': 'r',
	    '\n': 'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  function escapeChar(match) {
	    return '\\' + escapes[match];
	  }
	
	  // In order to prevent third-party code injection through
	  // `_.templateSettings.variable`, we test it against the following regular
	  // expression. It is intentionally a bit more liberal than just matching valid
	  // identifiers, but still prevents possible loopholes through defaults or
	  // destructuring assignment.
	  var bareIdentifier = /^\s*(\w|\$)+\s*$/;
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  function template(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = defaults({}, settings, _$1.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offset.
	      return match;
	    });
	    source += "';\n";
	
	    var argument = settings.variable;
	    if (argument) {
	      // Insure against third-party code injection. (CVE-2021-23358)
	      if (!bareIdentifier.test(argument)) throw new Error(
	        'variable is not a bare identifier: ' + argument
	      );
	    } else {
	      // If a variable is not specified, place data values in local scope.
	      source = 'with(obj||{}){\n' + source + '}\n';
	      argument = 'obj';
	    }
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    var render;
	    try {
	      render = new Function(argument, '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _$1);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  }
	
	  // Traverses the children of `obj` along `path`. If a child is a function, it
	  // is invoked with its parent as context. Returns the value of the final
	  // child, or `fallback` if any child is undefined.
	  function result(obj, path, fallback) {
	    path = toPath(path);
	    var length = path.length;
	    if (!length) {
	      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
	    }
	    for (var i = 0; i < length; i++) {
	      var prop = obj == null ? void 0 : obj[path[i]];
	      if (prop === void 0) {
	        prop = fallback;
	        i = length; // Ensure we don't continue iterating.
	      }
	      obj = isFunction$1(prop) ? prop.call(obj) : prop;
	    }
	    return obj;
	  }
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  function uniqueId(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  }
	
	  // Start chaining a wrapped Underscore object.
	  function chain(obj) {
	    var instance = _$1(obj);
	    instance._chain = true;
	    return instance;
	  }
	
	  // Internal function to execute `sourceFunc` bound to `context` with optional
	  // `args`. Determines whether to execute a function as a constructor or as a
	  // normal function.
	  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (isObject(result)) return result;
	    return self;
	  }
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
	  // as a placeholder by default, allowing any combination of arguments to be
	  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
	  var partial = restArguments(function(func, boundArgs) {
	    var placeholder = partial.placeholder;
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  });
	
	  partial.placeholder = _$1;
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally).
	  var bind = restArguments(function(func, context, args) {
	    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
	    var bound = restArguments(function(callArgs) {
	      return executeBound(func, bound, context, this, args.concat(callArgs));
	    });
	    return bound;
	  });
	
	  // Internal helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object.
	  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var isArrayLike = createSizePropertyCheck(getLength);
	
	  // Internal implementation of a recursive `flatten` function.
	  function flatten$1(input, depth, strict, output) {
	    output = output || [];
	    if (!depth && depth !== 0) {
	      depth = Infinity;
	    } else if (depth <= 0) {
	      return output.concat(input);
	    }
	    var idx = output.length;
	    for (var i = 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
	        // Flatten current level of array or arguments object.
	        if (depth > 1) {
	          flatten$1(value, depth - 1, strict, output);
	          idx = output.length;
	        } else {
	          var j = 0, len = value.length;
	          while (j < len) output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  }
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  var bindAll = restArguments(function(obj, keys) {
	    keys = flatten$1(keys, false, false);
	    var index = keys.length;
	    if (index < 1) throw new Error('bindAll must be passed function names');
	    while (index--) {
	      var key = keys[index];
	      obj[key] = bind(obj[key], obj);
	    }
	    return obj;
	  });
	
	  // Memoize an expensive function by storing its results.
	  function memoize(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!has$1(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  }
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  var delay = restArguments(function(func, wait, args) {
	    return setTimeout(function() {
	      return func.apply(null, args);
	    }, wait);
	  });
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  var defer = partial(delay, _$1, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  function throttle(func, wait, options) {
	    var timeout, context, args, result;
	    var previous = 0;
	    if (!options) options = {};
	
	    var later = function() {
	      previous = options.leading === false ? 0 : now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	
	    var throttled = function() {
	      var _now = now();
	      if (!previous && options.leading === false) previous = _now;
	      var remaining = wait - (_now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = _now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	
	    throttled.cancel = function() {
	      clearTimeout(timeout);
	      previous = 0;
	      timeout = context = args = null;
	    };
	
	    return throttled;
	  }
	
	  // When a sequence of calls of the returned function ends, the argument
	  // function is triggered. The end of a sequence is defined by the `wait`
	  // parameter. If `immediate` is passed, the argument function will be
	  // triggered at the beginning of the sequence instead of at the end.
	  function debounce(func, wait, immediate) {
	    var timeout, previous, args, result, context;
	
	    var later = function() {
	      var passed = now() - previous;
	      if (wait > passed) {
	        timeout = setTimeout(later, wait - passed);
	      } else {
	        timeout = null;
	        if (!immediate) result = func.apply(context, args);
	        // This check is needed because `func` can recursively invoke `debounced`.
	        if (!timeout) args = context = null;
	      }
	    };
	
	    var debounced = restArguments(function(_args) {
	      context = this;
	      args = _args;
	      previous = now();
	      if (!timeout) {
	        timeout = setTimeout(later, wait);
	        if (immediate) result = func.apply(context, args);
	      }
	      return result;
	    });
	
	    debounced.cancel = function() {
	      clearTimeout(timeout);
	      timeout = args = context = null;
	    };
	
	    return debounced;
	  }
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  function wrap(func, wrapper) {
	    return partial(wrapper, func);
	  }
	
	  // Returns a negated version of the passed-in predicate.
	  function negate(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  }
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  function compose() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  }
	
	  // Returns a function that will only be executed on and after the Nth call.
	  function after(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  }
	
	  // Returns a function that will only be executed up to (but not including) the
	  // Nth call.
	  function before(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  }
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  var once = partial(before, 2);
	
	  // Returns the first key on an object that passes a truth test.
	  function findKey(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = keys(obj), key;
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      key = _keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  }
	
	  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a truth test.
	  var findIndex = createPredicateIndexFinder(1);
	
	  // Returns the last index on an array-like that passes a truth test.
	  var findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  function sortedIndex(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  }
	
	  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	          i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), isNaN$1);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  var indexOf = createIndexFinder(1, findIndex, sortedIndex);
	
	  // Return the position of the last occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  var lastIndexOf = createIndexFinder(-1, findLastIndex);
	
	  // Return the first value which passes a truth test.
	  function find(obj, predicate, context) {
	    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
	    var key = keyFinder(obj, predicate, context);
	    if (key !== void 0 && key !== -1) return obj[key];
	  }
	
	  // Convenience version of a common use case of `_.find`: getting the first
	  // object containing specific `key:value` pairs.
	  function findWhere(obj, attrs) {
	    return find(obj, matcher(attrs));
	  }
	
	  // The cornerstone for collection functions, an `each`
	  // implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  function each(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var _keys = keys(obj);
	      for (i = 0, length = _keys.length; i < length; i++) {
	        iteratee(obj[_keys[i]], _keys[i], obj);
	      }
	    }
	    return obj;
	  }
	
	  // Return the results of applying the iteratee to each element.
	  function map(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Internal helper to create a reducing function, iterating left or right.
	  function createReduce(dir) {
	    // Wrap code that reassigns argument variables in a separate function than
	    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
	    var reducer = function(obj, iteratee, memo, initial) {
	      var _keys = !isArrayLike(obj) && keys(obj),
	          length = (_keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      if (!initial) {
	        memo = obj[_keys ? _keys[index] : index];
	        index += dir;
	      }
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = _keys ? _keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    };
	
	    return function(obj, iteratee, memo, context) {
	      var initial = arguments.length >= 3;
	      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  var reduce = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  var reduceRight = createReduce(-1);
	
	  // Return all the elements that pass a truth test.
	  function filter(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  }
	
	  // Return all the elements for which a truth test fails.
	  function reject(obj, predicate, context) {
	    return filter(obj, negate(cb(predicate)), context);
	  }
	
	  // Determine whether all of the elements pass a truth test.
	  function every(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  }
	
	  // Determine if at least one element in the object passes a truth test.
	  function some(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  }
	
	  // Determine if the array or object contains a given item (using `===`).
	  function contains(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return indexOf(obj, item, fromIndex) >= 0;
	  }
	
	  // Invoke a method (with arguments) on every item in a collection.
	  var invoke = restArguments(function(obj, path, args) {
	    var contextPath, func;
	    if (isFunction$1(path)) {
	      func = path;
	    } else {
	      path = toPath(path);
	      contextPath = path.slice(0, -1);
	      path = path[path.length - 1];
	    }
	    return map(obj, function(context) {
	      var method = func;
	      if (!method) {
	        if (contextPath && contextPath.length) {
	          context = deepGet(context, contextPath);
	        }
	        if (context == null) return void 0;
	        method = context[path];
	      }
	      return method == null ? method : method.apply(context, args);
	    });
	  });
	
	  // Convenience version of a common use case of `_.map`: fetching a property.
	  function pluck(obj, key) {
	    return map(obj, property(key));
	  }
	
	  // Convenience version of a common use case of `_.filter`: selecting only
	  // objects containing specific `key:value` pairs.
	  function where(obj, attrs) {
	    return filter(obj, matcher(attrs));
	  }
	
	  // Return the maximum element (or element-based computation).
	  function max(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed > lastComputed || (computed === -Infinity && result === -Infinity)) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Return the minimum element (or element-based computation).
	  function min(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed < lastComputed || (computed === Infinity && result === Infinity)) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Safely create a real, live array from anything iterable.
	  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
	  function toArray(obj) {
	    if (!obj) return [];
	    if (isArray(obj)) return slice.call(obj);
	    if (isString(obj)) {
	      // Keep surrogate pair characters together.
	      return obj.match(reStrSymbol);
	    }
	    if (isArrayLike(obj)) return map(obj, identity);
	    return values(obj);
	  }
	
	  // Sample **n** random values from a collection using the modern version of the
	  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `_.map`.
	  function sample(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = values(obj);
	      return obj[random(obj.length - 1)];
	    }
	    var sample = toArray(obj);
	    var length = getLength(sample);
	    n = Math.max(Math.min(n, length), 0);
	    var last = length - 1;
	    for (var index = 0; index < n; index++) {
	      var rand = random(index, last);
	      var temp = sample[index];
	      sample[index] = sample[rand];
	      sample[rand] = temp;
	    }
	    return sample.slice(0, n);
	  }
	
	  // Shuffle a collection.
	  function shuffle(obj) {
	    return sample(obj, Infinity);
	  }
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  function sortBy(obj, iteratee, context) {
	    var index = 0;
	    iteratee = cb(iteratee, context);
	    return pluck(map(obj, function(value, key, list) {
	      return {
	        value: value,
	        index: index++,
	        criteria: iteratee(value, key, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  }
	
	  // An internal function used for aggregate "group by" operations.
	  function group(behavior, partition) {
	    return function(obj, iteratee, context) {
	      var result = partition ? [[], []] : {};
	      iteratee = cb(iteratee, context);
	      each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  }
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  var groupBy = group(function(result, value, key) {
	    if (has$1(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
	  // when you know that your index values will be unique.
	  var indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  var countBy = group(function(result, value, key) {
	    if (has$1(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Split a collection into two arrays: one whose elements all pass the given
	  // truth test, and one whose elements all do not pass the truth test.
	  var partition = group(function(result, value, pass) {
	    result[pass ? 0 : 1].push(value);
	  }, true);
	
	  // Return the number of elements in a collection.
	  function size(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : keys(obj).length;
	  }
	
	  // Internal `_.pick` helper function to determine whether `key` is an enumerable
	  // property name of `obj`.
	  function keyInObj(value, key, obj) {
	    return key in obj;
	  }
	
	  // Return a copy of the object only containing the allowed properties.
	  var pick = restArguments(function(obj, keys) {
	    var result = {}, iteratee = keys[0];
	    if (obj == null) return result;
	    if (isFunction$1(iteratee)) {
	      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
	      keys = allKeys(obj);
	    } else {
	      iteratee = keyInObj;
	      keys = flatten$1(keys, false, false);
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  });
	
	  // Return a copy of the object without the disallowed properties.
	  var omit = restArguments(function(obj, keys) {
	    var iteratee = keys[0], context;
	    if (isFunction$1(iteratee)) {
	      iteratee = negate(iteratee);
	      if (keys.length > 1) context = keys[1];
	    } else {
	      keys = map(flatten$1(keys, false, false), String);
	      iteratee = function(value, key) {
	        return !contains(keys, key);
	      };
	    }
	    return pick(obj, iteratee, context);
	  });
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  function initial(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  }
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  function first(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[0];
	    return initial(array, array.length - n);
	  }
	
	  // Returns everything but the first entry of the `array`. Especially useful on
	  // the `arguments` object. Passing an **n** will return the rest N values in the
	  // `array`.
	  function rest(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  }
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  function last(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[array.length - 1];
	    return rest(array, Math.max(0, array.length - n));
	  }
	
	  // Trim out all falsy values from an array.
	  function compact(array) {
	    return filter(array, Boolean);
	  }
	
	  // Flatten out an array, either recursively (by default), or up to `depth`.
	  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
	  function flatten(array, depth) {
	    return flatten$1(array, depth, false);
	  }
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  var difference = restArguments(function(array, rest) {
	    rest = flatten$1(rest, true, true);
	    return filter(array, function(value){
	      return !contains(rest, value);
	    });
	  });
	
	  // Return a version of the array that does not contain the specified value(s).
	  var without = restArguments(function(array, otherArrays) {
	    return difference(array, otherArrays);
	  });
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // The faster algorithm will not work with an iteratee if the iteratee
	  // is not a one-to-one function, so providing an iteratee will disable
	  // the faster algorithm.
	  function uniq(array, isSorted, iteratee, context) {
	    if (!isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted && !iteratee) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  }
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  var union = restArguments(function(arrays) {
	    return uniq(flatten$1(arrays, true, true));
	  });
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  function intersection(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (contains(result, item)) continue;
	      var j;
	      for (j = 1; j < argsLength; j++) {
	        if (!contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  }
	
	  // Complement of zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices.
	  function unzip(array) {
	    var length = (array && max(array, getLength).length) || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = pluck(array, index);
	    }
	    return result;
	  }
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  var zip = restArguments(unzip);
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
	  function object(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  }
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](https://docs.python.org/library/functions.html#range).
	  function range(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    if (!step) {
	      step = stop < start ? -1 : 1;
	    }
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  }
	
	  // Chunk a single array into multiple arrays, each containing `count` or fewer
	  // items.
	  function chunk(array, count) {
	    if (count == null || count < 1) return [];
	    var result = [];
	    var i = 0, length = array.length;
	    while (i < length) {
	      result.push(slice.call(array, i, i += count));
	    }
	    return result;
	  }
	
	  // Helper function to continue chaining intermediate results.
	  function chainResult(instance, obj) {
	    return instance._chain ? _$1(obj).chain() : obj;
	  }
	
	  // Add your own custom functions to the Underscore object.
	  function mixin(obj) {
	    each(functions(obj), function(name) {
	      var func = _$1[name] = obj[name];
	      _$1.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return chainResult(this, func.apply(_$1, args));
	      };
	    });
	    return _$1;
	  }
	
	  // Add all mutator `Array` functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _$1.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) {
	        method.apply(obj, arguments);
	        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
	          delete obj[0];
	        }
	      }
	      return chainResult(this, obj);
	    };
	  });
	
	  // Add all accessor `Array` functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _$1.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) obj = method.apply(obj, arguments);
	      return chainResult(this, obj);
	    };
	  });
	
	  // Named Exports
	
	  var allExports = {
	    __proto__: null,
	    VERSION: VERSION,
	    restArguments: restArguments,
	    isObject: isObject,
	    isNull: isNull,
	    isUndefined: isUndefined,
	    isBoolean: isBoolean,
	    isElement: isElement,
	    isString: isString,
	    isNumber: isNumber,
	    isDate: isDate,
	    isRegExp: isRegExp,
	    isError: isError,
	    isSymbol: isSymbol,
	    isArrayBuffer: isArrayBuffer,
	    isDataView: isDataView$1,
	    isArray: isArray,
	    isFunction: isFunction$1,
	    isArguments: isArguments$1,
	    isFinite: isFinite$1,
	    isNaN: isNaN$1,
	    isTypedArray: isTypedArray$1,
	    isEmpty: isEmpty,
	    isMatch: isMatch,
	    isEqual: isEqual,
	    isMap: isMap,
	    isWeakMap: isWeakMap,
	    isSet: isSet,
	    isWeakSet: isWeakSet,
	    keys: keys,
	    allKeys: allKeys,
	    values: values,
	    pairs: pairs,
	    invert: invert,
	    functions: functions,
	    methods: functions,
	    extend: extend,
	    extendOwn: extendOwn,
	    assign: extendOwn,
	    defaults: defaults,
	    create: create,
	    clone: clone,
	    tap: tap,
	    get: get,
	    has: has,
	    mapObject: mapObject,
	    identity: identity,
	    constant: constant,
	    noop: noop,
	    toPath: toPath$1,
	    property: property,
	    propertyOf: propertyOf,
	    matcher: matcher,
	    matches: matcher,
	    times: times,
	    random: random,
	    now: now,
	    escape: _escape,
	    unescape: _unescape,
	    templateSettings: templateSettings,
	    template: template,
	    result: result,
	    uniqueId: uniqueId,
	    chain: chain,
	    iteratee: iteratee,
	    partial: partial,
	    bind: bind,
	    bindAll: bindAll,
	    memoize: memoize,
	    delay: delay,
	    defer: defer,
	    throttle: throttle,
	    debounce: debounce,
	    wrap: wrap,
	    negate: negate,
	    compose: compose,
	    after: after,
	    before: before,
	    once: once,
	    findKey: findKey,
	    findIndex: findIndex,
	    findLastIndex: findLastIndex,
	    sortedIndex: sortedIndex,
	    indexOf: indexOf,
	    lastIndexOf: lastIndexOf,
	    find: find,
	    detect: find,
	    findWhere: findWhere,
	    each: each,
	    forEach: each,
	    map: map,
	    collect: map,
	    reduce: reduce,
	    foldl: reduce,
	    inject: reduce,
	    reduceRight: reduceRight,
	    foldr: reduceRight,
	    filter: filter,
	    select: filter,
	    reject: reject,
	    every: every,
	    all: every,
	    some: some,
	    any: some,
	    contains: contains,
	    includes: contains,
	    include: contains,
	    invoke: invoke,
	    pluck: pluck,
	    where: where,
	    max: max,
	    min: min,
	    shuffle: shuffle,
	    sample: sample,
	    sortBy: sortBy,
	    groupBy: groupBy,
	    indexBy: indexBy,
	    countBy: countBy,
	    partition: partition,
	    toArray: toArray,
	    size: size,
	    pick: pick,
	    omit: omit,
	    first: first,
	    head: first,
	    take: first,
	    initial: initial,
	    last: last,
	    rest: rest,
	    tail: rest,
	    drop: rest,
	    compact: compact,
	    flatten: flatten,
	    without: without,
	    uniq: uniq,
	    unique: uniq,
	    union: union,
	    intersection: intersection,
	    difference: difference,
	    unzip: unzip,
	    transpose: unzip,
	    zip: zip,
	    object: object,
	    range: range,
	    chunk: chunk,
	    mixin: mixin,
	    'default': _$1
	  };
	
	  // Default Export
	
	  // Add all of the Underscore functions to the wrapper object.
	  var _ = mixin(allExports);
	  // Legacy Node.js API.
	  _._ = _;
	
	  return _;
	
	})));
	//# sourceMappingURL=underscore-umd.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {(function(global) {
	  /**
	   * Polyfill URLSearchParams
	   *
	   * Inspired from : https://github.com/WebReflection/url-search-params/blob/master/src/url-search-params.js
	   */
	
	  var checkIfIteratorIsSupported = function() {
	    try {
	      return !!Symbol.iterator;
	    } catch (error) {
	      return false;
	    }
	  };
	
	
	  var iteratorSupported = checkIfIteratorIsSupported();
	
	  var createIterator = function(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift();
	        return { done: value === void 0, value: value };
	      }
	    };
	
	    if (iteratorSupported) {
	      iterator[Symbol.iterator] = function() {
	        return iterator;
	      };
	    }
	
	    return iterator;
	  };
	
	  /**
	   * Search param name and values should be encoded according to https://url.spec.whatwg.org/#urlencoded-serializing
	   * encodeURIComponent() produces the same result except encoding spaces as `%20` instead of `+`.
	   */
	  var serializeParam = function(value) {
	    return encodeURIComponent(value).replace(/%20/g, '+');
	  };
	
	  var deserializeParam = function(value) {
	    return decodeURIComponent(String(value).replace(/\+/g, ' '));
	  };
	
	  var polyfillURLSearchParams = function() {
	
	    var URLSearchParams = function(searchString) {
	      Object.defineProperty(this, '_entries', { writable: true, value: {} });
	      var typeofSearchString = typeof searchString;
	
	      if (typeofSearchString === 'undefined') {
	        // do nothing
	      } else if (typeofSearchString === 'string') {
	        if (searchString !== '') {
	          this._fromString(searchString);
	        }
	      } else if (searchString instanceof URLSearchParams) {
	        var _this = this;
	        searchString.forEach(function(value, name) {
	          _this.append(name, value);
	        });
	      } else if ((searchString !== null) && (typeofSearchString === 'object')) {
	        if (Object.prototype.toString.call(searchString) === '[object Array]') {
	          for (var i = 0; i < searchString.length; i++) {
	            var entry = searchString[i];
	            if ((Object.prototype.toString.call(entry) === '[object Array]') || (entry.length !== 2)) {
	              this.append(entry[0], entry[1]);
	            } else {
	              throw new TypeError('Expected [string, any] as entry at index ' + i + ' of URLSearchParams\'s input');
	            }
	          }
	        } else {
	          for (var key in searchString) {
	            if (searchString.hasOwnProperty(key)) {
	              this.append(key, searchString[key]);
	            }
	          }
	        }
	      } else {
	        throw new TypeError('Unsupported input\'s type for URLSearchParams');
	      }
	    };
	
	    var proto = URLSearchParams.prototype;
	
	    proto.append = function(name, value) {
	      if (name in this._entries) {
	        this._entries[name].push(String(value));
	      } else {
	        this._entries[name] = [String(value)];
	      }
	    };
	
	    proto.delete = function(name) {
	      delete this._entries[name];
	    };
	
	    proto.get = function(name) {
	      return (name in this._entries) ? this._entries[name][0] : null;
	    };
	
	    proto.getAll = function(name) {
	      return (name in this._entries) ? this._entries[name].slice(0) : [];
	    };
	
	    proto.has = function(name) {
	      return (name in this._entries);
	    };
	
	    proto.set = function(name, value) {
	      this._entries[name] = [String(value)];
	    };
	
	    proto.forEach = function(callback, thisArg) {
	      var entries;
	      for (var name in this._entries) {
	        if (this._entries.hasOwnProperty(name)) {
	          entries = this._entries[name];
	          for (var i = 0; i < entries.length; i++) {
	            callback.call(thisArg, entries[i], name, this);
	          }
	        }
	      }
	    };
	
	    proto.keys = function() {
	      var items = [];
	      this.forEach(function(value, name) {
	        items.push(name);
	      });
	      return createIterator(items);
	    };
	
	    proto.values = function() {
	      var items = [];
	      this.forEach(function(value) {
	        items.push(value);
	      });
	      return createIterator(items);
	    };
	
	    proto.entries = function() {
	      var items = [];
	      this.forEach(function(value, name) {
	        items.push([name, value]);
	      });
	      return createIterator(items);
	    };
	
	    if (iteratorSupported) {
	      proto[Symbol.iterator] = proto.entries;
	    }
	
	    proto.toString = function() {
	      var searchArray = [];
	      this.forEach(function(value, name) {
	        searchArray.push(serializeParam(name) + '=' + serializeParam(value));
	      });
	      return searchArray.join('&');
	    };
	
	
	    global.URLSearchParams = URLSearchParams;
	  };
	
	  var checkIfURLSearchParamsSupported = function() {
	    try {
	      var URLSearchParams = global.URLSearchParams;
	
	      return (
	        (new URLSearchParams('?a=1').toString() === 'a=1') &&
	        (typeof URLSearchParams.prototype.set === 'function') &&
	        (typeof URLSearchParams.prototype.entries === 'function')
	      );
	    } catch (e) {
	      return false;
	    }
	  };
	
	  if (!checkIfURLSearchParamsSupported()) {
	    polyfillURLSearchParams();
	  }
	
	  var proto = global.URLSearchParams.prototype;
	
	  if (typeof proto.sort !== 'function') {
	    proto.sort = function() {
	      var _this = this;
	      var items = [];
	      this.forEach(function(value, name) {
	        items.push([name, value]);
	        if (!_this._entries) {
	          _this.delete(name);
	        }
	      });
	      items.sort(function(a, b) {
	        if (a[0] < b[0]) {
	          return -1;
	        } else if (a[0] > b[0]) {
	          return +1;
	        } else {
	          return 0;
	        }
	      });
	      if (_this._entries) { // force reset because IE keeps keys index
	        _this._entries = {};
	      }
	      for (var i = 0; i < items.length; i++) {
	        this.append(items[i][0], items[i][1]);
	      }
	    };
	  }
	
	  if (typeof proto._fromString !== 'function') {
	    Object.defineProperty(proto, '_fromString', {
	      enumerable: false,
	      configurable: false,
	      writable: false,
	      value: function(searchString) {
	        if (this._entries) {
	          this._entries = {};
	        } else {
	          var keys = [];
	          this.forEach(function(value, name) {
	            keys.push(name);
	          });
	          for (var i = 0; i < keys.length; i++) {
	            this.delete(keys[i]);
	          }
	        }
	
	        searchString = searchString.replace(/^\?/, '');
	        var attributes = searchString.split('&');
	        var attribute;
	        for (var i = 0; i < attributes.length; i++) {
	          attribute = attributes[i].split('=');
	          this.append(
	            deserializeParam(attribute[0]),
	            (attribute.length > 1) ? deserializeParam(attribute[1]) : ''
	          );
	        }
	      }
	    });
	  }
	
	  // HTMLAnchorElement
	
	})(
	  (typeof global !== 'undefined') ? global
	    : ((typeof window !== 'undefined') ? window
	    : ((typeof self !== 'undefined') ? self : this))
	);
	
	(function(global) {
	  /**
	   * Polyfill URL
	   *
	   * Inspired from : https://github.com/arv/DOM-URL-Polyfill/blob/master/src/url.js
	   */
	
	  var checkIfURLIsSupported = function() {
	    try {
	      var u = new global.URL('b', 'http://a');
	      u.pathname = 'c d';
	      return (u.href === 'http://a/c%20d') && u.searchParams;
	    } catch (e) {
	      return false;
	    }
	  };
	
	
	  var polyfillURL = function() {
	    var _URL = global.URL;
	
	    var URL = function(url, base) {
	      if (typeof url !== 'string') url = String(url);
	      if (base && typeof base !== 'string') base = String(base);
	
	      // Only create another document if the base is different from current location.
	      var doc = document, baseElement;
	      if (base && (global.location === void 0 || base !== global.location.href)) {
	        base = base.toLowerCase();
	        doc = document.implementation.createHTMLDocument('');
	        baseElement = doc.createElement('base');
	        baseElement.href = base;
	        doc.head.appendChild(baseElement);
	        try {
	          if (baseElement.href.indexOf(base) !== 0) throw new Error(baseElement.href);
	        } catch (err) {
	          throw new Error('URL unable to set base ' + base + ' due to ' + err);
	        }
	      }
	
	      var anchorElement = doc.createElement('a');
	      anchorElement.href = url;
	      if (baseElement) {
	        doc.body.appendChild(anchorElement);
	        anchorElement.href = anchorElement.href; // force href to refresh
	      }
	
	      var inputElement = doc.createElement('input');
	      inputElement.type = 'url';
	      inputElement.value = url;
	
	      if (anchorElement.protocol === ':' || !/:/.test(anchorElement.href) || (!inputElement.checkValidity() && !base)) {
	        throw new TypeError('Invalid URL');
	      }
	
	      Object.defineProperty(this, '_anchorElement', {
	        value: anchorElement
	      });
	
	
	      // create a linked searchParams which reflect its changes on URL
	      var searchParams = new global.URLSearchParams(this.search);
	      var enableSearchUpdate = true;
	      var enableSearchParamsUpdate = true;
	      var _this = this;
	      ['append', 'delete', 'set'].forEach(function(methodName) {
	        var method = searchParams[methodName];
	        searchParams[methodName] = function() {
	          method.apply(searchParams, arguments);
	          if (enableSearchUpdate) {
	            enableSearchParamsUpdate = false;
	            _this.search = searchParams.toString();
	            enableSearchParamsUpdate = true;
	          }
	        };
	      });
	
	      Object.defineProperty(this, 'searchParams', {
	        value: searchParams,
	        enumerable: true
	      });
	
	      var search = void 0;
	      Object.defineProperty(this, '_updateSearchParams', {
	        enumerable: false,
	        configurable: false,
	        writable: false,
	        value: function() {
	          if (this.search !== search) {
	            search = this.search;
	            if (enableSearchParamsUpdate) {
	              enableSearchUpdate = false;
	              this.searchParams._fromString(this.search);
	              enableSearchUpdate = true;
	            }
	          }
	        }
	      });
	    };
	
	    var proto = URL.prototype;
	
	    var linkURLWithAnchorAttribute = function(attributeName) {
	      Object.defineProperty(proto, attributeName, {
	        get: function() {
	          return this._anchorElement[attributeName];
	        },
	        set: function(value) {
	          this._anchorElement[attributeName] = value;
	        },
	        enumerable: true
	      });
	    };
	
	    ['hash', 'host', 'hostname', 'port', 'protocol']
	      .forEach(function(attributeName) {
	        linkURLWithAnchorAttribute(attributeName);
	      });
	
	    Object.defineProperty(proto, 'search', {
	      get: function() {
	        return this._anchorElement['search'];
	      },
	      set: function(value) {
	        this._anchorElement['search'] = value;
	        this._updateSearchParams();
	      },
	      enumerable: true
	    });
	
	    Object.defineProperties(proto, {
	
	      'toString': {
	        get: function() {
	          var _this = this;
	          return function() {
	            return _this.href;
	          };
	        }
	      },
	
	      'href': {
	        get: function() {
	          return this._anchorElement.href.replace(/\?$/, '');
	        },
	        set: function(value) {
	          this._anchorElement.href = value;
	          this._updateSearchParams();
	        },
	        enumerable: true
	      },
	
	      'pathname': {
	        get: function() {
	          return this._anchorElement.pathname.replace(/(^\/?)/, '/');
	        },
	        set: function(value) {
	          this._anchorElement.pathname = value;
	        },
	        enumerable: true
	      },
	
	      'origin': {
	        get: function() {
	          // get expected port from protocol
	          var expectedPort = { 'http:': 80, 'https:': 443, 'ftp:': 21 }[this._anchorElement.protocol];
	          // add port to origin if, expected port is different than actual port
	          // and it is not empty f.e http://foo:8080
	          // 8080 != 80 && 8080 != ''
	          var addPortToOrigin = this._anchorElement.port != expectedPort &&
	            this._anchorElement.port !== '';
	
	          return this._anchorElement.protocol +
	            '//' +
	            this._anchorElement.hostname +
	            (addPortToOrigin ? (':' + this._anchorElement.port) : '');
	        },
	        enumerable: true
	      },
	
	      'password': { // TODO
	        get: function() {
	          return '';
	        },
	        set: function(value) {
	        },
	        enumerable: true
	      },
	
	      'username': { // TODO
	        get: function() {
	          return '';
	        },
	        set: function(value) {
	        },
	        enumerable: true
	      },
	    });
	
	    URL.createObjectURL = function(blob) {
	      return _URL.createObjectURL.apply(_URL, arguments);
	    };
	
	    URL.revokeObjectURL = function(url) {
	      return _URL.revokeObjectURL.apply(_URL, arguments);
	    };
	
	    global.URL = URL;
	
	  };
	
	  if (!checkIfURLIsSupported()) {
	    polyfillURL();
	  }
	
	  if ((global.location !== void 0) && !('origin' in global.location)) {
	    var getOrigin = function() {
	      return global.location.protocol + '//' + global.location.hostname + (global.location.port ? (':' + global.location.port) : '');
	    };
	
	    try {
	      Object.defineProperty(global.location, 'origin', {
	        get: getOrigin,
	        enumerable: true
	      });
	    } catch (e) {
	      setInterval(function() {
	        global.location.origin = getOrigin();
	      }, 100);
	    }
	  }
	
	})(
	  (typeof global !== 'undefined') ? global
	    : ((typeof window !== 'undefined') ? window
	    : ((typeof self !== 'undefined') ? self : this))
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 1245 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./about-you/about-you.html": 1198,
		"./admin-panel/application-listing/application-lawyer-profile.html": 1199,
		"./admin-panel/application-listing/application-listing.html": 1200,
		"./admin-panel/candidate-listing/candidate-listing.html": 1201,
		"./admin-panel/email-listing/email-listing.html": 1202,
		"./admin-panel/email-listing/email-preview/email-preview.html": 1203,
		"./admin-panel/employers-listing/employers-listing.html": 1204,
		"./admin-panel/position-listing/inactive-position-listing.html": 1205,
		"./admin-panel/position-listing/position-listing.html": 1206,
		"./admin-panel/recommendation-listing/help-description-modal/help-description-modal.html": 430,
		"./admin-panel/recommendation-listing/recommendation-listing.html": 1207,
		"./admin-panel/recommendation-listing/recommendation-page.html": 1208,
		"./admin-panel/referral-listing/referral-listing.html": 1209,
		"./admin-profile/admin-profile.html": 1210,
		"./approved-profile/profile-approved.html": 1211,
		"./candidate-applications/candidate-application.html": 1212,
		"./candidate-profile/applications/applications.template.html": 431,
		"./candidate-profile/applications/applications.template.spec.html": 1213,
		"./candidate-profile/candidate-profile.template.html": 432,
		"./candidate-profile/employment-history/employment-form.html": 433,
		"./candidate-profile/employment-history/employment-history.html": 434,
		"./candidate-profile/login-history/login-history.template.html": 435,
		"./candidate-profile/preferences/preferences.template.html": 436,
		"./candidate-profile/profile/profile.template.html": 437,
		"./candidate-profile/recommendations/recommendations.template.html": 438,
		"./change-password/change-password.html": 1214,
		"./change-password/reset-password.html": 1215,
		"./edit-email/edit-email.html": 1216,
		"./forgot-password/forgot-password.html": 1217,
		"./hiring/hiring.html": 1218,
		"./home/home.html": 1219,
		"./inhouse-jobs/in-house.html": 1220,
		"./invite-friend/invite-friend.html": 1221,
		"./job-application-history/email-history.html": 1222,
		"./job-application-history/view-job-application-body.html": 1223,
		"./job/job-creation.html": 1224,
		"./job/job-edit.html": 1225,
		"./lawyer-profile/candidate-profile.html": 1226,
		"./make-me-offer/make-me-an-offer.html": 1227,
		"./matches/matches.html": 1228,
		"./matches/welcome-modal-popup/welcome-modal.html": 168,
		"./notes/employer-notes.html": 1229,
		"./notes/notes.template.html": 439,
		"./refer-friend/refer-friend.html": 1230,
		"./shared/directives/actions-popup/template.html": 440,
		"./shared/directives/ag-grid-listing/ag-grid-filters/add-filters/add-filters.html": 441,
		"./shared/directives/ag-grid-listing/ag-grid-filters/delete-filters/delete-filters.html": 442,
		"./shared/directives/ag-grid-listing/ag-grid-filters/filters.html": 443,
		"./shared/directives/ag-grid-listing/ag-grid-listing.html": 444,
		"./shared/directives/ag-grid-listing/help-modal/help-modal.html": 445,
		"./shared/directives/angular-querybuilder/template.html": 1231,
		"./shared/directives/application/application-agent/application-agent-modal.html": 446,
		"./shared/directives/application/application-history/application-history-modal.html": 447,
		"./shared/directives/application/application-modal/application-modal.template.html": 448,
		"./shared/directives/application/application-stages-setting/application-stages-setting-modal.html": 449,
		"./shared/directives/application/application-status-dropdown/application-status-dropdown.html": 450,
		"./shared/directives/application/applications-stage-dropdown/application-stage-dropdown.html": 451,
		"./shared/directives/application/delete-applications/delete-application-modal.html": 452,
		"./shared/directives/assign-agent-dropdown/assign-agent-dropdown.html": 453,
		"./shared/directives/candidate-profile-modal/candidate-profile-modal.template.html": 454,
		"./shared/directives/clone-position/clone-position-modal.html": 455,
		"./shared/directives/contact-admin/contact-admin-modal.html": 456,
		"./shared/directives/create-update-employer/create-update-employer-modal.html": 457,
		"./shared/directives/create-update-employer/create-update-employer-page.html": 1232,
		"./shared/directives/create-update-position/create-update-position-modal.html": 458,
		"./shared/directives/create-update-position/create-update-position-page.html": 1233,
		"./shared/directives/date-modal/date-modal.html": 459,
		"./shared/directives/delete-employer/delete-employer-modal.html": 460,
		"./shared/directives/delete-position/delete-position-modal.html": 461,
		"./shared/directives/footer/footer.html": 462,
		"./shared/directives/group-pipeline/template.html": 463,
		"./shared/directives/header/header.html": 464,
		"./shared/directives/lawyer-preferences/template.html": 465,
		"./shared/directives/lawyer-salary/template.html": 466,
		"./shared/directives/locations/locations-dropdown.html": 467,
		"./shared/directives/locations/locations-modal.html": 468,
		"./shared/directives/modal-hide-positions-employer/hide-position-employer.html": 469,
		"./shared/directives/position-details/position-details-modal.html": 470,
		"./shared/directives/practice-area/practice-area-dropdown.html": 471,
		"./shared/directives/practice-area/practice-area-modal.html": 472,
		"./sign-in/signin.html": 1234,
		"./sign-up/signup.html": 1235,
		"./user-profile/UserProfile.html": 1236
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1246;


/***/ }),
/* 1247 */
/***/ (function(module, exports) {

	/*!
	 * Dropdownhover v1.0.0 (http://bs-dropdownhover.kybarg.com)
	 */
	+function(o){"use strict";function t(t){return this.each(function(){var e=o(this),r=e.data("bs.dropdownhover"),i=e.data();void 0!==e.data("animations")&&null!==e.data("animations")&&(i.animations=o.isArray(i.animations)?i.animations:i.animations.split(" "));var s=o.extend({},n.DEFAULTS,i,"object"==typeof t&&t);r||e.data("bs.dropdownhover",r=new n(this,s))})}var n=function(t,n){this.options=n,this.$element=o(t);var e=this;this.dropdowns=this.$element.hasClass("dropdown-toggle")?this.$element.parent().find(".dropdown-menu").parent(".dropdown"):this.$element.find(".dropdown"),this.dropdowns.each(function(){o(this).on("mouseenter.bs.dropdownhover",function(t){e.show(o(this).children("a, button"))})}),this.dropdowns.each(function(){o(this).on("mouseleave.bs.dropdownhover",function(t){e.hide(o(this).children("a, button"))})})};n.TRANSITION_DURATION=300,n.DELAY=150,n.TIMEOUT,n.DEFAULTS={animations:["fadeInDown","fadeInRight","fadeInUp","fadeInLeft"]},n.prototype.show=function(t){var e=o(t);window.clearTimeout(n.TIMEOUT),o(".dropdown").not(e.parents()).each(function(){o(this).removeClass("open")});var r=this.options.animations[0];if(!e.is(".disabled, :disabled")){var i=e.parent(),s=i.hasClass("open");if(!s){var d=e.next(".dropdown-menu");i.addClass("open");var a=this.position(d);r="top"==a?this.options.animations[2]:"right"==a?this.options.animations[3]:"left"==a?this.options.animations[1]:this.options.animations[0],d.addClass("animated "+r);var h=o.support.transition&&d.hasClass("animated");h?d.one("bsTransitionEnd",function(){d.removeClass("animated "+r)}).emulateTransitionEnd(n.TRANSITION_DURATION):d.removeClass("animated "+r)}return!1}},n.prototype.hide=function(t){var e=o(t),r=e.parent();n.TIMEOUT=window.setTimeout(function(){r.removeClass("open")},n.DELAY)},n.prototype.position=function(t){var n=o(window);t.css({bottom:"",left:"",top:"",right:""}).removeClass("dropdownhover-top");var e={top:n.scrollTop(),left:n.scrollLeft()};e.right=e.left+n.width(),e.bottom=e.top+n.height();var r=t.offset();r.right=r.left+t.outerWidth(),r.bottom=r.top+t.outerHeight();var i=t.position();i.right=r.left+t.outerWidth(),i.bottom=r.top+t.outerHeight();var s="",d=t.parents(".dropdown-menu").length;if(d)i.left<0?(s="left",t.removeClass("dropdownhover-right").addClass("dropdownhover-left")):(s="right",t.addClass("dropdownhover-right").removeClass("dropdownhover-left")),r.left<e.left?(s="right",t.css({left:"100%",right:"auto"}).addClass("dropdownhover-right").removeClass("dropdownhover-left")):r.right>e.right&&(s="left",t.css({left:"auto",right:"100%"}).removeClass("dropdownhover-right").addClass("dropdownhover-left")),r.bottom>e.bottom?t.css({bottom:"auto",top:-(r.bottom-e.bottom)}):r.top<e.top&&t.css({bottom:-(e.top-r.top),top:"auto"});else{var a=t.parent(".dropdown"),h=a.offset();h.right=h.left+a.outerWidth(),h.bottom=h.top+a.outerHeight(),r.right>e.right&&t.css({left:-(r.right-e.right),right:"auto"}),r.bottom>e.bottom&&h.top-e.top>e.bottom-h.bottom||t.position().top<0?(s="top",t.css({bottom:"100%",top:"auto"}).addClass("dropdownhover-top").removeClass("dropdownhover-bottom")):(s="bottom",t.addClass("dropdownhover-bottom"))}return s};var e=o.fn.dropdownhover;o.fn.dropdownhover=t,o.fn.dropdownhover.Constructor=n,o.fn.dropdownhover.noConflict=function(){return o.fn.dropdownhover=e,this};var r;o(document).ready(function(){o(window).width()>=768&&o('[data-hover="dropdown"]').each(function(){var n=o(this);t.call(n,n.data())})}),o(window).on("resize",function(){clearTimeout(r),r=setTimeout(function(){o(window).width()>=768?o('[data-hover="dropdown"]').each(function(){var n=o(this);t.call(n,n.data())}):o('[data-hover="dropdown"]').each(function(){o(this).removeData("bs.dropdownhover"),o(this).hasClass("dropdown-toggle")?o(this).parent(".dropdown").find(".dropdown").andSelf().off("mouseenter.bs.dropdownhover mouseleave.bs.dropdownhover"):o(this).find(".dropdown").off("mouseenter.bs.dropdownhover mouseleave.bs.dropdownhover")})},200)})}(jQuery);


/***/ })
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.08dfb909.js